
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire874b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire874b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jWQW9"));

});
parcelRegister("jWQW9", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $e85c7f443c64506d$export$ffb0004e005737fa, (v) => $e85c7f443c64506d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $e85c7f443c64506d$export$5f8d39834fd61797, (v) => $e85c7f443c64506d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $e85c7f443c64506d$export$e2c29f18771995cb, (v) => $e85c7f443c64506d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $e85c7f443c64506d$export$74bf444e3cd11ea5, (v) => $e85c7f443c64506d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $e85c7f443c64506d$export$dca3b0875bd9a954, (v) => $e85c7f443c64506d$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e85c7f443c64506d$export$16fa2f45be04daa8, (v) => $e85c7f443c64506d$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $e85c7f443c64506d$export$221d75b3f55bb0bd, (v) => $e85c7f443c64506d$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e85c7f443c64506d$export$ae55be85d98224ed, (v) => $e85c7f443c64506d$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $e85c7f443c64506d$export$e530037191fcd5d7, (v) => $e85c7f443c64506d$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e85c7f443c64506d$export$fd42f52fd3ae1109, (v) => $e85c7f443c64506d$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e85c7f443c64506d$export$c8a8987d4410bf2d, (v) => $e85c7f443c64506d$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $e85c7f443c64506d$export$d38cd72104c1f0e9, (v) => $e85c7f443c64506d$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $e85c7f443c64506d$export$7d1e3a5e95ceca43, (v) => $e85c7f443c64506d$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e85c7f443c64506d$export$257a8862b851cb5b, (v) => $e85c7f443c64506d$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e85c7f443c64506d$export$a8257692ac88316c, (v) => $e85c7f443c64506d$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e85c7f443c64506d$export$488013bae63b21da, (v) => $e85c7f443c64506d$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e85c7f443c64506d$export$7c73462e0d25e514, (v) => $e85c7f443c64506d$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $e85c7f443c64506d$export$35808ee640e87ca7, (v) => $e85c7f443c64506d$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e85c7f443c64506d$export$fae74005e78b1a27, (v) => $e85c7f443c64506d$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e85c7f443c64506d$export$dc8fbce3eb94dc1e, (v) => $e85c7f443c64506d$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $e85c7f443c64506d$export$6d9c69b0de29b591, (v) => $e85c7f443c64506d$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e85c7f443c64506d$export$d5a552a76deda3c2, (v) => $e85c7f443c64506d$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e85c7f443c64506d$export$e5c5a5f917a5871c, (v) => $e85c7f443c64506d$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e85c7f443c64506d$export$1538c33de8887b59, (v) => $e85c7f443c64506d$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $e85c7f443c64506d$export$13e3392192263954, (v) => $e85c7f443c64506d$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e85c7f443c64506d$export$b8f5890fc79d6aca, (v) => $e85c7f443c64506d$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e85c7f443c64506d$export$60241385465d0a34, (v) => $e85c7f443c64506d$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $e85c7f443c64506d$export$83d89fbfd8236492, (v) => $e85c7f443c64506d$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e85c7f443c64506d$export$ffb0004e005737fa;
var $e85c7f443c64506d$export$5f8d39834fd61797;
var $e85c7f443c64506d$export$e2c29f18771995cb;
var $e85c7f443c64506d$export$74bf444e3cd11ea5;
var $e85c7f443c64506d$export$dca3b0875bd9a954;
var $e85c7f443c64506d$export$16fa2f45be04daa8;
var $e85c7f443c64506d$export$221d75b3f55bb0bd;
var $e85c7f443c64506d$export$ae55be85d98224ed;
var $e85c7f443c64506d$export$e530037191fcd5d7;
var $e85c7f443c64506d$export$fd42f52fd3ae1109;
var $e85c7f443c64506d$export$c8a8987d4410bf2d;
var $e85c7f443c64506d$export$d38cd72104c1f0e9;
var $e85c7f443c64506d$export$7d1e3a5e95ceca43;
var $e85c7f443c64506d$export$257a8862b851cb5b;
var $e85c7f443c64506d$export$a8257692ac88316c;
var $e85c7f443c64506d$export$488013bae63b21da;
var $e85c7f443c64506d$export$7c73462e0d25e514;
var $e85c7f443c64506d$export$35808ee640e87ca7;
var $e85c7f443c64506d$export$fae74005e78b1a27;
var $e85c7f443c64506d$export$dc8fbce3eb94dc1e;
var $e85c7f443c64506d$export$6d9c69b0de29b591;
var $e85c7f443c64506d$export$d5a552a76deda3c2;
var $e85c7f443c64506d$export$e5c5a5f917a5871c;
var $e85c7f443c64506d$export$1538c33de8887b59;
var $e85c7f443c64506d$export$13e3392192263954;
var $e85c7f443c64506d$export$b8f5890fc79d6aca;
var $e85c7f443c64506d$export$60241385465d0a34;
var $e85c7f443c64506d$export$83d89fbfd8236492;
"use strict";

(function() {
    "use strict";
    var _assign = (parcelRequire("8coUR"));
    // TODO: this is special because it gets imported during build.
    var ReactVersion = "17.0.2";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    $e85c7f443c64506d$export$ffb0004e005737fa = 0xeacb;
    $e85c7f443c64506d$export$5f8d39834fd61797 = 0xeacc;
    $e85c7f443c64506d$export$e2c29f18771995cb = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    $e85c7f443c64506d$export$74bf444e3cd11ea5 = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor("react.element");
        REACT_PORTAL_TYPE = symbolFor("react.portal");
        $e85c7f443c64506d$export$ffb0004e005737fa = symbolFor("react.fragment");
        $e85c7f443c64506d$export$5f8d39834fd61797 = symbolFor("react.strict_mode");
        $e85c7f443c64506d$export$e2c29f18771995cb = symbolFor("react.profiler");
        REACT_PROVIDER_TYPE = symbolFor("react.provider");
        REACT_CONTEXT_TYPE = symbolFor("react.context");
        REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
        $e85c7f443c64506d$export$74bf444e3cd11ea5 = symbolFor("react.suspense");
        REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
        REACT_MEMO_TYPE = symbolFor("react.memo");
        REACT_LAZY_TYPE = symbolFor("react.lazy");
        REACT_BLOCK_TYPE = symbolFor("react.block");
        REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
        REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
        REACT_SCOPE_TYPE = symbolFor("react.scope");
        REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
        REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
        REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: 0
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    /**
 * Used by act() to track whether you're inside an act() scope.
 */ var IsSomeRendererActing = {
        current: false
    };
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner,
        IsSomeRendererActing: IsSomeRendererActing,
        // Used by renderers to avoid bundling object-assign twice in UMD bundles:
        assign: _assign
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return "" + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (!(typeof partialState === "object" || typeof partialState === "function" || partialState == null)) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    _assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || "Context";
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case $e85c7f443c64506d$export$ffb0004e005737fa:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case $e85c7f443c64506d$export$e2c29f18771995cb:
                return "Profiler";
            case $e85c7f443c64506d$export$5f8d39834fd61797:
                return "StrictMode";
            case $e85c7f443c64506d$export$74bf444e3cd11ea5:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) key = "" + config.key;
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (!!(element === null || element === undefined)) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = _assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) key = "" + config.key;
             // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) // Explicit key
        return escape("" + element.key);
         // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (Array.isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                var childrenString = "" + children;
                throw Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). If you meant to render a collection of children, use an array instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue, calculateChangedBits) {
        if (calculateChangedBits === undefined) calculateChangedBits = null;
        else if (calculateChangedBits !== null && typeof calculateChangedBits !== "function") error("createContext: Expected the optional second argument to be a function. Instead received: %s", calculateChangedBits);
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            _calculateChangedBits: calculateChangedBits,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context,
            _calculateChangedBits: context._calculateChangedBits
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            var pending = payload;
            pending._status = Pending;
            pending._result = thenable;
            thenable.then(function(moduleObject) {
                if (payload._status === Pending) {
                    var defaultExport = moduleObject.default;
                    if (defaultExport === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = defaultExport;
                }
            }, function(error) {
                if (payload._status === Pending) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
        }
        if (payload._status === Resolved) return payload._result;
        else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: -1,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                if (render.displayName == null) render.displayName = name;
            }
        });
        return elementType;
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === $e85c7f443c64506d$export$ffb0004e005737fa || type === $e85c7f443c64506d$export$e2c29f18771995cb || type === REACT_DEBUG_TRACING_MODE_TYPE || type === $e85c7f443c64506d$export$5f8d39834fd61797 || type === $e85c7f443c64506d$export$74bf444e3cd11ea5 || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                if (type.displayName == null) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (!(dispatcher !== null)) throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function useContext(Context, unstable_observedBits) {
        var dispatcher = resolveDispatcher();
        if (unstable_observedBits !== undefined) error("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", unstable_observedBits, typeof unstable_observedBits === "number" && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks" : "");
         // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context, unstable_observedBits);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case $e85c7f443c64506d$export$74bf444e3cd11ea5:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentName(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (Array.isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentName(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentName(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (Array.isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === $e85c7f443c64506d$export$ffb0004e005737fa) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    try {
        var frozenObject = Object.freeze({});
        /* eslint-disable no-new */ new Map([
            [
                frozenObject,
                null
            ]
        ]);
        new Set([
            frozenObject
        ]);
    /* eslint-enable no-new */ } catch (e) {}
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    $e85c7f443c64506d$export$dca3b0875bd9a954 = Children;
    $e85c7f443c64506d$export$16fa2f45be04daa8 = Component;
    $e85c7f443c64506d$export$221d75b3f55bb0bd = PureComponent;
    $e85c7f443c64506d$export$ae55be85d98224ed = ReactSharedInternals;
    $e85c7f443c64506d$export$e530037191fcd5d7 = cloneElement$1;
    $e85c7f443c64506d$export$fd42f52fd3ae1109 = createContext;
    $e85c7f443c64506d$export$c8a8987d4410bf2d = createElement$1;
    $e85c7f443c64506d$export$d38cd72104c1f0e9 = createFactory;
    $e85c7f443c64506d$export$7d1e3a5e95ceca43 = createRef;
    $e85c7f443c64506d$export$257a8862b851cb5b = forwardRef;
    $e85c7f443c64506d$export$a8257692ac88316c = isValidElement;
    $e85c7f443c64506d$export$488013bae63b21da = lazy;
    $e85c7f443c64506d$export$7c73462e0d25e514 = memo;
    $e85c7f443c64506d$export$35808ee640e87ca7 = useCallback;
    $e85c7f443c64506d$export$fae74005e78b1a27 = useContext;
    $e85c7f443c64506d$export$dc8fbce3eb94dc1e = useDebugValue;
    $e85c7f443c64506d$export$6d9c69b0de29b591 = useEffect;
    $e85c7f443c64506d$export$d5a552a76deda3c2 = useImperativeHandle;
    $e85c7f443c64506d$export$e5c5a5f917a5871c = useLayoutEffect;
    $e85c7f443c64506d$export$1538c33de8887b59 = useMemo;
    $e85c7f443c64506d$export$13e3392192263954 = useReducer;
    $e85c7f443c64506d$export$b8f5890fc79d6aca = useRef;
    $e85c7f443c64506d$export$60241385465d0a34 = useState;
    $e85c7f443c64506d$export$83d89fbfd8236492 = ReactVersion;
})();

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

module.exports = (parcelRequire("3y30c"));

});
parcelRegister("3y30c", function(module, exports) {
/** @license React v17.0.2
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";




(function() {
    "use strict";
    var React = (parcelRequire("acw62"));
    var _assign = (parcelRequire("8coUR"));
    var Scheduler = (parcelRequire("fO90s"));
    var tracing = (parcelRequire("eXC0v"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return "" + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    if (!React) throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var FundamentalComponent = 20;
    var ScopeComponent = 21;
    var Block = 22;
    var OffscreenComponent = 23;
    var LegacyHiddenComponent = 24;
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableFundamentalAPI = false; // Experimental Scope support.
    var enableNewReconciler = false; // Errors that are thrown while unmounting (or after in the case of passive effects)
    var warnAboutStringRefs = false;
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var ROOT_ATTRIBUTE_NAME = "data-reactroot";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue;
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected) {
        if (!isAttributeNameSafe(name)) return;
         // If the object is an opaque reference ID, it's expected that
        // the next prop is different than the server value, so just return
        // expected
        if (isOpaqueHydratingObject(expected)) return expected;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
         // If the prop isn't in the special list, treat it as a simple attribute.
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else node.setAttribute(_attributeName, "" + value);
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    var REACT_FRAGMENT_TYPE = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor("react.element");
        REACT_PORTAL_TYPE = symbolFor("react.portal");
        REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
        REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
        REACT_PROFILER_TYPE = symbolFor("react.profiler");
        REACT_PROVIDER_TYPE = symbolFor("react.provider");
        REACT_CONTEXT_TYPE = symbolFor("react.context");
        REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
        REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
        REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
        REACT_MEMO_TYPE = symbolFor("react.memo");
        REACT_LAZY_TYPE = symbolFor("react.lazy");
        REACT_BLOCK_TYPE = symbolFor("react.block");
        REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
        REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
        REACT_SCOPE_TYPE = symbolFor("react.scope");
        REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
        REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
        REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at ");
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case Block:
                return describeFunctionComponentFrame(fiber.type._render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || "Context";
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentName(owner.type);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    function getIsRendering() {
        return isRendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "object":
            case "string":
            case "undefined":
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = _assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            // but that sometimes behaves strangely in IE8. We could also try using
            // `form.getElementsByName`, but that will only return direct children
            // and won't include inputs that use the HTML5 `form=` attribute. Since
            // the input might not even be in a form. It might not even be in the
            // document. Let's just use the local `querySelectorAll` to ensure we don't
            // miss anything.
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    function flattenChildren(children) {
        var content = ""; // Flatten children. We'll warn if they are invalid
        // during validateProps() which runs for hydration too.
        // Note that this would throw on non-element objects.
        // Elements are stringified (which is normally irrelevant
        // but matters for <fbt>).
        React.Children.forEach(children, function(child) {
            if (child == null) return;
            content += child; // Note: we don't warn about invalid children here.
        // Instead, this is done separately below so that
        // it happens during the hydration code path too.
        });
        return content;
    }
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // This mirrors the code path above, but runs for hydration too.
        // Warn about invalid children here so that client and hydration are consistent.
        // TODO: this seems like it could cause a DEV-only throw for hydration
        // if children contains a non-element object. We should try to avoid that.
        if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
            if (child == null) return;
            if (typeof child === "string" || typeof child === "number") return;
            if (typeof child.type !== "string") return;
            if (!didWarnInvalidChild) {
                didWarnInvalidChild = true;
                error("Only strings and numbers are supported as <option> children.");
            }
        });
         // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    function getHostProps$1(element, props) {
        var hostProps = _assign({
            children: undefined
        }, props);
        var content = flattenChildren(props.children);
        if (content) hostProps.children = content;
        return hostProps;
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var isArray = Array.isArray(props[propName]);
            if (props.multiple && !isArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && isArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$2(element, props) {
        return _assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$3(element, props) {
        var node = element;
        if (!(props.dangerouslySetInnerHTML == null)) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = _assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (!(defaultValue == null)) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (Array.isArray(children)) {
                    if (!(children.length <= 1)) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg";
    var Namespaces = {
        html: HTML_NAMESPACE,
        mathml: MATH_NAMESPACE,
        svg: SVG_NAMESPACE
    }; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === Namespaces.svg) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = _assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (!(typeof props.dangerouslySetInnerHTML === "object" && HTML in props.dangerouslySetInnerHTML)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (!(props.style == null || typeof props.style === "object")) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
    function validateProperty(tagName, name) {
        if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var _hasOwnProperty = Object.prototype.hasOwnProperty;
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    var IS_REPLAYED = 16;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (!(typeof restoreImpl === "function")) throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var discreteUpdatesImpl = function(fn, a, b, c, d) {
        return fn(a, b, c, d);
    };
    var flushDiscreteUpdatesImpl = function() {};
    var batchedEventUpdatesImpl = batchedUpdatesImpl;
    var isInsideEventHandler = false;
    var isBatchingEventUpdates = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            flushDiscreteUpdatesImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, bookkeeping) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(bookkeeping);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, bookkeeping);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    }
    function batchedEventUpdates(fn, a, b) {
        if (isBatchingEventUpdates) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isBatchingEventUpdates = true;
        try {
            return batchedEventUpdatesImpl(fn, a, b);
        } finally{
            isBatchingEventUpdates = false;
            finishEventHandler();
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var prevIsInsideEventHandler = isInsideEventHandler;
        isInsideEventHandler = true;
        try {
            return discreteUpdatesImpl(fn, a, b, c, d);
        } finally{
            isInsideEventHandler = prevIsInsideEventHandler;
            if (!isInsideEventHandler) finishEventHandler();
        }
    }
    function flushDiscreteUpdatesIfNeeded(timeStamp) {
        if (!isInsideEventHandler) flushDiscreteUpdatesImpl();
    }
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        discreteUpdatesImpl = _discreteUpdatesImpl;
        flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
        batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (!(!listener || typeof listener === "function")) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== "undefined")) throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var PlacementAndUpdate = /*           */ 6;
    var Deletion = /*                     */ 8;
    var ContentReset = /*                 */ 16;
    var Callback = /*                     */ 32;
    var DidCapture = /*                   */ 64;
    var Ref = /*                          */ 128;
    var Snapshot = /*                     */ 256;
    var Passive = /*                      */ 512; // TODO (effects) Remove this bit once the new reconciler is synced to the old.
    var PassiveUnmountPendingDev = /*     */ 8192;
    var Hydrating = /*                    */ 1024;
    var HydratingAndUpdate = /*           */ 1028; // Passive & Update & Callback & Ref & Snapshot
    var LifecycleEffectMask = /*          */ 932; // Union of all host effects
    var HostEffectMask = /*               */ 2047; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 2048;
    var ShouldCapture = /*                */ 4096;
    var ForceUpdateForLegacySuspense = /* */ 16384; // Static tags describe aspects of a fiber that are not specific to a render,
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) throw Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (!(a.alternate === b)) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (!(a.tag === HostRoot)) throw Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText) return node;
            else if (node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) return node;
            else if (node.child && node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function doesFiberContain(parentFiber, childFiber) {
        var node = childFiber;
        var parentFiberAlternate = parentFiber.alternate;
        while(node !== null){
            if (node === parentFiber || node === parentFiberAlternate) return true;
            node = node.return;
        }
        return false;
    }
    var attemptUserBlockingHydration;
    function setAttemptUserBlockingHydration(fn) {
        attemptUserBlockingHydration = fn;
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    function hasQueuedDiscreteEvents() {
        return queuedDiscreteEvents.length > 0;
    }
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isReplayableDiscreteEvent(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags | IS_REPLAYED,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
        queuedDiscreteEvents.push(queuedEvent);
    } // Resets the replaying for this type of continuous event to no event.
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with attemptToDispatchEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.lanePriority, function() {
                            Scheduler.unstable_runWithPriority(queuedTarget.priority, function() {
                                attemptHydrationAtCurrentPriority(nearestMounted);
                            });
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn !== null) {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false; // First replay discrete events.
        while(queuedDiscreteEvents.length > 0){
            var nextDiscreteEvent = queuedDiscreteEvents[0];
            if (nextDiscreteEvent.blockedOn !== null) {
                // We're still blocked.
                // Increase the priority of this boundary to unblock
                // the next discrete event.
                var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);
                if (_fiber4 !== null) attemptUserBlockingHydration(_fiber4);
                break;
            }
            var targetContainers = nextDiscreteEvent.targetContainers;
            while(targetContainers.length > 0){
                var targetContainer = targetContainers[0];
                var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);
                if (nextBlockedOn !== null) {
                    // We're still blocked. Try again later.
                    nextDiscreteEvent.blockedOn = nextBlockedOn;
                    break;
                } // This target container was successfully dispatched. Try the next.
                targetContainers.shift();
            }
            if (nextDiscreteEvent.blockedOn === null) // We've successfully replayed the first event. Let's try the next one.
            queuedDiscreteEvents.shift();
        } // Next replay any continuous events.
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var DiscreteEvent = 0;
    var UserBlockingEvent = 1;
    var ContinuousEvent = 2;
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map();
    var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
    // the code required to apply the same logic for event prioritization and that of the
    // SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
    // duplication (for which there would be quite a bit). For the events that are not needed
    // for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
    // array of top level events.
    // Lastly, we ignore prettier so we can keep the formatting sane.
    // prettier-ignore
    var discreteEventPairsForSimpleEventPlugin = [
        "cancel",
        "cancel",
        "click",
        "click",
        "close",
        "close",
        "contextmenu",
        "contextMenu",
        "copy",
        "copy",
        "cut",
        "cut",
        "auxclick",
        "auxClick",
        "dblclick",
        "doubleClick",
        "dragend",
        "dragEnd",
        "dragstart",
        "dragStart",
        "drop",
        "drop",
        "focusin",
        "focus",
        "focusout",
        "blur",
        "input",
        "input",
        "invalid",
        "invalid",
        "keydown",
        "keyDown",
        "keypress",
        "keyPress",
        "keyup",
        "keyUp",
        "mousedown",
        "mouseDown",
        "mouseup",
        "mouseUp",
        "paste",
        "paste",
        "pause",
        "pause",
        "play",
        "play",
        "pointercancel",
        "pointerCancel",
        "pointerdown",
        "pointerDown",
        "pointerup",
        "pointerUp",
        "ratechange",
        "rateChange",
        "reset",
        "reset",
        "seeked",
        "seeked",
        "submit",
        "submit",
        "touchcancel",
        "touchCancel",
        "touchend",
        "touchEnd",
        "touchstart",
        "touchStart",
        "volumechange",
        "volumeChange"
    ];
    var otherDiscreteEvents = [
        "change",
        "selectionchange",
        "textInput",
        "compositionstart",
        "compositionend",
        "compositionupdate"
    ];
    var userBlockingPairsForSimpleEventPlugin = [
        "drag",
        "drag",
        "dragenter",
        "dragEnter",
        "dragexit",
        "dragExit",
        "dragleave",
        "dragLeave",
        "dragover",
        "dragOver",
        "mousemove",
        "mouseMove",
        "mouseout",
        "mouseOut",
        "mouseover",
        "mouseOver",
        "pointermove",
        "pointerMove",
        "pointerout",
        "pointerOut",
        "pointerover",
        "pointerOver",
        "scroll",
        "scroll",
        "toggle",
        "toggle",
        "touchmove",
        "touchMove",
        "wheel",
        "wheel"
    ]; // prettier-ignore
    var continuousPairsForSimpleEventPlugin = [
        "abort",
        "abort",
        ANIMATION_END,
        "animationEnd",
        ANIMATION_ITERATION,
        "animationIteration",
        ANIMATION_START,
        "animationStart",
        "canplay",
        "canPlay",
        "canplaythrough",
        "canPlayThrough",
        "durationchange",
        "durationChange",
        "emptied",
        "emptied",
        "encrypted",
        "encrypted",
        "ended",
        "ended",
        "error",
        "error",
        "gotpointercapture",
        "gotPointerCapture",
        "load",
        "load",
        "loadeddata",
        "loadedData",
        "loadedmetadata",
        "loadedMetadata",
        "loadstart",
        "loadStart",
        "lostpointercapture",
        "lostPointerCapture",
        "playing",
        "playing",
        "progress",
        "progress",
        "seeking",
        "seeking",
        "stalled",
        "stalled",
        "suspend",
        "suspend",
        "timeupdate",
        "timeUpdate",
        TRANSITION_END,
        "transitionEnd",
        "waiting",
        "waiting"
    ];
    /**
 * Turns
 * ['abort', ...]
 *
 * into
 *
 * topLevelEventsToReactNames = new Map([
 *   ['abort', 'onAbort'],
 * ]);
 *
 * and registers them.
 */ function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
        // As the event types are in pairs of two, we need to iterate
        // through in twos. The events are in pairs of two to save code
        // and improve init perf of processing this array, as it will
        // result in far fewer object allocations and property accesses
        // if we only use three arrays to process all the categories of
        // instead of tuples.
        for(var i = 0; i < eventTypes.length; i += 2){
            var topEvent = eventTypes[i];
            var event = eventTypes[i + 1];
            var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
            var reactName = "on" + capitalizedEvent;
            eventPriorities.set(topEvent, priority);
            topLevelEventsToReactNames.set(topEvent, reactName);
            registerTwoPhaseEvent(reactName, [
                topEvent
            ]);
        }
    }
    function setEventPriorities(eventTypes, priority) {
        for(var i = 0; i < eventTypes.length; i++)eventPriorities.set(eventTypes[i], priority);
    }
    function getEventPriorityForPluginSystem(domEventName) {
        var priority = eventPriorities.get(domEventName); // Default to a ContinuousEvent. Note: we might
        // want to warn if we can't detect the priority
        // for the event.
        return priority === undefined ? ContinuousEvent : priority;
    }
    function registerSimpleEvents() {
        registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
        registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
        registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
        setEventPriorities(otherDiscreteEvents, DiscreteEvent);
    }
    var Scheduler_now = Scheduler.unstable_now;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority = 99;
    var UserBlockingPriority = 98;
    var NormalPriority = 97;
    var LowPriority = 96;
    var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority = 90;
    var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    var SyncLanePriority = 15;
    var SyncBatchedLanePriority = 14;
    var InputDiscreteHydrationLanePriority = 13;
    var InputDiscreteLanePriority = 12;
    var InputContinuousHydrationLanePriority = 11;
    var InputContinuousLanePriority = 10;
    var DefaultHydrationLanePriority = 9;
    var DefaultLanePriority = 8;
    var TransitionHydrationPriority = 7;
    var TransitionPriority = 6;
    var RetryLanePriority = 5;
    var SelectiveHydrationLanePriority = 4;
    var IdleHydrationLanePriority = 3;
    var IdleLanePriority = 2;
    var OffscreenLanePriority = 1;
    var NoLanePriority = 0;
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var SyncBatchedLane = /*                 */ 2;
    var InputDiscreteHydrationLane = /*      */ 4;
    var InputDiscreteLanes = /*                    */ 24;
    var InputContinuousHydrationLane = /*           */ 32;
    var InputContinuousLanes = /*                  */ 192;
    var DefaultHydrationLane = /*            */ 256;
    var DefaultLanes = /*                   */ 3584;
    var TransitionHydrationLane = /*                */ 4096;
    var TransitionLanes = /*                       */ 4186112;
    var RetryLanes = /*                            */ 62914560;
    var SomeRetryLane = /*                  */ 33554432;
    var SelectiveHydrationLane = /*          */ 67108864;
    var NonIdleLanes = /*                                 */ 134217727;
    var IdleHydrationLane = /*               */ 134217728;
    var IdleLanes = /*                             */ 805306368;
    var OffscreenLane = /*                   */ 1073741824;
    var NoTimestamp = -1;
    function setCurrentUpdateLanePriority(newLanePriority) {} // "Registers" used to "return" multiple values
    // Used by getHighestPriorityLanes and getNextLanes:
    var return_highestLanePriority = DefaultLanePriority;
    function getHighestPriorityLanes(lanes) {
        if ((SyncLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncLanePriority;
            return SyncLane;
        }
        if ((SyncBatchedLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncBatchedLanePriority;
            return SyncBatchedLane;
        }
        if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
            return_highestLanePriority = InputDiscreteHydrationLanePriority;
            return InputDiscreteHydrationLane;
        }
        var inputDiscreteLanes = InputDiscreteLanes & lanes;
        if (inputDiscreteLanes !== NoLanes) {
            return_highestLanePriority = InputDiscreteLanePriority;
            return inputDiscreteLanes;
        }
        if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
            return_highestLanePriority = InputContinuousHydrationLanePriority;
            return InputContinuousHydrationLane;
        }
        var inputContinuousLanes = InputContinuousLanes & lanes;
        if (inputContinuousLanes !== NoLanes) {
            return_highestLanePriority = InputContinuousLanePriority;
            return inputContinuousLanes;
        }
        if ((lanes & DefaultHydrationLane) !== NoLanes) {
            return_highestLanePriority = DefaultHydrationLanePriority;
            return DefaultHydrationLane;
        }
        var defaultLanes = DefaultLanes & lanes;
        if (defaultLanes !== NoLanes) {
            return_highestLanePriority = DefaultLanePriority;
            return defaultLanes;
        }
        if ((lanes & TransitionHydrationLane) !== NoLanes) {
            return_highestLanePriority = TransitionHydrationPriority;
            return TransitionHydrationLane;
        }
        var transitionLanes = TransitionLanes & lanes;
        if (transitionLanes !== NoLanes) {
            return_highestLanePriority = TransitionPriority;
            return transitionLanes;
        }
        var retryLanes = RetryLanes & lanes;
        if (retryLanes !== NoLanes) {
            return_highestLanePriority = RetryLanePriority;
            return retryLanes;
        }
        if (lanes & SelectiveHydrationLane) {
            return_highestLanePriority = SelectiveHydrationLanePriority;
            return SelectiveHydrationLane;
        }
        if ((lanes & IdleHydrationLane) !== NoLanes) {
            return_highestLanePriority = IdleHydrationLanePriority;
            return IdleHydrationLane;
        }
        var idleLanes = IdleLanes & lanes;
        if (idleLanes !== NoLanes) {
            return_highestLanePriority = IdleLanePriority;
            return idleLanes;
        }
        if ((OffscreenLane & lanes) !== NoLanes) {
            return_highestLanePriority = OffscreenLanePriority;
            return OffscreenLane;
        }
        error("Should have found matching lanes. This is a bug in React.");
        return_highestLanePriority = DefaultLanePriority;
        return lanes;
    }
    function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
        switch(schedulerPriorityLevel){
            case ImmediatePriority:
                return SyncLanePriority;
            case UserBlockingPriority:
                return InputContinuousLanePriority;
            case NormalPriority:
            case LowPriority:
                // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                return DefaultLanePriority;
            case IdlePriority:
                return IdleLanePriority;
            default:
                return NoLanePriority;
        }
    }
    function lanePriorityToSchedulerPriority(lanePriority) {
        switch(lanePriority){
            case SyncLanePriority:
            case SyncBatchedLanePriority:
                return ImmediatePriority;
            case InputDiscreteHydrationLanePriority:
            case InputDiscreteLanePriority:
            case InputContinuousHydrationLanePriority:
            case InputContinuousLanePriority:
                return UserBlockingPriority;
            case DefaultHydrationLanePriority:
            case DefaultLanePriority:
            case TransitionHydrationPriority:
            case TransitionPriority:
            case SelectiveHydrationLanePriority:
            case RetryLanePriority:
                return NormalPriority;
            case IdleHydrationLanePriority:
            case IdleLanePriority:
            case OffscreenLanePriority:
                return IdlePriority;
            case NoLanePriority:
                return NoPriority;
            default:
                throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) {
            return_highestLanePriority = NoLanePriority;
            return NoLanes;
        }
        var nextLanes = NoLanes;
        var nextLanePriority = NoLanePriority;
        var expiredLanes = root.expiredLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Check if any work has expired.
        if (expiredLanes !== NoLanes) {
            nextLanes = expiredLanes;
            nextLanePriority = return_highestLanePriority = SyncLanePriority;
        } else {
            // Do not work on any idle work until all the non-idle work has finished,
            // even if the work is suspended.
            var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
            if (nonIdlePendingLanes !== NoLanes) {
                var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
                if (nonIdleUnblockedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
                    nextLanePriority = return_highestLanePriority;
                } else {
                    var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                    if (nonIdlePingedLanes !== NoLanes) {
                        nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
                        nextLanePriority = return_highestLanePriority;
                    }
                }
            } else {
                // The only remaining work is Idle.
                var unblockedLanes = pendingLanes & ~suspendedLanes;
                if (unblockedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(unblockedLanes);
                    nextLanePriority = return_highestLanePriority;
                } else if (pingedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(pingedLanes);
                    nextLanePriority = return_highestLanePriority;
                }
            }
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If there are higher priority lanes, we'll include them even if they
        // are suspended.
        nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes); // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            getHighestPriorityLanes(wipLanes);
            var wipLanePriority = return_highestLanePriority;
            if (nextLanePriority <= wipLanePriority) return wipLanes;
            else return_highestLanePriority = nextLanePriority;
        } // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        // TODO: Expiration heuristic is constant per lane, so could use a map.
        getHighestPriorityLanes(lane);
        var priority = return_highestLanePriority;
        if (priority >= InputContinuousLanePriority) // User interactions should expire slightly more quickly.
        //
        // NOTE: This is set to the corresponding constant as in Scheduler.js. When
        // we made it larger, a product metric in www regressed, suggesting there's
        // a user interaction that's being starved by a series of synchronous
        // updates. If that theory is correct, the proper solution is to fix the
        // starvation. However, this scenario supports the idea that expiration
        // times are an important safeguard when starvation does happen.
        //
        // Also note that, in the case of user input specifically, this will soon no
        // longer be an issue because we plan to make user input synchronous by
        // default (until you enter `startTransition`, of course.)
        //
        // If weren't planning to make these updates synchronous soon anyway, I
        // would probably make this number a configurable parameter.
        return currentTime + 250;
        else if (priority >= TransitionPriority) return currentTime + 5000;
        else // Anything idle priority or lower should never expire.
        return NoTimestamp;
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function returnNextLanesPriority() {
        return return_highestLanePriority;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    } // To ensure consistency across multiple updates in the same event, this should
    // be a pure function, so that it always returns the same lane for given inputs.
    function findUpdateLane(lanePriority, wipLanes) {
        switch(lanePriority){
            case NoLanePriority:
                break;
            case SyncLanePriority:
                return SyncLane;
            case SyncBatchedLanePriority:
                return SyncBatchedLane;
            case InputDiscreteLanePriority:
                var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);
                if (_lane === NoLane) // Shift to the next priority level
                return findUpdateLane(InputContinuousLanePriority, wipLanes);
                return _lane;
            case InputContinuousLanePriority:
                var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);
                if (_lane2 === NoLane) // Shift to the next priority level
                return findUpdateLane(DefaultLanePriority, wipLanes);
                return _lane2;
            case DefaultLanePriority:
                var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);
                if (_lane3 === NoLane) {
                    // If all the default lanes are already being worked on, look for a
                    // lane in the transition range.
                    _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);
                    if (_lane3 === NoLane) // All the transition lanes are taken, too. This should be very
                    // rare, but as a last resort, pick a default lane. This will have
                    // the effect of interrupting the current work-in-progress render.
                    _lane3 = pickArbitraryLane(DefaultLanes);
                }
                return _lane3;
            case TransitionPriority:
            case RetryLanePriority:
                break;
            case IdleLanePriority:
                var lane = pickArbitraryLane(IdleLanes & ~wipLanes);
                if (lane === NoLane) lane = pickArbitraryLane(IdleLanes);
                return lane;
        }
        throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
    } // To ensure consistency across multiple updates in the same event, this should
    // be pure function, so that it always returns the same lane for given inputs.
    function findTransitionLane(wipLanes, pendingLanes) {
        // First look for lanes that are completely unclaimed, i.e. have no
        // pending work.
        var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);
        if (lane === NoLane) {
            // If all lanes have pending work, look for a lane that isn't currently
            // being worked on.
            lane = pickArbitraryLane(TransitionLanes & ~wipLanes);
            if (lane === NoLane) // If everything is being worked on, pick any lane. This has the
            // effect of interrupting the current work-in-progress.
            lane = pickArbitraryLane(TransitionLanes);
        }
        return lane;
    } // To ensure consistency across multiple updates in the same event, this should
    // be pure function, so that it always returns the same lane for given inputs.
    function findRetryLane(wipLanes) {
        // This is a fork of `findUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        var lane = pickArbitraryLane(RetryLanes & ~wipLanes);
        if (lane === NoLane) lane = pickArbitraryLane(RetryLanes);
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function getLowestPriorityLane(lanes) {
        // This finds the most significant non-zero bit.
        var index = 31 - clz32(lanes);
        return index < 0 ? NoLanes : 1 << index;
    }
    function getEqualOrHigherPriorityLanes(lanes) {
        return (getLowestPriorityLane(lanes) << 1) - 1;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // TODO: Theoretically, any update to any lane can unblock any other lane. But
        // it's not practical to try every single possible combination. We need a
        // heuristic to decide which lanes to attempt to render, and in which batches.
        // For now, we use the same heuristic as in the old ExpirationTimes model:
        // retry any lane at equal or lower priority, but don't try updates at higher
        // priority without also including the lower priority updates. This works well
        // when considering updates across different priority levels, but isn't
        // sufficient for updates within the same priority, since we want to treat
        // those updates as parallel.
        // Unsuspend any update at equal or lower priority.
        var higherPriorityLanes = updateLane - 1; // Turns 0b1000 into 0b0111
        root.suspendedLanes &= higherPriorityLanes;
        root.pingedLanes &= higherPriorityLanes;
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markDiscreteUpdatesExpired(root) {
        root.expiredLanes |= InputDiscreteLanes & root.pendingLanes;
    }
    function hasDiscreteLanes(lanes) {
        return (lanes & InputDiscreteLanes) !== NoLanes;
    }
    function markRootMutableRead(root, updateLane) {
        root.mutableReadLanes |= updateLane & root.pendingLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = entangledLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros. Only used on lanes, so assume input is an integer.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(lanes) {
        if (lanes === 0) return 32;
        return 31 - (log(lanes) / LN2 | 0) | 0;
    }
    // Intentionally not named imports because Rollup would use dynamic dispatch for
    var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority, runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriorityForPluginSystem(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEvent:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case UserBlockingEvent:
                listenerWrapper = dispatchUserBlockingUpdate;
                break;
            case ContinuousEvent:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
        discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
    }
    function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
        runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        var allowReplay = true;
        // TODO: replaying capture phase events is currently broken
        // because we used to do it during top-level native bubble handlers
        // but now we use different bubble and capture handlers.
        // In eager mode, we attach capture listeners early, so we need
        // to filter them out until we fix the logic to handle them correctly.
        // This could've been outside the flag but I put it inside to reduce risk.
        allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
        if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
            // If we already have a queue of discrete events, and this is another discrete
            // event, then we can't dispatch it regardless of its target, since they
            // need to dispatch in order.
            queueDiscreteEvent(null, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            return;
        }
        var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            // We successfully dispatched this event.
            if (allowReplay) clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (allowReplay) {
            if (isReplayableDiscreteEvent(domEventName)) {
                // This this to be replayed later once the target is available.
                queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
                return;
            }
            if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) return;
             // We need to clear only if we didn't queue because
            // queueing is accummulative.
            clearIfContinuousEvent(domEventName, nativeEvent);
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    } // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.
    function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer); // We're not blocked on anything.
        return null;
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        _assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = _assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = _assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = _assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = _assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = _assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = _assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = _assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = _assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = _assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = _assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = _assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = _assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't forsee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (rootContainerElement[listeningMarker]) // Performance optimization: don't iterate through events
        // for the same portal container or root node more than once.
        // TODO: once we remove the flag, we may be able to also
        // remove some of the bookkeeping maps used for laziness.
        return;
        rootContainerElement[listeningMarker] = true;
        allNativeEvents.forEach(function(domEventName) {
            if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement, null);
            listenToNativeEvent(domEventName, true, rootContainerElement, null);
        });
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
        var eventSystemFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var target = rootContainerElement; // selectionchange needs to be attached to the document
        // otherwise it won't capture incoming events that are only
        // triggered on the document directly.
        if (domEventName === "selectionchange" && rootContainerElement.nodeType !== DOCUMENT_NODE) target = rootContainerElement.ownerDocument;
         // If the event can be delegated (or is capture phase), we can
        // register it to the root container. Otherwise, we should
        // register the event to the target element and mark it as
        // a non-delegated event.
        if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
            // For all non-delegated events, apart from scroll, we attach
            // their event listeners to the respective elements that their
            // events fire on. That means we can skip this step, as event
            // listener has already been added previously. However, we
            // special case the scroll event because the reality is that any
            // element can scroll.
            // TODO: ideally, we'd eventually apply the same logic to all
            // events from the nonDelegatedEvents list. Then we can remove
            // this special case and use the same logic for all events.
            if (domEventName !== "scroll") return;
            eventSystemFlags |= IS_NON_DELEGATED;
            target = targetElement;
        }
        var listenerSet = getEventListenerSet(target);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener); // If the listener entry is empty or we should upgrade, then
        // we need to trap an event listener onto the target.
        if (!listenerSet.has(listenerSetKey)) {
            if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
            addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedEventUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var HTML_NAMESPACE$1 = Namespaces.html;
    var warnedUnknownTags;
    var suppressHydrationWarning;
    var validatePropertiesInDevelopment;
    var warnForTextDifference;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeMarkupForTextOrAttribute;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    normalizeMarkupForTextOrAttribute = function(markup) {
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    };
    warnForTextDifference = function(serverText, clientText) {
        if (didWarnInvalidHydration) return;
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        didWarnInvalidHydration = true;
        error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
    };
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE$1) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$3(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "option":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$3(domElement, lastRawProps);
                nextProps = getHostProps$3(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else if (typeof nextProp === "object" && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) // If we encounter useOpaqueReference's opaque object, this means we are hydrating.
            // In this case, call the opaque object's toString function which generates a new client
            // ID so client and server IDs match and throws to rerender.
            nextProp.toString();
            else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
        var isCustomComponentTag;
        var extraAttributeNames;
        suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Built-in SSR attribute is allowed
                case "data-reactroot":
                    break;
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = getPropertyInfo(propKey);
                if (suppressHydrationWarning) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE$1) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE$1) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    if (nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        // $FlowFixMe - Should be inferred as not undefined.
        if (extraAttributeNames.size > 0 && !suppressHydrationWarning) // $FlowFixMe - Should be inferred as not undefined.
        warnForExtraAttributes(extraAttributeNames);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForUnmatchedText(textNode, text) {
        warnForTextDifference(textNode.nodeValue, text);
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1;
    SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function shouldAutoFocusHostComponent(type, props) {
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
        }
        return false;
    }
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        return shouldAutoFocusHostComponent(type, props);
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "option" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1; // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        if (shouldAutoFocusHostComponent(type, newProps)) domElement.focus();
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            var body = container.body;
            if (body != null) body.textContent = "";
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        return diffHydratedProperties(instance, type, props, parentNamespace);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
        warnForUnmatchedText(textInstance, text);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForUnmatchedText(textInstance, text);
    }
    function didNotHydrateContainerInstance(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableContainerInstance(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableContainerTextInstance(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
        parentProps[SUPPRESS_HYDRATION_WARNING$1];
    }
    var clientId = 0;
    function makeClientIdInDEV(warnOnAccessInDEV) {
        var id = "r:" + (clientId++).toString(36);
        return {
            toString: function() {
                warnOnAccessInDEV();
                return id;
            },
            valueOf: function() {
                warnOnAccessInDEV();
                return id;
            }
        };
    }
    function isOpaqueHydratingObject(value) {
        return value !== null && typeof value === "object" && value.$$typeof === REACT_OPAQUE_ID_TYPE;
    }
    function makeOpaqueHydratingObject(attemptToReadValue) {
        return {
            $$typeof: REACT_OPAQUE_ID_TYPE,
            toString: attemptToReadValue,
            valueOf: attemptToReadValue
        };
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentName(type) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (!(contextStackCursor.current === emptyContextObject)) throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentName(type) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw Error((getComponentName(type) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentName(type) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return _assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var BlockingRoot = 1;
    var ConcurrentRoot = 2;
    var rendererID = null;
    var injectedHook = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        } // DevTools exists
        return true;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, priorityLevel) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) injectedHook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
            else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler.unstable_cancelCallback, Scheduler_shouldYield = Scheduler.unstable_shouldYield, Scheduler_requestPaint = Scheduler.unstable_requestPaint, Scheduler_now$1 = Scheduler.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler.unstable_NormalPriority, Scheduler_LowPriority = Scheduler.unstable_LowPriority, Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority$1 = 99;
    var UserBlockingPriority$2 = 98;
    var NormalPriority$1 = 97;
    var LowPriority$1 = 96;
    var IdlePriority$1 = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority$1 = 90;
    var shouldYield = Scheduler_shouldYield;
    var requestPaint = Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function() {};
    var syncQueue = null;
    var immediateQueueCallbackNode = null;
    var isFlushingSyncQueue = false;
    var initialTimeMs$1 = Scheduler_now$1(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    // This will be the case for modern browsers that support `performance.now`. In
    // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
    // timestamp. In that case, subtract the module initialization time to simulate
    // the behavior of performance.now and keep our times small enough to fit
    // within 32 bits.
    // TODO: Consider lifting this into Scheduler.
    var now = initialTimeMs$1 < 10000 ? Scheduler_now$1 : function() {
        return Scheduler_now$1() - initialTimeMs$1;
    };
    function getCurrentPriorityLevel() {
        switch(Scheduler_getCurrentPriorityLevel()){
            case Scheduler_ImmediatePriority:
                return ImmediatePriority$1;
            case Scheduler_UserBlockingPriority:
                return UserBlockingPriority$2;
            case Scheduler_NormalPriority:
                return NormalPriority$1;
            case Scheduler_LowPriority:
                return LowPriority$1;
            case Scheduler_IdlePriority:
                return IdlePriority$1;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch(reactPriorityLevel){
            case ImmediatePriority$1:
                return Scheduler_ImmediatePriority;
            case UserBlockingPriority$2:
                return Scheduler_UserBlockingPriority;
            case NormalPriority$1:
                return Scheduler_NormalPriority;
            case LowPriority$1:
                return Scheduler_LowPriority;
            case IdlePriority$1:
                return Scheduler_IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function runWithPriority$1(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
    }
    function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
    }
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
            syncQueue = [
                callback
            ]; // Flush the queue in the next tick, at the earliest.
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
        return fakeCallbackNode;
    }
    function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) Scheduler_cancelCallback(callbackNode);
    }
    function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
            var node = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
    }
    function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrancy.
            isFlushingSyncQueue = true;
            var i = 0;
            try {
                var _isSync2 = true;
                var _queue = syncQueue;
                runWithPriority$1(ImmediatePriority$1, function() {
                    for(; i < _queue.length; i++){
                        var callback = _queue[i];
                        do callback = callback(_isSync2);
                        while (callback !== null);
                    }
                });
                syncQueue = null;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error;
            } finally{
                isFlushingSyncQueue = false;
            }
        }
    }
    // TODO: this is special because it gets imported during build.
    var ReactVersion = "17.0.2";
    var NoMode = 0;
    var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
    // tag instead
    var BlockingMode = 2;
    var ConcurrentMode = 4;
    var ProfileMode = 8;
    var DebugTracingMode = 16;
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = 0;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedup strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = _assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var MAX_SIGNED_31_BIT_INT = 1073741823;
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastContextWithAllBitsObserved = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        context._currentValue = currentValue;
    }
    function calculateChangedBits(context, newValue, oldValue) {
        if (objectIs(oldValue, newValue)) // No change
        return 0;
        else {
            var changedBits = typeof context._calculateChangedBits === "function" ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) error("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
            return changedBits | 0;
        }
    }
    function scheduleWorkOnParentPath(parent, renderLanes) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            else break;
            node = node.return;
        }
    }
    function propagateContextChange(workInProgress, context, changedBits, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes));
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            enqueueUpdate(fiber, update);
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleWorkOnParentPath(fiber.return, renderLanes); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context, observedBits) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        if (lastContextWithAllBitsObserved === context) ;
        else if (observedBits === false || observedBits === 0) ;
        else {
            var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.
            if (typeof observedBits !== "number" || observedBits === MAX_SIGNED_31_BIT_INT) {
                // Observe all updates.
                lastContextWithAllBitsObserved = context;
                resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else resolvedObservedBits = observedBits;
            var contextItem = {
                context: context,
                observedBits: resolvedObservedBits,
                next: null
            };
            if (lastContextDependency === null) {
                if (!(currentlyRenderingFiber !== null)) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem,
                    responders: null
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return context._currentValue;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        var pending = sharedQueue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        sharedQueue.pending = update;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            reenableLogs();
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            reenableLogs();
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return _assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (!(typeof callback === "function")) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {};
    var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentName(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                // Invoke the function an extra time to help detect side-effects.
                getDerivedStateFromProps(nextProps, prevState);
            } finally{
                reenableLogs();
            }
        }
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    reenableLogs();
                }
            }
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentName(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                new ctor(props, context); // eslint-disable-line no-new
            } finally{
                reenableLogs();
            }
        }
        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentName(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress.type) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentName(workInProgress.type) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") workInProgress.flags |= Update;
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") workInProgress.flags |= Update;
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") workInProgress.flags |= Update;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") workInProgress.flags |= Update;
             // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (!(typeof child._store === "object")) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentName(returnFiber.type) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    var isArray$1 = Array.isArray;
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (!(ownerFiber.tag === ClassComponent)) throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = inst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = inst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (!(typeof mixedRef === "string")) throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== "textarea") throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : newChild) + "). If you meant to render a collection of children, use an array instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentName(returnFiber.type) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    } // We avoid inlining this to avoid potential deopts from using try/catch.
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
             // Deletions are added in reversed order so we add it to the front.
            // At this point, the return fiber's effect list is empty except for
            // deletions, so we can just append the deletion to the list. The remaining
            // effects aren't added until the complete phase. Once we implement
            // resuming, this may not be true.
            var last = returnFiber.lastEffect;
            if (last !== null) {
                last.nextEffect = childToDelete;
                returnFiber.lastEffect = childToDelete;
            } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            childToDelete.nextEffect = null;
            childToDelete.flags = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) // Noop.
            return lastPlacedIndex;
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags = Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags = Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags = Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            if (current !== null) {
                if (current.elementType === element.type || isCompatibleFamilyForHotReloading(current, element)) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) {
                            if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, oldFiber, newChild.props.children, lanes, key);
                            return updateElement(returnFiber, oldFiber, newChild, lanes);
                        } else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === "function")) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) throw Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    switch(child.tag){
                        case Fragment:
                            if (element.type === REACT_FRAGMENT_TYPE) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var existing = useFiber(child, element.props.children);
                                existing.return = returnFiber;
                                existing._debugSource = element._source;
                                existing._debugOwner = element._owner;
                                return existing;
                            }
                            break;
                        case Block:
                        // We intentionally fallthrough here if enableBlocksAPI is not on.
                        // eslint-disable-next-lined no-fallthrough
                        default:
                            if (child.elementType === element.type || isCompatibleFamilyForHotReloading(child, element)) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var _existing3 = useFiber(child, element.props);
                                _existing3.ref = coerceRef(returnFiber, child, element);
                                _existing3.return = returnFiber;
                                _existing3._debugSource = element._source;
                                _existing3._debugOwner = element._owner;
                                return _existing3;
                            }
                            break;
                    } // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            var isObject = typeof newChild === "object" && newChild !== null;
            if (isObject) switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                case REACT_PORTAL_TYPE:
                    return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
            }
            if (typeof newChild === "string" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (isArray$1(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            if (isObject) throwOnInvalidObjectType(returnFiber, newChild);
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            if (typeof newChild === "undefined" && !isUnkeyedTopLevelFragment) // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch(returnFiber.tag){
                case ClassComponent:
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) break;
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough
                case Block:
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    throw Error((getComponentName(returnFiber.type) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
            }
             // Remaining cases are all treated as empty.
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (!(current === null || workInProgress.child === current.child)) throw Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (!(c !== NO_CONTEXT)) throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.
        if (props.fallback === undefined) return false;
         // Regular boundaries always capture.
        if (props.unstable_avoidThisFallback !== true) return true;
         // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.
        if (hasInvisibleParent) return false;
         // If the parent is not able to handle it, we must handle it.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*  */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Layout = /*    */ 2;
    var Passive$1 = /*   */ 4;
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false;
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
    }
    function deleteHydratableInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.flags = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.
        if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
        } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableContainerInstance(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableContainerTextInstance(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                        break;
                    case SuspenseComponent:
                        didNotFindHydratableSuspenseInstance(parentType, parentProps);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    return true;
                }
                return false;
            case SuspenseComponent:
                return false;
            default:
                return false;
        }
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }
        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
            }
        }
        return shouldUpdate;
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        }
        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.
        if (fiber.tag !== HostComponent || type !== "head" && type !== "body" && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;
            while(nextInstance){
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
    }
    function getIsHydrating() {
        return isHydrating;
    }
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    var rendererSigil$1;
    // Used to detect multiple renderers using the same mutable source.
    rendererSigil$1 = {};
    function markSourceAsDirty(mutableSource) {
        workInProgressSources.push(mutableSource);
    }
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    function getWorkInProgressVersion(mutableSource) {
        return mutableSource._workInProgressVersionPrimary;
    }
    function setWorkInProgressVersion(mutableSource, version) {
        mutableSource._workInProgressVersionPrimary = version;
        workInProgressSources.push(mutableSource);
    }
    function warnAboutMultipleRenderersDEV(mutableSource) {
        if (mutableSource._currentPrimaryRenderer == null) mutableSource._currentPrimaryRenderer = rendererSigil$1;
        else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) error("Detected multiple renderers concurrently rendering the same mutable source. This is currently unsupported.");
    } // Eager reads the version of a mutable source and stores it on the root.
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnAboutUseOpaqueIdentifier;
    didWarnAboutUseOpaqueIdentifier = {};
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !Array.isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentName(currentlyRenderingFiber$1.type);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                if (!(numberOfReRenders < RE_RENDER_LIMIT)) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        didScheduleRenderPhaseUpdate = false;
        if (!!didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (!(nextCurrentHook !== null)) throw Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        eagerReducer: update.eagerReducer,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            eagerReducer: update.eagerReducer,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.eagerReducer === reducer) // If this update was processed eagerly, and its reducer matches the
                    // current reducer, we can use the eagerly computed state.
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        }
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function readFromUnsubcribedMutableSource(root, source, getSnapshot) {
        warnAboutMultipleRenderersDEV(source);
        var getVersion = source._getVersion;
        var version = getVersion(source._source); // Is it safe for this component to read from this source during the current render?
        var isSafeToReadFromSource = false; // Check the version first.
        // If this render has already been started with a specific version,
        // we can use it alone to determine if we can safely read from the source.
        var currentRenderVersion = getWorkInProgressVersion(source);
        if (currentRenderVersion !== null) // It's safe to read if the store hasn't been mutated since the last time
        // we read something.
        isSafeToReadFromSource = currentRenderVersion === version;
        else {
            // If there's no version, then this is the first time we've read from the
            // source during the current render pass, so we need to do a bit more work.
            // What we need to determine is if there are any hooks that already
            // subscribed to the source, and if so, whether there are any pending
            // mutations that haven't been synchronized yet.
            //
            // If there are no pending mutations, then `root.mutableReadLanes` will be
            // empty, and we know we can safely read.
            //
            // If there *are* pending mutations, we may still be able to safely read
            // if the currently rendering lanes are inclusive of the pending mutation
            // lanes, since that guarantees that the value we're about to read from
            // the source is consistent with the values that we read during the most
            // recent mutation.
            isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root.mutableReadLanes);
            if (isSafeToReadFromSource) // If it's safe to read from this source during the current render,
            // store the version in case other components read from it.
            // A changed version number will let those components know to throw and restart the render.
            setWorkInProgressVersion(source, version);
        }
        if (isSafeToReadFromSource) {
            var snapshot = getSnapshot(source._source);
            if (typeof snapshot === "function") error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
            return snapshot;
        } else {
            // This handles the special case of a mutable source being shared between renderers.
            // In that case, if the source is mutated between the first and second renderer,
            // The second renderer don't know that it needs to reset the WIP version during unwind,
            // (because the hook only marks sources as dirty if it's written to their WIP version).
            // That would cause this tear check to throw again and eventually be visible to the user.
            // We can avoid this infinite loop by explicitly marking the source as dirty.
            //
            // This can lead to tearing in the first renderer when it resumes,
            // but there's nothing we can do about that (short of throwing here and refusing to continue the render).
            markSourceAsDirty(source);
            throw Error("Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.");
        }
    }
    function useMutableSource(hook, source, getSnapshot, subscribe) {
        var root = getWorkInProgressRoot();
        if (!(root !== null)) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        var getVersion = source._getVersion;
        var version = getVersion(source._source);
        var dispatcher = ReactCurrentDispatcher$1.current; // eslint-disable-next-line prefer-const
        var _dispatcher$useState = dispatcher.useState(function() {
            return readFromUnsubcribedMutableSource(root, source, getSnapshot);
        }), currentSnapshot = _dispatcher$useState[0], setSnapshot = _dispatcher$useState[1];
        var snapshot = currentSnapshot; // Grab a handle to the state hook as well.
        // We use it to clear the pending update queue if we have a new source.
        var stateHook = workInProgressHook;
        var memoizedState = hook.memoizedState;
        var refs = memoizedState.refs;
        var prevGetSnapshot = refs.getSnapshot;
        var prevSource = memoizedState.source;
        var prevSubscribe = memoizedState.subscribe;
        var fiber = currentlyRenderingFiber$1;
        hook.memoizedState = {
            refs: refs,
            source: source,
            subscribe: subscribe
        }; // Sync the values needed by our subscription handler after each commit.
        dispatcher.useEffect(function() {
            refs.getSnapshot = getSnapshot; // Normally the dispatch function for a state hook never changes,
            // but this hook recreates the queue in certain cases  to avoid updates from stale sources.
            // handleChange() below needs to reference the dispatch function without re-subscribing,
            // so we use a ref to ensure that it always has the latest version.
            refs.setSnapshot = setSnapshot; // Check for a possible change between when we last rendered now.
            var maybeNewVersion = getVersion(source._source);
            if (!objectIs(version, maybeNewVersion)) {
                var maybeNewSnapshot = getSnapshot(source._source);
                if (typeof maybeNewSnapshot === "function") error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
                if (!objectIs(snapshot, maybeNewSnapshot)) {
                    setSnapshot(maybeNewSnapshot);
                    var lane = requestUpdateLane(fiber);
                    markRootMutableRead(root, lane);
                } // If the source mutated between render and now,
                // there may be state updates already scheduled from the old source.
                // Entangle the updates so that they render in the same batch.
                markRootEntangled(root, root.mutableReadLanes);
            }
        }, [
            getSnapshot,
            source,
            subscribe
        ]); // If we got a new source or subscribe function, re-subscribe in a passive effect.
        dispatcher.useEffect(function() {
            var handleChange = function() {
                var latestGetSnapshot = refs.getSnapshot;
                var latestSetSnapshot = refs.setSnapshot;
                try {
                    latestSetSnapshot(latestGetSnapshot(source._source)); // Record a pending mutable source update with the same expiration time.
                    var lane = requestUpdateLane(fiber);
                    markRootMutableRead(root, lane);
                } catch (error) {
                    // A selector might throw after a source mutation.
                    // e.g. it might try to read from a part of the store that no longer exists.
                    // In this case we should still schedule an update with React.
                    // Worst case the selector will throw again and then an error boundary will handle it.
                    latestSetSnapshot(function() {
                        throw error;
                    });
                }
            };
            var unsubscribe = subscribe(source._source, handleChange);
            if (typeof unsubscribe !== "function") error("Mutable source subscribe function must return an unsubscribe function.");
            return unsubscribe;
        }, [
            source,
            subscribe
        ]); // If any of the inputs to useMutableSource change, reading is potentially unsafe.
        //
        // If either the source or the subscription have changed we can't can't trust the update queue.
        // Maybe the source changed in a way that the old subscription ignored but the new one depends on.
        //
        // If the getSnapshot function changed, we also shouldn't rely on the update queue.
        // It's possible that the underlying source was mutated between the when the last "change" event fired,
        // and when the current render (with the new getSnapshot function) is processed.
        //
        // In both cases, we need to throw away pending updates (since they are no longer relevant)
        // and treat reading from the source as we do in the mount case.
        if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
            // Create a new queue and setState method,
            // So if there are interleaved updates, they get pushed to the older queue.
            // When this becomes current, the previous queue and dispatch method will be discarded,
            // including any interleaving updates that occur.
            var newQueue = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: snapshot
            };
            newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
            stateHook.queue = newQueue;
            stateHook.baseQueue = null;
            snapshot = readFromUnsubcribedMutableSource(root, source, getSnapshot);
            stateHook.memoizedState = stateHook.baseState = snapshot;
        }
        return snapshot;
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = {
            refs: {
                getSnapshot: getSnapshot,
                setSnapshot: null
            },
            source: source,
            subscribe: subscribe
        };
        return useMutableSource(hook, source, getSnapshot, subscribe);
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        var hook = updateWorkInProgressHook();
        return useMutableSource(hook, source, getSnapshot, subscribe);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
            current: initialValue
        };
        Object.seal(ref);
        hook.memoizedState = ref;
        return ref;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ("undefined" !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return mountEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ("undefined" !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return updateEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
        mountEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function updateDeferredValue(value) {
        var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
        updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function rerenderDeferredValue(value) {
        var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
        updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function startTransition(setPending, callback) {
        var priorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function() {
            setPending(true);
        });
        runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setPending(false);
                callback();
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        });
    }
    function mountTransition() {
        var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1]; // The `start` method can be stored on a ref, since `setPending`
        // never changes.
        var start = startTransition.bind(null, setPending);
        mountRef(start);
        return [
            start,
            isPending
        ];
    }
    function updateTransition() {
        var _updateState2 = updateState(), isPending = _updateState2[0];
        var startRef = updateRef();
        var start = startRef.current;
        return [
            start,
            isPending
        ];
    }
    function rerenderTransition() {
        var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0];
        var startRef = updateRef();
        var start = startRef.current;
        return [
            start,
            isPending
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function warnOnOpaqueIdentifierAccessInDEV(fiber) {
        // TODO: Should warn in effects and callbacks, too
        var name = getComponentName(fiber.type) || "Unknown";
        if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
            error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
            didWarnAboutUseOpaqueIdentifier[name] = true;
        }
    }
    function mountOpaqueIdentifier() {
        var makeId = makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1));
        if (getIsHydrating()) {
            var didUpgrade = false;
            var fiber = currentlyRenderingFiber$1;
            var readValue = function() {
                if (!didUpgrade) {
                    // Only upgrade once. This works even inside the render phase because
                    // the update is added to a shared queue, which outlasts the
                    // in-progress render.
                    didUpgrade = true;
                    isUpdatingOpaqueValueInRenderPhase = true;
                    setId(makeId());
                    isUpdatingOpaqueValueInRenderPhase = false;
                    warnOnOpaqueIdentifierAccessInDEV(fiber);
                }
                throw Error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
            };
            var id = makeOpaqueHydratingObject(readValue);
            var setId = mountState(id)[1];
            if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
                currentlyRenderingFiber$1.flags |= Update | Passive;
                pushEffect(HasEffect | Passive$1, function() {
                    setId(makeId());
                }, undefined, null);
            }
            return id;
        } else {
            var _id = makeId();
            mountState(_id);
            return _id;
        }
    }
    function updateOpaqueIdentifier() {
        var id = updateState()[0];
        return id;
    }
    function rerenderOpaqueIdentifier() {
        var id = rerenderState()[0];
        return id;
    }
    function dispatchAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            eagerReducer: null,
            eagerState: null,
            next: null
        }; // Append the update to the end of the list.
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        else {
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.eagerReducer = lastRenderedReducer;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) // Fast path. We can bail out without scheduling React to re-render.
                        // It's still possible that we'll need to rebase this update later,
                        // if the component re-renders for a different reason and by that
                        // time the reducer has changed.
                        return;
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ("undefined" !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        }
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useOpaqueIdentifier: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            mountHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            updateHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            updateHookTypesDev();
            return updateOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            updateHookTypesDev();
            return rerenderOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = "useOpaqueIdentifier";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var profilerStartTime = -1;
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        prepareToReadContext(workInProgress, renderLanes);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
            } finally{
                reenableLogs();
            }
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateLanes, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentName(_type));
        var currentChild = current.child; // This is always exactly one child
        if (!includesSomeLane(updateLanes, renderLanes)) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentName(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false;
                if (!includesSomeLane(renderLanes, updateLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumlated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || nextProps.mode === "unstable-defer-without-hiding") {
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Figure out what we should do in Blocking mode.
                var nextState = {
                    baseLanes: NoLanes
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                markSpawnedWork(OffscreenLane);
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes
                };
                workInProgress.memoizedState = _nextState; // We're about to bail out, but we need to push this to the stack anyway
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            var _subtreeRenderLanes;
            if (prevState !== null) {
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes); // Since we're not hidden anymore, reset the state
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    // ourselves to this constraint, though. If the behavior diverges, we should
    // fork the function.
    var updateLegacyHiddenComponent = updateOffscreenComponent;
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update; // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) // Schedule a Ref effect
        workInProgress.flags |= Ref;
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        prepareToReadContext(workInProgress, renderLanes);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
            } finally{
                reenableLogs();
            }
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentName(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            if (current !== null) {
                // A class component without an instance only mounts if it suspended
                // inside a non-concurrent tree, in an inconsistent state. We want to
                // treat it like a new mount, even though an empty version of it already
                // committed. Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            } // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress.type) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    instance.render();
                } finally{
                    reenableLogs();
                }
            }
            setIsRendering(false);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(current !== null && updateQueue !== null)) throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".
        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState(workInProgress)) {
            var mutableSourceEagerHydrationData = root.mutableSourceEagerHydrationData;
            if (mutableSourceEagerHydrationData != null) for(var i = 0; i < mutableSourceEagerHydrationData.length; i += 2){
                var mutableSource = mutableSourceEagerHydrationData[i];
                var version = mutableSourceEagerHydrationData[i + 1];
                setWorkInProgressVersion(mutableSource, version);
            }
            var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
            workInProgress.child = child;
            var node = child;
            while(node){
                // Mark each child as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                node.flags = node.flags & ~Placement | Hydrating;
                node = node.sibling;
            }
        } else {
            // Otherwise reset hydration state in case we aborted and resumed another
            // root.
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            resetHydrationState();
        }
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, updateLanes, renderLanes) {
        if (_current !== null) {
            // A lazy component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        }
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentName(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), updateLanes, renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        if (_current !== null) {
            // An incomplete component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        } // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        if (_current !== null) {
            // An indeterminate component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentName(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        setIsRendering(false);
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentName(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentName(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === "function") applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                } finally{
                    reenableLogs();
                }
            }
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || workInProgress._debugID || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentName(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentName(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes)
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallack
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else {
            // Attempting the main content
            if (current === null || current.memoizedState !== null) // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            {
                if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconcilation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // If we're currently hydrating, try to hydrate this boundary.
            // But only if this has a fallback.
            if (nextProps.fallback !== undefined) tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else if (typeof nextProps.unstable_expectedLoadTime === "number") {
                // This is a CPU-bound tree. Skip this tree and show a placeholder to
                // unblock the surrounding content. Then immediately retry after the
                // initial commit.
                var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment = workInProgress.child;
                _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER; // Since nothing actually suspended, there will nothing to ping this to
                // get it started back up to attempt the next item. While in terms of
                // priority this work has the same priority as this current render, it's
                // not part of the same transition once the transition has committed. If
                // it's sync, we still want to yield so that it can be painted.
                // Conceptually, this is really the same as pinging. We can use any
                // RetryLane even if it's the one currently rendering since we're leaving
                // it behind on this node.
                workInProgress.lanes = SomeRetryLane;
                markSpawnedWork(SomeRetryLane);
                return _fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren, renderLanes);
        } else {
            // This is an update.
            // If the current fiber has a SuspenseState, that means it's already showing
            // a fallback.
            var prevState = current.memoizedState;
            if (prevState !== null) {
                if (showFallback) {
                    var _nextFallbackChildren2 = nextProps.fallback;
                    var _nextPrimaryChildren2 = nextProps.children;
                    var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);
                    var _primaryChildFragment3 = workInProgress.child;
                    var prevOffscreenState = current.child.memoizedState;
                    _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                    _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    return _fallbackChildFragment;
                } else {
                    var _nextPrimaryChildren3 = nextProps.children;
                    var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);
                    workInProgress.memoizedState = null;
                    return _primaryChildFragment4;
                }
            } else // The current tree is not already showing a fallback.
            if (showFallback) {
                // Timed out.
                var _nextFallbackChildren3 = nextProps.fallback;
                var _nextPrimaryChildren4 = nextProps.children;
                var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);
                var _primaryChildFragment5 = workInProgress.child;
                var _prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
                _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes); // Skip the primary children, and continue working on the
                // fallback children.
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment2;
            } else {
                // Still haven't timed out. Continue rendering the children, like we
                // normally do.
                var _nextPrimaryChildren5 = nextProps.children;
                var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment6;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes, null);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function createWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & BlockingMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            currentFallbackChildFragment.nextEffect = null;
            currentFallbackChildFragment.flags = Deletion;
            workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChildFragment;
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & BlockingMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion effect during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it. So we need to remove it from the list. Deletions are stored
            // on the same list as effects. We want to keep the effects from the primary
            // tree. So we copy the primary child fragment's effect list, which does not
            // include the fallback deletion effect.
            var progressedLastEffect = primaryChildFragment.lastEffect;
            if (progressedLastEffect !== null) {
                workInProgress.firstEffect = primaryChildFragment.firstEffect;
                workInProgress.lastEffect = progressedLastEffect;
                progressedLastEffect.nextEffect = null;
            } else // TODO: Reset this somewhere else? Lol legacy mode is so weird.
            workInProgress.firstEffect = workInProgress.lastEffect = null;
        } else primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function scheduleWorkOnFiber(fiber, renderLanes) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleWorkOnParentPath(fiber.return, renderLanes);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleWorkOnFiber(node, renderLanes);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderLanes);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isArray = Array.isArray(childSlot);
        var isIterable = !isArray && typeof getIteratorFn(childSlot) === "function";
        if (isArray || isIterable) {
            var type = isArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode, workInProgress.lastEffect);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined, workInProgress.lastEffect);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);
            if (changedBits === 0) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context, newProps.unstable_observedBits);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) // The children don't have any work either. We can skip them.
        // TODO: Once we add back resuming, we should check if the children are
        // a work-in-progress set. If so, we need to transfer their effects.
        return null;
        else {
            // This fiber doesn't have work, but its subtree does. Clone the child
            // fibers and continue.
            cloneChildFibers(current, workInProgress);
            return workInProgress.child;
        }
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var last = returnFiber.lastEffect;
        if (last !== null) {
            last.nextEffect = current;
            returnFiber.lastEffect = current;
        } else returnFiber.firstEffect = returnFiber.lastEffect = current;
        current.nextEffect = null;
        current.flags = Deletion;
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function beginWork(current, workInProgress, renderLanes) {
        var updateLanes = workInProgress.lanes;
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else if (!includesSomeLane(renderLanes, updateLanes)) {
                didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
                // the begin phase. There's still some bookkeeping we that needs to be done
                // in this optimized path, mostly pushing stuff onto the stack.
                switch(workInProgress.tag){
                    case HostRoot:
                        pushHostRootContext(workInProgress);
                        resetHydrationState();
                        break;
                    case HostComponent:
                        pushHostContext(workInProgress);
                        break;
                    case ClassComponent:
                        var Component = workInProgress.type;
                        if (isContextProvider(Component)) pushContextProvider(workInProgress);
                        break;
                    case HostPortal:
                        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                        break;
                    case ContextProvider:
                        var newValue = workInProgress.memoizedProps.value;
                        pushProvider(workInProgress, newValue);
                        break;
                    case Profiler:
                        // Profiler should only call onRender when one of its descendants actually rendered.
                        var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                        if (hasChildWork) workInProgress.flags |= Update;
                         // Reset effect durations for the next eventual effect phase.
                        // These are reset during render to allow the DevTools commit hook a chance to read them,
                        var stateNode = workInProgress.stateNode;
                        stateNode.effectDuration = 0;
                        stateNode.passiveEffectDuration = 0;
                        break;
                    case SuspenseComponent:
                        var state = workInProgress.memoizedState;
                        if (state !== null) {
                            // whether to retry the primary children, or to skip over it and
                            // go straight to the fallback. Check the priority of the primary
                            // child fragment.
                            var primaryChildFragment = workInProgress.child;
                            var primaryChildLanes = primaryChildFragment.childLanes;
                            if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                            // to attempt to render the primary children again.
                            return updateSuspenseComponent(current, workInProgress, renderLanes);
                            else {
                                // The primary child fragment does not have pending work marked
                                // on it
                                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                                // priority. Bailout.
                                var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                                if (child !== null) // The fallback children have pending work. Skip over the
                                // primary children and work on the fallback.
                                return child.sibling;
                                else return null;
                            }
                        } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                        break;
                    case SuspenseListComponent:
                        var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                        var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                        if (didSuspendBefore) {
                            if (_hasChildWork) // If something was in fallback state last time, and we have all the
                            // same children then we're still in progressive loading state.
                            // Something might get unblocked by state updates or retries in the
                            // tree which will affect the tail. So we need to use the normal
                            // path to compute the correct tail.
                            return updateSuspenseListComponent(current, workInProgress, renderLanes);
                             // If none of the children had any work, that means that none of
                            // them got retried so they'll still be blocked in the same way
                            // as before. We can fast bail out.
                            workInProgress.flags |= DidCapture;
                        } // If nothing suspended before and we're rendering the same children,
                        // then the tail doesn't matter. Anything new that suspends will work
                        // in the "together" mode, so we can continue from the state we had.
                        var renderState = workInProgress.memoizedState;
                        if (renderState !== null) {
                            // Reset to the "together" mode in case we've started a different
                            // update in the past but didn't complete it.
                            renderState.rendering = null;
                            renderState.tail = null;
                            renderState.lastEffect = null;
                        }
                        pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                        if (_hasChildWork) break;
                        else // If none of the children had any work, that means that none of
                        // them got retried so they'll still be blocked in the same way
                        // as before. We can fast bail out.
                        return null;
                    case OffscreenComponent:
                    case LegacyHiddenComponent:
                        // Need to check if the tree still needs to be deferred. This is
                        // almost identical to the logic used in the normal update path,
                        // so we'll just enter that. The only difference is we'll bail out
                        // at the next level instead of this one, because the child props
                        // have not changed. Which is fine.
                        // TODO: Probably should refactor `beginWork` to split the bailout
                        // path from the normal path. I'm tempted to do a labeled break here
                        // but I won't :)
                        workInProgress.lanes = NoLanes;
                        return updateOffscreenComponent(current, workInProgress, renderLanes);
                }
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
            // See https://github.com/facebook/react/pull/19216.
            didReceiveUpdate = true;
            else // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
        } else didReceiveUpdate = false;
         // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, updateLanes, renderLanes);
            case FunctionComponent:
                var _Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentName(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateLanes, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateLanes, renderLanes);
            case IncompleteClassComponent:
                var _Component3 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case Block:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
            case LegacyHiddenComponent:
                return updateLegacyHiddenComponent(current, workInProgress, renderLanes);
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var fiberRoot = workInProgress.stateNode;
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (!fiberRoot.hydrate) // Schedule an effect to clear this container at the start of the next commit.
                    // This handles the case of React rendering into a container with previous children.
                    // It's also safe to do for updates too, because current.child would only be null
                    // if the previous render was null (so the the container would already be empty).
                    workInProgress.flags |= Snapshot;
                }
                updateHostContainer(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState;
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = false;
                if (current === null) {
                    if (workInProgress.memoizedProps.fallback !== undefined) popHydrationState(workInProgress);
                } else {
                    var prevState = current.memoizedState;
                    prevDidTimeout = prevState !== null;
                }
                if (nextDidTimeout && !prevDidTimeout) // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                {
                    if ((workInProgress.mode & BlockingMode) !== NoMode) {
                        // TODO: Move this back to throwException because this is too late
                        // if this is a large tree which is common for initial loads. We
                        // don't know if we should restart a render or not until we get
                        // this marker, and this is too late.
                        // If this render already had a ping or lower pri updates,
                        // and this is the first time we know we're going to suspend we
                        // should be able to immediately restart from within throwException.
                        var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                        if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                        // this boundary is ok.
                        renderDidSuspend();
                        else // Otherwise, we're going to have to hide content so we should
                        // suspend for longer if possible.
                        renderDidSuspendDelayIfPossible();
                    }
                }
                // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                if (nextDidTimeout || prevDidTimeout) // If this boundary just timed out, schedule an effect to attach a
                // retry listener to the promise. This flag is also used to hide the
                // primary children. In mutation mode, we also need the flag to
                // *unhide* children that were previously hidden, so check if this
                // is currently timed out, too.
                workInProgress.flags |= Update;
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                return null;
            case ContextProvider:
                // Pop provider fiber
                popProvider(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) // We're running in the default, "independent" mode.
                // We don't do anything in this mode.
                return null;
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thennables. Instead, we'll transfer its thennables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThennables = suspended.updateQueue;
                                    if (newThennables !== null) {
                                        workInProgress.updateQueue = newThennables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect list before doing the second pass since that's now invalid.
                                    if (renderState.lastEffect === null) workInProgress.firstEffect = null;
                                    workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                            markSpawnedWork(SomeRetryLane);
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThennables = _suspended.updateQueue;
                            if (_newThennables !== null) {
                                workInProgress.updateQueue = _newThennables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We need to delete the row we just rendered.
                                // Reset the effect list to what it was before we rendered this
                                // child. The nested children have already appended themselves.
                                var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.
                                if (lastEffect !== null) lastEffect.nextEffect = null;
                                 // We're done.
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                            markSpawnedWork(SomeRetryLane);
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.lastEffect = workInProgress.lastEffect;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    return next;
                }
                return null;
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case Block:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                if (current !== null) {
                    var _nextState = workInProgress.memoizedState;
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    var nextIsHidden = _nextState !== null;
                    if (prevIsHidden !== nextIsHidden && newProps.mode !== "unstable-defer-without-hiding") workInProgress.flags |= Update;
                }
                return null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if (!((_flags & DidCapture) === NoFlags)) throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                return workInProgress;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                popProvider(workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(interruptedWork) {
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                popProvider(interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentName(source.type) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            var errorBoundaryName = getComponentName(boundary.type);
            if (errorBoundaryName) errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            else errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                logCapturedError(fiber, errorInfo);
                return getDerivedStateFromError(error$1);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            if (typeof getDerivedStateFromError !== "function") {
                // To preserve the preexisting retry behavior of error boundaries,
                // we keep track of which ones already failed during this batch.
                // This gets reset before we yield back to the browser.
                // TODO: Warn in strict mode if getDerivedStateFromError is
                // not defined.
                markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined
                logCapturedError(fiber, errorInfo);
            }
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || "Unknown");
            }
        };
        else update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a listener to the promise to "ping" the root and retry. But only if
        // one does not already exist for the lanes we're currently rendering (which
        // acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            wakeable.then(ping, ping);
        }
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete; // Its effect list is no longer valid.
        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable.
            var wakeable = value;
            if ((sourceFiber.mode & BlockingMode) === NoMode) {
                // Reset the memoizedState to what it was before we attempted
                // to render it.
                var currentSource = sourceFiber.alternate;
                if (currentSource) {
                    sourceFiber.updateQueue = currentSource.updateQueue;
                    sourceFiber.memoizedState = currentSource.memoizedState;
                    sourceFiber.lanes = currentSource.lanes;
                } else {
                    sourceFiber.updateQueue = null;
                    sourceFiber.memoizedState = null;
                }
            }
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.
            var _workInProgress = returnFiber;
            do {
                if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                    // Found the nearest boundary.
                    // Stash the promise on the boundary fiber. If the boundary times out, we'll
                    // attach another listener to flip the boundary back to its normal state.
                    var wakeables = _workInProgress.updateQueue;
                    if (wakeables === null) {
                        var updateQueue = new Set();
                        updateQueue.add(wakeable);
                        _workInProgress.updateQueue = updateQueue;
                    } else wakeables.add(wakeable);
                     // If the boundary is outside of blocking mode, we should *not*
                    // suspend the commit. Pretend as if the suspended component rendered
                    // null and keep rendering. In the commit phase, we'll schedule a
                    // subsequent synchronous update to re-render the Suspense.
                    //
                    // Note: It doesn't matter whether the component that suspended was
                    // inside a blocking mode tree. If the Suspense is outside of it, we
                    // should *not* suspend the commit.
                    if ((_workInProgress.mode & BlockingMode) === NoMode) {
                        _workInProgress.flags |= DidCapture;
                        sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                        // But we shouldn't call any lifecycle methods or callbacks. Remove
                        // all lifecycle effect tags.
                        sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                        if (sourceFiber.tag === ClassComponent) {
                            var currentSourceFiber = sourceFiber.alternate;
                            if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                            // completed class component. For example, we should not call
                            // componentWillUnmount if it is deleted.
                            sourceFiber.tag = IncompleteClassComponent;
                            else {
                                // When we try rendering again, we should not reuse the current fiber,
                                // since it's known to be in an inconsistent state. Use a force update to
                                // prevent a bail out.
                                var update = createUpdate(NoTimestamp, SyncLane);
                                update.tag = ForceUpdate;
                                enqueueUpdate(sourceFiber, update);
                            }
                        } // The source fiber did not complete. Mark it with Sync priority to
                        // indicate that it still has pending work.
                        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane); // Exit without suspending.
                        return;
                    } // Confirmed that the boundary is in a concurrent mode tree. Continue
                    // with the normal suspend path.
                    //
                    // After this we'll use a set of heuristics to determine whether this
                    // render pass will run to completion or restart or "suspend" the commit.
                    // The actual logic for this is spread out in different places.
                    //
                    // This first principle is that if we're going to suspend when we complete
                    // a root, then we should also restart if we get an update or ping that
                    // might unsuspend it, and vice versa. The only reason to suspend is
                    // because you think you might want to restart before committing. However,
                    // it doesn't make sense to restart only while in the period we're suspended.
                    //
                    // Restarting too aggressively is also not good because it starves out any
                    // intermediate loading state. So we use heuristics to determine when.
                    // Suspense Heuristics
                    //
                    // If nothing threw a Promise or all the same fallbacks are already showing,
                    // then don't suspend/restart.
                    //
                    // If this is an initial render of a new tree of Suspense boundaries and
                    // those trigger a fallback, then don't suspend/restart. We want to ensure
                    // that we can show the initial loading state as quickly as possible.
                    //
                    // If we hit a "Delayed" case, such as when we'd switch from content back into
                    // a fallback, then we should always suspend/restart. Transitions apply
                    // to this case. If none is defined, JND is used instead.
                    //
                    // If we're already showing a fallback and it gets "retried", allowing us to show
                    // another level, but there's still an inner boundary that would show a fallback,
                    // then we suspend/restart for 500ms since the last time we showed a fallback
                    // anywhere in the tree. This effectively throttles progressive loading into a
                    // consistent train of commits. This also gives us an opportunity to restart to
                    // get to the completed state slightly earlier.
                    //
                    // If there's ambiguity due to batching it's resolved in preference of:
                    // 1) "delayed", 2) "initial render", 3) "retry".
                    //
                    // We want to ensure that a "busy" state doesn't get force committed. We want to
                    // ensure that new initial loading states can commit as soon as possible.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    _workInProgress.flags |= ShouldCapture;
                    _workInProgress.lanes = rootRenderLanes;
                    return;
                } // This boundary already captured during this render. Continue to the next
                // boundary.
                _workInProgress = _workInProgress.return;
            }while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
            // TODO: Use invariant so the message is stripped in prod?
            value = new Error((getComponentName(sourceFiber.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n" + "\n" + "Add a <Suspense fallback=...> component higher in the tree to " + "provide a loading indicator or placeholder to display.");
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var _update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, _update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update2 = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update2);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, instance) {
        invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
        if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current, unmountError);
        }
    }
    function safelyDetachRef(current) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                invokeGuardedCallback(null, ref, null, null);
                if (hasCaughtError()) {
                    var refError = clearCaughtError();
                    captureCommitPhaseError(current, refError);
                }
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, destroy) {
        invokeGuardedCallback(null, destroy, null);
        if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current, error);
        }
    }
    function commitBeforeMutationLifeCycles(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                return;
            case ClassComponent:
                if (finishedWork.flags & Snapshot) {
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                }
                return;
            case HostRoot:
                if (finishedWork.flags & Snapshot) {
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                }
                return;
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
                // Nothing to do for these component types
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitHookEffectListUnmount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) destroy();
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Mount
                    var create = effect.create;
                    effect.destroy = create();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("An effect function must not return anything besides a function, which is used for clean-up.%s", addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function schedulePassiveEffects(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                var _effect = effect, next = _effect.next, tag = _effect.tag;
                if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
                    enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
                    enqueuePendingPassiveHookEffectMount(finishedWork, effect);
                }
                effect = next;
            }while (effect !== firstEffect);
        }
    }
    function commitLifeCycles(finishedRoot, current, finishedWork, committedLanes) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                commitHookEffectListMount(Layout | HasEffect, finishedWork);
                schedulePassiveEffects(finishedWork);
                return;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (current === null) {
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        }
                        instance.componentDidMount();
                    } else {
                        var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                        var prevState = current.memoizedState; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        }
                        instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                return;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                return;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                return;
            case HostText:
                // We have no life-cycles associated with text.
                return;
            case HostPortal:
                // We have no life-cycles associated with portals.
                return;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, current === null ? "mount" : "update", finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime, finishedRoot.memoizedInteractions);
                return;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                return;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                var instance = node.stateNode;
                if (isHidden) hideInstance(instance);
                else unhideInstance(node.stateNode, node.memoizedProps);
            } else if (node.tag === HostText) {
                var _instance3 = node.stateNode;
                if (isHidden) hideTextInstance(_instance3);
                else unhideTextInstance(_instance3, node.memoizedProps);
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") ref(instanceToUse);
            else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentName(finishedWork.type));
                ref.current = instanceToUse;
            }
        }
    }
    function commitDetachRef(current) {
        var currentRef = current.ref;
        if (currentRef !== null) {
            if (typeof currentRef === "function") currentRef(null);
            else currentRef.current = null;
        }
    } // User-originating errors (lifecycles and refs) should not interrupt
    // deletion, so don't let them throw. Host-originating errors should
    // interrupt deletion, so it's okay
    function commitUnmount(finishedRoot, current, renderPriorityLevel) {
        onCommitUnmount(current);
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                var updateQueue = current.updateQueue;
                if (updateQueue !== null) {
                    var lastEffect = updateQueue.lastEffect;
                    if (lastEffect !== null) {
                        var firstEffect = lastEffect.next;
                        var effect = firstEffect;
                        do {
                            var _effect2 = effect, destroy = _effect2.destroy, tag = _effect2.tag;
                            if (destroy !== undefined) {
                                if ((tag & Passive$1) !== NoFlags$1) enqueuePendingPassiveHookEffectUnmount(current, effect);
                                else safelyCallDestroy(current, destroy);
                            }
                            effect = effect.next;
                        }while (effect !== firstEffect);
                    }
                }
                return;
            case ClassComponent:
                safelyDetachRef(current);
                var instance = current.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(current, instance);
                return;
            case HostComponent:
                safelyDetachRef(current);
                return;
            case HostPortal:
                unmountHostComponents(finishedRoot, current);
                return;
            case FundamentalComponent:
                return;
            case DehydratedFragment:
                return;
            case ScopeComponent:
                return;
        }
    }
    function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while(true){
            commitUnmount(finishedRoot, node); // Visit children because they may contain more composite or host nodes.
            // Skip portals because commitUnmount() currently visits them recursively.
            if (node.child !== null && // If we don't use mutation we drill down into portals here instead.
            node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === root) return;
            while(node.sibling === null){
                if (node.return === null || node.return === root) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.
        // Note: we cannot null out sibling here, otherwise it can cause issues
        // with findDOMNode and how it requires the sibling field to carry out
        // traversal in a later effect. See PR #16820. We now clear the sibling
        // field after effects, see: detachFiberAfterEffects.
        //
        // Don't disconnect stateNode now; it will be detached in detachFiberAfterEffects.
        // It may be required if the current component is an error boundary,
        // and one of its descendants throws while unmounting a passive effect.
        fiber.alternate = null;
        fiber.child = null;
        fiber.dependencies = null;
        fiber.firstEffect = null;
        fiber.lastEffect = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.return = null;
        fiber.updateQueue = null;
        fiber._debugOwner = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch(parentFiber.tag){
            case HostComponent:
                parent = parentStateNode;
                isContainer = false;
                break;
            case HostRoot:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case HostPortal:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case FundamentalComponent:
            // eslint-disable-next-line-no-fallthrough
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (parentFiber.flags & ContentReset) {
            // Reset the text content of the parent before doing any insertions
            resetTextContent(parent); // Clear ContentReset from the effect tag
            parentFiber.flags &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        if (isContainer) insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
        else insertOrAppendPlacementNode(finishedWork, before, parent);
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.
        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.
        var currentParent;
        var currentParentIsContainer;
        while(true){
            if (!currentParentIsValid) {
                var parent = node.return;
                findParent: while(true){
                    if (!(parent !== null)) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                    var parentStateNode = parent.stateNode;
                    switch(parent.tag){
                        case HostComponent:
                            currentParent = parentStateNode;
                            currentParentIsContainer = false;
                            break findParent;
                        case HostRoot:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                        case HostPortal:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                    }
                    parent = parent.return;
                }
                currentParentIsValid = true;
            }
            if (node.tag === HostComponent || node.tag === HostText) {
                commitNestedUnmounts(finishedRoot, node); // After all the children have unmounted, it is now safe to remove the
                // node from the tree.
                if (currentParentIsContainer) removeChildFromContainer(currentParent, node.stateNode);
                else removeChild(currentParent, node.stateNode);
                 // Don't visit children because we already visited them.
            } else if (node.tag === HostPortal) {
                if (node.child !== null) {
                    // When we go into a portal, it becomes the parent to remove from.
                    // We will reassign it back when we pop the portal on the way up.
                    currentParent = node.stateNode.containerInfo;
                    currentParentIsContainer = true; // Visit children because portals might contain host components.
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            } else {
                commitUnmount(finishedRoot, node); // Visit children because we may find more host components below.
                if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            }
            if (node === current) return;
            while(node.sibling === null){
                if (node.return === null || node.return === current) return;
                node = node.return;
                if (node.tag === HostPortal) // When we go out of the portal, we need to restore the parent.
                // Since we don't keep a stack of them, we will search for it.
                currentParentIsValid = false;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitDeletion(finishedRoot, current, renderPriorityLevel) {
        // Recursively delete all host nodes from the parent.
        // Detach refs and call componentWillUnmount() on the whole subtree.
        unmountHostComponents(finishedRoot, current);
        var alternate = current.alternate;
        detachFiberMutation(current);
        if (alternate !== null) detachFiberMutation(alternate);
    }
    function commitWork(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
                return;
            case ClassComponent:
                return;
            case HostComponent:
                var instance = finishedWork.stateNode;
                if (instance != null) {
                    // Commit the work prepared earlier.
                    var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldProps = current !== null ? current.memoizedProps : newProps;
                    var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                    var updatePayload = finishedWork.updateQueue;
                    finishedWork.updateQueue = null;
                    if (updatePayload !== null) commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
                return;
            case HostText:
                if (!(finishedWork.stateNode !== null)) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                var textInstance = finishedWork.stateNode;
                var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.
                var oldText = current !== null ? current.memoizedProps : newText;
                commitTextUpdate(textInstance, oldText, newText);
                return;
            case HostRoot:
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                    // We've just hydrated. No need to hydrate again.
                    _root.hydrate = false;
                    commitHydratedContainer(_root.containerInfo);
                }
                return;
            case Profiler:
                return;
            case SuspenseComponent:
                commitSuspenseComponent(finishedWork);
                attachSuspenseRetryListeners(finishedWork);
                return;
            case SuspenseListComponent:
                attachSuspenseRetryListeners(finishedWork);
                return;
            case IncompleteClassComponent:
                return;
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                var newState = finishedWork.memoizedState;
                var isHidden = newState !== null;
                hideOrUnhideAllChildren(finishedWork, isHidden);
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState !== null) {
            markCommitTimeOfFallback();
            // Hide the Offscreen component that contains the primary children. TODO:
            // Ideally, this effect would have been scheduled on the Offscreen fiber
            // itself. That's how unhiding works: the Offscreen component schedules an
            // effect on itself. However, in this case, the component didn't complete,
            // so the fiber was never added to the effect list in the normal path. We
            // could have appended it to the effect list in the Suspense component's
            // second pass, but doing it this way is less complicated. This would be
            // simpler if we got rid of the effect list and traversed the tree, like
            // we're planning to do.
            var primaryChildParent = finishedWork.child;
            hideOrUnhideAllChildren(primaryChildParent, true);
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    if (wakeable.__reactDoNotTraceInteractions !== true) retry = tracing.unstable_wrap(retry);
                    retryCache.add(wakeable);
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    // It returns false if the boundary is already hidden.
    // TODO: Use an effect tag.
    function isSuspenseBoundaryBeingHidden(current, finishedWork) {
        if (current !== null) {
            var oldState = current.memoizedState;
            if (oldState === null || oldState.dehydrated !== null) {
                var newState = finishedWork.memoizedState;
                return newState !== null && newState.dehydrated === null;
            }
        }
        return false;
    }
    function commitResetTextContent(current) {
        resetTextContent(current.stateNode);
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor$1 = Symbol.for;
        COMPONENT_TYPE = symbolFor$1("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor$1("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor$1("selector.role");
        TEST_NAME_TYPE = symbolFor$1("selector.test_id");
        TEXT_TYPE = symbolFor$1("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var EventContext = /*                 */ 2;
    var DiscreteEventContext = /*         */ 4;
    var LegacyUnbatchedContext = /*       */ 8;
    var RenderContext = /*                */ 16;
    var CommitContext = /*                */ 32;
    var RetryAfterError = /*       */ 64;
    var RootIncomplete = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootUpdatedLanes = NoLanes; // Lanes that were pinged (in an interleaved event) during this render.
    var workInProgressRootPingedLanes = NoLanes;
    var mostRecentlyUpdatedRoot = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var nextEffect = null;
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsRenderPriority = NoPriority$1;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveHookEffectsMount = [];
    var pendingPassiveHookEffectsUnmount = [];
    var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0; // Marks the need to reschedule pending interactions at these lanes
    // during the commit phase. This enables them to be traced across components
    // that spawn new work during render. E.g. hidden boundaries, suspended SSR
    // hydration or SuspenseList.
    // TODO: Can use a bitmask instead of an array
    var spawnedWorkDuringRender = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventWipLanes = NoLanes;
    var currentEventPendingLanes = NoLanes; // Dev only flag that tracks if passive effects are currently being flushed.
    // We warn about state updates for unmounted components differently in this case.
    var isFlushingPassiveEffects = false;
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return SyncLane;
        else if ((mode & ConcurrentMode) === NoMode) return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
         // The algorithm for assigning an update to a lane should be stable for all
        // updates at the same priority within the same event. To do this, the inputs
        // to the algorithm must be the same. For example, we use the `renderLanes`
        // to avoid choosing a lane that is already in the middle of rendering.
        //
        // However, the "included" lanes could be mutated in between updates in the
        // same event, like if you perform an update inside `flushSync`. Or any other
        // code path that might call `prepareFreshStack`.
        //
        // The trick we use is to cache the first of each of these inputs within an
        // event. Then reset the cached values once we can be sure the event is over.
        // Our heuristic for that is whenever we enter a concurrent work loop.
        //
        // We'll do the same for `currentEventPendingLanes` below.
        if (currentEventWipLanes === NoLanes) currentEventWipLanes = workInProgressRootIncludedLanes;
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (currentEventPendingLanes !== NoLanes) currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
            return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
        } // TODO: Remove this dependency on the Scheduler priority.
        // To do that, we're replacing it with an update lane priority.
        var schedulerPriority = getCurrentPriorityLevel(); // The old behavior was using the priority level of the Scheduler.
        // This couples React to the Scheduler internals, so we're replacing it
        // with the currentUpdateLanePriority above. As an example of how this
        // could be problematic, if we're not inside `Scheduler.runWithPriority`,
        // then we'll get the priority of the current running Scheduler task,
        // which is probably not what we want.
        var lane;
        if ((executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
        else {
            var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);
            lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
        }
        return lane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return SyncLane;
        else if ((mode & ConcurrentMode) === NoMode) return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
         // See `requestUpdateLane` for explanation of `currentEventWipLanes`
        if (currentEventWipLanes === NoLanes) currentEventWipLanes = workInProgressRootIncludedLanes;
        return findRetryLane(currentEventWipLanes);
    }
    function scheduleUpdateOnFiber(fiber, lane, eventTime) {
        checkForNestedUpdates();
        warnAboutRenderPhaseUpdatesInDEV(fiber);
        var root = markUpdateLaneFromFiberToRoot(fiber, lane);
        if (root === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return null;
        } // Mark that the root has a pending update.
        markRootUpdated(root, lane, eventTime);
        if (root === workInProgressRoot) {
            workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
            // definitely won't finish. Since we have a new update, let's mark it as
            // suspended now, right before marking the incoming update. This has the
            // effect of interrupting the current render and switching to the update.
            // TODO: Make sure this doesn't override pings that happen while we've
            // already started rendering.
            markRootSuspended$1(root, workInProgressRootRenderLanes);
        } // TODO: requestUpdateLanePriority also reads the priority. Pass the
        // priority as an argument to that function and this one.
        var priorityLevel = getCurrentPriorityLevel();
        if (lane === SyncLane) {
            if ((executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
            (executionContext & (RenderContext | CommitContext)) === NoContext) {
                // Register pending interactions on the root to avoid losing traced interaction data.
                schedulePendingInteractions(root, lane); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
                // root inside of batchedUpdates should be synchronous, but layout updates
                // should be deferred until the end of the batch.
                performSyncWorkOnRoot(root);
            } else {
                ensureRootIsScheduled(root, eventTime);
                schedulePendingInteractions(root, lane);
                if (executionContext === NoContext) {
                    // Flush the synchronous work now, unless we're already working or inside
                    // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                    // scheduleCallbackForFiber to preserve the ability to schedule a callback
                    // without immediately flushing it. We only do this for user-initiated
                    // updates, to preserve historical behavior of legacy mode.
                    resetRenderTimer();
                    flushSyncCallbackQueue();
                }
            }
        } else {
            // Schedule a discrete update but only if it's not Sync.
            if ((executionContext & DiscreteEventContext) !== NoContext && // discrete, even inside a discrete event.
            (priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
                // This is the result of a discrete event. Track the lowest priority
                // discrete update per root so we can flush them early, if needed.
                if (rootsWithPendingDiscreteUpdates === null) rootsWithPendingDiscreteUpdates = new Set([
                    root
                ]);
                else rootsWithPendingDiscreteUpdates.add(root);
            } // Schedule other updates after in case the callback is sync.
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, lane);
        } // We use this when assigning a lane for a transition inside
        // `requestUpdateLane`. We assume it's the same as the root being updated,
        // since in the common case of a single root app it probably is. If it's not
        // the same root, then it's not a huge deal, we just might batch more stuff
        // together more than necessary.
        mostRecentlyUpdatedRoot = root;
    } // This is split into a separate function so we can mark a fiber with pending
    // work without treating it as a typical update that originates from an event;
    // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
    // on a fiber.
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes); // This returns the priority level computed during the `getNextLanes` call.
        var newCallbackPriority = returnNextLanesPriority();
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) {
                cancelCallback(existingCallbackNode);
                root.callbackNode = null;
                root.callbackPriority = NoLanePriority;
            }
            return;
        } // Check if there's an existing task. We may be able to reuse it.
        if (existingCallbackNode !== null) {
            var existingCallbackPriority = root.callbackPriority;
            if (existingCallbackPriority === newCallbackPriority) // The priority hasn't changed. We can reuse the existing task. Exit.
            return;
             // The priority changed. Cancel the existing callback. We'll schedule a new
            // one below.
            cancelCallback(existingCallbackNode);
        } // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLanePriority) // Special case: Sync React callbacks are scheduled on a special
        // internal queue
        newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        else if (newCallbackPriority === SyncBatchedLanePriority) newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root));
        else {
            var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
            newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventWipLanes = NoLanes;
        currentEventPendingLanes = NoLanes;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
        var exitStatus = renderRootConcurrent(root, lanes);
        if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) // The render included lanes that were updated during the render phase.
        // For example, when unhiding a hidden tree, we include all the lanes
        // that were previously skipped when the tree was hidden. That set of
        // lanes is a superset of the lanes we started rendering with.
        //
        // So we'll throw out the current work and restart.
        prepareFreshStack(root, NoLanes);
        else if (exitStatus !== RootIncomplete) {
            if (exitStatus === RootErrored) {
                executionContext |= RetryAfterError; // If an error occurred during hydration,
                // discard server response and fall back to client side render.
                if (root.hydrate) {
                    root.hydrate = false;
                    clearContainer(root.containerInfo);
                } // If something threw an error, try rendering one more time. We'll render
                // synchronously to block concurrent data mutations, and we'll includes
                // all pending updates are included. If it still fails after the second
                // attempt, we'll give up and commit the resulting tree.
                lanes = getLanesToRetrySynchronouslyOnError(root);
                if (lanes !== NoLanes) exitStatus = renderRootSync(root, lanes);
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            } // We now have a consistent tree. The next step is either to commit it,
            // or, if something suspended, wait to commit it after a timeout.
            var finishedWork = root.current.alternate;
            root.finishedWork = finishedWork;
            root.finishedLanes = lanes;
            finishConcurrentRender(root, exitStatus, lanes);
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootIncomplete:
            case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root);
                break;
            default:
                throw Error("Unknown root exit status.");
        }
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        flushPassiveEffects();
        var lanes;
        var exitStatus;
        if (root === workInProgressRoot && includesSomeLane(root.expiredLanes, workInProgressRootRenderLanes)) {
            // There's a partial tree, and at least one of its lanes has expired. Finish
            // rendering it before rendering the rest of the expired work.
            lanes = workInProgressRootRenderLanes;
            exitStatus = renderRootSync(root, lanes);
            if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
                // The render included lanes that were updated during the render phase.
                // For example, when unhiding a hidden tree, we include all the lanes
                // that were previously skipped when the tree was hidden. That set of
                // lanes is a superset of the lanes we started rendering with.
                //
                // Note that this only happens when part of the tree is rendered
                // concurrently. If the whole tree is rendered synchronously, then there
                // are no interleaved events.
                lanes = getNextLanes(root, lanes);
                exitStatus = renderRootSync(root, lanes);
            }
        } else {
            lanes = getNextLanes(root, NoLanes);
            exitStatus = renderRootSync(root, lanes);
        }
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            executionContext |= RetryAfterError; // If an error occurred during hydration,
            // discard server response and fall back to client side render.
            if (root.hydrate) {
                root.hydrate = false;
                clearContainer(root.containerInfo);
            } // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            lanes = getLanesToRetrySynchronouslyOnError(root);
            if (lanes !== NoLanes) exitStatus = renderRootSync(root, lanes);
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        } // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushDiscreteUpdates() {
        // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
        // However, `act` uses `batchedUpdates`, so there's no way to distinguish
        // those two cases. Need to fix this before exposing flushDiscreteUpdates
        // as a public API.
        if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            if ((executionContext & RenderContext) !== NoContext) error("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
            // This is probably a nested event dispatch triggered by a lifecycle/effect,
            // like `el.focus()`. Exit.
            return;
        }
        flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
        // they fire before the next serial event.
        flushPassiveEffects();
    }
    function flushPendingDiscreteUpdates() {
        if (rootsWithPendingDiscreteUpdates !== null) {
            // For each root with pending discrete updates, schedule a callback to
            // immediately flush them.
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function(root) {
                markDiscreteUpdatesExpired(root);
                ensureRootIsScheduled(root, now());
            });
        } // Now flush the immediate queue.
        flushSyncCallbackQueue();
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function batchedEventUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= EventContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function discreteUpdates$1(fn, a, b, c, d) {
        var prevExecutionContext = executionContext;
        executionContext |= DiscreteEventContext;
        try {
            return runWithPriority$1(UserBlockingPriority$2, fn.bind(null, a, b, c, d));
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function unbatchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext &= ~BatchedContext;
        executionContext |= LegacyUnbatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function flushSync(fn, a) {
        var prevExecutionContext = executionContext;
        if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
            error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
            return fn(a);
        }
        executionContext |= BatchedContext;
        try {
            if (fn) return runWithPriority$1(ImmediatePriority$1, fn.bind(null, a));
            else return undefined;
        } finally{
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            flushSyncCallbackQueue();
        }
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                unwindInterruptedWork(interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        spawnedWorkDuringRender = null;
        ReactStrictModeWarnings.discardPendingWarnings();
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function pushInteractions(root) {
        var prevInteractions = tracing.__interactionsRef.current;
        tracing.__interactionsRef.current = root.memoizedInteractions;
        return prevInteractions;
    }
    function popInteractions(prevInteractions) {
        tracing.__interactionsRef.current = prevInteractions;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) workInProgressRootExitStatus = RootErrored;
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
        }
        var prevInteractions = pushInteractions(root);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popInteractions(prevInteractions);
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            resetRenderTimer();
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
        }
        var prevInteractions = pushInteractions(root);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popInteractions(prevInteractions);
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) return RootIncomplete;
        else {
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
                resetChildLanes(completedWork);
                if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
                (returnFiber.flags & Incomplete) === NoFlags) {
                    // Append all the effects of the subtree and this fiber onto the effect
                    // list of the parent. The completion order of the children affects the
                    // side-effect order.
                    if (returnFiber.firstEffect === null) returnFiber.firstEffect = completedWork.firstEffect;
                    if (completedWork.lastEffect !== null) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
                        returnFiber.lastEffect = completedWork.lastEffect;
                    } // If this fiber had side-effects, we append it AFTER the children's
                    // side-effects. We can perform certain side-effects earlier if needed,
                    // by doing multiple passes over the effect list. We don't want to
                    // schedule our own side-effect on our own list because if end up
                    // reusing children we'll schedule this effect onto itself since we're
                    // at the end.
                    var flags = completedWork.flags; // Skip both NoWork and PerformedWork tags when creating the effect
                    // list. PerformedWork effect is read by React DevTools but shouldn't be
                    // committed.
                    if (flags > PerformedWork) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = completedWork;
                        else returnFiber.firstEffect = completedWork;
                        returnFiber.lastEffect = completedWork;
                    }
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(completedWork); // Because this fiber did not complete, don't reset its expiration time.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its effect list.
                    returnFiber.firstEffect = returnFiber.lastEffect = null;
                    returnFiber.flags |= Incomplete;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootCompleted;
    }
    function resetChildLanes(completedWork) {
        if (// to switch statement in `completeWork`.
        (completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) // The children of this component are hidden. Don't bubble their
        // expiration times.
        return;
        var newChildLanes = NoLanes; // Bubble up the earliest expiration time.
        if ((completedWork.mode & ProfileMode) !== NoMode) {
            // In profiling mode, resetChildExpirationTime is also used to reset
            // profiler durations.
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
            // only be updated if work is done on the fiber (i.e. it doesn't bailout).
            // When work is done, it should bubble to the parent's actualDuration. If
            // the fiber has not been cloned though, (meaning no work was done), then
            // this value will reflect the amount of time spent working on a previous
            // render. In that case it should not bubble. We determine whether it was
            // cloned by comparing the child pointer.
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while(child !== null){
                newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                if (shouldBubbleActualDurations) actualDuration += child.actualDuration;
                treeBaseDuration += child.treeBaseDuration;
                child = child.sibling;
            }
            var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;
            if (isTimedOutSuspense) {
                // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                var primaryChildFragment = completedWork.child;
                if (primaryChildFragment !== null) treeBaseDuration -= primaryChildFragment.treeBaseDuration;
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
        } else {
            var _child = completedWork.child;
            while(_child !== null){
                newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                _child = _child.sibling;
            }
        }
        completedWork.childLanes = newChildLanes;
    }
    function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
    }
    function commitRootImpl(root, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        if (finishedWork === null) return null;
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (!(finishedWork !== root.current)) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes); // Clear already finished discrete updates in case that a later call of
        // `flushDiscreteUpdates` starts a useless render pass which may cancels
        // a scheduled timeout.
        if (rootsWithPendingDiscreteUpdates !== null) {
            if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root)) rootsWithPendingDiscreteUpdates.delete(root);
        }
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // Get the list of effects.
        var firstEffect;
        if (finishedWork.flags > PerformedWork) {
            // A fiber's effect list consists only of its children, not itself. So if
            // the root has an effect, we need to add it to the end of the list. The
            // resulting list is the set that would belong to the root's parent, if it
            // had one; that is, all the effects in the tree including the root.
            if (finishedWork.lastEffect !== null) {
                finishedWork.lastEffect.nextEffect = finishedWork;
                firstEffect = finishedWork.firstEffect;
            } else firstEffect = finishedWork;
        } else // There is no effect on the root.
        firstEffect = finishedWork.firstEffect;
        if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            focusedInstanceHandle = prepareForCommit(root.containerInfo);
            shouldFireAfterActiveInstanceBlur = false;
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null); // We no longer need to track the active instance fiber
            focusedInstanceHandle = null;
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            // the host tree after it's been mutated. The idiomatic use case for this is
            // layout, but class component lifecycles also fire here for legacy reasons.
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitLayoutEffects, null, root, lanes);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error2 = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error2);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
            // opportunity to paint.
            requestPaint();
            popInteractions(prevInteractions);
            executionContext = prevExecutionContext;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
            // We are done with the effect chain at this point so let's clear the
            // nextEffect pointers to assist with GC. If we have passive effects, we'll
            // clear this in flushPassiveEffects.
            nextEffect = firstEffect;
            while(nextEffect !== null){
                var nextNextEffect = nextEffect.nextEffect;
                nextEffect.nextEffect = null;
                if (nextEffect.flags & Deletion) detachFiberAfterEffects(nextEffect);
                nextEffect = nextNextEffect;
            }
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        if (remainingLanes !== NoLanes) {
            if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;
                for(var i = 0; i < expirationTimes.length; i++)scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
            }
            schedulePendingInteractions(root, remainingLanes);
        } else // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) // If there are no passive effects, then we can complete the pending interactions.
        // Otherwise, we'll wait until after the passive effects are flushed.
        // Wait to do this until after remaining work has been scheduled,
        // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
        finishPendingInteractions(root, lanes);
        if (remainingLanes === SyncLane) {
            // Count the number of times the root synchronously re-renders without
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
        // synchronously, but layout updates should be deferred until the end
        // of the batch.
        return null;
         // If layout work was scheduled, flush it now.
        flushSyncCallbackQueue();
        return null;
    }
    function commitBeforeMutationEffects() {
        while(nextEffect !== null){
            var current = nextEffect.alternate;
            if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
                if ((nextEffect.flags & Deletion) !== NoFlags) {
                    if (doesFiberContain(nextEffect, focusedInstanceHandle)) shouldFireAfterActiveInstanceBlur = true;
                } else // TODO: Move this out of the hot path using a dedicated effect tag.
                if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) shouldFireAfterActiveInstanceBlur = true;
            }
            var flags = nextEffect.flags;
            if ((flags & Snapshot) !== NoFlags) {
                setCurrentFiber(nextEffect);
                commitBeforeMutationLifeCycles(current, nextEffect);
                resetCurrentFiber();
            }
            if ((flags & Passive) !== NoFlags) // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            {
                if (!rootDoesHavePassiveEffects) {
                    rootDoesHavePassiveEffects = true;
                    scheduleCallback(NormalPriority$1, function() {
                        flushPassiveEffects();
                        return null;
                    });
                }
            }
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & ContentReset) commitResetTextContent(nextEffect);
            if (flags & Ref) {
                var current = nextEffect.alternate;
                if (current !== null) commitDetachRef(current);
            } // The following switch statement is only concerned about placement,
            // updates, and deletions. To avoid needing to add a case for every possible
            // bitmap value, we remove the secondary effects from the effect tag and
            // switch on that value.
            var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);
            switch(primaryFlags){
                case Placement:
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    // TODO: findDOMNode doesn't rely on this any more but isMounted does
                    // and isMounted is deprecated anyway so we should be able to kill this.
                    nextEffect.flags &= ~Placement;
                    break;
                case PlacementAndUpdate:
                    // Placement
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    nextEffect.flags &= ~Placement; // Update
                    var _current = nextEffect.alternate;
                    commitWork(_current, nextEffect);
                    break;
                case Hydrating:
                    nextEffect.flags &= ~Hydrating;
                    break;
                case HydratingAndUpdate:
                    nextEffect.flags &= ~Hydrating; // Update
                    var _current2 = nextEffect.alternate;
                    commitWork(_current2, nextEffect);
                    break;
                case Update:
                    var _current3 = nextEffect.alternate;
                    commitWork(_current3, nextEffect);
                    break;
                case Deletion:
                    commitDeletion(root, nextEffect);
                    break;
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitLayoutEffects(root, committedLanes) {
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & (Update | Callback)) {
                var current = nextEffect.alternate;
                commitLifeCycles(root, current, nextEffect);
            }
            if (flags & Ref) commitAttachRef(nextEffect);
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority$1;
            return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
        }
        return false;
    }
    function enqueuePendingPassiveHookEffectMount(fiber, effect) {
        pendingPassiveHookEffectsMount.push(effect, fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
        pendingPassiveHookEffectsUnmount.push(effect, fiber);
        fiber.flags |= PassiveUnmountPendingDev;
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.flags |= PassiveUnmountPendingDev;
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function invokePassiveEffectCreate(effect) {
        var create = effect.create;
        effect.destroy = create();
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsLanes = NoLanes;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root); // It's important that ALL pending passive effect destroy functions are called
        // before ANY passive effect create functions are called.
        // Otherwise effects in sibling components might interfere with each other.
        // e.g. a destroy function in one component may unintentionally override a ref
        // value set by a create function in another component.
        // Layout effects have the same constraint.
        // First pass: Destroy stale passive effects.
        var unmountEffects = pendingPassiveHookEffectsUnmount;
        pendingPassiveHookEffectsUnmount = [];
        for(var i = 0; i < unmountEffects.length; i += 2){
            var _effect = unmountEffects[i];
            var fiber = unmountEffects[i + 1];
            var destroy = _effect.destroy;
            _effect.destroy = undefined;
            fiber.flags &= ~PassiveUnmountPendingDev;
            var alternate = fiber.alternate;
            if (alternate !== null) alternate.flags &= ~PassiveUnmountPendingDev;
            if (typeof destroy === "function") {
                setCurrentFiber(fiber);
                invokeGuardedCallback(null, destroy, null);
                if (hasCaughtError()) {
                    if (!(fiber !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(fiber, error);
                }
                resetCurrentFiber();
            }
        } // Second pass: Create new passive effects.
        var mountEffects = pendingPassiveHookEffectsMount;
        pendingPassiveHookEffectsMount = [];
        for(var _i = 0; _i < mountEffects.length; _i += 2){
            var _effect2 = mountEffects[_i];
            var _fiber = mountEffects[_i + 1];
            setCurrentFiber(_fiber);
            invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
            if (hasCaughtError()) {
                if (!(_fiber !== null)) throw Error("Should be working on an effect.");
                var _error4 = clearCaughtError();
                captureCommitPhaseError(_fiber, _error4);
            }
            resetCurrentFiber();
        } // Note: This currently assumes there are no passive effects on the root fiber
        // because the root is not part of its own effect list.
        // This could change in the future.
        var effect = root.current.firstEffect;
        while(effect !== null){
            var nextNextEffect = effect.nextEffect; // Remove nextEffect pointer to assist GC
            effect.nextEffect = null;
            if (effect.flags & Deletion) detachFiberAfterEffects(effect);
            effect = nextNextEffect;
        }
        popInteractions(prevInteractions);
        finishPendingInteractions(root, lanes);
        isFlushingPassiveEffects = false;
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        enqueueUpdate(rootFiber, update);
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, SyncLane);
        }
    }
    function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
            return;
        }
        var fiber = sourceFiber.return;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValue(error, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    enqueueUpdate(fiber, update);
                    var eventTime = requestEventTime();
                    var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                        schedulePendingInteractions(root, SyncLane);
                    } else {
                        // This component has already been unmounted.
                        // We can't schedule any follow up work for the root because the fiber is already unmounted,
                        // but we can still call the log-only boundary so the error isn't swallowed.
                        //
                        // TODO This is only a temporary bandaid for the old reconciler fork.
                        // We can delete this special case once the new fork is merged.
                        if (typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) try {
                            instance.componentDidCatch(error, errorInfo);
                        } catch (errorToIgnore) {
                        // This is kind of an edge case.
                        }
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
        schedulePendingInteractions(root, pingedLanes);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryLane === NoLane) retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, retryLane);
        }
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        retryCache = boundaryFiber.stateNode;
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & (BlockingMode | ConcurrentMode))) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var didWarnStateUpdateForUnmountedComponent = null;
    function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        var tag = fiber.tag;
        if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // If there are pending passive effects unmounts for this Fiber,
        // we can assume that they would have prevented this update.
        if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || "ReactComponent";
        if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) return;
            didWarnStateUpdateForUnmountedComponent.add(componentName);
        } else didWarnStateUpdateForUnmountedComponent = new Set([
            componentName
        ]);
        if (isFlushingPassiveEffects) ;
        else {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.", tag === ClassComponent ? "the componentWillUnmount method" : "a useEffect cleanup function");
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises. Treat everything else like an error.
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
                // Rethrow this error instead of the original one.
                throw replayError;
            } else // This branch is reachable if the render phase is impure.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    } // a 'shared' variable that changes when act() opens/closes in tests.
    var IsThisRendererActing = {
        current: false
    };
    function warnIfNotScopedWithMatchingAct(fiber) {
        if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);");
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) error("An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
    }
    function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.
    var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
    // scheduler is the actual recommendation. The alternative could be a testing build,
    // a new lib, or whatever; we dunno just yet. This message is for early adopters
    // to get their tests right.
    function warnIfUnmockedScheduler(fiber) {
        if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error("In Concurrent or Sync modes, the \"scheduler\" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: \njest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\nFor more info, visit https://reactjs.org/link/mock-scheduler");
            }
        }
    }
    function computeThreadID(root, lane) {
        // Interaction threads are unique per root and expiration time.
        // NOTE: Intentionally unsound cast. All that matters is that it's a number
        // and it represents a batch of work. Could make a helper function instead,
        // but meh this is fine for now.
        return lane * 1000 + root.interactionThreadID;
    }
    function markSpawnedWork(lane) {
        if (spawnedWorkDuringRender === null) spawnedWorkDuringRender = [
            lane
        ];
        else spawnedWorkDuringRender.push(lane);
    }
    function scheduleInteractions(root, lane, interactions) {
        if (interactions.size > 0) {
            var pendingInteractionMap = root.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(lane);
            if (pendingInteractions != null) interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
                pendingInteractions.add(interaction);
            });
            else {
                pendingInteractionMap.set(lane, new Set(interactions)); // Update the pending async work count for the current interactions.
                interactions.forEach(function(interaction) {
                    interaction.__count++;
                });
            }
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, lane);
                subscriber.onWorkScheduled(interactions, threadID);
            }
        }
    }
    function schedulePendingInteractions(root, lane) {
        scheduleInteractions(root, lane, tracing.__interactionsRef.current);
    }
    function startWorkOnPendingInteractions(root, lanes) {
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.
        var interactions = new Set();
        root.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledLane) {
            if (includesSomeLane(lanes, scheduledLane)) scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
            });
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.
        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, lanes);
                try {
                    subscriber.onWorkStarted(interactions, threadID);
                } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority$1, function() {
                        throw error;
                    });
                }
            }
        }
    }
    function finishPendingInteractions(root, committedLanes) {
        var remainingLanesAfterCommit = root.pendingLanes;
        var subscriber;
        try {
            subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null && root.memoizedInteractions.size > 0) {
                // FIXME: More than one lane can finish in a single commit.
                var threadID = computeThreadID(root, committedLanes);
                subscriber.onWorkStopped(root.memoizedInteractions, threadID);
            }
        } catch (error) {
            // If the subscriber throws, rethrow it in a separate task
            scheduleCallback(ImmediatePriority$1, function() {
                throw error;
            });
        } finally{
            // Clear completed interactions from the pending Map.
            // Unless the render was suspended or cascading work was scheduled,
            // In which case– leave pending interactions until the subsequent render.
            var pendingInteractionMap = root.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, lane) {
                // Only decrement the pending interaction count if we're done.
                // If there's still work at the current priority,
                // That indicates that we are waiting for suspense data.
                if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
                    pendingInteractionMap.delete(lane);
                    scheduledInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) try {
                            subscriber.onInteractionScheduledWorkCompleted(interaction);
                        } catch (error) {
                            // If the subscriber throws, rethrow it in a separate task
                            scheduleCallback(ImmediatePriority$1, function() {
                                throw error;
                            });
                        }
                    });
                }
            });
        }
    } // `act` testing API
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return actingUpdatesScopeDepth > 0;
    }
    // so we can tell if any async act() calls try to run in parallel.
    var actingUpdatesScopeDepth = 0;
    function detachFiberAfterEffects(fiber) {
        fiber.sibling = null;
        fiber.stateNode = null;
    }
    var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    var debugCounter = 1;
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugID = debugCounter++;
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugID = current._debugID;
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effect list is no longer valid.
            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        }
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= Placement; // The effect list is no longer valid.
        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) mode = ConcurrentMode | BlockingMode | StrictMode;
        else if (tag === BlockingRoot) mode = BlockingMode | StrictMode;
        else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_DEBUG_TRACING_MODE_TYPE:
                fiberTag = Mode;
                mode |= DebugTracingMode;
                break;
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
                return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                    case REACT_BLOCK_TYPE:
                        fiberTag = Block;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentName(owner.type) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" as a prop');
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_LIST_TYPE;
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode); // TODO: The OffscreenComponent fiber shouldn't have a type. It has a tag.
        fiber.type = REACT_OFFSCREEN_TYPE;
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
        var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode); // TODO: The LegacyHidden fiber shouldn't have a type. It has a tag.
        fiber.type = REACT_LEGACY_HIDDEN_TYPE;
        fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.
        fiber.elementType = "DELETED";
        fiber.type = "DELETED";
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugID = source._debugID;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoLanePriority;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.mutableSourceEagerHydrationData = null;
        this.interactionThreadID = tracing.unstable_getThreadID();
        this.memoizedInteractions = new Set();
        this.pendingInteractionMap = new Map();
        switch(tag){
            case BlockingRoot:
                this._debugRootType = "createBlockingRoot()";
                break;
            case ConcurrentRoot:
                this._debugRootType = "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = "createLegacyRoot()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw Error("Unable to find node on an unmounted component.");
            else throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate);
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ("undefined" !== typeof jest) {
            warnIfUnmockedScheduler(current$1);
            warnIfNotScopedWithMatchingAct(current$1);
        }
        var lane = requestUpdateLane(current$1);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current.type) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        scheduleUpdateOnFiber(current$1, lane, eventTime);
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thennables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptUserBlockingHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var eventTime = requestEventTime();
        var lane = InputDiscreteHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var eventTime = requestEventTime();
        var lane = SelectiveHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function runWithPriority$2(priority, fn) {
        setCurrentUpdateLanePriority(priority);
        return fn();
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.tag === FundamentalComponent) return hostFiber.stateNode.instance;
        return hostFiber.stateNode;
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
        if (index + 1 === path.length) {
            if (Array.isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (Array.isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools
        });
    }
    function ReactDOMRoot(container, options) {
        this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
    }
    function ReactDOMBlockingRoot(container, tag, options) {
        this._internalRoot = createRootImpl(container, tag, options);
    }
    ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        var container = root.containerInfo;
        updateContainer(null, root, null, function() {
            unmarkContainerAsRoot(container);
        });
    };
    function createRootImpl(container, tag, options) {
        // Tag is either LegacyRoot or Concurrent Root
        var hydrate = options != null && options.hydrate === true;
        var hydrationCallbacks = options != null && options.hydrationOptions || null;
        var mutableSources = options != null && options.hydrationOptions != null && options.hydrationOptions.mutableSources || null;
        var root = createContainer(container, tag, hydrate);
        markContainerAsRoot(root.current, container);
        var containerNodeType = container.nodeType;
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return root;
    }
    function createLegacyRoot(container, options) {
        return new ReactDOMBlockingRoot(container, LegacyRoot, options);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    var warnedAboutHydrateAPI = false;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function shouldHydrateDueToLegacyHeuristic(container) {
        var rootElement = getReactRootElementInContainer(container);
        return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
    }
    function legacyCreateRootFromDOMContainer(container, forceHydrate) {
        var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.
        if (!shouldHydrate) {
            var warned = false;
            var rootSibling;
            while(rootSibling = container.lastChild){
                if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                    warned = true;
                    error("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.");
                }
                container.removeChild(rootSibling);
            }
        }
        if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
            warnedAboutHydrateAPI = true;
            warn("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v18. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.");
        }
        return createLegacyRoot(container, shouldHydrate ? {
            hydrate: true
        } : undefined);
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        // member of intersection type." Whyyyyyy.
        var root = container._reactRootContainer;
        var fiberRoot;
        if (!root) {
            // Initial mount
            root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
            fiberRoot = root._internalRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    originalCallback.call(instance);
                };
            } // Initial mount should not be batched.
            unbatchedUpdates(function() {
                updateContainer(children, fiberRoot, parentComponent, callback);
            });
        } else {
            fiberRoot = root._internalRoot;
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    _originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, fiberRoot, parentComponent, callback);
        }
        return getPublicRootInstance(fiberRoot);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        if (!isValidContainer(containerNode)) throw Error("Target container is not a DOM element.");
        if (!(parentComponent != null && has(parentComponent))) throw Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainer(container)) throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            unbatchedUpdates(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setAttemptHydrationAtPriority(runWithPriority$2);
    var didWarnAboutUnstableCreatePortal = false;
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    function unstable_createPortal(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!didWarnAboutUnstableCreatePortal) {
            didWarnAboutUnstableCreatePortal = true;
            warn('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 18+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.');
        }
        return createPortal$1(children, container, key);
    }
    var Internals = {
        // Keep in sync with ReactTestUtils.js, and ReactTestUtilsAct.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            flushPassiveEffects,
            IsThisRendererActing
        ]
    };
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
    exports.createPortal = createPortal$1;
    exports.findDOMNode = findDOMNode;
    exports.flushSync = flushSync;
    exports.hydrate = hydrate;
    exports.render = render;
    exports.unmountComponentAtNode = unmountComponentAtNode;
    exports.unstable_batchedUpdates = batchedUpdates$1;
    exports.unstable_createPortal = unstable_createPortal;
    exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
    exports.version = ReactVersion;
})();

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("7jGsX"));

});
parcelRegister("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $553b3f9a1c62156e$export$8352ce38b91d0c62, (v) => $553b3f9a1c62156e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $553b3f9a1c62156e$export$839f9183b0465a69, (v) => $553b3f9a1c62156e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $553b3f9a1c62156e$export$4b844e58a3e414b4, (v) => $553b3f9a1c62156e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$8352ce38b91d0c62;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$839f9183b0465a69;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$4b844e58a3e414b4;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var requestHostCallback;
    var requestHostTimeout;
    var cancelHostTimeout;
    var requestPaint;
    var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    }
    if (// implementation using setTimeout.
    typeof window === "undefined" || // Check if MessageChannel is supported, too.
    typeof MessageChannel !== "function") {
        // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
        // fallback to a naive implementation.
        var _callback = null;
        var _timeoutID = null;
        var _flushCallback = function() {
            if (_callback !== null) try {
                var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
            } catch (e) {
                setTimeout(_flushCallback, 0);
                throw e;
            }
        };
        requestHostCallback = function(cb) {
            if (_callback !== null) // Protect against re-entrancy.
            setTimeout(requestHostCallback, 0, cb);
            else {
                _callback = cb;
                setTimeout(_flushCallback, 0);
            }
        };
        requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
        };
        cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
        };
        $553b3f9a1c62156e$export$b5836b71941fa3ed = function() {
            return false;
        };
        requestPaint = $553b3f9a1c62156e$export$d66a1c1c77bd778b = function() {};
    } else {
        // Capture local references to native APIs, in case a polyfill overrides them.
        var _setTimeout = window.setTimeout;
        var _clearTimeout = window.clearTimeout;
        if (typeof console !== "undefined") {
            // TODO: Scheduler no longer requires these methods to be polyfilled. But
            // maybe we want to continue warning if they don't exist, to preserve the
            // option to rely on it in the future?
            var requestAnimationFrame = window.requestAnimationFrame;
            var cancelAnimationFrame = window.cancelAnimationFrame;
            if (typeof requestAnimationFrame !== "function") // Using console['error'] to evade Babel and ESLint
            console["error"]("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
            if (typeof cancelAnimationFrame !== "function") // Using console['error'] to evade Babel and ESLint
            console["error"]("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
        // thread, like user events. By default, it yields multiple times per frame.
        // It does not attempt to align with frame boundaries, since most tasks don't
        // need to be frame aligned; for those that do, use requestAnimationFrame.
        var yieldInterval = 5;
        var deadline = 0; // TODO: Make this configurable
        // `isInputPending` is not available. Since we have no way of knowing if
        // there's pending input, always yield at the end of the frame.
        $553b3f9a1c62156e$export$b5836b71941fa3ed = function() {
            return $553b3f9a1c62156e$export$c4744153514ff05d() >= deadline;
        }; // Since we yield every frame regardless, `requestPaint` has no effect.
        requestPaint = function() {};
        $553b3f9a1c62156e$export$d66a1c1c77bd778b = function(fps) {
            if (fps < 0 || fps > 125) {
                // Using console['error'] to evade Babel and ESLint
                console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
                return;
            }
            if (fps > 0) yieldInterval = Math.floor(1000 / fps);
            else // reset the framerate
            yieldInterval = 5;
        };
        var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
                var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
                // cycle. This means there's always time remaining at the beginning of
                // the message event.
                deadline = currentTime + yieldInterval;
                var hasTimeRemaining = true;
                try {
                    var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                    if (!hasMoreWork) {
                        isMessageLoopRunning = false;
                        scheduledHostCallback = null;
                    } else // If there's more work, schedule the next message event at the end
                    // of the preceding one.
                    port.postMessage(null);
                } catch (error) {
                    // If a scheduler task throws, exit the current browser task so the
                    // error can be observed.
                    port.postMessage(null);
                    throw error;
                }
            } else isMessageLoopRunning = false;
             // Yielding to the browser will give it a chance to paint, so we can
        };
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
                isMessageLoopRunning = true;
                port.postMessage(null);
            }
        };
        requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
                callback($553b3f9a1c62156e$export$c4744153514ff05d());
            }, ms);
        };
        cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
        };
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
    }
    function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
            var last = heap.pop();
            if (last !== first) {
                heap[0] = last;
                siftDown(heap, last, 0);
            }
            return first;
        } else return null;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(true){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (parent !== undefined && compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while(index < length){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (left !== undefined && compare(left, node) < 0) {
                if (right !== undefined && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (right !== undefined && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || $553b3f9a1c62156e$export$b5836b71941fa3ed())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = LowPriority;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = NormalPriority;
    $553b3f9a1c62156e$export$c27134553091fb3a = unstable_Profiling;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $553b3f9a1c62156e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $553b3f9a1c62156e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $553b3f9a1c62156e$export$72fdf0e06517287b = unstable_next;
    $553b3f9a1c62156e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $553b3f9a1c62156e$export$cf845f2c119da08a = unstable_wrapCallback;
})();

});


parcelRegister("eXC0v", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eVxOk"));

});
parcelRegister("eVxOk", function(module, exports) {

$parcel$export(module.exports, "__interactionsRef", () => $ade09da924dc3e35$export$236303149b061964, (v) => $ade09da924dc3e35$export$236303149b061964 = v);
$parcel$export(module.exports, "__subscriberRef", () => $ade09da924dc3e35$export$d8c36835f54f0a3b, (v) => $ade09da924dc3e35$export$d8c36835f54f0a3b = v);
$parcel$export(module.exports, "unstable_clear", () => $ade09da924dc3e35$export$4a908c8bc96de6cd, (v) => $ade09da924dc3e35$export$4a908c8bc96de6cd = v);
$parcel$export(module.exports, "unstable_getCurrent", () => $ade09da924dc3e35$export$49d8199c8144c803, (v) => $ade09da924dc3e35$export$49d8199c8144c803 = v);
$parcel$export(module.exports, "unstable_getThreadID", () => $ade09da924dc3e35$export$c7d3dd8712817dbc, (v) => $ade09da924dc3e35$export$c7d3dd8712817dbc = v);
$parcel$export(module.exports, "unstable_subscribe", () => $ade09da924dc3e35$export$932a6d6a24b633a5, (v) => $ade09da924dc3e35$export$932a6d6a24b633a5 = v);
$parcel$export(module.exports, "unstable_trace", () => $ade09da924dc3e35$export$8405cb466bd0a1f1, (v) => $ade09da924dc3e35$export$8405cb466bd0a1f1 = v);
$parcel$export(module.exports, "unstable_unsubscribe", () => $ade09da924dc3e35$export$4fd753a282912317, (v) => $ade09da924dc3e35$export$4fd753a282912317 = v);
$parcel$export(module.exports, "unstable_wrap", () => $ade09da924dc3e35$export$230d7bceee602808, (v) => $ade09da924dc3e35$export$230d7bceee602808 = v);
/** @license React v0.20.2
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Interactions "stack"–
// Meaning that newly traced interactions are appended to the previously active set.
// When an interaction goes out of scope, the previous set (if any) is restored.
var $ade09da924dc3e35$export$236303149b061964;
var $ade09da924dc3e35$export$d8c36835f54f0a3b;
var $ade09da924dc3e35$export$4a908c8bc96de6cd;
var $ade09da924dc3e35$export$49d8199c8144c803;
var $ade09da924dc3e35$export$c7d3dd8712817dbc;
var $ade09da924dc3e35$export$932a6d6a24b633a5;
var $ade09da924dc3e35$export$8405cb466bd0a1f1;
var $ade09da924dc3e35$export$4fd753a282912317;
var $ade09da924dc3e35$export$230d7bceee602808;
"use strict";
(function() {
    "use strict";
    var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.
    var interactionIDCounter = 0;
    var threadIDCounter = 0; // Set of currently traced interactions.
    $ade09da924dc3e35$export$236303149b061964 = null; // Listener(s) to notify when interactions begin and end.
    $ade09da924dc3e35$export$d8c36835f54f0a3b = null;
    $ade09da924dc3e35$export$236303149b061964 = {
        current: new Set()
    };
    $ade09da924dc3e35$export$d8c36835f54f0a3b = {
        current: null
    };
    function unstable_clear(callback) {
        var prevInteractions = $ade09da924dc3e35$export$236303149b061964.current;
        $ade09da924dc3e35$export$236303149b061964.current = new Set();
        try {
            return callback();
        } finally{
            $ade09da924dc3e35$export$236303149b061964.current = prevInteractions;
        }
    }
    function unstable_getCurrent() {
        return $ade09da924dc3e35$export$236303149b061964.current;
    }
    function unstable_getThreadID() {
        return ++threadIDCounter;
    }
    function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name: name,
            timestamp: timestamp
        };
        var prevInteractions = $ade09da924dc3e35$export$236303149b061964.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.
        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        $ade09da924dc3e35$export$236303149b061964.current = interactions;
        var subscriber = $ade09da924dc3e35$export$d8c36835f54f0a3b.current;
        var returnValue;
        try {
            if (subscriber !== null) subscriber.onInteractionTraced(interaction);
        } finally{
            try {
                if (subscriber !== null) subscriber.onWorkStarted(interactions, threadID);
            } finally{
                try {
                    returnValue = callback();
                } finally{
                    $ade09da924dc3e35$export$236303149b061964.current = prevInteractions;
                    try {
                        if (subscriber !== null) subscriber.onWorkStopped(interactions, threadID);
                    } finally{
                        interaction.__count--; // If no async work was scheduled for this interaction,
                        // Notify subscribers that it's completed.
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    }
                }
            }
        }
        return returnValue;
    }
    function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        var wrappedInteractions = $ade09da924dc3e35$export$236303149b061964.current;
        var subscriber = $ade09da924dc3e35$export$d8c36835f54f0a3b.current;
        if (subscriber !== null) subscriber.onWorkScheduled(wrappedInteractions, threadID);
         // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.
        wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
        });
        var hasRun = false;
        function wrapped() {
            var prevInteractions = $ade09da924dc3e35$export$236303149b061964.current;
            $ade09da924dc3e35$export$236303149b061964.current = wrappedInteractions;
            subscriber = $ade09da924dc3e35$export$d8c36835f54f0a3b.current;
            try {
                var returnValue;
                try {
                    if (subscriber !== null) subscriber.onWorkStarted(wrappedInteractions, threadID);
                } finally{
                    try {
                        returnValue = callback.apply(undefined, arguments);
                    } finally{
                        $ade09da924dc3e35$export$236303149b061964.current = prevInteractions;
                        if (subscriber !== null) subscriber.onWorkStopped(wrappedInteractions, threadID);
                    }
                }
                return returnValue;
            } finally{
                if (!hasRun) {
                    // We only expect a wrapped function to be executed once,
                    // But in the event that it's executed more than once–
                    // Only decrement the outstanding interaction counts once.
                    hasRun = true; // Update pending async counts for all wrapped interactions.
                    // If this was the last scheduled async work for any of them,
                    // Mark them as completed.
                    wrappedInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    });
                }
            }
        }
        wrapped.cancel = function cancel() {
            subscriber = $ade09da924dc3e35$export$d8c36835f54f0a3b.current;
            try {
                if (subscriber !== null) subscriber.onWorkCanceled(wrappedInteractions, threadID);
            } finally{
                // Update pending async counts for all wrapped interactions.
                // If this was the last scheduled async work for any of them,
                // Mark them as completed.
                wrappedInteractions.forEach(function(interaction) {
                    interaction.__count--;
                    if (subscriber && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                });
            }
        };
        return wrapped;
    }
    var subscribers = null;
    subscribers = new Set();
    function unstable_subscribe(subscriber) {
        subscribers.add(subscriber);
        if (subscribers.size === 1) $ade09da924dc3e35$export$d8c36835f54f0a3b.current = {
            onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
            onInteractionTraced: onInteractionTraced,
            onWorkCanceled: onWorkCanceled,
            onWorkScheduled: onWorkScheduled,
            onWorkStarted: onWorkStarted,
            onWorkStopped: onWorkStopped
        };
    }
    function unstable_unsubscribe(subscriber) {
        subscribers.delete(subscriber);
        if (subscribers.size === 0) $ade09da924dc3e35$export$d8c36835f54f0a3b.current = null;
    }
    function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionTraced(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkScheduled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStopped(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkCanceled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    $ade09da924dc3e35$export$4a908c8bc96de6cd = unstable_clear;
    $ade09da924dc3e35$export$49d8199c8144c803 = unstable_getCurrent;
    $ade09da924dc3e35$export$c7d3dd8712817dbc = unstable_getThreadID;
    $ade09da924dc3e35$export$932a6d6a24b633a5 = unstable_subscribe;
    $ade09da924dc3e35$export$8405cb466bd0a1f1 = unstable_trace;
    $ade09da924dc3e35$export$4fd753a282912317 = unstable_unsubscribe;
    $ade09da924dc3e35$export$230d7bceee602808 = unstable_wrap;
})();

});




parcelRegister("6ztrJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $4c8cda5d2c6d1d8b$export$1e511d4a378977f5, (v) => $4c8cda5d2c6d1d8b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039, (v) => $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 = v);
var $4c8cda5d2c6d1d8b$export$1e511d4a378977f5;
var $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$4c8cda5d2c6d1d8b$export$1e511d4a378977f5 = true;
$4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 = void 0;

var $6Pan7 = parcelRequire("6Pan7");

var $4c8cda5d2c6d1d8b$var$_react = $4c8cda5d2c6d1d8b$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jHTLJ");
var $4hUQH = parcelRequire("4hUQH");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $4fGPb = parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");

var $4c8cda5d2c6d1d8b$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $4c8cda5d2c6d1d8b$var$_Authorize = $1jnue((parcelRequire("heiVx")));

var $4c8cda5d2c6d1d8b$var$_Unauthorized = $1jnue((parcelRequire("llXHs")));

var $4c8cda5d2c6d1d8b$var$_localeToggle = $1jnue((parcelRequire("gdchy")));

var $4c8cda5d2c6d1d8b$var$_logIn = $1jnue((parcelRequire("8WGmK")));

var $4c8cda5d2c6d1d8b$var$_LoggedOut = $1jnue((parcelRequire("ahQcD")));

var $4c8cda5d2c6d1d8b$var$_markdowns = $1jnue((parcelRequire("9p6eo")));

var $4c8cda5d2c6d1d8b$var$_NavBar = $1jnue((parcelRequire("xT1Nv")));

var $4c8cda5d2c6d1d8b$var$_privateRoute = $1jnue((parcelRequire("lX5Ms")));

var $4c8cda5d2c6d1d8b$var$_profile = $1jnue((parcelRequire("6kNd6")));

var $4c8cda5d2c6d1d8b$var$_promotions = $1jnue((parcelRequire("52kTc")));

var $4c8cda5d2c6d1d8b$var$_RouteInvalid = $1jnue((parcelRequire("gMLlu")));

var $4c8cda5d2c6d1d8b$var$_stockOnHand = $1jnue((parcelRequire("3L1tV")));

var $4c8cda5d2c6d1d8b$var$_upload = $1jnue((parcelRequire("3J8Aw")));

var $7Yi7V = parcelRequire("7Yi7V");

var $bEk1s = parcelRequire("bEk1s");

var $4c8cda5d2c6d1d8b$var$_store = $4c8cda5d2c6d1d8b$var$_interopRequireWildcard((parcelRequire("jMcIG")));

var $4c8cda5d2c6d1d8b$var$_nativeBridge = $1jnue((parcelRequire("ciGEA")));

var $5enz3 = parcelRequire("5enz3");
function $4c8cda5d2c6d1d8b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($4c8cda5d2c6d1d8b$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $4c8cda5d2c6d1d8b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $4c8cda5d2c6d1d8b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// import PartnerPromotions from './components/partner-promotions-deprecated';
// eslint-disable-next-line import/named
// import { checkIsPartnerLogin } from './utils/promoteUtils';
// const isPartnerLogin = checkIsPartnerLogin();
$4c8cda5d2c6d1d8b$var$_nativeBridge.default.initialize({
    onTokenRefreshed: (token)=>{
        $4c8cda5d2c6d1d8b$var$_Auth.default.setNativeSession(token);
    },
    onUserDidChange: ()=>{
        localStorage.clear();
        // eslint-disable-next-line fp/no-mutation
        window.location.href = "/login";
    }
});
const $4c8cda5d2c6d1d8b$var$App = ()=>/*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4hUQH.default, {
        store: $4c8cda5d2c6d1d8b$var$_store.default
    }, /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$Routes, null));
const $4c8cda5d2c6d1d8b$var$Routes = ()=>{
    const dispatch = (0, $2OPjR.useDispatch)();
    // Set the markdown and promotion flags from local storage on load
    (0, $4c8cda5d2c6d1d8b$var$_react.useEffect)(()=>{
        const isAuthenticated = $4c8cda5d2c6d1d8b$var$_Auth.default.isAuthenticated();
        dispatch((0, $4c8cda5d2c6d1d8b$var$_store.setIsMarkdownEnabled)(localStorage.getItem($7Yi7V.scsKeys.createMarkdowns) === "true"));
        dispatch((0, $4c8cda5d2c6d1d8b$var$_store.setIsCreatePromotionEnabled)(localStorage.getItem($7Yi7V.scsKeys.createPromotions) === "true"));
        dispatch((0, $4c8cda5d2c6d1d8b$var$_store.setIsCsvUploadEnabled)(localStorage.getItem($7Yi7V.scsKeys.isStyleUploadEnabled) === "true"));
        dispatch((0, $4c8cda5d2c6d1d8b$var$_store.setAllowPromoteApp)(isAuthenticated ? localStorage.getItem($7Yi7V.scsKeys.allowPromoteApp) === "true" : true));
    }, [
        dispatch
    ]);
    const isMarkdownEnabled = (0, $iD0SF.useSelector)($bEk1s.getIsMarkdownEnabled);
    const isPromoteAllowEnabled = (0, $iD0SF.useSelector)($bEk1s.getAllowPromoteApp);
    const isCsvUploadEnabled = (0, $iD0SF.useSelector)($bEk1s.getIsCsvUploadEnabled) && (0, $5enz3.isBohApp)();
    return /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($6Pan7.NikeDesignSystemProvider, null, /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4fGPb.BrowserRouter, null, isPromoteAllowEnabled && /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($kfZjc.Route, {
        component: ({ location: location })=>/*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_react.default.Fragment, null, /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_NavBar.default, {
                location: location
            }), /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_localeToggle.default, {
                location: location
            }))
    }), /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement("main", {
        className: "ncss-col-sm-12 ta-sm-c p6-sm mb12-sm"
    }, /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($kfZjc.Switch, null, /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($kfZjc.Route, {
        exact: true,
        component: $4c8cda5d2c6d1d8b$var$_logIn.default,
        path: "/login"
    }), /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($kfZjc.Route, {
        exact: true,
        component: $4c8cda5d2c6d1d8b$var$_profile.default,
        path: "/profile"
    }), /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($kfZjc.Route, {
        exact: true,
        component: $4c8cda5d2c6d1d8b$var$_Authorize.default,
        path: "/auth"
    }), isPromoteAllowEnabled && /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_privateRoute.default, {
        exact: true,
        path: "/promotions*"
    }, /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_promotions.default, null)), isPromoteAllowEnabled && isCsvUploadEnabled && /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_privateRoute.default, {
        exact: true,
        path: "/upload"
    }, /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_upload.default, null)), isPromoteAllowEnabled && isMarkdownEnabled && /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_privateRoute.default, {
        exact: true,
        path: "/markdowns*"
    }, /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_markdowns.default, null)), isPromoteAllowEnabled && /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_privateRoute.default, {
        exact: true,
        path: "/stock-on-hand*"
    }, /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($4c8cda5d2c6d1d8b$var$_stockOnHand.default, null)), /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($kfZjc.Route, {
        component: $4c8cda5d2c6d1d8b$var$_LoggedOut.default,
        path: "/logged-out"
    }), /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($kfZjc.Route, {
        exact: true,
        component: $4c8cda5d2c6d1d8b$var$_Unauthorized.default,
        path: "/unauthorized"
    }), /*#__PURE__*/ $4c8cda5d2c6d1d8b$var$_react.default.createElement($kfZjc.Route, {
        component: $4c8cda5d2c6d1d8b$var$_RouteInvalid.default
    })))));
};
var $4c8cda5d2c6d1d8b$var$_default = $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 = $4c8cda5d2c6d1d8b$var$App;

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6Pan7", function(module, exports) {

$parcel$export(module.exports, "NikeDesignSystemProvider", () => $4f7f8d262cf925ca$export$d2d2ed76e9253615);

var $acw62 = parcelRequire("acw62");

var $f6z69 = parcelRequire("f6z69");

var $4B7Xs = parcelRequire("4B7Xs");
var $4f7f8d262cf925ca$var$e = undefined && undefined.__rest || function(e, t) {
    var n, r = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(n = 0, o = Object.getOwnPropertySymbols(e); n < o.length; n++)t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (r[o[n]] = e[o[n]]);
    return r;
};
var $4f7f8d262cf925ca$export$c1fd9f444a3dc711 = function() {
    return (0, $acw62.useContext)((0, $4B7Xs.DSContext)).language;
};
var $4f7f8d262cf925ca$export$d2d2ed76e9253615 = function(n) {
    var a = n.children, l = n.lang, s = n.themeExtension, c = void 0 === s ? {} : s, m = $4f7f8d262cf925ca$var$e(n, [
        "children",
        "lang",
        "themeExtension"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4B7Xs.Provider), Object.assign({
        lang: null != l ? l : "en-us",
        themeExtension: c
    }, m), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4B7Xs.DSContext).Consumer, null, function(e) {
        var n = e.tokens;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f6z69.ThemeProvider), {
            theme: Object.assign(Object.assign({}, n), c)
        }, a);
    }));
};

});
parcelRegister("f6z69", function(module, exports) {

$parcel$export(module.exports, "ThemeProvider", () => $aff2a44f48a51d46$export$d8964aec282183a3);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $f5Egd = parcelRequire("f5Egd");

var $55EI3 = parcelRequire("55EI3");

var $3p9rK = parcelRequire("3p9rK");

var $eGwU1 = parcelRequire("eGwU1");
function $aff2a44f48a51d46$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aff2a44f48a51d46$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aff2a44f48a51d46$var$ownKeys(source, true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aff2a44f48a51d46$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $aff2a44f48a51d46$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        if (mergedTheme == null || typeof mergedTheme !== "object" || Array.isArray(mergedTheme)) throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
        return mergedTheme;
    }
    if (theme == null || typeof theme !== "object" || Array.isArray(theme)) throw new Error("[ThemeProvider] Please make your theme prop a plain object");
    return $aff2a44f48a51d46$var$_objectSpread({}, outerTheme, {}, theme);
};
var $aff2a44f48a51d46$var$createCacheWithTheme = (0, $55EI3.default)(function(outerTheme) {
    return (0, $55EI3.default)(function(theme) {
        return $aff2a44f48a51d46$var$getTheme(outerTheme, theme);
    });
});
var $aff2a44f48a51d46$export$d8964aec282183a3 = function ThemeProvider(props) {
    return (0, $acw62.createElement)((0, $f5Egd.ThemeContext).Consumer, null, function(theme) {
        if (props.theme !== theme) theme = $aff2a44f48a51d46$var$createCacheWithTheme(theme)(props.theme);
        return (0, $acw62.createElement)((0, $f5Egd.ThemeContext).Provider, {
            value: theme
        }, props.children);
    });
};
// should we change this to be forwardRef/withCSSContext style so it doesn't merge with props?
function $aff2a44f48a51d46$export$e8748c6a27b910dc(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        return (0, $acw62.createElement)((0, $f5Egd.ThemeContext).Consumer, null, function(theme) {
            return (0, $acw62.createElement)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                theme: theme,
                ref: ref
            }, props));
        });
    }; // $FlowFixMe
    var WithTheme = (0, $acw62.forwardRef)(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, (/*@__PURE__*/$parcel$interopDefault($eGwU1)))(WithTheme, Component);
}
function $aff2a44f48a51d46$export$93d4e7f90805808f() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext((0, $f5Egd.ThemeContext));
}

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("f5Egd", function(module, exports) {

$parcel$export(module.exports, "ThemeContext", () => $afc68d865495bec5$export$2c657da244d00bd6);
$parcel$export(module.exports, "CacheProvider", () => $afc68d865495bec5$export$8b61c863970f2dd2);
$parcel$export(module.exports, "withEmotionCache", () => $afc68d865495bec5$export$f78961b537b140b1);
$parcel$export(module.exports, "jsx", () => $afc68d865495bec5$export$34b9dba7ce09269b);
$parcel$export(module.exports, "Global", () => $afc68d865495bec5$export$98f03c5d19621d70);
$parcel$export(module.exports, "keyframes", () => $afc68d865495bec5$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $afc68d865495bec5$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "css", () => (parcelRequire("6xSYO")).default);

var $6r4zt = parcelRequire("6r4zt");

var $acw62 = parcelRequire("acw62");

var $czXz2 = parcelRequire("czXz2");

var $boAuA = parcelRequire("boAuA");

var $cXgB3 = parcelRequire("cXgB3");

var $gGJqS = parcelRequire("gGJqS");

var $6xSYO = parcelRequire("6xSYO");
var $afc68d865495bec5$var$EmotionCacheContext = (0, $acw62.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? (0, $czXz2.default)() : null);
var $afc68d865495bec5$export$2c657da244d00bd6 = (0, $acw62.createContext)({});
var $afc68d865495bec5$export$8b61c863970f2dd2 = $afc68d865495bec5$var$EmotionCacheContext.Provider;
var $afc68d865495bec5$export$f78961b537b140b1 = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return (0, $acw62.createElement)($afc68d865495bec5$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return (0, $acw62.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $afc68d865495bec5$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $afc68d865495bec5$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $afc68d865495bec5$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $afc68d865495bec5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $afc68d865495bec5$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$afc68d865495bec5$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $boAuA.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cXgB3.serializeStyles)(registeredStyles);
    if (serialized.name.indexOf("-") === -1) {
        var labelFromStack = props[$afc68d865495bec5$var$labelPropName];
        if (labelFromStack) serialized = (0, $cXgB3.serializeStyles)([
            serialized,
            "label:" + labelFromStack + ";"
        ]);
    }
    var rules = (0, $boAuA.insertStyles)(cache, serialized, typeof type === "string");
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($afc68d865495bec5$var$hasOwnProperty.call(props, key) && key !== "css" && key !== $afc68d865495bec5$var$typePropName && key !== $afc68d865495bec5$var$labelPropName) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = (0, $acw62.createElement)(type, newProps);
    return ele;
};
var $afc68d865495bec5$var$Emotion = /* #__PURE__ */ $afc68d865495bec5$export$f78961b537b140b1(function(props, cache, ref) {
    // use Context.read for the theme when it's stable
    if (typeof props.css === "function") return (0, $acw62.createElement)($afc68d865495bec5$export$2c657da244d00bd6.Consumer, null, function(theme) {
        return $afc68d865495bec5$var$render(cache, props, theme, ref);
    });
    return $afc68d865495bec5$var$render(cache, props, null, ref);
});
$afc68d865495bec5$var$Emotion.displayName = "EmotionCssPropInternal";
var $afc68d865495bec5$export$34b9dba7ce09269b = function jsx(type, props) {
    var args = arguments;
    if (props == null || !$afc68d865495bec5$var$hasOwnProperty.call(props, "css")) // $FlowFixMe
    return (0, $acw62.createElement).apply(undefined, args);
    if (typeof props.css === "string" && // check if there is a css declaration
    props.css.indexOf(":") !== -1) throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = $afc68d865495bec5$var$Emotion;
    var newProps = {};
    for(var key in props)if ($afc68d865495bec5$var$hasOwnProperty.call(props, key)) newProps[key] = props[key];
    newProps[$afc68d865495bec5$var$typePropName] = type;
    var error = new Error();
    if (error.stack) {
        // chrome
        var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);
        if (!match) // safari and firefox
        match = error.stack.match(/^.*\n([A-Z][A-Za-z$]+)@/);
        if (match) newProps[$afc68d865495bec5$var$labelPropName] = $afc68d865495bec5$var$sanitizeIdentifier(match[1]);
    }
    createElementArgArray[1] = newProps;
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $acw62.createElement).apply(null, createElementArgArray);
};
var $afc68d865495bec5$var$warnedAboutCssPropForGlobal = false;
var $afc68d865495bec5$export$98f03c5d19621d70 = /* #__PURE__ */ $afc68d865495bec5$export$f78961b537b140b1(function(props, cache) {
    if (!$afc68d865495bec5$var$warnedAboutCssPropForGlobal && // probably using the custom createElement which
    // means it will be turned into a className prop
    // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
    (props.className || props.css)) {
        console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
        $afc68d865495bec5$var$warnedAboutCssPropForGlobal = true;
    }
    var styles = props.styles;
    if (typeof styles === "function") return (0, $acw62.createElement)($afc68d865495bec5$export$2c657da244d00bd6.Consumer, null, function(theme) {
        var serialized = (0, $cXgB3.serializeStyles)([
            styles(theme)
        ]);
        return (0, $acw62.createElement)($afc68d865495bec5$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $cXgB3.serializeStyles)([
        styles
    ]);
    return (0, $acw62.createElement)($afc68d865495bec5$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $afc68d865495bec5$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6r4zt)))(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $gGJqS.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + '="' + this.props.serialized.name + '"]');
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $boAuA.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $acw62.Component));
var $afc68d865495bec5$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $6xSYO.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $afc68d865495bec5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $afc68d865495bec5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $boAuA.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $afc68d865495bec5$export$9b9c0f9d9f3552b8 = $afc68d865495bec5$export$f78961b537b140b1(function(props, context) {
    return (0, $acw62.createElement)($afc68d865495bec5$export$2c657da244d00bd6.Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            if (hasRendered && true) throw new Error("css can only be used during render");
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $cXgB3.serializeStyles)(args, context.registered);
            (0, $boAuA.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            if (hasRendered && true) throw new Error("cx can only be used during render");
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $afc68d865495bec5$var$merge(context.registered, css, $afc68d865495bec5$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        return ele;
    });
});

});
parcelRegister("6r4zt", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $4af8cf748148995c$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $aAhot(t, o);
}
module.exports = $4af8cf748148995c$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("czXz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9286f517b9779ada$export$2e2bcd8739ae039);

var $gGJqS = parcelRequire("gGJqS");

var $demXJ = parcelRequire("demXJ");
parcelRequire("55EI3");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $9286f517b9779ada$var$delimiter = "/*|*/";
var $9286f517b9779ada$var$needle = $9286f517b9779ada$var$delimiter + "}";
function $9286f517b9779ada$var$toSheet(block) {
    if (block) $9286f517b9779ada$var$Sheet.current.insert(block + "}");
}
var $9286f517b9779ada$var$Sheet = {
    current: null
};
var $9286f517b9779ada$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $9286f517b9779ada$var$Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $9286f517b9779ada$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $9286f517b9779ada$var$Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? $9286f517b9779ada$var$delimiter : "");
            }
        case -2:
            content.split($9286f517b9779ada$var$needle).forEach($9286f517b9779ada$var$toSheet);
    }
};
var $9286f517b9779ada$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $demXJ.default)(stylisOptions);
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($9286f517b9779ada$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $9286f517b9779ada$var$Sheet.current = sheet;
        if (serialized.map !== undefined) {
            var map = serialized.map;
            $9286f517b9779ada$var$Sheet.current = {
                insert: function insert(rule) {
                    sheet.insert(rule + map);
                }
            };
        }
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function(context, content) {
        switch(context){
            case -1:
                while(commentStart.test(content)){
                    commentEnd.lastIndex = commentStart.lastIndex;
                    if (commentEnd.test(content)) {
                        commentStart.lastIndex = commentEnd.lastIndex;
                        continue;
                    }
                    throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
                }
                commentStart.lastIndex = 0;
                break;
        }
    });
    stylis.use(function(context, content, selectors) {
        switch(context){
            case -1:
                var flag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
                var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
                if (unsafePseudoClasses && cache.compat !== true) unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                    var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                    var ignore = ignoreRegExp.test(content);
                    if (unsafePseudoClass && !ignore) console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
                });
                break;
        }
    });
    var cache = {
        key: key,
        sheet: new (0, $gGJqS.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $9286f517b9779ada$export$2e2bcd8739ae039 = $9286f517b9779ada$var$createCache;

});
parcelRegister("gGJqS", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $c263cf8568d025ad$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $c263cf8568d025ad$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $c263cf8568d025ad$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var $c263cf8568d025ad$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? false : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $c263cf8568d025ad$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $c263cf8568d025ad$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {
                console.warn('There was a problem inserting the following rule: "' + rule + '"', e);
            }
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("demXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a1e650477d9d52e$export$2e2bcd8739ae039);
function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;

});

parcelRegister("55EI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b4cff6eff59c4cb$export$2e2bcd8739ae039);
var $3b4cff6eff59c4cb$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $3b4cff6eff59c4cb$export$2e2bcd8739ae039 = $3b4cff6eff59c4cb$var$weakMemoize;

});


parcelRegister("boAuA", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $84be3e3d8830d20e$export$95d99596f328fd52);
$parcel$export(module.exports, "insertStyles", () => $84be3e3d8830d20e$export$6f077d94b33a01aa);
var $84be3e3d8830d20e$var$isBrowser = true;
function $84be3e3d8830d20e$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $84be3e3d8830d20e$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $84be3e3d8830d20e$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("cXgB3", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $96e7de74f086414c$export$6321afa313b251b5);

var $gz7zU = parcelRequire("gz7zU");

var $iDSBG = parcelRequire("iDSBG");

var $l7O8P = parcelRequire("l7O8P");
var $96e7de74f086414c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $96e7de74f086414c$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $96e7de74f086414c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $96e7de74f086414c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $96e7de74f086414c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $96e7de74f086414c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $96e7de74f086414c$var$processStyleName = (0, $l7O8P.default)(function(styleName) {
    return $96e7de74f086414c$var$isCustomProperty(styleName) ? styleName : styleName.replace($96e7de74f086414c$var$hyphenateRegex, "-$&").toLowerCase();
});
var $96e7de74f086414c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($96e7de74f086414c$var$animationRegex, function(match, p1, p2) {
                $96e7de74f086414c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $96e7de74f086414c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $iDSBG.default)[key] !== 1 && !$96e7de74f086414c$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $96e7de74f086414c$var$contentValuePattern = /(attr|calc|counters?|url)\(/;
var $96e7de74f086414c$var$contentValues = [
    "normal",
    "none",
    "counter",
    "open-quote",
    "close-quote",
    "no-open-quote",
    "no-close-quote",
    "initial",
    "inherit",
    "unset"
];
var $96e7de74f086414c$var$oldProcessStyleValue = $96e7de74f086414c$var$processStyleValue;
var $96e7de74f086414c$var$msPattern = /^-ms-/;
var $96e7de74f086414c$var$hyphenPattern = /-(.)/g;
var $96e7de74f086414c$var$hyphenatedCache = {};
$96e7de74f086414c$var$processStyleValue = function processStyleValue(key, value) {
    if (key === "content") {
        if (typeof value !== "string" || $96e7de74f086414c$var$contentValues.indexOf(value) === -1 && !$96e7de74f086414c$var$contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
    }
    var processed = $96e7de74f086414c$var$oldProcessStyleValue(key, value);
    if (processed !== "" && !$96e7de74f086414c$var$isCustomProperty(key) && key.indexOf("-") !== -1 && $96e7de74f086414c$var$hyphenatedCache[key] === undefined) {
        $96e7de74f086414c$var$hyphenatedCache[key] = true;
        console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace($96e7de74f086414c$var$msPattern, "ms-").replace($96e7de74f086414c$var$hyphenPattern, function(str, _char) {
            return _char.toUpperCase();
        }) + "?");
    }
    return processed;
};
var $96e7de74f086414c$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) {
        if (interpolation.toString() === "NO_COMPONENT_SELECTOR") throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
        return interpolation;
    }
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $96e7de74f086414c$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $96e7de74f086414c$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $96e7de74f086414c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $96e7de74f086414c$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                if (interpolation.map !== undefined) styles += interpolation.map;
                return styles;
            }
            return $96e7de74f086414c$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $96e7de74f086414c$var$cursor;
                var result = interpolation(mergedProps);
                $96e7de74f086414c$var$cursor = previousCursor;
                return $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            } else console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
            break;
        case "string":
            var matched = [];
            var replaced = interpolation.replace($96e7de74f086414c$var$animationRegex, function(match, p1, p2) {
                var fakeVarName = "animation" + matched.length;
                matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
                return "${" + fakeVarName + "}";
            });
            if (matched.length) console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, [
                "`" + replaced + "`"
            ]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    if (couldBeSelectorInterpolation && $96e7de74f086414c$var$shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
        console.error("Interpolating a className from css`` is not recommended and will cause problems with composition.\nInterpolating a className from css`` will be completely unsupported in a future major version of Emotion");
        $96e7de74f086414c$var$shouldWarnAboutInterpolatingClassNameFromCss = false;
    }
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $96e7de74f086414c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($96e7de74f086414c$var$isProcessableValue(value)) string += $96e7de74f086414c$var$processStyleName(_key) + ":" + $96e7de74f086414c$var$processStyleValue(_key, value) + ";";
        } else {
            if (_key === "NO_COMPONENT_SELECTOR" && true) throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
            if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($96e7de74f086414c$var$isProcessableValue(value[_i])) string += $96e7de74f086414c$var$processStyleName(_key) + ":" + $96e7de74f086414c$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case "animation":
                    case "animationName":
                        string += $96e7de74f086414c$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        if (_key === "undefined") console.error($96e7de74f086414c$var$UNDEFINED_AS_OBJECT_KEY_ERROR);
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $96e7de74f086414c$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $96e7de74f086414c$var$sourceMapPattern;
$96e7de74f086414c$var$sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
// keyframes are stored on the SerializedStyles object as a linked list
var $96e7de74f086414c$var$cursor;
var $96e7de74f086414c$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $96e7de74f086414c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, strings, false);
    } else {
        if (strings[0] === undefined) console.error($96e7de74f086414c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        styles += strings[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) {
            if (strings[i] === undefined) console.error($96e7de74f086414c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR);
            styles += strings[i];
        }
    }
    var sourceMap;
    styles = styles.replace($96e7de74f086414c$var$sourceMapPattern, function(match) {
        sourceMap = match;
        return "";
    });
    $96e7de74f086414c$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $96e7de74f086414c$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $gz7zU.default)(styles) + identifierName;
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
        name: name,
        styles: styles,
        map: sourceMap,
        next: $96e7de74f086414c$var$cursor,
        toString: function toString() {
            return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
    };
};

});
parcelRegister("gz7zU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f5cb12993018cc$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $c0f5cb12993018cc$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $c0f5cb12993018cc$export$2e2bcd8739ae039 = $c0f5cb12993018cc$var$murmur2;

});

parcelRegister("iDSBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9263a4c6739b952$export$2e2bcd8739ae039);
var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;

});

parcelRegister("l7O8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6112573aba91cb3$export$2e2bcd8739ae039);
function $f6112573aba91cb3$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $f6112573aba91cb3$export$2e2bcd8739ae039 = $f6112573aba91cb3$var$memoize;

});


parcelRegister("6xSYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c4078fc8d62d9b6$export$2e2bcd8739ae039);

var $cXgB3 = parcelRequire("cXgB3");
function $4c4078fc8d62d9b6$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cXgB3.serializeStyles)(args);
}
var $4c4078fc8d62d9b6$export$2e2bcd8739ae039 = $4c4078fc8d62d9b6$var$css;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eGwU1", function(module, exports) {
"use strict";

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $ab0e82af9edfd0f1$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $ab0e82af9edfd0f1$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $ab0e82af9edfd0f1$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $ab0e82af9edfd0f1$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $ab0e82af9edfd0f1$var$TYPE_STATICS = {};
$ab0e82af9edfd0f1$var$TYPE_STATICS[$4jPKB.ForwardRef] = $ab0e82af9edfd0f1$var$FORWARD_REF_STATICS;
$ab0e82af9edfd0f1$var$TYPE_STATICS[$4jPKB.Memo] = $ab0e82af9edfd0f1$var$MEMO_STATICS;
function $ab0e82af9edfd0f1$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $ab0e82af9edfd0f1$var$MEMO_STATICS;
     // React v16.12 and above
    return $ab0e82af9edfd0f1$var$TYPE_STATICS[component["$$typeof"]] || $ab0e82af9edfd0f1$var$REACT_STATICS;
}
var $ab0e82af9edfd0f1$var$defineProperty = Object.defineProperty;
var $ab0e82af9edfd0f1$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $ab0e82af9edfd0f1$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ab0e82af9edfd0f1$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ab0e82af9edfd0f1$var$getPrototypeOf = Object.getPrototypeOf;
var $ab0e82af9edfd0f1$var$objectPrototype = Object.prototype;
function $ab0e82af9edfd0f1$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($ab0e82af9edfd0f1$var$objectPrototype) {
            var inheritedComponent = $ab0e82af9edfd0f1$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $ab0e82af9edfd0f1$var$objectPrototype) $ab0e82af9edfd0f1$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $ab0e82af9edfd0f1$var$getOwnPropertyNames(sourceComponent);
        if ($ab0e82af9edfd0f1$var$getOwnPropertySymbols) keys = keys.concat($ab0e82af9edfd0f1$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $ab0e82af9edfd0f1$var$getStatics(targetComponent);
        var sourceStatics = $ab0e82af9edfd0f1$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$ab0e82af9edfd0f1$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $ab0e82af9edfd0f1$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $ab0e82af9edfd0f1$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $ab0e82af9edfd0f1$var$hoistNonReactStatics;

});
parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hkVY4"));

});
parcelRegister("hkVY4", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $c9f145267881427c$export$2b8d127b894957b9, (v) => $c9f145267881427c$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $c9f145267881427c$export$cea3a54a6425200c, (v) => $c9f145267881427c$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $c9f145267881427c$export$a7c73072b1a182ae, (v) => $c9f145267881427c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $c9f145267881427c$export$9f27bc3417b4524d, (v) => $c9f145267881427c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $c9f145267881427c$export$db77ccec0bb4ccac, (v) => $c9f145267881427c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $c9f145267881427c$export$8392c0c9d3dcbd35, (v) => $c9f145267881427c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $c9f145267881427c$export$ffb0004e005737fa, (v) => $c9f145267881427c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $c9f145267881427c$export$b624eff549462981, (v) => $c9f145267881427c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $c9f145267881427c$export$7897aa7841a5380c, (v) => $c9f145267881427c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $c9f145267881427c$export$602eac185826482c, (v) => $c9f145267881427c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $c9f145267881427c$export$e2c29f18771995cb, (v) => $c9f145267881427c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $c9f145267881427c$export$5f8d39834fd61797, (v) => $c9f145267881427c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $c9f145267881427c$export$74bf444e3cd11ea5, (v) => $c9f145267881427c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $c9f145267881427c$export$92387174baf9b227, (v) => $c9f145267881427c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $c9f145267881427c$export$ec112efeb987d9c6, (v) => $c9f145267881427c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $c9f145267881427c$export$b706b080d889d2c9, (v) => $c9f145267881427c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $c9f145267881427c$export$5be5a87408f70ddc, (v) => $c9f145267881427c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $c9f145267881427c$export$45a5e7f76e0caa8d, (v) => $c9f145267881427c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $c9f145267881427c$export$455c2e768291efa6, (v) => $c9f145267881427c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $c9f145267881427c$export$9522e17588c12572, (v) => $c9f145267881427c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $c9f145267881427c$export$2110ac352bb060b9, (v) => $c9f145267881427c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $c9f145267881427c$export$56885ab8b9c456ab, (v) => $c9f145267881427c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $c9f145267881427c$export$d927fcb6adf8f9de, (v) => $c9f145267881427c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $c9f145267881427c$export$b82d16f27459e05a, (v) => $c9f145267881427c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $c9f145267881427c$export$522c17b4f5e123e8, (v) => $c9f145267881427c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $c9f145267881427c$export$1aabd8a0274ecfd6, (v) => $c9f145267881427c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $c9f145267881427c$export$9b621391a187a31a, (v) => $c9f145267881427c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $c9f145267881427c$export$f5bbd400c2f4426f, (v) => $c9f145267881427c$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9f145267881427c$export$2b8d127b894957b9;
var $c9f145267881427c$export$cea3a54a6425200c;
var $c9f145267881427c$export$a7c73072b1a182ae;
var $c9f145267881427c$export$9f27bc3417b4524d;
var $c9f145267881427c$export$db77ccec0bb4ccac;
var $c9f145267881427c$export$8392c0c9d3dcbd35;
var $c9f145267881427c$export$ffb0004e005737fa;
var $c9f145267881427c$export$b624eff549462981;
var $c9f145267881427c$export$7897aa7841a5380c;
var $c9f145267881427c$export$602eac185826482c;
var $c9f145267881427c$export$e2c29f18771995cb;
var $c9f145267881427c$export$5f8d39834fd61797;
var $c9f145267881427c$export$74bf444e3cd11ea5;
var $c9f145267881427c$export$92387174baf9b227;
var $c9f145267881427c$export$ec112efeb987d9c6;
var $c9f145267881427c$export$b706b080d889d2c9;
var $c9f145267881427c$export$5be5a87408f70ddc;
var $c9f145267881427c$export$45a5e7f76e0caa8d;
var $c9f145267881427c$export$455c2e768291efa6;
var $c9f145267881427c$export$9522e17588c12572;
var $c9f145267881427c$export$2110ac352bb060b9;
var $c9f145267881427c$export$56885ab8b9c456ab;
var $c9f145267881427c$export$d927fcb6adf8f9de;
var $c9f145267881427c$export$b82d16f27459e05a;
var $c9f145267881427c$export$522c17b4f5e123e8;
var $c9f145267881427c$export$1aabd8a0274ecfd6;
var $c9f145267881427c$export$9b621391a187a31a;
var $c9f145267881427c$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $c9f145267881427c$export$2b8d127b894957b9 = AsyncMode;
    $c9f145267881427c$export$cea3a54a6425200c = ConcurrentMode;
    $c9f145267881427c$export$a7c73072b1a182ae = ContextConsumer;
    $c9f145267881427c$export$9f27bc3417b4524d = ContextProvider;
    $c9f145267881427c$export$db77ccec0bb4ccac = Element;
    $c9f145267881427c$export$8392c0c9d3dcbd35 = ForwardRef;
    $c9f145267881427c$export$ffb0004e005737fa = Fragment;
    $c9f145267881427c$export$b624eff549462981 = Lazy;
    $c9f145267881427c$export$7897aa7841a5380c = Memo;
    $c9f145267881427c$export$602eac185826482c = Portal;
    $c9f145267881427c$export$e2c29f18771995cb = Profiler;
    $c9f145267881427c$export$5f8d39834fd61797 = StrictMode;
    $c9f145267881427c$export$74bf444e3cd11ea5 = Suspense;
    $c9f145267881427c$export$92387174baf9b227 = isAsyncMode;
    $c9f145267881427c$export$ec112efeb987d9c6 = isConcurrentMode;
    $c9f145267881427c$export$b706b080d889d2c9 = isContextConsumer;
    $c9f145267881427c$export$5be5a87408f70ddc = isContextProvider;
    $c9f145267881427c$export$45a5e7f76e0caa8d = isElement;
    $c9f145267881427c$export$455c2e768291efa6 = isForwardRef;
    $c9f145267881427c$export$9522e17588c12572 = isFragment;
    $c9f145267881427c$export$2110ac352bb060b9 = isLazy;
    $c9f145267881427c$export$56885ab8b9c456ab = isMemo;
    $c9f145267881427c$export$d927fcb6adf8f9de = isPortal;
    $c9f145267881427c$export$b82d16f27459e05a = isProfiler;
    $c9f145267881427c$export$522c17b4f5e123e8 = isStrictMode;
    $c9f145267881427c$export$1aabd8a0274ecfd6 = isSuspense;
    $c9f145267881427c$export$9b621391a187a31a = isValidElementType;
    $c9f145267881427c$export$f5bbd400c2f4426f = typeOf;
})();

});




parcelRegister("4B7Xs", function(module, exports) {

$parcel$export(module.exports, "DSContext", () => $3590ca6df5e0d9ac$export$f4702fd175936998);
$parcel$export(module.exports, "Provider", () => $3590ca6df5e0d9ac$export$2881499e37b75b9a);

var $acw62 = parcelRequire("acw62");

var $cx76g = parcelRequire("cx76g");
var $3590ca6df5e0d9ac$var$e = undefined && undefined.__rest || function(e, t) {
    var n, r = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (r[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(n = 0, o = Object.getOwnPropertySymbols(e); n < o.length; n++)t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (r[o[n]] = e[o[n]]);
    return r;
};
var $3590ca6df5e0d9ac$export$f4702fd175936998 = (0, $acw62.createContext)({});
var $3590ca6df5e0d9ac$export$53ac33307b5acee9 = function(t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (0, $cx76g.nike), r = n.i18nTokens, i = $3590ca6df5e0d9ac$var$e(n, [
        "i18nTokens"
    ]), a = {};
    return r && (a = n.i18nTokens[t] || n.i18nTokens["en-us"]), Object.assign(Object.assign({}, a), i);
};
var $3590ca6df5e0d9ac$export$2881499e37b75b9a = function(n) {
    var o = n.children, i = n.lang, a = n.themeExtension, s = $3590ca6df5e0d9ac$var$e(n, [
        "children",
        "lang",
        "themeExtension"
    ]);
    return (0, $acw62.useMemo)(function() {
        var e = $3590ca6df5e0d9ac$export$53ac33307b5acee9(i), n = Object.assign(Object.assign({}, e), a);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3590ca6df5e0d9ac$export$f4702fd175936998.Provider, {
            value: Object.assign({
                tokens: n,
                language: i
            }, s)
        }, o);
    }, [
        i,
        o,
        a,
        s
    ]);
};

});
parcelRegister("cx76g", function(module, exports) {

$parcel$export(module.exports, "nike", () => $91fe13020e3eab9d$export$31ff9f59ae0ca7af);
const $91fe13020e3eab9d$export$31ff9f59ae0ca7af = {
    /**
   * Do not edit directly
   * Generated on Tue, 04 May 2021 18:08:54 GMT
   */ colorContentPrimary: "#111111",
    colorContentPrimaryInverse: "#ffffff",
    colorContentSecondary: "#757575",
    colorContentSecondaryInverse: "#cccccc",
    colorContentFocus: "#111111",
    colorContentActive: "#111111",
    colorContentDisabled: "#cccccc",
    colorContentError: "#d43f21",
    colorContentSuccess: "#128a09",
    colorBackgroundPrimary: "#ffffff",
    colorBackgroundAlwaysDark: "#111111",
    colorBackgroundAlwaysLight: "#ffffff",
    colorBorderBase: "#cccccc",
    colorBorderFocus: "#111111",
    colorBorderActive: "#111111",
    colorBorderDisabled: "#e5e5e5",
    colorBorderError: "#d43f21",
    colorFocusRing: "#f5f5f5",
    buttonBorderRadius: "30px",
    buttonBorderWidth: "1.5px",
    buttonBoxShadowWidth: "0",
    buttonBoxShadowHoverWidth: "0",
    buttonPaddingTopS: "4.5px",
    buttonPaddingTopM: "10.5px",
    buttonPaddingTopL: "16.5px",
    buttonPaddingBottomS: "4.5px",
    buttonPaddingBottomM: "10.5px",
    buttonPaddingBottomL: "16.5px",
    buttonPaddingSidesS: "18.5px",
    buttonPaddingSidesM: "22.5px",
    buttonPaddingSidesL: "22.5px",
    buttonPaddingUnderline: "0",
    buttonHeightS: "36px",
    buttonHeightM: "48px",
    buttonHeightL: "60px",
    buttonColorHover: "#757575",
    buttonColorHoverInverse: "#b2b2b2",
    dialogBackgroundBlur: "4px",
    elevation10: "10",
    elevation20: "20",
    elevation30: "30",
    elevation40: "40",
    elevation50: "50",
    elevation60: "60",
    elevation70: "70",
    elevation80: "80",
    elevation90: "90",
    elevation100: "100",
    fontWeightRegular: "400",
    fontWeightMedium: "500",
    fontWeightBold: "700",
    fontSizeXxs: "12px",
    fontSizeXs: "14px",
    fontSizeS: "16px",
    fontSizeM: "20px",
    fontSizeL: "24px",
    fontSizeXl: "28px",
    fontSizeXxl: "32px",
    fontSizeXxxl: "40px",
    fontSizeXxxxl: "48px",
    fontSizeXxxxxl: "72px",
    fontStyleNormal: "normal",
    paletteBlack: "#111111",
    paletteGrey1: "#757575",
    paletteGrey2: "#cccccc",
    paletteGrey3: "#e5e5e5",
    paletteGrey4: "#f5f5f5",
    paletteGrey5: "#fafafa",
    paletteWhite: "#ffffff",
    paletteError: "#d43f21",
    paletteSuccess: "#128a09",
    sizeSpacingXs: "4px",
    sizeSpacingS: "8px",
    sizeSpacingM: "12px",
    sizeSpacingL: "24px",
    sizeSpacingXl: "36px",
    sizeSpacingXxl: "60px",
    sizeSpacingXxxl: "84px",
    sizeSpacingXxxxl: "120px",
    sizeSpacingGridGutter: "16px",
    sizeSpacingGridGutterL: "12px",
    sizeSpacingGridExteriorGutterS: "24px",
    sizeSpacingGridExteriorGutterL: "48px",
    sizeBorderRadiusS: "4px",
    sizeBorderRadiusM: "8px",
    sizeBorderRadiusL: "12px",
    sizeBorderRadiusXl: "24px",
    sizeBorderWidthS: "1px",
    sizeBorderWidthM: "1.5px",
    sizeBorderWidthL: "2px",
    sizeIconS: "16px",
    sizeIconM: "24px",
    sizeIconL: "48px",
    sizeFormInputContainerHeight: "84px",
    sizeFormInputFieldHeight: "56px",
    transitionTimingFunctionEase: "cubic-bezier(.25, .1, .25, 1)",
    transitionDurationFast: "150ms",
    transitionDurationNormal: "250ms",
    breakpointXs: "320px",
    breakpointS: "600px",
    breakpointM: "960px",
    breakpointL: "1440px",
    breakpointXl: "1920px",
    formShadowFocus: "0 0 0 12px #f5f5f5",
    i18nTokens: {
        globalFallback: {
            typographyBody1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "72px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "48px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "44px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "40px",
            fontHeightXl: "40px",
            fontHeightXxl: "44px",
            fontHeightXxxl: "48px",
            fontHeightXxxxl: "72px",
            fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
        },
        get "ca-es" () {
            return this.globalFallback;
        },
        get "cs-cz" () {
            return this.globalFallback;
        },
        get "da-dk" () {
            return this.globalFallback;
        },
        get "de-de" () {
            return this.globalFallback;
        },
        "el-gr": {
            typographyBody1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "60px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "34px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "36px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "32px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "32px",
            fontHeightXl: "34px",
            fontHeightXxl: "36px",
            fontHeightXxxl: "40px",
            fontHeightXxxxl: "60px",
            fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
        },
        get "en-ca" () {
            return this["en-us"];
        },
        get "en-gb" () {
            return this["en-us"];
        },
        "en-us": {
            typographyBody1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "60px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "34px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "36px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "32px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "32px",
            fontHeightXl: "34px",
            fontHeightXxl: "36px",
            fontHeightXxxl: "40px",
            fontHeightXxxxl: "60px",
            fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
        },
        get "es-ar" () {
            return this.globalFallback;
        },
        get "es-ca" () {
            return this.globalFallback;
        },
        get "es-cl" () {
            return this.globalFallback;
        },
        get "es-es" () {
            return this.globalFallback;
        },
        get "es-la" () {
            return this.globalFallback;
        },
        get "es-mx" () {
            return this.globalFallback;
        },
        get "es-uy" () {
            return this.globalFallback;
        },
        get "fr-fr" () {
            return this.globalFallback;
        },
        get "hu-hu" () {
            return this.globalFallback;
        },
        get "it-it" () {
            return this.globalFallback;
        },
        "jp-jp": {
            typographyBody1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "72px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "48px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "44px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "40px",
            fontHeightXl: "40px",
            fontHeightXxl: "44px",
            fontHeightXxxl: "48px",
            fontHeightXxxxl: "72px",
            fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, "\u30E1\u30A4\u30EA\u30AA", Meiryo, "Hiragino Kaku Gothic Pro", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "MS PGothic", sans-serif',
            fontFamilyBrand: '"Nike TG", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyMarketing: '"Nike Futura", Meiryo, "\u30E1\u30A4\u30EA\u30AA", "MS Pgothic", "\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF", "Hiragino Kaku Gothic Pro", "\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4", "Helvetica Neue", Helvetica, Arial, sans-serif'
        },
        "ko-kr": {
            typographyBody1: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "72px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "48px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "44px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "40px",
            fontHeightXl: "40px",
            fontHeightXxl: "44px",
            fontHeightXxxl: "48px",
            fontHeightXxxxl: "72px",
            fontFamilyBase: '"Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
            fontFamilyBrand: '"Nike TG", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif',
            fontFamilyMarketing: '"Nike Futura", FBHanGothicDB, "Arial Bold", "Helvetica Neue", Helvetica, Arial, Dotum, "\uAD6D\uC5B4", Gulim, sans-serif'
        },
        get "nl-en" () {
            return this.globalFallback;
        },
        get "nl-nl" () {
            return this.globalFallback;
        },
        get "no-no" () {
            return this.globalFallback;
        },
        "pl-pl": {
            typographyBody1: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "72px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "48px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "44px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "40px",
            fontHeightXl: "40px",
            fontHeightXxl: "44px",
            fontHeightXxxl: "48px",
            fontHeightXxxxl: "72px",
            fontFamilyBase: '"Helvetica W02 Roman", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
        },
        get "pt-br" () {
            return this.globalFallback;
        },
        get "pt-pt" () {
            return this.globalFallback;
        },
        "ru-ru": {
            typographyBody1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "72px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "48px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "44px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "40px",
            fontHeightXl: "40px",
            fontHeightXxl: "44px",
            fontHeightXxxl: "48px",
            fontHeightXxxxl: "72px",
            fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, sans-serif'
        },
        get "sv-se" () {
            return this.globalFallback;
        },
        "th-th": {
            typographyBody1: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "72px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "48px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "44px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "40px",
            fontHeightXl: "40px",
            fontHeightXxl: "44px",
            fontHeightXxxl: "48px",
            fontHeightXxxxl: "72px",
            fontFamilyBase: '"Helvetica Neue W31", "Helvetica Neue", Helvetica, Arial, sans-serif',
            fontFamilyBrand: '"Nike TG", "Helvetica Neue W31", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif',
            fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, "Arial Bold", Arial, Tahoma, Thonburi, Ayuthaya, sans-serif'
        },
        get "tr-tr" () {
            return this.globalFallback;
        },
        "zh-cn": {
            typographyBody1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "72px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "48px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "44px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "40px",
            fontHeightXl: "40px",
            fontHeightXxl: "44px",
            fontHeightXxxl: "48px",
            fontHeightXxxxl: "72px",
            fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
            fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
            fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif'
        },
        "zh-tw": {
            typographyBody1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyBody4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "14px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyCta2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay1: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "72px",
                fontWeight: "700",
                lineHeight: "72px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay2: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "48px",
                fontWeight: "700",
                lineHeight: "48px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyDisplay3: {
                fontFamily: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "40px",
                fontWeight: "700",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading1: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "32px",
                fontWeight: "500",
                lineHeight: "44px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading2: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "28px",
                fontWeight: "500",
                lineHeight: "40px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading3: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "24px",
                fontWeight: "500",
                lineHeight: "28px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading4: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "20px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            typographyHeading5: {
                fontFamily: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
                fontSize: "16px",
                fontWeight: "500",
                lineHeight: "24px",
                fontStyle: "normal",
                textTransform: "none"
            },
            fontHeightXxs: "14px",
            fontHeightXs: "20px",
            fontHeightS: "24px",
            fontHeightM: "28px",
            fontHeightL: "40px",
            fontHeightXl: "40px",
            fontHeightXxl: "44px",
            fontHeightXxxl: "48px",
            fontHeightXxxxl: "72px",
            fontFamilyBase: '"Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
            fontFamilyBrand: '"Nike TG", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif',
            fontFamilyMarketing: '"Nike Futura", "Helvetica Neue", Helvetica, Arial, "PingFang", "Microsoft YaHei", "\u96C5\u9ED1\u4F53", SimHei, sans-serif'
        }
    }
};

});



parcelRegister("jHTLJ", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("hrvfy")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);
parcelRequire("gCPmi");
parcelRequire("7c7i6");
var $1u0KT = parcelRequire("1u0KT");

var $lnBci = parcelRequire("lnBci");
// with standard React renderers (ReactDOM, React Native)
(0, $lnBci.setBatch)((0, $1u0KT.unstable_batchedUpdates));

});
parcelRegister("gCPmi", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("4hUQH")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("hrvfy")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("2OPjR")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("iD0SF")).useSelector);

var $4hUQH = parcelRequire("4hUQH");

var $2g8Bt = parcelRequire("2g8Bt");

var $7iEsg = parcelRequire("7iEsg");

var $hrvfy = parcelRequire("hrvfy");

var $2OPjR = parcelRequire("2OPjR");

var $iD0SF = parcelRequire("iD0SF");

var $4TSkt = parcelRequire("4TSkt");

var $8PZ7r = parcelRequire("8PZ7r");

});
parcelRegister("4hUQH", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f4d8f6ffbbb628$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7iEsg = parcelRequire("7iEsg");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");
function $31f4d8f6ffbbb628$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $acw62.useMemo)(function() {
        var subscription = (0, $j4jJy.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $acw62.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $7iEsg.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
$31f4d8f6ffbbb628$var$Provider.propTypes = {
    store: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        dispatch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        getState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
    }),
    context: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $31f4d8f6ffbbb628$export$2e2bcd8739ae039 = $31f4d8f6ffbbb628$var$Provider;

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4jPKB = parcelRequire("4jPKB");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $8da5bfbbed271cd7$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("eGxWZ"))($4jPKB.isElement, $8da5bfbbed271cd7$var$throwOnDirectAccess);

});
parcelRegister("eGxWZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $4jPKB = parcelRequire("4jPKB");

var $8coUR = parcelRequire("8coUR");

var $kZO5c = parcelRequire("kZO5c");

var $fQsEq = parcelRequire("fQsEq");

var $gwROR = parcelRequire("gwROR");
var $ab0f52c9db6f842e$var$printWarning = function() {};
$ab0f52c9db6f842e$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator"; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = "<<anonymous>>";
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $kZO5c) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = "Invariant Violation";
                    throw err;
                } else if (typeof console !== "undefined") {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ":" + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $ab0f52c9db6f842e$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated " + "and will throw in the standalone `prop-types` package. " + "You may be seeing this warning due to a third-party PropTypes " + "library. See https://fb.me/react-warning-dont-call-proptypes " + "for details.");
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
                    return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$4jPKB.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $ab0f52c9db6f842e$var$printWarning("Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. " + "A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).");
                else $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === "symbol") return String(value);
                return value;
            });
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== "function") return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
            for(var key in propValue)if ($fQsEq(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType, expected an instance of array.");
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== "function") {
                $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + ".");
                return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $kZO5c);
                if (checkerResult == null) return null;
                if (checkerResult.data && $fQsEq(checkerResult.data, "expectedType")) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + type + "`.");
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== "object") return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $8coUR({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($fQsEq(shapeTypes, key) && typeof checker !== "function") return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`." + "\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                var error = checker(propValue, key, componentName, location, propFullName + "." + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case "number":
            case "string":
            case "undefined":
                return true;
            case "boolean":
                return !propValue;
            case "object":
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === "symbol") return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue["@@toStringTag"] === "Symbol") return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return "array";
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return "object";
        if (isSymbol(propType, propValue)) return "symbol";
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) return "" + propValue;
        var propType = getPropType(propValue);
        if (propType === "object") {
            if (propValue instanceof Date) return "date";
            else if (propValue instanceof RegExp) return "regexp";
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case "array":
            case "object":
                return "an " + type;
            case "boolean":
            case "date":
            case "regexp":
                return "a " + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $gwROR;
    ReactPropTypes.resetWarningCache = $gwROR.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});

parcelRegister("fQsEq", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("gwROR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $c08961ea4c03f601$var$printWarning = function() {};

var $kZO5c = parcelRequire("kZO5c");
var $c08961ea4c03f601$var$loggedTypeFailures = {};

var $fQsEq = parcelRequire("fQsEq");
$c08961ea4c03f601$var$printWarning = function(text) {
    var message = "Warning: " + text;
    if (typeof console !== "undefined") console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $c08961ea4c03f601$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($fQsEq(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                err.name = "Invariant Violation";
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $kZO5c);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $c08961ea4c03f601$var$printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker " + "function must return `null` or an `Error` but returned a " + typeof error + ". " + "You may have forgotten to pass an argument to the type checker " + "creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and " + "shape all require an argument).");
        if (error instanceof Error && !(error.message in $c08961ea4c03f601$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $c08961ea4c03f601$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : "";
            $c08961ea4c03f601$var$printWarning("Failed " + location + " type: " + error.message + (stack != null ? stack : ""));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $c08961ea4c03f601$var$checkPropTypes.resetWarningCache = function() {
    $c08961ea4c03f601$var$loggedTypeFailures = {};
};
module.exports = $c08961ea4c03f601$var$checkPropTypes;

});



parcelRegister("7iEsg", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $55099852ccad0564$export$cc80c08dc91f1c00);

var $acw62 = parcelRequire("acw62");
var $55099852ccad0564$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$55099852ccad0564$export$cc80c08dc91f1c00.displayName = "ReactRedux";
var $55099852ccad0564$export$2e2bcd8739ae039 = $55099852ccad0564$export$cc80c08dc91f1c00;

});

parcelRegister("j4jJy", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $de1db2bafb2c3b5a$export$d567d2b9af322f8f);

var $lnBci = parcelRequire("lnBci");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $de1db2bafb2c3b5a$var$createListenerCollection() {
    var batch = (0, $lnBci.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $de1db2bafb2c3b5a$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $de1db2bafb2c3b5a$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $de1db2bafb2c3b5a$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $de1db2bafb2c3b5a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $de1db2bafb2c3b5a$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("lnBci", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $f9089991fdc24c9c$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $f9089991fdc24c9c$var$defaultNoopBatch(callback) {
    callback();
}
var $f9089991fdc24c9c$var$batch = $f9089991fdc24c9c$var$defaultNoopBatch; // Allow injecting another batching function later
var $f9089991fdc24c9c$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $f9089991fdc24c9c$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $f9089991fdc24c9c$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $f9089991fdc24c9c$var$batch;
};

});


parcelRegister("atMb1", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $7a11fbbe9e9ac5f8$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $7a11fbbe9e9ac5f8$export$700979bc83e7db82 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);

});


parcelRegister("2g8Bt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a53bfd8072ab080$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $jI2LP = parcelRequire("jI2LP");

var $acw62 = parcelRequire("acw62");

var $cfvvO = parcelRequire("cfvvO");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");

var $7iEsg = parcelRequire("7iEsg");
var $1a53bfd8072ab080$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $1a53bfd8072ab080$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $1a53bfd8072ab080$var$EMPTY_ARRAY = [];
var $1a53bfd8072ab080$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $1a53bfd8072ab080$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $1a53bfd8072ab080$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $1a53bfd8072ab080$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $1a53bfd8072ab080$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: "STORE_UPDATED",
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $1a53bfd8072ab080$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $1a53bfd8072ab080$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? "connectAdvanced" : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? "store" : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $7iEsg.ReactReduxContext) : _ref2$context, connectOptions = (0, $1En50.default)(_ref2, $1a53bfd8072ab080$var$_excluded);
    if (renderCountProp !== undefined) throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    if (withRef) throw new Error("withRef is removed. To access the wrapped instance, use a ref on the connected component");
    var customStoreWarningMessage = "To use a custom Redux store for specific components, create a custom React context with React.createContext(), and pass the context object to React Redux's Provider and specific components like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. You may also pass a {context : MyContext} option to connect";
    if (storeKey !== "store") throw new Error("storeKey has been removed and does not do anything. " + customStoreWarningMessage);
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        if (!(0, $cfvvO.isValidElementType)(WrappedComponent)) throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + $1a53bfd8072ab080$var$stringifyComponent(WrappedComponent)));
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $8nd05.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $acw62.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $acw62.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $1En50.default)(props, $1a53bfd8072ab080$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $acw62.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $cfvvO.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $acw62.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            if (!didStoreComeFromProps && !didStoreComeFromContext) throw new Error('Could not find "store" in the context of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
             // Based on the previous check, one of these must be true
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $acw62.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $acw62.useMemo)(function() {
                if (!shouldHandleStateChanges) return $1a53bfd8072ab080$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $j4jJy.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $acw62.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $8nd05.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $acw62.useReducer)($1a53bfd8072ab080$var$storeStateUpdatesReducer, $1a53bfd8072ab080$var$EMPTY_ARRAY, $1a53bfd8072ab080$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $acw62.useRef)();
            var lastWrapperProps = (0, $acw62.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $acw62.useRef)();
            var renderIsScheduled = (0, $acw62.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs($1a53bfd8072ab080$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $1a53bfd8072ab080$var$useIsomorphicLayoutEffectWithArgs($1a53bfd8072ab080$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $acw62.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrappedComponent, (0, $8nd05.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $acw62.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Connect, (0, $8nd05.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($jI2LP)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($jI2LP)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("jI2LP", function(module, exports) {
"use strict";

var $hSCIc = parcelRequire("hSCIc");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $e59446857152c163$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $e59446857152c163$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $e59446857152c163$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $e59446857152c163$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $e59446857152c163$var$TYPE_STATICS = {};
$e59446857152c163$var$TYPE_STATICS[$hSCIc.ForwardRef] = $e59446857152c163$var$FORWARD_REF_STATICS;
$e59446857152c163$var$TYPE_STATICS[$hSCIc.Memo] = $e59446857152c163$var$MEMO_STATICS;
function $e59446857152c163$var$getStatics(component) {
    // React v16.11 and below
    if ($hSCIc.isMemo(component)) return $e59446857152c163$var$MEMO_STATICS;
     // React v16.12 and above
    return $e59446857152c163$var$TYPE_STATICS[component["$$typeof"]] || $e59446857152c163$var$REACT_STATICS;
}
var $e59446857152c163$var$defineProperty = Object.defineProperty;
var $e59446857152c163$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $e59446857152c163$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $e59446857152c163$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $e59446857152c163$var$getPrototypeOf = Object.getPrototypeOf;
var $e59446857152c163$var$objectPrototype = Object.prototype;
function $e59446857152c163$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($e59446857152c163$var$objectPrototype) {
            var inheritedComponent = $e59446857152c163$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $e59446857152c163$var$objectPrototype) $e59446857152c163$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $e59446857152c163$var$getOwnPropertyNames(sourceComponent);
        if ($e59446857152c163$var$getOwnPropertySymbols) keys = keys.concat($e59446857152c163$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $e59446857152c163$var$getStatics(targetComponent);
        var sourceStatics = $e59446857152c163$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$e59446857152c163$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $e59446857152c163$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $e59446857152c163$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $e59446857152c163$var$hoistNonReactStatics;

});
parcelRegister("hSCIc", function(module, exports) {
"use strict";

module.exports = (parcelRequire("vOEfk"));

});
parcelRegister("vOEfk", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $05fa2f0780ab4876$export$2b8d127b894957b9, (v) => $05fa2f0780ab4876$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $05fa2f0780ab4876$export$cea3a54a6425200c, (v) => $05fa2f0780ab4876$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $05fa2f0780ab4876$export$a7c73072b1a182ae, (v) => $05fa2f0780ab4876$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $05fa2f0780ab4876$export$9f27bc3417b4524d, (v) => $05fa2f0780ab4876$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $05fa2f0780ab4876$export$db77ccec0bb4ccac, (v) => $05fa2f0780ab4876$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $05fa2f0780ab4876$export$8392c0c9d3dcbd35, (v) => $05fa2f0780ab4876$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $05fa2f0780ab4876$export$ffb0004e005737fa, (v) => $05fa2f0780ab4876$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $05fa2f0780ab4876$export$b624eff549462981, (v) => $05fa2f0780ab4876$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $05fa2f0780ab4876$export$7897aa7841a5380c, (v) => $05fa2f0780ab4876$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $05fa2f0780ab4876$export$602eac185826482c, (v) => $05fa2f0780ab4876$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $05fa2f0780ab4876$export$e2c29f18771995cb, (v) => $05fa2f0780ab4876$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $05fa2f0780ab4876$export$5f8d39834fd61797, (v) => $05fa2f0780ab4876$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $05fa2f0780ab4876$export$74bf444e3cd11ea5, (v) => $05fa2f0780ab4876$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $05fa2f0780ab4876$export$92387174baf9b227, (v) => $05fa2f0780ab4876$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $05fa2f0780ab4876$export$ec112efeb987d9c6, (v) => $05fa2f0780ab4876$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $05fa2f0780ab4876$export$b706b080d889d2c9, (v) => $05fa2f0780ab4876$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $05fa2f0780ab4876$export$5be5a87408f70ddc, (v) => $05fa2f0780ab4876$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $05fa2f0780ab4876$export$45a5e7f76e0caa8d, (v) => $05fa2f0780ab4876$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $05fa2f0780ab4876$export$455c2e768291efa6, (v) => $05fa2f0780ab4876$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $05fa2f0780ab4876$export$9522e17588c12572, (v) => $05fa2f0780ab4876$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $05fa2f0780ab4876$export$2110ac352bb060b9, (v) => $05fa2f0780ab4876$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $05fa2f0780ab4876$export$56885ab8b9c456ab, (v) => $05fa2f0780ab4876$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $05fa2f0780ab4876$export$d927fcb6adf8f9de, (v) => $05fa2f0780ab4876$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $05fa2f0780ab4876$export$b82d16f27459e05a, (v) => $05fa2f0780ab4876$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $05fa2f0780ab4876$export$522c17b4f5e123e8, (v) => $05fa2f0780ab4876$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $05fa2f0780ab4876$export$1aabd8a0274ecfd6, (v) => $05fa2f0780ab4876$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $05fa2f0780ab4876$export$9b621391a187a31a, (v) => $05fa2f0780ab4876$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $05fa2f0780ab4876$export$f5bbd400c2f4426f, (v) => $05fa2f0780ab4876$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $05fa2f0780ab4876$export$2b8d127b894957b9;
var $05fa2f0780ab4876$export$cea3a54a6425200c;
var $05fa2f0780ab4876$export$a7c73072b1a182ae;
var $05fa2f0780ab4876$export$9f27bc3417b4524d;
var $05fa2f0780ab4876$export$db77ccec0bb4ccac;
var $05fa2f0780ab4876$export$8392c0c9d3dcbd35;
var $05fa2f0780ab4876$export$ffb0004e005737fa;
var $05fa2f0780ab4876$export$b624eff549462981;
var $05fa2f0780ab4876$export$7897aa7841a5380c;
var $05fa2f0780ab4876$export$602eac185826482c;
var $05fa2f0780ab4876$export$e2c29f18771995cb;
var $05fa2f0780ab4876$export$5f8d39834fd61797;
var $05fa2f0780ab4876$export$74bf444e3cd11ea5;
var $05fa2f0780ab4876$export$92387174baf9b227;
var $05fa2f0780ab4876$export$ec112efeb987d9c6;
var $05fa2f0780ab4876$export$b706b080d889d2c9;
var $05fa2f0780ab4876$export$5be5a87408f70ddc;
var $05fa2f0780ab4876$export$45a5e7f76e0caa8d;
var $05fa2f0780ab4876$export$455c2e768291efa6;
var $05fa2f0780ab4876$export$9522e17588c12572;
var $05fa2f0780ab4876$export$2110ac352bb060b9;
var $05fa2f0780ab4876$export$56885ab8b9c456ab;
var $05fa2f0780ab4876$export$d927fcb6adf8f9de;
var $05fa2f0780ab4876$export$b82d16f27459e05a;
var $05fa2f0780ab4876$export$522c17b4f5e123e8;
var $05fa2f0780ab4876$export$1aabd8a0274ecfd6;
var $05fa2f0780ab4876$export$9b621391a187a31a;
var $05fa2f0780ab4876$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $05fa2f0780ab4876$export$2b8d127b894957b9 = AsyncMode;
    $05fa2f0780ab4876$export$cea3a54a6425200c = ConcurrentMode;
    $05fa2f0780ab4876$export$a7c73072b1a182ae = ContextConsumer;
    $05fa2f0780ab4876$export$9f27bc3417b4524d = ContextProvider;
    $05fa2f0780ab4876$export$db77ccec0bb4ccac = Element;
    $05fa2f0780ab4876$export$8392c0c9d3dcbd35 = ForwardRef;
    $05fa2f0780ab4876$export$ffb0004e005737fa = Fragment;
    $05fa2f0780ab4876$export$b624eff549462981 = Lazy;
    $05fa2f0780ab4876$export$7897aa7841a5380c = Memo;
    $05fa2f0780ab4876$export$602eac185826482c = Portal;
    $05fa2f0780ab4876$export$e2c29f18771995cb = Profiler;
    $05fa2f0780ab4876$export$5f8d39834fd61797 = StrictMode;
    $05fa2f0780ab4876$export$74bf444e3cd11ea5 = Suspense;
    $05fa2f0780ab4876$export$92387174baf9b227 = isAsyncMode;
    $05fa2f0780ab4876$export$ec112efeb987d9c6 = isConcurrentMode;
    $05fa2f0780ab4876$export$b706b080d889d2c9 = isContextConsumer;
    $05fa2f0780ab4876$export$5be5a87408f70ddc = isContextProvider;
    $05fa2f0780ab4876$export$45a5e7f76e0caa8d = isElement;
    $05fa2f0780ab4876$export$455c2e768291efa6 = isForwardRef;
    $05fa2f0780ab4876$export$9522e17588c12572 = isFragment;
    $05fa2f0780ab4876$export$2110ac352bb060b9 = isLazy;
    $05fa2f0780ab4876$export$56885ab8b9c456ab = isMemo;
    $05fa2f0780ab4876$export$d927fcb6adf8f9de = isPortal;
    $05fa2f0780ab4876$export$b82d16f27459e05a = isProfiler;
    $05fa2f0780ab4876$export$522c17b4f5e123e8 = isStrictMode;
    $05fa2f0780ab4876$export$1aabd8a0274ecfd6 = isSuspense;
    $05fa2f0780ab4876$export$9b621391a187a31a = isValidElementType;
    $05fa2f0780ab4876$export$f5bbd400c2f4426f = typeOf;
})();

});



parcelRegister("cfvvO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("luY4l"));

});
parcelRegister("luY4l", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $fa6afecb3ac62071$export$a7c73072b1a182ae, (v) => $fa6afecb3ac62071$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $fa6afecb3ac62071$export$9f27bc3417b4524d, (v) => $fa6afecb3ac62071$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $fa6afecb3ac62071$export$db77ccec0bb4ccac, (v) => $fa6afecb3ac62071$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $fa6afecb3ac62071$export$8392c0c9d3dcbd35, (v) => $fa6afecb3ac62071$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $fa6afecb3ac62071$export$ffb0004e005737fa, (v) => $fa6afecb3ac62071$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $fa6afecb3ac62071$export$b624eff549462981, (v) => $fa6afecb3ac62071$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $fa6afecb3ac62071$export$7897aa7841a5380c, (v) => $fa6afecb3ac62071$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $fa6afecb3ac62071$export$602eac185826482c, (v) => $fa6afecb3ac62071$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $fa6afecb3ac62071$export$e2c29f18771995cb, (v) => $fa6afecb3ac62071$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $fa6afecb3ac62071$export$5f8d39834fd61797, (v) => $fa6afecb3ac62071$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $fa6afecb3ac62071$export$74bf444e3cd11ea5, (v) => $fa6afecb3ac62071$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $fa6afecb3ac62071$export$92387174baf9b227, (v) => $fa6afecb3ac62071$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $fa6afecb3ac62071$export$ec112efeb987d9c6, (v) => $fa6afecb3ac62071$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $fa6afecb3ac62071$export$b706b080d889d2c9, (v) => $fa6afecb3ac62071$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $fa6afecb3ac62071$export$5be5a87408f70ddc, (v) => $fa6afecb3ac62071$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $fa6afecb3ac62071$export$45a5e7f76e0caa8d, (v) => $fa6afecb3ac62071$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $fa6afecb3ac62071$export$455c2e768291efa6, (v) => $fa6afecb3ac62071$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $fa6afecb3ac62071$export$9522e17588c12572, (v) => $fa6afecb3ac62071$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $fa6afecb3ac62071$export$2110ac352bb060b9, (v) => $fa6afecb3ac62071$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $fa6afecb3ac62071$export$56885ab8b9c456ab, (v) => $fa6afecb3ac62071$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $fa6afecb3ac62071$export$d927fcb6adf8f9de, (v) => $fa6afecb3ac62071$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $fa6afecb3ac62071$export$b82d16f27459e05a, (v) => $fa6afecb3ac62071$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $fa6afecb3ac62071$export$522c17b4f5e123e8, (v) => $fa6afecb3ac62071$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $fa6afecb3ac62071$export$1aabd8a0274ecfd6, (v) => $fa6afecb3ac62071$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $fa6afecb3ac62071$export$9b621391a187a31a, (v) => $fa6afecb3ac62071$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $fa6afecb3ac62071$export$f5bbd400c2f4426f, (v) => $fa6afecb3ac62071$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $fa6afecb3ac62071$export$a7c73072b1a182ae;
var $fa6afecb3ac62071$export$9f27bc3417b4524d;
var $fa6afecb3ac62071$export$db77ccec0bb4ccac;
var $fa6afecb3ac62071$export$8392c0c9d3dcbd35;
var $fa6afecb3ac62071$export$ffb0004e005737fa;
var $fa6afecb3ac62071$export$b624eff549462981;
var $fa6afecb3ac62071$export$7897aa7841a5380c;
var $fa6afecb3ac62071$export$602eac185826482c;
var $fa6afecb3ac62071$export$e2c29f18771995cb;
var $fa6afecb3ac62071$export$5f8d39834fd61797;
var $fa6afecb3ac62071$export$74bf444e3cd11ea5;
var $fa6afecb3ac62071$export$92387174baf9b227;
var $fa6afecb3ac62071$export$ec112efeb987d9c6;
var $fa6afecb3ac62071$export$b706b080d889d2c9;
var $fa6afecb3ac62071$export$5be5a87408f70ddc;
var $fa6afecb3ac62071$export$45a5e7f76e0caa8d;
var $fa6afecb3ac62071$export$455c2e768291efa6;
var $fa6afecb3ac62071$export$9522e17588c12572;
var $fa6afecb3ac62071$export$2110ac352bb060b9;
var $fa6afecb3ac62071$export$56885ab8b9c456ab;
var $fa6afecb3ac62071$export$d927fcb6adf8f9de;
var $fa6afecb3ac62071$export$b82d16f27459e05a;
var $fa6afecb3ac62071$export$522c17b4f5e123e8;
var $fa6afecb3ac62071$export$1aabd8a0274ecfd6;
var $fa6afecb3ac62071$export$9b621391a187a31a;
var $fa6afecb3ac62071$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    var REACT_FRAGMENT_TYPE = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor("react.element");
        REACT_PORTAL_TYPE = symbolFor("react.portal");
        REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
        REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
        REACT_PROFILER_TYPE = symbolFor("react.profiler");
        REACT_PROVIDER_TYPE = symbolFor("react.provider");
        REACT_CONTEXT_TYPE = symbolFor("react.context");
        REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
        REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
        REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
        REACT_MEMO_TYPE = symbolFor("react.memo");
        REACT_LAZY_TYPE = symbolFor("react.lazy");
        REACT_BLOCK_TYPE = symbolFor("react.block");
        REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
        REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
        REACT_SCOPE_TYPE = symbolFor("react.scope");
        REACT_OPAQUE_ID_TYPE = symbolFor("react.opaque.id");
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
        REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
        REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $fa6afecb3ac62071$export$a7c73072b1a182ae = ContextConsumer;
    $fa6afecb3ac62071$export$9f27bc3417b4524d = ContextProvider;
    $fa6afecb3ac62071$export$db77ccec0bb4ccac = Element;
    $fa6afecb3ac62071$export$8392c0c9d3dcbd35 = ForwardRef;
    $fa6afecb3ac62071$export$ffb0004e005737fa = Fragment;
    $fa6afecb3ac62071$export$b624eff549462981 = Lazy;
    $fa6afecb3ac62071$export$7897aa7841a5380c = Memo;
    $fa6afecb3ac62071$export$602eac185826482c = Portal;
    $fa6afecb3ac62071$export$e2c29f18771995cb = Profiler;
    $fa6afecb3ac62071$export$5f8d39834fd61797 = StrictMode;
    $fa6afecb3ac62071$export$74bf444e3cd11ea5 = Suspense;
    $fa6afecb3ac62071$export$92387174baf9b227 = isAsyncMode;
    $fa6afecb3ac62071$export$ec112efeb987d9c6 = isConcurrentMode;
    $fa6afecb3ac62071$export$b706b080d889d2c9 = isContextConsumer;
    $fa6afecb3ac62071$export$5be5a87408f70ddc = isContextProvider;
    $fa6afecb3ac62071$export$45a5e7f76e0caa8d = isElement;
    $fa6afecb3ac62071$export$455c2e768291efa6 = isForwardRef;
    $fa6afecb3ac62071$export$9522e17588c12572 = isFragment;
    $fa6afecb3ac62071$export$2110ac352bb060b9 = isLazy;
    $fa6afecb3ac62071$export$56885ab8b9c456ab = isMemo;
    $fa6afecb3ac62071$export$d927fcb6adf8f9de = isPortal;
    $fa6afecb3ac62071$export$b82d16f27459e05a = isProfiler;
    $fa6afecb3ac62071$export$522c17b4f5e123e8 = isStrictMode;
    $fa6afecb3ac62071$export$1aabd8a0274ecfd6 = isSuspense;
    $fa6afecb3ac62071$export$9b621391a187a31a = isValidElementType;
    $fa6afecb3ac62071$export$f5bbd400c2f4426f = typeOf;
})();

});



parcelRegister("hrvfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb2d32d6c07199e9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $2g8Bt = parcelRequire("2g8Bt");

var $8PZ7r = parcelRequire("8PZ7r");

var $ih4tx = parcelRequire("ih4tx");

var $kSE8V = parcelRequire("kSE8V");

var $7EQ16 = parcelRequire("7EQ16");

var $40Fxm = parcelRequire("40Fxm");
var $cb2d32d6c07199e9$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $cb2d32d6c07199e9$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $cb2d32d6c07199e9$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $cb2d32d6c07199e9$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $2g8Bt.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $kSE8V.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $ih4tx.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $7EQ16.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $40Fxm.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $cb2d32d6c07199e9$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $8PZ7r.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $8PZ7r.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $8PZ7r.default) : _ref3$areMergedPropsE, extraOptions = (0, $1En50.default)(_ref3, $cb2d32d6c07199e9$var$_excluded);
        var initMapStateToProps = $cb2d32d6c07199e9$var$match(mapStateToProps, mapStateToPropsFactories, "mapStateToProps");
        var initMapDispatchToProps = $cb2d32d6c07199e9$var$match(mapDispatchToProps, mapDispatchToPropsFactories, "mapDispatchToProps");
        var initMergeProps = $cb2d32d6c07199e9$var$match(mergeProps, mergePropsFactories, "mergeProps");
        return connectHOC(selectorFactory, (0, $8nd05.default)({
            // used in error messages
            methodName: "connect",
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $cb2d32d6c07199e9$export$2e2bcd8739ae039 = /*#__PURE__*/ $cb2d32d6c07199e9$export$9f9feb656dec1fc4();

});
parcelRegister("8PZ7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f27f2048ec2805$export$2e2bcd8739ae039);
function $66f27f2048ec2805$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $66f27f2048ec2805$export$2e2bcd8739ae039(objA, objB) {
    if ($66f27f2048ec2805$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$66f27f2048ec2805$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("ih4tx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4dd493c66c4df43$export$2e2bcd8739ae039);

var $96XmR = parcelRequire("96XmR");

var $3TktP = parcelRequire("3TktP");
function $d4dd493c66c4df43$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === "function" ? (0, $3TktP.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : undefined;
}
function $d4dd493c66c4df43$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $3TktP.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $d4dd493c66c4df43$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $3TktP.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $96XmR.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $d4dd493c66c4df43$export$2e2bcd8739ae039 = [
    $d4dd493c66c4df43$export$a9f27b4b187c1166,
    $d4dd493c66c4df43$export$ba20d1a7aa0c4a90,
    $d4dd493c66c4df43$export$94a6e55709d4d961
];

});
parcelRegister("96XmR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a22b9cec285f673$export$2e2bcd8739ae039);
function $6a22b9cec285f673$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("3TktP", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $2d566511964cb2c4$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $2d566511964cb2c4$export$8d46c7f53c8c602f);

var $jKoYp = parcelRequire("jKoYp");
function $2d566511964cb2c4$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $2d566511964cb2c4$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $2d566511964cb2c4$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $2d566511964cb2c4$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            (0, $jKoYp.default)(props, displayName, methodName);
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("jKoYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e605af63e5bbc093$export$2e2bcd8739ae039);

var $btfXQ = parcelRequire("btfXQ");

var $7CByU = parcelRequire("7CByU");
function $e605af63e5bbc093$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $btfXQ.default)(value)) (0, $7CByU.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("btfXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $859ec94da7aa38c4$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $859ec94da7aa38c4$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("7CByU", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c9380df5fc9ad2$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $58c9380df5fc9ad2$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("kSE8V", function(module, exports) {

$parcel$export(module.exports, "default", () => $f337fd5395077a96$export$2e2bcd8739ae039);

var $3TktP = parcelRequire("3TktP");
function $f337fd5395077a96$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === "function" ? (0, $3TktP.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : undefined;
}
function $f337fd5395077a96$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $3TktP.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $f337fd5395077a96$export$2e2bcd8739ae039 = [
    $f337fd5395077a96$export$23fc470827b14aa,
    $f337fd5395077a96$export$514bc8c1a53c1d66
];

});

parcelRegister("7EQ16", function(module, exports) {

$parcel$export(module.exports, "default", () => $59349e43bbd01749$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $jKoYp = parcelRequire("jKoYp");
function $59349e43bbd01749$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $8nd05.default)({}, ownProps, stateProps, dispatchProps);
}
function $59349e43bbd01749$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
                (0, $jKoYp.default)(mergedProps, displayName, "mergeProps");
            }
            return mergedProps;
        };
    };
}
function $59349e43bbd01749$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === "function" ? $59349e43bbd01749$export$5b105939c84b5234(mergeProps) : undefined;
}
function $59349e43bbd01749$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $59349e43bbd01749$export$691c327fc30bc857;
    } : undefined;
}
var $59349e43bbd01749$export$2e2bcd8739ae039 = [
    $59349e43bbd01749$export$d61b680184bc3f00,
    $59349e43bbd01749$export$a13ba70ef50dda6d
];

});

parcelRegister("40Fxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb761e6a8ffbe36$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $d6Wo0 = parcelRequire("d6Wo0");
var $2eb761e6a8ffbe36$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $2eb761e6a8ffbe36$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $2eb761e6a8ffbe36$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $1En50.default)(_ref2, $2eb761e6a8ffbe36$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    (0, $d6Wo0.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
    var selectorFactory = options.pure ? $2eb761e6a8ffbe36$export$d20c0c2ca6eb2b6f : $2eb761e6a8ffbe36$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("d6Wo0", function(module, exports) {

$parcel$export(module.exports, "default", () => $98b92028b84cbd13$export$2e2bcd8739ae039);

var $7CByU = parcelRequire("7CByU");
function $98b92028b84cbd13$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $7CByU.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $98b92028b84cbd13$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $98b92028b84cbd13$var$verify(mapStateToProps, "mapStateToProps", displayName);
    $98b92028b84cbd13$var$verify(mapDispatchToProps, "mapDispatchToProps", displayName);
    $98b92028b84cbd13$var$verify(mergeProps, "mergeProps", displayName);
}

});



parcelRegister("2OPjR", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $20d80f3cecee513e$export$8ad76b76a4c905f8);

var $7iEsg = parcelRequire("7iEsg");

var $4TSkt = parcelRequire("4TSkt");
function $20d80f3cecee513e$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $7iEsg.ReactReduxContext);
    var useStore = context === (0, $7iEsg.ReactReduxContext) ? (0, $4TSkt.useStore) : (0, $4TSkt.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $20d80f3cecee513e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $20d80f3cecee513e$export$bc9b55530897c558();

});
parcelRegister("4TSkt", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $391671225302c365$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $391671225302c365$export$6ccbb43953eebf8);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");

var $1ubyh = parcelRequire("1ubyh");
function $391671225302c365$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $7iEsg.ReactReduxContext);
    var useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : function() {
        return (0, $acw62.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $391671225302c365$export$6ccbb43953eebf8 = /*#__PURE__*/ $391671225302c365$export$671dba69185d0304();

});
parcelRegister("1ubyh", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $11518dc3bb05d381$export$c1275ca9a6fd3ec5);

var $acw62 = parcelRequire("acw62");

var $7iEsg = parcelRequire("7iEsg");
function $11518dc3bb05d381$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $acw62.useContext)((0, $7iEsg.ReactReduxContext));
    if (!contextValue) throw new Error("could not find react-redux context value; please ensure the component is wrapped in a <Provider>");
    return contextValue;
}

});



parcelRegister("iD0SF", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $d8fc8d639f906efc$export$2105062e25df4afe);

var $acw62 = parcelRequire("acw62");

var $1ubyh = parcelRequire("1ubyh");

var $j4jJy = parcelRequire("j4jJy");

var $atMb1 = parcelRequire("atMb1");

var $7iEsg = parcelRequire("7iEsg");
var $d8fc8d639f906efc$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $d8fc8d639f906efc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $acw62.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $acw62.useMemo)(function() {
        return (0, $j4jJy.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $acw62.useRef)();
    var latestSelector = (0, $acw62.useRef)();
    var latestStoreState = (0, $acw62.useRef)();
    var latestSelectedState = (0, $acw62.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $atMb1.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $d8fc8d639f906efc$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $7iEsg.ReactReduxContext);
    var useReduxContext = context === (0, $7iEsg.ReactReduxContext) ? (0, $1ubyh.useReduxContext) : function() {
        return (0, $acw62.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $d8fc8d639f906efc$var$refEquality;
        if (!selector) throw new Error("You must pass a selector to useSelector");
        if (typeof selector !== "function") throw new Error("You must pass a function as a selector to useSelector");
        if (typeof equalityFn !== "function") throw new Error("You must pass a function as an equality function to useSelector");
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $d8fc8d639f906efc$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $acw62.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $d8fc8d639f906efc$export$2105062e25df4afe = /*#__PURE__*/ $d8fc8d639f906efc$export$2b53f90d2bd1cbfb();

});


parcelRegister("7c7i6", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("1u0KT")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $1u0KT = parcelRequire("1u0KT");

});


parcelRegister("4fGPb", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $3189c83282a9a1c6$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $3189c83282a9a1c6$export$a6c7ac8248d6e38a);

var $kfZjc = parcelRequire("kfZjc");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $3np4r = parcelRequire("3np4r");

var $c9Z8w = parcelRequire("c9Z8w");

var $9RYKL = parcelRequire("9RYKL");

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bv4qN = parcelRequire("bv4qN");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3189c83282a9a1c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$3189c83282a9a1c6$export$9ba4e89fdfa1fc54.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    forceRefresh: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    keyLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
};
$3189c83282a9a1c6$export$9ba4e89fdfa1fc54.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
};
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3189c83282a9a1c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$3189c83282a9a1c6$export$7221d69dcfc8e36b.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    hashType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "hashbang",
        "noslash",
        "slash"
    ])
};
$3189c83282a9a1c6$export$7221d69dcfc8e36b.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { HashRouter as Router }`.");
};
var $3189c83282a9a1c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3189c83282a9a1c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $3np4r.createLocation)(to, null, null, currentLocation) : to;
};
var $3189c83282a9a1c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef === "undefined") $3189c83282a9a1c6$var$forwardRef = $3189c83282a9a1c6$var$forwardRefShim;
function $3189c83282a9a1c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3189c83282a9a1c6$var$LinkAnchor = $3189c83282a9a1c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1En50.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $8nd05.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3189c83282a9a1c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", props);
});
$3189c83282a9a1c6$var$LinkAnchor.displayName = "LinkAnchor";
/**
 * The public API for rendering a history-aware <a>.
 */ var $3189c83282a9a1c6$export$a6c7ac8248d6e38a = $3189c83282a9a1c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3189c83282a9a1c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1En50.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false, "You should not use <Link> outside a <Router>");
        var history = context.history;
        var location = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $8nd05.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3189c83282a9a1c6$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $3np4r.createPath)(context.location) === (0, $3np4r.createPath)($3189c83282a9a1c6$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props);
    });
});
var $3189c83282a9a1c6$var$toType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
]);
var $3189c83282a9a1c6$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
    })
]);
$3189c83282a9a1c6$export$a6c7ac8248d6e38a.displayName = "Link";
$3189c83282a9a1c6$export$a6c7ac8248d6e38a.propTypes = {
    innerRef: $3189c83282a9a1c6$var$refType,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    to: $3189c83282a9a1c6$var$toType.isRequired
};
var $3189c83282a9a1c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef$1 === "undefined") $3189c83282a9a1c6$var$forwardRef$1 = $3189c83282a9a1c6$var$forwardRefShim$1;
function $3189c83282a9a1c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3189c83282a9a1c6$export$b0d92dbee9b5b60d = $3189c83282a9a1c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1En50.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false, "You should not use <NavLink> outside a <Router>");
        var currentLocation = locationProp || context.location;
        var toLocation = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $kfZjc.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $3189c83282a9a1c6$var$joinClassnames(className, activeClassName);
            style = (0, $8nd05.default)({}, style, activeStyle);
        }
        var props = (0, $8nd05.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim$1 !== $3189c83282a9a1c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3189c83282a9a1c6$export$a6c7ac8248d6e38a, props);
    });
});
$3189c83282a9a1c6$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $3189c83282a9a1c6$var$ariaCurrentType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
    "page",
    "step",
    "location",
    "date",
    "time",
    "true",
    "false"
]);
$3189c83282a9a1c6$export$b0d92dbee9b5b60d.propTypes = (0, $8nd05.default)({}, $3189c83282a9a1c6$export$a6c7ac8248d6e38a.propTypes, {
    "aria-current": $3189c83282a9a1c6$var$ariaCurrentType,
    activeClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    activeStyle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ])
});

});
parcelRegister("kfZjc", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", () => $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07);
$parcel$export(module.exports, "Router", () => $ebf4c3fe5600f7ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "MemoryRouter", () => $ebf4c3fe5600f7ed$export$ae46f04cfaffe093);
$parcel$export(module.exports, "Prompt", () => $ebf4c3fe5600f7ed$export$83716a4aa1642908);
$parcel$export(module.exports, "generatePath", () => $ebf4c3fe5600f7ed$export$82476f982757e71e);
$parcel$export(module.exports, "Redirect", () => $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e);
$parcel$export(module.exports, "matchPath", () => $ebf4c3fe5600f7ed$export$81336c211d5ff295);
$parcel$export(module.exports, "Route", () => $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "StaticRouter", () => $ebf4c3fe5600f7ed$export$cac06da4d76d935b);
$parcel$export(module.exports, "Switch", () => $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262);
$parcel$export(module.exports, "withRouter", () => $ebf4c3fe5600f7ed$export$369b6b2b30582e8e);
$parcel$export(module.exports, "useHistory", () => $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c);
$parcel$export(module.exports, "useLocation", () => $ebf4c3fe5600f7ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useParams", () => $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "useRouteMatch", () => $ebf4c3fe5600f7ed$export$632be4bb944c1bc7);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3np4r = parcelRequire("3np4r");

var $9RYKL = parcelRequire("9RYKL");

var $bv4qN = parcelRequire("bv4qN");

var $8nd05 = parcelRequire("8nd05");

var $8ugx5 = parcelRequire("8ugx5");

var $4jPKB = parcelRequire("4jPKB");

var $1En50 = parcelRequire("1En50");

var $13XQU = parcelRequire("13XQU");
var $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $ebf4c3fe5600f7ed$var$commonjsGlobal = typeof globalThis !== "undefined" // 'global proper'
 ? globalThis : typeof window !== "undefined" ? window // Browser
 : typeof $parcel$global !== "undefined" ? $parcel$global // node.js
 : {};
function $ebf4c3fe5600f7ed$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $ebf4c3fe5600f7ed$var$commonjsGlobal[key] = ($ebf4c3fe5600f7ed$var$commonjsGlobal[key] || 0) + 1;
} // Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $ebf4c3fe5600f7ed$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else // eslint-disable-next-line no-self-compare
    return x !== x && y !== y;
}
function $ebf4c3fe5600f7ed$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $ebf4c3fe5600f7ed$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $ebf4c3fe5600f7ed$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $ebf4c3fe5600f7ed$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_React$Component) {
        (0, $g7ajw.default)(Provider, _React$Component);
        function Provider() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.emitter = $ebf4c3fe5600f7ed$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($ebf4c3fe5600f7ed$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT;
                    (0, $9RYKL.default)((changedBits & $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT) === changedBits, "calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: " + changedBits);
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_React$Component2) {
        (0, $g7ajw.default)(Consumer, _React$Component2);
        function Consumer() {
            var _this2;
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            _this2 = _React$Component2.call.apply(_React$Component2, [
                this
            ].concat(args)) || this;
            _this2.observedBits = void 0;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $ebf4c3fe5600f7ed$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $ebf4c3fe5600f7ed$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
// MIT License
var $ebf4c3fe5600f7ed$var$createContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext || $ebf4c3fe5600f7ed$var$createReactContext;
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext = function createNamedContext(name) {
    var context = $ebf4c3fe5600f7ed$var$createContext();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$c213558b66925821 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router-History");
var $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $ebf4c3fe5600f7ed$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        this._isMounted = true;
        if (this.unlisten) // Any pre-mount location changes have been captured at
        // this point, so unregister the listener.
        this.unlisten();
        if (!this.props.staticContext) this.unlisten = this.props.history.listen(function(location) {
            if (_this2._isMounted) _this2.setState({
                location: location
            });
        });
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$55185c17a0fcbe46.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    history: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
$ebf4c3fe5600f7ed$export$55185c17a0fcbe46.prototype.componentDidUpdate = function(prevProps) {
    (0, $9RYKL.default)(prevProps.history === this.props.history, "You cannot change <Router history>");
};
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ebf4c3fe5600f7ed$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$ae46f04cfaffe093.propTypes = {
    initialEntries: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    initialIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    getUserConfirmation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    keyLength: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
$ebf4c3fe5600f7ed$export$ae46f04cfaffe093.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { MemoryRouter as Router }`.");
};
var $ebf4c3fe5600f7ed$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ebf4c3fe5600f7ed$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false, "You should not use <Prompt> outside a <Router>");
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ebf4c3fe5600f7ed$var$messageType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
]);
$ebf4c3fe5600f7ed$export$83716a4aa1642908.propTypes = {
    when: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    message: $ebf4c3fe5600f7ed$var$messageType.isRequired
};
var $ebf4c3fe5600f7ed$var$cache = {};
var $ebf4c3fe5600f7ed$var$cacheLimit = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount = 0;
function $ebf4c3fe5600f7ed$var$compilePath(path) {
    if ($ebf4c3fe5600f7ed$var$cache[path]) return $ebf4c3fe5600f7ed$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($8ugx5))).compile(path);
    if ($ebf4c3fe5600f7ed$var$cacheCount < $ebf4c3fe5600f7ed$var$cacheLimit) {
        $ebf4c3fe5600f7ed$var$cache[path] = generator;
        $ebf4c3fe5600f7ed$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ebf4c3fe5600f7ed$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ebf4c3fe5600f7ed$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false, "You should not use <Redirect> outside a <Router>");
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $3np4r.createLocation)(computedMatch ? typeof to === "string" ? $ebf4c3fe5600f7ed$export$82476f982757e71e(to, computedMatch.params) : (0, $8nd05.default)({}, to, {
            pathname: $ebf4c3fe5600f7ed$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $3np4r.createLocation)(prevProps.to);
                if (!(0, $3np4r.locationsAreEqual)(prevLocation, (0, $8nd05.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
$ebf4c3fe5600f7ed$export$2d8d895a0a0f636e.propTypes = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]).isRequired
};
var $ebf4c3fe5600f7ed$var$cache$1 = {};
var $ebf4c3fe5600f7ed$var$cacheLimit$1 = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount$1 = 0;
function $ebf4c3fe5600f7ed$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ebf4c3fe5600f7ed$var$cache$1[cacheKey] || ($ebf4c3fe5600f7ed$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($8ugx5)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ebf4c3fe5600f7ed$var$cacheCount$1 < $ebf4c3fe5600f7ed$var$cacheLimit$1) {
        pathCache[path] = result;
        $ebf4c3fe5600f7ed$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ebf4c3fe5600f7ed$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ebf4c3fe5600f7ed$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ebf4c3fe5600f7ed$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 0;
}
function $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    (0, $9RYKL.default)(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? ' path="' + path + '"' : "") + ">, but you ") + "should have returned a React element or `null`");
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $bv4qN.default)(false, "You should not use <Route> outside a <Router>");
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $8nd05.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $ebf4c3fe5600f7ed$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, _this.props.path) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, _this.props.path) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$e7b0ac011bb776c6.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]),
    component: function component(props, propName) {
        if (props[propName] && !(0, $4jPKB.isValidElementType)(props[propName])) return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
    },
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string)
    ]),
    render: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
$ebf4c3fe5600f7ed$export$e7b0ac011bb776c6.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!(this.props.children && !$ebf4c3fe5600f7ed$var$isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored");
    (0, $9RYKL.default)(!(this.props.children && !$ebf4c3fe5600f7ed$var$isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored");
    (0, $9RYKL.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
};
$ebf4c3fe5600f7ed$export$e7b0ac011bb776c6.prototype.componentDidUpdate = function(prevProps) {
    (0, $9RYKL.default)(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
    (0, $9RYKL.default)(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
};
function $ebf4c3fe5600f7ed$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ebf4c3fe5600f7ed$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: $ebf4c3fe5600f7ed$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ebf4c3fe5600f7ed$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ebf4c3fe5600f7ed$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ebf4c3fe5600f7ed$var$createURL(location) {
    return typeof location === "string" ? location : (0, $3np4r.createPath)(location);
}
function $ebf4c3fe5600f7ed$var$staticHandler(methodName) {
    return function() {
        (0, $bv4qN.default)(false, "You cannot %s with <StaticRouter>", methodName);
    };
}
function $ebf4c3fe5600f7ed$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ebf4c3fe5600f7ed$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        _this.handleBlock = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ebf4c3fe5600f7ed$var$addBasename(basename, (0, $3np4r.createLocation)(location));
        context.url = $ebf4c3fe5600f7ed$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $1En50.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ebf4c3fe5600f7ed$var$addLeadingSlash(basename + $ebf4c3fe5600f7ed$var$createURL(path));
            },
            action: "POP",
            location: $ebf4c3fe5600f7ed$var$stripBasename(basename, (0, $3np4r.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ebf4c3fe5600f7ed$var$staticHandler("go"),
            goBack: $ebf4c3fe5600f7ed$var$staticHandler("goBack"),
            goForward: $ebf4c3fe5600f7ed$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, (0, $8nd05.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$cac06da4d76d935b.propTypes = {
    basename: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    context: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])
};
$ebf4c3fe5600f7ed$export$cac06da4d76d935b.prototype.componentDidMount = function() {
    (0, $9RYKL.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { StaticRouter as Router }`.");
};
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false, "You should not use <Switch> outside a <Router>");
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, (0, $8nd05.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ebf4c3fe5600f7ed$export$b5d5cf8927ab7262.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
$ebf4c3fe5600f7ed$export$b5d5cf8927ab7262.prototype.componentDidUpdate = function(prevProps) {
    (0, $9RYKL.default)(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
    (0, $9RYKL.default)(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
};
/**
 * A public higher-order component to access the imperative API
 */ function $ebf4c3fe5600f7ed$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $1En50.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false, "You should not use <" + displayName + " /> outside a <Router>");
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    C.propTypes = {
        wrappedComponentRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
        ])
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($13XQU)))(C, Component);
}
var $ebf4c3fe5600f7ed$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext;
function $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c() {
    !(typeof $ebf4c3fe5600f7ed$var$useContext === "function") && (0, $bv4qN.default)(false, "You must use React >= 16.8 in order to use useHistory()");
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$c213558b66925821);
}
function $ebf4c3fe5600f7ed$export$45d76561a5302f2b() {
    !(typeof $ebf4c3fe5600f7ed$var$useContext === "function") && (0, $bv4qN.default)(false, "You must use React >= 16.8 in order to use useLocation()");
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).location;
}
function $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef() {
    !(typeof $ebf4c3fe5600f7ed$var$useContext === "function") && (0, $bv4qN.default)(false, "You must use React >= 16.8 in order to use useParams()");
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ebf4c3fe5600f7ed$export$632be4bb944c1bc7(path) {
    !(typeof $ebf4c3fe5600f7ed$var$useContext === "function") && (0, $bv4qN.default)(false, "You must use React >= 16.8 in order to use useRouteMatch()");
    var location = $ebf4c3fe5600f7ed$export$45d76561a5302f2b();
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, path) : match;
}
if (typeof window !== "undefined") {
    var $ebf4c3fe5600f7ed$var$global$1 = window;
    var $ebf4c3fe5600f7ed$var$key = "__react_router_build__";
    var $ebf4c3fe5600f7ed$var$buildNames = {
        cjs: "CommonJS",
        esm: "ES modules",
        umd: "UMD"
    };
    if ($ebf4c3fe5600f7ed$var$global$1[$ebf4c3fe5600f7ed$var$key] && $ebf4c3fe5600f7ed$var$global$1[$ebf4c3fe5600f7ed$var$key] !== "esm") {
        var $ebf4c3fe5600f7ed$var$initialBuildName = $ebf4c3fe5600f7ed$var$buildNames[$ebf4c3fe5600f7ed$var$global$1[$ebf4c3fe5600f7ed$var$key]];
        var $ebf4c3fe5600f7ed$var$secondaryBuildName = $ebf4c3fe5600f7ed$var$buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
        // loading 2 different builds.
        throw new Error("You are loading the " + $ebf4c3fe5600f7ed$var$secondaryBuildName + " build of React Router " + ("on a page that is already running the " + $ebf4c3fe5600f7ed$var$initialBuildName + " ") + "build, so things won't work right.");
    }
    $ebf4c3fe5600f7ed$var$global$1[$ebf4c3fe5600f7ed$var$key] = "esm";
}

});
parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("3np4r", function(module, exports) {

$parcel$export(module.exports, "createPath", () => $2756f79476f0245f$export$fe53371bee54353d);
$parcel$export(module.exports, "createLocation", () => $2756f79476f0245f$export$90c043f1c57770b8);
$parcel$export(module.exports, "locationsAreEqual", () => $2756f79476f0245f$export$c3e8bb440bd55b18);
$parcel$export(module.exports, "createBrowserHistory", () => $2756f79476f0245f$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $2756f79476f0245f$export$b71fdd3798280242);
$parcel$export(module.exports, "createMemoryHistory", () => $2756f79476f0245f$export$2b76ad033c6e6d08);

var $8nd05 = parcelRequire("8nd05");

var $WYl7Q = parcelRequire("WYl7Q");

var $9t72y = parcelRequire("9t72y");

var $9RYKL = parcelRequire("9RYKL");

var $bv4qN = parcelRequire("bv4qN");
function $2756f79476f0245f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $2756f79476f0245f$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $2756f79476f0245f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $2756f79476f0245f$var$stripBasename(path, prefix) {
    return $2756f79476f0245f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $2756f79476f0245f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $2756f79476f0245f$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $2756f79476f0245f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $2756f79476f0245f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $2756f79476f0245f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $8nd05.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $WYl7Q.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $2756f79476f0245f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $9t72y.default)(a.state, b.state);
}
function $2756f79476f0245f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        (0, $9RYKL.default)(prompt == null, "A history supports only one prompt at a time");
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else {
                    (0, $9RYKL.default)(false, "A history needs a getUserConfirmation function in order to use a prompt message");
                    callback(true);
                }
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $2756f79476f0245f$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $2756f79476f0245f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $2756f79476f0245f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $2756f79476f0245f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $2756f79476f0245f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $2756f79476f0245f$var$PopStateEvent = "popstate";
var $2756f79476f0245f$var$HashChangeEvent = "hashchange";
function $2756f79476f0245f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $2756f79476f0245f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false, "Browser history needs a DOM");
    var globalHistory = window.history;
    var canUseHistory = $2756f79476f0245f$var$supportsHistory();
    var needsHashChangeListener = !$2756f79476f0245f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        (0, $9RYKL.default)(!basename || $2756f79476f0245f$var$hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($2756f79476f0245f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($2756f79476f0245f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($2756f79476f0245f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $2756f79476f0245f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        (0, $9RYKL.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $9RYKL.default)(state === undefined, "Browser history cannot push state in browsers that do not support HTML5 history");
                window.location.href = href;
            }
        });
    }
    function replace(path, state) {
        (0, $9RYKL.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else {
                (0, $9RYKL.default)(state === undefined, "Browser history cannot replace state in browsers that do not support HTML5 history");
                window.location.replace(href);
            }
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $2756f79476f0245f$var$HashChangeEvent$1 = "hashchange";
var $2756f79476f0245f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $2756f79476f0245f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $2756f79476f0245f$var$stripLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    },
    slash: {
        encodePath: $2756f79476f0245f$var$addLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    }
};
function $2756f79476f0245f$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $2756f79476f0245f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $2756f79476f0245f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $2756f79476f0245f$var$replaceHashPath(path) {
    window.location.replace($2756f79476f0245f$var$stripHash(window.location.href) + "#" + path);
}
function $2756f79476f0245f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false, "Hash history needs a DOM");
    var globalHistory = window.history;
    var canGoWithoutReload = $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $2756f79476f0245f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($2756f79476f0245f$var$getHashPath());
        (0, $9RYKL.default)(!basename || $2756f79476f0245f$var$hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $2756f79476f0245f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $2756f79476f0245f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $2756f79476f0245f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $2756f79476f0245f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $2756f79476f0245f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $2756f79476f0245f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $2756f79476f0245f$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $2756f79476f0245f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        (0, $9RYKL.default)(state === undefined, "Hash history cannot push state; it is ignored");
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else {
                (0, $9RYKL.default)(false, "Hash history cannot PUSH the same path; a new entry will not be added to the history stack");
                setState();
            }
        });
    }
    function replace(path, state) {
        (0, $9RYKL.default)(state === undefined, "Hash history cannot replace state; it is ignored");
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        (0, $9RYKL.default)(canGoWithoutReload, "Hash history go(n) causes a full page reload in this browser");
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $2756f79476f0245f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $2756f79476f0245f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $2756f79476f0245f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, createKey()) : $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $2756f79476f0245f$export$fe53371bee54353d;
    function push(path, state) {
        (0, $9RYKL.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to push when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        (0, $9RYKL.default)(!(typeof path === "object" && path.state !== undefined && state !== undefined), "You should avoid providing a 2nd state argument to replace when the 1st argument is a location-like object that already has state; it is ignored");
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $2756f79476f0245f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("WYl7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b14391bdc5d7d11$export$2e2bcd8739ae039);
function $0b14391bdc5d7d11$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0b14391bdc5d7d11$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0b14391bdc5d7d11$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $0b14391bdc5d7d11$var$isAbsolute(to);
    var isFromAbs = from && $0b14391bdc5d7d11$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0b14391bdc5d7d11$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$0b14391bdc5d7d11$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $0b14391bdc5d7d11$export$2e2bcd8739ae039 = $0b14391bdc5d7d11$var$resolvePathname;

});

parcelRegister("9t72y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e4c488965e5c6e8$export$2e2bcd8739ae039);
function $6e4c488965e5c6e8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6e4c488965e5c6e8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6e4c488965e5c6e8$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $6e4c488965e5c6e8$var$valueOf(a);
        var bValue = $6e4c488965e5c6e8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6e4c488965e5c6e8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6e4c488965e5c6e8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6e4c488965e5c6e8$export$2e2bcd8739ae039 = $6e4c488965e5c6e8$var$valueEqual;

});

parcelRegister("9RYKL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = false;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("bv4qN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $85f606e562c81b96$export$2e2bcd8739ae039);
var $85f606e562c81b96$var$isProduction = false;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($85f606e562c81b96$var$prefix, ": ").concat(provided) : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}

});


parcelRegister("8ugx5", function(module, exports) {

var $767Wy = parcelRequire("767Wy");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $62ddf3174d9df941$var$pathToRegexp;
module.exports.parse = $62ddf3174d9df941$var$parse;
module.exports.compile = $62ddf3174d9df941$var$compile;
module.exports.tokensToFunction = $62ddf3174d9df941$var$tokensToFunction;
module.exports.tokensToRegExp = $62ddf3174d9df941$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $62ddf3174d9df941$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $62ddf3174d9df941$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $62ddf3174d9df941$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $62ddf3174d9df941$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $62ddf3174d9df941$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $62ddf3174d9df941$var$compile(str, options) {
    return $62ddf3174d9df941$var$tokensToFunction($62ddf3174d9df941$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $62ddf3174d9df941$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $62ddf3174d9df941$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $62ddf3174d9df941$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($767Wy(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $62ddf3174d9df941$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $62ddf3174d9df941$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $62ddf3174d9df941$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($62ddf3174d9df941$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $62ddf3174d9df941$var$flags(options));
    return $62ddf3174d9df941$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$stringToRegexp(path, keys, options) {
    return $62ddf3174d9df941$var$tokensToRegExp($62ddf3174d9df941$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$tokensToRegExp(tokens, keys, options) {
    if (!$767Wy(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $62ddf3174d9df941$var$escapeString(token);
        else {
            var prefix = $62ddf3174d9df941$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $62ddf3174d9df941$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $62ddf3174d9df941$var$attachKeys(new RegExp("^" + route, $62ddf3174d9df941$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$pathToRegexp(path, keys, options) {
    if (!$767Wy(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $62ddf3174d9df941$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($767Wy(path)) return $62ddf3174d9df941$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $62ddf3174d9df941$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("767Wy", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

});


parcelRegister("13XQU", function(module, exports) {
"use strict";

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $0c647fb303ca0159$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $0c647fb303ca0159$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $0c647fb303ca0159$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $0c647fb303ca0159$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $0c647fb303ca0159$var$TYPE_STATICS = {};
$0c647fb303ca0159$var$TYPE_STATICS[$4jPKB.ForwardRef] = $0c647fb303ca0159$var$FORWARD_REF_STATICS;
$0c647fb303ca0159$var$TYPE_STATICS[$4jPKB.Memo] = $0c647fb303ca0159$var$MEMO_STATICS;
function $0c647fb303ca0159$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $0c647fb303ca0159$var$MEMO_STATICS;
     // React v16.12 and above
    return $0c647fb303ca0159$var$TYPE_STATICS[component["$$typeof"]] || $0c647fb303ca0159$var$REACT_STATICS;
}
var $0c647fb303ca0159$var$defineProperty = Object.defineProperty;
var $0c647fb303ca0159$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $0c647fb303ca0159$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $0c647fb303ca0159$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $0c647fb303ca0159$var$getPrototypeOf = Object.getPrototypeOf;
var $0c647fb303ca0159$var$objectPrototype = Object.prototype;
function $0c647fb303ca0159$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($0c647fb303ca0159$var$objectPrototype) {
            var inheritedComponent = $0c647fb303ca0159$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $0c647fb303ca0159$var$objectPrototype) $0c647fb303ca0159$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $0c647fb303ca0159$var$getOwnPropertyNames(sourceComponent);
        if ($0c647fb303ca0159$var$getOwnPropertySymbols) keys = keys.concat($0c647fb303ca0159$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $0c647fb303ca0159$var$getStatics(targetComponent);
        var sourceStatics = $0c647fb303ca0159$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$0c647fb303ca0159$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $0c647fb303ca0159$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $0c647fb303ca0159$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $0c647fb303ca0159$var$hoistNonReactStatics;

});



parcelRegister("fIPMX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $b723233bfd6a94cc$export$1e511d4a378977f5, (v) => $b723233bfd6a94cc$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $b723233bfd6a94cc$export$2e2bcd8739ae039, (v) => $b723233bfd6a94cc$export$2e2bcd8739ae039 = v);
var $b723233bfd6a94cc$export$1e511d4a378977f5;
var $b723233bfd6a94cc$export$2e2bcd8739ae039;

var $6ZWSX = parcelRequire("6ZWSX");
var $b723233bfd6a94cc$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $1jnue = parcelRequire("1jnue");
$b723233bfd6a94cc$export$1e511d4a378977f5 = true;
$b723233bfd6a94cc$export$2e2bcd8739ae039 = void 0;

var $7Yi7V = parcelRequire("7Yi7V");

var $ilYXe = parcelRequire("ilYXe");

var $b723233bfd6a94cc$var$_nativeBridge = $1jnue((parcelRequire("ciGEA")));
var $b723233bfd6a94cc$var$_Auth;
/* eslint-disable fp/no-mutating-methods */ // import { match } from '@nike/rcf-fp';
// eslint-disable-next-line import/no-cycle
class $b723233bfd6a94cc$var$Auth {
}
$b723233bfd6a94cc$export$2e2bcd8739ae039 = $b723233bfd6a94cc$var$Auth;
$b723233bfd6a94cc$var$_Auth = $b723233bfd6a94cc$var$Auth;
$b723233bfd6a94cc$var$Auth.confirmAuth = async ()=>{
    if (!$b723233bfd6a94cc$var$_Auth.isAuthenticated()) {
        if ($b723233bfd6a94cc$var$_nativeBridge.default.isNativeApp()) try {
            const token = await $b723233bfd6a94cc$var$_nativeBridge.default.requestAthleteToken();
            $b723233bfd6a94cc$var$_Auth.setNativeSession(token);
        } catch (err) {
        // Token unavailable — fall through with stale token;
        // the API call will 401 and the component error-handler decides next steps.
        }
        else await $b723233bfd6a94cc$var$_Auth.reAuthorize();
    }
    return $b723233bfd6a94cc$var$_Auth.getAuth();
};
$b723233bfd6a94cc$var$Auth.getAuth = ()=>localStorage.getItem("accessToken");
$b723233bfd6a94cc$var$Auth.getStoreId = ()=>localStorage.getItem("storeId");
$b723233bfd6a94cc$var$Auth.isAuthenticated = ()=>new Date().getTime() < JSON.parse(localStorage.getItem("expiresAt"));
$b723233bfd6a94cc$var$Auth.login = async (loginInformation)=>{
    try {
        const auth = await (0, $ilYXe.authUser)(loginInformation);
        if (!JSON.parse($b723233bfd6a94cc$require$Buffer.from(auth.access_token.split(".")[1], "base64").toString("utf-8")).nike_storeId) // eslint-disable-next-line fp/no-throw
        throw new Error(`BERM didn't send us a store id. Try again.`); // unseen error
        $b723233bfd6a94cc$var$_Auth.setLoginSession(auth);
        return true;
    } catch (err) {
        // eslint-disable-next-line fp/no-throw
        throw Error("Authorization Failed");
    }
};
/**
 * Accept a raw JWT from the native bridge, validate it contains store info,
 * persist the session, and return the decoded payload for store look-up.
 */ $b723233bfd6a94cc$var$Auth.loginWithNativeToken = (accessToken)=>{
    const payload = JSON.parse($b723233bfd6a94cc$require$Buffer.from(accessToken.split(".")[1], "base64").toString("utf-8"));
    if (!payload.nike_storeId) // eslint-disable-next-line fp/no-throw
    throw new Error("Token does not contain store information");
    $b723233bfd6a94cc$var$_Auth.setNativeSession(accessToken);
    return payload;
};
$b723233bfd6a94cc$var$Auth.logout = ()=>{
    const isNative = localStorage.getItem("isNativeApp") === "true";
    localStorage.clear();
    if (isNative) $b723233bfd6a94cc$var$_nativeBridge.default.requestLogout();
};
$b723233bfd6a94cc$var$Auth.reAuthorize = async ()=>{
    try {
        const reauth = await (0, $ilYXe.reAuthUser)(localStorage.getItem("accessToken"), localStorage.getItem("refreshToken"));
        $b723233bfd6a94cc$var$_Auth.setLoginSession(reauth);
        return true;
    } catch (err) {
        return false;
    }
};
$b723233bfd6a94cc$var$Auth.requiresRole = (auth, roleList)=>{
    try {
        const payload = JSON.parse($b723233bfd6a94cc$require$Buffer.from(auth.split(".")[1], "base64").toString("utf-8"));
        const roles = payload.nike_storeRoles;
        if (!Array.isArray(roles)) return false;
        return !!roles.filter((role)=>roleList.includes(role)).length;
    } catch  {
        return false;
    }
};
$b723233bfd6a94cc$var$Auth.requiresRole40 = (auth)=>$b723233bfd6a94cc$var$_Auth.requiresRole(auth, $7Yi7V.LEVEL_40);
$b723233bfd6a94cc$var$Auth.setLoginSession = (auth)=>{
    const expiresAt = auth.expires_in * $7Yi7V.PERCENT_90 + new Date().getTime();
    const refreshToken = auth.refresh_token.split(".")[1];
    // Subtract 10 minutes (600,000 milliseconds) to retrieve a new refresh token if expiration is within 10 minutes
    const refreshExpiresAt = JSON.parse($b723233bfd6a94cc$require$Buffer.from(refreshToken, "base64").toString("utf-8")).exp * 1000 - 600000;
    localStorage.setItem("expiresAt", expiresAt);
    localStorage.setItem("accessToken", auth.access_token);
    localStorage.setItem("refreshToken", auth.refresh_token);
    localStorage.setItem("refreshExpiresAt", refreshExpiresAt);
};
/** Persist a session from a native-bridge JWT (no refresh token available). */ $b723233bfd6a94cc$var$Auth.setNativeSession = (accessToken)=>{
    console.log("-------------------------setNativeSession", accessToken);
    const payload = JSON.parse($b723233bfd6a94cc$require$Buffer.from(accessToken.split(".")[1], "base64").toString("utf-8"));
    const expiresAt = payload.exp ? payload.exp * 1000 - 30000 : new Date().getTime() + 3600000;
    localStorage.setItem("expiresAt", expiresAt);
    localStorage.setItem("accessToken", accessToken);
    localStorage.setItem("isNativeApp", "true");
};
$b723233bfd6a94cc$var$Auth.validRefresh = ()=>{
    const refreshExpires = JSON.parse(localStorage.getItem("refreshExpiresAt"));
    const currentTime = new Date().getTime();
    return currentTime < refreshExpires;
};

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("7Yi7V", function(module, exports) {

$parcel$export(module.exports, "scsKeys", () => $5cdc329eeebd56d0$export$fc7d94d9a29d8350, (v) => $5cdc329eeebd56d0$export$fc7d94d9a29d8350 = v);
$parcel$export(module.exports, "defaultPromotions", () => $5cdc329eeebd56d0$export$d31c9a6a8cb51e0a, (v) => $5cdc329eeebd56d0$export$d31c9a6a8cb51e0a = v);
$parcel$export(module.exports, "PERCENT_90", () => $5cdc329eeebd56d0$export$7f376ad5a47a2d7e, (v) => $5cdc329eeebd56d0$export$7f376ad5a47a2d7e = v);
$parcel$export(module.exports, "LEVEL_40", () => $5cdc329eeebd56d0$export$9f39a68f874cd107, (v) => $5cdc329eeebd56d0$export$9f39a68f874cd107 = v);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $5cdc329eeebd56d0$export$1af4c7e47ad72f44, (v) => $5cdc329eeebd56d0$export$1af4c7e47ad72f44 = v);
$parcel$export(module.exports, "CSV_UPLOAD", () => $5cdc329eeebd56d0$export$dc318c7e8e479fc0, (v) => $5cdc329eeebd56d0$export$dc318c7e8e479fc0 = v);
var $5cdc329eeebd56d0$export$1e511d4a378977f5;
var $5cdc329eeebd56d0$export$fc7d94d9a29d8350;
var $5cdc329eeebd56d0$export$d31c9a6a8cb51e0a;
var $5cdc329eeebd56d0$export$7f376ad5a47a2d7e;
var $5cdc329eeebd56d0$export$9f39a68f874cd107;
var $5cdc329eeebd56d0$export$f474a153c18bb3be;
var $5cdc329eeebd56d0$export$596d75d815a8563b;
var $5cdc329eeebd56d0$export$1af4c7e47ad72f44;
var $5cdc329eeebd56d0$export$dc318c7e8e479fc0;
"use strict";
$5cdc329eeebd56d0$export$1e511d4a378977f5 = true;
$5cdc329eeebd56d0$export$fc7d94d9a29d8350 = $5cdc329eeebd56d0$export$d31c9a6a8cb51e0a = $5cdc329eeebd56d0$export$7f376ad5a47a2d7e = $5cdc329eeebd56d0$export$9f39a68f874cd107 = $5cdc329eeebd56d0$export$f474a153c18bb3be = $5cdc329eeebd56d0$export$596d75d815a8563b = $5cdc329eeebd56d0$export$1af4c7e47ad72f44 = $5cdc329eeebd56d0$export$dc318c7e8e479fc0 = void 0;
const $5cdc329eeebd56d0$var$DEFAULT_LOCALE = $5cdc329eeebd56d0$export$1af4c7e47ad72f44 = "en-US";
const $5cdc329eeebd56d0$var$PERCENT_90 = $5cdc329eeebd56d0$export$7f376ad5a47a2d7e = 900;
const $5cdc329eeebd56d0$var$LEVEL_40 = $5cdc329eeebd56d0$export$9f39a68f874cd107 = [
    "Admin",
    "AssistantManagerBOH",
    "AssistantManagerFOH",
    "KeyHolder",
    "ManagerBOH",
    "ManagerFOH",
    "SupportBOH",
    "SupportFOH"
];
const $5cdc329eeebd56d0$var$LEVEL_20 = $5cdc329eeebd56d0$export$f474a153c18bb3be = [
    ...$5cdc329eeebd56d0$var$LEVEL_40,
    "Cashier",
    "CustomerService",
    "InventoryAdjuster",
    "ShippingReceivingAssociate"
];
const $5cdc329eeebd56d0$var$DROPDOWN_OPTION_ALL = $5cdc329eeebd56d0$export$596d75d815a8563b = {
    label: "All",
    value: ""
};
const $5cdc329eeebd56d0$var$scsKeys = $5cdc329eeebd56d0$export$fc7d94d9a29d8350 = {
    allowPromoteApp: "scs.allowPromoteApp",
    createMarkdowns: "scs.createMarkdowns",
    createPromotions: "scs.createPromotions",
    isStyleUploadEnabled: "scs.isStyleUploadEnabled"
};
const $5cdc329eeebd56d0$var$CSV_UPLOAD = $5cdc329eeebd56d0$export$dc318c7e8e479fc0 = {
    BATCH_INTERVAL_MS: 1000,
    BATCH_SIZE: 100,
    MAX_ALLOWED_ROWS: 1000,
    STATUS_FAILURE: "RL_Failure",
    STATUS_PROCESSING: "RL_Waiting",
    STATUS_SUCCESS: "RL_Success",
    WARNING_PAGE_LEAVE: "The Upload is in progress. By leaving this page you would be aborting the upload.\n\nNote: Some of the StyleColors would have been already added to the promotions ?"
};
const $5cdc329eeebd56d0$var$defaultPromotions = $5cdc329eeebd56d0$export$d31c9a6a8cb51e0a = [
    "MENS CLEARANCE",
    "WOMENS CLEARANCE",
    "KIDS CLEARANCE",
    "MENS BACKWALL",
    "WOMENS BACKWALL",
    "KIDS BACKWALL"
];

});

parcelRegister("ilYXe", function(module, exports) {

$parcel$export(module.exports, "reAuthUser", () => $d5c978667035ede8$export$9c1c0821ddc65f6e, (v) => $d5c978667035ede8$export$9c1c0821ddc65f6e = v);
$parcel$export(module.exports, "postPromotion", () => $d5c978667035ede8$export$113accaf342c3d43, (v) => $d5c978667035ede8$export$113accaf342c3d43 = v);
$parcel$export(module.exports, "postMarkdown", () => $d5c978667035ede8$export$2ebec957b123ba7d, (v) => $d5c978667035ede8$export$2ebec957b123ba7d = v);
$parcel$export(module.exports, "postCsvUpload", () => $d5c978667035ede8$export$2cce2244ce74955d, (v) => $d5c978667035ede8$export$2cce2244ce74955d = v);
$parcel$export(module.exports, "postCodeToOkta", () => $d5c978667035ede8$export$49a5c4ee01b58b20, (v) => $d5c978667035ede8$export$49a5c4ee01b58b20 = v);
$parcel$export(module.exports, "patchPromotion", () => $d5c978667035ede8$export$5afc8170e33bc3fd, (v) => $d5c978667035ede8$export$5afc8170e33bc3fd = v);
$parcel$export(module.exports, "getStore", () => $d5c978667035ede8$export$6fec604aa7293d0c, (v) => $d5c978667035ede8$export$6fec604aa7293d0c = v);
$parcel$export(module.exports, "getStockOnHand", () => $d5c978667035ede8$export$cae10d02389df77e, (v) => $d5c978667035ede8$export$cae10d02389df77e = v);
$parcel$export(module.exports, "getPromotions", () => $d5c978667035ede8$export$aea5060850a5a045, (v) => $d5c978667035ede8$export$aea5060850a5a045 = v);
$parcel$export(module.exports, "getPromotion", () => $d5c978667035ede8$export$4eb2b7ed40659ce8, (v) => $d5c978667035ede8$export$4eb2b7ed40659ce8 = v);
$parcel$export(module.exports, "getPromoteConfig", () => $d5c978667035ede8$export$f2800486f94b9664, (v) => $d5c978667035ede8$export$f2800486f94b9664 = v);
$parcel$export(module.exports, "getMarkdowns", () => $d5c978667035ede8$export$cf04576cc11b2f1d, (v) => $d5c978667035ede8$export$cf04576cc11b2f1d = v);
$parcel$export(module.exports, "authUser", () => $d5c978667035ede8$export$e76dad090f952455, (v) => $d5c978667035ede8$export$e76dad090f952455 = v);
var $d5c978667035ede8$export$1e511d4a378977f5;
var $d5c978667035ede8$export$9c1c0821ddc65f6e;
var $d5c978667035ede8$export$3664a7b4a9e41b07;
var $d5c978667035ede8$export$113accaf342c3d43;
var $d5c978667035ede8$export$2ebec957b123ba7d;
var $d5c978667035ede8$export$2cce2244ce74955d;
var $d5c978667035ede8$export$49a5c4ee01b58b20;
var $d5c978667035ede8$export$5afc8170e33bc3fd;
var $d5c978667035ede8$export$6fec604aa7293d0c;
var $d5c978667035ede8$export$cae10d02389df77e;
var $d5c978667035ede8$export$aea5060850a5a045;
var $d5c978667035ede8$export$4eb2b7ed40659ce8;
var $d5c978667035ede8$export$f2800486f94b9664;
var $d5c978667035ede8$export$cf04576cc11b2f1d;
var $d5c978667035ede8$export$e76dad090f952455;
var $d5c978667035ede8$export$c211d82ee3134c96;
"use strict";

var $1jnue = parcelRequire("1jnue");
$d5c978667035ede8$export$1e511d4a378977f5 = true;
$d5c978667035ede8$export$9c1c0821ddc65f6e = $d5c978667035ede8$export$3664a7b4a9e41b07 = $d5c978667035ede8$export$113accaf342c3d43 = $d5c978667035ede8$export$2ebec957b123ba7d = $d5c978667035ede8$export$2cce2244ce74955d = $d5c978667035ede8$export$49a5c4ee01b58b20 = $d5c978667035ede8$export$5afc8170e33bc3fd = $d5c978667035ede8$export$6fec604aa7293d0c = $d5c978667035ede8$export$cae10d02389df77e = $d5c978667035ede8$export$aea5060850a5a045 = $d5c978667035ede8$export$4eb2b7ed40659ce8 = $d5c978667035ede8$export$f2800486f94b9664 = $d5c978667035ede8$export$cf04576cc11b2f1d = $d5c978667035ede8$export$e76dad090f952455 = $d5c978667035ede8$export$c211d82ee3134c96 = void 0;

var $d5c978667035ede8$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $d5c978667035ede8$var$_config = $1jnue((parcelRequire("9hEyy")));

var $6zLPD = parcelRequire("6zLPD");

var $7s4Ap = parcelRequire("7s4Ap");
// eslint-disable-next-line import/no-cycle
const { HOST: $d5c978667035ede8$var$HOST, HOST_DELEDGE: // HOST_PARTNER,
$d5c978667035ede8$var$HOST_DELEDGE, HOST_STORE_LOCATIONS: $d5c978667035ede8$var$HOST_STORE_LOCATIONS, RESOURCE_AUTH: // HOST_STORE_VIEWS,
$d5c978667035ede8$var$RESOURCE_AUTH, RESOURCE_MARKDOWNS: $d5c978667035ede8$var$RESOURCE_MARKDOWNS, RESOURCE_PROMOTIONS: $d5c978667035ede8$var$RESOURCE_PROMOTIONS, RESOURCE_SCS: $d5c978667035ede8$var$RESOURCE_SCS, RESOURCE_STOCK_ON_HAND: $d5c978667035ede8$var$RESOURCE_STOCK_ON_HAND, RESOURCE_STORE_LOCATIONS: $d5c978667035ede8$var$RESOURCE_STORE_LOCATIONS, RESOURCE_CSV_UPLOAD: // RESOURCE_STORE_VIEWS,
// RESOURCE_PARTNER_PROMOTIONS,
$d5c978667035ede8$var$RESOURCE_CSV_UPLOAD, oktaRedirectURI: $d5c978667035ede8$var$oktaRedirectURI, oktaClientID: $d5c978667035ede8$var$oktaClientID, oktaAegisHost: $d5c978667035ede8$var$oktaAegisHost, oktaTokenResource: $d5c978667035ede8$var$oktaTokenResource } = (0, $d5c978667035ede8$var$_config.default)();
const $d5c978667035ede8$var$OktaException = (message)=>({
        message: message,
        name: "OktaException"
    });
$d5c978667035ede8$export$c211d82ee3134c96 = $d5c978667035ede8$var$OktaException;
const $d5c978667035ede8$var$getPromotion = async (promotionId)=>(0, $7s4Ap.get)(await $d5c978667035ede8$var$_Auth.default.confirmAuth(), $d5c978667035ede8$var$HOST, `${$d5c978667035ede8$var$RESOURCE_PROMOTIONS}/${promotionId}`);
// export const getPartnerPromotion = async (promotionId) => getPartner(await Auth.confirmAuth(), HOST_PARTNER, `${RESOURCE_PARTNER_PROMOTIONS}/${promotionId}`);
$d5c978667035ede8$export$4eb2b7ed40659ce8 = $d5c978667035ede8$var$getPromotion;
const $d5c978667035ede8$var$getPromotions = async (storeId = $d5c978667035ede8$var$_Auth.default.getStoreId())=>(0, $7s4Ap.get)(await $d5c978667035ede8$var$_Auth.default.confirmAuth(), $d5c978667035ede8$var$HOST, $d5c978667035ede8$var$RESOURCE_PROMOTIONS, `?filter=storeId(${storeId})`);
// export const getPartnerPromotions = async (partnerName) => getPartner(await Auth.confirmAuth(), HOST_PARTNER, RESOURCE_PARTNER_PROMOTIONS, `?filter=partnerName(${partnerName})`);
$d5c978667035ede8$export$aea5060850a5a045 = $d5c978667035ede8$var$getPromotions;
const $d5c978667035ede8$var$patchPromotion = async (promotionId, body)=>(0, $7s4Ap.patch)(await $d5c978667035ede8$var$_Auth.default.confirmAuth(), $d5c978667035ede8$var$HOST, `${$d5c978667035ede8$var$RESOURCE_PROMOTIONS}/${promotionId}`, body);
// export const patchPartnerPromotion = async (promotionId, body) => patchPartner(await Auth.confirmAuth(), HOST_PARTNER, `${RESOURCE_PARTNER_PROMOTIONS}/${promotionId}`, body);
$d5c978667035ede8$export$5afc8170e33bc3fd = $d5c978667035ede8$var$patchPromotion;
const $d5c978667035ede8$var$postPromotion = async (body)=>(0, $7s4Ap.post)(await $d5c978667035ede8$var$_Auth.default.confirmAuth(), $d5c978667035ede8$var$HOST, $d5c978667035ede8$var$RESOURCE_PROMOTIONS, (0, $6zLPD.formatPromotionAddBody)(body));
// export const postPartnerPromotion = async (body) => postPartner(await Auth.confirmAuth(), HOST_PARTNER, RESOURCE_PARTNER_PROMOTIONS, formatPartnerPromotionAddBody(body));
$d5c978667035ede8$export$113accaf342c3d43 = $d5c978667035ede8$var$postPromotion;
const $d5c978667035ede8$var$putPromotion = async (body)=>(0, $7s4Ap.put)(await $d5c978667035ede8$var$_Auth.default.confirmAuth(), $d5c978667035ede8$var$HOST, `${$d5c978667035ede8$var$RESOURCE_PROMOTIONS}/${body.id}`, body);
$d5c978667035ede8$export$3664a7b4a9e41b07 = $d5c978667035ede8$var$putPromotion;
const $d5c978667035ede8$var$getStockOnHand = async (storeId = $d5c978667035ede8$var$_Auth.default.getStoreId(), productType, { minimumQuantity: minimumQuantity, maximumQuantity: maximumQuantity })=>(0, $7s4Ap.get)(await $d5c978667035ede8$var$_Auth.default.confirmAuth(), $d5c978667035ede8$var$HOST, $d5c978667035ede8$var$RESOURCE_STOCK_ON_HAND, `?filter=storeId(${storeId})&filter=divisionId(${productType})${minimumQuantity ? `&filter=minimumQuantity(${minimumQuantity})` : ""}${maximumQuantity ? `&filter=maximumQuantity(${maximumQuantity})` : ""}`);
$d5c978667035ede8$export$cae10d02389df77e = $d5c978667035ede8$var$getStockOnHand;
const $d5c978667035ede8$var$getMarkdowns = async (storeId = $d5c978667035ede8$var$_Auth.default.getStoreId())=>(0, $7s4Ap.get)(await $d5c978667035ede8$var$_Auth.default.confirmAuth(), $d5c978667035ede8$var$HOST, $d5c978667035ede8$var$RESOURCE_MARKDOWNS, `?filter=storeId(${storeId})`);
$d5c978667035ede8$export$cf04576cc11b2f1d = $d5c978667035ede8$var$getMarkdowns;
const $d5c978667035ede8$var$postMarkdown = async (body)=>(0, $7s4Ap.post)(await $d5c978667035ede8$var$_Auth.default.confirmAuth(), $d5c978667035ede8$var$HOST, $d5c978667035ede8$var$RESOURCE_MARKDOWNS, (0, $6zLPD.formatMarkdownAddBody)(body));
$d5c978667035ede8$export$2ebec957b123ba7d = $d5c978667035ede8$var$postMarkdown;
const $d5c978667035ede8$var$postCsvUpload = async (data, uploadId, batchNo, isLastBatch)=>(0, $7s4Ap.postCsv)(await $d5c978667035ede8$var$_Auth.default.confirmAuth(), $d5c978667035ede8$var$HOST, $d5c978667035ede8$var$RESOURCE_CSV_UPLOAD, data, uploadId, batchNo, isLastBatch);
/* Authorization */ $d5c978667035ede8$export$2cce2244ce74955d = $d5c978667035ede8$var$postCsvUpload;
const $d5c978667035ede8$var$authUser = async (loginInformation)=>{
    const body = {
        loginInformation: {
            athleteNumber: loginInformation.athleteNumber,
            athletePassword: loginInformation.athletePassword,
            selectedCountry: loginInformation.selectedCountry,
            selectedStore: loginInformation.selectedStore
        },
        refresh: false
    };
    return (0, $7s4Ap.post)(null, $d5c978667035ede8$var$HOST, $d5c978667035ede8$var$RESOURCE_AUTH, body);
};
$d5c978667035ede8$export$e76dad090f952455 = $d5c978667035ede8$var$authUser;
const $d5c978667035ede8$var$reAuthUser = async (accessToken, refreshToken)=>{
    const body = {
        loginInformation: {
            access_token: accessToken,
            refresh_token: refreshToken
        },
        refresh: true
    };
    return (0, $7s4Ap.post)(null, $d5c978667035ede8$var$HOST, $d5c978667035ede8$var$RESOURCE_AUTH, body);
};
/* Store Locations */ $d5c978667035ede8$export$9c1c0821ddc65f6e = $d5c978667035ede8$var$reAuthUser;
const $d5c978667035ede8$var$fetchWithTimeout = async (resource, options)=>{
    const { timeout: timeout = 8000 } = options;
    const controller = new AbortController();
    const id = setTimeout(()=>controller.abort(), timeout);
    const response = await fetch(resource, {
        ...options,
        signal: controller.signal
    });
    clearTimeout(id);
    return response;
};
const $d5c978667035ede8$var$formatStoreData = async (store)=>({
        currency: store.currencies[0],
        id: store.id,
        locale: store.locale,
        region: store.region,
        timezone: store.timezone
    });
// const formatCountries = (storesArr) => {
//   const arr = storesArr.reduce((prevItem, currItem) => {
//     const key = currItem.address.country;
//     if (prevItem[key]) {
//       // eslint-disable-next-line fp/no-mutating-methods
//       prevItem[key].push(currItem.id);
//     } else {
//       // eslint-disable-next-line fp/no-mutation
//       prevItem[key] = [currItem.id];
//     }
//     return prevItem;
//   }, {});
//   return arr;
// };
// SCS promote app config
const $d5c978667035ede8$var$SCS_PROMOTE_KEYS = [
    "promote.createMarkdowns",
    "promote.createPromotions",
    "promote.isStyleUploadEnabled",
    "promote.allowPromoteApp"
];
const $d5c978667035ede8$var$getPromoteConfig = async (country, storeNumber)=>$d5c978667035ede8$var$fetchWithTimeout(`${$d5c978667035ede8$var$HOST_DELEDGE}${$d5c978667035ede8$var$RESOURCE_SCS}/${country}-${storeNumber}?filter=key(${$d5c978667035ede8$var$SCS_PROMOTE_KEYS.toString()})`, {
        headers: {
            Authorization: `Bearer ${await $d5c978667035ede8$var$_Auth.default.confirmAuth()}`
        },
        method: "GET"
    }).then(async (res)=>{
        const scsData = await res.json();
        const promoteObject = scsData.objects.find((obj)=>obj.key === "promote.allowPromoteApp");
        if (!promoteObject) return {
            data: null,
            errorMessage: "Promote App is not available in this store"
        };
        if (promoteObject.value === false && promoteObject.scopeType === "STORE") return {
            data: null,
            errorMessage: "Promote App is not available in this store"
        };
        return {
            data: scsData.objects.reduce((prev, curr)=>{
                prev[curr.key.split(".")[1]] = curr.value;
                return prev;
            }, {}),
            errorMessage: null
        };
    }).catch((err)=>{
        console.error("Error in getPromoteConfig:", err);
        return {
            data: null,
            errorMessage: "Failed to fetch configuration."
        };
    });
$d5c978667035ede8$export$f2800486f94b9664 = $d5c978667035ede8$var$getPromoteConfig;
const $d5c978667035ede8$var$getStore = async (country, storeNumber)=>{
    const queryString = `?search=(address.country==${country} and storeNumber==${storeNumber})&fields=address,currencies,id,locale,name,phone,region,timezone`;
    return fetch(`${$d5c978667035ede8$var$HOST_STORE_LOCATIONS}${$d5c978667035ede8$var$RESOURCE_STORE_LOCATIONS}${queryString}`, {
        method: "GET"
    }).then(async (res)=>{
        if (!res.ok) // eslint-disable-next-line fp/no-throw
        throw await res.json();
        return $d5c978667035ede8$var$formatStoreData((await res.json()).objects[0]);
    });
};
$d5c978667035ede8$export$6fec604aa7293d0c = $d5c978667035ede8$var$getStore;
const $d5c978667035ede8$var$postCodeToOkta = async ()=>{
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search.slice(1));
    const code = searchParams.get("code");
    if (!code) {
        const error = searchParams.get("error") || "Unauthorized";
        // eslint-disable-next-line fp/no-throw
        throw new $d5c978667035ede8$var$OktaException(error);
    }
    const codeVerifier = localStorage.getItem("code_verifier");
    const params = new URLSearchParams();
    params.set("code", code);
    params.set("code_verifier", codeVerifier);
    params.set("grant_type", "authorization_code");
    params.set("redirect_uri", $d5c978667035ede8$var$oktaRedirectURI);
    params.set("client_id", $d5c978667035ede8$var$oktaClientID);
    const options = {
        body: params,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded"
        },
        method: "POST"
    };
    const uri = $d5c978667035ede8$var$oktaAegisHost + $d5c978667035ede8$var$oktaTokenResource;
    return fetch(uri, options).then(async (res)=>{
        if (res.status !== 200) {
            var _res$reasons;
            // eslint-disable-next-line camelcase,fp/no-throw
            throw Error((_res$reasons = res.reasons) === null || _res$reasons === void 0 ? void 0 : _res$reasons.error_description);
        }
        return res.json();
    });
};
/* Store Views */ // export const storeViewsByPartner = async (partner) => {
//   const options = {
//     headers: {
//       Accept: 'application/json',
//       'Content-Type': 'application/x-www-form-urlencoded',
//       'nike-api-caller-id': 'com.nike:test-caller-id',
//     },
//     json: true,
//     method: 'GET',
//     resolveWithFullResponse: true
//   };
//   try {
//     const res = await fetch(`${HOST_STORE_VIEWS}${RESOURCE_STORE_VIEWS}?search=(company==${partner})&fields=id,address.country&count=1000`, options);
//     const result = await res.json();
//     return formatCountries(result.objects);
//   } catch (err) {
//     // eslint-disable-next-line fp/no-throw
//     throw await err.json();
//   }
// };
$d5c978667035ede8$export$49a5c4ee01b58b20 = $d5c978667035ede8$var$postCodeToOkta;

});
parcelRegister("9hEyy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $6c252934bda41dfa$var$_development = $1jnue((parcelRequire("7W3hr")));

var $6c252934bda41dfa$var$_production = $1jnue((parcelRequire("ihOvg")));

var $6c252934bda41dfa$var$_standard = $1jnue((parcelRequire("anvUf")));

var $6c252934bda41dfa$var$_test = $1jnue((parcelRequire("csbVt")));
const $6c252934bda41dfa$var$config = {
    development: $6c252934bda41dfa$var$_development.default,
    production: $6c252934bda41dfa$var$_production.default,
    test: $6c252934bda41dfa$var$_test.default
};
module.exports = ()=>({
        RESOURCE_AUTH: "/store/athlete_jwts/v1",
        RESOURCE_CSV_UPLOAD: "/store/csv_upload/v1",
        RESOURCE_MARKDOWNS: "/store/markdown_definitions/v1",
        // RESOURCE_PARTNER_PROMOTIONS: '/promotions/v1',
        RESOURCE_PROMOTIONS: "/store/promotion_definitions/v1",
        RESOURCE_SCS: "/store/configs/v2/store",
        RESOURCE_STOCK_ON_HAND: "/store/promotion_stock_on_hand/v1",
        RESOURCE_STORE_LOCATIONS: "/store/store_locations/v1",
        RESOURCE_STORE_VIEWS: "/store/store_views/v2",
        ...$6c252934bda41dfa$var$_standard.default,
        ...$6c252934bda41dfa$var$config["test".toLowerCase()]
    });

});
parcelRegister("7W3hr", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"HOST":"https://multiregion-promote-service.rcf-test.nikecloud.com","HOST_DELEDGE":"https://deledge.test.commerce.nikecloud.com","HOST_STORE_LOCATIONS":"https://api-test.nikecloud.com","oktaAuthorizeResource":"/v1/qa/authorize","oktaRedirectURI":"http://localhost:3000/auth","oktaTokenResource":"/v1/qa/token","HOST_STORE_VIEWS":"https://storeviews-regional-us-east-1.risedomain-test.nikecloud.com"}');

});

parcelRegister("ihOvg", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"HOST":"https://multiregion-promote-service.rcf-prod.nikecloud.com","HOST_DELEDGE":"https://deledge.prod.commerce.nikecloud.com","HOST_STORE_LOCATIONS":"https://api.nike.com","oktaAuthorizeResource":"/v1/prod/authorize","oktaTokenResource":"/v1/prod/token","HOST_STORE_VIEWS":"https://storeviews-regional-us-east-1.risedomain-prod.nikecloud.com"}');

});

parcelRegister("anvUf", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"oktaAegisHost":"https://api.aegis.nikecloud.com","oktaClientID":"nike.rcf.promote"}');

});

parcelRegister("csbVt", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"HOST":"https://multiregion-promote-service.rcf-test.nikecloud.com","HOST_DELEDGE":"https://deledge.test.commerce.nikecloud.com","HOST_STORE_LOCATIONS":"https://api-test.nikecloud.com","oktaAuthorizeResource":"/v1/qa/authorize","oktaTokenResource":"/v1/qa/token","HOST_STORE_VIEWS":"https://storeviews-regional-us-east-1.risedomain-test.nikecloud.com"}');

});


parcelRegister("6zLPD", function(module, exports) {
"use strict";

var $e080M = parcelRequire("e080M");
var $4c9b1d6031e12121$require$group = $e080M.group;
var $4c9b1d6031e12121$require$match = $e080M.match;
var $4c9b1d6031e12121$require$sortBy = $e080M.sortBy;
var $4c9b1d6031e12121$require$sort = $e080M.sort;
var $4c9b1d6031e12121$require$_ = $e080M.Default;

var $aTXuQ = parcelRequire("aTXuQ");

var $45fvw = parcelRequire("45fvw");

var $8NWq9 = parcelRequire("8NWq9");

var $auStQ = parcelRequire("auStQ");
var $4c9b1d6031e12121$require$promotionTranslate = $auStQ.promotionTranslate;

var $bEk1s = parcelRequire("bEk1s");
var $4c9b1d6031e12121$require$getLocaleForTranslation = $bEk1s.getLocaleForTranslation;

var $jMcIG = parcelRequire("jMcIG");

var $aHaJN = parcelRequire("aHaJN");

var $30Fb0 = parcelRequire("30Fb0");
var $4c9b1d6031e12121$require$countryInfo = $30Fb0.default;

var $1BuK1 = parcelRequire("1BuK1");
var $4c9b1d6031e12121$require$divisionIDs = $1BuK1.divisionIDs;
var $4c9b1d6031e12121$require$genderIDs = $1BuK1.genderIDs;
const $4c9b1d6031e12121$var$reverseComparator = (left, right)=>$4c9b1d6031e12121$require$match()([
        ()=>left < right,
        1
    ], [
        ()=>left > right,
        -1
    ], [
        $4c9b1d6031e12121$require$_,
        0
    ]);
const $4c9b1d6031e12121$var$formatCurrency = (number, priceFormatOptions)=>{
    // priceFormatOptions should look like the below object for any of the below fields that you want to override
    const defaultCurrency = {
        decimal: ".",
        digitsAfterDecimal: 2,
        thousands: ","
    };
    const { thousands: thousands, decimal: decimal, digitsAfterDecimal: digitsAfterDecimal } = {
        ...defaultCurrency,
        ...priceFormatOptions
    };
    const stringfied = number.toString();
    const dollars = stringfied.length > digitsAfterDecimal ? stringfied.slice(0, stringfied.length - digitsAfterDecimal) : "0";
    const dollarsWithSeparators = dollars.length > 3 ? dollars.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) : dollars;
    if (digitsAfterDecimal) {
        const cents = stringfied.length > digitsAfterDecimal ? stringfied.slice(stringfied.length - digitsAfterDecimal) : stringfied.padStart(digitsAfterDecimal, "0");
        return `${dollarsWithSeparators}${decimal}${cents}`;
    } else return dollarsWithSeparators;
};
const $4c9b1d6031e12121$var$formatDate = (date, format = "YYYY-MM-DD")=>$45fvw(date, "YYYY-MM-DDTHH:mm:ss.SSS").format(format);
const $4c9b1d6031e12121$var$formatPromotionAddBody = ({ discountPercentage: discountPercentage, divisions: divisions, endDate: endDate, genders: genders, itemDetails: itemDetails, name: name, startDate: startDate })=>({
        discountPercentage: discountPercentage,
        divisionIds: [
            ...new Set(...divisions.map(({ value: value })=>value))
        ],
        endDateTime: $45fvw(endDate).endOf("day").toISOString(true),
        genderIds: [
            ...new Set(...genders.map(({ value: value })=>value))
        ],
        itemDetails: itemDetails,
        name: name,
        startDateTime: $45fvw(startDate).startOf("day").toISOString(true)
    });
const $4c9b1d6031e12121$var$formatStoreInfo = ()=>({
        storeInfo: {
            id: localStorage.getItem("storeId"),
            locale: localStorage.getItem("storeLocale"),
            region: localStorage.getItem("storeRegion"),
            storeNumber: localStorage.getItem("storeNumber"),
            timezone: localStorage.getItem("storeTimezone")
        }
    });
// const formatPartnerPromotionAddBody = ({
//   discountPercentage, divisions, endDate, genders, itemDetails, name, startDate, country, storesList, partnerName
// }) => ({
//   country,
//   discountPercentage,
//   divisionIds: [...(new Set(...divisions.map(({ value }) => value)))],
//   endDateTime: moment(endDate).endOf('day').toISOString(true),
//   genderIds: [...(new Set(...genders.map(({ value }) => value)))],
//   itemDetails,
//   name,
//   partnerName,
//   startDateTime: moment(startDate).startOf('day').toISOString(true),
//   storesList
// });
const $4c9b1d6031e12121$var$formatPromotionPatchAddItems = (items)=>items.map((value)=>({
            op: "add",
            path: "/itemDetails",
            value: value
        }));
const $4c9b1d6031e12121$var$formatPromotionPatchDeleteItems = (items)=>items.map(({ productId: productId, ...rest })=>({
            op: "remove",
            path: "/itemDetails",
            value: {
                ...rest,
                id: productId
            }
        }));
// const formatPartnerPromotionPatchDeleteItems = (items) => items.map(({ styleColor, ...rest }) => ({ op: 'remove', path: '/itemDetails', value: { ...rest, styleColor } }));
const $4c9b1d6031e12121$var$formatPromotionPatchUpdate = (path, value)=>({
        op: "replace",
        path: `/${path}`,
        value: value
    });
const $4c9b1d6031e12121$var$setKeyToStyleColor = ({ styleColor: styleColor })=>styleColor;
const $4c9b1d6031e12121$var$setValueToFullItem = (i)=>i;
// startDateTime will exist for markdowns, but not for promotions, which is okay
const $4c9b1d6031e12121$var$takeNewestStyleColorItem = (styleColorArray)=>$4c9b1d6031e12121$require$sortBy(styleColorArray, ({ startDateTime: startDateTime })=>startDateTime)[styleColorArray.length - 1];
const $4c9b1d6031e12121$var$getUniqueItems = (items)=>Object.values($4c9b1d6031e12121$require$group(items, $4c9b1d6031e12121$var$setKeyToStyleColor, $4c9b1d6031e12121$var$setValueToFullItem, $4c9b1d6031e12121$var$takeNewestStyleColorItem));
const $4c9b1d6031e12121$var$formatPromotions = (promotions)=>$aHaJN(promotions).map((p)=>({
            ...p,
            divisions: new Set([
                ...p.divisionIds
            ].map((id)=>$4c9b1d6031e12121$require$divisionIDs[id])),
            endDate: $4c9b1d6031e12121$var$formatDate($45fvw(p.endDateTime), "l"),
            genders: new Set([
                ...p.genderIds
            ].map((id)=>$4c9b1d6031e12121$require$genderIDs[id])),
            itemDetails: $4c9b1d6031e12121$require$sortBy($4c9b1d6031e12121$var$getUniqueItems(p.itemDetails || []), ({ createDateTime: createDateTime })=>createDateTime, $4c9b1d6031e12121$var$reverseComparator),
            startDate: $4c9b1d6031e12121$var$formatDate($45fvw(p.startDateTime), "l")
        }));
const $4c9b1d6031e12121$var$sortStockOnHand = (soh, sohSortDirection)=>$aTXuQ(soh, [
        "stockOnHand",
        "name"
    ], [
        sohSortDirection,
        "asc"
    ]);
const $4c9b1d6031e12121$var$formatStockOnHand = (soh, sohSortDirection)=>$4c9b1d6031e12121$var$sortStockOnHand(soh.map((s)=>s.error ? {
            ...s.itemDetails,
            error: s.error
        } : {
            ...s.itemDetails,
            promotionIds: s.promotionIds,
            stockOnHand: s.stockOnHand
        }), sohSortDirection);
const $4c9b1d6031e12121$var$groupSOHByPromotionId = (sohProducts)=>sohProducts.reduce((map, { gtin: gtin, productId: productId, promotionIds: promotionIds, styleColor: styleColor })=>({
            // result looks like { [promotionId]: [product1, product2]} where a product contains ONLY { gtin, id, styleColor }
            ...map,
            ...promotionIds === null || promotionIds === void 0 ? void 0 : promotionIds.reduce((mapSegment, promotionId)=>({
                    ...mapSegment,
                    // note: gtin will only be defined if the item was scanned and not added manually
                    [promotionId]: [
                        ...(map === null || map === void 0 ? void 0 : map[promotionId]) || [],
                        {
                            gtin: gtin,
                            productId: productId,
                            styleColor: styleColor
                        }
                    ]
                }), map)
        }), {});
const $4c9b1d6031e12121$var$formatMarkdownAddBody = ({ price: price, startDate: startDate, styleColor: styleColor, gtin: gtin })=>({
        itemDetails: {
            gtin: gtin,
            markdownPrice: price,
            startDateTime: $45fvw(startDate).startOf("day").toISOString(),
            styleColor: styleColor
        }
    });
// Sort markdown list by start date, break ties by create date
const $4c9b1d6031e12121$var$sortByStartDate = (markdownA, markdownB)=>{
    const markdownAStart = markdownA.startDateTime || markdownA.upcomingMarkdown.startDateTime;
    const markdownBStart = markdownB.startDateTime || markdownB.upcomingMarkdown.startDateTime;
    if ($45fvw(markdownAStart) > $45fvw(markdownBStart)) return 1;
    else if ($45fvw(markdownAStart) < $45fvw(markdownBStart)) return -1;
    else {
        const markdownACreated = markdownA.createDateTime || markdownA.upcomingMarkdown.createDateTime;
        const markdownBCreated = markdownB.createDateTime || markdownB.upcomingMarkdown.createDateTime;
        return $45fvw(markdownACreated) >= $45fvw(markdownBCreated) ? 1 : -1;
    }
};
const $4c9b1d6031e12121$var$formatActiveMarkdown = (markdown, priceFormat)=>({
        ...markdown.itemDetails,
        id: markdown.id,
        markdownPrice: $8NWq9(markdown.itemDetails.markdownPrice).format(priceFormat),
        startDate: $4c9b1d6031e12121$var$formatDate($45fvw(markdown.itemDetails.startDateTime), "l")
    });
const $4c9b1d6031e12121$var$formatUpcomingMarkdown = (futureMarkdown, activeMarkdown, priceFormat)=>{
    const { name: name, productId: productId, styleColor: styleColor, startDateTime: startDateTime, createDateTime: createDateTime, markdownPrice: markdownPrice } = futureMarkdown.itemDetails;
    return {
        ...activeMarkdown,
        name: name,
        productId: productId,
        styleColor: styleColor,
        upcomingMarkdown: {
            createDateTime: createDateTime,
            id: futureMarkdown.id,
            markdownPrice: $8NWq9(markdownPrice).format(priceFormat),
            startDate: $4c9b1d6031e12121$var$formatDate($45fvw(startDateTime), "l"),
            startDateTime: startDateTime
        }
    };
};
/*
 * Get the nearest past and future markdown to today:
 * Past <---x----A-- Present --U----x---> Future
 * A = Active and U = Upcoming
 * x = Ended or future markdowns (don't display info about these)
 *
 * Because the incoming markdowns are in sorted order, we discard any markdowns from the past
 * that are duplicates (replace with more recent 'Active' markdown). The first future markdown
 * with the same style color is saved as the upcoming markdown.
*/ const $4c9b1d6031e12121$var$groupActiveAndFutureMarkdowns = (markdowns, priceFormat)=>{
    const sortedMarkdowns = $4c9b1d6031e12121$require$sort(markdowns, (a, b)=>$4c9b1d6031e12121$var$sortByStartDate(a.itemDetails, b.itemDetails));
    return sortedMarkdowns.reduce((markdownsByStyleColor, markdown)=>{
        const { styleColor: styleColor, startDateTime: startDateTime } = markdown.itemDetails;
        if ($45fvw(startDateTime) <= $45fvw()) // Markdown is in the past:
        return {
            ...markdownsByStyleColor,
            [styleColor]: $4c9b1d6031e12121$var$formatActiveMarkdown(markdown, priceFormat)
        };
        else if (!markdownsByStyleColor[styleColor] || markdownsByStyleColor[styleColor] && !markdownsByStyleColor[styleColor].upcomingMarkdown) // Markdown is in the future:
        return {
            ...markdownsByStyleColor,
            [styleColor]: $4c9b1d6031e12121$var$formatUpcomingMarkdown(markdown, markdownsByStyleColor[styleColor], priceFormat)
        };
        else return markdownsByStyleColor;
    }, {});
};
const $4c9b1d6031e12121$var$formatMarkdowns = (markdowns, country)=>{
    var _countryInfo$country;
    const currency = (_countryInfo$country = $4c9b1d6031e12121$require$countryInfo[country]) === null || _countryInfo$country === void 0 ? void 0 : _countryInfo$country.currency;
    const defaultCurrency = {
        decimal: ".",
        digitsAfterDecimal: 2,
        postfix: "",
        prefix: "",
        thousands: ","
    };
    const { thousands: thousands, decimal: decimal, digitsAfterDecimal: digitsAfterDecimal, prefix: prefix, postfix: postfix } = {
        ...defaultCurrency,
        ...currency
    };
    const customLocaleName = `custom-${country}`;
    try {
        $8NWq9.register("locale", customLocaleName, {
            currency: {
                symbol: prefix || postfix
            },
            delimiters: {
                decimal: decimal,
                thousands: thousands
            }
        });
    } catch  {
    // do nothing, we've already registered the locale
    }
    $8NWq9.locale(customLocaleName);
    const priceFormat = `${prefix ? "$ " : ""}0,0${digitsAfterDecimal ? "." : "[.]"}${"0".repeat(digitsAfterDecimal)}${postfix ? " $" : ""}`;
    const activeAndFutureMarkdowns = $4c9b1d6031e12121$var$groupActiveAndFutureMarkdowns(markdowns, priceFormat);
    return $4c9b1d6031e12121$require$sort(Object.values(activeAndFutureMarkdowns), (a, b)=>$4c9b1d6031e12121$var$sortByStartDate(a, b));
};
const $4c9b1d6031e12121$var$formatUniqueString = (iterable)=>[
        ...new Set(iterable)
    ].join(", ");
const $4c9b1d6031e12121$var$handleErrorMessage = (error, submittedItems)=>{
    const locale = $4c9b1d6031e12121$require$getLocaleForTranslation($jMcIG.default.getState());
    if (submittedItems) {
        const setSubmittedItems = new Set(submittedItems);
        const successfulNewItems = (error.itemDetails || []).map(({ gtin: gtin, styleColor: styleColor })=>gtin || styleColor).filter((item)=>setSubmittedItems.has(item));
        const successMessage = successfulNewItems.length ? $4c9b1d6031e12121$require$promotionTranslate(successfulNewItems.length === 1 ? "RL_ProductAddSuccess3" : "RL_ProductAddSuccess4", locale, successfulNewItems.length) : "";
        const errorMessage = error.errors.length === 1 ? $4c9b1d6031e12121$require$promotionTranslate("RL_ProductAddError1", locale, $4c9b1d6031e12121$var$formatUniqueString(error.errors.map(({ gtin: gtin, message: message, styleColor: styleColor })=>` ** ${styleColor || gtin} (${message})`))) : $4c9b1d6031e12121$require$promotionTranslate("RL_ProductAddError2", locale, error.errors.length, $4c9b1d6031e12121$var$formatUniqueString(error.errors.map(({ gtin: gtin, message: message, styleColor: styleColor })=>` ** ${styleColor || gtin} (${message})`)));
        return {
            errorMessage: errorMessage,
            successMessage: successMessage
        };
    }
    const errorMessage = error.message === "Forbidden" ? $4c9b1d6031e12121$require$promotionTranslate("RL_ProductAddError3", locale) : error.message;
    return error.message !== "Bad Request" && error.message !== "Forbidden" ? $4c9b1d6031e12121$require$promotionTranslate("RL_ProductAddError4", locale, errorMessage) : $4c9b1d6031e12121$require$promotionTranslate("RL_ProductAddError5", locale, errorMessage, $4c9b1d6031e12121$var$formatUniqueString(error.errors && error.errors.map(({ message: message })=>message)));
};
const $4c9b1d6031e12121$var$handleResponse = (setSuccess, successValue, setError, errorValue)=>{
    setSuccess(successValue);
    return setError(errorValue);
};
const $4c9b1d6031e12121$var$isGTIN = (value)=>/^[0-9]{14}$/.test(value);
const $4c9b1d6031e12121$var$isNumber = (value)=>/^[0-9]*$/.test(value);
const $4c9b1d6031e12121$var$isStyleColor = (value)=>/^[A-Za-z0-9]{5,6}-[A-Za-z0-9]{3}$/.test(value);
module.exports = {
    formatCurrency: $4c9b1d6031e12121$var$formatCurrency,
    formatDate: $4c9b1d6031e12121$var$formatDate,
    formatMarkdownAddBody: $4c9b1d6031e12121$var$formatMarkdownAddBody,
    formatMarkdowns: $4c9b1d6031e12121$var$formatMarkdowns,
    formatPromotionAddBody: // formatPartnerPromotionAddBody,
    // formatPartnerPromotionPatchDeleteItems,
    $4c9b1d6031e12121$var$formatPromotionAddBody,
    formatPromotionPatchAddItems: $4c9b1d6031e12121$var$formatPromotionPatchAddItems,
    formatPromotionPatchDeleteItems: $4c9b1d6031e12121$var$formatPromotionPatchDeleteItems,
    formatPromotionPatchUpdate: $4c9b1d6031e12121$var$formatPromotionPatchUpdate,
    formatPromotions: $4c9b1d6031e12121$var$formatPromotions,
    formatStockOnHand: $4c9b1d6031e12121$var$formatStockOnHand,
    formatStoreInfo: $4c9b1d6031e12121$var$formatStoreInfo,
    formatUniqueString: $4c9b1d6031e12121$var$formatUniqueString,
    groupSOHByPromotionId: $4c9b1d6031e12121$var$groupSOHByPromotionId,
    handleErrorMessage: $4c9b1d6031e12121$var$handleErrorMessage,
    handleResponse: $4c9b1d6031e12121$var$handleResponse,
    isGTIN: $4c9b1d6031e12121$var$isGTIN,
    isNumber: $4c9b1d6031e12121$var$isNumber,
    isStyleColor: $4c9b1d6031e12121$var$isStyleColor,
    sortStockOnHand: $4c9b1d6031e12121$var$sortStockOnHand
};

});
parcelRegister("e080M", function(module, exports) {









module.exports = {
    ...(parcelRequire("eXLGK")),
    ...(parcelRequire("ecl4r")),
    ...(parcelRequire("3htoL")),
    ...(parcelRequire("gIi26")),
    ...(parcelRequire("d7xWY")),
    ...(parcelRequire("jzlES")),
    ...(parcelRequire("lYrhP")),
    ...(parcelRequire("b9yfs")),
    ...(parcelRequire("cyoAd"))
};

});
parcelRegister("eXLGK", function(module, exports) {
const $ae4b914cf6367e96$var$isNull = (v)=>v === undefined || v === null;
const $ae4b914cf6367e96$var$noOp = ()=>{};
const $ae4b914cf6367e96$var$checkMaybe = (possiblyMaybe)=>{
    if (possiblyMaybe instanceof $ae4b914cf6367e96$var$Maybe) return possiblyMaybe;
    else throw new Error("Expected Maybe type");
};
class $ae4b914cf6367e96$var$Maybe {
    constructor(value){
        this.value = value;
    }
    isNone() {
        return $ae4b914cf6367e96$var$isNull(this.value);
    }
    isSome() {
        return !this.isNone();
    }
    get() {
        if (this.isSome()) return this.value;
        else throw new Error("Expected Some type");
    }
    orElse(anotherValue) {
        return this.isSome() ? this.value : anotherValue;
    }
    orElseGet(anotherValueSupplier) {
        return this.isSome() ? this.value : anotherValueSupplier();
    }
    map(f) {
        return this.isSome() ? $ae4b914cf6367e96$var$Maybe.of(f(this.value)) : this;
    }
    flatMap(f) {
        return this.isSome() ? $ae4b914cf6367e96$var$checkMaybe(f(this.value)) : this;
    }
    filter(test) {
        return this.isSome() && test(this.value) ? this : $ae4b914cf6367e96$var$Maybe.none();
    }
    peek(someConsumer, noneConsumer = $ae4b914cf6367e96$var$noOp) {
        if (this.isSome()) someConsumer(this.value);
        else noneConsumer();
        return this;
    }
    orElseThrow(errorSupplier) {
        if (this.isSome()) return this.value;
        else throw errorSupplier();
    }
    static of(value) {
        return new $ae4b914cf6367e96$var$Maybe(value);
    }
    static maybeOf(value) {
        return $ae4b914cf6367e96$var$Maybe.of(value);
    }
    static none() {
        return $ae4b914cf6367e96$var$Maybe.of();
    }
    static maybeNone() {
        return $ae4b914cf6367e96$var$Maybe.none();
    }
    static ofTry(expr, errorConsumer = $ae4b914cf6367e96$var$noOp) {
        try {
            return $ae4b914cf6367e96$var$Maybe.of(expr());
        } catch (err) {
            errorConsumer(err);
            return $ae4b914cf6367e96$var$Maybe.none();
        }
    }
}
module.exports = {
    Maybe: $ae4b914cf6367e96$var$Maybe
};

});

parcelRegister("ecl4r", function(module, exports) {

var $eXLGK = parcelRequire("eXLGK");
var $a56287d76d819fca$require$Maybe = $eXLGK.Maybe;
const $a56287d76d819fca$var$checkEither = (possiblyEither)=>{
    if (possiblyEither instanceof $a56287d76d819fca$var$Either) return possiblyEither;
    else throw new Error("Expected Either type");
};
const $a56287d76d819fca$var$noOp = ()=>{};
class $a56287d76d819fca$var$Either {
    constructor(isRight, value){
        this.m_isRight = isRight;
        this.m_value = value;
    }
    isRight() {
        return this.m_isRight;
    }
    isLeft() {
        return !this.isRight();
    }
    getRight() {
        if (this.isRight()) return this.m_value;
        else throw new Error("Expected Right type");
    }
    get() {
        return this.getRight();
    }
    getLeft() {
        if (this.isLeft()) return this.m_value;
        else throw new Error("Expected Left type");
    }
    toMaybe() {
        return this.isRight() ? $a56287d76d819fca$require$Maybe.of(this.m_value) : $a56287d76d819fca$require$Maybe.none();
    }
    map(f) {
        return this.isRight() ? $a56287d76d819fca$var$Either.right(f(this.m_value)) : this;
    }
    mapLeft(f) {
        return this.isLeft() ? $a56287d76d819fca$var$Either.left(f(this.m_value)) : this;
    }
    flatMap(f) {
        return this.isRight() ? $a56287d76d819fca$var$checkEither(f(this.m_value)) : this;
    }
    flatMapLeft(f) {
        return this.isLeft() ? $a56287d76d819fca$var$checkEither(f(this.m_value)) : this;
    }
    peek(rightConsumer, leftConsumer = $a56287d76d819fca$var$noOp) {
        if (this.isRight()) rightConsumer(this.m_value);
        else leftConsumer(this.m_value);
        return this;
    }
    peekLeft(leftConsumer) {
        return this.peek($a56287d76d819fca$var$noOp, leftConsumer);
    }
    orElse(anotherValue) {
        return this.isRight() ? this.m_value : anotherValue;
    }
    orElseGet(anotherValueSupplier) {
        return this.isRight() ? this.m_value : anotherValueSupplier();
    }
    fold(leftTransformer, rightTransformer) {
        return this.isRight() ? rightTransformer(this.m_value) : leftTransformer(this.m_value);
    }
    swap() {
        if (this.isRight()) return $a56287d76d819fca$var$Either.left(this.m_value);
        else return $a56287d76d819fca$var$Either.right(this.m_value);
    }
    orElseThrow(f) {
        if (this.isRight()) return this.m_value;
        else throw f(this.m_value);
    }
    static right(value) {
        return new $a56287d76d819fca$var$Either(true, value);
    }
    static eitherRight(value) {
        return $a56287d76d819fca$var$Either.right(value);
    }
    static left(value) {
        return new $a56287d76d819fca$var$Either(false, value);
    }
    static eitherLeft(value) {
        return $a56287d76d819fca$var$Either.left(value);
    }
    static ofTry(expr) {
        try {
            const value = expr();
            return $a56287d76d819fca$var$Either.right(value);
        } catch (err) {
            return $a56287d76d819fca$var$Either.left(err);
        }
    }
}
module.exports = {
    Either: $a56287d76d819fca$var$Either
};

});

parcelRegister("3htoL", function(module, exports) {
const $2639c3868e54d9f8$var$isFunction = (o)=>o instanceof Function;
const $2639c3868e54d9f8$var$isEqual = (l)=>(r)=>l === r;
const $2639c3868e54d9f8$var$predicate = (literalOrPredicate)=>$2639c3868e54d9f8$var$isFunction(literalOrPredicate) ? literalOrPredicate : $2639c3868e54d9f8$var$isEqual(literalOrPredicate);
const $2639c3868e54d9f8$var$testPredicate = (arg, valueOrPredicate)=>$2639c3868e54d9f8$var$predicate(valueOrPredicate)(arg);
const $2639c3868e54d9f8$var$expression = (literalOrExpression)=>$2639c3868e54d9f8$var$isFunction(literalOrExpression) ? literalOrExpression : ()=>literalOrExpression;
const $2639c3868e54d9f8$var$applyExpression = (arg, literalOrExpression)=>$2639c3868e54d9f8$var$expression(literalOrExpression)(arg);
const $2639c3868e54d9f8$var$defaultAccumulator = {
    isDefault: true
};
const $2639c3868e54d9f8$var$reducer = (arg)=>(acc, caseTuple)=>acc === $2639c3868e54d9f8$var$defaultAccumulator && $2639c3868e54d9f8$var$testPredicate(arg, caseTuple[0]) ? {
            isDefault: false,
            transformerValue: $2639c3868e54d9f8$var$applyExpression(arg, caseTuple[1])
        } : acc;
const $2639c3868e54d9f8$var$of = (arg)=>(...caseTuples)=>caseTuples.reduce($2639c3868e54d9f8$var$reducer(arg), $2639c3868e54d9f8$var$defaultAccumulator).transformerValue;
const $2639c3868e54d9f8$var$match = (arg)=>$2639c3868e54d9f8$var$of(arg);
const $2639c3868e54d9f8$var$Default = ()=>true;
module.exports = {
    match: $2639c3868e54d9f8$var$match,
    Default: $2639c3868e54d9f8$var$Default
};

});

parcelRegister("gIi26", function(module, exports) {

var $eXLGK = parcelRequire("eXLGK");
var $c2aebe5969052902$require$Maybe = $eXLGK.Maybe;
const $c2aebe5969052902$var$reducer = (keyExtractor, valueExtractor)=>(acc, value)=>{
        const key = keyExtractor(value);
        const newValues = [
            ...acc[key] || [],
            valueExtractor(value)
        ];
        return {
            ...acc,
            [key]: newValues
        };
    };
const $c2aebe5969052902$var$finish = (grouping, finisher)=>Object.entries(grouping).reduce((acc, [key, group])=>({
            ...acc,
            [key]: finisher(group)
        }), {});
const $c2aebe5969052902$var$group = (items, keyExtractor = (k)=>k, valueExtractor = (v)=>v, finisher)=>{
    const grouping = items.reduce($c2aebe5969052902$var$reducer(keyExtractor, valueExtractor), {});
    return $c2aebe5969052902$require$Maybe.of(finisher).map(()=>$c2aebe5969052902$var$finish(grouping, finisher)).orElse(grouping);
};
module.exports = {
    group: $c2aebe5969052902$var$group
};

});

parcelRegister("d7xWY", function(module, exports) {

var $ikZ7K = parcelRequire("ikZ7K");
var $98d6439ecd9358c6$require$Map = $ikZ7K.Map;

var $eXLGK = parcelRequire("eXLGK");
var $98d6439ecd9358c6$require$Maybe = $eXLGK.Maybe;
const $98d6439ecd9358c6$var$copy = (o, ...mutations)=>mutations.reduce((acc, [path, value])=>$98d6439ecd9358c6$require$Maybe.of(value).map((v)=>acc.setIn(path, v)).orElseGet(()=>acc.deleteIn(path)), $98d6439ecd9358c6$require$Map(o)).toJS();
module.exports = {
    copy: $98d6439ecd9358c6$var$copy
};

});
parcelRegister("ikZ7K", function(module, exports) {

$parcel$export(module.exports, "Map", () => Map);
$parcel$export(module.exports, "List", () => List);
/**
 * MIT License
 * 
 * Copyright (c) 2014-present, Lee Byron and other contributors.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var DELETE = "delete";
// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
function MakeRef() {
    return {
        value: false
    };
}
function SetRef(ref) {
    if (ref) ref.value = true;
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}
function ensureSize(iter) {
    if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
    return iter.size;
}
function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== "number") {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ("" + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
}
function returnTrue() {
    return true;
}
function wholeSlice(begin, end, size) {
    return (begin === 0 && !isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
}
function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
}
function resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
var IS_COLLECTION_SYMBOL = "@@__IMMUTABLE_ITERABLE__@@";
function isCollection(maybeCollection) {
    return Boolean(maybeCollection && maybeCollection[IS_COLLECTION_SYMBOL]);
}
var IS_KEYED_SYMBOL = "@@__IMMUTABLE_KEYED__@@";
function isKeyed(maybeKeyed) {
    return Boolean(maybeKeyed && maybeKeyed[IS_KEYED_SYMBOL]);
}
var IS_INDEXED_SYMBOL = "@@__IMMUTABLE_INDEXED__@@";
function isIndexed(maybeIndexed) {
    return Boolean(maybeIndexed && maybeIndexed[IS_INDEXED_SYMBOL]);
}
function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}
var Collection = function Collection(value) {
    // eslint-disable-next-line no-constructor-return
    return isCollection(value) ? value : Seq(value);
};
var KeyedCollection = /*@__PURE__*/ function(Collection) {
    function KeyedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}(Collection);
var IndexedCollection = /*@__PURE__*/ function(Collection) {
    function IndexedCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}(Collection);
var SetCollection = /*@__PURE__*/ function(Collection) {
    function SetCollection(value) {
        // eslint-disable-next-line no-constructor-return
        return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}(Collection);
Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;
var IS_SEQ_SYMBOL = "@@__IMMUTABLE_SEQ__@@";
function isSeq(maybeSeq) {
    return Boolean(maybeSeq && maybeSeq[IS_SEQ_SYMBOL]);
}
var IS_RECORD_SYMBOL = "@@__IMMUTABLE_RECORD__@@";
function isRecord(maybeRecord) {
    return Boolean(maybeRecord && maybeRecord[IS_RECORD_SYMBOL]);
}
function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}
var IS_ORDERED_SYMBOL = "@@__IMMUTABLE_ORDERED__@@";
function isOrdered(maybeOrdered) {
    return Boolean(maybeOrdered && maybeOrdered[IS_ORDERED_SYMBOL]);
}
var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;
var REAL_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = "@@iterator";
var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
var Iterator = function Iterator(next) {
    this.next = next;
};
Iterator.prototype.toString = function toString() {
    return "[Iterator]";
};
Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;
Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
    return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function() {
    return this;
};
function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [
        k,
        v
    ];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
    };
    return iteratorResult;
}
function iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function hasIterator(maybeIterable) {
    if (Array.isArray(maybeIterable)) // IE11 trick as it does not support `Symbol.iterator`
    return true;
    return !!getIteratorFn(maybeIterable);
}
function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === "function";
}
function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function getIteratorFn(iterable) {
    var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === "function") return iteratorFn;
}
function isEntriesIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.entries;
}
function isKeysIterable(maybeIterable) {
    var iteratorFn = getIteratorFn(maybeIterable);
    return iteratorFn && iteratorFn === maybeIterable.keys;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isArrayLike(value) {
    if (Array.isArray(value) || typeof value === "string") return true;
    return value && typeof value === "object" && Number.isInteger(value.length) && value.length >= 0 && (value.length === 0 ? Object.keys(value).length === 1 : // in the array-like may be found (which could be undefined).
    value.hasOwnProperty(value.length - 1));
}
var Seq = /*@__PURE__*/ function(Collection) {
    function Seq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isImmutable(value) ? value.toSeq() : seqFromValue(value);
    }
    if (Collection) Seq.__proto__ = Collection;
    Seq.prototype = Object.create(Collection && Collection.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString("Seq {", "}");
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new Iterator(function() {
                if (i === size) return iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}(Collection);
var KeyedSeq = /*@__PURE__*/ function(Seq) {
    function KeyedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence().toKeyedSeq() : isCollection(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}(Seq);
var IndexedSeq = /*@__PURE__*/ function(Seq) {
    function IndexedSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySequence() : isCollection(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : isRecord(value) ? value.toSeq().entrySeq() : indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString("Seq [", "]");
    };
    return IndexedSeq;
}(Seq);
var SetSeq = /*@__PURE__*/ function(Seq) {
    function SetSeq(value) {
        // eslint-disable-next-line no-constructor-return
        return (isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}(Seq);
Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;
Seq.prototype[IS_SEQ_SYMBOL] = true;
// #pragma Root Sequences
var ArraySeq = /*@__PURE__*/ function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}(IndexedSeq);
var ObjectSeq = /*@__PURE__*/ function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object).concat(Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(object) : []);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}(KeyedSeq);
ObjectSeq.prototype[IS_ORDERED_SYMBOL] = true;
var CollectionSeq = /*@__PURE__*/ function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}(IndexedSeq);
// # pragma Helper functions
var EMPTY_SEQ;
function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}
function keyedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq.fromEntrySeq();
    if (typeof value === "object") return new ObjectSeq(value);
    throw new TypeError("Expected Array or collection object of [k, v] entries, or keyed object: " + value);
}
function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError("Expected Array or collection object of values: " + value);
}
function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return isEntriesIterable(value) ? seq.fromEntrySeq() : isKeysIterable(value) ? seq.toSetSeq() : seq;
    if (typeof value === "object") return new ObjectSeq(value);
    throw new TypeError("Expected Array or collection object of values, or keyed object: " + value);
}
function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
}
var IS_MAP_SYMBOL = "@@__IMMUTABLE_MAP__@@";
function isMap(maybeMap) {
    return Boolean(maybeMap && maybeMap[IS_MAP_SYMBOL]);
}
function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}
function isValueObject(maybeValue) {
    return Boolean(maybeValue && typeof maybeValue.equals === "function" && typeof maybeValue.hashCode === "function");
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === "function" && typeof valueB.valueOf === "function") {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!(isValueObject(valueA) && isValueObject(valueB) && valueA.equals(valueB));
}
var imul = typeof Math.imul === "function" && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
var defaultValueOf = Object.prototype.valueOf;
function hash(o) {
    if (o == null) return hashNullish(o);
    if (typeof o.hashCode === "function") // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode(o));
    var v = valueOf(o);
    if (v == null) return hashNullish(v);
    switch(typeof v){
        case "boolean":
            // The hash values for built-in constants are a 1 value for each 5-byte
            // shift region expect for the first, which encodes the value. This
            // reduces the odds of a hash collision for these common values.
            return v ? 0x42108421 : 0x42108420;
        case "number":
            return hashNumber(v);
        case "string":
            return v.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(v) : hashString(v);
        case "object":
        case "function":
            return hashJSObj(v);
        case "symbol":
            return hashSymbol(v);
        default:
            if (typeof v.toString === "function") return hashString(v.toString());
            throw new Error("Value type " + typeof v + " cannot be hashed.");
    }
}
function hashNullish(nullish) {
    return nullish === null ? 0x42108422 : /* undefined */ 0x42108423;
}
// Compress arbitrarily large numbers into smi hashes.
function hashNumber(n) {
    if (n !== n || n === Infinity) return 0;
    var hash = n | 0;
    if (hash !== n) hash ^= n * 0xffffffff;
    while(n > 0xffffffff){
        n /= 0xffffffff;
        hash ^= n;
    }
    return smi(hash);
}
function cachedHashString(string) {
    var hashed = stringHashCache[string];
    if (hashed === undefined) {
        hashed = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return smi(hashed);
}
function hashSymbol(sym) {
    var hashed = symbolMap[sym];
    if (hashed !== undefined) return hashed;
    hashed = nextHash();
    symbolMap[sym] = hashed;
    return hashed;
}
function hashJSObj(obj) {
    var hashed;
    if (usingWeakMap) {
        hashed = weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = obj[UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!canDefineProperty) {
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = nextHash();
    if (usingWeakMap) weakMap.set(obj, hashed);
    else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error("Non-extensible objects are not allowed as keys.");
    else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
    else throw new Error("Unable to set a non-enumerable property on object.");
    return hashed;
}
// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = function() {
    try {
        Object.defineProperty({}, "@", {});
        return true;
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
    if (node && node.nodeType > 0) switch(node.nodeType){
        case 1:
            return node.uniqueID;
        case 9:
            return node.documentElement && node.documentElement.uniqueID;
    }
}
function valueOf(obj) {
    return obj.valueOf !== defaultValueOf && typeof obj.valueOf === "function" ? obj.valueOf(obj) : obj;
}
function nextHash() {
    var nextHash = ++_objHashUID;
    if (_objHashUID & 0x40000000) _objHashUID = 0;
    return nextHash;
}
// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === "function";
var weakMap;
if (usingWeakMap) weakMap = new WeakMap();
var symbolMap = Object.create(null);
var _objHashUID = 0;
var UID_HASH_KEY = "__immutablehash__";
if (typeof Symbol === "function") UID_HASH_KEY = Symbol(UID_HASH_KEY);
var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};
var ToKeyedSequence = /*@__PURE__*/ function(KeyedSeq) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq) ToKeyedSequence.__proto__ = KeyedSeq;
    ToKeyedSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1$1 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}(KeyedSeq);
ToKeyedSequence.prototype[IS_ORDERED_SYMBOL] = true;
var ToIndexedSequence = /*@__PURE__*/ function(IndexedSeq) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq) ToIndexedSequence.__proto__ = IndexedSeq;
    ToIndexedSequence.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var i = 0;
        reverse && ensureSize(this);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? this$1$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}(IndexedSeq);
var ToSetSequence = /*@__PURE__*/ function(SetSeq) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq) ToSetSequence.__proto__ = SetSeq;
    ToSetSequence.prototype = Object.create(SetSeq && SetSeq.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}(SetSeq);
var FromEntriesSequence = /*@__PURE__*/ function(KeyedSeq) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq) FromEntriesSequence.__proto__ = KeyedSeq;
    FromEntriesSequence.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedCollection = isCollection(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedCollection = isCollection(entry);
                    return iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}(KeyedSeq);
ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
function flipFactory(collection) {
    var flipSequence = makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function mapFactory(collection, mapper, context) {
    var mappedSequence = makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function reverseFactory(collection, useKeys) {
    var this$1$1 = this;
    var reversedSequence = makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1$1 = this;
        var i = 0;
        reverse && ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1$1.size - ++i : i++, this$1$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        reverse && ensureSize(collection);
        var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return iteratorValue(type, useKeys ? entry[0] : reverse ? this$1$1.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function countByFactory(collection, grouper, context) {
    var groups = Map().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function groupByFactory(collection, grouper, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    }).asImmutable();
}
function partitionFactory(collection, predicate, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = [
        [],
        []
    ];
    collection.__iterate(function(v, k) {
        groups[predicate.call(context, v, k, collection) ? 1 : 0].push(isKeyedIter ? [
            k,
            v
        ] : v);
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    });
}
function sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if (wholeSlice(begin, end, originalSize)) return collection;
    // begin or end can not be resolved if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (typeof originalSize === "undefined" && (begin < 0 || end < 0)) return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && isSeq(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new Iterator(iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return iteratorDone();
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES || step.done) return step;
            if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
            return iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function takeWhileFactory(collection, predicate, context) {
    var takeSequence = makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
            if (!iterating) return iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1$1)) {
                iterating = false;
                return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) return step;
                    if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                    return iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$1$1));
            }while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
function concatFactory(collection, values) {
    var isKeyedCollection = isKeyed(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!isCollection(v)) v = isKeyedCollection ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && isKeyed(singleton) || isIndexed(collection) && isIndexed(singleton)) return singleton;
    }
    var concatSeq = new ArraySeq(iters);
    if (isKeyedCollection) concatSeq = concatSeq.toKeyedSeq();
    else if (!isIndexed(collection)) concatSeq = concatSeq.toSetSeq();
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function(sum, seq) {
        if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) return sum + size;
        }
    }, 0);
    return concatSeq;
}
function flattenFactory(collection, depth, useKeys) {
    var flatSequence = makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && isCollection(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && isCollection(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
            return iteratorDone();
        });
    };
    return flatSequence;
}
function flatMapFactory(collection, mapper, context) {
    var coerce = collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function interposeFactory(collection, separator) {
    var interposedSequence = makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1$1) !== false) && fn(v, iterations++, this$1$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    var isKeyedCollection = isKeyed(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? KeyedSeq(entries) : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}
function maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return maxCompare(comparator, a, b) ? b : a;
    });
}
function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = makeSequence(keyIter);
    var sizes = new ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = Collection(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return iteratorDone();
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function reify(iter, seq) {
    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}
function validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError("Expected [K, V] tuple: " + entry);
}
function collectionClass(collection) {
    return isKeyed(collection) ? KeyedCollection : isIndexed(collection) ? IndexedCollection : SetCollection;
}
function makeSequence(collection) {
    return Object.create((isKeyed(collection) ? KeyedSeq : isIndexed(collection) ? IndexedSeq : SetSeq).prototype);
}
function cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return Seq.prototype.cacheResult.call(this);
}
function defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
    return newArr;
}
function invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function assertNotInfinite(size) {
    invariant(size !== Infinity, "Cannot perform this action with an infinite size.");
}
function coerceKeyPath(keyPath) {
    if (isArrayLike(keyPath) && typeof keyPath !== "string") return keyPath;
    if (isOrdered(keyPath)) return keyPath.toArray();
    throw new TypeError("Invalid keyPath: expected Ordered Collection or Array: " + keyPath);
}
var toString = Object.prototype.toString;
function isPlainObject(value) {
    // The base prototype's toString deals with Argument objects and native namespaces like Math
    if (!value || typeof value !== "object" || toString.call(value) !== "[object Object]") return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    // Iteratively going up the prototype chain is needed for cross-realm environments (differing contexts, iframes, etc)
    var parentProto = proto;
    var nextProto = Object.getPrototypeOf(proto);
    while(nextProto !== null){
        parentProto = nextProto;
        nextProto = Object.getPrototypeOf(parentProto);
    }
    return parentProto === proto;
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function isDataStructure(value) {
    return typeof value === "object" && (isImmutable(value) || Array.isArray(value) || isPlainObject(value));
}
function quoteString(value) {
    try {
        return typeof value === "string" ? JSON.stringify(value) : String(value);
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
function has(collection, key) {
    return isImmutable(collection) ? collection.has(key) : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}
function get(collection, key, notSetValue) {
    return isImmutable(collection) ? collection.get(key, notSetValue) : !has(collection, key) ? notSetValue : typeof collection.get === "function" ? collection.get(key) : collection[key];
}
function shallowCopy(from) {
    if (Array.isArray(from)) return arrCopy(from);
    var to = {};
    for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
    return to;
}
function remove(collection, key) {
    if (!isDataStructure(collection)) throw new TypeError("Cannot update non-data-structure value: " + collection);
    if (isImmutable(collection)) {
        if (!collection.remove) throw new TypeError("Cannot update immutable value without .remove() method: " + collection);
        return collection.remove(key);
    }
    if (!hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = shallowCopy(collection);
    if (Array.isArray(collectionCopy)) collectionCopy.splice(key, 1);
    else delete collectionCopy[key];
    return collectionCopy;
}
function set(collection, key, value) {
    if (!isDataStructure(collection)) throw new TypeError("Cannot update non-data-structure value: " + collection);
    if (isImmutable(collection)) {
        if (!collection.set) throw new TypeError("Cannot update immutable value without .set() method: " + collection);
        return collection.set(key, value);
    }
    if (hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = shallowCopy(collection);
    collectionCopy[key] = value;
    return collectionCopy;
}
function updateIn$1(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = updateInDeeply(isImmutable(collection), collection, coerceKeyPath(keyPath), 0, notSetValue, updater);
    return updatedValue === NOT_SET ? notSetValue : updatedValue;
}
function updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !isDataStructure(existing)) throw new TypeError("Cannot update within non-data-structure value in path [" + keyPath.slice(0, i).map(quoteString) + "]: " + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
    var nextUpdated = updateInDeeply(nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting), nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? remove(existing, key) : set(wasNotSet ? inImmutable ? emptyMap() : {} : existing, key, nextUpdated);
}
function setIn$1(collection, keyPath, value) {
    return updateIn$1(collection, keyPath, NOT_SET, function() {
        return value;
    });
}
function setIn(keyPath, v) {
    return setIn$1(this, keyPath, v);
}
function removeIn(collection, keyPath) {
    return updateIn$1(collection, keyPath, function() {
        return NOT_SET;
    });
}
function deleteIn(keyPath) {
    return removeIn(this, keyPath);
}
function update$1(collection, key, notSetValue, updater) {
    return updateIn$1(collection, [
        key
    ], notSetValue, updater);
}
function update(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : update$1(this, key, notSetValue, updater);
}
function updateIn(keyPath, notSetValue, updater) {
    return updateIn$1(this, keyPath, notSetValue, updater);
}
function merge$1() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeIntoKeyedWith(this, iters);
}
function mergeWith$1(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    if (typeof merger !== "function") throw new TypeError("Invalid merger function: " + merger);
    return mergeIntoKeyedWith(this, iters, merger);
}
function mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.toSeq().size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function(value, key) {
            update$1(collection, key, NOT_SET, function(oldVal) {
                return oldVal === NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
function merge(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeWithSources(collection, sources);
}
function mergeWith(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeWithSources(collection, sources, merger);
}
function mergeDeep$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeDeepWithSources(collection, sources);
}
function mergeDeepWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeDeepWithSources(collection, sources, merger);
}
function mergeDeepWithSources(collection, sources, merger) {
    return mergeWithSources(collection, sources, deepMergerWith(merger));
}
function mergeWithSources(collection, sources, merger) {
    if (!isDataStructure(collection)) throw new TypeError("Cannot merge into non-data-structure value: " + collection);
    if (isImmutable(collection)) return typeof merger === "function" && collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.merge ? collection.merge.apply(collection, sources) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection = isArray ? IndexedCollection : KeyedCollection;
    var mergeItem = isArray ? function(value) {
        // Copy on write
        if (merged === collection) merged = shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection(sources[i]).forEach(mergeItem);
    return merged;
}
function deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return isDataStructure(oldValue) && isDataStructure(newValue) && areMergeable(oldValue, newValue) ? mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
/**
 * It's unclear what the desired behavior is for merging two collections that
 * fall into separate categories between keyed, indexed, or set-like, so we only
 * consider them mergeable if they fall into the same category.
 */ function areMergeable(oldDataStructure, newDataStructure) {
    var oldSeq = Seq(oldDataStructure);
    var newSeq = Seq(newDataStructure);
    // This logic assumes that a sequence can only fall into one of the three
    // categories mentioned above (since there's no `isSetLike()` method).
    return isIndexed(oldSeq) === isIndexed(newSeq) && isKeyed(oldSeq) === isKeyed(newSeq);
}
function mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeDeepWithSources(this, iters);
}
function mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeDeepWithSources(this, iters, merger);
}
function mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeWithSources(m, iters);
    });
}
function mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn$1(this, keyPath, emptyMap(), function(m) {
        return mergeDeepWithSources(m, iters);
    });
}
function withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
function asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}
function asImmutable() {
    return this.__ensureOwner();
}
function wasAltered() {
    return this.__altered;
}
var Map = /*@__PURE__*/ function(KeyedCollection) {
    function Map(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection) Map.__proto__ = KeyedCollection;
    Map.prototype = Object.create(KeyedCollection && KeyedCollection.prototype);
    Map.prototype.constructor = Map;
    Map.of = function of() {
        var keyValues = [], len = arguments.length;
        while(len--)keyValues[len] = arguments[len];
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error("Missing value for key: " + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function toString() {
        return this.__toString("Map {", "}");
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = Collection(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    Map.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(map) {
            map.forEach(function(value, key) {
                map.set(key, mapper.call(context, value, key, this$1$1));
            });
        });
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}(KeyedCollection);
Map.isMap = isMap;
var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SYMBOL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.setIn = setIn;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update;
MapPrototype.updateIn = updateIn;
MapPrototype.merge = MapPrototype.concat = merge$1;
MapPrototype.mergeWith = mergeWith$1;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype["@@transducer/init"] = MapPrototype.asMutable = asMutable;
MapPrototype["@@transducer/step"] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
MapPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
ArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new ArrayMapNode(ownerID, newEntries);
};
var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
};
BitmapIndexedNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === NOT_SET) return this;
    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setAt(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
};
HashArrayMapNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new HashArrayMapNode(ownerID, newCount, newNodes);
};
var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
};
HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
HashCollisionNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var removed = value === NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
ValueNode.prototype.update = function update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    SetRef(didAlter);
    if (removed) {
        SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [
        key,
        value
    ]);
};
// #pragma Iterators
ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var MapIterator = /*@__PURE__*/ function(Iterator) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    if (Iterator) MapIterator.__proto__ = Iterator;
    MapIterator.prototype = Object.create(Iterator && Iterator.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this._stack = this._stack.__prev;
        }
        return iteratorDone();
    };
    return MapIterator;
}(Iterator);
function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
}
function mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_MAP;
function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}
function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === NOT_SET) return map;
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = MakeRef();
        var didAlter = MakeRef();
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}
function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === NOT_SET) return node;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
}
function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
    ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new OwnerID();
    var node = new ValueNode(ownerID, hash(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
var IS_LIST_SYMBOL = "@@__IMMUTABLE_LIST__@@";
function isList(maybeList) {
    return Boolean(maybeList && maybeList[IS_LIST_SYMBOL]);
}
var List = /*@__PURE__*/ function(IndexedCollection) {
    function List(value) {
        var empty = emptyList();
        if (value === undefined || value === null) // eslint-disable-next-line no-constructor-return
        return empty;
        if (isList(value)) // eslint-disable-next-line no-constructor-return
        return value;
        var iter = IndexedCollection(value);
        var size = iter.size;
        if (size === 0) // eslint-disable-next-line no-constructor-return
        return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) // eslint-disable-next-line no-constructor-return
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        // eslint-disable-next-line no-constructor-return
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection) List.__proto__ = IndexedCollection;
    List.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString("List [", "]");
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection(typeof argument !== "string" && hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return setListBounds(this, 0, size);
    };
    List.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        return this.withMutations(function(list) {
            for(var i = 0; i < this$1$1.size; i++)list.set(i, mapper.call(context, list.get(i), i, this$1$1));
        });
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, reverse ? --index : index++, this) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}(IndexedCollection);
List.isList = isList;
var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SYMBOL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update;
ListPrototype.updateIn = updateIn;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype["@@transducer/init"] = ListPrototype.asMutable = asMutable;
ListPrototype["@@transducer/step"] = function(result, arr) {
    return result.push(arr);
};
ListPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
var VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if (index === level ? 1 << level : this.array.length === 0) return this;
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) return new VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var DONE = {};
function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) to = SIZE;
        return function() {
            if (from === to) return DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) to = SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== DONE) return value;
                    values = null;
                }
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            }
        };
    }
}
function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
var EMPTY_LIST;
function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}
function updateList(list, index, value) {
    index = wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef();
    if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    if (didAlter) SetRef(didAlter);
    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new VNode(node ? node.array.slice() : [], ownerID);
}
function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
        }
        return node;
    }
}
function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= 1 << newLevel + SHIFT){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > SHIFT; level -= SHIFT){
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
}
var OrderedMap = /*@__PURE__*/ function(Map) {
    function OrderedMap(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map) OrderedMap.__proto__ = Map;
    OrderedMap.prototype = Object.create(Map && Map.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString("OrderedMap {", "}");
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            this.__altered = true;
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return emptyOrderedMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}(Map);
OrderedMap.isOrderedMap = isOrderedMap;
OrderedMap.prototype[IS_ORDERED_SYMBOL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    omap.__altered = false;
    return omap;
}
var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
}
function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
        // removed
        if (!has) return omap;
        if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        omap.__altered = true;
        return omap;
    }
    return makeOrderedMap(newMap, newList);
}
var IS_STACK_SYMBOL = "@@__IMMUTABLE_STACK__@@";
function isStack(maybeStack) {
    return Boolean(maybeStack && maybeStack[IS_STACK_SYMBOL]);
}
var Stack = /*@__PURE__*/ function(IndexedCollection) {
    function Stack(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyStack() : isStack(value) ? value : emptyStack().pushAll(value);
    }
    if (IndexedCollection) Stack.__proto__ = IndexedCollection;
    Stack.prototype = Object.create(IndexedCollection && IndexedCollection.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString("Stack [", "]");
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && isStack(iter)) return iter;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        if (reverse) return new ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    return Stack;
}(IndexedCollection);
Stack.isStack = isStack;
var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SYMBOL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype["@@transducer/init"] = StackPrototype.asMutable = asMutable;
StackPrototype["@@transducer/step"] = function(result, arr) {
    return result.unshift(arr);
};
StackPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_STACK;
function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}
var IS_SET_SYMBOL = "@@__IMMUTABLE_SET__@@";
function isSet(maybeSet) {
    return Boolean(maybeSet && maybeSet[IS_SET_SYMBOL]);
}
function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!isCollection(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !isAssociative(a);
    if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        if (b.size === undefined) {
            if (typeof a.cacheResult === "function") a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && a.size === bSize;
}
function mixin(ctor, methods) {
    var keyCopier = function(key) {
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
function toJS(value) {
    if (!value || typeof value !== "object") return value;
    if (!isCollection(value)) {
        if (!isDataStructure(value)) return value;
        value = Seq(value);
    }
    if (isKeyed(value)) {
        var result$1 = {};
        value.__iterate(function(v, k) {
            result$1[k] = toJS(v);
        });
        return result$1;
    }
    var result = [];
    value.__iterate(function(v) {
        result.push(toJS(v));
    });
    return result;
}
var Set = /*@__PURE__*/ function(SetCollection) {
    function Set(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection) Set.__proto__ = SetCollection;
    Set.prototype = Object.create(SetCollection && SetCollection.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.intersect.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.union = function union(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.union.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString("Set {", "}");
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.map = function map(mapper, context) {
        var this$1$1 = this;
        // keep track if the set is altered by the map function
        var didChanges = false;
        var newMap = updateSet(this, this._map.mapEntries(function(ref) {
            var v = ref[1];
            var mapped = mapper.call(context, v, v, this$1$1);
            if (mapped !== v) didChanges = true;
            return [
                mapped,
                mapped
            ];
        }, context));
        return didChanges ? newMap : this;
    };
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)if (typeof iters[ii] === "string") set.add(iters[ii]);
            else SetCollection(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}(SetCollection);
Set.isSet = isSet;
var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SYMBOL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype["@@transducer/init"] = SetPrototype.asMutable = asMutable;
SetPrototype["@@transducer/step"] = function(result, arr) {
    return result.add(arr);
};
SetPrototype["@@transducer/result"] = function(obj) {
    return obj.asImmutable();
};
SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;
function updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_SET;
function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var Range = /*@__PURE__*/ function(IndexedSeq) {
    function Range(start, end, step) {
        if (!(this instanceof Range)) // eslint-disable-next-line no-constructor-return
        return new Range(start, end, step);
        invariant(step !== 0, "Cannot step a Range by 0");
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) // eslint-disable-next-line no-constructor-return
            return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq) Range.__proto__ = IndexedSeq;
    Range.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        if (this.size === 0) return "Range []";
        return "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    return Range;
}(IndexedSeq);
var EMPTY_RANGE;
function getIn$1(collection, searchKeyPath, notSetValue) {
    var keyPath = coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        collection = get(collection, keyPath[i++], NOT_SET);
        if (collection === NOT_SET) return notSetValue;
    }
    return collection;
}
function getIn(searchKeyPath, notSetValue) {
    return getIn$1(this, searchKeyPath, notSetValue);
}
function hasIn$1(collection, keyPath) {
    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}
function hasIn(searchKeyPath) {
    return hasIn$1(this, searchKeyPath);
}
function toObject() {
    assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        object[k] = v;
    });
    return object;
}
// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;
Collection.Iterator = Iterator;
mixin(Collection, {
    // ### Conversion to other types
    toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = isKeyed(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
    },
    toObject: toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return "[Collection]";
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return reify(this, concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return is(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
    },
    partition: function partition(predicate, context) {
        return partitionFactory(this, predicate, context);
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? "" + separator : ",";
        var joined = "";
        var isFirst = true;
        this.__iterate(function(v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : "";
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = false;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                returnValue = true;
                return false;
            }
        });
        return returnValue;
    },
    sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator(ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first(notSetValue) {
        return this.find(returnTrue, null, notSetValue);
    },
    flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return is(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: getIn,
    groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
    },
    hasIn: hasIn,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === "function" ? iter : Collection(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === "function" ? iter : Collection(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return is(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
    },
    last: function last(notSetValue) {
        return this.toSeq().reverse().first(notSetValue);
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashCollection(this));
    }
});
var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_COLLECTION_SYMBOL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
    return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;
mixin(KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return reify(this, flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1$1 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1$1 = this;
        return reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1$1);
        }).flip());
    }
});
var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SYMBOL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return quoteString(k) + ": " + quoteString(v);
};
mixin(IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first(notSetValue) {
        return this.get(0, notSetValue);
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },
    interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return Range(0, this.size);
    },
    last: function last(notSetValue) {
        return this.get(-1, notSetValue);
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = arrCopy(arguments);
        collections[0] = this;
        return reify(this, zipWithFactory(this, zipper, collections));
    }
});
var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SYMBOL] = true;
IndexedCollectionPrototype[IS_ORDERED_SYMBOL] = true;
mixin(SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
var SetCollectionPrototype = SetCollection.prototype;
SetCollectionPrototype.has = CollectionPrototype.includes;
SetCollectionPrototype.contains = SetCollectionPrototype.includes;
SetCollectionPrototype.keys = SetCollectionPrototype.values;
// Mixin subclasses
mixin(KeyedSeq, KeyedCollectionPrototype);
mixin(IndexedSeq, IndexedCollectionPrototype);
mixin(SetSeq, SetCollectionPrototype);
// #pragma Helper functions
function reduce(collection, reducer, reduction, context, useFirst, reverse) {
    assertNotInfinite(collection.size);
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function keyMapper(v, k) {
    return k;
}
function entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function not(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}
function neg(predicate) {
    return function() {
        return -predicate.apply(this, arguments);
    };
}
function defaultZipper() {
    return arrCopy(arguments);
}
function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function hashCollection(collection) {
    if (collection.size === Infinity) return 0;
    var ordered = isOrdered(collection);
    var keyed = isKeyed(collection);
    var h = ordered ? 1 : 0;
    var size = collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function(v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + hash(v) | 0;
    } : function(v) {
        h = h + hash(v) | 0;
    });
    return murmurHashOfSize(size, h);
}
function murmurHashOfSize(size, h) {
    h = imul(h, 0xcc9e2d51);
    h = imul(h << 15 | h >>> -15, 0x1b873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85ebca6b);
    h = imul(h ^ h >>> 13, 0xc2b2ae35);
    h = smi(h ^ h >>> 16);
    return h;
}
function hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
var OrderedSet = /*@__PURE__*/ function(Set) {
    function OrderedSet(value) {
        // eslint-disable-next-line no-constructor-return
        return value === undefined || value === null ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set) OrderedSet.__proto__ = Set;
    OrderedSet.prototype = Object.create(Set && Set.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString("OrderedSet {", "}");
    };
    return OrderedSet;
}(Set);
OrderedSet.isOrderedSet = isOrderedSet;
var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SYMBOL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.zipAll = IndexedCollectionPrototype.zipAll;
OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;
function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
}
var PairSorting = {
    LeftThenRight: -1,
    RightThenLeft: 1
};
function throwOnInvalidDefaultValues(defaultValues) {
    if (isRecord(defaultValues)) throw new Error("Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead.");
    if (isImmutable(defaultValues)) throw new Error("Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead.");
    if (defaultValues === null || typeof defaultValues !== "object") throw new Error("Can not call `Record` with a non-object as default values. Use a plain javascript object instead.");
}
var Record = function Record(defaultValues, name) {
    var hasInitialized;
    throwOnInvalidDefaultValues(defaultValues);
    var RecordType = function Record(values) {
        var this$1$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            // Deprecated: left to attempt not to break any external code which
            // relies on a ._name property existing on record instances.
            // Use Record.getDescriptiveName() instead
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ typeof console === "object" && console.warn && console.warn("Cannot define " + recordName(this) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = List().withMutations(function(l) {
            l.setSize(this$1$1._keys.length);
            KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1$1._indices[k], v === this$1$1._defaultValues[k] ? undefined : v);
            });
        });
        return this;
    };
    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    if (name) RecordType.displayName = name;
    // eslint-disable-next-line no-constructor-return
    return RecordType;
};
Record.prototype.toString = function toString() {
    var str = recordName(this) + " { ";
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ", " : "") + k + ": " + quoteString(this.get(k));
    }
    return str + " }";
};
Record.prototype.equals = function equals(other) {
    return this === other || isRecord(other) && recordSeq(this).equals(recordSeq(other));
};
Record.prototype.hashCode = function hashCode() {
    return recordSeq(this).hashCode();
};
// @pragma Access
Record.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
Record.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
Record.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return makeRecord(this, newValues);
    }
    return this;
};
Record.prototype.remove = function remove(k) {
    return this.set(k);
};
Record.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : makeRecord(this, newValues);
};
Record.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
Record.prototype.toSeq = function toSeq() {
    return recordSeq(this);
};
Record.prototype.toJS = function toJS$1() {
    return toJS(this);
};
Record.prototype.entries = function entries() {
    return this.__iterator(ITERATE_ENTRIES);
};
Record.prototype.__iterator = function __iterator(type, reverse) {
    return recordSeq(this).__iterator(type, reverse);
};
Record.prototype.__iterate = function __iterate(fn, reverse) {
    return recordSeq(this).__iterate(fn, reverse);
};
Record.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return makeRecord(this, newValues, ownerID);
};
Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SYMBOL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge$1;
RecordPrototype.mergeWith = mergeWith$1;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn;
RecordPrototype.update = update;
RecordPrototype.updateIn = updateIn;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject = CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
    return this.toString();
};
function makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function recordName(record) {
    return record.constructor.displayName || record.constructor.name || "Record";
}
function recordSeq(record) {
    return keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, "Cannot set on an immutable record.");
                this.set(name, value);
            }
        });
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var Repeat = /*@__PURE__*/ function(IndexedSeq) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) // eslint-disable-next-line no-constructor-return
        return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) // eslint-disable-next-line no-constructor-return
            return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq) Repeat.__proto__ = IndexedSeq;
    Repeat.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return "Repeat []";
        return "Repeat [ " + this._value + " " + this.size + " times ]";
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this._value, reverse ? size - ++i : i++, this) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1$1 = this;
        var size = this.size;
        var i = 0;
        return new Iterator(function() {
            return i === size ? iteratorDone() : iteratorValue(type, reverse ? size - ++i : i++, this$1$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(this, other);
    };
    return Repeat;
}(IndexedSeq);
var EMPTY_REPEAT;
function fromJS(value, converter) {
    return fromJSWith([], converter || defaultConverter, value, "", converter && converter.length > 2 ? [] : undefined, {
        "": value
    });
}
function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    if (typeof value !== "string" && !isImmutable(value) && (isArrayLike(value) || hasIterator(value) || isPlainObject(value))) {
        if (~stack.indexOf(value)) throw new TypeError("Cannot convert circular structure to Immutable");
        stack.push(value);
        keyPath && key !== "" && keyPath.push(key);
        var converted = converter.call(parentValue, key, Seq(value).map(function(v, k) {
            return fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function defaultConverter(k, v) {
    // Effectively the opposite of "Collection.toSeq()"
    return isIndexed(v) ? v.toList() : isKeyed(v) ? v.toMap() : v.toSet();
}
var version = "4.3.7";
var Immutable = {
    version: version,
    Collection: Collection,
    // Note: Iterable is deprecated
    Iterable: Collection,
    Seq: Seq,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,
    PairSorting: PairSorting,
    Record: Record,
    Range: Range,
    Repeat: Repeat,
    is: is,
    fromJS: fromJS,
    hash: hash,
    isImmutable: isImmutable,
    isCollection: isCollection,
    isKeyed: isKeyed,
    isIndexed: isIndexed,
    isAssociative: isAssociative,
    isOrdered: isOrdered,
    isValueObject: isValueObject,
    isPlainObject: isPlainObject,
    isSeq: isSeq,
    isList: isList,
    isMap: isMap,
    isOrderedMap: isOrderedMap,
    isStack: isStack,
    isSet: isSet,
    isOrderedSet: isOrderedSet,
    isRecord: isRecord,
    get: get,
    getIn: getIn$1,
    has: has,
    hasIn: hasIn$1,
    merge: merge,
    mergeDeep: mergeDeep$1,
    mergeWith: mergeWith,
    mergeDeepWith: mergeDeepWith$1,
    remove: remove,
    removeIn: removeIn,
    set: set,
    setIn: setIn$1,
    update: update$1,
    updateIn: updateIn$1
};
// Note: Iterable is deprecated
var Iterable = Collection;
var $d5998233ee9140ac$export$2e2bcd8739ae039 = Immutable;

});


parcelRegister("jzlES", function(module, exports) {
const $e3f2161d6e57bebf$var$objectFromEntry = ([key, value])=>({
        [key]: value
    });
const $e3f2161d6e57bebf$var$reduceEntry = (acc, [key, value])=>acc.constructor.name === "Object" ? {
        ...acc,
        [key]: value
    } : {
        ...$e3f2161d6e57bebf$var$objectFromEntry(acc),
        [key]: value
    };
module.exports = {
    reduceEntry: $e3f2161d6e57bebf$var$reduceEntry
};

});

parcelRegister("lYrhP", function(module, exports) {

var $eXLGK = parcelRequire("eXLGK");
var $fff45e17db059106$require$Maybe = $eXLGK.Maybe;
const $fff45e17db059106$var$isSome = (o)=>$fff45e17db059106$require$Maybe.of(o).isSome();
const $fff45e17db059106$var$isNot = (predicate)=>(o)=>!predicate(o);
const $fff45e17db059106$var$isNone = $fff45e17db059106$var$isNot($fff45e17db059106$var$isSome);
module.exports = {
    isSome: $fff45e17db059106$var$isSome,
    isNone: $fff45e17db059106$var$isNone,
    isNot: $fff45e17db059106$var$isNot
};

});

parcelRegister("b9yfs", function(module, exports) {
const $81eb19f58ad00628$var$chain = (...fs)=>(arg)=>fs.reduce((acc, f)=>f(acc), arg);
const $81eb19f58ad00628$var$compose = (...fs)=>(arg)=>fs.reduceRight((acc, f)=>f(acc), arg);
module.exports = {
    chain: $81eb19f58ad00628$var$chain,
    compose: $81eb19f58ad00628$var$compose
};

});

parcelRegister("cyoAd", function(module, exports) {

var $ikZ7K = parcelRequire("ikZ7K");
var $923bbaba74bd2f77$require$List = $ikZ7K.List;
const $923bbaba74bd2f77$var$sort = (arr, comparator)=>$923bbaba74bd2f77$require$List(arr).sort(comparator).toJS();
const $923bbaba74bd2f77$var$sortBy = (arr, comparatorValueMapper, comparator)=>$923bbaba74bd2f77$require$List(arr).sortBy(comparatorValueMapper, comparator).toJS();
module.exports = {
    sort: $923bbaba74bd2f77$var$sort,
    sortBy: $923bbaba74bd2f77$var$sortBy
};

});


parcelRegister("aTXuQ", function(module, exports) {

var $jrtNg = parcelRequire("jrtNg");

var $o8HxT = parcelRequire("o8HxT");
/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */ function $7efd313040cb9ee6$var$orderBy(collection, iteratees, orders, guard) {
    if (collection == null) return [];
    if (!$o8HxT(iteratees)) iteratees = iteratees == null ? [] : [
        iteratees
    ];
    orders = guard ? undefined : orders;
    if (!$o8HxT(orders)) orders = orders == null ? [] : [
        orders
    ];
    return $jrtNg(collection, iteratees, orders);
}
module.exports = $7efd313040cb9ee6$var$orderBy;

});
parcelRegister("jrtNg", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $lJEX1 = parcelRequire("lJEX1");

var $7MWok = parcelRequire("7MWok");

var $fDc61 = parcelRequire("fDc61");

var $9xZGY = parcelRequire("9xZGY");

var $91Qdd = parcelRequire("91Qdd");

var $fyGSR = parcelRequire("fyGSR");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $i46jW(iteratees, function(iteratee) {
        if ($o8HxT(iteratee)) return function(value) {
            return $lJEX1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $4Nq5y
    ];
    var index = -1;
    iteratees = $i46jW(iteratees, $91Qdd($7MWok));
    var result = $fDc61(collection, function(value, key, collection) {
        var criteria = $i46jW(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $9xZGY(result, function(object, other) {
        return $fyGSR(object, other, orders);
    });
}
module.exports = $e277a64de4eeade6$var$baseOrderBy;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});

parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});
parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});
parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype["delete"] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $c8dKl,
        "map": new ($2cJKd || $iYOpJ),
        "string": new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, "create");
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});




parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});


parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, "Map");
module.exports = $19b02faa57603249$var$Map;

});


parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});





parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + "";
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});



parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $9dr3u(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});


parcelRegister("7MWok", function(module, exports) {

var $jShkp = parcelRequire("jShkp");

var $in5n5 = parcelRequire("in5n5");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");

var $bAYPD = parcelRequire("bAYPD");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $4Nq5y;
    if (typeof value == "object") return $o8HxT(value) ? $in5n5(value[0], value[1]) : $jShkp(value);
    return $bAYPD(value);
}
module.exports = $5aba4f6d9f8304a3$var$baseIteratee;

});
parcelRegister("jShkp", function(module, exports) {

var $kgn8n = parcelRequire("kgn8n");

var $9dd8D = parcelRequire("9dd8D");

var $2IhDm = parcelRequire("2IhDm");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $9dd8D(source);
    if (matchData.length == 1 && matchData[0][2]) return $2IhDm(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $kgn8n(object, source, matchData);
    };
}
module.exports = $e780807e2b795134$var$baseMatches;

});
parcelRegister("kgn8n", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $abgWr = parcelRequire("abgWr");
/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $g779E;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $abgWr(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $ec073f38db6e7d54$var$baseIsMatch;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});


parcelRegister("abgWr", function(module, exports) {

var $7qq40 = parcelRequire("7qq40");

var $8l89S = parcelRequire("8l89S");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8l89S(value) && !$8l89S(other)) return value !== value && other !== other;
    return $7qq40(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
module.exports = $769812b29c18141e$var$baseIsEqual;

});
parcelRegister("7qq40", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $1pRE7 = parcelRequire("1pRE7");

var $g3aCZ = parcelRequire("g3aCZ");

var $eOqMj = parcelRequire("eOqMj");

var $67A6V = parcelRequire("67A6V");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $1Q21n = parcelRequire("1Q21n");
/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = "[object Arguments]", $567f2dd161ebd4f6$var$arrayTag = "[object Array]", $567f2dd161ebd4f6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $o8HxT(object), othIsArr = $o8HxT(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $g779E);
        return objIsArr || $1Q21n(object) ? $1pRE7(object, other, bitmask, customizer, equalFunc, stack) : $g3aCZ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $g779E);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $g779E);
    return $eOqMj(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;

});
parcelRegister("1pRE7", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $eFBTL = parcelRequire("eFBTL");

var $2l8n7 = parcelRequire("2l8n7");
/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $dXA7v : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eFBTL(other, function(othValue, othIndex) {
                if (!$2l8n7(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $1081bd3a2e361911$var$equalArrays;

});
parcelRegister("dXA7v", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");

var $j1Tfx = parcelRequire("j1Tfx");

var $8NkYQ = parcelRequire("8NkYQ");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $j1Tfx;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $8NkYQ;
module.exports = $a29ccdc0f60e279e$var$SetCache;

});
parcelRegister("j1Tfx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $dda8f7b6b589544e$var$setCacheAdd;

});

parcelRegister("8NkYQ", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $66732c92c350622c$var$setCacheHas;

});


parcelRegister("eFBTL", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $aae24ad60cc3cfcb$var$arraySome;

});

parcelRegister("2l8n7", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1b44096ad4b9e2d5$var$cacheHas;

});


parcelRegister("g3aCZ", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $lx3EF = parcelRequire("lx3EF");

var $6TC8i = parcelRequire("6TC8i");

var $1pRE7 = parcelRequire("1pRE7");

var $cwfcG = parcelRequire("cwfcG");

var $1xAji = parcelRequire("1xAji");
/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = "[object Boolean]", $baf52b9e146f3da7$var$dateTag = "[object Date]", $baf52b9e146f3da7$var$errorTag = "[object Error]", $baf52b9e146f3da7$var$mapTag = "[object Map]", $baf52b9e146f3da7$var$numberTag = "[object Number]", $baf52b9e146f3da7$var$regexpTag = "[object RegExp]", $baf52b9e146f3da7$var$setTag = "[object Set]", $baf52b9e146f3da7$var$stringTag = "[object String]", $baf52b9e146f3da7$var$symbolTag = "[object Symbol]";
var $baf52b9e146f3da7$var$arrayBufferTag = "[object ArrayBuffer]", $baf52b9e146f3da7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $lx3EF(object), new $lx3EF(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6TC8i(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $cwfcG;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1xAji);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1pRE7(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $baf52b9e146f3da7$var$equalByTag;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});

parcelRegister("cwfcG", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $91d4444cbb077e0c$var$mapToArray;

});

parcelRegister("1xAji", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $11f509f8f53d8c36$var$setToArray;

});


parcelRegister("eOqMj", function(module, exports) {

var $apVCl = parcelRequire("apVCl");
/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $apVCl(object), objLength = objProps.length, othProps = $apVCl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $ac8a81cbae0357e8$var$equalObjects;

});
parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});


parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});


parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});

parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});


parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});

parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});
parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});


parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});

parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});




parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, "DataView");
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, "Promise");
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, "Set");
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, "WeakMap");
module.exports = $aedce50092a1e6a6$var$WeakMap;

});





parcelRegister("9dd8D", function(module, exports) {

var $1n1hd = parcelRequire("1n1hd");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $LAMcS(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1n1hd(value)
        ];
    }
    return result;
}
module.exports = $6b4f84f6be7f825c$var$getMatchData;

});
parcelRegister("1n1hd", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$lsJ54(value);
}
module.exports = $0ff8edf4f90a7955$var$isStrictComparable;

});


parcelRegister("2IhDm", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $1f9d5e891556ddb9$var$matchesStrictComparable;

});


parcelRegister("in5n5", function(module, exports) {

var $abgWr = parcelRequire("abgWr");

var $i51gj = parcelRequire("i51gj");

var $2VBx6 = parcelRequire("2VBx6");

var $kPpic = parcelRequire("kPpic");

var $1n1hd = parcelRequire("1n1hd");

var $2IhDm = parcelRequire("2IhDm");

var $6DSvu = parcelRequire("6DSvu");
/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($kPpic(path) && $1n1hd(srcValue)) return $2IhDm($6DSvu(path), srcValue);
    return function(object) {
        var objValue = $i51gj(object, path);
        return objValue === undefined && objValue === srcValue ? $2VBx6(object, path) : $abgWr(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;

});
parcelRegister("i51gj", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $lJEX1(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $d299ac421c05c135$var$get;

});

parcelRegister("2VBx6", function(module, exports) {

var $ij33W = parcelRequire("ij33W");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $btvBm(object, path, $ij33W);
}
module.exports = $221e04e57e35dd04$var$hasIn;

});
parcelRegister("ij33W", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d53c6080f339a51f$var$baseHasIn;

});

parcelRegister("btvBm", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $4RK0h(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6DSvu(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
module.exports = $85aaea8f77d790ae$var$hasPath;

});



parcelRegister("4Nq5y", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
module.exports = $37dff9aa04444f9c$var$identity;

});

parcelRegister("bAYPD", function(module, exports) {

var $ielIK = parcelRequire("ielIK");

var $jfdoV = parcelRequire("jfdoV");

var $kPpic = parcelRequire("kPpic");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $kPpic(path) ? $ielIK($6DSvu(path)) : $jfdoV(path);
}
module.exports = $87123e72266aa58c$var$property;

});
parcelRegister("ielIK", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $d45a621b4548f6bb$var$baseProperty;

});

parcelRegister("jfdoV", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $lJEX1(object, path);
    };
}
module.exports = $e029d02f9dd10368$var$basePropertyDeep;

});



parcelRegister("fDc61", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");

var $eMthh = parcelRequire("eMthh");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $eMthh(collection) ? Array(collection.length) : [];
    $4DjQp(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $b613e194c1b157de$var$baseMap;

});
parcelRegister("4DjQp", function(module, exports) {

var $4xK4A = parcelRequire("4xK4A");

var $kCOH9 = parcelRequire("kCOH9");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $kCOH9($4xK4A);
module.exports = $35fa3296f177aa01$var$baseEach;

});
parcelRegister("4xK4A", function(module, exports) {

var $dEvx9 = parcelRequire("dEvx9");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $dEvx9(object, iteratee, $LAMcS);
}
module.exports = $34edfba366a0cfa1$var$baseForOwn;

});
parcelRegister("dEvx9", function(module, exports) {

var $jTvRt = parcelRequire("jTvRt");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $jTvRt();
module.exports = $9f0778b809a8c692$var$baseFor;

});
parcelRegister("jTvRt", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $e7bbde6376f4568a$var$createBaseFor;

});



parcelRegister("kCOH9", function(module, exports) {

var $eMthh = parcelRequire("eMthh");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$eMthh(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $f03eae3721f9ace8$var$createBaseEach;

});



parcelRegister("9xZGY", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $6f370ce7a904568e$var$baseSortBy;

});

parcelRegister("fyGSR", function(module, exports) {

var $1HU00 = parcelRequire("1HU00");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $1HU00(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $b53b4bd61680c3b6$var$compareMultiple;

});
parcelRegister("1HU00", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9dr3u(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9dr3u(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $13e53edf809f77b7$var$compareAscending;

});




parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("8NWq9", function(module, exports) {
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else if (0, module.exports) module.exports = factory();
    else global.numeral = factory();
})(module.exports, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = "2.0.6", formats = {}, locales = {}, defaults = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === "undefined") value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === "string") {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, "").length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === "function" ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = "", neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, "(")) {
                negP = true;
                format = format.replace(/[\(|\)]/g, "");
            } else if (numeral._.includes(format, "+") || numeral._.includes(format, "-")) {
                signed = numeral._.includes(format, "+") ? format.indexOf("+") : value < 0 ? format.indexOf("-") : -1;
                format = format.replace(/[\+|\-]/g, "");
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, "a")) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, " a")) abbr = " ";
                format = format.replace(new RegExp(abbr + "a[kmbt]?"), "");
                if (abs >= trillion && !abbrForce || abbrForce === "t") {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === "b") {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === "m") {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === "k") {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, "[.]")) {
                optDec = true;
                format = format.replace("[.]", ".");
            }
            // break number and format
            int = value.toString().split(".")[0];
            precision = format.split(".")[1];
            thousands = format.indexOf(",");
            leadingCount = (format.split(".")[0].split(",")[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, "[")) {
                    precision = precision.replace("]", "");
                    precision = precision.split("[");
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split(".")[0];
                if (numeral._.includes(decimal, ".")) decimal = locale.delimiters.decimal + decimal.split(".")[1];
                else decimal = "";
                if (optDec && Number(decimal.slice(1)) === 0) decimal = "";
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, "-")) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = "0" + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale.delimiters.thousands);
            if (format.indexOf(".") === 0) int = "";
            output = int + decimal + (abbr ? abbr : "");
            if (negP) output = (negP && neg ? "(" : "") + output + (negP && neg ? ")" : "");
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? "-" : "+") + output : output + (neg ? "-" : "+");
                else if (neg) output = "-" + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, "").length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== ".") string = string.replace(/\./g, "").replace(locale.delimiters.decimal, ".");
                for(abbreviation in abbreviations){
                    regexp = new RegExp("[^a-zA-Z]" + locale.abbreviations[abbreviation] + "(?:\\)|(\\" + locale.currency.symbol + ")?(?:\\))?)?$");
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split("-").length + Math.min(string.split("(").length - 1, string.split(")").length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, "");
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === "number" && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError("Array.prototype.reduce called on null or undefined");
            if (typeof callback !== "function") throw new TypeError(callback + " is not a function");
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError("Reduce of empty array with no initial value");
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split(".");
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
                output = output.replace(optionalsRegExp, "");
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error("Unknown locale : " + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === "string" ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === "string" ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === "string" ? format : "0.0";
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + "s"][name]) throw new TypeError(name + " " + type + " already registered.");
        this[type + "s"][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== "string") {
            val += "";
            if (console.warn) console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === "") return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === ".") _thousandSep = "\\.";
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + "{2}");
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register("locale", "en", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        },
        currency: {
            symbol: "$"
        }
    });
    (function() {
        numeral.register("format", "bps", {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " BPS") ? " " : "", output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "BPS");
                    output = output.join("");
                } else output = output + space + "BPS";
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                "B",
                "KB",
                "MB",
                "GB",
                "TB",
                "PB",
                "EB",
                "ZB",
                "YB"
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                "B",
                "KiB",
                "MiB",
                "GiB",
                "TiB",
                "PiB",
                "EiB",
                "ZiB",
                "YiB"
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join("|");
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
        numeral.register("format", "bytes", {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, "ib") ? binary : decimal, suffix = numeral._.includes(format, " b") || numeral._.includes(format, " ib") ? " " : "", power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, "");
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register("format", "currency", {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, "");
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, "");
                    symbols.after = symbols.after.replace(/[\-\)]/, "");
                } else if (value < 0 && !numeral._.includes(symbols.before, "-") && !numeral._.includes(symbols.before, "(")) symbols.before = "-" + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case "$":
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case " ":
                            output = numeral._.insert(output, " ", i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case "$":
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case " ":
                            output = i === symbols.after.length - 1 ? output + " " : numeral._.insert(output, " ", -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register("format", "exponential", {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === "number" && !numeral._.isNaN(value) ? value.toExponential() : "0e+0", parts = exponential.split("e");
                format = format.replace(/e[\+|\-]{1}0/, "");
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + "e" + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, "e+") ? string.split("e+") : string.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, "e-") ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register("format", "ordinal", {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, " o") ? " " : "";
                // check for space before
                format = format.replace(/\s?o/, "");
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register("format", "percentage", {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " %") ? " " : "", output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "%");
                    output = output.join("");
                } else output = output + space + "%";
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register("format", "time", {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(":"), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});

});

parcelRegister("auStQ", function(module, exports) {

var $4K1Rf = parcelRequire("4K1Rf");

var $70ZCW = parcelRequire("70ZCW");

var $iO0MQ = parcelRequire("iO0MQ");
module.exports = {
    labelTranslate: $4K1Rf,
    translate: $70ZCW,
    promotionTranslate: $iO0MQ
};

});
parcelRegister("4K1Rf", function(module, exports) {

var $6MR35 = parcelRequire("6MR35");
/*
  Translate word based on locale passed in.
  If locale translation does not exist, split off the language from the locale and translate based on that language.
*/ module.exports = (word, language)=>{
    let translation = null;
    try {
        translation = $6MR35[word][language] || $6MR35[word][language.split("-")[0]] || null;
        return translation;
    } catch (err) {
        return null;
    }
};

});
parcelRegister("6MR35", function(module, exports) {
module.exports = JSON.parse('{"IL_Color":{"ca":"Color","comment":"Text for the Color code attribute of the product to print on the labels. ","cs":"Barva","da":"Farve","de":"Farbe","el":"\u03A7\u03C1\u03CE\u03BC\u03B1","en":"Color","en-GB":"Colour","en-XA":"[\xc7\xf6\u013C\xf6\u0155\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"Color","es-ES":"Color","es-MX":"Color","fi":"V\xe4ri","fr":"Couleur","he":"\u05E6\u05D1\u05E2","hr":"Boja","hu":"Sz\xedn","it":"Colore","ja":"\u30AB\u30E9\u30FC","key":"IL_Color","ko":"\uCEEC\uB7EC","nb":"Farge","nl":"Kleur","pl":"Kolor","pt-BR":"Cor","pt-PT":"Cor","ru":"\u0420\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430","sv":"F\xe4rg","th":"\u0E2A\u0E35","tr":"Renk","zh-Hans":"\u989C\u8272","zh-Hant":"\u984F\u8272"},"IL_Created":{"ca":"Creat el","comment":"The string \\"Created\\" that indicate the date on which the label was printed.","cs":"Vytvo\u0159eno","da":"Oprettet","de":"Erstellt","el":"\u0394\u03B7\u03BC\u03B9\u03BF\u03C5\u03C1\u03B3\u03AE\u03B8\u03B7\u03BA\u03B5","en":"Created","en-GB":"Created","en-XA":"[\xc7\u0155\xe9\xe5\u0163\xe9\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"Fecha de creaci\xf3n","es-ES":"Creado el","es-MX":"Creado","fi":"Luotu","fr":"Cr\xe9\xe9e","he":"\u05E0\u05D5\u05E6\u05E8","hr":"Izra\u0111eno","hu":"K\xe9sz\xfclt","it":"Data creazione","ja":"\u4F5C\u6210\u6E08\u307F","key":"IL_Created","ko":"\uC0DD\uC131\uB428","nb":"Opprettet","nl":"Gemaakt","pl":"Utworzono","pt-BR":"Criado","pt-PT":"Data de cria\xe7\xe3o","ru":"\u0421\u043E\u0437\u0434\u0430\u043D\u043E","sv":"Skapad","th":"\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E21\u0E37\u0E48\u0E2D","tr":"F\u0130YAT TAR\u0130H\u0130","zh-Hans":"\u521B\u5EFA\u65E5\u671F","zh-Hant":"\u5EFA\u7ACB\u65E5\u671F"},"IL_CurrencySymbol":{"ca":"$","comment":"Currency symbol on the label.","cs":"USD","da":"$","de":"$","el":"$","en":"$","en-GB":"$","en-XA":"[\u20AC\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"$","es-ES":"$","es-MX":"$","fi":"$","fr":"$","he":"$","hr":"$","hu":"HUF","it":"$","ja":"$","key":"IL_CurrencySymbol","ko":"\uB2EC\uB7EC($)","nb":"$","nl":"$","pl":"USD","pt-BR":"$","pt-PT":"$","ru":"$","sv":"$","th":"$","tr":"$","zh-Hans":"\uFFE5","zh-Hant":"$"},"IL_CurrentPrice":{"ca":"Preu actual","comment":"Current Price of an item on the Item price and Heel Tab Label.","cs":"Aktu\xe1ln\xed cena","da":"Nuv\xe6rende pris","de":"Aktueller Preis","el":"\u03A4\u03C1\u03AD\u03C7\u03BF\u03C5\u03C3\u03B1 \u03C4\u03B9\u03BC\u03AE","en":"Current Price","en-GB":"Current Price","en-XA":"[\xc7\xfb\u0155\u0155\xe9\xf1\u0163\u2002\xde\u0155\xee\xe7\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"Precio actual","es-ES":"Precio actual","es-MX":"Precio actual","fi":"Nykyinen hinta","fr":"Prix actuel","he":"\u05DE\u05D7\u05D9\u05E8 \u05E0\u05D5\u05DB\u05D7\u05D9","hr":"Trenuta\u010Dna cijena","hu":"Jelenlegi \xe1r","it":"Prezzo attuale","ja":"\u73FE\u5728\u306E\u4FA1\u683C","key":"IL_CurrentPrice","ko":"\uD604\uC7AC \uAC00\uACA9","nb":"N\xe5v\xe6rende pris","nl":"Huidige prijs","pl":"Aktualna cena","pt-BR":"Pre\xe7o atual","pt-PT":"Pre\xe7o atual","ru":"\u0422\u0435\u043A\u0443\u0449\u0430\u044F \u0446\u0435\u043D\u0430","sv":"Nuvarande pris","th":"\u0E23\u0E32\u0E04\u0E32\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19","tr":"Mevcut Fiyat","zh-Hans":"\u5F53\u524D\u4EF7\u683C","zh-Hant":"\u76EE\u524D\u50F9\u683C"},"IL_CurrentPrice1":{"ca":"Preu","comment":"The verbiage for the Current Selling Price","cs":"Cena","da":"Pris","de":"Preis","el":"\u03A4\u03B9\u03BC\u03AE","en":"Price","en-GB":"Price","en-XA":"[\xde\u0155\xee\xe7\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"Precio","es-ES":"Precio","es-MX":"Precio","fi":"Hinta","fr":"Prix","he":"\u05DE\u05D7\u05D9\u05E8","hr":"Cijena","hu":"\xc1r","it":"Prezzo","ja":"\u4FA1\u683C","key":"IL_CurrentPrice1","ko":"\uAC00\uACA9","nb":"Pris","nl":"Prijs","pl":"Cena","pt-BR":"Pre\xe7o","pt-PT":"Pre\xe7o","ru":"\u0426\u0435\u043D\u0430","sv":"Pris","th":"\u0E23\u0E32\u0E04\u0E32","tr":"Fiyat","zh-Hans":"\u4EF7\u683C","zh-Hant":"\u50F9\u683C"},"IL_CurrentPrice2":{"ca":"Preu actual de venda","comment":"Current selling price verbiage on the second line.","cs":"CSP","da":"CSP","de":"CSP","el":"CSP","en":"CSP","en-GB":"CSP","en-XA":"[\xc7\u0160\xde\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"Precio actual de venta","es-ES":"Precio actual de venta","es-MX":"CSP","fi":"CSP","fr":"PVA","he":"CSP","hr":"CSP","hu":"CSP","it":"PVA","ja":"CSP","key":"IL_CurrentPrice2","ko":"\uCE74\uC2A4\uD53C\uC548(CSP)","nb":"CSP","nl":"CSP","pl":"Aktualna cena sprzeda\u017Cy","pt-BR":"Pre\xe7o de venda atual","pt-PT":"Pre\xe7o de venda atual","ru":"CSP","sv":"Nuvarande pris","th":"\u0E23\u0E32\u0E04\u0E32\u0E02\u0E32\u0E22\u0E1B\u0E31\u0E08\u0E08\u0E38\u0E1A\u0E31\u0E19","tr":"Mevcut Sat\u0131\u015F Fiyat\u0131","zh-Hans":"\u5F53\u524D\u4EF7\u683C","zh-Hant":"CSP"},"IL_FactoryPrice":{"ca":"Preu de f\xe0brica","comment":"The price of the items in a factory store. This price will be printed on the Item price and Heel Tab labels of a Nike Factory store.","cs":"V\xfdrobn\xed cena","da":"Fabrikspris","de":"Fabrikpreis","el":"\u03A4\u03B9\u03BC\u03AE \u03B5\u03C1\u03B3\u03BF\u03C3\u03C4\u03B1\u03C3\u03AF\u03BF\u03C5","en":"Factory Price","en-GB":"Factory Price","en-XA":"[\u0191\xe5\xe7\u0163\xf6\u0155\xfd\u2002\xde\u0155\xee\xe7\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"Previo de f\xe1brica","es-ES":"Precio de f\xe1brica","es-MX":"Precio de f\xe1brica","fi":"Tehdashinta","fr":"Prix usine","he":"\u05DE\u05D7\u05D9\u05E8 \u05DE\u05E4\u05E2\u05DC","hr":"Tvorni\u010Dka cijena","hu":"El\u0151\xe1ll\xedt\xe1si \xe1r","it":"Prezzo di fabbrica","ja":"\u30D5\u30A1\u30AF\u30C8\u30EA\u30FC\u30B9\u30C8\u30A2\u4FA1\u683C","key":"IL_FactoryPrice","ko":"\uACF5\uC7A5 \uAC00\uACA9","nb":"Fabrikkpris","nl":"Factoryprijs","pl":"Cena fabryczna","pt-BR":"Pre\xe7o de f\xe1brica","pt-PT":"Pre\xe7o de f\xe1brica","ru":"\u0424\u0430\u0431\u0440\u0438\u0447\u043D\u0430\u044F \u0446\u0435\u043D\u0430","sv":"Factory-pris","th":"\u0E23\u0E32\u0E04\u0E32\u0E42\u0E23\u0E07\u0E07\u0E32\u0E19","tr":"Fabrika Fiyat\u0131","zh-Hans":"\u51FA\u5382\u4EF7\u683C","zh-Hant":"Factory \u50F9\u683C"},"IL_ShipmentNumber":{"comment":"Shipment Number is a unique identifier assigned to each shipment/transfer","en":"Shipment Number","en-XA":"[\u0160\u0125\xee\xfe\u0271\xe9\xf1\u0163\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","key":"IL_ShipmentNumber"},"IL_Size":{"ca":"Talla","comment":"Size of the item","cs":"Velikost","da":"St\xf8rrelse","de":"Gr\xf6\xdfe","el":"\u039C\u03AD\u03B3\u03B5\u03B8\u03BF\u03C2","en":"Size","en-GB":"Size","en-XA":"[\u0160\xee\u017E\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"Talle","es-ES":"Talla","es-MX":"Talla","fi":"Koko","fr":"Taille/Pointure","he":"\u05DE\u05D9\u05D3\u05D4","hr":"Veli\u010Dina","hu":"M\xe9ret","it":"Taglia/misura","ja":"\u30B5\u30A4\u30BA","key":"IL_Size","ko":"\uC0AC\uC774\uC988","nb":"St\xf8rrelse","nl":"Maat","pl":"Rozmiar","pt-BR":"Tamanho","pt-PT":"Tamanho","ru":"\u0420\u0430\u0437\u043C\u0435\u0440","sv":"Storlek","th":"\u0E44\u0E0B\u0E2A\u0E4C","tr":"Numara/Beden","zh-Hans":"\u5C3A\u7801","zh-Hant":"\u5C3A\u5BF8"},"IL_Style":{"ca":"Model","comment":"Style of the item ","cs":"Styl","da":"Style","de":"Style","el":"\u03A3\u03C4\u03B9\u03BB","en":"Style","en-GB":"Style","en-XA":"[\u0160\u0163\xfd\u013C\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"Estilo","es-ES":"Modelo","es-MX":"Estilo","fi":"Tyyli","fr":"Mod\xe8le","he":"\u05E1\u05D2\u05E0\u05D5\u05DF","hr":"Model","hu":"St\xedlus","it":"Modello","ja":"\u30B9\u30BF\u30A4\u30EB","key":"IL_Style","ko":"\uC2A4\uD0C0\uC77C","nb":"Produkt","nl":"Stijl","pl":"Model","pt-BR":"Estilo","pt-PT":"Estilo","ru":"\u041C\u043E\u0434\u0435\u043B\u044C","sv":"Modell","th":"\u0E2A\u0E44\u0E15\u0E25\u0E4C","tr":"Stil","zh-Hans":"\u6B3E\u5F0F","zh-Hant":"\u6B3E\u5F0F"},"IL_SuggestedPrice":{"ca":"Preu suggerit","comment":"Suggested retail price of a product is the price at which its manufacturer nominally recommends that a retailer sell the product.","cs":"Doporu\u010Den\xe1 cena","da":"Vejledende pris","de":"Vorgeschlagener Preis","el":"\u03A0\u03C1\u03BF\u03C4\u03B5\u03B9\u03BD\u03CC\u03BC\u03B5\u03BD\u03B7 \u03C4\u03B9\u03BC\u03AE","en":"Suggested Price","en-GB":"Suggested Price","en-XA":"[\u0160\xfb\u011D\u011D\xe9\u0161\u0163\xe9\xf0\u2002\xde\u0155\xee\xe7\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-AR":"Precio sugerido","es-ES":"Precio recomendado","es-MX":"Precio sugerido","fi":"Suositeltu hinta","fr":"Prix sugg\xe9r\xe9","he":"\u05DE\u05D7\u05D9\u05E8 \u05DE\u05D5\u05E6\u05E2","hr":"Preporu\u010Dena cijena","hu":"Javasolt \xe1r","it":"Prezzo consigliato","ja":"\u5E0C\u671B\u5C0F\u58F2\u4FA1\u683C","key":"IL_SuggestedPrice","ko":"\uAD8C\uC7A5 \uAC00\uACA9","nb":"Foresl\xe5tt pris","nl":"Adviesprijs","pl":"Sugerowana cena","pt-BR":"Pre\xe7o sugerido","pt-PT":"Pre\xe7o sugerido","ru":"\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0446\u0435\u043D\u0430","sv":"Rekommenderat pris","th":"\u0E23\u0E32\u0E04\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33","tr":"\xd6nerilen Fiyat","zh-Hans":"\u5EFA\u8BAE\u4EF7\u683C","zh-Hant":"\u5EFA\u8B70\u552E\u50F9"}}');

});


parcelRegister("70ZCW", function(module, exports) {

var $bz2Yd = parcelRequire("bz2Yd");
/*
  Translate word based on locale passed in.
  If locale translation does not exist, split off the language from the locale and translate based on that language.
*/ module.exports = (word, language)=>{
    let translation = null;
    try {
        translation = $bz2Yd[word][language] || $bz2Yd[word][language.split("-")[0]] || null;
        return translation;
    } catch (err) {
        return null;
    }
};

});
parcelRegister("bz2Yd", function(module, exports) {
module.exports = JSON.parse('{"Amount":{"ar":"\u0627\u0644\u0645\u0628\u0644\u063A:","ca":"Import:","comment":"Amount displayed in receipt","cs":"\u010C\xe1stka:","da":"Bel\xf8b:","de":"Anzahl:","el":"\u03A0\u03BF\u03C3\u03CC:","en":"Amt:","en-GB":"Amt:","en-XA":"[\xc5\u0271\u0163\u2236\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Monto:","es-AR":"Importe:","es-ES":"Importe:","es-MX":"Monto:","fr":"Montant :","hu":"\xd6ssz.","id":"Jml:","it":"Importo:","ja":"\u91D1\u984D","key":"Amount","ko":"\uAE08\uC561:","nb":"Bel\xf8p:","nl":"Bedr.","pl":"Kwota","pt-BR":"Valor:","pt-PT":"Mont.:","ru":"\u0421\u0443\u043C\u043C\u0430:","sv":"Belopp:","th":"\u0E08\u0E33\u0E19\u0E27\u0E19:","tr":"Tutar:","zh-Hans":"\u91D1\u989D\uFF1A","zh-Hant":"\u91D1\u984D\uFF1A"},"CardNo":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","ca":"N.\xba tarj","comment":"Gift card number used in transaction","cs":"Karta c","da":"Kort nr","de":"Karten-Nr.","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2","en":"Card No","en-GB":"Card No","en-XA":"[\xc7\xe5\u0155\xf0\u2002\xd1\xf6\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N.\xba de tarjeta","es-AR":"N.\xba de tarjeta","es-ES":"N.\xba tarj","es-MX":"N.\xba de tarjeta","fr":"N\xb0 carte","hu":"Card No","id":"No. Kartu","it":"N. carta","ja":"\u30AB\u30FC\u30C9\u756A\u53F7","key":"CardNo","ko":"\uCE74\uB4DC \uBC88\uD638","nb":"Kortnr.","nl":"Kaartnr.","pl":"Nr karty","pt-BR":"N\xb0 do cart\xe3o","pt-PT":"N.\xba do cart\xe3o","ru":"\u2116 \u043A\u0430\u0440\u0442\u044B","sv":"Kortnr.","th":"\u0E40\u0E25\u0E02\u0E1A\u0E31\u0E15\u0E23","tr":"Kart No","zh-Hans":"\u5361\u53F7","zh-Hant":"\u5361\u865F"},"Control Code":{"ar":"\u0631\u0645\u0632 \u0627\u0644\u062A\u062D\u0643\u0651\u0645","ca":"Codi de control","comment":"Printed on the receipt which is an encrypted digital signature","cs":"Kontroln\xed k\xf3d","da":"Kontrolkode","de":"Kontrollcode","el":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03B5\u03BB\u03AD\u03B3\u03C7\u03BF\u03C5","en":"Control Code","en-GB":"Control Code","en-XA":"[\xc7\xf6\xf1\u0163\u0155\xf6\u013C\u2002\xc7\xf6\xf0\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"C\xf3digo de control","es-AR":"C\xf3digo de control","es-ES":"C\xf3digo de control","es-MX":"C\xf3digo de control","fr":"Code de contr\xf4le","hu":"Ellen\u0151rz\u0151k\xf3d","id":"Kode Kontrol","it":"Codice di controllo","ja":"\u30B3\u30F3\u30C8\u30ED\u30FC\u30EB \u30B3\u30FC\u30C9","key":"Control Code","ko":"\uCEE8\uD2B8\uB864 \uCF54\uB4DC","nb":"Kontrollkode","nl":"Controlecode","pl":"Kod kontrolny","pt-BR":"C\xf3digo de controle","pt-PT":"C\xf3digo de controlo","ru":"\u041A\u043E\u043D\u0442\u0440\u043E\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0434","sv":"Kontrollkod","th":"\u0E23\u0E2B\u0E31\u0E2A\u0E04\u0E27\u0E1A\u0E04\u0E38\u0E21","tr":"Kontrol Kodu","zh-Hans":"\u9632\u4F2A\u7801","zh-Hant":"\u63A7\u5236\u78BC"},"DuplicateReceipt":{"ca":"REBUT DUPLICAT","comment":"All caps text printed on a receipt to indicate the receipt is a reprint/duplicate","cs":"DUPLICITN\xcd PRODEJN\xcd DOKLAD","da":"KOPI AF KVITTERING","de":"DOPPELTER BELEG","en":"DUPLICATE RECEIPT","en-XA":"[\xd0\xdb\xde\u013B\xce\xc7\xc5\u0162\xc9\u2002\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"RECIBO DUPLICADO","es-AR":"RECIBO DUPLICADO","es-ES":"RECIBO DUPLICADO","es-MX":"DUPLICAR RECIBO","fr":"DUPLICATA DE RE\xc7U","hu":"SZ\xc1MLA M\xc1SOLATA","it":"DUPLICATO RICEVUTA","ja":"\u9818\u53CE\u66F8\u3092\u8907\u88FD\u3059\u308B","key":"DuplicateReceipt","nb":"DUPLIKATKVITTERING","nl":"DUBBELE BON","pl":"DUPLIKAT PARAGONU","pt-PT":"RECIBO DUPLICADO","ru":"\u0414\u0423\u0411\u041B\u0418\u041A\u0410\u0422 \u0427\u0415\u041A\u0410","sv":"KVITTOKOPIA","tr":"M\xdcKERRER MAKBUZ","zh-Hans":"\u6536\u636E\u91CD\u590D","zh-Hant":"\u6536\u64DA\u526F\u672C"},"EnterCode":{"ar":"\u064A\u0631\u062C\u0649 \u0625\u062F\u062E\u0627\u0644 \u0627\u0644\u0631\u0645\u0632","ca":"Introdueix el codi","comment":"Phrase that comes before the survey code we want the consumer to enter.","cs":"Zadat k\xf3d","da":"Indtast koden","de":"Code eingeben","el":"\u0395\u03B9\u03C3\u03B1\u03B3\u03C9\u03B3\u03AE \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD","en":"Enter the code","en-GB":"Enter the code","en-XA":"[\xc9\xf1\u0163\xe9\u0155\u2002\u0163\u0125\xe9\u2002\xe7\xf6\xf0\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Ingresa el c\xf3digo","es-AR":"Ingresar el c\xf3digo","es-ES":"Introduce el c\xf3digo","es-MX":"Ingresar c\xf3digo","fr":"Saisissez le code","hu":"K\xf3d megad\xe1sa","id":"Masukkan kode","it":"Inserisci il codice","ja":"\u30B3\u30FC\u30C9\u3092\u5165\u529B","key":"EnterCode","ko":"\uCF54\uB4DC\uB97C \uC785\uB825\uD558\uC138\uC694","nb":"Angi kode","nl":"Voer de code in","pl":"Wprowad\u017A kod","pt-PT":"Introduzir o c\xf3digo","ru":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434","sv":"Ange koden","th":"\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E2B\u0E31\u0E2A","tr":"Kodu girin","zh-Hans":"\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801","zh-Hant":"\u8F38\u5165\u4EE3\u78BC"},"GIFTITEMRECEIPT":{"ar":"\u0625\u064A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u062A\u062C \u0627\u0644\u0647\u062F\u064A\u0629","ca":"REBUT DE PRODUCTE DE REGAL","comment":"Title in the receipt to indicate gift items in the transaction","cs":"POLO\u017DKA Z D\xc1RKOV\xc9 KARTY","da":"GAVEPRODUKTKVITTERING","de":"GESCHENKARTIKELBELEG","el":"\u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397 \u0394\u03A9\u03A1\u039FY","en":"GIFT ITEM RECEIPT","en-GB":"GIFT ITEM RECEIPT","en-XA":"[\u011C\xce\u0191\u0162\u2002\xce\u0162\xc9\u1E40\u2002\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"RECIBO DE PRODUCTO PARA REGALO","es-AR":"RECIBO DEL PRODUCTO DE REGALO","es-ES":"RECIBO DE PRODUCTO DE REGALO","es-MX":"RECIBO DEL PRODUCTO DE REGALO","fr":"RE\xc7U D\'ARTICLE OFFERT EN CADEAU","hu":"SZ\xc1MLA \u2013 AJ\xc1ND\xc9KTERM\xc9K","id":"TANDA TERIMA ITEM HADIAH","it":"RICEVUTA ARTICOLO REGALO","ja":"\u30AE\u30D5\u30C8\u5546\u54C1\u306E\u9818\u53CE\u66F8","key":"GIFTITEMRECEIPT","ko":"\uAE30\uD504\uD2B8 \uC544\uC774\uD15C \uC601\uC218\uC99D","nb":"KVITTERING FOR GAVEARTIKKEL","nl":"BON CADEAU","pl":"UPOMINEK (PARAGON)","pt-BR":"RECIBO DO ITEM DE PRESENTE","pt-PT":"RECIBO DO ARTIGO DE OFERTA","ru":"\u0427\u0415\u041A \u041D\u0410 \u041F\u041E\u0414\u0410\u0420\u041E\u0427\u041D\u042B\u0419 \u0422\u041E\u0412\u0410\u0420","sv":"PRESENTKVITTO","th":"\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"HED\u0130YE \xdcR\xdcN MAKBUZU","zh-Hans":"\u793C\u54C1\u6536\u636E","zh-Hant":"\u79AE\u54C1\u6536\u64DA"},"GiftCard":{"ar":"\u0628\u0637\u0627\u0642\u0629 \u0647\u062F\u0627\u064A\u0627","ca":"Tarjeta regalo","comment":"Gift Card item","cs":"D\xe1rkov\xe1 karta","da":"Gavekort","de":"Geschenkgutschein","el":"\u0394\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1","en":"Gift Card","en-GB":"Gift Card","en-XA":"[\u011C\xee\u0192\u0163\u2002\xc7\xe5\u0155\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Gift Card","es-AR":"Tarjeta de regalo","es-ES":"Tarjeta regalo","es-MX":"Tarjeta de regalo","fr":"Gift Card","hu":"Gift Card","id":"Kartu Hadiah","it":"Carta regalo","ja":"\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9","key":"GiftCard","ko":"\uAE30\uD504\uD2B8 \uCE74\uB4DC","nb":"Gavekort","nl":"Cadeaubon","pl":"Karta upominkowa","pt-BR":"Cart\xe3o-presente","pt-PT":"Cart\xe3o de oferta","ru":"\u041F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430","sv":"Presentkort","th":"\u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"Hediye Kart\u0131","zh-Hans":"\u793C\u54C1\u5361","zh-Hant":"\u79AE\u54C1\u5361"},"GiftCertificateRedeem":{"ar":"\u0627\u0633\u062A\u0631\u062F\u0627\u062F \u0627\u0644\u0634\u0647\u0627\u062F\u0629 \u0628\u0627\u0644\u0647\u062F\u064A\u0629","ca":"Canje cheque regalo","comment":"Gift Certificate that is Redeem","cs":"Vr\xe1cen\xed d\xe1rk. cert","da":"Gavecertifikat indl\xf8s","de":"Einl\xf6sung Geschenkgutschein","el":"\u0395\u03BE\u03B1\u03C1\u03B3\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03C4\u03B9\u03BA\u03BF\u03CD \u03B4\u03CE\u03C1\u03BF\u03C5","en":"Gift Certificate Redeem","en-GB":"Gift Certificate Redeem","en-XA":"[\u011C\xee\u0192\u0163\u2002\xc7\xe9\u0155\u0163\xee\u0192\xee\xe7\xe5\u0163\xe9\u2002\u0154\xe9\xf0\xe9\xe9\u0271\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Canje de certificado de regalo","es-AR":"Canje de certificado de regalo","es-ES":"Canje cheque regalo","es-MX":"Canje de vale de regalo","fr":"Utilisation du certificat de cadeau","hu":"Gift Certificate Redeem","id":"Penukaran Sertifikat Hadiah","it":"Utilizzo certificato regalo","ja":"\u5546\u54C1\u5238\u4F7F\u7528","key":"GiftCertificateRedeem","ko":"\uC0C1\uD488\uAD8C \uAD50\uD658","nb":"L\xf8s inn gavekort","nl":"Cadeaubon inwisselen","pl":"Wykorzystanie bonu upominkowego","pt-BR":"Resgate do vale-presente","pt-PT":"Resgate do certificado de oferta","ru":"\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u043E\u0433\u043E \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430","sv":"Inl\xf6sande av presentkort","th":"\u0E41\u0E25\u0E01\u0E43\u0E0A\u0E49\u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"Hediye \xc7eki Kullanma","zh-Hans":"\u793C\u54C1\u5238\u5151\u6362","zh-Hant":"\u79AE\u5377\u514C\u63DB"},"INVALIDRECEIPT":{"ar":"\u0625\u064A\u0635\u0627\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D","ca":"Tiquet no v\xe0lid","comment":"Invalid Receipt Indicator while in training mode","cs":"NEPLATN\xdd DOKLAD","da":"UGYLDIG KVITTERING","de":"Ung\xfcltig","el":"\u039C\u0397 \u0395\u0393\u039A\u03A5\u03A1\u0397 \u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397","en":"INVALID RECEIPT","en-GB":"INVALID RECEIPT","en-XA":"[\xce\xd1\u1E7C\xc5\u013B\xce\xd0\u2002\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"RECIBO NO V\xc1LIDO","es-AR":"RECIBO NO V\xc1LIDO","es-ES":"RECIBO NO V\xc1LIDO","es-MX":"RECIBO NO V\xc1LIDO","fr":"RECU NON VALIDE","hu":"INVALID RECEIPT","id":"TANDA TERIMA TIDAK VALID","it":"RICEVUTA NON VALIDA","ja":"\u7121\u52B9\u30EC\u30B7\u30FC\u30C8","key":"INVALIDRECEIPT","ko":"\uC798\uBABB\uB41C \uC601\uC218\uC99D","nb":"UGYLDIG KVITTERING","nl":"ONGELDIGE BON","pl":"NIEPRAWID\u0141OWY PARAGON","pt-BR":"RECIBO INV\xc1LIDO","pt-PT":"RECIBO INV\xc1LIDO","ru":"\u041D\u0415\u0414\u0415\u0419\u0421\u0422\u0412\u0418\u0422\u0415\u041B\u042C\u041D\u042B\u0419 \u0427\u0415\u041A","sv":"OGILTIGT KVITTO","th":"\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07","tr":"GE\xc7ERS\u0130Z MAKBUZ","zh-Hans":"\u65E0\u6548\u6536\u636E","zh-Hant":"\u7121\u6548\u6536\u64DA"},"IN_ShipStore":{"ar":"\u0644\u0644\u0634\u062D\u0646 - \u0627\u0644\u0645\u062A\u062C\u0631","ca":"Env\xedo - Tienda","comment":"To be shipped - Store","cs":"Chcete-li b\xfdt dod\xe1v\xe1ny - Store","da":"Klar til afsendelse - Store","de":"Lieferanschrift - Store","el":"\u03A0\u03C1\u03BF\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE - \u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1","en":"To be shipped - Store","en-GB":"To be delivered \u2013 Store","en-XA":"[\u0162\xf6\u2002\u0180\xe9\u2002\u0161\u0125\xee\xfe\xfe\xe9\xf0\u2002\u2010\u2002\u0160\u0163\xf6\u0155\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Para enviar: Tienda","es-AR":"Para enviar: Tienda","es-ES":"Env\xedo - Tienda","es-MX":"Para enviar: Tienda","fr":"\xc0 exp\xe9dier - Magasin","hu":"To be shipped - Store","id":"Akan dikirim - Toko","it":"Da spedire - Negozio","ja":"\u767A\u9001\u6E96\u5099\u4E2D - \u5E97\u8217","key":"IN_ShipStore","ko":"\uBC30\uC1A1 \uC608\uC815 - \uB9E4\uC7A5","nb":"Skal sendes \u2013 butikk","nl":"Wordt verzonden - Store","pl":"Do wys\u0142ania \u2013 sklep","pt-BR":"A ser enviado - Loja","pt-PT":"A enviar \u2013 Loja","ru":"\u041E\u0436\u0438\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u2014 \u043C\u0430\u0433\u0430\u0437\u0438\u043D","sv":"Ska levereras \u2013 butik","th":"\u0E15\u0E49\u0E2D\u0E07\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07 - \u0E23\u0E49\u0E32\u0E19","tr":"Kargoya verilecek - Ma\u011Faza","zh-Hans":"\u5F85\u53D1\u8D27 - \u5546\u5E97","zh-Hant":"\u5F85\u904B\u9001\u81F3\uFF1A\u9580\u5E02"},"IN_TobeshippedNike":{"ar":"\u0644\u0644\u0634\u062D\u0646 - Nike.com","ca":"Env\xedo - Nike.com","comment":"To be shipped - Nike.com","cs":"Chcete-li b\xfdt dod\xe1v\xe1ny - Nike.com","da":"Klar til afsendelse - Nike.com","de":"Lieferanschrift - Nike.com","el":"\u03A0\u03C1\u03BF\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE - Nike.com","en":"To be shipped - Nike.com","en-GB":"To be delivered \u2013 Nike.com","en-XA":"[\u0162\xf6\u2002\u0180\xe9\u2002\u0161\u0125\xee\xfe\xfe\xe9\xf0\u2002\u2010\u2002\xd1\xee\u0137\xe9\xb7\xe7\xf6\u0271\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Para enviar: Nike.com","es-AR":"Para enviar: Nike.com","es-ES":"Env\xedo - Nike.com","es-MX":"Para enviar: Nike.com","fr":"\xc0 exp\xe9dier - Nike.com","hu":"To be shipped - Nike.com","id":"Akan dikirim - Nike.com","it":"Da spedire - Nike.com","ja":"\u767A\u9001\u6E96\u5099\u4E2D - Nike.com","key":"IN_TobeshippedNike","ko":"\uBC30\uC1A1 \uC608\uC815 - NIKE.COM","nb":"Skal sendes \u2013 Nike.com","nl":"Wordt verzonden - Nike.com","pl":"Do wys\u0142ania \u2013 Nike.com","pt-BR":"A ser enviado - Nike.com","pt-PT":"A enviar \u2013 Nike.com","ru":"\u041E\u0436\u0438\u0434\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u2014 Nike.com","sv":"Ska levereras \u2013 Nike.com","th":"\u0E15\u0E49\u0E2D\u0E07\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07 - Nike.com","tr":"Kargoya verilecek - Nike.com","zh-Hans":"\u5F85\u53D1\u8D27 - Nike.com","zh-Hant":"\u5F85\u904B\u9001\u81F3\uFF1ANike.com"},"Op":{"ar":"\u0627\u0644\u0645\u0634\u063A\u0644","ca":"Empl","comment":"Abbreviation for Operator Number","cs":"Prov","da":"Op","de":"Vorgang","el":"\u03A7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03AE\u03C2","en":"Op","en-GB":"Op","en-XA":"[\xd6\xfe\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Op.","es-AR":"Op","es-ES":"Empl","es-MX":"Op","fr":"Op","hu":"Op","id":"Op","it":"Op","ja":"\u62C5\u5F53","key":"Op","ko":"\uACC4\uC0B0\uC6D0","nb":"Op","nl":"Op","pl":"Op","pt-BR":"Op","pt-PT":"N.\xba de ope.","ru":"\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F","sv":"Operat\xf6rsnr.","th":"\u0E40\u0E25\u0E02\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23","tr":"Op.","zh-Hans":"\u64CD\u4F5C\u4EBA\u5458\u7F16\u53F7","zh-Hant":"\u6536\u9280\u54E1"},"Operator":{"ar":"\u0627\u0644\u0645\u0634\u063A\u0651\u0644","ca":"Operador","comment":"Operator served the customer","cs":"oper\xe1tora","da":"Operat\xf8r","de":"Bediener","el":"\u03A7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03AE\u03C2","en":"Operator","en-GB":"Operator","en-XA":"[\xd6\xfe\xe9\u0155\xe5\u0163\xf6\u0155\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Operador","es-AR":"Operador","es-ES":"Operador","es-MX":"operador","fr":"Op\xe9rateur","hu":"Operator","id":"Operator","it":"Operatore","ja":"\u62C5\u5F53\u8005","key":"Operator","ko":"\uACC4\uC0B0\uC6D0","nb":"Operat\xf8r","nl":"Operator","pl":"Operator","pt-BR":"Operador","pt-PT":"Operador","ru":"\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440","sv":"Operat\xf6r","th":"\u0E1C\u0E39\u0E49\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23","tr":"Operat\xf6r","zh-Hans":"\u64CD\u4F5C\u4EBA\u5458","zh-Hant":"\u6536\u9280\u54E1"},"OrderId":{"ca":"ID de comanda","comment":"Order ID to be printed at the top of a receipt when a receipt is for an order","cs":"iD objedn\xe1vky","da":"Ordre-ID","de":"Bestellnummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2","en":"Order ID","en-XA":"[\xd6\u0155\xf0\xe9\u0155\u2002\xce\xd0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Identificaci\xf3n del pedido","es-AR":"ID del pedido","es-ES":"ID de pedido","es-MX":"ID del pedido","fr":"Num\xe9ro de commande num\xe9rique","hu":"Rendel\xe9si azonos\xedt\xf3","it":"ID ordine","ja":"\u3054\u6CE8\u6587ID","key":"OrderId","ko":"\uC8FC\uBB38 ID","nb":"Bestillings-ID","nl":"Bestelnummer","pl":"ID zam\xf3wienia","pt-PT":"ID da encomenda","ru":"ID \u0437\u0430\u043A\u0430\u0437\u0430","sv":"Best\xe4llnings-id","tr":"Sipari\u015F ID","zh-Hans":"\u6570\u5B57\u8BA2\u5355\u7F16\u53F7","zh-Hant":"\u8A02\u55AE\u7DE8\u865F"},"OriginalTran":{"ar":"\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629","ca":"Trans. orig.","comment":"Abbreviation for Original Transaction","cs":"P\u016Fv. tran","da":"Oprindelig trans","de":"Original-Transaktion","el":"\u0391\u03C1\u03C7\u03B9\u03BA\u03AE \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE","en":"Original Tran","en-GB":"Original Tran","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\u0162\u0155\xe5\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Trans. original","es-AR":"Trans. original","es-ES":"Trans. orig.","es-MX":"Trans. original","fr":"Tran Originale","hu":"Original Tran","id":"Transaksi Awal","it":"Trans. originale","ja":"\u8CA9\u58F2\u756A\u53F7","key":"OriginalTran","ko":"\uAE30\uC874 \uAC70\uB798","nb":"Opprinnelig trans.","nl":"Originele trans","pl":"Oryginalna transakcja","pt-BR":"Transa\xe7\xe3o original","pt-PT":"Trans. original","ru":"\u0418\u0441\u0445\u043E\u0434\u043D\u0430\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F","sv":"Ursprunglig trans.","th":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E40\u0E14\u0E34\u0E21","tr":"Orijinal \u0130\u015Fl.","zh-Hans":"\u539F\u59CB\u4EA4\u6613","zh-Hant":"\u539F\u59CB\u4EA4\u6613"},"OriginalTranDate":{"ar":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A","ca":"Fecha trans. orig.","comment":"Abbreviation for Original Transaction Date","cs":"Datum p\u016Fv. tran","da":"Oprindelig trans. dato","de":"Datum der Original-Transaktion","el":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Original Tran Date","en-GB":"Original Tran Date","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\u0162\u0155\xe5\xf1\u2002\xd0\xe5\u0163\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Fecha de trans. original","es-AR":"Fecha de trans. original","es-ES":"Fecha trans. orig.","es-MX":"Fecha de trans. original","fr":"Date Tran Originale","hu":"Original Tran Date","id":"Tanggal Transaksi Awal","it":"Data originale transazione","ja":"\u8CA9\u58F2\u65E5","key":"OriginalTranDate","ko":"\uAE30\uC874 \uAC70\uB798 \uB0A0\uC9DC","nb":"Opprinnelig transaksjonsdato","nl":"Originele trans.datum","pl":"Data oryginalnej transakcji","pt-BR":"Data da transa\xe7\xe3o original","pt-PT":"Data da trans. original","ru":"\u0414\u0430\u0442\u0430 \u0438\u0441\u0445\u043E\u0434\u043D\u043E\u0439 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Ursprungligt trans. datum","th":"\u0E27\u0E31\u0E19\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E40\u0E14\u0E34\u0E21","tr":"Orijinal \u0130\u015Fl. Tarihi","zh-Hans":"\u539F\u59CB\u4EA4\u6613\u65E5\u671F","zh-Hant":"\u539F\u59CB\u4EA4\u6613\u65E5\u671F"},"OriginalTranReg":{"ar":"\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629","ca":"Caixa de transacci\xf3 original","comment":"Abbreviation for Original Transaction Register","cs":"Pokladna p\u016Fvodn\xed transakce","da":"Oprindelig transaktionskasse","de":"Urspr\xfcngliche Transaktionskasse","el":"\u03A4\u03B1\u03BC\u03B5\u03AF\u03BF \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Original Tran Reg","en-GB":"Original Tran Reg","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\u0162\u0155\xe5\xf1\u2002\u0154\xe9\u011D\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Registro de transacci\xf3n original","es-AR":"Caja de trans. original","es-ES":"Reg. trans. orig.","es-MX":"Caja de trans. original","fr":"Caisse transaction d\'origine","hu":"Eredeti kasszatranzakci\xf3","id":"Reg Trans Awal","it":"Cassa transazione originale","ja":"\u521D\u56DE\u53D6\u5F15\u30EC\u30B8","key":"OriginalTranReg","ko":"\uAE30\uC874 \uAC70\uB798 \uB4F1\uB85D","nb":"Kasse for opprinnelig transaksjon","nl":"Kassa originele trans.","pl":"Kasa oryg. trans.","pt-BR":"Reg Trans original","pt-PT":"Caixa reg. da trans. original","ru":"\u041A\u0430\u0441\u0441\u0430 \u0438\u0441\u0445\u043E\u0434\u043D\u043E\u0439 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Ursprunglig trans. reg.","th":"\u0E40\u0E25\u0E02\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E40\u0E14\u0E34\u0E21","tr":"Orijinal \u0130\u015Fl. Kayd\u0131","zh-Hans":"\u539F\u59CB\u4EA4\u6613\u6536\u94F6\u673A\u7F16\u53F7","zh-Hant":"\u539F\u59CB\u4EA4\u6613\u6536\u9280\u6A5F\u7DE8\u865F"},"OriginalTranTime":{"ar":"\u0648\u0642\u062A \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A","ca":"Hora trans. orig.","comment":"Abbreviation for Original Transaction Time","cs":"\u010Cas p\u016Fv. tran","da":"Oprindelig trans. tidspunkt","de":"Uhrzeit der urspr\xfcnglichen Transaktion","el":"\u038F\u03C1\u03B1 \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Original Tran Time","en-GB":"Original Tran Time","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\u0162\u0155\xe5\xf1\u2002\u0162\xee\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Hora de trans. original","es-AR":"Hora de trans. original","es-ES":"Original Tran Time","es-MX":"Hora de trans. original","fr":"Heure Tram Originale","hu":"Original Tran Time","id":"Waktu Tran Awal","it":"Ora transazione originale","ja":"\u8CA9\u58F2\u6642\u9593","key":"OriginalTranTime","ko":"\uAE30\uC874 \uAC70\uB798 \uC2DC\uAC04","nb":"Opprinnelig transaksjonstid","nl":"Originele trans.tijd","pl":"Oryginalny czas transakcji","pt-BR":"Tempo de transa\xe7\xe3o original","pt-PT":"Hora da trans. original","ru":"\u0412\u0440\u0435\u043C\u044F \u0438\u0441\u0445\u043E\u0434\u043D\u043E\u0439 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Ursprunglig trans. tid","th":"\u0E40\u0E27\u0E25\u0E32\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E40\u0E14\u0E34\u0E21","tr":"Orijinal \u0130\u015Fl. Saati","zh-Hans":"\u539F\u59CB\u4EA4\u6613\u65F6\u95F4","zh-Hant":"\u539F\u59CB\u4EA4\u6613\u6642\u9593"},"RF_CheckstatusonNikecom":{"ar":"\u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u0627\u0644\u062D\u0627\u0644\u0629 \u0639\u0644\u0649 Nike.com","ca":"Compruebe el estado en Nike.com","comment":"phrase of the receipt which says the customer to check the status in nike.com website","cs":"Ov\u011B\u0159te stav na webu Nike.com","da":"Tjek status p\xe5 Nike.com","de":"Status auf Nike.com pr\xfcfen:","el":"\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2 \u03C3\u03C4\u03BF Nike.com","en":"Check status on Nike.com","en-GB":"Check status on Nike.com","en-XA":"[\xc7\u0125\xe9\xe7\u0137\u2002\u0161\u0163\xe5\u0163\xfb\u0161\u2002\xf6\xf1\u2002\xd1\xee\u0137\xe9\xb7\xe7\xf6\u0271\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Verifique el estado en Nike.com","es-AR":"Verifique el estado en Nike.com","es-ES":"Compruebe el estado en Nike.com","es-MX":"Check status on Nike.com","fr":"Consulter le statut sur Nike.com:","hu":"Check status on Nike.com","id":"Periksa status di Nike.com","it":"Controlla lo stato su Nike.com","ja":"Check status on Nike.com","key":"RF_CheckstatusonNikecom","ko":"NIKE.COM\uC5D0\uC11C \uC0C1\uD0DC \uD655\uC778","nb":"Sjekk statusen p\xe5 Nike.com","nl":"Status controleren op Nike.com","pl":"Sprawd\u017A status zam\xf3wienia na Nike.com","pt-BR":"Verifique o status em Nike.com","pt-PT":"Verificar o estado em Nike.com","ru":"\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0441\u0442\u0430\u0442\u0443\u0441 \u043D\u0430 \u0441\u0430\u0439\u0442\u0435 Nike.com","sv":"Kontrollera statusen p\xe5 Nike.com","th":"\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E1A\u0E19 Nike.com","tr":"Durumu Nike.com\'dan kontrol et","zh-Hans":"\u5728 Nike.com \u4E0A\u67E5\u770B\u72B6\u6001","zh-Hant":"\u5230 Nike.com \u67E5\u770B\u72C0\u614B"},"RF_EmployeeVendorNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0645\u0648\u0638\u0641/\u0627\u0644\u0628\u0627\u0626\u0639","ca":"N.\xba empleado/vendedor","comment":"Employee/ Vendor Number for Employee Discount","cs":"Zam\u011Bst./Obchod. \u010D\xedslo","da":"Medarbejder/S\xe6lgernummer","de":"Angestellte / H\xe4ndler Nummer:","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B5\u03C1\u03B3\u03B1\u03B6\u03BF\u03BC\u03AD\u03BD\u03BF\u03C5/\u03C0\u03C1\u03BF\u03BC\u03B7\u03B8\u03B5\u03C5\u03C4\u03AE","en":"Employee/Vendor Number","en-GB":"Employee/Vendor Number","en-XA":"[\xc9\u0271\xfe\u013C\xf6\xfd\xe9\xe9\u2044\u1E7C\xe9\xf1\xf0\xf6\u0155\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de empleado/proveedor","es-AR":"N\xfamero de empleado/proveedor","es-ES":"N.\xba empleado/vendedor","es-MX":"N\xfamero de empleado/proveedor","fr":"Num\xe9ro employ\xe9/fournisseur","hu":"Employee/Vendor Number","id":"Nomor Karyawan/Vendor","it":"Numero dipendente/venditore","ja":"\u793E\u54E1/\u30D9\u30F3\u30C0\u30FC \u756A\u53F7","key":"RF_EmployeeVendorNumber","ko":"\uC9C1\uC6D0/\uBCA4\uB354 \uBC88\uD638","nb":"Ansatt-/leverand\xf8rnummer","nl":"Werknemer/leveranciersnummer","pl":"Numer pracownika/sprzedawcy","pt-BR":"N\xfamero do funcion\xe1rio/fornecedor","pt-PT":"N\xfamero de funcion\xe1rio/fornecedor","ru":"\u041D\u043E\u043C\u0435\u0440 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430/\u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0430","sv":"Medarbetar-/Leverant\xf6rsnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19/\u0E1C\u0E39\u0E49\u0E08\u0E33\u0E2B\u0E19\u0E48\u0E32\u0E22","tr":"\xc7al\u0131\u015Fan/Sat\u0131c\u0131 Numaras\u0131","zh-Hans":"\u5458\u5DE5/\u4F9B\u5E94\u5546\u7F16\u53F7","zh-Hant":"\u54E1\u5DE5/\u5EE0\u5546\u7DE8\u865F"},"RF_GIFTITEMRECEIPT":{"ar":"\u0625\u064A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u062A\u062C \u0627\u0644\u0647\u062F\u064A\u0629","ca":"RECIBO ART\xcdC. REGALO","comment":"Header of the receipt indicates the recipt of Gift Item","cs":"DARK. POL.-UCET","da":"GAVEVARE KVITTERING","de":"GESCHENKARTIKEL-QUITTUNG","el":"\u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397 \u0394\u03A9\u03A1\u039F\u03A5","en":"GIFT ITEM RECEIPT","en-GB":"GIFT ITEM RECEIPT","en-XA":"[\u011C\xce\u0191\u0162\u2002\xce\u0162\xc9\u1E40\u2002\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"RECIBO DE ART\xcdCULO DE REGALO","es-AR":"RECIBO DE ART\xcdCULO DE REGALO","es-ES":"RECIBO ART\xcdC. REGALO","es-MX":"RECIBO DE ART\xcdCULO DE REGALO","fr":"RE\xc7U ARTICLE CADEAU","hu":"GIFT ITEM RECEIPT","id":"TANDA TERIMA ITEM HADIAH","it":"RICEVUTA ARTICOLO REGALO","ja":"\u30AE\u30D5\u30C8\u5546\u54C1\u30EC\u30B7\u30FC\u30C8","key":"RF_GIFTITEMRECEIPT","ko":"\uAE30\uD504\uD2B8 \uC544\uC774\uD15C \uC601\uC218\uC99D","nb":"KVITTERING FOR GAVEARTIKKEL","nl":"BON CADEAU","pl":"UPOMINEK (PARAGON)","pt-BR":"RECIBO DO ITEM DE PRESENTE","pt-PT":"RECIBO DO ARTIGO DE OFERTA","ru":"\u0427\u0415\u041A \u041D\u0410 \u041F\u041E\u0414\u0410\u0420\u041E\u0427\u041D\u042B\u0419 \u0422\u041E\u0412\u0410\u0420","sv":"PRESENTKVITTO","th":"\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"HED\u0130YE \xdcR\xdcN MAKBUZU","zh-Hans":"\u793C\u54C1\u6536\u636E","zh-Hant":"\u79AE\u54C1\u6536\u64DA"},"RF_Telephone":{"ar":"\u0627\u0644\u0647\u0627\u062A\u0641","ca":"Tel\xe9fono.","comment":"Sotre telephone number","cs":"Telefon","da":"Telefon","de":"Telefon","el":"\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF","en":"Telephone","en-GB":"Telephone","en-XA":"[\u0162\xe9\u013C\xe9\xfe\u0125\xf6\xf1\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tel\xe9fono","es-AR":"Tel\xe9fono","es-ES":"Tel.","es-MX":"Tel\xe9fono","fr":"T\xe9l\xe9phone","hu":"Telephone","id":"Telepon","it":"Telefono","ja":"\u96FB\u8A71\u756A\u53F7","key":"RF_Telephone","ko":"Tel","nb":"Telefon","nl":"Telefoon","pl":"Telefon","pt-BR":"Telefone","pt-PT":"Telefone","ru":"\u0422\u0435\u043B\u0435\u0444\u043E\u043D","sv":"Telefon","th":"\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C","tr":"Telefon","zh-Hans":"\u7535\u8BDD\u53F7\u7801","zh-Hant":"\u96FB\u8A71\u865F\u78BC"},"RL_ABORTED":{"ar":"\u062A\u0645\u0651 \u0625\u0644\u063A\u0627\u0621 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"TRANS. ANULADA","comment":"A line in receipt indicates the transaction is aborted since it is voided.","cs":"TRANSACTION ABORTED","da":"TRANSAKTION AFBRUDT","de":"TRANSAKTION ABGEBROCHEN","el":"\u039C\u0391\u03A4\u0391\u0399\u03A9\u03A3\u0397 \u03A3\u03A5\u039D\u0391\u039B\u039B\u0391\u0393\u0397\u03A3","en":"TRANSACTION ABORTED","en-GB":"TRANSACTION ABORTED","en-XA":"[\u0162\u0154\xc5\xd1\u0160\xc5\xc7\u0162\xce\xd6\xd1\u2002\xc5\u0181\xd6\u0154\u0162\xc9\xd0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"TRANSACCI\xd3N CANCELADA","es-AR":"TRANSACCI\xd3N CANCELADA","es-ES":"TRANS. ANULADA","es-MX":"TRANSACCI\xd3N CANCELADA","fr":"TRANSACTION ANNULEE","hu":"TRANSACTION ABORTED","id":"TRANSAKSI DIBATALKAN","it":"TRANSAZIONE ABBANDONATA","ja":"\u4E2D\u6B62","key":"RL_ABORTED","ko":"\uAC70\uB798 \uC911\uB2E8\uB428","nb":"AVBRUTT TRANSAKSJON","nl":"TRANSACTIE AFGEBROKEN","pl":"TRANSAKCJA PRZERWANA","pt-BR":"TRANSA\xc7\xc3O CANCELADA","pt-PT":"TRANSA\xc7\xc3O ABORTADA","ru":"TRANSACTION ABORTED","sv":"TRANSAKTION AVBRUTEN","th":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E16\u0E39\u0E01\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01","tr":"\u0130\u015ELEM \u0130PTAL ED\u0130LD\u0130","zh-Hans":"\u4EA4\u6613\u5DF2\u4E2D\u6B62","zh-Hant":"\u4EA4\u6613\u4E2D\u6B62"},"RL_Address":{"ar":"\u0627\u0644\u0639\u0646\u0648\u0627\u0646","ca":"Direc","comment":"Address line in receipt","cs":"Adresa","da":"Adresse","de":"Addresse","el":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7","en":"Address","en-GB":"Address","en-XA":"[\xc5\xf0\xf0\u0155\xe9\u0161\u0161\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Direcci\xf3n","es-AR":"Direcci\xf3n","es-ES":"Direcci\xf3n","es-MX":"Direcci\xf3n","fr":"Address","hu":"Address","id":"Alamat","it":"Indirizzo","ja":"\u4F4F\u6240","key":"RL_Address","ko":"\uC8FC\uC18C","nb":"Adresse","nl":"Adres","pl":"Adres","pt-BR":"Endere\xe7o","pt-PT":"Morada","ru":"\u0410\u0434\u0440\u0435\u0441","sv":"Adress","th":"\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48","tr":"Adres","zh-Hans":"\u914D\u9001\u5730\u5740","zh-Hant":"\u5730\u5740"},"RL_Aid":{"ar":"\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062A\u0637\u0628\u064A\u0642","ca":"Aid","comment":"Aid in receipt","cs":"Aid","da":"Aid","de":"Aid","el":"Aid","en":"Aid","en-GB":"Aid","en-XA":"[\xc5\xee\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Ayuda","es-AR":"Ayuda","es-ES":"Aid","es-MX":"Ayuda","fr":"Aid","hu":"Aid","id":"Bantuan","it":"Aid","ja":"Aid","key":"RL_Aid","ko":"\uC9C0\uC6D0","nb":"Hjelp","nl":"Aid","pl":"Aid","pt-BR":"Ajuda","pt-PT":"Ajuda","ru":"\u041F\u043E\u043C\u043E\u0449\u044C","sv":"St\xf6d","th":"Aid","tr":"Aid","zh-Hans":"\u5546\u54C1\u8BC6\u522B\u7801","zh-Hant":"\u61C9\u7528\u8B58\u5225\u78BC"},"RL_Amount":{"ar":"\u0627\u0644\u0645\u0628\u0644\u063A","ca":"Ctdad","comment":"Amount of the item in receipt","cs":"C\xe1stka","da":"bel\xf8b","de":"Amount","el":"\u03A0\u03BF\u03C3\u03CC","en":"Amount","en-GB":"Amount","en-XA":"[\xc5\u0271\xf6\xfb\xf1\u0163\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Importe","es-AR":"Importe","es-ES":"Ctdad","es-MX":"Importe","fr":"Montant","hu":"Amount","id":"Jumlah","it":"Importo","ja":"\u91D1\u984D","key":"RL_Amount","ko":"\uAE08\uC561","nb":"Bel\xf8p","nl":"Bedrag","pl":"Kwota","pt-BR":"Valor","pt-PT":"Montante","ru":"\u0421\u0443\u043C\u043C\u0430","sv":"Belopp","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19","tr":"Tutar","zh-Hans":"\u91D1\u989D","zh-Hant":"\u6578\u91CF"},"RL_AmountPaid":{"ar":"\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062F\u0641\u0648\u0639","ca":"Ctdad Pagada","comment":"Paid amount in receipt ","cs":"Zaplac. c\xe1stka","da":"Betalt bel\xf8b","de":"Summe Paid","el":"\u03A0\u03BB\u03B7\u03C1\u03C9\u03B8\u03AD\u03BD \u03C0\u03BF\u03C3\u03CC","en":"Amount Paid","en-GB":"Amount Paid","en-XA":"[\xc5\u0271\xf6\xfb\xf1\u0163\u2002\xde\xe5\xee\xf0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Importe pagado","es-AR":"Importe pagado","es-ES":"Ctdad Pagada","es-MX":"Importe pagado","fr":"Montant pay\xe9","hu":"Amount Paid","id":"Jumlah Dibayarkan","it":"Importo pagato","ja":"\u652F\u6255\u6E08\u91D1\u984D","key":"RL_AmountPaid","ko":"\uACB0\uC81C \uC608\uC815 \uAE08\uC561","nb":"Bel\xf8p betalt","nl":"Betaald bedrag","pl":"Kwota zap\u0142acona","pt-BR":"Valor pago","pt-PT":"Montante pago","ru":"\u0412\u044B\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430","sv":"Betalat belopp","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E08\u0E48\u0E32\u0E22","tr":"\xd6denen Tutar","zh-Hans":"\u652F\u51FA\u91D1\u989D","zh-Hant":"\u5BE6\u4ED8\u91D1\u984D"},"RL_AmountRange":{"ar":"\u0646\u0637\u0627\u0642 \u0627\u0644\u0645\u0628\u0644\u063A","ca":"Interval d\'imports","comment":"Amount Range - the minimum and maximum amount to look up transactions.","cs":"Rozp\u011Bt\xed \u010D\xe1stek","da":"Bel\xf8bsinterval","de":"Mengenbereich","el":"\u0395\u03CD\u03C1\u03BF\u03C2 \u03C0\u03BF\u03C3\u03CE\u03BD","en":"Amount Range","en-GB":"Amount Range","en-XA":"[\xc5\u0271\xf6\xfb\xf1\u0163\u2002\u0154\xe5\xf1\u011D\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Intervalo de monto","es-AR":"Rango de importe","es-ES":"Rango de importe","es-MX":"Rango del monto","fr":"Plage de montant","hu":"\xd6sszegtartom\xe1ny","id":"Rentang Jumlah","it":"Intervallo importi","ja":"\u91D1\u984D\u7BC4\u56F2","key":"RL_AmountRange","ko":"\uAE08\uC561 \uBC94\uC704","nb":"Bel\xf8psomr\xe5de","nl":"Bedragbereik","pl":"Przedzia\u0142 kwotowy","pt-BR":"Faixa de valores","pt-PT":"Intervalo de valor","ru":"\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0441\u0443\u043C\u043C\u044B","sv":"Beloppsintervall","th":"\u0E0A\u0E48\u0E27\u0E07\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19","tr":"Tutar Aral\u0131\u011F\u0131","zh-Hans":"\u91D1\u989D\u8303\u56F4","zh-Hant":"\u91D1\u984D\u7BC4\u570D"},"RL_AmountReturned":{"ar":"\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0630\u064A \u062A\u0645 \u0625\u0631\u062C\u0627\u0639\u0647 \u0625\u0644\u0649 \u0627\u0644\u0639\u0645\u064A\u0644","ca":"Importe reembolsado al cliente","comment":"Indicates the amount refunded to customer in receipt","cs":"\u010C\xe1stka vr\xe1cen\xe1 z\xe1kazn\xedkovi","da":"Bel\xf8b refunderet til kunde","de":"Amount Refunded To Customer","el":"\u03A0\u03BF\u03C3\u03CC \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03C7\u03C1\u03B7\u03BC\u03AC\u03C4\u03C9\u03BD \u03C3\u03B5 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7","en":"Amount Refunded To Customer","en-GB":"Amount Refunded To Customer","en-XA":"[\xc5\u0271\xf6\xfb\xf1\u0163\u2002\u0154\xe9\u0192\xfb\xf1\xf0\xe9\xf0\u2002\u0162\xf6\u2002\xc7\xfb\u0161\u0163\xf6\u0271\xe9\u0155\u2002\xe5\u0180\xe7\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Monto reembolsado al consumidor","es-AR":"Monto reembolsado al cliente","es-ES":"Importe reembolsado al cliente","es-MX":"Monto reembolsado al cliente","fr":"Montant rembours\xe9 au client","hu":"Amount Refunded To Customer","id":"Jumlah yang Dikembalikan kepada Pelanggan","it":"Importo rimborsato al cliente","ja":"\u304A\u5BA2\u69D8\u3078\u306E\u8FD4\u91D1\u984D","key":"RL_AmountReturned","ko":"\uACE0\uAC1D\uC5D0\uAC8C \uD658\uBD88\uB41C \uAE08\uC561","nb":"Bel\xf8p refundert til kunde","nl":"Bedrag gerestitueerd aan de klant","pl":"Kwota zwr\xf3cona klientowi","pt-BR":"Valor reembolsado ao Cliente","pt-PT":"Valor reembolsado ao cliente","ru":"\u0421\u0443\u043C\u043C\u0430, \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u043D\u0430\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0443","sv":"Belopp \xe5terbetalat till kunden","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E04\u0E37\u0E19\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32","tr":"T\xfcketiciye \u0130ade Edilen Tutar","zh-Hans":"\u987E\u5BA2\u6536\u5230\u9000\u6B3E\u91D1\u989D","zh-Hant":"\u9867\u5BA2\u9000\u6B3E\u91D1\u984D"},"RL_AppName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u062A\u0637\u0628\u064A\u0642","ca":"Nom de l\'aplicaci\xf3","comment":"Name of the front end application name in the certificate. Certificate is the audit certificate that\'s gives the approval to trade.","cs":"N\xe1zev aplikace","da":"Programnavn","de":"Anwendungsname","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2","en":"Application Name","en-GB":"Application name","en-XA":"[\xc5\xfe\xfe\u013C\xee\xe7\xe5\u0163\xee\xf6\xf1\u2002\xd1\xe5\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre de la app","es-AR":"Nombre de la aplicaci\xf3n","es-ES":"Nombre de la aplicaci\xf3n","es-MX":"Nombre de la app","fr":"Nom de l\'application","hu":"Alkalmaz\xe1s neve","id":"Nama Aplikasi","it":"Nome applicazione","ja":"\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u540D","key":"RL_AppName","ko":"\uC560\uD50C\uB9AC\uCF00\uC774\uC158 \uC774\uB984","nb":"Applikasjonsnavn","nl":"Applicatienaam","pl":"Nazwa aplikacji","pt-BR":"Nome do aplicativo","pt-PT":"Nome da aplica\xe7\xe3o","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F","sv":"Appens namn","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E41\u0E2D\u0E1E\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19","tr":"Uygulama Ad\u0131","zh-Hans":"\u5E94\u7528\u7A0B\u5E8F\u540D\u79F0","zh-Hant":"\u61C9\u7528\u7A0B\u5F0F\u540D\u7A31"},"RL_AppVersion":{"ar":"\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u062A\u0637\u0628\u064A\u0642","ca":"Versi\xf3 de l\'aplicaci\xf3","comment":"Version of the application ","cs":"Verze aplikace","da":"Programversion","de":"Anwendungsversion","el":"\u0388\u03BA\u03B4\u03BF\u03C3\u03B7 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE\u03C2","en":"Application Version","en-GB":"Application version","en-XA":"[\xc5\xfe\xfe\u013C\xee\xe7\xe5\u0163\xee\xf6\xf1\u2002\u1E7C\xe9\u0155\u0161\xee\xf6\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Versi\xf3n de la app","es-AR":"Versi\xf3n de la aplicaci\xf3n","es-ES":"Versi\xf3n de la aplicaci\xf3n","es-MX":"Versi\xf3n de la app","fr":"Version de l\'application","hu":"Alkalmaz\xe1s verzi\xf3ja","id":"Versi Aplikasi","it":"Versione dell\'applicazione","ja":"\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u306E\u30D0\u30FC\u30B8\u30E7\u30F3","key":"RL_AppVersion","ko":"\uC560\uD50C\uB9AC\uCF00\uC774\uC158 \uBC84\uC804","nb":"Applikasjonsversjon","nl":"Versie van app","pl":"Wersja aplikacji","pt-BR":"Vers\xe3o do aplicativo","pt-PT":"Vers\xe3o da aplica\xe7\xe3o","ru":"\u0412\u0435\u0440\u0441\u0438\u044F \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F","sv":"Appversion","th":"\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E41\u0E2D\u0E1E\u0E1E\u0E25\u0E34\u0E40\u0E04\u0E0A\u0E31\u0E19","tr":"Uygulama S\xfcr\xfcm\xfc","zh-Hans":"\u5E94\u7528\u7A0B\u5E8F\u7248\u672C","zh-Hant":"\u61C9\u7528\u7A0B\u5F0F\u7248\u672C"},"RL_ApprovalDateTime":{"ar":"\u062A\u0627\u0631\u064A\u062E \u0648\u0648\u0642\u062A \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629","ca":"Data i hora d\'aprovaci\xf3","comment":"The date and time when the payment was approved by the payment vendor. ","cs":"Datum \u010Das schv\xe1len\xed","da":"Godkendelsesdato og -tidspunkt","de":"Genehmigungsdatum und -uhrzeit","el":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03CE\u03C1\u03B1 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7\u03C2","en":"Approval Date Time","en-GB":"Approval Date Time","en-XA":"[\xc5\xfe\xfe\u0155\xf6\u1E7D\xe5\u013C\u2002\xd0\xe5\u0163\xe9\u2002\u0162\xee\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Fecha y hora de aprobaci\xf3n","es-AR":"Fecha y hora de aprobaci\xf3n","es-ES":"Fecha y hora de la autorizaci\xf3n","es-MX":"Hora y fecha de aprobaci\xf3n","fr":"Date et heure de l\'approbation","hu":"J\xf3v\xe1hagy\xe1s d\xe1tuma \xe9s id\u0151pontja","id":"Tanggal Waktu Persetujuan","it":"Data e ora dell\'approvazione","ja":"\u627F\u8A8D\u3055\u308C\u305F\u65E5\u6642","key":"RL_ApprovalDateTime","ko":"\uC2B9\uC778 \uC77C\uC2DC","nb":"Godkjenning dato klokkeslett","nl":"Datum en tijd van goedkeuring","pl":"Data i czas akceptacji","pt-BR":"Data e hora da aprova\xe7\xe3o","pt-PT":"Data e hora de aprova\xe7\xe3o","ru":"\u0414\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F","sv":"Datum och tid f\xf6r godk\xe4nnande","th":"\u0E40\u0E27\u0E25\u0E32\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34","tr":"Onay Tarihi ve Saati","zh-Hans":"\u6279\u51C6\u65E5\u671F\u548C\u65F6\u95F4","zh-Hant":"\u6838\u51C6\u65E5\u671F\u8207\u6642\u9593"},"RL_ApprovalNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629","ca":"N\xfamero d\'aprovaci\xf3","comment":"Approval Number received after the payment is complete. ","cs":"\u010C\xedslo schv\xe1len\xed","da":"Godkendelsesnummer","de":"Genehmigungsnummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7\u03C2","en":"Approval Number","en-GB":"Approval Number","en-XA":"[\xc5\xfe\xfe\u0155\xf6\u1E7D\xe5\u013C\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de aprobaci\xf3n","es-AR":"N\xfamero de aprobaci\xf3n","es-ES":"N\xfamero de aprobaci\xf3n","es-MX":"N\xfamero de aprobaci\xf3n","fr":"Num\xe9ro d\'approbation","hu":"J\xf3v\xe1hagy\xe1si sz\xe1m","id":"Nomor Persetujuan","it":"Numero approvazione","ja":"\u627F\u8A8D\u756A\u53F7","key":"RL_ApprovalNumber","ko":"\uC2B9\uC778 \uBC88\uD638","nb":"Godkjenningsnummer","nl":"Goedkeuringsnummer","pl":"Numer zatwierdzenia","pt-BR":"N\xfamero de aprova\xe7\xe3o","pt-PT":"N\xfamero de aprova\xe7\xe3o","ru":"\u041D\u043E\u043C\u0435\u0440 \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F","sv":"Godk\xe4nnandenummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34","tr":"Onay Numaras\u0131","zh-Hans":"\u6279\u51C6\u53F7","zh-Hant":"\u6838\u51C6\u7DE8\u865F"},"RL_ApproverOperatorID":{"ar":"\u062A\u062A\u0645 \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0639\u0644\u0649 \u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u0645\u0634\u063A\u0651\u0644","ca":"Codigo Op Aprobador:","comment":"Id of the approving operator in receipt","cs":"ID schval. oper\xe1tora","da":"Godkendende operator-ID","de":"Genehmigen Bediener-ID","el":"\u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03B5\u03BE\u03BF\u03C5\u03C3\u03B9\u03BF\u03B4\u03BF\u03C4\u03B7\u03BC\u03AD\u03BD\u03BF\u03C5 \u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03AE","en":"Approving Operator ID","en-GB":"Approving Operator ID","en-XA":"[\xc5\xfe\xfe\u0155\xf6\u1E7D\xee\xf1\u011D\u2002\xd6\xfe\xe9\u0155\xe5\u0163\xf6\u0155\u2002\xce\xd0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Aprobando Id. de operador:","es-AR":"Aprobando Id. de operador","es-ES":"Codigo Op Aprobador:","es-MX":"Aprobando Id. de operador:","fr":"Manager ID","hu":"Approving Operator ID","id":"ID Operator Pemberi Persetujuan","it":"Approvazione ID operatore","ja":"\u30AA\u30DA\u30EC\u30FC\u30BF\u30FCID\u3092\u627F\u8A8D\u4E2D","key":"RL_ApproverOperatorID","ko":"\uC2B9\uC778 \uC6B4\uC601\uC790 ID","nb":"Godkjenner operat\xf8r-ID","nl":"ID goedkeurende operator","pl":"ID operatora zatwierdzaj\u0105cego","pt-BR":"ID do operador aprovador","pt-PT":"ID do operador autor da aprova\xe7\xe3o","ru":"\u041D\u043E\u043C\u0435\u0440 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0432\u0448\u0435\u0433\u043E \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0430","sv":"Godk\xe4nnares id","th":"ID \u0E1C\u0E39\u0E49\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E2D\u0E19\u0E38\u0E21\u0E31\u0E15\u0E34","tr":"Onaylayan Operat\xf6r Kimli\u011Fi","zh-Hans":"\u5BA1\u6838\u64CD\u4F5C\u4EBA\u5458 ID","zh-Hant":"\u6838\u51C6\u6536\u9280\u54E1 ID"},"RL_AthleteLoginNumber":{"ar":"\u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u062F\u062E\u0648\u0644 \u0627\u0644\u0645\u0648\u0638\u0641 \u0628\u062F\u0631\u062C\u0629 Athlete","ca":"N\xfamero d\'inici de sessi\xf3 de l\'atleta","comment":"Login Id or number of the athlete ","cs":"P\u0159ihla\u0161ovac\xed \u010D\xedslo Athlete","da":"Loginnummer for Athlete","de":"Login-Nummer des Athlete","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2 Athlete","en":"Athlete Login Number","en-GB":"Athlete Login Number","en-XA":"[\xc5\u0163\u0125\u013C\xe9\u0163\xe9\u2002\u013B\xf6\u011D\xee\xf1\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de inicio de sesi\xf3n del Athlete","es-AR":"N\xfamero de inicio de sesi\xf3n del athlete","es-ES":"N\xfamero de inicio de sesi\xf3n del athlete","es-MX":"N\xfamero de inicio de sesi\xf3n del Athlete","fr":"Num\xe9ro de connexion de l\'Athlete","hu":"Athlete bejelentkez\xe9si azonos\xedt\xf3ja","id":"Nomor Login Athlete","it":"Numero credenziali Athlete","ja":"\u30A2\u30B9\u30EA\u30FC\u30C8\u306E\u30ED\u30B0\u30A4\u30F3\u756A\u53F7","key":"RL_AthleteLoginNumber","ko":"Athlete \uB85C\uADF8\uC778 \uBC88\uD638","nb":"Athlete innloggingsnummer","nl":"Inlognummer Athlete","pl":"Numer logowania Athlete","pt-BR":"N\xfamero de login do Athlete","pt-PT":"N\xfamero de in\xedcio de sess\xe3o do Athlete","ru":"\u041D\u043E\u043C\u0435\u0440 \u0430\u0442\u043B\u0435\u0442\u0430 \u0434\u043B\u044F \u0432\u0445\u043E\u0434\u0430","sv":"Inloggningsnummer f\xf6r Athlete","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E25\u0E47\u0E2D\u0E01\u0E2D\u0E34\u0E19 Athlete","tr":"Athlete Oturum A\xe7ma Numaras\u0131","zh-Hans":"Athlete \u767B\u5F55\u53F7","zh-Hant":"Athlete \u767B\u5165\u865F\u78BC"},"RL_AuthCode":{"ar":"\u0631\u0645\u0632 \u0627\u0644\u062A\u0631\u062E\u064A\u0635","ca":"C\xf3digo Autoriz","comment":"Authentication  code for gift card in receipt","cs":"Autor. k\xf3d","da":"Aut.kode","de":"Auth.-Code","el":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7\u03C2","en":"Auth Code","en-GB":"Auth Code","en-XA":"[\xc5\xfb\u0163\u0125\u2002\xc7\xf6\xf0\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"C\xf3digo de aut","es-AR":"C\xf3digo de aut","es-ES":"C\xf3digo Autoriz","es-MX":"C\xf3digo de aut.","fr":"Code Aut","hu":"Auth Code","id":"Kode Otorisasi","it":"Codice Aut","ja":"\u8A8D\u8A3C\u756A\u53F7","key":"RL_AuthCode","ko":"\uC2B9\uC778\uBC88\uD638","nb":"Autorisasjonskode","nl":"Aut.code","pl":"Kod autoryzacyjny","pt-BR":"C\xf3digo de autoriza\xe7\xe3o","pt-PT":"C\xf3digo de autentica\xe7\xe3o","ru":"\u041A\u043E\u0434 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438","sv":"Aut. kod","th":"\u0E23\u0E2B\u0E31\u0E2A\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19","tr":"Yetk. Kodu","zh-Hans":"\u8BA4\u8BC1\u7801","zh-Hant":"\u8B58\u5225\u78BC"},"RL_AuthDate":{"ar":"\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u062A\u0631\u062E\u064A\u0635","ca":"Auth. Date","comment":"Authentication  date for gift card in receipt","cs":" Auth. Date","da":"Auth. Date","de":"Auth. Date","el":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7\u03C2","en":"Auth. Date","en-GB":"Auth. Date","en-XA":"[\xc5\xfb\u0163\u0125\xb7\u2002\xd0\xe5\u0163\xe9\u2002\xe5\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Aut. Fecha","es-AR":"Aut. Fecha","es-ES":"Auth. Date","es-MX":"Aut. Fecha","fr":"Auth. Date","hu":"Auth. Date","id":"Tanggal Otorisasi","it":"Auth. Date","ja":"Auth. Date","key":"RL_AuthDate","ko":"\uC2B9\uC778 \uB0A0\uC9DC","nb":"Aut. Dato","nl":"Aut.datum","pl":"Data autoryzacji","pt-BR":"Aut. Data","pt-PT":"Data de autentica\xe7\xe3o","ru":"\u0414\u0430\u0442\u0430 \u0430\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u0438","sv":"Aukt. datum","th":"\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19","tr":"Yetk. Tarihi","zh-Hans":"\u8BA4\u8BC1\u65E5\u671F","zh-Hant":"\u6388\u6B0A\u65E5\u671F"},"RL_AuthNo":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0631\u062E\u064A\u0635","ca":"Autoriz. No.","comment":"Authentication  number for gift card in receipt","cs":"C.Autor","da":"Aut. Nej.","de":"Auth. No","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03AD\u03B3\u03BA\u03C1\u03B9\u03C3\u03B7\u03C2","en":"Auth. No","en-GB":"Auth. No","en-XA":"[\xc5\xfb\u0163\u0125\xb7\u2002\xd1\xf6\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N.\xba aut","es-AR":"Aut. de tel","es-ES":"AutNo","es-MX":"Aut. N.\xba","fr":"Auto No","hu":"Auth. No","id":"No. Otorisasi","it":"N. aut","ja":"\u8A8D\u8A3C\u756A\u53F7.","key":"RL_AuthNo","ko":"\uC2B9\uC778 \uBC88\uD638","nb":"Aut. Nei","nl":"Aut.nr.","pl":"Nr autoryzacji","pt-BR":"N\xb0 Aut.","pt-PT":"N.\xba de autentica\xe7\xe3o","ru":"\u2116 \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438","sv":"Aut. nr.","th":"\u0E40\u0E25\u0E02\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19","tr":"Yetk. No","zh-Hans":"\u8BA4\u8BC1\u7801","zh-Hant":"\u6388\u6B0A\u78BC"},"RL_AvailablePoints":{"ar":"\u0627\u0644\u0646\u0642\u0627\u0637 \u0627\u0644\u0645\u062A\u0648\u0641\u0631\u0629","ca":"Ptos. Disponibles","comment":"Available points of  membership in receipt","cs":"Dostupn\xe9 body","da":"tilg\xe6ngelige point","de":"Available Points","el":"\u0394\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF\u03B9 \u03C0\u03CC\u03BD\u03C4\u03BF\u03B9","en":"Available Points","en-GB":"Available Points","en-XA":"[\xc5\u1E7D\xe5\xee\u013C\xe5\u0180\u013C\xe9\u2002\xde\xf6\xee\xf1\u0163\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Puntos disponibles","es-AR":"Puntos disponibles","es-ES":"Ptos. disponibles","es-MX":"Puntos disponibles","fr":"Points disponibles","hu":"Available Points","id":"Poin Tersedia","it":"Punti disponibili","ja":"Available Points","key":"RL_AvailablePoints","ko":"\uC0AC\uC6A9 \uAC00\uB2A5\uD55C \uD3EC\uC778\uD2B8","nb":"Tilgjengelige poeng","nl":"Beschikbare punten","pl":"Dost\u0119pne punkty","pt-BR":"Pontos dispon\xedveis","pt-PT":"Pontos dispon\xedveis","ru":"\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0431\u0430\u043B\u043B\u044B","sv":"Tillg\xe4ngliga po\xe4ng","th":"\u0E04\u0E30\u0E41\u0E19\u0E19\u0E17\u0E35\u0E48\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49","tr":"Kullan\u0131labilir Puanlar","zh-Hans":"\u53EF\u7528\u79EF\u5206","zh-Hant":"\u53EF\u4F7F\u7528\u9EDE\u6578"},"RL_BagFee":{"ar":"\u0631\u0633\u0648\u0645 \u0627\u0644\u0637\u0631\u062F","ca":"Preu de la bossa","comment":"Bag Fees or the Carrier Bag price printed on the receipts.","cs":"Ta\u0161ka \u2013 poplatek","da":"Posepris","de":"Taschengeb\xfchr","el":"\u03A7\u03C1\u03AD\u03C9\u03C3\u03B7 \u03C4\u03C3\u03AC\u03BD\u03C4\u03B1\u03C2","en":"Bag Fee","en-GB":"Carrier Bags","en-XA":"[\u0181\xe5\u011D\u2002\u0191\xe9\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tarifa de la bolsa de compras","es-AR":"Precio de la bolsa","es-ES":"Precio de la bolsa","es-MX":"Cargo por la bolsa","fr":"Suppl\xe9ment sac","hu":"T\xe1ska d\xedja","id":"Biaya Tas","it":"Costo sacchetto","ja":"\u30B7\u30E7\u30C3\u30D4\u30F3\u30B0\u30D0\u30C3\u30B0\u4EE3\u91D1","key":"RL_BagFee","ko":"\uC1FC\uD551\uBC31\uAC12","nb":"Handlekurvavgift","nl":"Tasprijs","pl":"Op\u0142ata za torb\u0119","pt-BR":"Taxa de sacola","pt-PT":"Pre\xe7o do saco","ru":"\u0421\u0431\u043E\u0440 \u0437\u0430 \u0443\u043F\u0430\u043A\u043E\u0432\u043A\u0443","sv":"P\xe5savgift","th":"\u0E04\u0E48\u0E32\u0E18\u0E23\u0E23\u0E21\u0E40\u0E19\u0E35\u0E22\u0E21\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E16\u0E38\u0E07","tr":"Sepet Tutar\u0131","zh-Hans":"\u8D2D\u7269\u888B\u8D39\u7528","zh-Hant":"\u624B\u63D0\u888B\u8CBB\u7528"},"RL_Balance":{"ar":"\u0627\u0644\u0631\u0635\u064A\u062F","ca":"Saldo","comment":"Balance of gift card in receipt","cs":"Zustatek","da":"Saldo","de":"Balance","el":"\u03A5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF","en":"Balance","en-GB":"Balance","en-XA":"[\u0181\xe5\u013C\xe5\xf1\xe7\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Saldo","es-AR":"Saldo","es-ES":"Saldo","es-MX":"Saldo","fr":"Solde","hu":"Balance","id":"Saldo","it":" Saldo","ja":"\u6B8B\u984D","key":"RL_Balance","ko":"\uC794\uC561","nb":"Saldo","nl":"Saldo","pl":"Saldo","pt-BR":"Equil\xedbrio","pt-PT":"Saldo","ru":"\u0411\u0430\u043B\u0430\u043D\u0441","sv":"Saldo","th":"\u0E22\u0E2D\u0E14\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D","tr":"Bakiye","zh-Hans":"\u4F59\u989D","zh-Hant":"\u9918\u984D"},"RL_BalanceDue":{"ar":"\u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0645\u0633\u062A\u062D\u0642","ca":"Saldo adeudado","comment":"Balance due for the transaction in receipt","cs":"Splatn\xfd Zustatek","da":"Forfalden saldo","de":"Restbetrag","el":"\u039F\u03C6\u03B5\u03B9\u03BB\u03CC\u03BC\u03B5\u03BD\u03BF \u03C5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF","en":"Balance Due","en-GB":"Balance Due","en-XA":"[\u0181\xe5\u013C\xe5\xf1\xe7\xe9\u2002\xd0\xfb\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Saldo adeudado","es-AR":"Saldo adeudado","es-ES":"Saldo por Cobrar","es-MX":"Saldo adeudado","fr":"Solde d\xfb","hu":"Balance Due","id":"Jatuh Tempo Saldo","it":"Saldo dovuto","ja":"\u3054\u8ACB\u6C42\u984D","key":"RL_BalanceDue","ko":"\uBBF8\uC9C0\uAE09\uC561","nb":"Saldo","nl":"Te betalen bedrag","pl":"Saldo nale\u017Cne","pt-BR":"Saldo devedor","pt-PT":"Saldo pendente","ru":"\u0421\u0443\u043C\u043C\u0430 \u043A \u043E\u043F\u043B\u0430\u0442\u0435","sv":"Saldo att betala","th":"\u0E22\u0E2D\u0E14\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E15\u0E49\u0E2D\u0E07\u0E0A\u0E33\u0E23\u0E30","tr":"\xd6denecek Bakiye","zh-Hans":"\u5E94\u4ED8\u4F59\u989D","zh-Hant":"\u61C9\u4ED8\u984D"},"RL_BankTransfer":{"ar":"\u062D\u0648\u0627\u0644\u0629 \u0645\u0635\u0631\u0641\u064A\u0629","ca":"Transferencia bancaria","comment":"Bank Transfer","cs":"Bankovn\xed p\u0159evod","da":"Bankoverf\xf8rsel","de":"\xdcberweisung","el":"\u03A4\u03C1\u03B1\u03C0\u03B5\u03B6\u03B9\u03BA\u03CC \u03AD\u03BC\u03B2\u03B1\u03C3\u03BC\u03B1","en":"Bank Transfer","en-GB":"Bank Transfer","en-XA":"[\u0181\xe5\xf1\u0137\u2002\u0162\u0155\xe5\xf1\u0161\u0192\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Transferencia bancaria","es-AR":"Transferencia bancaria","es-ES":"Transferencia bancaria","es-MX":"Transferencia bancaria","fr":"Virement bancaire","hu":"Bank Transfer","id":"Transfer Bank","it":"Bonifico bancario","ja":"\u632F\u8FBC","key":"RL_BankTransfer","ko":"\uC740\uD589 \uC774\uCCB4","nb":"Bankoverf\xf8ring","nl":"Bankoverboeking","pl":"Przelew bankowy","pt-BR":"Transfer\xeancia banc\xe1ria","pt-PT":"Transf. Banc\xe1ria","ru":"\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u043F\u0435\u0440\u0435\u0432\u043E\u0434","sv":"Bank\xf6verf\xf6ring","th":"\u0E42\u0E2D\u0E19\u0E40\u0E07\u0E34\u0E19\u0E1C\u0E48\u0E32\u0E19\u0E18\u0E19\u0E32\u0E04\u0E32\u0E23","tr":"Banka Havalesi","zh-Hans":"\u94F6\u884C\u6C47\u6B3E","zh-Hant":"\u9280\u884C\u8F49\u5E33"},"RL_BillingAddress":{"ar":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0648\u062A\u0631\u0629","ca":"Direcci\xf3n de Facturaci\xf3n","comment":"Billing address in receipt","cs":"Faktura\u010Dn\xed adresa","da":"Faktureringsadresse","de":"Billing Address","el":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C7\u03C1\u03AD\u03C9\u03C3\u03B7\u03C2","en":"Billing Address","en-GB":"Billing Address","en-XA":"[\u0181\xee\u013C\u013C\xee\xf1\u011D\u2002\xc5\xf0\xf0\u0155\xe9\u0161\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Direcci\xf3n de facturaci\xf3n","es-AR":"Direcci\xf3n de facturaci\xf3n","es-ES":"Direcci\xf3n de Facturaci\xf3n","es-MX":"Direcci\xf3n de facturaci\xf3n","fr":"Adresse fact","hu":"Billing Address","id":"Alamat Penagihan","it":"Indirizzo fattura","ja":"\u8ACB\u6C42\u5148\u4F4F\u6240","key":"RL_BillingAddress","ko":"\uCCAD\uAD6C\uC11C \uBC1C\uC1A1\uC9C0","nb":"Fakturaadresse","nl":"Factuuradres","pl":"Adres rozliczeniowy","pt-BR":"Endere\xe7o de cobran\xe7a","pt-PT":"Morada de fatura\xe7\xe3o","ru":"\u0410\u0434\u0440\u0435\u0441 \u0432\u044B\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0441\u0447\u0435\u0442\u0430","sv":"Fakturaadress","th":"\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E35\u0E22\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19","tr":"Fatura Adresi","zh-Hans":"\u5E10\u5355\u5730\u5740","zh-Hant":"\u5E33\u55AE\u5730\u5740"},"RL_BuyerTaxIdentificationNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0636\u0631\u064A\u0628\u064A \u0644\u0644\u0645\u0634\u062A\u0631\u064A","ca":"N\xfamero d\'identificaci\xf3 fiscal del comprador/a","comment":"Buyer\'s Tax Identification Number printed on the receipt. ","cs":"Da\u0148ov\xe9 identifika\u010Dn\xed \u010D\xedslo kupuj\xedc\xedho","da":"K\xf8bers skatteidentifikationsnummer","de":"Steueridentifikationsnummer K\xe4ufer:in","el":"\u0391\u03A6\u039C \u03B1\u03B3\u03BF\u03C1\u03B1\u03C3\u03C4\u03AE","en":"Buyer\'s Tax Identification Number","en-GB":"Buyer\'s Tax Identification Number","en-XA":"[\u0181\xfb\xfd\xe9\u0155\xb4\u0161\u2002\u0162\xe5\u1E8B\u2002\xce\xf0\xe9\xf1\u0163\xee\u0192\xee\xe7\xe5\u0163\xee\xf6\xf1\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de identificaci\xf3n fiscal del comprador","es-AR":"N\xfamero de identificaci\xf3n fiscal del comprador","es-ES":"N\xfamero de identificaci\xf3n fiscal del comprador","es-MX":"N\xfamero de identificaci\xf3n fiscal del comprador","fr":"Num\xe9ro d\'identification fiscale du client ou de la cliente","hu":"Vev\u0151 ad\xf3azonos\xedt\xf3 sz\xe1ma","id":"Nomor Identifikasi Pajak Pembeli","it":"Numero identificazione fiscale acquirente","ja":"\u8CFC\u5165\u8005\u306E\u7D0D\u7A0E\u8005\u756A\u53F7","key":"RL_BuyerTaxIdentificationNumber","ko":"\uAD6C\uB9E4\uC790\uC758 \uB0A9\uC138\uC790 \uC2DD\uBCC4\uBC88\uD638","nb":"Kj\xf8pers skattenummer","nl":"Btw-identificatienummer van de koper","pl":"NIP osoby kupuj\u0105cej","pt-BR":"N\xfamero de identifica\xe7\xe3o fiscal do comprador","pt-PT":"N\xfamero de identifica\xe7\xe3o fiscal do comprador","ru":"\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F","sv":"K\xf6parens personnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E15\u0E31\u0E27\u0E1C\u0E39\u0E49\u0E40\u0E2A\u0E35\u0E22\u0E20\u0E32\u0E29\u0E35\u0E2D\u0E32\u0E01\u0E23\u0E02\u0E2D\u0E07\u0E1C\u0E39\u0E49\u0E0B\u0E37\u0E49\u0E2D","tr":"Al\u0131c\u0131n\u0131n Vergi Kimlik Numaras\u0131","zh-Hans":"\u4E70\u5BB6\u7A0E\u52A1\u8BC6\u522B\u7801","zh-Hant":"\u8CB7\u5BB6\u7A05\u91D1\u8EAB\u4EFD\u8B49\u865F\u78BC"},"RL_COMMERCIALINVOICE":{"ar":"\u0641\u0627\u062A\u0648\u0631\u0629 \u062A\u062C\u0627\u0631\u064A\u0629","ca":"FACTURA COMERC.","comment":"Denotes the Commercial Invoice used in transaction","cs":"KOMER\u010CN\xcd POZV\xc1NKA","da":"Reklame kvit","de":"HANDELSGEWERBE-RECHNUNG","el":"\u0395\u039C\u03A0\u039F\u03A1\u0399\u039A\u039F \u03A4\u0399\u039C\u039F\u039B\u039F\u0393\u0399\u039F","en":"COMMERCIAL INVOICE","en-GB":"COMMERCIAL INVOICE","en-XA":"[\xc7\xd6\u1E40\u1E40\xc9\u0154\xc7\xce\xc5\u013B\u2002\xce\xd1\u1E7C\xd6\xce\xc7\xc9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"FACTURA COMERCIAL","es-AR":"FACTURA COMERCIAL","es-ES":"FACTURA COMERC.","es-MX":"FACTURA COMERCIAL","fr":"FACTURE COMMERCIALE","hu":"COMMERCIAL INVOICE","id":"FAKTUR KOMERSIAL","it":"FATTURA COMMERCIALE","ja":"COMMERCIAL INVOICE","key":"RL_COMMERCIALINVOICE","ko":"\uC0C1\uC5C5 \uC1A1\uC7A5","nb":"KOMMERSIELL FAKTURA","nl":"COMMERCIAL INVOICE","pl":"FAKTURA HANDLOWA","pt-BR":"FATURA COMERCIAL","pt-PT":"Factura Comercial","ru":"COMMERCIAL INVOICE","sv":"WHANDELSFAKTURA","th":"\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E0A\u0E34\u0E07\u0E1E\u0E32\u0E13\u0E34\u0E0A\u0E22\u0E4C","tr":"T\u0130CAR\u0130 FATURA","zh-Hans":"\u5546\u4E1A\u53D1\u7968","zh-Hant":"\u5546\u696D\u767C\u7968"},"RL_COUPON":{"ar":"\u0642\u0633\u064A\u0645\u0629","ca":"CUP\xd3N","comment":"The coupon used during transaction","cs":"KUPON","da":"KUPON:","de":"GUTSCHEIN","el":"\u039A\u039F\u03A5\u03A0\u039F\u039D\u0399","en":"COUPON","en-GB":"COUPON","en-XA":"[\xc7\xd6\xdb\xde\xd6\xd1\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"CUP\xd3N","es-AR":"CUP\xd3N","es-ES":"CUP\xd3N","es-MX":"CUP\xd3N","fr":"BON DE R\xc9DUCTION","hu":"COUPON","id":"KUPON","it":"COUPON","ja":"COUPON","key":"RL_COUPON","ko":"\uCFE0\uD3F0","nb":"KUPONG","nl":"KORTINGSBON","pl":"KUPON","pt-BR":"CUPOM","pt-PT":"CUP\xc3O","ru":"COUPON","sv":"WKUPONG","th":"\u0E04\u0E39\u0E1B\u0E2D\u0E07","tr":"KUPON","zh-Hans":"\u4F18\u60E0\u5238","zh-Hant":"\u512A\u60E0\u5238"},"RL_Cancel":{"ar":"\u0625\u0644\u063A\u0627\u0621","ca":"Cancel\xb7la","comment":"Prompting user to cancel an action in the UI. ","cs":"Zru\u0161it","da":"Annuller","de":"Abbrechen","el":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7","en":"Cancel","en-GB":"Cancel","en-XA":"[\xc7\xe5\xf1\xe7\xe9\u013C\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cancelar","es-AR":"Cancelar","es-ES":"Cancelar","es-MX":"Cancelar","fr":"Annuler","hu":"M\xe9gse","id":"Batal","it":"Annulla","ja":"\u30AD\u30E3\u30F3\u30BB\u30EB","key":"RL_Cancel","ko":"\uCDE8\uC18C","nb":"Avbryt","nl":"Annuleer","pl":"Anuluj","pt-BR":"Cancelar","pt-PT":"Cancelar","ru":"\u041E\u0442\u043C\u0435\u043D\u0430","sv":"Avbryt","th":"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01","tr":"\u0130ptal","zh-Hans":"\u53D6\u6D88","zh-Hant":"\u53D6\u6D88"},"RL_Card":{"ar":"\u0628\u0637\u0627\u0642\u0629","ca":"Targeta","comment":"Card","cs":"Karta","da":"Kort","de":"Karte","el":"\u039A\u03AC\u03C1\u03C4\u03B1","en":"Card","en-GB":"Card","en-XA":"[\xc7\xe5\u0155\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tarjeta","es-AR":"Tarjeta","es-ES":"Tarjeta","es-MX":"Tarjeta","fr":"Carte","hu":"K\xe1rtya","id":"Kartu","it":"Carta","ja":"\u30AB\u30FC\u30C9","key":"RL_Card","ko":"\uCE74\uB4DC","nb":"Kort","nl":"Kaart","pl":"Karta","pt-BR":"Cart\xe3o","pt-PT":"Cart\xe3o","ru":"\u041A\u0430\u0440\u0442\u0430","sv":"Kort","th":"\u0E1A\u0E31\u0E15\u0E23","tr":"Kart","zh-Hans":"\u5361\u7247","zh-Hant":"\u5361\u7247"},"RL_CardHolder":{"ar":"\u062D\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","ca":"Titular","comment":"Cardholder","cs":"Dr\u017EitelKarty","da":"Kortholder","de":"Karteninhaber","el":"\u039A\u03AC\u03C4\u03BF\u03C7\u03BF\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2","en":"Cardholder","en-GB":"Cardholder","en-XA":"[\xc7\xe5\u0155\xf0\u0125\xf6\u013C\xf0\xe9\u0155\u2002\xe5\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Titular de la tarjeta","es-AR":"Titular de la tarjeta","es-ES":"Titular","es-MX":"Titular de la tarjeta","fr":"Titulairecarte","hu":"K\xe1rtyatulajdonos","id":"Pemilik Kartu","it":"Titolare della carta","ja":"\u30AB\u30FC\u30C9\u540D\u7FA9\u4EBA","key":"RL_CardHolder","ko":"\uCE74\uB4DC \uC18C\uC9C0\uC790","nb":"Kortinnehaver","nl":"Kaarthouder","pl":"W\u0142a\u015Bciciel karty","pt-BR":"Titular do cart\xe3o","pt-PT":"Titular do cart\xe3o","ru":"\u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u043A\u0430\u0440\u0442\u044B","sv":"Kortinnehavare","th":"\u0E1C\u0E39\u0E49\u0E16\u0E37\u0E2D\u0E1A\u0E31\u0E15\u0E23","tr":"Kart Sahibi","zh-Hans":"\u6301\u5361\u4EBA","zh-Hant":"\u6301\u5361\u4EBA"},"RL_CardName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","ca":"Nom de la targeta","comment":"Card name used in the payment during checkout ","cs":"Jm\xe9no na kart\u011B","da":"Kortnavn","de":"Kartenname","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2","en":"Card Name","en-GB":"Card Name","en-XA":"[\xc7\xe5\u0155\xf0\u2002\xd1\xe5\u0271\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre en la tarjeta","es-AR":"Nombre de la tarjeta","es-ES":"Nombre de la tarjeta","es-MX":"Nombre en la tarjeta","fr":"Nom de la carte","hu":"K\xe1rtya neve","id":"Nama Kartu","it":"Nome sulla card","ja":"\u30AB\u30FC\u30C9\u540D","key":"RL_CardName","ko":"\uCE74\uB4DC\uC0AC\uBA85","nb":"Kortnavn","nl":"Kaartnaam","pl":"Nazwa karty","pt-BR":"Nome do cart\xe3o","pt-PT":"Nome do cart\xe3o","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u0430\u0440\u0442\u044B","sv":"Namn p\xe5 kort","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E1A\u0E31\u0E15\u0E23","tr":"Kart Ad\u0131","zh-Hans":"\u5361\u7247\u540D\u79F0","zh-Hant":"\u5361\u7247\u540D\u7A31"},"RL_CardNo":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","ca":"N\xb0 Tarjeta","comment":"Gift card number in receipt","cs":"Karta c","da":"Kortnr","de":" Kartennummer ","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03AC\u03C1\u03C4\u03B1\u03C2","en":"Card No","en-GB":"Card No","en-XA":"[\xc7\xe5\u0155\xf0\u2002\xd1\xf6\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N.\xba de tarjeta","es-AR":"Tarjeta N.\xba","es-ES":"Tarjeta  Cambio","es-MX":"N.\xba de tarjeta","fr":"No. carte","hu":"Card No","id":"No. Kartu","it":"N. carta","ja":"\u30AB\u30FC\u30C9\u756A\u53F7","key":"RL_CardNo","ko":"\uCE74\uB4DC \uBC88\uD638","nb":"Kortnr.","nl":"Kaartnr.","pl":"Nr karty","pt-BR":"N\xb0 do cart\xe3o","pt-PT":"N.\xba do cart\xe3o","ru":"\u2116 \u043A\u0430\u0440\u0442\u044B","sv":"Kortnr.","th":"\u0E40\u0E25\u0E02\u0E1A\u0E31\u0E15\u0E23","tr":"Kart No","zh-Hans":"\u5361\u53F7","zh-Hant":"\u5361\u865F"},"RL_CashRounding":{"ar":"\u062A\u062F\u0648\u064A\u0631 \u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0646\u0642\u062F\u064A","ca":"Cash rounding","comment":"Line indicating  rounded cash in rceipt line","cs":"Cash rounding","da":"Cash rounding ","de":"Cash rounding","el":"\u03A3\u03C4\u03C1\u03BF\u03B3\u03B3\u03C5\u03BB\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03C0\u03BF\u03C3\u03BF\u03CD","en":"Cash rounding","en-GB":"Cash rounding","en-XA":"[\xc7\xe5\u0161\u0125\u2002\u0155\xf6\xfb\xf1\xf0\xee\xf1\u011D\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Redondeo de efectivo","es-AR":"Redondeo de efectivo","es-ES":"Cash rounding","es-MX":"Redondeo de efectivo","fr":"Cash rounding","hu":"Cash rounding","id":"Pembulatan uang tunai","it":"Arrotondamento di denaro contante ","ja":"\u73FE\u91D1\u6255\u3044","key":"RL_CashRounding","ko":"\uD604\uAE08 \uBC18\uC62C\uB9BC","nb":"Kontantavrunding","nl":"Bedrag afronden","pl":"Got\xf3wka (kwota zaokr\u0105glona)","pt-BR":"Arredondamento de valor","pt-PT":"Arredondamento do valor","ru":"\u041E\u043A\u0440\u0443\u0433\u043B\u0435\u043D\u0438\u0435 \u0441\u0443\u043C\u043C\u044B","sv":"Avrundat belopp","th":"\u0E1B\u0E31\u0E14\u0E40\u0E28\u0E29\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E14","tr":"Nakit yuvarlama","zh-Hans":"\u73B0\u91D1\u53D6\u6574","zh-Hant":"\u73FE\u91D1\u53D6\u6574"},"RL_CertificateName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0647\u0627\u062F\u0629","ca":"Nom del certificat","comment":" Certificate name provided by the ministry of finance in Portugal. ","cs":"N\xe1zev certifik\xe1tu","da":"Certifikatets navn","de":"Bescheinigungsnummer","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03C4\u03B9\u03BA\u03BF\u03CD","en":"Certificate Name","en-GB":"Certificate name","en-XA":"[\xc7\xe9\u0155\u0163\xee\u0192\xee\xe7\xe5\u0163\xe9\u2002\xd1\xe5\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre del certificado","es-AR":"Nombre del certificado","es-ES":"Nombre del certificado","es-MX":"Nombre del certificado","fr":"Nom de certificat","hu":"Tan\xfas\xedtv\xe1ny elnevez\xe9se","id":"Nama Sertifikat","it":"Nome certificato","ja":"\u8A3C\u660E\u66F8\u306E\u540D\u79F0","key":"RL_CertificateName","ko":"\uC99D\uBA85\uC11C \uBA85\uCE6D","nb":"Navn p\xe5 sertifikat","nl":"Certificaatnaam","pl":"Nazwa certyfikatu","pt-BR":"Nome do certificado","pt-PT":"Nome do certificado","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430","sv":"Certifikatets namn","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07","tr":"Sertifika Ad\u0131","zh-Hans":"\u8BC1\u4E66\u540D\u79F0","zh-Hant":"\u79AE\u5238\u540D\u7A31"},"RL_CertificateNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0634\u0647\u0627\u062F\u0629","ca":"N\xfamero de certificat","comment":"Certificate Number (fiscal document id) printed on the Austria receipts. ","cs":"\u010C\xedslo certifik\xe1tu","da":"Certifikatets nummer","de":"Bescheinigungsnummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C6\u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03BF\u03CD \u03C0\u03B9\u03C3\u03C4\u03BF\u03C0\u03BF\u03B9\u03B7\u03C4\u03B9\u03BA\u03BF\u03CD","en":"Certificate Number","en-GB":"Certificate number","en-XA":"[\xc7\xe9\u0155\u0163\xee\u0192\xee\xe7\xe5\u0163\xe9\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de certificado","es-AR":"N\xfamero de certificado","es-ES":"N\xfamero de certificado","es-MX":"N\xfamero de certificado","fr":"Num\xe9ro de certificat","hu":"Igazol\xe1s sz\xe1ma","id":"Nomor Sertifikat","it":"Numero certificato","ja":"\u8A3C\u660E\u66F8\u756A\u53F7","key":"RL_CertificateNumber","ko":"\uC99D\uBA85\uC11C \uBC88\uD638","nb":"Sertifikatnummer","nl":"Certificaatnummer","pl":"Numer certyfikatu","pt-BR":"N\xfamero do certificado","pt-PT":"N\xfamero do certificado","ru":"\u041D\u043E\u043C\u0435\u0440 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430","sv":"Certifikatnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E43\u0E1A\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07","tr":"Sertifika Numaras\u0131","zh-Hans":"\u793C\u5238\u53F7","zh-Hant":"\u79AE\u5238\u7DE8\u865F"},"RL_Change":{"ar":"\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0645\u062A\u0628\u0642\u064A","ca":"Canvi","comment":"Line indicating change after  rounded cash in receipt line","cs":"K vr\xe1cen\xed","da":"Byttepenge","de":"Wechselgeld","el":"\u03A1\u03AD\u03C3\u03C4\u03B1","en":"Change","en-GB":"Change","en-XA":"[\xc7\u0125\xe5\xf1\u011D\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cambio","es-AR":"Cambio","es-ES":"Cambio","es-MX":"Cambio","fr":"Rendu","hu":"Visszaj\xe1r\xf3","id":"Kembalian","it":"Resto","ja":"\u91E3\u92AD\u91D1","key":"RL_Change","ko":"\uAC70\uC2A4\uB984\uB3C8","nb":"Endre","nl":"Wisselgeld","pl":"Reszta","pt-BR":"Troco","pt-PT":"Troco","ru":"\u0421\u0434\u0430\u0447\u0430","sv":"V\xe4xel","th":"\u0E40\u0E07\u0E34\u0E19\u0E17\u0E2D\u0E19","tr":"Para \xfcst\xfc","zh-Hans":"\u627E\u96F6","zh-Hant":"\u627E\u96F6"},"RL_City":{"ar":"\u0627\u0644\u0645\u062F\u064A\u0646\u0629","ca":"Ciudad","comment":"City in receipt","cs":"Mesto","da":"By","de":"Stadt","el":"\u03A0\u03CC\u03BB\u03B7","en":"City","en-GB":"Town/City","en-XA":"[\xc7\xee\u0163\xfd\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Ciudad","es-AR":"Ciudad","es-ES":" Ciudad","es-MX":"Ciudad","fr":"City","hu":"City","id":"Kota","it":"Citt\xe0","ja":"\u533A/\u5E02","key":"RL_City","ko":"\uC2DC","nb":"Poststed","nl":"Plaats","pl":"Miasto","pt-BR":"Cidade","pt-PT":"Cidade","ru":"\u0413\u043E\u0440\u043E\u0434","sv":"Ort","th":"\u0E40\u0E21\u0E37\u0E2D\u0E07","tr":"\u015Eehir","zh-Hans":"\u57CE\u5E02","zh-Hant":"\u7E23\u5E02"},"RL_ClientID":{"ar":"\u0645\u0639\u0631\u0650\u0651\u0641 \u0627\u0644\u0639\u0645\u064A\u0644","ca":"ID de client","comment":"ClientID or Client Serial Number for TSE  attributes on Germany receipts","cs":"ClientID","da":"KundeID","de":"Client-ID","el":"ClientID","en":"ClientID","en-GB":"ClientID","en-XA":"[\xc7\u013C\xee\xe9\xf1\u0163\xce\xd0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"iD del cliente","es-AR":"ID de cliente","es-ES":"ID de cliente","es-MX":"ID de cliente","fr":"ClientID","hu":"\xdcgyf\xe9l-azonos\xedt\xf3","id":"ClientID","it":"ClientID","ja":"\u30AF\u30E9\u30A4\u30A2\u30F3\u30C8ID","key":"RL_ClientID","ko":"\uD074\uB77C\uC774\uC5B8\uD2B8 ID","nb":"Kunde-ID","nl":"ClientID","pl":"Identyfikator klienta/klientki","pt-BR":"ID do cliente","pt-PT":"ID de cliente","ru":"ClientID","sv":"Klient-id","th":"ID \u0E25\u0E39\u0E01\u0E04\u0E49\u0E32","tr":"T\xfcketici Kimli\u011Fi","zh-Hans":"\u5BA2\u6237 ID","zh-Hant":"\u5BA2\u6236\u7DE8\u865F"},"RL_Color":{"ar":"\u0627\u0644\u0644\u0648\u0646","ca":"Color","comment":"Color of the item in receipt line","cs":"Barva","da":"Farve ","de":"Farbe ","el":"\u03A7\u03C1\u03CE\u03BC\u03B1","en":"Color","en-GB":"Colour","en-XA":"[\xc7\xf6\u013C\xf6\u0155\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Color","es-AR":"Color","es-ES":"Color","es-MX":"Color","fr":"Couleur","hu":"Color","id":"Warna","it":"Colore","ja":"Color","key":"RL_Color","ko":"\uCEEC\uB7EC","nb":"Farge","nl":"Kleur","pl":"Kolor","pt-BR":"Cor","pt-PT":"Cor","ru":"\u0426\u0432\u0435\u0442","sv":"F\xe4rg","th":"\u0E2A\u0E35","tr":"Renk","zh-Hans":"\u989C\u8272","zh-Hant":"\u984F\u8272"},"RL_CompNo":{"ar":"\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0625\u0636\u0627\u0641\u064A\u0651","ca":" N\xb0 Comp","comment":"Complimentary number in receipt line","cs":"Comp c","da":"Comp nr","de":"Comp No","el":"\u0391\u03C1. \u03B1\u03BD\u03C4.","en":"Comp No","en-GB":"Comp No.","en-XA":"[\xc7\xf6\u0271\xfe\u2002\xd1\xf6\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Comp. N.\xba","es-AR":"Comp. N.\xba","es-ES":"N\xb0 Comp","es-MX":"Comp. N.\xba","fr":"No. gratuit\xe9","hu":"Comp No","id":"No. Gratis","it":"Nu. conto","ja":"\u5546\u54C1\u63D0\u4F9B\u756A\u53F7","key":"RL_CompNo","ko":"\uBB34\uB8CC \uD488\uBAA9 \uBC88\uD638","nb":"Gratisnr.","nl":"Comp Nr","pl":"Comp No","pt-BR":"N\xfamero da cortesia","pt-PT":"Compra Gratuita N.\xba","ru":"\u2116 Comp","sv":"Gratiskod","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E02\u0E2D\u0E07\u0E2A\u0E21\u0E19\u0E32\u0E04\u0E38\u0E13","tr":"Par\xe7a No.","zh-Hans":"\u6210\u672C\u4E2D\u5FC3","zh-Hant":"\u8D08\u54C1\u7DE8\u865F"},"RL_CompanyRegistrationNumber":{"ar":"\u0631\u0642\u0645 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0634\u0631\u0643\u0629","ca":"N\xfamero de registre mercantil","comment":"The registered company number with the authorities, It would be different per company, but within a company, stores will have the same value.","cs":"Registra\u010Dn\xed \u010D\xedslo spole\u010Dnosti","da":"Virksomheds registreringsnummer","de":"Firmenregistrierungsnummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03C4\u03C1\u03CE\u03BF\u03C5 \u03B5\u03C4\u03B1\u03B9\u03C1\u03B5\u03AF\u03B1\u03C2","en":"Company Registration Number","en-GB":"Company Registration Number","en-XA":"[\xc7\xf6\u0271\xfe\xe5\xf1\xfd\u2002\u0154\xe9\u011D\xee\u0161\u0163\u0155\xe5\u0163\xee\xf6\xf1\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\xe5\u0180\xe7\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de registro de la empresa","es-AR":"N\xfamero de registro de la empresa","es-ES":"C\xf3digo de identificaci\xf3n fiscal","es-MX":"N\xfamero de registro de la compa\xf1\xeda","fr":"Num\xe9ro d\'enregistrement de l\'entreprise","hu":"C\xe9gjegyz\xe9ksz\xe1m","id":"Nomor Registrasi Perusahaan","it":"Numero di registrazione dell\'azienda","ja":"\u767B\u9332\u756A\u53F7","key":"RL_CompanyRegistrationNumber","ko":"\uC0AC\uC5C5\uC790 \uB4F1\uB85D \uBC88\uD638","nb":"Organisasjonsummer","nl":"Registratienummer bedrijf","pl":"Numer ewidencyjny firmy","pt-BR":"N\xfamero de registro da empresa","pt-PT":"N\xfamero de registo da empresa","ru":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438","sv":"F\xf6retagets registreringsnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E08\u0E14\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17","tr":"\u015Eirket Kay\u0131t Numaras\u0131","zh-Hans":"\u516C\u53F8\u6CE8\u518C\u53F7\u7801","zh-Hant":"\u516C\u53F8\u7D71\u7DE8"},"RL_Complimentary":{"ar":"\u0645\u062C\u0627\u0646\u064B\u0627","ca":"Gratu\xeft","comment":"Complimentary Tender in receipts","cs":"Bezplatn\u011B","da":"Uden beregning","de":"Erg\xe4nzende Angaben","el":"\u03A3\u03C5\u03BC\u03C0\u03BB\u03B7\u03C1\u03C9\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE","en":"Complimentary","en-GB":"Complimentary","en-XA":"[\xc7\xf6\u0271\xfe\u013C\xee\u0271\xe9\xf1\u0163\xe5\u0155\xfd\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"De cortes\xeda","es-AR":"De cortes\xeda","es-ES":"Cortes\xeda","es-MX":"Monto","fr":"Offert","hu":"J\xf3v\xe1hagy\xe1s","id":"Pembayaran","it":"Omaggio","ja":"\u512A\u5F85\u5546\u54C1","key":"RL_Complimentary","ko":"\uBB34\uB8CC","nb":"Gratis","nl":"Gratis","pl":"Towar nieodp\u0142atny","pt-BR":"Cortesia","pt-PT":"Cortesia","ru":"\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C","sv":"Utest\xe5ende belopp","th":"\u0E2D\u0E20\u0E34\u0E19\u0E31\u0E19\u0E17\u0E19\u0E32\u0E01\u0E32\u0E23","tr":"\xdccretsiz","zh-Hans":"\u514D\u8D39\u8D60\u9001","zh-Hant":"\u512A\u5F85"},"RL_ComplimentaryDetail":{"ar":"\u062A\u0641\u0627\u0635\u064A\u0644 \u0625\u0636\u0627\u0641\u064A\u0629","ca":"Info Complementaria","comment":"Complimentary Details","cs":"\xdadaje o bezpl. trans.","da":"Yderligere detaljer","de":"Erg\xe4nzende Details","el":"\u03A0\u03C1\u03CC\u03C3\u03B8\u03B5\u03C4\u03B5\u03C2 \u03BB\u03B5\u03C0\u03C4\u03BF\u03BC\u03AD\u03C1\u03B5\u03B9\u03B5\u03C2","en":"Complimentary Details","en-GB":"Complimentary Details","en-XA":"[\xc7\xf6\u0271\xfe\u013C\xee\u0271\xe9\xf1\u0163\xe5\u0155\xfd\u2002\xd0\xe9\u0163\xe5\xee\u013C\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Detalles del art\xedculo de cortes\xeda","es-AR":"Detalles del art\xedculo de cortes\xeda","es-ES":"Info Complementaria","es-MX":"Detalles del art\xedculo de cortes\xeda","fr":"D\xe9tails gratuit\xe9","hu":"Complimentary Details","id":"Detail Gratis","it":"Dettagli omaggio","ja":"\u5546\u54C1\u63D0\u4F9B\u8A73\u7D30","key":"RL_ComplimentaryDetail","ko":"\uBB34\uB8CC \uD488\uBAA9 \uC0C1\uC138 \uC815\uBCF4","nb":"Detaljer om gratisvarer","nl":"Aanvullende Details","pl":"Pochwalne Szczeg\xf3\u0142y","pt-BR":"Detalhes complementares","pt-PT":"Detalhes Complementares","ru":"\u0421\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E \u043B\u044C\u0433\u043E\u0442\u0430\u0445","sv":"Uppgifter gratiskupong","th":"\u0E23\u0E32\u0E22\u0E25\u0E30\u0E40\u0E2D\u0E35\u0E22\u0E14\u0E02\u0E2D\u0E07\u0E2A\u0E21\u0E19\u0E32\u0E04\u0E38\u0E13","tr":"\xdccretsiz Detaylar","zh-Hans":"\u8D60\u54C1\u8BE6\u60C5","zh-Hant":"\u8D08\u54C1\u8A73\u7D30\u8CC7\u6599"},"RL_ConsumerName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u0639\u0645\u064A\u0644","ca":"Consumidor","comment":"Name of the consumer in receipt line","cs":"Jm\xe9no z\xe1k","da":"Forbrugerens navn","de":"Consumer Name","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7","en":"Consumer Name","en-GB":"Consumer Name","en-XA":"[\xc7\xf6\xf1\u0161\xfb\u0271\xe9\u0155\u2002\xd1\xe5\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre del consumidor","es-AR":"Nombre del consumidor","es-ES":"Consumidor","es-MX":"Nombre del consumidor","fr":"Nom du client","hu":"Consumer Name","id":"Nama Pelanggan","it":"Nome Cliente","ja":"\u304A\u5BA2\u69D8\u540D","key":"RL_ConsumerName","ko":"\uACE0\uAC1D \uC774\uB984","nb":"Kundenavn","nl":"Naam klant","pl":"Imi\u0119 i nazwisko klienta","pt-BR":"Nome do consumidor","pt-PT":"Nome do cliente","ru":"\u0418\u043C\u044F \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F","sv":"Kundnamn","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32","tr":"T\xfcketici Ad\u0131","zh-Hans":"\u6D88\u8D39\u8005\u59D3\u540D","zh-Hant":"\u6D88\u8CBB\u8005\u59D3\u540D"},"RL_Contact":{"ar":"\u0627\u0644\u0627\u062A\u0635\u0627\u0644","ca":"Contacto","comment":"Contact details block  for the shipping  in receipt line","cs":"Contact","da":"Kontakt","de":"Kontakt","el":"\u0395\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1","en":"Contact","en-GB":"Contact","en-XA":"[\xc7\xf6\xf1\u0163\xe5\xe7\u0163\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Contacto","es-AR":"Contacto","es-ES":"Contacto","es-MX":"Contacto","fr":"Contact","hu":"Contact","id":"Kontak","it":"Contatto","ja":"\u304A\u554F\u3044\u5408\u308F\u305B","key":"RL_Contact","ko":"\uC5F0\uB77D\uCC98","nb":"Kontakt","nl":"Contact","pl":"Kontakt","pt-BR":"Contato","pt-PT":"Contacto","ru":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F","sv":"Kontakt","th":"\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D","tr":"\u0130leti\u015Fim","zh-Hans":"\u8054\u7CFB\u65B9\u5F0F","zh-Hant":"\u806F\u7D61\u8CC7\u8A0A"},"RL_ContactEmailID":{"ar":"\\n\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u062C\u0647\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644","ca":"ID del correu electr\xf2nic de contacte","comment":"Email Id of the point of Contact added to a transaction. ","cs":"\\nKontaktn\xed EmailID","da":"E-mail-id for kontakt","de":"\\nE-Mail-ID des Kontakts","el":"\\n\u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC email \u03B5\u03C0\u03B1\u03C6\u03AE\u03C2","en":"\\nContact EmailID","en-GB":"\\nContact Email ID","en-XA":"[\\n\xc7\xf6\xf1\u0163\xe5\xe7\u0163\u2002\xc9\u0271\xe5\xee\u013C\xce\xd0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Identificaci\xf3n del correo electr\xf3nico de contacto","es-AR":"\\nID de correo electr\xf3ncio del contacto","es-ES":"ID de correo electr\xf3nico del contacto","es-MX":"\\nCorreo electr\xf3nico de contacto","fr":"\\nID e-mail du contact","hu":"Kapcsolattart\xf3 e-mail-azonos\xedt\xf3ja","id":"\\nEmailID Kontak","it":"\\nID e-mail contatto","ja":"\\n\u9023\u7D61\u7528EmailID","key":"RL_ContactEmailID","ko":"\\n\uBB38\uC758 \uC774\uBA54\uC77C ID","nb":"\\nKontakt EmailID","nl":"E-mailadres ID voor contact","pl":"\\nIdentyfikator e-mail osoby do kontaktu","pt-BR":"\\nID de e-mail do contato","pt-PT":"\\nID de e-mail do ponto de contacto","ru":"\\nID \u044D\u043B. \u043F\u043E\u0447\u0442\u044B \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0430","sv":"\\nKontaktens e-post-id","th":"\\nID \u0E2D\u0E35\u0E40\u0E21\u0E25\u0E15\u0E34\u0E14\u0E15\u0E48\u0E2D","tr":"\\n\u0130leti\u015Fim Ki\u015Fisi E-posta Kimli\u011Fi","zh-Hans":"\\n\u8054\u7CFB\u4EBA\u7535\u5B50\u90AE\u4EF6\u5E10\u53F7","zh-Hant":"\\n\u806F\u7D61\u4EBA\u96FB\u5B50\u90F5\u4EF6 ID"},"RL_Country":{"ar":"\u0627\u0644\u0628\u0644\u062F/\u0627\u0644\u0645\u0646\u0637\u0642\u0629","ca":"Pa\xeds/regi\xf3","comment":"Country where a store is located. ","cs":"Zem\u011B/oblast","da":"Land","de":"Land/Region","el":"\u03A7\u03CE\u03C1\u03B1","en":"Country","en-GB":"Country","en-XA":"[\xc7\xf6\xfb\xf1\u0163\u0155\xfd\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Pa\xeds","es-AR":"Pa\xeds/Regi\xf3n","es-ES":"Pa\xeds/Regi\xf3n","es-MX":"Pa\xeds o regi\xf3n","fr":"Pays/R\xe9gion","hu":"Orsz\xe1g/r\xe9gi\xf3","id":"Negara/Wilayah","it":"Paese/regione","ja":"\u56FD","key":"RL_Country","ko":"\uAD6D\uAC00","nb":"Land","nl":"Land/regio","pl":"Kraj/region","pt-BR":"Pa\xeds/regi\xe3o","pt-PT":"Pa\xeds","ru":"\u0421\u0442\u0440\u0430\u043D\u0430","sv":"Land/region","th":"\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28","tr":"\xdclke","zh-Hans":"\u56FD\u5BB6/\u5730\u533A","zh-Hant":"\u570B\u5BB6/\u5730\u5340"},"RL_CouponNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0642\u0633\u064A\u0645\u0629","ca":"N\xfamero de Vale","comment":"Coupon number","cs":"C\xedslo kup\xf3nu","da":"Kuponnr","de":"Coupon Number","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BA\u03BF\u03C5\u03C0\u03BF\u03BD\u03B9\u03BF\u03CD","en":"Coupon Number","en-GB":"Coupon Number","en-XA":"[\xc7\xf6\xfb\xfe\xf6\xf1\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de cup\xf3n","es-AR":"N\xfamero de cup\xf3n","es-ES":"N\xfamero de Vale  ","es-MX":"N\xfamero de cup\xf3n","fr":"No bon de r\xe9duc.","hu":"Coupon Number","id":"Nomor Kupon","it":"Numero coupon","ja":"\u30AF\u30FC\u30DD\u30F3\u756A\u53F7","key":"RL_CouponNumber","ko":"\uCFE0\uD3F0 \uBC88\uD638","nb":"Kupongnummer","nl":"Couponnummer","pl":"Numer kuponu","pt-BR":"N\xfamero do cupom","pt-PT":"N\xfamero do cup\xe3o","ru":"\u041D\u043E\u043C\u0435\u0440 \u043A\u0443\u043F\u043E\u043D\u0430","sv":"Kupongnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E04\u0E39\u0E1B\u0E2D\u0E07","tr":"Kupon Numaras\u0131","zh-Hans":"\u4F18\u60E0\u5238\u7F16\u53F7","zh-Hant":"\u6298\u50F9\u5238\u7DE8\u865F"},"RL_Credit":{"ar":"\u0631\u0635\u064A\u062F","ca":"Cr\xe8dit","comment":"Credit","cs":"Z\u016Fstatek","da":"Kredit","de":"Gutschrift","el":"\u03A0\u03AF\u03C3\u03C4\u03C9\u03C3\u03B7","en":"Credit","en-GB":"Credit","en-XA":"[\xc7\u0155\xe9\xf0\xee\u0163\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cr\xe9dito","es-AR":"Cr\xe9dito","es-ES":"Cr\xe9dito","es-MX":"Cr\xe9dito","fr":"Carte de cr\xe9dit","hu":"J\xf3v\xe1\xedr\xe1s","id":"Kredit","it":"Carta di credito","ja":"\u30AF\u30EC\u30B8\u30C3\u30C8","key":"RL_Credit","ko":"\uD06C\uB808\uB527","nb":"Kreditt","nl":"Tegoed","pl":"Karta kredytowa","pt-BR":"Cr\xe9dito","pt-PT":"Cr\xe9dito","ru":"\u041A\u0440\u0435\u0434\u0438\u0442","sv":"Kreditkort","th":"\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15","tr":"Kredi","zh-Hans":"\u4FE1\u7528\u5361","zh-Hant":"\u4FE1\u7528\u5361"},"RL_CreditDebit":{"ar":"\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0627\u0626\u062A\u0645\u0627\u0646/\u0627\u0644\u062E\u0635\u0645","ca":"Targeta de cr\xe8dit o de d\xe8bit","comment":"Generic name for a Credit/Debit card","cs":"Kreditn\xed/debetn\xed karta","da":"Kreditkort/betalingskort","de":"Kredit-/EC-Karte","el":"\u03A0\u03B9\u03C3\u03C4\u03C9\u03C4\u03B9\u03BA\u03AE/\u03C7\u03C1\u03B5\u03C9\u03C3\u03C4\u03B9\u03BA\u03AE \u03BA\u03AC\u03C1\u03C4\u03B1","en":"Credit/Debit Card","en-GB":"Credit/Debit Card","en-XA":"[\xc7\u0155\xe9\xf0\xee\u0163\u2044\xd0\xe9\u0180\xee\u0163\u2002\xc7\xe5\u0155\xf0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tarjeta de cr\xe9dito o d\xe9bito","es-AR":"Tarjeta de cr\xe9dito o d\xe9bito","es-ES":"Tarjeta de cr\xe9dito o d\xe9bito","es-MX":"Tarjeta de d\xe9bito/cr\xe9dito","fr":"Carte de paiement","hu":"Hitelk\xe1rtya/bankk\xe1rtya","id":"Kartu Kredit/Debit","it":"Carta di credito o debito","ja":"\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u307E\u305F\u306F\u30C7\u30D3\u30C3\u30C8\u30AB\u30FC\u30C9","key":"RL_CreditDebit","ko":"\uC2E0\uC6A9/\uC9C1\uBD88 \uCE74\uB4DC","nb":"Kreditt-/debetkort","nl":"Creditcard/bankpas","pl":"Karta kredytowa/debetowa","pt-BR":"Cart\xe3o de cr\xe9dito/d\xe9bito","pt-PT":"Cart\xe3o de d\xe9bito/cr\xe9dito","ru":"\u041A\u0440\u0435\u0434\u0438\u0442\u043D\u0430\u044F/\u0434\u0435\u0431\u0435\u0442\u043E\u0432\u0430\u044F \u043A\u0430\u0440\u0442\u0430","sv":"Kredit-/kontokort","th":"\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15/\u0E40\u0E14\u0E1A\u0E34\u0E15","tr":"Kredi/Banka Kart\u0131","zh-Hans":"\u4FE1\u7528\u5361/\u501F\u8BB0\u5361","zh-Hant":"\u4FE1\u7528\u5361/\u7C3D\u5E33\u91D1\u878D\u5361"},"RL_CurrSymbol":{"ar":"\u062F\u0648\u0644\u0627\u0631 \u0623\u0645\u0631\u064A\u0643\u064A","ca":"$","comment":"Currency Symbol for the country","cs":"USD","da":"USD","de":"$","el":"$","en":"$","en-GB":"$","en-XA":"[\u20AC\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"$","es-AR":"$","es-ES":"$","es-MX":"$","fr":"$","hu":"HUF","id":"$","it":"$","ja":"\u5186","key":"RL_CurrSymbol","ko":"$","nb":"$","nl":"\u20AC ","pl":"USD","pt-BR":"$","pt-PT":"$","ru":"$","sv":"$","th":"$","tr":"$","zh-Hans":"\xa5","zh-Hant":"$"},"RL_CustIsAttachTran":{"ar":"\u0627\u0644\u0639\u0645\u064A\u0644 \u0645\u0631\u062A\u0628\u0637 \u0628\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"CLIENTE VINCULADO A TRANSACCI\xd3N","comment":"CUSTOMER IS ATTACHED TO TRANSACTION","cs":"Z\xc1KAZN\xcdK JE P\u0158I\u0158AZEN K\xa0TRANSAKCI","da":"KUNDE ER VEDH\xc6FTET TRANSAKTION","de":"DER KUNDE IST DER TRANSAKTION ZUGEORDNET","el":"\u039F \u03A0\u0395\u039B\u0391\u03A4\u0397\u03A3 \u03A0\u03A1\u039F\u03A3\u0391\u03A1\u03A4\u0397\u0398\u0397\u039A\u0395 \u03A3\u0395 \u03A3\u03A5\u039D\u0391\u039B\u039B\u0391\u0393\u0397","en":"CUSTOMER IS ATTACHED TO TRANSACTION","en-GB":"CUSTOMER IS ATTACHED TO TRANSACTION","en-XA":"[\xc7\xdb\u0160\u0162\xd6\u1E40\xc9\u0154\u2002\xce\u0160\u2002\xc5\u0162\u0162\xc5\xc7\u0124\xc9\xd0\u2002\u0162\xd6\u2002\u0162\u0154\xc5\xd1\u0160\xc5\xc7\u0162\xce\xd6\xd1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"EL CLIENTE EST\xc1 ADJUNTO A LA TRANSACCI\xd3N","es-AR":"EL CLIENTE EST\xc1 ADJUNTO A LA TRANSACCI\xd3N","es-ES":"CLIENTE VINCULADO A TRANSACCI\xd3N","es-MX":"EL CLIENTE EST\xc1 VINCULADO A LA TRANSACCI\xd3N","fr":"CUSTOMER IS ATTACHED TO TRANSACTION","hu":"CUSTOMER IS ATTACHED TO TRANSACTION","id":"PELANGGAN DILAMPIRKAN PADA TANDA TERIMA","it":"CLIENTE \xc8 COLLEGATO ALLA TRANSAZIONE","ja":"\u304A\u5BA2\u69D8\u306F\u53D6\u5F15\u306B\u5BFE\u3057\u3066\u95A2\u9023\u4ED8\u3051\u3089\u308C\u3066\u3044\u307E\u3059","key":"RL_CustIsAttachTran","ko":"\uACE0\uAC1D\uC774 \uD574\uB2F9 \uAC70\uB798\uC5D0 \uC785\uB825\uB428","nb":"KUNDE ER TILKNYTTET TRANSASKJON","nl":"CONSUMENT IS GEKOPPELD AAN TRANSACTIE","pl":"KLIENT JEST PO\u0141\u0104CZONY Z TRANSAKCJ\u0104","pt-BR":"O CLIENTE EST\xc1 VINCULADO \xc0 TRANSA\xc7\xc3O","pt-PT":"CLIENTE EST\xc1 ANEXADO \xc0 TRANSA\xc7\xc3O","ru":"\u041F\u041E\u041A\u0423\u041F\u0410\u0422\u0415\u041B\u042C \u041F\u0420\u0418\u041A\u0420\u0415\u041F\u041B\u0415\u041D \u041A \u041E\u041F\u0415\u0420\u0410\u0426\u0418\u0418","sv":"KUND \xc4R KNUTEN TILL TRANSAKTION","th":"\u0E41\u0E19\u0E1A\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"M\xdc\u015ETER\u0130 \u0130\u015ELEME EKLEND\u0130","zh-Hans":"\u987E\u5BA2\u4E0E\u4EA4\u6613\u5173\u8054","zh-Hant":"\u5BA2\u6236\u5DF2\u9644\u52A0\u65BC\u4EA4\u6613"},"RL_CustomerAddress":{"ar":"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0639\u0645\u064A\u0644","ca":"Adre\xe7a del client/a","comment":"Address of the customer","cs":"Adresa z\xe1kazn\xedka","da":"Kundes adresse","de":"Adresse Kund:in","el":"\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7","en":"Customer Address","en-GB":"Customer address","en-XA":"[\xc7\xfb\u0161\u0163\xf6\u0271\xe9\u0155\u2002\xc5\xf0\xf0\u0155\xe9\u0161\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Direcci\xf3n del cliente","es-AR":"Direcci\xf3n del cliente","es-ES":"Direcci\xf3n del cliente","es-MX":"Direcci\xf3n del cliente","fr":"Adresse du client ou de la cliente","hu":"V\xe1s\xe1rl\xf3 c\xedme","id":"Alamat Pelanggan","it":"Indirizzo cliente","ja":"\u30AB\u30B9\u30BF\u30DE\u30FC\u306E\u4F4F\u6240","key":"RL_CustomerAddress","ko":"\uACE0\uAC1D \uC8FC\uC18C","nb":"Kundens adresse","nl":"Adres van klant","pl":"Adres klienta/klientki","pt-BR":"Endere\xe7o do cliente","pt-PT":"Morada do cliente","ru":"\u0410\u0434\u0440\u0435\u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u0430","sv":"Kundens adress","th":"\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32","tr":"T\xfcketicinin Adresi","zh-Hans":"\u5BA2\u6237\u5730\u5740","zh-Hant":"\u9867\u5BA2\u5730\u5740"},"RL_CustomerChangeRequest":{"ar":"\u0637\u0644\u0628 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0639\u0645\u064A\u0644","ca":"Sol\xb7licitudCanviClient","comment":"CustomerChangeRequest","cs":"CustomerChangeRequest","da":"CustomerChangeRequest","de":"CustomerChangeRequest","el":"\u0391\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7","en":"CustomerChangeRequest","en-GB":"CustomerChangeRequest","en-XA":"[\xc7\xfb\u0161\u0163\xf6\u0271\xe9\u0155\xc7\u0125\xe5\xf1\u011D\xe9\u0154\xe9\u01EB\xfb\xe9\u0161\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Solicitud de cambio del cliente","es-AR":"SolicitudCambioCliente","es-ES":"Solicitudcambiocliente","es-MX":"Cambio a solicitud del Consumidor","fr":"DemandeModificationClient","hu":"CustomerChangeRequest","id":"PermintaanPerubahanPelanggan","it":"CustomerChangeRequest","ja":"\u30AB\u30B9\u30BF\u30DE\u30FC\u5909\u66F4\u30EA\u30AF\u30A8\u30B9\u30C8","key":"RL_CustomerChangeRequest","ko":"\uACE0\uAC1D \uBCC0\uACBD \uC694\uCCAD","nb":"CustomerChangeRequest","nl":"Aanvraag klantwissel","pl":"WniosekKlientaOZmian\u0119","pt-BR":"CustomerChangeRequest","pt-PT":"PedidoDeAltera\xe7\xe3oDoCliente","ru":"CustomerChangeRequest","sv":"CustomerChangeRequest","th":"\u0E04\u0E33\u0E02\u0E2D\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32","tr":"M\xfc\u015Fteri De\u011Fi\u015Fim Talebi","zh-Hans":"CustomerChangeRequest","zh-Hant":"CustomerChangeRequest"},"RL_CustomerFirstName":{"ar":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644 \u0644\u0644\u0639\u0645\u064A\u0644","ca":"Nom del client/a","comment":"First Name of the Customer ","cs":"K\u0159estn\xed jm\xe9no z\xe1kazn\xedka","da":"Kundes fornavn","de":"Vorname Kund:in","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7","en":"Customer First Name","en-GB":"Customer first name","en-XA":"[\xc7\xfb\u0161\u0163\xf6\u0271\xe9\u0155\u2002\u0191\xee\u0155\u0161\u0163\u2002\xd1\xe5\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre del cliente","es-AR":"Nombre del cliente","es-ES":"Nombre del cliente","es-MX":"Nombre del cliente","fr":"Pr\xe9nom du client ou de la cliente","hu":"V\xe1s\xe1rl\xf3 keresztneve","id":"Nama Depan Pelanggan","it":"Nome cliente","ja":"\u30AB\u30B9\u30BF\u30DE\u30FC\u306E\u540D","key":"RL_CustomerFirstName","ko":"\uACE0\uAC1D \uC774\uB984","nb":"Kundens fornavn","nl":"Voornaam van klant","pl":"Imi\u0119 klienta/klientki","pt-BR":"Nome do cliente","pt-PT":"Nome pr\xf3prio do cliente","ru":"\u0418\u043C\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0430","sv":"Kundens f\xf6rnamn","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32","tr":"T\xfcketicinin Ad\u0131","zh-Hans":"\u5BA2\u6237\u540D\u5B57","zh-Hant":"\u9867\u5BA2\u540D\u5B57"},"RL_CustomerLastName":{"ar":"\u0627\u0633\u0645 \u0639\u0627\u0626\u0644\u0629 \u0627\u0644\u0639\u0645\u064A\u0644 ","ca":"Cognoms del client/a ","comment":"Last name of the customer. ","cs":"P\u0159\xedjmen\xed z\xe1kazn\xedka ","da":"Kundes efternavn ","de":"Nachname Kund:in ","el":"\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF \u03C0\u03B5\u03BB\u03AC\u03C4\u03B7 ","en":"Customer Last Name ","en-GB":"Customer surname ","en-XA":"[\xc7\xfb\u0161\u0163\xf6\u0271\xe9\u0155\u2002\u013B\xe5\u0161\u0163\u2002\xd1\xe5\u0271\xe9\u2002\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Apellido del cliente ","es-AR":"Apellido del cliente ","es-ES":"Apellidos del cliente ","es-MX":"Apellido del cliente ","fr":"Nom du client ou de la cliente ","hu":"V\xe1s\xe1rl\xf3 vezet\xe9kneve ","id":"Nama Belakang Pelanggan ","it":"Cognome cliente ","ja":"\u30AB\u30B9\u30BF\u30DE\u30FC\u306E\u59D3 ","key":"RL_CustomerLastName","ko":"\uACE0\uAC1D \uC131 ","nb":"Kundens etternavn ","nl":"Achternaam van klant ","pl":"Nazwisko klienta/klientki ","pt-BR":"Sobrenome do cliente ","pt-PT":"Apelido do cliente ","ru":"\u0424\u0430\u043C\u0438\u043B\u0438\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u0430 ","sv":"Kundens efternamn ","th":"\u0E19\u0E32\u0E21\u0E2A\u0E01\u0E38\u0E25\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32 ","tr":"M\xfc\u015Fterinin Soyad\u0131 ","zh-Hans":"\u5BA2\u6237\u59D3\u6C0F ","zh-Hant":"\u9867\u5BA2\u59D3\u6C0F "},"RL_DEFECTIVE":{"ar":"\u0641\u064A\u0647 \u062E\u0644\u0644","ca":"DEFECTUOSO","comment":"Reason code indicates the DEFECTIVE return","cs":"DEFEKTY","da":"DEFEKTE","de":"FEHLERHAFT","el":"\u0395\u039B\u0391\u03A4\u03A4\u03A9\u039C\u0391\u03A4\u0399\u039A\u039F","en":"DEFECTIVE","en-GB":"DEFECTIVE","en-XA":"[\xd0\xc9\u0191\xc9\xc7\u0162\xce\u1E7C\xc9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"DEFECTUOSO","es-AR":"DEFECTUOSO","es-ES":"DEFECTUOSO","es-MX":"DEFECTUOSO","fr":"MARCHANDISE D\xc9FECTUEUSE","hu":"DEFECTIVE","id":"CACAT","it":"DIFETTOSO","ja":"DEFECTIVE","key":"RL_DEFECTIVE","ko":"\uACB0\uD568","nb":"\xd8DELAGT","nl":"DEFECT","pl":"WADLIWY","pt-BR":"COM DEFEITO","pt-PT":"DEFEITUOSO","ru":"DEFECTIVE","sv":"DEFEKT","th":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E21\u0E35\u0E15\u0E33\u0E2B\u0E19\u0E34","tr":"KUSURLU","zh-Hans":"\u7455\u75B5\u5546\u54C1","zh-Hant":"\u7455\u75B5"},"RL_DUPLICATERECEIPT":{"ar":"\u0625\u064A\u0635\u0627\u0644 \u0645\u0643\u0631\u0651\u0631","ca":"Duplicado de Recibo","comment":"DUPLICATE RECEIPT","cs":"DUPLIK\xc1T \xdaCTENKY","da":"BON I TO EKSEMPLARER","de":"DUPLIKAT BELEG","el":"\u0394\u0397\u039C\u0399\u039F\u03A5\u03A1\u0393\u0399\u0391 \u0391\u039D\u03A4\u0399\u0393\u03A1\u0391\u03A6\u039F\u03A5 \u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397\u03A3","en":"DUPLICATE RECEIPT","en-GB":"DUPLICATE RECEIPT","en-XA":"[\xd0\xdb\xde\u013B\xce\xc7\xc5\u0162\xc9\u2002\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"RECIBO DUPLICADO","es-AR":"RECIBO DUPLICADO","es-ES":"Duplicado de Recibo","es-MX":"RECIBO DUPLICADO","fr":"DUPLICATE RECEIPT","hu":"DUPLICATE RECEIPT","id":"TANDA TERIMA DUPLIKAT","it":"DUPLICA RICEVUTA","ja":"\u518D\u5370\u5237","key":"RL_DUPLICATERECEIPT","ko":"\uC601\uC218\uC99D \uBCF5\uC0AC","nb":"DUPLIKATKVITTERING","nl":"KOPIE BON","pl":"Duplikat paragonu","pt-BR":"RECIBO DUPLICADO","pt-PT":"DUPLICADO DO RECIBO","ru":"\u0414\u0423\u0411\u041B\u0418\u041A\u0410\u0422 \u0427\u0415\u041A\u0410","sv":"DUPLICERA KVITTO","th":"\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E0B\u0E49\u0E33\u0E0B\u0E49\u0E2D\u0E19","tr":"YEN\u0130DEN YAZDIR","zh-Hans":"\u6536\u636E\u91CD\u590D","zh-Hant":"\u6536\u64DA\u526F\u672C"},"RL_Date":{"ar":"\u0627\u0644\u062A\u0627\u0631\u064A\u062E","ca":"Fecha","comment":"Date of transaction","cs":"Datum","da":"Dato","de":"Datum","el":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1","en":"Date","en-GB":"Date","en-XA":"[\xd0\xe5\u0163\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Fecha","es-AR":"Fecha","es-ES":"Fecha","es-MX":"esperada","fr":"Date","hu":"Date","id":"Tanggal","it":"Data","ja":"\u65E5\u4ED8","key":"RL_Date","ko":"\uB0A0\uC9DC","nb":"Dato","nl":"Datum","pl":"Data","pt-BR":"Data","pt-PT":"Data","ru":"\u0414\u0430\u0442\u0430","sv":"Datum","th":"\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48","tr":"Tarih","zh-Hans":"\u65E5\u671F","zh-Hant":"\u4EA4\u6613\u65E5\u671F"},"RL_DateEJ":{"ar":"\u0627\u0644\u062A\u0627\u0631\u064A\u062E","ca":"Fecha","comment":"Current system date","cs":"Datum","da":"Dato","de":"Datum","el":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1","en":"Date","en-GB":"Date","en-XA":"[\xd0\xe5\u0163\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Fecha","es-AR":"Fecha","es-ES":"Fecha","es-MX":"Fecha","fr":"Date","hu":"Date","id":"Tanggal","it":"Data","ja":"\u65E5\u4ED8","key":"RL_DateEJ","ko":"\uB0A0\uC9DC","nb":"Dato","nl":"Datum","pl":"Data","pt-BR":"Data","pt-PT":"Data","ru":"\u0414\u0430\u0442\u0430","sv":"Datum","th":"\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48","tr":"Tarih","zh-Hans":"\u65E5\u671F","zh-Hant":"\u65E5\u671F"},"RL_DateRange":{"ar":"\u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E","ca":"Interval de dates","comment":"Date Range - from date and to date","cs":"Rozsah dat","da":"Datointerval","de":"Datumsbereich","el":"\u0395\u03CD\u03C1\u03BF\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD","en":"Date Range","en-GB":"Date Range","en-XA":"[\xd0\xe5\u0163\xe9\u2002\u0154\xe5\xf1\u011D\xe9\u2002\xe5\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Intervalo de fechas","es-AR":"Rango de fechas","es-ES":"Rango de fechas","es-MX":"Rango de fechas","fr":"P\xe9riode","hu":"D\xe1tumtartom\xe1ny","id":"Rentang Tanggal","it":"Intervallo di date","ja":"\u671F\u9593","key":"RL_DateRange","ko":"\uB0A0\uC9DC \uBC94\uC704","nb":"Datointervall","nl":"Datumbereik","pl":"Zakres dat","pt-BR":"Per\xedodo","pt-PT":"Intervalo de datas","ru":"\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442","sv":"Datumintervall","th":"\u0E0A\u0E48\u0E27\u0E07\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48","tr":"Tarih Aral\u0131\u011F\u0131","zh-Hans":"\u65E5\u671F\u8303\u56F4","zh-Hant":"\u65E5\u671F\u7BC4\u570D"},"RL_Debit":{"ar":"\u062E\u0635\u0645","ca":"D\xe8bit","comment":"Debit","cs":"Debetn\xed karta","da":"Debet","de":"Lastschrift","el":"\u03A7\u03C1\u03AD\u03C9\u03C3\u03B7","en":"Debit","en-GB":"Debit","en-XA":"[\xd0\xe9\u0180\xee\u0163\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"D\xe9bito","es-AR":"D\xe9bito","es-ES":"D\xe9bito","es-MX":"D\xe9bito","fr":"Carte de d\xe9bit","hu":"Terhel\xe9s","id":"Debit","it":"Carta di debito","ja":"\u30C7\u30D3\u30C3\u30C8","key":"RL_Debit","ko":"\uC9C1\uBD88","nb":"Debet","nl":"Bank","pl":"Karta debetowa","pt-BR":"D\xe9bito","pt-PT":"D\xe9bito","ru":"\u0414\u0435\u0431\u0435\u0442","sv":"Betalkort","th":"\u0E40\u0E14\u0E1A\u0E34\u0E15","tr":"Banka kart\u0131","zh-Hans":"\u501F\u8BB0\u5361","zh-Hant":"\u7C3D\u5E33\u91D1\u878D\u5361"},"RL_DefectiveReceiptStoreCopy":{"ar":"\u0646\u0633\u062E\u0629 \u0627\u0644\u0625\u064A\u0635\u0627\u0644 \u0627\u0644\u062A\u0627\u0628\u0639\u0629 \u0644\u0644\u0645\u062A\u062C\u0631 \u0641\u064A\u0647\u0627 \u062E\u0644\u0644","ca":"Copia tienda recibo defect","comment":"header of the defective return receipt to indicates the store copy of the defective return","cs":"Kopie dokladu o defektech","da":"Defekt kvittering butik kopi","de":"Mangelhafter Beleg Kopie des Shops","el":"\u0391\u03BD\u03C4\u03AF\u03B3\u03C1\u03B1\u03C6\u03BF \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03B1\u03C0\u03CC\u03B4\u03B5\u03B9\u03BE\u03B7\u03C2 \u03B5\u03BB\u03B1\u03C4\u03C4\u03C9\u03BC\u03B1\u03C4\u03B9\u03BA\u03BF\u03CD \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2","en":"Defective Receipt Store Copy","en-GB":"Defective Receipt Store Copy","en-XA":"[\xd0\xe9\u0192\xe9\xe7\u0163\xee\u1E7D\xe9\u2002\u0154\xe9\xe7\xe9\xee\xfe\u0163\u2002\u0160\u0163\xf6\u0155\xe9\u2002\xc7\xf6\xfe\xfd\u2002\xe5\u0180\xe7\xf0\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Copia de recibo defectuoso de tienda","es-AR":"Copia de recibo defectuoso de tienda","es-ES":"Copia tienda recibo defect","es-MX":"Copia de recibo defectuoso de tienda","fr":"Exemplaire du magasin du re\xe7u de marchandise d\xe9fectueuse","hu":"Defective Receipt Store Copy","id":"Salinan Toko Tanda Terima Cacat","it":"Copia ricevuta articolo difettoso punto vendita","ja":"Defective Receipt Store Copy","key":"RL_DefectiveReceiptStoreCopy","ko":"\uACB0\uD568 \uBC18\uD488 \uC601\uC218\uC99D \uB9E4\uC7A5\uC6A9 \uC0AC\uBCF8","nb":"Kvittering for \xf8delagt retur butikkeksemplar","nl":"Exemplaar bon defect artikel voor store","pl":"Uszkodzona sklepowa kopia zapasowa","pt-BR":"C\xf3pia do recibo da loja com defeito","pt-PT":"C\xf3pia Store Recibo Defeituoso","ru":"Defective Receipt Store Copy","sv":"Defekt kvitto, Storeexemplar","th":"\u0E2A\u0E33\u0E40\u0E19\u0E32\u0E23\u0E49\u0E32\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E21\u0E35\u0E15\u0E33\u0E2B\u0E19\u0E34","tr":"Kusurlu Makbuzu Ma\u011Faza Kopyas\u0131","zh-Hans":"\u7455\u75B5\u5546\u54C1\u6536\u636E\u5546\u5E97\u526F\u672C","zh-Hant":"\u7455\u75B5\u6536\u64DA\u5546\u5E97\u806F"},"RL_Delivered":{"ar":"\u062A\u0645 \u0627\u0644\u062A\u0633\u0644\u064A\u0645","ca":"Lliurades","comment":"Transactions that are completed/Delivered","cs":"Doru\u010Den\xe1","da":"Leveret","de":"Zugestellt","el":"\u03A0\u03B1\u03C1\u03B1\u03B4\u03BF\u03BC\u03AD\u03BD\u03B5\u03C2","en":"Delivered","en-GB":"Delivered","en-XA":"[\xd0\xe9\u013C\xee\u1E7D\xe9\u0155\xe9\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Entregada","es-AR":"Entregado","es-ES":"Entregado","es-MX":"Entregado","fr":"Livraison effectu\xe9e","hu":"Teljes\xedtett","id":"Terkirim","it":"Completate","ja":"\u914D\u9001\u6E08\u307F","key":"RL_Delivered","ko":"\uBC30\uC1A1\uB428","nb":"Levert","nl":"Afgeleverd","pl":"Dostarczone","pt-BR":"Entregue","pt-PT":"Conclu\xedda","ru":"\u0414\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043E","sv":"Levererad","th":"\u0E2A\u0E48\u0E07\u0E21\u0E2D\u0E1A\u0E41\u0E25\u0E49\u0E27","tr":"Teslim Edildi","zh-Hans":"\u5DF2\u914D\u9001","zh-Hant":"\u5DF2\u51FA\u8CA8"},"RL_Department1":{"ar":"\u0627\u0644\u0642\u0633\u0645:","ca":"Departamento:","comment":"Department:","cs":"Odd\u011Blen\xed:","da":"Afdeling:","de":"Department:","el":"\u03A4\u03BC\u03AE\u03BC\u03B1:","en":"Department:","en-GB":"Department:","en-XA":"[\xd0\xe9\xfe\xe5\u0155\u0163\u0271\xe9\xf1\u0163\u2236\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Departamento:","es-AR":"Departamento:","es-ES":"Departamento:","es-MX":"Departamento:","fr":"Rayon\xa0:","hu":"Department:","id":"Departemen:","it":"Reparto:","ja":"Department:","key":"RL_Department1","ko":"\uBD80\uC11C:","nb":"Avdeling:","nl":"Afdeling:","pl":"Dzia\u0142:","pt-BR":"Departamento:","pt-PT":"Sec\xe7\xe3o:","ru":"\u041E\u0442\u0434\u0435\u043B:","sv":"Avdelning:","th":"\u0E1D\u0E48\u0E32\u0E22","tr":"B\xf6l\xfcm:","zh-Hans":"\u90E8\u95E8:","zh-Hant":"\u90E8\u9580:"},"RL_DeviceID":{"ar":"\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062C\u0647\u0627\u0632","ca":"Identificador del dispositiu","comment":"Unique ID of the Clean Cash device ( fiscal device) from which the digital signatures are issued for the transaction.","cs":"ID za\u0159\xedzen\xed","da":"Enheds-id","de":"Ger\xe4te-ID","el":"\u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE\u03C2","en":"Device ID","en-GB":"Device ID","en-XA":"[\xd0\xe9\u1E7D\xee\xe7\xe9\u2002\xce\xd0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"ID del dispositivo","es-AR":"ID del dispositivo","es-ES":"ID del dispositivo","es-MX":"ID del dispositivo","fr":"ID de l\'appareil","hu":"Eszk\xf6zazonos\xedt\xf3","id":"ID Perangkat","it":"ID dispositivo","ja":"\u30C7\u30D0\u30A4\u30B9ID","key":"RL_DeviceID","ko":"\uAE30\uAE30 ID","nb":"Enhets-ID","nl":"Device-ID","pl":"Identyfikator urz\u0105dzenia","pt-BR":"ID do dispositivo","pt-PT":"ID do dispositivo","ru":"ID \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430","sv":"Enhets-id","th":"ID \u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C","tr":"Cihaz Kimli\u011Fi","zh-Hans":"\u8BBE\u5907 ID","zh-Hant":"\u88DD\u7F6E ID"},"RL_Difference":{"ar":"\u0627\u0644\u0641\u064E\u0631\u0642","ca":"Diferencia","comment":"Difference  after a price override","cs":"Rozd\xed","da":"Difference","de":"Differenz","el":"\u0394\u03B9\u03B1\u03C6\u03BF\u03C1\u03AC","en":"Difference","en-GB":"Difference","en-XA":"[\xd0\xee\u0192\u0192\xe9\u0155\xe9\xf1\xe7\xe9\u2002\xe5\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Diferencia","es-AR":"Diferencia","es-ES":"Diferencia","es-MX":"Diferencia","fr":"Difference","hu":"Difference","id":"Selisih","it":"Differenza","ja":"\u5DEE\u7570","key":"RL_Difference","ko":"\uCC28\uC561","nb":"Forskjell","nl":"Verschil","pl":"R\xf3\u017Cnica","pt-BR":"Diferen\xe7a","pt-PT":"Diferenca","ru":"\u0420\u0430\u0437\u043D\u0438\u0446\u0430","sv":"Skillnad","th":"\u0E04\u0E27\u0E32\u0E21\u0E41\u0E15\u0E01\u0E15\u0E48\u0E32\u0E07","tr":"Fark","zh-Hans":"\u5DEE\u989D","zh-Hant":"\u5DEE\u7570"},"RL_DigitalOrderNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0637\u0644\u0628\u064A\u0629 \u0627\u0644\u0631\u0642\u0645\u064A\u0651\u0629 ","ca":"N\xfamero de la comanda digital","comment":"Digital Order Number is the unique identifier of a transaction printed on the receipt. ","cs":"\u010C\xedslo elektronick\xe9 objedn\xe1vky","da":"Digitalt ordrenummer","de":"Digitale Bestellnummer ","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 ","en":"Digital Order Number ","en-GB":"Digital Order Number","en-XA":"[\xd0\xee\u011D\xee\u0163\xe5\u013C\u2002\xd6\u0155\xf0\xe9\u0155\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero del pedido digital","es-AR":"N\xfamero de pedido digital","es-ES":"N\xfamero de pedido digital","es-MX":"N\xfamero de pedido digital ","fr":"Num\xe9ro de commande num\xe9rique","hu":"Digit\xe1lis rendel\xe9ssz\xe1m","id":"Nomor Pesanan Digital ","it":"Numero ordine digitale ","ja":"\u30C7\u30B8\u30BF\u30EB\u306E\u3054\u6CE8\u6587\u756A\u53F7","key":"RL_DigitalOrderNumber","ko":"\uC8FC\uBB38\uBC88\uD638","nb":"Digitalt bestillingsnummer ","nl":"Digitaal bestelnummer","pl":"Numer zam\xf3wienia cyfrowego","pt-BR":"N\xfamero do pedido digital","pt-PT":"N\xfamero da encomenda digital","ru":"\u041D\u043E\u043C\u0435\u0440 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Digitalt best\xe4llningsnummer ","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25","tr":"Dijital Sipari\u015F Numaras\u0131","zh-Hans":"\u6570\u5B57\u8BA2\u5355\u53F7 ","zh-Hant":"\u6578\u4F4D\u8A02\u55AE\u7DE8\u865F"},"RL_DigitalSignature":{"ar":"\u0627\u0644\u062A\u0648\u0642\u064A\u0639 \u0627\u0644\u0631\u0642\u0645\u064A","ca":"Signatura digital","comment":"Digital Signature printed on the receipt for ensuring the authenticity and validity of a transaction.","cs":"Elektronick\xfd podpis","da":"Digital underskrift","de":"Digitale Unterschrift","el":"\u03A8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE \u03C5\u03C0\u03BF\u03B3\u03C1\u03B1\u03C6\u03AE","en":"Digital Signature","en-GB":"Digital Signature","en-XA":"[\xd0\xee\u011D\xee\u0163\xe5\u013C\u2002\u0160\xee\u011D\xf1\xe5\u0163\xfb\u0155\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Firma digital","es-AR":"Firma digital","es-ES":"Firma digital","es-MX":"Firma digital","fr":"Signature num\xe9rique","hu":"Digit\xe1lis al\xe1\xedr\xe1s","id":"Tanda Tangan Digital","it":"Firma digitale","ja":"\u30C7\u30B8\u30BF\u30EB\u7F72\u540D","key":"RL_DigitalSignature","ko":"\uB514\uC9C0\uD138 \uC11C\uBA85","nb":"Digital signatur","nl":"Digitale handtekening","pl":"Podpis elektroniczny","pt-BR":"Assinatura digital","pt-PT":"Assinatura digital","ru":"\u0426\u0438\u0444\u0440\u043E\u0432\u0430\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u044C","sv":"Digital signatur","th":"\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D\u0E41\u0E1A\u0E1A\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25","tr":"Dijital \u0130mza","zh-Hans":"\u6570\u5B57\u7B7E\u540D","zh-Hant":"\u6578\u4F4D\u7C3D\u540D"},"RL_DiscountSummary":{"ar":"\u0645\u0644\u062E\u0651\u0635 \u0627\u0644\u062E\u0635\u0645","ca":"Resum del descompte","comment":"Discount summary","cs":"P\u0159ehled slevy","da":"Opsummering af rabat","de":"Rabattzusammenfassung","el":"\u03A3\u03CD\u03BD\u03BF\u03C8\u03B7 \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7\u03C2","en":"Summary of Discount","en-GB":"Summary of Discount","en-XA":"[\u0160\xfb\u0271\u0271\xe5\u0155\xfd\u2002\xf6\u0192\u2002\xd0\xee\u0161\xe7\xf6\xfb\xf1\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Resumen del descuento","es-AR":"Resumen del descuento","es-ES":"Resumen de los descuentos","es-MX":"Resumen del descuento","fr":"R\xe9capitulatif de la r\xe9duction","hu":"Kedvezm\xe9ny \xf6sszegz\xe9se","id":"Ringkasan Diskon","it":"Riepilogo dello sconto","ja":"\u5272\u5F15\u306E\u6982\u8981","key":"RL_DiscountSummary","ko":"\uD560\uC778 \uC694\uC57D","nb":"Sammendrag av rabatt","nl":"Overzicht korting","pl":"Podsumowanie rabat\xf3w","pt-BR":"Resumo de desconto","pt-PT":"Resumo do desconto","ru":"\u041E\u0431\u0437\u043E\u0440 \u0441\u043A\u0438\u0434\u043E\u043A","sv":"Sammanfattning av rabatt","th":"\u0E2A\u0E23\u0E38\u0E1B\u0E22\u0E2D\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14","tr":"\u0130ndirim \xd6zeti","zh-Hans":"\u6298\u6263\u6458\u8981","zh-Hant":"\u6298\u6263\u6458\u8981"},"RL_DocumentName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u0646\u062F","ca":"Nom del document","comment":"The name of the document for which a document number is printed. Example ReceiptNumber","cs":"\u010C\xedslo dokumentu","da":"Dokumentnavn","de":"Dokumentenname","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03B5\u03B3\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5","en":"Document Name","en-GB":"Document Name","en-XA":"[\xd0\xf6\xe7\xfb\u0271\xe9\xf1\u0163\u2002\xd1\xe5\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre del documento","es-AR":"Nombre del documento","es-ES":"Tipo de documento","es-MX":"Nombre del documento","fr":"Nom de document","hu":"Dokumentum neve","id":"Nama Dokumen","it":"Nome documento","ja":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u540D","key":"RL_DocumentName","ko":"\uBB38\uC11C \uC774\uB984","nb":"Dokumentnavn","nl":"Documentnaam","pl":"Nazwa dokumentu","pt-BR":"Nome do documento","pt-PT":"Nome do documento","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430","sv":"Dokumentnamn","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23","tr":"Belge Ad\u0131","zh-Hans":"\u5355\u636E\u540D\u79F0","zh-Hant":"\u6587\u4EF6\u540D\u7A31"},"RL_DocumentNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0645\u0633\u062A\u0646\u062F:","ca":"N\xfam. de document:","comment":"A unique sequence number generated for every transaction/receipt in the store.","cs":"Dokument \u010D.","da":"Dokument-nr.:","de":"Dokumentennr.: ","el":"\u0391\u03C1. \u03B5\u03B3\u03B3\u03C1\u03AC\u03C6\u03BF\u03C5: ","en":"Document No: ","en-GB":"Document No.: ","en-XA":"[\xd0\xf6\xe7\xfb\u0271\xe9\xf1\u0163\u2002\xd1\xf6\u2236\u2002\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero del documento:","es-AR":"N.\xba de documento","es-ES":"N.\xba de documento:","es-MX":"N\xb0 de documento","fr":"N\xb0 de document\xa0:","hu":"Dokumentum sz\xe1ma:","id":"No. Dokumen: ","it":"Numero documento:","ja":"\u30C9\u30AD\u30E5\u30E1\u30F3\u30C8\u756A\u53F7\uFF1A","key":"RL_DocumentNumber","ko":"\uBB38\uC11C \uBC88\uD638:","nb":"Dokumentnr.: ","nl":"Documentnr.","pl":"Nr dokumentu:","pt-BR":"N\xfamero do documento:","pt-PT":"Documento n.\xba:","ru":"\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u2116","sv":"Dokumentnr:","th":"\u0E40\u0E25\u0E02\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23","tr":"Belge No:","zh-Hans":"\u5355\u636E\u7F16\u53F7\uFF1A","zh-Hant":"\u6587\u4EF6\u7DE8\u865F\uFF1A"},"RL_DocumentType":{"ar":"\u0627\u0644\u0646\u0648\u0639","ca":"Tipus","comment":"The type of document that is printed in the store","cs":"Typ","da":"Type","de":"Typ","el":"\u03A4\u03CD\u03C0\u03BF\u03C2","en":"Type","en-GB":"Type","en-XA":"[\u0162\xfd\xfe\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tipo","es-AR":"Tipo","es-ES":"Tipo","es-MX":"Tipo","fr":"Type","hu":"T\xedpus","id":"Jenis","it":"Tipo","ja":"\u7A2E\u985E","key":"RL_DocumentType","ko":"\uC720\uD615","nb":"Type","nl":"Type","pl":"Typ","pt-BR":"Tipo","pt-PT":"Tipo","ru":"\u0422\u0438\u043F","sv":"Typ","th":"\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17","tr":"T\xfcr","zh-Hans":"\u7C7B\u578B","zh-Hant":"\u985E\u578B"},"RL_EJExportSuccess":{"ar":"\u0646\u062C\u062D\u062A \u0627\u0644\u0639\u0645\u0644\u064A\u0629! \u062A\u0645 \u062A\u0646\u0632\u064A\u0644 \u0623\u062D\u062F\u062B \u0661\u0660\u0660 \u0645\u0639\u0627\u0645\u0644\u0629 \u0645\u0637\u0627\u0628\u0642\u0629 \u0644\u0645\u0639\u0627\u064A\u064A\u0631 \u0627\u0644\u0628\u062D\u062B. \u0625\u0630\u0627 \u0644\u0645 \u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0645\u0639\u0627\u0645\u0644\u0629\u064D \u0645\u0627\u060C \u0641\u064A\u0631\u062C\u0649 \u062A\u0636\u064A\u064A\u0642 \u0646\u0637\u0627\u0642 \u0646\u062A\u0627\u0626\u062C \u0627\u0644\u0628\u062D\u062B \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0639\u0648\u0627\u0645\u0644 \u0627\u0644\u062A\u0635\u0641\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0627\u0644\u0628\u062D\u062B.","ca":"Ho has aconseguit S\'han descarregat les 100\xa0transaccions m\xe9s recents segons els criteris de cerca. Si no trobes alguna transacci\xf3, ajusta els filtres de cerca per definir m\xe9s els resultats.","comment":"Success Message when search results are exported from the Electronic Journal UI. ","cs":"Poda\u0159ilo se!! St\xe1hlo se posledn\xedch sto transakc\xed, kter\xe9 odpov\xeddaj\xed krit\xe9ri\xedm hled\xe1n\xed. Pokud se ti transakci neda\u0159\xed naj\xedt, zkust z\xfa\u017Eit v\xfdsledky vyhled\xe1v\xe1n\xed pomoc\xed filtr\u016F.","da":"Gennemf\xf8rt! Download de seneste 100 transaktioner, der matcher s\xf8gekriterierne. Hvis du ikke kan finde en transaktion, kan du indsn\xe6vre s\xf8geresultaterne med s\xf8gefiltre.","de":"Es hat funktioniert! Die letzten 100 Transaktionen, die den Suchkriterien entsprechen, wurden heruntergeladen. Wenn du eine Transaktion nicht finden kannst, verfeinere das Suchergebnis mit den Suchfiltern.","el":"\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1! \u0388\u03B3\u03B9\u03BD\u03B5 \u03BB\u03AE\u03C8\u03B7 \u03C4\u03C9\u03BD 100 \u03C0\u03B9\u03BF \u03C0\u03C1\u03CC\u03C3\u03C6\u03B1\u03C4\u03C9\u03BD \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03C0\u03BF\u03C5 \u03C4\u03B1\u03B9\u03C1\u03B9\u03AC\u03B6\u03BF\u03C5\u03BD \u03BC\u03B5 \u03C4\u03B1 \u03BA\u03C1\u03B9\u03C4\u03AE\u03C1\u03B9\u03B1 \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2. \u0391\u03BD \u03B4\u03B5\u03BD \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B2\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE, \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03AF\u03C3\u03C4\u03B5 \u03C4\u03B1 \u03BA\u03C1\u03B9\u03C4\u03AE\u03C1\u03B9\u03B1 \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03CE\u03BD\u03C4\u03B1\u03C2 \u03C6\u03AF\u03BB\u03C4\u03C1\u03B1 \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2.","en":"Success! Downloaded the most recent 100 transactions matching the search criteria. If you are unable to find a transaction, please narrow down the search result using search filters.","en-GB":"Success! Downloaded the most recent 100 transactions matching the search criteria. If you are unable to find a transaction, please narrow down the search result using search filters.","en-XA":"[\u0160\xfb\xe7\xe7\xe9\u0161\u0161\xa1\u2002\xd0\xf6\u0175\xf1\u013C\xf6\xe5\xf0\xe9\xf0\u2002\u0163\u0125\xe9\u2002\u0271\xf6\u0161\u0163\u2002\u0155\xe9\xe7\xe9\xf1\u0163\u2002\u2460\u24EA\u24EA\u2002\u0163\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u0161\u2002\u0271\xe5\u0163\xe7\u0125\xee\xf1\u011D\u2002\u0163\u0125\xe9\u2002\u0161\xe9\xe5\u0155\xe7\u0125\u2002\xe7\u0155\xee\u0163\xe9\u0155\xee\xe5\xb7\u2002\xce\u0192\u2002\xfd\xf6\xfb\u2002\xe5\u0155\xe9\u2002\xfb\xf1\xe5\u0180\u013C\xe9\u2002\u0163\xf6\u2002\u0192\xee\xf1\xf0\u2002\xe5\u2002\u0163\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u060C\u2002\xfe\u013C\xe9\xe5\u0161\xe9\u2002\xf1\xe5\u0155\u0155\xf6\u0175\u2002\xf0\xf6\u0175\xf1\u2002\u0163\u0125\xe9\u2002\u0161\xe9\xe5\u0155\xe7\u0125\u2002\u0155\xe9\u0161\xfb\u013C\u0163\u2002\xfb\u0161\xee\xf1\u011D\u2002\u0161\xe9\xe5\u0155\xe7\u0125\u2002\u0192\xee\u013C\u0163\xe9\u0155\u0161\xb7\u2002\xe5\u0180\xe7\xf0\xe9\u0192\u011D\u0125\xee\u0135\u0137\u013C\u0271\xf1\xf6\xfe\u01EB\u0155\u0161\u0163\xfb\u1E7D\u0175\u1E8B\xfd\u017E\xc5\u0181\xc7\xd0\xc9\u0191\u011C\u0124\xce\u0134\u0136\u013B\u1E40\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Listo. Se descargaron las 100 transacciones m\xe1s recientes de acuerdo con los criterios de b\xfasqueda. Si no puedes encontrar una transacci\xf3n, reduce los resultados de la b\xfasqueda con los filtros.","es-AR":"Hecho Se descargaron las 100 transacciones m\xe1s recientes seg\xfan el criterio de b\xfasqueda. Si no pod\xe9s encontrar una transacci\xf3n, reduc\xed los resultados de la b\xfasqueda con los filtros.","es-ES":"Hecho Se han descargado las 100\xa0transacciones m\xe1s recientes seg\xfan los criterios de b\xfasqueda. Si no encuentras una transacci\xf3n, ajusta m\xe1s los filtros de b\xfasqueda.","es-MX":"Listo. Se descargaron las 100 transacciones m\xe1s recientes seg\xfan el criterio de b\xfasqueda. Si no encuentras una transacci\xf3n, reduce los resultados con los filtros de b\xfasqueda.","fr":"C\'est un succ\xe8s\xa0! Les 100\xa0transactions les plus r\xe9centes correspondant aux crit\xe8res de recherche ont \xe9t\xe9 t\xe9l\xe9charg\xe9es. Si vous ne parvenez pas \xe0 trouver une transaction, r\xe9duisez le nombre de r\xe9sultats \xe0 l\'aide des filtres de recherche.","hu":"Siker! Let\xf6lt\xf6tt\xfck a keres\xe9si felt\xe9teleknek megfelel\u0151 legut\xf3bbi 100 tranzakci\xf3t. Ha nem tal\xe1lsz egy tranzakci\xf3t, sz\u0171k\xedtsd le a keres\xe9si tal\xe1latokat a keres\xe9si sz\u0171r\u0151k seg\xedts\xe9g\xe9vel.","id":"Berhasil! 100 transaksi terbaru yang cocok dengan kriteria pencarian telah diunduh. Jika transaksi tidak dapat ditemukan, persempit hasil pencarian menggunakan filter pencarian.","it":"Operazione riuscita! Hai scaricato le 100 transazioni pi\xf9 recenti che soddisfano i criteri di ricerca. Se non riesci a trovare una transazione, restringi i risultati di ricerca usando i filtri.","ja":"\u6210\u529F \u691C\u7D22\u6761\u4EF6\u306B\u5408\u3063\u305F\u76F4\u8FD1100\u4EF6\u306E\u53D6\u5F15\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u307E\u3057\u305F\u3002 \u53D6\u5F15\u304C\u898B\u3064\u304B\u3089\u306A\u3044\u5834\u5408\u306F\u3001\u691C\u7D22\u30D5\u30A3\u30EB\u30BF\u30FC\u3092\u4F7F\u3063\u3066\u691C\u7D22\u7D50\u679C\u3092\u7D5E\u308A\u8FBC\u3093\u3067\u304F\u3060\u3055\u3044\u3002","key":"RL_EJExportSuccess","ko":"\uC131\uACF5\uD588\uC2B5\uB2C8\uB2E4! \uAC80\uC0C9 \uAE30\uC900\uC5D0 \uC77C\uCE58\uD558\uB294 \uCD5C\uADFC 100\uAC74\uC758 \uAC70\uB798\uB97C \uB2E4\uC6B4\uB85C\uB4DC\uD588\uC2B5\uB2C8\uB2E4. \uAC70\uB798\uB97C \uCC3E\uC744 \uC218 \uC5C6\uB294 \uACBD\uC6B0 \uAC80\uC0C9 \uD544\uD130\uB97C \uC0AC\uC6A9\uD558\uC5EC \uAC80\uC0C9 \uACB0\uACFC\uC758 \uBC94\uC704\uB97C \uCD95\uC18C\uD574 \uC8FC\uC138\uC694.","nb":"Vellykket! Den 100 nyeste transaksjonene som matcher s\xf8kekriteriene, er lastet ned. Hvis du ikke finner en bestemt transaksjon, m\xe5 du snevre inn s\xf8keresultatet ved hjelp av s\xf8kefiltrene.","nl":"Gelukt! De 100 meest recente transacties die overeenkomen met de zoekcriteria zijn gedownload. Als je een transactie niet kunt vinden, beperk dan het zoekresultaat met de zoekfilters.","pl":"Uda\u0142o si\u0119! Pobrano 100 ostatnich transakcji pasuj\u0105cych do kryteri\xf3w wyszukiwania. Je\u015Bli nie mo\u017Cesz znale\u017A\u0107 danej transakcji, zaw\u0119\u017A wyniki wyszukiwania przy u\u017Cyciu filtr\xf3w wyszukiwania.","pt-BR":"Conclu\xeddo! Fa\xe7a o download das 100 transa\xe7\xf5es mais recentes que correspondem aos crit\xe9rios de pesquisa. Caso n\xe3o consiga encontrar uma transa\xe7\xe3o, limite o resultado da pesquisa usando os filtros de pesquisa.","pt-PT":"\xcaxito! Foram transferidas as 100\xa0transa\xe7\xf5es mais recentes que correspondem aos crit\xe9rios de pesquisa. Se n\xe3o conseguir encontrar uma transa\xe7\xe3o, limite o resultado da pesquisa utilizando filtros de pesquisa.","ru":"\u0423\u0441\u043F\u0435\u0448\u043D\u043E! \u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u044B \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 100\xa0\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u044F\u043C. \u0415\u0441\u043B\u0438 \u043D\u0435\xa0\u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u0439\u0442\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E, \u0441\u0443\u0437\u044C\u0442\u0435 \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u0438 \u043F\u043E\u0438\u0441\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432.","sv":"Klart Laddade ned de senaste 100 transaktionerna som matchar s\xf6kkriterierna. Om du inte kan hitta en transaktion, begr\xe4nsa s\xf6kresultatet med hj\xe4lp av s\xf6kfilter.","th":"\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08 \u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E01\u0E32\u0E23\u0E17\u0E33\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E15\u0E32\u0E21\u0E40\u0E01\u0E13\u0E11\u0E4C\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32 100 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14 \u0E2B\u0E32\u0E01\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23 \u0E42\u0E1B\u0E23\u0E14\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E1C\u0E25\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E43\u0E2B\u0E49\u0E41\u0E04\u0E1A\u0E25\u0E07\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E15\u0E31\u0E27\u0E01\u0E23\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32","tr":"Ba\u015Far\u0131l\u0131! Arama kriterine uyan en g\xfcncel 100 i\u015Flem indirildi. \u0130\u015Flem bulamad\u0131ysan l\xfctfen arama filtrelerini kullanarak arama sonucunu daralt. ","zh-Hans":"\u6210\u529F\uFF01 \u7B26\u5408\u641C\u7D22\u6761\u4EF6\u7684\u6700\u8FD1 100 \u7B14\u4EA4\u6613\u5DF2\u4E0B\u8F7D\u5B8C\u6BD5\u3002 \u5982\u679C\u65E0\u6CD5\u627E\u5230\u4EA4\u6613\uFF0C\u8BF7\u4F7F\u7528\u641C\u7D22\u7B5B\u9009\u6761\u4EF6\u7F29\u5C0F\u641C\u7D22\u7ED3\u679C\u7684\u8303\u56F4\u3002","zh-Hant":"\u6210\u529F\uFF01 \u5DF2\u4E0B\u8F09\u7B26\u5408\u641C\u5C0B\u689D\u4EF6\u7684\u6700\u8FD1 100 \u7B46\u4EA4\u6613\u3002 \u5982\u679C\u4F60\u627E\u4E0D\u5230\u4EA4\u6613\uFF0C\u8ACB\u4F7F\u7528\u7BE9\u9078\u689D\u4EF6\u4F86\u7E2E\u5C0F\u641C\u5C0B\u7BC4\u570D\u3002"},"RL_EJExportWarning":{"ar":"\u0633\u064A\u0624\u062F\u064A \u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0648\u0638\u064A\u0641\u0629 \u0627\u0644\u062A\u0635\u062F\u064A\u0631 \u0647\u0630\u0647 \u0625\u0644\u0649 \u062A\u0646\u0632\u064A\u0644 \u0623\u062D\u062F\u062B \u0661\u0660\u0660 \u0645\u0639\u0627\u0645\u0644\u0629 \u0641\u0642\u0637 \u0628\u0646\u0627\u0621\u064B \u0639\u0644\u0649 \u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629. \u064A\u0631\u062C\u0649 \u0627\u0644\u0636\u063A\u0637 \u0639\u0644\u0649 \\"\u0645\u062A\u0627\u0628\u0639\u0629\\" \u0644\u0627\u0633\u062A\u0643\u0645\u0627\u0644 \u0627\u0644\u0639\u0645\u0644\u064A\u0629 \u0623\u0648 \\"\u0625\u0644\u063A\u0627\u0621\\" \u0644\u062A\u062D\u0633\u064A\u0646 \u0645\u0639\u0627\u064A\u064A\u0631 \u0627\u0644\u0628\u062D\u062B \u0642\u0628\u0644 \u0627\u0644\u062A\u0646\u0632\u064A\u0644. \\n","ca":"Amb la funci\xf3 d\'exportaci\xf3 nom\xe9s es descarregaran les 100\xa0transaccions m\xe9s recents segons la data actual. Fes clic a Continua per seguir endavant o a Cancel\xb7la per justar els criteris de cerca abans de descarregar les transaccions. \\n","comment":"Warning Message to be displayed when user clicks the Export button on the EJ UI. ","cs":"Pou\u017Eit\xed t\xe9hle exportn\xed funkce jenom st\xe1hne posledn\xedch sto transakc\xed podle dat transakc\xed. Klikni na Proceed (Pokra\u010Dovat), jestli chce\u0161 pokra\u010Dovat, nebo na Cancel (Zru\u0161it), jestli chce\u0161 p\u0159ed sta\u017Een\xedm upravit krit\xe9ria hled\xe1n\xed. \\n","da":"Hvis du bruger denne eksportfunktion, downloader du kun de seneste 100 transaktioner baseret p\xe5 transaktionsdatoen. Klik p\xe5 Forts\xe6t for at forts\xe6tte eller Annuller for at justere dine s\xf8gekriterier, f\xf8r du downloader. \\n","de":"Diese Exportfunktion l\xe4dt nur die letzten 100 Transaktionen (basierend auf dem Transaktionsdatum) herunter. Klicke auf \\"Fortfahren\\", um weiterzumachen, oder auf \\"Abbrechen\\", um deine Suchkriterien vor dem Download zu verfeinern. \\n","el":"\u039C\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 \u03B5\u03BE\u03B1\u03B3\u03C9\u03B3\u03AE\u03C2 \u03B3\u03AF\u03BD\u03B5\u03C4\u03B1\u03B9 \u03BB\u03AE\u03C8\u03B7 \u03BC\u03CC\u03BD\u03BF \u03C4\u03C9\u03BD 100 \u03C0\u03B9\u03BF \u03C0\u03C1\u03CC\u03C3\u03C6\u03B1\u03C4\u03C9\u03BD \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD \u03BC\u03B5 \u03B2\u03AC\u03C3\u03B7 \u03C4\u03B7\u03BD \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2. \u0395\u03C0\u03B9\u03BB\u03AD\u03BE\u03C4\u03B5 \u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B5\u03C7\u03AF\u03C3\u03B5\u03C4\u03B5 \u03AE \u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C1\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B1 \u03BA\u03C1\u03B9\u03C4\u03AE\u03C1\u03B9\u03B1 \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2 \u03C0\u03C1\u03B9\u03BD \u03B1\u03C0\u03CC \u03C4\u03B7 \u03B4\u03B9\u03B1\u03B4\u03B9\u03BA\u03B1\u03C3\u03AF\u03B1 \u03BB\u03AE\u03C8\u03B7\u03C2. \\n","en":"Using this export function will only download the most recent 100 transactions based on the transaction date. Click on Proceed to continue or Cancel to refine your search criteria before downloading. \\n","en-GB":"Using this export function will only download the most recent 100 transactions based on the transaction date. Click on Proceed to continue or Cancel to refine your search criteria before downloading. \\n","en-XA":"[\xdb\u0161\xee\xf1\u011D\u2002\u0163\u0125\xee\u0161\u2002\xe9\u1E8B\xfe\xf6\u0155\u0163\u2002\u0192\xfb\xf1\xe7\u0163\xee\xf6\xf1\u2002\u0175\xee\u013C\u013C\u2002\xf6\xf1\u013C\xfd\u2002\xf0\xf6\u0175\xf1\u013C\xf6\xe5\xf0\u2002\u0163\u0125\xe9\u2002\u0271\xf6\u0161\u0163\u2002\u0155\xe9\xe7\xe9\xf1\u0163\u2002\u2460\u24EA\u24EA\u2002\u0163\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u0161\u2002\u0180\xe5\u0161\xe9\xf0\u2002\xf6\xf1\u2002\u0163\u0125\xe9\u2002\u0163\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\xf0\xe5\u0163\xe9\xb7\u2002\xc7\u013C\xee\xe7\u0137\u2002\xf6\xf1\u2002\xde\u0155\xf6\xe7\xe9\xe9\xf0\u2002\u0163\xf6\u2002\xe7\xf6\xf1\u0163\xee\xf1\xfb\xe9\u2002\xf6\u0155\u2002\xc7\xe5\xf1\xe7\xe9\u013C\u2002\u0163\xf6\u2002\u0155\xe9\u0192\xee\xf1\xe9\u2002\xfd\xf6\xfb\u0155\u2002\u0161\xe9\xe5\u0155\xe7\u0125\u2002\xe7\u0155\xee\u0163\xe9\u0155\xee\xe5\u2002\u0180\xe9\u0192\xf6\u0155\xe9\u2002\xf0\xf6\u0175\xf1\u013C\xf6\xe5\xf0\xee\xf1\u011D\xb7\u2002\\n\u2002\xe5\u0180\xe7\xf0\xe9\u0192\u011D\u0125\xee\u0135\u0137\u013C\u0271\xf1\xf6\xfe\u01EB\u0155\u0161\u0163\xfb\u1E7D\u0175\u1E8B\xfd\u017E\xc5\u0181\xc7\xd0\xc9\u0191\u011C\u0124\xce\u0134\u0136\u013B\u1E40\xd1\xd6\xde\u01EA\u0154\u0160\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Al usar esta funci\xf3n de exportar, solo se descargar\xe1n las 100 transacciones m\xe1s recientes seg\xfan la fecha de transacci\xf3n. Haz clic en Continuar para seguir o en Cancelar para ajustar tus criterios de b\xfasqueda antes de descargar. \\n","es-AR":"Al usar esta funci\xf3n de exportar, solo se descargar\xe1n las 100 transacciones m\xe1s recientes seg\xfan la fecha de transacci\xf3n. Hac\xe9 clic en Continuar o en Cancelar para ajustar los criterios de b\xfasqueda antes de seguir con la descarga. \\n","es-ES":"Al utilizar esta funci\xf3n de exportaci\xf3n, solo se descargar\xe1n las 100\xa0transacciones m\xe1s recientes en la fecha actual. Haz clic en Continuar o en Cancelar para ajustar los criterios de b\xfasqueda antes de seguir con la descarga. \\n","es-MX":"La funci\xf3n de exportar solo descarga las 100 transacciones m\xe1s recientes seg\xfan la fecha de transacci\xf3n. Haz clic en Continuar para proceder o Cancelar para modificar el criterio de b\xfasqueda antes de descargar. \\n","fr":"Avec cette fonction d\'exportation, il est possible de t\xe9l\xe9charger uniquement les 100\xa0transactions les plus r\xe9centes (selon la date de transaction). Cliquez sur Continuer pour poursuivre ou Annuler pour affiner vos crit\xe8res de recherche avant le t\xe9l\xe9chargement. \\n","hu":"Ez az export\xe1l\xe1si funkci\xf3 csak a legut\xf3bbi 100 tranzakci\xf3t t\xf6lti le a tranzakci\xf3 d\xe1tuma alapj\xe1n. A folytat\xe1shoz kattints a Tov\xe1bb gombra, vagy a M\xe9gse gombra kattintva pontos\xedthatod a keres\xe9si felt\xe9teleket a let\xf6lt\xe9s el\u0151tt. \\n","id":"Fungsi ekspor ini hanya akan mengunduh 100 transaksi terbaru dalam data transaksi. Klik Lanjutkan untuk melanjutkan, atau Batal untuk menyaring kriteria pencarian sebelum mengunduh. \\n","it":"Questa funzione di esportazione ti permetter\xe0 di scaricare solo le 100 transazioni pi\xf9 recenti, in base alla data di transazione. Clicca su Continua o Annulla per rifinire i tuoi criteri di ricerca prima di eseguire il download. \\n","ja":"\u3053\u306E\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3067\u304D\u308B\u306E\u306F\u3001\u53D6\u5F15\u306E\u65E5\u4ED8\u306B\u57FA\u3065\u3044\u305F\u76F4\u8FD1100\u4EF6\u306E\u53D6\u5F15\u306E\u307F\u3067\u3059\u3002 \u300C\u7D9A\u3051\u308B\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u7D9A\u884C\u3059\u308B\u304B\u3001\u300C\u30AD\u30E3\u30F3\u30BB\u30EB\u300D\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u524D\u306B\u691C\u7D22\u6761\u4EF6\u3092\u8ABF\u6574\u3057\u307E\u3059\u3002 \\n","key":"RL_EJExportWarning","ko":"\uC774 \uB0B4\uBCF4\uB0B4\uAE30 \uAE30\uB2A5\uC744 \uC0AC\uC6A9\uD558\uBA74 \uAC70\uB798 \uB0A0\uC9DC\uB97C \uAE30\uC900\uC73C\uB85C \uCD5C\uADFC 100\uAC74\uC758 \uAC70\uB798\uB9CC \uB2E4\uC6B4\uB85C\uB4DC\uB429\uB2C8\uB2E4. \'Proceed(\uC9C4\uD589)\'\uB97C \uD074\uB9AD\uD558\uC5EC \uACC4\uC18D \uC9C4\uD589\uD558\uAC70\uB098 \'Cancel(\uCDE8\uC18C)\'\uC744 \uD074\uB9AD\uD558\uC5EC \uB2E4\uC6B4\uB85C\uB4DC \uC804\uC5D0 \uAC80\uC0C9 \uAE30\uC900\uC744 \uC138\uBD84\uD654\uD558\uC138\uC694. \\n","nb":"Bruk av denne eksportfunksjonen laster bare ned de 100 nyeste transaksjonene basert p\xe5 transaksjonsdato. Klikk p\xe5 Fortsett for \xe5 g\xe5 videre eller Avbryt for \xe5 justere s\xf8kekriteriene f\xf8r du laster ned. \\n","nl":"Als je deze exportfunctie gebruikt, download je alleen de 100 meest recente transacties op basis van de transactiedatum. Klik op Verder om door te gaan of op Annuleer om je zoekcriteria te verfijnen voordat je gaat downloaden. \\n","pl":"Funkcja eksportowania pozwoli Ci na pobranie tylko 100 ostatnich transakcji (na podstawie daty transakcji). Kliknij \u201EKontynuuj\u201D, aby pobra\u0107 transakcje, lub \u201EAnuluj\u201D, aby najpierw zastosowa\u0107 bardziej szczeg\xf3\u0142owe kryteria wyszukiwania. \\n","pt-BR":"A utiliza\xe7\xe3o desta fun\xe7\xe3o de exporta\xe7\xe3o far\xe1 apenas o download das 100 transa\xe7\xf5es mais recentes com base na data da transa\xe7\xe3o. Clique em Continuar para prosseguir ou em Cancelar para especificar os crit\xe9rios de pesquisa antes de fazer o download. \\n","pt-PT":"A utiliza\xe7\xe3o desta fun\xe7\xe3o de exporta\xe7\xe3o apenas transfere as 100\xa0transa\xe7\xf5es mais recentes com base na data da transa\xe7\xe3o. Clique em Prosseguir para continuar ou Cancelar para refinar os crit\xe9rios de pesquisa antes de fazer a transfer\xeancia. \\n","ru":"\u0424\u0443\u043D\u043A\u0446\u0438\u044F \u044D\u043A\u0441\u043F\u043E\u0440\u0442\u0430 \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0435 100\xa0\u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u043F\u043E \u0434\u0430\u0442\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \xab\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C\xbb, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C, \u0438\u043B\u0438 \xab\u041E\u0442\u043C\u0435\u043D\u0430\xbb, \u0447\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043A\u0440\u0438\u0442\u0435\u0440\u0438\u0438 \u043F\u043E\u0438\u0441\u043A\u0430 \u043F\u0435\u0440\u0435\u0434 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u043E\u0439. \\n","sv":"Om du anv\xe4nder den h\xe4r exportfunktionen laddas endast de senaste 100 transaktionerna ned baserat p\xe5 transaktionsdatumet. Klicka p\xe5 Forts\xe4tt f\xf6r att forts\xe4tta eller Avbryt f\xf6r att f\xf6rfina dina s\xf6kkriterier innan du laddar ned. \\n","th":"\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1F\u0E31\u0E07\u0E01\u0E4C\u0E0A\u0E31\u0E19\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01\u0E19\u0E35\u0E49\u0E08\u0E30\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E01\u0E32\u0E23\u0E17\u0E33\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 100 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14\u0E42\u0E14\u0E22\u0E2D\u0E34\u0E07\u0E08\u0E32\u0E01\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E17\u0E33\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48 \\"\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D \\"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E23\u0E31\u0E1A\u0E40\u0E01\u0E13\u0E11\u0E4C\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E01\u0E48\u0E2D\u0E19\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14 \\n","tr":"Bu d\u0131\u015Fa aktarma i\u015Flevi, i\u015Flem tarihine ba\u011Fl\u0131 olarak yaln\u0131zca en g\xfcncel 100 i\u015Flemi indirecektir.  Devam etmek i\xe7in Devam Et \xf6\u011Fesine veya indirmeden \xf6nce arama kriterini iyile\u015Ftirmek i\xe7in \u0130ptal \xf6\u011Fesine t\u0131kla. \\n","zh-Hans":"\u4F7F\u7528\u6B64\u5BFC\u51FA\u529F\u80FD\u53EA\u4F1A\u6839\u636E\u4EA4\u6613\u65E5\u671F\u4E0B\u8F7D\u6700\u8FD1\u7684 100 \u7B14\u4EA4\u6613\u3002 \u70B9\u51FB\u201C\u7EE7\u7EED\u201D\u4EE5\u7EE7\u7EED\uFF0C\u6216\u70B9\u51FB\u201C\u53D6\u6D88\u201D\u4EE5\u4F18\u5316\u641C\u7D22\u6761\u4EF6\uFF0C\u7136\u540E\u518D\u4E0B\u8F7D\u3002 \\n","zh-Hant":"\u4F7F\u7528\u6B64\u532F\u51FA\u529F\u80FD\u53EA\u80FD\u4E0B\u8F09\u8DDD\u96E2\u4EA4\u6613\u65E5\u671F\u6700\u8FD1\u7684 100 \u7B46\u4EA4\u6613\u3002 \u6309\u4E00\u4E0B\u300C\u7E7C\u7E8C\u300D\u4EE5\u7E7C\u7E8C\uFF0C\u6216\u6309\u4E00\u4E0B\u300C\u53D6\u6D88\u300D\uFF0C\u91CD\u8A2D\u641C\u5C0B\u689D\u4EF6\u5F8C\u518D\u4E0B\u8F09\u3002 \\n"},"RL_ElectronicJournal":{"ar":"\u062F\u0641\u062A\u0631 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A","ca":"Registre electr\xf2nic","comment":"Electronic Journal to view the transaction and print receipt","cs":"Elektronick\xe9 noviny","da":"Elektronisk journal","de":"Elektronische Zeitschrift","el":"\u0397\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE \u03B5\u03C6\u03B7\u03BC\u03B5\u03C1\u03AF\u03B4\u03B1","en":"Electronic Journal","en-GB":"Electronic Journal","en-XA":"[\xc9\u013C\xe9\xe7\u0163\u0155\xf6\xf1\xee\xe7\u2002\u0134\xf6\xfb\u0155\xf1\xe5\u013C\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Publicaci\xf3n electr\xf3nica","es-AR":"Publicaci\xf3n electr\xf3nica","es-ES":"Publicaci\xf3n electr\xf3nica","es-MX":"Diario electr\xf3nico","fr":"Journal \xe9lectronique","hu":"Elektronikus nyilv\xe1ntart\xe1s","id":"Jurnal Elektronik","it":"Diario elettronico","ja":"\u96FB\u5B50\u30B8\u30E3\u30FC\u30CA\u30EB","key":"RL_ElectronicJournal","ko":"\uC804\uC790 \uC800\uB110","nb":"Elektronisk journal","nl":"Elektronisch kasboek","pl":"Dziennik elektroniczny","pt-BR":"Di\xe1rio eletr\xf4nico","pt-PT":"Registo eletr\xf3nico","ru":"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0436\u0443\u0440\u043D\u0430\u043B","sv":"Elektronisk journal","th":"\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2D\u0E34\u0E40\u0E25\u0E47\u0E01\u0E17\u0E23\u0E2D\u0E19\u0E34\u0E01\u0E2A\u0E4C","tr":"Elektronik G\xfcnl\xfck Dosyas\u0131","zh-Hans":"\u7535\u5B50\u65E5\u8BB0\u8D26","zh-Hant":"\u96FB\u5B50\u65E5\u8A8C"},"RL_Email":{"ca":"Correu electr\xf2nic","comment":"Email field for a user to be printed on the receipt","cs":"E-mail","da":"E-mail","de":"E-Mail","en":"Email","en-XA":"[\xc9\u0271\xe5\xee\u013C\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Correo electr\xf3nico","es-AR":"Correo electr\xf3nico","es-ES":"Correo electr\xf3nico","es-MX":"Correo electr\xf3nico","fr":"E-mail","hu":"E-mail","it":"E-mail","ja":"\u30E1\u30FC\u30EB","key":"RL_Email","ko":"\uC774\uBA54\uC77C","nb":"E-post","nl":"E-mailadres","pl":"E-mail","pt-PT":"E-mail","ru":"\u042D\u043B. \u043F\u043E\u0447\u0442\u0430","sv":"E-post","tr":"E-posta","zh-Hans":"\u7535\u5B50\u90AE\u4EF6","zh-Hant":"\u96FB\u5B50\u90F5\u4EF6"},"RL_EmpNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0645\u0648\u0638\u0641","ca":"N\xfamero Empleado","comment":"Employee number given for the employee discount transaction","cs":"C. zamestnance","da":"Medarb.nr.","de":"Mitarbeiternummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B5\u03C1\u03B3\u03B1\u03B6\u03BF\u03BC\u03AD\u03BD\u03BF\u03C5","en":"Employee Number","en-GB":"Employee Number","en-XA":"[\xc9\u0271\xfe\u013C\xf6\xfd\xe9\xe9\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de empleado","es-AR":"N\xfamero de empleado","es-ES":"N de Empleado","es-MX":"N\xfamero de empleado","fr":"No d\u2019employ\xe9","hu":"Employee Number","id":"Nomor Karyawan","it":"Numero dipendente","ja":"\u793E\u54E1\u756A\u53F7","key":"RL_EmpNumber","ko":"\uC9C1\uC6D0 \uBC88\uD638","nb":"Ansattnummer","nl":"Werknemernummer","pl":"Numer pracownika","pt-BR":"N\xfamero do funcion\xe1rio","pt-PT":"N\xfamero do funcion\xe1rio","ru":"\u041D\u043E\u043C\u0435\u0440 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430","sv":"Medarbetarnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19","tr":"\xc7al\u0131\u015Fan Numaras\u0131","zh-Hans":"\u5458\u5DE5\u7F16\u53F7","zh-Hant":"\u54E1\u5DE5\u7DE8\u865F"},"RL_EmployeeDiscount":{"ar":"\u062E\u0635\u0645 \u0644\u0644\u0645\u0648\u0638\u0641\u064A\u0646","ca":"Descompte per a empleats","comment":"Discounts given to the employees","cs":"Zam\u011Bstnaneck\xe1 sleva","da":"Medarbejderrabat","de":"Mitarbeiterrabatt","el":"\u0388\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7 \u03B3\u03B9\u03B1 \u03C4\u03BF\u03C5\u03C2 \u03B5\u03C1\u03B3\u03B1\u03B6\u03CC\u03BC\u03B5\u03BD\u03BF\u03C5\u03C2","en":"Employee Discount","en-GB":"Employee Discount","en-XA":"[\xc9\u0271\xfe\u013C\xf6\xfd\xe9\xe9\u2002\xd0\xee\u0161\xe7\xf6\xfb\xf1\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Descuento para empleados","es-AR":"Descuento para empleados","es-ES":"Descuento para empleados","es-MX":"Descuento de empleado","fr":"R\xe9duction pour employ\xe9","hu":"Alkalmazotti kedvezm\xe9ny","id":"Diskon Karyawan","it":"Sconto per i dipendenti","ja":"\u5F93\u696D\u54E1\u5272\u5F15","key":"RL_EmployeeDiscount","ko":"\uC9C1\uC6D0 \uD560\uC778","nb":"Ansattrabatt","nl":"Werknemerskorting","pl":"Zni\u017Cka pracownicza","pt-BR":"Desconto para funcion\xe1rios","pt-PT":"Desconto de funcion\xe1rio","ru":"\u0421\u043A\u0438\u0434\u043A\u0430 \u0434\u043B\u044F \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432","sv":"Personalrabatt","th":"\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19","tr":"\xc7al\u0131\u015Fan \u0130ndirimi","zh-Hans":"\u5458\u5DE5\u6298\u6263","zh-Hant":"\u54E1\u5DE5\u6298\u6263"},"RL_EmployeeID":{"ar":"\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u0645\u0648\u0638\u0651\u0641","ca":"ID de empleado","comment":"Employee ID","cs":"ID zam\u011Bstnance","da":"Medarbejder-id","de":"Employee ID","el":"\u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03B5\u03C1\u03B3\u03B1\u03B6\u03BF\u03BC\u03AD\u03BD\u03BF\u03C5","en":"Employee ID","en-GB":"Employee ID","en-XA":"[\xc9\u0271\xfe\u013C\xf6\xfd\xe9\xe9\u2002\xce\xd0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Id. de empleado","es-AR":"Id. de empleado","es-ES":"ID de empleado","es-MX":"Id. de empleado","fr":"ID employ\xe9","hu":"Employee ID","id":"ID Karyawan","it":"ID dipendente","ja":"\u793E\u54E1 ID","key":"RL_EmployeeID","ko":"\uC9C1\uC6D0 ID","nb":"Ansatt-ID","nl":"ID werknemer","pl":"ID pracownika","pt-BR":"ID do funcion\xe1rio","pt-PT":"ID de funcion\xe1rio","ru":"\u041D\u043E\u043C\u0435\u0440 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430","sv":"Medarbetar-ID","th":"ID \u0E1E\u0E19\u0E31\u0E01\u0E07\u0E32\u0E19","tr":"\xc7al\u0131\u015Fan Kimli\u011Fi","zh-Hans":"\u5458\u5DE5 ID","zh-Hant":"\u54E1\u5DE5 ID"},"RL_ExchangeInTender":{"ar":"\u062A\u0628\u0627\u062F\u0644 \u0636\u0645\u0646 \u0627\u0644\u0645\u0646\u0627\u0642\u0635\u0629","ca":"Pago en cambio","comment":"Exchange of multi tender transaction","cs":"V\xfdmena zaplacena","da":"Betalingsmiddeltransaktion - ind","de":"Zahlungsmittelwechsel Ein","el":"\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC \u03B5\u03B9\u03C3\u03B5\u03C1\u03C7\u03CC\u03BC\u03B5\u03BD\u03B7\u03C2 \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Exchange In Tender","en-GB":"Exchange In Tender","en-XA":"[\xc9\u1E8B\xe7\u0125\xe5\xf1\u011D\xe9\u2002\xce\xf1\u2002\u0162\xe9\xf1\xf0\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Medio de pago de cambio entrante","es-AR":"Cam. form. pago","es-ES":"Pago Cambio Entrante","es-MX":"Cambio de medio de pago entrante","fr":"Echange Mode paiement","hu":"Exchange In Tender","id":"Pertukaran dalam Tender","it":"Mezzo pag. in entrata sost","ja":"\u4EA4\u63DB\u30C6\u30F3\u30C0\u30FC\u30A4\u30F3","key":"RL_ExchangeInTender","ko":"\uAD50\uD658 \uC218\uB2E8 \uC218\uB839","nb":"Veksel inn betalingsmetode","nl":"Ruil In Betaling","pl":"Kurs w ofercie","pt-BR":"Troca de pagamento","pt-PT":"Troca de Modo Pag","ru":"\u0412\u043D\u0435\u0441\u0435\u043D\u0438\u0435 \u043F\u043B\u0430\u0442\u0435\u0436. \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043F\u0440\u0438 \u043E\u0431\u043C\u0435\u043D\u0435","sv":"Utv\xe4xling betmed","th":"\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E43\u0E19\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19","tr":"\u0130\xe7e De\u011Fi\u015Fim Kasa \u0130\u015Flemi","zh-Hans":"\u6362\u5165\u652F\u4ED8\u65B9\u5F0F","zh-Hant":"\u652F\u4ED8\u65B9\u5F0F\u4EA4\u63DB"},"RL_ExchangeOutTender":{"ar":"\u062A\u0628\u0627\u062F\u0644 \u062E\u0627\u0631\u062C \u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0646\u0627\u0642\u0635\u0629","ca":"Pago Cambio Saliente","comment":"Exchnage out given in multi tender","cs":"V\xfdmena vyplacena","da":"Betalingsmiddeltransaktion - ud","de":"Zahlungsmittelwechsel Aus","el":"\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC \u03B5\u03BE\u03B5\u03C1\u03C7\u03CC\u03BC\u03B5\u03BD\u03B7\u03C2 \u03B1\u03BD\u03C4\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Exchange Out Tender","en-GB":"Exchange Out Tender","en-XA":"[\xc9\u1E8B\xe7\u0125\xe5\xf1\u011D\xe9\u2002\xd6\xfb\u0163\u2002\u0162\xe9\xf1\xf0\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cambio de medio de pago saliente","es-AR":"Camb. oferta sali","es-ES":"Pago Cambio Saliente","es-MX":"Cambio de medio de pago saliente","fr":"Mode de paiement pour d\xe9caissement","hu":"Exchange Out Tender","id":"Pertukaran di Luar Tender","it":"Mezzo pag. in uscita sost","ja":"\u4EA4\u63DB\u30C6\u30F3\u30C0\u30FC\u30A2\u30A6\u30C8","key":"RL_ExchangeOutTender","ko":"\uAD50\uD658 \uC218\uB2E8 \uC9C0\uAE09","nb":"Veksel ut betalingsmetode","nl":"Ruil uit Betaling","pl":"Wymiana \u015Brodk\xf3w p\u0142atniczych na zewn\u0105trz","pt-BR":"Troca de pagamento","pt-PT":"Modo Pagamento trocado","ru":"\u0412\u044B\u043F\u043B\u0430\u0442\u0430 \u043F\u043B\u0430\u0442\u0435\u0436. \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043F\u0440\u0438 \u043E\u0431\u043C\u0435\u043D\u0435","sv":"Inv\xe4xling betmed","th":"\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E19\u0E2D\u0E01\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19","tr":"D\u0131\u015Fa De\u011Fi\u015Fim Kasa \u0130\u015Flemi","zh-Hans":"\u6362\u51FA\u652F\u4ED8\u65B9\u5F0F","zh-Hant":"\u652F\u4ED8\u65B9\u5F0F\u4EA4\u63DB"},"RL_ExchangeRate":{"ar":"\u0633\u0639\u0631 \u0627\u0644\u0635\u0631\u0641","ca":"Taxa de canvi","comment":"To display foreign currency exchange rate on the receipts. ","cs":"Sm\u011Bnn\xfd kurz","da":"Ombytningsrate","de":"Wechselkurs","el":"\u0399\u03C3\u03BF\u03C4\u03B9\u03BC\u03AF\u03B1 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03AC\u03B3\u03BC\u03B1\u03C4\u03BF\u03C2","en":"Exchange Rate","en-GB":"Exchange rate","en-XA":"[\xc9\u1E8B\xe7\u0125\xe5\xf1\u011D\xe9\u2002\u0154\xe5\u0163\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tasa de cambio","es-AR":"Tasa de cambio","es-ES":"Tasa de cambio","es-MX":"Tasa de cambio","fr":"Taux de change","hu":"\xc1rfolyam","id":"Nilai Tukar","it":"Tasso di cambio","ja":"\u70BA\u66FF\u30EC\u30FC\u30C8","key":"RL_ExchangeRate","ko":"\uD658\uC728","nb":"Vekslingskurs","nl":"Wisselkoers","pl":"Kurs wymiany walutowej","pt-BR":"Taxa de c\xe2mbio","pt-PT":"Taxa de c\xe2mbio","ru":"\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0435\u043D\u0430","sv":"V\xe4xlingskurs","th":"\u0E2D\u0E31\u0E15\u0E23\u0E32\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19","tr":"D\xf6viz Kuru","zh-Hans":"\u6C47\u7387","zh-Hant":"\u532F\u7387"},"RL_Export":{"ar":"\u062A\u0635\u062F\u064A\u0631","ca":"Exporta","comment":"Export the search results from Electronic Journal","cs":"Exportovat","da":"Eksport\xe9r","de":"Exportieren","el":"\u0395\u03BE\u03B1\u03B3\u03C9\u03B3\u03AE","en":"Export","en-GB":"Export","en-XA":"[\xc9\u1E8B\xfe\xf6\u0155\u0163\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Exportar","es-AR":"Exportar","es-ES":"Exportar","es-MX":"Exportar","fr":"Exporter","hu":"Export\xe1l\xe1s","id":"Ekspor","it":"Esporta","ja":"\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8","key":"RL_Export","ko":"\uB0B4\uBCF4\uB0B4\uAE30","nb":"Eksporter","nl":"Exporteer","pl":"Eksportuj","pt-BR":"Exportar","pt-PT":"Exportar","ru":"\u042D\u043A\u0441\u043F\u043E\u0440\u0442","sv":"Exportera","th":"\u0E2A\u0E48\u0E07\u0E2D\u0E2D\u0E01","tr":"D\u0131\u015Fa Aktar","zh-Hans":"\u5BFC\u51FA","zh-Hant":"\u532F\u51FA"},"RL_FinalPrice":{"ar":"\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0646\u0647\u0627\u0626\u064A","ca":"Precio Final","comment":"Final price of the item after group or package  discount","cs":"Konecn\xe1 cena","da":"Slutpris","de":"Final Price","el":"\u03A4\u03B5\u03BB\u03B9\u03BA\u03AE \u03C4\u03B9\u03BC\u03AE","en":"Final Price","en-GB":"Final Price","en-XA":"[\u0191\xee\xf1\xe5\u013C\u2002\xde\u0155\xee\xe7\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Precio final","es-AR":"Precio final","es-ES":"Precio Final","es-MX":"Precio final","fr":"Prix final","hu":"Final Price","id":"Harga Akhir","it":"Prezzo finale","ja":"\u6700\u7D42\u4FA1\u683C","key":"RL_FinalPrice","ko":"\uAE08\uC561","nb":"Endelig pris","nl":"Uiteindelijke Prijs","pl":"Cena ko\u0144cowa","pt-BR":"Pre\xe7o final","pt-PT":"Pre\xe7o final","ru":"\u041E\u043A\u043E\u043D\u0447\u0430\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0446\u0435\u043D\u0430","sv":"Slutligt pris","th":"\u0E23\u0E32\u0E04\u0E32\u0E2A\u0E38\u0E14\u0E17\u0E49\u0E32\u0E22","tr":"Son Fiyat","zh-Hans":"\u6700\u7EC8\u4EF7\u683C","zh-Hant":"\u6700\u7D42\u50F9\u683C"},"RL_FiscalSequenceNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u0644\u0633\u0644 \u0627\u0644\u0645\u0627\u0644\u064A ","ca":"N\xfamero de seq\xfc\xe8ncia fiscal ","comment":"Fiscal Sequence Number printed on the receipts of EMEA fiscal countries. ","cs":"\u010C\xedslo fisk\xe1ln\xed sekvence ","da":"Regnskabssekvensnummer: ","de":"Laufende Steuernummer ","el":"\u03A3\u0395\u0399\u03A1\u0391 \u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397\u03A3 \u039B\u0399\u0391\u039D\u0399\u039A\u0397\u03A3","en":"Fiscal Sequence Number ","en-GB":"Fiscal sequence number ","en-XA":"[\u0191\xee\u0161\xe7\xe5\u013C\u2002\u0160\xe9\u01EB\xfb\xe9\xf1\xe7\xe9\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de secuencia fiscal ","es-AR":"N\xfamero de secuencia fiscal ","es-ES":"N\xfamero de secuencia fiscal ","es-MX":"Registro fiscal de contribuyentes ","fr":"Num\xe9ro de s\xe9quence fiscale ","hu":"Fisk\xe1lis sorsz\xe1m ","id":"Nomor Urutan Fiskal ","it":"Numero progressivo scontrino ","ja":"\u4F1A\u8A08\u30B7\u30FC\u30B1\u30F3\u30B9\u756A\u53F7 ","key":"RL_FiscalSequenceNumber","ko":"\uD68C\uACC4 \uC2DC\uD000\uC2A4 \uBC88\uD638 ","nb":"Skattemessig sekvensnummer ","nl":"Fiscaal volgnummer ","pl":"Numer sekwencyjny paragonu fiskalnego ","pt-BR":"N\xfamero de sequ\xeancia fiscal ","pt-PT":"N\xfamero de sequ\xeancia fiscal ","ru":"\u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 ","sv":"Sekvensnummer f\xf6r r\xe4kenskaps\xe5r ","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E25\u0E4D\u0E32\u0E14\u0E31\u0E1A\u0E40\u0E2D\u0E01\u0E2A\u0E32\u0E23\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19 ","tr":"Mali S\u0131ra Numaras\u0131 ","zh-Hans":"\u8D22\u52A1\u5E8F\u5217\u53F7 ","zh-Hant":"\u8CA1\u653F\u5E8F\u865F "},"RL_FiscalSoftwareName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u0645\u0627\u0644\u064A","ca":"Nom del programari fiscal","comment":"Name of the EFSTA vendor software used in fiscal countries like France ","cs":"N\xe1zev fisk\xe1ln\xedho softwaru","da":"Regnskabssoftwares navn","de":"Steuersoftwarenummer","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C6\u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B9\u03C3\u03BC\u03B9\u03BA\u03BF\u03CD","en":"Fiscal Software Name","en-GB":"Fiscal software name","en-XA":"[\u0191\xee\u0161\xe7\xe5\u013C\u2002\u0160\xf6\u0192\u0163\u0175\xe5\u0155\xe9\u2002\xd1\xe5\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre del software fiscal","es-AR":"Nombre del software fiscal","es-ES":"Nombre del software fiscal","es-MX":"Nombre del software fiscal","fr":"Nom du logiciel fiscal","hu":"Fisk\xe1lis szoftver neve","id":"Nama Perangkat Lunak Fiskal","it":"Nome software fiscale","ja":"\u4F1A\u8A08\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u540D","key":"RL_FiscalSoftwareName","ko":"\uD68C\uACC4 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uC774\uB984","nb":"Navn p\xe5 regnskapsprogram","nl":"Nummer fiscale software","pl":"Nazwa oprogramowania fiskalnego","pt-BR":"Nome do software fiscal","pt-PT":"Nome do software fiscal","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F","sv":"Programvarans namn f\xf6r r\xe4kenskaps\xe5r","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19","tr":"Mali Yaz\u0131l\u0131m Ad\u0131","zh-Hans":"\u8D22\u52A1\u8F6F\u4EF6\u540D\u79F0","zh-Hant":"\u8CA1\u653F\u8EDF\u9AD4\u540D\u7A31"},"RL_FiscalSoftwareVersion":{"ar":"\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C \u0627\u0644\u0645\u0627\u0644\u064A","ca":"Versi\xf3 del programari fiscal","comment":"Version of the EFSTA vendors fiscal software used in France","cs":"Verze fisk\xe1ln\xedho softwaru","da":"Regnskabssoftwares version","de":"Steuersoftwareversion","el":"\u0388\u03BA\u03B4\u03BF\u03C3\u03B7 \u03C6\u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03BF\u03CD \u03BB\u03BF\u03B3\u03B9\u03C3\u03BC\u03B9\u03BA\u03BF\u03CD","en":"Fiscal Software Version","en-GB":"Fiscal software version","en-XA":"[\u0191\xee\u0161\xe7\xe5\u013C\u2002\u0160\xf6\u0192\u0163\u0175\xe5\u0155\xe9\u2002\u1E7C\xe9\u0155\u0161\xee\xf6\xf1\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Versi\xf3n del software fiscal","es-AR":"Versi\xf3n del software fiscal","es-ES":"Versi\xf3n del software fiscal","es-MX":"Versi\xf3n del software fiscal","fr":"Version du logiciel fiscal","hu":"Fisk\xe1lis szoftver verzi\xf3ja","id":"Versi Perangkat Lunak Fiskal","it":"Versione software fiscale","ja":"\u4F1A\u8A08\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u30D0\u30FC\u30B8\u30E7\u30F3","key":"RL_FiscalSoftwareVersion","ko":"\uD68C\uACC4 \uC18C\uD504\uD2B8\uC6E8\uC5B4 \uBC84\uC804","nb":"Versjon av regnskapsprogram","nl":"Versie fiscale software","pl":"Wersja oprogramowania fiskalnego","pt-BR":"Vers\xe3o do software fiscal","pt-PT":"Vers\xe3o do software fiscal","ru":"\u0412\u0435\u0440\u0441\u0438\u044F \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F","sv":"Programvaruversion f\xf6r r\xe4kenskaps\xe5r","th":"\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E19\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19","tr":"Mali Yaz\u0131l\u0131m S\xfcr\xfcm\xfc","zh-Hans":"\u8D22\u52A1\u8F6F\u4EF6\u7248\u672C","zh-Hant":"\u8CA1\u653F\u8EDF\u9AD4\u7248\u672C"},"RL_GCBalance":{"ar":"\u0631\u0635\u064A\u062F \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627","ca":"Saldo Vale Regalo","comment":"Balance of the gift card","cs":"Zustatek D\xe1rk.karty","da":"Gavekortsaldo","de":"Verbleibendes Geschenkgutschein-Guthaben","el":"\u03A5\u03C0\u03CC\u03BB\u03BF\u03B9\u03C0\u03BF \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1\u03C2","en":"Gift Card Balance","en-GB":"Gift Card Balance","en-XA":"[\u011C\xee\u0192\u0163\u2002\xc7\xe5\u0155\xf0\u2002\u0181\xe5\u013C\xe5\xf1\xe7\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Saldo de Gift Card","es-AR":"Saldo de Gift Card","es-ES":"Saldo Vale Regalo","es-MX":"Saldo de la Tarjeta de regalo","fr":"Solde carte cadeau","hu":"Gift Card Balance","id":"Saldo Kartu Hadiah","it":"Saldo Gift Card","ja":"\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u6B8B\u9AD8","key":"RL_GCBalance","ko":"\uAE30\uD504\uD2B8 \uCE74\uB4DC \uC794\uC561","nb":"Saldo p\xe5 gavekortet","nl":"Saldo cadeaubon","pl":"Saldo na karcie upominkowej","pt-BR":"Saldo do cart\xe3o-presente","pt-PT":"Saldo do cart\xe3o de oferta","ru":"\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B","sv":"Presentkortssaldo","th":"\u0E22\u0E2D\u0E14\u0E04\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E43\u0E19\u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"Hediye Kart\u0131 Bakiyesi","zh-Hans":"\u793C\u54C1\u5361\u4F59\u989D","zh-Hant":"\u79AE\u54C1\u5361\u9918\u984D"},"RL_GCNumber":{"ar":"\u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627","ca":"N\xfamero TR","comment":"Gift card number in receipt","cs":"GC c\xedslo","da":"GC nummer","de":"GC Nummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 GC","en":"GC Number","en-GB":"GC Number","en-XA":"[\u011C\xc7\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de GC","es-AR":"N\xfamero de GC","es-ES":"N\xfamero TR","es-MX":"N\xfamero de GC","fr":"NoCC","hu":"GC Number","id":"Nomor GC","it":"Numero GC","ja":"\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u756A\u53F7","key":"RL_GCNumber","ko":"GC \uBC88\uD638","nb":"GC-nummer","nl":"CB-nummer","pl":"Numer KU","pt-BR":"N\xfamero do GC","pt-PT":"N\xfamero do CO","ru":"\u041D\u043E\u043C\u0435\u0440 GC","sv":"Presentkortsnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"GC Numaras\u0131","zh-Hans":"\u793C\u54C1\u5361\u7F16\u53F7","zh-Hant":"\u79AE\u54C1\u5361\u7DE8\u865F"},"RL_GIFTITEMRECEIPT":{"ar":"\u0625\u064A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0646\u062A\u062C \u0627\u0644\u0647\u062F\u064A\u0629","ca":"RECIBO ART\xcdC. REGALO","comment":"Header of the receipt indicates the recipt of Gift Item","cs":"DARK. POL.-UCET","da":"GAVEVARE KVITTERING","de":"GESCHENKARTIKEL-QUITTUNG","el":"\u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397 \u0395\u0399\u0394\u039F\u03A5\u03A3 \u0394\u03A9\u03A1\u039F\u03A5","en":"GIFT ITEM RECEIPT","en-GB":"GIFT ITEM RECEIPT","en-XA":"[\u011C\xce\u0191\u0162\u2002\xce\u0162\xc9\u1E40\u2002\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"RECIBO DE ART\xcdCULO DE REGALO","es-AR":"RECIBO DE ART\xcdCULO DE REGALO","es-ES":"RECIBO ART\xcdC. REGALO","es-MX":"RECIBO DE ART\xcdCULO DE REGALO","fr":"RE\xc7U ARTICLE CADEAU","hu":"GIFT ITEM RECEIPT","id":"TANDA TERIMA ITEM HADIAH","it":"RICEVUTA ARTICOLO REGALO","ja":"\u30AE\u30D5\u30C8\u5546\u54C1\u30EC\u30B7\u30FC\u30C8","key":"RL_GIFTITEMRECEIPT","ko":"\uAE30\uD504\uD2B8 \uD488\uBAA9 \uC601\uC218\uC99D","nb":"KVITTERING FOR GAVEARTIKKEL","nl":"BON VOOR GESCHENKARTIKEL","pl":"RACHUNEK PODARUNKOWY","pt-BR":"RECIBO DO ITEM DE PRESENTE","pt-PT":"RECIBO ARTIGO OFERTA","ru":"GIFT ITEM RECEIPT","sv":"PRESENTARTIKEL, KVITTO","th":"\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"HED\u0130YE \xdcR\xdcN MAKBUZU","zh-Hans":"\u793C\u54C1\u5546\u54C1\u6536\u636E","zh-Hant":"\u79AE\u54C1\u5546\u54C1\u6536\u64DA"},"RL_General":{"ar":"\u0639\u0627\u0645","ca":"General","comment":"General information ","cs":"Obecn\xe9","da":"Generel","de":"Allgemein","el":"\u0393\u03B5\u03BD\u03B9\u03BA\u03AC","en":"General","en-GB":"General","en-XA":"[\u011C\xe9\xf1\xe9\u0155\xe5\u013C\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"General","es-AR":"General","es-ES":"General","es-MX":"General","fr":"G\xe9n\xe9ral","hu":"\xc1ltal\xe1nos","id":"Umum","it":"Generale","ja":"\u4E00\u822C\u60C5\u5831","key":"RL_General","ko":"\uC77C\uBC18","nb":"Generell","nl":"Algemeen","pl":"Og\xf3lne","pt-BR":"Disposi\xe7\xf5es gerais","pt-PT":"Geral","ru":"\u041E\u0431\u0449\u0438\u0435","sv":"Allm\xe4nt","th":"\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B","tr":"Genel","zh-Hans":"\u4E00\u822C\u4FE1\u606F","zh-Hant":"\u4E00\u822C"},"RL_GeneralDiscount":{"ar":"\u062E\u0635\u0645 \u0639\u0627\u0645","ca":"Descompte general","comment":"The general discounts given to the customers. ","cs":"V\u0161eobecn\xe1 sleva","da":"Generel rabat","de":"Allgemeiner Rabatt","el":"\u03A4\u03C5\u03C0\u03B9\u03BA\u03AE \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7 \u03C0\u03B5\u03BB\u03B1\u03C4\u03CE\u03BD","en":"General Discount","en-GB":"General Discount","en-XA":"[\u011C\xe9\xf1\xe9\u0155\xe5\u013C\u2002\xd0\xee\u0161\xe7\xf6\xfb\xf1\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Descuento general","es-AR":"Descuento general","es-ES":"Descuento general","es-MX":"Descuento general","fr":"R\xe9duction g\xe9n\xe9rale","hu":"\xc1ltal\xe1nos kedvezm\xe9ny","id":"Diskon Umum","it":"Sconto generale","ja":"\u4E00\u822C\u5272\u5F15","key":"RL_GeneralDiscount","ko":"\uC77C\uBC18 \uD560\uC778","nb":"Generell rabatt","nl":"Algemene korting","pl":"Og\xf3lny rabat","pt-BR":"Desconto geral","pt-PT":"Desconto geral","ru":"\u041E\u0431\u0449\u0430\u044F \u0441\u043A\u0438\u0434\u043A\u0430","sv":"Allm\xe4n rabatt","th":"\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E17\u0E31\u0E48\u0E27\u0E44\u0E1B","tr":"Genel \u0130ndirim","zh-Hans":"\u666E\u901A\u6298\u6263","zh-Hant":"\u4E00\u822C\u6298\u6263"},"RL_GeneralManagerName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u0645\u062F\u064A\u0631 \u0627\u0644\u0639\u0627\u0645 ","ca":"Nom del responsable general","comment":"The Manager name of the store or territory. ","cs":"Jm\xe9no gener\xe1ln\xedho \u0159editele","da":"Daglige leders navn","de":"Name des General Manager ","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03B3\u03B5\u03BD\u03B9\u03BA\u03BF\u03CD \u03B4\u03B9\u03B5\u03C5\u03B8\u03C5\u03BD\u03C4\u03AE ","en":"General Manager Name ","en-GB":"General Manager Name ","en-XA":"[\u011C\xe9\xf1\xe9\u0155\xe5\u013C\u2002\u1E40\xe5\xf1\xe5\u011D\xe9\u0155\u2002\xd1\xe5\u0271\xe9\u2002\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre del gerente general","es-AR":"Nombre del gerente general","es-ES":"Nombre del manager o la manager general","es-MX":"Nombre del gerente general","fr":"Nom du directeur g\xe9n\xe9ral","hu":"\xdczlet- vagy r\xe9gi\xf3vezet\u0151 neve","id":"Nama General Manager","it":"Nome General Manager ","ja":"\u30BC\u30CD\u30E9\u30EB \u30DE\u30CD\u30FC\u30B8\u30E3\u30FC\u306E\u6C0F\u540D","key":"RL_GeneralManagerName","ko":"\uB300\uD45C","nb":"Navn p\xe5 daglig leder ","nl":"Naam van algemeen manager","pl":"Imi\u0119 i nazwisko g\u0142\xf3wnego kierownika","pt-BR":"Nome do Gerente geral","pt-PT":"Nome do gerente geral","ru":"\u0418\u043C\u044F \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u0430","sv":"Verkst\xe4llande direkt\xf6r ","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E02\u0E2D\u0E07 General Manager","tr":"Genel Y\xf6netici Ad\u0131","zh-Hans":"\u603B\u7ECF\u7406\u59D3\u540D","zh-Hant":"\u7E3D\u7D93\u7406\u59D3\u540D"},"RL_GiftCardNo":{"ar":"\u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627","ca":"N\xfamero de targeta de regal","comment":"Identifier that proceeds the gift card\'s number","cs":"D\xe1rkov\xe1 karta \u010D.","da":"Gavekortnummer","de":"Geschenkgutschein-Nr.","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1\u03C2","en":"Gift Card No","en-GB":"Gift Card No","en-XA":"[\u011C\xee\u0192\u0163\u2002\xc7\xe5\u0155\xf0\u2002\xd1\xf6\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Identificador de la tarjeta de regalo","es-AR":"N.\xba de la tarjeta de regalo","es-ES":"N.\xba de la tarjeta de regalo","es-MX":"N\xfamero de tarjeta de regalo","fr":"N\xb0 de carte cadeau","hu":"Aj\xe1nd\xe9kutalv\xe1ny sz\xe1ma","id":"No. Kartu Hadiah","it":"N. gift card","ja":"\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u756A\u53F7","key":"RL_GiftCardNo","ko":"\uAE30\uD504\uD2B8 \uCE74\uB4DC \uBC88\uD638","nb":"Gavekortnummer","nl":"GC Nummer","pl":"Nr karty upominkowej","pt-BR":"N\xb0 do cart\xe3o-presente","pt-PT":"N.\xba do cart\xe3o de oferta","ru":"\u041D\u043E\u043C\u0435\u0440 \u043F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u044B","sv":"Presentkortsnr.","th":"\u0E40\u0E25\u0E02\u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"Hediye Kart\u0131 Numaras\u0131","zh-Hans":"\u793C\u54C1\u5361\u7F16\u53F7","zh-Hant":"\u79AE\u54C1\u5361\u7DE8\u865F"},"RL_GiftCardRedeemed":{"ar":"\u062A\u0645 \u0627\u0633\u062A\u0631\u062F\u0627\u062F \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062F\u0627\u064A\u0627","ca":"S\'ha bescanviat la targeta de regal","comment":"Phrase that indicates a gift card was redeemed","cs":"Uplatn\u011Bn\xe1 d\xe1rkov\xe1 karta","da":"Indl\xf8st gavekort","de":"Geschenkgutschein eingel\xf6st","el":"\u0395\u03BE\u03B1\u03C1\u03B3\u03CD\u03C1\u03C9\u03C3\u03B7 \u03B4\u03C9\u03C1\u03BF\u03BA\u03AC\u03C1\u03C4\u03B1\u03C2","en":"Gift Card Redeemed","en-GB":"Gift Card Redeemed","en-XA":"[\u011C\xee\u0192\u0163\u2002\xc7\xe5\u0155\xf0\u2002\u0154\xe9\xf0\xe9\xe9\u0271\xe9\xf0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tarjeta de regalo canjeada","es-AR":"Tarjeta de regalo canjeada","es-ES":"Tarjeta de regalo canjeada","es-MX":"Tarjeta de regalo canjeada","fr":"Carte cadeau utilis\xe9e","hu":"Aj\xe1nd\xe9kutalv\xe1ny bev\xe1ltva","id":"Kartu Hadiah Ditukarkan","it":"Gift card utilizzata","ja":"\u30AE\u30D5\u30C8\u30AB\u30FC\u30C9\u5229\u7528","key":"RL_GiftCardRedeemed","ko":"\uAE30\uD504\uD2B8 \uCE74\uB4DC \uAD50\uD658","nb":"Gavekortet er l\xf8st inn","nl":"Cadeaubon gebruikt","pl":"Wykorzystana karta upominkowa","pt-BR":"Vale-presente resgatado","pt-PT":"Cart\xe3o de oferta resgatado","ru":"\u041F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0430","sv":"Presentkort inl\xf6st","th":"\u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D\u0E17\u0E35\u0E48\u0E41\u0E25\u0E01\u0E43\u0E0A\u0E49","tr":"Hediye Kart\u0131 Kullan\u0131ld\u0131","zh-Hans":"\u793C\u54C1\u5361\u5DF2\u5151\u6362","zh-Hant":"\u79AE\u54C1\u5361\u514C\u63DB"},"RL_GiftCertificate":{"ar":"\u0634\u0647\u0627\u062F\u0629 \u0625\u0647\u062F\u0627\u0621","ca":"Cheque regalo","comment":"Gift Certificate","cs":"D\xe1rkov\xfd certifik\xe1t","da":"Gavebevis ","de":"Geschenkgutschein","el":"\u0394\u03C9\u03C1\u03BF\u03B5\u03C0\u03B9\u03C4\u03B1\u03B3\u03AE","en":"Gift Certificate","en-GB":"Gift Certificate","en-XA":"[\u011C\xee\u0192\u0163\u2002\xc7\xe9\u0155\u0163\xee\u0192\xee\xe7\xe5\u0163\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Vale de regalo","es-AR":"Vale de regalo","es-ES":"Cheque regalo","es-MX":"Vale de regalo","fr":"Ch\xe8que cadeau","hu":"Gift Certificate","id":"Sertifikat Hadiah","it":"Buono prepagato","ja":"\u5546\u54C1\u5238","key":"RL_GiftCertificate","ko":"\uC0C1\uD488\uAD8C","nb":"Gavekort","nl":"Cadeaubon","pl":"Karta upominkowa","pt-BR":"Certificado de presente","pt-PT":"Certificado de Oferta","ru":"\u041F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u044B\u0439 \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442","sv":"Presentkort","th":"\u0E1A\u0E31\u0E15\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"Hediye \xc7eki","zh-Hans":"\u793C\u54C1\u5238","zh-Hant":"\u79AE\u5238"},"RL_GiftItem":{"ar":"\u0645\u0646\u062A\u062C \u0647\u062F\u064A\u0629","ca":"Art\xedculo de Regalo","comment":"Line in receipt indicate the item is a gift item","cs":"D\xe1rkov\xe1 pol.","da":"Gavevare","de":"Geschenkartikel","el":"\u0395\u03AF\u03B4\u03BF\u03C2 \u03B4\u03CE\u03C1\u03BF\u03C5","en":"Gift Item","en-GB":"Gift Item","en-XA":"[\u011C\xee\u0192\u0163\u2002\xce\u0163\xe9\u0271\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Art\xedculo de regalo","es-AR":"Art\xedculo de regalo","es-ES":"Art\xedculo de Regalo ","es-MX":"Art\xedculo de regalo","fr":"Cadeau","hu":"Gift Item","id":"Item Hadiah","it":"Articolo regalo","ja":"Gift Item","key":"RL_GiftItem","ko":"\uAE30\uD504\uD2B8 \uC544\uC774\uD15C","nb":"Gaveartikkel","nl":"Cadeau","pl":"Upominek","pt-BR":"Item de presente","pt-PT":"Artigo de oferta","ru":"\u041F\u043E\u0434\u0430\u0440\u043E\u0447\u043D\u044B\u0439 \u0442\u043E\u0432\u0430\u0440","sv":"Presentprodukt","th":"\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E02\u0E2D\u0E07\u0E02\u0E27\u0E31\u0E0D","tr":"Hediye \xdcr\xfcn","zh-Hans":"\u793C\u54C1","zh-Hant":"\u79AE\u54C1"},"RL_Hashalgorithms":{"ar":"\u062E\u0648\u0627\u0631\u0632\u0645\u064A\u0627\u062A \u0627\u0644\u062A\u062C\u0632\u0626\u0629","ca":"Algoritmes de hash","comment":"Hashalogrithm - TSE fiskaly data on the Germany receipts","cs":"Hashalgorithms","da":"Hashalgoritmer","de":"Hash-Algorithmen","el":"\u0391\u03BB\u03B3\u03CC\u03C1\u03B9\u03B8\u03BC\u03BF\u03B9 \u03BA\u03B1\u03C4\u03B1\u03BA\u03B5\u03C1\u03BC\u03B1\u03C4\u03B9\u03C3\u03BC\u03BF\u03CD","en":"Hashalgorithms","en-GB":"Hashalgorithms","en-XA":"[\u0124\xe5\u0161\u0125\xe5\u013C\u011D\xf6\u0155\xee\u0163\u0125\u0271\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Algoritmos hash","es-AR":"Algoritmos hash","es-ES":"Algoritmos hash","es-MX":"Hashalgorithms","fr":"Hashalgorithms","hu":"Kivonatol\xe1si algoritmus","id":"Hashalgorithms","it":"Hashalgorithms","ja":"HashAlgorithms","key":"RL_Hashalgorithms","ko":"\uD574\uC2DC \uC54C\uACE0\uB9AC\uC998","nb":"Hash-algoritmer","nl":"Hash-algoritmes","pl":"Algorytmy hashuj\u0105ce","pt-BR":"Hashalgorithms","pt-PT":"Algoritmos de dispers\xe3o","ru":"\u0425\u0435\u0448-\u0430\u043B\u0433\u043E\u0440\u0438\u0442\u043C\u044B","sv":"Hashalgoritmer","th":"Hashalgorithms","tr":"Kar\u0131\u015F\u0131k \xfcr\xfcn algoritmalar\u0131","zh-Hans":"Hash \u7B97\u6CD5","zh-Hant":"\u96DC\u6E4A\u6F14\u7B97"},"RL_INVALIDRECEIPT":{"ar":"\u0625\u064A\u0635\u0627\u0644 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D","ca":"Tiquet no v\xe1lido","comment":"Invalid Receipt Indicator while in training mode","cs":"NEPLATN\xdd DOKLAD","da":"UGYLDIG KVITTERING","de":"Ung\xfcltig","el":"\u039C\u0397 \u0395\u0393\u039A\u03A5\u03A1\u0397 \u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397","en":"INVALID RECEIPT","en-GB":"INVALID RECEIPT","en-XA":"[\xce\xd1\u1E7C\xc5\u013B\xce\xd0\u2002\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"RECIBO NO V\xc1LIDO","es-AR":"RECIBO NO V\xc1LIDO","es-ES":"RECIBO NO V\xc1LIDO","es-MX":"RECIBO NO V\xc1LIDO","fr":"RECU NON VALIDE","hu":"INVALID RECEIPT","id":"TANDA TERIMA TIDAK VALID","it":"RICEVUTA NON VALIDA","ja":"\u7121\u52B9\u30EC\u30B7\u30FC\u30C8","key":"RL_INVALIDRECEIPT","ko":"\uC798\uBABB\uB41C \uC601\uC218\uC99D","nb":"UGYLDIG KVITTERING","nl":"ONGELDIGE BON","pl":"NIEPRAWID\u0141OWY PARAGON","pt-BR":"RECIBO INV\xc1LIDO","pt-PT":"RECIBO INV\xc1LIDO","ru":"\u041D\u0415\u0414\u0415\u0419\u0421\u0422\u0412\u0418\u0422\u0415\u041B\u042C\u041D\u042B\u0419 \u0427\u0415\u041A","sv":"OGILTIGT KVITTO","th":"\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07","tr":"GE\xc7ERS\u0130Z MAKBUZ","zh-Hans":"\u65E0\u6548\u6536\u636E","zh-Hant":"\u7121\u6548\u6536\u64DA"},"RL_ITEMVOID":{"ar":"\u0645\u0646\u062A\u062C \u0628\u0627\u0637\u0644","ca":"ANULAR ART\xcdCULO","comment":"<ITEM VOID>","cs":"POL.ZNEPL.","da":"VARE VOID","de":"Artikel abbrechen","el":"\u0391\u039A\u03A5\u03A1\u03A9\u03A3\u0397 \u0395\u0399\u0394\u039F\u03A5\u03A3","en":"ITEM VOID","en-GB":"ITEM VOID","en-XA":"[\xce\u0162\xc9\u1E40\u2002\u1E7C\xd6\xce\xd0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Anulaci\xf3n de art\xedculo","es-AR":"Anulaci\xf3n de art\xedculo","es-ES":"ANULAR ART\xcdCULO","es-MX":"Anulaci\xf3n de art\xedculo","fr":"ANNULER ART.","hu":"ITEM VOID","id":"ITEM BATAL","it":"ARTICOLO NULLO","ja":"Item VOID","key":"RL_ITEMVOID","ko":"\uD488\uBAA9 \uCDE8\uC18C","nb":"UGYLDIG VARE","nl":"ARTIKEL VERNIETIGEN","pl":"Usuniecie przedmiotu","pt-BR":"ITEM INEXISTENTE","pt-PT":"Artigo ANULADO","ru":"\u0410\u041D\u041D\u0423\u041B\u0418\u0420\u041E\u0412\u0410\u041D\u0418\u0415 \u0422\u041E\u0412\u0410\u0420\u0410","sv":"ART. ANUL","th":"\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","tr":"\u0130PTAL \xdcR\xdcN","zh-Hans":"\u5546\u54C1\u64A4\u9500","zh-Hant":"ITEM VOID"},"RL_IdentificationNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0639\u0631\u064A\u0641","ca":"N\xfamero d\'identificaci\xf3","comment":"Identification Number of the Customer. It has to be a unique number, a phone number or Tax ID.","cs":"Identifika\u010Dn\xed \u010D\xedslo","da":"Identifikationsnummer","de":"Identifikationsnummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B1\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03BF\u03CD","en":"Identification Number","en-GB":"Identification Number","en-XA":"[\xce\xf0\xe9\xf1\u0163\xee\u0192\xee\xe7\xe5\u0163\xee\xf6\xf1\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de identificaci\xf3n","es-AR":"N\xfamero de identificaci\xf3n","es-ES":"N\xfamero de identificaci\xf3n","es-MX":"N\xfamero de identificaci\xf3n","fr":"Num\xe9ro d\'identification","hu":"Azonos\xedt\xf3 sz\xe1m","id":"Nomor Identifikasi","it":"Numero di identificazione","ja":"\u8EAB\u5206\u8A3C\u660E\u66F8\u756A\u53F7","key":"RL_IdentificationNumber","ko":"\uC2DD\uBCC4 \uBC88\uD638","nb":"Identifikasjonsnummer","nl":"Identificatienummer","pl":"Numer identyfikacyjny","pt-BR":"N\xfamero de identifica\xe7\xe3o","pt-PT":"N\xfamero de identifica\xe7\xe3o","ru":"\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440","sv":"ID-nummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E15\u0E31\u0E27","tr":"Kimlik Numaras\u0131","zh-Hans":"\u987E\u5BA2\u6807\u8BC6\u53F7","zh-Hant":"\u8EAB\u4EFD\u8B49\u660E\u865F\u78BC"},"RL_InstallmentMonth":{"ar":"\u0623\u0634\u0647\u0631 \u0627\u0644\u062A\u0642\u0633\u064A\u0637","ca":"Mes del termini","comment":"Number of installments in months for the card payments. ","cs":"m\u011Bs\xedc n\xe1kupu","da":"Afdragsm\xe5ned","de":"Ratenmonat","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03BC\u03B7\u03BD\u03B9\u03B1\u03AF\u03C9\u03BD \u03B4\u03CC\u03C3\u03B5\u03C9\u03BD","en":"Installment month","en-GB":"Instalment month","en-XA":"[\xce\xf1\u0161\u0163\xe5\u013C\u013C\u0271\xe9\xf1\u0163\u2002\u0271\xf6\xf1\u0163\u0125\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Mes de pago","es-AR":"Cuota mensual","es-ES":"Cuota mensual","es-MX":"Meses sin intereses","fr":"Mois du versement","hu":"R\xe9szletfizet\xe9si h\xf3nap","id":"Bulan cicilan","it":"Mese rata","ja":"\u5206\u5272\u6255\u3044\uFF08\u6708\uFF09","key":"RL_InstallmentMonth","ko":"\uD560\uBD80 \uAC1C\uC6D4","nb":"Avdragsm\xe5ned","nl":"Termijnmaand","pl":"Miesi\u0119czna rata","pt-BR":"M\xeas da parcela","pt-PT":"M\xeas de presta\xe7\xe3o","ru":"\u041E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443 (\u043C\u0435\u0441\u044F\u0446)","sv":"Delbetalningsm\xe5nad","th":"\u0E40\u0E14\u0E37\u0E2D\u0E19\u0E1C\u0E48\u0E2D\u0E19\u0E0A\u0E33\u0E23\u0E30","tr":"Taksit s\xfcresi (ay)","zh-Hans":"\u5206\u671F\u4ED8\u6B3E\u6708\u6570","zh-Hant":"\u5206\u671F\u4ED8\u6B3E\u6708\u4EFD"},"RL_InvoiceNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629","ca":"N.\xba factura","comment":"Invoice Number","cs":"\u010C. pozv\xe1nky","da":"Fakturanummer","de":"Rechnungsnummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5","en":"Invoice Number","en-GB":"Invoice Number","en-XA":"[\xce\xf1\u1E7D\xf6\xee\xe7\xe9\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de factura","es-AR":"N\xfamero de factura","es-ES":"Fra n\xba","es-MX":"N\xfamero de factura","fr":"Num Facture","hu":"Invoice Number","id":"Nomor Faktur","it":"Numero fattura","ja":"Invoice Number","key":"RL_InvoiceNumber","ko":"\uC1A1\uC7A5 \uBC88\uD638","nb":"Fakturanummer","nl":"Factuurnummer","pl":"Numer faktury","pt-BR":"N\xfamero da fatura","pt-PT":"N\xba Factura","ru":"Invoice Number","sv":"Faktura nummer","th":"\u0E40\u0E25\u0E02\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","tr":"Fatura Numaras\u0131","zh-Hans":"\u53D1\u7968\u7F16\u53F7","zh-Hant":"\u767C\u7968\u865F\u78BC"},"RL_Item":{"ar":"\u0627\u0644\u0645\u0646\u062A\u062C","ca":"Art\xedculo","comment":"Line in receipt indicates the item","cs":"Polo\u017Eka","da":"Vare","de":"Item","el":"\u0395\u03AF\u03B4\u03BF\u03C2","en":"Item","en-GB":"Item","en-XA":"[\xce\u0163\xe9\u0271\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Art\xedculo","es-AR":"Art\xedculo","es-ES":"Art\xedculo","es-MX":"Art\xedculo","fr":"Article","hu":"Item","id":"Item","it":"Articolo","ja":"\u5546\u54C1","key":"RL_Item","ko":"\uC544\uC774\uD15C","nb":"Vare","nl":"Artikel","pl":"Przedmiot","pt-BR":"Item","pt-PT":"Artigo","ru":"\u042D\u043B\u0435\u043C\u0435\u043D\u0442","sv":"Produkt","th":"\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","tr":"\xdcr\xfcn","zh-Hans":"\u5546\u54C1","zh-Hant":"\u54C1\u9805"},"RL_ItemTax":{"ar":"\u0627\u0644\u0636\u0631\u064A\u0628\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0646\u062A\u062C","ca":"Impuestos Art\xedculo","comment":"Tax of the item","cs":"Dan-polo\u017Eka","da":"Afgift p\xe5 vare","de":"Artikel-Steuer","el":"\u03A6\u03A0\u0391 \u03B5\u03AF\u03B4\u03BF\u03C5\u03C2","en":"Item Tax","en-GB":"Item Tax","en-XA":"[\xce\u0163\xe9\u0271\u2002\u0162\xe5\u1E8B\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Impuestos de art\xedculo","es-AR":"Impuestos de art\xedculo","es-ES":"Impuestos Art\xedculo","es-MX":"Impuestos de art\xedculo","fr":"Taxe art.","hu":"Item Tax","id":"Pajak Item","it":"Tassa Articolo","ja":"Item \u6D88\u8CBB\u7A0E","key":"RL_ItemTax","ko":"\uD488\uBAA9\uC138","nb":"Vareavgift","nl":"Btw items","pl":"Podatek od przedmiotu","pt-BR":"Imposto do item","pt-PT":"Imposto sobre o artigo","ru":"\u041D\u0430\u043B\u043E\u0433 \u043D\u0430 \u0442\u043E\u0432\u0430\u0440","sv":"Moms produkt","th":"\u0E20\u0E32\u0E29\u0E35\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","tr":"\xdcr\xfcn Vergisi","zh-Hans":"\u5546\u54C1\u7A0E\u8D39","zh-Hant":"\u54C1\u9805\u7A05\u91D1"},"RL_ItemTaxAmt":{"ar":"\u0642\u064A\u0645\u0629 \u0627\u0644\u0636\u0631\u064A\u0628\u0629 \u0639\u0644\u0649 \u0627\u0644\u0645\u0646\u062A\u062C","ca":"Impuesto en art\xedculo","comment":"Item Tax Amount","cs":"\u010C\xe1stka dan\u011B polo\u017Eky","da":"Varemomsbel\xf8b","de":"Item Tax Amount","el":"\u03A0\u03BF\u03C3\u03CC \u03A6\u03A0\u0391 \u03B5\u03AF\u03B4\u03BF\u03C5\u03C2","en":"Item Tax Amount","en-GB":"Item Tax Amount","en-XA":"[\xce\u0163\xe9\u0271\u2002\u0162\xe5\u1E8B\u2002\xc5\u0271\xf6\xfb\xf1\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Monto de impuestos del art\xedculo","es-AR":"Monto de impuestos del art\xedculo","es-ES":"Importe impuestos","es-MX":"Importe del impuesto del art\xedculo","fr":"Montant de la taxe de l\u2019article ","hu":"Item Tax Amount","id":"Jumlah Pajak Item","it":"Importo imposte articolo","ja":"\u5546\u54C1\u7A0E\u91D1\u984D","key":"RL_ItemTaxAmt","ko":"\uD488\uBAA9\uC138\uC561","nb":"Avgiftsbel\xf8p p\xe5 vare","nl":"Btw-bedrag items","pl":"Kwota podatku od przedmiotu","pt-BR":"Valor fiscal do item","pt-PT":"Valor do imposto sobre o artigo","ru":"\u0421\u0443\u043C\u043C\u0430 \u043D\u0430\u043B\u043E\u0433\u0430 \u043D\u0430 \u0442\u043E\u0432\u0430\u0440","sv":"Momsbelopp produkt","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E20\u0E32\u0E29\u0E35\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","tr":"\xdcr\xfcn Vergi Tutar\u0131","zh-Hans":"\u5546\u54C1\u7A0E\u91D1\u989D","zh-Hant":"\u7A05\u91D1\u91D1\u984D"},"RL_Journal":{"ar":"\u0639\u0631\u0636 \u062F\u0641\u062A\u0631 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A","ca":"Mostra el registre","comment":"the view of the journal that has the transaction details.","cs":"Den\xedkov\xe9 zobrazen\xed","da":"Journalvisning","de":"Zeitschriftansicht","el":"\u03A0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE \u03B5\u03C6\u03B7\u03BC\u03B5\u03C1\u03AF\u03B4\u03B1\u03C2","en":"Journal View","en-GB":"Journal View","en-XA":"[\u0134\xf6\xfb\u0155\xf1\xe5\u013C\u2002\u1E7C\xee\xe9\u0175\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Vista de publicaci\xf3n","es-AR":"Vista de publicaci\xf3n","es-ES":"Vista de publicaci\xf3n","es-MX":"Vista de diario","fr":"Affichage du journal","hu":"Nyilv\xe1ntart\xe1si n\xe9zet","id":"Tampilan Jurnal","it":"Vista diario","ja":"\u30B8\u30E3\u30FC\u30CA\u30EB \u30D3\u30E5\u30FC","key":"RL_Journal","ko":"\uC800\uB110 \uBDF0","nb":"Journalvisning","nl":"Weergave kasboek","pl":"Widok dziennika","pt-BR":"Visualiza\xe7\xe3o do di\xe1rio","pt-PT":"Vista de registo","ru":"\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0436\u0443\u0440\u043D\u0430\u043B\u0430","sv":"Journalvy","th":"\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","tr":"G\xfcnl\xfck G\xf6r\xfcn\xfcm\xfc","zh-Hans":"\u65E5\u8BB0\u8D26\u89C6\u56FE","zh-Hant":"\u65E5\u8A8C\u6AA2\u8996\u6A21\u5F0F"},"RL_LLCard":{"ar":"\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0627\u0644\u0643","ca":"Landlord Card","comment":"Landlord Card","cs":"Landlord Card","da":"Landlord Card","de":"Landlord Card","el":"\u039A\u03AC\u03C1\u03C4\u03B1 \u03B9\u03B4\u03B9\u03BF\u03BA\u03C4\u03AE\u03C4\u03B7","en":"Landlord Card","en-GB":"Landlord Card","en-XA":"[\u013B\xe5\xf1\xf0\u013C\xf6\u0155\xf0\u2002\xc7\xe5\u0155\xf0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Landlord Card","es-AR":"Landlord Card","es-ES":"Landlord Card","es-MX":"Landlord Card","fr":"Landlord Card","hu":"Landlord Card","id":"Kartu Pemilik Tempat","it":"Landlord Card","ja":"\u5BB6\u4E3B\u30AB\u30FC\u30C9","key":"RL_LLCard","ko":"\uC784\uB300\uC8FC \uCE74\uB4DC","nb":"Landlord Card","nl":"Landlord Card","pl":"Landlord Card","pt-BR":"Cart\xe3o do propriet\xe1rio","pt-PT":"Landlord Card","ru":"\u041A\u0430\u0440\u0442\u0430 \u0430\u0440\u0435\u043D\u0434\u043E\u0434\u0430\u0442\u0435\u043B\u044F","sv":"Landlord Card","th":"\u0E1A\u0E31\u0E15\u0E23\u0E40\u0E08\u0E49\u0E32\u0E02\u0E2D\u0E07\u0E2A\u0E16\u0E32\u0E19\u0E17\u0E35\u0E48","tr":"Ev Sahibi Kart\u0131","zh-Hans":"Landlord Card","zh-Hant":"Landlord Card"},"RL_LoginToNikecom":{"ar":"\u0633\u062C\u0651\u0644 \u062F\u062E\u0648\u0644\u0643 \u0625\u0644\u0649 \u0645\u0648\u0642\u0639 Nike.com \u0644\u0644\u0627\u0637\u0651\u0644\u0627\u0639 \u0639\u0644\u0649 \u062D\u0627\u0644\u0629 \u0637\u0644\u0628\u064A\u062A\u0643","ca":"Inicia la sessi\xf3 a Nike.com per comprovar l\'estat de la teva comanda","comment":"Phrase to instruct customers to login to Nike.com to check their order status","cs":"Stav objedn\xe1vky zjist\xed\u0161 p\u0159ihl\xe1\u0161en\xedm na Nike.com","da":"Log ind p\xe5 Nike.com for at se din ordrestatus","de":"Melde dich bei Nike.com an, um deinen Bestellstatus zu \xfcberpr\xfcfen","el":"\u03A3\u03C5\u03BD\u03B4\u03AD\u03C3\u03BF\u03C5 \u03C3\u03C4\u03BF Nike.com \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03B5\u03BB\u03AD\u03B3\u03BE\u03B5\u03B9\u03C2 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03C0\u03B1\u03C1\u03B1\u03B3\u03B3\u03B5\u03BB\u03AF\u03B1\u03C2 \u03C3\u03BF\u03C5","en":"Log into Nike.com to check your order status","en-GB":"Sign in to Nike.com to check your order status","en-XA":"[\u013B\xf6\u011D\u2002\xee\xf1\u0163\xf6\u2002\xd1\xee\u0137\xe9\xb7\xe7\xf6\u0271\u2002\u0163\xf6\u2002\xe7\u0125\xe9\xe7\u0137\u2002\xfd\xf6\xfb\u0155\u2002\xf6\u0155\xf0\xe9\u0155\u2002\u0161\u0163\xe5\u0163\xfb\u0161\u2002\xe5\u0180\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Inicia sesi\xf3n en Nike.com para verificar estado del pedido","es-AR":"Inici\xe1 sesi\xf3n en Nike.com para comprobar el estado de tu pedido","es-ES":"Inicia sesi\xf3n en Nike.com para comprobar el estado de tu pedido","es-MX":"Inicia sesi\xf3n en Nike.com para revisar el estado de tu pedido","fr":"Connecte-toi \xe0 Nike.com pour voir le statut de ta commande","hu":"A rendel\xe9s \xe1llapot\xe1nak ellen\u0151rz\xe9s\xe9hez jelentkezzen be a Nike.com oldalra","id":"Masuk ke Nike.com untuk memeriksa status pemesanan Anda","it":"Accedi a Nike.com per verificare lo stato dell\'ordine","ja":"Nike.com\u306B\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u3001\u6CE8\u6587\u5C65\u6B74\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044","key":"RL_LoginToNikecom","ko":"NIKE.COM\uC5D0 \uB85C\uADF8\uC778\uD558\uC5EC \uC8FC\uBB38 \uC0C1\uD0DC \uD655\uC778","nb":"Logg p\xe5 Nike.com for \xe5 sjekke bestillingsstatus","nl":"Log in op Nike.com om je bestelstatus te controleren","pl":"Zaloguj si\u0119 na Nike.com, aby sprawdzi\u0107 status zam\xf3wienia","pt-BR":"Fa\xe7a login em Nike.com para verificar o status do seu pedido","pt-PT":"Inicia sess\xe3o em Nike.com para verificares o estado da encomenda","ru":"\u0412\u043E\u0439\u0434\u0438\u0442\u0435 \u043D\u0430 \u0441\u0430\u0439\u0442 Nike.com, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0432\u0435\u0440\u0438\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u043A\u0430\u0437\u0430","sv":"Logga in p\xe5 Nike.com f\xf6r att se statusen f\xf6r din best\xe4llning.","th":"\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A Nike.com \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E0B\u0E37\u0E49\u0E2D","tr":"Sipari\u015F durumunu kontrol etmek i\xe7in Nike.com\'da oturum a\xe7","zh-Hans":"\u767B\u5F55 Nike.com\uFF0C\u67E5\u770B\u60A8\u7684\u8BA2\u5355\u72B6\u6001","zh-Hant":"\u524D\u5F80 Nike.com \u67E5\u770B\u8A02\u55AE\u72C0\u614B"},"RL_Lumpsum":{"ar":"\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A","ca":"pagament \xfanic","comment":"A single payment made at a particular time, as opposed to a number of smaller payments or installments.","cs":"jedna platba","da":"samlet bel\xf8b","de":"Pauschalbetrag","el":"\u03C0\u03BB\u03B7\u03C1\u03C9\u03C4\u03AD\u03BF \u03B5\u03C6\u03AC\u03C0\u03B1\u03BE \u03C0\u03BF\u03C3\u03CC","en":"lumpsum","en-GB":"lump sum","en-XA":"[\u013C\xfb\u0271\xfe\u0161\xfb\u0271\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"suma global","es-AR":"pago \xfanico","es-ES":"Pago \xfanico","es-MX":"sumatotal","fr":"lumpsum","hu":"egy \xf6sszegben","id":"lumsum","it":"lumpsum","ja":"\u4E00\u62EC\u6255\u3044","key":"RL_Lumpsum","ko":"\uC77C\uC2DC\uBD88","nb":"enkeltutbetaling","nl":"aanbetaling","pl":"rycza\u0142t","pt-BR":"lumpsum","pt-PT":"Pagamento \xfanico","ru":"\u0415\u0434\u0438\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u0430\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u0430","sv":"eng\xe5ngsbetalning","th":"\u0E40\u0E07\u0E34\u0E19\u0E01\u0E49\u0E2D\u0E19","tr":"lumpsum","zh-Hans":"\u603B\u989D","zh-Hant":"\u7E3D\u91D1\u984D"},"RL_MallCertificate":{"ar":"\u0634\u0647\u0627\u062F\u0629 \u0627\u0644\u0645\u0648\u0644","ca":"Cheque c. comercial","comment":"Mall Certificate used in the transation","cs":"Mall Certificate","da":"Indk\xf8bscenter certifikat","de":"Zertifikat Shoppingcenter","el":"\u0394\u03C9\u03C1\u03BF\u03B5\u03C0\u03B9\u03C4\u03B1\u03B3\u03AE \u03B5\u03BC\u03C0\u03BF\u03C1\u03B9\u03BA\u03BF\u03CD","en":"Mall Certificate","en-GB":"Mall Certificate","en-XA":"[\u1E40\xe5\u013C\u013C\u2002\xc7\xe9\u0155\u0163\xee\u0192\xee\xe7\xe5\u0163\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Certificado de regalo de centro comercial","es-AR":"Certificado de regalo de centro comercial","es-ES":"Cheque c. comercial","es-MX":"Certificado de centro comercial","fr":"Certificat du centre commercial","hu":"Mall Certificate","id":"Sertifikat Mal","it":"Certificato centro commerciale","ja":"\u30E2\u30FC\u30EB\u30AE\u30D5\u30C8\u5238","key":"RL_MallCertificate","ko":"\uC0C1\uD488\uAD8C","nb":"Gavekort til kj\xf8pesenter","nl":"Bon winkelcentrum","pl":"Certyfikat sklepowy","pt-BR":"Certificado do correio","pt-PT":"Vale de Centro Comercial","ru":"Mall Certificate","sv":"K\xf6pcenter, certifikat","th":"\u0E1A\u0E31\u0E15\u0E23\u0E2B\u0E49\u0E32\u0E07\u0E2F","tr":"Al\u0131\u015Fveri\u015F Merkezi Hediye \xc7eki","zh-Hans":"\u5546\u573A\u8BC1\u4E66","zh-Hant":"\u5546\u5834\u79AE\u5238"},"RL_MatchingTransactions":{"ar":"\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0627\u0644\u0645\u062A\u0637\u0627\u0628\u0642\u0629","ca":"Transaccions coincidents","comment":"Transactions Matching the given search criteria.","cs":"Odpov\xeddaj\xedc\xed transakce","da":"Matchende transaktioner","de":"Passende Transaktionen","el":"\u03A3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AD\u03C2 \u03C0\u03BF\u03C5 \u03C3\u03C5\u03BC\u03C6\u03C9\u03BD\u03BF\u03CD\u03BD","en":"Matching Transactions","en-GB":"Matching Transactions","en-XA":"[\u1E40\xe5\u0163\xe7\u0125\xee\xf1\u011D\u2002\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Transacciones coincidentes","es-AR":"Transacciones coincidentes","es-ES":"Transacciones coincidentes","es-MX":"Transacciones coincidentes","fr":"Transactions correspondantes","hu":"Keres\xe9snek megfelel\u0151 tranzakci\xf3k","id":"Transaksi yang Sesuai","it":"Transazioni corrispondenti","ja":"\u6761\u4EF6\u3068\u4E00\u81F4\u3057\u305F\u53D6\u5F15","key":"RL_MatchingTransactions","ko":"\uC77C\uCE58\uD558\uB294 \uAC70\uB798","nb":"Samsvarende transaksjoner","nl":"Sluitende transacties","pl":"Pasuj\u0105ce transakcje","pt-BR":"Transa\xe7\xf5es correspondentes","pt-PT":"Transa\xe7\xf5es com correspond\xeancia","ru":"\u0421\u043E\u0432\u043F\u0430\u0434\u0430\u044E\u0449\u0438\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Matchande transaktioner","th":"\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E35\u0E48\u0E15\u0E23\u0E07\u0E01\u0E31\u0E19","tr":"E\u015Fle\u015Fen \u0130\u015Flemler","zh-Hans":"\u7B26\u5408\u6761\u4EF6\u7684\u4EA4\u6613","zh-Hant":"\u4EA4\u6613\u641C\u5C0B\u7D50\u679C"},"RL_Mid":{"ar":"\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062A\u0627\u062C\u0631","ca":"Mid","comment":"Mid of the gift card details","cs":"Mid","da":"Mid","de":"Mid","el":"Mid","en":"Mid","en-GB":"Mid","en-XA":"[\u1E40\xee\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Mitad del d\xeda","es-AR":"Mitad del d\xeda","es-ES":"Mid","es-MX":"Mid","fr":"Mid","hu":"Mid","id":"Mid","it":"Mid","ja":"Mid","key":"RL_Mid","ko":"Mid","nb":"Mid","nl":"Mid","pl":"Mid","pt-BR":"M\xe9dio","pt-PT":"Meio","ru":"\u0421\u0440\u0435\u0434\u043D.","sv":"Med","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E1C\u0E39\u0E49\u0E04\u0E49\u0E32","tr":"Mid","zh-Hans":"\u578B\u53F7\u8BC6\u522B\u7801","zh-Hant":"\u7279\u5E97\u4EE3\u865F"},"RL_Modifiers":{"ar":"\u0627\u0644\u062D\u0633\u0648\u0645\u0627\u062A/\u0627\u0644\u0639\u0631\u0648\u0636","ca":"Modificadors","comment":"Price override, Promotions, Discounts etc that modifies the item price. ","cs":"Modifik\xe1tory","da":"\xc6ndringer","de":"Modifizierer","el":"\u03A4\u03C1\u03BF\u03C0\u03BF\u03C0\u03BF\u03B9\u03B7\u03C4\u03AD\u03C2","en":"Modifiers","en-GB":"Modifiers","en-XA":"[\u1E40\xf6\xf0\xee\u0192\xee\xe9\u0155\u0161\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Modificadores","es-AR":"Modificadores","es-ES":"Modificadores","es-MX":"Modificadores","fr":"Modificateurs","hu":"Attrib\xfatumok","id":"Pengubah","it":"Modificatori","ja":"\u4FA1\u683C\u5909\u66F4\u56E0\u5B50","key":"RL_Modifiers","ko":"\uBCC0\uACBD \uD56D\uBAA9 \uC801\uC6A9","nb":"Justeringer","nl":"Aanpassingen","pl":"Modyfikatory","pt-BR":"Modificadores","pt-PT":"Modificadores","ru":"\u041C\u043E\u0434\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440\u044B","sv":"Modifierare","th":"\u0E15\u0E31\u0E27\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E04\u0E32","tr":"De\u011Fi\u015Ftiriciler","zh-Hans":"\u4EF7\u683C\u66F4\u6539","zh-Hant":"\u4FEE\u6539\u9805\u76EE"},"RL_Months":{"ar":"\u0634\u0647\u0631","ca":"mesos","comment":"Number of months to complete an installment payment. eg 2 months, 3 months etc.","cs":"m\u011Bs\xedce","da":"m\xe5neder","de":"Monate","el":"\u03BC\u03AE\u03BD\u03B5\u03C2","en":"months","en-GB":"months","en-XA":"[\u0271\xf6\xf1\u0163\u0125\u0161\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"meses","es-AR":"meses","es-ES":"meses","es-MX":"meses","fr":"mois","hu":"h\xf3nap","id":"bulan","it":"mesi","ja":"\u6708","key":"RL_Months","ko":"\uAC1C\uC6D4","nb":"m\xe5neder","nl":"maanden","pl":"mies.","pt-BR":"meses","pt-PT":"meses","ru":"\u043C\u0435\u0441\u044F\u0446\u044B","sv":"m\xe5nader","th":"\u0E40\u0E14\u0E37\u0E2D\u0E19","tr":"ay","zh-Hans":"\u4E2A\u6708","zh-Hant":"\u6708"},"RL_Name":{"ar":"\u0627\u0644\u0627\u0633\u0645","ca":"Nombre","comment":"Name  in shipping details","cs":"Jm\xe9no","da":"Navn","de":"Name","el":"\u038C\u03BD\u03BF\u03BC\u03B1","en":"Name","en-GB":"Name","en-XA":"[\xd1\xe5\u0271\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre","es-AR":"Nombre","es-ES":"Nombre","es-MX":"Nombre","fr":"Name","hu":"Name","id":"Nama","it":"Nome","ja":"\u304A\u540D\u524D","key":"RL_Name","ko":"\uC774\uB984","nb":"Navn","nl":"Naam","pl":"Imi\u0119 i nazwisko","pt-BR":"Nome","pt-PT":"Nome","ru":"\u0418\u043C\u044F","sv":"Namn","th":"\u0E0A\u0E37\u0E48\u0E2D","tr":"Ad","zh-Hans":"\u540D\u79F0","zh-Hant":"\u540D\u7A31"},"RL_No":{"ar":"\u0644\u0627.","ca":"NO","comment":"No.","cs":"Ne","da":"Nej","de":"Nr.","el":"\u0391\u03C1.","en":"No.","en-GB":"No.","en-XA":"[\xd1\xf6\xb7\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"No","es-AR":"No","es-ES":"No.","es-MX":"No.","fr":"Non","hu":"No.","id":"No.","it":"NO","ja":"No.","key":"RL_No","ko":"\uBC88\uD638","nb":"Nr.","nl":"Nee","pl":"Nr.","pt-BR":"N\xba","pt-PT":"N\xc3O","ru":"\u2116","sv":"Nr.","th":"\u0E40\u0E25\u0E02\u0E17\u0E35\u0E48","tr":"No.","zh-Hans":"\u7F16\u53F7","zh-Hant":"NO"},"RL_NoSale":{"ar":"\u0645\u0627 \u0645\u0646 \u062A\u062E\u0641\u064A\u0636\u0627\u062A","ca":"Oferta n\xfam.","comment":"No Sale","cs":"Bez slevy","da":"Ikke udsalg","de":"Kein Verkauf","el":"\u03A7\u03C9\u03C1\u03AF\u03C2 \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7","en":"No Sale","en-GB":"No Sale","en-XA":"[\xd1\xf6\u2002\u0160\xe5\u013C\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de rebaja","es-AR":"Sin venta","es-ES":"N.\xba de oferta","es-MX":"Sin venta","fr":"N\xb0 de promotion","hu":"Nem akci\xf3s","id":"Tidak Ada Sale","it":"Non in saldo","ja":"\u30BB\u30FC\u30EB\u306A\u3057","key":"RL_NoSale","ko":"\uBE44\uD560\uC778","nb":"Intet salg","nl":"Geen sale","pl":"Bez sprzeda\u017Cy","pt-BR":"N\xfamero da venda","pt-PT":"Sem saldos","ru":"\u041D\u0435\u0442 \u0430\u043A\u0446\u0438\u0438","sv":"Ingen rea","th":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22","tr":"Sat\u0131\u015F Yok","zh-Hans":"\u672A\u6210\u4EA4","zh-Hant":"\u7121\u7279\u60E0"},"RL_Number":{"ar":"\u0627\u0644\u0631\u0642\u0645","ca":"N\xfamero","comment":"Card number","cs":"  \u010C\xedslo ","da":"Kortnummer","de":"Number","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2","en":"Number","en-GB":"Number","en-XA":"[\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nro.","es-AR":"N\xfamero","es-ES":"N\xfamero","es-MX":"N\xfamero","fr":"No carte","hu":"Number","id":"Nomor","it":"Numero","ja":"\u756A\u53F7","key":"RL_Number","ko":"\uBC88\uD638","nb":"Nummer","nl":"Nummer","pl":"Numer","pt-BR":"N\xfamero","pt-PT":"N\xfamero","ru":"\u041D\u043E\u043C\u0435\u0440","sv":"Nummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02","tr":"Numara","zh-Hans":"\u7F16\u53F7","zh-Hant":"\u865F\u78BC"},"RL_NumberItemReturned":{"ar":"\u0639\u062F\u062F \u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u0625\u0631\u062C\u0627\u0639\u0647\u0627","ca":"Num articulos devueltos","comment":"Number of items returned in transaction","cs":"C. vr\xe1cen\xfdch pol.","da":"Antal af units retuneret","de":"Anzahl der Artikel umgetauscht","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B5\u03B9\u03B4\u03CE\u03BD \u03C0\u03BF\u03C5 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03AC\u03C6\u03B7\u03BA\u03B1\u03BD","en":"Number of Item(s) Returned","en-GB":"Number of Item(s) Returned","en-XA":"[\xd1\xfb\u0271\u0180\xe9\u0155\u2002\xf6\u0192\u2002\xce\u0163\xe9\u0271(\u0161)\u2002\u0154\xe9\u0163\xfb\u0155\xf1\xe9\xf0\u2002\xe5\u0180\xe7\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cantidad de art\xedculo(s) devuelto(s)","es-AR":"Cantidad de art\xedculo(s) devuelto(s)","es-ES":"Num articulos devueltos","es-MX":"Cantidad de art\xedculo(s) devuelto(s)","fr":"Nb ligne d\'art.(s) Retourne","hu":"Number of Item(s) Returned","id":"Jumlah Item Dikembalikan","it":"Numero di articolo(i) resi","ja":"\u8FD4\u54C1\u5546\u54C1\u6570","key":"RL_NumberItemReturned","ko":"\uBC18\uD488 \uC218\uB7C9","nb":"Antall varer returnert","nl":"Aantal artikelen geretourneerd","pl":"Liczba zwr\xf3conych przedmiot\xf3w","pt-BR":"N\xfamero de itens retornados","pt-PT":"N\xfamero de artigos devolvidos","ru":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u043D\u044B\u0445 \u0442\u043E\u0432\u0430\u0440\u043E\u0432","sv":"Antal returnerade produkter","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19","tr":"\u0130ade Edilen \xdcr\xfcn Say\u0131s\u0131","zh-Hans":"\u9000\u8D27\u5546\u54C1\u6570\u91CF","zh-Hant":"\u9000\u8CA8\u6578\u91CF"},"RL_NumberItemSold":{"ar":"\u0639\u062F\u062F \u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645 \u0628\u064A\u0639\u0647\u0627","ca":"Num articulos vendidos","comment":"Number of items sold in transactions","cs":"C. prodan\xfdch pol.","da":"Antal af units solgt: ","de":"Anzahl der Artikel verkauft","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C0\u03C9\u03BB\u03B7\u03B8\u03AD\u03BD\u03C4\u03C9\u03BD \u03B5\u03B9\u03B4\u03CE\u03BD","en":"Number of Item(s) Sold","en-GB":"Number of Item(s) Sold","en-XA":"[\xd1\xfb\u0271\u0180\xe9\u0155\u2002\xf6\u0192\u2002\xce\u0163\xe9\u0271(\u0161)\u2002\u0160\xf6\u013C\xf0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cantidad de art\xedculo(s) vendido(s)","es-AR":"Cantidad de art\xedculo(s) vendido(s)","es-ES":"Num articulos vendidos","es-MX":"Cantidad de art\xedculo(s) vendido(s)","fr":"Nb ligne d\u2019art. (s) vendu","hu":"Number of Item(s) Sold","id":"Jumlah Item Dijual","it":"Numero di articolo(i) venduti","ja":"\u8CA9\u58F2\u5546\u54C1\u6570","key":"RL_NumberItemSold","ko":"\uD310\uB9E4 \uC218\uB7C9","nb":"Antall solgte varer","nl":"Aantal artikelen verkocht","pl":"Liczba sprzedanych przedmiot\xf3w","pt-BR":"N\xfamero de itens vendidos","pt-PT":"N\xfamero de artigos vendidos","ru":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u0440\u043E\u0434\u0430\u043D\u043D\u044B\u0445 \u0442\u043E\u0432\u0430\u0440\u043E\u0432","sv":"Antal s\xe5lda produkter","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E02\u0E32\u0E22","tr":"Sat\u0131lan \xdcr\xfcn Say\u0131s\u0131","zh-Hans":"\u552E\u51FA\u5546\u54C1\u6570\u91CF","zh-Hant":"\u92B7\u552E\u6578\u91CF"},"RL_NumberOfPrints":{"ar":"\u0639\u062F\u062F \u0627\u0644\u0637\u0628\u0639\u0627\u062A","ca":"Nombre d\'impressions","comment":"Number of receipt prints from the printer.","cs":"Po\u010Det tisk\u016F","da":"Antal print","de":"Anzahl der Ausdrucke","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B5\u03BA\u03C4\u03C5\u03C0\u03CE\u03C3\u03B5\u03C9\u03BD","en":"Number Of Prints","en-GB":"Number of Prints","en-XA":"[\xd1\xfb\u0271\u0180\xe9\u0155\u2002\xd6\u0192\u2002\xde\u0155\xee\xf1\u0163\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de impresiones","es-AR":"N\xfamero de impresiones","es-ES":"N\xfamero de copias","es-MX":"N\xfamero de impresiones","fr":"Nombre d\'impressions","hu":"Nyomtatott p\xe9ld\xe1nyok sz\xe1ma","id":"Jumlah Cetakan","it":"Numero di stampe","ja":"\u5370\u5237\u6570","key":"RL_NumberOfPrints","ko":"\uC778\uC1C4 \uB9E4\uC218","nb":"Antall utskrifter","nl":"Aantal prints","pl":"Liczba wydruk\xf3w","pt-BR":"N\xfamero de impress\xf5es","pt-PT":"N\xfamero de impress\xf5es","ru":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440\u043E\u0432","sv":"Antal utskrifter","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E1E\u0E34\u0E21\u0E1E\u0E4C","tr":"Bask\u0131 Say\u0131s\u0131","zh-Hans":"\u6253\u5370\u6570\u91CF","zh-Hant":"\u5217\u5370\u6578\u91CF"},"RL_O2OEvents":{"ar":"\u0641\u0639\u0627\u0644\u064A\u0627\u062A O2O","ca":"Esdeveniments online i offline","comment":"Online to Offline, O2O events that happens in a store. E.g Buy Online Pick Up in Store. ","cs":"Ud\xe1losti O2O","da":"O2O-events","de":"O2O Events","el":"\u03A3\u03C5\u03BC\u03B2\u03AC\u03BD\u03C4\u03B1 O2O","en":"O2O Events","en-GB":"O2O Events","en-XA":"[\xd6\u2461\xd6\u2002\xc9\u1E7D\xe9\xf1\u0163\u0161\u2002\xe5\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Eventos en l\xednea a la tienda","es-AR":"Eventos O2O","es-ES":"Eventos 020","es-MX":"Eventos O2O","fr":"\xc9v\xe8nements O2O","hu":"O2O-esem\xe9nyek","id":"Acara O2O","it":"Eventi O2O","ja":"O2O\u306B\u3088\u308B\u8CFC\u5165","key":"RL_O2OEvents","ko":"O2O \uC774\uBCA4\uD2B8","nb":"O2O Events","nl":"O2O evenementen","pl":"Wydarzenia O2O","pt-BR":"Eventos O2O","pt-PT":"Eventos O2O","ru":"\u0421\u043E\u0431\u044B\u0442\u0438\u044F O2O","sv":"O2O Event","th":"\u0E01\u0E34\u0E08\u0E01\u0E23\u0E23\u0E21 O2O","tr":"O2O Etkinlikleri","zh-Hans":"O2O \u6D3B\u52A8","zh-Hant":"O2O \u6D3B\u52D5"},"RL_OfflineReceipt":{"ar":"\u0625\u064A\u0635\u0627\u0644 \u0645\u0646 \u062F\u0648\u0646 \u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0625\u0646\u062A\u0631\u0646\u062A","ca":"Rebut offline","comment":"Text to be printed on top of  the receipts that are generated in Offline Scenarios /when network is down.","cs":"Offline \xfa\u010Dtenka","da":"Offline-kvittering","de":"Offline-Beleg","el":"\u0391\u03C0\u03CC\u03B4\u03B5\u03B9\u03BE\u03B7 \u03B5\u03BA\u03C4\u03CC\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2","en":"Offline Receipt","en-GB":"Offline Receipt","en-XA":"[\xd6\u0192\u0192\u013C\xee\xf1\xe9\u2002\u0154\xe9\xe7\xe9\xee\xfe\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Recibo sin conexi\xf3n","es-AR":"Recibo sin conexi\xf3n","es-ES":"Recibo offline","es-MX":"Recibo sin conexi\xf3n","fr":"Re\xe7u hors ligne","hu":"Offline sz\xe1mla","id":"Tanda Terima Offline","it":"Ricevuta offline","ja":"\u30AA\u30D5\u30E9\u30A4\u30F3\u7528\u306E\u9818\u53CE\u66F8","key":"RL_OfflineReceipt","ko":"\uC624\uD504\uB77C\uC778 \uC601\uC218\uC99D","nb":"Offline-kvittering","nl":"Offline bon","pl":"Paragon offline","pt-BR":"Recibos off-line","pt-PT":"Recibo offline","ru":"\u0424\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0447\u0435\u043A","sv":"Offline-kvitto","th":"\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E41\u0E1A\u0E1A\u0E2D\u0E2D\u0E1F\u0E44\u0E25\u0E19\u0E4C","tr":"\xc7evrimd\u0131\u015F\u0131 Makbuz","zh-Hans":"\u79BB\u7EBF\u6536\u636E","zh-Hant":"\u96E2\u7DDA\u6536\u64DA"},"RL_OperationType":{"ar":"\u0646\u0648\u0639 \u0627\u0644\u0639\u0645\u0644\u064A\u0629","ca":"Tipus d\'operaci\xf3","comment":"Operation Type is a type of operation - sales or returns ","cs":"Typ operace","da":"Handlingstype","de":"Vorgang","el":"\u03A4\u03CD\u03C0\u03BF\u03C2 \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1\u03C2","en":"Operation Type","en-GB":"Operation Type","en-XA":"[\xd6\xfe\xe9\u0155\xe5\u0163\xee\xf6\xf1\u2002\u0162\xfd\xfe\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tipo de operaci\xf3n","es-AR":"Tipo de operaci\xf3n","es-ES":"Tipo de operaci\xf3n","es-MX":"Tipo de operaci\xf3n","fr":"Type d\'op\xe9ration","hu":"M\u0171velet t\xedpusa","id":"Jenis Operasi","it":"Tipo operazione","ja":"\u64CD\u4F5C\u306E\u7A2E\u985E","key":"RL_OperationType","ko":"\uC6B4\uC601 \uC720\uD615","nb":"Operasjonstype","nl":"Type bewerking","pl":"Typ transakcji","pt-BR":"Tipo de opera\xe7\xe3o","pt-PT":"Tipo de opera\xe7\xe3o","ru":"\u0422\u0438\u043F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438","sv":"\xc5tg\xe4rdstyp","th":"\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23","tr":"\u0130\u015Flem Tipi","zh-Hans":"\u64CD\u4F5C\u7C7B\u578B","zh-Hant":"\u4F5C\u696D\u985E\u578B"},"RL_OperatorChangeRequest":{"ar":"\u0637\u0644\u0628 \u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0645\u0634\u063A\u0651\u0650\u0644","ca":"Sol\xb7licitudCanviOperador","comment":"OperatorChangeRequest","cs":"OperatorChangeRequest","da":"OperatorChangeRequest","de":"OperatorChangeRequest","el":"\u0391\u03AF\u03C4\u03B7\u03BC\u03B1 \u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2 \u03C7\u03B5\u03B9\u03C1\u03B9\u03C3\u03C4\u03AE","en":"OperatorChangeRequest","en-GB":"OperatorChangeRequest","en-XA":"[\xd6\xfe\xe9\u0155\xe5\u0163\xf6\u0155\xc7\u0125\xe5\xf1\u011D\xe9\u0154\xe9\u01EB\xfb\xe9\u0161\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Solicitud para cambiar de operador","es-AR":"SolicitudCambioOperador","es-ES":"Solicitudcambiooperador","es-MX":"Cambio a solicitud del Operador","fr":"DemandeModificationOp\xe9rateur","hu":"OperatorChangeRequest","id":"PermintaanPerubahanOperator","it":"OperatorChangeRequest","ja":"\u30AA\u30DA\u30EC\u30FC\u30BF\u5909\u66F4\u30EA\u30AF\u30A8\u30B9\u30C8","key":"RL_OperatorChangeRequest","ko":"\uC6B4\uC601\uC790 \uBCC0\uACBD \uC694\uCCAD","nb":"OperatorChangeRequest","nl":"Aanvraag voor operatorwissel","pl":"WniosekOperatoraOZmian\u0119","pt-BR":"OperatorChangeRequest","pt-PT":"PedidoDeAltera\xe7\xe3oDoOperador","ru":"OperatorChangeRequest","sv":"OperatorChangeRequest","th":"\u0E1C\u0E39\u0E49\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E04\u0E33\u0E02\u0E2D","tr":"Operat\xf6r De\u011Fi\u015Fim Talebi","zh-Hans":"OperatorChangeRequest","zh-Hant":"OperatorChangeRequest"},"RL_OrgDate":{"ar":"\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0627\u0644\u0623\u0633\u0627\u0633\u064A","ca":"Fecha Origen","comment":"Date of roriginal transaction","cs":"Puvodn\xed datum","da":"Original dato","de":"Original Datum","el":"\u0391\u03C1\u03C7\u03B9\u03BA\u03AE \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1","en":"Original Date","en-GB":"Original Date","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\xd0\xe5\u0163\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Fecha original","es-AR":"Fecha original","es-ES":"Fecha Origen","es-MX":"Fecha original","fr":"Date d\u2019origine","hu":"Original Date","id":"Tanggal Awal","it":"Data originale","ja":"\u8CA9\u58F2\u65E5","key":"RL_OrgDate","ko":"\uAE30\uC874 \uAD6C\uB9E4 \uC77C\uC790","nb":"Opprinnelig dato","nl":"Originele datum","pl":"Oryginalna data","pt-BR":"Data original","pt-PT":"Data original","ru":"\u0418\u0441\u0445\u043E\u0434\u043D\u0430\u044F \u0434\u0430\u0442\u0430","sv":"Ursprungligt datum","th":"\u0E27\u0E31\u0E19\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"Orijinal Tarih","zh-Hans":"\u539F\u59CB\u65E5\u671F","zh-Hant":"\u539F\u59CB\u65E5\u671F"},"RL_OrgPrice":{"ar":"\u0627\u0644\u0633\u0639\u0631 \u0627\u0644\u0623\u0635\u0644\u064A","ca":"Precio orig.","comment":"Original price of the item","cs":"Puvodn\xed cena","da":"Original pris","de":"Original Preis","el":"\u0391\u03C1\u03C7\u03B9\u03BA\u03AE \u03C4\u03B9\u03BC\u03AE","en":"Original Price","en-GB":"Original Price","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\xde\u0155\xee\xe7\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Precio original","es-AR":"Precio original","es-ES":"Precio orig.","es-MX":"Precio original","fr":"Prix Original","hu":"Original Price","id":"Harga Asal","it":"Prezzo originale","ja":"\u306E\u4FA1\u683C\u5909\u66F4\u3000\u5143\u306E\u4FA1\u683C\u3000\u3000 ","key":"RL_OrgPrice","ko":"\uC815\uAC00","nb":"Original pris","nl":"Originele Prijs","pl":"Cena pierwotna","pt-BR":"Pre\xe7o original","pt-PT":"Preco Original","ru":"\u0418\u0441\u0445\u043E\u0434\u043D\u0430\u044F \u0446\u0435\u043D\u0430","sv":"Originalpris","th":"\u0E23\u0E32\u0E04\u0E32\u0E40\u0E14\u0E34\u0E21","tr":"Orijinal Fiyat","zh-Hans":"\u539F\u4EF7","zh-Hant":"\u539F\u59CB\u50F9\u683C"},"RL_OrgRegNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u0623\u0633\u0627\u0633\u064A","ca":"N\xfamero Caja Origen","comment":"Original register number used","cs":"Puvodn\xed c. registru","da":"Originalt kasseapparatsnr","de":"Original-Kasse nummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B1\u03C1\u03C7\u03B9\u03BA\u03BF\u03CD \u03C4\u03B1\u03BC\u03B5\u03AF\u03BF\u03C5","en":"Original Register Number","en-GB":"Original Register Number","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\u0154\xe9\u011D\xee\u0161\u0163\xe9\u0155\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero original de caja reg.","es-AR":"N\xfamero original de caja reg","es-ES":"N\xfamero Caja Origen","es-MX":"N\xfamero original de caja reg.","fr":"No. caisse d\u2019origine","hu":"Original Register Number","id":"Nomor Registrasi Awal","it":"Numero registrazione originale","ja":"\u8CA9\u58F2\u30EC\u30B8\u756A\u53F7","key":"RL_OrgRegNumber","ko":"\uAE30\uC874 POS No","nb":"Opprinnelig kassenummer","nl":"Origineel Kassa Nummer","pl":"Oryginalny numer kasy","pt-BR":"N\xfamero de registro original","pt-PT":"N\xfamero de registo original","ru":"\u0418\u0441\u0445\u043E\u0434\u043D\u044B\u0439 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440","sv":"Ursprungligt registreringsnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19\u0E40\u0E14\u0E34\u0E21","tr":"Orijinal Kasa Numaras\u0131","zh-Hans":"\u539F\u59CB\u6CE8\u518C\u7F16\u53F7","zh-Hant":"\u539F\u59CB\u8A3B\u518A\u7DE8\u865F"},"RL_OrgStoreNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0645\u062A\u062C\u0631 \u0627\u0644\u0623\u0633\u0627\u0633\u064A","ca":"N\xfamero Tienda Origen","comment":"Original store number used","cs":"Puvodn\xed c. prodejny","da":"Originalt butiksnr","de":"Original Store-Nummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B1\u03C1\u03C7\u03B9\u03BA\u03BF\u03CD \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2","en":"Original Store Number","en-GB":"Original Store Number","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\u0160\u0163\xf6\u0155\xe9\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero original de tienda","es-AR":"N\xfamero original de tienda","es-ES":"N\xfamero Tienda Origen","es-MX":"N\xfamero original de tienda","fr":"No. magasin original","hu":"Original Store Number","id":"Nomor Toko Awal","it":"Numero negozio originale","ja":"\u8CA9\u58F2\u5E97\u8217\u756A\u53F7","key":"RL_OrgStoreNumber","ko":"\uC6D0\uB9E4\uC7A5 \uBC88\uD638","nb":"Opprinnelig butikknummer","nl":"Origineel Winkelnummer","pl":"Oryginalny numer sklepu","pt-BR":"N\xfamero da loja original","pt-PT":"N\xfamero da loja original","ru":"\u0418\u0441\u0445. \u043D\u043E\u043C\u0435\u0440 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430","sv":"Ursprungligt butiksnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E23\u0E49\u0E32\u0E19\u0E40\u0E14\u0E34\u0E21","tr":"Orijinal Ma\u011Faza Numaras\u0131","zh-Hans":"\u539F\u59CB\u5546\u5E97\u7F16\u53F7","zh-Hant":"\u539F\u59CB\u9580\u5E02\u7DE8\u865F"},"RL_OrgTransaction":{"ar":"\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629","ca":"Operaci\xf3n Origen","comment":"Original transation details","cs":"Puvodn\xed transakce","da":"Original transaktion","de":"Original-Transaktion","el":"\u0391\u03C1\u03C7\u03B9\u03BA\u03AE \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE","en":"Original Transaction","en-GB":"Original Transaction","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Transacci\xf3n original","es-AR":"Transacci\xf3n original","es-ES":"Operaci\xf3n Origen","es-MX":"Transacci\xf3n original","fr":"Trans. d\u2019origine","hu":"Original Transaction","id":"Transaksi Awal","it":"Transazione originale","ja":"\u8CA9\u58F2\u756A\u53F7","key":"RL_OrgTransaction","ko":"\uAE30\uC874 \uC601\uC218 No","nb":"Opprinnelig transaksjon","nl":"Originele transactie","pl":"Oryginalna transakcja","pt-BR":"Transa\xe7\xe3o original","pt-PT":"Transa\xe7\xe3o original","ru":"\u0418\u0441\u0445\u043E\u0434\u043D\u0430\u044F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F","sv":"Ursprunglig transaktion","th":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E40\u0E14\u0E34\u0E21","tr":"Orijinal \u0130\u015Flem","zh-Hans":"\u539F\u59CB\u4EA4\u6613","zh-Hant":"\u539F\u59CB\u4EA4\u6613\u7D30\u7BC0"},"RL_OrigInvoiceNo":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629","ca":"N.\xba factura orig.","comment":"Abbreviation for Original Transaction Invoice No","cs":"Orig Invoice No","da":"Orig fakturanr","de":"Orig Invoice No","el":"\u0391\u03C1. \u03B1\u03C1\u03C7\u03B9\u03BA\u03BF\u03CD \u03C4\u03B9\u03BC\u03BF\u03BB\u03BF\u03B3\u03AF\u03BF\u03C5","en":"Orig Invoice No","en-GB":"Orig Invoice No.","en-XA":"[\xd6\u0155\xee\u011D\u2002\xce\xf1\u1E7D\xf6\xee\xe7\xe9\u2002\xd1\xf6\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N.\xba de factura orig","es-AR":"N.\xba de factura orig","es-ES":"Factura Orig n\xba","es-MX":"N.\xba de factura orig","fr":"Orig Invoice No","hu":"Orig Invoice No","id":"No. Faktur Asli","it":"Orig Invoice No","ja":"Orig Invoice No","key":"RL_OrigInvoiceNo","ko":"\uC6D0\uBCF8 \uC1A1\uC7A5 \uBC88\uD638","nb":"Originalt fakturanr.","nl":"Orig Invoice No","pl":"Nr pierwotnej faktury","pt-BR":"N\xfamero original da fatura","pt-PT":"Orig Invoice No","ru":"Orig Invoice No","sv":"Urspr. fakturanr","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E14\u0E34\u0E21","tr":"Orij Fatura No","zh-Hans":"\u539F\u59CB\u53D1\u7968\u53F7","zh-Hant":"\u539F\u59CB\u767C\u7968\u865F\u78BC"},"RL_OriginalTransactionNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629 \u0627\u0644\u0623\u0633\u0627\u0633\u064A\u0629","ca":"N\xfamero de la transacci\xf3 original","comment":"Original Transaction Number","cs":"\u010C\xedslo p\u016Fvodn\xed transakce","da":"Oprindeligt transaktionsnummer","de":"Urspr\xfcngliche Transaktionsnummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Original Transaction Number","en-GB":"Original Transaction Number","en-XA":"[\xd6\u0155\xee\u011D\xee\xf1\xe5\u013C\u2002\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\xe5\u0180\xe7\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de transacci\xf3n original","es-AR":"N\xfamero de transacci\xf3n original","es-ES":"N\xfamero de transacci\xf3n original","es-MX":"N\xfamero de la transacci\xf3n original","fr":"Num\xe9ro de transaction d\'origine","hu":"Eredeti tranzakci\xf3s sz\xe1m","id":"Nomor Transaksi Awal","it":"Numero della transazione originale","ja":"\u521D\u56DE\u53D6\u5F15\u756A\u53F7","key":"RL_OriginalTransactionNumber","ko":"\uAE30\uC874 \uAC70\uB798 \uBC88\uD638","nb":"Opprinnelig transaksjonsnummer","nl":"Origineel transactienummer","pl":"Oryginalny numer transakcji","pt-BR":"N\xfamero da transa\xe7\xe3o original","pt-PT":"N\xfamero da transa\xe7\xe3o original","ru":"\u041D\u043E\u043C\u0435\u0440 \u0438\u0441\u0445\u043E\u0434\u043D\u043E\u0439 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Ursprungligt transaktionsnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E40\u0E14\u0E34\u0E21","tr":"Orijinal \u0130\u015Flem Numaras\u0131","zh-Hans":"\u539F\u59CB\u4EA4\u6613\u7F16\u53F7","zh-Hant":"\u539F\u59CB\u4EA4\u6613\u7DE8\u865F"},"RL_Original_CreditNote":{"ar":"\u0625\u0634\u0639\u0627\u0631 \u0628\u0627\u0644\u0631\u0635\u064A\u062F \u0627\u0644\u0623\u0635\u0644\u064A\u0651","ca":"NOTA D\'ABONAMENT ORIGINAL","comment":"ORIGINAL CREDIT NOTE","cs":"Origin\xe1ln\xed dobropis","da":"ORIGINAL KREDITNOTE","de":"ORIGINALE GUTSCHRIFT","el":"\u0391\u03A1\u03A7\u0399\u039A\u039F \u03A0\u0399\u03A3\u03A4\u03A9\u03A4\u0399\u039A\u039F \u03A3\u0397\u039C\u0395\u0399\u03A9\u039C\u0391","en":"ORIGINAL CREDIT NOTE","en-GB":"ORIGINAL CREDIT NOTE","en-XA":"[\xd6\u0154\xce\u011C\xce\xd1\xc5\u013B\u2002\xc7\u0154\xc9\xd0\xce\u0162\u2002\xd1\xd6\u0162\xc9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"NOTA DE CR\xc9DITO ORIGINAL","es-AR":"NOTA DE CR\xc9DITO ORIGINAL","es-ES":"NOTA DE CR\xc9DITO ORIGINAL","es-MX":"NOTA DE CR\xc9DITO ORIGINAL","fr":"NOTE DE CR\xc9DIT D\'ORIGINE","hu":"EREDET J\xd3V\xc1\xcdR\xc1SI \xc9RTES\xcdT\xc9S","id":"CATATAN KREDIT ASLI","it":"NOTA DI CREDITO ORIGINALE","ja":"\u30AF\u30EC\u30B8\u30C3\u30C8\u30CE\u30FC\u30C8\u306E\u539F\u672C","key":"RL_Original_CreditNote","ko":"\uC2E0\uC6A9 \uC804\uD45C \uC6D0\uBCF8","nb":"OPPRINNELIG KREDITNOTA","nl":"ORIGINELE TEGOEDBON","pl":"ORYGINALNA NOTA KREDYTOWA","pt-BR":"NOTA DE CR\xc9DITO ORIGINAL","pt-PT":"NOTA DE CR\xc9DITO ORIGINAL","ru":"\u0418\u0421\u0425\u041E\u0414\u041D\u041E\u0415 \u041A\u0420\u0415\u0414\u0418\u0422\u041E\u0412\u041E\u0415 \u0410\u0412\u0418\u0417\u041E","sv":"URSPRUNGLIG KREDITNOTA","th":"\u0E43\u0E1A\u0E25\u0E14\u0E2B\u0E19\u0E35\u0E49\u0E40\u0E14\u0E34\u0E21","tr":"OR\u0130J\u0130NAL KRED\u0130 NOTU","zh-Hans":"\u539F\u59CB\u4FE1\u7528\u7968\u636E","zh-Hant":"\u6298\u8B93\u55AE\u6B63\u672C"},"RL_Original_Invoice":{"ar":"\u0627\u0644\u0641\u0627\u062A\u0648\u0631\u0629 \u0627\u0644\u0623\u0635\u0644\u064A\u0629/\u0627\u0644\u0625\u064A\u0635\u0627\u0644 \u0627\u0644\u0623\u0635\u0644\u064A\u0651","ca":"REBUT / FACTURA ORIGINAL","comment":"ORIGINAL INVOICE/RECEIPT","cs":"ORIGIN\xc1LN\xcd FAKTURA/DOKLAD","da":"ORIGINAL FAKTURA/KVITTERING","de":"ORIGINALRECHNUNG/-BELEG","el":"\u0391\u03A1\u03A7\u0399\u039A\u039F \u03A4\u0399\u039C\u039F\u039B\u039F\u0393\u0399\u039F/\u0391\u03A1\u03A7\u0399\u039A\u0397 \u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397","en":"ORIGINAL INVOICE/RECEIPT","en-GB":"ORIGINAL INVOICE/RECEIPT","en-XA":"[\xd6\u0154\xce\u011C\xce\xd1\xc5\u013B\u2002\xce\xd1\u1E7C\xd6\xce\xc7\xc9\u2044\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"RECIBO/FACTURA ORIGINAL","es-AR":"FACTURA/RECIBO ORIGINAL","es-ES":"FACTURA/RECIBO ORIGINAL","es-MX":"FACTURA/RECIBO ORIGINAL","fr":"FACTURE/RE\xc7U D\'ORIGINE","hu":"EREDETI SZ\xc1MLA","id":"FAKTUR/TANDA TERIMA ASLI","it":"FATTURA/RICEVUTA ORIGINALE","ja":"\u30A4\u30F3\u30DC\u30A4\u30B9/\u30EC\u30B7\u30FC\u30C8\u306E\u539F\u672C","key":"RL_Original_Invoice","ko":"\uC1A1\uC7A5/\uC601\uC218\uC99D \uC6D0\uBCF8","nb":"ORIGINAL FAKTURA/KVITTERING","nl":"ORIGINELE FACTUUR/BON","pl":"ORYG. FAKTURA/PARAGON","pt-BR":"FATURA/RECIBO ORIGINAL","pt-PT":"FATURA/RECIBO ORIGINAL","ru":"\u041E\u0420\u0418\u0413\u0418\u041D\u0410\u041B \u0421\u0427\u0415\u0422\u0410/\u0427\u0415\u041A\u0410","sv":"URSPRUNGLIG FAKTURA/KVITTO","th":"\u0E43\u0E1A\u0E01\u0E33\u0E01\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32/\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E14\u0E31\u0E49\u0E07\u0E40\u0E14\u0E34\u0E21","tr":"OR\u0130J\u0130NAL FATURA/MAKBUZ","zh-Hans":"\u539F\u59CB\u53D1\u7968/\u6536\u636E","zh-Hant":"\u767C\u7968/\u6536\u64DA\u6B63\u672C"},"RL_Other":{"ar":"\u063A\u064A\u0631 \u0630\u0644\u0643 ","ca":"Altres","comment":"Other ","cs":"Jin\xe9","da":"Andet ","de":"Sonstige","el":"\u0386\u03BB\u03BB\u03BF ","en":"Other ","en-GB":"Other ","en-XA":"[\xd6\u0163\u0125\xe9\u0155\u2002\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Otro","es-AR":"Otro","es-ES":"Otros","es-MX":"Otro ","fr":"Autre","hu":"Egy\xe9b","id":"Lainnya ","it":"Altro","ja":"\u305D\u306E\u4ED6","key":"RL_Other","ko":"\uAE30\uD0C0","nb":"Annet ","nl":"Anders ","pl":"Inne","pt-BR":"Outros","pt-PT":"Outro","ru":"\u0414\u0440\u0443\u0433\u043E\u0435","sv":"Annat ","th":"\u0E2D\u0E37\u0E48\u0E19\u0E46","tr":"Di\u011Fer","zh-Hans":"\u5176\u4ED6","zh-Hant":"\u5176\u4ED6"},"RL_OtherCredit":{"ar":"\u0631\u0635\u064A\u062F \u0622\u062E\u0631","ca":"Altres tipus de cr\xe8dit","comment":"Other Credit","cs":"Jin\xfd z\u016Fstatek","da":"Andet tilgodehavende","de":"Andere Gutschrift","el":"\u0386\u03BB\u03BB\u03B7 \u03C0\u03AF\u03C3\u03C4\u03C9\u03C3\u03B7","en":"Other Credit","en-GB":"Other Credit","en-XA":"[\xd6\u0163\u0125\xe9\u0155\u2002\xc7\u0155\xe9\xf0\xee\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Otros cr\xe9ditos","es-AR":"Otros cr\xe9ditos","es-ES":"Otros sistemas de cr\xe9dito","es-MX":"Cr\xe9dito","fr":"Autre carte de cr\xe9dit","hu":"Egy\xe9b j\xf3v\xe1\xedr\xe1s","id":"Kredit Lainnya","it":"Altra forma di credito","ja":"\u305D\u306E\u4ED6\u306E\u30AF\u30EC\u30B8\u30C3\u30C8","key":"RL_OtherCredit","ko":"\uAE30\uD0C0 \uD06C\uB808\uB527","nb":"Annen kreditt","nl":"Ander tegoed","pl":"Inny rodzaj uznania konta","pt-BR":"Outro cr\xe9dito","pt-PT":"Outros tipos de pagamento a cr\xe9dito","ru":"\u0414\u0440\u0443\u0433\u043E\u0439 \u0432\u0438\u0434 \u043A\u0440\u0435\u0434\u0438\u0442\u0430","sv":"Annat kreditkort","th":"\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E2D\u0E37\u0E48\u0E19\u0E46","tr":"Di\u011Fer Kredi","zh-Hans":"\u5176\u4ED6\u4FE1\u7528\u5361","zh-Hant":"\u5176\u4ED6\u4FE1\u7528\u5361"},"RL_PANSeq":{"ar":"\u062A\u0633\u0644\u0633\u0644 \u0631\u0642\u0645 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0623\u0633\u0627\u0633\u064A","ca":"PANSeq","comment":"PAN sequence number","cs":"PANSeq","da":"PANSeq","de":"PANSeq","el":"PANSeq","en":"PANSeq","en-GB":"PANSeq","en-XA":"[\xde\xc5\xd1\u0160\xe9\u01EB\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"PANSeq","es-AR":"PANSeq","es-ES":"PANSeq","es-MX":"PANSeq","fr":"PANSeq","hu":"PANSeq","id":"PANSeq","it":"PANSeq","ja":"PANSeq","key":"RL_PANSeq","ko":"PANSeq","nb":"PANSeq","nl":"PANSeq","pl":"PANSeq","pt-BR":"PANSeq","pt-PT":"Sequ\xeancia PAN","ru":"PANSeq","sv":"Kontokortsnummer (PAN)","th":"\u0E25\u0E33\u0E14\u0E31\u0E1A PAN","tr":"PANSeq","zh-Hans":"PAN \u5E8F\u5217\u53F7","zh-Hant":"\u4E3B\u5E33\u865F\u5E8F\u5217"},"RL_PackagePrice":{"ar":"\u0633\u0639\u0631 \u0627\u0644\u062D\u0632\u0645\u0629","ca":"Preu del paquet","comment":"The price of a fixed price promotion. \\nFor e.g  buy N for $60. Here the price of all the items in the package will total to 60. ","cs":"Cena bal\xed\u010Dku","da":"Pakkepris","de":"Paketpreis","el":"\u03A4\u03B9\u03BC\u03AE \u03B4\u03AD\u03BC\u03B1\u03C4\u03BF\u03C2","en":"Package Price","en-GB":"Package Price","en-XA":"[\xde\xe5\xe7\u0137\xe5\u011D\xe9\u2002\xde\u0155\xee\xe7\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Precio del paquete","es-AR":"Precio del paquete","es-ES":"Precio de paquete","es-MX":"Precio del paquete","fr":"Total de l\'offre","hu":"Csomag \xe1ra","id":"Harga paket","it":"Prezzo pacchetto","ja":"\u4E00\u62EC\u4FA1\u683C","key":"RL_PackagePrice","ko":"\uD328\uD0A4\uC9C0 \uAC00\uACA9","nb":"Pakkepris","nl":"Prijs van pakket","pl":"Cena paczki","pt-BR":"Pre\xe7o do pacote","pt-PT":"Pre\xe7o do pacote","ru":"\u0426\u0435\u043D\u0430 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430","sv":"Paketpris","th":"\u0E23\u0E32\u0E04\u0E32\u0E41\u0E1E\u0E04\u0E40\u0E01\u0E08","tr":"Ambalaj Fiyat\u0131","zh-Hans":"\u7EC4\u5408\u4EF7","zh-Hant":"\u7E3D\u50F9\u683C"},"RL_Phone":{"ar":"\u0627\u0644\u0647\u0627\u062A\u0641","ca":"TEL\xc9FONO","comment":"Phone field in receipt","cs":"Tel","da":"Telefon","de":"Telefon","el":"\u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF","en":"Phone","en-GB":"Phone","en-XA":"[\xde\u0125\xf6\xf1\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tel\xe9fono","es-AR":"Tel\xe9fono","es-ES":"Telf","es-MX":"Tel\xe9fono","fr":"T\xe9l.","hu":"Phone","id":"Telepon","it":"Telefono","ja":"\u96FB\u8A71\u756A\u53F7","key":"RL_Phone","ko":"Tel","nb":"Telefonnummer","nl":"Telefoonnummer","pl":"Nr telefonu","pt-BR":"Telefone","pt-PT":"N.\xba de telefone","ru":"\u0422\u0435\u043B\u0435\u0444\u043E\u043D","sv":"Telefon","th":"\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C","tr":"Telefon","zh-Hans":"\u7535\u8BDD\u53F7\u7801","zh-Hant":"\u96FB\u8A71\u865F\u78BC"},"RL_PostalCode":{"ar":"\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064A\u062F\u064A","ca":"C\xf3digo Postal","comment":"Postal code field","cs":"PSC","da":"Postnummer","de":"Postleihzahl","el":"\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2","en":"Postal Code","en-GB":"Postcode","en-XA":"[\xde\xf6\u0161\u0163\xe5\u013C\u2002\xc7\xf6\xf0\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"C\xf3digo postal","es-AR":"C\xf3digo postal","es-ES":"C\xf3digo Postal","es-MX":"C\xf3digo postal","fr":"Postal Code","hu":"Postal Code","id":"Kode Pos","it":"Codice Postale","ja":"\u90F5\u4FBF\u756A\u53F7","key":"RL_PostalCode","ko":"\uC6B0\uD3B8\uBC88\uD638","nb":"Postnummer","nl":"Postcode","pl":"Kod pocztowy","pt-BR":"C\xf3digo postal","pt-PT":"C\xf3digo postal","ru":"\u041F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u0438\u043D\u0434\u0435\u043A\u0441","sv":"Postnummer","th":"\u0E23\u0E2B\u0E31\u0E2A\u0E44\u0E1B\u0E23\u0E29\u0E13\u0E35\u0E22\u0E4C","tr":"Posta Kodu","zh-Hans":"\u90AE\u653F\u7F16\u7801","zh-Hant":"\u90F5\u905E\u5340\u865F"},"RL_PrefName":{"ar":"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0645\u0641\u0636\u0644","ca":"PrefName","comment":"Preferred name","cs":"PrefName","da":"PrefName","de":"PrefName","el":"PrefName","en":"PrefName","en-GB":"PrefName","en-XA":"[\xde\u0155\xe9\u0192\xd1\xe5\u0271\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"PrefName","es-AR":"PrefName","es-ES":"PrefName","es-MX":"PrefName","fr":"PrefName","hu":"PrefName","id":"PrefName","it":"PrefName","ja":"PrefName","key":"RL_PrefName","ko":"\uAE30\uBCF8 \uC124\uC815 \uC774\uB984","nb":"PrefName","nl":"PrefName","pl":"PrefName","pt-BR":"PrefName","pt-PT":"Nome preferido","ru":"PrefName","sv":"\xd6nskat namn","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E35\u0E22\u0E01","tr":"PrefName","zh-Hans":"\u9996\u9009\u540D\u79F0","zh-Hant":"\u5225\u540D"},"RL_PriceOverride":{"ar":"\u062A\u062C\u0627\u0648\u064F\u0632 \u0627\u0644\u0633\u0639\u0631","ca":"Reemplazo de Precio","comment":"Price Override","cs":"Zmena ceny","da":"Pristilsides\xe6ttelse","de":"Preis \xe4ndern","el":"\u03A0\u03B1\u03C1\u03AC\u03BA\u03B1\u03BC\u03C8\u03B7 \u03C4\u03B9\u03BC\u03AE\u03C2","en":"Price Override","en-GB":"Price Override","en-XA":"[\xde\u0155\xee\xe7\xe9\u2002\xd6\u1E7D\xe9\u0155\u0155\xee\xf0\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Anulaci\xf3n de precio","es-AR":"Anulaci\xf3n de precio","es-ES":"Reemplazo de Precio","es-MX":"Anulaci\xf3n de precio","fr":"Modif. man. du prix","hu":"Price Override","id":"Penggantian Harga","it":"Modifica Prezzo","ja":"\u4FA1\u683C\u4E0A\u66F8\u304D","key":"RL_PriceOverride","ko":"\uAC00\uACA9 \uC7AC\uC124\uC815","nb":"Prisoverstyring","nl":"Verander prijs","pl":"Zmiana ceny","pt-BR":"Substitui\xe7\xe3o de pre\xe7o","pt-PT":"Alterar Pre\xe7o","ru":"\u041F\u0435\u0440\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u0446\u0435\u043D\u044B","sv":"\xc4ndra Pris","th":"\u0E40\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A\u0E23\u0E32\u0E04\u0E32","tr":"Fiyat Ge\xe7ersiz K\u0131lma","zh-Hans":"\u4EF7\u683C\u91CD\u6574","zh-Hant":"\u50F9\u683C\u66FF\u63DB"},"RL_PriceOvr":{"ar":"\u062A\u062C\u0627\u0648\u064F\u0632 \u0627\u0644\u0633\u0639\u0631 \u0639\u0644\u0649 \u0627\u0644\u0645\u0646\u062A\u062C \u0631\u0642\u0645","ca":"Cambio de precio de Art. No","comment":"price ovverride applied on item","cs":"Zmena ceny u c. polozky","da":"Overskriv vare","de":"Preis\xfcberschreibung f\xfcr Item Nr","el":"\u03A0\u03B1\u03C1\u03AC\u03BA\u03B1\u03BC\u03C8\u03B7 \u03C4\u03B9\u03BC\u03AE\u03C2 \u03C3\u03B5 \u03B1\u03C1. \u03B5\u03AF\u03B4\u03BF\u03C5\u03C2","en":"Price Override on Item No","en-GB":"Price Override on Item No.","en-XA":"[\xde\u0155\xee\xe7\xe9\u2002\xd6\u1E7D\xe9\u0155\u0155\xee\xf0\xe9\u2002\xf6\xf1\u2002\xce\u0163\xe9\u0271\u2002\xd1\xf6\u2002\xe5\u0180\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Anulaci\xf3n de precio en art\xedculo N.\xba","es-AR":"Anulaci\xf3n de precio en art\xedculo N.\xba","es-ES":"Cambio de precio de Art. No","es-MX":"Anulaci\xf3n de precio en art\xedculo N.\xba","fr":"Modif. Prix sur Article N\xb0","hu":"Price Override on Item No","id":"Penggantian Harga pada Nomor Item","it":"Modifcare prezzo articolo No","ja":"\u30A2\u30A4\u30C6\u30E0\u756A\u53F7","key":"RL_PriceOvr","ko":"\uAC00\uACA9 \uC7AC\uC124\uC815 \uD488\uBAA9 \uBC88\uD638","nb":"Prisoverstyring p\xe5 varenummer","nl":"Prijswiziging op artikel nr","pl":"Nadpisanie ceny produktu nr","pt-BR":"Substitui\xe7\xe3o de pre\xe7o no n\xfamero do item","pt-PT":"Alterar Preco no Item Nr","ru":"\u041F\u0435\u0440\u0435\u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u0446\u0435\u043D\u044B \u0442\u043E\u0432\u0430\u0440\u0430 \u2116","sv":"Pris\xe4ndring p\xe5 Art.nr","th":"\u0E40\u0E02\u0E35\u0E22\u0E19\u0E17\u0E31\u0E1A\u0E23\u0E32\u0E04\u0E32\u0E02\u0E2D\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02","tr":"\xdcr\xfcn No\'da Fiyat\u0131 Ge\xe7ersiz K\u0131lma","zh-Hans":"\u8FDB\u884C\u4EF7\u683C\u66FF\u6362\u7684\u5546\u54C1\u7F16\u53F7","zh-Hant":"\u5546\u54C1\u7DE8\u865F\u50F9\u683C\u66FF\u63DB"},"RL_Print":{"ar":"\u0637\u0628\u0627\u0639\u0629","ca":"Imprimeix","comment":"Print the receipt ","cs":"Tisk","da":"Udskriv","de":"Drucken","el":"\u0395\u03BA\u03C4\u03CD\u03C0\u03C9\u03C3\u03B7","en":"Print","en-GB":"Print","en-XA":"[\xde\u0155\xee\xf1\u0163\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Imprimir","es-AR":"Imprimir","es-ES":"Imprimir","es-MX":"Imprimir","fr":"Imprimer","hu":"Nyomtat\xe1s","id":"Cetak","it":"Stampa","ja":"\u5370\u5237","key":"RL_Print","ko":"\uD504\uB9B0\uD2B8","nb":"Skriv ut","nl":"Printen","pl":"Drukuj","pt-BR":"Imprimir","pt-PT":"Imprimir","ru":"\u041F\u0435\u0447\u0430\u0442\u044C","sv":"Skriv ut","th":"\u0E1E\u0E34\u0E21\u0E1E\u0E4C","tr":"Yazd\u0131r","zh-Hans":"\u6253\u5370","zh-Hant":"\u5217\u5370"},"RL_PrintEJ":{"ar":"\u0637\u0628\u0627\u0639\u0629 EJ","ca":"Imprimeix l\'EJ","comment":"Print ","cs":"Vytisknout EJ","da":"Udskriv EJ","de":"EJ drucken","el":"\u0395\u03BA\u03C4\u03CD\u03C0\u03C9\u03C3\u03B7 EJ","en":"Print EJ","en-GB":"Print EJ","en-XA":"[\xde\u0155\xee\xf1\u0163\u2002\xc9\u0134\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Imprimir EJ","es-AR":"Imprimir EJ","es-ES":"Imprimir EJ","es-MX":"Imprimir EJ","fr":"Imprimer EJ","hu":"Elektronikus napl\xf3 nyomtat\xe1sa","id":"Cetak EJ","it":"Stampa EJ","ja":"EJ\u3092\u5370\u5237","key":"RL_PrintEJ","ko":"EJ \uC778\uC1C4","nb":"Skriv ut EJ","nl":"Print EJ","pl":"Drukuj EJ","pt-BR":"Imprimir EJ","pt-PT":"Imprimir registo eletr\xf3nico","ru":"\u041F\u0435\u0447\u0430\u0442\u044C \u0436\u0443\u0440\u043D\u0430\u043B\u0430","sv":"Skriv ut EJ","th":"\u0E1E\u0E34\u0E21\u0E1E\u0E4C EJ","tr":"EJ\'yi Yazd\u0131r","zh-Hans":"\u6253\u5370 EJ","zh-Hant":"\u5217\u5370 EJ"},"RL_Proceed":{"ar":"\u0645\u062A\u0627\u0628\u0639\u0629","ca":"Continua","comment":"Prompting user to Proceed with an action in the UI. ","cs":"Pokra\u010Dovat","da":"Forts\xe6t","de":"Fortfahren","el":"\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1","en":"Proceed","en-GB":"Proceed","en-XA":"[\xde\u0155\xf6\xe7\xe9\xe9\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Continuar","es-AR":"Continuar","es-ES":"Continuar","es-MX":"Continuar","fr":"Continuer","hu":"Tov\xe1bb","id":"Lanjutkan","it":"Continua","ja":"\u7D9A\u3051\u308B","key":"RL_Proceed","ko":"\uC9C4\uD589","nb":"Fortsett","nl":"Verder","pl":"Kontynuuj","pt-BR":"Continuar","pt-PT":"Prosseguir","ru":"\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C","sv":"Forts\xe4tt","th":"\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","tr":"Devam Et","zh-Hans":"\u7EE7\u7EED","zh-Hant":"\u7E7C\u7E8C"},"RL_Promotion":{"ar":"\u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u062A\u0631\u0648\u064A\u062C\u064A","ca":"Promoci\xf3","comment":"Identify promotions in EJ","cs":"Promoakce","da":"Kampagne","de":"Angebot","el":"\u03A0\u03C1\u03BF\u03CE\u03B8\u03B7\u03C3\u03B7","en":"Promotion","en-GB":"Promotion","en-XA":"[\xde\u0155\xf6\u0271\xf6\u0163\xee\xf6\xf1\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Promoci\xf3n","es-AR":"Promoci\xf3n","es-ES":"Promoci\xf3n","es-MX":"Promoci\xf3n","fr":"Promotion","hu":"Prom\xf3ci\xf3","id":"Promosi","it":"Promozione","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3","key":"RL_Promotion","ko":"\uD504\uB85C\uBAA8\uC158","nb":"Kampanje","nl":"Promotie","pl":"Promocja","pt-BR":"Promo\xe7\xe3o","pt-PT":"Promo\xe7\xe3o","ru":"\u0410\u043A\u0446\u0438\u044F","sv":"Kampanj","th":"\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr":"Promosyon","zh-Hans":"\u4FC3\u9500","zh-Hant":"\u4FC3\u92B7"},"RL_PromotionBlockEnd":{"ar":"\u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u062A\u0631\u0648\u064A\u062C\u064A \u0644\u0644\u0645\u062C\u0645\u0648\u0639\u0629","ca":"Promoci\xf3 de fi de grup","comment":"End of group promotion block","cs":"Konec skupiny promoakc\xed","da":"Gruppekampagne er overst\xe5et","de":"Ende des Gruppenangebots","el":"\u03A4\u03B5\u03C1\u03BC\u03B1\u03C4\u03B9\u03C3\u03BC\u03CC\u03C2 \u03BF\u03BC\u03B1\u03B4\u03B9\u03BA\u03AE\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en":"End of Group Promotion","en-GB":"End of Group Promotion","en-XA":"[\xc9\xf1\xf0\u2002\xf6\u0192\u2002\u011C\u0155\xf6\xfb\xfe\u2002\xde\u0155\xf6\u0271\xf6\u0163\xee\xf6\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Finalizaci\xf3n de la promoci\xf3n grupal","es-AR":"Finalizaci\xf3n de la promoci\xf3n grupal","es-ES":"Promoci\xf3n de final de grupo","es-MX":"Promoci\xf3n de fin de grupo","fr":"Promotion fin de groupe","hu":"Csoportos prom\xf3ci\xf3 v\xe9ge","id":"Akhir Promosi Grup","it":"Promozione gruppo terminata","ja":"\u30B0\u30EB\u30FC\u30D7\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306F\u3053\u3053\u307E\u3067","key":"RL_PromotionBlockEnd","ko":"\uADF8\uB8F9 \uD504\uB85C\uBAA8\uC158 \uC885\uB8CC","nb":"Slutt p\xe5 kampanjegruppe","nl":"Einde van groepspromotie","pl":"Koniec promocji grupowej","pt-BR":"Fim da promo\xe7\xe3o em grupo","pt-PT":"Promo\xe7\xe3o de fim de grupo","ru":"\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0435 \u043E\u0431\u0449\u0435\u0439 \u0430\u043A\u0446\u0438\u0438","sv":"Slut f\xf6r gruppkampanj","th":"\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E41\u0E1A\u0E1A\u0E01\u0E25\u0E38\u0E48\u0E21","tr":"Grup Promosyonu Sonu","zh-Hans":"\u7CFB\u5217\u4FC3\u9500\u7ED3\u675F","zh-Hant":"\u5718\u9AD4\u4FC3\u92B7\u7D50\u675F"},"RL_PromotionName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u0639\u0631\u0636 \u0627\u0644\u062A\u0631\u0648\u064A\u062C\u064A","ca":"Nombre de Promo","comment":"Promotion name","cs":"N\xe1zev promoakce","da":"Navn p\xe5 reklame","de":"Bezeichnung der Promotion","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en":"Promotion Name","en-GB":"Promotion Name","en-XA":"[\xde\u0155\xf6\u0271\xf6\u0163\xee\xf6\xf1\u2002\xd1\xe5\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre de la promoci\xf3n","es-AR":"Nombre de la promoci\xf3n","es-ES":"Nombre de Promo","es-MX":"Nombre de la promoci\xf3n","fr":"Nom. Promo","hu":"Promotion Name","id":"Nama Promosi","it":"Nome promozione","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u540D ","key":"RL_PromotionName","ko":"\uD504\uB85C\uBAA8\uC158 \uC774\uB984","nb":"Kampanjenavn","nl":"Naam promotie","pl":"Nazwa promocji","pt-BR":"Nome da promo\xe7\xe3o","pt-PT":"Nome da promo\xe7\xe3o","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u0438","sv":"Kampanjnamn","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr":"Promosyon Ad\u0131","zh-Hans":"\u4FC3\u9500\u540D\u79F0","zh-Hant":"\u4FC3\u92B7\u540D\u7A31"},"RL_PublicKey":{"ar":"\u0645\u0641\u062A\u0627\u062D \u0639\u0627\u0645","ca":"Clau p\xfablica","comment":"Public Key for TSE signature on the Germany receipts","cs":"PublicKey","da":"OffentligN\xf8gle","de":"\xd6ffentlicher Schl\xfcssel","el":"\u0394\u03B7\u03BC\u03CC\u03C3\u03B9\u03BF \u03BA\u03BB\u03B5\u03B9\u03B4\u03AF","en":"PublicKey","en-GB":"PublicKey","en-XA":"[\xde\xfb\u0180\u013C\xee\xe7\u0136\xe9\xfd\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"PublicKey","es-AR":"Clave p\xfablica","es-ES":"Clave p\xfablica","es-MX":"PublicKey","fr":"PublicKey","hu":"Nyilv\xe1nos kulcs","id":"PublicKey","it":"PublicKey","ja":"\u516C\u958B\u30AD\u30FC","key":"RL_PublicKey","ko":"\uD37C\uBE14\uB9AD\uD0A4","nb":"PublicKey","nl":"PublicKey","pl":"Klucz publiczny","pt-BR":"PublicKey","pt-PT":"Chave p\xfablica","ru":"\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0439 \u043A\u043B\u044E\u0447","sv":"Offentlig nyckel","th":"PublicKey","tr":"Ortak Anahtar","zh-Hans":"\u516C\u5171\u5BC6\u94A5","zh-Hant":"\u516C\u958B\u91D1\u9470"},"RL_PurchaserName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u0645\u0634\u062A\u0631\u064A","ca":"Nombre del Comprador","comment":"Purchaser name","cs":"Jm\xe9no z\xe1kazn\xedka","da":"K\xf8bers navn","de":"Kundenname / K\xe4ufername","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03B1\u03B3\u03BF\u03C1\u03B1\u03C3\u03C4\u03AE","en":"Purchaser Name","en-GB":"Purchaser Name","en-XA":"[\xde\xfb\u0155\xe7\u0125\xe5\u0161\xe9\u0155\u2002\xd1\xe5\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre del comprador","es-AR":"Nombre del comprador","es-ES":"Nombre del Comprador","es-MX":"Nombre del comprador","fr":"Nom de l\u2019acheteur","hu":"Purchaser Name","id":"Nama Pembeli","it":"Nome acquirente","ja":"\u304A\u5BA2\u69D8\u540D","key":"RL_PurchaserName","ko":"\uAD6C\uB9E4\uC790 \uC774\uB984","nb":"Kj\xf8pers navn","nl":"Naam Koper","pl":"Purchaser Name","pt-BR":"Nome do comprador","pt-PT":"Nome do comprador","ru":"\u0418\u043C\u044F \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F","sv":"Kundnamn","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E0B\u0E37\u0E49\u0E2D","tr":"Al\u0131c\u0131 Ad\u0131","zh-Hans":"\u9886\u8D27\u4EBA","zh-Hant":"\u8CFC\u8CB7\u8005\u59D3\u540D"},"RL_QRCode":{"ar":"\u0631\u0645\u0632 QR","ca":"Codi QR","comment":"QR Code on the receipt.","cs":"QR k\xf3d","da":"QR-kode","de":"QR-Code","el":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 QR","en":"QR Code","en-GB":"QR code","en-XA":"[\u01EA\u0154\u2002\xc7\xf6\xf0\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"C\xf3digo QR","es-AR":"C\xf3digo QR","es-ES":"C\xf3digo QR","es-MX":"C\xf3digo QR","fr":"Code QR","hu":"QR-k\xf3d","id":"Kode QR","it":"Codice QR","ja":"QR\u30B3\u30FC\u30C9","key":"RL_QRCode","ko":"QR \uCF54\uB4DC","nb":"QR-kode","nl":"QR-code","pl":"Kod QR","pt-BR":"C\xf3digo QR","pt-PT":"C\xf3digo QR","ru":"QR-\u043A\u043E\u0434","sv":"QR-kod","th":"\u0E04\u0E34\u0E27\u0E2D\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14","tr":"QR Kodu","zh-Hans":"\u4E8C\u7EF4\u7801","zh-Hant":"QR \u78BC"},"RL_Quantity":{"ar":"\u0627\u0644\u0643\u0645\u064A\u0629","ca":"Quantitat","comment":"Quantity of items purchased","cs":"Po\u010Det","da":"Antal","de":"Menge","el":"\u03A0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1","en":"Quantity","en-GB":"Quantity","en-XA":"[\u01EA\xfb\xe5\xf1\u0163\xee\u0163\xfd\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cantidad","es-AR":"Cantidad","es-ES":"Cantidad","es-MX":"Cantidad","fr":"Quantit\xe9","hu":"Mennyis\xe9g","id":"Kuantitas","it":"Quantit\xe0","ja":"\u6570\u91CF","key":"RL_Quantity","ko":"\uC218\uB7C9","nb":"Antall","nl":"Aantal","pl":"Ilo\u015B\u0107","pt-BR":"Quantidade","pt-PT":"Quantidade","ru":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E","sv":"Antal","th":"\u0E08\u0E33\u0E19\u0E27\u0E19","tr":"Adet","zh-Hans":"\u6570\u91CF","zh-Hant":"\u6578\u91CF"},"RL_REPRINT":{"ar":"\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0637\u0628\u0627\u0639\u0629","ca":"REIMPRIM","comment":"Header to identify the Reprinted receipt","cs":"P\u0158ETISK","da":"UDSKRIV IGEN","de":"HERPRINT","el":"\u0395\u03A0\u0391\u039D\u0395\u039A\u03A4\u03A5\u03A0\u03A9\u03A3\u0397","en":"REPRINT","en-GB":"REPRINT","en-XA":"[\u0154\xc9\xde\u0154\xce\xd1\u0162\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"VOLVER A IMPRIMIR","es-AR":"VOLVER A IMPRIMIR","es-ES":"REIMPRIM.","es-MX":"VOLVER A IMPRIMIR","fr":"REPRINT","hu":"REPRINT","id":"CETAK ULANG","it":"RISTAMPA","ja":"REPRINT","key":"RL_REPRINT","ko":"\uC7AC\uC778\uC1C4","nb":"OPPTRYKK","nl":"OPNIEUW AFDRUKKEN","pl":"REPRINT","pt-BR":"REIMPRESS\xc3O","pt-PT":"REIMPRIMIR","ru":"REPRINT","sv":"REPRINT","th":"\u0E1E\u0E34\u0E21\u0E1E\u0E4C\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","tr":"YEN\u0130DEN YAZDIR","zh-Hans":"\u91CD\u65B0\u6253\u5370","zh-Hant":"\u91CD\u65B0\u5217\u5370"},"RL_Reason":{"ar":"\u0627\u0644\u0633\u0628\u0628","ca":"Motiu","comment":"Reason","cs":"D\u016Fvod","da":"Begrundelse","de":"Grund","el":"\u0391\u03B9\u03C4\u03AF\u03B1","en":"Reason","en-GB":"Reason","en-XA":"[\u0154\xe9\xe5\u0161\xf6\xf1\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Motivo","es-AR":"Motivo","es-ES":"Motivo","es-MX":"Motivo","fr":"Motif","hu":"Indokl\xe1s","id":"Alasan","it":"Motivo","ja":"\u7406\u7531","key":"RL_Reason","ko":"\uC0AC\uC720","nb":"\xc5rsak","nl":"Reden","pl":"Pow\xf3d","pt-BR":"Motivo","pt-PT":"Motivo","ru":"\u041F\u0440\u0438\u0447\u0438\u043D\u0430","sv":"Sk\xe4l","th":"\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25","tr":"Neden","zh-Hans":"\u539F\u56E0","zh-Hant":"\u539F\u56E0"},"RL_Reason3":{"ar":"\u0627\u0644\u0633\u0628\u0628:","ca":"Motivo:","comment":"Reason:","cs":"Duvod:","da":"\xc5rsag:","de":"Grund:","el":"\u0391\u03B9\u03C4\u03AF\u03B1:","en":"Reason:","en-GB":"Reason:","en-XA":"[\u0154\xe9\xe5\u0161\xf6\xf1\u2236\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Motivo:","es-AR":"Motivo:","es-ES":"Motivo:","es-MX":"Motivo:","fr":"Motif :","hu":"Reason:","id":"Alasan:","it":"ragione:","ja":"\u7406\u7531:","key":"RL_Reason3","ko":"\uC0AC\uC720:","nb":"\xc5rsak:","nl":"Reden:","pl":"Pow\xf3d:","pt-BR":"Motivo:","pt-PT":"Motivo:","ru":"\u041F\u0440\u0438\u0447\u0438\u043D\u0430:","sv":"Orsak:","th":"\u0E40\u0E2B\u0E15\u0E38\u0E1C\u0E25","tr":"Neden:","zh-Hans":"\u539F\u56E0:","zh-Hant":"\u539F\u56E0:"},"RL_ReferenceNumber":{"ar":"\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u0631\u062C\u0639\u064A ","ca":"N\xfamero de refer\xe8ncia ","comment":"Reference number or the fiscal document number printed on the Austria receipts. ","cs":"Referen\u010Dn\xed \u010D\xedslo ","da":"Referencenummer ","de":"Referenznummer ","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2 ","en":"Reference Number ","en-GB":"Reference number ","en-XA":"[\u0154\xe9\u0192\xe9\u0155\xe9\xf1\xe7\xe9\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de referencia ","es-AR":"N\xfamero de referencia ","es-ES":"N\xfamero de referencia ","es-MX":"N\xfamero de referencia ","fr":"Num\xe9ro de r\xe9f\xe9rence ","hu":"Hivatkoz\xe1si sz\xe1m ","id":"Nomor Referensi ","it":"Numero di riferimento ","ja":"\u53C2\u7167\u756A\u53F7 ","key":"RL_ReferenceNumber","ko":"\uCC38\uC870 \uBC88\uD638 ","nb":"Referansenummer ","nl":"Referentienummer ","pl":"Numer referencyjny ","pt-BR":"N\xfamero de refer\xeancia ","pt-PT":"N\xfamero de refer\xeancia ","ru":"\u041D\u043E\u043C\u0435\u0440 \u0434\u043B\u044F \u043E\u0442\u0441\u043B\u0435\u0436\u0438\u0432\u0430\u043D\u0438\u044F ","sv":"Referensnummer ","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E2D\u0E49\u0E32\u0E07\u0E2D\u0E34\u0E07 ","tr":"Referans Numaras\u0131 ","zh-Hans":"\u53C2\u8003\u53F7 ","zh-Hant":"\u53C3\u8003\u7DE8\u865F "},"RL_Refund":{"ar":"\u0627\u0633\u062A\u0631\u062F\u0627\u062F \u0627\u0644\u0623\u0645\u0648\u0627\u0644","ca":"Reembolso","comment":"Refund","cs":" Vr\xe1cen\xed","da":"Refundering","de":"Verg\xfctung","el":"\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C7\u03C1\u03B7\u03BC\u03AC\u03C4\u03C9\u03BD","en":"Refund","en-GB":"Refund","en-XA":"[\u0154\xe9\u0192\xfb\xf1\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Reembolso","es-AR":"Reembolso","es-ES":"Reembolso","es-MX":"Reembolso","fr":"Remboursement","hu":"Refund","id":"Pengembalian Dana","it":"Rimborso","ja":"\u8FD4\u91D1","key":"RL_Refund","ko":"\uD658\uBD88","nb":"Refusjon","nl":"Terugbetaling","pl":"Zwrot.","pt-BR":"Reembolso","pt-PT":"Reembolsar","ru":"\u0412\u043E\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435","sv":"\xc5terbet.","th":"\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E40\u0E07\u0E34\u0E19","tr":"\xd6deme \u0130adesi","zh-Hans":"\u9000\u6B3E","zh-Hant":"\u9000\u6B3E"},"RL_Reg":{"ar":"\u0627\u0644\u062A\u0633\u062C\u064A\u0644","ca":"Caja.","comment":"Abbreviation for Register number","cs":"Pokladna","da":"Kasse","de":"RegVerz","el":"\u0391\u03C1. \u03C4\u03B1\u03BC\u03B5\u03AF\u03BF\u03C5","en":"Reg","en-GB":"Reg","en-XA":"[\u0154\xe9\u011D\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Caja","es-AR":"Caja","es-ES":"Caja","es-MX":"Caja","fr":"Caisse","hu":"Kassza","id":"Reg","it":"Cassa","ja":"\u30EC\u30B8","key":"RL_Reg","ko":"POS No","nb":"Kasse","nl":"Term","pl":"Kasa","pt-BR":"Reg","pt-PT":"Caixa registadora","ru":"\u041A\u0430\u0441\u0441\u0430","sv":"kassa","th":"\u0E40\u0E25\u0E02\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19","tr":"Kasa","zh-Hans":"\u6536\u94F6\u673A\u7F16\u53F7","zh-Hant":"\u6536\u9280\u6A5F\u7DE8\u865F"},"RL_Register":{"ar":"\u0627\u0644\u062A\u0633\u062C\u064A\u0644","ca":"Caixa","comment":"Regsiter being used","cs":"Pokladna","da":"Kasse","de":"Kasse","el":"\u03A4\u03B1\u03BC\u03B5\u03AF\u03BF","en":"Register","en-GB":"Register","en-XA":"[\u0154\xe9\u011D\xee\u0161\u0163\xe9\u0155\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Caja","es-AR":"Caja","es-ES":"Caja ","es-MX":"Caja","fr":"Caisse","hu":"Kassza","id":"Daftar","it":"Cassa","ja":"\u30EC\u30B8\u30B9\u30BF\u30FC","key":"RL_Register","ko":"POS No","nb":"Kasse","nl":"Kassa","pl":"Kasa","pt-BR":"Cadastrar-se","pt-PT":"Caixa registadora","ru":"\u041A\u0430\u0441\u0441\u0430","sv":"Registrera mig","th":"\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19","tr":"Kaydol","zh-Hans":"\u6536\u94F6\u673A","zh-Hant":"\u6536\u9280\u6A5F"},"RL_Requestedby":{"ar":"\u062A\u0645 \u0627\u0644\u0637\u0644\u0628 \u0645\u0650\u0646 \u0642\u0650\u0628\u0644","ca":"Solicitado por","comment":"Field in receipt indicates the person requested ","cs":"Vy\u017E\xe1d\xe1no k\xfdm","da":"P\xe5kr\xe6vet af","de":" angefordert","el":"\u0396\u03B7\u03C4\u03AE\u03B8\u03B7\u03BA\u03B5 \u03B1\u03C0\u03CC","en":"Requested by","en-GB":"Requested by","en-XA":"[\u0154\xe9\u01EB\xfb\xe9\u0161\u0163\xe9\xf0\u2002\u0180\xfd\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Solicitado por","es-AR":"Solicitado por","es-ES":"Solicitado por","es-MX":"Solicitado por","fr":"Demand\xe9 par","hu":"Requested by","id":"Diminta oleh","it":"Richiesto da","ja":"\u672C\u793E\u62C5\u5F53\u8005\u540D","key":"RL_Requestedby","ko":"\uC694\uCCAD\uC778","nb":"Forespurt av","nl":"Aangevraagd door","pl":"Requested by","pt-BR":"Solicitado por","pt-PT":"Pedido por","ru":"\u041A\u0435\u043C \u0437\u0430\u043F\u0440\u043E\u0448\u0435\u043D\u043E","sv":"Beg\xe4rd av","th":"\u0E23\u0E49\u0E2D\u0E07\u0E02\u0E2D\u0E42\u0E14\u0E22","tr":"Talep eden","zh-Hans":"\u7533\u8BF7\u4EBA","zh-Hant":"\u7D22\u53D6\u4EBA"},"RL_ResetSearch":{"ar":"\u0625\u0639\u0627\u062F\u0629 \u0636\u0628\u0637 \u0627\u0644\u0628\u062D\u062B ","ca":"Restableix la cerca","comment":"Reset the transaction search","cs":"Obnovit hled\xe1n\xed","da":"Nulstil s\xf8gning ","de":"Suche zur\xfccksetzen","el":"\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2 ","en":"Reset Search ","en-GB":"Reset Search ","en-XA":"[\u0154\xe9\u0161\xe9\u0163\u2002\u0160\xe9\xe5\u0155\xe7\u0125\u2002\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Restablecer b\xfasqueda","es-AR":"Restablecer b\xfasqueda","es-ES":"Restablecer b\xfasqueda","es-MX":"Restablecer b\xfasqueda ","fr":"R\xe9initialiser la recherche","hu":"Keres\xe9s vissza\xe1ll\xedt\xe1sa","id":"Reset Pencarian","it":"Reimposta ricerca","ja":"\u691C\u7D22\u6761\u4EF6\u3092\u30EA\u30BB\u30C3\u30C8","key":"RL_ResetSearch","ko":"\uAC80\uC0C9 \uCD08\uAE30\uD654","nb":"Tilbakestill s\xf8k ","nl":"Reset zoekopdracht ","pl":"Resetuj wyszukiwanie","pt-BR":"Redefinir pesquisa","pt-PT":"Repor a pesquisa","ru":"\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u043F\u043E\u0438\u0441\u043A\u0430","sv":"\xc5terst\xe4ll s\xf6kning","th":"\u0E23\u0E35\u0E40\u0E0B\u0E47\u0E15\u0E01\u0E32\u0E23\u0E04\u0E49\u0E19\u0E2B\u0E32","tr":"Aramay\u0131 S\u0131f\u0131rla","zh-Hans":"\u91CD\u7F6E\u641C\u7D22","zh-Hant":"\u91CD\u8A2D\u641C\u5C0B"},"RL_Restitution":{"ar":"\u0627\u0633\u062A\u0631\u062F\u0627\u062F","ca":"Compensaci\xf3n","comment":"Restitution","cs":"Obnoven\xed","da":"Kompensation","de":"Entsch\xe4digung","el":"\u0391\u03C0\u03BF\u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7","en":"Restitution","en-GB":"Restitution","en-XA":"[\u0154\xe9\u0161\u0163\xee\u0163\xfb\u0163\xee\xf6\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Restituci\xf3n","es-AR":"Restituci\xf3n","es-ES":"Compensaci\xf3n","es-MX":"Restituci\xf3n","fr":"Restitution","hu":"Restitution","id":"Restitusi","it":"Restituzione","ja":"\u640D\u5BB3\u8CE0\u511F","key":"RL_Restitution","ko":"\uBC18\uD658","nb":"Kompensasjon","nl":"Teruggave","pl":"Restytucja","pt-BR":"Restitui\xe7\xe3o","pt-PT":"Restitui\xe7\xe3o","ru":"\u0412\u043E\u0437\u043C\u0435\u0449\u0435\u043D\u0438\u0435","sv":"\xc5terbetalning","th":"\u0E01\u0E32\u0E23\u0E0A\u0E14\u0E43\u0E0A\u0E49\u0E04\u0E27\u0E32\u0E21\u0E40\u0E2A\u0E35\u0E22\u0E2B\u0E32\u0E22","tr":"\u0130ade Etme","zh-Hans":"\u6062\u590D","zh-Hant":"\u8CE0\u511F"},"RL_Resume":{"ar":"\u0627\u0633\u062A\u0626\u0646\u0627\u0641","ca":"Represes","comment":"Resumed transactions","cs":"Obnovit","da":"Genoptag","de":"Fortsetzen","el":"\u03A3\u03C5\u03BD\u03B5\u03C7\u03B9\u03C3\u03BC\u03AD\u03BD\u03B5\u03C2","en":"Resume","en-GB":"Resume","en-XA":"[\u0154\xe9\u0161\xfb\u0271\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Reanudada","es-AR":"Reanudar","es-ES":"Reanudado","es-MX":"Reanudar","fr":"Reprendre","hu":"Folytat\xe1s","id":"Lanjutkan","it":"Riprendi","ja":"\u518D\u958B","key":"RL_Resume","ko":"\uC7AC\uAC1C","nb":"Fortsett","nl":"Hervat","pl":"Wzn\xf3w","pt-BR":"Retomar","pt-PT":"Retomada","ru":"\u0412\u043E\u0437\u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C","sv":"\xc5teruppta","th":"\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D","tr":"S\xfcrd\xfcr","zh-Hans":"\u5DF2\u6062\u590D","zh-Hant":"\u7E7C\u7E8C"},"RL_ResumeTransaction":{"ar":"\u0627\u0633\u062A\u0626\u0646\u0627\u0641 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"Repr\xe8n la transacci\xf3","comment":"Resume Transaction","cs":"Obnovit transakci","da":"Genoptag transaktion","de":"Transaktion fortsetzen","el":"\u03A3\u03C5\u03BD\u03AD\u03C7\u03B9\u03C3\u03B7 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Resume Transaction","en-GB":"Resume Transaction","en-XA":"[\u0154\xe9\u0161\xfb\u0271\xe9\u2002\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Retomar la transacci\xf3n","es-AR":"Reanudar transacci\xf3n","es-ES":"Reanudar transacci\xf3n","es-MX":"Reanudar transacci\xf3n","fr":"Reprendre la transaction","hu":"Tranzakci\xf3 folytat\xe1sa","id":"Lanjutkan Transaksi","it":"Riprendi transazione","ja":"\u53D6\u5F15\u3092\u518D\u958B","key":"RL_ResumeTransaction","ko":"\uAC70\uB798 \uC7AC\uAC1C","nb":"Fortsett transaksjon","nl":"Hervat transactie","pl":"Wzn\xf3w transakcj\u0119","pt-BR":"Retomar transa\xe7\xe3o","pt-PT":"Retomar transa\xe7\xe3o","ru":"\u0412\u043E\u0437\u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E","sv":"\xc5teruppta transaktion","th":"\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E15\u0E48\u0E2D","tr":"\u0130\u015Flemi S\xfcrd\xfcr","zh-Hans":"\u6062\u590D\u4EA4\u6613","zh-Hant":"\u7E7C\u7E8C\u8655\u7406\u4EA4\u6613"},"RL_ReturnWOReceipt":{"ar":"\u0625\u0631\u062C\u0627\u0639 \u0645\u0646 \u062F\u0648\u0646 \u0625\u064A\u0635\u0627\u0644","ca":"Devoluci\xf3n Sin Tiquet","comment":"RETURN WITHOUT RECEIPT","cs":"VR\xc1CEN\xcd BEZ DOKLADU","da":"RETURNERING UDEN KVITTERING","de":"R\xfcckgabe ohne Quittung","el":"\u0395\u03A0\u0399\u03A3\u03A4\u03A1\u039F\u03A6\u0397 \u03A7\u03A9\u03A1\u0399\u03A3 \u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397","en":"RETURN WITHOUT RECEIPT","en-GB":"RETURN WITHOUT RECEIPT","en-XA":"[\u0154\xc9\u0162\xdb\u0154\xd1\u2002\u0174\xce\u0162\u0124\xd6\xdb\u0162\u2002\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"DEVOLUCI\xd3N SIN RECIBO","es-AR":"DEVOLUCI\xd3N SIN RECIBO","es-ES":"Devoluci\xf3n Sin Tiquet","es-MX":"DEVOLUCI\xd3N SIN RECIBO","fr":"RETOUR SANS RECU","hu":"RETURN WITHOUT RECEIPT","id":"PENGEMBALIAN TANPA TANDA TERIMA","it":"RESO SENZA RICEVUTA","ja":"\u30EC\u30B7\u30FC\u30C8\u306E\u306A\u3044\u8FD4\u54C1","key":"RL_ReturnWOReceipt","ko":"\uC601\uC218\uC99D \uC5C6\uB294 \uBC18\uD488","nb":"RETUR UTEN KVITTERING","nl":"RETOUR ZONDER BON","pl":"ZWROT BEZ PARAGONU","pt-BR":"DEVOLU\xc7\xc3O SEM RECIBO","pt-PT":"DEVOLU\xc7\xc3O SEM RECIBO","ru":"\u0412\u041E\u0417\u0412\u0420\u0410\u0422 \u0411\u0415\u0417 \u0427\u0415\u041A\u0410","sv":"CRETUR UTAN KVITTO","th":"\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E21\u0E35\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08","tr":"MAKBUZ OLMADAN \u0130ADE","zh-Hans":"\u65E0\u6536\u636E\u9000\u8D27","zh-Hant":"\u6C92\u6709\u6536\u64DA\u7684\u9000\u8CA8"},"RL_ReturnedReceipt":{"ar":"\u0625\u064A\u0635\u0627\u0644 \u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A \u0627\u0644\u062A\u064A \u062A\u0645\u062A \u0625\u0639\u0627\u062F\u062A\u0647\u0627","ca":"Tiquet Art\xedculos Devueltos","comment":"Items returned in receipted transations","cs":"Vr\xe1cen\xe9 prijat\xe9 polo\u017Eky","da":"Returneret bon varer","de":"Beleg umgetauschter Artikel","el":"\u03A0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2 \u03BC\u03B5 \u03B1\u03C0\u03CC\u03B4\u03B5\u03B9\u03BE\u03B7","en":"Returned Receipt Items","en-GB":"Returned Receipt Items","en-XA":"[\u0154\xe9\u0163\xfb\u0155\xf1\xe9\xf0\u2002\u0154\xe9\xe7\xe9\xee\xfe\u0163\u2002\xce\u0163\xe9\u0271\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Art\xedculos recibidos devueltos","es-AR":"Art\xedculos recibidos devueltos","es-ES":"Tiquet Art\xedculos Devueltos","es-MX":"Art\xedculos recibidos devueltos","fr":"Re\xe7u art.s retourn\xe9s","hu":"Returned Receipt Items","id":"Item di Tanda Terima yang Dikembalikan","it":"Ricevuta Articoli resi","ja":"\u8FD4\u54C1\u5546\u54C1","key":"RL_ReturnedReceipt","ko":"\uBC18\uD488 \uC81C\uD488","nb":"Kvittering for returnerte varer","nl":"Bon geretourneerde artikelen","pl":"Zwr\xf3cone przedmioty (paragon)","pt-BR":"Itens de Recebimento devolvidos","pt-PT":"Artigos em recibo devolvidos","ru":"\u0422\u043E\u0432\u0430\u0440\u044B, \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u043D\u044B\u0435 \u043F\u043E \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u043E\u0439","sv":"Returkvitto","th":"\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2A\u0E48\u0E07\u0E04\u0E37\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08","tr":"\u0130ade Edilen Makbuz \xdcr\xfcnleri","zh-Hans":"\u5DF2\u9000\u8D27\u5546\u54C1\u6536\u636E","zh-Hant":"\u5DF2\u9000\u8CA8\u54C1\u9805\u6536\u64DA"},"RL_ReusableToteL":{"ar":"\u0643\u064A\u0633 \u0642\u0627\u0628\u0644 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0628\u0645\u0642\u0627\u0633 \u0643\u0628\u064A\u0631","ca":"Bossa de m\xe0 reutilitzable (gran)","comment":"Reusable Tote bag of size L","cs":"Opakovan\u011B pou\u017Eiteln\xe1 ta\u0161ka L","da":"Genbrugelig mulepose L","de":"Wiederverwendbare Tragetasche L","el":"\u0395\u03C0\u03B1\u03BD\u03B1\u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B9\u03BC\u03B7 \u03C4\u03C3\u03AC\u03BD\u03C4\u03B1 \u03CE\u03BC\u03BF\u03C5 \u03C3\u03B5 \u03BC\u03AD\u03B3\u03B5\u03B8\u03BF\u03C2 Large","en":"Reusable Tote L","en-GB":"Reusable Tote L","en-XA":"[\u0154\xe9\xfb\u0161\xe5\u0180\u013C\xe9\u2002\u0162\xf6\u0163\xe9\u2002\u013B\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Bolsa tipo tote reutilizable L","es-AR":"Bolso de mano reutilizable L","es-ES":"Tote bag reutilizable de talla L","es-MX":"Bolsa tipo tote reutilizable grande","fr":"Cabas r\xe9utilisable taille L","hu":"\xdajrahaszn\xe1lhat\xf3 bev\xe1s\xe1rl\xf3t\xe1ska, L-es","id":"Reusable Tote L","it":"Borsa tote riutilizzabile L","ja":"\u30A8\u30B3\u30FC\u30C8\u30D0\u30C3\u30B0\uFF08L\uFF09","key":"RL_ReusableToteL","ko":"\uB9AC\uC720\uC800\uBE14 \uD1A0\uD2B8\uBC31 L","nb":"Gjenbrukbart b\xe6renett L","nl":"Herbruikbare tas L","pl":"Torba wielokrotnego u\u017Cytku (rozmiar L)","pt-BR":"Sacola reutiliz\xe1vel G","pt-PT":"Saco reutiliz\xe1vel L","ru":"\u041C\u043D\u043E\u0433\u043E\u0440\u0430\u0437\u043E\u0432\u0430\u044F \u0441\u0443\u043C\u043A\u0430-\u0442\u043E\u0443\u0442 (L)","sv":"Tote bag som kan \xe5teranv\xe4ndas (L)","th":"\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E30\u0E1E\u0E32\u0E22\u0E41\u0E1A\u0E1A\u0E43\u0E0A\u0E49\u0E0B\u0E49\u0E33\u0E44\u0E14\u0E49 \u0E44\u0E0B\u0E2A\u0E4C L","tr":"Yeniden Kullan\u0131labilir El \xc7antas\u0131 L","zh-Hans":"\u53EF\u91CD\u590D\u4F7F\u7528\u6258\u7279\u5305 L \u7801","zh-Hant":"\u53EF\u91CD\u8907\u4F7F\u7528\u6258\u7279\u5305\uFF0C\u5C3A\u5BF8 L"},"RL_ReusableToteM":{"ar":"\u0643\u064A\u0633 \u0642\u0627\u0628\u0644 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0628\u0645\u0642\u0627\u0633 \u0645\u062A\u0648\u0633\u0637","ca":"Bossa de m\xe0 reutilitzable (mitjana)","comment":"Reusable tote bag of size Medium","cs":"Opakovan\u011B pou\u017Eiteln\xe1 ta\u0161ka M","da":"Genbrugelig mulepose M","de":"Wiederverwendbare Tragetasche M","el":"\u0395\u03C0\u03B1\u03BD\u03B1\u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B9\u03BC\u03B7 \u03C4\u03C3\u03AC\u03BD\u03C4\u03B1 \u03CE\u03BC\u03BF\u03C5 \u03C3\u03B5 \u03BC\u03AD\u03B3\u03B5\u03B8\u03BF\u03C2 Medium","en":"Reusable Tote M","en-GB":"Reusable Tote M","en-XA":"[\u0154\xe9\xfb\u0161\xe5\u0180\u013C\xe9\u2002\u0162\xf6\u0163\xe9\u2002\u1E40\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Bolsa tipo tote reutilizable M","es-AR":"Bolso de mano reutilizable M","es-ES":"Tote bag reutilizable de talla M","es-MX":"Bolsa tipo tote reutilizable mediana","fr":"Cabas r\xe9utilisable taille M","hu":"\xdajrahaszn\xe1lhat\xf3 bev\xe1s\xe1rl\xf3t\xe1ska, M-es","id":"Reusable Tote M","it":"Borsa tote riutilizzabile M","ja":"\u30A8\u30B3\u30C8\u30FC\u30C8\u30D0\u30C3\u30B0\uFF08M\uFF09","key":"RL_ReusableToteM","ko":"\uB9AC\uC720\uC800\uBE14 \uD1A0\uD2B8\uBC31 M","nb":"Gjenbrukbart b\xe6renett M","nl":"Herbruikbare tas M","pl":"Torba wielokrotnego u\u017Cytku (rozmiar M)","pt-BR":"Sacola reutiliz\xe1vel M","pt-PT":"Saco reutiliz\xe1vel M","ru":"\u041C\u043D\u043E\u0433\u043E\u0440\u0430\u0437\u043E\u0432\u0430\u044F \u0441\u0443\u043C\u043A\u0430-\u0442\u043E\u0443\u0442 (M)","sv":"Tote bag som kan \xe5teranv\xe4ndas (M)","th":"\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E30\u0E1E\u0E32\u0E22\u0E41\u0E1A\u0E1A\u0E43\u0E0A\u0E49\u0E0B\u0E49\u0E33\u0E44\u0E14\u0E49 \u0E44\u0E0B\u0E2A\u0E4C M","tr":"Yeniden Kullan\u0131labilir El \xc7antas\u0131 M","zh-Hans":"\u53EF\u91CD\u590D\u4F7F\u7528\u6258\u7279\u5305 M \u7801","zh-Hant":"\u53EF\u91CD\u8907\u4F7F\u7528\u6258\u7279\u5305\uFF0C\u5C3A\u5BF8 M"},"RL_ReusableToteS":{"ar":"\u0643\u064A\u0633 \u0642\u0627\u0628\u0644 \u0644\u0625\u0639\u0627\u062F\u0629 \u0627\u0644\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0628\u0645\u0642\u0627\u0633 \u0635\u063A\u064A\u0631","ca":"Bossa de m\xe0 reutilitzable (petita)","comment":"Reusable Tote Bag of size Small","cs":"Opakovan\u011B pou\u017Eiteln\xe1 ta\u0161ka S","da":"Genbrugelig mulepose S","de":"Wiederverwendbare Tragetasche S","el":"\u0395\u03C0\u03B1\u03BD\u03B1\u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B9\u03BC\u03B7 \u03C4\u03C3\u03AC\u03BD\u03C4\u03B1 \u03CE\u03BC\u03BF\u03C5 \u03C3\u03B5 \u03BC\u03AD\u03B3\u03B5\u03B8\u03BF\u03C2 Small","en":"Reusable Tote S","en-GB":"Reusable Tote S","en-XA":"[\u0154\xe9\xfb\u0161\xe5\u0180\u013C\xe9\u2002\u0162\xf6\u0163\xe9\u2002\u0160\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Bolsa tipo tote reutilizable S","es-AR":"Bolso de mano reutilizable S","es-ES":"Tote bag reutilizable de talla S","es-MX":"Bolsa tipo tote reutilizable chica","fr":"Cabas r\xe9utilisable taille S","hu":"\xdajrahaszn\xe1lhat\xf3 bev\xe1s\xe1rl\xf3t\xe1ska, S-es","id":"Reusable Tote S","it":"Borsa tote riutilizzabile S","ja":"\u30A8\u30B3\u30C8\u30FC\u30C8\u30D0\u30C3\u30B0\uFF08S\uFF09","key":"RL_ReusableToteS","ko":"\uB9AC\uC720\uC800\uBE14 \uD1A0\uD2B8\uBC31 S","nb":"Gjenbrukbart b\xe6renett S","nl":"Herbruikbare tas S","pl":"Torba wielokrotnego u\u017Cytku (rozmiar S)","pt-BR":"Sacola reutiliz\xe1vel P","pt-PT":"Saco reutiliz\xe1vel S","ru":"\u041C\u043D\u043E\u0433\u043E\u0440\u0430\u0437\u043E\u0432\u0430\u044F \u0441\u0443\u043C\u043A\u0430-\u0442\u043E\u0443\u0442 (S)","sv":"Tote bag som kan \xe5teranv\xe4ndas (S)","th":"\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E30\u0E1E\u0E32\u0E22\u0E41\u0E1A\u0E1A\u0E43\u0E0A\u0E49\u0E0B\u0E49\u0E33\u0E44\u0E14\u0E49 \u0E44\u0E0B\u0E2A\u0E4C S","tr":"Yeniden Kullan\u0131labilir El \xc7antas\u0131 S","zh-Hans":"\u53EF\u91CD\u590D\u4F7F\u7528\u6258\u7279\u5305 S \u7801","zh-Hant":"\u53EF\u91CD\u8907\u4F7F\u7528\u6258\u7279\u5305\uFF0C\u5C3A\u5BF8 S"},"RL_ReviewTillContents":{"ar":"\u0645\u0631\u0627\u062C\u0639\u0629 \u0645\u062D\u062A\u0648\u0649 \u0635\u0646\u062F\u0648\u0642 \u0627\u0644\u062F\u0641\u0639","ca":"ComprovaContingutCaixaEnregistradora","comment":"ReviewTillContents","cs":"ReviewTillContents","da":"ReviewTillContents","de":"ReviewTillContents","el":"\u0388\u03BB\u03B5\u03B3\u03C7\u03BF\u03C2 \u03C0\u03B5\u03C1\u03B9\u03B5\u03C7\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD \u03C4\u03B1\u03BC\u03B5\u03B9\u03B1\u03BA\u03AE\u03C2","en":"ReviewTillContents","en-GB":"ReviewTillContents","en-XA":"[\u0154\xe9\u1E7D\xee\xe9\u0175\u0162\xee\u013C\u013C\xc7\xf6\xf1\u0163\xe9\xf1\u0163\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Contenidos para evaluar","es-AR":"Revisarcontenidocajaregistradora","es-ES":"Revisarcontenidocajaregistradora","es-MX":"Revisar contenido del Caj\xf3n","fr":"V\xe9rificationContenuCaisse","hu":"ReviewTillContents","id":"ReviewTillContents","it":"ReviewTillContents","ja":"\u30B3\u30F3\u30C6\u30F3\u30C4\u3078\u79FB\u52D5","key":"RL_ReviewTillContents","ko":"\uACB0\uC81C \uB0B4\uC5ED \uAC80\uD1A0","nb":"ReviewTillContents","nl":"Inhoud kassa controleren","pl":"Sprawdzi\u0107Zawarto\u015B\u0107Kasy","pt-BR":"ReviewTillContents","pt-PT":"ReverConte\xfadosDaCaixaRegistadora","ru":"ReviewTillContents","sv":"ReviewTillContents","th":"\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E08\u0E33\u0E19\u0E27\u0E19\u0E43\u0E19\u0E25\u0E34\u0E49\u0E19\u0E0A\u0E31\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19","tr":"Kasa \u0130\xe7eri\u011Fini \u0130ncele","zh-Hans":"ReviewTillContents","zh-Hant":"ReviewTillContents"},"RL_STORECOPY":{"ar":"\u0646\u0633\u062E\u0629 \u0627\u0644\u0645\u062A\u062C\u0631","ca":"COPIA TIENDA","comment":"Receipt header to indicate that the receipt is a copy for the store","cs":"KOPIE - PRODEJNA","da":"OPBEVAR KOPI","de":"SHOP-KOPIE","el":"\u0391\u039D\u03A4\u0399\u0393\u03A1\u0391\u03A6\u039F \u039A\u0391\u03A4\u0391\u03A3\u03A4\u0397\u039C\u0391\u03A4\u039F\u03A3","en":"STORE COPY","en-GB":"STORE COPY","en-XA":"[\u0160\u0162\xd6\u0154\xc9\u2002\xc7\xd6\xde\xdd\u2002\xe5\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"COPIA DE TIENDA","es-AR":"COPIA DE TIENDA","es-ES":"COPIA TIENDA","es-MX":"COPIA DE TIENDA","fr":"EXEMPLAIRE MAGASIN","hu":"STORE COPY","id":"SALINAN TOKO","it":"COPIA PUNTO VENDITA","ja":"\u5E97\u8217\u63A7\u3048","key":"RL_STORECOPY","ko":"\uB9E4\uC7A5\uC6A9 \uC0AC\uBCF8","nb":"BUTIKKEKSEMPLAR","nl":"EXEMPLAAR VOOR DE STORE","pl":"KOPIA DLA SKLEPU","pt-BR":"C\xd3PIA DA LOJA","pt-PT":"C\xd3PIA DA LOJA","ru":"STORE COPY","sv":"BUTIKSKOPIA","th":"\u0E2A\u0E33\u0E40\u0E19\u0E32\u0E23\u0E49\u0E32\u0E19","tr":"MA\u011EAZA KOPYASI","zh-Hans":"\u5546\u5E97\u526F\u672C","zh-Hant":"\u5546\u5E97\u806F"},"RL_SUSPEND_TRAN":{"ar":"\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"SUSPENDER TRANS","comment":"The line in receipt to indicate the suspended transaction","cs":"Odlo\u017Eit transakci","da":"SUSPENDER TRANSAKTION","de":"TRANSAKTION AUFHEBEN","el":"\u0391\u039D\u0391\u03A3\u03A4\u039F\u039B\u0397 \u03A3\u03A5\u039D\u0391\u039B\u039B\u0391\u0393\u0397\u03A3","en":"SUSPEND TRANSACTION","en-GB":"SUSPEND TRANSACTION","en-XA":"[\u0160\xdb\u0160\xde\xc9\xd1\xd0\u2002\u0162\u0154\xc5\xd1\u0160\xc5\xc7\u0162\xce\xd6\xd1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"SUSPENDER TRANSACCI\xd3N","es-AR":"SUSPENDER TRANSACCI\xd3N","es-ES":"SUSPENDER TRANS","es-MX":"SUSPENDER TRANSACCI\xd3N","fr":"SUSPENDRE LA TRANSACTION","hu":"SUSPEND TRANSACTION","id":"TRANSAKSI YANG DITANGGUHKAN","it":"SOSPENDI TRANSAZIONE","ja":"\u4FDD\u7559","key":"RL_SUSPEND_TRAN","ko":"\uAC70\uB798 \uC815\uC9C0","nb":"SUSPENDER TRANSAKSJON","nl":"TRANSACTIE ONDERBREKE","pl":"ZAWIE\u015A TRANSAKCJ","pt-BR":"TRANSA\xc7\xc3O SUSPENSA","pt-PT":"SUSPENDER TRANSA\xc7\xc3O","ru":"SUSPEND TRANSACTION","sv":"SKJUT UPP TRANSAKTION","th":"\u0E23\u0E30\u0E07\u0E31\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"\u0130\u015ELEM\u0130 ASKIYA AL","zh-Hans":"\u6682\u505C\u4EA4\u6613","zh-Hant":"\u66AB\u7DE9\u4EA4\u6613"},"RL_Sale":{"ar":"\u0627\u0644\u0628\u064A\u0639","ca":"Venda","comment":"Sale transaction. ","cs":"V\xfdprodej","da":"Udsalg","de":"Sale","el":"\u03A0\u03CE\u03BB\u03B7\u03C3\u03B7","en":"Sale","en-GB":"Sale","en-XA":"[\u0160\xe5\u013C\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Rebajas","es-AR":"Rebajas","es-ES":"Venta","es-MX":"Venta","fr":"Vente","hu":"\xc9rt\xe9kes\xedt\xe9s","id":"Penjualan","it":"Vendita","ja":"\u30BB\u30FC\u30EB","key":"RL_Sale","ko":"\uD560\uC778","nb":"Salg","nl":"Sale","pl":"Sprzeda\u017C","pt-BR":"Venda","pt-PT":"Venda","ru":"\u0420\u0430\u0441\u043F\u0440\u043E\u0434\u0430\u0436\u0430","sv":"Rea","th":"\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32","tr":"Sat\u0131\u015F","zh-Hans":"\u9500\u552E","zh-Hant":"\u7279\u60E0"},"RL_Search":{"ar":"\u0627\u0644\u0628\u062D\u062B","ca":"Cerca","comment":"Search for a transaction","cs":"Hledat","da":"S\xf8g","de":"Suchen","el":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7","en":"Search","en-GB":"Search","en-XA":"[\u0160\xe9\xe5\u0155\xe7\u0125\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Buscar","es-AR":"Buscar","es-ES":"Buscar","es-MX":"Buscar","fr":"Rechercher","hu":"Keres\xe9s","id":"Cari","it":"Cerca","ja":"\u691C\u7D22","key":"RL_Search","ko":"\uAC80\uC0C9","nb":"S\xf8k","nl":"Zoek","pl":"Szukaj","pt-BR":"Pesquisar","pt-PT":"Pesquisar","ru":"\u041F\u043E\u0438\u0441\u043A","sv":"S\xf6k","th":"\u0E04\u0E49\u0E19\u0E2B\u0E32","tr":"Ara","zh-Hans":"\u641C\u7D22","zh-Hant":"\u641C\u5C0B"},"RL_SerialNum":{"ar":"\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u062A\u0633\u0644\u0633\u0644","ca":"N\xfam. de s\xe8rie","comment":"Serial number abbreviation","cs":"S\xe9riov\xe9 \u010D\xedslo","da":"Serienummer","de":"Seriennr.","el":"\u03A3\u03B5\u03B9\u03C1\u03B9\u03B1\u03BA\u03CC\u03C2 \u03B1\u03C1.","en":"Serial Num","en-GB":"Serial Num","en-XA":"[\u0160\xe9\u0155\xee\xe5\u013C\u2002\xd1\xfb\u0271\u2002\xe5\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N.\xba de serie","es-AR":"N\xfam. de serie:","es-ES":"N.\xba de serie","es-MX":"N\xb0 de serie","fr":"N\xb0 de s\xe9rie","hu":"Sorozatsz\xe1m","id":"No. Seri","it":"Numero di serie","ja":"\u30B7\u30EA\u30A2\u30EB\u756A\u53F7","key":"RL_SerialNum","ko":"\uC77C\uB828\uBC88\uD638","nb":"Serienr.","nl":"Serienr.","pl":"Nr seryjny","pt-BR":"N\xfamero de s\xe9rie","pt-PT":"N\xfamero de s\xe9rie","ru":"\u0421\u0435\u0440\u0438\u0439\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440","sv":"Serienummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E0B\u0E35\u0E40\u0E23\u0E35\u0E22\u0E25","tr":"Seri Num","zh-Hans":"\u5E8F\u5217\u53F7","zh-Hant":"\u5E8F\u865F"},"RL_ShipStore":{"ar":"\u0644\u0644\u0634\u062D\u0646 - \u0627\u0644\u0645\u062A\u062C\u0631","ca":"Env\xedo - Tienda","comment":"To be shipped - Store","cs":"Chcete-li b\xfdt dod\xe1v\xe1ny - Store","da":"Klar til afsendelse - Store","de":"Lieferanschrift - Store","el":"\u03A0\u03C1\u03BF\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE - \u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1","en":"To be shipped - Store","en-GB":"To be delivered \u2013 Store","en-XA":"[\u0162\xf6\u2002\u0180\xe9\u2002\u0161\u0125\xee\xfe\xfe\xe9\xf0\u2002\u2010\u2002\u0160\u0163\xf6\u0155\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Para enviar: Tienda","es-AR":"Para enviar: Tienda","es-ES":"Env\xedo - Tienda","es-MX":"Para enviar: Tienda","fr":"\xc0 exp\xe9dier - Magasin","hu":"To be shipped - Store","id":"Akan dikirim - Toko","it":"Da spedire - Negozio","ja":"\u767A\u9001\u6E96\u5099\u4E2D - \u5E97\u8217","key":"RL_ShipStore","ko":"\uBC30\uC1A1 \uC608\uC815 - \uB9E4\uC7A5","nb":"Skal sendes \u2013 butikk","nl":"Wordt verzonden - Store","pl":"Do wysy\u0142ki - Sklep","pt-BR":"A ser enviado \u2013 Loja","pt-PT":"Por enviar - Store","ru":"\u041A \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0435\xa0\u2014 \u043C\u0430\u0433\u0430\u0437\u0438\u043D","sv":"Por enviar - Store","th":"\u0E15\u0E49\u0E2D\u0E07\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07 - \u0E23\u0E49\u0E32\u0E19","tr":"Kargoya verilecek - Ma\u011Faza","zh-Hans":"\u5F85\u914D\u9001 - \u5546\u5E97","zh-Hant":"\u5F85\u51FA\u8CA8 \u2013 \u5546\u5E97"},"RL_ShipTo":{"ar":"\u0627\u0644\u0634\u062D\u0646 \u0625\u0644\u0649","ca":"Enviar a","comment":"Line in receipt indicating the destination address of native tax exempt transaction","cs":"Preprava do","da":"Send til","de":"Versand an","el":"\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u03C0\u03C1\u03BF\u03C2","en":"Ship To","en-GB":"Deliver To","en-XA":"[\u0160\u0125\xee\xfe\u2002\u0162\xf6\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Enviar a","es-AR":"ENVIAR A","es-ES":"Enviar a","es-MX":"Enviar a","fr":"SHIP TO","hu":"Ship To","id":"Kirim Ke","it":"Indirizzo spedizione","ja":"\u914D\u9001\u5148","key":"RL_ShipTo","ko":"\uBC1C\uC1A1 \uB300\uC0C1","nb":"Send til","nl":"Verzendadres","pl":"Wysy\u0142ka na adres","pt-BR":"Enviar para","pt-PT":"Enviar para","ru":"\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u044C","sv":"Leveransadress","th":"\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E44\u0E1B\u0E17\u0E35\u0E48","tr":"Kargo Adresi","zh-Hans":"\u914D\u9001\u5730\u5740","zh-Hant":"\u5BC4\u9001\u81F3"},"RL_ShippingAmount":{"ar":"\u0642\u064A\u0645\u0629 \u0627\u0644\u0634\u062D\u0646","ca":"ctdad Env\xedo","comment":"Amount  for shipping","cs":"\u010C\xe1stka p\u0159epravy","da":"Transportbel\xf8b","de":"Versand Summe","el":"\u03A0\u03BF\u03C3\u03CC \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2","en":"Shipping Amount","en-GB":"Shipping Amount","en-XA":"[\u0160\u0125\xee\xfe\xfe\xee\xf1\u011D\u2002\xc5\u0271\xf6\xfb\xf1\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Monto de env\xedo","es-AR":"Monto de env\xedo","es-ES":"ctdad Env\xedo","es-MX":"Monto de env\xedo","fr":"Montant exp\xe9dition","hu":"Shipping Amount","id":"Jumlah Pengiriman","it":"Importo spedizione","ja":"\u914D\u9001\u91D1\u984D","key":"RL_ShippingAmount","ko":"\uBC30\uC1A1 \uAE08\uC561","nb":"Sendingsbel\xf8p","nl":"Verzendkosten","pl":"Koszt wysy\u0142ki","pt-BR":"Valor da remessa","pt-PT":"Montante do envio","ru":"\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438","sv":"Frakt","th":"\u0E23\u0E32\u0E04\u0E32\u0E04\u0E48\u0E32\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07","tr":"Kargo Tutar\u0131","zh-Hans":"\u8FD0\u8D39\u91D1\u989D","zh-Hant":"\u904B\u9001\u91D1\u984D"},"RL_ShippingCOPY":{"ar":"\u0646\u0633\u062E\u0629 \u0627\u0644\u0634\u062D\u0646","ca":"COPIA Env\xedo","comment":"Receipt header for the shipping copy receipt","cs":"Preprava KOPIE","da":"Forsendelse af KOPI","de":"Kopie der Lieferung","el":"\u0391\u039D\u03A4\u0399\u0393\u03A1\u0391\u03A6\u039F \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2","en":"Shipping COPY","en-GB":"Shipping COPY","en-XA":"[\u0160\u0125\xee\xfe\xfe\xee\xf1\u011D\u2002\xc7\xd6\xde\xdd\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"COPIA para el env\xedo","es-AR":"COPIA para el env\xedo","es-ES":"COPIA Env\xedo","es-MX":"COPIA de env\xedo","fr":"EXEMPLAIRE Expedition","hu":"Shipping COPY","id":"SALINAN Pengiriman","it":"COPIA di spedizione","ja":"\u914D\u9001\u63A7\u3048","key":"RL_ShippingCOPY","ko":"\uBC30\uC1A1 \uC0AC\uBCF8","nb":"Leveranseeksemplar","nl":"Kopie verzending","pl":"Wysy\u0142ka (KOPIA)","pt-BR":"C\xd3PIA de envio","pt-PT":"C\xd3PIA de envio","ru":"\u041A\u041E\u041F\u0418\u042F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438","sv":"Leverans KOPIA","th":"\u0E2A\u0E33\u0E40\u0E19\u0E32\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07","tr":"Kargo KOPYASI","zh-Hans":"\u914D\u9001\u526F\u672C","zh-Hant":"\u904B\u9001\u526F\u672C"},"RL_ShippingItems":{"ar":"\u0627\u0644\u0645\u0646\u062A\u062C\u0627\u062A \u0644\u0644\u0634\u062D\u0646","ca":"Art\xedculos del env\xedo","comment":"Items being shipped","cs":"Preprava polo\u017Eek","da":"Forsendelsesvarer","de":"Versand Artikel","el":"\u0395\u03AF\u03B4\u03B7 \u03C0\u03C1\u03BF\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE","en":"Shipping Items","en-GB":"Shipping Items","en-XA":"[\u0160\u0125\xee\xfe\xfe\xee\xf1\u011D\u2002\xce\u0163\xe9\u0271\u0161\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Art\xedculos para enviar","es-AR":"Art\xedculos para enviar","es-ES":"Env\xedo de Art\xedculos","es-MX":"Art\xedculos del env\xedo","fr":"Exp\xe9dition art.s","hu":"Shipping Items","id":"Item yang Dikirim","it":"Articoli di spedizione","ja":"\u914D\u9001\u5546\u54C1","key":"RL_ShippingItems","ko":"\uBC30\uC1A1 \uC0C1\uD488","nb":"Sender varer","nl":"Items verzenden","pl":"Przedmioty do wysy\u0142ki","pt-BR":"Itens de Remessa","pt-PT":"Artigos a enviar","ru":"\u041E\u0442\u043F\u0440\u0430\u0432\u043A\u0430 \u0442\u043E\u0432\u0430\u0440\u043E\u0432","sv":"Produkter att leverera","th":"\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07","tr":"Kargo \xdcr\xfcnleri","zh-Hans":"\u914D\u9001\u5546\u54C1","zh-Hant":"\u904B\u9001\u54C1\u9805"},"RL_ShippingMethod":{"ar":"\u0637\u0631\u064A\u0642\u0629 \u0627\u0644\u0634\u062D\u0646","ca":"Metodo de Envio","comment":"Method used for shipping","cs":"Zp\u016Fsob dopravy","da":"Forsendelsesmetode","de":"Liefermethode","el":"\u03A4\u03C1\u03CC\u03C0\u03BF\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2","en":"Shipping Method","en-GB":"Shipping Method","en-XA":"[\u0160\u0125\xee\xfe\xfe\xee\xf1\u011D\u2002\u1E40\xe9\u0163\u0125\xf6\xf0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"M\xe9todo de env\xedo","es-AR":"M\xe9todo de env\xedo","es-ES":"Metodo de Envio","es-MX":"M\xe9todo de env\xedo","fr":"Mode d\'Expe","hu":"Shipping Method","id":"Metode Pengiriman","it":"Metodo di spedizione","ja":"\u914D\u9001\u65B9\u6CD5","key":"RL_ShippingMethod","ko":"\uBC30\uC1A1 \uBC29\uBC95","nb":"Leveringsmetode","nl":"Verzendmethode","pl":"Metoda dostawy","pt-BR":"M\xe9todo de envio","pt-PT":"M\xe9todo de envio","ru":"\u0421\u043F\u043E\u0441\u043E\u0431 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438","sv":"Leveranss\xe4tt","th":"\u0E27\u0E34\u0E18\u0E35\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07","tr":"Kargo Y\xf6ntemi","zh-Hans":"\u914D\u9001\u65B9\u5F0F","zh-Hant":"\u904B\u9001\u65B9\u5F0F"},"RL_ShipppingInfo":{"ar":"\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u0627\u0644\u0634\u062D\u0646","ca":"Informacion de Envio","comment":"Shipping information block","cs":"Info o doprave","da":"Vareflytnings Information","de":"Versandinformationen","el":"\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE\u03C2","en":"Shipping Information","en-GB":"Shipping Information","en-XA":"[\u0160\u0125\xee\xfe\xfe\xee\xf1\u011D\u2002\xce\xf1\u0192\xf6\u0155\u0271\xe5\u0163\xee\xf6\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Informaci\xf3n de env\xedo","es-AR":"Informaci\xf3n de env\xedo","es-ES":"Informacion de Envio","es-MX":"Informaci\xf3n de env\xedo","fr":"Informations d\'Expe","hu":"Shipping Information","id":"Informasi Pengiriman","it":"Informazioni Spedizione","ja":"\u914D\u9001\u60C5\u5831","key":"RL_ShipppingInfo","ko":"\uBC30\uC1A1 \uC815\uBCF4","nb":"Leveringsinformasjon","nl":"Verzendgegevens","pl":"Informacje o wysy\u0142ce","pt-BR":"Informa\xe7\xf5es de envio","pt-PT":"Informa\xe7\xf5es de envio","ru":"\u0410\u0434\u0440\u0435\u0441 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0438","sv":"Leveransinformation","th":"\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","tr":"Kargo Bilgileri","zh-Hans":"\u914D\u9001\u4FE1\u606F","zh-Hant":"\u904B\u9001\u8CC7\u8A0A"},"RL_Signature":{"ar":"\u0627\u0644\u062A\u0648\u0642\u064A\u0639","ca":"Signatura","comment":"Digital Signature generated and printed on the fiscal receipts. ","cs":"Podpis","da":"Underskrift","de":"Unterschrift","el":"\u03A5\u03C0\u03BF\u03B3\u03C1\u03B1\u03C6\u03AE","en":"Signature","en-GB":"Signature","en-XA":"[\u0160\xee\u011D\xf1\xe5\u0163\xfb\u0155\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Firma","es-AR":"Firma","es-ES":"Firma","es-MX":"Firma","fr":"Signature","hu":"Al\xe1\xedr\xe1s","id":"Tanda Tangan","it":"Firma","ja":"\u7F72\u540D","key":"RL_Signature","ko":"\uC11C\uBA85","nb":"Signatur","nl":"Handtekening","pl":"Podpis","pt-BR":"Assinatura","pt-PT":"Assinatura","ru":"\u041F\u043E\u0434\u043F\u0438\u0441\u044C","sv":"Signatur","th":"\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D","tr":"\u0130mza","zh-Hans":"\u7B7E\u540D","zh-Hant":"\u7C3D\u540D"},"RL_SignatureCount":{"ar":"\u062A\u0639\u062F\u0627\u062F \u0627\u0644\u062A\u0648\u0627\u0642\u064A\u0639","ca":"Recompte de signatures","comment":"Count of Digital Signatures generated for printing on the receipt. ","cs":"Po\u010Det podpis\u016F","da":"Antal underskrifter","de":"Anzahl der Unterschriften","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C5\u03C0\u03BF\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2","en":"Signature count","en-GB":"Signature count","en-XA":"[\u0160\xee\u011D\xf1\xe5\u0163\xfb\u0155\xe9\u2002\xe7\xf6\xfb\xf1\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Recuento de firmas","es-AR":"Recuento de firmas","es-ES":"N\xfamero de firmas","es-MX":"Conteo de firmas","fr":"D\xe9compte signature","hu":"Al\xe1\xedr\xe1sok sz\xe1ma","id":"Jumlah tanda tangan","it":"Numero firme","ja":"\u7F72\u540D\u306E\u6570","key":"RL_SignatureCount","ko":"\uC11C\uBA85 \uC218","nb":"Gyldig signatur","nl":"Aantal handtekeningen","pl":"Liczba podpis\xf3w","pt-BR":"Contagem de assinaturas","pt-PT":"Contagem de assinaturas","ru":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u0434\u043F\u0438\u0441\u0435\u0439","sv":"Antal signaturer","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E25\u0E32\u0E22\u0E21\u0E37\u0E2D\u0E0A\u0E37\u0E48\u0E2D","tr":"\u0130mza say\u0131s\u0131","zh-Hans":"\u7B7E\u540D\u6570","zh-Hant":"\u7C3D\u540D\u6578\u91CF"},"RL_Size":{"ar":"\u0627\u0644\u0642\u064A\u0627\u0633","ca":"Talla","comment":"Size of the item","cs":"Velikost","da":"St\xf8rrelse ","de":"Gr\xf6\xdfe ","el":"\u039C\u03AD\u03B3\u03B5\u03B8\u03BF\u03C2","en":"Size","en-GB":"Size","en-XA":"[\u0160\xee\u017E\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tama\xf1o","es-AR":"Tama\xf1o","es-ES":"Talla","es-MX":"Talla","fr":"Taille","hu":"Size","id":"Ukuran","it":" Misura","ja":"Size","key":"RL_Size","ko":"\uC0AC\uC774\uC988","nb":"St\xf8rrelse","nl":"Maat","pl":"Rozmiar","pt-BR":"Tamanho","pt-PT":"Tamanho","ru":"\u0420\u0430\u0437\u043C\u0435\u0440","sv":"Storlek","th":"\u0E44\u0E0B\u0E2A\u0E4C","tr":"Beden","zh-Hans":"\u5C3A\u7801","zh-Hant":"\u5C3A\u5BF8"},"RL_SoftwareName":{"ar":"\u0627\u0633\u0645 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C","ca":"Nom del programari","comment":"Name of the software that converts the transaction into a given format","cs":"N\xe1zev softwaru","da":"Softwarenavn","de":"Softwarename","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03BB\u03BF\u03B3\u03B9\u03C3\u03BC\u03B9\u03BA\u03BF\u03CD","en":"Software Name","en-GB":"Software name","en-XA":"[\u0160\xf6\u0192\u0163\u0175\xe5\u0155\xe9\u2002\xd1\xe5\u0271\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Nombre del software","es-AR":"Nombre del software","es-ES":"Nombre del software","es-MX":"Nombre del software","fr":"Nom du logiciel","hu":"Szoftver neve","id":"Nama Perangkat Lunak","it":"Nome software","ja":"\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u540D","key":"RL_SoftwareName","ko":"\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uC774\uB984","nb":"Programvarenavn","nl":"Softwarenaam","pl":"Nazwa oprogramowania","pt-BR":"Nome do software","pt-PT":"Nome do software","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u041F\u041E","sv":"Programvarans namn","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C","tr":"Yaz\u0131l\u0131m Ad\u0131","zh-Hans":"\u8F6F\u4EF6\u540D\u79F0","zh-Hant":"\u8EDF\u9AD4\u540D\u7A31"},"RL_SoftwareVersion":{"ar":"\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0628\u0631\u0646\u0627\u0645\u062C","ca":"Versi\xf3 de programari","comment":"Software Version ","cs":"Verze softwaru","da":"Softwareversion","de":"Software-Version","el":"\u0388\u03BA\u03B4\u03BF\u03C3\u03B7 \u03BB\u03BF\u03B3\u03B9\u03C3\u03BC\u03B9\u03BA\u03BF\u03CD","en":"Software Version","en-GB":"Software Version","en-XA":"[\u0160\xf6\u0192\u0163\u0175\xe5\u0155\xe9\u2002\u1E7C\xe9\u0155\u0161\xee\xf6\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Versi\xf3n de software","es-AR":"Versi\xf3n de software","es-ES":"Versi\xf3n de software","es-MX":"Versi\xf3n del software","fr":"Version du logiciel","hu":"Szoftver verzi\xf3ja","id":"Versi Perangkat Lunak","it":"Versione software","ja":"\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u306E\u30D0\u30FC\u30B8\u30E7\u30F3","key":"RL_SoftwareVersion","ko":"\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uBC84\uC804","nb":"Programvareversjon","nl":"Softwareversie","pl":"Wersja oprogramowania","pt-BR":"Vers\xe3o do software","pt-PT":"Vers\xe3o do software","ru":"\u0412\u0435\u0440\u0441\u0438\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043D\u043E\u0433\u043E \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D\u0438\u044F","sv":"Programversion","th":"\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E19\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C","tr":"Yaz\u0131l\u0131m S\xfcr\xfcm\xfc","zh-Hans":"\u8F6F\u4EF6\u7248\u672C","zh-Hant":"\u8EDF\u9AD4\u7248\u672C"},"RL_SrlNo_Lft":{"ar":"\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u062A\u0633\u0644\u0633\u0644 \u0625\u0644\u0649 \u0627\u0644\u064A\u0633\u0627\u0631","ca":"N\xfam. de s\xe8rie de la sabatilla esquerra","comment":"Serial Number Left-HyperAdapt","cs":"S\xe9riov\xe9 \u010D. vlevo","da":"Serie-nr. venstre","de":"Seriennr. links","el":"\u03A3\u03B5\u03B9\u03C1\u03B9\u03B1\u03BA\u03CC\u03C2 \u03B1\u03C1. \u03B1\u03C1\u03B9\u03C3\u03C4\u03B5\u03C1\u03AC","en":"Serial No Left","en-GB":"Serial No. Left","en-XA":"[\u0160\xe9\u0155\xee\xe5\u013C\u2002\xd1\xf6\u2002\u013B\xe9\u0192\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de serie para el calzado izquierdo","es-AR":"N\xb0 de serie del calzado izquierdo","es-ES":"N.\xba de serie de la zapatilla izquierda","es-MX":"N\xb0 de serie izquierdo","fr":"N\xb0 de s\xe9rie de la chaussure gauche","hu":"Sorozatsz\xe1m, bal","id":"No. Seri Kiri","it":"Numero di serie mancante","ja":"\u5DE6\u5074\u306E\u30B7\u30EA\u30A2\u30EB\u756A\u53F7","key":"RL_SrlNo_Lft","ko":"\uC67C\uCABD \uC77C\uB828\uBC88\uD638","nb":"Serienr. venstre","nl":"Serienr. links","pl":"Nr seryjny \u2013 lewy","pt-BR":"Sem n\xfamero de s\xe9rie","pt-PT":"N.\xba de s\xe9rie esquerdo","ru":"\u0421\u0435\u0440\u0438\u0439\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0441\u043B\u0435\u0432\u0430","sv":"Serienummer v\xe4nster","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E0B\u0E35\u0E40\u0E23\u0E35\u0E22\u0E25 (\u0E0B\u0E49\u0E32\u0E22)","tr":"Seri No Sol","zh-Hans":"\u5E8F\u5217\u53F7\u9760\u5DE6","zh-Hant":"\u5DE6\u5074\u5E8F\u865F"},"RL_SrlNo_Rght":{"ar":"\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u062A\u0633\u0644\u0633\u0644 \u0625\u0644\u0649 \u0627\u0644\u064A\u0645\u064A\u0646","ca":"N\xfam. de s\xe8rie de la sabatilla dreta","comment":"Serial Number Right-HyperAdapt","cs":"S\xe9riov\xe9 \u010D\xedslo vpravo","da":"Serie-nr. h\xf8jre","de":"Seriennr. rechts","el":"\u03A3\u03B5\u03B9\u03C1\u03B9\u03B1\u03BA\u03CC\u03C2 \u03B1\u03C1. \u03B4\u03B5\u03BE\u03B9\u03AC","en":"Serial No Right","en-GB":"Serial No. Right","en-XA":"[\u0160\xe9\u0155\xee\xe5\u013C\u2002\xd1\xf6\u2002\u0154\xee\u011D\u0125\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de serie incorrecto","es-AR":"N.\xb0 de serie del calzado derecho","es-ES":"N.\xba de serie de la zapatilla derecha","es-MX":"N\xb0 de serie derecho","fr":"N\xb0 de s\xe9rie de la chaussure droite","hu":"Sorozatsz\xe1m, jobb","id":"No. Seri Kanan","it":"Numero di serie non corretto","ja":"\u53F3\u5074\u306E\u30B7\u30EA\u30A2\u30EB\u756A\u53F7","key":"RL_SrlNo_Rght","ko":"\uC624\uB978\uCABD \uC77C\uB828\uBC88\uD638","nb":"Serienr. h\xf8yre","nl":"Serienr. rechts","pl":"Nr seryjny \u2013 prawy","pt-BR":"N\xfamero de s\xe9rie correto","pt-PT":"N.\xba de s\xe9rie direito","ru":"\u0421\u0435\u0440\u0438\u0439\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0441\u043F\u0440\u0430\u0432\u0430","sv":"Serienr. h\xf6ger","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E0B\u0E35\u0E40\u0E23\u0E35\u0E22\u0E25 (\u0E02\u0E27\u0E32)","tr":"Seri No. Sa\u011F","zh-Hans":"\u5E8F\u5217\u53F7\u9760\u53F3","zh-Hant":"\u53F3\u5074\u5E8F\u865F"},"RL_Start":{"ar":"\u0627\u0644\u0628\u062F\u0621 ","ca":"Inicia ","comment":"Start Date Time for TSE attributes in Germany receipts. ","cs":"Za\u010D\xedt ","da":"Start ","de":"Start ","el":"\u0388\u03BD\u03B1\u03C1\u03BE\u03B7 ","en":"Start ","en-GB":"Start ","en-XA":"[\u0160\u0163\xe5\u0155\u0163\u2002\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Comenzar ","es-AR":"Inicio ","es-ES":"Empezar ","es-MX":"Comenzar ","fr":"Start ","hu":"Kezd\xe9s ","id":"Mulai ","it":"Inizia ","ja":"\u958B\u59CB ","key":"RL_Start","ko":"\uC2DC\uC791 ","nb":"Start ","nl":"Start ","pl":"Rozpocznij ","pt-BR":"Iniciar ","pt-PT":"In\xedcio ","ru":"\u0421\u0442\u0430\u0440\u0442 ","sv":"Start ","th":"\u0E40\u0E23\u0E34\u0E48\u0E21 ","tr":"Ba\u015Flat ","zh-Hans":"\u5F00\u59CB ","zh-Hant":"\u958B\u59CB "},"RL_State":{"ar":"\u0627\u0644\u0648\u0644\u0627\u064A\u0629","ca":"Estado","comment":"State where the transactions occurs","cs":"St\xe1t","da":"Kommune","de":"Bundesland","el":"\u039D\u03BF\u03BC\u03CC\u03C2","en":"State","en-GB":"State","en-XA":"[\u0160\u0163\xe5\u0163\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Estado","es-AR":"Estado","es-ES":"Estado","es-MX":"Estado","fr":"State","hu":"State","id":"Negara Bagian","it":"Stato","ja":"\u90FD\u9053\u5E9C\u770C","key":"RL_State","ko":"\uC8FC","nb":"Delstat","nl":"Staat","pl":"Wojew\xf3dztwo","pt-BR":"Estado","pt-PT":"Estado","ru":"\u0420\u0435\u0433\u0438\u043E\u043D","sv":"Delstat","th":"\u0E23\u0E31\u0E10","tr":"Eyalet","zh-Hans":"\u7701/\u5E02/\u76F4\u8F96\u5E02","zh-Hant":"\u5DDE"},"RL_Status":{"ar":"\u0627\u0644\u062D\u0627\u0644\u0629","ca":"Estat","comment":"Status of a transaction like Resume, Delivered, voided etc","cs":"Stav","da":"Status","de":"Status","el":"\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7","en":"Status","en-GB":"Status","en-XA":"[\u0160\u0163\xe5\u0163\xfb\u0161\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Estado","es-AR":"Estado","es-ES":"Estado","es-MX":"Estado","fr":"Statut","hu":"\xc1llapot","id":"Status","it":"Stato","ja":"\u30B9\u30C6\u30FC\u30BF\u30B9","key":"RL_Status","ko":"\uC0C1\uD0DC","nb":"Status","nl":"Status","pl":"Status","pt-BR":"Status","pt-PT":"Estado","ru":"\u0421\u0442\u0430\u0442\u0443\u0441","sv":"Status","th":"\u0E2A\u0E16\u0E32\u0E19\u0E30","tr":"Durum","zh-Hans":"\u72B6\u6001","zh-Hant":"\u72C0\u614B"},"RL_Stop":{"ar":"\u0627\u0644\u062A\u0648\u0642\u0651\u0641","ca":"Atura","comment":" End date and time for the TSE attributes in German receipts. ","cs":"Zastavit","da":"Stop","de":"Beenden","el":"\u0394\u03B9\u03B1\u03BA\u03BF\u03C0\u03AE","en":"Stop","en-GB":"Stop","en-XA":"[\u0160\u0163\xf6\xfe\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Detener","es-AR":"Finalizaci\xf3n","es-ES":"Detener","es-MX":"Detener","fr":"Stop","hu":"Le\xe1ll\xedt\xe1s","id":"Berhenti","it":"Interrompi","ja":"\u505C\u6B62","key":"RL_Stop","ko":"\uC815\uC9C0","nb":"Stopp","nl":"Stop","pl":"Zatrzymaj","pt-BR":"Parar","pt-PT":"Fim","ru":"\u0421\u0442\u043E\u043F","sv":"Slut","th":"\u0E2B\u0E22\u0E38\u0E14","tr":"Durdur","zh-Hans":"\u7ED3\u675F","zh-Hant":"\u7D50\u675F"},"RL_Store":{"ar":"\u0627\u0644\u0645\u062A\u062C\u0631","ca":"Tienda","comment":"Store where the transaction is done","cs":"Obchod","da":"Butik","de":"Shop","el":"\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1","en":"Store","en-GB":"Store","en-XA":"[\u0160\u0163\xf6\u0155\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tienda","es-AR":"Tienda","es-ES":"Tienda","es-MX":"Tienda","fr":"Magasin","hu":"Store","id":"Toko","it":"Punto vendita","ja":"\u5E97\u8217","key":"RL_Store","ko":"\uB9E4\uC7A5","nb":"Butikk","nl":"Winkel","pl":"Sklep","pt-BR":"Loja","pt-PT":"Loja","ru":"\u041C\u0430\u0433\u0430\u0437\u0438\u043D","sv":"Butik","th":"\u0E23\u0E49\u0E32\u0E19","tr":"Ma\u011Faza","zh-Hans":"\u9002\u7528\u5546\u5E97","zh-Hant":"\u9580\u5E02"},"RL_StoreCredit":{"ar":"\u0631\u0635\u064A\u062F \u0641\u064A \u0627\u0644\u0645\u062A\u062C\u0631","ca":"Cr\xe9dito tienda","comment":"Indicates the store credit","cs":"N\xe1kupn\xed kredit prodejny","da":"Butik kredit","de":"Shop -Gutschrift","el":"\u03A0\u03AF\u03C3\u03C4\u03C9\u03C3\u03B7 \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2","en":"Store Credit","en-GB":"Store Credit","en-XA":"[\u0160\u0163\xf6\u0155\xe9\u2002\xc7\u0155\xe9\xf0\xee\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cr\xe9dito de la tienda","es-AR":"Cr\xe9dito de la tienda","es-ES":"Cr\xe9dito tienda","es-MX":"Cr\xe9dito de tienda","fr":"Bon d\'achat","hu":"Store Credit","id":"Kredit Toko","it":"Credito punto vendita","ja":"\u30B9\u30C8\u30A2\u30AF\u30EC\u30B8\u30C3\u30C8","key":"RL_StoreCredit","ko":"\uB9E4\uC7A5 \uD06C\uB808\uB527","nb":"Butikkreditt","nl":"Winkel krediet","pl":"Sklepowa linia kredytowa","pt-BR":"Cr\xe9dito da loja","pt-PT":"Cr\xe9dito Store","ru":"Store Credit","sv":"Storekredit","th":"\u0E40\u0E04\u0E23\u0E14\u0E34\u0E15\u0E43\u0E19\u0E23\u0E49\u0E32\u0E19","tr":"Ma\u011Faza Kredisi","zh-Hans":"\u5546\u5E97\u8D2D\u7269\u5238","zh-Hant":"\u5E97\u5167\u73FE\u91D1\u984D\u5EA6"},"RL_StoreLevelPromotion":{"ar":"\u0639\u0631\u0636 \u062A\u0631\u0648\u064A\u062C\u064A \u0639\u0644\u0649 \u0645\u0633\u062A\u0648\u0649 \u0627\u0644\u0645\u062A\u062C\u0631","ca":"Promoci\xf3 de la botiga","comment":"String in receipt to identify Store Level Promotion","cs":"Promoakce v\xa0obchod\u011B","da":"Kampagne p\xe5 butiksniveau","de":"Store-Level-Angebot","el":"\u03A0\u03C1\u03BF\u03CE\u03B8\u03B7\u03C3\u03B7 \u03C3\u03B5 \u03B5\u03C0\u03AF\u03C0\u03B5\u03B4\u03BF \u03BA\u03B1\u03C4\u03B1\u03C3\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2","en":"Store Level Promotion","en-GB":"Store-Level Promotion","en-XA":"[\u0160\u0163\xf6\u0155\xe9\u2002\u013B\xe9\u1E7D\xe9\u013C\u2002\xde\u0155\xf6\u0271\xf6\u0163\xee\xf6\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Promoci\xf3n a nivel de tienda","es-AR":"Promoci\xf3n de la tienda","es-ES":"Promoci\xf3n de la tienda","es-MX":"Promoci\xf3n de Tienda","fr":"Promotion au niveau du magasin","hu":"\xdczletszint\u0171 prom\xf3ci\xf3","id":"Promosi Tingkat Toko","it":"Promozione a livello di negozio","ja":"\u5E97\u8217\u5358\u4F4D\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3","key":"RL_StoreLevelPromotion","ko":"\uB9E4\uC7A5 \uCC28\uC6D0 \uD504\uB85C\uBAA8\uC158","nb":"Butikkampanje","nl":"Promotie in de Store","pl":"Promocja na poziomie sklepu","pt-BR":"Promo\xe7\xe3o da loja","pt-PT":"Promo\xe7\xe3o ao n\xedvel da loja","ru":"\u0420\u0435\u043A\u043B\u0430\u043C\u043D\u0430\u044F \u0430\u043A\u0446\u0438\u044F \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435","sv":"Kampanj p\xe5 butiksniv\xe5","th":"\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E23\u0E49\u0E32\u0E19","tr":"Ma\u011Faza D\xfczeyinde Promosyon","zh-Hans":"\u5546\u5E97\u4FC3\u9500","zh-Hant":"\u9580\u5E02\u7B49\u7D1A\u4FC3\u92B7"},"RL_StoreNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0645\u062A\u062C\u0631","ca":"N\xfamero de tienda","comment":" Store number in receipt","cs":"\u010C\xedslo prodejny","da":"ButikNummer","de":"StoreNumber","el":"StoreNumber","en":"StoreNumber","en-GB":"StoreNumber","en-XA":"[\u0160\u0163\xf6\u0155\xe9\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de tienda","es-AR":"N\xfamero de tienda","es-ES":"N.\xba tienda","es-MX":"N\xfamero de tienda","fr":"Nomagasin","hu":"StoreNumber","id":"NomorToko","it":"Numero punto vendita:","ja":"\u5E97\u8217\u756A\u53F7","key":"RL_StoreNumber","ko":"\uB9E4\uC7A5 \uBC88\uD638","nb":"Butikknummer","nl":"StoreNummer","pl":"Numer sklepu","pt-BR":"N\xfameroLoja","pt-PT":"N\xfamero da loja","ru":"StoreNumber","sv":"Butiksnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E23\u0E49\u0E32\u0E19","tr":"Ma\u011FazaNumaras\u0131","zh-Hans":"\u5546\u5E97\u7F16\u53F7","zh-Hant":"\u9580\u5E02\u7DE8\u865F"},"RL_Style":{"ar":"\u0627\u0644\u0623\u0633\u0644\u0648\u0628","ca":"Estilo","comment":"Style field in receipt","cs":"Styl ","da":"Stil ","de":"Style","el":"\u03A3\u03C4\u03B9\u03BB","en":"Style","en-GB":"Style","en-XA":"[\u0160\u0163\xfd\u013C\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Estilo ","es-AR":"Estilo","es-ES":"Estilo","es-MX":"Estilo","fr":"Mod\xe8le ","hu":"Style","id":"Gaya","it":"Modello","ja":"Style","key":"RL_Style","ko":"\uC2A4\uD0C0\uC77C","nb":"Produkt","nl":"Stijl","pl":"Styl","pt-BR":"Estilo","pt-PT":"Estilo","ru":"\u0410\u0440\u0442\u0438\u043A\u0443\u043B","sv":"Modell","th":"\u0E2A\u0E44\u0E15\u0E25\u0E4C","tr":"Stil","zh-Hans":"\u6B3E\u5F0F","zh-Hant":"\u6B3E\u5F0F"},"RL_SubTenderType":{"ar":"\u0646\u0648\u0639 \u0635\u064A\u063A\u0629 \u0627\u0644\u062F\u0641\u0639 \u0627\u0644\u0641\u0631\u0639\u064A\u0629","ca":"Subtipus de m\xe8tode de pagament","comment":"Sub Tender under a given Tender Type.  For eg: SubTenderTypes like Alipay, WeChatPay under TenderType =Online Payment","cs":"Slu\u017Eba:","da":"Underbetalingstype","de":"Unterkategorie f\xfcr Zahlungsmittelart","el":"\u03A5\u03C0\u03BF\u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B1 \u03B1\u03BD\u03C4\u03B9\u03C4\u03AF\u03BC\u03BF\u03C5","en":"SubTender Type","en-GB":"SubTender type","en-XA":"[\u0160\xfb\u0180\u0162\xe9\xf1\xf0\xe9\u0155\u2002\u0162\xfd\xfe\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tipo de subforma de pago","es-AR":"Subtipo de forma de pago","es-ES":"Subtipo de forma de pago","es-MX":"Subforma de pago","fr":"Sous-type de r\xe8glement","hu":"Fizet\xe9si m\xf3d alt\xedpusa","id":"Jenis SubTender","it":"Sottotipo di pagamento","ja":"\u4E88\u5099\u306E\u6C7A\u6E08\u624B\u6BB5\u306E\u7A2E\u985E","key":"RL_SubTenderType","ko":"\uD558\uC704 \uACB0\uC81C \uC218\uB2E8 \uC720\uD615","nb":"SubTender-type","nl":"Type SubTender","pl":"Podkategoria formy p\u0142atno\u015Bci","pt-BR":"Tipo de subpagamento","pt-PT":"Subtipo de pagamento","ru":"\u0422\u0438\u043F \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E\u0433\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u0432\u0442\u043E\u0440\u043E\u0433\u043E \u043F\u043E\u0440\u044F\u0434\u043A\u0430","sv":"Delanbudstyp","th":"\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19\u0E22\u0E48\u0E2D\u0E22","tr":"Alt Kasa \u0130\u015Flemi T\xfcr\xfc","zh-Hans":"\u5907\u9009\u4ED8\u6B3E\u65B9\u5F0F","zh-Hant":"\u5B50\u4ED8\u6B3E\u985E\u578B"},"RL_Subtotal":{"ar":"\u0627\u0644\u0645\u062C\u0645\u0648\u0639 \u0627\u0644\u0641\u0631\u0639\u064A","ca":"Subtotal","comment":"Sub total of the transaction","cs":"Mezisoucet","da":"Subtotal","de":"Zwischensumme","el":"\u03A5\u03C0\u03BF\u03C3\u03CD\u03BD\u03BF\u03BB\u03BF","en":"Subtotal","en-GB":"Subtotal","en-XA":"[\u0160\xfb\u0180\u0163\xf6\u0163\xe5\u013C\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Subtotal","es-AR":"Subtotal","es-ES":"Subtotal","es-MX":"Subtotal","fr":"Sous-total","hu":"Subtotal","id":"Subtotal","it":"Subtotale","ja":"\u5C0F\u8A08","key":"RL_Subtotal","ko":"\uC0C1\uD488 \uAE08\uC561","nb":"Subtotal","nl":"Subtotaal","pl":"Suma cz\u0119\u015Bciowa","pt-BR":"Subtotal","pt-PT":"Subtotal","ru":"\u041F\u0440\u043E\u043C\u0435\u0436\u0443\u0442\u043E\u0447\u043D\u044B\u0439 \u0438\u0442\u043E\u0433","sv":"Delsumma","th":"\u0E22\u0E2D\u0E14\u0E23\u0E27\u0E21\u0E22\u0E48\u0E2D\u0E22","tr":"Ara Toplam","zh-Hans":"\u5B9E\u9645\u5546\u54C1\u603B\u989D","zh-Hant":"\u5C0F\u8A08"},"RL_Suspend":{"ar":"\u062A\u0639\u0644\u064A\u0642","ca":"Suspeses","comment":"Transactions that are suspended","cs":"Pozastaven\xe1","da":"Overskriv","de":"Aussetzen","el":"\u03A3\u03B5 \u03B1\u03BD\u03B1\u03C3\u03C4\u03BF\u03BB\u03AE","en":"Suspend","en-GB":"Suspend","en-XA":"[\u0160\xfb\u0161\xfe\xe9\xf1\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Suspendida","es-AR":"Suspender","es-ES":"Suspendido","es-MX":"Suspender","fr":"Suspendre","hu":"Felf\xfcggeszt\xe9s","id":"Ditangguhkan","it":"Sospese","ja":"\u4FDD\u7559\u306B\u3059\u308B","key":"RL_Suspend","ko":"\uC0AC\uC6A9 \uC911\uC9C0","nb":"Suspender","nl":"Onderbreek","pl":"Wstrzymaj","pt-BR":"Suspenso","pt-PT":"Suspensa","ru":"\u041F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C","sv":"Pausa","th":"\u0E23\u0E30\u0E07\u0E31\u0E1A","tr":"Ask\u0131ya Al","zh-Hans":"\u5DF2\u6682\u505C","zh-Hant":"\u5DF2\u505C\u6B62"},"RL_SwitchView":{"ar":"\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0639\u0631\u0636","ca":"Canvia la vista","comment":"Switch view between the Transaction and Receipt view on the Electronic Journal.","cs":"P\u0159epnout pohled","da":"Skift visning","de":"Ansicht wechseln","el":"\u0391\u03BB\u03BB\u03B1\u03B3\u03AE \u03C0\u03C1\u03BF\u03B2\u03BF\u03BB\u03AE\u03C2","en":"Switch View","en-GB":"Switch View","en-XA":"[\u0160\u0175\xee\u0163\xe7\u0125\u2002\u1E7C\xee\xe9\u0175\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cambiar vista","es-AR":"Cambiar vista","es-ES":"Cambiar vista","es-MX":"Cambiar vista","fr":"Changer l\'affichage","hu":"N\xe9zetv\xe1lt\xe1s","id":"Beralih Tampilan","it":"Cambia visualizzazione","ja":"\u30D3\u30E5\u30FC\u3092\u5207\u308A\u66FF\u3048","key":"RL_SwitchView","ko":"\uBCF4\uAE30 \uC804\uD658","nb":"Bytt visning","nl":"Wissel van weergave","pl":"Prze\u0142\u0105cz widok","pt-BR":"Alterar visualiza\xe7\xe3o","pt-PT":"Mudar de vista","ru":"\u0421\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u0438\u0434","sv":"V\xe4xla vy","th":"\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E21\u0E38\u0E21\u0E21\u0E2D\u0E07","tr":"G\xf6r\xfcn\xfcm\xfc De\u011Fi\u015Ftir","zh-Hans":"\u5207\u6362\u89C6\u56FE","zh-Hant":"\u5207\u63DB\u6AA2\u8996\u6A21\u5F0F"},"RL_TC":{"ar":"\u0631\u0645\u0632 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"TC","comment":"TC term in card transaction","cs":"TC","da":"TC","de":"TC","el":"TC","en":"TC","en-GB":"TC","en-XA":"[\u0162\xc7\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"TC","es-AR":"TC","es-ES":"TC","es-MX":"TC","fr":"TC","hu":"TC","id":"TC","it":"TC","ja":"TC","key":"RL_TC","ko":"TC","nb":"TC","nl":"TC","pl":"TC","pt-BR":"TC","pt-PT":"Cart\xe3o de transa\xe7\xe3o","ru":"TC","sv":"TC","th":"TC","tr":"TC","zh-Hans":"\u4EA4\u6613\u8BA4\u8BC1\u7801","zh-Hant":"\u4EA4\u6613\u8A8D\u8B49\u78BC"},"RL_TENDEREXCHANGE":{"ar":"\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0645\u0646\u0627\u0642\u0635\u0629","ca":"CAMBIO DE PAGO","comment":"Phrase to indicate the TENDER EXCHANGE in the transaction","cs":"V\xddMENA - ZPUS. PLATBY","da":"BETALINGSVALUTA","de":"ANGEBOT WECHSELNZAHLUNGSMITTEL WECHSELGELD","el":"\u0391\u039D\u03A4\u0391\u039B\u039B\u0391\u0393\u0397 \u03A0\u03A1\u039F\u03A3\u03A6\u039F\u03A1\u03A9\u039D","en":"TENDER EXCHANGE","en-GB":"TENDER EXCHANGE","en-XA":"[\u0162\xc9\xd1\xd0\xc9\u0154\u2002\xc9\u1E8A\xc7\u0124\xc5\xd1\u011C\xc9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"CAMBIO DE MEDIO DE PAGO","es-AR":"CAMBIO DE MEDIO DE PAGO","es-ES":"CAMBIO DE PAGO","es-MX":"CAMBIO DE MEDIO DE PAGO","fr":"\xc9CHANGE DE MODE DE PAIEMENT","hu":"TENDER EXCHANGE","id":"PERTUKARAN TENDER","it":"CAMBIO MODALIT\xc0 DI PAGAMENTO","ja":"\u652F\u6255\u3044\u65B9\u6CD5\u5909\u66F4","key":"RL_TENDEREXCHANGE","ko":"\uC9C0\uBD88 \uC218\uB2E8 \uBCC0\uACBD \uAD50\uD658","nb":"BETALINGSMETODE FOR VEKSEL","nl":"BETAALWIJZE WISSELEN","pl":"WYMIANA OFERTY","pt-BR":"TROCA DE PAGAMENTO","pt-PT":"TROCA FORMA PAGAMENTO","ru":"TENDER EXCHANGE","sv":"V\xc4XLA IN BETALNINGSMEDEL","th":"\u0E01\u0E32\u0E23\u0E41\u0E25\u0E01\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19","tr":"KASA \u0130\u015ELEM\u0130 DE\u011E\u0130\u015E\u0130M\u0130","zh-Hans":"\u652F\u4ED8\u65B9\u5F0F\u66F4\u6362","zh-Hant":"\u652F\u4ED8\u65B9\u5F0F\u514C\u63DB"},"RL_TRAININGMODE":{"ar":"\u0648\u0636\u0639 \u0627\u0644\u062A\u062F\u0631\u064A\u0628","ca":"Modo Training","comment":"Training Mode Indicator","cs":"V\xfdukov\xfd re\u017Eim","da":"TR\xc6NINGSTILSTAND","de":"Ausbildung / Training","el":"\u039B\u0395\u0399\u03A4\u039F\u03A5\u03A1\u0393\u0399\u0391 \u0395\u039A\u03A0\u0391\u0399\u0394\u0395\u03A5\u03A3\u0397\u03A3","en":"TRAINING MODE","en-GB":"TRAINING MODE","en-XA":"[\u0162\u0154\xc5\xce\xd1\xce\xd1\u011C\u2002\u1E40\xd6\xd0\xc9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"MODALIDAD DE ENTRENAMIENTO","es-AR":"MODALIDAD DE ENTRENAMIENTO","es-ES":"MODO FORMACI\xd3N","es-MX":"MODO DE CAPACITACI\xd3N","fr":"MODE FORMATION","hu":"TRAINING MODE","id":"MODE LATIHAN","it":"MODALIT\xc0 ADDESTRAMENTO","ja":"TRAINING MODE","key":"RL_TRAININGMODE","ko":"\uD2B8\uB808\uC774\uB2DD \uBAA8\uB4DC","nb":"OPPL\xc6RINGSMODUS","nl":"Training Modus","pl":"TRYB SZKOLENIOWY","pt-BR":"MODO DE TREINO","pt-PT":"Modo Forma\xe7\xe3o","ru":"TRAINING MODE","sv":"Utbildningsl\xe4ge","th":"\u0E42\u0E2B\u0E21\u0E14\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49","tr":"E\u011E\u0130T\u0130M MODU","zh-Hans":"\u57F9\u8BAD\u6A21\u5F0F","zh-Hant":"\u57F9\u8A13\u6A21\u5F0F"},"RL_TRANSACTION":{"ar":"\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"TRANSACCI\xd3N","comment":"word to indicates the transaction number","cs":"TRANSACTION","da":"TRANSAKTION","de":"TRANSACTIE","el":"\u03A3\u03A5\u039D\u0391\u039B\u039B\u0391\u0393\u0397","en":"TRANSACTION","en-GB":"TRANSACTION","en-XA":"[\u0162\u0154\xc5\xd1\u0160\xc5\xc7\u0162\xce\xd6\xd1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"TRANSACCI\xd3N","es-AR":"TRANSACCI\xd3N","es-ES":"TRANSACTION","es-MX":"TRANSACCI\xd3N|","fr":"APRES ACHAT","hu":"TRANSACTION","id":"TRANSAKSI","it":"TRANSACTION","ja":"TRANSACTION","key":"RL_TRANSACTION","ko":"\uAC70\uB798","nb":"TRANSAKSJON","nl":"TRANSACTIE","pl":"TRANSAKCJA","pt-BR":"TRANSA\xc7\xc3O","pt-PT":"Transac\xe7\xe3o","ru":"TRANSACTION","sv":"TRANSACTION","th":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"\u0130\u015ELEM","zh-Hans":"\u4EA4\u6613","zh-Hant":"\u4EA4\u6613"},"RL_TRANSACTION_SUSPENDED":{"ar":"\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629 \u0645\u0639\u0644\u0651\u0642\u0629","ca":"TRANSACCI\xd3 INTERROMPUDA","comment":"TRANSACTION SUSPENDED","cs":"POZASTAVEN\xc1 TRANSAKCE","da":"TRANSAKTION AFBRUDT","de":"TRANSAKTION UNTERBROCHEN","el":"\u0397 \u03A3\u03A5\u039D\u0391\u039B\u039B\u0391\u0393\u0397 \u03A4\u0395\u0398\u0397\u039A\u0395 \u03A3\u0395 \u0391\u039D\u0391\u03A3\u03A4\u039F\u039B\u0397","en":"TRANSACTION SUSPENDED","en-GB":"TRANSACTION SUSPENDED","en-XA":"[\u0162\u0154\xc5\xd1\u0160\xc5\xc7\u0162\xce\xd6\xd1\u2002\u0160\xdb\u0160\xde\xc9\xd1\xd0\xc9\xd0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"TRANSACCI\xd3N SUSPENDIDA","es-AR":"TRANSACCI\xd3N SUSPENDIDA","es-ES":"TRANSACCI\xd3N SUSPENDIDA","es-MX":"SUSPENDER TRANSACCI\xd3N","fr":"TRANSACTION SUSPENDUE","hu":"TRANZAKCI\xd3 FELF\xdcGGESZTVE","id":"TRANSAKSI DITANGGUHKAN","it":"TRANSAZIONE SOSPESA","ja":"\u4E2D\u65AD\u3055\u308C\u305F\u53D6\u5F15","key":"RL_TRANSACTION_SUSPENDED","ko":"\uAC70\uB798 \uC815\uC9C0\uB428","nb":"TRANSAKSJON SUSPENDERT","nl":"TRANSACTIE AFGEBROKEN","pl":"TRANSAKCJA ZAWIESZONA","pt-BR":"TRANSA\xc7\xc3O SUSPENSA","pt-PT":"TRANSA\xc7\xc3O SUSPENSA","ru":"\u0422\u0420\u0410\u041D\u0417\u0410\u041A\u0426\u0418\u042F \u041F\u0420\u0418\u041E\u0421\u0422\u0410\u041D\u041E\u0412\u041B\u0415\u041D\u0410","sv":"TRANSAKTIONEN \xc4R PAUSAD","th":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E16\u0E39\u0E01\u0E23\u0E30\u0E07\u0E31\u0E1A","tr":"\u0130\u015ELEM ASKIYA ALINDI","zh-Hans":"\u4EA4\u6613\u6682\u505C","zh-Hant":"\u4EA4\u6613\u5DF2\u505C\u6B62"},"RL_TSEOffline":{"ar":"\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0646\u0638\u0627\u0645 \u0627\u0644\u0623\u0645\u0646 \u0627\u0644\u062A\u0642\u0646\u064A\u0651 TSE","ca":"No es pot connectar amb el TSE","comment":"Text to print on German receipts when TSE is not reachable","cs":"Nelze se spojit s\xa0TSE","da":"TSE kan ikke n\xe5s","de":"TSE kann nicht erreicht werden","el":"\u0394\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1 \u03BC\u03B5 \u03C4\u03BF TSE","en":"TSE cannot be reached","en-GB":"TSE cannot be reached","en-XA":"[\u0162\u0160\xc9\u2002\xe7\xe5\xf1\xf1\xf6\u0163\u2002\u0180\xe9\u2002\u0155\xe9\xe5\xe7\u0125\xe9\xf0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"El dispositivo t\xe9cnico de seguridad no se puede conectar","es-AR":"El dispositivo t\xe9cnico de seguridad no se puede conectar","es-ES":"No se ha podido conectar con el TSE","es-MX":"Hubo un erro al contactar a TSE","fr":"TSE inaccessible","hu":"A TSE nem el\xe9rhet\u0151","id":"TSE tidak dapat dihubungi","it":"TSE irraggiungibile","ja":"TSE\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u307E\u305B\u3093","key":"RL_TSEOffline","ko":"TSE \uC811\uADFC \uBD88\uAC00","nb":"N\xe5r ikke TSE","nl":"TSE is niet bereikbaar","pl":"Nie uda\u0142o si\u0119 po\u0142\u0105czy\u0107 z systemem TSE","pt-BR":"N\xe3o \xe9 poss\xedvel alcan\xe7ar TSE","pt-PT":"N\xe3o foi poss\xedvel contactar a TSE","ru":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0432\u044F\u0437\u044C \u0441 TSE","sv":"TSE kan inte n\xe5s","th":"\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 TSE \u0E44\u0E14\u0E49","tr":"TSE\'ye eri\u015Filemiyor.","zh-Hans":"\u65E0\u6CD5\u8BBF\u95EE TSE","zh-Hant":"\u7121\u6CD5\u9023\u63A5 TSE"},"RL_Tax":{"ar":"\u0627\u0644\u0636\u0631\u064A\u0628\u0629","ca":"Impuestos","comment":"Tax applied","cs":"Da\u0148","da":"Skat","de":"Tax","el":"\u03A6\u03CC\u03C1\u03BF\u03B9","en":"Tax","en-GB":"VAT","en-XA":"[\u0162\xe5\u1E8B\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Impuesto","es-AR":"Impuesto","es-ES":"Impuestos","es-MX":"Impuesto","fr":"Taxes","hu":"Tax","id":"Pajak","it":"Imposta","ja":"Tax","key":"RL_Tax","ko":"\uBD80\uAC00\uC138","nb":"Skatt","nl":"Btw","pl":"Podatek","pt-BR":"Imposto","pt-PT":"Imposto","ru":"\u041D\u0430\u043B\u043E\u0433","sv":"Moms","th":"\u0E20\u0E32\u0E29\u0E35","tr":"Vergi","zh-Hans":"\u7A0E\u8D39","zh-Hant":"\u7A05\u91D1"},"RL_TaxExempt":{"ar":"\u0645\u0639\u0641\u0649 \u0645\u0646 \u0627\u0644\u0636\u0631\u0627\u0626\u0628","ca":"Exenc. impuestos","comment":"Tax Exempted for the transaction","cs":"Osvobozen\xed od dan\u011B","da":"skattefritagelse","de":"Steuerbefreit","el":"\u03A6\u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03AE \u03B1\u03C0\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE","en":"Tax Exempt","en-GB":"Tax Exempt","en-XA":"[\u0162\xe5\u1E8B\u2002\xc9\u1E8B\xe9\u0271\xfe\u0163\u2002\xe5\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Exento de impuestos","es-AR":"Exenc. de imp. de trans","es-ES":"Exenc. impuestos","es-MX":"Exenci\xf3n de impuestos","fr":"Exon\xe9ration fiscale","hu":"Tax Exempt","id":"Bebas Pajak","it":"Esente da tasse","ja":"\u514D\u7A0E\u5BFE\u8C61\u8005","key":"RL_TaxExempt","ko":"\uBA74\uC138","nb":"Skattefri","nl":"Vrijstelling van belasting","pl":"zwolnienie podatkowe","pt-BR":"Isen\xe7\xe3o de taxa","pt-PT":"Isento Imposto","ru":"Tax Exempt","sv":"Skatteundantag","th":"\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E20\u0E32\u0E29\u0E35","tr":"Vergi Muafiyeti","zh-Hans":"\u514D\u7A0E","zh-Hant":"\u514D\u7A05"},"RL_TaxExemptNo":{"ar":"\u0627\u0644\u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0641\u0649 \u0645\u0646 \u0627\u0644\u0636\u0631\u0627\u0626\u0628","ca":"Tax Exempt No","comment":"Tax Exempt Number for exemption used in the transaction","cs":"Tax Exempt No","da":"Tax Exempt No","de":"Tax Exempt No","el":"\u0391\u03C1. \u03C6\u03BF\u03C1\u03BF\u03BB\u03BF\u03B3\u03B9\u03BA\u03AE\u03C2 \u03B1\u03C0\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Tax Exempt No","en-GB":"Tax Exempt No.","en-XA":"[\u0162\xe5\u1E8B\u2002\xc9\u1E8B\xe9\u0271\xfe\u0163\u2002\xd1\xf6\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero exento de impuestos","es-AR":"N\xfamero exento de impuestos","es-ES":"Tax Exempt No","es-MX":"Tax Exempt No","fr":"Tax Exempt No","hu":"Tax Exempt No","id":"No. Bebas Pajak","it":"Tax Exempt No","ja":"Tax Exempt No","key":"RL_TaxExemptNo","ko":"\uBA74\uC138 \uBC88\uD638","nb":"Skattefritaksnr.","nl":"Tax Exempt No","pl":"Tax Exempt No","pt-BR":"N\xfamero da isen\xe7\xe3o de taxa","pt-PT":"Tax Exempt No","ru":"Tax Exempt No","sv":"Tax Exempt No","th":"\u0E40\u0E25\u0E02\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E27\u0E49\u0E19\u0E20\u0E32\u0E29\u0E35","tr":"Vergi Muafiyeti No","zh-Hans":"\u514D\u7A0E\u7F16\u53F7","zh-Hant":"Tax Exempt No"},"RL_TenderType":{"ar":"\u0646\u0648\u0639 \u0627\u0644\u0645\u0646\u0627\u0642\u0635\u0629","ca":"Tipus de m\xe8tode de pagament","comment":"Type of tender - Cash, Credit Card etc","cs":"Typ platby","da":"Betalingstype","de":"Zahlungsmittelart","el":"\u03A4\u03CD\u03C0\u03BF\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en":"Tender Type","en-GB":"Tender Type","en-XA":"[\u0162\xe9\xf1\xf0\xe9\u0155\u2002\u0162\xfd\xfe\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tipo de forma de pago","es-AR":"Tipo de forma de pago","es-ES":"Tipo de forma de pago","es-MX":"Tipo de forma de pago","fr":"Type de r\xe8glement","hu":"Tender t\xedpusa","id":"Jenis Tender","it":"Tipo di pagamento","ja":"\u652F\u6255\u65B9\u6CD5","key":"RL_TenderType","ko":"\uC218\uB2E8 \uC720\uD615","nb":"Type betalingsmetode","nl":"Type offerte","pl":"Typ oferty","pt-BR":"Tipo de pagamento","pt-PT":"Tipo de pagamento","ru":"\u0422\u0438\u043F \u0442\u0435\u043D\u0434\u0435\u0440\u0430","sv":"Anbudstyp","th":"\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E01\u0E32\u0E23\u0E0A\u0E33\u0E23\u0E30\u0E40\u0E07\u0E34\u0E19","tr":"Kasa \u0130\u015Flemi T\xfcr\xfc","zh-Hans":"\u4ED8\u6B3E\u65B9\u5F0F","zh-Hant":"\u4ED8\u6B3E\u985E\u578B"},"RL_TenderVoid":{"ar":"\u0635\u064A\u063A\u0629 \u0627\u0644\u062F\u0641\u0639 \u063A\u064A\u0631 \u0635\u0627\u0644\u062D\u0629","ca":"M\xe8tode de pagament no v\xe0lid","comment":"To indicate that the tender amount (Cash, Credit etc) is voided in the transaction. ","cs":"Platba zru\u0161ena","da":"Betaling annulleret","de":"Zahlungsmittel ung\xfcltig","el":"\u0391\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en":"Tender Void","en-GB":"Tender void","en-XA":"[\u0162\xe9\xf1\xf0\xe9\u0155\u2002\u1E7C\xf6\xee\xf0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Forma de pago anulada","es-AR":"Forma de pago anulada","es-ES":"Forma de pago anulada","es-MX":"Forma de pago anulada","fr":"Montant du r\xe8glement nul","hu":"Fizet\xe9si m\xf3d \xe9rv\xe9nytelen\xedtve","id":"Pembatalan Tender","it":"Pagamento non valido","ja":"\u7121\u52B9\u306A\u4EE3\u91D1","key":"RL_TenderVoid","ko":"\uACB0\uC81C \uBB34\uD6A8","nb":"Ugyldig betalingsmetode","nl":"Bedrag gewist","pl":"Niewa\u017Cna forma p\u0142atno\u015Bci","pt-BR":"Pagamento cancelado","pt-PT":"Pagamento anulado","ru":"\u041F\u043B\u0430\u0442\u0435\u0436 \u0430\u043D\u043D\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u043D","sv":"Betalningsmedel annullerat","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30","tr":"Kasa \u0130\u015Flemi \u0130ptal","zh-Hans":"\u4ED8\u6B3E\u65B9\u5F0F\u65E0\u6548","zh-Hant":"\u4ED8\u6B3E\u4F5C\u5EE2"},"RL_TextSearch":{"ar":"\u0627\u0644\u0628\u062D\u062B \u0641\u064A \u0627\u0644\u0646\u0635 ","ca":"Cerca de text","comment":"A free text search field. ","cs":"Hledat text","da":"Teksts\xf8gning ","de":"Textsuche","el":"\u039A\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF \u03B1\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2 ","en":"Text Search ","en-GB":"Text Search ","en-XA":"[\u0162\xe9\u1E8B\u0163\u2002\u0160\xe9\xe5\u0155\xe7\u0125\u2002\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Texto de b\xfasqueda","es-AR":"B\xfasqueda de texto","es-ES":"B\xfasqueda de texto","es-MX":"B\xfasqueda de texto ","fr":"Recherche textuelle","hu":"Sz\xf6veges keres\xe9s","id":"Pencarian Teks","it":"Ricerca testo","ja":"\u30C6\u30AD\u30B9\u30C8\u691C\u7D22","key":"RL_TextSearch","ko":"\uD14D\uC2A4\uD2B8 \uAC80\uC0C9","nb":"Teksts\xf8k ","nl":"Tekst zoekopdracht ","pl":"Wyszukiwanie tekstowe","pt-BR":"Pesquisa de texto","pt-PT":"Pesquisa de texto","ru":"\u0422\u0435\u043A\u0441\u0442\u043E\u0432\u044B\u0439 \u043F\u043E\u0438\u0441\u043A","sv":"S\xf6ktext","th":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21","tr":"Metin Aramas\u0131","zh-Hans":"\u6587\u672C\u641C\u7D22","zh-Hant":"\u6587\u5B57\u641C\u5C0B"},"RL_Tid":{"ar":"\u0631\u0642\u0645 \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"Tid","comment":" Tid of the  card details","cs":"Tid","da":"Tid","de":"Tid","el":"Tid","en":"Tid","en-GB":"Tid","en-XA":"[\u0162\xee\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tid","es-AR":"Tid","es-ES":"Tid","es-MX":"Tid","fr":"Tid","hu":"Tid","id":"Tid","it":"Tid","ja":"Tid","key":"RL_Tid","ko":"Tid","nb":"Tid","nl":"Tid","pl":"Tid","pt-BR":"Tid","pt-PT":"ID da transa\xe7\xe3o","ru":"\u0418\u041D\u041D","sv":"Tid","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07","tr":"Tid","zh-Hans":"\u7EC8\u7AEF\u673A\u4EE3\u7801","zh-Hant":"\u7AEF\u672B\u6A5F\u4EE3\u865F"},"RL_Till":{"ar":"\u0631\u0642\u0645 \u0635\u0646\u062F\u0648\u0642 \u0627\u0644\u062F\u0641\u0639","ca":"N\xfamero de la caixa","comment":"Number assigned to the Till to accept payments","cs":"\u010C\xedslo pokladny","da":"Kasseapparatsnummer","de":"Geldkassettennummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B1\u03BC\u03B5\u03AF\u03BF\u03C5","en":"Till Number","en-GB":"Till number","en-XA":"[\u0162\xee\u013C\u013C\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de caja registradora","es-AR":"N\xfamero de caja registradora","es-ES":"N\xfamero de caja","es-MX":"N\xfamero de caja registradora","fr":"Num\xe9ro de la caisse","hu":"P\xe9nzt\xe1r sz\xe1ma","id":"Nomor Mesin Kasir","it":"Numero di cassa","ja":"\u73FE\u91D1\u30C8\u30EC\u30A4\u306E\u756A\u53F7","key":"RL_Till","ko":"\uCD9C\uB0A9\uAE30 \uBC88\uD638","nb":"Kasseskuffnummer","nl":"Kassanummer","pl":"Numer kasy","pt-BR":"N\xfamero da c\xe9dula","pt-PT":"N\xfamero de caixa","ru":"\u041D\u043E\u043C\u0435\u0440 \u043A\u0430\u0441\u0441\u043E\u0432\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430","sv":"Kassal\xe5dans nummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E25\u0E34\u0E49\u0E19\u0E0A\u0E31\u0E01\u0E40\u0E01\u0E47\u0E1A\u0E40\u0E07\u0E34\u0E19","tr":"Para \xc7ekmecesi Numaras\u0131","zh-Hans":"\u6536\u94F6\u673A\u7F16\u53F7","zh-Hant":"\u6536\u9280\u6A5F\u7DE8\u865F"},"RL_Time":{"ar":"\u0627\u0644\u0648\u0642\u062A","ca":"Hora","comment":"Time of the transaction","cs":"Cas","da":"Tid","de":"Uhrzeit","el":"\u038F\u03C1\u03B1","en":"Time","en-GB":"Time","en-XA":"[\u0162\xee\u0271\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Hora","es-AR":"Hora","es-ES":"Hora","es-MX":"Hora","fr":"Heure","hu":"Time","id":"Waktu","it":"Ora","ja":"\u6642\u9593","key":"RL_Time","ko":"\uC2DC\uAC04","nb":"Tidspunkt","nl":"Tijd","pl":"Godzina","pt-BR":"Dura\xe7\xe3o","pt-PT":"Data","ru":"\u0412\u0440\u0435\u043C\u044F","sv":"Tid","th":"\u0E40\u0E27\u0E25\u0E32","tr":"Zaman","zh-Hans":"\u65F6\u95F4","zh-Hant":"\u6642\u9593"},"RL_TimeFormat":{"ar":"\u062A\u0646\u0633\u064A\u0642 \u0627\u0644\u0648\u0642\u062A","ca":"Format de l\'hora","comment":"The Time Format, eg UTC time of the transaction printed on the receipt. ","cs":"Form\xe1t \u010Dasu","da":"Tidsformat","de":"Zeitformat","el":"\u039C\u03BF\u03C1\u03C6\u03AE \u03CE\u03C1\u03B1\u03C2","en":"Time Format","en-GB":"Time Format","en-XA":"[\u0162\xee\u0271\xe9\u2002\u0191\xf6\u0155\u0271\xe5\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Formato de tiempo","es-AR":"Formato de hora","es-ES":"Formato de hora","es-MX":"Formato de tiempo","fr":"Format horaire","hu":"Id\u0151 form\xe1tuma","id":"Format Waktu","it":"Formato ora","ja":"\u6642\u9593\u306E\u5F62\u5F0F","key":"RL_TimeFormat","ko":"\uC2DC\uAC04 \uD615\uC2DD","nb":"Tidsformat","nl":"Tijdnotatie","pl":"Format czasu","pt-BR":"Formato de hora","pt-PT":"Formato da hora","ru":"\u0424\u043E\u0440\u043C\u0430\u0442 \u0432\u0440\u0435\u043C\u0435\u043D\u0438","sv":"Tidsformat","th":"\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E40\u0E27\u0E25\u0E32","tr":"Saat Format\u0131","zh-Hans":"\u65F6\u95F4\u683C\u5F0F","zh-Hant":"\u6642\u9593\u683C\u5F0F"},"RL_TobeshippedNIKEId":{"ar":"\u0644\u0644\u0634\u062D\u0646 - Nike By You","ca":"Env\xedo - Nike By You","comment":"To be shipped - NIKEiD","cs":"Chcete-li b\xfdt dod\xe1v\xe1ny  - Nike By You","da":"Klar til afsendelse - Nike By You","de":"Lieferanschrift - Nike By You","el":"\u03A0\u03C1\u03BF\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE - Nike By You","en":"To be shipped - Nike By You","en-GB":"To be delivered \u2013 Nike By You","en-XA":"[\u0162\xf6\u2002\u0180\xe9\u2002\u0161\u0125\xee\xfe\xfe\xe9\xf0\u2002\u2010\u2002\xd1\xee\u0137\xe9\u2002\u0181\xfd\u2002\xdd\xf6\xfb\u2002\xe5\u0180\xe7\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Para enviar: Nike By You","es-AR":"Para enviar: Nike By You","es-ES":"Env\xedo - Nike By You","es-MX":"Para enviar: Nike By You","fr":"\xc0 exp\xe9dier - Nike By You","hu":"To be shipped - Nike By You","id":"Akan dikirim - Nike By You","it":"Da spedire - Nike By You","ja":"\u767A\u9001\u6E96\u5099\u4E2D - Nike By You","key":"RL_TobeshippedNIKEId","ko":"\uBC30\uC1A1 \uC608\uC815 - Nike By You","nb":"Skal sendes \u2013 Nike By You","nl":"Wordt verzonden - Nike By You","pl":"Do wysy\u0142ki - Nike By You","pt-BR":"A ser enviado \u2013 Nike By You","pt-PT":"Por enviar - Nike By You","ru":"\u041A \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0435\xa0\u2014 Nike By You","sv":"Por enviar - Nike By You","th":"\u0E15\u0E49\u0E2D\u0E07\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07 - Nike By You","tr":"Kargoya verilecek - Senin Nike Tasar\u0131m\u0131n","zh-Hans":"\u5F85\u914D\u9001 - Nike By You","zh-Hant":"\u5F85\u51FA\u8CA8 \u2013 Nike By You"},"RL_TobeshippedNike":{"ar":"\u0644\u0644\u0634\u062D\u0646 - Nike.com","ca":"Env\xedo - Nike.com","comment":"To be shipped - Nike.com","cs":"Chcete-li b\xfdt dod\xe1v\xe1ny - Nike.com","da":"Klar til afsendelse - Nike.com","de":"Lieferanschrift - Nike.com","el":"\u03A0\u03C1\u03BF\u03C2 \u03B1\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE - Nike.com","en":"To be shipped - Nike.com","en-GB":"To be delivered \u2013 Nike.com","en-XA":"[\u0162\xf6\u2002\u0180\xe9\u2002\u0161\u0125\xee\xfe\xfe\xe9\xf0\u2002\u2010\u2002\xd1\xee\u0137\xe9\xb7\xe7\xf6\u0271\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Para enviar: Nike.com","es-AR":"Para enviar: Nike.com","es-ES":"Env\xedo - Nike.com","es-MX":"Para enviar: Nike.com","fr":"\xc0 exp\xe9dier - Nike.com","hu":"To be shipped - Nike.com","id":"Akan dikirim - Nike.com","it":"Da spedire - Nike.com","ja":"\u767A\u9001\u6E96\u5099\u4E2D - Nike.com","key":"RL_TobeshippedNike","ko":"\uBC30\uC1A1 \uC608\uC815 - Nike.com","nb":"Skal sendes \u2013 Nike.com","nl":"Wordt verzonden - Nike.com","pl":"Do wysy\u0142ki - Nike.com","pt-BR":"A ser enviado \u2014 Nike.com","pt-PT":"Por enviar - Nike.com","ru":"\u041A \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0435\xa0\u2014 Nike.com","sv":"Por enviar - Nike.com","th":"\u0E15\u0E49\u0E2D\u0E07\u0E08\u0E31\u0E14\u0E2A\u0E48\u0E07 - Nike.com","tr":"Kargoya verilecek - Nike.com","zh-Hans":"\u5F85\u914D\u9001 - Nike.com","zh-Hant":"\u5F85\u51FA\u8CA8 \u2013 Nike.com"},"RL_Total":{"ar":"\u0627\u0644\u0645\u062C\u0645\u0648\u0639","ca":"Total","comment":"Total of the transaction","cs":"Celkem","da":"Total","de":"Summe","el":"\u03A3\u03CD\u03BD\u03BF\u03BB\u03BF","en":"Total","en-GB":"Total","en-XA":"[\u0162\xf6\u0163\xe5\u013C\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Total","es-AR":"Total","es-ES":"Total","es-MX":"Total","fr":"Total","hu":"Total","id":"Total","it":"Totale","ja":"\u5408\u8A08 ","key":"RL_Total","ko":"\uD569\uACC4","nb":"Totalt","nl":"Totaal","pl":"Suma","pt-BR":"Total","pt-PT":"Total","ru":"\u0412\u0441\u0435\u0433\u043E","sv":"Totalt","th":"\u0E22\u0E2D\u0E14\u0E23\u0E27\u0E21","tr":"Toplam","zh-Hans":"\u603B\u8BA1","zh-Hant":"\u7E3D\u8A08"},"RL_Tran":{"ar":"\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"Tran","comment":"Transaction number abbreviation","cs":"Tran","da":"Tran","de":"Tran","el":"\u03A3\u03C5\u03BD\u03B1\u03BB.","en":"Tran","en-GB":"Tran","en-XA":"[\u0162\u0155\xe5\xf1\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Trans.","es-AR":"Trans","es-ES":"Tran","es-MX":"Trans.","fr":"Tran","hu":"Tran","id":"Tran","it":"Tran","ja":"Tran","key":"RL_Tran","ko":"\uC601\uC218 No","nb":"Tran","nl":"Trans","pl":"Transakcja","pt-BR":"Transa\xe7\xe3o","pt-PT":"Trans.","ru":"\u0422\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044F","sv":"Trans. nr.","th":"\u0E40\u0E25\u0E02\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"\u0130\u015Fl.","zh-Hans":"\u4EA4\u6613\u7F16\u53F7","zh-Hant":"\u4EA4\u6613\u7DE8\u865F"},"RL_TransactionAmount":{"ar":"\u0642\u064A\u0645\u0629 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"Transaction Amount","comment":"Transaction amount","cs":"Transaction Amount","da":"Bel\xf8b","de":"Kundenbetrag","el":"\u03A0\u03BF\u03C3\u03CC \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Transaction Amount","en-GB":"Transaction Amount","en-XA":"[\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\xc5\u0271\xf6\xfb\xf1\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Importe de transacci\xf3n","es-AR":"Importe de transacci\xf3n","es-ES":"Importe de la transacci\xf3n","es-MX":"Importe de transacci\xf3n","fr":"Transaction Amount","hu":"Transaction Amount","id":"Jumlah Transaksi","it":"Transaction Amount","ja":"Transaction Amount","key":"RL_TransactionAmount","ko":"\uAC70\uB798 \uAE08\uC561","nb":"Transaksjonsbel\xf8p","nl":"Transactiebedrag","pl":"Kwota transakcji","pt-BR":"Valor da transa\xe7\xe3o","pt-PT":"Montante da transa\xe7\xe3o","ru":"\u0421\u0443\u043C\u043C\u0430 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Transaktionsbelopp","th":"\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"\u0130\u015Flem Tutar\u0131","zh-Hans":"\u4EA4\u6613\u91D1\u989D","zh-Hant":"\u4EA4\u6613\u91D1\u984D"},"RL_TransactionInformation":{"ar":"\u0645\u0639\u0644\u0648\u0645\u0627\u062A \u062D\u0648\u0644 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"Informaci\xf3 de transacci\xf3","comment":"Transaction Information that includes date time, transaction number etc","cs":"Informace o\xa0transakci","da":"Transaktionsoplysninger","de":"Transaktionsinformation","el":"\u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Transaction Information","en-GB":"Transaction Information","en-XA":"[\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\xce\xf1\u0192\xf6\u0155\u0271\xe5\u0163\xee\xf6\xf1\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Informaci\xf3n de transacci\xf3n","es-AR":"Informaci\xf3n de la transacci\xf3n","es-ES":"Informaci\xf3n de la transacci\xf3n","es-MX":"Informaci\xf3n de la transacci\xf3n","fr":"Informations sur la transaction","hu":"Tranzakci\xf3 adatai","id":"Informasi Transaksi","it":"Informazioni sulla transazione","ja":"\u53D6\u5F15\u60C5\u5831","key":"RL_TransactionInformation","ko":"\uAC70\uB798 \uC815\uBCF4","nb":"Transaksjonsopplysninger","nl":"Transactiegegevens","pl":"Dane transakcji","pt-BR":"Informa\xe7\xf5es da transa\xe7\xe3o","pt-PT":"Informa\xe7\xf5es da transa\xe7\xe3o","ru":"\u0421\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043E \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Transaktionsinformation","th":"\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"\u0130\u015Flem Bilgileri","zh-Hans":"\u4EA4\u6613\u4FE1\u606F","zh-Hant":"\u4EA4\u6613\u8CC7\u8A0A"},"RL_TransactionNo":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"N.\xba transacci\xf3n","comment":"Transaction number generated ","cs":"Transaction No","da":"Transaktionsnr","de":"Transaktions-Nr","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Transaction No","en-GB":"Transaction No","en-XA":"[\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\xd1\xf6\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Numero De Transacci\xf3n","es-AR":"Numero De Transacci\xf3n","es-ES":"N.\xba transacci\xf3n","es-MX":"Transacci\xf3n N.\xba","fr":"No. de transaction","hu":"Transaction No","id":"No. Transaksi","it":"Transaction No","ja":"\u53D6\u5F15\u756A\u53F7","key":"RL_TransactionNo","ko":"\uAC70\uB798 \uBC88\uD638","nb":"Transaksjonsnr.","nl":"Transactienummer","pl":"Nr transakcji","pt-BR":"N\xb0 da transa\xe7\xe3o","pt-PT":"N.\xba da transa\xe7\xe3o","ru":"\u041D\u043E\u043C\u0435\u0440 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Transaktionsnr.","th":"\u0E40\u0E25\u0E02\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"\u0130\u015Flem No","zh-Hans":"\u4EA4\u6613\u7F16\u53F7","zh-Hant":"\u4EA4\u6613\u7DE8\u865F"},"RL_TransactionRepresentation":{"ar":"\u062A\u0645\u062B\u064A\u0644 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A","ca":"Representaci\xf3 de la transacci\xf3","comment":"Representation of a transaction in the Electronic Journal","cs":"Zobrazen\xed transakce","da":"Transaktionsrepr\xe6sentation","de":"Transaktionsdarstellung","el":"\u0391\u03BD\u03B1\u03C0\u03B1\u03C1\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Transaction Representation","en-GB":"Transaction Representation","en-XA":"[\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\u0154\xe9\xfe\u0155\xe9\u0161\xe9\xf1\u0163\xe5\u0163\xee\xf6\xf1\u2002\xe5\u0180\xe7\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Representaci\xf3n de la transacci\xf3n","es-AR":"Representaci\xf3n de la transacci\xf3n","es-ES":"Representaci\xf3n de la transacci\xf3n","es-MX":"Representaci\xf3n de la transacci\xf3n","fr":"Repr\xe9sentation de la transaction","hu":"Tranzakci\xf3 reprezent\xe1ci\xf3ja","id":"Representasi Transaksi","it":"Rappresentazione transazione","ja":"\u53D6\u5F15\u8868\u793A","key":"RL_TransactionRepresentation","ko":"\uAC70\uB798 \uB300\uD45C","nb":"Transaksjonsrepresentasjon","nl":"Representatie van transactie","pl":"Przedstawienie transakcji","pt-BR":"Representa\xe7\xe3o da transa\xe7\xe3o","pt-PT":"Representa\xe7\xe3o da transa\xe7\xe3o","ru":"\u041F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439","sv":"Transaktionsrepresentation","th":"\u0E04\u0E33\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"\u0130\u015Flem Temsili","zh-Hans":"\u4EA4\u6613\u6807\u793A\u7B26","zh-Hant":"\u4EA4\u6613\u4EE3\u8868"},"RL_TransactionType":{"ar":"\u0646\u0648\u0639 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"Tipus de transacci\xf3","comment":"Type of transaction - sales, returns etc.","cs":"Typ transakce","da":"Transaktionstype","de":"Transaktionsart","el":"\u03A4\u03CD\u03C0\u03BF\u03C2 \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Transaction Type","en-GB":"Transaction Type","en-XA":"[\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\u0162\xfd\xfe\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Tipo de transacci\xf3n","es-AR":"Tipo de transacci\xf3n","es-ES":"Tipo de transacci\xf3n","es-MX":"Tipo de transacci\xf3n","fr":"Type de transaction","hu":"Tranzakci\xf3 t\xedpusa","id":"Jenis Transaksi","it":"Tipo di transazione","ja":"\u53D6\u5F15\u306E\u7A2E\u985E","key":"RL_TransactionType","ko":"\uAC70\uB798 \uC720\uD615","nb":"Transaksjonstype","nl":"Type transactie","pl":"Typ transakcji","pt-BR":"Tipo de transa\xe7\xe3o","pt-PT":"Tipo de transa\xe7\xe3o","ru":"\u0422\u0438\u043F \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Transaktionstyp","th":"\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"\u0130\u015Flem T\xfcr\xfc","zh-Hans":"\u4EA4\u6613\u7C7B\u578B","zh-Hant":"\u4EA4\u6613\u985E\u578B"},"RL_TransactionUUID":{"ar":"\u0627\u0644\u0645\u0639\u0631\u0651\u0650\u0641 \u0627\u0644\u0641\u0631\u064A\u062F \u0627\u0644\u0639\u0627\u0644\u0645\u064A UUID \u0644\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"UUID de la transacci\xf3","comment":"UUID or unique Identifier  to identify a transaction ","cs":"UUID transakce","da":"UUID for transaktion","de":"UUID-Transaktion","el":"UUID \u03C3\u03C5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE\u03C2","en":"Transaction UUID","en-GB":"Transaction UUID","en-XA":"[\u0162\u0155\xe5\xf1\u0161\xe5\xe7\u0163\xee\xf6\xf1\u2002\xdb\xdb\xce\xd0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Identificador \xfanico de la transacci\xf3n","es-AR":"UUID de la transacci\xf3n","es-ES":"UUID de la transacci\xf3n","es-MX":"UUID de la transacci\xf3n","fr":"UUID de la transaction","hu":"Tranzakci\xf3s UUID","id":"UUID Transaksi","it":"UUID transazione","ja":"\u53D6\u5F15UUID","key":"RL_TransactionUUID","ko":"\uAC70\uB798 UUID","nb":"Transaksjons-UUID","nl":"Transactie UUID","pl":"Identyfikator UUID transakcji","pt-BR":"UUID da transa\xe7\xe3o","pt-PT":"UUID da transa\xe7\xe3o","ru":"UUID \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438","sv":"Transaktions-UUID","th":"UUID \u0E02\u0E2D\u0E07\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21","tr":"\u0130\u015Flem UUID\'si","zh-Hans":"\u4EA4\u6613 UUID","zh-Hant":"\u4EA4\u6613 UUID"},"RL_UPCcode":{"ar":"\u0631\u0645\u0632 UPC","ca":"Codi Universal de Producte","comment":"The UPC code of the item printed on the receipt. ","cs":"K\xf3d UPC","da":"Stregkode","de":"UPC Code","el":"\u039A\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2 UPC","en":"UPC Code","en-GB":"UPC","en-XA":"[\xdb\xde\xc7\u2002\xc7\xf6\xf0\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"C\xf3digo UPC","es-AR":"C\xf3digo de barras","es-ES":"C\xf3digo UPC","es-MX":"C\xf3digo de barra","fr":"Code UPC","hu":"UPC-k\xf3d","id":"Kode UPC","it":"Codice UPC","ja":"UPC\u30B3\u30FC\u30C9","key":"RL_UPCcode","ko":"UPC \uCF54\uB4DC","nb":"Strekkode","nl":"UPC-code","pl":"Kod UPC","pt-BR":"C\xf3digo UPC","pt-PT":"C\xf3digo UPC","ru":"\u041A\u043E\u0434 UPC","sv":"UPC-kod","th":"\u0E23\u0E2B\u0E31\u0E2A UPC","tr":"UPC Kodu","zh-Hans":"UPC \u7801","zh-Hant":"UPC \u4EE3\u78BC"},"RL_UnnamedItem":{"ar":"\u0645\u0646\u062A\u062C \u0644\u0627 \u064A\u062D\u0645\u0644 \u0627\u0633\u0645\u064B\u0627","ca":"PRODUCTE SENSE NOM","comment":"All caps placeholder text for an item that didn\'t have a name on a receipt","cs":"POLO\u017DKA BEZ N\xc1ZVU","da":"IKKE ANGIVET VARE","de":"UNBENANNTES PRODUKT","el":"\u0395\u0399\u0394\u039F\u03A3 \u03A7\u03A9\u03A1\u0399\u03A3 \u039F\u039D\u039F\u039C\u0391","en":"UNNAMED ITEM","en-GB":"UNNAMED ITEM","en-XA":"[\xdb\xd1\xd1\xc5\u1E40\xc9\xd0\u2002\xce\u0162\xc9\u1E40\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"PRODUCTO SIN NOMBRE","es-AR":"PRODUCTO SIN NOMBRE","es-ES":"PRODUCTO SIN NOMBRE","es-MX":"PRODUCTO SIN NOMBRE","fr":"ARTICLE SANS NOM","hu":"N\xc9VTELEN TERM\xc9K","id":"ITEM TANPA NAMA","it":"ARTICOLO SENZA NOME","ja":"\u7121\u540D\u306E\u5546\u54C1","key":"RL_UnnamedItem","ko":"\uC774\uB984 \uC5C6\uB294 \uC544\uC774\uD15C","nb":"VARE UTEN NAVN","nl":"NAAMLOOS ITEM","pl":"PRZEDMIOT BEZ NAZWY","pt-BR":"ITEM SEM NOME","pt-PT":"ARTIGO SEM NOME","ru":"\u0422\u041E\u0412\u0410\u0420 \u0411\u0415\u0417 \u041D\u0410\u0417\u0412\u0410\u041D\u0418\u042F","sv":"PRODUKT UTAN NAMN","th":"\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E44\u0E21\u0E48\u0E21\u0E35\u0E0A\u0E37\u0E48\u0E2D","tr":"ADSIZ \xdcR\xdcN","zh-Hans":"\u672A\u547D\u540D\u5546\u54C1","zh-Hant":"\u7121\u540D\u7A31\u54C1\u9805"},"RL_VOIDED":{"ca":"ANULADO","comment":"phrase to indicate the voided transaction","cs":"ZNEPLAT","da":"UGYLDIGGJORT","de":"ENTWERTET","el":"\u0391\u039A\u03A5\u03A1\u03A9\u0398\u0397\u039A\u0395","en":"VOIDED","en-GB":"VOIDED","en-XA":"[\u1E7C\xd6\xce\xd0\xc9\xd0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"ANULADO","es-AR":"ANULADO","es-ES":"ANULADO","es-MX":"ANULADO","fr":"ANNUL\xc9","hu":"VOIDED","id":"BATAL","it":"ANNULLATO","ja":"VOIDED","key":"RL_VOIDED","ko":"\uCDE8\uC18C\uB428","nb":"ANNULLERT","nl":"GEANNULEERD","pl":"ANULOWANY","pt-BR":"ANULADO","pt-PT":"ANULADO","ru":"VOIDED","sv":"MAKULERAD","th":"\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30","tr":"\u0130PTAL ED\u0130LD\u0130","zh-Hans":"\u5DF2\u64A4\u9500","zh-Hant":"\u5DF2\u4F5C\u5EE2"},"RL_VOIDTRANSACTION":{"ca":"ANULAR TRANSACCI\xd3N","comment":"A line in receipt indicating that the particular transaction is voided.","cs":"VOID TRANSACTION","da":"ANNULLERET TRANSAKTION","de":"ENTWERTETE TRANSAKTION","el":"\u0391\u039A\u03A5\u03A1\u0397 \u03A3\u03A5\u039D\u0391\u039B\u039B\u0391\u0393\u0397","en":"VOID TRANSACTION","en-GB":"VOID TRANSACTION","en-XA":"[\u1E7C\xd6\xce\xd0\u2002\u0162\u0154\xc5\xd1\u0160\xc5\xc7\u0162\xce\xd6\xd1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"ANULAR TRANSACCI\xd3N","es-AR":"ANULAR TRANSACCI\xd3N","es-ES":"ANULAR TRANSACCI\xd3N","es-MX":"ANULAR TRANSACCI\xd3N","fr":"ANNULER LA TRANSACTION","hu":"VOID TRANSACTION","id":"TRANSAKSI BATAL","it":"ANNULLA TRANSAZIONE","ja":"VOID TRANSACTION","key":"RL_VOIDTRANSACTION","ko":"\uCDE8\uC18C\uB41C \uAC70\uB798","nb":"UGYLDIG TRANSAKSJON","nl":"GEANNULEERDE TRANSACTIE","pl":"ANULOWANIE TRANSAKCJI","pt-BR":"TRANSA\xc7\xc3O ANULADA","pt-PT":"ANULAR TRANSA\xc7\xc3O","ru":"\u0410\u041D\u041D\u0423\u041B\u0418\u0420\u041E\u0412\u0410\u0422\u042C \u0422\u0420\u0410\u041D\u0417\u0410\u041A\u0426\u0418\u042E","sv":"MAKULERA TRANSAKTION","th":"\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E42\u0E21\u0E06\u0E30","tr":"GE\xc7ERS\u0130Z \u0130\u015ELEM","zh-Hans":"\u64A4\u9500\u4EA4\u6613","zh-Hant":"\u4F5C\u5EE2\u4EA4\u6613"},"RL_Void":{"ar":"\u0645\u0644\u063A\u0627\u0629","ca":"Anul\xb7lades","comment":"Transactions that of voided status.","cs":"Pr\xe1zdn\xe1","da":"Annulleret","de":"Ung\xfcltig","el":"\u0386\u03BA\u03C5\u03C1\u03B5\u03C2","en":"Void","en-GB":"Void","en-XA":"[\u1E7C\xf6\xee\xf0\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Anulada","es-AR":"Anular","es-ES":"Anulado","es-MX":"Invalidar","fr":"Vide","hu":"Sztorn\xf3z\xe1s","id":"Batal","it":"Non valide","ja":"\u7121\u52B9\u5316","key":"RL_Void","ko":"\uBE44\uC6B0\uAE30","nb":"Ugyldig","nl":"Ongeldig","pl":"Pusty","pt-BR":"Anulado","pt-PT":"Anulada","ru":"\u0410\u043D\u043D\u0443\u043B\u0438\u0440\u043E\u0432\u0430\u0442\u044C","sv":"Annullera","th":"\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01","tr":"\u0130ptal","zh-Hans":"\u65E0\u6548","zh-Hant":"\u4F5C\u5EE2"},"RL_Voucher":{"ar":"\u0642\u0633\u064A\u0645\u0629","ca":"Vale","comment":"Voucher","cs":"Poukaz","da":"V\xe6rdibevis","de":"Gutschein","el":"\u039A\u03BF\u03C5\u03C0\u03CC\u03BD\u03B9","en":"Voucher","en-GB":"Voucher","en-XA":"[\u1E7C\xf6\xfb\xe7\u0125\xe9\u0155\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Vale","es-AR":"Vale","es-ES":"Vale","es-MX":"Vale","fr":"Bon","hu":"Voucher","id":"Voucher","it":"Voucher","ja":"\u5F15\u63DB\u5238","key":"RL_Voucher","ko":"\uBC14\uC6B0\uCC98","nb":"Kupong","nl":"Voucher","pl":"Voucher","pt-BR":"Voucher","pt-PT":"Voucher","ru":"\u0412\u0430\u0443\u0447\u0435\u0440","sv":"Kupong","th":"\u0E1A\u0E31\u0E15\u0E23\u0E01\u0E33\u0E19\u0E31\u0E25","tr":"Hediye Kuponu","zh-Hans":"\u4EE3\u91D1\u5238","zh-Hant":"\u512A\u60E0\u5238"},"RL_YouSaved":{"ar":"\u0644\u0642\u062F \u0648\u0641\u0651\u0631\u062A {amount} \u0627\u0644\u064A\u0648\u0645","ca":"Avui has estalviat {amount}","comment":"Phrase showing the savings a customer had on a receipt due to discounts. {amount} to be filled programmatically and not translated","cs":"Dnes u\u0161et\u0159eno celkem {amount}","da":"Du sparede {amount} i dag","de":"Sie haben heute {amount} gespart","el":"\u039A\u03B5\u03C1\u03B4\u03AF\u03C3\u03B1\u03C4\u03B5 {amount} \u03C3\u03AE\u03BC\u03B5\u03C1\u03B1","en":"You saved {amount} today","en-GB":"You saved {amount} today","en-XA":"[\xdd\xf6\xfb\u2002\u0161\xe5\u1E7D\xe9\xf0\u2002{amount}\u2002\u0163\xf6\xf0\xe5\xfd\u2002\xe5\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Hoy ahorraste {amount}","es-AR":"Hoy ahorraste {amount}","es-ES":"Hoy has ahorrado {amount}","es-MX":"Ahorraste {amount} el d\xeda de hoy","fr":"Vous avez \xe9conomis\xe9 {amount} aujourd\'hui","hu":"Mai megtakar\xedt\xe1s: {amount}","id":"Anda menghemat {amount} hari ini","it":"Oggi hai risparmiato {amount}","ja":"{amount}\u5186\u5206\u306E\u5272\u5F15\u304C\u9069\u7528\u3055\u308C\u307E\u3057\u305F","key":"RL_YouSaved","ko":"{amount} \uC6D0 \uD560\uC778 \uB418\uC5C8\uC2B5\uB2C8\uB2E4.","nb":"Du sparte {amount} i dag","nl":"U heeft vandaag {amount} bespaard","pl":"Dzisiejsza oszcz\u0119dno\u015B\u0107: {amount}","pt-BR":"Voc\xea economizou {amount} hoje","pt-PT":"Poupaste {amount} hoje","ru":"\u0421\u0435\u0433\u043E\u0434\u043D\u044F \u0432\u044B \u0441\u044D\u043A\u043E\u043D\u043E\u043D\u043E\u043C\u0438\u043B\u0438 {amount}","sv":"Du har sparat {amount} idag","th":"\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E1B\u0E23\u0E30\u0E2B\u0E22\u0E31\u0E14\u0E44\u0E14\u0E49 {amount}","tr":"Bug\xfcn {amount} tutar\u0131nda tasarruf ettin","zh-Hans":"\u672C\u6B21\u8D2D\u7269\u60A8\u8282\u7EA6\u4E86 {amount}","zh-Hant":"\u4F60\u4ECA\u5929\u7701\u4E0B\u4E86 {amount}"},"RL_eCommerceID":{"ar":"\u0645\u0639\u0631\u0651\u0641 \u0627\u0644\u062A\u062C\u0627\u0631\u0629 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u0629","ca":"E-commerce ID","comment":"eCommerce ID field in receipt line","cs":"eCommerce ID","da":"eHandel-id","de":"eCommerce ID","el":"\u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC eCommerce","en":"eCommerce ID","en-GB":"eCommerce ID","en-XA":"[\xe9\xc7\xf6\u0271\u0271\xe9\u0155\xe7\xe9\u2002\xce\xd0\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"ID de comercio electr\xf3nico","es-AR":"ID de comercio electr\xf3nico","es-ES":"ID eCommerce","es-MX":"ID de comercio electr\xf3nico","fr":"id eCommerce","hu":"eCommerce ID","id":"ID eCommerce","it":"ID eCommerce","ja":"e\u30B3\u30DE\u30FC\u30B9ID","key":"RL_eCommerceID","ko":"e\uCEE4\uBA38\uC2A4 ID","nb":"e-handel-ID","nl":"eCommerce ID","pl":"ID eCommerce","pt-BR":"ID de eCommerce","pt-PT":"ID de com\xe9rcio eletr\xf3nico","ru":"\u041D\u043E\u043C\u0435\u0440 eCommerce","sv":"e-handels-id","th":"eCommerce ID","tr":"E-Ticaret Kimli\u011Fi","zh-Hans":"\u7535\u5B50\u5546\u52A1 ID","zh-Hant":"\u96FB\u5546 ID"},"RL_eMoney":{"ar":"eMoney","ca":"eMoney","comment":"eMoney","cs":"eMoney","da":"eMoney","de":"eGeld","el":"eMoney","en":"eMoney","en-GB":"eMoney","en-XA":"[\xe9\u1E40\xf6\xf1\xe9\xfd\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"eMoney","es-AR":"eMoney","es-ES":"eMoney","es-MX":"eMoney","fr":"Argent \xe9lectronique","hu":"eMoney","id":"eMoney","it":"eMoney","ja":"eMoney","key":"RL_eMoney","ko":"\uC804\uC790 \uD654\uD3D0","nb":"eMoney","nl":"eMoney","pl":"eMoney","pt-BR":"eMoney","pt-PT":"eMoney","ru":"eMoney","sv":"eMoney","th":"eMoney","tr":"E-Para","zh-Hans":"eMoney","zh-Hant":"eMoney"},"RL_eWallet":{"ar":"eWallet","ca":"eWallet","comment":"eWallet","cs":"eWallet","da":"eWallet","de":"eWallet","el":"eWallet","en":"eWallet","en-GB":"eWallet","en-XA":"[\xe9\u0174\xe5\u013C\u013C\xe9\u0163\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"eWallet","es-AR":"eWallet","es-ES":"eWallet","es-MX":"eWallet","fr":"eWallet","hu":"eWallet","id":"eWallet","it":"eWallet","ja":"eWallet","key":"RL_eWallet","ko":"\uC804\uC790 \uC9C0\uAC11","nb":"eWallet","nl":"eWallet","pl":"eWallet","pt-BR":"eWallet","pt-PT":"eWallet","ru":"\u042D\u043B. \u043A\u043E\u0448\u0435\u043B\u0435\u043A","sv":"eWallet","th":"eWallet","tr":"E-C\xfczdan","zh-Hans":"\u7535\u5B50\u94B1\u5305","zh-Hant":"eWallet"},"RL_returnRcpt":{"ar":"\u0625\u064A\u0635\u0627\u0644 \u0627\u0644\u0625\u0631\u062C\u0627\u0639","ca":"Tiquet de Dev","comment":"Return Receipt","cs":"Pr\xedjem Vr\xe1cen\xed","da":"Returner bon","de":"Reklamationsbeleg","el":"\u0391\u03C0\u03CC\u03B4\u03B5\u03B9\u03BE\u03B7 \u03B5\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE\u03C2","en":"Return Receipt","en-GB":"Return Receipt","en-XA":"[\u0154\xe9\u0163\xfb\u0155\xf1\u2002\u0154\xe9\xe7\xe9\xee\xfe\u0163\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Recibo para devoluciones","es-AR":"Recibo para devoluciones","es-ES":"Tiquet de Dev","es-MX":"Recibo para devoluciones","fr":"Re\xe7u de retour.","hu":"Return Receipt","id":"Tanda Terima Pengembalian","it":"Ricevuta reso","ja":"\u8FD4\u54C1\u30EC\u30B7\u30FC\u30C8","key":"RL_returnRcpt","ko":"\uBC18\uD488 \uC601\uC218\uC99D","nb":"Returkvittering","nl":"Bon Retour","pl":"Dowod zwrotu","pt-BR":"Recibo de devolu\xe7\xe3o","pt-PT":"Recibo Devolucao","ru":"\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u043E \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0435","sv":"Returkvitto","th":"\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E01\u0E32\u0E23\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","tr":"\u0130ade Makbuzu","zh-Hans":"\u8FD4\u56DE\u6536\u636E","zh-Hant":"\u9000\u8CA8\u6536\u64DA"},"RL_\u201CstringCash_Change\u201D":{"ar":"\u0628\u0627\u0642\u064A \u0627\u0644\u0646\u0642\u0648\u062F","ca":"Canvi en efectiu","comment":" To change \\"Wijzig\\" into \\"Wisselgeld\\" local language?","cs":"Vr\xe1tit","da":"Kontant byttepenge","de":"Wechselgeld","el":"\u039C\u03B5\u03C4\u03B1\u03B2\u03BF\u03BB\u03AE \u03BC\u03B5\u03C4\u03C1\u03B7\u03C4\u03CE\u03BD","en":"Cash Change","en-GB":"Cash Change","en-XA":"[\xc7\xe5\u0161\u0125\u2002\xc7\u0125\xe5\xf1\u011D\xe9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Cambio de efectivo","es-AR":"Cambio en efectivo","es-ES":"Cambio en efectivo","es-MX":"Cambio de efectivo","fr":"Rendu monnaie","hu":"K\xe9szp\xe9nz-visszaj\xe1r\xf3","id":"Kembalian","it":"Resto contanti","ja":"\u304A\u91E3\u308A","key":"RL_\u201CstringCash_Change\u201D","ko":"\uD604\uAE08 \uC794\uC561","nb":"Vekselpenger","nl":"Contant wisselgeld","pl":"Reszta w got\xf3wce","pt-BR":"Troco","pt-PT":"Troco","ru":"\u0421\u0434\u0430\u0447\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u044B\u043C\u0438","sv":"Kontant v\xe4xel","th":"\u0E40\u0E07\u0E34\u0E19\u0E17\u0E2D\u0E19","tr":"Nakit Para \xdcst\xfc","zh-Hans":"\u73B0\u91D1\u627E\u96F6","zh-Hant":"\u73FE\u91D1\u8B8A\u5316"},"RegisterNumber":{"ar":"\u0631\u0642\u0645 \u0627\u0644\u062A\u0633\u062C\u064A\u0644","ca":"N\xfamero de caixa","comment":"Register Number","cs":"\u010C\xedslo pokladny","da":"Kassenummer","de":"Kassennummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03C4\u03B1\u03BC\u03B5\u03AF\u03BF\u03C5","en":"Register Number","en-GB":"Register Number","en-XA":"[\u0154\xe9\u011D\xee\u0161\u0163\xe9\u0155\u2002\xd1\xfb\u0271\u0180\xe9\u0155\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"N\xfamero de caja","es-AR":"N\xfamero de caja","es-ES":"N\xfamero de caja","es-MX":"N\xfamero de caja","fr":"Num\xe9ro de caisse","hu":"Kassza sz\xe1ma","id":"Nomor Registrasi","it":"Numero di cassa","ja":"\u30EC\u30B8\u30B9\u30BF\u30FC\u756A\u53F7","key":"RegisterNumber","ko":"\uB4F1\uB85D \uBC88\uD638","nb":"Kassenummer","nl":"Kassanummer","pl":"Numer kasy","pt-BR":"N\xfamero do registro","pt-PT":"N\xfamero de caixa reg.","ru":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043A\u0430\u0441\u0441\u044B","sv":"Kassanummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E25\u0E07\u0E17\u0E30\u0E40\u0E1A\u0E35\u0E22\u0E19","tr":"Kasa Numaras\u0131","zh-Hans":"\u6536\u94F6\u673A\u7F16\u53F7","zh-Hant":"\u6536\u9280\u6A5F\u7DE8\u865F"},"ReturnWithoutReceipt":{"ar":"\u0625\u0631\u062C\u0627\u0639 \u0645\u0646 \u062F\u0648\u0646 \u0625\u064A\u0635\u0627\u0644","ca":"DEVOLUCI\xd3 SENSE REBUT","comment":"Prints in all caps above returned items on a receipt where the original receipt was not provided","cs":"VR\xc1CEN\xcd BEZ DOKLADU","da":"RETURNERING UDEN KVITTERING","de":"R\xdcCKGABE OHNE BELEG","el":"\u0395\u03A0\u0399\u03A3\u03A4\u03A1\u039F\u03A6\u0397 \u03A7\u03A9\u03A1\u0399\u03A3 \u0391\u03A0\u039F\u0394\u0395\u0399\u039E\u0397","en":"RETURN WITHOUT RECEIPT","en-GB":"RETURN WITHOUT RECEIPT","en-XA":"[\u0154\xc9\u0162\xdb\u0154\xd1\u2002\u0174\xce\u0162\u0124\xd6\xdb\u0162\u2002\u0154\xc9\xc7\xc9\xce\xde\u0162\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"DEVOLUCI\xd3N SIN RECIBO","es-AR":"DEVOLUCI\xd3N SIN RECIBO","es-ES":"DEVOLUCI\xd3N EN TIENDA SIN RECIBO","es-MX":"DEVOLUCI\xd3N SIN RECIBO","fr":"RETOUR SANS RE\xc7U","hu":"VISSZAK\xdcLD\xc9S SZ\xc1MLA N\xc9LK\xdcL","id":"PENGEMBALIAN TANPA TANDA TERIMA","it":"RESO SENZA RICEVUTA","ja":"\u30EC\u30B7\u30FC\u30C8\u306A\u3057\u306E\u8FD4\u54C1","key":"ReturnWithoutReceipt","ko":"\uC601\uC218\uC99D \uC5C6\uB294 \uBC18\uD488","nb":"RETUR UTEN KVITTERING","nl":"RETOUR ZONDER BON","pl":"ZWROT BEZ PARAGONU","pt-BR":"DEVOLU\xc7\xc3O SEM RECIBO","pt-PT":"DEVOLU\xc7\xc3O SEM RECIBO","ru":"\u0412\u041E\u0417\u0412\u0420\u0410\u0422 \u0411\u0415\u0417 \u0427\u0415\u041A\u0410","sv":"RETUR UTAN KVITTO","th":"\u0E04\u0E37\u0E19\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E21\u0E35\u0E43\u0E1A\u0E40\u0E2A\u0E23\u0E47\u0E08","tr":"MAKBUZ OLMADAN \u0130ADE","zh-Hans":"\u65E0\u6536\u636E\u9000\u6362\u8D27","zh-Hant":"\u7121\u6536\u64DA\u9000\u8CA8"},"ReturnedItemsEnd":{"ca":"Fi de la devoluci\xf3","comment":"Line in receipt stating the end of a list of items that were returned to the store","cs":"Konec vr\xe1cen\xed","da":"Slut p\xe5 returvarer","de":"Umtausch beendet","en":"End of Return","en-XA":"[\xc9\xf1\xf0\u2002\xf6\u0192\u2002\u0154\xe9\u0163\xfb\u0155\xf1\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Fin de devoluci\xf3n","es-AR":"Fin de la devoluci\xf3n","es-ES":"T\xe9rmino Devoluci\xf3n","es-MX":"Final de la devoluci\xf3n","fr":"Fin retour","hu":"Visszak\xfcld\xe9s v\xe9ge","it":"Fine del reso","ja":"\u8FD4\u54C1\u3055\u308C\u305F\u5546\u54C1\u306F\u3053\u3053\u307E\u3067","key":"ReturnedItemsEnd","ko":"\uBC18\uD488 \uBAA9\uB85D \uB05D","nb":"Slutt p\xe5 retur","nl":"Einde Retour","pl":"Koniec listy zwrot\xf3w","pt-PT":"Fim da devolu\xe7\xe3o","ru":"\u041A\u043E\u043D\u0435\u0446 \u0441\u043F\u0438\u0441\u043A\u0430 \u0442\u043E\u0432\u0430\u0440\u043E\u0432","sv":"Inga fler returer","tr":"\u0130ade Sonu","zh-Hans":"\u9000\u6362\u8D27\u5546\u54C1\u6E05\u5355\u672B\u5C3E","zh-Hant":"\u9000\u8CA8\u7D50\u675F"},"TRAININGMODE":{"ar":"\u0648\u0636\u0639 \u0627\u0644\u062A\u062F\u0631\u064A\u0628","ca":"Modo Training","comment":"Training Mode Indicator","cs":"V\xfdukov\xfd re\u017Eim","da":"TR\xc6NINGSTILSTAND","de":"Ausbildung / Training","el":"\u039B\u0395\u0399\u03A4\u039F\u03A5\u03A1\u0393\u0399\u0391 \u0395\u039A\u03A0\u0391\u0399\u0394\u0395\u03A5\u03A3\u0397\u03A3","en":"TRAINING MODE","en-GB":"TRAINING MODE","en-XA":"[\u0162\u0154\xc5\xce\xd1\xce\xd1\u011C\u2002\u1E40\xd6\xd0\xc9\u2002\u041F\u03B2\u30B7\u8010\u514B\u0E1A\u0E31\u0E49\u2002\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"MODALIDAD DE ENTRENAMIENTO","es-AR":"MODALIDAD DE ENTRENAMIENTO","es-ES":"MODO FORMACI\xd3N","es-MX":"MODO DE CAPACITACI\xd3N","fr":"MODE FORMATION","hu":"TRAINING MODE","id":"MODE LATIHAN","it":"MODALIT\xc0 ADDESTRAMENTO","ja":"TRAINING MODE","key":"TRAININGMODE","ko":"\uD2B8\uB808\uC774\uB2DD \uBAA8\uB4DC","nb":"OPPL\xc6RINGSMODUS","nl":"TRAININGSMODUS","pl":"TRYB TRENINGOWY","pt-BR":"MODO DE TREINO","pt-PT":"MODO DE TREINO","ru":"\u0420\u0415\u0416\u0418\u041C \u041E\u0411\u0423\u0427\u0415\u041D\u0418\u042F","sv":"UTBILDNINGSL\xc4GE","th":"\u0E42\u0E2B\u0E21\u0E14\u0E17\u0E14\u0E25\u0E2D\u0E07\u0E43\u0E0A\u0E49","tr":"E\u011E\u0130T\u0130M MODU","zh-Hans":"\u57F9\u8BAD\u6A21\u5F0F","zh-Hant":"\u8A13\u7DF4\u6A21\u5F0F"},"Test":{"ar":"\u0627\u062E\u062A\u0628\u0627\u0631","ca":"Prova","comment":"Testing bodega!!","cs":"Test","da":"Test","de":"Test","el":"\u0394\u03BF\u03BA\u03B9\u03BC\u03AE","en":"Test","en-GB":"Test","en-XA":"[\u0162\xe9\u0161\u0163\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Prueba","es-AR":"Prueba","es-ES":"Prueba","es-MX":"Prueba","fr":"Test","hu":"Teszt","id":"Tes","it":"Test","ja":"\u30C6\u30B9\u30C8","key":"Test","ko":"\uD14C\uC2A4\uD2B8","nb":"Test","nl":"Test","pl":"Test","pt-BR":"Teste","pt-PT":"Teste","ru":"Test","sv":"Test","th":"\u0E01\u0E32\u0E23\u0E17\u0E14\u0E2A\u0E2D\u0E1A","tr":"Test","zh-Hans":"\u6D4B\u8BD5","zh-Hant":"\u6E2C\u8A66"},"TxRef":{"ar":"\u0645\u0631\u062C\u0639 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"TxRef","comment":"Tax reference for the card based transaction","cs":"TxRef","da":"TxRef","de":"TxRef","el":"TxRef","en":"TxRef","en-GB":"TxRef","en-XA":"[\u0162\u1E8B\u0154\xe9\u0192\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"TxRef","es-AR":"TxRef","es-ES":"TxRef","es-MX":"TxRef","fr":"TxRef","hu":"TxRef","id":"TxRef","it":"TxRef","ja":"TxRef","key":"TxRef","ko":"\uC138\uAE08 \uD658\uBD88","nb":"TxRef","nl":"TxRef","pl":"Nr rejestracji podatkowej","pt-BR":"RefTx","pt-PT":"Ref. fiscal","ru":"TxRef","sv":"Momsref.","th":"TxRef","tr":"TxRef","zh-Hans":"\u7A0E\u8D39\u53C2\u8003","zh-Hant":"\u7A05\u91D1\u53C3\u8003"},"TxType":{"ar":"\u0646\u0648\u0639 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0629","ca":"TxType","comment":"Card type for the card based transaction","cs":"TxType","da":"TxType","de":"TxType","el":"TxType","en":"TxType","en-GB":"TxType","en-XA":"[\u0162\u1E8B\u0162\xfd\xfe\xe9\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"TxType","es-AR":"TxType","es-ES":"TxType","es-MX":"TxType","fr":"TxType","hu":"TxType","id":"TxType","it":"TxType","ja":"TxType","key":"TxType","ko":"\uC138\uAE08 \uC720\uD615","nb":"Avgiftstype","nl":"TxType","pl":"TxType","pt-BR":"TipoTx","pt-PT":"Tipo de cart\xe3o","ru":"TxType","sv":"Korttyp","th":"TxType","tr":"TxTip","zh-Hans":"\u5361\u79CD","zh-Hant":"\u5361\u5225"},"UI_Cash":{"ar":"\u0627\u0644\u0645\u0628\u0644\u063A \u0627\u0644\u0646\u0642\u062F\u064A","ca":"Efectivo","comment":"Cash","cs":"Hotovost","da":"KR.","de":"Bar","el":"\u039C\u03B5\u03C4\u03C1\u03B7\u03C4\u03AC","en":"Cash","en-GB":"Cash","en-XA":"[\xc7\xe5\u0161\u0125\u2002\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Efectivo","es-AR":"Efectivo","es-ES":"Efectivo","es-MX":"Efectivo","fr":"Cash","hu":"Cash","id":"Uang Tunai","it":"Contanti","ja":"\u73FE\u91D1","key":"UI_Cash","ko":"\uD604\uAE08","nb":"Kontanter","nl":"Contant","pl":"Got\xf3wka","pt-BR":"Dinheiro","pt-PT":"Dinheiro","ru":"\u041D\u0430\u043B\u0438\u0447\u043D\u044B\u0435","sv":"Kontant","th":"\u0E40\u0E07\u0E34\u0E19\u0E2A\u0E14","tr":"Nakit","zh-Hans":"\u73B0\u91D1","zh-Hant":"\u73FE\u91D1"},"WeChatPay":{"ca":"Pagament amb WeChat","comment":"Denotes a payment done through WeChat Pay","cs":"Platit p\u0159es WeChat","da":"WeChat Pay","de":"WeChat Pay","en":"WeChat Pay","en-XA":"[\u0174\xe9\xc7\u0125\xe5\u0163\u2002\xde\xe5\xfd\u2002\xe5\u8010\u514B\u0E23\u0E37\u0E48\u0628\u064F\u0648]","es-419":"Pago mediante WeChat","es-AR":"WeChat Pay","es-ES":"WeChat Pay","es-MX":"WeChat Pay","fr":"WeChat Pay","hu":"WeChat Pay","it":"WeChat Pay","ja":"WeChat Pay","key":"WeChatPay","nb":"WeChat Pay","nl":"WeChat Pay","pl":"P\u0142atno\u015B\u0107 w systemie WeChat Pay","pt-PT":"WeChat Pay","ru":"WeChat Pay","sv":"WeChat Pay","tr":"WeChat Pay","zh-Hans":"\u5FAE\u4FE1\u652F\u4ED8","zh-Hant":"WeChat Pay"}}');

});


parcelRegister("iO0MQ", function(module, exports) {

var $9AZuj = parcelRequire("9AZuj");
/*
  Translate word based on locale passed in.
  If locale translation does not exist, split off the language from the locale and translate based on that language.
*/ module.exports = (word, language, ...args)=>{
    let translation = null;
    try {
        translation = $9AZuj[word][language] || $9AZuj[word][language.split("-")[0]] || null;
        // Replacing dynamic strings
        args.forEach((arg, i)=>{
            if ([
                "string",
                "number"
            ].includes(typeof arg)) translation = translation.replace(`{{${i + 1}}}`, arg);
        });
        return translation;
    } catch (err) {
        return null;
    }
};

});
parcelRegister("9AZuj", function(module, exports) {
module.exports = JSON.parse('{"RL_Active":{"key":"RL_Active","en":"Active","ca-ES":"Actiu","ca":"Actiu","cs-CZ":"Aktivn\xed","cs":"Aktivn\xed","da-DK":"Aktiv","da":"Aktiv","de-DE":"Aktiv","de":"Aktiv","el-GR":"\u0395\u03BD\u03B5\u03C1\u03B3\u03CC","el":"\u0395\u03BD\u03B5\u03C1\u03B3\u03CC","en-GB":"Active","es-ES":"Activo(s)","es":"Activo(s)","fi-FI":"Aktiivinen","fr-FR":"Actif","fr":"Actif","he-IL":"\u05E4\u05E2\u05D9\u05DC","hr-HR":"Aktivno","hu-HU":"Akt\xedv","hu":"Akt\xedv","it-IT":"Attivo","it":"Attivo","ja-JP":"\u30A2\u30AF\u30C6\u30A3\u30D6","ja":"\u30A2\u30AF\u30C6\u30A3\u30D6","ko-KR":"\uD65C\uC131","ko":"\uD65C\uC131","nl-NL":"Actief","nl":"Actief","no-NO":"Aktive","pl-PL":"Aktywny","pl":"Aktywny","pt-BR":"Ativar","pt-PT":"Ativo","ru-RU":"\u0410\u043A\u0442\u0438\u0432\u043D\u043E","ru":"\u0410\u043A\u0442\u0438\u0432\u043D\u043E","sv-SE":"Aktiv","sv":"Aktiv","th-TH":"\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E39\u0E48","th":"\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2D\u0E22\u0E39\u0E48","tr-TR":"Etkin","tr":"Etkin"},"RL_Add":{"key":"RL_Add","en":"Add","ca-ES":"Afegeix","ca":"Afegeix","cs-CZ":"P\u0159idat","cs":"P\u0159idat","da-DK":"Tilf\xf8j","da":"Tilf\xf8j","de-DE":"Hinzuf\xfcgen","de":"Hinzuf\xfcgen","el-GR":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7","el":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7","en-GB":"Add","es-ES":"A\xf1adir","es":"A\xf1adir","fi-FI":"Lis\xe4\xe4","fr-FR":"Ajouter","fr":"Ajouter","he-IL":"\u05D4\u05D5\u05E1\u05E4\u05D4","hr-HR":"Dodaj","hu-HU":"Hozz\xe1ad\xe1s","hu":"Hozz\xe1ad\xe1s","it-IT":"Aggiungi","it":"Aggiungi","ja-JP":"\u8FFD\u52A0","ja":"\u8FFD\u52A0","ko-KR":"\uCD94\uAC00","ko":"\uCD94\uAC00","nl-NL":"Voeg toe","nl":"Voeg toe","no-NO":"Legg til","pl-PL":"Dodaj","pl":"Dodaj","pt-BR":"Adicionar","pt-PT":"Adicionar","ru-RU":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C","ru":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C","sv-SE":"L\xe4gg till","sv":"L\xe4gg till","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21","tr-TR":"Ekle","tr":"Ekle"},"RL_AddProduct":{"key":"RL_AddProduct","en":"Add Product","ca-ES":"Afegeix producte","ca":"Afegeix producte","cs-CZ":"P\u0159idat \xa0produkt","cs":"P\u0159idat \xa0produkt","da-DK":"Tilf\xf8j produkt","da":"Tilf\xf8j produkt","de-DE":"Ein Produkt hinzuf\xfcgen","de":"Ein Produkt hinzuf\xfcgen","el-GR":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03BD\u03CC\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2","el":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03BD\u03CC\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2","en-GB":"Add Product","es-ES":"A\xf1adir producto","es":"A\xf1adir producto","fi-FI":"Lis\xe4\xe4 tuote","fr-FR":"Ajouter \xa0produit","fr":"Ajouter \xa0produit","he-IL":"\u05D4\u05D5\u05E1\u05D9\u05E4\u05D5 \u05DE\u05D5\u05E6\u05E8 \u05D0\u05D7\u05D3","hr-HR":"Dodaj proizvod","hu-HU":"term\xe9k hozz\xe1ad\xe1sa","hu":"term\xe9k hozz\xe1ad\xe1sa","it-IT":"Aggiungi prodotto","it":"Aggiungi prodotto","ja-JP":"\u4EF6\u306E\u5546\u54C1\u3092\u8FFD\u52A0","ja":"\u4EF6\u306E\u5546\u54C1\u3092\u8FFD\u52A0","ko-KR":"\uAC1C \uC81C\uD488 \uCD94\uAC00","ko":"\uAC1C \uC81C\uD488 \uCD94\uAC00","nl-NL":"Voeg product toe","nl":"Voeg product toe","no-NO":"Legg til ett produkt","pl-PL":"Dodaj produkt","pl":"Dodaj produkt","pt-BR":"Adicionar produto","pt-PT":"Adicionar produto","ru-RU":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u043E\u0432\u0430\u0440","ru":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u043E\u0432\u0430\u0440","sv-SE":"L\xe4gg till produkt","sv":"L\xe4gg till produkt","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","tr-TR":"\xdcr\xfcn Ekle","tr":"\xdcr\xfcn Ekle"},"RL_Add1Product":{"key":"RL_Add1Product","en":"Add 1 Product","ca-ES":"Afegeix 1 producte","ca":"Afegeix 1 producte","cs-CZ":"P\u0159idat 1\xa0produkt","cs":"P\u0159idat 1\xa0produkt","da-DK":"Tilf\xf8j 1 produkt","da":"Tilf\xf8j 1 produkt","de-DE":"Ein Produkt hinzuf\xfcgen","de":"Ein Produkt hinzuf\xfcgen","el-GR":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03BD\u03CC\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2","el":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03B5\u03BD\u03CC\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2","en-GB":"Add 1 Product","es-ES":"A\xf1adir 1 producto","es":"A\xf1adir 1 producto","fi-FI":"Lis\xe4\xe4 1 tuote","fr-FR":"Ajouter 1\xa0produit","fr":"Ajouter 1\xa0produit","he-IL":"\u05D4\u05D5\u05E1\u05D9\u05E4\u05D5 \u05DE\u05D5\u05E6\u05E8 \u05D0\u05D7\u05D3","hr-HR":"Dodaj 1 proizvod","hu-HU":"1 term\xe9k hozz\xe1ad\xe1sa","hu":"1 term\xe9k hozz\xe1ad\xe1sa","it-IT":"Aggiungi 1 prodotto","it":"Aggiungi 1 prodotto","ja-JP":"1\u4EF6\u306E\u5546\u54C1\u3092\u8FFD\u52A0","ja":"1\u4EF6\u306E\u5546\u54C1\u3092\u8FFD\u52A0","ko-KR":"1\uAC1C \uC81C\uD488 \uCD94\uAC00","ko":"1\uAC1C \uC81C\uD488 \uCD94\uAC00","nl-NL":"Voeg 1 product toe","nl":"Voeg 1 product toe","no-NO":"Legg til ett produkt","pl-PL":"Dodaj 1 produkt","pl":"Dodaj 1 produkt","pt-BR":"Adicionar 1 produto","pt-PT":"Adicionar 1 produto","ru-RU":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C 1 \u0442\u043E\u0432\u0430\u0440","ru":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C 1 \u0442\u043E\u0432\u0430\u0440","sv-SE":"L\xe4gg till 1 produkt","sv":"L\xe4gg till 1 produkt","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 1 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 1 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","tr-TR":"1 \xdcr\xfcn Ekle","tr":"1 \xdcr\xfcn Ekle"},"RL_Add2Products":{"key":"RL_Add2Products","en":"Add {{1}} Products","ca-ES":"Afegeix {{1}} productes","ca":"Afegeix {{1}} productes","cs-CZ":"P\u0159idat {{1}}\xa0produkty","cs":"P\u0159idat {{1}}\xa0produkty","da-DK":"Tilf\xf8j {{1}} produkter","da":"Tilf\xf8j {{1}} produkter","de-DE":"{{1}} Produkte hinzuf\xfcgen","de":"{{1}} Produkte hinzuf\xfcgen","el-GR":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 {{1}} \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD","el":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 {{1}} \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD","en-GB":"Add {{1}} Products","es-ES":"A\xf1adir {{1}} productos","es":"A\xf1adir {{1}} productos","fi-FI":"Lis\xe4\xe4 {{1}} tuote(tta)","fr-FR":"Ajouter {{1}}\xa0produits","fr":"Ajouter {{1}}\xa0produits","he-IL":"\u05D4\u05D5\u05E1\u05D9\u05E4\u05D5 {{1}} \u05DE\u05D5\u05E6\u05E8\u05D9\u05DD","hr-HR":"Dodaj proizvode (njih {{1}})","hu-HU":"{{1}} term\xe9k hozz\xe1ad\xe1sa","hu":"{{1}} term\xe9k hozz\xe1ad\xe1sa","it-IT":"Aggiungi {{1}} prodotti","it":"Aggiungi {{1}} prodotti","ja-JP":"{{1}}\u4EF6\u306E\u5546\u54C1\u3092\u8FFD\u52A0","ja":"{{1}}\u4EF6\u306E\u5546\u54C1\u3092\u8FFD\u52A0","ko-KR":"{{1}}\uAC1C \uC81C\uD488 \uCD94\uAC00","ko":"{{1}}\uAC1C \uC81C\uD488 \uCD94\uAC00","nl-NL":"Voeg {{1}} producten toe","nl":"Voeg {{1}} producten toe","no-NO":"Legg til {{1}} produkter","pl-PL":"Dodaj produkty: {{1}}","pl":"Dodaj produkty: {{1}}","pt-BR":"Adicionar {{1}} produtos","pt-PT":"Adicionar {{1}} produtos","ru-RU":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u044B: {{1}}","ru":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u044B: {{1}}","sv-SE":"L\xe4gg till {{1}} produkter","sv":"L\xe4gg till {{1}} produkter","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 {{1}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 {{1}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","tr-TR":"{{1}} \xdcr\xfcn Ekle","tr":"{{1}} \xdcr\xfcn Ekle"},"RL_AddMarkdown":{"key":"RL_AddMarkdown","en":"Add Markdown","ca-ES":"Afegeix un descompte","ca":"Afegeix un descompte","cs-CZ":"P\u0159idat slevu","cs":"P\u0159idat slevu","da-DK":"Tilf\xf8j prisneds\xe6ttelse","da":"Tilf\xf8j prisneds\xe6ttelse","de-DE":"Preisabschlag hinzuf\xfcgen","de":"Preisabschlag hinzuf\xfcgen","el-GR":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03BC\u03B5\u03AF\u03C9\u03C3\u03B7\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2","el":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03BC\u03B5\u03AF\u03C9\u03C3\u03B7\u03C2 \u03C4\u03B9\u03BC\u03AE\u03C2","en-GB":"Add Markdown","es-ES":"A\xf1adir rebaja","es":"A\xf1adir rebaja","fi-FI":"Lis\xe4\xe4 alennus","fr-FR":"Ajouter une d\xe9marque","fr":"Ajouter une d\xe9marque","he-IL":"\u05D4\u05D5\u05E1\u05D9\u05E4\u05D5 \u05D4\u05E0\u05D7\u05D4","hr-HR":"Dodaj sni\u017Eenje","hu-HU":"Le\xe9rt\xe9kel\xe9s hozz\xe1ad\xe1sa","hu":"Le\xe9rt\xe9kel\xe9s hozz\xe1ad\xe1sa","it-IT":"Aggiungi ribasso","it":"Aggiungi ribasso","ja-JP":"\u5024\u4E0B\u3052\u3092\u8FFD\u52A0","ja":"\u5024\u4E0B\u3052\u3092\u8FFD\u52A0","ko-KR":"\uAC00\uACA9 \uC778\uD558 \uCD94\uAC00","ko":"\uAC00\uACA9 \uC778\uD558 \uCD94\uAC00","nl-NL":"Voeg korting toe","nl":"Voeg korting toe","no-NO":"Legg til tilbud","pl-PL":"Dodaj obni\u017Ck\u0119","pl":"Dodaj obni\u017Ck\u0119","pt-BR":"Adicionar redu\xe7\xe3o de pre\xe7o","pt-PT":"Adicionar desconto","ru-RU":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0446\u0435\u043D\u043A\u0443","ru":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0443\u0446\u0435\u043D\u043A\u0443","sv-SE":"L\xe4gg till priss\xe4nkning","sv":"L\xe4gg till priss\xe4nkning","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32","tr-TR":"\u0130ndirim Ekle","tr":"\u0130ndirim Ekle"},"RL_AddPromotion":{"key":"RL_AddPromotion","en":"Add Promotion","ca-ES":"Afegeix una promoci\xf3","ca":"Afegeix una promoci\xf3","cs-CZ":"P\u0159idat promoakci","cs":"P\u0159idat promoakci","da-DK":"Tilf\xf8j kampagne","da":"Tilf\xf8j kampagne","de-DE":"Angebot hinzuf\xfcgen","de":"Angebot hinzuf\xfcgen","el-GR":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","el":"\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en-GB":"Add Promotion","es-ES":"A\xf1adir promoci\xf3n","es":"A\xf1adir promoci\xf3n","fi-FI":"Lis\xe4\xe4 tarjouskampanja","fr-FR":"Ajouter une promotion","fr":"Ajouter une promotion","he-IL":"\u05D4\u05D5\u05E1\u05D9\u05E4\u05D5 \u05DE\u05D1\u05E6\u05E2","hr-HR":"Dodaj promociju","hu-HU":"Prom\xf3ci\xf3 hozz\xe1ad\xe1sa","hu":"Prom\xf3ci\xf3 hozz\xe1ad\xe1sa","it-IT":"Aggiungi promozione","it":"Aggiungi promozione","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u8FFD\u52A0","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u8FFD\u52A0","ko-KR":"\uD504\uB85C\uBAA8\uC158 \uCD94\uAC00","ko":"\uD504\uB85C\uBAA8\uC158 \uCD94\uAC00","nl-NL":"Voeg promotie toe","nl":"Voeg promotie toe","no-NO":"Legg til kampanje","pl-PL":"Dodaj promocj\u0119","pl":"Dodaj promocj\u0119","pt-BR":"Adicionar promo\xe7\xe3o","pt-PT":"Adicionar promo\xe7\xe3o","ru-RU":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u043A\u0446\u0438\u044E","ru":"\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0430\u043A\u0446\u0438\u044E","sv-SE":"L\xe4gg till kampanj","sv":"L\xe4gg till kampanj","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr-TR":"Promosyon Ekle","tr":"Promosyon Ekle"},"RL_AdultUnisex":{"key":"RL_AdultUnisex","en":"Adult Unisex","ca-ES":"Models unisex per a adults","ca":"Models unisex per a adults","cs-CZ":"Dosp\u011Bl\xed (unisex)","cs":"Dosp\u011Bl\xed (unisex)","da-DK":"Voksen unisex","da":"Voksen unisex","de-DE":"Erwachsene (Unisex)","de":"Erwachsene (Unisex)","el-GR":"Unisex \u03B3\u03B9\u03B1 \u03B5\u03BD\u03AE\u03BB\u03B9\u03BA\u03B5\u03C2","el":"Unisex \u03B3\u03B9\u03B1 \u03B5\u03BD\u03AE\u03BB\u03B9\u03BA\u03B5\u03C2","en-GB":"Adult Unisex","es-ES":"Modelos unisex para adultos","es":"Modelos unisex para adultos","fi-FI":"Aikuiset unisex","fr-FR":"Adulte mixte","fr":"Adulte mixte","he-IL":"\u05D9\u05D5\u05E0\u05D9\u05E1\u05E7\u05E1 \u2013 \u05DE\u05D1\u05D5\u05D2\u05E8\u05D9\u05DD","hr-HR":"Odrasli \u2013 uniseks","hu-HU":"Feln\u0151tt uniszex","hu":"Feln\u0151tt uniszex","it-IT":"Adulti \u2013 Unisex","it":"Adulti \u2013 Unisex","ja-JP":"\u5927\u4EBA \u30E6\u30CB\u30BB\u30C3\u30AF\u30B9","ja":"\u5927\u4EBA \u30E6\u30CB\u30BB\u30C3\u30AF\u30B9","ko-KR":"\uC131\uC778\uACF5\uC6A9","ko":"\uC131\uC778\uACF5\uC6A9","nl-NL":"Unisex voor volwassenen","nl":"Unisex voor volwassenen","no-NO":"Unisex til voksen","pl-PL":"Dla doros\u0142ych uniseks","pl":"Dla doros\u0142ych uniseks","pt-BR":"Adulto unissex","pt-PT":"Adulto (unissexo)","ru-RU":"\u0423\u043D\u0438\u0441\u0435\u043A\u0441, \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0435","ru":"\u0423\u043D\u0438\u0441\u0435\u043A\u0441, \u0432\u0437\u0440\u043E\u0441\u043B\u044B\u0435","sv-SE":"Vuxen unisex","sv":"Vuxen unisex","th-TH":"Unisex \u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E0D\u0E48","th":"Unisex \u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E0D\u0E48","tr-TR":"Unisex Yeti\u015Fkin \xdcr\xfcnleri","tr":"Unisex Yeti\u015Fkin \xdcr\xfcnleri"},"RL_All":{"key":"RL_All","en":"All","ca-ES":"Tot","ca":"Tot","cs-CZ":"V\u0161echno","cs":"V\u0161echno","da-DK":"Alle","da":"Alle","de-DE":"Alle","de":"Alle","el-GR":"\u038C\u03BB\u03B1","el":"\u038C\u03BB\u03B1","en-GB":"All","es-ES":"Todo","es":"Todo","fi-FI":"Kaikki","fr-FR":"Tout afficher","fr":"Tout afficher","he-IL":"\u05D4\u05DB\u05D5\u05DC","hr-HR":"Sve","hu-HU":"\xd6sszes","hu":"\xd6sszes","it-IT":"Tutto","it":"Tutto","ja-JP":"\u3059\u3079\u3066","ja":"\u3059\u3079\u3066","ko-KR":"\uC804\uCCB4","ko":"\uC804\uCCB4","nl-NL":"Alle","nl":"Alle","no-NO":"Alle","pl-PL":"Wszystkie","pl":"Wszystkie","pt-BR":"Tudo","pt-PT":"Tudo","ru-RU":"\u0412\u0441\u0435","ru":"\u0412\u0441\u0435","sv-SE":"Alla","sv":"Alla","th-TH":"\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","th":"\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","tr-TR":"T\xfcm\xfc","tr":"T\xfcm\xfc"},"RL_AllDivisions":{"key":"RL_AllDivisions","en":"All Divisions","ca-ES":"Totes les categories","ca":"Totes les categories","cs-CZ":"V\u0161echny sekce","cs":"V\u0161echny sekce","da-DK":"Alle divisioner","da":"Alle divisioner","de-DE":"Alle Divisions","de":"Alle Divisions","el-GR":"\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1","el":"\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1","en-GB":"All Divisions","es-ES":"Todas las categor\xedas","es":"Todas las categor\xedas","fi-FI":"Kaikki kategoriat","fr-FR":"Toutes les divisions","fr":"Toutes les divisions","he-IL":"\u05DB\u05DC \u05D4\u05DE\u05D7\u05DC\u05E7\u05D5\u05EA","hr-HR":"Sve kategorije","hu-HU":"Minden r\xe9szleg","hu":"Minden r\xe9szleg","it-IT":"Tutti i reparti","it":"Tutti i reparti","ja-JP":"\u3059\u3079\u3066\u306E\u90E8\u9580","ja":"\u3059\u3079\u3066\u306E\u90E8\u9580","ko-KR":"\uBAA8\uB4E0 \uBD80\uC11C","ko":"\uBAA8\uB4E0 \uBD80\uC11C","nl-NL":"Alle divisies","nl":"Alle divisies","no-NO":"Alle avdelinger","pl-PL":"Wszystkie dzia\u0142y","pl":"Wszystkie dzia\u0142y","pt-BR":"Todas as divis\xf5es","pt-PT":"Todas as divis\xf5es","ru-RU":"\u0412\u0441\u0435 \u043E\u0442\u0434\u0435\u043B\u044B","ru":"\u0412\u0441\u0435 \u043E\u0442\u0434\u0435\u043B\u044B","sv-SE":"Alla avdelningar","sv":"Alla avdelningar","th-TH":"\u0E17\u0E38\u0E01\u0E2B\u0E21\u0E27\u0E14","th":"\u0E17\u0E38\u0E01\u0E2B\u0E21\u0E27\u0E14","tr-TR":"T\xfcm B\xf6l\xfcmler","tr":"T\xfcm B\xf6l\xfcmler"},"RL_Apparel":{"key":"RL_Apparel","en":"Apparel","ca-ES":"Roba","ca":"Roba","cs-CZ":"Oble\u010Den\xed","cs":"Oble\u010Den\xed","da-DK":"T\xf8j","da":"T\xf8j","de-DE":"Bekleidung","de":"Bekleidung","el-GR":"\u03A1\u03BF\u03CD\u03C7\u03B1","el":"\u03A1\u03BF\u03CD\u03C7\u03B1","en-GB":"Apparel","es-ES":"Ropa","es":"Ropa","fi-FI":"Vaatteet","fr-FR":"V\xeatements","fr":"V\xeatements","he-IL":"\u05D4\u05DC\u05D1\u05E9\u05D4","hr-HR":"Odje\u0107a","hu-HU":"Ruh\xe1zat","hu":"Ruh\xe1zat","it-IT":"Abbigliamento","it":"Abbigliamento","ja-JP":"\u30A2\u30D1\u30EC\u30EB","ja":"\u30A2\u30D1\u30EC\u30EB","ko-KR":"\uC758\uB958","ko":"\uC758\uB958","nl-NL":"Kleding","nl":"Kleding","no-NO":"Kl\xe6r","pl-PL":"Odzie\u017C","pl":"Odzie\u017C","pt-BR":"Vestu\xe1rio","pt-PT":"Vestu\xe1rio","ru-RU":"\u041E\u0434\u0435\u0436\u0434\u0430","ru":"\u041E\u0434\u0435\u0436\u0434\u0430","sv-SE":"Kl\xe4der","sv":"Kl\xe4der","th-TH":"\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E41\u0E15\u0E48\u0E07\u0E01\u0E32\u0E22","th":"\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E41\u0E15\u0E48\u0E07\u0E01\u0E32\u0E22","tr-TR":"Giysi","tr":"Giysi"},"RL_ApparelDivision":{"key":"RL_ApparelDivision","en":"Apparel Division","ca-ES":"Categoria de roba","ca":"Categoria de roba","cs-CZ":"Sekce Oble\u010Den\xed","cs":"Sekce Oble\u010Den\xed","da-DK":"T\xf8j, division","da":"T\xf8j, division","de-DE":"Apparel Division","de":"Apparel Division","el-GR":"\u03A4\u03BC\u03AE\u03BC\u03B1 \u03C1\u03BF\u03CD\u03C7\u03C9\u03BD","el":"\u03A4\u03BC\u03AE\u03BC\u03B1 \u03C1\u03BF\u03CD\u03C7\u03C9\u03BD","en-GB":"Apparel Division","es-ES":"Categor\xeda de ropa","es":"Categor\xeda de ropa","fi-FI":"Vaatekategoria","fr-FR":"Division v\xeatements","fr":"Division v\xeatements","he-IL":"\u05D7\u05D8\u05D9\u05D1\u05EA \u05D4\u05D4\u05DC\u05D1\u05E9\u05D4","hr-HR":"Kategorija odje\u0107e","hu-HU":"Ruh\xe1zati r\xe9szleg","hu":"Ruh\xe1zati r\xe9szleg","it-IT":"Reparto abbigliamento","it":"Reparto abbigliamento","ja-JP":"\u30A2\u30D1\u30EC\u30EB\u90E8\u9580","ja":"\u30A2\u30D1\u30EC\u30EB\u90E8\u9580","ko-KR":"\uC758\uB958 \uBD80\uC11C","ko":"\uC758\uB958 \uBD80\uC11C","nl-NL":"Kledingdivisie","nl":"Kledingdivisie","no-NO":"Klesavdeling","pl-PL":"Dzia\u0142 Odzie\u017C","pl":"Dzia\u0142 Odzie\u017C","pt-BR":"Divis\xe3o de vestu\xe1rio","pt-PT":"Divis\xe3o de vestu\xe1rio","ru-RU":"\u041E\u0442\u0434\u0435\u043B \u043E\u0434\u0435\u0436\u0434\u044B","ru":"\u041E\u0442\u0434\u0435\u043B \u043E\u0434\u0435\u0436\u0434\u044B","sv-SE":"Kl\xe4davdelning","sv":"Kl\xe4davdelning","th-TH":"\u0E2B\u0E21\u0E27\u0E14\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E41\u0E15\u0E48\u0E07\u0E01\u0E32\u0E22","th":"\u0E2B\u0E21\u0E27\u0E14\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E41\u0E15\u0E48\u0E07\u0E01\u0E32\u0E22","tr-TR":"Giysi B\xf6l\xfcm\xfc","tr":"Giysi B\xf6l\xfcm\xfc"},"RL_Athlete":{"key":"RL_Athlete","en":"Athlete","ca-ES":"Atleta","ca":"Atleta","cs-CZ":"Zam\u011Bstnanec","cs":"Zam\u011Bstnanec","da-DK":"Atlet","da":"Atlet","de-DE":"Athlete","de":"Athlete","el-GR":"Athlete","el":"Athlete","en-GB":"Athlete","es-ES":"Athlete","es":"Athlete","fi-FI":"Urheiluvaatteet","fr-FR":"Athlete","fr":"Athlete","he-IL":"\u05E1\u05E4\u05D5\u05E8\u05D8\u05D0\u05D9","hr-HR":"Athlete","hu-HU":"Athlete","hu":"Athlete","it-IT":"Athlete","it":"Athlete","ja-JP":"Athlete","ja":"Athlete","ko-KR":"Athlete","ko":"Athlete","nl-NL":"Athlete","nl":"Athlete","no-NO":"Atlet","pl-PL":"Athlete","pl":"Athlete","pt-BR":"Athlete","pt-PT":"Athlete","ru-RU":"\u0410\u0442\u043B\u0435\u0442","ru":"\u0410\u0442\u043B\u0435\u0442","sv-SE":"Atlet","sv":"Atlet","th-TH":"Athlete","th":"Athlete","tr-TR":"Athlete","tr":"Athlete"},"RL_AthleteRoles":{"key":"RL_AthleteRoles","en":"Athlete Roles","ca-ES":"Funcions de l\'athlete","ca":"Funcions de l\'athlete","cs-CZ":"Role zam\u011Bstnance na pozici Athlete","cs":"Role zam\u011Bstnance na pozici Athlete","da-DK":"Athlete-stillinger","da":"Athlete-stillinger","de-DE":"Rolle des Athlete","de":"Rolle des Athlete","el-GR":"\u03A1\u03CC\u03BB\u03BF\u03B9 Athlete","el":"\u03A1\u03CC\u03BB\u03BF\u03B9 Athlete","en-GB":"Athlete Roles","es-ES":"Funciones de athlete","es":"Funciones de athlete","fi-FI":"Urheilijaroolit","fr-FR":"R\xf4les de l\'Athlete","fr":"R\xf4les de l\'Athlete","he-IL":"\u05EA\u05E4\u05E7\u05D9\u05D3\u05D9 Athletes","hr-HR":"Uloge athletea","hu-HU":"Athlete-szerepk\xf6r\xf6k","hu":"Athlete-szerepk\xf6r\xf6k","it-IT":"Ruoli Athlete","it":"Ruoli Athlete","ja-JP":"Athlete\u306E\u696D\u52D9","ja":"Athlete\u306E\u696D\u52D9","ko-KR":"Athlete \uC5ED\uD560","ko":"Athlete \uC5ED\uD560","nl-NL":"Atleetrollen","nl":"Atleetrollen","no-NO":"Atletroller","pl-PL":"Role Athletes","pl":"Role Athletes","pt-BR":"Fun\xe7\xf5es de Athlete","pt-PT":"Fun\xe7\xf5es dos Athletes","ru-RU":"\u0417\u0430\u0434\u0430\u0447\u0438 \u0430\u0442\u043B\u0435\u0442\u0430","ru":"\u0417\u0430\u0434\u0430\u0447\u0438 \u0430\u0442\u043B\u0435\u0442\u0430","sv-SE":"Athlete-roller","sv":"Athlete-roller","th-TH":"\u0E1A\u0E17\u0E1A\u0E32\u0E17\u0E02\u0E2D\u0E07 Athlete","th":"\u0E1A\u0E17\u0E1A\u0E32\u0E17\u0E02\u0E2D\u0E07 Athlete","tr-TR":"Athlete Rolleri","tr":"Athlete Rolleri"},"RL_BackToPromotions":{"key":"RL_BackToPromotions","en":"Back to Promotions","ca-ES":"Torna a les promocions","ca":"Torna a les promocions","cs-CZ":"Zp\xe1tky k\xa0promoakc\xedm","cs":"Zp\xe1tky k\xa0promoakc\xedm","da-DK":"Tilbage til kampagner","da":"Tilbage til kampagner","de-DE":"Zur\xfcck zu Angeboten","de":"Zur\xfcck zu Angeboten","el-GR":"\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2","el":"\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03C3\u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2","en-GB":"Back to Promotions","es-ES":"Volver a Promociones","es":"Volver a Promociones","fi-FI":"Takaisin kampanjoihin","fr-FR":"Retour aux promotions","fr":"Retour aux promotions","he-IL":"\u05D7\u05D6\u05E8\u05D4 \u05DC\u05DE\u05D1\u05E6\u05E2\u05D9\u05DD","hr-HR":"Natrag na promocije","hu-HU":"Vissza a prom\xf3ci\xf3khoz","hu":"Vissza a prom\xf3ci\xf3khoz","it-IT":"Torna alle promozioni","it":"Torna alle promozioni","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306B\u623B\u308B","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306B\u623B\u308B","ko-KR":"\uD504\uB85C\uBAA8\uC158\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30","ko":"\uD504\uB85C\uBAA8\uC158\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30","nl-NL":"Terug naar promoties","nl":"Terug naar promoties","no-NO":"Tilbake til kampanjer","pl-PL":"Powr\xf3t do promocji","pl":"Powr\xf3t do promocji","pt-BR":"Voltar para Promo\xe7\xf5es","pt-PT":"Regressar \xe0s Promo\xe7\xf5es","ru-RU":"\u041D\u0430\u0437\u0430\u0434 \u043A \u043F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u044F\u043C","ru":"\u041D\u0430\u0437\u0430\u0434 \u043A \u043F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u044F\u043C","sv-SE":"Tillbaka till kampanjer","sv":"Tillbaka till kampanjer","th-TH":"\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","th":"\u0E01\u0E25\u0E31\u0E1A\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr-TR":"Promosyonlara D\xf6n","tr":"Promosyonlara D\xf6n"},"RL_Browser":{"key":"RL_Browser","en":"browser","ca-ES":"navegador","ca":"navegador","cs-CZ":"prohl\xed\u017Ee\u010D","cs":"prohl\xed\u017Ee\u010D","da-DK":"browser","da":"browser","de-DE":"Browser","de":"Browser","el-GR":"\u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03B7\u03C2","el":"\u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03B7\u03C2","en-GB":"browser","es-ES":"navegador","es":"navegador","fi-FI":"selain","fr-FR":"navigateur","fr":"navigateur","he-IL":"\u05D3\u05E4\u05D3\u05E4\u05DF","hr-HR":"preglednik","hu-HU":"b\xf6ng\xe9sz\u0151","hu":"b\xf6ng\xe9sz\u0151","it-IT":"browser","it":"browser","ja-JP":"\u30D6\u30E9\u30A6\u30B6","ja":"\u30D6\u30E9\u30A6\u30B6","ko-KR":"\uBE0C\uB77C\uC6B0\uC800","ko":"\uBE0C\uB77C\uC6B0\uC800","nl-NL":"browser","nl":"browser","no-NO":"nettleser","pl-PL":"przegl\u0105darka","pl":"przegl\u0105darka","pt-BR":"navegador","pt-PT":"navegador","ru-RU":"\u0431\u0440\u0430\u0443\u0437\u0435\u0440","ru":"\u0431\u0440\u0430\u0443\u0437\u0435\u0440","sv-SE":"webbl\xe4sare","sv":"webbl\xe4sare","th-TH":"\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C","th":"\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C","tr-TR":"taray\u0131c\u0131","tr":"taray\u0131c\u0131"},"RL_Clear":{"key":"RL_Clear","en":"Clear","ca-ES":"Esborra","ca":"Esborra","cs-CZ":"Vymazat","cs":"Vymazat","da-DK":"Ryd","da":"Ryd","de-DE":"L\xf6schen","de":"L\xf6schen","el-GR":"\u0391\u03C0\u03B1\u03BB\u03BF\u03B9\u03C6\u03AE","el":"\u0391\u03C0\u03B1\u03BB\u03BF\u03B9\u03C6\u03AE","en-GB":"Clear","es-ES":"Borrar","es":"Borrar","fi-FI":"Tyhjenn\xe4","fr-FR":"Effacer","fr":"Effacer","he-IL":"\u05E0\u05D9\u05E7\u05D5\u05D9","hr-HR":"O\u010Disti","hu-HU":"T\xf6rl\xe9s","hu":"T\xf6rl\xe9s","it-IT":"Cancella","it":"Cancella","ja-JP":"\u30AF\u30EA\u30A2","ja":"\u30AF\u30EA\u30A2","ko-KR":"\uC9C0\uC6B0\uAE30","ko":"\uC9C0\uC6B0\uAE30","nl-NL":"Wis","nl":"Wis","no-NO":"Fjern","pl-PL":"Wyczy\u015B\u0107","pl":"Wyczy\u015B\u0107","pt-BR":"Limpar","pt-PT":"Limpar","ru-RU":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C","ru":"\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C","sv-SE":"Rensa","sv":"Rensa","th-TH":"\u0E25\u0E49\u0E32\u0E07","th":"\u0E25\u0E49\u0E32\u0E07","tr-TR":"Temizle","tr":"Temizle"},"RL_Code":{"key":"RL_Code","en":"code","ca-ES":"codi","ca":"codi","cs-CZ":"k\xf3d","cs":"k\xf3d","da-DK":"kode","da":"kode","de-DE":"Code","de":"Code","el-GR":"\u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2","el":"\u03BA\u03C9\u03B4\u03B9\u03BA\u03CC\u03C2","en-GB":"code","es-ES":"c\xf3digo","es":"c\xf3digo","fi-FI":"koodi","fr-FR":"code","fr":"code","he-IL":"\u05E7\u05D5\u05D3","hr-HR":"\u0161ifra","hu-HU":"k\xf3d","hu":"k\xf3d","it-IT":"codice","it":"codice","ja-JP":"\u30B3\u30FC\u30C9","ja":"\u30B3\u30FC\u30C9","ko-KR":"\uCF54\uB4DC","ko":"\uCF54\uB4DC","nl-NL":"code","nl":"code","no-NO":"kode","pl-PL":"kod","pl":"kod","pt-BR":"c\xf3digo","pt-PT":"c\xf3digo","ru-RU":"\u043A\u043E\u0434\u0430","ru":"\u043A\u043E\u0434\u0430","sv-SE":"kod","sv":"kod","th-TH":"\u0E23\u0E2B\u0E31\u0E2A","th":"\u0E23\u0E2B\u0E31\u0E2A","tr-TR":"kod","tr":"kod"},"RL_Codes":{"key":"RL_Codes","en":"codes","ca-ES":"codis","ca":"codis","cs-CZ":"k\xf3dy","cs":"k\xf3dy","da-DK":"koder","da":"koder","de-DE":"Codes","de":"Codes","el-GR":"\u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF","el":"\u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF","en-GB":"codes","es-ES":"c\xf3digos","es":"c\xf3digos","fi-FI":"koodit","fr-FR":"codes","fr":"codes","he-IL":"\u05E7\u05D5\u05D3\u05D9\u05DD","hr-HR":"\u0161ifre","hu-HU":"k\xf3d","hu":"k\xf3d","it-IT":"codici","it":"codici","ja-JP":"\u30B3\u30FC\u30C9","ja":"\u30B3\u30FC\u30C9","ko-KR":"\uCF54\uB4DC","ko":"\uCF54\uB4DC","nl-NL":"codes","nl":"codes","no-NO":"koder","pl-PL":"kody","pl":"kody","pt-BR":"c\xf3digos","pt-PT":"c\xf3digos","ru-RU":"\u043A\u043E\u0434\u043E\u0432","ru":"\u043A\u043E\u0434\u043E\u0432","sv-SE":"koder","sv":"koder","th-TH":"\u0E23\u0E2B\u0E31\u0E2A","th":"\u0E23\u0E2B\u0E31\u0E2A","tr-TR":"kodlar","tr":"kodlar"},"RL_Confirm":{"key":"RL_Confirm","en":"Are you sure?","ca-ES":"Ho confirmes?","ca":"Ho confirmes?","cs-CZ":"Ur\u010Dit\u011B?","cs":"Ur\u010Dit\u011B?","da-DK":"Er du sikker?","da":"Er du sikker?","de-DE":"Bist du sicher?","de":"Bist du sicher?","el-GR":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9;","el":"\u0395\u03AF\u03C3\u03C4\u03B5 \u03B2\u03AD\u03B2\u03B1\u03B9\u03BF\u03B9;","en-GB":"Are you sure?","es-ES":"\xbfSeguro?","es":"\xbfSeguro?","fi-FI":"Oletko varma?","fr-FR":"\xcates-vous s\xfbr(e)\xa0?","fr":"\xcates-vous s\xfbr(e)\xa0?","he-IL":"\u05D4\u05D0\u05DD \u05D0\u05EA\u05DD \u05D1\u05D8\u05D5\u05D7\u05D9\u05DD?","hr-HR":"Jeste li sigurni?","hu-HU":"Biztos vagy benne?","hu":"Biztos vagy benne?","it-IT":"Confermi?","it":"Confermi?","ja-JP":"\u7D9A\u884C\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","ja":"\u7D9A\u884C\u3057\u3066\u3082\u3088\u308D\u3057\u3044\u3067\u3059\u304B\uFF1F","ko-KR":"\uACC4\uC18D \uC9C4\uD589\uD558\uC2DC\uACA0\uC5B4\uC694?","ko":"\uACC4\uC18D \uC9C4\uD589\uD558\uC2DC\uACA0\uC5B4\uC694?","nl-NL":"Weet je het zeker?","nl":"Weet je het zeker?","no-NO":"Er du sikker?","pl-PL":"Na pewno?","pl":"Na pewno?","pt-BR":"Tem certeza?","pt-PT":"Tem a certeza?","ru-RU":"\u0422\u043E\u0447\u043D\u043E?","ru":"\u0422\u043E\u0447\u043D\u043E?","sv-SE":"\xc4r du s\xe4ker?","sv":"\xc4r du s\xe4ker?","th-TH":"\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","th":"\u0E04\u0E38\u0E13\u0E41\u0E19\u0E48\u0E43\u0E08\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","tr-TR":"Emin misin?","tr":"Emin misin?"},"RL_CrossDivision":{"key":"RL_CrossDivision","en":"Cross Division","ca-ES":"Categoria transversal","ca":"Categoria transversal","cs-CZ":"Sekce Cross Division","cs":"Sekce Cross Division","da-DK":"Krydsdivision","da":"Krydsdivision","de-DE":"Cross Division","de":"Cross Division","el-GR":"\u03A3\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1","el":"\u03A3\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1","en-GB":"Cross Division","es-ES":"Categor\xeda transversal","es":"Categor\xeda transversal","fi-FI":"Useampi kategoria","fr-FR":"Divisions multiples","fr":"Divisions multiples","he-IL":"\u05E8\u05D1-\u05DE\u05D7\u05DC\u05E7\u05EA\u05D9","hr-HR":"Vi\u0161ekategorijsko","hu-HU":"Keresztr\xe9szleg","hu":"Keresztr\xe9szleg","it-IT":"Cross Division","it":"Cross Division","ja-JP":"\u30AF\u30ED\u30B9\u90E8\u9580","ja":"\u30AF\u30ED\u30B9\u90E8\u9580","ko-KR":"\uAD50\uCC28 \uBD80\uC11C","ko":"\uAD50\uCC28 \uBD80\uC11C","nl-NL":"Divisie overstijgend","nl":"Divisie overstijgend","no-NO":"Blandet avdeling","pl-PL":"Cross Division","pl":"Cross Division","pt-BR":"Divis\xe3o mista","pt-PT":"Interdivisional","ru-RU":"\u0414\u043B\u044F \u0432\u0441\u0435\u0445 \u043E\u0442\u0434\u0435\u043B\u043E\u0432","ru":"\u0414\u043B\u044F \u0432\u0441\u0435\u0445 \u043E\u0442\u0434\u0435\u043B\u043E\u0432","sv-SE":"Flera avdelningar","sv":"Flera avdelningar","th-TH":"\u0E02\u0E49\u0E32\u0E21\u0E2B\u0E21\u0E27\u0E14","th":"\u0E02\u0E49\u0E32\u0E21\u0E2B\u0E21\u0E27\u0E14","tr-TR":"B\xf6l\xfcmler Aras\u0131","tr":"B\xf6l\xfcmler Aras\u0131"},"RL_DefaultPromotion":{"key":"RL_DefaultPromotion","en":"This is a default promotion. Only the discount percentage can be edited.","cs-CZ":"Jde o\xa0v\xfdchoz\xed promoakci. Editovat se d\xe1 jenom procentu\xe1ln\xed vyj\xe1d\u0159en\xed slevy.","cs":"Jde o\xa0v\xfdchoz\xed promoakci. Editovat se d\xe1 jenom procentu\xe1ln\xed vyj\xe1d\u0159en\xed slevy.","da-DK":"Dette er en standardkampagne. Kun rabatprocenten kan redigeres.","da":"Dette er en standardkampagne. Kun rabatprocenten kan redigeres.","de-DE":"Hierbei handelt es sich um ein Standardangebot. Es kann nur der Rabattprozentsatz bearbeitet werden.","de":"Hierbei handelt es sich um ein Standardangebot. Es kann nur der Rabattprozentsatz bearbeitet werden.","el-GR":"\u03A0\u03C1\u03CC\u03BA\u03B5\u03B9\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03C0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC. \u03A0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03B7 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03BC\u03CC\u03BD\u03BF \u03C4\u03BF\u03C5 \u03C0\u03BF\u03C3\u03BF\u03C3\u03C4\u03BF\u03CD \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7\u03C2.","el":"\u03A0\u03C1\u03CC\u03BA\u03B5\u03B9\u03C4\u03B1\u03B9 \u03B3\u03B9\u03B1 \u03C0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B7 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC. \u03A0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03B7 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03B5\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1\u03C2 \u03BC\u03CC\u03BD\u03BF \u03C4\u03BF\u03C5 \u03C0\u03BF\u03C3\u03BF\u03C3\u03C4\u03BF\u03CD \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7\u03C2.","en-GB":"This is a default promotion. Only the discount percentage can be edited.","es-ES":"Esta es una promoci\xf3n por defecto. Solo se puede editar el porcentaje del descuento.","es":"Esta es una promoci\xf3n por defecto. Solo se puede editar el porcentaje del descuento.","fi-FI":"T\xe4m\xe4 on oletuskampanja. Vain alennusprosenttia voi muokata.","fr-FR":"Il s\'agit d\'une promotion par d\xe9faut. Seul le pourcentage de r\xe9duction peut \xeatre modifi\xe9.","fr":"Il s\'agit d\'une promotion par d\xe9faut. Seul le pourcentage de r\xe9duction peut \xeatre modifi\xe9.","he-IL":"\u05D6\u05D4\u05D5 \u05DE\u05D1\u05E6\u05E2 \u05D1\u05E8\u05D9\u05E8\u05EA \u05DE\u05D7\u05D3\u05DC. \u05E0\u05D9\u05EA\u05DF \u05DC\u05E2\u05E8\u05D5\u05DA \u05E8\u05E7 \u05D0\u05EA \u05D0\u05D7\u05D5\u05D6 \u05D4\u05D4\u05E0\u05D7\u05D4.","hr-HR":"Ovo je zadana promocija. Urediti se mo\u017Ee samo postotak popusta.","hu-HU":"Ez alap\xe9rtelmezett prom\xf3ci\xf3. Csak a kedvezm\xe9ny sz\xe1zal\xe9kos ar\xe1nya szerkeszthet\u0151.","hu":"Ez alap\xe9rtelmezett prom\xf3ci\xf3. Csak a kedvezm\xe9ny sz\xe1zal\xe9kos ar\xe1nya szerkeszthet\u0151.","it-IT":"Questa \xe8 una promozione predefinita. Solo la percentuale di sconto pu\xf2 essere modificata.","it":"Questa \xe8 una promozione predefinita. Solo la percentuale di sconto pu\xf2 essere modificata.","ja-JP":"\u3053\u308C\u306F\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3067\u3059\u3002 \u5272\u5F15\u7387\u306E\u307F\u7DE8\u96C6\u3067\u304D\u307E\u3059\u3002","ja":"\u3053\u308C\u306F\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3067\u3059\u3002 \u5272\u5F15\u7387\u306E\u307F\u7DE8\u96C6\u3067\u304D\u307E\u3059\u3002","ko-KR":"\uAE30\uBCF8 \uD504\uB85C\uBAA8\uC158\uC785\uB2C8\uB2E4. \uD560\uC778 \uBE44\uC728\uB9CC \uC218\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","ko":"\uAE30\uBCF8 \uD504\uB85C\uBAA8\uC158\uC785\uB2C8\uB2E4. \uD560\uC778 \uBE44\uC728\uB9CC \uC218\uC815\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","nl-NL":"Dit is een standaard promotie. Alleen het kortingspercentage kan worden bewerkt.","nl":"Dit is een standaard promotie. Alleen het kortingspercentage kan worden bewerkt.","no-NO":"Dette er en standardkampanje. Det er bare rabattprosenten som kan redigeres.","pl-PL":"To jest domy\u015Blna promocja. Mo\u017Cna zmieni\u0107 tylko odsetek rabatu.","pl":"To jest domy\u015Blna promocja. Mo\u017Cna zmieni\u0107 tylko odsetek rabatu.","pt-BR":"Esta \xe9 uma promo\xe7\xe3o padr\xe3o. Somente a porcentagem de desconto pode ser editada.","pt-PT":"Esta \xe9 uma promo\xe7\xe3o predefinida. S\xf3 \xe9 poss\xedvel editar a percentagem de desconto.","ru-RU":"\u042D\u0442\u043E \u043F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u044F \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E. \u041C\u043E\u0436\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u043E\u0446\u0435\u043D\u0442 \u0441\u043A\u0438\u0434\u043A\u0438.","ru":"\u042D\u0442\u043E \u043F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u044F \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E. \u041C\u043E\u0436\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u043E\u0446\u0435\u043D\u0442 \u0441\u043A\u0438\u0434\u043A\u0438.","sv-SE":"Det h\xe4r \xe4r en standardkampanj. Du kan bara redigera rabattens procentandel.","sv":"Det h\xe4r \xe4r en standardkampanj. Du kan bara redigera rabattens procentandel.","th-TH":"\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19 \u0E41\u0E01\u0E49\u0E44\u0E02\u0E44\u0E14\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","th":"\u0E19\u0E35\u0E48\u0E04\u0E37\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19 \u0E41\u0E01\u0E49\u0E44\u0E02\u0E44\u0E14\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","tr-TR":"Bu, varsay\u0131lan bir promosyondur. Yaln\u0131zca indirim oran\u0131 d\xfczenlenebilir.","tr":"Bu, varsay\u0131lan bir promosyondur. Yaln\u0131zca indirim oran\u0131 d\xfczenlenebilir."},"RL_Delete":{"key":"RL_Delete","en":"Delete","ca-ES":"Elimina","ca":"Elimina","cs-CZ":"Odstranit","cs":"Odstranit","da-DK":"Slet","da":"Slet","de-DE":"L\xf6schen","de":"L\xf6schen","el-GR":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE","el":"\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE","en-GB":"Delete","es-ES":"Eliminar","es":"Eliminar","fi-FI":"Poista","fr-FR":"Supprimer","fr":"Supprimer","he-IL":"\u05DE\u05D7\u05D9\u05E7\u05D4","hr-HR":"Izbri\u0161i","hu-HU":"T\xf6rl\xe9s","hu":"T\xf6rl\xe9s","it-IT":"Elimina","it":"Elimina","ja-JP":"\u524A\u9664","ja":"\u524A\u9664","ko-KR":"\uC0AD\uC81C","ko":"\uC0AD\uC81C","nl-NL":"Verwijder","nl":"Verwijder","no-NO":"Slett","pl-PL":"Usu\u0144","pl":"Usu\u0144","pt-BR":"Excluir","pt-PT":"Eliminar","ru-RU":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C","ru":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C","sv-SE":"Ta bort","sv":"Ta bort","th-TH":"\u0E25\u0E1A","th":"\u0E25\u0E1A","tr-TR":"Sil","tr":"Sil"},"RL_Discount":{"key":"RL_Discount","en":"Discount","ca-ES":"Descompte","ca":"Descompte","cs-CZ":"Sleva","cs":"Sleva","da-DK":"Rabat","da":"Rabat","de-DE":"Rabatt","de":"Rabatt","el-GR":"\u0388\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7","el":"\u0388\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7","en-GB":"Discount","es-ES":"Descuento","es":"Descuento","fi-FI":"Alennus","fr-FR":"R\xe9duction","fr":"R\xe9duction","he-IL":"\u05D4\u05E0\u05D7\u05D4","hr-HR":"Popust","hu-HU":"Kedvezm\xe9ny","hu":"Kedvezm\xe9ny","it-IT":"Sconto","it":"Sconto","ja-JP":"\u5272\u5F15","ja":"\u5272\u5F15","ko-KR":"\uD560\uC778","ko":"\uD560\uC778","nl-NL":"Korting","nl":"Korting","no-NO":"Rabatt","pl-PL":"Rabat","pl":"Rabat","pt-BR":"Desconto","pt-PT":"Desconto","ru-RU":"\u0421\u043A\u0438\u0434\u043A\u0430","ru":"\u0421\u043A\u0438\u0434\u043A\u0430","sv-SE":"Rabatt","sv":"Rabatt","th-TH":"\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14","th":"\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14","tr-TR":"\u0130ndirim","tr":"\u0130ndirim"},"RL_DiscountPercentage":{"key":"RL_DiscountPercentage","en":"Discount Percentage","ca-ES":"Percentatge del descompte","ca":"Percentatge del descompte","cs-CZ":"Procentu\xe1ln\xed vyj\xe1d\u0159en\xed slevy","cs":"Procentu\xe1ln\xed vyj\xe1d\u0159en\xed slevy","da-DK":"Rabatprocent","da":"Rabatprocent","de-DE":"Rabattprozentsatz","de":"Rabattprozentsatz","el-GR":"\u03A0\u03BF\u03C3\u03BF\u03C3\u03C4\u03CC \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7\u03C2","el":"\u03A0\u03BF\u03C3\u03BF\u03C3\u03C4\u03CC \u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7\u03C2","en-GB":"Discount Percentage","es-ES":"Porcentaje de descuento","es":"Porcentaje de descuento","fi-FI":"Alennusprosentti","fr-FR":"Pourcentage de r\xe9duction","fr":"Pourcentage de r\xe9duction","he-IL":"\u05D0\u05D7\u05D5\u05D6 \u05D4\u05E0\u05D7\u05D4","hr-HR":"Postotak popusta","hu-HU":"Kedvezm\xe9ny sz\xe1zal\xe9kos ar\xe1nya","hu":"Kedvezm\xe9ny sz\xe1zal\xe9kos ar\xe1nya","it-IT":"Percentuale sconto","it":"Percentuale sconto","ja-JP":"\u5272\u5F15\u7387","ja":"\u5272\u5F15\u7387","ko-KR":"\uD560\uC778 \uBE44\uC728","ko":"\uD560\uC778 \uBE44\uC728","nl-NL":"Kortingspercentage","nl":"Kortingspercentage","no-NO":"Rabattprosent","pl-PL":"Odsetek rabatu","pl":"Odsetek rabatu","pt-BR":"Porcentagem de desconto","pt-PT":"Percentagem de desconto","ru-RU":"\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u0441\u043A\u0438\u0434\u043A\u0438","ru":"\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u0441\u043A\u0438\u0434\u043A\u0438","sv-SE":"Rabatt i procent","sv":"Rabatt i procent","th-TH":"\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14","th":"\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14","tr-TR":"\u0130ndirim Oran\u0131","tr":"\u0130ndirim Oran\u0131"},"RL_Divisions":{"key":"RL_Divisions","en":"Divisions","ca-ES":"Categories","ca":"Categories","cs-CZ":"Sekce","cs":"Sekce","da-DK":"Divisioner","da":"Divisioner","de-DE":"Divisions","de":"Divisions","el-GR":"\u03A4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1","el":"\u03A4\u03BC\u03AE\u03BC\u03B1\u03C4\u03B1","en-GB":"Divisions","es-ES":"Categor\xedas","es":"Categor\xedas","fi-FI":"Kategoriat","fr-FR":"Divisions","fr":"Divisions","he-IL":"\u05DE\u05D7\u05DC\u05E7\u05D5\u05EA","hr-HR":"Kategorije","hu-HU":"R\xe9szlegek","hu":"R\xe9szlegek","it-IT":"Reparti","it":"Reparti","ja-JP":"\u90E8\u9580","ja":"\u90E8\u9580","ko-KR":"\uBD80\uC11C","ko":"\uBD80\uC11C","nl-NL":"Divisies","nl":"Divisies","no-NO":"Avdelinger","pl-PL":"Dzia\u0142y","pl":"Dzia\u0142y","pt-BR":"Divis\xf5es","pt-PT":"Divis\xf5es","ru-RU":"\u041E\u0442\u0434\u0435\u043B\u044B","ru":"\u041E\u0442\u0434\u0435\u043B\u044B","sv-SE":"Avdelningar","sv":"Avdelningar","th-TH":"\u0E2B\u0E21\u0E27\u0E14","th":"\u0E2B\u0E21\u0E27\u0E14","tr-TR":"B\xf6l\xfcmler","tr":"B\xf6l\xfcmler"},"RL_EditPromotion":{"key":"RL_EditPromotion","en":"Edit Promotion","ca-ES":"Edita la promoci\xf3","ca":"Edita la promoci\xf3","cs-CZ":"Upravit promoakci","cs":"Upravit promoakci","da-DK":"Rediger kampagne","da":"Rediger kampagne","de-DE":"Angebot bearbeiten","de":"Angebot bearbeiten","el-GR":"\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","el":"\u0395\u03C0\u03B5\u03BE\u03B5\u03C1\u03B3\u03B1\u03C3\u03AF\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en-GB":"Edit Promotion","es-ES":"Editar promoci\xf3n","es":"Editar promoci\xf3n","fi-FI":"Muokkaa tarjouskampanjaa","fr-FR":"Modifier la promotion","fr":"Modifier la promotion","he-IL":"\u05E2\u05E8\u05DB\u05D5 \u05D0\u05EA \u05D4\u05DE\u05D1\u05E6\u05E2","hr-HR":"Uredi promociju","hu-HU":"Prom\xf3ci\xf3 szerkeszt\xe9se","hu":"Prom\xf3ci\xf3 szerkeszt\xe9se","it-IT":"Modifica promozione","it":"Modifica promozione","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u7DE8\u96C6","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u7DE8\u96C6","ko-KR":"\uD504\uB85C\uBAA8\uC158 \uD3B8\uC9D1","ko":"\uD504\uB85C\uBAA8\uC158 \uD3B8\uC9D1","nl-NL":"Bewerk promotie","nl":"Bewerk promotie","no-NO":"Endre kampanje","pl-PL":"Edytuj promocj\u0119","pl":"Edytuj promocj\u0119","pt-BR":"Editar promo\xe7\xe3o","pt-PT":"Editar promo\xe7\xe3o","ru-RU":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0430\u043A\u0446\u0438\u044E","ru":"\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0430\u043A\u0446\u0438\u044E","sv-SE":"Redigera kampanj","sv":"Redigera kampanj","th-TH":"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","th":"\u0E41\u0E01\u0E49\u0E44\u0E02\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr-TR":"Promosyonu D\xfczenle","tr":"Promosyonu D\xfczenle"},"RL_EndDate":{"key":"RL_EndDate","en":"End Date","ca-ES":"Data de finalitzaci\xf3","ca":"Data de finalitzaci\xf3","cs-CZ":"Koncov\xe9 datum","cs":"Koncov\xe9 datum","da-DK":"Slutdato","da":"Slutdato","de-DE":"Enddatum","de":"Enddatum","el-GR":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2","el":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2","en-GB":"End Date","es-ES":"Fecha de finalizaci\xf3n","es":"Fecha de finalizaci\xf3n","fi-FI":"P\xe4\xe4ttymisp\xe4iv\xe4","fr-FR":"Date de fin","fr":"Date de fin","he-IL":"\u05EA\u05D0\u05E8\u05D9\u05DA \u05E1\u05D9\u05D5\u05DD","hr-HR":"Datum zavr\u0161etka","hu-HU":"Befejez\xe9s d\xe1tuma","hu":"Befejez\xe9s d\xe1tuma","it-IT":"Data di fine","it":"Data di fine","ja-JP":"\u7D42\u4E86\u65E5","ja":"\u7D42\u4E86\u65E5","ko-KR":"\uC885\uB8CC\uC77C","ko":"\uC885\uB8CC\uC77C","nl-NL":"Einddatum","nl":"Einddatum","no-NO":"Sluttdato","pl-PL":"Data ko\u0144cowa","pl":"Data ko\u0144cowa","pt-BR":"Data de t\xe9rmino","pt-PT":"Data de fim","ru-RU":"\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F","ru":"\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F","sv-SE":"Slutdatum","sv":"Slutdatum","th-TH":"\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14","th":"\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14","tr-TR":"Biti\u015F Tarihi","tr":"Biti\u015F Tarihi"},"RL_EndDateValidation1":{"key":"RL_EndDateValidation1","en":"New End Date must be at least 2 days in the future.","ca-ES":"La nova data de finalitzaci\xf3 s\'ha de definir, com a m\xednim, dos dies despr\xe9s de la data actual.","ca":"La nova data de finalitzaci\xf3 s\'ha de definir, com a m\xednim, dos dies despr\xe9s de la data actual.","cs-CZ":"Nov\xe9 datum ukon\u010Den\xed mus\xed b\xfdt alespo\u0148 po dvou dnech.","cs":"Nov\xe9 datum ukon\u010Den\xed mus\xed b\xfdt alespo\u0148 po dvou dnech.","da-DK":"Den nye slutdato skal v\xe6re mindst to dage ude i fremtiden.","da":"Den nye slutdato skal v\xe6re mindst to dage ude i fremtiden.","de-DE":"Das neue Enddatum muss mindestens zwei Tage in der Zukunft liegen.","de":"Das neue Enddatum muss mindestens zwei Tage in der Zukunft liegen.","el-GR":"\u0397 \u03BD\u03AD\u03B1 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AE (\u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03B4\u03CD\u03BF \u03BC\u03AD\u03C1\u03B5\u03C2 \u03BC\u03B5\u03C4\u03AC).","el":"\u0397 \u03BD\u03AD\u03B1 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AE (\u03C4\u03BF\u03C5\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF\u03BD \u03B4\u03CD\u03BF \u03BC\u03AD\u03C1\u03B5\u03C2 \u03BC\u03B5\u03C4\u03AC).","en-GB":"New end date must be at least 2 days in the future.","es-ES":"La nueva fecha de finalizaci\xf3n debe fijarse al menos dentro de 2 d\xedas.","es":"La nueva fecha de finalizaci\xf3n debe fijarse al menos dentro de 2 d\xedas.","fi-FI":"Uuden p\xe4\xe4ttymisp\xe4iv\xe4n on oltava v\xe4hint\xe4\xe4n kaksi p\xe4iv\xe4\xe4 tulevaisuudessa.","fr-FR":"La nouvelle date de fin doit \xeatre post\xe9rieure d\'au moins 2\xa0jours \xe0 la date actuelle.","fr":"La nouvelle date de fin doit \xeatre post\xe9rieure d\'au moins 2\xa0jours \xe0 la date actuelle.","he-IL":"\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05E1\u05D9\u05D5\u05DD \u05D4\u05D7\u05D3\u05E9 \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05EA\u05E7\u05D9\u05D9\u05DD \u05DC\u05E4\u05D7\u05D5\u05EA \u05D9\u05D5\u05DE\u05D9\u05D9\u05DD \u05DE\u05D4\u05D9\u05D5\u05DD.","hr-HR":"Novi datum zavr\u0161etka mora biti barem dva dana u budu\u0107nosti.","hu-HU":"Az \xfaj befejez\xe9si d\xe1tumnak legal\xe1bb k\xe9t nap m\xfalva kell lennie.","hu":"Az \xfaj befejez\xe9si d\xe1tumnak legal\xe1bb k\xe9t nap m\xfalva kell lennie.","it-IT":"La nuova data di fine deve essere stabilita ad almeno 2 giorni di distanza.","it":"La nuova data di fine deve essere stabilita ad almeno 2 giorni di distanza.","ja-JP":"\u65B0\u3057\u3044\u7D42\u4E86\u65E5\u306F2\u65E5\u5F8C\u4EE5\u964D\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ja":"\u65B0\u3057\u3044\u7D42\u4E86\u65E5\u306F2\u65E5\u5F8C\u4EE5\u964D\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ko-KR":"\uC0C8 \uC885\uB8CC\uC77C\uC740 \uD604\uC7AC\uB85C\uBD80\uD130 \uCD5C\uC18C 2\uC77C \uD6C4\uC5EC\uC57C \uD569\uB2C8\uB2E4.","ko":"\uC0C8 \uC885\uB8CC\uC77C\uC740 \uD604\uC7AC\uB85C\uBD80\uD130 \uCD5C\uC18C 2\uC77C \uD6C4\uC5EC\uC57C \uD569\uB2C8\uB2E4.","nl-NL":"De nieuwe einddatum moet minimaal twee dagen in de toekomst liggen.","nl":"De nieuwe einddatum moet minimaal twee dagen in de toekomst liggen.","no-NO":"Ny sluttdato m\xe5 v\xe6re minst to dager i fremtiden.","pl-PL":"Nowa data ko\u0144cowa musi przypada\u0107 najwcze\u015Bniej za 2 dni.","pl":"Nowa data ko\u0144cowa musi przypada\u0107 najwcze\u015Bniej za 2 dni.","pt-BR":"A nova data de t\xe9rmino deve ser pelo menos dois dias no futuro.","pt-PT":"A nova Data de fim tem de se situar, no m\xednimo, 2 dias no futuro.","ru-RU":"\u041D\u043E\u0432\u0430\u044F \u0434\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 2\xa0\u0434\u043D\u044F.","ru":"\u041D\u043E\u0432\u0430\u044F \u0434\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 2\xa0\u0434\u043D\u044F.","sv-SE":"Nytt slutdatum m\xe5ste vara minst 2 dagar fram\xe5t.","sv":"Nytt slutdatum m\xe5ste vara minst 2 dagar fram\xe5t.","th-TH":"\u0E27\u0E31\u0E19\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E43\u0E2B\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E35\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 2 \u0E27\u0E31\u0E19\u0E02\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32","th":"\u0E27\u0E31\u0E19\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E43\u0E2B\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E35\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22 2 \u0E27\u0E31\u0E19\u0E02\u0E49\u0E32\u0E07\u0E2B\u0E19\u0E49\u0E32","tr-TR":"Yeni Biti\u015F Tarihi, en az 2 g\xfcn sonra olmal\u0131d\u0131r.","tr":"Yeni Biti\u015F Tarihi, en az 2 g\xfcn sonra olmal\u0131d\u0131r."},"RL_EndDateValidation2":{"key":"RL_EndDateValidation2","en":"End Date must be after Start Date.","ca-ES":"La data de finalitzaci\xf3 ha de ser posterior a la data d\'inici.","ca":"La data de finalitzaci\xf3 ha de ser posterior a la data d\'inici.","cs-CZ":"Datum ukon\u010Den\xed mus\xed b\xfdt po datu zah\xe1jen\xed.","cs":"Datum ukon\u010Den\xed mus\xed b\xfdt po datu zah\xe1jen\xed.","da-DK":"Slutdatoen skal ligge efter startdatoen.","da":"Slutdatoen skal ligge efter startdatoen.","de-DE":"Das Enddatum muss nach dem Startdatum liegen.","de":"Das Enddatum muss nach dem Startdatum liegen.","el-GR":"\u0397 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03C4\u03B1\u03B3\u03B5\u03BD\u03AD\u03C3\u03C4\u03B5\u03C1\u03B7 \u03C4\u03B7\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1\u03C2 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2.","el":"\u0397 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BB\u03AE\u03BE\u03B7\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B5\u03AF\u03BD\u03B1\u03B9 \u03BC\u03B5\u03C4\u03B1\u03B3\u03B5\u03BD\u03AD\u03C3\u03C4\u03B5\u03C1\u03B7 \u03C4\u03B7\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1\u03C2 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2.","en-GB":"End date must be after start date.","es-ES":"La fecha de finalizaci\xf3n debe ser posterior a la fecha de inicio.","es":"La fecha de finalizaci\xf3n debe ser posterior a la fecha de inicio.","fi-FI":"P\xe4\xe4ttymisp\xe4iv\xe4n on oltava alkamisp\xe4iv\xe4n j\xe4lkeen.","fr-FR":"La date de fin doit \xeatre post\xe9rieure \xe0 la date de d\xe9but.","fr":"La date de fin doit \xeatre post\xe9rieure \xe0 la date de d\xe9but.","he-IL":"\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05E1\u05D9\u05D5\u05DD \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05EA\u05E7\u05D9\u05D9\u05DD \u05D0\u05D7\u05E8\u05D9 \u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05D4\u05EA\u05D7\u05DC\u05D4.","hr-HR":"Datum zavr\u0161etka mora biti nakon datuma po\u010Detka.","hu-HU":"A befejez\xe9si d\xe1tumnak a kezd\u0151 d\xe1tumn\xe1l k\xe9s\u0151bbi id\u0151pontnak kell lennie.","hu":"A befejez\xe9si d\xe1tumnak a kezd\u0151 d\xe1tumn\xe1l k\xe9s\u0151bbi id\u0151pontnak kell lennie.","it-IT":"La data di fine deve essere successiva alla data d\'inizio.","it":"La data di fine deve essere successiva alla data d\'inizio.","ja-JP":"\u7D42\u4E86\u65E5\u306F\u958B\u59CB\u65E5\u3088\u308A\u3082\u5F8C\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","ja":"\u7D42\u4E86\u65E5\u306F\u958B\u59CB\u65E5\u3088\u308A\u3082\u5F8C\u306B\u3059\u308B\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002","ko-KR":"\uC885\uB8CC\uC77C\uC740 \uC2DC\uC791\uC77C \uC774\uD6C4\uC5EC\uC57C \uD569\uB2C8\uB2E4.","ko":"\uC885\uB8CC\uC77C\uC740 \uC2DC\uC791\uC77C \uC774\uD6C4\uC5EC\uC57C \uD569\uB2C8\uB2E4.","nl-NL":"De einddatum moet na de begindatum zijn.","nl":"De einddatum moet na de begindatum zijn.","no-NO":"Sluttdato m\xe5 v\xe6re etter startdato.","pl-PL":"Data ko\u0144cowa musi przypada\u0107 po dacie rozpocz\u0119cia.","pl":"Data ko\u0144cowa musi przypada\u0107 po dacie rozpocz\u0119cia.","pt-BR":"A data de t\xe9rmino deve ser posterior \xe0 data de in\xedcio.","pt-PT":"A Data de fim tem de ser posterior \xe0 Data de in\xedcio.","ru-RU":"\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043F\u043E\u0437\u0436\u0435 \u0434\u0430\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u0430.","ru":"\u0414\u0430\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043F\u043E\u0437\u0436\u0435 \u0434\u0430\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u0430.","sv-SE":"Slutdatumet m\xe5ste vara efter startdatumet.","sv":"Slutdatumet m\xe5ste vara efter startdatumet.","th-TH":"\u0E27\u0E31\u0E19\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E32\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E27\u0E31\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19","th":"\u0E27\u0E31\u0E19\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14\u0E15\u0E49\u0E2D\u0E07\u0E21\u0E32\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E27\u0E31\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19","tr-TR":"Biti\u015F Tarihi, Ba\u015Flang\u0131\xe7 Tarihinden sonra olmal\u0131d\u0131r.","tr":"Biti\u015F Tarihi, Ba\u015Flang\u0131\xe7 Tarihinden sonra olmal\u0131d\u0131r."},"RL_Ends":{"key":"RL_Ends","en":"Ends","ca-ES":"Finalitza","ca":"Finalitza","cs-CZ":"Kon\u010D\xed","cs":"Kon\u010D\xed","da-DK":"Slutter","da":"Slutter","de-DE":"Endet","de":"Endet","el-GR":"\u039B\u03AE\u03B3\u03B5\u03B9:","el":"\u039B\u03AE\u03B3\u03B5\u03B9:","en-GB":"Ends","es-ES":"Finaliza","es":"Finaliza","fi-FI":"P\xe4\xe4ttyy","fr-FR":"Prend fin","fr":"Prend fin","he-IL":"\u05DE\u05E1\u05EA\u05D9\u05D9\u05DD","hr-HR":"Zavr\u0161ava","hu-HU":"Befejez\xe9s:","hu":"Befejez\xe9s:","it-IT":"Termine:","it":"Termine:","ja-JP":"\u7D42\u4E86","ja":"\u7D42\u4E86","ko-KR":"\uC885\uB8CC","ko":"\uC885\uB8CC","nl-NL":"Eindigt","nl":"Eindigt","no-NO":"Slutter","pl-PL":"Wa\u017Cna do:","pl":"Wa\u017Cna do:","pt-BR":"Concluir","pt-PT":"Termina a","ru-RU":"\u0417\u0430\u0432\u0435\u0440\u0448\u0430\u0435\u0442\u0441\u044F","ru":"\u0417\u0430\u0432\u0435\u0440\u0448\u0430\u0435\u0442\u0441\u044F","sv-SE":"Slutar","sv":"Slutar","th-TH":"\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14","th":"\u0E2A\u0E34\u0E49\u0E19\u0E2A\u0E38\u0E14","tr-TR":"Sona Erdi\u011Fi Tarih:","tr":"Sona Erdi\u011Fi Tarih:"},"RL_Equipment":{"key":"RL_Equipment","en":"Equipment","ca-ES":"Equipament","ca":"Equipament","cs-CZ":"Sportovn\xed pot\u0159eby","cs":"Sportovn\xed pot\u0159eby","da-DK":"Udstyr","da":"Udstyr","de-DE":"Equipment","de":"Equipment","el-GR":"\u0395\u03BE\u03BF\u03C0\u03BB\u03B9\u03C3\u03BC\u03CC\u03C2","el":"\u0395\u03BE\u03BF\u03C0\u03BB\u03B9\u03C3\u03BC\u03CC\u03C2","en-GB":"Equipment","es-ES":"Equipamiento","es":"Equipamiento","fi-FI":"Varusteet","fr-FR":"\xc9quipement","fr":"\xc9quipement","he-IL":"\u05E6\u05D9\u05D5\u05D3","hr-HR":"Oprema","hu-HU":"Kell\xe9kek","hu":"Kell\xe9kek","it-IT":"Accessori","it":"Accessori","ja-JP":"\u5668\u5177","ja":"\u5668\u5177","ko-KR":"\uAE30\uAD6C","ko":"\uAE30\uAD6C","nl-NL":"Materialen","nl":"Materialen","no-NO":"Utstyr","pl-PL":"Sprz\u0119t","pl":"Sprz\u0119t","pt-BR":"Equipamento","pt-PT":"Equipamento","ru-RU":"\u0421\u043D\u0430\u0440\u044F\u0436\u0435\u043D\u0438\u0435","ru":"\u0421\u043D\u0430\u0440\u044F\u0436\u0435\u043D\u0438\u0435","sv-SE":"Utrustning","sv":"Utrustning","th-TH":"\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C","th":"\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C","tr-TR":"Ekipman","tr":"Ekipman"},"RL_EquipmentDivision":{"key":"RL_EquipmentDivision","en":"Equipment Division","ca-ES":"Categoria d\'equipament","ca":"Categoria d\'equipament","cs-CZ":"Sekce Sportovn\xed pot\u0159eby","cs":"Sekce Sportovn\xed pot\u0159eby","da-DK":"Udstyrsdivision","da":"Udstyrsdivision","de-DE":"Equipment Division","de":"Equipment Division","el-GR":"\u03A4\u03BC\u03AE\u03BC\u03B1 \u03B5\u03BE\u03BF\u03C0\u03BB\u03B9\u03C3\u03BC\u03BF\u03CD","el":"\u03A4\u03BC\u03AE\u03BC\u03B1 \u03B5\u03BE\u03BF\u03C0\u03BB\u03B9\u03C3\u03BC\u03BF\u03CD","en-GB":"Equipment Division","es-ES":"Categor\xeda de equipamiento","es":"Categor\xeda de equipamiento","fi-FI":"Varustekategoria","fr-FR":"Division \xe9quipement","fr":"Division \xe9quipement","he-IL":"\u05DE\u05D7\u05DC\u05E7\u05EA \u05E6\u05D9\u05D5\u05D3","hr-HR":"Kategorija opreme","hu-HU":"Kell\xe9kek r\xe9szleg","hu":"Kell\xe9kek r\xe9szleg","it-IT":"Reparto accessori","it":"Reparto accessori","ja-JP":"\u5668\u5177\u90E8\u9580","ja":"\u5668\u5177\u90E8\u9580","ko-KR":"\uAE30\uAD6C \uBD80\uC11C","ko":"\uAE30\uAD6C \uBD80\uC11C","nl-NL":"Divisie materialen","nl":"Divisie materialen","no-NO":"Utstyrsavdeling","pl-PL":"Dzia\u0142 Sprz\u0119t","pl":"Dzia\u0142 Sprz\u0119t","pt-BR":"Divis\xe3o de equipamentos","pt-PT":"Divis\xe3o de equipamento","ru-RU":"\u041E\u0442\u0434\u0435\u043B \u0441\u043D\u0430\u0440\u044F\u0436\u0435\u043D\u0438\u044F","ru":"\u041E\u0442\u0434\u0435\u043B \u0441\u043D\u0430\u0440\u044F\u0436\u0435\u043D\u0438\u044F","sv-SE":"Utrustningsavdelning","sv":"Utrustningsavdelning","th-TH":"\u0E2B\u0E21\u0E27\u0E14\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C","th":"\u0E2B\u0E21\u0E27\u0E14\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C","tr-TR":"Ekipman Departman\u0131","tr":"Ekipman Departman\u0131"},"RL_Footwear":{"key":"RL_Footwear","en":"Footwear","ca-ES":"Sabatilles","ca":"Sabatilles","cs-CZ":"Boty","cs":"Boty","da-DK":"Fodt\xf8j","da":"Fodt\xf8j","de-DE":"Schuhe","de":"Schuhe","el-GR":"\u03A0\u03B1\u03C0\u03BF\u03CD\u03C4\u03C3\u03B9\u03B1","el":"\u03A0\u03B1\u03C0\u03BF\u03CD\u03C4\u03C3\u03B9\u03B1","en-GB":"Footwear","es-ES":"Zapatillas","es":"Zapatillas","fi-FI":"Keng\xe4t","fr-FR":"Chaussures","fr":"Chaussures","he-IL":"\u05D4\u05E0\u05E2\u05DC\u05D4","hr-HR":"Obu\u0107a","hu-HU":"Cip\u0151k","hu":"Cip\u0151k","it-IT":"Scarpe","it":"Scarpe","ja-JP":"\u30D5\u30C3\u30C8\u30A6\u30A7\u30A2","ja":"\u30D5\u30C3\u30C8\u30A6\u30A7\u30A2","ko-KR":"\uC2E0\uBC1C","ko":"\uC2E0\uBC1C","nl-NL":"Schoenen","nl":"Schoenen","no-NO":"Sko","pl-PL":"Buty","pl":"Buty","pt-BR":"Cal\xe7ados","pt-PT":"Cal\xe7ado","ru-RU":"\u041E\u0431\u0443\u0432\u044C","ru":"\u041E\u0431\u0443\u0432\u044C","sv-SE":"Skor","sv":"Skor","th-TH":"\u0E23\u0E2D\u0E07\u0E40\u0E17\u0E49\u0E32","th":"\u0E23\u0E2D\u0E07\u0E40\u0E17\u0E49\u0E32","tr-TR":"Ayakkab\u0131","tr":"Ayakkab\u0131"},"RL_For":{"key":"RL_For","en":"for","ca-ES":"per a","ca":"per a","cs-CZ":"pro","cs":"pro","da-DK":"til","da":"til","de-DE":"f\xfcr","de":"f\xfcr","el-GR":"\u03B3\u03B9\u03B1","el":"\u03B3\u03B9\u03B1","en-GB":"for","es-ES":"para","es":"para","fi-FI":"ryhm\xe4lle","fr-FR":"pour","fr":"pour","he-IL":"\u05E2\u05D1\u05D5\u05E8","hr-HR":"za","hu-HU":"c\xe9lk\xf6z\xf6ns\xe9g:","hu":"c\xe9lk\xf6z\xf6ns\xe9g:","it-IT":"per","it":"per","ja-JP":"\u5BFE\u8C61\uFF1A","ja":"\u5BFE\u8C61\uFF1A","ko-KR":"\uC6A9\uB3C4","ko":"\uC6A9\uB3C4","nl-NL":"voor","nl":"voor","no-NO":"for","pl-PL":"dla","pl":"dla","pt-BR":"para","pt-PT":"para","ru-RU":"\u0434\u043B\u044F","ru":"\u0434\u043B\u044F","sv-SE":"f\xf6r","sv":"f\xf6r","th-TH":"\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A","th":"\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A","tr-TR":"\u015Funun i\xe7in:","tr":"\u015Funun i\xe7in:"},"RL_Gender":{"key":"RL_Gender","en":"Gender","ca-ES":"Sexe","ca":"Sexe","cs-CZ":"Pohlav\xed","cs":"Pohlav\xed","da-DK":"K\xf8n","da":"K\xf8n","de-DE":"Geschlecht","de":"Geschlecht","el-GR":"\u03A6\u03CD\u03BB\u03BF","el":"\u03A6\u03CD\u03BB\u03BF","en-GB":"Gender","es-ES":"Sexo","es":"Sexo","fi-FI":"Sukupuoli","fr-FR":"Sexe","fr":"Sexe","he-IL":"\u05DE\u05D2\u05D3\u05E8","hr-HR":"Spol","hu-HU":"Nem","hu":"Nem","it-IT":"Genere","it":"Genere","ja-JP":"\u6027\u5225","ja":"\u6027\u5225","ko-KR":"\uC131\uBCC4","ko":"\uC131\uBCC4","nl-NL":"Geslacht","nl":"Geslacht","no-NO":"Kj\xf8nn","pl-PL":"P\u0142e\u0107","pl":"P\u0142e\u0107","pt-BR":"Sexo","pt-PT":"Sexo","ru-RU":"\u041F\u043E\u043B","ru":"\u041F\u043E\u043B","sv-SE":"K\xf6n","sv":"K\xf6n","th-TH":"\u0E40\u0E1E\u0E28","th":"\u0E40\u0E1E\u0E28","tr-TR":"Cinsiyet","tr":"Cinsiyet"},"RL_Genders":{"key":"RL_Genders","en":"Genders","ca-ES":"Sexes","ca":"Sexes","cs-CZ":"Pohlav\xed","cs":"Pohlav\xed","da-DK":"K\xf8n","da":"K\xf8n","de-DE":"Geschlechter","de":"Geschlechter","el-GR":"\u03A6\u03CD\u03BB\u03B1","el":"\u03A6\u03CD\u03BB\u03B1","en-GB":"Genders","es-ES":"Sexos","es":"Sexos","fi-FI":"Sukupuolet","fr-FR":"Sexes","fr":"Sexes","he-IL":"\u05DE\u05D2\u05D3\u05E8\u05D9\u05DD","hr-HR":"Spolovi","hu-HU":"Nemek","hu":"Nemek","it-IT":"Generi","it":"Generi","ja-JP":"\u6027\u5225","ja":"\u6027\u5225","ko-KR":"\uC131\uBCC4","ko":"\uC131\uBCC4","nl-NL":"Geslachten","nl":"Geslachten","no-NO":"Kj\xf8nn","pl-PL":"P\u0142cie","pl":"P\u0142cie","pt-BR":"G\xeaneros","pt-PT":"Sexos","ru-RU":"\u041F\u043E\u043B","ru":"\u041F\u043E\u043B","sv-SE":"K\xf6n","sv":"K\xf6n","th-TH":"\u0E40\u0E1E\u0E28","th":"\u0E40\u0E1E\u0E28","tr-TR":"Cinsiyetler","tr":"Cinsiyetler"},"RL_InTransit":{"key":"RL_InTransit","en":"In Transit","ca-ES":"En tr\xe0nsit","ca":"En tr\xe0nsit","cs-CZ":"P\u0159epravuje se","cs":"P\u0159epravuje se","da-DK":"P\xe5 vej","da":"P\xe5 vej","de-DE":"Auf dem Weg","de":"Auf dem Weg","el-GR":"\u03A3\u03B5 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC","el":"\u03A3\u03B5 \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03AC","en-GB":"In Transit","es-ES":"En camino","es":"En camino","fi-FI":"Kuljetuksessa","fr-FR":"En transit","fr":"En transit","he-IL":"\u05D1\u05D3\u05E8\u05DA","hr-HR":"U prijenosu","hu-HU":"Sz\xe1ll\xedt\xe1s folyamatban","hu":"Sz\xe1ll\xedt\xe1s folyamatban","it-IT":"In transito","it":"In transito","ja-JP":"\u914D\u9001\u4E2D","ja":"\u914D\u9001\u4E2D","ko-KR":"\uC774\uB3D9 \uC911","ko":"\uC774\uB3D9 \uC911","nl-NL":"In behandeling","nl":"In behandeling","no-NO":"Under transport","pl-PL":"W transporcie","pl":"W transporcie","pt-BR":"Em tr\xe2nsito","pt-PT":"Em tr\xe2nsito","ru-RU":"\u0412 \u043F\u0443\u0442\u0438","ru":"\u0412 \u043F\u0443\u0442\u0438","sv-SE":"P\xe5 v\xe4g","sv":"P\xe5 v\xe4g","th-TH":"\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E02\u0E19\u0E2A\u0E48\u0E07","th":"\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07\u0E02\u0E19\u0E2A\u0E48\u0E07","tr-TR":"Ta\u015F\u0131mada","tr":"Ta\u015F\u0131mada"},"RL_ItemDeleteFail":{"key":"RL_ItemDeleteFail","en":"Some items failed to delete. ** Please try again.","ca-ES":"undefined","ca":"undefined","cs-CZ":"N\u011Bkter\xe9 polo\u017Eky se nepoda\u0159ilo smazat. ** Zkuste to znova.","cs":"N\u011Bkter\xe9 polo\u017Eky se nepoda\u0159ilo smazat. ** Zkuste to znova.","da-DK":"Nogle varer blev ikke slettet. ** Pr\xf8v igen.","da":"Nogle varer blev ikke slettet. ** Pr\xf8v igen.","de-DE":"Einige Artikel konnten nicht gel\xf6scht werden. ** Bitte versuche es erneut.","de":"Einige Artikel konnten nicht gel\xf6scht werden. ** Bitte versuche es erneut.","el-GR":"\u0397 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03C9\u03BD \u03B5\u03B9\u03B4\u03CE\u03BD \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5. **\u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","el":"\u0397 \u03B4\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03BF\u03C1\u03B9\u03C3\u03BC\u03AD\u03BD\u03C9\u03BD \u03B5\u03B9\u03B4\u03CE\u03BD \u03B1\u03C0\u03AD\u03C4\u03C5\u03C7\u03B5. **\u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","en-GB":"Failed to delete some items. ** Please try again.","es-ES":"Algunos productos no se han borrado correctamente. **\xa0Vuelve a intentarlo.","es":"Algunos productos no se han borrado correctamente. **\xa0Vuelve a intentarlo.","fi-FI":"Joitain tuotteita ei voitu poistaa. ** Yrit\xe4 uudelleen.","fr-FR":"Certains articles n\'ont pas pu \xeatre supprim\xe9s. **\xa0Veuillez r\xe9essayer.","fr":"Certains articles n\'ont pas pu \xeatre supprim\xe9s. **\xa0Veuillez r\xe9essayer.","he-IL":"\u05E0\u05DB\u05E9\u05DC\u05D4 \u05D4\u05DE\u05D7\u05D9\u05E7\u05D4 \u05E9\u05DC \u05D7\u05DC\u05E7 \u05DE\u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD. ** \u05E0\u05E1\u05D5 \u05E9\u05D5\u05D1.","hr-HR":"Brisanje odre\u0111enih stavki nije uspjelo. ** Poku\u0161ajte ponovno.","hu-HU":"Egyes cikkek t\xf6rl\xe9se nem siker\xfclt. ** Pr\xf3b\xe1ld \xfajra.","hu":"Egyes cikkek t\xf6rl\xe9se nem siker\xfclt. ** Pr\xf3b\xe1ld \xfajra.","it-IT":"Alcuni articoli non sono stati eliminati. ** Riprova.","it":"Alcuni articoli non sono stati eliminati. ** Riprova.","ja-JP":"\u3044\u304F\u3064\u304B\u306E\u5546\u54C1\u3092\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002 ** \u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","ja":"\u3044\u304F\u3064\u304B\u306E\u5546\u54C1\u3092\u524A\u9664\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002 ** \u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","ko-KR":"\uC77C\uBD80 \uD56D\uBAA9\uC744 \uC0AD\uC81C\uD558\uB294 \uB370 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. ** \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.","ko":"\uC77C\uBD80 \uD56D\uBAA9\uC744 \uC0AD\uC81C\uD558\uB294 \uB370 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4. ** \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.","nl-NL":"Sommige artikelen konden niet worden verwijderd. ** Probeer het opnieuw.","nl":"Sommige artikelen konden niet worden verwijderd. ** Probeer het opnieuw.","no-NO":"Noen varer kunne ikke slettes. ** Pr\xf8v p\xe5 nytt.","pl-PL":"Nie uda\u0142o si\u0119 usun\u0105\u0107 niekt\xf3rych produkt\xf3w. ** Spr\xf3buj ponownie.","pl":"Nie uda\u0142o si\u0119 usun\u0105\u0107 niekt\xf3rych produkt\xf3w. ** Spr\xf3buj ponownie.","pt-BR":"Falha ao remover alguns itens. ** Tente novamente.","pt-PT":"Falha ao eliminar alguns artigos. ** Tente novamente.","ru-RU":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B. ** \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.","ru":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B. ** \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.","sv-SE":"Vissa produkter uppdaterades inte. ** F\xf6rs\xf6k igen.","sv":"Vissa produkter uppdaterades inte. ** F\xf6rs\xf6k igen.","th-TH":"\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E32\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27 ** \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","th":"\u0E01\u0E32\u0E23\u0E25\u0E1A\u0E1A\u0E32\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27 ** \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","tr-TR":"Baz\u0131 \xfcr\xfcnler silinemedi. ** L\xfctfen tekrar dene.","tr":"Baz\u0131 \xfcr\xfcnler silinemedi. ** L\xfctfen tekrar dene."},"RL_Kids":{"key":"RL_Kids","en":"Kids","ca-ES":"Nen/a","ca":"Nen/a","cs-CZ":"D\u011Bti","cs":"D\u011Bti","da-DK":"B\xf8rn","da":"B\xf8rn","de-DE":"Kinder","de":"Kinder","el-GR":"\u03A0\u03B1\u03B9\u03B4\u03B9\u03AC","el":"\u03A0\u03B1\u03B9\u03B4\u03B9\u03AC","en-GB":"Kids","es-ES":"Ni\xf1o/a","es":"Ni\xf1o/a","fi-FI":"Lapset","fr-FR":"Enfant","fr":"Enfant","he-IL":"\u05D9\u05DC\u05D3\u05D9\u05DD","hr-HR":"Djeca","hu-HU":"Gyerek","hu":"Gyerek","it-IT":"Bambini","it":"Bambini","ja-JP":"\u30AD\u30C3\u30BA","ja":"\u30AD\u30C3\u30BA","ko-KR":"\uD0A4\uC988","ko":"\uD0A4\uC988","nl-NL":"Kids","nl":"Kids","no-NO":"Barn","pl-PL":"Dzieci","pl":"Dzieci","pt-BR":"Infantil","pt-PT":"Crian\xe7a","ru-RU":"\u0414\u0435\u0442\u0438","ru":"\u0414\u0435\u0442\u0438","sv-SE":"Barn","sv":"Barn","th-TH":"\u0E40\u0E14\u0E47\u0E01","th":"\u0E40\u0E14\u0E47\u0E01","tr-TR":"\xc7ocuk","tr":"\xc7ocuk"},"RL_LogOut":{"key":"RL_LogOut","en":"Log Out","ca-ES":"Tanca la sessi\xf3","ca":"Tanca la sessi\xf3","cs-CZ":"Odhl\xe1sit se","cs":"Odhl\xe1sit se","da-DK":"Log af","da":"Log af","de-DE":"Abmelden","de":"Abmelden","el-GR":"\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","el":"\u0391\u03C0\u03BF\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","en-GB":"Log Out","es-ES":"Cerrar sesi\xf3n","es":"Cerrar sesi\xf3n","fi-FI":"Kirjaudu ulos","fr-FR":"D\xe9connexion","fr":"D\xe9connexion","he-IL":"\u05D9\u05E6\u05D9\u05D0\u05D4","hr-HR":"Odjava","hu-HU":"Kijelentkez\xe9s","hu":"Kijelentkez\xe9s","it-IT":"Esci","it":"Esci","ja-JP":"\u30ED\u30B0\u30A2\u30A6\u30C8","ja":"\u30ED\u30B0\u30A2\u30A6\u30C8","ko-KR":"\uB85C\uADF8\uC544\uC6C3","ko":"\uB85C\uADF8\uC544\uC6C3","nl-NL":"Log uit","nl":"Log uit","no-NO":"Logg av","pl-PL":"Wyloguj si\u0119","pl":"Wyloguj si\u0119","pt-BR":"Sair","pt-PT":"Terminar sess\xe3o","ru-RU":"\u0412\u044B\u0439\u0442\u0438","ru":"\u0412\u044B\u0439\u0442\u0438","sv-SE":"Logga ut","sv":"Logga ut","th-TH":"\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E2D\u0E32\u0E17\u0E4C","th":"\u0E25\u0E47\u0E2D\u0E01\u0E40\u0E2D\u0E32\u0E17\u0E4C","tr-TR":"Oturumu Kapat","tr":"Oturumu Kapat"},"RL_MarkdownAddSuccess":{"key":"RL_MarkdownAddSuccess","en":"Markdown added! Please click the \'X\' button to close this form.","ca-ES":"undefined","ca":"undefined","cs-CZ":"Sleva p\u0159id\xe1na. Tenhle formul\xe1\u0159 zav\u0159ete klepnut\xedm na symbol \u201EX\u201C.","cs":"Sleva p\u0159id\xe1na. Tenhle formul\xe1\u0159 zav\u0159ete klepnut\xedm na symbol \u201EX\u201C.","da-DK":"Prisneds\xe6ttelsen blev tilf\xf8jet. Klik p\xe5 \\"X\\"-knappen for at lukke denne formular.","da":"Prisneds\xe6ttelsen blev tilf\xf8jet. Klik p\xe5 \\"X\\"-knappen for at lukke denne formular.","de-DE":"Preisabschlag wurde hinzugef\xfcgt. Klicke auf die Schaltfl\xe4che \\"X\\", um dieses Formular zu schlie\xdfen.","de":"Preisabschlag wurde hinzugef\xfcgt. Klicke auf die Schaltfl\xe4che \\"X\\", um dieses Formular zu schlie\xdfen.","el-GR":"\u0397 \u03BC\u03B5\u03AF\u03C9\u03C3\u03B7 \u03C4\u03B9\u03BC\u03AE\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5! \u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03CC\u03C1\u03BC\u03B1, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \\"X\\".","el":"\u0397 \u03BC\u03B5\u03AF\u03C9\u03C3\u03B7 \u03C4\u03B9\u03BC\u03AE\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5! \u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03CC\u03C1\u03BC\u03B1, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \\"X\\".","en-GB":"Markdown added! Please click the \\"X\\" button to close this form.","es-ES":"Rebaja a\xf1adida. Haz clic en el bot\xf3n \\"X\\" para cerrar este formulario.","es":"Rebaja a\xf1adida. Haz clic en el bot\xf3n \\"X\\" para cerrar este formulario.","fi-FI":"Alennus lis\xe4tty! Valitse \'X\', kun haluat sulkea lomakkeen.","fr-FR":"D\xe9marque ajout\xe9e\xa0! Cliquez sur le bouton \xab\xa0X\xa0\xbb pour fermer ce formulaire.","fr":"D\xe9marque ajout\xe9e\xa0! Cliquez sur le bouton \xab\xa0X\xa0\xbb pour fermer ce formulaire.","he-IL":"\u05D4\u05D4\u05E0\u05D7\u05D4 \u05E0\u05D5\u05E1\u05E4\u05D4! \u05DC\u05D7\u05E6\u05D5 \u05E2\u05DC \u05D4\u05DC\u05D7\u05E6\u05DF \'X\' \u05DB\u05D3\u05D9 \u05DC\u05E1\u05D2\u05D5\u05E8 \u05D0\u05EA \u05D4\u05D8\u05D5\u05E4\u05E1.","hr-HR":"Dodano je sni\u017Eenje! Kliknite na gumb \u201EX\u201D za zatvaranje ovog obrasca.","hu-HU":"Le\xe9rt\xe9kel\xe9s hozz\xe1adva! Az \u0171rlap bez\xe1r\xe1s\xe1hoz kattints az \u201EX\u201D gombra.","hu":"Le\xe9rt\xe9kel\xe9s hozz\xe1adva! Az \u0171rlap bez\xe1r\xe1s\xe1hoz kattints az \u201EX\u201D gombra.","it-IT":"Ribasso aggiunto! Clicca sulla \\"X\\" per chiudere questo modulo.","it":"Ribasso aggiunto! Clicca sulla \\"X\\" per chiudere questo modulo.","ja-JP":"\u5024\u4E0B\u3052\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002 \u300CX\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u9589\u3058\u3066\u304F\u3060\u3055\u3044\u3002","ja":"\u5024\u4E0B\u3052\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002 \u300CX\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u9589\u3058\u3066\u304F\u3060\u3055\u3044\u3002","ko-KR":"\uAC00\uACA9 \uC778\uD558\uAC00 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4! \uC774 \uC591\uC2DD\uC744 \uB2EB\uC73C\uB824\uBA74 \'X\' \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC138\uC694.","ko":"\uAC00\uACA9 \uC778\uD558\uAC00 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4! \uC774 \uC591\uC2DD\uC744 \uB2EB\uC73C\uB824\uBA74 \'X\' \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC138\uC694.","nl-NL":"Korting toegevoegd. Klik op de \'X\' om dit formulier te sluiten.","nl":"Korting toegevoegd. Klik op de \'X\' om dit formulier te sluiten.","no-NO":"Tilbud lagt til. Klikk p\xe5 \xabX\xbb-knappen for \xe5 lukke dette skjemaet.","pl-PL":"Dodano obni\u017Ck\u0119! Kliknij przycisk \u201EX\u201D, by zamkn\u0105\u0107 ten formularz.","pl":"Dodano obni\u017Ck\u0119! Kliknij przycisk \u201EX\u201D, by zamkn\u0105\u0107 ten formularz.","pt-BR":"Redu\xe7\xe3o de pre\xe7o adicionada! Clique no bot\xe3o \u201CX\u201D para fechar este formul\xe1rio.","pt-PT":"Desconto adicionado! Clique no bot\xe3o \\"X\\" para fechar este formul\xe1rio.","ru-RU":"\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430 \u0443\u0446\u0435\u043D\u043A\u0430. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 X, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u044D\u0442\u0443 \u0444\u043E\u0440\u043C\u0443.","ru":"\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430 \u0443\u0446\u0435\u043D\u043A\u0430. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 X, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u044D\u0442\u0443 \u0444\u043E\u0440\u043C\u0443.","sv-SE":"Priss\xe4nkning har lagts till. Klicka p\xe5 knappen X f\xf6r att st\xe4nga formul\xe4ret.","sv":"Priss\xe4nkning har lagts till. Klicka p\xe5 knappen X f\xf6r att st\xe4nga formul\xe4ret.","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 \\"X\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 \\"X\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49","tr-TR":"\u0130ndirim eklendi! L\xfctfen bu formu kapatmak i\xe7in \\"X\\" d\xfc\u011Fmesine t\u0131kla.","tr":"\u0130ndirim eklendi! L\xfctfen bu formu kapatmak i\xe7in \\"X\\" d\xfc\u011Fmesine t\u0131kla."},"RL_Markdowns":{"key":"RL_Markdowns","en":"Markdowns","ca-ES":"Descomptes","ca":"Descomptes","cs-CZ":"Slevy","cs":"Slevy","da-DK":"Prisneds\xe6ttelser","da":"Prisneds\xe6ttelser","de-DE":"Reduzierungen","de":"Reduzierungen","el-GR":"\u039C\u03B5\u03B9\u03CE\u03C3\u03B5\u03B9\u03C2 \u03C4\u03B9\u03BC\u03CE\u03BD","el":"\u039C\u03B5\u03B9\u03CE\u03C3\u03B5\u03B9\u03C2 \u03C4\u03B9\u03BC\u03CE\u03BD","en-GB":"Markdowns","es-ES":"Descuentos","es":"Descuentos","fi-FI":"Alennukset","fr-FR":"D\xe9marques","fr":"D\xe9marques","he-IL":"\u05D4\u05E0\u05D7\u05D5\u05EA","hr-HR":"Sni\u017Eenja","hu-HU":"Le\xe9rt\xe9kel\xe9sek","hu":"Le\xe9rt\xe9kel\xe9sek","it-IT":"Ribassi","it":"Ribassi","ja-JP":"\u5024\u4E0B\u3052","ja":"\u5024\u4E0B\u3052","ko-KR":"\uAC00\uACA9 \uC778\uD558","ko":"\uAC00\uACA9 \uC778\uD558","nl-NL":"Prijsverlagingen","nl":"Prijsverlagingen","no-NO":"Tilbud","pl-PL":"Obni\u017Cki","pl":"Obni\u017Cki","pt-BR":"Redu\xe7\xf5es de pre\xe7o","pt-PT":"Pre\xe7o reduzido","ru-RU":"\u0423\u0446\u0435\u043D\u043A\u0430","ru":"\u0423\u0446\u0435\u043D\u043A\u0430","sv-SE":"Priss\xe4nkningar","sv":"Priss\xe4nkningar","th-TH":"\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32","th":"\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32","tr-TR":"\u0130ndirimler","tr":"\u0130ndirimler"},"RL_Men":{"key":"RL_Men","en":"Men","ca-ES":"Home","ca":"Home","cs-CZ":"Mu\u017Ei","cs":"Mu\u017Ei","da-DK":"M\xe6nd","da":"M\xe6nd","de-DE":"Herren","de":"Herren","el-GR":"\u0386\u03BD\u03B4\u03C1\u03B5\u03C2","el":"\u0386\u03BD\u03B4\u03C1\u03B5\u03C2","en-GB":"Men","es-ES":"Hombre","es":"Hombre","fi-FI":"Miehet","fr-FR":"Homme","fr":"Homme","he-IL":"\u05D2\u05D1\u05E8\u05D9\u05DD","hr-HR":"Mu\u0161karci","hu-HU":"F\xe9rfi","hu":"F\xe9rfi","it-IT":"Uomo","it":"Uomo","ja-JP":"\u30E1\u30F3\u30BA","ja":"\u30E1\u30F3\u30BA","ko-KR":"\uB0A8\uC131","ko":"\uB0A8\uC131","nl-NL":"Heren","nl":"Heren","no-NO":"Herre","pl-PL":"M\u0119\u017Cczy\u017Ani","pl":"M\u0119\u017Cczy\u017Ani","pt-BR":"Masculino","pt-PT":"Homem","ru-RU":"\u041C\u0443\u0436\u0447\u0438\u043D\u044B","ru":"\u041C\u0443\u0436\u0447\u0438\u043D\u044B","sv-SE":"M\xe4n","sv":"M\xe4n","th-TH":"\u0E1C\u0E39\u0E49\u0E0A\u0E32\u0E22","th":"\u0E1C\u0E39\u0E49\u0E0A\u0E32\u0E22","tr-TR":"Erkek","tr":"Erkek"},"RL_NewPrice":{"key":"RL_NewPrice","en":"New Price","ca-ES":"Preu nou","ca":"Preu nou","cs-CZ":"Nov\xe1 cena","cs":"Nov\xe1 cena","da-DK":"Ny pris","da":"Ny pris","de-DE":"Neuer Preis","de":"Neuer Preis","el-GR":"\u039D\u03AD\u03B1 \u03C4\u03B9\u03BC\u03AE","el":"\u039D\u03AD\u03B1 \u03C4\u03B9\u03BC\u03AE","en-GB":"New Price","es-ES":"Precio nuevo","es":"Precio nuevo","fi-FI":"Uusi hinta","fr-FR":"Nouveau prix","fr":"Nouveau prix","he-IL":"\u05DE\u05D7\u05D9\u05E8 \u05D7\u05D3\u05E9","hr-HR":"Nova cijena","hu-HU":"\xdaj \xe1r","hu":"\xdaj \xe1r","it-IT":"Nuovo prezzo","it":"Nuovo prezzo","ja-JP":"\u65B0\u4FA1\u683C","ja":"\u65B0\u4FA1\u683C","ko-KR":"\uC0C8 \uAC00\uACA9","ko":"\uC0C8 \uAC00\uACA9","nl-NL":"Nieuwe prijs","nl":"Nieuwe prijs","no-NO":"Ny pris","pl-PL":"Nowa cena","pl":"Nowa cena","pt-BR":"Novo pre\xe7o","pt-PT":"Novo pre\xe7o","ru-RU":"\u041D\u043E\u0432\u0430\u044F \u0446\u0435\u043D\u0430","ru":"\u041D\u043E\u0432\u0430\u044F \u0446\u0435\u043D\u0430","sv-SE":"Nytt pris","sv":"Nytt pris","th-TH":"\u0E23\u0E32\u0E04\u0E32\u0E43\u0E2B\u0E21\u0E48","th":"\u0E23\u0E32\u0E04\u0E32\u0E43\u0E2B\u0E21\u0E48","tr-TR":"Yeni Fiyat","tr":"Yeni Fiyat"},"RL_NoAssociatedProducts":{"key":"RL_NoAssociatedProducts","en":"There are no associated products.","ca-ES":"No hi ha productes associats.","ca":"No hi ha productes associats.","cs-CZ":"Nejsou \u017E\xe1dn\xe9 p\u0159idru\u017Een\xe9 produkty.","cs":"Nejsou \u017E\xe1dn\xe9 p\u0159idru\u017Een\xe9 produkty.","da-DK":"Der er ikke tilknyttet nogen produkter.","da":"Der er ikke tilknyttet nogen produkter.","de-DE":"Keine zugeordneten Produkte vorhanden.","de":"Keine zugeordneten Produkte vorhanden.","el-GR":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C3\u03C5\u03C3\u03C7\u03B5\u03C4\u03B9\u03C3\u03BC\u03AD\u03BD\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1.","el":"\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03C3\u03C5\u03C3\u03C7\u03B5\u03C4\u03B9\u03C3\u03BC\u03AD\u03BD\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1.","en-GB":"There are no associated products.","es-ES":"No hay productos asociados.","es":"No hay productos asociados.","fi-FI":"Tuotteita ei l\xf6ydy.","fr-FR":"Il n\'existe aucun produit associ\xe9.","fr":"Il n\'existe aucun produit associ\xe9.","he-IL":"\u05D0\u05D9\u05DF \u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05DE\u05E9\u05D5\u05D9\u05DB\u05D9\u05DD.","hr-HR":"Nema povezanih proizvoda.","hu-HU":"Nincs kapcsol\xf3d\xf3 term\xe9k.","hu":"Nincs kapcsol\xf3d\xf3 term\xe9k.","it-IT":"Nessun prodotto associato.","it":"Nessun prodotto associato.","ja-JP":"\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u5546\u54C1\u306F\u3042\u308A\u307E\u305B\u3093\u3002","ja":"\u95A2\u9023\u4ED8\u3051\u3089\u308C\u305F\u5546\u54C1\u306F\u3042\u308A\u307E\u305B\u3093\u3002","ko-KR":"\uC5F0\uACB0\uB41C \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.","ko":"\uC5F0\uACB0\uB41C \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.","nl-NL":"Er zijn geen gekoppelde producten.","nl":"Er zijn geen gekoppelde producten.","no-NO":"Det er ingen tilknyttede produkter.","pl-PL":"Brak powi\u0105zanych produkt\xf3w","pl":"Brak powi\u0105zanych produkt\xf3w","pt-BR":"N\xe3o h\xe1 produtos associados.","pt-PT":"N\xe3o existem produtos associados.","ru-RU":"\u041D\u0435\u0442 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0442\u043E\u0432\u0430\u0440\u043E\u0432.","ru":"\u041D\u0435\u0442 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0445 \u0442\u043E\u0432\u0430\u0440\u043E\u0432.","sv-SE":"Det finns inga associerade produkter.","sv":"Det finns inga associerade produkter.","th-TH":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07","th":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07","tr-TR":"\u0130lgili bir \xfcr\xfcn bulunmuyor.","tr":"\u0130lgili bir \xfcr\xfcn bulunmuyor."},"RL_Off":{"key":"RL_Off","en":"off","ca-ES":"de descompte","ca":"de descompte","cs-CZ":"vyp.","cs":"vyp.","da-DK":"rabat","da":"rabat","de-DE":"Rabatt","de":"Rabatt","el-GR":"\u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7","el":"\u03AD\u03BA\u03C0\u03C4\u03C9\u03C3\u03B7","en-GB":"off","es-ES":"de descuento","es":"de descuento","fi-FI":"alennusta","fr-FR":"de r\xe9duction","fr":"de r\xe9duction","he-IL":"\u05D4\u05E0\u05D7\u05D4","hr-HR":"popust","hu-HU":"kedvezm\xe9ny","hu":"kedvezm\xe9ny","it-IT":"di sconto","it":"di sconto","ja-JP":"\u30AA\u30D5","ja":"\u30AA\u30D5","ko-KR":"\uD560\uC778","ko":"\uD560\uC778","nl-NL":"korting","nl":"korting","no-NO":"rabatt","pl-PL":"wy\u0142.","pl":"wy\u0142.","pt-BR":"desligado","pt-PT":"de desconto","ru-RU":"\u0441\u043A\u0438\u0434\u043A\u0430","ru":"\u0441\u043A\u0438\u0434\u043A\u0430","sv-SE":"rabatt","sv":"rabatt","th-TH":"\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14","th":"\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E14","tr-TR":"indirim","tr":"indirim"},"RL_OffCode":{"key":"RL_OffCode","en":"{{1}}% off for {{2}} code","ca-ES":"{{1}}\xa0% de descompte en {{2}} codi","ca":"{{1}}\xa0% de descompte en {{2}} codi","cs-CZ":"{{1}}% sleva za {{2}}\xa0k\xf3d","cs":"{{1}}% sleva za {{2}}\xa0k\xf3d","da-DK":"{{1}}% rabat for {{2}} kode","da":"{{1}}% rabat for {{2}} kode","de-DE":"{{1}} % Rabatt f\xfcr {{2}} Codes","de":"{{1}} % Rabatt f\xfcr {{2}} Codes","el-GR":"-{{1}}% \u03B3\u03B9\u03B1 {{2}} \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC","el":"-{{1}}% \u03B3\u03B9\u03B1 {{2}} \u03BA\u03C9\u03B4\u03B9\u03BA\u03CC","en-GB":"{{1}}% off for {{2}} code","es-ES":"{{1}}% de descuento para {{2}} c\xf3digo","es":"{{1}}% de descuento para {{2}} c\xf3digo","fi-FI":"{{1}} % alennusta {{2}} koodilla","fr-FR":"{{1}}\xa0% de r\xe9duction pour {{2}}\xa0code","fr":"{{1}}\xa0% de r\xe9duction pour {{2}}\xa0code","he-IL":"{{1}}% \u05D4\u05E0\u05D7\u05D4 \u05E2\u05D1\u05D5\u05E8 \u05E7\u05D5\u05D3 \u05D0\u05D7\u05D3 ({{2}})","hr-HR":"{{1}}% popusta za {{2}} \u0161ifru","hu-HU":"{{1}}% kedvezm\xe9ny {{2}} k\xf3dhoz","hu":"{{1}}% kedvezm\xe9ny {{2}} k\xf3dhoz","it-IT":"{{1}}% di sconto per {{2}} codice","it":"{{1}}% di sconto per {{2}} codice","ja-JP":"{{1}}\uFF05\u30AA\u30D5\u306E\u30B3\u30FC\u30C9{{2}}\u4EF6","ja":"{{1}}\uFF05\u30AA\u30D5\u306E\u30B3\u30FC\u30C9{{2}}\u4EF6","ko-KR":"{{2}}\uAC1C \uCF54\uB4DC\uC5D0 \uB300\uD574 {{1}}% \uD560\uC778","ko":"{{2}}\uAC1C \uCF54\uB4DC\uC5D0 \uB300\uD574 {{1}}% \uD560\uC778","nl-NL":"{{1}}% korting voor {{2}} code","nl":"{{1}}% korting voor {{2}} code","no-NO":"{{1}}\xa0% rabatt for {{2}} kode","pl-PL":"{{1}}% zni\u017Cki za kod: {{2}}","pl":"{{1}}% zni\u017Cki za kod: {{2}}","pt-BR":"{{1}}% de desc. para {{2}} c\xf3digo","pt-PT":"{{1}}% de desconto para {{2}} c\xf3digo","ru-RU":"\u0421\u043A\u0438\u0434\u043A\u0430 {{1}}% \u043D\u0430 \u043A\u043E\u0434 {{2}}","ru":"\u0421\u043A\u0438\u0434\u043A\u0430 {{1}}% \u043D\u0430 \u043A\u043E\u0434 {{2}}","sv-SE":"{{1}}% rabatt med {{2}} kod","sv":"{{1}}% rabatt med {{2}} kod","th-TH":"\u0E25\u0E14 {{1}}% \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A {{2}} \u0E23\u0E2B\u0E31\u0E2A","th":"\u0E25\u0E14 {{1}}% \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A {{2}} \u0E23\u0E2B\u0E31\u0E2A","tr-TR":"{{2}} kod i\xe7in %{{1}} indirim","tr":"{{2}} kod i\xe7in %{{1}} indirim"},"RL_OffCodes":{"key":"RL_OffCodes","en":"{{1}}% off for {{2}} codes","ca-ES":"{{1}}\xa0% de descompte en {{2}} codis","ca":"{{1}}\xa0% de descompte en {{2}} codis","cs-CZ":"{{1}}% sleva za {{2}}\xa0k\xf3dy","cs":"{{1}}% sleva za {{2}}\xa0k\xf3dy","da-DK":"{{1}}% rabat for {{2}} koder","da":"{{1}}% rabat for {{2}} koder","de-DE":"{{1}} % Rabatt f\xfcr {{2}} Codes","de":"{{1}} % Rabatt f\xfcr {{2}} Codes","el-GR":"-{{1}}% \u03B3\u03B9\u03B1 {{2}} \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2","el":"-{{1}}% \u03B3\u03B9\u03B1 {{2}} \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03CD\u03C2","en-GB":"{{1}}% off for {{2}} codes","es-ES":"{{1}}% de descuento para {{2}} c\xf3digos","es":"{{1}}% de descuento para {{2}} c\xf3digos","fi-FI":"{{1}} % alennusta {{2}} koodilla","fr-FR":"{{1}}\xa0% de r\xe9duction pour {{2}}\xa0codes","fr":"{{1}}\xa0% de r\xe9duction pour {{2}}\xa0codes","he-IL":"{{1}}% \u05D4\u05E0\u05D7\u05D4 \u05E2\u05D1\u05D5\u05E8 {{2}} \u05E7\u05D5\u05D3\u05D9\u05DD","hr-HR":"{{1}}% popusta za \u0161ifre (njih {{2}})","hu-HU":"{{1}}% kedvezm\xe9ny {{2}} k\xf3dhoz","hu":"{{1}}% kedvezm\xe9ny {{2}} k\xf3dhoz","it-IT":"{{1}}% di sconto per {{2}} codici","it":"{{1}}% di sconto per {{2}} codici","ja-JP":"{{1}}\uFF05\u30AA\u30D5\u306E\u30B3\u30FC\u30C9{{2}}\u4EF6","ja":"{{1}}\uFF05\u30AA\u30D5\u306E\u30B3\u30FC\u30C9{{2}}\u4EF6","ko-KR":"{{2}}\uAC1C \uCF54\uB4DC\uC5D0 \uB300\uD574 {{1}}% \uD560\uC778","ko":"{{2}}\uAC1C \uCF54\uB4DC\uC5D0 \uB300\uD574 {{1}}% \uD560\uC778","nl-NL":"{{1}}% korting voor {{2}} codes","nl":"{{1}}% korting voor {{2}} codes","no-NO":"{{1}}\xa0% rabatt for {{2}} koder","pl-PL":"{{1}}% zni\u017Cki za kody: {{2}}","pl":"{{1}}% zni\u017Cki za kody: {{2}}","pt-BR":"{{1}}% de desc. para {{2}} c\xf3digos","pt-PT":"{{1}}% de desconto para {{2}} c\xf3digos","ru-RU":"\u0421\u043A\u0438\u0434\u043A\u0430 {{1}}% \u043D\u0430 \u043A\u043E\u0434\u044B {{2}}","ru":"\u0421\u043A\u0438\u0434\u043A\u0430 {{1}}% \u043D\u0430 \u043A\u043E\u0434\u044B {{2}}","sv-SE":"{{1}}% rabatt med {{2}} koder","sv":"{{1}}% rabatt med {{2}} koder","th-TH":"\u0E25\u0E14 {{1}}% \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A {{2}} \u0E23\u0E2B\u0E31\u0E2A","th":"\u0E25\u0E14 {{1}}% \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A {{2}} \u0E23\u0E2B\u0E31\u0E2A","tr-TR":"{{2}} kod i\xe7in %{{1}} indirim","tr":"{{2}} kod i\xe7in %{{1}} indirim"},"RL_PausedPromotion":{"key":"RL_PausedPromotion","en":"Paused Promotion","ca-ES":"Promoci\xf3 pausada","ca":"Promoci\xf3 pausada","cs-CZ":"Promoakce pozastaven\xe1","cs":"Promoakce pozastaven\xe1","da-DK":"Kampagnen er sat p\xe5 pause","da":"Kampagnen er sat p\xe5 pause","de-DE":"Angebot ausgesetzt","de":"Angebot ausgesetzt","el-GR":"\u0394\u03B9\u03B1\u03BA\u03BF\u03C0\u03AE \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","el":"\u0394\u03B9\u03B1\u03BA\u03BF\u03C0\u03AE \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en-GB":"Paused Promotion","es-ES":"Promoci\xf3n pausada","es":"Promoci\xf3n pausada","fi-FI":"Keskeytetty tarjouskampanja","fr-FR":"Promotion en pause","fr":"Promotion en pause","he-IL":"\u05D4\u05DE\u05D1\u05E6\u05E2 \u05D4\u05D5\u05E9\u05D4\u05D4","hr-HR":"Pauzirana promocija","hu-HU":"Sz\xfcneteltetett prom\xf3ci\xf3","hu":"Sz\xfcneteltetett prom\xf3ci\xf3","it-IT":"Promozione sospesa","it":"Promozione sospesa","ja-JP":"\u4E00\u6642\u505C\u6B62\u3057\u305F\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3","ja":"\u4E00\u6642\u505C\u6B62\u3057\u305F\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3","ko-KR":"\uC77C\uC2DC \uC911\uC9C0\uB41C \uD504\uB85C\uBAA8\uC158","ko":"\uC77C\uC2DC \uC911\uC9C0\uB41C \uD504\uB85C\uBAA8\uC158","nl-NL":"Promotie gepauzeerd","nl":"Promotie gepauzeerd","no-NO":"Kampanje satt p\xe5 pause","pl-PL":"Wstrzymana promocja","pl":"Wstrzymana promocja","pt-BR":"Promo\xe7\xe3o em pausa","pt-PT":"Promo\xe7\xe3o em pausa","ru-RU":"\u041F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u0430\u043A\u0446\u0438\u044F","ru":"\u041F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u0430\u044F \u0430\u043A\u0446\u0438\u044F","sv-SE":"Kampanj har pausats","sv":"Kampanj har pausats","th-TH":"\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01\u0E44\u0E27\u0E49","th":"\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E17\u0E35\u0E48\u0E1E\u0E31\u0E01\u0E44\u0E27\u0E49","tr-TR":"Promosyon Duraklat\u0131ld\u0131","tr":"Promosyon Duraklat\u0131ld\u0131"},"RL_PendingSync":{"key":"RL_PendingSync","en":"Pending Sync","ca-ES":"Sincronitzaci\xf3 pendent","ca":"Sincronitzaci\xf3 pendent","cs-CZ":"\u010Cek\xe1 se na synchronizaci","cs":"\u010Cek\xe1 se na synchronizaci","da-DK":"Afventer synkronisering","da":"Afventer synkronisering","de-DE":"Synchronisierung steht aus","de":"Synchronisierung steht aus","el-GR":"\u03A3\u03C5\u03B3\u03C7\u03C1\u03BF\u03BD\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C3\u03B5 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1","el":"\u03A3\u03C5\u03B3\u03C7\u03C1\u03BF\u03BD\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C3\u03B5 \u03B5\u03BA\u03BA\u03C1\u03B5\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1","en-GB":"Pending Sync","es-ES":"Sincronizaci\xf3n pendiente","es":"Sincronizaci\xf3n pendiente","fi-FI":"Odottaa synkronointia","fr-FR":"Synchronisation en cours","fr":"Synchronisation en cours","he-IL":"\u05D1\u05D4\u05DE\u05EA\u05E0\u05D4 \u05DC\u05E1\u05E0\u05DB\u05E8\u05D5\u05DF","hr-HR":"Sinkronizacija na \u010Dekanju","hu-HU":"Szinkroniz\xe1l\xe1s f\xfcgg\u0151ben","hu":"Szinkroniz\xe1l\xe1s f\xfcgg\u0151ben","it-IT":"Sincronizzazione in sospeso","it":"Sincronizzazione in sospeso","ja-JP":"\u540C\u671F\u306E\u4FDD\u7559\u4E2D","ja":"\u540C\u671F\u306E\u4FDD\u7559\u4E2D","ko-KR":"\uB3D9\uAE30\uD654 \uB300\uAE30 \uC911","ko":"\uB3D9\uAE30\uD654 \uB300\uAE30 \uC911","nl-NL":"In afwachting van synchronisatie","nl":"In afwachting van synchronisatie","no-NO":"Synkronisering venter","pl-PL":"Synchronizacja w toku","pl":"Synchronizacja w toku","pt-BR":"Sincroniza\xe7\xe3o pendente","pt-PT":"Sincroniza\xe7\xe3o pendente","ru-RU":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u0438","ru":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0438\u0437\u0430\u0446\u0438\u0438","sv-SE":"V\xe4ntar p\xe5 synk","sv":"V\xe4ntar p\xe5 synk","th-TH":"\u0E01\u0E32\u0E23\u0E0B\u0E34\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23","th":"\u0E01\u0E32\u0E23\u0E0B\u0E34\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23","tr-TR":"Senkronizasyon Beklemede","tr":"Senkronizasyon Beklemede"},"RL_PriceValidation":{"key":"RL_PriceValidation","en":"Price must be entered in the form XX.XX\'","ca-ES":"El preu s\'ha d\'introduir en el format XX.XX\'","ca":"El preu s\'ha d\'introduir en el format XX.XX\'","cs-CZ":"Cenu mus\xedte zadat ve form\xe1tu XX.XX\'","cs":"Cenu mus\xedte zadat ve form\xe1tu XX.XX\'","da-DK":"Prisen skal indtastes i formen XX,XX","da":"Prisen skal indtastes i formen XX,XX","de-DE":"Der Preis muss folgenderma\xdfen eingegeben werden: XX,XX","de":"Der Preis muss folgenderma\xdfen eingegeben werden: XX,XX","el-GR":"\u0397 \u03C4\u03B9\u03BC\u03AE \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B5\u03BE\u03AE\u03C2 \u03BC\u03BF\u03C1\u03C6\u03AE: XX.XX\'","el":"\u0397 \u03C4\u03B9\u03BC\u03AE \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03AD\u03C7\u03B5\u03B9 \u03C4\u03B7\u03BD \u03B5\u03BE\u03AE\u03C2 \u03BC\u03BF\u03C1\u03C6\u03AE: XX.XX\'","en-GB":"Price must be entered in the form \\"XX.XX\\"","es-ES":"El precio debe introducirse en el formato XX,XX","es":"El precio debe introducirse en el formato XX,XX","fi-FI":"Hinta on asetettava seuraavassa muodossa: XX,XX","fr-FR":"Le prix doit \xeatre saisi au format \xab\xa0XX,XX\xa0\xbb","fr":"Le prix doit \xeatre saisi au format \xab\xa0XX,XX\xa0\xbb","he-IL":"\u05D9\u05E9 \u05DC\u05D4\u05D6\u05D9\u05DF \u05D0\u05EA \u05D4\u05DE\u05D7\u05D9\u05E8 \u05D1\u05EA\u05D1\u05E0\u05D9\u05EA XX.XX","hr-HR":"Cijena se unosi u obliku XX.XX\'","hu-HU":"Az \xe1rat XX.XX form\xe1tumban kell megadni.","hu":"Az \xe1rat XX.XX form\xe1tumban kell megadni.","it-IT":"Il prezzo deve essere inserito nel formato XX,XX","it":"Il prezzo deve essere inserito nel formato XX,XX","ja-JP":"\u4FA1\u683C\u306FXX.XX\'\u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","ja":"\u4FA1\u683C\u306FXX.XX\'\u306E\u5F62\u5F0F\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044","ko-KR":"\uAC00\uACA9\uC740 \uBC18\uB4DC\uC2DC XX.XX \uD615\uD0DC\uB85C \uC785\uB825\uD574\uC57C \uD569\uB2C8\uB2E4.","ko":"\uAC00\uACA9\uC740 \uBC18\uB4DC\uC2DC XX.XX \uD615\uD0DC\uB85C \uC785\uB825\uD574\uC57C \uD569\uB2C8\uB2E4.","nl-NL":"De prijs moet de indeling XX.XX hebben","nl":"De prijs moet de indeling XX.XX hebben","no-NO":"Pris m\xe5 legges inn i formen XX.XX\'","pl-PL":"Cen\u0119 nale\u017Cy wprowadzi\u0107 w formacie XX.XX","pl":"Cen\u0119 nale\u017Cy wprowadzi\u0107 w formacie XX.XX","pt-BR":"O pre\xe7o deve ser inserido no formato XX.XX\'","pt-PT":"O pre\xe7o dever ser introduzido no formato XX,XX\'","ru-RU":"\u0426\u0435\u043D\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0432\u0432\u0435\u0434\u0435\u043D\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 XX,XX\'","ru":"\u0426\u0435\u043D\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0432\u0432\u0435\u0434\u0435\u043D\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 XX,XX\'","sv-SE":"Pris m\xe5ste anges i formatet XX.XX","sv":"Pris m\xe5ste anges i formatet XX.XX","th-TH":"\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E32\u0E04\u0E32\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21 XX.XX\'","th":"\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E49\u0E2D\u0E19\u0E23\u0E32\u0E04\u0E32\u0E43\u0E19\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21 XX.XX\'","tr-TR":"Fiyat XX,XX \u015Feklinde girilmelidir","tr":"Fiyat XX,XX \u015Feklinde girilmelidir"},"RL_ProductDeleteConfirm1":{"key":"RL_ProductDeleteConfirm1","en":"Do you want to remove all products with less than or equal to {{1}} units from all promotions in the store?","ca-ES":"Vols eliminar tots els productes amb {{1}} o menys unitats de totes les promocions de la botiga?","ca":"Vols eliminar tots els productes amb {{1}} o menys unitats de totes les promocions de la botiga?","cs-CZ":"Chcete odstranit v\u0161echny produkty v\xa0po\u010Dtu {{1}}\xa0jednotek nebo men\u0161\xedm ze v\u0161ech promoakc\xed na prodejn\u011B?","cs":"Chcete odstranit v\u0161echny produkty v\xa0po\u010Dtu {{1}}\xa0jednotek nebo men\u0161\xedm ze v\u0161ech promoakc\xed na prodejn\u011B?","da-DK":"Vil du fjerne alle produkter med mindre end eller pr\xe6cis {{1}} enheder fra alle kampagner i butikken?","da":"Vil du fjerne alle produkter med mindre end eller pr\xe6cis {{1}} enheder fra alle kampagner i butikken?","de-DE":"M\xf6chtest du alle Produkte, deren Bestand {{1}} Einheiten nicht \xfcbersteigt, aus allen Angeboten des Stores entfernen?","de":"M\xf6chtest du alle Produkte, deren Bestand {{1}} Einheiten nicht \xfcbersteigt, aus allen Angeboten des Stores entfernen?","el-GR":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B1 \u03BF\u03C0\u03BF\u03AF\u03B1 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03AD\u03C9\u03C2 {1}} \u03BC\u03BF\u03BD\u03AC\u03B4\u03B5\u03C2 \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1;","el":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B1 \u03BF\u03C0\u03BF\u03AF\u03B1 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03AD\u03C9\u03C2 {1}} \u03BC\u03BF\u03BD\u03AC\u03B4\u03B5\u03C2 \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1;","en-GB":"Do you want to remove all products with less than or equal to {{1}} units from all promotions in the store?","es-ES":"\xbfQuieres eliminar todos los productos con {{1}} unidades o menos de todas las promociones de la tienda?","es":"\xbfQuieres eliminar todos los productos con {{1}} unidades o menos de todas las promociones de la tienda?","fi-FI":"Haluatko poistaa kaikista tarjouskampanjoista kaikki tuotteet, joita on {{1}} tai v\xe4hemm\xe4n?","fr-FR":"Souhaitez-vous supprimer tous les produits comptant {{1}}\xa0unit\xe9s ou moins de toutes les promotions du magasin\xa0?","fr":"Souhaitez-vous supprimer tous les produits comptant {{1}}\xa0unit\xe9s ou moins de toutes les promotions du magasin\xa0?","he-IL":"\u05D4\u05D0\u05DD \u05D1\u05E8\u05E6\u05D5\u05E0\u05DB\u05DD \u05DC\u05D4\u05E1\u05D9\u05E8 \u05D0\u05EA \u05DB\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05E9\u05D9\u05E9 \u05DE\u05D4\u05DD {{1}} \u05D9\u05D7\u05D9\u05D3\u05D5\u05EA \u05D0\u05D5 \u05E4\u05D7\u05D5\u05EA \u05DE\u05DB\u05DC \u05D4\u05DE\u05D1\u05E6\u05E2\u05D9\u05DD \u05D1\u05D7\u05E0\u05D5\u05EA?","hr-HR":"\u017Delite li ukloniti sve proizvode s {{1}} ili manje jedinica sa svih promocija na prodajnom mjestu?","hu-HU":"Kiz\xe1rod a(z) {{1}} vagy kevesebb egys\xe9gb\u0151l \xe1ll\xf3 term\xe9keket az \xfczlet \xf6sszes prom\xf3ci\xf3j\xe1b\xf3l?","hu":"Kiz\xe1rod a(z) {{1}} vagy kevesebb egys\xe9gb\u0151l \xe1ll\xf3 term\xe9keket az \xfczlet \xf6sszes prom\xf3ci\xf3j\xe1b\xf3l?","it-IT":"Vuoi rimuovere tutti i prodotti con un massimo di {{1}} unit\xe0 da tutte le promozioni dello store?","it":"Vuoi rimuovere tutti i prodotti con un massimo di {{1}} unit\xe0 da tutte le promozioni dello store?","ja-JP":"{{1}}\u500B\u4EE5\u4E0B\u306E\u5168\u5546\u54C1\u3092\u5E97\u8217\u5185\u306E\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ja":"{{1}}\u500B\u4EE5\u4E0B\u306E\u5168\u5546\u54C1\u3092\u5E97\u8217\u5185\u306E\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ko-KR":"\uB9E4\uC7A5\uC758 \uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C {{1}}\uAC1C \uC720\uB2DB \uC774\uD558\uC758 \uC81C\uD488\uC744 \uC804\uBD80 \uC81C\uAC70\uD558\uC2DC\uACA0\uC5B4\uC694?","ko":"\uB9E4\uC7A5\uC758 \uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C {{1}}\uAC1C \uC720\uB2DB \uC774\uD558\uC758 \uC81C\uD488\uC744 \uC804\uBD80 \uC81C\uAC70\uD558\uC2DC\uACA0\uC5B4\uC694?","nl-NL":"Wil je alle producten met {{1}} of minder eenheden verwijderen uit alle promoties in de store?","nl":"Wil je alle producten met {{1}} of minder eenheden verwijderen uit alle promoties in de store?","no-NO":"Vil du fjerne alle produkter med mindre enn eller lik {{1}} enheter fra alle kampanjer i butikken?","pl-PL":"Czy chcesz usun\u0105\u0107 wszystkie produkty, kt\xf3re s\u0105 dost\u0119pne w liczbie {{1}} sztuk lub mniej, ze wszystkich promocji w sklepie?","pl":"Czy chcesz usun\u0105\u0107 wszystkie produkty, kt\xf3re s\u0105 dost\u0119pne w liczbie {{1}} sztuk lub mniej, ze wszystkich promocji w sklepie?","pt-BR":"Deseja remover todos os produtos com {{1}} unidades ou menos de todas as promo\xe7\xf5es da loja?","pt-PT":"Pretende remover todos os produtos com {{1}} ou menos unidades de todas as promo\xe7\xf5es na loja?","ru-RU":"\u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0441 {{1}} \u0438\u043B\u0438 \u043C\u0435\u043D\u0435\u0435 \u0435\u0434\u0438\u043D\u0438\u0446\u0430\u043C\u0438 \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435?","ru":"\u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0441 {{1}} \u0438\u043B\u0438 \u043C\u0435\u043D\u0435\u0435 \u0435\u0434\u0438\u043D\u0438\u0446\u0430\u043C\u0438 \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435?","sv-SE":"Vill du ta bort alla produkter med {{1}} eller f\xe4rre enheter fr\xe5n alla kampanjer i butiken?","sv":"Vill du ta bort alla produkter med {{1}} eller f\xe4rre enheter fr\xe5n alla kampanjer i butiken?","th-TH":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E21\u0E35\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A {{1}} \u0E0A\u0E34\u0E49\u0E19\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E43\u0E19 Store \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","th":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E21\u0E35\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A {{1}} \u0E0A\u0E34\u0E49\u0E19\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E43\u0E19 Store \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","tr-TR":"{{1}} birim veya daha az olan t\xfcm \xfcr\xfcnleri ma\u011Fazadaki t\xfcm promosyonlardan kald\u0131rmak istiyor musun?","tr":"{{1}} birim veya daha az olan t\xfcm \xfcr\xfcnleri ma\u011Fazadaki t\xfcm promosyonlardan kald\u0131rmak istiyor musun?"},"RL_ProductDeleteConfirm2":{"key":"RL_ProductDeleteConfirm2","en":"Do you want to remove all products with greater than or equal to {{1}} units from all promotions in the store?","ca-ES":"Vols eliminar tots els productes amb {{1}} o m\xe9s unitats de totes les promocions de la botiga?","ca":"Vols eliminar tots els productes amb {{1}} o m\xe9s unitats de totes les promocions de la botiga?","cs-CZ":"Chcete odstranit v\u0161echny produkty v\xa0po\u010Dtu {{1}}\xa0jednotek nebo vy\u0161\u0161\xedm ze v\u0161ech promoakc\xed na prodejn\u011B?","cs":"Chcete odstranit v\u0161echny produkty v\xa0po\u010Dtu {{1}}\xa0jednotek nebo vy\u0161\u0161\xedm ze v\u0161ech promoakc\xed na prodejn\u011B?","da-DK":"Vil du fjerne alle produkter med mere end eller pr\xe6cis {{1}} enheder fra alle kampagner i butikken?","da":"Vil du fjerne alle produkter med mere end eller pr\xe6cis {{1}} enheder fra alle kampagner i butikken?","de-DE":"M\xf6chtest du alle Produkte, deren Bestand {{1}} Einheiten oder mehr betr\xe4gt, aus allen Angeboten des Stores entfernen?","de":"M\xf6chtest du alle Produkte, deren Bestand {{1}} Einheiten oder mehr betr\xe4gt, aus allen Angeboten des Stores entfernen?","el-GR":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B1 \u03BF\u03C0\u03BF\u03AF\u03B1 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD {{1}} \u03BC\u03BF\u03BD\u03AC\u03B4\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1;","el":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B1 \u03BF\u03C0\u03BF\u03AF\u03B1 \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD {{1}} \u03BC\u03BF\u03BD\u03AC\u03B4\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1;","en-GB":"Do you want to remove all products with greater than or equal to {{1}} units from all promotions in the store?","es-ES":"\xbfQuieres eliminar todos los productos con {{1}} unidades o m\xe1s de todas las promociones de la tienda?","es":"\xbfQuieres eliminar todos los productos con {{1}} unidades o m\xe1s de todas las promociones de la tienda?","fi-FI":"Haluatko poistaa kaikista tarjouskampanjoista kaikki tuotteet, joita on {{1}} tai enemm\xe4n?","fr-FR":"Souhaitez-vous supprimer tous les produits comptant {{1}}\xa0unit\xe9s ou plus de toutes les promotions du magasin\xa0?","fr":"Souhaitez-vous supprimer tous les produits comptant {{1}}\xa0unit\xe9s ou plus de toutes les promotions du magasin\xa0?","he-IL":"\u05D4\u05D0\u05DD \u05D1\u05E8\u05E6\u05D5\u05E0\u05DB\u05DD \u05DC\u05D4\u05E1\u05D9\u05E8 \u05D0\u05EA \u05DB\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05E9\u05D9\u05E9 \u05DE\u05D4\u05DD {{1}} \u05D9\u05D7\u05D9\u05D3\u05D5\u05EA \u05D0\u05D5 \u05D9\u05D5\u05EA\u05E8 \u05DE\u05DB\u05DC \u05D4\u05DE\u05D1\u05E6\u05E2\u05D9\u05DD \u05D1\u05D7\u05E0\u05D5\u05EA?","hr-HR":"\u017Delite li ukloniti sve proizvode s {{1}} ili vi\u0161e jedinica sa svih promocija na prodajnom mjestu?","hu-HU":"Kiz\xe1rod a(z) {{1}} vagy t\xf6bb egys\xe9gb\u0151l \xe1ll\xf3 term\xe9keket az \xfczlet \xf6sszes prom\xf3ci\xf3j\xe1b\xf3l?","hu":"Kiz\xe1rod a(z) {{1}} vagy t\xf6bb egys\xe9gb\u0151l \xe1ll\xf3 term\xe9keket az \xfczlet \xf6sszes prom\xf3ci\xf3j\xe1b\xf3l?","it-IT":"Vuoi rimuovere tutti i prodotti con un minimo di {{1}} unit\xe0 da tutte le promozioni dello store?","it":"Vuoi rimuovere tutti i prodotti con un minimo di {{1}} unit\xe0 da tutte le promozioni dello store?","ja-JP":"{{1}}\u500B\u4EE5\u4E0A\u306E\u5168\u5546\u54C1\u3092\u5E97\u8217\u5185\u306E\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ja":"{{1}}\u500B\u4EE5\u4E0A\u306E\u5168\u5546\u54C1\u3092\u5E97\u8217\u5185\u306E\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ko-KR":"\uB9E4\uC7A5\uC758 \uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C {{1}}\uAC1C \uC720\uB2DB \uC774\uC0C1\uC758 \uC81C\uD488\uC744 \uC804\uBD80 \uC81C\uAC70\uD558\uC2DC\uACA0\uC5B4\uC694?","ko":"\uB9E4\uC7A5\uC758 \uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C {{1}}\uAC1C \uC720\uB2DB \uC774\uC0C1\uC758 \uC81C\uD488\uC744 \uC804\uBD80 \uC81C\uAC70\uD558\uC2DC\uACA0\uC5B4\uC694?","nl-NL":"Wil je alle producten met {{1}} of meer eenheden verwijderen uit alle promoties in de store?","nl":"Wil je alle producten met {{1}} of meer eenheden verwijderen uit alle promoties in de store?","no-NO":"Vil du fjerne alle produkter med flere enn eller lik {{1}} enheter fra alle kampanjer i butikken?","pl-PL":"Czy chcesz usun\u0105\u0107 wszystkie produkty, kt\xf3re s\u0105 dost\u0119pne w liczbie {{1}} sztuk lub wi\u0119cej, ze wszystkich promocji w sklepie?","pl":"Czy chcesz usun\u0105\u0107 wszystkie produkty, kt\xf3re s\u0105 dost\u0119pne w liczbie {{1}} sztuk lub wi\u0119cej, ze wszystkich promocji w sklepie?","pt-BR":"Deseja remover todos os produtos com {{1}} unidades ou mais de todas as promo\xe7\xf5es da loja?","pt-PT":"Pretende remover todos os produtos com {{1}} ou mais unidades de todas as promo\xe7\xf5es na loja?","ru-RU":"\u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0441 {{1}} \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0435\u0434\u0438\u043D\u0438\u0446\u0430\u043C\u0438 \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435?","ru":"\u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u0441\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0441 {{1}} \u0438\u043B\u0438 \u0431\u043E\u043B\u0435\u0435 \u0435\u0434\u0438\u043D\u0438\u0446\u0430\u043C\u0438 \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435?","sv-SE":"Vill du ta bort alla produkter med {{1}} eller fler enheter fr\xe5n alla kampanjer i butiken?","sv":"Vill du ta bort alla produkter med {{1}} eller fler enheter fr\xe5n alla kampanjer i butiken?","th-TH":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E21\u0E35\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A {{1}} \u0E0A\u0E34\u0E49\u0E19\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E43\u0E19 Store \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","th":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E21\u0E35\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E40\u0E17\u0E48\u0E32\u0E01\u0E31\u0E1A {{1}} \u0E0A\u0E34\u0E49\u0E19\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E43\u0E19 Store \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","tr-TR":"{{1}} birim veya daha fazla olan t\xfcm \xfcr\xfcnleri ma\u011Fazadaki t\xfcm promosyonlardan kald\u0131rmak istiyor musun?","tr":"{{1}} birim veya daha fazla olan t\xfcm \xfcr\xfcnleri ma\u011Fazadaki t\xfcm promosyonlardan kald\u0131rmak istiyor musun?"},"RL_ProductDeleteConfirm3":{"key":"RL_ProductDeleteConfirm3","en":"Do you want to remove this product from all promotions in the store?","ca-ES":"Vols eliminar aquest producte de totes les promocions de la botiga?","ca":"Vols eliminar aquest producte de totes les promocions de la botiga?","cs-CZ":"Chcete odstranit tenhle produkt ze v\u0161ech promoakc\xed na prodejn\u011B?","cs":"Chcete odstranit tenhle produkt ze v\u0161ech promoakc\xed na prodejn\u011B?","da-DK":"Vil du fjerne dette produkt fra alle kampagner i butikken?","da":"Vil du fjerne dette produkt fra alle kampagner i butikken?","de-DE":"M\xf6chtest du dieses Produkt aus allen Angeboten im Store entfernen?","de":"M\xf6chtest du dieses Produkt aus allen Angeboten im Store entfernen?","el-GR":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1;","el":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2 \u03C3\u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1;","en-GB":"Do you want to remove this product from all promotions in the store?","es-ES":"\xbfQuieres eliminar este producto de todas las promociones de la tienda?","es":"\xbfQuieres eliminar este producto de todas las promociones de la tienda?","fi-FI":"Haluatko poistaa t\xe4m\xe4n tuotteen kaikista tarjouskampanjoista?","fr-FR":"Souhaitez-vous supprimer ce produit de toutes les promotions du magasin\xa0?","fr":"Souhaitez-vous supprimer ce produit de toutes les promotions du magasin\xa0?","he-IL":"\u05D4\u05D0\u05DD \u05D1\u05E8\u05E6\u05D5\u05E0\u05DB\u05DD \u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05DE\u05D5\u05E6\u05E8 \u05D4\u05D6\u05D4 \u05DE\u05DB\u05DC \u05D4\u05DE\u05D1\u05E6\u05E2\u05D9\u05DD \u05D1\u05D7\u05E0\u05D5\u05EA?","hr-HR":"\u017Delite li ukloniti ovaj proizvod sa svih promocija na prodajnom mjestu?","hu-HU":"Kiz\xe1rod ezt a term\xe9ket az \xfczlet \xf6sszes prom\xf3ci\xf3j\xe1b\xf3l?","hu":"Kiz\xe1rod ezt a term\xe9ket az \xfczlet \xf6sszes prom\xf3ci\xf3j\xe1b\xf3l?","it-IT":"Vuoi rimuovere questo prodotto da tutte le promozioni dello store?","it":"Vuoi rimuovere questo prodotto da tutte le promozioni dello store?","ja-JP":"\u3053\u306E\u5546\u54C1\u3092\u5E97\u8217\u5185\u306E\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ja":"\u3053\u306E\u5546\u54C1\u3092\u5E97\u8217\u5185\u306E\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ko-KR":"\uB9E4\uC7A5\uC758 \uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C \uC774 \uC81C\uD488\uC744 \uC81C\uAC70\uD558\uC2DC\uACA0\uC5B4\uC694?","ko":"\uB9E4\uC7A5\uC758 \uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C \uC774 \uC81C\uD488\uC744 \uC81C\uAC70\uD558\uC2DC\uACA0\uC5B4\uC694?","nl-NL":"Wil je dit product verwijderen van alle promoties in de store?","nl":"Wil je dit product verwijderen van alle promoties in de store?","no-NO":"Vil du fjerne dette produktet fra alle kampanjer i butikken?","pl-PL":"Czy chcesz usun\u0105\u0107 ten produkt ze wszystkich promocji w sklepie?","pl":"Czy chcesz usun\u0105\u0107 ten produkt ze wszystkich promocji w sklepie?","pt-BR":"Deseja remover este produto de todas as promo\xe7\xf5es da loja?","pt-PT":"Pretende remover este produto de todas as promo\xe7\xf5es na loja?","ru-RU":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0442\u043E\u0432\u0430\u0440 \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435?","ru":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0442\u043E\u0432\u0430\u0440 \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439 \u0432 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435?","sv-SE":"Vill du ta bort den h\xe4r produkten fr\xe5n alla kampanjer i butiken?","sv":"Vill du ta bort den h\xe4r produkten fr\xe5n alla kampanjer i butiken?","th-TH":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E43\u0E19 Store \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","th":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E43\u0E19 Store \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","tr-TR":"Bu \xfcr\xfcn\xfc ma\u011Fazadaki t\xfcm promosyonlardan kald\u0131rmak istiyor musun?","tr":"Bu \xfcr\xfcn\xfc ma\u011Fazadaki t\xfcm promosyonlardan kald\u0131rmak istiyor musun?"},"RL_ProductDivision":{"key":"RL_ProductDivision","en":"Product Division","ca-ES":"Categoria del producte","ca":"Categoria del producte","cs-CZ":"Produktov\xe1 sekce","cs":"Produktov\xe1 sekce","da-DK":"Produktdivision","da":"Produktdivision","de-DE":"Product Division","de":"Product Division","el-GR":"\u03A4\u03BC\u03AE\u03BC\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD","el":"\u03A4\u03BC\u03AE\u03BC\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD","en-GB":"Product Division","es-ES":"Categor\xeda del producto","es":"Categor\xeda del producto","fi-FI":"Tuotekategoria","fr-FR":"Division produit","fr":"Division produit","he-IL":"\u05DE\u05D7\u05DC\u05E7\u05EA \u05DE\u05D5\u05E6\u05E8\u05D9\u05DD","hr-HR":"Kategorija proizvoda","hu-HU":"Term\xe9kr\xe9szleg","hu":"Term\xe9kr\xe9szleg","it-IT":"Reparto prodotto","it":"Reparto prodotto","ja-JP":"\u5546\u54C1\u306E\u90E8\u9580","ja":"\u5546\u54C1\u306E\u90E8\u9580","ko-KR":"\uC81C\uD488 \uBD80\uC11C","ko":"\uC81C\uD488 \uBD80\uC11C","nl-NL":"Productdivisie","nl":"Productdivisie","no-NO":"Produktavdeling","pl-PL":"Dzia\u0142 Produkty","pl":"Dzia\u0142 Produkty","pt-BR":"Divis\xe3o do produto","pt-PT":"Divis\xe3o do produto","ru-RU":"\u041E\u0442\u0434\u0435\u043B \u0442\u043E\u0432\u0430\u0440\u0430","ru":"\u041E\u0442\u0434\u0435\u043B \u0442\u043E\u0432\u0430\u0440\u0430","sv-SE":"Produktavdelning","sv":"Produktavdelning","th-TH":"\u0E2B\u0E21\u0E27\u0E14\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","th":"\u0E2B\u0E21\u0E27\u0E14\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","tr-TR":"\xdcr\xfcn B\xf6l\xfcm\xfc","tr":"\xdcr\xfcn B\xf6l\xfcm\xfc"},"RL_ProductNameOrStyleColor":{"key":"RL_ProductNameOrStyleColor","en":"Product Name or Style Color","ca-ES":"Nom del producte o color del model","ca":"Nom del producte o color del model","cs-CZ":"N\xe1zev produktu nebo barva modelu","cs":"N\xe1zev produktu nebo barva modelu","da-DK":"Produktnavn eller modelfarve","da":"Produktnavn eller modelfarve","de-DE":"Produktname oder Style-Farbe","de":"Produktname oder Style-Farbe","el-GR":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 \u03AE \u03C7\u03C1\u03CE\u03BC\u03B1 \u03C3\u03C4\u03B9\u03BB","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 \u03AE \u03C7\u03C1\u03CE\u03BC\u03B1 \u03C3\u03C4\u03B9\u03BB","en-GB":"Product Name or Style Colour","es-ES":"Nombre de producto o color del modelo","es":"Nombre de producto o color del modelo","fi-FI":"Tuotenimi tai v\xe4ri","fr-FR":"Nom du produit ou couleur de mod\xe8le","fr":"Nom du produit ou couleur de mod\xe8le","he-IL":"\u05E9\u05DD \u05D4\u05DE\u05D5\u05E6\u05E8 \u05D0\u05D5 \u05E1\u05D2\u05E0\u05D5\u05DF-\u05E6\u05D1\u05E2","hr-HR":"Naziv proizvoda ili model/boja","hu-HU":"Term\xe9k neve vagy Style Color","hu":"Term\xe9k neve vagy Style Color","it-IT":"Nome del prodotto o colore del modello","it":"Nome del prodotto o colore del modello","ja-JP":"\u5546\u54C1\u540D\u307E\u305F\u306F\u30B9\u30BF\u30A4\u30EB \u30AB\u30E9\u30FC","ja":"\u5546\u54C1\u540D\u307E\u305F\u306F\u30B9\u30BF\u30A4\u30EB \u30AB\u30E9\u30FC","ko-KR":"\uC81C\uD488 \uC774\uB984 \uB610\uB294 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC","ko":"\uC81C\uD488 \uC774\uB984 \uB610\uB294 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC","nl-NL":"Productnaam of stijlkleur","nl":"Productnaam of stijlkleur","no-NO":"Produktnavn eller produktfarge","pl-PL":"Nazwa produktu lub model-kolor","pl":"Nazwa produktu lub model-kolor","pt-BR":"Nome do produto ou Cor do estilo","pt-PT":"Nome do produto ou estilo-cor","ru-RU":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u0432\u0430\u0440\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u0432\u0430\u0440\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430","sv-SE":"Produktnamn eller modellf\xe4rg","sv":"Produktnamn eller modellf\xe4rg","th-TH":"\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","tr-TR":"\xdcr\xfcn Ad\u0131 veya Stil Rengi","tr":"\xdcr\xfcn Ad\u0131 veya Stil Rengi"},"RL_ProductType":{"key":"RL_ProductType","en":"Product Type","ca-ES":"Tipus de producte","ca":"Tipus de producte","cs-CZ":"Typ produktu","cs":"Typ produktu","da-DK":"Produkttype","da":"Produkttype","de-DE":"Produkttyp","de":"Produkttyp","el-GR":"\u03A4\u03CD\u03C0\u03BF\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2","el":"\u03A4\u03CD\u03C0\u03BF\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2","en-GB":"Product Type","es-ES":"Tipo de producto","es":"Tipo de producto","fi-FI":"Tuotetyyppi","fr-FR":"Type de produit","fr":"Type de produit","he-IL":"\u05E1\u05D5\u05D2 \u05DE\u05D5\u05E6\u05E8","hr-HR":"Vrsta proizvoda","hu-HU":"Term\xe9kt\xedpus","hu":"Term\xe9kt\xedpus","it-IT":"Tipo di prodotto","it":"Tipo di prodotto","ja-JP":"\u5546\u54C1\u306E\u7A2E\u985E","ja":"\u5546\u54C1\u306E\u7A2E\u985E","ko-KR":"\uC81C\uD488 \uC720\uD615","ko":"\uC81C\uD488 \uC720\uD615","nl-NL":"Producttype","nl":"Producttype","no-NO":"Produkttype","pl-PL":"Rodzaj produktu","pl":"Rodzaj produktu","pt-BR":"Tipo de produto","pt-PT":"Tipo de produto","ru-RU":"\u0422\u0438\u043F \u0442\u043E\u0432\u0430\u0440\u0430","ru":"\u0422\u0438\u043F \u0442\u043E\u0432\u0430\u0440\u0430","sv-SE":"Produkttyp","sv":"Produkttyp","th-TH":"\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","th":"\u0E1B\u0E23\u0E30\u0E40\u0E20\u0E17\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","tr-TR":"\xdcr\xfcn T\xfcr\xfc","tr":"\xdcr\xfcn T\xfcr\xfc"},"RL_Products":{"key":"RL_Products","en":"Products","ca-ES":"Productes","ca":"Productes","cs-CZ":"Produkty","cs":"Produkty","da-DK":"Produkter","da":"Produkter","de-DE":"Produkte","de":"Produkte","el-GR":"\u03A0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1","el":"\u03A0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1","en-GB":"Products","es-ES":"Productos","es":"Productos","fi-FI":"Tuotteet","fr-FR":"Produits","fr":"Produits","he-IL":"\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD","hr-HR":"Proizvodi","hu-HU":"Term\xe9kek","hu":"Term\xe9kek","it-IT":"Prodotti","it":"Prodotti","ja-JP":"\u5546\u54C1","ja":"\u5546\u54C1","ko-KR":"\uC81C\uD488","ko":"\uC81C\uD488","nl-NL":"Producten","nl":"Producten","no-NO":"Produkter","pl-PL":"Produkty","pl":"Produkty","pt-BR":"Produtos","pt-PT":"Produtos","ru-RU":"\u0422\u043E\u0432\u0430\u0440\u044B","ru":"\u0422\u043E\u0432\u0430\u0440\u044B","sv-SE":"Produkter","sv":"Produkter","th-TH":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","th":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","tr-TR":"\xdcr\xfcnler","tr":"\xdcr\xfcnler"},"RL_ProductsAddSuccess":{"key":"RL_ProductsAddSuccess","en":"All products added! Please click the \'X\' button to close this form.","ca-ES":"undefined","ca":"undefined","cs-CZ":"V\u0161echny produkty p\u0159id\xe1ny! Tenhle formul\xe1\u0159 zav\u0159ete klepnut\xedm na symbol \u201EX\u201C.","cs":"V\u0161echny produkty p\u0159id\xe1ny! Tenhle formul\xe1\u0159 zav\u0159ete klepnut\xedm na symbol \u201EX\u201C.","da-DK":"Alle produkter er tilf\xf8jet. Klik p\xe5 \\"X\\"-knappen for at lukke denne formular.","da":"Alle produkter er tilf\xf8jet. Klik p\xe5 \\"X\\"-knappen for at lukke denne formular.","de-DE":"Alle Produkte wurden hinzugef\xfcgt. Klicke auf die Schaltfl\xe4che \\"X\\", um dieses Formular zu schlie\xdfen.","de":"Alle Produkte wurden hinzugef\xfcgt. Klicke auf die Schaltfl\xe4che \\"X\\", um dieses Formular zu schlie\xdfen.","el-GR":"\u03A0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1! \u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03CC\u03C1\u03BC\u03B1, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \\"X\\".","el":"\u03A0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03CC\u03BB\u03B1 \u03C4\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1! \u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03CC\u03C1\u03BC\u03B1, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \\"X\\".","en-GB":"All products added! Please click the \\"X\\" button to close this form.","es-ES":"Todos los productos se han a\xf1adido Haz clic en el bot\xf3n \\"X\\" para cerrar este formulario.","es":"Todos los productos se han a\xf1adido Haz clic en el bot\xf3n \\"X\\" para cerrar este formulario.","fi-FI":"Kaikki tuotteet lis\xe4tty! Valitse \'X\', kun haluat sulkea lomakkeen.","fr-FR":"Tous les produits ont \xe9t\xe9 ajout\xe9s\xa0! Cliquez sur le bouton \xab\xa0X\xa0\xbb pour fermer ce formulaire.","fr":"Tous les produits ont \xe9t\xe9 ajout\xe9s\xa0! Cliquez sur le bouton \xab\xa0X\xa0\xbb pour fermer ce formulaire.","he-IL":"\u05DB\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05E0\u05D5\u05E1\u05E4\u05D5! \u05DC\u05D7\u05E6\u05D5 \u05E2\u05DC \u05D4\u05DC\u05D7\u05E6\u05DF \'X\' \u05DB\u05D3\u05D9 \u05DC\u05E1\u05D2\u05D5\u05E8 \u05D0\u05EA \u05D4\u05D8\u05D5\u05E4\u05E1.","hr-HR":"Dodani su svi proizvodi! Kliknite na gumb \u201EX\u201D za zatvaranje ovog obrasca.","hu-HU":"\xd6sszes term\xe9k hozz\xe1adva! Az \u0171rlap bez\xe1r\xe1s\xe1hoz kattints az \u201EX\u201D gombra.","hu":"\xd6sszes term\xe9k hozz\xe1adva! Az \u0171rlap bez\xe1r\xe1s\xe1hoz kattints az \u201EX\u201D gombra.","it-IT":"Tutti i prodotti sono stati aggiunti! Clicca sulla \\"X\\" per chiudere questo modulo.","it":"Tutti i prodotti sono stati aggiunti! Clicca sulla \\"X\\" per chiudere questo modulo.","ja-JP":"\u3059\u3079\u3066\u306E\u5546\u54C1\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002 \u300CX\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u9589\u3058\u3066\u304F\u3060\u3055\u3044\u3002","ja":"\u3059\u3079\u3066\u306E\u5546\u54C1\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002 \u300CX\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u9589\u3058\u3066\u304F\u3060\u3055\u3044\u3002","ko-KR":"\uBAA8\uB4E0 \uC81C\uD488\uC774 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4! \uC774 \uC591\uC2DD\uC744 \uB2EB\uC73C\uB824\uBA74 \'X\' \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC138\uC694.","ko":"\uBAA8\uB4E0 \uC81C\uD488\uC774 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4! \uC774 \uC591\uC2DD\uC744 \uB2EB\uC73C\uB824\uBA74 \'X\' \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC138\uC694.","nl-NL":"Alle producten zijn toegevoegd. Klik op de \'X\' om dit formulier te sluiten.","nl":"Alle producten zijn toegevoegd. Klik op de \'X\' om dit formulier te sluiten.","no-NO":"Alle produkter er lagt til. Klikk p\xe5 \xabX\xbb-knappen for \xe5 lukke dette skjemaet.","pl-PL":"Dodano wszystkie produkty! Kliknij przycisk \u201EX\u201D, by zamkn\u0105\u0107 ten formularz.","pl":"Dodano wszystkie produkty! Kliknij przycisk \u201EX\u201D, by zamkn\u0105\u0107 ten formularz.","pt-BR":"Todos os produtos foram adicionados! Clique no bot\xe3o \u201CX\u201D para fechar este formul\xe1rio.","pt-PT":"Todos os produtos foram adicionados! Clique no bot\xe3o \\"X\\" para fechar este formul\xe1rio.","ru-RU":"\u0412\u0441\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u044B! \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 X, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u044D\u0442\u0443 \u0444\u043E\u0440\u043C\u0443.","ru":"\u0412\u0441\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u044B! \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 X, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u044D\u0442\u0443 \u0444\u043E\u0440\u043C\u0443.","sv-SE":"Alla produkter har lagts till. Klicka p\xe5 knappen X f\xf6r att st\xe4nga formul\xe4ret.","sv":"Alla produkter har lagts till. Klicka p\xe5 knappen X f\xf6r att st\xe4nga formul\xe4ret.","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 \\"X\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 \\"X\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49","tr-TR":"T\xfcm \xfcr\xfcnler eklendi! L\xfctfen bu formu kapatmak i\xe7in \\"X\\" d\xfc\u011Fmesine t\u0131kla.","tr":"T\xfcm \xfcr\xfcnler eklendi! L\xfctfen bu formu kapatmak i\xe7in \\"X\\" d\xfc\u011Fmesine t\u0131kla."},"RL_Profile":{"key":"RL_Profile","en":"Profile","ca-ES":"Perfil","ca":"Perfil","cs-CZ":"Profil","cs":"Profil","da-DK":"Profil","da":"Profil","de-DE":"Profil","de":"Profil","el-GR":"\u03A0\u03C1\u03BF\u03C6\u03AF\u03BB","el":"\u03A0\u03C1\u03BF\u03C6\u03AF\u03BB","en-GB":"Profile","es-ES":"Perfil","es":"Perfil","fi-FI":"Profiili","fr-FR":"Profil","fr":"Profil","he-IL":"\u05E4\u05E8\u05D5\u05E4\u05D9\u05DC","hr-HR":"Profil","hu-HU":"Profil","hu":"Profil","it-IT":"Profilo","it":"Profilo","ja-JP":"\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB","ja":"\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB","ko-KR":"\uD504\uB85C\uD544","ko":"\uD504\uB85C\uD544","nl-NL":"Profiel","nl":"Profiel","no-NO":"Profil","pl-PL":"Profil","pl":"Profil","pt-BR":"Perfil","pt-PT":"Perfil","ru-RU":"\u041F\u0440\u043E\u0444\u0438\u043B\u044C","ru":"\u041F\u0440\u043E\u0444\u0438\u043B\u044C","sv-SE":"Profil","sv":"Profil","th-TH":"\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C","th":"\u0E42\u0E1B\u0E23\u0E44\u0E1F\u0E25\u0E4C","tr-TR":"Profil","tr":"Profil"},"RL_PromotionDeleteSuccess1":{"key":"RL_PromotionDeleteSuccess1","en":"Successfully deleted the item from all promotions","ca-ES":"S\'ha eliminat el producte correctament de totes les promocions.","ca":"S\'ha eliminat el producte correctament de totes les promocions.","cs-CZ":"Polo\u017Eka byla \xfasp\u011B\u0161n\u011B smazan\xe1 ze v\u0161ech promoakc\xed","cs":"Polo\u017Eka byla \xfasp\u011B\u0161n\u011B smazan\xe1 ze v\u0161ech promoakc\xed","da-DK":"Varen er fjernet fra alle kampagner","da":"Varen er fjernet fra alle kampagner","de-DE":"Der Artikel wurde erfolgreich aus allen Angeboten gel\xf6scht.","de":"Der Artikel wurde erfolgreich aus allen Angeboten gel\xf6scht.","el-GR":"\u03A4\u03BF \u03B5\u03AF\u03B4\u03BF\u03C2 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2","el":"\u03A4\u03BF \u03B5\u03AF\u03B4\u03BF\u03C2 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2","en-GB":"Item successfully deleted from all promotions","es-ES":"El producto se ha borrado correctamente de todas las promociones","es":"El producto se ha borrado correctamente de todas las promociones","fi-FI":"Tuote on poistettu kaikista tarjouskampanjoista","fr-FR":"Article supprim\xe9 de toutes les promotions","fr":"Article supprim\xe9 de toutes les promotions","he-IL":"\u05D4\u05E4\u05E8\u05D9\u05D8 \u05E0\u05DE\u05D7\u05E7 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4 \u05DE\u05DB\u05DC \u05D4\u05DE\u05D1\u05E6\u05E2\u05D9\u05DD","hr-HR":"Stavka je uspje\u0161no izbrisana iz svih promocija","hu-HU":"A cikket sikeresen t\xf6r\xf6lt\xfck az \xf6sszes prom\xf3ci\xf3b\xf3l","hu":"A cikket sikeresen t\xf6r\xf6lt\xfck az \xf6sszes prom\xf3ci\xf3b\xf3l","it-IT":"L\'articolo \xe8 stato eliminato correttamente da tutte le promozioni","it":"L\'articolo \xe8 stato eliminato correttamente da tutte le promozioni","ja-JP":"\u5546\u54C1\u3092\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3057\u305F","ja":"\u5546\u54C1\u3092\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3057\u305F","ko-KR":"\uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C \uD574\uB2F9 \uC81C\uD488\uC744 \uC0AD\uC81C\uD588\uC2B5\uB2C8\uB2E4.","ko":"\uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C \uD574\uB2F9 \uC81C\uD488\uC744 \uC0AD\uC81C\uD588\uC2B5\uB2C8\uB2E4.","nl-NL":"Het item is verwijderd uit alle promoties","nl":"Het item is verwijderd uit alle promoties","no-NO":"Varen er slettet fra alle kampanjer","pl-PL":"Produkt zosta\u0142 usuni\u0119ty ze wszystkich promocji","pl":"Produkt zosta\u0142 usuni\u0119ty ze wszystkich promocji","pt-BR":"O item foi removido de todas as promo\xe7\xf5es","pt-PT":"O artigo foi eliminado com sucesso de todas as promo\xe7\xf5es","ru-RU":"\u0422\u043E\u0432\u0430\u0440 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439","ru":"\u0422\u043E\u0432\u0430\u0440 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439","sv-SE":"Produkten har tagits bort fr\xe5n alla kampanjer","sv":"Produkten har tagits bort fr\xe5n alla kampanjer","th-TH":"\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27","th":"\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27","tr-TR":"\xdcr\xfcn t\xfcm promosyonlardan ba\u015Far\u0131yla silindi","tr":"\xdcr\xfcn t\xfcm promosyonlardan ba\u015Far\u0131yla silindi"},"RL_PromotionDeleteSuccess2":{"key":"RL_PromotionDeleteSuccess2","en":"Successfully deleted all selected items from all promotions.","ca-ES":"S\'han eliminat els productes correctament de totes les promocions.","ca":"S\'han eliminat els productes correctament de totes les promocions.","cs-CZ":"V\u0161echny vybran\xe9 polo\u017Eky byly \xfasp\u011B\u0161n\u011B smazan\xe9 ze v\u0161ech promoakc\xed","cs":"V\u0161echny vybran\xe9 polo\u017Eky byly \xfasp\u011B\u0161n\u011B smazan\xe9 ze v\u0161ech promoakc\xed","da-DK":"Alle valgte varer er fjernet fra alle kampagner.","da":"Alle valgte varer er fjernet fra alle kampagner.","de-DE":"Die ausgew\xe4hlten Artikel wurden erfolgreich aus allen Angeboten gel\xf6scht.","de":"Die ausgew\xe4hlten Artikel wurden erfolgreich aus allen Angeboten gel\xf6scht.","el-GR":"\u038C\u03BB\u03B1 \u03C4\u03B1 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B1 \u03B5\u03AF\u03B4\u03B7 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B1\u03BD \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2.","el":"\u038C\u03BB\u03B1 \u03C4\u03B1 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B1 \u03B5\u03AF\u03B4\u03B7 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B1\u03BD \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03C0\u03CC \u03CC\u03BB\u03B5\u03C2 \u03C4\u03B9\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2.","en-GB":"All selected items successfully deleted from all promotions.","es-ES":"Todos los productos seleccionados se han borrado correctamente de todas las promociones.","es":"Todos los productos seleccionados se han borrado correctamente de todas las promociones.","fi-FI":"Kaikki valitut tuotteet on poistettu kaikista tarjouskampanjoista.","fr-FR":"Tous les articles s\xe9lectionn\xe9s ont \xe9t\xe9 supprim\xe9s de toutes les promotions.","fr":"Tous les articles s\xe9lectionn\xe9s ont \xe9t\xe9 supprim\xe9s de toutes les promotions.","he-IL":"\u05DB\u05DC \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E9\u05E0\u05D1\u05D7\u05E8\u05D5 \u05E0\u05DE\u05D7\u05E7\u05D5 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4 \u05DE\u05DB\u05DC \u05D4\u05DE\u05D1\u05E6\u05E2\u05D9\u05DD.","hr-HR":"Sve odabrane stavke uspje\u0161no su izbrisane iz svih promocija.","hu-HU":"Az \xf6sszes kiv\xe1lasztott cikket sikeresen t\xf6r\xf6lt\xfck az \xf6sszes prom\xf3ci\xf3b\xf3l","hu":"Az \xf6sszes kiv\xe1lasztott cikket sikeresen t\xf6r\xf6lt\xfck az \xf6sszes prom\xf3ci\xf3b\xf3l","it-IT":"Tutti gli articoli selezionati sono stati eliminati correttamente da tutte le promozioni.","it":"Tutti gli articoli selezionati sono stati eliminati correttamente da tutte le promozioni.","ja-JP":"\u9078\u629E\u3057\u305F\u5168\u5546\u54C1\u3092\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3057\u305F\u3002","ja":"\u9078\u629E\u3057\u305F\u5168\u5546\u54C1\u3092\u3059\u3079\u3066\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3057\u305F\u3002","ko-KR":"\uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C \uC120\uD0DD\uD55C \uC81C\uD488\uC744 \uC804\uBD80 \uC0AD\uC81C\uD588\uC2B5\uB2C8\uB2E4.","ko":"\uBAA8\uB4E0 \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C \uC120\uD0DD\uD55C \uC81C\uD488\uC744 \uC804\uBD80 \uC0AD\uC81C\uD588\uC2B5\uB2C8\uB2E4.","nl-NL":"Alle geselecteerde items zijn verwijderd uit alle promoties.","nl":"Alle geselecteerde items zijn verwijderd uit alle promoties.","no-NO":"Alle valgte varer er slettet fra alle kampanjer","pl-PL":"Wszystkie wybrane produkty zosta\u0142y usuni\u0119te ze wszystkich promocji","pl":"Wszystkie wybrane produkty zosta\u0142y usuni\u0119te ze wszystkich promocji","pt-BR":"Todos os itens selecionados foram removidos de todas as promo\xe7\xf5es.","pt-PT":"Os artigos selecionados foram eliminados com sucesso de todas as promo\xe7\xf5es.","ru-RU":"\u0412\u0441\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439.","ru":"\u0412\u0441\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0438\u0437 \u0432\u0441\u0435\u0445 \u0430\u043A\u0446\u0438\u0439.","sv-SE":"De valda produkterna har tagits bort fr\xe5n alla kampanjer.","sv":"De valda produkterna har tagits bort fr\xe5n alla kampanjer.","th-TH":"\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E27\u0E49\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27","th":"\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E27\u0E49\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E17\u0E38\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27","tr-TR":"Se\xe7ilen t\xfcm \xfcr\xfcnler t\xfcm promosyonlardan ba\u015Far\u0131yla silindi.","tr":"Se\xe7ilen t\xfcm \xfcr\xfcnler t\xfcm promosyonlardan ba\u015Far\u0131yla silindi."},"RL_PromotionID":{"key":"RL_PromotionID","en":"Promotion ID","ca-ES":"ID de la promoci\xf3","ca":"ID de la promoci\xf3","cs-CZ":"ID promoakce","cs":"ID promoakce","da-DK":"Kampagne-ID","da":"Kampagne-ID","de-DE":"Angebots-ID","de":"Angebots-ID","el-GR":"\u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","el":"\u0391\u03BD\u03B1\u03B3\u03BD\u03C9\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en-GB":"Promotion ID","es-ES":"ID de la promoci\xf3n","es":"ID de la promoci\xf3n","fi-FI":"Tarjouskampanjan tunnus","fr-FR":"ID de la promotion","fr":"ID de la promotion","he-IL":"\u05DE\u05D6\u05D4\u05D4 \u05DE\u05D1\u05E6\u05E2","hr-HR":"ID promocije","hu-HU":"Prom\xf3ci\xf3s azonos\xedt\xf3","hu":"Prom\xf3ci\xf3s azonos\xedt\xf3","it-IT":"ID Promozione","it":"ID Promozione","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3ID","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3ID","ko-KR":"\uD504\uB85C\uBAA8\uC158 ID","ko":"\uD504\uB85C\uBAA8\uC158 ID","nl-NL":"Promotie-id","nl":"Promotie-id","no-NO":"Kampanje-ID","pl-PL":"Identyfikator promocji","pl":"Identyfikator promocji","pt-BR":"ID da promo\xe7\xe3o","pt-PT":"Identifica\xe7\xe3o da promo\xe7\xe3o","ru-RU":"ID \u0430\u043A\u0446\u0438\u0438","ru":"ID \u0430\u043A\u0446\u0438\u0438","sv-SE":"Kampanj-id","sv":"Kampanj-id","th-TH":"ID \u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","th":"ID \u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr-TR":"Promosyon kimli\u011Fi","tr":"Promosyon kimli\u011Fi"},"RL_PromotionName":{"key":"RL_PromotionName","en":"Promotion Name","ca-ES":"Nom de la promoci\xf3","ca":"Nom de la promoci\xf3","cs-CZ":"N\xe1zev promoakce","cs":"N\xe1zev promoakce","da-DK":"Kampagnenavn","da":"Kampagnenavn","de-DE":"Angebotsname","de":"Angebotsname","el-GR":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en-GB":"Promotion Name","es-ES":"Nombre de promoci\xf3n","es":"Nombre de promoci\xf3n","fi-FI":"Kampanjan nimi","fr-FR":"Nom de la promotion","fr":"Nom de la promotion","he-IL":"\u05E9\u05DD \u05DE\u05D1\u05E6\u05E2","hr-HR":"Naziv promocije","hu-HU":"Prom\xf3ci\xf3s n\xe9v","hu":"Prom\xf3ci\xf3s n\xe9v","it-IT":"Nome promozione","it":"Nome promozione","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u540D","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u540D","ko-KR":"\uD504\uB85C\uBAA8\uC158 \uC774\uB984","ko":"\uD504\uB85C\uBAA8\uC158 \uC774\uB984","nl-NL":"Naam promotie","nl":"Naam promotie","no-NO":"Kampanjenavn","pl-PL":"Nazwa promocji","pl":"Nazwa promocji","pt-BR":"Nome da promo\xe7\xe3o","pt-PT":"Nome da promo\xe7\xe3o","ru-RU":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438","sv-SE":"Kampanjnamn","sv":"Kampanjnamn","th-TH":"\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr-TR":"Promosyon Ad\u0131","tr":"Promosyon Ad\u0131"},"RL_PromotionNameValidation1":{"key":"RL_PromotionNameValidation1","en":"Promotion Name must be alphanumeric characters only.","ca-ES":"El nom de la promoci\xf3 nom\xe9s pot tenir car\xe0cters alfanum\xe8rics.","ca":"El nom de la promoci\xf3 nom\xe9s pot tenir car\xe0cters alfanum\xe8rics.","cs-CZ":"N\xe1zev promoakce m\u016F\u017Eou tvo\u0159it jenom alfanumerick\xe9 znaky.","cs":"N\xe1zev promoakce m\u016F\u017Eou tvo\u0159it jenom alfanumerick\xe9 znaky.","da-DK":"Kampagnenavnet m\xe5 kun best\xe5 af alfanumeriske tegn.","da":"Kampagnenavnet m\xe5 kun best\xe5 af alfanumeriske tegn.","de-DE":"Der Angebotsname darf nur aus alphanumerischen Zeichen bestehen.","de":"Der Angebotsname darf nur aus alphanumerischen Zeichen bestehen.","el-GR":"\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03BC\u03CC\u03BD\u03BF \u03B1\u03C0\u03CC \u03B1\u03BB\u03C6\u03B1\u03C1\u03B9\u03B8\u03BC\u03B7\u03C4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.","el":"\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03BC\u03CC\u03BD\u03BF \u03B1\u03C0\u03CC \u03B1\u03BB\u03C6\u03B1\u03C1\u03B9\u03B8\u03BC\u03B7\u03C4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.","en-GB":"Promotion name must be alphanumeric characters only.","es-ES":"El nombre de la promoci\xf3n debe contener solo caracteres alfanum\xe9ricos.","es":"El nombre de la promoci\xf3n debe contener solo caracteres alfanum\xe9ricos.","fi-FI":"Tarjouskampanjan nimess\xe4 voi olla ainostaan kirjaimia ja numeroita.","fr-FR":"Le nom de la promotion doit \xeatre compos\xe9 uniquement de caract\xe8res alphanum\xe9riques.","fr":"Le nom de la promotion doit \xeatre compos\xe9 uniquement de caract\xe8res alphanum\xe9riques.","he-IL":"\u05E9\u05DD \u05D4\u05DE\u05D1\u05E6\u05E2 \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC \u05EA\u05D5\u05D5\u05D9\u05DD \u05D0\u05DC\u05E4\u05D0\u05E0\u05D5\u05DE\u05E8\u05D9\u05D9\u05DD \u05D1\u05DC\u05D1\u05D3.","hr-HR":"Naziv promocije smije imati samo alfanumeri\u010Dke znakove.","hu-HU":"A prom\xf3ci\xf3s n\xe9vben csakis alfanumerikus karakterek szerepelhetnek.","hu":"A prom\xf3ci\xf3s n\xe9vben csakis alfanumerikus karakterek szerepelhetnek.","it-IT":"Il nome del prodotto deve contenere solo caratteri alfanumerici.","it":"Il nome del prodotto deve contenere solo caratteri alfanumerici.","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u540D\u306B\u4F7F\u7528\u3067\u304D\u308B\u306E\u306F\u82F1\u6570\u5B57\u306E\u307F\u3067\u3059\u3002","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u540D\u306B\u4F7F\u7528\u3067\u304D\u308B\u306E\u306F\u82F1\u6570\u5B57\u306E\u307F\u3067\u3059\u3002","ko-KR":"\uD504\uB85C\uBAA8\uC158 \uC774\uB984\uC740 \uBC18\uB4DC\uC2DC \uC54C\uD30C\uBCB3\uACFC \uC22B\uC790\uB85C\uB9CC \uC774\uB8E8\uC5B4\uC838\uC57C \uD569\uB2C8\uB2E4.","ko":"\uD504\uB85C\uBAA8\uC158 \uC774\uB984\uC740 \uBC18\uB4DC\uC2DC \uC54C\uD30C\uBCB3\uACFC \uC22B\uC790\uB85C\uB9CC \uC774\uB8E8\uC5B4\uC838\uC57C \uD569\uB2C8\uB2E4.","nl-NL":"De promotienaam mag alleen bestaan uit alfanumerieke tekens.","nl":"De promotienaam mag alleen bestaan uit alfanumerieke tekens.","no-NO":"Kampanjenavn kan bare best\xe5 av alfanumeriske tegn.","pl-PL":"Nazwa promocji mo\u017Ce zawiera\u0107 wy\u0142\u0105cznie znaki alfanumeryczne.","pl":"Nazwa promocji mo\u017Ce zawiera\u0107 wy\u0142\u0105cznie znaki alfanumeryczne.","pt-BR":"O nome da promo\xe7\xe3o deve conter apenas caracteres alfanum\xe9ricos.","pt-PT":"O Nome da promo\xe7\xe3o dever conter apenas carateres alfanum\xe9ricos.","ru-RU":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0431\u0443\u043A\u0432\u044B \u0438 \u0446\u0438\u0444\u0440\u044B.","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0431\u0443\u043A\u0432\u044B \u0438 \u0446\u0438\u0444\u0440\u044B.","sv-SE":"Kampanjnamnet f\xe5r endast inneh\xe5lla alfanumeriska tecken.","sv":"Kampanjnamnet f\xe5r endast inneh\xe5lla alfanumeriska tecken.","th-TH":"\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","tr-TR":"Promosyon Ad\u0131 yaln\u0131zca alfabetik karakterler i\xe7ermelidir.","tr":"Promosyon Ad\u0131 yaln\u0131zca alfabetik karakterler i\xe7ermelidir."},"RL_PromotionNameValidation2":{"key":"RL_PromotionNameValidation2","en":"Promotion Name must be alphanumeric characters only.","ca-ES":"El nom de la promoci\xf3 nom\xe9s pot tenir car\xe0cters alfanum\xe8rics.","ca":"El nom de la promoci\xf3 nom\xe9s pot tenir car\xe0cters alfanum\xe8rics.","cs-CZ":"N\xe1zev promoakce m\u016F\u017Eou tvo\u0159it jenom alfanumerick\xe9 znaky.","cs":"N\xe1zev promoakce m\u016F\u017Eou tvo\u0159it jenom alfanumerick\xe9 znaky.","da-DK":"Kampagnenavnet m\xe5 kun best\xe5 af alfanumeriske tegn.","da":"Kampagnenavnet m\xe5 kun best\xe5 af alfanumeriske tegn.","de-DE":"Der Angebotsname darf nur aus alphanumerischen Zeichen bestehen.","de":"Der Angebotsname darf nur aus alphanumerischen Zeichen bestehen.","el-GR":"\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03BC\u03CC\u03BD\u03BF \u03B1\u03C0\u03CC \u03B1\u03BB\u03C6\u03B1\u03C1\u03B9\u03B8\u03BC\u03B7\u03C4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.","el":"\u03A4\u03BF \u03CC\u03BD\u03BF\u03BC\u03B1 \u03C4\u03B7\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03BC\u03CC\u03BD\u03BF \u03B1\u03C0\u03CC \u03B1\u03BB\u03C6\u03B1\u03C1\u03B9\u03B8\u03BC\u03B7\u03C4\u03B9\u03BA\u03BF\u03CD\u03C2 \u03C7\u03B1\u03C1\u03B1\u03BA\u03C4\u03AE\u03C1\u03B5\u03C2.","en-GB":"Promotion name must be alphanumeric characters only.","es-ES":"El nombre de la promoci\xf3n debe contener solo caracteres alfanum\xe9ricos.","es":"El nombre de la promoci\xf3n debe contener solo caracteres alfanum\xe9ricos.","fi-FI":"Tarjouskampanjan nimess\xe4 voi olla ainostaan kirjaimia ja numeroita.","fr-FR":"Le nom de la promotion doit \xeatre compos\xe9 uniquement de caract\xe8res alphanum\xe9riques.","fr":"Le nom de la promotion doit \xeatre compos\xe9 uniquement de caract\xe8res alphanum\xe9riques.","he-IL":"\u05E9\u05DD \u05D4\u05DE\u05D1\u05E6\u05E2 \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC \u05EA\u05D5\u05D5\u05D9\u05DD \u05D0\u05DC\u05E4\u05D0\u05E0\u05D5\u05DE\u05E8\u05D9\u05D9\u05DD \u05D1\u05DC\u05D1\u05D3.","hr-HR":"Naziv promocije smije imati samo alfanumeri\u010Dke znakove.","hu-HU":"A prom\xf3ci\xf3s n\xe9vben csakis alfanumerikus karakterek szerepelhetnek.","hu":"A prom\xf3ci\xf3s n\xe9vben csakis alfanumerikus karakterek szerepelhetnek.","it-IT":"Il nome del prodotto deve contenere solo caratteri alfanumerici.","it":"Il nome del prodotto deve contenere solo caratteri alfanumerici.","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u540D\u306B\u4F7F\u7528\u3067\u304D\u308B\u306E\u306F\u82F1\u6570\u5B57\u306E\u307F\u3067\u3059\u3002","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u540D\u306B\u4F7F\u7528\u3067\u304D\u308B\u306E\u306F\u82F1\u6570\u5B57\u306E\u307F\u3067\u3059\u3002","ko-KR":"\uD504\uB85C\uBAA8\uC158 \uC774\uB984\uC740 \uBC18\uB4DC\uC2DC \uC54C\uD30C\uBCB3\uACFC \uC22B\uC790\uB85C\uB9CC \uC774\uB8E8\uC5B4\uC838\uC57C \uD569\uB2C8\uB2E4.","ko":"\uD504\uB85C\uBAA8\uC158 \uC774\uB984\uC740 \uBC18\uB4DC\uC2DC \uC54C\uD30C\uBCB3\uACFC \uC22B\uC790\uB85C\uB9CC \uC774\uB8E8\uC5B4\uC838\uC57C \uD569\uB2C8\uB2E4.","nl-NL":"De promotienaam mag alleen bestaan uit alfanumerieke tekens.","nl":"De promotienaam mag alleen bestaan uit alfanumerieke tekens.","no-NO":"Kampanjenavn kan bare best\xe5 av alfanumeriske tegn.","pl-PL":"Nazwa promocji mo\u017Ce zawiera\u0107 wy\u0142\u0105cznie znaki alfanumeryczne.","pl":"Nazwa promocji mo\u017Ce zawiera\u0107 wy\u0142\u0105cznie znaki alfanumeryczne.","pt-BR":"O nome da promo\xe7\xe3o deve conter apenas caracteres alfanum\xe9ricos.","pt-PT":"O Nome da promo\xe7\xe3o dever conter apenas carateres alfanum\xe9ricos.","ru-RU":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0431\u0443\u043A\u0432\u044B \u0438 \u0446\u0438\u0444\u0440\u044B.","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0431\u0443\u043A\u0432\u044B \u0438 \u0446\u0438\u0444\u0440\u044B.","sv-SE":"Kampanjnamnet f\xe5r endast inneh\xe5lla alfanumeriska tecken.","sv":"Kampanjnamnet f\xe5r endast inneh\xe5lla alfanumeriska tecken.","th-TH":"\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","tr-TR":"Promosyon Ad\u0131 yaln\u0131zca alfabetik karakterler i\xe7ermelidir.","tr":"Promosyon Ad\u0131 yaln\u0131zca alfabetik karakterler i\xe7ermelidir."},"RL_PromotionUpdateSuccess":{"key":"RL_PromotionUpdateSuccess","en":"Promotion updated successfully!","ca-ES":"La promoci\xf3 s\'ha actualitzat correctament.","ca":"La promoci\xf3 s\'ha actualitzat correctament.","cs-CZ":"Promoakce byla \xfasp\u011B\u0161n\u011B upraven\xe1.","cs":"Promoakce byla \xfasp\u011B\u0161n\u011B upraven\xe1.","da-DK":"Kampagne blev opdateret.","da":"Kampagne blev opdateret.","de-DE":"Das Angebot wurde erfolgreich aktualisiert.","de":"Das Angebot wurde erfolgreich aktualisiert.","el-GR":"\u0397 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1!","el":"\u0397 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC \u03B5\u03BD\u03B7\u03BC\u03B5\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1!","en-GB":"Promotion updated successfully!","es-ES":"Promoci\xf3n actualizada correctamente.","es":"Promoci\xf3n actualizada correctamente.","fi-FI":"Tarjouskampanja on p\xe4ivitetty!","fr-FR":"Promotion mise \xe0 jour avec succ\xe8s\xa0!","fr":"Promotion mise \xe0 jour avec succ\xe8s\xa0!","he-IL":"\u05D4\u05DE\u05D1\u05E6\u05E2 \u05E2\u05D5\u05D3\u05DB\u05DF \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4!","hr-HR":"Uspje\u0161no je a\u017Eurirana promocija!","hu-HU":"A prom\xf3ci\xf3t sikeresen friss\xedtett\xfck!","hu":"A prom\xf3ci\xf3t sikeresen friss\xedtett\xfck!","it-IT":"Promozione aggiornata correttamente!","it":"Promozione aggiornata correttamente!","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002","ko-KR":"\uD504\uB85C\uBAA8\uC158\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","ko":"\uD504\uB85C\uBAA8\uC158\uC774 \uC5C5\uB370\uC774\uD2B8\uB418\uC5C8\uC2B5\uB2C8\uB2E4!","nl-NL":"De promotie is bijgewerkt.","nl":"De promotie is bijgewerkt.","no-NO":"Kampanjen er oppdatert.","pl-PL":"Promocja zaktualizowana!","pl":"Promocja zaktualizowana!","pt-BR":"Promo\xe7\xe3o atualizada!","pt-PT":"Promo\xe7\xe3o atualizada com sucesso!","ru-RU":"\u0410\u043A\u0446\u0438\u044F \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430!","ru":"\u0410\u043A\u0446\u0438\u044F \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430!","sv-SE":"Kampanjen har uppdaterats.","sv":"Kampanjen har uppdaterats.","th-TH":"\u0E2D\u0E31\u0E1E\u0E40\u0E14\u0E17\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27","th":"\u0E2D\u0E31\u0E1E\u0E40\u0E14\u0E17\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27","tr-TR":"Promosyon ba\u015Far\u0131yla g\xfcncellendi!","tr":"Promosyon ba\u015Far\u0131yla g\xfcncellendi!"},"RL_PromotionalProductsWith":{"key":"RL_PromotionalProductsWith","en":"Promotional Products with","ca-ES":"Productes promocionals amb","ca":"Productes promocionals amb","cs-CZ":"Propaga\u010Dn\xed produkty s","cs":"Propaga\u010Dn\xed produkty s","da-DK":"Kampagneprodukter med","da":"Kampagneprodukter med","de-DE":"Werbeprodukte mit","de":"Werbeprodukte mit","el-GR":"\u03A0\u03C1\u03BF\u03C9\u03B8\u03B7\u03C4\u03B9\u03BA\u03AC \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03BC\u03B5","el":"\u03A0\u03C1\u03BF\u03C9\u03B8\u03B7\u03C4\u03B9\u03BA\u03AC \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03BC\u03B5","en-GB":"Promotional Products with","es-ES":"Productos promocionales con","es":"Productos promocionales con","fi-FI":"Kampanjatuotteet","fr-FR":"Produit promotionnels avec","fr":"Produit promotionnels avec","he-IL":"\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05D1\u05DE\u05D1\u05E6\u05E2 \u05E2\u05DD","hr-HR":"Promotivni proizvodi s","hu-HU":"Prom\xf3ci\xf3s term\xe9kek:","hu":"Prom\xf3ci\xf3s term\xe9kek:","it-IT":"Prodotti promozionali con","it":"Prodotti promozionali con","ja-JP":"\u6B21\u306E\u5E97\u5185\u7528\u88FD\u54C1\uFF1A","ja":"\u6B21\u306E\u5E97\u5185\u7528\u88FD\u54C1\uFF1A","ko-KR":"\uD310\uCD09\uC6A9 \uC81C\uD488 +","ko":"\uD310\uCD09\uC6A9 \uC81C\uD488 +","nl-NL":"Promotieproducten met","nl":"Promotieproducten met","no-NO":"Kampanjeprodukter med","pl-PL":"Produkty promocyjne z","pl":"Produkty promocyjne z","pt-BR":"Produtos promocionais com","pt-PT":"Produtos promocionais com","ru-RU":"\u0420\u0435\u043A\u043B\u0430\u043C\u043D\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0441","ru":"\u0420\u0435\u043A\u043B\u0430\u043C\u043D\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0441","sv-SE":"Kampanjprodukter med","sv":"Kampanjprodukter med","th-TH":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E1A","th":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E01\u0E32\u0E23\u0E02\u0E32\u0E22\u0E23\u0E48\u0E27\u0E21\u0E01\u0E31\u0E1A","tr-TR":"Promosyon \xdcr\xfcnleri:","tr":"Promosyon \xdcr\xfcnleri:"},"RL_Promotions":{"key":"RL_Promotions","en":"Promotions","ca-ES":"Promocions","ca":"Promocions","cs-CZ":"Promoakce","cs":"Promoakce","da-DK":"Kampagner","da":"Kampagner","de-DE":"Angebote","de":"Angebote","el-GR":"\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2","el":"\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2","en-GB":"Promotions","es-ES":"Promociones","es":"Promociones","fi-FI":"Kampanjat","fr-FR":"Promotions","fr":"Promotions","he-IL":"\u05DE\u05D1\u05E6\u05E2\u05D9\u05DD","hr-HR":"Promocije","hu-HU":"Prom\xf3ci\xf3k","hu":"Prom\xf3ci\xf3k","it-IT":"Promozioni","it":"Promozioni","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3","ko-KR":"\uD504\uB85C\uBAA8\uC158","ko":"\uD504\uB85C\uBAA8\uC158","nl-NL":"Promoties","nl":"Promoties","no-NO":"Kampanjer","pl-PL":"Promocje","pl":"Promocje","pt-BR":"Promo\xe7\xf5es","pt-PT":"Promo\xe7\xf5es","ru-RU":"\u041F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u0438","ru":"\u041F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u0438","sv-SE":"Kampanjer","sv":"Kampanjer","th-TH":"\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","th":"\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr-TR":"Promosyonlar","tr":"Promosyonlar"},"RL_Quantity":{"key":"RL_Quantity","en":"Quantity","ca-ES":"Quantitat","ca":"Quantitat","cs-CZ":"Po\u010Det","cs":"Po\u010Det","da-DK":"Antal","da":"Antal","de-DE":"Menge","de":"Menge","el-GR":"\u03A0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1","el":"\u03A0\u03BF\u03C3\u03CC\u03C4\u03B7\u03C4\u03B1","en-GB":"Quantity","es-ES":"Cantidad","es":"Cantidad","fi-FI":"M\xe4\xe4r\xe4","fr-FR":"Quantit\xe9","fr":"Quantit\xe9","he-IL":"\u05DB\u05DE\u05D5\u05EA","hr-HR":"Koli\u010Dina","hu-HU":"Mennyis\xe9g","hu":"Mennyis\xe9g","it-IT":"Quantit\xe0","it":"Quantit\xe0","ja-JP":"\u6570\u91CF","ja":"\u6570\u91CF","ko-KR":"\uC218\uB7C9","ko":"\uC218\uB7C9","nl-NL":"Aantal","nl":"Aantal","no-NO":"Antall","pl-PL":"Ilo\u015B\u0107","pl":"Ilo\u015B\u0107","pt-BR":"Quantidade","pt-PT":"Quantidade","ru-RU":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E","ru":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E","sv-SE":"Antal","sv":"Antal","th-TH":"\u0E08\u0E33\u0E19\u0E27\u0E19","th":"\u0E08\u0E33\u0E19\u0E27\u0E19","tr-TR":"Adet","tr":"Adet"},"RL_RemoveConfirmation":{"key":"RL_RemoveConfirmation","en":"Do you want to remove this product?","ca-ES":"Vols eliminar aquest producte?","ca":"Vols eliminar aquest producte?","cs-CZ":"Chcete tenhle produkt odebrat?","cs":"Chcete tenhle produkt odebrat?","da-DK":"Vil du fjerne dette produkt?","da":"Vil du fjerne dette produkt?","de-DE":"M\xf6chtest du dieses Produkt entfernen?","de":"M\xf6chtest du dieses Produkt entfernen?","el-GR":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD;","el":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD;","en-GB":"Do you want to remove this product?","es-ES":"\xbfQuieres eliminar este producto?","es":"\xbfQuieres eliminar este producto?","fi-FI":"Haluatko poistaa t\xe4m\xe4n tuotteen?","fr-FR":"Souhaitez-vous supprimer ce produit\xa0?","fr":"Souhaitez-vous supprimer ce produit\xa0?","he-IL":"\u05D4\u05D0\u05DD \u05D1\u05E8\u05E6\u05D5\u05E0\u05DB\u05DD \u05DC\u05D4\u05E1\u05D9\u05E8 \u05D0\u05EA \u05D4\u05DE\u05D5\u05E6\u05E8 \u05D4\u05D6\u05D4?","hr-HR":"\u017Delite li ukloniti ovaj proizvod?","hu-HU":"Elt\xe1vol\xedtod ezt a term\xe9ket?","hu":"Elt\xe1vol\xedtod ezt a term\xe9ket?","it-IT":"Vuoi rimuovere questo prodotto?","it":"Vuoi rimuovere questo prodotto?","ja-JP":"\u3053\u306E\u5546\u54C1\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ja":"\u3053\u306E\u5546\u54C1\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ko-KR":"\uC774 \uC81C\uD488\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC5B4\uC694?","ko":"\uC774 \uC81C\uD488\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC5B4\uC694?","nl-NL":"Wil je dit product verwijderen?","nl":"Wil je dit product verwijderen?","no-NO":"Vil du fjerne dette produktet?","pl-PL":"Czy chcesz usun\u0105\u0107 ten produkt?","pl":"Czy chcesz usun\u0105\u0107 ten produkt?","pt-BR":"Deseja remover este produto?","pt-PT":"Pretende remover este produto?","ru-RU":"\u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0442\u043E\u0432\u0430\u0440?","ru":"\u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0442\u043E\u0432\u0430\u0440?","sv-SE":"Vill du ta bort den h\xe4r produkten?","sv":"Vill du ta bort den h\xe4r produkten?","th-TH":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49\u0E2D\u0E2D\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","th":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E19\u0E35\u0E49\u0E2D\u0E2D\u0E01\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","tr-TR":"Bu \xfcr\xfcn\xfc kald\u0131rmak istiyor musunuz?","tr":"Bu \xfcr\xfcn\xfc kald\u0131rmak istiyor musunuz?"},"RL_Roles":{"key":"RL_Roles","en":"Roles","ca-ES":"Funcions","ca":"Funcions","cs-CZ":"Role","cs":"Role","da-DK":"Roller","da":"Roller","de-DE":"Rollen","de":"Rollen","el-GR":"\u03A1\u03CC\u03BB\u03BF\u03B9","el":"\u03A1\u03CC\u03BB\u03BF\u03B9","en-GB":"Roles","es-ES":"Funciones","es":"Funciones","fi-FI":"Roolit","fr-FR":"R\xf4les","fr":"R\xf4les","he-IL":"\u05EA\u05E4\u05E7\u05D9\u05D3\u05D9\u05DD","hr-HR":"Uloge","hu-HU":"Szerepek","hu":"Szerepek","it-IT":"Ruoli","it":"Ruoli","ja-JP":"\u5F79\u5272","ja":"\u5F79\u5272","ko-KR":"\uC5ED\uD560","ko":"\uC5ED\uD560","nl-NL":"Rollen","nl":"Rollen","no-NO":"Roller","pl-PL":"Stanowiska","pl":"Stanowiska","pt-BR":"Fun\xe7\xf5es","pt-PT":"Fun\xe7\xf5es","ru-RU":"\u0420\u043E\u043B\u0438","ru":"\u0420\u043E\u043B\u0438","sv-SE":"Roller","sv":"Roller","th-TH":"\u0E1A\u0E17\u0E1A\u0E32\u0E17","th":"\u0E1A\u0E17\u0E1A\u0E32\u0E17","tr-TR":"Roller","tr":"Roller"},"RL_STOCK_ON_HANDS":{"key":"RL_STOCK_ON_HANDS","en":"STOCK ON HANDS","ca-ES":"EXIST\xc8NCIES ACTUALS","ca":"EXIST\xc8NCIES ACTUALS","cs-CZ":"Existuj\xedc\xed z\xe1soby","cs":"Existuj\xedc\xed z\xe1soby","da-DK":"SOH\'er","da":"SOH\'er","de-DE":"LAGERBESTAND","de":"LAGERBESTAND","el-GR":"\u0394\u0399\u0391\u0398\u0395\u03A3\u0399\u039C\u039F \u0391\u03A0\u039F\u0398\u0395\u039C\u0391","el":"\u0394\u0399\u0391\u0398\u0395\u03A3\u0399\u039C\u039F \u0391\u03A0\u039F\u0398\u0395\u039C\u0391","en-GB":"STOCK ON HANDS","es-ES":"EXISTENCIAS ACTUALES","es":"EXISTENCIAS ACTUALES","fi-FI":"VARASTOSSA OLEVAT TUOTTEET","fr-FR":"STOCK DISPONIBLE","fr":"STOCK DISPONIBLE","he-IL":"\u05E1\u05D7\u05D5\u05E8\u05D4 \u05D6\u05DE\u05D9\u05E0\u05D4","hr-HR":"RASPOLO\u017DIVE ZALIHE","hu-HU":"RENDELKEZ\xc9SRE \xc1LL\xd3 RAKT\xc1RK\xc9SZLET","hu":"RENDELKEZ\xc9SRE \xc1LL\xd3 RAKT\xc1RK\xc9SZLET","it-IT":"SCORTE DISPONIBILI","it":"SCORTE DISPONIBILI","ja-JP":"\u5728\u5EAB","ja":"\u5728\u5EAB","ko-KR":"\uD604\uC7AC \uC7AC\uACE0 \uC218\uC900","ko":"\uD604\uC7AC \uC7AC\uACE0 \uC218\uC900","nl-NL":"BESTAANDE VOORRAAD","nl":"BESTAANDE VOORRAAD","no-NO":"P\xc5 LAGER","pl-PL":"AKTUALNE ZAPASY","pl":"AKTUALNE ZAPASY","pt-BR":"ESTOQUE DISPON\xcdVEL","pt-PT":"STOCK DISPON\xcdVEL","ru-RU":"\u0422\u041E\u0412\u0410\u0420\u042B \u0412 \u041D\u0410\u041B\u0418\u0427\u0418\u0418","ru":"\u0422\u041E\u0412\u0410\u0420\u042B \u0412 \u041D\u0410\u041B\u0418\u0427\u0418\u0418","sv-SE":"FINNS I LAGER","sv":"FINNS I LAGER","th-TH":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E43\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01","th":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E43\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01","tr-TR":"ELDE BULUNAN STOK","tr":"ELDE BULUNAN STOK"},"RL_SaveChanges":{"key":"RL_SaveChanges","en":"Save Changes","ca-ES":"Desa els canvis","ca":"Desa els canvis","cs-CZ":"Ulo\u017Eit zm\u011Bny","cs":"Ulo\u017Eit zm\u011Bny","da-DK":"Gem \xe6ndringer","da":"Gem \xe6ndringer","de-DE":"\xc4nderungen speichern","de":"\xc4nderungen speichern","el-GR":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD","el":"\u0391\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7 \u03B1\u03BB\u03BB\u03B1\u03B3\u03CE\u03BD","en-GB":"Save Changes","es-ES":"Guardar cambios","es":"Guardar cambios","fi-FI":"Tallenna muutokset","fr-FR":"Enregistrer les modifications","fr":"Enregistrer les modifications","he-IL":"\u05E9\u05DE\u05D5\u05E8 \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD","hr-HR":"Spremi promjene","hu-HU":"V\xe1ltoztat\xe1sok ment\xe9se","hu":"V\xe1ltoztat\xe1sok ment\xe9se","it-IT":"Salva modifiche","it":"Salva modifiche","ja-JP":"\u5909\u66F4\u3092\u4FDD\u5B58","ja":"\u5909\u66F4\u3092\u4FDD\u5B58","ko-KR":"\uBCC0\uACBD \uC0AC\uD56D \uC800\uC7A5","ko":"\uBCC0\uACBD \uC0AC\uD56D \uC800\uC7A5","nl-NL":"Sla wijzigingen op","nl":"Sla wijzigingen op","no-NO":"Lagre endringene","pl-PL":"Zapisz zmiany","pl":"Zapisz zmiany","pt-BR":"Salvar altera\xe7\xf5es","pt-PT":"Guardar altera\xe7\xf5es","ru-RU":"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F","ru":"\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F","sv-SE":"Spara \xe4ndringar","sv":"Spara \xe4ndringar","th-TH":"\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07","th":"\u0E1A\u0E31\u0E19\u0E17\u0E36\u0E01\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07","tr-TR":"De\u011Fi\u015Fiklikleri Kaydet","tr":"De\u011Fi\u015Fiklikleri Kaydet"},"RL_ScanBarcode":{"key":"RL_ScanBarcode","en":"Scan Barcode","ca-ES":"Escaneja el codi de barres","ca":"Escaneja el codi de barres","cs-CZ":"Na\u010Dt\u011Bte \u010D\xe1rov\xfd k\xf3d","cs":"Na\u010Dt\u011Bte \u010D\xe1rov\xfd k\xf3d","da-DK":"Scan stregkode","da":"Scan stregkode","de-DE":"Barcode scannen","de":"Barcode scannen","el-GR":"\u03A3\u03AC\u03C1\u03C9\u03C3\u03B7 \u03B3\u03C1\u03B1\u03BC\u03BC\u03C9\u03C4\u03BF\u03CD \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1","el":"\u03A3\u03AC\u03C1\u03C9\u03C3\u03B7 \u03B3\u03C1\u03B1\u03BC\u03BC\u03C9\u03C4\u03BF\u03CD \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1","en-GB":"Scan Barcode","es-ES":"Escanear c\xf3digo de barras","es":"Escanear c\xf3digo de barras","fi-FI":"Skannaa viivakoodi","fr-FR":"Scanner un code-barres","fr":"Scanner un code-barres","he-IL":"\u05E1\u05E8\u05E7\u05D5 \u05D1\u05E8\u05E7\u05D5\u05D3","hr-HR":"Skeniraj crti\u010Dni k\xf4d","hu-HU":"Vonalk\xf3d beolvas\xe1sa","hu":"Vonalk\xf3d beolvas\xe1sa","it-IT":"Scansiona codice a barre","it":"Scansiona codice a barre","ja-JP":"\u30D0\u30FC\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3","ja":"\u30D0\u30FC\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3","ko-KR":"\uBC14\uCF54\uB4DC \uC2A4\uCE94","ko":"\uBC14\uCF54\uB4DC \uC2A4\uCE94","nl-NL":"Scan barcode","nl":"Scan barcode","no-NO":"Skann strekkode","pl-PL":"Zeskanuj kod kreskowy","pl":"Zeskanuj kod kreskowy","pt-BR":"Digitalizar c\xf3digo de barras","pt-PT":"Ler c\xf3digo de barras","ru-RU":"\u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0448\u0442\u0440\u0438\u0445\u043A\u043E\u0434","ru":"\u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0448\u0442\u0440\u0438\u0445\u043A\u043E\u0434","sv-SE":"Skanna streckkod","sv":"Skanna streckkod","th-TH":"\u0E2A\u0E41\u0E01\u0E19\u0E1A\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14","th":"\u0E2A\u0E41\u0E01\u0E19\u0E1A\u0E32\u0E23\u0E4C\u0E42\u0E04\u0E49\u0E14","tr-TR":"Barkodu Tara","tr":"Barkodu Tara"},"RL_SearchMarkdowns":{"key":"RL_SearchMarkdowns","en":"Search Markdowns","ca-ES":"Cerca descomptes","ca":"Cerca descomptes","cs-CZ":"Hledat ve slev\xe1ch","cs":"Hledat ve slev\xe1ch","da-DK":"S\xf8g i prisneds\xe6ttelser","da":"S\xf8g i prisneds\xe6ttelser","de-DE":"Preisabschl\xe4ge suchen","de":"Preisabschl\xe4ge suchen","el-GR":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03BC\u03B5\u03B9\u03CE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B9\u03BC\u03CE\u03BD","el":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03BC\u03B5\u03B9\u03CE\u03C3\u03B5\u03C9\u03BD \u03C4\u03B9\u03BC\u03CE\u03BD","en-GB":"Search Markdowns","es-ES":"Buscar rebajas","es":"Buscar rebajas","fi-FI":"Etsi alennuksia","fr-FR":"Rechercher des d\xe9marques","fr":"Rechercher des d\xe9marques","he-IL":"\u05D7\u05E4\u05E9\u05D5 \u05D4\u05E0\u05D7\u05D5\u05EA","hr-HR":"Pretra\u017Ei sni\u017Eenja","hu-HU":"Le\xe9rt\xe9kel\xe9sek keres\xe9se","hu":"Le\xe9rt\xe9kel\xe9sek keres\xe9se","it-IT":"Cerca ribassi","it":"Cerca ribassi","ja-JP":"\u5024\u4E0B\u3052\u3092\u691C\u7D22","ja":"\u5024\u4E0B\u3052\u3092\u691C\u7D22","ko-KR":"\uAC00\uACA9 \uC778\uD558 \uAC80\uC0C9","ko":"\uAC00\uACA9 \uC778\uD558 \uAC80\uC0C9","nl-NL":"Zoek kortingen","nl":"Zoek kortingen","no-NO":"S\xf8k etter tilbud","pl-PL":"Szukaj obni\u017Cek","pl":"Szukaj obni\u017Cek","pt-BR":"Pesquisar redu\xe7\xe3o de pre\xe7o","pt-PT":"Procurar artigos com desconto","ru-RU":"\u041F\u043E\u0438\u0441\u043A \u0443\u0446\u0435\u043D\u0435\u043D\u043D\u044B\u0445 \u0442\u043E\u0432\u0430\u0440\u043E\u0432","ru":"\u041F\u043E\u0438\u0441\u043A \u0443\u0446\u0435\u043D\u0435\u043D\u043D\u044B\u0445 \u0442\u043E\u0432\u0430\u0440\u043E\u0432","sv-SE":"S\xf6k efter priss\xe4nkningar","sv":"S\xf6k efter priss\xe4nkningar","th-TH":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32","th":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E25\u0E14\u0E23\u0E32\u0E04\u0E32","tr-TR":"\u0130ndirimleri Ara","tr":"\u0130ndirimleri Ara"},"RL_SearchProductOrStyleColor":{"key":"RL_SearchProductOrStyleColor","en":"Search Product or Style Color","ca-ES":"Cerca el producte o el color del model","ca":"Cerca el producte o el color del model","cs-CZ":"Hledat podle produktu nebo barvy modelu","cs":"Hledat podle produktu nebo barvy modelu","da-DK":"S\xf8g efter produkt eller modelfarve","da":"S\xf8g efter produkt eller modelfarve","de-DE":"Produktname oder Style-Farbe suchen","de":"Produktname oder Style-Farbe suchen","el-GR":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 \u03AE \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C3\u03C4\u03B9\u03BB","el":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2 \u03AE \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C3\u03C4\u03B9\u03BB","en-GB":"Search Product or Style Colour","es-ES":"Buscar producto o color de modelo","es":"Buscar producto o color de modelo","fi-FI":"Etsi tuotenimen tai v\xe4rin perusteella","fr-FR":"Rechercher un produit ou une couleur de mod\xe8le","fr":"Rechercher un produit ou une couleur de mod\xe8le","he-IL":"\u05D7\u05E4\u05E9\u05D5 \u05DE\u05D5\u05E6\u05E8 \u05D0\u05D5 \u05E1\u05D2\u05E0\u05D5\u05DF-\u05E6\u05D1\u05E2","hr-HR":"Pretra\u017Ei proizvod ili model/boju","hu-HU":"Term\xe9k vagy Style Color keres\xe9se","hu":"Term\xe9k vagy Style Color keres\xe9se","it-IT":"Cerca per prodotto o colore del modello","it":"Cerca per prodotto o colore del modello","ja-JP":"\u5546\u54C1\u307E\u305F\u306F\u30B9\u30BF\u30A4\u30EB \u30AB\u30E9\u30FC\u3092\u691C\u7D22","ja":"\u5546\u54C1\u307E\u305F\u306F\u30B9\u30BF\u30A4\u30EB \u30AB\u30E9\u30FC\u3092\u691C\u7D22","ko-KR":"\uC81C\uD488 \uB610\uB294 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC \uAC80\uC0C9","ko":"\uC81C\uD488 \uB610\uB294 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC \uAC80\uC0C9","nl-NL":"Zoek op product of stijlkleur","nl":"Zoek op product of stijlkleur","no-NO":"S\xf8k etter produkt eller produktfarge","pl-PL":"Szukaj produktu lub modelu-koloru","pl":"Szukaj produktu lub modelu-koloru","pt-BR":"Pesquisar produto ou cor do estilo","pt-PT":"Procurar Produto ou estilo-cor","ru-RU":"\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E \u0442\u043E\u0432\u0430\u0440\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0435\u043B\u0438/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0435","ru":"\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E \u0442\u043E\u0432\u0430\u0440\u0430 \u0438\u043B\u0438 \u043C\u043E\u0434\u0435\u043B\u0438/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0435","sv-SE":"S\xf6k efter produkt eller modellf\xe4rg","sv":"S\xf6k efter produkt eller modellf\xe4rg","th-TH":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","th":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","tr-TR":"\xdcr\xfcn veya Stil Rengi Ara","tr":"\xdcr\xfcn veya Stil Rengi Ara"},"RL_Select":{"key":"RL_Select","en":"Select","ca-ES":"Selecciona","ca":"Selecciona","cs-CZ":"Vybrat","cs":"Vybrat","da-DK":"V\xe6lg","da":"V\xe6lg","de-DE":"Ausw\xe4hlen","de":"Ausw\xe4hlen","el-GR":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE","el":"\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE","en-GB":"Select","es-ES":"Seleccionar","es":"Seleccionar","fi-FI":"Valitse","fr-FR":"S\xe9lectionner","fr":"S\xe9lectionner","he-IL":"\u05D1\u05D7\u05D9\u05E8\u05D4","hr-HR":"Odaberi","hu-HU":"Kiv\xe1laszt\xe1s","hu":"Kiv\xe1laszt\xe1s","it-IT":"Seleziona","it":"Seleziona","ja-JP":"\u9078\u629E","ja":"\u9078\u629E","ko-KR":"\uC120\uD0DD","ko":"\uC120\uD0DD","nl-NL":"Selecteer","nl":"Selecteer","no-NO":"Velg","pl-PL":"Wybierz","pl":"Wybierz","pt-BR":"Selecionar","pt-PT":"Selecionar","ru-RU":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C","ru":"\u0412\u044B\u0431\u0440\u0430\u0442\u044C","sv-SE":"V\xe4lj","sv":"V\xe4lj","th-TH":"\u0E40\u0E25\u0E37\u0E2D\u0E01","th":"\u0E40\u0E25\u0E37\u0E2D\u0E01","tr-TR":"Se\xe7","tr":"Se\xe7"},"RL_SignIn":{"key":"RL_SignIn","en":"Sign In","ca-ES":"Inicia la sessi\xf3","ca":"Inicia la sessi\xf3","cs-CZ":"P\u0159ihl\xe1sit se","cs":"P\u0159ihl\xe1sit se","da-DK":"Log ind","da":"Log ind","de-DE":"Anmelden","de":"Anmelden","el-GR":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","el":"\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7","en-GB":"Sign In","es-ES":"Iniciar sesi\xf3n","es":"Iniciar sesi\xf3n","fi-FI":"Kirjaudu sis\xe4\xe4n","fr-FR":"S\'identifier","fr":"S\'identifier","he-IL":"\u05DB\u05E0\u05D9\u05E1\u05D4","hr-HR":"Prijava","hu-HU":"Bel\xe9p\xe9s","hu":"Bel\xe9p\xe9s","it-IT":"Accedi","it":"Accedi","ja-JP":"\u30ED\u30B0\u30A4\u30F3","ja":"\u30ED\u30B0\u30A4\u30F3","ko-KR":"\uB85C\uADF8\uC778","ko":"\uB85C\uADF8\uC778","nl-NL":"Log in","nl":"Log in","no-NO":"Logg p\xe5","pl-PL":"Zaloguj si\u0119","pl":"Zaloguj si\u0119","pt-BR":"Entrar","pt-PT":"Iniciar sess\xe3o","ru-RU":"\u0412\u043E\u0439\u0442\u0438","ru":"\u0412\u043E\u0439\u0442\u0438","sv-SE":"Logga in","sv":"Logga in","th-TH":"\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49","th":"\u0E25\u0E07\u0E0A\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E43\u0E0A\u0E49","tr-TR":"Oturum A\xe7","tr":"Oturum A\xe7"},"RL_StartDate":{"key":"RL_StartDate","en":"Start Date","ca-ES":"Data d\'inici","ca":"Data d\'inici","cs-CZ":"Po\u010D\xe1te\u010Dn\xed datum","cs":"Po\u010D\xe1te\u010Dn\xed datum","da-DK":"Startdato","da":"Startdato","de-DE":"Startdatum","de":"Startdatum","el-GR":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","el":"\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2","en-GB":"Start Date","es-ES":"Fecha de inicio","es":"Fecha de inicio","fi-FI":"Aloitusp\xe4iv\xe4","fr-FR":"Date de d\xe9but","fr":"Date de d\xe9but","he-IL":"\u05EA\u05D0\u05E8\u05D9\u05DA \u05D4\u05EA\u05D7\u05DC\u05D4","hr-HR":"Datum po\u010Detka","hu-HU":"Kezd\xe9s d\xe1tuma","hu":"Kezd\xe9s d\xe1tuma","it-IT":"Data di inizio","it":"Data di inizio","ja-JP":"\u958B\u59CB\u65E5","ja":"\u958B\u59CB\u65E5","ko-KR":"\uC2DC\uC791\uC77C","ko":"\uC2DC\uC791\uC77C","nl-NL":"Begindatum","nl":"Begindatum","no-NO":"Startdato","pl-PL":"Data rozpocz\u0119cia","pl":"Data rozpocz\u0119cia","pt-BR":"Data de in\xedcio","pt-PT":"Data de in\xedcio","ru-RU":"\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430","ru":"\u0414\u0430\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430","sv-SE":"Startdatum","sv":"Startdatum","th-TH":"\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E23\u0E34\u0E48\u0E21","th":"\u0E27\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E23\u0E34\u0E48\u0E21","tr-TR":"Ba\u015Flang\u0131\xe7 Tarihi","tr":"Ba\u015Flang\u0131\xe7 Tarihi"},"RL_StartScanning":{"key":"RL_StartScanning","en":"Start scanning","ca-ES":"Comen\xe7a a escanejar","ca":"Comen\xe7a a escanejar","cs-CZ":"Za\u010D\xedt skenovat","cs":"Za\u010D\xedt skenovat","da-DK":"Start scanning","da":"Start scanning","de-DE":"Suche starten","de":"Suche starten","el-GR":"\u0388\u03BD\u03B1\u03C1\u03BE\u03B7 \u03C3\u03AC\u03C1\u03C9\u03C3\u03B7\u03C2","el":"\u0388\u03BD\u03B1\u03C1\u03BE\u03B7 \u03C3\u03AC\u03C1\u03C9\u03C3\u03B7\u03C2","en-GB":"Start scanning","es-ES":"Empezar escaneo","es":"Empezar escaneo","fi-FI":"Aloita skannaaminen","fr-FR":"Commencer \xe0 scanner","fr":"Commencer \xe0 scanner","he-IL":"\u05D4\u05EA\u05D7\u05D9\u05DC\u05D5 \u05DC\u05E1\u05E8\u05D5\u05E7","hr-HR":"Pokreni skenirane","hu-HU":"Beolvas\xe1s kezd\xe9se","hu":"Beolvas\xe1s kezd\xe9se","it-IT":"Inizia scansione","it":"Inizia scansione","ja-JP":"\u30B9\u30AD\u30E3\u30F3\u3092\u958B\u59CB","ja":"\u30B9\u30AD\u30E3\u30F3\u3092\u958B\u59CB","ko-KR":"\uC2A4\uCE94 \uC2DC\uC791","ko":"\uC2A4\uCE94 \uC2DC\uC791","nl-NL":"Begin met scannen","nl":"Begin met scannen","no-NO":"Start skanning","pl-PL":"Rozpocznij skanowanie","pl":"Rozpocznij skanowanie","pt-BR":"Iniciar a digitaliza\xe7\xe3o","pt-PT":"Iniciar leitura","ru-RU":"\u041D\u0430\u0447\u0430\u0442\u044C \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435","ru":"\u041D\u0430\u0447\u0430\u0442\u044C \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435","sv-SE":"B\xf6rja skanna","sv":"B\xf6rja skanna","th-TH":"\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19","th":"\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19","tr-TR":"Taramay\u0131 ba\u015Flat","tr":"Taramay\u0131 ba\u015Flat"},"RL_Starts":{"key":"RL_Starts","en":"starts","ca-ES":"comen\xe7a","ca":"comen\xe7a","cs-CZ":"za\u010D\xe1tek","cs":"za\u010D\xe1tek","da-DK":"begynder","da":"begynder","de-DE":"Beginnt","de":"Beginnt","el-GR":"\u03BE\u03B5\u03BA\u03B9\u03BD\u03AC","el":"\u03BE\u03B5\u03BA\u03B9\u03BD\u03AC","en-GB":"starts","es-ES":"empieza","es":"empieza","fi-FI":"alkaa","fr-FR":"commence","fr":"commence","he-IL":"\u05D4\u05D7\u05DC \u05DE","hr-HR":"po\u010Dinje","hu-HU":"kezd\xe9s","hu":"kezd\xe9s","it-IT":"inizia","it":"inizia","ja-JP":"\u958B\u59CB","ja":"\u958B\u59CB","ko-KR":"\uC2DC\uC791","ko":"\uC2DC\uC791","nl-NL":"begint","nl":"begint","no-NO":"starter","pl-PL":"rozpocznie si\u0119","pl":"rozpocznie si\u0119","pt-BR":"come\xe7a","pt-PT":"come\xe7a","ru-RU":"\u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F","ru":"\u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F","sv-SE":"startar","sv":"startar","th-TH":"\u0E40\u0E23\u0E34\u0E48\u0E21","th":"\u0E40\u0E23\u0E34\u0E48\u0E21","tr-TR":"ba\u015Flang\u0131\xe7","tr":"ba\u015Flang\u0131\xe7"},"RL_StockOnHand":{"key":"RL_StockOnHand","en":"Stock on Hand","ca-ES":"Exist\xe8ncies actuals","ca":"Exist\xe8ncies actuals","cs-CZ":"Existuj\xedc\xed z\xe1soby v","cs":"Existuj\xedc\xed z\xe1soby v","da-DK":"SOH","da":"SOH","de-DE":"Lagerbestand","de":"Lagerbestand","el-GR":"\u0394\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03B1\u03C0\u03CC\u03B8\u03B5\u03BC\u03B1","el":"\u0394\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03BF \u03B1\u03C0\u03CC\u03B8\u03B5\u03BC\u03B1","en-GB":"Stock on Hand","es-ES":"Existencias actuales","es":"Existencias actuales","fi-FI":"Varastossa olevat tuotteet","fr-FR":"Stock disponible","fr":"Stock disponible","he-IL":"\u05E1\u05D7\u05D5\u05E8\u05D4 \u05D6\u05DE\u05D9\u05E0\u05D4","hr-HR":"Raspolo\u017Eive zalihe","hu-HU":"Rendelkez\xe9sre \xe1ll\xf3 rakt\xe1rk\xe9szlet","hu":"Rendelkez\xe9sre \xe1ll\xf3 rakt\xe1rk\xe9szlet","it-IT":"Scorte disponibili","it":"Scorte disponibili","ja-JP":"\u5728\u5EAB","ja":"\u5728\u5EAB","ko-KR":"\uD604\uC7AC \uC7AC\uACE0 \uC218\uC900","ko":"\uD604\uC7AC \uC7AC\uACE0 \uC218\uC900","nl-NL":"Bestaande voorraad","nl":"Bestaande voorraad","no-NO":"P\xe5 lager","pl-PL":"Aktualne zapasy","pl":"Aktualne zapasy","pt-BR":"Estoque dispon\xedvel","pt-PT":"Stock dispon\xedvel","ru-RU":"\u0422\u043E\u0432\u0430\u0440\u044B \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438","ru":"\u0422\u043E\u0432\u0430\u0440\u044B \u0432 \u043D\u0430\u043B\u0438\u0447\u0438\u0438","sv-SE":"Finns i lager","sv":"Finns i lager","th-TH":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E43\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01","th":"\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E43\u0E19\u0E2A\u0E15\u0E47\u0E2D\u0E01","tr-TR":"Elde Bulunan Stok","tr":"Elde Bulunan Stok"},"RL_StyleColor":{"key":"RL_StyleColor","en":"Style Color","ca-ES":"Color del model","ca":"Color del model","cs-CZ":"Barva stylu","cs":"Barva stylu","da-DK":"Modelfarve","da":"Modelfarve","de-DE":"Style-Color","de":"Style-Color","el-GR":"\u03A7\u03C1\u03CE\u03BC\u03B1 \u03C3\u03C4\u03B9\u03BB","el":"\u03A7\u03C1\u03CE\u03BC\u03B1 \u03C3\u03C4\u03B9\u03BB","en-GB":"Style Colour","es-ES":"Color del modelo","es":"Color del modelo","fi-FI":"V\xe4ri","fr-FR":"Style-coloris","fr":"Style-coloris","he-IL":"\u05E6\u05D1\u05E2 \u05E1\u05D2\u05E0\u05D5\u05DF","hr-HR":"Style Color","hu-HU":"Sz\xedn","hu":"Sz\xedn","it-IT":"Colore del modello","it":"Colore del modello","ja-JP":"Style Color","ja":"Style Color","ko-KR":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC","ko":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC","nl-NL":"Stijlkleur","nl":"Stijlkleur","no-NO":"Produktfarge","pl-PL":"Model-kolor","pl":"Model-kolor","pt-BR":"Cor do estilo","pt-PT":"Style-Color","ru-RU":"\u041C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430","ru":"\u041C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430","sv-SE":"Modellf\xe4rg","sv":"Modellf\xe4rg","th-TH":"\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","th":"\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","tr-TR":"Stil Rengi","tr":"Stil Rengi"},"RL_StyleColors":{"key":"RL_StyleColors","en":"Style Colors","ca-ES":"Colors del model","ca":"Colors del model","cs-CZ":"Styly-barvy","cs":"Styly-barvy","da-DK":"Modelfarver","da":"Modelfarver","de-DE":"Style-Colors","de":"Style-Colors","el-GR":"\u03A7\u03C1\u03CE\u03BC\u03B1\u03C4\u03B1 \u03C3\u03C4\u03BB","el":"\u03A7\u03C1\u03CE\u03BC\u03B1\u03C4\u03B1 \u03C3\u03C4\u03BB","en-GB":"Style Colours","es-ES":"Colores del modelo","es":"Colores del modelo","fi-FI":"V\xe4rit","fr-FR":"Style-coloris","fr":"Style-coloris","he-IL":"\u05E6\u05D1\u05E2\u05D9 \u05E1\u05D2\u05E0\u05D5\u05DF","hr-HR":"Style Colors","hu-HU":"Sz\xednek","hu":"Sz\xednek","it-IT":"Colori del modello","it":"Colori del modello","ja-JP":"Style Color","ja":"Style Color","ko-KR":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC","ko":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC","nl-NL":"Stijlkleuren","nl":"Stijlkleuren","no-NO":"Produktfarger","pl-PL":"Modele-kolory","pl":"Modele-kolory","pt-BR":"Cores do estilo","pt-PT":"Style-Colors","ru-RU":"\u041C\u043E\u0434\u0435\u043B\u0438/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0438","ru":"\u041C\u043E\u0434\u0435\u043B\u0438/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0438","sv-SE":"Modellf\xe4rger","sv":"Modellf\xe4rger","th-TH":"\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","th":"\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","tr-TR":"Stil Renkleri","tr":"Stil Renkleri"},"RL_Submit":{"key":"RL_Submit","en":"Submit","ca-ES":"Envia","ca":"Envia","cs-CZ":"Odeslat","cs":"Odeslat","da-DK":"Send","da":"Send","de-DE":"Senden","de":"Senden","el-GR":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE","el":"\u03A5\u03C0\u03BF\u03B2\u03BF\u03BB\u03AE","en-GB":"Submit","es-ES":"Enviar","es":"Enviar","fi-FI":"L\xe4het\xe4","fr-FR":"Envoyer","fr":"Envoyer","he-IL":"\u05E9\u05DC\u05D9\u05D7\u05D4","hr-HR":"Po\u0161alji","hu-HU":"K\xfcld\xe9s","hu":"K\xfcld\xe9s","it-IT":"Invia","it":"Invia","ja-JP":"\u9001\u4FE1","ja":"\u9001\u4FE1","ko-KR":"\uC81C\uCD9C","ko":"\uC81C\uCD9C","nl-NL":"Verzend","nl":"Verzend","no-NO":"Send inn","pl-PL":"Wy\u015Blij","pl":"Wy\u015Blij","pt-BR":"Enviar","pt-PT":"Enviar","ru-RU":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C","ru":"\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C","sv-SE":"Skicka","sv":"Skicka","th-TH":"\u0E2A\u0E48\u0E07","th":"\u0E2A\u0E48\u0E07","tr-TR":"G\xf6nder","tr":"G\xf6nder"},"RL_Today":{"key":"RL_Today","en":"Today","ca-ES":"Avui","ca":"Avui","cs-CZ":"Dnes","cs":"Dnes","da-DK":"I dag","da":"I dag","de-DE":"Heute","de":"Heute","el-GR":"\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1","el":"\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1","en-GB":"Today","es-ES":"Hoy","es":"Hoy","fi-FI":"T\xe4n\xe4\xe4n","fr-FR":"Aujourd\'hui","fr":"Aujourd\'hui","he-IL":"\u05D4\u05D9\u05D5\u05DD","hr-HR":"Danas","hu-HU":"Ma","hu":"Ma","it-IT":"Oggi","it":"Oggi","ja-JP":"\u672C\u65E5","ja":"\u672C\u65E5","ko-KR":"\uC624\uB298","ko":"\uC624\uB298","nl-NL":"Vandaag","nl":"Vandaag","no-NO":"I dag","pl-PL":"Dzisiaj","pl":"Dzisiaj","pt-BR":"Hoje","pt-PT":"Hoje","ru-RU":"\u0421\u0435\u0433\u043E\u0434\u043D\u044F","ru":"\u0421\u0435\u0433\u043E\u0434\u043D\u044F","sv-SE":"Idag","sv":"Idag","th-TH":"\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49","th":"\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49","tr-TR":"Bug\xfcn","tr":"Bug\xfcn"},"RL_Units":{"key":"RL_Units","en":"Units","ca-ES":"Unitats","ca":"Unitats","cs-CZ":"Polo\u017Eky","cs":"Polo\u017Eky","da-DK":"Enheder","da":"Enheder","de-DE":"Einheiten","de":"Einheiten","el-GR":"\u039C\u03BF\u03BD\u03AC\u03B4\u03B5\u03C2","el":"\u039C\u03BF\u03BD\u03AC\u03B4\u03B5\u03C2","en-GB":"Units","es-ES":"Unidades","es":"Unidades","fi-FI":"Yksikk\xf6\xe4","fr-FR":"Unit\xe9s","fr":"Unit\xe9s","he-IL":"\u05D9\u05D7\u05D9\u05D3\u05D5\u05EA","hr-HR":"Jedinice","hu-HU":"Egys\xe9gek","hu":"Egys\xe9gek","it-IT":"Unit\xe0","it":"Unit\xe0","ja-JP":"\u5358\u4F4D","ja":"\u5358\u4F4D","ko-KR":"\uC720\uB2DB","ko":"\uC720\uB2DB","nl-NL":"Eenheden","nl":"Eenheden","no-NO":"Enheter","pl-PL":"Sztuki","pl":"Sztuki","pt-BR":"Unidades","pt-PT":"Unidades","ru-RU":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0435\u0434\u0438\u043D\u0438\u0446","ru":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0435\u0434\u0438\u043D\u0438\u0446","sv-SE":"Enheter","sv":"Enheter","th-TH":"\u0E2B\u0E19\u0E48\u0E27\u0E22","th":"\u0E2B\u0E19\u0E48\u0E27\u0E22","tr-TR":"Birimler","tr":"Birimler"},"RL_Version":{"key":"RL_Version","en":"Version","ca-ES":"Versi\xf3","ca":"Versi\xf3","cs-CZ":"Verze","cs":"Verze","da-DK":"Version","da":"Version","de-DE":"Version","de":"Version","el-GR":"\u0388\u03BA\u03B4\u03BF\u03C3\u03B7","el":"\u0388\u03BA\u03B4\u03BF\u03C3\u03B7","en-GB":"Version","es-ES":"Versi\xf3n","es":"Versi\xf3n","fi-FI":"Versio","fr-FR":"Version","fr":"Version","he-IL":"\u05D2\u05E8\u05E1\u05D4","hr-HR":"Verzija","hu-HU":"Verzi\xf3","hu":"Verzi\xf3","it-IT":"Versione","it":"Versione","ja-JP":"\u30D0\u30FC\u30B8\u30E7\u30F3","ja":"\u30D0\u30FC\u30B8\u30E7\u30F3","ko-KR":"\uBC84\uC804","ko":"\uBC84\uC804","nl-NL":"Versie","nl":"Versie","no-NO":"Versjon","pl-PL":"Wersja","pl":"Wersja","pt-BR":"vers\xe3o","pt-PT":"Vers\xe3o","ru-RU":"\u0412\u0435\u0440\u0441\u0438\u044F","ru":"\u0412\u0435\u0440\u0441\u0438\u044F","sv-SE":"Version","sv":"Version","th-TH":"\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E19","th":"\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E19","tr-TR":"Versiyon","tr":"Versiyon"},"RL_VisualMerchandising":{"key":"RL_VisualMerchandising","en":"Visual Merchandising","ca-ES":"Marxandatge visual","ca":"Marxandatge visual","cs-CZ":"Vizu\xe1ln\xed podpora","cs":"Vizu\xe1ln\xed podpora","da-DK":"Visuel markedsf\xf8ring","da":"Visuel markedsf\xf8ring","de-DE":"Visual Merchandising","de":"Visual Merchandising","el-GR":"\u039F\u03C0\u03C4\u03B9\u03BA\u03AE \u03C0\u03C1\u03BF\u03CE\u03B8\u03B7\u03C3\u03B7 \u03B5\u03BC\u03C0\u03BF\u03C1\u03B5\u03C5\u03BC\u03AC\u03C4\u03C9\u03BD","el":"\u039F\u03C0\u03C4\u03B9\u03BA\u03AE \u03C0\u03C1\u03BF\u03CE\u03B8\u03B7\u03C3\u03B7 \u03B5\u03BC\u03C0\u03BF\u03C1\u03B5\u03C5\u03BC\u03AC\u03C4\u03C9\u03BD","en-GB":"Visual Merchandising","es-ES":"Presentaci\xf3n visual","es":"Presentaci\xf3n visual","fi-FI":"Visuaalinen markkinointi","fr-FR":"Merchandising visuel","fr":"Merchandising visuel","he-IL":"\u05E9\u05D9\u05D5\u05D5\u05E7 \u05D7\u05D6\u05D5\u05EA\u05D9","hr-HR":"Proizvodi za izlaganje","hu-HU":"Vizu\xe1lis \xe1ru\xe9rt\xe9kes\xedt\xe9s","hu":"Vizu\xe1lis \xe1ru\xe9rt\xe9kes\xedt\xe9s","it-IT":"Visual Merchandising","it":"Visual Merchandising","ja-JP":"\u30D3\u30B8\u30E5\u30A2\u30EB \u30DE\u30FC\u30C1\u30E3\u30F3\u30C0\u30A4\u30B8\u30F3\u30B0","ja":"\u30D3\u30B8\u30E5\u30A2\u30EB \u30DE\u30FC\u30C1\u30E3\u30F3\u30C0\u30A4\u30B8\u30F3\u30B0","ko-KR":"\uBE44\uC8FC\uC5BC \uBA38\uCC9C\uB2E4\uC774\uC9D5","ko":"\uBE44\uC8FC\uC5BC \uBA38\uCC9C\uB2E4\uC774\uC9D5","nl-NL":"Visuele merchandising","nl":"Visuele merchandising","no-NO":"Visuell merchandising","pl-PL":"Prezentacja towaru","pl":"Prezentacja towaru","pt-BR":"Merchandising visual","pt-PT":"Apresenta\xe7\xe3o visual da mercadoria","ru-RU":"\u0412\u0438\u0437\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0438\u043D\u0433","ru":"\u0412\u0438\u0437\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u043C\u0435\u0440\u0447\u0435\u043D\u0434\u0430\u0439\u0437\u0438\u043D\u0433","sv-SE":"Visuell marknadsf\xf6ring","sv":"Visuell marknadsf\xf6ring","th-TH":"\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","th":"\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32","tr-TR":"G\xf6rsel Sat\u0131\u015F Geli\u015Ftirme","tr":"G\xf6rsel Sat\u0131\u015F Geli\u015Ftirme"},"RL_Women":{"key":"RL_Women","en":"Women","ca-ES":"Dona","ca":"Dona","cs-CZ":"\u017Deny","cs":"\u017Deny","da-DK":"Kvinder","da":"Kvinder","de-DE":"Damen","de":"Damen","el-GR":"\u0393\u03C5\u03BD\u03B1\u03AF\u03BA\u03B5\u03C2","el":"\u0393\u03C5\u03BD\u03B1\u03AF\u03BA\u03B5\u03C2","en-GB":"Women","es-ES":"Mujer","es":"Mujer","fi-FI":"Naiset","fr-FR":"Femme","fr":"Femme","he-IL":"\u05E0\u05E9\u05D9\u05DD","hr-HR":"\u017Dene","hu-HU":"N\u0151i","hu":"N\u0151i","it-IT":"Donna","it":"Donna","ja-JP":"\u30A6\u30A3\u30E1\u30F3\u30BA","ja":"\u30A6\u30A3\u30E1\u30F3\u30BA","ko-KR":"\uC5EC\uC131","ko":"\uC5EC\uC131","nl-NL":"Dames","nl":"Dames","no-NO":"Dame","pl-PL":"Kobiety","pl":"Kobiety","pt-BR":"Feminino","pt-PT":"Mulher","ru-RU":"\u0416\u0435\u043D\u0449\u0438\u043D\u044B","ru":"\u0416\u0435\u043D\u0449\u0438\u043D\u044B","sv-SE":"Kvinnor","sv":"Kvinnor","th-TH":"\u0E1C\u0E39\u0E49\u0E2B\u0E0D\u0E34\u0E07","th":"\u0E1C\u0E39\u0E49\u0E2B\u0E0D\u0E34\u0E07","tr-TR":"Kad\u0131n","tr":"Kad\u0131n"},"RL_Yes":{"key":"RL_Yes","en":"Yes","ca-ES":"S\xed","ca":"S\xed","cs-CZ":"Ano","cs":"Ano","da-DK":"Ja","da":"Ja","de-DE":"Ja","de":"Ja","el-GR":"\u039D\u03B1\u03B9","el":"\u039D\u03B1\u03B9","en-GB":"Yes","es-ES":"S\xed","es":"S\xed","fi-FI":"Kyll\xe4","fr-FR":"Oui","fr":"Oui","he-IL":"\u05DB\u05DF","hr-HR":"Da","hu-HU":"Igen","hu":"Igen","it-IT":"S\xec","it":"S\xec","ja-JP":"\u306F\u3044","ja":"\u306F\u3044","ko-KR":"\uC608","ko":"\uC608","nl-NL":"Ja","nl":"Ja","no-NO":"Ja","pl-PL":"Tak","pl":"Tak","pt-BR":"Sim","pt-PT":"Sim","ru-RU":"\u0414\u0430","ru":"\u0414\u0430","sv-SE":"Ja","sv":"Ja","th-TH":"\u0E43\u0E0A\u0E48","th":"\u0E43\u0E0A\u0E48","tr-TR":"Evet","tr":"Evet"},"RL_ClearItemSuccess":{"key":"RL_ClearItemSuccess","en":"Successfully cleared items from {{1}}","ca-ES":"S\'han eliminat correctament els productes de la promoci\xf3 {{1}}","ca":"S\'han eliminat correctament els productes de la promoci\xf3 {{1}}","cs-CZ":"Jednotky byly \xfasp\u011B\u0161n\u011B odstran\u011Bn\xe9 z\xa0{{1}}","cs":"Jednotky byly \xfasp\u011B\u0161n\u011B odstran\u011Bn\xe9 z\xa0{{1}}","da-DK":"Varer blev ryddet fra {{1}}","da":"Varer blev ryddet fra {{1}}","de-DE":"Die Artikel wurden erfolgreich aus {{1}} gel\xf6scht.","de":"Die Artikel wurden erfolgreich aus {{1}} gel\xf6scht.","el-GR":"\u03A4\u03B1 \u03B5\u03AF\u03B4\u03B7 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B1\u03BD \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03C0\u03CC {{1}}","el":"\u03A4\u03B1 \u03B5\u03AF\u03B4\u03B7 \u03B4\u03B9\u03B1\u03B3\u03C1\u03AC\u03C6\u03B7\u03BA\u03B1\u03BD \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03C0\u03CC {{1}}","en-GB":"Successfully cleared items from {{1}}","es-ES":"Se han eliminado correctamente los productos de {{1}}","es":"Se han eliminado correctamente los productos de {{1}}","fi-FI":"{{1}} tuotteen poisto onnistui","fr-FR":"Articles retir\xe9s avec succ\xe8s de {{1}}","fr":"Articles retir\xe9s avec succ\xe8s de {{1}}","he-IL":"\u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E0\u05D5\u05E7\u05D5 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4 \u05DE\u05EA\u05D5\u05DA {{1}}","hr-HR":"Stavke su uspje\u0161no uklonjene iz {{1}}","hu-HU":"A cikkeket sikeresen t\xf6r\xf6lt\xfck innen: {{1}}","hu":"A cikkeket sikeresen t\xf6r\xf6lt\xfck innen: {{1}}","it-IT":"Gli articoli sono stati rimossi correttamente da {{1}}","it":"Gli articoli sono stati rimossi correttamente da {{1}}","ja-JP":"{{1}}\u304B\u3089\u5546\u54C1\u3092\u524A\u9664\u3057\u307E\u3057\u305F","ja":"{{1}}\u304B\u3089\u5546\u54C1\u3092\u524A\u9664\u3057\u307E\u3057\u305F","ko-KR":"{{1}}\uC5D0\uC11C \uC81C\uD488\uC744 \uC0AD\uC81C\uD588\uC2B5\uB2C8\uB2E4","ko":"{{1}}\uC5D0\uC11C \uC81C\uD488\uC744 \uC0AD\uC81C\uD588\uC2B5\uB2C8\uB2E4","nl-NL":"Items zijn verwijderd uit {{1}}","nl":"Items zijn verwijderd uit {{1}}","no-NO":"Slettet varer fra {{1}}","pl-PL":"Uda\u0142o si\u0119 usun\u0105\u0107 produkty z {{1}}","pl":"Uda\u0142o si\u0119 usun\u0105\u0107 produkty z {{1}}","pt-BR":"Itens removidos de {{1}}","pt-PT":"Artigos eliminados com sucesso de {{1}}","ru-RU":"\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0442\u043E\u0432\u0430\u0440\u044B \u0438\u0437 {{1}}","ru":"\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0442\u043E\u0432\u0430\u0440\u044B \u0438\u0437 {{1}}","sv-SE":"Du har rensat alla produkter fr\xe5n {{1}}","sv":"Du har rensat alla produkter fr\xe5n {{1}}","th-TH":"\u0E19\u0E33\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01 {{1}} \u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27","th":"\u0E19\u0E33\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01 {{1}} \u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27","tr-TR":"\xdcr\xfcnler {{1}} \xf6\u011Fesinden ba\u015Far\u0131yla temizlendi","tr":"\xdcr\xfcnler {{1}} \xf6\u011Fesinden ba\u015Far\u0131yla temizlendi"},"RL_PromotionNameorStyleColor":{"key":"RL_PromotionNameorStyleColor","en":"Promotion Name or Style Color","ca-ES":"Nom de la promoci\xf3 o color del model","ca":"Nom de la promoci\xf3 o color del model","cs-CZ":"N\xe1zev promoakce nebo barva modelu","cs":"N\xe1zev promoakce nebo barva modelu","da-DK":"Kampagnenavn eller modelfarve","da":"Kampagnenavn eller modelfarve","de-DE":"Angebotsname oder Style-Farbe","de":"Angebotsname oder Style-Farbe","el-GR":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2 \u03AE \u03C7\u03C1\u03CE\u03BC\u03B1 \u03C3\u03C4\u03B9\u03BB","el":"\u038C\u03BD\u03BF\u03BC\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2 \u03AE \u03C7\u03C1\u03CE\u03BC\u03B1 \u03C3\u03C4\u03B9\u03BB","en-GB":"Promotion Name or Style Colour","es-ES":"Nombre de la promoci\xf3n o color del modelo","es":"Nombre de la promoci\xf3n o color del modelo","fi-FI":"Tarjouskampanjan nimi tai tyylin v\xe4ri","fr-FR":"Nom de la promotion ou Style-Coloris","fr":"Nom de la promotion ou Style-Coloris","he-IL":"\u05E9\u05DD \u05D4\u05DE\u05D1\u05E6\u05E2 \u05D0\u05D5 \u05E1\u05D2\u05E0\u05D5\u05DF-\u05E6\u05D1\u05E2","hr-HR":"Naziv promocije ili model/boja","hu-HU":"Prom\xf3ci\xf3 neve vagy Style Color","hu":"Prom\xf3ci\xf3 neve vagy Style Color","it-IT":"Nome della promozione o colore del modello","it":"Nome della promozione o colore del modello","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u540D\u307E\u305F\u306F\u30B9\u30BF\u30A4\u30EB \u30AB\u30E9\u30FC","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u540D\u307E\u305F\u306F\u30B9\u30BF\u30A4\u30EB \u30AB\u30E9\u30FC","ko-KR":"\uD504\uB85C\uBAA8\uC158 \uC774\uB984 \uB610\uB294 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC","ko":"\uD504\uB85C\uBAA8\uC158 \uC774\uB984 \uB610\uB294 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC","nl-NL":"Promotienaam of stijlkleur","nl":"Promotienaam of stijlkleur","no-NO":"Kampanjenavn eller produktfarge","pl-PL":"Nazwa promocji lub model/kolor","pl":"Nazwa promocji lub model/kolor","pt-BR":"Nome da promo\xe7\xe3o ou Cor do estilo","pt-PT":"Nome da promo\xe7\xe3o ou estilo-cor","ru-RU":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438 \u0438\u043B\u0438 \u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430 \u043C\u043E\u0434\u0435\u043B\u0438","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0430\u043A\u0446\u0438\u0438 \u0438\u043B\u0438 \u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430 \u043C\u043E\u0434\u0435\u043B\u0438","sv-SE":"Kampanjnamn eller modellf\xe4rg","sv":"Kampanjnamn eller modellf\xe4rg","th-TH":"\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","th":"\u0E0A\u0E37\u0E48\u0E2D\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C","tr-TR":"Promosyon Ad\u0131 veya Stil/Renk","tr":"Promosyon Ad\u0131 veya Stil/Renk"},"RL_FootwearDivision":{"key":"RL_FootwearDivision","en":"Footwear Division","ca-ES":"Departament de cal\xe7at","ca":"Departament de cal\xe7at","cs-CZ":"Sekce Obuv","cs":"Sekce Obuv","da-DK":"Fodt\xf8jsdivision","da":"Fodt\xf8jsdivision","de-DE":"Footwear Division","de":"Footwear Division","el-GR":"\u03A4\u03BC\u03AE\u03BC\u03B1 \u03C0\u03B1\u03C0\u03BF\u03C5\u03C4\u03C3\u03B9\u03CE\u03BD","el":"\u03A4\u03BC\u03AE\u03BC\u03B1 \u03C0\u03B1\u03C0\u03BF\u03C5\u03C4\u03C3\u03B9\u03CE\u03BD","en-GB":"Footwear Division","es-ES":"Categor\xeda de zapatillas","es":"Categor\xeda de zapatillas","fi-FI":"Jalkineosasto","fr-FR":"Division chaussures","fr":"Division chaussures","he-IL":"\u05DE\u05D7\u05DC\u05E7\u05EA \u05D4\u05E0\u05E2\u05DC\u05D4","hr-HR":"Odjel obu\u0107e","hu-HU":"Cip\u0151r\xe9szleg","hu":"Cip\u0151r\xe9szleg","it-IT":"Divisione Scarpe","it":"Divisione Scarpe","ja-JP":"\u30D5\u30C3\u30C8\u30A6\u30A7\u30A2\u90E8\u9580","ja":"\u30D5\u30C3\u30C8\u30A6\u30A7\u30A2\u90E8\u9580","ko-KR":"\uC2E0\uBC1C \uBD80\uC11C","ko":"\uC2E0\uBC1C \uBD80\uC11C","nl-NL":"Schoenendivisie","nl":"Schoenendivisie","no-NO":"Skoavdeling","pl-PL":"Dzia\u0142 obuwia","pl":"Dzia\u0142 obuwia","pt-BR":"Divis\xe3o de cal\xe7ados","pt-PT":"Sec\xe7\xe3o de cal\xe7ado","ru-RU":"\u041E\u0442\u0434\u0435\u043B \u043E\u0431\u0443\u0432\u0438","ru":"\u041E\u0442\u0434\u0435\u043B \u043E\u0431\u0443\u0432\u0438","sv-SE":"Skoavdelning","sv":"Skoavdelning","th-TH":"\u0E2B\u0E21\u0E27\u0E14\u0E23\u0E2D\u0E07\u0E40\u0E17\u0E49\u0E32","th":"\u0E2B\u0E21\u0E27\u0E14\u0E23\u0E2D\u0E07\u0E40\u0E17\u0E49\u0E32","tr-TR":"Ayakkab\u0131 Departman\u0131","tr":"Ayakkab\u0131 Departman\u0131"},"RL_Mens":{"key":"RL_Mens","en":"Mens","ca-ES":"Per a home","ca":"Per a home","cs-CZ":"Mu\u017Ei","cs":"Mu\u017Ei","da-DK":"Til m\xe6nd","da":"Til m\xe6nd","de-DE":"Herren","de":"Herren","el-GR":"\u0391\u03BD\u03B4\u03C1\u03B9\u03BA\u03AC","el":"\u0391\u03BD\u03B4\u03C1\u03B9\u03BA\u03AC","en-GB":"Men\'s","es-ES":"Hombre","es":"Hombre","fi-FI":"Miesten","fr-FR":"Homme","fr":"Homme","he-IL":"\u05D2\u05D1\u05E8\u05D9\u05DD","hr-HR":"Mu\u0161karci","hu-HU":"F\xe9rfi","hu":"F\xe9rfi","it-IT":"Uomo","it":"Uomo","ja-JP":"\u30E1\u30F3\u30BA","ja":"\u30E1\u30F3\u30BA","ko-KR":"\uB0A8\uC131","ko":"\uB0A8\uC131","nl-NL":"Heren","nl":"Heren","no-NO":"Herre","pl-PL":"M\u0119skie","pl":"M\u0119skie","pt-BR":"Masculino","pt-PT":"Homem","ru-RU":"\u041C\u0443\u0436\u0447\u0438\u043D\u044B","ru":"\u041C\u0443\u0436\u0447\u0438\u043D\u044B","sv-SE":"M\xe4n","sv":"M\xe4n","th-TH":"\u0E1C\u0E39\u0E49\u0E0A\u0E32\u0E22","th":"\u0E1C\u0E39\u0E49\u0E0A\u0E32\u0E22","tr-TR":"Erkek","tr":"Erkek"},"RL_Womens":{"key":"RL_Womens","en":"Womens","ca-ES":"Per a dona","ca":"Per a dona","cs-CZ":"\u017Deny","cs":"\u017Deny","da-DK":"Til kvinder","da":"Til kvinder","de-DE":"Damen","de":"Damen","el-GR":"\u0393\u03C5\u03BD\u03B1\u03B9\u03BA\u03B5\u03AF\u03B1","el":"\u0393\u03C5\u03BD\u03B1\u03B9\u03BA\u03B5\u03AF\u03B1","en-GB":"Women\'s","es-ES":"Mujer","es":"Mujer","fi-FI":"Naisten","fr-FR":"Femme","fr":"Femme","he-IL":"\u05E0\u05E9\u05D9\u05DD","hr-HR":"\u017Dene","hu-HU":"N\u0151i","hu":"N\u0151i","it-IT":"Donna","it":"Donna","ja-JP":"\u30A6\u30A3\u30E1\u30F3\u30BA","ja":"\u30A6\u30A3\u30E1\u30F3\u30BA","ko-KR":"\uC5EC\uC131","ko":"\uC5EC\uC131","nl-NL":"Dames","nl":"Dames","no-NO":"Dame","pl-PL":"Damskie","pl":"Damskie","pt-BR":"Feminino","pt-PT":"Mulher","ru-RU":"\u0416\u0435\u043D\u0449\u0438\u043D\u044B","ru":"\u0416\u0435\u043D\u0449\u0438\u043D\u044B","sv-SE":"Kvinnor","sv":"Kvinnor","th-TH":"\u0E1C\u0E39\u0E49\u0E2B\u0E0D\u0E34\u0E07","th":"\u0E1C\u0E39\u0E49\u0E2B\u0E0D\u0E34\u0E07","tr-TR":"Kad\u0131n","tr":"Kad\u0131n"},"RL_SearchPromotions":{"key":"RL_SearchPromotions","en":"Search Promotions","ca-ES":"Cerca promocions","ca":"Cerca promocions","cs-CZ":"Hledat promoakce","cs":"Hledat promoakce","da-DK":"S\xf8g efter kampagner","da":"S\xf8g efter kampagner","de-DE":"Angebote suchen","de":"Angebote suchen","el-GR":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03CE\u03BD","el":"\u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03CE\u03BD","en-GB":"Search Promotions","es-ES":"Buscar promociones","es":"Buscar promociones","fi-FI":"Etsi tarjouskampanjoita","fr-FR":"Rechercher les promotions","fr":"Rechercher les promotions","he-IL":"\u05D7\u05D9\u05E4\u05D5\u05E9 \u05DE\u05D1\u05E6\u05E2\u05D9\u05DD","hr-HR":"Pretra\u017Ei promocije","hu-HU":"Prom\xf3ci\xf3k keres\xe9se","hu":"Prom\xf3ci\xf3k keres\xe9se","it-IT":"Cerca promozioni","it":"Cerca promozioni","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u691C\u7D22","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u691C\u7D22","ko-KR":"\uD504\uB85C\uBAA8\uC158 \uAC80\uC0C9","ko":"\uD504\uB85C\uBAA8\uC158 \uAC80\uC0C9","nl-NL":"Zoek promoties","nl":"Zoek promoties","no-NO":"S\xf8k i kampanjer","pl-PL":"Wyszukaj promocje","pl":"Wyszukaj promocje","pt-BR":"Pesquisar promo\xe7\xf5es","pt-PT":"Procurar promo\xe7\xf5es","ru-RU":"\u041F\u043E\u0438\u0441\u043A \u0430\u043A\u0446\u0438\u0439","ru":"\u041F\u043E\u0438\u0441\u043A \u0430\u043A\u0446\u0438\u0439","sv-SE":"S\xf6k efter kampanj","sv":"S\xf6k efter kampanj","th-TH":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","th":"\u0E04\u0E49\u0E19\u0E2B\u0E32\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr-TR":"Promosyon Ara","tr":"Promosyon Ara"},"RL_ProductDeleteConfirm4":{"key":"RL_ProductDeleteConfirm4","en":"Do you want to remove products ({{1}}) from {{2}} promotion?","ca-ES":"Vols eliminar els productes ({{1}}) de la promoci\xf3 {{2}}?","ca":"Vols eliminar els productes ({{1}}) de la promoci\xf3 {{2}}?","cs-CZ":"Chcete odebrat produkty ({{1}}) z\xa0promoakce {{2}}?","cs":"Chcete odebrat produkty ({{1}}) z\xa0promoakce {{2}}?","da-DK":"Vil du fjerne ({{1}}) produkter fra {{2}}-kampagnen?","da":"Vil du fjerne ({{1}}) produkter fra {{2}}-kampagnen?","de-DE":"M\xf6chtest du Produkte ({{1}}) aus {{2}} Angebot entfernen?","de":"M\xf6chtest du Produkte ({{1}}) aus {{2}} Angebot entfernen?","el-GR":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 ({{1}}) \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC {{2}};","el":"\u0398\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 ({{1}}) \u03B1\u03C0\u03CC \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC {{2}};","en-GB":"Do you want to remove products ({{1}}) from {{2}} promotion?","es-ES":"\xbfQuieres eliminar ({{1}}) productos de la promoci\xf3n {{2}}?","es":"\xbfQuieres eliminar ({{1}}) productos de la promoci\xf3n {{2}}?","fi-FI":"Haluatko poistaa tuotteet ({{1}}) tarjouskampanjasta {{2}}?","fr-FR":"Souhaitez-vous retirer ({{1}})\xa0produits de la promotion {{2}}\xa0?","fr":"Souhaitez-vous retirer ({{1}})\xa0produits de la promotion {{2}}\xa0?","he-IL":"\u05D4\u05D0\u05DD \u05D1\u05E8\u05E6\u05D5\u05E0\u05DB\u05DD \u05DC\u05D4\u05E1\u05D9\u05E8 \u05DE\u05D5\u05E6\u05E8\u05D9\u05DD ({{1}}) \u05DE\u05D4\u05DE\u05D1\u05E6\u05E2 {{2}}?","hr-HR":"\u017Delite li ukloniti proizvode ({{1}}) iz promocije {{2}}?","hu-HU":"Elt\xe1vol\xedtod a term\xe9keket ({{1}}) a(z) {{2}} prom\xf3ci\xf3b\xf3l?","hu":"Elt\xe1vol\xedtod a term\xe9keket ({{1}}) a(z) {{2}} prom\xf3ci\xf3b\xf3l?","it-IT":"Vuoi rimuovere i prodotti ({{1}}) dalla promozione {{2}}?","it":"Vuoi rimuovere i prodotti ({{1}}) dalla promozione {{2}}?","ja-JP":"\u5546\u54C1\uFF08{{1}}\uFF09\u3092{{2}}\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ja":"\u5546\u54C1\uFF08{{1}}\uFF09\u3092{{2}}\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u304B\u3089\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","ko-KR":"{{2}} \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C \uC81C\uD488({{1}}\uAC1C)\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC5B4\uC694?","ko":"{{2}} \uD504\uB85C\uBAA8\uC158\uC5D0\uC11C \uC81C\uD488({{1}}\uAC1C)\uC744 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC5B4\uC694?","nl-NL":"Wil je producten ({{1}}) verwijderen uit de promotie {{2}}?","nl":"Wil je producten ({{1}}) verwijderen uit de promotie {{2}}?","no-NO":"Vil du fjerne produkter ({{1}}) fra {{2}} kampanje?","pl-PL":"Czy chcesz usun\u0105\u0107 produkty ({{1}}) z promocji {{2}}?","pl":"Czy chcesz usun\u0105\u0107 produkty ({{1}}) z promocji {{2}}?","pt-BR":"Deseja remover os produtos ({{1}}) de {{2}} promo\xe7\xe3o?","pt-PT":"Pretende remover produtos ({{1}}) da promo\xe7\xe3o {{2}}?","ru-RU":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u044B ({{1}}) \u0438\u0437 \u0430\u043A\u0446\u0438\u0438 {{2}}?","ru":"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u043E\u0432\u0430\u0440\u044B ({{1}}) \u0438\u0437 \u0430\u043A\u0446\u0438\u0438 {{2}}?","sv-SE":"Vill du ta bort produkter ({{1}}) fr\xe5n {{2}} kampanj?","sv":"Vill du ta bort produkter ({{1}}) fr\xe5n {{2}} kampanj?","th-TH":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 ({{1}}) \u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19 {{2}} \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","th":"\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E19\u0E33\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 ({{1}}) \u0E2D\u0E2D\u0E01\u0E08\u0E32\u0E01\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19 {{2}} \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","tr-TR":"{{2}} promosyonundan \xfcr\xfcnleri ({{1}}) kald\u0131rmak istiyor musun?","tr":"{{2}} promosyonundan \xfcr\xfcnleri ({{1}}) kald\u0131rmak istiyor musun?"},"RL_PromotionValidation1":{"key":"RL_PromotionValidation1","en":"This store does not have any promotions.","ca-ES":"Aquesta botiga no t\xe9 cap promoci\xf3.","ca":"Aquesta botiga no t\xe9 cap promoci\xf3.","cs-CZ":"Prodejna nem\xe1 \u017E\xe1dn\xe9 promoakce.","cs":"Prodejna nem\xe1 \u017E\xe1dn\xe9 promoakce.","da-DK":"Denne butik har ingen kampagner.","da":"Denne butik har ingen kampagner.","de-DE":"Dieser Store hat keine Angebote.","de":"Dieser Store hat keine Angebote.","el-GR":"\u03A4\u03BF \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1 \u03B4\u03B5\u03BD \u03B4\u03B9\u03B1\u03B8\u03AD\u03C4\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2.","el":"\u03A4\u03BF \u03C3\u03C5\u03B3\u03BA\u03B5\u03BA\u03C1\u03B9\u03BC\u03AD\u03BD\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1 \u03B4\u03B5\u03BD \u03B4\u03B9\u03B1\u03B8\u03AD\u03C4\u03B5\u03B9 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2.","en-GB":"This store does not have any promotions.","es-ES":"Esta tienda no tiene ninguna promoci\xf3n.","es":"Esta tienda no tiene ninguna promoci\xf3n.","fi-FI":"T\xe4ss\xe4 kaupassa ei ole tarjouskampanjoita.","fr-FR":"Ce magasin ne propose aucune promotion.","fr":"Ce magasin ne propose aucune promotion.","he-IL":"\u05D1\u05D7\u05E0\u05D5\u05EA \u05D6\u05D5 \u05D0\u05D9\u05DF \u05DE\u05D1\u05E6\u05E2\u05D9\u05DD.","hr-HR":"Na ovom prodajnom mjestu nema promocija.","hu-HU":"Ebben az \xfczletben nincsenek prom\xf3ci\xf3k.","hu":"Ebben az \xfczletben nincsenek prom\xf3ci\xf3k.","it-IT":"Questo store non offre promozioni.","it":"Questo store non offre promozioni.","ja-JP":"\u3053\u306E\u5E97\u8217\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306F\u3042\u308A\u307E\u305B\u3093\u3002","ja":"\u3053\u306E\u5E97\u8217\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306F\u3042\u308A\u307E\u305B\u3093\u3002","ko-KR":"\uC774 \uB9E4\uC7A5\uC5D0\uB294 \uC9C4\uD589 \uC911\uC778 \uD504\uB85C\uBAA8\uC158\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.","ko":"\uC774 \uB9E4\uC7A5\uC5D0\uB294 \uC9C4\uD589 \uC911\uC778 \uD504\uB85C\uBAA8\uC158\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.","nl-NL":"Er zijn geen promoties in deze store.","nl":"Er zijn geen promoties in deze store.","no-NO":"Denne butikken har ingen kampanjer.","pl-PL":"W tym sklepie nie ma \u017Cadnych promocji.","pl":"W tym sklepie nie ma \u017Cadnych promocji.","pt-BR":"Esta loja n\xe3o tem promo\xe7\xf5es.","pt-PT":"Esta loja n\xe3o tem quaisquer promo\xe7\xf5es.","ru-RU":"\u0412 \u044D\u0442\u043E\u043C \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435 \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u0430\u043A\u0446\u0438\u0439.","ru":"\u0412 \u044D\u0442\u043E\u043C \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0435 \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u0442\u0441\u044F \u0430\u043A\u0446\u0438\u0439.","sv-SE":"Den h\xe4r butiken har inga kampanjer.","sv":"Den h\xe4r butiken har inga kampanjer.","th-TH":"Store \u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E21\u0E35\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E43\u0E14\u0E46","th":"Store \u0E19\u0E35\u0E49\u0E44\u0E21\u0E48\u0E21\u0E35\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E43\u0E14\u0E46","tr-TR":"Bu ma\u011Fazada promosyon yok.","tr":"Bu ma\u011Fazada promosyon yok."},"RL_ProductScanSuccess":{"key":"RL_ProductScanSuccess","en":"All scanned products have been submitted successfully! Please click the \\"X\\" button to close the scanner.","cs-CZ":"V\u0161echny naskenovan\xe9 produkty byly \xfasp\u011B\u0161n\u011B odesl\xe1ny. Skener zav\u0159ete klepnut\xedm na symbol \u201EX\u201C.","cs":"V\u0161echny naskenovan\xe9 produkty byly \xfasp\u011B\u0161n\u011B odesl\xe1ny. Skener zav\u0159ete klepnut\xedm na symbol \u201EX\u201C.","da-DK":"Alle scannede produkter er blevet indsendt. Klik p\xe5 \\"X\\"-knappen for at lukke scanneren.","da":"Alle scannede produkter er blevet indsendt. Klik p\xe5 \\"X\\"-knappen for at lukke scanneren.","de-DE":"Alle gescannten Produkte wurden erfolgreich abgesendet! Klicke auf die Schaltfl\xe4che \\"X\\", um den Scanner zu schlie\xdfen.","de":"Alle gescannten Produkte wurden erfolgreich abgesendet! Klicke auf die Schaltfl\xe4che \\"X\\", um den Scanner zu schlie\xdfen.","el-GR":"\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C3\u03B1\u03C1\u03C9\u03BC\u03AD\u03BD\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03AD\u03C7\u03BF\u03C5\u03BD \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1! \u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03B1\u03C1\u03C9\u03C4\u03AE, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \\"X\\".","el":"\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C3\u03B1\u03C1\u03C9\u03BC\u03AD\u03BD\u03B1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03AD\u03C7\u03BF\u03C5\u03BD \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1! \u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03B1\u03C1\u03C9\u03C4\u03AE, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \\"X\\".","en-GB":"All scanned products have been submitted successfully! Please click the \\"X\\" button to close the scanner.","es-ES":"Todos los productos escaneados se han enviado correctamente. Haz clic en el bot\xf3n \\"X\\" para cerrar este esc\xe1ner.","es":"Todos los productos escaneados se han enviado correctamente. Haz clic en el bot\xf3n \\"X\\" para cerrar este esc\xe1ner.","fi-FI":"Kaikki skannatut tuotteet on lis\xe4tty onnistuneesti! Valitse \'X\', kun haluat sulkea skannerin.","fr-FR":"Tous les produits scann\xe9s ont \xe9t\xe9 soumis avec succ\xe8s\xa0! Cliquez sur le bouton \xab\xa0X\xa0\xbb pour fermer le scanner.","fr":"Tous les produits scann\xe9s ont \xe9t\xe9 soumis avec succ\xe8s\xa0! Cliquez sur le bouton \xab\xa0X\xa0\xbb pour fermer le scanner.","he-IL":"\u05DB\u05DC \u05D4\u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05D4\u05E1\u05E8\u05D5\u05E7\u05D9\u05DD \u05E0\u05E9\u05DC\u05D7\u05D5 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4! \u05DC\u05D7\u05E6\u05D5 \u05E2\u05DC \u05D4\u05DC\u05D7\u05E6\u05DF \'X\' \u05DB\u05D3\u05D9 \u05DC\u05E1\u05D2\u05D5\u05E8 \u05D0\u05EA \u05D4\u05E1\u05D5\u05E8\u05E7.","hr-HR":"Svi skenirani proizvodi uspje\u0161no su poslani! Kliknite na gumb \u201EX\u201D za zatvaranje skenera.","hu-HU":"Minden beolvasott term\xe9k bek\xfcld\xe9se sikeres volt! A beolvas\xf3 bez\xe1r\xe1s\xe1hoz kattints az \u201EX\u201D gombra.","hu":"Minden beolvasott term\xe9k bek\xfcld\xe9se sikeres volt! A beolvas\xf3 bez\xe1r\xe1s\xe1hoz kattints az \u201EX\u201D gombra.","it-IT":"Tutti i prodotti scansionati sono stati inviati correttamente. Clicca sulla \\"X\\" per chiudere lo scanner.","it":"Tutti i prodotti scansionati sono stati inviati correttamente. Clicca sulla \\"X\\" per chiudere lo scanner.","ja-JP":"\u30B9\u30AD\u30E3\u30F3\u6E08\u307F\u306E\u5546\u54C1\u306F\u3059\u3079\u3066\u6B63\u5E38\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002 \u300CX\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u30B9\u30AD\u30E3\u30CA\u30FC\u3092\u9589\u3058\u3066\u304F\u3060\u3055\u3044\u3002","ja":"\u30B9\u30AD\u30E3\u30F3\u6E08\u307F\u306E\u5546\u54C1\u306F\u3059\u3079\u3066\u6B63\u5E38\u306B\u9001\u4FE1\u3055\u308C\u307E\u3057\u305F\u3002 \u300CX\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u30B9\u30AD\u30E3\u30CA\u30FC\u3092\u9589\u3058\u3066\u304F\u3060\u3055\u3044\u3002","ko-KR":"\uC2A4\uCE94\uD55C \uC81C\uD488\uC774 \uBAA8\uB450 \uC131\uACF5\uC801\uC73C\uB85C \uC81C\uCD9C\uB418\uC5C8\uC2B5\uB2C8\uB2E4! \uC2A4\uCE90\uB108\uB97C \uC885\uB8CC\uD558\uB824\uBA74 \'X\' \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC138\uC694.","ko":"\uC2A4\uCE94\uD55C \uC81C\uD488\uC774 \uBAA8\uB450 \uC131\uACF5\uC801\uC73C\uB85C \uC81C\uCD9C\uB418\uC5C8\uC2B5\uB2C8\uB2E4! \uC2A4\uCE90\uB108\uB97C \uC885\uB8CC\uD558\uB824\uBA74 \'X\' \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC138\uC694.","nl-NL":"Alle gescande producten zijn doorgestuurd. Klik op de \'X\' om de scanner te sluiten.","nl":"Alle gescande producten zijn doorgestuurd. Klik op de \'X\' om de scanner te sluiten.","no-NO":"Alle skannede produkter er sendt inn. Klikk p\xe5 \xabX\xbb-knappen for \xe5 lukke skanneren.","pl-PL":"Wszystkie zeskanowane produkty zosta\u0142y przes\u0142ane. Kliknij przycisk \u201EX\u201D, by zamkn\u0105\u0107 skaner.","pl":"Wszystkie zeskanowane produkty zosta\u0142y przes\u0142ane. Kliknij przycisk \u201EX\u201D, by zamkn\u0105\u0107 skaner.","pt-BR":"Todos os produtos escaneados foram enviados. Clique no bot\xe3o \u201CX\u201D para fechar o escaneamento.","pt-PT":"Todos os produtos lidos foram enviados com sucesso! Clique no bot\xe3o \\"X\\" para fechar o leitor.","ru-RU":"\u0412\u0441\u0435 \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B! \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 X, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0441\u043A\u0430\u043D\u0435\u0440\u0430.","ru":"\u0412\u0441\u0435 \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u044B! \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 X, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0441\u043A\u0430\u043D\u0435\u0440\u0430.","sv-SE":"Alla skannade produkter har registrerats korrekt. Klicka p\xe5 knappen X f\xf6r att st\xe4nga skannern.","sv":"Alla skannade produkter har registrerats korrekt. Klicka p\xe5 knappen X f\xf6r att st\xe4nga skannern.","th-TH":"\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E38\u0E01\u0E0A\u0E34\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E41\u0E01\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27! \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 \\"X\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E34\u0E14\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2A\u0E41\u0E01\u0E19","th":"\u0E2A\u0E48\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E38\u0E01\u0E0A\u0E34\u0E49\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E41\u0E01\u0E19\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27! \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 \\"X\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E34\u0E14\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2A\u0E41\u0E01\u0E19","tr-TR":"Taranan t\xfcm \xfcr\xfcnler ba\u015Far\u0131yla g\xf6nderildi! L\xfctfen taray\u0131c\u0131y\u0131 kapatmak i\xe7in \\"X\\" d\xfc\u011Fmesine t\u0131kla.","tr":"Taranan t\xfcm \xfcr\xfcnler ba\u015Far\u0131yla g\xf6nderildi! L\xfctfen taray\u0131c\u0131y\u0131 kapatmak i\xe7in \\"X\\" d\xfc\u011Fmesine t\u0131kla."},"RL_ProductScanCancel1":{"key":"RL_ProductScanCancel1","en":"There is 1 un-submitted item, do you want to cancel?","ca-ES":"Hi ha un producte sense validar. Vols cancel\xb7lar-lo?","ca":"Hi ha un producte sense validar. Vols cancel\xb7lar-lo?","cs-CZ":"M\xe1te 1 neodeslanou polo\u017Eku, chcete proces zru\u0161it?","cs":"M\xe1te 1 neodeslanou polo\u017Eku, chcete proces zru\u0161it?","da-DK":"Der er 1 vare, der ikke er indsendt, vil du annullere?","da":"Der er 1 vare, der ikke er indsendt, vil du annullere?","de-DE":"Es gibt ein nicht abgesendetes Produkt, m\xf6chtest du abbrechen?","de":"Es gibt ein nicht abgesendetes Produkt, m\xf6chtest du abbrechen?","el-GR":"\u03A5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 1 \u03B5\u03AF\u03B4\u03BF\u03C2 \u03C0\u03BF\u03C5 \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF, \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B3\u03AF\u03BD\u03B5\u03B9 \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7;","el":"\u03A5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 1 \u03B5\u03AF\u03B4\u03BF\u03C2 \u03C0\u03BF\u03C5 \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF, \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B3\u03AF\u03BD\u03B5\u03B9 \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7;","en-GB":"There is 1 unsubmitted item, do you want to cancel?","es-ES":"Hay un producto sin enviar. \xbfQuieres cancelarlo?","es":"Hay un producto sin enviar. \xbfQuieres cancelarlo?","fi-FI":"Yksi tuote on lis\xe4\xe4m\xe4tt\xe4, haluatko peruuttaa?","fr-FR":"Il reste 1\xa0article non soumis, souhaitez-vous annuler\xa0?","fr":"Il reste 1\xa0article non soumis, souhaitez-vous annuler\xa0?","he-IL":"\u05D9\u05E9 \u05E4\u05E8\u05D9\u05D8 1 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DC\u05D7, \u05D4\u05D0\u05DD \u05DC\u05D1\u05D8\u05DC?","hr-HR":"Jedan artikl nije poslan. \u017Delite li odustati?","hu-HU":"Tal\xe1ltunk 1 nem bek\xfcld\xf6tt cikket. Megszak\xedtod?","hu":"Tal\xe1ltunk 1 nem bek\xfcld\xf6tt cikket. Megszak\xedtod?","it-IT":"\xc8 presente 1 articolo non inviato, vuoi annullare?","it":"\xc8 presente 1 articolo non inviato, vuoi annullare?","ja-JP":"\u672A\u9001\u4FE1\u306E\u5546\u54C1\u304C1\u4EF6\u3042\u308A\u307E\u3059\u3002\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u304B\uFF1F","ja":"\u672A\u9001\u4FE1\u306E\u5546\u54C1\u304C1\u4EF6\u3042\u308A\u307E\u3059\u3002\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u304B\uFF1F","ko-KR":"\uC81C\uCD9C\uB418\uC9C0 \uC54A\uC740 \uC81C\uD488\uC774 1\uAC1C \uC788\uC2B5\uB2C8\uB2E4. \uCDE8\uC18C\uB97C \uC6D0\uD558\uC2DC\uB098\uC694?","ko":"\uC81C\uCD9C\uB418\uC9C0 \uC54A\uC740 \uC81C\uD488\uC774 1\uAC1C \uC788\uC2B5\uB2C8\uB2E4. \uCDE8\uC18C\uB97C \uC6D0\uD558\uC2DC\uB098\uC694?","nl-NL":"Er is 1 item niet doorgestuurd, wil je annuleren?","nl":"Er is 1 item niet doorgestuurd, wil je annuleren?","no-NO":"Det er 1 vare som ikke er sendt inn. Vil du avbryte?","pl-PL":"Nie przes\u0142ano 1 produktu, czy chcesz anulowa\u0107?","pl":"Nie przes\u0142ano 1 produktu, czy chcesz anulowa\u0107?","pt-BR":"H\xe1 1 item n\xe3o enviado. Deseja cancelar?","pt-PT":"Um artigo n\xe3o foi enviado. Pretende cancelar?","ru-RU":"\u041D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043E\u0434\u0438\u043D \u0442\u043E\u0432\u0430\u0440. \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C?","ru":"\u041D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043E\u0434\u0438\u043D \u0442\u043E\u0432\u0430\u0440. \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C?","sv-SE":"1 produkt har inte registrerats. Vill du avbryta?","sv":"1 produkt har inte registrerats. Vill du avbryta?","th-TH":"\u0E21\u0E35 1 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","th":"\u0E21\u0E35 1 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","tr-TR":"G\xf6nderilmemi\u015F 1 \xf6\u011Fe var, iptal etmek istiyor musun?","tr":"G\xf6nderilmemi\u015F 1 \xf6\u011Fe var, iptal etmek istiyor musun?"},"RL_ProductScanCancel2":{"key":"RL_ProductScanCancel2","en":"There are {{1}} un-submitted items, do you want to cancel?","ca-ES":"Hi ha {{1}} productes sense validar. Vols cancel\xb7lar-los?","ca":"Hi ha {{1}} productes sense validar. Vols cancel\xb7lar-los?","cs-CZ":"M\xe1te {{1}} neodeslan\xe9 polo\u017Eky, chcete proces zru\u0161it?","cs":"M\xe1te {{1}} neodeslan\xe9 polo\u017Eky, chcete proces zru\u0161it?","da-DK":"Der er {{1}} varer, der ikke er indsendt, vil du annullere?","da":"Der er {{1}} varer, der ikke er indsendt, vil du annullere?","de-DE":"Es gibt {{1}} nicht abgesendete Produkte, m\xf6chtest du abbrechen?","de":"Es gibt {{1}} nicht abgesendete Produkte, m\xf6chtest du abbrechen?","el-GR":"\u03A5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD {{1}} \u03B5\u03AF\u03B4\u03B7 \u03C0\u03BF\u03C5 \u03B4\u03B5\u03BD \u03AD\u03C7\u03BF\u03C5\u03BD \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF, \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B3\u03AF\u03BD\u03B5\u03B9 \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7;","el":"\u03A5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD {{1}} \u03B5\u03AF\u03B4\u03B7 \u03C0\u03BF\u03C5 \u03B4\u03B5\u03BD \u03AD\u03C7\u03BF\u03C5\u03BD \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF, \u03B8\u03AD\u03BB\u03B5\u03C4\u03B5 \u03BD\u03B1 \u03B3\u03AF\u03BD\u03B5\u03B9 \u03B1\u03BA\u03CD\u03C1\u03C9\u03C3\u03B7;","en-GB":"There are {{1}} unsubmitted items, do you want to cancel?","es-ES":"Hay {{1}} productos sin enviar. \xbfQuieres cancelarlos?","es":"Hay {{1}} productos sin enviar. \xbfQuieres cancelarlos?","fi-FI":"{{1}} tuotetta on lis\xe4\xe4m\xe4tt\xe4, haluatko peruuttaa?","fr-FR":"Il reste {{1}}\xa0articles non soumis, souhaitez-vous annuler\xa0?","fr":"Il reste {{1}}\xa0articles non soumis, souhaitez-vous annuler\xa0?","he-IL":"\u05D9\u05E9 {{1}} \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DC\u05D7\u05D5, \u05D4\u05D0\u05DD \u05DC\u05D1\u05D8\u05DC?","hr-HR":"Postoji artikli (njih {{1}}) koji nisu poslani. \u017Delite li odustati?","hu-HU":"Tal\xe1ltunk {{1}} nem bek\xfcld\xf6tt cikket. Megszak\xedtod?","hu":"Tal\xe1ltunk {{1}} nem bek\xfcld\xf6tt cikket. Megszak\xedtod?","it-IT":"Sono presenti {{1}} articoli non inviati, vuoi annullare?","it":"Sono presenti {{1}} articoli non inviati, vuoi annullare?","ja-JP":"\u672A\u9001\u4FE1\u306E\u5546\u54C1\u304C{{1}}\u4EF6\u3042\u308A\u307E\u3059\u3002\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u304B\uFF1F","ja":"\u672A\u9001\u4FE1\u306E\u5546\u54C1\u304C{{1}}\u4EF6\u3042\u308A\u307E\u3059\u3002\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3059\u304B\uFF1F","ko-KR":"\uC81C\uCD9C\uB418\uC9C0 \uC54A\uC740 \uC81C\uD488\uC774 {{1}}\uAC1C \uC788\uC2B5\uB2C8\uB2E4. \uCDE8\uC18C\uB97C \uC6D0\uD558\uC2DC\uB098\uC694?","ko":"\uC81C\uCD9C\uB418\uC9C0 \uC54A\uC740 \uC81C\uD488\uC774 {{1}}\uAC1C \uC788\uC2B5\uB2C8\uB2E4. \uCDE8\uC18C\uB97C \uC6D0\uD558\uC2DC\uB098\uC694?","nl-NL":"Er zijn {{1}} items niet doorgestuurd, wil je annuleren?","nl":"Er zijn {{1}} items niet doorgestuurd, wil je annuleren?","no-NO":"Det er {{1}} varer som ikke er sendt inn. Vil du avbryte?","pl-PL":"Produkty: {{1}} nie zosta\u0142y przes\u0142ane, czy chcesz anulowa\u0107?","pl":"Produkty: {{1}} nie zosta\u0142y przes\u0142ane, czy chcesz anulowa\u0107?","pt-BR":"H\xe1 {{1}} itens n\xe3o enviados. Deseja cancelar?","pt-PT":"{{1}} artigos n\xe3o foram enviados. Pretende cancelar?","ru-RU":"\u041D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u0442\u043E\u0432\u0430\u0440\u043E\u0432: {{1}}. \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C?","ru":"\u041D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u0442\u043E\u0432\u0430\u0440\u043E\u0432: {{1}}. \u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C?","sv-SE":"{{1}} produkter har inte registrerats. Vill du avbryta?","sv":"{{1}} produkter har inte registrerats. Vill du avbryta?","th-TH":"\u0E21\u0E35 {{1}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","th":"\u0E21\u0E35 {{1}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E2A\u0E48\u0E07 \u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E43\u0E0A\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48","tr-TR":"G\xf6nderilmemi\u015F {{1}} \xf6\u011Fe var, iptal etmek istiyor musun?","tr":"G\xf6nderilmemi\u015F {{1}} \xf6\u011Fe var, iptal etmek istiyor musun?"},"RL_ProductAddSuccess1":{"key":"RL_ProductAddSuccess1","en":"Promotion {{1}} added! Please click the \\"X\\" button to close this form.","cs-CZ":"Promoakce {{1}} byla p\u0159id\xe1na. Tenhle formul\xe1\u0159 zav\u0159ete klepnut\xedm na symbol \u201EX\u201C.","cs":"Promoakce {{1}} byla p\u0159id\xe1na. Tenhle formul\xe1\u0159 zav\u0159ete klepnut\xedm na symbol \u201EX\u201C.","da-DK":"{{1}}-kampagnen er tilf\xf8jet. Klik p\xe5 \\"X\\"-knappen for at lukke denne formular.","da":"{{1}}-kampagnen er tilf\xf8jet. Klik p\xe5 \\"X\\"-knappen for at lukke denne formular.","de-DE":"Angebot {{1}} hinzugef\xfcgt! Klicke auf die Schaltfl\xe4che \\"X\\", um dieses Formular zu schlie\xdfen.","de":"Angebot {{1}} hinzugef\xfcgt! Klicke auf die Schaltfl\xe4che \\"X\\", um dieses Formular zu schlie\xdfen.","el-GR":"\u0397 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC {{1}} \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5! \u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03CC\u03C1\u03BC\u03B1, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \\"X\\".","el":"\u0397 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC {{1}} \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5! \u0393\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03BB\u03B5\u03AF\u03C3\u03B5\u03C4\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C6\u03CC\u03C1\u03BC\u03B1, \u03BA\u03AC\u03BD\u03C4\u03B5 \u03BA\u03BB\u03B9\u03BA \u03C3\u03C4\u03BF \u03BA\u03BF\u03C5\u03BC\u03C0\u03AF \\"X\\".","en-GB":"Promotion {{1}} added! Please click the \\"X\\" button to close this form.","es-ES":"Promoci\xf3n {{1}} a\xf1adida. Haz clic en el bot\xf3n \\"X\\" para cerrar este formulario.","es":"Promoci\xf3n {{1}} a\xf1adida. Haz clic en el bot\xf3n \\"X\\" para cerrar este formulario.","fi-FI":"Tarjouskampanja {{1}} lis\xe4tty! Valitse \'X\', kun haluat sulkea lomakkeen.","fr-FR":"Promotion {{1}} ajout\xe9e\xa0! Cliquez sur le bouton \xab\xa0X\xa0\xbb pour fermer ce formulaire.","fr":"Promotion {{1}} ajout\xe9e\xa0! Cliquez sur le bouton \xab\xa0X\xa0\xbb pour fermer ce formulaire.","he-IL":"\u05D4\u05D5\u05E1\u05E4\u05EA\u05DD \u05D0\u05EA \u05D4\u05DE\u05D1\u05E6\u05E2 {{1}}! \u05DC\u05D7\u05E6\u05D5 \u05E2\u05DC \u05D4\u05DC\u05D7\u05E6\u05DF \'X\' \u05DB\u05D3\u05D9 \u05DC\u05E1\u05D2\u05D5\u05E8 \u05D0\u05EA \u05D4\u05D8\u05D5\u05E4\u05E1.","hr-HR":"Promocija {{1}} je dodana! Kliknite na gumb \u201EX\u201D za zatvaranje ovog obrasca.","hu-HU":"{{1}} prom\xf3ci\xf3 hozz\xe1adva! Az \u0171rlap bez\xe1r\xe1s\xe1hoz kattints az \u201EX\u201D gombra.","hu":"{{1}} prom\xf3ci\xf3 hozz\xe1adva! Az \u0171rlap bez\xe1r\xe1s\xe1hoz kattints az \u201EX\u201D gombra.","it-IT":"Promozione {{1}} aggiunta. Clicca sulla \\"X\\" per chiudere questo modulo.","it":"Promozione {{1}} aggiunta. Clicca sulla \\"X\\" per chiudere questo modulo.","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3{{1}}\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002 \u300CX\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u9589\u3058\u3066\u304F\u3060\u3055\u3044\u3002","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3{{1}}\u3092\u8FFD\u52A0\u3057\u307E\u3057\u305F\u3002 \u300CX\u300D\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001\u3053\u306E\u30D5\u30A9\u30FC\u30E0\u3092\u9589\u3058\u3066\u304F\u3060\u3055\u3044\u3002","ko-KR":"{{1}} \uD504\uB85C\uBAA8\uC158\uC774 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4! \uC774 \uC591\uC2DD\uC744 \uB2EB\uC73C\uB824\uBA74 \'X\' \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC138\uC694.","ko":"{{1}} \uD504\uB85C\uBAA8\uC158\uC774 \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4! \uC774 \uC591\uC2DD\uC744 \uB2EB\uC73C\uB824\uBA74 \'X\' \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC138\uC694.","nl-NL":"Promotie {{1}} toegevoegd. Klik op de \'X\' om dit formulier te sluiten.","nl":"Promotie {{1}} toegevoegd. Klik op de \'X\' om dit formulier te sluiten.","no-NO":"Kampanje {{1}} er lagt til. Klikk p\xe5 \xabX\xbb-knappen for \xe5 lukke dette skjemaet.","pl-PL":"Dodana promocja: {{1}}. Kliknij przycisk \u201EX\u201D, aby zamkn\u0105\u0107 ten formularz.","pl":"Dodana promocja: {{1}}. Kliknij przycisk \u201EX\u201D, aby zamkn\u0105\u0107 ten formularz.","pt-BR":"Promo\xe7\xe3o {{1}} adicionada! Clique no bot\xe3o \u201CX\u201D para fechar este formul\xe1rio.","pt-PT":"Promo\xe7\xe3o {{1}} adicionada! Clique no bot\xe3o \\"X\\" para fechar este formul\xe1rio.","ru-RU":"\u0410\u043A\u0446\u0438\u044F {{1}} \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430! \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 X, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u044D\u0442\u0443 \u0444\u043E\u0440\u043C\u0443.","ru":"\u0410\u043A\u0446\u0438\u044F {{1}} \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430! \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 X, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u044D\u0442\u0443 \u0444\u043E\u0440\u043C\u0443.","sv-SE":"Kampanj {{1}} har lagts till. Klicka p\xe5 knappen X f\xf6r att st\xe4nga formul\xe4ret.","sv":"Kampanj {{1}} har lagts till. Klicka p\xe5 knappen X f\xf6r att st\xe4nga formul\xe4ret.","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19 {{1}} \u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 \\"X\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19 {{1}} \u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E04\u0E25\u0E34\u0E01\u0E1B\u0E38\u0E48\u0E21 \\"X\\" \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E1B\u0E34\u0E14\u0E41\u0E1A\u0E1A\u0E1F\u0E2D\u0E23\u0E4C\u0E21\u0E19\u0E35\u0E49","tr-TR":"{{1}} promosyonu eklendi! L\xfctfen bu formu kapatmak i\xe7in \\"X\\" d\xfc\u011Fmesine t\u0131kla.","tr":"{{1}} promosyonu eklendi! L\xfctfen bu formu kapatmak i\xe7in \\"X\\" d\xfc\u011Fmesine t\u0131kla."},"RL_CodesValidation":{"key":"RL_CodesValidation","en":"Only {{1}} codes at a time.","ca-ES":"Nom\xe9s es poden introduir {{1}} codis alhora.","ca":"Nom\xe9s es poden introduir {{1}} codis alhora.","cs-CZ":"Jenom {{1}} k\xf3dy najednou.","cs":"Jenom {{1}} k\xf3dy najednou.","da-DK":"Kun {{1}} koder ad gangen.","da":"Kun {{1}} koder ad gangen.","de-DE":"Nur {{1}} Codes gleichzeitig.","de":"Nur {{1}} Codes gleichzeitig.","el-GR":"\u039C\u03CC\u03BD\u03BF {{1}} \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03C4\u03B7 \u03C6\u03BF\u03C1\u03AC.","el":"\u039C\u03CC\u03BD\u03BF {{1}} \u03BA\u03C9\u03B4\u03B9\u03BA\u03BF\u03AF \u03C4\u03B7 \u03C6\u03BF\u03C1\u03AC.","en-GB":"Only {{1}} codes at a time.","es-ES":"Solo {{1}} c\xf3digos al mismo tiempo.","es":"Solo {{1}} c\xf3digos al mismo tiempo.","fi-FI":"Vain {{1}} koodia kerrallaan.","fr-FR":"Seulement {{1}}\xa0codes \xe0 la fois.","fr":"Seulement {{1}}\xa0codes \xe0 la fois.","he-IL":"\u05E8\u05E7 {{1}} \u05E7\u05D5\u05D3\u05D9\u05DD \u05D1\u05DB\u05DC \u05E4\u05E2\u05DD.","hr-HR":"Broj \u0161ifri koji se mo\u017Ee odjednom dodati: {{1}}.","hu-HU":"Egyszerre csak {{1}} k\xf3d.","hu":"Egyszerre csak {{1}} k\xf3d.","it-IT":"Solo {{1}} codici per volta.","it":"Solo {{1}} codici per volta.","ja-JP":"\u4E00\u5EA6\u306B\u4F7F\u7528\u3067\u304D\u308B\u30B3\u30FC\u30C9\u306F{{1}}\u4EF6\u306E\u307F\u3067\u3059\u3002","ja":"\u4E00\u5EA6\u306B\u4F7F\u7528\u3067\u304D\u308B\u30B3\u30FC\u30C9\u306F{{1}}\u4EF6\u306E\u307F\u3067\u3059\u3002","ko-KR":"\uD55C \uBC88\uC5D0 {{1}}\uAC1C \uCF54\uB4DC\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","ko":"\uD55C \uBC88\uC5D0 {{1}}\uAC1C \uCF54\uB4DC\uB9CC \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.","nl-NL":"Slechts {{1}} codes tegelijk.","nl":"Slechts {{1}} codes tegelijk.","no-NO":"Bare {{1}} koder om gangen.","pl-PL":"Kody do wpisania jednocze\u015Bnie: {{1}}.","pl":"Kody do wpisania jednocze\u015Bnie: {{1}}.","pt-BR":"Somente {{1}} c\xf3digos por vez.","pt-PT":"Apenas {{1}} c\xf3digos de cada vez.","ru-RU":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043A\u043E\u0434\u043E\u0432 \u0437\u0430 \u0440\u0430\u0437: {{1}}.","ru":"\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043A\u043E\u0434\u043E\u0432 \u0437\u0430 \u0440\u0430\u0437: {{1}}.","sv-SE":"Endast {{1}} koder samtidigt.","sv":"Endast {{1}} koder samtidigt.","th-TH":"\u0E43\u0E0A\u0E49 {{1}} \u0E42\u0E04\u0E49\u0E14\u0E15\u0E48\u0E2D\u0E04\u0E23\u0E31\u0E49\u0E07\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","th":"\u0E43\u0E0A\u0E49 {{1}} \u0E42\u0E04\u0E49\u0E14\u0E15\u0E48\u0E2D\u0E04\u0E23\u0E31\u0E49\u0E07\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","tr-TR":"Tek seferde yaln\u0131zca {{1}} kod kullan\u0131labilir.","tr":"Tek seferde yaln\u0131zca {{1}} kod kullan\u0131labilir."},"RL_GTINValidation":{"key":"RL_GTINValidation","en":"GTIN must be 14 digits.","ca-ES":"El GTIN ha de tenir 14\xa0d\xedgits.","ca":"El GTIN ha de tenir 14\xa0d\xedgits.","cs-CZ":"GTIN mus\xed m\xedt 14 \u010D\xedslic.","cs":"GTIN mus\xed m\xedt 14 \u010D\xedslic.","da-DK":"GTIN skal indeholde 14 cifre.","da":"GTIN skal indeholde 14 cifre.","de-DE":"GTIN muss 14-stellig sein.","de":"GTIN muss 14-stellig sein.","el-GR":"\u03A4\u03BF GTIN \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC 14 \u03C8\u03B7\u03C6\u03AF\u03B1.","el":"\u03A4\u03BF GTIN \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC 14 \u03C8\u03B7\u03C6\u03AF\u03B1.","en-GB":"GTIN must be 14 digits.","es-ES":"El GTIN debe tener 14\xa0d\xedgitos.","es":"El GTIN debe tener 14\xa0d\xedgitos.","fi-FI":"GTIN:n on oltava 14 merkin pituinen.","fr-FR":"Le num\xe9ro GTIN doit contenir 14\xa0chiffres.","fr":"Le num\xe9ro GTIN doit contenir 14\xa0chiffres.","he-IL":"GTIN \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05D9\u05D5\u05EA \u05D1\u05D0\u05D5\u05E8\u05DA 14 \u05E1\u05E4\u05E8\u05D5\u05EA.","hr-HR":"GTIN mora sadr\u017Eavati 14 znamenki.","hu-HU":"A GTIN 14 sz\xe1mjegy hossz\xfas\xe1g\xfa kell, hogy legyen.","hu":"A GTIN 14 sz\xe1mjegy hossz\xfas\xe1g\xfa kell, hogy legyen.","it-IT":"GTIN deve contenere 14 cifre.","it":"GTIN deve contenere 14 cifre.","ja-JP":"GTIN\u306F14\u6841\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ja":"GTIN\u306F14\u6841\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ko-KR":"GTIN\uC740 14\uC790\uB9AC \uC22B\uC790\uB85C \uC785\uB825\uD574\uC57C \uD569\uB2C8\uB2E4.","ko":"GTIN\uC740 14\uC790\uB9AC \uC22B\uC790\uB85C \uC785\uB825\uD574\uC57C \uD569\uB2C8\uB2E4.","nl-NL":"GTIN moet 14 cijfers zijn.","nl":"GTIN moet 14 cijfers zijn.","no-NO":"GTIN m\xe5 inneholde 14 sifre.","pl-PL":"Kod GTIN musi zawiera\u0107 14 cyfr.","pl":"Kod GTIN musi zawiera\u0107 14 cyfr.","pt-BR":"O GTIN deve ter 14 d\xedgitos.","pt-PT":"O GTIN tem de ter 14 d\xedgitos.","ru-RU":"\u041D\u043E\u043C\u0435\u0440 GTIN \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 14 \u0446\u0438\u0444\u0440.","ru":"\u041D\u043E\u043C\u0435\u0440 GTIN \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 14 \u0446\u0438\u0444\u0440.","sv-SE":"GTIN m\xe5ste inneh\xe5lla 14 siffror.","sv":"GTIN m\xe5ste inneh\xe5lla 14 siffror.","th-TH":"GTIN \u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35 14 \u0E2B\u0E25\u0E31\u0E01","th":"GTIN \u0E15\u0E49\u0E2D\u0E07\u0E21\u0E35 14 \u0E2B\u0E25\u0E31\u0E01","tr-TR":"GTIN, 14 haneli olmal\u0131d\u0131r.","tr":"GTIN, 14 haneli olmal\u0131d\u0131r."},"RL_StyleColorValidation":{"key":"RL_StyleColorValidation","en":"Style Color must be 5 or 6 alphanumeric values, hyphen, 3 alphanumeric values.","ca-ES":"El color del model ha de tenir cinc o sis valors alfanum\xe8rics, un guionet i tres valors alfanum\xe8rics.","ca":"El color del model ha de tenir cinc o sis valors alfanum\xe8rics, un guionet i tres valors alfanum\xe8rics.","cs-CZ":"Barva modelu mus\xed obsahovat 5 nebo 6 alfanumerick\xfdch znak\u016F, spojovn\xedk, 3 alfanumerick\xe9 znaky.","cs":"Barva modelu mus\xed obsahovat 5 nebo 6 alfanumerick\xfdch znak\u016F, spojovn\xedk, 3 alfanumerick\xe9 znaky.","da-DK":"Modelfarven skal v\xe6re 5 eller 6 alfanumeriske tegn, bindestreg, 3 alfanumeriske tegn.","da":"Modelfarven skal v\xe6re 5 eller 6 alfanumeriske tegn, bindestreg, 3 alfanumeriske tegn.","de-DE":"Die Style-Farbe darf nur aus f\xfcnf oder sechs alphanumerischen Werten, Bindestrich, drei alphanumerischen Werten bestehen.","de":"Die Style-Farbe darf nur aus f\xfcnf oder sechs alphanumerischen Werten, Bindestrich, drei alphanumerischen Werten bestehen.","el-GR":"\u03A4\u03BF \u03C3\u03C4\u03B9\u03BB \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC 5 \u03AE 6 \u03B1\u03BB\u03C6\u03B1\u03C1\u03B9\u03B8\u03BC\u03B7\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C4\u03B9\u03BC\u03AD\u03C2, \u03B5\u03BD\u03C9\u03C4\u03B9\u03BA\u03CC, 3 \u03B1\u03BB\u03C6\u03B1\u03C1\u03B9\u03B8\u03BC\u03B7\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C4\u03B9\u03BC\u03AD\u03C2.","el":"\u03A4\u03BF \u03C3\u03C4\u03B9\u03BB \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03B5\u03AF\u03C4\u03B1\u03B9 \u03B1\u03C0\u03CC 5 \u03AE 6 \u03B1\u03BB\u03C6\u03B1\u03C1\u03B9\u03B8\u03BC\u03B7\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C4\u03B9\u03BC\u03AD\u03C2, \u03B5\u03BD\u03C9\u03C4\u03B9\u03BA\u03CC, 3 \u03B1\u03BB\u03C6\u03B1\u03C1\u03B9\u03B8\u03BC\u03B7\u03C4\u03B9\u03BA\u03AD\u03C2 \u03C4\u03B9\u03BC\u03AD\u03C2.","en-GB":"Style Colour must be 5 or 6 alphanumeric characters, hyphen, 3 alphanumeric characters.","es-ES":"El color del modelo debe tener 5 o 6 valores alfanum\xe9ricos, un guion y 3 valores alfanum\xe9ricos.","es":"El color del modelo debe tener 5 o 6 valores alfanum\xe9ricos, un guion y 3 valores alfanum\xe9ricos.","fi-FI":"Tyylin v\xe4rin on oltava viisi tai kuusi aakkosnumeerista arvoa, yhdysviiva ja kolme aakkosnumeerista arvoa.","fr-FR":"Le Style-Coloris se compose de 5 ou 6\xa0caract\xe8res alphanum\xe9riques suivis d\'un tiret et de 3\xa0caract\xe8res alphanum\xe9riques.","fr":"Le Style-Coloris se compose de 5 ou 6\xa0caract\xe8res alphanum\xe9riques suivis d\'un tiret et de 3\xa0caract\xe8res alphanum\xe9riques.","he-IL":"\u05E1\u05D2\u05E0\u05D5\u05DF-\u05E6\u05D1\u05E2 \u05D7\u05D9\u05D9\u05D1 \u05DC\u05D4\u05DB\u05D9\u05DC 5 \u05D0\u05D5 6 \u05E2\u05E8\u05DB\u05D9\u05DD \u05D0\u05DC\u05E4\u05D0\u05E0\u05D5\u05DE\u05E8\u05D9\u05D9\u05DD, \u05DE\u05E7\u05E3, 3 \u05E2\u05E8\u05DB\u05D9\u05DD \u05D0\u05DC\u05E4\u05D0\u05E0\u05D5\u05DE\u05E8\u05D9\u05D9\u05DD.","hr-HR":"Model/boja mora sadr\u017Eavati 5 ili 6 alfanumeri\u010Dkih vrijednosti, crticu, 3 alfanumeri\u010Dke vrijednosti.","hu-HU":"A Style Color helyes form\xe1tuma: 5 vagy 6 alfanumerikus \xe9rt\xe9k, k\xf6t\u0151jel, 3 alfanumerikus \xe9rt\xe9k.","hu":"A Style Color helyes form\xe1tuma: 5 vagy 6 alfanumerikus \xe9rt\xe9k, k\xf6t\u0151jel, 3 alfanumerikus \xe9rt\xe9k.","it-IT":"Il colore del modello deve contenere 5 o 6 caratteri alfanumerici, trattino, 3 caratteri alfanumerici.","it":"Il colore del modello deve contenere 5 o 6 caratteri alfanumerici, trattino, 3 caratteri alfanumerici.","ja-JP":"\u30B9\u30BF\u30A4\u30EB \u30AB\u30E9\u30FC\u306F\u30015\u307E\u305F\u306F6\u3064\u306E\u82F1\u6570\u5B57\u3001\u30CF\u30A4\u30D5\u30F3\u30013\u3064\u306E\u82F1\u6570\u5B57\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ja":"\u30B9\u30BF\u30A4\u30EB \u30AB\u30E9\u30FC\u306F\u30015\u307E\u305F\u306F6\u3064\u306E\u82F1\u6570\u5B57\u3001\u30CF\u30A4\u30D5\u30F3\u30013\u3064\u306E\u82F1\u6570\u5B57\u306B\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ko-KR":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uB294 \uC601\uC22B\uC790 5~6\uC790, \uD558\uC774\uD508, \uC601\uC22B\uC790 3\uC790\uB85C\uB9CC \uC774\uB8E8\uC5B4\uC838\uC57C \uD569\uB2C8\uB2E4.","ko":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uB294 \uC601\uC22B\uC790 5~6\uC790, \uD558\uC774\uD508, \uC601\uC22B\uC790 3\uC790\uB85C\uB9CC \uC774\uB8E8\uC5B4\uC838\uC57C \uD569\uB2C8\uB2E4.","nl-NL":"Stijlkleur moet bestaan uit 5 of 6 alfanumerieke tekens, koppelteken, 3 alfanumerieke tekens.","nl":"Stijlkleur moet bestaan uit 5 of 6 alfanumerieke tekens, koppelteken, 3 alfanumerieke tekens.","no-NO":"Produktfarge m\xe5 v\xe6re 5 eller 6 alfanumeriske verdier, bindestrek, 3 alfanumeriske verdier.","pl-PL":"Model/kolor musi mie\u0107 5 lub 6 znak\xf3w alfanumerycznych, \u0142\u0105cznik, 3 znaki alfanumeryczne.","pl":"Model/kolor musi mie\u0107 5 lub 6 znak\xf3w alfanumerycznych, \u0142\u0105cznik, 3 znaki alfanumeryczne.","pt-BR":"A cor do estilo deve ter 5 ou 6 valores alfanum\xe9ricos, h\xedfen e 3 valores alfanum\xe9ricos.","pt-PT":"O estilo-cor tem de ter cinco ou seis valores alfanum\xe9ricos, um h\xedfen e tr\xeas valores alfanum\xe9ricos.","ru-RU":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0446\u0432\u0435\u0442\u0430 \u043C\u043E\u0434\u0435\u043B\u0438 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 5 \u0438\u043B\u0438 6 \u0431\u0443\u043A\u0432 \u0438\u043B\u0438 \u0446\u0438\u0444\u0440, \u0434\u0435\u0444\u0438\u0441\u0430 \u0438 3 \u0431\u0443\u043A\u0432 \u0438\u043B\u0438 \u0446\u0438\u0444\u0440.","ru":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0446\u0432\u0435\u0442\u0430 \u043C\u043E\u0434\u0435\u043B\u0438 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0438\u0437 5 \u0438\u043B\u0438 6 \u0431\u0443\u043A\u0432 \u0438\u043B\u0438 \u0446\u0438\u0444\u0440, \u0434\u0435\u0444\u0438\u0441\u0430 \u0438 3 \u0431\u0443\u043A\u0432 \u0438\u043B\u0438 \u0446\u0438\u0444\u0440.","sv-SE":"Modellf\xe4rgen m\xe5ste ha 5 eller 6 alfanumeriska tecken, bindestreck, 3 alfanumeriska tecken.","sv":"Modellf\xe4rgen m\xe5ste ha 5 eller 6 alfanumeriska tecken, bindestreck, 3 alfanumeriska tecken.","th-TH":"\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 5 \u0E2B\u0E23\u0E37\u0E2D 6 \u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30, \u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E02\u0E35\u0E14, \u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 3 \u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30","th":"\u0E2A\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E15\u0E49\u0E2D\u0E07\u0E1B\u0E23\u0E30\u0E01\u0E2D\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 5 \u0E2B\u0E23\u0E37\u0E2D 6 \u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30, \u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2B\u0E21\u0E32\u0E22\u0E02\u0E35\u0E14, \u0E15\u0E31\u0E27\u0E40\u0E25\u0E02\u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E2D\u0E31\u0E01\u0E29\u0E23 3 \u0E2D\u0E31\u0E01\u0E02\u0E23\u0E30","tr-TR":"Stil/Renk; 5 veya 6 alfasay\u0131sal de\u011Fer, tire ve 3 alfasay\u0131sal de\u011Ferden olu\u015Fmal\u0131d\u0131r.","tr":"Stil/Renk; 5 veya 6 alfasay\u0131sal de\u011Fer, tire ve 3 alfasay\u0131sal de\u011Ferden olu\u015Fmal\u0131d\u0131r."},"RL_MoreInformation":{"key":"RL_MoreInformation","en":"More Information","ca-ES":"M\xe9s informaci\xf3","ca":"M\xe9s informaci\xf3","cs-CZ":"Dal\u0161\xed informace","cs":"Dal\u0161\xed informace","da-DK":"Flere oplysninger","da":"Flere oplysninger","de-DE":"Weitere Informationen","de":"Weitere Informationen","el-GR":"\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2","el":"\u03A0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B5\u03C2 \u03C0\u03BB\u03B7\u03C1\u03BF\u03C6\u03BF\u03C1\u03AF\u03B5\u03C2","en-GB":"More Information","es-ES":"M\xe1s informaci\xf3n","es":"M\xe1s informaci\xf3n","fi-FI":"Lis\xe4tietoja","fr-FR":"Plus d\'informations","fr":"Plus d\'informations","he-IL":"\u05DE\u05D9\u05D3\u05E2 \u05E0\u05D5\u05E1\u05E3","hr-HR":"Dodatne informacije","hu-HU":"Tov\xe1bbi inform\xe1ci\xf3k","hu":"Tov\xe1bbi inform\xe1ci\xf3k","it-IT":"Ulteriori informazioni","it":"Ulteriori informazioni","ja-JP":"\u8A73\u7D30\u3092\u898B\u308B","ja":"\u8A73\u7D30\u3092\u898B\u308B","ko-KR":"\uC790\uC138\uD788 \uBCF4\uAE30","ko":"\uC790\uC138\uD788 \uBCF4\uAE30","nl-NL":"Meer info","nl":"Meer info","no-NO":"Mer informasjon","pl-PL":"Wi\u0119cej informacji","pl":"Wi\u0119cej informacji","pt-BR":"Mais informa\xe7\xf5es","pt-PT":"Mais informa\xe7\xf5es","ru-RU":"\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435","ru":"\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435","sv-SE":"Mer information","sv":"Mer information","th-TH":"\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21","th":"\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21","tr-TR":"Daha Fazla Bilgi","tr":"Daha Fazla Bilgi"},"RL_ScannerError":{"key":"RL_ScannerError","en":"Scanner Error: {{1}}","ca-ES":"Error de l\'esc\xe0ner: {{1}}","ca":"Error de l\'esc\xe0ner: {{1}}","cs-CZ":"Chyba skeneru: {{1}}","cs":"Chyba skeneru: {{1}}","da-DK":"Scannerfejl: {{1}}","da":"Scannerfejl: {{1}}","de-DE":"Scannerfehler: {{1}}","de":"Scannerfehler: {{1}}","el-GR":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03C3\u03B1\u03C1\u03C9\u03C4\u03AE: {{1}}","el":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03C3\u03B1\u03C1\u03C9\u03C4\u03AE: {{1}}","en-GB":"Scanner Error: {{1}}","es-ES":"Error de esc\xe1ner: {{1}}","es":"Error de esc\xe1ner: {{1}}","fi-FI":"Skannerin virhe: {{1}}","fr-FR":"Erreur scanner\xa0: {{1}}","fr":"Erreur scanner\xa0: {{1}}","he-IL":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05E1\u05D5\u05E8\u05E7: {{1}}","hr-HR":"Pogre\u0161ka skenera: {{1}}","hu-HU":"Beolvas\xe1si hiba: {{1}}","hu":"Beolvas\xe1si hiba: {{1}}","it-IT":"Errore scanner: {{1}}","it":"Errore scanner: {{1}}","ja-JP":"\u30B9\u30AD\u30E3\u30CA\u30FC\u306E\u30A8\u30E9\u30FC\uFF1A{{1}}","ja":"\u30B9\u30AD\u30E3\u30CA\u30FC\u306E\u30A8\u30E9\u30FC\uFF1A{{1}}","ko-KR":"\uC2A4\uCE90\uB108 \uC624\uB958: {{1}}","ko":"\uC2A4\uCE90\uB108 \uC624\uB958: {{1}}","nl-NL":"Scannerfout: {{1}}","nl":"Scannerfout: {{1}}","no-NO":"Skannerfeil: {{1}}","pl-PL":"B\u0142\u0105d skanera: {{1}}","pl":"B\u0142\u0105d skanera: {{1}}","pt-BR":"Erro do escaneamento: {{1}}","pt-PT":"Erro do leitor: {{1}}","ru-RU":"\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043A\u0430\u043D\u0435\u0440\u0430: {{1}}","ru":"\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u043A\u0430\u043D\u0435\u0440\u0430: {{1}}","sv-SE":"Skannerfel: {{1}}","sv":"Skannerfel: {{1}}","th-TH":"\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2A\u0E41\u0E01\u0E19\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14: {{1}}","th":"\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2A\u0E41\u0E01\u0E19\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14: {{1}}","tr-TR":"Taray\u0131c\u0131 Hatas\u0131: {{1}}","tr":"Taray\u0131c\u0131 Hatas\u0131: {{1}}"},"RL_ProductAddSuccess3":{"key":"RL_ProductAddSuccess3","en":"1 product has been added successfully.","ca-ES":"S\'ha afegit un producte correctament.","ca":"S\'ha afegit un producte correctament.","cs-CZ":"1 produkt byl \xfasp\u011B\u0161n\u011B p\u0159id\xe1n.","cs":"1 produkt byl \xfasp\u011B\u0161n\u011B p\u0159id\xe1n.","da-DK":"1 produkt er blevet tilf\xf8jet.","da":"1 produkt er blevet tilf\xf8jet.","de-DE":"Ein Produkt wurde erfolgreich hinzugef\xfcgt.","de":"Ein Produkt wurde erfolgreich hinzugef\xfcgt.","el-GR":"1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1.","el":"1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B5 \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1.","en-GB":"1 product has been added successfully.","es-ES":"Se ha a\xf1adido un producto correctamente.","es":"Se ha a\xf1adido un producto correctamente.","fi-FI":"Yksi tuote on lis\xe4tty.","fr-FR":"1\xa0produit a \xe9t\xe9 ajout\xe9 avec succ\xe8s.","fr":"1\xa0produit a \xe9t\xe9 ajout\xe9 avec succ\xe8s.","he-IL":"\u05DE\u05D5\u05E6\u05E8 1 \u05E0\u05D5\u05E1\u05E3 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4.","hr-HR":"Jedan je proizvod uspje\u0161no dodan.","hu-HU":"1 term\xe9k hozz\xe1ad\xe1sa sikeres volt.","hu":"1 term\xe9k hozz\xe1ad\xe1sa sikeres volt.","it-IT":"1 prodotto \xe8 stato aggiunto.","it":"1 prodotto \xe8 stato aggiunto.","ja-JP":"1\u4EF6\u306E\u5546\u54C1\u304C\u6B63\u5E38\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002","ja":"1\u4EF6\u306E\u5546\u54C1\u304C\u6B63\u5E38\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002","ko-KR":"1\uAC1C \uC81C\uD488\uC774 \uC131\uACF5\uC801\uC73C\uB85C \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","ko":"1\uAC1C \uC81C\uD488\uC774 \uC131\uACF5\uC801\uC73C\uB85C \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","nl-NL":"Er is 1 product toegevoegd.","nl":"Er is 1 product toegevoegd.","no-NO":"1 produkt er lagt til.","pl-PL":"Dodano 1 produkt.","pl":"Dodano 1 produkt.","pt-BR":"1 produto adicionado.","pt-PT":"Foi adicionado um produto com sucesso.","ru-RU":"\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u043E\u0434\u0438\u043D \u0442\u043E\u0432\u0430\u0440.","ru":"\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u043E\u0434\u0438\u043D \u0442\u043E\u0432\u0430\u0440.","sv-SE":"1 produkt har lagts till.","sv":"1 produkt har lagts till.","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 1 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 1 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27","tr-TR":"1 \xfcr\xfcn ba\u015Far\u0131yla eklendi.","tr":"1 \xfcr\xfcn ba\u015Far\u0131yla eklendi."},"RL_ProductAddSuccess4":{"key":"RL_ProductAddSuccess4","en":"{{1}} products have been added successfully.","ca-ES":"S\'han afegit {{1}} productes correctament.","ca":"S\'han afegit {{1}} productes correctament.","cs-CZ":"{{1}} produkty byly \xfasp\u011B\u0161n\u011B p\u0159id\xe1ny.","cs":"{{1}} produkty byly \xfasp\u011B\u0161n\u011B p\u0159id\xe1ny.","da-DK":"{{1}} produkter er blevet tilf\xf8jet.","da":"{{1}} produkter er blevet tilf\xf8jet.","de-DE":"{{1}} Produkte wurden erfolgreich hinzugef\xfcgt.","de":"{{1}} Produkte wurden erfolgreich hinzugef\xfcgt.","el-GR":"{{1}} \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1.","el":"{{1}} \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1 \u03C0\u03C1\u03BF\u03C3\u03C4\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1.","en-GB":"{{1}} products have been added successfully.","es-ES":"Se han a\xf1adido {{1}} productos correctamente.","es":"Se han a\xf1adido {{1}} productos correctamente.","fi-FI":"{{1}} tuotetta on lis\xe4tty.","fr-FR":"{{1}}\xa0produits ont \xe9t\xe9 ajout\xe9s avec succ\xe8s.","fr":"{{1}}\xa0produits ont \xe9t\xe9 ajout\xe9s avec succ\xe8s.","he-IL":"{{1}} \u05DE\u05D5\u05E6\u05E8\u05D9\u05DD \u05E0\u05D5\u05E1\u05E4\u05D5 \u05D1\u05D4\u05E6\u05DC\u05D7\u05D4.","hr-HR":"Proizvodi (njih {{1}}) uspje\u0161no su dodani.","hu-HU":"{{1}} term\xe9k hozz\xe1ad\xe1sa sikeres volt.","hu":"{{1}} term\xe9k hozz\xe1ad\xe1sa sikeres volt.","it-IT":"{{1}} prodotti sono stati aggiunti.","it":"{{1}} prodotti sono stati aggiunti.","ja-JP":"{{1}}\u4EF6\u306E\u5546\u54C1\u304C\u6B63\u5E38\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002","ja":"{{1}}\u4EF6\u306E\u5546\u54C1\u304C\u6B63\u5E38\u306B\u8FFD\u52A0\u3055\u308C\u307E\u3057\u305F\u3002","ko-KR":"{{1}}\uAC1C \uC81C\uD488\uC774 \uC131\uACF5\uC801\uC73C\uB85C \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","ko":"{{1}}\uAC1C \uC81C\uD488\uC774 \uC131\uACF5\uC801\uC73C\uB85C \uCD94\uAC00\uB418\uC5C8\uC2B5\uB2C8\uB2E4.","nl-NL":"Er zijn {{1}} producten toegevoegd.","nl":"Er zijn {{1}} producten toegevoegd.","no-NO":"{{1}} produkter er lagt til.","pl-PL":"Dodano produkty: {{1}}.","pl":"Dodano produkty: {{1}}.","pt-BR":"{{1}} produtos adicionados.","pt-PT":"Foram adicionados {{1}} produtos com sucesso.","ru-RU":"\u0422\u043E\u0432\u0430\u0440\u043E\u0432 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E: {{1}}","ru":"\u0422\u043E\u0432\u0430\u0440\u043E\u0432 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u043E: {{1}}","sv-SE":"{{1}} produkter har lagts till.","sv":"{{1}} produkter har lagts till.","th-TH":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 {{1}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27","th":"\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 {{1}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E41\u0E25\u0E49\u0E27","tr-TR":"{{1}} \xfcr\xfcn ba\u015Far\u0131yla eklendi.","tr":"{{1}} \xfcr\xfcn ba\u015Far\u0131yla eklendi."},"RL_ProductAddError1":{"key":"RL_ProductAddError1","en":"1 product failed to add: {{1}}","ca-ES":"No s\'ha pogut afegir un producte: {{1}}","ca":"No s\'ha pogut afegir un producte: {{1}}","cs-CZ":"1 produkt se nepoda\u0159ilo p\u0159idat: {{1}}","cs":"1 produkt se nepoda\u0159ilo p\u0159idat: {{1}}","da-DK":"1 produkt blev ikke tilf\xf8jet: {{1}}","da":"1 produkt blev ikke tilf\xf8jet: {{1}}","de-DE":"Ein Produkt konnte nicht hinzugef\xfcgt werden: {{1}}","de":"Ein Produkt konnte nicht hinzugef\xfcgt werden: {{1}}","el-GR":"\u0394\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2: {{1}}","el":"\u0394\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 1 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03BF\u03C2: {{1}}","en-GB":"1 product failed to add: {{1}}","es-ES":"Se ha producido un error al a\xf1adir 1 producto: {{1}}","es":"Se ha producido un error al a\xf1adir 1 producto: {{1}}","fi-FI":"Yht\xe4 tuotetta ei voitu lis\xe4t\xe4: {{1}}","fr-FR":"1\xa0produit n\'a pas pu \xeatre ajout\xe9\xa0: {{1}}","fr":"1\xa0produit n\'a pas pu \xeatre ajout\xe9\xa0: {{1}}","he-IL":"\u05E0\u05DB\u05E9\u05DC\u05D4 \u05D4\u05D5\u05E1\u05E4\u05D4 \u05E9\u05DC \u05DE\u05D5\u05E6\u05E8 1: {{1}}","hr-HR":"Dodavanje jednog proizvoda nije uspjelo: {{1}}","hu-HU":"1 term\xe9k hozz\xe1ad\xe1sa nem siker\xfclt: {{1}}","hu":"1 term\xe9k hozz\xe1ad\xe1sa nem siker\xfclt: {{1}}","it-IT":"Impossibile aggiungere 1 prodotto: {{1}}","it":"Impossibile aggiungere 1 prodotto: {{1}}","ja-JP":"1\u4EF6\u306E\u5546\u54C1\u306E\u8FFD\u52A0\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A{{1}}","ja":"1\u4EF6\u306E\u5546\u54C1\u306E\u8FFD\u52A0\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A{{1}}","ko-KR":"1\uAC1C \uC81C\uD488 \uCD94\uAC00 \uC2E4\uD328: {{1}}","ko":"1\uAC1C \uC81C\uD488 \uCD94\uAC00 \uC2E4\uD328: {{1}}","nl-NL":"1 product is niet toegevoegd: {{1}}","nl":"1 product is niet toegevoegd: {{1}}","no-NO":"1 produkt kunne ikke legges til: {{1}}","pl-PL":"Nie uda\u0142o si\u0119 doda\u0107 1 produktu: {{1}}","pl":"Nie uda\u0142o si\u0119 doda\u0107 1 produktu: {{1}}","pt-BR":"Falha ao adicionar 1 produto: {{1}}","pt-PT":"Falha ao adicionar um produto: {{1}}","ru-RU":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043E\u0434\u0438\u043D \u0442\u043E\u0432\u0430\u0440: {{1}}","ru":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043E\u0434\u0438\u043D \u0442\u043E\u0432\u0430\u0440: {{1}}","sv-SE":"1 produkt har inte lagts till.: {{1}}","sv":"1 produkt har inte lagts till.: {{1}}","th-TH":"\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 1 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23: {{1}}","th":"\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 1 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23: {{1}}","tr-TR":"1 \xfcr\xfcn eklenemedi: {{1}}","tr":"1 \xfcr\xfcn eklenemedi: {{1}}"},"RL_ProductAddError2":{"key":"RL_ProductAddError2","en":"{{1}} products failed to add: {{2}}","ca-ES":"No s\'han pogut afegir {{1}} productes: {{2}}","ca":"No s\'han pogut afegir {{1}} productes: {{2}}","cs-CZ":"{{1}} produkty se nepoda\u0159ilo p\u0159idat: {{2}}","cs":"{{1}} produkty se nepoda\u0159ilo p\u0159idat: {{2}}","da-DK":"{{1}} produkter blev ikke tilf\xf8jet: {{2}}","da":"{{1}} produkter blev ikke tilf\xf8jet: {{2}}","de-DE":"{{1}} Produkte konnten nicht hinzugef\xfcgt werden: {{2}}","de":"{{1}} Produkte konnten nicht hinzugef\xfcgt werden: {{2}}","el-GR":"\u0394\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 {{1}} \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD: {{2}}","el":"\u0394\u03B5\u03BD \u03AE\u03C4\u03B1\u03BD \u03B4\u03C5\u03BD\u03B1\u03C4\u03AE \u03B7 \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 {{1}} \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD: {{2}}","en-GB":"{{1}} products failed to add: {{2}}","es-ES":"Se ha producido un error al a\xf1adir {{1}} productos: {{2}}","es":"Se ha producido un error al a\xf1adir {{1}} productos: {{2}}","fi-FI":"{{1}} tuotetta ei voitu lis\xe4t\xe4: {{2}}","fr-FR":"{{1}}\xa0produits n\'ont pas pu \xeatre ajout\xe9s\xa0: {{2}}","fr":"{{1}}\xa0produits n\'ont pas pu \xeatre ajout\xe9s\xa0: {{2}}","he-IL":"\u05E0\u05DB\u05E9\u05DC\u05D4 \u05D4\u05D5\u05E1\u05E4\u05D4 \u05E9\u05DC {{1}} \u05DE\u05D5\u05E6\u05E8\u05D9\u05DD: {{2}}","hr-HR":"Dodavanje {{1}} proizvoda nije uspjelo: {{2}}","hu-HU":"{{1}} term\xe9k hozz\xe1ad\xe1sa nem siker\xfclt: {{2}}","hu":"{{1}} term\xe9k hozz\xe1ad\xe1sa nem siker\xfclt: {{2}}","it-IT":"Impossibile aggiungere {{1}} prodotti: {{2}}","it":"Impossibile aggiungere {{1}} prodotti: {{2}}","ja-JP":"{{1}}\u4EF6\u306E\u5546\u54C1\u306E\u8FFD\u52A0\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A{{2}}","ja":"{{1}}\u4EF6\u306E\u5546\u54C1\u306E\u8FFD\u52A0\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A{{2}}","ko-KR":"{{1}}\uAC1C \uC81C\uD488 \uCD94\uAC00 \uC2E4\uD328: {{2}}","ko":"{{1}}\uAC1C \uC81C\uD488 \uCD94\uAC00 \uC2E4\uD328: {{2}}","nl-NL":"{{1}} producten zijn niet toegevoegd: {{2}}","nl":"{{1}} producten zijn niet toegevoegd: {{2}}","no-NO":"{{1}} produkter kunne ikke legges til: {{2}}","pl-PL":"Nie uda\u0142o si\u0119 doda\u0107 produkt\xf3w: {{1}}: {{2}}","pl":"Nie uda\u0142o si\u0119 doda\u0107 produkt\xf3w: {{1}}: {{2}}","pt-BR":"Falha ao adicionar {{1}} produtos: {{2}}","pt-PT":"Falha ao adicionar {{1}} produtos: {{2}}","ru-RU":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0442\u043E\u0432\u0430\u0440\u043E\u0432 ({{1}}): {{2}}","ru":"\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0442\u043E\u0432\u0430\u0440\u043E\u0432 ({{1}}): {{2}}","sv-SE":"{{1}} produkter har inte lagts till.: {{2}}","sv":"{{1}} produkter har inte lagts till.: {{2}}","th-TH":"\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 {{1}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23: {{2}}","th":"\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 {{1}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23: {{2}}","tr-TR":"{{1}} \xfcr\xfcn eklenemedi: {{2}}","tr":"{{1}} \xfcr\xfcn eklenemedi: {{2}}"},"RL_ProductAddError3":{"key":"RL_ProductAddError3","en":"You do not have permission to perform this action","ca-ES":"No tens perm\xeds per dur a terme aquesta acci\xf3","ca":"No tens perm\xeds per dur a terme aquesta acci\xf3","cs-CZ":"K\xa0proveden\xed t\xe9hle akce nem\xe1te opr\xe1vn\u011Bn\xed","cs":"K\xa0proveden\xed t\xe9hle akce nem\xe1te opr\xe1vn\u011Bn\xed","da-DK":"Du har ikke tilladelse til at udf\xf8re denne handling","da":"Du har ikke tilladelse til at udf\xf8re denne handling","de-DE":"Du hast keine Berechtigung, diese Aktion auszuf\xfchren.","de":"Du hast keine Berechtigung, diese Aktion auszuf\xfchren.","el-GR":"\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B4\u03B9\u03BA\u03B1\u03B9\u03CE\u03BC\u03B1\u03C4\u03B1 \u03B5\u03BA\u03C4\u03AD\u03BB\u03B5\u03C3\u03B7\u03C2 \u03B1\u03C5\u03C4\u03AE\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B1\u03C2.","el":"\u0394\u03B5\u03BD \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B4\u03B9\u03BA\u03B1\u03B9\u03CE\u03BC\u03B1\u03C4\u03B1 \u03B5\u03BA\u03C4\u03AD\u03BB\u03B5\u03C3\u03B7\u03C2 \u03B1\u03C5\u03C4\u03AE\u03C2 \u03C4\u03B7\u03C2 \u03B5\u03BD\u03AD\u03C1\u03B3\u03B5\u03B9\u03B1\u03C2.","en-GB":"You do not have permission to perform this action","es-ES":"No tienes permiso para llevar a cabo esta acci\xf3n.","es":"No tienes permiso para llevar a cabo esta acci\xf3n.","fi-FI":"Sinulla ei ole oikeutta suorittaa t\xe4t\xe4 toimintoa","fr-FR":"Vous n\'avez pas l\'autorisation d\'ex\xe9cuter cette action","fr":"Vous n\'avez pas l\'autorisation d\'ex\xe9cuter cette action","he-IL":"\u05D0\u05D9\u05DF \u05DC\u05DA \u05D4\u05E8\u05E9\u05D0\u05D4 \u05DC\u05D1\u05E6\u05E2 \u05E4\u05E2\u05D5\u05DC\u05D4 \u05D6\u05D5","hr-HR":"Nemate dozvolu za izvo\u0111enje ove radnje","hu-HU":"Nincs enged\xe9lyed ennek a m\u0171veletnek az elv\xe9gz\xe9s\xe9re","hu":"Nincs enged\xe9lyed ennek a m\u0171veletnek az elv\xe9gz\xe9s\xe9re","it-IT":"Non disponi dell\'autorizzazione per eseguire questa azione","it":"Non disponi dell\'autorizzazione per eseguire questa azione","ja-JP":"\u3053\u306E\u64CD\u4F5C\u3092\u5B9F\u884C\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093","ja":"\u3053\u306E\u64CD\u4F5C\u3092\u5B9F\u884C\u3059\u308B\u6A29\u9650\u304C\u3042\u308A\u307E\u305B\u3093","ko-KR":"\uC774 \uC791\uC5C5\uC744 \uC218\uD589\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4","ko":"\uC774 \uC791\uC5C5\uC744 \uC218\uD589\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4","nl-NL":"Je hebt geen toestemming om deze bewerking uit te voeren.","nl":"Je hebt geen toestemming om deze bewerking uit te voeren.","no-NO":"Du har ikke tillatelse til \xe5 utf\xf8re denne handlingen","pl-PL":"Nie masz pozwolenia na wykonanie tego zadania.","pl":"Nie masz pozwolenia na wykonanie tego zadania.","pt-BR":"Voc\xea n\xe3o tem permiss\xe3o para executar esta a\xe7\xe3o","pt-PT":"N\xe3o tem permiss\xe3o para executar esta a\xe7\xe3o","ru-RU":"\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F","ru":"\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u044D\u0442\u043E\u0433\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F","sv-SE":"Du har inte beh\xf6righet att utf\xf6ra den h\xe4r \xe5tg\xe4rden.","sv":"Du har inte beh\xf6righet att utf\xf6ra den h\xe4r \xe5tg\xe4rden.","th-TH":"\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E01\u0E23\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49","th":"\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E2D\u0E19\u0E38\u0E0D\u0E32\u0E15\u0E43\u0E2B\u0E49\u0E01\u0E23\u0E30\u0E17\u0E33\u0E01\u0E32\u0E23\u0E19\u0E35\u0E49","tr-TR":"Bu eylemi ger\xe7ekle\u015Ftirme iznine sahip de\u011Filsin","tr":"Bu eylemi ger\xe7ekle\u015Ftirme iznine sahip de\u011Filsin"},"RL_ProductAddError4":{"key":"RL_ProductAddError4","en":"Request failed: \\"{{1}}\\" Please try again.","ca-ES":"S\'ha produ\xeft un error en la sol\xb7licitud: \\"{{1}}\\". Torna-ho a provar.","ca":"S\'ha produ\xeft un error en la sol\xb7licitud: \\"{{1}}\\". Torna-ho a provar.","cs-CZ":"\u017D\xe1dost selhala: \u201E{{1}}\u201C Zkuste to pros\xedm znovu.","cs":"\u017D\xe1dost selhala: \u201E{{1}}\u201C Zkuste to pros\xedm znovu.","da-DK":"Anmodningen mislykkedes: \\"{{1}}\\" Pr\xf8v igen.","da":"Anmodningen mislykkedes: \\"{{1}}\\" Pr\xf8v igen.","de-DE":"Anfrage fehlgeschlagen: \\"{{1}}\\" Bitte versuche es erneut.","de":"Anfrage fehlgeschlagen: \\"{{1}}\\" Bitte versuche es erneut.","el-GR":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2: \\"{{1}}\\" \u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","el":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2: \\"{{1}}\\" \u0394\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","en-GB":"Request failed: \\"{{1}}\\" Please try again.","es-ES":"Error en la solicitud: \\"{{1}}\\" Vuelve a intentarlo.","es":"Error en la solicitud: \\"{{1}}\\" Vuelve a intentarlo.","fi-FI":"Pyynt\xf6 ep\xe4onnistui: \\"{{1}}\\" Yrit\xe4 uudelleen.","fr-FR":"\xc9chec de la demande\xa0: \xab\xa0{{1}}\xa0\xbb Veuillez r\xe9essayer","fr":"\xc9chec de la demande\xa0: \xab\xa0{{1}}\xa0\xbb Veuillez r\xe9essayer","he-IL":"\u05D4\u05D1\u05E7\u05E9\u05D4 \u05E0\u05DB\u05E9\u05DC\u05D4: \\"{{1}}\\" \u05E0\u05E1\u05D5 \u05E9\u05D5\u05D1.","hr-HR":"Zahtjev nije uspio: \u201E{{1}}\u201D. Poku\u0161ajte ponovno.","hu-HU":"Sikertelen k\xe9r\xe9s: \u201E{{1}}\u201D Pr\xf3b\xe1ld \xfajra.","hu":"Sikertelen k\xe9r\xe9s: \u201E{{1}}\u201D Pr\xf3b\xe1ld \xfajra.","it-IT":"Richiesta non riuscita: \\"{{1}}\\" Riprova.","it":"Richiesta non riuscita: \\"{{1}}\\" Riprova.","ja-JP":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u51E6\u7406\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A\\"{{1}}\\" \u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","ja":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u51E6\u7406\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A\\"{{1}}\\" \u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","ko-KR":"\uC694\uCCAD \uC2E4\uD328: \\"{{1}}\\" \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.","ko":"\uC694\uCCAD \uC2E4\uD328: \\"{{1}}\\" \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.","nl-NL":"Verzoek is mislukt: \\"{{1}}\\" Probeer het opnieuw.","nl":"Verzoek is mislukt: \\"{{1}}\\" Probeer het opnieuw.","no-NO":"Foresp\xf8rsel feilet: \xab{{1}}\xbb Pr\xf8v p\xe5 nytt.","pl-PL":"Nieudane zg\u0142oszenie: {{1}}. Spr\xf3buj ponownie.","pl":"Nieudane zg\u0142oszenie: {{1}}. Spr\xf3buj ponownie.","pt-BR":"Falha na solicita\xe7\xe3o: \\"{{1}}\\". Tente novamente","pt-PT":"Falha no pedido: \\"{{1}}\\" Tente novamente.","ru-RU":"\u0421\u0431\u043E\u0439 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430: \\"{{1}}\\" \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.","ru":"\u0421\u0431\u043E\u0439 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430: \\"{{1}}\\" \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.","sv-SE":"Beg\xe4ran misslyckades: \\"{{1}}\\" F\xf6rs\xf6k igen.","sv":"Beg\xe4ran misslyckades: \\"{{1}}\\" F\xf6rs\xf6k igen.","th-TH":"\u0E04\u0E33\u0E02\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27: \\"{{1}}\\" \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","th":"\u0E04\u0E33\u0E02\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27: \\"{{1}}\\" \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","tr-TR":"\u0130stek ba\u015Far\u0131s\u0131z: \\"{{1}}\\" L\xfctfen tekrar dene.","tr":"\u0130stek ba\u015Far\u0131s\u0131z: \\"{{1}}\\" L\xfctfen tekrar dene."},"RL_ProductAddError5":{"key":"RL_ProductAddError5","en":"Request failed: \\"{{1}}\\" {{2}}","ca-ES":"S\'ha produ\xeft un error en la sol\xb7licitud: \\"{{1}}\\". {{2}}","ca":"S\'ha produ\xeft un error en la sol\xb7licitud: \\"{{1}}\\". {{2}}","cs-CZ":"\u017D\xe1dost selhala: \u201E{{1}}\u201C {{2}}","cs":"\u017D\xe1dost selhala: \u201E{{1}}\u201C {{2}}","da-DK":"Anmodningen mislykkedes: \\"{{1}}\\" {{2}}","da":"Anmodningen mislykkedes: \\"{{1}}\\" {{2}}","de-DE":"Anfrage fehlgeschlagen: \\"{{1}}\\" {{2}}","de":"Anfrage fehlgeschlagen: \\"{{1}}\\" {{2}}","el-GR":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2: \\"{{1}}\\" {{2}}","el":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1 \u03B1\u03B9\u03C4\u03AE\u03BC\u03B1\u03C4\u03BF\u03C2: \\"{{1}}\\" {{2}}","en-GB":"Request failed: \\"{{1}}\\" {{2}}","es-ES":"Error en la solicitud: \\"{{1}}\\" {{2}}","es":"Error en la solicitud: \\"{{1}}\\" {{2}}","fi-FI":"Pyynt\xf6 ep\xe4onnistui: \\"{{1}}\\" {{2}}","fr-FR":"\xc9chec de la demande\xa0: \xab\xa0{{1}}\xa0\xbb {{2}}","fr":"\xc9chec de la demande\xa0: \xab\xa0{{1}}\xa0\xbb {{2}}","he-IL":"\u05D1\u05E7\u05E9\u05D4 \u05E0\u05DB\u05E9\u05DC\u05D4: \\"{{1}}\\" {{2}}","hr-HR":"Zahtjev nije uspio: \u201E{{1}}\u201D {{2}}","hu-HU":"Sikertelen k\xe9r\xe9s: \u201E{{1}}\u201D {{2}}","hu":"Sikertelen k\xe9r\xe9s: \u201E{{1}}\u201D {{2}}","it-IT":"Richiesta non riuscita: \\"{{1}}\\" {{2}}","it":"Richiesta non riuscita: \\"{{1}}\\" {{2}}","ja-JP":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u51E6\u7406\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A\\"{{1}}\\" {{2}}","ja":"\u30EA\u30AF\u30A8\u30B9\u30C8\u306E\u51E6\u7406\u306B\u5931\u6557\u3057\u307E\u3057\u305F\uFF1A\\"{{1}}\\" {{2}}","ko-KR":"\uC694\uCCAD \uC2E4\uD328: \\"{{1}}\\" {{2}}","ko":"\uC694\uCCAD \uC2E4\uD328: \\"{{1}}\\" {{2}}","nl-NL":"Verzoek is mislukt: \\"{{1}}\\" {{2}}","nl":"Verzoek is mislukt: \\"{{1}}\\" {{2}}","no-NO":"Foresp\xf8rsel feilet: \xab{{1}}\xbb {{2}}","pl-PL":"Nieudane zg\u0142oszenie: {{1}} {{2}}","pl":"Nieudane zg\u0142oszenie: {{1}} {{2}}","pt-BR":"Falha na solicita\xe7\xe3o: \\"{{1}}\\". {{2}}","pt-PT":"Falha no pedido: \\"{{1}}\\" {{2}}","ru-RU":"\u0421\u0431\u043E\u0439 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430: \\"{{1}}\\" {{2}}","ru":"\u0421\u0431\u043E\u0439 \u043F\u0440\u0438 \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0435 \u0437\u0430\u043F\u0440\u043E\u0441\u0430: \\"{{1}}\\" {{2}}","sv-SE":"Beg\xe4ran misslyckades: \\"{{1}}\\" {{2}}","sv":"Beg\xe4ran misslyckades: \\"{{1}}\\" {{2}}","th-TH":"\u0E04\u0E33\u0E02\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27: \\"{{1}}\\" {{2}}","th":"\u0E04\u0E33\u0E02\u0E2D\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27: \\"{{1}}\\" {{2}}","tr-TR":"\u0130stek ba\u015Far\u0131s\u0131z: \\"{{1}}\\" {{2}}","tr":"\u0130stek ba\u015Far\u0131s\u0131z: \\"{{1}}\\" {{2}}"},"RL_ScanError1":{"key":"RL_ScanError1","en":"Using the camera on this device is not supported. Please upgrade your iOS version to use the Promote App.","cs-CZ":"Pou\u017E\xedv\xe1n\xed fotoapar\xe1tu na tomhle p\u0159\xedstroji nen\xed podporov\xe1no. Aktualizujte svoji verzi iOS, abyste mohli pou\u017E\xedvat aplikaci Promote.","cs":"Pou\u017E\xedv\xe1n\xed fotoapar\xe1tu na tomhle p\u0159\xedstroji nen\xed podporov\xe1no. Aktualizujte svoji verzi iOS, abyste mohli pou\u017E\xedvat aplikaci Promote.","da-DK":"Brug af kamera p\xe5 denne enhed er ikke underst\xf8ttet. Opgrader  din iOS-version for at bruge Promote App.","da":"Brug af kamera p\xe5 denne enhed er ikke underst\xf8ttet. Opgrader  din iOS-version for at bruge Promote App.","de-DE":"Die Verwendung der Kamera wird auf diesem Ger\xe4t nicht unterst\xfctzt. Bitte aktualisiere deine iOS-Version, um die Promote App zu verwenden.","de":"Die Verwendung der Kamera wird auf diesem Ger\xe4t nicht unterst\xfctzt. Bitte aktualisiere deine iOS-Version, um die Promote App zu verwenden.","el-GR":"\u0397 \u03C7\u03C1\u03AE\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03B4\u03B5\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9. \u0393\u03B9\u03B1 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE Promote, \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03BD\u03B1\u03B2\u03B1\u03B8\u03BC\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7 iOS.","el":"\u0397 \u03C7\u03C1\u03AE\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BA\u03AC\u03BC\u03B5\u03C1\u03B1\u03C2 \u03C3\u03B5 \u03B1\u03C5\u03C4\u03AE\u03BD \u03C4\u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03B4\u03B5\u03BD \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03B5\u03C4\u03B1\u03B9. \u0393\u03B9\u03B1 \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AE Promote, \u03C0\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03B1\u03BD\u03B1\u03B2\u03B1\u03B8\u03BC\u03AF\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7 iOS.","en-GB":"Using the camera on this device is not supported. Please upgrade your iOS version to use the Promote App.","es-ES":"No se puede usar la c\xe1mara en este dispositivo. Actualiza la versi\xf3n de iOS para usar Promote App.","es":"No se puede usar la c\xe1mara en este dispositivo. Actualiza la versi\xf3n de iOS para usar Promote App.","fi-FI":"Laitteen kameraa ei tueta. P\xe4ivit\xe4 iOS-j\xe4rjestelm\xe4versiosi k\xe4ytt\xe4\xe4ksesi Promote-sovellusta.","fr-FR":"L\'utilisation de l\'appareil photo sur cet appareil n\'est pas prise en charge. Veuillez mettre \xe0 jour votre version iOS pour utiliser l\'application Promote.","fr":"L\'utilisation de l\'appareil photo sur cet appareil n\'est pas prise en charge. Veuillez mettre \xe0 jour votre version iOS pour utiliser l\'application Promote.","he-IL":"\u05D4\u05E9\u05D9\u05DE\u05D5\u05E9 \u05D1\u05DE\u05E6\u05DC\u05DE\u05D4 \u05D1\u05DE\u05DB\u05E9\u05D9\u05E8 \u05D6\u05D4 \u05D0\u05D9\u05E0\u05D5 \u05E0\u05EA\u05DE\u05DA. \u05E9\u05D3\u05E8\u05D2\u05D5 \u05D0\u05EA \u05D2\u05E8\u05E1\u05EA \u05D4-iOS \u05DB\u05D3\u05D9 \u05DC\u05D4\u05E9\u05EA\u05DE\u05E9 \u05D1\u05D0\u05E4\u05DC\u05D9\u05E7\u05E6\u05D9\u05D9\u05EA Promote.","hr-HR":"Upotreba kamere na ovom ure\u0111aju nije podr\u017Eana. Nadogradite verziju operativnog sustava iOS da biste upotrijebili aplikaciju Promote.","hu-HU":"A kamera haszn\xe1lata ezen az eszk\xf6z\xf6n nem t\xe1mogatott. A Promote app haszn\xe1lat\xe1hoz friss\xedtsd az iOS verzi\xf3t.","hu":"A kamera haszn\xe1lata ezen az eszk\xf6z\xf6n nem t\xe1mogatott. A Promote app haszn\xe1lat\xe1hoz friss\xedtsd az iOS verzi\xf3t.","it-IT":"Questo dispositivo non supporta l\'uso della fotocamera. Aggiorna la versione di iOS per utilizzare l\'app Promote.","it":"Questo dispositivo non supporta l\'uso della fotocamera. Aggiorna la versione di iOS per utilizzare l\'app Promote.","ja-JP":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306E\u30AB\u30E1\u30E9\u306E\u4F7F\u7528\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002 Promote\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001iOS\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ja":"\u3053\u306E\u30C7\u30D0\u30A4\u30B9\u306E\u30AB\u30E1\u30E9\u306E\u4F7F\u7528\u306F\u30B5\u30DD\u30FC\u30C8\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002 Promote\u30A2\u30D7\u30EA\u3092\u4F7F\u7528\u3059\u308B\u306B\u306F\u3001iOS\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ko-KR":"\uC774 \uAE30\uAE30\uC5D0\uC11C\uB294 \uCE74\uBA54\uB77C \uC0AC\uC6A9\uC774 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. Promote \uC571\uC744 \uC0AC\uC6A9\uD558\uB824\uBA74 iOS \uBC84\uC804\uC744 \uC5C5\uADF8\uB808\uC774\uB4DC\uD558\uC138\uC694.","ko":"\uC774 \uAE30\uAE30\uC5D0\uC11C\uB294 \uCE74\uBA54\uB77C \uC0AC\uC6A9\uC774 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. Promote \uC571\uC744 \uC0AC\uC6A9\uD558\uB824\uBA74 iOS \uBC84\uC804\uC744 \uC5C5\uADF8\uB808\uC774\uB4DC\uD558\uC138\uC694.","nl-NL":"Het gebruik van de camera op dit apparaat wordt niet ondersteund. Werk je iOS-versie bij om de Promote app te gebruiken.","nl":"Het gebruik van de camera op dit apparaat wordt niet ondersteund. Werk je iOS-versie bij om de Promote app te gebruiken.","no-NO":"Bruk av kameraet p\xe5 denne enheten st\xf8ttes ikke. Oppgrader iOS-versjonen for \xe5 bruke kampanjeappen.","pl-PL":"Na tym urz\u0105dzeniu aparat nie jest obs\u0142ugiwany. Uaktualnij swoj\u0105 wersj\u0119 iOS, aby korzysta\u0107 z aplikacji Promocje.","pl":"Na tym urz\u0105dzeniu aparat nie jest obs\u0142ugiwany. Uaktualnij swoj\u0105 wersj\u0119 iOS, aby korzysta\u0107 z aplikacji Promocje.","pt-BR":"O uso da c\xe2mera n\xe3o \xe9 suportado neste dispositivo. Atualize sua vers\xe3o do iOS para usar o app Promote.","pt-PT":"N\xe3o \xe9 suportada a utiliza\xe7\xe3o da c\xe2mara neste dispositivo. Atualize a vers\xe3o do iOS para utilizar a Promote App.","ru-RU":"\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u0430\u043C\u0435\u0440\u044B \u043D\u0430 \u044D\u0442\u043E\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F. \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0435\u0440\u0441\u0438\u044E iOS, \u0447\u0442\u043E\u0431\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Promote.","ru":"\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u0430\u043C\u0435\u0440\u044B \u043D\u0430 \u044D\u0442\u043E\u043C \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0435 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F. \u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0435\u0440\u0441\u0438\u044E iOS, \u0447\u0442\u043E\u0431\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Promote.","sv-SE":"Anv\xe4ndning av kameran st\xf6ds inte p\xe5 den h\xe4r enheten. Uppgradera din iOS_version f\xf6r att anv\xe4nda Promote App.","sv":"Anv\xe4ndning av kameran st\xf6ds inte p\xe5 den h\xe4r enheten. Uppgradera din iOS_version f\xf6r att anv\xe4nda Promote App.","th-TH":"\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E1A\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1E\u0E40\u0E01\u0E23\u0E14\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E19 iOS \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49\u0E41\u0E2D\u0E1E Promote","th":"\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E25\u0E49\u0E2D\u0E07\u0E1A\u0E19\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E19\u0E35\u0E49 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1E\u0E40\u0E01\u0E23\u0E14\u0E40\u0E27\u0E2D\u0E23\u0E4C\u0E0A\u0E31\u0E19 iOS \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E0A\u0E49\u0E41\u0E2D\u0E1E Promote","tr-TR":"Bu cihazda kameran\u0131n kullan\u0131lmas\u0131 desteklenmiyor. Promote Uygulamas\u0131n\u0131 kullanmak i\xe7in l\xfctfen iOS s\xfcr\xfcm\xfcn\xfc y\xfckselt.","tr":"Bu cihazda kameran\u0131n kullan\u0131lmas\u0131 desteklenmiyor. Promote Uygulamas\u0131n\u0131 kullanmak i\xe7in l\xfctfen iOS s\xfcr\xfcm\xfcn\xfc y\xfckselt."},"RL_ScanError2":{"key":"RL_ScanError2","en":"Your network connection is not stable or the device is busy. Please close the scanner and try again.","cs-CZ":"Va\u0161e p\u0159ipojen\xed k\xa0s\xedti nen\xed stabiln\xed nebo je va\u0161e za\u0159\xedzen\xed zanepr\xe1zdn\u011Bno. Zav\u0159ete skener a\xa0zkuste to znova.","cs":"Va\u0161e p\u0159ipojen\xed k\xa0s\xedti nen\xed stabiln\xed nebo je va\u0161e za\u0159\xedzen\xed zanepr\xe1zdn\u011Bno. Zav\u0159ete skener a\xa0zkuste to znova.","da-DK":"Din netv\xe6rksforbindelse er ikke stabil, eller din enhed er overbelastet. Luk scanneren, og pr\xf8v igen.","da":"Din netv\xe6rksforbindelse er ikke stabil, eller din enhed er overbelastet. Luk scanneren, og pr\xf8v igen.","de-DE":"Deine Netzwerkverbindung ist nicht stabil oder das Ger\xe4t ist ausgelastet. Bitte schlie\xdfe den Scanner und versuche es erneut.","de":"Deine Netzwerkverbindung ist nicht stabil oder das Ger\xe4t ist ausgelastet. Bitte schlie\xdfe den Scanner und versuche es erneut.","el-GR":"\u0397 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C4\u03B1\u03B8\u03B5\u03C1\u03AE \u03AE \u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C3\u03C7\u03BF\u03BB\u03B7\u03BC\u03AD\u03BD\u03B7. \u039A\u03BB\u03B5\u03AF\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03B1\u03C1\u03C9\u03C4\u03AE \u03BA\u03B1\u03B9 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","el":"\u0397 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C4\u03B1\u03B8\u03B5\u03C1\u03AE \u03AE \u03B7 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B1\u03C0\u03B1\u03C3\u03C7\u03BF\u03BB\u03B7\u03BC\u03AD\u03BD\u03B7. \u039A\u03BB\u03B5\u03AF\u03C3\u03C4\u03B5 \u03C4\u03BF\u03BD \u03C3\u03B1\u03C1\u03C9\u03C4\u03AE \u03BA\u03B1\u03B9 \u03B4\u03BF\u03BA\u03B9\u03BC\u03AC\u03C3\u03C4\u03B5 \u03BE\u03B1\u03BD\u03AC.","en-GB":"Your network connection is not stable or the device is busy. Please close the scanner and try again.","es-ES":"Tu conexi\xf3n de red es inestable o el dispositivo est\xe1 ocupado. Cierra el esc\xe1ner y vuelve a intentarlo.","es":"Tu conexi\xf3n de red es inestable o el dispositivo est\xe1 ocupado. Cierra el esc\xe1ner y vuelve a intentarlo.","fi-FI":"Verkkoyhteytesi on ep\xe4vakaa tai laite on varattu. Sulje skanneri ja yrit\xe4 uudelleen.","fr-FR":"Votre connexion r\xe9seau n\'est pas stable ou l\'appareil est occup\xe9. Veuillez fermer le scanner et r\xe9essayer.","fr":"Votre connexion r\xe9seau n\'est pas stable ou l\'appareil est occup\xe9. Veuillez fermer le scanner et r\xe9essayer.","he-IL":"\u05D4\u05D7\u05D9\u05D1\u05D5\u05E8 \u05E9\u05DC\u05DB\u05DD \u05DC\u05E8\u05E9\u05EA \u05DC\u05D0 \u05D9\u05E6\u05D9\u05D1 \u05D0\u05D5 \u05E9\u05D4\u05DE\u05DB\u05E9\u05D9\u05E8 \u05E2\u05DE\u05D5\u05E1. \u05E1\u05D2\u05E8\u05D5 \u05D0\u05EA \u05D4\u05E1\u05D5\u05E8\u05E7 \u05D5\u05E0\u05E1\u05D5 \u05E9\u05D5\u05D1.","hr-HR":"Mre\u017Ena veza nije stabilna ili je ure\u0111aj zauzet. Zatvorite skener i poku\u0161ajte ponovno.","hu-HU":"A h\xe1l\xf3zati kapcsolat nem stabil, vagy az eszk\xf6z nem el\xe9rhet\u0151. Z\xe1rd be a beolvas\xf3t, majd pr\xf3b\xe1ld \xfajra.","hu":"A h\xe1l\xf3zati kapcsolat nem stabil, vagy az eszk\xf6z nem el\xe9rhet\u0151. Z\xe1rd be a beolvas\xf3t, majd pr\xf3b\xe1ld \xfajra.","it-IT":"La connessione di rete non \xe8 stabile o il dispositivo \xe8 occupato. Chiudi lo scanner e riprova.","it":"La connessione di rete non \xe8 stabile o il dispositivo \xe8 occupato. Chiudi lo scanner e riprova.","ja-JP":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u63A5\u7D9A\u304C\u4E0D\u5B89\u5B9A\u3067\u3042\u308B\u304B\u30C7\u30D0\u30A4\u30B9\u304C\u30D3\u30B8\u30FC\u72B6\u614B\u3067\u3059\u3002 \u30B9\u30AD\u30E3\u30CA\u30FC\u3092\u7D42\u4E86\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","ja":"\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u63A5\u7D9A\u304C\u4E0D\u5B89\u5B9A\u3067\u3042\u308B\u304B\u30C7\u30D0\u30A4\u30B9\u304C\u30D3\u30B8\u30FC\u72B6\u614B\u3067\u3059\u3002 \u30B9\u30AD\u30E3\u30CA\u30FC\u3092\u7D42\u4E86\u3057\u3066\u3001\u3082\u3046\u4E00\u5EA6\u304A\u8A66\u3057\u304F\u3060\u3055\u3044\u3002","ko-KR":"\uB124\uD2B8\uC6CC\uD06C \uC5F0\uACB0\uC774 \uBD88\uC548\uC815\uD558\uAC70\uB098 \uAE30\uAE30\uAC00 \uC0AC\uC6A9 \uC911\uC785\uB2C8\uB2E4. \uC2A4\uCE90\uB108\uB97C \uC885\uB8CC\uD558\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.","ko":"\uB124\uD2B8\uC6CC\uD06C \uC5F0\uACB0\uC774 \uBD88\uC548\uC815\uD558\uAC70\uB098 \uAE30\uAE30\uAC00 \uC0AC\uC6A9 \uC911\uC785\uB2C8\uB2E4. \uC2A4\uCE90\uB108\uB97C \uC885\uB8CC\uD558\uACE0 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.","nl-NL":"Je netwerkverbinding is niet stabiel of het apparaat is bezig. Sluit de scanner en probeer het opnieuw.","nl":"Je netwerkverbinding is niet stabiel of het apparaat is bezig. Sluit de scanner en probeer het opnieuw.","no-NO":"Nettverksforbindelsen din er ikke stabil eller enheten er opptatt. Lukk skanneren, og pr\xf8v p\xe5 nytt.","pl-PL":"Po\u0142\u0105czenie sieciowe jest niestabilne lub urz\u0105dzenie jest zaj\u0119te. Zamknij skaner i spr\xf3buj ponownie.","pl":"Po\u0142\u0105czenie sieciowe jest niestabilne lub urz\u0105dzenie jest zaj\u0119te. Zamknij skaner i spr\xf3buj ponownie.","pt-BR":"Sua conex\xe3o de rede n\xe3o est\xe1 est\xe1vel ou o dispositivo est\xe1 ocupado. Feche o escaneamento e tente novamente.","pt-PT":"A liga\xe7\xe3o de rede n\xe3o \xe9 est\xe1vel ou o dispositivo est\xe1 ocupado. Feche o leitor e tente novamente.","ru-RU":"\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043D\u0435\u0441\u0442\u0430\u0431\u0438\u043B\u044C\u043D\u043E \u0438\u043B\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0437\u0430\u043D\u044F\u0442\u043E. \u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0435 \u0440\u0430\u0431\u043E\u0442\u0443 \u0441\u043A\u0430\u043D\u0435\u0440\u0430 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.","ru":"\u0421\u0435\u0442\u0435\u0432\u043E\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043D\u0435\u0441\u0442\u0430\u0431\u0438\u043B\u044C\u043D\u043E \u0438\u043B\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E \u0437\u0430\u043D\u044F\u0442\u043E. \u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0435 \u0440\u0430\u0431\u043E\u0442\u0443 \u0441\u043A\u0430\u043D\u0435\u0440\u0430 \u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443.","sv-SE":"Din n\xe4tverksanslutning \xe4r instabil eller s\xe5 \xe4r enheten upptagen. St\xe4ng skannern och f\xf6rs\xf6k igen.","sv":"Din n\xe4tverksanslutning \xe4r instabil eller s\xe5 \xe4r enheten upptagen. St\xe4ng skannern och f\xf6rs\xf6k igen.","th-TH":"\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E40\u0E2A\u0E16\u0E35\u0E22\u0E23\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E44\u0E21\u0E48\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E34\u0E14\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2A\u0E41\u0E01\u0E19\u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","th":"\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E40\u0E2A\u0E16\u0E35\u0E22\u0E23\u0E2B\u0E23\u0E37\u0E2D\u0E2D\u0E38\u0E1B\u0E01\u0E23\u0E13\u0E4C\u0E44\u0E21\u0E48\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19 \u0E42\u0E1B\u0E23\u0E14\u0E1B\u0E34\u0E14\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E2A\u0E41\u0E01\u0E19\u0E41\u0E25\u0E49\u0E27\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07","tr-TR":"A\u011F ba\u011Flant\u0131n sabit de\u011Fil veya cihaz me\u015Fgul. L\xfctfen taray\u0131c\u0131y\u0131 kapat ve tekrar dene.","tr":"A\u011F ba\u011Flant\u0131n sabit de\u011Fil veya cihaz me\u015Fgul. L\xfctfen taray\u0131c\u0131y\u0131 kapat ve tekrar dene."},"RL_StyleUpload":{"key":"RL_StyleUpload","en":"STYLES UPLOAD","ca":"PUJADA DE PRODUCTES","ca-ES":"PUJADA DE PRODUCTES","cs":"NAHR\xc1V\xc1N\xcd STYL\u016E","cs-CZ":"NAHR\xc1V\xc1N\xcd STYL\u016E","da":"UPLOAD MODELLER","da-DK":"UPLOAD MODELLER","de":"STYLE-UPLOAD","de-DE":"STYLE-UPLOAD","el":"\u039C\u0395\u03A4\u0391\u03A6\u039F\u03A1\u03A4\u03A9\u03A3\u0397 \u03A3\u03A4\u0399\u039B","el-GR":"\u039C\u0395\u03A4\u0391\u03A6\u039F\u03A1\u03A4\u03A9\u03A3\u0397 \u03A3\u03A4\u0399\u039B","en-GB":"STYLES UPLOAD","es":"CARGA DE PRODUCTOS","es-ES":"CARGA DE PRODUCTOS","fi-FI":"TYYLIEN LATAAMINEN","fr":"IMPORTATION DE MOD\xc8LES","fr-FR":"IMPORTATION DE MOD\xc8LES","he-IL":"\u05D4\u05E2\u05DC\u05D0\u05EA \u05E1\u05D2\u05E0\u05D5\u05E0\u05D5\u05EA","hr-HR":"PRIJENOS MODELA","hu":"ST\xcdLUSOK FELT\xd6LT\xc9SE","hu-HU":"ST\xcdLUSOK FELT\xd6LT\xc9SE","it":"UPLOAD MODELLI","it-IT":"UPLOAD MODELLI","ja":"\u30B9\u30BF\u30A4\u30EB\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9","ja-JP":"\u30B9\u30BF\u30A4\u30EB\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9","ko":"\uC2A4\uD0C0\uC77C \uC5C5\uB85C\uB4DC","ko-KR":"\uC2A4\uD0C0\uC77C \uC5C5\uB85C\uB4DC","nl":"STIJLEN UPLOADEN","nl-NL":"STIJLEN UPLOADEN","no-NO":"LAST OPP PRODUKTER","pl":"PRZESY\u0141ANIE MODELI","pl-PL":"PRZESY\u0141ANIE MODELI","pt-BR":"UPLOAD DE ESTILOS","pt-PT":"CARREGAMENTO DE ESTILOS","ru":"\u0417\u0410\u0413\u0420\u0423\u0417\u041A\u0410 \u041C\u041E\u0414\u0415\u041B\u0415\u0419","ru-RU":"\u0417\u0410\u0413\u0420\u0423\u0417\u041A\u0410 \u041C\u041E\u0414\u0415\u041B\u0415\u0419","sv":"LADDA UPP MODELLER","sv-SE":"LADDA UPP MODELLER","th":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E44\u0E15\u0E25\u0E4C","th-TH":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E44\u0E15\u0E25\u0E4C","tr":"ST\u0130L Y\xdcKLEME","tr-TR":"ST\u0130L Y\xdcKLEME"},"RL_1UploaStyle":{"key":"RL_1UploaStyle","en":"Upload 1 Style Color","ca":"Puja un producte","ca-ES":"Puja un producte","cs":"Nahr\xe1t 1 barvu stylu","cs-CZ":"Nahr\xe1t 1 barvu stylu","da":"Upload 1 modelfarve","da-DK":"Upload 1 modelfarve","de":"1 Style-/Farbcode hochladen","de-DE":"1 Style-/Farbcode hochladen","el":"\u039C\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 1 \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2","el-GR":"\u039C\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 1 \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2","en-GB":"Upload 1 Style Colour","es":"Carga 1 producto","es-ES":"Carga 1 producto","fi-FI":"Lataa 1 StyleColor","fr":"Importer 1 style-coloris","fr-FR":"Importer 1 style-coloris","he-IL":"\u05D4\u05E2\u05DC\u05D0\u05EA \u05E1\u05D2\u05E0\u05D5\u05DF-\u05E6\u05D1\u05E2 \u05D0\u05D7\u05D3","hr-HR":"Prenesi 1 parametar Style Color","hu":"1 st\xedlus\u2013sz\xedn felt\xf6lt\xe9se","hu-HU":"1 st\xedlus\u2013sz\xedn felt\xf6lt\xe9se","it":"Upload 1 modello colore","it-IT":"Upload 1 modello colore","ja":"1\u4EF6\u306EStyle Color\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9","ja-JP":"1\u4EF6\u306EStyle Color\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9","ko":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC 1\uAC1C \uC5C5\uB85C\uB4DC","ko-KR":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC 1\uAC1C \uC5C5\uB85C\uB4DC","nl":"Upload 1 stijl/kleur","nl-NL":"Upload 1 stijl/kleur","no-NO":"Last opp 1 produktfarge","pl":"Prze\u015Blij 1 model/kolor","pl-PL":"Prze\u015Blij 1 model/kolor","pt-BR":"Fazer upload de 1 cor de estilo","pt-PT":"Carregar 1 estilo-cor","ru":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C 1 \u043C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0443","ru-RU":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C 1 \u043C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0443","sv":"Ladda upp 1 modellf\xe4rg","sv-SE":"Ladda upp 1 modellf\xe4rg","th":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14 1 \u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35","th-TH":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14 1 \u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35","tr":"1 Stil-Renk Y\xfckle","tr-TR":"1 Stil-Renk Y\xfckle"},"RL_2UploaStyle":{"key":"RL_2UploaStyle","en":"Upload {{1}} Style Colors","ca":"Puja {{1}} productes","ca-ES":"Puja {{1}} productes","cs":"Nahr\xe1t {{1}} barev styl\u016F","cs-CZ":"Nahr\xe1t {{1}} barev styl\u016F","da":"Upload {{1}} modelfarver","da-DK":"Upload {{1}} modelfarver","de":"{{1}} Style-/Farbcodes hochladen","de-DE":"{{1}} Style-/Farbcodes hochladen","el":"\u039C\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 {{1}} \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03C9\u03BC\u03AC\u03C4\u03C9\u03BD","el-GR":"\u039C\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 {{1}} \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03C9\u03BC\u03AC\u03C4\u03C9\u03BD","en-GB":"Upload {{1}} Style Colours","es":"Carga {{1}} productos","es-ES":"Carga {{1}} productos","fi-FI":"Lataa ((1)) StyleColoria","fr":"Importer {{1}} style-coloris","fr-FR":"Importer {{1}} style-coloris","he-IL":"\u05D4\u05E2\u05DC\u05D0\u05EA {{1}} \u05E1\u05D2\u05E0\u05D5\u05E0\u05D5\u05EA-\u05E6\u05D1\u05E2\u05D9\u05DD","hr-HR":"Prenesi {{1}} parametar Style Colors","hu":"{{1}} st\xedlus\u2013sz\xedn felt\xf6lt\xe9se","hu-HU":"{{1}} st\xedlus\u2013sz\xedn felt\xf6lt\xe9se","it":"Upload {{1}} modelli colore","it-IT":"Upload {{1}} modelli colore","ja":"{{1}}\u4EF6\u306EStyle Color\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9","ja-JP":"{{1}}\u4EF6\u306EStyle Color\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9","ko":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC {{1}}\uAC1C \uC5C5\uB85C\uB4DC","ko-KR":"\uC2A4\uD0C0\uC77C \uCEEC\uB7EC {{1}}\uAC1C \uC5C5\uB85C\uB4DC","nl":"Upload {{1}} stijlen/kleuren","nl-NL":"Upload {{1}} stijlen/kleuren","no-NO":"Last opp {{1}} produktfarger","pl":"Prze\u015Blij modele/kolory: {{1}}","pl-PL":"Prze\u015Blij modele/kolory: {{1}}","pt-BR":"Fazer upload de {{1}} cores de estilo","pt-PT":"Carregar {{1}} estilos-cores","ru":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043C\u043E\u0434\u0435\u043B\u0438/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0438 ({{1}})","ru-RU":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u043C\u043E\u0434\u0435\u043B\u0438/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0438 ({{1}})","sv":"Ladda upp {{1}} modellf\xe4rger","sv-SE":"Ladda upp {{1}} modellf\xe4rger","th":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14 {{1}} \u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35","th-TH":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14 {{1}} \u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35","tr":"{{1}} Stil-Renk Y\xfckle","tr-TR":"{{1}} Stil-Renk Y\xfckle"},"RL_UploadComplete":{"key":"RL_UploadComplete","en":"The Upload was complete. {{1}} of {{2}} uploads succeeded","ca":"La pujada s\'ha completat. S\'han pujat correctament {{1}} dels {{2}} productes","ca-ES":"La pujada s\'ha completat. S\'han pujat correctament {{1}} dels {{2}} productes","cs":"Nahr\xe1v\xe1n\xed bylo dokon\u010Deno. {{1}} z {{2}} nahr\xe1n\xed prob\u011Bhlo \xfasp\u011B\u0161n\u011B","cs-CZ":"Nahr\xe1v\xe1n\xed bylo dokon\u010Deno. {{1}} z {{2}} nahr\xe1n\xed prob\u011Bhlo \xfasp\u011B\u0161n\u011B","da":"Overf\xf8rslen blev gennemf\xf8rt. {{1}} af {{2}} uploads blev gennemf\xf8rt","da-DK":"Overf\xf8rslen blev gennemf\xf8rt. {{1}} af {{2}} uploads blev gennemf\xf8rt","de":"Der Upload ist abgeschlossen. {{1}} von {{2}} Uploads erfolgreich","de-DE":"Der Upload ist abgeschlossen. {{1}} von {{2}} Uploads erfolgreich","el":"\u0397 \u03BC\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5. {{1}} \u03B1\u03C0\u03CC {{2}} \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03C4\u03CE\u03C3\u03B5\u03B9\u03C2 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B1\u03BD \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1","el-GR":"\u0397 \u03BC\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B5. {{1}} \u03B1\u03C0\u03CC {{2}} \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03C4\u03CE\u03C3\u03B5\u03B9\u03C2 \u03BF\u03BB\u03BF\u03BA\u03BB\u03B7\u03C1\u03CE\u03B8\u03B7\u03BA\u03B1\u03BD \u03BC\u03B5 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1","en-GB":"The upload is complete. {{1}} of {{2}} uploads succeeded","es":"La carga se ha completado. {{1}} de {{2}} cargas completadas correctamente","es-ES":"La carga se ha completado. {{1}} de {{2}} cargas completadas correctamente","fi-FI":"Lataus onnistui. ((1))/((2)) latausta onnistui.","fr":"Importation termin\xe9e. {{1}} importation termin\xe9e(s) sur {{2}}","fr-FR":"Importation termin\xe9e. {{1}} importation termin\xe9e(s) sur {{2}}","he-IL":"\u05D4\u05D4\u05E2\u05DC\u05D0\u05D4 \u05D4\u05D5\u05E9\u05DC\u05DE\u05D4. {{1}} \u05DE\u05EA\u05D5\u05DA {{2}} \u05D4\u05E2\u05DC\u05D0\u05D5\u05EA \u05D4\u05E6\u05DC\u05D9\u05D7\u05D5","hr-HR":"Dovr\u0161en je prijenos. {{1}} od {{2}} prijenosa uspje\u0161no je dovr\u0161en","hu":"A felt\xf6lt\xe9s befejez\u0151d\xf6tt. {{1}} / {{2}} sikeres felt\xf6lt\xe9s","hu-HU":"A felt\xf6lt\xe9s befejez\u0151d\xf6tt. {{1}} / {{2}} sikeres felt\xf6lt\xe9s","it":"Upload completato. Upload riusciti: {{1}} di {{2}}","it-IT":"Upload completato. Upload riusciti: {{1}} di {{2}}","ja":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002 {{2}}\u4EF6\u4E2D{{1}}\u4EF6\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306B\u6210\u529F\u3057\u307E\u3057\u305F","ja-JP":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F\u3002 {{2}}\u4EF6\u4E2D{{1}}\u4EF6\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u306B\u6210\u529F\u3057\u307E\u3057\u305F","ko":"\uC5C5\uB85C\uB4DC\uAC00 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. {{2}}\uAC74 \uC911 {{1}}\uAC74\uC758 \uC5C5\uB85C\uB4DC\uAC00 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4","ko-KR":"\uC5C5\uB85C\uB4DC\uAC00 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4. {{2}}\uAC74 \uC911 {{1}}\uAC74\uC758 \uC5C5\uB85C\uB4DC\uAC00 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4","nl":"Het uploaden is voltooid. {{1}} van {{2}} uploads zijn gelukt","nl-NL":"Het uploaden is voltooid. {{1}} van {{2}} uploads zijn gelukt","no-NO":"Opplastingen er fullf\xf8rt. {{1}} av {{2}} opplastinger er gjennomf\xf8rt","pl":"Przesy\u0142anie zosta\u0142o zako\u0144czone. {{1}} z {{2}} proces\xf3w przesy\u0142ania zako\u0144czone sukcesem","pl-PL":"Przesy\u0142anie zosta\u0142o zako\u0144czone. {{1}} z {{2}} proces\xf3w przesy\u0142ania zako\u0144czone sukcesem","pt-BR":"Upload conclu\xeddo. Uploads conclu\xeddos: {{1}} de {{2}}","pt-PT":"O carregamento terminou. {{1}} de {{2}} carregamentos efetuados com sucesso","ru":"\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430. \u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u043E\u043A: {{1}} \u0438\u0437 {{2}}","ru-RU":"\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430. \u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u043E\u043A: {{1}} \u0438\u0437 {{2}}","sv":"Uppladdningen klar. {{1}} av {{2}} uppladdningar genomf\xf6rdes","sv-SE":"Uppladdningen klar. {{1}} av {{2}} uppladdningar genomf\xf6rdes","th":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19 \u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08 {{1}} \u0E08\u0E32\u0E01 {{2}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","th-TH":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E40\u0E2A\u0E23\u0E47\u0E08\u0E2A\u0E34\u0E49\u0E19 \u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08 {{1}} \u0E08\u0E32\u0E01 {{2}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","tr":"Y\xfckleme tamamland\u0131. {{1}}/{{2}} y\xfckleme ba\u015Far\u0131l\u0131","tr-TR":"Y\xfckleme tamamland\u0131. {{1}}/{{2}} y\xfckleme ba\u015Far\u0131l\u0131"},"RL_AllStyleColours":{"key":"RL_AllStyleColours","en":"All StyleColors","ca":"Tots els productes","ca-ES":"Tots els productes","cs":"V\u0161echny barvy styl\u016F","cs-CZ":"V\u0161echny barvy styl\u016F","da":"Alle modelfarver","da-DK":"Alle modelfarver","de":"Alle Style-/Farbcodes","de-DE":"Alle Style-/Farbcodes","el":"\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03B1","el-GR":"\u038C\u03BB\u03B1 \u03C4\u03B1 \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03B1","en-GB":"All Style Colours","es":"Todos los productos","es-ES":"Todos los productos","fi-FI":"Kaikki StyleColorit","fr":"Tous les styles-coloris","fr-FR":"Tous les styles-coloris","he-IL":"\u05DB\u05DC \u05D4\u05E1\u05D2\u05E0\u05D5\u05E0\u05D5\u05EA-\u05E6\u05D1\u05E2\u05D9\u05DD","hr-HR":"Svi parametri model-boja","hu":"\xd6sszes st\xedlus\u2013sz\xedn","hu-HU":"\xd6sszes st\xedlus\u2013sz\xedn","it":"Tutti i modelli-colore","it-IT":"Tutti i modelli-colore","ja":"\u3059\u3079\u3066\u306EStyleColor","ja-JP":"\u3059\u3079\u3066\u306EStyleColor","ko":"\uBAA8\uB4E0 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC","ko-KR":"\uBAA8\uB4E0 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC","nl":"Alle stijlen/kleuren","nl-NL":"Alle stijlen/kleuren","no-NO":"Alle produktfarger","pl":"Wszystkie modele/kolory","pl-PL":"Wszystkie modele/kolory","pt-BR":"Todas as CoresEstilos","pt-PT":"Todos os estilos-cores","ru":"\u0412\u0441\u0435 \u043C\u043E\u0434\u0435\u043B\u0438/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0438","ru-RU":"\u0412\u0441\u0435 \u043C\u043E\u0434\u0435\u043B\u0438/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0438","sv":"Alla modellf\xe4rger","sv-SE":"Alla modellf\xe4rger","th":"\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","th-TH":"\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14","tr":"T\xfcm Stil-Renkler","tr-TR":"T\xfcm Stil-Renkler"},"RL_Succeeded":{"key":"RL_Succeeded","en":"Succeeded","ca":"Pujada correcta","ca-ES":"Pujada correcta","cs":"Povedlo se","cs-CZ":"Povedlo se","da":"Gennemf\xf8rt","da-DK":"Gennemf\xf8rt","de":"Erfolgreich","de-DE":"Erfolgreich","el":"\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE","el-GR":"\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE","en-GB":"Succeeded","es":"Completadas","es-ES":"Completadas","fi-FI":"Onnistui","fr":"R\xe9ussie(s)","fr-FR":"R\xe9ussie(s)","he-IL":"\u05D4\u05E6\u05DC\u05D9\u05D7\u05D5","hr-HR":"Uspje\u0161no","hu":"Sikeres","hu-HU":"Sikeres","it":"Riusciti","it-IT":"Riusciti","ja":"\u6210\u529F\u3057\u307E\u3057\u305F","ja-JP":"\u6210\u529F\u3057\u307E\u3057\u305F","ko":"\uC644\uB8CC","ko-KR":"\uC644\uB8CC","nl":"Gelukt","nl-NL":"Gelukt","no-NO":"Gjennomf\xf8rt","pl":"Zako\u0144czone sukcesem","pl-PL":"Zako\u0144czone sukcesem","pt-BR":"Conclu\xeddo","pt-PT":"Com sucesso","ru":"\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E","ru-RU":"\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E","sv":"Genomf\xf6rdes","sv-SE":"Genomf\xf6rdes","th":"\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08","th-TH":"\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08","tr":"Ba\u015Far\u0131l\u0131","tr-TR":"Ba\u015Far\u0131l\u0131"},"RL_Failed":{"key":"RL_Failed","en":"Failed","ca":"Error","ca-ES":"Error","cs":"Nepovedlo se","cs-CZ":"Nepovedlo se","da":"Mislykkedes","da-DK":"Mislykkedes","de":"Fehlgeschlagen","de-DE":"Fehlgeschlagen","el":"\u039C\u03B7 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE","el-GR":"\u039C\u03B7 \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03AE","en-GB":"Failed","es":"Error","es-ES":"Error","fi-FI":"Ep\xe4onnistui","fr":"\xc9chou\xe9e(s)","fr-FR":"\xc9chou\xe9e(s)","he-IL":"\u05E0\u05DB\u05E9\u05DC\u05D5","hr-HR":"Neuspje\u0161no","hu":"Sikertelen","hu-HU":"Sikertelen","it":"Non riusciti","it-IT":"Non riusciti","ja":"\u5931\u6557\u3057\u307E\u3057\u305F","ja-JP":"\u5931\u6557\u3057\u307E\u3057\u305F","ko":"\uC2E4\uD328","ko-KR":"\uC2E4\uD328","nl":"Mislukt","nl-NL":"Mislukt","no-NO":"Mislyktes","pl":"Zako\u0144czone niepowodzeniem","pl-PL":"Zako\u0144czone niepowodzeniem","pt-BR":"Com falha","pt-PT":"Falha","ru":"\u041D\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E","ru-RU":"\u041D\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E","sv":"Misslyckades","sv-SE":"Misslyckades","th":"\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27","th-TH":"\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27","tr":"Ba\u015Far\u0131s\u0131z","tr-TR":"Ba\u015Far\u0131s\u0131z"},"RL_RowNumber":{"key":"RL_RowNumber","en":"Row Number","ca":"N\xfamero de fila","ca-ES":"N\xfamero de fila","cs":"\u010C\xedslo \u0159\xe1dku","cs-CZ":"\u010C\xedslo \u0159\xe1dku","da":"R\xe6kkenummer","da-DK":"R\xe6kkenummer","de":"Zeilennummer","de-DE":"Zeilennummer","el":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AE\u03C2","el-GR":"\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AE\u03C2","en-GB":"Row number","es":"N\xfamero de fila","es-ES":"N\xfamero de fila","fi-FI":"Rivin numero","fr":"Num\xe9ro de ligne","fr-FR":"Num\xe9ro de ligne","he-IL":"\u05DE\u05E1\u05E4\u05E8 \u05E9\u05D5\u05E8\u05D4","hr-HR":"Broj retka","hu":"Sor sz\xe1ma","hu-HU":"Sor sz\xe1ma","it":"Numero riga","it-IT":"Numero riga","ja":"\u884C\u756A\u53F7","ja-JP":"\u884C\u756A\u53F7","ko":"\uD589 \uBC88\uD638","ko-KR":"\uD589 \uBC88\uD638","nl":"Rijnummer","nl-NL":"Rijnummer","no-NO":"Radnummer","pl":"Numer rz\u0119du","pl-PL":"Numer rz\u0119du","pt-BR":"N\xfamero da linha","pt-PT":"N\xfamero da linha","ru":"\u041D\u043E\u043C\u0435\u0440 \u0441\u0442\u0440\u043E\u043A\u0438","ru-RU":"\u041D\u043E\u043C\u0435\u0440 \u0441\u0442\u0440\u043E\u043A\u0438","sv":"Radnummer","sv-SE":"Radnummer","th":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E41\u0E16\u0E27","th-TH":"\u0E2B\u0E21\u0E32\u0E22\u0E40\u0E25\u0E02\u0E41\u0E16\u0E27","tr":"S\u0131ra Numaras\u0131","tr-TR":"S\u0131ra Numaras\u0131"},"RL_StyleColor1":{"key":"RL_StyleColor1","en":"Style-Color","ca":"Producte","ca-ES":"Producte","cs":"Barva stylu","cs-CZ":"Barva stylu","da":"Modelfarve","da-DK":"Modelfarve","de":"Style-/Farbcode","de-DE":"Style-/Farbcode","el":"\u03A3\u03C4\u03B9\u03BB-\u03A7\u03C1\u03CE\u03BC\u03B1","el-GR":"\u03A3\u03C4\u03B9\u03BB-\u03A7\u03C1\u03CE\u03BC\u03B1","en-GB":"Style colour","es":"Modelo-color","es-ES":"Modelo-color","fi-FI":"StyleColor","fr":"Style-coloris","fr-FR":"Style-coloris","he-IL":"\u05E1\u05D2\u05E0\u05D5\u05DF-\u05E6\u05D1\u05E2","hr-HR":"Style-Color","hu":"St\xedlus\u2013sz\xedn","hu-HU":"St\xedlus\u2013sz\xedn","it":"Modello-colore","it-IT":"Modello-colore","ja":"Style-Color","ja-JP":"Style-Color","ko":"\uC2A4\uD0C0\uC77C-\uCEEC\uB7EC","ko-KR":"\uC2A4\uD0C0\uC77C-\uCEEC\uB7EC","nl":"Stijl/kleur","nl-NL":"Stijl/kleur","no-NO":"Produktfarge","pl":"Model/kolor","pl-PL":"Model/kolor","pt-BR":"Cor-Estilo","pt-PT":"Estilo-cor","ru":"\u041C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430","ru-RU":"\u041C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430","sv":"Modellf\xe4rg","sv-SE":"Modellf\xe4rg","th":"\u0E2A\u0E44\u0E15\u0E25\u0E4C-\u0E2A\u0E35","th-TH":"\u0E2A\u0E44\u0E15\u0E25\u0E4C-\u0E2A\u0E35","tr":"Stil-Renk","tr-TR":"Stil-Renk"},"RL_UploadStatus":{"key":"RL_UploadStatus","en":"Upload Status","ca":"Estat de la pujada","ca-ES":"Estat de la pujada","cs":"Stav nahr\xe1v\xe1n\xed","cs-CZ":"Stav nahr\xe1v\xe1n\xed","da":"Status p\xe5 upload","da-DK":"Status p\xe5 upload","de":"Upload-Status","de-DE":"Upload-Status","el":"\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03BC\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2","el-GR":"\u039A\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7 \u03BC\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7\u03C2","en-GB":"Upload status","es":"Estado de la carga","es-ES":"Estado de la carga","fi-FI":"Latauksen tila","fr":"Progression de l\'importation","fr-FR":"Progression de l\'importation","he-IL":"\u05DE\u05E6\u05D1 \u05D4\u05E2\u05DC\u05D0\u05D4","hr-HR":"Status prijenosa","hu":"Felt\xf6lt\xe9s \xe1llapota","hu-HU":"Felt\xf6lt\xe9s \xe1llapota","it":"Stato upload","it-IT":"Stato upload","ja":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u72B6\u6CC1","ja-JP":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u72B6\u6CC1","ko":"\uC5C5\uB85C\uB4DC \uC0C1\uD0DC","ko-KR":"\uC5C5\uB85C\uB4DC \uC0C1\uD0DC","nl":"Uploadstatus","nl-NL":"Uploadstatus","no-NO":"Status for opplasting","pl":"Status przesy\u0142ania","pl-PL":"Status przesy\u0142ania","pt-BR":"Status do upload","pt-PT":"Estado do carregamento","ru":"\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438","ru-RU":"\u0421\u0442\u0430\u0442\u0443\u0441 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438","sv":"Uppladdningsstatus","sv-SE":"Uppladdningsstatus","th":"\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14","th-TH":"\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14","tr":"Y\xfckleme Durumu","tr-TR":"Y\xfckleme Durumu"},"RL_Errors":{"key":"RL_Errors","en":"Errors","ca":"Errors","ca-ES":"Errors","cs":"Chyby","cs-CZ":"Chyby","da":"Fejl","da-DK":"Fejl","de":"Fehler","de-DE":"Fehler","el":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1\u03C4\u03B1","el-GR":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1\u03C4\u03B1","en-GB":"Errors","es":"Errores","es-ES":"Errores","fi-FI":"Virheet","fr":"Erreurs","fr-FR":"Erreurs","he-IL":"\u05E9\u05D2\u05D9\u05D0\u05D5\u05EA","hr-HR":"Pogre\u0161ke","hu":"Hiba","hu-HU":"Hiba","it":"Errori","it-IT":"Errori","ja":"\u30A8\u30E9\u30FC","ja-JP":"\u30A8\u30E9\u30FC","ko":"\uC624\uB958","ko-KR":"\uC624\uB958","nl":"Foutmeldingen","nl-NL":"Foutmeldingen","no-NO":"Feil","pl":"B\u0142\u0119dy","pl-PL":"B\u0142\u0119dy","pt-BR":"Erros","pt-PT":"Erros","ru":"\u041E\u0448\u0438\u0431\u043A\u0438","ru-RU":"\u041E\u0448\u0438\u0431\u043A\u0438","sv":"Fel","sv-SE":"Fel","th":"\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14","th-TH":"\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14","tr":"Hatalar","tr-TR":"Hatalar"},"RL_Success":{"key":"RL_Success","en":"Success","ca":"Correcte","ca-ES":"Correcte","cs":"Povedlo se","cs-CZ":"Povedlo se","da":"Gennemf\xf8rt","da-DK":"Gennemf\xf8rt","de":"Erfolgreich","de-DE":"Erfolgreich","el":"\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1","el-GR":"\u0395\u03C0\u03B9\u03C4\u03C5\u03C7\u03AF\u03B1","en-GB":"Success","es":"Completada","es-ES":"Completada","fi-FI":"Onnistui","fr":"Termin\xe9e avec succ\xe8s","fr-FR":"Termin\xe9e avec succ\xe8s","he-IL":"\u05D4\u05E6\u05DC\u05D7\u05D4","hr-HR":"Uspje\u0161no","hu":"Siker","hu-HU":"Siker","it":"Riuscito","it-IT":"Riuscito","ja":"\u6210\u529F","ja-JP":"\u6210\u529F","ko":"\uC644\uB8CC","ko-KR":"\uC644\uB8CC","nl":"Gelukt","nl-NL":"Gelukt","no-NO":"Fullf\xf8rt","pl":"Uda\u0142o si\u0119","pl-PL":"Uda\u0142o si\u0119","pt-BR":"Conclu\xeddo","pt-PT":"Sucesso","ru":"\u0423\u0441\u043F\u0435\u0448\u043D\u043E","ru-RU":"\u0423\u0441\u043F\u0435\u0448\u043D\u043E","sv":"Klar","sv-SE":"Klar","th":"\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08","th-TH":"\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08","tr":"Ba\u015Far\u0131l\u0131","tr-TR":"Ba\u015Far\u0131l\u0131"},"RL_StyleUpload1":{"key":"RL_StyleUpload1","en":"Styles Upload","ca":"Pujada de productes","ca-ES":"Pujada de productes","cs":"Nahr\xe1v\xe1n\xed styl\u016F","cs-CZ":"Nahr\xe1v\xe1n\xed styl\u016F","da":"Upload modeller","da-DK":"Upload modeller","de":"Style-Upload","de-DE":"Style-Upload","el":"\u039C\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03C3\u03C4\u03B9\u03BB","el-GR":"\u039C\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03C3\u03C4\u03B9\u03BB","en-GB":"Styles Upload","es":"Carga de productos","es-ES":"Carga de productos","fi-FI":"Tyylien lataaminen","fr":"Importation de mod\xe8les","fr-FR":"Importation de mod\xe8les","he-IL":"\u05D4\u05E2\u05DC\u05D0\u05EA \u05E1\u05D2\u05E0\u05D5\u05E0\u05D5\u05EA","hr-HR":"Prijenos modela","hu":"St\xedlusok felt\xf6lt\xe9se","hu-HU":"St\xedlusok felt\xf6lt\xe9se","it":"Upload modelli","it-IT":"Upload modelli","ja":"\u30B9\u30BF\u30A4\u30EB\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9","ja-JP":"\u30B9\u30BF\u30A4\u30EB\u306E\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9","ko":"\uC2A4\uD0C0\uC77C \uC5C5\uB85C\uB4DC","ko-KR":"\uC2A4\uD0C0\uC77C \uC5C5\uB85C\uB4DC","nl":"Stijlen uploaden","nl-NL":"Stijlen uploaden","no-NO":"Last opp produkter","pl":"Przesy\u0142anie modeli","pl-PL":"Przesy\u0142anie modeli","pt-BR":"Upload de estilos","pt-PT":"Carregamento de estilos","ru":"\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043C\u043E\u0434\u0435\u043B\u0435\u0439","ru-RU":"\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043C\u043E\u0434\u0435\u043B\u0435\u0439","sv":"Ladda upp modeller","sv-SE":"Ladda upp modeller","th":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E44\u0E15\u0E25\u0E4C","th-TH":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E44\u0E15\u0E25\u0E4C","tr":"Stil Y\xfckleme","tr-TR":"Stil Y\xfckleme"},"RL_Failure":{"key":"RL_Failure","en":"Failure","ca":"Error","ca-ES":"Error","cs":"Nepovedlo se","cs-CZ":"Nepovedlo se","da":"Fejl","da-DK":"Fejl","de":"Fehlgeschlagen","de-DE":"Fehlgeschlagen","el":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1","el-GR":"\u0391\u03C0\u03BF\u03C4\u03C5\u03C7\u03AF\u03B1","en-GB":"Failure","es":"Error","es-ES":"Error","fi-FI":"Ep\xe4onnistui","fr":"\xc9chec","fr-FR":"\xc9chec","he-IL":"\u05DB\u05E9\u05DC","hr-HR":"Neuspje\u0161no","hu":"Hiba","hu-HU":"Hiba","it":"Non riuscito","it-IT":"Non riuscito","ja":"\u5931\u6557","ja-JP":"\u5931\u6557","ko":"\uC2E4\uD328","ko-KR":"\uC2E4\uD328","nl":"Mislukt","nl-NL":"Mislukt","no-NO":"Mislyktes","pl":"Niepowodzenie","pl-PL":"Niepowodzenie","pt-BR":"N\xe3o conclu\xeddo","pt-PT":"Falha","ru":"\u0421\u0431\u043E\u0439","ru-RU":"\u0421\u0431\u043E\u0439","sv":"Misslyckades","sv-SE":"Misslyckades","th":"\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27","th-TH":"\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27","tr":"Ba\u015Far\u0131s\u0131z","tr-TR":"Ba\u015Far\u0131s\u0131z"},"RL_Waiting":{"key":"RL_Waiting","en":"Waiting","ca":"En espera","ca-ES":"En espera","cs":"\u010Cek\xe1 se","cs-CZ":"\u010Cek\xe1 se","da":"Venter","da-DK":"Venter","de":"Warten","de-DE":"Warten","el":"\u03A0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5","el-GR":"\u03A0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5","en-GB":"Waiting","es":"Esperando","es-ES":"Esperando","fi-FI":"Odota","fr":"En attente","fr-FR":"En attente","he-IL":"\u05D1\u05D4\u05DE\u05EA\u05E0\u05D4","hr-HR":"\u010Cekanje","hu":"V\xe1rakoz\xe1s","hu-HU":"V\xe1rakoz\xe1s","it":"In corso","it-IT":"In corso","ja":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044","ja-JP":"\u304A\u5F85\u3061\u304F\u3060\u3055\u3044","ko":"\uB300\uAE30 \uC911","ko-KR":"\uB300\uAE30 \uC911","nl":"Wachten...","nl-NL":"Wachten...","no-NO":"Venter","pl":"Oczekiwanie","pl-PL":"Oczekiwanie","pt-BR":"Aguardando","pt-PT":"A aguardar","ru":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435","ru-RU":"\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435","sv":"V\xe4ntar","sv-SE":"V\xe4ntar","th":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E2D","th-TH":"\u0E01\u0E33\u0E25\u0E31\u0E07\u0E23\u0E2D","tr":"Bekleniyor","tr-TR":"Bekleniyor"},"RL_PleaseWait":{"key":"RL_PleaseWait","en":"Please wait while the upload is in progress. Progress: {{1}}%","ca":"Espera mentre es completa la pujada. Progr\xe9s: {{1}}%","ca-ES":"Espera mentre es completa la pujada. Progr\xe9s: {{1}}%","cs":"Vy\u010Dkejte, dokud nahr\xe1v\xe1n\xed nen\xed dokon\u010Deno. Z {{1}} % dokon\u010Deno","cs-CZ":"Vy\u010Dkejte, dokud nahr\xe1v\xe1n\xed nen\xed dokon\u010Deno. Z {{1}} % dokon\u010Deno","da":"Vent, mens overf\xf8rslen er i gang. Status: {{1}}%","da-DK":"Vent, mens overf\xf8rslen er i gang. Status: {{1}}%","de":"Bitte warte, w\xe4hrend der Upload l\xe4uft. Fortschritt: {{1}} %","de-DE":"Bitte warte, w\xe4hrend der Upload l\xe4uft. Fortschritt: {{1}} %","el":"\u03A0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5 \u03CC\u03C3\u03BF \u03B7 \u03BC\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03B2\u03C1\u03AF\u03C3\u03BA\u03B5\u03C4\u03B1\u03B9 \u03C3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7. \u03A0\u03C1\u03CC\u03BF\u03B4\u03BF\u03C2{{1}}%","el-GR":"\u03A0\u03B5\u03C1\u03B9\u03BC\u03AD\u03BD\u03B5\u03C4\u03B5 \u03CC\u03C3\u03BF \u03B7 \u03BC\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03B2\u03C1\u03AF\u03C3\u03BA\u03B5\u03C4\u03B1\u03B9 \u03C3\u03B5 \u03B5\u03BE\u03AD\u03BB\u03B9\u03BE\u03B7. \u03A0\u03C1\u03CC\u03BF\u03B4\u03BF\u03C2{{1}}%","en-GB":"Please wait while the upload is in progress. Progress{{1}}%","es":"Espera mientras la carga est\xe1 en curso. Progreso: {{1}} %","es-ES":"Espera mientras la carga est\xe1 en curso. Progreso: {{1}} %","fi-FI":"Odota latauksen valmistumista. Edistyminen {{1}} %","fr":"Importation en cours. Merci de patienter. Progression : {{1}} %","fr-FR":"Importation en cours. Merci de patienter. Progression : {{1}} %","he-IL":"\u05D4\u05DE\u05EA\u05D9\u05E0\u05D5 \u05D1\u05D6\u05DE\u05DF \u05E9\u05D4\u05D4\u05E2\u05DC\u05D0\u05D4 \u05DE\u05EA\u05D1\u05E6\u05E2\u05EA. \u05D4\u05EA\u05E7\u05D3\u05DE\u05D5\u05EA: {{1}}%","hr-HR":"Prijenos je u tijeku. Pri\u010Dekajte. U tijeku{{1}} %","hu":"K\xe9rj\xfck, v\xe1rd meg a felt\xf6lt\xe9si folyamat v\xe9g\xe9t. Folyamat: {{1}}%","hu-HU":"K\xe9rj\xfck, v\xe1rd meg a felt\xf6lt\xe9si folyamat v\xe9g\xe9t. Folyamat: {{1}}%","it":"Upload in corso. Attendi il completamento. Avanzamento {{1}}%","it-IT":"Upload in corso. Attendi il completamento. Avanzamento {{1}}%","ja":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002 \u9032\u6357\uFF1A{{1}}\uFF05","ja-JP":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D\u3067\u3059\u3002\u3057\u3070\u3089\u304F\u304A\u5F85\u3061\u304F\u3060\u3055\u3044\u3002 \u9032\u6357\uFF1A{{1}}\uFF05","ko":"\uC5C5\uB85C\uB4DC\uAC00 \uC9C4\uD589\uB418\uB294 \uB3D9\uC548 \uAE30\uB2E4\uB824 \uC8FC\uC138\uC694. \uC9C4\uD589\uB960: {{1}}%","ko-KR":"\uC5C5\uB85C\uB4DC\uAC00 \uC9C4\uD589\uB418\uB294 \uB3D9\uC548 \uAE30\uB2E4\uB824 \uC8FC\uC138\uC694. \uC9C4\uD589\uB960: {{1}}%","nl":"Even geduld, de upload is bezig. Voortgang: {{1}}%","nl-NL":"Even geduld, de upload is bezig. Voortgang: {{1}}%","no-NO":"Vent mens opplastingen p\xe5g\xe5r. Fremdrift: {{1}}%","pl":"Poczekaj na zako\u0144czenie przesy\u0142ania. Przes\u0142ano{{1}}%","pl-PL":"Poczekaj na zako\u0144czenie przesy\u0142ania. Przes\u0142ano{{1}}%","pt-BR":"Aguarde enquanto o upload \xe9 realizado. Progresso: {{1}}%","pt-PT":"Aguarde enquanto o carregamento est\xe1 em curso. Progresso: {{1}}%","ru":"\u0414\u043E\u0436\u0434\u0438\u0442\u0435\u0441\u044C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441: {{1}}%","ru-RU":"\u0414\u043E\u0436\u0434\u0438\u0442\u0435\u0441\u044C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441: {{1}}%","sv":"V\xe4nta medan uppladdningen p\xe5g\xe5r. F\xf6rlopp{{1}}%","sv-SE":"V\xe4nta medan uppladdningen p\xe5g\xe5r. F\xf6rlopp{{1}}%","th":"\u0E42\u0E1B\u0E23\u0E14\u0E23\u0E2D\u0E02\u0E13\u0E30\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14 \u0E04\u0E27\u0E32\u0E21\u0E04\u0E37\u0E1A\u0E2B\u0E19\u0E49\u0E32{{1}}%","th-TH":"\u0E42\u0E1B\u0E23\u0E14\u0E23\u0E2D\u0E02\u0E13\u0E30\u0E01\u0E33\u0E25\u0E31\u0E07\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14 \u0E04\u0E27\u0E32\u0E21\u0E04\u0E37\u0E1A\u0E2B\u0E19\u0E49\u0E32{{1}}%","tr":"Y\xfckleme devam ediyor, l\xfctfen bekle. \u0130lerleme Durumu: %{{1}}","tr-TR":"Y\xfckleme devam ediyor, l\xfctfen bekle. \u0130lerleme Durumu: %{{1}}"},"RL_DownloadReport":{"key":"RL_DownloadReport","en":"\'Download Report\'","ca":"Descarrega l\'informe","ca-ES":"Descarrega l\'informe","cs":"St\xe1hnout p\u0159ehled","cs-CZ":"St\xe1hnout p\u0159ehled","da":"\\"Download rapport\\"","da-DK":"\\"Download rapport\\"","de":"\\"Bericht herunterladen\\"","de-DE":"\\"Bericht herunterladen\\"","el":"\\"\u039B\u03AE\u03C8\u03B7 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2\\"","el-GR":"\\"\u039B\u03AE\u03C8\u03B7 \u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC\u03C2\\"","en-GB":"Download Report","es":"Descargar informe","es-ES":"Descargar informe","fi-FI":"\\"Lataa raportti\\"","fr":"\xab T\xe9l\xe9charger le rapport \xbb","fr-FR":"\xab T\xe9l\xe9charger le rapport \xbb","he-IL":"\u05D4\u05D5\u05E8\u05D3\u05EA \u05D3\u05D5\u05D7","hr-HR":"\u201EIzvje\u0161\u0107e o preuzimanju\u201D","hu":"\u201EJelent\xe9s let\xf6lt\xe9se\u201D","hu-HU":"\u201EJelent\xe9s let\xf6lt\xe9se\u201D","it":"\\"Scarica il report\\"","it-IT":"\\"Scarica il report\\"","ja":"\'\u30EC\u30DD\u30FC\u30C8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\'","ja-JP":"\'\u30EC\u30DD\u30FC\u30C8\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\'","ko":"\'\uBCF4\uACE0\uC11C \uB2E4\uC6B4\uB85C\uB4DC\'","ko-KR":"\'\uBCF4\uACE0\uC11C \uB2E4\uC6B4\uB85C\uB4DC\'","nl":"\'Download rapport\'","nl-NL":"\'Download rapport\'","no-NO":"\xabLast ned rapport\xbb","pl":"\u201EPobierz raport\u201D","pl-PL":"\u201EPobierz raport\u201D","pt-BR":"\\"Baixar relat\xf3rio\\"","pt-PT":"\\"Transferir o relat\xf3rio\\"","ru":"\'\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043E\u0442\u0447\u0435\u0442\'","ru-RU":"\'\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043E\u0442\u0447\u0435\u0442\'","sv":"H\xe4mta rapporten","sv-SE":"H\xe4mta rapporten","th":"\'\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\'","th-TH":"\'\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E23\u0E32\u0E22\u0E07\u0E32\u0E19\'","tr":"\\"Raporu \u0130ndir\\"","tr-TR":"\\"Raporu \u0130ndir\\""},"RL_UploadMissing":{"key":"RL_UploadMissing","en":"The uploaded file is missing the following columns","ca":"Al fitxer que has pujat li falten les columnes seg\xfcents","ca-ES":"Al fitxer que has pujat li falten les columnes seg\xfcents","cs":"V nahran\xe9m souboru chyb\xed n\xe1sleduj\xedc\xed sloupce","cs-CZ":"V nahran\xe9m souboru chyb\xed n\xe1sleduj\xedc\xed sloupce","da":"Den fil, du uploadede, mangler f\xf8lgende kolonner","da-DK":"Den fil, du uploadede, mangler f\xf8lgende kolonner","de":"In der hochgeladenen Datei fehlen die folgenden Spalten","de-DE":"In der hochgeladenen Datei fehlen die folgenden Spalten","el":"\u03A4\u03BF \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03C4\u03C9\u03BC\u03AD\u03BD\u03BF \u03B1\u03C1\u03C7\u03B5\u03AF\u03BF \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C3\u03C4\u03AE\u03BB\u03B5\u03C2","el-GR":"\u03A4\u03BF \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03C4\u03C9\u03BC\u03AD\u03BD\u03BF \u03B1\u03C1\u03C7\u03B5\u03AF\u03BF \u03B4\u03B5\u03BD \u03AD\u03C7\u03B5\u03B9 \u03C4\u03B9\u03C2 \u03B1\u03BA\u03CC\u03BB\u03BF\u03C5\u03B8\u03B5\u03C2 \u03C3\u03C4\u03AE\u03BB\u03B5\u03C2","en-GB":"The uploaded file is missing the following columns","es":"En el archivo cargado faltan las siguientes columnas","es-ES":"En el archivo cargado faltan las siguientes columnas","fi-FI":"Ladatusta tiedostosta puuttuvat seuraavat sarakkeet","fr":"Le fichier import\xe9 ne contient pas les colonnes suivantes","fr-FR":"Le fichier import\xe9 ne contient pas les colonnes suivantes","he-IL":"\u05D1\u05E7\u05D5\u05D1\u05E5 \u05E9\u05D4\u05D5\u05E2\u05DC\u05D4 \u05D7\u05E1\u05E8\u05D5\u05EA \u05D4\u05E2\u05DE\u05D5\u05D3\u05D5\u05EA \u05D4\u05D1\u05D0\u05D5\u05EA","hr-HR":"Prenesenoj datoteci nedostaju sljede\u0107i stupci","hu":"A felt\xf6lt\xf6tt f\xe1jlb\xf3l hi\xe1nyoznak az al\xe1bbi oszlopok","hu-HU":"A felt\xf6lt\xf6tt f\xe1jlb\xf3l hi\xe1nyoznak az al\xe1bbi oszlopok","it":"Il file caricato non include le seguenti colonne","it-IT":"Il file caricato non include le seguenti colonne","ja":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u306B\u306F\u4EE5\u4E0B\u306E\u5217\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059","ja-JP":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u306B\u306F\u4EE5\u4E0B\u306E\u5217\u304C\u4E0D\u8DB3\u3057\u3066\u3044\u307E\u3059","ko":"\uC5C5\uB85C\uB4DC\uB41C \uD30C\uC77C\uC5D0 \uB2E4\uC74C \uC5F4\uC774 \uB204\uB77D\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4","ko-KR":"\uC5C5\uB85C\uB4DC\uB41C \uD30C\uC77C\uC5D0 \uB2E4\uC74C \uC5F4\uC774 \uB204\uB77D\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4","nl":"In het ge\xfcploade bestand ontbreken de volgende kolommen","nl-NL":"In het ge\xfcploade bestand ontbreken de volgende kolommen","no-NO":"Den opplastede filen mangler f\xf8lgende kolonner","pl":"W przes\u0142anym pliku brakuje nast\u0119puj\u0105cych kolumn","pl-PL":"W przes\u0142anym pliku brakuje nast\u0119puj\u0105cych kolumn","pt-BR":"O arquivo enviado n\xe3o tem as seguintes colunas","pt-PT":"O ficheiro carregado tem as seguintes colunas em falta","ru":"\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0439 \u0444\u0430\u0439\u043B \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0441\u0442\u043E\u043B\u0431\u0446\u0430\u0445","ru-RU":"\u0417\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u0439 \u0444\u0430\u0439\u043B \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u0441\u0442\u043E\u043B\u0431\u0446\u0430\u0445","sv":"Den uppladdade filen saknar f\xf6ljande kolumner","sv-SE":"Den uppladdade filen saknar f\xf6ljande kolumner","th":"\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E02\u0E32\u0E14\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49","th-TH":"\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E02\u0E32\u0E14\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E19\u0E35\u0E49","tr":"Y\xfcklenen dosyada a\u015Fa\u011F\u0131daki s\xfctunlar eksik","tr-TR":"Y\xfcklenen dosyada a\u015Fa\u011F\u0131daki s\xfctunlar eksik"},"RL_Validate":{"key":"RL_Validate","en":"The uploaded file has {{1}} rows. Please upload a file with maximum of {{2}} Style Colors.","ca":"El fitxer que has pujat t\xe9 {{1}} files. Puja un fitxer amb {{2}} productes com a m\xe0xim.","ca-ES":"El fitxer que has pujat t\xe9 {{1}} files. Puja un fitxer amb {{2}} productes com a m\xe0xim.","cs":"Nahran\xfd soubor m\xe1 {{1}} \u0159\xe1dk\u016F. Nahrajte pros\xedm soubor s maxim\xe1ln\u011B {{2}} barvami styl\u016F.","cs-CZ":"Nahran\xfd soubor m\xe1 {{1}} \u0159\xe1dk\u016F. Nahrajte pros\xedm soubor s maxim\xe1ln\u011B {{2}} barvami styl\u016F.","da":"Den fil, du uploadede, har {{1}} r\xe6kker. Du kan maksimalt uploade {{2}} modelfarver.","da-DK":"Den fil, du uploadede, har {{1}} r\xe6kker. Du kan maksimalt uploade {{2}} modelfarver.","de":"Die hochgeladene Datei hat {{1}} Zeilen. Bitte lade eine Datei mit maximal {{2}} Style-/Farbcodes hoch.","de-DE":"Die hochgeladene Datei hat {{1}} Zeilen. Bitte lade eine Datei mit maximal {{2}} Style-/Farbcodes hoch.","el":"\u03A4\u03BF \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03C4\u03C9\u03BC\u03AD\u03BD\u03BF \u03B1\u03C1\u03C7\u03B5\u03AF\u03BF \u03AD\u03C7\u03B5\u03B9 {{1}} \u03B3\u03C1\u03B1\u03BC\u03BC\u03AD\u03C2. \u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03C1\u03C7\u03B5\u03AF\u03BF \u03BC\u03B5 \u03AD\u03C9\u03C2 {{2}} \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03B1.","el-GR":"\u03A4\u03BF \u03BC\u03B5\u03C4\u03B1\u03C6\u03BF\u03C1\u03C4\u03C9\u03BC\u03AD\u03BD\u03BF \u03B1\u03C1\u03C7\u03B5\u03AF\u03BF \u03AD\u03C7\u03B5\u03B9 {{1}} \u03B3\u03C1\u03B1\u03BC\u03BC\u03AD\u03C2. \u0391\u03BD\u03B5\u03B2\u03AC\u03C3\u03C4\u03B5 \u03AD\u03BD\u03B1 \u03B1\u03C1\u03C7\u03B5\u03AF\u03BF \u03BC\u03B5 \u03AD\u03C9\u03C2 {{2}} \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03B1.","en-GB":"The uploaded file has {{1}} rows. Please upload a file with a maximum of {{2}} style colours.","es":"El archivo cargado tiene {{1}} filas. Carga un archivo con un m\xe1ximo de {{2}} productos.","es-ES":"El archivo cargado tiene {{1}} filas. Carga un archivo con un m\xe1ximo de {{2}} productos.","fi-FI":"Ladatussa tiedostossa on ((1)) rivi\xe4. Lataa tiedosto, jossa on enint\xe4\xe4n ((2)) StyleColoria.","fr":"Le fichier import\xe9 contient {{1}} ligne(s). Le fichier import\xe9 doit contenir {{2}} style-coloris maximum.","fr-FR":"Le fichier import\xe9 contient {{1}} ligne(s). Le fichier import\xe9 doit contenir {{2}} style-coloris maximum.","he-IL":"\u05D4\u05E7\u05D5\u05D1\u05E5 \u05E9\u05D4\u05D5\u05E2\u05DC\u05D4 \u05DE\u05DB\u05D9\u05DC {{1}} \u05E9\u05D5\u05E8\u05D5\u05EA. \u05E6\u05E8\u05D9\u05DA \u05DC\u05D4\u05E2\u05DC\u05D5\u05EA \u05E7\u05D5\u05D1\u05E5 \u05E2\u05DD {{2}} \u05E1\u05D2\u05E0\u05D5\u05E0\u05D5\u05EA-\u05E6\u05D1\u05E2\u05D9\u05DD \u05DC\u05DB\u05DC \u05D4\u05D9\u05D5\u05EA\u05E8.","hr-HR":"Prenesena datoteka ima {{1}} redaka. Prenesite datoteku koja sadr\u017Ei najvi\u0161e {{2}} parametra Style Colors.","hu":"A felt\xf6lt\xf6tt f\xe1jlban {{1}} sor van. K\xe9rj\xfck, legfeljebb {{1}} st\xedlus\u2013sz\xednt tartalmaz\xf3 f\xe1jlt t\xf6lts fel.","hu-HU":"A felt\xf6lt\xf6tt f\xe1jlban {{1}} sor van. K\xe9rj\xfck, legfeljebb {{1}} st\xedlus\u2013sz\xednt tartalmaz\xf3 f\xe1jlt t\xf6lts fel.","it":"Il file caricato include il seguente numero di righe: {{1}}. Carica un file con un massimo di {{2}} modelli-colore.","it-IT":"Il file caricato include il seguente numero di righe: {{1}}. Carica un file con un massimo di {{2}} modelli-colore.","ja":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u306B\u306F{{1}}\u4EF6\u306E\u884C\u304C\u3042\u308A\u307E\u3059\u3002 \u6700\u5927{{2}}\u4EF6\u306EStyle Color\u304C\u542B\u307E\u308C\u308B\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ja-JP":"\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3055\u308C\u305F\u30D5\u30A1\u30A4\u30EB\u306B\u306F{{1}}\u4EF6\u306E\u884C\u304C\u3042\u308A\u307E\u3059\u3002 \u6700\u5927{{2}}\u4EF6\u306EStyle Color\u304C\u542B\u307E\u308C\u308B\u30D5\u30A1\u30A4\u30EB\u3092\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ko":"\uC5C5\uB85C\uB4DC\uD55C \uD30C\uC77C\uC5D0 {{1}}\uAC1C\uC758 \uD589\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uCD5C\uB300 {{2}}\uAC1C\uC758 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uAC00 \uD3EC\uD568\uB41C \uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD558\uC138\uC694.","ko-KR":"\uC5C5\uB85C\uB4DC\uD55C \uD30C\uC77C\uC5D0 {{1}}\uAC1C\uC758 \uD589\uC774 \uC788\uC2B5\uB2C8\uB2E4. \uCD5C\uB300 {{2}}\uAC1C\uC758 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uAC00 \uD3EC\uD568\uB41C \uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD558\uC138\uC694.","nl":"Het ge\xfcploade bestand heeft {{1}} rijen. Upload een bestand met maximaal {{2}} stijlen/kleuren.","nl-NL":"Het ge\xfcploade bestand heeft {{1}} rijen. Upload een bestand met maximaal {{2}} stijlen/kleuren.","no-NO":"Den opplastede filen har {{1}} rader. Last opp en fil med maksimalt {{2}} produktfarger.","pl":"Rz\u0119dy w przes\u0142anym pliku: {{1}}. Maksymalna liczba modeli/kolor\xf3w w przesy\u0142any pliku: {{2}}.","pl-PL":"Rz\u0119dy w przes\u0142anym pliku: {{1}}. Maksymalna liczba modeli/kolor\xf3w w przesy\u0142any pliku: {{2}}.","pt-BR":"O arquivo enviado tem {{1}} linhas. Fa\xe7a upload de um arquivo com no m\xe1ximo {{2}} cores de estilo.","pt-PT":"O ficheiro carregado tem {{1}} linhas. Carregue um ficheiro com, no m\xe1ximo, {{2}} estilos-cores.","ru":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0442\u0440\u043E\u043A \u0432 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u043E\u043C \u0444\u0430\u0439\u043B\u0435: {{1}}. \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u0441 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u043C \u043C\u043E\u0434\u0435\u043B\u0435\u0439/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043E\u043A, \u043D\u0435 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u044E\u0449\u0435\u043C {{2}}.","ru-RU":"\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0442\u0440\u043E\u043A \u0432 \u0437\u0430\u0433\u0440\u0443\u0436\u0435\u043D\u043D\u043E\u043C \u0444\u0430\u0439\u043B\u0435: {{1}}. \u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B \u0441 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u043C \u043C\u043E\u0434\u0435\u043B\u0435\u0439/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043E\u043A, \u043D\u0435 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u044E\u0449\u0435\u043C {{2}}.","sv":"Den uppladdade filen har {{1}} rader. Ladda upp en fil med max {{2}} modellf\xe4rger.","sv-SE":"Den uppladdade filen har {{1}} rader. Ladda upp en fil med max {{2}} modellf\xe4rger.","th":"\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E21\u0E35 {{1}} \u0E41\u0E16\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 {{2}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","th-TH":"\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E21\u0E35 {{1}} \u0E41\u0E16\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E1F\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 {{2}} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23","tr":"Y\xfcklenen dosyada {{1}} sat\u0131r var. L\xfctfen en fazla {{2}} Stil-Renk bulunan bir dosya y\xfckle.","tr-TR":"Y\xfcklenen dosyada {{1}} sat\u0131r var. L\xfctfen en fazla {{2}} Stil-Renk bulunan bir dosya y\xfckle."},"RL_Error1":{"key":"RL_Error1","en":"Only Clearance Styles can be uploaded (i.e. Price = *.97)","ca":"Nom\xe9s es poden pujar productes en liquidaci\xf3 (amb preu = *,97)","ca-ES":"Nom\xe9s es poden pujar productes en liquidaci\xf3 (amb preu = *,97)","cs":"Nahr\xe1ny mohou b\xfdt pouze styly z likvidace z\xe1sob (nap\u0159. cena = *.97)","cs-CZ":"Nahr\xe1ny mohou b\xfdt pouze styly z likvidace z\xe1sob (nap\u0159. cena = *.97)","da":"Du kan kun uploade udsalgsmodeller (f.eks. Pris = *,97)","da-DK":"Du kan kun uploade udsalgsmodeller (f.eks. Pris = *,97)","de":"Nur reduzierte Styles k\xf6nnen hochgeladen werden (d. h. Preis = *,97)","de-DE":"Nur reduzierte Styles k\xf6nnen hochgeladen werden (d. h. Preis = *,97)","el":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03B5\u03B2\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BC\u03CC\u03BD\u03BF \u03C3\u03C4\u03B9\u03BB \u03C3\u03B5 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC (\u03B4\u03B7\u03BB\u03B1\u03B4\u03AE \u03BC\u03B5 \u03C4\u03B9\u03BC\u03AE = *,97)","el-GR":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03B5\u03B2\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BC\u03CC\u03BD\u03BF \u03C3\u03C4\u03B9\u03BB \u03C3\u03B5 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC (\u03B4\u03B7\u03BB\u03B1\u03B4\u03AE \u03BC\u03B5 \u03C4\u03B9\u03BC\u03AE = *,97)","en-GB":"Only sale styles can be uploaded (i.e. price = *.97)","es":"Solo se pueden cargar productos de liquidaci\xf3n (Precio = *,97)","es-ES":"Solo se pueden cargar productos de liquidaci\xf3n (Precio = *,97)","fi-FI":"Voit ladata ainoastaan alennuksessa olevia tyylej\xe4 (esim. hinta. =*.97)","fr":"Seuls les articles de d\xe9stockage peuvent \xeatre import\xe9s (par exemple, prix = *,97)","fr-FR":"Seuls les articles de d\xe9stockage peuvent \xeatre import\xe9s (par exemple, prix = *,97)","he-IL":"\u05D0\u05E4\u05E9\u05E8 \u05DC\u05D4\u05E2\u05DC\u05D5\u05EA \u05E8\u05E7 \u05E1\u05D2\u05E0\u05D5\u05E0\u05D5\u05EA \u05E2\u05D5\u05D3\u05E4\u05D9\u05DD (\u05DB\u05DC\u05D5\u05DE\u05E8 \u05E9\u05D4\u05DE\u05D7\u05D9\u05E8 \u05DE\u05E1\u05EA\u05D9\u05D9\u05DD \u05D1-\u200E*.97)","hr-HR":"Mogu se prenijeti samo \u201EModeli na rasprodaji\u201D (npr. cijena = *.97)","hu":"Csak a ki\xe1rus\xedt\xe1sban r\xe9szt vev\u0151 st\xedlusok t\xf6lthet\u0151k fel (azaz \xe1r = *.97)","hu-HU":"Csak a ki\xe1rus\xedt\xe1sban r\xe9szt vev\u0151 st\xedlusok t\xf6lthet\u0151k fel (azaz \xe1r = *.97)","it":"Solo i modelli scontati possono essere caricati (prezzo = *,97)","it-IT":"Solo i modelli scontati possono essere caricati (prezzo = *,97)","ja":"\u30BB\u30FC\u30EB\u4E2D\u306E\u30B9\u30BF\u30A4\u30EB\u306E\u307F\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u53EF\u80FD\u3067\u3059\uFF08\u4F8B\uFF1A\u4FA1\u683C= *.97\uFF09","ja-JP":"\u30BB\u30FC\u30EB\u4E2D\u306E\u30B9\u30BF\u30A4\u30EB\u306E\u307F\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u53EF\u80FD\u3067\u3059\uFF08\u4F8B\uFF1A\u4FA1\u683C= *.97\uFF09","ko":"\uAC00\uACA9 \uC778\uD558 \uC2A4\uD0C0\uC77C\uB9CC \uC5C5\uB85C\uB4DC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4(\uC608: \uAC00\uACA9 = *.97)","ko-KR":"\uAC00\uACA9 \uC778\uD558 \uC2A4\uD0C0\uC77C\uB9CC \uC5C5\uB85C\uB4DC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4(\uC608: \uAC00\uACA9 = *.97)","nl":"Alleen afgeprijsde stijlen kunnen worden ge\xfcpload (d.w.z. prijs = *.97)","nl-NL":"Alleen afgeprijsde stijlen kunnen worden ge\xfcpload (d.w.z. prijs = *.97)","no-NO":"Bare salgsprodukter kan lastes opp (dvs. pris = *,97)","pl":"Mo\u017Cna przes\u0142a\u0107 tylko modele/kolory z outlet\xf3w (tj. cena = *.97)","pl-PL":"Mo\u017Cna przes\u0142a\u0107 tylko modele/kolory z outlet\xf3w (tj. cena = *.97)","pt-BR":"\xc9 poss\xedvel fazer upload apenas de estilos em liquida\xe7\xe3o (ou seja, pre\xe7o = *,97)","pt-PT":"S\xf3 \xe9 poss\xedvel carregar estilos em liquida\xe7\xe3o (por exemplo: pre\xe7o = *,97)","ru":"\u041C\u043E\u0436\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u043C\u043E\u0434\u0435\u043B\u0438 \u0438\u0437 \u0440\u0430\u0441\u043F\u0440\u043E\u0434\u0430\u0436\u0438 (\u0442\u043E \u0435\u0441\u0442\u044C \u043F\u043E \u0446\u0435\u043D\u0435 \u0441 \u043A\u043E\u044D\u0444\u0444\u0438\u0446\u0438\u0435\u043D\u0442\u043E\u043C *0,97)","ru-RU":"\u041C\u043E\u0436\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u043C\u043E\u0434\u0435\u043B\u0438 \u0438\u0437 \u0440\u0430\u0441\u043F\u0440\u043E\u0434\u0430\u0436\u0438 (\u0442\u043E \u0435\u0441\u0442\u044C \u043F\u043E \u0446\u0435\u043D\u0435 \u0441 \u043A\u043E\u044D\u0444\u0444\u0438\u0446\u0438\u0435\u043D\u0442\u043E\u043C *0,97)","sv":"Endast reamodeller kan laddas upp (dvs. pris = *,97)","sv-SE":"Endast reamodeller kan laddas upp (dvs. pris = *,97)","th":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E14\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E25\u0E49\u0E32\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 (\u0E40\u0E0A\u0E48\u0E19 \u0E23\u0E32\u0E04\u0E32 = *.97)","th-TH":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E14\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E25\u0E49\u0E32\u0E07\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 (\u0E40\u0E0A\u0E48\u0E19 \u0E23\u0E32\u0E04\u0E32 = *.97)","tr":"Yaln\u0131zca Seri Sonu Stilleri y\xfcklenebilir (\xf6r. Fiyat = *.97)","tr-TR":"Yaln\u0131zca Seri Sonu Stilleri y\xfcklenebilir (\xf6r. Fiyat = *.97)"},"RL_Error2":{"key":"RL_Error2","en":"The StyleColor is not found in CPA for this country","ca":"Aquest producte no es troba a la CPA d\'aquest pa\xeds/regi\xf3","ca-ES":"Aquest producte no es troba a la CPA d\'aquest pa\xeds/regi\xf3","cs":"Barva stylu se v CPA pro tuto zemi nenach\xe1z\xed","cs-CZ":"Barva stylu se v CPA pro tuto zemi nenach\xe1z\xed","da":"Modelfarven findes ikke i CPA for dette land","da-DK":"Modelfarven findes ikke i CPA for dette land","de":"Der Style-/Farbcode konnte nicht in der CPA f\xfcr dieses Land gefunden werden","de-DE":"Der Style-/Farbcode konnte nicht in der CPA f\xfcr dieses Land gefunden werden","el":"\u03A4\u03BF \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1 \u03B4\u03B5\u03BD \u03B2\u03C1\u03AF\u03C3\u03BA\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03BF CPA \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03C7\u03CE\u03C1\u03B1","el-GR":"\u03A4\u03BF \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1 \u03B4\u03B5\u03BD \u03B2\u03C1\u03AF\u03C3\u03BA\u03B5\u03C4\u03B1\u03B9 \u03C3\u03C4\u03BF CPA \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03AE \u03C4\u03B7 \u03C7\u03CE\u03C1\u03B1","en-GB":"The style colour is not found in the CPA for this country/region","es":"El modelo-color no se encuentra en CPA para este pa\xeds/regi\xf3n.","es-ES":"El modelo-color no se encuentra en CPA para este pa\xeds/regi\xf3n.","fi-FI":"StyleColoria ei l\xf6ydetty t\xe4m\xe4n maan CPA:sta","fr":"Le style-coloris est introuvable dans le CPA de ce pays/cette r\xe9gion","fr-FR":"Le style-coloris est introuvable dans le CPA de ce pays/cette r\xe9gion","he-IL":"\u05D4\u05E1\u05D2\u05E0\u05D5\u05DF-\u05E6\u05D1\u05E2 \u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0 \u05D1-CPA \u05E9\u05DC \u05D4\u05DE\u05D3\u05D9\u05E0\u05D4 \u05D4\u05D6\u05D5","hr-HR":"Parametar model-boja nije prona\u0111en u CPA za ovu dr\u017Eavu","hu":"Ez a st\xedlus\u2013sz\xedn nem szerepel a CPA-ban ebben az orsz\xe1gban","hu-HU":"Ez a st\xedlus\u2013sz\xedn nem szerepel a CPA-ban ebben az orsz\xe1gban","it":"Modello-colore non trovato in CPA per questo Paese","it-IT":"Modello-colore non trovato in CPA per questo Paese","ja":"StyleColor\u304C\u3053\u306E\u56FD\uFF0F\u5730\u57DF\u306ECPA\u5185\u306B\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F","ja-JP":"StyleColor\u304C\u3053\u306E\u56FD\uFF0F\u5730\u57DF\u306ECPA\u5185\u306B\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F","ko":"\uC774 \uAD6D\uAC00\uC758 \uC18C\uBE44\uC790 \uC81C\uD488 API\uC5D0\uC11C \uD574\uB2F9 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4","ko-KR":"\uC774 \uAD6D\uAC00\uC758 \uC18C\uBE44\uC790 \uC81C\uD488 API\uC5D0\uC11C \uD574\uB2F9 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4","nl":"De stijl/kleur is niet gevonden in CPA voor dit land","nl-NL":"De stijl/kleur is niet gevonden in CPA voor dit land","no-NO":"Produktfargen finnes ikke i CPA for dette landet","pl":"Model/kolor nie wyst\u0119puje w CPA dla tego kraju","pl-PL":"Model/kolor nie wyst\u0119puje w CPA dla tego kraju","pt-BR":"A CorEstilo n\xe3o foi encontrada na CPA deste pa\xeds","pt-PT":"O estilo-cor n\xe3o est\xe1 dispon\xedvel no CPA deste pa\xeds","ru":"\u041C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u0432 CPA \u0434\u043B\u044F \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u044B","ru-RU":"\u041C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u0430 \u0432 CPA \u0434\u043B\u044F \u044D\u0442\u043E\u0439 \u0441\u0442\u0440\u0430\u043D\u044B","sv":"Modellf\xe4rgen finns inte i CPA f\xf6r det h\xe4r landet","sv-SE":"Modellf\xe4rgen finns inte i CPA f\xf6r det h\xe4r landet","th":"\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E19\u0E35\u0E49\u0E43\u0E19 CPA \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E19\u0E35\u0E49","th-TH":"\u0E44\u0E21\u0E48\u0E1E\u0E1A\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E19\u0E35\u0E49\u0E43\u0E19 CPA \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E19\u0E35\u0E49","tr":"Stil-Renk bu \xfclke i\xe7in CPA\'da bulunamad\u0131","tr-TR":"Stil-Renk bu \xfclke i\xe7in CPA\'da bulunamad\u0131"},"RL_Error3":{"key":"RL_Error3","en":"Error while adding StyelColors to Promotion","ca":"S\'ha produ\xeft un error en afegir productes a la promoci\xf3","ca-ES":"S\'ha produ\xeft un error en afegir productes a la promoci\xf3","cs":"Chyba p\u0159i p\u0159id\xe1v\xe1n\xed barev styl\u016F do promoakce","cs-CZ":"Chyba p\u0159i p\u0159id\xe1v\xe1n\xed barev styl\u016F do promoakce","da":"Fejl under tilf\xf8jelse af modelfarver til kampagnen","da-DK":"Fejl under tilf\xf8jelse af modelfarver til kampagnen","de":"Fehler beim Hinzuf\xfcgen der Style-Farben zum Angebot","de-DE":"Fehler beim Hinzuf\xfcgen der Style-Farben zum Angebot","el":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03C9\u03BC\u03AC\u03C4\u03C9\u03BD \u03C3\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC","el-GR":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03C9\u03BC\u03AC\u03C4\u03C9\u03BD \u03C3\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC","en-GB":"Error while adding style colours to promotion","es":"Se ha producido un error al a\xf1adir el modelo-color a la promoci\xf3n","es-ES":"Se ha producido un error al a\xf1adir el modelo-color a la promoci\xf3n","fi-FI":"Virhe StyleColorien lis\xe4\xe4misess\xe4 kampanjaan","fr":"Une erreur est survenue lors de l\'importation du style-coloris aux promotions","fr-FR":"Une erreur est survenue lors de l\'importation du style-coloris aux promotions","he-IL":"\u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05D4\u05D5\u05E1\u05E4\u05EA \u05E1\u05D2\u05E0\u05D5\u05E0\u05D5\u05EA-\u05E6\u05D1\u05E2\u05D9\u05DD \u05DC\u05DE\u05D1\u05E6\u05E2","hr-HR":"Pogre\u0161ka prilikom dodavanja parametara model-boja u \u201EPromociju\u201D","hu":"Hiba t\xf6rt\xe9nt a st\xedlus\u2013sz\xedn prom\xf3ci\xf3hoz val\xf3 hozz\xe1ad\xe1sa sor\xe1n","hu-HU":"Hiba t\xf6rt\xe9nt a st\xedlus\u2013sz\xedn prom\xf3ci\xf3hoz val\xf3 hozz\xe1ad\xe1sa sor\xe1n","it":"Errore durante l\'aggiunta di modelli-colore alla promozione","it-IT":"Errore durante l\'aggiunta di modelli-colore alla promozione","ja":"StyleColor\u3092\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306B\u8FFD\u52A0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","ja-JP":"StyleColor\u3092\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306B\u8FFD\u52A0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","ko":"\uD504\uB85C\uBAA8\uC158\uC5D0 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uB97C \uCD94\uAC00\uD558\uB294 \uACFC\uC815\uC5D0\uC11C \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4","ko-KR":"\uD504\uB85C\uBAA8\uC158\uC5D0 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uB97C \uCD94\uAC00\uD558\uB294 \uACFC\uC815\uC5D0\uC11C \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4","nl":"Fout bij het toevoegen van stijlen/kleuren aan promotie","nl-NL":"Fout bij het toevoegen van stijlen/kleuren aan promotie","no-NO":"Feil under tilf\xf8yelse av produktfarger i kampanjen","pl":"B\u0142\u0105d podczas dodawania modelu/koloru do promocji","pl-PL":"B\u0142\u0105d podczas dodawania modelu/koloru do promocji","pt-BR":"Erro ao adicionar CoresEstilos \xe0 promo\xe7\xe3o","pt-PT":"Erro ao adicionar estilos-cores \xe0 promo\xe7\xe3o","ru":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043E\u043A \u0432 \u043F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u044E","ru-RU":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0438 \u043C\u043E\u0434\u0435\u043B\u0435\u0439/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043E\u043A \u0432 \u043F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u044E","sv":"Fel uppstod n\xe4r modellf\xe4rger lades till i kampanj","sv-SE":"Fel uppstod n\xe4r modellf\xe4rger lades till i kampanj","th":"\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E02\u0E13\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E44\u0E1B\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","th-TH":"\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E02\u0E13\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E44\u0E1B\u0E43\u0E19\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr":"Stil-Renkler Promosyona eklenirken hata olu\u015Ftu","tr-TR":"Stil-Renkler Promosyona eklenirken hata olu\u015Ftu"},"RL_Error4":{"key":"RL_Error4","en":"Error while updating the Promotion Status","ca":"S\'ha produ\xeft un error en actualitzar l\'estat de la promoci\xf3","ca-ES":"S\'ha produ\xeft un error en actualitzar l\'estat de la promoci\xf3","cs":"Chyba p\u0159i aktualizaci stavu promoakce","cs-CZ":"Chyba p\u0159i aktualizaci stavu promoakce","da":"Fejl under opdatering af kampagnestatus","da-DK":"Fejl under opdatering af kampagnestatus","de":"Fehler beim Aktualisieren des Angebotsstatus","de-DE":"Fehler beim Aktualisieren des Angebotsstatus","el":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7\u03BD \u03B5\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","el-GR":"\u03A3\u03C6\u03AC\u03BB\u03BC\u03B1 \u03BA\u03B1\u03C4\u03AC \u03C4\u03B7\u03BD \u03B5\u03BD\u03B7\u03BC\u03AD\u03C1\u03C9\u03C3\u03B7 \u03C4\u03B7\u03C2 \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AC\u03C2","en-GB":"Error while updating the promotion status","es":"Se ha producido un error al actualizar el estado de la promoci\xf3n","es-ES":"Se ha producido un error al actualizar el estado de la promoci\xf3n","fi-FI":"Virhe kampanjan tilan p\xe4ivitt\xe4misen yhteydess\xe4","fr":"Erreur lors de la mise \xe0 jour du statut de la promotion","fr-FR":"Erreur lors de la mise \xe0 jour du statut de la promotion","he-IL":"\u05E9\u05D2\u05D9\u05D0\u05D4 \u05D1\u05E2\u05D3\u05DB\u05D5\u05DF \u05DE\u05E6\u05D1 \u05D4\u05DE\u05D1\u05E6\u05E2","hr-HR":"Pogre\u0161ka prilikom a\u017Euriranja \u201EStatusa promocije\u201D","hu":"Hiba t\xf6rt\xe9nt a prom\xf3ci\xf3 \xe1llapot\xe1nak friss\xedt\xe9se k\xf6zben","hu-HU":"Hiba t\xf6rt\xe9nt a prom\xf3ci\xf3 \xe1llapot\xe1nak friss\xedt\xe9se k\xf6zben","it":"Errore durante l\'aggiornamento dello stato della promozione","it-IT":"Errore durante l\'aggiornamento dello stato della promozione","ja":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u3092\u66F4\u65B0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","ja-JP":"\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u306E\u30B9\u30C6\u30FC\u30BF\u30B9\u3092\u66F4\u65B0\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","ko":"\uD504\uB85C\uBAA8\uC158 \uC0C1\uD0DC\uB97C \uC5C5\uB370\uC774\uD2B8\uD558\uB294 \uACFC\uC815\uC5D0\uC11C \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4","ko-KR":"\uD504\uB85C\uBAA8\uC158 \uC0C1\uD0DC\uB97C \uC5C5\uB370\uC774\uD2B8\uD558\uB294 \uACFC\uC815\uC5D0\uC11C \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4","nl":"Fout bij het bijwerken van promotiestatus","nl-NL":"Fout bij het bijwerken van promotiestatus","no-NO":"Feil ved oppdatering av kampanjestatus","pl":"B\u0142\u0105d podczas aktualizowania statusu promocji","pl-PL":"B\u0142\u0105d podczas aktualizowania statusu promocji","pt-BR":"Erro ao atualizar o status da promo\xe7\xe3o","pt-PT":"Erro ao atualizar o estado da promo\xe7\xe3o","ru":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u043F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u0438","ru-RU":"\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0438 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u043F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u0438","sv":"Fel uppstod n\xe4r kampanjstatus uppdaterades","sv-SE":"Fel uppstod n\xe4r kampanjstatus uppdaterades","th":"\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E02\u0E13\u0E30\u0E2D\u0E31\u0E1E\u0E40\u0E14\u0E17\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","th-TH":"\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14\u0E02\u0E13\u0E30\u0E2D\u0E31\u0E1E\u0E40\u0E14\u0E17\u0E2A\u0E16\u0E32\u0E19\u0E30\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19","tr":"Promosyon Durumu g\xfcncellenirken hata olu\u015Ftu","tr-TR":"Promosyon Durumu g\xfcncellenirken hata olu\u015Ftu"},"RL_Error5":{"key":"RL_Error5","en":"Default Promotions are unavalable for this store","ca":"No hi ha promocions predeterminades disponibles per a aquesta botiga","ca-ES":"No hi ha promocions predeterminades disponibles per a aquesta botiga","cs":"V\xfdchoz\xed promoakce nejsou pro tuto prodejnu dostupn\xe9","cs-CZ":"V\xfdchoz\xed promoakce nejsou pro tuto prodejnu dostupn\xe9","da":"Standardkampagner er ikke tilg\xe6ngelige for denne butik","da-DK":"Standardkampagner er ikke tilg\xe6ngelige for denne butik","de":"Standardangebote sind f\xfcr diesen Store nicht verf\xfcgbar","de-DE":"Standardangebote sind f\xfcr diesen Store nicht verf\xfcgbar","el":"\u039F\u03B9 \u03C0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1","el-GR":"\u039F\u03B9 \u03C0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03C0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2 \u03B4\u03B5\u03BD \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B5\u03C2 \u03B3\u03B9\u03B1 \u03B1\u03C5\u03C4\u03CC \u03C4\u03BF \u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B7\u03BC\u03B1","en-GB":"Default promotions are unavailable for this store","es":"Las promociones predeterminadas no est\xe1n disponibles para esta tienda","es-ES":"Las promociones predeterminadas no est\xe1n disponibles para esta tienda","fi-FI":"Oletuskampanjat eiv\xe4t ole saatavana t\xe4ss\xe4 myym\xe4l\xe4ss\xe4","fr":"Les promotions par d\xe9faut ne sont pas disponibles pour ce magasin","fr-FR":"Les promotions par d\xe9faut ne sont pas disponibles pour ce magasin","he-IL":"\u05D0\u05D9\u05DF \u05DE\u05D1\u05E6\u05E2\u05D9 \u05D1\u05E8\u05D9\u05E8\u05EA \u05DE\u05D7\u05D3\u05DC \u05DC\u05D7\u05E0\u05D5\u05EA \u05D4\u05D6\u05D5","hr-HR":"Zadane \u201EPromocije\u201D nisu dostupne za ovo prodajno mjesto","hu":"Az alapprom\xf3ci\xf3k nem el\xe9rhet\u0151k ehhez az \xfczlethez","hu-HU":"Az alapprom\xf3ci\xf3k nem el\xe9rhet\u0151k ehhez az \xfczlethez","it":"Le promozioni predefinite non sono disponibili per questo punto vendita","it-IT":"Le promozioni predefinite non sono disponibili per questo punto vendita","ja":"\u3053\u306E\u30B9\u30C8\u30A2\u3067\u306F\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u5229\u7528\u3067\u304D\u307E\u305B\u3093","ja-JP":"\u3053\u306E\u30B9\u30C8\u30A2\u3067\u306F\u30C7\u30D5\u30A9\u30EB\u30C8\u306E\u30D7\u30ED\u30E2\u30FC\u30B7\u30E7\u30F3\u3092\u5229\u7528\u3067\u304D\u307E\u305B\u3093","ko":"\uC774 \uB9E4\uC7A5\uC5D0\uB294 \uAE30\uBCF8 \uD504\uB85C\uBAA8\uC158\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4","ko-KR":"\uC774 \uB9E4\uC7A5\uC5D0\uB294 \uAE30\uBCF8 \uD504\uB85C\uBAA8\uC158\uC744 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4","nl":"Standaardpromoties zijn niet beschikbaar voor deze store","nl-NL":"Standaardpromoties zijn niet beschikbaar voor deze store","no-NO":"Standardkampanjer er ikke tilgjengelig for denne butikken","pl":"Promocje domy\u015Blne nie s\u0105 dost\u0119pne dla tego sklepu","pl-PL":"Promocje domy\u015Blne nie s\u0105 dost\u0119pne dla tego sklepu","pt-BR":"Promo\xe7\xf5es padr\xe3o indispon\xedveis para esta loja","pt-PT":"As promo\xe7\xf5es predefinidas n\xe3o est\xe3o dispon\xedveis para esta loja","ru":"\u041F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u0438 \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430","ru-RU":"\u041F\u0440\u043E\u043C\u043E\u0430\u043A\u0446\u0438\u0438 \u043F\u043E \u0443\u043C\u043E\u043B\u0447\u0430\u043D\u0438\u044E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u0430","sv":"Standardkampanjer ej tillg\xe4ngliga f\xf6r den h\xe4r butiken","sv-SE":"Standardkampanjer ej tillg\xe4ngliga f\xf6r den h\xe4r butiken","th":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A Store \u0E19\u0E35\u0E49","th-TH":"\u0E44\u0E21\u0E48\u0E21\u0E35\u0E42\u0E1B\u0E23\u0E42\u0E21\u0E0A\u0E31\u0E19\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A Store \u0E19\u0E35\u0E49","tr":"Varsay\u0131lan Promosyonlar bu ma\u011Fazada kullan\u0131lam\u0131yor","tr-TR":"Varsay\u0131lan Promosyonlar bu ma\u011Fazada kullan\u0131lam\u0131yor"},"RL_Error6":{"key":"RL_Error6","en":"The StyleColor is already present in the upload. Please remove the duplicate item.","ca":"El producte ja s\'ha pujat. Elimina l\'element duplicat.","ca-ES":"El producte ja s\'ha pujat. Elimina l\'element duplicat.","cs":"Barva stylu je ji\u017E v nahr\xe1v\xe1n\xed zahrnuta. Odstra\u0148te pros\xedm duplicitn\xed polo\u017Eku.","cs-CZ":"Barva stylu je ji\u017E v nahr\xe1v\xe1n\xed zahrnuta. Odstra\u0148te pros\xedm duplicitn\xed polo\u017Eku.","da":"Modelfarven er allerede med i overf\xf8rslen. Fjern den duplikerede vare.","da-DK":"Modelfarven er allerede med i overf\xf8rslen. Fjern den duplikerede vare.","de":"Der Style-/Farbcode ist schon im Upload enthalten. Bitte entferne den doppelten Eintrag.","de-DE":"Der Style-/Farbcode ist schon im Upload enthalten. Bitte entferne den doppelten Eintrag.","el":"\u03A4\u03BF \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1 \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03AE\u03B4\u03B7 \u03C3\u03C4\u03B7 \u03BC\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7. \u039A\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03B4\u03B9\u03C0\u03BB\u03CC\u03C4\u03C5\u03C0\u03BF \u03B5\u03AF\u03B4\u03BF\u03C2.","el-GR":"\u03A4\u03BF \u03C3\u03C4\u03B9\u03BB-\u03C7\u03C1\u03CE\u03BC\u03B1 \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03AE\u03B4\u03B7 \u03C3\u03C4\u03B7 \u03BC\u03B5\u03C4\u03B1\u03C6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7. \u039A\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03C4\u03B5 \u03C4\u03BF \u03B4\u03B9\u03C0\u03BB\u03CC\u03C4\u03C5\u03C0\u03BF \u03B5\u03AF\u03B4\u03BF\u03C2.","en-GB":"The style colour is already present in the upload. Please remove the duplicate item.","es":"El modelo-color ya est\xe1 presente en la carga. Elimina el elemento duplicado.","es-ES":"El modelo-color ya est\xe1 presente en la carga. Elimina el elemento duplicado.","fi-FI":"StyleColor on jo latauksessa. Poista kaksoiskappale.","fr":"Le style-coloris a d\xe9j\xe0 \xe9t\xe9 import\xe9. Merci de supprimer l\'article en double.","fr-FR":"Le style-coloris a d\xe9j\xe0 \xe9t\xe9 import\xe9. Merci de supprimer l\'article en double.","he-IL":"\u05D4\u05E1\u05D2\u05E0\u05D5\u05DF-\u05E6\u05D1\u05E2 \u05DB\u05D1\u05E8 \u05E0\u05DB\u05DC\u05DC \u05D1\u05D4\u05E2\u05DC\u05D0\u05D4. \u05D4\u05E1\u05D9\u05E8\u05D5 \u05D0\u05EA \u05D4\u05E4\u05E8\u05D9\u05D8 \u05D4\u05DB\u05E4\u05D5\u05DC.","hr-HR":"Parametar model-boja ve\u0107 je prisutan u postupku prijenosa. Uklonite duplicirani artikl.","hu":"Ez a st\xedlus\u2013sz\xedn m\xe1r szerepel a felt\xf6lt\xe9sben. K\xe9rj\xfck, t\xe1vol\xedtsd el a duplik\xe1lt t\xe9telt.","hu-HU":"Ez a st\xedlus\u2013sz\xedn m\xe1r szerepel a felt\xf6lt\xe9sben. K\xe9rj\xfck, t\xe1vol\xedtsd el a duplik\xe1lt t\xe9telt.","it":"Il modello-colore \xe8 gi\xe0 presente nell\'upload. Rimuovi l\'elemento duplicato.","it-IT":"Il modello-colore \xe8 gi\xe0 presente nell\'upload. Rimuovi l\'elemento duplicato.","ja":"\u3053\u306EStyleColor\u306F\u3059\u3067\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u5185\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002 \u91CD\u8907\u3059\u308B\u30A2\u30A4\u30C6\u30E0\u3092\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ja-JP":"\u3053\u306EStyleColor\u306F\u3059\u3067\u306B\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u5185\u306B\u5B58\u5728\u3057\u3066\u3044\u307E\u3059\u3002 \u91CD\u8907\u3059\u308B\u30A2\u30A4\u30C6\u30E0\u3092\u524A\u9664\u3057\u3066\u304F\u3060\u3055\u3044\u3002","ko":"\uD574\uB2F9 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uB294 \uC774\uBBF8 \uC5C5\uB85C\uB4DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4. \uC911\uBCF5\uB41C \uC544\uC774\uD15C\uC744 \uC0AD\uC81C\uD574 \uC8FC\uC138\uC694.","ko-KR":"\uD574\uB2F9 \uC2A4\uD0C0\uC77C \uCEEC\uB7EC\uB294 \uC774\uBBF8 \uC5C5\uB85C\uB4DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4. \uC911\uBCF5\uB41C \uC544\uC774\uD15C\uC744 \uC0AD\uC81C\uD574 \uC8FC\uC138\uC694.","nl":"De stijl/kleur is al aanwezig in de upload. Verwijder het dubbele item.","nl-NL":"De stijl/kleur is al aanwezig in de upload. Verwijder het dubbele item.","no-NO":"Produktfargen finnes allerede i opplastingen. Fjern den dupliserte varen.","pl":"Model/kolor zosta\u0142 ju\u017C dodany do listy element\xf3w do przes\u0142ania. Usu\u0144 zduplikowan\u0105 pozycj\u0119.","pl-PL":"Model/kolor zosta\u0142 ju\u017C dodany do listy element\xf3w do przes\u0142ania. Usu\u0144 zduplikowan\u0105 pozycj\u0119.","pt-BR":"A CorEstilo j\xe1 est\xe1 listada no upload. Remova o item duplicado.","pt-PT":"O estilo-cor j\xe1 est\xe1 presente no carregamento. Remova o artigo duplicado.","ru":"\u041C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430 \u0443\u0436\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430 \u0432 \u044D\u0442\u0443 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0443. \u0423\u0434\u0430\u043B\u0438\u0442\u0435 \u0434\u0443\u0431\u043B\u0438\u0440\u0443\u044E\u0449\u0438\u0439\u0441\u044F \u0442\u043E\u0432\u0430\u0440.","ru-RU":"\u041C\u043E\u0434\u0435\u043B\u044C/\u0440\u0430\u0441\u0446\u0432\u0435\u0442\u043A\u0430 \u0443\u0436\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0430 \u0432 \u044D\u0442\u0443 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0443. \u0423\u0434\u0430\u043B\u0438\u0442\u0435 \u0434\u0443\u0431\u043B\u0438\u0440\u0443\u044E\u0449\u0438\u0439\u0441\u044F \u0442\u043E\u0432\u0430\u0440.","sv":"Modellf\xe4rgen finns redan i uppladdningen. Ta bort dubbletten.","sv-SE":"Modellf\xe4rgen finns redan i uppladdningen. Ta bort dubbletten.","th":"\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E19\u0E35\u0E49\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E0B\u0E49\u0E33\u0E2D\u0E2D\u0E01","th-TH":"\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E2A\u0E35\u0E19\u0E35\u0E49\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27\u0E43\u0E19\u0E01\u0E32\u0E23\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E1A\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E0B\u0E49\u0E33\u0E2D\u0E2D\u0E01","tr":"Stil-Renk, y\xfcklemede zaten mevcut. Yinelenen \xf6\u011Feyi l\xfctfen kald\u0131r.","tr-TR":"Stil-Renk, y\xfcklemede zaten mevcut. Yinelenen \xf6\u011Feyi l\xfctfen kald\u0131r."},"RL_Error7":{"key":"RL_Error7","en":"Invalid value provided for the column Division","ca":"El valor de la columna \\"Categoria\\" no \xe9s v\xe0lid","ca-ES":"El valor de la columna \\"Categoria\\" no \xe9s v\xe0lid","cs":"Neplatn\xe1 hodnota zadan\xe1 pro sloupec Divize","cs-CZ":"Neplatn\xe1 hodnota zadan\xe1 pro sloupec Divize","da":"Ugyldig kode for kolonnen Afdeling","da-DK":"Ugyldig kode for kolonnen Afdeling","de":"Ung\xfcltiger Wert f\xfcr die Spalte \\"Bereich\\"","de-DE":"Ung\xfcltiger Wert f\xfcr die Spalte \\"Bereich\\"","el":"\u039A\u03B1\u03C4\u03B1\u03C7\u03C9\u03C1\u03AF\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BC\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03C4\u03B9\u03BC\u03AE \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03C3\u03C4\u03AE\u03BB\u03B7 \u03A4\u03BC\u03AE\u03BC\u03B1","el-GR":"\u039A\u03B1\u03C4\u03B1\u03C7\u03C9\u03C1\u03AF\u03C3\u03C4\u03B7\u03BA\u03B5 \u03BC\u03B7 \u03AD\u03B3\u03BA\u03C5\u03C1\u03B7 \u03C4\u03B9\u03BC\u03AE \u03B3\u03B9\u03B1 \u03C4\u03B7 \u03C3\u03C4\u03AE\u03BB\u03B7 \u03A4\u03BC\u03AE\u03BC\u03B1","en-GB":"Invalid value provided for the column \\"Division\\"","es":"Se ha indicado un valor no v\xe1lido para la columna Divisi\xf3n","es-ES":"Se ha indicado un valor no v\xe1lido para la columna Divisi\xf3n","fi-FI":"Virheellinen arvo Osasto-sarakkeessa","fr":"Valeur incorrecte indiqu\xe9e pour la colonne Division","fr-FR":"Valeur incorrecte indiqu\xe9e pour la colonne Division","he-IL":"\u05E6\u05D5\u05D9\u05DF \u05E2\u05E8\u05DA \u05DC\u05D0 \u05EA\u05E7\u05D9\u05DF \u05D1\u05E2\u05DE\u05D5\u05D3\u05EA \u05D4\u05DE\u05D7\u05DC\u05E7\u05D4","hr-HR":"Neispravna vrijednost navedena u stupcu \u201EVrsta proizvoda\u201D","hu":"\xc9rv\xe9nytelen \xe9rt\xe9k ker\xfclt megad\xe1sra a R\xe9szleg oszlopban","hu-HU":"\xc9rv\xe9nytelen \xe9rt\xe9k ker\xfclt megad\xe1sra a R\xe9szleg oszlopban","it":"Valore non valido fornito per la colonna divisione","it-IT":"Valore non valido fornito per la colonna divisione","ja":"\u300C\u90E8\u9580\u300D\u5217\u306B\u7121\u52B9\u306A\u5024\u304C\u5165\u529B\u3055\u308C\u307E\u3057\u305F","ja-JP":"\u300C\u90E8\u9580\u300D\u5217\u306B\u7121\u52B9\u306A\u5024\u304C\u5165\u529B\u3055\u308C\u307E\u3057\u305F","ko":"\uBD80\uBB38 \uC5F4\uC5D0 \uC785\uB825\uD55C \uAC12\uC774 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4","ko-KR":"\uBD80\uBB38 \uC5F4\uC5D0 \uC785\uB825\uD55C \uAC12\uC774 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4","nl":"Ongeldige waarde opgegeven voor de kolom Divisie","nl-NL":"Ongeldige waarde opgegeven voor de kolom Divisie","no-NO":"Ugyldig verdi for kolonnen Avdeling","pl":"Warto\u015B\u0107 dla kolumny Dzia\u0142 jest nieprawid\u0142owa","pl-PL":"Warto\u015B\u0107 dla kolumny Dzia\u0142 jest nieprawid\u0142owa","pt-BR":"Valor inv\xe1lido inserido na coluna \\"Divis\xe3o\\"","pt-PT":"Valor inv\xe1lido fornecido para a coluna Divis\xe3o","ru":"\u0414\u043B\u044F \u0441\u0442\u043E\u043B\u0431\u0446\u0430 \xab\u041E\u0442\u0434\u0435\u043B\xbb \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435","ru-RU":"\u0414\u043B\u044F \u0441\u0442\u043E\u043B\u0431\u0446\u0430 \xab\u041E\u0442\u0434\u0435\u043B\xbb \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435","sv":"Ogiltigt v\xe4rde f\xf6r kolumnen Avdelning","sv-SE":"Ogiltigt v\xe4rde f\xf6r kolumnen Avdelning","th":"\u0E1B\u0E49\u0E2D\u0E19\u0E04\u0E48\u0E32\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C\u0E41\u0E1C\u0E19\u0E01","th-TH":"\u0E1B\u0E49\u0E2D\u0E19\u0E04\u0E48\u0E32\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E2D\u0E25\u0E31\u0E21\u0E19\u0E4C\u0E41\u0E1C\u0E19\u0E01","tr":"B\xf6l\xfcm s\xfctunu i\xe7in ge\xe7ersiz de\u011Fer sa\u011Fland\u0131","tr-TR":"B\xf6l\xfcm s\xfctunu i\xe7in ge\xe7ersiz de\u011Fer sa\u011Fland\u0131"},"RL_Error8":{"key":"RL_Error8","en":"Only Unbinned Styles can be uploaded","ca":"Nom\xe9s es poden pujar productes que no estiguin assignats a un bin","ca-ES":"Nom\xe9s es poden pujar productes que no estiguin assignats a un bin","cs":"Nahr\xe1ny mohou b\xfdt pouze styly mimo sektor","cs-CZ":"Nahr\xe1ny mohou b\xfdt pouze styly mimo sektor","da":"Du kan kun uploade gemte modeller","da-DK":"Du kan kun uploade gemte modeller","de":"Nur nicht gelagerte Styles k\xf6nnen hochgeladen werden","de-DE":"Nur nicht gelagerte Styles k\xf6nnen hochgeladen werden","el":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03B5\u03B2\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BC\u03CC\u03BD\u03BF \u03C3\u03C4\u03B9\u03BB \u03B5\u03BA\u03C4\u03CC\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B1\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7\u03C2","el-GR":"\u039C\u03C0\u03BF\u03C1\u03B5\u03AF\u03C4\u03B5 \u03BD\u03B1 \u03B1\u03BD\u03B5\u03B2\u03AC\u03C3\u03B5\u03C4\u03B5 \u03BC\u03CC\u03BD\u03BF \u03C3\u03C4\u03B9\u03BB \u03B5\u03BA\u03C4\u03CC\u03C2 \u03B8\u03AD\u03C3\u03B7\u03C2 \u03B1\u03C0\u03BF\u03B8\u03AE\u03BA\u03B5\u03C5\u03C3\u03B7\u03C2","en-GB":"Only unbinned styles can be uploaded","es":"Solo se pueden cargar productos que no est\xe9n en bins","es-ES":"Solo se pueden cargar productos que no est\xe9n en bins","fi-FI":"Et voit ladata roskakorissa olevia tyylej\xe4","fr":"Seuls les articles sortis du bin peuvent \xeatre import\xe9s","fr-FR":"Seuls les articles sortis du bin peuvent \xeatre import\xe9s","he-IL":"\u05D0\u05E4\u05E9\u05E8 \u05DC\u05D4\u05E2\u05DC\u05D5\u05EA \u05E8\u05E7 \u05E1\u05D2\u05E0\u05D5\u05E0\u05D5\u05EA \u05DC\u05D0 \u05D1\u05E9\u05D8\u05D7\u05D9 \u05D0\u05D7\u05E1\u05D5\u05DF","hr-HR":"Mogu se prenijeti samo \u201EModeli izvan spremnika\u201D","hu":"Csak t\xe1rol\xf3b\xf3l kivett st\xedlusokat lehet felt\xf6lteni","hu-HU":"Csak t\xe1rol\xf3b\xf3l kivett st\xedlusokat lehet felt\xf6lteni","it":"Solo i modelli non assegnati a un bin possono essere caricati","it-IT":"Solo i modelli non assegnati a un bin possono essere caricati","ja":"BIN\u306B\u5165\u3063\u3066\u3044\u306A\u3044\u30B9\u30BF\u30A4\u30EB\u306E\u307F\u304C\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u53EF\u80FD\u3067\u3059","ja-JP":"BIN\u306B\u5165\u3063\u3066\u3044\u306A\u3044\u30B9\u30BF\u30A4\u30EB\u306E\u307F\u304C\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u53EF\u80FD\u3067\u3059","ko":"\uC218\uB0A9\uB418\uC9C0 \uC54A\uC740 \uC2A4\uD0C0\uC77C\uB9CC \uC5C5\uB85C\uB4DC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4","ko-KR":"\uC218\uB0A9\uB418\uC9C0 \uC54A\uC740 \uC2A4\uD0C0\uC77C\uB9CC \uC5C5\uB85C\uB4DC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4","nl":"Alleen niet in de bak geplaatste stijlen kunnen worden ge\xfcpload","nl-NL":"Alleen niet in de bak geplaatste stijlen kunnen worden ge\xfcpload","no-NO":"Du kan kun laste opp produkter som ikke er kategorisert","pl":"Mo\u017Cna przes\u0142a\u0107 tylko modele poza sektorem zasob\xf3w","pl-PL":"Mo\u017Cna przes\u0142a\u0107 tylko modele poza sektorem zasob\xf3w","pt-BR":"S\xf3 \xe9 poss\xedvel fazer upload de estilos que n\xe3o est\xe3o na categoria \\"Compartimento\\"","pt-PT":"S\xf3 \xe9 poss\xedvel carregar estilos sem sec\xe7\xe3o","ru":"\u041C\u043E\u0436\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u043C\u043E\u0434\u0435\u043B\u0438 \u0431\u0435\u0437 \u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u0430","ru-RU":"\u041C\u043E\u0436\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u043C\u043E\u0434\u0435\u043B\u0438 \u0431\u0435\u0437 \u043A\u043E\u043D\u0442\u0435\u0439\u043D\u0435\u0440\u0430","sv":"Endast modeller som inte har v\xe4rdet Bin kan laddas upp.","sv-SE":"Endast modeller som inte har v\xe4rdet Bin kan laddas upp.","th":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E14\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E43\u0E19 Bin \u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","th-TH":"\u0E2D\u0E31\u0E1E\u0E42\u0E2B\u0E25\u0E14\u0E44\u0E14\u0E49\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E2A\u0E44\u0E15\u0E25\u0E4C\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E08\u0E31\u0E14\u0E40\u0E01\u0E47\u0E1A\u0E43\u0E19 Bin \u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19","tr":"Yaln\u0131zca Kutuya Koyulmam\u0131\u015F Stiller y\xfcklenebilir","tr-TR":"Yaln\u0131zca Kutuya Koyulmam\u0131\u015F Stiller y\xfcklenebilir"}}');

});



parcelRegister("bEk1s", function(module, exports) {

$parcel$export(module.exports, "getLocaleToggleStatus", () => $87b2f6334f89b0ae$export$941e50cdd8a4287b, (v) => $87b2f6334f89b0ae$export$941e50cdd8a4287b = v);
$parcel$export(module.exports, "getLocaleForTranslation", () => $87b2f6334f89b0ae$export$aab857100a18b4d6, (v) => $87b2f6334f89b0ae$export$aab857100a18b4d6 = v);
$parcel$export(module.exports, "getLocaleForToggleButton", () => $87b2f6334f89b0ae$export$b2a37d9767599c0b, (v) => $87b2f6334f89b0ae$export$b2a37d9767599c0b = v);
$parcel$export(module.exports, "getLocale", () => $87b2f6334f89b0ae$export$180605366c04f0cd, (v) => $87b2f6334f89b0ae$export$180605366c04f0cd = v);
$parcel$export(module.exports, "getIsMarkdownEnabled", () => $87b2f6334f89b0ae$export$e5776776b383e5b4, (v) => $87b2f6334f89b0ae$export$e5776776b383e5b4 = v);
$parcel$export(module.exports, "getIsCsvUploadEnabled", () => $87b2f6334f89b0ae$export$d1a6fa7a215c1a38, (v) => $87b2f6334f89b0ae$export$d1a6fa7a215c1a38 = v);
$parcel$export(module.exports, "getIsCreatePromotionEnabled", () => $87b2f6334f89b0ae$export$1ae6a59c4faff924, (v) => $87b2f6334f89b0ae$export$1ae6a59c4faff924 = v);
$parcel$export(module.exports, "getAllowPromoteApp", () => $87b2f6334f89b0ae$export$42572650fcb7de01, (v) => $87b2f6334f89b0ae$export$42572650fcb7de01 = v);
var $87b2f6334f89b0ae$export$1e511d4a378977f5;
var $87b2f6334f89b0ae$export$941e50cdd8a4287b;
var $87b2f6334f89b0ae$export$aab857100a18b4d6;
var $87b2f6334f89b0ae$export$b2a37d9767599c0b;
var $87b2f6334f89b0ae$export$180605366c04f0cd;
var $87b2f6334f89b0ae$export$e5776776b383e5b4;
var $87b2f6334f89b0ae$export$d1a6fa7a215c1a38;
var $87b2f6334f89b0ae$export$1ae6a59c4faff924;
var $87b2f6334f89b0ae$export$42572650fcb7de01;
"use strict";
$87b2f6334f89b0ae$export$1e511d4a378977f5 = true;
$87b2f6334f89b0ae$export$941e50cdd8a4287b = $87b2f6334f89b0ae$export$aab857100a18b4d6 = $87b2f6334f89b0ae$export$b2a37d9767599c0b = $87b2f6334f89b0ae$export$180605366c04f0cd = $87b2f6334f89b0ae$export$e5776776b383e5b4 = $87b2f6334f89b0ae$export$d1a6fa7a215c1a38 = $87b2f6334f89b0ae$export$1ae6a59c4faff924 = $87b2f6334f89b0ae$export$42572650fcb7de01 = void 0;

var $7Yi7V = parcelRequire("7Yi7V");
const $87b2f6334f89b0ae$var$getLocale = (state)=>state.storeLocale;
$87b2f6334f89b0ae$export$180605366c04f0cd = $87b2f6334f89b0ae$var$getLocale;
const $87b2f6334f89b0ae$var$getLocaleToggleStatus = (state)=>state.localeToggle;
// export const getIsPartnerLogin = (state) => state.isPartnerLogin;
$87b2f6334f89b0ae$export$941e50cdd8a4287b = $87b2f6334f89b0ae$var$getLocaleToggleStatus;
const $87b2f6334f89b0ae$var$getLocaleForToggleButton = (state)=>$87b2f6334f89b0ae$var$getLocaleToggleStatus(state) ? $87b2f6334f89b0ae$var$getLocale(state) : $7Yi7V.DEFAULT_LOCALE;
$87b2f6334f89b0ae$export$b2a37d9767599c0b = $87b2f6334f89b0ae$var$getLocaleForToggleButton;
const $87b2f6334f89b0ae$var$getLocaleForTranslation = (state)=>$87b2f6334f89b0ae$var$getLocaleToggleStatus(state) ? $7Yi7V.DEFAULT_LOCALE : $87b2f6334f89b0ae$var$getLocale(state);
// export const getPartnerStores = (state) => state.partnerStores;
$87b2f6334f89b0ae$export$aab857100a18b4d6 = $87b2f6334f89b0ae$var$getLocaleForTranslation;
const $87b2f6334f89b0ae$var$getIsMarkdownEnabled = (state)=>state.markdownEnabled;
$87b2f6334f89b0ae$export$e5776776b383e5b4 = $87b2f6334f89b0ae$var$getIsMarkdownEnabled;
const $87b2f6334f89b0ae$var$getAllowPromoteApp = (state)=>state.allowPromoteApp;
$87b2f6334f89b0ae$export$42572650fcb7de01 = $87b2f6334f89b0ae$var$getAllowPromoteApp;
const $87b2f6334f89b0ae$var$getIsCreatePromotionEnabled = (state)=>state.createPromotionEnabled;
$87b2f6334f89b0ae$export$1ae6a59c4faff924 = $87b2f6334f89b0ae$var$getIsCreatePromotionEnabled;
const $87b2f6334f89b0ae$var$getIsCsvUploadEnabled = (state)=>state.isStyleUploadEnabled;
$87b2f6334f89b0ae$export$d1a6fa7a215c1a38 = $87b2f6334f89b0ae$var$getIsCsvUploadEnabled;

});

parcelRegister("jMcIG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $e65c5ddf82681177$export$1e511d4a378977f5, (v) => $e65c5ddf82681177$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "toggleLocale", () => $e65c5ddf82681177$export$dc8ec81bd2260f8b, (v) => $e65c5ddf82681177$export$dc8ec81bd2260f8b = v);
$parcel$export(module.exports, "setLoginType", () => $e65c5ddf82681177$export$9b16b760c6b5c1ae, (v) => $e65c5ddf82681177$export$9b16b760c6b5c1ae = v);
$parcel$export(module.exports, "setLocale", () => $e65c5ddf82681177$export$c8aadf3621e41efb, (v) => $e65c5ddf82681177$export$c8aadf3621e41efb = v);
$parcel$export(module.exports, "setIsMarkdownEnabled", () => $e65c5ddf82681177$export$6e0934383c02e4d9, (v) => $e65c5ddf82681177$export$6e0934383c02e4d9 = v);
$parcel$export(module.exports, "setIsCsvUploadEnabled", () => $e65c5ddf82681177$export$d92d939e6314ebd9, (v) => $e65c5ddf82681177$export$d92d939e6314ebd9 = v);
$parcel$export(module.exports, "setIsCreatePromotionEnabled", () => $e65c5ddf82681177$export$adeb0ecf18908a25, (v) => $e65c5ddf82681177$export$adeb0ecf18908a25 = v);
$parcel$export(module.exports, "setCountry", () => $e65c5ddf82681177$export$a8b0f88da47c7740, (v) => $e65c5ddf82681177$export$a8b0f88da47c7740 = v);
$parcel$export(module.exports, "setAllowPromoteApp", () => $e65c5ddf82681177$export$46ebf5340bfc49ee, (v) => $e65c5ddf82681177$export$46ebf5340bfc49ee = v);
$parcel$export(module.exports, "promoReducer", () => $e65c5ddf82681177$export$984cd686f1c58899, (v) => $e65c5ddf82681177$export$984cd686f1c58899 = v);
$parcel$export(module.exports, "default", () => $e65c5ddf82681177$export$2e2bcd8739ae039, (v) => $e65c5ddf82681177$export$2e2bcd8739ae039 = v);
var $e65c5ddf82681177$export$1e511d4a378977f5;
var $e65c5ddf82681177$export$dc8ec81bd2260f8b;
var $e65c5ddf82681177$export$9b16b760c6b5c1ae;
var $e65c5ddf82681177$export$c8aadf3621e41efb;
var $e65c5ddf82681177$export$6e0934383c02e4d9;
var $e65c5ddf82681177$export$d92d939e6314ebd9;
var $e65c5ddf82681177$export$adeb0ecf18908a25;
var $e65c5ddf82681177$export$a8b0f88da47c7740;
var $e65c5ddf82681177$export$46ebf5340bfc49ee;
var $e65c5ddf82681177$export$984cd686f1c58899;
var $e65c5ddf82681177$export$2e2bcd8739ae039;
"use strict";
$e65c5ddf82681177$export$1e511d4a378977f5 = true;
$e65c5ddf82681177$export$dc8ec81bd2260f8b = $e65c5ddf82681177$export$9b16b760c6b5c1ae = $e65c5ddf82681177$export$c8aadf3621e41efb = $e65c5ddf82681177$export$6e0934383c02e4d9 = $e65c5ddf82681177$export$d92d939e6314ebd9 = $e65c5ddf82681177$export$adeb0ecf18908a25 = $e65c5ddf82681177$export$a8b0f88da47c7740 = $e65c5ddf82681177$export$46ebf5340bfc49ee = $e65c5ddf82681177$export$984cd686f1c58899 = $e65c5ddf82681177$export$2e2bcd8739ae039 = void 0;

var $a1McR = parcelRequire("a1McR");

var $7Yi7V = parcelRequire("7Yi7V");
// createSlice wraps the reducer function with 'produce' from the Immer library
// which prevents us from actually mutating the passed in state
/* eslint-disable fp/no-mutation */ /* eslint-disable no-param-reassign */ // eslint-disable-next-line import/named
// import { checkIsPartnerLogin } from '../utils/promoteUtils';
const $e65c5ddf82681177$var$localeSlice = (0, $a1McR.createSlice)({
    initialState: {
        allowPromoteApp: false,
        country: localStorage.country,
        createPromotionEnabled: false,
        // isPartnerLogin: checkIsPartnerLogin(),
        localeToggle: false,
        markdownEnabled: false,
        partnerCountries: [],
        partnerStores: {},
        storeLocale: localStorage.storeLocale || $7Yi7V.DEFAULT_LOCALE
    },
    name: "locale",
    reducers: {
        setAllowPromoteApp (state, action) {
            state.allowPromoteApp = action.payload;
        },
        setCountry (state, action) {
            state.country = action.payload;
        },
        setIsCreatePromotionEnabled (state, action) {
            state.createPromotionEnabled = action.payload;
        },
        setIsCsvUploadEnabled (state, action) {
            state.isStyleUploadEnabled = action.payload;
        },
        setIsMarkdownEnabled (state, action) {
            state.markdownEnabled = action.payload;
        },
        setLocale (state, action) {
            state.storeLocale = action.payload;
        },
        setLoginType (state, action) {
            state.loginType = action.payload;
        },
        // setPartnerStores(state, action) {
        //   state.partnerStores = action.payload;
        // },
        toggleLocale (state) {
            state.localeToggle = !state.localeToggle;
        }
    }
});
const $e65c5ddf82681177$var$store = (0, $a1McR.configureStore)({
    reducer: $e65c5ddf82681177$var$localeSlice.reducer
});
const { setAllowPromoteApp: $e65c5ddf82681177$var$setAllowPromoteApp, setCountry: $e65c5ddf82681177$var$setCountry, setLocale: $e65c5ddf82681177$var$setLocale, setLoginType: $e65c5ddf82681177$var$setLoginType, toggleLocale: $e65c5ddf82681177$var$toggleLocale, setIsMarkdownEnabled: $e65c5ddf82681177$var$setIsMarkdownEnabled, setIsCreatePromotionEnabled: $e65c5ddf82681177$var$setIsCreatePromotionEnabled, setIsCsvUploadEnabled: $e65c5ddf82681177$var$setIsCsvUploadEnabled } = $e65c5ddf82681177$var$localeSlice.actions;
$e65c5ddf82681177$export$d92d939e6314ebd9 = $e65c5ddf82681177$var$setIsCsvUploadEnabled;
$e65c5ddf82681177$export$adeb0ecf18908a25 = $e65c5ddf82681177$var$setIsCreatePromotionEnabled;
$e65c5ddf82681177$export$6e0934383c02e4d9 = $e65c5ddf82681177$var$setIsMarkdownEnabled;
$e65c5ddf82681177$export$dc8ec81bd2260f8b = $e65c5ddf82681177$var$toggleLocale;
$e65c5ddf82681177$export$9b16b760c6b5c1ae = $e65c5ddf82681177$var$setLoginType;
$e65c5ddf82681177$export$c8aadf3621e41efb = $e65c5ddf82681177$var$setLocale;
$e65c5ddf82681177$export$a8b0f88da47c7740 = $e65c5ddf82681177$var$setCountry;
$e65c5ddf82681177$export$46ebf5340bfc49ee = $e65c5ddf82681177$var$setAllowPromoteApp;
const $e65c5ddf82681177$var$promoReducer = $e65c5ddf82681177$export$984cd686f1c58899 = $e65c5ddf82681177$var$localeSlice.reducer;
var $e65c5ddf82681177$var$_default = $e65c5ddf82681177$export$2e2bcd8739ae039 = $e65c5ddf82681177$var$store;

});
parcelRegister("a1McR", function(module, exports) {

$parcel$export(module.exports, "configureStore", () => $74cf642ba7fa99c2$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createSlice", () => $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b);

var $i4CZ2 = parcelRequire("i4CZ2");

var $eShmq = parcelRequire("eShmq");

var $6SpLG = parcelRequire("6SpLG");

var $eNuyV = parcelRequire("eNuyV");

var $hPtJY = parcelRequire("hPtJY");
var $74cf642ba7fa99c2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $74cf642ba7fa99c2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $74cf642ba7fa99c2$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $74cf642ba7fa99c2$var$__defProp = Object.defineProperty;
var $74cf642ba7fa99c2$var$__defProps = Object.defineProperties;
var $74cf642ba7fa99c2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $74cf642ba7fa99c2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $74cf642ba7fa99c2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $74cf642ba7fa99c2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $74cf642ba7fa99c2$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $74cf642ba7fa99c2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $74cf642ba7fa99c2$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($74cf642ba7fa99c2$var$__hasOwnProp.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    if ($74cf642ba7fa99c2$var$__getOwnPropSymbols) for(var _i = 0, _c = $74cf642ba7fa99c2$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($74cf642ba7fa99c2$var$__propIsEnum.call(b, prop)) $74cf642ba7fa99c2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $74cf642ba7fa99c2$var$__spreadProps = function(a, b) {
    return $74cf642ba7fa99c2$var$__defProps(a, $74cf642ba7fa99c2$var$__getOwnPropDescs(b));
};
var $74cf642ba7fa99c2$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $74cf642ba7fa99c2$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $6SpLG.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $74cf642ba7fa99c2$var$__spreadArray([
            (0, $i4CZ2.isDraft)(value) ? (0, $i4CZ2.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $74cf642ba7fa99c2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $eShmq.compose;
    return (0, $eShmq.compose).apply(null, arguments);
};
var $74cf642ba7fa99c2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $74cf642ba7fa99c2$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $74cf642ba7fa99c2$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $74cf642ba7fa99c2$export$b956e38827fca970(action) {
    return $74cf642ba7fa99c2$export$53b83ca8eaab0383(action) && "type" in action;
}
function $74cf642ba7fa99c2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $74cf642ba7fa99c2$var$hasMatchFunction(action);
}
function $74cf642ba7fa99c2$export$ebd532f9034651f3(action) {
    return $74cf642ba7fa99c2$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($74cf642ba7fa99c2$var$isValidKey);
}
function $74cf642ba7fa99c2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $74cf642ba7fa99c2$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $74cf642ba7fa99c2$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $74cf642ba7fa99c2$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c = options.isActionCreator, isActionCreator2 = _c === void 0 ? $74cf642ba7fa99c2$export$4e5cad2c7f795b8f : _c;
    return function() {
        return function(next) {
            return function(action) {
                if (isActionCreator2(action)) console.warn($74cf642ba7fa99c2$var$getMessage(action.type));
                return next(action);
            };
        };
    };
}
function $74cf642ba7fa99c2$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $74cf642ba7fa99c2$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $74cf642ba7fa99c2$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $74cf642ba7fa99c2$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $74cf642ba7fa99c2$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $74cf642ba7fa99c2$var$freezeDraftable(val) {
    return (0, $i4CZ2.isDraftable)(val) ? (0, $i4CZ2.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $74cf642ba7fa99c2$var$isProduction = false;
var $74cf642ba7fa99c2$var$prefix = "Invariant failed";
function $74cf642ba7fa99c2$var$invariant(condition, message) {
    if (condition) return;
    if ($74cf642ba7fa99c2$var$isProduction) throw new Error($74cf642ba7fa99c2$var$prefix);
    throw new Error($74cf642ba7fa99c2$var$prefix + ": " + (message || ""));
}
function $74cf642ba7fa99c2$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $74cf642ba7fa99c2$var$getSerialize(serializer, decycler), indent);
}
function $74cf642ba7fa99c2$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $74cf642ba7fa99c2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $74cf642ba7fa99c2$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $74cf642ba7fa99c2$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $74cf642ba7fa99c2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $74cf642ba7fa99c2$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c = options.isImmutable, isImmutable = _c === void 0 ? $74cf642ba7fa99c2$export$9021b2733a0028a3 : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = $74cf642ba7fa99c2$var$trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function(_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function(next) {
            return function(action) {
                var measureUtils = $74cf642ba7fa99c2$var$getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
                measureUtils.measureTime(function() {
                    state = getState();
                    result = tracker.detectMutations();
                    tracker = track(state);
                    $74cf642ba7fa99c2$var$invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
                });
                var dispatchedAction = next(action);
                measureUtils.measureTime(function() {
                    state = getState();
                    result = tracker.detectMutations();
                    tracker = track(state);
                    result.wasMutated && $74cf642ba7fa99c2$var$invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + $74cf642ba7fa99c2$var$stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
                });
                measureUtils.warnIfExceeded();
                return dispatchedAction;
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $74cf642ba7fa99c2$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $74cf642ba7fa99c2$export$53b83ca8eaab0383(val);
}
function $74cf642ba7fa99c2$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $74cf642ba7fa99c2$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $74cf642ba7fa99c2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $74cf642ba7fa99c2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $74cf642ba7fa99c2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$74cf642ba7fa99c2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $74cf642ba7fa99c2$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c = options.isSerializable, isSerializable = _c === void 0 ? $74cf642ba7fa99c2$export$77670485918dab4e : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? [
        "meta.arg",
        "meta.baseQueryMeta"
    ] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j, _k = options.disableCache, disableCache = _k === void 0 ? false : _k;
    var cache = !disableCache && WeakSet ? new WeakSet() : void 0;
    return function(storeAPI) {
        return function(next) {
            return function(action) {
                var result = next(action);
                var measureUtils = $74cf642ba7fa99c2$var$getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
                if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) measureUtils.measureTime(function() {
                    var foundActionNonSerializableValue = $74cf642ba7fa99c2$export$ada5dca0b571bc7(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
                    if (foundActionNonSerializableValue) {
                        var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                        console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                    }
                });
                if (!ignoreState) {
                    measureUtils.measureTime(function() {
                        var state = storeAPI.getState();
                        var foundStateNonSerializableValue = $74cf642ba7fa99c2$export$ada5dca0b571bc7(state, "", isSerializable, getEntries, ignoredPaths, cache);
                        if (foundStateNonSerializableValue) {
                            var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                            console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                        }
                    });
                    measureUtils.warnIfExceeded();
                }
                return result;
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $74cf642ba7fa99c2$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $74cf642ba7fa99c2$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options);
    };
}
function $74cf642ba7fa99c2$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $74cf642ba7fa99c2$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($74cf642ba7fa99c2$var$isBoolean(thunk)) middlewareArray.push((0, $eNuyV.default));
        else middlewareArray.push((0, $eNuyV.default).withExtraArgument(thunk.extraArgument));
    }
    if (immutableCheck) {
        var immutableOptions = {};
        if (!$74cf642ba7fa99c2$var$isBoolean(immutableCheck)) immutableOptions = immutableCheck;
        middlewareArray.unshift($74cf642ba7fa99c2$export$9181bb1a5474289(immutableOptions));
    }
    if (serializableCheck) {
        var serializableOptions = {};
        if (!$74cf642ba7fa99c2$var$isBoolean(serializableCheck)) serializableOptions = serializableCheck;
        middlewareArray.push($74cf642ba7fa99c2$export$6dea1aad6dac5ac2(serializableOptions));
    }
    if (actionCreatorCheck) {
        var actionCreatorOptions = {};
        if (!$74cf642ba7fa99c2$var$isBoolean(actionCreatorCheck)) actionCreatorOptions = actionCreatorCheck;
        middlewareArray.unshift($74cf642ba7fa99c2$export$6a1fcb4ceef578f(actionCreatorOptions));
    }
    return middlewareArray;
}
// src/configureStore.ts
var $74cf642ba7fa99c2$var$IS_PRODUCTION = false;
function $74cf642ba7fa99c2$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $74cf642ba7fa99c2$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($74cf642ba7fa99c2$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $eShmq.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$74cf642ba7fa99c2$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $eShmq.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $eShmq.compose);
    if (devTools) finalCompose = $74cf642ba7fa99c2$var$composeWithDevTools($74cf642ba7fa99c2$var$__spreadValues({
        trace: !$74cf642ba7fa99c2$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $74cf642ba7fa99c2$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $74cf642ba7fa99c2$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $eShmq.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $74cf642ba7fa99c2$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            if (actionMatchers.length > 0) throw new Error("`builder.addCase` should only be called before calling `builder.addMatcher`");
            if (defaultCaseReducer) throw new Error("`builder.addCase` should only be called before calling `builder.addDefaultCase`");
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            if (defaultCaseReducer) throw new Error("`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            if (defaultCaseReducer) throw new Error("`builder.addDefaultCase` can only be called once");
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $74cf642ba7fa99c2$var$isStateFunction(x) {
    return typeof x === "function";
}
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation = false;
function $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    if (typeof mapOrBuilderCallback === "object") {
        if (!$74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation) {
            $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation = true;
            console.warn("The object notation for `createReducer` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
        }
    }
    var _c = typeof mapOrBuilderCallback === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($74cf642ba7fa99c2$var$isStateFunction(initialState)) getInitialState = function() {
        return $74cf642ba7fa99c2$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $74cf642ba7fa99c2$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $74cf642ba7fa99c2$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $i4CZ2.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $i4CZ2.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $i4CZ2.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation2 = false;
function $74cf642ba7fa99c2$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $74cf642ba7fa99c2$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $hPtJY;
    var initialState = typeof options.initialState == "function" ? options.initialState : $74cf642ba7fa99c2$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $74cf642ba7fa99c2$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type, prepareCallback) : $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        if (typeof options.extraReducers === "object") {
            if (!$74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation2) {
                $74cf642ba7fa99c2$var$hasWarnedAboutObjectNotation2 = true;
                console.warn("The object notation for `createSlice.extraReducers` is deprecated, and will be removed in RTK 2.0. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
            }
        }
        var _c = typeof options.extraReducers === "function" ? $74cf642ba7fa99c2$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $74cf642ba7fa99c2$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $74cf642ba7fa99c2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $74cf642ba7fa99c2$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($74cf642ba7fa99c2$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $74cf642ba7fa99c2$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $74cf642ba7fa99c2$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(mutator) {
    var operator = $74cf642ba7fa99c2$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $74cf642ba7fa99c2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $74cf642ba7fa99c2$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $i4CZ2.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $i4CZ2.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $74cf642ba7fa99c2$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (key === void 0) console.warn("The entity passed to the `selectId` implementation returned undefined.", "You should probably provide your own `selectId` implementation.", "The entity that was passed:", entity, "The `selectId` implementation:", selectId.toString());
    return key;
}
function $74cf642ba7fa99c2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $74cf642ba7fa99c2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $74cf642ba7fa99c2$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $74cf642ba7fa99c2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably),
        removeOne: $74cf642ba7fa99c2$var$createStateOperator(removeOneMutably),
        removeMany: $74cf642ba7fa99c2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sort) {
    var _c = $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($74cf642ba7fa99c2$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $74cf642ba7fa99c2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $74cf642ba7fa99c2$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $74cf642ba7fa99c2$var$createStateOperator(addOneMutably),
        updateOne: $74cf642ba7fa99c2$var$createStateOperator(updateOneMutably),
        upsertOne: $74cf642ba7fa99c2$var$createStateOperator(upsertOneMutably),
        setOne: $74cf642ba7fa99c2$var$createStateOperator(setOneMutably),
        setMany: $74cf642ba7fa99c2$var$createStateOperator(setManyMutably),
        setAll: $74cf642ba7fa99c2$var$createStateOperator(setAllMutably),
        addMany: $74cf642ba7fa99c2$var$createStateOperator(addManyMutably),
        updateMany: $74cf642ba7fa99c2$var$createStateOperator(updateManyMutably),
        upsertMany: $74cf642ba7fa99c2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $74cf642ba7fa99c2$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $74cf642ba7fa99c2$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $74cf642ba7fa99c2$var$createInitialStateFactory();
    var selectorsFactory = $74cf642ba7fa99c2$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $74cf642ba7fa99c2$var$createSortedStateAdapter(selectId, sortComparer) : $74cf642ba7fa99c2$var$createUnsortedStateAdapter(selectId);
    return $74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues($74cf642ba7fa99c2$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $74cf642ba7fa99c2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $74cf642ba7fa99c2$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $74cf642ba7fa99c2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $74cf642ba7fa99c2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $74cf642ba7fa99c2$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $74cf642ba7fa99c2$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $74cf642ba7fa99c2$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $74cf642ba7fa99c2$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $74cf642ba7fa99c2$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $74cf642ba7fa99c2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $74cf642ba7fa99c2$var$__spreadProps($74cf642ba7fa99c2$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {
                if (!displayedWarning) {
                    displayedWarning = true;
                    console.info("This platform does not implement AbortController. \nIf you want to use the AbortController to react to `abort` events, please consider importing a polyfill like 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only'.");
                }
            };
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $74cf642ba7fa99c2$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$74cf642ba7fa99c2$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $74cf642ba7fa99c2$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $74cf642ba7fa99c2$var$RejectWithValue) throw result;
                                                if (result instanceof $74cf642ba7fa99c2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $74cf642ba7fa99c2$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($74cf642ba7fa99c2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $74cf642ba7fa99c2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $74cf642ba7fa99c2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $74cf642ba7fa99c2$var$matches = function(matcher, action) {
    if ($74cf642ba7fa99c2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $74cf642ba7fa99c2$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $74cf642ba7fa99c2$var$matches(matcher, action);
        });
    };
}
function $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $74cf642ba7fa99c2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $74cf642ba7fa99c2$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $74cf642ba7fa99c2$export$9dd1fb32974da385($74cf642ba7fa99c2$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $74cf642ba7fa99c2$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $74cf642ba7fa99c2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$74cf642ba7fa99c2$var$isAsyncThunkArray(asyncThunks)) return $74cf642ba7fa99c2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $74cf642ba7fa99c2$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $74cf642ba7fa99c2$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $74cf642ba7fa99c2$var$noop = function() {};
var $74cf642ba7fa99c2$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $74cf642ba7fa99c2$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $74cf642ba7fa99c2$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $74cf642ba7fa99c2$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $74cf642ba7fa99c2$var$task = "task";
var $74cf642ba7fa99c2$var$listener = "listener";
var $74cf642ba7fa99c2$var$completed = "completed";
var $74cf642ba7fa99c2$var$cancelled = "cancelled";
var $74cf642ba7fa99c2$var$taskCancelled = "task-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$taskCompleted = "task-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$var$listenerCancelled = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$cancelled;
var $74cf642ba7fa99c2$var$listenerCompleted = $74cf642ba7fa99c2$var$listener + "-" + $74cf642ba7fa99c2$var$completed;
var $74cf642ba7fa99c2$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $74cf642ba7fa99c2$var$task + " " + $74cf642ba7fa99c2$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $74cf642ba7fa99c2$var$validateActive = function(signal) {
    if (signal.aborted) throw new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason);
};
function $74cf642ba7fa99c2$var$raceWithSignal(signal, promise2) {
    var cleanup = $74cf642ba7fa99c2$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $74cf642ba7fa99c2$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $74cf642ba7fa99c2$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $74cf642ba7fa99c2$var$noop;
    });
}
var $74cf642ba7fa99c2$var$runTask = function(task2, cleanUp) {
    return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
        var value, error_1;
        return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $74cf642ba7fa99c2$var$createPause = function(signal) {
    return function(promise2) {
        return $74cf642ba7fa99c2$var$catchRejection($74cf642ba7fa99c2$var$raceWithSignal(signal, promise2).then(function(output) {
            $74cf642ba7fa99c2$var$validateActive(signal);
            return output;
        }));
    };
};
var $74cf642ba7fa99c2$var$createDelay = function(signal) {
    var pause = $74cf642ba7fa99c2$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $74cf642ba7fa99c2$var$assign = Object.assign;
var $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN = {};
var $74cf642ba7fa99c2$var$alm = "listenerMiddleware";
var $74cf642ba7fa99c2$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $74cf642ba7fa99c2$var$addAbortSignalListener(parentAbortSignal, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $74cf642ba7fa99c2$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $74cf642ba7fa99c2$var$runTask(function() {
            return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
                var result2;
                return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $74cf642ba7fa99c2$var$validateActive(parentAbortSignal);
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $74cf642ba7fa99c2$var$createPause(childAbortController.signal),
                                    delay: $74cf642ba7fa99c2$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $74cf642ba7fa99c2$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $74cf642ba7fa99c2$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $74cf642ba7fa99c2$var$abortControllerWithReason(childAbortController, $74cf642ba7fa99c2$var$taskCancelled);
            }
        };
    };
};
var $74cf642ba7fa99c2$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $74cf642ba7fa99c2$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $74cf642ba7fa99c2$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $74cf642ba7fa99c2$var$catchRejection(take(predicate, timeout));
    };
};
var $74cf642ba7fa99c2$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $74cf642ba7fa99c2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $74cf642ba7fa99c2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $74cf642ba7fa99c2$var$createListenerEntry = function(options) {
    var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $74cf642ba7fa99c2$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $74cf642ba7fa99c2$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
    });
};
var $74cf642ba7fa99c2$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($74cf642ba7fa99c2$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $74cf642ba7fa99c2$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $74cf642ba7fa99c2$export$f03a6b845d3fb58b = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/add");
var $74cf642ba7fa99c2$export$b1b8022855fb2b71 = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/removeAll");
var $74cf642ba7fa99c2$export$b03e9483f936dccb = $74cf642ba7fa99c2$export$309c7a02b0b0bc62($74cf642ba7fa99c2$var$alm + "/remove");
var $74cf642ba7fa99c2$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $74cf642ba7fa99c2$var$__spreadArray([
        $74cf642ba7fa99c2$var$alm + "/error"
    ], args));
};
function $74cf642ba7fa99c2$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $74cf642ba7fa99c2$var$defaultErrorHandler : _c;
    $74cf642ba7fa99c2$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $74cf642ba7fa99c2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $74cf642ba7fa99c2$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $74cf642ba7fa99c2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $74cf642ba7fa99c2$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $74cf642ba7fa99c2$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $74cf642ba7fa99c2$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $74cf642ba7fa99c2$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $74cf642ba7fa99c2$var$createDelay(internalTaskController.signal),
                                pause: $74cf642ba7fa99c2$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $74cf642ba7fa99c2$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $74cf642ba7fa99c2$var$abortControllerWithReason(controller, $74cf642ba7fa99c2$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $74cf642ba7fa99c2$export$cb1bdac908fed7f)) $74cf642ba7fa99c2$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $74cf642ba7fa99c2$var$abortControllerWithReason(internalTaskController, $74cf642ba7fa99c2$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $74cf642ba7fa99c2$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$74cf642ba7fa99c2$export$b956e38827fca970(action)) return next(action);
                if ($74cf642ba7fa99c2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($74cf642ba7fa99c2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($74cf642ba7fa99c2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN) throw new Error($74cf642ba7fa99c2$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $74cf642ba7fa99c2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $74cf642ba7fa99c2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $74cf642ba7fa99c2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $74cf642ba7fa99c2$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$74cf642ba7fa99c2$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $74cf642ba7fa99c2$var$promise;
var $74cf642ba7fa99c2$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($74cf642ba7fa99c2$var$promise || ($74cf642ba7fa99c2$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $74cf642ba7fa99c2$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $74cf642ba7fa99c2$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $74cf642ba7fa99c2$var$createQueueWithTimer(10);
var $74cf642ba7fa99c2$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $74cf642ba7fa99c2$var$queueMicrotaskShim : options.type === "raf" ? $74cf642ba7fa99c2$var$rAF : options.type === "callback" ? options.queueNotification : $74cf642ba7fa99c2$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$74cf642ba7fa99c2$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $i4CZ2.enableES5)();

});
parcelRegister("i4CZ2", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => r);
$parcel$export(module.exports, "isDraftable", () => t);
$parcel$export(module.exports, "immerable", () => L);
$parcel$export(module.exports, "original", () => e);
$parcel$export(module.exports, "freeze", () => d);
$parcel$export(module.exports, "nothing", () => H);
$parcel$export(module.exports, "current", () => R);
$parcel$export(module.exports, "enableES5", () => F);
$parcel$export(module.exports, "enablePatches", () => T);
$parcel$export(module.exports, "enableMapSet", () => C);
$parcel$export(module.exports, "enableAllPlugins", () => J);
$parcel$export(module.exports, "castDraft", () => K);
$parcel$export(module.exports, "castImmutable", () => $);
$parcel$export(module.exports, "Immer", () => un);
$parcel$export(module.exports, "produce", () => fn);
$parcel$export(module.exports, "produceWithPatches", () => cn);
$parcel$export(module.exports, "setAutoFreeze", () => sn);
$parcel$export(module.exports, "setUseProxies", () => vn);
$parcel$export(module.exports, "applyPatches", () => pn);
$parcel$export(module.exports, "createDraft", () => ln);
$parcel$export(module.exports, "finishDraft", () => dn);
$parcel$export(module.exports, "default", () => $d286d705bbfd559a$export$2e2bcd8739ae039);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i = Y[n], o = i ? "function" == typeof i ? i.apply(null, t) : i : "unknown error nr: " + n;
    throw Error("[Immer] " + o);
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U || n(0), U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (c === o && n(5), r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return f(r), en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                f(t), en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return isNaN(parseInt(t)) && n(13), on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return "length" !== t && isNaN(parseInt(t)) && n(14), en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        e && e.C || n(9), e.I && n(10);
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $d286d705bbfd559a$export$2e2bcd8739ae039 = fn;

});

parcelRegister("eShmq", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $ad4393542232627c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $ad4393542232627c$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $ad4393542232627c$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $ad4393542232627c$export$9ff26e0402cc7b7);

var $d49SP = parcelRequire("d49SP");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $ad4393542232627c$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $ad4393542232627c$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $ad4393542232627c$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $ad4393542232627c$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $ad4393542232627c$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $ad4393542232627c$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $ad4393542232627c$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $ad4393542232627c$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $ad4393542232627c$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($ad4393542232627c$var$isDate(val)) return "date";
    if ($ad4393542232627c$var$isError(val)) return "error";
    var constructorName = $ad4393542232627c$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $ad4393542232627c$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $ad4393542232627c$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $ad4393542232627c$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $ad4393542232627c$var$kindOf(val) {
    var typeOfVal = typeof val;
    typeOfVal = $ad4393542232627c$var$miniKindOf(val);
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $ad4393542232627c$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error("Expected the enhancer to be a function. Instead, received: '" + $ad4393542232627c$var$kindOf(enhancer) + "'");
        return enhancer($ad4393542232627c$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error("Expected the root reducer to be a function. Instead, received: '" + $ad4393542232627c$var$kindOf(reducer) + "'");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error("Expected the listener to be a function. Instead, received: '" + $ad4393542232627c$var$kindOf(listener) + "'");
        if (isDispatching) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$ad4393542232627c$var$isPlainObject(action)) throw new Error("Actions must be plain objects. Instead, the actual type was: '" + $ad4393542232627c$var$kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
        if (typeof action.type === "undefined") throw new Error('Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
        if (isDispatching) throw new Error("Reducers may not dispatch actions.");
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error("Expected the nextReducer to be a function. Instead, received: '" + $ad4393542232627c$var$kindOf(nextReducer));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $ad4393542232627c$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error("Expected the observer to be an object. Instead, received: '" + $ad4393542232627c$var$kindOf(observer) + "'");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$ad4393542232627c$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $ad4393542232627c$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$ad4393542232627c$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $ad4393542232627c$export$8928921ea2d3b126 = $ad4393542232627c$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $ad4393542232627c$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $ad4393542232627c$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$ad4393542232627c$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $ad4393542232627c$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $ad4393542232627c$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $ad4393542232627c$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error('The slice reducer for key "' + key + '" returned undefined during initialization. ' + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        if (typeof reducer(undefined, {
            type: $ad4393542232627c$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error('The slice reducer for key "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle '" + $ad4393542232627c$export$4219e499db7ca678.INIT + '\' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $ad4393542232627c$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "undefined") $ad4393542232627c$var$warning('No reducer provided for key "' + key + '"');
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    unexpectedKeyCache = {};
    var shapeAssertionError;
    try {
        $ad4393542232627c$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage = $ad4393542232627c$var$getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
        if (warningMessage) $ad4393542232627c$var$warning(warningMessage);
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error("When called with an action of type " + (actionType ? '"' + String(actionType) + '"' : "(unknown type)") + ', the slice reducer for key "' + _key + '" returned undefined. ' + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $ad4393542232627c$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $ad4393542232627c$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, but instead received: '" + $ad4393542232627c$var$kindOf(actionCreators) + "'. " + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $ad4393542232627c$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $ad4393542232627c$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $ad4393542232627c$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $ad4393542232627c$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $d49SP.default)((0, $d49SP.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("d49SP", function(module, exports) {

$parcel$export(module.exports, "default", () => $983350b7b3960a26$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");
function $983350b7b3960a26$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $983350b7b3960a26$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $983350b7b3960a26$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSlfw.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $983350b7b3960a26$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("6SpLG", function(module, exports) {

$parcel$export(module.exports, "createSelector", () => $501bc638b8425ea6$export$595d22ed68ca2841);

var $9EdUm = parcelRequire("9EdUm");
function $501bc638b8425ea6$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $501bc638b8425ea6$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $501bc638b8425ea6$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $501bc638b8425ea6$export$595d22ed68ca2841 = /* #__PURE__ */ $501bc638b8425ea6$export$5943f4447f6ef248((0, $9EdUm.defaultMemoize));
var $501bc638b8425ea6$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $501bc638b8425ea6$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("9EdUm", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", () => $7062a3595350e02d$export$281bff7f05488aa2);
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $7062a3595350e02d$var$NOT_FOUND = "NOT_FOUND";
function $7062a3595350e02d$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $7062a3595350e02d$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $7062a3595350e02d$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $7062a3595350e02d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $7062a3595350e02d$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $7062a3595350e02d$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $7062a3595350e02d$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $7062a3595350e02d$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $7062a3595350e02d$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $7062a3595350e02d$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $7062a3595350e02d$var$createSingletonCache(comparator) : $7062a3595350e02d$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $7062a3595350e02d$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("eNuyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac5d5956ce0b399b$export$2e2bcd8739ae039);
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $ac5d5956ce0b399b$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $ac5d5956ce0b399b$var$thunk = $ac5d5956ce0b399b$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$ac5d5956ce0b399b$var$thunk.withExtraArgument = $ac5d5956ce0b399b$var$createThunkMiddleware;
var $ac5d5956ce0b399b$export$2e2bcd8739ae039 = $ac5d5956ce0b399b$var$thunk;

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("aHaJN", function(module, exports) {
"use strict";

var $e080M = parcelRequire("e080M");
var $7c963fd2423c5693$require$sort = $e080M.sort;
// promotions including these words should be sorted first, and grouped in the order of these arrays
const $7c963fd2423c5693$var$prioritizedDivisions = [
    "BACKWALL",
    "CLEARANCE"
];
const $7c963fd2423c5693$var$prioritizedGenders = [
    "MENS",
    "WOMENS",
    "KIDS"
];
const $7c963fd2423c5693$var$sortByPriority = (priorities, pieces, originalLeft, originalRight)=>{
    const currentPriorities = priorities[0];
    const [left, right] = pieces[0];
    if (currentPriorities.includes(left) && currentPriorities.includes(right)) {
        // compare two strings with prioritized words
        const leftPriority = currentPriorities.findIndex((x)=>x === left);
        const rightPriority = currentPriorities.findIndex((x)=>x === right);
        const restOfPriorities = priorities.slice(1);
        const restOfPieces = pieces.slice(1);
        // eslint-disable-next-line no-nested-ternary
        return leftPriority === rightPriority ? restOfPriorities.length && restOfPieces.length ? $7c963fd2423c5693$var$sortByPriority(restOfPriorities, restOfPieces, originalLeft, originalRight) : originalLeft.localeCompare(originalRight) : leftPriority - rightPriority;
    }
    if (currentPriorities.includes(left)) // only left is a prioritized word
    return -1;
    if (currentPriorities.includes(right)) // only right is a prioritized word
    return 1;
    return originalLeft.localeCompare(originalRight);
};
// return a negative integer if 'left' goes before 'right', return a positive integer if 'right' goes before 'left'
const $7c963fd2423c5693$var$compare = ({ name: left }, { name: right })=>{
    if (!left) return 1;
    if (!right) return -1;
    const leftWords = left.split(" ");
    const leftFirst = leftWords[0];
    const leftLast = leftWords[leftWords.length - 1];
    const rightWords = right.split(" ");
    const rightFirst = rightWords[0];
    const rightLast = rightWords[rightWords.length - 1];
    return $7c963fd2423c5693$var$sortByPriority([
        $7c963fd2423c5693$var$prioritizedDivisions,
        $7c963fd2423c5693$var$prioritizedGenders
    ], [
        [
            leftLast,
            rightLast
        ],
        [
            leftFirst,
            rightFirst
        ]
    ], left, right);
};
/**
 * First, promotions are in 1 of 3 groups sorted by BACKWALL, CLEARANCE, then others.
 * In the first 2 groups, promotions are further sorted by MENS, WOMENS, KIDS, then others alphabetically.
 * Any remaining promotions in the 3rd group are sorted alphabetically.
 */ const $7c963fd2423c5693$var$sortPromotions = (promotions)=>$7c963fd2423c5693$require$sort(promotions, $7c963fd2423c5693$var$compare);
module.exports = $7c963fd2423c5693$var$sortPromotions;

});

parcelRegister("30Fb0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $23114ffdb0bde66a$export$1e511d4a378977f5, (v) => $23114ffdb0bde66a$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $23114ffdb0bde66a$export$2e2bcd8739ae039, (v) => $23114ffdb0bde66a$export$2e2bcd8739ae039 = v);
var $23114ffdb0bde66a$export$1e511d4a378977f5;
var $23114ffdb0bde66a$export$2e2bcd8739ae039;
"use strict";
$23114ffdb0bde66a$export$1e511d4a378977f5 = true;
$23114ffdb0bde66a$export$2e2bcd8739ae039 = void 0;
// All data fetched from child pages of https://confluence.nike.com/display/G11N/Nike+Locale+Quick+Guide
const $23114ffdb0bde66a$var$countryInfo = {
    ARE: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "AED",
            thousands: ","
        },
        dateFormat: "YYYY/M/D"
    },
    ARG: {
        dateFormat: "DD/MM/YYYY"
    },
    AUS: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "$",
            thousands: ","
        },
        dateFormat: "DD/MM/YYYY"
    },
    AUT: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            prefix: "\u20AC",
            thousands: "."
        },
        dateFormat: "DD.MM.YYYY"
    },
    BEL: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            prefix: "\u20AC",
            thousands: "."
        },
        dateFormat: "YYYY-MM-DD"
    },
    BGR: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            postfix: "\u043B\u0432.",
            prefix: "",
            thousands: ","
        },
        dateFormat: "DD.MM.YYYY"
    },
    BRA: {
        dateFormat: "DD/MM/YYYY"
    },
    CAN: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "$",
            thousands: ","
        },
        dateFormat: "MM/DD/YYYY"
    },
    CHE: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "CHF",
            thousands: "\u2019"
        },
        dateFormat: "DD.MM.YYYY"
    },
    CHL: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 0,
            prefix: "$",
            thousands: "."
        },
        dateFormat: "DD.MM.YYYY"
    },
    CHN: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "\uFFE5",
            thousands: ","
        },
        dateFormat: "YYYY/MM/DD"
    },
    CZE: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "K\u010D",
            prefix: "",
            thousands: " "
        },
        dateFormat: "D. M. YYYY"
    },
    DEU: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "\u20AC",
            prefix: "",
            thousands: "."
        },
        dateFormat: "DD.MM.YYYY"
    },
    DNK: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "kr.",
            prefix: "",
            thousands: "."
        },
        dateFormat: "DD-MM-YYYY"
    },
    EGY: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "EGP",
            thousands: ","
        },
        dateFormat: "YYYY/MM/DD"
    },
    ESP: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "\u20AC",
            prefix: "",
            thousands: "."
        },
        dateFormat: "DD/MM/YYYY"
    },
    FIN: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            postfix: "\u20AC",
            prefix: "",
            thousands: ","
        },
        dateFormat: "D.M.YYYY"
    },
    FRA: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "\u20AC",
            prefix: "",
            thousands: " "
        },
        dateFormat: "DD/MM/YYYY"
    },
    GBR: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "\xa3",
            thousands: ","
        },
        dateFormat: "DD/MM/YYYY"
    },
    GRC: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            prefix: "\u20AC",
            thousands: "."
        },
        dateFormat: "DD/MM/YYYY"
    },
    "Hong Kong": {},
    HRV: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            postfix: "kn",
            prefix: "",
            thousands: ","
        },
        dateFormat: "D. M. YYYY"
    },
    HUN: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "Ft",
            prefix: "",
            thousands: " "
        },
        dateFormat: "YYYY. MM. DD."
    },
    IDN: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "Rp",
            thousands: ","
        },
        dateFormat: "DD/MM/YYYY"
    },
    IND: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "\u20B9",
            thousands: ","
        },
        dateFormat: "DD-MM-YY"
    },
    IRL: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "\u20AC",
            thousands: ","
        },
        dateFormat: "DD/MM/YYYY"
    },
    ISR: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "\u20AA",
            thousands: ","
        },
        dateFormat: "DD/MM/YYYY"
    },
    ITA: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "\u20AC",
            prefix: "",
            thousands: "."
        },
        dateFormat: "DD/MM/YYYY"
    },
    JPN: {
        currency: {
            digitsAfterDecimal: 0,
            prefix: "\uFFE5",
            thousands: ","
        },
        dateFormat: "YYYY/MM/DD"
    },
    KOR: {
        currency: {
            digitsAfterDecimal: 0,
            postfix: "\uFFE6",
            prefix: "",
            thousands: ","
        },
        dateFormat: "YYYY/MM/DD"
    },
    LUX: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "\u20AC",
            prefix: "",
            thousands: "."
        },
        dateFormat: "DD/MM/YYYY"
    },
    MAR: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "Dh",
            prefix: "",
            thousands: "."
        },
        dateFormat: "YYYY/M/D"
    },
    MEX: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "$",
            thousands: ","
        },
        dateFormat: "DD/MM/YYYY"
    },
    MYS: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "RM",
            thousands: ","
        },
        dateFormat: "D/M/YY"
    },
    NLD: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            prefix: "\u20AC",
            thousands: "."
        },
        dateFormat: "DD-MM-YYYY"
    },
    NOR: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            prefix: "kr",
            thousands: " "
        },
        dateFormat: "DD/MM/YYYY"
    },
    NZL: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "$",
            thousands: ","
        },
        dateFormat: "DD/MM/YYYY"
    },
    PHL: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "\u20B1",
            thousands: ","
        },
        dateFormat: "MM/DD/YYYY"
    },
    POL: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "z\u0142",
            prefix: "",
            thousands: " " // Should only be used if there are 5 or more digits... I'll... figure that out later...
        },
        dateFormat: "D.MM.YYYY"
    },
    PRI: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "$",
            thousands: ","
        },
        dateFormat: "DD/MM/YYYY"
    },
    PRT: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "\u20AC",
            prefix: "",
            thousands: " "
        },
        dateFormat: "DD/MM/YYYY"
    },
    ROU: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "lei",
            prefix: "",
            thousands: "."
        },
        dateFormat: "DD/MM/YYYY"
    },
    RUS: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "\u20BD",
            prefix: "",
            thousands: " "
        },
        dateFormat: "DD.MM.YYYY"
    },
    SAU: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "SAR",
            thousands: ","
        },
        dateFormat: "YYYY/M/D"
    },
    SGP: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "S$",
            thousands: ","
        },
        dateFormat: "DD-MM-YYYY"
    },
    SVK: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "\u20AC",
            thousands: ","
        },
        dateFormat: "DD. MM. YYYY"
    },
    SVN: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "\u20AC",
            thousands: ","
        },
        dateFormat: "D. M. YYYY"
    },
    SWE: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            postfix: "kr",
            prefix: "",
            thousands: " "
        },
        dateFormat: "DD-MM-YY"
    },
    THA: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "\u0E3F",
            thousands: ","
        },
        dateFormat: "DD/MM/YYYY"
    },
    TUR: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            prefix: "\u20BA",
            thousands: "."
        },
        dateFormat: "DD.MM.YYYY"
    },
    TWN: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "$",
            thousands: ","
        },
        dateFormat: "YYYY/MM/DD"
    },
    URY: {},
    USA: {
        currency: {
            decimal: ".",
            digitsAfterDecimal: 2,
            prefix: "$",
            thousands: ","
        },
        dateFormat: "MM/DD/YYYY"
    },
    VNM: {
        currency: {
            digitsAfterDecimal: 0,
            postfix: "\u20AB",
            prefix: "",
            thousands: ","
        },
        dateFormat: "D/M/YY"
    },
    ZAF: {
        currency: {
            decimal: ",",
            digitsAfterDecimal: 2,
            prefix: "R",
            thousands: " "
        },
        dateFormat: "DD-MM-YYYY"
    }
};
var $23114ffdb0bde66a$var$_default = $23114ffdb0bde66a$export$2e2bcd8739ae039 = $23114ffdb0bde66a$var$countryInfo;

});

parcelRegister("1BuK1", function(module, exports) {
"use strict";
/* eslint-disable sort-keys-fix/sort-keys-fix */ const $12b117bd7f770afb$var$divisionIDs = {
    "d3169f60-9d03-4ba0-818f-58e1967ce8e3": "Apparel Division",
    "5150459a-7ef9-46a8-b201-613fa841d871": "Cross Division",
    "24e5faba-9761-4669-bcc7-05060f0eeccb": "Equipment Division",
    "aaf5eae1-6889-4638-927a-527d511483a5": "Footwear Division",
    "79a3d559-ebcb-487c-8a6f-0ea13bfcdf74": "Product Division",
    "7e3ff92f-7caa-4587-b9b4-86dfcb6df576": "Visual Merchandising"
};
/*  Update the magic 6 in PromotionPreview.js if we ever have more divisionValues than below (there are 6 groupings, so 'All' is all 6) */ const $12b117bd7f770afb$var$divisionValues = [
    {
        label: "All",
        value: [
            "d3169f60-9d03-4ba0-818f-58e1967ce8e3",
            "5150459a-7ef9-46a8-b201-613fa841d871",
            "24e5faba-9761-4669-bcc7-05060f0eeccb",
            "aaf5eae1-6889-4638-927a-527d511483a5",
            "79a3d559-ebcb-487c-8a6f-0ea13bfcdf74",
            "7e3ff92f-7caa-4587-b9b4-86dfcb6df576"
        ]
    },
    {
        label: "Apparel Division",
        value: [
            "d3169f60-9d03-4ba0-818f-58e1967ce8e3"
        ]
    },
    {
        label: "Cross Division",
        value: [
            "5150459a-7ef9-46a8-b201-613fa841d871"
        ]
    },
    {
        label: "Equipment Division",
        value: [
            "24e5faba-9761-4669-bcc7-05060f0eeccb"
        ]
    },
    {
        label: "Footwear Division",
        value: [
            "aaf5eae1-6889-4638-927a-527d511483a5"
        ]
    },
    {
        label: "Product Division",
        value: [
            "79a3d559-ebcb-487c-8a6f-0ea13bfcdf74"
        ]
    },
    {
        label: "Visual Merchandising",
        value: [
            "7e3ff92f-7caa-4587-b9b4-86dfcb6df576"
        ]
    }
];
const $12b117bd7f770afb$var$genderAgeIDs = {
    "aea0eb4b-9e97-4052-bb0b-fa8f77641852": "Adult Unisex",
    "92cae888-59c1-404b-ab13-0c94fe20b1f6": "Mens",
    "71ab6e32-16b2-4e27-acf9-ea4cc09b73f0": "Womens",
    "bdab8de7-4d22-472c-8330-59e25be9faa6": "Unisex Big Kid",
    "a5ddf53a-f1c4-4563-a700-fbe35fff7799": "Unisex Little Kid",
    "a6515dc4-23cd-4d31-9a3e-214e31d4ef63": "Unisex Infant/Toddler",
    "72a66f34-43ad-4e8c-8796-c81047d27b7b": "Boys Big Kid",
    "c9653f79-6e18-4a05-bc31-faa39bca223e": "Boys Little Kid",
    "dba41ab9-5b16-44d9-bf44-fc16bacee6ba": "Boys Infant/Toddler",
    "37d86509-85cf-410a-8c3c-509a7c5633a7": "Girls Big Kid",
    "355b35ac-3af5-436b-86e8-2a3079d251dd": "Girls Little Kid",
    "6312357c-aceb-448d-9447-7f40c6d4eb01": "Girls Infant/Toddler"
};
const $12b117bd7f770afb$var$genderIDs = {
    "355b35ac-3af5-436b-86e8-2a3079d251dd": "Kids",
    "37d86509-85cf-410a-8c3c-509a7c5633a7": "Kids",
    "6312357c-aceb-448d-9447-7f40c6d4eb01": "Kids",
    "71ab6e32-16b2-4e27-acf9-ea4cc09b73f0": "Womens",
    "72a66f34-43ad-4e8c-8796-c81047d27b7b": "Kids",
    "92cae888-59c1-404b-ab13-0c94fe20b1f6": "Mens",
    "a5ddf53a-f1c4-4563-a700-fbe35fff7799": "Kids",
    "a6515dc4-23cd-4d31-9a3e-214e31d4ef63": "Kids",
    "aea0eb4b-9e97-4052-bb0b-fa8f77641852": "Adult Unisex",
    "bdab8de7-4d22-472c-8330-59e25be9faa6": "Kids",
    "c9653f79-6e18-4a05-bc31-faa39bca223e": "Kids",
    "dba41ab9-5b16-44d9-bf44-fc16bacee6ba": "Kids"
};
/*  Update the magic 4 in PromotionPreview.js if we ever have more genderValues than below(there are 4 groupings, so 'All' is all 4) */ const $12b117bd7f770afb$var$genderValues = [
    {
        label: "All",
        value: [
            "355b35ac-3af5-436b-86e8-2a3079d251dd",
            "37d86509-85cf-410a-8c3c-509a7c5633a7",
            "6312357c-aceb-448d-9447-7f40c6d4eb01",
            "71ab6e32-16b2-4e27-acf9-ea4cc09b73f0",
            "72a66f34-43ad-4e8c-8796-c81047d27b7b",
            "92cae888-59c1-404b-ab13-0c94fe20b1f6",
            "a5ddf53a-f1c4-4563-a700-fbe35fff7799",
            "a6515dc4-23cd-4d31-9a3e-214e31d4ef63",
            "aea0eb4b-9e97-4052-bb0b-fa8f77641852",
            "bdab8de7-4d22-472c-8330-59e25be9faa6",
            "c9653f79-6e18-4a05-bc31-faa39bca223e",
            "dba41ab9-5b16-44d9-bf44-fc16bacee6ba"
        ]
    },
    {
        label: "Mens",
        value: [
            "92cae888-59c1-404b-ab13-0c94fe20b1f6",
            "aea0eb4b-9e97-4052-bb0b-fa8f77641852"
        ]
    },
    {
        label: "Womens",
        value: [
            "71ab6e32-16b2-4e27-acf9-ea4cc09b73f0",
            "aea0eb4b-9e97-4052-bb0b-fa8f77641852"
        ]
    },
    {
        label: "Adult Unisex",
        value: [
            "aea0eb4b-9e97-4052-bb0b-fa8f77641852"
        ]
    },
    {
        label: "Kids",
        value: [
            "72a66f34-43ad-4e8c-8796-c81047d27b7b",
            "a5ddf53a-f1c4-4563-a700-fbe35fff7799",
            "a6515dc4-23cd-4d31-9a3e-214e31d4ef63",
            "bdab8de7-4d22-472c-8330-59e25be9faa6",
            "c9653f79-6e18-4a05-bc31-faa39bca223e",
            "dba41ab9-5b16-44d9-bf44-fc16bacee6ba",
            "355b35ac-3af5-436b-86e8-2a3079d251dd",
            "37d86509-85cf-410a-8c3c-509a7c5633a7",
            "6312357c-aceb-448d-9447-7f40c6d4eb01"
        ]
    }
];
const $12b117bd7f770afb$var$translationMappings = {
    All: "RL_All",
    "Apparel Division": "RL_ApparelDivision",
    "Cross Division": "RL_CrossDivision",
    "Equipment Division": "RL_EquipmentDivision",
    "Footwear Division": "RL_FootwearDivision",
    "Product Division": "RL_ProductDivision",
    "Visual Merchandising": "RL_VisualMerchandising",
    Mens: "RL_Mens",
    Womens: "RL_Womens",
    "Adult Unisex": "RL_AdultUnisex",
    Kids: "RL_Kids",
    Apparel: "RL_Apparel",
    Equipment: "RL_Equipment",
    Footwear: "RL_Footwear"
};
module.exports = {
    divisionIDs: $12b117bd7f770afb$var$divisionIDs,
    divisionValues: $12b117bd7f770afb$var$divisionValues,
    genderAgeIDs: $12b117bd7f770afb$var$genderAgeIDs,
    genderIDs: $12b117bd7f770afb$var$genderIDs,
    genderValues: $12b117bd7f770afb$var$genderValues,
    translationMappings: $12b117bd7f770afb$var$translationMappings
};

});


parcelRegister("7s4Ap", function(module, exports) {

$parcel$export(module.exports, "put", () => $56ceb4aec0813cc6$export$327f7b26ebf455db, (v) => $56ceb4aec0813cc6$export$327f7b26ebf455db = v);
$parcel$export(module.exports, "postCsv", () => $56ceb4aec0813cc6$export$e58a427668942a50, (v) => $56ceb4aec0813cc6$export$e58a427668942a50 = v);
$parcel$export(module.exports, "post", () => $56ceb4aec0813cc6$export$299ba2dee77727e9, (v) => $56ceb4aec0813cc6$export$299ba2dee77727e9 = v);
$parcel$export(module.exports, "patch", () => $56ceb4aec0813cc6$export$b76953f99ab2be78, (v) => $56ceb4aec0813cc6$export$b76953f99ab2be78 = v);
$parcel$export(module.exports, "get", () => $56ceb4aec0813cc6$export$3988ae62b71be9a3, (v) => $56ceb4aec0813cc6$export$3988ae62b71be9a3 = v);
var $56ceb4aec0813cc6$export$1e511d4a378977f5;
var $56ceb4aec0813cc6$export$327f7b26ebf455db;
var $56ceb4aec0813cc6$export$e58a427668942a50;
var $56ceb4aec0813cc6$export$299ba2dee77727e9;
var $56ceb4aec0813cc6$export$b76953f99ab2be78;
var $56ceb4aec0813cc6$export$3988ae62b71be9a3;
"use strict";
$56ceb4aec0813cc6$export$1e511d4a378977f5 = true;
$56ceb4aec0813cc6$export$327f7b26ebf455db = $56ceb4aec0813cc6$export$e58a427668942a50 = $56ceb4aec0813cc6$export$299ba2dee77727e9 = $56ceb4aec0813cc6$export$b76953f99ab2be78 = $56ceb4aec0813cc6$export$3988ae62b71be9a3 = void 0;
const $56ceb4aec0813cc6$var$get = async (token, host, resource, queryString)=>fetch(`${host}${resource}${queryString !== null && queryString !== void 0 ? queryString : ""}`, {
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Request-Headers": "Accept, Access-Control-Allow-Credentials, Access-Control-Allow-Origin, Authorization",
            Authorization: `Bearer ${token}`
        },
        method: "GET"
    }).then(async (res)=>{
        if (!res.ok) // eslint-disable-next-line fp/no-throw
        throw await res.json();
        return res.json();
    });
// export const getPartner = async (token, host, resource, queryString) => fetch(
//   `${host}${resource}${queryString ?? ''}`,
//   {
//     headers: {
//       Accept: 'application/json',
//       'Access-Control-Allow-Credentials': 'true',
//       'Access-Control-Allow-Origin': '*',
//       'Access-Control-Request-Headers': 'Accept, Access-Control-Allow-Credentials, Access-Control-Allow-Origin, Authorization, authtype',
//       Authorization: `Bearer ${token}`,
//       authtype: 'okta',
//     },
//     method: 'GET',
//   },
// )
//   .then(async (res) => {
//     if (!res.ok) {
//       // eslint-disable-next-line fp/no-throw
//       throw await res.json();
//     }
//     return res.json();
//   });
$56ceb4aec0813cc6$export$3988ae62b71be9a3 = $56ceb4aec0813cc6$var$get;
const $56ceb4aec0813cc6$var$patch = async (token, host, resource, body)=>fetch(`${host}${resource}`, {
        body: JSON.stringify(body),
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Request-Headers": "Accept, Access-Control-Allow-Credentials, Access-Control-Allow-Origin, Authorization, Content-Type",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        method: "PATCH"
    }).then(async (res)=>{
        if (!res.ok) // eslint-disable-next-line fp/no-throw
        throw await res.json();
        return res.json();
    });
// export const patchPartner = async (token, host, resource, body) => fetch(
//   `${host}${resource}`,
//   {
//     body: JSON.stringify(body),
//     headers: {
//       Accept: 'application/json',
//       'Access-Control-Allow-Credentials': 'true',
//       'Access-Control-Allow-Origin': '*',
//       'Access-Control-Request-Headers': 'Accept, Access-Control-Allow-Credentials, Access-Control-Allow-Origin, Authorization, Content-Type',
//       Authorization: `Bearer ${token}`,
//       authtype: 'okta',
//       'Content-Type': 'application/json',
//     },
//     method: 'PATCH',
//   },
// )
//   .then(async (res) => {
//     if (!res.ok) {
//       // eslint-disable-next-line fp/no-throw
//       throw await res.json();
//     }
//     return res.json();
//   });
$56ceb4aec0813cc6$export$b76953f99ab2be78 = $56ceb4aec0813cc6$var$patch;
const $56ceb4aec0813cc6$var$post = async (token, host, resource, body)=>fetch(`${host}${resource}`, {
        body: JSON.stringify(body),
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Request-Headers": "Accept, Access-Control-Allow-Credentials, Access-Control-Allow-Origin, Authorization, Content-Type",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        method: "POST"
    }).then(async (res)=>{
        if (!res.ok) // eslint-disable-next-line fp/no-throw
        throw await res.json();
        return res.json();
    });
// eslint-disable-next-line no-unused-vars
$56ceb4aec0813cc6$export$299ba2dee77727e9 = $56ceb4aec0813cc6$var$post;
const $56ceb4aec0813cc6$var$postCsv = async (token, host, resource, data, uploadId, batchNo, isLastBatch)=>{
    const queryUploadId = uploadId ? `&uploadId=${uploadId}&` : "";
    const query = `?${queryUploadId}batchNo=${batchNo}&isLastBatch=${isLastBatch}`;
    return fetch(`${host}${resource}${query}`, {
        body: JSON.stringify(data),
        headers: {
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Request-Headers": "Accept, Access-Control-Allow-Headers, Access-Control-Allow-Credentials, Access-Control-Allow-Origin, Authorization, Content-Type",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        method: "POST"
    }).then(async (res)=>{
        if (!res.ok) // eslint-disable-next-line fp/no-throw
        throw await res.json();
        return res.json();
    });
};
// export const postPartner = async (token, host, resource, body) => fetch(
//   `${host}${resource}`,
//   {
//     body: JSON.stringify(body),
//     headers: {
//       Accept: 'application/json',
//       'Access-Control-Allow-Credentials': 'true',
//       'Access-Control-Allow-Origin': '*',
//       'Access-Control-Request-Headers': 'Accept, Access-Control-Allow-Credentials, Access-Control-Allow-Origin, Authorization, Content-Type, authtype',
//       Authorization: `Bearer ${token}`,
//       authtype: 'okta',
//       'Content-Type': 'application/json'
//     },
//     method: 'POST',
//   },
// )
//   .then(async (res) => {
//     if (!res.ok) {
//       // eslint-disable-next-line fp/no-throw
//       throw await res.json();
//     }
//     return res.json();
//   });
$56ceb4aec0813cc6$export$e58a427668942a50 = $56ceb4aec0813cc6$var$postCsv;
const $56ceb4aec0813cc6$var$put = async (token, host, resource, body)=>fetch(`${host}${resource}`, {
        body: JSON.stringify(body),
        headers: {
            Accept: "application/json",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Request-Headers": "Accept, Access-Control-Allow-Credentials, Access-Control-Allow-Origin, Authorization, Content-Type",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
        },
        method: "PUT"
    }).then(async (res)=>{
        if (!res.ok) // eslint-disable-next-line fp/no-throw
        throw await res.json();
        return res.json();
    });
$56ceb4aec0813cc6$export$327f7b26ebf455db = $56ceb4aec0813cc6$var$put;

});


parcelRegister("ciGEA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $8f48409550048901$export$1e511d4a378977f5, (v) => $8f48409550048901$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $8f48409550048901$export$2e2bcd8739ae039, (v) => $8f48409550048901$export$2e2bcd8739ae039 = v);
var $8f48409550048901$export$1e511d4a378977f5;
var $8f48409550048901$export$2e2bcd8739ae039;
"use strict";
$8f48409550048901$export$1e511d4a378977f5 = true;
$8f48409550048901$export$2e2bcd8739ae039 = void 0;
/* eslint-disable fp/no-mutation */ /**
 * Communication layer between the Promote web app and the iOS native wrapper (WKWebView).
 *
 * Protocol (matches NikeNativeBridgeHandler.swift):
 *   Web → Native : window.webkit.messageHandlers.nikeNative.postMessage({ action })
 *   Native → Web : window.nikeNative.onAthleteToken({ token } | { error })
 *                   window.nikeNative.onUserDidChange({})
 */ const $8f48409550048901$var$NATIVE_TOKEN_TIMEOUT_MS = 5000;
let $8f48409550048901$var$sessionGeneration = 0;
const $8f48409550048901$var$state = {
    bridgeInitialized: false,
    pendingGeneration: 0,
    tokenReject: null,
    tokenResolve: null
};
const $8f48409550048901$var$NativeBridge = {
    /**
   * Register the `window.nikeNative` callback object and background-resume listener.
   * Call once at app startup.
   *
   * @param {Object}   opts
   * @param {function} opts.onUserDidChange  - called when native detects a different SSO user
   * @param {function} opts.onTokenRefreshed - called with a fresh access_token on foreground resume
   */ initialize ({ onUserDidChange: onUserDidChange, onTokenRefreshed: onTokenRefreshed } = {}) {
        if ($8f48409550048901$var$state.bridgeInitialized || !this.isNativeApp()) return;
        $8f48409550048901$var$state.bridgeInitialized = true;
        window.nikeNative = {
            onAthleteToken: (response)=>{
                if ($8f48409550048901$var$state.pendingGeneration !== $8f48409550048901$var$sessionGeneration) {
                    $8f48409550048901$var$state.tokenResolve = null;
                    $8f48409550048901$var$state.tokenReject = null;
                    return;
                }
                if (response.error && $8f48409550048901$var$state.tokenReject) $8f48409550048901$var$state.tokenReject(new Error(response.error));
                else if (response.token && $8f48409550048901$var$state.tokenResolve) $8f48409550048901$var$state.tokenResolve(response.token);
                $8f48409550048901$var$state.tokenResolve = null;
                $8f48409550048901$var$state.tokenReject = null;
            },
            onUserDidChange: ()=>{
                $8f48409550048901$var$sessionGeneration++;
                if ($8f48409550048901$var$state.tokenReject) $8f48409550048901$var$state.tokenReject(new Error("Session invalidated by user change"));
                $8f48409550048901$var$state.tokenResolve = null;
                $8f48409550048901$var$state.tokenReject = null;
                if (onUserDidChange) onUserDidChange();
            }
        };
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "visible" && localStorage.getItem("isNativeApp") === "true") $8f48409550048901$var$NativeBridge.requestAthleteToken().then((token)=>{
                if (onTokenRefreshed) onTokenRefreshed(token);
                return undefined;
            }).catch(()=>{});
        });
    },
    isNativeApp () {
        return !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.nikeNative);
    },
    /**
   * Ask native for the current athlete JWT.
   * Resolves with the raw access-token string; rejects on error or timeout.
   * If a prior request is still pending it is rejected before the new one starts.
   */ requestAthleteToken () {
        return new Promise((resolve, reject)=>{
            if (!this.isNativeApp()) {
                reject(new Error("Not running in native app"));
                return;
            }
            if ($8f48409550048901$var$state.tokenReject) {
                $8f48409550048901$var$state.tokenReject(new Error("Superseded by a newer token request"));
                $8f48409550048901$var$state.tokenResolve = null;
                $8f48409550048901$var$state.tokenReject = null;
            }
            const timeout = setTimeout(()=>{
                $8f48409550048901$var$state.tokenResolve = null;
                $8f48409550048901$var$state.tokenReject = null;
                reject(new Error("Token request timed out"));
            }, $8f48409550048901$var$NATIVE_TOKEN_TIMEOUT_MS);
            $8f48409550048901$var$state.tokenResolve = (token)=>{
                clearTimeout(timeout);
                resolve(token);
            };
            $8f48409550048901$var$state.tokenReject = (err)=>{
                clearTimeout(timeout);
                reject(err);
            };
            $8f48409550048901$var$state.pendingGeneration = $8f48409550048901$var$sessionGeneration;
            window.webkit.messageHandlers.nikeNative.postMessage({
                action: "getAthleteToken"
            });
        });
    },
    /** Tell native to log out (fire-and-forget; native tears down the WebView). */ requestLogout () {
        if (!this.isNativeApp()) return;
        window.webkit.messageHandlers.nikeNative.postMessage({
            action: "logout"
        });
    }
};
var $8f48409550048901$var$_default = $8f48409550048901$export$2e2bcd8739ae039 = $8f48409550048901$var$NativeBridge;

});


parcelRegister("heiVx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $c8b26d00905df3d3$export$1e511d4a378977f5, (v) => $c8b26d00905df3d3$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $c8b26d00905df3d3$export$2e2bcd8739ae039, (v) => $c8b26d00905df3d3$export$2e2bcd8739ae039 = v);
var $c8b26d00905df3d3$export$1e511d4a378977f5;
var $c8b26d00905df3d3$export$2e2bcd8739ae039;
"use strict";
$c8b26d00905df3d3$export$1e511d4a378977f5 = true;
$c8b26d00905df3d3$export$2e2bcd8739ae039 = void 0;

var $2Hjjx = parcelRequire("2Hjjx");

var $c8b26d00905df3d3$var$_react = $c8b26d00905df3d3$var$_interopRequireWildcard((parcelRequire("acw62")));

var $kfZjc = parcelRequire("kfZjc");

var $ilYXe = parcelRequire("ilYXe");
function $c8b26d00905df3d3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($c8b26d00905df3d3$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $c8b26d00905df3d3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $c8b26d00905df3d3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $c8b26d00905df3d3$var$Authorize = ()=>{
    const [accessTokenError, setAccessTokenError] = (0, $c8b26d00905df3d3$var$_react.useState)(false);
    const [accessTokenSuccess, setAccessTokenSuccess] = (0, $c8b26d00905df3d3$var$_react.useState)(false);
    const [authFlowError, setAuthFlowError] = (0, $c8b26d00905df3d3$var$_react.useState)(false);
    const [isLoading, setIsLoading] = (0, $c8b26d00905df3d3$var$_react.useState)(true);
    (0, $c8b26d00905df3d3$var$_react.useEffect)(()=>{
        // eslint-disable-next-line fp/no-let
        let unmounted = false;
        (0, $ilYXe.postCodeToOkta)().then((body)=>{
            const exp = JSON.parse(window.atob(body.access_token.split(".")[1], "base64")).exp * 1000 - 600000;
            localStorage.setItem("expiresAt", exp);
            localStorage.setItem("accessToken", body.access_token);
            if (!unmounted) setAccessTokenSuccess(true);
            return localStorage.removeItem("code_verifier");
        }).catch((err)=>{
            if (!unmounted) return err.name === "OktaException" ? setAuthFlowError(true) : setAccessTokenError(true);
            return localStorage.removeItem("code_verifier");
        });
        // eslint-disable-next-line fp/no-mutation
        return ()=>{
            unmounted = true;
        };
    }, []);
    (0, $c8b26d00905df3d3$var$_react.useEffect)(()=>{
        setIsLoading(false);
    }, [
        accessTokenError,
        accessTokenSuccess,
        authFlowError
    ]);
    return /*#__PURE__*/ $c8b26d00905df3d3$var$_react.default.createElement("main", {
        className: "ncss-col-sm-12 mt12-sm pt2-sm ta-sm-c"
    }, /*#__PURE__*/ $c8b26d00905df3d3$var$_react.default.createElement("p", {
        className: "headline-4"
    }, "Validating credentials..."), isLoading && /*#__PURE__*/ $c8b26d00905df3d3$var$_react.default.createElement($2Hjjx.Loading, null), accessTokenSuccess && !isLoading && /*#__PURE__*/ $c8b26d00905df3d3$var$_react.default.createElement($kfZjc.Redirect, {
        to: {
            pathname: "promotions"
        }
    }), accessTokenError && !isLoading && /*#__PURE__*/ $c8b26d00905df3d3$var$_react.default.createElement($kfZjc.Redirect, {
        to: {
            pathname: "error"
        }
    }), authFlowError && !isLoading && /*#__PURE__*/ $c8b26d00905df3d3$var$_react.default.createElement($kfZjc.Redirect, {
        to: {
            pathname: "unauthorized"
        }
    }));
};
var $c8b26d00905df3d3$var$_default = $c8b26d00905df3d3$export$2e2bcd8739ae039 = $c8b26d00905df3d3$var$Authorize;

});
parcelRegister("2Hjjx", function(module, exports) {



module.exports = function(e) {
    var t = {};
    function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function(e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, n.t = function(e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
            return e[t];
        }).bind(null, o));
        return r;
    }, n.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return n.d(t, "a", t), t;
    }, n.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 68);
}([
    function(e, t, n) {
        e.exports = n(69)();
    },
    function(e, t) {
        e.exports = (parcelRequire("acw62"));
    },
    function(e, t) {
        e.exports = (parcelRequire("8g1PZ"));
    },
    function(e, t, n) {
        (function(e) {
            e.exports = function() {
                "use strict";
                var t, n;
                function r() {
                    return t.apply(null, arguments);
                }
                function o(e) {
                    return e instanceof Array || "[object Array]" === Object.prototype.toString.call(e);
                }
                function a(e) {
                    return null != e && "[object Object]" === Object.prototype.toString.call(e);
                }
                function i(e) {
                    return void 0 === e;
                }
                function s(e) {
                    return "number" == typeof e || "[object Number]" === Object.prototype.toString.call(e);
                }
                function l(e) {
                    return e instanceof Date || "[object Date]" === Object.prototype.toString.call(e);
                }
                function c(e, t) {
                    var n, r = [];
                    for(n = 0; n < e.length; ++n)r.push(t(e[n], n));
                    return r;
                }
                function u(e, t) {
                    return Object.prototype.hasOwnProperty.call(e, t);
                }
                function f(e, t) {
                    for(var n in t)u(t, n) && (e[n] = t[n]);
                    return u(t, "toString") && (e.toString = t.toString), u(t, "valueOf") && (e.valueOf = t.valueOf), e;
                }
                function p(e, t, n, r) {
                    return Ct(e, t, n, r, !0).utc();
                }
                function d(e) {
                    return null == e._pf && (e._pf = {
                        empty: !1,
                        unusedTokens: [],
                        unusedInput: [],
                        overflow: -2,
                        charsLeftOver: 0,
                        nullInput: !1,
                        invalidMonth: null,
                        invalidFormat: !1,
                        userInvalidated: !1,
                        iso: !1,
                        parsedDateParts: [],
                        meridiem: null,
                        rfc2822: !1,
                        weekdayMismatch: !1
                    }), e._pf;
                }
                function h(e) {
                    if (null == e._isValid) {
                        var t = d(e), r = n.call(t.parsedDateParts, function(e) {
                            return null != e;
                        }), o = !isNaN(e._d.getTime()) && t.overflow < 0 && !t.empty && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r);
                        if (e._strict && (o = o && 0 === t.charsLeftOver && 0 === t.unusedTokens.length && void 0 === t.bigHour), null != Object.isFrozen && Object.isFrozen(e)) return o;
                        e._isValid = o;
                    }
                    return e._isValid;
                }
                function y(e) {
                    var t = p(NaN);
                    return null != e ? f(d(t), e) : d(t).userInvalidated = !0, t;
                }
                n = Array.prototype.some ? Array.prototype.some : function(e) {
                    for(var t = Object(this), n = t.length >>> 0, r = 0; r < n; r++)if (r in t && e.call(this, t[r], r, t)) return !0;
                    return !1;
                };
                var m = r.momentProperties = [];
                function b(e, t) {
                    var n, r, o;
                    if (i(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), i(t._i) || (e._i = t._i), i(t._f) || (e._f = t._f), i(t._l) || (e._l = t._l), i(t._strict) || (e._strict = t._strict), i(t._tzm) || (e._tzm = t._tzm), i(t._isUTC) || (e._isUTC = t._isUTC), i(t._offset) || (e._offset = t._offset), i(t._pf) || (e._pf = d(t)), i(t._locale) || (e._locale = t._locale), m.length > 0) for(n = 0; n < m.length; n++)r = m[n], i(o = t[r]) || (e[r] = o);
                    return e;
                }
                var g = !1;
                function v(e) {
                    b(this, e), this._d = new Date(null != e._d ? e._d.getTime() : NaN), this.isValid() || (this._d = new Date(NaN)), !1 === g && (g = !0, r.updateOffset(this), g = !1);
                }
                function O(e) {
                    return e instanceof v || null != e && null != e._isAMomentObject;
                }
                function A(e) {
                    return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
                }
                function w(e) {
                    var t = +e, n = 0;
                    return 0 !== t && isFinite(t) && (n = A(t)), n;
                }
                function S(e, t, n) {
                    var r, o = Math.min(e.length, t.length), a = Math.abs(e.length - t.length), i = 0;
                    for(r = 0; r < o; r++)(n && e[r] !== t[r] || !n && w(e[r]) !== w(t[r])) && i++;
                    return i + a;
                }
                function E(e) {
                    !1 === r.suppressDeprecationWarnings && "undefined" != typeof console && console.warn && console.warn("Deprecation warning: " + e);
                }
                function D(e, t) {
                    var n = !0;
                    return f(function() {
                        if (null != r.deprecationHandler && r.deprecationHandler(null, e), n) {
                            for(var o, a = [], i = 0; i < arguments.length; i++){
                                if (o = "", "object" == typeof arguments[i]) {
                                    for(var s in o += "\n[" + i + "] ", arguments[0])o += s + ": " + arguments[0][s] + ", ";
                                    o = o.slice(0, -2);
                                } else o = arguments[i];
                                a.push(o);
                            }
                            E(e + "\nArguments: " + Array.prototype.slice.call(a).join("") + "\n" + (new Error).stack), n = !1;
                        }
                        return t.apply(this, arguments);
                    }, t);
                }
                var k, M = {};
                function C(e, t) {
                    null != r.deprecationHandler && r.deprecationHandler(e, t), M[e] || (E(t), M[e] = !0);
                }
                function x(e) {
                    return e instanceof Function || "[object Function]" === Object.prototype.toString.call(e);
                }
                function _(e, t) {
                    var n, r = f({}, e);
                    for(n in t)u(t, n) && (a(e[n]) && a(t[n]) ? (r[n] = {}, f(r[n], e[n]), f(r[n], t[n])) : null != t[n] ? r[n] = t[n] : delete r[n]);
                    for(n in e)u(e, n) && !u(t, n) && a(e[n]) && (r[n] = f({}, r[n]));
                    return r;
                }
                function T(e) {
                    null != e && this.set(e);
                }
                r.suppressDeprecationWarnings = !1, r.deprecationHandler = null, k = Object.keys ? Object.keys : function(e) {
                    var t, n = [];
                    for(t in e)u(e, t) && n.push(t);
                    return n;
                };
                var j = {};
                function I(e, t) {
                    var n = e.toLowerCase();
                    j[n] = j[n + "s"] = j[t] = e;
                }
                function R(e) {
                    return "string" == typeof e ? j[e] || j[e.toLowerCase()] : void 0;
                }
                function P(e) {
                    var t, n, r = {};
                    for(n in e)u(e, n) && (t = R(n)) && (r[t] = e[n]);
                    return r;
                }
                var N = {};
                function B(e, t) {
                    N[e] = t;
                }
                function Y(e, t, n) {
                    var r = "" + Math.abs(e), o = t - r.length, a = e >= 0;
                    return (a ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + r;
                }
                var Q = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, U = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, F = {}, H = {};
                function G(e, t, n, r) {
                    var o = r;
                    "string" == typeof r && (o = function() {
                        return this[r]();
                    }), e && (H[e] = o), t && (H[t[0]] = function() {
                        return Y(o.apply(this, arguments), t[1], t[2]);
                    }), n && (H[n] = function() {
                        return this.localeData().ordinal(o.apply(this, arguments), e);
                    });
                }
                function J(e, t) {
                    return e.isValid() ? (t = W(t, e.localeData()), F[t] = F[t] || function(e) {
                        var t, n, r, o = e.match(Q);
                        for(t = 0, n = o.length; t < n; t++)H[o[t]] ? o[t] = H[o[t]] : o[t] = (r = o[t]).match(/\[[\s\S]/) ? r.replace(/^\[|\]$/g, "") : r.replace(/\\/g, "");
                        return function(t) {
                            var r, a = "";
                            for(r = 0; r < n; r++)a += x(o[r]) ? o[r].call(t, e) : o[r];
                            return a;
                        };
                    }(t), F[t](e)) : e.localeData().invalidDate();
                }
                function W(e, t) {
                    var n = 5;
                    function r(e) {
                        return t.longDateFormat(e) || e;
                    }
                    for(U.lastIndex = 0; n >= 0 && U.test(e);)e = e.replace(U, r), U.lastIndex = 0, n -= 1;
                    return e;
                }
                var K = /\d/, L = /\d\d/, V = /\d{3}/, Z = /\d{4}/, q = /[+-]?\d{6}/, z = /\d\d?/, X = /\d\d\d\d?/, $ = /\d\d\d\d\d\d?/, ee = /\d{1,3}/, te = /\d{1,4}/, ne = /[+-]?\d{1,6}/, re = /\d+/, oe = /[+-]?\d+/, ae = /Z|[+-]\d\d:?\d\d/gi, ie = /Z|[+-]\d\d(?::?\d\d)?/gi, se = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, le = {};
                function ce(e, t, n) {
                    le[e] = x(t) ? t : function(e, r) {
                        return e && n ? n : t;
                    };
                }
                function ue(e, t) {
                    return u(le, e) ? le[e](t._strict, t._locale) : new RegExp(fe(e.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(e, t, n, r, o) {
                        return t || n || r || o;
                    })));
                }
                function fe(e) {
                    return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
                }
                var pe = {};
                function de(e, t) {
                    var n, r = t;
                    for("string" == typeof e && (e = [
                        e
                    ]), s(t) && (r = function(e, n) {
                        n[t] = w(e);
                    }), n = 0; n < e.length; n++)pe[e[n]] = r;
                }
                function he(e, t) {
                    de(e, function(e, n, r, o) {
                        r._w = r._w || {}, t(e, r._w, r, o);
                    });
                }
                function ye(e, t, n) {
                    null != t && u(pe, e) && pe[e](t, n._a, n, e);
                }
                var me = 0, be = 1, ge = 2, ve = 3, Oe = 4, Ae = 5, we = 6, Se = 7, Ee = 8;
                function De(e) {
                    return ke(e) ? 366 : 365;
                }
                function ke(e) {
                    return e % 4 == 0 && e % 100 != 0 || e % 400 == 0;
                }
                G("Y", 0, 0, function() {
                    var e = this.year();
                    return e <= 9999 ? "" + e : "+" + e;
                }), G(0, [
                    "YY",
                    2
                ], 0, function() {
                    return this.year() % 100;
                }), G(0, [
                    "YYYY",
                    4
                ], 0, "year"), G(0, [
                    "YYYYY",
                    5
                ], 0, "year"), G(0, [
                    "YYYYYY",
                    6,
                    !0
                ], 0, "year"), I("year", "y"), B("year", 1), ce("Y", oe), ce("YY", z, L), ce("YYYY", te, Z), ce("YYYYY", ne, q), ce("YYYYYY", ne, q), de([
                    "YYYYY",
                    "YYYYYY"
                ], me), de("YYYY", function(e, t) {
                    t[me] = 2 === e.length ? r.parseTwoDigitYear(e) : w(e);
                }), de("YY", function(e, t) {
                    t[me] = r.parseTwoDigitYear(e);
                }), de("Y", function(e, t) {
                    t[me] = parseInt(e, 10);
                }), r.parseTwoDigitYear = function(e) {
                    return w(e) + (w(e) > 68 ? 1900 : 2e3);
                };
                var Me, Ce = xe("FullYear", !0);
                function xe(e, t) {
                    return function(n) {
                        return null != n ? (Te(this, e, n), r.updateOffset(this, t), this) : _e(this, e);
                    };
                }
                function _e(e, t) {
                    return e.isValid() ? e._d["get" + (e._isUTC ? "UTC" : "") + t]() : NaN;
                }
                function Te(e, t, n) {
                    e.isValid() && !isNaN(n) && ("FullYear" === t && ke(e.year()) && 1 === e.month() && 29 === e.date() ? e._d["set" + (e._isUTC ? "UTC" : "") + t](n, e.month(), je(n, e.month())) : e._d["set" + (e._isUTC ? "UTC" : "") + t](n));
                }
                function je(e, t) {
                    if (isNaN(e) || isNaN(t)) return NaN;
                    var n, r = (t % (n = 12) + n) % n;
                    return e += (t - r) / 12, 1 === r ? ke(e) ? 29 : 28 : 31 - r % 7 % 2;
                }
                Me = Array.prototype.indexOf ? Array.prototype.indexOf : function(e) {
                    var t;
                    for(t = 0; t < this.length; ++t)if (this[t] === e) return t;
                    return -1;
                }, G("M", [
                    "MM",
                    2
                ], "Mo", function() {
                    return this.month() + 1;
                }), G("MMM", 0, 0, function(e) {
                    return this.localeData().monthsShort(this, e);
                }), G("MMMM", 0, 0, function(e) {
                    return this.localeData().months(this, e);
                }), I("month", "M"), B("month", 8), ce("M", z), ce("MM", z, L), ce("MMM", function(e, t) {
                    return t.monthsShortRegex(e);
                }), ce("MMMM", function(e, t) {
                    return t.monthsRegex(e);
                }), de([
                    "M",
                    "MM"
                ], function(e, t) {
                    t[be] = w(e) - 1;
                }), de([
                    "MMM",
                    "MMMM"
                ], function(e, t, n, r) {
                    var o = n._locale.monthsParse(e, r, n._strict);
                    null != o ? t[be] = o : d(n).invalidMonth = e;
                });
                var Ie = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, Re = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), Pe = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");
                function Ne(e, t) {
                    var n;
                    if (!e.isValid()) return e;
                    if ("string" == typeof t) {
                        if (/^\d+$/.test(t)) t = w(t);
                        else if (!s(t = e.localeData().monthsParse(t))) return e;
                    }
                    return n = Math.min(e.date(), je(e.year(), t)), e._d["set" + (e._isUTC ? "UTC" : "") + "Month"](t, n), e;
                }
                function Be(e) {
                    return null != e ? (Ne(this, e), r.updateOffset(this, !0), this) : _e(this, "Month");
                }
                var Ye = se, Qe = se;
                function Ue() {
                    function e(e, t) {
                        return t.length - e.length;
                    }
                    var t, n, r = [], o = [], a = [];
                    for(t = 0; t < 12; t++)n = p([
                        2e3,
                        t
                    ]), r.push(this.monthsShort(n, "")), o.push(this.months(n, "")), a.push(this.months(n, "")), a.push(this.monthsShort(n, ""));
                    for(r.sort(e), o.sort(e), a.sort(e), t = 0; t < 12; t++)r[t] = fe(r[t]), o[t] = fe(o[t]);
                    for(t = 0; t < 24; t++)a[t] = fe(a[t]);
                    this._monthsRegex = new RegExp("^(" + a.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._monthsShortStrictRegex = new RegExp("^(" + r.join("|") + ")", "i");
                }
                function Fe(e) {
                    var t = new Date(Date.UTC.apply(null, arguments));
                    return e < 100 && e >= 0 && isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e), t;
                }
                function He(e, t, n) {
                    var r = 7 + t - n, o = (7 + Fe(e, 0, r).getUTCDay() - t) % 7;
                    return -o + r - 1;
                }
                function Ge(e, t, n, r, o) {
                    var a, i, s = (7 + n - r) % 7, l = He(e, r, o), c = 1 + 7 * (t - 1) + s + l;
                    return c <= 0 ? i = De(a = e - 1) + c : c > De(e) ? (a = e + 1, i = c - De(e)) : (a = e, i = c), {
                        year: a,
                        dayOfYear: i
                    };
                }
                function Je(e, t, n) {
                    var r, o, a = He(e.year(), t, n), i = Math.floor((e.dayOfYear() - a - 1) / 7) + 1;
                    return i < 1 ? (o = e.year() - 1, r = i + We(o, t, n)) : i > We(e.year(), t, n) ? (r = i - We(e.year(), t, n), o = e.year() + 1) : (o = e.year(), r = i), {
                        week: r,
                        year: o
                    };
                }
                function We(e, t, n) {
                    var r = He(e, t, n), o = He(e + 1, t, n);
                    return (De(e) - r + o) / 7;
                }
                G("w", [
                    "ww",
                    2
                ], "wo", "week"), G("W", [
                    "WW",
                    2
                ], "Wo", "isoWeek"), I("week", "w"), I("isoWeek", "W"), B("week", 5), B("isoWeek", 5), ce("w", z), ce("ww", z, L), ce("W", z), ce("WW", z, L), he([
                    "w",
                    "ww",
                    "W",
                    "WW"
                ], function(e, t, n, r) {
                    t[r.substr(0, 1)] = w(e);
                }), G("d", 0, "do", "day"), G("dd", 0, 0, function(e) {
                    return this.localeData().weekdaysMin(this, e);
                }), G("ddd", 0, 0, function(e) {
                    return this.localeData().weekdaysShort(this, e);
                }), G("dddd", 0, 0, function(e) {
                    return this.localeData().weekdays(this, e);
                }), G("e", 0, 0, "weekday"), G("E", 0, 0, "isoWeekday"), I("day", "d"), I("weekday", "e"), I("isoWeekday", "E"), B("day", 11), B("weekday", 11), B("isoWeekday", 11), ce("d", z), ce("e", z), ce("E", z), ce("dd", function(e, t) {
                    return t.weekdaysMinRegex(e);
                }), ce("ddd", function(e, t) {
                    return t.weekdaysShortRegex(e);
                }), ce("dddd", function(e, t) {
                    return t.weekdaysRegex(e);
                }), he([
                    "dd",
                    "ddd",
                    "dddd"
                ], function(e, t, n, r) {
                    var o = n._locale.weekdaysParse(e, r, n._strict);
                    null != o ? t.d = o : d(n).invalidWeekday = e;
                }), he([
                    "d",
                    "e",
                    "E"
                ], function(e, t, n, r) {
                    t[r] = w(e);
                });
                var Ke = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Le = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Ve = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Ze = se, qe = se, ze = se;
                function Xe() {
                    function e(e, t) {
                        return t.length - e.length;
                    }
                    var t, n, r, o, a, i = [], s = [], l = [], c = [];
                    for(t = 0; t < 7; t++)n = p([
                        2e3,
                        1
                    ]).day(t), r = this.weekdaysMin(n, ""), o = this.weekdaysShort(n, ""), a = this.weekdays(n, ""), i.push(r), s.push(o), l.push(a), c.push(r), c.push(o), c.push(a);
                    for(i.sort(e), s.sort(e), l.sort(e), c.sort(e), t = 0; t < 7; t++)s[t] = fe(s[t]), l[t] = fe(l[t]), c[t] = fe(c[t]);
                    this._weekdaysRegex = new RegExp("^(" + c.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp("^(" + l.join("|") + ")", "i"), this._weekdaysShortStrictRegex = new RegExp("^(" + s.join("|") + ")", "i"), this._weekdaysMinStrictRegex = new RegExp("^(" + i.join("|") + ")", "i");
                }
                function $e() {
                    return this.hours() % 12 || 12;
                }
                function et(e, t) {
                    G(e, 0, 0, function() {
                        return this.localeData().meridiem(this.hours(), this.minutes(), t);
                    });
                }
                function tt(e, t) {
                    return t._meridiemParse;
                }
                G("H", [
                    "HH",
                    2
                ], 0, "hour"), G("h", [
                    "hh",
                    2
                ], 0, $e), G("k", [
                    "kk",
                    2
                ], 0, function() {
                    return this.hours() || 24;
                }), G("hmm", 0, 0, function() {
                    return "" + $e.apply(this) + Y(this.minutes(), 2);
                }), G("hmmss", 0, 0, function() {
                    return "" + $e.apply(this) + Y(this.minutes(), 2) + Y(this.seconds(), 2);
                }), G("Hmm", 0, 0, function() {
                    return "" + this.hours() + Y(this.minutes(), 2);
                }), G("Hmmss", 0, 0, function() {
                    return "" + this.hours() + Y(this.minutes(), 2) + Y(this.seconds(), 2);
                }), et("a", !0), et("A", !1), I("hour", "h"), B("hour", 13), ce("a", tt), ce("A", tt), ce("H", z), ce("h", z), ce("k", z), ce("HH", z, L), ce("hh", z, L), ce("kk", z, L), ce("hmm", X), ce("hmmss", $), ce("Hmm", X), ce("Hmmss", $), de([
                    "H",
                    "HH"
                ], ve), de([
                    "k",
                    "kk"
                ], function(e, t, n) {
                    var r = w(e);
                    t[ve] = 24 === r ? 0 : r;
                }), de([
                    "a",
                    "A"
                ], function(e, t, n) {
                    n._isPm = n._locale.isPM(e), n._meridiem = e;
                }), de([
                    "h",
                    "hh"
                ], function(e, t, n) {
                    t[ve] = w(e), d(n).bigHour = !0;
                }), de("hmm", function(e, t, n) {
                    var r = e.length - 2;
                    t[ve] = w(e.substr(0, r)), t[Oe] = w(e.substr(r)), d(n).bigHour = !0;
                }), de("hmmss", function(e, t, n) {
                    var r = e.length - 4, o = e.length - 2;
                    t[ve] = w(e.substr(0, r)), t[Oe] = w(e.substr(r, 2)), t[Ae] = w(e.substr(o)), d(n).bigHour = !0;
                }), de("Hmm", function(e, t, n) {
                    var r = e.length - 2;
                    t[ve] = w(e.substr(0, r)), t[Oe] = w(e.substr(r));
                }), de("Hmmss", function(e, t, n) {
                    var r = e.length - 4, o = e.length - 2;
                    t[ve] = w(e.substr(0, r)), t[Oe] = w(e.substr(r, 2)), t[Ae] = w(e.substr(o));
                });
                var nt, rt = xe("Hours", !0), ot = {
                    calendar: {
                        sameDay: "[Today at] LT",
                        nextDay: "[Tomorrow at] LT",
                        nextWeek: "dddd [at] LT",
                        lastDay: "[Yesterday at] LT",
                        lastWeek: "[Last] dddd [at] LT",
                        sameElse: "L"
                    },
                    longDateFormat: {
                        LTS: "h:mm:ss A",
                        LT: "h:mm A",
                        L: "MM/DD/YYYY",
                        LL: "MMMM D, YYYY",
                        LLL: "MMMM D, YYYY h:mm A",
                        LLLL: "dddd, MMMM D, YYYY h:mm A"
                    },
                    invalidDate: "Invalid date",
                    ordinal: "%d",
                    dayOfMonthOrdinalParse: /\d{1,2}/,
                    relativeTime: {
                        future: "in %s",
                        past: "%s ago",
                        s: "a few seconds",
                        ss: "%d seconds",
                        m: "a minute",
                        mm: "%d minutes",
                        h: "an hour",
                        hh: "%d hours",
                        d: "a day",
                        dd: "%d days",
                        M: "a month",
                        MM: "%d months",
                        y: "a year",
                        yy: "%d years"
                    },
                    months: Re,
                    monthsShort: Pe,
                    week: {
                        dow: 0,
                        doy: 6
                    },
                    weekdays: Ke,
                    weekdaysMin: Ve,
                    weekdaysShort: Le,
                    meridiemParse: /[ap]\.?m?\.?/i
                }, at = {}, it = {};
                function st(e) {
                    return e ? e.toLowerCase().replace("_", "-") : e;
                }
                function lt(t) {
                    var n = null;
                    if (!at[t] && void 0 !== e && e && e.exports) try {
                        n = nt._abbr, !function() {
                            var e = new Error("Cannot find module 'undefined'");
                            throw e.code = "MODULE_NOT_FOUND", e;
                        }(), ct(n);
                    } catch (e) {}
                    return at[t];
                }
                function ct(e, t) {
                    var n;
                    return e && ((n = i(t) ? ft(e) : ut(e, t)) ? nt = n : "undefined" != typeof console && console.warn && console.warn("Locale " + e + " not found. Did you forget to load it?")), nt._abbr;
                }
                function ut(e, t) {
                    if (null !== t) {
                        var n, r = ot;
                        if (t.abbr = e, null != at[e]) C("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."), r = at[e]._config;
                        else if (null != t.parentLocale) {
                            if (null != at[t.parentLocale]) r = at[t.parentLocale]._config;
                            else {
                                if (null == (n = lt(t.parentLocale))) return it[t.parentLocale] || (it[t.parentLocale] = []), it[t.parentLocale].push({
                                    name: e,
                                    config: t
                                }), null;
                                r = n._config;
                            }
                        }
                        return at[e] = new T(_(r, t)), it[e] && it[e].forEach(function(e) {
                            ut(e.name, e.config);
                        }), ct(e), at[e];
                    }
                    return delete at[e], null;
                }
                function ft(e) {
                    var t;
                    if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e) return nt;
                    if (!o(e)) {
                        if (t = lt(e)) return t;
                        e = [
                            e
                        ];
                    }
                    return function(e) {
                        for(var t, n, r, o, a = 0; a < e.length;){
                            for(o = st(e[a]).split("-"), t = o.length, n = (n = st(e[a + 1])) ? n.split("-") : null; t > 0;){
                                if (r = lt(o.slice(0, t).join("-"))) return r;
                                if (n && n.length >= t && S(o, n, !0) >= t - 1) break;
                                t--;
                            }
                            a++;
                        }
                        return nt;
                    }(e);
                }
                function pt(e) {
                    var t, n = e._a;
                    return n && -2 === d(e).overflow && (t = n[be] < 0 || n[be] > 11 ? be : n[ge] < 1 || n[ge] > je(n[me], n[be]) ? ge : n[ve] < 0 || n[ve] > 24 || 24 === n[ve] && (0 !== n[Oe] || 0 !== n[Ae] || 0 !== n[we]) ? ve : n[Oe] < 0 || n[Oe] > 59 ? Oe : n[Ae] < 0 || n[Ae] > 59 ? Ae : n[we] < 0 || n[we] > 999 ? we : -1, d(e)._overflowDayOfYear && (t < me || t > ge) && (t = ge), d(e)._overflowWeeks && -1 === t && (t = Se), d(e)._overflowWeekday && -1 === t && (t = Ee), d(e).overflow = t), e;
                }
                function dt(e, t, n) {
                    return null != e ? e : null != t ? t : n;
                }
                function ht(e) {
                    var t, n, o, a, i, s = [];
                    if (!e._d) {
                        for(o = function(e) {
                            var t = new Date(r.now());
                            return e._useUTC ? [
                                t.getUTCFullYear(),
                                t.getUTCMonth(),
                                t.getUTCDate()
                            ] : [
                                t.getFullYear(),
                                t.getMonth(),
                                t.getDate()
                            ];
                        }(e), e._w && null == e._a[ge] && null == e._a[be] && function(e) {
                            var t, n, r, o, a, i, s, l;
                            if (null != (t = e._w).GG || null != t.W || null != t.E) a = 1, i = 4, n = dt(t.GG, e._a[me], Je(xt(), 1, 4).year), r = dt(t.W, 1), ((o = dt(t.E, 1)) < 1 || o > 7) && (l = !0);
                            else {
                                a = e._locale._week.dow, i = e._locale._week.doy;
                                var c = Je(xt(), a, i);
                                n = dt(t.gg, e._a[me], c.year), r = dt(t.w, c.week), null != t.d ? ((o = t.d) < 0 || o > 6) && (l = !0) : null != t.e ? (o = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : o = a;
                            }
                            r < 1 || r > We(n, a, i) ? d(e)._overflowWeeks = !0 : null != l ? d(e)._overflowWeekday = !0 : (s = Ge(n, r, o, a, i), e._a[me] = s.year, e._dayOfYear = s.dayOfYear);
                        }(e), null != e._dayOfYear && (i = dt(e._a[me], o[me]), (e._dayOfYear > De(i) || 0 === e._dayOfYear) && (d(e)._overflowDayOfYear = !0), n = Fe(i, 0, e._dayOfYear), e._a[be] = n.getUTCMonth(), e._a[ge] = n.getUTCDate()), t = 0; t < 3 && null == e._a[t]; ++t)e._a[t] = s[t] = o[t];
                        for(; t < 7; t++)e._a[t] = s[t] = null == e._a[t] ? 2 === t ? 1 : 0 : e._a[t];
                        24 === e._a[ve] && 0 === e._a[Oe] && 0 === e._a[Ae] && 0 === e._a[we] && (e._nextDay = !0, e._a[ve] = 0), e._d = (e._useUTC ? Fe : function(e, t, n, r, o, a, i) {
                            var s = new Date(e, t, n, r, o, a, i);
                            return e < 100 && e >= 0 && isFinite(s.getFullYear()) && s.setFullYear(e), s;
                        }).apply(null, s), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), null != e._tzm && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[ve] = 24), e._w && void 0 !== e._w.d && e._w.d !== a && (d(e).weekdayMismatch = !0);
                    }
                }
                var yt = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/, mt = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/, bt = /Z|[+-]\d\d(?::?\d\d)?/, gt = [
                    [
                        "YYYYYY-MM-DD",
                        /[+-]\d{6}-\d\d-\d\d/
                    ],
                    [
                        "YYYY-MM-DD",
                        /\d{4}-\d\d-\d\d/
                    ],
                    [
                        "GGGG-[W]WW-E",
                        /\d{4}-W\d\d-\d/
                    ],
                    [
                        "GGGG-[W]WW",
                        /\d{4}-W\d\d/,
                        !1
                    ],
                    [
                        "YYYY-DDD",
                        /\d{4}-\d{3}/
                    ],
                    [
                        "YYYY-MM",
                        /\d{4}-\d\d/,
                        !1
                    ],
                    [
                        "YYYYYYMMDD",
                        /[+-]\d{10}/
                    ],
                    [
                        "YYYYMMDD",
                        /\d{8}/
                    ],
                    [
                        "GGGG[W]WWE",
                        /\d{4}W\d{3}/
                    ],
                    [
                        "GGGG[W]WW",
                        /\d{4}W\d{2}/,
                        !1
                    ],
                    [
                        "YYYYDDD",
                        /\d{7}/
                    ]
                ], vt = [
                    [
                        "HH:mm:ss.SSSS",
                        /\d\d:\d\d:\d\d\.\d+/
                    ],
                    [
                        "HH:mm:ss,SSSS",
                        /\d\d:\d\d:\d\d,\d+/
                    ],
                    [
                        "HH:mm:ss",
                        /\d\d:\d\d:\d\d/
                    ],
                    [
                        "HH:mm",
                        /\d\d:\d\d/
                    ],
                    [
                        "HHmmss.SSSS",
                        /\d\d\d\d\d\d\.\d+/
                    ],
                    [
                        "HHmmss,SSSS",
                        /\d\d\d\d\d\d,\d+/
                    ],
                    [
                        "HHmmss",
                        /\d\d\d\d\d\d/
                    ],
                    [
                        "HHmm",
                        /\d\d\d\d/
                    ],
                    [
                        "HH",
                        /\d\d/
                    ]
                ], Ot = /^\/?Date\((\-?\d+)/i;
                function At(e) {
                    var t, n, r, o, a, i, s = e._i, l = yt.exec(s) || mt.exec(s);
                    if (l) {
                        for(d(e).iso = !0, t = 0, n = gt.length; t < n; t++)if (gt[t][1].exec(l[1])) {
                            o = gt[t][0], r = !1 !== gt[t][2];
                            break;
                        }
                        if (null == o) return void (e._isValid = !1);
                        if (l[3]) {
                            for(t = 0, n = vt.length; t < n; t++)if (vt[t][1].exec(l[3])) {
                                a = (l[2] || " ") + vt[t][0];
                                break;
                            }
                            if (null == a) return void (e._isValid = !1);
                        }
                        if (!r && null != a) return void (e._isValid = !1);
                        if (l[4]) {
                            if (!bt.exec(l[4])) return void (e._isValid = !1);
                            i = "Z";
                        }
                        e._f = o + (a || "") + (i || ""), kt(e);
                    } else e._isValid = !1;
                }
                var wt = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
                function St(e) {
                    var t = parseInt(e, 10);
                    return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
                }
                var Et = {
                    UT: 0,
                    GMT: 0,
                    EDT: -240,
                    EST: -300,
                    CDT: -300,
                    CST: -360,
                    MDT: -360,
                    MST: -420,
                    PDT: -420,
                    PST: -480
                };
                function Dt(e) {
                    var t, n, r, o, a, i, s, l = wt.exec(e._i.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, ""));
                    if (l) {
                        var c = (t = l[4], n = l[3], r = l[2], o = l[5], a = l[6], i = l[7], s = [
                            St(t),
                            Pe.indexOf(n),
                            parseInt(r, 10),
                            parseInt(o, 10),
                            parseInt(a, 10)
                        ], i && s.push(parseInt(i, 10)), s);
                        if (!function(e, t, n) {
                            if (e) {
                                var r = Le.indexOf(e), o = new Date(t[0], t[1], t[2]).getDay();
                                if (r !== o) return d(n).weekdayMismatch = !0, n._isValid = !1, !1;
                            }
                            return !0;
                        }(l[1], c, e)) return;
                        e._a = c, e._tzm = function(e, t, n) {
                            if (e) return Et[e];
                            if (t) return 0;
                            var r = parseInt(n, 10), o = r % 100, a = (r - o) / 100;
                            return 60 * a + o;
                        }(l[8], l[9], l[10]), e._d = Fe.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), d(e).rfc2822 = !0;
                    } else e._isValid = !1;
                }
                function kt(e) {
                    if (e._f !== r.ISO_8601) {
                        if (e._f !== r.RFC_2822) {
                            e._a = [], d(e).empty = !0;
                            var t, n, o, a, i, s = "" + e._i, l = s.length, c = 0;
                            for(o = W(e._f, e._locale).match(Q) || [], t = 0; t < o.length; t++)a = o[t], (n = (s.match(ue(a, e)) || [])[0]) && ((i = s.substr(0, s.indexOf(n))).length > 0 && d(e).unusedInput.push(i), s = s.slice(s.indexOf(n) + n.length), c += n.length), H[a] ? (n ? d(e).empty = !1 : d(e).unusedTokens.push(a), ye(a, n, e)) : e._strict && !n && d(e).unusedTokens.push(a);
                            d(e).charsLeftOver = l - c, s.length > 0 && d(e).unusedInput.push(s), e._a[ve] <= 12 && !0 === d(e).bigHour && e._a[ve] > 0 && (d(e).bigHour = void 0), d(e).parsedDateParts = e._a.slice(0), d(e).meridiem = e._meridiem, e._a[ve] = (u = e._locale, f = e._a[ve], null == (p = e._meridiem) ? f : null != u.meridiemHour ? u.meridiemHour(f, p) : null != u.isPM ? ((h = u.isPM(p)) && f < 12 && (f += 12), h || 12 !== f || (f = 0), f) : f), ht(e), pt(e);
                        } else Dt(e);
                    } else At(e);
                    var u, f, p, h;
                }
                function Mt(e) {
                    var t = e._i, n = e._f;
                    return e._locale = e._locale || ft(e._l), null === t || void 0 === n && "" === t ? y({
                        nullInput: !0
                    }) : ("string" == typeof t && (e._i = t = e._locale.preparse(t)), O(t) ? new v(pt(t)) : (l(t) ? e._d = t : o(n) ? function(e) {
                        var t, n, r, o, a;
                        if (0 === e._f.length) return d(e).invalidFormat = !0, void (e._d = new Date(NaN));
                        for(o = 0; o < e._f.length; o++)a = 0, t = b({}, e), null != e._useUTC && (t._useUTC = e._useUTC), t._f = e._f[o], kt(t), h(t) && (a += d(t).charsLeftOver, a += 10 * d(t).unusedTokens.length, d(t).score = a, (null == r || a < r) && (r = a, n = t));
                        f(e, n || t);
                    }(e) : n ? kt(e) : function(e) {
                        var t = e._i;
                        i(t) ? e._d = new Date(r.now()) : l(t) ? e._d = new Date(t.valueOf()) : "string" == typeof t ? function(e) {
                            var t = Ot.exec(e._i);
                            null === t ? (At(e), !1 === e._isValid && (delete e._isValid, Dt(e), !1 === e._isValid && (delete e._isValid, r.createFromInputFallback(e)))) : e._d = new Date(+t[1]);
                        }(e) : o(t) ? (e._a = c(t.slice(0), function(e) {
                            return parseInt(e, 10);
                        }), ht(e)) : a(t) ? function(e) {
                            if (!e._d) {
                                var t = P(e._i);
                                e._a = c([
                                    t.year,
                                    t.month,
                                    t.day || t.date,
                                    t.hour,
                                    t.minute,
                                    t.second,
                                    t.millisecond
                                ], function(e) {
                                    return e && parseInt(e, 10);
                                }), ht(e);
                            }
                        }(e) : s(t) ? e._d = new Date(t) : r.createFromInputFallback(e);
                    }(e), h(e) || (e._d = null), e));
                }
                function Ct(e, t, n, r, i) {
                    var s, l = {};
                    return !0 !== n && !1 !== n || (r = n, n = void 0), (a(e) && function(e) {
                        if (Object.getOwnPropertyNames) return 0 === Object.getOwnPropertyNames(e).length;
                        var t;
                        for(t in e)if (e.hasOwnProperty(t)) return !1;
                        return !0;
                    }(e) || o(e) && 0 === e.length) && (e = void 0), l._isAMomentObject = !0, l._useUTC = l._isUTC = i, l._l = n, l._i = e, l._f = t, l._strict = r, (s = new v(pt(Mt(l))))._nextDay && (s.add(1, "d"), s._nextDay = void 0), s;
                }
                function xt(e, t, n, r) {
                    return Ct(e, t, n, r, !1);
                }
                r.createFromInputFallback = D("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(e) {
                    e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
                }), r.ISO_8601 = function() {}, r.RFC_2822 = function() {};
                var _t = D("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                    var e = xt.apply(null, arguments);
                    return this.isValid() && e.isValid() ? e < this ? this : e : y();
                }), Tt = D("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
                    var e = xt.apply(null, arguments);
                    return this.isValid() && e.isValid() ? e > this ? this : e : y();
                });
                function jt(e, t) {
                    var n, r;
                    if (1 === t.length && o(t[0]) && (t = t[0]), !t.length) return xt();
                    for(n = t[0], r = 1; r < t.length; ++r)t[r].isValid() && !t[r][e](n) || (n = t[r]);
                    return n;
                }
                var It = [
                    "year",
                    "quarter",
                    "month",
                    "week",
                    "day",
                    "hour",
                    "minute",
                    "second",
                    "millisecond"
                ];
                function Rt(e) {
                    var t = P(e), n = t.year || 0, r = t.quarter || 0, o = t.month || 0, a = t.week || 0, i = t.day || 0, s = t.hour || 0, l = t.minute || 0, c = t.second || 0, u = t.millisecond || 0;
                    this._isValid = function(e) {
                        for(var t in e)if (-1 === Me.call(It, t) || null != e[t] && isNaN(e[t])) return !1;
                        for(var n = !1, r = 0; r < It.length; ++r)if (e[It[r]]) {
                            if (n) return !1;
                            parseFloat(e[It[r]]) !== w(e[It[r]]) && (n = !0);
                        }
                        return !0;
                    }(t), this._milliseconds = +u + 1e3 * c + 6e4 * l + 1e3 * s * 3600, this._days = +i + 7 * a, this._months = +o + 3 * r + 12 * n, this._data = {}, this._locale = ft(), this._bubble();
                }
                function Pt(e) {
                    return e instanceof Rt;
                }
                function Nt(e) {
                    return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
                }
                function Bt(e, t) {
                    G(e, 0, 0, function() {
                        var e = this.utcOffset(), n = "+";
                        return e < 0 && (e = -e, n = "-"), n + Y(~~(e / 60), 2) + t + Y(~~e % 60, 2);
                    });
                }
                Bt("Z", ":"), Bt("ZZ", ""), ce("Z", ie), ce("ZZ", ie), de([
                    "Z",
                    "ZZ"
                ], function(e, t, n) {
                    n._useUTC = !0, n._tzm = Qt(ie, e);
                });
                var Yt = /([\+\-]|\d\d)/gi;
                function Qt(e, t) {
                    var n = (t || "").match(e);
                    if (null === n) return null;
                    var r = n[n.length - 1] || [], o = (r + "").match(Yt) || [
                        "-",
                        0,
                        0
                    ], a = 60 * o[1] + w(o[2]);
                    return 0 === a ? 0 : "+" === o[0] ? a : -a;
                }
                function Ut(e, t) {
                    var n, o;
                    return t._isUTC ? (n = t.clone(), o = (O(e) || l(e) ? e.valueOf() : xt(e).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + o), r.updateOffset(n, !1), n) : xt(e).local();
                }
                function Ft(e) {
                    return 15 * -Math.round(e._d.getTimezoneOffset() / 15);
                }
                function Ht() {
                    return !!this.isValid() && this._isUTC && 0 === this._offset;
                }
                r.updateOffset = function() {};
                var Gt = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/, Jt = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
                function Wt(e, t) {
                    var n, r, o, a, i, l, c = e, f = null;
                    return Pt(e) ? c = {
                        ms: e._milliseconds,
                        d: e._days,
                        M: e._months
                    } : s(e) ? (c = {}, t ? c[t] = e : c.milliseconds = e) : (f = Gt.exec(e)) ? (n = "-" === f[1] ? -1 : 1, c = {
                        y: 0,
                        d: w(f[ge]) * n,
                        h: w(f[ve]) * n,
                        m: w(f[Oe]) * n,
                        s: w(f[Ae]) * n,
                        ms: w(Nt(1e3 * f[we])) * n
                    }) : (f = Jt.exec(e)) ? (n = "-" === f[1] ? -1 : (f[1], 1), c = {
                        y: Kt(f[2], n),
                        M: Kt(f[3], n),
                        w: Kt(f[4], n),
                        d: Kt(f[5], n),
                        h: Kt(f[6], n),
                        m: Kt(f[7], n),
                        s: Kt(f[8], n)
                    }) : null == c ? c = {} : "object" == typeof c && ("from" in c || "to" in c) && (a = xt(c.from), i = xt(c.to), o = a.isValid() && i.isValid() ? (i = Ut(i, a), a.isBefore(i) ? l = Lt(a, i) : ((l = Lt(i, a)).milliseconds = -l.milliseconds, l.months = -l.months), l) : {
                        milliseconds: 0,
                        months: 0
                    }, (c = {}).ms = o.milliseconds, c.M = o.months), r = new Rt(c), Pt(e) && u(e, "_locale") && (r._locale = e._locale), r;
                }
                function Kt(e, t) {
                    var n = e && parseFloat(e.replace(",", "."));
                    return (isNaN(n) ? 0 : n) * t;
                }
                function Lt(e, t) {
                    var n = {
                        milliseconds: 0,
                        months: 0
                    };
                    return n.months = t.month() - e.month() + 12 * (t.year() - e.year()), e.clone().add(n.months, "M").isAfter(t) && --n.months, n.milliseconds = +t - +e.clone().add(n.months, "M"), n;
                }
                function Vt(e, t) {
                    return function(n, r) {
                        var o;
                        return null === r || isNaN(+r) || (C(t, "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."), o = n, n = r, r = o), Zt(this, Wt(n = "string" == typeof n ? +n : n, r), e), this;
                    };
                }
                function Zt(e, t, n, o) {
                    var a = t._milliseconds, i = Nt(t._days), s = Nt(t._months);
                    e.isValid() && (o = null == o || o, s && Ne(e, _e(e, "Month") + s * n), i && Te(e, "Date", _e(e, "Date") + i * n), a && e._d.setTime(e._d.valueOf() + a * n), o && r.updateOffset(e, i || s));
                }
                Wt.fn = Rt.prototype, Wt.invalid = function() {
                    return Wt(NaN);
                };
                var qt = Vt(1, "add"), zt = Vt(-1, "subtract");
                function Xt(e, t) {
                    var n, r, o = 12 * (t.year() - e.year()) + (t.month() - e.month()), a = e.clone().add(o, "months");
                    return t - a < 0 ? (n = e.clone().add(o - 1, "months"), r = (t - a) / (a - n)) : (n = e.clone().add(o + 1, "months"), r = (t - a) / (n - a)), -(o + r) || 0;
                }
                function $t(e) {
                    var t;
                    return void 0 === e ? this._locale._abbr : (null != (t = ft(e)) && (this._locale = t), this);
                }
                r.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ", r.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
                var en = D("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(e) {
                    return void 0 === e ? this.localeData() : this.locale(e);
                });
                function tn() {
                    return this._locale;
                }
                function nn(e, t) {
                    G(0, [
                        e,
                        e.length
                    ], 0, t);
                }
                function rn(e, t, n, r, o) {
                    var a;
                    return null == e ? Je(this, r, o).year : (a = We(e, r, o), t > a && (t = a), (function(e, t, n, r, o) {
                        var a = Ge(e, t, n, r, o), i = Fe(a.year, 0, a.dayOfYear);
                        return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
                    }).call(this, e, t, n, r, o));
                }
                G(0, [
                    "gg",
                    2
                ], 0, function() {
                    return this.weekYear() % 100;
                }), G(0, [
                    "GG",
                    2
                ], 0, function() {
                    return this.isoWeekYear() % 100;
                }), nn("gggg", "weekYear"), nn("ggggg", "weekYear"), nn("GGGG", "isoWeekYear"), nn("GGGGG", "isoWeekYear"), I("weekYear", "gg"), I("isoWeekYear", "GG"), B("weekYear", 1), B("isoWeekYear", 1), ce("G", oe), ce("g", oe), ce("GG", z, L), ce("gg", z, L), ce("GGGG", te, Z), ce("gggg", te, Z), ce("GGGGG", ne, q), ce("ggggg", ne, q), he([
                    "gggg",
                    "ggggg",
                    "GGGG",
                    "GGGGG"
                ], function(e, t, n, r) {
                    t[r.substr(0, 2)] = w(e);
                }), he([
                    "gg",
                    "GG"
                ], function(e, t, n, o) {
                    t[o] = r.parseTwoDigitYear(e);
                }), G("Q", 0, "Qo", "quarter"), I("quarter", "Q"), B("quarter", 7), ce("Q", K), de("Q", function(e, t) {
                    t[be] = 3 * (w(e) - 1);
                }), G("D", [
                    "DD",
                    2
                ], "Do", "date"), I("date", "D"), B("date", 9), ce("D", z), ce("DD", z, L), ce("Do", function(e, t) {
                    return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
                }), de([
                    "D",
                    "DD"
                ], ge), de("Do", function(e, t) {
                    t[ge] = w(e.match(z)[0]);
                });
                var on = xe("Date", !0);
                G("DDD", [
                    "DDDD",
                    3
                ], "DDDo", "dayOfYear"), I("dayOfYear", "DDD"), B("dayOfYear", 4), ce("DDD", ee), ce("DDDD", V), de([
                    "DDD",
                    "DDDD"
                ], function(e, t, n) {
                    n._dayOfYear = w(e);
                }), G("m", [
                    "mm",
                    2
                ], 0, "minute"), I("minute", "m"), B("minute", 14), ce("m", z), ce("mm", z, L), de([
                    "m",
                    "mm"
                ], Oe);
                var an = xe("Minutes", !1);
                G("s", [
                    "ss",
                    2
                ], 0, "second"), I("second", "s"), B("second", 15), ce("s", z), ce("ss", z, L), de([
                    "s",
                    "ss"
                ], Ae);
                var sn, ln = xe("Seconds", !1);
                for(G("S", 0, 0, function() {
                    return ~~(this.millisecond() / 100);
                }), G(0, [
                    "SS",
                    2
                ], 0, function() {
                    return ~~(this.millisecond() / 10);
                }), G(0, [
                    "SSS",
                    3
                ], 0, "millisecond"), G(0, [
                    "SSSS",
                    4
                ], 0, function() {
                    return 10 * this.millisecond();
                }), G(0, [
                    "SSSSS",
                    5
                ], 0, function() {
                    return 100 * this.millisecond();
                }), G(0, [
                    "SSSSSS",
                    6
                ], 0, function() {
                    return 1e3 * this.millisecond();
                }), G(0, [
                    "SSSSSSS",
                    7
                ], 0, function() {
                    return 1e4 * this.millisecond();
                }), G(0, [
                    "SSSSSSSS",
                    8
                ], 0, function() {
                    return 1e5 * this.millisecond();
                }), G(0, [
                    "SSSSSSSSS",
                    9
                ], 0, function() {
                    return 1e6 * this.millisecond();
                }), I("millisecond", "ms"), B("millisecond", 16), ce("S", ee, K), ce("SS", ee, L), ce("SSS", ee, V), sn = "SSSS"; sn.length <= 9; sn += "S")ce(sn, re);
                function cn(e, t) {
                    t[we] = w(1e3 * ("0." + e));
                }
                for(sn = "S"; sn.length <= 9; sn += "S")de(sn, cn);
                var un = xe("Milliseconds", !1);
                G("z", 0, 0, "zoneAbbr"), G("zz", 0, 0, "zoneName");
                var fn = v.prototype;
                function pn(e) {
                    return e;
                }
                fn.add = qt, fn.calendar = function(e, t) {
                    var n = e || xt(), o = Ut(n, this).startOf("day"), a = r.calendarFormat(this, o) || "sameElse", i = t && (x(t[a]) ? t[a].call(this, n) : t[a]);
                    return this.format(i || this.localeData().calendar(a, this, xt(n)));
                }, fn.clone = function() {
                    return new v(this);
                }, fn.diff = function(e, t, n) {
                    var r, o, a;
                    if (!this.isValid()) return NaN;
                    if (!(r = Ut(e, this)).isValid()) return NaN;
                    switch(o = 6e4 * (r.utcOffset() - this.utcOffset()), t = R(t)){
                        case "year":
                            a = Xt(this, r) / 12;
                            break;
                        case "month":
                            a = Xt(this, r);
                            break;
                        case "quarter":
                            a = Xt(this, r) / 3;
                            break;
                        case "second":
                            a = (this - r) / 1e3;
                            break;
                        case "minute":
                            a = (this - r) / 6e4;
                            break;
                        case "hour":
                            a = (this - r) / 36e5;
                            break;
                        case "day":
                            a = (this - r - o) / 864e5;
                            break;
                        case "week":
                            a = (this - r - o) / 6048e5;
                            break;
                        default:
                            a = this - r;
                    }
                    return n ? a : A(a);
                }, fn.endOf = function(e) {
                    return void 0 === (e = R(e)) || "millisecond" === e ? this : ("date" === e && (e = "day"), this.startOf(e).add(1, "isoWeek" === e ? "week" : e).subtract(1, "ms"));
                }, fn.format = function(e) {
                    e || (e = this.isUtc() ? r.defaultFormatUtc : r.defaultFormat);
                    var t = J(this, e);
                    return this.localeData().postformat(t);
                }, fn.from = function(e, t) {
                    return this.isValid() && (O(e) && e.isValid() || xt(e).isValid()) ? Wt({
                        to: this,
                        from: e
                    }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
                }, fn.fromNow = function(e) {
                    return this.from(xt(), e);
                }, fn.to = function(e, t) {
                    return this.isValid() && (O(e) && e.isValid() || xt(e).isValid()) ? Wt({
                        from: this,
                        to: e
                    }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
                }, fn.toNow = function(e) {
                    return this.to(xt(), e);
                }, fn.get = function(e) {
                    return x(this[e = R(e)]) ? this[e]() : this;
                }, fn.invalidAt = function() {
                    return d(this).overflow;
                }, fn.isAfter = function(e, t) {
                    var n = O(e) ? e : xt(e);
                    return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = R(i(t) ? "millisecond" : t)) ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(t).valueOf());
                }, fn.isBefore = function(e, t) {
                    var n = O(e) ? e : xt(e);
                    return !(!this.isValid() || !n.isValid()) && ("millisecond" === (t = R(i(t) ? "millisecond" : t)) ? this.valueOf() < n.valueOf() : this.clone().endOf(t).valueOf() < n.valueOf());
                }, fn.isBetween = function(e, t, n, r) {
                    return ("(" === (r = r || "()")[0] ? this.isAfter(e, n) : !this.isBefore(e, n)) && (")" === r[1] ? this.isBefore(t, n) : !this.isAfter(t, n));
                }, fn.isSame = function(e, t) {
                    var n, r = O(e) ? e : xt(e);
                    return !(!this.isValid() || !r.isValid()) && ("millisecond" === (t = R(t || "millisecond")) ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf()));
                }, fn.isSameOrAfter = function(e, t) {
                    return this.isSame(e, t) || this.isAfter(e, t);
                }, fn.isSameOrBefore = function(e, t) {
                    return this.isSame(e, t) || this.isBefore(e, t);
                }, fn.isValid = function() {
                    return h(this);
                }, fn.lang = en, fn.locale = $t, fn.localeData = tn, fn.max = Tt, fn.min = _t, fn.parsingFlags = function() {
                    return f({}, d(this));
                }, fn.set = function(e, t) {
                    if ("object" == typeof e) for(var n = function(e) {
                        var t = [];
                        for(var n in e)t.push({
                            unit: n,
                            priority: N[n]
                        });
                        return t.sort(function(e, t) {
                            return e.priority - t.priority;
                        }), t;
                    }(e = P(e)), r = 0; r < n.length; r++)this[n[r].unit](e[n[r].unit]);
                    else if (x(this[e = R(e)])) return this[e](t);
                    return this;
                }, fn.startOf = function(e) {
                    switch(e = R(e)){
                        case "year":
                            this.month(0);
                        case "quarter":
                        case "month":
                            this.date(1);
                        case "week":
                        case "isoWeek":
                        case "day":
                        case "date":
                            this.hours(0);
                        case "hour":
                            this.minutes(0);
                        case "minute":
                            this.seconds(0);
                        case "second":
                            this.milliseconds(0);
                    }
                    return "week" === e && this.weekday(0), "isoWeek" === e && this.isoWeekday(1), "quarter" === e && this.month(3 * Math.floor(this.month() / 3)), this;
                }, fn.subtract = zt, fn.toArray = function() {
                    var e = this;
                    return [
                        e.year(),
                        e.month(),
                        e.date(),
                        e.hour(),
                        e.minute(),
                        e.second(),
                        e.millisecond()
                    ];
                }, fn.toObject = function() {
                    var e = this;
                    return {
                        years: e.year(),
                        months: e.month(),
                        date: e.date(),
                        hours: e.hours(),
                        minutes: e.minutes(),
                        seconds: e.seconds(),
                        milliseconds: e.milliseconds()
                    };
                }, fn.toDate = function() {
                    return new Date(this.valueOf());
                }, fn.toISOString = function(e) {
                    if (!this.isValid()) return null;
                    var t = !0 !== e, n = t ? this.clone().utc() : this;
                    return n.year() < 0 || n.year() > 9999 ? J(n, t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ") : x(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3).toISOString().replace("Z", J(n, "Z")) : J(n, t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
                }, fn.inspect = function() {
                    if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
                    var e = "moment", t = "";
                    this.isLocal() || (e = 0 === this.utcOffset() ? "moment.utc" : "moment.parseZone", t = "Z");
                    var n = "[" + e + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = t + '[")]';
                    return this.format(n + r + "-MM-DD[T]HH:mm:ss.SSS" + o);
                }, fn.toJSON = function() {
                    return this.isValid() ? this.toISOString() : null;
                }, fn.toString = function() {
                    return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
                }, fn.unix = function() {
                    return Math.floor(this.valueOf() / 1e3);
                }, fn.valueOf = function() {
                    return this._d.valueOf() - 6e4 * (this._offset || 0);
                }, fn.creationData = function() {
                    return {
                        input: this._i,
                        format: this._f,
                        locale: this._locale,
                        isUTC: this._isUTC,
                        strict: this._strict
                    };
                }, fn.year = Ce, fn.isLeapYear = function() {
                    return ke(this.year());
                }, fn.weekYear = function(e) {
                    return rn.call(this, e, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
                }, fn.isoWeekYear = function(e) {
                    return rn.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
                }, fn.quarter = fn.quarters = function(e) {
                    return null == e ? Math.ceil((this.month() + 1) / 3) : this.month(3 * (e - 1) + this.month() % 3);
                }, fn.month = Be, fn.daysInMonth = function() {
                    return je(this.year(), this.month());
                }, fn.week = fn.weeks = function(e) {
                    var t = this.localeData().week(this);
                    return null == e ? t : this.add(7 * (e - t), "d");
                }, fn.isoWeek = fn.isoWeeks = function(e) {
                    var t = Je(this, 1, 4).week;
                    return null == e ? t : this.add(7 * (e - t), "d");
                }, fn.weeksInYear = function() {
                    var e = this.localeData()._week;
                    return We(this.year(), e.dow, e.doy);
                }, fn.isoWeeksInYear = function() {
                    return We(this.year(), 1, 4);
                }, fn.date = on, fn.day = fn.days = function(e) {
                    if (!this.isValid()) return null != e ? this : NaN;
                    var t = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
                    return null != e ? (e = function(e, t) {
                        return "string" != typeof e ? e : isNaN(e) ? "number" == typeof (e = t.weekdaysParse(e)) ? e : null : parseInt(e, 10);
                    }(e, this.localeData()), this.add(e - t, "d")) : t;
                }, fn.weekday = function(e) {
                    if (!this.isValid()) return null != e ? this : NaN;
                    var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
                    return null == e ? t : this.add(e - t, "d");
                }, fn.isoWeekday = function(e) {
                    if (!this.isValid()) return null != e ? this : NaN;
                    if (null != e) {
                        var t = function(e, t) {
                            return "string" == typeof e ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
                        }(e, this.localeData());
                        return this.day(this.day() % 7 ? t : t - 7);
                    }
                    return this.day() || 7;
                }, fn.dayOfYear = function(e) {
                    var t = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
                    return null == e ? t : this.add(e - t, "d");
                }, fn.hour = fn.hours = rt, fn.minute = fn.minutes = an, fn.second = fn.seconds = ln, fn.millisecond = fn.milliseconds = un, fn.utcOffset = function(e, t, n) {
                    var o, a = this._offset || 0;
                    if (!this.isValid()) return null != e ? this : NaN;
                    if (null != e) {
                        if ("string" == typeof e) {
                            if (null === (e = Qt(ie, e))) return this;
                        } else Math.abs(e) < 16 && !n && (e *= 60);
                        return !this._isUTC && t && (o = Ft(this)), this._offset = e, this._isUTC = !0, null != o && this.add(o, "m"), a !== e && (!t || this._changeInProgress ? Zt(this, Wt(e - a, "m"), 1, !1) : this._changeInProgress || (this._changeInProgress = !0, r.updateOffset(this, !0), this._changeInProgress = null)), this;
                    }
                    return this._isUTC ? a : Ft(this);
                }, fn.utc = function(e) {
                    return this.utcOffset(0, e);
                }, fn.local = function(e) {
                    return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Ft(this), "m")), this;
                }, fn.parseZone = function() {
                    if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
                    else if ("string" == typeof this._i) {
                        var e = Qt(ae, this._i);
                        null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
                    }
                    return this;
                }, fn.hasAlignedHourOffset = function(e) {
                    return !!this.isValid() && (e = e ? xt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 == 0);
                }, fn.isDST = function() {
                    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
                }, fn.isLocal = function() {
                    return !!this.isValid() && !this._isUTC;
                }, fn.isUtcOffset = function() {
                    return !!this.isValid() && this._isUTC;
                }, fn.isUtc = Ht, fn.isUTC = Ht, fn.zoneAbbr = function() {
                    return this._isUTC ? "UTC" : "";
                }, fn.zoneName = function() {
                    return this._isUTC ? "Coordinated Universal Time" : "";
                }, fn.dates = D("dates accessor is deprecated. Use date instead.", on), fn.months = D("months accessor is deprecated. Use month instead", Be), fn.years = D("years accessor is deprecated. Use year instead", Ce), fn.zone = D("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", function(e, t) {
                    return null != e ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
                }), fn.isDSTShifted = D("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", function() {
                    if (!i(this._isDSTShifted)) return this._isDSTShifted;
                    var e = {};
                    if (b(e, this), (e = Mt(e))._a) {
                        var t = e._isUTC ? p(e._a) : xt(e._a);
                        this._isDSTShifted = this.isValid() && S(e._a, t.toArray()) > 0;
                    } else this._isDSTShifted = !1;
                    return this._isDSTShifted;
                });
                var dn = T.prototype;
                function hn(e, t, n, r) {
                    var o = ft(), a = p().set(r, t);
                    return o[n](a, e);
                }
                function yn(e, t, n) {
                    if (s(e) && (t = e, e = void 0), e = e || "", null != t) return hn(e, t, n, "month");
                    var r, o = [];
                    for(r = 0; r < 12; r++)o[r] = hn(e, r, n, "month");
                    return o;
                }
                function mn(e, t, n, r) {
                    "boolean" == typeof e ? (s(t) && (n = t, t = void 0), t = t || "") : (n = t = e, e = !1, s(t) && (n = t, t = void 0), t = t || "");
                    var o, a = ft(), i = e ? a._week.dow : 0;
                    if (null != n) return hn(t, (n + i) % 7, r, "day");
                    var l = [];
                    for(o = 0; o < 7; o++)l[o] = hn(t, (o + i) % 7, r, "day");
                    return l;
                }
                dn.calendar = function(e, t, n) {
                    var r = this._calendar[e] || this._calendar.sameElse;
                    return x(r) ? r.call(t, n) : r;
                }, dn.longDateFormat = function(e) {
                    var t = this._longDateFormat[e], n = this._longDateFormat[e.toUpperCase()];
                    return t || !n ? t : (this._longDateFormat[e] = n.replace(/MMMM|MM|DD|dddd/g, function(e) {
                        return e.slice(1);
                    }), this._longDateFormat[e]);
                }, dn.invalidDate = function() {
                    return this._invalidDate;
                }, dn.ordinal = function(e) {
                    return this._ordinal.replace("%d", e);
                }, dn.preparse = pn, dn.postformat = pn, dn.relativeTime = function(e, t, n, r) {
                    var o = this._relativeTime[n];
                    return x(o) ? o(e, t, n, r) : o.replace(/%d/i, e);
                }, dn.pastFuture = function(e, t) {
                    var n = this._relativeTime[e > 0 ? "future" : "past"];
                    return x(n) ? n(t) : n.replace(/%s/i, t);
                }, dn.set = function(e) {
                    var t, n;
                    for(n in e)x(t = e[n]) ? this[n] = t : this["_" + n] = t;
                    this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
                }, dn.months = function(e, t) {
                    return e ? o(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Ie).test(t) ? "format" : "standalone"][e.month()] : o(this._months) ? this._months : this._months.standalone;
                }, dn.monthsShort = function(e, t) {
                    return e ? o(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Ie.test(t) ? "format" : "standalone"][e.month()] : o(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
                }, dn.monthsParse = function(e, t, n) {
                    var r, o, a;
                    if (this._monthsParseExact) return (function(e, t, n) {
                        var r, o, a, i = e.toLocaleLowerCase();
                        if (!this._monthsParse) for(this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)a = p([
                            2e3,
                            r
                        ]), this._shortMonthsParse[r] = this.monthsShort(a, "").toLocaleLowerCase(), this._longMonthsParse[r] = this.months(a, "").toLocaleLowerCase();
                        return n ? "MMM" === t ? -1 !== (o = Me.call(this._shortMonthsParse, i)) ? o : null : -1 !== (o = Me.call(this._longMonthsParse, i)) ? o : null : "MMM" === t ? -1 !== (o = Me.call(this._shortMonthsParse, i)) ? o : -1 !== (o = Me.call(this._longMonthsParse, i)) ? o : null : -1 !== (o = Me.call(this._longMonthsParse, i)) ? o : -1 !== (o = Me.call(this._shortMonthsParse, i)) ? o : null;
                    }).call(this, e, t, n);
                    for(this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++){
                        if (o = p([
                            2e3,
                            r
                        ]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp("^" + this.months(o, "").replace(".", "") + "$", "i"), this._shortMonthsParse[r] = new RegExp("^" + this.monthsShort(o, "").replace(".", "") + "$", "i")), n || this._monthsParse[r] || (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[r] = new RegExp(a.replace(".", ""), "i")), n && "MMMM" === t && this._longMonthsParse[r].test(e)) return r;
                        if (n && "MMM" === t && this._shortMonthsParse[r].test(e)) return r;
                        if (!n && this._monthsParse[r].test(e)) return r;
                    }
                }, dn.monthsRegex = function(e) {
                    return this._monthsParseExact ? (u(this, "_monthsRegex") || Ue.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (u(this, "_monthsRegex") || (this._monthsRegex = Qe), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
                }, dn.monthsShortRegex = function(e) {
                    return this._monthsParseExact ? (u(this, "_monthsRegex") || Ue.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (u(this, "_monthsShortRegex") || (this._monthsShortRegex = Ye), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
                }, dn.week = function(e) {
                    return Je(e, this._week.dow, this._week.doy).week;
                }, dn.firstDayOfYear = function() {
                    return this._week.doy;
                }, dn.firstDayOfWeek = function() {
                    return this._week.dow;
                }, dn.weekdays = function(e, t) {
                    return e ? o(this._weekdays) ? this._weekdays[e.day()] : this._weekdays[this._weekdays.isFormat.test(t) ? "format" : "standalone"][e.day()] : o(this._weekdays) ? this._weekdays : this._weekdays.standalone;
                }, dn.weekdaysMin = function(e) {
                    return e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
                }, dn.weekdaysShort = function(e) {
                    return e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
                }, dn.weekdaysParse = function(e, t, n) {
                    var r, o, a;
                    if (this._weekdaysParseExact) return (function(e, t, n) {
                        var r, o, a, i = e.toLocaleLowerCase();
                        if (!this._weekdaysParse) for(this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)a = p([
                            2e3,
                            1
                        ]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(a, "").toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(a, "").toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(a, "").toLocaleLowerCase();
                        return n ? "dddd" === t ? -1 !== (o = Me.call(this._weekdaysParse, i)) ? o : null : "ddd" === t ? -1 !== (o = Me.call(this._shortWeekdaysParse, i)) ? o : null : -1 !== (o = Me.call(this._minWeekdaysParse, i)) ? o : null : "dddd" === t ? -1 !== (o = Me.call(this._weekdaysParse, i)) ? o : -1 !== (o = Me.call(this._shortWeekdaysParse, i)) ? o : -1 !== (o = Me.call(this._minWeekdaysParse, i)) ? o : null : "ddd" === t ? -1 !== (o = Me.call(this._shortWeekdaysParse, i)) ? o : -1 !== (o = Me.call(this._weekdaysParse, i)) ? o : -1 !== (o = Me.call(this._minWeekdaysParse, i)) ? o : null : -1 !== (o = Me.call(this._minWeekdaysParse, i)) ? o : -1 !== (o = Me.call(this._weekdaysParse, i)) ? o : -1 !== (o = Me.call(this._shortWeekdaysParse, i)) ? o : null;
                    }).call(this, e, t, n);
                    for(this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++){
                        if (o = p([
                            2e3,
                            1
                        ]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp("^" + this.weekdays(o, "").replace(".", "\\.?") + "$", "i"), this._shortWeekdaysParse[r] = new RegExp("^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$", "i"), this._minWeekdaysParse[r] = new RegExp("^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$", "i")), this._weekdaysParse[r] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[r] = new RegExp(a.replace(".", ""), "i")), n && "dddd" === t && this._fullWeekdaysParse[r].test(e)) return r;
                        if (n && "ddd" === t && this._shortWeekdaysParse[r].test(e)) return r;
                        if (n && "dd" === t && this._minWeekdaysParse[r].test(e)) return r;
                        if (!n && this._weekdaysParse[r].test(e)) return r;
                    }
                }, dn.weekdaysRegex = function(e) {
                    return this._weekdaysParseExact ? (u(this, "_weekdaysRegex") || Xe.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (u(this, "_weekdaysRegex") || (this._weekdaysRegex = Ze), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
                }, dn.weekdaysShortRegex = function(e) {
                    return this._weekdaysParseExact ? (u(this, "_weekdaysRegex") || Xe.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (u(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = qe), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
                }, dn.weekdaysMinRegex = function(e) {
                    return this._weekdaysParseExact ? (u(this, "_weekdaysRegex") || Xe.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (u(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = ze), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
                }, dn.isPM = function(e) {
                    return "p" === (e + "").toLowerCase().charAt(0);
                }, dn.meridiem = function(e, t, n) {
                    return e > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
                }, ct("en", {
                    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
                    ordinal: function(e) {
                        var t = e % 10, n = 1 === w(e % 100 / 10) ? "th" : 1 === t ? "st" : 2 === t ? "nd" : 3 === t ? "rd" : "th";
                        return e + n;
                    }
                }), r.lang = D("moment.lang is deprecated. Use moment.locale instead.", ct), r.langData = D("moment.langData is deprecated. Use moment.localeData instead.", ft);
                var bn = Math.abs;
                function gn(e, t, n, r) {
                    var o = Wt(t, n);
                    return e._milliseconds += r * o._milliseconds, e._days += r * o._days, e._months += r * o._months, e._bubble();
                }
                function vn(e) {
                    return e < 0 ? Math.floor(e) : Math.ceil(e);
                }
                function On(e) {
                    return 4800 * e / 146097;
                }
                function An(e) {
                    return 146097 * e / 4800;
                }
                function wn(e) {
                    return function() {
                        return this.as(e);
                    };
                }
                var Sn = wn("ms"), En = wn("s"), Dn = wn("m"), kn = wn("h"), Mn = wn("d"), Cn = wn("w"), xn = wn("M"), _n = wn("y");
                function Tn(e) {
                    return function() {
                        return this.isValid() ? this._data[e] : NaN;
                    };
                }
                var jn = Tn("milliseconds"), In = Tn("seconds"), Rn = Tn("minutes"), Pn = Tn("hours"), Nn = Tn("days"), Bn = Tn("months"), Yn = Tn("years"), Qn = Math.round, Un = {
                    ss: 44,
                    s: 45,
                    m: 45,
                    h: 22,
                    d: 26,
                    M: 11
                }, Fn = Math.abs;
                function Hn(e) {
                    return (e > 0) - (e < 0) || +e;
                }
                function Gn() {
                    if (!this.isValid()) return this.localeData().invalidDate();
                    var e, t, n = Fn(this._milliseconds) / 1e3, r = Fn(this._days), o = Fn(this._months);
                    e = A(n / 60), t = A(e / 60), n %= 60, e %= 60;
                    var a = A(o / 12), i = o %= 12, s = r, l = t, c = e, u = n ? n.toFixed(3).replace(/\.?0+$/, "") : "", f = this.asSeconds();
                    if (!f) return "P0D";
                    var p = f < 0 ? "-" : "", d = Hn(this._months) !== Hn(f) ? "-" : "", h = Hn(this._days) !== Hn(f) ? "-" : "", y = Hn(this._milliseconds) !== Hn(f) ? "-" : "";
                    return p + "P" + (a ? d + a + "Y" : "") + (i ? d + i + "M" : "") + (s ? h + s + "D" : "") + (l || c || u ? "T" : "") + (l ? y + l + "H" : "") + (c ? y + c + "M" : "") + (u ? y + u + "S" : "");
                }
                var Jn = Rt.prototype;
                return Jn.isValid = function() {
                    return this._isValid;
                }, Jn.abs = function() {
                    var e = this._data;
                    return this._milliseconds = bn(this._milliseconds), this._days = bn(this._days), this._months = bn(this._months), e.milliseconds = bn(e.milliseconds), e.seconds = bn(e.seconds), e.minutes = bn(e.minutes), e.hours = bn(e.hours), e.months = bn(e.months), e.years = bn(e.years), this;
                }, Jn.add = function(e, t) {
                    return gn(this, e, t, 1);
                }, Jn.subtract = function(e, t) {
                    return gn(this, e, t, -1);
                }, Jn.as = function(e) {
                    if (!this.isValid()) return NaN;
                    var t, n, r = this._milliseconds;
                    if ("month" === (e = R(e)) || "year" === e) return t = this._days + r / 864e5, n = this._months + On(t), "month" === e ? n : n / 12;
                    switch(t = this._days + Math.round(An(this._months)), e){
                        case "week":
                            return t / 7 + r / 6048e5;
                        case "day":
                            return t + r / 864e5;
                        case "hour":
                            return 24 * t + r / 36e5;
                        case "minute":
                            return 1440 * t + r / 6e4;
                        case "second":
                            return 86400 * t + r / 1e3;
                        case "millisecond":
                            return Math.floor(864e5 * t) + r;
                        default:
                            throw new Error("Unknown unit " + e);
                    }
                }, Jn.asMilliseconds = Sn, Jn.asSeconds = En, Jn.asMinutes = Dn, Jn.asHours = kn, Jn.asDays = Mn, Jn.asWeeks = Cn, Jn.asMonths = xn, Jn.asYears = _n, Jn.valueOf = function() {
                    return this.isValid() ? this._milliseconds + 864e5 * this._days + this._months % 12 * 2592e6 + 31536e6 * w(this._months / 12) : NaN;
                }, Jn._bubble = function() {
                    var e, t, n, r, o, a = this._milliseconds, i = this._days, s = this._months, l = this._data;
                    return a >= 0 && i >= 0 && s >= 0 || a <= 0 && i <= 0 && s <= 0 || (a += 864e5 * vn(An(s) + i), i = 0, s = 0), l.milliseconds = a % 1e3, e = A(a / 1e3), l.seconds = e % 60, t = A(e / 60), l.minutes = t % 60, n = A(t / 60), l.hours = n % 24, i += A(n / 24), o = A(On(i)), s += o, i -= vn(An(o)), r = A(s / 12), s %= 12, l.days = i, l.months = s, l.years = r, this;
                }, Jn.clone = function() {
                    return Wt(this);
                }, Jn.get = function(e) {
                    return e = R(e), this.isValid() ? this[e + "s"]() : NaN;
                }, Jn.milliseconds = jn, Jn.seconds = In, Jn.minutes = Rn, Jn.hours = Pn, Jn.days = Nn, Jn.weeks = function() {
                    return A(this.days() / 7);
                }, Jn.months = Bn, Jn.years = Yn, Jn.humanize = function(e) {
                    if (!this.isValid()) return this.localeData().invalidDate();
                    var t = this.localeData(), n = function(e, t, n) {
                        var r = Wt(e).abs(), o = Qn(r.as("s")), a = Qn(r.as("m")), i = Qn(r.as("h")), s = Qn(r.as("d")), l = Qn(r.as("M")), c = Qn(r.as("y")), u = o <= Un.ss && [
                            "s",
                            o
                        ] || o < Un.s && [
                            "ss",
                            o
                        ] || a <= 1 && [
                            "m"
                        ] || a < Un.m && [
                            "mm",
                            a
                        ] || i <= 1 && [
                            "h"
                        ] || i < Un.h && [
                            "hh",
                            i
                        ] || s <= 1 && [
                            "d"
                        ] || s < Un.d && [
                            "dd",
                            s
                        ] || l <= 1 && [
                            "M"
                        ] || l < Un.M && [
                            "MM",
                            l
                        ] || c <= 1 && [
                            "y"
                        ] || [
                            "yy",
                            c
                        ];
                        return u[2] = t, u[3] = +e > 0, u[4] = n, (function(e, t, n, r, o) {
                            return o.relativeTime(t || 1, !!n, e, r);
                        }).apply(null, u);
                    }(this, !e, t);
                    return e && (n = t.pastFuture(+this, n)), t.postformat(n);
                }, Jn.toISOString = Gn, Jn.toString = Gn, Jn.toJSON = Gn, Jn.locale = $t, Jn.localeData = tn, Jn.toIsoString = D("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", Gn), Jn.lang = en, G("X", 0, 0, "unix"), G("x", 0, 0, "valueOf"), ce("x", oe), ce("X", /[+-]?\d+(\.\d{1,3})?/), de("X", function(e, t, n) {
                    n._d = new Date(1e3 * parseFloat(e, 10));
                }), de("x", function(e, t, n) {
                    n._d = new Date(w(e));
                }), r.version = "2.22.2", t = xt, r.fn = fn, r.min = function() {
                    return jt("isBefore", [].slice.call(arguments, 0));
                }, r.max = function() {
                    return jt("isAfter", [].slice.call(arguments, 0));
                }, r.now = function() {
                    return Date.now ? Date.now() : +new Date;
                }, r.utc = p, r.unix = function(e) {
                    return xt(1e3 * e);
                }, r.months = function(e, t) {
                    return yn(e, t, "months");
                }, r.isDate = l, r.locale = ct, r.invalid = y, r.duration = Wt, r.isMoment = O, r.weekdays = function(e, t, n) {
                    return mn(e, t, n, "weekdays");
                }, r.parseZone = function() {
                    return xt.apply(null, arguments).parseZone();
                }, r.localeData = ft, r.isDuration = Pt, r.monthsShort = function(e, t) {
                    return yn(e, t, "monthsShort");
                }, r.weekdaysMin = function(e, t, n) {
                    return mn(e, t, n, "weekdaysMin");
                }, r.defineLocale = ut, r.updateLocale = function(e, t) {
                    if (null != t) {
                        var n, r, o = ot;
                        null != (r = lt(e)) && (o = r._config), t = _(o, t), (n = new T(t)).parentLocale = at[e], at[e] = n, ct(e);
                    } else null != at[e] && (null != at[e].parentLocale ? at[e] = at[e].parentLocale : null != at[e] && delete at[e]);
                    return at[e];
                }, r.locales = function() {
                    return k(at);
                }, r.weekdaysShort = function(e, t, n) {
                    return mn(e, t, n, "weekdaysShort");
                }, r.normalizeUnits = R, r.relativeTimeRounding = function(e) {
                    return void 0 === e ? Qn : "function" == typeof e && (Qn = e, !0);
                }, r.relativeTimeThreshold = function(e, t) {
                    return void 0 !== Un[e] && (void 0 === t ? Un[e] : (Un[e] = t, "s" === e && (Un.ss = t - 1), !0));
                }, r.calendarFormat = function(e, t) {
                    var n = e.diff(t, "days", !0);
                    return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
                }, r.prototype = fn, r.HTML5_FMT = {
                    DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
                    DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
                    DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
                    DATE: "YYYY-MM-DD",
                    TIME: "HH:mm",
                    TIME_SECONDS: "HH:mm:ss",
                    TIME_MS: "HH:mm:ss.SSS",
                    WEEK: "YYYY-[W]WW",
                    MONTH: "YYYY-MM"
                }, r;
            }();
        }).call(this, n(30)(e));
    },
    function(e, t) {
        e.exports = function(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        };
    },
    function(e, t) {
        e.exports = function(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        };
    },
    function(e, t) {
        e.exports = function() {
            var e = [];
            return e.toString = function() {
                for(var e = [], t = 0; t < this.length; t++){
                    var n = this[t];
                    n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1]);
                }
                return e.join("");
            }, e.i = function(t, n) {
                "string" == typeof t && (t = [
                    [
                        null,
                        t,
                        ""
                    ]
                ]);
                for(var r = {}, o = 0; o < this.length; o++){
                    var a = this[o][0];
                    "number" == typeof a && (r[a] = !0);
                }
                for(o = 0; o < t.length; o++){
                    var i = t[o];
                    "number" == typeof i[0] && r[i[0]] || (n && !i[2] ? i[2] = n : n && (i[2] = "(" + i[2] + ") and (" + n + ")"), e.push(i));
                }
            }, e;
        };
    },
    function(e, t) {
        var n = {}, r = function(e) {
            var t;
            return function() {
                return void 0 === t && (t = e.apply(this, arguments)), t;
            };
        }, o = r(function() {
            return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
        }), a = r(function() {
            return document.head || document.getElementsByTagName("head")[0];
        }), i = null, s = 0, l = [];
        function c(e, t) {
            for(var r = 0; r < e.length; r++){
                var o = e[r], a = n[o.id];
                if (a) {
                    a.refs++;
                    for(var i = 0; i < a.parts.length; i++)a.parts[i](o.parts[i]);
                    for(; i < o.parts.length; i++)a.parts.push(h(o.parts[i], t));
                } else {
                    var s = [];
                    for(i = 0; i < o.parts.length; i++)s.push(h(o.parts[i], t));
                    n[o.id] = {
                        id: o.id,
                        refs: 1,
                        parts: s
                    };
                }
            }
        }
        function u(e) {
            for(var t = [], n = {}, r = 0; r < e.length; r++){
                var o = e[r], a = o[0], i = {
                    css: o[1],
                    media: o[2],
                    sourceMap: o[3]
                };
                n[a] ? n[a].parts.push(i) : t.push(n[a] = {
                    id: a,
                    parts: [
                        i
                    ]
                });
            }
            return t;
        }
        function f(e, t) {
            var n = a(), r = l[l.length - 1];
            if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), l.push(t);
            else {
                if ("bottom" !== e.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
                n.appendChild(t);
            }
        }
        function p(e) {
            e.parentNode.removeChild(e);
            var t = l.indexOf(e);
            t >= 0 && l.splice(t, 1);
        }
        function d(e) {
            var t = document.createElement("style");
            return t.type = "text/css", f(e, t), t;
        }
        function h(e, t) {
            var n, r, o;
            if (t.singleton) {
                var a = s++;
                n = i || (i = d(t)), r = b.bind(null, n, a, !1), o = b.bind(null, n, a, !0);
            } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function(e) {
                var t = document.createElement("link");
                return t.rel = "stylesheet", f(e, t), t;
            }(t), r = (function(e, t) {
                var n = t.css, r = t.sourceMap;
                r && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
                var o = new Blob([
                    n
                ], {
                    type: "text/css"
                }), a = e.href;
                e.href = URL.createObjectURL(o), a && URL.revokeObjectURL(a);
            }).bind(null, n), o = function() {
                p(n), n.href && URL.revokeObjectURL(n.href);
            }) : (n = d(t), r = (function(e, t) {
                var n = t.css, r = t.media;
                r && e.setAttribute("media", r);
                if (e.styleSheet) e.styleSheet.cssText = n;
                else {
                    for(; e.firstChild;)e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(n));
                }
            }).bind(null, n), o = function() {
                p(n);
            });
            return r(e), function(t) {
                if (t) {
                    if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
                    r(e = t);
                } else o();
            };
        }
        e.exports = function(e, t) {
            if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
            void 0 === (t = t || {}).singleton && (t.singleton = o()), void 0 === t.insertAt && (t.insertAt = "bottom");
            var r = u(e);
            return c(r, t), function(e) {
                for(var o = [], a = 0; a < r.length; a++){
                    var i = r[a];
                    (s = n[i.id]).refs--, o.push(s);
                }
                e && c(u(e), t);
                for(a = 0; a < o.length; a++){
                    var s;
                    if (0 === (s = o[a]).refs) {
                        for(var l = 0; l < s.parts.length; l++)s.parts[l]();
                        delete n[s.id];
                    }
                }
            };
        };
        var y, m = (y = [], function(e, t) {
            return y[e] = t, y.filter(Boolean).join("\n");
        });
        function b(e, t, n, r) {
            var o = n ? "" : r.css;
            if (e.styleSheet) e.styleSheet.cssText = m(t, o);
            else {
                var a = document.createTextNode(o), i = e.childNodes;
                i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(a, i[t]) : e.appendChild(a);
            }
        }
    },
    function(e, t, n) {
        var r = n(39), o = 0;
        e.exports = function(e) {
            var t = ++o;
            return r(e) + t;
        };
    },
    function(e, t, n) {
        var r = n(59), o = n(34), a = n(40), i = Math.max;
        e.exports = function(e, t, n) {
            var s = null == e ? 0 : e.length;
            if (!s) return -1;
            var l = null == n ? 0 : a(n);
            return l < 0 && (l = i(s + l, 0)), r(e, o(t, 3), l);
        };
    },
    function(e, t, n) {
        var r = n(46), o = "object" == typeof self && self && self.Object === Object && self, a = r || o || Function("return this")();
        e.exports = a;
    },
    function(e, t) {
        function n() {
            return e.exports = n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }, n.apply(this, arguments);
        }
        e.exports = n;
    },
    function(e, t) {
        var n = Array.isArray;
        e.exports = n;
    },
    function(e, t, n) {
        var r = n(75), o = n(80);
        e.exports = function(e, t) {
            var n = o(e, t);
            return r(n) ? n : void 0;
        };
    },
    function(e, t) {
        e.exports = function(e, t) {
            e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
        };
    },
    function(e, t, n) {
        var r = n(59), o = n(34), a = n(40), i = Math.max, s = Math.min;
        e.exports = function(e, t, n) {
            var l = null == e ? 0 : e.length;
            if (!l) return -1;
            var c = l - 1;
            return void 0 !== n && (c = a(n), c = n < 0 ? i(l + c, 0) : s(c, l - 1)), r(e, o(t, 3), c, !0);
        };
    },
    function(e, t, n) {
        var r = n(20), o = n(76), a = n(77), i = "[object Null]", s = "[object Undefined]", l = r ? r.toStringTag : void 0;
        e.exports = function(e) {
            return null == e ? void 0 === e ? s : i : l && l in Object(e) ? o(e) : a(e);
        };
    },
    function(e, t) {
        e.exports = function(e) {
            var t = typeof e;
            return null != e && ("object" == t || "function" == t);
        };
    },
    function(e, t) {
        e.exports = function(e) {
            return null != e && "object" == typeof e;
        };
    },
    function(e, t, n) {
        "use strict";
        var r = Object.prototype.hasOwnProperty;
        function o(e, t) {
            return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
        }
        e.exports = function(e, t) {
            if (o(e, t)) return !0;
            if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
            var n = Object.keys(e), a = Object.keys(t);
            if (n.length !== a.length) return !1;
            for(var i = 0; i < n.length; i++)if (!r.call(t, n[i]) || !o(e[n[i]], t[n[i]])) return !1;
            return !0;
        };
    },
    function(e, t, n) {
        var r = n(10).Symbol;
        e.exports = r;
    },
    function(e, t) {
        var n;
        n = function() {
            return this;
        }();
        try {
            n = n || new Function("return this")();
        } catch (e) {
            "object" == typeof window && (n = window);
        }
        e.exports = n;
    },
    function(e, t, n) {
        var r = n(97), o = n(98), a = n(99), i = n(100), s = n(101);
        function l(e) {
            var t = -1, n = null == e ? 0 : e.length;
            for(this.clear(); ++t < n;){
                var r = e[t];
                this.set(r[0], r[1]);
            }
        }
        l.prototype.clear = r, l.prototype.delete = o, l.prototype.get = a, l.prototype.has = i, l.prototype.set = s, e.exports = l;
    },
    function(e, t, n) {
        var r = n(35);
        e.exports = function(e, t) {
            for(var n = e.length; n--;)if (r(e[n][0], t)) return n;
            return -1;
        };
    },
    function(e, t, n) {
        var r = n(13)(Object, "create");
        e.exports = r;
    },
    function(e, t, n) {
        var r = n(115);
        e.exports = function(e, t) {
            var n = e.__data__;
            return r(t) ? n["string" == typeof t ? "string" : "hash"] : n.map;
        };
    },
    function(e, t, n) {
        var r = n(16), o = n(18), a = "[object Symbol]";
        e.exports = function(e) {
            return "symbol" == typeof e || o(e) && r(e) == a;
        };
    },
    function(e, t, n) {
        var r = n(26), o = 1 / 0;
        e.exports = function(e) {
            if ("string" == typeof e || r(e)) return e;
            var t = e + "";
            return "0" == t && 1 / e == -o ? "-0" : t;
        };
    },
    function(e, t) {
        e.exports = function() {};
    },
    function(e, t, n) {
        "use strict";
        (function(e, r) {
            var o, a = n(63);
            o = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : r;
            var i = Object(a.a)(o);
            t.a = i;
        }).call(this, n(21), n(168)(e));
    },
    function(e, t) {
        e.exports = function(e) {
            return e.webpackPolyfill || (e.deprecate = function() {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
                enumerable: !0,
                get: function() {
                    return e.l;
                }
            }), Object.defineProperty(e, "id", {
                enumerable: !0,
                get: function() {
                    return e.i;
                }
            }), e.webpackPolyfill = 1), e;
        };
    },
    function(e, t, n) {
        var r = n(84), o = n(91), a = n(51);
        e.exports = function(e) {
            return a(e) ? r(e) : o(e);
        };
    },
    function(e, t) {
        var n = 9007199254740991, r = /^(?:0|[1-9]\d*)$/;
        e.exports = function(e, t) {
            var o = typeof e;
            return !!(t = null == t ? n : t) && ("number" == o || "symbol" != o && r.test(e)) && e > -1 && e % 1 == 0 && e < t;
        };
    },
    function(e, t) {
        var n = 9007199254740991;
        e.exports = function(e) {
            return "number" == typeof e && e > -1 && e % 1 == 0 && e <= n;
        };
    },
    function(e, t, n) {
        var r = n(95), o = n(142), a = n(152), i = n(12), s = n(153);
        e.exports = function(e) {
            return "function" == typeof e ? e : null == e ? a : "object" == typeof e ? i(e) ? o(e[0], e[1]) : r(e) : s(e);
        };
    },
    function(e, t) {
        e.exports = function(e, t) {
            return e === t || e != e && t != t;
        };
    },
    function(e, t, n) {
        var r = n(13)(n(10), "Map");
        e.exports = r;
    },
    function(e, t, n) {
        var r = n(107), o = n(114), a = n(116), i = n(117), s = n(118);
        function l(e) {
            var t = -1, n = null == e ? 0 : e.length;
            for(this.clear(); ++t < n;){
                var r = e[t];
                this.set(r[0], r[1]);
            }
        }
        l.prototype.clear = r, l.prototype.delete = o, l.prototype.get = a, l.prototype.has = i, l.prototype.set = s, e.exports = l;
    },
    function(e, t, n) {
        var r = n(12), o = n(26), a = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
        e.exports = function(e, t) {
            if (r(e)) return !1;
            var n = typeof e;
            return !("number" != n && "symbol" != n && "boolean" != n && null != e && !o(e)) || i.test(e) || !a.test(e) || null != t && e in Object(t);
        };
    },
    function(e, t, n) {
        var r = n(147);
        e.exports = function(e) {
            return null == e ? "" : r(e);
        };
    },
    function(e, t, n) {
        var r = n(164);
        e.exports = function(e) {
            var t = r(e), n = t % 1;
            return t == t ? n ? t - n : t : 0;
        };
    },
    function(e, t, n) {
        var r = n(183);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        "use strict";
        var r = function() {};
        e.exports = r;
    },
    function(e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
        t.createChangeEmitter = function() {
            var e = [], t = e;
            function n() {
                t === e && (t = e.slice());
            }
            return {
                listen: function(e) {
                    if ("function" != typeof e) throw new Error("Expected listener to be a function.");
                    var r = !0;
                    return n(), t.push(e), function() {
                        if (r) {
                            r = !1, n();
                            var o = t.indexOf(e);
                            t.splice(o, 1);
                        }
                    };
                },
                emit: function() {
                    for(var n = e = t, r = 0; r < n.length; r++)n[r].apply(n, arguments);
                }
            };
        };
    },
    function(e, t, n) {
        "use strict";
        (function(e) {
            for(/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var n = "undefined" != typeof window && "undefined" != typeof document, r = [
                "Edge",
                "Trident",
                "Firefox"
            ], o = 0, a = 0; a < r.length; a += 1)if (n && navigator.userAgent.indexOf(r[a]) >= 0) {
                o = 1;
                break;
            }
            var i = n && window.Promise ? function(e) {
                var t = !1;
                return function() {
                    t || (t = !0, window.Promise.resolve().then(function() {
                        t = !1, e();
                    }));
                };
            } : function(e) {
                var t = !1;
                return function() {
                    t || (t = !0, setTimeout(function() {
                        t = !1, e();
                    }, o));
                };
            };
            function s(e) {
                return e && "[object Function]" === ({}).toString.call(e);
            }
            function l(e, t) {
                if (1 !== e.nodeType) return [];
                var n = e.ownerDocument.defaultView.getComputedStyle(e, null);
                return t ? n[t] : n;
            }
            function c(e) {
                return "HTML" === e.nodeName ? e : e.parentNode || e.host;
            }
            function u(e) {
                if (!e) return document.body;
                switch(e.nodeName){
                    case "HTML":
                    case "BODY":
                        return e.ownerDocument.body;
                    case "#document":
                        return e.body;
                }
                var t = l(e), n = t.overflow, r = t.overflowX, o = t.overflowY;
                return /(auto|scroll|overlay)/.test(n + o + r) ? e : u(c(e));
            }
            var f = n && !(!window.MSInputMethodContext || !document.documentMode), p = n && /MSIE 10/.test(navigator.userAgent);
            function d(e) {
                return 11 === e ? f : 10 === e ? p : f || p;
            }
            function h(e) {
                if (!e) return document.documentElement;
                for(var t = d(10) ? document.body : null, n = e.offsetParent || null; n === t && e.nextElementSibling;)n = (e = e.nextElementSibling).offsetParent;
                var r = n && n.nodeName;
                return r && "BODY" !== r && "HTML" !== r ? -1 !== [
                    "TH",
                    "TD",
                    "TABLE"
                ].indexOf(n.nodeName) && "static" === l(n, "position") ? h(n) : n : e ? e.ownerDocument.documentElement : document.documentElement;
            }
            function y(e) {
                return null !== e.parentNode ? y(e.parentNode) : e;
            }
            function m(e, t) {
                if (!(e && e.nodeType && t && t.nodeType)) return document.documentElement;
                var n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING, r = n ? e : t, o = n ? t : e, a = document.createRange();
                a.setStart(r, 0), a.setEnd(o, 0);
                var i, s, l = a.commonAncestorContainer;
                if (e !== l && t !== l || r.contains(o)) return "BODY" === (s = (i = l).nodeName) || "HTML" !== s && h(i.firstElementChild) !== i ? h(l) : l;
                var c = y(e);
                return c.host ? m(c.host, t) : m(e, y(t).host);
            }
            function b(e) {
                var t = "top" === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "top") ? "scrollTop" : "scrollLeft", n = e.nodeName;
                if ("BODY" === n || "HTML" === n) {
                    var r = e.ownerDocument.documentElement;
                    return (e.ownerDocument.scrollingElement || r)[t];
                }
                return e[t];
            }
            function g(e, t) {
                var n = "x" === t ? "Left" : "Top", r = "Left" === n ? "Right" : "Bottom";
                return parseFloat(e["border" + n + "Width"], 10) + parseFloat(e["border" + r + "Width"], 10);
            }
            function v(e, t, n, r) {
                return Math.max(t["offset" + e], t["scroll" + e], n["client" + e], n["offset" + e], n["scroll" + e], d(10) ? parseInt(n["offset" + e]) + parseInt(r["margin" + ("Height" === e ? "Top" : "Left")]) + parseInt(r["margin" + ("Height" === e ? "Bottom" : "Right")]) : 0);
            }
            function O(e) {
                var t = e.body, n = e.documentElement, r = d(10) && getComputedStyle(n);
                return {
                    height: v("Height", t, n, r),
                    width: v("Width", t, n, r)
                };
            }
            var A = function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }, w = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                    }
                }
                return function(t, n, r) {
                    return n && e(t.prototype, n), r && e(t, r), t;
                };
            }(), S = function(e, t, n) {
                return t in e ? Object.defineProperty(e, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = n, e;
            }, E = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            };
            function D(e) {
                return E({}, e, {
                    right: e.left + e.width,
                    bottom: e.top + e.height
                });
            }
            function k(e) {
                var t = {};
                try {
                    if (d(10)) {
                        t = e.getBoundingClientRect();
                        var n = b(e, "top"), r = b(e, "left");
                        t.top += n, t.left += r, t.bottom += n, t.right += r;
                    } else t = e.getBoundingClientRect();
                } catch (e) {}
                var o = {
                    left: t.left,
                    top: t.top,
                    width: t.right - t.left,
                    height: t.bottom - t.top
                }, a = "HTML" === e.nodeName ? O(e.ownerDocument) : {}, i = a.width || e.clientWidth || o.right - o.left, s = a.height || e.clientHeight || o.bottom - o.top, c = e.offsetWidth - i, u = e.offsetHeight - s;
                if (c || u) {
                    var f = l(e);
                    c -= g(f, "x"), u -= g(f, "y"), o.width -= c, o.height -= u;
                }
                return D(o);
            }
            function M(e, t) {
                var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = d(10), o = "HTML" === t.nodeName, a = k(e), i = k(t), s = u(e), c = l(t), f = parseFloat(c.borderTopWidth, 10), p = parseFloat(c.borderLeftWidth, 10);
                n && o && (i.top = Math.max(i.top, 0), i.left = Math.max(i.left, 0));
                var h = D({
                    top: a.top - i.top - f,
                    left: a.left - i.left - p,
                    width: a.width,
                    height: a.height
                });
                if (h.marginTop = 0, h.marginLeft = 0, !r && o) {
                    var y = parseFloat(c.marginTop, 10), m = parseFloat(c.marginLeft, 10);
                    h.top -= f - y, h.bottom -= f - y, h.left -= p - m, h.right -= p - m, h.marginTop = y, h.marginLeft = m;
                }
                return (r && !n ? t.contains(s) : t === s && "BODY" !== s.nodeName) && (h = function(e, t) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = b(t, "top"), o = b(t, "left"), a = n ? -1 : 1;
                    return e.top += r * a, e.bottom += r * a, e.left += o * a, e.right += o * a, e;
                }(h, t)), h;
            }
            function C(e) {
                if (!e || !e.parentElement || d()) return document.documentElement;
                for(var t = e.parentElement; t && "none" === l(t, "transform");)t = t.parentElement;
                return t || document.documentElement;
            }
            function x(e, t, n, r) {
                var o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], a = {
                    top: 0,
                    left: 0
                }, i = o ? C(e) : m(e, t);
                if ("viewport" === r) a = function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = e.ownerDocument.documentElement, r = M(e, n), o = Math.max(n.clientWidth, window.innerWidth || 0), a = Math.max(n.clientHeight, window.innerHeight || 0), i = t ? 0 : b(n), s = t ? 0 : b(n, "left");
                    return D({
                        top: i - r.top + r.marginTop,
                        left: s - r.left + r.marginLeft,
                        width: o,
                        height: a
                    });
                }(i, o);
                else {
                    var s = void 0;
                    "scrollParent" === r ? "BODY" === (s = u(c(t))).nodeName && (s = e.ownerDocument.documentElement) : s = "window" === r ? e.ownerDocument.documentElement : r;
                    var f = M(s, i, o);
                    if ("HTML" !== s.nodeName || function e(t) {
                        var n = t.nodeName;
                        if ("BODY" === n || "HTML" === n) return !1;
                        if ("fixed" === l(t, "position")) return !0;
                        var r = c(t);
                        return !!r && e(r);
                    }(i)) a = f;
                    else {
                        var p = O(e.ownerDocument), d = p.height, h = p.width;
                        a.top += f.top - f.marginTop, a.bottom = d + f.top, a.left += f.left - f.marginLeft, a.right = h + f.left;
                    }
                }
                var y = "number" == typeof (n = n || 0);
                return a.left += y ? n : n.left || 0, a.top += y ? n : n.top || 0, a.right -= y ? n : n.right || 0, a.bottom -= y ? n : n.bottom || 0, a;
            }
            function _(e, t, n, r, o) {
                var a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
                if (-1 === e.indexOf("auto")) return e;
                var i = x(n, r, a, o), s = {
                    top: {
                        width: i.width,
                        height: t.top - i.top
                    },
                    right: {
                        width: i.right - t.right,
                        height: i.height
                    },
                    bottom: {
                        width: i.width,
                        height: i.bottom - t.bottom
                    },
                    left: {
                        width: t.left - i.left,
                        height: i.height
                    }
                }, l = Object.keys(s).map(function(e) {
                    var t;
                    return E({
                        key: e
                    }, s[e], {
                        area: (t = s[e], t.width * t.height)
                    });
                }).sort(function(e, t) {
                    return t.area - e.area;
                }), c = l.filter(function(e) {
                    var t = e.width, r = e.height;
                    return t >= n.clientWidth && r >= n.clientHeight;
                }), u = c.length > 0 ? c[0].key : l[0].key, f = e.split("-")[1];
                return u + (f ? "-" + f : "");
            }
            function T(e, t, n) {
                var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                return M(n, r ? C(t) : m(t, n), r);
            }
            function j(e) {
                var t = e.ownerDocument.defaultView.getComputedStyle(e), n = parseFloat(t.marginTop || 0) + parseFloat(t.marginBottom || 0), r = parseFloat(t.marginLeft || 0) + parseFloat(t.marginRight || 0);
                return {
                    width: e.offsetWidth + r,
                    height: e.offsetHeight + n
                };
            }
            function I(e) {
                var t = {
                    left: "right",
                    right: "left",
                    bottom: "top",
                    top: "bottom"
                };
                return e.replace(/left|right|bottom|top/g, function(e) {
                    return t[e];
                });
            }
            function R(e, t, n) {
                n = n.split("-")[0];
                var r = j(e), o = {
                    width: r.width,
                    height: r.height
                }, a = -1 !== [
                    "right",
                    "left"
                ].indexOf(n), i = a ? "top" : "left", s = a ? "left" : "top", l = a ? "height" : "width", c = a ? "width" : "height";
                return o[i] = t[i] + t[l] / 2 - r[l] / 2, o[s] = n === s ? t[s] - r[c] : t[I(s)], o;
            }
            function P(e, t) {
                return Array.prototype.find ? e.find(t) : e.filter(t)[0];
            }
            function N(e, t, n) {
                return (void 0 === n ? e : e.slice(0, function(e, t, n) {
                    if (Array.prototype.findIndex) return e.findIndex(function(e) {
                        return e[t] === n;
                    });
                    var r = P(e, function(e) {
                        return e[t] === n;
                    });
                    return e.indexOf(r);
                }(e, "name", n))).forEach(function(e) {
                    e.function && console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
                    var n = e.function || e.fn;
                    e.enabled && s(n) && (t.offsets.popper = D(t.offsets.popper), t.offsets.reference = D(t.offsets.reference), t = n(t, e));
                }), t;
            }
            function B(e, t) {
                return e.some(function(e) {
                    var n = e.name;
                    return e.enabled && n === t;
                });
            }
            function Y(e) {
                for(var t = [
                    !1,
                    "ms",
                    "Webkit",
                    "Moz",
                    "O"
                ], n = e.charAt(0).toUpperCase() + e.slice(1), r = 0; r < t.length; r++){
                    var o = t[r], a = o ? "" + o + n : e;
                    if (void 0 !== document.body.style[a]) return a;
                }
                return null;
            }
            function Q(e) {
                var t = e.ownerDocument;
                return t ? t.defaultView : window;
            }
            function U(e, t, n, r) {
                n.updateBound = r, Q(e).addEventListener("resize", n.updateBound, {
                    passive: !0
                });
                var o = u(e);
                return function e(t, n, r, o) {
                    var a = "BODY" === t.nodeName, i = a ? t.ownerDocument.defaultView : t;
                    i.addEventListener(n, r, {
                        passive: !0
                    }), a || e(u(i.parentNode), n, r, o), o.push(i);
                }(o, "scroll", n.updateBound, n.scrollParents), n.scrollElement = o, n.eventsEnabled = !0, n;
            }
            function F() {
                var e, t;
                this.state.eventsEnabled && (cancelAnimationFrame(this.scheduleUpdate), this.state = (e = this.reference, t = this.state, Q(e).removeEventListener("resize", t.updateBound), t.scrollParents.forEach(function(e) {
                    e.removeEventListener("scroll", t.updateBound);
                }), t.updateBound = null, t.scrollParents = [], t.scrollElement = null, t.eventsEnabled = !1, t));
            }
            function H(e) {
                return "" !== e && !isNaN(parseFloat(e)) && isFinite(e);
            }
            function G(e, t) {
                Object.keys(t).forEach(function(n) {
                    var r = "";
                    -1 !== [
                        "width",
                        "height",
                        "top",
                        "right",
                        "bottom",
                        "left"
                    ].indexOf(n) && H(t[n]) && (r = "px"), e.style[n] = t[n] + r;
                });
            }
            var J = n && /Firefox/i.test(navigator.userAgent);
            function W(e, t, n) {
                var r = P(e, function(e) {
                    return e.name === t;
                }), o = !!r && e.some(function(e) {
                    return e.name === n && e.enabled && e.order < r.order;
                });
                if (!o) {
                    var a = "`" + t + "`", i = "`" + n + "`";
                    console.warn(i + " modifier is required by " + a + " modifier in order to work, be sure to include it before " + a + "!");
                }
                return o;
            }
            var K = [
                "auto-start",
                "auto",
                "auto-end",
                "top-start",
                "top",
                "top-end",
                "right-start",
                "right",
                "right-end",
                "bottom-end",
                "bottom",
                "bottom-start",
                "left-end",
                "left",
                "left-start"
            ], L = K.slice(3);
            function V(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = L.indexOf(e), r = L.slice(n + 1).concat(L.slice(0, n));
                return t ? r.reverse() : r;
            }
            var Z = {
                FLIP: "flip",
                CLOCKWISE: "clockwise",
                COUNTERCLOCKWISE: "counterclockwise"
            };
            function q(e, t, n, r) {
                var o = [
                    0,
                    0
                ], a = -1 !== [
                    "right",
                    "left"
                ].indexOf(r), i = e.split(/(\+|\-)/).map(function(e) {
                    return e.trim();
                }), s = i.indexOf(P(i, function(e) {
                    return -1 !== e.search(/,|\s/);
                }));
                i[s] && -1 === i[s].indexOf(",") && console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
                var l = /\s*,\s*|\s+/, c = -1 !== s ? [
                    i.slice(0, s).concat([
                        i[s].split(l)[0]
                    ]),
                    [
                        i[s].split(l)[1]
                    ].concat(i.slice(s + 1))
                ] : [
                    i
                ];
                return (c = c.map(function(e, r) {
                    var o = (1 === r ? !a : a) ? "height" : "width", i = !1;
                    return e.reduce(function(e, t) {
                        return "" === e[e.length - 1] && -1 !== [
                            "+",
                            "-"
                        ].indexOf(t) ? (e[e.length - 1] = t, i = !0, e) : i ? (e[e.length - 1] += t, i = !1, e) : e.concat(t);
                    }, []).map(function(e) {
                        return function(e, t, n, r) {
                            var o = e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/), a = +o[1], i = o[2];
                            if (!a) return e;
                            if (0 === i.indexOf("%")) {
                                var s = void 0;
                                switch(i){
                                    case "%p":
                                        s = n;
                                        break;
                                    case "%":
                                    case "%r":
                                    default:
                                        s = r;
                                }
                                return D(s)[t] / 100 * a;
                            }
                            if ("vh" === i || "vw" === i) return ("vh" === i ? Math.max(document.documentElement.clientHeight, window.innerHeight || 0) : Math.max(document.documentElement.clientWidth, window.innerWidth || 0)) / 100 * a;
                            return a;
                        }(e, o, t, n);
                    });
                })).forEach(function(e, t) {
                    e.forEach(function(n, r) {
                        H(n) && (o[t] += n * ("-" === e[r - 1] ? -1 : 1));
                    });
                }), o;
            }
            var z = {
                placement: "bottom",
                positionFixed: !1,
                eventsEnabled: !0,
                removeOnDestroy: !1,
                onCreate: function() {},
                onUpdate: function() {},
                modifiers: {
                    shift: {
                        order: 100,
                        enabled: !0,
                        fn: function(e) {
                            var t = e.placement, n = t.split("-")[0], r = t.split("-")[1];
                            if (r) {
                                var o = e.offsets, a = o.reference, i = o.popper, s = -1 !== [
                                    "bottom",
                                    "top"
                                ].indexOf(n), l = s ? "left" : "top", c = s ? "width" : "height", u = {
                                    start: S({}, l, a[l]),
                                    end: S({}, l, a[l] + a[c] - i[c])
                                };
                                e.offsets.popper = E({}, i, u[r]);
                            }
                            return e;
                        }
                    },
                    offset: {
                        order: 200,
                        enabled: !0,
                        fn: function(e, t) {
                            var n = t.offset, r = e.placement, o = e.offsets, a = o.popper, i = o.reference, s = r.split("-")[0], l = void 0;
                            return l = H(+n) ? [
                                +n,
                                0
                            ] : q(n, a, i, s), "left" === s ? (a.top += l[0], a.left -= l[1]) : "right" === s ? (a.top += l[0], a.left += l[1]) : "top" === s ? (a.left += l[0], a.top -= l[1]) : "bottom" === s && (a.left += l[0], a.top += l[1]), e.popper = a, e;
                        },
                        offset: 0
                    },
                    preventOverflow: {
                        order: 300,
                        enabled: !0,
                        fn: function(e, t) {
                            var n = t.boundariesElement || h(e.instance.popper);
                            e.instance.reference === n && (n = h(n));
                            var r = Y("transform"), o = e.instance.popper.style, a = o.top, i = o.left, s = o[r];
                            o.top = "", o.left = "", o[r] = "";
                            var l = x(e.instance.popper, e.instance.reference, t.padding, n, e.positionFixed);
                            o.top = a, o.left = i, o[r] = s, t.boundaries = l;
                            var c = t.priority, u = e.offsets.popper, f = {
                                primary: function(e) {
                                    var n = u[e];
                                    return u[e] < l[e] && !t.escapeWithReference && (n = Math.max(u[e], l[e])), S({}, e, n);
                                },
                                secondary: function(e) {
                                    var n = "right" === e ? "left" : "top", r = u[n];
                                    return u[e] > l[e] && !t.escapeWithReference && (r = Math.min(u[n], l[e] - ("right" === e ? u.width : u.height))), S({}, n, r);
                                }
                            };
                            return c.forEach(function(e) {
                                var t = -1 !== [
                                    "left",
                                    "top"
                                ].indexOf(e) ? "primary" : "secondary";
                                u = E({}, u, f[t](e));
                            }), e.offsets.popper = u, e;
                        },
                        priority: [
                            "left",
                            "right",
                            "top",
                            "bottom"
                        ],
                        padding: 5,
                        boundariesElement: "scrollParent"
                    },
                    keepTogether: {
                        order: 400,
                        enabled: !0,
                        fn: function(e) {
                            var t = e.offsets, n = t.popper, r = t.reference, o = e.placement.split("-")[0], a = Math.floor, i = -1 !== [
                                "top",
                                "bottom"
                            ].indexOf(o), s = i ? "right" : "bottom", l = i ? "left" : "top", c = i ? "width" : "height";
                            return n[s] < a(r[l]) && (e.offsets.popper[l] = a(r[l]) - n[c]), n[l] > a(r[s]) && (e.offsets.popper[l] = a(r[s])), e;
                        }
                    },
                    arrow: {
                        order: 500,
                        enabled: !0,
                        fn: function(e, t) {
                            var n;
                            if (!W(e.instance.modifiers, "arrow", "keepTogether")) return e;
                            var r = t.element;
                            if ("string" == typeof r) {
                                if (!(r = e.instance.popper.querySelector(r))) return e;
                            } else if (!e.instance.popper.contains(r)) return console.warn("WARNING: `arrow.element` must be child of its popper element!"), e;
                            var o = e.placement.split("-")[0], a = e.offsets, i = a.popper, s = a.reference, c = -1 !== [
                                "left",
                                "right"
                            ].indexOf(o), u = c ? "height" : "width", f = c ? "Top" : "Left", p = f.toLowerCase(), d = c ? "left" : "top", h = c ? "bottom" : "right", y = j(r)[u];
                            s[h] - y < i[p] && (e.offsets.popper[p] -= i[p] - (s[h] - y)), s[p] + y > i[h] && (e.offsets.popper[p] += s[p] + y - i[h]), e.offsets.popper = D(e.offsets.popper);
                            var m = s[p] + s[u] / 2 - y / 2, b = l(e.instance.popper), g = parseFloat(b["margin" + f], 10), v = parseFloat(b["border" + f + "Width"], 10), O = m - e.offsets.popper[p] - g - v;
                            return O = Math.max(Math.min(i[u] - y, O), 0), e.arrowElement = r, e.offsets.arrow = (S(n = {}, p, Math.round(O)), S(n, d, ""), n), e;
                        },
                        element: "[x-arrow]"
                    },
                    flip: {
                        order: 600,
                        enabled: !0,
                        fn: function(e, t) {
                            if (B(e.instance.modifiers, "inner")) return e;
                            if (e.flipped && e.placement === e.originalPlacement) return e;
                            var n = x(e.instance.popper, e.instance.reference, t.padding, t.boundariesElement, e.positionFixed), r = e.placement.split("-")[0], o = I(r), a = e.placement.split("-")[1] || "", i = [];
                            switch(t.behavior){
                                case Z.FLIP:
                                    i = [
                                        r,
                                        o
                                    ];
                                    break;
                                case Z.CLOCKWISE:
                                    i = V(r);
                                    break;
                                case Z.COUNTERCLOCKWISE:
                                    i = V(r, !0);
                                    break;
                                default:
                                    i = t.behavior;
                            }
                            return i.forEach(function(s, l) {
                                if (r !== s || i.length === l + 1) return e;
                                r = e.placement.split("-")[0], o = I(r);
                                var c = e.offsets.popper, u = e.offsets.reference, f = Math.floor, p = "left" === r && f(c.right) > f(u.left) || "right" === r && f(c.left) < f(u.right) || "top" === r && f(c.bottom) > f(u.top) || "bottom" === r && f(c.top) < f(u.bottom), d = f(c.left) < f(n.left), h = f(c.right) > f(n.right), y = f(c.top) < f(n.top), m = f(c.bottom) > f(n.bottom), b = "left" === r && d || "right" === r && h || "top" === r && y || "bottom" === r && m, g = -1 !== [
                                    "top",
                                    "bottom"
                                ].indexOf(r), v = !!t.flipVariations && (g && "start" === a && d || g && "end" === a && h || !g && "start" === a && y || !g && "end" === a && m), O = !!t.flipVariationsByContent && (g && "start" === a && h || g && "end" === a && d || !g && "start" === a && m || !g && "end" === a && y), A = v || O;
                                (p || b || A) && (e.flipped = !0, (p || b) && (r = i[l + 1]), A && (a = function(e) {
                                    return "end" === e ? "start" : "start" === e ? "end" : e;
                                }(a)), e.placement = r + (a ? "-" + a : ""), e.offsets.popper = E({}, e.offsets.popper, R(e.instance.popper, e.offsets.reference, e.placement)), e = N(e.instance.modifiers, e, "flip"));
                            }), e;
                        },
                        behavior: "flip",
                        padding: 5,
                        boundariesElement: "viewport",
                        flipVariations: !1,
                        flipVariationsByContent: !1
                    },
                    inner: {
                        order: 700,
                        enabled: !1,
                        fn: function(e) {
                            var t = e.placement, n = t.split("-")[0], r = e.offsets, o = r.popper, a = r.reference, i = -1 !== [
                                "left",
                                "right"
                            ].indexOf(n), s = -1 === [
                                "top",
                                "left"
                            ].indexOf(n);
                            return o[i ? "left" : "top"] = a[n] - (s ? o[i ? "width" : "height"] : 0), e.placement = I(t), e.offsets.popper = D(o), e;
                        }
                    },
                    hide: {
                        order: 800,
                        enabled: !0,
                        fn: function(e) {
                            if (!W(e.instance.modifiers, "hide", "preventOverflow")) return e;
                            var t = e.offsets.reference, n = P(e.instance.modifiers, function(e) {
                                return "preventOverflow" === e.name;
                            }).boundaries;
                            if (t.bottom < n.top || t.left > n.right || t.top > n.bottom || t.right < n.left) {
                                if (!0 === e.hide) return e;
                                e.hide = !0, e.attributes["x-out-of-boundaries"] = "";
                            } else {
                                if (!1 === e.hide) return e;
                                e.hide = !1, e.attributes["x-out-of-boundaries"] = !1;
                            }
                            return e;
                        }
                    },
                    computeStyle: {
                        order: 850,
                        enabled: !0,
                        fn: function(e, t) {
                            var n = t.x, r = t.y, o = e.offsets.popper, a = P(e.instance.modifiers, function(e) {
                                return "applyStyle" === e.name;
                            }).gpuAcceleration;
                            void 0 !== a && console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
                            var i = void 0 !== a ? a : t.gpuAcceleration, s = h(e.instance.popper), l = k(s), c = {
                                position: o.position
                            }, u = function(e, t) {
                                var n = e.offsets, r = n.popper, o = n.reference, a = Math.round, i = Math.floor, s = function(e) {
                                    return e;
                                }, l = a(o.width), c = a(r.width), u = -1 !== [
                                    "left",
                                    "right"
                                ].indexOf(e.placement), f = -1 !== e.placement.indexOf("-"), p = t ? u || f || l % 2 == c % 2 ? a : i : s, d = t ? a : s;
                                return {
                                    left: p(l % 2 == 1 && c % 2 == 1 && !f && t ? r.left - 1 : r.left),
                                    top: d(r.top),
                                    bottom: d(r.bottom),
                                    right: p(r.right)
                                };
                            }(e, window.devicePixelRatio < 2 || !J), f = "bottom" === n ? "top" : "bottom", p = "right" === r ? "left" : "right", d = Y("transform"), y = void 0, m = void 0;
                            if (m = "bottom" === f ? "HTML" === s.nodeName ? -s.clientHeight + u.bottom : -l.height + u.bottom : u.top, y = "right" === p ? "HTML" === s.nodeName ? -s.clientWidth + u.right : -l.width + u.right : u.left, i && d) c[d] = "translate3d(" + y + "px, " + m + "px, 0)", c[f] = 0, c[p] = 0, c.willChange = "transform";
                            else {
                                var b = "bottom" === f ? -1 : 1, g = "right" === p ? -1 : 1;
                                c[f] = m * b, c[p] = y * g, c.willChange = f + ", " + p;
                            }
                            var v = {
                                "x-placement": e.placement
                            };
                            return e.attributes = E({}, v, e.attributes), e.styles = E({}, c, e.styles), e.arrowStyles = E({}, e.offsets.arrow, e.arrowStyles), e;
                        },
                        gpuAcceleration: !0,
                        x: "bottom",
                        y: "right"
                    },
                    applyStyle: {
                        order: 900,
                        enabled: !0,
                        fn: function(e) {
                            var t, n;
                            return G(e.instance.popper, e.styles), t = e.instance.popper, n = e.attributes, Object.keys(n).forEach(function(e) {
                                !1 !== n[e] ? t.setAttribute(e, n[e]) : t.removeAttribute(e);
                            }), e.arrowElement && Object.keys(e.arrowStyles).length && G(e.arrowElement, e.arrowStyles), e;
                        },
                        onLoad: function(e, t, n, r, o) {
                            var a = T(o, t, e, n.positionFixed), i = _(n.placement, a, t, e, n.modifiers.flip.boundariesElement, n.modifiers.flip.padding);
                            return t.setAttribute("x-placement", i), G(t, {
                                position: n.positionFixed ? "fixed" : "absolute"
                            }), n;
                        },
                        gpuAcceleration: void 0
                    }
                }
            }, X = function() {
                function e(t, n) {
                    var r = this, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    A(this, e), this.scheduleUpdate = function() {
                        return requestAnimationFrame(r.update);
                    }, this.update = i(this.update.bind(this)), this.options = E({}, e.Defaults, o), this.state = {
                        isDestroyed: !1,
                        isCreated: !1,
                        scrollParents: []
                    }, this.reference = t && t.jquery ? t[0] : t, this.popper = n && n.jquery ? n[0] : n, this.options.modifiers = {}, Object.keys(E({}, e.Defaults.modifiers, o.modifiers)).forEach(function(t) {
                        r.options.modifiers[t] = E({}, e.Defaults.modifiers[t] || {}, o.modifiers ? o.modifiers[t] : {});
                    }), this.modifiers = Object.keys(this.options.modifiers).map(function(e) {
                        return E({
                            name: e
                        }, r.options.modifiers[e]);
                    }).sort(function(e, t) {
                        return e.order - t.order;
                    }), this.modifiers.forEach(function(e) {
                        e.enabled && s(e.onLoad) && e.onLoad(r.reference, r.popper, r.options, e, r.state);
                    }), this.update();
                    var a = this.options.eventsEnabled;
                    a && this.enableEventListeners(), this.state.eventsEnabled = a;
                }
                return w(e, [
                    {
                        key: "update",
                        value: function() {
                            return (function() {
                                if (!this.state.isDestroyed) {
                                    var e = {
                                        instance: this,
                                        styles: {},
                                        arrowStyles: {},
                                        attributes: {},
                                        flipped: !1,
                                        offsets: {}
                                    };
                                    e.offsets.reference = T(this.state, this.popper, this.reference, this.options.positionFixed), e.placement = _(this.options.placement, e.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding), e.originalPlacement = e.placement, e.positionFixed = this.options.positionFixed, e.offsets.popper = R(this.popper, e.offsets.reference, e.placement), e.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute", e = N(this.modifiers, e), this.state.isCreated ? this.options.onUpdate(e) : (this.state.isCreated = !0, this.options.onCreate(e));
                                }
                            }).call(this);
                        }
                    },
                    {
                        key: "destroy",
                        value: function() {
                            return (function() {
                                return this.state.isDestroyed = !0, B(this.modifiers, "applyStyle") && (this.popper.removeAttribute("x-placement"), this.popper.style.position = "", this.popper.style.top = "", this.popper.style.left = "", this.popper.style.right = "", this.popper.style.bottom = "", this.popper.style.willChange = "", this.popper.style[Y("transform")] = ""), this.disableEventListeners(), this.options.removeOnDestroy && this.popper.parentNode.removeChild(this.popper), this;
                            }).call(this);
                        }
                    },
                    {
                        key: "enableEventListeners",
                        value: function() {
                            return (function() {
                                this.state.eventsEnabled || (this.state = U(this.reference, this.options, this.state, this.scheduleUpdate));
                            }).call(this);
                        }
                    },
                    {
                        key: "disableEventListeners",
                        value: function() {
                            return F.call(this);
                        }
                    }
                ]), e;
            }();
            X.Utils = ("undefined" != typeof window ? window : e).PopperUtils, X.placements = K, X.Defaults = z, t.a = X;
        }).call(this, n(21));
    },
    function(e, t, n) {
        var r = n(16), o = n(17), a = "[object AsyncFunction]", i = "[object Function]", s = "[object GeneratorFunction]", l = "[object Proxy]";
        e.exports = function(e) {
            if (!o(e)) return !1;
            var t = r(e);
            return t == i || t == s || t == a || t == l;
        };
    },
    function(e, t, n) {
        (function(t) {
            var n = "object" == typeof t && t && t.Object === Object && t;
            e.exports = n;
        }).call(this, n(21));
    },
    function(e, t) {
        var n = Function.prototype.toString;
        e.exports = function(e) {
            if (null != e) {
                try {
                    return n.call(e);
                } catch (e) {}
                try {
                    return e + "";
                } catch (e) {}
            }
            return "";
        };
    },
    function(e, t, n) {
        var r = n(86), o = n(18), a = Object.prototype, i = a.hasOwnProperty, s = a.propertyIsEnumerable, l = r(function() {
            return arguments;
        }()) ? r : function(e) {
            return o(e) && i.call(e, "callee") && !s.call(e, "callee");
        };
        e.exports = l;
    },
    function(e, t, n) {
        (function(e) {
            var r = n(10), o = n(87), a = t && !t.nodeType && t, i = a && "object" == typeof e && e && !e.nodeType && e, s = i && i.exports === a ? r.Buffer : void 0, l = (s ? s.isBuffer : void 0) || o;
            e.exports = l;
        }).call(this, n(30)(e));
    },
    function(e, t, n) {
        var r = n(88), o = n(89), a = n(90), i = a && a.isTypedArray, s = i ? o(i) : r;
        e.exports = s;
    },
    function(e, t, n) {
        var r = n(45), o = n(33);
        e.exports = function(e) {
            return null != e && o(e.length) && !r(e);
        };
    },
    function(e, t, n) {
        var r = n(22), o = n(102), a = n(103), i = n(104), s = n(105), l = n(106);
        function c(e) {
            var t = this.__data__ = new r(e);
            this.size = t.size;
        }
        c.prototype.clear = o, c.prototype.delete = a, c.prototype.get = i, c.prototype.has = s, c.prototype.set = l, e.exports = c;
    },
    function(e, t, n) {
        var r = n(119), o = n(18);
        e.exports = function e(t, n, a, i, s) {
            return t === n || (null == t || null == n || !o(t) && !o(n) ? t != t && n != n : r(t, n, a, i, e, s));
        };
    },
    function(e, t, n) {
        var r = n(120), o = n(123), a = n(124), i = 1, s = 2;
        e.exports = function(e, t, n, l, c, u) {
            var f = n & i, p = e.length, d = t.length;
            if (p != d && !(f && d > p)) return !1;
            var h = u.get(e);
            if (h && u.get(t)) return h == t;
            var y = -1, m = !0, b = n & s ? new r : void 0;
            for(u.set(e, t), u.set(t, e); ++y < p;){
                var g = e[y], v = t[y];
                if (l) var O = f ? l(v, g, y, t, e, u) : l(g, v, y, e, t, u);
                if (void 0 !== O) {
                    if (O) continue;
                    m = !1;
                    break;
                }
                if (b) {
                    if (!o(t, function(e, t) {
                        if (!a(b, t) && (g === e || c(g, e, n, l, u))) return b.push(t);
                    })) {
                        m = !1;
                        break;
                    }
                } else if (g !== v && !c(g, v, n, l, u)) {
                    m = !1;
                    break;
                }
            }
            return u.delete(e), u.delete(t), m;
        };
    },
    function(e, t, n) {
        var r = n(17);
        e.exports = function(e) {
            return e == e && !r(e);
        };
    },
    function(e, t) {
        e.exports = function(e, t) {
            return function(n) {
                return null != n && n[e] === t && (void 0 !== t || e in Object(n));
            };
        };
    },
    function(e, t, n) {
        var r = n(58), o = n(27);
        e.exports = function(e, t) {
            for(var n = 0, a = (t = r(t, e)).length; null != e && n < a;)e = e[o(t[n++])];
            return n && n == a ? e : void 0;
        };
    },
    function(e, t, n) {
        var r = n(12), o = n(38), a = n(144), i = n(39);
        e.exports = function(e, t) {
            return r(e) ? e : o(e, t) ? [
                e
            ] : a(i(e));
        };
    },
    function(e, t) {
        e.exports = function(e, t, n, r) {
            for(var o = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < o;)if (t(e[a], a, e)) return a;
            return -1;
        };
    },
    function(e, t, n) {
        var r = n(73), o = n(81), a = n(34);
        e.exports = function(e, t) {
            var n = {};
            return t = a(t, 3), o(e, function(e, o, a) {
                r(n, o, t(e, o, a));
            }), n;
        };
    },
    function(e, t, n) {
        var r = n(39), o = /[\\^$.*+?()[\]{}|]/g, a = RegExp(o.source);
        e.exports = function(e) {
            return (e = r(e)) && a.test(e) ? e.replace(o, "\\$&") : e;
        };
    },
    function(e, t, n) {
        "use strict";
        var r = {
            childContextTypes: !0,
            contextTypes: !0,
            defaultProps: !0,
            displayName: !0,
            getDefaultProps: !0,
            mixins: !0,
            propTypes: !0,
            type: !0
        }, o = {
            name: !0,
            length: !0,
            prototype: !0,
            caller: !0,
            arguments: !0,
            arity: !0
        }, a = "function" == typeof Object.getOwnPropertySymbols;
        e.exports = function(e, t, n) {
            if ("string" != typeof t) {
                var i = Object.getOwnPropertyNames(t);
                a && (i = i.concat(Object.getOwnPropertySymbols(t)));
                for(var s = 0; s < i.length; ++s)if (!(r[i[s]] || o[i[s]] || n && n[i[s]])) try {
                    e[i[s]] = t[i[s]];
                } catch (e) {}
            }
            return e;
        };
    },
    function(e, t, n) {
        "use strict";
        function r(e) {
            var t, n = e.Symbol;
            return "function" == typeof n ? n.observable ? t = n.observable : (t = n("observable"), n.observable = t) : t = "@@observable", t;
        }
        n.d(t, "a", function() {
            return r;
        });
    },
    function(e, t, n) {
        var r = n(171), o = n(172), a = n(40), i = Math.ceil, s = Math.max;
        e.exports = function(e, t, n) {
            t = (n ? o(e, t, n) : void 0 === t) ? 1 : s(a(t), 0);
            var l = null == e ? 0 : e.length;
            if (!l || t < 1) return [];
            for(var c = 0, u = 0, f = Array(i(l / t)); c < l;)f[u++] = r(e, c, c += t);
            return f;
        };
    },
    function(e, t) {
        e.exports = (parcelRequire("1u0KT"));
    },
    function(e, t) {
        e.exports = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, a = Object.keys(e);
            for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        };
    },
    function(e, t, n) {
        "use strict";
        t.__esModule = !0;
        var r = a(n(1)), o = a(n(190));
        function a(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        t.default = r.default.createContext || o.default, e.exports = t.default;
    },
    function(e, t, n) {
        e.exports = n(194);
    },
    function(e, t, n) {
        "use strict";
        var r = n(70);
        function o() {}
        e.exports = function() {
            function e(e, t, n, o, a, i) {
                if (i !== r) {
                    var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    throw s.name = "Invariant Violation", s;
                }
            }
            function t() {
                return e;
            }
            e.isRequired = e;
            var n = {
                array: e,
                bool: e,
                func: e,
                number: e,
                object: e,
                string: e,
                symbol: e,
                any: e,
                arrayOf: t,
                element: e,
                instanceOf: t,
                node: e,
                objectOf: t,
                oneOf: t,
                oneOfType: t,
                shape: t,
                exact: t
            };
            return n.checkPropTypes = o, n.PropTypes = n, n;
        };
    },
    function(e, t, n) {
        "use strict";
        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    },
    function(e, t, n) {
        var r = n(72);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".alert-container {\n  position: relative;\n}\n.alert-container .alert-icon {\n  top: 16px;\n  left: 16px;\n  line-height: 1.2em;\n  position: absolute;\n}\n.alert-container .close-btn {\n  top: 16px;\n  right: 16px;\n  position: absolute;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(74);
        e.exports = function(e, t, n) {
            "__proto__" == t && r ? r(e, t, {
                configurable: !0,
                enumerable: !0,
                value: n,
                writable: !0
            }) : e[t] = n;
        };
    },
    function(e, t, n) {
        var r = n(13), o = function() {
            try {
                var e = r(Object, "defineProperty");
                return e({}, "", {}), e;
            } catch (e) {}
        }();
        e.exports = o;
    },
    function(e, t, n) {
        var r = n(45), o = n(78), a = n(17), i = n(47), s = /^\[object .+?Constructor\]$/, l = Function.prototype, c = Object.prototype, u = l.toString, f = c.hasOwnProperty, p = RegExp("^" + u.call(f).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        e.exports = function(e) {
            return !(!a(e) || o(e)) && (r(e) ? p : s).test(i(e));
        };
    },
    function(e, t, n) {
        var r = n(20), o = Object.prototype, a = o.hasOwnProperty, i = o.toString, s = r ? r.toStringTag : void 0;
        e.exports = function(e) {
            var t = a.call(e, s), n = e[s];
            try {
                e[s] = void 0;
                var r = !0;
            } catch (e) {}
            var o = i.call(e);
            return r && (t ? e[s] = n : delete e[s]), o;
        };
    },
    function(e, t) {
        var n = Object.prototype.toString;
        e.exports = function(e) {
            return n.call(e);
        };
    },
    function(e, t, n) {
        var r, o = n(79), a = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";
        e.exports = function(e) {
            return !!a && a in e;
        };
    },
    function(e, t, n) {
        var r = n(10)["__core-js_shared__"];
        e.exports = r;
    },
    function(e, t) {
        e.exports = function(e, t) {
            return null == e ? void 0 : e[t];
        };
    },
    function(e, t, n) {
        var r = n(82), o = n(31);
        e.exports = function(e, t) {
            return e && r(e, t, o);
        };
    },
    function(e, t, n) {
        var r = n(83)();
        e.exports = r;
    },
    function(e, t) {
        e.exports = function(e) {
            return function(t, n, r) {
                for(var o = -1, a = Object(t), i = r(t), s = i.length; s--;){
                    var l = i[e ? s : ++o];
                    if (!1 === n(a[l], l, a)) break;
                }
                return t;
            };
        };
    },
    function(e, t, n) {
        var r = n(85), o = n(48), a = n(12), i = n(49), s = n(32), l = n(50), c = Object.prototype.hasOwnProperty;
        e.exports = function(e, t) {
            var n = a(e), u = !n && o(e), f = !n && !u && i(e), p = !n && !u && !f && l(e), d = n || u || f || p, h = d ? r(e.length, String) : [], y = h.length;
            for(var m in e)!t && !c.call(e, m) || d && ("length" == m || f && ("offset" == m || "parent" == m) || p && ("buffer" == m || "byteLength" == m || "byteOffset" == m) || s(m, y)) || h.push(m);
            return h;
        };
    },
    function(e, t) {
        e.exports = function(e, t) {
            for(var n = -1, r = Array(e); ++n < e;)r[n] = t(n);
            return r;
        };
    },
    function(e, t, n) {
        var r = n(16), o = n(18), a = "[object Arguments]";
        e.exports = function(e) {
            return o(e) && r(e) == a;
        };
    },
    function(e, t) {
        e.exports = function() {
            return !1;
        };
    },
    function(e, t, n) {
        var r = n(16), o = n(33), a = n(18), i = {};
        i["[object Float32Array]"] = i["[object Float64Array]"] = i["[object Int8Array]"] = i["[object Int16Array]"] = i["[object Int32Array]"] = i["[object Uint8Array]"] = i["[object Uint8ClampedArray]"] = i["[object Uint16Array]"] = i["[object Uint32Array]"] = !0, i["[object Arguments]"] = i["[object Array]"] = i["[object ArrayBuffer]"] = i["[object Boolean]"] = i["[object DataView]"] = i["[object Date]"] = i["[object Error]"] = i["[object Function]"] = i["[object Map]"] = i["[object Number]"] = i["[object Object]"] = i["[object RegExp]"] = i["[object Set]"] = i["[object String]"] = i["[object WeakMap]"] = !1, e.exports = function(e) {
            return a(e) && o(e.length) && !!i[r(e)];
        };
    },
    function(e, t) {
        e.exports = function(e) {
            return function(t) {
                return e(t);
            };
        };
    },
    function(e, t, n) {
        (function(e) {
            var r = n(46), o = t && !t.nodeType && t, a = o && "object" == typeof e && e && !e.nodeType && e, i = a && a.exports === o && r.process, s = function() {
                try {
                    var e = a && a.require && a.require("util").types;
                    return e || i && i.binding && i.binding("util");
                } catch (e) {}
            }();
            e.exports = s;
        }).call(this, n(30)(e));
    },
    function(e, t, n) {
        var r = n(92), o = n(93), a = Object.prototype.hasOwnProperty;
        e.exports = function(e) {
            if (!r(e)) return o(e);
            var t = [];
            for(var n in Object(e))a.call(e, n) && "constructor" != n && t.push(n);
            return t;
        };
    },
    function(e, t) {
        var n = Object.prototype;
        e.exports = function(e) {
            var t = e && e.constructor;
            return e === ("function" == typeof t && t.prototype || n);
        };
    },
    function(e, t, n) {
        var r = n(94)(Object.keys, Object);
        e.exports = r;
    },
    function(e, t) {
        e.exports = function(e, t) {
            return function(n) {
                return e(t(n));
            };
        };
    },
    function(e, t, n) {
        var r = n(96), o = n(141), a = n(56);
        e.exports = function(e) {
            var t = o(e);
            return 1 == t.length && t[0][2] ? a(t[0][0], t[0][1]) : function(n) {
                return n === e || r(n, e, t);
            };
        };
    },
    function(e, t, n) {
        var r = n(52), o = n(53), a = 1, i = 2;
        e.exports = function(e, t, n, s) {
            var l = n.length, c = l, u = !s;
            if (null == e) return !c;
            for(e = Object(e); l--;){
                var f = n[l];
                if (u && f[2] ? f[1] !== e[f[0]] : !(f[0] in e)) return !1;
            }
            for(; ++l < c;){
                var p = (f = n[l])[0], d = e[p], h = f[1];
                if (u && f[2]) {
                    if (void 0 === d && !(p in e)) return !1;
                } else {
                    var y = new r;
                    if (s) var m = s(d, h, p, e, t, y);
                    if (!(void 0 === m ? o(h, d, a | i, s, y) : m)) return !1;
                }
            }
            return !0;
        };
    },
    function(e, t) {
        e.exports = function() {
            this.__data__ = [], this.size = 0;
        };
    },
    function(e, t, n) {
        var r = n(23), o = Array.prototype.splice;
        e.exports = function(e) {
            var t = this.__data__, n = r(t, e);
            return !(n < 0 || (n == t.length - 1 ? t.pop() : o.call(t, n, 1), --this.size, 0));
        };
    },
    function(e, t, n) {
        var r = n(23);
        e.exports = function(e) {
            var t = this.__data__, n = r(t, e);
            return n < 0 ? void 0 : t[n][1];
        };
    },
    function(e, t, n) {
        var r = n(23);
        e.exports = function(e) {
            return r(this.__data__, e) > -1;
        };
    },
    function(e, t, n) {
        var r = n(23);
        e.exports = function(e, t) {
            var n = this.__data__, o = r(n, e);
            return o < 0 ? (++this.size, n.push([
                e,
                t
            ])) : n[o][1] = t, this;
        };
    },
    function(e, t, n) {
        var r = n(22);
        e.exports = function() {
            this.__data__ = new r, this.size = 0;
        };
    },
    function(e, t) {
        e.exports = function(e) {
            var t = this.__data__, n = t.delete(e);
            return this.size = t.size, n;
        };
    },
    function(e, t) {
        e.exports = function(e) {
            return this.__data__.get(e);
        };
    },
    function(e, t) {
        e.exports = function(e) {
            return this.__data__.has(e);
        };
    },
    function(e, t, n) {
        var r = n(22), o = n(36), a = n(37), i = 200;
        e.exports = function(e, t) {
            var n = this.__data__;
            if (n instanceof r) {
                var s = n.__data__;
                if (!o || s.length < i - 1) return s.push([
                    e,
                    t
                ]), this.size = ++n.size, this;
                n = this.__data__ = new a(s);
            }
            return n.set(e, t), this.size = n.size, this;
        };
    },
    function(e, t, n) {
        var r = n(108), o = n(22), a = n(36);
        e.exports = function() {
            this.size = 0, this.__data__ = {
                hash: new r,
                map: new (a || o),
                string: new r
            };
        };
    },
    function(e, t, n) {
        var r = n(109), o = n(110), a = n(111), i = n(112), s = n(113);
        function l(e) {
            var t = -1, n = null == e ? 0 : e.length;
            for(this.clear(); ++t < n;){
                var r = e[t];
                this.set(r[0], r[1]);
            }
        }
        l.prototype.clear = r, l.prototype.delete = o, l.prototype.get = a, l.prototype.has = i, l.prototype.set = s, e.exports = l;
    },
    function(e, t, n) {
        var r = n(24);
        e.exports = function() {
            this.__data__ = r ? r(null) : {}, this.size = 0;
        };
    },
    function(e, t) {
        e.exports = function(e) {
            var t = this.has(e) && delete this.__data__[e];
            return this.size -= t ? 1 : 0, t;
        };
    },
    function(e, t, n) {
        var r = n(24), o = "__lodash_hash_undefined__", a = Object.prototype.hasOwnProperty;
        e.exports = function(e) {
            var t = this.__data__;
            if (r) {
                var n = t[e];
                return n === o ? void 0 : n;
            }
            return a.call(t, e) ? t[e] : void 0;
        };
    },
    function(e, t, n) {
        var r = n(24), o = Object.prototype.hasOwnProperty;
        e.exports = function(e) {
            var t = this.__data__;
            return r ? void 0 !== t[e] : o.call(t, e);
        };
    },
    function(e, t, n) {
        var r = n(24), o = "__lodash_hash_undefined__";
        e.exports = function(e, t) {
            var n = this.__data__;
            return this.size += this.has(e) ? 0 : 1, n[e] = r && void 0 === t ? o : t, this;
        };
    },
    function(e, t, n) {
        var r = n(25);
        e.exports = function(e) {
            var t = r(this, e).delete(e);
            return this.size -= t ? 1 : 0, t;
        };
    },
    function(e, t) {
        e.exports = function(e) {
            var t = typeof e;
            return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
        };
    },
    function(e, t, n) {
        var r = n(25);
        e.exports = function(e) {
            return r(this, e).get(e);
        };
    },
    function(e, t, n) {
        var r = n(25);
        e.exports = function(e) {
            return r(this, e).has(e);
        };
    },
    function(e, t, n) {
        var r = n(25);
        e.exports = function(e, t) {
            var n = r(this, e), o = n.size;
            return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
        };
    },
    function(e, t, n) {
        var r = n(52), o = n(54), a = n(125), i = n(129), s = n(136), l = n(12), c = n(49), u = n(50), f = 1, p = "[object Arguments]", d = "[object Array]", h = "[object Object]", y = Object.prototype.hasOwnProperty;
        e.exports = function(e, t, n, m, b, g) {
            var v = l(e), O = l(t), A = v ? d : s(e), w = O ? d : s(t), S = (A = A == p ? h : A) == h, E = (w = w == p ? h : w) == h, D = A == w;
            if (D && c(e)) {
                if (!c(t)) return !1;
                v = !0, S = !1;
            }
            if (D && !S) return g || (g = new r), v || u(e) ? o(e, t, n, m, b, g) : a(e, t, A, n, m, b, g);
            if (!(n & f)) {
                var k = S && y.call(e, "__wrapped__"), M = E && y.call(t, "__wrapped__");
                if (k || M) {
                    var C = k ? e.value() : e, x = M ? t.value() : t;
                    return g || (g = new r), b(C, x, n, m, g);
                }
            }
            return !!D && (g || (g = new r), i(e, t, n, m, b, g));
        };
    },
    function(e, t, n) {
        var r = n(37), o = n(121), a = n(122);
        function i(e) {
            var t = -1, n = null == e ? 0 : e.length;
            for(this.__data__ = new r; ++t < n;)this.add(e[t]);
        }
        i.prototype.add = i.prototype.push = o, i.prototype.has = a, e.exports = i;
    },
    function(e, t) {
        var n = "__lodash_hash_undefined__";
        e.exports = function(e) {
            return this.__data__.set(e, n), this;
        };
    },
    function(e, t) {
        e.exports = function(e) {
            return this.__data__.has(e);
        };
    },
    function(e, t) {
        e.exports = function(e, t) {
            for(var n = -1, r = null == e ? 0 : e.length; ++n < r;)if (t(e[n], n, e)) return !0;
            return !1;
        };
    },
    function(e, t) {
        e.exports = function(e, t) {
            return e.has(t);
        };
    },
    function(e, t, n) {
        var r = n(20), o = n(126), a = n(35), i = n(54), s = n(127), l = n(128), c = 1, u = 2, f = "[object Boolean]", p = "[object Date]", d = "[object Error]", h = "[object Map]", y = "[object Number]", m = "[object RegExp]", b = "[object Set]", g = "[object String]", v = "[object Symbol]", O = "[object ArrayBuffer]", A = "[object DataView]", w = r ? r.prototype : void 0, S = w ? w.valueOf : void 0;
        e.exports = function(e, t, n, r, w, E, D) {
            switch(n){
                case A:
                    if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                    e = e.buffer, t = t.buffer;
                case O:
                    return !(e.byteLength != t.byteLength || !E(new o(e), new o(t)));
                case f:
                case p:
                case y:
                    return a(+e, +t);
                case d:
                    return e.name == t.name && e.message == t.message;
                case m:
                case g:
                    return e == t + "";
                case h:
                    var k = s;
                case b:
                    var M = r & c;
                    if (k || (k = l), e.size != t.size && !M) return !1;
                    var C = D.get(e);
                    if (C) return C == t;
                    r |= u, D.set(e, t);
                    var x = i(k(e), k(t), r, w, E, D);
                    return D.delete(e), x;
                case v:
                    if (S) return S.call(e) == S.call(t);
            }
            return !1;
        };
    },
    function(e, t, n) {
        var r = n(10).Uint8Array;
        e.exports = r;
    },
    function(e, t) {
        e.exports = function(e) {
            var t = -1, n = Array(e.size);
            return e.forEach(function(e, r) {
                n[++t] = [
                    r,
                    e
                ];
            }), n;
        };
    },
    function(e, t) {
        e.exports = function(e) {
            var t = -1, n = Array(e.size);
            return e.forEach(function(e) {
                n[++t] = e;
            }), n;
        };
    },
    function(e, t, n) {
        var r = n(130), o = 1, a = Object.prototype.hasOwnProperty;
        e.exports = function(e, t, n, i, s, l) {
            var c = n & o, u = r(e), f = u.length;
            if (f != r(t).length && !c) return !1;
            for(var p = f; p--;){
                var d = u[p];
                if (!(c ? d in t : a.call(t, d))) return !1;
            }
            var h = l.get(e);
            if (h && l.get(t)) return h == t;
            var y = !0;
            l.set(e, t), l.set(t, e);
            for(var m = c; ++p < f;){
                var b = e[d = u[p]], g = t[d];
                if (i) var v = c ? i(g, b, d, t, e, l) : i(b, g, d, e, t, l);
                if (!(void 0 === v ? b === g || s(b, g, n, i, l) : v)) {
                    y = !1;
                    break;
                }
                m || (m = "constructor" == d);
            }
            if (y && !m) {
                var O = e.constructor, A = t.constructor;
                O != A && "constructor" in e && "constructor" in t && !("function" == typeof O && O instanceof O && "function" == typeof A && A instanceof A) && (y = !1);
            }
            return l.delete(e), l.delete(t), y;
        };
    },
    function(e, t, n) {
        var r = n(131), o = n(133), a = n(31);
        e.exports = function(e) {
            return r(e, a, o);
        };
    },
    function(e, t, n) {
        var r = n(132), o = n(12);
        e.exports = function(e, t, n) {
            var a = t(e);
            return o(e) ? a : r(a, n(e));
        };
    },
    function(e, t) {
        e.exports = function(e, t) {
            for(var n = -1, r = t.length, o = e.length; ++n < r;)e[o + n] = t[n];
            return e;
        };
    },
    function(e, t, n) {
        var r = n(134), o = n(135), a = Object.prototype.propertyIsEnumerable, i = Object.getOwnPropertySymbols, s = i ? function(e) {
            return null == e ? [] : (e = Object(e), r(i(e), function(t) {
                return a.call(e, t);
            }));
        } : o;
        e.exports = s;
    },
    function(e, t) {
        e.exports = function(e, t) {
            for(var n = -1, r = null == e ? 0 : e.length, o = 0, a = []; ++n < r;){
                var i = e[n];
                t(i, n, e) && (a[o++] = i);
            }
            return a;
        };
    },
    function(e, t) {
        e.exports = function() {
            return [];
        };
    },
    function(e, t, n) {
        var r = n(137), o = n(36), a = n(138), i = n(139), s = n(140), l = n(16), c = n(47), u = c(r), f = c(o), p = c(a), d = c(i), h = c(s), y = l;
        (r && "[object DataView]" != y(new r(new ArrayBuffer(1))) || o && "[object Map]" != y(new o) || a && "[object Promise]" != y(a.resolve()) || i && "[object Set]" != y(new i) || s && "[object WeakMap]" != y(new s)) && (y = function(e) {
            var t = l(e), n = "[object Object]" == t ? e.constructor : void 0, r = n ? c(n) : "";
            if (r) switch(r){
                case u:
                    return "[object DataView]";
                case f:
                    return "[object Map]";
                case p:
                    return "[object Promise]";
                case d:
                    return "[object Set]";
                case h:
                    return "[object WeakMap]";
            }
            return t;
        }), e.exports = y;
    },
    function(e, t, n) {
        var r = n(13)(n(10), "DataView");
        e.exports = r;
    },
    function(e, t, n) {
        var r = n(13)(n(10), "Promise");
        e.exports = r;
    },
    function(e, t, n) {
        var r = n(13)(n(10), "Set");
        e.exports = r;
    },
    function(e, t, n) {
        var r = n(13)(n(10), "WeakMap");
        e.exports = r;
    },
    function(e, t, n) {
        var r = n(55), o = n(31);
        e.exports = function(e) {
            for(var t = o(e), n = t.length; n--;){
                var a = t[n], i = e[a];
                t[n] = [
                    a,
                    i,
                    r(i)
                ];
            }
            return t;
        };
    },
    function(e, t, n) {
        var r = n(53), o = n(143), a = n(149), i = n(38), s = n(55), l = n(56), c = n(27), u = 1, f = 2;
        e.exports = function(e, t) {
            return i(e) && s(t) ? l(c(e), t) : function(n) {
                var i = o(n, e);
                return void 0 === i && i === t ? a(n, e) : r(t, i, u | f);
            };
        };
    },
    function(e, t, n) {
        var r = n(57);
        e.exports = function(e, t, n) {
            var o = null == e ? void 0 : r(e, t);
            return void 0 === o ? n : o;
        };
    },
    function(e, t, n) {
        var r = n(145), o = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, a = /\\(\\)?/g, i = r(function(e) {
            var t = [];
            return 46 === e.charCodeAt(0) && t.push(""), e.replace(o, function(e, n, r, o) {
                t.push(r ? o.replace(a, "$1") : n || e);
            }), t;
        });
        e.exports = i;
    },
    function(e, t, n) {
        var r = n(146), o = 500;
        e.exports = function(e) {
            var t = r(e, function(e) {
                return n.size === o && n.clear(), e;
            }), n = t.cache;
            return t;
        };
    },
    function(e, t, n) {
        var r = n(37), o = "Expected a function";
        function a(e, t) {
            if ("function" != typeof e || null != t && "function" != typeof t) throw new TypeError(o);
            var n = function() {
                var r = arguments, o = t ? t.apply(this, r) : r[0], a = n.cache;
                if (a.has(o)) return a.get(o);
                var i = e.apply(this, r);
                return n.cache = a.set(o, i) || a, i;
            };
            return n.cache = new (a.Cache || r), n;
        }
        a.Cache = r, e.exports = a;
    },
    function(e, t, n) {
        var r = n(20), o = n(148), a = n(12), i = n(26), s = 1 / 0, l = r ? r.prototype : void 0, c = l ? l.toString : void 0;
        e.exports = function e(t) {
            if ("string" == typeof t) return t;
            if (a(t)) return o(t, e) + "";
            if (i(t)) return c ? c.call(t) : "";
            var n = t + "";
            return "0" == n && 1 / t == -s ? "-0" : n;
        };
    },
    function(e, t) {
        e.exports = function(e, t) {
            for(var n = -1, r = null == e ? 0 : e.length, o = Array(r); ++n < r;)o[n] = t(e[n], n, e);
            return o;
        };
    },
    function(e, t, n) {
        var r = n(150), o = n(151);
        e.exports = function(e, t) {
            return null != e && o(e, t, r);
        };
    },
    function(e, t) {
        e.exports = function(e, t) {
            return null != e && t in Object(e);
        };
    },
    function(e, t, n) {
        var r = n(58), o = n(48), a = n(12), i = n(32), s = n(33), l = n(27);
        e.exports = function(e, t, n) {
            for(var c = -1, u = (t = r(t, e)).length, f = !1; ++c < u;){
                var p = l(t[c]);
                if (!(f = null != e && n(e, p))) break;
                e = e[p];
            }
            return f || ++c != u ? f : !!(u = null == e ? 0 : e.length) && s(u) && i(p, u) && (a(e) || o(e));
        };
    },
    function(e, t) {
        e.exports = function(e) {
            return e;
        };
    },
    function(e, t, n) {
        var r = n(154), o = n(155), a = n(38), i = n(27);
        e.exports = function(e) {
            return a(e) ? r(i(e)) : o(e);
        };
    },
    function(e, t) {
        e.exports = function(e) {
            return function(t) {
                return null == t ? void 0 : t[e];
            };
        };
    },
    function(e, t, n) {
        var r = n(57);
        e.exports = function(e) {
            return function(t) {
                return r(t, e);
            };
        };
    },
    function(e, t, n) {
        var r = n(157);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".fcl-datepicker-day-td {\n  border: 1px solid #e5e5e5;\n}\n.fcl-datepicker-day-td:hover {\n  border: 1px double #fa5400;\n}\n.fcl-datepicker-day-td :focus {\n  outline: none;\n  background-color: #87cefa;\n}\n.fcl-datepicker-day-td .day-within-range {\n  background: rgba(250,84,0,0.4);\n  color: #fff;\n}\n.fcl-datepicker-day-td .not-selectable:hover {\n  border: none;\n}\n.fcl-datepicker-day-td .not-selectable :focus {\n  outline: none;\n  background-color: none;\n}\n.fcl-datepicker-day-td .selected-day {\n  background-color: #fa5400;\n}\n.fcl-datepicker-day-style {\n  width: 40px;\n  height: 40px;\n}\n.today {\n  background: #000;\n  -moz-border-radius: 100%;\n  -webkit-border-radius: 100%;\n  border-radius: 100%;\n  color: #fff;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(159);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".u-position-relative {\n  position: relative;\n}\n.input-icon {\n  position: absolute;\n  display: block;\n  top: 8px;\n  right: 8px;\n  width: 16px;\n  height: 16px;\n  z-index: 1;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(161);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".date-colon {\n  display: inline-block;\n  position: relative;\n  top: -16px;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(163);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".datepicker-container {\n  position: relative;\n}\n.datepicker-overlay {\n  position: absolute;\n  background-color: #fff;\n  border: solid 1px;\n  display: flex;\n  width: 304px;\n}\n.datepicker-overlay.range-picker {\n  width: 608px;\n}\n.datepicker-overlay.center-picker {\n  left: 50%;\n  transform: translate(-50%, 0);\n}\n.datepicker-overlay.right-picker {\n  left: 100%;\n  transform: translate(-100%, 0);\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(165), o = 1 / 0, a = 1.7976931348623157e308;
        e.exports = function(e) {
            return e ? (e = r(e)) === o || e === -o ? (e < 0 ? -1 : 1) * a : e == e ? e : 0 : 0 === e ? e : 0;
        };
    },
    function(e, t, n) {
        var r = n(17), o = n(26), a = NaN, i = /^\s+|\s+$/g, s = /^[-+]0x[0-9a-f]+$/i, l = /^0b[01]+$/i, c = /^0o[0-7]+$/i, u = parseInt;
        e.exports = function(e) {
            if ("number" == typeof e) return e;
            if (o(e)) return a;
            if (r(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = r(t) ? t + "" : t;
            }
            if ("string" != typeof e) return 0 === e ? e : +e;
            e = e.replace(i, "");
            var n = l.test(e);
            return n || c.test(e) ? u(e.slice(2), n ? 2 : 8) : s.test(e) ? a : +e;
        };
    },
    function(e, t, n) {
        var r = n(167);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".typeahead-dropdown-container {\n  overflow: visible;\n}\n.typeahead-dropdown-container.disabled {\n  opacity: 0.55;\n}\n.typeahead-dropdown-container.disabled .typeahead-btn {\n  cursor: default;\n}\n.typeahead-dropdown-container .typeahead-input {\n  height: 100%;\n  width: 100%;\n}\n.typeahead-dropdown-container .typeahead-input-container {\n  position: relative;\n}\n.typeahead-dropdown-container .typeahead-btn {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.error.typeahead-dropdown-container .typeahead-btn {\n  box-shadow: inset 0 0 0 1px #fe0000;\n}\n.error.typeahead-dropdown-container .dropdown-btn {\n  box-shadow: inset 0 0 0 1px #fe0000;\n}\n.typeahead-dropdown-container.focus .typeahead-options {\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, 0);\n}\n",
            ""
        ]);
    },
    function(e, t) {
        e.exports = function(e) {
            if (!e.webpackPolyfill) {
                var t = Object.create(e);
                t.children || (t.children = []), Object.defineProperty(t, "loaded", {
                    enumerable: !0,
                    get: function() {
                        return t.l;
                    }
                }), Object.defineProperty(t, "id", {
                    enumerable: !0,
                    get: function() {
                        return t.i;
                    }
                }), Object.defineProperty(t, "exports", {
                    enumerable: !0
                }), t.webpackPolyfill = 1;
            }
            return t;
        };
    },
    function(e, t, n) {
        var r = n(170);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".time-input-container {\n  text-align: center;\n}\n.time-input-container .ncss-input-container {\n  width: 48px;\n}\n",
            ""
        ]);
    },
    function(e, t) {
        e.exports = function(e, t, n) {
            var r = -1, o = e.length;
            t < 0 && (t = -t > o ? 0 : o + t), (n = n > o ? o : n) < 0 && (n += o), o = t > n ? 0 : n - t >>> 0, t >>>= 0;
            for(var a = Array(o); ++r < o;)a[r] = e[r + t];
            return a;
        };
    },
    function(e, t, n) {
        var r = n(35), o = n(51), a = n(32), i = n(17);
        e.exports = function(e, t, n) {
            if (!i(n)) return !1;
            var s = typeof t;
            return !!("number" == s ? o(n) && a(t, n.length) : "string" == s && t in n) && r(n[t], e);
        };
    },
    function(e, t, n) {
        var r = n(174);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".calendar-container {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 224px;\n}\n.calendar-container .calendar-weekdays {\n  border-left: 1px solid #e5e5e5;\n  border-right: 1px solid #e5e5e5;\n}\n.calendar-container .calendar-day {\n  border: 1px solid #e5e5e5;\n}\n.calendar-container .calendar-day.enable:hover {\n  border: 1px double #3498db;\n}\n.calendar-container .calendar-day.enable:active {\n  background-color: #3498db;\n  color: #fff;\n}\n.calendar-container .calendar-day .today {\n  background: #000;\n  -moz-border-radius: 100%;\n  -webkit-border-radius: 100%;\n  border-radius: 100%;\n  color: #fff;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(176);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".hidden-control-container {\n  overflow: hidden;\n  width: 0;\n  height: 0;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(178);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".date-input-container {\n  overflow: visible;\n}\n.date-input-container .placeholder-active:hover {\n  color: #3498db;\n}\n.date-input-container .placeholder-active:active {\n  color: #3498db;\n}\n.date-input-container .date-input-overlay {\n  width: 224px;\n  position: absolute;\n  background-color: #fff;\n  z-index: 1;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(180);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            '.spinner-style {\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n.primary {\n  background-image: url("data:image/gif;base64,R0lGODlhMAAwAOZ/ADw8PJGRkVpaWr+/v29vb+jo6NDQ0Obm5hYWFmNjY1JSUoaGhiwsLIODgykpKaCgoEVFRR4eHnh4eFVVVRkZGYSEhMPDw7GxsWRkZDo6OtLS0iQkJJ6enjc3N6enp3t7e5OTk2dnZ0hISEBAQC4uLjAwMHFxcU9PT5mZmTQ0NLa2tkpKSpycnExMTBoaGkJCQjg4OBwcHICAgNfX119fXxISEiYmJv39/a2trVBQUKysrHZ2dj4+PuHh4aurq8zMzPb29t/f383NzT8/P3Nzc/Pz83JycuLi4sjIyKqqqq+vr3R0dO7u7qioqPT09MDAwMXFxc7Ozs/Pz4+Pj/j4+ODg4Jqamvf398TExPHx8fDw8MbGxnV1ddXV1cfHx+Xl5dzc3I2Nje/v7+Tk5K6urvr6+vX19cvLy1FRUcHBwfLy8nd3d+Pj493d3bKyspubm9TU1Pz8/MrKyqmpqcnJyfv7+zMzM97e3vn5+WhoaImJiezs7Lq6utjY2BEREf///yH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTE0QUZDNTAxRUIxMTFFNTk1NEM5RUNGRUNEREEwQjciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTE0QUZDNTExRUIxMTFFNTk1NEM5RUNGRUNEREEwQjciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NEY0RDAwOTFFQTUxMUU1OTU0QzlFQ0ZFQ0REQTBCNyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NEY0RDAwQTFFQTUxMUU1OTU0QzlFQ0ZFQ0REQTBCNyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PgH//v38+/r5+Pf29fTz8vHw7+7t7Ovq6ejn5uXk4+Lh4N/e3dzb2tnY19bV1NPS0dDPzs3My8rJyMfGxcTDwsHAv769vLu6ubi3trW0s7KxsK+urayrqqmop6alpKOioaCfnp2cm5qZmJeWlZSTkpGQj46NjIuKiYiHhoWEg4KBgH9+fXx7enl4d3Z1dHNycXBvbm1sa2ppaGdmZWRjYmFgX15dXFtaWVhXVlVUU1JRUE9OTUxLSklIR0ZFRENCQUA/Pj08Ozo5ODc2NTQzMjEwLy4tLCsqKSgnJiUkIyIhIB8eHRwbGhkYFxYVFBMSERAPDg0MCwoJCAcGBQQDAgEAACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg1VJCwkTIoaOj5CQUTskfpaXjig/kZyGN0pDl6KWhkwIfgA6N52cSACjoy6GD6IAWKyOVESwCGhTT2OPArBLQLiDQa+iKSxMnVkPHaMAVccaNqIOSavHfziVlxsGrBoRoiZF3YROu5cR45FB2JYUPuqOFxThQZBUyn4RoNx7JMecJQBmHrXzQ0HgQIL6LC1xhESUvYeQLoi6RejGPxMYOS25BICbICWXHKQLCQkIOD84CIWylIQlJzKXeAyKcimFSZuObkiztOnPjkssgHKiJVEQOATOlEJSE5HEnyqX0EjlNOESmCSXpmyNFOCSjwWXnoyFhOVSgwSX/4KtdVTgEoaupOY+upRDhCVZeh0ZFOHXD+DAhVxYEoHXD2JDlybAtST38Z8xlxKgtaTW8p8nlxaAtSTW85RLSbBa0uoZzaVqT6MiNmXJqlGklllc2iGIpyWfiG+kuBRl0Ew/NQOP9jOEEEpLKvUWcXBJScePek2Q/Pmnotm1PkQhcbSw4VYoEf0QeeTPnUObUAyiogJJ3qV6Nn2kt8EvUrlzK91ThHbuaEDOPNBt080NSVB3iQ0G4pLMKMzIBgkTLAxXS3/H6MKLL8AQMsYTU6BxyihE0DeQK7CI4oJiLR40XkifHBdji0MowV1Ik7x0Iwk7FKcXIoowwphmqd0TCAAh+QQJAwB/ACwAAAAAMAAwAAAH/4B/goOEhYM9cwsJaCsQEwkLF4aTlJWEPxIMfpucnRmWoJY3SiOdpp0EoaqFSEOnnS4unA+GUlirhlRcpwgKU2ljgzdfTwWGL34mV7iCPQCmdlZMzB6cGUG4UjadDk03zIIQnRtRqnARqEXgg2Y7nRHllkEbnBQ664ZuFJwbPZVXzzZF8IJv0hl0mzIsm2SkHpSClH7s20RkEpJO9yBSutCJIKEbGTgZ0WiJCCcA3wbh4MRAHUlKZjRtwkEooJ+MLynpODlICqcOKXNOutGB0w9Bazi9EWqJA6cdgkpsQiCGaaUsCDYx+FOFUw6rliZwurNyUwCwlQJwSsTpCVpKWP84NUjA6cvbSQU4JRC7KehdQjU25RDnx8XfSQhbrNhk+HChxGg4Of4Y2E8OupuCTf6TdxOGBZzSbP6TRu4cTlNGq93kowcnBaNzcKryRyaCaY7FZPVTQpAETlYmv+G0RtAPTnb8oiXKScqgUpuaHN65CQAhJZwcuERbRKYfmsJcbUr1tmFC5Rc54WRKfROSSbs2UfAoFMpEPyMnUbEZ4WFOLwj5AcBCk/SwjXzrFaTDfRtgY4kUAeK3HThFEPAOHObQw5IOyoFyQxMOdGKDc6sEYdMmHbxRFShMWGGHKQD4w8wV5nWCQA4BPPFFUGOkMYUCu3XCBRUFIRHSK4zJgqQrH0O8p9ENOJy4pCkjKNEhRFKsIdWUfjAgwVF3VYGDIhNAsAIakMwhIzOBAAAh+QQJAwB/ACwAAAAAMAAwAAAH/4B/goOEhYM9PhUhJy0QCgkLOHeGlJWWg0IfDH6cnZ6cJWsGl6SGN2Qvn6qrC6WuUCOrnRQxsl2ul1c7qgg5YU9scYJ1XwMBOQh+ObiWRxmfKVZMpWJWXsyUUTaeDk032JQqP65wEZ4ETuCUXhQRUaQ9G7M46pQz5n4bQZZAAJ0RdOpREoLPT4YrlZbMCiiQ0hkKnUysq9HJR0NLbjxBMcSjE5GLl3ZxAvBtUEZODNSAtGRmEyd6gzpysrjSko5OIwYZ6NShZE1KN2B0GvdnTScrPy9x6LRGUAlOCMQktZQlmR8Sf+50WjbVkoJObXB0CtDVUoCKCzoNKFvJQqcGCf86fWFLqUAnDF851aFrymoOCJxi8KWEb0ULThQGG8L34kQnYYoHbQ3RiU1kQXY5JajQ6cnlP1je+ugU5vNZTkl6bP08AewflwimKa6KUtCHo5FZMBUkpFMKn2xvdOgkZFAqTk0Gjx5JiEwnB+nYqnHpxw2hG7E4EaBLpBMPQ1A8wZy63E+Na4ZE+qHA8CcdiJyWVLryjBNA9wUBAGm2DTHNizjAl08PpERRkB9EqFSPEwR4EgEc5MjTCQM+AFfKDU044IkN7+DSgz+edGCFVKQwYUUKn2RwBDhALEGRJ70EMMAXe/0RBxtPhIGMKjsgVI8XMskSg4CrjLARSG4EKcsiKi+QYeFFBqzx1JIofVAcXXfgsEACCkDQwgkhVOADgeAEAgAh+QQJAwB/ACwAAAAAMAAwAAAH/4B/goOEhYNBOA0hOS0tChgNZGCGlJWWg0ISJH6cnZ6cJTtSl6SUOCOfqaoASqWlWDyqnRQRspw8W66UZkupCDlhA0dlgmUHAwE5CJ81ErqERwCfKShapVooHZ56z4I/G54MTTfdN3MMfitx3V3gnUZO3YRqH1/dR+5+FDry/YVAQzpFOOOvoKAds34YvBRHzxpKW2p08rHQ0pcVnLAYisWJSEVLMjoBIDdISScGaj5WArKJE79B0jjNUWkJh8hBUjp1IEmTkjZOQg52QtHTEodOXASV4ITAWlFKWShwIvEHTKccTy0p6NSGTKcAWSsF6JSo04CwlNJ0aoCh0wG0hv8KdMKwlRMxuIWutuAUAa+hWn4g7NXntxDgFTk63S18Q6KfEyE6HSksSC4nSGYp/7HQSYZNTmE0g5gY5KrmCZ0mtWxaOConBoIkDC38AKkgIZ1S8EQLoxNBQag4NcH72c8QQsUZxAvrpKWfl4M4+jGClkgnHrv/YPEEvacPTxoN9eJE4TfNH1I5LalkJqafCApVngFsHIglfLMoVtSR3s+GyZd84wkRKfnjhBGebNCFK+2EM0d2pNzQBDqdbBCfK0cE5EkH1VyDQgqfAADgM0Ds4FgnvwQwwAF3lXHEAGEok8oSZhS0hXSqRNCfKjyEt5AS7tmSygg4FCXFDksJ6QcUCRIEhRYYZLClQCM5hNAADkH0EwgAIfkECQMAfwAsAAAAADAAMAAAB/+Af4KDhIWDYGQNIQotLWh5DThthpSVloNCOyV+nJ2enCQSQpeklDhDn6mqIzilpVs8qp0REbKcPBaulEBcNZ8IOQEDY3iCZWwDUycIqUtmuoNHsZ4dKFqlWSgdnwBH0F0bngxNN9B/N00MnhtdruCeREXmhE5E6+2XR+GcFD7zlDoo8FNxyQyAWT/+VTpDywupJZ0onFFoScgMUhY86aDI8c80P0Q6UsTRiYETkQpHdGqC0t0CTJ06lGtpyUsOTqP+SOiEgualB524CCLBCUEWn5aKMPPD4E+bTieQXprQqQ1JTlOkWgrQKUmDTgO0VsrIqUGeTmzEUjrQKQGaTmX/1FLqhKYFpwhyKdXy0+huXkN7WyjoVOyvoBu+/OQI0WmMYUEFOmH4yinsY7J+GpDpFODxHxCdfIDplMMzVU6TNvlBcO1vlqVN/+zgaRgopx2ChMScqfZGhk4TBaHixFLuVT88CB1nIE+sGXWcWhH6GFIsl04ZeAvaktiPP6kXPG2hdJ1fQp9yBHIyUQnIxwjBUf7Y6yfDFUv6Im4U6UO9HxtVkPJOJ0ScpFAR9swShTv7cDKOdqWgAx0nGxgAzREHUYPCUaRooc0nPHhjjhkQ/XLCFAOwEdcfeIwxQAA5LNVJDVwAQZEFH6lCiy3IjScSDirxqMoQ0tEkhARECVnCDw45iWWVWXUJFoJmYPwTCAAh+QQJAwB/ACwAAAAAMAAwAAAH/4B/goOEhYNgOA0YCiItJyENOD2GlJWWg1I7JX6cnZ6cDB8/l6SUbjyfqaovODelpEioqpwRFLOcI1ivlEBcNZ8IOQEDBWWCdUdPYTkIqTtAu4M9AJ8dVlqlTCgpnxmTu10bngw+rtE3TQyeNkKvQhGeRGrRhU4EnhFdpD02nRQ+9CrpsMVpwzdeGTpFGBWwkhx4nABAo7TDn5yGl34Q9MOFEhZPOjCS8tGpBpJCN0Z0IiCyFBFOL6QUwtGJgZOWpNRA8EDpRacmOEX+6JTCXNCAHzqhOIpRnR8ETJgG7NEph9SANDmFuUqqwAMCGRJ1esL1koVOMkJ0OlLWUoFOCf9OdKrTttKNX35ytOBEoa4liC1E0PJbCSIEBZ2MES7UCQ2GTgUWEzoAt0GnAZIHneW0IKufAJkFBeiUBEzV0H8mdAryZ9NTbJKzNPPDQFBFTlYyc+i0RpCUTh2M1r3RoVM7QbL8ACTsmQchNzXn1QXi1A+OQsmJ+L3tB4DwP0jwKm8LvZMuQ1z8MZT6w0Un7byo0brI9GGnDBMp9RDHN2TQCxttUAUpXUDECQE3YeQEd35EIFMpQvRTUxPfkXKDD9X5sUEU0fSQkCcpoBAVKVpYUZwnGbBGDxAMchJMGE8cQdcfZRQwQADMpGLEFSJhodItFBioCg9eBHUDDj7dMgscD25w9cMHGc5Swg4P1tVDIiGcEJgCGEQCRkOBAAAh+QQJAwB/ACwAAAAAMAAwAAAH/4B/goOEhYNBOAsJChArORgLST2GlJWWgwYSJX6cnZ6cDB8/l6SUSgCfqaovSjelpF48qp0xLrOcQ1CvlFdGqRQ5AU9fcYI3bGlhOQipO1S7h6ieHVZipUxvKZ8Zk7twG54MOq7QNx4OnjZRr1ERnkRF0IVOBJ4RcKQ9Np0UOvKVOCh02hDEEpUMnSJs+WcJiTtOAK5U2sEPCcNLWwRyMkIJiiccF0np8OSl0I0hnQiELEWkE49CSjo5cLKSVBEGnZQQetHJQ81SIyEO+tEpBbmflm506GRA0IdOb5CWssIJgRVBOP0gYCKVlBgBD7j+6dEpR9d/STqFOStvQac0bP+hYejEJu6uHJ2O2r20gpOLvaScFIHAKQbgSg8hKOhU7HChGpxaJOj0xTGhAp0SuOX0xPIgLJ1k4OgUwLMgEJ2SBClr+s9iTmD+bPJDwZrlLBpJCJLQ6aplDp12CDLQqYPevUs5CRkkzY+/w0H9jCAUE1S8vU5IdAJJSBYnIoCXuDzuxdNzthc8YaHkixOFhWflaPSzpNKV5hEsSv3x0E9ES0GA4x53NV1gCycEkQJHf34QQNNFQFCUkBTs7COTB8eRcgMZ2g1E4S49IORJCm+IdYkWHCTXCQAFyUOFhJ4gkEMYabBBThxfPBFADvN1soQZIUGB0i0uxHCLfxb8dIMjEjwdqcoQOGS40g8fZHVkCRIsB1gPSSyAQQ4rKKYZDi3KEwgAIfkECQMAfwAsAAAAADAAMAAAB/+Af4KDhIWDVToLCRMiIgoJC0k9hpSVloNROyV+nJ2enCQSQpekhjc4Q5+qq0NKN6WkSBmrnS4utJw8SLCUVEaqCDlTT1+EY2lTCgiqS1S8g0EAnx1vYqVMLHafAFXPGjaeDj6vzzdJDp42BrAGEZ5GRc+FRQSeERqkVeCcFDrylToodLIRxBIVaZwiQPlnaYs7TgCcUVrSicIWhpegCORkhBIST/4wXtLhaRehGzw6ERBZ6henDOQEKenkIB7LS0XQccJBKBWnJDdL+eg0ZJCQTnZiBq10o0OnKIIkdGKxtNSbTjsEkeCEgElVUmKW+Snxp0cnBV9L5ehUJUmnKWn/SU3plKhTmriXnnRS1GkMXksHGECg4UFBp7+8RHBygRiWYj+MG5OacFjypQSdilmutKDTk80A34IW9IDGFAtUqnTKMfoPZU5t/mzyg8Da5ixiGQja0ekN6AdYBUXp1EHp3xuzONEZ5NOPD8s4OvEgFJ1TzcZmGHTiOQh5p46IKUI0/pHu3wueLhpy6YfCwrRyNvoBb+hgpwjql5556CfDFUtB7NNeSDddIJ8N3VyiAX9+EGATQ0BwYQ9UpRggoB8OJGEcKTfooF0nG4zCSxUIIcWCV6Rk8YBTnmQwiTxUiOcJAgpMkYZfgxyARQATiPXOfxghkRIutuDS33ss3aBEH3NGboPDhiwJIcFWTTKwwxmS9ZCEIgo0MgEkSRT0TyAAIfkECQMAfwAsAAAAADAAMAAAB/+Af4KDhIWDPUkLCQoiIhMJCzpVhpSVloNCEiR+nJ2enCU7UZekhjdKQ5+qq0M4N6WkSDyrnS4utJwZSLCUVEuqCApTaWOEX09TOQiqRlS8g1UAn3YsTKVibx2fAEHPBjaeDkmvzzc+Dp42GrAaEZ4ERc+FRUaeEQakQeCcFDrylToodLIxqRIVaZwibPlnCYo7TgCcUarHDwrDS1sEclpCCYknfxcv6fC0i9CNDJ2MhCxFoBMPcoJwdHIQb+WlIug4KSGUipMPm6WSdBoyKEqnDjCBVrphp5MQQTs6vVFaikUnCYJKcEIghiopJsv8kPhTpVMOr6UUdOoxktMUtKT/pnRK1OkJ3EtpOinq9OWupTGdEkzo5PdSJ0acXBS2dMtPo8SLKzUWoZZTZEqdHnUqdnnQDQ18HlxY0ClN50pC3Z6m1OPwakqb/CCw9pqQhE4sahMS0slOUr83aMzBU6innySX2zrwQEjJzJp+gTDohMPkLE4EFnPplOG3x04g4V7whIXSL34L0f7Q6EdlL4R+IlikKuehnwxALFXZ56efUiXsbdADKQbY1x50/zgRVScRSMEOf3444MNvpegQGyc2jMJLEPBx0sEbXZGSxQMwfJJBN/JQQZEnCOQwxRN9CXJDARaAMEFYnhhxRUhIoIRLBBHgqAoA8610Aw7G4aJKHisUrhTFDlop6QcDO8gRWRU6KMJICzlg0IAPYDAUCAAh+QQJAwB/ACwAAAAAMAAwAAAH/4B/goOEhYM9SQsYOSsQCgkLOEGGlJWWgz8fDH6cnZ6cJRIGl6SGN0ovn6qrAEqlpVBDq50uMbOcPF6vlFQ7qgg5YWlsN4JxX08BORSqRle7hxmfKW9MpWJWHZ8Ak7tRNp4OHsXQNzqbnRtwr3ARngRO0IVFRJ4RUaRBG50UOPKVOphxstHD0hUAnSIg+WdpiztOGahUMsJvC8NLSAT62UHJiycdF0nh8ATFEI9OREKWItBpCDlBSjoxKKKSlBMHnVwNQsgJZE1SHjq9GGSgU4eXPyvdSNHphyAJnawkLfWm0wdBJThREDOVFBMEnBj8CdIpR9dSOTr1GMkpwFlSYf86Jer05O2lNJ0WJOj0xa4lNp0wKOgUx6/SshA4xTBsyQWnFSs4uWBcyZYfCGk5IaX8J04nBRg6seFM6EsnSJ3SkB70JG+STmFWCwrQCUePsrL/ZPYzCR0Ca6t9CEBQQtCHTm9y/8ky6s+PTik2507FyYNyQjE5OYh3/c8NWZwIMM5yCYonf3YvRCBzyZfWhWfPCCQApBIVaZwiWJx65qEfAGZY0gM4WvlU0wUabdAGKVH45wcRNF3kRD0JScHOPjLpIN0l5qDDyQYW7hIET0ZZwRUpWXCgjSfc/HMFRZ9QoAAIaRTwUgFYBKCARp0sUd9FXpw0CwIROKgKACX9pAQmibeoMgQOG4ZkwBokNMkJCTsIQRkYODSAwQkiQHBCAg0kseA/gQAAIfkECQMAfwAsAAAAADAAMAAAB/+Af4KDhIWDPTgNISctIgoYDThghpSVloM/Hwx+nJ2enCU7Upekhjc4L5+qqzxupaVYI6udFBGznDxIr5RAO6oIOWFPR3WCZQUDATkInzVcQLuHGZ8pKEylWlYdnwA90UI2ngxNN9F/Nz6bnRtdr122nQRO5oRqRJ4RQqQ9G7Q69JR8UOhkw1slIAA6RZADsNIPeH4yQKPEhdaPhpbkDOS0gxKSGp18YLykwxMWQzw6ERlJikCnEeUGuenEQA3LS07U+cFBKCUnkTcvNen0YpCUTh1iBq10I0Wni398cbKylBSKTh8EleCEQEvVS0yY+WHwB0ynHF9J5eiEqFOAtJf/wnRK1GkAXEtPOjXA0KnA3UpHOoVQ0KnMX0p1Op0QwSnC4UobW7TgROExJXgiTnQqZnlQmU4KQnQ60nlQgU6QOj0pLWiAXhydwrD+E2Buj7Oz13KapA7Btc5axJYQ9KETitJWOnX886NTCqV/b2zjNEpQKk5NLPvoxIMQbE4M5h3uo9vVoBuyOBHorIKGISye/s0mJNUPBYbzBQGZ1hhq0DjR9BAOZUCxdEEKbHwDkR9E2NQQEBX5kcIe0XTRD006QFfKDTro5IcA5vSQkCcdcJBFKVmwMF0nGVRBD4QgeYLABCBY4JdpFgSggFieGDERQEj4tEoNESyoCgAnsXRKI3q3rAIADhqydMYOHs7CwBr6HNZGEw0kkINkaCRQQRJBABQIACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg204DXloLS0KIQ1kYIaUlZaDQhIkfpydnpwlO0KXpJQ4I5+pqkM4paUWPKqdERGynDxbrpRmS6kIJ1MDbGWCeGMDATkInzVcQLqDRwCfHShZpVooHZ88R9BdG54MTTfQfzdNDJ4bXa7gnkRO5oRFROvtl0fhnBQ685Q+KHTa4K0SkFicIpz5V+lHLU4AzFTi0onCD4aWzgjktITSlhqdfGC8pMOTBUMI/RAZScrerUI4OjEowvKSE3WcWg0a0qlJTVJNOo3A1KlDuZ+WbmzjNOrPjk4okJJC0UmCoBKcEGiReinLMj8k/oDplIMrqROd2pDpFMDspSmd/xJ1GuDW0oBODUJ0GlO3EptOeRR0wtOXUplOjBIWrvSwkeLFhhqj6UQM8iA8nRTk6cTG8qAxnSDN9SzoLqcGMTlNIf0nQCcybTqdYJ2j06RNfhBcs6zlawlBEqB6pspphyAhRY8WVtqp6R9UnHwuDsppCKHUfhjI61sEpx+dg1Ku7OvSDw9DFjz5c+ujU41chnrxW8g1TopOXCqZmZbwItcj9/HwTCX6VKSEWXsIUJAl73SyxICs/dEgJwyQoZwuOPQxUg8ZUPOAGqVk8UCHZY0EhHyeUDBBAFgcMEgcBVgQwARfcaJCTVjwJwstIMkiwE834KCjLanwoMOFNf2whBl3tjCwAx2LtZFEAwmgIUILOWBQgQ9t/BMIACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg2BkDRgKLS05IQ04QYaUlZaDUjslfpydnpwkEkKXpJRKAJ+pqiM4paVbPKqdERSynDxYrpRAOzWfCDkBAwdlgmVHA2E5CKlLZrqDR0OfHShapVooKZ8AR9BdG54MczfQfzdNDJ4bP64/4Z1EauaETkbrXaRH8H4UPvSUdNTitMFbJTOoOEVoB5DSmQidhgCptKQThTMNLf0Y6GcHJSyedGS85KNTjS2GYnEyMpIUkU48CuHoxMBJy0tq1HFSQmhEpyY3Sc3pBGCQkE4pygW1dKNDJymCJHRCsZQUik4e/5DghOBaVUtamPkp8SdIpxxfSeXoBGYmpzBp/y8F6JSo04C4lgZ0ahCik0G8hg50wrCWUzHAhsp0YsSJAuJKEP00UviY0sAWCjodrmzsLIZOBzhH6wTJrmhBejk1INMpwOk/YTrhAHP2dWE/kzb56So6LChBO6aKvspJgiApnTooRXxjG6dRghL6mVO5SacRhJTQnAfYiU4/rQip9EME8b1bhrb42olXh6dchoI3lpP2DMcllYBIj0B/6Y/IfgDwTCVB8EOBG0H5wFFBpBgAoB9rDNiQFgCy44oU/PhBAhkjsebHBvnoEoR0nMDwQBYNETDEX7oAcZ4nCCgQQBoFLFcAFiBM8E8hQEzUkAUkphLBg34IENcNOkxjyxwvKOL1ww5bLalhFJW1pcgJIohwAgYyJAEGQIEAACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg3c4CwkKEC0nIRU+PYaUlZaDBmslfpydnpwMH0KXpJRuPJ+pqi9kN6WkXqiqnDEUs5wjUK+UQEs1nwg5AQNfdYJxbE9hOQipO1e7gz0Anx1WYqVMVimfGUfRcBueDD6u0TdNDp42Ua9REZ5EatGFTgSeEXCkRzadFD70KuGwxWnDpEpXMnSKQCegJTrwOAEAUmmHv4YOHxL0s4QSFE84MpLy0amGl0I3RnQiILIUkU48CpHp5MBJS1JqGHRyQ+hFpyY3S5HkFFOQkE4pzAW1dKNDJwOCPnSysrSUlU5rBOn0g4BJVVJimvkp8adHpxxfS+XodGeonzBp/0kF6ISjQqcncS8N6LQgRCc2eS196ZTgRKc4gSvV6aSgBScKiS3F4AQBAq3IlQi2UNDJGGZCcTqdSNDpy2dCbDqFWNBpwOlBTzpVwNEpwGtBYTr5uHP29p+1nCZt4ortNBOxDAStmfr6KqcPggx06qA08Q1unEYJkuVHx+cmnV4Qog2KYmIn6jiRIXSDGicuke/hqv7Hiyeeeclz0mXo5eMfcdGx0Q4IKcRJBGd8BVEnGUBTSRXiPHbBUj5sZMM3l/wQ0XtmiKSGfwe2U4oQEYKiA32k3ODDVgXps0sVBk7HQRa70PAJAAdFc4UJqSAwQQAWFIDiIHOUtIR5Dm3hnjEqNUQAjwaF4KEODyfddAMOQ9zCCR+GeIDfV2fswOInD/j2RxtJNJBADi28kMOEIgUCACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg1U4CwkTECtoCQtzPYaUlZaDUmslfpydnpwMEj+XpIY3OACfqqsjSjelpEgZq50uLrScQ0iwlFdGqgg5AU9fr4JjaVMKCKpcVLyDQameHW9ipUxWdp8Ak7xwG54MOsa8N00OnjZSsFIRnkZF0IVFBJ4RcKQ9Np0UOvOVdFDotCGIJSrT/ESAAtCSl3ecAFypxKWfl4aXoAzkZIQSEk//MF7S4WkXoRtDOhEQWeoXpwzl/ijp5EAey0tFGHTCQWhEpyY3S5GMOOhHJzsxg1K60aETuz8SOllRWupNpzWCdPpBwIQqKTHM/JT406OTAq+lcnSqMqfTFLSk/wLsXNApDdxLTzop6jTmrqUvnRKg6eTX0o1OE1ZwclHY0i0/ECAsblzp8YoJnZJS/tPpUacvmwmNCUyX05PQg9LoxdEpAGpBUzrNuWP29R8FnSaR4IQgC2omYRkIWtPpAWornSQIMvoy9I1tnEYJSsmJJ+UmnUYQGuqHhJnGRdJxUnIy4Y7G9nIlteDJjV/ufkwWcumHghy4Xjb64VLpyixOEUinFBQQ+QHAM5UEEQ4nFFyglECd2OCNJVEU6McSQIhUBH0KPUWKAQuC4oNml9ygg1acbJAPLz0kxEkHHPj21RtNeQKAQfMAsQQwEwQARQGGPJBDWPBMhBEULopjCCsNqmQgn0inJAmZIbF1AgAOJIokxA4o0mAIeyWs4aFfbTTRgAeGUFFFQ4EAACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg1VJCwkTIiITCQtJVYaUlZaDUTskfpydnpwkO1GXpIY3SkOfqqtDSjelpEgAq50uLrScAEiwlFREqghoU09jhGNPU2gIqkRUvINBs54pLEylTCwpnwBBzxo2ng5Jr883SQ6eNhqwGhGeJkXPhUUmnhHrl0HgnBQ+8pU+KHSy0a0SFWl+IkD5ZwmKu1zOKP3it5BhQ4GciFBC4smfxUs+PO0idAOhiY+l6uUiJ0hJJwfxUF4qgo6TEkKpOCWRWSpJpyGYOqVgybPSDW2cRv3Z0YlF0VIsOu0QtMkPAmtPLzFZ5ofEnyqd0GQthaYTok5TxpKa0ilRpydq/y896aSoU7G4lcZ0WtQJ76VOjDi58Gvplp9GnCIQrmRYRI6+iw0BxtCpQGRjext0wnJ50FxOC0JyCtBZEFudYACX/lOW06SqFNR03gpK0JJODzpH5TT1z49OHYjiPdpJ6R8enchE9skJ6CAcnUgAIUyz081BJTstIazSDwDhWDxdwCua08hCt/nJUQsFox+NlMwgjLD+qcNOACJSCrKhE4XxPAU0UEGWGPBQRk58RI89+JBiQH/R4fCPOTVxos4zVSDESQcPZHFNNtsQyAsQ6XkiQF7IKMOMfv9goWFuhKhhGC268HSDDrNcVYgWuLQinEw/oGAIj5+EYtxlRTgCiQQkDAUCACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFgz1zCwloKxATCQs4VYaUlZaDPxIMfpydnpwla1KXpIY3SiOfqqsAODelpEhDq50uLrScGUiwlFRcqggKU2ljgzdfTwE5CKpGV7yHAJ92VkylYm8dnwBB0FI2ng5Nr9A3OpudG3CwcBGeBEXQhUVGnhGjl0EbnRQ68pU6KHSy0cPSFWmcInj5ZwmKO04AqFSqx4kCFIaXvAjkxIUSEk/+MF7S4WkXoRsZOhkRWYpApyHkBOHoxCAey0tFHHRSQgihn5A3LzXpNGKQlE4dYgatdMNOpx+C1nR6s7SUlU4SBJXghEBMVVJMmPlh8KdKpxxfSyno1MNHpwBp/0lN6TSnQac0cS+l6bQAQ6cCeS2N6ZQgB6caSgMX6oSmRULFlm75WeHYTwTIlSRDMOynBmZTnR79/UzoC2G7nLCQHvSE75y3qwUF6ITjTujYfzj7mYQOQZbVYsSWELSjE4fVbzqtEfQDaeK8N7RxwvfHJ1DFJCESmsmJgRnIRdD5wXHSJxHIFP1kSOzF04XA2TmZLESEH9S0UDb6WUnpSsqEZ3zlxUN+APBMJT3sU5EbSwWUTjeXREGgHzt8h1ERLnUSwTqlRKEgJxAwdEMTOg1EXSlB/OeHB/IwYYVTngBQkDxXmODHC4YU8MQXMY2RxhQKiOUJFxJhhMWJgjxQiyRktAwxX1oZ4sLJCEo8V5WKqzAgwX2QXaDIBBCsgAYkc8woTyAAIfkECQMAfwAsAAAAADAAMAAAB/+Af4KDhIWDPT4VISctEAoJCzh3hpSVloNCHwx+nJ2enCVrBpekhjdkL5+qqzxupaVQI6udFDGznDxer5RXO6oIOWFPbHGCdV8DATkInzVLQLuDRxmfKVZMpWJWHZ8APdFRNp4OTTfRfzc+m50bcK9wEZ4ETueEakSeEVGkPRu0OPUo+aDQycYRS0AAdIpAJ2AlOvE4ZbhSaQmthg4fEuS0g5KXGp18ZLyEwxMUQzw6ERlJikCnEeYGuenEQA3LS04cdCJDSCEnkTcvNen0AlOnDjGDVrqRopMQQWs6sVBKykqnD4LWIchC9RITZn4Y/GnTaUJXUjk69UjSKcDZS2H/QjbohOWtpSedKiToVMBuJTadQqTl5LdSnE4nUvmJULjSxhYrODFubMiWHwiDESSl/KdOJwUY+HIe9KVTgrmcLIwWNKDTAh9tV/8J0AkHWU4KZA/2M4kEp62jxYAtAbUTh9FWOa0R9KMTjM12b3DjNEqQLE46KMPGRagkJwZmCqtZ58fVoBs+/XT0i497ISiezJ/d7qeGLkMmaJ05S2ejnyWVXEGNZE8pBVEnAEBTSRD+LDaDUjj4t8E3l0QRAQX3seSESwu5U8oPKtx0QxM6FbTPSF5YIUYpTFjRlCcZHMRSWsAEMMAXdQgSBxtPhLGMKjtQxFIXs8Tg3yojnBTUJAK33PICGdCxZMAaJTT53QcF+nUHDgskoAAELZwQQgU+UHhOIAAh+QQJAwB/ACwAAAAAMAAwAAAH/4B/goOEhYNBOA0hOS0tChgNZGCGlJWWg0ISJH6cnZ6cJTtSl6SUOCOfqaoASqWlWDyqnRQRspw8W66UZkupCDlhA0dlgmUHAwE5CJ81O0C6g0cAnykoWqVaKB2fQ0fQPxueDE030H83cwyeG12uXeGdRk7mhGpE6z+kR/B+FDr0lHxQ6LTBWyUgQzpFOAOw0o9anACYqdSLE4V8DSudGchpCSUsnnxkvKTDE5ZCN2JxIjKSlJFOPAqV5ERiXktLTtRxwkEo4c6bpJp0GjHoTCcYQEndSNFJiCAunR4kJYWikwRBOilkmXpJyzI/JP6A6TSBK6kcnYL46ATC7KUwnf9wyOhkwa2lAZ0aYOhUwG6lI51CnOBUo5xfQ2U65VjBKcLhShxbQGj8mBLEFmg5VS6UmNMjvpsHHegEqVOa0ILwcmqAo1MA1H8CdCLTppMC2Jn9TNrUb+tmr6CeduIQuiqnHYKEdOqw+cY2TqMETfv5eE4nAIRmgn3mV41OP60G3ZjuR8bhe7cMgfSz4ovftYRzGVqjJ47fHxz9IIct6AxEP0NwB5sO+RVkzhcfqJGREy8R1A40cTDGwByG6XJDE9/5sQFG0OjhSQfWYIMCU54AYJA5EtTwyS8BDHAAMX+UccQAYSiTyhITNbSFSrJEkJ8qPJx0kxLk2ZLKCDxxJcUXDiUYSZMETh0GBhl6KdBIDiGwFgRAgQAAIfkECQMAfwAsAAAAADAAMAAAB/+Af4KDhIWDYGQNIQotLWh5DThthpSVloNCOyV+nJ2enCQSQpeklDhDn6mqIzilpVs8qp0REbKcPBaulEBcNZ8IOQEDY3iCZWwDUycIqUtmuoNHsZ4dKFqlWSgdnwBH0AYbngxNN9B/N00MnhtdrlG1nURF5oROROvtl1U2nRQ+9JR0UOi0wVulKxlm/QBY6Qw8PzyAVDLRTw5DSz8GcuJCaYunCxcv+ehUY0uhGwk3hiR171YhHJ0YSFxpqYg6Tq0GTfOTk6alJp2GDDrTKUM5n5ZubOM06s+OTg+QkkLRaYegmwiySL2khZmfEn/adJqwlVSOTmBGcgJR9lKATon/OuVqW2lApwYYOhWgW2lMpxBn/dQ4yrcQnk6MOEUoXAleI8WMKTlG0ylyoTKd0CTodMDyIDadIMn1LMgupwZJOgUg/WdKJ0ljWZ/oNAnrPMtZvJIQxAWqZ6qcJAgSwimHF8tKOzX9syCfZaCcRrCud5Pn9EEtIV4XpMPTXEszliM9o9HPElJeaJ2R+uMhgGeWVGikoMOnj/IFSXUJF8/JxSLZ+cGOK/uJQ4456FQnoHOlHAHAJ9VoRYoW2nzCg0HQmLFEKgicMMUAbJQhCB5jDBBADl6RxMVMAFmwkyq02AKRSTThMIKMsgzRE1JCSEACjl/tIF5bbeDQQB5oNKJACAgNkAEGQIEAACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg2A4DRgKIi0nIQ04PYaUlZaDUjslfpydnpwMHz+XpJRuPJ+pqi84N6WkXqiqnBEUs5wjWK+UV0apCDkBAwVlgnVHT2E5CKk7QLuDQRmfHVZapUwoKZ8Zk7tRG54MPq7QN00MnjZCr1IRnjtO0IVOBJ4RXaRV4ZwUF/OVdNjitMEbJSDTaMkBaEnOO04AnlEi0snFKIaWfgz0w4USFk9uMJLy0akGkkI3AHTaIbIURU48CuHoxEBiS0tq0nEKOUiWHxw3S5GEOUhIpw7lglq60aGTFEFrOnFQWsrKSkE6EWShSkoLMz8l/gTpNIFrqRydwCTpFMAsqQCd/3As6GTB7aUBnRok6HTArqUCnTCg6eTXUplOCiDQKmzpYaPFjCkNbIHWT42kkY11OrGXU4HMhI50CiGDLuhBT/LiyEDgwefTf8LEhW2osh+DtP8w+cogNyEUnT74FnRjG6eLvpt0ekHJAwQ1jJ3o/FlIygtORBjbw4X5D5IanXz41eFJlyEunSggpypnI8uDKhVy/fHQTwabhnrw80NBh1IfG9mAGyVd1OcHAfJgpMZLtLBTihA2iNNEd6Tc4MN0fmyQzy49JNRJCigwUYoWVjTlCQADlgLEDr/kEMYTR9QhSBkFDBDAMp/UwAV+82Axwi38GZgKDyfddAMO1wGpChwPPM33AYazlLDDU4z1kEgIJ7QgggIYRAIGQ4EAACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg0E4CwkKECs5GAtJPYaUlZaDQhIlfpydnpwMHz+XpIY3OEOfqqsvSjelpBYAq50xLrScQ1CwlGZLqhQ5AU9fcYI3bGlhOQiqO1S8h7OeHRxapUxvKZ8Zk7xSG54kZK/RNx4OnjZRsFIRnjtA0YVOBJ4RcKRB4ZwuF/OVcFDotCGIpSvT/EQYBbASknecAFyp9IsTBTkNL20ZyMkIJSye/mW8pMOTl0I3eHRaMrIUkU48CuHoRMJJS1JFGHRSQmhEJx03S5WMiKlTh6ClbnToZEDQjk4ckJay0kmCIBIWs0glJYZjiT9gOinYWipHpyBJOoEgSypAJxwy/zphYXvpSSdFnQrQtfSlU4IWnGrstRRHLAROEQZbisEJQhEzii/d8rMi8qUbnXJYtsSmE4bNldLcBU0pTKckpA2Z5eSNyQMBYkAzaeaHgSArtK2AftPpgyADRsspvrGNE8M/CYFG9tDpBSElnRgUUewkHSeehFRyIqLYXi7hgrx4Us52Zqddhox0orCFLRKOfnZUQtgpApKtWyD6yQCt0r71OCClA3w2eGMJHPr5QYBNGRXxUn3slBKFDZ444AF4SemgE0H58NJDBp+k8AYTpYhhxVKeAGDQPFQ89QkCOYSRBhvlxPHFEwHkAF8nRkyUERSp4OICY7jwcNJNNyjxAiIuuACA3VY/fLAhkyVI0JRiPSSxAAY5rACBAgksgMOK8wQCACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg0FJCwkTIiIKCQtJPYaUlZaDZzsMfpydnpwkEkKXpIY3OACfqqtDSjelpFAZq50uLrScPEiwlFdGqggTAVgHhGNpUwoIqktUvIM9s54dD1mlTCx2nwBVz0Ibngw6r883SQ6eNgawURGeXEDPhUUEnhEapFU2nRQX8pU6KHSyEcTSFWl+Ipz5Z2mLO04AnFH6xYmCHIaXoAjkZITSFk/+MF7S4WkXoRupOC0RWYqinwzkBOHoxMAMS1JF0HHCQYhHJ543SfnoNGQQnU4wg5K60aFTFEE7Oj1QWupNpx2CNvlBYI3qJTHL/JT406bTBK+lcnSqQsXCFBpT/9FemtJJh9xnTzotuMvrS6cEfHmZDQzrlh8RhEsZRpz4UicFHmhAYFCs8aAxfxd0emJ5UBq9JDlN6SyILqckVTrlIP1HQadJJTghENOZSVgSUDu96cyikwRBUTp1iBn4hjZOowQN6eSjcRKihGZyclCEcM5OSk4i7Bi4Xi7if5B4sns3NCeThVxSgCJ3y0Y/KylRSZlwi1coD/1EtBRkX0XyNwU0UDeXaJCfHwRUh1ERLiW0TikG+DddEuAt5YNOnNiADy9V0MeJHSwwUYoYbzTlCQAFyUPFEsAoMEUaYxDyxRNT5BCWJ0ZIxBASPuFiCy4voSfSDUosByQrOFTIkhgQEpBwpFg7PEVYD4kkoEAjE0CiA4HyBAIAIfkECQMAfwAsAAAAADAAMAAAB/+Af4KDhIWDYD4NGDktIgoJCzpVhpSVloNyOwx+nJ2enCU7UZekhjc4Q5+qq0M4N6WkUACrnAgREbScGUiwlFdGqggTIBYFr4JfT1M5CKpGVL2DQRmfMA9ZpWJvHZ8AQdFRNp4kOtGCNz4OnjYasFK4nTtO5oRFwJ0RBqQ9G50USvQo6aDQycakSkCocYogJ2AlKPD8AIBG6Z4fCj8cWtpCkNMSSlg8XdB4SYcnXoRuKPTDhSQpAp14HBOEoxMDIC4vFVHHCeAgDzzL5byUpNOQQnjm0Jg5lNINO52ENA3IopOEqfSYNPNDAis9BZ16eI02pVOSsb3SdFpw4QEfDUz/0RIa0ynBhE5yLXVSIIKTi7yVXHAS0dfPX8CGBPtxhBdxoU4TEnQa43jQl7oLOqWpLOjJ2qKcpnD+U5aTjh57R+foNIlELSaVxWwtIUhCJxaV38QTJKSTnbhjb3DjNEpQKk5nAfswSkhJJwdF8u7shCMlj04E8lrMEBeJJ6FeTXZCWWiJvy1eoXT0Y6QSlVkLoUzdEnGipSriOFEAT3JgwW+XGBARe9E5VARM+LRTigb5ceKAD8BdckMSPHFigz69BAFfJx28IUYpTLAAlScAHBQNFRZ1gkAOUzzxxVxpTKHAVp4sQVFASKy0iguK0cIDeRqdclwurCgRoUZR7FACFZGckCCBVHlVocMCdhH2yAJJiEVPIAAh+QQJAwB/ACwAAAAAMAAwAAAH/4B/goOEhYNtSQ0JJxAiJxgNOGCGlJWWg0I7JH6cnZ6cJGsGl6SGNzhDn6qrAEqlpVAAq50REQizfjxer5RAS6oUCgFYBYM3BWkgChSqRle8g0Gynh0cWaViVh2fAEHQUhueDDo30H83OgyeG3CvUhGeRE7mhEVEnhFRpG3hnBQX9CjpYMbJRg9LZqb5iXAmYKUt8DhloFIJCAF/DR1WQkLQz45LZCIA1GgJhycol66RvHSR05ByKx06cdDJVUyHHjq9uOnwRopOPwQZUMmz1JtOHwSVQCDAR1FSTG75YfAnSKccT0nl6NTDJKcAWS+F6ZRkQacnYS2l6bQgQacvaf8rsemEQUGnOHEp3bgKgVOMvJVccFqxgpMLwJRicIKwlRNMxILidFKAoRMbyIO+dEpgllMazIKesE3SKQzoPwE64ehx9XRjP97U+UHABLMYgiUEfej0BrOVThIE/eiU4nHcG9s4jRL0opMHxDo6ASCkpJODeXGLyPZjU9CNVJwI5L3HiYchKJ5wpI3eaZehHZ0oIMm6paORSlQy0NpSFElEPwA8U0kPNsSnw004dLSBN5dE8Z8fRBShkRMtcRJBO6XA0Q8n4xhXyg0e0NSJDfrwIs0nHVghRilMvPGTJxkcZM4VRgCTQwBPfIHXOWykEUYOUnmyA0UOecEDLn7EIBgpLkOgFJMSCiH5yQtKeLiSARKUIOVUHwSVVxA4tKUABCvkgMECSchoTiAAIfkECQMAfwAsAAAAADAAMAAAB/+Af4KDhIWDQUkVCWgtLTkJDU1thpSVloNCawx+nJ2enAw7Z5ekhjc4AJ+qqyM4N6WkWKmrnBERNbR+PEiwlEBGqggKARYFhAUWIBMInzVcQL2DVRmfHSxZpVkcHZ8APdF/Ap4MOq/RNzqbnRtd0XspnM/ghGpEnhFC0WwpF/OUPhQ62fjWK46/Sj8idMoA7aBDQXICctrxsKIOT1gM0VBRERaBTiPMCXLDKUefjpecqPODgxCPTj5QXmrS6cUgKZ06iJRpCh6nH4J2dLLC8xKKTh8EleCEQEtRS0yY+WHwB0ynHE8v5ejUA0enAFkthemEo0GnAWErPenUAEMnY2n/DR3pFEJBpzJxDdXpdEJErbyUJDbiRAGwIYV+RJzoVMfwoDKdFITodMSxoAKdMJjl9MTynwFsvXIK4zkA2R5XPW/lBOaPOgRMHGuRWkLQh04oHFvpRPHPj04pdoa9wY2TlEEvOjUB7KMTD0KipzqJq2alG0I3RnQiENcep+eFsHjSEbY5pxq8DAklLOfpD4l+uFQCQq0WUJlyEPsB0JBSDxudUBBTRzrAtwFBlgihnx9EqOGQEx91EkE7pXSxwTg+CEfKDU2s5IcN+fTSwyw5WeEUKUyg4NNCCPYCBBe4eIJADgEMUABef9RxxBNh5CCVJzv0Nw8SL+USAXysZNSRIxtF5rLKC64UJcUOSzk51Qf3pQVGWRgoIEILJ4TQAA4t9hIIACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg20+FRg5LSJoCQ1JbYaUlZaDdDsMfpydnpwMSz+XpIY3OjyfqqsAODelpQKrnDUREbOcAFiwlyqeCBMBFgVxgwdYARMUqktAvJU5fhkPWaVqDx2fGT3Phn043X83ZJudG13h6YZAS57npEcCe+qWSsucG0eWQKkp+vSUftzKZaYSl04pigE0dOaenyWUttTo5GNhJR2eLBhKxYmIRUtEOvEohKMTgyIfKzkp5wfcoCGdmqS01KTTiEFCOnV4NZPSjWychAja0QlFT0soOkkQVIITAi1HK2VBwInEHzCdckS1dKJTGzKdAmytNKUTjgadBoylNKBTgxCd/8asNcSmUx4FnfDMLVSmE5oWnCLsNTSwBWA/ggcTKoymUxnFgvB0UpCnExvIf8Z0CoGWk1rIbTk1KMlpCuYAnci06XQCczROYP6QcFptsBaqfkoIklBUcVJOOwTl5LRz789OQgWNiLm3JqchhEj7YeBkbRGWLgdx9ONxbEhOIwtZ8KRjq49ONbZQaseJwpmjPxxyqWQGQKcIo1KeGeiHh7NKR2zQCQUVWaSDQ/mQ0oWAnRCBkjpOfIcPOqUs6AkDTfDEyw1NsOTHO7wcsR1xKEBFShYoANUJAP88AwQXE/2SQwADjKHXH2WwMcAUJ+DmyRIFqbPFiKrYgkt/GlmEAx9MR64yQnYpCbFDU02SIEFyY4FBxlsKGIZGHqNNEk4gACH5BAkDAH8ALAAAAAAwADAAAAf/gH+Cg4SFg2BJMhgnIiInGA04YIaUlZaEUSR+m5ydmyQ7P5ejl1kInqidQzo3pK6EAp4REamcABavhkBAhj4TIFgFgzcFaQEKp55GvLl/R0MEzYNZDzCeAEG5XRubZNKEZJqcG1KuP9ybEVrfg2ZrnREGo0fofhQ+7IVuFOPZlWYAOEUQla+QHFqbADAztIQThTMFKcnht2kHJSyddESspIRTjS2GeHAystESEU48CuHgxMBJyUpqGHBSQmgEpyYvLc2xNUgIpxStclK60YFTuT8SOKEQagkFJ4t/xCFYx5SSlmQl/gThlKOqpRycwKzcFMZrpQCcyDTgNMAspQGc/xqE4HTEraEDnDCA3VTGbqEynBS02ETBryGELQb7iWC4EMUWCjj1bfwH8KYcGDgdoOyMU4i1m9pShrupARlOATiH4SSJK+e9frKV2DS18dVPgnYobex0kwRBUjh1COr2RgpOQgYF3DTHbxNOIwh13MRAjVsnMjfhKCRyExG3RlAa2lKDE76qOjphoaSbMMGcZyj6WVIJyBCBEF/+QOgHgBlL9Dik0UY+yLdBXZds04kRLrGjxknjvHfJOZ0w0ARxrtwwR3abbNBFLkcs9xMKVF2iBQpFqYJgLmY05AkCOYQxwBGTlXHAAAHkkIxHOywkDRbd1UIBf6nwANJGONhUyx6SANAklBASiLOkHyXscJRZQeAgVw6JKQAJGZNIEwgAIfkECQMAfwAsAAAAADAAMAAAB/+Af4KDhIWGFzkvLTkJDUlthpGSk5MPfpeYlww7Z5SekW4ehnyZpZdDODefnl48fg54hRp+ERE1ppgAW6uRQEu3l3OTNwUWARMIpiZXvIM9AKU0vFkcHaUZVc1wG5kMPqrNNzoMmRtCq1ERmURqzYVmXJkRP55HNpgUPu6SFxSYG9kkXcmAKQKdfZPOqLuUgVmkHfgOIpz0w98lIpGgZMIx0ZObTF4K3RiBiUDHT/EuAQAniAwmB05OegJC7hLHQS8wNZH5SQcmHoOEYErBkqekG9YuGRD0AZMVo5+sYFojqCYCJlA9iUnmp8SfHphyZP2UA9MdH5jCjPUUABOOCpj/nqylNADTghCY2Myd9AVTghOY4uyVVAeTghaXKAyeFOMSBAiXYiyWZLGFAkx1JheKg+lEAkxfNBNigynEAkwDRA96gqkCDkwBVAsKg8nHnbCy/5S91ONPiUsIxKhmwpWBoDVOVUu99EGQAUwdiu69kQLTOUGuLumb3ATTC0IfNbUb7MQBJjKFsvvBOJgAphHSvQDzs33ta0xQIi2JuJaORT87SAIENJcYlBUdC/nR0CQ9cJPYTTL58J8NR3gCR4J+EBDTRGoQIU8U6NzzUhPSeXKDDzVdsgEczRxBUCYpWIGVVlYklUtv7lwBUSkI5BDGE2wI9kcdXwwQQA5cYVLDNhJAdAQFSbgk1liUfvAQkkw3kJETlVHy4MZaQnyQIpUlrLHUYj34UEEIJ7QAgQIJLIDDHQgFAgAh+QQFAwB/ACwAAAAAMAAwAAAH/4B/goOEhYNVVIYeDU1tho+QkYNSayV+FoY0fpsMO0KSoIY3OACbm1OGEKamADg3oaBIGaubNIYMtKxQsI9XRrkIOQ+GBVABEwi5S0C8g0Glqx1vYqFZHB20AD3NcBurDDqvzTc+uKYbBrBSEatGRc2FQEurEVGgPTamFDrwkBcU54JEogLNT4Rd/SD9YLcpwxVIXPR5SShJDsBNRh4hWcWPoiQ3qzARujHEFAGPoXawEidIiSkH71BKMkPCVEdBI0w1kRkKh6khg36YssOSZ6RZm34IkmDKitFQD0ytEWQOAZOnoLIk80PiTw9TCrCGUmDqzhxTqMRKCmAKxwJTaf/USnpiakECU2PkRvpiKgEaU3oj3TA1YcUmF4EjudgEQZUfxIkfLfazYoKpopEFmUJzd9OXzITG9H276QnoQWnq+twU4LSgKabmVDGVw/Ufspu2WfKDgBpoJlsZCFpj6s1pK6YkCJJiqgNmuTfsmFIqqODNwE1MjSC02g+DmHqLODClZCRSPxkDE/iJeaNNvTpWIXn0axMFhFi9XPTDBdKVghFM9BQUDPkBQCKQBOGNfdd5pMN+NmwjCRwF+kEAeP0UUd8mEUihTj4vNfGcJDfoYM4mG8DRTA8FbWKHFVeBIsYb2KwCgEDwUBERLQgoMEUaeQlywxdPBJDDVu08RBEyEiXlYooLkznpRwbzyXSDEjlJqWUrI3r0gwQnalnCGh4m1sMcdqGxAgQTJLAADlUkFAgAOw==");\n}\n.secondary {\n  background-image: url("data:image/gif;base64,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");\n}\n',
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(182);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".modal {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background-color: rgba(0,0,0,0.75);\n  transition: opacity 300ms ease, visibility 300ms ease;\n}\n.modal-content {\n  margin: 150px auto;\n  background-color: #fff;\n}\n.h4 {\n  font-size: 20px;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".nav-link {\n  opacity: 0.65;\n}\n.nav-link:hover,\n.nav-link.active {\n  opacity: 1;\n}\n.h1 {\n  font-size: 40px;\n  line-height: 1.2;\n}\n.h2 {\n  font-size: 34px;\n  line-height: 1.411764705882353;\n}\n.h3 {\n  font-size: 28px;\n  line-height: 1.714285714285714;\n}\n.h4 {\n  font-size: 16px;\n  line-height: 1.5;\n}\n.h5 {\n  font-size: 16px;\n  line-height: 1.5;\n}\n.h6 {\n  font-size: 14px;\n  line-height: 1.714285714285714;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(185);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".nav-dropdown .ncss-flyout-options {\n  background: #111;\n  box-shadow: none;\n}\n.nav-dropdown .ncss-flyout-options .ncss-option {\n  color: #fff;\n  webkit-box-shadow: none;\n  box-shadow: none;\n}\n.nav-dropdown .ncss-flyout-options .ncss-option:hover {\n  color: #fff;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(187);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            '.progress-bar {\n  height: 6px;\n  width: 100%;\n  border-radius: 3px;\n  box-shadow: inset 0 0 1px 2px #fff;\n  background-color: #ccc;\n  margin: 4px 0;\n}\n.progress-bar .fill-color {\n  height: 6px;\n  border-radius: 3px;\n  box-shadow: inset 0 2px 9px rgba(255,255,255,0.25), inset 0 -2px 6px rgba(0,0,0,0.4);\n  position: relative;\n}\n.progress-bar .fill-color.animateTransitions {\n  transition: width 1.5s ease-in-out, background-color 1.5s ease;\n}\n.progress-bar > .animateColorStripe:after {\n  content: "";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-image: linear-gradient(-45deg, rgba(255,255,255,0.2) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.2) 50%, rgba(255,255,255,0.2) 75%, transparent 75%, transparent);\n  z-index: 1;\n  background-size: 25px 25px;\n  animation: move 2s linear infinite;\n}\n@-moz-keyframes move {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 25px 25px;\n  }\n}\n@-webkit-keyframes move {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 25px 25px;\n  }\n}\n@-o-keyframes move {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 25px 25px;\n  }\n}\n@keyframes move {\n  0% {\n    background-position: 0 0;\n  }\n  100% {\n    background-position: 25px 25px;\n  }\n}\n',
            ""
        ]);
    },
    function(e, t, n) {
        var r = n(189);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".typeahead-dropdown-container {\n  overflow: visible;\n}\n.typeahead-dropdown-container.disabled {\n  opacity: 0.55;\n}\n.typeahead-dropdown-container.disabled .dropdown-btn {\n  cursor: default;\n}\n.typeahead-dropdown-container.focus .typeahead-options {\n  opacity: 1;\n  visibility: visible;\n  transform: translate(0, 0);\n}\n.error.typeahead-dropdown-container .typeahead-btn {\n  box-shadow: inset 0 0 0 1px #fe0000;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        "use strict";
        t.__esModule = !0;
        var r = n(1), o = (i(r), i(n(0))), a = i(n(191));
        i(n(42));
        function i(e) {
            return e && e.__esModule ? e : {
                default: e
            };
        }
        function s(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function l(e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }
        function c(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }
        var u = 1073741823;
        t.default = function(e, t) {
            var n, i, f = "__create-react-context-" + (0, a.default)() + "__", p = function(e) {
                function n() {
                    var t, r, o, a;
                    s(this, n);
                    for(var i = arguments.length, c = Array(i), u = 0; u < i; u++)c[u] = arguments[u];
                    return t = r = l(this, e.call.apply(e, [
                        this
                    ].concat(c))), r.emitter = (o = r.props.value, a = [], {
                        on: function(e) {
                            a.push(e);
                        },
                        off: function(e) {
                            a = a.filter(function(t) {
                                return t !== e;
                            });
                        },
                        get: function() {
                            return o;
                        },
                        set: function(e, t) {
                            o = e, a.forEach(function(e) {
                                return e(o, t);
                            });
                        }
                    }), l(r, t);
                }
                return c(n, e), n.prototype.getChildContext = function() {
                    var e;
                    return (e = {})[f] = this.emitter, e;
                }, n.prototype.componentWillReceiveProps = function(e) {
                    if (this.props.value !== e.value) {
                        var n = this.props.value, r = e.value, o = void 0;
                        ((a = n) === (i = r) ? 0 !== a || 1 / a == 1 / i : a != a && i != i) ? o = 0 : (o = "function" == typeof t ? t(n, r) : u, 0 != (o |= 0) && this.emitter.set(e.value, o));
                    }
                    var a, i;
                }, n.prototype.render = function() {
                    return this.props.children;
                }, n;
            }(r.Component);
            p.childContextTypes = ((n = {})[f] = o.default.object.isRequired, n);
            var d = function(t) {
                function n() {
                    var e, r;
                    s(this, n);
                    for(var o = arguments.length, a = Array(o), i = 0; i < o; i++)a[i] = arguments[i];
                    return e = r = l(this, t.call.apply(t, [
                        this
                    ].concat(a))), r.state = {
                        value: r.getValue()
                    }, r.onUpdate = function(e, t) {
                        0 != ((0 | r.observedBits) & t) && r.setState({
                            value: r.getValue()
                        });
                    }, l(r, e);
                }
                return c(n, t), n.prototype.componentWillReceiveProps = function(e) {
                    var t = e.observedBits;
                    this.observedBits = null == t ? u : t;
                }, n.prototype.componentDidMount = function() {
                    this.context[f] && this.context[f].on(this.onUpdate);
                    var e = this.props.observedBits;
                    this.observedBits = null == e ? u : e;
                }, n.prototype.componentWillUnmount = function() {
                    this.context[f] && this.context[f].off(this.onUpdate);
                }, n.prototype.getValue = function() {
                    return this.context[f] ? this.context[f].get() : e;
                }, n.prototype.render = function() {
                    var e;
                    return (e = this.props.children, Array.isArray(e) ? e[0] : e)(this.state.value);
                }, n;
            }(r.Component);
            return d.contextTypes = ((i = {})[f] = o.default.object, i), {
                Provider: p,
                Consumer: d
            };
        }, e.exports = t.default;
    },
    function(e, t, n) {
        "use strict";
        (function(t) {
            var n = "__global_unique_id__";
            e.exports = function() {
                return t[n] = (t[n] || 0) + 1;
            };
        }).call(this, n(21));
    },
    function(e, t, n) {
        var r = n(193);
        "string" == typeof r && (r = [
            [
                e.i,
                r,
                ""
            ]
        ]);
        n(7)(r, {});
        r.locals && (e.exports = r.locals);
    },
    function(e, t, n) {
        (e.exports = n(6)()).push([
            e.i,
            ".bottom-left {\n  top: 20px;\n  right: 10px;\n}\n.bottom-right {\n  top: 20px;\n  left: 10px;\n}\n.tooltip-container {\n  border-radius: 8px;\n  display: block;\n  font-family: Helvetica;\n  padding: 8px;\n  position: absolute;\n}\n.tooltip-icon {\n  position: relative;\n}\n.top-left {\n  bottom: 20px;\n  right: 10px;\n}\n.top-right {\n  bottom: 20px;\n  left: 10px;\n}\n",
            ""
        ]);
    },
    function(e, t, n) {
        "use strict";
        n.r(t);
        var r = n(1), o = n.n(r), a = n(0), i = n.n(a), s = n(2), l = n.n(s);
        function c(e) {
            return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function u(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function f(e, t) {
            return !t || "object" !== c(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function p(e) {
            return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function d(e, t) {
            return (d = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var h = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), f(this, p(t).apply(this, arguments));
            }
            var n, o, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && d(e, t);
            }(t, r["Component"]), n = t, o = [
                {
                    key: "_bind",
                    value: function() {
                        for(var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                        n.forEach(function(t) {
                            e[t] = e[t].bind(e);
                        });
                    }
                }
            ], u(n.prototype, o), a && u(n, a), t;
        }();
        n(71);
        function y(e) {
            return (y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function m() {
            return (m = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function b(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function g(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function v(e, t) {
            return !t || "object" !== y(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function O(e) {
            return (O = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function A(e, t) {
            return (A = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var w = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), v(this, O(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && A(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e, t, n, r = this.props, a = r.children, i = r.className, s = r.context, c = r.hasIcon, u = r.onClose, f = b(r, [
                            "children",
                            "className",
                            "context",
                            "hasIcon",
                            "onClose"
                        ]), p = l()((e = {
                            "border-accent text-color-accent": "info" === s
                        }, t = "border-".concat(s, " text-color-").concat(s), n = "info" !== s, t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n, e), "alert-container ncss-brand pt4-sm pb4-sm pr10-sm pl10-sm", i), d = l()({
                            "g72-info": "info" === s,
                            "g72-check-circle": "success" === s,
                            "g72-alert": "error" === s
                        }, "h4 alert-icon");
                        return o.a.createElement("div", m({
                            className: p
                        }, f), c && o.a.createElement("i", {
                            className: d
                        }), u && o.a.createElement("i", {
                            className: "g72-x u-cursor-pointer close-btn",
                            onClick: u
                        }), a);
                    }
                }
            ], g(n.prototype, r), a && g(n, a), t;
        }();
        w.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            context: i.a.oneOf([
                "success",
                "info",
                "error"
            ]).isRequired,
            hasIcon: i.a.bool,
            onClose: i.a.func
        }, w.defaultProps = {
            hasIcon: !0,
            context: "info"
        }, w.displayName = "Alert";
        var S = w;
        function E(e) {
            return (E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function D() {
            return (D = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function k(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function M(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function C(e, t) {
            return !t || "object" !== E(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function x(e) {
            return (x = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function _(e, t) {
            return (_ = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var T = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), C(this, x(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && _(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.children, n = e.className, r = e.isDisabled, a = e.kind, i = k(e, [
                            "children",
                            "className",
                            "isDisabled",
                            "kind"
                        ]), s = l()(n, "ncss-brand pt2-sm pr5-sm pb2-sm pl5-sm u-uppercase", {
                            "ncss-btn-black": "primary" === a,
                            "ncss-btn-border-black": "secondary" === a,
                            "ncss-btn-medium-grey": "cancel" === a,
                            "ncss-btn-border-light-grey": "navBack" === a || "navForward" === a
                        });
                        return o.a.createElement("button", D({}, i, {
                            className: s,
                            disabled: r
                        }), t);
                    }
                }
            ], M(n.prototype, r), a && M(n, a), t;
        }();
        T.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            isDisabled: i.a.bool,
            kind: i.a.oneOf([
                "primary",
                "secondary",
                "cancel",
                "navBack",
                "navForward"
            ]).isRequired,
            onClick: i.a.func,
            tabIndex: i.a.oneOfType([
                i.a.number,
                i.a.string
            ])
        }, T.defaultProps = {
            kind: "primary"
        }, T.displayName = "Button";
        var j = T, I = n(3), R = n.n(I), P = n(60), N = n.n(P);
        function B(e) {
            return (B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Y(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Q(e, t) {
            return !t || "object" !== B(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function U(e) {
            return (U = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function F(e, t) {
            return (F = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var H = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = Q(this, U(t).call(this, e))).setPrevMonthRef = function(e) {
                    n.prevMonth = e;
                }, n.setNextMonthRef = function(e) {
                    n.nextMonth = e;
                }, n._bind("handleKeyDownOnArrow"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && F(e, t);
            }(t, h), n = t, r = [
                {
                    key: "handleKeyDownOnArrow",
                    value: function(e) {
                        var t = this.props, n = t.handleGoToNextMonth, r = t.handleGoToPreviousMonth;
                        switch(e.keyCode){
                            case 37:
                                r(), this.prevMonth.focus();
                                break;
                            case 39:
                                n(), this.nextMonth.focus();
                        }
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.month, n = e.handleGoToNextMonth, r = e.handleGoToPreviousMonth;
                        return o.a.createElement("div", null, o.a.createElement("button", {
                            ref: this.setPrevMonthRef,
                            className: "ncss-btn-white pt2-sm pr5-sm pb2-sm pl5-sm",
                            onClick: r,
                            onKeyDown: this.handleKeyDownOnArrow,
                            type: "button"
                        }, o.a.createElement("div", {
                            className: "g72-arrow-thick-left"
                        })), o.a.createElement("div", {
                            className: "current-month pt2-sm pl4-sm pr4-sm",
                            style: {
                                display: "inline-block"
                            }
                        }, o.a.createElement("strong", null, t)), o.a.createElement("button", {
                            ref: this.setNextMonthRef,
                            className: "ncss-btn-white pt2-sm pr5-sm pb2-sm pl5-sm",
                            onClick: n,
                            onKeyDown: this.handleKeyDownOnArrow,
                            type: "button"
                        }, o.a.createElement("div", {
                            className: "g72-arrow-thick-right"
                        })));
                    }
                }
            ], Y(n.prototype, r), a && Y(n, a), t;
        }();
        H.propTypes = {
            month: i.a.string,
            handleGoToNextMonth: i.a.func,
            handleGoToPreviousMonth: i.a.func,
            handleKeyDownOnArrow: i.a.func
        }, H.displayName = "CalendarHeader";
        var G = H, J = n(8), W = n.n(J);
        n(156);
        function K(e) {
            return (K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function L(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function V(e) {
            return (V = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Z(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function q(e, t) {
            return (q = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var z = function(e) {
            function t(e) {
                var n, r, o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), r = this, (n = !(o = V(t).call(this, e)) || "object" !== K(o) && "function" != typeof o ? Z(r) : o).handleOnClick = n.handleOnClick.bind(Z(n)), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && q(e, t);
            }(t, h), n = t, r = [
                {
                    key: "handleOnClick",
                    value: function() {
                        var e = this.props, t = e.day, n = e.handleDayClick;
                        e.isDaySelectable && n(t);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.day, n = e.isToday, r = e.isDayInRange, a = e.isDayOutsideOfMonth, i = e.isDaySelectable, s = e.isSelected, c = l()("p2-sm fcl-datepicker-day-style", {
                            "bg-offwhite": a || !i,
                            "text-color-medium-grey": a || !i,
                            "u-cursor-default": !i,
                            "u-cursor-pointer": i,
                            "selected-day": s && !a,
                            "text-color-white": s,
                            "day-within-range": r && !a
                        }), u = l()("fcl-datepicker-day-td", {
                            "not-selectable": !i
                        });
                        return t ? o.a.createElement("td", {
                            className: u,
                            onClick: this.handleOnClick
                        }, o.a.createElement("div", {
                            disabled: !i,
                            id: "day-".concat(t.format("MM-DD-YYYY")),
                            tabIndex: "0",
                            className: c
                        }, o.a.createElement("div", {
                            className: n ? "today" : void 0
                        }, t.format("D")))) : o.a.createElement("td", null);
                    }
                }
            ], L(n.prototype, r), a && L(n, a), t;
        }();
        z.propTypes = {
            day: i.a.object,
            handleDayClick: i.a.func,
            isDayInRange: i.a.bool,
            isDayOutsideOfMonth: i.a.bool,
            isSelected: i.a.bool,
            isToday: i.a.bool
        };
        var X = z;
        function $() {
            return ($ = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        var ee = function(e, t) {
            return t instanceof R.a ? e && t && t.isSame(e, "day") : e && Object.values(t).some(function(t) {
                return t && t.isSame(e, "day");
            });
        }, te = function(e) {
            var t = e.earliestDateTime, n = e.enableOutsideDays, r = e.handleDayClick, a = e.handleKeyDownOnDay, i = e.latestDateTime, s = e.month, l = e.selectedDates, c = function(e, t) {
                for(var n = R()(e).clone(), r = n.clone().startOf("month"), o = n.clone().endOf("month").startOf("day"), a = r.clone(), i = [], s = [], l = 0; l < a.weekday(); l += 1){
                    var c = t ? a.clone().subtract(l + 1, "day") : null;
                    i.unshift(c);
                }
                for(; a <= o;)i.push(a.clone()), a.add(1, "d"), 0 === a.weekday() && (s.push(i), i = []);
                if (0 !== a.weekday()) {
                    for(var u = a.weekday(), f = 0; u < 7; u += 1, f += 1){
                        var p = t ? a.clone().add(f, "day") : null;
                        i.push(p);
                    }
                    s.push(i);
                }
                return s;
            }(s, n);
            return o.a.createElement("div", {
                className: "pt2-sm"
            }, o.a.createElement("table", {
                className: "d-sm-ib"
            }, o.a.createElement("thead", {
                className: "text-color-grey"
            }, o.a.createElement("tr", null, o.a.createElement("th", null, "Sun"), o.a.createElement("th", null, "Mon"), o.a.createElement("th", null, "Tue"), o.a.createElement("th", null, "Wed"), o.a.createElement("th", null, "Thur"), o.a.createElement("th", null, "Fri"), o.a.createElement("th", null, "Sat"))), o.a.createElement("tbody", {
                tabIndex: "0",
                onKeyDown: a
            }, c.map(function(e) {
                return o.a.createElement("tr", {
                    key: "week-of-".concat(e.find(function(e) {
                        return e;
                    }).format("MMM-D"))
                }, e.map(function(e) {
                    return o.a.createElement(X, $({
                        day: e,
                        handleDayClick: r,
                        key: e ? e.format("MMM-Do") : W()()
                    }, function(e, t, n, r, o) {
                        var a = !e || e.month() !== t.month(), i = e && n.end && e.isBetween(n.start, n.end);
                        return {
                            isDaySelectable: !(r && e && e.isBefore(r, "day") || o && e && e.isAfter(o, "day")),
                            isDayInRange: i,
                            isDayOutsideOfMonth: a,
                            isSelected: ee(e, n),
                            isToday: e && e.format("MM-DD-YYYY") === R()().format("MM-DD-YYYY")
                        };
                    }(e, s, l, t, i)));
                }));
            }))));
        };
        te.propTypes = {
            earliestDateTime: i.a.object,
            enableOutsideDays: i.a.bool,
            handleDayClick: i.a.func,
            handleKeyDownOnDay: i.a.func,
            latestDateTime: i.a.object,
            month: i.a.object,
            selectedDates: i.a.object
        };
        var ne = te;
        n(158);
        function re(e) {
            return (re = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function oe() {
            return (oe = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function ae(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function ie(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function se(e, t) {
            return !t || "object" !== re(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function le(e) {
            return (le = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function ce(e, t) {
            return (ce = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var ue = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = se(this, le(t).call(this, e)))._bind("_handleMouseEnter", "_handleMouseLeave"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ce(e, t);
            }(t, h), n = t, r = [
                {
                    key: "_handleMouseEnter",
                    value: function(e) {
                        var t = this.props, n = t.onMouseEnter, r = t.isDisabled;
                        n && !r && n(e);
                    }
                },
                {
                    key: "_handleMouseLeave",
                    value: function(e) {
                        var t = this.props, n = t.onMouseLeave, r = t.isDisabled;
                        n && !r && n(e);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.containerClassName, n = e.errorMessage, r = e.helpMessage, a = e.inputClassName, i = e.inputIcon, s = e.isDisabled, c = e.isIconDisabled, u = e.isReadOnly, f = e.label, p = e.onIconClick, d = e.onClick, h = e.style, y = e.type, m = ae(e, [
                            "containerClassName",
                            "errorMessage",
                            "helpMessage",
                            "inputClassName",
                            "inputIcon",
                            "isDisabled",
                            "isIconDisabled",
                            "isReadOnly",
                            "label",
                            "onIconClick",
                            "onClick",
                            "style",
                            "type"
                        ]), b = l()(t, {
                            error: n
                        }, "ncss-input-container"), g = l()(a, "ncss-input pt2-sm pb2-sm pl4-sm", i ? "pr7-sm" : "pr4-sm"), v = l()("input-icon", {
                            "u-cursor-pointer": !c && !s
                        }, {
                            "text-color-grey": s || c
                        }, i, "z1");
                        return o.a.createElement("div", {
                            style: h,
                            className: b,
                            onClick: d
                        }, o.a.createElement("label", {
                            className: "ncss-label pr3-sm"
                        }, f), o.a.createElement("div", {
                            className: "u-position-relative"
                        }, o.a.createElement("input", oe({}, m, {
                            type: y || "text",
                            className: g,
                            disabled: s,
                            readOnly: u,
                            onMouseEnter: this._handleMouseEnter,
                            onMouseLeave: this._handleMouseLeave
                        })), i && o.a.createElement("span", {
                            className: v,
                            onClick: s || c ? null : p,
                            onMouseEnter: this._handleMouseEnter,
                            onMouseLeave: this._handleMouseLeave
                        })), r && o.a.createElement("small", {
                            className: "text-color-grey"
                        }, r), n && o.a.createElement("div", {
                            className: "ncss-error-msg"
                        }, n));
                    }
                }
            ], ie(n.prototype, r), a && ie(n, a), t;
        }();
        ue.propTypes = {
            containerClassName: i.a.string,
            defaultValue: i.a.string,
            errorMessage: i.a.string,
            helpMessage: i.a.string,
            inputClassName: i.a.string,
            inputIcon: i.a.string,
            isDisabled: i.a.bool,
            isIconDisabled: i.a.bool,
            isReadOnly: i.a.bool,
            label: i.a.string,
            onIconClick: i.a.func,
            onClick: i.a.func,
            type: i.a.oneOf([
                "text",
                "number",
                "password"
            ]),
            value: i.a.oneOfType([
                i.a.string,
                i.a.number
            ])
        }, ue.displayName = "Input";
        var fe = ue;
        n(160);
        function pe(e) {
            return (pe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function de(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function he(e) {
            return (he = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function ye(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function me(e, t) {
            return (me = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var be = function(e, t) {
            return t ? e && e.format("HH") : "0" === e.format("h") ? "12" : e.format("h");
        }, ge = function(e) {
            function t(e) {
                var n, r, o;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), r = this, (n = !(o = he(t).call(this, e)) || "object" !== pe(o) && "function" != typeof o ? ye(r) : o).updateHours = n.updateHours.bind(ye(n)), n.validateAndSetHours = n.validateAndSetHours.bind(ye(n)), n.updateMinutes = n.updateMinutes.bind(ye(n)), n.validateAndSetMinutes = n.validateAndSetMinutes.bind(ye(n));
                var a = e.date || R()().startOf("day");
                return n.state = {
                    inputHours: be(a, e.enableMilitaryTime),
                    inputMinutes: a.format("mm"),
                    meridiem: !e.enableMilitaryTime && a.format("A"),
                    hoursError: !1,
                    minutesError: !1
                }, n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && me(e, t);
            }(t, o.a.Component), n = t, r = [
                {
                    key: "componentWillReceiveProps",
                    value: function(e) {
                        var t = this.props.date;
                        e.date && !e.date.isSame(t) && this.setState({
                            inputHours: be(e.date, e.enableMilitaryTime),
                            inputMinutes: e.date.format("mm"),
                            meridiem: !e.enableMilitaryTime && e.date.format("A")
                        });
                    }
                },
                {
                    key: "updateHours",
                    value: function(e) {
                        var t = this.props.enableMilitaryTime, n = e.target.value;
                        t ? n >= 0 && n <= 23 && 0 !== n.length ? this.setState({
                            inputHours: n,
                            hoursError: !1
                        }) : this.setState({
                            inputHours: n,
                            hoursError: !0
                        }) : n >= 0 && n <= 12 && 0 !== n.length ? this.setState({
                            inputHours: n,
                            hoursError: !1
                        }) : this.setState({
                            inputHours: n,
                            hoursError: !0
                        });
                    }
                },
                {
                    key: "validateAndSetHours",
                    value: function() {
                        var e = this.props, t = e.handleSetHours, n = e.enableMilitaryTime, r = this.state, o = r.inputHours, a = r.hoursError, i = r.meridiem;
                        if (!a) {
                            var s = parseInt(o, 10);
                            n || "PM" !== i || 12 === s || (s += 12), 12 === s && "AM" === i && (s = 0), t(s);
                        }
                        0 === parseInt(o, 10) && (n ? this.setState({
                            inputHours: "00"
                        }) : this.setState({
                            inputHours: 12
                        }));
                    }
                },
                {
                    key: "updateMinutes",
                    value: function(e) {
                        var t = e.target.value;
                        t >= 0 && t <= 59 ? this.setState({
                            inputMinutes: t,
                            minutesError: !1
                        }) : this.setState({
                            inputMinutes: t,
                            minutesError: !0
                        });
                    }
                },
                {
                    key: "validateAndSetMinutes",
                    value: function() {
                        var e = this.props.handleSetMinutes, t = this.state, n = t.inputMinutes;
                        t.minutesError || e(n);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.calendarIdentifier, n = e.date, r = e.enableMilitaryTime, a = e.handleToggleMeridiem, i = e.isTimeInvalid, s = this.state, l = s.inputHours, c = s.inputMinutes, u = s.meridiem, f = s.hoursError, p = s.minutesError;
                        return o.a.createElement("div", null, o.a.createElement(fe, {
                            containerClassName: "mr1-sm",
                            errorMessage: f || i ? " " : "",
                            id: "input-hour-".concat(t),
                            isDisabled: !n,
                            onBlur: this.validateAndSetHours,
                            onChange: this.updateHours,
                            style: {
                                width: "48px"
                            },
                            value: l
                        }), o.a.createElement("div", {
                            className: "date-colon"
                        }, ":"), o.a.createElement(fe, {
                            containerClassName: "ml1-sm mr1-sm",
                            errorMessage: p || i ? " " : "",
                            id: "input-minute-".concat(t),
                            isDisabled: !n,
                            onBlur: this.validateAndSetMinutes,
                            onChange: this.updateMinutes,
                            style: {
                                width: "48px"
                            },
                            value: c
                        }), !r && o.a.createElement(j, {
                            className: "ml1-sm",
                            isDisabled: !n,
                            kind: "AM" === u ? "primary" : "secondary",
                            onClick: a
                        }, u));
                    }
                }
            ], de(n.prototype, r), a && de(n, a), t;
        }();
        ge.propTypes = {
            calendarIdentifier: i.a.string,
            date: i.a.instanceOf(R.a),
            enableMilitaryTime: i.a.bool,
            handleSetHours: i.a.func,
            handleSetMinutes: i.a.func,
            handleToggleMeridiem: i.a.func,
            isTimeInvalid: i.a.bool
        };
        var ve = ge;
        function Oe(e) {
            return (Oe = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Ae(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function we(e) {
            return (we = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Se(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function Ee(e, t) {
            return (Ee = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var De = function(e, t, n) {
            return t && e.isBefore(t) ? "Date time must be after ".concat(t.format("dddd, MMMM Do YYYY hh:mm a")) : !(!n || !e.isAfter(n)) && "Date time must be before ".concat(n.format("dddd, MMMM Do YYYY hh:mm a"));
        }, ke = function(e) {
            function t(e) {
                var n, r, o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), r = this, (n = !(o = we(t).call(this, e)) || "object" !== Oe(o) && "function" != typeof o ? Se(r) : o).goToNextMonth = n.goToNextMonth.bind(Se(n)), n.goToPreviousMonth = n.goToPreviousMonth.bind(Se(n)), n.handleKeyDownOnDay = n.handleKeyDownOnDay.bind(Se(n)), n.handleUpdateHighlightedDay = n.handleUpdateHighlightedDay.bind(Se(n)), n.setDate = n.setDate.bind(Se(n)), n.setMinutes = n.setMinutes.bind(Se(n)), n.setHours = n.setHours.bind(Se(n)), n.toggleMeridiem = n.toggleMeridiem.bind(Se(n)), n.state = {
                    highlightedDate: e.displayedMonth || e.selectedDates && e.selectedDates.start || R()()
                }, n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Ee(e, t);
            }(t, h), n = t, r = [
                {
                    key: "goToNextMonth",
                    value: function() {
                        this.setState(function(e) {
                            return {
                                highlightedDate: e.highlightedDate.clone().add(1, "month")
                            };
                        });
                    }
                },
                {
                    key: "goToPreviousMonth",
                    value: function() {
                        this.setState(function(e) {
                            return {
                                highlightedDate: e.highlightedDate.clone().subtract(1, "month")
                            };
                        });
                    }
                },
                {
                    key: "setDate",
                    value: function(e) {
                        var t = this.props, n = t.calendarIdentifier, r = t.earliestDateTime, o = t.enableTime, a = t.handleUpdateDate, i = t.latestDateTime, s = t.selectedDates, l = e.clone();
                        o && s && s[n] && l.hour(s[n].hours()).minute(s[n].minutes()), a(e, De(l, r, i));
                    }
                },
                {
                    key: "setHours",
                    value: function(e) {
                        var t = this.props, n = t.calendarIdentifier, r = t.earliestDateTime, o = t.handleUpdateHours, a = t.latestDateTime, i = t.selectedDates[n].clone().set("hour", e);
                        o(e, n, De(i, r, a));
                    }
                },
                {
                    key: "setMinutes",
                    value: function(e) {
                        var t = this.props, n = t.calendarIdentifier, r = t.earliestDateTime, o = t.handleUpdateMinutes, a = t.latestDateTime, i = t.selectedDates[n].clone().set("minute", e);
                        o(e, n, De(i, r, a));
                    }
                },
                {
                    key: "toggleMeridiem",
                    value: function() {
                        var e = this.props, t = e.calendarIdentifier, n = e.earliestDateTime, r = e.handleUpdateHours, o = e.latestDateTime, a = e.selectedDates[t], i = "am" === a.format("a") ? a.clone().add(12, "hours") : a.clone().subtract(12, "hours"), s = De(i, n, o);
                        r(i.hour(), t, s);
                    }
                },
                {
                    key: "handleUpdateHighlightedDay",
                    value: function(e) {
                        this.setState({
                            highlightedDate: e
                        }, function() {
                            document.getElementById("day-".concat(e.format("MM-DD-YYYY"))).focus();
                        });
                    }
                },
                {
                    key: "handleKeyDownOnDay",
                    value: function(e) {
                        var t = this.props, n = t.calendarIdentifier, r = t.enableTime, o = this.state.highlightedDate;
                        switch(e.keyCode){
                            case 13:
                                this.setDate(o), r && document.getElementById("input-hour-".concat(n)).focus();
                                break;
                            case 37:
                                var a = o.clone().subtract(1, "day");
                                this.handleUpdateHighlightedDay(a);
                                break;
                            case 39:
                                var i = o.clone().add(1, "day");
                                this.handleUpdateHighlightedDay(i);
                                break;
                            case 38:
                                var s = o.clone().subtract(7, "day");
                                this.handleUpdateHighlightedDay(s);
                                break;
                            case 40:
                                var l = o.clone().add(7, "day");
                                this.handleUpdateHighlightedDay(l);
                                break;
                            case 9:
                                e.preventDefault(), r ? document.getElementById("input-hour-".concat(n)).focus() : document.activeElement.blur();
                        }
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.calendarIdentifier, n = e.earliestDateTime, r = e.enableMilitaryTime, a = e.enableOutsideDays, i = e.enableTime, s = e.latestDateTime, l = e.selectedDates, c = this.state.highlightedDate, u = l ? l[t] : c, f = t === $e && l.start && l.start.isAfter(l.end);
                        return o.a.createElement("div", {
                            className: "p2-sm"
                        }, o.a.createElement(G, {
                            month: c.format("MMMM YYYY"),
                            handleGoToNextMonth: this.goToNextMonth,
                            handleGoToPreviousMonth: this.goToPreviousMonth
                        }), o.a.createElement(ne, {
                            earliestDateTime: n,
                            enableOutsideDays: a,
                            handleDayClick: this.setDate,
                            handleKeyDownOnDay: this.handleKeyDownOnDay,
                            latestDateTime: s,
                            month: c,
                            selectedDates: l
                        }), i && o.a.createElement(ve, {
                            calendarIdentifier: t,
                            date: u,
                            enableMilitaryTime: r,
                            handleSetHours: this.setHours,
                            handleSetMinutes: this.setMinutes,
                            handleToggleMeridiem: this.toggleMeridiem,
                            isTimeInvalid: f
                        }));
                    }
                }
            ], Ae(n.prototype, r), a && Ae(n, a), t;
        }();
        ke.propTypes = {
            calendarIdentifier: i.a.string,
            displayedMonth: i.a.object,
            earliestDateTime: i.a.object,
            enableMilitaryTime: i.a.bool,
            enableOutsideDays: i.a.bool,
            enableTime: i.a.bool,
            handleUpdateDate: i.a.func,
            handleUpdateHours: i.a.func,
            handleUpdateMinutes: i.a.func,
            latestDateTime: i.a.object,
            selectedDates: i.a.object
        }, ke.defaultProps = {
            calendarIdentifier: Xe
        };
        var Me = ke;
        function Ce(e) {
            return (Ce = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function xe() {
            return (xe = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function _e(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Te(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function je(e, t) {
            return !t || "object" !== Ce(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function Ie(e) {
            return (Ie = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Re(e, t) {
            return (Re = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Pe = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = je(this, Ie(t).call(this, e))).setAutoPositionerRef = function(e) {
                    n.autoPositioner = e;
                }, n.state = {
                    originalHeight: document.documentElement.scrollHeight,
                    originalYScrollDistance: window.scrollY,
                    adjustedYPosition: 0
                }, n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Re(e, t);
            }(t, o.a.Component), n = t, r = [
                {
                    key: "componentDidMount",
                    value: function() {
                        var e = this.props, t = e.paddingBottom, n = e.paddingTop, r = this.state, o = r.originalHeight, a = r.originalYScrollDistance;
                        if (this.autoPositioner.lastChild.getBoundingClientRect().bottom + a > o) {
                            var i = this.autoPositioner.lastChild.getBoundingClientRect().bottom + window.scrollY, s = this.autoPositioner.firstChild.getBoundingClientRect().top + window.scrollY, l = i - o;
                            l += s - l < 0 ? s - l - n : t, this.setState({
                                adjustedYPosition: l
                            });
                        }
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.position, n = (e.paddingBottom, e.paddingTop, _e(e, [
                            "position",
                            "paddingBottom",
                            "paddingTop"
                        ]));
                        return o.a.createElement("div", xe({
                            ref: this.setAutoPositionerRef,
                            style: {
                                bottom: "".concat(this.state.adjustedYPosition, "px"),
                                position: "".concat(t)
                            }
                        }, n), this.props.children);
                    }
                }
            ], Te(n.prototype, r), a && Te(n, a), t;
        }();
        Pe.propTypes = {
            children: i.a.node,
            paddingBottom: i.a.number,
            paddingTop: i.a.number,
            position: i.a.oneOf([
                "absolute",
                "fixed",
                "relative",
                "static",
                "sticky"
            ])
        }, Pe.defaultProps = {
            paddingBottom: 0,
            paddingTop: 0,
            position: "relative"
        };
        var Ne = Pe;
        n(162);
        function Be(e) {
            return (Be = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Ye(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Qe(e) {
            return (Qe = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Ue(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function Fe(e, t) {
            return (Fe = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var He = function(e, t, n, r, o, a) {
            if (e) {
                if (o) {
                    var i = n ? "MM/DD/YY h:mm A" : "MMM Do YYYY";
                    return "".concat(e ? e.format(i) : "", " - ").concat(t ? t.format(i) : "");
                }
                return n ? r ? e.format("ddd, MMMM Do YYYY, HH:mm") : e.format("ddd, MMMM Do YYYY, h:mm A") : e.format("ddd, MMMM Do YYYY");
            }
            return a;
        }, Ge = function(e, t, n) {
            return e === $e ? n && !n.isSame(t, "month") ? n : t ? t.clone().add(1, "month") : R()().add(1, "month") : t || R()();
        }, Je = function(e) {
            function t(e) {
                var n, r, o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), r = this, (n = !(o = Qe(t).call(this, e)) || "object" !== Be(o) && "function" != typeof o ? Ue(r) : o).handleOpenCalendar = n.handleOpenCalendar.bind(Ue(n)), n.handleCancelSelection = n.handleCancelSelection.bind(Ue(n)), n.handleCloseCalendarClick = n.handleCloseCalendarClick.bind(Ue(n)), n.handleCloseCalendar = n.handleCloseCalendar.bind(Ue(n)), n.state = {
                    isActive: !1
                }, n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Fe(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentWillUnmount",
                    value: function() {
                        document.body.removeEventListener("click", this.handleCloseCalendarClick, !1);
                    }
                },
                {
                    key: "handleOpenCalendar",
                    value: function() {
                        this.props.isDisabled || (document.body.addEventListener("click", this.handleCloseCalendarClick, !1), this.setState({
                            isActive: !0
                        }));
                    }
                },
                {
                    key: "handleCloseCalendar",
                    value: function() {
                        document.body.removeEventListener("click", this.handleCloseCalendarClick, !1), this.setState({
                            isActive: !1
                        });
                    }
                },
                {
                    key: "handleCancelSelection",
                    value: function(e) {
                        var t = this.props.handleCancelSetDate;
                        27 === e.keyCode && (t(), this.handleCloseCalendar());
                    }
                },
                {
                    key: "handleCloseCalendarClick",
                    value: function(e) {
                        var t = this.props, n = t.enableRange, r = t.errorMessage, o = t.handleCancelSetDate, a = t.handleOutsideClick, i = t.selectedDates, s = this.state.isActive;
                        this.node.contains(e.target) || (e.stopPropagation(), s && !r && (n && !i.end ? o() : a(), this.handleCloseCalendar()));
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, t = this.props, n = t.className, r = t.earliestDateTime, a = t.selectedDates, i = t.enableMilitaryTime, s = t.enableOutsideDays, c = t.enableRange, u = t.enableTime, f = t.errorMessage, p = t.handleUpdateDate, d = t.handleUpdateHours, h = t.handleUpdateMinutes, y = t.latestDateTime, m = t.isDisabled, b = t.paddingTop, g = t.paddingBottom, v = t.placeholder, O = t.position, A = t.style, w = t.zIndex, S = this.state.isActive, E = l()("datepicker-container", n), D = l()("datepicker-overlay ta-sm-c", "z".concat(w), {
                            "center-picker": "center" === O,
                            "left-picker": "left" === O,
                            "right-picker": "right" === O,
                            "range-picker": c
                        });
                        return o.a.createElement("div", {
                            ref: function(t) {
                                e.node = t;
                            },
                            className: E,
                            onKeyDown: this.handleCancelSelection,
                            style: A
                        }, o.a.createElement(fe, {
                            errorMessage: "string" == typeof f ? f : "",
                            inputClassName: "ta-sm-c u-cursor-pointer",
                            isDisabled: m,
                            isReadOnly: !0,
                            onClick: this.handleOpenCalendar,
                            value: He(a.start, a.end, u, i, c, v)
                        }), S && o.a.createElement(Ne, {
                            paddingTop: b,
                            paddingBottom: g,
                            position: "relative"
                        }, o.a.createElement("div", {
                            id: "fcl-datepicker-overlay",
                            className: D
                        }, o.a.createElement(Me, {
                            calendarIdentifier: Xe,
                            displayedMonth: Ge(Xe, a.start),
                            earliestDateTime: r,
                            enableMilitaryTime: i,
                            enableOutsideDays: s,
                            enableTime: u,
                            handleUpdateDate: p,
                            handleUpdateHours: d,
                            handleUpdateMinutes: h,
                            latestDateTime: y,
                            selectedDates: a
                        }), c && o.a.createElement(Me, {
                            calendarIdentifier: $e,
                            displayedMonth: Ge($e, a.start, a.end),
                            earliestDateTime: r,
                            enableMilitaryTime: i,
                            enableOutsideDays: s,
                            enableTime: u,
                            handleUpdateDate: p,
                            handleUpdateHours: d,
                            handleUpdateMinutes: h,
                            latestDateTime: y,
                            selectedDates: a
                        }))));
                    }
                }
            ], Ye(n.prototype, r), a && Ye(n, a), t;
        }();
        Je.propTypes = {
            calendarIdentifier: i.a.string,
            className: i.a.string,
            earliestDateTime: i.a.object,
            enableMilitaryTime: i.a.bool,
            enableOutsideDays: i.a.bool,
            enableRange: i.a.bool,
            enableTime: i.a.bool,
            errorMessage: i.a.oneOfType([
                i.a.string,
                i.a.bool
            ]),
            handleCancelSetDate: i.a.func,
            handleOutsideClick: i.a.func,
            handleUpdateDate: i.a.func,
            latestDateTime: i.a.object,
            paddingBottom: i.a.number,
            paddingTop: i.a.number,
            placeholder: i.a.string,
            position: i.a.oneOf([
                "center",
                "left",
                "right"
            ]),
            selectedDates: i.a.exact({
                start: i.a.object,
                end: i.a.object
            }),
            style: i.a.object,
            zIndex: i.a.number
        }, Je.defaultProps = {
            enableRange: !1,
            enableTime: !1,
            paddingTop: 16,
            paddingBottom: 16,
            placeholder: "Click To Select A Date",
            position: "center",
            zIndex: 1
        };
        var We = Je;
        function Ke(e) {
            return (Ke = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Le(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        function Ve(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Ze(e) {
            return (Ze = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function qe(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function ze(e, t) {
            return (ze = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Xe = "start", $e = "end", et = function(e, t) {
            return t ? N()(e, function(e) {
                return e && e.toISOString();
            }) : e.start && e.start.toISOString();
        }, tt = function(e) {
            function t(e) {
                var n, r, o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), r = this, (n = !(o = Ze(t).call(this, e)) || "object" !== Ke(o) && "function" != typeof o ? qe(r) : o).cancelSetDate = n.cancelSetDate.bind(qe(n)), n.handleOnClickOff = n.handleOnClickOff.bind(qe(n)), n.hydrateDatePicker = n.hydrateDatePicker.bind(qe(n)), n.updateEndDate = n.updateEndDate.bind(qe(n)), n.updateStartDate = n.updateStartDate.bind(qe(n)), n.updateHours = n.updateHours.bind(qe(n)), n.updateMinutes = n.updateMinutes.bind(qe(n)), n.state = {
                    errorMessage: !1,
                    nextDateSelection: Xe
                }, n;
            }
            var n, a, i;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ze(e, t);
            }(t, r["Component"]), n = t, a = [
                {
                    key: "componentWillMount",
                    value: function() {
                        this.hydrateDatePicker(this.props);
                    }
                },
                {
                    key: "componentWillReceiveProps",
                    value: function(e) {
                        e.value === this.props.value && e.start === this.props.start && e.end === this.props.end && e.earliestDateTime === this.props.earliestDateTime && e.latestDateTime === this.props.latestDateTime || this.hydrateDatePicker(e);
                    }
                },
                {
                    key: "hydrateDatePicker",
                    value: function(e) {
                        var t = e.earliestDateTime, n = e.enableRange, r = e.end, o = e.latestDateTime, a = e.start, i = e.value, s = i && R()(i) || a && R()(a) || void 0, l = R()().startOf("day"), c = n && r ? R()(r) : void 0, u = t && R()(t), f = o && R()(o), p = {
                            earliestDate: u,
                            errorMessage: s && De(s, u, f) || c && De(c, u, f),
                            latestDate: f,
                            originalStartDate: s,
                            originalEndDate: c,
                            selectedStartDate: s,
                            selectedEndDate: c,
                            startHours: s ? s.format("H") : l.format("H"),
                            startMinutes: s ? s.format("mm") : l.format("mm")
                        };
                        n && (p.endHours = c ? c.format("H") : l.format("H"), p.endMinutes = c ? c.format("mm") : l.format("mm")), this.setState(p);
                    }
                },
                {
                    key: "updateStartDate",
                    value: function(e, t) {
                        var n = this, r = this.props, o = r.enableRange, a = r.enableTime, i = r.onDayClick, s = this.state, l = s.startHours, c = s.startMinutes;
                        a && e.hour(l).minute(c), this.setState({
                            errorMessage: t,
                            nextDateSelection: o ? $e : Xe,
                            selectedStartDate: e,
                            selectedEndDate: void 0
                        }, function() {
                            i && i(et({
                                start: n.state.selectedStartDate,
                                end: n.state.selectedEndDate
                            }, o));
                        });
                    }
                },
                {
                    key: "updateEndDate",
                    value: function(e, t) {
                        var n = this, r = this.props, o = r.enableRange, a = r.enableTime, i = r.onDayClick, s = this.state, l = s.endHours, c = s.endMinutes, u = s.selectedStartDate, f = s.startHours, p = s.startMinutes;
                        a && e.hour(l).minute(c);
                        var d = {};
                        u.isBefore(e) ? (d.selectedStartDate = u, d.selectedEndDate = e) : u.isSame(e, "day") && u.isAfter(e) ? (e.hour(f).minute(p), d.selectedStartDate = u, d.selectedEndDate = e, this.setState({
                            endHours: f,
                            endMinutes: p
                        })) : (d.selectedStartDate = e.hour(f).minute(p), d.selectedEndDate = u.hour(l).minute(c)), this.setState({
                            errorMessage: t,
                            nextDateSelection: Xe,
                            selectedEndDate: d.selectedEndDate,
                            selectedStartDate: d.selectedStartDate
                        }, function() {
                            i && i(et({
                                start: n.state.selectedStartDate,
                                end: n.state.selectedEndDate
                            }, o));
                        });
                    }
                },
                {
                    key: "updateHours",
                    value: function(e, t, n) {
                        var r = this.props.enableRange, o = this.state, a = o.selectedStartDate, i = o.selectedEndDate;
                        if (t === Xe) {
                            var s, l = a.clone().hour(e);
                            this.setState((Le(s = {
                                selectedStartDate: l
                            }, "".concat(t, "Hours"), e), Le(s, "errorMessage", n || r && i && l.isAfter(i)), s));
                        } else {
                            var c, u = i.clone().hour(e);
                            this.setState((Le(c = {
                                selectedEndDate: u
                            }, "".concat(t, "Hours"), e), Le(c, "errorMessage", n || u.isBefore(a)), c));
                        }
                    }
                },
                {
                    key: "updateMinutes",
                    value: function(e, t, n) {
                        var r = this.props.enableRange, o = this.state, a = o.selectedEndDate, i = o.selectedStartDate;
                        if (t === Xe) {
                            var s, l = i.clone().minute(e);
                            this.setState((Le(s = {
                                selectedStartDate: l
                            }, "".concat(t, "Minutes"), e), Le(s, "errorMessage", n || r && a && l.isAfter(a)), s));
                        } else {
                            var c, u = a.clone().minute(e);
                            this.setState((Le(c = {
                                selectedEndDate: u
                            }, "".concat(t, "Minutes"), e), Le(c, "errorMessage", n || u.isBefore(i)), c));
                        }
                    }
                },
                {
                    key: "cancelSetDate",
                    value: function() {
                        var e = this.state, t = e.originalEndDate, n = e.originalStartDate;
                        this.setState({
                            nextDateSelection: Xe,
                            selectedEndDate: t,
                            selectedStartDate: n
                        });
                    }
                },
                {
                    key: "handleOnClickOff",
                    value: function() {
                        var e = this.props, t = e.enableRange, n = e.onClickOff, r = this.state, o = r.selectedEndDate, a = r.selectedStartDate, i = {
                            start: a,
                            end: o
                        };
                        this.setState({
                            originalStartDate: a,
                            originalEndDate: o,
                            nextDateSelection: Xe
                        }), n && n(et(i, t));
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.className, n = e.earliestDateTime, r = e.enableMilitaryTime, a = e.enableOutsideDays, i = e.enableRange, s = e.enableTime, l = e.isDisabled, c = e.latestDateTime, u = e.paddingBottom, f = e.paddingTop, p = e.placeholder, d = e.position, h = e.style, y = e.zIndex, m = this.state, b = m.errorMessage, g = m.nextDateSelection, v = m.selectedEndDate, O = m.selectedStartDate, A = n && R()(n), w = c && R()(c), S = {
                            start: O,
                            end: v
                        };
                        return o.a.createElement(We, {
                            className: t,
                            earliestDateTime: A,
                            enableMilitaryTime: r,
                            enableOutsideDays: a,
                            enableRange: i,
                            enableTime: s,
                            errorMessage: b,
                            isDisabled: l,
                            handleCancelSetDate: this.cancelSetDate,
                            handleOutsideClick: this.handleOnClickOff,
                            handleUpdateDate: i && g === $e ? this.updateEndDate : this.updateStartDate,
                            handleUpdateHours: this.updateHours,
                            handleUpdateMinutes: this.updateMinutes,
                            latestDateTime: w,
                            paddingBottom: u,
                            paddingTop: f,
                            placeholder: p,
                            position: d,
                            selectedDates: S,
                            style: h,
                            zIndex: y
                        });
                    }
                }
            ], Ve(n.prototype, a), i && Ve(n, i), t;
        }();
        tt.propTypes = {
            className: i.a.string,
            earliestDateTime: i.a.string,
            enableOutsideDays: i.a.bool,
            enableMilitaryTime: i.a.bool,
            enableRange: i.a.bool,
            enableTime: i.a.bool,
            end: i.a.string,
            isDisabled: i.a.bool,
            latestDateTime: i.a.string,
            onClickOff: i.a.func,
            onDayClick: i.a.func,
            paddingBottom: i.a.number,
            paddingTop: i.a.number,
            placeholder: i.a.string,
            position: i.a.oneOf([
                "center",
                "left",
                "right"
            ]),
            start: i.a.string,
            style: i.a.object,
            value: i.a.string,
            zIndex: i.a.number
        }, tt.defaultProps = {
            enableTime: !1,
            enableRange: !1,
            enableOutsideDays: !1,
            enableMilitaryTime: !1,
            position: "center"
        }, tt.displayName = "DatePicker";
        var nt = tt;
        function rt(e) {
            return (rt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function ot() {
            return (ot = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function at(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function it(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function st(e, t) {
            return !t || "object" !== rt(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function lt(e) {
            return (lt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function ct(e, t) {
            return (ct = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var ut = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), st(this, lt(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ct(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentWillMount",
                    value: function() {
                        this.forId = this.props.id || "fcl-".concat(W()());
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.containerClassName, n = e.helpMessage, r = e.inputClassName, a = e.isChecked, i = e.isDefaultChecked, s = e.isDisabled, c = e.label, u = at(e, [
                            "containerClassName",
                            "helpMessage",
                            "inputClassName",
                            "isChecked",
                            "isDefaultChecked",
                            "isDisabled",
                            "label"
                        ]), f = l()(t, "ncss-checkbox-container u-cursor-default"), p = l()(r, "ncss-checkbox");
                        return o.a.createElement("div", {
                            className: f
                        }, o.a.createElement("input", ot({}, u, {
                            type: "checkbox",
                            className: p,
                            id: this.forId,
                            disabled: s,
                            checked: a,
                            defaultChecked: i
                        })), o.a.createElement("label", {
                            className: "ncss-label pl6-sm",
                            htmlFor: this.forId
                        }, c), n && o.a.createElement("div", {
                            className: "text-color-grey"
                        }, n));
                    }
                }
            ], it(n.prototype, r), a && it(n, a), t;
        }();
        ut.propTypes = {
            containerClassName: i.a.string,
            helpMessage: i.a.string,
            id: i.a.string,
            inputClassName: i.a.string,
            isChecked: i.a.bool,
            isDefaultChecked: i.a.bool,
            isDisabled: i.a.bool,
            label: i.a.string.isRequired,
            onChange: i.a.func,
            tabIndex: i.a.oneOfType([
                i.a.number,
                i.a.string
            ])
        }, ut.displayName = "Checkbox";
        var ft = ut;
        function pt(e) {
            return (pt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function dt() {
            return (dt = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function ht(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        function yt(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function mt(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function bt(e, t) {
            return !t || "object" !== pt(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function gt(e) {
            return (gt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function vt(e, t) {
            return (vt = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Ot = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), bt(this, gt(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && vt(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e, t = this.props, n = t.className, r = t.children, a = t.isFull, i = t.elementType, s = t.sm, c = t.md, u = t.lg, f = t.xl, p = t.xxl, d = t.smOffset, h = t.mdOffset, y = t.lgOffset, m = t.xlOffset, b = t.xxlOffset, g = yt(t, [
                            "className",
                            "children",
                            "isFull",
                            "elementType",
                            "sm",
                            "md",
                            "lg",
                            "xl",
                            "xxl",
                            "smOffset",
                            "mdOffset",
                            "lgOffset",
                            "xlOffset",
                            "xxlOffset"
                        ]), v = l()((ht(e = {
                            full: a
                        }, "ncss-col-sm-".concat(s), s), ht(e, "ncss-col-md-".concat(c), c), ht(e, "ncss-col-lg-".concat(u), u), ht(e, "ncss-col-xl-".concat(f), f), ht(e, "ncss-col-xxl-".concat(p), p), ht(e, "ncss-col-sm-offset-".concat(d), d), ht(e, "ncss-col-md-offset-".concat(h), h), ht(e, "ncss-col-lg-offset-".concat(y), y), ht(e, "ncss-col-xl-offset-".concat(m), m), ht(e, "ncss-col-xxl-offset-".concat(b), b), e), n);
                        return o.a.createElement(i, dt({
                            className: v
                        }, g), r);
                    }
                }
            ], mt(n.prototype, r), a && mt(n, a), t;
        }();
        Ot.propTypes = {
            isFull: i.a.bool,
            className: i.a.string,
            sm: i.a.string,
            md: i.a.string,
            lg: i.a.string,
            xl: i.a.string,
            xxl: i.a.string,
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            elementType: i.a.oneOfType([
                i.a.string,
                i.a.element
            ])
        }, Ot.defaultProps = {
            elementType: "div"
        }, Ot.displayName = "Column";
        var At = Ot, wt = n(61), St = n.n(wt), Et = n(28), Dt = n.n(Et), kt = n(9), Mt = n.n(kt), Ct = n(15), xt = n.n(Ct), _t = function(e) {
            var t = e.children, n = e.className, r = e.onMouseDown, a = l()(n, "dropdown-btn ncss-flyout-btn bg-white border-light-grey u-full-width");
            return o.a.createElement("div", {
                className: a,
                onMouseDown: r
            }, t);
        };
        _t.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            onMouseDown: i.a.func
        }, _t.displayName = "DropdownButton";
        var Tt = _t, jt = function(e) {
            var t = e.children, n = void 0 === t ? [] : t, r = e.className, a = e.focusedIndex, i = e.onClickOption, s = e.onMouseDown, c = l()(r, "typeahead-options ncss-flyout-options");
            return o.a.createElement("div", {
                className: c,
                onMouseDown: s
            }, n.map(function(e, t) {
                return o.a.cloneElement(e, {
                    isSelected: t === a,
                    onClick: i,
                    key: e.key || e.props.label
                });
            }));
        };
        jt.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            focusedIndex: i.a.number,
            onClickOption: i.a.func,
            onMouseDown: i.a.func
        }, jt.defaultProps = {
            focusedIndex: 0
        }, jt.displayName = "Menu";
        var It = jt;
        n(166);
        function Rt(e) {
            return (Rt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Pt() {
            return (Pt = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Nt(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Bt(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Yt(e, t) {
            return !t || "object" !== Rt(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function Qt(e) {
            return (Qt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Ut(e, t) {
            return (Ut = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Ft = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = Yt(this, Qt(t).call(this, e)))._bind("_handleKeyDown", "_handleMouseDownOnButton", "_handleMouseDownOnMenu", "_handleSelect", "_handleChange", "_handleFocus", "_handleBlur", "_handleEnter"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Ut(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentWillMount",
                    value: function() {
                        var e = this.props, t = e.children, n = e.defaultValue, r = e.selectOption, o = e.value, a = n || o;
                        if (t) {
                            if (a) {
                                var i = this._filterOptions(a), s = xt()(i, function(e) {
                                    return e.props.label === a;
                                });
                                r(s < 0 ? 0 : s, a);
                            } else r(0, t[0].props.label);
                        }
                    }
                },
                {
                    key: "componentWillReceiveProps",
                    value: function(e) {
                        var t = this.props, n = t.selectedValue, r = t.selectOption, o = e.selectedValue, a = this._filterOptions(o);
                        if (n && o && n !== o) {
                            var i = xt()(a, function(e) {
                                return e.props.label === o;
                            });
                            r(i < 0 ? 0 : i, o);
                        }
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function() {
                        this.props.isOpen && this.refs.input.focus();
                    }
                },
                {
                    key: "_openMenu",
                    value: function() {
                        this.props.openMenu();
                    }
                },
                {
                    key: "_closeMenu",
                    value: function() {
                        this.props.closeMenu();
                    }
                },
                {
                    key: "_selectPrevious",
                    value: function() {
                        var e = this.props, t = e.focusPrevOption, n = e.selectedValue || this.refs.input.value;
                        t(this._filterOptions(n).length - 1);
                    }
                },
                {
                    key: "_selectNext",
                    value: function() {
                        var e = this.props, t = e.focusNextOption, n = e.selectedValue || this.refs.input.value;
                        t(this._filterOptions(n).length - 1);
                    }
                },
                {
                    key: "_handleMouseDownOnButton",
                    value: function(e) {
                        var t = this.props, n = t.closeMenu, r = t.isDisabled, o = t.isOpen, a = t.openMenu;
                        r || (e.stopPropagation(), e.preventDefault(), o ? n() : a());
                    }
                },
                {
                    key: "_handleMouseDownOnMenu",
                    value: function(e) {
                        this.props.isDisabled || (e.stopPropagation(), e.preventDefault());
                    }
                },
                {
                    key: "_handleKeyDown",
                    value: function(e) {
                        var t = this.props, n = t.isDisabled, r = t.isOpen;
                        if (!n) switch(e.keyCode){
                            case 38:
                                e.preventDefault(), r ? this._selectPrevious() : this._openMenu();
                                break;
                            case 40:
                                e.preventDefault(), r ? this._selectNext() : this._openMenu();
                                break;
                            case 27:
                                r && (e.preventDefault(), this._closeMenu());
                                break;
                            case 13:
                                e.preventDefault(), this._handleEnter();
                        }
                    }
                },
                {
                    key: "_handleFocus",
                    value: function(e) {
                        var t = this.props, n = t.onFocus;
                        t.isDisabled || (this._openMenu(), n && n(e));
                    }
                },
                {
                    key: "_handleBlur",
                    value: function(e) {
                        var t = this.props, n = t.onBlur;
                        t.isDisabled || (this._closeMenu(), n && n(e));
                    }
                },
                {
                    key: "_handleChange",
                    value: function(e) {
                        var t = this.props, n = t.isDisabled, r = t.onChange, o = t.selectOption;
                        if (!n) {
                            var a = e.target.value, i = this._filterOptions(a), s = Mt()(i, function(e) {
                                return e.label === a;
                            });
                            o(s < 0 ? 0 : s, a), this._openMenu(), r && r(e, a);
                        }
                    }
                },
                {
                    key: "_handleEnter",
                    value: function() {
                        var e = this.props, t = e.focusedIndex, n = e.selectedValue, r = e.selectOption, o = this._filterOptions(n), a = o[t].props.label, i = Mt()(o, function(e) {
                            return e.props.value === a;
                        });
                        this._closeMenu(), r(i < 0 ? 0 : i, a);
                    }
                },
                {
                    key: "_handleSelect",
                    value: function(e, t) {
                        var n = this.props, r = n.children, o = n.onChange, a = n.isDisabled, i = n.selectedValue, s = n.selectOption;
                        if (!a) {
                            var l = r.find(function(e) {
                                return e.props.value === t;
                            }).props.label, c = this._filterOptions(l), u = Mt()(c, function(e) {
                                return e.props.value === t;
                            });
                            s(u < 0 ? 0 : u, l), this._closeMenu(), l !== i && o(e, l);
                        }
                    }
                },
                {
                    key: "_filterOptions",
                    value: function(e) {
                        var t = this.props, n = t.caseSensitive, r = t.children, o = t.exactMatch, a = [];
                        if (r instanceof Array) {
                            var i = o ? "^".concat(e) : e, s = n ? "" : "i", l = new RegExp(St()(i), s);
                            a = r.filter(function(e) {
                                return l.test(e.props.label);
                            });
                        }
                        return a;
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e, t, n, r = this.props, a = (r.caseSensitive, r.className), i = (r.closeMenu, r.errorMessage), s = (r.exactMatch, r.focusedIndex), c = (r.focusNextOption, r.focusPrevOption, r.helpMessage), u = r.isDisabled, f = r.isOpen, p = r.label, d = (r.openMenu, r.placeholder), h = r.selectedValue, y = (r.selectedOption, r.selectOption, r.tabIndex), m = r.zIndex, b = Nt(r, [
                            "caseSensitive",
                            "className",
                            "closeMenu",
                            "errorMessage",
                            "exactMatch",
                            "focusedIndex",
                            "focusNextOption",
                            "focusPrevOption",
                            "helpMessage",
                            "isDisabled",
                            "isOpen",
                            "label",
                            "openMenu",
                            "placeholder",
                            "selectedValue",
                            "selectedOption",
                            "selectOption",
                            "tabIndex",
                            "zIndex"
                        ]), g = l()(a, "typeahead-dropdown-container ncss-input-container", {
                            disabled: u,
                            error: i,
                            focus: f
                        }), v = l()("typeahead-input-container", (e = {}, t = "z".concat(m), n = m, t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n, e));
                        return o.a.createElement("div", Pt({
                            className: g
                        }, b), o.a.createElement("label", {
                            className: "ncss-label pr3-sm"
                        }, p), o.a.createElement("div", {
                            ref: "typeaheadInput",
                            className: v
                        }, o.a.createElement(Tt, {
                            onMouseDown: this._handleMouseDownOnButton
                        }, o.a.createElement("input", {
                            className: "typeahead-input",
                            type: "text",
                            ref: "input",
                            tabIndex: y,
                            autoFocus: f,
                            disabled: u,
                            value: h || "",
                            placeholder: d,
                            onKeyDown: this._handleKeyDown,
                            onFocus: this._handleFocus,
                            onBlur: this._handleBlur,
                            onChange: this._handleChange
                        })), o.a.createElement(It, {
                            focusedIndex: s,
                            onMouseDown: this._handleMouseDownOnMenu,
                            onClickOption: this._handleSelect
                        }, this._filterOptions(h))), c && o.a.createElement("small", {
                            className: "text-color-grey"
                        }, c), i && o.a.createElement("div", {
                            className: "ncss-error-msg"
                        }, i));
                    }
                }
            ], Bt(n.prototype, r), a && Bt(n, a), t;
        }();
        Ft.propTypes = {
            caseSensitive: i.a.bool,
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            defaultValue: i.a.string,
            errorMessage: i.a.string,
            exactMatch: i.a.bool,
            helpMessage: i.a.string,
            isOpen: i.a.bool,
            isDisabled: i.a.bool,
            label: i.a.string.isRequired,
            onChange: i.a.func,
            onFocus: i.a.func,
            onBlur: i.a.func,
            placeholder: i.a.string,
            tabIndex: i.a.oneOfType([
                i.a.number,
                i.a.string
            ]),
            value: i.a.string,
            zIndex: i.a.oneOfType([
                i.a.string,
                i.a.number
            ])
        }, Ft.displayName = "ComboboxComponent", Ft.defaultProps = {
            caseSensitive: !1,
            exactMatch: !1,
            isDisabled: !1,
            label: "Combobox",
            onChange: Dt.a,
            onFocus: Dt.a,
            onBlur: Dt.a
        };
        var Ht = Ft, Gt = (n(19), n(62), n(43)), Jt = n(29), Wt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, Kt = function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }, Lt = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
        }, Vt = function(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }, Zt = function(e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
        }, qt = function(e, t, n, r, a) {
            if (!e && t) return n(a ? Lt({}, r, {
                children: a
            }) : r);
            var i = n;
            return a ? o.a.createElement(i, r, a) : o.a.createElement(i, r);
        }, zt = function(e) {
            return Boolean(e && e.prototype && "object" === Wt(e.prototype.isReactComponent));
        }, Xt = function(e) {
            return Boolean(!("function" != typeof e || zt(e) || e.defaultProps || e.contextTypes));
        }, $t = function(e) {
            var t = Xt(e);
            return function(n, r) {
                return qt(!1, t, e, n, r);
            };
        }, en = function(e) {
            return function(t) {
                var n = $t(t);
                return function(t) {
                    return n(e(t));
                };
            };
        }, tn = (Object.keys, function(e, t, n, o) {
            return function(a) {
                var i = $t(a);
                return function(r) {
                    function a() {
                        var e, t;
                        Kt(this, a);
                        for(var o = arguments.length, i = Array(o), s = 0; s < o; s++)i[s] = arguments[s];
                        return e = t = Zt(this, r.call.apply(r, [
                            this
                        ].concat(i))), t.state = {
                            stateValue: t.initializeStateValue()
                        }, t.dispatch = function(e) {
                            return t.setState(function(t) {
                                var r = t.stateValue;
                                return {
                                    stateValue: n(r, e)
                                };
                            });
                        }, Zt(t, e);
                    }
                    return Vt(a, r), a.prototype.initializeStateValue = function() {
                        return void 0 !== o ? "function" == typeof o ? o(this.props) : o : n(void 0, {
                            type: "@@recompose/INIT"
                        });
                    }, a.prototype.render = function() {
                        var n;
                        return i(Lt({}, this.props, ((n = {})[e] = this.state.stateValue, n[t] = this.dispatch, n)));
                    }, a;
                }(r.Component);
            };
        }), nn = function(e) {
            function t() {
                return Kt(this, t), Zt(this, e.apply(this, arguments));
            }
            return Vt(t, e), t.prototype.render = function() {
                return null;
            }, t;
        }(r.Component);
        nn.displayName = "Nothing";
        function rn() {
            for(var e = arguments.length, t = Array(e), n = 0; n < e; n++)t[n] = arguments[n];
            return 0 === t.length ? function(e) {
                return e;
            } : 1 === t.length ? t[0] : t.reduce(function(e, t) {
                return function() {
                    return e(t.apply(void 0, arguments));
                };
            });
        }
        var on, an = {
            fromESObservable: null,
            toESObservable: null
        }, sn = {
            fromESObservable: function(e) {
                return "function" == typeof an.fromESObservable ? an.fromESObservable(e) : e;
            },
            toESObservable: function(e) {
                return "function" == typeof an.toESObservable ? an.toESObservable(e) : e;
            }
        };
        on = sn;
        function ln(e) {
            return (ln = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        var cn = function(e, t) {
            return function() {
                return t(e.apply(void 0, arguments));
            };
        }, un = function(e, t) {
            if ("function" == typeof e) return cn(e, t);
            if ("object" !== ln(e) || null === e) throw new Error("bindActionCreators expected an object or a function, instead received ".concat(null === e ? "null" : ln(e), ". ") + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
            for(var n = Object.keys(e), r = {}, o = 0; o < n.length; o++){
                var a = n[o], i = e[a];
                "function" == typeof i && (r[a] = cn(i, t));
            }
            return r;
        }, fn = "frame-component-library/dropdown/OPEN_MENU", pn = "frame-component-library/dropdown/CLOSE_MENU", dn = function() {
            return {
                type: fn
            };
        }, hn = function() {
            return {
                type: pn
            };
        }, yn = function(e) {
            return {
                type: "frame-component-library/dropdown/FOCUS_NEXT_OPTION",
                payload: {
                    maxIndex: e
                }
            };
        }, mn = function(e) {
            return {
                type: "frame-component-library/dropdown/FOCUS_PREV_OPTION",
                payload: {
                    maxIndex: e
                }
            };
        }, bn = "frame-component-library/dropdown/SELECT_OPTION", gn = function(e, t) {
            return {
                type: bn,
                payload: {
                    optionIndex: e,
                    optionValue: t
                }
            };
        };
        function vn(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = null != arguments[t] ? arguments[t] : {}, r = Object.keys(n);
                "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(e) {
                    return Object.getOwnPropertyDescriptor(n, e).enumerable;
                }))), r.forEach(function(t) {
                    On(e, t, n[t]);
                });
            }
            return e;
        }
        function On(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        var An = {
            selectedValue: null,
            selectedOption: 0,
            focusedIndex: 0,
            isOpen: !1
        };
        function wn(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        function Sn(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        var En = rn(tn("state", "dispatch", function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : An, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            switch(t.type){
                case fn:
                    return vn({}, e, {
                        isOpen: !0,
                        focusedIndex: e.selectedOption
                    });
                case pn:
                    return vn({}, e, {
                        isOpen: !1
                    });
                case "frame-component-library/dropdown/FOCUS_NEXT_OPTION":
                    var n = t.payload.maxIndex, r = e.focusedIndex;
                    return vn({}, e, {
                        focusedIndex: r === n ? 0 : r + 1
                    });
                case "frame-component-library/dropdown/FOCUS_PREV_OPTION":
                    var o = t.payload.maxIndex, a = e.focusedIndex;
                    return vn({}, e, {
                        focusedIndex: 0 === a ? o : a - 1
                    });
                case bn:
                    var i = t.payload, s = i.optionIndex;
                    return vn({}, e, {
                        selectedOption: s,
                        selectedValue: i.optionValue,
                        focusedIndex: s || 0
                    });
                default:
                    return e;
            }
        }, An), en(function(e) {
            var t = e.state, n = e.dispatch, r = Sn(e, [
                "state",
                "dispatch"
            ]);
            return function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = null != arguments[t] ? arguments[t] : {}, r = Object.keys(n);
                    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(e) {
                        return Object.getOwnPropertyDescriptor(n, e).enumerable;
                    }))), r.forEach(function(t) {
                        wn(e, t, n[t]);
                    });
                }
                return e;
            }({}, t, un({
                focusNextOption: yn,
                focusPrevOption: mn,
                selectOption: gn,
                openMenu: dn,
                closeMenu: hn
            }, n), r);
        })), Dn = En(Ht);
        Dn.propTypes = {
            caseSensitive: i.a.bool,
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            defaultValue: i.a.string,
            errorMessage: i.a.string,
            exactMatch: i.a.bool,
            helpMessage: i.a.string,
            isDisabled: i.a.bool,
            label: i.a.string.isRequired,
            onBlur: i.a.func,
            onChange: i.a.func,
            onFocus: i.a.func,
            placeholder: i.a.string,
            tabIndex: i.a.oneOfType([
                i.a.number,
                i.a.string
            ]),
            value: i.a.string,
            zIndex: i.a.oneOfType([
                i.a.string,
                i.a.number
            ])
        }, Dn.displayName = "Combobox";
        var kn = Dn;
        function Mn(e) {
            return (Mn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Cn() {
            return (Cn = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function xn(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function _n(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Tn(e, t) {
            return !t || "object" !== Mn(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function jn(e) {
            return (jn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function In(e, t) {
            return (In = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Rn = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), Tn(this, jn(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && In(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.children, n = e.className, r = e.elementType, a = e.isFixedFluid, i = xn(e, [
                            "children",
                            "className",
                            "elementType",
                            "isFixedFluid"
                        ]), s = l()(n, {
                            "fixed-fluid": a
                        }, "ncss-container");
                        return o.a.createElement(r, Cn({
                            className: s
                        }, i), t);
                    }
                }
            ], _n(n.prototype, r), a && _n(n, a), t;
        }();
        Rn.propTypes = {
            isFixedFluid: i.a.bool,
            className: i.a.string,
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            elementType: i.a.oneOfType([
                i.a.string,
                i.a.element
            ])
        }, Rn.defaultProps = {
            elementType: "div"
        }, Rn.displayName = "Container";
        var Pn = Rn;
        n(169);
        function Nn(e) {
            return (Nn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Bn(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Yn(e) {
            return (Yn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Qn(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function Un(e, t) {
            return (Un = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Fn = function(e) {
            return e.length <= 2 && !Number.isNaN(e) && Number(e) === Math.abs(e);
        }, Hn = function(e, t) {
            return R()(e, t ? "HH" : "h", !0).isValid() && Number(e) < 24;
        }, Gn = function(e) {
            return R()(e, "mm", !0).isValid();
        }, Jn = function(e) {
            function t(e) {
                var n, r, o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), r = this, (n = !(o = Yn(t).call(this, e)) || "object" !== Nn(o) && "function" != typeof o ? Qn(r) : o)._handleSetDisplayedHours = n._handleSetDisplayedHours.bind(Qn(n)), n._handleSetDisplayedMinutes = n._handleSetDisplayedMinutes.bind(Qn(n)), n._handleToggleDisplayedMeridiem = n._handleToggleDisplayedMeridiem.bind(Qn(n)), n._handleFocusHours = n._handleFocusHours.bind(Qn(n)), n._handleFocusMinutes = n._handleFocusMinutes.bind(Qn(n)), n._handleBlurHours = n._handleBlurHours.bind(Qn(n)), n._handleBlurMinutes = n._handleBlurMinutes.bind(Qn(n)), n._handleKeyUpHours = n._handleKeyUpHours.bind(Qn(n)), n._handleKeyUpMinutes = n._handleKeyUpMinutes.bind(Qn(n)), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Un(e, t);
            }(t, h), n = t, r = [
                {
                    key: "_handleSetDisplayedHours",
                    value: function(e) {
                        var t = this.props.handleSetDisplayedHours, n = e.target.value;
                        Fn(n) && t(n);
                    }
                },
                {
                    key: "_handleSetDisplayedMinutes",
                    value: function(e) {
                        var t = this.props.handleSetDisplayedMinutes, n = e.target.value;
                        Fn(n) && t(n);
                    }
                },
                {
                    key: "_handleToggleDisplayedMeridiem",
                    value: function() {
                        this.props.handleToggleDisplayedMeridiem();
                    }
                },
                {
                    key: "_handleFocusHours",
                    value: function() {
                        this.props.handleSetHoursFocused(!0);
                    }
                },
                {
                    key: "_handleFocusMinutes",
                    value: function() {
                        this.props.handleSetMinutesFocused(!0);
                    }
                },
                {
                    key: "_handleBlurHours",
                    value: function() {
                        this.props.handleSetHoursFocused(!1);
                    }
                },
                {
                    key: "_handleBlurMinutes",
                    value: function() {
                        this.props.handleSetMinutesFocused(!1);
                    }
                },
                {
                    key: "_handleKeyUpHours",
                    value: function(e) {
                        var t = this.props, n = t.handleSetHoursFocused, r = t.isMilitaryTime, o = e.target.value;
                        2 === o.length && Hn(o, r) && n(!1);
                    }
                },
                {
                    key: "_handleKeyUpMinutes",
                    value: function(e) {
                        var t = this.props.handleSetMinutesFocused, n = e.target.value;
                        2 === n.length && Gn(n) && t(!1);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.hoursFocused, n = e.minutesFocused, r = e.displayedHours, a = e.displayedMinutes, i = e.displayedMeridiem, s = e.isMilitaryTime;
                        return o.a.createElement("div", {
                            className: "time-input-container pt3-sm pl3-sm pr3-sm"
                        }, o.a.createElement(fe, {
                            value: r,
                            onChange: this._handleSetDisplayedHours,
                            onFocus: this._handleFocusHours,
                            onBlur: this._handleBlurHours,
                            onKeyUp: this._handleKeyUpHours,
                            containerClassName: "d-sm-ib va-sm-m mr1-sm",
                            label: "",
                            errorMessage: Hn(r) || t ? "" : " "
                        }), ":", o.a.createElement(fe, {
                            value: a,
                            onChange: this._handleSetDisplayedMinutes,
                            onFocus: this._handleFocusMinutes,
                            onBlur: this._handleBlurMinutes,
                            onKeyUp: this._handleKeyUpMinutes,
                            containerClassName: "d-sm-ib va-sm-m mr1-sm ml1-sm",
                            label: "",
                            errorMessage: Gn(a) || n ? "" : " "
                        }), !s && o.a.createElement(j, {
                            onClick: this._handleToggleDisplayedMeridiem,
                            className: "d-sm-ib va-sm-m ml2-sm",
                            kind: "secondary"
                        }, i));
                    }
                }
            ], Bn(n.prototype, r), a && Bn(n, a), t;
        }(), Wn = n(64), Kn = n.n(Wn);
        function Ln(e) {
            return (Ln = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Vn(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Zn(e, t) {
            return !t || "object" !== Ln(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function qn(e) {
            return (qn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function zn(e, t) {
            return (zn = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Xn = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = Zn(this, qn(t).call(this, e)))._bind("_handleSelectDay"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && zn(e, t);
            }(t, h), n = t, r = [
                {
                    key: "_handleSelectDay",
                    value: function() {
                        var e = this.props, t = e.onDateSelection, n = e.date;
                        e.isSelectedMonth && t(n);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.hasError, n = e.isSelectedMonth, r = e.isSelectedDay, a = e.date, i = l()({
                            "text-color-light-grey u-cursor-default": !n,
                            "enable u-cursor-pointer": n,
                            "text-color-white": r,
                            "bg-accent": r && !t,
                            "bg-error": r && t
                        }, "calendar-day d-sm-tc ta-sm-c va-sm-m pt1-sm pb1-sm prl1-sm"), s = l()({
                            today: R()(a).isSame(R()(), "day")
                        }), c = a.getDate();
                        return o.a.createElement("div", {
                            className: i,
                            onClick: this._handleSelectDay
                        }, o.a.createElement("div", {
                            className: s
                        }, c));
                    }
                }
            ], Vn(n.prototype, r), a && Vn(n, a), t;
        }();
        Xn.propTypes = {
            date: i.a.object.isRequired,
            hasError: i.a.bool,
            isSelectedMonth: i.a.bool.isRequired,
            isSelectedDay: i.a.bool.isRequired
        }, Xn.displayName = "Day";
        var $n = Xn;
        n(173);
        function er(e) {
            return (er = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function tr(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function nr(e, t) {
            return !t || "object" !== er(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function rr(e) {
            return (rr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function or(e, t) {
            return (or = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var ar = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = nr(this, rr(t).call(this, e)))._bind("_handleNextMonthSelection", "_handlePreviousMonthSelection"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && or(e, t);
            }(t, h), n = t, r = [
                {
                    key: "_handleNextMonthSelection",
                    value: function(e) {
                        var t = this.props, n = t.handleNextMonthSelection, r = t.handleChangeYear, o = t.displayedMonth, a = t.displayedYear, i = t.value, s = i ? R()(i) : R()();
                        s.month(o), s.year(parseInt(a, 10));
                        var l, c = (l = s, R()(l).add(1, "month").format("MMMM"));
                        n && (n(e, c), r && "January" === c && r(e, s.add(1, "year").format("YYYY")));
                    }
                },
                {
                    key: "_handlePreviousMonthSelection",
                    value: function(e) {
                        var t = this.props, n = t.handlePreviousMonthSelection, r = t.handleChangeYear, o = t.displayedMonth, a = t.displayedYear, i = t.value, s = i ? R()(i) : R()();
                        s.month(o), s.year(parseInt(a, 10));
                        var l, c = (l = s, R()(l).subtract(1, "month").format("MMMM"));
                        n && (n(e, c), r && "December" === c && r(e, s.subtract(1, "year").format("YYYY")));
                    }
                },
                {
                    key: "render",
                    value: function() {
                        for(var e = this.props, t = e.hasError, n = e.displayedMonth, r = e.displayedYear, a = e.selectedDate, i = e.onDateSelection, s = R()("".concat(r, " ").concat(n, " 01"), "YYYY MMMM 01"), l = [], c = R()(s).subtract(1, "month").endOf("month").day(0), u = 0; u < 42; u++){
                            var f = c.format("MMMM") === n, p = "" !== a && R()(a).isSame(c, "day"), d = {
                                date: c.toDate(),
                                isSelectedMonth: f,
                                isSelectedDay: p
                            };
                            l.push(d), c.add(1, "day");
                        }
                        return o.a.createElement("div", {
                            className: "calendar-container"
                        }, o.a.createElement("div", {
                            className: "calendar-header bg-black text-color-white pt1-sm pb1-sm"
                        }, o.a.createElement("div", {
                            className: "ncss-col-sm-3 ta-sm-r"
                        }, o.a.createElement("i", {
                            className: "g72-arrow-fill-left u-cursor-pointer",
                            onClick: this._handlePreviousMonthSelection
                        })), o.a.createElement("div", {
                            className: "ncss-col-sm-6 ncss-brand u-uppercase ta-sm-c"
                        }, n, "\xa0", r), o.a.createElement("div", {
                            className: "ncss-col-sm-3 ta-sm-l"
                        }, o.a.createElement("i", {
                            className: "g72-arrow-fill-right u-cursor-pointer",
                            onClick: this._handleNextMonthSelection
                        }))), o.a.createElement("div", {
                            className: "d-sm-t u-full-width"
                        }, o.a.createElement("div", {
                            className: "calendar-weekdays d-sm-tr text-color-grey"
                        }, [
                            "S",
                            "M",
                            "T",
                            "W",
                            "T",
                            "F",
                            "S"
                        ].map(function(e, t) {
                            return o.a.createElement("p", {
                                className: "weekday ta-sm-c va-sm-m d-sm-tc pb1-sm pt1-sm",
                                key: t
                            }, e);
                        })), Kn()(l, 7).map(function(e, n) {
                            return o.a.createElement("div", {
                                className: "d-sm-tr",
                                key: n
                            }, e.map(function(e, n) {
                                return o.a.createElement($n, {
                                    key: n,
                                    date: e.date,
                                    onDateSelection: i,
                                    isSelectedMonth: e.isSelectedMonth,
                                    isSelectedDay: e.isSelectedDay,
                                    hasError: t
                                });
                            }));
                        })));
                    }
                }
            ], tr(n.prototype, r), a && tr(n, a), t;
        }();
        ar.displayName = "Calendar";
        var ir = ar;
        n(175);
        function sr(e) {
            return (sr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function lr() {
            return (lr = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function cr(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function ur(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function fr(e, t) {
            return !t || "object" !== sr(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function pr(e) {
            return (pr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function dr(e, t) {
            return (dr = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var hr = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = fr(this, pr(t).call(this, e))).setHiddenControlRef = function(e) {
                    n.inputRef = e;
                }, n;
            }
            var n, a, i;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && dr(e, t);
            }(t, r["Component"]), n = t, a = [
                {
                    key: "componentDidUpdate",
                    value: function() {
                        this.props.isFocused && this.inputRef.focus();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.className, n = e.isFocused, r = e.onBlur, a = e.onFocus, i = e.onKeyDown, s = e.tabIndex, c = cr(e, [
                            "className",
                            "isFocused",
                            "onBlur",
                            "onFocus",
                            "onKeyDown",
                            "tabIndex"
                        ]), u = l()(t, "hidden-control-container");
                        return o.a.createElement("div", lr({
                            className: u
                        }, c), o.a.createElement("input", {
                            autoFocus: n,
                            onBlur: r,
                            onFocus: a,
                            onKeyDown: i,
                            ref: this.setHiddenControlRef,
                            tabIndex: s,
                            type: "text"
                        }));
                    }
                }
            ], ur(n.prototype, a), i && ur(n, i), t;
        }();
        hr.propTypes = {
            className: i.a.string,
            isFocused: i.a.bool,
            onBlur: i.a.func,
            onFocus: i.a.func,
            onKeyDown: i.a.func,
            tabIndex: i.a.oneOfType([
                i.a.number,
                i.a.string
            ])
        }, hr.displayName = "HiddenControl";
        var yr = hr;
        n(177);
        function mr(e) {
            return (mr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function br(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function gr(e, t) {
            return !t || "object" !== mr(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function vr(e) {
            return (vr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Or(e, t) {
            return (Or = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Ar = function(e) {
            var t = e.value, n = e.setDisplayedMonth, r = e.setDisplayedYear, o = e.setSelectedDate, a = e.setDisplayedHours, i = e.setDisplayedMinutes, s = e.setDisplayedMeridiem, l = e.isMilitaryTime, c = t ? new Date(t) : "", u = c ? R()(c) : R()(), f = u.format("MMMM"), p = u.format("YYYY"), d = u.format(l ? "HH" : "hh"), h = u.format("mm"), y = u.format("a");
            o(c), n(f), r(p), a(d), i(h), s(y);
        }, wr = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = gr(this, vr(t).call(this, e)))._bind("_handleClearValue", "_handleToggleDatePicker", "_handleCloseDatePicker", "_handleSelectMonth", "_handleChangeDisplayedYear", "_handleMouseEnter", "_handleMouseLeave", "_handleSaveClick", "_handleCancelClick", "_handleSelectDate"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Or(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentDidMount",
                    value: function() {
                        Ar(this.props);
                    }
                },
                {
                    key: "componentWillReceiveProps",
                    value: function(e) {
                        e.value === this.props.value && e.isActive === this.props.isActive || Ar(e);
                    }
                },
                {
                    key: "getMoment",
                    value: function() {
                        var e = this.props, t = e.selectedDate, n = e.displayedHours, r = e.displayedMinutes, o = e.displayedMeridiem, a = e.isMilitaryTime;
                        if ("" !== t) {
                            var i, s = R()(t).format("YYYY MMMM DD");
                            if (a) i = R()("".concat(s, " ").concat(n, " ").concat(r), "YYYY MMMM DD HH mm");
                            else {
                                var l = Number(n);
                                i = l > 12 || l < 1 ? R()("".concat(s, " ").concat(r, " ").concat(o), "YYYY MMMM DD hh mm a") : R()("".concat(s, " ").concat(n, " ").concat(r, " ").concat(o), "YYYY MMMM DD hh mm a");
                            }
                            return i;
                        }
                        return null;
                    }
                },
                {
                    key: "_handleClearValue",
                    value: function() {
                        var e = this.props, t = e.setSelectedDate;
                        e.isDisabled || t("");
                    }
                },
                {
                    key: "_handleToggleDatePicker",
                    value: function() {
                        var e = this.props, t = e.isDisabled, n = e.isReadOnly, r = e.toggleDatePicker;
                        t || n || r();
                    }
                },
                {
                    key: "_handleCloseDatePicker",
                    value: function() {
                        var e = this.props, t = e.closeDatePicker, n = e.keepCalendarOpen, r = e.isDisabled, o = e.isReadOnly, a = e.errorMessage;
                        r || o || n || a || t();
                    }
                },
                {
                    key: "_handleChangeDisplayedYear",
                    value: function(e, t) {
                        this.props.setDisplayedYear(t);
                    }
                },
                {
                    key: "_handleSelectMonth",
                    value: function(e, t) {
                        this.props.setDisplayedMonth(t);
                    }
                },
                {
                    key: "_handleSelectDate",
                    value: function(e) {
                        this.props.setSelectedDate(e);
                    }
                },
                {
                    key: "_handleMouseEnter",
                    value: function() {
                        this.props.setKeepCalendarOpen(!0);
                    }
                },
                {
                    key: "_handleMouseLeave",
                    value: function() {
                        this.props.setKeepCalendarOpen(!1);
                    }
                },
                {
                    key: "_handleSaveClick",
                    value: function() {
                        var e = this.props, t = e.closeDatePicker, n = e.selectedDate, r = e.onChange, o = e.isDisabled, a = e.isReadOnly, i = e.errorMessage;
                        if (!o && !a && !i) {
                            if ("" === n) r && r(""), t();
                            else {
                                var s = this.getMoment();
                                s && s.isValid() && (r && r(s.toDate()), t());
                            }
                        }
                    }
                },
                {
                    key: "_handleCancelClick",
                    value: function() {
                        var e = this.props, t = e.closeDatePicker, n = e.value;
                        (0, e.setSelectedDate)(n), t();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.value, n = e.isActive, r = e.isDisabled, a = e.zIndex, i = e.isReadOnly, s = e.label, c = e.placeholder, u = e.dateFormat, f = e.errorMessage, p = e.displayedMonth, d = e.displayedYear, h = e.selectedDate, y = e.hasTimePicker, m = e.isMilitaryTime, b = e.displayedHours, g = e.displayedMinutes, v = e.displayedMeridiem, O = e.setDisplayedHours, A = e.setDisplayedMinutes, w = e.toggleDisplayedMeridiem, S = e.setHoursFocused, E = e.setMinutesFocused, D = e.hoursFocused, k = e.minutesFocused, M = l()(function(e, t, n) {
                            return t in e ? Object.defineProperty(e, t, {
                                value: n,
                                enumerable: !0,
                                configurable: !0,
                                writable: !0
                            }) : e[t] = n, e;
                        }({}, "z".concat(a), a), "ncss-input-container date-input-container"), C = l()({
                            "text-color-light-grey": r,
                            "text-color-grey": !r
                        }, "ncss-label pb1-sm"), x = l()({
                            "text-color-light-grey": r,
                            "text-color-grey u-cursor-pointer": !r
                        }, "g72-edit"), _ = l()({
                            "text-color-light-grey": r,
                            "u-underline": !i,
                            "placeholder-active u-cursor-pointer": !i && !r
                        }), T = this.getMoment(), I = "", P = "", N = f, B = !!f;
                        return T && (I = t ? R()(t).format(u) : c, T.isValid() ? P = T.format(u) : (N = f || T.format(), B = !0)), o.a.createElement("div", {
                            className: M
                        }, o.a.createElement("div", {
                            className: "d-sm-t u-full-width border-bottom-light-grey"
                        }, o.a.createElement("div", {
                            className: "d-sm-tr"
                        }, o.a.createElement("div", {
                            className: "d-sm-tc"
                        }, o.a.createElement("label", {
                            className: C
                        }, s)), !i && o.a.createElement("div", {
                            className: "d-sm-tc ta-sm-r"
                        }, o.a.createElement("i", {
                            className: x,
                            onClick: this._handleToggleDatePicker
                        })))), n && !i && !r && o.a.createElement("div", null, o.a.createElement(fe, {
                            containerClassName: "mt3-sm mb3-sm",
                            value: P,
                            errorMessage: N,
                            inputIcon: "g72-x-circle",
                            onIconClick: this._handleClearValue,
                            isReadOnly: !0,
                            label: "",
                            onMouseEnter: this._handleMouseEnter,
                            onMouseLeave: this._handleMouseLeave
                        }), o.a.createElement(yr, {
                            isFocused: n && !D && !k,
                            onBlur: this._handleCloseDatePicker
                        }), o.a.createElement(Ne, {
                            paddingTop: 16,
                            paddingBottom: 16,
                            position: "absolute"
                        }, o.a.createElement("div", {
                            className: "date-input-overlay border-light-grey",
                            onMouseEnter: this._handleMouseEnter,
                            onMouseLeave: this._handleMouseLeave
                        }, o.a.createElement(ir, {
                            value: t,
                            displayedYear: d,
                            displayedMonth: p,
                            selectedDate: h,
                            hasError: B,
                            dateFormat: u,
                            isActive: n,
                            handleChangeYear: this._handleChangeDisplayedYear,
                            handleNextMonthSelection: this._handleSelectMonth,
                            handlePreviousMonthSelection: this._handleSelectMonth,
                            onDateSelection: this._handleSelectDate,
                            handleCloseDatePicker: this._handleCloseDatePicker
                        }), y && o.a.createElement(Jn, {
                            hoursFocused: D,
                            minutesFocused: k,
                            isMilitaryTime: m,
                            displayedHours: b,
                            displayedMinutes: g,
                            displayedMeridiem: v,
                            handleSetDisplayedHours: O,
                            handleSetDisplayedMinutes: A,
                            handleToggleDisplayedMeridiem: w,
                            handleSetHoursFocused: S,
                            handleSetMinutesFocused: E
                        }), o.a.createElement("div", {
                            className: "d-sm-t u-full-width pl3-sm pr3-sm mt2-sm"
                        }, o.a.createElement(j, {
                            kind: "primary",
                            className: "u-full-width",
                            onClick: this._handleSaveClick
                        }, "SELECT"), o.a.createElement(j, {
                            kind: "secondary",
                            className: "u-full-width mt2-sm mb2-sm",
                            onClick: this._handleCancelClick
                        }, "CANCEL"))))), (!n || i || r) && o.a.createElement("small", {
                            className: "pt2-sm"
                        }, o.a.createElement("span", {
                            className: _,
                            onClick: this._handleToggleDatePicker
                        }, t ? I : c)));
                    }
                }
            ], br(n.prototype, r), a && br(n, a), t;
        }();
        wr.propTypes = {
            value: i.a.string,
            isActive: i.a.bool,
            isDisabled: i.a.bool,
            isReadOnly: i.a.bool,
            hasTimePicker: i.a.bool,
            isMilitaryTime: i.a.bool,
            label: i.a.string.isRequired,
            placeholder: i.a.string.isRequired,
            dateFormat: i.a.string.isRequired,
            errorMessage: i.a.string,
            handleClearValue: i.a.func
        }, wr.displayName = "DateInput";
        var Sr = wr, Er = "frame-component-library/dateinput/OPEN_DATE_PICKER", Dr = function(e) {
            return {
                type: "frame-component-library/dateinput/SET_DISPLAYED_YEAR",
                payload: {
                    yearToDisplay: e
                }
            };
        }, kr = function(e) {
            return {
                type: "frame-component-library/dateinput/SET_DIPLAYED_MONTH",
                payload: {
                    monthToDisplay: e
                }
            };
        }, Mr = function(e) {
            return {
                type: "frame-component-library/dateinput/SET_DISPLAYED_HOURS",
                payload: {
                    hoursToDisplay: e
                }
            };
        }, Cr = function(e) {
            return {
                type: "frame-component-library/dateinput/SET_DISPLAYED_MINUTES",
                payload: {
                    minutesToDisplay: e
                }
            };
        }, xr = function(e) {
            return {
                type: "frame-component-library/dateinput/SET_DISPLAYED_MERIDIEM",
                payload: {
                    meridiemToDisplay: e
                }
            };
        }, _r = function() {
            return {
                type: "frame-component-library/dateinput/TOGGLE_DISPLAYED_MERIDIEM"
            };
        }, Tr = function(e) {
            return {
                type: "frame-component-library/dateinput/SET_HOURS_FOCUSED",
                payload: {
                    isFocused: e
                }
            };
        }, jr = function(e) {
            return {
                type: "frame-component-library/dateinput/SET_MINUTES_FOCUSED",
                payload: {
                    isFocused: e
                }
            };
        }, Ir = function(e) {
            return {
                type: "frame-component-library/dateinput/SET_SELECTED_DATE",
                payload: {
                    date: e
                }
            };
        }, Rr = function(e) {
            return {
                type: "frame-component-library/dateinput/KEEP_CALENDAR_OPEN",
                payload: {
                    open: e
                }
            };
        }, Pr = function() {
            return {
                type: "frame-component-library/dateinput/TOGGLE_DATE_PICKER"
            };
        }, Nr = function() {
            return {
                type: Er
            };
        }, Br = function() {
            return {
                type: "frame-component-library/dateinput/CLOSE_DATE_PICKER"
            };
        }, Yr = {
            isActive: !1,
            displayedMonth: "",
            displayedYear: "",
            displayedHours: "",
            displayedMinutes: "",
            displayedMeridiem: "am",
            hoursFocused: !1,
            minutesFocused: !1,
            selectedDate: new Date,
            keepCalendarOpen: !0
        };
        function Qr(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        function Ur(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        var Fr = rn(tn("state", "dispatch", function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Yr, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            switch(t.type){
                case "frame-component-library/dateinput/KEEP_CALENDAR_OPEN":
                    return Object.assign({}, e, {
                        keepCalendarOpen: t.payload.open
                    });
                case "frame-component-library/dateinput/TOGGLE_DATE_PICKER":
                    return Object.assign({}, e, {
                        isActive: !e.isActive
                    });
                case Er:
                    return Object.assign({}, e, {
                        isActive: !0
                    });
                case "frame-component-library/dateinput/CLOSE_DATE_PICKER":
                    return Object.assign({}, e, {
                        isActive: !1
                    });
                case "frame-component-library/dateinput/SET_DIPLAYED_MONTH":
                    return Object.assign({}, e, {
                        displayedMonth: t.payload.monthToDisplay
                    });
                case "frame-component-library/dateinput/SET_DISPLAYED_YEAR":
                    return Object.assign({}, e, {
                        displayedYear: t.payload.yearToDisplay
                    });
                case "frame-component-library/dateinput/SET_DISPLAYED_HOURS":
                    return Object.assign({}, e, {
                        displayedHours: t.payload.hoursToDisplay
                    });
                case "frame-component-library/dateinput/SET_DISPLAYED_MINUTES":
                    return Object.assign({}, e, {
                        displayedMinutes: t.payload.minutesToDisplay
                    });
                case "frame-component-library/dateinput/SET_DISPLAYED_MERIDIEM":
                    return Object.assign({}, e, {
                        displayedMeridiem: t.payload.meridiemToDisplay
                    });
                case "frame-component-library/dateinput/TOGGLE_DISPLAYED_MERIDIEM":
                    return Object.assign({}, e, {
                        displayedMeridiem: "am" === e.displayedMeridiem ? "pm" : "am"
                    });
                case "frame-component-library/dateinput/SET_HOURS_FOCUSED":
                    return Object.assign({}, e, {
                        hoursFocused: t.payload.isFocused
                    });
                case "frame-component-library/dateinput/SET_MINUTES_FOCUSED":
                    return Object.assign({}, e, {
                        minutesFocused: t.payload.isFocused
                    });
                case "frame-component-library/dateinput/SET_SELECTED_DATE":
                    return Object.assign({}, e, {
                        selectedDate: t.payload.date
                    });
                default:
                    return e;
            }
        }, Yr), en(function(e) {
            var t = e.state, n = e.dispatch, r = Ur(e, [
                "state",
                "dispatch"
            ]);
            return function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = null != arguments[t] ? arguments[t] : {}, r = Object.keys(n);
                    "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(e) {
                        return Object.getOwnPropertyDescriptor(n, e).enumerable;
                    }))), r.forEach(function(t) {
                        Qr(e, t, n[t]);
                    });
                }
                return e;
            }({}, t, un({
                toggleDatePicker: Pr,
                openDatePicker: Nr,
                closeDatePicker: Br,
                setDisplayedMonth: kr,
                setDisplayedYear: Dr,
                setSelectedDate: Ir,
                setDisplayedHours: Mr,
                setDisplayedMinutes: Cr,
                setDisplayedMeridiem: xr,
                toggleDisplayedMeridiem: _r,
                setHoursFocused: Tr,
                setMinutesFocused: jr,
                setKeepCalendarOpen: Rr
            }, n), r);
        }))(Sr);
        Fr.defaultProps = {
            dateFormat: "ddd, MMMM Do YYYY"
        }, Fr.displayName = "DatePicker", Fr.propTypes = {
            isActive: i.a.bool,
            isDisabled: i.a.bool,
            isReadOnly: i.a.bool,
            hasTimePicker: i.a.bool,
            isMilitaryTime: i.a.bool,
            label: i.a.string.isRequired,
            placeholder: i.a.string.isRequired,
            value: i.a.string,
            dateFormat: i.a.string.isRequired,
            errorMessage: i.a.string,
            onChange: i.a.func
        };
        var Hr = Fr;
        function Gr(e) {
            return (Gr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Jr() {
            return (Jr = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Wr(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Kr(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Lr(e, t) {
            return !t || "object" !== Gr(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function Vr(e) {
            return (Vr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Zr(e, t) {
            return (Zr = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var qr = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), Lr(this, Vr(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Zr(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.className, n = e.isInline, r = Wr(e, [
                            "className",
                            "isInline"
                        ]), a = l()(t, "ncss-form-group", {
                            "inline bs2": n
                        });
                        return o.a.createElement("div", Jr({}, r, {
                            className: a
                        }), this.props.children);
                    }
                }
            ], Kr(n.prototype, r), a && Kr(n, a), t;
        }();
        qr.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            isInline: i.a.bool
        }, qr.displayName = "FormGroup";
        var zr = qr;
        n(179);
        function Xr(e) {
            return (Xr = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function $r(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function eo(e, t) {
            return !t || "object" !== Xr(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function to(e) {
            return (to = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function no(e, t) {
            return (no = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var ro = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), eo(this, to(t).apply(this, arguments));
            }
            var n, a, i;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && no(e, t);
            }(t, r["Component"]), n = t, a = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.className, n = e.height, r = e.isNotCentered, a = e.kind, i = e.style, s = e.width, c = l()({
                            "ta-sm-c u-full-width pt12-sm": !r
                        }, t), u = {
                            width: "".concat(s, "px"),
                            height: "".concat(n, "px")
                        };
                        return o.a.createElement("div", {
                            className: c,
                            style: i
                        }, o.a.createElement("div", {
                            className: "d-sm-ib spinner-style ".concat(a),
                            style: u
                        }));
                    }
                }
            ], $r(n.prototype, a), i && $r(n, i), t;
        }();
        ro.displayName = "Loading", ro.propTypes = {
            className: i.a.string,
            height: i.a.number,
            isNotCentered: i.a.bool,
            kind: i.a.oneOf([
                "primary",
                "secondary"
            ]),
            style: i.a.object,
            width: i.a.number
        }, ro.defaultProps = {
            height: 32,
            width: 32,
            kind: "primary"
        };
        var oo = ro, ao = n(65), io = n.n(ao);
        function so() {
            return "undefined" != typeof window;
        }
        n(181);
        function lo(e) {
            return (lo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function co() {
            return (co = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function uo(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function fo(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function po(e, t) {
            return !t || "object" !== lo(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function ho(e) {
            return (ho = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function yo(e, t) {
            return (yo = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var mo = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = po(this, ho(t).call(this, e)))._bind("_onEscapeKeyDown", "_onClickOut", "_onClickOnX"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && yo(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentDidMount",
                    value: function() {
                        so() && (window.addEventListener("mousedown", this._onClickOut), window.addEventListener("keydown", this._onEscapeKeyDown));
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        so() && (window.removeEventListener("mousedown", this._onClickOut), window.removeEventListener("keydown", this._onEscapeKeyDown));
                    }
                },
                {
                    key: "_onClickOut",
                    value: function(e) {
                        if (this.props.isOpen && this.props.onClickOut) {
                            var t = io.a.findDOMNode(this);
                            e.target === t && this.props.onClickOut(e);
                        }
                    }
                },
                {
                    key: "_onEscapeKeyDown",
                    value: function(e) {
                        this.props.isOpen && "Escape" === e.code && this.props.onEscapeKeyDown && this.props.onEscapeKeyDown(e);
                    }
                },
                {
                    key: "_onClickOnX",
                    value: function() {
                        var e = this.props, t = e.onClickOnX;
                        e.isOpen && t();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.children, n = e.className, r = e.isOpen, a = e.onClickOnX, i = (e.onClickOut, e.onEscapeKeyDown, e.styles), s = e.title, c = e.width, u = uo(e, [
                            "children",
                            "className",
                            "isOpen",
                            "onClickOnX",
                            "onClickOut",
                            "onEscapeKeyDown",
                            "styles",
                            "title",
                            "width"
                        ]), f = l()("modal", n), p = Object.assign({}, i, {
                            width: c
                        });
                        return r && o.a.createElement("div", co({
                            className: f
                        }, u), o.a.createElement("div", {
                            className: "modal-content border-medium-grey p4-sm",
                            style: p
                        }, a && o.a.createElement("div", {
                            className: "h4 fl-sm-r u-cursor-pointer"
                        }, o.a.createElement("i", {
                            className: "g72-x",
                            onClick: this._onClickOnX
                        })), o.a.createElement("div", {
                            className: "ncss-brand ta-sm-c pt8-sm pb4-sm u-uppercase h4"
                        }, s), t));
                    }
                }
            ], fo(n.prototype, r), a && fo(n, a), t;
        }();
        mo.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            isOpen: i.a.bool,
            onClickOnX: i.a.func,
            onClickOut: i.a.func,
            onEscapeKeyDown: i.a.func,
            title: i.a.string,
            styles: i.a.object,
            width: i.a.string
        }, mo.defaultProps = {
            width: "600px"
        }, mo.displayName = "Modal";
        var bo = mo;
        n(41);
        function go(e) {
            return (go = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function vo() {
            return (vo = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Oo(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Ao(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function wo(e, t) {
            return !t || "object" !== go(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function So(e) {
            return (So = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Eo(e, t) {
            return (Eo = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Do = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), wo(this, So(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Eo(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.children, n = e.className, r = e.headerColumnSize, a = e.headerSize, i = e.label, s = Oo(e, [
                            "children",
                            "className",
                            "headerColumnSize",
                            "headerSize",
                            "label"
                        ]), c = l()(n, "ncss-container bg-black");
                        return o.a.createElement("header", vo({
                            className: c
                        }, s), o.a.createElement("div", {
                            className: "ncss-row"
                        }, o.a.createElement("div", {
                            className: "ncss-col-sm-".concat(r, " pb2-sm pt2-sm prl6-sm va-sm-m")
                        }, o.a.createElement("div", {
                            className: "".concat(a, " ncss-brand text-color-white u-uppercase")
                        }, i)), o.a.createElement("nav", {
                            className: "ncss-col-sm-".concat(12 - r, " prl0-sm va-sm-m ta-sm-r")
                        }, t)));
                    }
                }
            ], Ao(n.prototype, r), a && Ao(n, a), t;
        }();
        Do.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            headerColumnSize: i.a.string,
            headerSize: i.a.string,
            label: i.a.node
        }, Do.displayName = "Nav", Do.defaultProps = {
            headerSize: "h3",
            headerColumnSize: "6"
        };
        var ko = Do;
        n(184);
        function Mo() {
            return (Mo = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Co(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        var xo = function(e) {
            var t, n, r, a = e.className, i = e.children, s = e.label, c = e.zIndex, u = Co(e, [
                "className",
                "children",
                "label",
                "zIndex"
            ]), f = l()(a, "ncss-flyout nav-dropdown pt3-sm pr0-sm pb3-sm pl0-sm"), p = l()("ncss-flyout-options", (t = {}, n = "z".concat(c), r = c, n in t ? Object.defineProperty(t, n, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : t[n] = r, t));
            return o.a.createElement("div", Mo({
                className: f
            }, u), o.a.createElement("div", {
                className: "nav-link u-full-width ta-sm-r ncss-flyout-btn text-color-white bg-black"
            }, s), o.a.createElement("div", {
                className: p
            }, i && i.map(function(e) {
                var t = l()(e.props.className, "ncss-option ta-sm-r pt2-sm pr5-sm pb2-sm pl5-sm");
                return o.a.cloneElement(e, {
                    key: e.props.navKey,
                    className: t
                });
            })));
        };
        xo.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            label: i.a.string.isRequired,
            zIndex: i.a.oneOfType([
                i.a.string,
                i.a.number
            ])
        }, xo.displayName = "NavDropdown";
        var _o = xo;
        function To(e) {
            return (To = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function jo() {
            return (jo = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Io(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Ro(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Po(e, t) {
            return !t || "object" !== To(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function No(e) {
            return (No = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Bo(e, t) {
            return (Bo = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Yo = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = Po(this, No(t).call(this, e)))._bind("_onClick"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Bo(e, t);
            }(t, h), n = t, r = [
                {
                    key: "_onClick",
                    value: function(e) {
                        var t = this.props, n = t.isDisabled, r = t.onClick, o = t.navKey;
                        r && !n && r(e, o);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.children, n = e.className, r = e.elementType, a = e.isActive, i = e.isDisabled, s = e.label, c = e.navKey, u = Io(e, [
                            "children",
                            "className",
                            "elementType",
                            "isActive",
                            "isDisabled",
                            "label",
                            "navKey"
                        ]), f = l()(n, "nav-link ncss-btn-black pt5-sm pr5-sm pb5-sm pl5-sm", {
                            active: a
                        });
                        return o.a.createElement(r, jo({}, u, {
                            key: c,
                            className: f,
                            disabled: i,
                            onClick: this._onClick
                        }), "string" == typeof r && s || t);
                    }
                }
            ], Ro(n.prototype, r), a && Ro(n, a), t;
        }();
        Yo.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            elementType: i.a.oneOfType([
                i.a.string,
                i.a.func
            ]),
            href: i.a.string,
            isActive: i.a.bool,
            isDisabled: i.a.bool,
            label: i.a.string,
            navKey: i.a.string,
            onClick: i.a.func
        }, Yo.defaultProps = {
            elementType: "a"
        }, Yo.displayName = "NavItem";
        var Qo = Yo;
        function Uo(e) {
            return (Uo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Fo() {
            return (Fo = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Ho(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Go(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Jo(e, t) {
            return !t || "object" !== Uo(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function Wo(e) {
            return (Wo = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Ko(e, t) {
            return (Ko = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Lo = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), Jo(this, Wo(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Ko(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.children, n = e.className, r = e.height, a = e.isDisabled, i = e.isOpen, s = e.label, c = e.onHeaderClick, u = Ho(e, [
                            "children",
                            "className",
                            "height",
                            "isDisabled",
                            "isOpen",
                            "label",
                            "onHeaderClick"
                        ]), f = l()({
                            "g72-plus": !i,
                            "g72-minus": i
                        }, "fl-sm-r"), p = l()({
                            "d-sm-h": !i
                        }, "pt1-sm pb1-sm"), d = {};
                        return r && (d.height = r, d.overflowY = "auto"), o.a.createElement("div", Fo({
                            className: n
                        }, u), o.a.createElement("div", {
                            className: "pt1-sm pb1-sm u-cursor-pointer",
                            onClick: a ? null : c
                        }, o.a.createElement("span", {
                            className: "h6 ncss-brand u-uppercase"
                        }, s), o.a.createElement("i", {
                            className: f
                        })), o.a.createElement("div", {
                            className: p,
                            style: d
                        }, t));
                    }
                }
            ], Go(n.prototype, r), a && Go(n, a), t;
        }();
        Lo.propTypes = {
            className: i.a.string,
            height: i.a.number,
            isDisabled: i.a.bool,
            isOpen: i.a.bool,
            label: i.a.string.isRequired,
            onHeaderClick: i.a.func
        }, Lo.displayName = "Panel";
        var Vo = Lo;
        n(186);
        function Zo(e) {
            return (Zo = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function qo(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function zo(e, t) {
            return !t || "object" !== Zo(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function Xo(e) {
            return (Xo = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function $o(e, t) {
            return ($o = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var ea = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), zo(this, Xo(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && $o(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.value, n = e.color, r = e.animateColorStripe, a = e.animateTransitions, i = Math.floor(t), s = i < 100 ? "".concat(i, "%") : "100%", c = n, u = l()("fill-color", {
                            animateTransitions: a,
                            animateColorStripe: r
                        });
                        return o.a.createElement("div", {
                            className: "progress-bar"
                        }, o.a.createElement("div", {
                            className: u,
                            style: {
                                width: s,
                                backgroundColor: c
                            }
                        }));
                    }
                }
            ], qo(n.prototype, r), a && qo(n, a), t;
        }();
        ea.propTypes = {
            value: i.a.number,
            color: i.a.string,
            animateColorStripe: i.a.bool,
            animateTransitions: i.a.bool
        }, ea.defaultProps = {
            value: 0,
            color: "#3498db"
        }, ea.displayName = "ProgressBar";
        var ta = ea, na = "frame-component-library/radio/SELECT_INDEX", ra = function(e) {
            return {
                type: na,
                payload: e
            };
        };
        function oa(e) {
            return (oa = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function aa() {
            return (aa = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function ia(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function sa(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function la(e) {
            return (la = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function ca(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function ua(e, t) {
            return (ua = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var fa = function(e) {
            function t(e) {
                var n, r, o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), r = this, (n = !(o = la(t).call(this, e)) || "object" !== oa(o) && "function" != typeof o ? ca(r) : o)._onChange = n._onChange.bind(ca(n)), n.groupName = W()("fcl-radio"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ua(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentWillMount",
                    value: function() {
                        var e = this.props, t = e.value, n = e.defaultValue, r = e.setSelectedIndex, o = e.children;
                        if (o) {
                            var a = t || n, i = 0;
                            if (o && a) {
                                for(var s = o.length; s-- > 0;)if (o[s].props.value === a) {
                                    i = s;
                                    break;
                                }
                                r(i);
                            }
                        }
                    }
                },
                {
                    key: "componentWillReceiveProps",
                    value: function(e) {
                        var t = this.props, n = t.value, r = t.selectedIndex, o = t.setSelectedIndex, a = e.value, i = e.children;
                        if (i && a && a !== n) {
                            for(var s = r, l = i.length; l-- > 0;)if (i[l].props.value === a) {
                                s = l;
                                break;
                            }
                            o(s);
                        }
                    }
                },
                {
                    key: "_onChange",
                    value: function(e, t) {
                        var n = this.props, r = n.value, o = n.setSelectedIndex, a = n.children, i = n.onChange, s = Mt()(a, function(e) {
                            return e.props.value === t;
                        });
                        s !== t && (r || o(s), i && i(e, t));
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, t = this.props, n = t.className, r = t.children, a = t.helpMessage, i = t.selectedIndex, s = (t.setSelectedIndex, ia(t, [
                            "className",
                            "children",
                            "helpMessage",
                            "selectedIndex",
                            "setSelectedIndex"
                        ])), c = l()("ncss-radio-container", n);
                        return o.a.createElement("div", aa({
                            className: c
                        }, s), r.map(function(t, n) {
                            return o.a.cloneElement(t, {
                                key: t.value,
                                isChecked: n === i,
                                onChange: e._onChange,
                                groupName: e.groupName
                            });
                        }), a && o.a.createElement("small", {
                            className: "text-color-grey"
                        }, a));
                    }
                }
            ], sa(n.prototype, r), a && sa(n, a), t;
        }();
        fa.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            defaultValue: i.a.string,
            helpMessage: i.a.string,
            onChange: i.a.func,
            selectedIndex: i.a.number,
            setSelectedIndex: i.a.func,
            value: i.a.string
        }, fa.displayName = "RadioGroup";
        var pa = fa;
        function da(e) {
            return (da = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function ha() {
            return (ha = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function ya(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function ma(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function ba(e, t) {
            return !t || "object" !== da(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function ga(e) {
            return (ga = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function va(e, t) {
            return (va = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Oa = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), ba(this, ga(t).apply(this, arguments));
            }
            var n, a, i;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && va(e, t);
            }(t, r["Component"]), n = t, a = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.dispatch, n = ya(e, [
                            "dispatch"
                        ]), r = un({
                            setSelectedIndex: ra
                        }, t);
                        return o.a.createElement(pa, ha({}, n, r));
                    }
                }
            ], ma(n.prototype, a), i && ma(n, i), t;
        }();
        Oa.displayName = "RadioGroupContainer", Oa.propTypes = {
            dispatch: i.a.func.isRequired
        };
        var Aa = Oa, wa = tn("selectedIndex", "dispatch", function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            switch(t.type){
                case na:
                    return t.payload;
                default:
                    return e;
            }
        }, 0)(Aa);
        wa.displayName = "Radio", wa.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            defaultValue: i.a.string,
            onChange: i.a.func,
            value: i.a.string
        };
        var Sa = wa;
        function Ea(e) {
            return (Ea = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Da() {
            return (Da = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function ka(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Ma(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Ca(e, t) {
            return !t || "object" !== Ea(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function xa(e) {
            return (xa = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function _a(e, t) {
            return (_a = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Ta = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = Ca(this, xa(t).call(this, e)))._bind("_onChange"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && _a(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentWillMount",
                    value: function() {
                        this.forId = this.props.id || W()("fcl");
                    }
                },
                {
                    key: "_onChange",
                    value: function(e) {
                        var t = this.props, n = t.isDisabled, r = t.onChange, o = t.value;
                        r && !n && r(e, o);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.className, n = e.defaultChecked, r = e.groupName, a = e.isChecked, i = e.isDisabled, s = e.isError, c = e.label, u = (e.onChange, ka(e, [
                            "className",
                            "defaultChecked",
                            "groupName",
                            "isChecked",
                            "isDisabled",
                            "isError",
                            "label",
                            "onChange"
                        ])), f = l()(t, "ncss-radio-container", {
                            error: s
                        });
                        return o.a.createElement("div", Da({
                            className: f
                        }, u), o.a.createElement("input", {
                            type: "radio",
                            name: r,
                            className: "ncss-radio",
                            id: this.forId,
                            defaultChecked: n,
                            checked: a,
                            disabled: i,
                            onChange: this._onChange
                        }), o.a.createElement("label", {
                            className: "ncss-label pt3-sm pr5-sm pb2-sm pl5-sm pt2-lg pb1-lg pl6-sm",
                            htmlFor: this.forId
                        }, c));
                    }
                }
            ], Ma(n.prototype, r), a && Ma(n, a), t;
        }();
        Ta.propTypes = {
            className: i.a.string,
            groupName: i.a.string,
            id: i.a.string,
            isChecked: i.a.bool,
            isDisabled: i.a.bool,
            isError: i.a.bool,
            label: i.a.string.isRequired,
            onChange: i.a.func,
            value: i.a.string.isRequired
        }, Ta.displayName = "RadioOption";
        var ja = Ta;
        function Ia(e) {
            return (Ia = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Ra() {
            return (Ra = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Pa(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Na(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Ba(e, t) {
            return !t || "object" !== Ia(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function Ya(e) {
            return (Ya = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Qa(e, t) {
            return (Qa = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Ua = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), Ba(this, Ya(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Qa(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.className, n = e.children, r = e.elementType, a = Pa(e, [
                            "className",
                            "children",
                            "elementType"
                        ]), i = l()(t, "ncss-row");
                        return o.a.createElement(r, Ra({
                            className: i
                        }, a), n);
                    }
                }
            ], Na(n.prototype, r), a && Na(n, a), t;
        }();
        Ua.propTypes = {
            className: i.a.string,
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            elementType: i.a.oneOfType([
                i.a.string,
                i.a.element
            ])
        }, Ua.defaultProps = {
            elementType: "div"
        }, Ua.displayName = "Row";
        var Fa = Ua;
        n(188);
        function Ha(e) {
            return (Ha = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Ga() {
            return (Ga = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Ja(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Wa(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Ka(e, t) {
            return !t || "object" !== Ha(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function La(e) {
            return (La = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Va(e, t) {
            return (Va = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Za = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = Ka(this, La(t).call(this, e)))._bind("_handleKeyDown", "_handleFocus", "_handleBlur", "_handleMouseDownOnButton", "_handleMouseDownOnMenu", "_handleClickOnOption"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Va(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentWillMount",
                    value: function() {
                        var e = this.props, t = e.value, n = e.defaultValue, r = e.selectOption, o = e.children, a = t || n;
                        if (o && a) {
                            var i = xt()(o, function(e) {
                                return e.props.value === a;
                            });
                            r(i < 0 ? 0 : i, a);
                        }
                    }
                },
                {
                    key: "componentWillReceiveProps",
                    value: function(e) {
                        var t = this.props, n = t.value, r = t.selectedOption, o = t.selectOption, a = e.value, i = e.children;
                        if (i && a !== n) {
                            var s = xt()(i, function(e) {
                                return e.props.value === a;
                            });
                            o(s < 0 ? r : s, a);
                        }
                    }
                },
                {
                    key: "_handleKeyDown",
                    value: function(e) {
                        var t = this.props, n = t.children, r = t.closeMenu, o = t.focusedIndex, a = t.focusNextOption, i = t.focusPrevOption, s = t.isDisabled, l = t.isOpen, c = t.onChange, u = t.openMenu, f = t.selectOption, p = t.value;
                        if (!s) switch(e.keyCode){
                            case 38:
                                e.preventDefault(), l ? i(n.length - 1) : u();
                                break;
                            case 40:
                                e.preventDefault(), l ? a(n.length - 1) : u();
                                break;
                            case 27:
                                e.preventDefault(), l && r();
                                break;
                            case 13:
                                e.preventDefault(), l && (p || f(o), r(), c && c(e, n[o].props.value));
                        }
                    }
                },
                {
                    key: "_handleFocus",
                    value: function(e) {
                        var t = this.props, n = t.isDisabled, r = t.onFocus;
                        !n && r && r(e);
                    }
                },
                {
                    key: "_handleBlur",
                    value: function(e) {
                        var t = this.props, n = t.closeMenu, r = t.isDisabled, o = t.onBlur;
                        r || (n(), o && o(e));
                    }
                },
                {
                    key: "_handleMouseDownOnButton",
                    value: function(e) {
                        var t = this.props, n = t.closeMenu, r = t.isDisabled, o = t.isOpen, a = t.openMenu;
                        r || (e.stopPropagation(), e.preventDefault(), o ? n() : a());
                    }
                },
                {
                    key: "_handleMouseDownOnMenu",
                    value: function(e) {
                        this.props.isDisabled || (e.stopPropagation(), e.preventDefault());
                    }
                },
                {
                    key: "_handleClickOnOption",
                    value: function(e, t) {
                        var n = this.props, r = n.children, o = n.closeMenu, a = n.isDisabled, i = n.onChange, s = n.selectOption, l = n.value;
                        a || (l || s(Mt()(r, function(e) {
                            return e.props.value === t;
                        }), t), o(), i && i(e, t));
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e, t, n, r = this.props, a = r.children, i = r.className, s = (r.closeMenu, r.errorMessage), c = r.focusedIndex, u = (r.focusNextOption, r.focusPrevOption, r.helpMessage), f = r.isDisabled, p = r.isOpen, d = r.label, h = (r.openMenu, r.selectOption, r.selectedOption), y = (r.selectedValue, r.tabIndex), m = r.zIndex, b = Ja(r, [
                            "children",
                            "className",
                            "closeMenu",
                            "errorMessage",
                            "focusedIndex",
                            "focusNextOption",
                            "focusPrevOption",
                            "helpMessage",
                            "isDisabled",
                            "isOpen",
                            "label",
                            "openMenu",
                            "selectOption",
                            "selectedOption",
                            "selectedValue",
                            "tabIndex",
                            "zIndex"
                        ]), g = l()(i, "typeahead-dropdown-container ncss-input-container", {
                            disabled: f,
                            error: s,
                            focus: p
                        }), v = l()("typeahead-input-container", (e = {}, t = "z".concat(m), n = m, t in e ? Object.defineProperty(e, t, {
                            value: n,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }) : e[t] = n, e));
                        return o.a.createElement("div", Ga({
                            className: g
                        }, b), o.a.createElement("label", {
                            className: "ncss-label pr3-sm"
                        }, d), o.a.createElement("div", {
                            className: v
                        }, o.a.createElement(yr, {
                            isFocused: p,
                            onBlur: this._handleBlur,
                            onFocus: this._handleFocus,
                            onKeyDown: this._handleKeyDown,
                            tabIndex: y
                        }), o.a.createElement(Tt, {
                            onMouseDown: this._handleMouseDownOnButton
                        }, a ? a[h].props.label : "\xa0"), o.a.createElement(It, {
                            focusedIndex: c,
                            onMouseDown: this._handleMouseDownOnMenu,
                            onClickOption: this._handleClickOnOption
                        }, a)), u && o.a.createElement("small", {
                            className: "text-color-grey"
                        }, u), s && o.a.createElement("div", {
                            className: "ncss-error-msg"
                        }, s));
                    }
                }
            ], Wa(n.prototype, r), a && Wa(n, a), t;
        }();
        Za.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            closeMenu: i.a.func,
            defaultValue: i.a.oneOfType([
                i.a.string,
                i.a.number
            ]),
            errorMessage: i.a.string,
            focusedIndex: i.a.number.isRequired,
            focusNextOption: i.a.func,
            focusPrevOption: i.a.func,
            helpMessage: i.a.string,
            isDisabled: i.a.bool,
            isOpen: i.a.bool,
            onBlur: i.a.func,
            onChange: i.a.func,
            onFocus: i.a.func,
            openMenu: i.a.func,
            label: i.a.string.isRequired,
            selectOption: i.a.func,
            selectedOption: i.a.number.isRequired,
            tabIndex: i.a.oneOfType([
                i.a.number,
                i.a.string
            ]),
            value: i.a.oneOfType([
                i.a.string,
                i.a.number
            ]),
            zIndex: i.a.oneOfType([
                i.a.string,
                i.a.number
            ])
        }, Za.defaultProps = {
            selectedOption: 0,
            focusedIndex: 0,
            zIndex: 2
        }, Za.displayName = "SelectComponent";
        var qa = En(Za);
        qa.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            defaultValue: i.a.oneOfType([
                i.a.string,
                i.a.number
            ]),
            errorMessage: i.a.string,
            helpMessage: i.a.string,
            isDisabled: i.a.bool,
            label: i.a.string.isRequired,
            onChange: i.a.func,
            onFocus: i.a.func,
            onBlur: i.a.func,
            tabIndex: i.a.oneOfType([
                i.a.number,
                i.a.string
            ]),
            value: i.a.oneOfType([
                i.a.string,
                i.a.number
            ]),
            zIndex: i.a.oneOfType([
                i.a.string,
                i.a.number
            ])
        }, qa.displayName = "Select";
        var za = qa;
        function Xa(e) {
            return (Xa = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function $a() {
            return ($a = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function ei(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function ti(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function ni(e, t) {
            return !t || "object" !== Xa(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function ri(e) {
            return (ri = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function oi(e, t) {
            return (oi = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var ai = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = ni(this, ri(t).call(this, e)))._bind("_onClick"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && oi(e, t);
            }(t, h), n = t, r = [
                {
                    key: "_onClick",
                    value: function(e) {
                        var t = this.props, n = t.isDisabled, r = t.value, o = t.onClick;
                        !n && o && o(e, r);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.className, n = e.isDisabled, r = e.isSelected, a = e.label, i = ei(e, [
                            "className",
                            "isDisabled",
                            "isSelected",
                            "label"
                        ]), s = l()(t, {
                            active: r,
                            disabled: n
                        }, "ncss-option pt2-sm pr5-sm pb2-sm pl5-sm");
                        return o.a.createElement("a", $a({}, i, {
                            className: s,
                            onClick: this._onClick
                        }), a);
                    }
                }
            ], ti(n.prototype, r), a && ti(n, a), t;
        }();
        ai.propTypes = {
            className: i.a.string,
            isDisabled: i.a.bool,
            isSelected: i.a.bool,
            label: i.a.string.isRequired,
            onClick: i.a.func,
            value: i.a.oneOfType([
                i.a.string,
                i.a.number
            ])
        }, ai.defaultProps = {
            label: "Select Option"
        }, ai.displayName = "SelectOption";
        var ii = ai;
        function si(e) {
            return (si = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function li() {
            return (li = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function ci(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function ui(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function fi(e, t) {
            return !t || "object" !== si(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function pi(e) {
            return (pi = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function di(e, t) {
            return (di = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var hi = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), fi(this, pi(t).apply(this, arguments));
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && di(e, t);
            }(t, h), n = t, r = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.containerClassName, n = e.errorMessage, r = e.helpMessage, a = e.isDisabled, i = e.isReadOnly, s = e.label, c = e.textareaClassName, u = ci(e, [
                            "containerClassName",
                            "errorMessage",
                            "helpMessage",
                            "isDisabled",
                            "isReadOnly",
                            "label",
                            "textareaClassName"
                        ]), f = l()(t, "ncss-textarea-container", {
                            error: n
                        }), p = l()(c, "ncss-textarea p4-sm");
                        return o.a.createElement("div", {
                            className: f
                        }, o.a.createElement("label", {
                            className: "ncss-label"
                        }, s), o.a.createElement("textarea", li({
                            className: p,
                            disabled: a,
                            readOnly: i
                        }, u)), r && o.a.createElement("small", {
                            className: "text-color-grey"
                        }, r), n && o.a.createElement("div", {
                            className: "ncss-error-msg"
                        }, n));
                    }
                }
            ], ui(n.prototype, r), a && ui(n, a), t;
        }();
        hi.propTypes = {
            containerClassName: i.a.string,
            defaultValue: i.a.string,
            errorMessage: i.a.string,
            helpMessage: i.a.string,
            isDisabled: i.a.bool,
            isReadOnly: i.a.bool,
            label: i.a.string,
            onBlur: i.a.func,
            onChange: i.a.func,
            onFocus: i.a.func,
            placeholder: i.a.string,
            tabIndex: i.a.oneOfType([
                i.a.number,
                i.a.string
            ]),
            textareaClassName: i.a.string,
            value: i.a.string
        }, hi.displayName = "TextArea";
        var yi = hi, mi = function(e) {
            return {
                type: "frame-component-library/toggle/SELECT_INDEX",
                payload: e
            };
        };
        function bi(e) {
            return (bi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function gi() {
            return (gi = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function vi(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Oi(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Ai(e) {
            return (Ai = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function wi(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function Si(e, t) {
            return (Si = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Ei = function(e) {
            function t(e) {
                var n, r, o;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), r = this, (n = !(o = Ai(t).call(this, e)) || "object" !== bi(o) && "function" != typeof o ? wi(r) : o)._onSelect = n._onSelect.bind(wi(n)), n.groupName = W()("fcl-toggle"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Si(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentWillMount",
                    value: function() {
                        var e = this.props, t = e.value, n = e.defaultValue, r = e.setSelectedIndex, o = e.children;
                        if (o) {
                            var a = t || n, i = 0;
                            if (o && a) {
                                for(var s = o.length; s-- > 0;)if (o[s].props.value === a) {
                                    i = s;
                                    break;
                                }
                                r(i);
                            }
                        }
                    }
                },
                {
                    key: "componentWillReceiveProps",
                    value: function(e) {
                        var t = this.props, n = t.value, r = t.selectedIndex, o = t.setSelectedIndex, a = e.value, i = e.children;
                        if (i && a && a !== n) {
                            for(var s = r, l = i.length; l-- > 0;)if (i[l].props.value === a) {
                                s = l;
                                break;
                            }
                            o(s);
                        }
                    }
                },
                {
                    key: "_onSelect",
                    value: function(e, t) {
                        var n = this.props, r = n.value, o = n.setSelectedIndex, a = n.children, i = n.onChange, s = Mt()(a, function(e) {
                            return e.props.value === t;
                        });
                        s !== t && (r || o(s), i && i(e, t));
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, t = this.props, n = t.className, r = t.children, a = t.selectedIndex, i = (t.setSelectedIndex, vi(t, [
                            "className",
                            "children",
                            "selectedIndex",
                            "setSelectedIndex"
                        ])), s = l()("ncss-toggle-btn", n);
                        return o.a.createElement("div", gi({
                            className: s
                        }, i), r.map(function(t, n) {
                            return o.a.cloneElement(t, {
                                isChecked: n === a,
                                onChange: e._onSelect,
                                groupName: e.groupName
                            });
                        }));
                    }
                }
            ], Oi(n.prototype, r), a && Oi(n, a), t;
        }();
        Ei.displayName = "ToggleGroup", Ei.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            defaultValue: i.a.string,
            onChange: i.a.func,
            setSelectedIndex: i.a.func,
            selectedIndex: i.a.number,
            value: i.a.string
        };
        var Di = Ei;
        function ki(e) {
            return (ki = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Mi() {
            return (Mi = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Ci(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function xi(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function _i(e, t) {
            return !t || "object" !== ki(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function Ti(e) {
            return (Ti = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function ji(e, t) {
            return (ji = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Ii = function(e) {
            function t() {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), _i(this, Ti(t).apply(this, arguments));
            }
            var n, a, i;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ji(e, t);
            }(t, r["Component"]), n = t, a = [
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.dispatch, n = Ci(e, [
                            "dispatch"
                        ]), r = un({
                            setSelectedIndex: mi
                        }, t);
                        return o.a.createElement(Di, Mi({}, n, r));
                    }
                }
            ], xi(n.prototype, a), i && xi(n, i), t;
        }();
        Ii.propTypes = {
            dispatch: i.a.func.isRequired
        }, Ii.displayName = "ToggleGroupContainer";
        var Ri = Ii, Pi = tn("selectedIndex", "dispatch", function() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            switch(t.type){
                case "frame-component-library/toggle/SELECT_INDEX":
                    return t.payload;
                default:
                    return e;
            }
        }, 0)(Ri);
        Pi.displayName = "Toggle", Pi.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            defaultValue: i.a.string,
            onChange: i.a.func,
            value: i.a.string
        };
        var Ni = Pi;
        function Bi(e) {
            return (Bi = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function Yi() {
            return (Yi = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function Qi(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function Ui(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Fi(e, t) {
            return !t || "object" !== Bi(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function Hi(e) {
            return (Hi = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function Gi(e, t) {
            return (Gi = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Ji = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = Fi(this, Hi(t).call(this, e)))._bind("_onChange"), n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && Gi(e, t);
            }(t, h), n = t, r = [
                {
                    key: "componentWillMount",
                    value: function() {
                        this.forId = this.props.id || W()("fcl");
                    }
                },
                {
                    key: "_onChange",
                    value: function(e) {
                        var t = this.props, n = t.isDisabled, r = t.onChange, o = t.value;
                        r && !n && r(e, o);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.className, n = e.defaultChecked, r = e.groupName, a = e.isChecked, i = e.isDisabled, s = e.isError, c = e.label, u = (e.onChange, e.tabIndex), f = Qi(e, [
                            "className",
                            "defaultChecked",
                            "groupName",
                            "isChecked",
                            "isDisabled",
                            "isError",
                            "label",
                            "onChange",
                            "tabIndex"
                        ]), p = l()(t, "ncss-toggle-btn-item u-uppercase ncss-brand", {
                            error: s
                        });
                        return o.a.createElement("div", Yi({
                            className: p
                        }, f), o.a.createElement("input", {
                            type: "radio",
                            name: r,
                            className: "ncss-radio",
                            id: this.forId,
                            defaultChecked: n,
                            checked: a,
                            disabled: i,
                            onChange: this._onChange,
                            tabIndex: u
                        }), o.a.createElement("label", {
                            className: "ncss-label pt3-sm pr5-sm pb2-sm pl5-sm pt2-lg pb1-lg u-uppercase ncss-brand",
                            htmlFor: this.forId
                        }, c));
                    }
                }
            ], Ui(n.prototype, r), a && Ui(n, a), t;
        }();
        Ji.propTypes = {
            className: i.a.string,
            defaultChecked: i.a.bool,
            groupName: i.a.string,
            id: i.a.string,
            isChecked: i.a.bool,
            isDisabled: i.a.bool,
            isError: i.a.string,
            label: i.a.string.isRequired,
            onChange: i.a.func,
            tabIndex: i.a.oneOfType([
                i.a.number,
                i.a.string
            ]),
            value: i.a.string.isRequired
        }, Ji.displayName = "ToggleOption";
        var Wi = Ji, Ki = n(66), Li = n.n(Ki), Vi = n(11), Zi = n.n(Vi), qi = n(4), zi = n.n(qi), Xi = n(14), $i = n.n(Xi), es = n(5), ts = n.n(es), ns = n(44), rs = n(67), os = n.n(rs)()({
            setReferenceNode: void 0,
            referenceNode: void 0
        }), as = function(e) {
            function t() {
                var t;
                return t = e.call(this) || this, ts()(zi()(t), "setReferenceNode", function(e) {
                    e && t.state.context.referenceNode !== e && t.setState(function(t) {
                        var n = t.context;
                        return {
                            context: Zi()({}, n, {
                                referenceNode: e
                            })
                        };
                    });
                }), t.state = {
                    context: {
                        setReferenceNode: t.setReferenceNode,
                        referenceNode: void 0
                    }
                }, t;
            }
            return $i()(t, e), t.prototype.render = function() {
                return r.createElement(os.Provider, {
                    value: this.state.context
                }, this.props.children);
            }, t;
        }(r.Component), is = function(e) {
            return Array.isArray(e) ? e[0] : e;
        }, ss = function(e) {
            if ("function" == typeof e) {
                for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
                return e.apply(void 0, n);
            }
        }, ls = {
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            pointerEvents: "none"
        }, cs = {}, us = function(e) {
            function t() {
                for(var t, n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                return t = e.call.apply(e, [
                    this
                ].concat(r)) || this, ts()(zi()(t), "state", {
                    data: void 0,
                    placement: void 0
                }), ts()(zi()(t), "popperInstance", void 0), ts()(zi()(t), "popperNode", null), ts()(zi()(t), "arrowNode", null), ts()(zi()(t), "setPopperNode", function(e) {
                    e && t.popperNode !== e && (ss(t.props.innerRef, e), t.popperNode = e, t.updatePopperInstance());
                }), ts()(zi()(t), "setArrowNode", function(e) {
                    t.arrowNode = e;
                }), ts()(zi()(t), "updateStateModifier", {
                    enabled: !0,
                    order: 900,
                    fn: function(e) {
                        var n = e.placement;
                        return t.setState({
                            data: e,
                            placement: n
                        }), e;
                    }
                }), ts()(zi()(t), "getOptions", function() {
                    return {
                        placement: t.props.placement,
                        eventsEnabled: t.props.eventsEnabled,
                        positionFixed: t.props.positionFixed,
                        modifiers: Zi()({}, t.props.modifiers, {
                            arrow: Zi()({}, t.props.modifiers && t.props.modifiers.arrow, {
                                enabled: !!t.arrowNode,
                                element: t.arrowNode
                            }),
                            applyStyle: {
                                enabled: !1
                            },
                            updateStateModifier: t.updateStateModifier
                        })
                    };
                }), ts()(zi()(t), "getPopperStyle", function() {
                    return t.popperNode && t.state.data ? Zi()({
                        position: t.state.data.offsets.popper.position
                    }, t.state.data.styles) : ls;
                }), ts()(zi()(t), "getPopperPlacement", function() {
                    return t.state.data ? t.state.placement : void 0;
                }), ts()(zi()(t), "getArrowStyle", function() {
                    return t.arrowNode && t.state.data ? t.state.data.arrowStyles : cs;
                }), ts()(zi()(t), "getOutOfBoundariesState", function() {
                    return t.state.data ? t.state.data.hide : void 0;
                }), ts()(zi()(t), "destroyPopperInstance", function() {
                    t.popperInstance && (t.popperInstance.destroy(), t.popperInstance = null);
                }), ts()(zi()(t), "updatePopperInstance", function() {
                    t.destroyPopperInstance();
                    var e = zi()(t).popperNode, n = t.props.referenceElement;
                    n && e && (t.popperInstance = new ns.a(n, e, t.getOptions()));
                }), ts()(zi()(t), "scheduleUpdate", function() {
                    t.popperInstance && t.popperInstance.scheduleUpdate();
                }), t;
            }
            $i()(t, e);
            var n = t.prototype;
            return n.componentDidUpdate = function(e, t) {
                this.props.placement !== e.placement || this.props.referenceElement !== e.referenceElement || this.props.positionFixed !== e.positionFixed ? this.updatePopperInstance() : this.props.eventsEnabled !== e.eventsEnabled && this.popperInstance && (this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners()), t.placement !== this.state.placement && this.scheduleUpdate();
            }, n.componentWillUnmount = function() {
                ss(this.props.innerRef, null), this.destroyPopperInstance();
            }, n.render = function() {
                return is(this.props.children)({
                    ref: this.setPopperNode,
                    style: this.getPopperStyle(),
                    placement: this.getPopperPlacement(),
                    outOfBoundaries: this.getOutOfBoundariesState(),
                    scheduleUpdate: this.scheduleUpdate,
                    arrowProps: {
                        ref: this.setArrowNode,
                        style: this.getArrowStyle()
                    }
                });
            }, t;
        }(r.Component);
        ts()(us, "defaultProps", {
            placement: "bottom",
            eventsEnabled: !0,
            referenceElement: void 0,
            positionFixed: !1
        });
        ns.a.placements;
        function fs(e) {
            var t = e.referenceElement, n = Li()(e, [
                "referenceElement"
            ]);
            return r.createElement(os.Consumer, null, function(e) {
                var o = e.referenceNode;
                return r.createElement(us, Zi()({
                    referenceElement: void 0 !== t ? t : o
                }, n));
            });
        }
        var ps = n(42), ds = n.n(ps), hs = function(e) {
            function t() {
                for(var t, n = arguments.length, r = new Array(n), o = 0; o < n; o++)r[o] = arguments[o];
                return t = e.call.apply(e, [
                    this
                ].concat(r)) || this, ts()(zi()(t), "refHandler", function(e) {
                    ss(t.props.innerRef, e), ss(t.props.setReferenceNode, e);
                }), t;
            }
            $i()(t, e);
            var n = t.prototype;
            return n.componentWillUnmount = function() {
                ss(this.props.innerRef, null);
            }, n.render = function() {
                return ds()(Boolean(this.props.setReferenceNode), "`Reference` should not be used outside of a `Manager` component."), is(this.props.children)({
                    ref: this.refHandler
                });
            }, t;
        }(r.Component);
        function ys(e) {
            return r.createElement(os.Consumer, null, function(t) {
                var n = t.setReferenceNode;
                return r.createElement(hs, Zi()({
                    setReferenceNode: n
                }, e));
            });
        }
        n(192);
        function ms(e) {
            return (ms = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function bs() {
            return (bs = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function gs(e, t) {
            if (null == e) return {};
            var n, r, o = function(e, t) {
                if (null == e) return {};
                var n, r, o = {}, a = Object.keys(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
            }(e, t);
            if (Object.getOwnPropertySymbols) {
                var a = Object.getOwnPropertySymbols(e);
                for(r = 0; r < a.length; r++)n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
        }
        function vs(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Os(e, t) {
            return !t || "object" !== ms(t) && "function" != typeof t ? function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e) : t;
        }
        function As(e) {
            return (As = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function ws(e, t) {
            return (ws = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        var Ss = function(e) {
            function t(e) {
                var n;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, t), (n = Os(this, As(t).call(this, e)))._bind("_handleMouseOver", "_handleMouseOut"), n.state = {
                    showTooltip: !1
                }, n;
            }
            var n, r, a;
            return function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), t && ws(e, t);
            }(t, h), n = t, r = [
                {
                    key: "_handleMouseOver",
                    value: function() {
                        this.setState({
                            showTooltip: !0
                        });
                    }
                },
                {
                    key: "_handleMouseOut",
                    value: function() {
                        this.setState({
                            showTooltip: !1
                        });
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, t = this.props, n = (t.children, t.className), r = t.position, a = t.textString, i = t.tooltipClassName, s = gs(t, [
                            "children",
                            "className",
                            "position",
                            "textString",
                            "tooltipClassName"
                        ]), c = this.state.showTooltip, u = l()("g72-help tooltip-icon", n), f = l()("tooltip-container ncss-brand lh12-sm ta-sm-c bg-medium-grey", i);
                        return o.a.createElement(as, null, o.a.createElement(ys, null, function(t) {
                            var n = t.ref;
                            return o.a.createElement("div", bs({
                                className: u,
                                onMouseOver: e._handleMouseOver,
                                onMouseOut: e._handleMouseOut,
                                onFocus: e._handleMouseOver,
                                onBlur: e._handleMouseOut,
                                ref: n
                            }, s));
                        }), c && o.a.createElement(fs, {
                            placement: r
                        }, function(e) {
                            var t = e.ref, n = e.style, r = e.placement;
                            return o.a.createElement("div", {
                                className: f,
                                "data-placement": r,
                                style: n,
                                ref: t
                            }, a);
                        }));
                    }
                }
            ], vs(n.prototype, r), a && vs(n, a), t;
        }();
        Ss.propTypes = {
            children: i.a.oneOfType([
                i.a.node,
                i.a.arrayOf(i.a.node)
            ]),
            className: i.a.string,
            position: i.a.oneOf([
                "top-start",
                "top",
                "top-end",
                "right-start",
                "right",
                "right-end",
                "bottom-end",
                "bottom",
                "bottom-start",
                "left-end",
                "left",
                "left-start"
            ]),
            textString: i.a.string.isRequired,
            tooltipClassName: i.a.string
        }, Ss.defaultProps = {
            position: "bottom-right",
            textString: ""
        }, Ss.displayName = "Tooltip";
        var Es = Ss;
        n.d(t, "Alert", function() {
            return S;
        }), n.d(t, "Button", function() {
            return j;
        }), n.d(t, "Calendar", function() {
            return nt;
        }), n.d(t, "Checkbox", function() {
            return ft;
        }), n.d(t, "Column", function() {
            return At;
        }), n.d(t, "Combobox", function() {
            return kn;
        }), n.d(t, "Container", function() {
            return Pn;
        }), n.d(t, "DatePicker", function() {
            return Hr;
        }), n.d(t, "FormGroup", function() {
            return zr;
        }), n.d(t, "Input", function() {
            return fe;
        }), n.d(t, "Loading", function() {
            return oo;
        }), n.d(t, "Modal", function() {
            return bo;
        }), n.d(t, "Nav", function() {
            return ko;
        }), n.d(t, "NavDropdown", function() {
            return _o;
        }), n.d(t, "NavItem", function() {
            return Qo;
        }), n.d(t, "Panel", function() {
            return Vo;
        }), n.d(t, "ProgressBar", function() {
            return ta;
        }), n.d(t, "Radio", function() {
            return Sa;
        }), n.d(t, "RadioOption", function() {
            return ja;
        }), n.d(t, "Row", function() {
            return Fa;
        }), n.d(t, "Select", function() {
            return za;
        }), n.d(t, "SelectOption", function() {
            return ii;
        }), n.d(t, "TextArea", function() {
            return yi;
        }), n.d(t, "Toggle", function() {
            return Ni;
        }), n.d(t, "ToggleOption", function() {
            return Wi;
        }), n.d(t, "Tooltip", function() {
            return Es;
        });
        var Ds = {
            Alert: S,
            Button: j,
            Calendar: nt,
            Checkbox: ft,
            Column: At,
            Combobox: kn,
            Container: Pn,
            DatePicker: Hr,
            FormGroup: zr,
            Input: fe,
            Loading: oo,
            Modal: bo,
            Nav: ko,
            NavDropdown: _o,
            NavItem: Qo,
            Panel: Vo,
            ProgressBar: ta,
            Radio: Sa,
            RadioOption: ja,
            Row: Fa,
            Select: za,
            SelectOption: ii,
            TextArea: yi,
            Toggle: Ni,
            ToggleOption: Wi,
            Tooltip: Es
        };
        t.default = Ds;
    }
]);

});
parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});



parcelRegister("llXHs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $f8b9de474ce06838$export$1e511d4a378977f5, (v) => $f8b9de474ce06838$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $f8b9de474ce06838$export$2e2bcd8739ae039, (v) => $f8b9de474ce06838$export$2e2bcd8739ae039 = v);
var $f8b9de474ce06838$export$1e511d4a378977f5;
var $f8b9de474ce06838$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$f8b9de474ce06838$export$1e511d4a378977f5 = true;
$f8b9de474ce06838$export$2e2bcd8739ae039 = void 0;

var $f8b9de474ce06838$var$_react = $1jnue((parcelRequire("acw62")));
const $f8b9de474ce06838$var$Unauthorized = ()=>/*#__PURE__*/ $f8b9de474ce06838$var$_react.default.createElement("main", {
        className: "ncss-col-sm-12 ta-sm-c"
    }, /*#__PURE__*/ $f8b9de474ce06838$var$_react.default.createElement("h1", {
        className: "display-3 mt10-sm mb4-sm text-color-error"
    }, "Unauthorized"), /*#__PURE__*/ $f8b9de474ce06838$var$_react.default.createElement("p", {
        className: "body-1"
    }, "You do not have permission to access this application."));
var $f8b9de474ce06838$var$_default = $f8b9de474ce06838$export$2e2bcd8739ae039 = $f8b9de474ce06838$var$Unauthorized;

});

parcelRegister("gdchy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $bcd763376d80601c$export$1e511d4a378977f5, (v) => $bcd763376d80601c$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $bcd763376d80601c$export$2e2bcd8739ae039, (v) => $bcd763376d80601c$export$2e2bcd8739ae039 = v);
var $bcd763376d80601c$export$1e511d4a378977f5;
var $bcd763376d80601c$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$bcd763376d80601c$export$1e511d4a378977f5 = true;
$bcd763376d80601c$export$2e2bcd8739ae039 = void 0;

var $bcd763376d80601c$var$_localeCode = $1jnue((parcelRequire("PAiZv")));

var $bcd763376d80601c$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $bcd763376d80601c$var$_react = $bcd763376d80601c$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");
var $iD0SF = parcelRequire("iD0SF");

var $7Yi7V = parcelRequire("7Yi7V");

var $bEk1s = parcelRequire("bEk1s");

var $jMcIG = parcelRequire("jMcIG");

var $f2CEG = parcelRequire("f2CEG");

var $ikfii = parcelRequire("ikfii");
function $bcd763376d80601c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($bcd763376d80601c$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $bcd763376d80601c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $bcd763376d80601c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $bcd763376d80601c$var$LocaleToggle = ({ location: { pathname: pathname } })=>{
    const storeLocale = (0, $iD0SF.useSelector)($bEk1s.getLocale);
    const localeName = (0, $iD0SF.useSelector)($bEk1s.getLocaleForToggleButton);
    const isTranslationsAvailable = (0, $f2CEG.getIsTranslationsAvailable)();
    const dispatch = (0, $2OPjR.useDispatch)();
    const onToggleLocale = (0, $bcd763376d80601c$var$_react.useCallback)(()=>{
        dispatch((0, $jMcIG.toggleLocale)());
    }, [
        dispatch
    ]);
    if (pathname === "/login" || storeLocale === $7Yi7V.DEFAULT_LOCALE || !isTranslationsAvailable) return "";
    return /*#__PURE__*/ $bcd763376d80601c$var$_react.default.createElement("div", {
        className: "ncss-col-sm-6 ncss-col-sm-offset-6 ta-sm-c d-sm-flx flx-jc-sm-fe prl6-sm"
    }, /*#__PURE__*/ $bcd763376d80601c$var$_react.default.createElement($ikfii.Button, {
        buttonClassName: "ncss-btn-primary-dark bg-black mt3-sm btn-primary-dark",
        label: `Translate to ${$bcd763376d80601c$var$_localeCode.default.getLanguageName(localeName)}`,
        onClick: onToggleLocale
    }));
};
$bcd763376d80601c$var$LocaleToggle.propTypes = {
    location: $bcd763376d80601c$var$_propTypes.default.shape({
        pathname: $bcd763376d80601c$var$_propTypes.default.string.isRequired
    }).isRequired
};
var $bcd763376d80601c$var$_default = $bcd763376d80601c$export$2e2bcd8739ae039 = $bcd763376d80601c$var$LocaleToggle;

});
parcelRegister("PAiZv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $09b0ed03378dd7cf$export$2e2bcd8739ae039);

var $c7nEy = parcelRequire("c7nEy");

var $3qzNN = parcelRequire("3qzNN");
const $09b0ed03378dd7cf$var$REG = /^([a-z]{2})-([A-Z]{2})$/;
class $09b0ed03378dd7cf$export$2e2bcd8739ae039 {
    /* language iso-639-1 */ static getLanguageCode(code) {
        var match = code.match($09b0ed03378dd7cf$var$REG);
        if (!match || match.length < 1) return "";
        return match[1];
    }
    static getLanguageName(code) {
        var languageCode = $09b0ed03378dd7cf$export$2e2bcd8739ae039.getLanguageCode(code);
        return (0, $c7nEy.default).getName(languageCode);
    }
    static getLanguageNativeName(code) {
        var languageCode = $09b0ed03378dd7cf$export$2e2bcd8739ae039.getLanguageCode(code);
        return (0, $c7nEy.default).getNativeName(languageCode);
    }
    static getLanguageZhName(code) {
        var languageCode = $09b0ed03378dd7cf$export$2e2bcd8739ae039.getLanguageCode(code);
        return (0, $c7nEy.default).getZhName(languageCode);
    }
    static validateLanguageCode(code) {
        var languageCode = $09b0ed03378dd7cf$export$2e2bcd8739ae039.getLanguageCode(code);
        return (0, $c7nEy.default).validate(languageCode);
    }
    static getLanguages(codes) {
        var list = [];
        for(var i = 0; i < codes.length; i++)list.push({
            code: codes[i],
            name: $09b0ed03378dd7cf$export$2e2bcd8739ae039.getLanguageName(codes[i]),
            nativeName: $09b0ed03378dd7cf$export$2e2bcd8739ae039.getLanguageNativeName(codes[i]),
            zhName: $09b0ed03378dd7cf$export$2e2bcd8739ae039.getLanguageZhName(codes[i])
        });
        return list;
    }
    /* country iso-3166-1-alpha-2 */ static getCountryCode(code) {
        var match = code.match($09b0ed03378dd7cf$var$REG);
        if (!match || match.length < 2) return "";
        return match[2];
    }
    static getCountryName(code) {
        var countryCode = $09b0ed03378dd7cf$export$2e2bcd8739ae039.getCountryCode(code);
        return (0, (/*@__PURE__*/$parcel$interopDefault($3qzNN))).getCountry(countryCode);
    }
    static validateCountryCode(code) {
        code = $09b0ed03378dd7cf$export$2e2bcd8739ae039.getCountryCode(code);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3qzNN))).getCodes().indexOf(code) === -1) return false;
        else return true;
    }
    /* validate */ static validate(code) {
        var match = code.match($09b0ed03378dd7cf$var$REG);
        if (match && match.length === 3 && $09b0ed03378dd7cf$export$2e2bcd8739ae039.validateLanguageCode(code) && $09b0ed03378dd7cf$export$2e2bcd8739ae039.validateCountryCode(code)) return true;
        else return false;
    }
}

});
parcelRegister("c7nEy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d287c8074044847$export$2e2bcd8739ae039);

var $bEWKV = parcelRequire("bEWKV");

var $g9Zh1 = parcelRequire("g9Zh1");
class $8d287c8074044847$export$2e2bcd8739ae039 extends (0, $bEWKV.default) {
    static getLanguages(codes) {
        return super.getLanguages(codes).map((language)=>{
            Object.assign(language, {
                zhName: $8d287c8074044847$export$2e2bcd8739ae039.getZhName(language.code)
            });
            return language;
        });
    }
    static getZhName(code) {
        return super.validate(code) ? (0, $g9Zh1.default)[code] : "";
    }
    static getAllZhNames() {
        return Object.values((0, $g9Zh1.default));
    }
}

});
parcelRegister("bEWKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87d101d03a098ee8$export$2e2bcd8739ae039);

var $l8S9f = parcelRequire("l8S9f");
class $87d101d03a098ee8$export$2e2bcd8739ae039 {
    static getLanguages(codes = []) {
        return codes.map((code)=>({
                code: code,
                name: $87d101d03a098ee8$export$2e2bcd8739ae039.getName(code),
                nativeName: $87d101d03a098ee8$export$2e2bcd8739ae039.getNativeName(code)
            }));
    }
    static getName(code) {
        return $87d101d03a098ee8$export$2e2bcd8739ae039.validate(code) ? (0, $l8S9f.default)[code].name : "";
    }
    static getAllNames() {
        return Object.values((0, $l8S9f.default)).map((l)=>l.name);
    }
    static getNativeName(code) {
        return $87d101d03a098ee8$export$2e2bcd8739ae039.validate(code) ? (0, $l8S9f.default)[code].nativeName : "";
    }
    static getAllNativeNames() {
        return Object.values((0, $l8S9f.default)).map((l)=>l.nativeName);
    }
    static getCode(name) {
        const code = Object.keys((0, $l8S9f.default)).find((code)=>{
            const language = (0, $l8S9f.default)[code];
            return language.name.toLowerCase() === name.toLowerCase() || language.nativeName.toLowerCase() === name.toLowerCase();
        });
        return code || "";
    }
    static getAllCodes() {
        return Object.keys((0, $l8S9f.default));
    }
    static validate(code) {
        return (0, $l8S9f.default).hasOwnProperty(code);
    }
}

});
parcelRegister("l8S9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $f644590b078bf3f3$export$2e2bcd8739ae039);
const $f644590b078bf3f3$var$LANGUAGES_LIST = {
    aa: {
        name: "Afar",
        nativeName: "Afaraf"
    },
    ab: {
        name: "Abkhaz",
        nativeName: "\u0430\u04A7\u0441\u0443\u0430 \u0431\u044B\u0437\u0448\u04D9\u0430"
    },
    ae: {
        name: "Avestan",
        nativeName: "avesta"
    },
    af: {
        name: "Afrikaans",
        nativeName: "Afrikaans"
    },
    ak: {
        name: "Akan",
        nativeName: "Akan"
    },
    am: {
        name: "Amharic",
        nativeName: "\u12A0\u121B\u122D\u129B"
    },
    an: {
        name: "Aragonese",
        nativeName: "aragon\xe9s"
    },
    ar: {
        name: "Arabic",
        nativeName: "\u0627\u064E\u0644\u0652\u0639\u064E\u0631\u064E\u0628\u0650\u064A\u064E\u0651\u0629\u064F"
    },
    as: {
        name: "Assamese",
        nativeName: "\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE"
    },
    av: {
        name: "Avaric",
        nativeName: "\u0430\u0432\u0430\u0440 \u043C\u0430\u0446\u04C0"
    },
    ay: {
        name: "Aymara",
        nativeName: "aymar aru"
    },
    az: {
        name: "Azerbaijani",
        nativeName: "az\u0259rbaycan dili"
    },
    ba: {
        name: "Bashkir",
        nativeName: "\u0431\u0430\u0448\u04A1\u043E\u0440\u0442 \u0442\u0435\u043B\u0435"
    },
    be: {
        name: "Belarusian",
        nativeName: "\u0431\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F \u043C\u043E\u0432\u0430"
    },
    bg: {
        name: "Bulgarian",
        nativeName: "\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 \u0435\u0437\u0438\u043A"
    },
    bi: {
        name: "Bislama",
        nativeName: "Bislama"
    },
    bm: {
        name: "Bambara",
        nativeName: "bamanankan"
    },
    bn: {
        name: "Bengali",
        nativeName: "\u09AC\u09BE\u0982\u09B2\u09BE"
    },
    bo: {
        name: "Tibetan",
        nativeName: "\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42"
    },
    br: {
        name: "Breton",
        nativeName: "brezhoneg"
    },
    bs: {
        name: "Bosnian",
        nativeName: "bosanski jezik"
    },
    ca: {
        name: "Catalan",
        nativeName: "Catal\xe0"
    },
    ce: {
        name: "Chechen",
        nativeName: "\u043D\u043E\u0445\u0447\u0438\u0439\u043D \u043C\u043E\u0442\u0442"
    },
    ch: {
        name: "Chamorro",
        nativeName: "Chamoru"
    },
    co: {
        name: "Corsican",
        nativeName: "corsu"
    },
    cr: {
        name: "Cree",
        nativeName: "\u14C0\u1426\u1403\u152D\u140D\u140F\u1423"
    },
    cs: {
        name: "Czech",
        nativeName: "\u010De\u0161tina"
    },
    cu: {
        name: "Old Church Slavonic",
        nativeName: "\u0469\u0437\u044B\u043A\u044A \u0441\u043B\u043E\u0432\u0463\u043D\u044C\u0441\u043A\u044A"
    },
    cv: {
        name: "Chuvash",
        nativeName: "\u0447\u04D1\u0432\u0430\u0448 \u0447\u04D7\u043B\u0445\u0438"
    },
    cy: {
        name: "Welsh",
        nativeName: "Cymraeg"
    },
    da: {
        name: "Danish",
        nativeName: "dansk"
    },
    de: {
        name: "German",
        nativeName: "Deutsch"
    },
    dv: {
        name: "Divehi",
        nativeName: "\u078B\u07A8\u0788\u07AC\u0780\u07A8"
    },
    dz: {
        name: "Dzongkha",
        nativeName: "\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41"
    },
    ee: {
        name: "Ewe",
        nativeName: "E\u028Begbe"
    },
    el: {
        name: "Greek",
        nativeName: "\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"
    },
    en: {
        name: "English",
        nativeName: "English"
    },
    eo: {
        name: "Esperanto",
        nativeName: "Esperanto"
    },
    es: {
        name: "Spanish",
        nativeName: "Espa\xf1ol"
    },
    et: {
        name: "Estonian",
        nativeName: "eesti"
    },
    eu: {
        name: "Basque",
        nativeName: "euskara"
    },
    fa: {
        name: "Persian",
        nativeName: "\u0641\u0627\u0631\u0633\u06CC"
    },
    ff: {
        name: "Fula",
        nativeName: "Fulfulde"
    },
    fi: {
        name: "Finnish",
        nativeName: "suomi"
    },
    fj: {
        name: "Fijian",
        nativeName: "vosa Vakaviti"
    },
    fo: {
        name: "Faroese",
        nativeName: "f\xf8royskt"
    },
    fr: {
        name: "French",
        nativeName: "Fran\xe7ais"
    },
    fy: {
        name: "Western Frisian",
        nativeName: "Frysk"
    },
    ga: {
        name: "Irish",
        nativeName: "Gaeilge"
    },
    gd: {
        name: "Scottish Gaelic",
        nativeName: "G\xe0idhlig"
    },
    gl: {
        name: "Galician",
        nativeName: "galego"
    },
    gn: {
        name: "Guaran\xed",
        nativeName: "Ava\xf1e'\u1EBD"
    },
    gu: {
        name: "Gujarati",
        nativeName: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0"
    },
    gv: {
        name: "Manx",
        nativeName: "Gaelg"
    },
    ha: {
        name: "Hausa",
        nativeName: "\u0647\u064E\u0648\u064F\u0633\u064E"
    },
    he: {
        name: "Hebrew",
        nativeName: "\u05E2\u05D1\u05E8\u05D9\u05EA"
    },
    hi: {
        name: "Hindi",
        nativeName: "\u0939\u093F\u0928\u094D\u0926\u0940"
    },
    ho: {
        name: "Hiri Motu",
        nativeName: "Hiri Motu"
    },
    hr: {
        name: "Croatian",
        nativeName: "Hrvatski"
    },
    ht: {
        name: "Haitian",
        nativeName: "Krey\xf2l ayisyen"
    },
    hu: {
        name: "Hungarian",
        nativeName: "magyar"
    },
    hy: {
        name: "Armenian",
        nativeName: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576"
    },
    hz: {
        name: "Herero",
        nativeName: "Otjiherero"
    },
    ia: {
        name: "Interlingua",
        nativeName: "Interlingua"
    },
    id: {
        name: "Indonesian",
        nativeName: "Bahasa Indonesia"
    },
    ie: {
        name: "Interlingue",
        nativeName: "Interlingue"
    },
    ig: {
        name: "Igbo",
        nativeName: "As\u1EE5s\u1EE5 Igbo"
    },
    ii: {
        name: "Nuosu",
        nativeName: "\uA188\uA320\uA4BF Nuosuhxop"
    },
    ik: {
        name: "Inupiaq",
        nativeName: "I\xf1upiaq"
    },
    io: {
        name: "Ido",
        nativeName: "Ido"
    },
    is: {
        name: "Icelandic",
        nativeName: "\xcdslenska"
    },
    it: {
        name: "Italian",
        nativeName: "Italiano"
    },
    iu: {
        name: "Inuktitut",
        nativeName: "\u1403\u14C4\u1483\u144E\u1450\u1466"
    },
    ja: {
        name: "Japanese",
        nativeName: "\u65E5\u672C\u8A9E"
    },
    jv: {
        name: "Javanese",
        nativeName: "basa Jawa"
    },
    ka: {
        name: "Georgian",
        nativeName: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8"
    },
    kg: {
        name: "Kongo",
        nativeName: "Kikongo"
    },
    ki: {
        name: "Kikuyu",
        nativeName: "G\u0129k\u0169y\u0169"
    },
    kj: {
        name: "Kwanyama",
        nativeName: "Kuanyama"
    },
    kk: {
        name: "Kazakh",
        nativeName: "\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456"
    },
    kl: {
        name: "Kalaallisut",
        nativeName: "kalaallisut"
    },
    km: {
        name: "Khmer",
        nativeName: "\u1781\u17C1\u1798\u179A\u1797\u17B6\u179F\u17B6"
    },
    kn: {
        name: "Kannada",
        nativeName: "\u0C95\u0CA8\u0CCD\u0CA8\u0CA1"
    },
    ko: {
        name: "Korean",
        nativeName: "\uD55C\uAD6D\uC5B4"
    },
    kr: {
        name: "Kanuri",
        nativeName: "Kanuri"
    },
    ks: {
        name: "Kashmiri",
        nativeName: "\u0915\u0936\u094D\u092E\u0940\u0930\u0940"
    },
    ku: {
        name: "Kurdish",
        nativeName: "Kurd\xee"
    },
    kv: {
        name: "Komi",
        nativeName: "\u043A\u043E\u043C\u0438 \u043A\u044B\u0432"
    },
    kw: {
        name: "Cornish",
        nativeName: "Kernewek"
    },
    ky: {
        name: "Kyrgyz",
        nativeName: "\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430"
    },
    la: {
        name: "Latin",
        nativeName: "latine"
    },
    lb: {
        name: "Luxembourgish",
        nativeName: "L\xebtzebuergesch"
    },
    lg: {
        name: "Ganda",
        nativeName: "Luganda"
    },
    li: {
        name: "Limburgish",
        nativeName: "Limburgs"
    },
    ln: {
        name: "Lingala",
        nativeName: "Ling\xe1la"
    },
    lo: {
        name: "Lao",
        nativeName: "\u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7"
    },
    lt: {
        name: "Lithuanian",
        nativeName: "lietuvi\u0173 kalba"
    },
    lu: {
        name: "Luba-Katanga",
        nativeName: "Kiluba"
    },
    lv: {
        name: "Latvian",
        nativeName: "latvie\u0161u valoda"
    },
    mg: {
        name: "Malagasy",
        nativeName: "fiteny malagasy"
    },
    mh: {
        name: "Marshallese",
        nativeName: "Kajin M\u0327aje\u013C"
    },
    mi: {
        name: "M\u0101ori",
        nativeName: "te reo M\u0101ori"
    },
    mk: {
        name: "Macedonian",
        nativeName: "\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 \u0458\u0430\u0437\u0438\u043A"
    },
    ml: {
        name: "Malayalam",
        nativeName: "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02"
    },
    mn: {
        name: "Mongolian",
        nativeName: "\u041C\u043E\u043D\u0433\u043E\u043B \u0445\u044D\u043B"
    },
    mr: {
        name: "Marathi",
        nativeName: "\u092E\u0930\u093E\u0920\u0940"
    },
    ms: {
        name: "Malay",
        nativeName: "Bahasa Melayu"
    },
    mt: {
        name: "Maltese",
        nativeName: "Malti"
    },
    my: {
        name: "Burmese",
        nativeName: "\u1017\u1019\u102C\u1005\u102C"
    },
    na: {
        name: "Nauru",
        nativeName: "Dorerin Naoero"
    },
    nb: {
        name: "Norwegian Bokm\xe5l",
        nativeName: "Norsk bokm\xe5l"
    },
    nd: {
        name: "Northern Ndebele",
        nativeName: "isiNdebele"
    },
    ne: {
        name: "Nepali",
        nativeName: "\u0928\u0947\u092A\u093E\u0932\u0940"
    },
    ng: {
        name: "Ndonga",
        nativeName: "Owambo"
    },
    nl: {
        name: "Dutch",
        nativeName: "Nederlands"
    },
    nn: {
        name: "Norwegian Nynorsk",
        nativeName: "Norsk nynorsk"
    },
    no: {
        name: "Norwegian",
        nativeName: "Norsk"
    },
    nr: {
        name: "Southern Ndebele",
        nativeName: "isiNdebele"
    },
    nv: {
        name: "Navajo",
        nativeName: "Din\xe9 bizaad"
    },
    ny: {
        name: "Chichewa",
        nativeName: "chiChe\u0175a"
    },
    oc: {
        name: "Occitan",
        nativeName: "occitan"
    },
    oj: {
        name: "Ojibwe",
        nativeName: "\u140A\u14C2\u1511\u14C8\u142F\u14A7\u140E\u14D0"
    },
    om: {
        name: "Oromo",
        nativeName: "Afaan Oromoo"
    },
    or: {
        name: "Oriya",
        nativeName: "\u0B13\u0B21\u0B3C\u0B3F\u0B06"
    },
    os: {
        name: "Ossetian",
        nativeName: "\u0438\u0440\u043E\u043D \xe6\u0432\u0437\u0430\u0433"
    },
    pa: {
        name: "Panjabi",
        nativeName: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40"
    },
    pi: {
        name: "P\u0101li",
        nativeName: "\u092A\u093E\u0934\u093F"
    },
    pl: {
        name: "Polish",
        nativeName: "Polski"
    },
    ps: {
        name: "Pashto",
        nativeName: "\u067E\u069A\u062A\u0648"
    },
    pt: {
        name: "Portuguese",
        nativeName: "Portugu\xeas"
    },
    qu: {
        name: "Quechua",
        nativeName: "Runa Simi"
    },
    rm: {
        name: "Romansh",
        nativeName: "rumantsch grischun"
    },
    rn: {
        name: "Kirundi",
        nativeName: "Ikirundi"
    },
    ro: {
        name: "Romanian",
        nativeName: "Rom\xe2n\u0103"
    },
    ru: {
        name: "Russian",
        nativeName: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    rw: {
        name: "Kinyarwanda",
        nativeName: "Ikinyarwanda"
    },
    sa: {
        name: "Sanskrit",
        nativeName: "\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D"
    },
    sc: {
        name: "Sardinian",
        nativeName: "sardu"
    },
    sd: {
        name: "Sindhi",
        nativeName: "\u0938\u093F\u0928\u094D\u0927\u0940"
    },
    se: {
        name: "Northern Sami",
        nativeName: "Davvis\xe1megiella"
    },
    sg: {
        name: "Sango",
        nativeName: "y\xe2ng\xe2 t\xee s\xe4ng\xf6"
    },
    si: {
        name: "Sinhala",
        nativeName: "\u0DC3\u0DD2\u0D82\u0DC4\u0DBD"
    },
    sk: {
        name: "Slovak",
        nativeName: "sloven\u010Dina"
    },
    sl: {
        name: "Slovenian",
        nativeName: "sloven\u0161\u010Dina"
    },
    sm: {
        name: "Samoan",
        nativeName: "gagana fa'a Samoa"
    },
    sn: {
        name: "Shona",
        nativeName: "chiShona"
    },
    so: {
        name: "Somali",
        nativeName: "Soomaaliga"
    },
    sq: {
        name: "Albanian",
        nativeName: "Shqip"
    },
    sr: {
        name: "Serbian",
        nativeName: "\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A"
    },
    ss: {
        name: "Swati",
        nativeName: "SiSwati"
    },
    st: {
        name: "Southern Sotho",
        nativeName: "Sesotho"
    },
    su: {
        name: "Sundanese",
        nativeName: "Basa Sunda"
    },
    sv: {
        name: "Swedish",
        nativeName: "Svenska"
    },
    sw: {
        name: "Swahili",
        nativeName: "Kiswahili"
    },
    ta: {
        name: "Tamil",
        nativeName: "\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD"
    },
    te: {
        name: "Telugu",
        nativeName: "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41"
    },
    tg: {
        name: "Tajik",
        nativeName: "\u0442\u043E\u04B7\u0438\u043A\u04E3"
    },
    th: {
        name: "Thai",
        nativeName: "\u0E44\u0E17\u0E22"
    },
    ti: {
        name: "Tigrinya",
        nativeName: "\u1275\u130D\u122D\u129B"
    },
    tk: {
        name: "Turkmen",
        nativeName: "T\xfcrkmen\xe7e"
    },
    tl: {
        name: "Tagalog",
        nativeName: "Wikang Tagalog"
    },
    tn: {
        name: "Tswana",
        nativeName: "Setswana"
    },
    to: {
        name: "Tonga",
        nativeName: "faka Tonga"
    },
    tr: {
        name: "Turkish",
        nativeName: "T\xfcrk\xe7e"
    },
    ts: {
        name: "Tsonga",
        nativeName: "Xitsonga"
    },
    tt: {
        name: "Tatar",
        nativeName: "\u0442\u0430\u0442\u0430\u0440 \u0442\u0435\u043B\u0435"
    },
    tw: {
        name: "Twi",
        nativeName: "Twi"
    },
    ty: {
        name: "Tahitian",
        nativeName: "Reo Tahiti"
    },
    ug: {
        name: "Uyghur",
        nativeName: "\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5\u200E"
    },
    uk: {
        name: "Ukrainian",
        nativeName: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"
    },
    ur: {
        name: "Urdu",
        nativeName: "\u0627\u0631\u062F\u0648"
    },
    uz: {
        name: "Uzbek",
        nativeName: "\u040E\u0437\u0431\u0435\u043A"
    },
    ve: {
        name: "Venda",
        nativeName: "Tshiven\u1E13a"
    },
    vi: {
        name: "Vietnamese",
        nativeName: "Ti\u1EBFng Vi\u1EC7t"
    },
    vo: {
        name: "Volap\xfck",
        nativeName: "Volap\xfck"
    },
    wa: {
        name: "Walloon",
        nativeName: "walon"
    },
    wo: {
        name: "Wolof",
        nativeName: "Wollof"
    },
    xh: {
        name: "Xhosa",
        nativeName: "isiXhosa"
    },
    yi: {
        name: "Yiddish",
        nativeName: "\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9"
    },
    yo: {
        name: "Yoruba",
        nativeName: "Yor\xf9b\xe1"
    },
    za: {
        name: "Zhuang",
        nativeName: "Sa\u026F cue\u014B\u0185"
    },
    zh: {
        name: "Chinese",
        nativeName: "\u4E2D\u6587"
    },
    zu: {
        name: "Zulu",
        nativeName: "isiZulu"
    }
};
var $f644590b078bf3f3$export$2e2bcd8739ae039 = $f644590b078bf3f3$var$LANGUAGES_LIST;

});


parcelRegister("g9Zh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc3d043c6b96f1bb$export$2e2bcd8739ae039);
const $bc3d043c6b96f1bb$var$LANGUAGES_ZH_NAMES = {
    aa: "\u963F\u6CD5\u5C14\u8BED",
    ab: "\u963F\u5E03\u54C8\u5179\u8BED",
    ae: "\u963F\u7EF4\u65AF\u9640\u8BED",
    af: "\u5357\u975E\u8377\u5170\u8BED",
    ak: "\u963F\u574E\u8BED",
    am: "\u963F\u59C6\u54C8\u62C9\u8BED",
    an: "\u963F\u62C9\u8D21\u8BED",
    ar: "\u963F\u62C9\u4F2F\u8BED",
    as: "\u963F\u8428\u59C6\u8BED",
    av: "\u963F\u74E6\u5C14\u8BED",
    ay: "\u827E\u9A6C\u62C9\u8BED",
    az: "\u963F\u585E\u62DC\u7586\u8BED",
    ba: "\u5DF4\u4EC0\u57FA\u5C14\u8BED",
    be: "\u767D\u4FC4\u7F57\u65AF\u8BED",
    bg: "\u4FDD\u52A0\u5229\u4E9A\u8BED",
    bh: "\u6BD4\u54C8\u5C14\u8BED",
    bi: "\u6BD4\u65AF\u62C9\u9A6C\u8BED",
    bm: "\u73ED\u5DF4\u62C9\u8BED",
    bn: "\u5B5F\u52A0\u62C9\u8BED",
    bo: "\u85CF\u8BED",
    br: "\u5E03\u5217\u5854\u5C3C\u8BED",
    bs: "\u6CE2\u65AF\u5C3C\u4E9A\u8BED",
    ca: "\u52A0\u6CF0\u7F57\u5C3C\u4E9A\u8BED",
    ce: "\u8F66\u81E3\u8BED",
    ch: "\u67E5\u83AB\u6D1B\u8BED",
    co: "\u79D1\u897F\u5609\u8BED",
    cr: "\u514B\u91CC\u8BED",
    cs: "\u6377\u514B\u8BED",
    cu: "\u53E4\u6559\u4F1A\u65AF\u62C9\u592B\u8BED",
    cv: "\u695A\u74E6\u4EC0\u8BED",
    cy: "\u5A01\u5C14\u58EB\u8BED",
    da: "\u4E39\u9EA6\u8BED",
    de: "\u5FB7\u8BED",
    dv: "\u8FEA\u7EF4\u5E0C\u8BED",
    dz: "\u4E0D\u4E39\u8BED",
    ee: "\u57C3\u7EF4\u8BED",
    el: "\u5E0C\u814A\u8BED",
    en: "\u82F1\u8BED",
    eo: "\u4E16\u754C\u8BED",
    es: "\u897F\u73ED\u7259\u8BED",
    et: "\u7231\u6C99\u5C3C\u4E9A\u8BED",
    eu: "\u5DF4\u65AF\u514B\u8BED",
    fa: "\u6CE2\u65AF\u8BED",
    ff: "\u5BCC\u62C9\u8BED",
    fi: "\u82AC\u5170\u8BED",
    fj: "\u6590\u6D4E\u8BED",
    fo: "\u6CD5\u7F57\u8BED",
    fr: "\u6CD5\u8BED",
    fy: "\u897F\u5F17\u91CC\u897F\u4E9A\u8BED",
    ga: "\u7231\u5C14\u5170\u8BED",
    gd: "\u82CF\u683C\u5170\u76D6\u5C14\u8BED",
    gl: "\u52A0\u5229\u897F\u4E9A\u8BED",
    gn: "\u74DC\u62C9\u5C3C\u8BED",
    gu: "\u53E4\u5409\u62C9\u7279\u8BED",
    gv: "\u9A6C\u6069\u5C9B\u8BED",
    ha: "\u8C6A\u8428\u8BED",
    he: "\u5E0C\u4F2F\u6765\u8BED",
    hi: "\u5370\u5730\u8BED",
    ho: "\u83AB\u56FE\u8BED",
    hr: "\u514B\u7F57\u5730\u4E9A\u8BED",
    ht: "\u6D77\u5730\u6587",
    hu: "\u5308\u7259\u5229\u8BED",
    hy: "\u4E9A\u7F8E\u5C3C\u4E9A\u8BED",
    hz: "\u8D6B\u52D2\u5A04\u8BED",
    ia: "\u56FD\u9645\u8BED",
    id: "\u5370\u5C3C\u8BED",
    ie: "\u56FD\u9645\u8BED",
    ig: "\u4F0A\u535A\u8BED",
    ii: "\u8BFA\u82CF\u8BED",
    ik: "\u4F9D\u5974\u76AE\u7EF4\u514B\u6587",
    io: "\u4F0A\u591A\u6587",
    is: "\u51B0\u5C9B\u8BED",
    it: "\u610F\u5927\u5229\u8BED",
    iu: "\u56E0\u7EBD\u7279\u8BED",
    ja: "\u65E5\u8BED",
    jv: "\u722A\u54C7\u8BED",
    ka: "\u683C\u9C81\u5409\u4E9A\u8BED",
    kg: "\u521A\u679C\u8BED",
    ki: "\u57FA\u5E93\u5C24\u8BED",
    kj: "\u5BBD\u4E9A\u9A6C\u8BED",
    kk: "\u54C8\u8428\u514B\u8BED",
    kl: "\u683C\u9675\u5170\u8BED",
    km: "\u9AD8\u68C9\u8BED",
    kn: "\u5361\u7EB3\u8FBE\u8BED",
    ko: "\u97E9\u8BED",
    kr: "\u5361\u52AA\u91CC\u8BED",
    ks: "\u514B\u4EC0\u7C73\u5C14\u8BED",
    ku: "\u5E93\u5C14\u5FB7\u8BED",
    kv: "\u79D1\u7C73\u8BED",
    kw: "\u79D1\u5C3C\u4EC0\u8BED",
    ky: "\u5409\u5C14\u5409\u65AF\u8BED",
    la: "\u62C9\u4E01\u8BED",
    lb: "\u5362\u68EE\u5821\u8BED",
    lg: "\u7518\u8FBE\u8BED",
    li: "\u6797\u5821\u8BED",
    ln: "\u6797\u52A0\u62C9\u8BED",
    lo: "\u8001\u631D\u8BED",
    lt: "\u7ACB\u9676\u5B9B\u8BED",
    lu: "\u5362\u5DF4\u52A0\u4E39\u52A0\u8BED",
    lv: "\u62C9\u8131\u7EF4\u4E9A\u8BED",
    mg: "\u9A6C\u5C14\u52A0\u4EC0\u8BED",
    mh: "\u9A6C\u7ECD\u5C14\u8BED",
    mi: "\u6BDB\u5229\u8BED",
    mk: "\u9A6C\u5176\u987F\u8BED",
    ml: "\u9A6C\u62C9\u96C5\u62C9\u59C6\u8BED",
    mn: "\u8499\u53E4\u6587",
    mr: "\u9A6C\u62C9\u5730\u8BED",
    ms: "\u9A6C\u6765\u8BED",
    mt: "\u9A6C\u8033\u4ED6\u8BED",
    my: "\u7F05\u7538\u8BED",
    na: "\u7459\u9C81\u8BED",
    nb: "\u632A\u5A01\u535A\u514B\u9A6C\u5C14\u8BED",
    nd: "\u5317\u6069\u5FB7\u8D1D\u52D2\u8BED",
    ne: "\u5C3C\u6CCA\u5C14\u8BED",
    ng: "\u5C3C\u65E5\u5C14\u521A\u679C\u8BED",
    nl: "\u8377\u5170\u8BED",
    nn: "\u632A\u5A01\u5C3C\u8BFA\u65AF\u514B\u8BED",
    no: "\u632A\u5A01\u8BED",
    nr: "\u5357\u6069\u5FB7\u8D1D\u52D2\u8BED",
    nv: "\u7EB3\u74E6\u970D\u8BED",
    ny: "\u9F50\u5207\u74E6\u8BED",
    oc: "\u5965\u514B\u897F\u5510\u8BED",
    oj: "\u6B27\u53CA\u5E03\u5A01\u8BED",
    om: "\u5965\u7F57\u83AB\u8BED",
    or: "\u5965\u91CC\u4E9A\u8BED",
    os: "\u5965\u585E\u68AF\u8BED",
    pa: "\u65C1\u906E\u666E\u8BED",
    pi: "\u5DF4\u5229\u8BED",
    pl: "\u6CE2\u5170\u8BED",
    ps: "\u666E\u4EC0\u56FE\u8BED",
    pt: "\u8461\u8404\u7259\u8BED",
    qu: "\u514B\u4E18\u4E9A\u8BED",
    rm: "\u7F57\u66FC\u65AF\u8BED",
    rn: "\u57FA\u9686\u8FEA\u8BED",
    ro: "\u7F57\u9A6C\u5C3C\u4E9A\u8BED",
    ru: "\u4FC4\u8BED",
    rw: "\u5362\u65FA\u8FBE\u8BED",
    sa: "\u68B5\u6587",
    sc: "\u6492\u4E01\u5C9B\u8BED",
    sd: "\u4FE1\u5FB7\u8BED",
    se: "\u5317\u8428\u7C73\u6587",
    sg: "\u6851\u6208\u8BED",
    si: "\u50E7\u4F3D\u7F57\u8BED",
    sk: "\u65AF\u6D1B\u4F10\u514B\u8BED",
    sl: "\u65AF\u6D1B\u6587\u5C3C\u4E9A\u8BED",
    sm: "\u8428\u6469\u4E9A\u8BED",
    sn: "\u7ECD\u7EB3\u8BED",
    so: "\u7D22\u9A6C\u91CC\u8BED",
    sq: "\u963F\u5C14\u5DF4\u5C3C\u4E9A\u8BED",
    sr: "\u585E\u5C14\u7EF4\u4E9A\u8BED",
    ss: "\u65AF\u74E6\u8482\u8BED",
    st: "\u5357\u7D22\u6258\u8BED",
    su: "\u5DFD\u4ED6\u8BED",
    sv: "\u745E\u5178\u8BED",
    sw: "\u65AF\u74E6\u5E0C\u91CC\u8BED",
    ta: "\u6CF0\u7C73\u5C14\u8BED",
    te: "\u6CF0\u5362\u56FA\u8BED",
    tg: "\u5854\u5409\u514B\u8BED",
    th: "\u6CF0\u8BED",
    ti: "\u63D0\u683C\u96F7\u8BED",
    tk: "\u571F\u5E93\u66FC\u8BED",
    tl: "\u83F2\u5F8B\u5BBE\u8BED",
    tn: "\u8328\u74E6\u7EB3\u8BED",
    to: "\u6C64\u52A0\u8BED",
    tr: "\u571F\u8033\u5176\u8BED",
    ts: "\u7279\u677E\u52A0\u8BED",
    tt: "\u5854\u5854\u5C14\u8BED",
    tw: "\u5951\u7EF4\u8BED",
    ty: "\u5854\u5E0C\u63D0\u8BED",
    ug: "\u7EF4\u543E\u5C14\u8BED",
    uk: "\u4E4C\u514B\u5170\u8BED",
    ur: "\u4E4C\u5C14\u90FD\u8BED",
    uz: "\u4E4C\u5179\u522B\u514B\u8BED",
    ve: "\u6587\u8FBE\u8BED",
    vi: "\u8D8A\u5357\u8BED",
    vo: "\u6C83\u62C9\u666E\u514B\u8BED",
    wa: "\u534E\u9686\u8BED",
    wo: "\u6C83\u6D1B\u592B\u8BED",
    xh: "\u79D1\u8428\u8BED",
    yi: "\u610F\u7B2C\u7EEA\u8BED",
    yo: "\u7EA6\u9C81\u5DF4\u8BED",
    za: "\u58EE\u8BED",
    zh: "\u4E2D\u6587",
    zu: "\u7956\u9C81\u8BED"
};
var $bc3d043c6b96f1bb$export$2e2bcd8739ae039 = $bc3d043c6b96f1bb$var$LANGUAGES_ZH_NAMES;

});


parcelRegister("3qzNN", function(module, exports) {

(function() {
    var Iso31661a2, mout, singleton;
    mout = (parcelRequire("k83WX"));
    Iso31661a2 = function() {
        function Iso31661a2() {}
        Iso31661a2.prototype.getCountry = function(code) {
            return Iso31661a2.prototype.countries[code];
        };
        Iso31661a2.prototype.getCode = function(country) {
            var idx, ret;
            ret = null;
            if (country != null) {
                idx = mout.values(Iso31661a2.prototype.countries).indexOf(country);
                if (idx !== -1) ret = Object.keys(Iso31661a2.prototype.countries)[idx];
            }
            return ret;
        };
        Iso31661a2.prototype.getCountries = function() {
            return mout.values(Iso31661a2.prototype.countries);
        };
        Iso31661a2.prototype.getCodes = function() {
            return Object.keys(Iso31661a2.prototype.countries);
        };
        Iso31661a2.prototype.getData = function() {
            return Iso31661a2.prototype.countries;
        };
        Iso31661a2.prototype.countries = {
            AF: "Afghanistan",
            AX: "\xc5land Islands",
            AL: "Albania",
            DZ: "Algeria",
            AS: "American Samoa",
            AD: "Andorra",
            AO: "Angola",
            AI: "Anguilla",
            AQ: "Antarctica",
            AG: "Antigua and Barbuda",
            AR: "Argentina",
            AM: "Armenia",
            AW: "Aruba",
            AU: "Australia",
            AT: "Austria",
            AZ: "Azerbaijan",
            BS: "Bahamas",
            BH: "Bahrain",
            BD: "Bangladesh",
            BB: "Barbados",
            BY: "Belarus",
            BE: "Belgium",
            BZ: "Belize",
            BJ: "Benin",
            BM: "Bermuda",
            BT: "Bhutan",
            BO: "Bolivia, Plurinational State of",
            BQ: "Bonaire, Sint Eustatius and Saba",
            BA: "Bosnia and Herzegovina",
            BW: "Botswana",
            BV: "Bouvet Island",
            BR: "Brazil",
            IO: "British Indian Ocean Territory",
            BN: "Brunei Darussalam",
            BG: "Bulgaria",
            BF: "Burkina Faso",
            BI: "Burundi",
            KH: "Cambodia",
            CM: "Cameroon",
            CA: "Canada",
            CV: "Cape Verde",
            KY: "Cayman Islands",
            CF: "Central African Republic",
            TD: "Chad",
            CL: "Chile",
            CN: "China",
            CX: "Christmas Island",
            CC: "Cocos (Keeling) Islands",
            CO: "Colombia",
            KM: "Comoros",
            CG: "Congo",
            CD: "Congo, the Democratic Republic of the",
            CK: "Cook Islands",
            CR: "Costa Rica",
            CI: "C\xf4te d'Ivoire",
            HR: "Croatia",
            CU: "Cuba",
            CW: "Cura\xe7ao",
            CY: "Cyprus",
            CZ: "Czech Republic",
            DK: "Denmark",
            DJ: "Djibouti",
            DM: "Dominica",
            DO: "Dominican Republic",
            EC: "Ecuador",
            EG: "Egypt",
            SV: "El Salvador",
            GQ: "Equatorial Guinea",
            ER: "Eritrea",
            EE: "Estonia",
            ET: "Ethiopia",
            FK: "Falkland Islands (Malvinas)",
            FO: "Faroe Islands",
            FJ: "Fiji",
            FI: "Finland",
            FR: "France",
            GF: "French Guiana",
            PF: "French Polynesia",
            TF: "French Southern Territories",
            GA: "Gabon",
            GM: "Gambia",
            GE: "Georgia",
            DE: "Germany",
            GH: "Ghana",
            GI: "Gibraltar",
            GR: "Greece",
            GL: "Greenland",
            GD: "Grenada",
            GP: "Guadeloupe",
            GU: "Guam",
            GT: "Guatemala",
            GG: "Guernsey",
            GN: "Guinea",
            GW: "Guinea-Bissau",
            GY: "Guyana",
            HT: "Haiti",
            HM: "Heard Island and McDonald Mcdonald Islands",
            VA: "Holy See (Vatican City State)",
            HN: "Honduras",
            HK: "Hong Kong",
            HU: "Hungary",
            IS: "Iceland",
            IN: "India",
            ID: "Indonesia",
            IR: "Iran, Islamic Republic of",
            IQ: "Iraq",
            IE: "Ireland",
            IM: "Isle of Man",
            IL: "Israel",
            IT: "Italy",
            JM: "Jamaica",
            JP: "Japan",
            JE: "Jersey",
            JO: "Jordan",
            KZ: "Kazakhstan",
            KE: "Kenya",
            KI: "Kiribati",
            XK: "Kosovo",
            KP: "Korea, Democratic People's Republic of",
            KR: "Korea, Republic of",
            KW: "Kuwait",
            KG: "Kyrgyzstan",
            LA: "Lao People's Democratic Republic",
            LV: "Latvia",
            LB: "Lebanon",
            LS: "Lesotho",
            LR: "Liberia",
            LY: "Libya",
            LI: "Liechtenstein",
            LT: "Lithuania",
            LU: "Luxembourg",
            MO: "Macao",
            MK: "North Macedonia",
            MG: "Madagascar",
            MW: "Malawi",
            MY: "Malaysia",
            MV: "Maldives",
            ML: "Mali",
            MT: "Malta",
            MH: "Marshall Islands",
            MQ: "Martinique",
            MR: "Mauritania",
            MU: "Mauritius",
            YT: "Mayotte",
            MX: "Mexico",
            FM: "Micronesia, Federated States of",
            MD: "Moldova, Republic of",
            MC: "Monaco",
            MN: "Mongolia",
            ME: "Montenegro",
            MS: "Montserrat",
            MA: "Morocco",
            MZ: "Mozambique",
            MM: "Myanmar",
            NA: "Namibia",
            NR: "Nauru",
            NP: "Nepal",
            NL: "Netherlands",
            AN: "Netherlands Antilles",
            NC: "New Caledonia",
            NZ: "New Zealand",
            NI: "Nicaragua",
            NE: "Niger",
            NG: "Nigeria",
            NU: "Niue",
            NF: "Norfolk Island",
            MP: "Northern Mariana Islands",
            NO: "Norway",
            OM: "Oman",
            PK: "Pakistan",
            PW: "Palau",
            PS: "Palestine, State of",
            PA: "Panama",
            PG: "Papua New Guinea",
            PY: "Paraguay",
            PE: "Peru",
            PH: "Philippines",
            PN: "Pitcairn",
            PL: "Poland",
            PT: "Portugal",
            PR: "Puerto Rico",
            QA: "Qatar",
            RE: "R\xe9union",
            RO: "Romania",
            RU: "Russian Federation",
            RW: "Rwanda",
            BL: "Saint Barth\xe9lemy",
            SH: "Saint Helena, Ascension and Tristan da Cunha",
            KN: "Saint Kitts and Nevis",
            LC: "Saint Lucia",
            MF: "Saint Martin (French part)",
            PM: "Saint Pierre and Miquelon",
            VC: "Saint Vincent and the Grenadines",
            WS: "Samoa",
            SM: "San Marino",
            ST: "Sao Tome and Principe",
            SA: "Saudi Arabia",
            SN: "Senegal",
            RS: "Serbia",
            SC: "Seychelles",
            SL: "Sierra Leone",
            SG: "Singapore",
            SX: "Sint Maarten (Dutch part)",
            SK: "Slovakia",
            SI: "Slovenia",
            SB: "Solomon Islands",
            SO: "Somalia",
            ZA: "South Africa",
            GS: "South Georgia and the South Sandwich Islands",
            SS: "South Sudan",
            ES: "Spain",
            LK: "Sri Lanka",
            SD: "Sudan",
            SR: "Suriname",
            SJ: "Svalbard and Jan Mayen",
            SZ: "Swaziland",
            SE: "Sweden",
            CH: "Switzerland",
            SY: "Syrian Arab Republic",
            TW: "Taiwan, Province of China",
            TJ: "Tajikistan",
            TZ: "Tanzania, United Republic of",
            TH: "Thailand",
            TL: "Timor-Leste",
            TG: "Togo",
            TK: "Tokelau",
            TO: "Tonga",
            TT: "Trinidad and Tobago",
            TN: "Tunisia",
            TR: "Turkey",
            TM: "Turkmenistan",
            TC: "Turks and Caicos Islands",
            TV: "Tuvalu",
            UG: "Uganda",
            UA: "Ukraine",
            AE: "United Arab Emirates",
            GB: "United Kingdom",
            US: "United States",
            UM: "United States Minor Outlying Islands",
            UY: "Uruguay",
            UZ: "Uzbekistan",
            VU: "Vanuatu",
            VE: "Venezuela, Bolivarian Republic of",
            VN: "Viet Nam",
            VG: "Virgin Islands, British",
            VI: "Virgin Islands, U.S.",
            WF: "Wallis and Futuna",
            EH: "Western Sahara",
            YE: "Yemen",
            ZM: "Zambia",
            ZW: "Zimbabwe"
        };
        return Iso31661a2;
    }();
    singleton = null;
    module.exports = function() {
        return singleton != null ? singleton : singleton = new Iso31661a2();
    }();
}).call(module.exports);

});
parcelRegister("k83WX", function(module, exports) {
//automatically generated, do not edit!
//run `node build` instead




































module.exports = {
    "bindAll": (parcelRequire("d3mAr")),
    "contains": (parcelRequire("5OVVB")),
    "deepFillIn": (parcelRequire("8P8vc")),
    "deepMatches": (parcelRequire("fomiQ")),
    "deepMixIn": (parcelRequire("anMzU")),
    "equals": (parcelRequire("jTSRK")),
    "every": (parcelRequire("bktb5")),
    "fillIn": (parcelRequire("hTbno")),
    "filter": (parcelRequire("1BHzX")),
    "find": (parcelRequire("9P2kT")),
    "flatten": (parcelRequire("e2IUS")),
    "forIn": (parcelRequire("afr3x")),
    "forOwn": (parcelRequire("ltrFL")),
    "functions": (parcelRequire("019X2")),
    "get": (parcelRequire("9pwF4")),
    "has": (parcelRequire("b4Af5")),
    "hasOwn": (parcelRequire("f49nk")),
    "keys": (parcelRequire("1fFzc")),
    "map": (parcelRequire("9BrIp")),
    "matches": (parcelRequire("h3V3F")),
    "max": (parcelRequire("aE5Xc")),
    "merge": (parcelRequire("9rCnL")),
    "min": (parcelRequire("ldZPn")),
    "mixIn": (parcelRequire("1jlIP")),
    "namespace": (parcelRequire("6Cptt")),
    "omit": (parcelRequire("iVJSf")),
    "pick": (parcelRequire("58eYY")),
    "pluck": (parcelRequire("lNQmL")),
    "reduce": (parcelRequire("husMK")),
    "reject": (parcelRequire("kT2js")),
    "result": (parcelRequire("2OwJr")),
    "set": (parcelRequire("lT7jr")),
    "size": (parcelRequire("6PL2h")),
    "some": (parcelRequire("70unz")),
    "unset": (parcelRequire("4UFt5")),
    "values": (parcelRequire("3gwgt"))
};

});
parcelRegister("d3mAr", function(module, exports) {

var $019X2 = parcelRequire("019X2");

var $if8RD = parcelRequire("if8RD");

var $1wEiX = parcelRequire("1wEiX");

var $fXExr = parcelRequire("fXExr");
/**
     * Binds methods of the object to be run in it's own context.
     */ function $980d13755208ae99$var$bindAll(obj, rest_methodNames) {
    var keys = arguments.length > 1 ? $fXExr(arguments, 1) : $019X2(obj);
    $1wEiX(keys, function(key) {
        obj[key] = $if8RD(obj[key], obj);
    });
}
module.exports = $980d13755208ae99$var$bindAll;

});
parcelRegister("019X2", function(module, exports) {

var $afr3x = parcelRequire("afr3x");
/**
     * return a list of all enumerable properties that have function values
     */ function $0037d03a1a38ee1d$var$functions(obj) {
    var keys = [];
    $afr3x(obj, function(val, key) {
        if (typeof val === "function") keys.push(key);
    });
    return keys.sort();
}
module.exports = $0037d03a1a38ee1d$var$functions;

});
parcelRegister("afr3x", function(module, exports) {

var $f49nk = parcelRequire("f49nk");
var $77604ad8c52f08c3$var$_hasDontEnumBug, $77604ad8c52f08c3$var$_dontEnums;
function $77604ad8c52f08c3$var$checkDontEnum() {
    $77604ad8c52f08c3$var$_dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    $77604ad8c52f08c3$var$_hasDontEnumBug = true;
    for(var key in {
        "toString": null
    })$77604ad8c52f08c3$var$_hasDontEnumBug = false;
}
/**
     * Similar to Array/forEach but works over object properties and fixes Don't
     * Enum bug on IE.
     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
     */ function $77604ad8c52f08c3$var$forIn(obj, fn, thisObj) {
    var key, i = 0;
    // no need to check if argument is a real object that way we can use
    // it for arrays, functions, date, etc.
    //post-pone check till needed
    if ($77604ad8c52f08c3$var$_hasDontEnumBug == null) $77604ad8c52f08c3$var$checkDontEnum();
    for(key in obj){
        if ($77604ad8c52f08c3$var$exec(fn, obj, key, thisObj) === false) break;
    }
    if ($77604ad8c52f08c3$var$_hasDontEnumBug) {
        var ctor = obj.constructor, isProto = !!ctor && obj === ctor.prototype;
        while(key = $77604ad8c52f08c3$var$_dontEnums[i++])// For constructor, if it is a prototype object the constructor
        // is always non-enumerable unless defined otherwise (and
        // enumerated above).  For non-prototype objects, it will have
        // to be defined on this object, since it cannot be defined on
        // any prototype objects.
        //
        // For other [[DontEnum]] properties, check if the value is
        // different than Object prototype value.
        if ((key !== "constructor" || !isProto && $f49nk(obj, key)) && obj[key] !== Object.prototype[key]) {
            if ($77604ad8c52f08c3$var$exec(fn, obj, key, thisObj) === false) break;
        }
    }
}
function $77604ad8c52f08c3$var$exec(fn, obj, key, thisObj) {
    return fn.call(thisObj, obj[key], key, obj);
}
module.exports = $77604ad8c52f08c3$var$forIn;

});
parcelRegister("f49nk", function(module, exports) {
/**
     * Safer Object.hasOwnProperty
     */ function $af7e8079017dbbf2$var$hasOwn(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = $af7e8079017dbbf2$var$hasOwn;

});



parcelRegister("if8RD", function(module, exports) {

var $fXExr = parcelRequire("fXExr");
/**
     * Return a function that will execute in the given context, optionally adding any additional supplied parameters to the beginning of the arguments collection.
     * @param {Function} fn  Function.
     * @param {object} context   Execution context.
     * @param {rest} args    Arguments (0...n arguments).
     * @return {Function} Wrapped Function.
     */ function $036d6d6f346b2256$var$bind(fn, context, args) {
    var argsArr = $fXExr(arguments, 2); //curried args
    return function() {
        return fn.apply(context, argsArr.concat($fXExr(arguments)));
    };
}
module.exports = $036d6d6f346b2256$var$bind;

});
parcelRegister("fXExr", function(module, exports) {
/**
     * Create slice of source array or array-like object
     */ function $b9ebcfcc832bad07$var$slice(arr, start, end) {
    var len = arr.length;
    if (start == null) start = 0;
    else if (start < 0) start = Math.max(len + start, 0);
    else start = Math.min(start, len);
    if (end == null) end = len;
    else if (end < 0) end = Math.max(len + end, 0);
    else end = Math.min(end, len);
    var result = [];
    while(start < end)result.push(arr[start++]);
    return result;
}
module.exports = $b9ebcfcc832bad07$var$slice;

});


parcelRegister("1wEiX", function(module, exports) {
/**
     * Array forEach
     */ function $11c80b44a03aaf55$var$forEach(arr, callback, thisObj) {
    if (arr == null) return;
    var i = -1, len = arr.length;
    while(++i < len){
        // we iterate over sparse items since there is no way to make it
        // work properly on IE 7-8. see #64
        if (callback.call(thisObj, arr[i], i, arr) === false) break;
    }
}
module.exports = $11c80b44a03aaf55$var$forEach;

});


parcelRegister("5OVVB", function(module, exports) {

var $70unz = parcelRequire("70unz");
/**
     * Check if object contains value
     */ function $43ce8e8bd30be08d$var$contains(obj, needle) {
    return $70unz(obj, function(val) {
        return val === needle;
    });
}
module.exports = $43ce8e8bd30be08d$var$contains;

});
parcelRegister("70unz", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");

var $3cJKy = parcelRequire("3cJKy");
/**
     * Object some
     */ function $51a0192f6b385b17$var$some(obj, callback, thisObj) {
    callback = $3cJKy(callback, thisObj);
    var result = false;
    $ltrFL(obj, function(val, key) {
        if (callback(val, key, obj)) {
            result = true;
            return false; // break
        }
    });
    return result;
}
module.exports = $51a0192f6b385b17$var$some;

});
parcelRegister("ltrFL", function(module, exports) {

var $f49nk = parcelRequire("f49nk");

var $afr3x = parcelRequire("afr3x");
/**
     * Similar to Array/forEach but works over object properties and fixes Don't
     * Enum bug on IE.
     * based on: http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
     */ function $fa21c59da7ca3691$var$forOwn(obj, fn, thisObj) {
    $afr3x(obj, function(val, key) {
        if ($f49nk(obj, key)) return fn.call(thisObj, obj[key], key, obj);
    });
}
module.exports = $fa21c59da7ca3691$var$forOwn;

});

parcelRegister("3cJKy", function(module, exports) {

var $gVxka = parcelRequire("gVxka");

var $6Fbnp = parcelRequire("6Fbnp");

var $fomiQ = parcelRequire("fomiQ");
/**
     * Converts argument into a valid iterator.
     * Used internally on most array/object/collection methods that receives a
     * callback/iterator providing a shortcut syntax.
     */ function $2555fb0b31b4edaa$var$makeIterator(src, thisObj) {
    if (src == null) return $gVxka;
    switch(typeof src){
        case "function":
            // function is the first to improve perf (most common case)
            // also avoid using `Function#call` if not needed, which boosts
            // perf a lot in some cases
            return typeof thisObj !== "undefined" ? function(val, i, arr) {
                return src.call(thisObj, val, i, arr);
            } : src;
        case "object":
            return function(val) {
                return $fomiQ(val, src);
            };
        case "string":
        case "number":
            return $6Fbnp(src);
    }
}
module.exports = $2555fb0b31b4edaa$var$makeIterator;

});
parcelRegister("gVxka", function(module, exports) {
/**
     * Returns the first argument provided to it.
     */ function $c52bd1b45a243f3c$var$identity(val) {
    return val;
}
module.exports = $c52bd1b45a243f3c$var$identity;

});

parcelRegister("6Fbnp", function(module, exports) {
/**
     * Returns a function that gets a property of the passed object
     */ function $4d9f65942a327664$var$prop(name) {
    return function(obj) {
        return obj[name];
    };
}
module.exports = $4d9f65942a327664$var$prop;

});

parcelRegister("fomiQ", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");

var $h358O = parcelRequire("h358O");
function $b34a65cc916e9856$var$containsMatch(array, pattern) {
    var i = -1, length = array.length;
    while(++i < length){
        if ($b34a65cc916e9856$var$deepMatches(array[i], pattern)) return true;
    }
    return false;
}
function $b34a65cc916e9856$var$matchArray(target, pattern) {
    var i = -1, patternLength = pattern.length;
    while(++i < patternLength){
        if (!$b34a65cc916e9856$var$containsMatch(target, pattern[i])) return false;
    }
    return true;
}
function $b34a65cc916e9856$var$matchObject(target, pattern) {
    var result = true;
    $ltrFL(pattern, function(val, key) {
        if (!$b34a65cc916e9856$var$deepMatches(target[key], val)) // Return false to break out of forOwn early
        return result = false;
    });
    return result;
}
/**
     * Recursively check if the objects match.
     */ function $b34a65cc916e9856$var$deepMatches(target, pattern) {
    if (target && typeof target === "object" && pattern && typeof pattern === "object") {
        if ($h358O(target) && $h358O(pattern)) return $b34a65cc916e9856$var$matchArray(target, pattern);
        else return $b34a65cc916e9856$var$matchObject(target, pattern);
    } else return target === pattern;
}
module.exports = $b34a65cc916e9856$var$deepMatches;

});
parcelRegister("h358O", function(module, exports) {

var $h13K8 = parcelRequire("h13K8");
/**
     */ var $c696b46dbdcfe82c$var$isArray = Array.isArray || function(val) {
    return $h13K8(val, "Array");
};
module.exports = $c696b46dbdcfe82c$var$isArray;

});
parcelRegister("h13K8", function(module, exports) {

var $d3Afl = parcelRequire("d3Afl");
/**
     * Check if value is from a specific "kind".
     */ function $c6356ef65f20054c$var$isKind(val, kind) {
    return $d3Afl(val) === kind;
}
module.exports = $c6356ef65f20054c$var$isKind;

});
parcelRegister("d3Afl", function(module, exports) {
/**
     * Gets the "kind" of value. (e.g. "String", "Number", etc)
     */ function $9817abfd04f134f2$var$kindOf(val) {
    return Object.prototype.toString.call(val).slice(8, -1);
}
module.exports = $9817abfd04f134f2$var$kindOf;

});







parcelRegister("8P8vc", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");

var $45X4L = parcelRequire("45X4L");
/**
     * Deeply copy missing properties in the target from the defaults.
     */ function $66c9ae86ecee9ebe$var$deepFillIn(target, defaults) {
    var i = 0, n = arguments.length, obj;
    while(++i < n){
        obj = arguments[i];
        if (obj) // jshint loopfunc: true
        $ltrFL(obj, function(newValue, key) {
            var curValue = target[key];
            if (curValue == null) target[key] = newValue;
            else if ($45X4L(curValue) && $45X4L(newValue)) $66c9ae86ecee9ebe$var$deepFillIn(curValue, newValue);
        });
    }
    return target;
}
module.exports = $66c9ae86ecee9ebe$var$deepFillIn;

});
parcelRegister("45X4L", function(module, exports) {
/**
     * Checks if the value is created by the `Object` constructor.
     */ function $2fb57442da966796$var$isPlainObject(value) {
    return !!value && typeof value === "object" && value.constructor === Object;
}
module.exports = $2fb57442da966796$var$isPlainObject;

});


parcelRegister("anMzU", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");

var $45X4L = parcelRequire("45X4L");
/**
     * Mixes objects into the target object, recursively mixing existing child
     * objects.
     */ function $78f1bbfb0634c164$var$deepMixIn(target, objects) {
    var i = 0, n = arguments.length, obj;
    while(++i < n){
        obj = arguments[i];
        if (obj) $ltrFL(obj, $78f1bbfb0634c164$var$copyProp, target);
    }
    return target;
}
function $78f1bbfb0634c164$var$copyProp(val, key) {
    var existing = this[key];
    if ($45X4L(val) && $45X4L(existing)) $78f1bbfb0634c164$var$deepMixIn(existing, val);
    else this[key] = val;
}
module.exports = $78f1bbfb0634c164$var$deepMixIn;

});

parcelRegister("jTSRK", function(module, exports) {

var $f49nk = parcelRequire("f49nk");

var $bktb5 = parcelRequire("bktb5");

var $iYR8s = parcelRequire("iYR8s");

var $ffzoH = parcelRequire("ffzoH");
// Makes a function to compare the object values from the specified compare
// operation callback.
function $e7cdb69cb5402db3$var$makeCompare(callback) {
    return function(value, key) {
        return $f49nk(this, key) && callback(value, this[key]);
    };
}
function $e7cdb69cb5402db3$var$checkProperties(value, key) {
    return $f49nk(this, key);
}
/**
     * Checks if two objects have the same keys and values.
     */ function $e7cdb69cb5402db3$var$equals(a, b, callback) {
    callback = callback || $ffzoH;
    if (!$iYR8s(a) || !$iYR8s(b)) return callback(a, b);
    return $bktb5(a, $e7cdb69cb5402db3$var$makeCompare(callback), b) && $bktb5(b, $e7cdb69cb5402db3$var$checkProperties, a);
}
module.exports = $e7cdb69cb5402db3$var$equals;

});
parcelRegister("bktb5", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");

var $3cJKy = parcelRequire("3cJKy");
/**
     * Object every
     */ function $83f8321266140909$var$every(obj, callback, thisObj) {
    callback = $3cJKy(callback, thisObj);
    var result = true;
    $ltrFL(obj, function(val, key) {
        // we consider any falsy values as "false" on purpose so shorthand
        // syntax can be used to check property existence
        if (!callback(val, key, obj)) {
            result = false;
            return false; // break
        }
    });
    return result;
}
module.exports = $83f8321266140909$var$every;

});

parcelRegister("iYR8s", function(module, exports) {

var $h13K8 = parcelRequire("h13K8");
/**
     */ function $dd170c291018c0c9$var$isObject(val) {
    return $h13K8(val, "Object");
}
module.exports = $dd170c291018c0c9$var$isObject;

});

parcelRegister("ffzoH", function(module, exports) {
/**
     * Check if both arguments are egal.
     */ function $b1a3b6e9cd3a666c$var$is(x, y) {
    // implementation borrowed from harmony:egal spec
    if (x === y) // 0 === -0, but they are not identical
    return x !== 0 || 1 / x === 1 / y;
    // NaN !== NaN, but they are identical.
    // NaNs are the only non-reflexive value, i.e., if x !== x,
    // then x is a NaN.
    // isNaN is broken: it converts its argument to number, so
    // isNaN("foo") => true
    return x !== x && y !== y;
}
module.exports = $b1a3b6e9cd3a666c$var$is;

});


parcelRegister("hTbno", function(module, exports) {

var $1wEiX = parcelRequire("1wEiX");

var $fXExr = parcelRequire("fXExr");

var $ltrFL = parcelRequire("ltrFL");
/**
     * Copy missing properties in the obj from the defaults.
     */ function $d06065cdea2fe0ac$var$fillIn(obj, var_defaults) {
    $1wEiX($fXExr(arguments, 1), function(base) {
        $ltrFL(base, function(val, key) {
            if (obj[key] == null) obj[key] = val;
        });
    });
    return obj;
}
module.exports = $d06065cdea2fe0ac$var$fillIn;

});

parcelRegister("1BHzX", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");

var $3cJKy = parcelRequire("3cJKy");
/**
     * Creates a new object with all the properties where the callback returns
     * true.
     */ function $12bb0d044df882f1$var$filterValues(obj, callback, thisObj) {
    callback = $3cJKy(callback, thisObj);
    var output = {};
    $ltrFL(obj, function(value, key, obj) {
        if (callback(value, key, obj)) output[key] = value;
    });
    return output;
}
module.exports = $12bb0d044df882f1$var$filterValues;

});

parcelRegister("9P2kT", function(module, exports) {

var $70unz = parcelRequire("70unz");

var $3cJKy = parcelRequire("3cJKy");
/**
     * Returns first item that matches criteria
     */ function $726ab05621c29810$var$find(obj, callback, thisObj) {
    callback = $3cJKy(callback, thisObj);
    var result;
    $70unz(obj, function(value, key, obj) {
        if (callback(value, key, obj)) {
            result = value;
            return true; //break
        }
    });
    return result;
}
module.exports = $726ab05621c29810$var$find;

});

parcelRegister("e2IUS", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");

var $45X4L = parcelRequire("45X4L");
/*
     * Helper function to flatten to a destination object.
     * Used to remove the need to create intermediate objects while flattening.
     */ function $a394180d9056a056$var$flattenTo(obj, result, prefix, level) {
    $ltrFL(obj, function(value, key) {
        var nestedPrefix = prefix ? prefix + "." + key : key;
        if (level !== 0 && $45X4L(value)) $a394180d9056a056$var$flattenTo(value, result, nestedPrefix, level - 1);
        else result[nestedPrefix] = value;
    });
    return result;
}
/**
     * Recursively flattens an object.
     * A new object containing all the elements is returned.
     * If level is specified, it will only flatten up to that level.
     */ function $a394180d9056a056$var$flatten(obj, level) {
    if (obj == null) return {};
    level = level == null ? -1 : level;
    return $a394180d9056a056$var$flattenTo(obj, {}, "", level);
}
module.exports = $a394180d9056a056$var$flatten;

});

parcelRegister("9pwF4", function(module, exports) {
parcelRequire("kWnbF");
/**
     * get "nested" object property
     */ function $6d9fc8b9d5684749$var$get(obj, prop) {
    if (!obj) return;
    var parts = prop.split("."), last = parts.pop();
    while(prop = parts.shift()){
        obj = obj[prop];
        if (obj == null) return;
    }
    return obj[last];
}
module.exports = $6d9fc8b9d5684749$var$get;

});
parcelRegister("kWnbF", function(module, exports) {
/**
     * Checks if the object is a primitive
     */ function $f3eb35eb196f00f6$var$isPrimitive(value) {
    // Using switch fallthrough because it's simple to read and is
    // generally fast: http://jsperf.com/testing-value-is-primitive/5
    switch(typeof value){
        case "string":
        case "number":
        case "boolean":
            return true;
    }
    return value == null;
}
module.exports = $f3eb35eb196f00f6$var$isPrimitive;

});


parcelRegister("b4Af5", function(module, exports) {

var $9pwF4 = parcelRequire("9pwF4");
var $80fc2e61ec15310a$var$UNDEF;
/**
     * Check if object has nested property.
     */ function $80fc2e61ec15310a$var$has(obj, prop) {
    return $9pwF4(obj, prop) !== $80fc2e61ec15310a$var$UNDEF;
}
module.exports = $80fc2e61ec15310a$var$has;

});

parcelRegister("1fFzc", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");
/**
     * Get object keys
     */ var $0e976f742a155ad6$var$keys = Object.keys || function(obj) {
    var keys = [];
    $ltrFL(obj, function(val, key) {
        keys.push(key);
    });
    return keys;
};
module.exports = $0e976f742a155ad6$var$keys;

});

parcelRegister("9BrIp", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");

var $3cJKy = parcelRequire("3cJKy");
/**
     * Creates a new object where all the values are the result of calling
     * `callback`.
     */ function $6fdd1170c6616030$var$mapValues(obj, callback, thisObj) {
    callback = $3cJKy(callback, thisObj);
    var output = {};
    $ltrFL(obj, function(val, key, obj) {
        output[key] = callback(val, key, obj);
    });
    return output;
}
module.exports = $6fdd1170c6616030$var$mapValues;

});

parcelRegister("h3V3F", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");
/**
     * checks if a object contains all given properties/values
     */ function $c6befa0d3231c352$var$matches(target, props) {
    // can't use "object/every" because of circular dependency
    var result = true;
    $ltrFL(props, function(val, key) {
        if (target[key] !== val) // break loop at first difference
        return result = false;
    });
    return result;
}
module.exports = $c6befa0d3231c352$var$matches;

});

parcelRegister("aE5Xc", function(module, exports) {

var $5xfeP = parcelRequire("5xfeP");

var $3gwgt = parcelRequire("3gwgt");
/**
     * Returns maximum value inside object.
     */ function $7c02421db573a604$var$max(obj, compareFn) {
    return $5xfeP($3gwgt(obj), compareFn);
}
module.exports = $7c02421db573a604$var$max;

});
parcelRegister("5xfeP", function(module, exports) {

var $3cJKy = parcelRequire("3cJKy");
/**
     * Return maximum value inside array
     */ function $407bdacf1a7903b5$var$max(arr, iterator, thisObj) {
    if (arr == null || !arr.length) return Infinity;
    else if (arr.length && !iterator) return Math.max.apply(Math, arr);
    else {
        iterator = $3cJKy(iterator, thisObj);
        var result, compare = -Infinity, value, temp;
        var i = -1, len = arr.length;
        while(++i < len){
            value = arr[i];
            temp = iterator(value, i, arr);
            if (temp > compare) {
                compare = temp;
                result = value;
            }
        }
        return result;
    }
}
module.exports = $407bdacf1a7903b5$var$max;

});

parcelRegister("3gwgt", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");
/**
     * Get object values
     */ function $260be4cc7dfe0ddb$var$values(obj) {
    var vals = [];
    $ltrFL(obj, function(val, key) {
        vals.push(val);
    });
    return vals;
}
module.exports = $260be4cc7dfe0ddb$var$values;

});


parcelRegister("9rCnL", function(module, exports) {

var $f49nk = parcelRequire("f49nk");

var $j7wt4 = parcelRequire("j7wt4");

var $iYR8s = parcelRequire("iYR8s");
/**
     * Deep merge objects.
     */ function $6e0468997e554284$var$merge() {
    var i = 1, key, val, obj, target;
    // make sure we don't modify source element and it's properties
    // objects are passed by reference
    target = $j7wt4(arguments[0]);
    while(obj = arguments[i++])for(key in obj){
        if (!$f49nk(obj, key)) continue;
        val = obj[key];
        if ($iYR8s(val) && $iYR8s(target[key])) // inception, deep merge objects
        target[key] = $6e0468997e554284$var$merge(target[key], val);
        else // make sure arrays, regexp, date, objects are cloned
        target[key] = $j7wt4(val);
    }
    return target;
}
module.exports = $6e0468997e554284$var$merge;

});
parcelRegister("j7wt4", function(module, exports) {

var $1oVlt = parcelRequire("1oVlt");

var $ltrFL = parcelRequire("ltrFL");

var $d3Afl = parcelRequire("d3Afl");

var $45X4L = parcelRequire("45X4L");
/**
     * Recursively clone native types.
     */ function $deb7db37fce5cbb4$var$deepClone(val, instanceClone) {
    switch($d3Afl(val)){
        case "Object":
            return $deb7db37fce5cbb4$var$cloneObject(val, instanceClone);
        case "Array":
            return $deb7db37fce5cbb4$var$cloneArray(val, instanceClone);
        default:
            return $1oVlt(val);
    }
}
function $deb7db37fce5cbb4$var$cloneObject(source, instanceClone) {
    if ($45X4L(source)) {
        var out = {};
        $ltrFL(source, function(val, key) {
            this[key] = $deb7db37fce5cbb4$var$deepClone(val, instanceClone);
        }, out);
        return out;
    } else if (instanceClone) return instanceClone(source);
    else return source;
}
function $deb7db37fce5cbb4$var$cloneArray(arr, instanceClone) {
    var out = [], i = -1, n = arr.length, val;
    while(++i < n)out[i] = $deb7db37fce5cbb4$var$deepClone(arr[i], instanceClone);
    return out;
}
module.exports = $deb7db37fce5cbb4$var$deepClone;

});
parcelRegister("1oVlt", function(module, exports) {

var $d3Afl = parcelRequire("d3Afl");

var $45X4L = parcelRequire("45X4L");

var $1jlIP = parcelRequire("1jlIP");
/**
     * Clone native types.
     */ function $105483ed982187de$var$clone(val) {
    switch($d3Afl(val)){
        case "Object":
            return $105483ed982187de$var$cloneObject(val);
        case "Array":
            return $105483ed982187de$var$cloneArray(val);
        case "RegExp":
            return $105483ed982187de$var$cloneRegExp(val);
        case "Date":
            return $105483ed982187de$var$cloneDate(val);
        default:
            return val;
    }
}
function $105483ed982187de$var$cloneObject(source) {
    if ($45X4L(source)) return $1jlIP({}, source);
    else return source;
}
function $105483ed982187de$var$cloneRegExp(r) {
    var flags = "";
    flags += r.multiline ? "m" : "";
    flags += r.global ? "g" : "";
    flags += r.ignoreCase ? "i" : "";
    return new RegExp(r.source, flags);
}
function $105483ed982187de$var$cloneDate(date) {
    return new Date(+date);
}
function $105483ed982187de$var$cloneArray(arr) {
    return arr.slice();
}
module.exports = $105483ed982187de$var$clone;

});
parcelRegister("1jlIP", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");
/**
    * Combine properties from all the objects into first one.
    * - This method affects target object in place, if you want to create a new Object pass an empty object as first param.
    * @param {object} target    Target Object
    * @param {...object} objects    Objects to be combined (0...n objects).
    * @return {object} Target Object.
    */ function $0f486a50b668131f$var$mixIn(target, objects) {
    var i = 0, n = arguments.length, obj;
    while(++i < n){
        obj = arguments[i];
        if (obj != null) $ltrFL(obj, $0f486a50b668131f$var$copyProp, target);
    }
    return target;
}
function $0f486a50b668131f$var$copyProp(val, key) {
    this[key] = val;
}
module.exports = $0f486a50b668131f$var$mixIn;

});




parcelRegister("ldZPn", function(module, exports) {

var $kUoEO = parcelRequire("kUoEO");

var $3gwgt = parcelRequire("3gwgt");
/**
     * Returns minimum value inside object.
     */ function $f73ac592e84e7a95$var$min(obj, iterator) {
    return $kUoEO($3gwgt(obj), iterator);
}
module.exports = $f73ac592e84e7a95$var$min;

});
parcelRegister("kUoEO", function(module, exports) {

var $3cJKy = parcelRequire("3cJKy");
/**
     * Return minimum value inside array
     */ function $f38c2a0d0c81bee0$var$min(arr, iterator, thisObj) {
    if (arr == null || !arr.length) return -Infinity;
    else if (arr.length && !iterator) return Math.min.apply(Math, arr);
    else {
        iterator = $3cJKy(iterator, thisObj);
        var result, compare = Infinity, value, temp;
        var i = -1, len = arr.length;
        while(++i < len){
            value = arr[i];
            temp = iterator(value, i, arr);
            if (temp < compare) {
                compare = temp;
                result = value;
            }
        }
        return result;
    }
}
module.exports = $f38c2a0d0c81bee0$var$min;

});


parcelRegister("6Cptt", function(module, exports) {

var $1wEiX = parcelRequire("1wEiX");
/**
     * Create nested object if non-existent
     */ function $4d1a0d5ed1cf5fc0$var$namespace(obj, path) {
    if (!path) return obj;
    $1wEiX(path.split("."), function(key) {
        if (!obj[key]) obj[key] = {};
        obj = obj[key];
    });
    return obj;
}
module.exports = $4d1a0d5ed1cf5fc0$var$namespace;

});

parcelRegister("iVJSf", function(module, exports) {

var $fXExr = parcelRequire("fXExr");

var $ell3E = parcelRequire("ell3E");
/**
     * Return a copy of the object, filtered to only contain properties except the blacklisted keys.
     */ function $dc8122774785b5ae$var$omit(obj, var_keys) {
    var keys = typeof arguments[1] !== "string" ? arguments[1] : $fXExr(arguments, 1), out = {};
    for(var property in obj)if (obj.hasOwnProperty(property) && !$ell3E(keys, property)) out[property] = obj[property];
    return out;
}
module.exports = $dc8122774785b5ae$var$omit;

});
parcelRegister("ell3E", function(module, exports) {

var $mnUpd = parcelRequire("mnUpd");
/**
     * If array contains values.
     */ function $a7135c835ee675dd$var$contains(arr, val) {
    return $mnUpd(arr, val) !== -1;
}
module.exports = $a7135c835ee675dd$var$contains;

});
parcelRegister("mnUpd", function(module, exports) {
/**
     * Array.indexOf
     */ function $043499f8e818e2a2$var$indexOf(arr, item, fromIndex) {
    fromIndex = fromIndex || 0;
    if (arr == null) return -1;
    var len = arr.length, i = fromIndex < 0 ? len + fromIndex : fromIndex;
    while(i < len){
        // we iterate over sparse items since there is no way to make it
        // work properly on IE 7-8. see #64
        if (arr[i] === item) return i;
        i++;
    }
    return -1;
}
module.exports = $043499f8e818e2a2$var$indexOf;

});



parcelRegister("58eYY", function(module, exports) {

var $fXExr = parcelRequire("fXExr");
/**
     * Return a copy of the object, filtered to only have values for the whitelisted keys.
     */ function $3bc95250d0ffa02e$var$pick(obj, var_keys) {
    var keys = typeof arguments[1] !== "string" ? arguments[1] : $fXExr(arguments, 1), out = {}, i = 0, key;
    while(key = keys[i++])out[key] = obj[key];
    return out;
}
module.exports = $3bc95250d0ffa02e$var$pick;

});

parcelRegister("lNQmL", function(module, exports) {

var $9BrIp = parcelRequire("9BrIp");

var $6Fbnp = parcelRequire("6Fbnp");
/**
     * Extract a list of property values.
     */ function $fdf6cb64a83cbd58$var$pluck(obj, propName) {
    return $9BrIp(obj, $6Fbnp(propName));
}
module.exports = $fdf6cb64a83cbd58$var$pluck;

});

parcelRegister("husMK", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");

var $6PL2h = parcelRequire("6PL2h");
/**
     * Object reduce
     */ function $cbbb9129c0af7694$var$reduce(obj, callback, memo, thisObj) {
    var initial = arguments.length > 2;
    if (!$6PL2h(obj) && !initial) throw new Error("reduce of empty object with no initial value");
    $ltrFL(obj, function(value, key, list) {
        if (!initial) {
            memo = value;
            initial = true;
        } else memo = callback.call(thisObj, memo, value, key, list);
    });
    return memo;
}
module.exports = $cbbb9129c0af7694$var$reduce;

});
parcelRegister("6PL2h", function(module, exports) {

var $ltrFL = parcelRequire("ltrFL");
/**
     * Get object size
     */ function $4f9bfdd5252bd004$var$size(obj) {
    var count = 0;
    $ltrFL(obj, function() {
        count++;
    });
    return count;
}
module.exports = $4f9bfdd5252bd004$var$size;

});


parcelRegister("kT2js", function(module, exports) {

var $1BHzX = parcelRequire("1BHzX");

var $3cJKy = parcelRequire("3cJKy");
/**
     * Object reject
     */ function $f34abcfcde4de34d$var$reject(obj, callback, thisObj) {
    callback = $3cJKy(callback, thisObj);
    return $1BHzX(obj, function(value, index, obj) {
        return !callback(value, index, obj);
    }, thisObj);
}
module.exports = $f34abcfcde4de34d$var$reject;

});

parcelRegister("2OwJr", function(module, exports) {

var $ju2V9 = parcelRequire("ju2V9");
function $20c9a42897fe851b$var$result(obj, prop) {
    var property = obj[prop];
    if (property === undefined) return;
    return $ju2V9(property) ? property.call(obj) : property;
}
module.exports = $20c9a42897fe851b$var$result;

});
parcelRegister("ju2V9", function(module, exports) {

var $h13K8 = parcelRequire("h13K8");
/**
     */ function $e2f315aff6675dc5$var$isFunction(val) {
    return $h13K8(val, "Function");
}
module.exports = $e2f315aff6675dc5$var$isFunction;

});


parcelRegister("lT7jr", function(module, exports) {

var $6Cptt = parcelRequire("6Cptt");
/**
     * set "nested" object property
     */ function $fef46823a9e494df$var$set(obj, prop, val) {
    var stringifiedProp = prop.toString();
    // prototype pollution mitigation
    if (stringifiedProp.includes("__proto__") || stringifiedProp.includes("prototype") || stringifiedProp.includes("constructor")) return false;
    var parts = /^(.+)\.(.+)$/.exec(stringifiedProp);
    if (parts) $6Cptt(obj, parts[1])[parts[2]] = val;
    else obj[stringifiedProp] = val;
}
module.exports = $fef46823a9e494df$var$set;

});

parcelRegister("4UFt5", function(module, exports) {

var $b4Af5 = parcelRequire("b4Af5");
/**
     * Unset object property.
     */ function $393c8f154485efd2$var$unset(obj, prop) {
    if ($b4Af5(obj, prop)) {
        var parts = prop.split("."), last = parts.pop();
        while(prop = parts.shift())obj = obj[prop];
        return delete obj[last];
    } else // if property doesn't exist treat as deleted
    return true;
}
module.exports = $393c8f154485efd2$var$unset;

});




parcelRegister("f2CEG", function(module, exports) {

$parcel$export(module.exports, "translateSets", () => $af35070c5b439881$export$4a6db3c71ce7fb1a, (v) => $af35070c5b439881$export$4a6db3c71ce7fb1a = v);
$parcel$export(module.exports, "isAllTranslationsPresent", () => $af35070c5b439881$export$585adbb217a950b6, (v) => $af35070c5b439881$export$585adbb217a950b6 = v);
$parcel$export(module.exports, "getIsTranslationsAvailable", () => $af35070c5b439881$export$bc966f8528b2e703, (v) => $af35070c5b439881$export$bc966f8528b2e703 = v);
var $af35070c5b439881$export$1e511d4a378977f5;
var $af35070c5b439881$export$4a6db3c71ce7fb1a;
var $af35070c5b439881$export$585adbb217a950b6;
var $af35070c5b439881$export$bc966f8528b2e703;
"use strict";

var $1jnue = parcelRequire("1jnue");
$af35070c5b439881$export$1e511d4a378977f5 = true;
$af35070c5b439881$export$4a6db3c71ce7fb1a = $af35070c5b439881$export$585adbb217a950b6 = $af35070c5b439881$export$bc966f8528b2e703 = void 0;

var $auStQ = parcelRequire("auStQ");

var $af35070c5b439881$var$_bodegaKeys = $1jnue((parcelRequire("gjzC1")));

var $1BuK1 = parcelRequire("1BuK1");
/* eslint-disable import/prefer-default-export */ const $af35070c5b439881$var$translateSets = (set, translate)=>new Set([
        ...set
    ].map((element)=>translate($1BuK1.translationMappings[element]) || element));
/* Check if translation for all the keys present in bodegaKeys are available for a perticular locale */ $af35070c5b439881$export$4a6db3c71ce7fb1a = $af35070c5b439881$var$translateSets;
const $af35070c5b439881$var$isAllTranslationsPresent = (locale)=>!$af35070c5b439881$var$_bodegaKeys.default.map((key)=>(0, $auStQ.promotionTranslate)(key, locale)).some((val)=>!val);
$af35070c5b439881$export$585adbb217a950b6 = $af35070c5b439881$var$isAllTranslationsPresent;
const $af35070c5b439881$var$getIsTranslationsAvailable = ()=>localStorage.getItem("isTranslationsAvailable") === "true";
$af35070c5b439881$export$bc966f8528b2e703 = $af35070c5b439881$var$getIsTranslationsAvailable;

});
parcelRegister("gjzC1", function(module, exports) {
"use strict";
module.exports = JSON.parse('["RL_Active","RL_Add","RL_AddProduct","RL_Add1Product","RL_Add2Products","RL_AddMarkdown","RL_AddPromotion","RL_AdultUnisex","RL_All","RL_AllDivisions","RL_Apparel","RL_ApparelDivision","RL_Athlete","RL_AthleteRoles","RL_BackToPromotions","RL_Browser","RL_Clear","RL_Code","RL_Codes","RL_Confirm","RL_CrossDivision","RL_DefaultPromotion","RL_Delete","RL_Discount","RL_DiscountPercentage","RL_Divisions","RL_EditPromotion","RL_EndDate","RL_EndDateValidation1","RL_EndDateValidation2","RL_Ends","RL_Equipment","RL_EquipmentDivision","RL_Footwear","RL_For","RL_Gender","RL_Genders","RL_InTransit","RL_ItemDeleteFail","RL_Kids","RL_LogOut","RL_MarkdownAddSuccess","RL_Markdowns","RL_Men","RL_NewPrice","RL_NoAssociatedProducts","RL_Off","RL_OffCode","RL_OffCodes","RL_PausedPromotion","RL_PendingSync","RL_PriceValidation","RL_ProductDeleteConfirm1","RL_ProductDeleteConfirm2","RL_ProductDeleteConfirm3","RL_ProductDivision","RL_ProductNameOrStyleColor","RL_ProductType","RL_Products","RL_ProductsAddSuccess","RL_Profile","RL_PromotionDeleteSuccess1","RL_PromotionDeleteSuccess2","RL_PromotionID","RL_PromotionName","RL_PromotionNameValidation1","RL_PromotionNameValidation2","RL_PromotionUpdateSuccess","RL_PromotionalProductsWith","RL_Promotions","RL_Quantity","RL_RemoveConfirmation","RL_Roles","RL_STOCK_ON_HANDS","RL_SaveChanges","RL_ScanBarcode","RL_SearchMarkdowns","RL_SearchProductOrStyleColor","RL_Select","RL_SignIn","RL_StartDate","RL_StartScanning","RL_Starts","RL_StockOnHand","RL_StyleColor","RL_StyleColors","RL_Submit","RL_Today","RL_Units","RL_Version","RL_VisualMerchandising","RL_Women","RL_Yes","RL_ClearItemSuccess","RL_PromotionNameorStyleColor","RL_FootwearDivision","RL_Mens","RL_Womens","RL_SearchPromotions","RL_ProductDeleteConfirm4","RL_PromotionValidation1","RL_ProductScanSuccess","RL_ProductScanCancel1","RL_ProductScanCancel2","RL_ProductAddSuccess1","RL_CodesValidation","RL_GTINValidation","RL_StyleColorValidation","RL_MoreInformation","RL_ScannerError","RL_ProductAddSuccess3","RL_ProductAddSuccess4","RL_ProductAddError1","RL_ProductAddError2","RL_ProductAddError3","RL_ProductAddError4","RL_ProductAddError5","RL_ScanError1","RL_ScanError2"]');

});


parcelRegister("ikfii", function(module, exports) {

$parcel$export(module.exports, "Back", () => $d575f5555244dac5$export$25e48ac541203d4a, (v) => $d575f5555244dac5$export$25e48ac541203d4a = v);
$parcel$export(module.exports, "Button", () => $d575f5555244dac5$export$353f5b6fc5456de1, (v) => $d575f5555244dac5$export$353f5b6fc5456de1 = v);
$parcel$export(module.exports, "ButtonAdd", () => $d575f5555244dac5$export$1e3b939b417c2a9b, (v) => $d575f5555244dac5$export$1e3b939b417c2a9b = v);
$parcel$export(module.exports, "ButtonPopup", () => $d575f5555244dac5$export$703fd2ae2f469567, (v) => $d575f5555244dac5$export$703fd2ae2f469567 = v);
$parcel$export(module.exports, "ButtonSubmit", () => $d575f5555244dac5$export$883ac606d954afa4, (v) => $d575f5555244dac5$export$883ac606d954afa4 = v);
$parcel$export(module.exports, "ContentLoads", () => $d575f5555244dac5$export$4c318a677c7521c1, (v) => $d575f5555244dac5$export$4c318a677c7521c1 = v);
$parcel$export(module.exports, "Creatable", () => $d575f5555244dac5$export$786119aed6a780cf, (v) => $d575f5555244dac5$export$786119aed6a780cf = v);
$parcel$export(module.exports, "CurrencyInput", () => $d575f5555244dac5$export$498b61b4b30ac8a7, (v) => $d575f5555244dac5$export$498b61b4b30ac8a7 = v);
$parcel$export(module.exports, "CustomPanel", () => $d575f5555244dac5$export$327757885c45eb04, (v) => $d575f5555244dac5$export$327757885c45eb04 = v);
$parcel$export(module.exports, "DiscountPercentages", () => $d575f5555244dac5$export$bea78d755492fe99, (v) => $d575f5555244dac5$export$bea78d755492fe99 = v);
$parcel$export(module.exports, "Input", () => $d575f5555244dac5$export$f5b8910cec6cf069, (v) => $d575f5555244dac5$export$f5b8910cec6cf069 = v);
$parcel$export(module.exports, "InputDate", () => $d575f5555244dac5$export$7ac9d04ce3f22c96, (v) => $d575f5555244dac5$export$7ac9d04ce3f22c96 = v);
$parcel$export(module.exports, "Messages", () => $d575f5555244dac5$export$ceaacf8b390a3600, (v) => $d575f5555244dac5$export$ceaacf8b390a3600 = v);
$parcel$export(module.exports, "Popup", () => $d575f5555244dac5$export$129a32eedafa97c5, (v) => $d575f5555244dac5$export$129a32eedafa97c5 = v);
$parcel$export(module.exports, "ProductsDisplay", () => $d575f5555244dac5$export$4897920ed8dba629, (v) => $d575f5555244dac5$export$4897920ed8dba629 = v);
$parcel$export(module.exports, "Scanner", () => $d575f5555244dac5$export$2da42535f3a161df, (v) => $d575f5555244dac5$export$2da42535f3a161df = v);
$parcel$export(module.exports, "Select", () => $d575f5555244dac5$export$ef9b1a59e592288f, (v) => $d575f5555244dac5$export$ef9b1a59e592288f = v);
var $d575f5555244dac5$export$1e511d4a378977f5;
var $d575f5555244dac5$export$25e48ac541203d4a;
var $d575f5555244dac5$export$353f5b6fc5456de1;
var $d575f5555244dac5$export$1e3b939b417c2a9b;
var $d575f5555244dac5$export$703fd2ae2f469567;
var $d575f5555244dac5$export$883ac606d954afa4;
var $d575f5555244dac5$export$4c318a677c7521c1;
var $d575f5555244dac5$export$786119aed6a780cf;
var $d575f5555244dac5$export$498b61b4b30ac8a7;
var $d575f5555244dac5$export$327757885c45eb04;
var $d575f5555244dac5$export$bea78d755492fe99;
var $d575f5555244dac5$export$f5b8910cec6cf069;
var $d575f5555244dac5$export$7ac9d04ce3f22c96;
var $d575f5555244dac5$export$7c20be4c1d342248;
var $d575f5555244dac5$export$ceaacf8b390a3600;
var $d575f5555244dac5$export$129a32eedafa97c5;
var $d575f5555244dac5$export$4897920ed8dba629;
var $d575f5555244dac5$export$2da42535f3a161df;
var $d575f5555244dac5$export$ef9b1a59e592288f;
"use strict";

var $1jnue = parcelRequire("1jnue");
$d575f5555244dac5$export$1e511d4a378977f5 = true;

var $d575f5555244dac5$var$_Back = $1jnue((parcelRequire("8HX9Y")));
$d575f5555244dac5$export$25e48ac541203d4a = $d575f5555244dac5$var$_Back.default;

var $d575f5555244dac5$var$_Button = $1jnue((parcelRequire("wPEr3")));
$d575f5555244dac5$export$353f5b6fc5456de1 = $d575f5555244dac5$var$_Button.default;

var $d575f5555244dac5$var$_ButtonAdd = $1jnue((parcelRequire("iu8qZ")));
$d575f5555244dac5$export$1e3b939b417c2a9b = $d575f5555244dac5$var$_ButtonAdd.default;

var $d575f5555244dac5$var$_ButtonPopup = $1jnue((parcelRequire("elKPR")));
$d575f5555244dac5$export$703fd2ae2f469567 = $d575f5555244dac5$var$_ButtonPopup.default;

var $d575f5555244dac5$var$_ButtonSubmit = $1jnue((parcelRequire("9NEcE")));
$d575f5555244dac5$export$883ac606d954afa4 = $d575f5555244dac5$var$_ButtonSubmit.default;

var $d575f5555244dac5$var$_ContentLoads = $1jnue((parcelRequire("bploO")));
$d575f5555244dac5$export$4c318a677c7521c1 = $d575f5555244dac5$var$_ContentLoads.default;

var $d575f5555244dac5$var$_Creatable = $1jnue((parcelRequire("fwrhT")));
$d575f5555244dac5$export$786119aed6a780cf = $d575f5555244dac5$var$_Creatable.default;

var $d575f5555244dac5$var$_CurrencyInput = $1jnue((parcelRequire("ivILl")));
$d575f5555244dac5$export$498b61b4b30ac8a7 = $d575f5555244dac5$var$_CurrencyInput.default;

var $d575f5555244dac5$var$_CustomPanel = $1jnue((parcelRequire("j9pCl")));
$d575f5555244dac5$export$327757885c45eb04 = $d575f5555244dac5$var$_CustomPanel.default;

var $d575f5555244dac5$var$_DiscountPercentages = $1jnue((parcelRequire("dCVX9")));
$d575f5555244dac5$export$bea78d755492fe99 = $d575f5555244dac5$var$_DiscountPercentages.default;

var $d575f5555244dac5$var$_Input = $1jnue((parcelRequire("AJ2d4")));
$d575f5555244dac5$export$f5b8910cec6cf069 = $d575f5555244dac5$var$_Input.default;

var $d575f5555244dac5$var$_InputDate = $1jnue((parcelRequire("lmip3")));
$d575f5555244dac5$export$7ac9d04ce3f22c96 = $d575f5555244dac5$var$_InputDate.default;

var $d575f5555244dac5$var$_LoadingIndicator = $1jnue((parcelRequire("8hUZb")));
$d575f5555244dac5$export$7c20be4c1d342248 = $d575f5555244dac5$var$_LoadingIndicator.default;

var $d575f5555244dac5$var$_Messages = $1jnue((parcelRequire("eUNP9")));
$d575f5555244dac5$export$ceaacf8b390a3600 = $d575f5555244dac5$var$_Messages.default;

var $d575f5555244dac5$var$_Popup = $1jnue((parcelRequire("883Id")));
$d575f5555244dac5$export$129a32eedafa97c5 = $d575f5555244dac5$var$_Popup.default;

var $d575f5555244dac5$var$_ProductsDisplay = $1jnue((parcelRequire("jShCf")));
$d575f5555244dac5$export$4897920ed8dba629 = $d575f5555244dac5$var$_ProductsDisplay.default;

var $d575f5555244dac5$var$_Scanner = $1jnue((parcelRequire("bKeHw")));
$d575f5555244dac5$export$2da42535f3a161df = $d575f5555244dac5$var$_Scanner.default;

var $d575f5555244dac5$var$_Select = $1jnue((parcelRequire("9e5yx")));
$d575f5555244dac5$export$ef9b1a59e592288f = $d575f5555244dac5$var$_Select.default;

});
parcelRegister("8HX9Y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $65703accda22adb3$export$1e511d4a378977f5, (v) => $65703accda22adb3$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $65703accda22adb3$export$2e2bcd8739ae039, (v) => $65703accda22adb3$export$2e2bcd8739ae039 = v);
var $65703accda22adb3$export$1e511d4a378977f5;
var $65703accda22adb3$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$65703accda22adb3$export$1e511d4a378977f5 = true;
$65703accda22adb3$export$2e2bcd8739ae039 = void 0;

var $gslx4 = parcelRequire("gslx4");

var $65703accda22adb3$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $65703accda22adb3$var$_react = $1jnue((parcelRequire("acw62")));

var $4fGPb = parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");
const $65703accda22adb3$var$Back = ({ label: label, link: link })=>/*#__PURE__*/ $65703accda22adb3$var$_react.default.createElement("article", {
        className: "ta-sm-l ncss-row"
    }, /*#__PURE__*/ $65703accda22adb3$var$_react.default.createElement($4fGPb.Link, {
        className: "ncss-cta-primary-dark",
        to: link,
        onClick: ()=>/*#__PURE__*/ $65703accda22adb3$var$_react.default.createElement($kfZjc.Redirect, {
                to: link
            })
    }, /*#__PURE__*/ $65703accda22adb3$var$_react.default.createElement($gslx4.CaretLeft, {
        "aria-hidden": true
    }), /*#__PURE__*/ $65703accda22adb3$var$_react.default.createElement("span", {
        className: "flx-as-sm-c"
    }, label)));
$65703accda22adb3$var$Back.propTypes = {
    label: $65703accda22adb3$var$_propTypes.default.string.isRequired,
    link: $65703accda22adb3$var$_propTypes.default.string.isRequired
};
var $65703accda22adb3$var$_default = $65703accda22adb3$export$2e2bcd8739ae039 = $65703accda22adb3$var$Back;

});
parcelRegister("gslx4", function(module, exports) {

$parcel$export(module.exports, "CaretLeft", () => $bfaff6c565d44ca6$export$9de62fa342934f27);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $bfaff6c565d44ca6$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bfaff6c565d44ca6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bfaff6c565d44ca6$var$_typeof(o);
}
function $bfaff6c565d44ca6$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bfaff6c565d44ca6$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bfaff6c565d44ca6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $bfaff6c565d44ca6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bfaff6c565d44ca6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $bfaff6c565d44ca6$var$_defineProperty(obj, key, value) {
    key = $bfaff6c565d44ca6$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bfaff6c565d44ca6$var$_toPropertyKey(t) {
    var i = $bfaff6c565d44ca6$var$_toPrimitive(t, "string");
    return "symbol" == $bfaff6c565d44ca6$var$_typeof(i) ? i : String(i);
}
function $bfaff6c565d44ca6$var$_toPrimitive(t, r) {
    if ("object" != $bfaff6c565d44ca6$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $bfaff6c565d44ca6$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $bfaff6c565d44ca6$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M14.75 17.5L9.25 12l5.5-5.5"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M15.525 18.966L8.558 12l6.967-6.967"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M31.05 37.932L17.118 24 31.05 10.066"
    }))
};
var $bfaff6c565d44ca6$export$9de62fa342934f27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $bfaff6c565d44ca6$var$_objectSpread($bfaff6c565d44ca6$var$_objectSpread({}, props), {}, {
        paths: $bfaff6c565d44ca6$var$compPaths,
        fill: "none"
    }));
});

});
parcelRegister("kc63j", function(module, exports) {

$parcel$export(module.exports, "SvgIcon", () => $eb399f806e6fd46f$export$dbcb8210e8a983ed);

var $acw62 = parcelRequire("acw62");

function $eb399f806e6fd46f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $eb399f806e6fd46f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eb399f806e6fd46f$var$_typeof(o);
}
var $eb399f806e6fd46f$var$_excluded = [
    "aria-hidden",
    "className",
    "fill",
    "height",
    "paths",
    "role",
    "title",
    "size",
    "viewBox",
    "width"
];
function $eb399f806e6fd46f$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eb399f806e6fd46f$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eb399f806e6fd46f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $eb399f806e6fd46f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eb399f806e6fd46f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $eb399f806e6fd46f$var$_defineProperty(obj, key, value) {
    key = $eb399f806e6fd46f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $eb399f806e6fd46f$var$_toPropertyKey(t) {
    var i = $eb399f806e6fd46f$var$_toPrimitive(t, "string");
    return "symbol" == $eb399f806e6fd46f$var$_typeof(i) ? i : String(i);
}
function $eb399f806e6fd46f$var$_toPrimitive(t, r) {
    if ("object" != $eb399f806e6fd46f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $eb399f806e6fd46f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $eb399f806e6fd46f$var$_slicedToArray(arr, i) {
    return $eb399f806e6fd46f$var$_arrayWithHoles(arr) || $eb399f806e6fd46f$var$_iterableToArrayLimit(arr, i) || $eb399f806e6fd46f$var$_unsupportedIterableToArray(arr, i) || $eb399f806e6fd46f$var$_nonIterableRest();
}
function $eb399f806e6fd46f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $eb399f806e6fd46f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $eb399f806e6fd46f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $eb399f806e6fd46f$var$_arrayLikeToArray(o, minLen);
}
function $eb399f806e6fd46f$var$_arrayLikeToArray(arr, len) {
    var i, arr2;
    if (len == null || len > arr.length) len = arr.length;
    for(i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $eb399f806e6fd46f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"], e, n, i, u, a, f, o;
    if (null != t) {
        a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $eb399f806e6fd46f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $eb399f806e6fd46f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $eb399f806e6fd46f$var$_objectWithoutPropertiesLoose(source, excluded), sourceSymbolKeys;
    var key, i;
    if (Object.getOwnPropertySymbols) {
        sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $eb399f806e6fd46f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $eb399f806e6fd46f$var$sizeIconM = "24px";
var $eb399f806e6fd46f$var$sizeIconL = "48px";
var $eb399f806e6fd46f$var$viewBoxes = {
    s: "0 0 ".concat(parseInt($eb399f806e6fd46f$var$sizeIconM), " ").concat(parseInt($eb399f806e6fd46f$var$sizeIconM)),
    m: "0 0 ".concat(parseInt($eb399f806e6fd46f$var$sizeIconM), " ").concat(parseInt($eb399f806e6fd46f$var$sizeIconM)),
    l: "0 0 ".concat(parseInt($eb399f806e6fd46f$var$sizeIconL), " ").concat(parseInt($eb399f806e6fd46f$var$sizeIconL))
};
var $eb399f806e6fd46f$var$sizes = {
    s: $eb399f806e6fd46f$var$sizeIconM,
    m: $eb399f806e6fd46f$var$sizeIconM,
    l: $eb399f806e6fd46f$var$sizeIconL,
    container: "container"
};
var $eb399f806e6fd46f$export$dbcb8210e8a983ed = function(_ref) {
    var ariaHidden = _ref["aria-hidden"], className = _ref.className, fill = _ref.fill, height = _ref.height, paths = _ref.paths, _ref$role = _ref.role, role = _ref$role === void 0 ? "img" : _ref$role, title = _ref.title, _ref$size = _ref.size, size = _ref$size === void 0 ? "m" : _ref$size, viewBox = _ref.viewBox, width = _ref.width, rest = $eb399f806e6fd46f$var$_objectWithoutProperties(_ref, $eb399f806e6fd46f$var$_excluded);
    var _useState = (0, $acw62.useState)(size), _useState2 = $eb399f806e6fd46f$var$_slicedToArray(_useState, 2), sizeState = _useState2[0], setSizeState = _useState2[1];
    var ariaHiddenValue = ariaHidden;
    if (function isInaccessible(ariaHiddenValue) {
        return !ariaHiddenValue && !title;
    }(ariaHidden)) ariaHiddenValue = true;
    (0, $acw62.useEffect)(function() {
        if (!Object.keys($eb399f806e6fd46f$var$sizes).includes(size)) setSizeState("m");
        else setSizeState(size);
    }, [
        size
    ]);
    var vb = viewBox ? viewBox : $eb399f806e6fd46f$var$viewBoxes[size] || $eb399f806e6fd46f$var$viewBoxes.m;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", $eb399f806e6fd46f$var$_objectSpread({
        "aria-hidden": ariaHiddenValue ? "true" : "false",
        className: className,
        focusable: "false",
        viewBox: vb,
        role: role,
        width: function getSvgWidth() {
            if (sizeState === "container") return;
            return width ? width : $eb399f806e6fd46f$var$sizes[sizeState];
        }(),
        height: function getSvgHeight() {
            if (sizeState === "container") return;
            return height ? height : $eb399f806e6fd46f$var$sizes[sizeState];
        }(),
        fill: fill
    }, rest), (paths === null || paths === void 0 ? void 0 : paths[sizeState]) ? paths[sizeState] : paths === null || paths === void 0 ? void 0 : paths["m"], title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title));
};

});



parcelRegister("wPEr3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $062b0e1f5013c9d2$export$1e511d4a378977f5, (v) => $062b0e1f5013c9d2$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $062b0e1f5013c9d2$export$2e2bcd8739ae039, (v) => $062b0e1f5013c9d2$export$2e2bcd8739ae039 = v);
var $062b0e1f5013c9d2$export$1e511d4a378977f5;
var $062b0e1f5013c9d2$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$062b0e1f5013c9d2$export$1e511d4a378977f5 = true;
$062b0e1f5013c9d2$export$2e2bcd8739ae039 = void 0;

var $fr6za = parcelRequire("fr6za");

var $062b0e1f5013c9d2$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $062b0e1f5013c9d2$var$_react = $1jnue((parcelRequire("acw62")));
const $062b0e1f5013c9d2$var$Button = ({ appearance: appearance, ariaLabel: ariaLabel, buttonClassName: buttonClassName, icon: icon, isDisabled: isDisabled, label: label, onClick: onClick, sectionClassName: sectionClassName, size: size })=>/*#__PURE__*/ $062b0e1f5013c9d2$var$_react.default.createElement("section", {
        className: sectionClassName
    }, /*#__PURE__*/ $062b0e1f5013c9d2$var$_react.default.createElement($fr6za.ButtonStyled, {
        appearance: appearance,
        ariaLabel: ariaLabel,
        className: buttonClassName,
        disabled: isDisabled,
        size: size,
        type: "button",
        onClick: onClick
    }, icon || label));
$062b0e1f5013c9d2$var$Button.defaultProps = {
    appearance: "secondary",
    ariaLabel: "Button",
    buttonClassName: "mb2-sm",
    icon: null,
    isDisabled: false,
    label: "Button",
    sectionClassName: "",
    size: "small"
};
$062b0e1f5013c9d2$var$Button.propTypes = {
    appearance: $062b0e1f5013c9d2$var$_propTypes.default.string,
    ariaLabel: $062b0e1f5013c9d2$var$_propTypes.default.string,
    buttonClassName: $062b0e1f5013c9d2$var$_propTypes.default.string,
    icon: $062b0e1f5013c9d2$var$_propTypes.default.shape(),
    isDisabled: $062b0e1f5013c9d2$var$_propTypes.default.bool,
    label: $062b0e1f5013c9d2$var$_propTypes.default.string,
    onClick: $062b0e1f5013c9d2$var$_propTypes.default.func.isRequired,
    sectionClassName: $062b0e1f5013c9d2$var$_propTypes.default.string,
    size: $062b0e1f5013c9d2$var$_propTypes.default.string
};
var $062b0e1f5013c9d2$var$_default = $062b0e1f5013c9d2$export$2e2bcd8739ae039 = $062b0e1f5013c9d2$var$Button;

});
parcelRegister("fr6za", function(module, exports) {

$parcel$export(module.exports, "ButtonStyled", () => $b3ce788740b5a5b5$export$f1c4195fa4a48d90);

var $1poQt = parcelRequire("1poQt");

var $8oaD5 = parcelRequire("8oaD5");

var $alnzM = parcelRequire("alnzM");
var $b3ce788740b5a5b5$export$f1c4195fa4a48d90 = (0, $1poQt.default)((0, $8oaD5.Button), {
    target: "ex41m6f0"
})((0, $alnzM.buttonStyles));

});
parcelRegister("1poQt", function(module, exports) {

$parcel$export(module.exports, "default", () => $106b65ffba5ad10b$export$2e2bcd8739ae039);

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $7dGEo = parcelRequire("7dGEo");

var $f5Egd = parcelRequire("f5Egd");

var $boAuA = parcelRequire("boAuA");

var $cXgB3 = parcelRequire("cXgB3");
var $106b65ffba5ad10b$var$testOmitPropsOnStringTag = (0, $7dGEo.default);
var $106b65ffba5ad10b$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme" && key !== "innerRef";
};
var $106b65ffba5ad10b$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $106b65ffba5ad10b$var$testOmitPropsOnStringTag : $106b65ffba5ad10b$var$testOmitPropsOnComponent;
};
function $106b65ffba5ad10b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $106b65ffba5ad10b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $106b65ffba5ad10b$var$ownKeys(source, true).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $106b65ffba5ad10b$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $106b65ffba5ad10b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $106b65ffba5ad10b$var$createStyled = function createStyled(tag, options) {
    if (tag === undefined) throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
    var identifierName;
    var shouldForwardProp;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
        shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && // $FlowFixMe
            options.shouldForwardProp(propName);
        } : options.shouldForwardProp;
    }
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    var defaultShouldForwardProp = shouldForwardProp || $106b65ffba5ad10b$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            if (args[0][0] === undefined) console.error($106b65ffba5ad10b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR);
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++){
                if (args[0][i] === undefined) console.error($106b65ffba5ad10b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR);
                styles.push(args[i], args[0][i]);
            }
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $f5Egd.withEmotionCache)(function(props, context, ref) {
            return (0, $acw62.createElement)((0, $f5Egd.ThemeContext).Consumer, null, function(theme) {
                var finalTag = shouldUseAs && props.as || baseTag;
                var className = "";
                var classInterpolations = [];
                var mergedProps = props;
                if (props.theme == null) {
                    mergedProps = {};
                    for(var key in props)mergedProps[key] = props[key];
                    mergedProps.theme = theme;
                }
                if (typeof props.className === "string") className = (0, $boAuA.getRegisteredStyles)(context.registered, classInterpolations, props.className);
                else if (props.className != null) className = props.className + " ";
                var serialized = (0, $cXgB3.serializeStyles)(styles.concat(classInterpolations), context.registered, mergedProps);
                var rules = (0, $boAuA.insertStyles)(context, serialized, typeof finalTag === "string");
                className += context.key + "-" + serialized.name;
                if (targetClassName !== undefined) className += " " + targetClassName;
                var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $106b65ffba5ad10b$var$getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
                var newProps = {};
                for(var _key in props){
                    if (shouldUseAs && _key === "as") continue;
                    if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
                }
                newProps.className = className;
                newProps.ref = ref || props.innerRef;
                if (0, props.innerRef) console.error("`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead" + (identifierName === undefined ? "" : " in the usage of `" + identifierName + "`"));
                var ele = (0, $acw62.createElement)(finalTag, newProps);
                return ele;
            });
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                if (targetClassName === undefined && true) return "NO_COMPONENT_SELECTOR";
                 // $FlowFixMe: coerce undefined to string
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, nextOptions !== undefined ? $106b65ffba5ad10b$var$_objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
        };
        return Styled;
    };
};
var $106b65ffba5ad10b$export$2e2bcd8739ae039 = $106b65ffba5ad10b$var$createStyled;

});
parcelRegister("7dGEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $541ad4d15ffa42f6$export$2e2bcd8739ae039);

var $l7O8P = parcelRequire("l7O8P");
var $541ad4d15ffa42f6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $541ad4d15ffa42f6$var$index = (0, $l7O8P.default)(function(prop) {
    return $541ad4d15ffa42f6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $541ad4d15ffa42f6$export$2e2bcd8739ae039 = $541ad4d15ffa42f6$var$index;

});


parcelRegister("8oaD5", function(module, exports) {

$parcel$export(module.exports, "Button", () => $61b8cf6678bfda53$export$353f5b6fc5456de1);

var $1SA7b = parcelRequire("1SA7b");

var $acw62 = parcelRequire("acw62");
function $61b8cf6678bfda53$var$e(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
var $61b8cf6678bfda53$var$t = undefined && undefined.__rest || function(e, t) {
    var n, r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)t.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
};
var $61b8cf6678bfda53$export$353f5b6fc5456de1 = function(a) {
    var o, i, l = a.appearance, c = void 0 === l ? "primary" : l, s = a.ariaLabel, p = a.background, d = void 0 === p ? "light" : p, u = a.children, b = a.className, m = a.classes, v = void 0 === m ? {
        Button: "btn",
        Text: "cta",
        IconWrapper: "btn-icon-wrapper",
        ButtonLarge: "btn-lg",
        ButtonMedium: "btn-md",
        ButtonSmall: "",
        ButtonResponsive: "btn-responsive",
        TextUnderline: "underline"
    } : m, f = a.disabled, y = a.href, g = a.onClick, x = a.size, B = void 0 === x ? "responsive" : x, h = a.Component, O = void 0 === h ? "button" : h, k = a.Icon, I = a.IconWrapper, j = void 0 === I ? "span" : I, w = a.type, C = void 0 === w ? "submit" : w, N = a.disableRipple, U = void 0 !== N && N, E = $61b8cf6678bfda53$var$t(a, [
        "appearance",
        "ariaLabel",
        "background",
        "children",
        "className",
        "classes",
        "disabled",
        "href",
        "onClick",
        "size",
        "Component",
        "Icon",
        "IconWrapper",
        "type",
        "disableRipple"
    ]), L = function(e) {
        return "text" === e || "textUnderline" === e ? "primary" : e;
    }(c), P = function(e, t, n) {
        return "text" === e || "textUnderline" === e ? n : t;
    }(c, v.Button, v.Text), R = "textUnderline" === c ? v.TextUnderline : "";
    if (v.Button) {
        var S = "dark" === d ? "light" : "dark";
        i = "".concat(P, "-").concat(L, "-").concat(S, " ").concat(R);
    } else i = c;
    var T = function(e, t, n, r, a) {
        return "small" === e ? t : "medium" === e ? n : "large" === e ? r : a;
    }(B, v.ButtonSmall, v.ButtonMedium, v.ButtonLarge, v.ButtonResponsive);
    i = (0, $1SA7b.default)(b, i, ($61b8cf6678bfda53$var$e(o = {}, T, !!T), $61b8cf6678bfda53$var$e(o, "disabled", "a" === O ? void 0 : f), o));
    var W = k && ("primary" === c || "secondary" === c) && $acw62.createElement(j, {
        className: v.IconWrapper
    }, k);
    return $acw62.createElement(O, Object.assign({
        disabled: "a" === O ? void 0 : f,
        "aria-label": s,
        className: i,
        onClick: g,
        href: "a" === O ? y : void 0,
        type: "a" !== O ? C : void 0
    }, E), u, W, !(U || f) && $acw62.createElement("span", {
        className: "ripple"
    }));
};

});
parcelRegister("1SA7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $15e6d94060e5d8b6$export$2e2bcd8739ae039);
function $15e6d94060e5d8b6$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $15e6d94060e5d8b6$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $15e6d94060e5d8b6$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $15e6d94060e5d8b6$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $15e6d94060e5d8b6$export$2e2bcd8739ae039 = $15e6d94060e5d8b6$export$4f5d2d50c9deca37;

});


parcelRegister("alnzM", function(module, exports) {

$parcel$export(module.exports, "buttonStyles", () => $787e2745d6c76ce0$export$19a3970fbcd4ca20);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");
var $787e2745d6c76ce0$export$19a3970fbcd4ca20 = function(t) {
    var n = t.theme, r = t.Component, e = t.size, a = t.appearance, i = void 0 === a ? "primary" : a, d = t.classes, c = t.background, l = void 0 === c ? "light" : c, s = t.disableRipple, b = n.breakpointS, u = n.buttonBorderRadius, h = n.buttonBorderWidth, g = n.buttonBoxShadowWidth, p = n.buttonBoxShadowHoverWidth, v = n.buttonColorHover, m = n.buttonColorHoverInverse, B = n.buttonPaddingBottomS, f = n.buttonPaddingSidesS, y = n.buttonPaddingSidesM, C = n.buttonPaddingSidesL, k = n.buttonPaddingUnderline, x = n.buttonHeightL, w = n.buttonHeightM, S = n.buttonHeightS, A = n.buttonPaddingTopS, z = n.buttonPaddingTopM, F = n.buttonPaddingTopL, P = n.colorBackgroundAlwaysDark, H = n.colorBackgroundAlwaysLight, I = n.colorBorderActive, W = n.colorBorderBase, L = n.colorContentDisabled, M = n.colorContentPrimary, U = n.colorContentPrimaryInverse, T = n.colorContentSecondary, D = n.fontSizeXxs, G = n.paletteGrey1, R = n.paletteWhite, j = n.paletteGrey3, X = n.sizeIconM, q = n.sizeSpacingS, E = n.typographyCta1, J = n.typographyCta2, K = "light" === l, N = {
        light: {
            primary: {
                backgroundStyle: P,
                color: U,
                borderColor: "transparent",
                hoverFocusActiveBackground: T,
                hoverFocusActiveBorderColor: "transparent",
                disabledBackground: j,
                disabledColor: T,
                disabledBorderColor: "transparent"
            },
            secondary: {
                backgroundStyle: "transparent",
                color: M,
                borderColor: W,
                hoverFocusActiveBackground: "transparent",
                hoverFocusActiveBorderColor: I,
                disabledBackground: "transparent",
                disabledColor: L,
                disabledBorderColor: L
            }
        },
        dark: {
            primary: {
                backgroundStyle: H,
                color: M,
                borderColor: "transparent",
                hoverFocusActiveBackground: m,
                hoverFocusActiveBorderColor: "transparent",
                disabledBackground: "#8B8B8B",
                disabledColor: "#3A3A3A",
                disabledBorderColor: "transparent"
            },
            secondary: {
                backgroundStyle: "transparent",
                color: U,
                borderColor: T,
                hoverFocusActiveBackground: "",
                hoverFocusActiveBorderColor: R,
                disabledBackground: "transparent",
                disabledColor: G,
                disabledBorderColor: G
            }
        }
    };
    return (0, $6xSYO.default)(E, ";text-align:center;text-decoration:none;box-sizing:border-box;display:", "a" === r ? "inline-flex" : "flex", ";justify-content:center;align-items:center;cursor:pointer;", function() {
        if ("primary" === i || "secondary" === i) {
            var t, n = "\n          padding: ".concat(F, " ").concat(C, ";\n          width: 100%;\n          min-height: ").concat(x, ";\n        "), r = "\n        padding: ".concat(A, " ").concat(f, " ").concat(B, ";\n        min-height: ").concat(S, ";\n      "), a = "\n          padding: ".concat(z, " ").concat(y, ";\n          min-height: ").concat(w, ";\n      ");
            return t = "large" === e ? n : "medium" === e ? a : "small" === e ? r : "\n          ".concat(n, "\n          @media (min-width: ").concat(b, ") {\n            ").concat(r, "\n            width: auto;\n            height: auto;\n            min-height: auto;\n          }\n        "), (0, $6xSYO.default)(t);
        }
    }(), " ", (0, $6xSYO.default)("", " .", null == d ? void 0 : d.IconWrapper, "{width:", X, ";height:", X, ";margin-left:", q, ";}"), " ", function() {
        if ("text" === i || "textUnderline" === i) return (0, $6xSYO.default)("padding:0;color:", K ? M : U, ";background:transparent;border:0;", "small" === e && "font-size: ".concat(D, ";\n           line-height: 18px;\n          "), " ", "medium" === e && "font-size: ".concat(J.fontSize, ";\n            line-height: ").concat(J.lineHeight, ";\n          "), " ", "responsive" === e && "@media (min-width: ".concat(parseInt(b.replace("px", "")) + 1, "px) {\n            font-size: ").concat(D, ";\n            line-height: 18px};\n        }"), " &:hover:not(:disabled),&:focus:not(:disabled),&:active:not(:disabled){outline:none;color:", K ? v : m, ";}&:disabled{color:", K ? L : "#8B8B8B", ";cursor:default;}");
    }(), " ", function() {
        var t = 0 !== parseInt(g), n = 0 !== parseInt(h);
        if ("textUnderline" === i) return (0, $6xSYO.default)("border-bottom:", h, " solid ", K ? M : U, ";box-shadow:inset 0 ", g, " 0 0 ", K ? M : U, ";padding-bottom:", k, ";&:hover:not(:disabled),&:active:not(:disabled){box-shadow:inset 0 ", p, " 0 0 ", K ? M : U, ";border-bottom:", h, " solid ", K ? v : m, ";}}&:disabled{", n && "border-bottom: ".concat(h, " solid\n          ").concat(K ? L : "#8B8B8B", ";"), " ", t && "box-shadow: inset 0 ".concat(g, " 0 0 ").concat(K ? L : "#8B8B8B", ";"), "}");
    }(), " ", s || "text" === i || "textUnderline" === i ? null : (0, $6xSYO.default)("position:relative;overflow:hidden;transform:translate3d(0,0,0);> .ripple{display:block;position:absolute;", "small" === e && "width: ".concat(S, ";\n           height: ").concat(S, ";\n          "), " ", "medium" === e && "width: ".concat(w, ";\n         height: ").concat(w, ";\n        "), " ", "large" === e && "width: ".concat(x, ";\n         height: ").concat(x, ";\n        "), " ", "responsive" === e && "@media (min-width: ".concat(b, ") {\n          width: ").concat(S, ";\n          height: ").concat(S, ";\n        }\n        width: ").concat(x, ";\n        height: ").concat(x, ";\n        "), " border-radius:", u, ";top:50%;left:50%;background-color:rgba(255,255,255,0.7);background-size:100%;transform:translate3d(-50%,-50%,0) scale(10);transform-origin:center center;opacity:0;transition:transform 0.8s,opacity 1s;margin:0;}&:active > .ripple{transform:translate3d(-50%,-50%,0) scale(0);opacity:0.5;transition:0s;}"), " ", function() {
        var t, n, r, e, a, d, c, s, b;
        if ("primary" === i || "secondary" === i) return n = (t = N[null != l ? l : "light"][i]).backgroundStyle, r = t.color, e = t.borderColor, a = t.hoverFocusActiveBackground, d = t.hoverFocusActiveBorderColor, c = t.disabledBackground, s = t.disabledColor, b = t.disabledBorderColor, (0, $6xSYO.default)("background:", n, ";color:", r, ";border-radius:", u, ";border:", h, " solid;border-color:", e, ";&:hover:not(:disabled),&:active:not(:disabled){outline:none;background:", a, ";border-color:", d, ";}&:focus:not(:disabled){outline:0;}&:focus-visible{box-shadow:0 0 0 2px rgba(39,93,197,1);}&.focus-visible{box-shadow:0 0 0 2px rgba(39,93,197,1);}&:disabled{background:", c, ";color:", s, ";border-color:", b, ";cursor:default;}");
    }());
};

});



parcelRegister("iu8qZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $d7519236b4da5991$export$1e511d4a378977f5, (v) => $d7519236b4da5991$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d7519236b4da5991$export$2e2bcd8739ae039, (v) => $d7519236b4da5991$export$2e2bcd8739ae039 = v);
var $d7519236b4da5991$export$1e511d4a378977f5;
var $d7519236b4da5991$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$d7519236b4da5991$export$1e511d4a378977f5 = true;
$d7519236b4da5991$export$2e2bcd8739ae039 = void 0;

var $fr6za = parcelRequire("fr6za");

var $142Bi = parcelRequire("142Bi");
var $EvkAW = parcelRequire("EvkAW");

var $d7519236b4da5991$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $d7519236b4da5991$var$_react = $1jnue((parcelRequire("acw62")));

var $d7519236b4da5991$var$_useTranslate = $1jnue((parcelRequire("90irH")));
const $d7519236b4da5991$var$ButtonAdd = ({ isAdding: isAdding, isDisabled: isDisabled, onToggle: onToggle })=>{
    const translate = (0, $d7519236b4da5991$var$_useTranslate.default)();
    return /*#__PURE__*/ $d7519236b4da5991$var$_react.default.createElement("nav", {
        className: "d-sm-flx flx-jc-sm-fe"
    }, /*#__PURE__*/ $d7519236b4da5991$var$_react.default.createElement($fr6za.ButtonStyled, {
        appearance: "secondary",
        ariaLabel: isAdding ? "Cancel" : "Add",
        className: "mb2-sm",
        disabled: isDisabled,
        size: "small",
        type: "button",
        onClick: onToggle
    }, isAdding ? /*#__PURE__*/ $d7519236b4da5991$var$_react.default.createElement($142Bi.Close, {
        style: {
            margin: "0.32rem -1rem"
        },
        title: translate("RL_Cancel")
    }) : /*#__PURE__*/ $d7519236b4da5991$var$_react.default.createElement($EvkAW.Plus, {
        size: "l",
        style: {
            margin: "-0.47rem -1.5rem"
        },
        title: translate("RL_Add1Product")
    })));
};
$d7519236b4da5991$var$ButtonAdd.defaultProps = {
    isAdding: false,
    isDisabled: false
};
$d7519236b4da5991$var$ButtonAdd.propTypes = {
    isAdding: $d7519236b4da5991$var$_propTypes.default.bool,
    isDisabled: $d7519236b4da5991$var$_propTypes.default.bool,
    onToggle: $d7519236b4da5991$var$_propTypes.default.func.isRequired
};
var $d7519236b4da5991$var$_default = $d7519236b4da5991$export$2e2bcd8739ae039 = $d7519236b4da5991$var$ButtonAdd;

});
parcelRegister("142Bi", function(module, exports) {

$parcel$export(module.exports, "Close", () => $0c682e9604d97a57$export$f39c2d165cd861fe);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $0c682e9604d97a57$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0c682e9604d97a57$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0c682e9604d97a57$var$_typeof(o);
}
function $0c682e9604d97a57$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c682e9604d97a57$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c682e9604d97a57$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0c682e9604d97a57$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c682e9604d97a57$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c682e9604d97a57$var$_defineProperty(obj, key, value) {
    key = $0c682e9604d97a57$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0c682e9604d97a57$var$_toPropertyKey(t) {
    var i = $0c682e9604d97a57$var$_toPrimitive(t, "string");
    return "symbol" == $0c682e9604d97a57$var$_typeof(i) ? i : String(i);
}
function $0c682e9604d97a57$var$_toPrimitive(t, r) {
    if ("object" != $0c682e9604d97a57$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $0c682e9604d97a57$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0c682e9604d97a57$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M17.5 6.5l-11 11m0-11l11 11"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M18.973 5.027L5.028 18.972m0-13.945l13.944 13.945"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M37.945 10.055l-27.89 27.89m0-27.89l27.89 27.89"
    }))
};
var $0c682e9604d97a57$export$f39c2d165cd861fe = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $0c682e9604d97a57$var$_objectSpread($0c682e9604d97a57$var$_objectSpread({}, props), {}, {
        paths: $0c682e9604d97a57$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("EvkAW", function(module, exports) {

$parcel$export(module.exports, "Plus", () => $079c0a429744d66d$export$2d9ac7aa84f97a08);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $079c0a429744d66d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $079c0a429744d66d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $079c0a429744d66d$var$_typeof(o);
}
function $079c0a429744d66d$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $079c0a429744d66d$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $079c0a429744d66d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $079c0a429744d66d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $079c0a429744d66d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $079c0a429744d66d$var$_defineProperty(obj, key, value) {
    key = $079c0a429744d66d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $079c0a429744d66d$var$_toPropertyKey(t) {
    var i = $079c0a429744d66d$var$_toPrimitive(t, "string");
    return "symbol" == $079c0a429744d66d$var$_typeof(i) ? i : String(i);
}
function $079c0a429744d66d$var$_toPrimitive(t, r) {
    if ("object" != $079c0a429744d66d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $079c0a429744d66d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $079c0a429744d66d$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M18 12H6m6 6V6"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M19.5 12h-15m7.5 7.5v-15"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M39 24H9m15 15V9"
    }))
};
var $079c0a429744d66d$export$2d9ac7aa84f97a08 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $079c0a429744d66d$var$_objectSpread($079c0a429744d66d$var$_objectSpread({}, props), {}, {
        paths: $079c0a429744d66d$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("90irH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $68e26c166e883674$export$1e511d4a378977f5, (v) => $68e26c166e883674$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $68e26c166e883674$export$2e2bcd8739ae039, (v) => $68e26c166e883674$export$2e2bcd8739ae039 = v);
var $68e26c166e883674$export$1e511d4a378977f5;
var $68e26c166e883674$export$2e2bcd8739ae039;
"use strict";
$68e26c166e883674$export$1e511d4a378977f5 = true;
$68e26c166e883674$export$2e2bcd8739ae039 = $68e26c166e883674$var$useTranslate;

var $auStQ = parcelRequire("auStQ");

var $acw62 = parcelRequire("acw62");
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $7Yi7V = parcelRequire("7Yi7V");

var $bEk1s = parcelRequire("bEk1s");

var $f2CEG = parcelRequire("f2CEG");
function $68e26c166e883674$var$useTranslate() {
    const locale = (0, $iD0SF.useSelector)($bEk1s.getLocale);
    const localeToggle = (0, $iD0SF.useSelector)($bEk1s.getLocaleToggleStatus);
    const isTranslationsAvailable = (0, $f2CEG.getIsTranslationsAvailable)();
    return (0, $acw62.useCallback)((id, ...args)=>isTranslationsAvailable ? (0, $auStQ.promotionTranslate)(id, localeToggle ? $7Yi7V.DEFAULT_LOCALE : locale, ...args) : (0, $auStQ.promotionTranslate)(id, $7Yi7V.DEFAULT_LOCALE, ...args), [
        isTranslationsAvailable,
        locale,
        localeToggle
    ]);
}

});


parcelRegister("elKPR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $a7275b6adf9370c1$export$1e511d4a378977f5, (v) => $a7275b6adf9370c1$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $a7275b6adf9370c1$export$2e2bcd8739ae039, (v) => $a7275b6adf9370c1$export$2e2bcd8739ae039 = v);
var $a7275b6adf9370c1$export$1e511d4a378977f5;
var $a7275b6adf9370c1$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$a7275b6adf9370c1$export$1e511d4a378977f5 = true;
$a7275b6adf9370c1$export$2e2bcd8739ae039 = void 0;

var $a7275b6adf9370c1$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $a7275b6adf9370c1$var$_react = $a7275b6adf9370c1$var$_interopRequireWildcard((parcelRequire("acw62")));

var $a7275b6adf9370c1$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $a7275b6adf9370c1$var$_Popup = $1jnue((parcelRequire("883Id")));
function $a7275b6adf9370c1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a7275b6adf9370c1$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $a7275b6adf9370c1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $a7275b6adf9370c1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $a7275b6adf9370c1$var$ButtonPopup = ({ className: className, isDisabled: isDisabled, isSubmitting: isSubmitting, label: label, onSubmit: onSubmit, showPopup: showPopup, style: style, subtitle: subtitle, textConfirm: textConfirm, title: title })=>{
    const [isPopupOpen, setIsPopupOpen] = (0, $a7275b6adf9370c1$var$_react.useState)(false);
    const translate = (0, $a7275b6adf9370c1$var$_useTranslate.default)();
    const openModal = ()=>setIsPopupOpen(true);
    return /*#__PURE__*/ $a7275b6adf9370c1$var$_react.default.createElement($a7275b6adf9370c1$var$_react.default.Fragment, null, /*#__PURE__*/ $a7275b6adf9370c1$var$_react.default.createElement("span", {
        id: "modal-root"
    }), /*#__PURE__*/ $a7275b6adf9370c1$var$_react.default.createElement("button", {
        className: className,
        disabled: isDisabled || isSubmitting,
        style: {
            filter: `brightness(${isDisabled ? 72 : 100}%)`,
            ...style
        },
        type: "button",
        onClick: showPopup ? openModal : ()=>({})
    }, label), /*#__PURE__*/ $a7275b6adf9370c1$var$_react.default.createElement($a7275b6adf9370c1$var$_Popup.default, {
        isOpen: isPopupOpen,
        setIsOpen: setIsPopupOpen,
        subtitle: subtitle,
        textConfirm: textConfirm || translate("RL_Yes"),
        title: title || translate("RL_Confirm"),
        onSubmit: onSubmit
    }));
};
$a7275b6adf9370c1$var$ButtonPopup.defaultProps = {
    className: "",
    isDisabled: false,
    isSubmitting: false,
    showPopup: true,
    style: {},
    subtitle: "",
    textConfirm: null,
    title: null
};
$a7275b6adf9370c1$var$ButtonPopup.propTypes = {
    className: $a7275b6adf9370c1$var$_propTypes.default.string,
    isDisabled: $a7275b6adf9370c1$var$_propTypes.default.bool,
    isSubmitting: $a7275b6adf9370c1$var$_propTypes.default.bool,
    label: $a7275b6adf9370c1$var$_propTypes.default.oneOfType([
        $a7275b6adf9370c1$var$_propTypes.default.string,
        $a7275b6adf9370c1$var$_propTypes.default.shape()
    ]).isRequired,
    onSubmit: $a7275b6adf9370c1$var$_propTypes.default.func.isRequired,
    showPopup: $a7275b6adf9370c1$var$_propTypes.default.bool,
    style: $a7275b6adf9370c1$var$_propTypes.default.shape(),
    subtitle: $a7275b6adf9370c1$var$_propTypes.default.string,
    textConfirm: $a7275b6adf9370c1$var$_propTypes.default.string,
    title: $a7275b6adf9370c1$var$_propTypes.default.string
};
var $a7275b6adf9370c1$var$_default = $a7275b6adf9370c1$export$2e2bcd8739ae039 = $a7275b6adf9370c1$var$ButtonPopup;

});
parcelRegister("883Id", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $5eb1f338f1401aae$export$1e511d4a378977f5, (v) => $5eb1f338f1401aae$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $5eb1f338f1401aae$export$2e2bcd8739ae039, (v) => $5eb1f338f1401aae$export$2e2bcd8739ae039 = v);
var $5eb1f338f1401aae$export$1e511d4a378977f5;
var $5eb1f338f1401aae$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$5eb1f338f1401aae$export$1e511d4a378977f5 = true;
$5eb1f338f1401aae$export$2e2bcd8739ae039 = void 0;

var $fr6za = parcelRequire("fr6za");
var $fe9Bm = parcelRequire("fe9Bm");
var $vNXDb = parcelRequire("vNXDb");

var $5eb1f338f1401aae$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $5eb1f338f1401aae$var$_react = $1jnue((parcelRequire("acw62")));

var $5eb1f338f1401aae$var$_useTranslate = $1jnue((parcelRequire("90irH")));
const $5eb1f338f1401aae$var$Popup = ({ isOpen: isOpen, onSubmit: onSubmit, setIsOpen: setIsOpen, subtitle: subtitle, textConfirm: textConfirm, title: title })=>{
    const closeModal = ()=>setIsOpen(false);
    const translate = (0, $5eb1f338f1401aae$var$_useTranslate.default)();
    return /*#__PURE__*/ $5eb1f338f1401aae$var$_react.default.createElement($5eb1f338f1401aae$var$_react.default.Fragment, null, /*#__PURE__*/ $5eb1f338f1401aae$var$_react.default.createElement("span", {
        id: "modal-root"
    }), /*#__PURE__*/ $5eb1f338f1401aae$var$_react.default.createElement($vNXDb.DialogStyled, {
        className: "ta-sm-l",
        closeModal: closeModal,
        footerContent: /*#__PURE__*/ $5eb1f338f1401aae$var$_react.default.createElement($fe9Bm.DialogActionsStyled, null, /*#__PURE__*/ $5eb1f338f1401aae$var$_react.default.createElement($fr6za.ButtonStyled, {
            appearance: "primary",
            ariaLabel: "Submit",
            role: "alertdialog",
            onClick: ()=>{
                closeModal();
                onSubmit();
            }
        }, textConfirm || translate("RL_Yes"))),
        isOpen: isOpen,
        title: title || translate("RL_Confirm")
    }, subtitle));
};
$5eb1f338f1401aae$var$Popup.defaultProps = {
    isOpen: false,
    subtitle: "",
    textConfirm: null,
    title: null
};
$5eb1f338f1401aae$var$Popup.propTypes = {
    isOpen: $5eb1f338f1401aae$var$_propTypes.default.bool,
    onSubmit: $5eb1f338f1401aae$var$_propTypes.default.func.isRequired,
    setIsOpen: $5eb1f338f1401aae$var$_propTypes.default.func.isRequired,
    subtitle: $5eb1f338f1401aae$var$_propTypes.default.string,
    textConfirm: $5eb1f338f1401aae$var$_propTypes.default.string,
    title: $5eb1f338f1401aae$var$_propTypes.default.string
};
var $5eb1f338f1401aae$var$_default = $5eb1f338f1401aae$export$2e2bcd8739ae039 = $5eb1f338f1401aae$var$Popup;

});
parcelRegister("fe9Bm", function(module, exports) {

$parcel$export(module.exports, "DialogActionsStyled", () => $b15f9c7b093fdfcb$export$fa8947fd809a59fa);

var $1poQt = parcelRequire("1poQt");

var $e9RDh = parcelRequire("e9RDh");

var $c5ivo = parcelRequire("c5ivo");
var $b15f9c7b093fdfcb$export$fa8947fd809a59fa = (0, $1poQt.default)((0, $e9RDh.DialogActions), {
    target: "e1eje3q30"
})((0, $c5ivo.baseStyles));

});
parcelRegister("e9RDh", function(module, exports) {

$parcel$export(module.exports, "DialogActions", () => $a4eb823e016f58c9$export$702322f34446412d);

var $acw62 = parcelRequire("acw62");
var $a4eb823e016f58c9$var$t = undefined && undefined.__rest || function(t, e) {
    var o, r = {};
    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) for(o = 0, n = Object.getOwnPropertySymbols(t); o < n.length; o++)e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
    return r;
};
var $a4eb823e016f58c9$export$702322f34446412d = function(o) {
    var r = o.actionsClasses, n = void 0 === r ? "" : r, a = o.children, i = o.Component, s = void 0 === i ? "div" : i, c = $a4eb823e016f58c9$var$t(o, [
        "actionsClasses",
        "children",
        "Component"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(s, Object.assign({}, c, {
        "data-testid": "dialog-actions"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: n
    }, a));
};

});

parcelRegister("c5ivo", function(module, exports) {

$parcel$export(module.exports, "baseStyles", () => $8cc44e77483e0610$export$6a08aa478781aaec);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $7GaV5 = parcelRequire("7GaV5");
var $8cc44e77483e0610$export$6a08aa478781aaec = function(o) {
    var r = o.theme, e = r.colorBackgroundPrimary, n = r.sizeSpacingGridGutter, a = r.breakpointS;
    return (0, $6xSYO.default)("background:", e, ";width:100%;z-index:1;position:relative;padding-top:18px;@media (min-width:", a, '){padding-left:64px;}&:before{content:"";display:block;position:absolute;bottom:calc(100% - 18px);left:0;width:100%;height:36px;background:', e, ";background:linear-gradient( to top,", (0, $7GaV5.hexToCssRgba)(e, 1), " 0%,", (0, $7GaV5.hexToCssRgba)(e, 1), " 33%,", (0, $7GaV5.hexToCssRgba)(e, 0), " 100% );}> *{display:inherit;}> * > * + *{margin-top:", n, ";}@media (min-width:", a, "){> *{display:flex;flex-direction:row-reverse;}> * > * + *{margin-top:0;margin-right:", n, ";}}");
};

});
parcelRegister("7GaV5", function(module, exports) {

$parcel$export(module.exports, "hexToCssRgba", () => $5974ed1462955247$export$30286f4341cfed93);
var $5974ed1462955247$export$5a544e13ad4e1fa5 = function(r) {
    var a = parseInt(r.replace(/[^a-f0-9]+/i, ""), 16);
    return {
        r: a >> 16 & 255,
        g: a >> 8 & 255,
        b: 255 & a
    };
};
var $5974ed1462955247$export$30286f4341cfed93 = function(r, a) {
    var c = $5974ed1462955247$export$5a544e13ad4e1fa5(r), n = c.r, o = c.g, t = c.b;
    return "rgba(".concat(n, ", ").concat(o, ", ").concat(t, ", ").concat(a, ")");
};

});



parcelRegister("vNXDb", function(module, exports) {

$parcel$export(module.exports, "DialogStyled", () => $05f9a68984e65a44$export$9a0b5966b26e3fd6);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");

var $cx76g = parcelRequire("cx76g");

var $jGYPf = parcelRequire("jGYPf");

var $fe9Bm = parcelRequire("fe9Bm");

var $edU4P = parcelRequire("edU4P");

var $iEnuB = parcelRequire("iEnuB");

var $2jD6S = parcelRequire("2jD6S");

var $klCNo = parcelRequire("klCNo");

var $9bXpj = parcelRequire("9bXpj");

var $9iiQA = parcelRequire("9iiQA");
var $05f9a68984e65a44$var$D = (0, $cx76g.nike).breakpointS, $05f9a68984e65a44$var$c = (0, $cx76g.nike).elevation100, $05f9a68984e65a44$var$S = (0, $cx76g.nike).sizeSpacingXs, $05f9a68984e65a44$var$f = (0, $cx76g.nike).sizeSpacingS, $05f9a68984e65a44$var$y = (0, $cx76g.nike).sizeSpacingXl;
var $05f9a68984e65a44$export$c59bc42ae095d26 = function(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $jGYPf.Dialog), Object.assign({
        DialogActionsComp: (0, $fe9Bm.DialogActionsStyled),
        DialogBaseComp: (0, $edU4P.DialogBaseStyled),
        DialogCloseButtonComp: (0, $9bXpj.DialogCloseButtonStyled),
        DialogHeaderComp: (0, $iEnuB.DialogHeaderStyled),
        DialogContentComp: (0, $2jD6S.DialogContentStyled),
        DialogMainComp: (0, $klCNo.DialogMainStyled)
    }, o));
};
var $05f9a68984e65a44$export$9a0b5966b26e3fd6 = (0, $1poQt.default)($05f9a68984e65a44$export$c59bc42ae095d26, {
    target: "ed959o10"
})(".close-btn-container{position:sticky;top:", $05f9a68984e65a44$var$S, ";right:", $05f9a68984e65a44$var$S, ";z-index:", $05f9a68984e65a44$var$c, ";float:right;", (0, $9iiQA.pointerCourse), "{position:absolute;top:", $05f9a68984e65a44$var$y, ";right:", $05f9a68984e65a44$var$y, ";@media (max-width:", $05f9a68984e65a44$var$D, "){top:44px;right:", $05f9a68984e65a44$var$y, ";margin:0;}}", (0, $9iiQA.onlySafari10Plus), "{float:none;", (0, $9iiQA.pointerFine), "{right:", $05f9a68984e65a44$var$f, ";top:", $05f9a68984e65a44$var$f, ";button{position:absolute;right:", $05f9a68984e65a44$var$f, ";top:0px;}}}}.dialog-header-container{display:inline-block;width:80%;}");
$05f9a68984e65a44$export$9a0b5966b26e3fd6.displayName = "DialogStyled";

});
parcelRegister("jGYPf", function(module, exports) {

$parcel$export(module.exports, "Dialog", () => $e5611f3c63e7597e$export$3ddf2d174ce01153);

var $acw62 = parcelRequire("acw62");

var $f5Egd = parcelRequire("f5Egd");

var $krPIU = parcelRequire("krPIU");

var $1SA7b = parcelRequire("1SA7b");

var $39sFt = parcelRequire("39sFt");

var $8ikqj = parcelRequire("8ikqj");

var $eOXBH = parcelRequire("eOXBH");

var $h1B2D = parcelRequire("h1B2D");

var $5FmI4 = parcelRequire("5FmI4");

var $axTTc = parcelRequire("axTTc");

var $e5611f3c63e7597e$var$o = undefined && undefined.__rest || function(o, e) {
    var a, l = {};
    for(var t in o)Object.prototype.hasOwnProperty.call(o, t) && e.indexOf(t) < 0 && (l[t] = o[t]);
    if (null != o && "function" == typeof Object.getOwnPropertySymbols) for(a = 0, t = Object.getOwnPropertySymbols(o); a < t.length; a++)e.indexOf(t[a]) < 0 && Object.prototype.propertyIsEnumerable.call(o, t[a]) && (l[t[a]] = o[t[a]]);
    return l;
};
var $e5611f3c63e7597e$var$D = {
    name: "k6r56v",
    styles: ".nds-no-scroll{position:fixed;overflow:hidden;}"
}, $e5611f3c63e7597e$export$3ddf2d174ce01153 = function(n) {
    var u = n.appearance, f = void 0 === u ? "base" : u, B = (n["aria-labelledby"], n.children), b = n.classes, P = void 0 === b ? {} : b, v = n.className, O = n.closeModal, k = n.dialogCloseAriaLabel, h = n.footerContent, y = n.isOpen, E = n.role, M = void 0 === E ? "dialog" : E, I = n.shouldCloseOnBackgroundClick, N = void 0 === I || I, j = n.shouldCloseOnEsc, w = void 0 === j || j, H = n.title, R = n.titleId, L = n.BackdropComp, W = n.BackdropCompProps, x = n.DialogRootComp, T = n.DialogRootCompProps, A = n.DialogCloseButtonComp, S = void 0 === A ? (0, $eOXBH.DialogCloseButton) : A, _ = n.DialogCloseButtonCompProps, q = n.DialogContainerComp, F = n.DialogContainerCompProps, z = n.DialogBaseComp, G = void 0 === z ? (0, $39sFt.DialogBase) : z, J = n.DialogBaseCompProps, K = n.DialogHeaderComp, Q = void 0 === K ? (0, $8ikqj.DialogHeader) : K, U = n.DialogHeaderCompProps, V = n.DialogContentComp, X = void 0 === V ? "div" : V, Y = n.DialogContentCompProps, Z = n.DialogMainComp, $ = void 0 === Z ? "div" : Z, oo = n.DialogMainCompProps, eo = n.IconWrapper, ao = n.Icon, lo = n.ModalComp, to = n.ModalCompProps, ro = $e5611f3c63e7597e$var$o(n, [
        "appearance",
        "aria-labelledby",
        "children",
        "classes",
        "className",
        "closeModal",
        "dialogCloseAriaLabel",
        "footerContent",
        "isOpen",
        "role",
        "shouldCloseOnBackgroundClick",
        "shouldCloseOnEsc",
        "title",
        "titleId",
        "BackdropComp",
        "BackdropCompProps",
        "DialogRootComp",
        "DialogRootCompProps",
        "DialogCloseButtonComp",
        "DialogCloseButtonCompProps",
        "DialogContainerComp",
        "DialogContainerCompProps",
        "DialogBaseComp",
        "DialogBaseCompProps",
        "DialogHeaderComp",
        "DialogHeaderCompProps",
        "DialogContentComp",
        "DialogContentCompProps",
        "DialogMainComp",
        "DialogMainCompProps",
        "IconWrapper",
        "Icon",
        "ModalComp",
        "ModalCompProps"
    ]), no = null != R ? R : H.toLowerCase().replace(/\W/g, "-"), io = (0, $h1B2D.useTokens)().transitionDurationNormal, so = (0, $acw62.useRef)();
    return (0, $acw62.useLayoutEffect)(function() {
        (0, $axTTc.hasWindow)() && y && (so.current = (0, $5FmI4.getScrollPosition)());
    }, [
        y
    ]), (0, $acw62.useEffect)(function() {
        if ((0, $axTTc.hasWindow)()) {
            var o = document.querySelector("body");
            return "fullscreen" === f && y && setTimeout(function() {
                o.classList.add("nds-no-scroll");
            }, parseInt(io)), function() {
                o.classList.remove("nds-no-scroll"), window.scrollTo(0, so.current);
            };
        }
    }, [
        f,
        y,
        io
    ]), (0, $acw62.useEffect)(function() {}, [
        null == P ? void 0 : P.dialogTitle
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f5Egd.Global), {
        styles: $e5611f3c63e7597e$var$D
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $krPIU.default), {
        appear: y,
        in: y,
        timeout: parseInt(io),
        classNames: "dialog",
        mountOnEnter: !0,
        unmountOnExit: !0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(G, Object.assign({
        className: (0, $1SA7b.default)(v, f, P.Base),
        appearance: f,
        isOpen: !0,
        role: M,
        "aria-labelledby": "dialog-".concat(no),
        classes: {
            Backdrop: P.Backdrop,
            BackdropContainer: P.BackdropContainer,
            Modal: P.Modal,
            Root: P.Root
        },
        closeModal: O,
        shouldCloseOnBackgroundClick: N,
        shouldCloseOnEsc: w,
        ModalComp: lo,
        ModalCompProps: to,
        BackdropComp: L,
        BackdropCompProps: W,
        DialogRootComp: x,
        DialogRootCompProps: T,
        DialogContainerComp: q,
        DialogContainerCompProps: F
    }, J, ro), "function" == typeof O && "fullscreen" === f && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "close-btn-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(S, {
        appearance: f,
        className: P.CloseButton,
        dialogCloseAriaLabel: k,
        onClick: O,
        "data-testid": "dialog-close-button",
        DialogCloseButtonCompProps: _
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($, Object.assign({
        className: P.Main,
        appearance: f
    }, oo), "function" == typeof O && "fullscreen" !== f && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "close-btn-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(S, {
        appearance: f,
        className: P.CloseButton,
        dialogCloseAriaLabel: k,
        onClick: O,
        "data-testid": "dialog-close-button",
        DialogCloseButtonCompProps: _
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "dialog-header-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Q, Object.assign({
        appearance: f,
        closeModal: O,
        IconWrapper: eo,
        className: P.Header,
        classes: {
            Icon: P.Icon,
            IconWrapper: P.IconWrapper,
            Title: (0, $1SA7b.default)(P.dialogTitle, P.Title, "headline-3")
        },
        id: "dialog-".concat(no),
        title: H,
        Icon: ao
    }, U))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(X, Object.assign({
        className: P.Content
    }, Y), B)), h && h)));
};

});
parcelRegister("krPIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2e736fe07a2c40$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");

var $c9Z8w = parcelRequire("c9Z8w");

var $8pZ1o = parcelRequire("8pZ1o");

var $gFyrF = parcelRequire("gFyrF");

var $acw62 = parcelRequire("acw62");

var $1mPeS = parcelRequire("1mPeS");

var $bRYJd = parcelRequire("bRYJd");

var $4NYRH = parcelRequire("4NYRH");
var $ee2e736fe07a2c40$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $8pZ1o.default)(node, c);
    });
};
var $ee2e736fe07a2c40$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $gFyrF.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ee2e736fe07a2c40$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $4NYRH.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ee2e736fe07a2c40$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ee2e736fe07a2c40$var$removeClass(node, baseClassName);
        if (activeClassName) $ee2e736fe07a2c40$var$removeClass(node, activeClassName);
        if (doneClassName) $ee2e736fe07a2c40$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $1En50.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1mPeS.default), (0, $8nd05.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ee2e736fe07a2c40$var$CSSTransition.defaultProps = {
    classNames: ""
};
$ee2e736fe07a2c40$var$CSSTransition.propTypes = (0, $8nd05.default)({}, (0, $1mPeS.default).propTypes, {
    /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */ classNames: (0, $bRYJd.classNamesShape),
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
});
var $ee2e736fe07a2c40$export$2e2bcd8739ae039 = $ee2e736fe07a2c40$var$CSSTransition;

});
parcelRegister("8pZ1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $620ffe1c3bcccf8e$export$2e2bcd8739ae039);

var $59GJ0 = parcelRequire("59GJ0");
function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $59GJ0.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("59GJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c0eef4e7b8d3866$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("gFyrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c22b31c675df16bf$export$2e2bcd8739ae039);
function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});

parcelRegister("1mPeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fef977f04119bf5$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $dIte2 = parcelRequire("dIte2");

var $bRYJd = parcelRequire("bRYJd");

var $6xlZQ = parcelRequire("6xlZQ");

var $4NYRH = parcelRequire("4NYRH");
var $0fef977f04119bf5$export$bb38bb9a1161268 = "unmounted";
var $0fef977f04119bf5$export$84cbff306f539230 = "exited";
var $0fef977f04119bf5$export$df38205c966be359 = "entering";
var $0fef977f04119bf5$export$78e9e6e3e014d60a = "entered";
var $0fef977f04119bf5$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $4NYRH.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $dIte2.default).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6xlZQ.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $6xlZQ.default);
$0fef977f04119bf5$var$Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: typeof Element === "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).instanceOf(value && "ownerDocument" in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, $bRYJd.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;

});
parcelRegister("dIte2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc60dfb9203246b$export$2e2bcd8739ae039);
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("bRYJd", function(module, exports) {

$parcel$export(module.exports, "timeoutsShape", () => $8a43c04fdfd3c437$export$3458ee1082941f5e);
$parcel$export(module.exports, "classNamesShape", () => $8a43c04fdfd3c437$export$d61341ca8ef7c732);

var $c9Z8w = parcelRequire("c9Z8w");
var $8a43c04fdfd3c437$export$3458ee1082941f5e = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        appear: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    }).isRequired
]);
var $8a43c04fdfd3c437$export$d61341ca8ef7c732 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        enter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        enterDone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        enterActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exitDone: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        exitActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    })
]);

});

parcelRegister("6xlZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c26e32a51d8c622$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});

parcelRegister("4NYRH", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $37faf39349e00e45$export$7d26bbb1236dafd6);
var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});



parcelRegister("39sFt", function(module, exports) {

$parcel$export(module.exports, "DialogBase", () => $24b873322f9c4d5b$export$569e42c9a98af7b7);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $imA3l = parcelRequire("imA3l");

var $dwbPi = parcelRequire("dwbPi");

var $gcy1x = parcelRequire("gcy1x");

var $5vEzr = parcelRequire("5vEzr");
var $24b873322f9c4d5b$var$o = undefined && undefined.__rest || function(o, a) {
    var e, l = {};
    for(var r in o)Object.prototype.hasOwnProperty.call(o, r) && a.indexOf(r) < 0 && (l[r] = o[r]);
    if (null != o && "function" == typeof Object.getOwnPropertySymbols) for(e = 0, r = Object.getOwnPropertySymbols(o); e < r.length; e++)a.indexOf(r[e]) < 0 && Object.prototype.propertyIsEnumerable.call(o, r[e]) && (l[r[e]] = o[r[e]]);
    return l;
};
var $24b873322f9c4d5b$export$569e42c9a98af7b7 = function(i) {
    var t = i.appearance, n = void 0 === t ? "base" : t, c = i["aria-labelledby"], d = i.children, m = i.classes, C = void 0 === m ? {} : m, g = i.className, O = i.closeModal, b = i.isOpen, u = i.role, f = void 0 === u ? "dialog" : u, h = i.shouldCloseOnBackgroundClick, k = i.shouldCloseOnEsc, B = i.BackdropComp, v = void 0 === B ? (0, $dwbPi.Backdrop) : B, y = i.BackdropCompProps, P = (i.DialogBaseCompProps, i.DialogRootComp), D = void 0 === P ? "div" : P, M = i.DialogRootCompProps, j = i.DialogContainerComp, E = void 0 === j ? (0, $gcy1x.DialogContainer) : j, N = i.DialogContainerCompProps, R = i.ModalComp, w = void 0 === R ? (0, $imA3l.Modal) : R, x = i.ModalCompProps, S = $24b873322f9c4d5b$var$o(i, [
        "appearance",
        "aria-labelledby",
        "children",
        "classes",
        "className",
        "closeModal",
        "isOpen",
        "role",
        "shouldCloseOnBackgroundClick",
        "shouldCloseOnEsc",
        "BackdropComp",
        "BackdropCompProps",
        "DialogBaseCompProps",
        "DialogRootComp",
        "DialogRootCompProps",
        "DialogContainerComp",
        "DialogContainerCompProps",
        "ModalComp",
        "ModalCompProps"
    ]), _ = (0, $5vEzr.useWindowHeight)({
        wait: 250
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(w, Object.assign({
        className: C.Modal,
        isOpen: b
    }, x, S), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(v, Object.assign({
        className: C.Backdrop,
        closeModal: O,
        shouldCloseOnBackgroundClick: h,
        shouldCloseOnEsc: k
    }, y), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(D, Object.assign({
        className: (0, $1SA7b.default)(g, C.Root),
        role: f,
        "aria-labelledby": c,
        style: "fullscreen" === n ? {
            height: _
        } : {}
    }, M), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(E, Object.assign({
        className: C.BackdropContainer,
        appearance: n
    }, N), d))));
};

});
parcelRegister("imA3l", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $d5e63f6ad16c3453$export$2b77a92f1a5ad772);

var $acw62 = parcelRequire("acw62");

var $lWVyc = parcelRequire("lWVyc");

var $1PC3K = parcelRequire("1PC3K");

var $851sL = parcelRequire("851sL");
var $d5e63f6ad16c3453$var$e = undefined && undefined.__rest || function(e, t) {
    var r, o = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (o[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(r = 0, n = Object.getOwnPropertySymbols(e); r < n.length; r++)t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (o[n[r]] = e[n[r]]);
    return o;
};
var $d5e63f6ad16c3453$export$2b77a92f1a5ad772 = function(l) {
    var i = l.selector, c = void 0 === i ? (0, $1PC3K.MODAL_ROOT_ELEMENT_SELECTOR) : i, p = l.isOpen, a = void 0 !== p && p, s = l.trapFocus, f = void 0 === s || s, m = l.children, u = $d5e63f6ad16c3453$var$e(l, [
        "selector",
        "isOpen",
        "trapFocus",
        "children"
    ]), O = f ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lWVyc))), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, m)) : m;
    return "undefined" == typeof window ? O : a ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $851sL.Portal), Object.assign({
        selector: c
    }, u), O) : null;
};

});
parcelRegister("lWVyc", function(module, exports) {
"use strict";
var $ffaba819b528f80e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $ffaba819b528f80e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ffaba819b528f80e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ffaba819b528f80e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $7b5Rz = parcelRequire("7b5Rz");
var $ffaba819b528f80e$var$FocusTrap = function(_React$Component) {
    $ffaba819b528f80e$var$_inherits(FocusTrap, _React$Component);
    function FocusTrap(props) {
        $ffaba819b528f80e$var$_classCallCheck(this, FocusTrap);
        var _this = $ffaba819b528f80e$var$_possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));
        _this.setFocusTrapElement = function(element) {
            _this.focusTrapElement = element;
        };
        if (typeof document !== "undefined") _this.previouslyFocusedElement = document.activeElement;
        return _this;
    }
    $ffaba819b528f80e$var$_createClass(FocusTrap, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // We need to hijack the returnFocusOnDeactivate option,
                // because React can move focus into the element before we arrived at
                // this lifecycle hook (e.g. with autoFocus inputs). So the component
                // captures the previouslyFocusedElement in componentWillMount,
                // then (optionally) returns focus to it in componentWillUnmount.
                var specifiedFocusTrapOptions = this.props.focusTrapOptions;
                var tailoredFocusTrapOptions = {
                    returnFocusOnDeactivate: false
                };
                for(var optionName in specifiedFocusTrapOptions){
                    if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
                    if (optionName === "returnFocusOnDeactivate") continue;
                    tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
                }
                var focusTrapElementDOMNode = $1u0KT.findDOMNode(this.focusTrapElement);
                this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNode, tailoredFocusTrapOptions);
                if (this.props.active) this.focusTrap.activate();
                if (this.props.paused) this.focusTrap.pause();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (prevProps.active && !this.props.active) {
                    var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;
                    var returnFocus = returnFocusOnDeactivate || false;
                    var config = {
                        returnFocus: returnFocus
                    };
                    this.focusTrap.deactivate(config);
                } else if (!prevProps.active && this.props.active) this.focusTrap.activate();
                if (prevProps.paused && !this.props.paused) this.focusTrap.unpause();
                else if (!prevProps.paused && this.props.paused) this.focusTrap.pause();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.focusTrap.deactivate();
                if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) this.previouslyFocusedElement.focus();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var child = $acw62.Children.only(this.props.children);
                var composedRefCallback = function composedRefCallback(element) {
                    _this2.setFocusTrapElement(element);
                    if (typeof child.ref === "function") child.ref(element);
                };
                var childWithRef = $acw62.cloneElement(child, {
                    ref: composedRefCallback
                });
                return childWithRef;
            }
        }
    ]);
    return FocusTrap;
}($acw62.Component);
$ffaba819b528f80e$var$FocusTrap.defaultProps = {
    active: true,
    paused: false,
    focusTrapOptions: {},
    _createFocusTrap: $7b5Rz
};
module.exports = $ffaba819b528f80e$var$FocusTrap;

});
parcelRegister("7b5Rz", function(module, exports) {

var $31HEB = parcelRequire("31HEB");

var $h0kNM = parcelRequire("h0kNM");
var $539e1bc5b4077faf$var$activeFocusTraps = function() {
    var trapQueue = [];
    return {
        activateTrap: function(trap) {
            if (trapQueue.length > 0) {
                var activeTrap = trapQueue[trapQueue.length - 1];
                if (activeTrap !== trap) activeTrap.pause();
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) trapQueue.push(trap);
            else {
                // move this existing trap to the front of the queue
                trapQueue.splice(trapIndex, 1);
                trapQueue.push(trap);
            }
        },
        deactivateTrap: function(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
            if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
        }
    };
}();
function $539e1bc5b4077faf$var$focusTrap(element, userOptions) {
    var doc = document;
    var container = typeof element === "string" ? doc.querySelector(element) : element;
    var config = $h0kNM({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true
    }, userOptions);
    var state = {
        firstTabbableNode: null,
        lastTabbableNode: null,
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false
    };
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (state.active) return;
        updateTabbableNodes();
        state.active = true;
        state.paused = false;
        state.nodeFocusedBeforeActivation = doc.activeElement;
        var onActivate = activateOptions && activateOptions.onActivate ? activateOptions.onActivate : config.onActivate;
        if (onActivate) onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!state.active) return;
        removeListeners();
        state.active = false;
        state.paused = false;
        $539e1bc5b4077faf$var$activeFocusTraps.deactivateTrap(trap);
        var onDeactivate = deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate;
        if (onDeactivate) onDeactivate();
        var returnFocus = deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate;
        if (returnFocus) $539e1bc5b4077faf$var$delay(function() {
            tryFocus(state.nodeFocusedBeforeActivation);
        });
        return trap;
    }
    function pause() {
        if (state.paused || !state.active) return;
        state.paused = true;
        removeListeners();
    }
    function unpause() {
        if (!state.paused || !state.active) return;
        state.paused = false;
        addListeners();
    }
    function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $539e1bc5b4077faf$var$activeFocusTraps.activateTrap(trap);
        updateTabbableNodes();
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        $539e1bc5b4077faf$var$delay(function() {
            tryFocus(getInitialFocusNode());
        });
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, true);
        doc.addEventListener("touchstart", checkPointerDown, true);
        doc.addEventListener("click", checkClick, true);
        doc.addEventListener("keydown", checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue);
            if (!node) throw new Error("`" + optionName + "` refers to no known node");
        }
        if (typeof optionValue === "function") {
            node = optionValue();
            if (!node) throw new Error("`" + optionName + "` did not return a node");
        }
        return node;
    }
    function getInitialFocusNode() {
        var node;
        if (getNodeForOption("initialFocus") !== null) node = getNodeForOption("initialFocus");
        else if (container.contains(doc.activeElement)) node = doc.activeElement;
        else node = state.firstTabbableNode || getNodeForOption("fallbackFocus");
        if (!node) throw new Error("You can't have a focus-trap without at least one focusable element");
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    function checkPointerDown(e) {
        if (container.contains(e.target)) return;
        if (config.clickOutsideDeactivates) deactivate({
            returnFocus: !$31HEB.isFocusable(e.target)
        });
        else e.preventDefault();
    }
    // In case focus escapes the trap for some strange reason, pull it back in.
    function checkFocusIn(e) {
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (container.contains(e.target) || e.target instanceof Document) return;
        e.stopImmediatePropagation();
        tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
    function checkKey(e) {
        if (config.escapeDeactivates !== false && $539e1bc5b4077faf$var$isEscapeEvent(e)) {
            e.preventDefault();
            deactivate();
            return;
        }
        if ($539e1bc5b4077faf$var$isTabEvent(e)) {
            checkTab(e);
            return;
        }
    }
    // Hijack Tab events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    function checkTab(e) {
        updateTabbableNodes();
        if (e.shiftKey && e.target === state.firstTabbableNode) {
            e.preventDefault();
            tryFocus(state.lastTabbableNode);
            return;
        }
        if (!e.shiftKey && e.target === state.lastTabbableNode) {
            e.preventDefault();
            tryFocus(state.firstTabbableNode);
            return;
        }
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function updateTabbableNodes() {
        var tabbableNodes = $31HEB(container);
        state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
        state.lastTabbableNode = tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
    }
    function tryFocus(node) {
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus();
        state.mostRecentlyFocusedNode = node;
        if ($539e1bc5b4077faf$var$isSelectableInput(node)) node.select();
    }
}
function $539e1bc5b4077faf$var$isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
}
function $539e1bc5b4077faf$var$isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
}
function $539e1bc5b4077faf$var$isTabEvent(e) {
    return e.key === "Tab" || e.keyCode === 9;
}
function $539e1bc5b4077faf$var$delay(fn) {
    return setTimeout(fn, 0);
}
module.exports = $539e1bc5b4077faf$var$focusTrap;

});
parcelRegister("31HEB", function(module, exports) {
var $234353d92c14c737$var$candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
];
var $234353d92c14c737$var$candidateSelector = $234353d92c14c737$var$candidateSelectors.join(",");
var $234353d92c14c737$var$matches = typeof Element === "undefined" ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
function $234353d92c14c737$var$tabbable(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var regularTabbables = [];
    var orderedTabbables = [];
    var untouchabilityChecker = new $234353d92c14c737$var$UntouchabilityChecker(elementDocument);
    var candidates = el.querySelectorAll($234353d92c14c737$var$candidateSelector);
    if (options.includeContainer) {
        if ($234353d92c14c737$var$matches.call(el, $234353d92c14c737$var$candidateSelector)) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var i, candidate, candidateTabindex;
    for(i = 0; i < candidates.length; i++){
        candidate = candidates[i];
        if (!$234353d92c14c737$var$isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;
        candidateTabindex = $234353d92c14c737$var$getTabindex(candidate);
        if (candidateTabindex === 0) regularTabbables.push(candidate);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort($234353d92c14c737$var$sortOrderedTabbables).map(function(a) {
        return a.node;
    }).concat(regularTabbables);
    return tabbableNodes;
}
$234353d92c14c737$var$tabbable.isTabbable = $234353d92c14c737$var$isTabbable;
$234353d92c14c737$var$tabbable.isFocusable = $234353d92c14c737$var$isFocusable;
function $234353d92c14c737$var$isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
    if (!$234353d92c14c737$var$isNodeMatchingSelectorFocusable(node, untouchabilityChecker) || $234353d92c14c737$var$isNonTabbableRadio(node) || $234353d92c14c737$var$getTabindex(node) < 0) return false;
    return true;
}
function $234353d92c14c737$var$isTabbable(node, untouchabilityChecker) {
    if (!node) throw new Error("No node provided");
    if ($234353d92c14c737$var$matches.call(node, $234353d92c14c737$var$candidateSelector) === false) return false;
    return $234353d92c14c737$var$isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
}
function $234353d92c14c737$var$isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
    untouchabilityChecker = untouchabilityChecker || new $234353d92c14c737$var$UntouchabilityChecker(node.ownerDocument || node);
    if (node.disabled || $234353d92c14c737$var$isHiddenInput(node) || untouchabilityChecker.isUntouchable(node)) return false;
    return true;
}
var $234353d92c14c737$var$focusableCandidateSelector = $234353d92c14c737$var$candidateSelectors.concat("iframe").join(",");
function $234353d92c14c737$var$isFocusable(node, untouchabilityChecker) {
    if (!node) throw new Error("No node provided");
    if ($234353d92c14c737$var$matches.call(node, $234353d92c14c737$var$focusableCandidateSelector) === false) return false;
    return $234353d92c14c737$var$isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
}
function $234353d92c14c737$var$getTabindex(node) {
    var tabindexAttr = parseInt(node.getAttribute("tabindex"), 10);
    if (!isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    if ($234353d92c14c737$var$isContentEditable(node)) return 0;
    return node.tabIndex;
}
function $234353d92c14c737$var$sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}
// Array.prototype.find not available in IE.
function $234353d92c14c737$var$find(list, predicate) {
    for(var i = 0, length = list.length; i < length; i++){
        if (predicate(list[i])) return list[i];
    }
}
function $234353d92c14c737$var$isContentEditable(node) {
    return node.contentEditable === "true";
}
function $234353d92c14c737$var$isInput(node) {
    return node.tagName === "INPUT";
}
function $234353d92c14c737$var$isHiddenInput(node) {
    return $234353d92c14c737$var$isInput(node) && node.type === "hidden";
}
function $234353d92c14c737$var$isRadio(node) {
    return $234353d92c14c737$var$isInput(node) && node.type === "radio";
}
function $234353d92c14c737$var$isNonTabbableRadio(node) {
    return $234353d92c14c737$var$isRadio(node) && !$234353d92c14c737$var$isTabbableRadio(node);
}
function $234353d92c14c737$var$getCheckedRadio(nodes) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked) return nodes[i];
    }
}
function $234353d92c14c737$var$isTabbableRadio(node) {
    if (!node.name) return true;
    // This won't account for the edge case where you have radio groups with the same
    // in separate forms on the same page.
    var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
    var checked = $234353d92c14c737$var$getCheckedRadio(radioSet);
    return !checked || checked === node;
}
// An element is "untouchable" if *it or one of its ancestors* has
// `visibility: hidden` or `display: none`.
function $234353d92c14c737$var$UntouchabilityChecker(elementDocument) {
    this.doc = elementDocument;
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed. The cache contains tuples
    // mapping nodes to their boolean result.
    this.cache = [];
}
// getComputedStyle accurately reflects `visibility: hidden` of ancestors
// but not `display: none`, so we need to recursively check parents.
$234353d92c14c737$var$UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    // Search for a cached result.
    var cached = $234353d92c14c737$var$find(this.cache, function(item) {
        return item === node;
    });
    if (cached) return cached[1];
    nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);
    var result = false;
    if (nodeComputedStyle.display === "none") result = true;
    else if (node.parentNode) result = this.hasDisplayNone(node.parentNode);
    this.cache.push([
        node,
        result
    ]);
    return result;
};
$234353d92c14c737$var$UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
    if (node === this.doc.documentElement) return false;
    var computedStyle = this.doc.defaultView.getComputedStyle(node);
    if (this.hasDisplayNone(node, computedStyle)) return true;
    return computedStyle.visibility === "hidden";
};
module.exports = $234353d92c14c737$var$tabbable;

});

parcelRegister("h0kNM", function(module, exports) {
module.exports = $c61292941889f8f2$var$extend;
var $c61292941889f8f2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c61292941889f8f2$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($c61292941889f8f2$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});



parcelRegister("1PC3K", function(module, exports) {

$parcel$export(module.exports, "MODAL_ROOT_ELEMENT_SELECTOR", () => $155813aae12b5a50$export$4745d4ddb1ad7c53);
var $155813aae12b5a50$export$4745d4ddb1ad7c53 = "#modal-root";

});

parcelRegister("851sL", function(module, exports) {

$parcel$export(module.exports, "Portal", () => $5e1fecdb358c09d7$export$602eac185826482c);

var $1u0KT = parcelRequire("1u0KT");

var $i1nZH = parcelRequire("i1nZH");
var $5e1fecdb358c09d7$export$602eac185826482c = function(t) {
    var e = t.selector, m = t.children;
    return (0, $1u0KT.createPortal)(m, (0, $i1nZH.usePortal)(e));
};

});
parcelRegister("i1nZH", function(module, exports) {

$parcel$export(module.exports, "usePortal", () => $d1eaeebfff973867$export$b1072f43c67b540c);

var $acw62 = parcelRequire("acw62");
var $d1eaeebfff973867$export$b1072f43c67b540c = function(n) {
    var t = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(function() {
        var r = document.querySelector(n);
        return r || console.warn('Could not find modal root "'.concat(n, '".')), r && r.appendChild(t.current), function() {
            t.current.parentNode && t.current.parentNode.removeChild(t.current);
        };
    }, []), t.current || (t.current = document.createElement("div")), t.current;
};

});



parcelRegister("dwbPi", function(module, exports) {

$parcel$export(module.exports, "Backdrop", () => $9d776fffb6f353f5$export$698223c589197ab7);

var $acw62 = parcelRequire("acw62");

var $axTTc = parcelRequire("axTTc");
var $9d776fffb6f353f5$var$e = undefined && undefined.__rest || function(e, o) {
    var r, n = {};
    for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && o.indexOf(t) < 0 && (n[t] = e[t]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(r = 0, t = Object.getOwnPropertySymbols(e); r < t.length; r++)o.indexOf(t[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[r]) && (n[t[r]] = e[t[r]]);
    return n;
};
var $9d776fffb6f353f5$export$698223c589197ab7 = function(c) {
    var l = c.closeModal, s = c.shouldCloseOnBackgroundClick, a = c.shouldCloseOnEsc, i = c.className, d = c.children, p = c.BackdropCompProps, u = $9d776fffb6f353f5$var$e(c, [
        "closeModal",
        "shouldCloseOnBackgroundClick",
        "shouldCloseOnEsc",
        "className",
        "children",
        "BackdropCompProps"
    ]), f = (0, $acw62.useRef)(null);
    return (0, $acw62.useEffect)(function() {
        var e = function(e) {
            "Escape" === e.key && l && a && l(e);
        };
        return (0, $axTTc.hasWindow)() && window.addEventListener("keydown", e), function() {
            (0, $axTTc.hasWindow)() && window.removeEventListener("keydown", e);
        };
    }, [
        a
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: f,
        className: i,
        onClick: function(e) {
            e.target === f.current && l && s && l(e);
        },
        "data-testid": "dialog-backdrop"
    }, p, u), d);
};

});
parcelRegister("axTTc", function(module, exports) {

$parcel$export(module.exports, "hasWindow", () => $7ad856eba4ee1495$export$fef62134eea24008);
var $7ad856eba4ee1495$export$fef62134eea24008 = function() {
    return "undefined" != typeof window;
};

});


parcelRegister("gcy1x", function(module, exports) {

$parcel$export(module.exports, "DialogContainer", () => $bcb828c0d5814fea$export$547754aada6e339f);

var $acw62 = parcelRequire("acw62");
var $bcb828c0d5814fea$var$e = undefined && undefined.__rest || function(e, t) {
    var r, n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
    return n;
};
var $bcb828c0d5814fea$export$547754aada6e339f = function(r) {
    r.appearance;
    var n = r.Component, o = void 0 === n ? "section" : n, a = r.className, c = $bcb828c0d5814fea$var$e(r, [
        "appearance",
        "Component",
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(o, Object.assign({
        className: a
    }, c));
};

});

parcelRegister("5vEzr", function(module, exports) {

$parcel$export(module.exports, "useWindowHeight", () => $402f517774995839$export$7c4ec72a573072ce);
$parcel$export(module.exports, "useWindowWidth", () => $402f517774995839$export$52797c36be27ec5f);

var $1Tevq = parcelRequire("1Tevq");

var $3GjA3 = parcelRequire("3GjA3");
const $402f517774995839$var$emptyObj = {};
const $402f517774995839$var$win = typeof window === "undefined" ? null : window;
const $402f517774995839$var$wv = $402f517774995839$var$win && typeof $402f517774995839$var$win.visualViewport !== "undefined" ? $402f517774995839$var$win.visualViewport : null;
const $402f517774995839$var$getSize = ()=>[
        document.documentElement.clientWidth,
        document.documentElement.clientHeight
    ];
const $402f517774995839$export$42c02f33970a2afa = function(options) {
    if (options === void 0) options = $402f517774995839$var$emptyObj;
    const { wait: wait, leading: leading, initialWidth: initialWidth = 0, initialHeight: initialHeight = 0 } = options;
    const [size, setDebouncedSize] = (0, $1Tevq.useDebounce)(/* istanbul ignore next */ typeof document === "undefined" ? [
        initialWidth,
        initialHeight
    ] : $402f517774995839$var$getSize, wait, leading);
    const setSize = ()=>setDebouncedSize($402f517774995839$var$getSize);
    (0, $3GjA3.default)($402f517774995839$var$win, "resize", setSize); // @ts-expect-error
    (0, $3GjA3.default)($402f517774995839$var$wv, "resize", setSize);
    (0, $3GjA3.default)($402f517774995839$var$win, "orientationchange", setSize);
    return size;
};
const $402f517774995839$export$7c4ec72a573072ce = (options)=>$402f517774995839$export$42c02f33970a2afa(options)[1];
const $402f517774995839$export$52797c36be27ec5f = (options)=>$402f517774995839$export$42c02f33970a2afa(options)[0];

});
parcelRegister("1Tevq", function(module, exports) {

$parcel$export(module.exports, "useDebounce", () => $16062e13c682c0d4$export$21805fee57372823);

var $acw62 = parcelRequire("acw62");

var $cZNg5 = parcelRequire("cZNg5");
const $16062e13c682c0d4$export$40ae01be0011c1e6 = (callback, wait = 100, leading = false)=>{
    const storedCallback = (0, $cZNg5.default)(callback);
    const timeout = $acw62.useRef();
    const deps = [
        wait,
        leading,
        storedCallback
    ]; // Cleans up pending timeouts when the deps change
    function _ref() {
        timeout.current && clearTimeout(timeout.current);
        timeout.current = void 0;
    }
    $acw62.useEffect(()=>_ref, deps);
    function _ref2() {
        timeout.current = void 0;
    }
    return $acw62.useCallback(function() {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        const { current: current } = timeout; // Calls on leading edge
        if (current === void 0 && leading) {
            timeout.current = setTimeout(_ref2, wait); // eslint-disable-next-line prefer-spread
            return storedCallback.current.apply(null, args);
        } // Clear the timeout every call and start waiting again
        current && clearTimeout(current); // Waits for `wait` before invoking the callback
        timeout.current = setTimeout(()=>{
            timeout.current = void 0;
            storedCallback.current.apply(null, args);
        }, wait);
    }, deps);
};
const $16062e13c682c0d4$export$21805fee57372823 = (initialState, wait, leading)=>{
    const state = $acw62.useState(initialState);
    return [
        state[0],
        $16062e13c682c0d4$export$40ae01be0011c1e6(state[1], wait, leading)
    ];
};

});
parcelRegister("cZNg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $97616438e23e23b1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
const $97616438e23e23b1$var$useLatest = (current)=>{
    const storedValue = $acw62.useRef(current);
    $acw62.useEffect(()=>{
        storedValue.current = current;
    });
    return storedValue;
};
var $97616438e23e23b1$export$2e2bcd8739ae039 = $97616438e23e23b1$var$useLatest;

});


parcelRegister("3GjA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ae47b9fdb734335$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $2ae47b9fdb734335$var$useEvent(target, type, listener, cleanup) {
    const storedListener = $acw62.useRef(listener);
    const storedCleanup = $acw62.useRef(cleanup);
    $acw62.useEffect(()=>{
        storedListener.current = listener;
        storedCleanup.current = cleanup;
    });
    $acw62.useEffect(()=>{
        const targetEl = target && "current" in target ? target.current : target;
        if (!targetEl) return;
        let didUnsubscribe = 0;
        function listener(...args) {
            if (didUnsubscribe) return;
            storedListener.current.apply(this, args);
        }
        targetEl.addEventListener(type, listener);
        const cleanup = storedCleanup.current;
        return ()=>{
            didUnsubscribe = 1;
            targetEl.removeEventListener(type, listener);
            cleanup && cleanup();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        target,
        type
    ]);
}
var $2ae47b9fdb734335$export$2e2bcd8739ae039 = $2ae47b9fdb734335$var$useEvent;

});



parcelRegister("8ikqj", function(module, exports) {

$parcel$export(module.exports, "DialogHeader", () => $609fd8d6997e16ee$export$742513523b177e3b);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $8ABBi = parcelRequire("8ABBi");
var $609fd8d6997e16ee$var$e = undefined && undefined.__rest || function(e, a) {
    var o, r = {};
    for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && a.indexOf(t) < 0 && (r[t] = e[t]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(o = 0, t = Object.getOwnPropertySymbols(e); o < t.length; o++)a.indexOf(t[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[o]) && (r[t[o]] = e[t[o]]);
    return r;
};
var $609fd8d6997e16ee$export$742513523b177e3b = function(t) {
    t.appearance;
    var l = t.className, n = t.classes, i = void 0 === n ? {} : n, c = (t.closeModal, t.dialogCloseAriaLabel, t.id), p = t.title, s = t.Component, d = void 0 === s ? "header" : s, m = t.DialogHeaderCompProps, g = t.Icon, f = t.IconWrapper, y = void 0 === f ? "span" : f, b = $609fd8d6997e16ee$var$e(t, [
        "appearance",
        "className",
        "classes",
        "closeModal",
        "dialogCloseAriaLabel",
        "id",
        "title",
        "Component",
        "DialogHeaderCompProps",
        "Icon",
        "IconWrapper"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(d, Object.assign({
        className: l
    }, m, b), g && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(y, {
        className: (0, $1SA7b.default)("icon-wrapper", i.IconWrapper),
        "data-testid": "dialog-icon"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, {
        className: i.Icon
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ABBi.Text), {
        className: (0, $1SA7b.default)("title-heading", i.Title),
        id: c,
        appearance: "heading1",
        "data-testid": "dialog-header-title"
    }, p));
};

});
parcelRegister("8ABBi", function(module, exports) {

$parcel$export(module.exports, "Text", () => $640eda379290a46d$export$5f1af8db9871e1d6);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");
function $640eda379290a46d$var$e(e, o, i) {
    return o in e ? Object.defineProperty(e, o, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[o] = i, e;
}
var $640eda379290a46d$var$o = undefined && undefined.__rest || function(e, o) {
    var i, r = {};
    for(var t in e)Object.prototype.hasOwnProperty.call(e, t) && o.indexOf(t) < 0 && (r[t] = e[t]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(i = 0, t = Object.getOwnPropertySymbols(e); i < t.length; i++)o.indexOf(t[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, t[i]) && (r[t[i]] = e[t[i]]);
    return r;
};
var $640eda379290a46d$var$t = {
    body1: "p",
    body2: "p",
    body3: "p",
    body4: "p",
    display1: "h1",
    display2: "h2",
    display3: "h3",
    heading1: "h1",
    heading2: "h2",
    heading3: "h3",
    heading4: "h4",
    heading5: "h5"
};
var $640eda379290a46d$export$5f1af8db9871e1d6 = function(a) {
    var n, l = a.Component, p = a.align, c = void 0 === p ? "inherit" : p, s = a.appearance, d = void 0 === s ? "body1" : s, h = a.bold, y = void 0 !== h && h, b = a.className, g = a.color, v = void 0 === g ? "primary" : g, u = a.display, m = void 0 === u ? "initial" : u, f = a.responsive, O = void 0 !== f && f, w = a.strikethrough, j = void 0 !== w && w, x = a.weight, P = void 0 === x ? "regular" : x, k = $640eda379290a46d$var$o(a, [
        "Component",
        "align",
        "appearance",
        "bold",
        "className",
        "color",
        "display",
        "responsive",
        "strikethrough",
        "weight"
    ]), N = (0, $1SA7b.default)(b, ($640eda379290a46d$var$e(n = {}, "text-align-".concat(c), "inherit" !== c), $640eda379290a46d$var$e(n, "appearance-".concat(d), !0), $640eda379290a46d$var$e(n, "bold", y), $640eda379290a46d$var$e(n, "color-".concat(v), !0), $640eda379290a46d$var$e(n, "display-".concat(m), "initial" !== m), $640eda379290a46d$var$e(n, "weight-".concat(P), !0), $640eda379290a46d$var$e(n, "responsive", O), $640eda379290a46d$var$e(n, "strikethrough", j), n)), C = l || $640eda379290a46d$var$t[d];
    return C || (C = "p"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(C, Object.assign({
        className: N
    }, k));
};

});


parcelRegister("eOXBH", function(module, exports) {

$parcel$export(module.exports, "DialogCloseButton", () => $aca3f8f14710a900$export$ac986cda6a87f93c);

var $acw62 = parcelRequire("acw62");

var $142Bi = parcelRequire("142Bi");
var $aca3f8f14710a900$var$e = undefined && undefined.__rest || function(e, o) {
    var t, r = {};
    for(var l in e)Object.prototype.hasOwnProperty.call(e, l) && o.indexOf(l) < 0 && (r[l] = e[l]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(t = 0, l = Object.getOwnPropertySymbols(e); t < l.length; t++)o.indexOf(l[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[t]) && (r[l[t]] = e[l[t]]);
    return r;
};
var $aca3f8f14710a900$export$ac986cda6a87f93c = function(r) {
    var l = r.dialogCloseAriaLabel, a = void 0 === l ? "Close Dialog" : l, i = r.onClick, n = r.className, s = void 0 === n ? "dialog-ui-close" : n, c = r.DialogCloseButtonCompProps, p = $aca3f8f14710a900$var$e(r, [
        "dialogCloseAriaLabel",
        "onClick",
        "className",
        "DialogCloseButtonCompProps"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        className: s,
        "aria-label": a,
        onClick: i
    }, c, p), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $142Bi.Close), {
        "aria-hidden": !0
    }));
};

});

parcelRegister("h1B2D", function(module, exports) {

$parcel$export(module.exports, "useTokens", () => $0332d3aa91d4de24$export$7c008f4adb925d9f);
$parcel$export(module.exports, "useIsRightToLeft", () => $0332d3aa91d4de24$export$1b9724e3bc483210);

var $acw62 = parcelRequire("acw62");

var $4B7Xs = parcelRequire("4B7Xs");

var $2cX3O = parcelRequire("2cX3O");

var $axTTc = parcelRequire("axTTc");

var $5FmI4 = parcelRequire("5FmI4");

var $5vEzr = parcelRequire("5vEzr");

function $0332d3aa91d4de24$var$t(t, e) {
    return function(t) {
        if (Array.isArray(t)) return t;
    }(t) || function(t, r) {
        var e = t && ("undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"]);
        if (null == e) return;
        var n, o, i = [], a = !0, u = !1;
        try {
            for(e = e.call(t); !(a = (n = e.next()).done) && (i.push(n.value), !r || i.length !== r); a = !0);
        } catch (t) {
            u = !0, o = t;
        } finally{
            try {
                a || null == e.return || e.return();
            } finally{
                if (u) throw o;
            }
        }
        return i;
    }(t, e) || function(t, e) {
        if (!t) return;
        if ("string" == typeof t) return $0332d3aa91d4de24$var$r(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0332d3aa91d4de24$var$r(t, e);
    }(t, e) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $0332d3aa91d4de24$var$r(t, r) {
    var e, n;
    for((null == r || r > t.length) && (r = t.length), e = 0, n = new Array(r); e < r; e++)n[e] = t[e];
    return n;
}
var $0332d3aa91d4de24$export$7c008f4adb925d9f = function() {
    var t;
    return null !== (t = (0, $acw62.useContext)((0, $4B7Xs.DSContext)).tokens) && void 0 !== t ? t : {};
};
var $0332d3aa91d4de24$export$199d6754bdf4e1e3 = function(t, r) {
    var e = $0332d3aa91d4de24$export$7c008f4adb925d9f();
    if (!r) return "";
    var n = e["breakpoint".concat((0, $2cX3O.capitalize)(r))];
    if (!n) return "";
    var o = parseInt(n, 10), i = {
        lt: o - 1,
        lte: o,
        gte: o,
        gt: o + 1
    }, a = {
        lt: "max-width",
        lte: "max-width",
        gte: "min-width",
        gt: "min-width"
    };
    return a[t] && i[t] ? "@media (".concat(String(a[t]), ": ").concat(String(i[t]), "px)") : "";
};
var $0332d3aa91d4de24$export$dd42f485803cd57d = function() {
    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, a = e.defaultMatch, u = void 0 !== a && a, s = !(!(0, $axTTc.hasWindow)() || !window.matchMedia), l = (0, $acw62.useMemo)(function() {
        return s ? window.matchMedia("string" == typeof r ? r.replace("@media", "").trim() : "") : {
            matches: u
        };
    }, [
        u,
        s,
        r
    ]), d = (0, $acw62.useState)(l.matches), f = $0332d3aa91d4de24$var$t(d, 2), m = f[0], p = f[1];
    return (0, $acw62.useEffect)(function() {
        if (s) {
            var t = function(t) {
                p(t.matches);
            };
            return p(l.matches), l.addListener(t), function() {
                return l.removeListener(t);
            };
        }
    }, [
        l,
        s
    ]), m;
};
var $0332d3aa91d4de24$export$53c3d779b8224825 = function() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return !$0332d3aa91d4de24$export$dd42f485803cd57d("(hover: none)", t);
};
var $0332d3aa91d4de24$export$4630e5ff877d08 = function() {
    var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "polite";
    return {
        "aria-busy": t,
        "aria-live": r
    };
};
var $0332d3aa91d4de24$export$1b9724e3bc483210 = function(t) {
    return "undefined" != typeof document && ("rtl" === document.documentElement.getAttribute("dir") || (0, $5FmI4.doParentNodesContainAttributeValue)(t, "dir", "rtl"));
};

});
parcelRegister("2cX3O", function(module, exports) {

$parcel$export(module.exports, "capitalize", () => $19ba83ee1dcaa851$export$9a00dee1beb8f576);
var $19ba83ee1dcaa851$export$15590da2024ee831 = function(t) {
    return "--".concat(t.split("").map(function(t) {
        return t === t.toUpperCase() ? "-".concat(t.toLowerCase()) : t;
    }).join(""));
};
var $19ba83ee1dcaa851$export$9a00dee1beb8f576 = function(t) {
    return "string" != typeof t ? t : t[0] ? t[0].toUpperCase() + t.slice(1) : t;
};

});

parcelRegister("5FmI4", function(module, exports) {

$parcel$export(module.exports, "doParentNodesContainAttributeValue", () => $420265c47cd4e45c$export$23dd770ec486bc8c);
$parcel$export(module.exports, "getScrollPosition", () => $420265c47cd4e45c$export$3abe133d5501edeb);
$parcel$export(module.exports, "getLocalizedRemainingMessage", () => $420265c47cd4e45c$export$56b167c20d4e7865);

var $420265c47cd4e45c$var$t = function(e) {
    return (e.parentElement ? $420265c47cd4e45c$var$t(e.parentElement) : []).concat([
        e
    ]);
};
var $420265c47cd4e45c$export$23dd770ec486bc8c = function(e, n, r) {
    var o = document.querySelector(e);
    return !!o && $420265c47cd4e45c$var$t(o).some(function(e) {
        var t, o;
        return t = n, o = r, e.getAttribute(t) === o;
    });
};
var $420265c47cd4e45c$export$2355d347cbd7b8f2 = function() {
    var e, t = window.navigator.userAgent, n = null !== (e = /iPad/i.exec(t)) && void 0 !== e ? e : /iPhone/i.exec(t), r = /WebKit/i.exec(t);
    return Boolean(n && r && !/CriOS/i.exec(t));
};
var $420265c47cd4e45c$export$3abe133d5501edeb = function() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};
var $420265c47cd4e45c$export$56b167c20d4e7865 = function(e, t, n, r) {
    return e && r && n && t ? e.replace("{charsRemaining}", t.toString()).replace("{num}", n.toString()).replace("{max}", r.toString()) : "";
};

});



parcelRegister("edU4P", function(module, exports) {

$parcel$export(module.exports, "DialogBaseStyled", () => $a5adc7478989d38a$export$da3fec8d4e152d0a);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");

var $39sFt = parcelRequire("39sFt");

var $dHNfQ = parcelRequire("dHNfQ");

var $i3Btf = parcelRequire("i3Btf");

var $akuCx = parcelRequire("akuCx");
var $a5adc7478989d38a$var$m = {
    BackdropComp: (0, $i3Btf.BackdropStyled),
    DialogContainerComp: (0, $akuCx.DialogContainerStyled)
};
var $a5adc7478989d38a$export$5e997205aec8693a = function(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $39sFt.DialogBase), Object.assign({}, o, $a5adc7478989d38a$var$m));
};
var $a5adc7478989d38a$export$da3fec8d4e152d0a = (0, $1poQt.default)($a5adc7478989d38a$export$5e997205aec8693a, {
    target: "ewzu9hy0"
})((0, $dHNfQ.baseStyles));

});
parcelRegister("dHNfQ", function(module, exports) {

$parcel$export(module.exports, "baseStyles", () => $9fa57f719272acd7$export$6a08aa478781aaec);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");
var $9fa57f719272acd7$export$6a08aa478781aaec = function(t) {
    var r = t.theme, i = t.appearance, e = r.colorBackgroundPrimary, n = r.sizeBorderRadiusXl, o = r.transitionDurationNormal, d = r.transitionTimingFunctionEase, s = r.breakpointS;
    return (0, $6xSYO.default)((0, $6xSYO.default)("position:absolute;left:0;width:100%;background:", e, ";min-height:300px;bottom:0;transform:translate3d(0,0,0);overflow:hidden;@media (min-width:", s, "){bottom:auto;top:50%;left:50%;transform:translate3d(-50%,-50%,0);}"), ";", function() {
        if ("fullscreen" !== i) return (0, $6xSYO.default)("max-height:calc(100% - 60px);border-radius:", n, " ", n, " 0 0;@media (min-width:", s, "){border-radius:", n, ";max-width:560px;max-height:calc(100% - 120px);}");
    }(), ";", (0, $6xSYO.default)(".dialog-enter &,.dialog-appear &{transform:translate3d(0,100%,0);}.dialog-enter-active &,.dialog-appear-active &{transform:translate3d(0,0,0);transition:transform ", o, " ", d, ";}.dialog-exit &{transform:translate3d(0,0,0);}.dialog-exit-active &{transform:translate3d(0,100%,0);transition:transform ", o, " ", d, ";}@media (min-width:", s, "){.dialog-enter &,.dialog-appear &{transform:translate3d(-50%,-45%,0);}.dialog-enter-active &,.dialog-appear-active &{transform:translate3d(-50%,-50%,0);transition:transform ", o, " ", d, ";}.dialog-exit &{transform:translate3d(-50%,-50%,0);}.dialog-exit-active &{transform:translate3d(-50%,-45%,0);transition:transform ", o, " ", d, ";}}"), ";");
};

});

parcelRegister("i3Btf", function(module, exports) {

$parcel$export(module.exports, "BackdropStyled", () => $d25592b3c3de5c83$export$75e5d0f152ddc28a);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $dwbPi = parcelRequire("dwbPi");

var $7GaV5 = parcelRequire("7GaV5");
var $d25592b3c3de5c83$var$r = function(o) {
    var i = o.theme, r = i.transitionDurationNormal, e = i.colorBackgroundAlwaysDark, c = i.dialogBackgroundBlur, l = i.elevation100;
    return (0, $6xSYO.default)("position:fixed;top:0;left:0;right:0;bottom:0;height:100%;width:100%;background-color:", (0, $7GaV5.hexToCssRgba)(e, .4), ";backdrop-filter:blur(", c, ");z-index:", l, ";.dialog-enter &,.dialog-appear &{opacity:0;}.dialog-enter-active &,.dialog-appear-active &{opacity:1;transition:opacity ", r, ";}.dialog-exit &{opacity:1;}.dialog-exit-active &{opacity:0;transition:opacity ", r, ";}");
};
var $d25592b3c3de5c83$export$75e5d0f152ddc28a = (0, $1poQt.default)((0, $dwbPi.Backdrop), {
    target: "e1mocx0m0"
})($d25592b3c3de5c83$var$r);

});

parcelRegister("akuCx", function(module, exports) {

$parcel$export(module.exports, "DialogContainerStyled", () => $7853863e076e5974$export$5c93f88b6357c566);

var $1poQt = parcelRequire("1poQt");

var $gcy1x = parcelRequire("gcy1x");

var $kdu4d = parcelRequire("kdu4d");
var $7853863e076e5974$export$5c93f88b6357c566 = (0, $1poQt.default)((0, $gcy1x.DialogContainer), {
    target: "e1yn52e40"
})((0, $kdu4d.containerStyles));

});
parcelRegister("kdu4d", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $eb7c583aaf147a4b$export$5972a68b6e54f38f);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $7GaV5 = parcelRequire("7GaV5");
var $eb7c583aaf147a4b$export$5972a68b6e54f38f = function(t) {
    var o = t.theme, n = t.appearance, r = o.sizeSpacingL, a = o.sizeSpacingXl, l = o.colorBackgroundPrimary, c = o.breakpointS, h = o.breakpointM;
    return (0, $6xSYO.default)((0, $6xSYO.default)("width:100%;max-height:100vh;min-height:300px;height:100%;padding:40px ", r, " ", r, " ", r, ";overflow:auto;-webkit-overflow-scrolling:touch;::-webkit-scrollbar{display:none;}scrollbar-width:none;-ms-overflow-style:none;@media (min-width:", c, "){height:100%;padding:48px 64px ", a, " 64px;}"), ";", function() {
        if ("fullscreen" !== n) return (0, $6xSYO.default)("overflow:auto;-webkit-overflow-scrolling:touch;max-height:calc(100vh - 60px);@media (min-width:", c, '){max-height:calc(100vh - 120px);}display:flex;flex-direction:column;justify-content:space-between;&:before{content:"";display:block;position:absolute;top:0;left:0;width:100%;height:36px;z-index:1;background:', l, ";background:linear-gradient( to bottom,", (0, $7GaV5.hexToCssRgba)(l, 1), " 0%,", (0, $7GaV5.hexToCssRgba)(l, 1), " 33%,", (0, $7GaV5.hexToCssRgba)(l, 0), " 100% );}");
    }(), ";", function() {
        if ("fullscreen" === n) return (0, $6xSYO.default)("width:100%;margin-left:auto;margin-right:auto;@media (min-width:", h, "){width:66.66666666666666%;}");
    }(), ";");
};

});



parcelRegister("iEnuB", function(module, exports) {

$parcel$export(module.exports, "DialogHeaderStyled", () => $d93e2f94fd3ee9dd$export$6a2778aa7955f39b);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");

var $8ikqj = parcelRequire("8ikqj");

var $bmifP = parcelRequire("bmifP");
var $d93e2f94fd3ee9dd$export$a6e357f8ad222435 = function(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8ikqj.DialogHeader), Object.assign({}, e));
};
var $d93e2f94fd3ee9dd$export$6a2778aa7955f39b = (0, $1poQt.default)($d93e2f94fd3ee9dd$export$a6e357f8ad222435, {
    target: "ekhkh950"
})((0, $bmifP.baseStyles));

});
parcelRegister("bmifP", function(module, exports) {

$parcel$export(module.exports, "baseStyles", () => $844fe8b1283eaf80$export$6a08aa478781aaec);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");
var $844fe8b1283eaf80$export$6a08aa478781aaec = function(o) {
    var t = o.theme, p = t.sizeSpacingXl, e = t.typographyHeading3, n = t.typographyBody2, r = t.sizeSpacingXs;
    return (0, $6xSYO.default)("width:100%;padding-bottom:", p, ";padding-right:48px;padding-top:", r, ";", e, " .icon-wrapper{font-size:", n.fontSize, ";}");
};

});


parcelRegister("2jD6S", function(module, exports) {

$parcel$export(module.exports, "DialogContentStyled", () => $1afbb1878f36d678$export$316f6dc85823e26);

var $1poQt = parcelRequire("1poQt");

var $9Yg6e = parcelRequire("9Yg6e");
var $1afbb1878f36d678$export$316f6dc85823e26 = (0, $1poQt.default)("div", {
    target: "e4rebre0"
})((0, $9Yg6e.baseStyles));

});
parcelRegister("9Yg6e", function(module, exports) {

$parcel$export(module.exports, "baseStyles", () => $742634ab3601d4e6$export$6a08aa478781aaec);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");
var $742634ab3601d4e6$export$6a08aa478781aaec = function(e) {
    var i = e.theme, o = i.typographyBody2, r = i.typographyBody1, a = i.breakpointS, n = i.sizeSpacingS;
    return (0, $6xSYO.default)(o, " line-height:", r.lineHeight, ";width:100%;@media (max-width:", a, "){padding-bottom:", n, ";}");
};

});


parcelRegister("klCNo", function(module, exports) {

$parcel$export(module.exports, "DialogMainStyled", () => $ed03dcd1cdbbfbdb$export$609aabb16859f7d);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");
var $ed03dcd1cdbbfbdb$export$6a08aa478781aaec = function(e) {
    var r = e.theme, t = e.appearance, l = r.breakpointS;
    return (0, $6xSYO.default)("overflow:scroll;@media (max-width:", l, "){max-height:", "fullscreen" !== t ? "50vh" : null, ";}-webkit-overflow-scrolling:touch;::-webkit-scrollbar{display:none;}scrollbar-width:none;-ms-overflow-style:none;");
};
var $ed03dcd1cdbbfbdb$export$609aabb16859f7d = (0, $1poQt.default)("div", {
    target: "e16f1y9y0"
})($ed03dcd1cdbbfbdb$export$6a08aa478781aaec);

});

parcelRegister("9bXpj", function(module, exports) {

$parcel$export(module.exports, "DialogCloseButtonStyled", () => $6b1339306d1f190d$export$f3231d226efbfb5d);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");

var $eOXBH = parcelRequire("eOXBH");

var $dJ51a = parcelRequire("dJ51a");
var $6b1339306d1f190d$export$8f8069f9a07d4bee = function(o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $eOXBH.DialogCloseButton), Object.assign({}, o));
};
var $6b1339306d1f190d$export$f3231d226efbfb5d = (0, $1poQt.default)($6b1339306d1f190d$export$8f8069f9a07d4bee, {
    target: "egyxy7o0"
})((0, $dJ51a.baseStyles));

});
parcelRegister("dJ51a", function(module, exports) {

$parcel$export(module.exports, "baseStyles", () => $9fe35ec470b1da83$export$6a08aa478781aaec);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");
var $9fe35ec470b1da83$export$6a08aa478781aaec = function(r) {
    var i = r.theme, t = i.colorContentPrimary, n = i.paletteGrey4, o = i.sizeSpacingS, a = i.breakpointS, l = r.appearance;
    return (0, $6xSYO.default)("display:inline-block;margin:", "fullscreen" === l ? o : 0, ";line-height:1;z-index:1;width:36px;height:36px;background:", n, ";border-radius:50%;border-width:0;svg{color:", t, ";position:absolute;transform:translate(-50%,-50%);}@media (min-width:", a, "){margin:0;}");
};

});


parcelRegister("9iiQA", function(module, exports) {

$parcel$export(module.exports, "visuallyHidden", () => $6c446a2d262ee055$export$a1b3edb637fb4f35);
$parcel$export(module.exports, "onlyIE", () => $6c446a2d262ee055$export$aaebc19301446d1e);
$parcel$export(module.exports, "onlyMoz", () => $6c446a2d262ee055$export$aa9c2363e1ea6bfd);
$parcel$export(module.exports, "onlySafari10Plus", () => $6c446a2d262ee055$export$f49f66bcf56aabaa);
$parcel$export(module.exports, "pointerFine", () => $6c446a2d262ee055$export$447a4619f9a574d0);
$parcel$export(module.exports, "pointerCourse", () => $6c446a2d262ee055$export$cdefc43e01ba68ef);
var $6c446a2d262ee055$export$a1b3edb637fb4f35 = {
    position: "absolute",
    left: "-2000px",
    fontSize: "0",
    width: "0",
    height: "0",
    overflow: "hidden",
    visibility: "hidden"
};
var $6c446a2d262ee055$export$aaebc19301446d1e = "@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)";
var $6c446a2d262ee055$export$cb4183c4b131c6a3 = "@media screen and (-webkit-min-device-pixel-ratio:0)";
var $6c446a2d262ee055$export$aa9c2363e1ea6bfd = "@-moz-document url-prefix()";
var $6c446a2d262ee055$export$b6a4e3c2b2015014 = "@supports (-ms-ime-align:auto)";
var $6c446a2d262ee055$export$f49f66bcf56aabaa = "@media not all and (min-resolution: 0.001dpcm)";
var $6c446a2d262ee055$export$447a4619f9a574d0 = "@media (pointer: fine)";
var $6c446a2d262ee055$export$cdefc43e01ba68ef = "@media (pointer: coarse)";

});




parcelRegister("9NEcE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $7227e01f8b141628$export$1e511d4a378977f5, (v) => $7227e01f8b141628$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7227e01f8b141628$export$2e2bcd8739ae039, (v) => $7227e01f8b141628$export$2e2bcd8739ae039 = v);
var $7227e01f8b141628$export$1e511d4a378977f5;
var $7227e01f8b141628$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$7227e01f8b141628$export$1e511d4a378977f5 = true;
$7227e01f8b141628$export$2e2bcd8739ae039 = void 0;

var $fr6za = parcelRequire("fr6za");

var $7227e01f8b141628$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $7227e01f8b141628$var$_react = $1jnue((parcelRequire("acw62")));

var $7227e01f8b141628$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $7227e01f8b141628$var$_ContentLoads = $1jnue((parcelRequire("bploO")));

var $7227e01f8b141628$var$_Messages = $1jnue((parcelRequire("eUNP9")));
const $7227e01f8b141628$var$ButtonSubmit = ({ buttonClassName: buttonClassName, isDisabled: isDisabled, isSubmitting: isSubmitting, label: label, messageError: messageError, messageSuccess: messageSuccess, onSubmit: onSubmit, sectionClassName: sectionClassName })=>{
    const translate = (0, $7227e01f8b141628$var$_useTranslate.default)();
    return /*#__PURE__*/ $7227e01f8b141628$var$_react.default.createElement($7227e01f8b141628$var$_ContentLoads.default, {
        isLoading: isSubmitting
    }, /*#__PURE__*/ $7227e01f8b141628$var$_react.default.createElement("section", {
        className: sectionClassName
    }, /*#__PURE__*/ $7227e01f8b141628$var$_react.default.createElement($fr6za.ButtonStyled, {
        ariaLabel: label,
        className: buttonClassName,
        disabled: isDisabled,
        size: "large",
        type: "button",
        onClick: onSubmit
    }, label || translate("RL_Submit")), /*#__PURE__*/ $7227e01f8b141628$var$_react.default.createElement($7227e01f8b141628$var$_Messages.default, {
        error: messageError,
        success: messageSuccess
    })));
};
$7227e01f8b141628$var$ButtonSubmit.defaultProps = {
    buttonClassName: "mb2-sm",
    isDisabled: false,
    isSubmitting: false,
    label: null,
    messageError: "",
    messageSuccess: "",
    sectionClassName: "ncss-col-sm-12 full"
};
$7227e01f8b141628$var$ButtonSubmit.propTypes = {
    buttonClassName: $7227e01f8b141628$var$_propTypes.default.string,
    isDisabled: $7227e01f8b141628$var$_propTypes.default.bool,
    isSubmitting: $7227e01f8b141628$var$_propTypes.default.bool,
    label: $7227e01f8b141628$var$_propTypes.default.string,
    messageError: $7227e01f8b141628$var$_propTypes.default.string,
    messageSuccess: $7227e01f8b141628$var$_propTypes.default.string,
    onSubmit: $7227e01f8b141628$var$_propTypes.default.func.isRequired,
    sectionClassName: $7227e01f8b141628$var$_propTypes.default.string
};
var $7227e01f8b141628$var$_default = $7227e01f8b141628$export$2e2bcd8739ae039 = $7227e01f8b141628$var$ButtonSubmit;

});
parcelRegister("bploO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $84e2a0ed485c39e2$export$1e511d4a378977f5, (v) => $84e2a0ed485c39e2$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $84e2a0ed485c39e2$export$2e2bcd8739ae039, (v) => $84e2a0ed485c39e2$export$2e2bcd8739ae039 = v);
var $84e2a0ed485c39e2$export$1e511d4a378977f5;
var $84e2a0ed485c39e2$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$84e2a0ed485c39e2$export$1e511d4a378977f5 = true;
$84e2a0ed485c39e2$export$2e2bcd8739ae039 = void 0;

var $84e2a0ed485c39e2$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $84e2a0ed485c39e2$var$_react = $1jnue((parcelRequire("acw62")));

var $84e2a0ed485c39e2$var$_LoadingIndicator = $1jnue((parcelRequire("8hUZb")));
// eslint-disable-next-line no-nested-ternary
const $84e2a0ed485c39e2$var$ContentLoads = ({ children: children, error: error, isLoading: isLoading })=>isLoading ? /*#__PURE__*/ $84e2a0ed485c39e2$var$_react.default.createElement($84e2a0ed485c39e2$var$_LoadingIndicator.default, null) : error ? /*#__PURE__*/ $84e2a0ed485c39e2$var$_react.default.createElement("h5", {
        className: "body-4 text-color-error"
    }, error) : children;
$84e2a0ed485c39e2$var$ContentLoads.defaultProps = {
    error: ""
};
$84e2a0ed485c39e2$var$ContentLoads.propTypes = {
    children: $84e2a0ed485c39e2$var$_propTypes.default.node.isRequired,
    error: $84e2a0ed485c39e2$var$_propTypes.default.string,
    isLoading: $84e2a0ed485c39e2$var$_propTypes.default.bool.isRequired
};
var $84e2a0ed485c39e2$var$_default = $84e2a0ed485c39e2$export$2e2bcd8739ae039 = $84e2a0ed485c39e2$var$ContentLoads;

});
parcelRegister("8hUZb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $608c1d743287d953$export$1e511d4a378977f5, (v) => $608c1d743287d953$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $608c1d743287d953$export$2e2bcd8739ae039, (v) => $608c1d743287d953$export$2e2bcd8739ae039 = v);
var $608c1d743287d953$export$1e511d4a378977f5;
var $608c1d743287d953$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$608c1d743287d953$export$1e511d4a378977f5 = true;
$608c1d743287d953$export$2e2bcd8739ae039 = void 0;

var $2SFa8 = parcelRequire("2SFa8");

var $608c1d743287d953$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $608c1d743287d953$var$_react = $1jnue((parcelRequire("acw62")));

const $608c1d743287d953$var$LoadingIndicator = ({ className: className })=>/*#__PURE__*/ $608c1d743287d953$var$_react.default.createElement("div", {
        className: `rcf-loader-container ${className}`
    }, /*#__PURE__*/ $608c1d743287d953$var$_react.default.createElement($2SFa8.Loading, {
        className: "rcf-loader mt12-sm mb12-sm",
        size: "l",
        title: "loading indicator"
    }));
$608c1d743287d953$var$LoadingIndicator.defaultProps = {
    className: ""
};
$608c1d743287d953$var$LoadingIndicator.propTypes = {
    className: $608c1d743287d953$var$_propTypes.default.string
};
var $608c1d743287d953$var$_default = $608c1d743287d953$export$2e2bcd8739ae039 = $608c1d743287d953$var$LoadingIndicator;

});
parcelRegister("2SFa8", function(module, exports) {

$parcel$export(module.exports, "Loading", () => $21908deaeb7558f8$export$669f6ea7d267feaf);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $21908deaeb7558f8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $21908deaeb7558f8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $21908deaeb7558f8$var$_typeof(o);
}
function $21908deaeb7558f8$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21908deaeb7558f8$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21908deaeb7558f8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $21908deaeb7558f8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21908deaeb7558f8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $21908deaeb7558f8$var$_defineProperty(obj, key, value) {
    key = $21908deaeb7558f8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21908deaeb7558f8$var$_toPropertyKey(t) {
    var i = $21908deaeb7558f8$var$_toPrimitive(t, "string");
    return "symbol" == $21908deaeb7558f8$var$_typeof(i) ? i : String(i);
}
function $21908deaeb7558f8$var$_toPrimitive(t, r) {
    if ("object" != $21908deaeb7558f8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $21908deaeb7558f8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $21908deaeb7558f8$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
        clipRule: "evenodd",
        opacity: ".2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M12 2.25A9.75 9.75 0 0121.75 12"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M21.75 12A9.75 9.75 0 0112 21.75 9.75 9.75 0 012.25 12 9.75 9.75 0 0112 2.25 9.75 9.75 0 0121.75 12z",
        clipRule: "evenodd",
        opacity: ".2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M12 2.25A9.75 9.75 0 0121.75 12"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M43.5 24c0 10.77-8.73 19.5-19.5 19.5S4.5 34.77 4.5 24 13.23 4.5 24 4.5 43.5 13.23 43.5 24z",
        clipRule: "evenodd",
        opacity: ".2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M24 4.5c10.77 0 19.5 8.73 19.5 19.5"
    }))
};
var $21908deaeb7558f8$export$669f6ea7d267feaf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $21908deaeb7558f8$var$_objectSpread($21908deaeb7558f8$var$_objectSpread({}, props), {}, {
        paths: $21908deaeb7558f8$var$compPaths,
        fill: "none"
    }));
});

});



parcelRegister("eUNP9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $adbcf1acfae20007$export$1e511d4a378977f5, (v) => $adbcf1acfae20007$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $adbcf1acfae20007$export$2e2bcd8739ae039, (v) => $adbcf1acfae20007$export$2e2bcd8739ae039 = v);
var $adbcf1acfae20007$export$1e511d4a378977f5;
var $adbcf1acfae20007$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$adbcf1acfae20007$export$1e511d4a378977f5 = true;
$adbcf1acfae20007$export$2e2bcd8739ae039 = void 0;

var $adbcf1acfae20007$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $adbcf1acfae20007$var$_react = $1jnue((parcelRequire("acw62")));
const $adbcf1acfae20007$var$Messages = ({ className: className, success: success, error: error })=>/*#__PURE__*/ $adbcf1acfae20007$var$_react.default.createElement("div", {
        className: className
    }, /*#__PURE__*/ $adbcf1acfae20007$var$_react.default.createElement("p", {
        className: "ta-sm-c text-color-success body-4"
    }, success), error.split(" ** ").map((err)=>/*#__PURE__*/ $adbcf1acfae20007$var$_react.default.createElement("p", {
            key: err,
            className: "ta-sm-c text-color-error body-4"
        }, err)));
$adbcf1acfae20007$var$Messages.defaultProps = {
    className: "",
    error: "",
    success: ""
};
$adbcf1acfae20007$var$Messages.propTypes = {
    className: $adbcf1acfae20007$var$_propTypes.default.string,
    error: $adbcf1acfae20007$var$_propTypes.default.string,
    success: $adbcf1acfae20007$var$_propTypes.default.string
};
var $adbcf1acfae20007$var$_default = $adbcf1acfae20007$export$2e2bcd8739ae039 = $adbcf1acfae20007$var$Messages;

});


parcelRegister("fwrhT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $b4cf02edcbc9af59$export$1e511d4a378977f5, (v) => $b4cf02edcbc9af59$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $b4cf02edcbc9af59$export$2e2bcd8739ae039, (v) => $b4cf02edcbc9af59$export$2e2bcd8739ae039 = v);
var $b4cf02edcbc9af59$export$1e511d4a378977f5;
var $b4cf02edcbc9af59$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$b4cf02edcbc9af59$export$1e511d4a378977f5 = true;
$b4cf02edcbc9af59$export$2e2bcd8739ae039 = void 0;

var $hwhVv = parcelRequire("hwhVv");

var $e080M = parcelRequire("e080M");

var $b4cf02edcbc9af59$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $b4cf02edcbc9af59$var$_react = $b4cf02edcbc9af59$var$_interopRequireWildcard((parcelRequire("acw62")));

var $b4cf02edcbc9af59$var$_creatable = $1jnue((parcelRequire("fcvsF")));

var $b4cf02edcbc9af59$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $6zLPD = parcelRequire("6zLPD");
function $b4cf02edcbc9af59$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($b4cf02edcbc9af59$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $b4cf02edcbc9af59$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $b4cf02edcbc9af59$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $b4cf02edcbc9af59$var$checkRegex = (label, value, translate)=>{
    // if isMulti, only validate the last value (the new one)
    const code = Array.isArray(value) ? value[(value === null || value === void 0 ? void 0 : value.length) - 1] : value;
    // allow for a clearable form (isRequired will still mark an error)
    if (!code) return "";
    return (0, $e080M.match)(label)([
        "GTIN",
        (0, $6zLPD.isGTIN)(code.value) ? "" : translate("RL_GTINValidation")
    ], [
        "Style Color",
        (0, $6zLPD.isStyleColor)(code.value) ? "" : translate("RL_StyleColorValidation")
    ], [
        $e080M.Default,
        ""
    ]);
};
const $b4cf02edcbc9af59$var$isTooManyCodes = (value, maxValues)=>{
    // if not isMulti, we're fine because we'll only ever have 0 or 1 code
    // we are also fine if there are undefined or 0 values
    if (!Array.isArray(value) || !value || !value.length) return false;
    return value.length > maxValues;
};
const $b4cf02edcbc9af59$var$Creatable = ({ errorMessage: errorMessage, isDisabled: isDisabled, isMulti: isMulti, isRequired: isRequired, label: label, maxValues: maxValues, onChange: onChange, value: value, zIndex: zIndex })=>{
    const [regexMessage, setRegexMessage] = (0, $b4cf02edcbc9af59$var$_react.useState)("");
    const translate = (0, $b4cf02edcbc9af59$var$_useTranslate.default)();
    (0, $b4cf02edcbc9af59$var$_react.useEffect)(()=>{
        const errorRegex = $b4cf02edcbc9af59$var$checkRegex(label, value, translate);
        const isTooMany = isMulti && maxValues && $b4cf02edcbc9af59$var$isTooManyCodes(value, maxValues);
        setRegexMessage(errorRegex || isTooMany ? translate("RL_CodesValidation", maxValues) : "");
    }, [
        value,
        isMulti,
        maxValues,
        label,
        translate
    ]);
    return /*#__PURE__*/ $b4cf02edcbc9af59$var$_react.default.createElement("article", {
        className: "nds-input-layout-control"
    }, /*#__PURE__*/ $b4cf02edcbc9af59$var$_react.default.createElement($hwhVv.LabelStyled, {
        className: `nds-input-label ${(isMulti ? value === null || value === void 0 ? void 0 : value.length : value) ? "z2" : "z0"} ml1-sm pl1-sm mr1-sm pr1-sm pb2-sm bg-white`,
        error: isRequired && (isMulti ? !(value !== null && value !== void 0 && value.length) : !(value !== null && value !== void 0 && value.value)) || regexMessage || errorMessage,
        htmlFor: label,
        id: label,
        isActive: isMulti ? value === null || value === void 0 ? void 0 : value.length : value,
        requiredIndicator: isRequired ? "*" : undefined,
        value: `${label}`
    }), /*#__PURE__*/ $b4cf02edcbc9af59$var$_react.default.createElement($b4cf02edcbc9af59$var$_creatable.default, {
        isClearable: true,
        arrowRenderer: null,
        className: "nds-input-text-field",
        components: {
            DropdownIndicator: null
        },
        id: label,
        isActive: isMulti ? value === null || value === void 0 ? void 0 : value.length : value,
        isDisabled: isDisabled,
        isMulti: isMulti,
        noOptionsMessage: ()=>null,
        placeholder: `${label}${isRequired ? "*" : ""}`,
        styles: {
            container: (styles)=>({
                    ...styles,
                    minHeight: "60px",
                    zIndex: zIndex
                }),
            control: (styles)=>({
                    ...styles,
                    borderColor: isRequired && (isMulti ? !(value !== null && value !== void 0 && value.length) : !(value !== null && value !== void 0 && value.value)) || regexMessage || errorMessage ? "#D43F21" : "lightgrey",
                    minHeight: "60px",
                    padding: "0px 0px 0px 3px",
                    zIndex: zIndex
                })
        },
        value: value,
        onChange: (newValue)=>onChange(newValue)
    }), /*#__PURE__*/ $b4cf02edcbc9af59$var$_react.default.createElement("p", {
        className: "text-color-error body-4 mb2-sm"
    }, regexMessage || errorMessage));
};
$b4cf02edcbc9af59$var$Creatable.defaultProps = {
    errorMessage: "",
    isDisabled: false,
    isMulti: false,
    isRequired: false,
    // only use this if isMulti (therefore also do not set this to 1)
    maxValues: 0,
    value: null,
    zIndex: 1
};
$b4cf02edcbc9af59$var$Creatable.propTypes = {
    errorMessage: $b4cf02edcbc9af59$var$_propTypes.default.string,
    isDisabled: $b4cf02edcbc9af59$var$_propTypes.default.bool,
    isMulti: $b4cf02edcbc9af59$var$_propTypes.default.bool,
    isRequired: $b4cf02edcbc9af59$var$_propTypes.default.bool,
    label: $b4cf02edcbc9af59$var$_propTypes.default.string.isRequired,
    maxValues: $b4cf02edcbc9af59$var$_propTypes.default.number,
    onChange: $b4cf02edcbc9af59$var$_propTypes.default.func.isRequired,
    value: $b4cf02edcbc9af59$var$_propTypes.default.oneOfType([
        $b4cf02edcbc9af59$var$_propTypes.default.arrayOf($b4cf02edcbc9af59$var$_propTypes.default.shape()),
        $b4cf02edcbc9af59$var$_propTypes.default.shape()
    ]),
    zIndex: $b4cf02edcbc9af59$var$_propTypes.default.number
};
var $b4cf02edcbc9af59$var$_default = $b4cf02edcbc9af59$export$2e2bcd8739ae039 = $b4cf02edcbc9af59$var$Creatable;

});
parcelRegister("hwhVv", function(module, exports) {

$parcel$export(module.exports, "LabelStyled", () => $cc1354a6c3a64281$export$b1e5c588ff7cd906);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $a4jPb = parcelRequire("a4jPb");

var $9iiQA = parcelRequire("9iiQA");
var $cc1354a6c3a64281$var$e = function(t) {
    var r = t.theme, e = t.error, i = void 0 !== e && e, a = t.isActive, s = void 0 !== a && a, l = r.typographyBody2, p = r.transitionTimingFunctionEase, m = r.transitionDurationNormal, c = r.colorContentError, f = r.colorContentSecondary, d = r.sizeSpacingS, g = r.sizeSpacingXs, y = r.breakpointS;
    return (0, $6xSYO.default)("position:absolute;padding:0 ", g, ";left:", d, ";top:16px;font-family:", l.fontFamily, ";font-size:", l.fontSize, ";user-select:none;line-height:", s ? "16px" : l.lineHeight, ";transform:", s ? "scale(0.75) translateY(-32px)" : "scale(1)", ";transform-origin:left;will-change:transform;transition-property:transform;transition-duration:", m, ";transition-timing-function:", p, ";color:", i ? c : f, ';pointer-events:none;[dir="rtl"] &{right:', s ? "0px" : d, ";left:0px;transform:", s ? "scale(0.75) translate(75px, -32px)" : "scale(1)", ";", (0, $9iiQA.pointerCourse), "{@media (max-width:", y, "){transform:", s ? "scale(0.75) translate(64px, -32px)" : "scale(1)", ";}}}");
};
var $cc1354a6c3a64281$export$b1e5c588ff7cd906 = (0, $1poQt.default)((0, $a4jPb.Label), {
    target: "eyw2uzc0"
})($cc1354a6c3a64281$var$e);

});
parcelRegister("a4jPb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7549a7dccbe4115b$export$b04be29aa201d4f5);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $9iiQA = parcelRequire("9iiQA");
var $7549a7dccbe4115b$var$e = undefined && undefined.__rest || function(e, t) {
    var r, a = {};
    for(var l in e)Object.prototype.hasOwnProperty.call(e, l) && t.indexOf(l) < 0 && (a[l] = e[l]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(r = 0, l = Object.getOwnPropertySymbols(e); r < l.length; r++)t.indexOf(l[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[r]) && (a[l[r]] = e[l[r]]);
    return a;
};
var $7549a7dccbe4115b$export$b04be29aa201d4f5 = function(l) {
    var n = l.a11yAdditionalInfo, i = l.className, o = (l.error, l.id), c = l.isActive, s = l.placeholder, m = l.requiredIndicator, d = l.value, p = $7549a7dccbe4115b$var$e(l, [
        "a11yAdditionalInfo",
        "className",
        "error",
        "id",
        "isActive",
        "placeholder",
        "requiredIndicator",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", Object.assign({
        htmlFor: o,
        className: (0, $1SA7b.default)(i, c ? "is-active" : ""),
        "data-testid": "label-element"
    }, p), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, s && c ? d : s, !s && d), m && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "required-indicator",
        "aria-hidden": "true"
    }, m), n && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $9iiQA.visuallyHidden)
    }, n)));
};

});


parcelRegister("fcvsF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "defaultProps", () => $b1106196094e4a81$export$9c21a3269931e1e6);
$parcel$export(module.exports, "makeCreatableSelect", () => $b1106196094e4a81$export$dd4e25915d5350b7);
$parcel$export(module.exports, "default", () => $b1106196094e4a81$export$2e2bcd8739ae039);
parcelRequire("gZU1N");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("02Ztr");

var $kbxxf = parcelRequire("kbxxf");

var $kSlfw = parcelRequire("kSlfw");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");
parcelRequire("6zC7B");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");

parcelRequire("f5Egd");
parcelRequire("1u0KT");
parcelRequire("41YNz");

var $32kym = parcelRequire("32kym");

var $bUCRB = parcelRequire("bUCRB");
parcelRequire("6xSYO");
parcelRequire("gS6QF");
parcelRequire("83zt3");

var $e9Jgd = parcelRequire("e9Jgd");
function $b1106196094e4a81$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b1106196094e4a81$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $b1106196094e4a81$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b1106196094e4a81$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b1106196094e4a81$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b1106196094e4a81$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b1106196094e4a81$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b1106196094e4a81$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(option.value).toLowerCase();
    var optionLabel = String(option.label).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $b1106196094e4a81$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return 'Create "'.concat(inputValue, '"');
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
        return !(!inputValue || selectValue.some(function(option) {
            return $b1106196094e4a81$var$compareOption(inputValue, option);
        }) || selectOptions.some(function(option) {
            return $b1106196094e4a81$var$compareOption(inputValue, option);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
var $b1106196094e4a81$export$9c21a3269931e1e6 = $b1106196094e4a81$var$_objectSpread({
    allowCreateWhileLoading: false,
    createOptionPosition: "last"
}, $b1106196094e4a81$var$builtins);
var $b1106196094e4a81$export$dd4e25915d5350b7 = function makeCreatableSelect(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $1gYAD.default)(Creatable, _Component);
        var _super = $b1106196094e4a81$var$_createSuper(Creatable);
        function Creatable(props) {
            var _this;
            (0, $6CZeq.default)(this, Creatable);
            _this = _super.call(this, props);
            _this.select = void 0;
            _this.onChange = function(newValue, actionMeta) {
                var _this$props = _this.props, getNewOptionData = _this$props.getNewOptionData, inputValue = _this$props.inputValue, isMulti = _this$props.isMulti, onChange = _this$props.onChange, onCreateOption = _this$props.onCreateOption, value = _this$props.value, name = _this$props.name;
                if (actionMeta.action !== "select-option") return onChange(newValue, actionMeta);
                var newOption = _this.state.newOption;
                var valueArray = Array.isArray(newValue) ? newValue : [
                    newValue
                ];
                if (valueArray[valueArray.length - 1] === newOption) {
                    if (onCreateOption) onCreateOption(inputValue);
                    else {
                        var newOptionData = getNewOptionData(inputValue, inputValue);
                        var newActionMeta = {
                            action: "create-option",
                            name: name
                        };
                        if (isMulti) onChange([].concat((0, $kbxxf.default)((0, $32kym.C)(value)), [
                            newOptionData
                        ]), newActionMeta);
                        else onChange(newOptionData, newActionMeta);
                    }
                    return;
                }
                onChange(newValue, actionMeta);
            };
            var options = props.options || [];
            _this.state = {
                newOption: undefined,
                options: options
            };
            return _this;
        }
        (0, $cHPF9.default)(Creatable, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    var allowCreateWhileLoading = nextProps.allowCreateWhileLoading, createOptionPosition = nextProps.createOptionPosition, formatCreateLabel = nextProps.formatCreateLabel, getNewOptionData = nextProps.getNewOptionData, inputValue = nextProps.inputValue, isLoading = nextProps.isLoading, isValidNewOption = nextProps.isValidNewOption, value = nextProps.value;
                    var options = nextProps.options || [];
                    var newOption = this.state.newOption;
                    if (isValidNewOption(inputValue, (0, $32kym.C)(value), options)) newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
                    else newOption = undefined;
                    this.setState({
                        newOption: newOption,
                        options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [
                            newOption
                        ].concat((0, $kbxxf.default)(options)) : [].concat((0, $kbxxf.default)(options), [
                            newOption
                        ]) : options
                    });
                }
            },
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var options = this.state.options;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectComponent, (0, $8nd05.default)({}, this.props, {
                        ref: function ref(_ref) {
                            _this2.select = _ref;
                        },
                        options: options,
                        onChange: this.onChange
                    }));
                }
            }
        ]);
        return Creatable;
    }((0, $acw62.Component)), _class.defaultProps = $b1106196094e4a81$export$9c21a3269931e1e6, _temp;
}; // TODO: do this in package entrypoint
var $b1106196094e4a81$var$SelectCreatable = $b1106196094e4a81$export$dd4e25915d5350b7((0, $bUCRB.S));
var $b1106196094e4a81$var$Creatable = (0, $e9Jgd.m)($b1106196094e4a81$var$SelectCreatable);
var $b1106196094e4a81$export$2e2bcd8739ae039 = $b1106196094e4a81$var$Creatable;

});
parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $cN7Ua.default)(r) || (0, $dOjF6.default)(r) || (0, $abLc2.default)(r) || (0, $fB5Ly.default)();
}

});
parcelRegister("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7K8zV.default)(r);
}

});
parcelRegister("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7K8zV.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7K8zV.default)(r, a) : void 0;
    }
}

});

parcelRegister("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6CZeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d35ca0862055760$export$2e2bcd8739ae039);
function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $4ZreY.default)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("1gYAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed648f7bbaf3aff$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $VFVve.default)(t, e);
}

});

parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a259df8fa92dc4a$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $hDpcU = parcelRequire("hDpcU");
function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $fSwVM.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hDpcU.default)(t);
}

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("jDKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5ebe502337db0$export$2e2bcd8739ae039);
function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}

});

parcelRegister("32kym", function(module, exports) {

$parcel$export(module.exports, "E", () => $2361806a25584d2d$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "z", () => $2361806a25584d2d$export$df995fae86a55f06);
$parcel$export(module.exports, "C", () => $2361806a25584d2d$export$e7094788287c5e9b);
$parcel$export(module.exports, "A", () => $2361806a25584d2d$export$ebd11618f299a286);
$parcel$export(module.exports, "D", () => $2361806a25584d2d$export$96f57966bedc81b4);
$parcel$export(module.exports, "w", () => $2361806a25584d2d$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $2361806a25584d2d$export$d141bba7fdc215a3);
$parcel$export(module.exports, "m", () => $2361806a25584d2d$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $2361806a25584d2d$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "k", () => $2361806a25584d2d$export$342063e11d6c3cad);
$parcel$export(module.exports, "r", () => $2361806a25584d2d$export$43caf9889c228507);
$parcel$export(module.exports, "j", () => $2361806a25584d2d$export$35e795649ee09318);
$parcel$export(module.exports, "n", () => $2361806a25584d2d$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "B", () => $2361806a25584d2d$export$ef35774e6d314e91);
$parcel$export(module.exports, "a", () => $2361806a25584d2d$export$407448d2b89b1813);
$parcel$export(module.exports, "v", () => $2361806a25584d2d$export$90a7f3efeed30595);
$parcel$export(module.exports, "i", () => $2361806a25584d2d$export$23f2a1d2818174ef);
$parcel$export(module.exports, "d", () => $2361806a25584d2d$export$4368d992c4eafac0);
$parcel$export(module.exports, "c", () => $2361806a25584d2d$export$db3b6bfb95261072);
$parcel$export(module.exports, "f", () => $2361806a25584d2d$export$2d1720544b23b823);
$parcel$export(module.exports, "l", () => $2361806a25584d2d$export$882b5998b3b9117c);
$parcel$export(module.exports, "b", () => $2361806a25584d2d$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $2361806a25584d2d$export$39b482c5e57630a8);
$parcel$export(module.exports, "e", () => $2361806a25584d2d$export$f1e1789686576879);
$parcel$export(module.exports, "h", () => $2361806a25584d2d$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "o", () => $2361806a25584d2d$export$ae1af26003f05816);
$parcel$export(module.exports, "p", () => $2361806a25584d2d$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $2361806a25584d2d$export$9e5f44173e64f162);
$parcel$export(module.exports, "s", () => $2361806a25584d2d$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "t", () => $2361806a25584d2d$export$625550452a3fa3ec);
$parcel$export(module.exports, "u", () => $2361806a25584d2d$export$3b14a55fb2447963);
$parcel$export(module.exports, "F", () => $2361806a25584d2d$export$d66501df72047452);
$parcel$export(module.exports, "y", () => $2361806a25584d2d$export$4a5767248b18ef41);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");

var $f5Egd = parcelRequire("f5Egd");

var $1u0KT = parcelRequire("1u0KT");

var $fSwVM = parcelRequire("fSwVM");

var $6xSYO = parcelRequire("6xSYO");

var $hvnYt = parcelRequire("hvnYt");

var $83zt3 = parcelRequire("83zt3");
// ==============================
// NO OP
// ==============================
var $2361806a25584d2d$export$a9c23c6ac3fc3eca = function noop() {};
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $2361806a25584d2d$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $2361806a25584d2d$export$df995fae86a55f06(prefix, state, className) {
    var arr = [
        className
    ];
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($2361806a25584d2d$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
} // ==============================
// Clean Value
// ==============================
var $2361806a25584d2d$export$e7094788287c5e9b = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, $fSwVM.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
}; // ==============================
// Handle Input Change
// ==============================
function $2361806a25584d2d$export$2329c99376c9d0a4(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === "string") return newValue;
    }
    return inputValue;
} // ==============================
// Scroll Helpers
// ==============================
function $2361806a25584d2d$export$ebd11618f299a286(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------
function $2361806a25584d2d$var$getScrollTop(el) {
    if ($2361806a25584d2d$export$ebd11618f299a286(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $2361806a25584d2d$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($2361806a25584d2d$export$ebd11618f299a286(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------
function $2361806a25584d2d$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...
    if (style.position === "fixed") return docEl;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return docEl;
} // Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $2361806a25584d2d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $2361806a25584d2d$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $2361806a25584d2d$export$a9c23c6ac3fc3eca;
    var start = $2361806a25584d2d$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $2361806a25584d2d$var$easeOutCubic(currentTime, start, change, duration);
        $2361806a25584d2d$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
} // Scroll Into View
// ------------------------------
function $2361806a25584d2d$export$96f57966bedc81b4(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $2361806a25584d2d$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $2361806a25584d2d$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $2361806a25584d2d$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// Touch Capability Detector
// ==============================
function $2361806a25584d2d$export$efccba1c4a2ef57b() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
} // ==============================
// Mobile Device Detector
// ==============================
function $2361806a25584d2d$export$d141bba7fdc215a3() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
function $2361806a25584d2d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2361806a25584d2d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2361806a25584d2d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $2361806a25584d2d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2361806a25584d2d$var$getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, placement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = $2361806a25584d2d$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: maxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = window.innerHeight;
    var scrollTop = $2361806a25584d2d$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(placement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2361806a25584d2d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $2361806a25584d2d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (placement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = maxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (placement === "bottom") {
                $2361806a25584d2d$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: maxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2361806a25584d2d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $2361806a25584d2d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: maxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(placement, '".'));
    } // fulfil contract with flow: implicit return value of undefined
    return defaultState;
} // Menu Component
// ------------------------------
function $2361806a25584d2d$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $2361806a25584d2d$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $2361806a25584d2d$export$953cecd6e717a553 = function menuCSS(_ref2) {
    var _ref3;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return _ref3 = {
        label: "menu"
    }, (0, $kSlfw.default)(_ref3, $2361806a25584d2d$var$alignToControl(placement), "100%"), (0, $kSlfw.default)(_ref3, "backgroundColor", colors.neutral0), (0, $kSlfw.default)(_ref3, "borderRadius", borderRadius), (0, $kSlfw.default)(_ref3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), (0, $kSlfw.default)(_ref3, "marginBottom", spacing.menuGutter), (0, $kSlfw.default)(_ref3, "marginTop", spacing.menuGutter), (0, $kSlfw.default)(_ref3, "position", "absolute"), (0, $kSlfw.default)(_ref3, "width", "100%"), (0, $kSlfw.default)(_ref3, "zIndex", 1), _ref3;
};
var $2361806a25584d2d$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)({
    getPortalPlacement: null
}); // NOTE: internal only
var $2361806a25584d2d$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(MenuPlacer, _Component);
    var _super = $2361806a25584d2d$var$_createSuper(MenuPlacer);
    function MenuPlacer() {
        var _this;
        (0, $6CZeq.default)(this, MenuPlacer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            maxHeight: _this.props.maxMenuHeight,
            placement: null
        };
        _this.getPlacement = function(ref) {
            var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
            if (!ref) return; // DO NOT scroll if position is fixed
            var isFixedPosition = menuPosition === "fixed";
            var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            var state = $2361806a25584d2d$var$getMenuPlacement({
                maxHeight: maxMenuHeight,
                menuEl: ref,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                theme: theme
            });
            var getPortalPlacement = _this.context.getPortalPlacement;
            if (getPortalPlacement) getPortalPlacement(state);
            _this.setState(state);
        };
        _this.getUpdatedProps = function() {
            var menuPlacement = _this.props.menuPlacement;
            var placement = _this.state.placement || $2361806a25584d2d$var$coercePlacement(menuPlacement);
            return $2361806a25584d2d$var$_objectSpread($2361806a25584d2d$var$_objectSpread({}, _this.props), {}, {
                placement: placement,
                maxHeight: _this.state.maxHeight
            });
        };
        return _this;
    }
    (0, $cHPF9.default)(MenuPlacer, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    ref: this.getPlacement,
                    placerProps: this.getUpdatedProps()
                });
            }
        }
    ]);
    return MenuPlacer;
}((0, $acw62.Component));
$2361806a25584d2d$export$3a1a48c8f6ef640e.contextType = $2361806a25584d2d$var$PortalPlacementContext;
var $2361806a25584d2d$var$Menu = function Menu(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("menu", props),
        className: cx({
            menu: true
        }, className)
    }, innerProps, {
        ref: innerRef
    }), children);
};
// Menu List
// ==============================
var $2361806a25584d2d$export$342063e11d6c3cad = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return {
        maxHeight: maxHeight,
        overflowY: "auto",
        paddingBottom: baseUnit,
        paddingTop: baseUnit,
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    };
};
var $2361806a25584d2d$var$MenuList = function MenuList(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isMulti = props.isMulti, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("menuList", props),
        className: cx({
            "menu-list": true,
            "menu-list--is-multi": isMulti
        }, className),
        ref: innerRef
    }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================
var $2361806a25584d2d$var$noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
        textAlign: "center"
    };
};
var $2361806a25584d2d$export$43caf9889c228507 = $2361806a25584d2d$var$noticeCSS;
var $2361806a25584d2d$export$35e795649ee09318 = $2361806a25584d2d$var$noticeCSS;
var $2361806a25584d2d$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("noOptionsMessage", props),
        className: cx({
            "menu-notice": true,
            "menu-notice--no-options": true
        }, className)
    }, innerProps), children);
};
$2361806a25584d2d$var$NoOptionsMessage.defaultProps = {
    children: "No options"
};
var $2361806a25584d2d$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("loadingMessage", props),
        className: cx({
            "menu-notice": true,
            "menu-notice--loading": true
        }, className)
    }, innerProps), children);
};
$2361806a25584d2d$var$LoadingMessage.defaultProps = {
    children: "Loading..."
}; // ==============================
// Menu Portal
// ==============================
var $2361806a25584d2d$export$7ccc53e8f1e7dfc5 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $2361806a25584d2d$var$MenuPortal = /*#__PURE__*/ function(_Component2) {
    (0, $1gYAD.default)(MenuPortal, _Component2);
    var _super2 = $2361806a25584d2d$var$_createSuper(MenuPortal);
    function MenuPortal() {
        var _this2;
        (0, $6CZeq.default)(this, MenuPortal);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.state = {
            placement: null
        };
        _this2.getPortalPlacement = function(_ref7) {
            var placement = _ref7.placement;
            var initialPlacement = $2361806a25584d2d$var$coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
            if (placement !== initialPlacement) _this2.setState({
                placement: placement
            });
        };
        return _this2;
    }
    (0, $cHPF9.default)(MenuPortal, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, controlElement = _this$props2.controlElement, menuPlacement = _this$props2.menuPlacement, position = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
                var isFixed = position === "fixed"; // bail early if required elements aren't present
                if (!appendTo && !isFixed || !controlElement) return null;
                var placement = this.state.placement || $2361806a25584d2d$var$coercePlacement(menuPlacement);
                var rect = $2361806a25584d2d$var$getBoundingClientObj(controlElement);
                var scrollDistance = isFixed ? 0 : window.pageYOffset;
                var offset = rect[placement] + scrollDistance;
                var state = {
                    offset: offset,
                    position: position,
                    rect: rect
                }; // same wrapper element whether fixed or portalled
                var menuWrapper = (0, $f5Egd.jsx)("div", {
                    css: getStyles("menuPortal", state)
                }, children);
                return (0, $f5Egd.jsx)($2361806a25584d2d$var$PortalPlacementContext.Provider, {
                    value: {
                        getPortalPlacement: this.getPortalPlacement
                    }
                }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
            }
        }
    ]);
    return MenuPortal;
}((0, $acw62.Component));
var $2361806a25584d2d$var$isArray = Array.isArray;
var $2361806a25584d2d$var$keyList = Object.keys;
var $2361806a25584d2d$var$hasProp = Object.prototype.hasOwnProperty;
function $2361806a25584d2d$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && (0, $fSwVM.default)(a) == "object" && (0, $fSwVM.default)(b) == "object") {
        var arrA = $2361806a25584d2d$var$isArray(a), arrB = $2361806a25584d2d$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$2361806a25584d2d$var$equal(a[i], b[i])) return false;
            }
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $2361806a25584d2d$var$keyList(a);
        length = keys.length;
        if (length !== $2361806a25584d2d$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!$2361806a25584d2d$var$hasProp.call(b, keys[i])) return false;
        } // end fast-deep-equal
        // Custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$2361806a25584d2d$var$equal(a[key], b[key])) return false;
            }
        } // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
} // end fast-deep-equal
function $2361806a25584d2d$export$ef35774e6d314e91(a, b) {
    try {
        return $2361806a25584d2d$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        } // some other error. we should definitely know about these
        throw error;
    }
}
var $2361806a25584d2d$export$407448d2b89b1813 = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : null,
        pointerEvents: isDisabled ? "none" : null,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $2361806a25584d2d$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("container", props),
        className: cx({
            "--is-disabled": isDisabled,
            "--is-rtl": isRtl
        }, className)
    }, innerProps), children);
}; // ==============================
// Value Container
// ==============================
var $2361806a25584d2d$export$90a7f3efeed30595 = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        alignItems: "center",
        display: "flex",
        flex: 1,
        flexWrap: "wrap",
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    };
};
var $2361806a25584d2d$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
    return (0, $f5Egd.jsx)("div", {
        css: getStyles("valueContainer", props),
        className: cx({
            "value-container": true,
            "value-container--is-multi": isMulti,
            "value-container--has-value": hasValue
        }, className)
    }, children);
}; // ==============================
// Indicator Container
// ==============================
var $2361806a25584d2d$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $2361806a25584d2d$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles;
    return (0, $f5Egd.jsx)("div", {
        css: getStyles("indicatorsContainer", props),
        className: cx({
            indicators: true
        }, className)
    }, children);
};
function $2361806a25584d2d$var$_templateObject() {
    var data = (0, $hvnYt.default)([
        "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
    ]);
    $2361806a25584d2d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $2361806a25584d2d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2361806a25584d2d$var$_ref2 = {
    name: "19bqh2r",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: $2361806a25584d2d$var$_EMOTION_STRINGIFIED_CSS_ERROR__
};
// ==============================
// Dropdown & Clear Icons
// ==============================
var $2361806a25584d2d$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $9X7IJ.default)(_ref, [
        "size"
    ]);
    return (0, $f5Egd.jsx)("svg", (0, $8nd05.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $2361806a25584d2d$var$_ref2
    }, props));
};
var $2361806a25584d2d$var$CrossIcon = function CrossIcon(props) {
    return (0, $f5Egd.jsx)($2361806a25584d2d$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $f5Egd.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $2361806a25584d2d$var$DownChevron = function DownChevron(props) {
    return (0, $f5Egd.jsx)($2361806a25584d2d$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $f5Egd.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================
var $2361806a25584d2d$var$baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return {
        label: "indicatorContainer",
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: "flex",
        padding: baseUnit * 2,
        transition: "color 150ms",
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    };
};
var $2361806a25584d2d$export$4368d992c4eafac0 = $2361806a25584d2d$var$baseCSS;
var $2361806a25584d2d$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({}, innerProps, {
        css: getStyles("dropdownIndicator", props),
        className: cx({
            indicator: true,
            "dropdown-indicator": true
        }, className)
    }), children || (0, $f5Egd.jsx)($2361806a25584d2d$var$DownChevron, null));
};
var $2361806a25584d2d$export$db3b6bfb95261072 = $2361806a25584d2d$var$baseCSS;
var $2361806a25584d2d$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({}, innerProps, {
        css: getStyles("clearIndicator", props),
        className: cx({
            indicator: true,
            "clear-indicator": true
        }, className)
    }), children || (0, $f5Egd.jsx)($2361806a25584d2d$var$CrossIcon, null));
}; // ==============================
// Separator
// ==============================
var $2361806a25584d2d$export$2d1720544b23b823 = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return {
        label: "indicatorSeparator",
        alignSelf: "stretch",
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2,
        width: 1
    };
};
var $2361806a25584d2d$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("span", (0, $8nd05.default)({}, innerProps, {
        css: getStyles("indicatorSeparator", props),
        className: cx({
            "indicator-separator": true
        }, className)
    }));
}; // ==============================
// Loading
// ==============================
var $2361806a25584d2d$var$loadingDotAnimations = (0, $f5Egd.keyframes)($2361806a25584d2d$var$_templateObject());
var $2361806a25584d2d$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return {
        label: "loadingIndicator",
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: "flex",
        padding: baseUnit * 2,
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    };
};
var $2361806a25584d2d$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $f5Egd.jsx)("span", {
        css: /*#__PURE__*/ (0, $6xSYO.default)({
            animation: "".concat($2361806a25584d2d$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : null,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    });
};
var $2361806a25584d2d$var$LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({}, innerProps, {
        css: getStyles("loadingIndicator", props),
        className: cx({
            indicator: true,
            "loading-indicator": true
        }, className)
    }), (0, $f5Egd.jsx)($2361806a25584d2d$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $f5Egd.jsx)($2361806a25584d2d$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $f5Egd.jsx)($2361806a25584d2d$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$2361806a25584d2d$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $2361806a25584d2d$export$8b22cf2602fb60ce = function css(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return {
        label: "control",
        alignItems: "center",
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms",
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    };
};
var $2361806a25584d2d$var$Control = function Control(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        ref: innerRef,
        css: getStyles("control", props),
        className: cx({
            control: true,
            "control--is-disabled": isDisabled,
            "control--is-focused": isFocused,
            "control--menu-is-open": menuIsOpen
        }, className)
    }, innerProps), children);
};
function $2361806a25584d2d$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2361806a25584d2d$export$39b482c5e57630a8 = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $2361806a25584d2d$var$Group = function Group(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $f5Egd.jsx)("div", {
        css: getStyles("group", props),
        className: cx({
            group: true
        }, className)
    }, (0, $f5Egd.jsx)(Heading, (0, $8nd05.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        cx: cx
    }), label), (0, $f5Egd.jsx)("div", null, children));
};
var $2361806a25584d2d$export$f1e1789686576879 = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        label: "group",
        color: "#999",
        cursor: "default",
        display: "block",
        fontSize: "75%",
        fontWeight: "500",
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    };
};
var $2361806a25584d2d$var$GroupHeading = function GroupHeading(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, theme = props.theme, selectProps = props.selectProps, cleanProps = (0, $9X7IJ.default)(props, [
        "className",
        "cx",
        "getStyles",
        "theme",
        "selectProps"
    ]);
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("groupHeading", $2361806a25584d2d$var$_objectSpread$1({
            theme: theme
        }, cleanProps)),
        className: cx({
            "group-heading": true
        }, className)
    }, cleanProps));
};
function $2361806a25584d2d$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2361806a25584d2d$export$dda1d9f60106f0e9 = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        visibility: isDisabled ? "hidden" : "visible",
        color: colors.neutral80
    };
};
var $2361806a25584d2d$var$inputStyle = function inputStyle(isHidden) {
    return {
        label: "input",
        background: 0,
        border: 0,
        fontSize: "inherit",
        opacity: isHidden ? 0 : 1,
        outline: 0,
        padding: 0,
        color: "inherit"
    };
};
var $2361806a25584d2d$var$Input = function Input(_ref2) {
    var className = _ref2.className, cx = _ref2.cx, getStyles = _ref2.getStyles, innerRef = _ref2.innerRef, isHidden = _ref2.isHidden, isDisabled = _ref2.isDisabled, theme = _ref2.theme, selectProps = _ref2.selectProps, props = (0, $9X7IJ.default)(_ref2, [
        "className",
        "cx",
        "getStyles",
        "innerRef",
        "isHidden",
        "isDisabled",
        "theme",
        "selectProps"
    ]);
    return (0, $f5Egd.jsx)("div", {
        css: getStyles("input", $2361806a25584d2d$var$_objectSpread$2({
            theme: theme
        }, props))
    }, (0, $f5Egd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($83zt3))), (0, $8nd05.default)({
        className: cx({
            input: true
        }, className),
        inputRef: innerRef,
        inputStyle: $2361806a25584d2d$var$inputStyle(isHidden),
        disabled: isDisabled
    }, props)));
};
function $2361806a25584d2d$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys$3(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2361806a25584d2d$export$ae1af26003f05816 = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return {
        label: "multiValue",
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        display: "flex",
        margin: spacing.baseUnit / 2,
        minWidth: 0 // resolves flex/text-overflow bug
    };
};
var $2361806a25584d2d$export$ffb5f4729a158638 = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        overflow: "hidden",
        padding: 3,
        paddingLeft: 6,
        textOverflow: cropWithEllipsis ? "ellipsis" : null,
        whiteSpace: "nowrap"
    };
};
var $2361806a25584d2d$export$9e5f44173e64f162 = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return {
        alignItems: "center",
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused && colors.dangerLight,
        display: "flex",
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    };
};
var $2361806a25584d2d$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $f5Egd.jsx)("div", innerProps, children);
};
var $2361806a25584d2d$var$MultiValueContainer = $2361806a25584d2d$var$MultiValueGeneric;
var $2361806a25584d2d$var$MultiValueLabel = $2361806a25584d2d$var$MultiValueGeneric;
function $2361806a25584d2d$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $f5Egd.jsx)("div", innerProps, children || (0, $f5Egd.jsx)($2361806a25584d2d$var$CrossIcon, {
        size: 14
    }));
}
var $2361806a25584d2d$var$MultiValue = function MultiValue(props) {
    var children = props.children, className = props.className, components = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $f5Egd.jsx)((0, $f5Egd.ClassNames), null, function(_ref6) {
        var css = _ref6.css, emotionCx = _ref6.cx;
        return (0, $f5Egd.jsx)(Container, {
            data: data,
            innerProps: $2361806a25584d2d$var$_objectSpread$3($2361806a25584d2d$var$_objectSpread$3({}, innerProps), {}, {
                className: emotionCx(css(getStyles("multiValue", props)), cx({
                    "multi-value": true,
                    "multi-value--is-disabled": isDisabled
                }, className))
            }),
            selectProps: selectProps
        }, (0, $f5Egd.jsx)(Label, {
            data: data,
            innerProps: {
                className: emotionCx(css(getStyles("multiValueLabel", props)), cx({
                    "multi-value__label": true
                }, className))
            },
            selectProps: selectProps
        }, children), (0, $f5Egd.jsx)(Remove, {
            data: data,
            innerProps: $2361806a25584d2d$var$_objectSpread$3({
                className: emotionCx(css(getStyles("multiValueRemove", props)), cx({
                    "multi-value__remove": true
                }, className))
            }, removeProps),
            selectProps: selectProps
        }));
    });
};
$2361806a25584d2d$var$MultiValue.defaultProps = {
    cropWithEllipsis: true
};
var $2361806a25584d2d$export$2408f22a0fab9ae5 = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "option",
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
        }
    };
};
var $2361806a25584d2d$var$Option = function Option(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("option", props),
        className: cx({
            option: true,
            "option--is-disabled": isDisabled,
            "option--is-focused": isFocused,
            "option--is-selected": isSelected
        }, className),
        ref: innerRef
    }, innerProps), children);
};
var $2361806a25584d2d$export$625550452a3fa3ec = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "placeholder",
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)"
    };
};
var $2361806a25584d2d$var$Placeholder = function Placeholder(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("placeholder", props),
        className: cx({
            placeholder: true
        }, className)
    }, innerProps), children);
};
var $2361806a25584d2d$export$3b14a55fb2447963 = function css(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "singleValue",
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
        overflow: "hidden",
        position: "absolute",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        top: "50%",
        transform: "translateY(-50%)"
    };
};
var $2361806a25584d2d$var$SingleValue = function SingleValue(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("singleValue", props),
        className: cx({
            "single-value": true,
            "single-value--is-disabled": isDisabled
        }, className)
    }, innerProps), children);
};
function $2361806a25584d2d$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys$4(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2361806a25584d2d$export$d66501df72047452 = {
    ClearIndicator: $2361806a25584d2d$var$ClearIndicator,
    Control: $2361806a25584d2d$var$Control,
    DropdownIndicator: $2361806a25584d2d$var$DropdownIndicator,
    DownChevron: $2361806a25584d2d$var$DownChevron,
    CrossIcon: $2361806a25584d2d$var$CrossIcon,
    Group: $2361806a25584d2d$var$Group,
    GroupHeading: $2361806a25584d2d$var$GroupHeading,
    IndicatorsContainer: $2361806a25584d2d$var$IndicatorsContainer,
    IndicatorSeparator: $2361806a25584d2d$var$IndicatorSeparator,
    Input: $2361806a25584d2d$var$Input,
    LoadingIndicator: $2361806a25584d2d$var$LoadingIndicator,
    Menu: $2361806a25584d2d$var$Menu,
    MenuList: $2361806a25584d2d$var$MenuList,
    MenuPortal: $2361806a25584d2d$var$MenuPortal,
    LoadingMessage: $2361806a25584d2d$var$LoadingMessage,
    NoOptionsMessage: $2361806a25584d2d$var$NoOptionsMessage,
    MultiValue: $2361806a25584d2d$var$MultiValue,
    MultiValueContainer: $2361806a25584d2d$var$MultiValueContainer,
    MultiValueLabel: $2361806a25584d2d$var$MultiValueLabel,
    MultiValueRemove: $2361806a25584d2d$var$MultiValueRemove,
    Option: $2361806a25584d2d$var$Option,
    Placeholder: $2361806a25584d2d$var$Placeholder,
    SelectContainer: $2361806a25584d2d$var$SelectContainer,
    SingleValue: $2361806a25584d2d$var$SingleValue,
    ValueContainer: $2361806a25584d2d$var$ValueContainer
};
var $2361806a25584d2d$export$4a5767248b18ef41 = function defaultComponents(props) {
    return $2361806a25584d2d$var$_objectSpread$4($2361806a25584d2d$var$_objectSpread$4({}, $2361806a25584d2d$export$d66501df72047452), props.components);
};

});
parcelRegister("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1En50.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("hvnYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe7edbf3ccb8828$export$2e2bcd8739ae039);
function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("83zt3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5dda1db15c8c646c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5dda1db15c8c646c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $5dda1db15c8c646c$var$_react2 = $5dda1db15c8c646c$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $5dda1db15c8c646c$var$_propTypes2 = $5dda1db15c8c646c$var$_interopRequireDefault($c9Z8w);
function $5dda1db15c8c646c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5dda1db15c8c646c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5dda1db15c8c646c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5dda1db15c8c646c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5dda1db15c8c646c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5dda1db15c8c646c$var$sizerStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    visibility: "hidden",
    height: 0,
    overflow: "scroll",
    whiteSpace: "pre"
};
var $5dda1db15c8c646c$var$INPUT_PROPS_BLACKLIST = [
    "extraWidth",
    "injectStyles",
    "inputClassName",
    "inputRef",
    "inputStyle",
    "minWidth",
    "onAutosize",
    "placeholderIsMinWidth"
];
var $5dda1db15c8c646c$var$cleanInputProps = function cleanInputProps(inputProps) {
    $5dda1db15c8c646c$var$INPUT_PROPS_BLACKLIST.forEach(function(field) {
        return delete inputProps[field];
    });
    return inputProps;
};
var $5dda1db15c8c646c$var$copyStyles = function copyStyles(styles, node) {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
};
var $5dda1db15c8c646c$var$isIE = typeof window !== "undefined" && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var $5dda1db15c8c646c$var$generateId = function generateId() {
    // we only need an auto-generated ID for stylesheet injection, which is only
    // used for IE. so if the browser is not IE, this should return undefined.
    return $5dda1db15c8c646c$var$isIE ? "_" + Math.random().toString(36).substr(2, 12) : undefined;
};
var $5dda1db15c8c646c$var$AutosizeInput = function(_Component) {
    $5dda1db15c8c646c$var$_inherits(AutosizeInput, _Component);
    $5dda1db15c8c646c$var$_createClass(AutosizeInput, null, [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var id = props.id;
                return id !== state.prevId ? {
                    inputId: id || $5dda1db15c8c646c$var$generateId(),
                    prevId: id
                } : null;
            }
        }
    ]);
    function AutosizeInput(props) {
        $5dda1db15c8c646c$var$_classCallCheck(this, AutosizeInput);
        var _this = $5dda1db15c8c646c$var$_possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
        _this.inputRef = function(el) {
            _this.input = el;
            if (typeof _this.props.inputRef === "function") _this.props.inputRef(el);
        };
        _this.placeHolderSizerRef = function(el) {
            _this.placeHolderSizer = el;
        };
        _this.sizerRef = function(el) {
            _this.sizer = el;
        };
        _this.state = {
            inputWidth: props.minWidth,
            inputId: props.id || $5dda1db15c8c646c$var$generateId(),
            prevId: props.id
        };
        return _this;
    }
    $5dda1db15c8c646c$var$_createClass(AutosizeInput, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
                this.copyInputStyles();
                this.updateInputWidth();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevState.inputWidth !== this.state.inputWidth) {
                    if (typeof this.props.onAutosize === "function") this.props.onAutosize(this.state.inputWidth);
                }
                this.updateInputWidth();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: "copyInputStyles",
            value: function copyInputStyles() {
                if (!this.mounted || !window.getComputedStyle) return;
                var inputStyles = this.input && window.getComputedStyle(this.input);
                if (!inputStyles) return;
                $5dda1db15c8c646c$var$copyStyles(inputStyles, this.sizer);
                if (this.placeHolderSizer) $5dda1db15c8c646c$var$copyStyles(inputStyles, this.placeHolderSizer);
            }
        },
        {
            key: "updateInputWidth",
            value: function updateInputWidth() {
                if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === "undefined") return;
                var newInputWidth = void 0;
                if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
                else newInputWidth = this.sizer.scrollWidth + 2;
                // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
                var extraWidth = this.props.type === "number" && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
                newInputWidth += extraWidth;
                if (newInputWidth < this.props.minWidth) newInputWidth = this.props.minWidth;
                if (newInputWidth !== this.state.inputWidth) this.setState({
                    inputWidth: newInputWidth
                });
            }
        },
        {
            key: "getInput",
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.input.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.input.blur();
            }
        },
        {
            key: "select",
            value: function select() {
                this.input.select();
            }
        },
        {
            key: "renderStyles",
            value: function renderStyles() {
                // this method injects styles to hide IE's clear indicator, which messes
                // with input size detection. the stylesheet is only injected when the
                // browser is IE, and can also be disabled by the `injectStyles` prop.
                var injectStyles = this.props.injectStyles;
                return $5dda1db15c8c646c$var$isIE && injectStyles ? $5dda1db15c8c646c$var$_react2.default.createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
                    }
                }) : null;
            }
        },
        {
            key: "render",
            value: function render() {
                var sizerValue = [
                    this.props.defaultValue,
                    this.props.value,
                    ""
                ].reduce(function(previousValue, currentValue) {
                    if (previousValue !== null && previousValue !== undefined) return previousValue;
                    return currentValue;
                });
                var wrapperStyle = $5dda1db15c8c646c$var$_extends({}, this.props.style);
                if (!wrapperStyle.display) wrapperStyle.display = "inline-block";
                var inputStyle = $5dda1db15c8c646c$var$_extends({
                    boxSizing: "content-box",
                    width: this.state.inputWidth + "px"
                }, this.props.inputStyle);
                var inputProps = $5dda1db15c8c646c$var$_objectWithoutProperties(this.props, []);
                $5dda1db15c8c646c$var$cleanInputProps(inputProps);
                inputProps.className = this.props.inputClassName;
                inputProps.id = this.state.inputId;
                inputProps.style = inputStyle;
                return $5dda1db15c8c646c$var$_react2.default.createElement("div", {
                    className: this.props.className,
                    style: wrapperStyle
                }, this.renderStyles(), $5dda1db15c8c646c$var$_react2.default.createElement("input", $5dda1db15c8c646c$var$_extends({}, inputProps, {
                    ref: this.inputRef
                })), $5dda1db15c8c646c$var$_react2.default.createElement("div", {
                    ref: this.sizerRef,
                    style: $5dda1db15c8c646c$var$sizerStyle
                }, sizerValue), this.props.placeholder ? $5dda1db15c8c646c$var$_react2.default.createElement("div", {
                    ref: this.placeHolderSizerRef,
                    style: $5dda1db15c8c646c$var$sizerStyle
                }, this.props.placeholder) : null);
            }
        }
    ]);
    return AutosizeInput;
}($acw62.Component);
$5dda1db15c8c646c$var$AutosizeInput.propTypes = {
    className: $5dda1db15c8c646c$var$_propTypes2.default.string,
    defaultValue: $5dda1db15c8c646c$var$_propTypes2.default.any,
    extraWidth: $5dda1db15c8c646c$var$_propTypes2.default.oneOfType([
        $5dda1db15c8c646c$var$_propTypes2.default.number,
        $5dda1db15c8c646c$var$_propTypes2.default.string
    ]),
    id: $5dda1db15c8c646c$var$_propTypes2.default.string,
    injectStyles: $5dda1db15c8c646c$var$_propTypes2.default.bool,
    inputClassName: $5dda1db15c8c646c$var$_propTypes2.default.string,
    inputRef: $5dda1db15c8c646c$var$_propTypes2.default.func,
    inputStyle: $5dda1db15c8c646c$var$_propTypes2.default.object,
    minWidth: $5dda1db15c8c646c$var$_propTypes2.default.oneOfType([
        $5dda1db15c8c646c$var$_propTypes2.default.number,
        $5dda1db15c8c646c$var$_propTypes2.default.string
    ]),
    onAutosize: $5dda1db15c8c646c$var$_propTypes2.default.func,
    onChange: $5dda1db15c8c646c$var$_propTypes2.default.func,
    placeholder: $5dda1db15c8c646c$var$_propTypes2.default.string,
    placeholderIsMinWidth: $5dda1db15c8c646c$var$_propTypes2.default.bool,
    style: $5dda1db15c8c646c$var$_propTypes2.default.object,
    value: $5dda1db15c8c646c$var$_propTypes2.default.any // field value
};
$5dda1db15c8c646c$var$AutosizeInput.defaultProps = {
    minWidth: 1,
    injectStyles: true
};
module.exports.default = $5dda1db15c8c646c$var$AutosizeInput;

});


parcelRegister("bUCRB", function(module, exports) {

$parcel$export(module.exports, "c", () => $8ac3122ed2a8618b$export$db3b6bfb95261072);
$parcel$export(module.exports, "m", () => $8ac3122ed2a8618b$export$953cecd6e717a553);
$parcel$export(module.exports, "a", () => $8ac3122ed2a8618b$export$407448d2b89b1813);
$parcel$export(module.exports, "S", () => $8ac3122ed2a8618b$export$25ce5a424b770e84);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $kSlfw = parcelRequire("kSlfw");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");

var $jk22o = parcelRequire("jk22o");

var $f5Egd = parcelRequire("f5Egd");

var $1u0KT = parcelRequire("1u0KT");

var $32kym = parcelRequire("32kym");

var $6xSYO = parcelRequire("6xSYO");
var $8ac3122ed2a8618b$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $8ac3122ed2a8618b$var$anyDiacritic = new RegExp("[" + $8ac3122ed2a8618b$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $8ac3122ed2a8618b$var$diacriticToBase = {};
for(var $8ac3122ed2a8618b$var$i = 0; $8ac3122ed2a8618b$var$i < $8ac3122ed2a8618b$var$diacritics.length; $8ac3122ed2a8618b$var$i++){
    var $8ac3122ed2a8618b$var$diacritic = $8ac3122ed2a8618b$var$diacritics[$8ac3122ed2a8618b$var$i];
    for(var $8ac3122ed2a8618b$var$j = 0; $8ac3122ed2a8618b$var$j < $8ac3122ed2a8618b$var$diacritic.letters.length; $8ac3122ed2a8618b$var$j++)$8ac3122ed2a8618b$var$diacriticToBase[$8ac3122ed2a8618b$var$diacritic.letters[$8ac3122ed2a8618b$var$j]] = $8ac3122ed2a8618b$var$diacritic.base;
}
var $8ac3122ed2a8618b$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($8ac3122ed2a8618b$var$anyDiacritic, function(match) {
        return $8ac3122ed2a8618b$var$diacriticToBase[match];
    });
};
function $8ac3122ed2a8618b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ac3122ed2a8618b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8ac3122ed2a8618b$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8ac3122ed2a8618b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $8ac3122ed2a8618b$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $8ac3122ed2a8618b$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $8ac3122ed2a8618b$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        var _ignoreCase$ignoreAcc = $8ac3122ed2a8618b$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $8ac3122ed2a8618b$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $8ac3122ed2a8618b$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $8ac3122ed2a8618b$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $8ac3122ed2a8618b$var$stripDiacritics(input);
            candidate = $8ac3122ed2a8618b$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
function $8ac3122ed2a8618b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8ac3122ed2a8618b$var$_ref = {
    name: "1laao21-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFJIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICA8c3BhblxuICAgIGNzcz17e1xuICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICB6SW5kZXg6IDk5OTksXG4gICAgICBib3JkZXI6IDAsXG4gICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgIGhlaWdodDogMSxcbiAgICAgIHdpZHRoOiAxLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBvdmVyZmxvdzogJ2hpZGRlbicsXG4gICAgICBwYWRkaW5nOiAwLFxuICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgfX1cbiAgICB7Li4ucHJvcHN9XG4gIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */",
    toString: $8ac3122ed2a8618b$var$_EMOTION_STRINGIFIED_CSS_ERROR__
};
var $8ac3122ed2a8618b$var$A11yText = function A11yText(props) {
    return (0, $f5Egd.jsx)("span", (0, $8nd05.default)({
        css: $8ac3122ed2a8618b$var$_ref
    }, props));
};
function $8ac3122ed2a8618b$var$DummyInput(_ref) {
    var inProp = _ref.in, out = _ref.out, onExited = _ref.onExited, appear = _ref.appear, enter = _ref.enter, exit = _ref.exit, innerRef = _ref.innerRef, emotion = _ref.emotion, props = (0, $9X7IJ.default)(_ref, [
        "in",
        "out",
        "onExited",
        "appear",
        "enter",
        "exit",
        "innerRef",
        "emotion"
    ]);
    return (0, $f5Egd.jsx)("input", (0, $8nd05.default)({
        ref: innerRef
    }, props, {
        css: /*#__PURE__*/ (0, $6xSYO.default)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            fontSize: "inherit",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(0)"
        }, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6IkR1bW15SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGluOiBpblByb3AsXG4gIG91dCxcbiAgb25FeGl0ZWQsXG4gIGFwcGVhcixcbiAgZW50ZXIsXG4gIGV4aXQsXG4gIGlubmVyUmVmLFxuICBlbW90aW9uLFxuICAuLi5wcm9wc1xufTogYW55KSB7XG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLnByb3BzfVxuICAgICAgY3NzPXt7XG4gICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgIC8vIGdldCByaWQgb2YgYW55IGRlZmF1bHQgc3R5bGVzXG4gICAgICAgIGJhY2tncm91bmQ6IDAsXG4gICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgZm9udFNpemU6ICdpbmhlcml0JyxcbiAgICAgICAgb3V0bGluZTogMCxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgLy8gaW1wb3J0YW50ISB3aXRob3V0IGB3aWR0aGAgYnJvd3NlcnMgd29uJ3QgYWxsb3cgZm9jdXNcbiAgICAgICAgd2lkdGg6IDEsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgIGNvbG9yOiAndHJhbnNwYXJlbnQnLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gbW9iaWxlIHdoaWxzdCBtYWludGFpbmluZyBcInNjcm9sbCBpbnRvIHZpZXdcIiBiZWhhdmlvdXJcbiAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgb3BhY2l0eTogMCxcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
    }));
}
function $8ac3122ed2a8618b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$var$NodeResolver = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(NodeResolver, _Component);
    var _super = $8ac3122ed2a8618b$var$_createSuper(NodeResolver);
    function NodeResolver() {
        (0, $6CZeq.default)(this, NodeResolver);
        return _super.apply(this, arguments);
    }
    (0, $cHPF9.default)(NodeResolver, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.innerRef((0, $1u0KT.findDOMNode)(this));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}((0, $acw62.Component));
var $8ac3122ed2a8618b$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $8ac3122ed2a8618b$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $8ac3122ed2a8618b$var$preventTouchMove(e) {
    e.preventDefault();
}
function $8ac3122ed2a8618b$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $8ac3122ed2a8618b$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $8ac3122ed2a8618b$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
function $8ac3122ed2a8618b$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$var$canUseDOM = !!(window.document && window.document.createElement);
var $8ac3122ed2a8618b$var$activeScrollLocks = 0;
var $8ac3122ed2a8618b$var$ScrollLock = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(ScrollLock, _Component);
    var _super = $8ac3122ed2a8618b$var$_createSuper$1(ScrollLock);
    function ScrollLock() {
        var _this;
        (0, $6CZeq.default)(this, ScrollLock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.originalStyles = {};
        _this.listenerOptions = {
            capture: false,
            passive: false
        };
        return _this;
    }
    (0, $cHPF9.default)(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                if (!$8ac3122ed2a8618b$var$canUseDOM) return;
                var _this$props = this.props, accountForScrollbars = _this$props.accountForScrollbars, touchScrollTarget = _this$props.touchScrollTarget;
                var target = document.body;
                var targetStyle = target && target.style;
                if (accountForScrollbars) // store any styles already applied to the body
                $8ac3122ed2a8618b$var$STYLE_KEYS.forEach(function(key) {
                    var val = targetStyle && targetStyle[key];
                    _this2.originalStyles[key] = val;
                });
                 // apply the lock styles and padding if this is the first scroll lock
                if (accountForScrollbars && $8ac3122ed2a8618b$var$activeScrollLocks < 1) {
                    var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
                    var clientWidth = document.body ? document.body.clientWidth : 0;
                    var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                    Object.keys($8ac3122ed2a8618b$var$LOCK_STYLES).forEach(function(key) {
                        var val = $8ac3122ed2a8618b$var$LOCK_STYLES[key];
                        if (targetStyle) targetStyle[key] = val;
                    });
                    if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
                } // account for touch devices
                if (target && $8ac3122ed2a8618b$var$isTouchDevice()) {
                    // Mobile Safari ignores { overflow: hidden } declaration on the body.
                    target.addEventListener("touchmove", $8ac3122ed2a8618b$var$preventTouchMove, this.listenerOptions); // Allow scroll on provided target
                    if (touchScrollTarget) {
                        touchScrollTarget.addEventListener("touchstart", $8ac3122ed2a8618b$var$preventInertiaScroll, this.listenerOptions);
                        touchScrollTarget.addEventListener("touchmove", $8ac3122ed2a8618b$var$allowTouchMove, this.listenerOptions);
                    }
                } // increment active scroll locks
                $8ac3122ed2a8618b$var$activeScrollLocks += 1;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this3 = this;
                if (!$8ac3122ed2a8618b$var$canUseDOM) return;
                var _this$props2 = this.props, accountForScrollbars = _this$props2.accountForScrollbars, touchScrollTarget = _this$props2.touchScrollTarget;
                var target = document.body;
                var targetStyle = target && target.style; // safely decrement active scroll locks
                $8ac3122ed2a8618b$var$activeScrollLocks = Math.max($8ac3122ed2a8618b$var$activeScrollLocks - 1, 0); // reapply original body styles, if any
                if (accountForScrollbars && $8ac3122ed2a8618b$var$activeScrollLocks < 1) $8ac3122ed2a8618b$var$STYLE_KEYS.forEach(function(key) {
                    var val = _this3.originalStyles[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                 // remove touch listeners
                if (target && $8ac3122ed2a8618b$var$isTouchDevice()) {
                    target.removeEventListener("touchmove", $8ac3122ed2a8618b$var$preventTouchMove, this.listenerOptions);
                    if (touchScrollTarget) {
                        touchScrollTarget.removeEventListener("touchstart", $8ac3122ed2a8618b$var$preventInertiaScroll, this.listenerOptions);
                        touchScrollTarget.removeEventListener("touchmove", $8ac3122ed2a8618b$var$allowTouchMove, this.listenerOptions);
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return ScrollLock;
}((0, $acw62.Component));
$8ac3122ed2a8618b$var$ScrollLock.defaultProps = {
    accountForScrollbars: true
};
function $8ac3122ed2a8618b$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $8ac3122ed2a8618b$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$var$_ref$1 = {
    name: "1dsbpcp",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: $8ac3122ed2a8618b$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1
};
// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var $8ac3122ed2a8618b$var$ScrollBlock = /*#__PURE__*/ function(_PureComponent) {
    (0, $1gYAD.default)(ScrollBlock, _PureComponent);
    var _super = $8ac3122ed2a8618b$var$_createSuper$2(ScrollBlock);
    function ScrollBlock() {
        var _this;
        (0, $6CZeq.default)(this, ScrollBlock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            touchScrollTarget: null
        };
        _this.getScrollTarget = function(ref) {
            if (ref === _this.state.touchScrollTarget) return;
            _this.setState({
                touchScrollTarget: ref
            });
        };
        _this.blurSelectInput = function() {
            if (document.activeElement) document.activeElement.blur();
        };
        return _this;
    }
    (0, $cHPF9.default)(ScrollBlock, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, isEnabled = _this$props.isEnabled;
                var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
                if (!isEnabled) return children;
                /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */ return (0, $f5Egd.jsx)("div", null, (0, $f5Egd.jsx)("div", {
                    onClick: this.blurSelectInput,
                    css: $8ac3122ed2a8618b$var$_ref$1
                }), (0, $f5Egd.jsx)($8ac3122ed2a8618b$var$NodeResolver, {
                    innerRef: this.getScrollTarget
                }, children), touchScrollTarget ? (0, $f5Egd.jsx)($8ac3122ed2a8618b$var$ScrollLock, {
                    touchScrollTarget: touchScrollTarget
                }) : null);
            }
        }
    ]);
    return ScrollBlock;
}((0, $acw62.PureComponent));
function $8ac3122ed2a8618b$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$var$ScrollCaptor = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(ScrollCaptor, _Component);
    var _super = $8ac3122ed2a8618b$var$_createSuper$3(ScrollCaptor);
    function ScrollCaptor() {
        var _this;
        (0, $6CZeq.default)(this, ScrollCaptor);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.isBottom = false;
        _this.isTop = false;
        _this.scrollTarget = void 0;
        _this.touchStart = void 0;
        _this.cancelScroll = function(event) {
            event.preventDefault();
            event.stopPropagation();
        };
        _this.handleEventDelta = function(event, delta) {
            var _this$props = _this.props, onBottomArrive = _this$props.onBottomArrive, onBottomLeave = _this$props.onBottomLeave, onTopArrive = _this$props.onTopArrive, onTopLeave = _this$props.onTopLeave;
            var _this$scrollTarget = _this.scrollTarget, scrollTop = _this$scrollTarget.scrollTop, scrollHeight = _this$scrollTarget.scrollHeight, clientHeight = _this$scrollTarget.clientHeight;
            var target = _this.scrollTarget;
            var isDeltaPositive = delta > 0;
            var availableScroll = scrollHeight - clientHeight - scrollTop;
            var shouldCancelScroll = false; // reset bottom/top flags
            if (availableScroll > delta && _this.isBottom) {
                if (onBottomLeave) onBottomLeave(event);
                _this.isBottom = false;
            }
            if (isDeltaPositive && _this.isTop) {
                if (onTopLeave) onTopLeave(event);
                _this.isTop = false;
            } // bottom limit
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !_this.isBottom) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                _this.isBottom = true; // top limit
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !_this.isTop) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                _this.isTop = true;
            } // cancel scroll
            if (shouldCancelScroll) _this.cancelScroll(event);
        };
        _this.onWheel = function(event) {
            _this.handleEventDelta(event, event.deltaY);
        };
        _this.onTouchStart = function(event) {
            // set touch start so we can calculate touchmove delta
            _this.touchStart = event.changedTouches[0].clientY;
        };
        _this.onTouchMove = function(event) {
            var deltaY = _this.touchStart - event.changedTouches[0].clientY;
            _this.handleEventDelta(event, deltaY);
        };
        _this.getScrollTarget = function(ref) {
            _this.scrollTarget = ref;
        };
        return _this;
    }
    (0, $cHPF9.default)(ScrollCaptor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListening(this.scrollTarget);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListening(this.scrollTarget);
            }
        },
        {
            key: "startListening",
            value: function startListening(el) {
                // bail early if no element is available to attach to
                if (!el) return; // all the if statements are to appease Flow 😢
                if (typeof el.addEventListener === "function") el.addEventListener("wheel", this.onWheel, false);
                if (typeof el.addEventListener === "function") el.addEventListener("touchstart", this.onTouchStart, false);
                if (typeof el.addEventListener === "function") el.addEventListener("touchmove", this.onTouchMove, false);
            }
        },
        {
            key: "stopListening",
            value: function stopListening(el) {
                if (!el) return; // all the if statements are to appease Flow 😢
                if (typeof el.removeEventListener === "function") el.removeEventListener("wheel", this.onWheel, false);
                if (typeof el.removeEventListener === "function") el.removeEventListener("touchstart", this.onTouchStart, false);
                if (typeof el.removeEventListener === "function") el.removeEventListener("touchmove", this.onTouchMove, false);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$NodeResolver, {
                    innerRef: this.getScrollTarget
                }, this.props.children);
            }
        }
    ]);
    return ScrollCaptor;
}((0, $acw62.Component));
function $8ac3122ed2a8618b$var$ScrollCaptorSwitch(_ref) {
    var _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, props = (0, $9X7IJ.default)(_ref, [
        "isEnabled"
    ]);
    return isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$ScrollCaptor, props) : props.children;
}
var $8ac3122ed2a8618b$var$instructionsAriaMessage = function instructionsAriaMessage(event) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isSearchable = context.isSearchable, isMulti = context.isMulti, label = context.label, isDisabled = context.isDisabled, tabSelectsValue = context.tabSelectsValue;
    switch(event){
        case "menu":
            return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
        case "input":
            return "".concat(label ? label : "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
        case "value":
            return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
    }
};
var $8ac3122ed2a8618b$var$valueEventAriaMessage = function valueEventAriaMessage(event, context) {
    var value = context.value, isDisabled = context.isDisabled;
    if (!value) return;
    switch(event){
        case "deselect-option":
        case "pop-value":
        case "remove-value":
            return "option ".concat(value, ", deselected.");
        case "select-option":
            return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
    }
};
var $8ac3122ed2a8618b$var$valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
    var focusedValue = _ref.focusedValue, getOptionLabel = _ref.getOptionLabel, selectValue = _ref.selectValue;
    return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var $8ac3122ed2a8618b$var$optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
    var focusedOption = _ref2.focusedOption, getOptionLabel = _ref2.getOptionLabel, options = _ref2.options;
    return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? " disabled" : "", ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var $8ac3122ed2a8618b$var$resultsAriaMessage = function resultsAriaMessage(_ref3) {
    var inputValue = _ref3.inputValue, screenReaderMessage = _ref3.screenReaderMessage;
    return "".concat(screenReaderMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
};
var $8ac3122ed2a8618b$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $8ac3122ed2a8618b$var$getOptionLabel = function getOptionLabel(option) {
    return option.label;
};
var $8ac3122ed2a8618b$var$getOptionValue = function getOptionValue(option) {
    return option.value;
};
var $8ac3122ed2a8618b$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
function $8ac3122ed2a8618b$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ac3122ed2a8618b$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8ac3122ed2a8618b$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8ac3122ed2a8618b$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $8ac3122ed2a8618b$var$defaultStyles = {
    clearIndicator: (0, $32kym.c),
    container: (0, $32kym.a),
    control: (0, $32kym.b),
    dropdownIndicator: (0, $32kym.d),
    group: (0, $32kym.g),
    groupHeading: (0, $32kym.e),
    indicatorsContainer: (0, $32kym.i),
    indicatorSeparator: (0, $32kym.f),
    input: (0, $32kym.h),
    loadingIndicator: (0, $32kym.l),
    loadingMessage: (0, $32kym.j),
    menu: (0, $32kym.m),
    menuList: (0, $32kym.k),
    menuPortal: (0, $32kym.n),
    multiValue: (0, $32kym.o),
    multiValueLabel: (0, $32kym.p),
    multiValueRemove: (0, $32kym.q),
    noOptionsMessage: (0, $32kym.r),
    option: (0, $32kym.s),
    placeholder: (0, $32kym.t),
    singleValue: (0, $32kym.u),
    valueContainer: (0, $32kym.v)
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles
function $8ac3122ed2a8618b$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $8ac3122ed2a8618b$var$_objectSpread$1({}, source); // massage in target styles
    Object.keys(target).forEach(function(key) {
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $8ac3122ed2a8618b$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $8ac3122ed2a8618b$var$borderRadius = 4; // Used to calculate consistent margin/padding on elements
var $8ac3122ed2a8618b$var$baseUnit = 4; // The minimum height of the control
var $8ac3122ed2a8618b$var$controlHeight = 38; // The amount of space between the control and menu */
var $8ac3122ed2a8618b$var$menuGutter = $8ac3122ed2a8618b$var$baseUnit * 2;
var $8ac3122ed2a8618b$var$spacing = {
    baseUnit: $8ac3122ed2a8618b$var$baseUnit,
    controlHeight: $8ac3122ed2a8618b$var$controlHeight,
    menuGutter: $8ac3122ed2a8618b$var$menuGutter
};
var $8ac3122ed2a8618b$export$407448d2b89b1813 = {
    borderRadius: $8ac3122ed2a8618b$var$borderRadius,
    colors: $8ac3122ed2a8618b$var$colors,
    spacing: $8ac3122ed2a8618b$var$spacing
};
function $8ac3122ed2a8618b$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ac3122ed2a8618b$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8ac3122ed2a8618b$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8ac3122ed2a8618b$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8ac3122ed2a8618b$var$_createSuper$4(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$export$4368d992c4eafac0 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $32kym.w)(),
    captureMenuScroll: !(0, $32kym.w)(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $8ac3122ed2a8618b$export$db3b6bfb95261072(),
    formatGroupLabel: $8ac3122ed2a8618b$var$formatGroupLabel,
    getOptionLabel: $8ac3122ed2a8618b$var$getOptionLabel,
    getOptionValue: $8ac3122ed2a8618b$var$getOptionValue,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $8ac3122ed2a8618b$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $32kym.x)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: "0",
    tabSelectsValue: true
};
var $8ac3122ed2a8618b$var$instanceId = 1;
var $8ac3122ed2a8618b$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(Select, _Component);
    var _super = $8ac3122ed2a8618b$var$_createSuper$4(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $6CZeq.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaLiveSelection: "",
            ariaLiveContext: "",
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            menuOptions: {
                render: [],
                focusable: []
            },
            selectValue: []
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.clearFocusValueOnUpdate = false;
        _this.commonProps = void 0;
        _this.components = void 0;
        _this.hasGroups = false;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.inputIsHiddenAfterUpdate = void 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.cacheComponents = function(components) {
            _this.components = (0, $32kym.y)({
                components: components
            });
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            onChange(newValue, $8ac3122ed2a8618b$var$_objectSpread$2($8ac3122ed2a8618b$var$_objectSpread$2({}, actionMeta), {}, {
                name: name
            }));
        };
        _this.setValue = function(newValue) {
            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "set-value";
            var option = arguments.length > 2 ? arguments[2] : undefined;
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti;
            _this.onInputChange("", {
                action: "set-value"
            });
            if (closeMenuOnSelect) {
                _this.inputIsHiddenAfterUpdate = !isMulti;
                _this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            _this.clearFocusValueOnUpdate = true;
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti;
            var selectValue = _this.state.selectValue;
            if (isMulti) {
                if (_this.isOptionSelected(newValue, selectValue)) {
                    var candidate = _this.getOptionValue(newValue);
                    _this.setValue(selectValue.filter(function(i) {
                        return _this.getOptionValue(i) !== candidate;
                    }), "deselect-option", newValue);
                    _this.announceAriaLiveSelection({
                        event: "deselect-option",
                        context: {
                            value: _this.getOptionLabel(newValue)
                        }
                    });
                } else if (!_this.isOptionDisabled(newValue, selectValue)) {
                    _this.setValue([].concat((0, $kbxxf.default)(selectValue), [
                        newValue
                    ]), "select-option", newValue);
                    _this.announceAriaLiveSelection({
                        event: "select-option",
                        context: {
                            value: _this.getOptionLabel(newValue)
                        }
                    });
                } else // announce that option is disabled
                _this.announceAriaLiveSelection({
                    event: "select-option",
                    context: {
                        value: _this.getOptionLabel(newValue),
                        isDisabled: true
                    }
                });
            } else if (!_this.isOptionDisabled(newValue, selectValue)) {
                _this.setValue(newValue, "select-option");
                _this.announceAriaLiveSelection({
                    event: "select-option",
                    context: {
                        value: _this.getOptionLabel(newValue)
                    }
                });
            } else // announce that option is disabled
            _this.announceAriaLiveSelection({
                event: "select-option",
                context: {
                    value: _this.getOptionLabel(newValue),
                    isDisabled: true
                }
            });
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValue = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            _this.onChange(newValue.length ? newValue : null, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.announceAriaLiveSelection({
                event: "remove-value",
                context: {
                    value: removedValue ? _this.getOptionLabel(removedValue) : ""
                }
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            _this.onChange(null, {
                action: "clear"
            });
        };
        _this.popValue = function() {
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValue = selectValue.slice(0, selectValue.length - 1);
            _this.announceAriaLiveSelection({
                event: "pop-value",
                context: {
                    value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ""
                }
            });
            _this.onChange(newValue.length ? newValue : null, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $32kym.z).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return _this.props.getOptionLabel(data);
        };
        _this.getOptionValue = function(data) {
            return _this.props.getOptionValue(data);
        };
        _this.getStyles = function(key, props) {
            var base = $8ac3122ed2a8618b$var$defaultStyles[key](props);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getActiveDescendentId = function() {
            var menuIsOpen = _this.props.menuIsOpen;
            var _this$state = _this.state, menuOptions = _this$state.menuOptions, focusedOption = _this$state.focusedOption;
            if (!focusedOption || !menuIsOpen) return undefined;
            var index = menuOptions.focusable.indexOf(focusedOption);
            var option = menuOptions.render[index];
            return option && option.key;
        };
        _this.announceAriaLiveSelection = function(_ref2) {
            var event = _ref2.event, context = _ref2.context;
            _this.setState({
                ariaLiveSelection: $8ac3122ed2a8618b$var$valueEventAriaMessage(event, context)
            });
        };
        _this.announceAriaLiveContext = function(_ref3) {
            var event = _ref3.event, context = _ref3.context;
            _this.setState({
                ariaLiveContext: $8ac3122ed2a8618b$var$instructionsAriaMessage(event, $8ac3122ed2a8618b$var$_objectSpread$2($8ac3122ed2a8618b$var$_objectSpread$2({}, context), {}, {
                    label: _this.props["aria-label"]
                }))
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.inputIsHiddenAfterUpdate = !isMulti;
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $32kym.A)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref4) {
            var touches = _ref4.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref5) {
            var touches = _ref5.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return; // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
             // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var inputValue = event.currentTarget.value;
            _this.inputIsHiddenAfterUpdate = false;
            _this.onInputChange(inputValue, {
                action: "input-change"
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            var _this$props5 = _this.props, isSearchable = _this$props5.isSearchable, isMulti = _this$props5.isMulti;
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.inputIsHiddenAfterUpdate = false;
            _this.announceAriaLiveContext({
                event: "input",
                context: {
                    isSearchable: isSearchable,
                    isMulti: isMulti
                }
            });
            _this.setState({
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur"
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            var _this$props6 = _this.props, hideSelectedOptions = _this$props6.hideSelectedOptions, isMulti = _this$props6.isMulti;
            if (hideSelectedOptions === undefined) return isMulti;
            return hideSelectedOptions;
        };
        _this.onKeyDown = function(event) {
            var _this$props7 = _this.props, isMulti = _this$props7.isMulti, backspaceRemovesValue = _this$props7.backspaceRemovesValue, escapeClearsValue = _this$props7.escapeClearsValue, inputValue = _this$props7.inputValue, isClearable = _this$props7.isClearable, isDisabled = _this$props7.isDisabled, menuIsOpen = _this$props7.menuIsOpen, onKeyDown = _this$props7.onKeyDown, tabSelectsValue = _this$props7.tabSelectsValue, openMenuOnFocus = _this$props7.openMenuOnFocus;
            var _this$state2 = _this.state, focusedOption = _this$state2.focusedOption, focusedValue = _this$state2.focusedValue, selectValue = _this$state2.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.inputIsHiddenAfterUpdate = false;
                        _this.onInputChange("", {
                            action: "menu-close"
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.buildMenuOptions = function(props, selectValue) {
            var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue, options = props.options;
            var toOption = function toOption(option, id) {
                var isDisabled = _this.isOptionDisabled(option, selectValue);
                var isSelected = _this.isOptionSelected(option, selectValue);
                var label = _this.getOptionLabel(option);
                var value = _this.getOptionValue(option);
                if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
                    label: label,
                    value: value,
                    data: option
                }, inputValue)) return;
                var onHover = isDisabled ? undefined : function() {
                    return _this.onOptionHover(option);
                };
                var onSelect = isDisabled ? undefined : function() {
                    return _this.selectOption(option);
                };
                var optionId = "".concat(_this.getElementId("option"), "-").concat(id);
                return {
                    innerProps: {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    },
                    data: option,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: "option",
                    value: value
                };
            };
            return options.reduce(function(acc, item, itemIndex) {
                if (item.options) {
                    // TODO needs a tidier implementation
                    if (!_this.hasGroups) _this.hasGroups = true;
                    var items = item.options;
                    var children = items.map(function(child, i) {
                        var option = toOption(child, "".concat(itemIndex, "-").concat(i));
                        if (option) acc.focusable.push(child);
                        return option;
                    }).filter(Boolean);
                    if (children.length) {
                        var groupId = "".concat(_this.getElementId("group"), "-").concat(itemIndex);
                        acc.render.push({
                            type: "group",
                            key: groupId,
                            data: item,
                            options: children
                        });
                    }
                } else {
                    var option = toOption(item, "".concat(itemIndex));
                    if (option) {
                        acc.render.push(option);
                        acc.focusable.push(item);
                    }
                }
                return acc;
            }, {
                render: [],
                focusable: []
            });
        };
        var _value = _props.value;
        _this.cacheComponents = (0, $jk22o.default)(_this.cacheComponents, (0, $32kym.B)).bind((0, $hDpcU.default)(_this));
        _this.cacheComponents(_props.components);
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$8ac3122ed2a8618b$var$instanceId);
        var _selectValue = (0, $32kym.C)(_value);
        _this.buildMenuOptions = (0, $jk22o.default)(_this.buildMenuOptions, function(newArgs, lastArgs) {
            var _ref6 = newArgs, _ref7 = (0, $eUqlC.default)(_ref6, 2), newProps = _ref7[0], newSelectValue = _ref7[1];
            var _ref8 = lastArgs, _ref9 = (0, $eUqlC.default)(_ref8, 2), lastProps = _ref9[0], lastSelectValue = _ref9[1];
            return newSelectValue === lastSelectValue && newProps.inputValue === lastProps.inputValue && newProps.options === lastProps.options;
        }).bind((0, $hDpcU.default)(_this));
        var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
            render: [],
            focusable: []
        };
        _this.state.menuOptions = _menuOptions;
        _this.state.selectValue = _selectValue;
        return _this;
    }
    (0, $cHPF9.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var _this$props8 = this.props, options = _this$props8.options, value = _this$props8.value, menuIsOpen = _this$props8.menuIsOpen, inputValue = _this$props8.inputValue; // re-cache custom components
                this.cacheComponents(nextProps.components); // rebuild the menu options
                if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
                    var selectValue = (0, $32kym.C)(nextProps.value);
                    var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
                        render: [],
                        focusable: []
                    };
                    var focusedValue = this.getNextFocusedValue(selectValue);
                    var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
                    this.setState({
                        menuOptions: menuOptions,
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue
                    });
                } // some updates should toggle the state of the input visibility
                if (this.inputIsHiddenAfterUpdate != null) {
                    this.setState({
                        inputIsHidden: this.inputIsHiddenAfterUpdate
                    });
                    delete this.inputIsHiddenAfterUpdate;
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props9 = this.props, isDisabled = _this$props9.isDisabled, menuIsOpen = _this$props9.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                 // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $32kym.D)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            // ==============================
            // Consumer Handlers
            // ==============================
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                var _this$props10 = this.props, isSearchable = _this$props10.isSearchable, isMulti = _this$props10.isMulti;
                this.announceAriaLiveContext({
                    event: "input",
                    context: {
                        isSearchable: isSearchable,
                        isMulti: isMulti
                    }
                });
                this.onInputChange("", {
                    action: "menu-close"
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            } // ==============================
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            } // aliased for consumers
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, isFocused = _this$state3.isFocused;
                var menuOptions = this.buildMenuOptions(this.props, selectValue);
                var _this$props11 = this.props, isMulti = _this$props11.isMulti, tabSelectsValue = _this$props11.tabSelectsValue;
                var openAtIndex = focusOption === "first" ? 0 : menuOptions.focusable.length - 1;
                if (!isMulti) {
                    var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                } // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.inputIsHiddenAfterUpdate = false;
                this.setState({
                    menuOptions: menuOptions,
                    focusedValue: null,
                    focusedOption: menuOptions.focusable[openAtIndex]
                }, function() {
                    _this2.onMenuOpen();
                    _this2.announceAriaLiveContext({
                        event: "menu",
                        context: {
                            tabSelectsValue: tabSelectsValue
                        }
                    });
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$props12 = this.props, isMulti = _this$props12.isMulti, isSearchable = _this$props12.isSearchable;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
                if (!isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) {
                    focusedIndex = -1;
                    this.announceAriaLiveContext({
                        event: "value"
                    });
                }
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                if (nextFocus === -1) this.announceAriaLiveContext({
                    event: "input",
                    context: {
                        isSearchable: isSearchable,
                        isMulti: isMulti
                    }
                });
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var _this$props13 = this.props, pageSize = _this$props13.pageSize, tabSelectsValue = _this$props13.tabSelectsValue;
                var _this$state5 = this.state, focusedOption = _this$state5.focusedOption, menuOptions = _this$state5.menuOptions;
                var options = menuOptions.focusable;
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) {
                    focusedIndex = -1;
                    this.announceAriaLiveContext({
                        event: "menu",
                        context: {
                            tabSelectsValue: tabSelectsValue
                        }
                    });
                }
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
                this.announceAriaLiveContext({
                    event: "menu",
                    context: {
                        isDisabled: $8ac3122ed2a8618b$var$isOptionDisabled(options[nextFocus]),
                        tabSelectsValue: tabSelectsValue
                    }
                });
            }
        },
        {
            key: "getTheme",
            // ==============================
            // Getters
            // ==============================
            value: function getTheme() {
                // Use the default theme if there are no customizations.
                if (!this.props.theme) return $8ac3122ed2a8618b$export$407448d2b89b1813;
                 // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($8ac3122ed2a8618b$export$407448d2b89b1813);
                 // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return $8ac3122ed2a8618b$var$_objectSpread$2($8ac3122ed2a8618b$var$_objectSpread$2({}, $8ac3122ed2a8618b$export$407448d2b89b1813), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, setValue = this.setValue, selectOption = this.selectOption, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    cx: cx,
                    clearValue: clearValue,
                    getStyles: getStyles,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    setValue: setValue,
                    selectProps: props,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "getNextFocusedValue",
            value: function getNextFocusedValue(nextSelectValue) {
                if (this.clearFocusValueOnUpdate) {
                    this.clearFocusValueOnUpdate = false;
                    return null;
                }
                var _this$state6 = this.state, focusedValue = _this$state6.focusedValue, lastSelectValue = _this$state6.selectValue;
                var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
                if (lastFocusedIndex > -1) {
                    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
                    if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
                    return focusedValue;
                    else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
                    // reference, so return the new value at the same index
                    return nextSelectValue[lastFocusedIndex];
                }
                return null;
            }
        },
        {
            key: "getNextFocusedOption",
            value: function getNextFocusedOption(options) {
                var lastFocusedOption = this.state.focusedOption;
                return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.state.menuOptions.render.length;
            }
        },
        {
            key: "countOptions",
            value: function countOptions() {
                return this.state.menuOptions.focusable.length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props14 = this.props, isClearable = _this$props14.isClearable, isMulti = _this$props14.isMulti; // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return typeof this.props.isOptionDisabled === "function" ? this.props.isOptionDisabled(option, selectValue) : false;
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                var _this3 = this;
                if (selectValue.indexOf(option) > -1) return true;
                if (typeof this.props.isOptionSelected === "function") return this.props.isOptionSelected(option, selectValue);
                var candidate = this.getOptionValue(option);
                return selectValue.some(function(i) {
                    return _this3.getOptionValue(i) === candidate;
                });
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            } // ==============================
        },
        {
            key: "startListeningComposition",
            // ==============================
            // Composition Handlers
            // ==============================
            value: function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            // ==============================
            // Touch Handlers
            // ==============================
            value: function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "constructAriaLiveMessage",
            // ==============================
            // Renderers
            // ==============================
            value: function constructAriaLiveMessage() {
                var _this$state7 = this.state, ariaLiveContext = _this$state7.ariaLiveContext, selectValue = _this$state7.selectValue, focusedValue = _this$state7.focusedValue, focusedOption = _this$state7.focusedOption;
                var _this$props15 = this.props, options = _this$props15.options, menuIsOpen = _this$props15.menuIsOpen, inputValue = _this$props15.inputValue, screenReaderStatus = _this$props15.screenReaderStatus; // An aria live message representing the currently focused value in the select.
                var focusedValueMsg = focusedValue ? $8ac3122ed2a8618b$var$valueFocusAriaMessage({
                    focusedValue: focusedValue,
                    getOptionLabel: this.getOptionLabel,
                    selectValue: selectValue
                }) : ""; // An aria live message representing the currently focused option in the select.
                var focusedOptionMsg = focusedOption && menuIsOpen ? $8ac3122ed2a8618b$var$optionFocusAriaMessage({
                    focusedOption: focusedOption,
                    getOptionLabel: this.getOptionLabel,
                    options: options
                }) : ""; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
                var resultsMsg = $8ac3122ed2a8618b$var$resultsAriaMessage({
                    inputValue: inputValue,
                    screenReaderMessage: screenReaderStatus({
                        count: this.countOptions()
                    })
                });
                return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
            }
        },
        {
            key: "renderInput",
            value: function renderInput() {
                var _this$props16 = this.props, isDisabled = _this$props16.isDisabled, isSearchable = _this$props16.isSearchable, inputId = _this$props16.inputId, inputValue = _this$props16.inputValue, tabIndex = _this$props16.tabIndex, form = _this$props16.form;
                var Input = this.components.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var id = inputId || this.getElementId("input"); // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = {
                    "aria-autocomplete": "list",
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"]
                };
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$DummyInput, (0, $8nd05.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $32kym.E),
                    onFocus: this.onInputFocus,
                    readOnly: true,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    form: form,
                    value: ""
                }, ariaAttributes));
                var _this$commonProps = this.commonProps, cx = _this$commonProps.cx, theme = _this$commonProps.theme, selectProps = _this$commonProps.selectProps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Input, (0, $8nd05.default)({
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    cx: cx,
                    getStyles: this.getStyles,
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    selectProps: selectProps,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    theme: theme,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this4 = this;
                var _this$components = this.components, MultiValue = _this$components.MultiValue, MultiValueContainer = _this$components.MultiValueContainer, MultiValueLabel = _this$components.MultiValueLabel, MultiValueRemove = _this$components.MultiValueRemove, SingleValue = _this$components.SingleValue, Placeholder = _this$components.Placeholder;
                var commonProps = this.commonProps;
                var _this$props17 = this.props, controlShouldRenderValue = _this$props17.controlShouldRenderValue, isDisabled = _this$props17.isDisabled, isMulti = _this$props17.isMulti, inputValue = _this$props17.inputValue, placeholder = _this$props17.placeholder;
                var _this$state8 = this.state, selectValue = _this$state8.selectValue, focusedValue = _this$state8.focusedValue, isFocused = _this$state8.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Placeholder, (0, $8nd05.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), placeholder);
                if (isMulti) {
                    var selectValues = selectValue.map(function(opt, index) {
                        var isOptionFocused = opt === focusedValue;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MultiValue, (0, $8nd05.default)({}, commonProps, {
                            components: {
                                Container: MultiValueContainer,
                                Label: MultiValueLabel,
                                Remove: MultiValueRemove
                            },
                            isFocused: isOptionFocused,
                            isDisabled: isDisabled,
                            key: "".concat(_this4.getOptionValue(opt)).concat(index),
                            index: index,
                            removeProps: {
                                onClick: function onClick() {
                                    return _this4.removeValue(opt);
                                },
                                onTouchEnd: function onTouchEnd() {
                                    return _this4.removeValue(opt);
                                },
                                onMouseDown: function onMouseDown(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            },
                            data: opt
                        }), _this4.formatOptionLabel(opt, "value"));
                    });
                    return selectValues;
                }
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SingleValue, (0, $8nd05.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var ClearIndicator = this.components.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props18 = this.props, isDisabled = _this$props18.isDisabled, isLoading = _this$props18.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ClearIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var LoadingIndicator = this.components.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props19 = this.props, isDisabled = _this$props19.isDisabled, isLoading = _this$props19.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$components2 = this.components, DropdownIndicator = _this$components2.DropdownIndicator, IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorSeparator, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var DropdownIndicator = this.components.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DropdownIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this5 = this;
                var _this$components3 = this.components, Group = _this$components3.Group, GroupHeading = _this$components3.GroupHeading, Menu = _this$components3.Menu, MenuList = _this$components3.MenuList, MenuPortal = _this$components3.MenuPortal, LoadingMessage = _this$components3.LoadingMessage, NoOptionsMessage = _this$components3.NoOptionsMessage, Option = _this$components3.Option;
                var commonProps = this.commonProps;
                var _this$state9 = this.state, focusedOption = _this$state9.focusedOption, menuOptions = _this$state9.menuOptions;
                var _this$props20 = this.props, captureMenuScroll = _this$props20.captureMenuScroll, inputValue = _this$props20.inputValue, isLoading = _this$props20.isLoading, loadingMessage = _this$props20.loadingMessage, minMenuHeight = _this$props20.minMenuHeight, maxMenuHeight = _this$props20.maxMenuHeight, menuIsOpen = _this$props20.menuIsOpen, menuPlacement = _this$props20.menuPlacement, menuPosition = _this$props20.menuPosition, menuPortalTarget = _this$props20.menuPortalTarget, menuShouldBlockScroll = _this$props20.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props20.menuShouldScrollIntoView, noOptionsMessage = _this$props20.noOptionsMessage, onMenuScrollToTop = _this$props20.onMenuScrollToTop, onMenuScrollToBottom = _this$props20.onMenuScrollToBottom;
                if (!menuIsOpen) return null; // TODO: Internal Option Type here
                var render = function render(props) {
                    // for performance, the menu options in state aren't changed when the
                    // focused option changes so we calculate additional props based on that
                    var isFocused = focusedOption === props.data;
                    props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Option, (0, $8nd05.default)({}, commonProps, props, {
                        isFocused: isFocused
                    }), _this5.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = menuOptions.render.map(function(item) {
                    if (item.type === "group") {
                        var type = item.type, group = (0, $9X7IJ.default)(item, [
                            "type"
                        ]);
                        var headingId = "".concat(item.key, "-heading");
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Group, (0, $8nd05.default)({}, commonProps, group, {
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this5.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option);
                        }));
                    } else if (item.type === "option") return render(item);
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32kym.M), (0, $8nd05.default)({}, commonProps, menuPlacementProps), function(_ref10) {
                    var ref = _ref10.ref, _ref10$placerProps = _ref10.placerProps, placement = _ref10$placerProps.placement, maxHeight = _ref10$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Menu, (0, $8nd05.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this5.onMenuMouseDown,
                            onMouseMove: _this5.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$ScrollCaptorSwitch, {
                        isEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$ScrollBlock, {
                        isEnabled: menuShouldBlockScroll
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuList, (0, $8nd05.default)({}, commonProps, {
                        innerRef: _this5.getMenuListRef,
                        isLoading: isLoading,
                        maxHeight: maxHeight
                    }), menuUI))));
                }); // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuPortal, (0, $8nd05.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this6 = this;
                var _this$props21 = this.props, delimiter = _this$props21.delimiter, isDisabled = _this$props21.isDisabled, isMulti = _this$props21.isMulti, name = _this$props21.name;
                var selectValue = this.state.selectValue;
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this6.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this6.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden"
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, input);
                    }
                } else {
                    var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value2
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                if (!this.state.isFocused) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$A11yText, {
                    "aria-live": "polite"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    id: "aria-selection-event"
                }, "\xa0", this.state.ariaLiveSelection), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    id: "aria-context"
                }, "\xa0", this.constructAriaLiveMessage()));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$components4 = this.components, Control = _this$components4.Control, IndicatorsContainer = _this$components4.IndicatorsContainer, SelectContainer = _this$components4.SelectContainer, ValueContainer = _this$components4.ValueContainer;
                var _this$props22 = this.props, className = _this$props22.className, id = _this$props22.id, isDisabled = _this$props22.isDisabled, menuIsOpen = _this$props22.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectContainer, (0, $8nd05.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Control, (0, $8nd05.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ValueContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorsContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$8ac3122ed2a8618b$export$25ce5a424b770e84.defaultProps = $8ac3122ed2a8618b$export$4368d992c4eafac0;

});
parcelRegister("eUqlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaabbc18727b3e6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $guSBA = parcelRequire("guSBA");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1uEeT.default)(r) || (0, $guSBA.default)(r, e) || (0, $abLc2.default)(r, e) || (0, $782Uh.default)();
}

});
parcelRegister("1uEeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ce760980f343$export$2e2bcd8739ae039);
function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("guSBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c029ce1ef065e371$export$2e2bcd8739ae039);
function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("782Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $530b88ff20858fe6$export$2e2bcd8739ae039);
function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jk22o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e111773323c0bcc0$export$2e2bcd8739ae039);
var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e111773323c0bcc0$export$2e2bcd8739ae039 = $e111773323c0bcc0$var$memoizeOne;

});


parcelRegister("gS6QF", function(module, exports) {
function $c4870074adc2be76$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $c4870074adc2be76$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e9Jgd", function(module, exports) {

$parcel$export(module.exports, "m", () => $a4e503baa4efcfb1$export$953cecd6e717a553);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");
function $a4e503baa4efcfb1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a4e503baa4efcfb1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $a4e503baa4efcfb1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $a4e503baa4efcfb1$var$defaultProps = {
    defaultInputValue: "",
    defaultMenuIsOpen: false,
    defaultValue: null
};
var $a4e503baa4efcfb1$export$953cecd6e717a553 = function manageState(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $1gYAD.default)(StateManager, _Component);
        var _super = $a4e503baa4efcfb1$var$_createSuper(StateManager);
        function StateManager() {
            var _this;
            (0, $6CZeq.default)(this, StateManager);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _this.select = void 0;
            _this.state = {
                inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
                menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
                value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
            };
            _this.onChange = function(value, actionMeta) {
                _this.callProp("onChange", value, actionMeta);
                _this.setState({
                    value: value
                });
            };
            _this.onInputChange = function(value, actionMeta) {
                // TODO: for backwards compatibility, we allow the prop to return a new
                // value, but now inputValue is a controllable prop we probably shouldn't
                var newValue = _this.callProp("onInputChange", value, actionMeta);
                _this.setState({
                    inputValue: newValue !== undefined ? newValue : value
                });
            };
            _this.onMenuOpen = function() {
                _this.callProp("onMenuOpen");
                _this.setState({
                    menuIsOpen: true
                });
            };
            _this.onMenuClose = function() {
                _this.callProp("onMenuClose");
                _this.setState({
                    menuIsOpen: false
                });
            };
            return _this;
        }
        (0, $cHPF9.default)(StateManager, [
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                } // FIXME: untyped flow code, return any
            },
            {
                key: "getProp",
                value: function getProp(key) {
                    return this.props[key] !== undefined ? this.props[key] : this.state[key];
                } // FIXME: untyped flow code, return any
            },
            {
                key: "callProp",
                value: function callProp(name) {
                    if (typeof this.props[name] === "function") {
                        var _this$props;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        return (_this$props = this.props)[name].apply(_this$props, args);
                    }
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var _this$props2 = this.props, defaultInputValue = _this$props2.defaultInputValue, defaultMenuIsOpen = _this$props2.defaultMenuIsOpen, defaultValue = _this$props2.defaultValue, props = (0, $9X7IJ.default)(_this$props2, [
                        "defaultInputValue",
                        "defaultMenuIsOpen",
                        "defaultValue"
                    ]);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectComponent, (0, $8nd05.default)({}, props, {
                        ref: function ref(_ref) {
                            _this2.select = _ref;
                        },
                        inputValue: this.getProp("inputValue"),
                        menuIsOpen: this.getProp("menuIsOpen"),
                        onChange: this.onChange,
                        onInputChange: this.onInputChange,
                        onMenuClose: this.onMenuClose,
                        onMenuOpen: this.onMenuOpen,
                        value: this.getProp("value")
                    }));
                }
            }
        ]);
        return StateManager;
    }((0, $acw62.Component)), _class.defaultProps = $a4e503baa4efcfb1$var$defaultProps, _temp;
};

});



parcelRegister("ivILl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $d79dd82f0d3f9b3f$export$1e511d4a378977f5, (v) => $d79dd82f0d3f9b3f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d79dd82f0d3f9b3f$export$2e2bcd8739ae039, (v) => $d79dd82f0d3f9b3f$export$2e2bcd8739ae039 = v);
var $d79dd82f0d3f9b3f$export$1e511d4a378977f5;
var $d79dd82f0d3f9b3f$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$d79dd82f0d3f9b3f$export$1e511d4a378977f5 = true;
$d79dd82f0d3f9b3f$export$2e2bcd8739ae039 = void 0;

var $b4nCt = parcelRequire("b4nCt");

var $d79dd82f0d3f9b3f$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $d79dd82f0d3f9b3f$var$_react = $d79dd82f0d3f9b3f$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jHTLJ");
var $hrvfy = parcelRequire("hrvfy");

var $d79dd82f0d3f9b3f$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $jMcIG = parcelRequire("jMcIG");

var $6zLPD = parcelRequire("6zLPD");

var $d79dd82f0d3f9b3f$var$_getUserCountry = $1jnue((parcelRequire("uKJdY")));

var $d79dd82f0d3f9b3f$var$_countryInfo = $1jnue((parcelRequire("30Fb0")));
function $d79dd82f0d3f9b3f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d79dd82f0d3f9b3f$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $d79dd82f0d3f9b3f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $d79dd82f0d3f9b3f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $d79dd82f0d3f9b3f$var$getCurrencyFormatRules = (country)=>{
    var _countryInfo$country;
    const defaultCurrency = {
        decimal: ".",
        digitsAfterDecimal: 2,
        postfix: "",
        prefix: "$",
        thousands: ","
    };
    return {
        ...defaultCurrency,
        ...(_countryInfo$country = $d79dd82f0d3f9b3f$var$_countryInfo.default[country]) === null || _countryInfo$country === void 0 ? void 0 : _countryInfo$country.currency
    };
};
const $d79dd82f0d3f9b3f$var$CurrencyInput = ({ country: country, reduxSetCountry: reduxSetCountry, setAmount: setAmount })=>{
    const [rawInput, setRawInput] = (0, $d79dd82f0d3f9b3f$var$_react.useState)(0);
    const [formattedPrice, setFormattedPrice] = (0, $d79dd82f0d3f9b3f$var$_react.useState)("");
    const translate = (0, $d79dd82f0d3f9b3f$var$_useTranslate.default)();
    !country && reduxSetCountry((0, $d79dd82f0d3f9b3f$var$_getUserCountry.default)());
    const priceFormatOptions = $d79dd82f0d3f9b3f$var$getCurrencyFormatRules(country);
    const handleKeyDown = (event)=>{
        const { key: key } = event;
        if (!Number.isNaN(Number(key))) {
            const newNumber = rawInput === 0 ? key : `${rawInput}${key}`;
            setRawInput(Number(newNumber));
            setAmount(Number(newNumber) / 10 ** priceFormatOptions.digitsAfterDecimal);
            setFormattedPrice((0, $6zLPD.formatCurrency)(newNumber, priceFormatOptions).slice(0, -1));
        } else if ([
            "Backspace",
            "Delete"
        ].includes(key)) {
            const priceString = `${rawInput}`;
            const newNumber = priceString.slice(0, priceString.length - 1);
            setRawInput(Number(newNumber));
            setAmount(Number(newNumber) / 10 ** priceFormatOptions.digitsAfterDecimal);
            setFormattedPrice((0, $6zLPD.formatCurrency)(newNumber, priceFormatOptions));
        }
    };
    return /*#__PURE__*/ $d79dd82f0d3f9b3f$var$_react.default.createElement($b4nCt.TextFieldStyled, {
        error: !rawInput,
        inputmode: "numeric",
        label: translate("RL_NewPrice"),
        requiredIndicator: "*",
        unitPrefix: priceFormatOptions.prefix,
        unitSuffix: priceFormatOptions.postfix,
        value: formattedPrice,
        onChange: ()=>{},
        onKeyDown: handleKeyDown
    });
};
$d79dd82f0d3f9b3f$var$CurrencyInput.propTypes = {
    country: $d79dd82f0d3f9b3f$var$_propTypes.default.string.isRequired,
    reduxSetCountry: $d79dd82f0d3f9b3f$var$_propTypes.default.func.isRequired,
    setAmount: $d79dd82f0d3f9b3f$var$_propTypes.default.func.isRequired
};
const $d79dd82f0d3f9b3f$var$mapStateToProps = ({ country: country })=>({
        country: country
    });
const $d79dd82f0d3f9b3f$var$mapDispatchToProps = (dispatch)=>({
        reduxSetCountry: (country)=>dispatch((0, $jMcIG.setCountry)(country))
    });
var $d79dd82f0d3f9b3f$var$_default = $d79dd82f0d3f9b3f$export$2e2bcd8739ae039 = (0, $hrvfy.default)($d79dd82f0d3f9b3f$var$mapStateToProps, $d79dd82f0d3f9b3f$var$mapDispatchToProps)($d79dd82f0d3f9b3f$var$CurrencyInput);

});
parcelRegister("b4nCt", function(module, exports) {

$parcel$export(module.exports, "TextFieldStyled", () => $80f263cad0ae2495$export$bec18608def21161);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");

var $9D53m = parcelRequire("9D53m");

var $iKfPk = parcelRequire("iKfPk");
var $eueDD = parcelRequire("eueDD");
var $hwhVv = parcelRequire("hwhVv");
var $3tf6i = parcelRequire("3tf6i");
var $lTHug = parcelRequire("lTHug");
var $k4ICp = parcelRequire("k4ICp");
var $asRz0 = parcelRequire("asRz0");

var $aeMRX = parcelRequire("aeMRX");
var $80f263cad0ae2495$var$s = {
    Input: (0, $eueDD.InputStyled),
    Label: (0, $hwhVv.LabelStyled),
    UnitPrefix: (0, $k4ICp.UnitPrefixStyled),
    UnitSuffix: (0, $asRz0.UnitSuffixStyled),
    TrailingIcon: (0, $lTHug.TrailingIconStyled),
    SupportText: (0, $3tf6i.SupportTextStyled),
    CharacterCount: (0, $iKfPk.CharacterCountStyled)
}, $80f263cad0ae2495$var$x = (0, $acw62.forwardRef)(function(e, r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9D53m.TextField), Object.assign({}, $80f263cad0ae2495$var$s, e, {
        ref: r
    }));
});
$80f263cad0ae2495$var$x.displayName = "TextFieldStyledComps";
var $80f263cad0ae2495$export$bec18608def21161 = (0, $1poQt.default)($80f263cad0ae2495$var$x, {
    target: "e192pr2z0"
})((0, $aeMRX.baseStyles));
$80f263cad0ae2495$export$bec18608def21161.displayName = "TextFieldStyled";

});
parcelRegister("9D53m", function(module, exports) {

$parcel$export(module.exports, "TextField", () => $702bad0567e0551e$export$2c73285ae9390cec);

var $1SA7b = parcelRequire("1SA7b");

var $acw62 = parcelRequire("acw62");

var $4dCgP = parcelRequire("4dCgP");
var $3cu5Z = parcelRequire("3cu5Z");
var $OFYOC = parcelRequire("OFYOC");
var $a4jPb = parcelRequire("a4jPb");
var $gxtdB = parcelRequire("gxtdB");
var $90LPq = parcelRequire("90LPq");
var $kR6L7 = parcelRequire("kR6L7");
var $2oLsu = parcelRequire("2oLsu");
function $702bad0567e0551e$var$e(e, n) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var n = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
        if (null == n) return;
        var r, i, a = [], o = !0, s = !1;
        try {
            for(n = n.call(e); !(o = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); o = !0);
        } catch (e) {
            s = !0, i = e;
        } finally{
            try {
                o || null == n.return || n.return();
            } finally{
                if (s) throw i;
            }
        }
        return a;
    }(e, n) || function(e, n) {
        if (!e) return;
        if ("string" == typeof e) return $702bad0567e0551e$var$t(e, n);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $702bad0567e0551e$var$t(e, n);
    }(e, n) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $702bad0567e0551e$var$t(e, t) {
    var n, r;
    for((null == t || t > e.length) && (t = e.length), n = 0, r = new Array(t); n < t; n++)r[n] = e[n];
    return r;
}
var $702bad0567e0551e$var$n = undefined && undefined.__rest || function(e, t) {
    var n, r = {};
    for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(n = 0, i = Object.getOwnPropertySymbols(e); n < i.length; n++)t.indexOf(i[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[n]) && (r[i[n]] = e[i[n]]);
    return r;
};
var $702bad0567e0551e$export$2c73285ae9390cec = (0, $acw62.forwardRef)(function(t, s) {
    var v, h = t.Input, g = void 0 === h ? (0, $3cu5Z.Input) : h, y = t.InputProps, C = t.Label, b = void 0 === C ? (0, $a4jPb.Label) : C, I = t.LabelProps, P = t.UnitPrefix, O = void 0 === P ? (0, $kR6L7.UnitPrefix) : P, T = t.UnitPrefixProps, S = t.UnitSuffix, L = void 0 === S ? (0, $2oLsu.UnitSuffix) : S, j = t.UnitSuffixProps, A = t.TrailingIcon, N = void 0 === A ? (0, $90LPq.TrailingIcon) : A, E = t.TrailingIconProps, U = t.SupportText, M = void 0 === U ? (0, $gxtdB.SupportText) : U, w = t.SupportTextProps, F = t.CharacterCount, k = void 0 === F ? (0, $4dCgP.CharacterCount) : F, q = t.CharacterCountProps, R = t.classes, B = void 0 === R ? {} : R, V = t.type, _ = void 0 === V ? "text" : V, $ = t.name, z = t.id, D = t.label, G = t.value, H = t.className, J = void 0 === H ? "nds-input-container" : H, K = t.minLength, Q = t.maxLength, W = t.placeholder, X = t.autoComplete, Y = void 0 === X ? "on" : X, Z = t.onChange, ee = t.onFocus, te = t.onBlur, ne = t.requiredIndicator, re = t.unitPrefix, ie = t.unitSuffix, ae = t.a11yMaxLengthAnnouncement, oe = t.supportText, se = t.shouldMakeActive, ce = t.error, ue = void 0 !== ce && ce, le = t.readOnly, pe = t.errorMessage, fe = t.showCharacterCount, de = t.a11yCharactersRemainingMessage, me = t.trailingIconContent, xe = t.iconTitle, ve = t.onIconClick, he = t.ariaLive, ge = void 0 === he ? "polite" : he, ye = t.pattern, Ce = t.inputmode, be = t.PrefixIconComponent, Ie = t.PrefixIconComponentProps, Pe = $702bad0567e0551e$var$n(t, [
        "Input",
        "InputProps",
        "Label",
        "LabelProps",
        "UnitPrefix",
        "UnitPrefixProps",
        "UnitSuffix",
        "UnitSuffixProps",
        "TrailingIcon",
        "TrailingIconProps",
        "SupportText",
        "SupportTextProps",
        "CharacterCount",
        "CharacterCountProps",
        "classes",
        "type",
        "name",
        "id",
        "label",
        "value",
        "className",
        "minLength",
        "maxLength",
        "placeholder",
        "autoComplete",
        "onChange",
        "onFocus",
        "onBlur",
        "requiredIndicator",
        "unitPrefix",
        "unitSuffix",
        "a11yMaxLengthAnnouncement",
        "supportText",
        "shouldMakeActive",
        "error",
        "readOnly",
        "errorMessage",
        "showCharacterCount",
        "a11yCharactersRemainingMessage",
        "trailingIconContent",
        "iconTitle",
        "onIconClick",
        "ariaLive",
        "pattern",
        "inputmode",
        "PrefixIconComponent",
        "PrefixIconComponentProps"
    ]), Oe = $702bad0567e0551e$var$e((0, $acw62.useState)(G || ""), 2), Te = Oe[0], Se = Oe[1], Le = $702bad0567e0551e$var$e((0, $acw62.useState)(null !== (v = (null == y ? void 0 : y.autoFocus) || se) && void 0 !== v && v), 2), je = Le[0], Ae = Le[1], Ne = $702bad0567e0551e$var$e((0, $acw62.useState)(!0), 2), Ee = Ne[0], Ue = Ne[1];
    (0, $acw62.useEffect)(function() {
        (G || "" === G) && Se(G), null == G && Se("");
    }, [
        G
    ]);
    var Me = je || Te.length > 0 || !Ee || se, we = (0, $1SA7b.default)(J, "nds-input-container", {
        error: ue,
        active: Me,
        focus: je,
        "input-prefix": re,
        "input-suffix": ie || me
    }), Fe = [];
    re && Fe.push(re), ie && Fe.push(ie);
    var ke = Fe.join(" "), qe = be;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: we
    }, Pe), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "nds-input-layout-control"
    }, re && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(O, Object.assign({
        value: re,
        isActive: Me,
        className: (0, $1SA7b.default)("nds-input-unit-prefix", B.UnitPrefix)
    }, T)), qe && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: "prefix-icon-container"
    }, Ie), qe), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, Object.assign({
        type: _,
        name: $,
        id: z,
        value: Te,
        className: (0, $1SA7b.default)("nds-input-text-field", B.Input, qe ? "has-prefix-icon" : ""),
        minLength: K,
        maxLength: Q,
        requiredIndicator: ne,
        autoComplete: Y,
        onChange: function(e) {
            Se(e.target.value), Z && Z(e);
        },
        onFocus: function(e) {
            Ae(!0), ee && ee(e);
        },
        onBlur: function(e) {
            Ae(!1), s && s.current && "function" == typeof s.current.checkValidity && Ue(s.current.checkValidity()), te && te(e);
        },
        a11yMaxLengthAnnouncement: ae,
        supportText: oe,
        error: ue,
        readOnly: le,
        unitPrefix: re,
        unitSuffix: ie,
        trailingIconContent: me,
        ref: s,
        isActive: Me,
        pattern: ye,
        inputmode: Ce,
        iconTitle: xe,
        a11yCharactersRemainingMessage: de,
        showCharacterCount: fe
    }, y)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(b, Object.assign({
        id: z,
        value: D,
        placeholder: W,
        className: (0, $1SA7b.default)("nds-input-label", B.Label, Me ? "active" : ""),
        requiredIndicator: ne,
        isActive: Me,
        error: ue,
        a11yAdditionalInfo: ke
    }, I)), ie && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(L, Object.assign({
        value: ie,
        className: (0, $1SA7b.default)("nds-input-unit-suffix", B.UnitSuffix),
        isActive: Me
    }, j)), me && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(N, Object.assign({
        className: (0, $1SA7b.default)("nds-input-trailing-icon", B.TrailingIcon),
        value: me,
        onClick: ve,
        iconTitle: xe
    }, E)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $OFYOC.InputFieldset), {
        className: (0, $1SA7b.default)("nds-input-fieldset", B.InputFieldset),
        label: D,
        requiredIndicator: ne,
        isActive: Me
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "textfield-support-container"
    }, oe && !ue && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(M, Object.assign({
        className: (0, $1SA7b.default)("nds-input-support-text", B.SupportText),
        value: oe,
        error: !1,
        ariaLive: ge
    }, w)), pe && ue && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(M, Object.assign({
        className: (0, $1SA7b.default)("nds-input-support-text", B.SupportText),
        value: pe,
        error: !0,
        ariaLive: ge
    }, w)), fe && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(k, Object.assign({
        className: (0, $1SA7b.default)("nds-input-character-count", B.CharacterCount),
        maxLength: Q,
        value: Te.length,
        a11yCharactersRemainingMessage: de
    }, q))));
});
$702bad0567e0551e$export$2c73285ae9390cec.displayName = "TextField";

});
parcelRegister("4dCgP", function(module, exports) {

$parcel$export(module.exports, "CharacterCount", () => $3126100bb5905ac3$export$5740cdd52697d95d);

var $acw62 = parcelRequire("acw62");

var $9iiQA = parcelRequire("9iiQA");

var $5FmI4 = parcelRequire("5FmI4");
var $3126100bb5905ac3$var$e = undefined && undefined.__rest || function(e, t) {
    var a, r = {};
    for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (r[i] = e[i]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(a = 0, i = Object.getOwnPropertySymbols(e); a < i.length; a++)t.indexOf(i[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[a]) && (r[i[a]] = e[i[a]]);
    return r;
};
(0, $9iiQA.visuallyHidden).visibility;
var $3126100bb5905ac3$var$i = $3126100bb5905ac3$var$e((0, $9iiQA.visuallyHidden), [
    "visibility"
]);
var $3126100bb5905ac3$export$5740cdd52697d95d = function(a) {
    var n = a.a11yCharactersRemainingMessage, s = a.className, l = a.maxLength, o = void 0 === l ? 0 : l, c = a.value, m = void 0 === c ? 0 : c, p = $3126100bb5905ac3$var$e(a, [
        "a11yCharactersRemainingMessage",
        "className",
        "maxLength",
        "value"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        className: s,
        "aria-hidden": "true",
        "data-testid": "character-count"
    }, p), m, o && "/".concat(o)), !!n && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "polite",
        style: $3126100bb5905ac3$var$i
    }, (0, $5FmI4.getLocalizedRemainingMessage)(n, o - m, m, o)));
};

});

parcelRegister("3cu5Z", function(module, exports) {

$parcel$export(module.exports, "Input", () => $2549d66ed4dede1b$export$f5b8910cec6cf069);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $9iiQA = parcelRequire("9iiQA");

var $5FmI4 = parcelRequire("5FmI4");
var $2549d66ed4dede1b$var$e = undefined && undefined.__rest || function(e, t) {
    var n, a = {};
    for(var r in e)Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (a[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(n = 0, r = Object.getOwnPropertySymbols(e); n < r.length; n++)t.indexOf(r[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[n]) && (a[r[n]] = e[r[n]]);
    return a;
};
var $2549d66ed4dede1b$export$f5b8910cec6cf069 = (0, $acw62.forwardRef)(function(n, o) {
    var l = n.a11yCharactersRemainingMessage, c = n.a11yMaxLengthAnnouncement, u = n.autoComplete, s = n.className, m = n.error, p = n.id, h = (n.iconTitle, n.inputmode), d = n.max, g = n.maxLength, y = n.min, f = n.minLength, x = n.name, v = n.onBlur, C = n.onChange, O = n.onFocus, b = n.pattern, L = n.placeholder, E = n.readOnly, I = n.requiredIndicator, j = n.showCharacterCount, w = n.supportText, M = n.type, P = n.value, S = (n.unitPrefix, n.unitSuffix, n.trailingIconContent, n.isActive, $2549d66ed4dede1b$var$e(n, [
        "a11yCharactersRemainingMessage",
        "a11yMaxLengthAnnouncement",
        "autoComplete",
        "className",
        "error",
        "id",
        "iconTitle",
        "inputmode",
        "max",
        "maxLength",
        "min",
        "minLength",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "pattern",
        "placeholder",
        "readOnly",
        "requiredIndicator",
        "showCharacterCount",
        "supportText",
        "type",
        "value",
        "unitPrefix",
        "unitSuffix",
        "trailingIconContent",
        "isActive"
    ])), A = P && P.length > 0, F = A ? P.length : 0, T = g || 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (null == P ? void 0 : P.length) === g && c && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "aria-live": "assertive",
        style: (0, $9iiQA.visuallyHidden)
    }, c), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({
        type: M,
        name: x,
        id: p,
        value: P,
        className: (0, $1SA7b.default)(s, A ? "has-value" : ""),
        minLength: f,
        maxLength: g,
        placeholder: L,
        autoComplete: u,
        onChange: C,
        onFocus: O,
        onBlur: v,
        "aria-describedby": "".concat(p, "-input-aria-description"),
        "aria-required": !!I,
        "aria-invalid": m,
        readOnly: E,
        pattern: b,
        ref: o,
        min: y,
        max: d,
        inputMode: h
    }, S)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: "".concat(p, "-input-aria-description"),
        style: (0, $9iiQA.visuallyHidden)
    }, w && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, w), j && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, $5FmI4.getLocalizedRemainingMessage)(l, T - F, P, g))));
});

});

parcelRegister("OFYOC", function(module, exports) {

$parcel$export(module.exports, "InputFieldset", () => $09853bf57994e827$export$3411b4ebfd3f2e66);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");
var $09853bf57994e827$export$ece75e029a085dc1 = function(e) {
    var a = e.className, s = e.isActive, r = e.label, i = e.legendClassName, l = e.requiredIndicator, n = void 0 === l ? "" : l;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("fieldset", {
        className: a
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("legend", {
        "aria-hidden": !s,
        className: i
    }, "".concat(r).concat(n)));
};
var $09853bf57994e827$export$3411b4ebfd3f2e66 = (0, $1poQt.default)($09853bf57994e827$export$ece75e029a085dc1, {
    target: "e1jmt8s30"
})({
    name: "1eif5ff",
    styles: "text-align:start;"
});

});

parcelRegister("gxtdB", function(module, exports) {

$parcel$export(module.exports, "SupportText", () => $c0a66495c8c30380$export$46be7f3c93f85130);

var $acw62 = parcelRequire("acw62");
var $c0a66495c8c30380$var$e = undefined && undefined.__rest || function(e, r) {
    var t, a = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && r.indexOf(o) < 0 && (a[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(t = 0, o = Object.getOwnPropertySymbols(e); t < o.length; t++)r.indexOf(o[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[t]) && (a[o[t]] = e[o[t]]);
    return a;
};
var $c0a66495c8c30380$export$46be7f3c93f85130 = function(t) {
    var a = t.ariaLive, o = t.className, n = t.value, i = (t.error, $c0a66495c8c30380$var$e(t, [
        "ariaLive",
        "className",
        "value",
        "error"
    ]));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        className: o,
        "aria-live": a,
        "data-testid": "support-text"
    }, i), n);
};

});

parcelRegister("90LPq", function(module, exports) {

$parcel$export(module.exports, "TrailingIcon", () => $68f936daa8b5dcb0$export$8ca6d6ccd1150ae1);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");
function $68f936daa8b5dcb0$var$t(t, e) {
    return function(t) {
        if (Array.isArray(t)) return t;
    }(t) || function(t, r) {
        var e = t && ("undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"]);
        if (null == e) return;
        var n, o, a = [], i = !0, l = !1;
        try {
            for(e = e.call(t); !(i = (n = e.next()).done) && (a.push(n.value), !r || a.length !== r); i = !0);
        } catch (t) {
            l = !0, o = t;
        } finally{
            try {
                i || null == e.return || e.return();
            } finally{
                if (l) throw o;
            }
        }
        return a;
    }(t, e) || function(t, e) {
        if (!t) return;
        if ("string" == typeof t) return $68f936daa8b5dcb0$var$r(t, e);
        var n = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === n && t.constructor && (n = t.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(t);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $68f936daa8b5dcb0$var$r(t, e);
    }(t, e) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $68f936daa8b5dcb0$var$r(t, r) {
    var e, n;
    for((null == r || r > t.length) && (r = t.length), e = 0, n = new Array(r); e < r; e++)n[e] = t[e];
    return n;
}
var $68f936daa8b5dcb0$var$e = undefined && undefined.__rest || function(t, r) {
    var e, n = {};
    for(var o in t)Object.prototype.hasOwnProperty.call(t, o) && r.indexOf(o) < 0 && (n[o] = t[o]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) for(e = 0, o = Object.getOwnPropertySymbols(t); e < o.length; e++)r.indexOf(o[e]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[e]) && (n[o[e]] = t[o[e]]);
    return n;
};
var $68f936daa8b5dcb0$export$8ca6d6ccd1150ae1 = function(r) {
    var i, l, c = r.value, u = r.onClick, s = r.className, f = r.iconTitle, p = $68f936daa8b5dcb0$var$e(r, [
        "value",
        "onClick",
        "className",
        "iconTitle"
    ]), y = $68f936daa8b5dcb0$var$t((0, $acw62.useState)(!1), 2), m = y[0], b = y[1], v = "object" == typeof c && (null === (i = c.props) || void 0 === i ? void 0 : i.title), d = v ? c.props.title : f, g = c;
    v && (g = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(c, Object.assign(Object.assign({}, null !== (l = c.props) && void 0 !== l ? l : {}), {
        "aria-hidden": "true"
    })));
    var O = (0, $1SA7b.default)(s, "ncss-trailing-icon-container");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, u ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        type: "button",
        className: O,
        onClick: function(t) {
            b(!m), u && u(t);
        },
        title: d || "",
        "aria-pressed": m
    }, p), g) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        className: O
    }, p), c));
};

});

parcelRegister("kR6L7", function(module, exports) {

$parcel$export(module.exports, "UnitPrefix", () => $f2ee001054c52816$export$c1cf2559d284e125);

var $acw62 = parcelRequire("acw62");
var $f2ee001054c52816$var$e = undefined && undefined.__rest || function(e, t) {
    var r, a = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (a[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(r = 0, n = Object.getOwnPropertySymbols(e); r < n.length; r++)t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (a[n[r]] = e[n[r]]);
    return a;
};
var $f2ee001054c52816$export$c1cf2559d284e125 = function(r) {
    var a = r.value, n = r.className, i = (r.isActive, $f2ee001054c52816$var$e(r, [
        "value",
        "className",
        "isActive"
    ]));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        className: n,
        "aria-hidden": !0
    }, i), a);
};

});

parcelRegister("2oLsu", function(module, exports) {

$parcel$export(module.exports, "UnitSuffix", () => $1bf2a2f3b6819485$export$684b7cb7459c51ec);

var $acw62 = parcelRequire("acw62");
var $1bf2a2f3b6819485$var$e = undefined && undefined.__rest || function(e, t) {
    var r, a = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (a[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(r = 0, n = Object.getOwnPropertySymbols(e); r < n.length; r++)t.indexOf(n[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[r]) && (a[n[r]] = e[n[r]]);
    return a;
};
var $1bf2a2f3b6819485$export$684b7cb7459c51ec = function(r) {
    var a = r.value, n = r.className, i = (r.isActive, $1bf2a2f3b6819485$var$e(r, [
        "value",
        "className",
        "isActive"
    ]));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        className: n,
        "aria-hidden": !0
    }, i), a);
};

});


parcelRegister("iKfPk", function(module, exports) {

$parcel$export(module.exports, "CharacterCountStyled", () => $da58ccc69ad49c97$export$1bf6b0034190b8d6);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $4dCgP = parcelRequire("4dCgP");
var $da58ccc69ad49c97$export$c1b11d3eb826418d = function(t) {
    var e = t.theme, r = e.typographyBody4, a = r.fontFamily, n = r.fontSize, i = e.sizeSpacingS, l = e.colorContentSecondary;
    return (0, $6xSYO.default)("font-family:", a, ";font-size:", n, ";line-height:16px;color:", l, ";padding-left:", i, ';text-align:right;margin-left:auto;[dir="rtl"] &{position:absolute;left:0;}');
};
var $da58ccc69ad49c97$export$1bf6b0034190b8d6 = (0, $1poQt.default)((0, $4dCgP.CharacterCount), {
    target: "e4nyfpu0"
})($da58ccc69ad49c97$export$c1b11d3eb826418d);

});

parcelRegister("eueDD", function(module, exports) {

$parcel$export(module.exports, "InputStyled", () => $a8bf38e0a6d55b1d$export$bb401da7ede99186);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $3cu5Z = parcelRequire("3cu5Z");

var $9iiQA = parcelRequire("9iiQA");
var $a8bf38e0a6d55b1d$var$r = function(e) {
    var t = e.theme, r = e.isActive, a = e.unitPrefix, d = e.unitSuffix, p = e.trailingIconContent, l = t.colorBorderFocus, s = t.colorContentDisabled, c = t.colorContentPrimary, g = t.colorContentSecondary, y = t.paletteGrey1, f = t.sizeBorderRadiusM, u = t.sizeFormInputFieldHeight, b = t.sizeIconM, m = t.sizeSpacingGridGutter, h = t.sizeSpacingGridGutterL, x = t.sizeSpacingM, z = t.sizeSpacingXs, w = t.sizeSpacingS, v = t.transitionDurationFast, S = t.typographyBody2, k = t.typographyBody4;
    return (0, $6xSYO.default)("border:0;margin:0;padding-top:", m, ";padding-inline-end:", d || p ? x : m, ";padding-bottom:", m, ";padding-inline-start:", a ? z : h, ";width:100%;box-sizing:border-box;font-size:", S.fontSize, ";font-family:", S.fontFamily, ";line-height:", S.lineHeight, ";color:", c, ";background-color:transparent;height:", u, ";border-radius:", f, ";-moz-appearance:textfield;&.has-prefix-icon{padding-inline-start:11px;}&::placeholder{font-family:", S.fontFamily, ";}&:not(:focus){&::placeholder{color:transparent;}}&:focus{outline:0;~ fieldset{border-color:", l, ";}~ label{color:", g, ';}}&[type="date"]{opacity:', r ? "1" : "0", ";transition-property:opacity;transition-duration:", v, ';padding-right:38px;[dir="rtl"] &{text-align:right;', (0, $9iiQA.pointerFine), ",", (0, $9iiQA.onlySafari10Plus), "{flex-direction:row-reverse;}padding-left:0;padding-right:", w, ";::-webkit-calendar-picker-indicator{width:100%;position:absolute;opacity:0;}", (0, $9iiQA.onlySafari10Plus), '{width:50%;}}}&[type="number"]:invalid,&[type="email"]:invalid,&[type="tel"]:invalid{box-shadow:none;& ~ fieldset{legend{padding:0px ', z, ";font-size:", k.fontSize, ';}}}&[type="number"]::-webkit-inner-spin-button,&[type="number"]::-webkit-outer-spin-button,&[type="date"]::-webkit-inner-spin-button{appearance:none;margin:0;}&[type="date"]::-webkit-clear-button{display:none;}&[type="date"]::-webkit-calendar-picker-indicator{opacity:0;position:relative;left:32px;width:', b, ";height:", b, ";}&[readonly]{color:", s, ";pointer-events:none;~ .input-calendar-display{svg{color:", s, ";}}~ label{color:", s, ";}~ fieldset{border-color:", y, ";}}&::-ms-clear,&::-ms-reveal{display:none;width:0;height:0;}");
};
var $a8bf38e0a6d55b1d$export$bb401da7ede99186 = (0, $1poQt.default)((0, $3cu5Z.Input), {
    target: "e1fiih290"
})($a8bf38e0a6d55b1d$var$r);

});

parcelRegister("3tf6i", function(module, exports) {

$parcel$export(module.exports, "SupportTextStyled", () => $286fcb2b79b2eb50$export$3d8ac7789a1eb969);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $gxtdB = parcelRequire("gxtdB");
var $286fcb2b79b2eb50$export$db2ef9f9b3e4fd12 = function(t) {
    var r = t.theme, e = t.error, i = r.typographyBody4, n = i.fontFamily, p = i.fontSize, l = r.colorContentError, m = r.colorContentSecondary;
    return (0, $6xSYO.default)("box-sizing:border-box;width:100%;height:auto;font-size:", p, ";line-height:16px;font-family:", n, ";text-align:left;color:", e ? l : m, ';[dir="rtl"] &{text-align:right;}');
};
var $286fcb2b79b2eb50$export$3d8ac7789a1eb969 = (0, $1poQt.default)((0, $gxtdB.SupportText), {
    target: "e1xmwk8m0"
})($286fcb2b79b2eb50$export$db2ef9f9b3e4fd12);

});

parcelRegister("lTHug", function(module, exports) {

$parcel$export(module.exports, "TrailingIconStyled", () => $ff1077abd6c8c651$export$fdffce44c2279b51);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $90LPq = parcelRequire("90LPq");
var $ff1077abd6c8c651$export$aaad25f4c1a4eece = function(e) {
    var n = e.theme, t = n.typographyHeading3.fontSize, r = n.sizeIconM, o = n.sizeSpacingM;
    return (0, $6xSYO.default)("padding:0;display:flex;justify-content:center;align-items:center;background-color:transparent;font-size:", t, ";width:", r, ";height:", r, ";margin-inline-end:", o, ";border:0;overflow:visible;");
};
var $ff1077abd6c8c651$export$fdffce44c2279b51 = (0, $1poQt.default)((0, $90LPq.TrailingIcon), {
    target: "e1723x6b0"
})($ff1077abd6c8c651$export$aaad25f4c1a4eece);

});

parcelRegister("k4ICp", function(module, exports) {

$parcel$export(module.exports, "UnitPrefixStyled", () => $e9d6caab32c3005f$export$9e90c0ff1382c376);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $kR6L7 = parcelRequire("kR6L7");
var $e9d6caab32c3005f$var$n = function(t) {
    var i = t.theme, n = t.isActive, e = i.typographyBody2, r = e.fontFamily, a = e.fontSize, c = e.lineHeight, p = i.colorContentSecondary, m = i.transitionDurationNormal, f = i.transitionTimingFunctionEase, s = i.sizeSpacingGridGutterL;
    return (0, $6xSYO.default)("position:relative;font-family:", r, ";font-size:", a, ";line-height:", c, ";color:", p, ";padding-left:", n ? s : "0px", ";opacity:", n ? "1" : "0", ";width:", n ? "auto" : "0px", ";transition:", n ? "opacity ".concat(m, " ").concat(f) : "opacity ".concat(m, " ").concat(f, ", padding-left 0ms ").concat(m), ";pointer-events:none;");
};
var $e9d6caab32c3005f$export$9e90c0ff1382c376 = (0, $1poQt.default)((0, $kR6L7.UnitPrefix), {
    target: "e1ytszry0"
})($e9d6caab32c3005f$var$n);

});

parcelRegister("asRz0", function(module, exports) {

$parcel$export(module.exports, "UnitSuffixStyled", () => $79e6118734960cdf$export$123b85f36780648f);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $2oLsu = parcelRequire("2oLsu");
var $79e6118734960cdf$var$n = function(t) {
    var o = t.theme, n = t.isActive, a = o.typographyBody2, e = a.fontFamily, r = a.fontSize, c = a.lineHeight, p = o.colorContentSecondary, m = o.transitionDurationNormal, f = o.transitionTimingFunctionEase, g = o.sizeSpacingM;
    return (0, $6xSYO.default)("position:relative;font-family:", e, ";font-size:", r, ";line-height:", c, ";color:", p, ";padding-right:", n ? g : "0px", ";opacity:", n ? "1" : "0", ";text-align:right;max-width:", n ? "1000px" : "0px", ";transition:", n ? "opacity ".concat(m, " ").concat(f) : "opacity ".concat(m, " ").concat(f, ", padding-right 0ms ").concat(m, ", max-width ").concat(m), ";pointer-events:none;");
};
var $79e6118734960cdf$export$123b85f36780648f = (0, $1poQt.default)((0, $2oLsu.UnitSuffix), {
    target: "ehxyjw70"
})($79e6118734960cdf$var$n);

});

parcelRegister("aeMRX", function(module, exports) {

$parcel$export(module.exports, "baseStyles", () => $77411e9ea763bd5c$export$6a08aa478781aaec);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $9iiQA = parcelRequire("9iiQA");
var $77411e9ea763bd5c$export$6a08aa478781aaec = function(n) {
    var o = n.theme, e = n.error, r = n.PrefixIconComponent, a = o.typographyBody2, s = o.typographyBody4, l = o.sizeBorderRadiusM, d = o.colorBorderBase, p = o.colorContentPrimary, c = o.colorContentError, f = o.colorContentDisabled, g = o.paletteGrey2, u = o.colorBorderFocus, b = o.colorFocusRing, m = o.transitionDurationNormal, h = o.transitionTimingFunctionEase, x = o.sizeBorderWidthS, y = o.sizeSpacingXs, z = o.sizeSpacingS, v = o.sizeSpacingM, w = o.sizeSpacingGridGutterL, S = o.sizeSpacingXl, B = o.sizeIconM, F = o.sizeFormInputContainerHeight, k = o.sizeFormInputFieldHeight;
    return (0, $6xSYO.default)("width:100%;box-sizing:border-box;font-family:", a.fontFamily, ";overflow:visible;position:relative;min-height:", F, ";.nds-input-layout-control{display:flex;justify-content:flex-start;background-color:transparent;align-items:center;position:relative;width:100%;height:", k, ";top:", z, ";border-radius:", l, ";&:hover{fieldset{border-color:", e ? c : u, ";}label{color:", e ? c : "", ";}}input[readonly] ~ fieldset{border-color:", d, ";}input[readonly] ~ label{color:", f, ";}.input-calendar-display{position:absolute;right:", v, ";pointer-events:none;width:", B, ";height:", B, ";}}", (0, $9iiQA.onlyMoz), "{input:invalid{box-shadow:none;}}input:-webkit-autofill ~ label{line-height:", s.lineHeight, ";transform:scale(0.75) translate(0,-32px);}input:-webkit-autofill ~ fieldset{legend{padding:0px ", y, ";font-size:", s.fontSize, ";}}label{pointer-events:none;}fieldset{position:absolute;box-sizing:border-box;left:0;bottom:0;width:100%;height:100%;border-color:", e ? c : g, ";border-style:solid;border-width:", x, ";border-radius:", l, ";padding:0;margin:0;pointer-events:none;&:hover,&:focus{border-color:", e ? c : u, ";}legend{border:0;margin-left:7px;padding:0;font-size:0px;visibility:hidden;height:1px;transition-property:padding,font-size;transition-duration:", m, ";transition-timing-function:", h, ";}}input:focus{~ fieldset{border-color:", e ? c : u, ";}~ label{color:", e ? c : p, ';}}button.nds-trailing-icon-container{outline:0;::after{content:" ";position:absolute;z-index:-1;width:48px;height:48px;border-radius:50%;background:', b, ";transform:scale(0);transition-property:transform;transition-duration:", m, ";transition-timing-function:", h, ";}&:hover::after,&:focus::after{transform:scale(1);transition-property:transform;transition-duration:", m, ";transition-timing-function:", h, ";}}&.active{fieldset{legend{padding:0px ", y, ";font-size:", s.fontSize, ';[dir="rtl"] &{padding:0px 8px;margin-inline-start:', v, ";}}}}.textfield-support-container{position:relative;margin-top:", z, ";display:flex;padding:", y, " ", w, " 0 ", w, ";}", r ? "\n    //https://www.figma.com/file/ZBlY0jd7E4fkPmYkrRpS21/Text-Inputs?node-id=804%3A2438\n      .prefix-icon-container {\n        display: flex;\n        margin-inline-start: ".concat(v, ";\n      }\n      label{\n        margin-inline-start: ").concat(S, ';\n        &.active{\n          margin-inline-start: 0;\n          [dir="rtl"] & {\n            transform: scale(0.75) translate(86px, -32px);\n          }\n        }\n      }\n    ') : "");
};

});


parcelRegister("uKJdY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $05c70cbf90bb87ce$export$1e511d4a378977f5, (v) => $05c70cbf90bb87ce$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $05c70cbf90bb87ce$export$2e2bcd8739ae039, (v) => $05c70cbf90bb87ce$export$2e2bcd8739ae039 = v);
var $05c70cbf90bb87ce$export$1e511d4a378977f5;
var $05c70cbf90bb87ce$export$2e2bcd8739ae039;

var $6ZWSX = parcelRequire("6ZWSX");
var $05c70cbf90bb87ce$require$Buffer = $6ZWSX.Buffer;
"use strict";
$05c70cbf90bb87ce$export$1e511d4a378977f5 = true;
$05c70cbf90bb87ce$export$2e2bcd8739ae039 = void 0;
const $05c70cbf90bb87ce$var$getUserCountry = ()=>JSON.parse($05c70cbf90bb87ce$require$Buffer.from(localStorage.getItem("accessToken").split(".")[1], "base64").toString("utf-8")).nike_country;
var $05c70cbf90bb87ce$var$_default = $05c70cbf90bb87ce$export$2e2bcd8739ae039 = $05c70cbf90bb87ce$var$getUserCountry;

});


parcelRegister("j9pCl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $df12bab40397ee80$export$1e511d4a378977f5, (v) => $df12bab40397ee80$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $df12bab40397ee80$export$2e2bcd8739ae039, (v) => $df12bab40397ee80$export$2e2bcd8739ae039 = v);
var $df12bab40397ee80$export$1e511d4a378977f5;
var $df12bab40397ee80$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$df12bab40397ee80$export$1e511d4a378977f5 = true;
$df12bab40397ee80$export$2e2bcd8739ae039 = void 0;

var $i9YB5 = parcelRequire("i9YB5");

var $df12bab40397ee80$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $df12bab40397ee80$var$_react = $df12bab40397ee80$var$_interopRequireWildcard((parcelRequire("acw62")));

var $4fGPb = parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");
function $df12bab40397ee80$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($df12bab40397ee80$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $df12bab40397ee80$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $df12bab40397ee80$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $df12bab40397ee80$var$CustomPanel = ({ button: button, children: children, label: label, sublabel: sublabel })=>{
    const [isOpen, setIsOpen] = (0, $df12bab40397ee80$var$_react.useState)(false);
    return /*#__PURE__*/ $df12bab40397ee80$var$_react.default.createElement("article", {
        className: "va-sm-m ta-sm-c pb2-sm"
    }, /*#__PURE__*/ $df12bab40397ee80$var$_react.default.createElement("button", {
        className: "u-rounded bg-black u-full-width u-cursor-pointer va-sm-m p2-sm d-sm-flx",
        style: {
            color: "white",
            flexDirection: "row",
            outline: "none",
            verticalAlign: "middle"
        },
        type: "button",
        onClick: ()=>setIsOpen(!isOpen)
    }, /*#__PURE__*/ $df12bab40397ee80$var$_react.default.createElement("h3", {
        className: `headline-3 ${button && "ml12-sm"} flex-child flx-gro-sm-1`,
        style: {
            overflowWrap: "anywhere"
        }
    }, label, /*#__PURE__*/ $df12bab40397ee80$var$_react.default.createElement("p", {
        className: "body-3"
    }, sublabel)), button && /*#__PURE__*/ $df12bab40397ee80$var$_react.default.createElement("section", {
        className: "flex-child flx-gro-sm-0 flx-as-sm-c mr2-sm"
    }, /*#__PURE__*/ $df12bab40397ee80$var$_react.default.createElement($4fGPb.Link, {
        className: "ncss-cta-primary-light",
        to: button.to,
        onClick: ()=>{
            button.onClick();
            return /*#__PURE__*/ $df12bab40397ee80$var$_react.default.createElement($kfZjc.Redirect, {
                to: button.to
            });
        }
    }, /*#__PURE__*/ $df12bab40397ee80$var$_react.default.createElement($i9YB5.CaretRight, {
        title: "More Information"
    })))), isOpen && children);
};
$df12bab40397ee80$var$CustomPanel.defaultProps = {
    button: undefined,
    children: null,
    sublabel: ""
};
$df12bab40397ee80$var$CustomPanel.propTypes = {
    button: $df12bab40397ee80$var$_propTypes.default.shape({
        onClick: $df12bab40397ee80$var$_propTypes.default.func.isRequired,
        to: $df12bab40397ee80$var$_propTypes.default.string.isRequired
    }),
    // eslint-disable-next-line react/forbid-prop-types
    children: $df12bab40397ee80$var$_propTypes.default.any,
    label: $df12bab40397ee80$var$_propTypes.default.string.isRequired,
    sublabel: $df12bab40397ee80$var$_propTypes.default.string
};
var $df12bab40397ee80$var$_default = $df12bab40397ee80$export$2e2bcd8739ae039 = $df12bab40397ee80$var$CustomPanel;

});
parcelRegister("i9YB5", function(module, exports) {

$parcel$export(module.exports, "CaretRight", () => $d38812981c3a5bb5$export$98ac0f496a0846de);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $d38812981c3a5bb5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d38812981c3a5bb5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d38812981c3a5bb5$var$_typeof(o);
}
function $d38812981c3a5bb5$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d38812981c3a5bb5$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d38812981c3a5bb5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d38812981c3a5bb5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d38812981c3a5bb5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d38812981c3a5bb5$var$_defineProperty(obj, key, value) {
    key = $d38812981c3a5bb5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d38812981c3a5bb5$var$_toPropertyKey(t) {
    var i = $d38812981c3a5bb5$var$_toPrimitive(t, "string");
    return "symbol" == $d38812981c3a5bb5$var$_typeof(i) ? i : String(i);
}
function $d38812981c3a5bb5$var$_toPrimitive(t, r) {
    if ("object" != $d38812981c3a5bb5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $d38812981c3a5bb5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d38812981c3a5bb5$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M9.25 17.5l5.5-5.5-5.5-5.5"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M8.474 18.966L15.44 12 8.474 5.033"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M16.947 37.932L30.881 24 16.947 10.066"
    }))
};
var $d38812981c3a5bb5$export$98ac0f496a0846de = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $d38812981c3a5bb5$var$_objectSpread($d38812981c3a5bb5$var$_objectSpread({}, props), {}, {
        paths: $d38812981c3a5bb5$var$compPaths,
        fill: "none"
    }));
});

});


parcelRegister("dCVX9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $9ebbc73705cdc185$export$1e511d4a378977f5, (v) => $9ebbc73705cdc185$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $9ebbc73705cdc185$export$2e2bcd8739ae039, (v) => $9ebbc73705cdc185$export$2e2bcd8739ae039 = v);
var $9ebbc73705cdc185$export$1e511d4a378977f5;
var $9ebbc73705cdc185$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$9ebbc73705cdc185$export$1e511d4a378977f5 = true;
$9ebbc73705cdc185$export$2e2bcd8739ae039 = void 0;

var $jXPi8 = parcelRequire("jXPi8");

var $e080M = parcelRequire("e080M");

var $9ebbc73705cdc185$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $9ebbc73705cdc185$var$_react = $1jnue((parcelRequire("acw62")));

var $9ebbc73705cdc185$var$_useTranslate = $1jnue((parcelRequire("90irH")));
const $9ebbc73705cdc185$var$DEFAULT_BUTTON_PERCENTAGES = [
    0,
    20,
    30,
    50,
    70
];
const $9ebbc73705cdc185$var$SOUTH_AFRICA_PERCENTAGE = [
    40
];
const $9ebbc73705cdc185$var$DEFAULT_DROPDOWN_PERCENTAGES = [
    0,
    5,
    10,
    15,
    20,
    25,
    30,
    35,
    40,
    45,
    50,
    55,
    60,
    65,
    70
];
/* Handles which region recieves the button or dropdown component */ const $9ebbc73705cdc185$var$DiscountPercentages = ({ additionalOptions: additionalOptions, discountPercentage: discountPercentage, isDisabled: isDisabled, isRequired: isRequired, onChange: onChange })=>{
    const translate = (0, $9ebbc73705cdc185$var$_useTranslate.default)();
    return /*#__PURE__*/ $9ebbc73705cdc185$var$_react.default.createElement("section", {
        className: "ta-sm-l mb4-sm mt4-sm"
    }, localStorage.getItem("storeRegion") === "EUROPE_MIDDLE_EAST_AFRICA" ? /*#__PURE__*/ $9ebbc73705cdc185$var$_react.default.createElement($9ebbc73705cdc185$var$_react.default.Fragment, null, /*#__PURE__*/ $9ebbc73705cdc185$var$_react.default.createElement("p", {
        className: "body-4 text-color-secondary"
    }, "Discount Percentage", isRequired ? "*" : ""), (0, $e080M.sort)([
        ...$9ebbc73705cdc185$var$DEFAULT_BUTTON_PERCENTAGES,
        ...localStorage.getItem("country") === "ZAF" ? $9ebbc73705cdc185$var$SOUTH_AFRICA_PERCENTAGE : [],
        ...additionalOptions
    ]).map((p)=>/*#__PURE__*/ $9ebbc73705cdc185$var$_react.default.createElement("button", {
            key: p,
            className: `ncss-col-sm-4 ncss-col-md-2 ncss-btn-${discountPercentage === p ? "primary" : "secondary"}-dark`,
            disabled: isDisabled,
            type: "button",
            onClick: ()=>onChange(p)
        }, p, "%"))) : /*#__PURE__*/ $9ebbc73705cdc185$var$_react.default.createElement($jXPi8.DropDownStyled, {
        disabled: isDisabled,
        id: "discountPercentage",
        label: translate("RL_DiscountPercentage"),
        name: "Discount Percentage",
        options: (0, $e080M.sort)([
            ...$9ebbc73705cdc185$var$DEFAULT_DROPDOWN_PERCENTAGES,
            ...additionalOptions
        ]).map((option)=>({
                label: `${option}%`,
                value: option.toString()
            })),
        placeholder: translate("RL_DiscountPercentage"),
        requiredIndicator: isRequired ? "*" : "",
        value: discountPercentage.toString() // required so placeholder doesn't display over falsey value
        ,
        onChange: ({ target: { value: value } })=>onChange(parseInt(value, 10))
    }));
};
$9ebbc73705cdc185$var$DiscountPercentages.defaultProps = {
    additionalOptions: [],
    discountPercentage: 0,
    isDisabled: false,
    isRequired: false,
    onChange: ()=>{}
};
$9ebbc73705cdc185$var$DiscountPercentages.propTypes = {
    additionalOptions: $9ebbc73705cdc185$var$_propTypes.default.arrayOf($9ebbc73705cdc185$var$_propTypes.default.number),
    discountPercentage: $9ebbc73705cdc185$var$_propTypes.default.number,
    isDisabled: $9ebbc73705cdc185$var$_propTypes.default.bool,
    isRequired: $9ebbc73705cdc185$var$_propTypes.default.bool,
    onChange: $9ebbc73705cdc185$var$_propTypes.default.func
};
var $9ebbc73705cdc185$var$_default = $9ebbc73705cdc185$export$2e2bcd8739ae039 = $9ebbc73705cdc185$var$DiscountPercentages;

});
parcelRegister("jXPi8", function(module, exports) {

$parcel$export(module.exports, "DropDownStyled", () => $e88b507186d0f9b2$export$9d986ac857f2b38);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");

var $cuvKW = parcelRequire("cuvKW");

var $hwhVv = parcelRequire("hwhVv");
var $k2e5G = parcelRequire("k2e5G");
var $3tf6i = parcelRequire("3tf6i");

var $gdata = parcelRequire("gdata");
var $e88b507186d0f9b2$var$i = {
    Select: (0, $k2e5G.SelectStyled),
    Label: (0, $hwhVv.LabelStyled),
    SupportText: (0, $3tf6i.SupportTextStyled)
}, $e88b507186d0f9b2$var$n = function(r) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cuvKW.DropDown), Object.assign({}, $e88b507186d0f9b2$var$i, r));
};
var $e88b507186d0f9b2$export$9d986ac857f2b38 = (0, $1poQt.default)($e88b507186d0f9b2$var$n, {
    target: "e1i9v64g0"
})((0, $gdata.baseStyles));

});
parcelRegister("cuvKW", function(module, exports) {

$parcel$export(module.exports, "DropDown", () => $9180eb7f77119fe2$export$e7fbc454eee05098);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $OFYOC = parcelRequire("OFYOC");
var $a4jPb = parcelRequire("a4jPb");
var $jqnEY = parcelRequire("jqnEY");
var $gxtdB = parcelRequire("gxtdB");

var $ipphV = parcelRequire("ipphV");
function $9180eb7f77119fe2$var$e(e, t) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, r) {
        var t = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
        if (null == t) return;
        var o, a, n = [], l = !0, i = !1;
        try {
            for(t = t.call(e); !(l = (o = t.next()).done) && (n.push(o.value), !r || n.length !== r); l = !0);
        } catch (e) {
            i = !0, a = e;
        } finally{
            try {
                l || null == t.return || t.return();
            } finally{
                if (i) throw a;
            }
        }
        return n;
    }(e, t) || function(e, t) {
        if (!e) return;
        if ("string" == typeof e) return $9180eb7f77119fe2$var$r(e, t);
        var o = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === o && e.constructor && (o = e.constructor.name);
        if ("Map" === o || "Set" === o) return Array.from(e);
        if ("Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return $9180eb7f77119fe2$var$r(e, t);
    }(e, t) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $9180eb7f77119fe2$var$r(e, r) {
    var t, o;
    for((null == r || r > e.length) && (r = e.length), t = 0, o = new Array(r); t < r; t++)o[t] = e[t];
    return o;
}
var $9180eb7f77119fe2$var$t = undefined && undefined.__rest || function(e, r) {
    var t, o = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && r.indexOf(a) < 0 && (o[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(t = 0, a = Object.getOwnPropertySymbols(e); t < a.length; t++)r.indexOf(a[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[t]) && (o[a[t]] = e[a[t]]);
    return o;
};
var $9180eb7f77119fe2$export$e7fbc454eee05098 = function(r) {
    var d = r.ariaLive, m = r.autoComplete, f = void 0 === m ? "off" : m, v = r.className, b = void 0 === v ? "" : v, y = r.classes, h = void 0 === y ? {} : y, g = r.disabled, S = r.error, O = r.errorMessage, x = r.id, j = r.label, w = r.name, E = r.onBlur, I = r.onChange, L = r.onFocus, T = r.options, N = r.placeholder, P = r.requiredIndicator, A = r.supportText, C = r.value, q = r.Label, B = void 0 === q ? (0, $a4jPb.Label) : q, F = r.LabelProps, M = r.Select, _ = void 0 === M ? (0, $jqnEY.Select) : M, U = r.SelectProps, V = r.SupportText, W = void 0 === V ? (0, $gxtdB.SupportText) : V, $ = r.SupportTextProps, k = $9180eb7f77119fe2$var$t(r, [
        "ariaLive",
        "autoComplete",
        "className",
        "classes",
        "disabled",
        "error",
        "errorMessage",
        "id",
        "label",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "options",
        "placeholder",
        "requiredIndicator",
        "supportText",
        "value",
        "Label",
        "LabelProps",
        "Select",
        "SelectProps",
        "SupportText",
        "SupportTextProps"
    ]), z = $9180eb7f77119fe2$var$e((0, $acw62.useState)(!1), 2), D = z[0], G = z[1], H = $9180eb7f77119fe2$var$e((0, $acw62.useState)(C || ""), 2), J = H[0], K = H[1];
    (0, $acw62.useEffect)(function() {
        var e = (0, $ipphV.isValueWithinOptions)(T, C);
        K(e && null != C ? C : "");
    }, [
        T,
        C
    ]);
    var Q = D || !!J, R = (0, $1SA7b.default)(b, "dropdown-container", {
        error: S,
        active: Q,
        disabled: g,
        focus: D
    }), X = (0, $1SA7b.default)("nds-dropdown-support-text", h.SupportText);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: R
    }, k), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "nds-select-layout-control"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_, Object.assign({
        name: w,
        id: x,
        error: S,
        autoComplete: f,
        disabled: g,
        options: T,
        placeholder: N,
        label: j,
        onChange: function(e) {
            var r = e.target, t = r.selectedIndex, o = r.options[t];
            K(o.value), I && I(e);
        },
        onFocus: function(e) {
            G(!0), L && L(e);
        },
        onBlur: function(e) {
            G(!1), E && E(e);
        },
        supportText: A,
        requiredIndicator: P,
        value: J,
        className: (0, $1SA7b.default)("nds-dropdown-select-container", h.Select)
    }, U)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(B, Object.assign({
        id: x,
        value: j,
        requiredIndicator: P,
        placeholder: N,
        error: S,
        isActive: Q,
        className: (0, $1SA7b.default)("nds-dropdown-label", h.Label, Q ? "is-active" : "")
    }, F)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $OFYOC.InputFieldset), {
        label: j,
        requiredIndicator: P,
        isActive: Q
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "dropdown-support-container"
    }, A && !S && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(W, Object.assign({
        value: A,
        error: !1,
        ariaLive: d,
        className: X
    }, $)), O && S && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(W, Object.assign({
        value: O,
        error: !0,
        ariaLive: d,
        className: X
    }, $))));
};

});
parcelRegister("jqnEY", function(module, exports) {

$parcel$export(module.exports, "Select", () => $e242cc6537acddfe$export$ef9b1a59e592288f);

var $acw62 = parcelRequire("acw62");

var $8bLY3 = parcelRequire("8bLY3");

var $9iiQA = parcelRequire("9iiQA");
function $e242cc6537acddfe$var$e(e, r) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var r = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
        if (null == r) return;
        var n, a, o = [], i = !0, l = !1;
        try {
            for(r = r.call(e); !(i = (n = r.next()).done) && (o.push(n.value), !t || o.length !== t); i = !0);
        } catch (e) {
            l = !0, a = e;
        } finally{
            try {
                i || null == r.return || r.return();
            } finally{
                if (l) throw a;
            }
        }
        return o;
    }(e, r) || function(e, r) {
        if (!e) return;
        if ("string" == typeof e) return $e242cc6537acddfe$var$t(e, r);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e242cc6537acddfe$var$t(e, r);
    }(e, r) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $e242cc6537acddfe$var$t(e, t) {
    var r, n;
    for((null == t || t > e.length) && (t = e.length), r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
    return n;
}
var $e242cc6537acddfe$var$r = undefined && undefined.__rest || function(e, t) {
    var r, n = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(r = 0, a = Object.getOwnPropertySymbols(e); r < a.length; r++)t.indexOf(a[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[r]) && (n[a[r]] = e[a[r]]);
    return n;
};
var $e242cc6537acddfe$export$ef9b1a59e592288f = function(t) {
    var u = t.name, c = t.id, s = t.autoComplete, d = t.disabled, p = t.options, m = t.onChange, f = t.onFocus, y = void 0 === f ? function() {} : f, b = t.onBlur, v = void 0 === b ? function() {} : b, h = t.placeholder, g = t.label, O = t.className, E = t.error, S = t.requiredIndicator, j = t.supportText, w = t.value, C = void 0 === w ? "" : w, x = $e242cc6537acddfe$var$r(t, [
        "name",
        "id",
        "autoComplete",
        "disabled",
        "options",
        "onChange",
        "onFocus",
        "onBlur",
        "placeholder",
        "label",
        "className",
        "error",
        "requiredIndicator",
        "supportText",
        "value"
    ]), A = $e242cc6537acddfe$var$e((0, $acw62.useState)(""), 2), I = A[0], N = A[1];
    return (0, $acw62.useEffect)(function() {
        var e = p && p.find(function(e) {
            return e.value === C;
        });
        N(e ? e.label : "");
    }, [
        p,
        C
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: O
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", Object.assign({
        name: u,
        id: c,
        autoComplete: s,
        disabled: d,
        onChange: m,
        onFocus: y,
        onBlur: v,
        className: O,
        "aria-required": !!S,
        "aria-invalid": E,
        "aria-describedby": "".concat(c, "-select-aria-description"),
        value: C
    }, x), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        hidden: !0,
        "data-testid": "hidden-option",
        disabled: !0,
        value: "",
        "aria-hidden": "true"
    }, h || g), !!p && p.map(function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            value: e.value || "",
            key: e.value || "",
            disabled: e.disabled
        }, e.label || "");
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "value-display",
        "aria-hidden": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-testid": "dropdown-value-display"
    }, I), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8bLY3.CaretDown), {
        "aria-hidden": !0
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: "".concat(c, "-select-aria-description"),
        style: (0, $9iiQA.visuallyHidden)
    }, j));
};

});
parcelRegister("8bLY3", function(module, exports) {

$parcel$export(module.exports, "CaretDown", () => $5f648f34549a39fc$export$14643e45770079c3);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $5f648f34549a39fc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5f648f34549a39fc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5f648f34549a39fc$var$_typeof(o);
}
function $5f648f34549a39fc$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5f648f34549a39fc$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5f648f34549a39fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5f648f34549a39fc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5f648f34549a39fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5f648f34549a39fc$var$_defineProperty(obj, key, value) {
    key = $5f648f34549a39fc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5f648f34549a39fc$var$_toPropertyKey(t) {
    var i = $5f648f34549a39fc$var$_toPrimitive(t, "string");
    return "symbol" == $5f648f34549a39fc$var$_typeof(i) ? i : String(i);
}
function $5f648f34549a39fc$var$_toPrimitive(t, r) {
    if ("object" != $5f648f34549a39fc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $5f648f34549a39fc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5f648f34549a39fc$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M17.5 9.25l-5.5 5.5-5.5-5.5"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M18.966 8.476L12 15.443 5.033 8.476"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M37.933 16.951L24 30.885 10.067 16.951"
    }))
};
var $5f648f34549a39fc$export$14643e45770079c3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $5f648f34549a39fc$var$_objectSpread($5f648f34549a39fc$var$_objectSpread({}, props), {}, {
        paths: $5f648f34549a39fc$var$compPaths,
        fill: "none"
    }));
});

});


parcelRegister("ipphV", function(module, exports) {

$parcel$export(module.exports, "isValueWithinOptions", () => $d66e2d7d12015f22$export$96249a9293f4ae75);
var $d66e2d7d12015f22$export$96249a9293f4ae75 = function(n, i) {
    return null != i && !!n.find(function(n) {
        return n.value === i;
    });
};

});


parcelRegister("k2e5G", function(module, exports) {

$parcel$export(module.exports, "SelectStyled", () => $e95eeca39c1df96f$export$3d1b056be7d139f4);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $jqnEY = parcelRequire("jqnEY");
var $e95eeca39c1df96f$var$i = function(e) {
    var o = e.theme, i = o.colorContentPrimary, r = o.colorContentDisabled, n = o.sizeBorderRadiusS, a = o.sizeSpacingM, s = o.sizeFormInputFieldHeight, l = o.sizeSpacingGridGutterL, p = o.typographyBody2;
    return (0, $6xSYO.default)("position:relative;width:100%;height:", s, ";color:", i, ";select{width:100%;box-sizing:border-box;border-radius:", n, ";outline:0;appearance:none;opacity:0;&:disabled{color:", r, ";~ .value-display{path{stroke:", r, ";}span{color:", r, ";}}}&:-moz-focusring{color:transparent;text-shadow:0 0 0 #000;}&::-ms-expand{display:none;}&:focus::-ms-value{color:", i, ";background:transparent;}}.value-display{display:flex;align-items:center;justify-content:space-between;position:absolute;top:0;right:0;bottom:0;left:0;width:100%;pointer-events:none;span{margin-inline-start:", l, ";width:calc(100% - 64px);font-size:", p.fontSize, ";}svg{margin-inline-end:", a, ";margin-inline-start:", a, ";}}");
};
var $e95eeca39c1df96f$export$3d1b056be7d139f4 = (0, $1poQt.default)((0, $jqnEY.Select), {
    target: "erx5h8s0"
})($e95eeca39c1df96f$var$i);

});

parcelRegister("gdata", function(module, exports) {

$parcel$export(module.exports, "baseStyles", () => $bcd5fb420b54be12$export$6a08aa478781aaec);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $9iiQA = parcelRequire("9iiQA");
var $bcd5fb420b54be12$export$6a08aa478781aaec = function(t) {
    var i = t.theme, n = t.error, l = i.typographyBody2, s = i.typographyBody4, d = i.colorContentError, a = i.colorContentPrimary, c = i.colorContentDisabled, p = i.colorBorderBase, b = i.colorBorderFocus, f = i.sizeBorderRadiusM, g = i.sizeBorderWidthS, h = i.transitionDurationNormal, u = i.transitionTimingFunctionEase, m = i.breakpointS, y = i.sizeSpacingXs, x = i.sizeSpacingS, v = i.sizeSpacingGridGutterL, z = i.sizeFormInputContainerHeight, S = i.sizeFormInputFieldHeight;
    return (0, $6xSYO.default)("width:100%;box-sizing:border-box;font-family:", l.fontFamily, ";overflow:visible;position:relative;min-height:", z, ";.nds-select-layout-control{display:flex;justify-content:flex-start;align-items:center;position:relative;width:100%;height:", S, ";top:", x, ";border-radius:", f, ";&:hover{fieldset{border-color:", n ? d : b, ";}}}fieldset{position:absolute;box-sizing:border-box;left:0;top:0;width:100%;height:", S, ";border-color:", n ? d : p, ";border-style:solid;border-width:", g, ";border-radius:", f, ";padding:0;margin:0;pointer-events:none;&:hover{border-color:", n ? d : b, ";}legend{border:0;margin-left:7px;padding:0;font-size:0px;visibility:hidden;height:1px;transition-property:padding,font-size;transition-duration:", h, ";transition-timing-function:", u, ";}}&.active{.nds-select-layout-control:hover{label{color:", n ? d : a, ";}}fieldset{legend{padding:0px ", y, ";font-size:", s.fontSize, ';}}}[dir="rtl"] &{label{&.is-active{transform:scale(0.75) translate(91px,-32px);', (0, $9iiQA.pointerCourse), "{@media (max-width:", m, "){transform:scale(0.75) translate(74px,-32px);}}}}}&.focus{fieldset{border-color:", b, ";}label{color:", a, ";}}&.error.focus{.nds-select-layout-control:hover{label{color:", a, ";}fieldset{border-color:", b, ";}}}&.disabled{.nds-select-layout-control,.nds-select-layout-control:hover{label{color:", c, ";}fieldset{border-color:", p, ";}}}", (0, $9iiQA.onlyIE), "{fieldset{border-radius:0;legend{transition:unset;}}}.dropdown-support-container{position:relative;margin-top:8px;display:flex;padding:", y, " ", v, " 0 ", v, ";}");
};

});



parcelRegister("AJ2d4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $06e64bd9708c60a8$export$1e511d4a378977f5, (v) => $06e64bd9708c60a8$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $06e64bd9708c60a8$export$2e2bcd8739ae039, (v) => $06e64bd9708c60a8$export$2e2bcd8739ae039 = v);
var $06e64bd9708c60a8$export$1e511d4a378977f5;
var $06e64bd9708c60a8$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$06e64bd9708c60a8$export$1e511d4a378977f5 = true;
$06e64bd9708c60a8$export$2e2bcd8739ae039 = void 0;

var $b4nCt = parcelRequire("b4nCt");

var $06e64bd9708c60a8$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $06e64bd9708c60a8$var$_react = $1jnue((parcelRequire("acw62")));
const $06e64bd9708c60a8$var$Input = ({ error: error, errorMessage: errorMessage, id: id, isDisabled: isDisabled, isRequired: isRequired, label: label, maxLength: maxLength, minLength: minLength, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onIconClick: onIconClick, placeholder: placeholder, showCharacterCount: showCharacterCount, trailingIconContent: trailingIconContent, type: type, value: value })=>/*#__PURE__*/ $06e64bd9708c60a8$var$_react.default.createElement($b4nCt.TextFieldStyled, {
        error: error || isRequired && !value,
        errorMessage: errorMessage,
        id: id,
        label: label,
        maxLength: maxLength,
        minLength: minLength,
        name: id,
        placeholder: placeholder,
        readOnly: isDisabled,
        requiredIndicator: isRequired ? "*" : "",
        showCharacterCount: showCharacterCount,
        trailingIconContent: trailingIconContent,
        type: type,
        value: value,
        onBlur: onBlur,
        onChange: ({ target: { value: newValue } })=>onChange(newValue),
        onFocus: onFocus,
        onIconClick: onIconClick
    });
$06e64bd9708c60a8$var$Input.defaultProps = {
    error: false,
    errorMessage: "",
    isDisabled: false,
    isRequired: false,
    maxLength: undefined,
    minLength: undefined,
    onBlur: ()=>{},
    onFocus: ()=>{},
    onIconClick: ()=>{},
    placeholder: "",
    showCharacterCount: false,
    trailingIconContent: undefined,
    type: "text"
};
$06e64bd9708c60a8$var$Input.propTypes = {
    error: $06e64bd9708c60a8$var$_propTypes.default.bool,
    errorMessage: $06e64bd9708c60a8$var$_propTypes.default.string,
    id: $06e64bd9708c60a8$var$_propTypes.default.string.isRequired,
    isDisabled: $06e64bd9708c60a8$var$_propTypes.default.bool,
    isRequired: $06e64bd9708c60a8$var$_propTypes.default.bool,
    label: $06e64bd9708c60a8$var$_propTypes.default.string.isRequired,
    maxLength: $06e64bd9708c60a8$var$_propTypes.default.number,
    minLength: $06e64bd9708c60a8$var$_propTypes.default.number,
    onBlur: $06e64bd9708c60a8$var$_propTypes.default.func,
    onChange: $06e64bd9708c60a8$var$_propTypes.default.func.isRequired,
    onFocus: $06e64bd9708c60a8$var$_propTypes.default.func,
    onIconClick: $06e64bd9708c60a8$var$_propTypes.default.func,
    placeholder: $06e64bd9708c60a8$var$_propTypes.default.string,
    showCharacterCount: $06e64bd9708c60a8$var$_propTypes.default.bool,
    trailingIconContent: $06e64bd9708c60a8$var$_propTypes.default.element,
    type: $06e64bd9708c60a8$var$_propTypes.default.string,
    value: $06e64bd9708c60a8$var$_propTypes.default.string.isRequired
};
var $06e64bd9708c60a8$var$_default = $06e64bd9708c60a8$export$2e2bcd8739ae039 = $06e64bd9708c60a8$var$Input;

});

parcelRegister("lmip3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $f8c9ed89d403cfb9$export$1e511d4a378977f5, (v) => $f8c9ed89d403cfb9$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $f8c9ed89d403cfb9$export$2e2bcd8739ae039, (v) => $f8c9ed89d403cfb9$export$2e2bcd8739ae039 = v);
var $f8c9ed89d403cfb9$export$1e511d4a378977f5;
var $f8c9ed89d403cfb9$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$f8c9ed89d403cfb9$export$1e511d4a378977f5 = true;
$f8c9ed89d403cfb9$export$2e2bcd8739ae039 = void 0;

var $kFDb3 = parcelRequire("kFDb3");

var $f8c9ed89d403cfb9$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $f8c9ed89d403cfb9$var$_react = $1jnue((parcelRequire("acw62")));
const $f8c9ed89d403cfb9$var$DateInput = ({ errorMessage: errorMessage, id: id, isDisabled: isDisabled, isRequired: isRequired, label: label, locale: locale, maxDate: maxDate, minDate: minDate, onChange: onChange, value: value })=>/*#__PURE__*/ $f8c9ed89d403cfb9$var$_react.default.createElement($kFDb3.DatePickerStyled, {
        error: errorMessage || isRequired && !value,
        errorMessage: errorMessage,
        iconTitle: "Calendar Icon",
        id: id,
        label: label,
        locale: locale,
        max: maxDate,
        min: minDate,
        name: id,
        readOnly: isDisabled,
        requiredIndicator: isRequired ? "*" : "",
        value: value,
        onChange: ({ target: { value: newValue } })=>onChange(newValue)
    });
$f8c9ed89d403cfb9$var$DateInput.defaultProps = {
    errorMessage: "",
    isDisabled: false,
    isRequired: false,
    locale: "US",
    // Dates MUST be in this format
    maxDate: "9999-12-31",
    minDate: "0000-01-01"
};
$f8c9ed89d403cfb9$var$DateInput.propTypes = {
    errorMessage: $f8c9ed89d403cfb9$var$_propTypes.default.string,
    id: $f8c9ed89d403cfb9$var$_propTypes.default.string.isRequired,
    isDisabled: $f8c9ed89d403cfb9$var$_propTypes.default.bool,
    isRequired: $f8c9ed89d403cfb9$var$_propTypes.default.bool,
    label: $f8c9ed89d403cfb9$var$_propTypes.default.string.isRequired,
    locale: $f8c9ed89d403cfb9$var$_propTypes.default.string,
    maxDate: $f8c9ed89d403cfb9$var$_propTypes.default.string,
    minDate: $f8c9ed89d403cfb9$var$_propTypes.default.string,
    onChange: $f8c9ed89d403cfb9$var$_propTypes.default.func.isRequired,
    value: $f8c9ed89d403cfb9$var$_propTypes.default.string.isRequired
};
var $f8c9ed89d403cfb9$var$_default = $f8c9ed89d403cfb9$export$2e2bcd8739ae039 = $f8c9ed89d403cfb9$var$DateInput;

});
parcelRegister("kFDb3", function(module, exports) {

$parcel$export(module.exports, "DatePickerStyled", () => $f0c606cce37ec18a$export$3392f6f10f96e9b2);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");

var $aeRQj = parcelRequire("aeRQj");

var $hwhVv = parcelRequire("hwhVv");
var $3tf6i = parcelRequire("3tf6i");

var $b4nCt = parcelRequire("b4nCt");

var $aqxLM = parcelRequire("aqxLM");

var $gbMhS = parcelRequire("gbMhS");
var $f0c606cce37ec18a$var$p = {
    Label: (0, $hwhVv.LabelStyled),
    TextField: (0, $b4nCt.TextFieldStyled),
    SupportText: (0, $3tf6i.SupportTextStyled),
    DatePickerFallback: (0, $aqxLM.DatePickerFallbackStyled)
}, $f0c606cce37ec18a$var$c = function(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $aeRQj.DatePicker), Object.assign({}, e, $f0c606cce37ec18a$var$p));
};
var $f0c606cce37ec18a$export$3392f6f10f96e9b2 = (0, $1poQt.default)($f0c606cce37ec18a$var$c, {
    target: "er6rhxo0"
})((0, $gbMhS.nativeBaseStyles));

});
parcelRegister("aeRQj", function(module, exports) {

$parcel$export(module.exports, "DatePicker", () => $7744fa3c6165c091$export$5109c6dd95d8fb00);

var $acw62 = parcelRequire("acw62");

var $fTqgO = parcelRequire("fTqgO");

var $9D53m = parcelRequire("9D53m");

var $a4jPb = parcelRequire("a4jPb");

var $AKSwl = parcelRequire("AKSwl");

var $60uCl = parcelRequire("60uCl");
var $7744fa3c6165c091$var$e = undefined && undefined.__rest || function(e, r) {
    var t, a = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && r.indexOf(o) < 0 && (a[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(t = 0, o = Object.getOwnPropertySymbols(e); t < o.length; t++)r.indexOf(o[t]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[t]) && (a[o[t]] = e[o[t]]);
    return a;
};
var $7744fa3c6165c091$export$5109c6dd95d8fb00 = function(i) {
    var p = i.ariaLive, s = void 0 === p ? "polite" : p, c = i.autoComplete, u = i.className, m = i.error, d = i.errorMessage, b = i.iconTitle, x = i.id, f = i.label, v = i.locale, P = void 0 === v ? "US" : v, T = i.max, k = i.min, g = i.name, F = i.onBlur, h = i.onChange, y = i.onFocus, O = i.pattern, C = i.placeholder, L = i.readOnly, I = i.requiredIndicator, S = i.shouldUseFallback, D = i.supportText, j = i.value, E = i.DatePickerFallback, N = void 0 === E ? (0, $AKSwl.DatePickerFallback) : E, q = i.DatePickerFallbackProps, B = i.Label, M = void 0 === B ? (0, $a4jPb.Label) : B, U = i.LabelProps, w = i.SupportText, _ = i.SupportTextProps, z = i.TextField, A = void 0 === z ? (0, $9D53m.TextField) : z, G = $7744fa3c6165c091$var$e(i, [
        "ariaLive",
        "autoComplete",
        "className",
        "error",
        "errorMessage",
        "iconTitle",
        "id",
        "label",
        "locale",
        "max",
        "min",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "pattern",
        "placeholder",
        "readOnly",
        "requiredIndicator",
        "shouldUseFallback",
        "supportText",
        "value",
        "DatePickerFallback",
        "DatePickerFallbackProps",
        "Label",
        "LabelProps",
        "SupportText",
        "SupportTextProps",
        "TextField"
    ]);
    return !(0, $60uCl.supportsNativeDateInput)() || S ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(N, Object.assign({
        name: g,
        id: x,
        label: f,
        value: j,
        className: u,
        onChange: h,
        onFocus: y,
        onBlur: F,
        requiredIndicator: I,
        supportText: D,
        error: m,
        readOnly: L,
        placeholder: C,
        errorMessage: d,
        autoComplete: c,
        min: k,
        max: T,
        locale: P.toUpperCase(),
        ariaLive: s,
        trailingIconContent: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fTqgO.Calendar), {
            title: b
        }),
        fallbackProps: q
    }, G)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(A, Object.assign({
        Label: M,
        LabelProps: U,
        SupportText: w,
        SupportTextProps: _,
        type: "date",
        name: g,
        id: x,
        label: f,
        value: j,
        className: u,
        placeholder: C,
        onChange: function(e) {
            h && h(e);
        },
        onFocus: function(e) {
            y && y(e);
        },
        onBlur: function(e) {
            F && F(e);
        },
        requiredIndicator: I,
        supportText: D,
        error: m,
        readOnly: L,
        errorMessage: d,
        autoComplete: c,
        pattern: O,
        InputProps: {
            min: k,
            max: T
        },
        ariaLive: s,
        iconTitle: b,
        trailingIconContent: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $fTqgO.Calendar), {
            title: b
        })
    }, G));
};

});
parcelRegister("fTqgO", function(module, exports) {

$parcel$export(module.exports, "Calendar", () => $b9205ec4ce5c7e8b$export$e1aef45b828286de);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $b9205ec4ce5c7e8b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b9205ec4ce5c7e8b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b9205ec4ce5c7e8b$var$_typeof(o);
}
function $b9205ec4ce5c7e8b$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b9205ec4ce5c7e8b$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b9205ec4ce5c7e8b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b9205ec4ce5c7e8b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b9205ec4ce5c7e8b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b9205ec4ce5c7e8b$var$_defineProperty(obj, key, value) {
    key = $b9205ec4ce5c7e8b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b9205ec4ce5c7e8b$var$_toPropertyKey(t) {
    var i = $b9205ec4ce5c7e8b$var$_toPrimitive(t, "string");
    return "symbol" == $b9205ec4ce5c7e8b$var$_typeof(i) ? i : String(i);
}
function $b9205ec4ce5c7e8b$var$_toPrimitive(t, r) {
    if ("object" != $b9205ec4ce5c7e8b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $b9205ec4ce5c7e8b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b9205ec4ce5c7e8b$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M20.25 9.75H3.75M8.25 3v4.5m7.5-4.5v4.5M18 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25z"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M20.25 9.75H3.75M8.25 3v4.5m7.5-4.5v4.5M18 20.25H6A2.25 2.25 0 013.75 18V7.5A2.25 2.25 0 016 5.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25z"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M40.5 19.5h-33m9-13.5v9m15-9v9M36 40.5H12A4.5 4.5 0 017.5 36V15a4.5 4.5 0 014.5-4.5h24a4.5 4.5 0 014.5 4.5v21a4.5 4.5 0 01-4.5 4.5z"
    }))
};
var $b9205ec4ce5c7e8b$export$e1aef45b828286de = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $b9205ec4ce5c7e8b$var$_objectSpread($b9205ec4ce5c7e8b$var$_objectSpread({}, props), {}, {
        paths: $b9205ec4ce5c7e8b$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("AKSwl", function(module, exports) {

$parcel$export(module.exports, "DatePickerFallback", () => $06e7b9f977e5e69d$export$476a77c637ab963b);

var $1SA7b = parcelRequire("1SA7b");

var $acw62 = parcelRequire("acw62");

var $7ClUQ = parcelRequire("7ClUQ");

var $19Cyq = parcelRequire("19Cyq");

var $OFYOC = parcelRequire("OFYOC");
var $a4jPb = parcelRequire("a4jPb");
var $gxtdB = parcelRequire("gxtdB");
var $90LPq = parcelRequire("90LPq");
var $9iiQA = parcelRequire("9iiQA");
function $06e7b9f977e5e69d$var$e(e, a) {
    return function(e) {
        if (Array.isArray(e)) return e;
    }(e) || function(e, t) {
        var a = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);
        if (null == a) return;
        var r, n, l = [], o = !0, i = !1;
        try {
            for(a = a.call(e); !(o = (r = a.next()).done) && (l.push(r.value), !t || l.length !== t); o = !0);
        } catch (e) {
            i = !0, n = e;
        } finally{
            try {
                o || null == a.return || a.return();
            } finally{
                if (i) throw n;
            }
        }
        return l;
    }(e, a) || function(e, a) {
        if (!e) return;
        if ("string" == typeof e) return $06e7b9f977e5e69d$var$t(e, a);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $06e7b9f977e5e69d$var$t(e, a);
    }(e, a) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $06e7b9f977e5e69d$var$t(e, t) {
    var a, r;
    for((null == t || t > e.length) && (t = e.length), a = 0, r = new Array(t); a < t; a++)r[a] = e[a];
    return r;
}
var $06e7b9f977e5e69d$var$a = undefined && undefined.__rest || function(e, t) {
    var a, r = {};
    for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
    return r;
};
var $06e7b9f977e5e69d$export$476a77c637ab963b = function(t) {
    var b, h = t.ariaLive, g = t.autoComplete, v = t.classes, E = void 0 === v ? {
        Label: "ncss-input-label",
        InputFieldset: "ncss-input-fieldset",
        SupportText: "ncss-input-support-text"
    } : v, x = t.className, N = t.error, L = t.errorMessage, O = t.fallbackProps, I = void 0 === O ? {
        monthPlaceholder: "--",
        dayPlaceholder: "--",
        yearPlaceholder: "----",
        dateSeparator: "/",
        a11yMonthLabel: "Month",
        a11yDayLabel: "Day",
        a11yYearLabel: "Year"
    } : O, P = (t.iconTitle, t.id), F = t.label, S = t.locale, T = t.max, w = (t.min, t.name, t.onBlur), C = t.onChange, j = t.onFocus, A = t.placeholder, M = t.readOnly, D = t.requiredIndicator, k = t.supportText, B = t.trailingIconContent, q = t.value, K = void 0 === q ? "" : q, Y = t.InputFieldset, H = void 0 === Y ? (0, $OFYOC.InputFieldset) : Y, W = t.Label, _ = void 0 === W ? (0, $a4jPb.Label) : W, U = t.LabelProps, $ = t.SupportText, z = void 0 === $ ? (0, $gxtdB.SupportText) : $, G = t.SupportTextProps, J = t.TrailingIcon, Q = void 0 === J ? (0, $90LPq.TrailingIcon) : J, R = $06e7b9f977e5e69d$var$a(t, [
        "ariaLive",
        "autoComplete",
        "classes",
        "className",
        "error",
        "errorMessage",
        "fallbackProps",
        "iconTitle",
        "id",
        "label",
        "locale",
        "max",
        "min",
        "name",
        "onBlur",
        "onChange",
        "onFocus",
        "placeholder",
        "readOnly",
        "requiredIndicator",
        "supportText",
        "trailingIconContent",
        "value",
        "InputFieldset",
        "Label",
        "LabelProps",
        "SupportText",
        "SupportTextProps",
        "TrailingIcon"
    ]), V = I.monthPlaceholder, X = I.dayPlaceholder, Z = I.yearPlaceholder, ee = I.dateSeparator, te = I.monthPattern, ae = I.dayPattern, re = I.yearPattern, ne = I.a11yMonthLabel, le = I.a11yDayLabel, oe = I.a11yYearLabel, ie = "", ce = "", se = "";
    /\d{4}-\d{2}-\d{2}/.test(K) && (b = $06e7b9f977e5e69d$var$e(K.split("-"), 3), ie = b[0], ce = b[1], se = b[2]);
    var ue = $06e7b9f977e5e69d$var$e((0, $acw62.useState)(ce || ""), 2), me = ue[0], pe = ue[1], de = $06e7b9f977e5e69d$var$e((0, $acw62.useState)(se || ""), 2), fe = de[0], ye = de[1], be = $06e7b9f977e5e69d$var$e((0, $acw62.useState)(ie || ""), 2), he = be[0], ge = be[1], ve = $06e7b9f977e5e69d$var$e((0, $acw62.useState)(!1), 2), Ee = ve[0], xe = ve[1], Ne = $06e7b9f977e5e69d$var$e((0, $acw62.useState)(), 2), Le = Ne[0], Oe = Ne[1], Ie = $06e7b9f977e5e69d$var$e((0, $acw62.useState)(""), 2), Pe = Ie[0], Fe = Ie[1], Se = $06e7b9f977e5e69d$var$e((0, $acw62.useState)(""), 2), Te = Se[0], we = Se[1], Ce = $06e7b9f977e5e69d$var$e((0, $acw62.useState)(""), 2), je = Ce[0], Ae = Ce[1], Me = (0, $acw62.useRef)(!0);
    (0, $acw62.useEffect)(function() {
        pe(ce), ye(se), ge(ie), Oe((0, $19Cyq.geoHelper)(S));
    }, [
        ce,
        se,
        ie,
        S
    ]), (0, $acw62.useEffect)(function() {
        var e = new Array;
        he.length > 0 && Number(he) > 0 && e.push(he), me.length > 0 && e.push(me.length < 2 ? "0".concat(me) : me), fe.length > 0 && e.push(fe.length < 2 ? "0".concat(fe) : fe);
        var t = e.join("-");
        Me.current && t === K || C && C(null, t);
    }, [
        he,
        me,
        fe,
        K
    ]);
    var De, ke, Be, qe, Ke, Ye, He = function(e) {
        Me.current = !1, xe(!0), j && j(e);
    }, We = function(e) {
        xe(!1), w && w(e);
    }, _e = T ? Number(T.slice(5, 7)) : 12, Ue = function(e) {
        Number(e.target.value) <= _e && pe(e.target.value);
    }, $e = T ? Number(T.slice(8, 10)) : 31, ze = function(e) {
        Number(e.target.value) <= $e && ye(e.target.value);
    }, Ge = T ? Number(T.slice(0, 4)) : 9999, Je = function(e) {
        Number(e.target.value) <= Ge && ge(e.target.value);
    }, Qe = function(e, t, a) {
        var r = document.createElement("input");
        try {
            r.type = "date", t(e.offsetWidth);
        } catch (r) {
            t(e.offsetWidth + a);
        }
    }, Re = (0, $acw62.useRef)(null), Ve = (0, $acw62.useCallback)(function(e) {
        null === e || !me && "" !== me || Qe(e, Fe, 12);
    }, [
        me
    ]), Xe = (0, $acw62.useCallback)(function(e) {
        null === e || !fe && "" !== fe || ("ymd" !== Le.format ? Qe(e, we, 12) : we("100%"));
    }, [
        fe,
        Le
    ]), Ze = (0, $acw62.useCallback)(function(e) {
        null === e || !he && "" !== he || ("ymd" === Le.format ? Qe(e, Ae, 20) : Ae("100%"));
    }, [
        he,
        Le
    ]), et = Ee || me.length > 0 || fe.length > 0 || he.length > 0, tt = (0, $1SA7b.default)(x, {
        error: N,
        active: et,
        focus: Ee
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: tt
    }, R), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ncss-datepickerfb-parent-container",
        ref: Re
    }, S && S.length >= 2 && (De = Le ? "mdy" === Le.format ? "fb-first-input" : ("ymd" === Le.format || "dmy" === Le.format) && "fb-middle-input" : "", ke = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "text",
        inputMode: "numeric",
        id: "".concat(P, "-month"),
        placeholder: V,
        pattern: te,
        readOnly: M,
        maxLength: 2,
        max: _e,
        value: me,
        onKeyDown: function(e) {
            return (0, $7ClUQ.datePickerFallbackInputFocus)(e, "month", Re, P, _e);
        },
        onChange: Ue,
        onFocus: He,
        onBlur: We,
        autoComplete: g,
        style: {
            width: Pe
        },
        className: De || "",
        "aria-label": "".concat(ne, " ").concat(F),
        "aria-describedby": "".concat(P, "-month-aria-description")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: Ve,
        "aria-hidden": !0,
        className: "fb-input-measurement ".concat(De, "-measurement")
    }, me || V)), Be = Le ? "dmy" === Le.format ? "fb-first-input" : "ymd" === Le.format ? "fb-last-input" : "fb-middle-input" : "", qe = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "text",
        inputMode: "numeric",
        id: "".concat(P, "-day"),
        placeholder: X,
        pattern: ae,
        readOnly: M,
        maxLength: 2,
        max: $e,
        value: fe,
        onKeyDown: function(e) {
            return (0, $7ClUQ.datePickerFallbackInputFocus)(e, "day", Re, P, $e);
        },
        onChange: ze,
        onFocus: He,
        onBlur: We,
        autoComplete: g,
        style: {
            width: Te
        },
        className: Be,
        "aria-label": "".concat(le, " ").concat(F),
        "aria-describedby": "".concat(P, "-day-aria-description")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: Xe,
        "aria-hidden": !0,
        className: "fb-input-measurement ".concat(Be, "-measurement")
    }, fe || X)), Ke = Le ? "ymd" === Le.format ? "fb-first-input-year" : "fb-last-input" : "", Ye = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "text",
        inputMode: "numeric",
        id: "".concat(P, "-year"),
        placeholder: Z,
        pattern: re,
        readOnly: M,
        maxLength: 4,
        max: Ge,
        value: he,
        onKeyDown: function(e) {
            return (0, $7ClUQ.datePickerFallbackInputFocus)(e, "year", Re, P, Ge);
        },
        onChange: Je,
        onFocus: He,
        onBlur: We,
        autoComplete: g,
        style: {
            width: je
        },
        className: Ke,
        "aria-label": "".concat(oe, " ").concat(F),
        "aria-describedby": "".concat(P, "-year-aria-description")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        ref: Ze,
        "aria-hidden": !0,
        className: "fb-input-measurement ".concat(Ke, "-measurement")
    }, he || Z)), Le && "dmy" === Le.format ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, qe, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "fb-input-seperator",
        "aria-hidden": !0
    }, ee), ke, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "fb-input-seperator",
        "aria-hidden": !0
    }, ee), Ye) : Le && "ymd" === Le.format ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, Ye, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "fb-input-seperator",
        "aria-hidden": !0
    }, ee), ke, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "fb-input-seperator",
        "aria-hidden": !0
    }, ee), qe) : Le && "mdy" === Le.format ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, ke, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "fb-input-seperator",
        "aria-hidden": !0
    }, ee), qe, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "fb-input-seperator",
        "aria-hidden": !0
    }, ee), Ye) : null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_, Object.assign({
        id: P,
        value: F,
        placeholder: A,
        className: E.Label,
        requiredIndicator: D,
        isActive: et,
        error: N
    }, U)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Q, {
        value: B
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(H, {
        className: E.InputFieldset,
        label: F,
        requiredIndicator: D,
        isActive: et
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "textfield-support-container"
    }, k && !N && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(z, Object.assign({
        className: E.SupportText,
        value: k,
        error: !1,
        ariaLive: h
    }, G)), L && N && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(z, Object.assign({
        className: E.SupportText,
        value: L,
        error: !0,
        ariaLive: h
    }, G))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: "".concat(P, "-month-aria-description"),
        style: (0, $9iiQA.visuallyHidden)
    }, ne, "\xa0", F, ",\xa0", k), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: "".concat(P, "-day-aria-description"),
        style: (0, $9iiQA.visuallyHidden)
    }, le, "\xa0", F, ",\xa0", k), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        id: "".concat(P, "-year-aria-description"),
        style: (0, $9iiQA.visuallyHidden)
    }, oe, "\xa0", F, ",\xa0", k));
};

});
parcelRegister("7ClUQ", function(module, exports) {

$parcel$export(module.exports, "datePickerFallbackInputFocus", () => $58bd150e7de4db6d$export$7e7a4ee4af2eb631);
function $58bd150e7de4db6d$var$t(t) {
    return function(t) {
        if (Array.isArray(t)) return $58bd150e7de4db6d$var$e(t);
    }(t) || function(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }(t) || function(t, n) {
        if (!t) return;
        if ("string" == typeof t) return $58bd150e7de4db6d$var$e(t, n);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $58bd150e7de4db6d$var$e(t, n);
    }(t) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $58bd150e7de4db6d$var$e(t, e) {
    var n, r;
    for((null == e || e > t.length) && (e = t.length), n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
    return r;
}
var $58bd150e7de4db6d$export$7e7a4ee4af2eb631 = function(e, n, r, o, u) {
    var a, i = e.currentTarget, l = e.keyCode, c = Number(e.key), f = r.current, s = null !== (a = null == f ? void 0 : f.querySelectorAll("input")) && void 0 !== a ? a : [], v = $58bd150e7de4db6d$var$t(s)[0], g = $58bd150e7de4db6d$var$t(s)[1], y = $58bd150e7de4db6d$var$t(s)[2], m = function(t) {
        return "".concat(String(o), "-").concat(String(n)) === t.id;
    }, p = function(t) {
        return l === t;
    }, S = i.value.length >= i.maxLength, d = i.value > u.toString().slice(0, 1), b = function(t) {
        return i.value.length === t.selectionStart;
    }, h = function(t, e) {
        m(t) && (S || d) && b(t) && !Number.isNaN(c) && (e.focus(), e.setSelectionRange(0, e.value.length));
    };
    h(v, g), h(g, y);
    var A = function(t, n) {
        (p(39) || p(191) || p(189) || p(190)) && m(t) && b(t) && (e.preventDefault(), n.focus(), n.setSelectionRange(0, n.value.length));
    };
    A(v, g), A(g, y);
    var k = function(t, n) {
        var r;
        (p(37) || p(8)) && m(t) && 0 === (r = t).selectionStart && 0 === r.selectionEnd && (e.preventDefault(), n.focus(), n.setSelectionRange(0, n.value.length));
    };
    k(g, v), k(y, g);
};

});

parcelRegister("19Cyq", function(module, exports) {

$parcel$export(module.exports, "geoHelper", () => $0d7489ccec12d497$export$745ad56d2555e8b);

var $8xK3Z = parcelRequire("8xK3Z");
var $0d7489ccec12d497$export$745ad56d2555e8b = function(o) {
    switch(!0){
        case (0, $8xK3Z.dmyCodes).includes(o):
            return {
                format: "dmy"
            };
        case (0, $8xK3Z.ymdCodes).includes(o):
            return {
                format: "ymd"
            };
        case (0, $8xK3Z.mdyCodes).includes(o):
            return {
                format: "mdy"
            };
    }
};

});
parcelRegister("8xK3Z", function(module, exports) {

$parcel$export(module.exports, "dmyCodes", () => $63852301ff6306f8$export$85aa38919525bdb2);
$parcel$export(module.exports, "ymdCodes", () => $63852301ff6306f8$export$54f702d7b9996d9d);
$parcel$export(module.exports, "mdyCodes", () => $63852301ff6306f8$export$5eafddf31a3ce16);
var $63852301ff6306f8$export$85aa38919525bdb2 = [
    "AR",
    "BR",
    "HK",
    "XL",
    "UY",
    "AT",
    "BE",
    "CZ",
    "DK",
    "FI",
    "FR",
    "DE",
    "GR",
    "IRL",
    "IT",
    "LU",
    "NL",
    "PL",
    "PT",
    "SI",
    "ES",
    "SE",
    "GB",
    "IN",
    "ID",
    "MY",
    "SG",
    "TH",
    "VN",
    "AU",
    "BG",
    "CA",
    "CL",
    "HR",
    "IL",
    "MX",
    "NZ",
    "NO",
    "PR",
    "RO",
    "RU",
    "SK",
    "ZA",
    "CH",
    "TR"
];
var $63852301ff6306f8$export$54f702d7b9996d9d = [
    "KR",
    "CN",
    "JP",
    "HU",
    "TW",
    "EG",
    "MA",
    "SA",
    "AE"
];
var $63852301ff6306f8$export$5eafddf31a3ce16 = [
    "US",
    "PH"
];

});



parcelRegister("60uCl", function(module, exports) {

$parcel$export(module.exports, "supportsNativeDateInput", () => $45fa7e24d2d5bf7d$export$9a7359c4ed9bf9c3);
var $45fa7e24d2d5bf7d$export$9a7359c4ed9bf9c3 = function() {
    try {
        var t = document.createElement("input");
        return t.type = "date", "date" === t.type;
    } catch (t) {
        return !1;
    }
};

});


parcelRegister("aqxLM", function(module, exports) {

$parcel$export(module.exports, "DatePickerFallbackStyled", () => $7976870743141e1e$export$7b1755b32f92a7d8);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");

var $AKSwl = parcelRequire("AKSwl");

var $hwhVv = parcelRequire("hwhVv");
var $3tf6i = parcelRequire("3tf6i");
var $lTHug = parcelRequire("lTHug");

var $gbMhS = parcelRequire("gbMhS");
var $7976870743141e1e$var$m = {
    Label: (0, $hwhVv.LabelStyled),
    TrailingIcon: (0, $lTHug.TrailingIconStyled),
    SupportText: (0, $3tf6i.SupportTextStyled)
};
var $7976870743141e1e$export$ed56b7ee0f789b3d = function(e) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $AKSwl.DatePickerFallback), Object.assign({}, $7976870743141e1e$var$m, e));
};
var $7976870743141e1e$export$7b1755b32f92a7d8 = (0, $1poQt.default)($7976870743141e1e$export$ed56b7ee0f789b3d, {
    target: "e150jzwo0"
})((0, $gbMhS.fallbackBaseStyles));

});
parcelRegister("gbMhS", function(module, exports) {

$parcel$export(module.exports, "nativeBaseStyles", () => $bc93214cb6edde60$export$e202836891511fe7);
$parcel$export(module.exports, "fallbackBaseStyles", () => $bc93214cb6edde60$export$80322a1beeca01af);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");
var $bc93214cb6edde60$export$e202836891511fe7 = function(t) {
    var i = t.theme, r = i.sizeIconM, n = i.colorContentDisabled;
    return (0, $6xSYO.default)("input[readonly] ~ .ncss-trailing-icon-container{color:", n, ';}[dir="rtl"] &{direction:rtl;text-align:right;label:not(.active){right:24px;}.nds-input-layout-control{}}.ncss-trailing-icon-container{position:absolute;right:0px;pointer-events:none;width:', r, ";height:", r, ';[dir="rtl"] &{right:unset;left:0px;}}');
};
var $bc93214cb6edde60$export$80322a1beeca01af = function(t) {
    var i = t.theme, r = t.error, n = t.readOnly, o = i.typographyBody2, a = i.typographyBody4, l = i.colorContentPrimary, s = i.colorContentSecondary, d = i.colorContentError, p = i.colorContentDisabled, c = i.colorBorderBase, f = i.colorBorderFocus, b = i.paletteGrey1, u = i.transitionDurationNormal, g = i.transitionTimingFunctionEase, h = i.sizeBorderRadiusM, y = i.sizeBorderWidthS, m = i.sizeSpacingXs, v = i.sizeSpacingS, x = i.sizeSpacingM, z = i.sizeSpacingGridGutterL, w = i.sizeFormInputContainerHeight, S = i.sizeFormInputFieldHeight, B = i.sizeIconM;
    return (0, $6xSYO.default)("width:100%;box-sizing:border-box;font-family:", o.fontFamily, ";overflow:visible;position:relative;min-height:", w, ";.ncss-datepickerfb-parent-container{display:flex;justify-content:flex-start;align-items:center;position:relative;width:100%;height:", S, ";top:", v, ";border-radius:", h, ";pointer-events:", n ? "none" : "auto", ';[dir="rtl"] &{padding-inline-start:', x, ";}input[readonly] ~ fieldset{border-color:", c, ";}&:hover{fieldset{border-color:", r ? d : f, ";}}input{outline:0;border:0;}input,.fb-input-measurement{font-family:", o.fontFamily, ";font-size:", o.fontSize, ";height:100%;padding:0 ", m, " 0 ", v, ';background:transparent;[dir="rtl"] &{padding:0 ', v, " 0 ", m, ";}}input::placeholder{color:", s, ";}input[readonly],input[readonly]::placeholder,input[readonly] ~ label,input[readonly] ~ span,input[readonly] ~ .fb-input-seperator{color:", p, ";}.fb-first-input,.fb-first-input-year,.fb-first-input-measurement,.fb-first-input-year-measurement{padding-left:", z, ";overflow:visible;}.fb-input-measurement{position:absolute;display:hidden;left:-9999px;top:-9999px;}.fb-input-seperator{color:", s, ";width:0;}.ncss-trailing-icon-container{position:absolute;pointer-events:none;width:", B, ";height:", B, ';}label{pointer-events:none;[dir="rtl"] &{&.is-active{transform:scale(0.75) translate(116px,-32px);}}}fieldset{position:absolute;box-sizing:border-box;left:0;bottom:0;width:100%;height:100%;border-color:', r ? d : b, ";border-style:solid;border-width:", y, ";border-radius:", h, ";padding:0;margin:0;pointer-events:none;legend{border:0;margin-left:7px;padding:0;font-size:0px;visibility:hidden;height:1px;transition-property:padding,font-size;transition-duration:", u, ";transition-timing-function:", g, ";}}}&:not(.active){.fb-first-input,.fb-first-input-year{min-width:100%;}.fb-middle-input,.fb-last-input,.fb-input-seperator{overflow:hidden;width:0;padding:0;}input,.fb-input-seperator{opacity:0;}}&.active{.ncss-datepickerfb-parent-container:hover{fieldset{border-color:", f, ";}label{color:", l, ";}}.fb-last-input{width:100%;}fieldset{legend{padding:0px ", m, ";font-size:", a.fontSize, ";}}}&.focus{.ncss-datepickerfb-parent-container{label{color:", l, ";}fieldset{border-color:", f, ";}}}&.error{.ncss-datepickerfb-parent-container,.ncss-datepickerfb-parent-container:hover{label{color:", d, ";}fieldset{border-color:", d, ";}}input[readonly] ~ fieldset{border-color:", c, ";}}&.error.focus{.ncss-datepickerfb-parent-container{label{color:", l, ";}fieldset{border-color:", f, ";}}}.textfield-support-container{position:relative;margin-top:", v, ";display:flex;padding:", m, " ", z, " 0 ", z, ";}");
};

});




parcelRegister("jShCf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $e780b99790579e2d$export$1e511d4a378977f5, (v) => $e780b99790579e2d$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $e780b99790579e2d$export$2e2bcd8739ae039, (v) => $e780b99790579e2d$export$2e2bcd8739ae039 = v);
var $e780b99790579e2d$export$1e511d4a378977f5;
var $e780b99790579e2d$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$e780b99790579e2d$export$1e511d4a378977f5 = true;
$e780b99790579e2d$export$2e2bcd8739ae039 = void 0;

var $142Bi = parcelRequire("142Bi");

var $e780b99790579e2d$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $e780b99790579e2d$var$_react = $e780b99790579e2d$var$_interopRequireWildcard((parcelRequire("acw62")));

var $e780b99790579e2d$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $e780b99790579e2d$var$_MarkdownStatus = $1jnue((parcelRequire("2ry9E")));

var $e780b99790579e2d$var$_ButtonPopup = $1jnue((parcelRequire("elKPR")));

var $e780b99790579e2d$var$_ContentLoads = $1jnue((parcelRequire("bploO")));

var $e780b99790579e2d$var$_Input = $1jnue((parcelRequire("AJ2d4")));

var $e780b99790579e2d$var$_Messages = $1jnue((parcelRequire("eUNP9")));

function $e780b99790579e2d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($e780b99790579e2d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $e780b99790579e2d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $e780b99790579e2d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $e780b99790579e2d$var$ProductsDisplay = ({ canDelete: canDelete, isMarkdowns: isMarkdowns, isStockOnHand: isStockOnHand, onStockOnHandDelete: onStockOnHandDelete, popupSubtitle: popupSubtitle, products: products, promotion: promotion, setProducts: setProducts, title: title })=>{
    const [isDeleting, setIsDeleting] = (0, $e780b99790579e2d$var$_react.useState)(false);
    const [error, setError] = (0, $e780b99790579e2d$var$_react.useState)("");
    const [searchValue, setSearchValue] = (0, $e780b99790579e2d$var$_react.useState)("");
    const translate = (0, $e780b99790579e2d$var$_useTranslate.default)();
    const onDelete = (product)=>{
        setIsDeleting(true);
        const newProducts = products.filter((item)=>item.styleColor !== product.styleColor);
        (async ()=>(0, $ilYXe.patchPromotion)(promotion.id, {
                updates: (0, $6zLPD.formatPromotionPatchDeleteItems)([
                    product
                ]),
                ...(0, $6zLPD.formatStoreInfo)()
            }).then((res)=>res.errors.length ? (0, $6zLPD.handleResponse)(setProducts, products, setError, (0, $6zLPD.handleErrorMessage)(res.errors[0])) : (0, $6zLPD.handleResponse)(setProducts, newProducts, setError, "")).catch((err)=>(0, $6zLPD.handleResponse)(setProducts, products, setError, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>setIsDeleting(false)))();
    };
    const filterProducts = (product)=>product.styleColor.indexOf(searchValue.toUpperCase()) !== -1 || product.name.toUpperCase().indexOf(searchValue.toUpperCase()) !== -1;
    return /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement($e780b99790579e2d$var$_ContentLoads.default, {
        isLoading: isDeleting
    }, products.length ? /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement($e780b99790579e2d$var$_react.default.Fragment, null, !isStockOnHand && /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement($e780b99790579e2d$var$_Input.default, {
        id: "Search Markdowns",
        label: isMarkdowns ? translate("RL_SearchMarkdowns") : translate("RL_SearchProductOrStyleColor"),
        placeholder: translate("RL_ProductNameOrStyleColor"),
        trailingIconContent: /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement($142Bi.Close, null),
        value: searchValue,
        onChange: setSearchValue,
        onIconClick: ()=>setSearchValue("")
    }), /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("p", {
        className: "body-4 ta-sm-l text-color-secondary"
    }, title), products.filter((p)=>filterProducts(p)).map((p)=>{
        var _p$upcomingMarkdown;
        return /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("article", {
            key: p.productId,
            className: "va-sm-t ta-sm-l p2-sm border"
        }, /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("section", {
            className: "slide-display"
        }, /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("section", {
            className: "d-sm-flx flx-ai-sm-c slide-display-info"
        }, /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("img", {
            alt: p.name,
            className: "u-rounded flx-as-sm-c flx-gro-sm-0",
            src: `${p.imageUrl ? p.imageUrl : "https://static.nike.com/a/images/c_limit,h_500,w_500,f_jpg,q_auto:eco/notfound/image.jpg"}`,
            style: {
                height: "90px",
                width: "90px"
            }
        }), /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("section", {
            className: "flx-gro-sm-1 va-sm-t ml4-sm"
        }, /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("p", {
            className: "headline-4 d-sm-flx flx-dir-sm-r flx-ai-sm-c"
        }, p.name, p.productShipmentCount && /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("span", {
            className: "text-color-success ml3-sm body-3"
        }, "- ", translate("RL_InTransit"), " (", translate("RL_Quantity"), " - ", p.productShipmentCount, ")")), /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("p", {
            className: "body-2"
        }, isMarkdowns && (p.markdownPrice || (p === null || p === void 0 ? void 0 : (_p$upcomingMarkdown = p.upcomingMarkdown) === null || _p$upcomingMarkdown === void 0 ? void 0 : _p$upcomingMarkdown.markdownPrice)), isStockOnHand && `${p.stockOnHand}x`, /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement("span", {
            className: "text-color-secondary"
        }, p.styleColor)), isMarkdowns && /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement($e780b99790579e2d$var$_MarkdownStatus.default, {
            markdown: p
        }))), (canDelete && promotion || canDelete && isStockOnHand && onStockOnHandDelete) && /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement($e780b99790579e2d$var$_ButtonPopup.default, {
            className: "bg-error u-rounded text-color-primary-light flx-jc-sm-c flx-ai-sm-c ml2-sm slide-display-button",
            isSubmitting: isDeleting,
            label: translate("RL_Delete"),
            style: {
                height: "90px",
                width: "90px"
            },
            subtitle: popupSubtitle || translate("RL_RemoveConfirmation"),
            onSubmit: ()=>isStockOnHand ? onStockOnHandDelete(p) : onDelete(p)
        })), /*#__PURE__*/ $e780b99790579e2d$var$_react.default.createElement($e780b99790579e2d$var$_Messages.default, {
            className: error ? "pt2-sm" : "",
            error: error
        }));
    })) : translate("RL_NoAssociatedProducts"));
};
$e780b99790579e2d$var$ProductsDisplay.defaultProps = {
    canDelete: false,
    isMarkdowns: false,
    isStockOnHand: false,
    onStockOnHandDelete: undefined,
    popupSubtitle: null,
    promotion: undefined,
    setProducts: ()=>{},
    title: ""
};
$e780b99790579e2d$var$ProductsDisplay.propTypes = {
    canDelete: $e780b99790579e2d$var$_propTypes.default.bool,
    isMarkdowns: $e780b99790579e2d$var$_propTypes.default.bool,
    isStockOnHand: $e780b99790579e2d$var$_propTypes.default.bool,
    onStockOnHandDelete: $e780b99790579e2d$var$_propTypes.default.func,
    popupSubtitle: $e780b99790579e2d$var$_propTypes.default.string,
    products: $e780b99790579e2d$var$_propTypes.default.arrayOf($e780b99790579e2d$var$_propTypes.default.shape({
        markdownPrice: $e780b99790579e2d$var$_propTypes.default.string,
        name: $e780b99790579e2d$var$_propTypes.default.string.isRequired,
        productId: $e780b99790579e2d$var$_propTypes.default.string.isRequired,
        stockOnHand: $e780b99790579e2d$var$_propTypes.default.number,
        styleColor: $e780b99790579e2d$var$_propTypes.default.string.isRequired
    })).isRequired,
    promotion: $e780b99790579e2d$var$_propTypes.default.shape({
        discountPercentage: $e780b99790579e2d$var$_propTypes.default.number.isRequired,
        divisions: $e780b99790579e2d$var$_propTypes.default.shape().isRequired,
        endDate: $e780b99790579e2d$var$_propTypes.default.string.isRequired,
        genders: $e780b99790579e2d$var$_propTypes.default.shape().isRequired,
        id: $e780b99790579e2d$var$_propTypes.default.string.isRequired,
        itemDetails: $e780b99790579e2d$var$_propTypes.default.arrayOf($e780b99790579e2d$var$_propTypes.default.shape({
            gtin: $e780b99790579e2d$var$_propTypes.default.string,
            name: $e780b99790579e2d$var$_propTypes.default.string,
            productId: $e780b99790579e2d$var$_propTypes.default.string,
            styleColor: $e780b99790579e2d$var$_propTypes.default.string
        })),
        name: $e780b99790579e2d$var$_propTypes.default.string.isRequired,
        startDate: $e780b99790579e2d$var$_propTypes.default.string.isRequired
    }),
    setProducts: $e780b99790579e2d$var$_propTypes.default.func,
    title: $e780b99790579e2d$var$_propTypes.default.string
};
var $e780b99790579e2d$var$_default = $e780b99790579e2d$export$2e2bcd8739ae039 = $e780b99790579e2d$var$ProductsDisplay;

});
parcelRegister("2ry9E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $1c7898cef799b351$export$1e511d4a378977f5, (v) => $1c7898cef799b351$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $1c7898cef799b351$export$2e2bcd8739ae039, (v) => $1c7898cef799b351$export$2e2bcd8739ae039 = v);
var $1c7898cef799b351$export$1e511d4a378977f5;
var $1c7898cef799b351$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$1c7898cef799b351$export$1e511d4a378977f5 = true;
$1c7898cef799b351$export$2e2bcd8739ae039 = void 0;

var $1c7898cef799b351$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $1c7898cef799b351$var$_react = $1jnue((parcelRequire("acw62")));

var $1c7898cef799b351$var$_useTranslate = $1jnue((parcelRequire("90irH")));
const $1c7898cef799b351$var$MarkdownStatus = (markdown)=>{
    var _markdown$upcomingMar;
    const translate = (0, $1c7898cef799b351$var$_useTranslate.default)();
    const markdownStatus = (upcomingMarkdown)=>{
        const activeStatus = /*#__PURE__*/ $1c7898cef799b351$var$_react.default.createElement("span", {
            key: "active-status",
            className: "text-color-success"
        }, translate("RL_Active"));
        return !upcomingMarkdown ? activeStatus : [
            activeStatus,
            /*#__PURE__*/ $1c7898cef799b351$var$_react.default.createElement("span", {
                key: "new-price-status",
                className: "body-3 text-color-secondary"
            }, " - ", translate("RL_NewPrice"), " ", upcomingMarkdown.markdownPrice, " ", translate("RL_Starts"), " ", upcomingMarkdown.startDate)
        ];
    };
    return /*#__PURE__*/ $1c7898cef799b351$var$_react.default.createElement("p", {
        className: "body-3"
    }, markdown.startDate ? markdownStatus(markdown.upcomingMarkdown) : /*#__PURE__*/ $1c7898cef799b351$var$_react.default.createElement("span", {
        className: "text-color-secondary"
    }, translate("RL_Starts"), " ", markdown === null || markdown === void 0 ? void 0 : (_markdown$upcomingMar = markdown.upcomingMarkdown) === null || _markdown$upcomingMar === void 0 ? void 0 : _markdown$upcomingMar.startDate));
};
$1c7898cef799b351$var$MarkdownStatus.propTypes = {
    markdown: $1c7898cef799b351$var$_propTypes.default.shape({
        startDate: $1c7898cef799b351$var$_propTypes.default.string,
        // Defined if markdown is "Active"
        upcomingMarkdown: $1c7898cef799b351$var$_propTypes.default.shape({
            // Defined if markdown is "Upcoming"
            markdownPrice: $1c7898cef799b351$var$_propTypes.default.string,
            startDate: $1c7898cef799b351$var$_propTypes.default.string
        })
    }).isRequired
};
var $1c7898cef799b351$var$_default = $1c7898cef799b351$export$2e2bcd8739ae039 = $1c7898cef799b351$var$MarkdownStatus;

});


parcelRegister("bKeHw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $88cf64e3ddfa76c9$export$1e511d4a378977f5, (v) => $88cf64e3ddfa76c9$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $88cf64e3ddfa76c9$export$2e2bcd8739ae039, (v) => $88cf64e3ddfa76c9$export$2e2bcd8739ae039 = v);
var $88cf64e3ddfa76c9$export$1e511d4a378977f5;
var $88cf64e3ddfa76c9$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$88cf64e3ddfa76c9$export$1e511d4a378977f5 = true;
$88cf64e3ddfa76c9$export$2e2bcd8739ae039 = void 0;

var $142Bi = parcelRequire("142Bi");
parcelRequire("lpaee");
var $bx5V3 = parcelRequire("bx5V3");
var $1oJp7 = parcelRequire("1oJp7");

var $88cf64e3ddfa76c9$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $88cf64e3ddfa76c9$var$_react = $88cf64e3ddfa76c9$var$_interopRequireWildcard((parcelRequire("acw62")));

var $88cf64e3ddfa76c9$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $88cf64e3ddfa76c9$var$_Button = $1jnue((parcelRequire("wPEr3")));

var $88cf64e3ddfa76c9$var$_LoadingIndicator = $1jnue((parcelRequire("8hUZb")));

var $88cf64e3ddfa76c9$var$_Messages = $1jnue((parcelRequire("eUNP9")));

function $88cf64e3ddfa76c9$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($88cf64e3ddfa76c9$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $88cf64e3ddfa76c9$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $88cf64e3ddfa76c9$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $88cf64e3ddfa76c9$var$ALLOWED_FORMATS = [
    $bx5V3.default.CODE_128,
    $bx5V3.default.EAN_13,
    $bx5V3.default.EAN_8,
    $bx5V3.default.UPC_A,
    $bx5V3.default.UPC_E,
    $bx5V3.default.UPC_EAN_EXTENSION
];
const $88cf64e3ddfa76c9$var$codeReader = new $1oJp7.BrowserMultiFormatReader(null, [
    ...$88cf64e3ddfa76c9$var$ALLOWED_FORMATS
]);
const $88cf64e3ddfa76c9$var$isValidScan = (result)=>$88cf64e3ddfa76c9$var$ALLOWED_FORMATS.includes(result === null || result === void 0 ? void 0 : result.format);
const $88cf64e3ddfa76c9$var$Scanner = ({ children: children, onClose: onClose, onDetected: onDetected })=>{
    const videoRef = (0, $88cf64e3ddfa76c9$var$_react.useRef)(null);
    const translate = (0, $88cf64e3ddfa76c9$var$_useTranslate.default)();
    (0, $88cf64e3ddfa76c9$var$_react.useEffect)(()=>{
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) navigator.mediaDevices.getUserMedia({
            video: {
                facingMode: "environment"
            }
        }).then((stream)=>{
            $88cf64e3ddfa76c9$var$codeReader.listVideoInputDevices().then((videoInputDevices)=>{
                const selectedDeviceId = videoInputDevices[0].deviceId;
                return selectedDeviceId;
            }).then(()=>{
                $88cf64e3ddfa76c9$var$codeReader.decodeFromVideoDevice(undefined, videoRef.current, (result, err)=>{
                    if (result) {
                        if (!$88cf64e3ddfa76c9$var$isValidScan(result)) // Scanned Code is not supported!!
                        return false;
                        onDetected(result.text);
                        return result.text;
                    }
                    err;
                    return true;
                });
                return null;
            }).catch((err)=>err);
            return stream;
        }).catch((err)=>err);
        return ()=>{
            $88cf64e3ddfa76c9$var$codeReader.reset();
        };
    }, [
        onDetected
    ]);
    const ScannerLens = ()=>/*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement("div", {
            className: "scanner-lens"
        });
    return /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement("article", {
        className: "scanner-container"
    }, /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement(ScannerLens, null), /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement($88cf64e3ddfa76c9$var$_LoadingIndicator.default, null), /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement($88cf64e3ddfa76c9$var$_Button.default, {
        icon: /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement($142Bi.Close, {
            style: {
                margin: "0.32rem -1rem"
            },
            title: "Cancel"
        }),
        sectionClassName: "scanner-close",
        onClick: onClose
    }), /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement("section", {
        className: "scanner-target"
    }, /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement("video", {
        ref: videoRef,
        muted: true,
        playsInline: true,
        className: "scanner-target",
        id: "video"
    }, /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement("track", {
        kind: "captions"
    }))), /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement("section", {
        className: "ncss-col-sm-12 scanner-button"
    }, children || /*#__PURE__*/ $88cf64e3ddfa76c9$var$_react.default.createElement($88cf64e3ddfa76c9$var$_Messages.default, {
        success: translate("RL_StartScanning")
    })));
};
$88cf64e3ddfa76c9$var$Scanner.defaultProps = {
    children: null
};
$88cf64e3ddfa76c9$var$Scanner.propTypes = {
    children: $88cf64e3ddfa76c9$var$_propTypes.default.oneOfType([
        $88cf64e3ddfa76c9$var$_propTypes.default.element,
        $88cf64e3ddfa76c9$var$_propTypes.default.arrayOf($88cf64e3ddfa76c9$var$_propTypes.default.element)
    ]),
    onClose: $88cf64e3ddfa76c9$var$_propTypes.default.func.isRequired,
    onDetected: $88cf64e3ddfa76c9$var$_propTypes.default.func.isRequired
};
var $88cf64e3ddfa76c9$var$_default = $88cf64e3ddfa76c9$export$2e2bcd8739ae039 = $88cf64e3ddfa76c9$var$Scanner;

});
parcelRegister("lpaee", function(module, exports) {

$parcel$export(module.exports, "BarcodeFormat", () => (parcelRequire("bx5V3")).default);

var $1G3QF = parcelRequire("1G3QF");

var $bfDuf = parcelRequire("bfDuf");

var $72EX6 = parcelRequire("72EX6");

var $9Nn2d = parcelRequire("9Nn2d");

var $26SD6 = parcelRequire("26SD6");

var $dtgr5 = parcelRequire("dtgr5");

var $kLpae = parcelRequire("kLpae");

var $amwnq = parcelRequire("amwnq");

var $cQi30 = parcelRequire("cQi30");

var $6JrXb = parcelRequire("6JrXb");

var $is5hj = parcelRequire("is5hj");

var $e8t3n = parcelRequire("e8t3n");

var $lq7FB = parcelRequire("lq7FB");

var $bx5V3 = parcelRequire("bx5V3");

var $lXXBN = parcelRequire("lXXBN");

var $lU9SL = parcelRequire("lU9SL");

var $b5DE3 = parcelRequire("b5DE3");

var $bBVLs = parcelRequire("bBVLs");

var $bvYQM = parcelRequire("bvYQM");

var $72l3G = parcelRequire("72l3G");

var $j3BF2 = parcelRequire("j3BF2");

var $aSnmH = parcelRequire("aSnmH");

var $kWndQ = parcelRequire("kWndQ");

var $eS8qc = parcelRequire("eS8qc");

var $5rZ9k = parcelRequire("5rZ9k");

var $fwBMA = parcelRequire("fwBMA");

var $b6IL4 = parcelRequire("b6IL4");

var $6E9N1 = parcelRequire("6E9N1");

var $fPMAB = parcelRequire("fPMAB");

var $h9FI6 = parcelRequire("h9FI6");

var $iYwLM = parcelRequire("iYwLM");

var $7QoZg = parcelRequire("7QoZg");

var $hcAg4 = parcelRequire("hcAg4");

var $fHKUB = parcelRequire("fHKUB");

var $hzqel = parcelRequire("hzqel");

var $iVZgW = parcelRequire("iVZgW");

var $l8eP1 = parcelRequire("l8eP1");

var $jpf17 = parcelRequire("jpf17");

var $acfSE = parcelRequire("acfSE");

var $1q3xj = parcelRequire("1q3xj");

var $1NSRh = parcelRequire("1NSRh");

var $a6Uvg = parcelRequire("a6Uvg");

var $Ywfs9 = parcelRequire("Ywfs9");

var $5a6kn = parcelRequire("5a6kn");

var $fPntp = parcelRequire("fPntp");

var $1e7M5 = parcelRequire("1e7M5");

var $7mB9T = parcelRequire("7mB9T");

var $fbOCK = parcelRequire("fbOCK");

var $jIl78 = parcelRequire("jIl78");

var $7nLua = parcelRequire("7nLua");

var $4v5ZZ = parcelRequire("4v5ZZ");

var $f5xTf = parcelRequire("f5xTf");

var $jFi7K = parcelRequire("jFi7K");

var $lxsNI = parcelRequire("lxsNI");

var $klJLs = parcelRequire("klJLs");

var $gTiVc = parcelRequire("gTiVc");

var $eQbu2 = parcelRequire("eQbu2");

var $h1LwC = parcelRequire("h1LwC");

var $lamxU = parcelRequire("lamxU");

var $1SukY = parcelRequire("1SukY");

var $6T9tw = parcelRequire("6T9tw");

var $7G1W6 = parcelRequire("7G1W6");

var $2ZNS2 = parcelRequire("2ZNS2");

var $3AG8d = parcelRequire("3AG8d");

var $2wCgm = parcelRequire("2wCgm");

var $d6Ijx = parcelRequire("d6Ijx");

var $3dVi1 = parcelRequire("3dVi1");

var $aH6oJ = parcelRequire("aH6oJ");

var $4yMtz = parcelRequire("4yMtz");

var $b41gY = parcelRequire("b41gY");

var $aLAHy = parcelRequire("aLAHy");

var $iFZGM = parcelRequire("iFZGM");

var $8Z0a4 = parcelRequire("8Z0a4");

var $6YEpc = parcelRequire("6YEpc");

var $2Km2C = parcelRequire("2Km2C");

var $78He7 = parcelRequire("78He7");

var $cvLRZ = parcelRequire("cvLRZ");

var $hEUjg = parcelRequire("hEUjg");

var $fJ3d6 = parcelRequire("fJ3d6");

var $8D9tv = parcelRequire("8D9tv");

var $8OWED = parcelRequire("8OWED");

var $7WPDx = parcelRequire("7WPDx");

var $4d4yv = parcelRequire("4d4yv");

var $bkP7r = parcelRequire("bkP7r");

var $e3wFC = parcelRequire("e3wFC");

var $erHVo = parcelRequire("erHVo");

var $itEYK = parcelRequire("itEYK");

var $fGbQr = parcelRequire("fGbQr");

var $hZs5H = parcelRequire("hZs5H");

var $7oKct = parcelRequire("7oKct");

var $9BRcf = parcelRequire("9BRcf");

var $a0iHq = parcelRequire("a0iHq");

var $bDjlU = parcelRequire("bDjlU");

var $4RT7c = parcelRequire("4RT7c");

var $5TbhC = parcelRequire("5TbhC");

var $2cyv1 = parcelRequire("2cyv1");

var $eisSD = parcelRequire("eisSD");

var $eWQaA = parcelRequire("eWQaA");
$parcel$exportWildcard(module.exports, $1G3QF);

});
parcelRegister("1G3QF", function(module, exports) {
$parcel$export(module.exports, "BrowserMultiFormatReader", () => (parcelRequire("1oJp7")).BrowserMultiFormatReader);
// browser
parcelRequire("cosxb");
parcelRequire("94fZV");
parcelRequire("au3R0");
parcelRequire("5BKaQ");
parcelRequire("1oJp7");
parcelRequire("fBj85");
parcelRequire("chxf2");
parcelRequire("bAAyj");

var $2E0E3 = parcelRequire("2E0E3");
parcelRequire("cuqS0");

var $AP5Sk = parcelRequire("AP5Sk");
parcelRequire("45Mx2");
$parcel$exportWildcard(module.exports, $2E0E3);
$parcel$exportWildcard(module.exports, $AP5Sk);

});
parcelRegister("cosxb", function(module, exports) {

var $au3R0 = parcelRequire("au3R0");

var $fJ3d6 = parcelRequire("fJ3d6");
var $905ddc356fd466a6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Aztec Code reader to use from browser.
 *
 * @class BrowserAztecCodeReader
 * @extends {BrowserCodeReader}
 */ var $905ddc356fd466a6$export$f01bcae3c23f676f = /** @class */ function(_super) {
    $905ddc356fd466a6$var$__extends(BrowserAztecCodeReader, _super);
    /**
     * Creates an instance of BrowserAztecCodeReader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     *
     * @memberOf BrowserAztecCodeReader
     */ function BrowserAztecCodeReader(timeBetweenScansMillis) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $fJ3d6.default)(), timeBetweenScansMillis) || this;
    }
    return BrowserAztecCodeReader;
}((0, $au3R0.BrowserCodeReader));

});
parcelRegister("au3R0", function(module, exports) {

$parcel$export(module.exports, "BrowserCodeReader", () => $7a1fb2032ae12cba$export$7b30a0ae0c6e0607);

var $bfDuf = parcelRequire("bfDuf");

var $lU9SL = parcelRequire("lU9SL");

var $9Nn2d = parcelRequire("9Nn2d");

var $fPntp = parcelRequire("fPntp");

var $dtgr5 = parcelRequire("dtgr5");

var $cQi30 = parcelRequire("cQi30");

var $cuqS0 = parcelRequire("cuqS0");

var $45Mx2 = parcelRequire("45Mx2");
var $7a1fb2032ae12cba$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7a1fb2032ae12cba$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $7a1fb2032ae12cba$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @deprecated Moving to @zxing/browser
 *
 * Base class for browser code reader.
 */ var $7a1fb2032ae12cba$export$7b30a0ae0c6e0607 = /** @class */ function() {
    /**
     * Creates an instance of BrowserCodeReader.
     * @param {Reader} reader The reader instance to decode the barcode
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent successful decode tries
     *
     * @memberOf BrowserCodeReader
     */ function BrowserCodeReader(reader, timeBetweenScansMillis, _hints) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        this.reader = reader;
        this.timeBetweenScansMillis = timeBetweenScansMillis;
        this._hints = _hints;
        /**
         * This will break the loop.
         */ this._stopContinuousDecode = false;
        /**
         * This will break the loop.
         */ this._stopAsyncDecode = false;
        /**
         * Delay time between decode attempts made by the scanner.
         */ this._timeBetweenDecodingAttempts = 0;
    }
    Object.defineProperty(BrowserCodeReader.prototype, "hasNavigator", {
        /**
         * If navigator is present.
         */ get: function() {
            return typeof navigator !== "undefined";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserCodeReader.prototype, "isMediaDevicesSuported", {
        /**
         * If mediaDevices under navigator is supported.
         */ get: function() {
            return this.hasNavigator && !!navigator.mediaDevices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserCodeReader.prototype, "canEnumerateDevices", {
        /**
         * If enumerateDevices under navigator is supported.
         */ get: function() {
            return !!(this.isMediaDevicesSuported && navigator.mediaDevices.enumerateDevices);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserCodeReader.prototype, "timeBetweenDecodingAttempts", {
        /** Time between two decoding tries in milli seconds. */ get: function() {
            return this._timeBetweenDecodingAttempts;
        },
        /**
         * Change the time span the decoder waits between two decoding tries.
         *
         * @param {number} millis Time between two decoding tries in milli seconds.
         */ set: function(millis) {
            this._timeBetweenDecodingAttempts = millis < 0 ? 0 : millis;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserCodeReader.prototype, "hints", {
        /**
         * Sets the hints.
         */ get: function() {
            return this._hints;
        },
        /**
         * Sets the hints.
         */ set: function(hints) {
            this._hints = hints || null;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Lists all the available video input devices.
     */ BrowserCodeReader.prototype.listVideoInputDevices = function() {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var devices, videoDevices, devices_1, devices_1_1, device, kind, deviceId, label, groupId, videoDevice;
            var e_1, _a;
            return $7a1fb2032ae12cba$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.hasNavigator) throw new Error("Can't enumerate devices, navigator is not present.");
                        if (!this.canEnumerateDevices) throw new Error("Can't enumerate devices, method not supported.");
                        return [
                            4 /*yield*/ ,
                            navigator.mediaDevices.enumerateDevices()
                        ];
                    case 1:
                        devices = _b.sent();
                        videoDevices = [];
                        try {
                            for(devices_1 = $7a1fb2032ae12cba$var$__values(devices), devices_1_1 = devices_1.next(); !devices_1_1.done; devices_1_1 = devices_1.next()){
                                device = devices_1_1.value;
                                kind = device.kind === "video" ? "videoinput" : device.kind;
                                if (kind !== "videoinput") continue;
                                deviceId = device.deviceId || device.id;
                                label = device.label || "Video device " + (videoDevices.length + 1);
                                groupId = device.groupId;
                                videoDevice = {
                                    deviceId: deviceId,
                                    label: label,
                                    kind: kind,
                                    groupId: groupId
                                };
                                videoDevices.push(videoDevice);
                            }
                        } catch (e_1_1) {
                            e_1 = {
                                error: e_1_1
                            };
                        } finally{
                            try {
                                if (devices_1_1 && !devices_1_1.done && (_a = devices_1.return)) _a.call(devices_1);
                            } finally{
                                if (e_1) throw e_1.error;
                            }
                        }
                        return [
                            2 /*return*/ ,
                            videoDevices
                        ];
                }
            });
        });
    };
    /**
     * Obtain the list of available devices with type 'videoinput'.
     *
     * @returns {Promise<VideoInputDevice[]>} an array of available video input devices
     *
     * @memberOf BrowserCodeReader
     *
     * @deprecated Use `listVideoInputDevices` instead.
     */ BrowserCodeReader.prototype.getVideoInputDevices = function() {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var devices;
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        devices = _a.sent();
                        return [
                            2 /*return*/ ,
                            devices.map(function(d) {
                                return new (0, $45Mx2.VideoInputDevice)(d.deviceId, d.label);
                            })
                        ];
                }
            });
        });
    };
    /**
     * Let's you find a device using it's Id.
     */ BrowserCodeReader.prototype.findDeviceById = function(deviceId) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var devices;
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.listVideoInputDevices()
                        ];
                    case 1:
                        devices = _a.sent();
                        if (!devices) return [
                            2 /*return*/ ,
                            null
                        ];
                        return [
                            2 /*return*/ ,
                            devices.find(function(x) {
                                return x.deviceId === deviceId;
                            })
                        ];
                }
            });
        });
    };
    /**
     * Decodes the barcode from the device specified by deviceId while showing the video in the specified video element.
     *
     * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
     * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns The decoding result.
     *
     * @memberOf BrowserCodeReader
     *
     * @deprecated Use `decodeOnceFromVideoDevice` instead.
     */ BrowserCodeReader.prototype.decodeFromInputVideoDevice = function(deviceId, videoSource) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.decodeOnceFromVideoDevice(deviceId, videoSource)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * In one attempt, tries to decode the barcode from the device specified by deviceId while showing the video in the specified video element.
     *
     * @param deviceId the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
     * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeOnceFromVideoDevice = function(deviceId, videoSource) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var videoConstraints, constraints;
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.reset();
                        if (!deviceId) videoConstraints = {
                            facingMode: "environment"
                        };
                        else videoConstraints = {
                            deviceId: {
                                exact: deviceId
                            }
                        };
                        constraints = {
                            video: videoConstraints
                        };
                        return [
                            4 /*yield*/ ,
                            this.decodeOnceFromConstraints(constraints, videoSource)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
     *
     * @param constraints the media stream constraints to get s valid media stream to decode from
     * @param video the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeOnceFromConstraints = function(constraints, videoSource) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var stream;
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            navigator.mediaDevices.getUserMedia(constraints)
                        ];
                    case 1:
                        stream = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeOnceFromStream(stream, videoSource)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
     *
     * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
     * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeOnceFromStream = function(stream, videoSource) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var video, result;
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.reset();
                        return [
                            4 /*yield*/ ,
                            this.attachStreamToVideo(stream, videoSource)
                        ];
                    case 1:
                        video = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeOnce(video)
                        ];
                    case 2:
                        result = _a.sent();
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /**
     * Continuously decodes the barcode from the device specified by device while showing the video in the specified video element.
     *
     * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
     * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<void>}
     *
     * @memberOf BrowserCodeReader
     *
     * @deprecated Use `decodeFromVideoDevice` instead.
     */ BrowserCodeReader.prototype.decodeFromInputVideoDeviceContinuously = function(deviceId, videoSource, callbackFn) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.decodeFromVideoDevice(deviceId, videoSource, callbackFn)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Continuously tries to decode the barcode from the device specified by device while showing the video in the specified video element.
     *
     * @param {string|null} [deviceId] the id of one of the devices obtained after calling getVideoInputDevices. Can be undefined, in this case it will decode from one of the available devices, preffering the main camera (environment facing) if available.
     * @param {string|HTMLVideoElement|null} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<void>}
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromVideoDevice = function(deviceId, videoSource, callbackFn) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var videoConstraints, constraints;
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!deviceId) videoConstraints = {
                            facingMode: "environment"
                        };
                        else videoConstraints = {
                            deviceId: {
                                exact: deviceId
                            }
                        };
                        constraints = {
                            video: videoConstraints
                        };
                        return [
                            4 /*yield*/ ,
                            this.decodeFromConstraints(constraints, videoSource, callbackFn)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Continuously tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
     *
     * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
     * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromConstraints = function(constraints, videoSource, callbackFn) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var stream;
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            navigator.mediaDevices.getUserMedia(constraints)
                        ];
                    case 1:
                        stream = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeFromStream(stream, videoSource, callbackFn)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * In one attempt, tries to decode the barcode from a stream obtained from the given constraints while showing the video in the specified video element.
     *
     * @param {MediaStream} [constraints] the media stream constraints to get s valid media stream to decode from
     * @param {string|HTMLVideoElement} [video] the video element in page where to show the video while decoding. Can be either an element id or directly an HTMLVideoElement. Can be undefined, in which case no video will be shown.
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromStream = function(stream, videoSource, callbackFn) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var video;
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.reset();
                        return [
                            4 /*yield*/ ,
                            this.attachStreamToVideo(stream, videoSource)
                        ];
                    case 1:
                        video = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeContinuously(video, callbackFn)
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * Breaks the decoding loop.
     */ BrowserCodeReader.prototype.stopAsyncDecode = function() {
        this._stopAsyncDecode = true;
    };
    /**
     * Breaks the decoding loop.
     */ BrowserCodeReader.prototype.stopContinuousDecode = function() {
        this._stopContinuousDecode = true;
    };
    /**
     * Sets the new stream and request a new decoding-with-delay.
     *
     * @param stream The stream to be shown in the video element.
     * @param decodeFn A callback for the decode method.
     */ BrowserCodeReader.prototype.attachStreamToVideo = function(stream, videoSource) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var videoElement;
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        videoElement = this.prepareVideoElement(videoSource);
                        this.addVideoSource(videoElement, stream);
                        this.videoElement = videoElement;
                        this.stream = stream;
                        return [
                            4 /*yield*/ ,
                            this.playVideoOnLoadAsync(videoElement)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ ,
                            videoElement
                        ];
                }
            });
        });
    };
    /**
     *
     * @param videoElement
     */ BrowserCodeReader.prototype.playVideoOnLoadAsync = function(videoElement) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            return _this.playVideoOnLoad(videoElement, function() {
                return resolve();
            });
        });
    };
    /**
     * Binds listeners and callbacks to the videoElement.
     *
     * @param element
     * @param callbackFn
     */ BrowserCodeReader.prototype.playVideoOnLoad = function(element, callbackFn) {
        var _this = this;
        this.videoEndedListener = function() {
            return _this.stopStreams();
        };
        this.videoCanPlayListener = function() {
            return _this.tryPlayVideo(element);
        };
        element.addEventListener("ended", this.videoEndedListener);
        element.addEventListener("canplay", this.videoCanPlayListener);
        element.addEventListener("playing", callbackFn);
        // if canplay was already fired, we won't know when to play, so just give it a try
        this.tryPlayVideo(element);
    };
    /**
     * Checks if the given video element is currently playing.
     */ BrowserCodeReader.prototype.isVideoPlaying = function(video) {
        return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
    };
    /**
     * Just tries to play the video and logs any errors.
     * The play call is only made is the video is not already playing.
     */ BrowserCodeReader.prototype.tryPlayVideo = function(videoElement) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            var _a;
            return $7a1fb2032ae12cba$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.isVideoPlaying(videoElement)) {
                            console.warn("Trying to play video that is already playing.");
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            videoElement.play()
                        ];
                    case 2:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        _a = _b.sent();
                        console.warn("It was not possible to play the video.");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Searches and validates a media element.
     */ BrowserCodeReader.prototype.getMediaElement = function(mediaElementId, type) {
        var mediaElement = document.getElementById(mediaElementId);
        if (!mediaElement) throw new (0, $bfDuf.default)("element with id '" + mediaElementId + "' not found");
        if (mediaElement.nodeName.toLowerCase() !== type.toLowerCase()) throw new (0, $bfDuf.default)("element with id '" + mediaElementId + "' must be an " + type + " element");
        return mediaElement;
    };
    /**
     * Decodes the barcode from an image.
     *
     * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
     * @param {string} [url]
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromImage = function(source, url) {
        if (!source && !url) throw new (0, $bfDuf.default)("either imageElement with a src set or an url must be provided");
        if (url && !source) return this.decodeFromImageUrl(url);
        return this.decodeFromImageElement(source);
    };
    /**
     * Decodes the barcode from a video.
     *
     * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
     * @param {string} [url]
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.decodeFromVideo = function(source, url) {
        if (!source && !url) throw new (0, $bfDuf.default)("Either an element with a src set or an URL must be provided");
        if (url && !source) return this.decodeFromVideoUrl(url);
        return this.decodeFromVideoElement(source);
    };
    /**
     * Decodes continuously the barcode from a video.
     *
     * @param {(string|HTMLImageElement)} [source] The image element that can be either an element id or the element itself. Can be undefined in which case the decoding will be done from the imageUrl parameter.
     * @param {string} [url]
     * @returns {Promise<Result>} The decoding result.
     *
     * @memberOf BrowserCodeReader
     *
     * @experimental
     */ BrowserCodeReader.prototype.decodeFromVideoContinuously = function(source, url, callbackFn) {
        if (undefined === source && undefined === url) throw new (0, $bfDuf.default)("Either an element with a src set or an URL must be provided");
        if (url && !source) return this.decodeFromVideoUrlContinuously(url, callbackFn);
        return this.decodeFromVideoElementContinuously(source, callbackFn);
    };
    /**
     * Decodes something from an image HTML element.
     */ BrowserCodeReader.prototype.decodeFromImageElement = function(source) {
        if (!source) throw new (0, $bfDuf.default)("An image element must be provided.");
        this.reset();
        var element = this.prepareImageElement(source);
        this.imageElement = element;
        var task;
        if (this.isImageLoaded(element)) task = this.decodeOnce(element, false, true);
        else task = this._decodeOnLoadImage(element);
        return task;
    };
    /**
     * Decodes something from an image HTML element.
     */ BrowserCodeReader.prototype.decodeFromVideoElement = function(source) {
        var element = this._decodeFromVideoElementSetup(source);
        return this._decodeOnLoadVideo(element);
    };
    /**
     * Decodes something from an image HTML element.
     */ BrowserCodeReader.prototype.decodeFromVideoElementContinuously = function(source, callbackFn) {
        var element = this._decodeFromVideoElementSetup(source);
        return this._decodeOnLoadVideoContinuously(element, callbackFn);
    };
    /**
     * Sets up the video source so it can be decoded when loaded.
     *
     * @param source The video source element.
     */ BrowserCodeReader.prototype._decodeFromVideoElementSetup = function(source) {
        if (!source) throw new (0, $bfDuf.default)("A video element must be provided.");
        this.reset();
        var element = this.prepareVideoElement(source);
        // defines the video element before starts decoding
        this.videoElement = element;
        return element;
    };
    /**
     * Decodes an image from a URL.
     */ BrowserCodeReader.prototype.decodeFromImageUrl = function(url) {
        if (!url) throw new (0, $bfDuf.default)("An URL must be provided.");
        this.reset();
        var element = this.prepareImageElement();
        this.imageElement = element;
        var decodeTask = this._decodeOnLoadImage(element);
        element.src = url;
        return decodeTask;
    };
    /**
     * Decodes an image from a URL.
     */ BrowserCodeReader.prototype.decodeFromVideoUrl = function(url) {
        if (!url) throw new (0, $bfDuf.default)("An URL must be provided.");
        this.reset();
        // creates a new element
        var element = this.prepareVideoElement();
        var decodeTask = this.decodeFromVideoElement(element);
        element.src = url;
        return decodeTask;
    };
    /**
     * Decodes an image from a URL.
     *
     * @experimental
     */ BrowserCodeReader.prototype.decodeFromVideoUrlContinuously = function(url, callbackFn) {
        if (!url) throw new (0, $bfDuf.default)("An URL must be provided.");
        this.reset();
        // creates a new element
        var element = this.prepareVideoElement();
        var decodeTask = this.decodeFromVideoElementContinuously(element, callbackFn);
        element.src = url;
        return decodeTask;
    };
    BrowserCodeReader.prototype._decodeOnLoadImage = function(element) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            _this.imageLoadedListener = function() {
                return _this.decodeOnce(element, false, true).then(resolve, reject);
            };
            element.addEventListener("load", _this.imageLoadedListener);
        });
    };
    BrowserCodeReader.prototype._decodeOnLoadVideo = function(videoElement) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // plays the video
                        return [
                            4 /*yield*/ ,
                            this.playVideoOnLoadAsync(videoElement)
                        ];
                    case 1:
                        // plays the video
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.decodeOnce(videoElement)
                        ];
                    case 2:
                        // starts decoding after played the video
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    BrowserCodeReader.prototype._decodeOnLoadVideoContinuously = function(videoElement, callbackFn) {
        return $7a1fb2032ae12cba$var$__awaiter(this, void 0, void 0, function() {
            return $7a1fb2032ae12cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // plays the video
                        return [
                            4 /*yield*/ ,
                            this.playVideoOnLoadAsync(videoElement)
                        ];
                    case 1:
                        // plays the video
                        _a.sent();
                        // starts decoding after played the video
                        this.decodeContinuously(videoElement, callbackFn);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserCodeReader.prototype.isImageLoaded = function(img) {
        // During the onload event, IE correctly identifies any images that
        // weren’t downloaded as not complete. Others should too. Gecko-based
        // browsers act like NS4 in that they report this incorrectly.
        if (!img.complete) return false;
        // However, they do have two very useful properties: naturalWidth and
        // naturalHeight. These give the true size of the image. If it failed
        // to load, either of these should be zero.
        if (img.naturalWidth === 0) return false;
        // No other way of checking: assume it’s ok.
        return true;
    };
    BrowserCodeReader.prototype.prepareImageElement = function(imageSource) {
        var imageElement;
        if (typeof imageSource === "undefined") {
            imageElement = document.createElement("img");
            imageElement.width = 200;
            imageElement.height = 200;
        }
        if (typeof imageSource === "string") imageElement = this.getMediaElement(imageSource, "img");
        if (imageSource instanceof HTMLImageElement) imageElement = imageSource;
        return imageElement;
    };
    /**
     * Sets a HTMLVideoElement for scanning or creates a new one.
     *
     * @param videoSource The HTMLVideoElement to be set.
     */ BrowserCodeReader.prototype.prepareVideoElement = function(videoSource) {
        var videoElement;
        if (!videoSource && typeof document !== "undefined") {
            videoElement = document.createElement("video");
            videoElement.width = 200;
            videoElement.height = 200;
        }
        if (typeof videoSource === "string") videoElement = this.getMediaElement(videoSource, "video");
        if (videoSource instanceof HTMLVideoElement) videoElement = videoSource;
        // Needed for iOS 11
        videoElement.setAttribute("autoplay", "true");
        videoElement.setAttribute("muted", "true");
        videoElement.setAttribute("playsinline", "true");
        return videoElement;
    };
    /**
     * Tries to decode from the video input until it finds some value.
     */ BrowserCodeReader.prototype.decodeOnce = function(element, retryIfNotFound, retryIfChecksumOrFormatError) {
        var _this = this;
        if (retryIfNotFound === void 0) retryIfNotFound = true;
        if (retryIfChecksumOrFormatError === void 0) retryIfChecksumOrFormatError = true;
        this._stopAsyncDecode = false;
        var loop = function(resolve, reject) {
            if (_this._stopAsyncDecode) {
                reject(new (0, $cQi30.default)("Video stream has ended before any code could be detected."));
                _this._stopAsyncDecode = undefined;
                return;
            }
            try {
                var result = _this.decode(element);
                resolve(result);
            } catch (e) {
                var ifNotFound = retryIfNotFound && e instanceof (0, $cQi30.default);
                var isChecksumOrFormatError = e instanceof (0, $9Nn2d.default) || e instanceof (0, $dtgr5.default);
                var ifChecksumOrFormat = isChecksumOrFormatError && retryIfChecksumOrFormatError;
                if (ifNotFound || ifChecksumOrFormat) // trying again
                return setTimeout(loop, _this._timeBetweenDecodingAttempts, resolve, reject);
                reject(e);
            }
        };
        return new Promise(function(resolve, reject) {
            return loop(resolve, reject);
        });
    };
    /**
     * Continuously decodes from video input.
     */ BrowserCodeReader.prototype.decodeContinuously = function(element, callbackFn) {
        var _this = this;
        this._stopContinuousDecode = false;
        var loop = function() {
            if (_this._stopContinuousDecode) {
                _this._stopContinuousDecode = undefined;
                return;
            }
            try {
                var result = _this.decode(element);
                callbackFn(result, null);
                setTimeout(loop, _this.timeBetweenScansMillis);
            } catch (e) {
                callbackFn(null, e);
                var isChecksumOrFormatError = e instanceof (0, $9Nn2d.default) || e instanceof (0, $dtgr5.default);
                var isNotFound = e instanceof (0, $cQi30.default);
                if (isChecksumOrFormatError || isNotFound) // trying again
                setTimeout(loop, _this._timeBetweenDecodingAttempts);
            }
        };
        loop();
    };
    /**
     * Gets the BinaryBitmap for ya! (and decodes it)
     */ BrowserCodeReader.prototype.decode = function(element) {
        // get binary bitmap for decode function
        var binaryBitmap = this.createBinaryBitmap(element);
        return this.decodeBitmap(binaryBitmap);
    };
    /**
     * Creates a binaryBitmap based in some image source.
     *
     * @param mediaElement HTML element containing drawable image source.
     */ BrowserCodeReader.prototype.createBinaryBitmap = function(mediaElement) {
        var ctx = this.getCaptureCanvasContext(mediaElement);
        if (mediaElement instanceof HTMLVideoElement) this.drawFrameOnCanvas(mediaElement);
        else this.drawImageOnCanvas(mediaElement);
        var canvas = this.getCaptureCanvas(mediaElement);
        var luminanceSource = new (0, $cuqS0.HTMLCanvasElementLuminanceSource)(canvas);
        var hybridBinarizer = new (0, $fPntp.default)(luminanceSource);
        return new (0, $lU9SL.default)(hybridBinarizer);
    };
    /**
     *
     */ BrowserCodeReader.prototype.getCaptureCanvasContext = function(mediaElement) {
        if (!this.captureCanvasContext) {
            var elem = this.getCaptureCanvas(mediaElement);
            var ctx = void 0;
            try {
                ctx = elem.getContext("2d", {
                    willReadFrequently: true
                });
            } catch (e) {
                ctx = elem.getContext("2d");
            }
            this.captureCanvasContext = ctx;
        }
        return this.captureCanvasContext;
    };
    /**
     *
     */ BrowserCodeReader.prototype.getCaptureCanvas = function(mediaElement) {
        if (!this.captureCanvas) {
            var elem = this.createCaptureCanvas(mediaElement);
            this.captureCanvas = elem;
        }
        return this.captureCanvas;
    };
    /**
     * Overwriting this allows you to manipulate the next frame in anyway you want before decode.
     */ BrowserCodeReader.prototype.drawFrameOnCanvas = function(srcElement, dimensions, canvasElementContext) {
        if (dimensions === void 0) dimensions = {
            sx: 0,
            sy: 0,
            sWidth: srcElement.videoWidth,
            sHeight: srcElement.videoHeight,
            dx: 0,
            dy: 0,
            dWidth: srcElement.videoWidth,
            dHeight: srcElement.videoHeight
        };
        if (canvasElementContext === void 0) canvasElementContext = this.captureCanvasContext;
        canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
    };
    /**
     * Ovewriting this allows you to manipulate the snapshot image in anyway you want before decode.
     */ BrowserCodeReader.prototype.drawImageOnCanvas = function(srcElement, dimensions, canvasElementContext) {
        if (dimensions === void 0) dimensions = {
            sx: 0,
            sy: 0,
            sWidth: srcElement.naturalWidth,
            sHeight: srcElement.naturalHeight,
            dx: 0,
            dy: 0,
            dWidth: srcElement.naturalWidth,
            dHeight: srcElement.naturalHeight
        };
        if (canvasElementContext === void 0) canvasElementContext = this.captureCanvasContext;
        canvasElementContext.drawImage(srcElement, dimensions.sx, dimensions.sy, dimensions.sWidth, dimensions.sHeight, dimensions.dx, dimensions.dy, dimensions.dWidth, dimensions.dHeight);
    };
    /**
     * Call the encapsulated readers decode
     */ BrowserCodeReader.prototype.decodeBitmap = function(binaryBitmap) {
        return this.reader.decode(binaryBitmap, this._hints);
    };
    /**
     * 🖌 Prepares the canvas for capture and scan frames.
     */ BrowserCodeReader.prototype.createCaptureCanvas = function(mediaElement) {
        if (typeof document === "undefined") {
            this._destroyCaptureCanvas();
            return null;
        }
        var canvasElement = document.createElement("canvas");
        var width;
        var height;
        if (typeof mediaElement !== "undefined") {
            if (mediaElement instanceof HTMLVideoElement) {
                width = mediaElement.videoWidth;
                height = mediaElement.videoHeight;
            } else if (mediaElement instanceof HTMLImageElement) {
                width = mediaElement.naturalWidth || mediaElement.width;
                height = mediaElement.naturalHeight || mediaElement.height;
            }
        }
        canvasElement.style.width = width + "px";
        canvasElement.style.height = height + "px";
        canvasElement.width = width;
        canvasElement.height = height;
        return canvasElement;
    };
    /**
     * Stops the continuous scan and cleans the stream.
     */ BrowserCodeReader.prototype.stopStreams = function() {
        if (this.stream) {
            this.stream.getVideoTracks().forEach(function(t) {
                return t.stop();
            });
            this.stream = undefined;
        }
        if (this._stopAsyncDecode === false) this.stopAsyncDecode();
        if (this._stopContinuousDecode === false) this.stopContinuousDecode();
    };
    /**
     * Resets the code reader to the initial state. Cancels any ongoing barcode scanning from video or camera.
     *
     * @memberOf BrowserCodeReader
     */ BrowserCodeReader.prototype.reset = function() {
        // stops the camera, preview and scan 🔴
        this.stopStreams();
        // clean and forget about HTML elements
        this._destroyVideoElement();
        this._destroyImageElement();
        this._destroyCaptureCanvas();
    };
    BrowserCodeReader.prototype._destroyVideoElement = function() {
        if (!this.videoElement) return;
        // first gives freedon to the element 🕊
        if (typeof this.videoEndedListener !== "undefined") this.videoElement.removeEventListener("ended", this.videoEndedListener);
        if (typeof this.videoPlayingEventListener !== "undefined") this.videoElement.removeEventListener("playing", this.videoPlayingEventListener);
        if (typeof this.videoCanPlayListener !== "undefined") this.videoElement.removeEventListener("loadedmetadata", this.videoCanPlayListener);
        // then forgets about that element 😢
        this.cleanVideoSource(this.videoElement);
        this.videoElement = undefined;
    };
    BrowserCodeReader.prototype._destroyImageElement = function() {
        if (!this.imageElement) return;
        // first gives freedon to the element 🕊
        if (undefined !== this.imageLoadedListener) this.imageElement.removeEventListener("load", this.imageLoadedListener);
        // then forget about that element 😢
        this.imageElement.src = undefined;
        this.imageElement.removeAttribute("src");
        this.imageElement = undefined;
    };
    /**
     * Cleans canvas references 🖌
     */ BrowserCodeReader.prototype._destroyCaptureCanvas = function() {
        // then forget about that element 😢
        this.captureCanvasContext = undefined;
        this.captureCanvas = undefined;
    };
    /**
     * Defines what the videoElement src will be.
     *
     * @param videoElement
     * @param stream
     */ BrowserCodeReader.prototype.addVideoSource = function(videoElement, stream) {
        // Older browsers may not have `srcObject`
        try {
            // @note Throws Exception if interrupted by a new loaded request
            videoElement.srcObject = stream;
        } catch (err) {
            // @note Avoid using this in new browsers, as it is going away.
            // @ts-ignore
            videoElement.src = URL.createObjectURL(stream);
        }
    };
    /**
     * Unbinds a HTML video src property.
     *
     * @param videoElement
     */ BrowserCodeReader.prototype.cleanVideoSource = function(videoElement) {
        try {
            videoElement.srcObject = null;
        } catch (err) {
            videoElement.src = "";
        }
        this.videoElement.removeAttribute("src");
    };
    return BrowserCodeReader;
}();

});
parcelRegister("bfDuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $021d28281c7fd8b6$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $021d28281c7fd8b6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $021d28281c7fd8b6$var$ArgumentException = /** @class */ function(_super) {
    $021d28281c7fd8b6$var$__extends(ArgumentException, _super);
    function ArgumentException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArgumentException.kind = "ArgumentException";
    return ArgumentException;
}((0, $26SD6.default));
var $021d28281c7fd8b6$export$2e2bcd8739ae039 = $021d28281c7fd8b6$var$ArgumentException;

});
parcelRegister("26SD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $189684a650f391fb$export$2e2bcd8739ae039);

var $6F5If = parcelRequire("6F5If");
var $189684a650f391fb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $189684a650f391fb$var$Exception = /** @class */ function(_super) {
    $189684a650f391fb$var$__extends(Exception, _super);
    /**
     * Allows Exception to be constructed directly
     * with some message and prototype definition.
     */ function Exception(message) {
        if (message === void 0) message = undefined;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        return _this;
    }
    Exception.prototype.getKind = function() {
        var ex = this.constructor;
        return ex.kind;
    };
    /**
     * It's typed as string so it can be extended and overriden.
     */ Exception.kind = "Exception";
    return Exception;
}((0, $6F5If.CustomError));
var $189684a650f391fb$export$2e2bcd8739ae039 = $189684a650f391fb$var$Exception;

});
parcelRegister("6F5If", function(module, exports) {

$parcel$export(module.exports, "CustomError", () => $6aba5d7a176539b0$export$f7a70f5f17339408);
function $6aba5d7a176539b0$var$fixProto(target, prototype) {
    var setPrototypeOf = Object.setPrototypeOf;
    setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
}
function $6aba5d7a176539b0$var$fixStack(target, fn) {
    if (fn === void 0) fn = target.constructor;
    var captureStackTrace = Error.captureStackTrace;
    captureStackTrace && captureStackTrace(target, fn);
}
var $6aba5d7a176539b0$var$__extends = function() {
    var _extendStatics = function extendStatics(d, b) {
        _extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return _extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        _extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6aba5d7a176539b0$export$f7a70f5f17339408 = function(_super) {
    $6aba5d7a176539b0$var$__extends(CustomError, _super);
    function CustomError(message, options) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message, options) || this;
        Object.defineProperty(_this, "name", {
            value: _newTarget.name,
            enumerable: false,
            configurable: true
        });
        $6aba5d7a176539b0$var$fixProto(_this, _newTarget.prototype);
        $6aba5d7a176539b0$var$fixStack(_this);
        return _this;
    }
    return CustomError;
}(Error);
var $6aba5d7a176539b0$var$__spreadArray = function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function $6aba5d7a176539b0$export$aa5f2b9aeca47350(fn, parent) {
    if (parent === void 0) parent = Error;
    function CustomError() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!(this instanceof CustomError)) return new (CustomError.bind.apply(CustomError, $6aba5d7a176539b0$var$__spreadArray([
            void 0
        ], args, false)))();
        parent.apply(this, args);
        Object.defineProperty(this, "name", {
            value: fn.name || parent.name,
            enumerable: false,
            configurable: true
        });
        fn.apply(this, args);
        $6aba5d7a176539b0$var$fixStack(this, CustomError);
    }
    return Object.defineProperties(CustomError, {
        prototype: {
            value: Object.create(parent.prototype, {
                constructor: {
                    value: CustomError,
                    writable: true,
                    configurable: true
                }
            })
        }
    });
}

});



parcelRegister("lU9SL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff267e5c03770962$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kLpae = parcelRequire("kLpae");
var $ff267e5c03770962$var$BinaryBitmap = /** @class */ function() {
    function BinaryBitmap(binarizer) {
        this.binarizer = binarizer;
        if (binarizer === null) throw new (0, $kLpae.default)("Binarizer must be non-null.");
    }
    /**
     * @return The width of the bitmap.
     */ BinaryBitmap.prototype.getWidth = function() {
        return this.binarizer.getWidth();
    };
    /**
     * @return The height of the bitmap.
     */ BinaryBitmap.prototype.getHeight = function() {
        return this.binarizer.getHeight();
    };
    /**
     * Converts one row of luminance data to 1 bit data. May actually do the conversion, or return
     * cached data. Callers should assume this method is expensive and call it as seldom as possible.
     * This method is intended for decoding 1D barcodes and may choose to apply sharpening.
     *
     * @param y The row to fetch, which must be in [0, bitmap height)
     * @param row An optional preallocated array. If null or too small, it will be ignored.
     *            If used, the Binarizer will call BitArray.clear(). Always use the returned object.
     * @return The array of bits for this row (true means black).
     * @throws NotFoundException if row can't be binarized
     */ BinaryBitmap.prototype.getBlackRow = function(y /*int*/ , row) {
        return this.binarizer.getBlackRow(y, row);
    };
    /**
     * Converts a 2D array of luminance data to 1 bit. As above, assume this method is expensive
     * and do not call it repeatedly. This method is intended for decoding 2D barcodes and may or
     * may not apply sharpening. Therefore, a row from this matrix may not be identical to one
     * fetched using getBlackRow(), so don't mix and match between them.
     *
     * @return The 2D array of bits for the image (true means black).
     * @throws NotFoundException if image can't be binarized to make a matrix
     */ BinaryBitmap.prototype.getBlackMatrix = function() {
        // The matrix is created on demand the first time it is requested, then cached. There are two
        // reasons for this:
        // 1. This work will never be done if the caller only installs 1D Reader objects, or if a
        //    1D Reader finds a barcode before the 2D Readers run.
        // 2. This work will only be done once even if the caller installs multiple 2D Readers.
        if (this.matrix === null || this.matrix === undefined) this.matrix = this.binarizer.getBlackMatrix();
        return this.matrix;
    };
    /**
     * @return Whether this bitmap can be cropped.
     */ BinaryBitmap.prototype.isCropSupported = function() {
        return this.binarizer.getLuminanceSource().isCropSupported();
    };
    /**
     * Returns a new object with cropped image data. Implementations may keep a reference to the
     * original data rather than a copy. Only callable if isCropSupported() is true.
     *
     * @param left The left coordinate, which must be in [0,getWidth())
     * @param top The top coordinate, which must be in [0,getHeight())
     * @param width The width of the rectangle to crop.
     * @param height The height of the rectangle to crop.
     * @return A cropped version of this object.
     */ BinaryBitmap.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        var newSource = this.binarizer.getLuminanceSource().crop(left, top, width, height);
        return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
    };
    /**
     * @return Whether this bitmap supports counter-clockwise rotation.
     */ BinaryBitmap.prototype.isRotateSupported = function() {
        return this.binarizer.getLuminanceSource().isRotateSupported();
    };
    /**
     * Returns a new object with rotated image data by 90 degrees counterclockwise.
     * Only callable if {@link #isRotateSupported()} is true.
     *
     * @return A rotated version of this object.
     */ BinaryBitmap.prototype.rotateCounterClockwise = function() {
        var newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise();
        return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
    };
    /**
     * Returns a new object with rotated image data by 45 degrees counterclockwise.
     * Only callable if {@link #isRotateSupported()} is true.
     *
     * @return A rotated version of this object.
     */ BinaryBitmap.prototype.rotateCounterClockwise45 = function() {
        var newSource = this.binarizer.getLuminanceSource().rotateCounterClockwise45();
        return new BinaryBitmap(this.binarizer.createBinarizer(newSource));
    };
    /*@Override*/ BinaryBitmap.prototype.toString = function() {
        try {
            return this.getBlackMatrix().toString();
        } catch (e /*: NotFoundException*/ ) {
            return "";
        }
    };
    return BinaryBitmap;
}();
var $ff267e5c03770962$export$2e2bcd8739ae039 = $ff267e5c03770962$var$BinaryBitmap;

});
parcelRegister("kLpae", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1dbb77b08a9ee16$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $f1dbb77b08a9ee16$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $f1dbb77b08a9ee16$var$IllegalArgumentException = /** @class */ function(_super) {
    $f1dbb77b08a9ee16$var$__extends(IllegalArgumentException, _super);
    function IllegalArgumentException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IllegalArgumentException.kind = "IllegalArgumentException";
    return IllegalArgumentException;
}((0, $26SD6.default));
var $f1dbb77b08a9ee16$export$2e2bcd8739ae039 = $f1dbb77b08a9ee16$var$IllegalArgumentException;

});


parcelRegister("9Nn2d", function(module, exports) {

$parcel$export(module.exports, "default", () => $721a8ede9949d265$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $721a8ede9949d265$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $721a8ede9949d265$var$ChecksumException = /** @class */ function(_super) {
    $721a8ede9949d265$var$__extends(ChecksumException, _super);
    function ChecksumException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChecksumException.getChecksumInstance = function() {
        return new ChecksumException();
    };
    ChecksumException.kind = "ChecksumException";
    return ChecksumException;
}((0, $26SD6.default));
var $721a8ede9949d265$export$2e2bcd8739ae039 = $721a8ede9949d265$var$ChecksumException;

});

parcelRegister("fPntp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b85dd3ba8dc79a20$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $a6Uvg = parcelRequire("a6Uvg");

var $hzqel = parcelRequire("hzqel");
var $b85dd3ba8dc79a20$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This class implements a local thresholding algorithm, which while slower than the
 * GlobalHistogramBinarizer, is fairly efficient for what it does. It is designed for
 * high frequency images of barcodes with black data on white backgrounds. For this application,
 * it does a much better job than a global blackpoint with severe shadows and gradients.
 * However it tends to produce artifacts on lower frequency images and is therefore not
 * a good general purpose binarizer for uses outside ZXing.
 *
 * This class extends GlobalHistogramBinarizer, using the older histogram approach for 1D readers,
 * and the newer local approach for 2D readers. 1D decoding using a per-row histogram is already
 * inherently local, and only fails for horizontal gradients. We can revisit that problem later,
 * but for now it was not a win to use local blocks for 1D.
 *
 * This Binarizer is the default for the unit tests and the recommended class for library users.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $b85dd3ba8dc79a20$var$HybridBinarizer = /** @class */ function(_super) {
    $b85dd3ba8dc79a20$var$__extends(HybridBinarizer, _super);
    function HybridBinarizer(source) {
        var _this = _super.call(this, source) || this;
        _this.matrix = null;
        return _this;
    }
    /**
     * Calculates the final BitMatrix once for all requests. This could be called once from the
     * constructor instead, but there are some advantages to doing it lazily, such as making
     * profiling easier, and not doing heavy lifting when callers don't expect it.
     */ /*@Override*/ HybridBinarizer.prototype.getBlackMatrix = function() {
        if (this.matrix !== null) return this.matrix;
        var source = this.getLuminanceSource();
        var width = source.getWidth();
        var height = source.getHeight();
        if (width >= HybridBinarizer.MINIMUM_DIMENSION && height >= HybridBinarizer.MINIMUM_DIMENSION) {
            var luminances = source.getMatrix();
            var subWidth = width >> HybridBinarizer.BLOCK_SIZE_POWER;
            if ((width & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subWidth++;
            var subHeight = height >> HybridBinarizer.BLOCK_SIZE_POWER;
            if ((height & HybridBinarizer.BLOCK_SIZE_MASK) !== 0) subHeight++;
            var blackPoints = HybridBinarizer.calculateBlackPoints(luminances, subWidth, subHeight, width, height);
            var newMatrix = new (0, $hzqel.default)(width, height);
            HybridBinarizer.calculateThresholdForBlock(luminances, subWidth, subHeight, width, height, blackPoints, newMatrix);
            this.matrix = newMatrix;
        } else // If the image is too small, fall back to the global histogram approach.
        this.matrix = _super.prototype.getBlackMatrix.call(this);
        return this.matrix;
    };
    /*@Override*/ HybridBinarizer.prototype.createBinarizer = function(source) {
        return new HybridBinarizer(source);
    };
    /**
     * For each block in the image, calculate the average black point using a 5x5 grid
     * of the blocks around it. Also handles the corner cases (fractional blocks are computed based
     * on the last pixels in the row/column which are also used in the previous block).
     */ HybridBinarizer.calculateThresholdForBlock = function(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ , blackPoints, matrix) {
        var maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
        var maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
        for(var y = 0; y < subHeight; y++){
            var yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
            if (yoffset > maxYOffset) yoffset = maxYOffset;
            var top_1 = HybridBinarizer.cap(y, 2, subHeight - 3);
            for(var x = 0; x < subWidth; x++){
                var xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                if (xoffset > maxXOffset) xoffset = maxXOffset;
                var left = HybridBinarizer.cap(x, 2, subWidth - 3);
                var sum = 0;
                for(var z = -2; z <= 2; z++){
                    var blackRow = blackPoints[top_1 + z];
                    sum += blackRow[left - 2] + blackRow[left - 1] + blackRow[left] + blackRow[left + 1] + blackRow[left + 2];
                }
                var average = sum / 25;
                HybridBinarizer.thresholdBlock(luminances, xoffset, yoffset, average, width, matrix);
            }
        }
    };
    HybridBinarizer.cap = function(value /*int*/ , min /*int*/ , max /*int*/ ) {
        return value < min ? min : value > max ? max : value;
    };
    /**
     * Applies a single threshold to a block of pixels.
     */ HybridBinarizer.thresholdBlock = function(luminances, xoffset /*int*/ , yoffset /*int*/ , threshold /*int*/ , stride /*int*/ , matrix) {
        for(var y = 0, offset = yoffset * stride + xoffset; y < HybridBinarizer.BLOCK_SIZE; y++, offset += stride){
            for(var x = 0; x < HybridBinarizer.BLOCK_SIZE; x++)// Comparison needs to be <= so that black == 0 pixels are black even if the threshold is 0.
            if ((luminances[offset + x] & 0xFF) <= threshold) matrix.set(xoffset + x, yoffset + y);
        }
    };
    /**
     * Calculates a single black point for each block of pixels and saves it away.
     * See the following thread for a discussion of this algorithm:
     *  http://groups.google.com/group/zxing/browse_thread/thread/d06efa2c35a7ddc0
     */ HybridBinarizer.calculateBlackPoints = function(luminances, subWidth /*int*/ , subHeight /*int*/ , width /*int*/ , height /*int*/ ) {
        var maxYOffset = height - HybridBinarizer.BLOCK_SIZE;
        var maxXOffset = width - HybridBinarizer.BLOCK_SIZE;
        // tslint:disable-next-line:whitespace
        var blackPoints = new Array(subHeight); // subWidth
        for(var y = 0; y < subHeight; y++){
            blackPoints[y] = new Int32Array(subWidth);
            var yoffset = y << HybridBinarizer.BLOCK_SIZE_POWER;
            if (yoffset > maxYOffset) yoffset = maxYOffset;
            for(var x = 0; x < subWidth; x++){
                var xoffset = x << HybridBinarizer.BLOCK_SIZE_POWER;
                if (xoffset > maxXOffset) xoffset = maxXOffset;
                var sum = 0;
                var min = 0xFF;
                var max = 0;
                for(var yy = 0, offset = yoffset * width + xoffset; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width){
                    for(var xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++){
                        var pixel = luminances[offset + xx] & 0xFF;
                        sum += pixel;
                        // still looking for good contrast
                        if (pixel < min) min = pixel;
                        if (pixel > max) max = pixel;
                    }
                    // short-circuit min/max tests once dynamic range is met
                    if (max - min > HybridBinarizer.MIN_DYNAMIC_RANGE) {
                        // finish the rest of the rows quickly
                        for(yy++, offset += width; yy < HybridBinarizer.BLOCK_SIZE; yy++, offset += width)for(var xx = 0; xx < HybridBinarizer.BLOCK_SIZE; xx++)sum += luminances[offset + xx] & 0xFF;
                    }
                }
                // The default estimate is the average of the values in the block.
                var average = sum >> HybridBinarizer.BLOCK_SIZE_POWER * 2;
                if (max - min <= HybridBinarizer.MIN_DYNAMIC_RANGE) {
                    // If variation within the block is low, assume this is a block with only light or only
                    // dark pixels. In that case we do not want to use the average, as it would divide this
                    // low contrast area into black and white pixels, essentially creating data out of noise.
                    //
                    // The default assumption is that the block is light/background. Since no estimate for
                    // the level of dark pixels exists locally, use half the min for the block.
                    average = min / 2;
                    if (y > 0 && x > 0) {
                        // Correct the "white background" assumption for blocks that have neighbors by comparing
                        // the pixels in this block to the previously calculated black points. This is based on
                        // the fact that dark barcode symbology is always surrounded by some amount of light
                        // background for which reasonable black point estimates were made. The bp estimated at
                        // the boundaries is used for the interior.
                        // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                        var averageNeighborBlackPoint = (blackPoints[y - 1][x] + 2 * blackPoints[y][x - 1] + blackPoints[y - 1][x - 1]) / 4;
                        if (min < averageNeighborBlackPoint) average = averageNeighborBlackPoint;
                    }
                }
                blackPoints[y][x] = average;
            }
        }
        return blackPoints;
    };
    // This class uses 5x5 blocks to compute local luminance, where each block is 8x8 pixels.
    // So this is the smallest dimension in each axis we can accept.
    HybridBinarizer.BLOCK_SIZE_POWER = 3;
    HybridBinarizer.BLOCK_SIZE = 1 << HybridBinarizer.BLOCK_SIZE_POWER; // ...0100...00
    HybridBinarizer.BLOCK_SIZE_MASK = HybridBinarizer.BLOCK_SIZE - 1; // ...0011...11
    HybridBinarizer.MINIMUM_DIMENSION = HybridBinarizer.BLOCK_SIZE * 5;
    HybridBinarizer.MIN_DYNAMIC_RANGE = 24;
    return HybridBinarizer;
}((0, $a6Uvg.default));
var $b85dd3ba8dc79a20$export$2e2bcd8739ae039 = $b85dd3ba8dc79a20$var$HybridBinarizer;

});
parcelRegister("a6Uvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $75c64b4bcff07280$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $lXXBN = parcelRequire("lXXBN");

var $fHKUB = parcelRequire("fHKUB");

var $hzqel = parcelRequire("hzqel");

var $cQi30 = parcelRequire("cQi30");
var $75c64b4bcff07280$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This Binarizer implementation uses the old ZXing global histogram approach. It is suitable
 * for low-end mobile devices which don't have enough CPU or memory to use a local thresholding
 * algorithm. However, because it picks a global black point, it cannot handle difficult shadows
 * and gradients.
 *
 * Faster mobile devices and all desktop applications should probably use HybridBinarizer instead.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 */ var $75c64b4bcff07280$var$GlobalHistogramBinarizer = /** @class */ function(_super) {
    $75c64b4bcff07280$var$__extends(GlobalHistogramBinarizer, _super);
    function GlobalHistogramBinarizer(source) {
        var _this = _super.call(this, source) || this;
        _this.luminances = GlobalHistogramBinarizer.EMPTY;
        _this.buckets = new Int32Array(GlobalHistogramBinarizer.LUMINANCE_BUCKETS);
        return _this;
    }
    // Applies simple sharpening to the row data to improve performance of the 1D Readers.
    /*@Override*/ GlobalHistogramBinarizer.prototype.getBlackRow = function(y /*int*/ , row) {
        var source = this.getLuminanceSource();
        var width = source.getWidth();
        if (row === undefined || row === null || row.getSize() < width) row = new (0, $fHKUB.default)(width);
        else row.clear();
        this.initArrays(width);
        var localLuminances = source.getRow(y, this.luminances);
        var localBuckets = this.buckets;
        for(var x = 0; x < width; x++)localBuckets[(localLuminances[x] & 0xff) >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
        var blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
        if (width < 3) {
            // Special case for very small images
            for(var x = 0; x < width; x++)if ((localLuminances[x] & 0xff) < blackPoint) row.set(x);
        } else {
            var left = localLuminances[0] & 0xff;
            var center = localLuminances[1] & 0xff;
            for(var x = 1; x < width - 1; x++){
                var right = localLuminances[x + 1] & 0xff;
                // A simple -1 4 -1 box filter with a weight of 2.
                if ((center * 4 - left - right) / 2 < blackPoint) row.set(x);
                left = center;
                center = right;
            }
        }
        return row;
    };
    // Does not sharpen the data, as this call is intended to only be used by 2D Readers.
    /*@Override*/ GlobalHistogramBinarizer.prototype.getBlackMatrix = function() {
        var source = this.getLuminanceSource();
        var width = source.getWidth();
        var height = source.getHeight();
        var matrix = new (0, $hzqel.default)(width, height);
        // Quickly calculates the histogram by sampling four rows from the image. This proved to be
        // more robust on the blackbox tests than sampling a diagonal as we used to do.
        this.initArrays(width);
        var localBuckets = this.buckets;
        for(var y = 1; y < 5; y++){
            var row = Math.floor(height * y / 5);
            var localLuminances_1 = source.getRow(row, this.luminances);
            var right = Math.floor(width * 4 / 5);
            for(var x = Math.floor(width / 5); x < right; x++){
                var pixel = localLuminances_1[x] & 0xff;
                localBuckets[pixel >> GlobalHistogramBinarizer.LUMINANCE_SHIFT]++;
            }
        }
        var blackPoint = GlobalHistogramBinarizer.estimateBlackPoint(localBuckets);
        // We delay reading the entire image luminance until the black point estimation succeeds.
        // Although we end up reading four rows twice, it is consistent with our motto of
        // "fail quickly" which is necessary for continuous scanning.
        var localLuminances = source.getMatrix();
        for(var y = 0; y < height; y++){
            var offset = y * width;
            for(var x = 0; x < width; x++){
                var pixel = localLuminances[offset + x] & 0xff;
                if (pixel < blackPoint) matrix.set(x, y);
            }
        }
        return matrix;
    };
    /*@Override*/ GlobalHistogramBinarizer.prototype.createBinarizer = function(source) {
        return new GlobalHistogramBinarizer(source);
    };
    GlobalHistogramBinarizer.prototype.initArrays = function(luminanceSize /*int*/ ) {
        if (this.luminances.length < luminanceSize) this.luminances = new Uint8ClampedArray(luminanceSize);
        var buckets = this.buckets;
        for(var x = 0; x < GlobalHistogramBinarizer.LUMINANCE_BUCKETS; x++)buckets[x] = 0;
    };
    GlobalHistogramBinarizer.estimateBlackPoint = function(buckets) {
        // Find the tallest peak in the histogram.
        var numBuckets = buckets.length;
        var maxBucketCount = 0;
        var firstPeak = 0;
        var firstPeakSize = 0;
        for(var x = 0; x < numBuckets; x++){
            if (buckets[x] > firstPeakSize) {
                firstPeak = x;
                firstPeakSize = buckets[x];
            }
            if (buckets[x] > maxBucketCount) maxBucketCount = buckets[x];
        }
        // Find the second-tallest peak which is somewhat far from the tallest peak.
        var secondPeak = 0;
        var secondPeakScore = 0;
        for(var x = 0; x < numBuckets; x++){
            var distanceToBiggest = x - firstPeak;
            // Encourage more distant second peaks by multiplying by square of distance.
            var score = buckets[x] * distanceToBiggest * distanceToBiggest;
            if (score > secondPeakScore) {
                secondPeak = x;
                secondPeakScore = score;
            }
        }
        // Make sure firstPeak corresponds to the black peak.
        if (firstPeak > secondPeak) {
            var temp = firstPeak;
            firstPeak = secondPeak;
            secondPeak = temp;
        }
        // If there is too little contrast in the image to pick a meaningful black point, throw rather
        // than waste time trying to decode the image, and risk false positives.
        if (secondPeak - firstPeak <= numBuckets / 16) throw new (0, $cQi30.default)();
        // Find a valley between them that is low and closer to the white peak.
        var bestValley = secondPeak - 1;
        var bestValleyScore = -1;
        for(var x = secondPeak - 1; x > firstPeak; x--){
            var fromFirst = x - firstPeak;
            var score = fromFirst * fromFirst * (secondPeak - x) * (maxBucketCount - buckets[x]);
            if (score > bestValleyScore) {
                bestValley = x;
                bestValleyScore = score;
            }
        }
        return bestValley << GlobalHistogramBinarizer.LUMINANCE_SHIFT;
    };
    GlobalHistogramBinarizer.LUMINANCE_BITS = 5;
    GlobalHistogramBinarizer.LUMINANCE_SHIFT = 8 - GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.LUMINANCE_BUCKETS = 1 << GlobalHistogramBinarizer.LUMINANCE_BITS;
    GlobalHistogramBinarizer.EMPTY = Uint8ClampedArray.from([
        0
    ]);
    return GlobalHistogramBinarizer;
}((0, $lXXBN.default));
var $75c64b4bcff07280$export$2e2bcd8739ae039 = $75c64b4bcff07280$var$GlobalHistogramBinarizer;

});
parcelRegister("lXXBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffdd58abe4c8ef5a$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This class hierarchy provides a set of methods to convert luminance data to 1 bit data.
 * It allows the algorithm to vary polymorphically, for example allowing a very expensive
 * thresholding technique for servers and a fast one for mobile. It also permits the implementation
 * to vary, e.g. a JNI version for Android and a Java fallback version for other platforms.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $ffdd58abe4c8ef5a$var$Binarizer = /** @class */ function() {
    function Binarizer(source) {
        this.source = source;
    }
    Binarizer.prototype.getLuminanceSource = function() {
        return this.source;
    };
    Binarizer.prototype.getWidth = function() {
        return this.source.getWidth();
    };
    Binarizer.prototype.getHeight = function() {
        return this.source.getHeight();
    };
    return Binarizer;
}();
var $ffdd58abe4c8ef5a$export$2e2bcd8739ae039 = $ffdd58abe4c8ef5a$var$Binarizer;

});

parcelRegister("fHKUB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ef42e93e981c53$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /*import java.util.Arrays;*/ 
var $kLpae = parcelRequire("kLpae");

var $iYwLM = parcelRequire("iYwLM");

var $hcAg4 = parcelRequire("hcAg4");

var $b6IL4 = parcelRequire("b6IL4");
/**
 * <p>A simple, fast array of bits, represented compactly by an array of ints internally.</p>
 *
 * @author Sean Owen
 */ var $b6ef42e93e981c53$var$BitArray /*implements Cloneable*/  = /** @class */ function() {
    // public constructor() {
    //   this.size = 0
    //   this.bits = new Int32Array(1)
    // }
    // public constructor(size?: number /*int*/) {
    //   if (undefined === size) {
    //     this.size = 0
    //   } else {
    //     this.size = size
    //   }
    //   this.bits = this.makeArray(size)
    // }
    // For testing only
    function BitArray(size /*int*/ , bits) {
        if (undefined === size) {
            this.size = 0;
            this.bits = new Int32Array(1);
        } else {
            this.size = size;
            if (undefined === bits || null === bits) this.bits = BitArray.makeArray(size);
            else this.bits = bits;
        }
    }
    BitArray.prototype.getSize = function() {
        return this.size;
    };
    BitArray.prototype.getSizeInBytes = function() {
        return Math.floor((this.size + 7) / 8);
    };
    BitArray.prototype.ensureCapacity = function(size /*int*/ ) {
        if (size > this.bits.length * 32) {
            var newBits = BitArray.makeArray(size);
            (0, $b6IL4.default).arraycopy(this.bits, 0, newBits, 0, this.bits.length);
            this.bits = newBits;
        }
    };
    /**
     * @param i bit to get
     * @return true iff bit i is set
     */ BitArray.prototype.get = function(i /*int*/ ) {
        return (this.bits[Math.floor(i / 32)] & 1 << (i & 0x1F)) !== 0;
    };
    /**
     * Sets bit i.
     *
     * @param i bit to set
     */ BitArray.prototype.set = function(i /*int*/ ) {
        this.bits[Math.floor(i / 32)] |= 1 << (i & 0x1F);
    };
    /**
     * Flips bit i.
     *
     * @param i bit to set
     */ BitArray.prototype.flip = function(i /*int*/ ) {
        this.bits[Math.floor(i / 32)] ^= 1 << (i & 0x1F);
    };
    /**
     * @param from first bit to check
     * @return index of first bit that is set, starting from the given index, or size if none are set
     *  at or beyond this given index
     * @see #getNextUnset(int)
     */ BitArray.prototype.getNextSet = function(from /*int*/ ) {
        var size = this.size;
        if (from >= size) return size;
        var bits = this.bits;
        var bitsOffset = Math.floor(from / 32);
        var currentBits = bits[bitsOffset];
        // mask off lesser bits first
        currentBits &= ~((1 << (from & 0x1F)) - 1);
        var length = bits.length;
        while(currentBits === 0){
            if (++bitsOffset === length) return size;
            currentBits = bits[bitsOffset];
        }
        var result = bitsOffset * 32 + (0, $hcAg4.default).numberOfTrailingZeros(currentBits);
        return result > size ? size : result;
    };
    /**
     * @param from index to start looking for unset bit
     * @return index of next unset bit, or {@code size} if none are unset until the end
     * @see #getNextSet(int)
     */ BitArray.prototype.getNextUnset = function(from /*int*/ ) {
        var size = this.size;
        if (from >= size) return size;
        var bits = this.bits;
        var bitsOffset = Math.floor(from / 32);
        var currentBits = ~bits[bitsOffset];
        // mask off lesser bits first
        currentBits &= ~((1 << (from & 0x1F)) - 1);
        var length = bits.length;
        while(currentBits === 0){
            if (++bitsOffset === length) return size;
            currentBits = ~bits[bitsOffset];
        }
        var result = bitsOffset * 32 + (0, $hcAg4.default).numberOfTrailingZeros(currentBits);
        return result > size ? size : result;
    };
    /**
     * Sets a block of 32 bits, starting at bit i.
     *
     * @param i first bit to set
     * @param newBits the new value of the next 32 bits. Note again that the least-significant bit
     * corresponds to bit i, the next-least-significant to i+1, and so on.
     */ BitArray.prototype.setBulk = function(i /*int*/ , newBits /*int*/ ) {
        this.bits[Math.floor(i / 32)] = newBits;
    };
    /**
     * Sets a range of bits.
     *
     * @param start start of range, inclusive.
     * @param end end of range, exclusive
     */ BitArray.prototype.setRange = function(start /*int*/ , end /*int*/ ) {
        if (end < start || start < 0 || end > this.size) throw new (0, $kLpae.default)();
        if (end === start) return;
        end--; // will be easier to treat this as the last actually set bit -- inclusive
        var firstInt = Math.floor(start / 32);
        var lastInt = Math.floor(end / 32);
        var bits = this.bits;
        for(var i = firstInt; i <= lastInt; i++){
            var firstBit = i > firstInt ? 0 : start & 0x1F;
            var lastBit = i < lastInt ? 31 : end & 0x1F;
            // Ones from firstBit to lastBit, inclusive
            var mask = (2 << lastBit) - (1 << firstBit);
            bits[i] |= mask;
        }
    };
    /**
     * Clears all bits (sets to false).
     */ BitArray.prototype.clear = function() {
        var max = this.bits.length;
        var bits = this.bits;
        for(var i = 0; i < max; i++)bits[i] = 0;
    };
    /**
     * Efficient method to check if a range of bits is set, or not set.
     *
     * @param start start of range, inclusive.
     * @param end end of range, exclusive
     * @param value if true, checks that bits in range are set, otherwise checks that they are not set
     * @return true iff all bits are set or not set in range, according to value argument
     * @throws IllegalArgumentException if end is less than start or the range is not contained in the array
     */ BitArray.prototype.isRange = function(start /*int*/ , end /*int*/ , value) {
        if (end < start || start < 0 || end > this.size) throw new (0, $kLpae.default)();
        if (end === start) return true; // empty range matches
        end--; // will be easier to treat this as the last actually set bit -- inclusive
        var firstInt = Math.floor(start / 32);
        var lastInt = Math.floor(end / 32);
        var bits = this.bits;
        for(var i = firstInt; i <= lastInt; i++){
            var firstBit = i > firstInt ? 0 : start & 0x1F;
            var lastBit = i < lastInt ? 31 : end & 0x1F;
            // Ones from firstBit to lastBit, inclusive
            var mask = (2 << lastBit) - (1 << firstBit) & 0xFFFFFFFF;
            // TYPESCRIPTPORT: & 0xFFFFFFFF added to discard anything after 32 bits, as ES has 53 bits
            // Return false if we're looking for 1s and the masked bits[i] isn't all 1s (is: that,
            // equals the mask, or we're looking for 0s and the masked portion is not all 0s
            if ((bits[i] & mask) !== (value ? mask : 0)) return false;
        }
        return true;
    };
    BitArray.prototype.appendBit = function(bit) {
        this.ensureCapacity(this.size + 1);
        if (bit) this.bits[Math.floor(this.size / 32)] |= 1 << (this.size & 0x1F);
        this.size++;
    };
    /**
     * Appends the least-significant bits, from value, in order from most-significant to
     * least-significant. For example, appending 6 bits from 0x000001E will append the bits
     * 0, 1, 1, 1, 1, 0 in that order.
     *
     * @param value {@code int} containing bits to append
     * @param numBits bits from value to append
     */ BitArray.prototype.appendBits = function(value /*int*/ , numBits /*int*/ ) {
        if (numBits < 0 || numBits > 32) throw new (0, $kLpae.default)("Num bits must be between 0 and 32");
        this.ensureCapacity(this.size + numBits);
        // const appendBit = this.appendBit;
        for(var numBitsLeft = numBits; numBitsLeft > 0; numBitsLeft--)this.appendBit((value >> numBitsLeft - 1 & 0x01) === 1);
    };
    BitArray.prototype.appendBitArray = function(other) {
        var otherSize = other.size;
        this.ensureCapacity(this.size + otherSize);
        // const appendBit = this.appendBit;
        for(var i = 0; i < otherSize; i++)this.appendBit(other.get(i));
    };
    BitArray.prototype.xor = function(other) {
        if (this.size !== other.size) throw new (0, $kLpae.default)("Sizes don't match");
        var bits = this.bits;
        for(var i = 0, length_1 = bits.length; i < length_1; i++)// The last int could be incomplete (i.e. not have 32 bits in
        // it) but there is no problem since 0 XOR 0 == 0.
        bits[i] ^= other.bits[i];
    };
    /**
     *
     * @param bitOffset first bit to start writing
     * @param array array to write into. Bytes are written most-significant byte first. This is the opposite
     *  of the internal representation, which is exposed by {@link #getBitArray()}
     * @param offset position in array to start writing
     * @param numBytes how many bytes to write
     */ BitArray.prototype.toBytes = function(bitOffset /*int*/ , array, offset /*int*/ , numBytes /*int*/ ) {
        for(var i = 0; i < numBytes; i++){
            var theByte = 0;
            for(var j = 0; j < 8; j++){
                if (this.get(bitOffset)) theByte |= 1 << 7 - j;
                bitOffset++;
            }
            array[offset + i] = /*(byte)*/ theByte;
        }
    };
    /**
     * @return underlying array of ints. The first element holds the first 32 bits, and the least
     *         significant bit is bit 0.
     */ BitArray.prototype.getBitArray = function() {
        return this.bits;
    };
    /**
     * Reverses all bits in the array.
     */ BitArray.prototype.reverse = function() {
        var newBits = new Int32Array(this.bits.length);
        // reverse all int's first
        var len = Math.floor((this.size - 1) / 32);
        var oldBitsLen = len + 1;
        var bits = this.bits;
        for(var i = 0; i < oldBitsLen; i++){
            var x = bits[i];
            x = x >> 1 & 0x55555555 | (x & 0x55555555) << 1;
            x = x >> 2 & 0x33333333 | (x & 0x33333333) << 2;
            x = x >> 4 & 0x0f0f0f0f | (x & 0x0f0f0f0f) << 4;
            x = x >> 8 & 0x00ff00ff | (x & 0x00ff00ff) << 8;
            x = x >> 16 & 0x0000ffff | (x & 0x0000ffff) << 16;
            newBits[len - i] = /*(int)*/ x;
        }
        // now correct the int's if the bit size isn't a multiple of 32
        if (this.size !== oldBitsLen * 32) {
            var leftOffset = oldBitsLen * 32 - this.size;
            var currentInt = newBits[0] >>> leftOffset;
            for(var i = 1; i < oldBitsLen; i++){
                var nextInt = newBits[i];
                currentInt |= nextInt << 32 - leftOffset;
                newBits[i - 1] = currentInt;
                currentInt = nextInt >>> leftOffset;
            }
            newBits[oldBitsLen - 1] = currentInt;
        }
        this.bits = newBits;
    };
    BitArray.makeArray = function(size /*int*/ ) {
        return new Int32Array(Math.floor((size + 31) / 32));
    };
    /*@Override*/ BitArray.prototype.equals = function(o) {
        if (!(o instanceof BitArray)) return false;
        var other = o;
        return this.size === other.size && (0, $iYwLM.default).equals(this.bits, other.bits);
    };
    /*@Override*/ BitArray.prototype.hashCode = function() {
        return 31 * this.size + (0, $iYwLM.default).hashCode(this.bits);
    };
    /*@Override*/ BitArray.prototype.toString = function() {
        var result = "";
        for(var i = 0, size = this.size; i < size; i++){
            if ((i & 0x07) === 0) result += " ";
            result += this.get(i) ? "X" : ".";
        }
        return result;
    };
    /*@Override*/ BitArray.prototype.clone = function() {
        return new BitArray(this.size, this.bits.slice());
    };
    /**
     * converts to boolean array.
     */ BitArray.prototype.toArray = function() {
        var result = [];
        for(var i = 0, size = this.size; i < size; i++)result.push(this.get(i));
        return result;
    };
    return BitArray;
}();
var $b6ef42e93e981c53$export$2e2bcd8739ae039 = $b6ef42e93e981c53$var$BitArray;

});
parcelRegister("iYwLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd073ff1fc653808$export$2e2bcd8739ae039);

var $b6IL4 = parcelRequire("b6IL4");

var $kLpae = parcelRequire("kLpae");

var $76OgE = parcelRequire("76OgE");
var $dd073ff1fc653808$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dd073ff1fc653808$var$Arrays = /** @class */ function() {
    function Arrays() {}
    /**
     * Assigns the specified int value to each element of the specified array
     * of ints.
     *
     * @param a the array to be filled
     * @param val the value to be stored in all elements of the array
     */ Arrays.fill = function(a, val) {
        for(var i = 0, len = a.length; i < len; i++)a[i] = val;
    };
    /**
     * Assigns the specified int value to each element of the specified
     * range of the specified array of ints.  The range to be filled
     * extends from index {@code fromIndex}, inclusive, to index
     * {@code toIndex}, exclusive.  (If {@code fromIndex==toIndex}, the
     * range to be filled is empty.)
     *
     * @param a the array to be filled
     * @param fromIndex the index of the first element (inclusive) to be
     *        filled with the specified value
     * @param toIndex the index of the last element (exclusive) to be
     *        filled with the specified value
     * @param val the value to be stored in all elements of the array
     * @throws IllegalArgumentException if {@code fromIndex > toIndex}
     * @throws ArrayIndexOutOfBoundsException if {@code fromIndex < 0} or
     *         {@code toIndex > a.length}
     */ Arrays.fillWithin = function(a, fromIndex, toIndex, val) {
        Arrays.rangeCheck(a.length, fromIndex, toIndex);
        for(var i = fromIndex; i < toIndex; i++)a[i] = val;
    };
    /**
     * Checks that {@code fromIndex} and {@code toIndex} are in
     * the range and throws an exception if they aren't.
     */ Arrays.rangeCheck = function(arrayLength, fromIndex, toIndex) {
        if (fromIndex > toIndex) throw new (0, $kLpae.default)("fromIndex(" + fromIndex + ") > toIndex(" + toIndex + ")");
        if (fromIndex < 0) throw new (0, $76OgE.default)(fromIndex);
        if (toIndex > arrayLength) throw new (0, $76OgE.default)(toIndex);
    };
    Arrays.asList = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return args;
    };
    Arrays.create = function(rows, cols, value) {
        var arr = Array.from({
            length: rows
        });
        return arr.map(function(x) {
            return Array.from({
                length: cols
            }).fill(value);
        });
    };
    Arrays.createInt32Array = function(rows, cols, value) {
        var arr = Array.from({
            length: rows
        });
        return arr.map(function(x) {
            return Int32Array.from({
                length: cols
            }).fill(value);
        });
    };
    Arrays.equals = function(first, second) {
        if (!first) return false;
        if (!second) return false;
        if (!first.length) return false;
        if (!second.length) return false;
        if (first.length !== second.length) return false;
        for(var i = 0, length_1 = first.length; i < length_1; i++){
            if (first[i] !== second[i]) return false;
        }
        return true;
    };
    Arrays.hashCode = function(a) {
        var e_1, _a;
        if (a === null) return 0;
        var result = 1;
        try {
            for(var a_1 = $dd073ff1fc653808$var$__values(a), a_1_1 = a_1.next(); !a_1_1.done; a_1_1 = a_1.next()){
                var element = a_1_1.value;
                result = 31 * result + element;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (a_1_1 && !a_1_1.done && (_a = a_1.return)) _a.call(a_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return result;
    };
    Arrays.fillUint8Array = function(a, value) {
        for(var i = 0; i !== a.length; i++)a[i] = value;
    };
    Arrays.copyOf = function(original, newLength) {
        return original.slice(0, newLength);
    };
    Arrays.copyOfUint8Array = function(original, newLength) {
        if (original.length <= newLength) {
            var newArray = new Uint8Array(newLength);
            newArray.set(original);
            return newArray;
        }
        return original.slice(0, newLength);
    };
    Arrays.copyOfRange = function(original, from, to) {
        var newLength = to - from;
        var copy = new Int32Array(newLength);
        (0, $b6IL4.default).arraycopy(original, from, copy, 0, newLength);
        return copy;
    };
    /*
    * Returns the index of of the element in a sorted array or (-n-1) where n is the insertion point
    * for the new element.
    * Parameters:
    *     ar - A sorted array
    *     el - An element to search for
    *     comparator - A comparator function. The function takes two arguments: (a, b) and returns:
    *        a negative number  if a is less than b;
    *        0 if a is equal to b;
    *        a positive number of a is greater than b.
    * The array may contain duplicate elements. If there are more than one equal elements in the array,
    * the returned value can be the index of any one of the equal elements.
    *
    * http://jsfiddle.net/aryzhov/pkfst550/
    */ Arrays.binarySearch = function(ar, el, comparator) {
        if (undefined === comparator) comparator = Arrays.numberComparator;
        var m = 0;
        var n = ar.length - 1;
        while(m <= n){
            var k = n + m >> 1;
            var cmp = comparator(el, ar[k]);
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return -m - 1;
    };
    Arrays.numberComparator = function(a, b) {
        return a - b;
    };
    return Arrays;
}();
var $dd073ff1fc653808$export$2e2bcd8739ae039 = $dd073ff1fc653808$var$Arrays;

});
parcelRegister("b6IL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8162f94badf73445$export$2e2bcd8739ae039);
var $8162f94badf73445$var$System = /** @class */ function() {
    function System() {}
    // public static void arraycopy(Object src, int srcPos, Object dest, int destPos, int length)
    /**
     * Makes a copy of a array.
     */ System.arraycopy = function(src, srcPos, dest, destPos, length) {
        // TODO: better use split or set?
        while(length--)dest[destPos++] = src[srcPos++];
    };
    /**
     * Returns the current time in milliseconds.
     */ System.currentTimeMillis = function() {
        return Date.now();
    };
    return System;
}();
var $8162f94badf73445$export$2e2bcd8739ae039 = $8162f94badf73445$var$System;

});

parcelRegister("76OgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $52d01605ce01cd02$export$2e2bcd8739ae039);

var $iChTI = parcelRequire("iChTI");
var $52d01605ce01cd02$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $52d01605ce01cd02$var$ArrayIndexOutOfBoundsException = /** @class */ function(_super) {
    $52d01605ce01cd02$var$__extends(ArrayIndexOutOfBoundsException, _super);
    function ArrayIndexOutOfBoundsException(index, message) {
        if (index === void 0) index = undefined;
        if (message === void 0) message = undefined;
        var _this = _super.call(this, message) || this;
        _this.index = index;
        _this.message = message;
        return _this;
    }
    ArrayIndexOutOfBoundsException.kind = "ArrayIndexOutOfBoundsException";
    return ArrayIndexOutOfBoundsException;
}((0, $iChTI.default));
var $52d01605ce01cd02$export$2e2bcd8739ae039 = $52d01605ce01cd02$var$ArrayIndexOutOfBoundsException;

});
parcelRegister("iChTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d9a8b34b2d2bfe$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $d8d9a8b34b2d2bfe$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $d8d9a8b34b2d2bfe$var$IndexOutOfBoundsException = /** @class */ function(_super) {
    $d8d9a8b34b2d2bfe$var$__extends(IndexOutOfBoundsException, _super);
    function IndexOutOfBoundsException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IndexOutOfBoundsException.kind = "IndexOutOfBoundsException";
    return IndexOutOfBoundsException;
}((0, $26SD6.default));
var $d8d9a8b34b2d2bfe$export$2e2bcd8739ae039 = $d8d9a8b34b2d2bfe$var$IndexOutOfBoundsException;

});



parcelRegister("hcAg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85faec72c09b894$export$2e2bcd8739ae039);
/**
 * Ponyfill for Java's Integer class.
 */ var $c85faec72c09b894$var$Integer = /** @class */ function() {
    function Integer() {}
    Integer.numberOfTrailingZeros = function(i) {
        var y;
        if (i === 0) return 32;
        var n = 31;
        y = i << 16;
        if (y !== 0) {
            n -= 16;
            i = y;
        }
        y = i << 8;
        if (y !== 0) {
            n -= 8;
            i = y;
        }
        y = i << 4;
        if (y !== 0) {
            n -= 4;
            i = y;
        }
        y = i << 2;
        if (y !== 0) {
            n -= 2;
            i = y;
        }
        return n - (i << 1 >>> 31);
    };
    Integer.numberOfLeadingZeros = function(i) {
        // HD, Figure 5-6
        if (i === 0) return 32;
        var n = 1;
        if (i >>> 16 === 0) {
            n += 16;
            i <<= 16;
        }
        if (i >>> 24 === 0) {
            n += 8;
            i <<= 8;
        }
        if (i >>> 28 === 0) {
            n += 4;
            i <<= 4;
        }
        if (i >>> 30 === 0) {
            n += 2;
            i <<= 2;
        }
        n -= i >>> 31;
        return n;
    };
    Integer.toHexString = function(i) {
        return i.toString(16);
    };
    Integer.toBinaryString = function(intNumber) {
        return String(parseInt(String(intNumber), 2));
    };
    // Returns the number of one-bits in the two's complement binary representation of the specified int value. This function is sometimes referred to as the population count.
    // Returns:
    // the number of one-bits in the two's complement binary representation of the specified int value.
    Integer.bitCount = function(i) {
        // HD, Figure 5-2
        i = i - (i >>> 1 & 0x55555555);
        i = (i & 0x33333333) + (i >>> 2 & 0x33333333);
        i = i + (i >>> 4) & 0x0f0f0f0f;
        i = i + (i >>> 8);
        i = i + (i >>> 16);
        return i & 0x3f;
    };
    Integer.truncDivision = function(dividend, divisor) {
        return Math.trunc(dividend / divisor);
    };
    /**
     * Converts A string to an integer.
     * @param s A string to convert into a number.
     * @param radix A value between 2 and 36 that specifies the base of the number in numString. If this argument is not supplied, strings with a prefix of '0x' are considered hexadecimal. All other strings are considered decimal.
     */ Integer.parseInt = function(num, radix) {
        if (radix === void 0) radix = undefined;
        return parseInt(num, radix);
    };
    Integer.MIN_VALUE_32_BITS = -2147483648;
    Integer.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    return Integer;
}();
var $c85faec72c09b894$export$2e2bcd8739ae039 = $c85faec72c09b894$var$Integer;

});


parcelRegister("hzqel", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccaa0d5a56e106e3$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /*import java.util.Arrays;*/ 
var $fHKUB = parcelRequire("fHKUB");

var $b6IL4 = parcelRequire("b6IL4");

var $iYwLM = parcelRequire("iYwLM");

var $6E9N1 = parcelRequire("6E9N1");

var $kLpae = parcelRequire("kLpae");
/**
 * <p>Represents a 2D matrix of bits. In function arguments below, and throughout the common
 * module, x is the column position, and y is the row position. The ordering is always x, y.
 * The origin is at the top-left.</p>
 *
 * <p>Internally the bits are represented in a 1-D array of 32-bit ints. However, each row begins
 * with a new int. This is done intentionally so that we can copy out a row into a BitArray very
 * efficiently.</p>
 *
 * <p>The ordering of bits is row-major. Within each int, the least significant bits are used first,
 * meaning they represent lower x values. This is compatible with BitArray's implementation.</p>
 *
 * @author Sean Owen
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $ccaa0d5a56e106e3$var$BitMatrix /*implements Cloneable*/  = /** @class */ function() {
    /**
     * Creates an empty square {@link BitMatrix}.
     *
     * @param dimension height and width
     */ // public constructor(dimension: number /*int*/) {
    //   this(dimension, dimension)
    // }
    /**
     * Creates an empty {@link BitMatrix}.
     *
     * @param width bit matrix width
     * @param height bit matrix height
     */ // public constructor(width: number /*int*/, height: number /*int*/) {
    //   if (width < 1 || height < 1) {
    //     throw new IllegalArgumentException("Both dimensions must be greater than 0")
    //   }
    //   this.width = width
    //   this.height = height
    //   this.rowSize = (width + 31) / 32
    //   bits = new int[rowSize * height];
    // }
    function BitMatrix(width /*int*/ , height /*int*/ , rowSize /*int*/ , bits) {
        this.width = width;
        this.height = height;
        this.rowSize = rowSize;
        this.bits = bits;
        if (undefined === height || null === height) height = width;
        this.height = height;
        if (width < 1 || height < 1) throw new (0, $kLpae.default)("Both dimensions must be greater than 0");
        if (undefined === rowSize || null === rowSize) rowSize = Math.floor((width + 31) / 32);
        this.rowSize = rowSize;
        if (undefined === bits || null === bits) this.bits = new Int32Array(this.rowSize * this.height);
    }
    /**
     * Interprets a 2D array of booleans as a {@link BitMatrix}, where "true" means an "on" bit.
     *
     * @function parse
     * @param image bits of the image, as a row-major 2D array. Elements are arrays representing rows
     * @return {@link BitMatrix} representation of image
     */ BitMatrix.parseFromBooleanArray = function(image) {
        var height = image.length;
        var width = image[0].length;
        var bits = new BitMatrix(width, height);
        for(var i = 0; i < height; i++){
            var imageI = image[i];
            for(var j = 0; j < width; j++)if (imageI[j]) bits.set(j, i);
        }
        return bits;
    };
    /**
     *
     * @function parse
     * @param stringRepresentation
     * @param setString
     * @param unsetString
     */ BitMatrix.parseFromString = function(stringRepresentation, setString, unsetString) {
        if (stringRepresentation === null) throw new (0, $kLpae.default)("stringRepresentation cannot be null");
        var bits = new Array(stringRepresentation.length);
        var bitsPos = 0;
        var rowStartPos = 0;
        var rowLength = -1;
        var nRows = 0;
        var pos = 0;
        while(pos < stringRepresentation.length){
            if (stringRepresentation.charAt(pos) === "\n" || stringRepresentation.charAt(pos) === "\r") {
                if (bitsPos > rowStartPos) {
                    if (rowLength === -1) rowLength = bitsPos - rowStartPos;
                    else if (bitsPos - rowStartPos !== rowLength) throw new (0, $kLpae.default)("row lengths do not match");
                    rowStartPos = bitsPos;
                    nRows++;
                }
                pos++;
            } else if (stringRepresentation.substring(pos, pos + setString.length) === setString) {
                pos += setString.length;
                bits[bitsPos] = true;
                bitsPos++;
            } else if (stringRepresentation.substring(pos, pos + unsetString.length) === unsetString) {
                pos += unsetString.length;
                bits[bitsPos] = false;
                bitsPos++;
            } else throw new (0, $kLpae.default)("illegal character encountered: " + stringRepresentation.substring(pos));
        }
        // no EOL at end?
        if (bitsPos > rowStartPos) {
            if (rowLength === -1) rowLength = bitsPos - rowStartPos;
            else if (bitsPos - rowStartPos !== rowLength) throw new (0, $kLpae.default)("row lengths do not match");
            nRows++;
        }
        var matrix = new BitMatrix(rowLength, nRows);
        for(var i = 0; i < bitsPos; i++)if (bits[i]) matrix.set(Math.floor(i % rowLength), Math.floor(i / rowLength));
        return matrix;
    };
    /**
     * <p>Gets the requested bit, where true means black.</p>
     *
     * @param x The horizontal component (i.e. which column)
     * @param y The vertical component (i.e. which row)
     * @return value of given bit in matrix
     */ BitMatrix.prototype.get = function(x /*int*/ , y /*int*/ ) {
        var offset = y * this.rowSize + Math.floor(x / 32);
        return (this.bits[offset] >>> (x & 0x1f) & 1) !== 0;
    };
    /**
     * <p>Sets the given bit to true.</p>
     *
     * @param x The horizontal component (i.e. which column)
     * @param y The vertical component (i.e. which row)
     */ BitMatrix.prototype.set = function(x /*int*/ , y /*int*/ ) {
        var offset = y * this.rowSize + Math.floor(x / 32);
        this.bits[offset] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
    };
    BitMatrix.prototype.unset = function(x /*int*/ , y /*int*/ ) {
        var offset = y * this.rowSize + Math.floor(x / 32);
        this.bits[offset] &= ~(1 << (x & 0x1f) & 0xFFFFFFFF);
    };
    /**
     * <p>Flips the given bit.</p>
     *
     * @param x The horizontal component (i.e. which column)
     * @param y The vertical component (i.e. which row)
     */ BitMatrix.prototype.flip = function(x /*int*/ , y /*int*/ ) {
        var offset = y * this.rowSize + Math.floor(x / 32);
        this.bits[offset] ^= 1 << (x & 0x1f) & 0xFFFFFFFF;
    };
    /**
     * Exclusive-or (XOR): Flip the bit in this {@code BitMatrix} if the corresponding
     * mask bit is set.
     *
     * @param mask XOR mask
     */ BitMatrix.prototype.xor = function(mask) {
        if (this.width !== mask.getWidth() || this.height !== mask.getHeight() || this.rowSize !== mask.getRowSize()) throw new (0, $kLpae.default)("input matrix dimensions do not match");
        var rowArray = new (0, $fHKUB.default)(Math.floor(this.width / 32) + 1);
        var rowSize = this.rowSize;
        var bits = this.bits;
        for(var y = 0, height = this.height; y < height; y++){
            var offset = y * rowSize;
            var row = mask.getRow(y, rowArray).getBitArray();
            for(var x = 0; x < rowSize; x++)bits[offset + x] ^= row[x];
        }
    };
    /**
     * Clears all bits (sets to false).
     */ BitMatrix.prototype.clear = function() {
        var bits = this.bits;
        var max = bits.length;
        for(var i = 0; i < max; i++)bits[i] = 0;
    };
    /**
     * <p>Sets a square region of the bit matrix to true.</p>
     *
     * @param left The horizontal position to begin at (inclusive)
     * @param top The vertical position to begin at (inclusive)
     * @param width The width of the region
     * @param height The height of the region
     */ BitMatrix.prototype.setRegion = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        if (top < 0 || left < 0) throw new (0, $kLpae.default)("Left and top must be nonnegative");
        if (height < 1 || width < 1) throw new (0, $kLpae.default)("Height and width must be at least 1");
        var right = left + width;
        var bottom = top + height;
        if (bottom > this.height || right > this.width) throw new (0, $kLpae.default)("The region must fit inside the matrix");
        var rowSize = this.rowSize;
        var bits = this.bits;
        for(var y = top; y < bottom; y++){
            var offset = y * rowSize;
            for(var x = left; x < right; x++)bits[offset + Math.floor(x / 32)] |= 1 << (x & 0x1f) & 0xFFFFFFFF;
        }
    };
    /**
     * A fast method to retrieve one row of data from the matrix as a BitArray.
     *
     * @param y The row to retrieve
     * @param row An optional caller-allocated BitArray, will be allocated if null or too small
     * @return The resulting BitArray - this reference should always be used even when passing
     *         your own row
     */ BitMatrix.prototype.getRow = function(y /*int*/ , row) {
        if (row === null || row === undefined || row.getSize() < this.width) row = new (0, $fHKUB.default)(this.width);
        else row.clear();
        var rowSize = this.rowSize;
        var bits = this.bits;
        var offset = y * rowSize;
        for(var x = 0; x < rowSize; x++)row.setBulk(x * 32, bits[offset + x]);
        return row;
    };
    /**
     * @param y row to set
     * @param row {@link BitArray} to copy from
     */ BitMatrix.prototype.setRow = function(y /*int*/ , row) {
        (0, $b6IL4.default).arraycopy(row.getBitArray(), 0, this.bits, y * this.rowSize, this.rowSize);
    };
    /**
     * Modifies this {@code BitMatrix} to represent the same but rotated 180 degrees
     */ BitMatrix.prototype.rotate180 = function() {
        var width = this.getWidth();
        var height = this.getHeight();
        var topRow = new (0, $fHKUB.default)(width);
        var bottomRow = new (0, $fHKUB.default)(width);
        for(var i = 0, length_1 = Math.floor((height + 1) / 2); i < length_1; i++){
            topRow = this.getRow(i, topRow);
            bottomRow = this.getRow(height - 1 - i, bottomRow);
            topRow.reverse();
            bottomRow.reverse();
            this.setRow(i, bottomRow);
            this.setRow(height - 1 - i, topRow);
        }
    };
    /**
     * This is useful in detecting the enclosing rectangle of a 'pure' barcode.
     *
     * @return {@code left,top,width,height} enclosing rectangle of all 1 bits, or null if it is all white
     */ BitMatrix.prototype.getEnclosingRectangle = function() {
        var width = this.width;
        var height = this.height;
        var rowSize = this.rowSize;
        var bits = this.bits;
        var left = width;
        var top = height;
        var right = -1;
        var bottom = -1;
        for(var y = 0; y < height; y++)for(var x32 = 0; x32 < rowSize; x32++){
            var theBits = bits[y * rowSize + x32];
            if (theBits !== 0) {
                if (y < top) top = y;
                if (y > bottom) bottom = y;
                if (x32 * 32 < left) {
                    var bit = 0;
                    while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
                    if (x32 * 32 + bit < left) left = x32 * 32 + bit;
                }
                if (x32 * 32 + 31 > right) {
                    var bit = 31;
                    while(theBits >>> bit === 0)bit--;
                    if (x32 * 32 + bit > right) right = x32 * 32 + bit;
                }
            }
        }
        if (right < left || bottom < top) return null;
        return Int32Array.from([
            left,
            top,
            right - left + 1,
            bottom - top + 1
        ]);
    };
    /**
     * This is useful in detecting a corner of a 'pure' barcode.
     *
     * @return {@code x,y} coordinate of top-left-most 1 bit, or null if it is all white
     */ BitMatrix.prototype.getTopLeftOnBit = function() {
        var rowSize = this.rowSize;
        var bits = this.bits;
        var bitsOffset = 0;
        while(bitsOffset < bits.length && bits[bitsOffset] === 0)bitsOffset++;
        if (bitsOffset === bits.length) return null;
        var y = bitsOffset / rowSize;
        var x = bitsOffset % rowSize * 32;
        var theBits = bits[bitsOffset];
        var bit = 0;
        while((theBits << 31 - bit & 0xFFFFFFFF) === 0)bit++;
        x += bit;
        return Int32Array.from([
            x,
            y
        ]);
    };
    BitMatrix.prototype.getBottomRightOnBit = function() {
        var rowSize = this.rowSize;
        var bits = this.bits;
        var bitsOffset = bits.length - 1;
        while(bitsOffset >= 0 && bits[bitsOffset] === 0)bitsOffset--;
        if (bitsOffset < 0) return null;
        var y = Math.floor(bitsOffset / rowSize);
        var x = Math.floor(bitsOffset % rowSize) * 32;
        var theBits = bits[bitsOffset];
        var bit = 31;
        while(theBits >>> bit === 0)bit--;
        x += bit;
        return Int32Array.from([
            x,
            y
        ]);
    };
    /**
     * @return The width of the matrix
     */ BitMatrix.prototype.getWidth = function() {
        return this.width;
    };
    /**
     * @return The height of the matrix
     */ BitMatrix.prototype.getHeight = function() {
        return this.height;
    };
    /**
     * @return The row size of the matrix
     */ BitMatrix.prototype.getRowSize = function() {
        return this.rowSize;
    };
    /*@Override*/ BitMatrix.prototype.equals = function(o) {
        if (!(o instanceof BitMatrix)) return false;
        var other = o;
        return this.width === other.width && this.height === other.height && this.rowSize === other.rowSize && (0, $iYwLM.default).equals(this.bits, other.bits);
    };
    /*@Override*/ BitMatrix.prototype.hashCode = function() {
        var hash = this.width;
        hash = 31 * hash + this.width;
        hash = 31 * hash + this.height;
        hash = 31 * hash + this.rowSize;
        hash = 31 * hash + (0, $iYwLM.default).hashCode(this.bits);
        return hash;
    };
    /**
     * @return string representation using "X" for set and " " for unset bits
     */ /*@Override*/ // public toString(): string {
    //   return toString(": "X, "  ")
    // }
    /**
     * @param setString representation of a set bit
     * @param unsetString representation of an unset bit
     * @return string representation of entire matrix utilizing given strings
     */ // public toString(setString: string = "X ", unsetString: string = "  "): string {
    //   return this.buildToString(setString, unsetString, "\n")
    // }
    /**
     * @param setString representation of a set bit
     * @param unsetString representation of an unset bit
     * @param lineSeparator newline character in string representation
     * @return string representation of entire matrix utilizing given strings and line separator
     * @deprecated call {@link #toString(String,String)} only, which uses \n line separator always
     */ // @Deprecated
    BitMatrix.prototype.toString = function(setString, unsetString, lineSeparator) {
        if (setString === void 0) setString = "X ";
        if (unsetString === void 0) unsetString = "  ";
        if (lineSeparator === void 0) lineSeparator = "\n";
        return this.buildToString(setString, unsetString, lineSeparator);
    };
    BitMatrix.prototype.buildToString = function(setString, unsetString, lineSeparator) {
        var result = new (0, $6E9N1.default)();
        // result.append(lineSeparator);
        for(var y = 0, height = this.height; y < height; y++){
            for(var x = 0, width = this.width; x < width; x++)result.append(this.get(x, y) ? setString : unsetString);
            result.append(lineSeparator);
        }
        return result.toString();
    };
    /*@Override*/ BitMatrix.prototype.clone = function() {
        return new BitMatrix(this.width, this.height, this.rowSize, this.bits.slice());
    };
    return BitMatrix;
}();
var $ccaa0d5a56e106e3$export$2e2bcd8739ae039 = $ccaa0d5a56e106e3$var$BitMatrix;

});
parcelRegister("6E9N1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d6e128987b0ecb9$export$2e2bcd8739ae039);

var $7mB9T = parcelRequire("7mB9T");
var $4d6e128987b0ecb9$var$StringBuilder = /** @class */ function() {
    function StringBuilder(value) {
        if (value === void 0) value = "";
        this.value = value;
    }
    StringBuilder.prototype.enableDecoding = function(encoding) {
        this.encoding = encoding;
        return this;
    };
    StringBuilder.prototype.append = function(s) {
        if (typeof s === "string") this.value += s.toString();
        else if (this.encoding) // use passed format (fromCharCode will return UTF8 encoding)
        this.value += (0, $7mB9T.default).castAsNonUtf8Char(s, this.encoding);
        else // correctly converts from UTF-8, but not other encodings
        this.value += String.fromCharCode(s);
        return this;
    };
    StringBuilder.prototype.appendChars = function(str, offset, len) {
        for(var i = offset; offset < offset + len; i++)this.append(str[i]);
        return this;
    };
    StringBuilder.prototype.length = function() {
        return this.value.length;
    };
    StringBuilder.prototype.charAt = function(n) {
        return this.value.charAt(n);
    };
    StringBuilder.prototype.deleteCharAt = function(n) {
        this.value = this.value.substr(0, n) + this.value.substring(n + 1);
    };
    StringBuilder.prototype.setCharAt = function(n, c) {
        this.value = this.value.substr(0, n) + c + this.value.substr(n + 1);
    };
    StringBuilder.prototype.substring = function(start, end) {
        return this.value.substring(start, end);
    };
    /**
     * @note helper method for RSS Expanded
     */ StringBuilder.prototype.setLengthToZero = function() {
        this.value = "";
    };
    StringBuilder.prototype.toString = function() {
        return this.value;
    };
    StringBuilder.prototype.insert = function(n, c) {
        this.value = this.value.substring(0, n) + c + this.value.substring(n);
    };
    return StringBuilder;
}();
var $4d6e128987b0ecb9$export$2e2bcd8739ae039 = $4d6e128987b0ecb9$var$StringBuilder;

});
parcelRegister("7mB9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $55c76968e7c7a13d$export$2e2bcd8739ae039);
/*
 * Copyright (C) 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /*import java.nio.charset.Charset;*/ /*import java.util.Map;*/ 
var $b5DE3 = parcelRequire("b5DE3");

var $l8eP1 = parcelRequire("l8eP1");

var $fPMAB = parcelRequire("fPMAB");
/**
 * Common string-related functions.
 *
 * @author Sean Owen
 * @author Alex Dupre
 */ var $55c76968e7c7a13d$var$StringUtils = /** @class */ function() {
    function StringUtils() {}
    // SHIFT_JIS.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING) ||
    // EUC_JP.equalsIgnoreCase(PLATFORM_DEFAULT_ENCODING);
    StringUtils.castAsNonUtf8Char = function(code, encoding) {
        if (encoding === void 0) encoding = null;
        // ISO 8859-1 is the Java default as UTF-8 is JavaScripts
        // you can see this method as a Java version of String.fromCharCode
        var e = encoding ? encoding.getName() : this.ISO88591;
        // use passed format (fromCharCode will return UTF8 encoding)
        return (0, $fPMAB.default).decode(new Uint8Array([
            code
        ]), e);
    };
    /**
     * @param bytes bytes encoding a string, whose encoding should be guessed
     * @param hints decode hints if applicable
     * @return name of guessed encoding; at the moment will only guess one of:
     *  {@link #SHIFT_JIS}, {@link #UTF8}, {@link #ISO88591}, or the platform
     *  default encoding if none of these can possibly be correct
     */ StringUtils.guessEncoding = function(bytes, hints) {
        if (hints !== null && hints !== undefined && undefined !== hints.get((0, $b5DE3.default).CHARACTER_SET)) return hints.get((0, $b5DE3.default).CHARACTER_SET).toString();
        // For now, merely tries to distinguish ISO-8859-1, UTF-8 and Shift_JIS,
        // which should be by far the most common encodings.
        var length = bytes.length;
        var canBeISO88591 = true;
        var canBeShiftJIS = true;
        var canBeUTF8 = true;
        var utf8BytesLeft = 0;
        // int utf8LowChars = 0
        var utf2BytesChars = 0;
        var utf3BytesChars = 0;
        var utf4BytesChars = 0;
        var sjisBytesLeft = 0;
        // int sjisLowChars = 0
        var sjisKatakanaChars = 0;
        // int sjisDoubleBytesChars = 0
        var sjisCurKatakanaWordLength = 0;
        var sjisCurDoubleBytesWordLength = 0;
        var sjisMaxKatakanaWordLength = 0;
        var sjisMaxDoubleBytesWordLength = 0;
        // int isoLowChars = 0
        // int isoHighChars = 0
        var isoHighOther = 0;
        var utf8bom = bytes.length > 3 && bytes[0] === /*(byte) */ 0xEF && bytes[1] === /*(byte) */ 0xBB && bytes[2] === /*(byte) */ 0xBF;
        for(var i = 0; i < length && (canBeISO88591 || canBeShiftJIS || canBeUTF8); i++){
            var value = bytes[i] & 0xFF;
            // UTF-8 stuff
            if (canBeUTF8) {
                if (utf8BytesLeft > 0) {
                    if ((value & 0x80) === 0) canBeUTF8 = false;
                    else utf8BytesLeft--;
                } else if ((value & 0x80) !== 0) {
                    if ((value & 0x40) === 0) canBeUTF8 = false;
                    else {
                        utf8BytesLeft++;
                        if ((value & 0x20) === 0) utf2BytesChars++;
                        else {
                            utf8BytesLeft++;
                            if ((value & 0x10) === 0) utf3BytesChars++;
                            else {
                                utf8BytesLeft++;
                                if ((value & 0x08) === 0) utf4BytesChars++;
                                else canBeUTF8 = false;
                            }
                        }
                    }
                } // else {
            // utf8LowChars++
            // }
            }
            // ISO-8859-1 stuff
            if (canBeISO88591) {
                if (value > 0x7F && value < 0xA0) canBeISO88591 = false;
                else if (value > 0x9F) {
                    if (value < 0xC0 || value === 0xD7 || value === 0xF7) isoHighOther++;
                     // else {
                } // else {
            // isoLowChars++
            // }
            }
            // Shift_JIS stuff
            if (canBeShiftJIS) {
                if (sjisBytesLeft > 0) {
                    if (value < 0x40 || value === 0x7F || value > 0xFC) canBeShiftJIS = false;
                    else sjisBytesLeft--;
                } else if (value === 0x80 || value === 0xA0 || value > 0xEF) canBeShiftJIS = false;
                else if (value > 0xA0 && value < 0xE0) {
                    sjisKatakanaChars++;
                    sjisCurDoubleBytesWordLength = 0;
                    sjisCurKatakanaWordLength++;
                    if (sjisCurKatakanaWordLength > sjisMaxKatakanaWordLength) sjisMaxKatakanaWordLength = sjisCurKatakanaWordLength;
                } else if (value > 0x7F) {
                    sjisBytesLeft++;
                    // sjisDoubleBytesChars++
                    sjisCurKatakanaWordLength = 0;
                    sjisCurDoubleBytesWordLength++;
                    if (sjisCurDoubleBytesWordLength > sjisMaxDoubleBytesWordLength) sjisMaxDoubleBytesWordLength = sjisCurDoubleBytesWordLength;
                } else {
                    // sjisLowChars++
                    sjisCurKatakanaWordLength = 0;
                    sjisCurDoubleBytesWordLength = 0;
                }
            }
        }
        if (canBeUTF8 && utf8BytesLeft > 0) canBeUTF8 = false;
        if (canBeShiftJIS && sjisBytesLeft > 0) canBeShiftJIS = false;
        // Easy -- if there is BOM or at least 1 valid not-single byte character (and no evidence it can't be UTF-8), done
        if (canBeUTF8 && (utf8bom || utf2BytesChars + utf3BytesChars + utf4BytesChars > 0)) return StringUtils.UTF8;
        // Easy -- if assuming Shift_JIS or at least 3 valid consecutive not-ascii characters (and no evidence it can't be), done
        if (canBeShiftJIS && (StringUtils.ASSUME_SHIFT_JIS || sjisMaxKatakanaWordLength >= 3 || sjisMaxDoubleBytesWordLength >= 3)) return StringUtils.SHIFT_JIS;
        // Distinguishing Shift_JIS and ISO-8859-1 can be a little tough for short words. The crude heuristic is:
        // - If we saw
        //   - only two consecutive katakana chars in the whole text, or
        //   - at least 10% of bytes that could be "upper" not-alphanumeric Latin1,
        // - then we conclude Shift_JIS, else ISO-8859-1
        if (canBeISO88591 && canBeShiftJIS) return sjisMaxKatakanaWordLength === 2 && sjisKatakanaChars === 2 || isoHighOther * 10 >= length ? StringUtils.SHIFT_JIS : StringUtils.ISO88591;
        // Otherwise, try in order ISO-8859-1, Shift JIS, UTF-8 and fall back to default platform encoding
        if (canBeISO88591) return StringUtils.ISO88591;
        if (canBeShiftJIS) return StringUtils.SHIFT_JIS;
        if (canBeUTF8) return StringUtils.UTF8;
        // Otherwise, we take a wild guess with platform encoding
        return StringUtils.PLATFORM_DEFAULT_ENCODING;
    };
    /**
     *
     * @see https://stackoverflow.com/a/13439711/4367683
     *
     * @param append The new string to append.
     * @param args Argumets values to be formated.
     */ StringUtils.format = function(append) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var i = -1;
        function callback(exp, p0, p1, p2, p3, p4) {
            if (exp === "%%") return "%";
            if (args[++i] === undefined) return undefined;
            exp = p2 ? parseInt(p2.substr(1)) : undefined;
            var base = p3 ? parseInt(p3.substr(1)) : undefined;
            var val;
            switch(p4){
                case "s":
                    val = args[i];
                    break;
                case "c":
                    val = args[i][0];
                    break;
                case "f":
                    val = parseFloat(args[i]).toFixed(exp);
                    break;
                case "p":
                    val = parseFloat(args[i]).toPrecision(exp);
                    break;
                case "e":
                    val = parseFloat(args[i]).toExponential(exp);
                    break;
                case "x":
                    val = parseInt(args[i]).toString(base ? base : 16);
                    break;
                case "d":
                    val = parseFloat(parseInt(args[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                    break;
            }
            val = typeof val === "object" ? JSON.stringify(val) : (+val).toString(base);
            var size = parseInt(p1); /* padding size */ 
            var ch = p1 && p1[0] + "" === "0" ? "0" : " "; /* isnull? */ 
            while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
            return val;
        }
        var regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
        return append.replace(regex, callback);
    };
    /**
     *
     */ StringUtils.getBytes = function(str, encoding) {
        return (0, $fPMAB.default).encode(str, encoding);
    };
    /**
     * Returns the charcode at the specified index or at index zero.
     */ StringUtils.getCharCode = function(str, index) {
        if (index === void 0) index = 0;
        return str.charCodeAt(index);
    };
    /**
     * Returns char for given charcode
     */ StringUtils.getCharAt = function(charCode) {
        return String.fromCharCode(charCode);
    };
    StringUtils.SHIFT_JIS = (0, $l8eP1.default).SJIS.getName(); // "SJIS"
    StringUtils.GB2312 = "GB2312";
    StringUtils.ISO88591 = (0, $l8eP1.default).ISO8859_1.getName(); // "ISO8859_1"
    StringUtils.EUC_JP = "EUC_JP";
    StringUtils.UTF8 = (0, $l8eP1.default).UTF8.getName(); // "UTF8"
    StringUtils.PLATFORM_DEFAULT_ENCODING = StringUtils.UTF8; // "UTF8"//Charset.defaultCharset().name()
    StringUtils.ASSUME_SHIFT_JIS = false;
    return StringUtils;
}();
var $55c76968e7c7a13d$export$2e2bcd8739ae039 = $55c76968e7c7a13d$var$StringUtils;

});
parcelRegister("b5DE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $812eea006ed8de76$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ /**
 * Encapsulates a type of hint that a caller may pass to a barcode reader to help it
 * more quickly or accurately decode it. It is up to implementations to decide what,
 * if anything, to do with the information that is supplied.
 *
 * @author Sean Owen
 * @author dswitkin@google.com (Daniel Switkin)
 * @see Reader#decode(BinaryBitmap,java.util.Map)
 */ var $812eea006ed8de76$var$DecodeHintType;
(function(DecodeHintType) {
    /**
     * Unspecified, application-specific hint. Maps to an unspecified {@link Object}.
     */ DecodeHintType[DecodeHintType["OTHER"] = 0] = "OTHER"; /*(Object.class)*/ 
    /**
     * Image is a pure monochrome image of a barcode. Doesn't matter what it maps to;
     * use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["PURE_BARCODE"] = 1] = "PURE_BARCODE"; /*(Void.class)*/ 
    /**
     * Image is known to be of one of a few possible formats.
     * Maps to a {@link List} of {@link BarcodeFormat}s.
     */ DecodeHintType[DecodeHintType["POSSIBLE_FORMATS"] = 2] = "POSSIBLE_FORMATS"; /*(List.class)*/ 
    /**
     * Spend more time to try to find a barcode; optimize for accuracy, not speed.
     * Doesn't matter what it maps to; use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["TRY_HARDER"] = 3] = "TRY_HARDER"; /*(Void.class)*/ 
    /**
     * Specifies what character encoding to use when decoding, where applicable (type String)
     */ DecodeHintType[DecodeHintType["CHARACTER_SET"] = 4] = "CHARACTER_SET"; /*(String.class)*/ 
    /**
     * Allowed lengths of encoded data -- reject anything else. Maps to an {@code Int32Array}.
     */ DecodeHintType[DecodeHintType["ALLOWED_LENGTHS"] = 5] = "ALLOWED_LENGTHS"; /*(Int32Array.class)*/ 
    /**
     * Assume Code 39 codes employ a check digit. Doesn't matter what it maps to;
     * use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["ASSUME_CODE_39_CHECK_DIGIT"] = 6] = "ASSUME_CODE_39_CHECK_DIGIT"; /*(Void.class)*/ 
    /**
     * Enable extended mode for Code 39 codes. Doesn't matter what it maps to;
     * use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["ENABLE_CODE_39_EXTENDED_MODE"] = 7] = "ENABLE_CODE_39_EXTENDED_MODE"; /*(Void.class)*/ 
    /**
     * Assume the barcode is being processed as a GS1 barcode, and modify behavior as needed.
     * For example this affects FNC1 handling for Code 128 (aka GS1-128). Doesn't matter what it maps to;
     * use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["ASSUME_GS1"] = 8] = "ASSUME_GS1"; /*(Void.class)*/ 
    /**
     * If true, return the start and end digits in a Codabar barcode instead of stripping them. They
     * are alpha, whereas the rest are numeric. By default, they are stripped, but this causes them
     * to not be. Doesn't matter what it maps to; use {@link Boolean#TRUE}.
     */ DecodeHintType[DecodeHintType["RETURN_CODABAR_START_END"] = 9] = "RETURN_CODABAR_START_END"; /*(Void.class)*/ 
    /**
     * The caller needs to be notified via callback when a possible {@link ResultPoint}
     * is found. Maps to a {@link ResultPointCallback}.
     */ DecodeHintType[DecodeHintType["NEED_RESULT_POINT_CALLBACK"] = 10] = "NEED_RESULT_POINT_CALLBACK"; /*(ResultPointCallback.class)*/ 
    /**
     * Allowed extension lengths for EAN or UPC barcodes. Other formats will ignore this.
     * Maps to an {@code Int32Array} of the allowed extension lengths, for example [2], [5], or [2, 5].
     * If it is optional to have an extension, do not set this hint. If this is set,
     * and a UPC or EAN barcode is found but an extension is not, then no result will be returned
     * at all.
     */ DecodeHintType[DecodeHintType["ALLOWED_EAN_EXTENSIONS"] = 11] = "ALLOWED_EAN_EXTENSIONS"; /*(Int32Array.class)*/ 
// End of enumeration values.
/**
     * Data type the hint is expecting.
     * Among the possible values the {@link Void} stands out as being used for
     * hints that do not expect a value to be supplied (flag hints). Such hints
     * will possibly have their value ignored, or replaced by a
     * {@link Boolean#TRUE}. Hint suppliers should probably use
     * {@link Boolean#TRUE} as directed by the actual hint documentation.
     */ // private valueType: Class<?>
// DecodeHintType(valueType: Class<?>) {
//   this.valueType = valueType
// }
// public getValueType(): Class<?> {
//   return valueType
// }
})($812eea006ed8de76$var$DecodeHintType || ($812eea006ed8de76$var$DecodeHintType = {}));
var $812eea006ed8de76$export$2e2bcd8739ae039 = $812eea006ed8de76$var$DecodeHintType;

});

parcelRegister("l8eP1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f625d7a31454dcd6$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $dtgr5 = parcelRequire("dtgr5");
var $f625d7a31454dcd6$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $f625d7a31454dcd6$export$f767678c309eaa03;
(function(CharacterSetValueIdentifiers) {
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp437"] = 0] = "Cp437";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_1"] = 1] = "ISO8859_1";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_2"] = 2] = "ISO8859_2";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_3"] = 3] = "ISO8859_3";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_4"] = 4] = "ISO8859_4";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_5"] = 5] = "ISO8859_5";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_6"] = 6] = "ISO8859_6";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_7"] = 7] = "ISO8859_7";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_8"] = 8] = "ISO8859_8";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_9"] = 9] = "ISO8859_9";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_10"] = 10] = "ISO8859_10";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_11"] = 11] = "ISO8859_11";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_13"] = 12] = "ISO8859_13";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_14"] = 13] = "ISO8859_14";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_15"] = 14] = "ISO8859_15";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ISO8859_16"] = 15] = "ISO8859_16";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["SJIS"] = 16] = "SJIS";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1250"] = 17] = "Cp1250";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1251"] = 18] = "Cp1251";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1252"] = 19] = "Cp1252";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Cp1256"] = 20] = "Cp1256";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UnicodeBigUnmarked"] = 21] = "UnicodeBigUnmarked";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["UTF8"] = 22] = "UTF8";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["ASCII"] = 23] = "ASCII";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["Big5"] = 24] = "Big5";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["GB18030"] = 25] = "GB18030";
    CharacterSetValueIdentifiers[CharacterSetValueIdentifiers["EUC_KR"] = 26] = "EUC_KR";
})($f625d7a31454dcd6$export$f767678c309eaa03 || ($f625d7a31454dcd6$export$f767678c309eaa03 = {}));
/**
 * Encapsulates a Character Set ECI, according to "Extended Channel Interpretations" 5.3.1.1
 * of ISO 18004.
 *
 * @author Sean Owen
 */ var $f625d7a31454dcd6$var$CharacterSetECI = /** @class */ function() {
    function CharacterSetECI(valueIdentifier, valuesParam, name) {
        var e_1, _a;
        var otherEncodingNames = [];
        for(var _i = 3; _i < arguments.length; _i++)otherEncodingNames[_i - 3] = arguments[_i];
        this.valueIdentifier = valueIdentifier;
        this.name = name;
        if (typeof valuesParam === "number") this.values = Int32Array.from([
            valuesParam
        ]);
        else this.values = valuesParam;
        this.otherEncodingNames = otherEncodingNames;
        CharacterSetECI.VALUE_IDENTIFIER_TO_ECI.set(valueIdentifier, this);
        CharacterSetECI.NAME_TO_ECI.set(name, this);
        var values = this.values;
        for(var i = 0, length_1 = values.length; i !== length_1; i++){
            var v = values[i];
            CharacterSetECI.VALUES_TO_ECI.set(v, this);
        }
        try {
            for(var otherEncodingNames_1 = $f625d7a31454dcd6$var$__values(otherEncodingNames), otherEncodingNames_1_1 = otherEncodingNames_1.next(); !otherEncodingNames_1_1.done; otherEncodingNames_1_1 = otherEncodingNames_1.next()){
                var otherName = otherEncodingNames_1_1.value;
                CharacterSetECI.NAME_TO_ECI.set(otherName, this);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (otherEncodingNames_1_1 && !otherEncodingNames_1_1.done && (_a = otherEncodingNames_1.return)) _a.call(otherEncodingNames_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    // CharacterSetECI(value: number /*int*/) {
    //   this(new Int32Array {value})
    // }
    // CharacterSetECI(value: number /*int*/, String... otherEncodingNames) {
    //   this.values = new Int32Array {value}
    //   this.otherEncodingNames = otherEncodingNames
    // }
    // CharacterSetECI(values: Int32Array, String... otherEncodingNames) {
    //   this.values = values
    //   this.otherEncodingNames = otherEncodingNames
    // }
    CharacterSetECI.prototype.getValueIdentifier = function() {
        return this.valueIdentifier;
    };
    CharacterSetECI.prototype.getName = function() {
        return this.name;
    };
    CharacterSetECI.prototype.getValue = function() {
        return this.values[0];
    };
    /**
     * @param value character set ECI value
     * @return {@code CharacterSetECI} representing ECI of given value, or null if it is legal but
     *   unsupported
     * @throws FormatException if ECI value is invalid
     */ CharacterSetECI.getCharacterSetECIByValue = function(value /*int*/ ) {
        if (value < 0 || value >= 900) throw new (0, $dtgr5.default)("incorect value");
        var characterSet = CharacterSetECI.VALUES_TO_ECI.get(value);
        if (undefined === characterSet) throw new (0, $dtgr5.default)("incorect value");
        return characterSet;
    };
    /**
     * @param name character set ECI encoding name
     * @return CharacterSetECI representing ECI for character encoding, or null if it is legal
     *   but unsupported
     */ CharacterSetECI.getCharacterSetECIByName = function(name) {
        var characterSet = CharacterSetECI.NAME_TO_ECI.get(name);
        if (undefined === characterSet) throw new (0, $dtgr5.default)("incorect value");
        return characterSet;
    };
    CharacterSetECI.prototype.equals = function(o) {
        if (!(o instanceof CharacterSetECI)) return false;
        var other = o;
        return this.getName() === other.getName();
    };
    CharacterSetECI.VALUE_IDENTIFIER_TO_ECI = new Map();
    CharacterSetECI.VALUES_TO_ECI = new Map();
    CharacterSetECI.NAME_TO_ECI = new Map();
    // Enum name is a Java encoding valid for java.lang and java.io
    // TYPESCRIPTPORT: changed the main label for ISO as the TextEncoder did not recognized them in the form from java
    // (eg ISO8859_1 must be ISO88591 or ISO8859-1 or ISO-8859-1)
    // later on: well, except 16 wich does not work with ISO885916 so used ISO-8859-1 form for default
    CharacterSetECI.Cp437 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.Cp437, Int32Array.from([
        0,
        2
    ]), "Cp437");
    CharacterSetECI.ISO8859_1 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_1, Int32Array.from([
        1,
        3
    ]), "ISO-8859-1", "ISO88591", "ISO8859_1");
    CharacterSetECI.ISO8859_2 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_2, 4, "ISO-8859-2", "ISO88592", "ISO8859_2");
    CharacterSetECI.ISO8859_3 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_3, 5, "ISO-8859-3", "ISO88593", "ISO8859_3");
    CharacterSetECI.ISO8859_4 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_4, 6, "ISO-8859-4", "ISO88594", "ISO8859_4");
    CharacterSetECI.ISO8859_5 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_5, 7, "ISO-8859-5", "ISO88595", "ISO8859_5");
    CharacterSetECI.ISO8859_6 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_6, 8, "ISO-8859-6", "ISO88596", "ISO8859_6");
    CharacterSetECI.ISO8859_7 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_7, 9, "ISO-8859-7", "ISO88597", "ISO8859_7");
    CharacterSetECI.ISO8859_8 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_8, 10, "ISO-8859-8", "ISO88598", "ISO8859_8");
    CharacterSetECI.ISO8859_9 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_9, 11, "ISO-8859-9", "ISO88599", "ISO8859_9");
    CharacterSetECI.ISO8859_10 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_10, 12, "ISO-8859-10", "ISO885910", "ISO8859_10");
    CharacterSetECI.ISO8859_11 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_11, 13, "ISO-8859-11", "ISO885911", "ISO8859_11");
    CharacterSetECI.ISO8859_13 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_13, 15, "ISO-8859-13", "ISO885913", "ISO8859_13");
    CharacterSetECI.ISO8859_14 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_14, 16, "ISO-8859-14", "ISO885914", "ISO8859_14");
    CharacterSetECI.ISO8859_15 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_15, 17, "ISO-8859-15", "ISO885915", "ISO8859_15");
    CharacterSetECI.ISO8859_16 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ISO8859_16, 18, "ISO-8859-16", "ISO885916", "ISO8859_16");
    CharacterSetECI.SJIS = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.SJIS, 20, "SJIS", "Shift_JIS");
    CharacterSetECI.Cp1250 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.Cp1250, 21, "Cp1250", "windows-1250");
    CharacterSetECI.Cp1251 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.Cp1251, 22, "Cp1251", "windows-1251");
    CharacterSetECI.Cp1252 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.Cp1252, 23, "Cp1252", "windows-1252");
    CharacterSetECI.Cp1256 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.Cp1256, 24, "Cp1256", "windows-1256");
    CharacterSetECI.UnicodeBigUnmarked = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.UnicodeBigUnmarked, 25, "UnicodeBigUnmarked", "UTF-16BE", "UnicodeBig");
    CharacterSetECI.UTF8 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.UTF8, 26, "UTF8", "UTF-8");
    CharacterSetECI.ASCII = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.ASCII, Int32Array.from([
        27,
        170
    ]), "ASCII", "US-ASCII");
    CharacterSetECI.Big5 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.Big5, 28, "Big5");
    CharacterSetECI.GB18030 = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.GB18030, 29, "GB18030", "GB2312", "EUC_CN", "GBK");
    CharacterSetECI.EUC_KR = new CharacterSetECI($f625d7a31454dcd6$export$f767678c309eaa03.EUC_KR, 30, "EUC_KR", "EUC-KR");
    return CharacterSetECI;
}();
var $f625d7a31454dcd6$export$2e2bcd8739ae039 = $f625d7a31454dcd6$var$CharacterSetECI;

});
parcelRegister("dtgr5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ceabb9e25375294$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $9ceabb9e25375294$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $9ceabb9e25375294$var$FormatException = /** @class */ function(_super) {
    $9ceabb9e25375294$var$__extends(FormatException, _super);
    function FormatException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormatException.getFormatInstance = function() {
        return new FormatException();
    };
    FormatException.kind = "FormatException";
    return FormatException;
}((0, $26SD6.default));
var $9ceabb9e25375294$export$2e2bcd8739ae039 = $9ceabb9e25375294$var$FormatException;

});


parcelRegister("fPMAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8714f4747d5b27d$export$2e2bcd8739ae039);

var $e8t3n = parcelRequire("e8t3n");

var $l8eP1 = parcelRequire("l8eP1");
/**
 * Responsible for en/decoding strings.
 */ var $b8714f4747d5b27d$var$StringEncoding = /** @class */ function() {
    function StringEncoding() {}
    /**
     * Decodes some Uint8Array to a string format.
     */ StringEncoding.decode = function(bytes, encoding) {
        var encodingName = this.encodingName(encoding);
        if (this.customDecoder) return this.customDecoder(bytes, encodingName);
        // Increases browser support.
        if (typeof TextDecoder === "undefined" || this.shouldDecodeOnFallback(encodingName)) return this.decodeFallback(bytes, encodingName);
        return new TextDecoder(encodingName).decode(bytes);
    };
    /**
     * Checks if the decoding method should use the fallback for decoding
     * once Node TextDecoder doesn't support all encoding formats.
     *
     * @param encodingName
     */ StringEncoding.shouldDecodeOnFallback = function(encodingName) {
        return !StringEncoding.isBrowser() && encodingName === "ISO-8859-1";
    };
    /**
     * Encodes some string into a Uint8Array.
     */ StringEncoding.encode = function(s, encoding) {
        var encodingName = this.encodingName(encoding);
        if (this.customEncoder) return this.customEncoder(s, encodingName);
        // Increases browser support.
        if (typeof TextEncoder === "undefined") return this.encodeFallback(s);
        // TextEncoder only encodes to UTF8 by default as specified by encoding.spec.whatwg.org
        return new TextEncoder().encode(s);
    };
    StringEncoding.isBrowser = function() {
        return typeof window !== "undefined" && ({}).toString.call(window) === "[object Window]";
    };
    /**
     * Returns the string value from some encoding character set.
     */ StringEncoding.encodingName = function(encoding) {
        return typeof encoding === "string" ? encoding : encoding.getName();
    };
    /**
     * Returns character set from some encoding character set.
     */ StringEncoding.encodingCharacterSet = function(encoding) {
        if (encoding instanceof (0, $l8eP1.default)) return encoding;
        return (0, $l8eP1.default).getCharacterSetECIByName(encoding);
    };
    /**
     * Runs a fallback for the native decoding funcion.
     */ StringEncoding.decodeFallback = function(bytes, encoding) {
        var characterSet = this.encodingCharacterSet(encoding);
        if (StringEncoding.isDecodeFallbackSupported(characterSet)) {
            var s = "";
            for(var i = 0, length_1 = bytes.length; i < length_1; i++){
                var h = bytes[i].toString(16);
                if (h.length < 2) h = "0" + h;
                s += "%" + h;
            }
            return decodeURIComponent(s);
        }
        if (characterSet.equals((0, $l8eP1.default).UnicodeBigUnmarked)) return String.fromCharCode.apply(null, new Uint16Array(bytes.buffer));
        throw new (0, $e8t3n.default)("Encoding " + this.encodingName(encoding) + " not supported by fallback.");
    };
    StringEncoding.isDecodeFallbackSupported = function(characterSet) {
        return characterSet.equals((0, $l8eP1.default).UTF8) || characterSet.equals((0, $l8eP1.default).ISO8859_1) || characterSet.equals((0, $l8eP1.default).ASCII);
    };
    /**
     * Runs a fallback for the native encoding funcion.
     *
     * @see https://stackoverflow.com/a/17192845/4367683
     */ StringEncoding.encodeFallback = function(s) {
        var encodedURIstring = btoa(unescape(encodeURIComponent(s)));
        var charList = encodedURIstring.split("");
        var uintArray = [];
        for(var i = 0; i < charList.length; i++)uintArray.push(charList[i].charCodeAt(0));
        return new Uint8Array(uintArray);
    };
    return StringEncoding;
}();
var $b8714f4747d5b27d$export$2e2bcd8739ae039 = $b8714f4747d5b27d$var$StringEncoding;

});
parcelRegister("e8t3n", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4a85972faf5c06c$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $a4a85972faf5c06c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $a4a85972faf5c06c$var$UnsupportedOperationException = /** @class */ function(_super) {
    $a4a85972faf5c06c$var$__extends(UnsupportedOperationException, _super);
    function UnsupportedOperationException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UnsupportedOperationException.kind = "UnsupportedOperationException";
    return UnsupportedOperationException;
}((0, $26SD6.default));
var $a4a85972faf5c06c$export$2e2bcd8739ae039 = $a4a85972faf5c06c$var$UnsupportedOperationException;

});





parcelRegister("cQi30", function(module, exports) {

$parcel$export(module.exports, "default", () => $9598573ddc78fbf8$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $9598573ddc78fbf8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $9598573ddc78fbf8$var$NotFoundException = /** @class */ function(_super) {
    $9598573ddc78fbf8$var$__extends(NotFoundException, _super);
    function NotFoundException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotFoundException.getNotFoundInstance = function() {
        return new NotFoundException();
    };
    NotFoundException.kind = "NotFoundException";
    return NotFoundException;
}((0, $26SD6.default));
var $9598573ddc78fbf8$export$2e2bcd8739ae039 = $9598573ddc78fbf8$var$NotFoundException;

});



parcelRegister("cuqS0", function(module, exports) {

$parcel$export(module.exports, "HTMLCanvasElementLuminanceSource", () => $917d2133c130b3fa$export$4ae6c62b2342fa1a);

var $bBVLs = parcelRequire("bBVLs");

var $bvYQM = parcelRequire("bvYQM");

var $kLpae = parcelRequire("kLpae");
var $917d2133c130b3fa$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 */ var $917d2133c130b3fa$export$4ae6c62b2342fa1a = /** @class */ function(_super) {
    $917d2133c130b3fa$var$__extends(HTMLCanvasElementLuminanceSource, _super);
    function HTMLCanvasElementLuminanceSource(canvas) {
        var _this = _super.call(this, canvas.width, canvas.height) || this;
        _this.canvas = canvas;
        _this.tempCanvasElement = null;
        _this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(canvas);
        return _this;
    }
    HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData = function(canvas) {
        var imageData = canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height);
        return HTMLCanvasElementLuminanceSource.toGrayscaleBuffer(imageData.data, canvas.width, canvas.height);
    };
    HTMLCanvasElementLuminanceSource.toGrayscaleBuffer = function(imageBuffer, width, height) {
        var grayscaleBuffer = new Uint8ClampedArray(width * height);
        HTMLCanvasElementLuminanceSource.FRAME_INDEX = !HTMLCanvasElementLuminanceSource.FRAME_INDEX;
        if (HTMLCanvasElementLuminanceSource.FRAME_INDEX) for(var i = 0, j = 0, length_1 = imageBuffer.length; i < length_1; i += 4, j++){
            var gray = void 0;
            var alpha = imageBuffer[i + 3];
            // The color of fully-transparent pixels is irrelevant. They are often, technically, fully-transparent
            // black (0 alpha, and then 0 RGB). They are often used, of course as the "white" area in a
            // barcode image. Force any such pixel to be white:
            if (alpha === 0) gray = 0xFF;
            else {
                var pixelR = imageBuffer[i];
                var pixelG = imageBuffer[i + 1];
                var pixelB = imageBuffer[i + 2];
                // .299R + 0.587G + 0.114B (YUV/YIQ for PAL and NTSC),
                // (306*R) >> 10 is approximately equal to R*0.299, and so on.
                // 0x200 >> 10 is 0.5, it implements rounding.
                gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 0x200 >> 10;
            }
            grayscaleBuffer[j] = gray;
        }
        else for(var i = 0, j = 0, length_2 = imageBuffer.length; i < length_2; i += 4, j++){
            var gray = void 0;
            var alpha = imageBuffer[i + 3];
            // The color of fully-transparent pixels is irrelevant. They are often, technically, fully-transparent
            // black (0 alpha, and then 0 RGB). They are often used, of course as the "white" area in a
            // barcode image. Force any such pixel to be white:
            if (alpha === 0) gray = 0xFF;
            else {
                var pixelR = imageBuffer[i];
                var pixelG = imageBuffer[i + 1];
                var pixelB = imageBuffer[i + 2];
                // .299R + 0.587G + 0.114B (YUV/YIQ for PAL and NTSC),
                // (306*R) >> 10 is approximately equal to R*0.299, and so on.
                // 0x200 >> 10 is 0.5, it implements rounding.
                gray = 306 * pixelR + 601 * pixelG + 117 * pixelB + 0x200 >> 10;
            }
            grayscaleBuffer[j] = 0xFF - gray;
        }
        return grayscaleBuffer;
    };
    HTMLCanvasElementLuminanceSource.prototype.getRow = function(y /*int*/ , row) {
        if (y < 0 || y >= this.getHeight()) throw new (0, $kLpae.default)("Requested row is outside the image: " + y);
        var width = this.getWidth();
        var start = y * width;
        if (row === null) row = this.buffer.slice(start, start + width);
        else {
            if (row.length < width) row = new Uint8ClampedArray(width);
            // The underlying raster of image consists of bytes with the luminance values
            // TODO: can avoid set/slice?
            row.set(this.buffer.slice(start, start + width));
        }
        return row;
    };
    HTMLCanvasElementLuminanceSource.prototype.getMatrix = function() {
        return this.buffer;
    };
    HTMLCanvasElementLuminanceSource.prototype.isCropSupported = function() {
        return true;
    };
    HTMLCanvasElementLuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        _super.prototype.crop.call(this, left, top, width, height);
        return this;
    };
    /**
     * This is always true, since the image is a gray-scale image.
     *
     * @return true
     */ HTMLCanvasElementLuminanceSource.prototype.isRotateSupported = function() {
        return true;
    };
    HTMLCanvasElementLuminanceSource.prototype.rotateCounterClockwise = function() {
        this.rotate(-90);
        return this;
    };
    HTMLCanvasElementLuminanceSource.prototype.rotateCounterClockwise45 = function() {
        this.rotate(-45);
        return this;
    };
    HTMLCanvasElementLuminanceSource.prototype.getTempCanvasElement = function() {
        if (null === this.tempCanvasElement) {
            var tempCanvasElement = this.canvas.ownerDocument.createElement("canvas");
            tempCanvasElement.width = this.canvas.width;
            tempCanvasElement.height = this.canvas.height;
            this.tempCanvasElement = tempCanvasElement;
        }
        return this.tempCanvasElement;
    };
    HTMLCanvasElementLuminanceSource.prototype.rotate = function(angle) {
        var tempCanvasElement = this.getTempCanvasElement();
        var tempContext = tempCanvasElement.getContext("2d");
        var angleRadians = angle * HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS;
        // Calculate and set new dimensions for temp canvas
        var width = this.canvas.width;
        var height = this.canvas.height;
        var newWidth = Math.ceil(Math.abs(Math.cos(angleRadians)) * width + Math.abs(Math.sin(angleRadians)) * height);
        var newHeight = Math.ceil(Math.abs(Math.sin(angleRadians)) * width + Math.abs(Math.cos(angleRadians)) * height);
        tempCanvasElement.width = newWidth;
        tempCanvasElement.height = newHeight;
        // Draw at center of temp canvas to prevent clipping of image data
        tempContext.translate(newWidth / 2, newHeight / 2);
        tempContext.rotate(angleRadians);
        tempContext.drawImage(this.canvas, width / -2, height / -2);
        this.buffer = HTMLCanvasElementLuminanceSource.makeBufferFromCanvasImageData(tempCanvasElement);
        return this;
    };
    HTMLCanvasElementLuminanceSource.prototype.invert = function() {
        return new (0, $bBVLs.default)(this);
    };
    HTMLCanvasElementLuminanceSource.DEGREE_TO_RADIANS = Math.PI / 180;
    HTMLCanvasElementLuminanceSource.FRAME_INDEX = true;
    return HTMLCanvasElementLuminanceSource;
}((0, $bvYQM.default));

});
parcelRegister("bBVLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $873ff538f277159a$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bvYQM = parcelRequire("bvYQM");
var $873ff538f277159a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/*namespace com.google.zxing {*/ /**
 * A wrapper implementation of {@link LuminanceSource} which inverts the luminances it returns -- black becomes
 * white and vice versa, and each value becomes (255-value).
 *
 * @author Sean Owen
 */ var $873ff538f277159a$var$InvertedLuminanceSource = /** @class */ function(_super) {
    $873ff538f277159a$var$__extends(InvertedLuminanceSource, _super);
    function InvertedLuminanceSource(delegate) {
        var _this = _super.call(this, delegate.getWidth(), delegate.getHeight()) || this;
        _this.delegate = delegate;
        return _this;
    }
    /*@Override*/ InvertedLuminanceSource.prototype.getRow = function(y /*int*/ , row) {
        var sourceRow = this.delegate.getRow(y, row);
        var width = this.getWidth();
        for(var i = 0; i < width; i++)sourceRow[i] = /*(byte)*/ 255 - (sourceRow[i] & 0xFF);
        return sourceRow;
    };
    /*@Override*/ InvertedLuminanceSource.prototype.getMatrix = function() {
        var matrix = this.delegate.getMatrix();
        var length = this.getWidth() * this.getHeight();
        var invertedMatrix = new Uint8ClampedArray(length);
        for(var i = 0; i < length; i++)invertedMatrix[i] = /*(byte)*/ 255 - (matrix[i] & 0xFF);
        return invertedMatrix;
    };
    /*@Override*/ InvertedLuminanceSource.prototype.isCropSupported = function() {
        return this.delegate.isCropSupported();
    };
    /*@Override*/ InvertedLuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        return new InvertedLuminanceSource(this.delegate.crop(left, top, width, height));
    };
    /*@Override*/ InvertedLuminanceSource.prototype.isRotateSupported = function() {
        return this.delegate.isRotateSupported();
    };
    /**
     * @return original delegate {@link LuminanceSource} since invert undoes itself
     */ /*@Override*/ InvertedLuminanceSource.prototype.invert = function() {
        return this.delegate;
    };
    /*@Override*/ InvertedLuminanceSource.prototype.rotateCounterClockwise = function() {
        return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise());
    };
    /*@Override*/ InvertedLuminanceSource.prototype.rotateCounterClockwise45 = function() {
        return new InvertedLuminanceSource(this.delegate.rotateCounterClockwise45());
    };
    return InvertedLuminanceSource;
}((0, $bvYQM.default));
var $873ff538f277159a$export$2e2bcd8739ae039 = $873ff538f277159a$var$InvertedLuminanceSource;

});
parcelRegister("bvYQM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8621ca8fea8e37d6$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $6E9N1 = parcelRequire("6E9N1");

var $e8t3n = parcelRequire("e8t3n");
/*namespace com.google.zxing {*/ /**
 * The purpose of this class hierarchy is to abstract different bitmap implementations across
 * platforms into a standard interface for requesting greyscale luminance values. The interface
 * only provides immutable methods; therefore crop and rotation create copies. This is to ensure
 * that one Reader does not modify the original luminance source and leave it in an unknown state
 * for other Readers in the chain.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $8621ca8fea8e37d6$var$LuminanceSource = /** @class */ function() {
    function LuminanceSource(width /*int*/ , height /*int*/ ) {
        this.width = width;
        this.height = height;
    }
    /**
     * @return The width of the bitmap.
     */ LuminanceSource.prototype.getWidth = function() {
        return this.width;
    };
    /**
     * @return The height of the bitmap.
     */ LuminanceSource.prototype.getHeight = function() {
        return this.height;
    };
    /**
     * @return Whether this subclass supports cropping.
     */ LuminanceSource.prototype.isCropSupported = function() {
        return false;
    };
    /**
     * Returns a new object with cropped image data. Implementations may keep a reference to the
     * original data rather than a copy. Only callable if isCropSupported() is true.
     *
     * @param left The left coordinate, which must be in [0,getWidth())
     * @param top The top coordinate, which must be in [0,getHeight())
     * @param width The width of the rectangle to crop.
     * @param height The height of the rectangle to crop.
     * @return A cropped version of this object.
     */ LuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        throw new (0, $e8t3n.default)("This luminance source does not support cropping.");
    };
    /**
     * @return Whether this subclass supports counter-clockwise rotation.
     */ LuminanceSource.prototype.isRotateSupported = function() {
        return false;
    };
    /**
     * Returns a new object with rotated image data by 90 degrees counterclockwise.
     * Only callable if {@link #isRotateSupported()} is true.
     *
     * @return A rotated version of this object.
     */ LuminanceSource.prototype.rotateCounterClockwise = function() {
        throw new (0, $e8t3n.default)("This luminance source does not support rotation by 90 degrees.");
    };
    /**
     * Returns a new object with rotated image data by 45 degrees counterclockwise.
     * Only callable if {@link #isRotateSupported()} is true.
     *
     * @return A rotated version of this object.
     */ LuminanceSource.prototype.rotateCounterClockwise45 = function() {
        throw new (0, $e8t3n.default)("This luminance source does not support rotation by 45 degrees.");
    };
    /*@Override*/ LuminanceSource.prototype.toString = function() {
        var row = new Uint8ClampedArray(this.width);
        var result = new (0, $6E9N1.default)();
        for(var y = 0; y < this.height; y++){
            var sourceRow = this.getRow(y, row);
            for(var x = 0; x < this.width; x++){
                var luminance = sourceRow[x] & 0xFF;
                var c = void 0;
                if (luminance < 0x40) c = "#";
                else if (luminance < 0x80) c = "+";
                else if (luminance < 0xC0) c = ".";
                else c = " ";
                result.append(c);
            }
            result.append("\n");
        }
        return result.toString();
    };
    return LuminanceSource;
}();
var $8621ca8fea8e37d6$export$2e2bcd8739ae039 = $8621ca8fea8e37d6$var$LuminanceSource;

});



parcelRegister("45Mx2", function(module, exports) {

$parcel$export(module.exports, "VideoInputDevice", () => $2fad467838de9df6$export$78e94e704b2dbda0);
/**
 * @deprecated Moving to @zxing/browser
 *
 * Video input device metadata containing the id and label of the device if available.
 */ var $2fad467838de9df6$export$78e94e704b2dbda0 = /** @class */ function() {
    /**
     * Creates an instance of VideoInputDevice.
     *
     * @param {string} deviceId the video input device id
     * @param {string} label the label of the device if available
     */ function VideoInputDevice(deviceId, label, groupId) {
        this.deviceId = deviceId;
        this.label = label;
        /** @inheritdoc */ this.kind = "videoinput";
        this.groupId = groupId || undefined;
    }
    /** @inheritdoc */ VideoInputDevice.prototype.toJSON = function() {
        return {
            kind: this.kind,
            groupId: this.groupId,
            deviceId: this.deviceId,
            label: this.label
        };
    };
    return VideoInputDevice;
}();

});


parcelRegister("fJ3d6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b72d8c8365ceef65$export$2e2bcd8739ae039);
/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kWndQ = parcelRequire("kWndQ");

var $bx5V3 = parcelRequire("bx5V3");

var $b5DE3 = parcelRequire("b5DE3");

var $eS8qc = parcelRequire("eS8qc");

var $b6IL4 = parcelRequire("b6IL4");

var $e3wFC = parcelRequire("e3wFC");

var $erHVo = parcelRequire("erHVo");
// import java.util.List;
// import java.util.Map;
/**
 * This implementation can detect and decode Aztec codes in an image.
 *
 * @author David Olivier
 */ var $b72d8c8365ceef65$var$AztecReader = /** @class */ function() {
    function AztecReader() {}
    /**
     * Locates and decodes a Data Matrix code in an image.
     *
     * @return a String representing the content encoded by the Data Matrix code
     * @throws NotFoundException if a Data Matrix code cannot be found
     * @throws FormatException if a Data Matrix code cannot be decoded
     */ AztecReader.prototype.decode = function(image, hints) {
        if (hints === void 0) hints = null;
        var exception = null;
        var detector = new (0, $erHVo.default)(image.getBlackMatrix());
        var points = null;
        var decoderResult = null;
        try {
            var detectorResult = detector.detectMirror(false);
            points = detectorResult.getPoints();
            this.reportFoundResultPoints(hints, points);
            decoderResult = new (0, $e3wFC.default)().decode(detectorResult);
        } catch (e) {
            exception = e;
        }
        if (decoderResult == null) try {
            var detectorResult = detector.detectMirror(true);
            points = detectorResult.getPoints();
            this.reportFoundResultPoints(hints, points);
            decoderResult = new (0, $e3wFC.default)().decode(detectorResult);
        } catch (e) {
            if (exception != null) throw exception;
            throw e;
        }
        var result = new (0, $kWndQ.default)(decoderResult.getText(), decoderResult.getRawBytes(), decoderResult.getNumBits(), points, (0, $bx5V3.default).AZTEC, (0, $b6IL4.default).currentTimeMillis());
        var byteSegments = decoderResult.getByteSegments();
        if (byteSegments != null) result.putMetadata((0, $eS8qc.default).BYTE_SEGMENTS, byteSegments);
        var ecLevel = decoderResult.getECLevel();
        if (ecLevel != null) result.putMetadata((0, $eS8qc.default).ERROR_CORRECTION_LEVEL, ecLevel);
        return result;
    };
    AztecReader.prototype.reportFoundResultPoints = function(hints, points) {
        if (hints != null) {
            var rpcb_1 = hints.get((0, $b5DE3.default).NEED_RESULT_POINT_CALLBACK);
            if (rpcb_1 != null) points.forEach(function(point, idx, arr) {
                rpcb_1.foundPossibleResultPoint(point);
            });
        }
    };
    // @Override
    AztecReader.prototype.reset = function() {
    // do nothing
    };
    return AztecReader;
}();
var $b72d8c8365ceef65$export$2e2bcd8739ae039 = $b72d8c8365ceef65$var$AztecReader;

});
parcelRegister("kWndQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3eb3ce3feb0213d$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $b6IL4 = parcelRequire("b6IL4");
/**
 * <p>Encapsulates the result of decoding a barcode within an image.</p>
 *
 * @author Sean Owen
 */ var $f3eb3ce3feb0213d$var$Result = /** @class */ function() {
    // public constructor(private text: string,
    //               Uint8Array rawBytes,
    //               ResultPoconst resultPoints: Int32Array,
    //               BarcodeFormat format) {
    //   this(text, rawBytes, resultPoints, format, System.currentTimeMillis())
    // }
    // public constructor(text: string,
    //               Uint8Array rawBytes,
    //               ResultPoconst resultPoints: Int32Array,
    //               BarcodeFormat format,
    //               long timestamp) {
    //   this(text, rawBytes, rawBytes == null ? 0 : 8 * rawBytes.length,
    //        resultPoints, format, timestamp)
    // }
    function Result(text, rawBytes, numBits, resultPoints, format, timestamp) {
        if (numBits === void 0) numBits = rawBytes == null ? 0 : 8 * rawBytes.length;
        if (timestamp === void 0) timestamp = (0, $b6IL4.default).currentTimeMillis();
        this.text = text;
        this.rawBytes = rawBytes;
        this.numBits = numBits;
        this.resultPoints = resultPoints;
        this.format = format;
        this.timestamp = timestamp;
        this.text = text;
        this.rawBytes = rawBytes;
        if (undefined === numBits || null === numBits) this.numBits = rawBytes === null || rawBytes === undefined ? 0 : 8 * rawBytes.length;
        else this.numBits = numBits;
        this.resultPoints = resultPoints;
        this.format = format;
        this.resultMetadata = null;
        if (undefined === timestamp || null === timestamp) this.timestamp = (0, $b6IL4.default).currentTimeMillis();
        else this.timestamp = timestamp;
    }
    /**
     * @return raw text encoded by the barcode
     */ Result.prototype.getText = function() {
        return this.text;
    };
    /**
     * @return raw bytes encoded by the barcode, if applicable, otherwise {@code null}
     */ Result.prototype.getRawBytes = function() {
        return this.rawBytes;
    };
    /**
     * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
     * @since 3.3.0
     */ Result.prototype.getNumBits = function() {
        return this.numBits;
    };
    /**
     * @return points related to the barcode in the image. These are typically points
     *         identifying finder patterns or the corners of the barcode. The exact meaning is
     *         specific to the type of barcode that was decoded.
     */ Result.prototype.getResultPoints = function() {
        return this.resultPoints;
    };
    /**
     * @return {@link BarcodeFormat} representing the format of the barcode that was decoded
     */ Result.prototype.getBarcodeFormat = function() {
        return this.format;
    };
    /**
     * @return {@link Map} mapping {@link ResultMetadataType} keys to values. May be
     *   {@code null}. This contains optional metadata about what was detected about the barcode,
     *   like orientation.
     */ Result.prototype.getResultMetadata = function() {
        return this.resultMetadata;
    };
    Result.prototype.putMetadata = function(type, value) {
        if (this.resultMetadata === null) this.resultMetadata = new Map();
        this.resultMetadata.set(type, value);
    };
    Result.prototype.putAllMetadata = function(metadata) {
        if (metadata !== null) {
            if (this.resultMetadata === null) this.resultMetadata = metadata;
            else this.resultMetadata = new Map(metadata);
        }
    };
    Result.prototype.addResultPoints = function(newPoints) {
        var oldPoints = this.resultPoints;
        if (oldPoints === null) this.resultPoints = newPoints;
        else if (newPoints !== null && newPoints.length > 0) {
            var allPoints = new Array(oldPoints.length + newPoints.length);
            (0, $b6IL4.default).arraycopy(oldPoints, 0, allPoints, 0, oldPoints.length);
            (0, $b6IL4.default).arraycopy(newPoints, 0, allPoints, oldPoints.length, newPoints.length);
            this.resultPoints = allPoints;
        }
    };
    Result.prototype.getTimestamp = function() {
        return this.timestamp;
    };
    /*@Override*/ Result.prototype.toString = function() {
        return this.text;
    };
    return Result;
}();
var $f3eb3ce3feb0213d$export$2e2bcd8739ae039 = $f3eb3ce3feb0213d$var$Result;

});

parcelRegister("bx5V3", function(module, exports) {

$parcel$export(module.exports, "default", () => $86575e37895ad7e2$export$2e2bcd8739ae039);
/*
 * Direct port to TypeScript of ZXing by Adrian Toșcă
 */ /*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ /**
 * Enumerates barcode formats known to this package. Please keep alphabetized.
 *
 * @author Sean Owen
 */ var $86575e37895ad7e2$var$BarcodeFormat;
(function(BarcodeFormat) {
    /** Aztec 2D barcode format. */ BarcodeFormat[BarcodeFormat["AZTEC"] = 0] = "AZTEC";
    /** CODABAR 1D format. */ BarcodeFormat[BarcodeFormat["CODABAR"] = 1] = "CODABAR";
    /** Code 39 1D format. */ BarcodeFormat[BarcodeFormat["CODE_39"] = 2] = "CODE_39";
    /** Code 93 1D format. */ BarcodeFormat[BarcodeFormat["CODE_93"] = 3] = "CODE_93";
    /** Code 128 1D format. */ BarcodeFormat[BarcodeFormat["CODE_128"] = 4] = "CODE_128";
    /** Data Matrix 2D barcode format. */ BarcodeFormat[BarcodeFormat["DATA_MATRIX"] = 5] = "DATA_MATRIX";
    /** EAN-8 1D format. */ BarcodeFormat[BarcodeFormat["EAN_8"] = 6] = "EAN_8";
    /** EAN-13 1D format. */ BarcodeFormat[BarcodeFormat["EAN_13"] = 7] = "EAN_13";
    /** ITF (Interleaved Two of Five) 1D format. */ BarcodeFormat[BarcodeFormat["ITF"] = 8] = "ITF";
    /** MaxiCode 2D barcode format. */ BarcodeFormat[BarcodeFormat["MAXICODE"] = 9] = "MAXICODE";
    /** PDF417 format. */ BarcodeFormat[BarcodeFormat["PDF_417"] = 10] = "PDF_417";
    /** QR Code 2D barcode format. */ BarcodeFormat[BarcodeFormat["QR_CODE"] = 11] = "QR_CODE";
    /** RSS 14 */ BarcodeFormat[BarcodeFormat["RSS_14"] = 12] = "RSS_14";
    /** RSS EXPANDED */ BarcodeFormat[BarcodeFormat["RSS_EXPANDED"] = 13] = "RSS_EXPANDED";
    /** UPC-A 1D format. */ BarcodeFormat[BarcodeFormat["UPC_A"] = 14] = "UPC_A";
    /** UPC-E 1D format. */ BarcodeFormat[BarcodeFormat["UPC_E"] = 15] = "UPC_E";
    /** UPC/EAN extension format. Not a stand-alone format. */ BarcodeFormat[BarcodeFormat["UPC_EAN_EXTENSION"] = 16] = "UPC_EAN_EXTENSION";
})($86575e37895ad7e2$var$BarcodeFormat || ($86575e37895ad7e2$var$BarcodeFormat = {}));
var $86575e37895ad7e2$export$2e2bcd8739ae039 = $86575e37895ad7e2$var$BarcodeFormat;

});

parcelRegister("eS8qc", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad3ca42f4aadb430$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ /**
 * Represents some type of metadata about the result of the decoding that the decoder
 * wishes to communicate back to the caller.
 *
 * @author Sean Owen
 */ var $ad3ca42f4aadb430$var$ResultMetadataType;
(function(ResultMetadataType) {
    /**
     * Unspecified, application-specific metadata. Maps to an unspecified {@link Object}.
     */ ResultMetadataType[ResultMetadataType["OTHER"] = 0] = "OTHER";
    /**
     * Denotes the likely approximate orientation of the barcode in the image. This value
     * is given as degrees rotated clockwise from the normal, upright orientation.
     * For example a 1D barcode which was found by reading top-to-bottom would be
     * said to have orientation "90". This key maps to an {@link Integer} whose
     * value is in the range [0,360).
     */ ResultMetadataType[ResultMetadataType["ORIENTATION"] = 1] = "ORIENTATION";
    /**
     * <p>2D barcode formats typically encode text, but allow for a sort of 'byte mode'
     * which is sometimes used to encode binary data. While {@link Result} makes available
     * the complete raw bytes in the barcode for these formats, it does not offer the bytes
     * from the byte segments alone.</p>
     *
     * <p>This maps to a {@link java.util.List} of byte arrays corresponding to the
     * raw bytes in the byte segments in the barcode, in order.</p>
     */ ResultMetadataType[ResultMetadataType["BYTE_SEGMENTS"] = 2] = "BYTE_SEGMENTS";
    /**
     * Error correction level used, if applicable. The value type depends on the
     * format, but is typically a String.
     */ ResultMetadataType[ResultMetadataType["ERROR_CORRECTION_LEVEL"] = 3] = "ERROR_CORRECTION_LEVEL";
    /**
     * For some periodicals, indicates the issue number as an {@link Integer}.
     */ ResultMetadataType[ResultMetadataType["ISSUE_NUMBER"] = 4] = "ISSUE_NUMBER";
    /**
     * For some products, indicates the suggested retail price in the barcode as a
     * formatted {@link String}.
     */ ResultMetadataType[ResultMetadataType["SUGGESTED_PRICE"] = 5] = "SUGGESTED_PRICE";
    /**
     * For some products, the possible country of manufacture as a {@link String} denoting the
     * ISO country code. Some map to multiple possible countries, like "US/CA".
     */ ResultMetadataType[ResultMetadataType["POSSIBLE_COUNTRY"] = 6] = "POSSIBLE_COUNTRY";
    /**
     * For some products, the extension text
     */ ResultMetadataType[ResultMetadataType["UPC_EAN_EXTENSION"] = 7] = "UPC_EAN_EXTENSION";
    /**
     * PDF417-specific metadata
     */ ResultMetadataType[ResultMetadataType["PDF417_EXTRA_METADATA"] = 8] = "PDF417_EXTRA_METADATA";
    /**
     * If the code format supports structured append and the current scanned code is part of one then the
     * sequence number is given with it.
     */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_SEQUENCE"] = 9] = "STRUCTURED_APPEND_SEQUENCE";
    /**
     * If the code format supports structured append and the current scanned code is part of one then the
     * parity is given with it.
     */ ResultMetadataType[ResultMetadataType["STRUCTURED_APPEND_PARITY"] = 10] = "STRUCTURED_APPEND_PARITY";
})($ad3ca42f4aadb430$var$ResultMetadataType || ($ad3ca42f4aadb430$var$ResultMetadataType = {}));
var $ad3ca42f4aadb430$export$2e2bcd8739ae039 = $ad3ca42f4aadb430$var$ResultMetadataType;

});

parcelRegister("e3wFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3bab01eebcdd9e1$export$2e2bcd8739ae039);
/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jpf17 = parcelRequire("jpf17");

var $7nLua = parcelRequire("7nLua");

var $f5xTf = parcelRequire("f5xTf");

var $amwnq = parcelRequire("amwnq");

var $dtgr5 = parcelRequire("dtgr5");

var $7mB9T = parcelRequire("7mB9T");

var $hcAg4 = parcelRequire("hcAg4");
// import java.util.Arrays;
var $a3bab01eebcdd9e1$var$Table;
(function(Table) {
    Table[Table["UPPER"] = 0] = "UPPER";
    Table[Table["LOWER"] = 1] = "LOWER";
    Table[Table["MIXED"] = 2] = "MIXED";
    Table[Table["DIGIT"] = 3] = "DIGIT";
    Table[Table["PUNCT"] = 4] = "PUNCT";
    Table[Table["BINARY"] = 5] = "BINARY";
})($a3bab01eebcdd9e1$var$Table || ($a3bab01eebcdd9e1$var$Table = {}));
/**
 * <p>The main class which implements Aztec Code decoding -- as opposed to locating and extracting
 * the Aztec Code from an image.</p>
 *
 * @author David Olivier
 */ var $a3bab01eebcdd9e1$var$Decoder = /** @class */ function() {
    function Decoder() {}
    Decoder.prototype.decode = function(detectorResult) {
        this.ddata = detectorResult;
        var matrix = detectorResult.getBits();
        var rawbits = this.extractBits(matrix);
        var correctedBits = this.correctBits(rawbits);
        var rawBytes = Decoder.convertBoolArrayToByteArray(correctedBits);
        var result = Decoder.getEncodedData(correctedBits);
        var decoderResult = new (0, $jpf17.default)(rawBytes, result, null, null);
        decoderResult.setNumBits(correctedBits.length);
        return decoderResult;
    };
    // This method is used for testing the high-level encoder
    Decoder.highLevelDecode = function(correctedBits) {
        return this.getEncodedData(correctedBits);
    };
    /**
     * Gets the string encoded in the aztec code bits
     *
     * @return the decoded string
     */ Decoder.getEncodedData = function(correctedBits) {
        var endIndex = correctedBits.length;
        var latchTable = $a3bab01eebcdd9e1$var$Table.UPPER; // table most recently latched to
        var shiftTable = $a3bab01eebcdd9e1$var$Table.UPPER; // table to use for the next read
        var result = "";
        var index = 0;
        while(index < endIndex)if (shiftTable === $a3bab01eebcdd9e1$var$Table.BINARY) {
            if (endIndex - index < 5) break;
            var length_1 = Decoder.readCode(correctedBits, index, 5);
            index += 5;
            if (length_1 === 0) {
                if (endIndex - index < 11) break;
                length_1 = Decoder.readCode(correctedBits, index, 11) + 31;
                index += 11;
            }
            for(var charCount = 0; charCount < length_1; charCount++){
                if (endIndex - index < 8) {
                    index = endIndex; // Force outer loop to exit
                    break;
                }
                var code = Decoder.readCode(correctedBits, index, 8);
                result += /*(char)*/ (0, $7mB9T.default).castAsNonUtf8Char(code);
                index += 8;
            }
            // Go back to whatever mode we had been in
            shiftTable = latchTable;
        } else {
            var size = shiftTable === $a3bab01eebcdd9e1$var$Table.DIGIT ? 4 : 5;
            if (endIndex - index < size) break;
            var code = Decoder.readCode(correctedBits, index, size);
            index += size;
            var str = Decoder.getCharacter(shiftTable, code);
            if (str.startsWith("CTRL_")) {
                // Table changes
                // ISO/IEC 24778:2008 prescribes ending a shift sequence in the mode from which it was invoked.
                // That's including when that mode is a shift.
                // Our test case dlusbs.png for issue #642 exercises that.
                latchTable = shiftTable; // Latch the current mode, so as to return to Upper after U/S B/S
                shiftTable = Decoder.getTable(str.charAt(5));
                if (str.charAt(6) === "L") latchTable = shiftTable;
            } else {
                result += str;
                // Go back to whatever mode we had been in
                shiftTable = latchTable;
            }
        }
        return result;
    };
    /**
     * gets the table corresponding to the char passed
     */ Decoder.getTable = function(t) {
        switch(t){
            case "L":
                return $a3bab01eebcdd9e1$var$Table.LOWER;
            case "P":
                return $a3bab01eebcdd9e1$var$Table.PUNCT;
            case "M":
                return $a3bab01eebcdd9e1$var$Table.MIXED;
            case "D":
                return $a3bab01eebcdd9e1$var$Table.DIGIT;
            case "B":
                return $a3bab01eebcdd9e1$var$Table.BINARY;
            case "U":
            default:
                return $a3bab01eebcdd9e1$var$Table.UPPER;
        }
    };
    /**
     * Gets the character (or string) corresponding to the passed code in the given table
     *
     * @param table the table used
     * @param code the code of the character
     */ Decoder.getCharacter = function(table, code) {
        switch(table){
            case $a3bab01eebcdd9e1$var$Table.UPPER:
                return Decoder.UPPER_TABLE[code];
            case $a3bab01eebcdd9e1$var$Table.LOWER:
                return Decoder.LOWER_TABLE[code];
            case $a3bab01eebcdd9e1$var$Table.MIXED:
                return Decoder.MIXED_TABLE[code];
            case $a3bab01eebcdd9e1$var$Table.PUNCT:
                return Decoder.PUNCT_TABLE[code];
            case $a3bab01eebcdd9e1$var$Table.DIGIT:
                return Decoder.DIGIT_TABLE[code];
            default:
                // Should not reach here.
                throw new (0, $amwnq.default)("Bad table");
        }
    };
    /**
     * <p>Performs RS error correction on an array of bits.</p>
     *
     * @return the corrected array
     * @throws FormatException if the input contains too many errors
     */ Decoder.prototype.correctBits = function(rawbits) {
        var gf;
        var codewordSize;
        if (this.ddata.getNbLayers() <= 2) {
            codewordSize = 6;
            gf = (0, $7nLua.default).AZTEC_DATA_6;
        } else if (this.ddata.getNbLayers() <= 8) {
            codewordSize = 8;
            gf = (0, $7nLua.default).AZTEC_DATA_8;
        } else if (this.ddata.getNbLayers() <= 22) {
            codewordSize = 10;
            gf = (0, $7nLua.default).AZTEC_DATA_10;
        } else {
            codewordSize = 12;
            gf = (0, $7nLua.default).AZTEC_DATA_12;
        }
        var numDataCodewords = this.ddata.getNbDatablocks();
        var numCodewords = rawbits.length / codewordSize;
        if (numCodewords < numDataCodewords) throw new (0, $dtgr5.default)();
        var offset = rawbits.length % codewordSize;
        var dataWords = new Int32Array(numCodewords);
        for(var i = 0; i < numCodewords; i++, offset += codewordSize)dataWords[i] = Decoder.readCode(rawbits, offset, codewordSize);
        try {
            var rsDecoder = new (0, $f5xTf.default)(gf);
            rsDecoder.decode(dataWords, numCodewords - numDataCodewords);
        } catch (ex) {
            throw new (0, $dtgr5.default)(ex);
        }
        // Now perform the unstuffing operation.
        // First, count how many bits are going to be thrown out as stuffing
        var mask = (1 << codewordSize) - 1;
        var stuffedBits = 0;
        for(var i = 0; i < numDataCodewords; i++){
            var dataWord = dataWords[i];
            if (dataWord === 0 || dataWord === mask) throw new (0, $dtgr5.default)();
            else if (dataWord === 1 || dataWord === mask - 1) stuffedBits++;
        }
        // Now, actually unpack the bits and remove the stuffing
        var correctedBits = new Array(numDataCodewords * codewordSize - stuffedBits);
        var index = 0;
        for(var i = 0; i < numDataCodewords; i++){
            var dataWord = dataWords[i];
            if (dataWord === 1 || dataWord === mask - 1) {
                // next codewordSize-1 bits are all zeros or all ones
                correctedBits.fill(dataWord > 1, index, index + codewordSize - 1);
                // Arrays.fill(correctedBits, index, index + codewordSize - 1, dataWord > 1);
                index += codewordSize - 1;
            } else for(var bit = codewordSize - 1; bit >= 0; --bit)correctedBits[index++] = (dataWord & 1 << bit) !== 0;
        }
        return correctedBits;
    };
    /**
     * Gets the array of bits from an Aztec Code matrix
     *
     * @return the array of bits
     */ Decoder.prototype.extractBits = function(matrix) {
        var compact = this.ddata.isCompact();
        var layers = this.ddata.getNbLayers();
        var baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
        var alignmentMap = new Int32Array(baseMatrixSize);
        var rawbits = new Array(this.totalBitsInLayer(layers, compact));
        if (compact) for(var i = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
        else {
            var matrixSize = baseMatrixSize + 1 + 2 * (0, $hcAg4.default).truncDivision((0, $hcAg4.default).truncDivision(baseMatrixSize, 2) - 1, 15);
            var origCenter = baseMatrixSize / 2;
            var center = (0, $hcAg4.default).truncDivision(matrixSize, 2);
            for(var i = 0; i < origCenter; i++){
                var newOffset = i + (0, $hcAg4.default).truncDivision(i, 15);
                alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                alignmentMap[origCenter + i] = center + newOffset + 1;
            }
        }
        for(var i = 0, rowOffset = 0; i < layers; i++){
            var rowSize = (layers - i) * 4 + (compact ? 9 : 12);
            // The top-left most point of this layer is <low, low> (not including alignment lines)
            var low = i * 2;
            // The bottom-right most point of this layer is <high, high> (not including alignment lines)
            var high = baseMatrixSize - 1 - low;
            // We pull bits from the two 2 x rowSize columns and two rowSize x 2 rows
            for(var j = 0; j < rowSize; j++){
                var columnOffset = j * 2;
                for(var k = 0; k < 2; k++){
                    // left column
                    rawbits[rowOffset + columnOffset + k] = matrix.get(alignmentMap[low + k], alignmentMap[low + j]);
                    // bottom row
                    rawbits[rowOffset + 2 * rowSize + columnOffset + k] = matrix.get(alignmentMap[low + j], alignmentMap[high - k]);
                    // right column
                    rawbits[rowOffset + 4 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - k], alignmentMap[high - j]);
                    // top row
                    rawbits[rowOffset + 6 * rowSize + columnOffset + k] = matrix.get(alignmentMap[high - j], alignmentMap[low + k]);
                }
            }
            rowOffset += rowSize * 8;
        }
        return rawbits;
    };
    /**
     * Reads a code of given length and at given index in an array of bits
     */ Decoder.readCode = function(rawbits, startIndex, length) {
        var res = 0;
        for(var i = startIndex; i < startIndex + length; i++){
            res <<= 1;
            if (rawbits[i]) res |= 0x01;
        }
        return res;
    };
    /**
     * Reads a code of length 8 in an array of bits, padding with zeros
     */ Decoder.readByte = function(rawbits, startIndex) {
        var n = rawbits.length - startIndex;
        if (n >= 8) return Decoder.readCode(rawbits, startIndex, 8);
        return Decoder.readCode(rawbits, startIndex, n) << 8 - n;
    };
    /**
     * Packs a bit array into bytes, most significant bit first
     */ Decoder.convertBoolArrayToByteArray = function(boolArr) {
        var byteArr = new Uint8Array((boolArr.length + 7) / 8);
        for(var i = 0; i < byteArr.length; i++)byteArr[i] = Decoder.readByte(boolArr, 8 * i);
        return byteArr;
    };
    Decoder.prototype.totalBitsInLayer = function(layers, compact) {
        return ((compact ? 88 : 112) + 16 * layers) * layers;
    };
    Decoder.UPPER_TABLE = [
        "CTRL_PS",
        " ",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "CTRL_LL",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ];
    Decoder.LOWER_TABLE = [
        "CTRL_PS",
        " ",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "CTRL_US",
        "CTRL_ML",
        "CTRL_DL",
        "CTRL_BS"
    ];
    Decoder.MIXED_TABLE = [
        "CTRL_PS",
        " ",
        "\x01",
        "\x02",
        "\x03",
        "\x04",
        "\x05",
        "\x06",
        "\x07",
        "\b",
        "	",
        "\n",
        "\v",
        "\f",
        "\r",
        "\x1b",
        "\x1c",
        "\x1d",
        "\x1e",
        "\x1f",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\x7f",
        "CTRL_LL",
        "CTRL_UL",
        "CTRL_PL",
        "CTRL_BS"
    ];
    Decoder.PUNCT_TABLE = [
        "",
        "\r",
        "\r\n",
        ". ",
        ", ",
        ": ",
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}",
        "CTRL_UL"
    ];
    Decoder.DIGIT_TABLE = [
        "CTRL_PS",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        ",",
        ".",
        "CTRL_UL",
        "CTRL_US"
    ];
    return Decoder;
}();
var $a3bab01eebcdd9e1$export$2e2bcd8739ae039 = $a3bab01eebcdd9e1$var$Decoder;

});
parcelRegister("jpf17", function(module, exports) {

$parcel$export(module.exports, "default", () => $e20c002fe2754068$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /*import java.util.List;*/ /**
 * <p>Encapsulates the result of decoding a matrix of bits. This typically
 * applies to 2D barcode formats. For now it contains the raw bytes obtained,
 * as well as a String interpretation of those bytes, if applicable.</p>
 *
 * @author Sean Owen
 */ var $e20c002fe2754068$var$DecoderResult = /** @class */ function() {
    // public constructor(rawBytes: Uint8Array,
    //                      text: string,
    //                      List<Uint8Array> byteSegments,
    //                      String ecLevel) {
    //   this(rawBytes, text, byteSegments, ecLevel, -1, -1)
    // }
    function DecoderResult(rawBytes, text, byteSegments, ecLevel, structuredAppendSequenceNumber, structuredAppendParity) {
        if (structuredAppendSequenceNumber === void 0) structuredAppendSequenceNumber = -1;
        if (structuredAppendParity === void 0) structuredAppendParity = -1;
        this.rawBytes = rawBytes;
        this.text = text;
        this.byteSegments = byteSegments;
        this.ecLevel = ecLevel;
        this.structuredAppendSequenceNumber = structuredAppendSequenceNumber;
        this.structuredAppendParity = structuredAppendParity;
        this.numBits = rawBytes === undefined || rawBytes === null ? 0 : 8 * rawBytes.length;
    }
    /**
     * @return raw bytes representing the result, or {@code null} if not applicable
     */ DecoderResult.prototype.getRawBytes = function() {
        return this.rawBytes;
    };
    /**
     * @return how many bits of {@link #getRawBytes()} are valid; typically 8 times its length
     * @since 3.3.0
     */ DecoderResult.prototype.getNumBits = function() {
        return this.numBits;
    };
    /**
     * @param numBits overrides the number of bits that are valid in {@link #getRawBytes()}
     * @since 3.3.0
     */ DecoderResult.prototype.setNumBits = function(numBits /*int*/ ) {
        this.numBits = numBits;
    };
    /**
     * @return text representation of the result
     */ DecoderResult.prototype.getText = function() {
        return this.text;
    };
    /**
     * @return list of byte segments in the result, or {@code null} if not applicable
     */ DecoderResult.prototype.getByteSegments = function() {
        return this.byteSegments;
    };
    /**
     * @return name of error correction level used, or {@code null} if not applicable
     */ DecoderResult.prototype.getECLevel = function() {
        return this.ecLevel;
    };
    /**
     * @return number of errors corrected, or {@code null} if not applicable
     */ DecoderResult.prototype.getErrorsCorrected = function() {
        return this.errorsCorrected;
    };
    DecoderResult.prototype.setErrorsCorrected = function(errorsCorrected /*Integer*/ ) {
        this.errorsCorrected = errorsCorrected;
    };
    /**
     * @return number of erasures corrected, or {@code null} if not applicable
     */ DecoderResult.prototype.getErasures = function() {
        return this.erasures;
    };
    DecoderResult.prototype.setErasures = function(erasures /*Integer*/ ) {
        this.erasures = erasures;
    };
    /**
     * @return arbitrary additional metadata
     */ DecoderResult.prototype.getOther = function() {
        return this.other;
    };
    DecoderResult.prototype.setOther = function(other) {
        this.other = other;
    };
    DecoderResult.prototype.hasStructuredAppend = function() {
        return this.structuredAppendParity >= 0 && this.structuredAppendSequenceNumber >= 0;
    };
    DecoderResult.prototype.getStructuredAppendParity = function() {
        return this.structuredAppendParity;
    };
    DecoderResult.prototype.getStructuredAppendSequenceNumber = function() {
        return this.structuredAppendSequenceNumber;
    };
    return DecoderResult;
}();
var $e20c002fe2754068$export$2e2bcd8739ae039 = $e20c002fe2754068$var$DecoderResult;

});

parcelRegister("7nLua", function(module, exports) {

$parcel$export(module.exports, "default", () => $55ff840becbc3e71$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4v5ZZ = parcelRequire("4v5ZZ");

var $3Wcyo = parcelRequire("3Wcyo");

var $hcAg4 = parcelRequire("hcAg4");

var $kLpae = parcelRequire("kLpae");

var $72EX6 = parcelRequire("72EX6");
var $55ff840becbc3e71$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>This class contains utility methods for performing mathematical operations over
 * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
 *
 * <p>Throughout this package, elements of the GF are represented as an {@code int}
 * for convenience and speed (but at the cost of memory).
 * </p>
 *
 * @author Sean Owen
 * @author David Olivier
 */ var $55ff840becbc3e71$var$GenericGF = /** @class */ function(_super) {
    $55ff840becbc3e71$var$__extends(GenericGF, _super);
    /**
     * Create a representation of GF(size) using the given primitive polynomial.
     *
     * @param primitive irreducible polynomial whose coefficients are represented by
     *  the bits of an int, where the least-significant bit represents the constant
     *  coefficient
     * @param size the size of the field
     * @param b the factor b in the generator polynomial can be 0- or 1-based
     *  (g(x) = (x+a^b)(x+a^(b+1))...(x+a^(b+2t-1))).
     *  In most cases it should be 1, but for QR code it is 0.
     */ function GenericGF(primitive /*int*/ , size /*int*/ , generatorBase /*int*/ ) {
        var _this = _super.call(this) || this;
        _this.primitive = primitive;
        _this.size = size;
        _this.generatorBase = generatorBase;
        var expTable = new Int32Array(size);
        var x = 1;
        for(var i = 0; i < size; i++){
            expTable[i] = x;
            x *= 2; // we're assuming the generator alpha is 2
            if (x >= size) {
                x ^= primitive;
                x &= size - 1;
            }
        }
        _this.expTable = expTable;
        var logTable = new Int32Array(size);
        for(var i = 0; i < size - 1; i++)logTable[expTable[i]] = i;
        _this.logTable = logTable;
        // logTable[0] == 0 but this should never be used
        _this.zero = new (0, $4v5ZZ.default)(_this, Int32Array.from([
            0
        ]));
        _this.one = new (0, $4v5ZZ.default)(_this, Int32Array.from([
            1
        ]));
        return _this;
    }
    GenericGF.prototype.getZero = function() {
        return this.zero;
    };
    GenericGF.prototype.getOne = function() {
        return this.one;
    };
    /**
     * @return the monomial representing coefficient * x^degree
     */ GenericGF.prototype.buildMonomial = function(degree /*int*/ , coefficient /*int*/ ) {
        if (degree < 0) throw new (0, $kLpae.default)();
        if (coefficient === 0) return this.zero;
        var coefficients = new Int32Array(degree + 1);
        coefficients[0] = coefficient;
        return new (0, $4v5ZZ.default)(this, coefficients);
    };
    /**
     * @return multiplicative inverse of a
     */ GenericGF.prototype.inverse = function(a /*int*/ ) {
        if (a === 0) throw new (0, $72EX6.default)();
        return this.expTable[this.size - this.logTable[a] - 1];
    };
    /**
     * @return product of a and b in GF(size)
     */ GenericGF.prototype.multiply = function(a /*int*/ , b /*int*/ ) {
        if (a === 0 || b === 0) return 0;
        return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
    };
    GenericGF.prototype.getSize = function() {
        return this.size;
    };
    GenericGF.prototype.getGeneratorBase = function() {
        return this.generatorBase;
    };
    /*@Override*/ GenericGF.prototype.toString = function() {
        return "GF(0x" + (0, $hcAg4.default).toHexString(this.primitive) + "," + this.size + ")";
    };
    GenericGF.prototype.equals = function(o) {
        return o === this;
    };
    GenericGF.AZTEC_DATA_12 = new GenericGF(0x1069, 4096, 1); // x^12 + x^6 + x^5 + x^3 + 1
    GenericGF.AZTEC_DATA_10 = new GenericGF(0x409, 1024, 1); // x^10 + x^3 + 1
    GenericGF.AZTEC_DATA_6 = new GenericGF(0x43, 64, 1); // x^6 + x + 1
    GenericGF.AZTEC_PARAM = new GenericGF(0x13, 16, 1); // x^4 + x + 1
    GenericGF.QR_CODE_FIELD_256 = new GenericGF(0x011d, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
    GenericGF.DATA_MATRIX_FIELD_256 = new GenericGF(0x012d, 256, 1); // x^8 + x^5 + x^3 + x^2 + 1
    GenericGF.AZTEC_DATA_8 = GenericGF.DATA_MATRIX_FIELD_256;
    GenericGF.MAXICODE_FIELD_64 = GenericGF.AZTEC_DATA_6;
    return GenericGF;
}((0, $3Wcyo.default));
var $55ff840becbc3e71$export$2e2bcd8739ae039 = $55ff840becbc3e71$var$GenericGF;

});
parcelRegister("4v5ZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $346eb5ee83c8cd07$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common.reedsolomon {*/ 
var $3Wcyo = parcelRequire("3Wcyo");

var $b6IL4 = parcelRequire("b6IL4");

var $kLpae = parcelRequire("kLpae");
/**
 * <p>Represents a polynomial whose coefficients are elements of a GF.
 * Instances of this class are immutable.</p>
 *
 * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
 * port of his C++ Reed-Solomon implementation.</p>
 *
 * @author Sean Owen
 */ var $346eb5ee83c8cd07$var$GenericGFPoly = /** @class */ function() {
    /**
     * @param field the {@link GenericGF} instance representing the field to use
     * to perform computations
     * @param coefficients coefficients as ints representing elements of GF(size), arranged
     * from most significant (highest-power term) coefficient to least significant
     * @throws IllegalArgumentException if argument is null or empty,
     * or if leading coefficient is 0 and this is not a
     * constant polynomial (that is, it is not the monomial "0")
     */ function GenericGFPoly(field, coefficients) {
        if (coefficients.length === 0) throw new (0, $kLpae.default)();
        this.field = field;
        var coefficientsLength = coefficients.length;
        if (coefficientsLength > 1 && coefficients[0] === 0) {
            // Leading term must be non-zero for anything except the constant polynomial "0"
            var firstNonZero = 1;
            while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
            if (firstNonZero === coefficientsLength) this.coefficients = Int32Array.from([
                0
            ]);
            else {
                this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                (0, $b6IL4.default).arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
            }
        } else this.coefficients = coefficients;
    }
    GenericGFPoly.prototype.getCoefficients = function() {
        return this.coefficients;
    };
    /**
     * @return degree of this polynomial
     */ GenericGFPoly.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    };
    /**
     * @return true iff this polynomial is the monomial "0"
     */ GenericGFPoly.prototype.isZero = function() {
        return this.coefficients[0] === 0;
    };
    /**
     * @return coefficient of x^degree term in this polynomial
     */ GenericGFPoly.prototype.getCoefficient = function(degree /*int*/ ) {
        return this.coefficients[this.coefficients.length - 1 - degree];
    };
    /**
     * @return evaluation of this polynomial at a given point
     */ GenericGFPoly.prototype.evaluateAt = function(a /*int*/ ) {
        if (a === 0) // Just return the x^0 coefficient
        return this.getCoefficient(0);
        var coefficients = this.coefficients;
        var result;
        if (a === 1) {
            // Just the sum of the coefficients
            result = 0;
            for(var i = 0, length_1 = coefficients.length; i !== length_1; i++){
                var coefficient = coefficients[i];
                result = (0, $3Wcyo.default).addOrSubtract(result, coefficient);
            }
            return result;
        }
        result = coefficients[0];
        var size = coefficients.length;
        var field = this.field;
        for(var i = 1; i < size; i++)result = (0, $3Wcyo.default).addOrSubtract(field.multiply(a, result), coefficients[i]);
        return result;
    };
    GenericGFPoly.prototype.addOrSubtract = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $kLpae.default)("GenericGFPolys do not have same GenericGF field");
        if (this.isZero()) return other;
        if (other.isZero()) return this;
        var smallerCoefficients = this.coefficients;
        var largerCoefficients = other.coefficients;
        if (smallerCoefficients.length > largerCoefficients.length) {
            var temp = smallerCoefficients;
            smallerCoefficients = largerCoefficients;
            largerCoefficients = temp;
        }
        var sumDiff = new Int32Array(largerCoefficients.length);
        var lengthDiff = largerCoefficients.length - smallerCoefficients.length;
        // Copy high-order terms only found in higher-degree polynomial's coefficients
        (0, $b6IL4.default).arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
        for(var i = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = (0, $3Wcyo.default).addOrSubtract(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
        return new GenericGFPoly(this.field, sumDiff);
    };
    GenericGFPoly.prototype.multiply = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $kLpae.default)("GenericGFPolys do not have same GenericGF field");
        if (this.isZero() || other.isZero()) return this.field.getZero();
        var aCoefficients = this.coefficients;
        var aLength = aCoefficients.length;
        var bCoefficients = other.coefficients;
        var bLength = bCoefficients.length;
        var product = new Int32Array(aLength + bLength - 1);
        var field = this.field;
        for(var i = 0; i < aLength; i++){
            var aCoeff = aCoefficients[i];
            for(var j = 0; j < bLength; j++)product[i + j] = (0, $3Wcyo.default).addOrSubtract(product[i + j], field.multiply(aCoeff, bCoefficients[j]));
        }
        return new GenericGFPoly(field, product);
    };
    GenericGFPoly.prototype.multiplyScalar = function(scalar /*int*/ ) {
        if (scalar === 0) return this.field.getZero();
        if (scalar === 1) return this;
        var size = this.coefficients.length;
        var field = this.field;
        var product = new Int32Array(size);
        var coefficients = this.coefficients;
        for(var i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], scalar);
        return new GenericGFPoly(field, product);
    };
    GenericGFPoly.prototype.multiplyByMonomial = function(degree /*int*/ , coefficient /*int*/ ) {
        if (degree < 0) throw new (0, $kLpae.default)();
        if (coefficient === 0) return this.field.getZero();
        var coefficients = this.coefficients;
        var size = coefficients.length;
        var product = new Int32Array(size + degree);
        var field = this.field;
        for(var i = 0; i < size; i++)product[i] = field.multiply(coefficients[i], coefficient);
        return new GenericGFPoly(field, product);
    };
    GenericGFPoly.prototype.divide = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $kLpae.default)("GenericGFPolys do not have same GenericGF field");
        if (other.isZero()) throw new (0, $kLpae.default)("Divide by 0");
        var field = this.field;
        var quotient = field.getZero();
        var remainder = this;
        var denominatorLeadingTerm = other.getCoefficient(other.getDegree());
        var inverseDenominatorLeadingTerm = field.inverse(denominatorLeadingTerm);
        while(remainder.getDegree() >= other.getDegree() && !remainder.isZero()){
            var degreeDifference = remainder.getDegree() - other.getDegree();
            var scale = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
            var term = other.multiplyByMonomial(degreeDifference, scale);
            var iterationQuotient = field.buildMonomial(degreeDifference, scale);
            quotient = quotient.addOrSubtract(iterationQuotient);
            remainder = remainder.addOrSubtract(term);
        }
        return [
            quotient,
            remainder
        ];
    };
    /*@Override*/ GenericGFPoly.prototype.toString = function() {
        var result = "";
        for(var degree = this.getDegree(); degree >= 0; degree--){
            var coefficient = this.getCoefficient(degree);
            if (coefficient !== 0) {
                if (coefficient < 0) {
                    result += " - ";
                    coefficient = -coefficient;
                } else if (result.length > 0) result += " + ";
                if (degree === 0 || coefficient !== 1) {
                    var alphaPower = this.field.log(coefficient);
                    if (alphaPower === 0) result += "1";
                    else if (alphaPower === 1) result += "a";
                    else {
                        result += "a^";
                        result += alphaPower;
                    }
                }
                if (degree !== 0) {
                    if (degree === 1) result += "x";
                    else {
                        result += "x^";
                        result += degree;
                    }
                }
            }
        }
        return result;
    };
    return GenericGFPoly;
}();
var $346eb5ee83c8cd07$export$2e2bcd8739ae039 = $346eb5ee83c8cd07$var$GenericGFPoly;

});
parcelRegister("3Wcyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de086c87a1724ed$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kLpae = parcelRequire("kLpae");
/**
 * <p>This class contains utility methods for performing mathematical operations over
 * the Galois Fields. Operations use a given primitive polynomial in calculations.</p>
 *
 * <p>Throughout this package, elements of the GF are represented as an {@code int}
 * for convenience and speed (but at the cost of memory).
 * </p>
 *
 * @author Sean Owen
 * @author David Olivier
 */ var $2de086c87a1724ed$var$AbstractGenericGF = /** @class */ function() {
    function AbstractGenericGF() {}
    /**
     * @return 2 to the power of a in GF(size)
     */ AbstractGenericGF.prototype.exp = function(a) {
        return this.expTable[a];
    };
    /**
     * @return base 2 log of a in GF(size)
     */ AbstractGenericGF.prototype.log = function(a /*int*/ ) {
        if (a === 0) throw new (0, $kLpae.default)();
        return this.logTable[a];
    };
    /**
     * Implements both addition and subtraction -- they are the same in GF(size).
     *
     * @return sum/difference of a and b
     */ AbstractGenericGF.addOrSubtract = function(a /*int*/ , b /*int*/ ) {
        return a ^ b;
    };
    return AbstractGenericGF;
}();
var $2de086c87a1724ed$export$2e2bcd8739ae039 = $2de086c87a1724ed$var$AbstractGenericGF;

});


parcelRegister("72EX6", function(module, exports) {

$parcel$export(module.exports, "default", () => $52087c965d0cd4e5$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $52087c965d0cd4e5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $52087c965d0cd4e5$var$ArithmeticException = /** @class */ function(_super) {
    $52087c965d0cd4e5$var$__extends(ArithmeticException, _super);
    function ArithmeticException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ArithmeticException.kind = "ArithmeticException";
    return ArithmeticException;
}((0, $26SD6.default));
var $52087c965d0cd4e5$export$2e2bcd8739ae039 = $52087c965d0cd4e5$var$ArithmeticException;

});


parcelRegister("f5xTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $afc19c7dcc84f895$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common.reedsolomon {*/ 
var $7nLua = parcelRequire("7nLua");

var $4v5ZZ = parcelRequire("4v5ZZ");

var $is5hj = parcelRequire("is5hj");

var $amwnq = parcelRequire("amwnq");
/**
 * <p>Implements Reed-Solomon decoding, as the name implies.</p>
 *
 * <p>The algorithm will not be explained here, but the following references were helpful
 * in creating this implementation:</p>
 *
 * <ul>
 * <li>Bruce Maggs.
 * <a href="http://www.cs.cmu.edu/afs/cs.cmu.edu/project/pscico-guyb/realworld/www/rs_decode.ps">
 * "Decoding Reed-Solomon Codes"</a> (see discussion of Forney's Formula)</li>
 * <li>J.I. Hall. <a href="www.mth.msu.edu/~jhall/classes/codenotes/GRS.pdf">
 * "Chapter 5. Generalized Reed-Solomon Codes"</a>
 * (see discussion of Euclidean algorithm)</li>
 * </ul>
 *
 * <p>Much credit is due to William Rucklidge since portions of this code are an indirect
 * port of his C++ Reed-Solomon implementation.</p>
 *
 * @author Sean Owen
 * @author William Rucklidge
 * @author sanfordsquires
 */ var $afc19c7dcc84f895$var$ReedSolomonDecoder = /** @class */ function() {
    function ReedSolomonDecoder(field) {
        this.field = field;
    }
    /**
     * <p>Decodes given set of received codewords, which include both data and error-correction
     * codewords. Really, this means it uses Reed-Solomon to detect and correct errors, in-place,
     * in the input.</p>
     *
     * @param received data and error-correction codewords
     * @param twoS number of error-correction codewords available
     * @throws ReedSolomonException if decoding fails for any reason
     */ ReedSolomonDecoder.prototype.decode = function(received, twoS /*int*/ ) {
        var field = this.field;
        var poly = new (0, $4v5ZZ.default)(field, received);
        var syndromeCoefficients = new Int32Array(twoS);
        var noError = true;
        for(var i = 0; i < twoS; i++){
            var evalResult = poly.evaluateAt(field.exp(i + field.getGeneratorBase()));
            syndromeCoefficients[syndromeCoefficients.length - 1 - i] = evalResult;
            if (evalResult !== 0) noError = false;
        }
        if (noError) return;
        var syndrome = new (0, $4v5ZZ.default)(field, syndromeCoefficients);
        var sigmaOmega = this.runEuclideanAlgorithm(field.buildMonomial(twoS, 1), syndrome, twoS);
        var sigma = sigmaOmega[0];
        var omega = sigmaOmega[1];
        var errorLocations = this.findErrorLocations(sigma);
        var errorMagnitudes = this.findErrorMagnitudes(omega, errorLocations);
        for(var i = 0; i < errorLocations.length; i++){
            var position = received.length - 1 - field.log(errorLocations[i]);
            if (position < 0) throw new (0, $is5hj.default)("Bad error location");
            received[position] = (0, $7nLua.default).addOrSubtract(received[position], errorMagnitudes[i]);
        }
    };
    ReedSolomonDecoder.prototype.runEuclideanAlgorithm = function(a, b, R /*int*/ ) {
        // Assume a's degree is >= b's
        if (a.getDegree() < b.getDegree()) {
            var temp = a;
            a = b;
            b = temp;
        }
        var field = this.field;
        var rLast = a;
        var r = b;
        var tLast = field.getZero();
        var t = field.getOne();
        // Run Euclidean algorithm until r's degree is less than R/2
        while(r.getDegree() >= (R / 2 | 0)){
            var rLastLast = rLast;
            var tLastLast = tLast;
            rLast = r;
            tLast = t;
            // Divide rLastLast by rLast, with quotient in q and remainder in r
            if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
            throw new (0, $is5hj.default)("r_{i-1} was zero");
            r = rLastLast;
            var q = field.getZero();
            var denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
            var dltInverse = field.inverse(denominatorLeadingTerm);
            while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                var degreeDiff = r.getDegree() - rLast.getDegree();
                var scale = field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
                r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
            }
            t = q.multiply(tLast).addOrSubtract(tLastLast);
            if (r.getDegree() >= rLast.getDegree()) throw new (0, $amwnq.default)("Division algorithm failed to reduce polynomial?");
        }
        var sigmaTildeAtZero = t.getCoefficient(0);
        if (sigmaTildeAtZero === 0) throw new (0, $is5hj.default)("sigmaTilde(0) was zero");
        var inverse = field.inverse(sigmaTildeAtZero);
        var sigma = t.multiplyScalar(inverse);
        var omega = r.multiplyScalar(inverse);
        return [
            sigma,
            omega
        ];
    };
    ReedSolomonDecoder.prototype.findErrorLocations = function(errorLocator) {
        // This is a direct application of Chien's search
        var numErrors = errorLocator.getDegree();
        if (numErrors === 1) return Int32Array.from([
            errorLocator.getCoefficient(1)
        ]);
        var result = new Int32Array(numErrors);
        var e = 0;
        var field = this.field;
        for(var i = 1; i < field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
            result[e] = field.inverse(i);
            e++;
        }
        if (e !== numErrors) throw new (0, $is5hj.default)("Error locator degree does not match number of roots");
        return result;
    };
    ReedSolomonDecoder.prototype.findErrorMagnitudes = function(errorEvaluator, errorLocations) {
        // This is directly applying Forney's Formula
        var s = errorLocations.length;
        var result = new Int32Array(s);
        var field = this.field;
        for(var i = 0; i < s; i++){
            var xiInverse = field.inverse(errorLocations[i]);
            var denominator = 1;
            for(var j = 0; j < s; j++)if (i !== j) {
                // denominator = field.multiply(denominator,
                //    GenericGF.addOrSubtract(1, field.multiply(errorLocations[j], xiInverse)))
                // Above should work but fails on some Apple and Linux JDKs due to a Hotspot bug.
                // Below is a funny-looking workaround from Steven Parkes
                var term = field.multiply(errorLocations[j], xiInverse);
                var termPlus1 = (term & 0x1) === 0 ? term | 1 : term & -2;
                denominator = field.multiply(denominator, termPlus1);
            }
            result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
            if (field.getGeneratorBase() !== 0) result[i] = field.multiply(result[i], xiInverse);
        }
        return result;
    };
    return ReedSolomonDecoder;
}();
var $afc19c7dcc84f895$export$2e2bcd8739ae039 = $afc19c7dcc84f895$var$ReedSolomonDecoder;

});
parcelRegister("is5hj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6eeefac8ca48b45$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $d6eeefac8ca48b45$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $d6eeefac8ca48b45$var$ReedSolomonException = /** @class */ function(_super) {
    $d6eeefac8ca48b45$var$__extends(ReedSolomonException, _super);
    function ReedSolomonException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReedSolomonException.kind = "ReedSolomonException";
    return ReedSolomonException;
}((0, $26SD6.default));
var $d6eeefac8ca48b45$export$2e2bcd8739ae039 = $d6eeefac8ca48b45$var$ReedSolomonException;

});

parcelRegister("amwnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $78b512cf522acdbd$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $78b512cf522acdbd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $78b512cf522acdbd$var$IllegalStateException = /** @class */ function(_super) {
    $78b512cf522acdbd$var$__extends(IllegalStateException, _super);
    function IllegalStateException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IllegalStateException.kind = "IllegalStateException";
    return IllegalStateException;
}((0, $26SD6.default));
var $78b512cf522acdbd$export$2e2bcd8739ae039 = $78b512cf522acdbd$var$IllegalStateException;

});



parcelRegister("erHVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a845a8d70f18f25f$export$2e2bcd8739ae039);
/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fwBMA = parcelRequire("fwBMA");

var $8OWED = parcelRequire("8OWED");

var $fbOCK = parcelRequire("fbOCK");

var $jIl78 = parcelRequire("jIl78");

var $7nLua = parcelRequire("7nLua");

var $f5xTf = parcelRequire("f5xTf");

var $cQi30 = parcelRequire("cQi30");

var $5a6kn = parcelRequire("5a6kn");

var $hcAg4 = parcelRequire("hcAg4");
var $a845a8d70f18f25f$export$baf26146a414f24a = /** @class */ function() {
    function Point(x, y) {
        this.x = x;
        this.y = y;
    }
    Point.prototype.toResultPoint = function() {
        return new (0, $fwBMA.default)(this.getX(), this.getY());
    };
    Point.prototype.getX = function() {
        return this.x;
    };
    Point.prototype.getY = function() {
        return this.y;
    };
    return Point;
}();
/**
 * Encapsulates logic that can detect an Aztec Code in an image, even if the Aztec Code
 * is rotated or skewed, or partially obscured.
 *
 * @author David Olivier
 * @author Frank Yellin
 */ var $a845a8d70f18f25f$var$Detector = /** @class */ function() {
    function Detector(image) {
        this.EXPECTED_CORNER_BITS = new Int32Array([
            0xee0,
            0x1dc,
            0x83b,
            0x707
        ]);
        this.image = image;
    }
    Detector.prototype.detect = function() {
        return this.detectMirror(false);
    };
    /**
     * Detects an Aztec Code in an image.
     *
     * @param isMirror if true, image is a mirror-image of original
     * @return {@link AztecDetectorResult} encapsulating results of detecting an Aztec Code
     * @throws NotFoundException if no Aztec Code can be found
     */ Detector.prototype.detectMirror = function(isMirror) {
        // 1. Get the center of the aztec matrix
        var pCenter = this.getMatrixCenter();
        // 2. Get the center points of the four diagonal points just outside the bull's eye
        //  [topRight, bottomRight, bottomLeft, topLeft]
        var bullsEyeCorners = this.getBullsEyeCorners(pCenter);
        if (isMirror) {
            var temp = bullsEyeCorners[0];
            bullsEyeCorners[0] = bullsEyeCorners[2];
            bullsEyeCorners[2] = temp;
        }
        // 3. Get the size of the matrix and other parameters from the bull's eye
        this.extractParameters(bullsEyeCorners);
        // 4. Sample the grid
        var bits = this.sampleGrid(this.image, bullsEyeCorners[this.shift % 4], bullsEyeCorners[(this.shift + 1) % 4], bullsEyeCorners[(this.shift + 2) % 4], bullsEyeCorners[(this.shift + 3) % 4]);
        // 5. Get the corners of the matrix.
        var corners = this.getMatrixCornerPoints(bullsEyeCorners);
        return new (0, $8OWED.default)(bits, corners, this.compact, this.nbDataBlocks, this.nbLayers);
    };
    /**
     * Extracts the number of data layers and data blocks from the layer around the bull's eye.
     *
     * @param bullsEyeCorners the array of bull's eye corners
     * @throws NotFoundException in case of too many errors or invalid parameters
     */ Detector.prototype.extractParameters = function(bullsEyeCorners) {
        if (!this.isValidPoint(bullsEyeCorners[0]) || !this.isValidPoint(bullsEyeCorners[1]) || !this.isValidPoint(bullsEyeCorners[2]) || !this.isValidPoint(bullsEyeCorners[3])) throw new (0, $cQi30.default)();
        var length = 2 * this.nbCenterLayers;
        // Get the bits around the bull's eye
        var sides = new Int32Array([
            this.sampleLine(bullsEyeCorners[0], bullsEyeCorners[1], length),
            this.sampleLine(bullsEyeCorners[1], bullsEyeCorners[2], length),
            this.sampleLine(bullsEyeCorners[2], bullsEyeCorners[3], length),
            this.sampleLine(bullsEyeCorners[3], bullsEyeCorners[0], length) // Top
        ]);
        // bullsEyeCorners[shift] is the corner of the bulls'eye that has three
        // orientation marks.
        // sides[shift] is the row/column that goes from the corner with three
        // orientation marks to the corner with two.
        this.shift = this.getRotation(sides, length);
        // Flatten the parameter bits into a single 28- or 40-bit long
        var parameterData = 0;
        for(var i = 0; i < 4; i++){
            var side = sides[(this.shift + i) % 4];
            if (this.compact) {
                // Each side of the form ..XXXXXXX. where Xs are parameter data
                parameterData <<= 7;
                parameterData += side >> 1 & 0x7F;
            } else {
                // Each side of the form ..XXXXX.XXXXX. where Xs are parameter data
                parameterData <<= 10;
                parameterData += (side >> 2 & 992) + (side >> 1 & 0x1F);
            }
        }
        // Corrects parameter data using RS.  Returns just the data portion
        // without the error correction.
        var correctedData = this.getCorrectedParameterData(parameterData, this.compact);
        if (this.compact) {
            // 8 bits:  2 bits layers and 6 bits data blocks
            this.nbLayers = (correctedData >> 6) + 1;
            this.nbDataBlocks = (correctedData & 0x3F) + 1;
        } else {
            // 16 bits:  5 bits layers and 11 bits data blocks
            this.nbLayers = (correctedData >> 11) + 1;
            this.nbDataBlocks = (correctedData & 0x7FF) + 1;
        }
    };
    Detector.prototype.getRotation = function(sides, length) {
        // In a normal pattern, we expect to See
        //   **    .*             D       A
        //   *      *
        //
        //   .      *
        //   ..    ..             C       B
        //
        // Grab the 3 bits from each of the sides the form the locator pattern and concatenate
        // into a 12-bit integer.  Start with the bit at A
        var cornerBits = 0;
        sides.forEach(function(side, idx, arr) {
            // XX......X where X's are orientation marks
            var t = (side >> length - 2 << 1) + (side & 1);
            cornerBits = (cornerBits << 3) + t;
        });
        // for (var side in sides) {
        //     // XX......X where X's are orientation marks
        //     var t = ((side >> (length - 2)) << 1) + (side & 1);
        //     cornerBits = (cornerBits << 3) + t;
        // }
        // Mov the bottom bit to the top, so that the three bits of the locator pattern at A are
        // together.  cornerBits is now:
        //  3 orientation bits at A || 3 orientation bits at B || ... || 3 orientation bits at D
        cornerBits = ((cornerBits & 1) << 11) + (cornerBits >> 1);
        // The result shift indicates which element of BullsEyeCorners[] goes into the top-left
        // corner. Since the four rotation values have a Hamming distance of 8, we
        // can easily tolerate two errors.
        for(var shift = 0; shift < 4; shift++){
            if ((0, $hcAg4.default).bitCount(cornerBits ^ this.EXPECTED_CORNER_BITS[shift]) <= 2) return shift;
        }
        throw new (0, $cQi30.default)();
    };
    /**
     * Corrects the parameter bits using Reed-Solomon algorithm.
     *
     * @param parameterData parameter bits
     * @param compact true if this is a compact Aztec code
     * @throws NotFoundException if the array contains too many errors
     */ Detector.prototype.getCorrectedParameterData = function(parameterData, compact) {
        var numCodewords;
        var numDataCodewords;
        if (compact) {
            numCodewords = 7;
            numDataCodewords = 2;
        } else {
            numCodewords = 10;
            numDataCodewords = 4;
        }
        var numECCodewords = numCodewords - numDataCodewords;
        var parameterWords = new Int32Array(numCodewords);
        for(var i = numCodewords - 1; i >= 0; --i){
            parameterWords[i] = parameterData & 0xF;
            parameterData >>= 4;
        }
        try {
            var rsDecoder = new (0, $f5xTf.default)((0, $7nLua.default).AZTEC_PARAM);
            rsDecoder.decode(parameterWords, numECCodewords);
        } catch (ignored) {
            throw new (0, $cQi30.default)();
        }
        // Toss the error correction.  Just return the data as an integer
        var result = 0;
        for(var i = 0; i < numDataCodewords; i++)result = (result << 4) + parameterWords[i];
        return result;
    };
    /**
     * Finds the corners of a bull-eye centered on the passed point.
     * This returns the centers of the diagonal points just outside the bull's eye
     * Returns [topRight, bottomRight, bottomLeft, topLeft]
     *
     * @param pCenter Center point
     * @return The corners of the bull-eye
     * @throws NotFoundException If no valid bull-eye can be found
     */ Detector.prototype.getBullsEyeCorners = function(pCenter) {
        var pina = pCenter;
        var pinb = pCenter;
        var pinc = pCenter;
        var pind = pCenter;
        var color = true;
        for(this.nbCenterLayers = 1; this.nbCenterLayers < 9; this.nbCenterLayers++){
            var pouta = this.getFirstDifferent(pina, color, 1, -1);
            var poutb = this.getFirstDifferent(pinb, color, 1, 1);
            var poutc = this.getFirstDifferent(pinc, color, -1, 1);
            var poutd = this.getFirstDifferent(pind, color, -1, -1);
            // d      a
            //
            // c      b
            if (this.nbCenterLayers > 2) {
                var q = this.distancePoint(poutd, pouta) * this.nbCenterLayers / (this.distancePoint(pind, pina) * (this.nbCenterLayers + 2));
                if (q < 0.75 || q > 1.25 || !this.isWhiteOrBlackRectangle(pouta, poutb, poutc, poutd)) break;
            }
            pina = pouta;
            pinb = poutb;
            pinc = poutc;
            pind = poutd;
            color = !color;
        }
        if (this.nbCenterLayers !== 5 && this.nbCenterLayers !== 7) throw new (0, $cQi30.default)();
        this.compact = this.nbCenterLayers === 5;
        // Expand the square by .5 pixel in each direction so that we're on the border
        // between the white square and the black square
        var pinax = new (0, $fwBMA.default)(pina.getX() + 0.5, pina.getY() - 0.5);
        var pinbx = new (0, $fwBMA.default)(pinb.getX() + 0.5, pinb.getY() + 0.5);
        var pincx = new (0, $fwBMA.default)(pinc.getX() - 0.5, pinc.getY() + 0.5);
        var pindx = new (0, $fwBMA.default)(pind.getX() - 0.5, pind.getY() - 0.5);
        // Expand the square so that its corners are the centers of the points
        // just outside the bull's eye.
        return this.expandSquare([
            pinax,
            pinbx,
            pincx,
            pindx
        ], 2 * this.nbCenterLayers - 3, 2 * this.nbCenterLayers);
    };
    /**
     * Finds a candidate center point of an Aztec code from an image
     *
     * @return the center point
     */ Detector.prototype.getMatrixCenter = function() {
        var pointA;
        var pointB;
        var pointC;
        var pointD;
        // Get a white rectangle that can be the border of the matrix in center bull's eye or
        try {
            var cornerPoints = new (0, $jIl78.default)(this.image).detect();
            pointA = cornerPoints[0];
            pointB = cornerPoints[1];
            pointC = cornerPoints[2];
            pointD = cornerPoints[3];
        } catch (e) {
            // This exception can be in case the initial rectangle is white
            // In that case, surely in the bull's eye, we try to expand the rectangle.
            var cx_1 = this.image.getWidth() / 2;
            var cy_1 = this.image.getHeight() / 2;
            pointA = this.getFirstDifferent(new $a845a8d70f18f25f$export$baf26146a414f24a(cx_1 + 7, cy_1 - 7), false, 1, -1).toResultPoint();
            pointB = this.getFirstDifferent(new $a845a8d70f18f25f$export$baf26146a414f24a(cx_1 + 7, cy_1 + 7), false, 1, 1).toResultPoint();
            pointC = this.getFirstDifferent(new $a845a8d70f18f25f$export$baf26146a414f24a(cx_1 - 7, cy_1 + 7), false, -1, 1).toResultPoint();
            pointD = this.getFirstDifferent(new $a845a8d70f18f25f$export$baf26146a414f24a(cx_1 - 7, cy_1 - 7), false, -1, -1).toResultPoint();
        }
        // Compute the center of the rectangle
        var cx = (0, $fbOCK.default).round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
        var cy = (0, $fbOCK.default).round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
        // Redetermine the white rectangle starting from previously computed center.
        // This will ensure that we end up with a white rectangle in center bull's eye
        // in order to compute a more accurate center.
        try {
            var cornerPoints = new (0, $jIl78.default)(this.image, 15, cx, cy).detect();
            pointA = cornerPoints[0];
            pointB = cornerPoints[1];
            pointC = cornerPoints[2];
            pointD = cornerPoints[3];
        } catch (e) {
            // This exception can be in case the initial rectangle is white
            // In that case we try to expand the rectangle.
            pointA = this.getFirstDifferent(new $a845a8d70f18f25f$export$baf26146a414f24a(cx + 7, cy - 7), false, 1, -1).toResultPoint();
            pointB = this.getFirstDifferent(new $a845a8d70f18f25f$export$baf26146a414f24a(cx + 7, cy + 7), false, 1, 1).toResultPoint();
            pointC = this.getFirstDifferent(new $a845a8d70f18f25f$export$baf26146a414f24a(cx - 7, cy + 7), false, -1, 1).toResultPoint();
            pointD = this.getFirstDifferent(new $a845a8d70f18f25f$export$baf26146a414f24a(cx - 7, cy - 7), false, -1, -1).toResultPoint();
        }
        // Recompute the center of the rectangle
        cx = (0, $fbOCK.default).round((pointA.getX() + pointD.getX() + pointB.getX() + pointC.getX()) / 4.0);
        cy = (0, $fbOCK.default).round((pointA.getY() + pointD.getY() + pointB.getY() + pointC.getY()) / 4.0);
        return new $a845a8d70f18f25f$export$baf26146a414f24a(cx, cy);
    };
    /**
     * Gets the Aztec code corners from the bull's eye corners and the parameters.
     *
     * @param bullsEyeCorners the array of bull's eye corners
     * @return the array of aztec code corners
     */ Detector.prototype.getMatrixCornerPoints = function(bullsEyeCorners) {
        return this.expandSquare(bullsEyeCorners, 2 * this.nbCenterLayers, this.getDimension());
    };
    /**
     * Creates a BitMatrix by sampling the provided image.
     * topLeft, topRight, bottomRight, and bottomLeft are the centers of the squares on the
     * diagonal just outside the bull's eye.
     */ Detector.prototype.sampleGrid = function(image, topLeft, topRight, bottomRight, bottomLeft) {
        var sampler = (0, $5a6kn.default).getInstance();
        var dimension = this.getDimension();
        var low = dimension / 2 - this.nbCenterLayers;
        var high = dimension / 2 + this.nbCenterLayers;
        return sampler.sampleGrid(image, dimension, dimension, low, low, high, low, high, high, low, high, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
    };
    /**
     * Samples a line.
     *
     * @param p1   start point (inclusive)
     * @param p2   end point (exclusive)
     * @param size number of bits
     * @return the array of bits as an int (first bit is high-order bit of result)
     */ Detector.prototype.sampleLine = function(p1, p2, size) {
        var result = 0;
        var d = this.distanceResultPoint(p1, p2);
        var moduleSize = d / size;
        var px = p1.getX();
        var py = p1.getY();
        var dx = moduleSize * (p2.getX() - p1.getX()) / d;
        var dy = moduleSize * (p2.getY() - p1.getY()) / d;
        for(var i = 0; i < size; i++)if (this.image.get((0, $fbOCK.default).round(px + i * dx), (0, $fbOCK.default).round(py + i * dy))) result |= 1 << size - i - 1;
        return result;
    };
    /**
     * @return true if the border of the rectangle passed in parameter is compound of white points only
     *         or black points only
     */ Detector.prototype.isWhiteOrBlackRectangle = function(p1, p2, p3, p4) {
        var corr = 3;
        p1 = new $a845a8d70f18f25f$export$baf26146a414f24a(p1.getX() - corr, p1.getY() + corr);
        p2 = new $a845a8d70f18f25f$export$baf26146a414f24a(p2.getX() - corr, p2.getY() - corr);
        p3 = new $a845a8d70f18f25f$export$baf26146a414f24a(p3.getX() + corr, p3.getY() - corr);
        p4 = new $a845a8d70f18f25f$export$baf26146a414f24a(p4.getX() + corr, p4.getY() + corr);
        var cInit = this.getColor(p4, p1);
        if (cInit === 0) return false;
        var c = this.getColor(p1, p2);
        if (c !== cInit) return false;
        c = this.getColor(p2, p3);
        if (c !== cInit) return false;
        c = this.getColor(p3, p4);
        return c === cInit;
    };
    /**
     * Gets the color of a segment
     *
     * @return 1 if segment more than 90% black, -1 if segment is more than 90% white, 0 else
     */ Detector.prototype.getColor = function(p1, p2) {
        var d = this.distancePoint(p1, p2);
        var dx = (p2.getX() - p1.getX()) / d;
        var dy = (p2.getY() - p1.getY()) / d;
        var error = 0;
        var px = p1.getX();
        var py = p1.getY();
        var colorModel = this.image.get(p1.getX(), p1.getY());
        var iMax = Math.ceil(d);
        for(var i = 0; i < iMax; i++){
            px += dx;
            py += dy;
            if (this.image.get((0, $fbOCK.default).round(px), (0, $fbOCK.default).round(py)) !== colorModel) error++;
        }
        var errRatio = error / d;
        if (errRatio > 0.1 && errRatio < 0.9) return 0;
        return errRatio <= 0.1 === colorModel ? 1 : -1;
    };
    /**
     * Gets the coordinate of the first point with a different color in the given direction
     */ Detector.prototype.getFirstDifferent = function(init, color, dx, dy) {
        var x = init.getX() + dx;
        var y = init.getY() + dy;
        while(this.isValid(x, y) && this.image.get(x, y) === color){
            x += dx;
            y += dy;
        }
        x -= dx;
        y -= dy;
        while(this.isValid(x, y) && this.image.get(x, y) === color)x += dx;
        x -= dx;
        while(this.isValid(x, y) && this.image.get(x, y) === color)y += dy;
        y -= dy;
        return new $a845a8d70f18f25f$export$baf26146a414f24a(x, y);
    };
    /**
     * Expand the square represented by the corner points by pushing out equally in all directions
     *
     * @param cornerPoints the corners of the square, which has the bull's eye at its center
     * @param oldSide the original length of the side of the square in the target bit matrix
     * @param newSide the new length of the size of the square in the target bit matrix
     * @return the corners of the expanded square
     */ Detector.prototype.expandSquare = function(cornerPoints, oldSide, newSide) {
        var ratio = newSide / (2.0 * oldSide);
        var dx = cornerPoints[0].getX() - cornerPoints[2].getX();
        var dy = cornerPoints[0].getY() - cornerPoints[2].getY();
        var centerx = (cornerPoints[0].getX() + cornerPoints[2].getX()) / 2.0;
        var centery = (cornerPoints[0].getY() + cornerPoints[2].getY()) / 2.0;
        var result0 = new (0, $fwBMA.default)(centerx + ratio * dx, centery + ratio * dy);
        var result2 = new (0, $fwBMA.default)(centerx - ratio * dx, centery - ratio * dy);
        dx = cornerPoints[1].getX() - cornerPoints[3].getX();
        dy = cornerPoints[1].getY() - cornerPoints[3].getY();
        centerx = (cornerPoints[1].getX() + cornerPoints[3].getX()) / 2.0;
        centery = (cornerPoints[1].getY() + cornerPoints[3].getY()) / 2.0;
        var result1 = new (0, $fwBMA.default)(centerx + ratio * dx, centery + ratio * dy);
        var result3 = new (0, $fwBMA.default)(centerx - ratio * dx, centery - ratio * dy);
        var results = [
            result0,
            result1,
            result2,
            result3
        ];
        return results;
    };
    Detector.prototype.isValid = function(x, y) {
        return x >= 0 && x < this.image.getWidth() && y > 0 && y < this.image.getHeight();
    };
    Detector.prototype.isValidPoint = function(point) {
        var x = (0, $fbOCK.default).round(point.getX());
        var y = (0, $fbOCK.default).round(point.getY());
        return this.isValid(x, y);
    };
    Detector.prototype.distancePoint = function(a, b) {
        return (0, $fbOCK.default).distance(a.getX(), a.getY(), b.getX(), b.getY());
    };
    Detector.prototype.distanceResultPoint = function(a, b) {
        return (0, $fbOCK.default).distance(a.getX(), a.getY(), b.getX(), b.getY());
    };
    Detector.prototype.getDimension = function() {
        if (this.compact) return 4 * this.nbLayers + 11;
        if (this.nbLayers <= 4) return 4 * this.nbLayers + 15;
        return 4 * this.nbLayers + 2 * ((0, $hcAg4.default).truncDivision(this.nbLayers - 4, 8) + 1) + 15;
    };
    return Detector;
}();
var $a845a8d70f18f25f$export$2e2bcd8739ae039 = $a845a8d70f18f25f$var$Detector;

});
parcelRegister("fwBMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d72707c65e27db$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ 
var $fbOCK = parcelRequire("fbOCK");

var $eT6M3 = parcelRequire("eT6M3");
/**
 * <p>Encapsulates a point of interest in an image containing a barcode. Typically, this
 * would be the location of a finder pattern or the corner of the barcode, for example.</p>
 *
 * @author Sean Owen
 */ var $b4d72707c65e27db$var$ResultPoint = /** @class */ function() {
    function ResultPoint(x, y) {
        this.x = x;
        this.y = y;
    }
    ResultPoint.prototype.getX = function() {
        return this.x;
    };
    ResultPoint.prototype.getY = function() {
        return this.y;
    };
    /*@Override*/ ResultPoint.prototype.equals = function(other) {
        if (other instanceof ResultPoint) {
            var otherPoint = other;
            return this.x === otherPoint.x && this.y === otherPoint.y;
        }
        return false;
    };
    /*@Override*/ ResultPoint.prototype.hashCode = function() {
        return 31 * (0, $eT6M3.default).floatToIntBits(this.x) + (0, $eT6M3.default).floatToIntBits(this.y);
    };
    /*@Override*/ ResultPoint.prototype.toString = function() {
        return "(" + this.x + "," + this.y + ")";
    };
    /**
     * Orders an array of three ResultPoints in an order [A,B,C] such that AB is less than AC
     * and BC is less than AC, and the angle between BC and BA is less than 180 degrees.
     *
     * @param patterns array of three {@code ResultPoint} to order
     */ ResultPoint.orderBestPatterns = function(patterns) {
        // Find distances between pattern centers
        var zeroOneDistance = this.distance(patterns[0], patterns[1]);
        var oneTwoDistance = this.distance(patterns[1], patterns[2]);
        var zeroTwoDistance = this.distance(patterns[0], patterns[2]);
        var pointA;
        var pointB;
        var pointC;
        // Assume one closest to other two is B; A and C will just be guesses at first
        if (oneTwoDistance >= zeroOneDistance && oneTwoDistance >= zeroTwoDistance) {
            pointB = patterns[0];
            pointA = patterns[1];
            pointC = patterns[2];
        } else if (zeroTwoDistance >= oneTwoDistance && zeroTwoDistance >= zeroOneDistance) {
            pointB = patterns[1];
            pointA = patterns[0];
            pointC = patterns[2];
        } else {
            pointB = patterns[2];
            pointA = patterns[0];
            pointC = patterns[1];
        }
        // Use cross product to figure out whether A and C are correct or flipped.
        // This asks whether BC x BA has a positive z component, which is the arrangement
        // we want for A, B, C. If it's negative, then we've got it flipped around and
        // should swap A and C.
        if (this.crossProductZ(pointA, pointB, pointC) < 0.0) {
            var temp = pointA;
            pointA = pointC;
            pointC = temp;
        }
        patterns[0] = pointA;
        patterns[1] = pointB;
        patterns[2] = pointC;
    };
    /**
     * @param pattern1 first pattern
     * @param pattern2 second pattern
     * @return distance between two points
     */ ResultPoint.distance = function(pattern1, pattern2) {
        return (0, $fbOCK.default).distance(pattern1.x, pattern1.y, pattern2.x, pattern2.y);
    };
    /**
     * Returns the z component of the cross product between vectors BC and BA.
     */ ResultPoint.crossProductZ = function(pointA, pointB, pointC) {
        var bX = pointB.x;
        var bY = pointB.y;
        return (pointC.x - bX) * (pointA.y - bY) - (pointC.y - bY) * (pointA.x - bX);
    };
    return ResultPoint;
}();
var $b4d72707c65e27db$export$2e2bcd8739ae039 = $b4d72707c65e27db$var$ResultPoint;

});
parcelRegister("fbOCK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ef26f7b0b420f0$export$2e2bcd8739ae039);
/*
 * Copyright 2012 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common.detector {*/ /**
 * General math-related and numeric utility functions.
 */ var $b0ef26f7b0b420f0$var$MathUtils = /** @class */ function() {
    function MathUtils() {}
    /**
     * Ends up being a bit faster than {@link Math#round(float)}. This merely rounds its
     * argument to the nearest int, where x.5 rounds up to x+1. Semantics of this shortcut
     * differ slightly from {@link Math#round(float)} in that half rounds down for negative
     * values. -2.5 rounds to -3, not -2. For purposes here it makes no difference.
     *
     * @param d real value to round
     * @return nearest {@code int}
     */ MathUtils.round = function(d /*float*/ ) {
        if (isNaN(d)) return 0;
        if (d <= Number.MIN_SAFE_INTEGER) return Number.MIN_SAFE_INTEGER;
        if (d >= Number.MAX_SAFE_INTEGER) return Number.MAX_SAFE_INTEGER;
        return /*(int) */ d + (d < 0.0 ? -0.5 : 0.5) | 0;
    };
    // TYPESCRIPTPORT: maybe remove round method and call directly Math.round, it looks like it doesn't make sense for js
    /**
     * @param aX point A x coordinate
     * @param aY point A y coordinate
     * @param bX point B x coordinate
     * @param bY point B y coordinate
     * @return Euclidean distance between points A and B
     */ MathUtils.distance = function(aX /*float|int*/ , aY /*float|int*/ , bX /*float|int*/ , bY /*float|int*/ ) {
        var xDiff = aX - bX;
        var yDiff = aY - bY;
        return /*(float) */ Math.sqrt(xDiff * xDiff + yDiff * yDiff);
    };
    /**
     * @param aX point A x coordinate
     * @param aY point A y coordinate
     * @param bX point B x coordinate
     * @param bY point B y coordinate
     * @return Euclidean distance between points A and B
     */ // public static distance(aX: number /*int*/, aY: number /*int*/, bX: number /*int*/, bY: number /*int*/): float {
    //   const xDiff = aX - bX
    //   const yDiff = aY - bY
    //   return (float) Math.sqrt(xDiff * xDiff + yDiff * yDiff);
    // }
    /**
     * @param array values to sum
     * @return sum of values in array
     */ MathUtils.sum = function(array) {
        var count = 0;
        for(var i = 0, length_1 = array.length; i !== length_1; i++){
            var a = array[i];
            count += a;
        }
        return count;
    };
    return MathUtils;
}();
var $b0ef26f7b0b420f0$export$2e2bcd8739ae039 = $b0ef26f7b0b420f0$var$MathUtils;

});

parcelRegister("eT6M3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad6b74ee521f6904$export$2e2bcd8739ae039);
/**
 * Ponyfill for Java's Float class.
 */ var $ad6b74ee521f6904$var$Float = /** @class */ function() {
    function Float() {}
    /**
     * SincTS has no difference between int and float, there's all numbers,
     * this is used only to polyfill Java code.
     */ Float.floatToIntBits = function(f) {
        return f;
    };
    /**
     * The float max value in JS is the number max value.
     */ Float.MAX_VALUE = Number.MAX_SAFE_INTEGER;
    return Float;
}();
var $ad6b74ee521f6904$export$2e2bcd8739ae039 = $ad6b74ee521f6904$var$Float;

});


parcelRegister("8OWED", function(module, exports) {

$parcel$export(module.exports, "default", () => $66c07dc8de580ffa$export$2e2bcd8739ae039);
/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1q3xj = parcelRequire("1q3xj");
var $66c07dc8de580ffa$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Extends {@link DetectorResult} with more information specific to the Aztec format,
 * like the number of layers and whether it's compact.</p>
 *
 * @author Sean Owen
 */ var $66c07dc8de580ffa$var$AztecDetectorResult = /** @class */ function(_super) {
    $66c07dc8de580ffa$var$__extends(AztecDetectorResult, _super);
    function AztecDetectorResult(bits, points, compact, nbDatablocks, nbLayers) {
        var _this = _super.call(this, bits, points) || this;
        _this.compact = compact;
        _this.nbDatablocks = nbDatablocks;
        _this.nbLayers = nbLayers;
        return _this;
    }
    AztecDetectorResult.prototype.getNbLayers = function() {
        return this.nbLayers;
    };
    AztecDetectorResult.prototype.getNbDatablocks = function() {
        return this.nbDatablocks;
    };
    AztecDetectorResult.prototype.isCompact = function() {
        return this.compact;
    };
    return AztecDetectorResult;
}((0, $1q3xj.default));
var $66c07dc8de580ffa$export$2e2bcd8739ae039 = $66c07dc8de580ffa$var$AztecDetectorResult;

});
parcelRegister("1q3xj", function(module, exports) {

$parcel$export(module.exports, "default", () => $108af6675328a2eb$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates the result of detecting a barcode in an image. This includes the raw
 * matrix of black/white pixels corresponding to the barcode, and possibly points of interest
 * in the image, like the location of finder patterns or corners of the barcode in the image.</p>
 *
 * @author Sean Owen
 */ var $108af6675328a2eb$var$DetectorResult = /** @class */ function() {
    function DetectorResult(bits, points) {
        this.bits = bits;
        this.points = points;
    }
    DetectorResult.prototype.getBits = function() {
        return this.bits;
    };
    DetectorResult.prototype.getPoints = function() {
        return this.points;
    };
    return DetectorResult;
}();
var $108af6675328a2eb$export$2e2bcd8739ae039 = $108af6675328a2eb$var$DetectorResult;

});


parcelRegister("jIl78", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5a281395458cef0$export$2e2bcd8739ae039);
/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common.detector {*/ 
var $fwBMA = parcelRequire("fwBMA");

var $fbOCK = parcelRequire("fbOCK");

var $cQi30 = parcelRequire("cQi30");
/**
 * <p>
 * Detects a candidate barcode-like rectangular region within an image. It
 * starts around the center of the image, increases the size of the candidate
 * region until it finds a white rectangular region. By keeping track of the
 * last black points it encountered, it determines the corners of the barcode.
 * </p>
 *
 * @author David Olivier
 */ var $e5a281395458cef0$var$WhiteRectangleDetector = /** @class */ function() {
    // public constructor(private image: BitMatrix) /*throws NotFoundException*/ {
    //   this(image, INIT_SIZE, image.getWidth() / 2, image.getHeight() / 2)
    // }
    /**
     * @param image barcode image to find a rectangle in
     * @param initSize initial size of search area around center
     * @param x x position of search center
     * @param y y position of search center
     * @throws NotFoundException if image is too small to accommodate {@code initSize}
     */ function WhiteRectangleDetector(image, initSize /*int*/ , x /*int*/ , y /*int*/ ) {
        this.image = image;
        this.height = image.getHeight();
        this.width = image.getWidth();
        if (undefined === initSize || null === initSize) initSize = WhiteRectangleDetector.INIT_SIZE;
        if (undefined === x || null === x) x = image.getWidth() / 2 | 0;
        if (undefined === y || null === y) y = image.getHeight() / 2 | 0;
        var halfsize = initSize / 2 | 0;
        this.leftInit = x - halfsize;
        this.rightInit = x + halfsize;
        this.upInit = y - halfsize;
        this.downInit = y + halfsize;
        if (this.upInit < 0 || this.leftInit < 0 || this.downInit >= this.height || this.rightInit >= this.width) throw new (0, $cQi30.default)();
    }
    /**
     * <p>
     * Detects a candidate barcode-like rectangular region within an image. It
     * starts around the center of the image, increases the size of the candidate
     * region until it finds a white rectangular region.
     * </p>
     *
     * @return {@link ResultPoint}[] describing the corners of the rectangular
     *         region. The first and last points are opposed on the diagonal, as
     *         are the second and third. The first point will be the topmost
     *         point and the last, the bottommost. The second point will be
     *         leftmost and the third, the rightmost
     * @throws NotFoundException if no Data Matrix Code can be found
     */ WhiteRectangleDetector.prototype.detect = function() {
        var left = this.leftInit;
        var right = this.rightInit;
        var up = this.upInit;
        var down = this.downInit;
        var sizeExceeded = false;
        var aBlackPointFoundOnBorder = true;
        var atLeastOneBlackPointFoundOnBorder = false;
        var atLeastOneBlackPointFoundOnRight = false;
        var atLeastOneBlackPointFoundOnBottom = false;
        var atLeastOneBlackPointFoundOnLeft = false;
        var atLeastOneBlackPointFoundOnTop = false;
        var width = this.width;
        var height = this.height;
        while(aBlackPointFoundOnBorder){
            aBlackPointFoundOnBorder = false;
            // .....
            // .   |
            // .....
            var rightBorderNotWhite = true;
            while((rightBorderNotWhite || !atLeastOneBlackPointFoundOnRight) && right < width){
                rightBorderNotWhite = this.containsBlackPoint(up, down, right, false);
                if (rightBorderNotWhite) {
                    right++;
                    aBlackPointFoundOnBorder = true;
                    atLeastOneBlackPointFoundOnRight = true;
                } else if (!atLeastOneBlackPointFoundOnRight) right++;
            }
            if (right >= width) {
                sizeExceeded = true;
                break;
            }
            // .....
            // .   .
            // .___.
            var bottomBorderNotWhite = true;
            while((bottomBorderNotWhite || !atLeastOneBlackPointFoundOnBottom) && down < height){
                bottomBorderNotWhite = this.containsBlackPoint(left, right, down, true);
                if (bottomBorderNotWhite) {
                    down++;
                    aBlackPointFoundOnBorder = true;
                    atLeastOneBlackPointFoundOnBottom = true;
                } else if (!atLeastOneBlackPointFoundOnBottom) down++;
            }
            if (down >= height) {
                sizeExceeded = true;
                break;
            }
            // .....
            // |   .
            // .....
            var leftBorderNotWhite = true;
            while((leftBorderNotWhite || !atLeastOneBlackPointFoundOnLeft) && left >= 0){
                leftBorderNotWhite = this.containsBlackPoint(up, down, left, false);
                if (leftBorderNotWhite) {
                    left--;
                    aBlackPointFoundOnBorder = true;
                    atLeastOneBlackPointFoundOnLeft = true;
                } else if (!atLeastOneBlackPointFoundOnLeft) left--;
            }
            if (left < 0) {
                sizeExceeded = true;
                break;
            }
            // .___.
            // .   .
            // .....
            var topBorderNotWhite = true;
            while((topBorderNotWhite || !atLeastOneBlackPointFoundOnTop) && up >= 0){
                topBorderNotWhite = this.containsBlackPoint(left, right, up, true);
                if (topBorderNotWhite) {
                    up--;
                    aBlackPointFoundOnBorder = true;
                    atLeastOneBlackPointFoundOnTop = true;
                } else if (!atLeastOneBlackPointFoundOnTop) up--;
            }
            if (up < 0) {
                sizeExceeded = true;
                break;
            }
            if (aBlackPointFoundOnBorder) atLeastOneBlackPointFoundOnBorder = true;
        }
        if (!sizeExceeded && atLeastOneBlackPointFoundOnBorder) {
            var maxSize = right - left;
            var z = null;
            for(var i = 1; z === null && i < maxSize; i++)z = this.getBlackPointOnSegment(left, down - i, left + i, down);
            if (z == null) throw new (0, $cQi30.default)();
            var t = null;
            // go down right
            for(var i = 1; t === null && i < maxSize; i++)t = this.getBlackPointOnSegment(left, up + i, left + i, up);
            if (t == null) throw new (0, $cQi30.default)();
            var x = null;
            // go down left
            for(var i = 1; x === null && i < maxSize; i++)x = this.getBlackPointOnSegment(right, up + i, right - i, up);
            if (x == null) throw new (0, $cQi30.default)();
            var y = null;
            // go up left
            for(var i = 1; y === null && i < maxSize; i++)y = this.getBlackPointOnSegment(right, down - i, right - i, down);
            if (y == null) throw new (0, $cQi30.default)();
            return this.centerEdges(y, z, x, t);
        } else throw new (0, $cQi30.default)();
    };
    WhiteRectangleDetector.prototype.getBlackPointOnSegment = function(aX /*float*/ , aY /*float*/ , bX /*float*/ , bY /*float*/ ) {
        var dist = (0, $fbOCK.default).round((0, $fbOCK.default).distance(aX, aY, bX, bY));
        var xStep = (bX - aX) / dist;
        var yStep = (bY - aY) / dist;
        var image = this.image;
        for(var i = 0; i < dist; i++){
            var x = (0, $fbOCK.default).round(aX + i * xStep);
            var y = (0, $fbOCK.default).round(aY + i * yStep);
            if (image.get(x, y)) return new (0, $fwBMA.default)(x, y);
        }
        return null;
    };
    /**
     * recenters the points of a constant distance towards the center
     *
     * @param y bottom most point
     * @param z left most point
     * @param x right most point
     * @param t top most point
     * @return {@link ResultPoint}[] describing the corners of the rectangular
     *         region. The first and last points are opposed on the diagonal, as
     *         are the second and third. The first point will be the topmost
     *         point and the last, the bottommost. The second point will be
     *         leftmost and the third, the rightmost
     */ WhiteRectangleDetector.prototype.centerEdges = function(y, z, x, t) {
        //
        //       t            t
        //  z                      x
        //        x    OR    z
        //   y                    y
        //
        var yi = y.getX();
        var yj = y.getY();
        var zi = z.getX();
        var zj = z.getY();
        var xi = x.getX();
        var xj = x.getY();
        var ti = t.getX();
        var tj = t.getY();
        var CORR = WhiteRectangleDetector.CORR;
        if (yi < this.width / 2.0) return [
            new (0, $fwBMA.default)(ti - CORR, tj + CORR),
            new (0, $fwBMA.default)(zi + CORR, zj + CORR),
            new (0, $fwBMA.default)(xi - CORR, xj - CORR),
            new (0, $fwBMA.default)(yi + CORR, yj - CORR)
        ];
        else return [
            new (0, $fwBMA.default)(ti + CORR, tj + CORR),
            new (0, $fwBMA.default)(zi + CORR, zj - CORR),
            new (0, $fwBMA.default)(xi - CORR, xj + CORR),
            new (0, $fwBMA.default)(yi - CORR, yj - CORR)
        ];
    };
    /**
     * Determines whether a segment contains a black point
     *
     * @param a          min value of the scanned coordinate
     * @param b          max value of the scanned coordinate
     * @param fixed      value of fixed coordinate
     * @param horizontal set to true if scan must be horizontal, false if vertical
     * @return true if a black point has been found, else false.
     */ WhiteRectangleDetector.prototype.containsBlackPoint = function(a /*int*/ , b /*int*/ , fixed /*int*/ , horizontal) {
        var image = this.image;
        if (horizontal) for(var x = a; x <= b; x++){
            if (image.get(x, fixed)) return true;
        }
        else for(var y = a; y <= b; y++){
            if (image.get(fixed, y)) return true;
        }
        return false;
    };
    WhiteRectangleDetector.INIT_SIZE = 10;
    WhiteRectangleDetector.CORR = 1;
    return WhiteRectangleDetector;
}();
var $e5a281395458cef0$export$2e2bcd8739ae039 = $e5a281395458cef0$var$WhiteRectangleDetector;

});

parcelRegister("5a6kn", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c22cb7aaf627865$export$2e2bcd8739ae039);

var $acfSE = parcelRequire("acfSE");
var $3c22cb7aaf627865$var$GridSamplerInstance = /** @class */ function() {
    function GridSamplerInstance() {}
    /**
     * Sets the implementation of GridSampler used by the library. One global
     * instance is stored, which may sound problematic. But, the implementation provided
     * ought to be appropriate for the entire platform, and all uses of this library
     * in the whole lifetime of the JVM. For instance, an Android activity can swap in
     * an implementation that takes advantage of native platform libraries.
     *
     * @param newGridSampler The platform-specific object to install.
     */ GridSamplerInstance.setGridSampler = function(newGridSampler) {
        GridSamplerInstance.gridSampler = newGridSampler;
    };
    /**
     * @return the current implementation of GridSampler
     */ GridSamplerInstance.getInstance = function() {
        return GridSamplerInstance.gridSampler;
    };
    GridSamplerInstance.gridSampler = new (0, $acfSE.default)();
    return GridSamplerInstance;
}();
var $3c22cb7aaf627865$export$2e2bcd8739ae039 = $3c22cb7aaf627865$var$GridSamplerInstance;

});
parcelRegister("acfSE", function(module, exports) {

$parcel$export(module.exports, "default", () => $76c757e921970ef7$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $Ywfs9 = parcelRequire("Ywfs9");

var $hzqel = parcelRequire("hzqel");

var $1e7M5 = parcelRequire("1e7M5");

var $cQi30 = parcelRequire("cQi30");
var $76c757e921970ef7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @author Sean Owen
 */ var $76c757e921970ef7$var$DefaultGridSampler = /** @class */ function(_super) {
    $76c757e921970ef7$var$__extends(DefaultGridSampler, _super);
    function DefaultGridSampler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*@Override*/ DefaultGridSampler.prototype.sampleGrid = function(image, dimensionX /*int*/ , dimensionY /*int*/ , p1ToX /*float*/ , p1ToY /*float*/ , p2ToX /*float*/ , p2ToY /*float*/ , p3ToX /*float*/ , p3ToY /*float*/ , p4ToX /*float*/ , p4ToY /*float*/ , p1FromX /*float*/ , p1FromY /*float*/ , p2FromX /*float*/ , p2FromY /*float*/ , p3FromX /*float*/ , p3FromY /*float*/ , p4FromX /*float*/ , p4FromY /*float*/ ) {
        var transform = (0, $1e7M5.default).quadrilateralToQuadrilateral(p1ToX, p1ToY, p2ToX, p2ToY, p3ToX, p3ToY, p4ToX, p4ToY, p1FromX, p1FromY, p2FromX, p2FromY, p3FromX, p3FromY, p4FromX, p4FromY);
        return this.sampleGridWithTransform(image, dimensionX, dimensionY, transform);
    };
    /*@Override*/ DefaultGridSampler.prototype.sampleGridWithTransform = function(image, dimensionX /*int*/ , dimensionY /*int*/ , transform) {
        if (dimensionX <= 0 || dimensionY <= 0) throw new (0, $cQi30.default)();
        var bits = new (0, $hzqel.default)(dimensionX, dimensionY);
        var points = new Float32Array(2 * dimensionX);
        for(var y = 0; y < dimensionY; y++){
            var max = points.length;
            var iValue = y + 0.5;
            for(var x = 0; x < max; x += 2){
                points[x] = x / 2 + 0.5;
                points[x + 1] = iValue;
            }
            transform.transformPoints(points);
            // Quick check to see if points transformed to something inside the image
            // sufficient to check the endpoints
            (0, $Ywfs9.default).checkAndNudgePoints(image, points);
            try {
                for(var x = 0; x < max; x += 2)if (image.get(Math.floor(points[x]), Math.floor(points[x + 1]))) // Black(-ish) pixel
                bits.set(x / 2, y);
            } catch (aioobe /*: ArrayIndexOutOfBoundsException*/ ) {
                // This feels wrong, but, sometimes if the finder patterns are misidentified, the resulting
                // transform gets "twisted" such that it maps a straight line of points to a set of points
                // whose endpoints are in bounds, but others are not. There is probably some mathematical
                // way to detect this about the transformation that I don't know yet.
                // This results in an ugly runtime exception despite our clever checks above -- can't have
                // that. We could check each point's coordinates but that feels duplicative. We settle for
                // catching and wrapping ArrayIndexOutOfBoundsException.
                throw new (0, $cQi30.default)();
            }
        }
        return bits;
    };
    return DefaultGridSampler;
}((0, $Ywfs9.default));
var $76c757e921970ef7$export$2e2bcd8739ae039 = $76c757e921970ef7$var$DefaultGridSampler;

});
parcelRegister("Ywfs9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5e9e8a6d43d156$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cQi30 = parcelRequire("cQi30");
/**
 * Implementations of this class can, given locations of finder patterns for a QR code in an
 * image, sample the right points in the image to reconstruct the QR code, accounting for
 * perspective distortion. It is abstracted since it is relatively expensive and should be allowed
 * to take advantage of platform-specific optimized implementations, like Sun's Java Advanced
 * Imaging library, but which may not be available in other environments such as J2ME, and vice
 * versa.
 *
 * The implementation used can be controlled by calling {@link #setGridSampler(GridSampler)}
 * with an instance of a class which implements this interface.
 *
 * @author Sean Owen
 */ var $0b5e9e8a6d43d156$var$GridSampler = /** @class */ function() {
    function GridSampler() {}
    /**
     * <p>Checks a set of points that have been transformed to sample points on an image against
     * the image's dimensions to see if the point are even within the image.</p>
     *
     * <p>This method will actually "nudge" the endpoints back onto the image if they are found to be
     * barely (less than 1 pixel) off the image. This accounts for imperfect detection of finder
     * patterns in an image where the QR Code runs all the way to the image border.</p>
     *
     * <p>For efficiency, the method will check points from either end of the line until one is found
     * to be within the image. Because the set of points are assumed to be linear, this is valid.</p>
     *
     * @param image image into which the points should map
     * @param points actual points in x1,y1,...,xn,yn form
     * @throws NotFoundException if an endpoint is lies outside the image boundaries
     */ GridSampler.checkAndNudgePoints = function(image, points) {
        var width = image.getWidth();
        var height = image.getHeight();
        // Check and nudge points from start until we see some that are OK:
        var nudged = true;
        for(var offset = 0; offset < points.length && nudged; offset += 2){
            var x = Math.floor(points[offset]);
            var y = Math.floor(points[offset + 1]);
            if (x < -1 || x > width || y < -1 || y > height) throw new (0, $cQi30.default)();
            nudged = false;
            if (x === -1) {
                points[offset] = 0.0;
                nudged = true;
            } else if (x === width) {
                points[offset] = width - 1;
                nudged = true;
            }
            if (y === -1) {
                points[offset + 1] = 0.0;
                nudged = true;
            } else if (y === height) {
                points[offset + 1] = height - 1;
                nudged = true;
            }
        }
        // Check and nudge points from end:
        nudged = true;
        for(var offset = points.length - 2; offset >= 0 && nudged; offset -= 2){
            var x = Math.floor(points[offset]);
            var y = Math.floor(points[offset + 1]);
            if (x < -1 || x > width || y < -1 || y > height) throw new (0, $cQi30.default)();
            nudged = false;
            if (x === -1) {
                points[offset] = 0.0;
                nudged = true;
            } else if (x === width) {
                points[offset] = width - 1;
                nudged = true;
            }
            if (y === -1) {
                points[offset + 1] = 0.0;
                nudged = true;
            } else if (y === height) {
                points[offset + 1] = height - 1;
                nudged = true;
            }
        }
    };
    return GridSampler;
}();
var $0b5e9e8a6d43d156$export$2e2bcd8739ae039 = $0b5e9e8a6d43d156$var$GridSampler;

});

parcelRegister("1e7M5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e4d211a44cf28a6$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ /**
 * <p>This class implements a perspective transform in two dimensions. Given four source and four
 * destination points, it will compute the transformation implied between them. The code is based
 * directly upon section 3.4.2 of George Wolberg's "Digital Image Warping"; see pages 54-56.</p>
 *
 * @author Sean Owen
 */ var $0e4d211a44cf28a6$var$PerspectiveTransform = /** @class */ function() {
    function PerspectiveTransform(a11 /*float*/ , a21 /*float*/ , a31 /*float*/ , a12 /*float*/ , a22 /*float*/ , a32 /*float*/ , a13 /*float*/ , a23 /*float*/ , a33 /*float*/ ) {
        this.a11 = a11;
        this.a21 = a21;
        this.a31 = a31;
        this.a12 = a12;
        this.a22 = a22;
        this.a32 = a32;
        this.a13 = a13;
        this.a23 = a23;
        this.a33 = a33;
    }
    PerspectiveTransform.quadrilateralToQuadrilateral = function(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ , x0p /*float*/ , y0p /*float*/ , x1p /*float*/ , y1p /*float*/ , x2p /*float*/ , y2p /*float*/ , x3p /*float*/ , y3p /*float*/ ) {
        var qToS = PerspectiveTransform.quadrilateralToSquare(x0, y0, x1, y1, x2, y2, x3, y3);
        var sToQ = PerspectiveTransform.squareToQuadrilateral(x0p, y0p, x1p, y1p, x2p, y2p, x3p, y3p);
        return sToQ.times(qToS);
    };
    PerspectiveTransform.prototype.transformPoints = function(points) {
        var max = points.length;
        var a11 = this.a11;
        var a12 = this.a12;
        var a13 = this.a13;
        var a21 = this.a21;
        var a22 = this.a22;
        var a23 = this.a23;
        var a31 = this.a31;
        var a32 = this.a32;
        var a33 = this.a33;
        for(var i = 0; i < max; i += 2){
            var x = points[i];
            var y = points[i + 1];
            var denominator = a13 * x + a23 * y + a33;
            points[i] = (a11 * x + a21 * y + a31) / denominator;
            points[i + 1] = (a12 * x + a22 * y + a32) / denominator;
        }
    };
    PerspectiveTransform.prototype.transformPointsWithValues = function(xValues, yValues) {
        var a11 = this.a11;
        var a12 = this.a12;
        var a13 = this.a13;
        var a21 = this.a21;
        var a22 = this.a22;
        var a23 = this.a23;
        var a31 = this.a31;
        var a32 = this.a32;
        var a33 = this.a33;
        var n = xValues.length;
        for(var i = 0; i < n; i++){
            var x = xValues[i];
            var y = yValues[i];
            var denominator = a13 * x + a23 * y + a33;
            xValues[i] = (a11 * x + a21 * y + a31) / denominator;
            yValues[i] = (a12 * x + a22 * y + a32) / denominator;
        }
    };
    PerspectiveTransform.squareToQuadrilateral = function(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
        var dx3 = x0 - x1 + x2 - x3;
        var dy3 = y0 - y1 + y2 - y3;
        if (dx3 === 0.0 && dy3 === 0.0) // Affine
        return new PerspectiveTransform(x1 - x0, x2 - x1, x0, y1 - y0, y2 - y1, y0, 0.0, 0.0, 1.0);
        else {
            var dx1 = x1 - x2;
            var dx2 = x3 - x2;
            var dy1 = y1 - y2;
            var dy2 = y3 - y2;
            var denominator = dx1 * dy2 - dx2 * dy1;
            var a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
            var a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
            return new PerspectiveTransform(x1 - x0 + a13 * x1, x3 - x0 + a23 * x3, x0, y1 - y0 + a13 * y1, y3 - y0 + a23 * y3, y0, a13, a23, 1.0);
        }
    };
    PerspectiveTransform.quadrilateralToSquare = function(x0 /*float*/ , y0 /*float*/ , x1 /*float*/ , y1 /*float*/ , x2 /*float*/ , y2 /*float*/ , x3 /*float*/ , y3 /*float*/ ) {
        // Here, the adjoint serves as the inverse:
        return PerspectiveTransform.squareToQuadrilateral(x0, y0, x1, y1, x2, y2, x3, y3).buildAdjoint();
    };
    PerspectiveTransform.prototype.buildAdjoint = function() {
        // Adjoint is the transpose of the cofactor matrix:
        return new PerspectiveTransform(this.a22 * this.a33 - this.a23 * this.a32, this.a23 * this.a31 - this.a21 * this.a33, this.a21 * this.a32 - this.a22 * this.a31, this.a13 * this.a32 - this.a12 * this.a33, this.a11 * this.a33 - this.a13 * this.a31, this.a12 * this.a31 - this.a11 * this.a32, this.a12 * this.a23 - this.a13 * this.a22, this.a13 * this.a21 - this.a11 * this.a23, this.a11 * this.a22 - this.a12 * this.a21);
    };
    PerspectiveTransform.prototype.times = function(other) {
        return new PerspectiveTransform(this.a11 * other.a11 + this.a21 * other.a12 + this.a31 * other.a13, this.a11 * other.a21 + this.a21 * other.a22 + this.a31 * other.a23, this.a11 * other.a31 + this.a21 * other.a32 + this.a31 * other.a33, this.a12 * other.a11 + this.a22 * other.a12 + this.a32 * other.a13, this.a12 * other.a21 + this.a22 * other.a22 + this.a32 * other.a23, this.a12 * other.a31 + this.a22 * other.a32 + this.a32 * other.a33, this.a13 * other.a11 + this.a23 * other.a12 + this.a33 * other.a13, this.a13 * other.a21 + this.a23 * other.a22 + this.a33 * other.a23, this.a13 * other.a31 + this.a23 * other.a32 + this.a33 * other.a33);
    };
    return PerspectiveTransform;
}();
var $0e4d211a44cf28a6$export$2e2bcd8739ae039 = $0e4d211a44cf28a6$var$PerspectiveTransform;

});






parcelRegister("94fZV", function(module, exports) {

var $au3R0 = parcelRequire("au3R0");

var $eisSD = parcelRequire("eisSD");
var $69a0e59de2914df3$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 *
 * Barcode reader reader to use from browser.
 */ var $69a0e59de2914df3$export$8710c3a40c27a798 = /** @class */ function(_super) {
    $69a0e59de2914df3$var$__extends(BrowserBarcodeReader, _super);
    /**
     * Creates an instance of BrowserBarcodeReader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     * @param {Map<DecodeHintType, any>} hints
     */ function BrowserBarcodeReader(timeBetweenScansMillis, hints) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $eisSD.default)(hints), timeBetweenScansMillis, hints) || this;
    }
    return BrowserBarcodeReader;
}((0, $au3R0.BrowserCodeReader));

});
parcelRegister("eisSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $02afa1a5c9134cc9$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $b5DE3 = parcelRequire("b5DE3");

var $cQi30 = parcelRequire("cQi30");

var $hZs5H = parcelRequire("hZs5H");

var $9BRcf = parcelRequire("9BRcf");

var $a0iHq = parcelRequire("a0iHq");

var $7oKct = parcelRequire("7oKct");

var $erVrW = parcelRequire("erVrW");

var $itEYK = parcelRequire("itEYK");

var $eWQaA = parcelRequire("eWQaA");

var $4RT7c = parcelRequire("4RT7c");

var $bDjlU = parcelRequire("bDjlU");
var $02afa1a5c9134cc9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @author Daniel Switkin <dswitkin@google.com>
 * @author Sean Owen
 */ var $02afa1a5c9134cc9$var$MultiFormatOneDReader = /** @class */ function(_super) {
    $02afa1a5c9134cc9$var$__extends(MultiFormatOneDReader, _super);
    function MultiFormatOneDReader(hints) {
        var _this = _super.call(this) || this;
        _this.readers = [];
        var possibleFormats = !hints ? null : hints.get((0, $b5DE3.default).POSSIBLE_FORMATS);
        var useCode39CheckDigit = hints && hints.get((0, $b5DE3.default).ASSUME_CODE_39_CHECK_DIGIT) !== undefined;
        var useCode39ExtendedMode = hints && hints.get((0, $b5DE3.default).ENABLE_CODE_39_EXTENDED_MODE) !== undefined;
        if (possibleFormats) {
            if (possibleFormats.includes((0, $bx5V3.default).EAN_13) || possibleFormats.includes((0, $bx5V3.default).UPC_A) || possibleFormats.includes((0, $bx5V3.default).EAN_8) || possibleFormats.includes((0, $bx5V3.default).UPC_E)) _this.readers.push(new (0, $erVrW.default)(hints));
            if (possibleFormats.includes((0, $bx5V3.default).CODE_39)) _this.readers.push(new (0, $9BRcf.default)(useCode39CheckDigit, useCode39ExtendedMode));
            if (possibleFormats.includes((0, $bx5V3.default).CODE_93)) _this.readers.push(new (0, $a0iHq.default)());
            if (possibleFormats.includes((0, $bx5V3.default).CODE_128)) _this.readers.push(new (0, $hZs5H.default)());
            if (possibleFormats.includes((0, $bx5V3.default).ITF)) _this.readers.push(new (0, $7oKct.default)());
            if (possibleFormats.includes((0, $bx5V3.default).CODABAR)) _this.readers.push(new (0, $eWQaA.default)());
            if (possibleFormats.includes((0, $bx5V3.default).RSS_14)) _this.readers.push(new (0, $bDjlU.default)());
            if (possibleFormats.includes((0, $bx5V3.default).RSS_EXPANDED)) {
                console.warn("RSS Expanded reader IS NOT ready for production yet! use at your own risk.");
                _this.readers.push(new (0, $4RT7c.default)());
            }
        }
        if (_this.readers.length === 0) {
            _this.readers.push(new (0, $erVrW.default)(hints));
            _this.readers.push(new (0, $9BRcf.default)());
            // this.readers.push(new CodaBarReader());
            _this.readers.push(new (0, $a0iHq.default)());
            _this.readers.push(new (0, $erVrW.default)(hints));
            _this.readers.push(new (0, $hZs5H.default)());
            _this.readers.push(new (0, $7oKct.default)());
            _this.readers.push(new (0, $bDjlU.default)());
        // this.readers.push(new RSSExpandedReader());
        }
        return _this;
    }
    // @Override
    MultiFormatOneDReader.prototype.decodeRow = function(rowNumber, row, hints) {
        for(var i = 0; i < this.readers.length; i++)try {
            return this.readers[i].decodeRow(rowNumber, row, hints);
        } catch (re) {
        // continue
        }
        throw new (0, $cQi30.default)();
    };
    // @Override
    MultiFormatOneDReader.prototype.reset = function() {
        this.readers.forEach(function(reader) {
            return reader.reset();
        });
    };
    return MultiFormatOneDReader;
}((0, $itEYK.default));
var $02afa1a5c9134cc9$export$2e2bcd8739ae039 = $02afa1a5c9134cc9$var$MultiFormatOneDReader;

});
parcelRegister("hZs5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $d18dec767146ea22$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $9Nn2d = parcelRequire("9Nn2d");

var $b5DE3 = parcelRequire("b5DE3");

var $dtgr5 = parcelRequire("dtgr5");

var $cQi30 = parcelRequire("cQi30");

var $kWndQ = parcelRequire("kWndQ");

var $fwBMA = parcelRequire("fwBMA");

var $itEYK = parcelRequire("itEYK");
var $d18dec767146ea22$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Decodes Code 128 barcodes.</p>
 *
 * @author Sean Owen
 */ var $d18dec767146ea22$var$Code128Reader = /** @class */ function(_super) {
    $d18dec767146ea22$var$__extends(Code128Reader, _super);
    function Code128Reader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Code128Reader.findStartPattern = function(row) {
        var width = row.getSize();
        var rowOffset = row.getNextSet(0);
        var counterPosition = 0;
        var counters = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        var patternStart = rowOffset;
        var isWhite = false;
        var patternLength = 6;
        for(var i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                var bestVariance = Code128Reader.MAX_AVG_VARIANCE;
                var bestMatch = -1;
                for(var startCode = Code128Reader.CODE_START_A; startCode <= Code128Reader.CODE_START_C; startCode++){
                    var variance = (0, $itEYK.default).patternMatchVariance(counters, Code128Reader.CODE_PATTERNS[startCode], Code128Reader.MAX_INDIVIDUAL_VARIANCE);
                    if (variance < bestVariance) {
                        bestVariance = variance;
                        bestMatch = startCode;
                    }
                }
                // Look for whitespace before start pattern, >= 50% of width of start pattern
                if (bestMatch >= 0 && row.isRange(Math.max(0, patternStart - (i - patternStart) / 2), patternStart, false)) return Int32Array.from([
                    patternStart,
                    i,
                    bestMatch
                ]);
                patternStart += counters[0] + counters[1];
                counters = counters.slice(2, counters.length);
                counters[counterPosition - 1] = 0;
                counters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $cQi30.default)();
    };
    Code128Reader.decodeCode = function(row, counters, rowOffset) {
        (0, $itEYK.default).recordPattern(row, rowOffset, counters);
        var bestVariance = Code128Reader.MAX_AVG_VARIANCE; // worst variance we'll accept
        var bestMatch = -1;
        for(var d = 0; d < Code128Reader.CODE_PATTERNS.length; d++){
            var pattern = Code128Reader.CODE_PATTERNS[d];
            var variance = this.patternMatchVariance(counters, pattern, Code128Reader.MAX_INDIVIDUAL_VARIANCE);
            if (variance < bestVariance) {
                bestVariance = variance;
                bestMatch = d;
            }
        }
        // TODO We're overlooking the fact that the STOP pattern has 7 values, not 6.
        if (bestMatch >= 0) return bestMatch;
        else throw new (0, $cQi30.default)();
    };
    Code128Reader.prototype.decodeRow = function(rowNumber, row, hints) {
        var convertFNC1 = hints && hints.get((0, $b5DE3.default).ASSUME_GS1) === true;
        var startPatternInfo = Code128Reader.findStartPattern(row);
        var startCode = startPatternInfo[2];
        var currentRawCodesIndex = 0;
        var rawCodes = new Uint8Array(20);
        rawCodes[currentRawCodesIndex++] = startCode;
        var codeSet;
        switch(startCode){
            case Code128Reader.CODE_START_A:
                codeSet = Code128Reader.CODE_CODE_A;
                break;
            case Code128Reader.CODE_START_B:
                codeSet = Code128Reader.CODE_CODE_B;
                break;
            case Code128Reader.CODE_START_C:
                codeSet = Code128Reader.CODE_CODE_C;
                break;
            default:
                throw new (0, $dtgr5.default)();
        }
        var done = false;
        var isNextShifted = false;
        var result = "";
        var lastStart = startPatternInfo[0];
        var nextStart = startPatternInfo[1];
        var counters = Int32Array.from([
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        var lastCode = 0;
        var code = 0;
        var checksumTotal = startCode;
        var multiplier = 0;
        var lastCharacterWasPrintable = true;
        var upperMode = false;
        var shiftUpperMode = false;
        while(!done){
            var unshift = isNextShifted;
            isNextShifted = false;
            // Save off last code
            lastCode = code;
            // Decode another code from image
            code = Code128Reader.decodeCode(row, counters, nextStart);
            rawCodes[currentRawCodesIndex++] = code;
            // Remember whether the last code was printable or not (excluding CODE_STOP)
            if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = true;
            // Add to checksum computation (if not CODE_STOP of course)
            if (code !== Code128Reader.CODE_STOP) {
                multiplier++;
                checksumTotal += multiplier * code;
            }
            // Advance to where the next code will to start
            lastStart = nextStart;
            nextStart += counters.reduce(function(previous, current) {
                return previous + current;
            }, 0);
            // Take care of illegal start codes
            switch(code){
                case Code128Reader.CODE_START_A:
                case Code128Reader.CODE_START_B:
                case Code128Reader.CODE_START_C:
                    throw new (0, $dtgr5.default)();
            }
            switch(codeSet){
                case Code128Reader.CODE_CODE_A:
                    if (code < 64) {
                        if (shiftUpperMode === upperMode) result += String.fromCharCode(" ".charCodeAt(0) + code);
                        else result += String.fromCharCode(" ".charCodeAt(0) + code + 128);
                        shiftUpperMode = false;
                    } else if (code < 96) {
                        if (shiftUpperMode === upperMode) result += String.fromCharCode(code - 64);
                        else result += String.fromCharCode(code + 64);
                        shiftUpperMode = false;
                    } else {
                        // Don't let CODE_STOP, which always appears, affect whether whether we think the last
                        // code was printable or not.
                        if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                        switch(code){
                            case Code128Reader.CODE_FNC_1:
                                if (convertFNC1) {
                                    if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                    // is FNC1 then this is GS1-128. We add the symbology identifier.
                                    result += "]C1";
                                    else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                    result += String.fromCharCode(29);
                                }
                                break;
                            case Code128Reader.CODE_FNC_2:
                            case Code128Reader.CODE_FNC_3:
                                break;
                            case Code128Reader.CODE_FNC_4_A:
                                if (!upperMode && shiftUpperMode) {
                                    upperMode = true;
                                    shiftUpperMode = false;
                                } else if (upperMode && shiftUpperMode) {
                                    upperMode = false;
                                    shiftUpperMode = false;
                                } else shiftUpperMode = true;
                                break;
                            case Code128Reader.CODE_SHIFT:
                                isNextShifted = true;
                                codeSet = Code128Reader.CODE_CODE_B;
                                break;
                            case Code128Reader.CODE_CODE_B:
                                codeSet = Code128Reader.CODE_CODE_B;
                                break;
                            case Code128Reader.CODE_CODE_C:
                                codeSet = Code128Reader.CODE_CODE_C;
                                break;
                            case Code128Reader.CODE_STOP:
                                done = true;
                                break;
                        }
                    }
                    break;
                case Code128Reader.CODE_CODE_B:
                    if (code < 96) {
                        if (shiftUpperMode === upperMode) result += String.fromCharCode(" ".charCodeAt(0) + code);
                        else result += String.fromCharCode(" ".charCodeAt(0) + code + 128);
                        shiftUpperMode = false;
                    } else {
                        if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                        switch(code){
                            case Code128Reader.CODE_FNC_1:
                                if (convertFNC1) {
                                    if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                    // is FNC1 then this is GS1-128. We add the symbology identifier.
                                    result += "]C1";
                                    else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                    result += String.fromCharCode(29);
                                }
                                break;
                            case Code128Reader.CODE_FNC_2:
                            case Code128Reader.CODE_FNC_3:
                                break;
                            case Code128Reader.CODE_FNC_4_B:
                                if (!upperMode && shiftUpperMode) {
                                    upperMode = true;
                                    shiftUpperMode = false;
                                } else if (upperMode && shiftUpperMode) {
                                    upperMode = false;
                                    shiftUpperMode = false;
                                } else shiftUpperMode = true;
                                break;
                            case Code128Reader.CODE_SHIFT:
                                isNextShifted = true;
                                codeSet = Code128Reader.CODE_CODE_A;
                                break;
                            case Code128Reader.CODE_CODE_A:
                                codeSet = Code128Reader.CODE_CODE_A;
                                break;
                            case Code128Reader.CODE_CODE_C:
                                codeSet = Code128Reader.CODE_CODE_C;
                                break;
                            case Code128Reader.CODE_STOP:
                                done = true;
                                break;
                        }
                    }
                    break;
                case Code128Reader.CODE_CODE_C:
                    if (code < 100) {
                        if (code < 10) result += "0";
                        result += code;
                    } else {
                        if (code !== Code128Reader.CODE_STOP) lastCharacterWasPrintable = false;
                        switch(code){
                            case Code128Reader.CODE_FNC_1:
                                if (convertFNC1) {
                                    if (result.length === 0) // GS1 specification 5.4.3.7. and 5.4.6.4. If the first char after the start code
                                    // is FNC1 then this is GS1-128. We add the symbology identifier.
                                    result += "]C1";
                                    else // GS1 specification 5.4.7.5. Every subsequent FNC1 is returned as ASCII 29 (GS)
                                    result += String.fromCharCode(29);
                                }
                                break;
                            case Code128Reader.CODE_CODE_A:
                                codeSet = Code128Reader.CODE_CODE_A;
                                break;
                            case Code128Reader.CODE_CODE_B:
                                codeSet = Code128Reader.CODE_CODE_B;
                                break;
                            case Code128Reader.CODE_STOP:
                                done = true;
                                break;
                        }
                    }
                    break;
            }
            // Unshift back to another code set if we were shifted
            if (unshift) codeSet = codeSet === Code128Reader.CODE_CODE_A ? Code128Reader.CODE_CODE_B : Code128Reader.CODE_CODE_A;
        }
        var lastPatternSize = nextStart - lastStart;
        // Check for ample whitespace following pattern, but, to do this we first need to remember that
        // we fudged decoding CODE_STOP since it actually has 7 bars, not 6. There is a black bar left
        // to read off. Would be slightly better to properly read. Here we just skip it:
        nextStart = row.getNextUnset(nextStart);
        if (!row.isRange(nextStart, Math.min(row.getSize(), nextStart + (nextStart - lastStart) / 2), false)) throw new (0, $cQi30.default)();
        // Pull out from sum the value of the penultimate check code
        checksumTotal -= multiplier * lastCode;
        // lastCode is the checksum then:
        if (checksumTotal % 103 !== lastCode) throw new (0, $9Nn2d.default)();
        // Need to pull out the check digits from string
        var resultLength = result.length;
        if (resultLength === 0) // false positive
        throw new (0, $cQi30.default)();
        // Only bother if the result had at least one character, and if the checksum digit happened to
        // be a printable character. If it was just interpreted as a control code, nothing to remove.
        if (resultLength > 0 && lastCharacterWasPrintable) {
            if (codeSet === Code128Reader.CODE_CODE_C) result = result.substring(0, resultLength - 2);
            else result = result.substring(0, resultLength - 1);
        }
        var left = (startPatternInfo[1] + startPatternInfo[0]) / 2.0;
        var right = lastStart + lastPatternSize / 2.0;
        var rawCodesSize = rawCodes.length;
        var rawBytes = new Uint8Array(rawCodesSize);
        for(var i = 0; i < rawCodesSize; i++)rawBytes[i] = rawCodes[i];
        var points = [
            new (0, $fwBMA.default)(left, rowNumber),
            new (0, $fwBMA.default)(right, rowNumber)
        ];
        return new (0, $kWndQ.default)(result, rawBytes, 0, points, (0, $bx5V3.default).CODE_128, new Date().getTime());
    };
    Code128Reader.CODE_PATTERNS = [
        Int32Array.from([
            2,
            1,
            2,
            2,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            2,
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            2,
            3
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3,
            2,
            2
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            1,
            3
        ]),
        Int32Array.from([
            1,
            2,
            2,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            2,
            2,
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            2,
            3,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            2,
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            3,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            3,
            2,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            2,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            3,
            2,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            2,
            3
        ]),
        Int32Array.from([
            2,
            1,
            2,
            3,
            2,
            1
        ]),
        Int32Array.from([
            2,
            3,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            3,
            3
        ]),
        Int32Array.from([
            1,
            1,
            2,
            3,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            2,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            2,
            3
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            2,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            2,
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            2,
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            3,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            2,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            2,
            1
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            3,
            1,
            2,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            2,
            3,
            1,
            1
        ]),
        Int32Array.from([
            3,
            3,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            3,
            1,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            4,
            3,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2,
            4
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4,
            2,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2,
            4
        ]),
        Int32Array.from([
            1,
            2,
            1,
            4,
            2,
            1
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            2,
            1,
            4
        ]),
        Int32Array.from([
            1,
            1,
            2,
            4,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            2,
            2,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            4,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            4,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            4,
            1,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            2,
            4,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            3,
            4,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            4,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            2,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            4,
            2,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            4,
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            4,
            1
        ]),
        Int32Array.from([
            2,
            1,
            4,
            1,
            2,
            1
        ]),
        Int32Array.from([
            4,
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            4,
            3
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            4,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            1,
            4,
            3,
            1,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            4,
            1,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            4,
            1
        ]),
        Int32Array.from([
            1,
            1,
            4,
            1,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            4,
            1
        ]),
        Int32Array.from([
            4,
            1,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            4,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1,
            4
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            3,
            2
        ]),
        Int32Array.from([
            2,
            3,
            3,
            1,
            1,
            1,
            2
        ])
    ];
    Code128Reader.MAX_AVG_VARIANCE = 0.25;
    Code128Reader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    Code128Reader.CODE_SHIFT = 98;
    Code128Reader.CODE_CODE_C = 99;
    Code128Reader.CODE_CODE_B = 100;
    Code128Reader.CODE_CODE_A = 101;
    Code128Reader.CODE_FNC_1 = 102;
    Code128Reader.CODE_FNC_2 = 97;
    Code128Reader.CODE_FNC_3 = 96;
    Code128Reader.CODE_FNC_4_A = 101;
    Code128Reader.CODE_FNC_4_B = 100;
    Code128Reader.CODE_START_A = 103;
    Code128Reader.CODE_START_B = 104;
    Code128Reader.CODE_START_C = 105;
    Code128Reader.CODE_STOP = 106;
    return Code128Reader;
}((0, $itEYK.default));
var $d18dec767146ea22$export$2e2bcd8739ae039 = $d18dec767146ea22$var$Code128Reader;

});
parcelRegister("itEYK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d73ab8fb41c3c9ca$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fHKUB = parcelRequire("fHKUB");

var $b5DE3 = parcelRequire("b5DE3");

var $eS8qc = parcelRequire("eS8qc");

var $fwBMA = parcelRequire("fwBMA");

var $cQi30 = parcelRequire("cQi30");
/**
 * Encapsulates functionality and implementation that is common to all families
 * of one-dimensional barcodes.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 */ var $d73ab8fb41c3c9ca$var$OneDReader = /** @class */ function() {
    function OneDReader() {}
    /*
    @Override
    public Result decode(BinaryBitmap image) throws NotFoundException, FormatException {
      return decode(image, null);
    }
    */ // Note that we don't try rotation without the try harder flag, even if rotation was supported.
    // @Override
    OneDReader.prototype.decode = function(image, hints) {
        try {
            return this.doDecode(image, hints);
        } catch (nfe) {
            var tryHarder = hints && hints.get((0, $b5DE3.default).TRY_HARDER) === true;
            if (tryHarder && image.isRotateSupported()) {
                var rotatedImage = image.rotateCounterClockwise();
                var result = this.doDecode(rotatedImage, hints);
                // Record that we found it rotated 90 degrees CCW / 270 degrees CW
                var metadata = result.getResultMetadata();
                var orientation_1 = 270;
                if (metadata !== null && metadata.get((0, $eS8qc.default).ORIENTATION) === true) // But if we found it reversed in doDecode(), add in that result here:
                orientation_1 = orientation_1 + metadata.get((0, $eS8qc.default).ORIENTATION) % 360;
                result.putMetadata((0, $eS8qc.default).ORIENTATION, orientation_1);
                // Update result points
                var points = result.getResultPoints();
                if (points !== null) {
                    var height = rotatedImage.getHeight();
                    for(var i = 0; i < points.length; i++)points[i] = new (0, $fwBMA.default)(height - points[i].getY() - 1, points[i].getX());
                }
                return result;
            } else throw new (0, $cQi30.default)();
        }
    };
    // @Override
    OneDReader.prototype.reset = function() {
    // do nothing
    };
    /**
     * We're going to examine rows from the middle outward, searching alternately above and below the
     * middle, and farther out each time. rowStep is the number of rows between each successive
     * attempt above and below the middle. So we'd scan row middle, then middle - rowStep, then
     * middle + rowStep, then middle - (2 * rowStep), etc.
     * rowStep is bigger as the image is taller, but is always at least 1. We've somewhat arbitrarily
     * decided that moving up and down by about 1/16 of the image is pretty good; we try more of the
     * image if "trying harder".
     *
     * @param image The image to decode
     * @param hints Any hints that were requested
     * @return The contents of the decoded barcode
     * @throws NotFoundException Any spontaneous errors which occur
     */ OneDReader.prototype.doDecode = function(image, hints) {
        var width = image.getWidth();
        var height = image.getHeight();
        var row = new (0, $fHKUB.default)(width);
        var tryHarder = hints && hints.get((0, $b5DE3.default).TRY_HARDER) === true;
        var rowStep = Math.max(1, height >> (tryHarder ? 8 : 5));
        var maxLines;
        if (tryHarder) maxLines = height; // Look at the whole image, not just the center
        else maxLines = 15; // 15 rows spaced 1/32 apart is roughly the middle half of the image
        var middle = Math.trunc(height / 2);
        for(var x = 0; x < maxLines; x++){
            // Scanning from the middle out. Determine which row we're looking at next:
            var rowStepsAboveOrBelow = Math.trunc((x + 1) / 2);
            var isAbove = (x & 0x01) === 0; // i.e. is x even?
            var rowNumber = middle + rowStep * (isAbove ? rowStepsAboveOrBelow : -rowStepsAboveOrBelow);
            if (rowNumber < 0 || rowNumber >= height) break;
            // Estimate black point for this row and load it:
            try {
                row = image.getBlackRow(rowNumber, row);
            } catch (ignored) {
                continue;
            }
            var _loop_1 = function(attempt) {
                if (attempt === 1) {
                    row.reverse(); // reverse the row and continue
                    // This means we will only ever draw result points *once* in the life of this method
                    // since we want to avoid drawing the wrong points after flipping the row, and,
                    // don't want to clutter with noise from every single row scan -- just the scans
                    // that start on the center line.
                    if (hints && hints.get((0, $b5DE3.default).NEED_RESULT_POINT_CALLBACK) === true) {
                        var newHints_1 = new Map();
                        hints.forEach(function(hint, key) {
                            return newHints_1.set(key, hint);
                        });
                        newHints_1.delete((0, $b5DE3.default).NEED_RESULT_POINT_CALLBACK);
                        hints = newHints_1;
                    }
                }
                try {
                    // Look for a barcode
                    var result = this_1.decodeRow(rowNumber, row, hints);
                    // We found our barcode
                    if (attempt === 1) {
                        // But it was upside down, so note that
                        result.putMetadata((0, $eS8qc.default).ORIENTATION, 180);
                        // And remember to flip the result points horizontally.
                        var points = result.getResultPoints();
                        if (points !== null) {
                            points[0] = new (0, $fwBMA.default)(width - points[0].getX() - 1, points[0].getY());
                            points[1] = new (0, $fwBMA.default)(width - points[1].getX() - 1, points[1].getY());
                        }
                    }
                    return {
                        value: result
                    };
                } catch (re) {
                // continue -- just couldn't decode this row
                }
            };
            var this_1 = this;
            // While we have the image data in a BitArray, it's fairly cheap to reverse it in place to
            // handle decoding upside down barcodes.
            for(var attempt = 0; attempt < 2; attempt++){
                var state_1 = _loop_1(attempt);
                if (typeof state_1 === "object") return state_1.value;
            }
        }
        throw new (0, $cQi30.default)();
    };
    /**
     * Records the size of successive runs of white and black pixels in a row, starting at a given point.
     * The values are recorded in the given array, and the number of runs recorded is equal to the size
     * of the array. If the row starts on a white pixel at the given start point, then the first count
     * recorded is the run of white pixels starting from that point; likewise it is the count of a run
     * of black pixels if the row begin on a black pixels at that point.
     *
     * @param row row to count from
     * @param start offset into row to start at
     * @param counters array into which to record counts
     * @throws NotFoundException if counters cannot be filled entirely from row before running out
     *  of pixels
     */ OneDReader.recordPattern = function(row, start, counters) {
        var numCounters = counters.length;
        for(var index = 0; index < numCounters; index++)counters[index] = 0;
        var end = row.getSize();
        if (start >= end) throw new (0, $cQi30.default)();
        var isWhite = !row.get(start);
        var counterPosition = 0;
        var i = start;
        while(i < end){
            if (row.get(i) !== isWhite) counters[counterPosition]++;
            else {
                if (++counterPosition === numCounters) break;
                else {
                    counters[counterPosition] = 1;
                    isWhite = !isWhite;
                }
            }
            i++;
        }
        // If we read fully the last section of pixels and filled up our counters -- or filled
        // the last counter but ran off the side of the image, OK. Otherwise, a problem.
        if (!(counterPosition === numCounters || counterPosition === numCounters - 1 && i === end)) throw new (0, $cQi30.default)();
    };
    OneDReader.recordPatternInReverse = function(row, start, counters) {
        // This could be more efficient I guess
        var numTransitionsLeft = counters.length;
        var last = row.get(start);
        while(start > 0 && numTransitionsLeft >= 0)if (row.get(--start) !== last) {
            numTransitionsLeft--;
            last = !last;
        }
        if (numTransitionsLeft >= 0) throw new (0, $cQi30.default)();
        OneDReader.recordPattern(row, start + 1, counters);
    };
    /**
     * Determines how closely a set of observed counts of runs of black/white values matches a given
     * target pattern. This is reported as the ratio of the total variance from the expected pattern
     * proportions across all pattern elements, to the length of the pattern.
     *
     * @param counters observed counters
     * @param pattern expected pattern
     * @param maxIndividualVariance The most any counter can differ before we give up
     * @return ratio of total variance between counters and pattern compared to total pattern size
     */ OneDReader.patternMatchVariance = function(counters, pattern, maxIndividualVariance) {
        var numCounters = counters.length;
        var total = 0;
        var patternLength = 0;
        for(var i = 0; i < numCounters; i++){
            total += counters[i];
            patternLength += pattern[i];
        }
        if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this is too small
        // to reliably match, so fail:
        return Number.POSITIVE_INFINITY;
        var unitBarWidth = total / patternLength;
        maxIndividualVariance *= unitBarWidth;
        var totalVariance = 0.0;
        for(var x = 0; x < numCounters; x++){
            var counter = counters[x];
            var scaledPattern = pattern[x] * unitBarWidth;
            var variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
            if (variance > maxIndividualVariance) return Number.POSITIVE_INFINITY;
            totalVariance += variance;
        }
        return totalVariance / total;
    };
    return OneDReader;
}();
var $d73ab8fb41c3c9ca$export$2e2bcd8739ae039 = $d73ab8fb41c3c9ca$var$OneDReader;

});


parcelRegister("9BRcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ff0d5818ae0fc99$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $9Nn2d = parcelRequire("9Nn2d");

var $dtgr5 = parcelRequire("dtgr5");

var $cQi30 = parcelRequire("cQi30");

var $itEYK = parcelRequire("itEYK");

var $kWndQ = parcelRequire("kWndQ");

var $fwBMA = parcelRequire("fwBMA");
var $6ff0d5818ae0fc99$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6ff0d5818ae0fc99$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Decodes Code 39 barcodes. Supports "Full ASCII Code 39" if USE_CODE_39_EXTENDED_MODE is set.</p>
 *
 * @author Sean Owen
 * @see Code93Reader
 */ var $6ff0d5818ae0fc99$var$Code39Reader = /** @class */ function(_super) {
    $6ff0d5818ae0fc99$var$__extends(Code39Reader, _super);
    /**
     * Creates a reader that assumes all encoded data is data, and does not treat the final
     * character as a check digit. It will not decoded "extended Code 39" sequences.
     */ // public Code39Reader() {
    //   this(false);
    // }
    /**
     * Creates a reader that can be configured to check the last character as a check digit.
     * It will not decoded "extended Code 39" sequences.
     *
     * @param usingCheckDigit if true, treat the last data character as a check digit, not
     * data, and verify that the checksum passes.
     */ // public Code39Reader(boolean usingCheckDigit) {
    //   this(usingCheckDigit, false);
    // }
    /**
     * Creates a reader that can be configured to check the last character as a check digit,
     * or optionally attempt to decode "extended Code 39" sequences that are used to encode
     * the full ASCII character set.
     *
     * @param usingCheckDigit if true, treat the last data character as a check digit, not
     * data, and verify that the checksum passes.
     * @param extendedMode if true, will attempt to decode extended Code 39 sequences in the
     * text.
     */ function Code39Reader(usingCheckDigit, extendedMode) {
        if (usingCheckDigit === void 0) usingCheckDigit = false;
        if (extendedMode === void 0) extendedMode = false;
        var _this = _super.call(this) || this;
        _this.usingCheckDigit = usingCheckDigit;
        _this.extendedMode = extendedMode;
        _this.decodeRowResult = "";
        _this.counters = new Int32Array(9);
        return _this;
    }
    Code39Reader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a, e_2, _b;
        var theCounters = this.counters;
        theCounters.fill(0);
        this.decodeRowResult = "";
        var start = Code39Reader.findAsteriskPattern(row, theCounters);
        // Read off white space
        var nextStart = row.getNextSet(start[1]);
        var end = row.getSize();
        var decodedChar;
        var lastStart;
        do {
            Code39Reader.recordPattern(row, nextStart, theCounters);
            var pattern = Code39Reader.toNarrowWidePattern(theCounters);
            if (pattern < 0) throw new (0, $cQi30.default)();
            decodedChar = Code39Reader.patternToChar(pattern);
            this.decodeRowResult += decodedChar;
            lastStart = nextStart;
            try {
                for(var theCounters_1 = (e_1 = void 0, $6ff0d5818ae0fc99$var$__values(theCounters)), theCounters_1_1 = theCounters_1.next(); !theCounters_1_1.done; theCounters_1_1 = theCounters_1.next()){
                    var counter = theCounters_1_1.value;
                    nextStart += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (theCounters_1_1 && !theCounters_1_1.done && (_a = theCounters_1.return)) _a.call(theCounters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Read off white space
            nextStart = row.getNextSet(nextStart);
        }while (decodedChar !== "*");
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1); // remove asterisk
        // Look for whitespace after pattern:
        var lastPatternSize = 0;
        try {
            for(var theCounters_2 = $6ff0d5818ae0fc99$var$__values(theCounters), theCounters_2_1 = theCounters_2.next(); !theCounters_2_1.done; theCounters_2_1 = theCounters_2.next()){
                var counter = theCounters_2_1.value;
                lastPatternSize += counter;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (theCounters_2_1 && !theCounters_2_1.done && (_b = theCounters_2.return)) _b.call(theCounters_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var whiteSpaceAfterEnd = nextStart - lastStart - lastPatternSize;
        // If 50% of last pattern size, following last pattern, is not whitespace, fail
        // (but if it's whitespace to the very end of the image, that's OK)
        if (nextStart !== end && whiteSpaceAfterEnd * 2 < lastPatternSize) throw new (0, $cQi30.default)();
        if (this.usingCheckDigit) {
            var max = this.decodeRowResult.length - 1;
            var total = 0;
            for(var i = 0; i < max; i++)total += Code39Reader.ALPHABET_STRING.indexOf(this.decodeRowResult.charAt(i));
            if (this.decodeRowResult.charAt(max) !== Code39Reader.ALPHABET_STRING.charAt(total % 43)) throw new (0, $9Nn2d.default)();
            this.decodeRowResult = this.decodeRowResult.substring(0, max);
        }
        if (this.decodeRowResult.length === 0) // false positive
        throw new (0, $cQi30.default)();
        var resultString;
        if (this.extendedMode) resultString = Code39Reader.decodeExtended(this.decodeRowResult);
        else resultString = this.decodeRowResult;
        var left = (start[1] + start[0]) / 2.0;
        var right = lastStart + lastPatternSize / 2.0;
        return new (0, $kWndQ.default)(resultString, null, 0, [
            new (0, $fwBMA.default)(left, rowNumber),
            new (0, $fwBMA.default)(right, rowNumber)
        ], (0, $bx5V3.default).CODE_39, new Date().getTime());
    };
    Code39Reader.findAsteriskPattern = function(row, counters) {
        var width = row.getSize();
        var rowOffset = row.getNextSet(0);
        var counterPosition = 0;
        var patternStart = rowOffset;
        var isWhite = false;
        var patternLength = counters.length;
        for(var i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                // Look for whitespace before start pattern, >= 50% of width of start pattern
                if (this.toNarrowWidePattern(counters) === Code39Reader.ASTERISK_ENCODING && row.isRange(Math.max(0, patternStart - Math.floor((i - patternStart) / 2)), patternStart, false)) return [
                    patternStart,
                    i
                ];
                patternStart += counters[0] + counters[1];
                counters.copyWithin(0, 2, 2 + counterPosition - 1);
                counters[counterPosition - 1] = 0;
                counters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $cQi30.default)();
    };
    // For efficiency, returns -1 on failure. Not throwing here saved as many as 700 exceptions
    // per image when using some of our blackbox images.
    Code39Reader.toNarrowWidePattern = function(counters) {
        var e_3, _a;
        var numCounters = counters.length;
        var maxNarrowCounter = 0;
        var wideCounters;
        do {
            var minCounter = 0x7fffffff;
            try {
                for(var counters_1 = (e_3 = void 0, $6ff0d5818ae0fc99$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    if (counter < minCounter && counter > maxNarrowCounter) minCounter = counter;
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            maxNarrowCounter = minCounter;
            wideCounters = 0;
            var totalWideCountersWidth = 0;
            var pattern = 0;
            for(var i = 0; i < numCounters; i++){
                var counter = counters[i];
                if (counter > maxNarrowCounter) {
                    pattern |= 1 << numCounters - 1 - i;
                    wideCounters++;
                    totalWideCountersWidth += counter;
                }
            }
            if (wideCounters === 3) {
                // Found 3 wide counters, but are they close enough in width?
                // We can perform a cheap, conservative check to see if any individual
                // counter is more than 1.5 times the average:
                for(var i = 0; i < numCounters && wideCounters > 0; i++){
                    var counter = counters[i];
                    if (counter > maxNarrowCounter) {
                        wideCounters--;
                        // totalWideCountersWidth = 3 * average, so this checks if counter >= 3/2 * average
                        if (counter * 2 >= totalWideCountersWidth) return -1;
                    }
                }
                return pattern;
            }
        }while (wideCounters > 3);
        return -1;
    };
    Code39Reader.patternToChar = function(pattern) {
        for(var i = 0; i < Code39Reader.CHARACTER_ENCODINGS.length; i++){
            if (Code39Reader.CHARACTER_ENCODINGS[i] === pattern) return Code39Reader.ALPHABET_STRING.charAt(i);
        }
        if (pattern === Code39Reader.ASTERISK_ENCODING) return "*";
        throw new (0, $cQi30.default)();
    };
    Code39Reader.decodeExtended = function(encoded) {
        var length = encoded.length;
        var decoded = "";
        for(var i = 0; i < length; i++){
            var c = encoded.charAt(i);
            if (c === "+" || c === "$" || c === "%" || c === "/") {
                var next = encoded.charAt(i + 1);
                var decodedChar = "\0";
                switch(c){
                    case "+":
                        // +A to +Z map to a to z
                        if (next >= "A" && next <= "Z") decodedChar = String.fromCharCode(next.charCodeAt(0) + 32);
                        else throw new (0, $dtgr5.default)();
                        break;
                    case "$":
                        // $A to $Z map to control codes SH to SB
                        if (next >= "A" && next <= "Z") decodedChar = String.fromCharCode(next.charCodeAt(0) - 64);
                        else throw new (0, $dtgr5.default)();
                        break;
                    case "%":
                        // %A to %E map to control codes ESC to US
                        if (next >= "A" && next <= "E") decodedChar = String.fromCharCode(next.charCodeAt(0) - 38);
                        else if (next >= "F" && next <= "J") decodedChar = String.fromCharCode(next.charCodeAt(0) - 11);
                        else if (next >= "K" && next <= "O") decodedChar = String.fromCharCode(next.charCodeAt(0) + 16);
                        else if (next >= "P" && next <= "T") decodedChar = String.fromCharCode(next.charCodeAt(0) + 43);
                        else if (next === "U") decodedChar = "\0";
                        else if (next === "V") decodedChar = "@";
                        else if (next === "W") decodedChar = "`";
                        else if (next === "X" || next === "Y" || next === "Z") decodedChar = "\x7f";
                        else throw new (0, $dtgr5.default)();
                        break;
                    case "/":
                        // /A to /O map to ! to , and /Z maps to :
                        if (next >= "A" && next <= "O") decodedChar = String.fromCharCode(next.charCodeAt(0) - 32);
                        else if (next === "Z") decodedChar = ":";
                        else throw new (0, $dtgr5.default)();
                        break;
                }
                decoded += decodedChar;
                // bump up i again since we read two characters
                i++;
            } else decoded += c;
        }
        return decoded;
    };
    Code39Reader.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%";
    /**
     * These represent the encodings of characters, as patterns of wide and narrow bars.
     * The 9 least-significant bits of each int correspond to the pattern of wide and narrow,
     * with 1s representing "wide" and 0s representing narrow.
     */ Code39Reader.CHARACTER_ENCODINGS = [
        0x034,
        0x121,
        0x061,
        0x160,
        0x031,
        0x130,
        0x070,
        0x025,
        0x124,
        0x064,
        0x109,
        0x049,
        0x148,
        0x019,
        0x118,
        0x058,
        0x00D,
        0x10C,
        0x04C,
        0x01C,
        0x103,
        0x043,
        0x142,
        0x013,
        0x112,
        0x052,
        0x007,
        0x106,
        0x046,
        0x016,
        0x181,
        0x0C1,
        0x1C0,
        0x091,
        0x190,
        0x0D0,
        0x085,
        0x184,
        0x0C4,
        0x0A8,
        0x0A2,
        0x08A,
        0x02A // /-%
    ];
    Code39Reader.ASTERISK_ENCODING = 0x094;
    return Code39Reader;
}((0, $itEYK.default));
var $6ff0d5818ae0fc99$export$2e2bcd8739ae039 = $6ff0d5818ae0fc99$var$Code39Reader;

});

parcelRegister("a0iHq", function(module, exports) {

$parcel$export(module.exports, "default", () => $748868c65cadd5d9$export$2e2bcd8739ae039);
/*
 * Copyright 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $9Nn2d = parcelRequire("9Nn2d");

var $dtgr5 = parcelRequire("dtgr5");

var $cQi30 = parcelRequire("cQi30");

var $itEYK = parcelRequire("itEYK");

var $kWndQ = parcelRequire("kWndQ");

var $fwBMA = parcelRequire("fwBMA");
var $748868c65cadd5d9$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $748868c65cadd5d9$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Decodes Code 93 barcodes.</p>
 *
 * @author Sean Owen
 * @see Code39Reader
 */ var $748868c65cadd5d9$var$Code93Reader = /** @class */ function(_super) {
    $748868c65cadd5d9$var$__extends(Code93Reader, _super);
    //public Code93Reader() {
    //  decodeRowResult = new StringBuilder(20);
    //  counters = new int[6];
    //}
    function Code93Reader() {
        var _this = _super.call(this) || this;
        _this.decodeRowResult = "";
        _this.counters = new Int32Array(6);
        return _this;
    }
    Code93Reader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a, e_2, _b;
        var start = this.findAsteriskPattern(row);
        // Read off white space
        var nextStart = row.getNextSet(start[1]);
        var end = row.getSize();
        var theCounters = this.counters;
        theCounters.fill(0);
        this.decodeRowResult = "";
        var decodedChar;
        var lastStart;
        do {
            Code93Reader.recordPattern(row, nextStart, theCounters);
            var pattern = this.toPattern(theCounters);
            if (pattern < 0) throw new (0, $cQi30.default)();
            decodedChar = this.patternToChar(pattern);
            this.decodeRowResult += decodedChar;
            lastStart = nextStart;
            try {
                for(var theCounters_1 = (e_1 = void 0, $748868c65cadd5d9$var$__values(theCounters)), theCounters_1_1 = theCounters_1.next(); !theCounters_1_1.done; theCounters_1_1 = theCounters_1.next()){
                    var counter = theCounters_1_1.value;
                    nextStart += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (theCounters_1_1 && !theCounters_1_1.done && (_a = theCounters_1.return)) _a.call(theCounters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Read off white space
            nextStart = row.getNextSet(nextStart);
        }while (decodedChar !== "*");
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 1); // remove asterisk
        var lastPatternSize = 0;
        try {
            for(var theCounters_2 = $748868c65cadd5d9$var$__values(theCounters), theCounters_2_1 = theCounters_2.next(); !theCounters_2_1.done; theCounters_2_1 = theCounters_2.next()){
                var counter = theCounters_2_1.value;
                lastPatternSize += counter;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (theCounters_2_1 && !theCounters_2_1.done && (_b = theCounters_2.return)) _b.call(theCounters_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        // Should be at least one more black module
        if (nextStart === end || !row.get(nextStart)) throw new (0, $cQi30.default)();
        if (this.decodeRowResult.length < 2) // false positive -- need at least 2 checksum digits
        throw new (0, $cQi30.default)();
        this.checkChecksums(this.decodeRowResult);
        // Remove checksum digits
        this.decodeRowResult = this.decodeRowResult.substring(0, this.decodeRowResult.length - 2);
        var resultString = this.decodeExtended(this.decodeRowResult);
        var left = (start[1] + start[0]) / 2.0;
        var right = lastStart + lastPatternSize / 2.0;
        return new (0, $kWndQ.default)(resultString, null, 0, [
            new (0, $fwBMA.default)(left, rowNumber),
            new (0, $fwBMA.default)(right, rowNumber)
        ], (0, $bx5V3.default).CODE_93, new Date().getTime());
    };
    Code93Reader.prototype.findAsteriskPattern = function(row) {
        var width = row.getSize();
        var rowOffset = row.getNextSet(0);
        this.counters.fill(0);
        var theCounters = this.counters;
        var patternStart = rowOffset;
        var isWhite = false;
        var patternLength = theCounters.length;
        var counterPosition = 0;
        for(var i = rowOffset; i < width; i++)if (row.get(i) !== isWhite) theCounters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                if (this.toPattern(theCounters) === Code93Reader.ASTERISK_ENCODING) return new Int32Array([
                    patternStart,
                    i
                ]);
                patternStart += theCounters[0] + theCounters[1];
                theCounters.copyWithin(0, 2, 2 + counterPosition - 1);
                theCounters[counterPosition - 1] = 0;
                theCounters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            theCounters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $cQi30.default);
    };
    Code93Reader.prototype.toPattern = function(counters) {
        var e_3, _a;
        var sum = 0;
        try {
            for(var counters_1 = $748868c65cadd5d9$var$__values(counters), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                var counter = counters_1_1.value;
                sum += counter;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        var pattern = 0;
        var max = counters.length;
        for(var i = 0; i < max; i++){
            var scaled = Math.round(counters[i] * 9.0 / sum);
            if (scaled < 1 || scaled > 4) return -1;
            if ((i & 0x01) === 0) for(var j = 0; j < scaled; j++)pattern = pattern << 1 | 0x01;
            else pattern <<= scaled;
        }
        return pattern;
    };
    Code93Reader.prototype.patternToChar = function(pattern) {
        for(var i = 0; i < Code93Reader.CHARACTER_ENCODINGS.length; i++){
            if (Code93Reader.CHARACTER_ENCODINGS[i] === pattern) return Code93Reader.ALPHABET_STRING.charAt(i);
        }
        throw new (0, $cQi30.default)();
    };
    Code93Reader.prototype.decodeExtended = function(encoded) {
        var length = encoded.length;
        var decoded = "";
        for(var i = 0; i < length; i++){
            var c = encoded.charAt(i);
            if (c >= "a" && c <= "d") {
                if (i >= length - 1) throw new (0, $dtgr5.default)();
                var next = encoded.charAt(i + 1);
                var decodedChar = "\0";
                switch(c){
                    case "d":
                        // +A to +Z map to a to z
                        if (next >= "A" && next <= "Z") decodedChar = String.fromCharCode(next.charCodeAt(0) + 32);
                        else throw new (0, $dtgr5.default)();
                        break;
                    case "a":
                        // $A to $Z map to control codes SH to SB
                        if (next >= "A" && next <= "Z") decodedChar = String.fromCharCode(next.charCodeAt(0) - 64);
                        else throw new (0, $dtgr5.default)();
                        break;
                    case "b":
                        if (next >= "A" && next <= "E") // %A to %E map to control codes ESC to USep
                        decodedChar = String.fromCharCode(next.charCodeAt(0) - 38);
                        else if (next >= "F" && next <= "J") // %F to %J map to ; < = > ?
                        decodedChar = String.fromCharCode(next.charCodeAt(0) - 11);
                        else if (next >= "K" && next <= "O") // %K to %O map to [ \ ] ^ _
                        decodedChar = String.fromCharCode(next.charCodeAt(0) + 16);
                        else if (next >= "P" && next <= "T") // %P to %T map to { | } ~ DEL
                        decodedChar = String.fromCharCode(next.charCodeAt(0) + 43);
                        else if (next === "U") // %U map to NUL
                        decodedChar = "\0";
                        else if (next === "V") // %V map to @
                        decodedChar = "@";
                        else if (next === "W") // %W map to `
                        decodedChar = "`";
                        else if (next >= "X" && next <= "Z") // %X to %Z all map to DEL (127)
                        decodedChar = String.fromCharCode(127);
                        else throw new (0, $dtgr5.default)();
                        break;
                    case "c":
                        // /A to /O map to ! to , and /Z maps to :
                        if (next >= "A" && next <= "O") decodedChar = String.fromCharCode(next.charCodeAt(0) - 32);
                        else if (next === "Z") decodedChar = ":";
                        else throw new (0, $dtgr5.default)();
                        break;
                }
                decoded += decodedChar;
                // bump up i again since we read two characters
                i++;
            } else decoded += c;
        }
        return decoded;
    };
    Code93Reader.prototype.checkChecksums = function(result) {
        var length = result.length;
        this.checkOneChecksum(result, length - 2, 20);
        this.checkOneChecksum(result, length - 1, 15);
    };
    Code93Reader.prototype.checkOneChecksum = function(result, checkPosition, weightMax) {
        var weight = 1;
        var total = 0;
        for(var i = checkPosition - 1; i >= 0; i--){
            total += weight * Code93Reader.ALPHABET_STRING.indexOf(result.charAt(i));
            if (++weight > weightMax) weight = 1;
        }
        if (result.charAt(checkPosition) !== Code93Reader.ALPHABET_STRING[total % 47]) throw new (0, $9Nn2d.default);
    };
    // Note that 'abcd' are dummy characters in place of control characters.
    Code93Reader.ALPHABET_STRING = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-. $/+%abcd*";
    /**
     * These represent the encodings of characters, as patterns of wide and narrow bars.
     * The 9 least-significant bits of each int correspond to the pattern of wide and narrow.
     */ Code93Reader.CHARACTER_ENCODINGS = [
        0x114,
        0x148,
        0x144,
        0x142,
        0x128,
        0x124,
        0x122,
        0x150,
        0x112,
        0x10A,
        0x1A8,
        0x1A4,
        0x1A2,
        0x194,
        0x192,
        0x18A,
        0x168,
        0x164,
        0x162,
        0x134,
        0x11A,
        0x158,
        0x14C,
        0x146,
        0x12C,
        0x116,
        0x1B4,
        0x1B2,
        0x1AC,
        0x1A6,
        0x196,
        0x19A,
        0x16C,
        0x166,
        0x136,
        0x13A,
        0x12E,
        0x1D4,
        0x1D2,
        0x1CA,
        0x16E,
        0x176,
        0x1AE,
        0x126,
        0x1DA,
        0x1D6,
        0x132,
        0x15E
    ];
    Code93Reader.ASTERISK_ENCODING = Code93Reader.CHARACTER_ENCODINGS[47];
    return Code93Reader;
}((0, $itEYK.default));
var $748868c65cadd5d9$export$2e2bcd8739ae039 = $748868c65cadd5d9$var$Code93Reader;

});

parcelRegister("7oKct", function(module, exports) {

$parcel$export(module.exports, "default", () => $562e9cae2a88994a$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $b5DE3 = parcelRequire("b5DE3");

var $dtgr5 = parcelRequire("dtgr5");

var $cQi30 = parcelRequire("cQi30");

var $kWndQ = parcelRequire("kWndQ");

var $fwBMA = parcelRequire("fwBMA");

var $6E9N1 = parcelRequire("6E9N1");

var $b6IL4 = parcelRequire("b6IL4");

var $itEYK = parcelRequire("itEYK");
var $562e9cae2a88994a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $562e9cae2a88994a$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Decodes ITF barcodes.</p>
 *
 * @author Tjieco
 */ var $562e9cae2a88994a$var$ITFReader = /** @class */ function(_super) {
    $562e9cae2a88994a$var$__extends(ITFReader, _super);
    function ITFReader() {
        // private static W = 3; // Pixel width of a 3x wide line
        // private static w = 2; // Pixel width of a 2x wide line
        // private static N = 1; // Pixed width of a narrow line
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Stores the actual narrow line width of the image being decoded.
        _this.narrowLineWidth = -1;
        return _this;
    }
    // See ITFWriter.PATTERNS
    /*
  
    /!**
     * Patterns of Wide / Narrow lines to indicate each digit
     *!/
    */ ITFReader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a;
        // Find out where the Middle section (payload) starts & ends
        var startRange = this.decodeStart(row);
        var endRange = this.decodeEnd(row);
        var result = new (0, $6E9N1.default)();
        ITFReader.decodeMiddle(row, startRange[1], endRange[0], result);
        var resultString = result.toString();
        var allowedLengths = null;
        if (hints != null) allowedLengths = hints.get((0, $b5DE3.default).ALLOWED_LENGTHS);
        if (allowedLengths == null) allowedLengths = ITFReader.DEFAULT_ALLOWED_LENGTHS;
        // To avoid false positives with 2D barcodes (and other patterns), make
        // an assumption that the decoded string must be a 'standard' length if it's short
        var length = resultString.length;
        var lengthOK = false;
        var maxAllowedLength = 0;
        try {
            for(var allowedLengths_1 = $562e9cae2a88994a$var$__values(allowedLengths), allowedLengths_1_1 = allowedLengths_1.next(); !allowedLengths_1_1.done; allowedLengths_1_1 = allowedLengths_1.next()){
                var value = allowedLengths_1_1.value;
                if (length === value) {
                    lengthOK = true;
                    break;
                }
                if (value > maxAllowedLength) maxAllowedLength = value;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (allowedLengths_1_1 && !allowedLengths_1_1.done && (_a = allowedLengths_1.return)) _a.call(allowedLengths_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (!lengthOK && length > maxAllowedLength) lengthOK = true;
        if (!lengthOK) throw new (0, $dtgr5.default)();
        var points = [
            new (0, $fwBMA.default)(startRange[1], rowNumber),
            new (0, $fwBMA.default)(endRange[0], rowNumber)
        ];
        var resultReturn = new (0, $kWndQ.default)(resultString, null, 0, points, (0, $bx5V3.default).ITF, new Date().getTime());
        return resultReturn;
    };
    /*
    /!**
     * @param row          row of black/white values to search
     * @param payloadStart offset of start pattern
     * @param resultString {@link StringBuilder} to append decoded chars to
     * @throws NotFoundException if decoding could not complete successfully
     *!/*/ ITFReader.decodeMiddle = function(row, payloadStart, payloadEnd, resultString) {
        // Digits are interleaved in pairs - 5 black lines for one digit, and the
        // 5
        // interleaved white lines for the second digit.
        // Therefore, need to scan 10 lines and then
        // split these into two arrays
        var counterDigitPair = new Int32Array(10); // 10
        var counterBlack = new Int32Array(5); // 5
        var counterWhite = new Int32Array(5); // 5
        counterDigitPair.fill(0);
        counterBlack.fill(0);
        counterWhite.fill(0);
        while(payloadStart < payloadEnd){
            // Get 10 runs of black/white.
            (0, $itEYK.default).recordPattern(row, payloadStart, counterDigitPair);
            // Split them into each array
            for(var k = 0; k < 5; k++){
                var twoK = 2 * k;
                counterBlack[k] = counterDigitPair[twoK];
                counterWhite[k] = counterDigitPair[twoK + 1];
            }
            var bestMatch = ITFReader.decodeDigit(counterBlack);
            resultString.append(bestMatch.toString());
            bestMatch = this.decodeDigit(counterWhite);
            resultString.append(bestMatch.toString());
            counterDigitPair.forEach(function(counterDigit) {
                payloadStart += counterDigit;
            });
        }
    };
    /*/!**
     * Identify where the start of the middle / payload section starts.
     *
     * @param row row of black/white values to search
     * @return Array, containing index of start of 'start block' and end of
     *         'start block'
     *!/*/ ITFReader.prototype.decodeStart = function(row) {
        var endStart = ITFReader.skipWhiteSpace(row);
        var startPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.START_PATTERN);
        // Determine the width of a narrow line in pixels. We can do this by
        // getting the width of the start pattern and dividing by 4 because its
        // made up of 4 narrow lines.
        this.narrowLineWidth = (startPattern[1] - startPattern[0]) / 4;
        this.validateQuietZone(row, startPattern[0]);
        return startPattern;
    };
    /*/!**
     * The start & end patterns must be pre/post fixed by a quiet zone. This
     * zone must be at least 10 times the width of a narrow line.  Scan back until
     * we either get to the start of the barcode or match the necessary number of
     * quiet zone pixels.
     *
     * Note: Its assumed the row is reversed when using this method to find
     * quiet zone after the end pattern.
     *
     * ref: http://www.barcode-1.net/i25code.html
     *
     * @param row bit array representing the scanned barcode.
     * @param startPattern index into row of the start or end pattern.
     * @throws NotFoundException if the quiet zone cannot be found
     *!/*/ ITFReader.prototype.validateQuietZone = function(row, startPattern) {
        var quietCount = this.narrowLineWidth * 10; // expect to find this many pixels of quiet zone
        // if there are not so many pixel at all let's try as many as possible
        quietCount = quietCount < startPattern ? quietCount : startPattern;
        for(var i = startPattern - 1; quietCount > 0 && i >= 0; i--){
            if (row.get(i)) break;
            quietCount--;
        }
        if (quietCount !== 0) // Unable to find the necessary number of quiet zone pixels.
        throw new (0, $cQi30.default)();
    };
    /*
    /!**
     * Skip all whitespace until we get to the first black line.
     *
     * @param row row of black/white values to search
     * @return index of the first black line.
     * @throws NotFoundException Throws exception if no black lines are found in the row
     *!/*/ ITFReader.skipWhiteSpace = function(row) {
        var width = row.getSize();
        var endStart = row.getNextSet(0);
        if (endStart === width) throw new (0, $cQi30.default)();
        return endStart;
    };
    /*/!**
     * Identify where the end of the middle / payload section ends.
     *
     * @param row row of black/white values to search
     * @return Array, containing index of start of 'end block' and end of 'end
     *         block'
     *!/*/ ITFReader.prototype.decodeEnd = function(row) {
        // For convenience, reverse the row and then
        // search from 'the start' for the end block
        row.reverse();
        try {
            var endStart = ITFReader.skipWhiteSpace(row);
            var endPattern = void 0;
            try {
                endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[0]);
            } catch (error) {
                if (error instanceof (0, $cQi30.default)) endPattern = ITFReader.findGuardPattern(row, endStart, ITFReader.END_PATTERN_REVERSED[1]);
            }
            // The start & end patterns must be pre/post fixed by a quiet zone. This
            // zone must be at least 10 times the width of a narrow line.
            // ref: http://www.barcode-1.net/i25code.html
            this.validateQuietZone(row, endPattern[0]);
            // Now recalculate the indices of where the 'endblock' starts & stops to
            // accommodate
            // the reversed nature of the search
            var temp = endPattern[0];
            endPattern[0] = row.getSize() - endPattern[1];
            endPattern[1] = row.getSize() - temp;
            return endPattern;
        } finally{
            // Put the row back the right way.
            row.reverse();
        }
    };
    /*
    /!**
     * @param row       row of black/white values to search
     * @param rowOffset position to start search
     * @param pattern   pattern of counts of number of black and white pixels that are
     *                  being searched for as a pattern
     * @return start/end horizontal offset of guard pattern, as an array of two
     *         ints
     * @throws NotFoundException if pattern is not found
     *!/*/ ITFReader.findGuardPattern = function(row, rowOffset, pattern) {
        var patternLength = pattern.length;
        var counters = new Int32Array(patternLength);
        var width = row.getSize();
        var isWhite = false;
        var counterPosition = 0;
        var patternStart = rowOffset;
        counters.fill(0);
        for(var x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                if ((0, $itEYK.default).patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE) < ITFReader.MAX_AVG_VARIANCE) return [
                    patternStart,
                    x
                ];
                patternStart += counters[0] + counters[1];
                (0, $b6IL4.default).arraycopy(counters, 2, counters, 0, counterPosition - 1);
                counters[counterPosition - 1] = 0;
                counters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $cQi30.default)();
    };
    /*/!**
     * Attempts to decode a sequence of ITF black/white lines into single
     * digit.
     *
     * @param counters the counts of runs of observed black/white/black/... values
     * @return The decoded digit
     * @throws NotFoundException if digit cannot be decoded
     *!/*/ ITFReader.decodeDigit = function(counters) {
        var bestVariance = ITFReader.MAX_AVG_VARIANCE; // worst variance we'll accept
        var bestMatch = -1;
        var max = ITFReader.PATTERNS.length;
        for(var i = 0; i < max; i++){
            var pattern = ITFReader.PATTERNS[i];
            var variance = (0, $itEYK.default).patternMatchVariance(counters, pattern, ITFReader.MAX_INDIVIDUAL_VARIANCE);
            if (variance < bestVariance) {
                bestVariance = variance;
                bestMatch = i;
            } else if (variance === bestVariance) // if we find a second 'best match' with the same variance, we can not reliably report to have a suitable match
            bestMatch = -1;
        }
        if (bestMatch >= 0) return bestMatch % 10;
        else throw new (0, $cQi30.default)();
    };
    ITFReader.PATTERNS = [
        Int32Array.from([
            1,
            1,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            1,
            2
        ]),
        Int32Array.from([
            2,
            2,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            2,
            1,
            2
        ]),
        Int32Array.from([
            2,
            1,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            2,
            2,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            2,
            2
        ]),
        Int32Array.from([
            2,
            1,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            2,
            1,
            2,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            3,
            1
        ]),
        Int32Array.from([
            3,
            1,
            1,
            1,
            3
        ]),
        Int32Array.from([
            1,
            3,
            1,
            1,
            3
        ]),
        Int32Array.from([
            3,
            3,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            3,
            3,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            3,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            3,
            1
        ]),
        Int32Array.from([
            1,
            3,
            1,
            3,
            1
        ]) // 9
    ];
    ITFReader.MAX_AVG_VARIANCE = 0.38;
    ITFReader.MAX_INDIVIDUAL_VARIANCE = 0.5;
    /* /!** Valid ITF lengths. Anything longer than the largest value is also allowed. *!/*/ ITFReader.DEFAULT_ALLOWED_LENGTHS = [
        6,
        8,
        10,
        12,
        14
    ];
    /*/!**
     * Start/end guard pattern.
     *
     * Note: The end pattern is reversed because the row is reversed before
     * searching for the END_PATTERN
     *!/*/ ITFReader.START_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1
    ]);
    ITFReader.END_PATTERN_REVERSED = [
        Int32Array.from([
            1,
            1,
            2
        ]),
        Int32Array.from([
            1,
            1,
            3
        ]) // 3x
    ];
    return ITFReader;
}((0, $itEYK.default));
var $562e9cae2a88994a$export$2e2bcd8739ae039 = $562e9cae2a88994a$var$ITFReader;

});

parcelRegister("erVrW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a85026964ecb3b94$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $b5DE3 = parcelRequire("b5DE3");

var $kWndQ = parcelRequire("kWndQ");

var $itEYK = parcelRequire("itEYK");

var $fGbQr = parcelRequire("fGbQr");

var $33ZIS = parcelRequire("33ZIS");

var $kVUZ4 = parcelRequire("kVUZ4");

var $cQi30 = parcelRequire("cQi30");

var $5DDYL = parcelRequire("5DDYL");
var $a85026964ecb3b94$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $a85026964ecb3b94$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>A reader that can read all available UPC/EAN formats. If a caller wants to try to
 * read all such formats, it is most efficient to use this implementation rather than invoke
 * individual readers.</p>
 *
 * @author Sean Owen
 */ var $a85026964ecb3b94$var$MultiFormatUPCEANReader = /** @class */ function(_super) {
    $a85026964ecb3b94$var$__extends(MultiFormatUPCEANReader, _super);
    function MultiFormatUPCEANReader(hints) {
        var _this = _super.call(this) || this;
        var possibleFormats = hints == null ? null : hints.get((0, $b5DE3.default).POSSIBLE_FORMATS);
        var readers = [];
        if (possibleFormats != null) {
            if (possibleFormats.indexOf((0, $bx5V3.default).EAN_13) > -1) readers.push(new (0, $fGbQr.default)());
            if (possibleFormats.indexOf((0, $bx5V3.default).UPC_A) > -1) readers.push(new (0, $kVUZ4.default)());
            if (possibleFormats.indexOf((0, $bx5V3.default).EAN_8) > -1) readers.push(new (0, $33ZIS.default)());
            if (possibleFormats.indexOf((0, $bx5V3.default).UPC_E) > -1) readers.push(new (0, $5DDYL.default)());
        }
        if (readers.length === 0) {
            readers.push(new (0, $fGbQr.default)());
            readers.push(new (0, $kVUZ4.default)());
            readers.push(new (0, $33ZIS.default)());
            readers.push(new (0, $5DDYL.default)());
        }
        _this.readers = readers;
        return _this;
    }
    MultiFormatUPCEANReader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a;
        try {
            for(var _b = $a85026964ecb3b94$var$__values(this.readers), _c = _b.next(); !_c.done; _c = _b.next()){
                var reader = _c.value;
                try {
                    // const result: Result = reader.decodeRow(rowNumber, row, startGuardPattern, hints);
                    var result = reader.decodeRow(rowNumber, row, hints);
                    // Special case: a 12-digit code encoded in UPC-A is identical to a "0"
                    // followed by those 12 digits encoded as EAN-13. Each will recognize such a code,
                    // UPC-A as a 12-digit string and EAN-13 as a 13-digit string starting with "0".
                    // Individually these are correct and their readers will both read such a code
                    // and correctly call it EAN-13, or UPC-A, respectively.
                    //
                    // In this case, if we've been looking for both types, we'd like to call it
                    // a UPC-A code. But for efficiency we only run the EAN-13 decoder to also read
                    // UPC-A. So we special case it here, and convert an EAN-13 result to a UPC-A
                    // result if appropriate.
                    //
                    // But, don't return UPC-A if UPC-A was not a requested format!
                    var ean13MayBeUPCA = result.getBarcodeFormat() === (0, $bx5V3.default).EAN_13 && result.getText().charAt(0) === "0";
                    // @SuppressWarnings("unchecked")
                    var possibleFormats = hints == null ? null : hints.get((0, $b5DE3.default).POSSIBLE_FORMATS);
                    var canReturnUPCA = possibleFormats == null || possibleFormats.includes((0, $bx5V3.default).UPC_A);
                    if (ean13MayBeUPCA && canReturnUPCA) {
                        var rawBytes = result.getRawBytes();
                        // Transfer the metadata across
                        var resultUPCA = new (0, $kWndQ.default)(result.getText().substring(1), rawBytes, rawBytes ? rawBytes.length : null, result.getResultPoints(), (0, $bx5V3.default).UPC_A);
                        resultUPCA.putAllMetadata(result.getResultMetadata());
                        return resultUPCA;
                    }
                    return result;
                } catch (err) {
                // continue;
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        throw new (0, $cQi30.default)();
    };
    MultiFormatUPCEANReader.prototype.reset = function() {
        var e_2, _a;
        try {
            for(var _b = $a85026964ecb3b94$var$__values(this.readers), _c = _b.next(); !_c.done; _c = _b.next()){
                var reader = _c.value;
                reader.reset();
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    return MultiFormatUPCEANReader;
}((0, $itEYK.default));
var $a85026964ecb3b94$export$2e2bcd8739ae039 = $a85026964ecb3b94$var$MultiFormatUPCEANReader;

});
parcelRegister("fGbQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6a3f764c3e7b939$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $aAMAh = parcelRequire("aAMAh");

var $cQi30 = parcelRequire("cQi30");
var $b6a3f764c3e7b939$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b6a3f764c3e7b939$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Implements decoding of the EAN-13 format.</p>
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 * @author alasdair@google.com (Alasdair Mackintosh)
 */ var $b6a3f764c3e7b939$var$EAN13Reader = /** @class */ function(_super) {
    $b6a3f764c3e7b939$var$__extends(EAN13Reader, _super);
    function EAN13Reader() {
        var _this = _super.call(this) || this;
        _this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]);
        return _this;
    }
    EAN13Reader.prototype.decodeMiddle = function(row, startRange, resultString) {
        var e_1, _a, e_2, _b;
        var counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        var lgPatternFound = 0;
        for(var x = 0; x < 6 && rowOffset < end; x++){
            var bestMatch = (0, $aAMAh.default).decodeDigit(row, counters, rowOffset, (0, $aAMAh.default).L_AND_G_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
            try {
                for(var counters_1 = (e_1 = void 0, $b6a3f764c3e7b939$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
        }
        resultString = EAN13Reader.determineFirstDigit(resultString, lgPatternFound);
        var middleRange = (0, $aAMAh.default).findGuardPattern(row, rowOffset, true, (0, $aAMAh.default).MIDDLE_PATTERN, new Int32Array((0, $aAMAh.default).MIDDLE_PATTERN.length).fill(0));
        rowOffset = middleRange[1];
        for(var x = 0; x < 6 && rowOffset < end; x++){
            var bestMatch = (0, $aAMAh.default).decodeDigit(row, counters, rowOffset, (0, $aAMAh.default).L_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch);
            try {
                for(var counters_2 = (e_2 = void 0, $b6a3f764c3e7b939$var$__values(counters)), counters_2_1 = counters_2.next(); !counters_2_1.done; counters_2_1 = counters_2.next()){
                    var counter = counters_2_1.value;
                    rowOffset += counter;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (counters_2_1 && !counters_2_1.done && (_b = counters_2.return)) _b.call(counters_2);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
        return {
            rowOffset: rowOffset,
            resultString: resultString
        };
    };
    EAN13Reader.prototype.getBarcodeFormat = function() {
        return (0, $bx5V3.default).EAN_13;
    };
    EAN13Reader.determineFirstDigit = function(resultString, lgPatternFound) {
        for(var d = 0; d < 10; d++)if (lgPatternFound === this.FIRST_DIGIT_ENCODINGS[d]) {
            resultString = String.fromCharCode("0".charCodeAt(0) + d) + resultString;
            return resultString;
        }
        throw new (0, $cQi30.default)();
    };
    EAN13Reader.FIRST_DIGIT_ENCODINGS = [
        0x00,
        0x0B,
        0x0D,
        0xE,
        0x13,
        0x19,
        0x1C,
        0x15,
        0x16,
        0x1A
    ];
    return EAN13Reader;
}((0, $aAMAh.default));
var $b6a3f764c3e7b939$export$2e2bcd8739ae039 = $b6a3f764c3e7b939$var$EAN13Reader;

});
parcelRegister("aAMAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b62f3fcd91bf1b2$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $b5DE3 = parcelRequire("b5DE3");

var $kWndQ = parcelRequire("kWndQ");

var $eS8qc = parcelRequire("eS8qc");

var $fwBMA = parcelRequire("fwBMA");

var $9O2Lm = parcelRequire("9O2Lm");

var $RDeX0 = parcelRequire("RDeX0");

var $cQi30 = parcelRequire("cQi30");

var $dtgr5 = parcelRequire("dtgr5");

var $9Nn2d = parcelRequire("9Nn2d");
var $7b62f3fcd91bf1b2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
 * of one-dimensional barcodes.</p>
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 * @author alasdair@google.com (Alasdair Mackintosh)
 */ var $7b62f3fcd91bf1b2$var$UPCEANReader = /** @class */ function(_super) {
    $7b62f3fcd91bf1b2$var$__extends(UPCEANReader, _super);
    function UPCEANReader() {
        var _this = _super.call(this) || this;
        _this.decodeRowStringBuffer = "";
        UPCEANReader.L_AND_G_PATTERNS = UPCEANReader.L_PATTERNS.map(function(arr) {
            return Int32Array.from(arr);
        });
        for(var i = 10; i < 20; i++){
            var widths = UPCEANReader.L_PATTERNS[i - 10];
            var reversedWidths = new Int32Array(widths.length);
            for(var j = 0; j < widths.length; j++)reversedWidths[j] = widths[widths.length - j - 1];
            UPCEANReader.L_AND_G_PATTERNS[i] = reversedWidths;
        }
        return _this;
    }
    UPCEANReader.prototype.decodeRow = function(rowNumber, row, hints) {
        var startGuardRange = UPCEANReader.findStartGuardPattern(row);
        var resultPointCallback = hints == null ? null : hints.get((0, $b5DE3.default).NEED_RESULT_POINT_CALLBACK);
        if (resultPointCallback != null) {
            var resultPoint_1 = new (0, $fwBMA.default)((startGuardRange[0] + startGuardRange[1]) / 2.0, rowNumber);
            resultPointCallback.foundPossibleResultPoint(resultPoint_1);
        }
        var budello = this.decodeMiddle(row, startGuardRange, this.decodeRowStringBuffer);
        var endStart = budello.rowOffset;
        var result = budello.resultString;
        if (resultPointCallback != null) {
            var resultPoint_2 = new (0, $fwBMA.default)(endStart, rowNumber);
            resultPointCallback.foundPossibleResultPoint(resultPoint_2);
        }
        var endRange = UPCEANReader.decodeEnd(row, endStart);
        if (resultPointCallback != null) {
            var resultPoint_3 = new (0, $fwBMA.default)((endRange[0] + endRange[1]) / 2.0, rowNumber);
            resultPointCallback.foundPossibleResultPoint(resultPoint_3);
        }
        // Make sure there is a quiet zone at least as big as the end pattern after the barcode. The
        // spec might want more whitespace, but in practice this is the maximum we can count on.
        var end = endRange[1];
        var quietEnd = end + (end - endRange[0]);
        if (quietEnd >= row.getSize() || !row.isRange(end, quietEnd, false)) throw new (0, $cQi30.default)();
        var resultString = result.toString();
        // UPC/EAN should never be less than 8 chars anyway
        if (resultString.length < 8) throw new (0, $dtgr5.default)();
        if (!UPCEANReader.checkChecksum(resultString)) throw new (0, $9Nn2d.default)();
        var left = (startGuardRange[1] + startGuardRange[0]) / 2.0;
        var right = (endRange[1] + endRange[0]) / 2.0;
        var format = this.getBarcodeFormat();
        var resultPoint = [
            new (0, $fwBMA.default)(left, rowNumber),
            new (0, $fwBMA.default)(right, rowNumber)
        ];
        var decodeResult = new (0, $kWndQ.default)(resultString, null, 0, resultPoint, format, new Date().getTime());
        var extensionLength = 0;
        try {
            var extensionResult = (0, $9O2Lm.default).decodeRow(rowNumber, row, endRange[1]);
            decodeResult.putMetadata((0, $eS8qc.default).UPC_EAN_EXTENSION, extensionResult.getText());
            decodeResult.putAllMetadata(extensionResult.getResultMetadata());
            decodeResult.addResultPoints(extensionResult.getResultPoints());
            extensionLength = extensionResult.getText().length;
        } catch (err) {}
        var allowedExtensions = hints == null ? null : hints.get((0, $b5DE3.default).ALLOWED_EAN_EXTENSIONS);
        if (allowedExtensions != null) {
            var valid = false;
            for(var length_1 in allowedExtensions)if (extensionLength.toString() === length_1) {
                valid = true;
                break;
            }
            if (!valid) throw new (0, $cQi30.default)();
        }
        format === (0, $bx5V3.default).EAN_13 || (0, $bx5V3.default).UPC_A;
        return decodeResult;
    };
    UPCEANReader.checkChecksum = function(s) {
        return UPCEANReader.checkStandardUPCEANChecksum(s);
    };
    UPCEANReader.checkStandardUPCEANChecksum = function(s) {
        var length = s.length;
        if (length === 0) return false;
        var check = parseInt(s.charAt(length - 1), 10);
        return UPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
    };
    UPCEANReader.getStandardUPCEANChecksum = function(s) {
        var length = s.length;
        var sum = 0;
        for(var i = length - 1; i >= 0; i -= 2){
            var digit = s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            if (digit < 0 || digit > 9) throw new (0, $dtgr5.default)();
            sum += digit;
        }
        sum *= 3;
        for(var i = length - 2; i >= 0; i -= 2){
            var digit = s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            if (digit < 0 || digit > 9) throw new (0, $dtgr5.default)();
            sum += digit;
        }
        return (1000 - sum) % 10;
    };
    UPCEANReader.decodeEnd = function(row, endStart) {
        return UPCEANReader.findGuardPattern(row, endStart, false, UPCEANReader.START_END_PATTERN, new Int32Array(UPCEANReader.START_END_PATTERN.length).fill(0));
    };
    return UPCEANReader;
}((0, $RDeX0.default));
var $7b62f3fcd91bf1b2$export$2e2bcd8739ae039 = $7b62f3fcd91bf1b2$var$UPCEANReader;

});
parcelRegister("9O2Lm", function(module, exports) {

$parcel$export(module.exports, "default", () => $723aed3eb6d7823b$export$2e2bcd8739ae039);
/*
 * Copyright (C) 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $RDeX0 = parcelRequire("RDeX0");

var $lNwiq = parcelRequire("lNwiq");

var $9H7r6 = parcelRequire("9H7r6");
var $723aed3eb6d7823b$var$UPCEANExtensionSupport = /** @class */ function() {
    function UPCEANExtensionSupport() {}
    UPCEANExtensionSupport.decodeRow = function(rowNumber, row, rowOffset) {
        var extensionStartRange = (0, $RDeX0.default).findGuardPattern(row, rowOffset, false, this.EXTENSION_START_PATTERN, new Int32Array(this.EXTENSION_START_PATTERN.length).fill(0));
        try {
            // return null;
            var fiveSupport = new (0, $lNwiq.default)();
            return fiveSupport.decodeRow(rowNumber, row, extensionStartRange);
        } catch (err) {
            // return null;
            var twoSupport = new (0, $9H7r6.default)();
            return twoSupport.decodeRow(rowNumber, row, extensionStartRange);
        }
    };
    UPCEANExtensionSupport.EXTENSION_START_PATTERN = Int32Array.from([
        1,
        1,
        2
    ]);
    return UPCEANExtensionSupport;
}();
var $723aed3eb6d7823b$export$2e2bcd8739ae039 = $723aed3eb6d7823b$var$UPCEANExtensionSupport;

});
parcelRegister("RDeX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a1363a077dbb8a5$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $itEYK = parcelRequire("itEYK");

var $cQi30 = parcelRequire("cQi30");

var $dtgr5 = parcelRequire("dtgr5");
var $0a1363a077dbb8a5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Encapsulates functionality and implementation that is common to UPC and EAN families
 * of one-dimensional barcodes.</p>
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 * @author alasdair@google.com (Alasdair Mackintosh)
 */ var $0a1363a077dbb8a5$var$AbstractUPCEANReader = /** @class */ function(_super) {
    $0a1363a077dbb8a5$var$__extends(AbstractUPCEANReader, _super);
    function AbstractUPCEANReader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.decodeRowStringBuffer = "";
        return _this;
    }
    // private final UPCEANExtensionSupport extensionReader;
    // private final EANManufacturerOrgSupport eanManSupport;
    /*
    protected UPCEANReader() {
        decodeRowStringBuffer = new StringBuilder(20);
        extensionReader = new UPCEANExtensionSupport();
        eanManSupport = new EANManufacturerOrgSupport();
    }
    */ AbstractUPCEANReader.findStartGuardPattern = function(row) {
        var foundStart = false;
        var startRange;
        var nextStart = 0;
        var counters = Int32Array.from([
            0,
            0,
            0
        ]);
        while(!foundStart){
            counters = Int32Array.from([
                0,
                0,
                0
            ]);
            startRange = AbstractUPCEANReader.findGuardPattern(row, nextStart, false, this.START_END_PATTERN, counters);
            var start = startRange[0];
            nextStart = startRange[1];
            var quietStart = start - (nextStart - start);
            if (quietStart >= 0) foundStart = row.isRange(quietStart, start, false);
        }
        return startRange;
    };
    AbstractUPCEANReader.checkChecksum = function(s) {
        return AbstractUPCEANReader.checkStandardUPCEANChecksum(s);
    };
    AbstractUPCEANReader.checkStandardUPCEANChecksum = function(s) {
        var length = s.length;
        if (length === 0) return false;
        var check = parseInt(s.charAt(length - 1), 10);
        return AbstractUPCEANReader.getStandardUPCEANChecksum(s.substring(0, length - 1)) === check;
    };
    AbstractUPCEANReader.getStandardUPCEANChecksum = function(s) {
        var length = s.length;
        var sum = 0;
        for(var i = length - 1; i >= 0; i -= 2){
            var digit = s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            if (digit < 0 || digit > 9) throw new (0, $dtgr5.default)();
            sum += digit;
        }
        sum *= 3;
        for(var i = length - 2; i >= 0; i -= 2){
            var digit = s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            if (digit < 0 || digit > 9) throw new (0, $dtgr5.default)();
            sum += digit;
        }
        return (1000 - sum) % 10;
    };
    AbstractUPCEANReader.decodeEnd = function(row, endStart) {
        return AbstractUPCEANReader.findGuardPattern(row, endStart, false, AbstractUPCEANReader.START_END_PATTERN, new Int32Array(AbstractUPCEANReader.START_END_PATTERN.length).fill(0));
    };
    /**
     * @throws NotFoundException
     */ AbstractUPCEANReader.findGuardPatternWithoutCounters = function(row, rowOffset, whiteFirst, pattern) {
        return this.findGuardPattern(row, rowOffset, whiteFirst, pattern, new Int32Array(pattern.length));
    };
    /**
     * @param row row of black/white values to search
     * @param rowOffset position to start search
     * @param whiteFirst if true, indicates that the pattern specifies white/black/white/...
     * pixel counts, otherwise, it is interpreted as black/white/black/...
     * @param pattern pattern of counts of number of black and white pixels that are being
     * searched for as a pattern
     * @param counters array of counters, as long as pattern, to re-use
     * @return start/end horizontal offset of guard pattern, as an array of two ints
     * @throws NotFoundException if pattern is not found
     */ AbstractUPCEANReader.findGuardPattern = function(row, rowOffset, whiteFirst, pattern, counters) {
        var width = row.getSize();
        rowOffset = whiteFirst ? row.getNextUnset(rowOffset) : row.getNextSet(rowOffset);
        var counterPosition = 0;
        var patternStart = rowOffset;
        var patternLength = pattern.length;
        var isWhite = whiteFirst;
        for(var x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === patternLength - 1) {
                if ((0, $itEYK.default).patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE) < AbstractUPCEANReader.MAX_AVG_VARIANCE) return Int32Array.from([
                    patternStart,
                    x
                ]);
                patternStart += counters[0] + counters[1];
                var slice = counters.slice(2, counters.length);
                for(var i = 0; i < counterPosition - 1; i++)counters[i] = slice[i];
                counters[counterPosition - 1] = 0;
                counters[counterPosition] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $cQi30.default)();
    };
    AbstractUPCEANReader.decodeDigit = function(row, counters, rowOffset, patterns) {
        this.recordPattern(row, rowOffset, counters);
        var bestVariance = this.MAX_AVG_VARIANCE;
        var bestMatch = -1;
        var max = patterns.length;
        for(var i = 0; i < max; i++){
            var pattern = patterns[i];
            var variance = (0, $itEYK.default).patternMatchVariance(counters, pattern, AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE);
            if (variance < bestVariance) {
                bestVariance = variance;
                bestMatch = i;
            }
        }
        if (bestMatch >= 0) return bestMatch;
        else throw new (0, $cQi30.default)();
    };
    // These two values are critical for determining how permissive the decoding will be.
    // We've arrived at these values through a lot of trial and error. Setting them any higher
    // lets false positives creep in quickly.
    AbstractUPCEANReader.MAX_AVG_VARIANCE = 0.48;
    AbstractUPCEANReader.MAX_INDIVIDUAL_VARIANCE = 0.7;
    /**
     * Start/end guard pattern.
     */ AbstractUPCEANReader.START_END_PATTERN = Int32Array.from([
        1,
        1,
        1
    ]);
    /**
     * Pattern marking the middle of a UPC/EAN pattern, separating the two halves.
     */ AbstractUPCEANReader.MIDDLE_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * end guard pattern.
     */ AbstractUPCEANReader.END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    /**
     * "Odd", or "L" patterns used to encode UPC/EAN digits.
     */ AbstractUPCEANReader.L_PATTERNS = [
        Int32Array.from([
            3,
            2,
            1,
            1
        ]),
        Int32Array.from([
            2,
            2,
            2,
            1
        ]),
        Int32Array.from([
            2,
            1,
            2,
            2
        ]),
        Int32Array.from([
            1,
            4,
            1,
            1
        ]),
        Int32Array.from([
            1,
            1,
            3,
            2
        ]),
        Int32Array.from([
            1,
            2,
            3,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            4
        ]),
        Int32Array.from([
            1,
            3,
            1,
            2
        ]),
        Int32Array.from([
            1,
            2,
            1,
            3
        ]),
        Int32Array.from([
            3,
            1,
            1,
            2
        ])
    ];
    return AbstractUPCEANReader;
}((0, $itEYK.default));
var $0a1363a077dbb8a5$export$2e2bcd8739ae039 = $0a1363a077dbb8a5$var$AbstractUPCEANReader;

});

parcelRegister("lNwiq", function(module, exports) {

$parcel$export(module.exports, "default", () => $fde739f19983b49e$export$2e2bcd8739ae039);
/*
 * Copyright (C) 2010 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $RDeX0 = parcelRequire("RDeX0");

var $kWndQ = parcelRequire("kWndQ");

var $fwBMA = parcelRequire("fwBMA");

var $eS8qc = parcelRequire("eS8qc");

var $cQi30 = parcelRequire("cQi30");
var $fde739f19983b49e$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @see UPCEANExtension2Support
 */ var $fde739f19983b49e$var$UPCEANExtension5Support = /** @class */ function() {
    function UPCEANExtension5Support() {
        this.CHECK_DIGIT_ENCODINGS = [
            0x18,
            0x14,
            0x12,
            0x11,
            0x0C,
            0x06,
            0x03,
            0x0A,
            0x09,
            0x05
        ];
        this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]);
        this.decodeRowStringBuffer = "";
    }
    UPCEANExtension5Support.prototype.decodeRow = function(rowNumber, row, extensionStartRange) {
        var result = this.decodeRowStringBuffer;
        var end = this.decodeMiddle(row, extensionStartRange, result);
        var resultString = result.toString();
        var extensionData = UPCEANExtension5Support.parseExtensionString(resultString);
        var resultPoints = [
            new (0, $fwBMA.default)((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
            new (0, $fwBMA.default)(end, rowNumber)
        ];
        var extensionResult = new (0, $kWndQ.default)(resultString, null, 0, resultPoints, (0, $bx5V3.default).UPC_EAN_EXTENSION, new Date().getTime());
        if (extensionData != null) extensionResult.putAllMetadata(extensionData);
        return extensionResult;
    };
    UPCEANExtension5Support.prototype.decodeMiddle = function(row, startRange, resultString) {
        var e_1, _a;
        var counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        var lgPatternFound = 0;
        for(var x = 0; x < 5 && rowOffset < end; x++){
            var bestMatch = (0, $RDeX0.default).decodeDigit(row, counters, rowOffset, (0, $RDeX0.default).L_AND_G_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
            try {
                for(var counters_1 = (e_1 = void 0, $fde739f19983b49e$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (bestMatch >= 10) lgPatternFound |= 1 << 4 - x;
            if (x !== 4) {
                // Read off separator if not last
                rowOffset = row.getNextSet(rowOffset);
                rowOffset = row.getNextUnset(rowOffset);
            }
        }
        if (resultString.length !== 5) throw new (0, $cQi30.default)();
        var checkDigit = this.determineCheckDigit(lgPatternFound);
        if (UPCEANExtension5Support.extensionChecksum(resultString.toString()) !== checkDigit) throw new (0, $cQi30.default)();
        return rowOffset;
    };
    UPCEANExtension5Support.extensionChecksum = function(s) {
        var length = s.length;
        var sum = 0;
        for(var i = length - 2; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
        sum *= 3;
        for(var i = length - 1; i >= 0; i -= 2)sum += s.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
        sum *= 3;
        return sum % 10;
    };
    UPCEANExtension5Support.prototype.determineCheckDigit = function(lgPatternFound) {
        for(var d = 0; d < 10; d++){
            if (lgPatternFound === this.CHECK_DIGIT_ENCODINGS[d]) return d;
        }
        throw new (0, $cQi30.default)();
    };
    UPCEANExtension5Support.parseExtensionString = function(raw) {
        if (raw.length !== 5) return null;
        var value = UPCEANExtension5Support.parseExtension5String(raw);
        if (value == null) return null;
        return new Map([
            [
                (0, $eS8qc.default).SUGGESTED_PRICE,
                value
            ]
        ]);
    };
    UPCEANExtension5Support.parseExtension5String = function(raw) {
        var currency;
        switch(raw.charAt(0)){
            case "0":
                currency = "\xa3";
                break;
            case "5":
                currency = "$";
                break;
            case "9":
                // Reference: http://www.jollytech.com
                switch(raw){
                    case "90000":
                        // No suggested retail price
                        return null;
                    case "99991":
                        // Complementary
                        return "0.00";
                    case "99990":
                        return "Used";
                }
                // Otherwise... unknown currency?
                currency = "";
                break;
            default:
                currency = "";
                break;
        }
        var rawAmount = parseInt(raw.substring(1));
        var unitsString = (rawAmount / 100).toString();
        var hundredths = rawAmount % 100;
        var hundredthsString = hundredths < 10 ? "0" + hundredths : hundredths.toString(); // fixme
        return currency + unitsString + "." + hundredthsString;
    };
    return UPCEANExtension5Support;
}();
var $fde739f19983b49e$export$2e2bcd8739ae039 = $fde739f19983b49e$var$UPCEANExtension5Support;

});

parcelRegister("9H7r6", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ede5e38ce11c8e$export$2e2bcd8739ae039);
/*
 * Copyright (C) 2012 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $RDeX0 = parcelRequire("RDeX0");

var $kWndQ = parcelRequire("kWndQ");

var $fwBMA = parcelRequire("fwBMA");

var $eS8qc = parcelRequire("eS8qc");

var $cQi30 = parcelRequire("cQi30");
var $70ede5e38ce11c8e$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @see UPCEANExtension5Support
 */ var $70ede5e38ce11c8e$var$UPCEANExtension2Support = /** @class */ function() {
    function UPCEANExtension2Support() {
        this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]);
        this.decodeRowStringBuffer = "";
    }
    UPCEANExtension2Support.prototype.decodeRow = function(rowNumber, row, extensionStartRange) {
        var result = this.decodeRowStringBuffer;
        var end = this.decodeMiddle(row, extensionStartRange, result);
        var resultString = result.toString();
        var extensionData = UPCEANExtension2Support.parseExtensionString(resultString);
        var resultPoints = [
            new (0, $fwBMA.default)((extensionStartRange[0] + extensionStartRange[1]) / 2.0, rowNumber),
            new (0, $fwBMA.default)(end, rowNumber)
        ];
        var extensionResult = new (0, $kWndQ.default)(resultString, null, 0, resultPoints, (0, $bx5V3.default).UPC_EAN_EXTENSION, new Date().getTime());
        if (extensionData != null) extensionResult.putAllMetadata(extensionData);
        return extensionResult;
    };
    UPCEANExtension2Support.prototype.decodeMiddle = function(row, startRange, resultString) {
        var e_1, _a;
        var counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        var checkParity = 0;
        for(var x = 0; x < 2 && rowOffset < end; x++){
            var bestMatch = (0, $RDeX0.default).decodeDigit(row, counters, rowOffset, (0, $RDeX0.default).L_AND_G_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
            try {
                for(var counters_1 = (e_1 = void 0, $70ede5e38ce11c8e$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (bestMatch >= 10) checkParity |= 1 << 1 - x;
            if (x !== 1) {
                // Read off separator if not last
                rowOffset = row.getNextSet(rowOffset);
                rowOffset = row.getNextUnset(rowOffset);
            }
        }
        if (resultString.length !== 2) throw new (0, $cQi30.default)();
        if (parseInt(resultString.toString()) % 4 !== checkParity) throw new (0, $cQi30.default)();
        return rowOffset;
    };
    UPCEANExtension2Support.parseExtensionString = function(raw) {
        if (raw.length !== 2) return null;
        return new Map([
            [
                (0, $eS8qc.default).ISSUE_NUMBER,
                parseInt(raw)
            ]
        ]);
    };
    return UPCEANExtension2Support;
}();
var $70ede5e38ce11c8e$export$2e2bcd8739ae039 = $70ede5e38ce11c8e$var$UPCEANExtension2Support;

});




parcelRegister("33ZIS", function(module, exports) {

$parcel$export(module.exports, "default", () => $23b187cc37cfc910$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $aAMAh = parcelRequire("aAMAh");
var $23b187cc37cfc910$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $23b187cc37cfc910$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Implements decoding of the EAN-8 format.</p>
 *
 * @author Sean Owen
 */ var $23b187cc37cfc910$var$EAN8Reader = /** @class */ function(_super) {
    $23b187cc37cfc910$var$__extends(EAN8Reader, _super);
    function EAN8Reader() {
        var _this = _super.call(this) || this;
        _this.decodeMiddleCounters = Int32Array.from([
            0,
            0,
            0,
            0
        ]);
        return _this;
    }
    EAN8Reader.prototype.decodeMiddle = function(row, startRange, resultString) {
        var e_1, _a, e_2, _b;
        var counters = this.decodeMiddleCounters;
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        for(var x = 0; x < 4 && rowOffset < end; x++){
            var bestMatch = (0, $aAMAh.default).decodeDigit(row, counters, rowOffset, (0, $aAMAh.default).L_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch);
            try {
                for(var counters_1 = (e_1 = void 0, $23b187cc37cfc910$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        var middleRange = (0, $aAMAh.default).findGuardPattern(row, rowOffset, true, (0, $aAMAh.default).MIDDLE_PATTERN, new Int32Array((0, $aAMAh.default).MIDDLE_PATTERN.length).fill(0));
        rowOffset = middleRange[1];
        for(var x = 0; x < 4 && rowOffset < end; x++){
            var bestMatch = (0, $aAMAh.default).decodeDigit(row, counters, rowOffset, (0, $aAMAh.default).L_PATTERNS);
            resultString += String.fromCharCode("0".charCodeAt(0) + bestMatch);
            try {
                for(var counters_2 = (e_2 = void 0, $23b187cc37cfc910$var$__values(counters)), counters_2_1 = counters_2.next(); !counters_2_1.done; counters_2_1 = counters_2.next()){
                    var counter = counters_2_1.value;
                    rowOffset += counter;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (counters_2_1 && !counters_2_1.done && (_b = counters_2.return)) _b.call(counters_2);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }
        return {
            rowOffset: rowOffset,
            resultString: resultString
        };
    };
    EAN8Reader.prototype.getBarcodeFormat = function() {
        return (0, $bx5V3.default).EAN_8;
    };
    return EAN8Reader;
}((0, $aAMAh.default));
var $23b187cc37cfc910$export$2e2bcd8739ae039 = $23b187cc37cfc910$var$EAN8Reader;

});

parcelRegister("kVUZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3d55557d154be63$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $kWndQ = parcelRequire("kWndQ");

var $cQi30 = parcelRequire("cQi30");

var $fGbQr = parcelRequire("fGbQr");

var $aAMAh = parcelRequire("aAMAh");
var $f3d55557d154be63$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Encapsulates functionality and implementation that is common to all families
 * of one-dimensional barcodes.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Sean Owen
 * @author sam2332 (Sam Rudloff)
 *
 * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCAReader.java
 *
 * @experimental
 */ var $f3d55557d154be63$var$UPCAReader = /** @class */ function(_super) {
    $f3d55557d154be63$var$__extends(UPCAReader, _super);
    function UPCAReader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ean13Reader = new (0, $fGbQr.default)();
        return _this;
    }
    // @Override
    UPCAReader.prototype.getBarcodeFormat = function() {
        return (0, $bx5V3.default).UPC_A;
    };
    // Note that we don't try rotation without the try harder flag, even if rotation was supported.
    // @Override
    UPCAReader.prototype.decode = function(image, hints) {
        return this.maybeReturnResult(this.ean13Reader.decode(image));
    };
    // @Override
    UPCAReader.prototype.decodeRow = function(rowNumber, row, hints) {
        return this.maybeReturnResult(this.ean13Reader.decodeRow(rowNumber, row, hints));
    };
    // @Override
    UPCAReader.prototype.decodeMiddle = function(row, startRange, resultString) {
        return this.ean13Reader.decodeMiddle(row, startRange, resultString);
    };
    UPCAReader.prototype.maybeReturnResult = function(result) {
        var text = result.getText();
        if (text.charAt(0) === "0") {
            var upcaResult = new (0, $kWndQ.default)(text.substring(1), null, null, result.getResultPoints(), (0, $bx5V3.default).UPC_A);
            if (result.getResultMetadata() != null) upcaResult.putAllMetadata(result.getResultMetadata());
            return upcaResult;
        } else throw new (0, $cQi30.default)();
    };
    UPCAReader.prototype.reset = function() {
        this.ean13Reader.reset();
    };
    return UPCAReader;
}((0, $aAMAh.default));
var $f3d55557d154be63$export$2e2bcd8739ae039 = $f3d55557d154be63$var$UPCAReader;

});

parcelRegister("5DDYL", function(module, exports) {

$parcel$export(module.exports, "default", () => $41af9b48367da0f8$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $aAMAh = parcelRequire("aAMAh");

var $6E9N1 = parcelRequire("6E9N1");

var $cQi30 = parcelRequire("cQi30");

var $bx5V3 = parcelRequire("bx5V3");
var $41af9b48367da0f8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $41af9b48367da0f8$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// package com.google.zxing.oned;
// import com.google.zxing.BarcodeFormat;
// import com.google.zxing.FormatException;
// import com.google.zxing.NotFoundException;
// import com.google.zxing.common.BitArray;
/**
 * <p>Implements decoding of the UPC-E format.</p>
 * <p><a href="http://www.barcodeisland.com/upce.phtml">This</a> is a great reference for
 * UPC-E information.</p>
 *
 * @author Sean Owen
 *
 * @source https://github.com/zxing/zxing/blob/3c96923276dd5785d58eb970b6ba3f80d36a9505/core/src/main/java/com/google/zxing/oned/UPCEReader.java
 *
 * @experimental
 */ var $41af9b48367da0f8$var$UPCEReader = /** @class */ function(_super) {
    $41af9b48367da0f8$var$__extends(UPCEReader, _super);
    function UPCEReader() {
        var _this = _super.call(this) || this;
        _this.decodeMiddleCounters = new Int32Array(4);
        return _this;
    }
    /**
     * @throws NotFoundException
     */ // @Override
    UPCEReader.prototype.decodeMiddle = function(row, startRange, result) {
        var e_1, _a;
        var counters = this.decodeMiddleCounters.map(function(x) {
            return x;
        });
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var end = row.getSize();
        var rowOffset = startRange[1];
        var lgPatternFound = 0;
        for(var x = 0; x < 6 && rowOffset < end; x++){
            var bestMatch = UPCEReader.decodeDigit(row, counters, rowOffset, UPCEReader.L_AND_G_PATTERNS);
            result += String.fromCharCode("0".charCodeAt(0) + bestMatch % 10);
            try {
                for(var counters_1 = (e_1 = void 0, $41af9b48367da0f8$var$__values(counters)), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    rowOffset += counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (bestMatch >= 10) lgPatternFound |= 1 << 5 - x;
        }
        UPCEReader.determineNumSysAndCheckDigit(new (0, $6E9N1.default)(result), lgPatternFound);
        return rowOffset;
    };
    /**
     * @throws NotFoundException
     */ // @Override
    UPCEReader.prototype.decodeEnd = function(row, endStart) {
        return UPCEReader.findGuardPatternWithoutCounters(row, endStart, true, UPCEReader.MIDDLE_END_PATTERN);
    };
    /**
     * @throws FormatException
     */ // @Override
    UPCEReader.prototype.checkChecksum = function(s) {
        return (0, $aAMAh.default).checkChecksum(UPCEReader.convertUPCEtoUPCA(s));
    };
    /**
     * @throws NotFoundException
     */ UPCEReader.determineNumSysAndCheckDigit = function(resultString, lgPatternFound) {
        for(var numSys = 0; numSys <= 1; numSys++){
            for(var d = 0; d < 10; d++)if (lgPatternFound === this.NUMSYS_AND_CHECK_DIGIT_PATTERNS[numSys][d]) {
                resultString.insert(0, /*(char)*/ "0" + numSys);
                resultString.append(/*(char)*/ "0" + d);
                return;
            }
        }
        throw (0, $cQi30.default).getNotFoundInstance();
    };
    // @Override
    UPCEReader.prototype.getBarcodeFormat = function() {
        return (0, $bx5V3.default).UPC_E;
    };
    /**
     * Expands a UPC-E value back into its full, equivalent UPC-A code value.
     *
     * @param upce UPC-E code as string of digits
     * @return equivalent UPC-A code as string of digits
     */ UPCEReader.convertUPCEtoUPCA = function(upce) {
        // the following line is equivalent to upce.getChars(1, 7, upceChars, 0);
        var upceChars = upce.slice(1, 7).split("").map(function(x) {
            return x.charCodeAt(0);
        });
        var result = new (0, $6E9N1.default)();
        result.append(upce.charAt(0));
        var lastChar = upceChars[5];
        switch(lastChar){
            case 0:
            case 1:
            case 2:
                result.appendChars(upceChars, 0, 2);
                result.append(lastChar);
                result.append("0000");
                result.appendChars(upceChars, 2, 3);
                break;
            case 3:
                result.appendChars(upceChars, 0, 3);
                result.append("00000");
                result.appendChars(upceChars, 3, 2);
                break;
            case 4:
                result.appendChars(upceChars, 0, 4);
                result.append("00000");
                result.append(upceChars[4]);
                break;
            default:
                result.appendChars(upceChars, 0, 5);
                result.append("0000");
                result.append(lastChar);
                break;
        }
        // Only append check digit in conversion if supplied
        if (upce.length >= 8) result.append(upce.charAt(7));
        return result.toString();
    };
    /**
     * The pattern that marks the middle, and end, of a UPC-E pattern.
     * There is no "second half" to a UPC-E barcode.
     */ UPCEReader.MIDDLE_END_PATTERN = Int32Array.from([
        1,
        1,
        1,
        1,
        1,
        1
    ]);
    // For an UPC-E barcode, the final digit is represented by the parities used
    // to encode the middle six digits, according to the table below.
    //
    //                Parity of next 6 digits
    //    Digit   0     1     2     3     4     5
    //       0    Even   Even  Even Odd  Odd   Odd
    //       1    Even   Even  Odd  Even Odd   Odd
    //       2    Even   Even  Odd  Odd  Even  Odd
    //       3    Even   Even  Odd  Odd  Odd   Even
    //       4    Even   Odd   Even Even Odd   Odd
    //       5    Even   Odd   Odd  Even Even  Odd
    //       6    Even   Odd   Odd  Odd  Even  Even
    //       7    Even   Odd   Even Odd  Even  Odd
    //       8    Even   Odd   Even Odd  Odd   Even
    //       9    Even   Odd   Odd  Even Odd   Even
    //
    // The encoding is represented by the following array, which is a bit pattern
    // using Odd = 0 and Even = 1. For example, 5 is represented by:
    //
    //              Odd Even Even Odd Odd Even
    // in binary:
    //                0    1    1   0   0    1   == 0x19
    //
    /**
     * See {@link #L_AND_G_PATTERNS}; these values similarly represent patterns of
     * even-odd parity encodings of digits that imply both the number system (0 or 1)
     * used, and the check digit.
     */ UPCEReader.NUMSYS_AND_CHECK_DIGIT_PATTERNS = [
        Int32Array.from([
            0x38,
            0x34,
            0x32,
            0x31,
            0x2C,
            0x26,
            0x23,
            0x2A,
            0x29,
            0x25
        ]),
        Int32Array.from([
            0x07,
            0x0B,
            0x0D,
            0x0E,
            0x13,
            0x19,
            0x1C,
            0x15,
            0x16,
            0x1
        ])
    ];
    return UPCEReader;
}((0, $aAMAh.default));
var $41af9b48367da0f8$export$2e2bcd8739ae039 = $41af9b48367da0f8$var$UPCEReader;

});


parcelRegister("eWQaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1ef3470009e945$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $cQi30 = parcelRequire("cQi30");

var $itEYK = parcelRequire("itEYK");

var $kWndQ = parcelRequire("kWndQ");

var $fwBMA = parcelRequire("fwBMA");
var $ae1ef3470009e945$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Decodes CodaBar barcodes. </p>
 *
 * @author Evan @dodobelieve
 * @see CodaBarReader
 */ var $ae1ef3470009e945$var$CodaBarReader = /** @class */ function(_super) {
    $ae1ef3470009e945$var$__extends(CodaBarReader, _super);
    function CodaBarReader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.CODA_BAR_CHAR_SET = {
            nnnnnww: "0",
            nnnnwwn: "1",
            nnnwnnw: "2",
            wwnnnnn: "3",
            nnwnnwn: "4",
            wnnnnwn: "5",
            nwnnnnw: "6",
            nwnnwnn: "7",
            nwwnnnn: "8",
            wnnwnnn: "9",
            nnnwwnn: "-",
            nnwwnnn: "$",
            wnnnwnw: ":",
            wnwnnnw: "/",
            wnwnwnn: ".",
            nnwwwww: "+",
            nnwwnwn: "A",
            nwnwnnw: "B",
            nnnwnww: "C",
            nnnwwwn: "D"
        };
        return _this;
    }
    CodaBarReader.prototype.decodeRow = function(rowNumber, row, hints) {
        var validRowData = this.getValidRowData(row);
        if (!validRowData) throw new (0, $cQi30.default)();
        var retStr = this.codaBarDecodeRow(validRowData.row);
        if (!retStr) throw new (0, $cQi30.default)();
        return new (0, $kWndQ.default)(retStr, null, 0, [
            new (0, $fwBMA.default)(validRowData.left, rowNumber),
            new (0, $fwBMA.default)(validRowData.right, rowNumber)
        ], (0, $bx5V3.default).CODABAR, new Date().getTime());
    };
    /**
     * converts bit array to valid data array(lengths of black bits and white bits)
     * @param row bit array to convert
     */ CodaBarReader.prototype.getValidRowData = function(row) {
        var booleanArr = row.toArray();
        var startIndex = booleanArr.indexOf(true);
        if (startIndex === -1) return null;
        var lastIndex = booleanArr.lastIndexOf(true);
        if (lastIndex <= startIndex) return null;
        booleanArr = booleanArr.slice(startIndex, lastIndex + 1);
        var result = [];
        var lastBit = booleanArr[0];
        var bitLength = 1;
        for(var i = 1; i < booleanArr.length; i++)if (booleanArr[i] === lastBit) bitLength++;
        else {
            lastBit = booleanArr[i];
            result.push(bitLength);
            bitLength = 1;
        }
        result.push(bitLength);
        // CodaBar code data valid
        if (result.length < 23 && (result.length + 1) % 8 !== 0) return null;
        return {
            row: result,
            left: startIndex,
            right: lastIndex
        };
    };
    /**
     * decode codabar code
     * @param row row to cecode
     */ CodaBarReader.prototype.codaBarDecodeRow = function(row) {
        var code = [];
        var barThreshold = Math.ceil(row.reduce(function(pre, item) {
            return (pre + item) / 2;
        }, 0));
        // Read one encoded character at a time.
        while(row.length > 0){
            var seg = row.splice(0, 8).splice(0, 7);
            var key = seg.map(function(len) {
                return len < barThreshold ? "n" : "w";
            }).join("");
            if (this.CODA_BAR_CHAR_SET[key] === undefined) return null;
            code.push(this.CODA_BAR_CHAR_SET[key]);
        }
        var strCode = code.join("");
        if (this.validCodaBarString(strCode)) return strCode;
        return null;
    };
    /**
     * check if the string is a CodaBar string
     * @param src string to determine
     */ CodaBarReader.prototype.validCodaBarString = function(src) {
        var reg = /^[A-D].{1,}[A-D]$/;
        return reg.test(src);
    };
    return CodaBarReader;
}((0, $itEYK.default));
var $ae1ef3470009e945$export$2e2bcd8739ae039 = $ae1ef3470009e945$var$CodaBarReader;

});

parcelRegister("4RT7c", function(module, exports) {

$parcel$export(module.exports, "default", () => $38b6dd59f095fa29$export$2e2bcd8739ae039);

var $bx5V3 = parcelRequire("bx5V3");

var $fbOCK = parcelRequire("fbOCK");

var $cQi30 = parcelRequire("cQi30");

var $kWndQ = parcelRequire("kWndQ");

var $b6IL4 = parcelRequire("b6IL4");

var $8qGai = parcelRequire("8qGai");

var $5QMYA = parcelRequire("5QMYA");

var $c141E = parcelRequire("c141E");

var $a2qrf = parcelRequire("a2qrf");

var $5fOJL = parcelRequire("5fOJL");

var $2cyv1 = parcelRequire("2cyv1");

var $iCJ3w = parcelRequire("iCJ3w");

var $aeyWR = parcelRequire("aeyWR");
var $38b6dd59f095fa29$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $38b6dd59f095fa29$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import java.util.ArrayList;
// import java.util.Iterator;
// import java.util.List;
// import java.util.Map;
// import java.util.Collections;
/** @experimental */ var $38b6dd59f095fa29$var$RSSExpandedReader = /** @class */ function(_super) {
    $38b6dd59f095fa29$var$__extends(RSSExpandedReader, _super);
    function RSSExpandedReader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pairs = new Array(RSSExpandedReader.MAX_PAIRS);
        _this.rows = new Array();
        _this.startEnd = [
            2
        ];
        return _this;
    }
    RSSExpandedReader.prototype.decodeRow = function(rowNumber, row, hints) {
        // Rows can start with even pattern in case in prev rows there where odd number of patters.
        // So lets try twice
        // this.pairs.clear();
        this.pairs.length = 0;
        this.startFromEven = false;
        try {
            return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
        } catch (e) {
        // OK
        // console.log(e);
        }
        this.pairs.length = 0;
        this.startFromEven = true;
        return RSSExpandedReader.constructResult(this.decodeRow2pairs(rowNumber, row));
    };
    RSSExpandedReader.prototype.reset = function() {
        this.pairs.length = 0;
        this.rows.length = 0;
    };
    // Not private for testing
    RSSExpandedReader.prototype.decodeRow2pairs = function(rowNumber, row) {
        var done = false;
        while(!done)try {
            this.pairs.push(this.retrieveNextPair(row, this.pairs, rowNumber));
        } catch (error) {
            if (error instanceof (0, $cQi30.default)) {
                if (!this.pairs.length) throw new (0, $cQi30.default)();
                // exit this loop when retrieveNextPair() fails and throws
                done = true;
            }
        }
        // TODO: verify sequence of finder patterns as in checkPairSequence()
        if (this.checkChecksum()) return this.pairs;
        var tryStackedDecode;
        if (this.rows.length) tryStackedDecode = true;
        else tryStackedDecode = false;
        // let tryStackedDecode = !this.rows.isEmpty();
        this.storeRow(rowNumber, false); // TODO: deal with reversed rows
        if (tryStackedDecode) {
            // When the image is 180-rotated, then rows are sorted in wrong direction.
            // Try twice with both the directions.
            var ps = this.checkRowsBoolean(false);
            if (ps != null) return ps;
            ps = this.checkRowsBoolean(true);
            if (ps != null) return ps;
        }
        throw new (0, $cQi30.default)();
    };
    // Need to Verify
    RSSExpandedReader.prototype.checkRowsBoolean = function(reverse) {
        // Limit number of rows we are checking
        // We use recursive algorithm with pure complexity and don't want it to take forever
        // Stacked barcode can have up to 11 rows, so 25 seems reasonable enough
        if (this.rows.length > 25) {
            this.rows.length = 0; // We will never have a chance to get result, so clear it
            return null;
        }
        this.pairs.length = 0;
        if (reverse) this.rows = this.rows.reverse();
        var ps = null;
        try {
            ps = this.checkRows(new Array(), 0);
        } catch (e) {
            // OK
            console.log(e);
        }
        if (reverse) this.rows = this.rows.reverse();
        return ps;
    };
    // Try to construct a valid rows sequence
    // Recursion is used to implement backtracking
    RSSExpandedReader.prototype.checkRows = function(collectedRows, currentRow) {
        var e_1, _a;
        for(var i = currentRow; i < this.rows.length; i++){
            var row = this.rows[i];
            this.pairs.length = 0;
            try {
                for(var collectedRows_1 = (e_1 = void 0, $38b6dd59f095fa29$var$__values(collectedRows)), collectedRows_1_1 = collectedRows_1.next(); !collectedRows_1_1.done; collectedRows_1_1 = collectedRows_1.next()){
                    var collectedRow = collectedRows_1_1.value;
                    this.pairs.push(collectedRow.getPairs());
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (collectedRows_1_1 && !collectedRows_1_1.done && (_a = collectedRows_1.return)) _a.call(collectedRows_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this.pairs.push(row.getPairs());
            if (!RSSExpandedReader.isValidSequence(this.pairs)) continue;
            if (this.checkChecksum()) return this.pairs;
            var rs = new Array(collectedRows);
            rs.push(row);
            try {
                // Recursion: try to add more rows
                return this.checkRows(rs, i + 1);
            } catch (e) {
                // We failed, try the next candidate
                console.log(e);
            }
        }
        throw new (0, $cQi30.default)();
    };
    // Whether the pairs form a valid find pattern sequence,
    // either complete or a prefix
    RSSExpandedReader.isValidSequence = function(pairs) {
        var e_2, _a;
        try {
            for(var _b = $38b6dd59f095fa29$var$__values(RSSExpandedReader.FINDER_PATTERN_SEQUENCES), _c = _b.next(); !_c.done; _c = _b.next()){
                var sequence = _c.value;
                if (pairs.length > sequence.length) continue;
                var stop_1 = true;
                for(var j = 0; j < pairs.length; j++)if (pairs[j].getFinderPattern().getValue() !== sequence[j]) {
                    stop_1 = false;
                    break;
                }
                if (stop_1) return true;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return false;
    };
    RSSExpandedReader.prototype.storeRow = function(rowNumber, wasReversed) {
        // Discard if duplicate above or below; otherwise insert in order by row number.
        var insertPos = 0;
        var prevIsSame = false;
        var nextIsSame = false;
        while(insertPos < this.rows.length){
            var erow = this.rows[insertPos];
            if (erow.getRowNumber() > rowNumber) {
                nextIsSame = erow.isEquivalent(this.pairs);
                break;
            }
            prevIsSame = erow.isEquivalent(this.pairs);
            insertPos++;
        }
        if (nextIsSame || prevIsSame) return;
        // When the row was partially decoded (e.g. 2 pairs found instead of 3),
        // it will prevent us from detecting the barcode.
        // Try to merge partial rows
        // Check whether the row is part of an allready detected row
        if (RSSExpandedReader.isPartialRow(this.pairs, this.rows)) return;
        this.rows.push(insertPos, new (0, $aeyWR.default)(this.pairs, rowNumber, wasReversed));
        this.removePartialRows(this.pairs, this.rows);
    };
    // Remove all the rows that contains only specified pairs
    RSSExpandedReader.prototype.removePartialRows = function(pairs, rows) {
        var e_3, _a, e_4, _b, e_5, _c;
        try {
            // for (Iterator<ExpandedRow> iterator = rows.iterator(); iterator.hasNext();) {
            //   ExpandedRow r = iterator.next();
            //   if (r.getPairs().size() == pairs.size()) {
            //     continue;
            //   }
            //   boolean allFound = true;
            //   for (ExpandedPair p : r.getPairs()) {
            //     boolean found = false;
            //     for (ExpandedPair pp : pairs) {
            //       if (p.equals(pp)) {
            //         found = true;
            //         break;
            //       }
            //     }
            //     if (!found) {
            //       allFound = false;
            //       break;
            //     }
            //   }
            //   if (allFound) {
            //     // 'pairs' contains all the pairs from the row 'r'
            //     iterator.remove();
            //   }
            // }
            for(var rows_1 = $38b6dd59f095fa29$var$__values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()){
                var row = rows_1_1.value;
                if (row.getPairs().length === pairs.length) continue;
                var allFound = true;
                try {
                    for(var _d = (e_4 = void 0, $38b6dd59f095fa29$var$__values(row.getPairs())), _e = _d.next(); !_e.done; _e = _d.next()){
                        var p = _e.value;
                        var found = false;
                        try {
                            for(var pairs_1 = (e_5 = void 0, $38b6dd59f095fa29$var$__values(pairs)), pairs_1_1 = pairs_1.next(); !pairs_1_1.done; pairs_1_1 = pairs_1.next()){
                                var pp = pairs_1_1.value;
                                if ((0, $iCJ3w.default).equals(p, pp)) {
                                    found = true;
                                    break;
                                }
                            }
                        } catch (e_5_1) {
                            e_5 = {
                                error: e_5_1
                            };
                        } finally{
                            try {
                                if (pairs_1_1 && !pairs_1_1.done && (_c = pairs_1.return)) _c.call(pairs_1);
                            } finally{
                                if (e_5) throw e_5.error;
                            }
                        }
                        if (!found) allFound = false;
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
    };
    // Returns true when one of the rows already contains all the pairs
    RSSExpandedReader.isPartialRow = function(pairs, rows) {
        var e_6, _a, e_7, _b, e_8, _c;
        try {
            for(var rows_2 = $38b6dd59f095fa29$var$__values(rows), rows_2_1 = rows_2.next(); !rows_2_1.done; rows_2_1 = rows_2.next()){
                var r = rows_2_1.value;
                var allFound = true;
                try {
                    for(var pairs_2 = (e_7 = void 0, $38b6dd59f095fa29$var$__values(pairs)), pairs_2_1 = pairs_2.next(); !pairs_2_1.done; pairs_2_1 = pairs_2.next()){
                        var p = pairs_2_1.value;
                        var found = false;
                        try {
                            for(var _d = (e_8 = void 0, $38b6dd59f095fa29$var$__values(r.getPairs())), _e = _d.next(); !_e.done; _e = _d.next()){
                                var pp = _e.value;
                                if (p.equals(pp)) {
                                    found = true;
                                    break;
                                }
                            }
                        } catch (e_8_1) {
                            e_8 = {
                                error: e_8_1
                            };
                        } finally{
                            try {
                                if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
                            } finally{
                                if (e_8) throw e_8.error;
                            }
                        }
                        if (!found) {
                            allFound = false;
                            break;
                        }
                    }
                } catch (e_7_1) {
                    e_7 = {
                        error: e_7_1
                    };
                } finally{
                    try {
                        if (pairs_2_1 && !pairs_2_1.done && (_b = pairs_2.return)) _b.call(pairs_2);
                    } finally{
                        if (e_7) throw e_7.error;
                    }
                }
                if (allFound) // the row 'r' contain all the pairs from 'pairs'
                return true;
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (rows_2_1 && !rows_2_1.done && (_a = rows_2.return)) _a.call(rows_2);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        return false;
    };
    // Only used for unit testing
    RSSExpandedReader.prototype.getRows = function() {
        return this.rows;
    };
    // Not private for unit testing
    RSSExpandedReader.constructResult = function(pairs) {
        var binary = (0, $5fOJL.default).buildBitArray(pairs);
        var decoder = (0, $2cyv1.createDecoder)(binary);
        var resultingString = decoder.parseInformation();
        var firstPoints = pairs[0].getFinderPattern().getResultPoints();
        var lastPoints = pairs[pairs.length - 1].getFinderPattern().getResultPoints();
        var points = [
            firstPoints[0],
            firstPoints[1],
            lastPoints[0],
            lastPoints[1]
        ];
        return new (0, $kWndQ.default)(resultingString, null, null, points, (0, $bx5V3.default).RSS_EXPANDED, null);
    };
    RSSExpandedReader.prototype.checkChecksum = function() {
        var firstPair = this.pairs.get(0);
        var checkCharacter = firstPair.getLeftChar();
        var firstCharacter = firstPair.getRightChar();
        if (firstCharacter === null) return false;
        var checksum = firstCharacter.getChecksumPortion();
        var s = 2;
        for(var i = 1; i < this.pairs.size(); ++i){
            var currentPair = this.pairs.get(i);
            checksum += currentPair.getLeftChar().getChecksumPortion();
            s++;
            var currentRightChar = currentPair.getRightChar();
            if (currentRightChar != null) {
                checksum += currentRightChar.getChecksumPortion();
                s++;
            }
        }
        checksum %= 211;
        var checkCharacterValue = 211 * (s - 4) + checksum;
        return checkCharacterValue === checkCharacter.getValue();
    };
    RSSExpandedReader.getNextSecondBar = function(row, initialPos) {
        var currentPos;
        if (row.get(initialPos)) {
            currentPos = row.getNextUnset(initialPos);
            currentPos = row.getNextSet(currentPos);
        } else {
            currentPos = row.getNextSet(initialPos);
            currentPos = row.getNextUnset(currentPos);
        }
        return currentPos;
    };
    // not private for testing
    RSSExpandedReader.prototype.retrieveNextPair = function(row, previousPairs, rowNumber) {
        var isOddPattern = previousPairs.length % 2 === 0;
        if (this.startFromEven) isOddPattern = !isOddPattern;
        var pattern;
        var keepFinding = true;
        var forcedOffset = -1;
        do {
            this.findNextPair(row, previousPairs, forcedOffset);
            pattern = this.parseFoundFinderPattern(row, rowNumber, isOddPattern);
            if (pattern === null) forcedOffset = RSSExpandedReader.getNextSecondBar(row, this.startEnd[0]);
            else keepFinding = false;
        }while (keepFinding);
        // When stacked symbol is split over multiple rows, there's no way to guess if this pair can be last or not.
        // boolean mayBeLast = checkPairSequence(previousPairs, pattern);
        var leftChar = this.decodeDataCharacter(row, pattern, isOddPattern, true);
        if (!this.isEmptyPair(previousPairs) && previousPairs[previousPairs.length - 1].mustBeLast()) throw new (0, $cQi30.default)();
        var rightChar;
        try {
            rightChar = this.decodeDataCharacter(row, pattern, isOddPattern, false);
        } catch (e) {
            rightChar = null;
            console.log(e);
        }
        return new (0, $iCJ3w.default)(leftChar, rightChar, pattern, true);
    };
    RSSExpandedReader.prototype.isEmptyPair = function(pairs) {
        if (pairs.length === 0) return true;
        return false;
    };
    RSSExpandedReader.prototype.findNextPair = function(row, previousPairs, forcedOffset) {
        var counters = this.getDecodeFinderCounters();
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var width = row.getSize();
        var rowOffset;
        if (forcedOffset >= 0) rowOffset = forcedOffset;
        else if (this.isEmptyPair(previousPairs)) rowOffset = 0;
        else {
            var lastPair = previousPairs[previousPairs.length - 1];
            rowOffset = lastPair.getFinderPattern().getStartEnd()[1];
        }
        var searchingEvenPair = previousPairs.length % 2 !== 0;
        if (this.startFromEven) searchingEvenPair = !searchingEvenPair;
        var isWhite = false;
        while(rowOffset < width){
            isWhite = !row.get(rowOffset);
            if (!isWhite) break;
            rowOffset++;
        }
        var counterPosition = 0;
        var patternStart = rowOffset;
        for(var x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === 3) {
                if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                if (RSSExpandedReader.isFinderPattern(counters)) {
                    this.startEnd[0] = patternStart;
                    this.startEnd[1] = x;
                    return;
                }
                if (searchingEvenPair) RSSExpandedReader.reverseCounters(counters);
                patternStart += counters[0] + counters[1];
                counters[0] = counters[2];
                counters[1] = counters[3];
                counters[2] = 0;
                counters[3] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $cQi30.default)();
    };
    RSSExpandedReader.reverseCounters = function(counters) {
        var length = counters.length;
        for(var i = 0; i < length / 2; ++i){
            var tmp = counters[i];
            counters[i] = counters[length - i - 1];
            counters[length - i - 1] = tmp;
        }
    };
    RSSExpandedReader.prototype.parseFoundFinderPattern = function(row, rowNumber, oddPattern) {
        // Actually we found elements 2-5.
        var firstCounter;
        var start;
        var end;
        if (oddPattern) {
            // If pattern number is odd, we need to locate element 1 *before* the current block.
            var firstElementStart = this.startEnd[0] - 1;
            // Locate element 1
            while(firstElementStart >= 0 && !row.get(firstElementStart))firstElementStart--;
            firstElementStart++;
            firstCounter = this.startEnd[0] - firstElementStart;
            start = firstElementStart;
            end = this.startEnd[1];
        } else {
            // If pattern number is even, the pattern is reversed, so we need to locate element 1 *after* the current block.
            start = this.startEnd[0];
            end = row.getNextUnset(this.startEnd[1] + 1);
            firstCounter = end - this.startEnd[1];
        }
        // Make 'counters' hold 1-4
        var counters = this.getDecodeFinderCounters();
        (0, $b6IL4.default).arraycopy(counters, 0, counters, 1, counters.length - 1);
        counters[0] = firstCounter;
        var value;
        try {
            value = this.parseFinderValue(counters, RSSExpandedReader.FINDER_PATTERNS);
        } catch (e) {
            return null;
        }
        // return new FinderPattern(value, new int[] { start, end }, start, end, rowNumber});
        return new (0, $c141E.default)(value, [
            start,
            end
        ], start, end, rowNumber);
    };
    RSSExpandedReader.prototype.decodeDataCharacter = function(row, pattern, isOddPattern, leftChar) {
        var counters = this.getDataCharacterCounters();
        for(var x = 0; x < counters.length; x++)counters[x] = 0;
        if (leftChar) RSSExpandedReader.recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
        else {
            RSSExpandedReader.recordPattern(row, pattern.getStartEnd()[1], counters);
            // reverse it
            for(var i = 0, j = counters.length - 1; i < j; i++, j--){
                var temp = counters[i];
                counters[i] = counters[j];
                counters[j] = temp;
            }
        } // counters[] has the pixels of the module
        var numModules = 17; // left and right data characters have all the same length
        var elementWidth = (0, $fbOCK.default).sum(new Int32Array(counters)) / numModules;
        // Sanity check: element width for pattern and the character should match
        var expectedElementWidth = (pattern.getStartEnd()[1] - pattern.getStartEnd()[0]) / 15.0;
        if (Math.abs(elementWidth - expectedElementWidth) / expectedElementWidth > 0.3) throw new (0, $cQi30.default)();
        var oddCounts = this.getOddCounts();
        var evenCounts = this.getEvenCounts();
        var oddRoundingErrors = this.getOddRoundingErrors();
        var evenRoundingErrors = this.getEvenRoundingErrors();
        for(var i = 0; i < counters.length; i++){
            var value_1 = 1.0 * counters[i] / elementWidth;
            var count = value_1 + 0.5; // Round
            if (count < 1) {
                if (value_1 < 0.3) throw new (0, $cQi30.default)();
                count = 1;
            } else if (count > 8) {
                if (value_1 > 8.7) throw new (0, $cQi30.default)();
                count = 8;
            }
            var offset = i / 2;
            if ((i & 0x01) === 0) {
                oddCounts[offset] = count;
                oddRoundingErrors[offset] = value_1 - count;
            } else {
                evenCounts[offset] = count;
                evenRoundingErrors[offset] = value_1 - count;
            }
        }
        this.adjustOddEvenCounts(numModules);
        var weightRowNumber = 4 * pattern.getValue() + (isOddPattern ? 0 : 2) + (leftChar ? 0 : 1) - 1;
        var oddSum = 0;
        var oddChecksumPortion = 0;
        for(var i = oddCounts.length - 1; i >= 0; i--){
            if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
                var weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i];
                oddChecksumPortion += oddCounts[i] * weight;
            }
            oddSum += oddCounts[i];
        }
        var evenChecksumPortion = 0;
        // int evenSum = 0;
        for(var i = evenCounts.length - 1; i >= 0; i--)if (RSSExpandedReader.isNotA1left(pattern, isOddPattern, leftChar)) {
            var weight = RSSExpandedReader.WEIGHTS[weightRowNumber][2 * i + 1];
            evenChecksumPortion += evenCounts[i] * weight;
        }
        var checksumPortion = oddChecksumPortion + evenChecksumPortion;
        if ((oddSum & 0x01) !== 0 || oddSum > 13 || oddSum < 4) throw new (0, $cQi30.default)();
        var group = (13 - oddSum) / 2;
        var oddWidest = RSSExpandedReader.SYMBOL_WIDEST[group];
        var evenWidest = 9 - oddWidest;
        var vOdd = (0, $a2qrf.default).getRSSvalue(oddCounts, oddWidest, true);
        var vEven = (0, $a2qrf.default).getRSSvalue(evenCounts, evenWidest, false);
        var tEven = RSSExpandedReader.EVEN_TOTAL_SUBSET[group];
        var gSum = RSSExpandedReader.GSUM[group];
        var value = vOdd * tEven + vEven + gSum;
        return new (0, $5QMYA.default)(value, checksumPortion);
    };
    RSSExpandedReader.isNotA1left = function(pattern, isOddPattern, leftChar) {
        // A1: pattern.getValue is 0 (A), and it's an oddPattern, and it is a left char
        return !(pattern.getValue() === 0 && isOddPattern && leftChar);
    };
    RSSExpandedReader.prototype.adjustOddEvenCounts = function(numModules) {
        var oddSum = (0, $fbOCK.default).sum(new Int32Array(this.getOddCounts()));
        var evenSum = (0, $fbOCK.default).sum(new Int32Array(this.getEvenCounts()));
        var incrementOdd = false;
        var decrementOdd = false;
        if (oddSum > 13) decrementOdd = true;
        else if (oddSum < 4) incrementOdd = true;
        var incrementEven = false;
        var decrementEven = false;
        if (evenSum > 13) decrementEven = true;
        else if (evenSum < 4) incrementEven = true;
        var mismatch = oddSum + evenSum - numModules;
        var oddParityBad = (oddSum & 0x01) === 1;
        var evenParityBad = (evenSum & 0x01) === 0;
        if (mismatch === 1) {
            if (oddParityBad) {
                if (evenParityBad) throw new (0, $cQi30.default)();
                decrementOdd = true;
            } else {
                if (!evenParityBad) throw new (0, $cQi30.default)();
                decrementEven = true;
            }
        } else if (mismatch === -1) {
            if (oddParityBad) {
                if (evenParityBad) throw new (0, $cQi30.default)();
                incrementOdd = true;
            } else {
                if (!evenParityBad) throw new (0, $cQi30.default)();
                incrementEven = true;
            }
        } else if (mismatch === 0) {
            if (oddParityBad) {
                if (!evenParityBad) throw new (0, $cQi30.default)();
                // Both bad
                if (oddSum < evenSum) {
                    incrementOdd = true;
                    decrementEven = true;
                } else {
                    decrementOdd = true;
                    incrementEven = true;
                }
            } else {
                if (evenParityBad) throw new (0, $cQi30.default)();
            // Nothing to do!
            }
        } else throw new (0, $cQi30.default)();
        if (incrementOdd) {
            if (decrementOdd) throw new (0, $cQi30.default)();
            RSSExpandedReader.increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (decrementOdd) RSSExpandedReader.decrement(this.getOddCounts(), this.getOddRoundingErrors());
        if (incrementEven) {
            if (decrementEven) throw new (0, $cQi30.default)();
            RSSExpandedReader.increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        if (decrementEven) RSSExpandedReader.decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    };
    RSSExpandedReader.SYMBOL_WIDEST = [
        7,
        5,
        4,
        3,
        1
    ];
    RSSExpandedReader.EVEN_TOTAL_SUBSET = [
        4,
        20,
        52,
        104,
        204
    ];
    RSSExpandedReader.GSUM = [
        0,
        348,
        1388,
        2948,
        3988
    ];
    RSSExpandedReader.FINDER_PATTERNS = [
        Int32Array.from([
            1,
            8,
            4,
            1
        ]),
        Int32Array.from([
            3,
            6,
            4,
            1
        ]),
        Int32Array.from([
            3,
            4,
            6,
            1
        ]),
        Int32Array.from([
            3,
            2,
            8,
            1
        ]),
        Int32Array.from([
            2,
            6,
            5,
            1
        ]),
        Int32Array.from([
            2,
            2,
            9,
            1
        ])
    ];
    RSSExpandedReader.WEIGHTS = [
        [
            1,
            3,
            9,
            27,
            81,
            32,
            96,
            77
        ],
        [
            20,
            60,
            180,
            118,
            143,
            7,
            21,
            63
        ],
        [
            189,
            145,
            13,
            39,
            117,
            140,
            209,
            205
        ],
        [
            193,
            157,
            49,
            147,
            19,
            57,
            171,
            91
        ],
        [
            62,
            186,
            136,
            197,
            169,
            85,
            44,
            132
        ],
        [
            185,
            133,
            188,
            142,
            4,
            12,
            36,
            108
        ],
        [
            113,
            128,
            173,
            97,
            80,
            29,
            87,
            50
        ],
        [
            150,
            28,
            84,
            41,
            123,
            158,
            52,
            156
        ],
        [
            46,
            138,
            203,
            187,
            139,
            206,
            196,
            166
        ],
        [
            76,
            17,
            51,
            153,
            37,
            111,
            122,
            155
        ],
        [
            43,
            129,
            176,
            106,
            107,
            110,
            119,
            146
        ],
        [
            16,
            48,
            144,
            10,
            30,
            90,
            59,
            177
        ],
        [
            109,
            116,
            137,
            200,
            178,
            112,
            125,
            164
        ],
        [
            70,
            210,
            208,
            202,
            184,
            130,
            179,
            115
        ],
        [
            134,
            191,
            151,
            31,
            93,
            68,
            204,
            190
        ],
        [
            148,
            22,
            66,
            198,
            172,
            94,
            71,
            2
        ],
        [
            6,
            18,
            54,
            162,
            64,
            192,
            154,
            40
        ],
        [
            120,
            149,
            25,
            75,
            14,
            42,
            126,
            167
        ],
        [
            79,
            26,
            78,
            23,
            69,
            207,
            199,
            175
        ],
        [
            103,
            98,
            83,
            38,
            114,
            131,
            182,
            124
        ],
        [
            161,
            61,
            183,
            127,
            170,
            88,
            53,
            159
        ],
        [
            55,
            165,
            73,
            8,
            24,
            72,
            5,
            15
        ],
        [
            45,
            135,
            194,
            160,
            58,
            174,
            100,
            89
        ]
    ];
    RSSExpandedReader.FINDER_PAT_A = 0;
    RSSExpandedReader.FINDER_PAT_B = 1;
    RSSExpandedReader.FINDER_PAT_C = 2;
    RSSExpandedReader.FINDER_PAT_D = 3;
    RSSExpandedReader.FINDER_PAT_E = 4;
    RSSExpandedReader.FINDER_PAT_F = 5;
    RSSExpandedReader.FINDER_PATTERN_SEQUENCES = [
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_C
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ],
        [
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_A,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_B,
            RSSExpandedReader.FINDER_PAT_C,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_D,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_E,
            RSSExpandedReader.FINDER_PAT_F,
            RSSExpandedReader.FINDER_PAT_F
        ]
    ];
    RSSExpandedReader.MAX_PAIRS = 11;
    return RSSExpandedReader;
}((0, $8qGai.default));
var $38b6dd59f095fa29$export$2e2bcd8739ae039 = $38b6dd59f095fa29$var$RSSExpandedReader;

});
parcelRegister("8qGai", function(module, exports) {

$parcel$export(module.exports, "default", () => $623175844d867494$export$2e2bcd8739ae039);

var $fbOCK = parcelRequire("fbOCK");

var $cQi30 = parcelRequire("cQi30");

var $itEYK = parcelRequire("itEYK");
var $623175844d867494$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $623175844d867494$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import Integer from '../../util/Integer';
// import Float from '../../util/Float';
var $623175844d867494$var$AbstractRSSReader = /** @class */ function(_super) {
    $623175844d867494$var$__extends(AbstractRSSReader, _super);
    function AbstractRSSReader() {
        var _this = _super.call(this) || this;
        _this.decodeFinderCounters = new Int32Array(4);
        _this.dataCharacterCounters = new Int32Array(8);
        _this.oddRoundingErrors = new Array(4);
        _this.evenRoundingErrors = new Array(4);
        _this.oddCounts = new Array(_this.dataCharacterCounters.length / 2);
        _this.evenCounts = new Array(_this.dataCharacterCounters.length / 2);
        return _this;
    }
    AbstractRSSReader.prototype.getDecodeFinderCounters = function() {
        return this.decodeFinderCounters;
    };
    AbstractRSSReader.prototype.getDataCharacterCounters = function() {
        return this.dataCharacterCounters;
    };
    AbstractRSSReader.prototype.getOddRoundingErrors = function() {
        return this.oddRoundingErrors;
    };
    AbstractRSSReader.prototype.getEvenRoundingErrors = function() {
        return this.evenRoundingErrors;
    };
    AbstractRSSReader.prototype.getOddCounts = function() {
        return this.oddCounts;
    };
    AbstractRSSReader.prototype.getEvenCounts = function() {
        return this.evenCounts;
    };
    AbstractRSSReader.prototype.parseFinderValue = function(counters, finderPatterns) {
        for(var value = 0; value < finderPatterns.length; value++){
            if ((0, $itEYK.default).patternMatchVariance(counters, finderPatterns[value], AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE) < AbstractRSSReader.MAX_AVG_VARIANCE) return value;
        }
        throw new (0, $cQi30.default)();
    };
    /**
     * @param array values to sum
     * @return sum of values
     * @deprecated call {@link MathUtils#sum(int[])}
     */ AbstractRSSReader.count = function(array) {
        return (0, $fbOCK.default).sum(new Int32Array(array));
    };
    AbstractRSSReader.increment = function(array, errors) {
        var index = 0;
        var biggestError = errors[0];
        for(var i = 1; i < array.length; i++)if (errors[i] > biggestError) {
            biggestError = errors[i];
            index = i;
        }
        array[index]++;
    };
    AbstractRSSReader.decrement = function(array, errors) {
        var index = 0;
        var biggestError = errors[0];
        for(var i = 1; i < array.length; i++)if (errors[i] < biggestError) {
            biggestError = errors[i];
            index = i;
        }
        array[index]--;
    };
    AbstractRSSReader.isFinderPattern = function(counters) {
        var e_1, _a;
        var firstTwoSum = counters[0] + counters[1];
        var sum = firstTwoSum + counters[2] + counters[3];
        var ratio = firstTwoSum / sum;
        if (ratio >= AbstractRSSReader.MIN_FINDER_PATTERN_RATIO && ratio <= AbstractRSSReader.MAX_FINDER_PATTERN_RATIO) {
            // passes ratio test in spec, but see if the counts are unreasonable
            var minCounter = Number.MAX_SAFE_INTEGER;
            var maxCounter = Number.MIN_SAFE_INTEGER;
            try {
                for(var counters_1 = $623175844d867494$var$__values(counters), counters_1_1 = counters_1.next(); !counters_1_1.done; counters_1_1 = counters_1.next()){
                    var counter = counters_1_1.value;
                    if (counter > maxCounter) maxCounter = counter;
                    if (counter < minCounter) minCounter = counter;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (counters_1_1 && !counters_1_1.done && (_a = counters_1.return)) _a.call(counters_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return maxCounter < 10 * minCounter;
        }
        return false;
    };
    AbstractRSSReader.MAX_AVG_VARIANCE = 0.2;
    AbstractRSSReader.MAX_INDIVIDUAL_VARIANCE = 0.45;
    AbstractRSSReader.MIN_FINDER_PATTERN_RATIO = 9.5 / 12.0;
    AbstractRSSReader.MAX_FINDER_PATTERN_RATIO = 12.5 / 14.0;
    return AbstractRSSReader;
}((0, $itEYK.default));
var $623175844d867494$export$2e2bcd8739ae039 = $623175844d867494$var$AbstractRSSReader;

});

parcelRegister("5QMYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4427ccbb69ead09e$export$2e2bcd8739ae039);
var $4427ccbb69ead09e$var$DataCharacter = /** @class */ function() {
    function DataCharacter(value, checksumPortion) {
        this.value = value;
        this.checksumPortion = checksumPortion;
    }
    DataCharacter.prototype.getValue = function() {
        return this.value;
    };
    DataCharacter.prototype.getChecksumPortion = function() {
        return this.checksumPortion;
    };
    DataCharacter.prototype.toString = function() {
        return this.value + "(" + this.checksumPortion + ")";
    };
    DataCharacter.prototype.equals = function(o) {
        if (!(o instanceof DataCharacter)) return false;
        var that = o;
        return this.value === that.value && this.checksumPortion === that.checksumPortion;
    };
    DataCharacter.prototype.hashCode = function() {
        return this.value ^ this.checksumPortion;
    };
    return DataCharacter;
}();
var $4427ccbb69ead09e$export$2e2bcd8739ae039 = $4427ccbb69ead09e$var$DataCharacter;

});

parcelRegister("c141E", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bf8b37175741d61$export$2e2bcd8739ae039);

var $fwBMA = parcelRequire("fwBMA");
var $8bf8b37175741d61$var$FinderPattern = /** @class */ function() {
    function FinderPattern(value, startEnd, start, end, rowNumber) {
        this.value = value;
        this.startEnd = startEnd;
        this.value = value;
        this.startEnd = startEnd;
        this.resultPoints = new Array();
        this.resultPoints.push(new (0, $fwBMA.default)(start, rowNumber));
        this.resultPoints.push(new (0, $fwBMA.default)(end, rowNumber));
    }
    FinderPattern.prototype.getValue = function() {
        return this.value;
    };
    FinderPattern.prototype.getStartEnd = function() {
        return this.startEnd;
    };
    FinderPattern.prototype.getResultPoints = function() {
        return this.resultPoints;
    };
    FinderPattern.prototype.equals = function(o) {
        if (!(o instanceof FinderPattern)) return false;
        var that = o;
        return this.value === that.value;
    };
    FinderPattern.prototype.hashCode = function() {
        return this.value;
    };
    return FinderPattern;
}();
var $8bf8b37175741d61$export$2e2bcd8739ae039 = $8bf8b37175741d61$var$FinderPattern;

});

parcelRegister("a2qrf", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ee996bdf27cba9$export$2e2bcd8739ae039);
var $74ee996bdf27cba9$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * RSS util functions.
 */ var $74ee996bdf27cba9$var$RSSUtils = /** @class */ function() {
    function RSSUtils() {}
    RSSUtils.getRSSvalue = function(widths, maxWidth, noNarrow) {
        var e_1, _a;
        var n = 0;
        try {
            for(var widths_1 = $74ee996bdf27cba9$var$__values(widths), widths_1_1 = widths_1.next(); !widths_1_1.done; widths_1_1 = widths_1.next()){
                var width = widths_1_1.value;
                n += width;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (widths_1_1 && !widths_1_1.done && (_a = widths_1.return)) _a.call(widths_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var val = 0;
        var narrowMask = 0;
        var elements = widths.length;
        for(var bar = 0; bar < elements - 1; bar++){
            var elmWidth = void 0;
            for(elmWidth = 1, narrowMask |= 1 << bar; elmWidth < widths[bar]; elmWidth++, narrowMask &= ~(1 << bar)){
                var subVal = RSSUtils.combins(n - elmWidth - 1, elements - bar - 2);
                if (noNarrow && narrowMask === 0 && n - elmWidth - (elements - bar - 1) >= elements - bar - 1) subVal -= RSSUtils.combins(n - elmWidth - (elements - bar), elements - bar - 2);
                if (elements - bar - 1 > 1) {
                    var lessVal = 0;
                    for(var mxwElement = n - elmWidth - (elements - bar - 2); mxwElement > maxWidth; mxwElement--)lessVal += RSSUtils.combins(n - elmWidth - mxwElement - 1, elements - bar - 3);
                    subVal -= lessVal * (elements - 1 - bar);
                } else if (n - elmWidth > maxWidth) subVal--;
                val += subVal;
            }
            n -= elmWidth;
        }
        return val;
    };
    RSSUtils.combins = function(n, r) {
        var maxDenom;
        var minDenom;
        if (n - r > r) {
            minDenom = r;
            maxDenom = n - r;
        } else {
            minDenom = n - r;
            maxDenom = r;
        }
        var val = 1;
        var j = 1;
        for(var i = n; i > maxDenom; i--){
            val *= i;
            if (j <= minDenom) {
                val /= j;
                j++;
            }
        }
        while(j <= minDenom){
            val /= j;
            j++;
        }
        return val;
    };
    return RSSUtils;
}();
var $74ee996bdf27cba9$export$2e2bcd8739ae039 = $74ee996bdf27cba9$var$RSSUtils;

});

parcelRegister("5fOJL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d35b5ce2ba55afd$export$2e2bcd8739ae039);

var $fHKUB = parcelRequire("fHKUB");
var $3d35b5ce2ba55afd$var$BitArrayBuilder = /** @class */ function() {
    function BitArrayBuilder() {}
    BitArrayBuilder.buildBitArray = function(pairs) {
        var charNumber = pairs.length * 2 - 1;
        if (pairs[pairs.length - 1].getRightChar() == null) charNumber -= 1;
        var size = 12 * charNumber;
        var binary = new (0, $fHKUB.default)(size);
        var accPos = 0;
        var firstPair = pairs[0];
        var firstValue = firstPair.getRightChar().getValue();
        for(var i = 11; i >= 0; --i){
            if ((firstValue & 1 << i) !== 0) binary.set(accPos);
            accPos++;
        }
        for(var i = 1; i < pairs.length; ++i){
            var currentPair = pairs[i];
            var leftValue = currentPair.getLeftChar().getValue();
            for(var j = 11; j >= 0; --j){
                if ((leftValue & 1 << j) !== 0) binary.set(accPos);
                accPos++;
            }
            if (currentPair.getRightChar() !== null) {
                var rightValue = currentPair.getRightChar().getValue();
                for(var j = 11; j >= 0; --j){
                    if ((rightValue & 1 << j) !== 0) binary.set(accPos);
                    accPos++;
                }
            }
        }
        return binary;
    };
    return BitArrayBuilder;
}();
var $3d35b5ce2ba55afd$export$2e2bcd8739ae039 = $3d35b5ce2ba55afd$var$BitArrayBuilder;

});

parcelRegister("2cyv1", function(module, exports) {

$parcel$export(module.exports, "createDecoder", () => $19a776976382dc9d$export$f8c898e83b60faaa);

var $amwnq = parcelRequire("amwnq");

var $iqtaA = parcelRequire("iqtaA");

var $bP5q6 = parcelRequire("bP5q6");

var $7B6Sn = parcelRequire("7B6Sn");

var $9J5zK = parcelRequire("9J5zK");

var $fKw9z = parcelRequire("fKw9z");

var $9zaRa = parcelRequire("9zaRa");

var $4eSFZ = parcelRequire("4eSFZ");

var $6lqug = parcelRequire("6lqug");
function $19a776976382dc9d$export$f8c898e83b60faaa(information) {
    try {
        if (information.get(1)) return new (0, $bP5q6.default)(information);
        if (!information.get(2)) return new (0, $7B6Sn.default)(information);
        var fourBitEncodationMethod = (0, $iqtaA.default).extractNumericValueFromBitArray(information, 1, 4);
        switch(fourBitEncodationMethod){
            case 4:
                return new (0, $9J5zK.default)(information);
            case 5:
                return new (0, $fKw9z.default)(information);
        }
        var fiveBitEncodationMethod = (0, $iqtaA.default).extractNumericValueFromBitArray(information, 1, 5);
        switch(fiveBitEncodationMethod){
            case 12:
                return new (0, $9zaRa.default)(information);
            case 13:
                return new (0, $4eSFZ.default)(information);
        }
        var sevenBitEncodationMethod = (0, $iqtaA.default).extractNumericValueFromBitArray(information, 1, 7);
        switch(sevenBitEncodationMethod){
            case 56:
                return new (0, $6lqug.default)(information, "310", "11");
            case 57:
                return new (0, $6lqug.default)(information, "320", "11");
            case 58:
                return new (0, $6lqug.default)(information, "310", "13");
            case 59:
                return new (0, $6lqug.default)(information, "320", "13");
            case 60:
                return new (0, $6lqug.default)(information, "310", "15");
            case 61:
                return new (0, $6lqug.default)(information, "320", "15");
            case 62:
                return new (0, $6lqug.default)(information, "310", "17");
            case 63:
                return new (0, $6lqug.default)(information, "320", "17");
        }
    } catch (e) {
        console.log(e);
        throw new (0, $amwnq.default)("unknown decoder: " + information);
    }
}

});
parcelRegister("iqtaA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6a14832732431c4$export$2e2bcd8739ae039);

var $dtgr5 = parcelRequire("dtgr5");

var $amwnq = parcelRequire("amwnq");

var $6E9N1 = parcelRequire("6E9N1");

var $4DVal = parcelRequire("4DVal");

var $bWuHh = parcelRequire("bWuHh");

var $3Zmo6 = parcelRequire("3Zmo6");

var $2QL9s = parcelRequire("2QL9s");

var $87Cyr = parcelRequire("87Cyr");
var $d6a14832732431c4$var$GeneralAppIdDecoder = /** @class */ function() {
    function GeneralAppIdDecoder(information) {
        this.buffer = new (0, $6E9N1.default)();
        this.information = information;
    }
    GeneralAppIdDecoder.prototype.decodeAllCodes = function(buff, initialPosition) {
        var currentPosition = initialPosition;
        var remaining = null;
        do {
            var info = this.decodeGeneralPurposeField(currentPosition, remaining);
            var parsedFields = (0, $87Cyr.default).parseFieldsInGeneralPurpose(info.getNewString());
            if (parsedFields != null) buff.append(parsedFields);
            if (info.isRemaining()) remaining = "" + info.getRemainingValue();
            else remaining = null;
            if (currentPosition === info.getNewPosition()) break;
            currentPosition = info.getNewPosition();
        }while (true);
        return buff.toString();
    };
    GeneralAppIdDecoder.prototype.isStillNumeric = function(pos) {
        // It's numeric if it still has 7 positions
        // and one of the first 4 bits is "1".
        if (pos + 7 > this.information.getSize()) return pos + 4 <= this.information.getSize();
        for(var i = pos; i < pos + 3; ++i){
            if (this.information.get(i)) return true;
        }
        return this.information.get(pos + 3);
    };
    GeneralAppIdDecoder.prototype.decodeNumeric = function(pos) {
        if (pos + 7 > this.information.getSize()) {
            var numeric_1 = this.extractNumericValueFromBitArray(pos, 4);
            if (numeric_1 === 0) return new (0, $2QL9s.default)(this.information.getSize(), (0, $2QL9s.default).FNC1, (0, $2QL9s.default).FNC1);
            return new (0, $2QL9s.default)(this.information.getSize(), numeric_1 - 1, (0, $2QL9s.default).FNC1);
        }
        var numeric = this.extractNumericValueFromBitArray(pos, 7);
        var digit1 = (numeric - 8) / 11;
        var digit2 = (numeric - 8) % 11;
        return new (0, $2QL9s.default)(pos + 7, digit1, digit2);
    };
    GeneralAppIdDecoder.prototype.extractNumericValueFromBitArray = function(pos, bits) {
        return GeneralAppIdDecoder.extractNumericValueFromBitArray(this.information, pos, bits);
    };
    GeneralAppIdDecoder.extractNumericValueFromBitArray = function(information, pos, bits) {
        var value = 0;
        for(var i = 0; i < bits; ++i)if (information.get(pos + i)) value |= 1 << bits - i - 1;
        return value;
    };
    GeneralAppIdDecoder.prototype.decodeGeneralPurposeField = function(pos, remaining) {
        // this.buffer.setLength(0);
        this.buffer.setLengthToZero();
        if (remaining != null) this.buffer.append(remaining);
        this.current.setPosition(pos);
        var lastDecoded = this.parseBlocks();
        if (lastDecoded != null && lastDecoded.isRemaining()) return new (0, $3Zmo6.default)(this.current.getPosition(), this.buffer.toString(), lastDecoded.getRemainingValue());
        return new (0, $3Zmo6.default)(this.current.getPosition(), this.buffer.toString());
    };
    GeneralAppIdDecoder.prototype.parseBlocks = function() {
        var isFinished;
        var result;
        do {
            var initialPosition = this.current.getPosition();
            if (this.current.isAlpha()) {
                result = this.parseAlphaBlock();
                isFinished = result.isFinished();
            } else if (this.current.isIsoIec646()) {
                result = this.parseIsoIec646Block();
                isFinished = result.isFinished();
            } else {
                result = this.parseNumericBlock();
                isFinished = result.isFinished();
            }
            var positionChanged = initialPosition !== this.current.getPosition();
            if (!positionChanged && !isFinished) break;
        }while (!isFinished);
        return result.getDecodedInformation();
    };
    GeneralAppIdDecoder.prototype.parseNumericBlock = function() {
        while(this.isStillNumeric(this.current.getPosition())){
            var numeric = this.decodeNumeric(this.current.getPosition());
            this.current.setPosition(numeric.getNewPosition());
            if (numeric.isFirstDigitFNC1()) {
                var information = void 0;
                if (numeric.isSecondDigitFNC1()) information = new (0, $3Zmo6.default)(this.current.getPosition(), this.buffer.toString());
                else information = new (0, $3Zmo6.default)(this.current.getPosition(), this.buffer.toString(), numeric.getSecondDigit());
                return new (0, $4DVal.default)(true, information);
            }
            this.buffer.append(numeric.getFirstDigit());
            if (numeric.isSecondDigitFNC1()) {
                var information = new (0, $3Zmo6.default)(this.current.getPosition(), this.buffer.toString());
                return new (0, $4DVal.default)(true, information);
            }
            this.buffer.append(numeric.getSecondDigit());
        }
        if (this.isNumericToAlphaNumericLatch(this.current.getPosition())) {
            this.current.setAlpha();
            this.current.incrementPosition(4);
        }
        return new (0, $4DVal.default)(false);
    };
    GeneralAppIdDecoder.prototype.parseIsoIec646Block = function() {
        while(this.isStillIsoIec646(this.current.getPosition())){
            var iso = this.decodeIsoIec646(this.current.getPosition());
            this.current.setPosition(iso.getNewPosition());
            if (iso.isFNC1()) {
                var information = new (0, $3Zmo6.default)(this.current.getPosition(), this.buffer.toString());
                return new (0, $4DVal.default)(true, information);
            }
            this.buffer.append(iso.getValue());
        }
        if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
            this.current.incrementPosition(3);
            this.current.setNumeric();
        } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
            if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
            else this.current.setPosition(this.information.getSize());
            this.current.setAlpha();
        }
        return new (0, $4DVal.default)(false);
    };
    GeneralAppIdDecoder.prototype.parseAlphaBlock = function() {
        while(this.isStillAlpha(this.current.getPosition())){
            var alpha = this.decodeAlphanumeric(this.current.getPosition());
            this.current.setPosition(alpha.getNewPosition());
            if (alpha.isFNC1()) {
                var information = new (0, $3Zmo6.default)(this.current.getPosition(), this.buffer.toString());
                return new (0, $4DVal.default)(true, information); // end of the char block
            }
            this.buffer.append(alpha.getValue());
        }
        if (this.isAlphaOr646ToNumericLatch(this.current.getPosition())) {
            this.current.incrementPosition(3);
            this.current.setNumeric();
        } else if (this.isAlphaTo646ToAlphaLatch(this.current.getPosition())) {
            if (this.current.getPosition() + 5 < this.information.getSize()) this.current.incrementPosition(5);
            else this.current.setPosition(this.information.getSize());
            this.current.setIsoIec646();
        }
        return new (0, $4DVal.default)(false);
    };
    GeneralAppIdDecoder.prototype.isStillIsoIec646 = function(pos) {
        if (pos + 5 > this.information.getSize()) return false;
        var fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
        if (pos + 7 > this.information.getSize()) return false;
        var sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
        if (sevenBitValue >= 64 && sevenBitValue < 116) return true;
        if (pos + 8 > this.information.getSize()) return false;
        var eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
        return eightBitValue >= 232 && eightBitValue < 253;
    };
    GeneralAppIdDecoder.prototype.decodeIsoIec646 = function(pos) {
        var fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue === 15) return new (0, $bWuHh.default)(pos + 5, (0, $bWuHh.default).FNC1);
        if (fiveBitValue >= 5 && fiveBitValue < 15) return new (0, $bWuHh.default)(pos + 5, "0" + (fiveBitValue - 5));
        var sevenBitValue = this.extractNumericValueFromBitArray(pos, 7);
        if (sevenBitValue >= 64 && sevenBitValue < 90) return new (0, $bWuHh.default)(pos + 7, "" + (sevenBitValue + 1));
        if (sevenBitValue >= 90 && sevenBitValue < 116) return new (0, $bWuHh.default)(pos + 7, "" + (sevenBitValue + 7));
        var eightBitValue = this.extractNumericValueFromBitArray(pos, 8);
        var c;
        switch(eightBitValue){
            case 232:
                c = "!";
                break;
            case 233:
                c = '"';
                break;
            case 234:
                c = "%";
                break;
            case 235:
                c = "&";
                break;
            case 236:
                c = "'";
                break;
            case 237:
                c = "(";
                break;
            case 238:
                c = ")";
                break;
            case 239:
                c = "*";
                break;
            case 240:
                c = "+";
                break;
            case 241:
                c = ",";
                break;
            case 242:
                c = "-";
                break;
            case 243:
                c = ".";
                break;
            case 244:
                c = "/";
                break;
            case 245:
                c = ":";
                break;
            case 246:
                c = ";";
                break;
            case 247:
                c = "<";
                break;
            case 248:
                c = "=";
                break;
            case 249:
                c = ">";
                break;
            case 250:
                c = "?";
                break;
            case 251:
                c = "_";
                break;
            case 252:
                c = " ";
                break;
            default:
                throw new (0, $dtgr5.default)();
        }
        return new (0, $bWuHh.default)(pos + 8, c);
    };
    GeneralAppIdDecoder.prototype.isStillAlpha = function(pos) {
        if (pos + 5 > this.information.getSize()) return false;
        // We now check if it's a valid 5-bit value (0..9 and FNC1)
        var fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue >= 5 && fiveBitValue < 16) return true;
        if (pos + 6 > this.information.getSize()) return false;
        var sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
        return sixBitValue >= 16 && sixBitValue < 63; // 63 not included
    };
    GeneralAppIdDecoder.prototype.decodeAlphanumeric = function(pos) {
        var fiveBitValue = this.extractNumericValueFromBitArray(pos, 5);
        if (fiveBitValue === 15) return new (0, $bWuHh.default)(pos + 5, (0, $bWuHh.default).FNC1);
        if (fiveBitValue >= 5 && fiveBitValue < 15) return new (0, $bWuHh.default)(pos + 5, "0" + (fiveBitValue - 5));
        var sixBitValue = this.extractNumericValueFromBitArray(pos, 6);
        if (sixBitValue >= 32 && sixBitValue < 58) return new (0, $bWuHh.default)(pos + 6, "" + (sixBitValue + 33));
        var c;
        switch(sixBitValue){
            case 58:
                c = "*";
                break;
            case 59:
                c = ",";
                break;
            case 60:
                c = "-";
                break;
            case 61:
                c = ".";
                break;
            case 62:
                c = "/";
                break;
            default:
                throw new (0, $amwnq.default)("Decoding invalid alphanumeric value: " + sixBitValue);
        }
        return new (0, $bWuHh.default)(pos + 6, c);
    };
    GeneralAppIdDecoder.prototype.isAlphaTo646ToAlphaLatch = function(pos) {
        if (pos + 1 > this.information.getSize()) return false;
        for(var i = 0; i < 5 && i + pos < this.information.getSize(); ++i){
            if (i === 2) {
                if (!this.information.get(pos + 2)) return false;
            } else if (this.information.get(pos + i)) return false;
        }
        return true;
    };
    GeneralAppIdDecoder.prototype.isAlphaOr646ToNumericLatch = function(pos) {
        // Next is alphanumeric if there are 3 positions and they are all zeros
        if (pos + 3 > this.information.getSize()) return false;
        for(var i = pos; i < pos + 3; ++i){
            if (this.information.get(i)) return false;
        }
        return true;
    };
    GeneralAppIdDecoder.prototype.isNumericToAlphaNumericLatch = function(pos) {
        // Next is alphanumeric if there are 4 positions and they are all zeros, or
        // if there is a subset of this just before the end of the symbol
        if (pos + 1 > this.information.getSize()) return false;
        for(var i = 0; i < 4 && i + pos < this.information.getSize(); ++i){
            if (this.information.get(pos + i)) return false;
        }
        return true;
    };
    return GeneralAppIdDecoder;
}();
var $d6a14832732431c4$export$2e2bcd8739ae039 = $d6a14832732431c4$var$GeneralAppIdDecoder;

});
parcelRegister("4DVal", function(module, exports) {

$parcel$export(module.exports, "default", () => $361725de6a8bdd1f$export$2e2bcd8739ae039);
var $361725de6a8bdd1f$var$BlockParsedResult = /** @class */ function() {
    function BlockParsedResult(finished, decodedInformation) {
        if (decodedInformation) this.decodedInformation = null;
        else {
            this.finished = finished;
            this.decodedInformation = decodedInformation;
        }
    }
    BlockParsedResult.prototype.getDecodedInformation = function() {
        return this.decodedInformation;
    };
    BlockParsedResult.prototype.isFinished = function() {
        return this.finished;
    };
    return BlockParsedResult;
}();
var $361725de6a8bdd1f$export$2e2bcd8739ae039 = $361725de6a8bdd1f$var$BlockParsedResult;

});

parcelRegister("bWuHh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b1cec496750908a$export$2e2bcd8739ae039);

var $3RWp2 = parcelRequire("3RWp2");
var $8b1cec496750908a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8b1cec496750908a$var$DecodedChar = /** @class */ function(_super) {
    $8b1cec496750908a$var$__extends(DecodedChar, _super);
    function DecodedChar(newPosition, value) {
        var _this = _super.call(this, newPosition) || this;
        _this.value = value;
        return _this;
    }
    DecodedChar.prototype.getValue = function() {
        return this.value;
    };
    DecodedChar.prototype.isFNC1 = function() {
        return this.value === DecodedChar.FNC1;
    };
    DecodedChar.FNC1 = "$";
    return DecodedChar;
}((0, $3RWp2.default));
var $8b1cec496750908a$export$2e2bcd8739ae039 = $8b1cec496750908a$var$DecodedChar;

});
parcelRegister("3RWp2", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d139fe8e39cd4b6$export$2e2bcd8739ae039);
var $2d139fe8e39cd4b6$var$DecodedObject = /** @class */ function() {
    function DecodedObject(newPosition) {
        this.newPosition = newPosition;
    }
    DecodedObject.prototype.getNewPosition = function() {
        return this.newPosition;
    };
    return DecodedObject;
}();
var $2d139fe8e39cd4b6$export$2e2bcd8739ae039 = $2d139fe8e39cd4b6$var$DecodedObject;

});


parcelRegister("3Zmo6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e786f57ede3721a$export$2e2bcd8739ae039);

var $3RWp2 = parcelRequire("3RWp2");
var $2e786f57ede3721a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $2e786f57ede3721a$var$DecodedInformation = /** @class */ function(_super) {
    $2e786f57ede3721a$var$__extends(DecodedInformation, _super);
    function DecodedInformation(newPosition, newString, remainingValue) {
        var _this = _super.call(this, newPosition) || this;
        if (remainingValue) {
            _this.remaining = true;
            _this.remainingValue = _this.remainingValue;
        } else {
            _this.remaining = false;
            _this.remainingValue = 0;
        }
        _this.newString = newString;
        return _this;
    }
    DecodedInformation.prototype.getNewString = function() {
        return this.newString;
    };
    DecodedInformation.prototype.isRemaining = function() {
        return this.remaining;
    };
    DecodedInformation.prototype.getRemainingValue = function() {
        return this.remainingValue;
    };
    return DecodedInformation;
}((0, $3RWp2.default));
var $2e786f57ede3721a$export$2e2bcd8739ae039 = $2e786f57ede3721a$var$DecodedInformation;

});

parcelRegister("2QL9s", function(module, exports) {

$parcel$export(module.exports, "default", () => $213503641ae192ff$export$2e2bcd8739ae039);

var $dtgr5 = parcelRequire("dtgr5");

var $3RWp2 = parcelRequire("3RWp2");
var $213503641ae192ff$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $213503641ae192ff$var$DecodedNumeric = /** @class */ function(_super) {
    $213503641ae192ff$var$__extends(DecodedNumeric, _super);
    function DecodedNumeric(newPosition, firstDigit, secondDigit) {
        var _this = _super.call(this, newPosition) || this;
        if (firstDigit < 0 || firstDigit > 10 || secondDigit < 0 || secondDigit > 10) throw new (0, $dtgr5.default)();
        _this.firstDigit = firstDigit;
        _this.secondDigit = secondDigit;
        return _this;
    }
    DecodedNumeric.prototype.getFirstDigit = function() {
        return this.firstDigit;
    };
    DecodedNumeric.prototype.getSecondDigit = function() {
        return this.secondDigit;
    };
    DecodedNumeric.prototype.getValue = function() {
        return this.firstDigit * 10 + this.secondDigit;
    };
    DecodedNumeric.prototype.isFirstDigitFNC1 = function() {
        return this.firstDigit === DecodedNumeric.FNC1;
    };
    DecodedNumeric.prototype.isSecondDigitFNC1 = function() {
        return this.secondDigit === DecodedNumeric.FNC1;
    };
    DecodedNumeric.prototype.isAnyFNC1 = function() {
        return this.firstDigit === DecodedNumeric.FNC1 || this.secondDigit === DecodedNumeric.FNC1;
    };
    DecodedNumeric.FNC1 = 10;
    return DecodedNumeric;
}((0, $3RWp2.default));
var $213503641ae192ff$export$2e2bcd8739ae039 = $213503641ae192ff$var$DecodedNumeric;

});

parcelRegister("87Cyr", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e9ce250524bb766$export$2e2bcd8739ae039);

var $cQi30 = parcelRequire("cQi30");
var $5e9ce250524bb766$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $5e9ce250524bb766$var$FieldParser = /** @class */ function() {
    function FieldParser() {}
    FieldParser.parseFieldsInGeneralPurpose = function(rawInformation) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
        if (!rawInformation) return null;
        // Processing 2-digit AIs
        if (rawInformation.length < 2) throw new (0, $cQi30.default)();
        var firstTwoDigits = rawInformation.substring(0, 2);
        try {
            for(var _e = $5e9ce250524bb766$var$__values(FieldParser.TWO_DIGIT_DATA_LENGTH), _f = _e.next(); !_f.done; _f = _e.next()){
                var dataLength = _f.value;
                if (dataLength[0] === firstTwoDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(2, dataLength[2], rawInformation);
                    return FieldParser.processFixedAI(2, dataLength[1], rawInformation);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (rawInformation.length < 3) throw new (0, $cQi30.default)();
        var firstThreeDigits = rawInformation.substring(0, 3);
        try {
            for(var _g = $5e9ce250524bb766$var$__values(FieldParser.THREE_DIGIT_DATA_LENGTH), _h = _g.next(); !_h.done; _h = _g.next()){
                var dataLength = _h.value;
                if (dataLength[0] === firstThreeDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(3, dataLength[2], rawInformation);
                    return FieldParser.processFixedAI(3, dataLength[1], rawInformation);
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _j = $5e9ce250524bb766$var$__values(FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH), _k = _j.next(); !_k.done; _k = _j.next()){
                var dataLength = _k.value;
                if (dataLength[0] === firstThreeDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                    return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (rawInformation.length < 4) throw new (0, $cQi30.default)();
        var firstFourDigits = rawInformation.substring(0, 4);
        try {
            for(var _l = $5e9ce250524bb766$var$__values(FieldParser.FOUR_DIGIT_DATA_LENGTH), _m = _l.next(); !_m.done; _m = _l.next()){
                var dataLength = _m.value;
                if (dataLength[0] === firstFourDigits) {
                    if (dataLength[1] === FieldParser.VARIABLE_LENGTH) return FieldParser.processVariableAI(4, dataLength[2], rawInformation);
                    return FieldParser.processFixedAI(4, dataLength[1], rawInformation);
                }
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        throw new (0, $cQi30.default)();
    };
    FieldParser.processFixedAI = function(aiSize, fieldSize, rawInformation) {
        if (rawInformation.length < aiSize) throw new (0, $cQi30.default)();
        var ai = rawInformation.substring(0, aiSize);
        if (rawInformation.length < aiSize + fieldSize) throw new (0, $cQi30.default)();
        var field = rawInformation.substring(aiSize, aiSize + fieldSize);
        var remaining = rawInformation.substring(aiSize + fieldSize);
        var result = "(" + ai + ")" + field;
        var parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
        return parsedAI == null ? result : result + parsedAI;
    };
    FieldParser.processVariableAI = function(aiSize, variableFieldSize, rawInformation) {
        var ai = rawInformation.substring(0, aiSize);
        var maxSize;
        if (rawInformation.length < aiSize + variableFieldSize) maxSize = rawInformation.length;
        else maxSize = aiSize + variableFieldSize;
        var field = rawInformation.substring(aiSize, maxSize);
        var remaining = rawInformation.substring(maxSize);
        var result = "(" + ai + ")" + field;
        var parsedAI = FieldParser.parseFieldsInGeneralPurpose(remaining);
        return parsedAI == null ? result : result + parsedAI;
    };
    FieldParser.VARIABLE_LENGTH = [];
    FieldParser.TWO_DIGIT_DATA_LENGTH = [
        [
            "00",
            18
        ],
        [
            "01",
            14
        ],
        [
            "02",
            14
        ],
        [
            "10",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "11",
            6
        ],
        [
            "12",
            6
        ],
        [
            "13",
            6
        ],
        [
            "15",
            6
        ],
        [
            "17",
            6
        ],
        [
            "20",
            2
        ],
        [
            "21",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "22",
            FieldParser.VARIABLE_LENGTH,
            29
        ],
        [
            "30",
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        [
            "37",
            FieldParser.VARIABLE_LENGTH,
            8
        ],
        // internal company codes
        [
            "90",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "91",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "92",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "93",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "94",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "95",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "96",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "97",
            FieldParser.VARIABLE_LENGTH,
            3
        ],
        [
            "98",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "99",
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.THREE_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            "240",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "241",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "242",
            FieldParser.VARIABLE_LENGTH,
            6
        ],
        [
            "250",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "251",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "253",
            FieldParser.VARIABLE_LENGTH,
            17
        ],
        [
            "254",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "400",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "401",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "402",
            17
        ],
        [
            "403",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "410",
            13
        ],
        [
            "411",
            13
        ],
        [
            "412",
            13
        ],
        [
            "413",
            13
        ],
        [
            "414",
            13
        ],
        [
            "420",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "421",
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            "422",
            3
        ],
        [
            "423",
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            "424",
            3
        ],
        [
            "425",
            3
        ],
        [
            "426",
            3
        ]
    ];
    FieldParser.THREE_DIGIT_PLUS_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            "310",
            6
        ],
        [
            "311",
            6
        ],
        [
            "312",
            6
        ],
        [
            "313",
            6
        ],
        [
            "314",
            6
        ],
        [
            "315",
            6
        ],
        [
            "316",
            6
        ],
        [
            "320",
            6
        ],
        [
            "321",
            6
        ],
        [
            "322",
            6
        ],
        [
            "323",
            6
        ],
        [
            "324",
            6
        ],
        [
            "325",
            6
        ],
        [
            "326",
            6
        ],
        [
            "327",
            6
        ],
        [
            "328",
            6
        ],
        [
            "329",
            6
        ],
        [
            "330",
            6
        ],
        [
            "331",
            6
        ],
        [
            "332",
            6
        ],
        [
            "333",
            6
        ],
        [
            "334",
            6
        ],
        [
            "335",
            6
        ],
        [
            "336",
            6
        ],
        [
            "340",
            6
        ],
        [
            "341",
            6
        ],
        [
            "342",
            6
        ],
        [
            "343",
            6
        ],
        [
            "344",
            6
        ],
        [
            "345",
            6
        ],
        [
            "346",
            6
        ],
        [
            "347",
            6
        ],
        [
            "348",
            6
        ],
        [
            "349",
            6
        ],
        [
            "350",
            6
        ],
        [
            "351",
            6
        ],
        [
            "352",
            6
        ],
        [
            "353",
            6
        ],
        [
            "354",
            6
        ],
        [
            "355",
            6
        ],
        [
            "356",
            6
        ],
        [
            "357",
            6
        ],
        [
            "360",
            6
        ],
        [
            "361",
            6
        ],
        [
            "362",
            6
        ],
        [
            "363",
            6
        ],
        [
            "364",
            6
        ],
        [
            "365",
            6
        ],
        [
            "366",
            6
        ],
        [
            "367",
            6
        ],
        [
            "368",
            6
        ],
        [
            "369",
            6
        ],
        [
            "390",
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            "391",
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            "392",
            FieldParser.VARIABLE_LENGTH,
            15
        ],
        [
            "393",
            FieldParser.VARIABLE_LENGTH,
            18
        ],
        [
            "703",
            FieldParser.VARIABLE_LENGTH,
            30
        ]
    ];
    FieldParser.FOUR_DIGIT_DATA_LENGTH = [
        // Same format as above
        [
            "7001",
            13
        ],
        [
            "7002",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "7003",
            10
        ],
        [
            "8001",
            14
        ],
        [
            "8002",
            FieldParser.VARIABLE_LENGTH,
            20
        ],
        [
            "8003",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "8004",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "8005",
            6
        ],
        [
            "8006",
            18
        ],
        [
            "8007",
            FieldParser.VARIABLE_LENGTH,
            30
        ],
        [
            "8008",
            FieldParser.VARIABLE_LENGTH,
            12
        ],
        [
            "8018",
            18
        ],
        [
            "8020",
            FieldParser.VARIABLE_LENGTH,
            25
        ],
        [
            "8100",
            6
        ],
        [
            "8101",
            10
        ],
        [
            "8102",
            2
        ],
        [
            "8110",
            FieldParser.VARIABLE_LENGTH,
            70
        ],
        [
            "8200",
            FieldParser.VARIABLE_LENGTH,
            70
        ]
    ];
    return FieldParser;
}();
var $5e9ce250524bb766$export$2e2bcd8739ae039 = $5e9ce250524bb766$var$FieldParser;

});


parcelRegister("bP5q6", function(module, exports) {

$parcel$export(module.exports, "default", () => $89b8a96a178224d4$export$2e2bcd8739ae039);

var $8GTTq = parcelRequire("8GTTq");

var $6E9N1 = parcelRequire("6E9N1");
var $89b8a96a178224d4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $89b8a96a178224d4$var$AI01AndOtherAIs = /** @class */ function(_super) {
    $89b8a96a178224d4$var$__extends(AI01AndOtherAIs, _super);
    // the second one is the encodation method, and the other two are for the variable length
    function AI01AndOtherAIs(information) {
        return _super.call(this, information) || this;
    }
    AI01AndOtherAIs.prototype.parseInformation = function() {
        var buff = new (0, $6E9N1.default)();
        buff.append("(01)");
        var initialGtinPosition = buff.length();
        var firstGtinDigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01AndOtherAIs.HEADER_SIZE, 4);
        buff.append(firstGtinDigit);
        this.encodeCompressedGtinWithoutAI(buff, AI01AndOtherAIs.HEADER_SIZE + 4, initialGtinPosition);
        return this.getGeneralDecoder().decodeAllCodes(buff, AI01AndOtherAIs.HEADER_SIZE + 44);
    };
    AI01AndOtherAIs.HEADER_SIZE = 4; // first bit encodes the linkage flag,
    return AI01AndOtherAIs;
}((0, $8GTTq.default));
var $89b8a96a178224d4$export$2e2bcd8739ae039 = $89b8a96a178224d4$var$AI01AndOtherAIs;

});
parcelRegister("8GTTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $653d9a28df1a6662$export$2e2bcd8739ae039);

var $5TbhC = parcelRequire("5TbhC");
var $653d9a28df1a6662$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $653d9a28df1a6662$var$AI01decoder = /** @class */ function(_super) {
    $653d9a28df1a6662$var$__extends(AI01decoder, _super);
    function AI01decoder(information) {
        return _super.call(this, information) || this;
    }
    AI01decoder.prototype.encodeCompressedGtin = function(buf, currentPos) {
        buf.append("(01)");
        var initialPosition = buf.length();
        buf.append("9");
        this.encodeCompressedGtinWithoutAI(buf, currentPos, initialPosition);
    };
    AI01decoder.prototype.encodeCompressedGtinWithoutAI = function(buf, currentPos, initialBufferPosition) {
        for(var i = 0; i < 4; ++i){
            var currentBlock = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos + 10 * i, 10);
            if (currentBlock / 100 === 0) buf.append("0");
            if (currentBlock / 10 === 0) buf.append("0");
            buf.append(currentBlock);
        }
        AI01decoder.appendCheckDigit(buf, initialBufferPosition);
    };
    AI01decoder.appendCheckDigit = function(buf, currentPos) {
        var checkDigit = 0;
        for(var i = 0; i < 13; i++){
            // let digit = buf.charAt(i + currentPos) - '0';
            // To be checked
            var digit = buf.charAt(i + currentPos).charCodeAt(0) - "0".charCodeAt(0);
            checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
        }
        checkDigit = 10 - checkDigit % 10;
        if (checkDigit === 10) checkDigit = 0;
        buf.append(checkDigit);
    };
    AI01decoder.GTIN_SIZE = 40;
    return AI01decoder;
}((0, $5TbhC.default));
var $653d9a28df1a6662$export$2e2bcd8739ae039 = $653d9a28df1a6662$var$AI01decoder;

});
parcelRegister("5TbhC", function(module, exports) {

$parcel$export(module.exports, "default", () => $011b4589f1df5168$export$2e2bcd8739ae039);

var $iqtaA = parcelRequire("iqtaA");
var $011b4589f1df5168$var$AbstractExpandedDecoder = /** @class */ function() {
    function AbstractExpandedDecoder(information) {
        this.information = information;
        this.generalDecoder = new (0, $iqtaA.default)(information);
    }
    AbstractExpandedDecoder.prototype.getInformation = function() {
        return this.information;
    };
    AbstractExpandedDecoder.prototype.getGeneralDecoder = function() {
        return this.generalDecoder;
    };
    return AbstractExpandedDecoder;
}();
var $011b4589f1df5168$export$2e2bcd8739ae039 = $011b4589f1df5168$var$AbstractExpandedDecoder;

});



parcelRegister("7B6Sn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5881528d0453adc7$export$2e2bcd8739ae039);

var $6E9N1 = parcelRequire("6E9N1");

var $5TbhC = parcelRequire("5TbhC");
var $5881528d0453adc7$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $5881528d0453adc7$var$AnyAIDecoder = /** @class */ function(_super) {
    $5881528d0453adc7$var$__extends(AnyAIDecoder, _super);
    function AnyAIDecoder(information) {
        return _super.call(this, information) || this;
    }
    AnyAIDecoder.prototype.parseInformation = function() {
        var buf = new (0, $6E9N1.default)();
        return this.getGeneralDecoder().decodeAllCodes(buf, AnyAIDecoder.HEADER_SIZE);
    };
    AnyAIDecoder.HEADER_SIZE = 5;
    return AnyAIDecoder;
}((0, $5TbhC.default));
var $5881528d0453adc7$export$2e2bcd8739ae039 = $5881528d0453adc7$var$AnyAIDecoder;

});

parcelRegister("9J5zK", function(module, exports) {

$parcel$export(module.exports, "default", () => $714ca438305dded5$export$2e2bcd8739ae039);

var $gJr1S = parcelRequire("gJr1S");
var $714ca438305dded5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $714ca438305dded5$var$AI013103decoder = /** @class */ function(_super) {
    $714ca438305dded5$var$__extends(AI013103decoder, _super);
    function AI013103decoder(information) {
        return _super.call(this, information) || this;
    }
    AI013103decoder.prototype.addWeightCode = function(buf, weight) {
        buf.append("(3103)");
    };
    AI013103decoder.prototype.checkWeight = function(weight) {
        return weight;
    };
    return AI013103decoder;
}((0, $gJr1S.default));
var $714ca438305dded5$export$2e2bcd8739ae039 = $714ca438305dded5$var$AI013103decoder;

});
parcelRegister("gJr1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2e5d0c55b6eb552$export$2e2bcd8739ae039);

var $hEiGU = parcelRequire("hEiGU");

var $6E9N1 = parcelRequire("6E9N1");

var $cQi30 = parcelRequire("cQi30");
var $c2e5d0c55b6eb552$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c2e5d0c55b6eb552$var$AI013x0xDecoder = /** @class */ function(_super) {
    $c2e5d0c55b6eb552$var$__extends(AI013x0xDecoder, _super);
    function AI013x0xDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI013x0xDecoder.prototype.parseInformation = function() {
        if (this.getInformation().getSize() !== AI013x0xDecoder.HEADER_SIZE + (0, $hEiGU.default).GTIN_SIZE + AI013x0xDecoder.WEIGHT_SIZE) throw new (0, $cQi30.default)();
        var buf = new (0, $6E9N1.default)();
        this.encodeCompressedGtin(buf, AI013x0xDecoder.HEADER_SIZE);
        this.encodeCompressedWeight(buf, AI013x0xDecoder.HEADER_SIZE + (0, $hEiGU.default).GTIN_SIZE, AI013x0xDecoder.WEIGHT_SIZE);
        return buf.toString();
    };
    AI013x0xDecoder.HEADER_SIZE = 5;
    AI013x0xDecoder.WEIGHT_SIZE = 15;
    return AI013x0xDecoder;
}((0, $hEiGU.default));
var $c2e5d0c55b6eb552$export$2e2bcd8739ae039 = $c2e5d0c55b6eb552$var$AI013x0xDecoder;

});
parcelRegister("hEiGU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd94abc0555640e6$export$2e2bcd8739ae039);

var $8GTTq = parcelRequire("8GTTq");
var $cd94abc0555640e6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $cd94abc0555640e6$var$AI01weightDecoder = /** @class */ function(_super) {
    $cd94abc0555640e6$var$__extends(AI01weightDecoder, _super);
    function AI01weightDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI01weightDecoder.prototype.encodeCompressedWeight = function(buf, currentPos, weightSize) {
        var originalWeightNumeric = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, weightSize);
        this.addWeightCode(buf, originalWeightNumeric);
        var weightNumeric = this.checkWeight(originalWeightNumeric);
        var currentDivisor = 100000;
        for(var i = 0; i < 5; ++i){
            if (weightNumeric / currentDivisor === 0) buf.append("0");
            currentDivisor /= 10;
        }
        buf.append(weightNumeric);
    };
    return AI01weightDecoder;
}((0, $8GTTq.default));
var $cd94abc0555640e6$export$2e2bcd8739ae039 = $cd94abc0555640e6$var$AI01weightDecoder;

});



parcelRegister("fKw9z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b77417e0915fb6cb$export$2e2bcd8739ae039);

var $gJr1S = parcelRequire("gJr1S");
var $b77417e0915fb6cb$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $b77417e0915fb6cb$var$AI01320xDecoder = /** @class */ function(_super) {
    $b77417e0915fb6cb$var$__extends(AI01320xDecoder, _super);
    function AI01320xDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI01320xDecoder.prototype.addWeightCode = function(buf, weight) {
        if (weight < 10000) buf.append("(3202)");
        else buf.append("(3203)");
    };
    AI01320xDecoder.prototype.checkWeight = function(weight) {
        if (weight < 10000) return weight;
        return weight - 10000;
    };
    return AI01320xDecoder;
}((0, $gJr1S.default));
var $b77417e0915fb6cb$export$2e2bcd8739ae039 = $b77417e0915fb6cb$var$AI01320xDecoder;

});

parcelRegister("9zaRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f6fcdd60260d496$export$2e2bcd8739ae039);

var $8GTTq = parcelRequire("8GTTq");

var $cQi30 = parcelRequire("cQi30");

var $6E9N1 = parcelRequire("6E9N1");
var $6f6fcdd60260d496$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6f6fcdd60260d496$var$AI01392xDecoder = /** @class */ function(_super) {
    $6f6fcdd60260d496$var$__extends(AI01392xDecoder, _super);
    function AI01392xDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI01392xDecoder.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < AI01392xDecoder.HEADER_SIZE + (0, $8GTTq.default).GTIN_SIZE) throw new (0, $cQi30.default)();
        var buf = new (0, $6E9N1.default)();
        this.encodeCompressedGtin(buf, AI01392xDecoder.HEADER_SIZE);
        var lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01392xDecoder.HEADER_SIZE + (0, $8GTTq.default).GTIN_SIZE, AI01392xDecoder.LAST_DIGIT_SIZE);
        buf.append("(392");
        buf.append(lastAIdigit);
        buf.append(")");
        var decodedInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01392xDecoder.HEADER_SIZE + (0, $8GTTq.default).GTIN_SIZE + AI01392xDecoder.LAST_DIGIT_SIZE, null);
        buf.append(decodedInformation.getNewString());
        return buf.toString();
    };
    AI01392xDecoder.HEADER_SIZE = 8;
    AI01392xDecoder.LAST_DIGIT_SIZE = 2;
    return AI01392xDecoder;
}((0, $8GTTq.default));
var $6f6fcdd60260d496$export$2e2bcd8739ae039 = $6f6fcdd60260d496$var$AI01392xDecoder;

});

parcelRegister("4eSFZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3162e1cc07526a47$export$2e2bcd8739ae039);

var $8GTTq = parcelRequire("8GTTq");

var $cQi30 = parcelRequire("cQi30");

var $6E9N1 = parcelRequire("6E9N1");
var $3162e1cc07526a47$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $3162e1cc07526a47$var$AI01393xDecoder = /** @class */ function(_super) {
    $3162e1cc07526a47$var$__extends(AI01393xDecoder, _super);
    function AI01393xDecoder(information) {
        return _super.call(this, information) || this;
    }
    AI01393xDecoder.prototype.parseInformation = function() {
        if (this.getInformation().getSize() < AI01393xDecoder.HEADER_SIZE + (0, $8GTTq.default).GTIN_SIZE) throw new (0, $cQi30.default)();
        var buf = new (0, $6E9N1.default)();
        this.encodeCompressedGtin(buf, AI01393xDecoder.HEADER_SIZE);
        var lastAIdigit = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + (0, $8GTTq.default).GTIN_SIZE, AI01393xDecoder.LAST_DIGIT_SIZE);
        buf.append("(393");
        buf.append(lastAIdigit);
        buf.append(")");
        var firstThreeDigits = this.getGeneralDecoder().extractNumericValueFromBitArray(AI01393xDecoder.HEADER_SIZE + (0, $8GTTq.default).GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE, AI01393xDecoder.FIRST_THREE_DIGITS_SIZE);
        if (firstThreeDigits / 100 === 0) buf.append("0");
        if (firstThreeDigits / 10 === 0) buf.append("0");
        buf.append(firstThreeDigits);
        var generalInformation = this.getGeneralDecoder().decodeGeneralPurposeField(AI01393xDecoder.HEADER_SIZE + (0, $8GTTq.default).GTIN_SIZE + AI01393xDecoder.LAST_DIGIT_SIZE + AI01393xDecoder.FIRST_THREE_DIGITS_SIZE, null);
        buf.append(generalInformation.getNewString());
        return buf.toString();
    };
    AI01393xDecoder.HEADER_SIZE = 8;
    AI01393xDecoder.LAST_DIGIT_SIZE = 2;
    AI01393xDecoder.FIRST_THREE_DIGITS_SIZE = 10;
    return AI01393xDecoder;
}((0, $8GTTq.default));
var $3162e1cc07526a47$export$2e2bcd8739ae039 = $3162e1cc07526a47$var$AI01393xDecoder;

});

parcelRegister("6lqug", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e940081fa35410$export$2e2bcd8739ae039);

var $hEiGU = parcelRequire("hEiGU");

var $cQi30 = parcelRequire("cQi30");

var $6E9N1 = parcelRequire("6E9N1");
var $49e940081fa35410$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $49e940081fa35410$var$AI013x0x1xDecoder = /** @class */ function(_super) {
    $49e940081fa35410$var$__extends(AI013x0x1xDecoder, _super);
    function AI013x0x1xDecoder(information, firstAIdigits, dateCode) {
        var _this = _super.call(this, information) || this;
        _this.dateCode = dateCode;
        _this.firstAIdigits = firstAIdigits;
        return _this;
    }
    AI013x0x1xDecoder.prototype.parseInformation = function() {
        if (this.getInformation().getSize() !== AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE + AI013x0x1xDecoder.DATE_SIZE) throw new (0, $cQi30.default)();
        var buf = new (0, $6E9N1.default)();
        this.encodeCompressedGtin(buf, AI013x0x1xDecoder.HEADER_SIZE);
        this.encodeCompressedWeight(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE, AI013x0x1xDecoder.WEIGHT_SIZE);
        this.encodeCompressedDate(buf, AI013x0x1xDecoder.HEADER_SIZE + AI013x0x1xDecoder.GTIN_SIZE + AI013x0x1xDecoder.WEIGHT_SIZE);
        return buf.toString();
    };
    AI013x0x1xDecoder.prototype.encodeCompressedDate = function(buf, currentPos) {
        var numericDate = this.getGeneralDecoder().extractNumericValueFromBitArray(currentPos, AI013x0x1xDecoder.DATE_SIZE);
        if (numericDate === 38400) return;
        buf.append("(");
        buf.append(this.dateCode);
        buf.append(")");
        var day = numericDate % 32;
        numericDate /= 32;
        var month = numericDate % 12 + 1;
        numericDate /= 12;
        var year = numericDate;
        if (year / 10 === 0) buf.append("0");
        buf.append(year);
        if (month / 10 === 0) buf.append("0");
        buf.append(month);
        if (day / 10 === 0) buf.append("0");
        buf.append(day);
    };
    AI013x0x1xDecoder.prototype.addWeightCode = function(buf, weight) {
        buf.append("(");
        buf.append(this.firstAIdigits);
        buf.append(weight / 100000);
        buf.append(")");
    };
    AI013x0x1xDecoder.prototype.checkWeight = function(weight) {
        return weight % 100000;
    };
    AI013x0x1xDecoder.HEADER_SIZE = 8;
    AI013x0x1xDecoder.WEIGHT_SIZE = 20;
    AI013x0x1xDecoder.DATE_SIZE = 16;
    return AI013x0x1xDecoder;
}((0, $hEiGU.default));
var $49e940081fa35410$export$2e2bcd8739ae039 = $49e940081fa35410$var$AI013x0x1xDecoder;

});


parcelRegister("iCJ3w", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8eeb9c004bb4183$export$2e2bcd8739ae039);
var $d8eeb9c004bb4183$var$ExpandedPair = /** @class */ function() {
    function ExpandedPair(leftChar, rightChar, finderPatter, mayBeLast) {
        this.leftchar = leftChar;
        this.rightchar = rightChar;
        this.finderpattern = finderPatter;
        this.maybeLast = mayBeLast;
    }
    ExpandedPair.prototype.mayBeLast = function() {
        return this.maybeLast;
    };
    ExpandedPair.prototype.getLeftChar = function() {
        return this.leftchar;
    };
    ExpandedPair.prototype.getRightChar = function() {
        return this.rightchar;
    };
    ExpandedPair.prototype.getFinderPattern = function() {
        return this.finderpattern;
    };
    ExpandedPair.prototype.mustBeLast = function() {
        return this.rightchar == null;
    };
    ExpandedPair.prototype.toString = function() {
        return "[ " + this.leftchar + ", " + this.rightchar + " : " + (this.finderpattern == null ? "null" : this.finderpattern.getValue()) + " ]";
    };
    ExpandedPair.equals = function(o1, o2) {
        if (!(o1 instanceof ExpandedPair)) return false;
        return ExpandedPair.equalsOrNull(o1.leftchar, o2.leftchar) && ExpandedPair.equalsOrNull(o1.rightchar, o2.rightchar) && ExpandedPair.equalsOrNull(o1.finderpattern, o2.finderpattern);
    };
    ExpandedPair.equalsOrNull = function(o1, o2) {
        return o1 === null ? o2 === null : ExpandedPair.equals(o1, o2);
    };
    ExpandedPair.prototype.hashCode = function() {
        // return ExpandedPair.hashNotNull(leftChar) ^ hashNotNull(rightChar) ^ hashNotNull(finderPattern);
        var value = this.leftchar.getValue() ^ this.rightchar.getValue() ^ this.finderpattern.getValue();
        return value;
    };
    return ExpandedPair;
}();
var $d8eeb9c004bb4183$export$2e2bcd8739ae039 = $d8eeb9c004bb4183$var$ExpandedPair;

});

parcelRegister("aeyWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $7736522f631284ef$export$2e2bcd8739ae039);
var $7736522f631284ef$var$ExpandedRow = /** @class */ function() {
    function ExpandedRow(pairs, rowNumber, wasReversed) {
        this.pairs = pairs;
        this.rowNumber = rowNumber;
        this.wasReversed = wasReversed;
    }
    ExpandedRow.prototype.getPairs = function() {
        return this.pairs;
    };
    ExpandedRow.prototype.getRowNumber = function() {
        return this.rowNumber;
    };
    ExpandedRow.prototype.isReversed = function() {
        return this.wasReversed;
    };
    // check implementation
    ExpandedRow.prototype.isEquivalent = function(otherPairs) {
        return this.checkEqualitity(this, otherPairs);
    };
    // @Override
    ExpandedRow.prototype.toString = function() {
        return "{ " + this.pairs + " }";
    };
    /**
     * Two rows are equal if they contain the same pairs in the same order.
     */ // @Override
    // check implementation
    ExpandedRow.prototype.equals = function(o1, o2) {
        if (!(o1 instanceof ExpandedRow)) return false;
        return this.checkEqualitity(o1, o2) && o1.wasReversed === o2.wasReversed;
    };
    ExpandedRow.prototype.checkEqualitity = function(pair1, pair2) {
        if (!pair1 || !pair2) return;
        var result;
        pair1.forEach(function(e1, i) {
            pair2.forEach(function(e2) {
                if (e1.getLeftChar().getValue() === e2.getLeftChar().getValue() && e1.getRightChar().getValue() === e2.getRightChar().getValue() && e1.getFinderPatter().getValue() === e2.getFinderPatter().getValue()) result = true;
            });
        });
        return result;
    };
    return ExpandedRow;
}();
var $7736522f631284ef$export$2e2bcd8739ae039 = $7736522f631284ef$var$ExpandedRow;

});


parcelRegister("bDjlU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8782593aee27256a$export$2e2bcd8739ae039);

var $8qGai = parcelRequire("8qGai");

var $1JkAC = parcelRequire("1JkAC");

var $kWndQ = parcelRequire("kWndQ");

var $b5DE3 = parcelRequire("b5DE3");

var $cQi30 = parcelRequire("cQi30");

var $6E9N1 = parcelRequire("6E9N1");

var $bx5V3 = parcelRequire("bx5V3");

var $fwBMA = parcelRequire("fwBMA");

var $c141E = parcelRequire("c141E");

var $5QMYA = parcelRequire("5QMYA");

var $fbOCK = parcelRequire("fbOCK");

var $a2qrf = parcelRequire("a2qrf");

var $b6IL4 = parcelRequire("b6IL4");

var $itEYK = parcelRequire("itEYK");
var $8782593aee27256a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $8782593aee27256a$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $8782593aee27256a$var$RSS14Reader = /** @class */ function(_super) {
    $8782593aee27256a$var$__extends(RSS14Reader, _super);
    function RSS14Reader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.possibleLeftPairs = [];
        _this.possibleRightPairs = [];
        return _this;
    }
    RSS14Reader.prototype.decodeRow = function(rowNumber, row, hints) {
        var e_1, _a, e_2, _b;
        var leftPair = this.decodePair(row, false, rowNumber, hints);
        RSS14Reader.addOrTally(this.possibleLeftPairs, leftPair);
        row.reverse();
        var rightPair = this.decodePair(row, true, rowNumber, hints);
        RSS14Reader.addOrTally(this.possibleRightPairs, rightPair);
        row.reverse();
        try {
            for(var _c = $8782593aee27256a$var$__values(this.possibleLeftPairs), _d = _c.next(); !_d.done; _d = _c.next()){
                var left = _d.value;
                if (left.getCount() > 1) try {
                    for(var _e = (e_2 = void 0, $8782593aee27256a$var$__values(this.possibleRightPairs)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var right = _f.value;
                        if (right.getCount() > 1 && RSS14Reader.checkChecksum(left, right)) return RSS14Reader.constructResult(left, right);
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        throw new (0, $cQi30.default)();
    };
    RSS14Reader.addOrTally = function(possiblePairs, pair) {
        var e_3, _a;
        if (pair == null) return;
        var found = false;
        try {
            for(var possiblePairs_1 = $8782593aee27256a$var$__values(possiblePairs), possiblePairs_1_1 = possiblePairs_1.next(); !possiblePairs_1_1.done; possiblePairs_1_1 = possiblePairs_1.next()){
                var other = possiblePairs_1_1.value;
                if (other.getValue() === pair.getValue()) {
                    other.incrementCount();
                    found = true;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (possiblePairs_1_1 && !possiblePairs_1_1.done && (_a = possiblePairs_1.return)) _a.call(possiblePairs_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!found) possiblePairs.push(pair);
    };
    RSS14Reader.prototype.reset = function() {
        this.possibleLeftPairs.length = 0;
        this.possibleRightPairs.length = 0;
    };
    RSS14Reader.constructResult = function(leftPair, rightPair) {
        var symbolValue = 4537077 * leftPair.getValue() + rightPair.getValue();
        var text = new String(symbolValue).toString();
        var buffer = new (0, $6E9N1.default)();
        for(var i = 13 - text.length; i > 0; i--)buffer.append("0");
        buffer.append(text);
        var checkDigit = 0;
        for(var i = 0; i < 13; i++){
            var digit = buffer.charAt(i).charCodeAt(0) - "0".charCodeAt(0);
            checkDigit += (i & 0x01) === 0 ? 3 * digit : digit;
        }
        checkDigit = 10 - checkDigit % 10;
        if (checkDigit === 10) checkDigit = 0;
        buffer.append(checkDigit.toString());
        var leftPoints = leftPair.getFinderPattern().getResultPoints();
        var rightPoints = rightPair.getFinderPattern().getResultPoints();
        return new (0, $kWndQ.default)(buffer.toString(), null, 0, [
            leftPoints[0],
            leftPoints[1],
            rightPoints[0],
            rightPoints[1]
        ], (0, $bx5V3.default).RSS_14, new Date().getTime());
    };
    RSS14Reader.checkChecksum = function(leftPair, rightPair) {
        var checkValue = (leftPair.getChecksumPortion() + 16 * rightPair.getChecksumPortion()) % 79;
        var targetCheckValue = 9 * leftPair.getFinderPattern().getValue() + rightPair.getFinderPattern().getValue();
        if (targetCheckValue > 72) targetCheckValue--;
        if (targetCheckValue > 8) targetCheckValue--;
        return checkValue === targetCheckValue;
    };
    RSS14Reader.prototype.decodePair = function(row, right, rowNumber, hints) {
        try {
            var startEnd = this.findFinderPattern(row, right);
            var pattern = this.parseFoundFinderPattern(row, rowNumber, right, startEnd);
            var resultPointCallback = hints == null ? null : hints.get((0, $b5DE3.default).NEED_RESULT_POINT_CALLBACK);
            if (resultPointCallback != null) {
                var center = (startEnd[0] + startEnd[1]) / 2.0;
                if (right) // row is actually reversed
                center = row.getSize() - 1 - center;
                resultPointCallback.foundPossibleResultPoint(new (0, $fwBMA.default)(center, rowNumber));
            }
            var outside = this.decodeDataCharacter(row, pattern, true);
            var inside = this.decodeDataCharacter(row, pattern, false);
            return new (0, $1JkAC.default)(1597 * outside.getValue() + inside.getValue(), outside.getChecksumPortion() + 4 * inside.getChecksumPortion(), pattern);
        } catch (err) {
            return null;
        }
    };
    RSS14Reader.prototype.decodeDataCharacter = function(row, pattern, outsideChar) {
        var counters = this.getDataCharacterCounters();
        for(var x = 0; x < counters.length; x++)counters[x] = 0;
        if (outsideChar) (0, $itEYK.default).recordPatternInReverse(row, pattern.getStartEnd()[0], counters);
        else {
            (0, $itEYK.default).recordPattern(row, pattern.getStartEnd()[1] + 1, counters);
            // reverse it
            for(var i = 0, j = counters.length - 1; i < j; i++, j--){
                var temp = counters[i];
                counters[i] = counters[j];
                counters[j] = temp;
            }
        }
        var numModules = outsideChar ? 16 : 15;
        var elementWidth = (0, $fbOCK.default).sum(new Int32Array(counters)) / numModules;
        var oddCounts = this.getOddCounts();
        var evenCounts = this.getEvenCounts();
        var oddRoundingErrors = this.getOddRoundingErrors();
        var evenRoundingErrors = this.getEvenRoundingErrors();
        for(var i = 0; i < counters.length; i++){
            var value = counters[i] / elementWidth;
            var count = Math.floor(value + 0.5);
            if (count < 1) count = 1;
            else if (count > 8) count = 8;
            var offset = Math.floor(i / 2);
            if ((i & 0x01) === 0) {
                oddCounts[offset] = count;
                oddRoundingErrors[offset] = value - count;
            } else {
                evenCounts[offset] = count;
                evenRoundingErrors[offset] = value - count;
            }
        }
        this.adjustOddEvenCounts(outsideChar, numModules);
        var oddSum = 0;
        var oddChecksumPortion = 0;
        for(var i = oddCounts.length - 1; i >= 0; i--){
            oddChecksumPortion *= 9;
            oddChecksumPortion += oddCounts[i];
            oddSum += oddCounts[i];
        }
        var evenChecksumPortion = 0;
        var evenSum = 0;
        for(var i = evenCounts.length - 1; i >= 0; i--){
            evenChecksumPortion *= 9;
            evenChecksumPortion += evenCounts[i];
            evenSum += evenCounts[i];
        }
        var checksumPortion = oddChecksumPortion + 3 * evenChecksumPortion;
        if (outsideChar) {
            if ((oddSum & 0x01) !== 0 || oddSum > 12 || oddSum < 4) throw new (0, $cQi30.default)();
            var group = (12 - oddSum) / 2;
            var oddWidest = RSS14Reader.OUTSIDE_ODD_WIDEST[group];
            var evenWidest = 9 - oddWidest;
            var vOdd = (0, $a2qrf.default).getRSSvalue(oddCounts, oddWidest, false);
            var vEven = (0, $a2qrf.default).getRSSvalue(evenCounts, evenWidest, true);
            var tEven = RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET[group];
            var gSum = RSS14Reader.OUTSIDE_GSUM[group];
            return new (0, $5QMYA.default)(vOdd * tEven + vEven + gSum, checksumPortion);
        } else {
            if ((evenSum & 0x01) !== 0 || evenSum > 10 || evenSum < 4) throw new (0, $cQi30.default)();
            var group = (10 - evenSum) / 2;
            var oddWidest = RSS14Reader.INSIDE_ODD_WIDEST[group];
            var evenWidest = 9 - oddWidest;
            var vOdd = (0, $a2qrf.default).getRSSvalue(oddCounts, oddWidest, true);
            var vEven = (0, $a2qrf.default).getRSSvalue(evenCounts, evenWidest, false);
            var tOdd = RSS14Reader.INSIDE_ODD_TOTAL_SUBSET[group];
            var gSum = RSS14Reader.INSIDE_GSUM[group];
            return new (0, $5QMYA.default)(vEven * tOdd + vOdd + gSum, checksumPortion);
        }
    };
    RSS14Reader.prototype.findFinderPattern = function(row, rightFinderPattern) {
        var counters = this.getDecodeFinderCounters();
        counters[0] = 0;
        counters[1] = 0;
        counters[2] = 0;
        counters[3] = 0;
        var width = row.getSize();
        var isWhite = false;
        var rowOffset = 0;
        while(rowOffset < width){
            isWhite = !row.get(rowOffset);
            if (rightFinderPattern === isWhite) break;
            rowOffset++;
        }
        var counterPosition = 0;
        var patternStart = rowOffset;
        for(var x = rowOffset; x < width; x++)if (row.get(x) !== isWhite) counters[counterPosition]++;
        else {
            if (counterPosition === 3) {
                if ((0, $8qGai.default).isFinderPattern(counters)) return [
                    patternStart,
                    x
                ];
                patternStart += counters[0] + counters[1];
                counters[0] = counters[2];
                counters[1] = counters[3];
                counters[2] = 0;
                counters[3] = 0;
                counterPosition--;
            } else counterPosition++;
            counters[counterPosition] = 1;
            isWhite = !isWhite;
        }
        throw new (0, $cQi30.default)();
    };
    RSS14Reader.prototype.parseFoundFinderPattern = function(row, rowNumber, right, startEnd) {
        // Actually we found elements 2-5
        var firstIsBlack = row.get(startEnd[0]);
        var firstElementStart = startEnd[0] - 1;
        // Locate element 1
        while(firstElementStart >= 0 && firstIsBlack !== row.get(firstElementStart))firstElementStart--;
        firstElementStart++;
        var firstCounter = startEnd[0] - firstElementStart;
        // Make 'counters' hold 1-4
        var counters = this.getDecodeFinderCounters();
        var copy = new Int32Array(counters.length);
        (0, $b6IL4.default).arraycopy(counters, 0, copy, 1, counters.length - 1);
        copy[0] = firstCounter;
        var value = this.parseFinderValue(copy, RSS14Reader.FINDER_PATTERNS);
        var start = firstElementStart;
        var end = startEnd[1];
        if (right) {
            // row is actually reversed
            start = row.getSize() - 1 - start;
            end = row.getSize() - 1 - end;
        }
        return new (0, $c141E.default)(value, [
            firstElementStart,
            startEnd[1]
        ], start, end, rowNumber);
    };
    RSS14Reader.prototype.adjustOddEvenCounts = function(outsideChar, numModules) {
        var oddSum = (0, $fbOCK.default).sum(new Int32Array(this.getOddCounts()));
        var evenSum = (0, $fbOCK.default).sum(new Int32Array(this.getEvenCounts()));
        var incrementOdd = false;
        var decrementOdd = false;
        var incrementEven = false;
        var decrementEven = false;
        if (outsideChar) {
            if (oddSum > 12) decrementOdd = true;
            else if (oddSum < 4) incrementOdd = true;
            if (evenSum > 12) decrementEven = true;
            else if (evenSum < 4) incrementEven = true;
        } else {
            if (oddSum > 11) decrementOdd = true;
            else if (oddSum < 5) incrementOdd = true;
            if (evenSum > 10) decrementEven = true;
            else if (evenSum < 4) incrementEven = true;
        }
        var mismatch = oddSum + evenSum - numModules;
        var oddParityBad = (oddSum & 0x01) === (outsideChar ? 1 : 0);
        var evenParityBad = (evenSum & 0x01) === 1;
        if (mismatch === 1) {
            if (oddParityBad) {
                if (evenParityBad) throw new (0, $cQi30.default)();
                decrementOdd = true;
            } else {
                if (!evenParityBad) throw new (0, $cQi30.default)();
                decrementEven = true;
            }
        } else if (mismatch === -1) {
            if (oddParityBad) {
                if (evenParityBad) throw new (0, $cQi30.default)();
                incrementOdd = true;
            } else {
                if (!evenParityBad) throw new (0, $cQi30.default)();
                incrementEven = true;
            }
        } else if (mismatch === 0) {
            if (oddParityBad) {
                if (!evenParityBad) throw new (0, $cQi30.default)();
                // Both bad
                if (oddSum < evenSum) {
                    incrementOdd = true;
                    decrementEven = true;
                } else {
                    decrementOdd = true;
                    incrementEven = true;
                }
            } else {
                if (evenParityBad) throw new (0, $cQi30.default)();
            // Nothing to do!
            }
        } else throw new (0, $cQi30.default)();
        if (incrementOdd) {
            if (decrementOdd) throw new (0, $cQi30.default)();
            (0, $8qGai.default).increment(this.getOddCounts(), this.getOddRoundingErrors());
        }
        if (decrementOdd) (0, $8qGai.default).decrement(this.getOddCounts(), this.getOddRoundingErrors());
        if (incrementEven) {
            if (decrementEven) throw new (0, $cQi30.default)();
            (0, $8qGai.default).increment(this.getEvenCounts(), this.getOddRoundingErrors());
        }
        if (decrementEven) (0, $8qGai.default).decrement(this.getEvenCounts(), this.getEvenRoundingErrors());
    };
    RSS14Reader.OUTSIDE_EVEN_TOTAL_SUBSET = [
        1,
        10,
        34,
        70,
        126
    ];
    RSS14Reader.INSIDE_ODD_TOTAL_SUBSET = [
        4,
        20,
        48,
        81
    ];
    RSS14Reader.OUTSIDE_GSUM = [
        0,
        161,
        961,
        2015,
        2715
    ];
    RSS14Reader.INSIDE_GSUM = [
        0,
        336,
        1036,
        1516
    ];
    RSS14Reader.OUTSIDE_ODD_WIDEST = [
        8,
        6,
        4,
        3,
        1
    ];
    RSS14Reader.INSIDE_ODD_WIDEST = [
        2,
        4,
        6,
        8
    ];
    RSS14Reader.FINDER_PATTERNS = [
        Int32Array.from([
            3,
            8,
            2,
            1
        ]),
        Int32Array.from([
            3,
            5,
            5,
            1
        ]),
        Int32Array.from([
            3,
            3,
            7,
            1
        ]),
        Int32Array.from([
            3,
            1,
            9,
            1
        ]),
        Int32Array.from([
            2,
            7,
            4,
            1
        ]),
        Int32Array.from([
            2,
            5,
            6,
            1
        ]),
        Int32Array.from([
            2,
            3,
            8,
            1
        ]),
        Int32Array.from([
            1,
            5,
            7,
            1
        ]),
        Int32Array.from([
            1,
            3,
            9,
            1
        ])
    ];
    return RSS14Reader;
}((0, $8qGai.default));
var $8782593aee27256a$export$2e2bcd8739ae039 = $8782593aee27256a$var$RSS14Reader;

});
parcelRegister("1JkAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1429f70f6af1a56e$export$2e2bcd8739ae039);

var $5QMYA = parcelRequire("5QMYA");
var $1429f70f6af1a56e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $1429f70f6af1a56e$var$Pair = /** @class */ function(_super) {
    $1429f70f6af1a56e$var$__extends(Pair, _super);
    function Pair(value, checksumPortion, finderPattern) {
        var _this = _super.call(this, value, checksumPortion) || this;
        _this.count = 0;
        _this.finderPattern = finderPattern;
        return _this;
    }
    Pair.prototype.getFinderPattern = function() {
        return this.finderPattern;
    };
    Pair.prototype.getCount = function() {
        return this.count;
    };
    Pair.prototype.incrementCount = function() {
        this.count++;
    };
    return Pair;
}((0, $5QMYA.default));
var $1429f70f6af1a56e$export$2e2bcd8739ae039 = $1429f70f6af1a56e$var$Pair;

});




parcelRegister("5BKaQ", function(module, exports) {

var $au3R0 = parcelRequire("au3R0");

var $lxsNI = parcelRequire("lxsNI");
var $4154399f9e037fcd$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 *
 * QR Code reader to use from browser.
 */ var $4154399f9e037fcd$export$5eb1c99461f4b7ef = /** @class */ function(_super) {
    $4154399f9e037fcd$var$__extends(BrowserDatamatrixCodeReader, _super);
    /**
     * Creates an instance of BrowserQRCodeReader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     */ function BrowserDatamatrixCodeReader(timeBetweenScansMillis) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $lxsNI.default)(), timeBetweenScansMillis) || this;
    }
    return BrowserDatamatrixCodeReader;
}((0, $au3R0.BrowserCodeReader));

});
parcelRegister("lxsNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fae3054942912357$export$2e2bcd8739ae039);

var $bx5V3 = parcelRequire("bx5V3");

var $hzqel = parcelRequire("hzqel");

var $b5DE3 = parcelRequire("b5DE3");

var $cQi30 = parcelRequire("cQi30");

var $kWndQ = parcelRequire("kWndQ");

var $eS8qc = parcelRequire("eS8qc");

var $b6IL4 = parcelRequire("b6IL4");

var $jsp6y = parcelRequire("jsp6y");

var $fE0wh = parcelRequire("fE0wh");
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * This implementation can detect and decode Data Matrix codes in an image.
 *
 * @author bbrown@google.com (Brian Brown)
 */ var $fae3054942912357$var$DataMatrixReader = /** @class */ function() {
    function DataMatrixReader() {
        this.decoder = new (0, $jsp6y.default)();
    }
    /**
     * Locates and decodes a Data Matrix code in an image.
     *
     * @return a String representing the content encoded by the Data Matrix code
     * @throws NotFoundException if a Data Matrix code cannot be found
     * @throws FormatException if a Data Matrix code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ // @Override
    // public Result decode(BinaryBitmap image) throws NotFoundException, ChecksumException, FormatException {
    //   return decode(image, null);
    // }
    // @Override
    DataMatrixReader.prototype.decode = function(image, hints) {
        if (hints === void 0) hints = null;
        var decoderResult;
        var points;
        if (hints != null && hints.has((0, $b5DE3.default).PURE_BARCODE)) {
            var bits = DataMatrixReader.extractPureBits(image.getBlackMatrix());
            decoderResult = this.decoder.decode(bits);
            points = DataMatrixReader.NO_POINTS;
        } else {
            var detectorResult = new (0, $fE0wh.default)(image.getBlackMatrix()).detect();
            decoderResult = this.decoder.decode(detectorResult.getBits());
            points = detectorResult.getPoints();
        }
        var rawBytes = decoderResult.getRawBytes();
        var result = new (0, $kWndQ.default)(decoderResult.getText(), rawBytes, 8 * rawBytes.length, points, (0, $bx5V3.default).DATA_MATRIX, (0, $b6IL4.default).currentTimeMillis());
        var byteSegments = decoderResult.getByteSegments();
        if (byteSegments != null) result.putMetadata((0, $eS8qc.default).BYTE_SEGMENTS, byteSegments);
        var ecLevel = decoderResult.getECLevel();
        if (ecLevel != null) result.putMetadata((0, $eS8qc.default).ERROR_CORRECTION_LEVEL, ecLevel);
        return result;
    };
    // @Override
    DataMatrixReader.prototype.reset = function() {
    // do nothing
    };
    /**
     * This method detects a code in a "pure" image -- that is, pure monochrome image
     * which contains only an unrotated, unskewed, image of a code, with some white border
     * around it. This is a specialized method that works exceptionally fast in this special
     * case.
     *
     * @see com.google.zxing.qrcode.QRCodeReader#extractPureBits(BitMatrix)
     */ DataMatrixReader.extractPureBits = function(image) {
        var leftTopBlack = image.getTopLeftOnBit();
        var rightBottomBlack = image.getBottomRightOnBit();
        if (leftTopBlack == null || rightBottomBlack == null) throw new (0, $cQi30.default)();
        var moduleSize = this.moduleSize(leftTopBlack, image);
        var top = leftTopBlack[1];
        var bottom = rightBottomBlack[1];
        var left = leftTopBlack[0];
        var right = rightBottomBlack[0];
        var matrixWidth = (right - left + 1) / moduleSize;
        var matrixHeight = (bottom - top + 1) / moduleSize;
        if (matrixWidth <= 0 || matrixHeight <= 0) throw new (0, $cQi30.default)();
        // Push in the "border" by half the module width so that we start
        // sampling in the middle of the module. Just in case the image is a
        // little off, this will help recover.
        var nudge = moduleSize / 2;
        top += nudge;
        left += nudge;
        // Now just read off the bits
        var bits = new (0, $hzqel.default)(matrixWidth, matrixHeight);
        for(var y = 0; y < matrixHeight; y++){
            var iOffset = top + y * moduleSize;
            for(var x = 0; x < matrixWidth; x++)if (image.get(left + x * moduleSize, iOffset)) bits.set(x, y);
        }
        return bits;
    };
    DataMatrixReader.moduleSize = function(leftTopBlack, image) {
        var width = image.getWidth();
        var x = leftTopBlack[0];
        var y = leftTopBlack[1];
        while(x < width && image.get(x, y))x++;
        if (x === width) throw new (0, $cQi30.default)();
        var moduleSize = x - leftTopBlack[0];
        if (moduleSize === 0) throw new (0, $cQi30.default)();
        return moduleSize;
    };
    DataMatrixReader.NO_POINTS = [];
    return DataMatrixReader;
}();
var $fae3054942912357$export$2e2bcd8739ae039 = $fae3054942912357$var$DataMatrixReader;

});
parcelRegister("jsp6y", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a41b1f32b9fe9f$export$2e2bcd8739ae039);

var $9Nn2d = parcelRequire("9Nn2d");

var $7nLua = parcelRequire("7nLua");

var $f5xTf = parcelRequire("f5xTf");

var $5M7C6 = parcelRequire("5M7C6");

var $lG8Si = parcelRequire("lG8Si");

var $klJLs = parcelRequire("klJLs");
var $e2a41b1f32b9fe9f$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>The main class which implements Data Matrix Code decoding -- as opposed to locating and extracting
 * the Data Matrix Code from an image.</p>
 *
 * @author bbrown@google.com (Brian Brown)
 */ var $e2a41b1f32b9fe9f$var$Decoder = /** @class */ function() {
    function Decoder() {
        this.rsDecoder = new (0, $f5xTf.default)((0, $7nLua.default).DATA_MATRIX_FIELD_256);
    }
    /**
     * <p>Decodes a Data Matrix Code represented as a {@link BitMatrix}. A 1 or "true" is taken
     * to mean a black module.</p>
     *
     * @param bits booleans representing white/black Data Matrix Code modules
     * @return text and bytes encoded within the Data Matrix Code
     * @throws FormatException if the Data Matrix Code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.decode = function(bits) {
        var e_1, _a;
        // Construct a parser and read version, error-correction level
        var parser = new (0, $5M7C6.default)(bits);
        var version = parser.getVersion();
        // Read codewords
        var codewords = parser.readCodewords();
        // Separate into data blocks
        var dataBlocks = (0, $lG8Si.default).getDataBlocks(codewords, version);
        // Count total number of data bytes
        var totalBytes = 0;
        try {
            for(var dataBlocks_1 = $e2a41b1f32b9fe9f$var$__values(dataBlocks), dataBlocks_1_1 = dataBlocks_1.next(); !dataBlocks_1_1.done; dataBlocks_1_1 = dataBlocks_1.next()){
                var db = dataBlocks_1_1.value;
                totalBytes += db.getNumDataCodewords();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (dataBlocks_1_1 && !dataBlocks_1_1.done && (_a = dataBlocks_1.return)) _a.call(dataBlocks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var resultBytes = new Uint8Array(totalBytes);
        var dataBlocksCount = dataBlocks.length;
        // Error-correct and copy data blocks together into a stream of bytes
        for(var j = 0; j < dataBlocksCount; j++){
            var dataBlock = dataBlocks[j];
            var codewordBytes = dataBlock.getCodewords();
            var numDataCodewords = dataBlock.getNumDataCodewords();
            this.correctErrors(codewordBytes, numDataCodewords);
            for(var i = 0; i < numDataCodewords; i++)// De-interlace data blocks.
            resultBytes[i * dataBlocksCount + j] = codewordBytes[i];
        }
        // Decode the contents of that stream of bytes
        return (0, $klJLs.default).decode(resultBytes);
    };
    /**
     * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
     * correct the errors in-place using Reed-Solomon error correction.</p>
     *
     * @param codewordBytes data and error correction codewords
     * @param numDataCodewords number of codewords that are data bytes
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.correctErrors = function(codewordBytes, numDataCodewords) {
        // const numCodewords = codewordBytes.length;
        // First read into an array of ints
        var codewordsInts = new Int32Array(codewordBytes);
        // for (let i = 0; i < numCodewords; i++) {
        //   codewordsInts[i] = codewordBytes[i] & 0xFF;
        // }
        try {
            this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
        } catch (ignored /* ReedSolomonException */ ) {
            throw new (0, $9Nn2d.default)();
        }
        // Copy back into array of bytes -- only need to worry about the bytes that were data
        // We don't care about errors in the error-correction codewords
        for(var i = 0; i < numDataCodewords; i++)codewordBytes[i] = codewordsInts[i];
    };
    return Decoder;
}();
var $e2a41b1f32b9fe9f$export$2e2bcd8739ae039 = $e2a41b1f32b9fe9f$var$Decoder;

});
parcelRegister("5M7C6", function(module, exports) {

$parcel$export(module.exports, "default", () => $43475756ea75b3e6$export$2e2bcd8739ae039);

var $hzqel = parcelRequire("hzqel");

var $50eet = parcelRequire("50eet");

var $dtgr5 = parcelRequire("dtgr5");

var $kLpae = parcelRequire("kLpae");
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @author bbrown@google.com (Brian Brown)
 */ var $43475756ea75b3e6$var$BitMatrixParser = /** @class */ function() {
    /**
     * @param bitMatrix {@link BitMatrix} to parse
     * @throws FormatException if dimension is < 8 or > 144 or not 0 mod 2
     */ function BitMatrixParser(bitMatrix) {
        var dimension = bitMatrix.getHeight();
        if (dimension < 8 || dimension > 144 || (dimension & 0x01) !== 0) throw new (0, $dtgr5.default)();
        this.version = BitMatrixParser.readVersion(bitMatrix);
        this.mappingBitMatrix = this.extractDataRegion(bitMatrix);
        this.readMappingMatrix = new (0, $hzqel.default)(this.mappingBitMatrix.getWidth(), this.mappingBitMatrix.getHeight());
    }
    BitMatrixParser.prototype.getVersion = function() {
        return this.version;
    };
    /**
     * <p>Creates the version object based on the dimension of the original bit matrix from
     * the datamatrix code.</p>
     *
     * <p>See ISO 16022:2006 Table 7 - ECC 200 symbol attributes</p>
     *
     * @param bitMatrix Original {@link BitMatrix} including alignment patterns
     * @return {@link Version} encapsulating the Data Matrix Code's "version"
     * @throws FormatException if the dimensions of the mapping matrix are not valid
     * Data Matrix dimensions.
     */ BitMatrixParser.readVersion = function(bitMatrix) {
        var numRows = bitMatrix.getHeight();
        var numColumns = bitMatrix.getWidth();
        return (0, $50eet.default).getVersionForDimensions(numRows, numColumns);
    };
    /**
     * <p>Reads the bits in the {@link BitMatrix} representing the mapping matrix (No alignment patterns)
     * in the correct order in order to reconstitute the codewords bytes contained within the
     * Data Matrix Code.</p>
     *
     * @return bytes encoded within the Data Matrix Code
     * @throws FormatException if the exact number of bytes expected is not read
     */ BitMatrixParser.prototype.readCodewords = function() {
        var result = new Int8Array(this.version.getTotalCodewords());
        var resultOffset = 0;
        var row = 4;
        var column = 0;
        var numRows = this.mappingBitMatrix.getHeight();
        var numColumns = this.mappingBitMatrix.getWidth();
        var corner1Read = false;
        var corner2Read = false;
        var corner3Read = false;
        var corner4Read = false;
        // Read all of the codewords
        do {
            // Check the four corner cases
            if (row === numRows && column === 0 && !corner1Read) {
                result[resultOffset++] = this.readCorner1(numRows, numColumns) & 0xff;
                row -= 2;
                column += 2;
                corner1Read = true;
            } else if (row === numRows - 2 && column === 0 && (numColumns & 0x03) !== 0 && !corner2Read) {
                result[resultOffset++] = this.readCorner2(numRows, numColumns) & 0xff;
                row -= 2;
                column += 2;
                corner2Read = true;
            } else if (row === numRows + 4 && column === 2 && (numColumns & 0x07) === 0 && !corner3Read) {
                result[resultOffset++] = this.readCorner3(numRows, numColumns) & 0xff;
                row -= 2;
                column += 2;
                corner3Read = true;
            } else if (row === numRows - 2 && column === 0 && (numColumns & 0x07) === 4 && !corner4Read) {
                result[resultOffset++] = this.readCorner4(numRows, numColumns) & 0xff;
                row -= 2;
                column += 2;
                corner4Read = true;
            } else {
                // Sweep upward diagonally to the right
                do {
                    if (row < numRows && column >= 0 && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                    row -= 2;
                    column += 2;
                }while (row >= 0 && column < numColumns);
                row += 1;
                column += 3;
                // Sweep downward diagonally to the left
                do {
                    if (row >= 0 && column < numColumns && !this.readMappingMatrix.get(column, row)) result[resultOffset++] = this.readUtah(row, column, numRows, numColumns) & 0xff;
                    row += 2;
                    column -= 2;
                }while (row < numRows && column >= 0);
                row += 3;
                column += 1;
            }
        }while (row < numRows || column < numColumns);
        if (resultOffset !== this.version.getTotalCodewords()) throw new (0, $dtgr5.default)();
        return result;
    };
    /**
     * <p>Reads a bit of the mapping matrix accounting for boundary wrapping.</p>
     *
     * @param row Row to read in the mapping matrix
     * @param column Column to read in the mapping matrix
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return value of the given bit in the mapping matrix
     */ BitMatrixParser.prototype.readModule = function(row, column, numRows, numColumns) {
        // Adjust the row and column indices based on boundary wrapping
        if (row < 0) {
            row += numRows;
            column += 4 - (numRows + 4 & 0x07);
        }
        if (column < 0) {
            column += numColumns;
            row += 4 - (numColumns + 4 & 0x07);
        }
        this.readMappingMatrix.set(column, row);
        return this.mappingBitMatrix.get(column, row);
    };
    /**
     * <p>Reads the 8 bits of the standard Utah-shaped pattern.</p>
     *
     * <p>See ISO 16022:2006, 5.8.1 Figure 6</p>
     *
     * @param row Current row in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
     * @param column Current column in the mapping matrix, anchored at the 8th bit (LSB) of the pattern
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the utah shape
     */ BitMatrixParser.prototype.readUtah = function(row, column, numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(row - 2, column - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row - 2, column - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row - 1, column - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row - 1, column - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row - 1, column, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row, column - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row, column - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(row, column, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Reads the 8 bits of the special corner condition 1.</p>
     *
     * <p>See ISO 16022:2006, Figure F.3</p>
     *
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the Corner condition 1
     */ BitMatrixParser.prototype.readCorner1 = function(numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Reads the 8 bits of the special corner condition 2.</p>
     *
     * <p>See ISO 16022:2006, Figure F.4</p>
     *
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the Corner condition 2
     */ BitMatrixParser.prototype.readCorner2 = function(numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 4, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Reads the 8 bits of the special corner condition 3.</p>
     *
     * <p>See ISO 16022:2006, Figure F.5</p>
     *
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the Corner condition 3
     */ BitMatrixParser.prototype.readCorner3 = function(numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 3, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 3, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Reads the 8 bits of the special corner condition 4.</p>
     *
     * <p>See ISO 16022:2006, Figure F.6</p>
     *
     * @param numRows Number of rows in the mapping matrix
     * @param numColumns Number of columns in the mapping matrix
     * @return byte from the Corner condition 4
     */ BitMatrixParser.prototype.readCorner4 = function(numRows, numColumns) {
        var currentByte = 0;
        if (this.readModule(numRows - 3, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 2, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(numRows - 1, 0, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 2, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(0, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(1, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(2, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        currentByte <<= 1;
        if (this.readModule(3, numColumns - 1, numRows, numColumns)) currentByte |= 1;
        return currentByte;
    };
    /**
     * <p>Extracts the data region from a {@link BitMatrix} that contains
     * alignment patterns.</p>
     *
     * @param bitMatrix Original {@link BitMatrix} with alignment patterns
     * @return BitMatrix that has the alignment patterns removed
     */ BitMatrixParser.prototype.extractDataRegion = function(bitMatrix) {
        var symbolSizeRows = this.version.getSymbolSizeRows();
        var symbolSizeColumns = this.version.getSymbolSizeColumns();
        if (bitMatrix.getHeight() !== symbolSizeRows) throw new (0, $kLpae.default)("Dimension of bitMatrix must match the version size");
        var dataRegionSizeRows = this.version.getDataRegionSizeRows();
        var dataRegionSizeColumns = this.version.getDataRegionSizeColumns();
        var numDataRegionsRow = symbolSizeRows / dataRegionSizeRows | 0;
        var numDataRegionsColumn = symbolSizeColumns / dataRegionSizeColumns | 0;
        var sizeDataRegionRow = numDataRegionsRow * dataRegionSizeRows;
        var sizeDataRegionColumn = numDataRegionsColumn * dataRegionSizeColumns;
        var bitMatrixWithoutAlignment = new (0, $hzqel.default)(sizeDataRegionColumn, sizeDataRegionRow);
        for(var dataRegionRow = 0; dataRegionRow < numDataRegionsRow; ++dataRegionRow){
            var dataRegionRowOffset = dataRegionRow * dataRegionSizeRows;
            for(var dataRegionColumn = 0; dataRegionColumn < numDataRegionsColumn; ++dataRegionColumn){
                var dataRegionColumnOffset = dataRegionColumn * dataRegionSizeColumns;
                for(var i = 0; i < dataRegionSizeRows; ++i){
                    var readRowOffset = dataRegionRow * (dataRegionSizeRows + 2) + 1 + i;
                    var writeRowOffset = dataRegionRowOffset + i;
                    for(var j = 0; j < dataRegionSizeColumns; ++j){
                        var readColumnOffset = dataRegionColumn * (dataRegionSizeColumns + 2) + 1 + j;
                        if (bitMatrix.get(readColumnOffset, readRowOffset)) {
                            var writeColumnOffset = dataRegionColumnOffset + j;
                            bitMatrixWithoutAlignment.set(writeColumnOffset, writeRowOffset);
                        }
                    }
                }
            }
        }
        return bitMatrixWithoutAlignment;
    };
    return BitMatrixParser;
}();
var $43475756ea75b3e6$export$2e2bcd8739ae039 = $43475756ea75b3e6$var$BitMatrixParser;

});
parcelRegister("50eet", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a47fe1af02e692c$export$2e2bcd8739ae039);

var $dtgr5 = parcelRequire("dtgr5");
var $3a47fe1af02e692c$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
 * use blocks of differing sizes within one version, so, this encapsulates the parameters for
 * each set of blocks. It also holds the number of error-correction codewords per block since it
 * will be the same across all blocks within one version.</p>
 */ var $3a47fe1af02e692c$export$fad497768edab5c8 = /** @class */ function() {
    function ECBlocks(ecCodewords, ecBlocks1, ecBlocks2) {
        this.ecCodewords = ecCodewords;
        this.ecBlocks = [
            ecBlocks1
        ];
        ecBlocks2 && this.ecBlocks.push(ecBlocks2);
    }
    ECBlocks.prototype.getECCodewords = function() {
        return this.ecCodewords;
    };
    ECBlocks.prototype.getECBlocks = function() {
        return this.ecBlocks;
    };
    return ECBlocks;
}();
/**
 * <p>Encapsulates the parameters for one error-correction block in one symbol version.
 * This includes the number of data codewords, and the number of times a block with these
 * parameters is used consecutively in the Data Matrix code version's format.</p>
 */ var $3a47fe1af02e692c$export$5c3eb387265a857d = /** @class */ function() {
    function ECB(count, dataCodewords) {
        this.count = count;
        this.dataCodewords = dataCodewords;
    }
    ECB.prototype.getCount = function() {
        return this.count;
    };
    ECB.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    };
    return ECB;
}();
/**
 * The Version object encapsulates attributes about a particular
 * size Data Matrix Code.
 *
 * @author bbrown@google.com (Brian Brown)
 */ var $3a47fe1af02e692c$var$Version = /** @class */ function() {
    function Version(versionNumber, symbolSizeRows, symbolSizeColumns, dataRegionSizeRows, dataRegionSizeColumns, ecBlocks) {
        var e_1, _a;
        this.versionNumber = versionNumber;
        this.symbolSizeRows = symbolSizeRows;
        this.symbolSizeColumns = symbolSizeColumns;
        this.dataRegionSizeRows = dataRegionSizeRows;
        this.dataRegionSizeColumns = dataRegionSizeColumns;
        this.ecBlocks = ecBlocks;
        // Calculate the total number of codewords
        var total = 0;
        var ecCodewords = ecBlocks.getECCodewords();
        var ecbArray = ecBlocks.getECBlocks();
        try {
            for(var ecbArray_1 = $3a47fe1af02e692c$var$__values(ecbArray), ecbArray_1_1 = ecbArray_1.next(); !ecbArray_1_1.done; ecbArray_1_1 = ecbArray_1.next()){
                var ecBlock = ecbArray_1_1.value;
                total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecbArray_1_1 && !ecbArray_1_1.done && (_a = ecbArray_1.return)) _a.call(ecbArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.totalCodewords = total;
    }
    Version.prototype.getVersionNumber = function() {
        return this.versionNumber;
    };
    Version.prototype.getSymbolSizeRows = function() {
        return this.symbolSizeRows;
    };
    Version.prototype.getSymbolSizeColumns = function() {
        return this.symbolSizeColumns;
    };
    Version.prototype.getDataRegionSizeRows = function() {
        return this.dataRegionSizeRows;
    };
    Version.prototype.getDataRegionSizeColumns = function() {
        return this.dataRegionSizeColumns;
    };
    Version.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    };
    Version.prototype.getECBlocks = function() {
        return this.ecBlocks;
    };
    /**
     * <p>Deduces version information from Data Matrix dimensions.</p>
     *
     * @param numRows Number of rows in modules
     * @param numColumns Number of columns in modules
     * @return Version for a Data Matrix Code of those dimensions
     * @throws FormatException if dimensions do correspond to a valid Data Matrix size
     */ Version.getVersionForDimensions = function(numRows, numColumns) {
        var e_2, _a;
        if ((numRows & 0x01) !== 0 || (numColumns & 0x01) !== 0) throw new (0, $dtgr5.default)();
        try {
            for(var _b = $3a47fe1af02e692c$var$__values(Version.VERSIONS), _c = _b.next(); !_c.done; _c = _b.next()){
                var version = _c.value;
                if (version.symbolSizeRows === numRows && version.symbolSizeColumns === numColumns) return version;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        throw new (0, $dtgr5.default)();
    };
    //  @Override
    Version.prototype.toString = function() {
        return "" + this.versionNumber;
    };
    /**
     * See ISO 16022:2006 5.5.1 Table 7
     */ Version.buildVersions = function() {
        return [
            new Version(1, 10, 10, 8, 8, new $3a47fe1af02e692c$export$fad497768edab5c8(5, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 3))),
            new Version(2, 12, 12, 10, 10, new $3a47fe1af02e692c$export$fad497768edab5c8(7, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 5))),
            new Version(3, 14, 14, 12, 12, new $3a47fe1af02e692c$export$fad497768edab5c8(10, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 8))),
            new Version(4, 16, 16, 14, 14, new $3a47fe1af02e692c$export$fad497768edab5c8(12, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 12))),
            new Version(5, 18, 18, 16, 16, new $3a47fe1af02e692c$export$fad497768edab5c8(14, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 18))),
            new Version(6, 20, 20, 18, 18, new $3a47fe1af02e692c$export$fad497768edab5c8(18, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 22))),
            new Version(7, 22, 22, 20, 20, new $3a47fe1af02e692c$export$fad497768edab5c8(20, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 30))),
            new Version(8, 24, 24, 22, 22, new $3a47fe1af02e692c$export$fad497768edab5c8(24, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 36))),
            new Version(9, 26, 26, 24, 24, new $3a47fe1af02e692c$export$fad497768edab5c8(28, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 44))),
            new Version(10, 32, 32, 14, 14, new $3a47fe1af02e692c$export$fad497768edab5c8(36, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 62))),
            new Version(11, 36, 36, 16, 16, new $3a47fe1af02e692c$export$fad497768edab5c8(42, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 86))),
            new Version(12, 40, 40, 18, 18, new $3a47fe1af02e692c$export$fad497768edab5c8(48, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 114))),
            new Version(13, 44, 44, 20, 20, new $3a47fe1af02e692c$export$fad497768edab5c8(56, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 144))),
            new Version(14, 48, 48, 22, 22, new $3a47fe1af02e692c$export$fad497768edab5c8(68, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 174))),
            new Version(15, 52, 52, 24, 24, new $3a47fe1af02e692c$export$fad497768edab5c8(42, new $3a47fe1af02e692c$export$5c3eb387265a857d(2, 102))),
            new Version(16, 64, 64, 14, 14, new $3a47fe1af02e692c$export$fad497768edab5c8(56, new $3a47fe1af02e692c$export$5c3eb387265a857d(2, 140))),
            new Version(17, 72, 72, 16, 16, new $3a47fe1af02e692c$export$fad497768edab5c8(36, new $3a47fe1af02e692c$export$5c3eb387265a857d(4, 92))),
            new Version(18, 80, 80, 18, 18, new $3a47fe1af02e692c$export$fad497768edab5c8(48, new $3a47fe1af02e692c$export$5c3eb387265a857d(4, 114))),
            new Version(19, 88, 88, 20, 20, new $3a47fe1af02e692c$export$fad497768edab5c8(56, new $3a47fe1af02e692c$export$5c3eb387265a857d(4, 144))),
            new Version(20, 96, 96, 22, 22, new $3a47fe1af02e692c$export$fad497768edab5c8(68, new $3a47fe1af02e692c$export$5c3eb387265a857d(4, 174))),
            new Version(21, 104, 104, 24, 24, new $3a47fe1af02e692c$export$fad497768edab5c8(56, new $3a47fe1af02e692c$export$5c3eb387265a857d(6, 136))),
            new Version(22, 120, 120, 18, 18, new $3a47fe1af02e692c$export$fad497768edab5c8(68, new $3a47fe1af02e692c$export$5c3eb387265a857d(6, 175))),
            new Version(23, 132, 132, 20, 20, new $3a47fe1af02e692c$export$fad497768edab5c8(62, new $3a47fe1af02e692c$export$5c3eb387265a857d(8, 163))),
            new Version(24, 144, 144, 22, 22, new $3a47fe1af02e692c$export$fad497768edab5c8(62, new $3a47fe1af02e692c$export$5c3eb387265a857d(8, 156), new $3a47fe1af02e692c$export$5c3eb387265a857d(2, 155))),
            new Version(25, 8, 18, 6, 16, new $3a47fe1af02e692c$export$fad497768edab5c8(7, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 5))),
            new Version(26, 8, 32, 6, 14, new $3a47fe1af02e692c$export$fad497768edab5c8(11, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 10))),
            new Version(27, 12, 26, 10, 24, new $3a47fe1af02e692c$export$fad497768edab5c8(14, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 16))),
            new Version(28, 12, 36, 10, 16, new $3a47fe1af02e692c$export$fad497768edab5c8(18, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 22))),
            new Version(29, 16, 36, 14, 16, new $3a47fe1af02e692c$export$fad497768edab5c8(24, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 32))),
            new Version(30, 16, 48, 14, 22, new $3a47fe1af02e692c$export$fad497768edab5c8(28, new $3a47fe1af02e692c$export$5c3eb387265a857d(1, 49)))
        ];
    };
    Version.VERSIONS = Version.buildVersions();
    return Version;
}();
var $3a47fe1af02e692c$export$2e2bcd8739ae039 = $3a47fe1af02e692c$var$Version;

});


parcelRegister("lG8Si", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc84678bd65e6a8c$export$2e2bcd8739ae039);

var $kLpae = parcelRequire("kLpae");
var $fc84678bd65e6a8c$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates a block of data within a Data Matrix Code. Data Matrix Codes may split their data into
 * multiple blocks, each of which is a unit of data and error-correction codewords. Each
 * is represented by an instance of this class.</p>
 *
 * @author bbrown@google.com (Brian Brown)
 */ var $fc84678bd65e6a8c$var$DataBlock = /** @class */ function() {
    function DataBlock(numDataCodewords, codewords) {
        this.numDataCodewords = numDataCodewords;
        this.codewords = codewords;
    }
    /**
     * <p>When Data Matrix Codes use multiple data blocks, they actually interleave the bytes of each of them.
     * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
     * method will separate the data into original blocks.</p>
     *
     * @param rawCodewords bytes as read directly from the Data Matrix Code
     * @param version version of the Data Matrix Code
     * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
     *         Data Matrix Code
     */ DataBlock.getDataBlocks = function(rawCodewords, version) {
        var e_1, _a, e_2, _b;
        // Figure out the number and size of data blocks used by this version
        var ecBlocks = version.getECBlocks();
        // First count the total number of data blocks
        var totalBlocks = 0;
        var ecBlockArray = ecBlocks.getECBlocks();
        try {
            for(var ecBlockArray_1 = $fc84678bd65e6a8c$var$__values(ecBlockArray), ecBlockArray_1_1 = ecBlockArray_1.next(); !ecBlockArray_1_1.done; ecBlockArray_1_1 = ecBlockArray_1.next()){
                var ecBlock = ecBlockArray_1_1.value;
                totalBlocks += ecBlock.getCount();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecBlockArray_1_1 && !ecBlockArray_1_1.done && (_a = ecBlockArray_1.return)) _a.call(ecBlockArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // Now establish DataBlocks of the appropriate size and number of data codewords
        var result = new Array(totalBlocks);
        var numResultBlocks = 0;
        try {
            for(var ecBlockArray_2 = $fc84678bd65e6a8c$var$__values(ecBlockArray), ecBlockArray_2_1 = ecBlockArray_2.next(); !ecBlockArray_2_1.done; ecBlockArray_2_1 = ecBlockArray_2.next()){
                var ecBlock = ecBlockArray_2_1.value;
                for(var i = 0; i < ecBlock.getCount(); i++){
                    var numDataCodewords = ecBlock.getDataCodewords();
                    var numBlockCodewords = ecBlocks.getECCodewords() + numDataCodewords;
                    result[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (ecBlockArray_2_1 && !ecBlockArray_2_1.done && (_b = ecBlockArray_2.return)) _b.call(ecBlockArray_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        // All blocks have the same amount of data, except that the last n
        // (where n may be 0) have 1 less byte. Figure out where these start.
        // TODO(bbrown): There is only one case where there is a difference for Data Matrix for size 144
        var longerBlocksTotalCodewords = result[0].codewords.length;
        // int shorterBlocksTotalCodewords = longerBlocksTotalCodewords - 1;
        var longerBlocksNumDataCodewords = longerBlocksTotalCodewords - ecBlocks.getECCodewords();
        var shorterBlocksNumDataCodewords = longerBlocksNumDataCodewords - 1;
        // The last elements of result may be 1 element shorter for 144 matrix
        // first fill out as many elements as all of them have minus 1
        var rawCodewordsOffset = 0;
        for(var i = 0; i < shorterBlocksNumDataCodewords; i++)for(var j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
        // Fill out the last data block in the longer ones
        var specialVersion = version.getVersionNumber() === 24;
        var numLongerBlocks = specialVersion ? 8 : numResultBlocks;
        for(var j = 0; j < numLongerBlocks; j++)result[j].codewords[longerBlocksNumDataCodewords - 1] = rawCodewords[rawCodewordsOffset++];
        // Now add in error correction blocks
        var max = result[0].codewords.length;
        for(var i = longerBlocksNumDataCodewords; i < max; i++)for(var j = 0; j < numResultBlocks; j++){
            var jOffset = specialVersion ? (j + 8) % numResultBlocks : j;
            var iOffset = specialVersion && jOffset > 7 ? i - 1 : i;
            result[jOffset].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
        }
        if (rawCodewordsOffset !== rawCodewords.length) throw new (0, $kLpae.default)();
        return result;
    };
    DataBlock.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    };
    DataBlock.prototype.getCodewords = function() {
        return this.codewords;
    };
    return DataBlock;
}();
var $fc84678bd65e6a8c$export$2e2bcd8739ae039 = $fc84678bd65e6a8c$var$DataBlock;

});

parcelRegister("klJLs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed0944b294597bc3$export$2e2bcd8739ae039);

var $jpf17 = parcelRequire("jpf17");

var $iVZgW = parcelRequire("iVZgW");

var $6E9N1 = parcelRequire("6E9N1");

var $fPMAB = parcelRequire("fPMAB");

var $7mB9T = parcelRequire("7mB9T");

var $dtgr5 = parcelRequire("dtgr5");

var $amwnq = parcelRequire("amwnq");
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $ed0944b294597bc3$var$Mode;
(function(Mode) {
    Mode[Mode["PAD_ENCODE"] = 0] = "PAD_ENCODE";
    Mode[Mode["ASCII_ENCODE"] = 1] = "ASCII_ENCODE";
    Mode[Mode["C40_ENCODE"] = 2] = "C40_ENCODE";
    Mode[Mode["TEXT_ENCODE"] = 3] = "TEXT_ENCODE";
    Mode[Mode["ANSIX12_ENCODE"] = 4] = "ANSIX12_ENCODE";
    Mode[Mode["EDIFACT_ENCODE"] = 5] = "EDIFACT_ENCODE";
    Mode[Mode["BASE256_ENCODE"] = 6] = "BASE256_ENCODE";
})($ed0944b294597bc3$var$Mode || ($ed0944b294597bc3$var$Mode = {}));
/**
 * <p>Data Matrix Codes can encode text as bits in one of several modes, and can use multiple modes
 * in one Data Matrix Code. This class decodes the bits back into text.</p>
 *
 * <p>See ISO 16022:2006, 5.2.1 - 5.2.9.2</p>
 *
 * @author bbrown@google.com (Brian Brown)
 * @author Sean Owen
 */ var $ed0944b294597bc3$var$DecodedBitStreamParser = /** @class */ function() {
    function DecodedBitStreamParser() {}
    DecodedBitStreamParser.decode = function(bytes) {
        var bits = new (0, $iVZgW.default)(bytes);
        var result = new (0, $6E9N1.default)();
        var resultTrailer = new (0, $6E9N1.default)();
        var byteSegments = new Array();
        var mode = $ed0944b294597bc3$var$Mode.ASCII_ENCODE;
        do if (mode === $ed0944b294597bc3$var$Mode.ASCII_ENCODE) mode = this.decodeAsciiSegment(bits, result, resultTrailer);
        else {
            switch(mode){
                case $ed0944b294597bc3$var$Mode.C40_ENCODE:
                    this.decodeC40Segment(bits, result);
                    break;
                case $ed0944b294597bc3$var$Mode.TEXT_ENCODE:
                    this.decodeTextSegment(bits, result);
                    break;
                case $ed0944b294597bc3$var$Mode.ANSIX12_ENCODE:
                    this.decodeAnsiX12Segment(bits, result);
                    break;
                case $ed0944b294597bc3$var$Mode.EDIFACT_ENCODE:
                    this.decodeEdifactSegment(bits, result);
                    break;
                case $ed0944b294597bc3$var$Mode.BASE256_ENCODE:
                    this.decodeBase256Segment(bits, result, byteSegments);
                    break;
                default:
                    throw new (0, $dtgr5.default)();
            }
            mode = $ed0944b294597bc3$var$Mode.ASCII_ENCODE;
        }
        while (mode !== $ed0944b294597bc3$var$Mode.PAD_ENCODE && bits.available() > 0);
        if (resultTrailer.length() > 0) result.append(resultTrailer.toString());
        return new (0, $jpf17.default)(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, null);
    };
    /**
     * See ISO 16022:2006, 5.2.3 and Annex C, Table C.2
     */ DecodedBitStreamParser.decodeAsciiSegment = function(bits, result, resultTrailer) {
        var upperShift = false;
        do {
            var oneByte = bits.readBits(8);
            if (oneByte === 0) throw new (0, $dtgr5.default)();
            else if (oneByte <= 128) {
                if (upperShift) oneByte += 128;
                result.append(String.fromCharCode(oneByte - 1));
                return $ed0944b294597bc3$var$Mode.ASCII_ENCODE;
            } else if (oneByte === 129) return $ed0944b294597bc3$var$Mode.PAD_ENCODE;
            else if (oneByte <= 229) {
                var value = oneByte - 130;
                if (value < 10) result.append("0");
                result.append("" + value);
            } else switch(oneByte){
                case 230:
                    return $ed0944b294597bc3$var$Mode.C40_ENCODE;
                case 231:
                    return $ed0944b294597bc3$var$Mode.BASE256_ENCODE;
                case 232:
                    result.append(String.fromCharCode(29)); // translate as ASCII 29
                    break;
                case 233:
                case 234:
                    break;
                case 235:
                    upperShift = true;
                    break;
                case 236:
                    result.append("[)>\x1e05\x1d");
                    resultTrailer.insert(0, "\x1e\x04");
                    break;
                case 237:
                    result.append("[)>\x1e06\x1d");
                    resultTrailer.insert(0, "\x1e\x04");
                    break;
                case 238:
                    return $ed0944b294597bc3$var$Mode.ANSIX12_ENCODE;
                case 239:
                    return $ed0944b294597bc3$var$Mode.TEXT_ENCODE;
                case 240:
                    return $ed0944b294597bc3$var$Mode.EDIFACT_ENCODE;
                case 241:
                    break;
                default:
                    // Not to be used in ASCII encodation
                    // but work around encoders that end with 254, latch back to ASCII
                    if (oneByte !== 254 || bits.available() !== 0) throw new (0, $dtgr5.default)();
                    break;
            }
        }while (bits.available() > 0);
        return $ed0944b294597bc3$var$Mode.ASCII_ENCODE;
    };
    /**
     * See ISO 16022:2006, 5.2.5 and Annex C, Table C.1
     */ DecodedBitStreamParser.decodeC40Segment = function(bits, result) {
        // Three C40 values are encoded in a 16-bit value as
        // (1600 * C1) + (40 * C2) + C3 + 1
        // TODO(bbrown): The Upper Shift with C40 doesn't work in the 4 value scenario all the time
        var upperShift = false;
        var cValues = [];
        var shift = 0;
        do {
            // If there is only one byte left then it will be encoded as ASCII
            if (bits.available() === 8) return;
            var firstByte = bits.readBits(8);
            if (firstByte === 254) return;
            this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
            for(var i = 0; i < 3; i++){
                var cValue = cValues[i];
                switch(shift){
                    case 0:
                        if (cValue < 3) shift = cValue + 1;
                        else if (cValue < this.C40_BASIC_SET_CHARS.length) {
                            var c40char = this.C40_BASIC_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(c40char);
                        } else throw new (0, $dtgr5.default)();
                        break;
                    case 1:
                        if (upperShift) {
                            result.append(String.fromCharCode(cValue + 128));
                            upperShift = false;
                        } else result.append(String.fromCharCode(cValue));
                        shift = 0;
                        break;
                    case 2:
                        if (cValue < this.C40_SHIFT2_SET_CHARS.length) {
                            var c40char = this.C40_SHIFT2_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(c40char.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(c40char);
                        } else switch(cValue){
                            case 27:
                                result.append(String.fromCharCode(29)); // translate as ASCII 29
                                break;
                            case 30:
                                upperShift = true;
                                break;
                            default:
                                throw new (0, $dtgr5.default)();
                        }
                        shift = 0;
                        break;
                    case 3:
                        if (upperShift) {
                            result.append(String.fromCharCode(cValue + 224));
                            upperShift = false;
                        } else result.append(String.fromCharCode(cValue + 96));
                        shift = 0;
                        break;
                    default:
                        throw new (0, $dtgr5.default)();
                }
            }
        }while (bits.available() > 0);
    };
    /**
     * See ISO 16022:2006, 5.2.6 and Annex C, Table C.2
     */ DecodedBitStreamParser.decodeTextSegment = function(bits, result) {
        // Three Text values are encoded in a 16-bit value as
        // (1600 * C1) + (40 * C2) + C3 + 1
        // TODO(bbrown): The Upper Shift with Text doesn't work in the 4 value scenario all the time
        var upperShift = false;
        var cValues = [];
        var shift = 0;
        do {
            // If there is only one byte left then it will be encoded as ASCII
            if (bits.available() === 8) return;
            var firstByte = bits.readBits(8);
            if (firstByte === 254) return;
            this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
            for(var i = 0; i < 3; i++){
                var cValue = cValues[i];
                switch(shift){
                    case 0:
                        if (cValue < 3) shift = cValue + 1;
                        else if (cValue < this.TEXT_BASIC_SET_CHARS.length) {
                            var textChar = this.TEXT_BASIC_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(textChar);
                        } else throw new (0, $dtgr5.default)();
                        break;
                    case 1:
                        if (upperShift) {
                            result.append(String.fromCharCode(cValue + 128));
                            upperShift = false;
                        } else result.append(String.fromCharCode(cValue));
                        shift = 0;
                        break;
                    case 2:
                        // Shift 2 for Text is the same encoding as C40
                        if (cValue < this.TEXT_SHIFT2_SET_CHARS.length) {
                            var textChar = this.TEXT_SHIFT2_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(textChar);
                        } else switch(cValue){
                            case 27:
                                result.append(String.fromCharCode(29)); // translate as ASCII 29
                                break;
                            case 30:
                                upperShift = true;
                                break;
                            default:
                                throw new (0, $dtgr5.default)();
                        }
                        shift = 0;
                        break;
                    case 3:
                        if (cValue < this.TEXT_SHIFT3_SET_CHARS.length) {
                            var textChar = this.TEXT_SHIFT3_SET_CHARS[cValue];
                            if (upperShift) {
                                result.append(String.fromCharCode(textChar.charCodeAt(0) + 128));
                                upperShift = false;
                            } else result.append(textChar);
                            shift = 0;
                        } else throw new (0, $dtgr5.default)();
                        break;
                    default:
                        throw new (0, $dtgr5.default)();
                }
            }
        }while (bits.available() > 0);
    };
    /**
     * See ISO 16022:2006, 5.2.7
     */ DecodedBitStreamParser.decodeAnsiX12Segment = function(bits, result) {
        // Three ANSI X12 values are encoded in a 16-bit value as
        // (1600 * C1) + (40 * C2) + C3 + 1
        var cValues = [];
        do {
            // If there is only one byte left then it will be encoded as ASCII
            if (bits.available() === 8) return;
            var firstByte = bits.readBits(8);
            if (firstByte === 254) return;
            this.parseTwoBytes(firstByte, bits.readBits(8), cValues);
            for(var i = 0; i < 3; i++){
                var cValue = cValues[i];
                switch(cValue){
                    case 0:
                        result.append("\r");
                        break;
                    case 1:
                        result.append("*");
                        break;
                    case 2:
                        result.append(">");
                        break;
                    case 3:
                        result.append(" ");
                        break;
                    default:
                        if (cValue < 14) result.append(String.fromCharCode(cValue + 44));
                        else if (cValue < 40) result.append(String.fromCharCode(cValue + 51));
                        else throw new (0, $dtgr5.default)();
                        break;
                }
            }
        }while (bits.available() > 0);
    };
    DecodedBitStreamParser.parseTwoBytes = function(firstByte, secondByte, result) {
        var fullBitValue = (firstByte << 8) + secondByte - 1;
        var temp = Math.floor(fullBitValue / 1600);
        result[0] = temp;
        fullBitValue -= temp * 1600;
        temp = Math.floor(fullBitValue / 40);
        result[1] = temp;
        result[2] = fullBitValue - temp * 40;
    };
    /**
     * See ISO 16022:2006, 5.2.8 and Annex C Table C.3
     */ DecodedBitStreamParser.decodeEdifactSegment = function(bits, result) {
        do {
            // If there is only two or less bytes left then it will be encoded as ASCII
            if (bits.available() <= 16) return;
            for(var i = 0; i < 4; i++){
                var edifactValue = bits.readBits(6);
                // Check for the unlatch character
                if (edifactValue === 0x1F) {
                    // Read rest of byte, which should be 0, and stop
                    var bitsLeft = 8 - bits.getBitOffset();
                    if (bitsLeft !== 8) bits.readBits(bitsLeft);
                    return;
                }
                if ((edifactValue & 0x20) === 0) edifactValue |= 0x40; // Add a leading 01 to the 6 bit binary value
                result.append(String.fromCharCode(edifactValue));
            }
        }while (bits.available() > 0);
    };
    /**
     * See ISO 16022:2006, 5.2.9 and Annex B, B.2
     */ DecodedBitStreamParser.decodeBase256Segment = function(bits, result, byteSegments) {
        // Figure out how long the Base 256 Segment is.
        var codewordPosition = 1 + bits.getByteOffset(); // position is 1-indexed
        var d1 = this.unrandomize255State(bits.readBits(8), codewordPosition++);
        var count;
        if (d1 === 0) count = bits.available() / 8 | 0;
        else if (d1 < 250) count = d1;
        else count = 250 * (d1 - 249) + this.unrandomize255State(bits.readBits(8), codewordPosition++);
        // We're seeing NegativeArraySizeException errors from users.
        if (count < 0) throw new (0, $dtgr5.default)();
        var bytes = new Uint8Array(count);
        for(var i = 0; i < count; i++){
            // Have seen this particular error in the wild, such as at
            // http://www.bcgen.com/demo/IDAutomationStreamingDataMatrix.aspx?MODE=3&D=Fred&PFMT=3&PT=F&X=0.3&O=0&LM=0.2
            if (bits.available() < 8) throw new (0, $dtgr5.default)();
            bytes[i] = this.unrandomize255State(bits.readBits(8), codewordPosition++);
        }
        byteSegments.push(bytes);
        try {
            result.append((0, $fPMAB.default).decode(bytes, (0, $7mB9T.default).ISO88591));
        } catch (uee) {
            throw new (0, $amwnq.default)("Platform does not support required encoding: " + uee.message);
        }
    };
    /**
     * See ISO 16022:2006, Annex B, B.2
     */ DecodedBitStreamParser.unrandomize255State = function(randomizedBase256Codeword, base256CodewordPosition) {
        var pseudoRandomNumber = 149 * base256CodewordPosition % 255 + 1;
        var tempVariable = randomizedBase256Codeword - pseudoRandomNumber;
        return tempVariable >= 0 ? tempVariable : tempVariable + 256;
    };
    /**
     * See ISO 16022:2006, Annex C Table C.1
     * The C40 Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.C40_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ];
    DecodedBitStreamParser.C40_SHIFT2_SET_CHARS = [
        "!",
        '"',
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "@",
        "[",
        "\\",
        "]",
        "^",
        "_"
    ];
    /**
     * See ISO 16022:2006, Annex C Table C.2
     * The Text Basic Character Set (*'s used for placeholders for the shift values)
     */ DecodedBitStreamParser.TEXT_BASIC_SET_CHARS = [
        "*",
        "*",
        "*",
        " ",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
    ];
    // Shift 2 for Text is the same encoding as C40
    DecodedBitStreamParser.TEXT_SHIFT2_SET_CHARS = DecodedBitStreamParser.C40_SHIFT2_SET_CHARS;
    DecodedBitStreamParser.TEXT_SHIFT3_SET_CHARS = [
        "`",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "{",
        "|",
        "}",
        "~",
        String.fromCharCode(127)
    ];
    return DecodedBitStreamParser;
}();
var $ed0944b294597bc3$export$2e2bcd8739ae039 = $ed0944b294597bc3$var$DecodedBitStreamParser;

});
parcelRegister("iVZgW", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc8d144752b46d32$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.common {*/ 
var $kLpae = parcelRequire("kLpae");
/**
 * <p>This provides an easy abstraction to read bits at a time from a sequence of bytes, where the
 * number of bits read is not often a multiple of 8.</p>
 *
 * <p>This class is thread-safe but not reentrant -- unless the caller modifies the bytes array
 * it passed in, in which case all bets are off.</p>
 *
 * @author Sean Owen
 */ var $dc8d144752b46d32$var$BitSource = /** @class */ function() {
    /**
     * @param bytes bytes from which this will read bits. Bits will be read from the first byte first.
     * Bits are read within a byte from most-significant to least-significant bit.
     */ function BitSource(bytes) {
        this.bytes = bytes;
        this.byteOffset = 0;
        this.bitOffset = 0;
    }
    /**
     * @return index of next bit in current byte which would be read by the next call to {@link #readBits(int)}.
     */ BitSource.prototype.getBitOffset = function() {
        return this.bitOffset;
    };
    /**
     * @return index of next byte in input byte array which would be read by the next call to {@link #readBits(int)}.
     */ BitSource.prototype.getByteOffset = function() {
        return this.byteOffset;
    };
    /**
     * @param numBits number of bits to read
     * @return int representing the bits read. The bits will appear as the least-significant
     *         bits of the int
     * @throws IllegalArgumentException if numBits isn't in [1,32] or more than is available
     */ BitSource.prototype.readBits = function(numBits /*int*/ ) {
        if (numBits < 1 || numBits > 32 || numBits > this.available()) throw new (0, $kLpae.default)("" + numBits);
        var result = 0;
        var bitOffset = this.bitOffset;
        var byteOffset = this.byteOffset;
        var bytes = this.bytes;
        // First, read remainder from current byte
        if (bitOffset > 0) {
            var bitsLeft = 8 - bitOffset;
            var toRead = numBits < bitsLeft ? numBits : bitsLeft;
            var bitsToNotRead = bitsLeft - toRead;
            var mask = 0xFF >> 8 - toRead << bitsToNotRead;
            result = (bytes[byteOffset] & mask) >> bitsToNotRead;
            numBits -= toRead;
            bitOffset += toRead;
            if (bitOffset === 8) {
                bitOffset = 0;
                byteOffset++;
            }
        }
        // Next read whole bytes
        if (numBits > 0) {
            while(numBits >= 8){
                result = result << 8 | bytes[byteOffset] & 0xFF;
                byteOffset++;
                numBits -= 8;
            }
            // Finally read a partial byte
            if (numBits > 0) {
                var bitsToNotRead = 8 - numBits;
                var mask = 0xFF >> bitsToNotRead << bitsToNotRead;
                result = result << numBits | (bytes[byteOffset] & mask) >> bitsToNotRead;
                bitOffset += numBits;
            }
        }
        this.bitOffset = bitOffset;
        this.byteOffset = byteOffset;
        return result;
    };
    /**
     * @return number of bits that can be read successfully
     */ BitSource.prototype.available = function() {
        return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    };
    return BitSource;
}();
var $dc8d144752b46d32$export$2e2bcd8739ae039 = $dc8d144752b46d32$var$BitSource;

});



parcelRegister("fE0wh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b63afe9f27b71f78$export$2e2bcd8739ae039);

var $jIl78 = parcelRequire("jIl78");

var $1q3xj = parcelRequire("1q3xj");

var $5a6kn = parcelRequire("5a6kn");

var $cQi30 = parcelRequire("cQi30");

var $fwBMA = parcelRequire("fwBMA");
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates logic that can detect a Data Matrix Code in an image, even if the Data Matrix Code
 * is rotated or skewed, or partially obscured.</p>
 *
 * @author Sean Owen
 */ var $b63afe9f27b71f78$var$Detector = /** @class */ function() {
    function Detector(image) {
        this.image = image;
        this.rectangleDetector = new (0, $jIl78.default)(this.image);
    }
    /**
     * <p>Detects a Data Matrix Code in an image.</p>
     *
     * @return {@link DetectorResult} encapsulating results of detecting a Data Matrix Code
     * @throws NotFoundException if no Data Matrix Code can be found
     */ Detector.prototype.detect = function() {
        var cornerPoints = this.rectangleDetector.detect();
        var points = this.detectSolid1(cornerPoints);
        points = this.detectSolid2(points);
        points[3] = this.correctTopRight(points);
        if (!points[3]) throw new (0, $cQi30.default)();
        points = this.shiftToModuleCenter(points);
        var topLeft = points[0];
        var bottomLeft = points[1];
        var bottomRight = points[2];
        var topRight = points[3];
        var dimensionTop = this.transitionsBetween(topLeft, topRight) + 1;
        var dimensionRight = this.transitionsBetween(bottomRight, topRight) + 1;
        if ((dimensionTop & 0x01) === 1) dimensionTop += 1;
        if ((dimensionRight & 0x01) === 1) dimensionRight += 1;
        if (4 * dimensionTop < 7 * dimensionRight && 4 * dimensionRight < 7 * dimensionTop) // The matrix is square
        dimensionTop = dimensionRight = Math.max(dimensionTop, dimensionRight);
        var bits = Detector.sampleGrid(this.image, topLeft, bottomLeft, bottomRight, topRight, dimensionTop, dimensionRight);
        return new (0, $1q3xj.default)(bits, [
            topLeft,
            bottomLeft,
            bottomRight,
            topRight
        ]);
    };
    Detector.shiftPoint = function(point, to, div) {
        var x = (to.getX() - point.getX()) / (div + 1);
        var y = (to.getY() - point.getY()) / (div + 1);
        return new (0, $fwBMA.default)(point.getX() + x, point.getY() + y);
    };
    Detector.moveAway = function(point, fromX, fromY) {
        var x = point.getX();
        var y = point.getY();
        if (x < fromX) x -= 1;
        else x += 1;
        if (y < fromY) y -= 1;
        else y += 1;
        return new (0, $fwBMA.default)(x, y);
    };
    /**
     * Detect a solid side which has minimum transition.
     */ Detector.prototype.detectSolid1 = function(cornerPoints) {
        // 0  2
        // 1  3
        var pointA = cornerPoints[0];
        var pointB = cornerPoints[1];
        var pointC = cornerPoints[3];
        var pointD = cornerPoints[2];
        var trAB = this.transitionsBetween(pointA, pointB);
        var trBC = this.transitionsBetween(pointB, pointC);
        var trCD = this.transitionsBetween(pointC, pointD);
        var trDA = this.transitionsBetween(pointD, pointA);
        // 0..3
        // :  :
        // 1--2
        var min = trAB;
        var points = [
            pointD,
            pointA,
            pointB,
            pointC
        ];
        if (min > trBC) {
            min = trBC;
            points[0] = pointA;
            points[1] = pointB;
            points[2] = pointC;
            points[3] = pointD;
        }
        if (min > trCD) {
            min = trCD;
            points[0] = pointB;
            points[1] = pointC;
            points[2] = pointD;
            points[3] = pointA;
        }
        if (min > trDA) {
            points[0] = pointC;
            points[1] = pointD;
            points[2] = pointA;
            points[3] = pointB;
        }
        return points;
    };
    /**
     * Detect a second solid side next to first solid side.
     */ Detector.prototype.detectSolid2 = function(points) {
        // A..D
        // :  :
        // B--C
        var pointA = points[0];
        var pointB = points[1];
        var pointC = points[2];
        var pointD = points[3];
        // Transition detection on the edge is not stable.
        // To safely detect, shift the points to the module center.
        var tr = this.transitionsBetween(pointA, pointD);
        var pointBs = Detector.shiftPoint(pointB, pointC, (tr + 1) * 4);
        var pointCs = Detector.shiftPoint(pointC, pointB, (tr + 1) * 4);
        var trBA = this.transitionsBetween(pointBs, pointA);
        var trCD = this.transitionsBetween(pointCs, pointD);
        // 0..3
        // |  :
        // 1--2
        if (trBA < trCD) {
            // solid sides: A-B-C
            points[0] = pointA;
            points[1] = pointB;
            points[2] = pointC;
            points[3] = pointD;
        } else {
            // solid sides: B-C-D
            points[0] = pointB;
            points[1] = pointC;
            points[2] = pointD;
            points[3] = pointA;
        }
        return points;
    };
    /**
     * Calculates the corner position of the white top right module.
     */ Detector.prototype.correctTopRight = function(points) {
        // A..D
        // |  :
        // B--C
        var pointA = points[0];
        var pointB = points[1];
        var pointC = points[2];
        var pointD = points[3];
        // shift points for safe transition detection.
        var trTop = this.transitionsBetween(pointA, pointD);
        var trRight = this.transitionsBetween(pointB, pointD);
        var pointAs = Detector.shiftPoint(pointA, pointB, (trRight + 1) * 4);
        var pointCs = Detector.shiftPoint(pointC, pointB, (trTop + 1) * 4);
        trTop = this.transitionsBetween(pointAs, pointD);
        trRight = this.transitionsBetween(pointCs, pointD);
        var candidate1 = new (0, $fwBMA.default)(pointD.getX() + (pointC.getX() - pointB.getX()) / (trTop + 1), pointD.getY() + (pointC.getY() - pointB.getY()) / (trTop + 1));
        var candidate2 = new (0, $fwBMA.default)(pointD.getX() + (pointA.getX() - pointB.getX()) / (trRight + 1), pointD.getY() + (pointA.getY() - pointB.getY()) / (trRight + 1));
        if (!this.isValid(candidate1)) {
            if (this.isValid(candidate2)) return candidate2;
            return null;
        }
        if (!this.isValid(candidate2)) return candidate1;
        var sumc1 = this.transitionsBetween(pointAs, candidate1) + this.transitionsBetween(pointCs, candidate1);
        var sumc2 = this.transitionsBetween(pointAs, candidate2) + this.transitionsBetween(pointCs, candidate2);
        if (sumc1 > sumc2) return candidate1;
        else return candidate2;
    };
    /**
     * Shift the edge points to the module center.
     */ Detector.prototype.shiftToModuleCenter = function(points) {
        // A..D
        // |  :
        // B--C
        var pointA = points[0];
        var pointB = points[1];
        var pointC = points[2];
        var pointD = points[3];
        // calculate pseudo dimensions
        var dimH = this.transitionsBetween(pointA, pointD) + 1;
        var dimV = this.transitionsBetween(pointC, pointD) + 1;
        // shift points for safe dimension detection
        var pointAs = Detector.shiftPoint(pointA, pointB, dimV * 4);
        var pointCs = Detector.shiftPoint(pointC, pointB, dimH * 4);
        //  calculate more precise dimensions
        dimH = this.transitionsBetween(pointAs, pointD) + 1;
        dimV = this.transitionsBetween(pointCs, pointD) + 1;
        if ((dimH & 0x01) === 1) dimH += 1;
        if ((dimV & 0x01) === 1) dimV += 1;
        // WhiteRectangleDetector returns points inside of the rectangle.
        // I want points on the edges.
        var centerX = (pointA.getX() + pointB.getX() + pointC.getX() + pointD.getX()) / 4;
        var centerY = (pointA.getY() + pointB.getY() + pointC.getY() + pointD.getY()) / 4;
        pointA = Detector.moveAway(pointA, centerX, centerY);
        pointB = Detector.moveAway(pointB, centerX, centerY);
        pointC = Detector.moveAway(pointC, centerX, centerY);
        pointD = Detector.moveAway(pointD, centerX, centerY);
        var pointBs;
        var pointDs;
        // shift points to the center of each modules
        pointAs = Detector.shiftPoint(pointA, pointB, dimV * 4);
        pointAs = Detector.shiftPoint(pointAs, pointD, dimH * 4);
        pointBs = Detector.shiftPoint(pointB, pointA, dimV * 4);
        pointBs = Detector.shiftPoint(pointBs, pointC, dimH * 4);
        pointCs = Detector.shiftPoint(pointC, pointD, dimV * 4);
        pointCs = Detector.shiftPoint(pointCs, pointB, dimH * 4);
        pointDs = Detector.shiftPoint(pointD, pointC, dimV * 4);
        pointDs = Detector.shiftPoint(pointDs, pointA, dimH * 4);
        return [
            pointAs,
            pointBs,
            pointCs,
            pointDs
        ];
    };
    Detector.prototype.isValid = function(p) {
        return p.getX() >= 0 && p.getX() < this.image.getWidth() && p.getY() > 0 && p.getY() < this.image.getHeight();
    };
    Detector.sampleGrid = function(image, topLeft, bottomLeft, bottomRight, topRight, dimensionX, dimensionY) {
        var sampler = (0, $5a6kn.default).getInstance();
        return sampler.sampleGrid(image, dimensionX, dimensionY, 0.5, 0.5, dimensionX - 0.5, 0.5, dimensionX - 0.5, dimensionY - 0.5, 0.5, dimensionY - 0.5, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRight.getX(), bottomRight.getY(), bottomLeft.getX(), bottomLeft.getY());
    };
    /**
     * Counts the number of black/white transitions between two points, using something like Bresenham's algorithm.
     */ Detector.prototype.transitionsBetween = function(from, to) {
        // See QR Code Detector, sizeOfBlackWhiteBlackRun()
        var fromX = Math.trunc(from.getX());
        var fromY = Math.trunc(from.getY());
        var toX = Math.trunc(to.getX());
        var toY = Math.trunc(to.getY());
        var steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
        if (steep) {
            var temp = fromX;
            fromX = fromY;
            fromY = temp;
            temp = toX;
            toX = toY;
            toY = temp;
        }
        var dx = Math.abs(toX - fromX);
        var dy = Math.abs(toY - fromY);
        var error = -dx / 2;
        var ystep = fromY < toY ? 1 : -1;
        var xstep = fromX < toX ? 1 : -1;
        var transitions = 0;
        var inBlack = this.image.get(steep ? fromY : fromX, steep ? fromX : fromY);
        for(var x = fromX, y = fromY; x !== toX; x += xstep){
            var isBlack = this.image.get(steep ? y : x, steep ? x : y);
            if (isBlack !== inBlack) {
                transitions++;
                inBlack = isBlack;
            }
            error += dy;
            if (error > 0) {
                if (y === toY) break;
                y += ystep;
                error -= dx;
            }
        }
        return transitions;
    };
    return Detector;
}();
var $b63afe9f27b71f78$export$2e2bcd8739ae039 = $b63afe9f27b71f78$var$Detector;

});



parcelRegister("1oJp7", function(module, exports) {

$parcel$export(module.exports, "BrowserMultiFormatReader", () => $104b40a5c229bb01$export$5632271b582b8149);

var $au3R0 = parcelRequire("au3R0");

var $72l3G = parcelRequire("72l3G");
var $104b40a5c229bb01$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $104b40a5c229bb01$export$5632271b582b8149 = /** @class */ function(_super) {
    $104b40a5c229bb01$var$__extends(BrowserMultiFormatReader, _super);
    function BrowserMultiFormatReader(hints, timeBetweenScansMillis) {
        if (hints === void 0) hints = null;
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        var _this = this;
        var reader = new (0, $72l3G.default)();
        reader.setHints(hints);
        _this = _super.call(this, reader, timeBetweenScansMillis) || this;
        return _this;
    }
    /**
     * Overwrite decodeBitmap to call decodeWithState, which will pay
     * attention to the hints set in the constructor function
     */ BrowserMultiFormatReader.prototype.decodeBitmap = function(binaryBitmap) {
        return this.reader.decodeWithState(binaryBitmap);
    };
    return BrowserMultiFormatReader;
}((0, $au3R0.BrowserCodeReader));

});
parcelRegister("72l3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f90e0e30565305$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $b5DE3 = parcelRequire("b5DE3");

var $bx5V3 = parcelRequire("bx5V3");

var $d6Ijx = parcelRequire("d6Ijx");

var $fJ3d6 = parcelRequire("fJ3d6");

var $eisSD = parcelRequire("eisSD");

var $lxsNI = parcelRequire("lxsNI");

var $cQi30 = parcelRequire("cQi30");

var $7G1W6 = parcelRequire("7G1W6");

var $6JrXb = parcelRequire("6JrXb");
var $51f90e0e30565305$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*namespace com.google.zxing {*/ /**
 * MultiFormatReader is a convenience class and the main entry point into the library for most uses.
 * By default it attempts to decode all barcode formats that the library supports. Optionally, you
 * can provide a hints object to request different behavior, for example only decoding QR codes.
 *
 * @author Sean Owen
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $51f90e0e30565305$var$MultiFormatReader = /** @class */ function() {
    function MultiFormatReader() {}
    /**
     * This version of decode honors the intent of Reader.decode(BinaryBitmap) in that it
     * passes null as a hint to the decoders. However, that makes it inefficient to call repeatedly.
     * Use setHints() followed by decodeWithState() for continuous scan applications.
     *
     * @param image The pixel data to decode
     * @return The contents of the image
     *
     * @throws NotFoundException Any errors which occurred
     */ /*@Override*/ // public decode(image: BinaryBitmap): Result {
    //   setHints(null)
    //   return decodeInternal(image)
    // }
    /**
     * Decode an image using the hints provided. Does not honor existing state.
     *
     * @param image The pixel data to decode
     * @param hints The hints to use, clearing the previous state.
     * @return The contents of the image
     *
     * @throws NotFoundException Any errors which occurred
     */ /*@Override*/ MultiFormatReader.prototype.decode = function(image, hints) {
        this.setHints(hints);
        return this.decodeInternal(image);
    };
    /**
     * Decode an image using the state set up by calling setHints() previously. Continuous scan
     * clients will get a <b>large</b> speed increase by using this instead of decode().
     *
     * @param image The pixel data to decode
     * @return The contents of the image
     *
     * @throws NotFoundException Any errors which occurred
     */ MultiFormatReader.prototype.decodeWithState = function(image) {
        // Make sure to set up the default state so we don't crash
        if (this.readers === null || this.readers === undefined) this.setHints(null);
        return this.decodeInternal(image);
    };
    /**
     * This method adds state to the MultiFormatReader. By setting the hints once, subsequent calls
     * to decodeWithState(image) can reuse the same set of readers without reallocating memory. This
     * is important for performance in continuous scan clients.
     *
     * @param hints The set of hints to use for subsequent calls to decode(image)
     */ MultiFormatReader.prototype.setHints = function(hints) {
        this.hints = hints;
        var tryHarder = hints !== null && hints !== undefined && undefined !== hints.get((0, $b5DE3.default).TRY_HARDER);
        /*@SuppressWarnings("unchecked")*/ var formats = hints === null || hints === undefined ? null : hints.get((0, $b5DE3.default).POSSIBLE_FORMATS);
        var readers = new Array();
        if (formats !== null && formats !== undefined) {
            var addOneDReader = formats.some(function(f) {
                return f === (0, $bx5V3.default).UPC_A || f === (0, $bx5V3.default).UPC_E || f === (0, $bx5V3.default).EAN_13 || f === (0, $bx5V3.default).EAN_8 || f === (0, $bx5V3.default).CODABAR || f === (0, $bx5V3.default).CODE_39 || f === (0, $bx5V3.default).CODE_93 || f === (0, $bx5V3.default).CODE_128 || f === (0, $bx5V3.default).ITF || f === (0, $bx5V3.default).RSS_14 || f === (0, $bx5V3.default).RSS_EXPANDED;
            });
            // Put 1D readers upfront in "normal" mode
            // TYPESCRIPTPORT: TODO: uncomment below as they are ported
            if (addOneDReader && !tryHarder) readers.push(new (0, $eisSD.default)(hints));
            if (formats.includes((0, $bx5V3.default).QR_CODE)) readers.push(new (0, $d6Ijx.default)());
            if (formats.includes((0, $bx5V3.default).DATA_MATRIX)) readers.push(new (0, $lxsNI.default)());
            if (formats.includes((0, $bx5V3.default).AZTEC)) readers.push(new (0, $fJ3d6.default)());
            if (formats.includes((0, $bx5V3.default).PDF_417)) readers.push(new (0, $7G1W6.default)());
            // if (formats.includes(BarcodeFormat.MAXICODE)) {
            //    readers.push(new MaxiCodeReader())
            // }
            // At end in "try harder" mode
            if (addOneDReader && tryHarder) readers.push(new (0, $eisSD.default)(hints));
        }
        if (readers.length === 0) {
            if (!tryHarder) readers.push(new (0, $eisSD.default)(hints));
            readers.push(new (0, $d6Ijx.default)());
            readers.push(new (0, $lxsNI.default)());
            readers.push(new (0, $fJ3d6.default)());
            readers.push(new (0, $7G1W6.default)());
            // readers.push(new MaxiCodeReader())
            if (tryHarder) readers.push(new (0, $eisSD.default)(hints));
        }
        this.readers = readers; // .toArray(new Reader[readers.size()])
    };
    /*@Override*/ MultiFormatReader.prototype.reset = function() {
        var e_1, _a;
        if (this.readers !== null) try {
            for(var _b = $51f90e0e30565305$var$__values(this.readers), _c = _b.next(); !_c.done; _c = _b.next()){
                var reader = _c.value;
                reader.reset();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * @throws NotFoundException
     */ MultiFormatReader.prototype.decodeInternal = function(image) {
        var e_2, _a;
        if (this.readers === null) throw new (0, $6JrXb.default)("No readers where selected, nothing can be read.");
        try {
            for(var _b = $51f90e0e30565305$var$__values(this.readers), _c = _b.next(); !_c.done; _c = _b.next()){
                var reader = _c.value;
                // Trying to decode with ${reader} reader.
                try {
                    return reader.decode(image, this.hints);
                } catch (ex) {
                    if (ex instanceof (0, $6JrXb.default)) continue;
                // Bad Exception.
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        throw new (0, $cQi30.default)("No MultiFormat Readers were able to detect the code.");
    };
    return MultiFormatReader;
}();
var $51f90e0e30565305$export$2e2bcd8739ae039 = $51f90e0e30565305$var$MultiFormatReader;

});
parcelRegister("d6Ijx", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ae35c0a8e16cec$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode {*/ 
var $bx5V3 = parcelRequire("bx5V3");

var $hzqel = parcelRequire("hzqel");

var $b5DE3 = parcelRequire("b5DE3");

var $cQi30 = parcelRequire("cQi30");

var $kWndQ = parcelRequire("kWndQ");

var $eS8qc = parcelRequire("eS8qc");

var $kDrQ8 = parcelRequire("kDrQ8");

var $hLuKK = parcelRequire("hLuKK");

var $cnFbF = parcelRequire("cnFbF");
/*import java.util.List;*/ /*import java.util.Map;*/ /**
 * This implementation can detect and decode QR Codes in an image.
 *
 * @author Sean Owen
 */ var $98ae35c0a8e16cec$var$QRCodeReader = /** @class */ function() {
    function QRCodeReader() {
        this.decoder = new (0, $kDrQ8.default)();
    }
    QRCodeReader.prototype.getDecoder = function() {
        return this.decoder;
    };
    /**
     * Locates and decodes a QR code in an image.
     *
     * @return a representing: string the content encoded by the QR code
     * @throws NotFoundException if a QR code cannot be found
     * @throws FormatException if a QR code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ /*@Override*/ // public decode(image: BinaryBitmap): Result /*throws NotFoundException, ChecksumException, FormatException */ {
    //   return this.decode(image, null)
    // }
    /*@Override*/ QRCodeReader.prototype.decode = function(image, hints) {
        var decoderResult;
        var points;
        if (hints !== undefined && hints !== null && undefined !== hints.get((0, $b5DE3.default).PURE_BARCODE)) {
            var bits = QRCodeReader.extractPureBits(image.getBlackMatrix());
            decoderResult = this.decoder.decodeBitMatrix(bits, hints);
            points = QRCodeReader.NO_POINTS;
        } else {
            var detectorResult = new (0, $cnFbF.default)(image.getBlackMatrix()).detect(hints);
            decoderResult = this.decoder.decodeBitMatrix(detectorResult.getBits(), hints);
            points = detectorResult.getPoints();
        }
        // If the code was mirrored: swap the bottom-left and the top-right points.
        if (decoderResult.getOther() instanceof (0, $hLuKK.default)) decoderResult.getOther().applyMirroredCorrection(points);
        var result = new (0, $kWndQ.default)(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, (0, $bx5V3.default).QR_CODE, undefined);
        var byteSegments = decoderResult.getByteSegments();
        if (byteSegments !== null) result.putMetadata((0, $eS8qc.default).BYTE_SEGMENTS, byteSegments);
        var ecLevel = decoderResult.getECLevel();
        if (ecLevel !== null) result.putMetadata((0, $eS8qc.default).ERROR_CORRECTION_LEVEL, ecLevel);
        if (decoderResult.hasStructuredAppend()) {
            result.putMetadata((0, $eS8qc.default).STRUCTURED_APPEND_SEQUENCE, decoderResult.getStructuredAppendSequenceNumber());
            result.putMetadata((0, $eS8qc.default).STRUCTURED_APPEND_PARITY, decoderResult.getStructuredAppendParity());
        }
        return result;
    };
    /*@Override*/ QRCodeReader.prototype.reset = function() {
    // do nothing
    };
    /**
     * This method detects a code in a "pure" image -- that is, pure monochrome image
     * which contains only an unrotated, unskewed, image of a code, with some white border
     * around it. This is a specialized method that works exceptionally fast in this special
     * case.
     *
     * @see com.google.zxing.datamatrix.DataMatrixReader#extractPureBits(BitMatrix)
     */ QRCodeReader.extractPureBits = function(image) {
        var leftTopBlack = image.getTopLeftOnBit();
        var rightBottomBlack = image.getBottomRightOnBit();
        if (leftTopBlack === null || rightBottomBlack === null) throw new (0, $cQi30.default)();
        var moduleSize = this.moduleSize(leftTopBlack, image);
        var top = leftTopBlack[1];
        var bottom = rightBottomBlack[1];
        var left = leftTopBlack[0];
        var right = rightBottomBlack[0];
        // Sanity check!
        if (left >= right || top >= bottom) throw new (0, $cQi30.default)();
        if (bottom - top !== right - left) {
            // Special case, where bottom-right module wasn't black so we found something else in the last row
            // Assume it's a square, so use height as the width
            right = left + (bottom - top);
            if (right >= image.getWidth()) // Abort if that would not make sense -- off image
            throw new (0, $cQi30.default)();
        }
        var matrixWidth = Math.round((right - left + 1) / moduleSize);
        var matrixHeight = Math.round((bottom - top + 1) / moduleSize);
        if (matrixWidth <= 0 || matrixHeight <= 0) throw new (0, $cQi30.default)();
        if (matrixHeight !== matrixWidth) // Only possibly decode square regions
        throw new (0, $cQi30.default)();
        // Push in the "border" by half the module width so that we start
        // sampling in the middle of the module. Just in case the image is a
        // little off, this will help recover.
        var nudge = /*(int) */ Math.floor(moduleSize / 2.0);
        top += nudge;
        left += nudge;
        // But careful that this does not sample off the edge
        // "right" is the farthest-right valid pixel location -- right+1 is not necessarily
        // This is positive by how much the inner x loop below would be too large
        var nudgedTooFarRight = left + /*(int) */ Math.floor((matrixWidth - 1) * moduleSize) - right;
        if (nudgedTooFarRight > 0) {
            if (nudgedTooFarRight > nudge) // Neither way fits; abort
            throw new (0, $cQi30.default)();
            left -= nudgedTooFarRight;
        }
        // See logic above
        var nudgedTooFarDown = top + /*(int) */ Math.floor((matrixHeight - 1) * moduleSize) - bottom;
        if (nudgedTooFarDown > 0) {
            if (nudgedTooFarDown > nudge) // Neither way fits; abort
            throw new (0, $cQi30.default)();
            top -= nudgedTooFarDown;
        }
        // Now just read off the bits
        var bits = new (0, $hzqel.default)(matrixWidth, matrixHeight);
        for(var y = 0; y < matrixHeight; y++){
            var iOffset = top + /*(int) */ Math.floor(y * moduleSize);
            for(var x = 0; x < matrixWidth; x++)if (image.get(left + /*(int) */ Math.floor(x * moduleSize), iOffset)) bits.set(x, y);
        }
        return bits;
    };
    QRCodeReader.moduleSize = function(leftTopBlack, image) {
        var height = image.getHeight();
        var width = image.getWidth();
        var x = leftTopBlack[0];
        var y = leftTopBlack[1];
        var inBlack = true;
        var transitions = 0;
        while(x < width && y < height){
            if (inBlack !== image.get(x, y)) {
                if (++transitions === 5) break;
                inBlack = !inBlack;
            }
            x++;
            y++;
        }
        if (x === width || y === height) throw new (0, $cQi30.default)();
        return (x - leftTopBlack[0]) / 7.0;
    };
    QRCodeReader.NO_POINTS = new Array();
    return QRCodeReader;
}();
var $98ae35c0a8e16cec$export$2e2bcd8739ae039 = $98ae35c0a8e16cec$var$QRCodeReader;

});
parcelRegister("kDrQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f05d0b9ae281b984$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9Nn2d = parcelRequire("9Nn2d");

var $hzqel = parcelRequire("hzqel");

var $7nLua = parcelRequire("7nLua");

var $f5xTf = parcelRequire("f5xTf");

var $1hZT5 = parcelRequire("1hZT5");

var $7dXSg = parcelRequire("7dXSg");

var $iFZGM = parcelRequire("iFZGM");

var $hLuKK = parcelRequire("hLuKK");
var $f05d0b9ae281b984$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*import java.util.Map;*/ /**
 * <p>The main class which implements QR Code decoding -- as opposed to locating and extracting
 * the QR Code from an image.</p>
 *
 * @author Sean Owen
 */ var $f05d0b9ae281b984$var$Decoder = /** @class */ function() {
    function Decoder() {
        this.rsDecoder = new (0, $f5xTf.default)((0, $7nLua.default).QR_CODE_FIELD_256);
    }
    // public decode(image: boolean[][]): DecoderResult /*throws ChecksumException, FormatException*/ {
    //   return decode(image, null)
    // }
    /**
     * <p>Convenience method that can decode a QR Code represented as a 2D array of booleans.
     * "true" is taken to mean a black module.</p>
     *
     * @param image booleans representing white/black QR Code modules
     * @param hints decoding hints that should be used to influence decoding
     * @return text and bytes encoded within the QR Code
     * @throws FormatException if the QR Code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.decodeBooleanArray = function(image, hints) {
        return this.decodeBitMatrix((0, $hzqel.default).parseFromBooleanArray(image), hints);
    };
    // public decodeBitMatrix(bits: BitMatrix): DecoderResult /*throws ChecksumException, FormatException*/ {
    //   return decode(bits, null)
    // }
    /**
     * <p>Decodes a QR Code represented as a {@link BitMatrix}. A 1 or "true" is taken to mean a black module.</p>
     *
     * @param bits booleans representing white/black QR Code modules
     * @param hints decoding hints that should be used to influence decoding
     * @return text and bytes encoded within the QR Code
     * @throws FormatException if the QR Code cannot be decoded
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.decodeBitMatrix = function(bits, hints) {
        // Construct a parser and read version, error-correction level
        var parser = new (0, $1hZT5.default)(bits);
        var ex = null;
        try {
            return this.decodeBitMatrixParser(parser, hints);
        } catch (e /*: FormatException, ChecksumException*/ ) {
            ex = e;
        }
        try {
            // Revert the bit matrix
            parser.remask();
            // Will be attempting a mirrored reading of the version and format info.
            parser.setMirror(true);
            // Preemptively read the version.
            parser.readVersion();
            // Preemptively read the format information.
            parser.readFormatInformation();
            /*
             * Since we're here, this means we have successfully detected some kind
             * of version and format information when mirrored. This is a good sign,
             * that the QR code may be mirrored, and we should try once more with a
             * mirrored content.
             */ // Prepare for a mirrored reading.
            parser.mirror();
            var result = this.decodeBitMatrixParser(parser, hints);
            // Success! Notify the caller that the code was mirrored.
            result.setOther(new (0, $hLuKK.default)(true));
            return result;
        } catch (e /*FormatException | ChecksumException*/ ) {
            // Throw the exception from the original reading
            if (ex !== null) throw ex;
            throw e;
        }
    };
    Decoder.prototype.decodeBitMatrixParser = function(parser, hints) {
        var e_1, _a, e_2, _b;
        var version = parser.readVersion();
        var ecLevel = parser.readFormatInformation().getErrorCorrectionLevel();
        // Read codewords
        var codewords = parser.readCodewords();
        // Separate into data blocks
        var dataBlocks = (0, $7dXSg.default).getDataBlocks(codewords, version, ecLevel);
        // Count total number of data bytes
        var totalBytes = 0;
        try {
            for(var dataBlocks_1 = $f05d0b9ae281b984$var$__values(dataBlocks), dataBlocks_1_1 = dataBlocks_1.next(); !dataBlocks_1_1.done; dataBlocks_1_1 = dataBlocks_1.next()){
                var dataBlock = dataBlocks_1_1.value;
                totalBytes += dataBlock.getNumDataCodewords();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (dataBlocks_1_1 && !dataBlocks_1_1.done && (_a = dataBlocks_1.return)) _a.call(dataBlocks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var resultBytes = new Uint8Array(totalBytes);
        var resultOffset = 0;
        try {
            // Error-correct and copy data blocks together into a stream of bytes
            for(var dataBlocks_2 = $f05d0b9ae281b984$var$__values(dataBlocks), dataBlocks_2_1 = dataBlocks_2.next(); !dataBlocks_2_1.done; dataBlocks_2_1 = dataBlocks_2.next()){
                var dataBlock = dataBlocks_2_1.value;
                var codewordBytes = dataBlock.getCodewords();
                var numDataCodewords = dataBlock.getNumDataCodewords();
                this.correctErrors(codewordBytes, numDataCodewords);
                for(var i = 0; i < numDataCodewords; i++)resultBytes[resultOffset++] = codewordBytes[i];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (dataBlocks_2_1 && !dataBlocks_2_1.done && (_b = dataBlocks_2.return)) _b.call(dataBlocks_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        // Decode the contents of that stream of bytes
        return (0, $iFZGM.default).decode(resultBytes, version, ecLevel, hints);
    };
    /**
     * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
     * correct the errors in-place using Reed-Solomon error correction.</p>
     *
     * @param codewordBytes data and error correction codewords
     * @param numDataCodewords number of codewords that are data bytes
     * @throws ChecksumException if error correction fails
     */ Decoder.prototype.correctErrors = function(codewordBytes, numDataCodewords /*int*/ ) {
        // const numCodewords = codewordBytes.length;
        // First read into an array of ints
        var codewordsInts = new Int32Array(codewordBytes);
        // TYPESCRIPTPORT: not realy necessary to transform to ints? could redesign everything to work with unsigned bytes?
        // const codewordsInts = new Int32Array(numCodewords)
        // for (let i = 0; i < numCodewords; i++) {
        //   codewordsInts[i] = codewordBytes[i] & 0xFF
        // }
        try {
            this.rsDecoder.decode(codewordsInts, codewordBytes.length - numDataCodewords);
        } catch (ignored /*: ReedSolomonException*/ ) {
            throw new (0, $9Nn2d.default)();
        }
        // Copy back into array of bytes -- only need to worry about the bytes that were data
        // We don't care about errors in the error-correction codewords
        for(var i = 0; i < numDataCodewords; i++)codewordBytes[i] = /*(byte) */ codewordsInts[i];
    };
    return Decoder;
}();
var $f05d0b9ae281b984$export$2e2bcd8739ae039 = $f05d0b9ae281b984$var$Decoder;

});
parcelRegister("1hZT5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f07628b5a68e4bb$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $b41gY = parcelRequire("b41gY");

var $4yMtz = parcelRequire("4yMtz");

var $8Z0a4 = parcelRequire("8Z0a4");

var $dtgr5 = parcelRequire("dtgr5");
/**
 * @author Sean Owen
 */ var $0f07628b5a68e4bb$var$BitMatrixParser = /** @class */ function() {
    /**
     * @param bitMatrix {@link BitMatrix} to parse
     * @throws FormatException if dimension is not >= 21 and 1 mod 4
     */ function BitMatrixParser(bitMatrix) {
        var dimension = bitMatrix.getHeight();
        if (dimension < 21 || (dimension & 0x03) !== 1) throw new (0, $dtgr5.default)();
        this.bitMatrix = bitMatrix;
    }
    /**
     * <p>Reads format information from one of its two locations within the QR Code.</p>
     *
     * @return {@link FormatInformation} encapsulating the QR Code's format info
     * @throws FormatException if both format information locations cannot be parsed as
     * the valid encoding of format information
     */ BitMatrixParser.prototype.readFormatInformation = function() {
        if (this.parsedFormatInfo !== null && this.parsedFormatInfo !== undefined) return this.parsedFormatInfo;
        // Read top-left format info bits
        var formatInfoBits1 = 0;
        for(var i = 0; i < 6; i++)formatInfoBits1 = this.copyBit(i, 8, formatInfoBits1);
        // .. and skip a bit in the timing pattern ...
        formatInfoBits1 = this.copyBit(7, 8, formatInfoBits1);
        formatInfoBits1 = this.copyBit(8, 8, formatInfoBits1);
        formatInfoBits1 = this.copyBit(8, 7, formatInfoBits1);
        // .. and skip a bit in the timing pattern ...
        for(var j = 5; j >= 0; j--)formatInfoBits1 = this.copyBit(8, j, formatInfoBits1);
        // Read the top-right/bottom-left pattern too
        var dimension = this.bitMatrix.getHeight();
        var formatInfoBits2 = 0;
        var jMin = dimension - 7;
        for(var j = dimension - 1; j >= jMin; j--)formatInfoBits2 = this.copyBit(8, j, formatInfoBits2);
        for(var i = dimension - 8; i < dimension; i++)formatInfoBits2 = this.copyBit(i, 8, formatInfoBits2);
        this.parsedFormatInfo = (0, $4yMtz.default).decodeFormatInformation(formatInfoBits1, formatInfoBits2);
        if (this.parsedFormatInfo !== null) return this.parsedFormatInfo;
        throw new (0, $dtgr5.default)();
    };
    /**
     * <p>Reads version information from one of its two locations within the QR Code.</p>
     *
     * @return {@link Version} encapsulating the QR Code's version
     * @throws FormatException if both version information locations cannot be parsed as
     * the valid encoding of version information
     */ BitMatrixParser.prototype.readVersion = function() {
        if (this.parsedVersion !== null && this.parsedVersion !== undefined) return this.parsedVersion;
        var dimension = this.bitMatrix.getHeight();
        var provisionalVersion = Math.floor((dimension - 17) / 4);
        if (provisionalVersion <= 6) return (0, $b41gY.default).getVersionForNumber(provisionalVersion);
        // Read top-right version info: 3 wide by 6 tall
        var versionBits = 0;
        var ijMin = dimension - 11;
        for(var j = 5; j >= 0; j--)for(var i = dimension - 9; i >= ijMin; i--)versionBits = this.copyBit(i, j, versionBits);
        var theParsedVersion = (0, $b41gY.default).decodeVersionInformation(versionBits);
        if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
            this.parsedVersion = theParsedVersion;
            return theParsedVersion;
        }
        // Hmm, failed. Try bottom left: 6 wide by 3 tall
        versionBits = 0;
        for(var i = 5; i >= 0; i--)for(var j = dimension - 9; j >= ijMin; j--)versionBits = this.copyBit(i, j, versionBits);
        theParsedVersion = (0, $b41gY.default).decodeVersionInformation(versionBits);
        if (theParsedVersion !== null && theParsedVersion.getDimensionForVersion() === dimension) {
            this.parsedVersion = theParsedVersion;
            return theParsedVersion;
        }
        throw new (0, $dtgr5.default)();
    };
    BitMatrixParser.prototype.copyBit = function(i /*int*/ , j /*int*/ , versionBits /*int*/ ) {
        var bit = this.isMirror ? this.bitMatrix.get(j, i) : this.bitMatrix.get(i, j);
        return bit ? versionBits << 1 | 0x1 : versionBits << 1;
    };
    /**
     * <p>Reads the bits in the {@link BitMatrix} representing the finder pattern in the
     * correct order in order to reconstruct the codewords bytes contained within the
     * QR Code.</p>
     *
     * @return bytes encoded within the QR Code
     * @throws FormatException if the exact number of bytes expected is not read
     */ BitMatrixParser.prototype.readCodewords = function() {
        var formatInfo = this.readFormatInformation();
        var version = this.readVersion();
        // Get the data mask for the format used in this QR Code. This will exclude
        // some bits from reading as we wind through the bit matrix.
        var dataMask = (0, $8Z0a4.default).values.get(formatInfo.getDataMask());
        var dimension = this.bitMatrix.getHeight();
        dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
        var functionPattern = version.buildFunctionPattern();
        var readingUp = true;
        var result = new Uint8Array(version.getTotalCodewords());
        var resultOffset = 0;
        var currentByte = 0;
        var bitsRead = 0;
        // Read columns in pairs, from right to left
        for(var j = dimension - 1; j > 0; j -= 2){
            if (j === 6) // Skip whole column with vertical alignment pattern
            // saves time and makes the other code proceed more cleanly
            j--;
            // Read alternatingly from bottom to top then top to bottom
            for(var count = 0; count < dimension; count++){
                var i = readingUp ? dimension - 1 - count : count;
                for(var col = 0; col < 2; col++)// Ignore bits covered by the function pattern
                if (!functionPattern.get(j - col, i)) {
                    // Read a bit
                    bitsRead++;
                    currentByte <<= 1;
                    if (this.bitMatrix.get(j - col, i)) currentByte |= 1;
                    // If we've made a whole byte, save it off
                    if (bitsRead === 8) {
                        result[resultOffset++] = /*(byte) */ currentByte;
                        bitsRead = 0;
                        currentByte = 0;
                    }
                }
            }
            readingUp = !readingUp; // readingUp ^= true; // readingUp = !readingUp; // switch directions
        }
        if (resultOffset !== version.getTotalCodewords()) throw new (0, $dtgr5.default)();
        return result;
    };
    /**
     * Revert the mask removal done while reading the code words. The bit matrix should revert to its original state.
     */ BitMatrixParser.prototype.remask = function() {
        if (this.parsedFormatInfo === null) return; // We have no format information, and have no data mask
        var dataMask = (0, $8Z0a4.default).values.get(this.parsedFormatInfo.getDataMask());
        var dimension = this.bitMatrix.getHeight();
        dataMask.unmaskBitMatrix(this.bitMatrix, dimension);
    };
    /**
     * Prepare the parser for a mirrored operation.
     * This flag has effect only on the {@link #readFormatInformation()} and the
     * {@link #readVersion()}. Before proceeding with {@link #readCodewords()} the
     * {@link #mirror()} method should be called.
     *
     * @param mirror Whether to read version and format information mirrored.
     */ BitMatrixParser.prototype.setMirror = function(isMirror) {
        this.parsedVersion = null;
        this.parsedFormatInfo = null;
        this.isMirror = isMirror;
    };
    /** Mirror the bit matrix in order to attempt a second reading. */ BitMatrixParser.prototype.mirror = function() {
        var bitMatrix = this.bitMatrix;
        for(var x = 0, width = bitMatrix.getWidth(); x < width; x++){
            for(var y = x + 1, height = bitMatrix.getHeight(); y < height; y++)if (bitMatrix.get(x, y) !== bitMatrix.get(y, x)) {
                bitMatrix.flip(y, x);
                bitMatrix.flip(x, y);
            }
        }
    };
    return BitMatrixParser;
}();
var $0f07628b5a68e4bb$export$2e2bcd8739ae039 = $0f07628b5a68e4bb$var$BitMatrixParser;

});
parcelRegister("b41gY", function(module, exports) {

$parcel$export(module.exports, "default", () => $80e10e307266ada8$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $hzqel = parcelRequire("hzqel");

var $4yMtz = parcelRequire("4yMtz");

var $6Lazo = parcelRequire("6Lazo");

var $9aXvR = parcelRequire("9aXvR");

var $dtgr5 = parcelRequire("dtgr5");

var $kLpae = parcelRequire("kLpae");
var $80e10e307266ada8$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * See ISO 18004:2006 Annex D
 *
 * @author Sean Owen
 */ var $80e10e307266ada8$var$Version = /** @class */ function() {
    function Version(versionNumber /*int*/ , alignmentPatternCenters) {
        var e_1, _a;
        var ecBlocks = [];
        for(var _i = 2; _i < arguments.length; _i++)ecBlocks[_i - 2] = arguments[_i];
        this.versionNumber = versionNumber;
        this.alignmentPatternCenters = alignmentPatternCenters;
        this.ecBlocks = ecBlocks;
        var total = 0;
        var ecCodewords = ecBlocks[0].getECCodewordsPerBlock();
        var ecbArray = ecBlocks[0].getECBlocks();
        try {
            for(var ecbArray_1 = $80e10e307266ada8$var$__values(ecbArray), ecbArray_1_1 = ecbArray_1.next(); !ecbArray_1_1.done; ecbArray_1_1 = ecbArray_1.next()){
                var ecBlock = ecbArray_1_1.value;
                total += ecBlock.getCount() * (ecBlock.getDataCodewords() + ecCodewords);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecbArray_1_1 && !ecbArray_1_1.done && (_a = ecbArray_1.return)) _a.call(ecbArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.totalCodewords = total;
    }
    Version.prototype.getVersionNumber = function() {
        return this.versionNumber;
    };
    Version.prototype.getAlignmentPatternCenters = function() {
        return this.alignmentPatternCenters;
    };
    Version.prototype.getTotalCodewords = function() {
        return this.totalCodewords;
    };
    Version.prototype.getDimensionForVersion = function() {
        return 17 + 4 * this.versionNumber;
    };
    Version.prototype.getECBlocksForLevel = function(ecLevel) {
        return this.ecBlocks[ecLevel.getValue()];
    // TYPESCRIPTPORT: original was using ordinal, and using the order of levels as defined in ErrorCorrectionLevel enum (LMQH)
    // I will use the direct value from ErrorCorrectionLevelValues enum which in typescript goes to a number
    };
    /**
     * <p>Deduces version information purely from QR Code dimensions.</p>
     *
     * @param dimension dimension in modules
     * @return Version for a QR Code of that dimension
     * @throws FormatException if dimension is not 1 mod 4
     */ Version.getProvisionalVersionForDimension = function(dimension /*int*/ ) {
        if (dimension % 4 !== 1) throw new (0, $dtgr5.default)();
        try {
            return this.getVersionForNumber((dimension - 17) / 4);
        } catch (ignored /*: IllegalArgumentException*/ ) {
            throw new (0, $dtgr5.default)();
        }
    };
    Version.getVersionForNumber = function(versionNumber /*int*/ ) {
        if (versionNumber < 1 || versionNumber > 40) throw new (0, $kLpae.default)();
        return Version.VERSIONS[versionNumber - 1];
    };
    Version.decodeVersionInformation = function(versionBits /*int*/ ) {
        var bestDifference = Number.MAX_SAFE_INTEGER;
        var bestVersion = 0;
        for(var i = 0; i < Version.VERSION_DECODE_INFO.length; i++){
            var targetVersion = Version.VERSION_DECODE_INFO[i];
            // Do the version info bits match exactly? done.
            if (targetVersion === versionBits) return Version.getVersionForNumber(i + 7);
            // Otherwise see if this is the closest to a real version info bit string
            // we have seen so far
            var bitsDifference = (0, $4yMtz.default).numBitsDiffering(versionBits, targetVersion);
            if (bitsDifference < bestDifference) {
                bestVersion = i + 7;
                bestDifference = bitsDifference;
            }
        }
        // We can tolerate up to 3 bits of error since no two version info codewords will
        // differ in less than 8 bits.
        if (bestDifference <= 3) return Version.getVersionForNumber(bestVersion);
        // If we didn't find a close enough match, fail
        return null;
    };
    /**
     * See ISO 18004:2006 Annex E
     */ Version.prototype.buildFunctionPattern = function() {
        var dimension = this.getDimensionForVersion();
        var bitMatrix = new (0, $hzqel.default)(dimension);
        // Top left finder pattern + separator + format
        bitMatrix.setRegion(0, 0, 9, 9);
        // Top right finder pattern + separator + format
        bitMatrix.setRegion(dimension - 8, 0, 8, 9);
        // Bottom left finder pattern + separator + format
        bitMatrix.setRegion(0, dimension - 8, 9, 8);
        // Alignment patterns
        var max = this.alignmentPatternCenters.length;
        for(var x = 0; x < max; x++){
            var i = this.alignmentPatternCenters[x] - 2;
            for(var y = 0; y < max; y++){
                if (x === 0 && (y === 0 || y === max - 1) || x === max - 1 && y === 0) continue;
                bitMatrix.setRegion(this.alignmentPatternCenters[y] - 2, i, 5, 5);
            }
        }
        // Vertical timing pattern
        bitMatrix.setRegion(6, 9, 1, dimension - 17);
        // Horizontal timing pattern
        bitMatrix.setRegion(9, 6, dimension - 17, 1);
        if (this.versionNumber > 6) {
            // Version info, top right
            bitMatrix.setRegion(dimension - 11, 0, 3, 6);
            // Version info, bottom left
            bitMatrix.setRegion(0, dimension - 11, 6, 3);
        }
        return bitMatrix;
    };
    /*@Override*/ Version.prototype.toString = function() {
        return "" + this.versionNumber;
    };
    /**
       * See ISO 18004:2006 Annex D.
       * Element i represents the raw version bits that specify version i + 7
       */ Version.VERSION_DECODE_INFO = Int32Array.from([
        0x07C94,
        0x085BC,
        0x09A99,
        0x0A4D3,
        0x0BBF6,
        0x0C762,
        0x0D847,
        0x0E60D,
        0x0F928,
        0x10B78,
        0x1145D,
        0x12A17,
        0x13532,
        0x149A6,
        0x15683,
        0x168C9,
        0x177EC,
        0x18EC4,
        0x191E1,
        0x1AFAB,
        0x1B08E,
        0x1CC1A,
        0x1D33F,
        0x1ED75,
        0x1F250,
        0x209D5,
        0x216F0,
        0x228BA,
        0x2379F,
        0x24B0B,
        0x2542E,
        0x26A64,
        0x27541,
        0x28C69
    ]);
    /**
       * See ISO 18004:2006 6.5.1 Table 9
       */ Version.VERSIONS = [
        new Version(1, new Int32Array(0), new (0, $6Lazo.default)(7, new (0, $9aXvR.default)(1, 19)), new (0, $6Lazo.default)(10, new (0, $9aXvR.default)(1, 16)), new (0, $6Lazo.default)(13, new (0, $9aXvR.default)(1, 13)), new (0, $6Lazo.default)(17, new (0, $9aXvR.default)(1, 9))),
        new Version(2, Int32Array.from([
            6,
            18
        ]), new (0, $6Lazo.default)(10, new (0, $9aXvR.default)(1, 34)), new (0, $6Lazo.default)(16, new (0, $9aXvR.default)(1, 28)), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(1, 22)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(1, 16))),
        new Version(3, Int32Array.from([
            6,
            22
        ]), new (0, $6Lazo.default)(15, new (0, $9aXvR.default)(1, 55)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(1, 44)), new (0, $6Lazo.default)(18, new (0, $9aXvR.default)(2, 17)), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(2, 13))),
        new Version(4, Int32Array.from([
            6,
            26
        ]), new (0, $6Lazo.default)(20, new (0, $9aXvR.default)(1, 80)), new (0, $6Lazo.default)(18, new (0, $9aXvR.default)(2, 32)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(2, 24)), new (0, $6Lazo.default)(16, new (0, $9aXvR.default)(4, 9))),
        new Version(5, Int32Array.from([
            6,
            30
        ]), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(1, 108)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(2, 43)), new (0, $6Lazo.default)(18, new (0, $9aXvR.default)(2, 15), new (0, $9aXvR.default)(2, 16)), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(2, 11), new (0, $9aXvR.default)(2, 12))),
        new Version(6, Int32Array.from([
            6,
            34
        ]), new (0, $6Lazo.default)(18, new (0, $9aXvR.default)(2, 68)), new (0, $6Lazo.default)(16, new (0, $9aXvR.default)(4, 27)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(4, 19)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(4, 15))),
        new Version(7, Int32Array.from([
            6,
            22,
            38
        ]), new (0, $6Lazo.default)(20, new (0, $9aXvR.default)(2, 78)), new (0, $6Lazo.default)(18, new (0, $9aXvR.default)(4, 31)), new (0, $6Lazo.default)(18, new (0, $9aXvR.default)(2, 14), new (0, $9aXvR.default)(4, 15)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(4, 13), new (0, $9aXvR.default)(1, 14))),
        new Version(8, Int32Array.from([
            6,
            24,
            42
        ]), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(2, 97)), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(2, 38), new (0, $9aXvR.default)(2, 39)), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(4, 18), new (0, $9aXvR.default)(2, 19)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(4, 14), new (0, $9aXvR.default)(2, 15))),
        new Version(9, Int32Array.from([
            6,
            26,
            46
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(2, 116)), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(3, 36), new (0, $9aXvR.default)(2, 37)), new (0, $6Lazo.default)(20, new (0, $9aXvR.default)(4, 16), new (0, $9aXvR.default)(4, 17)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(4, 12), new (0, $9aXvR.default)(4, 13))),
        new Version(10, Int32Array.from([
            6,
            28,
            50
        ]), new (0, $6Lazo.default)(18, new (0, $9aXvR.default)(2, 68), new (0, $9aXvR.default)(2, 69)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(4, 43), new (0, $9aXvR.default)(1, 44)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(6, 19), new (0, $9aXvR.default)(2, 20)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(6, 15), new (0, $9aXvR.default)(2, 16))),
        new Version(11, Int32Array.from([
            6,
            30,
            54
        ]), new (0, $6Lazo.default)(20, new (0, $9aXvR.default)(4, 81)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(1, 50), new (0, $9aXvR.default)(4, 51)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(4, 22), new (0, $9aXvR.default)(4, 23)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(3, 12), new (0, $9aXvR.default)(8, 13))),
        new Version(12, Int32Array.from([
            6,
            32,
            58
        ]), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(2, 92), new (0, $9aXvR.default)(2, 93)), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(6, 36), new (0, $9aXvR.default)(2, 37)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(4, 20), new (0, $9aXvR.default)(6, 21)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(7, 14), new (0, $9aXvR.default)(4, 15))),
        new Version(13, Int32Array.from([
            6,
            34,
            62
        ]), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(4, 107)), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(8, 37), new (0, $9aXvR.default)(1, 38)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(8, 20), new (0, $9aXvR.default)(4, 21)), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(12, 11), new (0, $9aXvR.default)(4, 12))),
        new Version(14, Int32Array.from([
            6,
            26,
            46,
            66
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(3, 115), new (0, $9aXvR.default)(1, 116)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(4, 40), new (0, $9aXvR.default)(5, 41)), new (0, $6Lazo.default)(20, new (0, $9aXvR.default)(11, 16), new (0, $9aXvR.default)(5, 17)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(11, 12), new (0, $9aXvR.default)(5, 13))),
        new Version(15, Int32Array.from([
            6,
            26,
            48,
            70
        ]), new (0, $6Lazo.default)(22, new (0, $9aXvR.default)(5, 87), new (0, $9aXvR.default)(1, 88)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(5, 41), new (0, $9aXvR.default)(5, 42)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(5, 24), new (0, $9aXvR.default)(7, 25)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(11, 12), new (0, $9aXvR.default)(7, 13))),
        new Version(16, Int32Array.from([
            6,
            26,
            50,
            74
        ]), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(5, 98), new (0, $9aXvR.default)(1, 99)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(7, 45), new (0, $9aXvR.default)(3, 46)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(15, 19), new (0, $9aXvR.default)(2, 20)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(3, 15), new (0, $9aXvR.default)(13, 16))),
        new Version(17, Int32Array.from([
            6,
            30,
            54,
            78
        ]), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(1, 107), new (0, $9aXvR.default)(5, 108)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(10, 46), new (0, $9aXvR.default)(1, 47)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(1, 22), new (0, $9aXvR.default)(15, 23)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(2, 14), new (0, $9aXvR.default)(17, 15))),
        new Version(18, Int32Array.from([
            6,
            30,
            56,
            82
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(5, 120), new (0, $9aXvR.default)(1, 121)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(9, 43), new (0, $9aXvR.default)(4, 44)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(17, 22), new (0, $9aXvR.default)(1, 23)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(2, 14), new (0, $9aXvR.default)(19, 15))),
        new Version(19, Int32Array.from([
            6,
            30,
            58,
            86
        ]), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(3, 113), new (0, $9aXvR.default)(4, 114)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(3, 44), new (0, $9aXvR.default)(11, 45)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(17, 21), new (0, $9aXvR.default)(4, 22)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(9, 13), new (0, $9aXvR.default)(16, 14))),
        new Version(20, Int32Array.from([
            6,
            34,
            62,
            90
        ]), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(3, 107), new (0, $9aXvR.default)(5, 108)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(3, 41), new (0, $9aXvR.default)(13, 42)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(15, 24), new (0, $9aXvR.default)(5, 25)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(15, 15), new (0, $9aXvR.default)(10, 16))),
        new Version(21, Int32Array.from([
            6,
            28,
            50,
            72,
            94
        ]), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(4, 116), new (0, $9aXvR.default)(4, 117)), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(17, 42)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(17, 22), new (0, $9aXvR.default)(6, 23)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(19, 16), new (0, $9aXvR.default)(6, 17))),
        new Version(22, Int32Array.from([
            6,
            26,
            50,
            74,
            98
        ]), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(2, 111), new (0, $9aXvR.default)(7, 112)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(17, 46)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(7, 24), new (0, $9aXvR.default)(16, 25)), new (0, $6Lazo.default)(24, new (0, $9aXvR.default)(34, 13))),
        new Version(23, Int32Array.from([
            6,
            30,
            54,
            78,
            102
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(4, 121), new (0, $9aXvR.default)(5, 122)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(4, 47), new (0, $9aXvR.default)(14, 48)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(11, 24), new (0, $9aXvR.default)(14, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(16, 15), new (0, $9aXvR.default)(14, 16))),
        new Version(24, Int32Array.from([
            6,
            28,
            54,
            80,
            106
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(6, 117), new (0, $9aXvR.default)(4, 118)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(6, 45), new (0, $9aXvR.default)(14, 46)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(11, 24), new (0, $9aXvR.default)(16, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(30, 16), new (0, $9aXvR.default)(2, 17))),
        new Version(25, Int32Array.from([
            6,
            32,
            58,
            84,
            110
        ]), new (0, $6Lazo.default)(26, new (0, $9aXvR.default)(8, 106), new (0, $9aXvR.default)(4, 107)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(8, 47), new (0, $9aXvR.default)(13, 48)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(7, 24), new (0, $9aXvR.default)(22, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(22, 15), new (0, $9aXvR.default)(13, 16))),
        new Version(26, Int32Array.from([
            6,
            30,
            58,
            86,
            114
        ]), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(10, 114), new (0, $9aXvR.default)(2, 115)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(19, 46), new (0, $9aXvR.default)(4, 47)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(28, 22), new (0, $9aXvR.default)(6, 23)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(33, 16), new (0, $9aXvR.default)(4, 17))),
        new Version(27, Int32Array.from([
            6,
            34,
            62,
            90,
            118
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(8, 122), new (0, $9aXvR.default)(4, 123)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(22, 45), new (0, $9aXvR.default)(3, 46)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(8, 23), new (0, $9aXvR.default)(26, 24)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(12, 15), new (0, $9aXvR.default)(28, 16))),
        new Version(28, Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(3, 117), new (0, $9aXvR.default)(10, 118)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(3, 45), new (0, $9aXvR.default)(23, 46)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(4, 24), new (0, $9aXvR.default)(31, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(11, 15), new (0, $9aXvR.default)(31, 16))),
        new Version(29, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(7, 116), new (0, $9aXvR.default)(7, 117)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(21, 45), new (0, $9aXvR.default)(7, 46)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(1, 23), new (0, $9aXvR.default)(37, 24)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(19, 15), new (0, $9aXvR.default)(26, 16))),
        new Version(30, Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(5, 115), new (0, $9aXvR.default)(10, 116)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(19, 47), new (0, $9aXvR.default)(10, 48)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(15, 24), new (0, $9aXvR.default)(25, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(23, 15), new (0, $9aXvR.default)(25, 16))),
        new Version(31, Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(13, 115), new (0, $9aXvR.default)(3, 116)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(2, 46), new (0, $9aXvR.default)(29, 47)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(42, 24), new (0, $9aXvR.default)(1, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(23, 15), new (0, $9aXvR.default)(28, 16))),
        new Version(32, Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(17, 115)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(10, 46), new (0, $9aXvR.default)(23, 47)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(10, 24), new (0, $9aXvR.default)(35, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(19, 15), new (0, $9aXvR.default)(35, 16))),
        new Version(33, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(17, 115), new (0, $9aXvR.default)(1, 116)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(14, 46), new (0, $9aXvR.default)(21, 47)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(29, 24), new (0, $9aXvR.default)(19, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(11, 15), new (0, $9aXvR.default)(46, 16))),
        new Version(34, Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(13, 115), new (0, $9aXvR.default)(6, 116)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(14, 46), new (0, $9aXvR.default)(23, 47)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(44, 24), new (0, $9aXvR.default)(7, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(59, 16), new (0, $9aXvR.default)(1, 17))),
        new Version(35, Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(12, 121), new (0, $9aXvR.default)(7, 122)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(12, 47), new (0, $9aXvR.default)(26, 48)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(39, 24), new (0, $9aXvR.default)(14, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(22, 15), new (0, $9aXvR.default)(41, 16))),
        new Version(36, Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(6, 121), new (0, $9aXvR.default)(14, 122)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(6, 47), new (0, $9aXvR.default)(34, 48)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(46, 24), new (0, $9aXvR.default)(10, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(2, 15), new (0, $9aXvR.default)(64, 16))),
        new Version(37, Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(17, 122), new (0, $9aXvR.default)(4, 123)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(29, 46), new (0, $9aXvR.default)(14, 47)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(49, 24), new (0, $9aXvR.default)(10, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(24, 15), new (0, $9aXvR.default)(46, 16))),
        new Version(38, Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(4, 122), new (0, $9aXvR.default)(18, 123)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(13, 46), new (0, $9aXvR.default)(32, 47)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(48, 24), new (0, $9aXvR.default)(14, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(42, 15), new (0, $9aXvR.default)(32, 16))),
        new Version(39, Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(20, 117), new (0, $9aXvR.default)(4, 118)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(40, 47), new (0, $9aXvR.default)(7, 48)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(43, 24), new (0, $9aXvR.default)(22, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(10, 15), new (0, $9aXvR.default)(67, 16))),
        new Version(40, Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(19, 118), new (0, $9aXvR.default)(6, 119)), new (0, $6Lazo.default)(28, new (0, $9aXvR.default)(18, 47), new (0, $9aXvR.default)(31, 48)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(34, 24), new (0, $9aXvR.default)(34, 25)), new (0, $6Lazo.default)(30, new (0, $9aXvR.default)(20, 15), new (0, $9aXvR.default)(61, 16)))
    ];
    return Version;
}();
var $80e10e307266ada8$export$2e2bcd8739ae039 = $80e10e307266ada8$var$Version;

});
parcelRegister("4yMtz", function(module, exports) {

$parcel$export(module.exports, "default", () => $351ff0b1280f31c1$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $aH6oJ = parcelRequire("aH6oJ");

var $hcAg4 = parcelRequire("hcAg4");
var $351ff0b1280f31c1$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Encapsulates a QR Code's format information, including the data mask used and
 * error correction level.</p>
 *
 * @author Sean Owen
 * @see DataMask
 * @see ErrorCorrectionLevel
 */ var $351ff0b1280f31c1$var$FormatInformation = /** @class */ function() {
    function FormatInformation(formatInfo /*int*/ ) {
        // Bits 3,4
        this.errorCorrectionLevel = (0, $aH6oJ.default).forBits(formatInfo >> 3 & 0x03);
        // Bottom 3 bits
        this.dataMask = /*(byte) */ formatInfo & 0x07;
    }
    FormatInformation.numBitsDiffering = function(a /*int*/ , b /*int*/ ) {
        return (0, $hcAg4.default).bitCount(a ^ b);
    };
    /**
     * @param maskedFormatInfo1 format info indicator, with mask still applied
     * @param maskedFormatInfo2 second copy of same info; both are checked at the same time
     *  to establish best match
     * @return information about the format it specifies, or {@code null}
     *  if doesn't seem to match any known pattern
     */ FormatInformation.decodeFormatInformation = function(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
        var formatInfo = FormatInformation.doDecodeFormatInformation(maskedFormatInfo1, maskedFormatInfo2);
        if (formatInfo !== null) return formatInfo;
        // Should return null, but, some QR codes apparently
        // do not mask this info. Try again by actually masking the pattern
        // first
        return FormatInformation.doDecodeFormatInformation(maskedFormatInfo1 ^ FormatInformation.FORMAT_INFO_MASK_QR, maskedFormatInfo2 ^ FormatInformation.FORMAT_INFO_MASK_QR);
    };
    FormatInformation.doDecodeFormatInformation = function(maskedFormatInfo1 /*int*/ , maskedFormatInfo2 /*int*/ ) {
        var e_1, _a;
        // Find the int in FORMAT_INFO_DECODE_LOOKUP with fewest bits differing
        var bestDifference = Number.MAX_SAFE_INTEGER;
        var bestFormatInfo = 0;
        try {
            for(var _b = $351ff0b1280f31c1$var$__values(FormatInformation.FORMAT_INFO_DECODE_LOOKUP), _c = _b.next(); !_c.done; _c = _b.next()){
                var decodeInfo = _c.value;
                var targetInfo = decodeInfo[0];
                if (targetInfo === maskedFormatInfo1 || targetInfo === maskedFormatInfo2) // Found an exact match
                return new FormatInformation(decodeInfo[1]);
                var bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo1, targetInfo);
                if (bitsDifference < bestDifference) {
                    bestFormatInfo = decodeInfo[1];
                    bestDifference = bitsDifference;
                }
                if (maskedFormatInfo1 !== maskedFormatInfo2) {
                    // also try the other option
                    bitsDifference = FormatInformation.numBitsDiffering(maskedFormatInfo2, targetInfo);
                    if (bitsDifference < bestDifference) {
                        bestFormatInfo = decodeInfo[1];
                        bestDifference = bitsDifference;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits
        // differing means we found a match
        if (bestDifference <= 3) return new FormatInformation(bestFormatInfo);
        return null;
    };
    FormatInformation.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    };
    FormatInformation.prototype.getDataMask = function() {
        return this.dataMask;
    };
    /*@Override*/ FormatInformation.prototype.hashCode = function() {
        return this.errorCorrectionLevel.getBits() << 3 | this.dataMask;
    };
    /*@Override*/ FormatInformation.prototype.equals = function(o) {
        if (!(o instanceof FormatInformation)) return false;
        var other = o;
        return this.errorCorrectionLevel === other.errorCorrectionLevel && this.dataMask === other.dataMask;
    };
    FormatInformation.FORMAT_INFO_MASK_QR = 0x5412;
    /**
     * See ISO 18004:2006, Annex C, Table C.1
     */ FormatInformation.FORMAT_INFO_DECODE_LOOKUP = [
        Int32Array.from([
            0x5412,
            0x00
        ]),
        Int32Array.from([
            0x5125,
            0x01
        ]),
        Int32Array.from([
            0x5E7C,
            0x02
        ]),
        Int32Array.from([
            0x5B4B,
            0x03
        ]),
        Int32Array.from([
            0x45F9,
            0x04
        ]),
        Int32Array.from([
            0x40CE,
            0x05
        ]),
        Int32Array.from([
            0x4F97,
            0x06
        ]),
        Int32Array.from([
            0x4AA0,
            0x07
        ]),
        Int32Array.from([
            0x77C4,
            0x08
        ]),
        Int32Array.from([
            0x72F3,
            0x09
        ]),
        Int32Array.from([
            0x7DAA,
            0x0A
        ]),
        Int32Array.from([
            0x789D,
            0x0B
        ]),
        Int32Array.from([
            0x662F,
            0x0C
        ]),
        Int32Array.from([
            0x6318,
            0x0D
        ]),
        Int32Array.from([
            0x6C41,
            0x0E
        ]),
        Int32Array.from([
            0x6976,
            0x0F
        ]),
        Int32Array.from([
            0x1689,
            0x10
        ]),
        Int32Array.from([
            0x13BE,
            0x11
        ]),
        Int32Array.from([
            0x1CE7,
            0x12
        ]),
        Int32Array.from([
            0x19D0,
            0x13
        ]),
        Int32Array.from([
            0x0762,
            0x14
        ]),
        Int32Array.from([
            0x0255,
            0x15
        ]),
        Int32Array.from([
            0x0D0C,
            0x16
        ]),
        Int32Array.from([
            0x083B,
            0x17
        ]),
        Int32Array.from([
            0x355F,
            0x18
        ]),
        Int32Array.from([
            0x3068,
            0x19
        ]),
        Int32Array.from([
            0x3F31,
            0x1A
        ]),
        Int32Array.from([
            0x3A06,
            0x1B
        ]),
        Int32Array.from([
            0x24B4,
            0x1C
        ]),
        Int32Array.from([
            0x2183,
            0x1D
        ]),
        Int32Array.from([
            0x2EDA,
            0x1E
        ]),
        Int32Array.from([
            0x2BED,
            0x1F
        ])
    ];
    return FormatInformation;
}();
var $351ff0b1280f31c1$export$2e2bcd8739ae039 = $351ff0b1280f31c1$var$FormatInformation;

});
parcelRegister("aH6oJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c92e2051315cf49$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode.decoder {*/ 
var $bfDuf = parcelRequire("bfDuf");

var $kLpae = parcelRequire("kLpae");
var $7c92e2051315cf49$export$a15989971a778f84;
(function(ErrorCorrectionLevelValues) {
    ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["L"] = 0] = "L";
    ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["M"] = 1] = "M";
    ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["Q"] = 2] = "Q";
    ErrorCorrectionLevelValues[ErrorCorrectionLevelValues["H"] = 3] = "H";
})($7c92e2051315cf49$export$a15989971a778f84 || ($7c92e2051315cf49$export$a15989971a778f84 = {}));
/**
 * <p>See ISO 18004:2006, 6.5.1. This enum encapsulates the four error correction levels
 * defined by the QR code standard.</p>
 *
 * @author Sean Owen
 */ var $7c92e2051315cf49$var$ErrorCorrectionLevel = /** @class */ function() {
    function ErrorCorrectionLevel(value, stringValue, bits /*int*/ ) {
        this.value = value;
        this.stringValue = stringValue;
        this.bits = bits;
        ErrorCorrectionLevel.FOR_BITS.set(bits, this);
        ErrorCorrectionLevel.FOR_VALUE.set(value, this);
    }
    ErrorCorrectionLevel.prototype.getValue = function() {
        return this.value;
    };
    ErrorCorrectionLevel.prototype.getBits = function() {
        return this.bits;
    };
    ErrorCorrectionLevel.fromString = function(s) {
        switch(s){
            case "L":
                return ErrorCorrectionLevel.L;
            case "M":
                return ErrorCorrectionLevel.M;
            case "Q":
                return ErrorCorrectionLevel.Q;
            case "H":
                return ErrorCorrectionLevel.H;
            default:
                throw new (0, $bfDuf.default)(s + "not available");
        }
    };
    ErrorCorrectionLevel.prototype.toString = function() {
        return this.stringValue;
    };
    ErrorCorrectionLevel.prototype.equals = function(o) {
        if (!(o instanceof ErrorCorrectionLevel)) return false;
        var other = o;
        return this.value === other.value;
    };
    /**
     * @param bits int containing the two bits encoding a QR Code's error correction level
     * @return ErrorCorrectionLevel representing the encoded error correction level
     */ ErrorCorrectionLevel.forBits = function(bits /*int*/ ) {
        if (bits < 0 || bits >= ErrorCorrectionLevel.FOR_BITS.size) throw new (0, $kLpae.default)();
        return ErrorCorrectionLevel.FOR_BITS.get(bits);
    };
    ErrorCorrectionLevel.FOR_BITS = new Map();
    ErrorCorrectionLevel.FOR_VALUE = new Map();
    /** L = ~7% correction */ ErrorCorrectionLevel.L = new ErrorCorrectionLevel($7c92e2051315cf49$export$a15989971a778f84.L, "L", 0x01);
    /** M = ~15% correction */ ErrorCorrectionLevel.M = new ErrorCorrectionLevel($7c92e2051315cf49$export$a15989971a778f84.M, "M", 0x00);
    /** Q = ~25% correction */ ErrorCorrectionLevel.Q = new ErrorCorrectionLevel($7c92e2051315cf49$export$a15989971a778f84.Q, "Q", 0x03);
    /** H = ~30% correction */ ErrorCorrectionLevel.H = new ErrorCorrectionLevel($7c92e2051315cf49$export$a15989971a778f84.H, "H", 0x02);
    return ErrorCorrectionLevel;
}();
var $7c92e2051315cf49$export$2e2bcd8739ae039 = $7c92e2051315cf49$var$ErrorCorrectionLevel;

});


parcelRegister("6Lazo", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ebf54d4cbf17188$export$2e2bcd8739ae039);
var $4ebf54d4cbf17188$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Encapsulates a set of error-correction blocks in one symbol version. Most versions will
 * use blocks of differing sizes within one version, so, this encapsulates the parameters for
 * each set of blocks. It also holds the number of error-correction codewords per block since it
 * will be the same across all blocks within one version.</p>
 */ var $4ebf54d4cbf17188$var$ECBlocks = /** @class */ function() {
    function ECBlocks(ecCodewordsPerBlock /*int*/ ) {
        var ecBlocks = [];
        for(var _i = 1; _i < arguments.length; _i++)ecBlocks[_i - 1] = arguments[_i];
        this.ecCodewordsPerBlock = ecCodewordsPerBlock;
        this.ecBlocks = ecBlocks;
    }
    ECBlocks.prototype.getECCodewordsPerBlock = function() {
        return this.ecCodewordsPerBlock;
    };
    ECBlocks.prototype.getNumBlocks = function() {
        var e_1, _a;
        var total = 0;
        var ecBlocks = this.ecBlocks;
        try {
            for(var ecBlocks_1 = $4ebf54d4cbf17188$var$__values(ecBlocks), ecBlocks_1_1 = ecBlocks_1.next(); !ecBlocks_1_1.done; ecBlocks_1_1 = ecBlocks_1.next()){
                var ecBlock = ecBlocks_1_1.value;
                total += ecBlock.getCount();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecBlocks_1_1 && !ecBlocks_1_1.done && (_a = ecBlocks_1.return)) _a.call(ecBlocks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return total;
    };
    ECBlocks.prototype.getTotalECCodewords = function() {
        return this.ecCodewordsPerBlock * this.getNumBlocks();
    };
    ECBlocks.prototype.getECBlocks = function() {
        return this.ecBlocks;
    };
    return ECBlocks;
}();
var $4ebf54d4cbf17188$export$2e2bcd8739ae039 = $4ebf54d4cbf17188$var$ECBlocks;

});

parcelRegister("9aXvR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ae33644fb71b054$export$2e2bcd8739ae039);
/**
 * <p>Encapsulates the parameters for one error-correction block in one symbol version.
 * This includes the number of data codewords, and the number of times a block with these
 * parameters is used consecutively in the QR code version's format.</p>
 */ var $6ae33644fb71b054$var$ECB = /** @class */ function() {
    function ECB(count /*int*/ , dataCodewords /*int*/ ) {
        this.count = count;
        this.dataCodewords = dataCodewords;
    }
    ECB.prototype.getCount = function() {
        return this.count;
    };
    ECB.prototype.getDataCodewords = function() {
        return this.dataCodewords;
    };
    return ECB;
}();
var $6ae33644fb71b054$export$2e2bcd8739ae039 = $6ae33644fb71b054$var$ECB;

});


parcelRegister("8Z0a4", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a42550d7de477f$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $68a42550d7de477f$export$ff43d31cc568a75f;
(function(DataMaskValues) {
    DataMaskValues[DataMaskValues["DATA_MASK_000"] = 0] = "DATA_MASK_000";
    DataMaskValues[DataMaskValues["DATA_MASK_001"] = 1] = "DATA_MASK_001";
    DataMaskValues[DataMaskValues["DATA_MASK_010"] = 2] = "DATA_MASK_010";
    DataMaskValues[DataMaskValues["DATA_MASK_011"] = 3] = "DATA_MASK_011";
    DataMaskValues[DataMaskValues["DATA_MASK_100"] = 4] = "DATA_MASK_100";
    DataMaskValues[DataMaskValues["DATA_MASK_101"] = 5] = "DATA_MASK_101";
    DataMaskValues[DataMaskValues["DATA_MASK_110"] = 6] = "DATA_MASK_110";
    DataMaskValues[DataMaskValues["DATA_MASK_111"] = 7] = "DATA_MASK_111";
})($68a42550d7de477f$export$ff43d31cc568a75f || ($68a42550d7de477f$export$ff43d31cc568a75f = {}));
/**
 * <p>Encapsulates data masks for the data bits in a QR code, per ISO 18004:2006 6.8. Implementations
 * of this class can un-mask a raw BitMatrix. For simplicity, they will unmask the entire BitMatrix,
 * including areas used for finder patterns, timing patterns, etc. These areas should be unused
 * after the point they are unmasked anyway.</p>
 *
 * <p>Note that the diagram in section 6.8.1 is misleading since it indicates that i is column position
 * and j is row position. In fact, as the text says, i is row position and j is column position.</p>
 *
 * @author Sean Owen
 */ var $68a42550d7de477f$var$DataMask = /** @class */ function() {
    // See ISO 18004:2006 6.8.1
    function DataMask(value, isMasked) {
        this.value = value;
        this.isMasked = isMasked;
    }
    // End of enum constants.
    /**
     * <p>Implementations of this method reverse the data masking process applied to a QR Code and
     * make its bits ready to read.</p>
     *
     * @param bits representation of QR Code bits
     * @param dimension dimension of QR Code, represented by bits, being unmasked
     */ DataMask.prototype.unmaskBitMatrix = function(bits, dimension /*int*/ ) {
        for(var i = 0; i < dimension; i++){
            for(var j = 0; j < dimension; j++)if (this.isMasked(i, j)) bits.flip(j, i);
        }
    };
    DataMask.values = new Map([
        /**
         * 000: mask bits for which (x + y) mod 2 == 0
         */ [
            $68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_000,
            new DataMask($68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_000, function(i /*int*/ , j /*int*/ ) {
                return (i + j & 0x01) === 0;
            })
        ],
        /**
         * 001: mask bits for which x mod 2 == 0
         */ [
            $68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_001,
            new DataMask($68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_001, function(i /*int*/ , j /*int*/ ) {
                return (i & 0x01) === 0;
            })
        ],
        /**
         * 010: mask bits for which y mod 3 == 0
         */ [
            $68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_010,
            new DataMask($68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_010, function(i /*int*/ , j /*int*/ ) {
                return j % 3 === 0;
            })
        ],
        /**
         * 011: mask bits for which (x + y) mod 3 == 0
         */ [
            $68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_011,
            new DataMask($68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_011, function(i /*int*/ , j /*int*/ ) {
                return (i + j) % 3 === 0;
            })
        ],
        /**
         * 100: mask bits for which (x/2 + y/3) mod 2 == 0
         */ [
            $68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_100,
            new DataMask($68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_100, function(i /*int*/ , j /*int*/ ) {
                return (Math.floor(i / 2) + Math.floor(j / 3) & 0x01) === 0;
            })
        ],
        /**
         * 101: mask bits for which xy mod 2 + xy mod 3 == 0
         * equivalently, such that xy mod 6 == 0
         */ [
            $68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_101,
            new DataMask($68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_101, function(i /*int*/ , j /*int*/ ) {
                return i * j % 6 === 0;
            })
        ],
        /**
         * 110: mask bits for which (xy mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that xy mod 6 < 3
         */ [
            $68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_110,
            new DataMask($68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_110, function(i /*int*/ , j /*int*/ ) {
                return i * j % 6 < 3;
            })
        ],
        /**
         * 111: mask bits for which ((x+y)mod 2 + xy mod 3) mod 2 == 0
         * equivalently, such that (x + y + xy mod 3) mod 2 == 0
         */ [
            $68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_111,
            new DataMask($68a42550d7de477f$export$ff43d31cc568a75f.DATA_MASK_111, function(i /*int*/ , j /*int*/ ) {
                return (i + j + i * j % 3 & 0x01) === 0;
            })
        ]
    ]);
    return DataMask;
}();
var $68a42550d7de477f$export$2e2bcd8739ae039 = $68a42550d7de477f$var$DataMask;

});


parcelRegister("7dXSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5428310ec7018be2$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kLpae = parcelRequire("kLpae");
var $5428310ec7018be2$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>Encapsulates a block of data within a QR Code. QR Codes may split their data into
 * multiple blocks, each of which is a unit of data and error-correction codewords. Each
 * is represented by an instance of this class.</p>
 *
 * @author Sean Owen
 */ var $5428310ec7018be2$var$DataBlock = /** @class */ function() {
    function DataBlock(numDataCodewords /*int*/ , codewords) {
        this.numDataCodewords = numDataCodewords;
        this.codewords = codewords;
    }
    /**
     * <p>When QR Codes use multiple data blocks, they are actually interleaved.
     * That is, the first byte of data block 1 to n is written, then the second bytes, and so on. This
     * method will separate the data into original blocks.</p>
     *
     * @param rawCodewords bytes as read directly from the QR Code
     * @param version version of the QR Code
     * @param ecLevel error-correction level of the QR Code
     * @return DataBlocks containing original bytes, "de-interleaved" from representation in the
     *         QR Code
     */ DataBlock.getDataBlocks = function(rawCodewords, version, ecLevel) {
        var e_1, _a, e_2, _b;
        if (rawCodewords.length !== version.getTotalCodewords()) throw new (0, $kLpae.default)();
        // Figure out the number and size of data blocks used by this version and
        // error correction level
        var ecBlocks = version.getECBlocksForLevel(ecLevel);
        // First count the total number of data blocks
        var totalBlocks = 0;
        var ecBlockArray = ecBlocks.getECBlocks();
        try {
            for(var ecBlockArray_1 = $5428310ec7018be2$var$__values(ecBlockArray), ecBlockArray_1_1 = ecBlockArray_1.next(); !ecBlockArray_1_1.done; ecBlockArray_1_1 = ecBlockArray_1.next()){
                var ecBlock = ecBlockArray_1_1.value;
                totalBlocks += ecBlock.getCount();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (ecBlockArray_1_1 && !ecBlockArray_1_1.done && (_a = ecBlockArray_1.return)) _a.call(ecBlockArray_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // Now establish DataBlocks of the appropriate size and number of data codewords
        var result = new Array(totalBlocks);
        var numResultBlocks = 0;
        try {
            for(var ecBlockArray_2 = $5428310ec7018be2$var$__values(ecBlockArray), ecBlockArray_2_1 = ecBlockArray_2.next(); !ecBlockArray_2_1.done; ecBlockArray_2_1 = ecBlockArray_2.next()){
                var ecBlock = ecBlockArray_2_1.value;
                for(var i = 0; i < ecBlock.getCount(); i++){
                    var numDataCodewords = ecBlock.getDataCodewords();
                    var numBlockCodewords = ecBlocks.getECCodewordsPerBlock() + numDataCodewords;
                    result[numResultBlocks++] = new DataBlock(numDataCodewords, new Uint8Array(numBlockCodewords));
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (ecBlockArray_2_1 && !ecBlockArray_2_1.done && (_b = ecBlockArray_2.return)) _b.call(ecBlockArray_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        // All blocks have the same amount of data, except that the last n
        // (where n may be 0) have 1 more byte. Figure out where these start.
        var shorterBlocksTotalCodewords = result[0].codewords.length;
        var longerBlocksStartAt = result.length - 1;
        // TYPESCRIPTPORT: check length is correct here
        while(longerBlocksStartAt >= 0){
            var numCodewords = result[longerBlocksStartAt].codewords.length;
            if (numCodewords === shorterBlocksTotalCodewords) break;
            longerBlocksStartAt--;
        }
        longerBlocksStartAt++;
        var shorterBlocksNumDataCodewords = shorterBlocksTotalCodewords - ecBlocks.getECCodewordsPerBlock();
        // The last elements of result may be 1 element longer
        // first fill out as many elements as all of them have
        var rawCodewordsOffset = 0;
        for(var i = 0; i < shorterBlocksNumDataCodewords; i++)for(var j = 0; j < numResultBlocks; j++)result[j].codewords[i] = rawCodewords[rawCodewordsOffset++];
        // Fill out the last data block in the longer ones
        for(var j = longerBlocksStartAt; j < numResultBlocks; j++)result[j].codewords[shorterBlocksNumDataCodewords] = rawCodewords[rawCodewordsOffset++];
        // Now add in error correction blocks
        var max = result[0].codewords.length;
        for(var i = shorterBlocksNumDataCodewords; i < max; i++)for(var j = 0; j < numResultBlocks; j++){
            var iOffset = j < longerBlocksStartAt ? i : i + 1;
            result[j].codewords[iOffset] = rawCodewords[rawCodewordsOffset++];
        }
        return result;
    };
    DataBlock.prototype.getNumDataCodewords = function() {
        return this.numDataCodewords;
    };
    DataBlock.prototype.getCodewords = function() {
        return this.codewords;
    };
    return DataBlock;
}();
var $5428310ec7018be2$export$2e2bcd8739ae039 = $5428310ec7018be2$var$DataBlock;

});

parcelRegister("iFZGM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d98be87a4f7b8231$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode.decoder {*/ 
var $iVZgW = parcelRequire("iVZgW");

var $l8eP1 = parcelRequire("l8eP1");

var $jpf17 = parcelRequire("jpf17");

var $7mB9T = parcelRequire("7mB9T");

var $dtgr5 = parcelRequire("dtgr5");

var $6E9N1 = parcelRequire("6E9N1");

var $fPMAB = parcelRequire("fPMAB");

var $aLAHy = parcelRequire("aLAHy");
/*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
 * <p>QR Codes can encode text as bits in one of several modes, and can use multiple modes
 * in one QR Code. This class decodes the bits back into text.</p>
 *
 * <p>See ISO 18004:2006, 6.4.3 - 6.4.7</p>
 *
 * @author Sean Owen
 */ var $d98be87a4f7b8231$var$DecodedBitStreamParser = /** @class */ function() {
    function DecodedBitStreamParser() {}
    DecodedBitStreamParser.decode = function(bytes, version, ecLevel, hints) {
        var bits = new (0, $iVZgW.default)(bytes);
        var result = new (0, $6E9N1.default)();
        var byteSegments = new Array(); // 1
        // TYPESCRIPTPORT: I do not use constructor with size 1 as in original Java means capacity and the array length is checked below
        var symbolSequence = -1;
        var parityData = -1;
        try {
            var currentCharacterSetECI = null;
            var fc1InEffect = false;
            var mode = void 0;
            do {
                // While still another segment to read...
                if (bits.available() < 4) // OK, assume we're done. Really, a TERMINATOR mode should have been recorded here
                mode = (0, $aLAHy.default).TERMINATOR;
                else {
                    var modeBits = bits.readBits(4);
                    mode = (0, $aLAHy.default).forBits(modeBits); // mode is encoded by 4 bits
                }
                switch(mode){
                    case (0, $aLAHy.default).TERMINATOR:
                        break;
                    case (0, $aLAHy.default).FNC1_FIRST_POSITION:
                    case (0, $aLAHy.default).FNC1_SECOND_POSITION:
                        // We do little with FNC1 except alter the parsed result a bit according to the spec
                        fc1InEffect = true;
                        break;
                    case (0, $aLAHy.default).STRUCTURED_APPEND:
                        if (bits.available() < 16) throw new (0, $dtgr5.default)();
                        // sequence number and parity is added later to the result metadata
                        // Read next 8 bits (symbol sequence #) and 8 bits (data: parity), then continue
                        symbolSequence = bits.readBits(8);
                        parityData = bits.readBits(8);
                        break;
                    case (0, $aLAHy.default).ECI:
                        // Count doesn't apply to ECI
                        var value = DecodedBitStreamParser.parseECIValue(bits);
                        currentCharacterSetECI = (0, $l8eP1.default).getCharacterSetECIByValue(value);
                        if (currentCharacterSetECI === null) throw new (0, $dtgr5.default)();
                        break;
                    case (0, $aLAHy.default).HANZI:
                        // First handle Hanzi mode which does not start with character count
                        // Chinese mode contains a sub set indicator right after mode indicator
                        var subset = bits.readBits(4);
                        var countHanzi = bits.readBits(mode.getCharacterCountBits(version));
                        if (subset === DecodedBitStreamParser.GB2312_SUBSET) DecodedBitStreamParser.decodeHanziSegment(bits, result, countHanzi);
                        break;
                    default:
                        // "Normal" QR code modes:
                        // How many characters will follow, encoded in this mode?
                        var count = bits.readBits(mode.getCharacterCountBits(version));
                        switch(mode){
                            case (0, $aLAHy.default).NUMERIC:
                                DecodedBitStreamParser.decodeNumericSegment(bits, result, count);
                                break;
                            case (0, $aLAHy.default).ALPHANUMERIC:
                                DecodedBitStreamParser.decodeAlphanumericSegment(bits, result, count, fc1InEffect);
                                break;
                            case (0, $aLAHy.default).BYTE:
                                DecodedBitStreamParser.decodeByteSegment(bits, result, count, currentCharacterSetECI, byteSegments, hints);
                                break;
                            case (0, $aLAHy.default).KANJI:
                                DecodedBitStreamParser.decodeKanjiSegment(bits, result, count);
                                break;
                            default:
                                throw new (0, $dtgr5.default)();
                        }
                        break;
                }
            }while (mode !== (0, $aLAHy.default).TERMINATOR);
        } catch (iae /*: IllegalArgumentException*/ ) {
            // from readBits() calls
            throw new (0, $dtgr5.default)();
        }
        return new (0, $jpf17.default)(bytes, result.toString(), byteSegments.length === 0 ? null : byteSegments, ecLevel === null ? null : ecLevel.toString(), symbolSequence, parityData);
    };
    /**
     * See specification GBT 18284-2000
     */ DecodedBitStreamParser.decodeHanziSegment = function(bits, result, count /*int*/ ) {
        // Don't crash trying to read more bits than we have available.
        if (count * 13 > bits.available()) throw new (0, $dtgr5.default)();
        // Each character will require 2 bytes. Read the characters as 2-byte pairs
        // and decode as GB2312 afterwards
        var buffer = new Uint8Array(2 * count);
        var offset = 0;
        while(count > 0){
            // Each 13 bits encodes a 2-byte character
            var twoBytes = bits.readBits(13);
            var assembledTwoBytes = twoBytes / 0x060 << 8 & 0xFFFFFFFF | twoBytes % 0x060;
            if (assembledTwoBytes < 0x003BF) // In the 0xA1A1 to 0xAAFE range
            assembledTwoBytes += 0x0A1A1;
            else // In the 0xB0A1 to 0xFAFE range
            assembledTwoBytes += 0x0A6A1;
            buffer[offset] = /*(byte) */ assembledTwoBytes >> 8 & 0xFF;
            buffer[offset + 1] = /*(byte) */ assembledTwoBytes & 0xFF;
            offset += 2;
            count--;
        }
        try {
            result.append((0, $fPMAB.default).decode(buffer, (0, $7mB9T.default).GB2312));
        // TYPESCRIPTPORT: TODO: implement GB2312 decode. StringView from MDN could be a starting point
        } catch (ignored /*: UnsupportedEncodingException*/ ) {
            throw new (0, $dtgr5.default)(ignored);
        }
    };
    DecodedBitStreamParser.decodeKanjiSegment = function(bits, result, count /*int*/ ) {
        // Don't crash trying to read more bits than we have available.
        if (count * 13 > bits.available()) throw new (0, $dtgr5.default)();
        // Each character will require 2 bytes. Read the characters as 2-byte pairs
        // and decode as Shift_JIS afterwards
        var buffer = new Uint8Array(2 * count);
        var offset = 0;
        while(count > 0){
            // Each 13 bits encodes a 2-byte character
            var twoBytes = bits.readBits(13);
            var assembledTwoBytes = twoBytes / 0x0C0 << 8 & 0xFFFFFFFF | twoBytes % 0x0C0;
            if (assembledTwoBytes < 0x01F00) // In the 0x8140 to 0x9FFC range
            assembledTwoBytes += 0x08140;
            else // In the 0xE040 to 0xEBBF range
            assembledTwoBytes += 0x0C140;
            buffer[offset] = /*(byte) */ assembledTwoBytes >> 8;
            buffer[offset + 1] = /*(byte) */ assembledTwoBytes;
            offset += 2;
            count--;
        }
        // Shift_JIS may not be supported in some environments:
        try {
            result.append((0, $fPMAB.default).decode(buffer, (0, $7mB9T.default).SHIFT_JIS));
        // TYPESCRIPTPORT: TODO: implement SHIFT_JIS decode. StringView from MDN could be a starting point
        } catch (ignored /*: UnsupportedEncodingException*/ ) {
            throw new (0, $dtgr5.default)(ignored);
        }
    };
    DecodedBitStreamParser.decodeByteSegment = function(bits, result, count /*int*/ , currentCharacterSetECI, byteSegments, hints) {
        // Don't crash trying to read more bits than we have available.
        if (8 * count > bits.available()) throw new (0, $dtgr5.default)();
        var readBytes = new Uint8Array(count);
        for(var i = 0; i < count; i++)readBytes[i] = /*(byte) */ bits.readBits(8);
        var encoding;
        if (currentCharacterSetECI === null) // The spec isn't clear on this mode; see
        // section 6.4.5: t does not say which encoding to assuming
        // upon decoding. I have seen ISO-8859-1 used as well as
        // Shift_JIS -- without anything like an ECI designator to
        // give a hint.
        encoding = (0, $7mB9T.default).guessEncoding(readBytes, hints);
        else encoding = currentCharacterSetECI.getName();
        try {
            result.append((0, $fPMAB.default).decode(readBytes, encoding));
        } catch (ignored /*: UnsupportedEncodingException*/ ) {
            throw new (0, $dtgr5.default)(ignored);
        }
        byteSegments.push(readBytes);
    };
    DecodedBitStreamParser.toAlphaNumericChar = function(value /*int*/ ) {
        if (value >= DecodedBitStreamParser.ALPHANUMERIC_CHARS.length) throw new (0, $dtgr5.default)();
        return DecodedBitStreamParser.ALPHANUMERIC_CHARS[value];
    };
    DecodedBitStreamParser.decodeAlphanumericSegment = function(bits, result, count /*int*/ , fc1InEffect) {
        // Read two characters at a time
        var start = result.length();
        while(count > 1){
            if (bits.available() < 11) throw new (0, $dtgr5.default)();
            var nextTwoCharsBits = bits.readBits(11);
            result.append(DecodedBitStreamParser.toAlphaNumericChar(Math.floor(nextTwoCharsBits / 45)));
            result.append(DecodedBitStreamParser.toAlphaNumericChar(nextTwoCharsBits % 45));
            count -= 2;
        }
        if (count === 1) {
            // special case: one character left
            if (bits.available() < 6) throw new (0, $dtgr5.default)();
            result.append(DecodedBitStreamParser.toAlphaNumericChar(bits.readBits(6)));
        }
        // See section 6.4.8.1, 6.4.8.2
        if (fc1InEffect) {
            // We need to massage the result a bit if in an FNC1 mode:
            for(var i = start; i < result.length(); i++)if (result.charAt(i) === "%") {
                if (i < result.length() - 1 && result.charAt(i + 1) === "%") // %% is rendered as %
                result.deleteCharAt(i + 1);
                else // In alpha mode, % should be converted to FNC1 separator 0x1D
                result.setCharAt(i, String.fromCharCode(0x1D));
            }
        }
    };
    DecodedBitStreamParser.decodeNumericSegment = function(bits, result, count /*int*/ ) {
        // Read three digits at a time
        while(count >= 3){
            // Each 10 bits encodes three digits
            if (bits.available() < 10) throw new (0, $dtgr5.default)();
            var threeDigitsBits = bits.readBits(10);
            if (threeDigitsBits >= 1000) throw new (0, $dtgr5.default)();
            result.append(DecodedBitStreamParser.toAlphaNumericChar(Math.floor(threeDigitsBits / 100)));
            result.append(DecodedBitStreamParser.toAlphaNumericChar(Math.floor(threeDigitsBits / 10) % 10));
            result.append(DecodedBitStreamParser.toAlphaNumericChar(threeDigitsBits % 10));
            count -= 3;
        }
        if (count === 2) {
            // Two digits left over to read, encoded in 7 bits
            if (bits.available() < 7) throw new (0, $dtgr5.default)();
            var twoDigitsBits = bits.readBits(7);
            if (twoDigitsBits >= 100) throw new (0, $dtgr5.default)();
            result.append(DecodedBitStreamParser.toAlphaNumericChar(Math.floor(twoDigitsBits / 10)));
            result.append(DecodedBitStreamParser.toAlphaNumericChar(twoDigitsBits % 10));
        } else if (count === 1) {
            // One digit left over to read
            if (bits.available() < 4) throw new (0, $dtgr5.default)();
            var digitBits = bits.readBits(4);
            if (digitBits >= 10) throw new (0, $dtgr5.default)();
            result.append(DecodedBitStreamParser.toAlphaNumericChar(digitBits));
        }
    };
    DecodedBitStreamParser.parseECIValue = function(bits) {
        var firstByte = bits.readBits(8);
        if ((firstByte & 0x80) === 0) // just one byte
        return firstByte & 0x7F;
        if ((firstByte & 0xC0) === 0x80) {
            // two bytes
            var secondByte = bits.readBits(8);
            return (firstByte & 0x3F) << 8 & 0xFFFFFFFF | secondByte;
        }
        if ((firstByte & 0xE0) === 0xC0) {
            // three bytes
            var secondThirdBytes = bits.readBits(16);
            return (firstByte & 0x1F) << 16 & 0xFFFFFFFF | secondThirdBytes;
        }
        throw new (0, $dtgr5.default)();
    };
    /**
     * See ISO 18004:2006, 6.4.4 Table 5
     */ DecodedBitStreamParser.ALPHANUMERIC_CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    DecodedBitStreamParser.GB2312_SUBSET = 1;
    return DecodedBitStreamParser;
}();
var $d98be87a4f7b8231$export$2e2bcd8739ae039 // function Uint8ArrayToString(a: Uint8Array): string {
 //     const CHUNK_SZ = 0x8000;
 //     const c = new StringBuilder();
 //     for (let i = 0, length = a.length; i < length; i += CHUNK_SZ) {
 //         c.append(String.fromCharCode.apply(null, a.subarray(i, i + CHUNK_SZ)));
 //     }
 //     return c.toString();
 // }
 = $d98be87a4f7b8231$var$DecodedBitStreamParser;

});
parcelRegister("aLAHy", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d6ac34d22f26d80$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kLpae = parcelRequire("kLpae");
var $7d6ac34d22f26d80$export$b241eb2cadd22852;
(function(ModeValues) {
    ModeValues[ModeValues["TERMINATOR"] = 0] = "TERMINATOR";
    ModeValues[ModeValues["NUMERIC"] = 1] = "NUMERIC";
    ModeValues[ModeValues["ALPHANUMERIC"] = 2] = "ALPHANUMERIC";
    ModeValues[ModeValues["STRUCTURED_APPEND"] = 3] = "STRUCTURED_APPEND";
    ModeValues[ModeValues["BYTE"] = 4] = "BYTE";
    ModeValues[ModeValues["ECI"] = 5] = "ECI";
    ModeValues[ModeValues["KANJI"] = 6] = "KANJI";
    ModeValues[ModeValues["FNC1_FIRST_POSITION"] = 7] = "FNC1_FIRST_POSITION";
    ModeValues[ModeValues["FNC1_SECOND_POSITION"] = 8] = "FNC1_SECOND_POSITION";
    /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ ModeValues[ModeValues["HANZI"] = 9] = "HANZI";
})($7d6ac34d22f26d80$export$b241eb2cadd22852 || ($7d6ac34d22f26d80$export$b241eb2cadd22852 = {}));
/**
 * <p>See ISO 18004:2006, 6.4.1, Tables 2 and 3. This enum encapsulates the various modes in which
 * data can be encoded to bits in the QR code standard.</p>
 *
 * @author Sean Owen
 */ var $7d6ac34d22f26d80$var$Mode = /** @class */ function() {
    function Mode(value, stringValue, characterCountBitsForVersions, bits /*int*/ ) {
        this.value = value;
        this.stringValue = stringValue;
        this.characterCountBitsForVersions = characterCountBitsForVersions;
        this.bits = bits;
        Mode.FOR_BITS.set(bits, this);
        Mode.FOR_VALUE.set(value, this);
    }
    /**
     * @param bits four bits encoding a QR Code data mode
     * @return Mode encoded by these bits
     * @throws IllegalArgumentException if bits do not correspond to a known mode
     */ Mode.forBits = function(bits /*int*/ ) {
        var mode = Mode.FOR_BITS.get(bits);
        if (undefined === mode) throw new (0, $kLpae.default)();
        return mode;
    };
    /**
     * @param version version in question
     * @return number of bits used, in this QR Code symbol {@link Version}, to encode the
     *         count of characters that will follow encoded in this Mode
     */ Mode.prototype.getCharacterCountBits = function(version) {
        var versionNumber = version.getVersionNumber();
        var offset;
        if (versionNumber <= 9) offset = 0;
        else if (versionNumber <= 26) offset = 1;
        else offset = 2;
        return this.characterCountBitsForVersions[offset];
    };
    Mode.prototype.getValue = function() {
        return this.value;
    };
    Mode.prototype.getBits = function() {
        return this.bits;
    };
    Mode.prototype.equals = function(o) {
        if (!(o instanceof Mode)) return false;
        var other = o;
        return this.value === other.value;
    };
    Mode.prototype.toString = function() {
        return this.stringValue;
    };
    Mode.FOR_BITS = new Map();
    Mode.FOR_VALUE = new Map();
    Mode.TERMINATOR = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.TERMINATOR, "TERMINATOR", Int32Array.from([
        0,
        0,
        0
    ]), 0x00); // Not really a mode...
    Mode.NUMERIC = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.NUMERIC, "NUMERIC", Int32Array.from([
        10,
        12,
        14
    ]), 0x01);
    Mode.ALPHANUMERIC = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.ALPHANUMERIC, "ALPHANUMERIC", Int32Array.from([
        9,
        11,
        13
    ]), 0x02);
    Mode.STRUCTURED_APPEND = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.STRUCTURED_APPEND, "STRUCTURED_APPEND", Int32Array.from([
        0,
        0,
        0
    ]), 0x03); // Not supported
    Mode.BYTE = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.BYTE, "BYTE", Int32Array.from([
        8,
        16,
        16
    ]), 0x04);
    Mode.ECI = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.ECI, "ECI", Int32Array.from([
        0,
        0,
        0
    ]), 0x07); // character counts don't apply
    Mode.KANJI = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.KANJI, "KANJI", Int32Array.from([
        8,
        10,
        12
    ]), 0x08);
    Mode.FNC1_FIRST_POSITION = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.FNC1_FIRST_POSITION, "FNC1_FIRST_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 0x05);
    Mode.FNC1_SECOND_POSITION = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.FNC1_SECOND_POSITION, "FNC1_SECOND_POSITION", Int32Array.from([
        0,
        0,
        0
    ]), 0x09);
    /** See GBT 18284-2000; "Hanzi" is a transliteration of this mode name. */ Mode.HANZI = new Mode($7d6ac34d22f26d80$export$b241eb2cadd22852.HANZI, "HANZI", Int32Array.from([
        8,
        10,
        12
    ]), 0x0D);
    return Mode;
}();
var $7d6ac34d22f26d80$export$2e2bcd8739ae039 = $7d6ac34d22f26d80$var$Mode;

});


parcelRegister("hLuKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceeeae5846effe44$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Meta-data container for QR Code decoding. Instances of this class may be used to convey information back to the
 * decoding caller. Callers are expected to process this.
 *
 * @see com.google.zxing.common.DecoderResult#getOther()
 */ var $ceeeae5846effe44$var$QRCodeDecoderMetaData = /** @class */ function() {
    function QRCodeDecoderMetaData(mirrored) {
        this.mirrored = mirrored;
    }
    /**
     * @return true if the QR Code was mirrored.
     */ QRCodeDecoderMetaData.prototype.isMirrored = function() {
        return this.mirrored;
    };
    /**
     * Apply the result points' order correction due to mirroring.
     *
     * @param points Array of points to apply mirror correction to.
     */ QRCodeDecoderMetaData.prototype.applyMirroredCorrection = function(points) {
        if (!this.mirrored || points === null || points.length < 3) return;
        var bottomLeft = points[0];
        points[0] = points[2];
        points[2] = bottomLeft;
    // No need to 'fix' top-left and alignment pattern.
    };
    return QRCodeDecoderMetaData;
}();
var $ceeeae5846effe44$export$2e2bcd8739ae039 = $ceeeae5846effe44$var$QRCodeDecoderMetaData;

});


parcelRegister("cnFbF", function(module, exports) {

$parcel$export(module.exports, "default", () => $903794f45f08d582$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fbOCK = parcelRequire("fbOCK");

var $1q3xj = parcelRequire("1q3xj");

var $5a6kn = parcelRequire("5a6kn");

var $1e7M5 = parcelRequire("1e7M5");

var $b5DE3 = parcelRequire("b5DE3");

var $cQi30 = parcelRequire("cQi30");

var $fwBMA = parcelRequire("fwBMA");

var $b41gY = parcelRequire("b41gY");

var $9rJZl = parcelRequire("9rJZl");

var $hW0WN = parcelRequire("hW0WN");
/*import java.util.Map;*/ /**
 * <p>Encapsulates logic that can detect a QR Code in an image, even if the QR Code
 * is rotated or skewed, or partially obscured.</p>
 *
 * @author Sean Owen
 */ var $903794f45f08d582$var$Detector = /** @class */ function() {
    function Detector(image) {
        this.image = image;
    }
    Detector.prototype.getImage = function() {
        return this.image;
    };
    Detector.prototype.getResultPointCallback = function() {
        return this.resultPointCallback;
    };
    /**
     * <p>Detects a QR Code in an image.</p>
     *
     * @return {@link DetectorResult} encapsulating results of detecting a QR Code
     * @throws NotFoundException if QR Code cannot be found
     * @throws FormatException if a QR Code cannot be decoded
     */ // public detect(): DetectorResult /*throws NotFoundException, FormatException*/ {
    //   return detect(null)
    // }
    /**
     * <p>Detects a QR Code in an image.</p>
     *
     * @param hints optional hints to detector
     * @return {@link DetectorResult} encapsulating results of detecting a QR Code
     * @throws NotFoundException if QR Code cannot be found
     * @throws FormatException if a QR Code cannot be decoded
     */ Detector.prototype.detect = function(hints) {
        this.resultPointCallback = hints === null || hints === undefined ? null : /*(ResultPointCallback) */ hints.get((0, $b5DE3.default).NEED_RESULT_POINT_CALLBACK);
        var finder = new (0, $hW0WN.default)(this.image, this.resultPointCallback);
        var info = finder.find(hints);
        return this.processFinderPatternInfo(info);
    };
    Detector.prototype.processFinderPatternInfo = function(info) {
        var topLeft = info.getTopLeft();
        var topRight = info.getTopRight();
        var bottomLeft = info.getBottomLeft();
        var moduleSize = this.calculateModuleSize(topLeft, topRight, bottomLeft);
        if (moduleSize < 1.0) throw new (0, $cQi30.default)("No pattern found in proccess finder.");
        var dimension = Detector.computeDimension(topLeft, topRight, bottomLeft, moduleSize);
        var provisionalVersion = (0, $b41gY.default).getProvisionalVersionForDimension(dimension);
        var modulesBetweenFPCenters = provisionalVersion.getDimensionForVersion() - 7;
        var alignmentPattern = null;
        // Anything above version 1 has an alignment pattern
        if (provisionalVersion.getAlignmentPatternCenters().length > 0) {
            // Guess where a "bottom right" finder pattern would have been
            var bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
            var bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
            // Estimate that alignment pattern is closer by 3 modules
            // from "bottom right" to known top left location
            var correctionToTopLeft = 1.0 - 3.0 / modulesBetweenFPCenters;
            var estAlignmentX = /*(int) */ Math.floor(topLeft.getX() + correctionToTopLeft * (bottomRightX - topLeft.getX()));
            var estAlignmentY = /*(int) */ Math.floor(topLeft.getY() + correctionToTopLeft * (bottomRightY - topLeft.getY()));
            // Kind of arbitrary -- expand search radius before giving up
            for(var i = 4; i <= 16; i <<= 1)try {
                alignmentPattern = this.findAlignmentInRegion(moduleSize, estAlignmentX, estAlignmentY, i);
                break;
            } catch (re /*NotFoundException*/ ) {
                if (!(re instanceof (0, $cQi30.default))) throw re;
            // try next round
            }
        // If we didn't find alignment pattern... well try anyway without it
        }
        var transform = Detector.createTransform(topLeft, topRight, bottomLeft, alignmentPattern, dimension);
        var bits = Detector.sampleGrid(this.image, transform, dimension);
        var points;
        if (alignmentPattern === null) points = [
            bottomLeft,
            topLeft,
            topRight
        ];
        else points = [
            bottomLeft,
            topLeft,
            topRight,
            alignmentPattern
        ];
        return new (0, $1q3xj.default)(bits, points);
    };
    Detector.createTransform = function(topLeft, topRight, bottomLeft, alignmentPattern, dimension /*int*/ ) {
        var dimMinusThree = dimension - 3.5;
        var bottomRightX; /*float*/ 
        var bottomRightY; /*float*/ 
        var sourceBottomRightX; /*float*/ 
        var sourceBottomRightY; /*float*/ 
        if (alignmentPattern !== null) {
            bottomRightX = alignmentPattern.getX();
            bottomRightY = alignmentPattern.getY();
            sourceBottomRightX = dimMinusThree - 3.0;
            sourceBottomRightY = sourceBottomRightX;
        } else {
            // Don't have an alignment pattern, just make up the bottom-right point
            bottomRightX = topRight.getX() - topLeft.getX() + bottomLeft.getX();
            bottomRightY = topRight.getY() - topLeft.getY() + bottomLeft.getY();
            sourceBottomRightX = dimMinusThree;
            sourceBottomRightY = dimMinusThree;
        }
        return (0, $1e7M5.default).quadrilateralToQuadrilateral(3.5, 3.5, dimMinusThree, 3.5, sourceBottomRightX, sourceBottomRightY, 3.5, dimMinusThree, topLeft.getX(), topLeft.getY(), topRight.getX(), topRight.getY(), bottomRightX, bottomRightY, bottomLeft.getX(), bottomLeft.getY());
    };
    Detector.sampleGrid = function(image, transform, dimension /*int*/ ) {
        var sampler = (0, $5a6kn.default).getInstance();
        return sampler.sampleGridWithTransform(image, dimension, dimension, transform);
    };
    /**
     * <p>Computes the dimension (number of modules on a size) of the QR Code based on the position
     * of the finder patterns and estimated module size.</p>
     */ Detector.computeDimension = function(topLeft, topRight, bottomLeft, moduleSize /*float*/ ) {
        var tltrCentersDimension = (0, $fbOCK.default).round((0, $fwBMA.default).distance(topLeft, topRight) / moduleSize);
        var tlblCentersDimension = (0, $fbOCK.default).round((0, $fwBMA.default).distance(topLeft, bottomLeft) / moduleSize);
        var dimension = Math.floor((tltrCentersDimension + tlblCentersDimension) / 2) + 7;
        switch(dimension & 0x03){
            case 0:
                dimension++;
                break;
            // 1? do nothing
            case 2:
                dimension--;
                break;
            case 3:
                throw new (0, $cQi30.default)("Dimensions could be not found.");
        }
        return dimension;
    };
    /**
     * <p>Computes an average estimated module size based on estimated derived from the positions
     * of the three finder patterns.</p>
     *
     * @param topLeft detected top-left finder pattern center
     * @param topRight detected top-right finder pattern center
     * @param bottomLeft detected bottom-left finder pattern center
     * @return estimated module size
     */ Detector.prototype.calculateModuleSize = function(topLeft, topRight, bottomLeft) {
        // Take the average
        return (this.calculateModuleSizeOneWay(topLeft, topRight) + this.calculateModuleSizeOneWay(topLeft, bottomLeft)) / 2.0;
    };
    /**
     * <p>Estimates module size based on two finder patterns -- it uses
     * {@link #sizeOfBlackWhiteBlackRunBothWays(int, int, int, int)} to figure the
     * width of each, measuring along the axis between their centers.</p>
     */ Detector.prototype.calculateModuleSizeOneWay = function(pattern, otherPattern) {
        var moduleSizeEst1 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()), /*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()));
        var moduleSizeEst2 = this.sizeOfBlackWhiteBlackRunBothWays(/*(int) */ Math.floor(otherPattern.getX()), /*(int) */ Math.floor(otherPattern.getY()), /*(int) */ Math.floor(pattern.getX()), /*(int) */ Math.floor(pattern.getY()));
        if (isNaN(moduleSizeEst1)) return moduleSizeEst2 / 7.0;
        if (isNaN(moduleSizeEst2)) return moduleSizeEst1 / 7.0;
        // Average them, and divide by 7 since we've counted the width of 3 black modules,
        // and 1 white and 1 black module on either side. Ergo, divide sum by 14.
        return (moduleSizeEst1 + moduleSizeEst2) / 14.0;
    };
    /**
     * See {@link #sizeOfBlackWhiteBlackRun(int, int, int, int)}; computes the total width of
     * a finder pattern by looking for a black-white-black run from the center in the direction
     * of another point (another finder pattern center), and in the opposite direction too.
     */ Detector.prototype.sizeOfBlackWhiteBlackRunBothWays = function(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
        var result = this.sizeOfBlackWhiteBlackRun(fromX, fromY, toX, toY);
        // Now count other way -- don't run off image though of course
        var scale = 1.0;
        var otherToX = fromX - (toX - fromX);
        if (otherToX < 0) {
            scale = fromX / /*(float) */ (fromX - otherToX);
            otherToX = 0;
        } else if (otherToX >= this.image.getWidth()) {
            scale = (this.image.getWidth() - 1 - fromX) / /*(float) */ (otherToX - fromX);
            otherToX = this.image.getWidth() - 1;
        }
        var otherToY = /*(int) */ Math.floor(fromY - (toY - fromY) * scale);
        scale = 1.0;
        if (otherToY < 0) {
            scale = fromY / /*(float) */ (fromY - otherToY);
            otherToY = 0;
        } else if (otherToY >= this.image.getHeight()) {
            scale = (this.image.getHeight() - 1 - fromY) / /*(float) */ (otherToY - fromY);
            otherToY = this.image.getHeight() - 1;
        }
        otherToX = /*(int) */ Math.floor(fromX + (otherToX - fromX) * scale);
        result += this.sizeOfBlackWhiteBlackRun(fromX, fromY, otherToX, otherToY);
        // Middle pixel is double-counted this way; subtract 1
        return result - 1.0;
    };
    /**
     * <p>This method traces a line from a point in the image, in the direction towards another point.
     * It begins in a black region, and keeps going until it finds white, then black, then white again.
     * It reports the distance from the start to this point.</p>
     *
     * <p>This is used when figuring out how wide a finder pattern is, when the finder pattern
     * may be skewed or rotated.</p>
     */ Detector.prototype.sizeOfBlackWhiteBlackRun = function(fromX /*int*/ , fromY /*int*/ , toX /*int*/ , toY /*int*/ ) {
        // Mild variant of Bresenham's algorithm
        // see http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
        var steep = Math.abs(toY - fromY) > Math.abs(toX - fromX);
        if (steep) {
            var temp = fromX;
            fromX = fromY;
            fromY = temp;
            temp = toX;
            toX = toY;
            toY = temp;
        }
        var dx = Math.abs(toX - fromX);
        var dy = Math.abs(toY - fromY);
        var error = -dx / 2;
        var xstep = fromX < toX ? 1 : -1;
        var ystep = fromY < toY ? 1 : -1;
        // In black pixels, looking for white, first or second time.
        var state = 0;
        // Loop up until x == toX, but not beyond
        var xLimit = toX + xstep;
        for(var x = fromX, y = fromY; x !== xLimit; x += xstep){
            var realX = steep ? y : x;
            var realY = steep ? x : y;
            // Does current pixel mean we have moved white to black or vice versa?
            // Scanning black in state 0,2 and white in state 1, so if we find the wrong
            // color, advance to next state or end if we are in state 2 already
            if (state === 1 === this.image.get(realX, realY)) {
                if (state === 2) return (0, $fbOCK.default).distance(x, y, fromX, fromY);
                state++;
            }
            error += dy;
            if (error > 0) {
                if (y === toY) break;
                y += ystep;
                error -= dx;
            }
        }
        // Found black-white-black; give the benefit of the doubt that the next pixel outside the image
        // is "white" so this last point at (toX+xStep,toY) is the right ending. This is really a
        // small approximation; (toX+xStep,toY+yStep) might be really correct. Ignore this.
        if (state === 2) return (0, $fbOCK.default).distance(toX + xstep, toY, fromX, fromY);
        // else we didn't find even black-white-black; no estimate is really possible
        return NaN;
    };
    /**
     * <p>Attempts to locate an alignment pattern in a limited region of the image, which is
     * guessed to contain it. This method uses {@link AlignmentPattern}.</p>
     *
     * @param overallEstModuleSize estimated module size so far
     * @param estAlignmentX x coordinate of center of area probably containing alignment pattern
     * @param estAlignmentY y coordinate of above
     * @param allowanceFactor number of pixels in all directions to search from the center
     * @return {@link AlignmentPattern} if found, or null otherwise
     * @throws NotFoundException if an unexpected error occurs during detection
     */ Detector.prototype.findAlignmentInRegion = function(overallEstModuleSize /*float*/ , estAlignmentX /*int*/ , estAlignmentY /*int*/ , allowanceFactor /*float*/ ) {
        // Look for an alignment pattern (3 modules in size) around where it
        // should be
        var allowance = /*(int) */ Math.floor(allowanceFactor * overallEstModuleSize);
        var alignmentAreaLeftX = Math.max(0, estAlignmentX - allowance);
        var alignmentAreaRightX = Math.min(this.image.getWidth() - 1, estAlignmentX + allowance);
        if (alignmentAreaRightX - alignmentAreaLeftX < overallEstModuleSize * 3) throw new (0, $cQi30.default)("Alignment top exceeds estimated module size.");
        var alignmentAreaTopY = Math.max(0, estAlignmentY - allowance);
        var alignmentAreaBottomY = Math.min(this.image.getHeight() - 1, estAlignmentY + allowance);
        if (alignmentAreaBottomY - alignmentAreaTopY < overallEstModuleSize * 3) throw new (0, $cQi30.default)("Alignment bottom exceeds estimated module size.");
        var alignmentFinder = new (0, $9rJZl.default)(this.image, alignmentAreaLeftX, alignmentAreaTopY, alignmentAreaRightX - alignmentAreaLeftX, alignmentAreaBottomY - alignmentAreaTopY, overallEstModuleSize, this.resultPointCallback);
        return alignmentFinder.find();
    };
    return Detector;
}();
var $903794f45f08d582$export$2e2bcd8739ae039 = $903794f45f08d582$var$Detector;

});
parcelRegister("9rJZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e0a4f04855d5c3e$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kICHP = parcelRequire("kICHP");

var $cQi30 = parcelRequire("cQi30");
var $6e0a4f04855d5c3e$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*import java.util.ArrayList;*/ /*import java.util.List;*/ /**
 * <p>This class attempts to find alignment patterns in a QR Code. Alignment patterns look like finder
 * patterns but are smaller and appear at regular intervals throughout the image.</p>
 *
 * <p>At the moment this only looks for the bottom-right alignment pattern.</p>
 *
 * <p>This is mostly a simplified copy of {@link FinderPatternFinder}. It is copied,
 * pasted and stripped down here for maximum performance but does unfortunately duplicate
 * some code.</p>
 *
 * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.</p>
 *
 * @author Sean Owen
 */ var $6e0a4f04855d5c3e$var$AlignmentPatternFinder = /** @class */ function() {
    /**
     * <p>Creates a finder that will look in a portion of the whole image.</p>
     *
     * @param image image to search
     * @param startX left column from which to start searching
     * @param startY top row from which to start searching
     * @param width width of region to search
     * @param height height of region to search
     * @param moduleSize estimated module size so far
     */ function AlignmentPatternFinder(image, startX /*int*/ , startY /*int*/ , width /*int*/ , height /*int*/ , moduleSize /*float*/ , resultPointCallback) {
        this.image = image;
        this.startX = startX;
        this.startY = startY;
        this.width = width;
        this.height = height;
        this.moduleSize = moduleSize;
        this.resultPointCallback = resultPointCallback;
        this.possibleCenters = []; // new Array<any>(5))
        // TYPESCRIPTPORT: array initialization without size as the length is checked below
        this.crossCheckStateCount = new Int32Array(3);
    }
    /**
     * <p>This method attempts to find the bottom-right alignment pattern in the image. It is a bit messy since
     * it's pretty performance-critical and so is written to be fast foremost.</p>
     *
     * @return {@link AlignmentPattern} if found
     * @throws NotFoundException if not found
     */ AlignmentPatternFinder.prototype.find = function() {
        var startX = this.startX;
        var height = this.height;
        var width = this.width;
        var maxJ = startX + width;
        var middleI = this.startY + height / 2;
        // We are looking for black/white/black modules in 1:1:1 ratio
        // this tracks the number of black/white/black modules seen so far
        var stateCount = new Int32Array(3);
        var image = this.image;
        for(var iGen = 0; iGen < height; iGen++){
            // Search from middle outwards
            var i = middleI + ((iGen & 0x01) === 0 ? Math.floor((iGen + 1) / 2) : -Math.floor((iGen + 1) / 2));
            stateCount[0] = 0;
            stateCount[1] = 0;
            stateCount[2] = 0;
            var j = startX;
            // Burn off leading white pixels before anything else; if we start in the middle of
            // a white run, it doesn't make sense to count its length, since we don't know if the
            // white run continued to the left of the start point
            while(j < maxJ && !image.get(j, i))j++;
            var currentState = 0;
            while(j < maxJ){
                if (image.get(j, i)) {
                    // Black pixel
                    if (currentState === 1) stateCount[1]++;
                    else if (currentState === 2) {
                        if (this.foundPatternCross(stateCount)) {
                            var confirmed = this.handlePossibleCenter(stateCount, i, j);
                            if (confirmed !== null) return confirmed;
                        }
                        stateCount[0] = stateCount[2];
                        stateCount[1] = 1;
                        stateCount[2] = 0;
                        currentState = 1;
                    } else stateCount[++currentState]++;
                } else {
                    if (currentState === 1) currentState++;
                    stateCount[currentState]++;
                }
                j++;
            }
            if (this.foundPatternCross(stateCount)) {
                var confirmed = this.handlePossibleCenter(stateCount, i, maxJ);
                if (confirmed !== null) return confirmed;
            }
        }
        // Hmm, nothing we saw was observed and confirmed twice. If we had
        // any guess at all, return it.
        if (this.possibleCenters.length !== 0) return this.possibleCenters[0];
        throw new (0, $cQi30.default)();
    };
    /**
     * Given a count of black/white/black pixels just seen and an end position,
     * figures the location of the center of this black/white/black run.
     */ AlignmentPatternFinder.centerFromEnd = function(stateCount, end /*int*/ ) {
        return end - stateCount[2] - stateCount[1] / 2.0;
    };
    /**
     * @param stateCount count of black/white/black pixels just read
     * @return true iff the proportions of the counts is close enough to the 1/1/1 ratios
     *         used by alignment patterns to be considered a match
     */ AlignmentPatternFinder.prototype.foundPatternCross = function(stateCount) {
        var moduleSize = this.moduleSize;
        var maxVariance = moduleSize / 2.0;
        for(var i = 0; i < 3; i++){
            if (Math.abs(moduleSize - stateCount[i]) >= maxVariance) return false;
        }
        return true;
    };
    /**
     * <p>After a horizontal scan finds a potential alignment pattern, this method
     * "cross-checks" by scanning down vertically through the center of the possible
     * alignment pattern to see if the same proportion is detected.</p>
     *
     * @param startI row where an alignment pattern was detected
     * @param centerJ center of the section that appears to cross an alignment pattern
     * @param maxCount maximum reasonable number of modules that should be
     * observed in any reading state, based on the results of the horizontal scan
     * @return vertical center of alignment pattern, or {@link Float#NaN} if not found
     */ AlignmentPatternFinder.prototype.crossCheckVertical = function(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
        var image = this.image;
        var maxI = image.getHeight();
        var stateCount = this.crossCheckStateCount;
        stateCount[0] = 0;
        stateCount[1] = 0;
        stateCount[2] = 0;
        // Start counting up from center
        var i = startI;
        while(i >= 0 && image.get(centerJ, i) && stateCount[1] <= maxCount){
            stateCount[1]++;
            i--;
        }
        // If already too many modules in this state or ran off the edge:
        if (i < 0 || stateCount[1] > maxCount) return NaN;
        while(i >= 0 && !image.get(centerJ, i) && stateCount[0] <= maxCount){
            stateCount[0]++;
            i--;
        }
        if (stateCount[0] > maxCount) return NaN;
        // Now also count down from center
        i = startI + 1;
        while(i < maxI && image.get(centerJ, i) && stateCount[1] <= maxCount){
            stateCount[1]++;
            i++;
        }
        if (i === maxI || stateCount[1] > maxCount) return NaN;
        while(i < maxI && !image.get(centerJ, i) && stateCount[2] <= maxCount){
            stateCount[2]++;
            i++;
        }
        if (stateCount[2] > maxCount) return NaN;
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
        if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
        return this.foundPatternCross(stateCount) ? AlignmentPatternFinder.centerFromEnd(stateCount, i) : NaN;
    };
    /**
     * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
     * cross check with a vertical scan, and if successful, will see if this pattern had been
     * found on a previous horizontal scan. If so, we consider it confirmed and conclude we have
     * found the alignment pattern.</p>
     *
     * @param stateCount reading state module counts from horizontal scan
     * @param i row where alignment pattern may be found
     * @param j end of possible alignment pattern in row
     * @return {@link AlignmentPattern} if we have found the same pattern twice, or null if not
     */ AlignmentPatternFinder.prototype.handlePossibleCenter = function(stateCount, i /*int*/ , j /*int*/ ) {
        var e_1, _a;
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2];
        var centerJ = AlignmentPatternFinder.centerFromEnd(stateCount, j);
        var centerI = this.crossCheckVertical(i, /*(int) */ centerJ, 2 * stateCount[1], stateCountTotal);
        if (!isNaN(centerI)) {
            var estimatedModuleSize = (stateCount[0] + stateCount[1] + stateCount[2]) / 3.0;
            try {
                for(var _b = $6e0a4f04855d5c3e$var$__values(this.possibleCenters), _c = _b.next(); !_c.done; _c = _b.next()){
                    var center = _c.value;
                    // Look for about the same center and module size:
                    if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) return center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Hadn't found this before; save it
            var point = new (0, $kICHP.default)(centerJ, centerI, estimatedModuleSize);
            this.possibleCenters.push(point);
            if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
        }
        return null;
    };
    return AlignmentPatternFinder;
}();
var $6e0a4f04855d5c3e$export$2e2bcd8739ae039 = $6e0a4f04855d5c3e$var$AlignmentPatternFinder;

});
parcelRegister("kICHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f155f0eaa8cb2a82$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fwBMA = parcelRequire("fwBMA");
var $f155f0eaa8cb2a82$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Encapsulates an alignment pattern, which are the smaller square patterns found in
 * all but the simplest QR Codes.</p>
 *
 * @author Sean Owen
 */ var $f155f0eaa8cb2a82$var$AlignmentPattern = /** @class */ function(_super) {
    $f155f0eaa8cb2a82$var$__extends(AlignmentPattern, _super);
    function AlignmentPattern(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ ) {
        var _this = _super.call(this, posX, posY) || this;
        _this.estimatedModuleSize = estimatedModuleSize;
        return _this;
    }
    /**
     * <p>Determines if this alignment pattern "about equals" an alignment pattern at the stated
     * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
     */ AlignmentPattern.prototype.aboutEquals = function(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
        if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
            var moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
            return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
        }
        return false;
    };
    /**
     * Combines this object's current estimate of a finder pattern position and module size
     * with a new estimate. It returns a new {@code FinderPattern} containing an average of the two.
     */ AlignmentPattern.prototype.combineEstimate = function(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
        var combinedX = (this.getX() + j) / 2.0;
        var combinedY = (this.getY() + i) / 2.0;
        var combinedModuleSize = (this.estimatedModuleSize + newModuleSize) / 2.0;
        return new AlignmentPattern(combinedX, combinedY, combinedModuleSize);
    };
    return AlignmentPattern;
}((0, $fwBMA.default));
var $f155f0eaa8cb2a82$export$2e2bcd8739ae039 = $f155f0eaa8cb2a82$var$AlignmentPattern;

});


parcelRegister("hW0WN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e896939ffa8bab$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $b5DE3 = parcelRequire("b5DE3");

var $fwBMA = parcelRequire("fwBMA");

var $amxNc = parcelRequire("amxNc");

var $clXev = parcelRequire("clXev");

var $cQi30 = parcelRequire("cQi30");
var $d0e896939ffa8bab$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*import java.io.Serializable;*/ /*import java.util.ArrayList;*/ /*import java.util.Collections;*/ /*import java.util.Comparator;*/ /*import java.util.List;*/ /*import java.util.Map;*/ /**
 * <p>This class attempts to find finder patterns in a QR Code. Finder patterns are the square
 * markers at three corners of a QR Code.</p>
 *
 * <p>This class is thread-safe but not reentrant. Each thread must allocate its own object.
 *
 * @author Sean Owen
 */ var $d0e896939ffa8bab$var$FinderPatternFinder = /** @class */ function() {
    /**
     * <p>Creates a finder that will search the image for three finder patterns.</p>
     *
     * @param image image to search
     */ // public constructor(image: BitMatrix) {
    //   this(image, null)
    // }
    function FinderPatternFinder(image, resultPointCallback) {
        this.image = image;
        this.resultPointCallback = resultPointCallback;
        this.possibleCenters = [];
        this.crossCheckStateCount = new Int32Array(5);
        this.resultPointCallback = resultPointCallback;
    }
    FinderPatternFinder.prototype.getImage = function() {
        return this.image;
    };
    FinderPatternFinder.prototype.getPossibleCenters = function() {
        return this.possibleCenters;
    };
    FinderPatternFinder.prototype.find = function(hints) {
        var tryHarder = hints !== null && hints !== undefined && undefined !== hints.get((0, $b5DE3.default).TRY_HARDER);
        var pureBarcode = hints !== null && hints !== undefined && undefined !== hints.get((0, $b5DE3.default).PURE_BARCODE);
        var image = this.image;
        var maxI = image.getHeight();
        var maxJ = image.getWidth();
        // We are looking for black/white/black/white/black modules in
        // 1:1:3:1:1 ratio; this tracks the number of such modules seen so far
        // Let's assume that the maximum version QR Code we support takes up 1/4 the height of the
        // image, and then account for the center being 3 modules in size. This gives the smallest
        // number of pixels the center could be, so skip this often. When trying harder, look for all
        // QR versions regardless of how dense they are.
        var iSkip = Math.floor(3 * maxI / (4 * FinderPatternFinder.MAX_MODULES));
        if (iSkip < FinderPatternFinder.MIN_SKIP || tryHarder) iSkip = FinderPatternFinder.MIN_SKIP;
        var done = false;
        var stateCount = new Int32Array(5);
        for(var i = iSkip - 1; i < maxI && !done; i += iSkip){
            // Get a row of black/white values
            stateCount[0] = 0;
            stateCount[1] = 0;
            stateCount[2] = 0;
            stateCount[3] = 0;
            stateCount[4] = 0;
            var currentState = 0;
            for(var j = 0; j < maxJ; j++){
                if (image.get(j, i)) {
                    // Black pixel
                    if ((currentState & 1) === 1) currentState++;
                    stateCount[currentState]++;
                } else if ((currentState & 1) === 0) {
                    if (currentState === 4) {
                        if (FinderPatternFinder.foundPatternCross(stateCount)) {
                            var confirmed = this.handlePossibleCenter(stateCount, i, j, pureBarcode);
                            if (confirmed === true) {
                                // Start examining every other line. Checking each line turned out to be too
                                // expensive and didn't improve performance.
                                iSkip = 2;
                                if (this.hasSkipped === true) done = this.haveMultiplyConfirmedCenters();
                                else {
                                    var rowSkip = this.findRowSkip();
                                    if (rowSkip > stateCount[2]) {
                                        // Skip rows between row of lower confirmed center
                                        // and top of presumed third confirmed center
                                        // but back up a bit to get a full chance of detecting
                                        // it, entire width of center of finder pattern
                                        // Skip by rowSkip, but back off by stateCount[2] (size of last center
                                        // of pattern we saw) to be conservative, and also back off by iSkip which
                                        // is about to be re-added
                                        i += rowSkip - stateCount[2] - iSkip;
                                        j = maxJ - 1;
                                    }
                                }
                            } else {
                                stateCount[0] = stateCount[2];
                                stateCount[1] = stateCount[3];
                                stateCount[2] = stateCount[4];
                                stateCount[3] = 1;
                                stateCount[4] = 0;
                                currentState = 3;
                                continue;
                            }
                            // Clear state to start looking again
                            currentState = 0;
                            stateCount[0] = 0;
                            stateCount[1] = 0;
                            stateCount[2] = 0;
                            stateCount[3] = 0;
                            stateCount[4] = 0;
                        } else {
                            stateCount[0] = stateCount[2];
                            stateCount[1] = stateCount[3];
                            stateCount[2] = stateCount[4];
                            stateCount[3] = 1;
                            stateCount[4] = 0;
                            currentState = 3;
                        }
                    } else stateCount[++currentState]++;
                } else stateCount[currentState]++;
            }
            if (FinderPatternFinder.foundPatternCross(stateCount)) {
                var confirmed = this.handlePossibleCenter(stateCount, i, maxJ, pureBarcode);
                if (confirmed === true) {
                    iSkip = stateCount[0];
                    if (this.hasSkipped) // Found a third one
                    done = this.haveMultiplyConfirmedCenters();
                }
            }
        }
        var patternInfo = this.selectBestPatterns();
        (0, $fwBMA.default).orderBestPatterns(patternInfo);
        return new (0, $clXev.default)(patternInfo);
    };
    /**
     * Given a count of black/white/black/white/black pixels just seen and an end position,
     * figures the location of the center of this run.
     */ FinderPatternFinder.centerFromEnd = function(stateCount, end /*int*/ ) {
        return end - stateCount[4] - stateCount[3] - stateCount[2] / 2.0;
    };
    /**
     * @param stateCount count of black/white/black/white/black pixels just read
     * @return true iff the proportions of the counts is close enough to the 1/1/3/1/1 ratios
     *         used by finder patterns to be considered a match
     */ FinderPatternFinder.foundPatternCross = function(stateCount) {
        var totalModuleSize = 0;
        for(var i = 0; i < 5; i++){
            var count = stateCount[i];
            if (count === 0) return false;
            totalModuleSize += count;
        }
        if (totalModuleSize < 7) return false;
        var moduleSize = totalModuleSize / 7.0;
        var maxVariance = moduleSize / 2.0;
        // Allow less than 50% variance from 1-1-3-1-1 proportions
        return Math.abs(moduleSize - stateCount[0]) < maxVariance && Math.abs(moduleSize - stateCount[1]) < maxVariance && Math.abs(3.0 * moduleSize - stateCount[2]) < 3 * maxVariance && Math.abs(moduleSize - stateCount[3]) < maxVariance && Math.abs(moduleSize - stateCount[4]) < maxVariance;
    };
    FinderPatternFinder.prototype.getCrossCheckStateCount = function() {
        var crossCheckStateCount = this.crossCheckStateCount;
        crossCheckStateCount[0] = 0;
        crossCheckStateCount[1] = 0;
        crossCheckStateCount[2] = 0;
        crossCheckStateCount[3] = 0;
        crossCheckStateCount[4] = 0;
        return crossCheckStateCount;
    };
    /**
     * After a vertical and horizontal scan finds a potential finder pattern, this method
     * "cross-cross-cross-checks" by scanning down diagonally through the center of the possible
     * finder pattern to see if the same proportion is detected.
     *
     * @param startI row where a finder pattern was detected
     * @param centerJ center of the section that appears to cross a finder pattern
     * @param maxCount maximum reasonable number of modules that should be
     *  observed in any reading state, based on the results of the horizontal scan
     * @param originalStateCountTotal The original state count total.
     * @return true if proportions are withing expected limits
     */ FinderPatternFinder.prototype.crossCheckDiagonal = function(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
        var stateCount = this.getCrossCheckStateCount();
        // Start counting up, left from center finding black center mass
        var i = 0;
        var image = this.image;
        while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i)){
            stateCount[2]++;
            i++;
        }
        if (startI < i || centerJ < i) return false;
        // Continue up, left finding white space
        while(startI >= i && centerJ >= i && !image.get(centerJ - i, startI - i) && stateCount[1] <= maxCount){
            stateCount[1]++;
            i++;
        }
        // If already too many modules in this state or ran off the edge:
        if (startI < i || centerJ < i || stateCount[1] > maxCount) return false;
        // Continue up, left finding black border
        while(startI >= i && centerJ >= i && image.get(centerJ - i, startI - i) && stateCount[0] <= maxCount){
            stateCount[0]++;
            i++;
        }
        if (stateCount[0] > maxCount) return false;
        var maxI = image.getHeight();
        var maxJ = image.getWidth();
        // Now also count down, right from center
        i = 1;
        while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i)){
            stateCount[2]++;
            i++;
        }
        // Ran off the edge?
        if (startI + i >= maxI || centerJ + i >= maxJ) return false;
        while(startI + i < maxI && centerJ + i < maxJ && !image.get(centerJ + i, startI + i) && stateCount[3] < maxCount){
            stateCount[3]++;
            i++;
        }
        if (startI + i >= maxI || centerJ + i >= maxJ || stateCount[3] >= maxCount) return false;
        while(startI + i < maxI && centerJ + i < maxJ && image.get(centerJ + i, startI + i) && stateCount[4] < maxCount){
            stateCount[4]++;
            i++;
        }
        if (stateCount[4] >= maxCount) return false;
        // If we found a finder-pattern-like section, but its size is more than 100% different than
        // the original, assume it's a false positive
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        return Math.abs(stateCountTotal - originalStateCountTotal) < 2 * originalStateCountTotal && FinderPatternFinder.foundPatternCross(stateCount);
    };
    /**
     * <p>After a horizontal scan finds a potential finder pattern, this method
     * "cross-checks" by scanning down vertically through the center of the possible
     * finder pattern to see if the same proportion is detected.</p>
     *
     * @param startI row where a finder pattern was detected
     * @param centerJ center of the section that appears to cross a finder pattern
     * @param maxCount maximum reasonable number of modules that should be
     * observed in any reading state, based on the results of the horizontal scan
     * @return vertical center of finder pattern, or {@link Float#NaN} if not found
     */ FinderPatternFinder.prototype.crossCheckVertical = function(startI /*int*/ , centerJ /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
        var image = this.image;
        var maxI = image.getHeight();
        var stateCount = this.getCrossCheckStateCount();
        // Start counting up from center
        var i = startI;
        while(i >= 0 && image.get(centerJ, i)){
            stateCount[2]++;
            i--;
        }
        if (i < 0) return NaN;
        while(i >= 0 && !image.get(centerJ, i) && stateCount[1] <= maxCount){
            stateCount[1]++;
            i--;
        }
        // If already too many modules in this state or ran off the edge:
        if (i < 0 || stateCount[1] > maxCount) return NaN;
        while(i >= 0 && image.get(centerJ, i) && stateCount[0] <= maxCount){
            stateCount[0]++;
            i--;
        }
        if (stateCount[0] > maxCount) return NaN;
        // Now also count down from center
        i = startI + 1;
        while(i < maxI && image.get(centerJ, i)){
            stateCount[2]++;
            i++;
        }
        if (i === maxI) return NaN;
        while(i < maxI && !image.get(centerJ, i) && stateCount[3] < maxCount){
            stateCount[3]++;
            i++;
        }
        if (i === maxI || stateCount[3] >= maxCount) return NaN;
        while(i < maxI && image.get(centerJ, i) && stateCount[4] < maxCount){
            stateCount[4]++;
            i++;
        }
        if (stateCount[4] >= maxCount) return NaN;
        // If we found a finder-pattern-like section, but its size is more than 40% different than
        // the original, assume it's a false positive
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= 2 * originalStateCountTotal) return NaN;
        return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, i) : NaN;
    };
    /**
     * <p>Like {@link #crossCheckVertical(int, int, int, int)}, and in fact is basically identical,
     * except it reads horizontally instead of vertically. This is used to cross-cross
     * check a vertical cross check and locate the real center of the alignment pattern.</p>
     */ FinderPatternFinder.prototype.crossCheckHorizontal = function(startJ /*int*/ , centerI /*int*/ , maxCount /*int*/ , originalStateCountTotal /*int*/ ) {
        var image = this.image;
        var maxJ = image.getWidth();
        var stateCount = this.getCrossCheckStateCount();
        var j = startJ;
        while(j >= 0 && image.get(j, centerI)){
            stateCount[2]++;
            j--;
        }
        if (j < 0) return NaN;
        while(j >= 0 && !image.get(j, centerI) && stateCount[1] <= maxCount){
            stateCount[1]++;
            j--;
        }
        if (j < 0 || stateCount[1] > maxCount) return NaN;
        while(j >= 0 && image.get(j, centerI) && stateCount[0] <= maxCount){
            stateCount[0]++;
            j--;
        }
        if (stateCount[0] > maxCount) return NaN;
        j = startJ + 1;
        while(j < maxJ && image.get(j, centerI)){
            stateCount[2]++;
            j++;
        }
        if (j === maxJ) return NaN;
        while(j < maxJ && !image.get(j, centerI) && stateCount[3] < maxCount){
            stateCount[3]++;
            j++;
        }
        if (j === maxJ || stateCount[3] >= maxCount) return NaN;
        while(j < maxJ && image.get(j, centerI) && stateCount[4] < maxCount){
            stateCount[4]++;
            j++;
        }
        if (stateCount[4] >= maxCount) return NaN;
        // If we found a finder-pattern-like section, but its size is significantly different than
        // the original, assume it's a false positive
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        if (5 * Math.abs(stateCountTotal - originalStateCountTotal) >= originalStateCountTotal) return NaN;
        return FinderPatternFinder.foundPatternCross(stateCount) ? FinderPatternFinder.centerFromEnd(stateCount, j) : NaN;
    };
    /**
     * <p>This is called when a horizontal scan finds a possible alignment pattern. It will
     * cross check with a vertical scan, and if successful, will, ah, cross-cross-check
     * with another horizontal scan. This is needed primarily to locate the real horizontal
     * center of the pattern in cases of extreme skew.
     * And then we cross-cross-cross check with another diagonal scan.</p>
     *
     * <p>If that succeeds the finder pattern location is added to a list that tracks
     * the number of times each location has been nearly-matched as a finder pattern.
     * Each additional find is more evidence that the location is in fact a finder
     * pattern center
     *
     * @param stateCount reading state module counts from horizontal scan
     * @param i row where finder pattern may be found
     * @param j end of possible finder pattern in row
     * @param pureBarcode true if in "pure barcode" mode
     * @return true if a finder pattern candidate was found this time
     */ FinderPatternFinder.prototype.handlePossibleCenter = function(stateCount, i /*int*/ , j /*int*/ , pureBarcode) {
        var stateCountTotal = stateCount[0] + stateCount[1] + stateCount[2] + stateCount[3] + stateCount[4];
        var centerJ = FinderPatternFinder.centerFromEnd(stateCount, j);
        var centerI = this.crossCheckVertical(i, /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal);
        if (!isNaN(centerI)) {
            // Re-cross check
            centerJ = this.crossCheckHorizontal(/*(int) */ Math.floor(centerJ), /*(int) */ Math.floor(centerI), stateCount[2], stateCountTotal);
            if (!isNaN(centerJ) && (!pureBarcode || this.crossCheckDiagonal(/*(int) */ Math.floor(centerI), /*(int) */ Math.floor(centerJ), stateCount[2], stateCountTotal))) {
                var estimatedModuleSize = stateCountTotal / 7.0;
                var found = false;
                var possibleCenters = this.possibleCenters;
                for(var index = 0, length_1 = possibleCenters.length; index < length_1; index++){
                    var center = possibleCenters[index];
                    // Look for about the same center and module size:
                    if (center.aboutEquals(estimatedModuleSize, centerI, centerJ)) {
                        possibleCenters[index] = center.combineEstimate(centerI, centerJ, estimatedModuleSize);
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    var point = new (0, $amxNc.default)(centerJ, centerI, estimatedModuleSize);
                    possibleCenters.push(point);
                    if (this.resultPointCallback !== null && this.resultPointCallback !== undefined) this.resultPointCallback.foundPossibleResultPoint(point);
                }
                return true;
            }
        }
        return false;
    };
    /**
     * @return number of rows we could safely skip during scanning, based on the first
     *         two finder patterns that have been located. In some cases their position will
     *         allow us to infer that the third pattern must lie below a certain point farther
     *         down in the image.
     */ FinderPatternFinder.prototype.findRowSkip = function() {
        var e_1, _a;
        var max = this.possibleCenters.length;
        if (max <= 1) return 0;
        var firstConfirmedCenter = null;
        try {
            for(var _b = $d0e896939ffa8bab$var$__values(this.possibleCenters), _c = _b.next(); !_c.done; _c = _b.next()){
                var center = _c.value;
                if (center.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                    if (firstConfirmedCenter == null) firstConfirmedCenter = center;
                    else {
                        // We have two confirmed centers
                        // How far down can we skip before resuming looking for the next
                        // pattern? In the worst case, only the difference between the
                        // difference in the x / y coordinates of the two centers.
                        // This is the case where you find top left last.
                        this.hasSkipped = true;
                        return /*(int) */ Math.floor((Math.abs(firstConfirmedCenter.getX() - center.getX()) - Math.abs(firstConfirmedCenter.getY() - center.getY())) / 2);
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return 0;
    };
    /**
     * @return true iff we have found at least 3 finder patterns that have been detected
     *         at least {@link #CENTER_QUORUM} times each, and, the estimated module size of the
     *         candidates is "pretty similar"
     */ FinderPatternFinder.prototype.haveMultiplyConfirmedCenters = function() {
        var e_2, _a, e_3, _b;
        var confirmedCount = 0;
        var totalModuleSize = 0.0;
        var max = this.possibleCenters.length;
        try {
            for(var _c = $d0e896939ffa8bab$var$__values(this.possibleCenters), _d = _c.next(); !_d.done; _d = _c.next()){
                var pattern = _d.value;
                if (pattern.getCount() >= FinderPatternFinder.CENTER_QUORUM) {
                    confirmedCount++;
                    totalModuleSize += pattern.getEstimatedModuleSize();
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        if (confirmedCount < 3) return false;
        // OK, we have at least 3 confirmed centers, but, it's possible that one is a "false positive"
        // and that we need to keep looking. We detect this by asking if the estimated module sizes
        // vary too much. We arbitrarily say that when the total deviation from average exceeds
        // 5% of the total module size estimates, it's too much.
        var average = totalModuleSize / max;
        var totalDeviation = 0.0;
        try {
            for(var _e = $d0e896939ffa8bab$var$__values(this.possibleCenters), _f = _e.next(); !_f.done; _f = _e.next()){
                var pattern = _f.value;
                totalDeviation += Math.abs(pattern.getEstimatedModuleSize() - average);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return totalDeviation <= 0.05 * totalModuleSize;
    };
    /**
     * @return the 3 best {@link FinderPattern}s from our list of candidates. The "best" are
     *         those that have been detected at least {@link #CENTER_QUORUM} times, and whose module
     *         size differs from the average among those patterns the least
     * @throws NotFoundException if 3 such finder patterns do not exist
     */ FinderPatternFinder.prototype.selectBestPatterns = function() {
        var e_4, _a, e_5, _b;
        var startSize = this.possibleCenters.length;
        if (startSize < 3) // Couldn't find enough finder patterns
        throw new (0, $cQi30.default)();
        var possibleCenters = this.possibleCenters;
        var average;
        // Filter outlier possibilities whose module size is too different
        if (startSize > 3) {
            // But we can only afford to do so if we have at least 4 possibilities to choose from
            var totalModuleSize = 0.0;
            var square = 0.0;
            try {
                for(var _c = $d0e896939ffa8bab$var$__values(this.possibleCenters), _d = _c.next(); !_d.done; _d = _c.next()){
                    var center = _d.value;
                    var size = center.getEstimatedModuleSize();
                    totalModuleSize += size;
                    square += size * size;
                }
            } catch (e_4_1) {
                e_4 = {
                    error: e_4_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_4) throw e_4.error;
                }
            }
            average = totalModuleSize / startSize;
            var stdDev = Math.sqrt(square / startSize - average * average);
            possibleCenters.sort(/**
             * <p>Orders by furthest from average</p>
             */ // FurthestFromAverageComparator implements Comparator<FinderPattern>
            function(center1, center2) {
                var dA = Math.abs(center2.getEstimatedModuleSize() - average);
                var dB = Math.abs(center1.getEstimatedModuleSize() - average);
                return dA < dB ? -1 : dA > dB ? 1 : 0;
            });
            var limit = Math.max(0.2 * average, stdDev);
            for(var i = 0; i < possibleCenters.length && possibleCenters.length > 3; i++){
                var pattern = possibleCenters[i];
                if (Math.abs(pattern.getEstimatedModuleSize() - average) > limit) {
                    possibleCenters.splice(i, 1);
                    i--;
                }
            }
        }
        if (possibleCenters.length > 3) {
            // Throw away all but those first size candidate points we found.
            var totalModuleSize = 0.0;
            try {
                for(var possibleCenters_1 = $d0e896939ffa8bab$var$__values(possibleCenters), possibleCenters_1_1 = possibleCenters_1.next(); !possibleCenters_1_1.done; possibleCenters_1_1 = possibleCenters_1.next()){
                    var possibleCenter = possibleCenters_1_1.value;
                    totalModuleSize += possibleCenter.getEstimatedModuleSize();
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (possibleCenters_1_1 && !possibleCenters_1_1.done && (_b = possibleCenters_1.return)) _b.call(possibleCenters_1);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            average = totalModuleSize / possibleCenters.length;
            possibleCenters.sort(/**
             * <p>Orders by {@link FinderPattern#getCount()}, descending.</p>
             */ // CenterComparator implements Comparator<FinderPattern>
            function(center1, center2) {
                if (center2.getCount() === center1.getCount()) {
                    var dA = Math.abs(center2.getEstimatedModuleSize() - average);
                    var dB = Math.abs(center1.getEstimatedModuleSize() - average);
                    return dA < dB ? 1 : dA > dB ? -1 : 0;
                } else return center2.getCount() - center1.getCount();
            });
            possibleCenters.splice(3); // this is not realy necessary as we only return first 3 anyway
        }
        return [
            possibleCenters[0],
            possibleCenters[1],
            possibleCenters[2]
        ];
    };
    FinderPatternFinder.CENTER_QUORUM = 2;
    FinderPatternFinder.MIN_SKIP = 3; // 1 pixel/module times 3 modules/center
    FinderPatternFinder.MAX_MODULES = 57; // support up to version 10 for mobile clients
    return FinderPatternFinder;
}();
var $d0e896939ffa8bab$export$2e2bcd8739ae039 = $d0e896939ffa8bab$var$FinderPatternFinder;

});
parcelRegister("amxNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $78b62bf990b44d14$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fwBMA = parcelRequire("fwBMA");
var $78b62bf990b44d14$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>Encapsulates a finder pattern, which are the three square patterns found in
 * the corners of QR Codes. It also encapsulates a count of similar finder patterns,
 * as a convenience to the finder's bookkeeping.</p>
 *
 * @author Sean Owen
 */ var $78b62bf990b44d14$var$FinderPattern = /** @class */ function(_super) {
    $78b62bf990b44d14$var$__extends(FinderPattern, _super);
    // FinderPattern(posX: number/*float*/, posY: number/*float*/, estimatedModuleSize: number/*float*/) {
    //   this(posX, posY, estimatedModuleSize, 1)
    // }
    function FinderPattern(posX /*float*/ , posY /*float*/ , estimatedModuleSize /*float*/ , count /*int*/ ) {
        var _this = _super.call(this, posX, posY) || this;
        _this.estimatedModuleSize = estimatedModuleSize;
        _this.count = count;
        if (undefined === count) _this.count = 1;
        return _this;
    }
    FinderPattern.prototype.getEstimatedModuleSize = function() {
        return this.estimatedModuleSize;
    };
    FinderPattern.prototype.getCount = function() {
        return this.count;
    };
    /*
    void incrementCount() {
      this.count++
    }
     */ /**
     * <p>Determines if this finder pattern "about equals" a finder pattern at the stated
     * position and size -- meaning, it is at nearly the same center with nearly the same size.</p>
     */ FinderPattern.prototype.aboutEquals = function(moduleSize /*float*/ , i /*float*/ , j /*float*/ ) {
        if (Math.abs(i - this.getY()) <= moduleSize && Math.abs(j - this.getX()) <= moduleSize) {
            var moduleSizeDiff = Math.abs(moduleSize - this.estimatedModuleSize);
            return moduleSizeDiff <= 1.0 || moduleSizeDiff <= this.estimatedModuleSize;
        }
        return false;
    };
    /**
     * Combines this object's current estimate of a finder pattern position and module size
     * with a new estimate. It returns a new {@code FinderPattern} containing a weighted average
     * based on count.
     */ FinderPattern.prototype.combineEstimate = function(i /*float*/ , j /*float*/ , newModuleSize /*float*/ ) {
        var combinedCount = this.count + 1;
        var combinedX = (this.count * this.getX() + j) / combinedCount;
        var combinedY = (this.count * this.getY() + i) / combinedCount;
        var combinedModuleSize = (this.count * this.estimatedModuleSize + newModuleSize) / combinedCount;
        return new FinderPattern(combinedX, combinedY, combinedModuleSize, combinedCount);
    };
    return FinderPattern;
}((0, $fwBMA.default));
var $78b62bf990b44d14$export$2e2bcd8739ae039 = $78b62bf990b44d14$var$FinderPattern;

});

parcelRegister("clXev", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe564a632f89474$export$2e2bcd8739ae039);
/*
 * Copyright 2007 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * <p>Encapsulates information about finder patterns in an image, including the location of
 * the three finder patterns, and their estimated module size.</p>
 *
 * @author Sean Owen
 */ var $8fe564a632f89474$var$FinderPatternInfo = /** @class */ function() {
    function FinderPatternInfo(patternCenters) {
        this.bottomLeft = patternCenters[0];
        this.topLeft = patternCenters[1];
        this.topRight = patternCenters[2];
    }
    FinderPatternInfo.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    };
    FinderPatternInfo.prototype.getTopLeft = function() {
        return this.topLeft;
    };
    FinderPatternInfo.prototype.getTopRight = function() {
        return this.topRight;
    };
    return FinderPatternInfo;
}();
var $8fe564a632f89474$export$2e2bcd8739ae039 = $8fe564a632f89474$var$FinderPatternInfo;

});




parcelRegister("7G1W6", function(module, exports) {

$parcel$export(module.exports, "default", () => $596df51dbcf87ee1$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bx5V3 = parcelRequire("bx5V3");

var $9Nn2d = parcelRequire("9Nn2d");

var $dtgr5 = parcelRequire("dtgr5");

var $cQi30 = parcelRequire("cQi30");

var $kWndQ = parcelRequire("kWndQ");

var $jXATC = parcelRequire("jXATC");

var $hcAg4 = parcelRequire("hcAg4");

var $eS8qc = parcelRequire("eS8qc");

var $lGVVH = parcelRequire("lGVVH");

var $23suV = parcelRequire("23suV");
var $596df51dbcf87ee1$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import java.util.ArrayList;
// import java.util.List;
// import java.util.Map;
/**
 * This implementation can detect and decode PDF417 codes in an image.
 *
 * @author Guenther Grau
 */ var $596df51dbcf87ee1$var$PDF417Reader = /** @class */ function() {
    function PDF417Reader() {}
    // private static /*final Result[]*/ EMPTY_RESULT_ARRAY: Result[] = new Result([0]);
    /**
     * Locates and decodes a PDF417 code in an image.
     *
     * @return a String representing the content encoded by the PDF417 code
     * @throws NotFoundException if a PDF417 code cannot be found,
     * @throws FormatException if a PDF417 cannot be decoded
     * @throws ChecksumException
     */ // @Override
    PDF417Reader.prototype.decode = function(image, hints) {
        if (hints === void 0) hints = null;
        var result = PDF417Reader.decode(image, hints, false);
        if (result == null || result.length === 0 || result[0] == null) throw (0, $cQi30.default).getNotFoundInstance();
        return result[0];
    };
    /**
     *
     * @param BinaryBitmap
     * @param image
     * @throws NotFoundException
     */ //   @Override
    PDF417Reader.prototype.decodeMultiple = function(image, hints) {
        if (hints === void 0) hints = null;
        try {
            return PDF417Reader.decode(image, hints, true);
        } catch (ignored) {
            if (ignored instanceof (0, $dtgr5.default) || ignored instanceof (0, $9Nn2d.default)) throw (0, $cQi30.default).getNotFoundInstance();
            throw ignored;
        }
    };
    /**
     *
     * @param image
     * @param hints
     * @param multiple
     *
     * @throws NotFoundException
     * @throws FormatExceptionß
     * @throws ChecksumException
     */ PDF417Reader.decode = function(image, hints, multiple) {
        var e_1, _a;
        var results = new Array();
        var detectorResult = (0, $lGVVH.default).detectMultiple(image, hints, multiple);
        try {
            for(var _b = $596df51dbcf87ee1$var$__values(detectorResult.getPoints()), _c = _b.next(); !_c.done; _c = _b.next()){
                var points = _c.value;
                var decoderResult = (0, $23suV.default).decode(detectorResult.getBits(), points[4], points[5], points[6], points[7], PDF417Reader.getMinCodewordWidth(points), PDF417Reader.getMaxCodewordWidth(points));
                var result = new (0, $kWndQ.default)(decoderResult.getText(), decoderResult.getRawBytes(), undefined, points, (0, $bx5V3.default).PDF_417);
                result.putMetadata((0, $eS8qc.default).ERROR_CORRECTION_LEVEL, decoderResult.getECLevel());
                var pdf417ResultMetadata = decoderResult.getOther();
                if (pdf417ResultMetadata != null) result.putMetadata((0, $eS8qc.default).PDF417_EXTRA_METADATA, pdf417ResultMetadata);
                results.push(result);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return results.map(function(x) {
            return x;
        });
    };
    PDF417Reader.getMaxWidth = function(p1, p2) {
        if (p1 == null || p2 == null) return 0;
        return Math.trunc(Math.abs(p1.getX() - p2.getX()));
    };
    PDF417Reader.getMinWidth = function(p1, p2) {
        if (p1 == null || p2 == null) return (0, $hcAg4.default).MAX_VALUE;
        return Math.trunc(Math.abs(p1.getX() - p2.getX()));
    };
    PDF417Reader.getMaxCodewordWidth = function(p) {
        return Math.floor(Math.max(Math.max(PDF417Reader.getMaxWidth(p[0], p[4]), PDF417Reader.getMaxWidth(p[6], p[2]) * (0, $jXATC.default).MODULES_IN_CODEWORD / (0, $jXATC.default).MODULES_IN_STOP_PATTERN), Math.max(PDF417Reader.getMaxWidth(p[1], p[5]), PDF417Reader.getMaxWidth(p[7], p[3]) * (0, $jXATC.default).MODULES_IN_CODEWORD / (0, $jXATC.default).MODULES_IN_STOP_PATTERN)));
    };
    PDF417Reader.getMinCodewordWidth = function(p) {
        return Math.floor(Math.min(Math.min(PDF417Reader.getMinWidth(p[0], p[4]), PDF417Reader.getMinWidth(p[6], p[2]) * (0, $jXATC.default).MODULES_IN_CODEWORD / (0, $jXATC.default).MODULES_IN_STOP_PATTERN), Math.min(PDF417Reader.getMinWidth(p[1], p[5]), PDF417Reader.getMinWidth(p[7], p[3]) * (0, $jXATC.default).MODULES_IN_CODEWORD / (0, $jXATC.default).MODULES_IN_STOP_PATTERN)));
    };
    // @Override
    PDF417Reader.prototype.reset = function() {
    // nothing needs to be reset
    };
    return PDF417Reader;
}();
var $596df51dbcf87ee1$export$2e2bcd8739ae039 = $596df51dbcf87ee1$var$PDF417Reader;

});
parcelRegister("jXATC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88025cac1820ce7$export$2e2bcd8739ae039);
/*
* Copyright 2009 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // package com.google.zxing.pdf417;

var $iYwLM = parcelRequire("iYwLM");

var $fbOCK = parcelRequire("fbOCK");
var $e88025cac1820ce7$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author SITA Lab (kevin.osullivan@sita.aero)
 * @author Guenther Grau
 */ var $e88025cac1820ce7$var$PDF417Common = /** @class */ function() {
    function PDF417Common() {}
    PDF417Common.prototype.PDF417Common = function() {};
    /**
     * @param moduleBitCount values to sum
     * @return sum of values
     * @deprecated call {@link MathUtils#sum(int[])}
     */ // @Deprecated
    PDF417Common.getBitCountSum = function(moduleBitCount) {
        return (0, $fbOCK.default).sum(moduleBitCount);
    };
    PDF417Common.toIntArray = function(list) {
        var e_1, _a;
        if (list == null || !list.length) return PDF417Common.EMPTY_INT_ARRAY;
        var result = new Int32Array(list.length);
        var i = 0;
        try {
            for(var list_1 = $e88025cac1820ce7$var$__values(list), list_1_1 = list_1.next(); !list_1_1.done; list_1_1 = list_1.next()){
                var integer = list_1_1.value;
                result[i++] = integer;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (list_1_1 && !list_1_1.done && (_a = list_1.return)) _a.call(list_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return result;
    };
    /**
     * @param symbol encoded symbol to translate to a codeword
     * @return the codeword corresponding to the symbol.
     */ PDF417Common.getCodeword = function(symbol /*int*/ ) {
        var i = (0, $iYwLM.default).binarySearch(PDF417Common.SYMBOL_TABLE, symbol & 0x3FFFF);
        if (i < 0) return -1;
        return (PDF417Common.CODEWORD_TABLE[i] - 1) % PDF417Common.NUMBER_OF_CODEWORDS;
    };
    PDF417Common.NUMBER_OF_CODEWORDS = 929;
    // Maximum Codewords (Data + Error).
    PDF417Common.MAX_CODEWORDS_IN_BARCODE = PDF417Common.NUMBER_OF_CODEWORDS - 1;
    PDF417Common.MIN_ROWS_IN_BARCODE = 3;
    PDF417Common.MAX_ROWS_IN_BARCODE = 90;
    // One left row indication column + max 30 data columns + one right row indicator column
    // public static /*final*/ MAX_CODEWORDS_IN_ROW: /*int*/ number = 32;
    PDF417Common.MODULES_IN_CODEWORD = 17;
    PDF417Common.MODULES_IN_STOP_PATTERN = 18;
    PDF417Common.BARS_IN_MODULE = 8;
    PDF417Common.EMPTY_INT_ARRAY = new Int32Array([]);
    /**
     * The sorted table of all possible symbols. Extracted from the PDF417
     * specification. The index of a symbol in this table corresponds to the
     * index into the codeword table.
     */ PDF417Common.SYMBOL_TABLE = Int32Array.from([
        0x1025e,
        0x1027a,
        0x1029e,
        0x102bc,
        0x102f2,
        0x102f4,
        0x1032e,
        0x1034e,
        0x1035c,
        0x10396,
        0x103a6,
        0x103ac,
        0x10422,
        0x10428,
        0x10436,
        0x10442,
        0x10444,
        0x10448,
        0x10450,
        0x1045e,
        0x10466,
        0x1046c,
        0x1047a,
        0x10482,
        0x1049e,
        0x104a0,
        0x104bc,
        0x104c6,
        0x104d8,
        0x104ee,
        0x104f2,
        0x104f4,
        0x10504,
        0x10508,
        0x10510,
        0x1051e,
        0x10520,
        0x1053c,
        0x10540,
        0x10578,
        0x10586,
        0x1058c,
        0x10598,
        0x105b0,
        0x105be,
        0x105ce,
        0x105dc,
        0x105e2,
        0x105e4,
        0x105e8,
        0x105f6,
        0x1062e,
        0x1064e,
        0x1065c,
        0x1068e,
        0x1069c,
        0x106b8,
        0x106de,
        0x106fa,
        0x10716,
        0x10726,
        0x1072c,
        0x10746,
        0x1074c,
        0x10758,
        0x1076e,
        0x10792,
        0x10794,
        0x107a2,
        0x107a4,
        0x107a8,
        0x107b6,
        0x10822,
        0x10828,
        0x10842,
        0x10848,
        0x10850,
        0x1085e,
        0x10866,
        0x1086c,
        0x1087a,
        0x10882,
        0x10884,
        0x10890,
        0x1089e,
        0x108a0,
        0x108bc,
        0x108c6,
        0x108cc,
        0x108d8,
        0x108ee,
        0x108f2,
        0x108f4,
        0x10902,
        0x10908,
        0x1091e,
        0x10920,
        0x1093c,
        0x10940,
        0x10978,
        0x10986,
        0x10998,
        0x109b0,
        0x109be,
        0x109ce,
        0x109dc,
        0x109e2,
        0x109e4,
        0x109e8,
        0x109f6,
        0x10a08,
        0x10a10,
        0x10a1e,
        0x10a20,
        0x10a3c,
        0x10a40,
        0x10a78,
        0x10af0,
        0x10b06,
        0x10b0c,
        0x10b18,
        0x10b30,
        0x10b3e,
        0x10b60,
        0x10b7c,
        0x10b8e,
        0x10b9c,
        0x10bb8,
        0x10bc2,
        0x10bc4,
        0x10bc8,
        0x10bd0,
        0x10bde,
        0x10be6,
        0x10bec,
        0x10c2e,
        0x10c4e,
        0x10c5c,
        0x10c62,
        0x10c64,
        0x10c68,
        0x10c76,
        0x10c8e,
        0x10c9c,
        0x10cb8,
        0x10cc2,
        0x10cc4,
        0x10cc8,
        0x10cd0,
        0x10cde,
        0x10ce6,
        0x10cec,
        0x10cfa,
        0x10d0e,
        0x10d1c,
        0x10d38,
        0x10d70,
        0x10d7e,
        0x10d82,
        0x10d84,
        0x10d88,
        0x10d90,
        0x10d9e,
        0x10da0,
        0x10dbc,
        0x10dc6,
        0x10dcc,
        0x10dd8,
        0x10dee,
        0x10df2,
        0x10df4,
        0x10e16,
        0x10e26,
        0x10e2c,
        0x10e46,
        0x10e58,
        0x10e6e,
        0x10e86,
        0x10e8c,
        0x10e98,
        0x10eb0,
        0x10ebe,
        0x10ece,
        0x10edc,
        0x10f0a,
        0x10f12,
        0x10f14,
        0x10f22,
        0x10f28,
        0x10f36,
        0x10f42,
        0x10f44,
        0x10f48,
        0x10f50,
        0x10f5e,
        0x10f66,
        0x10f6c,
        0x10fb2,
        0x10fb4,
        0x11022,
        0x11028,
        0x11042,
        0x11048,
        0x11050,
        0x1105e,
        0x1107a,
        0x11082,
        0x11084,
        0x11090,
        0x1109e,
        0x110a0,
        0x110bc,
        0x110c6,
        0x110cc,
        0x110d8,
        0x110ee,
        0x110f2,
        0x110f4,
        0x11102,
        0x1111e,
        0x11120,
        0x1113c,
        0x11140,
        0x11178,
        0x11186,
        0x11198,
        0x111b0,
        0x111be,
        0x111ce,
        0x111dc,
        0x111e2,
        0x111e4,
        0x111e8,
        0x111f6,
        0x11208,
        0x1121e,
        0x11220,
        0x11278,
        0x112f0,
        0x1130c,
        0x11330,
        0x1133e,
        0x11360,
        0x1137c,
        0x1138e,
        0x1139c,
        0x113b8,
        0x113c2,
        0x113c8,
        0x113d0,
        0x113de,
        0x113e6,
        0x113ec,
        0x11408,
        0x11410,
        0x1141e,
        0x11420,
        0x1143c,
        0x11440,
        0x11478,
        0x114f0,
        0x115e0,
        0x1160c,
        0x11618,
        0x11630,
        0x1163e,
        0x11660,
        0x1167c,
        0x116c0,
        0x116f8,
        0x1171c,
        0x11738,
        0x11770,
        0x1177e,
        0x11782,
        0x11784,
        0x11788,
        0x11790,
        0x1179e,
        0x117a0,
        0x117bc,
        0x117c6,
        0x117cc,
        0x117d8,
        0x117ee,
        0x1182e,
        0x11834,
        0x1184e,
        0x1185c,
        0x11862,
        0x11864,
        0x11868,
        0x11876,
        0x1188e,
        0x1189c,
        0x118b8,
        0x118c2,
        0x118c8,
        0x118d0,
        0x118de,
        0x118e6,
        0x118ec,
        0x118fa,
        0x1190e,
        0x1191c,
        0x11938,
        0x11970,
        0x1197e,
        0x11982,
        0x11984,
        0x11990,
        0x1199e,
        0x119a0,
        0x119bc,
        0x119c6,
        0x119cc,
        0x119d8,
        0x119ee,
        0x119f2,
        0x119f4,
        0x11a0e,
        0x11a1c,
        0x11a38,
        0x11a70,
        0x11a7e,
        0x11ae0,
        0x11afc,
        0x11b08,
        0x11b10,
        0x11b1e,
        0x11b20,
        0x11b3c,
        0x11b40,
        0x11b78,
        0x11b8c,
        0x11b98,
        0x11bb0,
        0x11bbe,
        0x11bce,
        0x11bdc,
        0x11be2,
        0x11be4,
        0x11be8,
        0x11bf6,
        0x11c16,
        0x11c26,
        0x11c2c,
        0x11c46,
        0x11c4c,
        0x11c58,
        0x11c6e,
        0x11c86,
        0x11c98,
        0x11cb0,
        0x11cbe,
        0x11cce,
        0x11cdc,
        0x11ce2,
        0x11ce4,
        0x11ce8,
        0x11cf6,
        0x11d06,
        0x11d0c,
        0x11d18,
        0x11d30,
        0x11d3e,
        0x11d60,
        0x11d7c,
        0x11d8e,
        0x11d9c,
        0x11db8,
        0x11dc4,
        0x11dc8,
        0x11dd0,
        0x11dde,
        0x11de6,
        0x11dec,
        0x11dfa,
        0x11e0a,
        0x11e12,
        0x11e14,
        0x11e22,
        0x11e24,
        0x11e28,
        0x11e36,
        0x11e42,
        0x11e44,
        0x11e50,
        0x11e5e,
        0x11e66,
        0x11e6c,
        0x11e82,
        0x11e84,
        0x11e88,
        0x11e90,
        0x11e9e,
        0x11ea0,
        0x11ebc,
        0x11ec6,
        0x11ecc,
        0x11ed8,
        0x11eee,
        0x11f1a,
        0x11f2e,
        0x11f32,
        0x11f34,
        0x11f4e,
        0x11f5c,
        0x11f62,
        0x11f64,
        0x11f68,
        0x11f76,
        0x12048,
        0x1205e,
        0x12082,
        0x12084,
        0x12090,
        0x1209e,
        0x120a0,
        0x120bc,
        0x120d8,
        0x120f2,
        0x120f4,
        0x12108,
        0x1211e,
        0x12120,
        0x1213c,
        0x12140,
        0x12178,
        0x12186,
        0x12198,
        0x121b0,
        0x121be,
        0x121e2,
        0x121e4,
        0x121e8,
        0x121f6,
        0x12204,
        0x12210,
        0x1221e,
        0x12220,
        0x12278,
        0x122f0,
        0x12306,
        0x1230c,
        0x12330,
        0x1233e,
        0x12360,
        0x1237c,
        0x1238e,
        0x1239c,
        0x123b8,
        0x123c2,
        0x123c8,
        0x123d0,
        0x123e6,
        0x123ec,
        0x1241e,
        0x12420,
        0x1243c,
        0x124f0,
        0x125e0,
        0x12618,
        0x1263e,
        0x12660,
        0x1267c,
        0x126c0,
        0x126f8,
        0x12738,
        0x12770,
        0x1277e,
        0x12782,
        0x12784,
        0x12790,
        0x1279e,
        0x127a0,
        0x127bc,
        0x127c6,
        0x127cc,
        0x127d8,
        0x127ee,
        0x12820,
        0x1283c,
        0x12840,
        0x12878,
        0x128f0,
        0x129e0,
        0x12bc0,
        0x12c18,
        0x12c30,
        0x12c3e,
        0x12c60,
        0x12c7c,
        0x12cc0,
        0x12cf8,
        0x12df0,
        0x12e1c,
        0x12e38,
        0x12e70,
        0x12e7e,
        0x12ee0,
        0x12efc,
        0x12f04,
        0x12f08,
        0x12f10,
        0x12f20,
        0x12f3c,
        0x12f40,
        0x12f78,
        0x12f86,
        0x12f8c,
        0x12f98,
        0x12fb0,
        0x12fbe,
        0x12fce,
        0x12fdc,
        0x1302e,
        0x1304e,
        0x1305c,
        0x13062,
        0x13068,
        0x1308e,
        0x1309c,
        0x130b8,
        0x130c2,
        0x130c8,
        0x130d0,
        0x130de,
        0x130ec,
        0x130fa,
        0x1310e,
        0x13138,
        0x13170,
        0x1317e,
        0x13182,
        0x13184,
        0x13190,
        0x1319e,
        0x131a0,
        0x131bc,
        0x131c6,
        0x131cc,
        0x131d8,
        0x131f2,
        0x131f4,
        0x1320e,
        0x1321c,
        0x13270,
        0x1327e,
        0x132e0,
        0x132fc,
        0x13308,
        0x1331e,
        0x13320,
        0x1333c,
        0x13340,
        0x13378,
        0x13386,
        0x13398,
        0x133b0,
        0x133be,
        0x133ce,
        0x133dc,
        0x133e2,
        0x133e4,
        0x133e8,
        0x133f6,
        0x1340e,
        0x1341c,
        0x13438,
        0x13470,
        0x1347e,
        0x134e0,
        0x134fc,
        0x135c0,
        0x135f8,
        0x13608,
        0x13610,
        0x1361e,
        0x13620,
        0x1363c,
        0x13640,
        0x13678,
        0x136f0,
        0x1370c,
        0x13718,
        0x13730,
        0x1373e,
        0x13760,
        0x1377c,
        0x1379c,
        0x137b8,
        0x137c2,
        0x137c4,
        0x137c8,
        0x137d0,
        0x137de,
        0x137e6,
        0x137ec,
        0x13816,
        0x13826,
        0x1382c,
        0x13846,
        0x1384c,
        0x13858,
        0x1386e,
        0x13874,
        0x13886,
        0x13898,
        0x138b0,
        0x138be,
        0x138ce,
        0x138dc,
        0x138e2,
        0x138e4,
        0x138e8,
        0x13906,
        0x1390c,
        0x13930,
        0x1393e,
        0x13960,
        0x1397c,
        0x1398e,
        0x1399c,
        0x139b8,
        0x139c8,
        0x139d0,
        0x139de,
        0x139e6,
        0x139ec,
        0x139fa,
        0x13a06,
        0x13a0c,
        0x13a18,
        0x13a30,
        0x13a3e,
        0x13a60,
        0x13a7c,
        0x13ac0,
        0x13af8,
        0x13b0e,
        0x13b1c,
        0x13b38,
        0x13b70,
        0x13b7e,
        0x13b88,
        0x13b90,
        0x13b9e,
        0x13ba0,
        0x13bbc,
        0x13bcc,
        0x13bd8,
        0x13bee,
        0x13bf2,
        0x13bf4,
        0x13c12,
        0x13c14,
        0x13c22,
        0x13c24,
        0x13c28,
        0x13c36,
        0x13c42,
        0x13c48,
        0x13c50,
        0x13c5e,
        0x13c66,
        0x13c6c,
        0x13c82,
        0x13c84,
        0x13c90,
        0x13c9e,
        0x13ca0,
        0x13cbc,
        0x13cc6,
        0x13ccc,
        0x13cd8,
        0x13cee,
        0x13d02,
        0x13d04,
        0x13d08,
        0x13d10,
        0x13d1e,
        0x13d20,
        0x13d3c,
        0x13d40,
        0x13d78,
        0x13d86,
        0x13d8c,
        0x13d98,
        0x13db0,
        0x13dbe,
        0x13dce,
        0x13ddc,
        0x13de4,
        0x13de8,
        0x13df6,
        0x13e1a,
        0x13e2e,
        0x13e32,
        0x13e34,
        0x13e4e,
        0x13e5c,
        0x13e62,
        0x13e64,
        0x13e68,
        0x13e76,
        0x13e8e,
        0x13e9c,
        0x13eb8,
        0x13ec2,
        0x13ec4,
        0x13ec8,
        0x13ed0,
        0x13ede,
        0x13ee6,
        0x13eec,
        0x13f26,
        0x13f2c,
        0x13f3a,
        0x13f46,
        0x13f4c,
        0x13f58,
        0x13f6e,
        0x13f72,
        0x13f74,
        0x14082,
        0x1409e,
        0x140a0,
        0x140bc,
        0x14104,
        0x14108,
        0x14110,
        0x1411e,
        0x14120,
        0x1413c,
        0x14140,
        0x14178,
        0x1418c,
        0x14198,
        0x141b0,
        0x141be,
        0x141e2,
        0x141e4,
        0x141e8,
        0x14208,
        0x14210,
        0x1421e,
        0x14220,
        0x1423c,
        0x14240,
        0x14278,
        0x142f0,
        0x14306,
        0x1430c,
        0x14318,
        0x14330,
        0x1433e,
        0x14360,
        0x1437c,
        0x1438e,
        0x143c2,
        0x143c4,
        0x143c8,
        0x143d0,
        0x143e6,
        0x143ec,
        0x14408,
        0x14410,
        0x1441e,
        0x14420,
        0x1443c,
        0x14440,
        0x14478,
        0x144f0,
        0x145e0,
        0x1460c,
        0x14618,
        0x14630,
        0x1463e,
        0x14660,
        0x1467c,
        0x146c0,
        0x146f8,
        0x1471c,
        0x14738,
        0x14770,
        0x1477e,
        0x14782,
        0x14784,
        0x14788,
        0x14790,
        0x147a0,
        0x147bc,
        0x147c6,
        0x147cc,
        0x147d8,
        0x147ee,
        0x14810,
        0x14820,
        0x1483c,
        0x14840,
        0x14878,
        0x148f0,
        0x149e0,
        0x14bc0,
        0x14c30,
        0x14c3e,
        0x14c60,
        0x14c7c,
        0x14cc0,
        0x14cf8,
        0x14df0,
        0x14e38,
        0x14e70,
        0x14e7e,
        0x14ee0,
        0x14efc,
        0x14f04,
        0x14f08,
        0x14f10,
        0x14f1e,
        0x14f20,
        0x14f3c,
        0x14f40,
        0x14f78,
        0x14f86,
        0x14f8c,
        0x14f98,
        0x14fb0,
        0x14fce,
        0x14fdc,
        0x15020,
        0x15040,
        0x15078,
        0x150f0,
        0x151e0,
        0x153c0,
        0x15860,
        0x1587c,
        0x158c0,
        0x158f8,
        0x159f0,
        0x15be0,
        0x15c70,
        0x15c7e,
        0x15ce0,
        0x15cfc,
        0x15dc0,
        0x15df8,
        0x15e08,
        0x15e10,
        0x15e20,
        0x15e40,
        0x15e78,
        0x15ef0,
        0x15f0c,
        0x15f18,
        0x15f30,
        0x15f60,
        0x15f7c,
        0x15f8e,
        0x15f9c,
        0x15fb8,
        0x1604e,
        0x1605c,
        0x1608e,
        0x1609c,
        0x160b8,
        0x160c2,
        0x160c4,
        0x160c8,
        0x160de,
        0x1610e,
        0x1611c,
        0x16138,
        0x16170,
        0x1617e,
        0x16184,
        0x16188,
        0x16190,
        0x1619e,
        0x161a0,
        0x161bc,
        0x161c6,
        0x161cc,
        0x161d8,
        0x161f2,
        0x161f4,
        0x1620e,
        0x1621c,
        0x16238,
        0x16270,
        0x1627e,
        0x162e0,
        0x162fc,
        0x16304,
        0x16308,
        0x16310,
        0x1631e,
        0x16320,
        0x1633c,
        0x16340,
        0x16378,
        0x16386,
        0x1638c,
        0x16398,
        0x163b0,
        0x163be,
        0x163ce,
        0x163dc,
        0x163e2,
        0x163e4,
        0x163e8,
        0x163f6,
        0x1640e,
        0x1641c,
        0x16438,
        0x16470,
        0x1647e,
        0x164e0,
        0x164fc,
        0x165c0,
        0x165f8,
        0x16610,
        0x1661e,
        0x16620,
        0x1663c,
        0x16640,
        0x16678,
        0x166f0,
        0x16718,
        0x16730,
        0x1673e,
        0x16760,
        0x1677c,
        0x1678e,
        0x1679c,
        0x167b8,
        0x167c2,
        0x167c4,
        0x167c8,
        0x167d0,
        0x167de,
        0x167e6,
        0x167ec,
        0x1681c,
        0x16838,
        0x16870,
        0x168e0,
        0x168fc,
        0x169c0,
        0x169f8,
        0x16bf0,
        0x16c10,
        0x16c1e,
        0x16c20,
        0x16c3c,
        0x16c40,
        0x16c78,
        0x16cf0,
        0x16de0,
        0x16e18,
        0x16e30,
        0x16e3e,
        0x16e60,
        0x16e7c,
        0x16ec0,
        0x16ef8,
        0x16f1c,
        0x16f38,
        0x16f70,
        0x16f7e,
        0x16f84,
        0x16f88,
        0x16f90,
        0x16f9e,
        0x16fa0,
        0x16fbc,
        0x16fc6,
        0x16fcc,
        0x16fd8,
        0x17026,
        0x1702c,
        0x17046,
        0x1704c,
        0x17058,
        0x1706e,
        0x17086,
        0x1708c,
        0x17098,
        0x170b0,
        0x170be,
        0x170ce,
        0x170dc,
        0x170e8,
        0x17106,
        0x1710c,
        0x17118,
        0x17130,
        0x1713e,
        0x17160,
        0x1717c,
        0x1718e,
        0x1719c,
        0x171b8,
        0x171c2,
        0x171c4,
        0x171c8,
        0x171d0,
        0x171de,
        0x171e6,
        0x171ec,
        0x171fa,
        0x17206,
        0x1720c,
        0x17218,
        0x17230,
        0x1723e,
        0x17260,
        0x1727c,
        0x172c0,
        0x172f8,
        0x1730e,
        0x1731c,
        0x17338,
        0x17370,
        0x1737e,
        0x17388,
        0x17390,
        0x1739e,
        0x173a0,
        0x173bc,
        0x173cc,
        0x173d8,
        0x173ee,
        0x173f2,
        0x173f4,
        0x1740c,
        0x17418,
        0x17430,
        0x1743e,
        0x17460,
        0x1747c,
        0x174c0,
        0x174f8,
        0x175f0,
        0x1760e,
        0x1761c,
        0x17638,
        0x17670,
        0x1767e,
        0x176e0,
        0x176fc,
        0x17708,
        0x17710,
        0x1771e,
        0x17720,
        0x1773c,
        0x17740,
        0x17778,
        0x17798,
        0x177b0,
        0x177be,
        0x177dc,
        0x177e2,
        0x177e4,
        0x177e8,
        0x17822,
        0x17824,
        0x17828,
        0x17836,
        0x17842,
        0x17844,
        0x17848,
        0x17850,
        0x1785e,
        0x17866,
        0x1786c,
        0x17882,
        0x17884,
        0x17888,
        0x17890,
        0x1789e,
        0x178a0,
        0x178bc,
        0x178c6,
        0x178cc,
        0x178d8,
        0x178ee,
        0x178f2,
        0x178f4,
        0x17902,
        0x17904,
        0x17908,
        0x17910,
        0x1791e,
        0x17920,
        0x1793c,
        0x17940,
        0x17978,
        0x17986,
        0x1798c,
        0x17998,
        0x179b0,
        0x179be,
        0x179ce,
        0x179dc,
        0x179e2,
        0x179e4,
        0x179e8,
        0x179f6,
        0x17a04,
        0x17a08,
        0x17a10,
        0x17a1e,
        0x17a20,
        0x17a3c,
        0x17a40,
        0x17a78,
        0x17af0,
        0x17b06,
        0x17b0c,
        0x17b18,
        0x17b30,
        0x17b3e,
        0x17b60,
        0x17b7c,
        0x17b8e,
        0x17b9c,
        0x17bb8,
        0x17bc4,
        0x17bc8,
        0x17bd0,
        0x17bde,
        0x17be6,
        0x17bec,
        0x17c2e,
        0x17c32,
        0x17c34,
        0x17c4e,
        0x17c5c,
        0x17c62,
        0x17c64,
        0x17c68,
        0x17c76,
        0x17c8e,
        0x17c9c,
        0x17cb8,
        0x17cc2,
        0x17cc4,
        0x17cc8,
        0x17cd0,
        0x17cde,
        0x17ce6,
        0x17cec,
        0x17d0e,
        0x17d1c,
        0x17d38,
        0x17d70,
        0x17d82,
        0x17d84,
        0x17d88,
        0x17d90,
        0x17d9e,
        0x17da0,
        0x17dbc,
        0x17dc6,
        0x17dcc,
        0x17dd8,
        0x17dee,
        0x17e26,
        0x17e2c,
        0x17e3a,
        0x17e46,
        0x17e4c,
        0x17e58,
        0x17e6e,
        0x17e72,
        0x17e74,
        0x17e86,
        0x17e8c,
        0x17e98,
        0x17eb0,
        0x17ece,
        0x17edc,
        0x17ee2,
        0x17ee4,
        0x17ee8,
        0x17ef6,
        0x1813a,
        0x18172,
        0x18174,
        0x18216,
        0x18226,
        0x1823a,
        0x1824c,
        0x18258,
        0x1826e,
        0x18272,
        0x18274,
        0x18298,
        0x182be,
        0x182e2,
        0x182e4,
        0x182e8,
        0x182f6,
        0x1835e,
        0x1837a,
        0x183ae,
        0x183d6,
        0x18416,
        0x18426,
        0x1842c,
        0x1843a,
        0x18446,
        0x18458,
        0x1846e,
        0x18472,
        0x18474,
        0x18486,
        0x184b0,
        0x184be,
        0x184ce,
        0x184dc,
        0x184e2,
        0x184e4,
        0x184e8,
        0x184f6,
        0x18506,
        0x1850c,
        0x18518,
        0x18530,
        0x1853e,
        0x18560,
        0x1857c,
        0x1858e,
        0x1859c,
        0x185b8,
        0x185c2,
        0x185c4,
        0x185c8,
        0x185d0,
        0x185de,
        0x185e6,
        0x185ec,
        0x185fa,
        0x18612,
        0x18614,
        0x18622,
        0x18628,
        0x18636,
        0x18642,
        0x18650,
        0x1865e,
        0x1867a,
        0x18682,
        0x18684,
        0x18688,
        0x18690,
        0x1869e,
        0x186a0,
        0x186bc,
        0x186c6,
        0x186cc,
        0x186d8,
        0x186ee,
        0x186f2,
        0x186f4,
        0x1872e,
        0x1874e,
        0x1875c,
        0x18796,
        0x187a6,
        0x187ac,
        0x187d2,
        0x187d4,
        0x18826,
        0x1882c,
        0x1883a,
        0x18846,
        0x1884c,
        0x18858,
        0x1886e,
        0x18872,
        0x18874,
        0x18886,
        0x18898,
        0x188b0,
        0x188be,
        0x188ce,
        0x188dc,
        0x188e2,
        0x188e4,
        0x188e8,
        0x188f6,
        0x1890c,
        0x18930,
        0x1893e,
        0x18960,
        0x1897c,
        0x1898e,
        0x189b8,
        0x189c2,
        0x189c8,
        0x189d0,
        0x189de,
        0x189e6,
        0x189ec,
        0x189fa,
        0x18a18,
        0x18a30,
        0x18a3e,
        0x18a60,
        0x18a7c,
        0x18ac0,
        0x18af8,
        0x18b1c,
        0x18b38,
        0x18b70,
        0x18b7e,
        0x18b82,
        0x18b84,
        0x18b88,
        0x18b90,
        0x18b9e,
        0x18ba0,
        0x18bbc,
        0x18bc6,
        0x18bcc,
        0x18bd8,
        0x18bee,
        0x18bf2,
        0x18bf4,
        0x18c22,
        0x18c24,
        0x18c28,
        0x18c36,
        0x18c42,
        0x18c48,
        0x18c50,
        0x18c5e,
        0x18c66,
        0x18c7a,
        0x18c82,
        0x18c84,
        0x18c90,
        0x18c9e,
        0x18ca0,
        0x18cbc,
        0x18ccc,
        0x18cf2,
        0x18cf4,
        0x18d04,
        0x18d08,
        0x18d10,
        0x18d1e,
        0x18d20,
        0x18d3c,
        0x18d40,
        0x18d78,
        0x18d86,
        0x18d98,
        0x18dce,
        0x18de2,
        0x18de4,
        0x18de8,
        0x18e2e,
        0x18e32,
        0x18e34,
        0x18e4e,
        0x18e5c,
        0x18e62,
        0x18e64,
        0x18e68,
        0x18e8e,
        0x18e9c,
        0x18eb8,
        0x18ec2,
        0x18ec4,
        0x18ec8,
        0x18ed0,
        0x18efa,
        0x18f16,
        0x18f26,
        0x18f2c,
        0x18f46,
        0x18f4c,
        0x18f58,
        0x18f6e,
        0x18f8a,
        0x18f92,
        0x18f94,
        0x18fa2,
        0x18fa4,
        0x18fa8,
        0x18fb6,
        0x1902c,
        0x1903a,
        0x19046,
        0x1904c,
        0x19058,
        0x19072,
        0x19074,
        0x19086,
        0x19098,
        0x190b0,
        0x190be,
        0x190ce,
        0x190dc,
        0x190e2,
        0x190e8,
        0x190f6,
        0x19106,
        0x1910c,
        0x19130,
        0x1913e,
        0x19160,
        0x1917c,
        0x1918e,
        0x1919c,
        0x191b8,
        0x191c2,
        0x191c8,
        0x191d0,
        0x191de,
        0x191e6,
        0x191ec,
        0x191fa,
        0x19218,
        0x1923e,
        0x19260,
        0x1927c,
        0x192c0,
        0x192f8,
        0x19338,
        0x19370,
        0x1937e,
        0x19382,
        0x19384,
        0x19390,
        0x1939e,
        0x193a0,
        0x193bc,
        0x193c6,
        0x193cc,
        0x193d8,
        0x193ee,
        0x193f2,
        0x193f4,
        0x19430,
        0x1943e,
        0x19460,
        0x1947c,
        0x194c0,
        0x194f8,
        0x195f0,
        0x19638,
        0x19670,
        0x1967e,
        0x196e0,
        0x196fc,
        0x19702,
        0x19704,
        0x19708,
        0x19710,
        0x19720,
        0x1973c,
        0x19740,
        0x19778,
        0x19786,
        0x1978c,
        0x19798,
        0x197b0,
        0x197be,
        0x197ce,
        0x197dc,
        0x197e2,
        0x197e4,
        0x197e8,
        0x19822,
        0x19824,
        0x19842,
        0x19848,
        0x19850,
        0x1985e,
        0x19866,
        0x1987a,
        0x19882,
        0x19884,
        0x19890,
        0x1989e,
        0x198a0,
        0x198bc,
        0x198cc,
        0x198f2,
        0x198f4,
        0x19902,
        0x19908,
        0x1991e,
        0x19920,
        0x1993c,
        0x19940,
        0x19978,
        0x19986,
        0x19998,
        0x199ce,
        0x199e2,
        0x199e4,
        0x199e8,
        0x19a08,
        0x19a10,
        0x19a1e,
        0x19a20,
        0x19a3c,
        0x19a40,
        0x19a78,
        0x19af0,
        0x19b18,
        0x19b3e,
        0x19b60,
        0x19b9c,
        0x19bc2,
        0x19bc4,
        0x19bc8,
        0x19bd0,
        0x19be6,
        0x19c2e,
        0x19c34,
        0x19c4e,
        0x19c5c,
        0x19c62,
        0x19c64,
        0x19c68,
        0x19c8e,
        0x19c9c,
        0x19cb8,
        0x19cc2,
        0x19cc8,
        0x19cd0,
        0x19ce6,
        0x19cfa,
        0x19d0e,
        0x19d1c,
        0x19d38,
        0x19d70,
        0x19d7e,
        0x19d82,
        0x19d84,
        0x19d88,
        0x19d90,
        0x19da0,
        0x19dcc,
        0x19df2,
        0x19df4,
        0x19e16,
        0x19e26,
        0x19e2c,
        0x19e46,
        0x19e4c,
        0x19e58,
        0x19e74,
        0x19e86,
        0x19e8c,
        0x19e98,
        0x19eb0,
        0x19ebe,
        0x19ece,
        0x19ee2,
        0x19ee4,
        0x19ee8,
        0x19f0a,
        0x19f12,
        0x19f14,
        0x19f22,
        0x19f24,
        0x19f28,
        0x19f42,
        0x19f44,
        0x19f48,
        0x19f50,
        0x19f5e,
        0x19f6c,
        0x19f9a,
        0x19fae,
        0x19fb2,
        0x19fb4,
        0x1a046,
        0x1a04c,
        0x1a072,
        0x1a074,
        0x1a086,
        0x1a08c,
        0x1a098,
        0x1a0b0,
        0x1a0be,
        0x1a0e2,
        0x1a0e4,
        0x1a0e8,
        0x1a0f6,
        0x1a106,
        0x1a10c,
        0x1a118,
        0x1a130,
        0x1a13e,
        0x1a160,
        0x1a17c,
        0x1a18e,
        0x1a19c,
        0x1a1b8,
        0x1a1c2,
        0x1a1c4,
        0x1a1c8,
        0x1a1d0,
        0x1a1de,
        0x1a1e6,
        0x1a1ec,
        0x1a218,
        0x1a230,
        0x1a23e,
        0x1a260,
        0x1a27c,
        0x1a2c0,
        0x1a2f8,
        0x1a31c,
        0x1a338,
        0x1a370,
        0x1a37e,
        0x1a382,
        0x1a384,
        0x1a388,
        0x1a390,
        0x1a39e,
        0x1a3a0,
        0x1a3bc,
        0x1a3c6,
        0x1a3cc,
        0x1a3d8,
        0x1a3ee,
        0x1a3f2,
        0x1a3f4,
        0x1a418,
        0x1a430,
        0x1a43e,
        0x1a460,
        0x1a47c,
        0x1a4c0,
        0x1a4f8,
        0x1a5f0,
        0x1a61c,
        0x1a638,
        0x1a670,
        0x1a67e,
        0x1a6e0,
        0x1a6fc,
        0x1a702,
        0x1a704,
        0x1a708,
        0x1a710,
        0x1a71e,
        0x1a720,
        0x1a73c,
        0x1a740,
        0x1a778,
        0x1a786,
        0x1a78c,
        0x1a798,
        0x1a7b0,
        0x1a7be,
        0x1a7ce,
        0x1a7dc,
        0x1a7e2,
        0x1a7e4,
        0x1a7e8,
        0x1a830,
        0x1a860,
        0x1a87c,
        0x1a8c0,
        0x1a8f8,
        0x1a9f0,
        0x1abe0,
        0x1ac70,
        0x1ac7e,
        0x1ace0,
        0x1acfc,
        0x1adc0,
        0x1adf8,
        0x1ae04,
        0x1ae08,
        0x1ae10,
        0x1ae20,
        0x1ae3c,
        0x1ae40,
        0x1ae78,
        0x1aef0,
        0x1af06,
        0x1af0c,
        0x1af18,
        0x1af30,
        0x1af3e,
        0x1af60,
        0x1af7c,
        0x1af8e,
        0x1af9c,
        0x1afb8,
        0x1afc4,
        0x1afc8,
        0x1afd0,
        0x1afde,
        0x1b042,
        0x1b05e,
        0x1b07a,
        0x1b082,
        0x1b084,
        0x1b088,
        0x1b090,
        0x1b09e,
        0x1b0a0,
        0x1b0bc,
        0x1b0cc,
        0x1b0f2,
        0x1b0f4,
        0x1b102,
        0x1b104,
        0x1b108,
        0x1b110,
        0x1b11e,
        0x1b120,
        0x1b13c,
        0x1b140,
        0x1b178,
        0x1b186,
        0x1b198,
        0x1b1ce,
        0x1b1e2,
        0x1b1e4,
        0x1b1e8,
        0x1b204,
        0x1b208,
        0x1b210,
        0x1b21e,
        0x1b220,
        0x1b23c,
        0x1b240,
        0x1b278,
        0x1b2f0,
        0x1b30c,
        0x1b33e,
        0x1b360,
        0x1b39c,
        0x1b3c2,
        0x1b3c4,
        0x1b3c8,
        0x1b3d0,
        0x1b3e6,
        0x1b410,
        0x1b41e,
        0x1b420,
        0x1b43c,
        0x1b440,
        0x1b478,
        0x1b4f0,
        0x1b5e0,
        0x1b618,
        0x1b660,
        0x1b67c,
        0x1b6c0,
        0x1b738,
        0x1b782,
        0x1b784,
        0x1b788,
        0x1b790,
        0x1b79e,
        0x1b7a0,
        0x1b7cc,
        0x1b82e,
        0x1b84e,
        0x1b85c,
        0x1b88e,
        0x1b89c,
        0x1b8b8,
        0x1b8c2,
        0x1b8c4,
        0x1b8c8,
        0x1b8d0,
        0x1b8e6,
        0x1b8fa,
        0x1b90e,
        0x1b91c,
        0x1b938,
        0x1b970,
        0x1b97e,
        0x1b982,
        0x1b984,
        0x1b988,
        0x1b990,
        0x1b99e,
        0x1b9a0,
        0x1b9cc,
        0x1b9f2,
        0x1b9f4,
        0x1ba0e,
        0x1ba1c,
        0x1ba38,
        0x1ba70,
        0x1ba7e,
        0x1bae0,
        0x1bafc,
        0x1bb08,
        0x1bb10,
        0x1bb20,
        0x1bb3c,
        0x1bb40,
        0x1bb98,
        0x1bbce,
        0x1bbe2,
        0x1bbe4,
        0x1bbe8,
        0x1bc16,
        0x1bc26,
        0x1bc2c,
        0x1bc46,
        0x1bc4c,
        0x1bc58,
        0x1bc72,
        0x1bc74,
        0x1bc86,
        0x1bc8c,
        0x1bc98,
        0x1bcb0,
        0x1bcbe,
        0x1bcce,
        0x1bce2,
        0x1bce4,
        0x1bce8,
        0x1bd06,
        0x1bd0c,
        0x1bd18,
        0x1bd30,
        0x1bd3e,
        0x1bd60,
        0x1bd7c,
        0x1bd9c,
        0x1bdc2,
        0x1bdc4,
        0x1bdc8,
        0x1bdd0,
        0x1bde6,
        0x1bdfa,
        0x1be12,
        0x1be14,
        0x1be22,
        0x1be24,
        0x1be28,
        0x1be42,
        0x1be44,
        0x1be48,
        0x1be50,
        0x1be5e,
        0x1be66,
        0x1be82,
        0x1be84,
        0x1be88,
        0x1be90,
        0x1be9e,
        0x1bea0,
        0x1bebc,
        0x1becc,
        0x1bef4,
        0x1bf1a,
        0x1bf2e,
        0x1bf32,
        0x1bf34,
        0x1bf4e,
        0x1bf5c,
        0x1bf62,
        0x1bf64,
        0x1bf68,
        0x1c09a,
        0x1c0b2,
        0x1c0b4,
        0x1c11a,
        0x1c132,
        0x1c134,
        0x1c162,
        0x1c164,
        0x1c168,
        0x1c176,
        0x1c1ba,
        0x1c21a,
        0x1c232,
        0x1c234,
        0x1c24e,
        0x1c25c,
        0x1c262,
        0x1c264,
        0x1c268,
        0x1c276,
        0x1c28e,
        0x1c2c2,
        0x1c2c4,
        0x1c2c8,
        0x1c2d0,
        0x1c2de,
        0x1c2e6,
        0x1c2ec,
        0x1c2fa,
        0x1c316,
        0x1c326,
        0x1c33a,
        0x1c346,
        0x1c34c,
        0x1c372,
        0x1c374,
        0x1c41a,
        0x1c42e,
        0x1c432,
        0x1c434,
        0x1c44e,
        0x1c45c,
        0x1c462,
        0x1c464,
        0x1c468,
        0x1c476,
        0x1c48e,
        0x1c49c,
        0x1c4b8,
        0x1c4c2,
        0x1c4c8,
        0x1c4d0,
        0x1c4de,
        0x1c4e6,
        0x1c4ec,
        0x1c4fa,
        0x1c51c,
        0x1c538,
        0x1c570,
        0x1c57e,
        0x1c582,
        0x1c584,
        0x1c588,
        0x1c590,
        0x1c59e,
        0x1c5a0,
        0x1c5bc,
        0x1c5c6,
        0x1c5cc,
        0x1c5d8,
        0x1c5ee,
        0x1c5f2,
        0x1c5f4,
        0x1c616,
        0x1c626,
        0x1c62c,
        0x1c63a,
        0x1c646,
        0x1c64c,
        0x1c658,
        0x1c66e,
        0x1c672,
        0x1c674,
        0x1c686,
        0x1c68c,
        0x1c698,
        0x1c6b0,
        0x1c6be,
        0x1c6ce,
        0x1c6dc,
        0x1c6e2,
        0x1c6e4,
        0x1c6e8,
        0x1c712,
        0x1c714,
        0x1c722,
        0x1c728,
        0x1c736,
        0x1c742,
        0x1c744,
        0x1c748,
        0x1c750,
        0x1c75e,
        0x1c766,
        0x1c76c,
        0x1c77a,
        0x1c7ae,
        0x1c7d6,
        0x1c7ea,
        0x1c81a,
        0x1c82e,
        0x1c832,
        0x1c834,
        0x1c84e,
        0x1c85c,
        0x1c862,
        0x1c864,
        0x1c868,
        0x1c876,
        0x1c88e,
        0x1c89c,
        0x1c8b8,
        0x1c8c2,
        0x1c8c8,
        0x1c8d0,
        0x1c8de,
        0x1c8e6,
        0x1c8ec,
        0x1c8fa,
        0x1c90e,
        0x1c938,
        0x1c970,
        0x1c97e,
        0x1c982,
        0x1c984,
        0x1c990,
        0x1c99e,
        0x1c9a0,
        0x1c9bc,
        0x1c9c6,
        0x1c9cc,
        0x1c9d8,
        0x1c9ee,
        0x1c9f2,
        0x1c9f4,
        0x1ca38,
        0x1ca70,
        0x1ca7e,
        0x1cae0,
        0x1cafc,
        0x1cb02,
        0x1cb04,
        0x1cb08,
        0x1cb10,
        0x1cb20,
        0x1cb3c,
        0x1cb40,
        0x1cb78,
        0x1cb86,
        0x1cb8c,
        0x1cb98,
        0x1cbb0,
        0x1cbbe,
        0x1cbce,
        0x1cbdc,
        0x1cbe2,
        0x1cbe4,
        0x1cbe8,
        0x1cbf6,
        0x1cc16,
        0x1cc26,
        0x1cc2c,
        0x1cc3a,
        0x1cc46,
        0x1cc58,
        0x1cc72,
        0x1cc74,
        0x1cc86,
        0x1ccb0,
        0x1ccbe,
        0x1ccce,
        0x1cce2,
        0x1cce4,
        0x1cce8,
        0x1cd06,
        0x1cd0c,
        0x1cd18,
        0x1cd30,
        0x1cd3e,
        0x1cd60,
        0x1cd7c,
        0x1cd9c,
        0x1cdc2,
        0x1cdc4,
        0x1cdc8,
        0x1cdd0,
        0x1cdde,
        0x1cde6,
        0x1cdfa,
        0x1ce22,
        0x1ce28,
        0x1ce42,
        0x1ce50,
        0x1ce5e,
        0x1ce66,
        0x1ce7a,
        0x1ce82,
        0x1ce84,
        0x1ce88,
        0x1ce90,
        0x1ce9e,
        0x1cea0,
        0x1cebc,
        0x1cecc,
        0x1cef2,
        0x1cef4,
        0x1cf2e,
        0x1cf32,
        0x1cf34,
        0x1cf4e,
        0x1cf5c,
        0x1cf62,
        0x1cf64,
        0x1cf68,
        0x1cf96,
        0x1cfa6,
        0x1cfac,
        0x1cfca,
        0x1cfd2,
        0x1cfd4,
        0x1d02e,
        0x1d032,
        0x1d034,
        0x1d04e,
        0x1d05c,
        0x1d062,
        0x1d064,
        0x1d068,
        0x1d076,
        0x1d08e,
        0x1d09c,
        0x1d0b8,
        0x1d0c2,
        0x1d0c4,
        0x1d0c8,
        0x1d0d0,
        0x1d0de,
        0x1d0e6,
        0x1d0ec,
        0x1d0fa,
        0x1d11c,
        0x1d138,
        0x1d170,
        0x1d17e,
        0x1d182,
        0x1d184,
        0x1d188,
        0x1d190,
        0x1d19e,
        0x1d1a0,
        0x1d1bc,
        0x1d1c6,
        0x1d1cc,
        0x1d1d8,
        0x1d1ee,
        0x1d1f2,
        0x1d1f4,
        0x1d21c,
        0x1d238,
        0x1d270,
        0x1d27e,
        0x1d2e0,
        0x1d2fc,
        0x1d302,
        0x1d304,
        0x1d308,
        0x1d310,
        0x1d31e,
        0x1d320,
        0x1d33c,
        0x1d340,
        0x1d378,
        0x1d386,
        0x1d38c,
        0x1d398,
        0x1d3b0,
        0x1d3be,
        0x1d3ce,
        0x1d3dc,
        0x1d3e2,
        0x1d3e4,
        0x1d3e8,
        0x1d3f6,
        0x1d470,
        0x1d47e,
        0x1d4e0,
        0x1d4fc,
        0x1d5c0,
        0x1d5f8,
        0x1d604,
        0x1d608,
        0x1d610,
        0x1d620,
        0x1d640,
        0x1d678,
        0x1d6f0,
        0x1d706,
        0x1d70c,
        0x1d718,
        0x1d730,
        0x1d73e,
        0x1d760,
        0x1d77c,
        0x1d78e,
        0x1d79c,
        0x1d7b8,
        0x1d7c2,
        0x1d7c4,
        0x1d7c8,
        0x1d7d0,
        0x1d7de,
        0x1d7e6,
        0x1d7ec,
        0x1d826,
        0x1d82c,
        0x1d83a,
        0x1d846,
        0x1d84c,
        0x1d858,
        0x1d872,
        0x1d874,
        0x1d886,
        0x1d88c,
        0x1d898,
        0x1d8b0,
        0x1d8be,
        0x1d8ce,
        0x1d8e2,
        0x1d8e4,
        0x1d8e8,
        0x1d8f6,
        0x1d90c,
        0x1d918,
        0x1d930,
        0x1d93e,
        0x1d960,
        0x1d97c,
        0x1d99c,
        0x1d9c2,
        0x1d9c4,
        0x1d9c8,
        0x1d9d0,
        0x1d9e6,
        0x1d9fa,
        0x1da0c,
        0x1da18,
        0x1da30,
        0x1da3e,
        0x1da60,
        0x1da7c,
        0x1dac0,
        0x1daf8,
        0x1db38,
        0x1db82,
        0x1db84,
        0x1db88,
        0x1db90,
        0x1db9e,
        0x1dba0,
        0x1dbcc,
        0x1dbf2,
        0x1dbf4,
        0x1dc22,
        0x1dc42,
        0x1dc44,
        0x1dc48,
        0x1dc50,
        0x1dc5e,
        0x1dc66,
        0x1dc7a,
        0x1dc82,
        0x1dc84,
        0x1dc88,
        0x1dc90,
        0x1dc9e,
        0x1dca0,
        0x1dcbc,
        0x1dccc,
        0x1dcf2,
        0x1dcf4,
        0x1dd04,
        0x1dd08,
        0x1dd10,
        0x1dd1e,
        0x1dd20,
        0x1dd3c,
        0x1dd40,
        0x1dd78,
        0x1dd86,
        0x1dd98,
        0x1ddce,
        0x1dde2,
        0x1dde4,
        0x1dde8,
        0x1de2e,
        0x1de32,
        0x1de34,
        0x1de4e,
        0x1de5c,
        0x1de62,
        0x1de64,
        0x1de68,
        0x1de8e,
        0x1de9c,
        0x1deb8,
        0x1dec2,
        0x1dec4,
        0x1dec8,
        0x1ded0,
        0x1dee6,
        0x1defa,
        0x1df16,
        0x1df26,
        0x1df2c,
        0x1df46,
        0x1df4c,
        0x1df58,
        0x1df72,
        0x1df74,
        0x1df8a,
        0x1df92,
        0x1df94,
        0x1dfa2,
        0x1dfa4,
        0x1dfa8,
        0x1e08a,
        0x1e092,
        0x1e094,
        0x1e0a2,
        0x1e0a4,
        0x1e0a8,
        0x1e0b6,
        0x1e0da,
        0x1e10a,
        0x1e112,
        0x1e114,
        0x1e122,
        0x1e124,
        0x1e128,
        0x1e136,
        0x1e142,
        0x1e144,
        0x1e148,
        0x1e150,
        0x1e166,
        0x1e16c,
        0x1e17a,
        0x1e19a,
        0x1e1b2,
        0x1e1b4,
        0x1e20a,
        0x1e212,
        0x1e214,
        0x1e222,
        0x1e224,
        0x1e228,
        0x1e236,
        0x1e242,
        0x1e248,
        0x1e250,
        0x1e25e,
        0x1e266,
        0x1e26c,
        0x1e27a,
        0x1e282,
        0x1e284,
        0x1e288,
        0x1e290,
        0x1e2a0,
        0x1e2bc,
        0x1e2c6,
        0x1e2cc,
        0x1e2d8,
        0x1e2ee,
        0x1e2f2,
        0x1e2f4,
        0x1e31a,
        0x1e332,
        0x1e334,
        0x1e35c,
        0x1e362,
        0x1e364,
        0x1e368,
        0x1e3ba,
        0x1e40a,
        0x1e412,
        0x1e414,
        0x1e422,
        0x1e428,
        0x1e436,
        0x1e442,
        0x1e448,
        0x1e450,
        0x1e45e,
        0x1e466,
        0x1e46c,
        0x1e47a,
        0x1e482,
        0x1e484,
        0x1e490,
        0x1e49e,
        0x1e4a0,
        0x1e4bc,
        0x1e4c6,
        0x1e4cc,
        0x1e4d8,
        0x1e4ee,
        0x1e4f2,
        0x1e4f4,
        0x1e502,
        0x1e504,
        0x1e508,
        0x1e510,
        0x1e51e,
        0x1e520,
        0x1e53c,
        0x1e540,
        0x1e578,
        0x1e586,
        0x1e58c,
        0x1e598,
        0x1e5b0,
        0x1e5be,
        0x1e5ce,
        0x1e5dc,
        0x1e5e2,
        0x1e5e4,
        0x1e5e8,
        0x1e5f6,
        0x1e61a,
        0x1e62e,
        0x1e632,
        0x1e634,
        0x1e64e,
        0x1e65c,
        0x1e662,
        0x1e668,
        0x1e68e,
        0x1e69c,
        0x1e6b8,
        0x1e6c2,
        0x1e6c4,
        0x1e6c8,
        0x1e6d0,
        0x1e6e6,
        0x1e6fa,
        0x1e716,
        0x1e726,
        0x1e72c,
        0x1e73a,
        0x1e746,
        0x1e74c,
        0x1e758,
        0x1e772,
        0x1e774,
        0x1e792,
        0x1e794,
        0x1e7a2,
        0x1e7a4,
        0x1e7a8,
        0x1e7b6,
        0x1e812,
        0x1e814,
        0x1e822,
        0x1e824,
        0x1e828,
        0x1e836,
        0x1e842,
        0x1e844,
        0x1e848,
        0x1e850,
        0x1e85e,
        0x1e866,
        0x1e86c,
        0x1e87a,
        0x1e882,
        0x1e884,
        0x1e888,
        0x1e890,
        0x1e89e,
        0x1e8a0,
        0x1e8bc,
        0x1e8c6,
        0x1e8cc,
        0x1e8d8,
        0x1e8ee,
        0x1e8f2,
        0x1e8f4,
        0x1e902,
        0x1e904,
        0x1e908,
        0x1e910,
        0x1e920,
        0x1e93c,
        0x1e940,
        0x1e978,
        0x1e986,
        0x1e98c,
        0x1e998,
        0x1e9b0,
        0x1e9be,
        0x1e9ce,
        0x1e9dc,
        0x1e9e2,
        0x1e9e4,
        0x1e9e8,
        0x1e9f6,
        0x1ea04,
        0x1ea08,
        0x1ea10,
        0x1ea20,
        0x1ea40,
        0x1ea78,
        0x1eaf0,
        0x1eb06,
        0x1eb0c,
        0x1eb18,
        0x1eb30,
        0x1eb3e,
        0x1eb60,
        0x1eb7c,
        0x1eb8e,
        0x1eb9c,
        0x1ebb8,
        0x1ebc2,
        0x1ebc4,
        0x1ebc8,
        0x1ebd0,
        0x1ebde,
        0x1ebe6,
        0x1ebec,
        0x1ec1a,
        0x1ec2e,
        0x1ec32,
        0x1ec34,
        0x1ec4e,
        0x1ec5c,
        0x1ec62,
        0x1ec64,
        0x1ec68,
        0x1ec8e,
        0x1ec9c,
        0x1ecb8,
        0x1ecc2,
        0x1ecc4,
        0x1ecc8,
        0x1ecd0,
        0x1ece6,
        0x1ecfa,
        0x1ed0e,
        0x1ed1c,
        0x1ed38,
        0x1ed70,
        0x1ed7e,
        0x1ed82,
        0x1ed84,
        0x1ed88,
        0x1ed90,
        0x1ed9e,
        0x1eda0,
        0x1edcc,
        0x1edf2,
        0x1edf4,
        0x1ee16,
        0x1ee26,
        0x1ee2c,
        0x1ee3a,
        0x1ee46,
        0x1ee4c,
        0x1ee58,
        0x1ee6e,
        0x1ee72,
        0x1ee74,
        0x1ee86,
        0x1ee8c,
        0x1ee98,
        0x1eeb0,
        0x1eebe,
        0x1eece,
        0x1eedc,
        0x1eee2,
        0x1eee4,
        0x1eee8,
        0x1ef12,
        0x1ef22,
        0x1ef24,
        0x1ef28,
        0x1ef36,
        0x1ef42,
        0x1ef44,
        0x1ef48,
        0x1ef50,
        0x1ef5e,
        0x1ef66,
        0x1ef6c,
        0x1ef7a,
        0x1efae,
        0x1efb2,
        0x1efb4,
        0x1efd6,
        0x1f096,
        0x1f0a6,
        0x1f0ac,
        0x1f0ba,
        0x1f0ca,
        0x1f0d2,
        0x1f0d4,
        0x1f116,
        0x1f126,
        0x1f12c,
        0x1f13a,
        0x1f146,
        0x1f14c,
        0x1f158,
        0x1f16e,
        0x1f172,
        0x1f174,
        0x1f18a,
        0x1f192,
        0x1f194,
        0x1f1a2,
        0x1f1a4,
        0x1f1a8,
        0x1f1da,
        0x1f216,
        0x1f226,
        0x1f22c,
        0x1f23a,
        0x1f246,
        0x1f258,
        0x1f26e,
        0x1f272,
        0x1f274,
        0x1f286,
        0x1f28c,
        0x1f298,
        0x1f2b0,
        0x1f2be,
        0x1f2ce,
        0x1f2dc,
        0x1f2e2,
        0x1f2e4,
        0x1f2e8,
        0x1f2f6,
        0x1f30a,
        0x1f312,
        0x1f314,
        0x1f322,
        0x1f328,
        0x1f342,
        0x1f344,
        0x1f348,
        0x1f350,
        0x1f35e,
        0x1f366,
        0x1f37a,
        0x1f39a,
        0x1f3ae,
        0x1f3b2,
        0x1f3b4,
        0x1f416,
        0x1f426,
        0x1f42c,
        0x1f43a,
        0x1f446,
        0x1f44c,
        0x1f458,
        0x1f46e,
        0x1f472,
        0x1f474,
        0x1f486,
        0x1f48c,
        0x1f498,
        0x1f4b0,
        0x1f4be,
        0x1f4ce,
        0x1f4dc,
        0x1f4e2,
        0x1f4e4,
        0x1f4e8,
        0x1f4f6,
        0x1f506,
        0x1f50c,
        0x1f518,
        0x1f530,
        0x1f53e,
        0x1f560,
        0x1f57c,
        0x1f58e,
        0x1f59c,
        0x1f5b8,
        0x1f5c2,
        0x1f5c4,
        0x1f5c8,
        0x1f5d0,
        0x1f5de,
        0x1f5e6,
        0x1f5ec,
        0x1f5fa,
        0x1f60a,
        0x1f612,
        0x1f614,
        0x1f622,
        0x1f624,
        0x1f628,
        0x1f636,
        0x1f642,
        0x1f644,
        0x1f648,
        0x1f650,
        0x1f65e,
        0x1f666,
        0x1f67a,
        0x1f682,
        0x1f684,
        0x1f688,
        0x1f690,
        0x1f69e,
        0x1f6a0,
        0x1f6bc,
        0x1f6cc,
        0x1f6f2,
        0x1f6f4,
        0x1f71a,
        0x1f72e,
        0x1f732,
        0x1f734,
        0x1f74e,
        0x1f75c,
        0x1f762,
        0x1f764,
        0x1f768,
        0x1f776,
        0x1f796,
        0x1f7a6,
        0x1f7ac,
        0x1f7ba,
        0x1f7d2,
        0x1f7d4,
        0x1f89a,
        0x1f8ae,
        0x1f8b2,
        0x1f8b4,
        0x1f8d6,
        0x1f8ea,
        0x1f91a,
        0x1f92e,
        0x1f932,
        0x1f934,
        0x1f94e,
        0x1f95c,
        0x1f962,
        0x1f964,
        0x1f968,
        0x1f976,
        0x1f996,
        0x1f9a6,
        0x1f9ac,
        0x1f9ba,
        0x1f9ca,
        0x1f9d2,
        0x1f9d4,
        0x1fa1a,
        0x1fa2e,
        0x1fa32,
        0x1fa34,
        0x1fa4e,
        0x1fa5c,
        0x1fa62,
        0x1fa64,
        0x1fa68,
        0x1fa76,
        0x1fa8e,
        0x1fa9c,
        0x1fab8,
        0x1fac2,
        0x1fac4,
        0x1fac8,
        0x1fad0,
        0x1fade,
        0x1fae6,
        0x1faec,
        0x1fb16,
        0x1fb26,
        0x1fb2c,
        0x1fb3a,
        0x1fb46,
        0x1fb4c,
        0x1fb58,
        0x1fb6e,
        0x1fb72,
        0x1fb74,
        0x1fb8a,
        0x1fb92,
        0x1fb94,
        0x1fba2,
        0x1fba4,
        0x1fba8,
        0x1fbb6,
        0x1fbda
    ]);
    /**
     * This table contains to codewords for all symbols.
     */ PDF417Common.CODEWORD_TABLE = Int32Array.from([
        2627,
        1819,
        2622,
        2621,
        1813,
        1812,
        2729,
        2724,
        2723,
        2779,
        2774,
        2773,
        902,
        896,
        908,
        868,
        865,
        861,
        859,
        2511,
        873,
        871,
        1780,
        835,
        2493,
        825,
        2491,
        842,
        837,
        844,
        1764,
        1762,
        811,
        810,
        809,
        2483,
        807,
        2482,
        806,
        2480,
        815,
        814,
        813,
        812,
        2484,
        817,
        816,
        1745,
        1744,
        1742,
        1746,
        2655,
        2637,
        2635,
        2626,
        2625,
        2623,
        2628,
        1820,
        2752,
        2739,
        2737,
        2728,
        2727,
        2725,
        2730,
        2785,
        2783,
        2778,
        2777,
        2775,
        2780,
        787,
        781,
        747,
        739,
        736,
        2413,
        754,
        752,
        1719,
        692,
        689,
        681,
        2371,
        678,
        2369,
        700,
        697,
        694,
        703,
        1688,
        1686,
        642,
        638,
        2343,
        631,
        2341,
        627,
        2338,
        651,
        646,
        643,
        2345,
        654,
        652,
        1652,
        1650,
        1647,
        1654,
        601,
        599,
        2322,
        596,
        2321,
        594,
        2319,
        2317,
        611,
        610,
        608,
        606,
        2324,
        603,
        2323,
        615,
        614,
        612,
        1617,
        1616,
        1614,
        1612,
        616,
        1619,
        1618,
        2575,
        2538,
        2536,
        905,
        901,
        898,
        909,
        2509,
        2507,
        2504,
        870,
        867,
        864,
        860,
        2512,
        875,
        872,
        1781,
        2490,
        2489,
        2487,
        2485,
        1748,
        836,
        834,
        832,
        830,
        2494,
        827,
        2492,
        843,
        841,
        839,
        845,
        1765,
        1763,
        2701,
        2676,
        2674,
        2653,
        2648,
        2656,
        2634,
        2633,
        2631,
        2629,
        1821,
        2638,
        2636,
        2770,
        2763,
        2761,
        2750,
        2745,
        2753,
        2736,
        2735,
        2733,
        2731,
        1848,
        2740,
        2738,
        2786,
        2784,
        591,
        588,
        576,
        569,
        566,
        2296,
        1590,
        537,
        534,
        526,
        2276,
        522,
        2274,
        545,
        542,
        539,
        548,
        1572,
        1570,
        481,
        2245,
        466,
        2242,
        462,
        2239,
        492,
        485,
        482,
        2249,
        496,
        494,
        1534,
        1531,
        1528,
        1538,
        413,
        2196,
        406,
        2191,
        2188,
        425,
        419,
        2202,
        415,
        2199,
        432,
        430,
        427,
        1472,
        1467,
        1464,
        433,
        1476,
        1474,
        368,
        367,
        2160,
        365,
        2159,
        362,
        2157,
        2155,
        2152,
        378,
        377,
        375,
        2166,
        372,
        2165,
        369,
        2162,
        383,
        381,
        379,
        2168,
        1419,
        1418,
        1416,
        1414,
        385,
        1411,
        384,
        1423,
        1422,
        1420,
        1424,
        2461,
        802,
        2441,
        2439,
        790,
        786,
        783,
        794,
        2409,
        2406,
        2403,
        750,
        742,
        738,
        2414,
        756,
        753,
        1720,
        2367,
        2365,
        2362,
        2359,
        1663,
        693,
        691,
        684,
        2373,
        680,
        2370,
        702,
        699,
        696,
        704,
        1690,
        1687,
        2337,
        2336,
        2334,
        2332,
        1624,
        2329,
        1622,
        640,
        637,
        2344,
        634,
        2342,
        630,
        2340,
        650,
        648,
        645,
        2346,
        655,
        653,
        1653,
        1651,
        1649,
        1655,
        2612,
        2597,
        2595,
        2571,
        2568,
        2565,
        2576,
        2534,
        2529,
        2526,
        1787,
        2540,
        2537,
        907,
        904,
        900,
        910,
        2503,
        2502,
        2500,
        2498,
        1768,
        2495,
        1767,
        2510,
        2508,
        2506,
        869,
        866,
        863,
        2513,
        876,
        874,
        1782,
        2720,
        2713,
        2711,
        2697,
        2694,
        2691,
        2702,
        2672,
        2670,
        2664,
        1828,
        2678,
        2675,
        2647,
        2646,
        2644,
        2642,
        1823,
        2639,
        1822,
        2654,
        2652,
        2650,
        2657,
        2771,
        1855,
        2765,
        2762,
        1850,
        1849,
        2751,
        2749,
        2747,
        2754,
        353,
        2148,
        344,
        342,
        336,
        2142,
        332,
        2140,
        345,
        1375,
        1373,
        306,
        2130,
        299,
        2128,
        295,
        2125,
        319,
        314,
        311,
        2132,
        1354,
        1352,
        1349,
        1356,
        262,
        257,
        2101,
        253,
        2096,
        2093,
        274,
        273,
        267,
        2107,
        263,
        2104,
        280,
        278,
        275,
        1316,
        1311,
        1308,
        1320,
        1318,
        2052,
        202,
        2050,
        2044,
        2040,
        219,
        2063,
        212,
        2060,
        208,
        2055,
        224,
        221,
        2066,
        1260,
        1258,
        1252,
        231,
        1248,
        229,
        1266,
        1264,
        1261,
        1268,
        155,
        1998,
        153,
        1996,
        1994,
        1991,
        1988,
        165,
        164,
        2007,
        162,
        2006,
        159,
        2003,
        2000,
        172,
        171,
        169,
        2012,
        166,
        2010,
        1186,
        1184,
        1182,
        1179,
        175,
        1176,
        173,
        1192,
        1191,
        1189,
        1187,
        176,
        1194,
        1193,
        2313,
        2307,
        2305,
        592,
        589,
        2294,
        2292,
        2289,
        578,
        572,
        568,
        2297,
        580,
        1591,
        2272,
        2267,
        2264,
        1547,
        538,
        536,
        529,
        2278,
        525,
        2275,
        547,
        544,
        541,
        1574,
        1571,
        2237,
        2235,
        2229,
        1493,
        2225,
        1489,
        478,
        2247,
        470,
        2244,
        465,
        2241,
        493,
        488,
        484,
        2250,
        498,
        495,
        1536,
        1533,
        1530,
        1539,
        2187,
        2186,
        2184,
        2182,
        1432,
        2179,
        1430,
        2176,
        1427,
        414,
        412,
        2197,
        409,
        2195,
        405,
        2193,
        2190,
        426,
        424,
        421,
        2203,
        418,
        2201,
        431,
        429,
        1473,
        1471,
        1469,
        1466,
        434,
        1477,
        1475,
        2478,
        2472,
        2470,
        2459,
        2457,
        2454,
        2462,
        803,
        2437,
        2432,
        2429,
        1726,
        2443,
        2440,
        792,
        789,
        785,
        2401,
        2399,
        2393,
        1702,
        2389,
        1699,
        2411,
        2408,
        2405,
        745,
        741,
        2415,
        758,
        755,
        1721,
        2358,
        2357,
        2355,
        2353,
        1661,
        2350,
        1660,
        2347,
        1657,
        2368,
        2366,
        2364,
        2361,
        1666,
        690,
        687,
        2374,
        683,
        2372,
        701,
        698,
        705,
        1691,
        1689,
        2619,
        2617,
        2610,
        2608,
        2605,
        2613,
        2593,
        2588,
        2585,
        1803,
        2599,
        2596,
        2563,
        2561,
        2555,
        1797,
        2551,
        1795,
        2573,
        2570,
        2567,
        2577,
        2525,
        2524,
        2522,
        2520,
        1786,
        2517,
        1785,
        2514,
        1783,
        2535,
        2533,
        2531,
        2528,
        1788,
        2541,
        2539,
        906,
        903,
        911,
        2721,
        1844,
        2715,
        2712,
        1838,
        1836,
        2699,
        2696,
        2693,
        2703,
        1827,
        1826,
        1824,
        2673,
        2671,
        2669,
        2666,
        1829,
        2679,
        2677,
        1858,
        1857,
        2772,
        1854,
        1853,
        1851,
        1856,
        2766,
        2764,
        143,
        1987,
        139,
        1986,
        135,
        133,
        131,
        1984,
        128,
        1983,
        125,
        1981,
        138,
        137,
        136,
        1985,
        1133,
        1132,
        1130,
        112,
        110,
        1974,
        107,
        1973,
        104,
        1971,
        1969,
        122,
        121,
        119,
        117,
        1977,
        114,
        1976,
        124,
        1115,
        1114,
        1112,
        1110,
        1117,
        1116,
        84,
        83,
        1953,
        81,
        1952,
        78,
        1950,
        1948,
        1945,
        94,
        93,
        91,
        1959,
        88,
        1958,
        85,
        1955,
        99,
        97,
        95,
        1961,
        1086,
        1085,
        1083,
        1081,
        1078,
        100,
        1090,
        1089,
        1087,
        1091,
        49,
        47,
        1917,
        44,
        1915,
        1913,
        1910,
        1907,
        59,
        1926,
        56,
        1925,
        53,
        1922,
        1919,
        66,
        64,
        1931,
        61,
        1929,
        1042,
        1040,
        1038,
        71,
        1035,
        70,
        1032,
        68,
        1048,
        1047,
        1045,
        1043,
        1050,
        1049,
        12,
        10,
        1869,
        1867,
        1864,
        1861,
        21,
        1880,
        19,
        1877,
        1874,
        1871,
        28,
        1888,
        25,
        1886,
        22,
        1883,
        982,
        980,
        977,
        974,
        32,
        30,
        991,
        989,
        987,
        984,
        34,
        995,
        994,
        992,
        2151,
        2150,
        2147,
        2146,
        2144,
        356,
        355,
        354,
        2149,
        2139,
        2138,
        2136,
        2134,
        1359,
        343,
        341,
        338,
        2143,
        335,
        2141,
        348,
        347,
        346,
        1376,
        1374,
        2124,
        2123,
        2121,
        2119,
        1326,
        2116,
        1324,
        310,
        308,
        305,
        2131,
        302,
        2129,
        298,
        2127,
        320,
        318,
        316,
        313,
        2133,
        322,
        321,
        1355,
        1353,
        1351,
        1357,
        2092,
        2091,
        2089,
        2087,
        1276,
        2084,
        1274,
        2081,
        1271,
        259,
        2102,
        256,
        2100,
        252,
        2098,
        2095,
        272,
        269,
        2108,
        266,
        2106,
        281,
        279,
        277,
        1317,
        1315,
        1313,
        1310,
        282,
        1321,
        1319,
        2039,
        2037,
        2035,
        2032,
        1203,
        2029,
        1200,
        1197,
        207,
        2053,
        205,
        2051,
        201,
        2049,
        2046,
        2043,
        220,
        218,
        2064,
        215,
        2062,
        211,
        2059,
        228,
        226,
        223,
        2069,
        1259,
        1257,
        1254,
        232,
        1251,
        230,
        1267,
        1265,
        1263,
        2316,
        2315,
        2312,
        2311,
        2309,
        2314,
        2304,
        2303,
        2301,
        2299,
        1593,
        2308,
        2306,
        590,
        2288,
        2287,
        2285,
        2283,
        1578,
        2280,
        1577,
        2295,
        2293,
        2291,
        579,
        577,
        574,
        571,
        2298,
        582,
        581,
        1592,
        2263,
        2262,
        2260,
        2258,
        1545,
        2255,
        1544,
        2252,
        1541,
        2273,
        2271,
        2269,
        2266,
        1550,
        535,
        532,
        2279,
        528,
        2277,
        546,
        543,
        549,
        1575,
        1573,
        2224,
        2222,
        2220,
        1486,
        2217,
        1485,
        2214,
        1482,
        1479,
        2238,
        2236,
        2234,
        2231,
        1496,
        2228,
        1492,
        480,
        477,
        2248,
        473,
        2246,
        469,
        2243,
        490,
        487,
        2251,
        497,
        1537,
        1535,
        1532,
        2477,
        2476,
        2474,
        2479,
        2469,
        2468,
        2466,
        2464,
        1730,
        2473,
        2471,
        2453,
        2452,
        2450,
        2448,
        1729,
        2445,
        1728,
        2460,
        2458,
        2456,
        2463,
        805,
        804,
        2428,
        2427,
        2425,
        2423,
        1725,
        2420,
        1724,
        2417,
        1722,
        2438,
        2436,
        2434,
        2431,
        1727,
        2444,
        2442,
        793,
        791,
        788,
        795,
        2388,
        2386,
        2384,
        1697,
        2381,
        1696,
        2378,
        1694,
        1692,
        2402,
        2400,
        2398,
        2395,
        1703,
        2392,
        1701,
        2412,
        2410,
        2407,
        751,
        748,
        744,
        2416,
        759,
        757,
        1807,
        2620,
        2618,
        1806,
        1805,
        2611,
        2609,
        2607,
        2614,
        1802,
        1801,
        1799,
        2594,
        2592,
        2590,
        2587,
        1804,
        2600,
        2598,
        1794,
        1793,
        1791,
        1789,
        2564,
        2562,
        2560,
        2557,
        1798,
        2554,
        1796,
        2574,
        2572,
        2569,
        2578,
        1847,
        1846,
        2722,
        1843,
        1842,
        1840,
        1845,
        2716,
        2714,
        1835,
        1834,
        1832,
        1830,
        1839,
        1837,
        2700,
        2698,
        2695,
        2704,
        1817,
        1811,
        1810,
        897,
        862,
        1777,
        829,
        826,
        838,
        1760,
        1758,
        808,
        2481,
        1741,
        1740,
        1738,
        1743,
        2624,
        1818,
        2726,
        2776,
        782,
        740,
        737,
        1715,
        686,
        679,
        695,
        1682,
        1680,
        639,
        628,
        2339,
        647,
        644,
        1645,
        1643,
        1640,
        1648,
        602,
        600,
        597,
        595,
        2320,
        593,
        2318,
        609,
        607,
        604,
        1611,
        1610,
        1608,
        1606,
        613,
        1615,
        1613,
        2328,
        926,
        924,
        892,
        886,
        899,
        857,
        850,
        2505,
        1778,
        824,
        823,
        821,
        819,
        2488,
        818,
        2486,
        833,
        831,
        828,
        840,
        1761,
        1759,
        2649,
        2632,
        2630,
        2746,
        2734,
        2732,
        2782,
        2781,
        570,
        567,
        1587,
        531,
        527,
        523,
        540,
        1566,
        1564,
        476,
        467,
        463,
        2240,
        486,
        483,
        1524,
        1521,
        1518,
        1529,
        411,
        403,
        2192,
        399,
        2189,
        423,
        416,
        1462,
        1457,
        1454,
        428,
        1468,
        1465,
        2210,
        366,
        363,
        2158,
        360,
        2156,
        357,
        2153,
        376,
        373,
        370,
        2163,
        1410,
        1409,
        1407,
        1405,
        382,
        1402,
        380,
        1417,
        1415,
        1412,
        1421,
        2175,
        2174,
        777,
        774,
        771,
        784,
        732,
        725,
        722,
        2404,
        743,
        1716,
        676,
        674,
        668,
        2363,
        665,
        2360,
        685,
        1684,
        1681,
        626,
        624,
        622,
        2335,
        620,
        2333,
        617,
        2330,
        641,
        635,
        649,
        1646,
        1644,
        1642,
        2566,
        928,
        925,
        2530,
        2527,
        894,
        891,
        888,
        2501,
        2499,
        2496,
        858,
        856,
        854,
        851,
        1779,
        2692,
        2668,
        2665,
        2645,
        2643,
        2640,
        2651,
        2768,
        2759,
        2757,
        2744,
        2743,
        2741,
        2748,
        352,
        1382,
        340,
        337,
        333,
        1371,
        1369,
        307,
        300,
        296,
        2126,
        315,
        312,
        1347,
        1342,
        1350,
        261,
        258,
        250,
        2097,
        246,
        2094,
        271,
        268,
        264,
        1306,
        1301,
        1298,
        276,
        1312,
        1309,
        2115,
        203,
        2048,
        195,
        2045,
        191,
        2041,
        213,
        209,
        2056,
        1246,
        1244,
        1238,
        225,
        1234,
        222,
        1256,
        1253,
        1249,
        1262,
        2080,
        2079,
        154,
        1997,
        150,
        1995,
        147,
        1992,
        1989,
        163,
        160,
        2004,
        156,
        2001,
        1175,
        1174,
        1172,
        1170,
        1167,
        170,
        1164,
        167,
        1185,
        1183,
        1180,
        1177,
        174,
        1190,
        1188,
        2025,
        2024,
        2022,
        587,
        586,
        564,
        559,
        556,
        2290,
        573,
        1588,
        520,
        518,
        512,
        2268,
        508,
        2265,
        530,
        1568,
        1565,
        461,
        457,
        2233,
        450,
        2230,
        446,
        2226,
        479,
        471,
        489,
        1526,
        1523,
        1520,
        397,
        395,
        2185,
        392,
        2183,
        389,
        2180,
        2177,
        410,
        2194,
        402,
        422,
        1463,
        1461,
        1459,
        1456,
        1470,
        2455,
        799,
        2433,
        2430,
        779,
        776,
        773,
        2397,
        2394,
        2390,
        734,
        728,
        724,
        746,
        1717,
        2356,
        2354,
        2351,
        2348,
        1658,
        677,
        675,
        673,
        670,
        667,
        688,
        1685,
        1683,
        2606,
        2589,
        2586,
        2559,
        2556,
        2552,
        927,
        2523,
        2521,
        2518,
        2515,
        1784,
        2532,
        895,
        893,
        890,
        2718,
        2709,
        2707,
        2689,
        2687,
        2684,
        2663,
        2662,
        2660,
        2658,
        1825,
        2667,
        2769,
        1852,
        2760,
        2758,
        142,
        141,
        1139,
        1138,
        134,
        132,
        129,
        126,
        1982,
        1129,
        1128,
        1126,
        1131,
        113,
        111,
        108,
        105,
        1972,
        101,
        1970,
        120,
        118,
        115,
        1109,
        1108,
        1106,
        1104,
        123,
        1113,
        1111,
        82,
        79,
        1951,
        75,
        1949,
        72,
        1946,
        92,
        89,
        86,
        1956,
        1077,
        1076,
        1074,
        1072,
        98,
        1069,
        96,
        1084,
        1082,
        1079,
        1088,
        1968,
        1967,
        48,
        45,
        1916,
        42,
        1914,
        39,
        1911,
        1908,
        60,
        57,
        54,
        1923,
        50,
        1920,
        1031,
        1030,
        1028,
        1026,
        67,
        1023,
        65,
        1020,
        62,
        1041,
        1039,
        1036,
        1033,
        69,
        1046,
        1044,
        1944,
        1943,
        1941,
        11,
        9,
        1868,
        7,
        1865,
        1862,
        1859,
        20,
        1878,
        16,
        1875,
        13,
        1872,
        970,
        968,
        966,
        963,
        29,
        960,
        26,
        23,
        983,
        981,
        978,
        975,
        33,
        971,
        31,
        990,
        988,
        985,
        1906,
        1904,
        1902,
        993,
        351,
        2145,
        1383,
        331,
        330,
        328,
        326,
        2137,
        323,
        2135,
        339,
        1372,
        1370,
        294,
        293,
        291,
        289,
        2122,
        286,
        2120,
        283,
        2117,
        309,
        303,
        317,
        1348,
        1346,
        1344,
        245,
        244,
        242,
        2090,
        239,
        2088,
        236,
        2085,
        2082,
        260,
        2099,
        249,
        270,
        1307,
        1305,
        1303,
        1300,
        1314,
        189,
        2038,
        186,
        2036,
        183,
        2033,
        2030,
        2026,
        206,
        198,
        2047,
        194,
        216,
        1247,
        1245,
        1243,
        1240,
        227,
        1237,
        1255,
        2310,
        2302,
        2300,
        2286,
        2284,
        2281,
        565,
        563,
        561,
        558,
        575,
        1589,
        2261,
        2259,
        2256,
        2253,
        1542,
        521,
        519,
        517,
        514,
        2270,
        511,
        533,
        1569,
        1567,
        2223,
        2221,
        2218,
        2215,
        1483,
        2211,
        1480,
        459,
        456,
        453,
        2232,
        449,
        474,
        491,
        1527,
        1525,
        1522,
        2475,
        2467,
        2465,
        2451,
        2449,
        2446,
        801,
        800,
        2426,
        2424,
        2421,
        2418,
        1723,
        2435,
        780,
        778,
        775,
        2387,
        2385,
        2382,
        2379,
        1695,
        2375,
        1693,
        2396,
        735,
        733,
        730,
        727,
        749,
        1718,
        2616,
        2615,
        2604,
        2603,
        2601,
        2584,
        2583,
        2581,
        2579,
        1800,
        2591,
        2550,
        2549,
        2547,
        2545,
        1792,
        2542,
        1790,
        2558,
        929,
        2719,
        1841,
        2710,
        2708,
        1833,
        1831,
        2690,
        2688,
        2686,
        1815,
        1809,
        1808,
        1774,
        1756,
        1754,
        1737,
        1736,
        1734,
        1739,
        1816,
        1711,
        1676,
        1674,
        633,
        629,
        1638,
        1636,
        1633,
        1641,
        598,
        1605,
        1604,
        1602,
        1600,
        605,
        1609,
        1607,
        2327,
        887,
        853,
        1775,
        822,
        820,
        1757,
        1755,
        1584,
        524,
        1560,
        1558,
        468,
        464,
        1514,
        1511,
        1508,
        1519,
        408,
        404,
        400,
        1452,
        1447,
        1444,
        417,
        1458,
        1455,
        2208,
        364,
        361,
        358,
        2154,
        1401,
        1400,
        1398,
        1396,
        374,
        1393,
        371,
        1408,
        1406,
        1403,
        1413,
        2173,
        2172,
        772,
        726,
        723,
        1712,
        672,
        669,
        666,
        682,
        1678,
        1675,
        625,
        623,
        621,
        618,
        2331,
        636,
        632,
        1639,
        1637,
        1635,
        920,
        918,
        884,
        880,
        889,
        849,
        848,
        847,
        846,
        2497,
        855,
        852,
        1776,
        2641,
        2742,
        2787,
        1380,
        334,
        1367,
        1365,
        301,
        297,
        1340,
        1338,
        1335,
        1343,
        255,
        251,
        247,
        1296,
        1291,
        1288,
        265,
        1302,
        1299,
        2113,
        204,
        196,
        192,
        2042,
        1232,
        1230,
        1224,
        214,
        1220,
        210,
        1242,
        1239,
        1235,
        1250,
        2077,
        2075,
        151,
        148,
        1993,
        144,
        1990,
        1163,
        1162,
        1160,
        1158,
        1155,
        161,
        1152,
        157,
        1173,
        1171,
        1168,
        1165,
        168,
        1181,
        1178,
        2021,
        2020,
        2018,
        2023,
        585,
        560,
        557,
        1585,
        516,
        509,
        1562,
        1559,
        458,
        447,
        2227,
        472,
        1516,
        1513,
        1510,
        398,
        396,
        393,
        390,
        2181,
        386,
        2178,
        407,
        1453,
        1451,
        1449,
        1446,
        420,
        1460,
        2209,
        769,
        764,
        720,
        712,
        2391,
        729,
        1713,
        664,
        663,
        661,
        659,
        2352,
        656,
        2349,
        671,
        1679,
        1677,
        2553,
        922,
        919,
        2519,
        2516,
        885,
        883,
        881,
        2685,
        2661,
        2659,
        2767,
        2756,
        2755,
        140,
        1137,
        1136,
        130,
        127,
        1125,
        1124,
        1122,
        1127,
        109,
        106,
        102,
        1103,
        1102,
        1100,
        1098,
        116,
        1107,
        1105,
        1980,
        80,
        76,
        73,
        1947,
        1068,
        1067,
        1065,
        1063,
        90,
        1060,
        87,
        1075,
        1073,
        1070,
        1080,
        1966,
        1965,
        46,
        43,
        40,
        1912,
        36,
        1909,
        1019,
        1018,
        1016,
        1014,
        58,
        1011,
        55,
        1008,
        51,
        1029,
        1027,
        1024,
        1021,
        63,
        1037,
        1034,
        1940,
        1939,
        1937,
        1942,
        8,
        1866,
        4,
        1863,
        1,
        1860,
        956,
        954,
        952,
        949,
        946,
        17,
        14,
        969,
        967,
        964,
        961,
        27,
        957,
        24,
        979,
        976,
        972,
        1901,
        1900,
        1898,
        1896,
        986,
        1905,
        1903,
        350,
        349,
        1381,
        329,
        327,
        324,
        1368,
        1366,
        292,
        290,
        287,
        284,
        2118,
        304,
        1341,
        1339,
        1337,
        1345,
        243,
        240,
        237,
        2086,
        233,
        2083,
        254,
        1297,
        1295,
        1293,
        1290,
        1304,
        2114,
        190,
        187,
        184,
        2034,
        180,
        2031,
        177,
        2027,
        199,
        1233,
        1231,
        1229,
        1226,
        217,
        1223,
        1241,
        2078,
        2076,
        584,
        555,
        554,
        552,
        550,
        2282,
        562,
        1586,
        507,
        506,
        504,
        502,
        2257,
        499,
        2254,
        515,
        1563,
        1561,
        445,
        443,
        441,
        2219,
        438,
        2216,
        435,
        2212,
        460,
        454,
        475,
        1517,
        1515,
        1512,
        2447,
        798,
        797,
        2422,
        2419,
        770,
        768,
        766,
        2383,
        2380,
        2376,
        721,
        719,
        717,
        714,
        731,
        1714,
        2602,
        2582,
        2580,
        2548,
        2546,
        2543,
        923,
        921,
        2717,
        2706,
        2705,
        2683,
        2682,
        2680,
        1771,
        1752,
        1750,
        1733,
        1732,
        1731,
        1735,
        1814,
        1707,
        1670,
        1668,
        1631,
        1629,
        1626,
        1634,
        1599,
        1598,
        1596,
        1594,
        1603,
        1601,
        2326,
        1772,
        1753,
        1751,
        1581,
        1554,
        1552,
        1504,
        1501,
        1498,
        1509,
        1442,
        1437,
        1434,
        401,
        1448,
        1445,
        2206,
        1392,
        1391,
        1389,
        1387,
        1384,
        359,
        1399,
        1397,
        1394,
        1404,
        2171,
        2170,
        1708,
        1672,
        1669,
        619,
        1632,
        1630,
        1628,
        1773,
        1378,
        1363,
        1361,
        1333,
        1328,
        1336,
        1286,
        1281,
        1278,
        248,
        1292,
        1289,
        2111,
        1218,
        1216,
        1210,
        197,
        1206,
        193,
        1228,
        1225,
        1221,
        1236,
        2073,
        2071,
        1151,
        1150,
        1148,
        1146,
        152,
        1143,
        149,
        1140,
        145,
        1161,
        1159,
        1156,
        1153,
        158,
        1169,
        1166,
        2017,
        2016,
        2014,
        2019,
        1582,
        510,
        1556,
        1553,
        452,
        448,
        1506,
        1500,
        394,
        391,
        387,
        1443,
        1441,
        1439,
        1436,
        1450,
        2207,
        765,
        716,
        713,
        1709,
        662,
        660,
        657,
        1673,
        1671,
        916,
        914,
        879,
        878,
        877,
        882,
        1135,
        1134,
        1121,
        1120,
        1118,
        1123,
        1097,
        1096,
        1094,
        1092,
        103,
        1101,
        1099,
        1979,
        1059,
        1058,
        1056,
        1054,
        77,
        1051,
        74,
        1066,
        1064,
        1061,
        1071,
        1964,
        1963,
        1007,
        1006,
        1004,
        1002,
        999,
        41,
        996,
        37,
        1017,
        1015,
        1012,
        1009,
        52,
        1025,
        1022,
        1936,
        1935,
        1933,
        1938,
        942,
        940,
        938,
        935,
        932,
        5,
        2,
        955,
        953,
        950,
        947,
        18,
        943,
        15,
        965,
        962,
        958,
        1895,
        1894,
        1892,
        1890,
        973,
        1899,
        1897,
        1379,
        325,
        1364,
        1362,
        288,
        285,
        1334,
        1332,
        1330,
        241,
        238,
        234,
        1287,
        1285,
        1283,
        1280,
        1294,
        2112,
        188,
        185,
        181,
        178,
        2028,
        1219,
        1217,
        1215,
        1212,
        200,
        1209,
        1227,
        2074,
        2072,
        583,
        553,
        551,
        1583,
        505,
        503,
        500,
        513,
        1557,
        1555,
        444,
        442,
        439,
        436,
        2213,
        455,
        451,
        1507,
        1505,
        1502,
        796,
        763,
        762,
        760,
        767,
        711,
        710,
        708,
        706,
        2377,
        718,
        715,
        1710,
        2544,
        917,
        915,
        2681,
        1627,
        1597,
        1595,
        2325,
        1769,
        1749,
        1747,
        1499,
        1438,
        1435,
        2204,
        1390,
        1388,
        1385,
        1395,
        2169,
        2167,
        1704,
        1665,
        1662,
        1625,
        1623,
        1620,
        1770,
        1329,
        1282,
        1279,
        2109,
        1214,
        1207,
        1222,
        2068,
        2065,
        1149,
        1147,
        1144,
        1141,
        146,
        1157,
        1154,
        2013,
        2011,
        2008,
        2015,
        1579,
        1549,
        1546,
        1495,
        1487,
        1433,
        1431,
        1428,
        1425,
        388,
        1440,
        2205,
        1705,
        658,
        1667,
        1664,
        1119,
        1095,
        1093,
        1978,
        1057,
        1055,
        1052,
        1062,
        1962,
        1960,
        1005,
        1003,
        1000,
        997,
        38,
        1013,
        1010,
        1932,
        1930,
        1927,
        1934,
        941,
        939,
        936,
        933,
        6,
        930,
        3,
        951,
        948,
        944,
        1889,
        1887,
        1884,
        1881,
        959,
        1893,
        1891,
        35,
        1377,
        1360,
        1358,
        1327,
        1325,
        1322,
        1331,
        1277,
        1275,
        1272,
        1269,
        235,
        1284,
        2110,
        1205,
        1204,
        1201,
        1198,
        182,
        1195,
        179,
        1213,
        2070,
        2067,
        1580,
        501,
        1551,
        1548,
        440,
        437,
        1497,
        1494,
        1490,
        1503,
        761,
        709,
        707,
        1706,
        913,
        912,
        2198,
        1386,
        2164,
        2161,
        1621,
        1766,
        2103,
        1208,
        2058,
        2054,
        1145,
        1142,
        2005,
        2002,
        1999,
        2009,
        1488,
        1429,
        1426,
        2200,
        1698,
        1659,
        1656,
        1975,
        1053,
        1957,
        1954,
        1001,
        998,
        1924,
        1921,
        1918,
        1928,
        937,
        934,
        931,
        1879,
        1876,
        1873,
        1870,
        945,
        1885,
        1882,
        1323,
        1273,
        1270,
        2105,
        1202,
        1199,
        1196,
        1211,
        2061,
        2057,
        1576,
        1543,
        1540,
        1484,
        1481,
        1478,
        1491,
        1700
    ]);
    return PDF417Common;
}();
var $e88025cac1820ce7$export$2e2bcd8739ae039 = $e88025cac1820ce7$var$PDF417Common;

});

parcelRegister("lGVVH", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcaa74d0441a5c4f$export$2e2bcd8739ae039);
/*
* Copyright 2009 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 
var $fwBMA = parcelRequire("fwBMA");

var $b6IL4 = parcelRequire("b6IL4");

var $iYwLM = parcelRequire("iYwLM");

var $7imBX = parcelRequire("7imBX");
var $fcaa74d0441a5c4f$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import java.util.ArrayList;
// import java.util.Arrays;
// import java.util.List;
// import java.util.Map;
/**
 * <p>Encapsulates logic that can detect a PDF417 Code in an image, even if the
 * PDF417 Code is rotated or skewed, or partially obscured.</p>
 *
 * @author SITA Lab (kevin.osullivan@sita.aero)
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Guenther Grau
 */ var $fcaa74d0441a5c4f$var$Detector = /** @class */ function() {
    function Detector() {}
    /**
     * <p>Detects a PDF417 Code in an image. Only checks 0 and 180 degree rotations.</p>
     *
     * @param image barcode image to decode
     * @param hints optional hints to detector
     * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
     * be found and returned
     * @return {@link PDF417DetectorResult} encapsulating results of detecting a PDF417 code
     * @throws NotFoundException if no PDF417 Code can be found
     */ Detector.detectMultiple = function(image, hints, multiple) {
        // TODO detection improvement, tryHarder could try several different luminance thresholds/blackpoints or even
        // different binarizers
        // boolean tryHarder = hints != null && hints.containsKey(DecodeHintType.TRY_HARDER);
        var bitMatrix = image.getBlackMatrix();
        var barcodeCoordinates = Detector.detect(multiple, bitMatrix);
        if (!barcodeCoordinates.length) {
            bitMatrix = bitMatrix.clone();
            bitMatrix.rotate180();
            barcodeCoordinates = Detector.detect(multiple, bitMatrix);
        }
        return new (0, $7imBX.default)(bitMatrix, barcodeCoordinates);
    };
    /**
     * Detects PDF417 codes in an image. Only checks 0 degree rotation
     * @param multiple if true, then the image is searched for multiple codes. If false, then at most one code will
     * be found and returned
     * @param bitMatrix bit matrix to detect barcodes in
     * @return List of ResultPoint arrays containing the coordinates of found barcodes
     */ Detector.detect = function(multiple, bitMatrix) {
        var e_1, _a;
        var barcodeCoordinates = new Array();
        var row = 0;
        var column = 0;
        var foundBarcodeInRow = false;
        while(row < bitMatrix.getHeight()){
            var vertices = Detector.findVertices(bitMatrix, row, column);
            if (vertices[0] == null && vertices[3] == null) {
                if (!foundBarcodeInRow) break;
                // we didn't find a barcode starting at the given column and row. Try again from the first column and slightly
                // below the lowest barcode we found so far.
                foundBarcodeInRow = false;
                column = 0;
                try {
                    for(var barcodeCoordinates_1 = (e_1 = void 0, $fcaa74d0441a5c4f$var$__values(barcodeCoordinates)), barcodeCoordinates_1_1 = barcodeCoordinates_1.next(); !barcodeCoordinates_1_1.done; barcodeCoordinates_1_1 = barcodeCoordinates_1.next()){
                        var barcodeCoordinate = barcodeCoordinates_1_1.value;
                        if (barcodeCoordinate[1] != null) row = Math.trunc(Math.max(row, barcodeCoordinate[1].getY()));
                        if (barcodeCoordinate[3] != null) row = Math.max(row, Math.trunc(barcodeCoordinate[3].getY()));
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (barcodeCoordinates_1_1 && !barcodeCoordinates_1_1.done && (_a = barcodeCoordinates_1.return)) _a.call(barcodeCoordinates_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                row += Detector.ROW_STEP;
                continue;
            }
            foundBarcodeInRow = true;
            barcodeCoordinates.push(vertices);
            if (!multiple) break;
            // if we didn't find a right row indicator column, then continue the search for the next barcode after the
            // start pattern of the barcode just found.
            if (vertices[2] != null) {
                column = Math.trunc(vertices[2].getX());
                row = Math.trunc(vertices[2].getY());
            } else {
                column = Math.trunc(vertices[4].getX());
                row = Math.trunc(vertices[4].getY());
            }
        }
        return barcodeCoordinates;
    };
    /**
     * Locate the vertices and the codewords area of a black blob using the Start
     * and Stop patterns as locators.
     *
     * @param matrix the scanned barcode image.
     * @return an array containing the vertices:
     *           vertices[0] x, y top left barcode
     *           vertices[1] x, y bottom left barcode
     *           vertices[2] x, y top right barcode
     *           vertices[3] x, y bottom right barcode
     *           vertices[4] x, y top left codeword area
     *           vertices[5] x, y bottom left codeword area
     *           vertices[6] x, y top right codeword area
     *           vertices[7] x, y bottom right codeword area
     */ Detector.findVertices = function(matrix, startRow, startColumn) {
        var height = matrix.getHeight();
        var width = matrix.getWidth();
        // const result = new ResultPoint[8];
        var result = new Array(8);
        Detector.copyToResult(result, Detector.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector.START_PATTERN), Detector.INDEXES_START_PATTERN);
        if (result[4] != null) {
            startColumn = Math.trunc(result[4].getX());
            startRow = Math.trunc(result[4].getY());
        }
        Detector.copyToResult(result, Detector.findRowsWithPattern(matrix, height, width, startRow, startColumn, Detector.STOP_PATTERN), Detector.INDEXES_STOP_PATTERN);
        return result;
    };
    Detector.copyToResult = function(result, tmpResult, destinationIndexes) {
        for(var i = 0; i < destinationIndexes.length; i++)result[destinationIndexes[i]] = tmpResult[i];
    };
    Detector.findRowsWithPattern = function(matrix, height, width, startRow, startColumn, pattern) {
        // const result = new ResultPoint[4];
        var result = new Array(4);
        var found = false;
        var counters = new Int32Array(pattern.length);
        for(; startRow < height; startRow += Detector.ROW_STEP){
            var loc = Detector.findGuardPattern(matrix, startColumn, startRow, width, false, pattern, counters);
            if (loc != null) {
                while(startRow > 0){
                    var previousRowLoc = Detector.findGuardPattern(matrix, startColumn, --startRow, width, false, pattern, counters);
                    if (previousRowLoc != null) loc = previousRowLoc;
                    else {
                        startRow++;
                        break;
                    }
                }
                result[0] = new (0, $fwBMA.default)(loc[0], startRow);
                result[1] = new (0, $fwBMA.default)(loc[1], startRow);
                found = true;
                break;
            }
        }
        var stopRow = startRow + 1;
        // Last row of the current symbol that contains pattern
        if (found) {
            var skippedRowCount = 0;
            var previousRowLoc = Int32Array.from([
                Math.trunc(result[0].getX()),
                Math.trunc(result[1].getX())
            ]);
            for(; stopRow < height; stopRow++){
                var loc = Detector.findGuardPattern(matrix, previousRowLoc[0], stopRow, width, false, pattern, counters);
                // a found pattern is only considered to belong to the same barcode if the start and end positions
                // don't differ too much. Pattern drift should be not bigger than two for consecutive rows. With
                // a higher number of skipped rows drift could be larger. To keep it simple for now, we allow a slightly
                // larger drift and don't check for skipped rows.
                if (loc != null && Math.abs(previousRowLoc[0] - loc[0]) < Detector.MAX_PATTERN_DRIFT && Math.abs(previousRowLoc[1] - loc[1]) < Detector.MAX_PATTERN_DRIFT) {
                    previousRowLoc = loc;
                    skippedRowCount = 0;
                } else {
                    if (skippedRowCount > Detector.SKIPPED_ROW_COUNT_MAX) break;
                    else skippedRowCount++;
                }
            }
            stopRow -= skippedRowCount + 1;
            result[2] = new (0, $fwBMA.default)(previousRowLoc[0], stopRow);
            result[3] = new (0, $fwBMA.default)(previousRowLoc[1], stopRow);
        }
        if (stopRow - startRow < Detector.BARCODE_MIN_HEIGHT) (0, $iYwLM.default).fill(result, null);
        return result;
    };
    /**
     * @param matrix row of black/white values to search
     * @param column x position to start search
     * @param row y position to start search
     * @param width the number of pixels to search on this row
     * @param pattern pattern of counts of number of black and white pixels that are
     *                 being searched for as a pattern
     * @param counters array of counters, as long as pattern, to re-use
     * @return start/end horizontal offset of guard pattern, as an array of two ints.
     */ Detector.findGuardPattern = function(matrix, column, row, width, whiteFirst, pattern, counters) {
        (0, $iYwLM.default).fillWithin(counters, 0, counters.length, 0);
        var patternStart = column;
        var pixelDrift = 0;
        // if there are black pixels left of the current pixel shift to the left, but only for MAX_PIXEL_DRIFT pixels
        while(matrix.get(patternStart, row) && patternStart > 0 && pixelDrift++ < Detector.MAX_PIXEL_DRIFT)patternStart--;
        var x = patternStart;
        var counterPosition = 0;
        var patternLength = pattern.length;
        for(var isWhite = whiteFirst; x < width; x++){
            var pixel = matrix.get(x, row);
            if (pixel !== isWhite) counters[counterPosition]++;
            else {
                if (counterPosition === patternLength - 1) {
                    if (Detector.patternMatchVariance(counters, pattern, Detector.MAX_INDIVIDUAL_VARIANCE) < Detector.MAX_AVG_VARIANCE) return new Int32Array([
                        patternStart,
                        x
                    ]);
                    patternStart += counters[0] + counters[1];
                    (0, $b6IL4.default).arraycopy(counters, 2, counters, 0, counterPosition - 1);
                    counters[counterPosition - 1] = 0;
                    counters[counterPosition] = 0;
                    counterPosition--;
                } else counterPosition++;
                counters[counterPosition] = 1;
                isWhite = !isWhite;
            }
        }
        if (counterPosition === patternLength - 1 && Detector.patternMatchVariance(counters, pattern, Detector.MAX_INDIVIDUAL_VARIANCE) < Detector.MAX_AVG_VARIANCE) return new Int32Array([
            patternStart,
            x - 1
        ]);
        return null;
    };
    /**
     * Determines how closely a set of observed counts of runs of black/white
     * values matches a given target pattern. This is reported as the ratio of
     * the total variance from the expected pattern proportions across all
     * pattern elements, to the length of the pattern.
     *
     * @param counters observed counters
     * @param pattern expected pattern
     * @param maxIndividualVariance The most any counter can differ before we give up
     * @return ratio of total variance between counters and pattern compared to total pattern size
     */ Detector.patternMatchVariance = function(counters, pattern, maxIndividualVariance) {
        var numCounters = counters.length;
        var total = 0;
        var patternLength = 0;
        for(var i = 0; i < numCounters; i++){
            total += counters[i];
            patternLength += pattern[i];
        }
        if (total < patternLength) // If we don't even have one pixel per unit of bar width, assume this
        // is too small to reliably match, so fail:
        return /*Float.POSITIVE_INFINITY*/ Infinity;
        // We're going to fake floating-point math in integers. We just need to use more bits.
        // Scale up patternLength so that intermediate values below like scaledCounter will have
        // more "significant digits".
        var unitBarWidth = total / patternLength;
        maxIndividualVariance *= unitBarWidth;
        var totalVariance = 0.0;
        for(var x = 0; x < numCounters; x++){
            var counter = counters[x];
            var scaledPattern = pattern[x] * unitBarWidth;
            var variance = counter > scaledPattern ? counter - scaledPattern : scaledPattern - counter;
            if (variance > maxIndividualVariance) return /*Float.POSITIVE_INFINITY*/ Infinity;
            totalVariance += variance;
        }
        return totalVariance / total;
    };
    Detector.INDEXES_START_PATTERN = Int32Array.from([
        0,
        4,
        1,
        5
    ]);
    Detector.INDEXES_STOP_PATTERN = Int32Array.from([
        6,
        2,
        7,
        3
    ]);
    Detector.MAX_AVG_VARIANCE = 0.42;
    Detector.MAX_INDIVIDUAL_VARIANCE = 0.8;
    // B S B S B S B S Bar/Space pattern
    // 11111111 0 1 0 1 0 1 000
    Detector.START_PATTERN = Int32Array.from([
        8,
        1,
        1,
        1,
        1,
        1,
        1,
        3
    ]);
    // 1111111 0 1 000 1 0 1 00 1
    Detector.STOP_PATTERN = Int32Array.from([
        7,
        1,
        1,
        3,
        1,
        1,
        1,
        2,
        1
    ]);
    Detector.MAX_PIXEL_DRIFT = 3;
    Detector.MAX_PATTERN_DRIFT = 5;
    // if we set the value too low, then we don't detect the correct height of the bar if the start patterns are damaged.
    // if we set the value too high, then we might detect the start pattern from a neighbor barcode.
    Detector.SKIPPED_ROW_COUNT_MAX = 25;
    // A PDF471 barcode should have at least 3 rows, with each row being >= 3 times the module width. Therefore it should be at least
    // 9 pixels tall. To be conservative, we use about half the size to ensure we don't miss it.
    Detector.ROW_STEP = 5;
    Detector.BARCODE_MIN_HEIGHT = 10;
    return Detector;
}();
var $fcaa74d0441a5c4f$export$2e2bcd8739ae039 = $fcaa74d0441a5c4f$var$Detector;

});
parcelRegister("7imBX", function(module, exports) {

$parcel$export(module.exports, "default", () => $54fbc0f12342299e$export$2e2bcd8739ae039);
/*
* Copyright 2007 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // import java.util.List;
/**
 * @author Guenther Grau
 */ var $54fbc0f12342299e$var$PDF417DetectorResult = /** @class */ function() {
    function PDF417DetectorResult(bits, points) {
        this.bits = bits;
        this.points = points;
    }
    PDF417DetectorResult.prototype.getBits = function() {
        return this.bits;
    };
    PDF417DetectorResult.prototype.getPoints = function() {
        return this.points;
    };
    return PDF417DetectorResult;
}();
var $54fbc0f12342299e$export$2e2bcd8739ae039 = $54fbc0f12342299e$var$PDF417DetectorResult;

});


parcelRegister("23suV", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f1f7a86fe6c74f$export$2e2bcd8739ae039);
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 
var $9Nn2d = parcelRequire("9Nn2d");

var $dtgr5 = parcelRequire("dtgr5");

var $cQi30 = parcelRequire("cQi30");

var $fbOCK = parcelRequire("fbOCK");

var $jXATC = parcelRequire("jXATC");

var $2wCgm = parcelRequire("2wCgm");

var $9K45D = parcelRequire("9K45D");

var $9ltkf = parcelRequire("9ltkf");

var $4rkOA = parcelRequire("4rkOA");

var $esg3G = parcelRequire("esg3G");

var $jPkxs = parcelRequire("jPkxs");

var $ck5kQ = parcelRequire("ck5kQ");

var $4G83W = parcelRequire("4G83W");

var $3AG8d = parcelRequire("3AG8d");

var $kzy6R = parcelRequire("kzy6R");
var $17f1f7a86fe6c74f$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// import java.util.ArrayList;
// import java.util.Collection;
// import java.util.Formatter;
// import java.util.List;
/**
 * @author Guenther Grau
 */ var $17f1f7a86fe6c74f$var$PDF417ScanningDecoder = /** @class */ function() {
    function PDF417ScanningDecoder() {}
    /**
     * @TODO don't pass in minCodewordWidth and maxCodewordWidth, pass in barcode columns for start and stop pattern
     *
     * columns. That way width can be deducted from the pattern column.
     * This approach also allows to detect more details about the barcode, e.g. if a bar type (white or black) is wider
     * than it should be. This can happen if the scanner used a bad blackpoint.
     *
     * @param BitMatrix
     * @param image
     * @param ResultPoint
     * @param imageTopLeft
     * @param ResultPoint
     * @param imageBottomLeft
     * @param ResultPoint
     * @param imageTopRight
     * @param ResultPoint
     * @param imageBottomRight
     * @param int
     * @param minCodewordWidth
     * @param int
     * @param maxCodewordWidth
     *
     * @throws NotFoundException
     * @throws FormatException
     * @throws ChecksumException
     */ PDF417ScanningDecoder.decode = function(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight, minCodewordWidth, maxCodewordWidth) {
        var boundingBox = new (0, $9K45D.default)(image, imageTopLeft, imageBottomLeft, imageTopRight, imageBottomRight);
        var leftRowIndicatorColumn = null;
        var rightRowIndicatorColumn = null;
        var detectionResult;
        for(var firstPass /*boolean*/  = true;; firstPass = false){
            if (imageTopLeft != null) leftRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopLeft, true, minCodewordWidth, maxCodewordWidth);
            if (imageTopRight != null) rightRowIndicatorColumn = PDF417ScanningDecoder.getRowIndicatorColumn(image, boundingBox, imageTopRight, false, minCodewordWidth, maxCodewordWidth);
            detectionResult = PDF417ScanningDecoder.merge(leftRowIndicatorColumn, rightRowIndicatorColumn);
            if (detectionResult == null) throw (0, $cQi30.default).getNotFoundInstance();
            var resultBox = detectionResult.getBoundingBox();
            if (firstPass && resultBox != null && (resultBox.getMinY() < boundingBox.getMinY() || resultBox.getMaxY() > boundingBox.getMaxY())) boundingBox = resultBox;
            else break;
        }
        detectionResult.setBoundingBox(boundingBox);
        var maxBarcodeColumn = detectionResult.getBarcodeColumnCount() + 1;
        detectionResult.setDetectionResultColumn(0, leftRowIndicatorColumn);
        detectionResult.setDetectionResultColumn(maxBarcodeColumn, rightRowIndicatorColumn);
        var leftToRight = leftRowIndicatorColumn != null;
        for(var barcodeColumnCount /*int*/  = 1; barcodeColumnCount <= maxBarcodeColumn; barcodeColumnCount++){
            var barcodeColumn = leftToRight ? barcodeColumnCount : maxBarcodeColumn - barcodeColumnCount;
            if (detectionResult.getDetectionResultColumn(barcodeColumn) !== /* null */ undefined) continue;
            var detectionResultColumn = void 0;
            if (barcodeColumn === 0 || barcodeColumn === maxBarcodeColumn) detectionResultColumn = new (0, $9ltkf.default)(boundingBox, barcodeColumn === 0);
            else detectionResultColumn = new (0, $esg3G.default)(boundingBox);
            detectionResult.setDetectionResultColumn(barcodeColumn, detectionResultColumn);
            var startColumn = -1;
            var previousStartColumn = startColumn;
            // TODO start at a row for which we know the start position, then detect upwards and downwards from there.
            for(var imageRow /*int*/  = boundingBox.getMinY(); imageRow <= boundingBox.getMaxY(); imageRow++){
                startColumn = PDF417ScanningDecoder.getStartColumn(detectionResult, barcodeColumn, imageRow, leftToRight);
                if (startColumn < 0 || startColumn > boundingBox.getMaxX()) {
                    if (previousStartColumn === -1) continue;
                    startColumn = previousStartColumn;
                }
                var codeword = PDF417ScanningDecoder.detectCodeword(image, boundingBox.getMinX(), boundingBox.getMaxX(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                if (codeword != null) {
                    detectionResultColumn.setCodeword(imageRow, codeword);
                    previousStartColumn = startColumn;
                    minCodewordWidth = Math.min(minCodewordWidth, codeword.getWidth());
                    maxCodewordWidth = Math.max(maxCodewordWidth, codeword.getWidth());
                }
            }
        }
        return PDF417ScanningDecoder.createDecoderResult(detectionResult);
    };
    /**
     *
     * @param leftRowIndicatorColumn
     * @param rightRowIndicatorColumn
     *
     * @throws NotFoundException
     */ PDF417ScanningDecoder.merge = function(leftRowIndicatorColumn, rightRowIndicatorColumn) {
        if (leftRowIndicatorColumn == null && rightRowIndicatorColumn == null) return null;
        var barcodeMetadata = PDF417ScanningDecoder.getBarcodeMetadata(leftRowIndicatorColumn, rightRowIndicatorColumn);
        if (barcodeMetadata == null) return null;
        var boundingBox = (0, $9K45D.default).merge(PDF417ScanningDecoder.adjustBoundingBox(leftRowIndicatorColumn), PDF417ScanningDecoder.adjustBoundingBox(rightRowIndicatorColumn));
        return new (0, $4rkOA.default)(barcodeMetadata, boundingBox);
    };
    /**
     *
     * @param rowIndicatorColumn
     *
     * @throws NotFoundException
     */ PDF417ScanningDecoder.adjustBoundingBox = function(rowIndicatorColumn) {
        var e_1, _a;
        if (rowIndicatorColumn == null) return null;
        var rowHeights = rowIndicatorColumn.getRowHeights();
        if (rowHeights == null) return null;
        var maxRowHeight = PDF417ScanningDecoder.getMax(rowHeights);
        var missingStartRows = 0;
        try {
            for(var rowHeights_1 = $17f1f7a86fe6c74f$var$__values(rowHeights), rowHeights_1_1 = rowHeights_1.next(); !rowHeights_1_1.done; rowHeights_1_1 = rowHeights_1.next()){
                var rowHeight = rowHeights_1_1.value /*int*/ ;
                missingStartRows += maxRowHeight - rowHeight;
                if (rowHeight > 0) break;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (rowHeights_1_1 && !rowHeights_1_1.done && (_a = rowHeights_1.return)) _a.call(rowHeights_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var codewords = rowIndicatorColumn.getCodewords();
        for(var row /*int*/  = 0; missingStartRows > 0 && codewords[row] == null; row++)missingStartRows--;
        var missingEndRows = 0;
        for(var row /*int*/  = rowHeights.length - 1; row >= 0; row--){
            missingEndRows += maxRowHeight - rowHeights[row];
            if (rowHeights[row] > 0) break;
        }
        for(var row /*int*/  = codewords.length - 1; missingEndRows > 0 && codewords[row] == null; row--)missingEndRows--;
        return rowIndicatorColumn.getBoundingBox().addMissingRows(missingStartRows, missingEndRows, rowIndicatorColumn.isLeft());
    };
    PDF417ScanningDecoder.getMax = function(values) {
        var e_2, _a;
        var maxValue = -1;
        try {
            for(var values_1 = $17f1f7a86fe6c74f$var$__values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()){
                var value = values_1_1.value /*int*/ ;
                maxValue = Math.max(maxValue, value);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return maxValue;
    };
    PDF417ScanningDecoder.getBarcodeMetadata = function(leftRowIndicatorColumn, rightRowIndicatorColumn) {
        var leftBarcodeMetadata;
        if (leftRowIndicatorColumn == null || (leftBarcodeMetadata = leftRowIndicatorColumn.getBarcodeMetadata()) == null) return rightRowIndicatorColumn == null ? null : rightRowIndicatorColumn.getBarcodeMetadata();
        var rightBarcodeMetadata;
        if (rightRowIndicatorColumn == null || (rightBarcodeMetadata = rightRowIndicatorColumn.getBarcodeMetadata()) == null) return leftBarcodeMetadata;
        if (leftBarcodeMetadata.getColumnCount() !== rightBarcodeMetadata.getColumnCount() && leftBarcodeMetadata.getErrorCorrectionLevel() !== rightBarcodeMetadata.getErrorCorrectionLevel() && leftBarcodeMetadata.getRowCount() !== rightBarcodeMetadata.getRowCount()) return null;
        return leftBarcodeMetadata;
    };
    PDF417ScanningDecoder.getRowIndicatorColumn = function(image, boundingBox, startPoint, leftToRight, minCodewordWidth, maxCodewordWidth) {
        var rowIndicatorColumn = new (0, $9ltkf.default)(boundingBox, leftToRight);
        for(var i /*int*/  = 0; i < 2; i++){
            var increment = i === 0 ? 1 : -1;
            var startColumn = Math.trunc(Math.trunc(startPoint.getX()));
            for(var imageRow /*int*/  = Math.trunc(Math.trunc(startPoint.getY())); imageRow <= boundingBox.getMaxY() && imageRow >= boundingBox.getMinY(); imageRow += increment){
                var codeword = PDF417ScanningDecoder.detectCodeword(image, 0, image.getWidth(), leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth);
                if (codeword != null) {
                    rowIndicatorColumn.setCodeword(imageRow, codeword);
                    if (leftToRight) startColumn = codeword.getStartX();
                    else startColumn = codeword.getEndX();
                }
            }
        }
        return rowIndicatorColumn;
    };
    /**
     *
     * @param detectionResult
     * @param BarcodeValue
     * @param param2
     * @param param3
     * @param barcodeMatrix
     *
     * @throws NotFoundException
     */ PDF417ScanningDecoder.adjustCodewordCount = function(detectionResult, barcodeMatrix) {
        var barcodeMatrix01 = barcodeMatrix[0][1];
        var numberOfCodewords = barcodeMatrix01.getValue();
        var calculatedNumberOfCodewords = detectionResult.getBarcodeColumnCount() * detectionResult.getBarcodeRowCount() - PDF417ScanningDecoder.getNumberOfECCodeWords(detectionResult.getBarcodeECLevel());
        if (numberOfCodewords.length === 0) {
            if (calculatedNumberOfCodewords < 1 || calculatedNumberOfCodewords > (0, $jXATC.default).MAX_CODEWORDS_IN_BARCODE) throw (0, $cQi30.default).getNotFoundInstance();
            barcodeMatrix01.setValue(calculatedNumberOfCodewords);
        } else if (numberOfCodewords[0] !== calculatedNumberOfCodewords) // The calculated one is more reliable as it is derived from the row indicator columns
        barcodeMatrix01.setValue(calculatedNumberOfCodewords);
    };
    /**
     *
     * @param detectionResult
     *
     * @throws FormatException
     * @throws ChecksumException
     * @throws NotFoundException
     */ PDF417ScanningDecoder.createDecoderResult = function(detectionResult) {
        var barcodeMatrix = PDF417ScanningDecoder.createBarcodeMatrix(detectionResult);
        PDF417ScanningDecoder.adjustCodewordCount(detectionResult, barcodeMatrix);
        var erasures /*Collection<Integer>*/  = new Array();
        var codewords = new Int32Array(detectionResult.getBarcodeRowCount() * detectionResult.getBarcodeColumnCount());
        var ambiguousIndexValuesList = /*List<int[]>*/ [];
        var ambiguousIndexesList = /*Collection<Integer>*/ new Array();
        for(var row /*int*/  = 0; row < detectionResult.getBarcodeRowCount(); row++)for(var column /*int*/  = 0; column < detectionResult.getBarcodeColumnCount(); column++){
            var values = barcodeMatrix[row][column + 1].getValue();
            var codewordIndex = row * detectionResult.getBarcodeColumnCount() + column;
            if (values.length === 0) erasures.push(codewordIndex);
            else if (values.length === 1) codewords[codewordIndex] = values[0];
            else {
                ambiguousIndexesList.push(codewordIndex);
                ambiguousIndexValuesList.push(values);
            }
        }
        var ambiguousIndexValues = new Array(ambiguousIndexValuesList.length);
        for(var i /*int*/  = 0; i < ambiguousIndexValues.length; i++)ambiguousIndexValues[i] = ambiguousIndexValuesList[i];
        return PDF417ScanningDecoder.createDecoderResultFromAmbiguousValues(detectionResult.getBarcodeECLevel(), codewords, (0, $jXATC.default).toIntArray(erasures), (0, $jXATC.default).toIntArray(ambiguousIndexesList), ambiguousIndexValues);
    };
    /**
     * This method deals with the fact, that the decoding process doesn't always yield a single most likely value. The
     * current error correction implementation doesn't deal with erasures very well, so it's better to provide a value
     * for these ambiguous codewords instead of treating it as an erasure. The problem is that we don't know which of
     * the ambiguous values to choose. We try decode using the first value, and if that fails, we use another of the
     * ambiguous values and try to decode again. This usually only happens on very hard to read and decode barcodes,
     * so decoding the normal barcodes is not affected by this.
     *
     * @param erasureArray contains the indexes of erasures
     * @param ambiguousIndexes array with the indexes that have more than one most likely value
     * @param ambiguousIndexValues two dimensional array that contains the ambiguous values. The first dimension must
     * be the same length as the ambiguousIndexes array
     *
     * @throws FormatException
     * @throws ChecksumException
     */ PDF417ScanningDecoder.createDecoderResultFromAmbiguousValues = function(ecLevel, codewords, erasureArray, ambiguousIndexes, ambiguousIndexValues) {
        var ambiguousIndexCount = new Int32Array(ambiguousIndexes.length);
        var tries = 100;
        while(tries-- > 0){
            for(var i /*int*/  = 0; i < ambiguousIndexCount.length; i++)codewords[ambiguousIndexes[i]] = ambiguousIndexValues[i][ambiguousIndexCount[i]];
            try {
                return PDF417ScanningDecoder.decodeCodewords(codewords, ecLevel, erasureArray);
            } catch (err) {
                var ignored = err instanceof (0, $9Nn2d.default);
                if (!ignored) throw err;
            }
            if (ambiguousIndexCount.length === 0) throw (0, $9Nn2d.default).getChecksumInstance();
            for(var i /*int*/  = 0; i < ambiguousIndexCount.length; i++)if (ambiguousIndexCount[i] < ambiguousIndexValues[i].length - 1) {
                ambiguousIndexCount[i]++;
                break;
            } else {
                ambiguousIndexCount[i] = 0;
                if (i === ambiguousIndexCount.length - 1) throw (0, $9Nn2d.default).getChecksumInstance();
            }
        }
        throw (0, $9Nn2d.default).getChecksumInstance();
    };
    PDF417ScanningDecoder.createBarcodeMatrix = function(detectionResult) {
        var e_3, _a, e_4, _b;
        // let barcodeMatrix: BarcodeValue[][] =
        // new BarcodeValue[detectionResult.getBarcodeRowCount()][detectionResult.getBarcodeColumnCount() + 2];
        var barcodeMatrix = Array.from({
            length: detectionResult.getBarcodeRowCount()
        }, function() {
            return new Array(detectionResult.getBarcodeColumnCount() + 2);
        });
        for(var row /*int*/  = 0; row < barcodeMatrix.length; row++)for(var column_1 /*int*/  = 0; column_1 < barcodeMatrix[row].length; column_1++)barcodeMatrix[row][column_1] = new (0, $ck5kQ.default)();
        var column = 0;
        try {
            for(var _c = $17f1f7a86fe6c74f$var$__values(detectionResult.getDetectionResultColumns()), _d = _c.next(); !_d.done; _d = _c.next()){
                var detectionResultColumn = _d.value /*DetectionResultColumn*/ ;
                if (detectionResultColumn != null) try {
                    for(var _e = (e_4 = void 0, $17f1f7a86fe6c74f$var$__values(detectionResultColumn.getCodewords())), _f = _e.next(); !_f.done; _f = _e.next()){
                        var codeword = _f.value /*Codeword*/ ;
                        if (codeword != null) {
                            var rowNumber = codeword.getRowNumber();
                            if (rowNumber >= 0) {
                                if (rowNumber >= barcodeMatrix.length) continue;
                                barcodeMatrix[rowNumber][column].setValue(codeword.getValue());
                            }
                        }
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
                column++;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return barcodeMatrix;
    };
    PDF417ScanningDecoder.isValidBarcodeColumn = function(detectionResult, barcodeColumn) {
        return barcodeColumn >= 0 && barcodeColumn <= detectionResult.getBarcodeColumnCount() + 1;
    };
    PDF417ScanningDecoder.getStartColumn = function(detectionResult, barcodeColumn, imageRow, leftToRight) {
        var e_5, _a;
        var offset = leftToRight ? 1 : -1;
        var codeword = null;
        if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodeword(imageRow);
        if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
        codeword = detectionResult.getDetectionResultColumn(barcodeColumn).getCodewordNearby(imageRow);
        if (codeword != null) return leftToRight ? codeword.getStartX() : codeword.getEndX();
        if (PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)) codeword = detectionResult.getDetectionResultColumn(barcodeColumn - offset).getCodewordNearby(imageRow);
        if (codeword != null) return leftToRight ? codeword.getEndX() : codeword.getStartX();
        var skippedColumns = 0;
        while(PDF417ScanningDecoder.isValidBarcodeColumn(detectionResult, barcodeColumn - offset)){
            barcodeColumn -= offset;
            try {
                for(var _b = (e_5 = void 0, $17f1f7a86fe6c74f$var$__values(detectionResult.getDetectionResultColumn(barcodeColumn).getCodewords())), _c = _b.next(); !_c.done; _c = _b.next()){
                    var previousRowCodeword = _c.value /*Codeword*/ ;
                    if (previousRowCodeword != null) return (leftToRight ? previousRowCodeword.getEndX() : previousRowCodeword.getStartX()) + offset * skippedColumns * (previousRowCodeword.getEndX() - previousRowCodeword.getStartX());
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            skippedColumns++;
        }
        return leftToRight ? detectionResult.getBoundingBox().getMinX() : detectionResult.getBoundingBox().getMaxX();
    };
    PDF417ScanningDecoder.detectCodeword = function(image, minColumn, maxColumn, leftToRight, startColumn, imageRow, minCodewordWidth, maxCodewordWidth) {
        startColumn = PDF417ScanningDecoder.adjustCodewordStartColumn(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
        // we usually know fairly exact now how long a codeword is. We should provide minimum and maximum expected length
        // and try to adjust the read pixels, e.g. remove single pixel errors or try to cut off exceeding pixels.
        // min and maxCodewordWidth should not be used as they are calculated for the whole barcode an can be inaccurate
        // for the current position
        var moduleBitCount = PDF417ScanningDecoder.getModuleBitCount(image, minColumn, maxColumn, leftToRight, startColumn, imageRow);
        if (moduleBitCount == null) return null;
        var endColumn;
        var codewordBitCount = (0, $fbOCK.default).sum(moduleBitCount);
        if (leftToRight) endColumn = startColumn + codewordBitCount;
        else {
            for(var i /*int*/  = 0; i < moduleBitCount.length / 2; i++){
                var tmpCount = moduleBitCount[i];
                moduleBitCount[i] = moduleBitCount[moduleBitCount.length - 1 - i];
                moduleBitCount[moduleBitCount.length - 1 - i] = tmpCount;
            }
            endColumn = startColumn;
            startColumn = endColumn - codewordBitCount;
        }
        // TODO implement check for width and correction of black and white bars
        // use start (and maybe stop pattern) to determine if black bars are wider than white bars. If so, adjust.
        // should probably done only for codewords with a lot more than 17 bits.
        // The following fixes 10-1.png, which has wide black bars and small white bars
        //    for (let i /*int*/ = 0; i < moduleBitCount.length; i++) {
        //      if (i % 2 === 0) {
        //        moduleBitCount[i]--;
        //      } else {
        //        moduleBitCount[i]++;
        //      }
        //    }
        // We could also use the width of surrounding codewords for more accurate results, but this seems
        // sufficient for now
        if (!PDF417ScanningDecoder.checkCodewordSkew(codewordBitCount, minCodewordWidth, maxCodewordWidth)) // We could try to use the startX and endX position of the codeword in the same column in the previous row,
        // create the bit count from it and normalize it to 8. This would help with single pixel errors.
        return null;
        var decodedValue = (0, $4G83W.default).getDecodedValue(moduleBitCount);
        var codeword = (0, $jXATC.default).getCodeword(decodedValue);
        if (codeword === -1) return null;
        return new (0, $jPkxs.default)(startColumn, endColumn, PDF417ScanningDecoder.getCodewordBucketNumber(decodedValue), codeword);
    };
    PDF417ScanningDecoder.getModuleBitCount = function(image, minColumn, maxColumn, leftToRight, startColumn, imageRow) {
        var imageColumn = startColumn;
        var moduleBitCount = new Int32Array(8);
        var moduleNumber = 0;
        var increment = leftToRight ? 1 : -1;
        var previousPixelValue = leftToRight;
        while((leftToRight ? imageColumn < maxColumn : imageColumn >= minColumn) && moduleNumber < moduleBitCount.length)if (image.get(imageColumn, imageRow) === previousPixelValue) {
            moduleBitCount[moduleNumber]++;
            imageColumn += increment;
        } else {
            moduleNumber++;
            previousPixelValue = !previousPixelValue;
        }
        if (moduleNumber === moduleBitCount.length || imageColumn === (leftToRight ? maxColumn : minColumn) && moduleNumber === moduleBitCount.length - 1) return moduleBitCount;
        return null;
    };
    PDF417ScanningDecoder.getNumberOfECCodeWords = function(barcodeECLevel) {
        return 2 << barcodeECLevel;
    };
    PDF417ScanningDecoder.adjustCodewordStartColumn = function(image, minColumn, maxColumn, leftToRight, codewordStartColumn, imageRow) {
        var correctedStartColumn = codewordStartColumn;
        var increment = leftToRight ? -1 : 1;
        // there should be no black pixels before the start column. If there are, then we need to start earlier.
        for(var i /*int*/  = 0; i < 2; i++){
            while((leftToRight ? correctedStartColumn >= minColumn : correctedStartColumn < maxColumn) && leftToRight === image.get(correctedStartColumn, imageRow)){
                if (Math.abs(codewordStartColumn - correctedStartColumn) > PDF417ScanningDecoder.CODEWORD_SKEW_SIZE) return codewordStartColumn;
                correctedStartColumn += increment;
            }
            increment = -increment;
            leftToRight = !leftToRight;
        }
        return correctedStartColumn;
    };
    PDF417ScanningDecoder.checkCodewordSkew = function(codewordSize, minCodewordWidth, maxCodewordWidth) {
        return minCodewordWidth - PDF417ScanningDecoder.CODEWORD_SKEW_SIZE <= codewordSize && codewordSize <= maxCodewordWidth + PDF417ScanningDecoder.CODEWORD_SKEW_SIZE;
    };
    /**
     * @throws FormatException,
     * @throws ChecksumException
     */ PDF417ScanningDecoder.decodeCodewords = function(codewords, ecLevel, erasures) {
        if (codewords.length === 0) throw (0, $dtgr5.default).getFormatInstance();
        var numECCodewords = 1 << ecLevel + 1;
        var correctedErrorsCount = PDF417ScanningDecoder.correctErrors(codewords, erasures, numECCodewords);
        PDF417ScanningDecoder.verifyCodewordCount(codewords, numECCodewords);
        // Decode the codewords
        var decoderResult = (0, $3AG8d.default).decode(codewords, "" + ecLevel);
        decoderResult.setErrorsCorrected(correctedErrorsCount);
        decoderResult.setErasures(erasures.length);
        return decoderResult;
    };
    /**
     * <p>Given data and error-correction codewords received, possibly corrupted by errors, attempts to
     * correct the errors in-place.</p>
     *
     * @param codewords   data and error correction codewords
     * @param erasures positions of any known erasures
     * @param numECCodewords number of error correction codewords that are available in codewords
     * @throws ChecksumException if error correction fails
     */ PDF417ScanningDecoder.correctErrors = function(codewords, erasures, numECCodewords) {
        if (erasures != null && erasures.length > numECCodewords / 2 + PDF417ScanningDecoder.MAX_ERRORS || numECCodewords < 0 || numECCodewords > PDF417ScanningDecoder.MAX_EC_CODEWORDS) // Too many errors or EC Codewords is corrupted
        throw (0, $9Nn2d.default).getChecksumInstance();
        return PDF417ScanningDecoder.errorCorrection.decode(codewords, numECCodewords, erasures);
    };
    /**
     * Verify that all is OK with the codeword array.
     * @throws FormatException
     */ PDF417ScanningDecoder.verifyCodewordCount = function(codewords, numECCodewords) {
        if (codewords.length < 4) // Codeword array size should be at least 4 allowing for
        // Count CW, At least one Data CW, Error Correction CW, Error Correction CW
        throw (0, $dtgr5.default).getFormatInstance();
        // The first codeword, the Symbol Length Descriptor, shall always encode the total number of data
        // codewords in the symbol, including the Symbol Length Descriptor itself, data codewords and pad
        // codewords, but excluding the number of error correction codewords.
        var numberOfCodewords = codewords[0];
        if (numberOfCodewords > codewords.length) throw (0, $dtgr5.default).getFormatInstance();
        if (numberOfCodewords === 0) {
            // Reset to the length of the array - 8 (Allow for at least level 3 Error Correction (8 Error Codewords)
            if (numECCodewords < codewords.length) codewords[0] = codewords.length - numECCodewords;
            else throw (0, $dtgr5.default).getFormatInstance();
        }
    };
    PDF417ScanningDecoder.getBitCountForCodeword = function(codeword) {
        var result = new Int32Array(8);
        var previousValue = 0;
        var i = result.length - 1;
        while(true){
            if ((codeword & 0x1) !== previousValue) {
                previousValue = codeword & 0x1;
                i--;
                if (i < 0) break;
            }
            result[i]++;
            codeword >>= 1;
        }
        return result;
    };
    PDF417ScanningDecoder.getCodewordBucketNumber = function(codeword) {
        if (codeword instanceof Int32Array) return this.getCodewordBucketNumber_Int32Array(codeword);
        return this.getCodewordBucketNumber_number(codeword);
    };
    PDF417ScanningDecoder.getCodewordBucketNumber_number = function(codeword) {
        return PDF417ScanningDecoder.getCodewordBucketNumber(PDF417ScanningDecoder.getBitCountForCodeword(codeword));
    };
    PDF417ScanningDecoder.getCodewordBucketNumber_Int32Array = function(moduleBitCount) {
        return (moduleBitCount[0] - moduleBitCount[2] + moduleBitCount[4] - moduleBitCount[6] + 9) % 9;
    };
    PDF417ScanningDecoder.toString = function(barcodeMatrix) {
        var formatter = new (0, $kzy6R.default)();
        // try (let formatter = new Formatter()) {
        for(var row /*int*/  = 0; row < barcodeMatrix.length; row++){
            formatter.format("Row %2d: ", row);
            for(var column /*int*/  = 0; column < barcodeMatrix[row].length; column++){
                var barcodeValue = barcodeMatrix[row][column];
                if (barcodeValue.getValue().length === 0) formatter.format("        ", null);
                else formatter.format("%4d(%2d)", barcodeValue.getValue()[0], barcodeValue.getConfidence(barcodeValue.getValue()[0]));
            }
            formatter.format("%n");
        }
        return formatter.toString();
    // }
    };
    /*final*/ PDF417ScanningDecoder.CODEWORD_SKEW_SIZE = 2;
    /*final*/ PDF417ScanningDecoder.MAX_ERRORS = 3;
    /*final*/ PDF417ScanningDecoder.MAX_EC_CODEWORDS = 512;
    /*final*/ PDF417ScanningDecoder.errorCorrection = new (0, $2wCgm.default)();
    return PDF417ScanningDecoder;
}();
var $17f1f7a86fe6c74f$export$2e2bcd8739ae039 = $17f1f7a86fe6c74f$var$PDF417ScanningDecoder;

});
parcelRegister("2wCgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d6c4027b075be68$export$2e2bcd8739ae039);
/*
* Copyright 2012 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 
var $9Nn2d = parcelRequire("9Nn2d");

var $ctAFJ = parcelRequire("ctAFJ");

var $8TkDD = parcelRequire("8TkDD");
var $1d6c4027b075be68$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * <p>PDF417 error correction implementation.</p>
 *
 * <p>This <a href="http://en.wikipedia.org/wiki/Reed%E2%80%93Solomon_error_correction#Example">example</a>
 * is quite useful in understanding the algorithm.</p>
 *
 * @author Sean Owen
 * @see com.google.zxing.common.reedsolomon.ReedSolomonDecoder
 */ var $1d6c4027b075be68$var$ErrorCorrection = /** @class */ function() {
    function ErrorCorrection() {
        this.field = (0, $8TkDD.default).PDF417_GF;
    }
    /**
     * @param received received codewords
     * @param numECCodewords number of those codewords used for EC
     * @param erasures location of erasures
     * @return number of errors
     * @throws ChecksumException if errors cannot be corrected, maybe because of too many errors
     */ ErrorCorrection.prototype.decode = function(received, numECCodewords, erasures) {
        var e_1, _a;
        var poly = new (0, $ctAFJ.default)(this.field, received);
        var S = new Int32Array(numECCodewords);
        var error = false;
        for(var i /*int*/  = numECCodewords; i > 0; i--){
            var evaluation = poly.evaluateAt(this.field.exp(i));
            S[numECCodewords - i] = evaluation;
            if (evaluation !== 0) error = true;
        }
        if (!error) return 0;
        var knownErrors = this.field.getOne();
        if (erasures != null) try {
            for(var erasures_1 = $1d6c4027b075be68$var$__values(erasures), erasures_1_1 = erasures_1.next(); !erasures_1_1.done; erasures_1_1 = erasures_1.next()){
                var erasure = erasures_1_1.value;
                var b = this.field.exp(received.length - 1 - erasure);
                // Add (1 - bx) term:
                var term = new (0, $ctAFJ.default)(this.field, new Int32Array([
                    this.field.subtract(0, b),
                    1
                ]));
                knownErrors = knownErrors.multiply(term);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (erasures_1_1 && !erasures_1_1.done && (_a = erasures_1.return)) _a.call(erasures_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        var syndrome = new (0, $ctAFJ.default)(this.field, S);
        // syndrome = syndrome.multiply(knownErrors);
        var sigmaOmega = this.runEuclideanAlgorithm(this.field.buildMonomial(numECCodewords, 1), syndrome, numECCodewords);
        var sigma = sigmaOmega[0];
        var omega = sigmaOmega[1];
        // sigma = sigma.multiply(knownErrors);
        var errorLocations = this.findErrorLocations(sigma);
        var errorMagnitudes = this.findErrorMagnitudes(omega, sigma, errorLocations);
        for(var i /*int*/  = 0; i < errorLocations.length; i++){
            var position = received.length - 1 - this.field.log(errorLocations[i]);
            if (position < 0) throw (0, $9Nn2d.default).getChecksumInstance();
            received[position] = this.field.subtract(received[position], errorMagnitudes[i]);
        }
        return errorLocations.length;
    };
    /**
     *
     * @param ModulusPoly
     * @param a
     * @param ModulusPoly
     * @param b
     * @param int
     * @param R
     * @throws ChecksumException
     */ ErrorCorrection.prototype.runEuclideanAlgorithm = function(a, b, R) {
        // Assume a's degree is >= b's
        if (a.getDegree() < b.getDegree()) {
            var temp = a;
            a = b;
            b = temp;
        }
        var rLast = a;
        var r = b;
        var tLast = this.field.getZero();
        var t = this.field.getOne();
        // Run Euclidean algorithm until r's degree is less than R/2
        while(r.getDegree() >= Math.round(R / 2)){
            var rLastLast = rLast;
            var tLastLast = tLast;
            rLast = r;
            tLast = t;
            // Divide rLastLast by rLast, with quotient in q and remainder in r
            if (rLast.isZero()) // Oops, Euclidean algorithm already terminated?
            throw (0, $9Nn2d.default).getChecksumInstance();
            r = rLastLast;
            var q = this.field.getZero();
            var denominatorLeadingTerm = rLast.getCoefficient(rLast.getDegree());
            var dltInverse = this.field.inverse(denominatorLeadingTerm);
            while(r.getDegree() >= rLast.getDegree() && !r.isZero()){
                var degreeDiff = r.getDegree() - rLast.getDegree();
                var scale = this.field.multiply(r.getCoefficient(r.getDegree()), dltInverse);
                q = q.add(this.field.buildMonomial(degreeDiff, scale));
                r = r.subtract(rLast.multiplyByMonomial(degreeDiff, scale));
            }
            t = q.multiply(tLast).subtract(tLastLast).negative();
        }
        var sigmaTildeAtZero = t.getCoefficient(0);
        if (sigmaTildeAtZero === 0) throw (0, $9Nn2d.default).getChecksumInstance();
        var inverse = this.field.inverse(sigmaTildeAtZero);
        var sigma = t.multiply(inverse);
        var omega = r.multiply(inverse);
        return [
            sigma,
            omega
        ];
    };
    /**
     *
     * @param errorLocator
     * @throws ChecksumException
     */ ErrorCorrection.prototype.findErrorLocations = function(errorLocator) {
        // This is a direct application of Chien's search
        var numErrors = errorLocator.getDegree();
        var result = new Int32Array(numErrors);
        var e = 0;
        for(var i /*int*/  = 1; i < this.field.getSize() && e < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
            result[e] = this.field.inverse(i);
            e++;
        }
        if (e !== numErrors) throw (0, $9Nn2d.default).getChecksumInstance();
        return result;
    };
    ErrorCorrection.prototype.findErrorMagnitudes = function(errorEvaluator, errorLocator, errorLocations) {
        var errorLocatorDegree = errorLocator.getDegree();
        var formalDerivativeCoefficients = new Int32Array(errorLocatorDegree);
        for(var i /*int*/  = 1; i <= errorLocatorDegree; i++)formalDerivativeCoefficients[errorLocatorDegree - i] = this.field.multiply(i, errorLocator.getCoefficient(i));
        var formalDerivative = new (0, $ctAFJ.default)(this.field, formalDerivativeCoefficients);
        // This is directly applying Forney's Formula
        var s = errorLocations.length;
        var result = new Int32Array(s);
        for(var i /*int*/  = 0; i < s; i++){
            var xiInverse = this.field.inverse(errorLocations[i]);
            var numerator = this.field.subtract(0, errorEvaluator.evaluateAt(xiInverse));
            var denominator = this.field.inverse(formalDerivative.evaluateAt(xiInverse));
            result[i] = this.field.multiply(numerator, denominator);
        }
        return result;
    };
    return ErrorCorrection;
}();
var $1d6c4027b075be68$export$2e2bcd8739ae039 = $1d6c4027b075be68$var$ErrorCorrection;

});
parcelRegister("ctAFJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9154a3c5e7406a78$export$2e2bcd8739ae039);
/*
* Copyright 2012 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 
var $kLpae = parcelRequire("kLpae");

var $b6IL4 = parcelRequire("b6IL4");

var $6E9N1 = parcelRequire("6E9N1");
var $9154a3c5e7406a78$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author Sean Owen
 * @see com.google.zxing.common.reedsolomon.GenericGFPoly
 */ var $9154a3c5e7406a78$var$ModulusPoly = /** @class */ function() {
    function ModulusPoly(field, coefficients) {
        if (coefficients.length === 0) throw new (0, $kLpae.default)();
        this.field = field;
        var coefficientsLength = /*int*/ coefficients.length;
        if (coefficientsLength > 1 && coefficients[0] === 0) {
            // Leading term must be non-zero for anything except the constant polynomial "0"
            var firstNonZero = /*int*/ 1;
            while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
            if (firstNonZero === coefficientsLength) this.coefficients = new Int32Array([
                0
            ]);
            else {
                this.coefficients = new Int32Array(coefficientsLength - firstNonZero);
                (0, $b6IL4.default).arraycopy(coefficients, firstNonZero, this.coefficients, 0, this.coefficients.length);
            }
        } else this.coefficients = coefficients;
    }
    ModulusPoly.prototype.getCoefficients = function() {
        return this.coefficients;
    };
    /**
     * @return degree of this polynomial
     */ ModulusPoly.prototype.getDegree = function() {
        return this.coefficients.length - 1;
    };
    /**
     * @return true iff this polynomial is the monomial "0"
     */ ModulusPoly.prototype.isZero = function() {
        return this.coefficients[0] === 0;
    };
    /**
     * @return coefficient of x^degree term in this polynomial
     */ ModulusPoly.prototype.getCoefficient = function(degree) {
        return this.coefficients[this.coefficients.length - 1 - degree];
    };
    /**
     * @return evaluation of this polynomial at a given point
     */ ModulusPoly.prototype.evaluateAt = function(a) {
        var e_1, _a;
        if (a === 0) // Just return the x^0 coefficient
        return this.getCoefficient(0);
        if (a === 1) {
            // Just the sum of the coefficients
            var sum = /*int*/ 0;
            try {
                for(var _b = $9154a3c5e7406a78$var$__values(this.coefficients), _c = _b.next(); !_c.done; _c = _b.next()){
                    var coefficient = _c.value /*int*/ ;
                    sum = this.field.add(sum, coefficient);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return sum;
        }
        var result = /*int*/ this.coefficients[0];
        var size = /*int*/ this.coefficients.length;
        for(var i /*int*/  = 1; i < size; i++)result = this.field.add(this.field.multiply(a, result), this.coefficients[i]);
        return result;
    };
    ModulusPoly.prototype.add = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $kLpae.default)("ModulusPolys do not have same ModulusGF field");
        if (this.isZero()) return other;
        if (other.isZero()) return this;
        var smallerCoefficients = this.coefficients;
        var largerCoefficients = other.coefficients;
        if (smallerCoefficients.length > largerCoefficients.length) {
            var temp = smallerCoefficients;
            smallerCoefficients = largerCoefficients;
            largerCoefficients = temp;
        }
        var sumDiff = new Int32Array(largerCoefficients.length);
        var lengthDiff = /*int*/ largerCoefficients.length - smallerCoefficients.length;
        // Copy high-order terms only found in higher-degree polynomial's coefficients
        (0, $b6IL4.default).arraycopy(largerCoefficients, 0, sumDiff, 0, lengthDiff);
        for(var i /*int*/  = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = this.field.add(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
        return new ModulusPoly(this.field, sumDiff);
    };
    ModulusPoly.prototype.subtract = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $kLpae.default)("ModulusPolys do not have same ModulusGF field");
        if (other.isZero()) return this;
        return this.add(other.negative());
    };
    ModulusPoly.prototype.multiply = function(other) {
        if (other instanceof ModulusPoly) return this.multiplyOther(other);
        return this.multiplyScalar(other);
    };
    ModulusPoly.prototype.multiplyOther = function(other) {
        if (!this.field.equals(other.field)) throw new (0, $kLpae.default)("ModulusPolys do not have same ModulusGF field");
        if (this.isZero() || other.isZero()) // return this.field.getZero();
        return new ModulusPoly(this.field, new Int32Array([
            0
        ]));
        var aCoefficients = this.coefficients;
        var aLength = /*int*/ aCoefficients.length;
        var bCoefficients = other.coefficients;
        var bLength = /*int*/ bCoefficients.length;
        var product = new Int32Array(aLength + bLength - 1);
        for(var i /*int*/  = 0; i < aLength; i++){
            var aCoeff = /*int*/ aCoefficients[i];
            for(var j /*int*/  = 0; j < bLength; j++)product[i + j] = this.field.add(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
        }
        return new ModulusPoly(this.field, product);
    };
    ModulusPoly.prototype.negative = function() {
        var size = /*int*/ this.coefficients.length;
        var negativeCoefficients = new Int32Array(size);
        for(var i /*int*/  = 0; i < size; i++)negativeCoefficients[i] = this.field.subtract(0, this.coefficients[i]);
        return new ModulusPoly(this.field, negativeCoefficients);
    };
    ModulusPoly.prototype.multiplyScalar = function(scalar) {
        if (scalar === 0) return new ModulusPoly(this.field, new Int32Array([
            0
        ]));
        if (scalar === 1) return this;
        var size = /*int*/ this.coefficients.length;
        var product = new Int32Array(size);
        for(var i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], scalar);
        return new ModulusPoly(this.field, product);
    };
    ModulusPoly.prototype.multiplyByMonomial = function(degree, coefficient) {
        if (degree < 0) throw new (0, $kLpae.default)();
        if (coefficient === 0) return new ModulusPoly(this.field, new Int32Array([
            0
        ]));
        var size = /*int*/ this.coefficients.length;
        var product = new Int32Array(size + degree);
        for(var i /*int*/  = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], coefficient);
        return new ModulusPoly(this.field, product);
    };
    /*
    ModulusPoly[] divide(other: ModulusPoly) {
      if (!field.equals(other.field)) {
        throw new IllegalArgumentException("ModulusPolys do not have same ModulusGF field");
      }
      if (other.isZero()) {
        throw new IllegalArgumentException("Divide by 0");
      }
  
      let quotient: ModulusPoly = field.getZero();
      let remainder: ModulusPoly = this;
  
      let denominatorLeadingTerm: /*int/ number = other.getCoefficient(other.getDegree());
      let inverseDenominatorLeadingTerm: /*int/ number = field.inverse(denominatorLeadingTerm);
  
      while (remainder.getDegree() >= other.getDegree() && !remainder.isZero()) {
        let degreeDifference: /*int/ number = remainder.getDegree() - other.getDegree();
        let scale: /*int/ number = field.multiply(remainder.getCoefficient(remainder.getDegree()), inverseDenominatorLeadingTerm);
        let term: ModulusPoly = other.multiplyByMonomial(degreeDifference, scale);
        let iterationQuotient: ModulusPoly = field.buildMonomial(degreeDifference, scale);
        quotient = quotient.add(iterationQuotient);
        remainder = remainder.subtract(term);
      }
  
      return new ModulusPoly[] { quotient, remainder };
    }
    */ // @Override
    ModulusPoly.prototype.toString = function() {
        var result = new (0, $6E9N1.default)(); // dynamic string size in JS
        for(var degree /*int*/  = this.getDegree(); degree >= 0; degree--){
            var coefficient = /*int*/ this.getCoefficient(degree);
            if (coefficient !== 0) {
                if (coefficient < 0) {
                    result.append(" - ");
                    coefficient = -coefficient;
                } else if (result.length() > 0) result.append(" + ");
                if (degree === 0 || coefficient !== 1) result.append(coefficient);
                if (degree !== 0) {
                    if (degree === 1) result.append("x");
                    else {
                        result.append("x^");
                        result.append(degree);
                    }
                }
            }
        }
        return result.toString();
    };
    return ModulusPoly;
}();
var $9154a3c5e7406a78$export$2e2bcd8739ae039 = $9154a3c5e7406a78$var$ModulusPoly;

});

parcelRegister("8TkDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6793781b1efe6daa$export$2e2bcd8739ae039);
/*
 * Copyright 2012 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jXATC = parcelRequire("jXATC");

var $ctAFJ = parcelRequire("ctAFJ");

var $kLpae = parcelRequire("kLpae");

var $a1gMw = parcelRequire("a1gMw");
var $6793781b1efe6daa$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * <p>A field based on powers of a generator integer, modulo some modulus.</p>
 *
 * @author Sean Owen
 * @see com.google.zxing.common.reedsolomon.GenericGF
 */ var $6793781b1efe6daa$var$ModulusGF = /** @class */ function(_super) {
    $6793781b1efe6daa$var$__extends(ModulusGF, _super);
    // private /*final*/ modulus: /*int*/ number;
    function ModulusGF(modulus, generator) {
        var _this = _super.call(this) || this;
        _this.modulus = modulus;
        _this.expTable = new Int32Array(modulus);
        _this.logTable = new Int32Array(modulus);
        var x = /*int*/ 1;
        for(var i /*int*/  = 0; i < modulus; i++){
            _this.expTable[i] = x;
            x = x * generator % modulus;
        }
        for(var i /*int*/  = 0; i < modulus - 1; i++)_this.logTable[_this.expTable[i]] = i;
        // logTable[0] == 0 but this should never be used
        _this.zero = new (0, $ctAFJ.default)(_this, new Int32Array([
            0
        ]));
        _this.one = new (0, $ctAFJ.default)(_this, new Int32Array([
            1
        ]));
        return _this;
    }
    ModulusGF.prototype.getZero = function() {
        return this.zero;
    };
    ModulusGF.prototype.getOne = function() {
        return this.one;
    };
    ModulusGF.prototype.buildMonomial = function(degree, coefficient) {
        if (degree < 0) throw new (0, $kLpae.default)();
        if (coefficient === 0) return this.zero;
        var coefficients = new Int32Array(degree + 1);
        coefficients[0] = coefficient;
        return new (0, $ctAFJ.default)(this, coefficients);
    };
    ModulusGF.PDF417_GF = new ModulusGF((0, $jXATC.default).NUMBER_OF_CODEWORDS, 3);
    return ModulusGF;
}((0, $a1gMw.default));
var $6793781b1efe6daa$export$2e2bcd8739ae039 = $6793781b1efe6daa$var$ModulusGF;

});
parcelRegister("a1gMw", function(module, exports) {

$parcel$export(module.exports, "default", () => $74b703d68844c10a$export$2e2bcd8739ae039);

var $kLpae = parcelRequire("kLpae");

var $72EX6 = parcelRequire("72EX6");
var $74b703d68844c10a$var$ModulusBase = /** @class */ function() {
    function ModulusBase() {}
    ModulusBase.prototype.add = function(a, b) {
        return (a + b) % this.modulus;
    };
    ModulusBase.prototype.subtract = function(a, b) {
        return (this.modulus + a - b) % this.modulus;
    };
    ModulusBase.prototype.exp = function(a) {
        return this.expTable[a];
    };
    ModulusBase.prototype.log = function(a) {
        if (a === 0) throw new (0, $kLpae.default)();
        return this.logTable[a];
    };
    ModulusBase.prototype.inverse = function(a) {
        if (a === 0) throw new (0, $72EX6.default)();
        return this.expTable[this.modulus - this.logTable[a] - 1];
    };
    ModulusBase.prototype.multiply = function(a, b) {
        if (a === 0 || b === 0) return 0;
        return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.modulus - 1)];
    };
    ModulusBase.prototype.getSize = function() {
        return this.modulus;
    };
    ModulusBase.prototype.equals = function(o) {
        return o === this;
    };
    return ModulusBase;
}();
var $74b703d68844c10a$export$2e2bcd8739ae039 = $74b703d68844c10a$var$ModulusBase;

});



parcelRegister("9K45D", function(module, exports) {

$parcel$export(module.exports, "default", () => $717b951b3df130e8$export$2e2bcd8739ae039);
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // package com.google.zxing.pdf417.decoder;
// import com.google.zxing.NotFoundException;

var $cQi30 = parcelRequire("cQi30");

var $fwBMA = parcelRequire("fwBMA");
/**
 * @author Guenther Grau
 */ var $717b951b3df130e8$var$BoundingBox = /** @class */ function() {
    function BoundingBox(image, topLeft, bottomLeft, topRight, bottomRight) {
        if (image instanceof BoundingBox) this.constructor_2(image);
        else this.constructor_1(image, topLeft, bottomLeft, topRight, bottomRight);
    }
    /**
     *
     * @param image
     * @param topLeft
     * @param bottomLeft
     * @param topRight
     * @param bottomRight
     *
     * @throws NotFoundException
     */ BoundingBox.prototype.constructor_1 = function(image, topLeft, bottomLeft, topRight, bottomRight) {
        var leftUnspecified = topLeft == null || bottomLeft == null;
        var rightUnspecified = topRight == null || bottomRight == null;
        if (leftUnspecified && rightUnspecified) throw new (0, $cQi30.default)();
        if (leftUnspecified) {
            topLeft = new (0, $fwBMA.default)(0, topRight.getY());
            bottomLeft = new (0, $fwBMA.default)(0, bottomRight.getY());
        } else if (rightUnspecified) {
            topRight = new (0, $fwBMA.default)(image.getWidth() - 1, topLeft.getY());
            bottomRight = new (0, $fwBMA.default)(image.getWidth() - 1, bottomLeft.getY());
        }
        this.image = image;
        this.topLeft = topLeft;
        this.bottomLeft = bottomLeft;
        this.topRight = topRight;
        this.bottomRight = bottomRight;
        this.minX = Math.trunc(Math.min(topLeft.getX(), bottomLeft.getX()));
        this.maxX = Math.trunc(Math.max(topRight.getX(), bottomRight.getX()));
        this.minY = Math.trunc(Math.min(topLeft.getY(), topRight.getY()));
        this.maxY = Math.trunc(Math.max(bottomLeft.getY(), bottomRight.getY()));
    };
    BoundingBox.prototype.constructor_2 = function(boundingBox) {
        this.image = boundingBox.image;
        this.topLeft = boundingBox.getTopLeft();
        this.bottomLeft = boundingBox.getBottomLeft();
        this.topRight = boundingBox.getTopRight();
        this.bottomRight = boundingBox.getBottomRight();
        this.minX = boundingBox.getMinX();
        this.maxX = boundingBox.getMaxX();
        this.minY = boundingBox.getMinY();
        this.maxY = boundingBox.getMaxY();
    };
    /**
     * @throws NotFoundException
     */ BoundingBox.merge = function(leftBox, rightBox) {
        if (leftBox == null) return rightBox;
        if (rightBox == null) return leftBox;
        return new BoundingBox(leftBox.image, leftBox.topLeft, leftBox.bottomLeft, rightBox.topRight, rightBox.bottomRight);
    };
    /**
     * @throws NotFoundException
     */ BoundingBox.prototype.addMissingRows = function(missingStartRows, missingEndRows, isLeft) {
        var newTopLeft = this.topLeft;
        var newBottomLeft = this.bottomLeft;
        var newTopRight = this.topRight;
        var newBottomRight = this.bottomRight;
        if (missingStartRows > 0) {
            var top_1 = isLeft ? this.topLeft : this.topRight;
            var newMinY = Math.trunc(top_1.getY() - missingStartRows);
            if (newMinY < 0) newMinY = 0;
            var newTop = new (0, $fwBMA.default)(top_1.getX(), newMinY);
            if (isLeft) newTopLeft = newTop;
            else newTopRight = newTop;
        }
        if (missingEndRows > 0) {
            var bottom = isLeft ? this.bottomLeft : this.bottomRight;
            var newMaxY = Math.trunc(bottom.getY() + missingEndRows);
            if (newMaxY >= this.image.getHeight()) newMaxY = this.image.getHeight() - 1;
            var newBottom = new (0, $fwBMA.default)(bottom.getX(), newMaxY);
            if (isLeft) newBottomLeft = newBottom;
            else newBottomRight = newBottom;
        }
        return new BoundingBox(this.image, newTopLeft, newBottomLeft, newTopRight, newBottomRight);
    };
    BoundingBox.prototype.getMinX = function() {
        return this.minX;
    };
    BoundingBox.prototype.getMaxX = function() {
        return this.maxX;
    };
    BoundingBox.prototype.getMinY = function() {
        return this.minY;
    };
    BoundingBox.prototype.getMaxY = function() {
        return this.maxY;
    };
    BoundingBox.prototype.getTopLeft = function() {
        return this.topLeft;
    };
    BoundingBox.prototype.getTopRight = function() {
        return this.topRight;
    };
    BoundingBox.prototype.getBottomLeft = function() {
        return this.bottomLeft;
    };
    BoundingBox.prototype.getBottomRight = function() {
        return this.bottomRight;
    };
    return BoundingBox;
}();
var $717b951b3df130e8$export$2e2bcd8739ae039 = $717b951b3df130e8$var$BoundingBox;

});

parcelRegister("9ltkf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cdcd2a550684666$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jXATC = parcelRequire("jXATC");

var $nbNAu = parcelRequire("nbNAu");

var $esg3G = parcelRequire("esg3G");

var $ck5kQ = parcelRequire("ck5kQ");
var $6cdcd2a550684666$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6cdcd2a550684666$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author Guenther Grau
 */ var $6cdcd2a550684666$var$DetectionResultRowIndicatorColumn = /** @class */ function(_super) {
    $6cdcd2a550684666$var$__extends(DetectionResultRowIndicatorColumn, _super);
    function DetectionResultRowIndicatorColumn(boundingBox, isLeft) {
        var _this = _super.call(this, boundingBox) || this;
        _this._isLeft = isLeft;
        return _this;
    }
    DetectionResultRowIndicatorColumn.prototype.setRowNumbers = function() {
        var e_1, _a;
        try {
            for(var _b = $6cdcd2a550684666$var$__values(this.getCodewords()), _c = _b.next(); !_c.done; _c = _b.next()){
                var codeword = _c.value /*Codeword*/ ;
                if (codeword != null) codeword.setRowNumberAsRowIndicatorColumn();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    // TODO implement properly
    // TODO maybe we should add missing codewords to store the correct row number to make
    // finding row numbers for other columns easier
    // use row height count to make detection of invalid row numbers more reliable
    DetectionResultRowIndicatorColumn.prototype.adjustCompleteIndicatorColumnRowNumbers = function(barcodeMetadata) {
        var codewords = this.getCodewords();
        this.setRowNumbers();
        this.removeIncorrectCodewords(codewords, barcodeMetadata);
        var boundingBox = this.getBoundingBox();
        var top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
        var bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
        var firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
        var lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
        // We need to be careful using the average row height. Barcode could be skewed so that we have smaller and
        // taller rows
        // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
        var barcodeRow = -1;
        var maxRowHeight = 1;
        var currentRowHeight = 0;
        for(var codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
            if (codewords[codewordsRow] == null) continue;
            var codeword = codewords[codewordsRow];
            //      float expectedRowNumber = (codewordsRow - firstRow) / averageRowHeight;
            //      if (Math.abs(codeword.getRowNumber() - expectedRowNumber) > 2) {
            //        SimpleLog.log(LEVEL.WARNING,
            //            "Removing codeword, rowNumberSkew too high, codeword[" + codewordsRow + "]: Expected Row: " +
            //                expectedRowNumber + ", RealRow: " + codeword.getRowNumber() + ", value: " + codeword.getValue());
            //        codewords[codewordsRow] = null;
            //      }
            var rowDifference = codeword.getRowNumber() - barcodeRow;
            // TODO improve handling with case where first row indicator doesn't start with 0
            if (rowDifference === 0) currentRowHeight++;
            else if (rowDifference === 1) {
                maxRowHeight = Math.max(maxRowHeight, currentRowHeight);
                currentRowHeight = 1;
                barcodeRow = codeword.getRowNumber();
            } else if (rowDifference < 0 || codeword.getRowNumber() >= barcodeMetadata.getRowCount() || rowDifference > codewordsRow) codewords[codewordsRow] = null;
            else {
                var checkedRows = void 0;
                if (maxRowHeight > 2) checkedRows = (maxRowHeight - 2) * rowDifference;
                else checkedRows = rowDifference;
                var closePreviousCodewordFound = checkedRows >= codewordsRow;
                for(var i /*int*/  = 1; i <= checkedRows && !closePreviousCodewordFound; i++)// there must be (height * rowDifference) number of codewords missing. For now we assume height = 1.
                // This should hopefully get rid of most problems already.
                closePreviousCodewordFound = codewords[codewordsRow - i] != null;
                if (closePreviousCodewordFound) codewords[codewordsRow] = null;
                else {
                    barcodeRow = codeword.getRowNumber();
                    currentRowHeight = 1;
                }
            }
        }
    // return (int) (averageRowHeight + 0.5);
    };
    DetectionResultRowIndicatorColumn.prototype.getRowHeights = function() {
        var e_2, _a;
        var barcodeMetadata = this.getBarcodeMetadata();
        if (barcodeMetadata == null) return null;
        this.adjustIncompleteIndicatorColumnRowNumbers(barcodeMetadata);
        var result = new Int32Array(barcodeMetadata.getRowCount());
        try {
            for(var _b = $6cdcd2a550684666$var$__values(this.getCodewords()), _c = _b.next(); !_c.done; _c = _b.next()){
                var codeword = _c.value /*Codeword*/ ;
                if (codeword != null) {
                    var rowNumber = codeword.getRowNumber();
                    if (rowNumber >= result.length) continue;
                    result[rowNumber]++;
                } // else throw exception?
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
    // TODO maybe we should add missing codewords to store the correct row number to make
    // finding row numbers for other columns easier
    // use row height count to make detection of invalid row numbers more reliable
    DetectionResultRowIndicatorColumn.prototype.adjustIncompleteIndicatorColumnRowNumbers = function(barcodeMetadata) {
        var boundingBox = this.getBoundingBox();
        var top = this._isLeft ? boundingBox.getTopLeft() : boundingBox.getTopRight();
        var bottom = this._isLeft ? boundingBox.getBottomLeft() : boundingBox.getBottomRight();
        var firstRow = this.imageRowToCodewordIndex(Math.trunc(top.getY()));
        var lastRow = this.imageRowToCodewordIndex(Math.trunc(bottom.getY()));
        // float averageRowHeight = (lastRow - firstRow) / /*(float)*/ barcodeMetadata.getRowCount();
        var codewords = this.getCodewords();
        var barcodeRow = -1;
        var maxRowHeight = 1;
        var currentRowHeight = 0;
        for(var codewordsRow /*int*/  = firstRow; codewordsRow < lastRow; codewordsRow++){
            if (codewords[codewordsRow] == null) continue;
            var codeword = codewords[codewordsRow];
            codeword.setRowNumberAsRowIndicatorColumn();
            var rowDifference = codeword.getRowNumber() - barcodeRow;
            // TODO improve handling with case where first row indicator doesn't start with 0
            if (rowDifference === 0) currentRowHeight++;
            else if (rowDifference === 1) {
                maxRowHeight = Math.max(maxRowHeight, currentRowHeight);
                currentRowHeight = 1;
                barcodeRow = codeword.getRowNumber();
            } else if (codeword.getRowNumber() >= barcodeMetadata.getRowCount()) codewords[codewordsRow] = null;
            else {
                barcodeRow = codeword.getRowNumber();
                currentRowHeight = 1;
            }
        }
    // return (int) (averageRowHeight + 0.5);
    };
    DetectionResultRowIndicatorColumn.prototype.getBarcodeMetadata = function() {
        var e_3, _a;
        var codewords = this.getCodewords();
        var barcodeColumnCount = new (0, $ck5kQ.default)();
        var barcodeRowCountUpperPart = new (0, $ck5kQ.default)();
        var barcodeRowCountLowerPart = new (0, $ck5kQ.default)();
        var barcodeECLevel = new (0, $ck5kQ.default)();
        try {
            for(var codewords_1 = $6cdcd2a550684666$var$__values(codewords), codewords_1_1 = codewords_1.next(); !codewords_1_1.done; codewords_1_1 = codewords_1.next()){
                var codeword = codewords_1_1.value /*Codeword*/ ;
                if (codeword == null) continue;
                codeword.setRowNumberAsRowIndicatorColumn();
                var rowIndicatorValue = codeword.getValue() % 30;
                var codewordRowNumber = codeword.getRowNumber();
                if (!this._isLeft) codewordRowNumber += 2;
                switch(codewordRowNumber % 3){
                    case 0:
                        barcodeRowCountUpperPart.setValue(rowIndicatorValue * 3 + 1);
                        break;
                    case 1:
                        barcodeECLevel.setValue(rowIndicatorValue / 3);
                        barcodeRowCountLowerPart.setValue(rowIndicatorValue % 3);
                        break;
                    case 2:
                        barcodeColumnCount.setValue(rowIndicatorValue + 1);
                        break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (codewords_1_1 && !codewords_1_1.done && (_a = codewords_1.return)) _a.call(codewords_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        // Maybe we should check if we have ambiguous values?
        if (barcodeColumnCount.getValue().length === 0 || barcodeRowCountUpperPart.getValue().length === 0 || barcodeRowCountLowerPart.getValue().length === 0 || barcodeECLevel.getValue().length === 0 || barcodeColumnCount.getValue()[0] < 1 || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] < (0, $jXATC.default).MIN_ROWS_IN_BARCODE || barcodeRowCountUpperPart.getValue()[0] + barcodeRowCountLowerPart.getValue()[0] > (0, $jXATC.default).MAX_ROWS_IN_BARCODE) return null;
        var barcodeMetadata = new (0, $nbNAu.default)(barcodeColumnCount.getValue()[0], barcodeRowCountUpperPart.getValue()[0], barcodeRowCountLowerPart.getValue()[0], barcodeECLevel.getValue()[0]);
        this.removeIncorrectCodewords(codewords, barcodeMetadata);
        return barcodeMetadata;
    };
    DetectionResultRowIndicatorColumn.prototype.removeIncorrectCodewords = function(codewords, barcodeMetadata) {
        // Remove codewords which do not match the metadata
        // TODO Maybe we should keep the incorrect codewords for the start and end positions?
        for(var codewordRow /*int*/  = 0; codewordRow < codewords.length; codewordRow++){
            var codeword = codewords[codewordRow];
            if (codewords[codewordRow] == null) continue;
            var rowIndicatorValue = codeword.getValue() % 30;
            var codewordRowNumber = codeword.getRowNumber();
            if (codewordRowNumber > barcodeMetadata.getRowCount()) {
                codewords[codewordRow] = null;
                continue;
            }
            if (!this._isLeft) codewordRowNumber += 2;
            switch(codewordRowNumber % 3){
                case 0:
                    if (rowIndicatorValue * 3 + 1 !== barcodeMetadata.getRowCountUpperPart()) codewords[codewordRow] = null;
                    break;
                case 1:
                    if (Math.trunc(rowIndicatorValue / 3) !== barcodeMetadata.getErrorCorrectionLevel() || rowIndicatorValue % 3 !== barcodeMetadata.getRowCountLowerPart()) codewords[codewordRow] = null;
                    break;
                case 2:
                    if (rowIndicatorValue + 1 !== barcodeMetadata.getColumnCount()) codewords[codewordRow] = null;
                    break;
            }
        }
    };
    DetectionResultRowIndicatorColumn.prototype.isLeft = function() {
        return this._isLeft;
    };
    // @Override
    DetectionResultRowIndicatorColumn.prototype.toString = function() {
        return "IsLeft: " + this._isLeft + "\n" + _super.prototype.toString.call(this);
    };
    return DetectionResultRowIndicatorColumn;
}((0, $esg3G.default));
var $6cdcd2a550684666$export$2e2bcd8739ae039 = $6cdcd2a550684666$var$DetectionResultRowIndicatorColumn;

});
parcelRegister("nbNAu", function(module, exports) {

$parcel$export(module.exports, "default", () => $045b4d17cd7f9126$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.pdf417.decoder;
/**
 * @author Guenther Grau
 */ var $045b4d17cd7f9126$var$BarcodeMetadata = /** @class */ function() {
    function BarcodeMetadata(columnCount, rowCountUpperPart, rowCountLowerPart, errorCorrectionLevel) {
        this.columnCount = columnCount;
        this.errorCorrectionLevel = errorCorrectionLevel;
        this.rowCountUpperPart = rowCountUpperPart;
        this.rowCountLowerPart = rowCountLowerPart;
        this.rowCount = rowCountUpperPart + rowCountLowerPart;
    }
    BarcodeMetadata.prototype.getColumnCount = function() {
        return this.columnCount;
    };
    BarcodeMetadata.prototype.getErrorCorrectionLevel = function() {
        return this.errorCorrectionLevel;
    };
    BarcodeMetadata.prototype.getRowCount = function() {
        return this.rowCount;
    };
    BarcodeMetadata.prototype.getRowCountUpperPart = function() {
        return this.rowCountUpperPart;
    };
    BarcodeMetadata.prototype.getRowCountLowerPart = function() {
        return this.rowCountLowerPart;
    };
    return BarcodeMetadata;
}();
var $045b4d17cd7f9126$export$2e2bcd8739ae039 = $045b4d17cd7f9126$var$BarcodeMetadata;

});

parcelRegister("esg3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $a860231839bdd014$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kzy6R = parcelRequire("kzy6R");

var $9K45D = parcelRequire("9K45D");
var $a860231839bdd014$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author Guenther Grau
 */ var $a860231839bdd014$var$DetectionResultColumn = /** @class */ function() {
    function DetectionResultColumn(boundingBox) {
        this.boundingBox = new (0, $9K45D.default)(boundingBox);
        // this.codewords = new Codeword[boundingBox.getMaxY() - boundingBox.getMinY() + 1];
        this.codewords = new Array(boundingBox.getMaxY() - boundingBox.getMinY() + 1);
    }
    /*final*/ DetectionResultColumn.prototype.getCodewordNearby = function(imageRow) {
        var codeword = this.getCodeword(imageRow);
        if (codeword != null) return codeword;
        for(var i = 1; i < DetectionResultColumn.MAX_NEARBY_DISTANCE; i++){
            var nearImageRow = this.imageRowToCodewordIndex(imageRow) - i;
            if (nearImageRow >= 0) {
                codeword = this.codewords[nearImageRow];
                if (codeword != null) return codeword;
            }
            nearImageRow = this.imageRowToCodewordIndex(imageRow) + i;
            if (nearImageRow < this.codewords.length) {
                codeword = this.codewords[nearImageRow];
                if (codeword != null) return codeword;
            }
        }
        return null;
    };
    /*final int*/ DetectionResultColumn.prototype.imageRowToCodewordIndex = function(imageRow) {
        return imageRow - this.boundingBox.getMinY();
    };
    /*final void*/ DetectionResultColumn.prototype.setCodeword = function(imageRow, codeword) {
        this.codewords[this.imageRowToCodewordIndex(imageRow)] = codeword;
    };
    /*final*/ DetectionResultColumn.prototype.getCodeword = function(imageRow) {
        return this.codewords[this.imageRowToCodewordIndex(imageRow)];
    };
    /*final*/ DetectionResultColumn.prototype.getBoundingBox = function() {
        return this.boundingBox;
    };
    /*final*/ DetectionResultColumn.prototype.getCodewords = function() {
        return this.codewords;
    };
    // @Override
    DetectionResultColumn.prototype.toString = function() {
        var e_1, _a;
        var formatter = new (0, $kzy6R.default)();
        var row = 0;
        try {
            for(var _b = $a860231839bdd014$var$__values(this.codewords), _c = _b.next(); !_c.done; _c = _b.next()){
                var codeword = _c.value;
                if (codeword == null) {
                    formatter.format("%3d:    |   %n", row++);
                    continue;
                }
                formatter.format("%3d: %3d|%3d%n", row++, codeword.getRowNumber(), codeword.getValue());
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return formatter.toString();
    };
    DetectionResultColumn.MAX_NEARBY_DISTANCE = 5;
    return DetectionResultColumn;
}();
var $a860231839bdd014$export$2e2bcd8739ae039 = $a860231839bdd014$var$DetectionResultColumn;

});
parcelRegister("kzy6R", function(module, exports) {

$parcel$export(module.exports, "default", () => $efa18901016ff6c4$export$2e2bcd8739ae039);
/**
 * Java Formatter class polyfill that works in the JS way.
 */ var $efa18901016ff6c4$var$Formatter = /** @class */ function() {
    function Formatter() {
        this.buffer = "";
    }
    /**
     *
     * @see https://stackoverflow.com/a/13439711/4367683
     *
     * @param str
     * @param arr
     */ Formatter.form = function(str, arr) {
        var i = -1;
        function callback(exp, p0, p1, p2, p3, p4) {
            if (exp === "%%") return "%";
            if (arr[++i] === undefined) return undefined;
            exp = p2 ? parseInt(p2.substr(1)) : undefined;
            var base = p3 ? parseInt(p3.substr(1)) : undefined;
            var val;
            switch(p4){
                case "s":
                    val = arr[i];
                    break;
                case "c":
                    val = arr[i][0];
                    break;
                case "f":
                    val = parseFloat(arr[i]).toFixed(exp);
                    break;
                case "p":
                    val = parseFloat(arr[i]).toPrecision(exp);
                    break;
                case "e":
                    val = parseFloat(arr[i]).toExponential(exp);
                    break;
                case "x":
                    val = parseInt(arr[i]).toString(base ? base : 16);
                    break;
                case "d":
                    val = parseFloat(parseInt(arr[i], base ? base : 10).toPrecision(exp)).toFixed(0);
                    break;
            }
            val = typeof val === "object" ? JSON.stringify(val) : (+val).toString(base);
            var size = parseInt(p1); /* padding size */ 
            var ch = p1 && p1[0] + "" === "0" ? "0" : " "; /* isnull? */ 
            while(val.length < size)val = p0 !== undefined ? val + ch : ch + val; /* isminus? */ 
            return val;
        }
        var regex = /%(-)?(0?[0-9]+)?([.][0-9]+)?([#][0-9]+)?([scfpexd%])/g;
        return str.replace(regex, callback);
    };
    /**
     *
     * @param append The new string to append.
     * @param args Argumets values to be formated.
     */ Formatter.prototype.format = function(append) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        this.buffer += Formatter.form(append, args);
    };
    /**
     * Returns the Formatter string value.
     */ Formatter.prototype.toString = function() {
        return this.buffer;
    };
    return Formatter;
}();
var $efa18901016ff6c4$export$2e2bcd8739ae039 = $efa18901016ff6c4$var$Formatter;

});


parcelRegister("ck5kQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8b7dbc949eafb2$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jXATC = parcelRequire("jXATC");
var $8f8b7dbc949eafb2$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $8f8b7dbc949eafb2$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
// import java.util.ArrayList;
// import java.util.Collection;
// import java.util.HashMap;
// import java.util.Map;
// import java.util.Map.Entry;
/**
 * @author Guenther Grau
 */ var $8f8b7dbc949eafb2$var$BarcodeValue = /** @class */ function() {
    function BarcodeValue() {
        this.values = new Map();
    }
    /**
     * Add an occurrence of a value
     */ BarcodeValue.prototype.setValue = function(value) {
        value = Math.trunc(value);
        var confidence = this.values.get(value);
        if (confidence == null) confidence = 0;
        confidence++;
        this.values.set(value, confidence);
    };
    /**
     * Determines the maximum occurrence of a set value and returns all values which were set with this occurrence.
     * @return an array of int, containing the values with the highest occurrence, or null, if no value was set
     */ BarcodeValue.prototype.getValue = function() {
        var e_1, _a;
        var maxConfidence = -1;
        var result = new Array();
        var _loop_1 = function(key, value) {
            var entry = {
                getKey: function() {
                    return key;
                },
                getValue: function() {
                    return value;
                }
            };
            if (entry.getValue() > maxConfidence) {
                maxConfidence = entry.getValue();
                result = [];
                result.push(entry.getKey());
            } else if (entry.getValue() === maxConfidence) result.push(entry.getKey());
        };
        try {
            for(var _b = $8f8b7dbc949eafb2$var$__values(this.values.entries()), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $8f8b7dbc949eafb2$var$__read(_c.value, 2), key = _d[0], value = _d[1];
                _loop_1(key, value);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return (0, $jXATC.default).toIntArray(result);
    };
    BarcodeValue.prototype.getConfidence = function(value) {
        return this.values.get(value);
    };
    return BarcodeValue;
}();
var $8f8b7dbc949eafb2$export$2e2bcd8739ae039 = $8f8b7dbc949eafb2$var$BarcodeValue;

});


parcelRegister("4rkOA", function(module, exports) {

$parcel$export(module.exports, "default", () => $33b9d472d649ab2f$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $jXATC = parcelRequire("jXATC");

var $kzy6R = parcelRequire("kzy6R");
var $33b9d472d649ab2f$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * @author Guenther Grau
 */ var $33b9d472d649ab2f$var$DetectionResult = /** @class */ function() {
    function DetectionResult(barcodeMetadata, boundingBox) {
        /*final*/ this.ADJUST_ROW_NUMBER_SKIP = 2;
        this.barcodeMetadata = barcodeMetadata;
        this.barcodeColumnCount = barcodeMetadata.getColumnCount();
        this.boundingBox = boundingBox;
        // this.detectionResultColumns = new DetectionResultColumn[this.barcodeColumnCount + 2];
        this.detectionResultColumns = new Array(this.barcodeColumnCount + 2);
    }
    DetectionResult.prototype.getDetectionResultColumns = function() {
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[0]);
        this.adjustIndicatorColumnRowNumbers(this.detectionResultColumns[this.barcodeColumnCount + 1]);
        var unadjustedCodewordCount = (0, $jXATC.default).MAX_CODEWORDS_IN_BARCODE;
        var previousUnadjustedCount;
        do {
            previousUnadjustedCount = unadjustedCodewordCount;
            unadjustedCodewordCount = this.adjustRowNumbersAndGetCount();
        }while (unadjustedCodewordCount > 0 && unadjustedCodewordCount < previousUnadjustedCount);
        return this.detectionResultColumns;
    };
    DetectionResult.prototype.adjustIndicatorColumnRowNumbers = function(detectionResultColumn) {
        if (detectionResultColumn != null) detectionResultColumn.adjustCompleteIndicatorColumnRowNumbers(this.barcodeMetadata);
    };
    // TODO ensure that no detected codewords with unknown row number are left
    // we should be able to estimate the row height and use it as a hint for the row number
    // we should also fill the rows top to bottom and bottom to top
    /**
     * @return number of codewords which don't have a valid row number. Note that the count is not accurate as codewords
     * will be counted several times. It just serves as an indicator to see when we can stop adjusting row numbers
     */ DetectionResult.prototype.adjustRowNumbersAndGetCount = function() {
        var unadjustedCount = this.adjustRowNumbersByRow();
        if (unadjustedCount === 0) return 0;
        for(var barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1; barcodeColumn++){
            var codewords = this.detectionResultColumns[barcodeColumn].getCodewords();
            for(var codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
                if (codewords[codewordsRow] == null) continue;
                if (!codewords[codewordsRow].hasValidRowNumber()) this.adjustRowNumbers(barcodeColumn, codewordsRow, codewords);
            }
        }
        return unadjustedCount;
    };
    DetectionResult.prototype.adjustRowNumbersByRow = function() {
        this.adjustRowNumbersFromBothRI();
        // TODO we should only do full row adjustments if row numbers of left and right row indicator column match.
        // Maybe it's even better to calculated the height (rows: d) and divide it by the number of barcode
        // rows. This, together with the LRI and RRI row numbers should allow us to get a good estimate where a row
        // number starts and ends.
        var unadjustedCount = this.adjustRowNumbersFromLRI();
        return unadjustedCount + this.adjustRowNumbersFromRRI();
    };
    DetectionResult.prototype.adjustRowNumbersFromBothRI = function() {
        if (this.detectionResultColumns[0] == null || this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return;
        var LRIcodewords = this.detectionResultColumns[0].getCodewords();
        var RRIcodewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
        for(var codewordsRow /*int*/  = 0; codewordsRow < LRIcodewords.length; codewordsRow++){
            if (LRIcodewords[codewordsRow] != null && RRIcodewords[codewordsRow] != null && LRIcodewords[codewordsRow].getRowNumber() === RRIcodewords[codewordsRow].getRowNumber()) for(var barcodeColumn /*int*/  = 1; barcodeColumn <= this.barcodeColumnCount; barcodeColumn++){
                var codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                if (codeword == null) continue;
                codeword.setRowNumber(LRIcodewords[codewordsRow].getRowNumber());
                if (!codeword.hasValidRowNumber()) this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow] = null;
            }
        }
    };
    DetectionResult.prototype.adjustRowNumbersFromRRI = function() {
        if (this.detectionResultColumns[this.barcodeColumnCount + 1] == null) return 0;
        var unadjustedCount = 0;
        var codewords = this.detectionResultColumns[this.barcodeColumnCount + 1].getCodewords();
        for(var codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
            if (codewords[codewordsRow] == null) continue;
            var rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
            var invalidRowCounts = 0;
            for(var barcodeColumn /*int*/  = this.barcodeColumnCount + 1; barcodeColumn > 0 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn--){
                var codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                if (codeword != null) {
                    invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                    if (!codeword.hasValidRowNumber()) unadjustedCount++;
                }
            }
        }
        return unadjustedCount;
    };
    DetectionResult.prototype.adjustRowNumbersFromLRI = function() {
        if (this.detectionResultColumns[0] == null) return 0;
        var unadjustedCount = 0;
        var codewords = this.detectionResultColumns[0].getCodewords();
        for(var codewordsRow /*int*/  = 0; codewordsRow < codewords.length; codewordsRow++){
            if (codewords[codewordsRow] == null) continue;
            var rowIndicatorRowNumber = codewords[codewordsRow].getRowNumber();
            var invalidRowCounts = 0;
            for(var barcodeColumn /*int*/  = 1; barcodeColumn < this.barcodeColumnCount + 1 && invalidRowCounts < this.ADJUST_ROW_NUMBER_SKIP; barcodeColumn++){
                var codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                if (codeword != null) {
                    invalidRowCounts = DetectionResult.adjustRowNumberIfValid(rowIndicatorRowNumber, invalidRowCounts, codeword);
                    if (!codeword.hasValidRowNumber()) unadjustedCount++;
                }
            }
        }
        return unadjustedCount;
    };
    DetectionResult.adjustRowNumberIfValid = function(rowIndicatorRowNumber, invalidRowCounts, codeword) {
        if (codeword == null) return invalidRowCounts;
        if (!codeword.hasValidRowNumber()) {
            if (codeword.isValidRowNumber(rowIndicatorRowNumber)) {
                codeword.setRowNumber(rowIndicatorRowNumber);
                invalidRowCounts = 0;
            } else ++invalidRowCounts;
        }
        return invalidRowCounts;
    };
    DetectionResult.prototype.adjustRowNumbers = function(barcodeColumn, codewordsRow, codewords) {
        var e_1, _a;
        if (this.detectionResultColumns[barcodeColumn - 1] == null) return;
        var codeword = codewords[codewordsRow];
        var previousColumnCodewords = this.detectionResultColumns[barcodeColumn - 1].getCodewords();
        var nextColumnCodewords = previousColumnCodewords;
        if (this.detectionResultColumns[barcodeColumn + 1] != null) nextColumnCodewords = this.detectionResultColumns[barcodeColumn + 1].getCodewords();
        // let otherCodewords: Codeword[] = new Codeword[14];
        var otherCodewords = new Array(14);
        otherCodewords[2] = previousColumnCodewords[codewordsRow];
        otherCodewords[3] = nextColumnCodewords[codewordsRow];
        if (codewordsRow > 0) {
            otherCodewords[0] = codewords[codewordsRow - 1];
            otherCodewords[4] = previousColumnCodewords[codewordsRow - 1];
            otherCodewords[5] = nextColumnCodewords[codewordsRow - 1];
        }
        if (codewordsRow > 1) {
            otherCodewords[8] = codewords[codewordsRow - 2];
            otherCodewords[10] = previousColumnCodewords[codewordsRow - 2];
            otherCodewords[11] = nextColumnCodewords[codewordsRow - 2];
        }
        if (codewordsRow < codewords.length - 1) {
            otherCodewords[1] = codewords[codewordsRow + 1];
            otherCodewords[6] = previousColumnCodewords[codewordsRow + 1];
            otherCodewords[7] = nextColumnCodewords[codewordsRow + 1];
        }
        if (codewordsRow < codewords.length - 2) {
            otherCodewords[9] = codewords[codewordsRow + 2];
            otherCodewords[12] = previousColumnCodewords[codewordsRow + 2];
            otherCodewords[13] = nextColumnCodewords[codewordsRow + 2];
        }
        try {
            for(var otherCodewords_1 = $33b9d472d649ab2f$var$__values(otherCodewords), otherCodewords_1_1 = otherCodewords_1.next(); !otherCodewords_1_1.done; otherCodewords_1_1 = otherCodewords_1.next()){
                var otherCodeword = otherCodewords_1_1.value;
                if (DetectionResult.adjustRowNumber(codeword, otherCodeword)) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (otherCodewords_1_1 && !otherCodewords_1_1.done && (_a = otherCodewords_1.return)) _a.call(otherCodewords_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * @return true, if row number was adjusted, false otherwise
     */ DetectionResult.adjustRowNumber = function(codeword, otherCodeword) {
        if (otherCodeword == null) return false;
        if (otherCodeword.hasValidRowNumber() && otherCodeword.getBucket() === codeword.getBucket()) {
            codeword.setRowNumber(otherCodeword.getRowNumber());
            return true;
        }
        return false;
    };
    DetectionResult.prototype.getBarcodeColumnCount = function() {
        return this.barcodeColumnCount;
    };
    DetectionResult.prototype.getBarcodeRowCount = function() {
        return this.barcodeMetadata.getRowCount();
    };
    DetectionResult.prototype.getBarcodeECLevel = function() {
        return this.barcodeMetadata.getErrorCorrectionLevel();
    };
    DetectionResult.prototype.setBoundingBox = function(boundingBox) {
        this.boundingBox = boundingBox;
    };
    DetectionResult.prototype.getBoundingBox = function() {
        return this.boundingBox;
    };
    DetectionResult.prototype.setDetectionResultColumn = function(barcodeColumn, detectionResultColumn) {
        this.detectionResultColumns[barcodeColumn] = detectionResultColumn;
    };
    DetectionResult.prototype.getDetectionResultColumn = function(barcodeColumn) {
        return this.detectionResultColumns[barcodeColumn];
    };
    // @Override
    DetectionResult.prototype.toString = function() {
        var rowIndicatorColumn = this.detectionResultColumns[0];
        if (rowIndicatorColumn == null) rowIndicatorColumn = this.detectionResultColumns[this.barcodeColumnCount + 1];
        // try (
        var formatter = new (0, $kzy6R.default)();
        // ) {
        for(var codewordsRow /*int*/  = 0; codewordsRow < rowIndicatorColumn.getCodewords().length; codewordsRow++){
            formatter.format("CW %3d:", codewordsRow);
            for(var barcodeColumn /*int*/  = 0; barcodeColumn < this.barcodeColumnCount + 2; barcodeColumn++){
                if (this.detectionResultColumns[barcodeColumn] == null) {
                    formatter.format("    |   ");
                    continue;
                }
                var codeword = this.detectionResultColumns[barcodeColumn].getCodewords()[codewordsRow];
                if (codeword == null) {
                    formatter.format("    |   ");
                    continue;
                }
                formatter.format(" %3d|%3d", codeword.getRowNumber(), codeword.getValue());
            }
            formatter.format("%n");
        }
        return formatter.toString();
    // }
    };
    return DetectionResult;
}();
var $33b9d472d649ab2f$export$2e2bcd8739ae039 = $33b9d472d649ab2f$var$DetectionResult;

});

parcelRegister("jPkxs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6f2b6481369a80e$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.pdf417.decoder;
/**
 * @author Guenther Grau
 */ var $e6f2b6481369a80e$var$Codeword = /** @class */ function() {
    function Codeword(startX, endX, bucket, value) {
        this.rowNumber = Codeword.BARCODE_ROW_UNKNOWN;
        this.startX = Math.trunc(startX);
        this.endX = Math.trunc(endX);
        this.bucket = Math.trunc(bucket);
        this.value = Math.trunc(value);
    }
    Codeword.prototype.hasValidRowNumber = function() {
        return this.isValidRowNumber(this.rowNumber);
    };
    Codeword.prototype.isValidRowNumber = function(rowNumber) {
        return rowNumber !== Codeword.BARCODE_ROW_UNKNOWN && this.bucket === rowNumber % 3 * 3;
    };
    Codeword.prototype.setRowNumberAsRowIndicatorColumn = function() {
        this.rowNumber = Math.trunc(Math.trunc(this.value / 30) * 3 + Math.trunc(this.bucket / 3));
    };
    Codeword.prototype.getWidth = function() {
        return this.endX - this.startX;
    };
    Codeword.prototype.getStartX = function() {
        return this.startX;
    };
    Codeword.prototype.getEndX = function() {
        return this.endX;
    };
    Codeword.prototype.getBucket = function() {
        return this.bucket;
    };
    Codeword.prototype.getValue = function() {
        return this.value;
    };
    Codeword.prototype.getRowNumber = function() {
        return this.rowNumber;
    };
    Codeword.prototype.setRowNumber = function(rowNumber) {
        this.rowNumber = rowNumber;
    };
    //   @Override
    Codeword.prototype.toString = function() {
        return this.rowNumber + "|" + this.value;
    };
    Codeword.BARCODE_ROW_UNKNOWN = -1;
    return Codeword;
}();
var $e6f2b6481369a80e$export$2e2bcd8739ae039 = $e6f2b6481369a80e$var$Codeword;

});

parcelRegister("4G83W", function(module, exports) {

$parcel$export(module.exports, "default", () => $368156b3d01d91db$export$2e2bcd8739ae039);
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // package com.google.zxing.pdf417.decoder;
// import com.google.zxing.common.detector.MathUtils;

var $fbOCK = parcelRequire("fbOCK");

var $jXATC = parcelRequire("jXATC");

var $eT6M3 = parcelRequire("eT6M3");
/**
 * @author Guenther Grau
 * @author creatale GmbH (christoph.schulz@creatale.de)
 */ var $368156b3d01d91db$var$PDF417CodewordDecoder = /** @class */ function() {
    function PDF417CodewordDecoder() {}
    /* @note
     * this action have to be performed before first use of class
     * - static constructor
     * working with 32bit float (based from Java logic)
    */ PDF417CodewordDecoder.initialize = function() {
        // Pre-computes the symbol ratio table.
        for(/*int*/ var i = 0; i < (0, $jXATC.default).SYMBOL_TABLE.length; i++){
            var currentSymbol = (0, $jXATC.default).SYMBOL_TABLE[i];
            var currentBit = currentSymbol & 0x1;
            for(/*int*/ var j = 0; j < (0, $jXATC.default).BARS_IN_MODULE; j++){
                var size = 0.0;
                while((currentSymbol & 0x1) === currentBit){
                    size += 1.0;
                    currentSymbol >>= 1;
                }
                currentBit = currentSymbol & 0x1;
                if (!PDF417CodewordDecoder.RATIOS_TABLE[i]) PDF417CodewordDecoder.RATIOS_TABLE[i] = new Array((0, $jXATC.default).BARS_IN_MODULE);
                PDF417CodewordDecoder.RATIOS_TABLE[i][(0, $jXATC.default).BARS_IN_MODULE - j - 1] = Math.fround(size / (0, $jXATC.default).MODULES_IN_CODEWORD);
            }
        }
        this.bSymbolTableReady = true;
    };
    PDF417CodewordDecoder.getDecodedValue = function(moduleBitCount) {
        var decodedValue = PDF417CodewordDecoder.getDecodedCodewordValue(PDF417CodewordDecoder.sampleBitCounts(moduleBitCount));
        if (decodedValue !== -1) return decodedValue;
        return PDF417CodewordDecoder.getClosestDecodedValue(moduleBitCount);
    };
    PDF417CodewordDecoder.sampleBitCounts = function(moduleBitCount) {
        var bitCountSum = (0, $fbOCK.default).sum(moduleBitCount);
        var result = new Int32Array((0, $jXATC.default).BARS_IN_MODULE);
        var bitCountIndex = 0;
        var sumPreviousBits = 0;
        for(/*int*/ var i = 0; i < (0, $jXATC.default).MODULES_IN_CODEWORD; i++){
            var sampleIndex = bitCountSum / (2 * (0, $jXATC.default).MODULES_IN_CODEWORD) + i * bitCountSum / (0, $jXATC.default).MODULES_IN_CODEWORD;
            if (sumPreviousBits + moduleBitCount[bitCountIndex] <= sampleIndex) {
                sumPreviousBits += moduleBitCount[bitCountIndex];
                bitCountIndex++;
            }
            result[bitCountIndex]++;
        }
        return result;
    };
    PDF417CodewordDecoder.getDecodedCodewordValue = function(moduleBitCount) {
        var decodedValue = PDF417CodewordDecoder.getBitValue(moduleBitCount);
        return (0, $jXATC.default).getCodeword(decodedValue) === -1 ? -1 : decodedValue;
    };
    PDF417CodewordDecoder.getBitValue = function(moduleBitCount) {
        var result = /*long*/ 0;
        for(var /*int*/ i = 0; i < moduleBitCount.length; i++)for(/*int*/ var bit = 0; bit < moduleBitCount[i]; bit++)result = result << 1 | (i % 2 === 0 ? 1 : 0);
        return Math.trunc(result);
    };
    // working with 32bit float (as in Java)
    PDF417CodewordDecoder.getClosestDecodedValue = function(moduleBitCount) {
        var bitCountSum = (0, $fbOCK.default).sum(moduleBitCount);
        var bitCountRatios = new Array((0, $jXATC.default).BARS_IN_MODULE);
        if (bitCountSum > 1) for(var /*int*/ i = 0; i < bitCountRatios.length; i++)bitCountRatios[i] = Math.fround(moduleBitCount[i] / bitCountSum);
        var bestMatchError = (0, $eT6M3.default).MAX_VALUE;
        var bestMatch = -1;
        if (!this.bSymbolTableReady) PDF417CodewordDecoder.initialize();
        for(/*int*/ var j = 0; j < PDF417CodewordDecoder.RATIOS_TABLE.length; j++){
            var error = 0.0;
            var ratioTableRow = PDF417CodewordDecoder.RATIOS_TABLE[j];
            for(/*int*/ var k = 0; k < (0, $jXATC.default).BARS_IN_MODULE; k++){
                var diff = Math.fround(ratioTableRow[k] - bitCountRatios[k]);
                error += Math.fround(diff * diff);
                if (error >= bestMatchError) break;
            }
            if (error < bestMatchError) {
                bestMatchError = error;
                bestMatch = (0, $jXATC.default).SYMBOL_TABLE[j];
            }
        }
        return bestMatch;
    };
    // flag that the table is ready for use
    PDF417CodewordDecoder.bSymbolTableReady = false;
    PDF417CodewordDecoder.RATIOS_TABLE = new Array((0, $jXATC.default).SYMBOL_TABLE.length).map(function(x) {
        return x = new Array((0, $jXATC.default).BARS_IN_MODULE);
    });
    return PDF417CodewordDecoder;
}();
var $368156b3d01d91db$export$2e2bcd8739ae039 = $368156b3d01d91db$var$PDF417CodewordDecoder;

});

parcelRegister("3AG8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $29d56a5644a9d1b8$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.pdf417.decoder;
// import com.google.zxing.FormatException;

var $dtgr5 = parcelRequire("dtgr5");

var $l8eP1 = parcelRequire("l8eP1");

var $jpf17 = parcelRequire("jpf17");

var $2ZNS2 = parcelRequire("2ZNS2");

var $iYwLM = parcelRequire("iYwLM");

var $6E9N1 = parcelRequire("6E9N1");

var $hcAg4 = parcelRequire("hcAg4");

var $6AJoj = parcelRequire("6AJoj");

var $kd2x6 = parcelRequire("kd2x6");

var $fPMAB = parcelRequire("fPMAB");
/*private*/ var $29d56a5644a9d1b8$var$Mode;
(function(Mode) {
    Mode[Mode["ALPHA"] = 0] = "ALPHA";
    Mode[Mode["LOWER"] = 1] = "LOWER";
    Mode[Mode["MIXED"] = 2] = "MIXED";
    Mode[Mode["PUNCT"] = 3] = "PUNCT";
    Mode[Mode["ALPHA_SHIFT"] = 4] = "ALPHA_SHIFT";
    Mode[Mode["PUNCT_SHIFT"] = 5] = "PUNCT_SHIFT";
})($29d56a5644a9d1b8$var$Mode || ($29d56a5644a9d1b8$var$Mode = {}));
/**
 * Indirectly access the global BigInt constructor, it
 * allows browsers that doesn't support BigInt to run
 * the library without breaking due to "undefined BigInt"
 * errors.
 */ function $29d56a5644a9d1b8$var$getBigIntConstructor() {
    if (typeof window !== "undefined") return window["BigInt"] || null;
    if (typeof $parcel$global !== "undefined") return $parcel$global["BigInt"] || null;
    if (typeof self !== "undefined") return self["BigInt"] || null;
    throw new Error("Can't search globals for BigInt!");
}
/**
 * Used to store the BigInt constructor.
 */ var $29d56a5644a9d1b8$var$BigInteger;
/**
 * This function creates a bigint value. It allows browsers
 * that doesn't support BigInt to run the rest of the library
 * by not directly accessing the BigInt constructor.
 */ function $29d56a5644a9d1b8$var$createBigInt(num) {
    if (typeof $29d56a5644a9d1b8$var$BigInteger === "undefined") $29d56a5644a9d1b8$var$BigInteger = $29d56a5644a9d1b8$var$getBigIntConstructor();
    if ($29d56a5644a9d1b8$var$BigInteger === null) throw new Error("BigInt is not supported!");
    return $29d56a5644a9d1b8$var$BigInteger(num);
}
function $29d56a5644a9d1b8$var$getEXP900() {
    // in Java - array with length = 16
    var EXP900 = [];
    EXP900[0] = $29d56a5644a9d1b8$var$createBigInt(1);
    var nineHundred = $29d56a5644a9d1b8$var$createBigInt(900);
    EXP900[1] = nineHundred;
    // in Java - array with length = 16
    for(var i /*int*/  = 2; i < 16; i++)EXP900[i] = EXP900[i - 1] * nineHundred;
    return EXP900;
}
/**
 * <p>This class contains the methods for decoding the PDF417 codewords.</p>
 *
 * @author SITA Lab (kevin.osullivan@sita.aero)
 * @author Guenther Grau
 */ var $29d56a5644a9d1b8$var$DecodedBitStreamParser = /** @class */ function() {
    function DecodedBitStreamParser() {}
    //   private DecodedBitStreamParser() {
    // }
    /**
     *
     * @param codewords
     * @param ecLevel
     *
     * @throws FormatException
     */ DecodedBitStreamParser.decode = function(codewords, ecLevel) {
        // pass encoding to result (will be used for decode symbols in byte mode)
        var result = new (0, $6E9N1.default)("");
        // let encoding: Charset = StandardCharsets.ISO_8859_1;
        var encoding = (0, $l8eP1.default).ISO8859_1;
        /**
         * @note the next command is specific from this TypeScript library
         * because TS can't properly cast some values to char and
         * convert it to string later correctly due to encoding
         * differences from Java version. As reported here:
         * https://github.com/zxing-js/library/pull/264/files#r382831593
         */ result.enableDecoding(encoding);
        // Get compaction mode
        var codeIndex = 1;
        var code = codewords[codeIndex++];
        var resultMetadata = new (0, $2ZNS2.default)();
        while(codeIndex < codewords[0]){
            switch(code){
                case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                    codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex, result);
                    break;
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                    codeIndex = DecodedBitStreamParser.byteCompaction(code, codewords, encoding, codeIndex, result);
                    break;
                case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    result.append(/*(char)*/ codewords[codeIndex++]);
                    break;
                case DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH:
                    codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex, result);
                    break;
                case DecodedBitStreamParser.ECI_CHARSET:
                    var charsetECI = (0, $l8eP1.default).getCharacterSetECIByValue(codewords[codeIndex++]);
                    break;
                case DecodedBitStreamParser.ECI_GENERAL_PURPOSE:
                    // Can't do anything with generic ECI; skip its 2 characters
                    codeIndex += 2;
                    break;
                case DecodedBitStreamParser.ECI_USER_DEFINED:
                    // Can't do anything with user ECI; skip its 1 character
                    codeIndex++;
                    break;
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                    codeIndex = DecodedBitStreamParser.decodeMacroBlock(codewords, codeIndex, resultMetadata);
                    break;
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                    // Should not see these outside a macro block
                    throw new (0, $dtgr5.default)();
                default:
                    // Default to text compaction. During testing numerous barcodes
                    // appeared to be missing the starting mode. In these cases defaulting
                    // to text compaction seems to work.
                    codeIndex--;
                    codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex, result);
                    break;
            }
            if (codeIndex < codewords.length) code = codewords[codeIndex++];
            else throw (0, $dtgr5.default).getFormatInstance();
        }
        if (result.length() === 0) throw (0, $dtgr5.default).getFormatInstance();
        var decoderResult = new (0, $jpf17.default)(null, result.toString(), null, ecLevel);
        decoderResult.setOther(resultMetadata);
        return decoderResult;
    };
    /**
     *
     * @param int
     * @param param1
     * @param codewords
     * @param int
     * @param codeIndex
     * @param PDF417ResultMetadata
     * @param resultMetadata
     *
     * @throws FormatException
     */ // @SuppressWarnings("deprecation")
    DecodedBitStreamParser.decodeMacroBlock = function(codewords, codeIndex, resultMetadata) {
        if (codeIndex + DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS > codewords[0]) // we must have at least two bytes left for the segment index
        throw (0, $dtgr5.default).getFormatInstance();
        var segmentIndexArray = new Int32Array(DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS);
        for(var i /*int*/  = 0; i < DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS; i++, codeIndex++)segmentIndexArray[i] = codewords[codeIndex];
        resultMetadata.setSegmentIndex((0, $hcAg4.default).parseInt(DecodedBitStreamParser.decodeBase900toBase10(segmentIndexArray, DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS)));
        var fileId = new (0, $6E9N1.default)();
        codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex, fileId);
        resultMetadata.setFileId(fileId.toString());
        var optionalFieldsStart = -1;
        if (codewords[codeIndex] === DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD) optionalFieldsStart = codeIndex + 1;
        while(codeIndex < codewords[0])switch(codewords[codeIndex]){
            case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                codeIndex++;
                switch(codewords[codeIndex]){
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME:
                        var fileName = new (0, $6E9N1.default)();
                        codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex + 1, fileName);
                        resultMetadata.setFileName(fileName.toString());
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_SENDER:
                        var sender = new (0, $6E9N1.default)();
                        codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex + 1, sender);
                        resultMetadata.setSender(sender.toString());
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE:
                        var addressee = new (0, $6E9N1.default)();
                        codeIndex = DecodedBitStreamParser.textCompaction(codewords, codeIndex + 1, addressee);
                        resultMetadata.setAddressee(addressee.toString());
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT:
                        var segmentCount = new (0, $6E9N1.default)();
                        codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex + 1, segmentCount);
                        resultMetadata.setSegmentCount((0, $hcAg4.default).parseInt(segmentCount.toString()));
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP:
                        var timestamp = new (0, $6E9N1.default)();
                        codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex + 1, timestamp);
                        resultMetadata.setTimestamp((0, $6AJoj.default).parseLong(timestamp.toString()));
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM:
                        var checksum = new (0, $6E9N1.default)();
                        codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex + 1, checksum);
                        resultMetadata.setChecksum((0, $hcAg4.default).parseInt(checksum.toString()));
                        break;
                    case DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE:
                        var fileSize = new (0, $6E9N1.default)();
                        codeIndex = DecodedBitStreamParser.numericCompaction(codewords, codeIndex + 1, fileSize);
                        resultMetadata.setFileSize((0, $6AJoj.default).parseLong(fileSize.toString()));
                        break;
                    default:
                        throw (0, $dtgr5.default).getFormatInstance();
                }
                break;
            case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                codeIndex++;
                resultMetadata.setLastSegment(true);
                break;
            default:
                throw (0, $dtgr5.default).getFormatInstance();
        }
        // copy optional fields to additional options
        if (optionalFieldsStart !== -1) {
            var optionalFieldsLength = codeIndex - optionalFieldsStart;
            if (resultMetadata.isLastSegment()) // do not include terminator
            optionalFieldsLength--;
            resultMetadata.setOptionalData((0, $iYwLM.default).copyOfRange(codewords, optionalFieldsStart, optionalFieldsStart + optionalFieldsLength));
        }
        return codeIndex;
    };
    /**
     * Text Compaction mode (see 5.4.1.5) permits all printable ASCII characters to be
     * encoded, i.e. values 32 - 126 inclusive in accordance with ISO/IEC 646 (IRV), as
     * well as selected control characters.
     *
     * @param codewords The array of codewords (data + error)
     * @param codeIndex The current index into the codeword array.
     * @param result    The decoded data is appended to the result.
     * @return The next index into the codeword array.
     */ DecodedBitStreamParser.textCompaction = function(codewords, codeIndex, result) {
        // 2 character per codeword
        var textCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
        // Used to hold the byte compaction value if there is a mode shift
        var byteCompactionData = new Int32Array((codewords[0] - codeIndex) * 2);
        var index = 0;
        var end = false;
        while(codeIndex < codewords[0] && !end){
            var code = codewords[codeIndex++];
            if (code < DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH) {
                textCompactionData[index] = code / 30;
                textCompactionData[index + 1] = code % 30;
                index += 2;
            } else switch(code){
                case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                    // reinitialize text compaction mode to alpha sub mode
                    textCompactionData[index++] = DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH;
                    break;
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                case DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                    codeIndex--;
                    end = true;
                    break;
                case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                    // The Mode Shift codeword 913 shall cause a temporary
                    // switch from Text Compaction mode to Byte Compaction mode.
                    // This switch shall be in effect for only the next codeword,
                    // after which the mode shall revert to the prevailing sub-mode
                    // of the Text Compaction mode. Codeword 913 is only available
                    // in Text Compaction mode; its use is described in 5.4.2.4.
                    textCompactionData[index] = DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE;
                    code = codewords[codeIndex++];
                    byteCompactionData[index] = code;
                    index++;
                    break;
            }
        }
        DecodedBitStreamParser.decodeTextCompaction(textCompactionData, byteCompactionData, index, result);
        return codeIndex;
    };
    /**
     * The Text Compaction mode includes all the printable ASCII characters
     * (i.e. values from 32 to 126) and three ASCII control characters: HT or tab
     * (9: e), LF or line feed (10: e), and CR or carriage
     * return (13: e). The Text Compaction mode also includes various latch
     * and shift characters which are used exclusively within the mode. The Text
     * Compaction mode encodes up to 2 characters per codeword. The compaction rules
     * for converting data into PDF417 codewords are defined in 5.4.2.2. The sub-mode
     * switches are defined in 5.4.2.3.
     *
     * @param textCompactionData The text compaction data.
     * @param byteCompactionData The byte compaction data if there
     *                           was a mode shift.
     * @param length             The size of the text compaction and byte compaction data.
     * @param result             The decoded data is appended to the result.
     */ DecodedBitStreamParser.decodeTextCompaction = function(textCompactionData, byteCompactionData, length, result) {
        // Beginning from an initial state of the Alpha sub-mode
        // The default compaction mode for PDF417 in effect at the start of each symbol shall always be Text
        // Compaction mode Alpha sub-mode (alphabetic: uppercase). A latch codeword from another mode to the Text
        // Compaction mode shall always switch to the Text Compaction Alpha sub-mode.
        var subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
        var priorToShiftMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
        var i = 0;
        while(i < length){
            var subModeCh = textCompactionData[i];
            var ch = /*char*/ "";
            switch(subMode){
                case $29d56a5644a9d1b8$var$Mode.ALPHA:
                    // Alpha (alphabetic: uppercase)
                    if (subModeCh < 26) // Upper case Alpha Character
                    // Note: 65 = 'A' ASCII -> there is byte code of symbol
                    ch = /*(char)('A' + subModeCh) */ String.fromCharCode(65 + subModeCh);
                    else switch(subModeCh){
                        case 26:
                            ch = " ";
                            break;
                        case DecodedBitStreamParser.LL:
                            subMode = $29d56a5644a9d1b8$var$Mode.LOWER;
                            break;
                        case DecodedBitStreamParser.ML:
                            subMode = $29d56a5644a9d1b8$var$Mode.MIXED;
                            break;
                        case DecodedBitStreamParser.PS:
                            // Shift to punctuation
                            priorToShiftMode = subMode;
                            subMode = $29d56a5644a9d1b8$var$Mode.PUNCT_SHIFT;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $29d56a5644a9d1b8$var$Mode.LOWER:
                    // Lower (alphabetic: lowercase)
                    if (subModeCh < 26) ch = /*(char)('a' + subModeCh)*/ String.fromCharCode(97 + subModeCh);
                    else switch(subModeCh){
                        case 26:
                            ch = " ";
                            break;
                        case DecodedBitStreamParser.AS:
                            // Shift to alpha
                            priorToShiftMode = subMode;
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA_SHIFT;
                            break;
                        case DecodedBitStreamParser.ML:
                            subMode = $29d56a5644a9d1b8$var$Mode.MIXED;
                            break;
                        case DecodedBitStreamParser.PS:
                            // Shift to punctuation
                            priorToShiftMode = subMode;
                            subMode = $29d56a5644a9d1b8$var$Mode.PUNCT_SHIFT;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            // TODO Does this need to use the current character encoding? See other occurrences below
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $29d56a5644a9d1b8$var$Mode.MIXED:
                    // Mixed (punctuation: e)
                    if (subModeCh < DecodedBitStreamParser.PL) ch = DecodedBitStreamParser.MIXED_CHARS[subModeCh];
                    else switch(subModeCh){
                        case DecodedBitStreamParser.PL:
                            subMode = $29d56a5644a9d1b8$var$Mode.PUNCT;
                            break;
                        case 26:
                            ch = " ";
                            break;
                        case DecodedBitStreamParser.LL:
                            subMode = $29d56a5644a9d1b8$var$Mode.LOWER;
                            break;
                        case DecodedBitStreamParser.AL:
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
                            break;
                        case DecodedBitStreamParser.PS:
                            // Shift to punctuation
                            priorToShiftMode = subMode;
                            subMode = $29d56a5644a9d1b8$var$Mode.PUNCT_SHIFT;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $29d56a5644a9d1b8$var$Mode.PUNCT:
                    // Punctuation
                    if (subModeCh < DecodedBitStreamParser.PAL) ch = DecodedBitStreamParser.PUNCT_CHARS[subModeCh];
                    else switch(subModeCh){
                        case DecodedBitStreamParser.PAL:
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $29d56a5644a9d1b8$var$Mode.ALPHA_SHIFT:
                    // Restore sub-mode
                    subMode = priorToShiftMode;
                    if (subModeCh < 26) ch = /*(char)('A' + subModeCh)*/ String.fromCharCode(65 + subModeCh);
                    else switch(subModeCh){
                        case 26:
                            ch = " ";
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
                            break;
                    }
                    break;
                case $29d56a5644a9d1b8$var$Mode.PUNCT_SHIFT:
                    // Restore sub-mode
                    subMode = priorToShiftMode;
                    if (subModeCh < DecodedBitStreamParser.PAL) ch = DecodedBitStreamParser.PUNCT_CHARS[subModeCh];
                    else switch(subModeCh){
                        case DecodedBitStreamParser.PAL:
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
                            break;
                        case DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE:
                            // PS before Shift-to-Byte is used as a padding character,
                            // see 5.4.2.4 of the specification
                            result.append(/*(char)*/ byteCompactionData[i]);
                            break;
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                            subMode = $29d56a5644a9d1b8$var$Mode.ALPHA;
                            break;
                    }
                    break;
            }
            // if (ch !== 0) {
            if (ch !== "") // Append decoded character to result
            result.append(ch);
            i++;
        }
    };
    /**
     * Byte Compaction mode (see 5.4.3) permits all 256 possible 8-bit byte values to be encoded.
     * This includes all ASCII characters value 0 to 127 inclusive and provides for international
     * character set support.
     *
     * @param mode      The byte compaction mode i.e. 901 or 924
     * @param codewords The array of codewords (data + error)
     * @param encoding  Currently active character encoding
     * @param codeIndex The current index into the codeword array.
     * @param result    The decoded data is appended to the result.
     * @return The next index into the codeword array.
     */ DecodedBitStreamParser.byteCompaction = function(mode, codewords, encoding, codeIndex, result) {
        var decodedBytes = new (0, $kd2x6.default)();
        var count = 0;
        var value = /*long*/ 0;
        var end = false;
        switch(mode){
            case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                // Total number of Byte Compaction characters to be encoded
                // is not a multiple of 6
                var byteCompactedCodewords = new Int32Array(6);
                var nextCode = codewords[codeIndex++];
                while(codeIndex < codewords[0] && !end){
                    byteCompactedCodewords[count++] = nextCode;
                    // Base 900
                    value = 900 * value + nextCode;
                    nextCode = codewords[codeIndex++];
                    // perhaps it should be ok to check only nextCode >= TEXT_COMPACTION_MODE_LATCH
                    switch(nextCode){
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                        case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                            codeIndex--;
                            end = true;
                            break;
                        default:
                            if (count % 5 === 0 && count > 0) {
                                // Decode every 5 codewords
                                // Convert to Base 256
                                for(var j /*int*/  = 0; j < 6; ++j)/* @note
                                     * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                                     * So the next bitwise operation could not be done with simple numbers
                                     */ decodedBytes.write(/*(byte)*/ Number($29d56a5644a9d1b8$var$createBigInt(value) >> $29d56a5644a9d1b8$var$createBigInt(8 * (5 - j))));
                                value = 0;
                                count = 0;
                            }
                            break;
                    }
                }
                // if the end of all codewords is reached the last codeword needs to be added
                if (codeIndex === codewords[0] && nextCode < DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH) byteCompactedCodewords[count++] = nextCode;
                // If Byte Compaction mode is invoked with codeword 901,
                // the last group of codewords is interpreted directly
                // as one byte per codeword, without compaction.
                for(var i /*int*/  = 0; i < count; i++)decodedBytes.write(/*(byte)*/ byteCompactedCodewords[i]);
                break;
            case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                // Total number of Byte Compaction characters to be encoded
                // is an integer multiple of 6
                while(codeIndex < codewords[0] && !end){
                    var code = codewords[codeIndex++];
                    if (code < DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH) {
                        count++;
                        // Base 900
                        value = 900 * value + code;
                    } else switch(code){
                        case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH:
                        case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                        case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                        case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                        case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                            codeIndex--;
                            end = true;
                            break;
                    }
                    if (count % 5 === 0 && count > 0) {
                        // Decode every 5 codewords
                        // Convert to Base 256
                        /* @note
                         * JavaScript stores numbers as 64 bits floating point numbers, but all bitwise operations are performed on 32 bits binary numbers.
                         * So the next bitwise operation could not be done with simple numbers
                        */ for(var j /*int*/  = 0; j < 6; ++j)decodedBytes.write(/*(byte)*/ Number($29d56a5644a9d1b8$var$createBigInt(value) >> $29d56a5644a9d1b8$var$createBigInt(8 * (5 - j))));
                        value = 0;
                        count = 0;
                    }
                }
                break;
        }
        result.append((0, $fPMAB.default).decode(decodedBytes.toByteArray(), encoding));
        return codeIndex;
    };
    /**
     * Numeric Compaction mode (see 5.4.4) permits efficient encoding of numeric data strings.
     *
     * @param codewords The array of codewords (data + error)
     * @param codeIndex The current index into the codeword array.
     * @param result    The decoded data is appended to the result.
     * @return The next index into the codeword array.
     *
     * @throws FormatException
     */ DecodedBitStreamParser.numericCompaction = function(codewords, codeIndex /*int*/ , result) {
        var count = 0;
        var end = false;
        var numericCodewords = new Int32Array(DecodedBitStreamParser.MAX_NUMERIC_CODEWORDS);
        while(codeIndex < codewords[0] && !end){
            var code = codewords[codeIndex++];
            if (codeIndex === codewords[0]) end = true;
            if (code < DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH) {
                numericCodewords[count] = code;
                count++;
            } else switch(code){
                case DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH:
                case DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6:
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK:
                case DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD:
                case DecodedBitStreamParser.MACRO_PDF417_TERMINATOR:
                    codeIndex--;
                    end = true;
                    break;
            }
            if ((count % DecodedBitStreamParser.MAX_NUMERIC_CODEWORDS === 0 || code === DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH || end) && count > 0) {
                // Re-invoking Numeric Compaction mode (by using codeword 902
                // while in Numeric Compaction mode) serves  to terminate the
                // current Numeric Compaction mode grouping as described in 5.4.4.2,
                // and then to start a new one grouping.
                result.append(DecodedBitStreamParser.decodeBase900toBase10(numericCodewords, count));
                count = 0;
            }
        }
        return codeIndex;
    };
    /**
     * Convert a list of Numeric Compacted codewords from Base 900 to Base 10.
     *
     * @param codewords The array of codewords
     * @param count     The number of codewords
     * @return The decoded string representing the Numeric data.
     *
     * EXAMPLE
     * Encode the fifteen digit numeric string 000213298174000
     * Prefix the numeric string with a 1 and set the initial value of
     * t = 1 000 213 298 174 000
     * Calculate codeword 0
     * d0 = 1 000 213 298 174 000 mod 900 = 200
     *
     * t = 1 000 213 298 174 000 div 900 = 1 111 348 109 082
     * Calculate codeword 1
     * d1 = 1 111 348 109 082 mod 900 = 282
     *
     * t = 1 111 348 109 082 div 900 = 1 234 831 232
     * Calculate codeword 2
     * d2 = 1 234 831 232 mod 900 = 632
     *
     * t = 1 234 831 232 div 900 = 1 372 034
     * Calculate codeword 3
     * d3 = 1 372 034 mod 900 = 434
     *
     * t = 1 372 034 div 900 = 1 524
     * Calculate codeword 4
     * d4 = 1 524 mod 900 = 624
     *
     * t = 1 524 div 900 = 1
     * Calculate codeword 5
     * d5 = 1 mod 900 = 1
     * t = 1 div 900 = 0
     * Codeword sequence is: 1, 624, 434, 632, 282, 200
     *
     * Decode the above codewords involves
     *   1 x 900 power of 5 + 624 x 900 power of 4 + 434 x 900 power of 3 +
     * 632 x 900 power of 2 + 282 x 900 power of 1 + 200 x 900 power of 0 = 1000213298174000
     *
     * Remove leading 1 =>  Result is 000213298174000
     *
     * @throws FormatException
     */ DecodedBitStreamParser.decodeBase900toBase10 = function(codewords, count) {
        var result = $29d56a5644a9d1b8$var$createBigInt(0);
        for(var i /*int*/  = 0; i < count; i++)result += DecodedBitStreamParser.EXP900[count - i - 1] * $29d56a5644a9d1b8$var$createBigInt(codewords[i]);
        var resultString = result.toString();
        if (resultString.charAt(0) !== "1") throw new (0, $dtgr5.default)();
        return resultString.substring(1);
    };
    DecodedBitStreamParser.TEXT_COMPACTION_MODE_LATCH = 900;
    DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH = 901;
    DecodedBitStreamParser.NUMERIC_COMPACTION_MODE_LATCH = 902;
    DecodedBitStreamParser.BYTE_COMPACTION_MODE_LATCH_6 = 924;
    DecodedBitStreamParser.ECI_USER_DEFINED = 925;
    DecodedBitStreamParser.ECI_GENERAL_PURPOSE = 926;
    DecodedBitStreamParser.ECI_CHARSET = 927;
    DecodedBitStreamParser.BEGIN_MACRO_PDF417_CONTROL_BLOCK = 928;
    DecodedBitStreamParser.BEGIN_MACRO_PDF417_OPTIONAL_FIELD = 923;
    DecodedBitStreamParser.MACRO_PDF417_TERMINATOR = 922;
    DecodedBitStreamParser.MODE_SHIFT_TO_BYTE_COMPACTION_MODE = 913;
    DecodedBitStreamParser.MAX_NUMERIC_CODEWORDS = 15;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_FILE_NAME = 0;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_SEGMENT_COUNT = 1;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_TIME_STAMP = 2;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_SENDER = 3;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_ADDRESSEE = 4;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_FILE_SIZE = 5;
    DecodedBitStreamParser.MACRO_PDF417_OPTIONAL_FIELD_CHECKSUM = 6;
    DecodedBitStreamParser.PL = 25;
    DecodedBitStreamParser.LL = 27;
    DecodedBitStreamParser.AS = 27;
    DecodedBitStreamParser.ML = 28;
    DecodedBitStreamParser.AL = 28;
    DecodedBitStreamParser.PS = 29;
    DecodedBitStreamParser.PAL = 29;
    DecodedBitStreamParser.PUNCT_CHARS = ";<>@[\\]_`~!\r	,:\n-.$/\"|*()?{}'";
    DecodedBitStreamParser.MIXED_CHARS = "0123456789&\r	,:#-.$/+%*=^";
    /**
     * Table containing values for the exponent of 900.
     * This is used in the numeric compaction decode algorithm.
     */ DecodedBitStreamParser.EXP900 = $29d56a5644a9d1b8$var$getBigIntConstructor() ? $29d56a5644a9d1b8$var$getEXP900() : [];
    DecodedBitStreamParser.NUMBER_OF_SEQUENCE_CODEWORDS = 2;
    return DecodedBitStreamParser;
}();
var $29d56a5644a9d1b8$export$2e2bcd8739ae039 = $29d56a5644a9d1b8$var$DecodedBitStreamParser;

});
parcelRegister("2ZNS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e7f6834722f7ed$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.pdf417;
/**
 * @author Guenther Grau
 */ var $22e7f6834722f7ed$var$PDF417ResultMetadata = /** @class */ function() {
    function PDF417ResultMetadata() {
        this.segmentCount = -1;
        this.fileSize = -1;
        this.timestamp = -1;
        this.checksum = -1;
    }
    /**
     * The Segment ID represents the segment of the whole file distributed over different symbols.
     *
     * @return File segment index
     */ PDF417ResultMetadata.prototype.getSegmentIndex = function() {
        return this.segmentIndex;
    };
    PDF417ResultMetadata.prototype.setSegmentIndex = function(segmentIndex) {
        this.segmentIndex = segmentIndex;
    };
    /**
     * Is the same for each related PDF417 symbol
     *
     * @return File ID
     */ PDF417ResultMetadata.prototype.getFileId = function() {
        return this.fileId;
    };
    PDF417ResultMetadata.prototype.setFileId = function(fileId) {
        this.fileId = fileId;
    };
    /**
     * @return always null
     * @deprecated use dedicated already parsed fields
     */ //   @Deprecated
    PDF417ResultMetadata.prototype.getOptionalData = function() {
        return this.optionalData;
    };
    /**
     * @param optionalData old optional data format as int array
     * @deprecated parse and use new fields
     */ //   @Deprecated
    PDF417ResultMetadata.prototype.setOptionalData = function(optionalData) {
        this.optionalData = optionalData;
    };
    /**
     * @return true if it is the last segment
     */ PDF417ResultMetadata.prototype.isLastSegment = function() {
        return this.lastSegment;
    };
    PDF417ResultMetadata.prototype.setLastSegment = function(lastSegment) {
        this.lastSegment = lastSegment;
    };
    /**
     * @return count of segments, -1 if not set
     */ PDF417ResultMetadata.prototype.getSegmentCount = function() {
        return this.segmentCount;
    };
    PDF417ResultMetadata.prototype.setSegmentCount = function(segmentCount /*int*/ ) {
        this.segmentCount = segmentCount;
    };
    PDF417ResultMetadata.prototype.getSender = function() {
        return this.sender || null;
    };
    PDF417ResultMetadata.prototype.setSender = function(sender) {
        this.sender = sender;
    };
    PDF417ResultMetadata.prototype.getAddressee = function() {
        return this.addressee || null;
    };
    PDF417ResultMetadata.prototype.setAddressee = function(addressee) {
        this.addressee = addressee;
    };
    /**
     * Filename of the encoded file
     *
     * @return filename
     */ PDF417ResultMetadata.prototype.getFileName = function() {
        return this.fileName;
    };
    PDF417ResultMetadata.prototype.setFileName = function(fileName) {
        this.fileName = fileName;
    };
    /**
     * filesize in bytes of the encoded file
     *
     * @return filesize in bytes, -1 if not set
     */ PDF417ResultMetadata.prototype.getFileSize = function() {
        return this.fileSize;
    };
    PDF417ResultMetadata.prototype.setFileSize = function(fileSize /*long*/ ) {
        this.fileSize = fileSize;
    };
    /**
     * 16-bit CRC checksum using CCITT-16
     *
     * @return crc checksum, -1 if not set
     */ PDF417ResultMetadata.prototype.getChecksum = function() {
        return this.checksum;
    };
    PDF417ResultMetadata.prototype.setChecksum = function(checksum /*int*/ ) {
        this.checksum = checksum;
    };
    /**
     * unix epock timestamp, elapsed seconds since 1970-01-01
     *
     * @return elapsed seconds, -1 if not set
     */ PDF417ResultMetadata.prototype.getTimestamp = function() {
        return this.timestamp;
    };
    PDF417ResultMetadata.prototype.setTimestamp = function(timestamp /*long*/ ) {
        this.timestamp = timestamp;
    };
    return PDF417ResultMetadata;
}();
var $22e7f6834722f7ed$export$2e2bcd8739ae039 = $22e7f6834722f7ed$var$PDF417ResultMetadata;

});

parcelRegister("6AJoj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cc950a0a656c51f$export$2e2bcd8739ae039);
/**
 * Ponyfill for Java's Long class.
 */ var $4cc950a0a656c51f$var$Long = /** @class */ function() {
    function Long() {}
    /**
     * Parses a string to a number, since JS has no really Int64.
     *
     * @param num Numeric string.
     * @param radix Destination radix.
     */ Long.parseLong = function(num, radix) {
        if (radix === void 0) radix = undefined;
        return parseInt(num, radix);
    };
    return Long;
}();
var $4cc950a0a656c51f$export$2e2bcd8739ae039 = $4cc950a0a656c51f$var$Long;

});

parcelRegister("kd2x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb66fc8da7ba125d$export$2e2bcd8739ae039);
/*
 * Copyright (c) 1994, 2010, Oracle and/or its affiliates. All rights reserved.
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This code is free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License version 2 only, as
 * published by the Free Software Foundation.  Oracle designates this
 * particular file as subject to the "Classpath" exception as provided
 * by Oracle in the LICENSE file that accompanied this code.
 *
 * This code is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
 * version 2 for more details (a copy is included in the LICENSE file that
 * accompanied this code).
 *
 * You should have received a copy of the GNU General Public License version
 * 2 along with this work; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
 *
 * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
 * or visit www.oracle.com if you need additional information or have any
 * questions.
 */ 
var $iYwLM = parcelRequire("iYwLM");

var $4fy8d = parcelRequire("4fy8d");

var $hcAg4 = parcelRequire("hcAg4");

var $kLpae = parcelRequire("kLpae");

var $h3QVT = parcelRequire("h3QVT");

var $b6IL4 = parcelRequire("b6IL4");

var $iChTI = parcelRequire("iChTI");
var $eb66fc8da7ba125d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This class implements an output stream in which the data is
 * written into a byte array. The buffer automatically grows as data
 * is written to it.
 * The data can be retrieved using <code>toByteArray()</code> and
 * <code>toString()</code>.
 * <p>
 * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
 * this class can be called after the stream has been closed without
 * generating an <tt>IOException</tt>.
 *
 * @author  Arthur van Hoff
 * @since   JDK1.0
 */ var $eb66fc8da7ba125d$var$ByteArrayOutputStream = /** @class */ function(_super) {
    $eb66fc8da7ba125d$var$__extends(ByteArrayOutputStream, _super);
    /**
     * Creates a new byte array output stream. The buffer capacity is
     * initially 32 bytes, though its size increases if necessary.
     */ // public constructor() {
    //     this(32);
    // }
    /**
     * Creates a new byte array output stream, with a buffer capacity of
     * the specified size, in bytes.
     *
     * @param   size   the initial size.
     * @exception  IllegalArgumentException if size is negative.
     */ function ByteArrayOutputStream(size) {
        if (size === void 0) size = 32;
        var _this = _super.call(this) || this;
        /**
         * The number of valid bytes in the buffer.
         */ _this.count = 0;
        if (size < 0) throw new (0, $kLpae.default)("Negative initial size: " + size);
        _this.buf = new Uint8Array(size);
        return _this;
    }
    /**
     * Increases the capacity if necessary to ensure that it can hold
     * at least the number of elements specified by the minimum
     * capacity argument.
     *
     * @param minCapacity the desired minimum capacity
     * @throws OutOfMemoryError if {@code minCapacity < 0}.  This is
     * interpreted as a request for the unsatisfiably large capacity
     * {@code (long) Integer.MAX_VALUE + (minCapacity - Integer.MAX_VALUE)}.
     */ ByteArrayOutputStream.prototype.ensureCapacity = function(minCapacity) {
        // overflow-conscious code
        if (minCapacity - this.buf.length > 0) this.grow(minCapacity);
    };
    /**
     * Increases the capacity to ensure that it can hold at least the
     * number of elements specified by the minimum capacity argument.
     *
     * @param minCapacity the desired minimum capacity
     */ ByteArrayOutputStream.prototype.grow = function(minCapacity) {
        // overflow-conscious code
        var oldCapacity = this.buf.length;
        var newCapacity = oldCapacity << 1;
        if (newCapacity - minCapacity < 0) newCapacity = minCapacity;
        if (newCapacity < 0) {
            if (minCapacity < 0) throw new (0, $h3QVT.default)();
            newCapacity = (0, $hcAg4.default).MAX_VALUE;
        }
        this.buf = (0, $iYwLM.default).copyOfUint8Array(this.buf, newCapacity);
    };
    /**
     * Writes the specified byte to this byte array output stream.
     *
     * @param   b   the byte to be written.
     */ ByteArrayOutputStream.prototype.write = function(b) {
        this.ensureCapacity(this.count + 1);
        this.buf[this.count] = /*(byte)*/ b;
        this.count += 1;
    };
    /**
     * Writes <code>len</code> bytes from the specified byte array
     * starting at offset <code>off</code> to this byte array output stream.
     *
     * @param   b     the data.
     * @param   off   the start offset in the data.
     * @param   len   the number of bytes to write.
     */ ByteArrayOutputStream.prototype.writeBytesOffset = function(b, off, len) {
        if (off < 0 || off > b.length || len < 0 || off + len - b.length > 0) throw new (0, $iChTI.default)();
        this.ensureCapacity(this.count + len);
        (0, $b6IL4.default).arraycopy(b, off, this.buf, this.count, len);
        this.count += len;
    };
    /**
     * Writes the complete contents of this byte array output stream to
     * the specified output stream argument, as if by calling the output
     * stream's write method using <code>out.write(buf, 0, count)</code>.
     *
     * @param      out   the output stream to which to write the data.
     * @exception  IOException  if an I/O error occurs.
     */ ByteArrayOutputStream.prototype.writeTo = function(out) {
        out.writeBytesOffset(this.buf, 0, this.count);
    };
    /**
     * Resets the <code>count</code> field of this byte array output
     * stream to zero, so that all currently accumulated output in the
     * output stream is discarded. The output stream can be used again,
     * reusing the already allocated buffer space.
     *
     * @see     java.io.ByteArrayInputStream#count
     */ ByteArrayOutputStream.prototype.reset = function() {
        this.count = 0;
    };
    /**
     * Creates a newly allocated byte array. Its size is the current
     * size of this output stream and the valid contents of the buffer
     * have been copied into it.
     *
     * @return  the current contents of this output stream, as a byte array.
     * @see     java.io.ByteArrayOutputStream#size()
     */ ByteArrayOutputStream.prototype.toByteArray = function() {
        return (0, $iYwLM.default).copyOfUint8Array(this.buf, this.count);
    };
    /**
     * Returns the current size of the buffer.
     *
     * @return  the value of the <code>count</code> field, which is the number
     *          of valid bytes in this output stream.
     * @see     java.io.ByteArrayOutputStream#count
     */ ByteArrayOutputStream.prototype.size = function() {
        return this.count;
    };
    ByteArrayOutputStream.prototype.toString = function(param) {
        if (!param) return this.toString_void();
        if (typeof param === "string") return this.toString_string(param);
        return this.toString_number(param);
    };
    /**
     * Converts the buffer's contents into a string decoding bytes using the
     * platform's default character set. The length of the new <tt>String</tt>
     * is a function of the character set, and hence may not be equal to the
     * size of the buffer.
     *
     * <p> This method always replaces malformed-input and unmappable-character
     * sequences with the default replacement string for the platform's
     * default character set. The {@linkplain java.nio.charset.CharsetDecoder}
     * class should be used when more control over the decoding process is
     * required.
     *
     * @return String decoded from the buffer's contents.
     * @since  JDK1.1
     */ ByteArrayOutputStream.prototype.toString_void = function() {
        return new String(this.buf /*, 0, this.count*/ ).toString();
    };
    /**
     * Converts the buffer's contents into a string by decoding the bytes using
     * the specified {@link java.nio.charset.Charset charsetName}. The length of
     * the new <tt>String</tt> is a function of the charset, and hence may not be
     * equal to the length of the byte array.
     *
     * <p> This method always replaces malformed-input and unmappable-character
     * sequences with this charset's default replacement string. The {@link
     * java.nio.charset.CharsetDecoder} class should be used when more control
     * over the decoding process is required.
     *
     * @param  charsetName  the name of a supported
     *              {@linkplain java.nio.charset.Charset </code>charset<code>}
     * @return String decoded from the buffer's contents.
     * @exception  UnsupportedEncodingException
     *             If the named charset is not supported
     * @since   JDK1.1
     */ ByteArrayOutputStream.prototype.toString_string = function(charsetName) {
        return new String(this.buf /*, 0, this.count, charsetName*/ ).toString();
    };
    /**
     * Creates a newly allocated string. Its size is the current size of
     * the output stream and the valid contents of the buffer have been
     * copied into it. Each character <i>c</i> in the resulting string is
     * constructed from the corresponding element <i>b</i> in the byte
     * array such that:
     * <blockquote><pre>
     *     c == (char)(((hibyte &amp; 0xff) &lt;&lt; 8) | (b &amp; 0xff))
     * </pre></blockquote>
     *
     * @deprecated This method does not properly convert bytes into characters.
     * As of JDK&nbsp;1.1, the preferred way to do this is via the
     * <code>toString(String enc)</code> method, which takes an encoding-name
     * argument, or the <code>toString()</code> method, which uses the
     * platform's default character encoding.
     *
     * @param      hibyte    the high byte of each resulting Unicode character.
     * @return     the current contents of the output stream, as a string.
     * @see        java.io.ByteArrayOutputStream#size()
     * @see        java.io.ByteArrayOutputStream#toString(String)
     * @see        java.io.ByteArrayOutputStream#toString()
     */ // @Deprecated
    ByteArrayOutputStream.prototype.toString_number = function(hibyte) {
        return new String(this.buf /*, hibyte, 0, this.count*/ ).toString();
    };
    /**
     * Closing a <tt>ByteArrayOutputStream</tt> has no effect. The methods in
     * this class can be called after the stream has been closed without
     * generating an <tt>IOException</tt>.
     * <p>
     *
     * @throws IOException
     */ ByteArrayOutputStream.prototype.close = function() {};
    return ByteArrayOutputStream;
}((0, $4fy8d.default));
var $eb66fc8da7ba125d$export$2e2bcd8739ae039 = $eb66fc8da7ba125d$var$ByteArrayOutputStream;

});
parcelRegister("4fy8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $318309f24ed454c4$export$2e2bcd8739ae039);

var $iChTI = parcelRequire("iChTI");

var $1NtER = parcelRequire("1NtER");
/*
 * Copyright (c) 1994, 2004, Oracle and/or its affiliates. All rights reserved.
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This code is free software; you can redistribute it and/or modify it
 * under the terms of the GNU General Public License version 2 only, as
 * published by the Free Software Foundation.  Oracle designates this
 * particular file as subject to the "Classpath" exception as provided
 * by Oracle in the LICENSE file that accompanied this code.
 *
 * This code is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or
 * FITNESS FOR A PARTICULAR PURPOSE.  See the GNU General Public License
 * version 2 for more details (a copy is included in the LICENSE file that
 * accompanied this code).
 *
 * You should have received a copy of the GNU General Public License version
 * 2 along with this work; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin St, Fifth Floor, Boston, MA 02110-1301 USA.
 *
 * Please contact Oracle, 500 Oracle Parkway, Redwood Shores, CA 94065 USA
 * or visit www.oracle.com if you need additional information or have any
 * questions.
 */ // package java.io;
/**
 * This abstract class is the superclass of all classes representing
 * an output stream of bytes. An output stream accepts output bytes
 * and sends them to some sink.
 * <p>
 * Applications that need to define a subclass of
 * <code>OutputStream</code> must always provide at least a method
 * that writes one byte of output.
 *
 * @author  Arthur van Hoff
 * @see     java.io.BufferedOutputStream
 * @see     java.io.ByteArrayOutputStream
 * @see     java.io.DataOutputStream
 * @see     java.io.FilterOutputStream
 * @see     java.io.InputStream
 * @see     java.io.OutputStream#write(int)
 * @since   JDK1.0
 */ var $318309f24ed454c4$var$OutputStream /*implements Closeable, Flushable*/  = /** @class */ function() {
    function OutputStream() {}
    /**
     * Writes <code>b.length</code> bytes from the specified byte array
     * to this output stream. The general contract for <code>write(b)</code>
     * is that it should have exactly the same effect as the call
     * <code>write(b, 0, b.length)</code>.
     *
     * @param      b   the data.
     * @exception  IOException  if an I/O error occurs.
     * @see        java.io.OutputStream#write(byte[], int, int)
     */ OutputStream.prototype.writeBytes = function(b) {
        this.writeBytesOffset(b, 0, b.length);
    };
    /**
     * Writes <code>len</code> bytes from the specified byte array
     * starting at offset <code>off</code> to this output stream.
     * The general contract for <code>write(b, off, len)</code> is that
     * some of the bytes in the array <code>b</code> are written to the
     * output stream in order; element <code>b[off]</code> is the first
     * byte written and <code>b[off+len-1]</code> is the last byte written
     * by this operation.
     * <p>
     * The <code>write</code> method of <code>OutputStream</code> calls
     * the write method of one argument on each of the bytes to be
     * written out. Subclasses are encouraged to override this method and
     * provide a more efficient implementation.
     * <p>
     * If <code>b</code> is <code>null</code>, a
     * <code>NullPointerException</code> is thrown.
     * <p>
     * If <code>off</code> is negative, or <code>len</code> is negative, or
     * <code>off+len</code> is greater than the length of the array
     * <code>b</code>, then an <tt>IndexOutOfBoundsException</tt> is thrown.
     *
     * @param      b     the data.
     * @param      off   the start offset in the data.
     * @param      len   the number of bytes to write.
     * @exception  IOException  if an I/O error occurs. In particular,
     *             an <code>IOException</code> is thrown if the output
     *             stream is closed.
     */ OutputStream.prototype.writeBytesOffset = function(b, off, len) {
        if (b == null) throw new (0, $1NtER.default)();
        else if (off < 0 || off > b.length || len < 0 || off + len > b.length || off + len < 0) throw new (0, $iChTI.default)();
        else if (len === 0) return;
        for(var i = 0; i < len; i++)this.write(b[off + i]);
    };
    /**
     * Flushes this output stream and forces any buffered output bytes
     * to be written out. The general contract of <code>flush</code> is
     * that calling it is an indication that, if any bytes previously
     * written have been buffered by the implementation of the output
     * stream, such bytes should immediately be written to their
     * intended destination.
     * <p>
     * If the intended destination of this stream is an abstraction provided by
     * the underlying operating system, for example a file, then flushing the
     * stream guarantees only that bytes previously written to the stream are
     * passed to the operating system for writing; it does not guarantee that
     * they are actually written to a physical device such as a disk drive.
     * <p>
     * The <code>flush</code> method of <code>OutputStream</code> does nothing.
     *
     * @exception  IOException  if an I/O error occurs.
     */ OutputStream.prototype.flush = function() {};
    /**
     * Closes this output stream and releases any system resources
     * associated with this stream. The general contract of <code>close</code>
     * is that it closes the output stream. A closed stream cannot perform
     * output operations and cannot be reopened.
     * <p>
     * The <code>close</code> method of <code>OutputStream</code> does nothing.
     *
     * @exception  IOException  if an I/O error occurs.
     */ OutputStream.prototype.close = function() {};
    return OutputStream;
}();
var $318309f24ed454c4$export$2e2bcd8739ae039 = $318309f24ed454c4$var$OutputStream;

});
parcelRegister("1NtER", function(module, exports) {

$parcel$export(module.exports, "default", () => $14f15f87cb8c1d7a$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $14f15f87cb8c1d7a$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $14f15f87cb8c1d7a$var$NullPointerException = /** @class */ function(_super) {
    $14f15f87cb8c1d7a$var$__extends(NullPointerException, _super);
    function NullPointerException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NullPointerException.kind = "NullPointerException";
    return NullPointerException;
}((0, $26SD6.default));
var $14f15f87cb8c1d7a$export$2e2bcd8739ae039 = $14f15f87cb8c1d7a$var$NullPointerException;

});


parcelRegister("h3QVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6bbc6d6e8a83d57$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $c6bbc6d6e8a83d57$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $c6bbc6d6e8a83d57$var$OutOfMemoryError = /** @class */ function(_super) {
    $c6bbc6d6e8a83d57$var$__extends(OutOfMemoryError, _super);
    function OutOfMemoryError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return OutOfMemoryError;
}((0, $26SD6.default));
var $c6bbc6d6e8a83d57$export$2e2bcd8739ae039 = $c6bbc6d6e8a83d57$var$OutOfMemoryError;

});





parcelRegister("6JrXb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e6ca10e24c2d714$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $4e6ca10e24c2d714$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $4e6ca10e24c2d714$var$ReaderException = /** @class */ function(_super) {
    $4e6ca10e24c2d714$var$__extends(ReaderException, _super);
    function ReaderException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReaderException.kind = "ReaderException";
    return ReaderException;
}((0, $26SD6.default));
var $4e6ca10e24c2d714$export$2e2bcd8739ae039 = $4e6ca10e24c2d714$var$ReaderException;

});



parcelRegister("fBj85", function(module, exports) {

var $au3R0 = parcelRequire("au3R0");

var $7G1W6 = parcelRequire("7G1W6");
var $b5b9267212cea4b2$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 *
 * QR Code reader to use from browser.
 */ var $b5b9267212cea4b2$export$6b868e6b4d8be0c6 = /** @class */ function(_super) {
    $b5b9267212cea4b2$var$__extends(BrowserPDF417Reader, _super);
    /**
     * Creates an instance of BrowserPDF417Reader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     */ function BrowserPDF417Reader(timeBetweenScansMillis) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $7G1W6.default)(), timeBetweenScansMillis) || this;
    }
    return BrowserPDF417Reader;
}((0, $au3R0.BrowserCodeReader));

});

parcelRegister("chxf2", function(module, exports) {

var $au3R0 = parcelRequire("au3R0");

var $d6Ijx = parcelRequire("d6Ijx");
var $8f10dba1ce21deec$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * @deprecated Moving to @zxing/browser
 *
 * QR Code reader to use from browser.
 */ var $8f10dba1ce21deec$export$da7a4b0ac9ceab04 = /** @class */ function(_super) {
    $8f10dba1ce21deec$var$__extends(BrowserQRCodeReader, _super);
    /**
     * Creates an instance of BrowserQRCodeReader.
     * @param {number} [timeBetweenScansMillis=500] the time delay between subsequent decode tries
     */ function BrowserQRCodeReader(timeBetweenScansMillis) {
        if (timeBetweenScansMillis === void 0) timeBetweenScansMillis = 500;
        return _super.call(this, new (0, $d6Ijx.default)(), timeBetweenScansMillis) || this;
    }
    return BrowserQRCodeReader;
}((0, $au3R0.BrowserCodeReader));

});

parcelRegister("bAAyj", function(module, exports) {

var $1NSRh = parcelRequire("1NSRh");

var $6YEpc = parcelRequire("6YEpc");

var $aH6oJ = parcelRequire("aH6oJ");

var $kLpae = parcelRequire("kLpae");

var $amwnq = parcelRequire("amwnq");
/**
 * @deprecated Moving to @zxing/browser
 */ var $86ff69087fbed4db$export$611f5a6e99b3de01 = /** @class */ function() {
    function BrowserQRCodeSvgWriter() {}
    /**
     * Writes and renders a QRCode SVG element.
     *
     * @param contents
     * @param width
     * @param height
     * @param hints
     */ BrowserQRCodeSvgWriter.prototype.write = function(contents, width, height, hints) {
        if (hints === void 0) hints = null;
        if (contents.length === 0) throw new (0, $kLpae.default)("Found empty contents");
        // if (format != BarcodeFormat.QR_CODE) {
        //   throw new IllegalArgumentException("Can only encode QR_CODE, but got " + format)
        // }
        if (width < 0 || height < 0) throw new (0, $kLpae.default)("Requested dimensions are too small: " + width + "x" + height);
        var errorCorrectionLevel = (0, $aH6oJ.default).L;
        var quietZone = BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE;
        if (hints !== null) {
            if (undefined !== hints.get((0, $1NSRh.default).ERROR_CORRECTION)) errorCorrectionLevel = (0, $aH6oJ.default).fromString(hints.get((0, $1NSRh.default).ERROR_CORRECTION).toString());
            if (undefined !== hints.get((0, $1NSRh.default).MARGIN)) quietZone = Number.parseInt(hints.get((0, $1NSRh.default).MARGIN).toString(), 10);
        }
        var code = (0, $6YEpc.default).encode(contents, errorCorrectionLevel, hints);
        return this.renderResult(code, width, height, quietZone);
    };
    /**
     * Renders the result and then appends it to the DOM.
     */ BrowserQRCodeSvgWriter.prototype.writeToDom = function(containerElement, contents, width, height, hints) {
        if (hints === void 0) hints = null;
        if (typeof containerElement === "string") containerElement = document.querySelector(containerElement);
        var svgElement = this.write(contents, width, height, hints);
        if (containerElement) containerElement.appendChild(svgElement);
    };
    /**
     * Note that the input matrix uses 0 == white, 1 == black.
     * The output matrix uses 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
     */ BrowserQRCodeSvgWriter.prototype.renderResult = function(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
        var input = code.getMatrix();
        if (input === null) throw new (0, $amwnq.default)();
        var inputWidth = input.getWidth();
        var inputHeight = input.getHeight();
        var qrWidth = inputWidth + quietZone * 2;
        var qrHeight = inputHeight + quietZone * 2;
        var outputWidth = Math.max(width, qrWidth);
        var outputHeight = Math.max(height, qrHeight);
        var multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
        // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
        // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
        // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
        // handle all the padding from 100x100 (the actual QR) up to 200x160.
        var leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
        var topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
        var svgElement = this.createSVGElement(outputWidth, outputHeight);
        for(var inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
            // Write the contents of this row of the barcode
            for(var inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) {
                var svgRectElement = this.createSvgRectElement(outputX, outputY, multiple, multiple);
                svgElement.appendChild(svgRectElement);
            }
        }
        return svgElement;
    };
    /**
     * Creates a SVG element.
     *
     * @param w SVG's width attribute
     * @param h SVG's height attribute
     */ BrowserQRCodeSvgWriter.prototype.createSVGElement = function(w, h) {
        var svgElement = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, "svg");
        svgElement.setAttributeNS(null, "height", w.toString());
        svgElement.setAttributeNS(null, "width", h.toString());
        return svgElement;
    };
    /**
     * Creates a SVG rect element.
     *
     * @param x Element's x coordinate
     * @param y Element's y coordinate
     * @param w Element's width attribute
     * @param h Element's height attribute
     */ BrowserQRCodeSvgWriter.prototype.createSvgRectElement = function(x, y, w, h) {
        var rect = document.createElementNS(BrowserQRCodeSvgWriter.SVG_NS, "rect");
        rect.setAttributeNS(null, "x", x.toString());
        rect.setAttributeNS(null, "y", y.toString());
        rect.setAttributeNS(null, "height", w.toString());
        rect.setAttributeNS(null, "width", h.toString());
        rect.setAttributeNS(null, "fill", "#000000");
        return rect;
    };
    BrowserQRCodeSvgWriter.QUIET_ZONE_SIZE = 4;
    /**
     * SVG markup NameSpace
     */ BrowserQRCodeSvgWriter.SVG_NS = "http://www.w3.org/2000/svg";
    return BrowserQRCodeSvgWriter;
}();

});
parcelRegister("1NSRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1504ebcb82af6f3b$export$2e2bcd8739ae039);
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing {*/ /**
 * These are a set of hints that you may pass to Writers to specify their behavior.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $1504ebcb82af6f3b$var$EncodeHintType;
(function(EncodeHintType) {
    /**
     * Specifies what degree of error correction to use, for example in QR Codes.
     * Type depends on the encoder. For example for QR codes it's type
     * {@link com.google.zxing.qrcode.decoder.ErrorCorrectionLevel ErrorCorrectionLevel}.
     * For Aztec it is of type {@link Integer}, representing the minimal percentage of error correction words.
     * For PDF417 it is of type {@link Integer}, valid values being 0 to 8.
     * In all cases, it can also be a {@link String} representation of the desired value as well.
     * Note: an Aztec symbol should have a minimum of 25% EC words.
     */ EncodeHintType[EncodeHintType["ERROR_CORRECTION"] = 0] = "ERROR_CORRECTION";
    /**
     * Specifies what character encoding to use where applicable (type {@link String})
     */ EncodeHintType[EncodeHintType["CHARACTER_SET"] = 1] = "CHARACTER_SET";
    /**
     * Specifies the matrix shape for Data Matrix (type {@link com.google.zxing.datamatrix.encoder.SymbolShapeHint})
     */ EncodeHintType[EncodeHintType["DATA_MATRIX_SHAPE"] = 2] = "DATA_MATRIX_SHAPE";
    /**
     * Specifies whether to use compact mode for Data Matrix (type {@link Boolean}, or "true" or "false"
     * {@link String } value).
     * The compact encoding mode also supports the encoding of characters that are not in the ISO-8859-1
     * character set via ECIs.
     * Please note that in that case, the most compact character encoding is chosen for characters in
     * the input that are not in the ISO-8859-1 character set. Based on experience, some scanners do not
     * support encodings like cp-1256 (Arabic). In such cases the encoding can be forced to UTF-8 by
     * means of the {@link #CHARACTER_SET} encoding hint.
     * Compact encoding also provides GS1-FNC1 support when {@link #GS1_FORMAT} is selected. In this case
     * group-separator character (ASCII 29 decimal) can be used to encode the positions of FNC1 codewords
     * for the purpose of delimiting AIs.
     * This option and {@link #FORCE_C40} are mutually exclusive.
     */ EncodeHintType[EncodeHintType["DATA_MATRIX_COMPACT"] = 3] = "DATA_MATRIX_COMPACT";
    /**
     * Specifies a minimum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
     *
     * @deprecated use width/height params in
     * {@link com.google.zxing.datamatrix.DataMatrixWriter#encode(String, BarcodeFormat, int, int)}
     */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MIN_SIZE"] = 4] = "MIN_SIZE";
    /**
     * Specifies a maximum barcode size (type {@link Dimension}). Only applicable to Data Matrix now.
     *
     * @deprecated without replacement
     */ /*@Deprecated*/ EncodeHintType[EncodeHintType["MAX_SIZE"] = 5] = "MAX_SIZE";
    /**
     * Specifies margin, in pixels, to use when generating the barcode. The meaning can vary
     * by format; for example it controls margin before and after the barcode horizontally for
     * most 1D formats. (Type {@link Integer}, or {@link String} representation of the integer value).
     */ EncodeHintType[EncodeHintType["MARGIN"] = 6] = "MARGIN";
    /**
     * Specifies whether to use compact mode for PDF417 (type {@link Boolean}, or "true" or "false"
     * {@link String} value).
     */ EncodeHintType[EncodeHintType["PDF417_COMPACT"] = 7] = "PDF417_COMPACT";
    /**
     * Specifies what compaction mode to use for PDF417 (type
     * {@link com.google.zxing.pdf417.encoder.Compaction Compaction} or {@link String} value of one of its
     * enum values).
     */ EncodeHintType[EncodeHintType["PDF417_COMPACTION"] = 8] = "PDF417_COMPACTION";
    /**
     * Specifies the minimum and maximum number of rows and columns for PDF417 (type
     * {@link com.google.zxing.pdf417.encoder.Dimensions Dimensions}).
     */ EncodeHintType[EncodeHintType["PDF417_DIMENSIONS"] = 9] = "PDF417_DIMENSIONS";
    /**
     * Specifies the required number of layers for an Aztec code.
     * A negative number (-1, -2, -3, -4) specifies a compact Aztec code.
     * 0 indicates to use the minimum number of layers (the default).
     * A positive number (1, 2, .. 32) specifies a normal (non-compact) Aztec code.
     * (Type {@link Integer}, or {@link String} representation of the integer value).
     */ EncodeHintType[EncodeHintType["AZTEC_LAYERS"] = 10] = "AZTEC_LAYERS";
    /**
     * Specifies the exact version of QR code to be encoded.
     * (Type {@link Integer}, or {@link String} representation of the integer value).
     */ EncodeHintType[EncodeHintType["QR_VERSION"] = 11] = "QR_VERSION";
    /**
     * Specifies whether the data should be encoded to the GS1 standard (type {@link Boolean}, or "true" or "false"
     * {@link String } value).
     */ EncodeHintType[EncodeHintType["GS1_FORMAT"] = 12] = "GS1_FORMAT";
    /**
     * Forces C40 encoding for data-matrix (type {@link Boolean}, or "true" or "false") {@link String } value). This
     * option and {@link #DATA_MATRIX_COMPACT} are mutually exclusive.
     */ EncodeHintType[EncodeHintType["FORCE_C40"] = 13] = "FORCE_C40";
})($1504ebcb82af6f3b$var$EncodeHintType || ($1504ebcb82af6f3b$var$EncodeHintType = {}));
var $1504ebcb82af6f3b$export$2e2bcd8739ae039 = $1504ebcb82af6f3b$var$EncodeHintType;

});

parcelRegister("6YEpc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5147b05fe9dbdea9$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1NSRh = parcelRequire("1NSRh");

var $fHKUB = parcelRequire("fHKUB");

var $l8eP1 = parcelRequire("l8eP1");

var $7nLua = parcelRequire("7nLua");

var $jFi7K = parcelRequire("jFi7K");

var $aLAHy = parcelRequire("aLAHy");

var $b41gY = parcelRequire("b41gY");

var $hEUjg = parcelRequire("hEUjg");

var $cvLRZ = parcelRequire("cvLRZ");

var $2Km2C = parcelRequire("2Km2C");

var $78He7 = parcelRequire("78He7");

var $fPMAB = parcelRequire("fPMAB");

var $8Pp3N = parcelRequire("8Pp3N");

var $lq7FB = parcelRequire("lq7FB");
var $5147b05fe9dbdea9$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*import java.io.UnsupportedEncodingException;*/ /*import java.util.ArrayList;*/ /*import java.util.Collection;*/ /*import java.util.Map;*/ /**
 * @author satorux@google.com (Satoru Takabayashi) - creator
 * @author dswitkin@google.com (Daniel Switkin) - ported from C++
 */ var $5147b05fe9dbdea9$var$Encoder = /** @class */ function() {
    // TYPESCRIPTPORT: changed to UTF8, the default for js
    function Encoder() {}
    // The mask penalty calculation is complicated.  See Table 21 of JISX0510:2004 (p.45) for details.
    // Basically it applies four rules and summate all penalties.
    Encoder.calculateMaskPenalty = function(matrix) {
        return (0, $hEUjg.default).applyMaskPenaltyRule1(matrix) + (0, $hEUjg.default).applyMaskPenaltyRule2(matrix) + (0, $hEUjg.default).applyMaskPenaltyRule3(matrix) + (0, $hEUjg.default).applyMaskPenaltyRule4(matrix);
    };
    /**
     * @param content text to encode
     * @param ecLevel error correction level to use
     * @return {@link QRCode} representing the encoded QR code
     * @throws WriterException if encoding can't succeed, because of for example invalid content
     *   or configuration
     */ // public static encode(content: string, ecLevel: ErrorCorrectionLevel): QRCode /*throws WriterException*/ {
    //   return encode(content, ecLevel, null)
    // }
    Encoder.encode = function(content, ecLevel, hints) {
        if (hints === void 0) hints = null;
        // Determine what character encoding has been specified by the caller, if any
        var encoding = Encoder.DEFAULT_BYTE_MODE_ENCODING;
        var hasEncodingHint = hints !== null && undefined !== hints.get((0, $1NSRh.default).CHARACTER_SET);
        if (hasEncodingHint) encoding = hints.get((0, $1NSRh.default).CHARACTER_SET).toString();
        // Pick an encoding mode appropriate for the content. Note that this will not attempt to use
        // multiple modes / segments even if that were more efficient. Twould be nice.
        var mode = this.chooseMode(content, encoding);
        // This will store the header information, like mode and
        // length, as well as "header" segments like an ECI segment.
        var headerBits = new (0, $fHKUB.default)();
        // Append ECI segment if applicable
        if (mode === (0, $aLAHy.default).BYTE && (hasEncodingHint || Encoder.DEFAULT_BYTE_MODE_ENCODING !== encoding)) {
            var eci = (0, $l8eP1.default).getCharacterSetECIByName(encoding);
            if (eci !== undefined) this.appendECI(eci, headerBits);
        }
        // (With ECI in place,) Write the mode marker
        this.appendModeInfo(mode, headerBits);
        // Collect data within the main segment, separately, to count its size if needed. Don't add it to
        // main payload yet.
        var dataBits = new (0, $fHKUB.default)();
        this.appendBytes(content, mode, dataBits, encoding);
        var version;
        if (hints !== null && undefined !== hints.get((0, $1NSRh.default).QR_VERSION)) {
            var versionNumber = Number.parseInt(hints.get((0, $1NSRh.default).QR_VERSION).toString(), 10);
            version = (0, $b41gY.default).getVersionForNumber(versionNumber);
            var bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, version);
            if (!this.willFit(bitsNeeded, version, ecLevel)) throw new (0, $lq7FB.default)("Data too big for requested version");
        } else version = this.recommendVersion(ecLevel, mode, headerBits, dataBits);
        var headerAndDataBits = new (0, $fHKUB.default)();
        headerAndDataBits.appendBitArray(headerBits);
        // Find "length" of main segment and write it
        var numLetters = mode === (0, $aLAHy.default).BYTE ? dataBits.getSizeInBytes() : content.length;
        this.appendLengthInfo(numLetters, version, mode, headerAndDataBits);
        // Put data together into the overall payload
        headerAndDataBits.appendBitArray(dataBits);
        var ecBlocks = version.getECBlocksForLevel(ecLevel);
        var numDataBytes = version.getTotalCodewords() - ecBlocks.getTotalECCodewords();
        // Terminate the bits properly.
        this.terminateBits(numDataBytes, headerAndDataBits);
        // Interleave data bits with error correction code.
        var finalBits = this.interleaveWithECBytes(headerAndDataBits, version.getTotalCodewords(), numDataBytes, ecBlocks.getNumBlocks());
        var qrCode = new (0, $2Km2C.default)();
        qrCode.setECLevel(ecLevel);
        qrCode.setMode(mode);
        qrCode.setVersion(version);
        //  Choose the mask pattern and set to "qrCode".
        var dimension = version.getDimensionForVersion();
        var matrix = new (0, $cvLRZ.default)(dimension, dimension);
        var maskPattern = this.chooseMaskPattern(finalBits, ecLevel, version, matrix);
        qrCode.setMaskPattern(maskPattern);
        // Build the matrix and set it to "qrCode".
        (0, $78He7.default).buildMatrix(finalBits, ecLevel, version, maskPattern, matrix);
        qrCode.setMatrix(matrix);
        return qrCode;
    };
    /**
     * Decides the smallest version of QR code that will contain all of the provided data.
     *
     * @throws WriterException if the data cannot fit in any version
     */ Encoder.recommendVersion = function(ecLevel, mode, headerBits, dataBits) {
        // Hard part: need to know version to know how many bits length takes. But need to know how many
        // bits it takes to know version. First we take a guess at version by assuming version will be
        // the minimum, 1:
        var provisionalBitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, (0, $b41gY.default).getVersionForNumber(1));
        var provisionalVersion = this.chooseVersion(provisionalBitsNeeded, ecLevel);
        // Use that guess to calculate the right version. I am still not sure this works in 100% of cases.
        var bitsNeeded = this.calculateBitsNeeded(mode, headerBits, dataBits, provisionalVersion);
        return this.chooseVersion(bitsNeeded, ecLevel);
    };
    Encoder.calculateBitsNeeded = function(mode, headerBits, dataBits, version) {
        return headerBits.getSize() + mode.getCharacterCountBits(version) + dataBits.getSize();
    };
    /**
     * @return the code point of the table used in alphanumeric mode or
     *  -1 if there is no corresponding code in the table.
     */ Encoder.getAlphanumericCode = function(code /*int*/ ) {
        if (code < Encoder.ALPHANUMERIC_TABLE.length) return Encoder.ALPHANUMERIC_TABLE[code];
        return -1;
    };
    // public static chooseMode(content: string): Mode {
    //   return chooseMode(content, null);
    // }
    /**
     * Choose the best mode by examining the content. Note that 'encoding' is used as a hint;
     * if it is Shift_JIS, and the input is only double-byte Kanji, then we return {@link Mode#KANJI}.
     */ Encoder.chooseMode = function(content, encoding) {
        if (encoding === void 0) encoding = null;
        if ((0, $l8eP1.default).SJIS.getName() === encoding && this.isOnlyDoubleByteKanji(content)) // Choose Kanji mode if all input are double-byte characters
        return (0, $aLAHy.default).KANJI;
        var hasNumeric = false;
        var hasAlphanumeric = false;
        for(var i = 0, length_1 = content.length; i < length_1; ++i){
            var c = content.charAt(i);
            if (Encoder.isDigit(c)) hasNumeric = true;
            else if (this.getAlphanumericCode(c.charCodeAt(0)) !== -1) hasAlphanumeric = true;
            else return (0, $aLAHy.default).BYTE;
        }
        if (hasAlphanumeric) return (0, $aLAHy.default).ALPHANUMERIC;
        if (hasNumeric) return (0, $aLAHy.default).NUMERIC;
        return (0, $aLAHy.default).BYTE;
    };
    Encoder.isOnlyDoubleByteKanji = function(content) {
        var bytes;
        try {
            bytes = (0, $fPMAB.default).encode(content, (0, $l8eP1.default).SJIS); // content.getBytes("Shift_JIS"))
        } catch (ignored /*: UnsupportedEncodingException*/ ) {
            return false;
        }
        var length = bytes.length;
        if (length % 2 !== 0) return false;
        for(var i = 0; i < length; i += 2){
            var byte1 = bytes[i] & 0xFF;
            if ((byte1 < 0x81 || byte1 > 0x9F) && (byte1 < 0xE0 || byte1 > 0xEB)) return false;
        }
        return true;
    };
    Encoder.chooseMaskPattern = function(bits, ecLevel, version, matrix) {
        var minPenalty = Number.MAX_SAFE_INTEGER; // Lower penalty is better.
        var bestMaskPattern = -1;
        // We try all mask patterns to choose the best one.
        for(var maskPattern = 0; maskPattern < (0, $2Km2C.default).NUM_MASK_PATTERNS; maskPattern++){
            (0, $78He7.default).buildMatrix(bits, ecLevel, version, maskPattern, matrix);
            var penalty = this.calculateMaskPenalty(matrix);
            if (penalty < minPenalty) {
                minPenalty = penalty;
                bestMaskPattern = maskPattern;
            }
        }
        return bestMaskPattern;
    };
    Encoder.chooseVersion = function(numInputBits /*int*/ , ecLevel) {
        for(var versionNum = 1; versionNum <= 40; versionNum++){
            var version = (0, $b41gY.default).getVersionForNumber(versionNum);
            if (Encoder.willFit(numInputBits, version, ecLevel)) return version;
        }
        throw new (0, $lq7FB.default)("Data too big");
    };
    /**
     * @return true if the number of input bits will fit in a code with the specified version and
     * error correction level.
     */ Encoder.willFit = function(numInputBits /*int*/ , version, ecLevel) {
        // In the following comments, we use numbers of Version 7-H.
        // numBytes = 196
        var numBytes = version.getTotalCodewords();
        // getNumECBytes = 130
        var ecBlocks = version.getECBlocksForLevel(ecLevel);
        var numEcBytes = ecBlocks.getTotalECCodewords();
        // getNumDataBytes = 196 - 130 = 66
        var numDataBytes = numBytes - numEcBytes;
        var totalInputBytes = (numInputBits + 7) / 8;
        return numDataBytes >= totalInputBytes;
    };
    /**
     * Terminate bits as described in 8.4.8 and 8.4.9 of JISX0510:2004 (p.24).
     */ Encoder.terminateBits = function(numDataBytes /*int*/ , bits) {
        var capacity = numDataBytes * 8;
        if (bits.getSize() > capacity) throw new (0, $lq7FB.default)("data bits cannot fit in the QR Code" + bits.getSize() + " > " + capacity);
        for(var i = 0; i < 4 && bits.getSize() < capacity; ++i)bits.appendBit(false);
        // Append termination bits. See 8.4.8 of JISX0510:2004 (p.24) for details.
        // If the last byte isn't 8-bit aligned, we'll add padding bits.
        var numBitsInLastByte = bits.getSize() & 0x07;
        if (numBitsInLastByte > 0) for(var i = numBitsInLastByte; i < 8; i++)bits.appendBit(false);
        // If we have more space, we'll fill the space with padding patterns defined in 8.4.9 (p.24).
        var numPaddingBytes = numDataBytes - bits.getSizeInBytes();
        for(var i = 0; i < numPaddingBytes; ++i)bits.appendBits((i & 0x01) === 0 ? 0xEC : 0x11, 8);
        if (bits.getSize() !== capacity) throw new (0, $lq7FB.default)("Bits size does not equal capacity");
    };
    /**
     * Get number of data bytes and number of error correction bytes for block id "blockID". Store
     * the result in "numDataBytesInBlock", and "numECBytesInBlock". See table 12 in 8.5.1 of
     * JISX0510:2004 (p.30)
     */ Encoder.getNumDataBytesAndNumECBytesForBlockID = function(numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ , blockID /*int*/ , numDataBytesInBlock, numECBytesInBlock) {
        if (blockID >= numRSBlocks) throw new (0, $lq7FB.default)("Block ID too large");
        // numRsBlocksInGroup2 = 196 % 5 = 1
        var numRsBlocksInGroup2 = numTotalBytes % numRSBlocks;
        // numRsBlocksInGroup1 = 5 - 1 = 4
        var numRsBlocksInGroup1 = numRSBlocks - numRsBlocksInGroup2;
        // numTotalBytesInGroup1 = 196 / 5 = 39
        var numTotalBytesInGroup1 = Math.floor(numTotalBytes / numRSBlocks);
        // numTotalBytesInGroup2 = 39 + 1 = 40
        var numTotalBytesInGroup2 = numTotalBytesInGroup1 + 1;
        // numDataBytesInGroup1 = 66 / 5 = 13
        var numDataBytesInGroup1 = Math.floor(numDataBytes / numRSBlocks);
        // numDataBytesInGroup2 = 13 + 1 = 14
        var numDataBytesInGroup2 = numDataBytesInGroup1 + 1;
        // numEcBytesInGroup1 = 39 - 13 = 26
        var numEcBytesInGroup1 = numTotalBytesInGroup1 - numDataBytesInGroup1;
        // numEcBytesInGroup2 = 40 - 14 = 26
        var numEcBytesInGroup2 = numTotalBytesInGroup2 - numDataBytesInGroup2;
        // Sanity checks.
        // 26 = 26
        if (numEcBytesInGroup1 !== numEcBytesInGroup2) throw new (0, $lq7FB.default)("EC bytes mismatch");
        // 5 = 4 + 1.
        if (numRSBlocks !== numRsBlocksInGroup1 + numRsBlocksInGroup2) throw new (0, $lq7FB.default)("RS blocks mismatch");
        // 196 = (13 + 26) * 4 + (14 + 26) * 1
        if (numTotalBytes !== (numDataBytesInGroup1 + numEcBytesInGroup1) * numRsBlocksInGroup1 + (numDataBytesInGroup2 + numEcBytesInGroup2) * numRsBlocksInGroup2) throw new (0, $lq7FB.default)("Total bytes mismatch");
        if (blockID < numRsBlocksInGroup1) {
            numDataBytesInBlock[0] = numDataBytesInGroup1;
            numECBytesInBlock[0] = numEcBytesInGroup1;
        } else {
            numDataBytesInBlock[0] = numDataBytesInGroup2;
            numECBytesInBlock[0] = numEcBytesInGroup2;
        }
    };
    /**
     * Interleave "bits" with corresponding error correction bytes. On success, store the result in
     * "result". The interleave rule is complicated. See 8.6 of JISX0510:2004 (p.37) for details.
     */ Encoder.interleaveWithECBytes = function(bits, numTotalBytes /*int*/ , numDataBytes /*int*/ , numRSBlocks /*int*/ ) {
        var e_1, _a, e_2, _b;
        // "bits" must have "getNumDataBytes" bytes of data.
        if (bits.getSizeInBytes() !== numDataBytes) throw new (0, $lq7FB.default)("Number of bits and data bytes does not match");
        // Step 1.  Divide data bytes into blocks and generate error correction bytes for them. We'll
        // store the divided data bytes blocks and error correction bytes blocks into "blocks".
        var dataBytesOffset = 0;
        var maxNumDataBytes = 0;
        var maxNumEcBytes = 0;
        // Since, we know the number of reedsolmon blocks, we can initialize the vector with the number.
        var blocks = new Array(); // new Array<BlockPair>(numRSBlocks)
        for(var i = 0; i < numRSBlocks; ++i){
            var numDataBytesInBlock = new Int32Array(1);
            var numEcBytesInBlock = new Int32Array(1);
            Encoder.getNumDataBytesAndNumECBytesForBlockID(numTotalBytes, numDataBytes, numRSBlocks, i, numDataBytesInBlock, numEcBytesInBlock);
            var size = numDataBytesInBlock[0];
            var dataBytes = new Uint8Array(size);
            bits.toBytes(8 * dataBytesOffset, dataBytes, 0, size);
            var ecBytes = Encoder.generateECBytes(dataBytes, numEcBytesInBlock[0]);
            blocks.push(new (0, $8Pp3N.default)(dataBytes, ecBytes));
            maxNumDataBytes = Math.max(maxNumDataBytes, size);
            maxNumEcBytes = Math.max(maxNumEcBytes, ecBytes.length);
            dataBytesOffset += numDataBytesInBlock[0];
        }
        if (numDataBytes !== dataBytesOffset) throw new (0, $lq7FB.default)("Data bytes does not match offset");
        var result = new (0, $fHKUB.default)();
        // First, place data blocks.
        for(var i = 0; i < maxNumDataBytes; ++i)try {
            for(var blocks_1 = (e_1 = void 0, $5147b05fe9dbdea9$var$__values(blocks)), blocks_1_1 = blocks_1.next(); !blocks_1_1.done; blocks_1_1 = blocks_1.next()){
                var block = blocks_1_1.value;
                var dataBytes = block.getDataBytes();
                if (i < dataBytes.length) result.appendBits(dataBytes[i], 8);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (blocks_1_1 && !blocks_1_1.done && (_a = blocks_1.return)) _a.call(blocks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // Then, place error correction blocks.
        for(var i = 0; i < maxNumEcBytes; ++i)try {
            for(var blocks_2 = (e_2 = void 0, $5147b05fe9dbdea9$var$__values(blocks)), blocks_2_1 = blocks_2.next(); !blocks_2_1.done; blocks_2_1 = blocks_2.next()){
                var block = blocks_2_1.value;
                var ecBytes = block.getErrorCorrectionBytes();
                if (i < ecBytes.length) result.appendBits(ecBytes[i], 8);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (blocks_2_1 && !blocks_2_1.done && (_b = blocks_2.return)) _b.call(blocks_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        if (numTotalBytes !== result.getSizeInBytes()) throw new (0, $lq7FB.default)("Interleaving error: " + numTotalBytes + " and " + result.getSizeInBytes() + " differ.");
        return result;
    };
    Encoder.generateECBytes = function(dataBytes, numEcBytesInBlock /*int*/ ) {
        var numDataBytes = dataBytes.length;
        var toEncode = new Int32Array(numDataBytes + numEcBytesInBlock); // int[numDataBytes + numEcBytesInBlock]
        for(var i = 0; i < numDataBytes; i++)toEncode[i] = dataBytes[i] & 0xFF;
        new (0, $jFi7K.default)((0, $7nLua.default).QR_CODE_FIELD_256).encode(toEncode, numEcBytesInBlock);
        var ecBytes = new Uint8Array(numEcBytesInBlock);
        for(var i = 0; i < numEcBytesInBlock; i++)ecBytes[i] = /*(byte) */ toEncode[numDataBytes + i];
        return ecBytes;
    };
    /**
     * Append mode info. On success, store the result in "bits".
     */ Encoder.appendModeInfo = function(mode, bits) {
        bits.appendBits(mode.getBits(), 4);
    };
    /**
     * Append length info. On success, store the result in "bits".
     */ Encoder.appendLengthInfo = function(numLetters /*int*/ , version, mode, bits) {
        var numBits = mode.getCharacterCountBits(version);
        if (numLetters >= 1 << numBits) throw new (0, $lq7FB.default)(numLetters + " is bigger than " + ((1 << numBits) - 1));
        bits.appendBits(numLetters, numBits);
    };
    /**
     * Append "bytes" in "mode" mode (encoding) into "bits". On success, store the result in "bits".
     */ Encoder.appendBytes = function(content, mode, bits, encoding) {
        switch(mode){
            case (0, $aLAHy.default).NUMERIC:
                Encoder.appendNumericBytes(content, bits);
                break;
            case (0, $aLAHy.default).ALPHANUMERIC:
                Encoder.appendAlphanumericBytes(content, bits);
                break;
            case (0, $aLAHy.default).BYTE:
                Encoder.append8BitBytes(content, bits, encoding);
                break;
            case (0, $aLAHy.default).KANJI:
                Encoder.appendKanjiBytes(content, bits);
                break;
            default:
                throw new (0, $lq7FB.default)("Invalid mode: " + mode);
        }
    };
    Encoder.getDigit = function(singleCharacter) {
        return singleCharacter.charCodeAt(0) - 48;
    };
    Encoder.isDigit = function(singleCharacter) {
        var cn = Encoder.getDigit(singleCharacter);
        return cn >= 0 && cn <= 9;
    };
    Encoder.appendNumericBytes = function(content, bits) {
        var length = content.length;
        var i = 0;
        while(i < length){
            var num1 = Encoder.getDigit(content.charAt(i));
            if (i + 2 < length) {
                // Encode three numeric letters in ten bits.
                var num2 = Encoder.getDigit(content.charAt(i + 1));
                var num3 = Encoder.getDigit(content.charAt(i + 2));
                bits.appendBits(num1 * 100 + num2 * 10 + num3, 10);
                i += 3;
            } else if (i + 1 < length) {
                // Encode two numeric letters in seven bits.
                var num2 = Encoder.getDigit(content.charAt(i + 1));
                bits.appendBits(num1 * 10 + num2, 7);
                i += 2;
            } else {
                // Encode one numeric letter in four bits.
                bits.appendBits(num1, 4);
                i++;
            }
        }
    };
    Encoder.appendAlphanumericBytes = function(content, bits) {
        var length = content.length;
        var i = 0;
        while(i < length){
            var code1 = Encoder.getAlphanumericCode(content.charCodeAt(i));
            if (code1 === -1) throw new (0, $lq7FB.default)();
            if (i + 1 < length) {
                var code2 = Encoder.getAlphanumericCode(content.charCodeAt(i + 1));
                if (code2 === -1) throw new (0, $lq7FB.default)();
                // Encode two alphanumeric letters in 11 bits.
                bits.appendBits(code1 * 45 + code2, 11);
                i += 2;
            } else {
                // Encode one alphanumeric letter in six bits.
                bits.appendBits(code1, 6);
                i++;
            }
        }
    };
    Encoder.append8BitBytes = function(content, bits, encoding) {
        var bytes;
        try {
            bytes = (0, $fPMAB.default).encode(content, encoding);
        } catch (uee /*: UnsupportedEncodingException*/ ) {
            throw new (0, $lq7FB.default)(uee);
        }
        for(var i = 0, length_2 = bytes.length; i !== length_2; i++){
            var b = bytes[i];
            bits.appendBits(b, 8);
        }
    };
    /**
     * @throws WriterException
     */ Encoder.appendKanjiBytes = function(content, bits) {
        var bytes;
        try {
            bytes = (0, $fPMAB.default).encode(content, (0, $l8eP1.default).SJIS);
        } catch (uee /*: UnsupportedEncodingException*/ ) {
            throw new (0, $lq7FB.default)(uee);
        }
        var length = bytes.length;
        for(var i = 0; i < length; i += 2){
            var byte1 = bytes[i] & 0xFF;
            var byte2 = bytes[i + 1] & 0xFF;
            var code = byte1 << 8 & 0xFFFFFFFF | byte2;
            var subtracted = -1;
            if (code >= 0x8140 && code <= 0x9ffc) subtracted = code - 0x8140;
            else if (code >= 0xe040 && code <= 0xebbf) subtracted = code - 0xc140;
            if (subtracted === -1) throw new (0, $lq7FB.default)("Invalid byte sequence");
            var encoded = (subtracted >> 8) * 0xc0 + (subtracted & 0xff);
            bits.appendBits(encoded, 13);
        }
    };
    Encoder.appendECI = function(eci, bits) {
        bits.appendBits((0, $aLAHy.default).ECI.getBits(), 4);
        // This is correct for values up to 127, which is all we need now.
        bits.appendBits(eci.getValue(), 8);
    };
    // The original table is defined in the table 5 of JISX0510:2004 (p.19).
    Encoder.ALPHANUMERIC_TABLE = Int32Array.from([
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        36,
        -1,
        -1,
        -1,
        37,
        38,
        -1,
        -1,
        -1,
        -1,
        39,
        40,
        -1,
        41,
        42,
        43,
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        44,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        -1,
        -1,
        -1,
        -1,
        -1
    ]);
    Encoder.DEFAULT_BYTE_MODE_ENCODING = (0, $l8eP1.default).UTF8.getName(); // "ISO-8859-1"
    return Encoder;
}();
var $5147b05fe9dbdea9$export$2e2bcd8739ae039 = $5147b05fe9dbdea9$var$Encoder;

});
parcelRegister("jFi7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50fe7b0fc2ab518$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4v5ZZ = parcelRequire("4v5ZZ");

var $b6IL4 = parcelRequire("b6IL4");

var $kLpae = parcelRequire("kLpae");
/**
 * <p>Implements Reed-Solomon encoding, as the name implies.</p>
 *
 * @author Sean Owen
 * @author William Rucklidge
 */ var $e50fe7b0fc2ab518$var$ReedSolomonEncoder = /** @class */ function() {
    /**
     * A reed solomon error-correcting encoding constructor is created by
     * passing as Galois Field with of size equal to the number of code
     * words (symbols) in the alphabet (the number of values in each
     * element of arrays that are encoded/decoded).
     * @param field A galois field with a number of elements equal to the size
     * of the alphabet of symbols to encode.
     */ function ReedSolomonEncoder(field) {
        this.field = field;
        this.cachedGenerators = [];
        this.cachedGenerators.push(new (0, $4v5ZZ.default)(field, Int32Array.from([
            1
        ])));
    }
    ReedSolomonEncoder.prototype.buildGenerator = function(degree /*int*/ ) {
        var cachedGenerators = this.cachedGenerators;
        if (degree >= cachedGenerators.length) {
            var lastGenerator = cachedGenerators[cachedGenerators.length - 1];
            var field = this.field;
            for(var d = cachedGenerators.length; d <= degree; d++){
                var nextGenerator = lastGenerator.multiply(new (0, $4v5ZZ.default)(field, Int32Array.from([
                    1,
                    field.exp(d - 1 + field.getGeneratorBase())
                ])));
                cachedGenerators.push(nextGenerator);
                lastGenerator = nextGenerator;
            }
        }
        return cachedGenerators[degree];
    };
    /**
     * <p>Encode a sequence of code words (symbols) using Reed-Solomon to allow decoders
     * to detect and correct errors that may have been introduced when the resulting
     * data is stored or transmitted.</p>
     *
     * @param toEncode array used for both and output. Caller initializes the array with
     * the code words (symbols) to be encoded followed by empty elements allocated to make
     * space for error-correction code words in the encoded output. The array contains
     * the encdoded output when encode returns. Code words are encoded as numbers from
     * 0 to n-1, where n is the number of possible code words (symbols), as determined
     * by the size of the Galois Field passed in the constructor of this object.
     * @param ecBytes the number of elements reserved in the array (first parameter)
     * to store error-correction code words. Thus, the number of code words (symbols)
     * to encode in the first parameter is thus toEncode.length - ecBytes.
     * Note, the use of "bytes" in the name of this parameter is misleading, as there may
     * be more or fewer than 256 symbols being encoded, as determined by the number of
     * elements in the Galois Field passed as a constructor to this object.
     * @throws IllegalArgumentException thrown in response to validation errros.
     */ ReedSolomonEncoder.prototype.encode = function(toEncode, ecBytes /*int*/ ) {
        if (ecBytes === 0) throw new (0, $kLpae.default)("No error correction bytes");
        var dataBytes = toEncode.length - ecBytes;
        if (dataBytes <= 0) throw new (0, $kLpae.default)("No data bytes provided");
        var generator = this.buildGenerator(ecBytes);
        var infoCoefficients = new Int32Array(dataBytes);
        (0, $b6IL4.default).arraycopy(toEncode, 0, infoCoefficients, 0, dataBytes);
        var info = new (0, $4v5ZZ.default)(this.field, infoCoefficients);
        info = info.multiplyByMonomial(ecBytes, 1);
        var remainder = info.divide(generator)[1];
        var coefficients = remainder.getCoefficients();
        var numZeroCoefficients = ecBytes - coefficients.length;
        for(var i = 0; i < numZeroCoefficients; i++)toEncode[dataBytes + i] = 0;
        (0, $b6IL4.default).arraycopy(coefficients, 0, toEncode, dataBytes + numZeroCoefficients, coefficients.length);
    };
    return ReedSolomonEncoder;
}();
var $e50fe7b0fc2ab518$export$2e2bcd8739ae039 = $e50fe7b0fc2ab518$var$ReedSolomonEncoder;

});

parcelRegister("hEUjg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdb1da0c3ce6bbe8$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kLpae = parcelRequire("kLpae");
/**
 * @author Satoru Takabayashi
 * @author Daniel Switkin
 * @author Sean Owen
 */ var $cdb1da0c3ce6bbe8$var$MaskUtil = /** @class */ function() {
    function MaskUtil() {
    // do nothing
    }
    /**
     * Apply mask penalty rule 1 and return the penalty. Find repetitive cells with the same color and
     * give penalty to them. Example: 00000 or 11111.
     */ MaskUtil.applyMaskPenaltyRule1 = function(matrix) {
        return MaskUtil.applyMaskPenaltyRule1Internal(matrix, true) + MaskUtil.applyMaskPenaltyRule1Internal(matrix, false);
    };
    /**
     * Apply mask penalty rule 2 and return the penalty. Find 2x2 blocks with the same color and give
     * penalty to them. This is actually equivalent to the spec's rule, which is to find MxN blocks and give a
     * penalty proportional to (M-1)x(N-1), because this is the number of 2x2 blocks inside such a block.
     */ MaskUtil.applyMaskPenaltyRule2 = function(matrix) {
        var penalty = 0;
        var array = matrix.getArray();
        var width = matrix.getWidth();
        var height = matrix.getHeight();
        for(var y = 0; y < height - 1; y++){
            var arrayY = array[y];
            for(var x = 0; x < width - 1; x++){
                var value = arrayY[x];
                if (value === arrayY[x + 1] && value === array[y + 1][x] && value === array[y + 1][x + 1]) penalty++;
            }
        }
        return MaskUtil.N2 * penalty;
    };
    /**
     * Apply mask penalty rule 3 and return the penalty. Find consecutive runs of 1:1:3:1:1:4
     * starting with black, or 4:1:1:3:1:1 starting with white, and give penalty to them.  If we
     * find patterns like 000010111010000, we give penalty once.
     */ MaskUtil.applyMaskPenaltyRule3 = function(matrix) {
        var numPenalties = 0;
        var array = matrix.getArray();
        var width = matrix.getWidth();
        var height = matrix.getHeight();
        for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
            var arrayY = array[y]; // We can at least optimize this access
            if (x + 6 < width && arrayY[x] === 1 && arrayY[x + 1] === 0 && arrayY[x + 2] === 1 && arrayY[x + 3] === 1 && arrayY[x + 4] === 1 && arrayY[x + 5] === 0 && arrayY[x + 6] === 1 && (MaskUtil.isWhiteHorizontal(arrayY, x - 4, x) || MaskUtil.isWhiteHorizontal(arrayY, x + 7, x + 11))) numPenalties++;
            if (y + 6 < height && array[y][x] === 1 && array[y + 1][x] === 0 && array[y + 2][x] === 1 && array[y + 3][x] === 1 && array[y + 4][x] === 1 && array[y + 5][x] === 0 && array[y + 6][x] === 1 && (MaskUtil.isWhiteVertical(array, x, y - 4, y) || MaskUtil.isWhiteVertical(array, x, y + 7, y + 11))) numPenalties++;
        }
        return numPenalties * MaskUtil.N3;
    };
    MaskUtil.isWhiteHorizontal = function(rowArray, from /*int*/ , to /*int*/ ) {
        from = Math.max(from, 0);
        to = Math.min(to, rowArray.length);
        for(var i = from; i < to; i++){
            if (rowArray[i] === 1) return false;
        }
        return true;
    };
    MaskUtil.isWhiteVertical = function(array, col /*int*/ , from /*int*/ , to /*int*/ ) {
        from = Math.max(from, 0);
        to = Math.min(to, array.length);
        for(var i = from; i < to; i++){
            if (array[i][col] === 1) return false;
        }
        return true;
    };
    /**
     * Apply mask penalty rule 4 and return the penalty. Calculate the ratio of dark cells and give
     * penalty if the ratio is far from 50%. It gives 10 penalty for 5% distance.
     */ MaskUtil.applyMaskPenaltyRule4 = function(matrix) {
        var numDarkCells = 0;
        var array = matrix.getArray();
        var width = matrix.getWidth();
        var height = matrix.getHeight();
        for(var y = 0; y < height; y++){
            var arrayY = array[y];
            for(var x = 0; x < width; x++)if (arrayY[x] === 1) numDarkCells++;
        }
        var numTotalCells = matrix.getHeight() * matrix.getWidth();
        var fivePercentVariances = Math.floor(Math.abs(numDarkCells * 2 - numTotalCells) * 10 / numTotalCells);
        return fivePercentVariances * MaskUtil.N4;
    };
    /**
     * Return the mask bit for "getMaskPattern" at "x" and "y". See 8.8 of JISX0510:2004 for mask
     * pattern conditions.
     */ MaskUtil.getDataMaskBit = function(maskPattern /*int*/ , x /*int*/ , y /*int*/ ) {
        var intermediate; /*int*/ 
        var temp; /*int*/ 
        switch(maskPattern){
            case 0:
                intermediate = y + x & 0x1;
                break;
            case 1:
                intermediate = y & 0x1;
                break;
            case 2:
                intermediate = x % 3;
                break;
            case 3:
                intermediate = (y + x) % 3;
                break;
            case 4:
                intermediate = Math.floor(y / 2) + Math.floor(x / 3) & 0x1;
                break;
            case 5:
                temp = y * x;
                intermediate = (temp & 0x1) + temp % 3;
                break;
            case 6:
                temp = y * x;
                intermediate = (temp & 0x1) + temp % 3 & 0x1;
                break;
            case 7:
                temp = y * x;
                intermediate = temp % 3 + (y + x & 0x1) & 0x1;
                break;
            default:
                throw new (0, $kLpae.default)("Invalid mask pattern: " + maskPattern);
        }
        return intermediate === 0;
    };
    /**
     * Helper function for applyMaskPenaltyRule1. We need this for doing this calculation in both
     * vertical and horizontal orders respectively.
     */ MaskUtil.applyMaskPenaltyRule1Internal = function(matrix, isHorizontal) {
        var penalty = 0;
        var iLimit = isHorizontal ? matrix.getHeight() : matrix.getWidth();
        var jLimit = isHorizontal ? matrix.getWidth() : matrix.getHeight();
        var array = matrix.getArray();
        for(var i = 0; i < iLimit; i++){
            var numSameBitCells = 0;
            var prevBit = -1;
            for(var j = 0; j < jLimit; j++){
                var bit = isHorizontal ? array[i][j] : array[j][i];
                if (bit === prevBit) numSameBitCells++;
                else {
                    if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
                    numSameBitCells = 1; // Include the cell itself.
                    prevBit = bit;
                }
            }
            if (numSameBitCells >= 5) penalty += MaskUtil.N1 + (numSameBitCells - 5);
        }
        return penalty;
    };
    // Penalty weights from section 6.8.2.1
    MaskUtil.N1 = 3;
    MaskUtil.N2 = 3;
    MaskUtil.N3 = 40;
    MaskUtil.N4 = 10;
    return MaskUtil;
}();
var $cdb1da0c3ce6bbe8$export$2e2bcd8739ae039 = $cdb1da0c3ce6bbe8$var$MaskUtil;

});

parcelRegister("cvLRZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $91bd8337f4e0c05a$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $iYwLM = parcelRequire("iYwLM");

var $6E9N1 = parcelRequire("6E9N1");
var $91bd8337f4e0c05a$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * JAVAPORT: The original code was a 2D array of ints, but since it only ever gets assigned
 * -1, 0, and 1, I'm going to use less memory and go with bytes.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $91bd8337f4e0c05a$var$ByteMatrix = /** @class */ function() {
    function ByteMatrix(width /*int*/ , height /*int*/ ) {
        this.width = width;
        this.height = height;
        var bytes = new Array(height); // [height][width]
        for(var i = 0; i !== height; i++)bytes[i] = new Uint8Array(width);
        this.bytes = bytes;
    }
    ByteMatrix.prototype.getHeight = function() {
        return this.height;
    };
    ByteMatrix.prototype.getWidth = function() {
        return this.width;
    };
    ByteMatrix.prototype.get = function(x /*int*/ , y /*int*/ ) {
        return this.bytes[y][x];
    };
    /**
     * @return an internal representation as bytes, in row-major order. array[y][x] represents point (x,y)
     */ ByteMatrix.prototype.getArray = function() {
        return this.bytes;
    };
    // TYPESCRIPTPORT: preffer to let two methods instead of override to avoid type comparison inside
    ByteMatrix.prototype.setNumber = function(x /*int*/ , y /*int*/ , value /*byte|int*/ ) {
        this.bytes[y][x] = value;
    };
    // public set(x: number /*int*/, y: number /*int*/, value: number /*int*/): void {
    //   bytes[y][x] = (byte) value
    // }
    ByteMatrix.prototype.setBoolean = function(x /*int*/ , y /*int*/ , value) {
        this.bytes[y][x] = /*(byte) */ value ? 1 : 0;
    };
    ByteMatrix.prototype.clear = function(value /*byte*/ ) {
        var e_1, _a;
        try {
            for(var _b = $91bd8337f4e0c05a$var$__values(this.bytes), _c = _b.next(); !_c.done; _c = _b.next()){
                var aByte = _c.value;
                (0, $iYwLM.default).fill(aByte, value);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    ByteMatrix.prototype.equals = function(o) {
        if (!(o instanceof ByteMatrix)) return false;
        var other = o;
        if (this.width !== other.width) return false;
        if (this.height !== other.height) return false;
        for(var y = 0, height = this.height; y < height; ++y){
            var bytesY = this.bytes[y];
            var otherBytesY = other.bytes[y];
            for(var x = 0, width = this.width; x < width; ++x){
                if (bytesY[x] !== otherBytesY[x]) return false;
            }
        }
        return true;
    };
    /*@Override*/ ByteMatrix.prototype.toString = function() {
        var result = new (0, $6E9N1.default)(); // (2 * width * height + 2)
        for(var y = 0, height = this.height; y < height; ++y){
            var bytesY = this.bytes[y];
            for(var x = 0, width = this.width; x < width; ++x)switch(bytesY[x]){
                case 0:
                    result.append(" 0");
                    break;
                case 1:
                    result.append(" 1");
                    break;
                default:
                    result.append("  ");
                    break;
            }
            result.append("\n");
        }
        return result.toString();
    };
    return ByteMatrix;
}();
var $91bd8337f4e0c05a$export$2e2bcd8739ae039 = $91bd8337f4e0c05a$var$ByteMatrix;

});

parcelRegister("2Km2C", function(module, exports) {

$parcel$export(module.exports, "default", () => $2000f9912606dad5$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $6E9N1 = parcelRequire("6E9N1");
/**
 * @author satorux@google.com (Satoru Takabayashi) - creator
 * @author dswitkin@google.com (Daniel Switkin) - ported from C++
 */ var $2000f9912606dad5$var$QRCode = /** @class */ function() {
    function QRCode() {
        this.maskPattern = -1;
    }
    QRCode.prototype.getMode = function() {
        return this.mode;
    };
    QRCode.prototype.getECLevel = function() {
        return this.ecLevel;
    };
    QRCode.prototype.getVersion = function() {
        return this.version;
    };
    QRCode.prototype.getMaskPattern = function() {
        return this.maskPattern;
    };
    QRCode.prototype.getMatrix = function() {
        return this.matrix;
    };
    /*@Override*/ QRCode.prototype.toString = function() {
        var result = new (0, $6E9N1.default)(); // (200)
        result.append("<<\n");
        result.append(" mode: ");
        result.append(this.mode ? this.mode.toString() : "null");
        result.append("\n ecLevel: ");
        result.append(this.ecLevel ? this.ecLevel.toString() : "null");
        result.append("\n version: ");
        result.append(this.version ? this.version.toString() : "null");
        result.append("\n maskPattern: ");
        result.append(this.maskPattern.toString());
        if (this.matrix) {
            result.append("\n matrix:\n");
            result.append(this.matrix.toString());
        } else result.append("\n matrix: null\n");
        result.append(">>\n");
        return result.toString();
    };
    QRCode.prototype.setMode = function(value) {
        this.mode = value;
    };
    QRCode.prototype.setECLevel = function(value) {
        this.ecLevel = value;
    };
    QRCode.prototype.setVersion = function(version) {
        this.version = version;
    };
    QRCode.prototype.setMaskPattern = function(value /*int*/ ) {
        this.maskPattern = value;
    };
    QRCode.prototype.setMatrix = function(value) {
        this.matrix = value;
    };
    // Check if "mask_pattern" is valid.
    QRCode.isValidMaskPattern = function(maskPattern /*int*/ ) {
        return maskPattern >= 0 && maskPattern < QRCode.NUM_MASK_PATTERNS;
    };
    QRCode.NUM_MASK_PATTERNS = 8;
    return QRCode;
}();
var $2000f9912606dad5$export$2e2bcd8739ae039 = $2000f9912606dad5$var$QRCode;

});

parcelRegister("78He7", function(module, exports) {

$parcel$export(module.exports, "default", () => $532acfb29d7b8c46$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode.encoder {*/ 
var $fHKUB = parcelRequire("fHKUB");

var $hcAg4 = parcelRequire("hcAg4");

var $2Km2C = parcelRequire("2Km2C");

var $hEUjg = parcelRequire("hEUjg");

var $lq7FB = parcelRequire("lq7FB");

var $kLpae = parcelRequire("kLpae");
/**
 * @author satorux@google.com (Satoru Takabayashi) - creator
 * @author dswitkin@google.com (Daniel Switkin) - ported from C++
 */ var $532acfb29d7b8c46$var$MatrixUtil = /** @class */ function() {
    function MatrixUtil() {
    // do nothing
    }
    // Set all cells to -1 (TYPESCRIPTPORT: 255).  -1 (TYPESCRIPTPORT: 255) means that the cell is empty (not set yet).
    //
    // JAVAPORT: We shouldn't need to do this at all. The code should be rewritten to begin encoding
    // with the ByteMatrix initialized all to zero.
    MatrixUtil.clearMatrix = function(matrix) {
        // TYPESCRIPTPORT: we use UintArray se changed here from -1 to 255
        matrix.clear(/*(byte) */ /*-1*/ 255);
    };
    // Build 2D matrix of QR Code from "dataBits" with "ecLevel", "version" and "getMaskPattern". On
    // success, store the result in "matrix" and return true.
    MatrixUtil.buildMatrix = function(dataBits, ecLevel, version, maskPattern /*int*/ , matrix) {
        MatrixUtil.clearMatrix(matrix);
        MatrixUtil.embedBasicPatterns(version, matrix);
        // Type information appear with any version.
        MatrixUtil.embedTypeInfo(ecLevel, maskPattern, matrix);
        // Version info appear if version >= 7.
        MatrixUtil.maybeEmbedVersionInfo(version, matrix);
        // Data should be embedded at end.
        MatrixUtil.embedDataBits(dataBits, maskPattern, matrix);
    };
    // Embed basic patterns. On success, modify the matrix and return true.
    // The basic patterns are:
    // - Position detection patterns
    // - Timing patterns
    // - Dark dot at the left bottom corner
    // - Position adjustment patterns, if need be
    MatrixUtil.embedBasicPatterns = function(version, matrix) {
        // Let's get started with embedding big squares at corners.
        MatrixUtil.embedPositionDetectionPatternsAndSeparators(matrix);
        // Then, embed the dark dot at the left bottom corner.
        MatrixUtil.embedDarkDotAtLeftBottomCorner(matrix);
        // Position adjustment patterns appear if version >= 2.
        MatrixUtil.maybeEmbedPositionAdjustmentPatterns(version, matrix);
        // Timing patterns should be embedded after position adj. patterns.
        MatrixUtil.embedTimingPatterns(matrix);
    };
    // Embed type information. On success, modify the matrix.
    MatrixUtil.embedTypeInfo = function(ecLevel, maskPattern /*int*/ , matrix) {
        var typeInfoBits = new (0, $fHKUB.default)();
        MatrixUtil.makeTypeInfoBits(ecLevel, maskPattern, typeInfoBits);
        for(var i = 0, size = typeInfoBits.getSize(); i < size; ++i){
            // Place bits in LSB to MSB order.  LSB (least significant bit) is the last value in
            // "typeInfoBits".
            var bit = typeInfoBits.get(typeInfoBits.getSize() - 1 - i);
            // Type info bits at the left top corner. See 8.9 of JISX0510:2004 (p.46).
            var coordinates = MatrixUtil.TYPE_INFO_COORDINATES[i];
            var x1 = coordinates[0];
            var y1 = coordinates[1];
            matrix.setBoolean(x1, y1, bit);
            if (i < 8) {
                // Right top corner.
                var x2 = matrix.getWidth() - i - 1;
                var y2 = 8;
                matrix.setBoolean(x2, y2, bit);
            } else {
                // Left bottom corner.
                var x2 = 8;
                var y2 = matrix.getHeight() - 7 + (i - 8);
                matrix.setBoolean(x2, y2, bit);
            }
        }
    };
    // Embed version information if need be. On success, modify the matrix and return true.
    // See 8.10 of JISX0510:2004 (p.47) for how to embed version information.
    MatrixUtil.maybeEmbedVersionInfo = function(version, matrix) {
        if (version.getVersionNumber() < 7) return; // Don't need version info.
        var versionInfoBits = new (0, $fHKUB.default)();
        MatrixUtil.makeVersionInfoBits(version, versionInfoBits);
        var bitIndex = 17; // It will decrease from 17 to 0.
        for(var i = 0; i < 6; ++i)for(var j = 0; j < 3; ++j){
            // Place bits in LSB (least significant bit) to MSB order.
            var bit = versionInfoBits.get(bitIndex);
            bitIndex--;
            // Left bottom corner.
            matrix.setBoolean(i, matrix.getHeight() - 11 + j, bit);
            // Right bottom corner.
            matrix.setBoolean(matrix.getHeight() - 11 + j, i, bit);
        }
    };
    // Embed "dataBits" using "getMaskPattern". On success, modify the matrix and return true.
    // For debugging purposes, it skips masking process if "getMaskPattern" is -1(TYPESCRIPTPORT: 255).
    // See 8.7 of JISX0510:2004 (p.38) for how to embed data bits.
    MatrixUtil.embedDataBits = function(dataBits, maskPattern /*int*/ , matrix) {
        var bitIndex = 0;
        var direction = -1;
        // Start from the right bottom cell.
        var x = matrix.getWidth() - 1;
        var y = matrix.getHeight() - 1;
        while(x > 0){
            // Skip the vertical timing pattern.
            if (x === 6) x -= 1;
            while(y >= 0 && y < matrix.getHeight()){
                for(var i = 0; i < 2; ++i){
                    var xx = x - i;
                    // Skip the cell if it's not empty.
                    if (!MatrixUtil.isEmpty(matrix.get(xx, y))) continue;
                    var bit = void 0;
                    if (bitIndex < dataBits.getSize()) {
                        bit = dataBits.get(bitIndex);
                        ++bitIndex;
                    } else // Padding bit. If there is no bit left, we'll fill the left cells with 0, as described
                    // in 8.4.9 of JISX0510:2004 (p. 24).
                    bit = false;
                    // Skip masking if mask_pattern is -1 (TYPESCRIPTPORT: 255).
                    if (maskPattern !== 255 && (0, $hEUjg.default).getDataMaskBit(maskPattern, xx, y)) bit = !bit;
                    matrix.setBoolean(xx, y, bit);
                }
                y += direction;
            }
            direction = -direction; // Reverse the direction.
            y += direction;
            x -= 2; // Move to the left.
        }
        // All bits should be consumed.
        if (bitIndex !== dataBits.getSize()) throw new (0, $lq7FB.default)("Not all bits consumed: " + bitIndex + "/" + dataBits.getSize());
    };
    // Return the position of the most significant bit set (one: to) in the "value". The most
    // significant bit is position 32. If there is no bit set, return 0. Examples:
    // - findMSBSet(0) => 0
    // - findMSBSet(1) => 1
    // - findMSBSet(255) => 8
    MatrixUtil.findMSBSet = function(value /*int*/ ) {
        return 32 - (0, $hcAg4.default).numberOfLeadingZeros(value);
    };
    // Calculate BCH (Bose-Chaudhuri-Hocquenghem) code for "value" using polynomial "poly". The BCH
    // code is used for encoding type information and version information.
    // Example: Calculation of version information of 7.
    // f(x) is created from 7.
    //   - 7 = 000111 in 6 bits
    //   - f(x) = x^2 + x^1 + x^0
    // g(x) is given by the standard (p. 67)
    //   - g(x) = x^12 + x^11 + x^10 + x^9 + x^8 + x^5 + x^2 + 1
    // Multiply f(x) by x^(18 - 6)
    //   - f'(x) = f(x) * x^(18 - 6)
    //   - f'(x) = x^14 + x^13 + x^12
    // Calculate the remainder of f'(x) / g(x)
    //         x^2
    //         __________________________________________________
    //   g(x) )x^14 + x^13 + x^12
    //         x^14 + x^13 + x^12 + x^11 + x^10 + x^7 + x^4 + x^2
    //         --------------------------------------------------
    //                              x^11 + x^10 + x^7 + x^4 + x^2
    //
    // The remainder is x^11 + x^10 + x^7 + x^4 + x^2
    // Encode it in binary: 110010010100
    // The return value is 0xc94 (1100 1001 0100)
    //
    // Since all coefficients in the polynomials are 1 or 0, we can do the calculation by bit
    // operations. We don't care if coefficients are positive or negative.
    MatrixUtil.calculateBCHCode = function(value /*int*/ , poly /*int*/ ) {
        if (poly === 0) throw new (0, $kLpae.default)("0 polynomial");
        // If poly is "1 1111 0010 0101" (version info poly), msbSetInPoly is 13. We'll subtract 1
        // from 13 to make it 12.
        var msbSetInPoly = MatrixUtil.findMSBSet(poly);
        value <<= msbSetInPoly - 1;
        // Do the division business using exclusive-or operations.
        while(MatrixUtil.findMSBSet(value) >= msbSetInPoly)value ^= poly << MatrixUtil.findMSBSet(value) - msbSetInPoly;
        // Now the "value" is the remainder (i.e. the BCH code)
        return value;
    };
    // Make bit vector of type information. On success, store the result in "bits" and return true.
    // Encode error correction level and mask pattern. See 8.9 of
    // JISX0510:2004 (p.45) for details.
    MatrixUtil.makeTypeInfoBits = function(ecLevel, maskPattern /*int*/ , bits) {
        if (!(0, $2Km2C.default).isValidMaskPattern(maskPattern)) throw new (0, $lq7FB.default)("Invalid mask pattern");
        var typeInfo = ecLevel.getBits() << 3 | maskPattern;
        bits.appendBits(typeInfo, 5);
        var bchCode = MatrixUtil.calculateBCHCode(typeInfo, MatrixUtil.TYPE_INFO_POLY);
        bits.appendBits(bchCode, 10);
        var maskBits = new (0, $fHKUB.default)();
        maskBits.appendBits(MatrixUtil.TYPE_INFO_MASK_PATTERN, 15);
        bits.xor(maskBits);
        if (bits.getSize() !== 15) throw new (0, $lq7FB.default)("should not happen but we got: " + bits.getSize());
    };
    // Make bit vector of version information. On success, store the result in "bits" and return true.
    // See 8.10 of JISX0510:2004 (p.45) for details.
    MatrixUtil.makeVersionInfoBits = function(version, bits) {
        bits.appendBits(version.getVersionNumber(), 6);
        var bchCode = MatrixUtil.calculateBCHCode(version.getVersionNumber(), MatrixUtil.VERSION_INFO_POLY);
        bits.appendBits(bchCode, 12);
        if (bits.getSize() !== 18) throw new (0, $lq7FB.default)("should not happen but we got: " + bits.getSize());
    };
    // Check if "value" is empty.
    MatrixUtil.isEmpty = function(value /*int*/ ) {
        return value === 255; // -1
    };
    MatrixUtil.embedTimingPatterns = function(matrix) {
        // -8 is for skipping position detection patterns (7: size), and two horizontal/vertical
        // separation patterns (1: size). Thus, 8 = 7 + 1.
        for(var i = 8; i < matrix.getWidth() - 8; ++i){
            var bit = (i + 1) % 2;
            // Horizontal line.
            if (MatrixUtil.isEmpty(matrix.get(i, 6))) matrix.setNumber(i, 6, bit);
            // Vertical line.
            if (MatrixUtil.isEmpty(matrix.get(6, i))) matrix.setNumber(6, i, bit);
        }
    };
    // Embed the lonely dark dot at left bottom corner. JISX0510:2004 (p.46)
    MatrixUtil.embedDarkDotAtLeftBottomCorner = function(matrix) {
        if (matrix.get(8, matrix.getHeight() - 8) === 0) throw new (0, $lq7FB.default)();
        matrix.setNumber(8, matrix.getHeight() - 8, 1);
    };
    MatrixUtil.embedHorizontalSeparationPattern = function(xStart /*int*/ , yStart /*int*/ , matrix) {
        for(var x = 0; x < 8; ++x){
            if (!MatrixUtil.isEmpty(matrix.get(xStart + x, yStart))) throw new (0, $lq7FB.default)();
            matrix.setNumber(xStart + x, yStart, 0);
        }
    };
    MatrixUtil.embedVerticalSeparationPattern = function(xStart /*int*/ , yStart /*int*/ , matrix) {
        for(var y = 0; y < 7; ++y){
            if (!MatrixUtil.isEmpty(matrix.get(xStart, yStart + y))) throw new (0, $lq7FB.default)();
            matrix.setNumber(xStart, yStart + y, 0);
        }
    };
    MatrixUtil.embedPositionAdjustmentPattern = function(xStart /*int*/ , yStart /*int*/ , matrix) {
        for(var y = 0; y < 5; ++y){
            var patternY = MatrixUtil.POSITION_ADJUSTMENT_PATTERN[y];
            for(var x = 0; x < 5; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
        }
    };
    MatrixUtil.embedPositionDetectionPattern = function(xStart /*int*/ , yStart /*int*/ , matrix) {
        for(var y = 0; y < 7; ++y){
            var patternY = MatrixUtil.POSITION_DETECTION_PATTERN[y];
            for(var x = 0; x < 7; ++x)matrix.setNumber(xStart + x, yStart + y, patternY[x]);
        }
    };
    // Embed position detection patterns and surrounding vertical/horizontal separators.
    MatrixUtil.embedPositionDetectionPatternsAndSeparators = function(matrix) {
        // Embed three big squares at corners.
        var pdpWidth = MatrixUtil.POSITION_DETECTION_PATTERN[0].length;
        // Left top corner.
        MatrixUtil.embedPositionDetectionPattern(0, 0, matrix);
        // Right top corner.
        MatrixUtil.embedPositionDetectionPattern(matrix.getWidth() - pdpWidth, 0, matrix);
        // Left bottom corner.
        MatrixUtil.embedPositionDetectionPattern(0, matrix.getWidth() - pdpWidth, matrix);
        // Embed horizontal separation patterns around the squares.
        var hspWidth = 8;
        // Left top corner.
        MatrixUtil.embedHorizontalSeparationPattern(0, hspWidth - 1, matrix);
        // Right top corner.
        MatrixUtil.embedHorizontalSeparationPattern(matrix.getWidth() - hspWidth, hspWidth - 1, matrix);
        // Left bottom corner.
        MatrixUtil.embedHorizontalSeparationPattern(0, matrix.getWidth() - hspWidth, matrix);
        // Embed vertical separation patterns around the squares.
        var vspSize = 7;
        // Left top corner.
        MatrixUtil.embedVerticalSeparationPattern(vspSize, 0, matrix);
        // Right top corner.
        MatrixUtil.embedVerticalSeparationPattern(matrix.getHeight() - vspSize - 1, 0, matrix);
        // Left bottom corner.
        MatrixUtil.embedVerticalSeparationPattern(vspSize, matrix.getHeight() - vspSize, matrix);
    };
    // Embed position adjustment patterns if need be.
    MatrixUtil.maybeEmbedPositionAdjustmentPatterns = function(version, matrix) {
        if (version.getVersionNumber() < 2) return;
        var index = version.getVersionNumber() - 1;
        var coordinates = MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE[index];
        for(var i = 0, length_1 = coordinates.length; i !== length_1; i++){
            var y = coordinates[i];
            if (y >= 0) for(var j = 0; j !== length_1; j++){
                var x = coordinates[j];
                if (x >= 0 && MatrixUtil.isEmpty(matrix.get(x, y))) // If the cell is unset, we embed the position adjustment pattern here.
                // -2 is necessary since the x/y coordinates point to the center of the pattern, not the
                // left top corner.
                MatrixUtil.embedPositionAdjustmentPattern(x - 2, y - 2, matrix);
            }
        }
    };
    MatrixUtil.POSITION_DETECTION_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            1,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN = Array.from([
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            1,
            0,
            1
        ]),
        Int32Array.from([
            1,
            0,
            0,
            0,
            1
        ]),
        Int32Array.from([
            1,
            1,
            1,
            1,
            1
        ])
    ]);
    // From Appendix E. Table 1, JIS0510X:2004 (71: p). The table was double-checked by komatsu.
    MatrixUtil.POSITION_ADJUSTMENT_PATTERN_COORDINATE_TABLE = Array.from([
        Int32Array.from([
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            18,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            -1,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            22,
            38,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            24,
            42,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            -1,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            46,
            66,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            48,
            70,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            -1,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            50,
            72,
            94,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            -1,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            50,
            74,
            98,
            122,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            -1
        ]),
        Int32Array.from([
            6,
            26,
            52,
            78,
            104,
            130,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            56,
            82,
            108,
            134,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            60,
            86,
            112,
            138,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            -1
        ]),
        Int32Array.from([
            6,
            34,
            62,
            90,
            118,
            146,
            -1
        ]),
        Int32Array.from([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        Int32Array.from([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        Int32Array.from([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        Int32Array.from([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        Int32Array.from([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        Int32Array.from([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]);
    // Type info cells at the left top corner.
    MatrixUtil.TYPE_INFO_COORDINATES = Array.from([
        Int32Array.from([
            8,
            0
        ]),
        Int32Array.from([
            8,
            1
        ]),
        Int32Array.from([
            8,
            2
        ]),
        Int32Array.from([
            8,
            3
        ]),
        Int32Array.from([
            8,
            4
        ]),
        Int32Array.from([
            8,
            5
        ]),
        Int32Array.from([
            8,
            7
        ]),
        Int32Array.from([
            8,
            8
        ]),
        Int32Array.from([
            7,
            8
        ]),
        Int32Array.from([
            5,
            8
        ]),
        Int32Array.from([
            4,
            8
        ]),
        Int32Array.from([
            3,
            8
        ]),
        Int32Array.from([
            2,
            8
        ]),
        Int32Array.from([
            1,
            8
        ]),
        Int32Array.from([
            0,
            8
        ])
    ]);
    // From Appendix D in JISX0510:2004 (p. 67)
    MatrixUtil.VERSION_INFO_POLY = 0x1f25; // 1 1111 0010 0101
    // From Appendix C in JISX0510:2004 (p.65).
    MatrixUtil.TYPE_INFO_POLY = 0x537;
    MatrixUtil.TYPE_INFO_MASK_PATTERN = 0x5412;
    return MatrixUtil;
}();
var $532acfb29d7b8c46$export$2e2bcd8739ae039 = $532acfb29d7b8c46$var$MatrixUtil;

});
parcelRegister("lq7FB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f981f9c9228d8614$export$2e2bcd8739ae039);

var $26SD6 = parcelRequire("26SD6");
var $f981f9c9228d8614$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Custom Error class of type Exception.
 */ var $f981f9c9228d8614$var$WriterException = /** @class */ function(_super) {
    $f981f9c9228d8614$var$__extends(WriterException, _super);
    function WriterException() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WriterException.kind = "WriterException";
    return WriterException;
}((0, $26SD6.default));
var $f981f9c9228d8614$export$2e2bcd8739ae039 = $f981f9c9228d8614$var$WriterException;

});


parcelRegister("8Pp3N", function(module, exports) {

$parcel$export(module.exports, "default", () => $01a89f12e951998c$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode.encoder {*/ var $01a89f12e951998c$var$BlockPair = /** @class */ function() {
    function BlockPair(dataBytes, errorCorrectionBytes) {
        this.dataBytes = dataBytes;
        this.errorCorrectionBytes = errorCorrectionBytes;
    }
    BlockPair.prototype.getDataBytes = function() {
        return this.dataBytes;
    };
    BlockPair.prototype.getErrorCorrectionBytes = function() {
        return this.errorCorrectionBytes;
    };
    return BlockPair;
}();
var $01a89f12e951998c$export$2e2bcd8739ae039 = $01a89f12e951998c$var$BlockPair;

});



parcelRegister("2E0E3", function(module, exports) {

});

parcelRegister("AP5Sk", function(module, exports) {

});


parcelRegister("j3BF2", function(module, exports) {
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // import DataMatrixWriter from './datamatrix/DataMatrixWriter'
// import CodaBarWriter from './oned/CodaBarWriter'
// import Code128Writer from './oned/Code128Writer'
// import Code39Writer from './oned/Code39Writer'
// import Code93Writer from './oned/Code93Writer'
// import EAN13Writer from './oned/EAN13Writer'
// import EAN8Writer from './oned/EAN8Writer'
// import ITFWriter from './oned/ITFWriter'
// import UPCAWriter from './oned/UPCAWriter'
// import UPCEWriter from './oned/UPCEWriter'
// import PDF417Writer from './pdf417/PDF417Writer'

var $3dVi1 = parcelRequire("3dVi1");

var $bx5V3 = parcelRequire("bx5V3");

var $kLpae = parcelRequire("kLpae");
/*import java.util.Map;*/ /**
 * This is a factory class which finds the appropriate Writer subclass for the BarcodeFormat
 * requested and encodes the barcode with the supplied contents.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $ddfb82d02d3adaa6$var$MultiFormatWriter = /** @class */ function() {
    function MultiFormatWriter() {}
    /*@Override*/ // public encode(contents: string,
    //                         format: BarcodeFormat,
    //                         width: number /*int*/,
    //                         height: number /*int*/): BitMatrix /*throws WriterException */ {
    //   return encode(contents, format, width, height, null)
    // }
    /*@Override*/ MultiFormatWriter.prototype.encode = function(contents, format, width /*int*/ , height /*int*/ , hints) {
        var writer;
        switch(format){
            // case BarcodeFormat.EAN_8:
            //   writer = new EAN8Writer()
            //   break
            // case BarcodeFormat.UPC_E:
            //   writer = new UPCEWriter()
            //   break
            // case BarcodeFormat.EAN_13:
            //   writer = new EAN13Writer()
            //   break
            // case BarcodeFormat.UPC_A:
            //   writer = new UPCAWriter()
            //   break
            case (0, $bx5V3.default).QR_CODE:
                writer = new (0, $3dVi1.default)();
                break;
            // case BarcodeFormat.CODE_39:
            //   writer = new Code39Writer()
            //   break
            // case BarcodeFormat.CODE_93:
            //   writer = new Code93Writer()
            //   break
            // case BarcodeFormat.CODE_128:
            //   writer = new Code128Writer()
            //   break
            // case BarcodeFormat.ITF:
            //   writer = new ITFWriter()
            //   break
            // case BarcodeFormat.PDF_417:
            //   writer = new PDF417Writer()
            //   break
            // case BarcodeFormat.CODABAR:
            //   writer = new CodaBarWriter()
            //   break
            // case BarcodeFormat.DATA_MATRIX:
            //   writer = new DataMatrixWriter()
            //   break
            // case BarcodeFormat.AZTEC:
            //   writer = new AztecWriter()
            //   break
            default:
                throw new (0, $kLpae.default)("No encoder available for format " + format);
        }
        return writer.encode(contents, format, width, height, hints);
    };
    return MultiFormatWriter;
}();
var $ddfb82d02d3adaa6$export$2e2bcd8739ae039 = $ddfb82d02d3adaa6$var$MultiFormatWriter;

});
parcelRegister("3dVi1", function(module, exports) {

$parcel$export(module.exports, "default", () => $258f068c1aa756eb$export$2e2bcd8739ae039);
/*
 * Copyright 2008 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*namespace com.google.zxing.qrcode {*/ 
var $bx5V3 = parcelRequire("bx5V3");

var $1NSRh = parcelRequire("1NSRh");

var $hzqel = parcelRequire("hzqel");

var $aH6oJ = parcelRequire("aH6oJ");

var $6YEpc = parcelRequire("6YEpc");

var $kLpae = parcelRequire("kLpae");

var $amwnq = parcelRequire("amwnq");
/*import java.util.Map;*/ /**
 * This object renders a QR Code as a BitMatrix 2D array of greyscale values.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $258f068c1aa756eb$var$QRCodeWriter = /** @class */ function() {
    function QRCodeWriter() {}
    /*@Override*/ // public encode(contents: string, format: BarcodeFormat, width: number /*int*/, height: number /*int*/): BitMatrix
    //     /*throws WriterException */ {
    //   return encode(contents, format, width, height, null)
    // }
    /*@Override*/ QRCodeWriter.prototype.encode = function(contents, format, width /*int*/ , height /*int*/ , hints) {
        if (contents.length === 0) throw new (0, $kLpae.default)("Found empty contents");
        if (format !== (0, $bx5V3.default).QR_CODE) throw new (0, $kLpae.default)("Can only encode QR_CODE, but got " + format);
        if (width < 0 || height < 0) throw new (0, $kLpae.default)("Requested dimensions are too small: " + width + "x" + height);
        var errorCorrectionLevel = (0, $aH6oJ.default).L;
        var quietZone = QRCodeWriter.QUIET_ZONE_SIZE;
        if (hints !== null) {
            if (undefined !== hints.get((0, $1NSRh.default).ERROR_CORRECTION)) errorCorrectionLevel = (0, $aH6oJ.default).fromString(hints.get((0, $1NSRh.default).ERROR_CORRECTION).toString());
            if (undefined !== hints.get((0, $1NSRh.default).MARGIN)) quietZone = Number.parseInt(hints.get((0, $1NSRh.default).MARGIN).toString(), 10);
        }
        var code = (0, $6YEpc.default).encode(contents, errorCorrectionLevel, hints);
        return QRCodeWriter.renderResult(code, width, height, quietZone);
    };
    // Note that the input matrix uses 0 == white, 1 == black, while the output matrix uses
    // 0 == black, 255 == white (i.e. an 8 bit greyscale bitmap).
    QRCodeWriter.renderResult = function(code, width /*int*/ , height /*int*/ , quietZone /*int*/ ) {
        var input = code.getMatrix();
        if (input === null) throw new (0, $amwnq.default)();
        var inputWidth = input.getWidth();
        var inputHeight = input.getHeight();
        var qrWidth = inputWidth + quietZone * 2;
        var qrHeight = inputHeight + quietZone * 2;
        var outputWidth = Math.max(width, qrWidth);
        var outputHeight = Math.max(height, qrHeight);
        var multiple = Math.min(Math.floor(outputWidth / qrWidth), Math.floor(outputHeight / qrHeight));
        // Padding includes both the quiet zone and the extra white pixels to accommodate the requested
        // dimensions. For example, if input is 25x25 the QR will be 33x33 including the quiet zone.
        // If the requested size is 200x160, the multiple will be 4, for a QR of 132x132. These will
        // handle all the padding from 100x100 (the actual QR) up to 200x160.
        var leftPadding = Math.floor((outputWidth - inputWidth * multiple) / 2);
        var topPadding = Math.floor((outputHeight - inputHeight * multiple) / 2);
        var output = new (0, $hzqel.default)(outputWidth, outputHeight);
        for(var inputY = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
            // Write the contents of this row of the barcode
            for(var inputX = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY) === 1) output.setRegion(outputX, outputY, multiple, multiple);
        }
        return output;
    };
    QRCodeWriter.QUIET_ZONE_SIZE = 4;
    return QRCodeWriter;
}();
var $258f068c1aa756eb$export$2e2bcd8739ae039 = $258f068c1aa756eb$var$QRCodeWriter;

});


parcelRegister("aSnmH", function(module, exports) {
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $b6IL4 = parcelRequire("b6IL4");

var $bvYQM = parcelRequire("bvYQM");

var $bBVLs = parcelRequire("bBVLs");

var $kLpae = parcelRequire("kLpae");
var $7eb11256743454b0$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This object extends LuminanceSource around an array of YUV data returned from the camera driver,
 * with the option to crop to a rectangle within the full data. This can be used to exclude
 * superfluous pixels around the perimeter and speed up decoding.
 *
 * It works for any pixel format where the Y channel is planar and appears first, including
 * YCbCr_420_SP and YCbCr_422_SP.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 */ var $7eb11256743454b0$var$PlanarYUVLuminanceSource = /** @class */ function(_super) {
    $7eb11256743454b0$var$__extends(PlanarYUVLuminanceSource, _super);
    function PlanarYUVLuminanceSource(yuvData, dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ , reverseHorizontal) {
        var _this = _super.call(this, width, height) || this;
        _this.yuvData = yuvData;
        _this.dataWidth = dataWidth;
        _this.dataHeight = dataHeight;
        _this.left = left;
        _this.top = top;
        if (left + width > dataWidth || top + height > dataHeight) throw new (0, $kLpae.default)("Crop rectangle does not fit within image data.");
        if (reverseHorizontal) _this.reverseHorizontal(width, height);
        return _this;
    }
    /*@Override*/ PlanarYUVLuminanceSource.prototype.getRow = function(y /*int*/ , row) {
        if (y < 0 || y >= this.getHeight()) throw new (0, $kLpae.default)("Requested row is outside the image: " + y);
        var width = this.getWidth();
        if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
        var offset = (y + this.top) * this.dataWidth + this.left;
        (0, $b6IL4.default).arraycopy(this.yuvData, offset, row, 0, width);
        return row;
    };
    /*@Override*/ PlanarYUVLuminanceSource.prototype.getMatrix = function() {
        var width = this.getWidth();
        var height = this.getHeight();
        // If the caller asks for the entire underlying image, save the copy and give them the
        // original data. The docs specifically warn that result.length must be ignored.
        if (width === this.dataWidth && height === this.dataHeight) return this.yuvData;
        var area = width * height;
        var matrix = new Uint8ClampedArray(area);
        var inputOffset = this.top * this.dataWidth + this.left;
        // If the width matches the full width of the underlying data, perform a single copy.
        if (width === this.dataWidth) {
            (0, $b6IL4.default).arraycopy(this.yuvData, inputOffset, matrix, 0, area);
            return matrix;
        }
        // Otherwise copy one cropped row at a time.
        for(var y = 0; y < height; y++){
            var outputOffset = y * width;
            (0, $b6IL4.default).arraycopy(this.yuvData, inputOffset, matrix, outputOffset, width);
            inputOffset += this.dataWidth;
        }
        return matrix;
    };
    /*@Override*/ PlanarYUVLuminanceSource.prototype.isCropSupported = function() {
        return true;
    };
    /*@Override*/ PlanarYUVLuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        return new PlanarYUVLuminanceSource(this.yuvData, this.dataWidth, this.dataHeight, this.left + left, this.top + top, width, height, false);
    };
    PlanarYUVLuminanceSource.prototype.renderThumbnail = function() {
        var width = this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        var height = this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        var pixels = new Int32Array(width * height);
        var yuv = this.yuvData;
        var inputOffset = this.top * this.dataWidth + this.left;
        for(var y = 0; y < height; y++){
            var outputOffset = y * width;
            for(var x = 0; x < width; x++){
                var grey = yuv[inputOffset + x * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR] & 0xff;
                pixels[outputOffset + x] = 0xFF000000 | grey * 0x00010101;
            }
            inputOffset += this.dataWidth * PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
        }
        return pixels;
    };
    /**
     * @return width of image from {@link #renderThumbnail()}
     */ PlanarYUVLuminanceSource.prototype.getThumbnailWidth = function() {
        return this.getWidth() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
    };
    /**
     * @return height of image from {@link #renderThumbnail()}
     */ PlanarYUVLuminanceSource.prototype.getThumbnailHeight = function() {
        return this.getHeight() / PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR;
    };
    PlanarYUVLuminanceSource.prototype.reverseHorizontal = function(width /*int*/ , height /*int*/ ) {
        var yuvData = this.yuvData;
        for(var y = 0, rowStart = this.top * this.dataWidth + this.left; y < height; y++, rowStart += this.dataWidth){
            var middle = rowStart + width / 2;
            for(var x1 = rowStart, x2 = rowStart + width - 1; x1 < middle; x1++, x2--){
                var temp = yuvData[x1];
                yuvData[x1] = yuvData[x2];
                yuvData[x2] = temp;
            }
        }
    };
    PlanarYUVLuminanceSource.prototype.invert = function() {
        return new (0, $bBVLs.default)(this);
    };
    PlanarYUVLuminanceSource.THUMBNAIL_SCALE_FACTOR = 2;
    return PlanarYUVLuminanceSource;
}((0, $bvYQM.default));
var $7eb11256743454b0$export$2e2bcd8739ae039 = $7eb11256743454b0$var$PlanarYUVLuminanceSource;

});

parcelRegister("5rZ9k", function(module, exports) {
/*
 * Copyright 2009 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bBVLs = parcelRequire("bBVLs");

var $bvYQM = parcelRequire("bvYQM");

var $b6IL4 = parcelRequire("b6IL4");

var $kLpae = parcelRequire("kLpae");
var $3f7ee8668e4448a4$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * This class is used to help decode images from files which arrive as RGB data from
 * an ARGB pixel array. It does not support rotation.
 *
 * @author dswitkin@google.com (Daniel Switkin)
 * @author Betaminos
 */ var $3f7ee8668e4448a4$var$RGBLuminanceSource = /** @class */ function(_super) {
    $3f7ee8668e4448a4$var$__extends(RGBLuminanceSource, _super);
    function RGBLuminanceSource(luminances, width /*int*/ , height /*int*/ , dataWidth /*int*/ , dataHeight /*int*/ , left /*int*/ , top /*int*/ ) {
        var _this = _super.call(this, width, height) || this;
        _this.dataWidth = dataWidth;
        _this.dataHeight = dataHeight;
        _this.left = left;
        _this.top = top;
        if (luminances.BYTES_PER_ELEMENT === 4) {
            var size = width * height;
            var luminancesUint8Array = new Uint8ClampedArray(size);
            for(var offset = 0; offset < size; offset++){
                var pixel = luminances[offset];
                var r = pixel >> 16 & 0xff; // red
                var g2 = pixel >> 7 & 0x1fe; // 2 * green
                var b = pixel & 0xff; // blue
                // Calculate green-favouring average cheaply
                luminancesUint8Array[offset] = (r + g2 + b) / 4 & 0xFF;
            }
            _this.luminances = luminancesUint8Array;
        } else _this.luminances = luminances;
        if (undefined === dataWidth) _this.dataWidth = width;
        if (undefined === dataHeight) _this.dataHeight = height;
        if (undefined === left) _this.left = 0;
        if (undefined === top) _this.top = 0;
        if (_this.left + width > _this.dataWidth || _this.top + height > _this.dataHeight) throw new (0, $kLpae.default)("Crop rectangle does not fit within image data.");
        return _this;
    }
    /*@Override*/ RGBLuminanceSource.prototype.getRow = function(y /*int*/ , row) {
        if (y < 0 || y >= this.getHeight()) throw new (0, $kLpae.default)("Requested row is outside the image: " + y);
        var width = this.getWidth();
        if (row === null || row === undefined || row.length < width) row = new Uint8ClampedArray(width);
        var offset = (y + this.top) * this.dataWidth + this.left;
        (0, $b6IL4.default).arraycopy(this.luminances, offset, row, 0, width);
        return row;
    };
    /*@Override*/ RGBLuminanceSource.prototype.getMatrix = function() {
        var width = this.getWidth();
        var height = this.getHeight();
        // If the caller asks for the entire underlying image, save the copy and give them the
        // original data. The docs specifically warn that result.length must be ignored.
        if (width === this.dataWidth && height === this.dataHeight) return this.luminances;
        var area = width * height;
        var matrix = new Uint8ClampedArray(area);
        var inputOffset = this.top * this.dataWidth + this.left;
        // If the width matches the full width of the underlying data, perform a single copy.
        if (width === this.dataWidth) {
            (0, $b6IL4.default).arraycopy(this.luminances, inputOffset, matrix, 0, area);
            return matrix;
        }
        // Otherwise copy one cropped row at a time.
        for(var y = 0; y < height; y++){
            var outputOffset = y * width;
            (0, $b6IL4.default).arraycopy(this.luminances, inputOffset, matrix, outputOffset, width);
            inputOffset += this.dataWidth;
        }
        return matrix;
    };
    /*@Override*/ RGBLuminanceSource.prototype.isCropSupported = function() {
        return true;
    };
    /*@Override*/ RGBLuminanceSource.prototype.crop = function(left /*int*/ , top /*int*/ , width /*int*/ , height /*int*/ ) {
        return new RGBLuminanceSource(this.luminances, width, height, this.dataWidth, this.dataHeight, this.left + left, this.top + top);
    };
    RGBLuminanceSource.prototype.invert = function() {
        return new (0, $bBVLs.default)(this);
    };
    return RGBLuminanceSource;
}((0, $bvYQM.default));
var $3f7ee8668e4448a4$export$2e2bcd8739ae039 = $3f7ee8668e4448a4$var$RGBLuminanceSource;

});

parcelRegister("h9FI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7d3a1bc64808d5d$export$2e2bcd8739ae039);

var $l8eP1 = parcelRequire("l8eP1");
var $c7d3a1bc64808d5d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Just to make a shortcut between Java code and TS code.
 */ var $c7d3a1bc64808d5d$var$Charset = /** @class */ function(_super) {
    $c7d3a1bc64808d5d$var$__extends(Charset, _super);
    function Charset() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Charset.forName = function(name) {
        return this.getCharacterSetECIByName(name);
    };
    return Charset;
}((0, $l8eP1.default));
var $c7d3a1bc64808d5d$export$2e2bcd8739ae039 = $c7d3a1bc64808d5d$var$Charset;

});

parcelRegister("7QoZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b60c5ab61c1e8a9$export$2e2bcd8739ae039);

var $l8eP1 = parcelRequire("l8eP1");
/**
 * Just to make a shortcut between Java code and TS code.
 */ var $5b60c5ab61c1e8a9$var$StandardCharsets = /** @class */ function() {
    function StandardCharsets() {}
    StandardCharsets.ISO_8859_1 = (0, $l8eP1.default).ISO8859_1;
    return StandardCharsets;
}();
var $5b60c5ab61c1e8a9$export$2e2bcd8739ae039 = $5b60c5ab61c1e8a9$var$StandardCharsets;

});

parcelRegister("gTiVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4c075d99dfe8e6b$export$2e2bcd8739ae039);

var $iYwLM = parcelRequire("iYwLM");
/**
 * Symbol Character Placement Program. Adapted from Annex M.1 in ISO/IEC 16022:2000(E).
 */ var $c4c075d99dfe8e6b$var$DefaultPlacement = /** @class */ function() {
    /**
     * Main constructor
     *
     * @param codewords the codewords to place
     * @param numcols   the number of columns
     * @param numrows   the number of rows
     */ function DefaultPlacement(codewords, numcols, numrows) {
        this.codewords = codewords;
        this.numcols = numcols;
        this.numrows = numrows;
        this.bits = new Uint8Array(numcols * numrows);
        (0, $iYwLM.default).fill(this.bits, 2); // Initialize with "not set" value
    }
    DefaultPlacement.prototype.getNumrows = function() {
        return this.numrows;
    };
    DefaultPlacement.prototype.getNumcols = function() {
        return this.numcols;
    };
    DefaultPlacement.prototype.getBits = function() {
        return this.bits;
    };
    DefaultPlacement.prototype.getBit = function(col, row) {
        return this.bits[row * this.numcols + col] === 1;
    };
    DefaultPlacement.prototype.setBit = function(col, row, bit) {
        this.bits[row * this.numcols + col] = bit ? 1 : 0;
    };
    DefaultPlacement.prototype.noBit = function(col, row) {
        return this.bits[row * this.numcols + col] === 2;
    };
    DefaultPlacement.prototype.place = function() {
        var pos = 0;
        var row = 4;
        var col = 0;
        do {
            // repeatedly first check for one of the special corner cases, then...
            if (row === this.numrows && col === 0) this.corner1(pos++);
            if (row === this.numrows - 2 && col === 0 && this.numcols % 4 !== 0) this.corner2(pos++);
            if (row === this.numrows - 2 && col === 0 && this.numcols % 8 === 4) this.corner3(pos++);
            if (row === this.numrows + 4 && col === 2 && this.numcols % 8 === 0) this.corner4(pos++);
            // sweep upward diagonally, inserting successive characters...
            do {
                if (row < this.numrows && col >= 0 && this.noBit(col, row)) this.utah(row, col, pos++);
                row -= 2;
                col += 2;
            }while (row >= 0 && col < this.numcols);
            row++;
            col += 3;
            // and then sweep downward diagonally, inserting successive characters, ...
            do {
                if (row >= 0 && col < this.numcols && this.noBit(col, row)) this.utah(row, col, pos++);
                row += 2;
                col -= 2;
            }while (row < this.numrows && col >= 0);
            row += 3;
            col++;
        // ...until the entire array is scanned
        }while (row < this.numrows || col < this.numcols);
        // Lastly, if the lower right-hand corner is untouched, fill in fixed pattern
        if (this.noBit(this.numcols - 1, this.numrows - 1)) {
            this.setBit(this.numcols - 1, this.numrows - 1, true);
            this.setBit(this.numcols - 2, this.numrows - 2, true);
        }
    };
    DefaultPlacement.prototype.module = function(row, col, pos, bit) {
        if (row < 0) {
            row += this.numrows;
            col += 4 - (this.numrows + 4) % 8;
        }
        if (col < 0) {
            col += this.numcols;
            row += 4 - (this.numcols + 4) % 8;
        }
        // Note the conversion:
        var v = this.codewords.charCodeAt(pos);
        v &= 1 << 8 - bit;
        this.setBit(col, row, v !== 0);
    };
    /**
     * Places the 8 bits of a utah-shaped symbol character in ECC200.
     *
     * @param row the row
     * @param col the column
     * @param pos character position
     */ DefaultPlacement.prototype.utah = function(row, col, pos) {
        this.module(row - 2, col - 2, pos, 1);
        this.module(row - 2, col - 1, pos, 2);
        this.module(row - 1, col - 2, pos, 3);
        this.module(row - 1, col - 1, pos, 4);
        this.module(row - 1, col, pos, 5);
        this.module(row, col - 2, pos, 6);
        this.module(row, col - 1, pos, 7);
        this.module(row, col, pos, 8);
    };
    DefaultPlacement.prototype.corner1 = function(pos) {
        this.module(this.numrows - 1, 0, pos, 1);
        this.module(this.numrows - 1, 1, pos, 2);
        this.module(this.numrows - 1, 2, pos, 3);
        this.module(0, this.numcols - 2, pos, 4);
        this.module(0, this.numcols - 1, pos, 5);
        this.module(1, this.numcols - 1, pos, 6);
        this.module(2, this.numcols - 1, pos, 7);
        this.module(3, this.numcols - 1, pos, 8);
    };
    DefaultPlacement.prototype.corner2 = function(pos) {
        this.module(this.numrows - 3, 0, pos, 1);
        this.module(this.numrows - 2, 0, pos, 2);
        this.module(this.numrows - 1, 0, pos, 3);
        this.module(0, this.numcols - 4, pos, 4);
        this.module(0, this.numcols - 3, pos, 5);
        this.module(0, this.numcols - 2, pos, 6);
        this.module(0, this.numcols - 1, pos, 7);
        this.module(1, this.numcols - 1, pos, 8);
    };
    DefaultPlacement.prototype.corner3 = function(pos) {
        this.module(this.numrows - 3, 0, pos, 1);
        this.module(this.numrows - 2, 0, pos, 2);
        this.module(this.numrows - 1, 0, pos, 3);
        this.module(0, this.numcols - 2, pos, 4);
        this.module(0, this.numcols - 1, pos, 5);
        this.module(1, this.numcols - 1, pos, 6);
        this.module(2, this.numcols - 1, pos, 7);
        this.module(3, this.numcols - 1, pos, 8);
    };
    DefaultPlacement.prototype.corner4 = function(pos) {
        this.module(this.numrows - 1, 0, pos, 1);
        this.module(this.numrows - 1, this.numcols - 1, pos, 2);
        this.module(0, this.numcols - 3, pos, 3);
        this.module(0, this.numcols - 2, pos, 4);
        this.module(0, this.numcols - 1, pos, 5);
        this.module(1, this.numcols - 3, pos, 6);
        this.module(1, this.numcols - 2, pos, 7);
        this.module(1, this.numcols - 1, pos, 8);
    };
    return DefaultPlacement;
}();
var $c4c075d99dfe8e6b$export$2e2bcd8739ae039 = $c4c075d99dfe8e6b$var$DefaultPlacement;

});

parcelRegister("eQbu2", function(module, exports) {

$parcel$export(module.exports, "default", () => $acded46b6060ebc0$export$2e2bcd8739ae039);

var $6E9N1 = parcelRequire("6E9N1");

var $1SukY = parcelRequire("1SukY");
/**
 * Error Correction Code for ECC200.
 */ var $acded46b6060ebc0$var$ErrorCorrection = /** @class */ function() {
    function ErrorCorrection() {}
    /**
     * Creates the ECC200 error correction for an encoded message.
     *
     * @param codewords  the codewords
     * @param symbolInfo information about the symbol to be encoded
     * @return the codewords with interleaved error correction.
     */ ErrorCorrection.encodeECC200 = function(codewords, symbolInfo) {
        if (codewords.length !== symbolInfo.getDataCapacity()) throw new Error("The number of codewords does not match the selected symbol");
        var sb = new (0, $6E9N1.default)();
        sb.append(codewords);
        var blockCount = symbolInfo.getInterleavedBlockCount();
        if (blockCount === 1) {
            var ecc = this.createECCBlock(codewords, symbolInfo.getErrorCodewords());
            sb.append(ecc);
        } else {
            // sb.setLength(sb.capacity());
            var dataSizes = [];
            var errorSizes = [];
            for(var i = 0; i < blockCount; i++){
                dataSizes[i] = symbolInfo.getDataLengthForInterleavedBlock(i + 1);
                errorSizes[i] = symbolInfo.getErrorLengthForInterleavedBlock(i + 1);
            }
            for(var block = 0; block < blockCount; block++){
                var temp = new (0, $6E9N1.default)();
                for(var d = block; d < symbolInfo.getDataCapacity(); d += blockCount)temp.append(codewords.charAt(d));
                var ecc = this.createECCBlock(temp.toString(), errorSizes[block]);
                var pos = 0;
                for(var e = block; e < errorSizes[block] * blockCount; e += blockCount)sb.setCharAt(symbolInfo.getDataCapacity() + e, ecc.charAt(pos++));
            }
        }
        return sb.toString();
    };
    ErrorCorrection.createECCBlock = function(codewords, numECWords) {
        var table = -1;
        for(var i = 0; i < (0, $1SukY.FACTOR_SETS).length; i++)if ((0, $1SukY.FACTOR_SETS)[i] === numECWords) {
            table = i;
            break;
        }
        if (table < 0) throw new Error("Illegal number of error correction codewords specified: " + numECWords);
        var poly = (0, $1SukY.FACTORS)[table];
        var ecc = [];
        for(var i = 0; i < numECWords; i++)ecc[i] = 0;
        for(var i = 0; i < codewords.length; i++){
            var m = ecc[numECWords - 1] ^ codewords.charAt(i).charCodeAt(0);
            for(var k = numECWords - 1; k > 0; k--)if (m !== 0 && poly[k] !== 0) ecc[k] = ecc[k - 1] ^ (0, $1SukY.ALOG)[((0, $1SukY.LOG)[m] + (0, $1SukY.LOG)[poly[k]]) % 255];
            else ecc[k] = ecc[k - 1];
            if (m !== 0 && poly[0] !== 0) ecc[0] = (0, $1SukY.ALOG)[((0, $1SukY.LOG)[m] + (0, $1SukY.LOG)[poly[0]]) % 255];
            else ecc[0] = 0;
        }
        var eccReversed = [];
        for(var i = 0; i < numECWords; i++)eccReversed[i] = ecc[numECWords - i - 1];
        return eccReversed.map(function(c) {
            return String.fromCharCode(c);
        }).join("");
    };
    return ErrorCorrection;
}();
var $acded46b6060ebc0$export$2e2bcd8739ae039 = $acded46b6060ebc0$var$ErrorCorrection;

});
parcelRegister("1SukY", function(module, exports) {

$parcel$export(module.exports, "FACTOR_SETS", () => $15e25defd8fef21c$export$1a4ea90639b29dc9);
$parcel$export(module.exports, "FACTORS", () => $15e25defd8fef21c$export$dbdb347f12e46d6c);
$parcel$export(module.exports, "LOG", () => $15e25defd8fef21c$export$5bfbc7f735892ffd);
$parcel$export(module.exports, "ALOG", () => $15e25defd8fef21c$export$1098f4555f330d74);
$parcel$export(module.exports, "PAD", () => $15e25defd8fef21c$export$f0a63d87a2a34697);
$parcel$export(module.exports, "LATCH_TO_C40", () => $15e25defd8fef21c$export$4a0f817a5f4ee4ee);
$parcel$export(module.exports, "LATCH_TO_BASE256", () => $15e25defd8fef21c$export$dd1a688a09fef810);
$parcel$export(module.exports, "UPPER_SHIFT", () => $15e25defd8fef21c$export$9ad52e625a8ea11d);
$parcel$export(module.exports, "MACRO_05", () => $15e25defd8fef21c$export$17e82e449024cedf);
$parcel$export(module.exports, "MACRO_06", () => $15e25defd8fef21c$export$a903123fbb5ef394);
$parcel$export(module.exports, "LATCH_TO_ANSIX12", () => $15e25defd8fef21c$export$262608b2e224b244);
$parcel$export(module.exports, "LATCH_TO_TEXT", () => $15e25defd8fef21c$export$96851926505e2f00);
$parcel$export(module.exports, "LATCH_TO_EDIFACT", () => $15e25defd8fef21c$export$b92c818abc80fbe5);
$parcel$export(module.exports, "C40_UNLATCH", () => $15e25defd8fef21c$export$d290130da1db6f5e);
$parcel$export(module.exports, "X12_UNLATCH", () => $15e25defd8fef21c$export$15fb43a449900da);
$parcel$export(module.exports, "MACRO_05_HEADER", () => $15e25defd8fef21c$export$b9291bc7e7703008);
$parcel$export(module.exports, "MACRO_06_HEADER", () => $15e25defd8fef21c$export$d9fe944fda3d8b83);
$parcel$export(module.exports, "MACRO_TRAILER", () => $15e25defd8fef21c$export$c131c12a8149fc4a);
$parcel$export(module.exports, "ASCII_ENCODATION", () => $15e25defd8fef21c$export$14da3e339495da6f);
$parcel$export(module.exports, "C40_ENCODATION", () => $15e25defd8fef21c$export$1a39cd5cb553e275);
$parcel$export(module.exports, "TEXT_ENCODATION", () => $15e25defd8fef21c$export$b6ad1f89161198e3);
$parcel$export(module.exports, "X12_ENCODATION", () => $15e25defd8fef21c$export$9c26c56fb5133974);
$parcel$export(module.exports, "EDIFACT_ENCODATION", () => $15e25defd8fef21c$export$468849a05d2676e7);
$parcel$export(module.exports, "BASE256_ENCODATION", () => $15e25defd8fef21c$export$198535988cfe7d20);
var $15e25defd8fef21c$var$_a;
var $15e25defd8fef21c$export$1a4ea90639b29dc9 = [
    5,
    7,
    10,
    11,
    12,
    14,
    18,
    20,
    24,
    28,
    36,
    42,
    48,
    56,
    62,
    68
];
var $15e25defd8fef21c$export$dbdb347f12e46d6c = [
    [
        228,
        48,
        15,
        111,
        62
    ],
    [
        23,
        68,
        144,
        134,
        240,
        92,
        254
    ],
    [
        28,
        24,
        185,
        166,
        223,
        248,
        116,
        255,
        110,
        61
    ],
    [
        175,
        138,
        205,
        12,
        194,
        168,
        39,
        245,
        60,
        97,
        120
    ],
    [
        41,
        153,
        158,
        91,
        61,
        42,
        142,
        213,
        97,
        178,
        100,
        242
    ],
    [
        156,
        97,
        192,
        252,
        95,
        9,
        157,
        119,
        138,
        45,
        18,
        186,
        83,
        185
    ],
    [
        83,
        195,
        100,
        39,
        188,
        75,
        66,
        61,
        241,
        213,
        109,
        129,
        94,
        254,
        225,
        48,
        90,
        188
    ],
    [
        15,
        195,
        244,
        9,
        233,
        71,
        168,
        2,
        188,
        160,
        153,
        145,
        253,
        79,
        108,
        82,
        27,
        174,
        186,
        172
    ],
    [
        52,
        190,
        88,
        205,
        109,
        39,
        176,
        21,
        155,
        197,
        251,
        223,
        155,
        21,
        5,
        172,
        254,
        124,
        12,
        181,
        184,
        96,
        50,
        193
    ],
    [
        211,
        231,
        43,
        97,
        71,
        96,
        103,
        174,
        37,
        151,
        170,
        53,
        75,
        34,
        249,
        121,
        17,
        138,
        110,
        213,
        141,
        136,
        120,
        151,
        233,
        168,
        93,
        255
    ],
    [
        245,
        127,
        242,
        218,
        130,
        250,
        162,
        181,
        102,
        120,
        84,
        179,
        220,
        251,
        80,
        182,
        229,
        18,
        2,
        4,
        68,
        33,
        101,
        137,
        95,
        119,
        115,
        44,
        175,
        184,
        59,
        25,
        225,
        98,
        81,
        112
    ],
    [
        77,
        193,
        137,
        31,
        19,
        38,
        22,
        153,
        247,
        105,
        122,
        2,
        245,
        133,
        242,
        8,
        175,
        95,
        100,
        9,
        167,
        105,
        214,
        111,
        57,
        121,
        21,
        1,
        253,
        57,
        54,
        101,
        248,
        202,
        69,
        50,
        150,
        177,
        226,
        5,
        9,
        5
    ],
    [
        245,
        132,
        172,
        223,
        96,
        32,
        117,
        22,
        238,
        133,
        238,
        231,
        205,
        188,
        237,
        87,
        191,
        106,
        16,
        147,
        118,
        23,
        37,
        90,
        170,
        205,
        131,
        88,
        120,
        100,
        66,
        138,
        186,
        240,
        82,
        44,
        176,
        87,
        187,
        147,
        160,
        175,
        69,
        213,
        92,
        253,
        225,
        19
    ],
    [
        175,
        9,
        223,
        238,
        12,
        17,
        220,
        208,
        100,
        29,
        175,
        170,
        230,
        192,
        215,
        235,
        150,
        159,
        36,
        223,
        38,
        200,
        132,
        54,
        228,
        146,
        218,
        234,
        117,
        203,
        29,
        232,
        144,
        238,
        22,
        150,
        201,
        117,
        62,
        207,
        164,
        13,
        137,
        245,
        127,
        67,
        247,
        28,
        155,
        43,
        203,
        107,
        233,
        53,
        143,
        46
    ],
    [
        242,
        93,
        169,
        50,
        144,
        210,
        39,
        118,
        202,
        188,
        201,
        189,
        143,
        108,
        196,
        37,
        185,
        112,
        134,
        230,
        245,
        63,
        197,
        190,
        250,
        106,
        185,
        221,
        175,
        64,
        114,
        71,
        161,
        44,
        147,
        6,
        27,
        218,
        51,
        63,
        87,
        10,
        40,
        130,
        188,
        17,
        163,
        31,
        176,
        170,
        4,
        107,
        232,
        7,
        94,
        166,
        224,
        124,
        86,
        47,
        11,
        204
    ],
    [
        220,
        228,
        173,
        89,
        251,
        149,
        159,
        56,
        89,
        33,
        147,
        244,
        154,
        36,
        73,
        127,
        213,
        136,
        248,
        180,
        234,
        197,
        158,
        177,
        68,
        122,
        93,
        213,
        15,
        160,
        227,
        236,
        66,
        139,
        153,
        185,
        202,
        167,
        179,
        25,
        220,
        232,
        96,
        210,
        231,
        136,
        223,
        239,
        181,
        241,
        59,
        52,
        172,
        25,
        49,
        232,
        211,
        189,
        64,
        54,
        108,
        153,
        132,
        63,
        96,
        103,
        82,
        186
    ]
];
var /*final*/ $15e25defd8fef21c$export$c16b7defc6bd7e7f = 0x12d;
var $15e25defd8fef21c$var$static_LOG = function(LOG, ALOG) {
    var p = 1;
    for(var i = 0; i < 255; i++){
        ALOG[i] = p;
        LOG[p] = i;
        p *= 2;
        if (p >= 256) p ^= $15e25defd8fef21c$export$c16b7defc6bd7e7f;
    }
    return {
        LOG: LOG,
        ALOG: ALOG
    };
};
var $15e25defd8fef21c$export$5bfbc7f735892ffd = ($15e25defd8fef21c$var$_a = $15e25defd8fef21c$var$static_LOG([], []), $15e25defd8fef21c$var$_a.LOG), $15e25defd8fef21c$export$1098f4555f330d74 = $15e25defd8fef21c$var$_a.ALOG;
var $15e25defd8fef21c$export$9943470dc8ddf67b;
(function(SymbolShapeHint) {
    SymbolShapeHint[SymbolShapeHint["FORCE_NONE"] = 0] = "FORCE_NONE";
    SymbolShapeHint[SymbolShapeHint["FORCE_SQUARE"] = 1] = "FORCE_SQUARE";
    SymbolShapeHint[SymbolShapeHint["FORCE_RECTANGLE"] = 2] = "FORCE_RECTANGLE";
})($15e25defd8fef21c$export$9943470dc8ddf67b || ($15e25defd8fef21c$export$9943470dc8ddf67b = {}));
var $15e25defd8fef21c$export$f0a63d87a2a34697 = 129;
var $15e25defd8fef21c$export$4a0f817a5f4ee4ee = 230;
var $15e25defd8fef21c$export$dd1a688a09fef810 = 231;
var $15e25defd8fef21c$export$9ad52e625a8ea11d = 235;
var $15e25defd8fef21c$export$17e82e449024cedf = 236;
var $15e25defd8fef21c$export$a903123fbb5ef394 = 237;
var $15e25defd8fef21c$export$262608b2e224b244 = 238;
var $15e25defd8fef21c$export$96851926505e2f00 = 239;
var $15e25defd8fef21c$export$b92c818abc80fbe5 = 240;
var $15e25defd8fef21c$export$d290130da1db6f5e = 254;
var $15e25defd8fef21c$export$15fb43a449900da = 254;
var $15e25defd8fef21c$export$b9291bc7e7703008 = "[)>\x1e05\x1d";
var $15e25defd8fef21c$export$d9fe944fda3d8b83 = "[)>\x1e06\x1d";
var $15e25defd8fef21c$export$c131c12a8149fc4a = "\x1e\x04";
var $15e25defd8fef21c$export$14da3e339495da6f = 0;
var $15e25defd8fef21c$export$1a39cd5cb553e275 = 1;
var $15e25defd8fef21c$export$b6ad1f89161198e3 = 2;
var $15e25defd8fef21c$export$9c26c56fb5133974 = 3;
var $15e25defd8fef21c$export$468849a05d2676e7 = 4;
var $15e25defd8fef21c$export$198535988cfe7d20 = 5;

});


parcelRegister("h1LwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c657652824b09e44$export$2e2bcd8739ae039);
// tslint:disable-next-line:no-circular-imports

var $cjIMN = parcelRequire("cjIMN");

var $auqnF = parcelRequire("auqnF");

var $1bF01 = parcelRequire("1bF01");

var $1SukY = parcelRequire("1SukY");

var $8QoNx = parcelRequire("8QoNx");

var $g79YU = parcelRequire("g79YU");

var $3iEu2 = parcelRequire("3iEu2");

var $2Qn2c = parcelRequire("2Qn2c");

var $iYwLM = parcelRequire("iYwLM");

var $hcAg4 = parcelRequire("hcAg4");
/**
 * DataMatrix ECC 200 data encoder following the algorithm described in ISO/IEC 16022:200(E) in
 * annex S.
 */ var $c657652824b09e44$var$HighLevelEncoder = /** @class */ function() {
    function HighLevelEncoder() {}
    HighLevelEncoder.randomize253State = function(codewordPosition) {
        var pseudoRandom = 149 * codewordPosition % 253 + 1;
        var tempVariable = (0, $1SukY.PAD) + pseudoRandom;
        return tempVariable <= 254 ? tempVariable : tempVariable - 254;
    };
    /**
     * Performs message encoding of a DataMatrix message using the algorithm described in annex P
     * of ISO/IEC 16022:2000(E).
     *
     * @param msg     the message
     * @param shape   requested shape. May be {@code SymbolShapeHint.FORCE_NONE},
     *                {@code SymbolShapeHint.FORCE_SQUARE} or {@code SymbolShapeHint.FORCE_RECTANGLE}.
     * @param minSize the minimum symbol size constraint or null for no constraint
     * @param maxSize the maximum symbol size constraint or null for no constraint
     * @param forceC40 enforce C40 encoding
     * @return the encoded message (the char values range from 0 to 255)
     */ HighLevelEncoder.encodeHighLevel = function(msg, shape, minSize, maxSize, forceC40) {
        if (shape === void 0) shape = 0 /* FORCE_NONE */ ;
        if (minSize === void 0) minSize = null;
        if (maxSize === void 0) maxSize = null;
        if (forceC40 === void 0) forceC40 = false;
        // the codewords 0..255 are encoded as Unicode characters
        var c40Encoder = new (0, $1bF01.C40Encoder)();
        var encoders = [
            new (0, $cjIMN.ASCIIEncoder)(),
            c40Encoder,
            new (0, $2Qn2c.TextEncoder)(),
            new (0, $3iEu2.X12Encoder)(),
            new (0, $8QoNx.EdifactEncoder)(),
            new (0, $auqnF.Base256Encoder)()
        ];
        var context = new (0, $g79YU.EncoderContext)(msg);
        context.setSymbolShape(shape);
        context.setSizeConstraints(minSize, maxSize);
        if (msg.startsWith((0, $1SukY.MACRO_05_HEADER)) && msg.endsWith((0, $1SukY.MACRO_TRAILER))) {
            context.writeCodeword((0, $1SukY.MACRO_05));
            context.setSkipAtEnd(2);
            context.pos += (0, $1SukY.MACRO_05_HEADER).length;
        } else if (msg.startsWith((0, $1SukY.MACRO_06_HEADER)) && msg.endsWith((0, $1SukY.MACRO_TRAILER))) {
            context.writeCodeword((0, $1SukY.MACRO_06));
            context.setSkipAtEnd(2);
            context.pos += (0, $1SukY.MACRO_06_HEADER).length;
        }
        var encodingMode = (0, $1SukY.ASCII_ENCODATION); // Default mode
        if (forceC40) {
            c40Encoder.encodeMaximal(context);
            encodingMode = context.getNewEncoding();
            context.resetEncoderSignal();
        }
        while(context.hasMoreCharacters()){
            encoders[encodingMode].encode(context);
            if (context.getNewEncoding() >= 0) {
                encodingMode = context.getNewEncoding();
                context.resetEncoderSignal();
            }
        }
        var len = context.getCodewordCount();
        context.updateSymbolInfo();
        var capacity = context.getSymbolInfo().getDataCapacity();
        if (len < capacity && encodingMode !== (0, $1SukY.ASCII_ENCODATION) && encodingMode !== (0, $1SukY.BASE256_ENCODATION) && encodingMode !== (0, $1SukY.EDIFACT_ENCODATION)) context.writeCodeword("\xfe"); // Unlatch (254)
        // Padding
        var codewords = context.getCodewords();
        if (codewords.length() < capacity) codewords.append((0, $1SukY.PAD));
        while(codewords.length() < capacity)codewords.append(this.randomize253State(codewords.length() + 1));
        return context.getCodewords().toString();
    };
    HighLevelEncoder.lookAheadTest = function(msg, startpos, currentMode) {
        var newMode = this.lookAheadTestIntern(msg, startpos, currentMode);
        if (currentMode === (0, $1SukY.X12_ENCODATION) && newMode === (0, $1SukY.X12_ENCODATION)) {
            var endpos = Math.min(startpos + 3, msg.length);
            for(var i = startpos; i < endpos; i++){
                if (!this.isNativeX12(msg.charCodeAt(i))) return 0, $1SukY.ASCII_ENCODATION;
            }
        } else if (currentMode === (0, $1SukY.EDIFACT_ENCODATION) && newMode === (0, $1SukY.EDIFACT_ENCODATION)) {
            var endpos = Math.min(startpos + 4, msg.length);
            for(var i = startpos; i < endpos; i++){
                if (!this.isNativeEDIFACT(msg.charCodeAt(i))) return 0, $1SukY.ASCII_ENCODATION;
            }
        }
        return newMode;
    };
    HighLevelEncoder.lookAheadTestIntern = function(msg, startpos, currentMode) {
        if (startpos >= msg.length) return currentMode;
        var charCounts;
        // step J
        if (currentMode === (0, $1SukY.ASCII_ENCODATION)) charCounts = [
            0,
            1,
            1,
            1,
            1,
            1.25
        ];
        else {
            charCounts = [
                1,
                2,
                2,
                2,
                2,
                2.25
            ];
            charCounts[currentMode] = 0;
        }
        var charsProcessed = 0;
        var mins = new Uint8Array(6);
        var intCharCounts = [];
        while(true){
            // step K
            if (startpos + charsProcessed === msg.length) {
                (0, $iYwLM.default).fill(mins, 0);
                (0, $iYwLM.default).fill(intCharCounts, 0);
                var min = this.findMinimums(charCounts, intCharCounts, (0, $hcAg4.default).MAX_VALUE, mins);
                var minCount = this.getMinimumCount(mins);
                if (intCharCounts[0, $1SukY.ASCII_ENCODATION] === min) return 0, $1SukY.ASCII_ENCODATION;
                if (minCount === 1) {
                    if (mins[0, $1SukY.BASE256_ENCODATION] > 0) return 0, $1SukY.BASE256_ENCODATION;
                    if (mins[0, $1SukY.EDIFACT_ENCODATION] > 0) return 0, $1SukY.EDIFACT_ENCODATION;
                    if (mins[0, $1SukY.TEXT_ENCODATION] > 0) return 0, $1SukY.TEXT_ENCODATION;
                    if (mins[0, $1SukY.X12_ENCODATION] > 0) return 0, $1SukY.X12_ENCODATION;
                }
                return 0, $1SukY.C40_ENCODATION;
            }
            var c = msg.charCodeAt(startpos + charsProcessed);
            charsProcessed++;
            // step L
            if (this.isDigit(c)) charCounts[0, $1SukY.ASCII_ENCODATION] += 0.5;
            else if (this.isExtendedASCII(c)) {
                charCounts[0, $1SukY.ASCII_ENCODATION] = Math.ceil(charCounts[0, $1SukY.ASCII_ENCODATION]);
                charCounts[0, $1SukY.ASCII_ENCODATION] += 2.0;
            } else {
                charCounts[0, $1SukY.ASCII_ENCODATION] = Math.ceil(charCounts[0, $1SukY.ASCII_ENCODATION]);
                charCounts[0, $1SukY.ASCII_ENCODATION]++;
            }
            // step M
            if (this.isNativeC40(c)) charCounts[0, $1SukY.C40_ENCODATION] += 2.0 / 3.0;
            else if (this.isExtendedASCII(c)) charCounts[0, $1SukY.C40_ENCODATION] += 8.0 / 3.0;
            else charCounts[0, $1SukY.C40_ENCODATION] += 4.0 / 3.0;
            // step N
            if (this.isNativeText(c)) charCounts[0, $1SukY.TEXT_ENCODATION] += 2.0 / 3.0;
            else if (this.isExtendedASCII(c)) charCounts[0, $1SukY.TEXT_ENCODATION] += 8.0 / 3.0;
            else charCounts[0, $1SukY.TEXT_ENCODATION] += 4.0 / 3.0;
            // step O
            if (this.isNativeX12(c)) charCounts[0, $1SukY.X12_ENCODATION] += 2.0 / 3.0;
            else if (this.isExtendedASCII(c)) charCounts[0, $1SukY.X12_ENCODATION] += 13.0 / 3.0;
            else charCounts[0, $1SukY.X12_ENCODATION] += 10.0 / 3.0;
            // step P
            if (this.isNativeEDIFACT(c)) charCounts[0, $1SukY.EDIFACT_ENCODATION] += 0.75;
            else if (this.isExtendedASCII(c)) charCounts[0, $1SukY.EDIFACT_ENCODATION] += 4.25;
            else charCounts[0, $1SukY.EDIFACT_ENCODATION] += 3.25;
            // step Q
            if (this.isSpecialB256(c)) charCounts[0, $1SukY.BASE256_ENCODATION] += 4.0;
            else charCounts[0, $1SukY.BASE256_ENCODATION]++;
            // step R
            if (charsProcessed >= 4) {
                (0, $iYwLM.default).fill(mins, 0);
                (0, $iYwLM.default).fill(intCharCounts, 0);
                this.findMinimums(charCounts, intCharCounts, (0, $hcAg4.default).MAX_VALUE, mins);
                if (intCharCounts[0, $1SukY.ASCII_ENCODATION] < this.min(intCharCounts[0, $1SukY.BASE256_ENCODATION], intCharCounts[0, $1SukY.C40_ENCODATION], intCharCounts[0, $1SukY.TEXT_ENCODATION], intCharCounts[0, $1SukY.X12_ENCODATION], intCharCounts[0, $1SukY.EDIFACT_ENCODATION])) return 0, $1SukY.ASCII_ENCODATION;
                if (intCharCounts[0, $1SukY.BASE256_ENCODATION] < intCharCounts[0, $1SukY.ASCII_ENCODATION] || intCharCounts[0, $1SukY.BASE256_ENCODATION] + 1 < this.min(intCharCounts[0, $1SukY.C40_ENCODATION], intCharCounts[0, $1SukY.TEXT_ENCODATION], intCharCounts[0, $1SukY.X12_ENCODATION], intCharCounts[0, $1SukY.EDIFACT_ENCODATION])) return 0, $1SukY.BASE256_ENCODATION;
                if (intCharCounts[0, $1SukY.EDIFACT_ENCODATION] + 1 < this.min(intCharCounts[0, $1SukY.BASE256_ENCODATION], intCharCounts[0, $1SukY.C40_ENCODATION], intCharCounts[0, $1SukY.TEXT_ENCODATION], intCharCounts[0, $1SukY.X12_ENCODATION], intCharCounts[0, $1SukY.ASCII_ENCODATION])) return 0, $1SukY.EDIFACT_ENCODATION;
                if (intCharCounts[0, $1SukY.TEXT_ENCODATION] + 1 < this.min(intCharCounts[0, $1SukY.BASE256_ENCODATION], intCharCounts[0, $1SukY.C40_ENCODATION], intCharCounts[0, $1SukY.EDIFACT_ENCODATION], intCharCounts[0, $1SukY.X12_ENCODATION], intCharCounts[0, $1SukY.ASCII_ENCODATION])) return 0, $1SukY.TEXT_ENCODATION;
                if (intCharCounts[0, $1SukY.X12_ENCODATION] + 1 < this.min(intCharCounts[0, $1SukY.BASE256_ENCODATION], intCharCounts[0, $1SukY.C40_ENCODATION], intCharCounts[0, $1SukY.EDIFACT_ENCODATION], intCharCounts[0, $1SukY.TEXT_ENCODATION], intCharCounts[0, $1SukY.ASCII_ENCODATION])) return 0, $1SukY.X12_ENCODATION;
                if (intCharCounts[0, $1SukY.C40_ENCODATION] + 1 < this.min(intCharCounts[0, $1SukY.ASCII_ENCODATION], intCharCounts[0, $1SukY.BASE256_ENCODATION], intCharCounts[0, $1SukY.EDIFACT_ENCODATION], intCharCounts[0, $1SukY.TEXT_ENCODATION])) {
                    if (intCharCounts[0, $1SukY.C40_ENCODATION] < intCharCounts[0, $1SukY.X12_ENCODATION]) return 0, $1SukY.C40_ENCODATION;
                    if (intCharCounts[0, $1SukY.C40_ENCODATION] === intCharCounts[0, $1SukY.X12_ENCODATION]) {
                        var p = startpos + charsProcessed + 1;
                        while(p < msg.length){
                            var tc = msg.charCodeAt(p);
                            if (this.isX12TermSep(tc)) return 0, $1SukY.X12_ENCODATION;
                            if (!this.isNativeX12(tc)) break;
                            p++;
                        }
                        return 0, $1SukY.C40_ENCODATION;
                    }
                }
            }
        }
    };
    HighLevelEncoder.min = function(f1, f2, f3, f4, f5) {
        var val = Math.min(f1, Math.min(f2, Math.min(f3, f4)));
        if (f5 === undefined) return val;
        else return Math.min(val, f5);
    };
    HighLevelEncoder.findMinimums = function(charCounts, intCharCounts, min, mins) {
        for(var i = 0; i < 6; i++){
            var current = intCharCounts[i] = Math.ceil(charCounts[i]);
            if (min > current) {
                min = current;
                (0, $iYwLM.default).fill(mins, 0);
            }
            if (min === current) mins[i] = mins[i] + 1;
        }
        return min;
    };
    HighLevelEncoder.getMinimumCount = function(mins) {
        var minCount = 0;
        for(var i = 0; i < 6; i++)minCount += mins[i];
        return minCount || 0;
    };
    HighLevelEncoder.isDigit = function(ch) {
        return ch >= "0".charCodeAt(0) && ch <= "9".charCodeAt(0);
    };
    HighLevelEncoder.isExtendedASCII = function(ch) {
        return ch >= 128 && ch <= 255;
    };
    HighLevelEncoder.isNativeC40 = function(ch) {
        return ch === " ".charCodeAt(0) || ch >= "0".charCodeAt(0) && ch <= "9".charCodeAt(0) || ch >= "A".charCodeAt(0) && ch <= "Z".charCodeAt(0);
    };
    HighLevelEncoder.isNativeText = function(ch) {
        return ch === " ".charCodeAt(0) || ch >= "0".charCodeAt(0) && ch <= "9".charCodeAt(0) || ch >= "a".charCodeAt(0) && ch <= "z".charCodeAt(0);
    };
    HighLevelEncoder.isNativeX12 = function(ch) {
        return this.isX12TermSep(ch) || ch === " ".charCodeAt(0) || ch >= "0".charCodeAt(0) && ch <= "9".charCodeAt(0) || ch >= "A".charCodeAt(0) && ch <= "Z".charCodeAt(0);
    };
    HighLevelEncoder.isX12TermSep = function(ch) {
        return ch === 13 || // CR
        ch === "*".charCodeAt(0) || ch === ">".charCodeAt(0);
    };
    HighLevelEncoder.isNativeEDIFACT = function(ch) {
        return ch >= " ".charCodeAt(0) && ch <= "^".charCodeAt(0);
    };
    HighLevelEncoder.isSpecialB256 = function(ch) {
        return false; // TODO NOT IMPLEMENTED YET!!!
    };
    /**
     * Determines the number of consecutive characters that are encodable using numeric compaction.
     *
     * @param msg      the message
     * @param startpos the start position within the message
     * @return the requested character count
     */ HighLevelEncoder.determineConsecutiveDigitCount = function(msg, startpos) {
        if (startpos === void 0) startpos = 0;
        var len = msg.length;
        var idx = startpos;
        while(idx < len && this.isDigit(msg.charCodeAt(idx)))idx++;
        return idx - startpos;
    };
    HighLevelEncoder.illegalCharacter = function(singleCharacter) {
        var hex = (0, $hcAg4.default).toHexString(singleCharacter.charCodeAt(0));
        hex = "0000".substring(0, 4 - hex.length) + hex;
        throw new Error("Illegal character: " + singleCharacter + " (0x" + hex + ")");
    };
    return HighLevelEncoder;
}();
var $c657652824b09e44$export$2e2bcd8739ae039 = $c657652824b09e44$var$HighLevelEncoder;

});
parcelRegister("cjIMN", function(module, exports) {

$parcel$export(module.exports, "ASCIIEncoder", () => $8f79fffa6417de87$export$17a895f6b9e73f8b);

var $1SukY = parcelRequire("1SukY");

var $h1LwC = parcelRequire("h1LwC");
var $8f79fffa6417de87$export$17a895f6b9e73f8b = /** @class */ function() {
    function ASCIIEncoder() {}
    ASCIIEncoder.prototype.getEncodingMode = function() {
        return 0, $1SukY.ASCII_ENCODATION;
    };
    ASCIIEncoder.prototype.encode = function(context) {
        // step B
        var n = (0, $h1LwC.default).determineConsecutiveDigitCount(context.getMessage(), context.pos);
        if (n >= 2) {
            context.writeCodeword(this.encodeASCIIDigits(context.getMessage().charCodeAt(context.pos), context.getMessage().charCodeAt(context.pos + 1)));
            context.pos += 2;
        } else {
            var c = context.getCurrentChar();
            var newMode = (0, $h1LwC.default).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
            if (newMode !== this.getEncodingMode()) switch(newMode){
                case 0, $1SukY.BASE256_ENCODATION:
                    context.writeCodeword((0, $1SukY.LATCH_TO_BASE256));
                    context.signalEncoderChange((0, $1SukY.BASE256_ENCODATION));
                    return;
                case 0, $1SukY.C40_ENCODATION:
                    context.writeCodeword((0, $1SukY.LATCH_TO_C40));
                    context.signalEncoderChange((0, $1SukY.C40_ENCODATION));
                    return;
                case 0, $1SukY.X12_ENCODATION:
                    context.writeCodeword((0, $1SukY.LATCH_TO_ANSIX12));
                    context.signalEncoderChange((0, $1SukY.X12_ENCODATION));
                    break;
                case 0, $1SukY.TEXT_ENCODATION:
                    context.writeCodeword((0, $1SukY.LATCH_TO_TEXT));
                    context.signalEncoderChange((0, $1SukY.TEXT_ENCODATION));
                    break;
                case 0, $1SukY.EDIFACT_ENCODATION:
                    context.writeCodeword((0, $1SukY.LATCH_TO_EDIFACT));
                    context.signalEncoderChange((0, $1SukY.EDIFACT_ENCODATION));
                    break;
                default:
                    throw new Error("Illegal mode: " + newMode);
            }
            else if ((0, $h1LwC.default).isExtendedASCII(c)) {
                context.writeCodeword((0, $1SukY.UPPER_SHIFT));
                context.writeCodeword(c - 128 + 1);
                context.pos++;
            } else {
                context.writeCodeword(c + 1);
                context.pos++;
            }
        }
    };
    ASCIIEncoder.prototype.encodeASCIIDigits = function(digit1, digit2) {
        if ((0, $h1LwC.default).isDigit(digit1) && (0, $h1LwC.default).isDigit(digit2)) {
            var num = (digit1 - 48) * 10 + (digit2 - 48);
            return num + 130;
        }
        throw new Error("not digits: " + digit1 + digit2);
    };
    return ASCIIEncoder;
}();

});

parcelRegister("auqnF", function(module, exports) {

$parcel$export(module.exports, "Base256Encoder", () => $7a312b63b67e1225$export$28d91855f6c4550e);

var $7mB9T = parcelRequire("7mB9T");

var $6E9N1 = parcelRequire("6E9N1");

var $h1LwC = parcelRequire("h1LwC");

var $1SukY = parcelRequire("1SukY");
var $7a312b63b67e1225$export$28d91855f6c4550e = /** @class */ function() {
    function Base256Encoder() {}
    Base256Encoder.prototype.getEncodingMode = function() {
        return 0, $1SukY.BASE256_ENCODATION;
    };
    Base256Encoder.prototype.encode = function(context) {
        var buffer = new (0, $6E9N1.default)();
        buffer.append(0); // Initialize length field
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            buffer.append(c);
            context.pos++;
            var newMode = (0, $h1LwC.default).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
            if (newMode !== this.getEncodingMode()) {
                // Return to ASCII encodation, which will actually handle latch to new mode
                context.signalEncoderChange((0, $1SukY.ASCII_ENCODATION));
                break;
            }
        }
        var dataCount = buffer.length() - 1;
        var lengthFieldSize = 1;
        var currentSize = context.getCodewordCount() + dataCount + lengthFieldSize;
        context.updateSymbolInfo(currentSize);
        var mustPad = context.getSymbolInfo().getDataCapacity() - currentSize > 0;
        if (context.hasMoreCharacters() || mustPad) {
            if (dataCount <= 249) buffer.setCharAt(0, (0, $7mB9T.default).getCharAt(dataCount));
            else if (dataCount <= 1555) {
                buffer.setCharAt(0, (0, $7mB9T.default).getCharAt(Math.floor(dataCount / 250) + 249));
                buffer.insert(1, (0, $7mB9T.default).getCharAt(dataCount % 250));
            } else throw new Error("Message length not in valid ranges: " + dataCount);
        }
        for(var i = 0, c = buffer.length(); i < c; i++)context.writeCodeword(this.randomize255State(buffer.charAt(i).charCodeAt(0), context.getCodewordCount() + 1));
    };
    Base256Encoder.prototype.randomize255State = function(ch, codewordPosition) {
        var pseudoRandom = 149 * codewordPosition % 255 + 1;
        var tempVariable = ch + pseudoRandom;
        if (tempVariable <= 255) return tempVariable;
        else return tempVariable - 256;
    };
    return Base256Encoder;
}();

});

parcelRegister("1bF01", function(module, exports) {

$parcel$export(module.exports, "C40Encoder", () => $0dd69f21cd8769e8$export$5b99b12a80a00de6);

var $6E9N1 = parcelRequire("6E9N1");

var $h1LwC = parcelRequire("h1LwC");

var $1SukY = parcelRequire("1SukY");
var $0dd69f21cd8769e8$export$5b99b12a80a00de6 = /** @class */ function() {
    function C40Encoder() {}
    C40Encoder.prototype.getEncodingMode = function() {
        return 0, $1SukY.C40_ENCODATION;
    };
    C40Encoder.prototype.encodeMaximal = function(context) {
        var buffer = new (0, $6E9N1.default)();
        var lastCharSize = 0;
        var backtrackStartPosition = context.pos;
        var backtrackBufferLength = 0;
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            context.pos++;
            lastCharSize = this.encodeChar(c, buffer);
            if (buffer.length() % 3 === 0) {
                backtrackStartPosition = context.pos;
                backtrackBufferLength = buffer.length();
            }
        }
        if (backtrackBufferLength !== buffer.length()) {
            var unwritten = Math.floor(buffer.length() / 3 * 2);
            var curCodewordCount = Math.floor(context.getCodewordCount() + unwritten + 1); // +1 for the latch to C40
            context.updateSymbolInfo(curCodewordCount);
            var available = context.getSymbolInfo().getDataCapacity() - curCodewordCount;
            var rest = Math.floor(buffer.length() % 3);
            if (rest === 2 && available !== 2 || rest === 1 && (lastCharSize > 3 || available !== 1)) // buffer.setLength(backtrackBufferLength);
            context.pos = backtrackStartPosition;
        }
        if (buffer.length() > 0) context.writeCodeword((0, $1SukY.LATCH_TO_C40));
        this.handleEOD(context, buffer);
    };
    C40Encoder.prototype.encode = function(context) {
        // step C
        var buffer = new (0, $6E9N1.default)();
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            context.pos++;
            var lastCharSize = this.encodeChar(c, buffer);
            var unwritten = Math.floor(buffer.length() / 3) * 2;
            var curCodewordCount = context.getCodewordCount() + unwritten;
            context.updateSymbolInfo(curCodewordCount);
            var available = context.getSymbolInfo().getDataCapacity() - curCodewordCount;
            if (!context.hasMoreCharacters()) {
                // Avoid having a single C40 value in the last triplet
                var removed = new (0, $6E9N1.default)();
                if (buffer.length() % 3 === 2 && available !== 2) lastCharSize = this.backtrackOneCharacter(context, buffer, removed, lastCharSize);
                while(buffer.length() % 3 === 1 && (lastCharSize > 3 || available !== 1))lastCharSize = this.backtrackOneCharacter(context, buffer, removed, lastCharSize);
                break;
            }
            var count = buffer.length();
            if (count % 3 === 0) {
                var newMode = (0, $h1LwC.default).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
                if (newMode !== this.getEncodingMode()) {
                    // Return to ASCII encodation, which will actually handle latch to new mode
                    context.signalEncoderChange((0, $1SukY.ASCII_ENCODATION));
                    break;
                }
            }
        }
        this.handleEOD(context, buffer);
    };
    C40Encoder.prototype.backtrackOneCharacter = function(context, buffer, removed, lastCharSize) {
        var count = buffer.length();
        var test = buffer.toString().substring(0, count - lastCharSize);
        buffer.setLengthToZero();
        buffer.append(test);
        // buffer.delete(count - lastCharSize, count);
        /*for (let i = count - lastCharSize; i < count; i++) {
          buffer.deleteCharAt(i);
        }*/ context.pos--;
        var c = context.getCurrentChar();
        lastCharSize = this.encodeChar(c, removed);
        context.resetSymbolInfo(); // Deal with possible reduction in symbol size
        return lastCharSize;
    };
    C40Encoder.prototype.writeNextTriplet = function(context, buffer) {
        context.writeCodewords(this.encodeToCodewords(buffer.toString()));
        var test = buffer.toString().substring(3);
        buffer.setLengthToZero();
        buffer.append(test);
    // buffer.delete(0, 3);
    /*for (let i = 0; i < 3; i++) {
          buffer.deleteCharAt(i);
        }*/ };
    /**
     * Handle "end of data" situations
     *
     * @param context the encoder context
     * @param buffer  the buffer with the remaining encoded characters
     */ C40Encoder.prototype.handleEOD = function(context, buffer) {
        var unwritten = Math.floor(buffer.length() / 3 * 2);
        var rest = buffer.length() % 3;
        var curCodewordCount = context.getCodewordCount() + unwritten;
        context.updateSymbolInfo(curCodewordCount);
        var available = context.getSymbolInfo().getDataCapacity() - curCodewordCount;
        if (rest === 2) {
            buffer.append("\0"); // Shift 1
            while(buffer.length() >= 3)this.writeNextTriplet(context, buffer);
            if (context.hasMoreCharacters()) context.writeCodeword((0, $1SukY.C40_UNLATCH));
        } else if (available === 1 && rest === 1) {
            while(buffer.length() >= 3)this.writeNextTriplet(context, buffer);
            if (context.hasMoreCharacters()) context.writeCodeword((0, $1SukY.C40_UNLATCH));
            // else no unlatch
            context.pos--;
        } else if (rest === 0) {
            while(buffer.length() >= 3)this.writeNextTriplet(context, buffer);
            if (available > 0 || context.hasMoreCharacters()) context.writeCodeword((0, $1SukY.C40_UNLATCH));
        } else throw new Error("Unexpected case. Please report!");
        context.signalEncoderChange((0, $1SukY.ASCII_ENCODATION));
    };
    C40Encoder.prototype.encodeChar = function(c, sb) {
        if (c === " ".charCodeAt(0)) {
            sb.append(3);
            return 1;
        }
        if (c >= "0".charCodeAt(0) && c <= "9".charCodeAt(0)) {
            sb.append(c - 48 + 4);
            return 1;
        }
        if (c >= "A".charCodeAt(0) && c <= "Z".charCodeAt(0)) {
            sb.append(c - 65 + 14);
            return 1;
        }
        if (c < " ".charCodeAt(0)) {
            sb.append(0); // Shift 1 Set
            sb.append(c);
            return 2;
        }
        if (c <= "/".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 33);
            return 2;
        }
        if (c <= "@".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 58 + 15);
            return 2;
        }
        if (c <= "_".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 91 + 22);
            return 2;
        }
        if (c <= 127) {
            sb.append(2); // Shift 3 Set
            sb.append(c - 96);
            return 2;
        }
        sb.append("1\x1e"); // Shift 2, Upper Shift
        var len = 2;
        len += this.encodeChar(c - 128, sb);
        return len;
    };
    C40Encoder.prototype.encodeToCodewords = function(sb) {
        var v = 1600 * sb.charCodeAt(0) + 40 * sb.charCodeAt(1) + sb.charCodeAt(2) + 1;
        var cw1 = v / 256;
        var cw2 = v % 256;
        var result = new (0, $6E9N1.default)();
        result.append(cw1);
        result.append(cw2);
        return result.toString();
    };
    return C40Encoder;
}();

});

parcelRegister("8QoNx", function(module, exports) {

$parcel$export(module.exports, "EdifactEncoder", () => $67066a708a9472b3$export$be5dd319206857a0);

var $7mB9T = parcelRequire("7mB9T");

var $6E9N1 = parcelRequire("6E9N1");

var $1SukY = parcelRequire("1SukY");

var $h1LwC = parcelRequire("h1LwC");
var $67066a708a9472b3$export$be5dd319206857a0 = /** @class */ function() {
    function EdifactEncoder() {}
    EdifactEncoder.prototype.getEncodingMode = function() {
        return 0, $1SukY.EDIFACT_ENCODATION;
    };
    EdifactEncoder.prototype.encode = function(context) {
        // step F
        var buffer = new (0, $6E9N1.default)();
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            this.encodeChar(c, buffer);
            context.pos++;
            var count = buffer.length();
            if (count >= 4) {
                context.writeCodewords(this.encodeToCodewords(buffer.toString()));
                var test_1 = buffer.toString().substring(4);
                buffer.setLengthToZero();
                buffer.append(test_1);
                // buffer.delete(0, 4);
                // for (let i = 0; i < 4; i++) {
                //  buffer.deleteCharAt(i);
                // }
                var newMode = (0, $h1LwC.default).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
                if (newMode !== this.getEncodingMode()) {
                    // Return to ASCII encodation, which will actually handle latch to new mode
                    context.signalEncoderChange((0, $1SukY.ASCII_ENCODATION));
                    break;
                }
            }
        }
        buffer.append((0, $7mB9T.default).getCharAt(31)); // Unlatch
        this.handleEOD(context, buffer);
    };
    /**
     * Handle "end of data" situations
     *
     * @param context the encoder context
     * @param buffer  the buffer with the remaining encoded characters
     */ EdifactEncoder.prototype.handleEOD = function(context, buffer) {
        try {
            var count = buffer.length();
            if (count === 0) return; // Already finished
            if (count === 1) {
                // Only an unlatch at the end
                context.updateSymbolInfo();
                var available = context.getSymbolInfo().getDataCapacity() - context.getCodewordCount();
                var remaining = context.getRemainingCharacters();
                // The following two lines are a hack inspired by the 'fix' from https://sourceforge.net/p/barcode4j/svn/221/
                if (remaining > available) {
                    context.updateSymbolInfo(context.getCodewordCount() + 1);
                    available = context.getSymbolInfo().getDataCapacity() - context.getCodewordCount();
                }
                if (remaining <= available && available <= 2) return; // No unlatch
            }
            if (count > 4) throw new Error("Count must not exceed 4");
            var restChars = count - 1;
            var encoded = this.encodeToCodewords(buffer.toString());
            var endOfSymbolReached = !context.hasMoreCharacters();
            var restInAscii = endOfSymbolReached && restChars <= 2;
            if (restChars <= 2) {
                context.updateSymbolInfo(context.getCodewordCount() + restChars);
                var available = context.getSymbolInfo().getDataCapacity() - context.getCodewordCount();
                if (available >= 3) {
                    restInAscii = false;
                    context.updateSymbolInfo(context.getCodewordCount() + encoded.length);
                // available = context.symbolInfo.dataCapacity - context.getCodewordCount();
                }
            }
            if (restInAscii) {
                context.resetSymbolInfo();
                context.pos -= restChars;
            } else context.writeCodewords(encoded);
        } finally{
            context.signalEncoderChange((0, $1SukY.ASCII_ENCODATION));
        }
    };
    EdifactEncoder.prototype.encodeChar = function(c, sb) {
        if (c >= " ".charCodeAt(0) && c <= "?".charCodeAt(0)) sb.append(c);
        else if (c >= "@".charCodeAt(0) && c <= "^".charCodeAt(0)) sb.append((0, $7mB9T.default).getCharAt(c - 64));
        else (0, $h1LwC.default).illegalCharacter((0, $7mB9T.default).getCharAt(c));
    };
    EdifactEncoder.prototype.encodeToCodewords = function(sb) {
        var len = sb.length;
        if (len === 0) throw new Error("StringBuilder must not be empty");
        var c1 = sb.charAt(0).charCodeAt(0);
        var c2 = len >= 2 ? sb.charAt(1).charCodeAt(0) : 0;
        var c3 = len >= 3 ? sb.charAt(2).charCodeAt(0) : 0;
        var c4 = len >= 4 ? sb.charAt(3).charCodeAt(0) : 0;
        var v = (c1 << 18) + (c2 << 12) + (c3 << 6) + c4;
        var cw1 = v >> 16 & 255;
        var cw2 = v >> 8 & 255;
        var cw3 = v & 255;
        var res = new (0, $6E9N1.default)();
        res.append(cw1);
        if (len >= 2) res.append(cw2);
        if (len >= 3) res.append(cw3);
        return res.toString();
    };
    return EdifactEncoder;
}();

});

parcelRegister("g79YU", function(module, exports) {

$parcel$export(module.exports, "EncoderContext", () => $bbb50ae015eccf1d$export$9cb00ee6d360e345);

var $6E9N1 = parcelRequire("6E9N1");

var $lamxU = parcelRequire("lamxU");
var $bbb50ae015eccf1d$export$9cb00ee6d360e345 = /** @class */ function() {
    function EncoderContext(msg) {
        this.msg = msg;
        this.pos = 0;
        this.skipAtEnd = 0;
        // From this point on Strings are not Unicode anymore!
        var msgBinary = msg.split("").map(function(c) {
            return c.charCodeAt(0);
        });
        var sb = new (0, $6E9N1.default)();
        for(var i = 0, c = msgBinary.length; i < c; i++){
            var ch = String.fromCharCode(msgBinary[i] & 0xff);
            if (ch === "?" && msg.charAt(i) !== "?") throw new Error("Message contains characters outside ISO-8859-1 encoding.");
            sb.append(ch);
        }
        this.msg = sb.toString(); // Not Unicode here!
        this.shape = 0 /* FORCE_NONE */ ;
        this.codewords = new (0, $6E9N1.default)();
        this.newEncoding = -1;
    }
    EncoderContext.prototype.setSymbolShape = function(shape) {
        this.shape = shape;
    };
    EncoderContext.prototype.setSizeConstraints = function(minSize, maxSize) {
        this.minSize = minSize;
        this.maxSize = maxSize;
    };
    EncoderContext.prototype.getMessage = function() {
        return this.msg;
    };
    EncoderContext.prototype.setSkipAtEnd = function(count) {
        this.skipAtEnd = count;
    };
    EncoderContext.prototype.getCurrentChar = function() {
        return this.msg.charCodeAt(this.pos);
    };
    EncoderContext.prototype.getCurrent = function() {
        return this.msg.charCodeAt(this.pos);
    };
    EncoderContext.prototype.getCodewords = function() {
        return this.codewords;
    };
    EncoderContext.prototype.writeCodewords = function(codewords) {
        this.codewords.append(codewords);
    };
    EncoderContext.prototype.writeCodeword = function(codeword) {
        this.codewords.append(codeword);
    };
    EncoderContext.prototype.getCodewordCount = function() {
        return this.codewords.length();
    };
    EncoderContext.prototype.getNewEncoding = function() {
        return this.newEncoding;
    };
    EncoderContext.prototype.signalEncoderChange = function(encoding) {
        this.newEncoding = encoding;
    };
    EncoderContext.prototype.resetEncoderSignal = function() {
        this.newEncoding = -1;
    };
    EncoderContext.prototype.hasMoreCharacters = function() {
        return this.pos < this.getTotalMessageCharCount();
    };
    EncoderContext.prototype.getTotalMessageCharCount = function() {
        return this.msg.length - this.skipAtEnd;
    };
    EncoderContext.prototype.getRemainingCharacters = function() {
        return this.getTotalMessageCharCount() - this.pos;
    };
    EncoderContext.prototype.getSymbolInfo = function() {
        return this.symbolInfo;
    };
    EncoderContext.prototype.updateSymbolInfo = function(len) {
        if (len === void 0) len = this.getCodewordCount();
        if (this.symbolInfo == null || len > this.symbolInfo.getDataCapacity()) this.symbolInfo = (0, $lamxU.default).lookup(len, this.shape, this.minSize, this.maxSize, true);
    };
    EncoderContext.prototype.resetSymbolInfo = function() {
        this.symbolInfo = null;
    };
    return EncoderContext;
}();

});
parcelRegister("lamxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f68c054b32b5e406$export$2e2bcd8739ae039);
var $f68c054b32b5e406$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $f68c054b32b5e406$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * Symbol info table for DataMatrix.
 */ var $f68c054b32b5e406$var$SymbolInfo = /** @class */ function() {
    function SymbolInfo(rectangular, dataCapacity, errorCodewords, matrixWidth, matrixHeight, dataRegions, rsBlockData, rsBlockError) {
        if (rsBlockData === void 0) rsBlockData = 0;
        if (rsBlockError === void 0) rsBlockError = 0;
        this.rectangular = rectangular;
        this.dataCapacity = dataCapacity;
        this.errorCodewords = errorCodewords;
        this.matrixWidth = matrixWidth;
        this.matrixHeight = matrixHeight;
        this.dataRegions = dataRegions;
        this.rsBlockData = rsBlockData;
        this.rsBlockError = rsBlockError;
    }
    SymbolInfo.lookup = function(dataCodewords, shape, minSize, maxSize, fail) {
        var e_1, _a;
        if (shape === void 0) shape = 0 /* FORCE_NONE */ ;
        if (minSize === void 0) minSize = null;
        if (maxSize === void 0) maxSize = null;
        if (fail === void 0) fail = true;
        try {
            for(var PROD_SYMBOLS_1 = $f68c054b32b5e406$var$__values($f68c054b32b5e406$export$8fe6f6a7cdb34756), PROD_SYMBOLS_1_1 = PROD_SYMBOLS_1.next(); !PROD_SYMBOLS_1_1.done; PROD_SYMBOLS_1_1 = PROD_SYMBOLS_1.next()){
                var symbol = PROD_SYMBOLS_1_1.value;
                if (shape === 1 /* FORCE_SQUARE */  && symbol.rectangular) continue;
                if (shape === 2 /* FORCE_RECTANGLE */  && !symbol.rectangular) continue;
                if (minSize != null && (symbol.getSymbolWidth() < minSize.getWidth() || symbol.getSymbolHeight() < minSize.getHeight())) continue;
                if (maxSize != null && (symbol.getSymbolWidth() > maxSize.getWidth() || symbol.getSymbolHeight() > maxSize.getHeight())) continue;
                if (dataCodewords <= symbol.dataCapacity) return symbol;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (PROD_SYMBOLS_1_1 && !PROD_SYMBOLS_1_1.done && (_a = PROD_SYMBOLS_1.return)) _a.call(PROD_SYMBOLS_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (fail) throw new Error("Can't find a symbol arrangement that matches the message. Data codewords: " + dataCodewords);
        return null;
    };
    SymbolInfo.prototype.getHorizontalDataRegions = function() {
        switch(this.dataRegions){
            case 1:
                return 1;
            case 2:
            case 4:
                return 2;
            case 16:
                return 4;
            case 36:
                return 6;
            default:
                throw new Error("Cannot handle this number of data regions");
        }
    };
    SymbolInfo.prototype.getVerticalDataRegions = function() {
        switch(this.dataRegions){
            case 1:
            case 2:
                return 1;
            case 4:
                return 2;
            case 16:
                return 4;
            case 36:
                return 6;
            default:
                throw new Error("Cannot handle this number of data regions");
        }
    };
    SymbolInfo.prototype.getSymbolDataWidth = function() {
        return this.getHorizontalDataRegions() * this.matrixWidth;
    };
    SymbolInfo.prototype.getSymbolDataHeight = function() {
        return this.getVerticalDataRegions() * this.matrixHeight;
    };
    SymbolInfo.prototype.getSymbolWidth = function() {
        return this.getSymbolDataWidth() + this.getHorizontalDataRegions() * 2;
    };
    SymbolInfo.prototype.getSymbolHeight = function() {
        return this.getSymbolDataHeight() + this.getVerticalDataRegions() * 2;
    };
    SymbolInfo.prototype.getCodewordCount = function() {
        return this.dataCapacity + this.errorCodewords;
    };
    SymbolInfo.prototype.getInterleavedBlockCount = function() {
        if (!this.rsBlockData) return 1;
        return this.dataCapacity / this.rsBlockData;
    };
    SymbolInfo.prototype.getDataCapacity = function() {
        return this.dataCapacity;
    };
    SymbolInfo.prototype.getErrorCodewords = function() {
        return this.errorCodewords;
    };
    SymbolInfo.prototype.getDataLengthForInterleavedBlock = function(index) {
        return this.rsBlockData;
    };
    SymbolInfo.prototype.getErrorLengthForInterleavedBlock = function(index) {
        return this.rsBlockError;
    };
    return SymbolInfo;
}();
var $f68c054b32b5e406$export$2e2bcd8739ae039 = $f68c054b32b5e406$var$SymbolInfo;
var $f68c054b32b5e406$var$DataMatrixSymbolInfo144 = /** @class */ function(_super) {
    $f68c054b32b5e406$var$__extends(DataMatrixSymbolInfo144, _super);
    function DataMatrixSymbolInfo144() {
        return _super.call(this, false, 1558, 620, 22, 22, 36, -1, 62) || this;
    }
    DataMatrixSymbolInfo144.prototype.getInterleavedBlockCount = function() {
        return 10;
    };
    DataMatrixSymbolInfo144.prototype.getDataLengthForInterleavedBlock = function(index) {
        return index <= 8 ? 156 : 155;
    };
    return DataMatrixSymbolInfo144;
}($f68c054b32b5e406$var$SymbolInfo);
var $f68c054b32b5e406$export$8fe6f6a7cdb34756 = [
    new $f68c054b32b5e406$var$SymbolInfo(false, 3, 5, 8, 8, 1),
    new $f68c054b32b5e406$var$SymbolInfo(false, 5, 7, 10, 10, 1),
    /*rect*/ new $f68c054b32b5e406$var$SymbolInfo(true, 5, 7, 16, 6, 1),
    new $f68c054b32b5e406$var$SymbolInfo(false, 8, 10, 12, 12, 1),
    /*rect*/ new $f68c054b32b5e406$var$SymbolInfo(true, 10, 11, 14, 6, 2),
    new $f68c054b32b5e406$var$SymbolInfo(false, 12, 12, 14, 14, 1),
    /*rect*/ new $f68c054b32b5e406$var$SymbolInfo(true, 16, 14, 24, 10, 1),
    new $f68c054b32b5e406$var$SymbolInfo(false, 18, 14, 16, 16, 1),
    new $f68c054b32b5e406$var$SymbolInfo(false, 22, 18, 18, 18, 1),
    /*rect*/ new $f68c054b32b5e406$var$SymbolInfo(true, 22, 18, 16, 10, 2),
    new $f68c054b32b5e406$var$SymbolInfo(false, 30, 20, 20, 20, 1),
    /*rect*/ new $f68c054b32b5e406$var$SymbolInfo(true, 32, 24, 16, 14, 2),
    new $f68c054b32b5e406$var$SymbolInfo(false, 36, 24, 22, 22, 1),
    new $f68c054b32b5e406$var$SymbolInfo(false, 44, 28, 24, 24, 1),
    /*rect*/ new $f68c054b32b5e406$var$SymbolInfo(true, 49, 28, 22, 14, 2),
    new $f68c054b32b5e406$var$SymbolInfo(false, 62, 36, 14, 14, 4),
    new $f68c054b32b5e406$var$SymbolInfo(false, 86, 42, 16, 16, 4),
    new $f68c054b32b5e406$var$SymbolInfo(false, 114, 48, 18, 18, 4),
    new $f68c054b32b5e406$var$SymbolInfo(false, 144, 56, 20, 20, 4),
    new $f68c054b32b5e406$var$SymbolInfo(false, 174, 68, 22, 22, 4),
    new $f68c054b32b5e406$var$SymbolInfo(false, 204, 84, 24, 24, 4, 102, 42),
    new $f68c054b32b5e406$var$SymbolInfo(false, 280, 112, 14, 14, 16, 140, 56),
    new $f68c054b32b5e406$var$SymbolInfo(false, 368, 144, 16, 16, 16, 92, 36),
    new $f68c054b32b5e406$var$SymbolInfo(false, 456, 192, 18, 18, 16, 114, 48),
    new $f68c054b32b5e406$var$SymbolInfo(false, 576, 224, 20, 20, 16, 144, 56),
    new $f68c054b32b5e406$var$SymbolInfo(false, 696, 272, 22, 22, 16, 174, 68),
    new $f68c054b32b5e406$var$SymbolInfo(false, 816, 336, 24, 24, 16, 136, 56),
    new $f68c054b32b5e406$var$SymbolInfo(false, 1050, 408, 18, 18, 36, 175, 68),
    new $f68c054b32b5e406$var$SymbolInfo(false, 1304, 496, 20, 20, 36, 163, 62),
    new $f68c054b32b5e406$var$DataMatrixSymbolInfo144()
];

});


parcelRegister("3iEu2", function(module, exports) {

$parcel$export(module.exports, "X12Encoder", () => $267274b7eb7f2574$export$b705e49a66db2d15);

var $7mB9T = parcelRequire("7mB9T");

var $6E9N1 = parcelRequire("6E9N1");

var $1bF01 = parcelRequire("1bF01");

var $h1LwC = parcelRequire("h1LwC");

var $1SukY = parcelRequire("1SukY");
var $267274b7eb7f2574$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $267274b7eb7f2574$export$b705e49a66db2d15 = /** @class */ function(_super) {
    $267274b7eb7f2574$var$__extends(X12Encoder, _super);
    function X12Encoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    X12Encoder.prototype.getEncodingMode = function() {
        return 0, $1SukY.X12_ENCODATION;
    };
    X12Encoder.prototype.encode = function(context) {
        // step C
        var buffer = new (0, $6E9N1.default)();
        while(context.hasMoreCharacters()){
            var c = context.getCurrentChar();
            context.pos++;
            this.encodeChar(c, buffer);
            var count = buffer.length();
            if (count % 3 === 0) {
                this.writeNextTriplet(context, buffer);
                var newMode = (0, $h1LwC.default).lookAheadTest(context.getMessage(), context.pos, this.getEncodingMode());
                if (newMode !== this.getEncodingMode()) {
                    // Return to ASCII encodation, which will actually handle latch to new mode
                    context.signalEncoderChange((0, $1SukY.ASCII_ENCODATION));
                    break;
                }
            }
        }
        this.handleEOD(context, buffer);
    };
    X12Encoder.prototype.encodeChar = function(c, sb) {
        switch(c){
            case 13:
                sb.append(0);
                break;
            case "*".charCodeAt(0):
                sb.append(1);
                break;
            case ">".charCodeAt(0):
                sb.append(2);
                break;
            case " ".charCodeAt(0):
                sb.append(3);
                break;
            default:
                if (c >= "0".charCodeAt(0) && c <= "9".charCodeAt(0)) sb.append(c - 48 + 4);
                else if (c >= "A".charCodeAt(0) && c <= "Z".charCodeAt(0)) sb.append(c - 65 + 14);
                else (0, $h1LwC.default).illegalCharacter((0, $7mB9T.default).getCharAt(c));
                break;
        }
        return 1;
    };
    X12Encoder.prototype.handleEOD = function(context, buffer) {
        context.updateSymbolInfo();
        var available = context.getSymbolInfo().getDataCapacity() - context.getCodewordCount();
        var count = buffer.length();
        context.pos -= count;
        if (context.getRemainingCharacters() > 1 || available > 1 || context.getRemainingCharacters() !== available) context.writeCodeword((0, $1SukY.X12_UNLATCH));
        if (context.getNewEncoding() < 0) context.signalEncoderChange((0, $1SukY.ASCII_ENCODATION));
    };
    return X12Encoder;
}((0, $1bF01.C40Encoder));

});

parcelRegister("2Qn2c", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", () => $21224e4691be085d$export$88fb0cfd153261a7);

var $1bF01 = parcelRequire("1bF01");

var $1SukY = parcelRequire("1SukY");
var $21224e4691be085d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $21224e4691be085d$export$88fb0cfd153261a7 = /** @class */ function(_super) {
    $21224e4691be085d$var$__extends(TextEncoder, _super);
    function TextEncoder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextEncoder.prototype.getEncodingMode = function() {
        return 0, $1SukY.TEXT_ENCODATION;
    };
    TextEncoder.prototype.encodeChar = function(c, sb) {
        if (c === " ".charCodeAt(0)) {
            sb.append(3);
            return 1;
        }
        if (c >= "0".charCodeAt(0) && c <= "9".charCodeAt(0)) {
            sb.append(c - 48 + 4);
            return 1;
        }
        if (c >= "a".charCodeAt(0) && c <= "z".charCodeAt(0)) {
            sb.append(c - 97 + 14);
            return 1;
        }
        if (c < " ".charCodeAt(0)) {
            sb.append(0); // Shift 1 Set
            sb.append(c);
            return 2;
        }
        if (c <= "/".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 33);
            return 2;
        }
        if (c <= "@".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 58 + 15);
            return 2;
        }
        if (c >= "[".charCodeAt(0) && c <= "_".charCodeAt(0)) {
            sb.append(1); // Shift 2 Set
            sb.append(c - 91 + 22);
            return 2;
        }
        if (c === "`".charCodeAt(0)) {
            sb.append(2); // Shift 3 Set
            sb.append(0); // '`' - 96 == 0
            return 2;
        }
        if (c <= "Z".charCodeAt(0)) {
            sb.append(2); // Shift 3 Set
            sb.append(c - 65 + 1);
            return 2;
        }
        if (c <= 127) {
            sb.append(2); // Shift 3 Set
            sb.append(c - 123 + 27);
            return 2;
        }
        sb.append("1\x1e"); // Shift 2, Upper Shift
        var len = 2;
        len += this.encodeChar(c - 128, sb);
        return len;
    };
    return TextEncoder;
}((0, $1bF01.C40Encoder));

});


parcelRegister("6T9tw", function(module, exports) {

var $bx5V3 = parcelRequire("bx5V3");

var $hzqel = parcelRequire("hzqel");

var $1NSRh = parcelRequire("1NSRh");

var $cvLRZ = parcelRequire("cvLRZ");

var $h9FI6 = parcelRequire("h9FI6");
parcelRequire("9NQdM");
var $gTiVc = parcelRequire("gTiVc");
var $eQbu2 = parcelRequire("eQbu2");
var $h1LwC = parcelRequire("h1LwC");
var $6443z = parcelRequire("6443z");
var $lamxU = parcelRequire("lamxU");
var $503f3ab3a0743a3f$var$DataMatrixWriter = /** @class */ function() {
    function DataMatrixWriter() {}
    DataMatrixWriter.prototype.encode = function(contents, format, width, height, hints) {
        if (hints === void 0) hints = null;
        if (contents.trim() === "") throw new Error("Found empty contents");
        if (format !== (0, $bx5V3.default).DATA_MATRIX) throw new Error("Can only encode DATA_MATRIX, but got " + format);
        if (width < 0 || height < 0) throw new Error("Requested dimensions can't be negative: " + width + "x" + height);
        // Try to get force shape & min / max size
        var shape = 0 /* FORCE_NONE */ ;
        var minSize = null;
        var maxSize = null;
        if (hints != null) {
            var requestedShape = hints.get((0, $1NSRh.default).DATA_MATRIX_SHAPE);
            if (requestedShape != null) shape = requestedShape;
            var requestedMinSize = hints.get((0, $1NSRh.default).MIN_SIZE);
            if (requestedMinSize != null) minSize = requestedMinSize;
            var requestedMaxSize = hints.get((0, $1NSRh.default).MAX_SIZE);
            if (requestedMaxSize != null) maxSize = requestedMaxSize;
        }
        // 1. step: Data encodation
        var encoded;
        var hasCompactionHint = hints != null && hints.has((0, $1NSRh.default).DATA_MATRIX_COMPACT) && Boolean(hints.get((0, $1NSRh.default).DATA_MATRIX_COMPACT).toString());
        if (hasCompactionHint) {
            var hasGS1FormatHint = hints.has((0, $1NSRh.default).GS1_FORMAT) && Boolean(hints.get((0, $1NSRh.default).GS1_FORMAT).toString());
            var charset = null;
            var hasEncodingHint = hints.has((0, $1NSRh.default).CHARACTER_SET);
            if (hasEncodingHint) charset = (0, $h9FI6.default).forName(hints.get((0, $1NSRh.default).CHARACTER_SET).toString());
            encoded = (0, $6443z.MinimalEncoder).encodeHighLevel(contents, charset, hasGS1FormatHint ? 0x1d : -1, shape);
        } else {
            var hasForceC40Hint = hints != null && hints.has((0, $1NSRh.default).FORCE_C40) && Boolean(hints.get((0, $1NSRh.default).FORCE_C40).toString());
            encoded = (0, $h1LwC.default).encodeHighLevel(contents, shape, minSize, maxSize, hasForceC40Hint);
        }
        var symbolInfo = (0, $lamxU.default).lookup(encoded.length, shape, minSize, maxSize, true);
        // 2. step: ECC generation
        var codewords = (0, $eQbu2.default).encodeECC200(encoded, symbolInfo);
        // 3. step: Module placement in Matrix
        var placement = new (0, $gTiVc.default)(codewords, symbolInfo.getSymbolDataWidth(), symbolInfo.getSymbolDataHeight());
        placement.place();
        // 4. step: low-level encoding
        return this.encodeLowLevel(placement, symbolInfo, width, height);
    };
    /**
     * Encode the given symbol info to a bit matrix.
     *
     * @param placement  The DataMatrix placement.
     * @param symbolInfo The symbol info to encode.
     * @return The bit matrix generated.
     */ DataMatrixWriter.prototype.encodeLowLevel = function(placement, symbolInfo, width, height) {
        var symbolWidth = symbolInfo.getSymbolDataWidth();
        var symbolHeight = symbolInfo.getSymbolDataHeight();
        var matrix = new (0, $cvLRZ.default)(symbolInfo.getSymbolWidth(), symbolInfo.getSymbolHeight());
        var matrixY = 0;
        for(var y = 0; y < symbolHeight; y++){
            // Fill the top edge with alternate 0 / 1
            var matrixX = void 0;
            if (y % symbolInfo.matrixHeight === 0) {
                matrixX = 0;
                for(var x = 0; x < symbolInfo.getSymbolWidth(); x++){
                    matrix.setBoolean(matrixX, matrixY, x % 2 === 0);
                    matrixX++;
                }
                matrixY++;
            }
            matrixX = 0;
            for(var x = 0; x < symbolWidth; x++){
                // Fill the right edge with full 1
                if (x % symbolInfo.matrixWidth === 0) {
                    matrix.setBoolean(matrixX, matrixY, true);
                    matrixX++;
                }
                matrix.setBoolean(matrixX, matrixY, placement.getBit(x, y));
                matrixX++;
                // Fill the right edge with alternate 0 / 1
                if (x % symbolInfo.matrixWidth === symbolInfo.matrixWidth - 1) {
                    matrix.setBoolean(matrixX, matrixY, y % 2 === 0);
                    matrixX++;
                }
            }
            matrixY++;
            // Fill the bottom edge with full 1
            if (y % symbolInfo.matrixHeight === symbolInfo.matrixHeight - 1) {
                matrixX = 0;
                for(var x = 0; x < symbolInfo.getSymbolWidth(); x++){
                    matrix.setBoolean(matrixX, matrixY, true);
                    matrixX++;
                }
                matrixY++;
            }
        }
        return this.convertByteMatrixToBitMatrix(matrix, width, height);
    };
    /**
     * Convert the ByteMatrix to BitMatrix.
     *
     * @param reqHeight The requested height of the image (in pixels) with the Datamatrix code
     * @param reqWidth The requested width of the image (in pixels) with the Datamatrix code
     * @param matrix The input matrix.
     * @return The output matrix.
     */ DataMatrixWriter.prototype.convertByteMatrixToBitMatrix = function(matrix, reqWidth, reqHeight) {
        var matrixWidth = matrix.getWidth();
        var matrixHeight = matrix.getHeight();
        var outputWidth = Math.max(reqWidth, matrixWidth);
        var outputHeight = Math.max(reqHeight, matrixHeight);
        var multiple = Math.min(outputWidth / matrixWidth, outputHeight / matrixHeight);
        var leftPadding = (outputWidth - matrixWidth * multiple) / 2;
        var topPadding = (outputHeight - matrixHeight * multiple) / 2;
        var output;
        // remove padding if requested width and height are too small
        if (reqHeight < matrixHeight || reqWidth < matrixWidth) {
            leftPadding = 0;
            topPadding = 0;
            output = new (0, $hzqel.default)(matrixWidth, matrixHeight);
        } else output = new (0, $hzqel.default)(reqWidth, reqHeight);
        output.clear();
        for(var inputY = 0, outputY = topPadding; inputY < matrixHeight; inputY++, outputY += multiple){
            // Write the contents of this row of the bytematrix
            for(var inputX = 0, outputX = leftPadding; inputX < matrixWidth; inputX++, outputX += multiple)if (matrix.get(inputX, inputY) === 1) output.setRegion(outputX, outputY, multiple, multiple);
        }
        return output;
    };
    return DataMatrixWriter;
}();
var $503f3ab3a0743a3f$export$2e2bcd8739ae039 = $503f3ab3a0743a3f$var$DataMatrixWriter;

});
parcelRegister("9NQdM", function(module, exports) {

$parcel$export(module.exports, "ErrorCorrection", () => (parcelRequire("eQbu2")).default);
$parcel$export(module.exports, "DefaultPlacement", () => (parcelRequire("gTiVc")).default);
$parcel$export(module.exports, "HighLevelEncoder", () => (parcelRequire("h1LwC")).default);
$parcel$export(module.exports, "MinimalEncoder", () => (parcelRequire("6443z")).MinimalEncoder);
$parcel$export(module.exports, "SymbolInfo", () => (parcelRequire("lamxU")).default);

var $cjIMN = parcelRequire("cjIMN");

var $auqnF = parcelRequire("auqnF");

var $1bF01 = parcelRequire("1bF01");

var $gTiVc = parcelRequire("gTiVc");

var $8QoNx = parcelRequire("8QoNx");

var $g79YU = parcelRequire("g79YU");

var $eQbu2 = parcelRequire("eQbu2");

var $h1LwC = parcelRequire("h1LwC");

var $6443z = parcelRequire("6443z");

var $lamxU = parcelRequire("lamxU");

var $2Qn2c = parcelRequire("2Qn2c");

var $3iEu2 = parcelRequire("3iEu2");

});
parcelRegister("6443z", function(module, exports) {

$parcel$export(module.exports, "MinimalEncoder", () => $46a6435f0d17eb65$export$c5f059be53a7e40d);

var $1SukY = parcelRequire("1SukY");

var $h1LwC = parcelRequire("h1LwC");

var $8c09Y = parcelRequire("8c09Y");

var $hcAg4 = parcelRequire("hcAg4");
var $46a6435f0d17eb65$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $46a6435f0d17eb65$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $46a6435f0d17eb65$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $46a6435f0d17eb65$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($46a6435f0d17eb65$var$__read(arguments[i]));
    return ar;
};
var $46a6435f0d17eb65$var$Mode;
(function(Mode) {
    Mode[Mode["ASCII"] = 0] = "ASCII";
    Mode[Mode["C40"] = 1] = "C40";
    Mode[Mode["TEXT"] = 2] = "TEXT";
    Mode[Mode["X12"] = 3] = "X12";
    Mode[Mode["EDF"] = 4] = "EDF";
    Mode[Mode["B256"] = 5] = "B256";
})($46a6435f0d17eb65$var$Mode || ($46a6435f0d17eb65$var$Mode = {}));
var $46a6435f0d17eb65$var$C40_SHIFT2_CHARS = [
    "!",
    '"',
    "#",
    "$",
    "%",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "[",
    "\\",
    "]",
    "^",
    "_"
];
var $46a6435f0d17eb65$export$c5f059be53a7e40d = /** @class */ function() {
    function MinimalEncoder() {}
    MinimalEncoder.isExtendedASCII = function(ch, fnc1) {
        return ch !== fnc1 && ch >= 128 && ch <= 255;
    };
    MinimalEncoder.isInC40Shift1Set = function(ch) {
        return ch <= 31;
    };
    MinimalEncoder.isInC40Shift2Set = function(ch, fnc1) {
        var e_1, _a;
        try {
            for(var C40_SHIFT2_CHARS_1 = $46a6435f0d17eb65$var$__values($46a6435f0d17eb65$var$C40_SHIFT2_CHARS), C40_SHIFT2_CHARS_1_1 = C40_SHIFT2_CHARS_1.next(); !C40_SHIFT2_CHARS_1_1.done; C40_SHIFT2_CHARS_1_1 = C40_SHIFT2_CHARS_1.next()){
                var c40Shift2Char = C40_SHIFT2_CHARS_1_1.value;
                if (c40Shift2Char.charCodeAt(0) === ch) return true;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (C40_SHIFT2_CHARS_1_1 && !C40_SHIFT2_CHARS_1_1.done && (_a = C40_SHIFT2_CHARS_1.return)) _a.call(C40_SHIFT2_CHARS_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return ch === fnc1;
    };
    MinimalEncoder.isInTextShift1Set = function(ch) {
        return this.isInC40Shift1Set(ch);
    };
    MinimalEncoder.isInTextShift2Set = function(ch, fnc1) {
        return this.isInC40Shift2Set(ch, fnc1);
    };
    /**
     * Performs message encoding of a DataMatrix message
     *
     * @param msg the message
     * @param priorityCharset The preferred {@link Charset}. When the value of the argument is null, the algorithm
     *   chooses charsets that leads to a minimal representation. Otherwise the algorithm will use the priority
     *   charset to encode any character in the input that can be encoded by it if the charset is among the
     *   supported charsets.
     * @param fnc1 denotes the character in the input that represents the FNC1 character or -1 if this is not a GS1
     *   bar code. If the value is not -1 then a FNC1 is also prepended.
     * @param shape requested shape.
     * @return the encoded message (the char values range from 0 to 255)
     */ MinimalEncoder.encodeHighLevel = function(msg, priorityCharset, fnc1, shape) {
        if (priorityCharset === void 0) priorityCharset = null;
        if (fnc1 === void 0) fnc1 = -1;
        if (shape === void 0) shape = 0 /* FORCE_NONE */ ;
        var macroId = 0;
        if (msg.startsWith((0, $1SukY.MACRO_05_HEADER)) && msg.endsWith((0, $1SukY.MACRO_TRAILER))) {
            macroId = 5;
            msg = msg.substring((0, $1SukY.MACRO_05_HEADER).length, msg.length - 2);
        } else if (msg.startsWith((0, $1SukY.MACRO_06_HEADER)) && msg.endsWith((0, $1SukY.MACRO_TRAILER))) {
            macroId = 6;
            msg = msg.substring((0, $1SukY.MACRO_06_HEADER).length, msg.length - 2);
        }
        return decodeURIComponent(escape(String.fromCharCode.apply(String, $46a6435f0d17eb65$var$__spread(this.encode(msg, priorityCharset, fnc1, shape, macroId)))));
    };
    /**
     * Encodes input minimally and returns an array of the codewords
     *
     * @param input The string to encode
     * @param priorityCharset The preferred {@link Charset}. When the value of the argument is null, the algorithm
     *   chooses charsets that leads to a minimal representation. Otherwise the algorithm will use the priority
     *   charset to encode any character in the input that can be encoded by it if the charset is among the
     *   supported charsets.
     * @param fnc1 denotes the character in the input that represents the FNC1 character or -1 if this is not a GS1
     *   bar code. If the value is not -1 then a FNC1 is also prepended.
     * @param shape requested shape.
     * @param macroId Prepends the specified macro function in case that a value of 5 or 6 is specified.
     * @return An array of bytes representing the codewords of a minimal encoding.
     */ MinimalEncoder.encode = function(input, priorityCharset, fnc1, shape, macroId) {
        return this.encodeMinimally(new $46a6435f0d17eb65$var$Input(input, priorityCharset, fnc1, shape, macroId)).getBytes();
    };
    MinimalEncoder.addEdge = function(edges, edge) {
        var vertexIndex = edge.fromPosition + edge.characterLength;
        if (edges[vertexIndex][edge.getEndMode()] === null || edges[vertexIndex][edge.getEndMode()].cachedTotalSize > edge.cachedTotalSize) edges[vertexIndex][edge.getEndMode()] = edge;
    };
    /** @return the number of words in which the string starting at from can be encoded in c40 or text mode.
     *  The number of characters encoded is returned in characterLength.
     *  The number of characters encoded is also minimal in the sense that the algorithm stops as soon
     *  as a character encoding fills a C40 word competely (three C40 values). An exception is at the
     *  end of the string where two C40 values are allowed (according to the spec the third c40 value
     *  is filled  with 0 (Shift 1) in this case).
     */ MinimalEncoder.getNumberOfC40Words = function(input, from, c40, characterLength) {
        var thirdsCount = 0;
        for(var i = from; i < input.length(); i++){
            if (input.isECI(i)) {
                characterLength[0] = 0;
                return 0;
            }
            var ci = input.charAt(i);
            if (c40 && (0, $h1LwC.default).isNativeC40(ci) || !c40 && (0, $h1LwC.default).isNativeText(ci)) thirdsCount++; // native
            else if (!MinimalEncoder.isExtendedASCII(ci, input.getFNC1Character())) thirdsCount += 2; // shift
            else {
                var asciiValue = ci & 0xff;
                if (asciiValue >= 128 && (c40 && (0, $h1LwC.default).isNativeC40(asciiValue - 128) || !c40 && (0, $h1LwC.default).isNativeText(asciiValue - 128))) thirdsCount += 3; // shift, Upper shift
                else thirdsCount += 4; // shift, Upper shift, shift
            }
            if (thirdsCount % 3 === 0 || (thirdsCount - 2) % 3 === 0 && i + 1 === input.length()) {
                characterLength[0] = i - from + 1;
                return Math.ceil(thirdsCount / 3.0);
            }
        }
        characterLength[0] = 0;
        return 0;
    };
    MinimalEncoder.addEdges = function(input, edges, from, previous) {
        var e_2, _a;
        if (input.isECI(from)) {
            this.addEdge(edges, new $46a6435f0d17eb65$var$Edge(input, $46a6435f0d17eb65$var$Mode.ASCII, from, 1, previous));
            return;
        }
        var ch = input.charAt(from);
        if (previous === null || previous.getEndMode() !== $46a6435f0d17eb65$var$Mode.EDF) {
            // not possible to unlatch a full EDF edge to something
            // else
            if ((0, $h1LwC.default).isDigit(ch) && input.haveNCharacters(from, 2) && (0, $h1LwC.default).isDigit(input.charAt(from + 1))) // two digits ASCII encoded
            this.addEdge(edges, new $46a6435f0d17eb65$var$Edge(input, $46a6435f0d17eb65$var$Mode.ASCII, from, 2, previous));
            else // one ASCII encoded character or an extended character via Upper Shift
            this.addEdge(edges, new $46a6435f0d17eb65$var$Edge(input, $46a6435f0d17eb65$var$Mode.ASCII, from, 1, previous));
            var modes = [
                $46a6435f0d17eb65$var$Mode.C40,
                $46a6435f0d17eb65$var$Mode.TEXT
            ];
            try {
                for(var modes_1 = $46a6435f0d17eb65$var$__values(modes), modes_1_1 = modes_1.next(); !modes_1_1.done; modes_1_1 = modes_1.next()){
                    var mode = modes_1_1.value;
                    var characterLength = [];
                    if (MinimalEncoder.getNumberOfC40Words(input, from, mode === $46a6435f0d17eb65$var$Mode.C40, characterLength) > 0) this.addEdge(edges, new $46a6435f0d17eb65$var$Edge(input, mode, from, characterLength[0], previous));
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (modes_1_1 && !modes_1_1.done && (_a = modes_1.return)) _a.call(modes_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            if (input.haveNCharacters(from, 3) && (0, $h1LwC.default).isNativeX12(input.charAt(from)) && (0, $h1LwC.default).isNativeX12(input.charAt(from + 1)) && (0, $h1LwC.default).isNativeX12(input.charAt(from + 2))) this.addEdge(edges, new $46a6435f0d17eb65$var$Edge(input, $46a6435f0d17eb65$var$Mode.X12, from, 3, previous));
            this.addEdge(edges, new $46a6435f0d17eb65$var$Edge(input, $46a6435f0d17eb65$var$Mode.B256, from, 1, previous));
        }
        // We create 4 EDF edges,  with 1, 2 3 or 4 characters length. The fourth normally doesn't have a latch to ASCII
        // unless it is 2 characters away from the end of the input.
        var i;
        for(i = 0; i < 3; i++){
            var pos = from + i;
            if (input.haveNCharacters(pos, 1) && (0, $h1LwC.default).isNativeEDIFACT(input.charAt(pos))) this.addEdge(edges, new $46a6435f0d17eb65$var$Edge(input, $46a6435f0d17eb65$var$Mode.EDF, from, i + 1, previous));
            else break;
        }
        if (i === 3 && input.haveNCharacters(from, 4) && (0, $h1LwC.default).isNativeEDIFACT(input.charAt(from + 3))) this.addEdge(edges, new $46a6435f0d17eb65$var$Edge(input, $46a6435f0d17eb65$var$Mode.EDF, from, 4, previous));
    };
    MinimalEncoder.encodeMinimally = function(input) {
        /* The minimal encoding is computed by Dijkstra. The acyclic graph is modeled as follows:
         * A vertex represents a combination of a position in the input and an encoding mode where position 0
         * denotes the position left of the first character, 1 the position left of the second character and so on.
         * Likewise the end vertices are located after the last character at position input.length().
         * For any position there might be up to six vertices, one for each of the encoding types ASCII, C40, TEXT, X12,
         * EDF and B256.
         *
         * As an example consider the input string "ABC123" then at position 0 there is only one vertex with the default
         * ASCII encodation. At position 3 there might be vertices for the types ASCII, C40, X12, EDF and B256.
         *
         * An edge leading to such a vertex encodes one or more of the characters left of the position that the vertex
         * represents. It encodes the characters in the encoding mode of the vertex that it ends on. In other words,
         * all edges leading to a particular vertex encode the same characters (the length of the suffix can vary) using the same
         * encoding mode.
         * As an example consider the input string "ABC123" and the vertex (4,EDF). Possible edges leading to this vertex
         * are:
         *   (0,ASCII)  --EDF(ABC1)--> (4,EDF)
         *   (1,ASCII)  --EDF(BC1)-->  (4,EDF)
         *   (1,B256)   --EDF(BC1)-->  (4,EDF)
         *   (1,EDF)    --EDF(BC1)-->  (4,EDF)
         *   (2,ASCII)  --EDF(C1)-->   (4,EDF)
         *   (2,B256)   --EDF(C1)-->   (4,EDF)
         *   (2,EDF)    --EDF(C1)-->   (4,EDF)
         *   (3,ASCII)  --EDF(1)-->    (4,EDF)
         *   (3,B256)   --EDF(1)-->    (4,EDF)
         *   (3,EDF)    --EDF(1)-->    (4,EDF)
         *   (3,C40)    --EDF(1)-->    (4,EDF)
         *   (3,X12)    --EDF(1)-->    (4,EDF)
         *
         * The edges leading to a vertex are stored in such a way that there is a fast way to enumerate the edges ending
         * on a particular vertex.
         *
         * The algorithm processes the vertices in order of their position thereby performing the following:
         *
         * For every vertex at position i the algorithm enumerates the edges ending on the vertex and removes all but the
         * shortest from that list.
         * Then it processes the vertices for the position i+1. If i+1 == input.length() then the algorithm ends
         * and chooses the the edge with the smallest size from any of the edges leading to vertices at this position.
         * Otherwise the algorithm computes all possible outgoing edges for the vertices at the position i+1
         *
         * Examples:
         * The process is illustrated by showing the graph (edges) after each iteration from left to right over the input:
         * An edge is drawn as follows "(" + fromVertex + ") -- " + encodingMode + "(" + encodedInput + ") (" +
         * accumulatedSize + ") --> (" + toVertex + ")"
         *
         * Example 1 encoding the string "ABCDEFG":
         *
         *
         * Situation after adding edges to the start vertex (0,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF)
         * (0,ASCII) C40(ABC) (3) --> (3,C40)
         * (0,ASCII) TEXT(ABC) (5) --> (3,TEXT)
         * (0,ASCII) X12(ABC) (3) --> (3,X12)
         * (0,ASCII) EDF(ABC) (4) --> (3,EDF)
         * (0,ASCII) EDF(ABCD) (4) --> (4,EDF)
         *
         * Situation after adding edges to vertices at position 1
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF)
         * (0,ASCII) C40(ABC) (3) --> (3,C40)
         * (0,ASCII) TEXT(ABC) (5) --> (3,TEXT)
         * (0,ASCII) X12(ABC) (3) --> (3,X12)
         * (0,ASCII) EDF(ABC) (4) --> (3,EDF)
         * (0,ASCII) EDF(ABCD) (4) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) B256(B) (4) --> (2,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BC) (5) --> (3,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) C40(BCD) (4) --> (4,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) TEXT(BCD) (6) --> (4,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) X12(BCD) (4) --> (4,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCD) (5) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCDE) (5) --> (5,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) ASCII(B) (4) --> (2,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BC) (6) --> (3,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) C40(BCD) (5) --> (4,C40)
         * (0,ASCII) B256(A) (3) --> (1,B256) TEXT(BCD) (7) --> (4,TEXT)
         * (0,ASCII) B256(A) (3) --> (1,B256) X12(BCD) (5) --> (4,X12)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BCD) (6) --> (4,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BCDE) (6) --> (5,EDF)
         *
         * Edge "(1,ASCII) ASCII(B) (2) --> (2,ASCII)" is minimal for the vertex (2,ASCII) so that edge "(1,B256) ASCII(B) (4) --> (2,ASCII)" is removed.
         * Edge "(1,B256) B256(B) (3) --> (2,B256)" is minimal for the vertext (2,B256) so that the edge "(1,ASCII) B256(B) (4) --> (2,B256)" is removed.
         *
         * Situation after adding edges to vertices at position 2
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF)
         * (0,ASCII) C40(ABC) (3) --> (3,C40)
         * (0,ASCII) TEXT(ABC) (5) --> (3,TEXT)
         * (0,ASCII) X12(ABC) (3) --> (3,X12)
         * (0,ASCII) EDF(ABC) (4) --> (3,EDF)
         * (0,ASCII) EDF(ABCD) (4) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BC) (5) --> (3,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) C40(BCD) (4) --> (4,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) TEXT(BCD) (6) --> (4,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) X12(BCD) (4) --> (4,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCD) (5) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCDE) (5) --> (5,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BC) (6) --> (3,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) C40(BCD) (5) --> (4,C40)
         * (0,ASCII) B256(A) (3) --> (1,B256) TEXT(BCD) (7) --> (4,TEXT)
         * (0,ASCII) B256(A) (3) --> (1,B256) X12(BCD) (5) --> (4,X12)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BCD) (6) --> (4,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) EDF(BCDE) (6) --> (5,EDF)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) ASCII(C) (5) --> (3,ASCII)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) B256(C) (6) --> (3,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) EDF(CD) (7) --> (4,EDF)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) C40(CDE) (6) --> (5,C40)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) TEXT(CDE) (8) --> (5,TEXT)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) X12(CDE) (6) --> (5,X12)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) EDF(CDE) (7) --> (5,EDF)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF) EDF(CDEF) (7) --> (6,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) B256(C) (5) --> (3,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) EDF(CD) (6) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) C40(CDE) (5) --> (5,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) TEXT(CDE) (7) --> (5,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) X12(CDE) (5) --> (5,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) EDF(CDE) (6) --> (5,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) EDF(CDEF) (6) --> (6,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) ASCII(C) (4) --> (3,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) EDF(CD) (6) --> (4,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) C40(CDE) (5) --> (5,C40)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) TEXT(CDE) (7) --> (5,TEXT)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) X12(CDE) (5) --> (5,X12)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) EDF(CDE) (6) --> (5,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) EDF(CDEF) (6) --> (6,EDF)
         *
         * Edge "(2,ASCII) ASCII(C) (3) --> (3,ASCII)" is minimal for the vertex (3,ASCII) so that edges "(2,EDF) ASCII(C) (5) --> (3,ASCII)"
         * and "(2,B256) ASCII(C) (4) --> (3,ASCII)" can be removed.
         * Edge "(0,ASCII) EDF(ABC) (4) --> (3,EDF)" is minimal for the vertex (3,EDF) so that edges "(1,ASCII) EDF(BC) (5) --> (3,EDF)"
         * and "(1,B256) EDF(BC) (6) --> (3,EDF)" can be removed.
         * Edge "(2,B256) B256(C) (4) --> (3,B256)" is minimal for the vertex (3,B256) so that edges "(2,ASCII) B256(C) (5) --> (3,B256)"
         * and "(2,EDF) B256(C) (6) --> (3,B256)" can be removed.
         *
         * This continues for vertices 3 thru 7
         *
         * Situation after adding edges to vertices at position 7
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256)
         * (0,ASCII) EDF(AB) (4) --> (2,EDF)
         * (0,ASCII) C40(ABC) (3) --> (3,C40)
         * (0,ASCII) TEXT(ABC) (5) --> (3,TEXT)
         * (0,ASCII) X12(ABC) (3) --> (3,X12)
         * (0,ASCII) EDF(ABC) (4) --> (3,EDF)
         * (0,ASCII) EDF(ABCD) (4) --> (4,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) C40(BCD) (4) --> (4,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) TEXT(BCD) (6) --> (4,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) X12(BCD) (4) --> (4,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) EDF(BCDE) (5) --> (5,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256)
         * (0,ASCII) C40(ABC) (3) --> (3,C40) C40(DEF) (5) --> (6,C40)
         * (0,ASCII) X12(ABC) (3) --> (3,X12) X12(DEF) (5) --> (6,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) C40(CDE) (5) --> (5,C40)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) TEXT(CDE) (7) --> (5,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) X12(CDE) (5) --> (5,X12)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) EDF(CDEF) (6) --> (6,EDF)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) C40(BCD) (4) --> (4,C40) C40(EFG) (6) --> (7,C40)    //Solution 1
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) X12(BCD) (4) --> (4,X12) X12(EFG) (6) --> (7,X12)    //Solution 2
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) TEXT(DEF) (8) --> (6,TEXT)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) EDF(DEFG) (7) --> (7,EDF)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256) B256(D) (5) --> (4,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII) ASCII(E) (5) --> (5,ASCII)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII) TEXT(EFG) (9) --> (7,TEXT)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256) B256(D) (5) --> (4,B256) B256(E) (6) --> (5,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII) ASCII(E) (5) --> (5,ASCII) ASCII(F) (6) --> (6,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256) B256(D) (5) --> (4,B256) B256(E) (6) --> (5,B256) B256(F) (7) --> (6,B256)
         * (0,ASCII) ASCII(A) (1) --> (1,ASCII) ASCII(B) (2) --> (2,ASCII) ASCII(C) (3) --> (3,ASCII) ASCII(D) (4) --> (4,ASCII) ASCII(E) (5) --> (5,ASCII) ASCII(F) (6) --> (6,ASCII) ASCII(G) (7) --> (7,ASCII)
         * (0,ASCII) B256(A) (3) --> (1,B256) B256(B) (3) --> (2,B256) B256(C) (4) --> (3,B256) B256(D) (5) --> (4,B256) B256(E) (6) --> (5,B256) B256(F) (7) --> (6,B256) B256(G) (8) --> (7,B256)
         *
         * Hence a minimal encoding of "ABCDEFG" is either ASCII(A),C40(BCDEFG) or ASCII(A), X12(BCDEFG) with a size of 5 bytes.
         */ var inputLength = input.length();
        // Array that represents vertices. There is a vertex for every character and mode.
        // The last dimension in the array below encodes the 6 modes ASCII, C40, TEXT, X12, EDF and B256
        var edges = Array(inputLength + 1).fill(null).map(function() {
            return Array(6).fill(0);
        });
        this.addEdges(input, edges, 0, null);
        for(var i = 1; i <= inputLength; i++){
            for(var j = 0; j < 6; j++)if (edges[i][j] !== null && i < inputLength) this.addEdges(input, edges, i, edges[i][j]);
            // optimize memory by removing edges that have been passed.
            for(var j = 0; j < 6; j++)edges[i - 1][j] = null;
        }
        var minimalJ = -1;
        var minimalSize = (0, $hcAg4.default).MAX_VALUE;
        for(var j = 0; j < 6; j++)if (edges[inputLength][j] !== null) {
            var edge = edges[inputLength][j];
            var size = j >= 1 && j <= 3 ? edge.cachedTotalSize + 1 : edge.cachedTotalSize; // C40, TEXT and X12 need an
            // extra unlatch at the end
            if (size < minimalSize) {
                minimalSize = size;
                minimalJ = j;
            }
        }
        if (minimalJ < 0) throw new Error('Failed to encode "' + input + '"');
        return new $46a6435f0d17eb65$var$Result(edges[inputLength][minimalJ]);
    };
    return MinimalEncoder;
}();
var $46a6435f0d17eb65$var$Result = /** @class */ function() {
    function Result(solution) {
        var input = solution.input;
        var size = 0;
        var bytesAL = [];
        var randomizePostfixLength = [];
        var randomizeLengths = [];
        if ((solution.mode === $46a6435f0d17eb65$var$Mode.C40 || solution.mode === $46a6435f0d17eb65$var$Mode.TEXT || solution.mode === $46a6435f0d17eb65$var$Mode.X12) && solution.getEndMode() !== $46a6435f0d17eb65$var$Mode.ASCII) size += this.prepend($46a6435f0d17eb65$var$Edge.getBytes(254), bytesAL);
        var current = solution;
        while(current !== null){
            size += this.prepend(current.getDataBytes(), bytesAL);
            if (current.previous === null || current.getPreviousStartMode() !== current.getMode()) {
                if (current.getMode() === $46a6435f0d17eb65$var$Mode.B256) {
                    if (size <= 249) {
                        bytesAL.unshift(size);
                        size++;
                    } else {
                        bytesAL.unshift(size % 250);
                        bytesAL.unshift(size / 250 + 249);
                        size += 2;
                    }
                    randomizePostfixLength.push(bytesAL.length);
                    randomizeLengths.push(size);
                }
                this.prepend(current.getLatchBytes(), bytesAL);
                size = 0;
            }
            current = current.previous;
        }
        if (input.getMacroId() === 5) size += this.prepend($46a6435f0d17eb65$var$Edge.getBytes(236), bytesAL);
        else if (input.getMacroId() === 6) size += this.prepend($46a6435f0d17eb65$var$Edge.getBytes(237), bytesAL);
        if (input.getFNC1Character() > 0) size += this.prepend($46a6435f0d17eb65$var$Edge.getBytes(232), bytesAL);
        for(var i = 0; i < randomizePostfixLength.length; i++)this.applyRandomPattern(bytesAL, bytesAL.length - randomizePostfixLength[i], randomizeLengths[i]);
        // add padding
        var capacity = solution.getMinSymbolSize(bytesAL.length);
        if (bytesAL.length < capacity) bytesAL.push(129);
        while(bytesAL.length < capacity)bytesAL.push(this.randomize253State(bytesAL.length + 1));
        this.bytes = new Uint8Array(bytesAL.length);
        for(var i = 0; i < this.bytes.length; i++)this.bytes[i] = bytesAL[i];
    }
    Result.prototype.prepend = function(bytes, into) {
        for(var i = bytes.length - 1; i >= 0; i--)into.unshift(bytes[i]);
        return bytes.length;
    };
    Result.prototype.randomize253State = function(codewordPosition) {
        var pseudoRandom = 149 * codewordPosition % 253 + 1;
        var tempVariable = 129 + pseudoRandom;
        return tempVariable <= 254 ? tempVariable : tempVariable - 254;
    };
    Result.prototype.applyRandomPattern = function(bytesAL, startPosition, length) {
        for(var i = 0; i < length; i++){
            // See "B.1 253-state algorithm
            var Pad_codeword_position = startPosition + i;
            var Pad_codeword_value = bytesAL[Pad_codeword_position] & 0xff;
            var pseudo_random_number = 149 * (Pad_codeword_position + 1) % 255 + 1;
            var temp_variable = Pad_codeword_value + pseudo_random_number;
            bytesAL[Pad_codeword_position] = temp_variable <= 255 ? temp_variable : temp_variable - 256;
        }
    };
    Result.prototype.getBytes = function() {
        return this.bytes;
    };
    return Result;
}();
var $46a6435f0d17eb65$var$Edge = /** @class */ function() {
    function Edge(input, mode, fromPosition, characterLength, previous) {
        this.input = input;
        this.mode = mode;
        this.fromPosition = fromPosition;
        this.characterLength = characterLength;
        this.previous = previous;
        this.allCodewordCapacities = [
            3,
            5,
            8,
            10,
            12,
            16,
            18,
            22,
            30,
            32,
            36,
            44,
            49,
            62,
            86,
            114,
            144,
            174,
            204,
            280,
            368,
            456,
            576,
            696,
            816,
            1050,
            1304,
            1558
        ];
        this.squareCodewordCapacities = [
            3,
            5,
            8,
            12,
            18,
            22,
            30,
            36,
            44,
            62,
            86,
            114,
            144,
            174,
            204,
            280,
            368,
            456,
            576,
            696,
            816,
            1050,
            1304,
            1558
        ];
        this.rectangularCodewordCapacities = [
            5,
            10,
            16,
            33,
            32,
            49
        ];
        if (!(fromPosition + characterLength <= input.length())) throw new Error("Invalid edge");
        var size = previous !== null ? previous.cachedTotalSize : 0;
        var previousMode = this.getPreviousMode();
        /*
         * Switching modes
         * ASCII -> C40: latch 230
         * ASCII -> TEXT: latch 239
         * ASCII -> X12: latch 238
         * ASCII -> EDF: latch 240
         * ASCII -> B256: latch 231
         * C40 -> ASCII: word(c1,c2,c3), 254
         * TEXT -> ASCII: word(c1,c2,c3), 254
         * X12 -> ASCII: word(c1,c2,c3), 254
         * EDIFACT -> ASCII: Unlatch character,0,0,0 or c1,Unlatch character,0,0 or c1,c2,Unlatch character,0 or
         * c1,c2,c3,Unlatch character
         * B256 -> ASCII: without latch after n bytes
         */ switch(mode){
            case $46a6435f0d17eb65$var$Mode.ASCII:
                size++;
                if (input.isECI(fromPosition) || $46a6435f0d17eb65$export$c5f059be53a7e40d.isExtendedASCII(input.charAt(fromPosition), input.getFNC1Character())) size++;
                if (previousMode === $46a6435f0d17eb65$var$Mode.C40 || previousMode === $46a6435f0d17eb65$var$Mode.TEXT || previousMode === $46a6435f0d17eb65$var$Mode.X12) size++; // unlatch 254 to ASCII
                break;
            case $46a6435f0d17eb65$var$Mode.B256:
                size++;
                if (previousMode !== $46a6435f0d17eb65$var$Mode.B256) size++; // byte count
                else if (this.getB256Size() === 250) size++; // extra byte count
                if (previousMode === $46a6435f0d17eb65$var$Mode.ASCII) size++; // latch to B256
                else if (previousMode === $46a6435f0d17eb65$var$Mode.C40 || previousMode === $46a6435f0d17eb65$var$Mode.TEXT || previousMode === $46a6435f0d17eb65$var$Mode.X12) size += 2; // unlatch to ASCII, latch to B256
                break;
            case $46a6435f0d17eb65$var$Mode.C40:
            case $46a6435f0d17eb65$var$Mode.TEXT:
            case $46a6435f0d17eb65$var$Mode.X12:
                if (mode === $46a6435f0d17eb65$var$Mode.X12) size += 2;
                else {
                    var charLen = [];
                    size += $46a6435f0d17eb65$export$c5f059be53a7e40d.getNumberOfC40Words(input, fromPosition, mode === $46a6435f0d17eb65$var$Mode.C40, charLen) * 2;
                }
                if (previousMode === $46a6435f0d17eb65$var$Mode.ASCII || previousMode === $46a6435f0d17eb65$var$Mode.B256) size++; // additional byte for latch from ASCII to this mode
                else if (previousMode !== mode && (previousMode === $46a6435f0d17eb65$var$Mode.C40 || previousMode === $46a6435f0d17eb65$var$Mode.TEXT || previousMode === $46a6435f0d17eb65$var$Mode.X12)) size += 2; // unlatch 254 to ASCII followed by latch to this mode
                break;
            case $46a6435f0d17eb65$var$Mode.EDF:
                size += 3;
                if (previousMode === $46a6435f0d17eb65$var$Mode.ASCII || previousMode === $46a6435f0d17eb65$var$Mode.B256) size++; // additional byte for latch from ASCII to this mode
                else if (previousMode === $46a6435f0d17eb65$var$Mode.C40 || previousMode === $46a6435f0d17eb65$var$Mode.TEXT || previousMode === $46a6435f0d17eb65$var$Mode.X12) size += 2; // unlatch 254 to ASCII followed by latch to this mode
                break;
        }
        this.cachedTotalSize = size;
    }
    // does not count beyond 250
    Edge.prototype.getB256Size = function() {
        var cnt = 0;
        var current = this;
        while(current !== null && current.mode === $46a6435f0d17eb65$var$Mode.B256 && cnt <= 250){
            cnt++;
            current = current.previous;
        }
        return cnt;
    };
    Edge.prototype.getPreviousStartMode = function() {
        return this.previous === null ? $46a6435f0d17eb65$var$Mode.ASCII : this.previous.mode;
    };
    Edge.prototype.getPreviousMode = function() {
        return this.previous === null ? $46a6435f0d17eb65$var$Mode.ASCII : this.previous.getEndMode();
    };
    /** Returns Mode.ASCII in case that:
     *  - Mode is EDIFACT and characterLength is less than 4 or the remaining characters can be encoded in at most 2
     *    ASCII bytes.
     *  - Mode is C40, TEXT or X12 and the remaining characters can be encoded in at most 1 ASCII byte.
     *  Returns mode in all other cases.
     * */ Edge.prototype.getEndMode = function() {
        if (this.mode === $46a6435f0d17eb65$var$Mode.EDF) {
            if (this.characterLength < 4) return $46a6435f0d17eb65$var$Mode.ASCII;
            var lastASCII = this.getLastASCII(); // see 5.2.8.2 EDIFACT encodation Rules
            if (lastASCII > 0 && this.getCodewordsRemaining(this.cachedTotalSize + lastASCII) <= 2 - lastASCII) return $46a6435f0d17eb65$var$Mode.ASCII;
        }
        if (this.mode === $46a6435f0d17eb65$var$Mode.C40 || this.mode === $46a6435f0d17eb65$var$Mode.TEXT || this.mode === $46a6435f0d17eb65$var$Mode.X12) {
            // see 5.2.5.2 C40 encodation rules and 5.2.7.2 ANSI X12 encodation rules
            if (this.fromPosition + this.characterLength >= this.input.length() && this.getCodewordsRemaining(this.cachedTotalSize) === 0) return $46a6435f0d17eb65$var$Mode.ASCII;
            var lastASCII = this.getLastASCII();
            if (lastASCII === 1 && this.getCodewordsRemaining(this.cachedTotalSize + 1) === 0) return $46a6435f0d17eb65$var$Mode.ASCII;
        }
        return this.mode;
    };
    Edge.prototype.getMode = function() {
        return this.mode;
    };
    /** Peeks ahead and returns 1 if the postfix consists of exactly two digits, 2 if the postfix consists of exactly
     *  two consecutive digits and a non extended character or of 4 digits.
     *  Returns 0 in any other case
     **/ Edge.prototype.getLastASCII = function() {
        var length = this.input.length();
        var from = this.fromPosition + this.characterLength;
        if (length - from > 4 || from >= length) return 0;
        if (length - from === 1) {
            if ($46a6435f0d17eb65$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from), this.input.getFNC1Character())) return 0;
            return 1;
        }
        if (length - from === 2) {
            if ($46a6435f0d17eb65$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from), this.input.getFNC1Character()) || $46a6435f0d17eb65$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from + 1), this.input.getFNC1Character())) return 0;
            if ((0, $h1LwC.default).isDigit(this.input.charAt(from)) && (0, $h1LwC.default).isDigit(this.input.charAt(from + 1))) return 1;
            return 2;
        }
        if (length - from === 3) {
            if ((0, $h1LwC.default).isDigit(this.input.charAt(from)) && (0, $h1LwC.default).isDigit(this.input.charAt(from + 1)) && !$46a6435f0d17eb65$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from + 2), this.input.getFNC1Character())) return 2;
            if ((0, $h1LwC.default).isDigit(this.input.charAt(from + 1)) && (0, $h1LwC.default).isDigit(this.input.charAt(from + 2)) && !$46a6435f0d17eb65$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(from), this.input.getFNC1Character())) return 2;
            return 0;
        }
        if ((0, $h1LwC.default).isDigit(this.input.charAt(from)) && (0, $h1LwC.default).isDigit(this.input.charAt(from + 1)) && (0, $h1LwC.default).isDigit(this.input.charAt(from + 2)) && (0, $h1LwC.default).isDigit(this.input.charAt(from + 3))) return 2;
        return 0;
    };
    /** Returns the capacity in codewords of the smallest symbol that has enough capacity to fit the given minimal
     * number of codewords.
     **/ Edge.prototype.getMinSymbolSize = function(minimum) {
        var e_3, _a, e_4, _b, e_5, _c;
        switch(this.input.getShapeHint()){
            case 1 /* FORCE_SQUARE */ :
                try {
                    for(var _d = $46a6435f0d17eb65$var$__values(this.squareCodewordCapacities), _e = _d.next(); !_e.done; _e = _d.next()){
                        var capacity = _e.value;
                        if (capacity >= minimum) return capacity;
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
                break;
            case 2 /* FORCE_RECTANGLE */ :
                try {
                    for(var _f = $46a6435f0d17eb65$var$__values(this.rectangularCodewordCapacities), _g = _f.next(); !_g.done; _g = _f.next()){
                        var capacity = _g.value;
                        if (capacity >= minimum) return capacity;
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
                break;
        }
        try {
            for(var _h = $46a6435f0d17eb65$var$__values(this.allCodewordCapacities), _j = _h.next(); !_j.done; _j = _h.next()){
                var capacity = _j.value;
                if (capacity >= minimum) return capacity;
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        return this.allCodewordCapacities[this.allCodewordCapacities.length - 1];
    };
    /** Returns the remaining capacity in codewords of the smallest symbol that has enough capacity to fit the given
     * minimal number of codewords.
     **/ Edge.prototype.getCodewordsRemaining = function(minimum) {
        return this.getMinSymbolSize(minimum) - minimum;
    };
    Edge.getBytes = function(c1, c2) {
        var result = new Uint8Array(c2 ? 2 : 1);
        result[0] = c1;
        if (c2) result[1] = c2;
        return result;
    };
    Edge.prototype.setC40Word = function(bytes, offset, c1, c2, c3) {
        var val16 = 1600 * (c1 & 0xff) + 40 * (c2 & 0xff) + (c3 & 0xff) + 1;
        bytes[offset] = val16 / 256;
        bytes[offset + 1] = val16 % 256;
    };
    Edge.prototype.getX12Value = function(c) {
        return c === 13 ? 0 : c === 42 ? 1 : c === 62 ? 2 : c === 32 ? 3 : c >= 48 && c <= 57 ? c - 44 : c >= 65 && c <= 90 ? c - 51 : c;
    };
    Edge.prototype.getX12Words = function() {
        if (!(this.characterLength % 3 === 0)) throw new Error("X12 words must be a multiple of 3");
        var result = new Uint8Array(this.characterLength / 3 * 2);
        for(var i = 0; i < result.length; i += 2)this.setC40Word(result, i, this.getX12Value(this.input.charAt(this.fromPosition + i / 2 * 3)), this.getX12Value(this.input.charAt(this.fromPosition + i / 2 * 3 + 1)), this.getX12Value(this.input.charAt(this.fromPosition + i / 2 * 3 + 2)));
        return result;
    };
    Edge.prototype.getShiftValue = function(c, c40, fnc1) {
        return c40 && $46a6435f0d17eb65$export$c5f059be53a7e40d.isInC40Shift1Set(c) || !c40 && $46a6435f0d17eb65$export$c5f059be53a7e40d.isInTextShift1Set(c) ? 0 : c40 && $46a6435f0d17eb65$export$c5f059be53a7e40d.isInC40Shift2Set(c, fnc1) || !c40 && $46a6435f0d17eb65$export$c5f059be53a7e40d.isInTextShift2Set(c, fnc1) ? 1 : 2;
    };
    Edge.prototype.getC40Value = function(c40, setIndex, c, fnc1) {
        if (c === fnc1) {
            if (!(setIndex === 2)) throw new Error("FNC1 cannot be used in C40 shift 2");
            return 27;
        }
        if (c40) return c <= 31 ? c : c === 32 ? 3 : c <= 47 ? c - 33 : c <= 57 ? c - 44 : c <= 64 ? c - 43 : c <= 90 ? c - 51 : c <= 95 ? c - 69 : c <= 127 ? c - 96 : c;
        else return c === 0 ? 0 : setIndex === 0 && c <= 3 ? c - 1 // is this a bug in the spec?
         : setIndex === 1 && c <= 31 ? c : c === 32 ? 3 : c >= 33 && c <= 47 ? c - 33 : c >= 48 && c <= 57 ? c - 44 : c >= 58 && c <= 64 ? c - 43 : c >= 65 && c <= 90 ? c - 64 : c >= 91 && c <= 95 ? c - 69 : c === 96 ? 0 : c >= 97 && c <= 122 ? c - 83 : c >= 123 && c <= 127 ? c - 96 : c;
    };
    Edge.prototype.getC40Words = function(c40, fnc1) {
        var c40Values = [];
        for(var i = 0; i < this.characterLength; i++){
            var ci = this.input.charAt(this.fromPosition + i);
            if (c40 && (0, $h1LwC.default).isNativeC40(ci) || !c40 && (0, $h1LwC.default).isNativeText(ci)) c40Values.push(this.getC40Value(c40, 0, ci, fnc1));
            else if (!$46a6435f0d17eb65$export$c5f059be53a7e40d.isExtendedASCII(ci, fnc1)) {
                var shiftValue = this.getShiftValue(ci, c40, fnc1);
                c40Values.push(shiftValue); // Shift[123]
                c40Values.push(this.getC40Value(c40, shiftValue, ci, fnc1));
            } else {
                var asciiValue = (ci & 0xff) - 128;
                if (c40 && (0, $h1LwC.default).isNativeC40(asciiValue) || !c40 && (0, $h1LwC.default).isNativeText(asciiValue)) {
                    c40Values.push(1); // Shift 2
                    c40Values.push(30); // Upper Shift
                    c40Values.push(this.getC40Value(c40, 0, asciiValue, fnc1));
                } else {
                    c40Values.push(1); // Shift 2
                    c40Values.push(30); // Upper Shift
                    var shiftValue = this.getShiftValue(asciiValue, c40, fnc1);
                    c40Values.push(shiftValue); // Shift[123]
                    c40Values.push(this.getC40Value(c40, shiftValue, asciiValue, fnc1));
                }
            }
        }
        if (c40Values.length % 3 !== 0) {
            if (!((c40Values.length - 2) % 3 === 0 && this.fromPosition + this.characterLength === this.input.length())) throw new Error("C40 words must be a multiple of 3");
            c40Values.push(0); // pad with 0 (Shift 1)
        }
        var result = new Uint8Array(c40Values.length / 3 * 2);
        var byteIndex = 0;
        for(var i = 0; i < c40Values.length; i += 3){
            this.setC40Word(result, byteIndex, c40Values[i] & 0xff, c40Values[i + 1] & 0xff, c40Values[i + 2] & 0xff);
            byteIndex += 2;
        }
        return result;
    };
    Edge.prototype.getEDFBytes = function() {
        var numberOfThirds = Math.ceil(this.characterLength / 4.0);
        var result = new Uint8Array(numberOfThirds * 3);
        var pos = this.fromPosition;
        var endPos = Math.min(this.fromPosition + this.characterLength - 1, this.input.length() - 1);
        for(var i = 0; i < numberOfThirds; i += 3){
            var edfValues = [];
            for(var j = 0; j < 4; j++)if (pos <= endPos) edfValues[j] = this.input.charAt(pos++) & 0x3f;
            else edfValues[j] = pos === endPos + 1 ? 0x1f : 0;
            var val24 = edfValues[0] << 18;
            val24 |= edfValues[1] << 12;
            val24 |= edfValues[2] << 6;
            val24 |= edfValues[3];
            result[i] = val24 >> 16 & 0xff;
            result[i + 1] = val24 >> 8 & 0xff;
            result[i + 2] = val24 & 0xff;
        }
        return result;
    };
    Edge.prototype.getLatchBytes = function() {
        switch(this.getPreviousMode()){
            case $46a6435f0d17eb65$var$Mode.ASCII:
            case $46a6435f0d17eb65$var$Mode.B256:
                switch(this.mode){
                    case $46a6435f0d17eb65$var$Mode.B256:
                        return Edge.getBytes(231);
                    case $46a6435f0d17eb65$var$Mode.C40:
                        return Edge.getBytes(230);
                    case $46a6435f0d17eb65$var$Mode.TEXT:
                        return Edge.getBytes(239);
                    case $46a6435f0d17eb65$var$Mode.X12:
                        return Edge.getBytes(238);
                    case $46a6435f0d17eb65$var$Mode.EDF:
                        return Edge.getBytes(240);
                }
                break;
            case $46a6435f0d17eb65$var$Mode.C40:
            case $46a6435f0d17eb65$var$Mode.TEXT:
            case $46a6435f0d17eb65$var$Mode.X12:
                if (this.mode !== this.getPreviousMode()) switch(this.mode){
                    case $46a6435f0d17eb65$var$Mode.ASCII:
                        return Edge.getBytes(254);
                    case $46a6435f0d17eb65$var$Mode.B256:
                        return Edge.getBytes(254, 231);
                    case $46a6435f0d17eb65$var$Mode.C40:
                        return Edge.getBytes(254, 230);
                    case $46a6435f0d17eb65$var$Mode.TEXT:
                        return Edge.getBytes(254, 239);
                    case $46a6435f0d17eb65$var$Mode.X12:
                        return Edge.getBytes(254, 238);
                    case $46a6435f0d17eb65$var$Mode.EDF:
                        return Edge.getBytes(254, 240);
                }
                break;
            case $46a6435f0d17eb65$var$Mode.EDF:
                // The rightmost EDIFACT edge always contains an unlatch character
                if (this.mode !== $46a6435f0d17eb65$var$Mode.EDF) throw new Error("Cannot switch from EDF to " + this.mode);
                break;
        }
        return new Uint8Array(0);
    };
    // Important: The function does not return the length bytes (one or two) in case of B256 encoding
    Edge.prototype.getDataBytes = function() {
        switch(this.mode){
            case $46a6435f0d17eb65$var$Mode.ASCII:
                if (this.input.isECI(this.fromPosition)) return Edge.getBytes(241, this.input.getECIValue(this.fromPosition) + 1);
                else if ($46a6435f0d17eb65$export$c5f059be53a7e40d.isExtendedASCII(this.input.charAt(this.fromPosition), this.input.getFNC1Character())) return Edge.getBytes(235, this.input.charAt(this.fromPosition) - 127);
                else if (this.characterLength === 2) return Edge.getBytes(this.input.charAt(this.fromPosition) * 10 + this.input.charAt(this.fromPosition + 1) + 130);
                else if (this.input.isFNC1(this.fromPosition)) return Edge.getBytes(232);
                else return Edge.getBytes(this.input.charAt(this.fromPosition) + 1);
            case $46a6435f0d17eb65$var$Mode.B256:
                return Edge.getBytes(this.input.charAt(this.fromPosition));
            case $46a6435f0d17eb65$var$Mode.C40:
                return this.getC40Words(true, this.input.getFNC1Character());
            case $46a6435f0d17eb65$var$Mode.TEXT:
                return this.getC40Words(false, this.input.getFNC1Character());
            case $46a6435f0d17eb65$var$Mode.X12:
                return this.getX12Words();
            case $46a6435f0d17eb65$var$Mode.EDF:
                return this.getEDFBytes();
        }
    };
    return Edge;
}();
var $46a6435f0d17eb65$var$Input = /** @class */ function(_super) {
    $46a6435f0d17eb65$var$__extends(Input, _super);
    function Input(stringToEncode, priorityCharset, fnc1, shape, macroId) {
        var _this = _super.call(this, stringToEncode, priorityCharset, fnc1) || this;
        _this.shape = shape;
        _this.macroId = macroId;
        return _this;
    }
    Input.prototype.getMacroId = function() {
        return this.macroId;
    };
    Input.prototype.getShapeHint = function() {
        return this.shape;
    };
    return Input;
}((0, $8c09Y.MinimalECIInput));

});
parcelRegister("8c09Y", function(module, exports) {

$parcel$export(module.exports, "MinimalECIInput", () => $5f6f9175cd7a1057$export$196399f5a83a42b6);

var $jYYhL = parcelRequire("jYYhL");

var $hcAg4 = parcelRequire("hcAg4");

var $6E9N1 = parcelRequire("6E9N1");
var $5f6f9175cd7a1057$var$COST_PER_ECI = 3; // approximated (latch + 2 codewords)
var $5f6f9175cd7a1057$export$196399f5a83a42b6 = /** @class */ function() {
    /**
     * Constructs a minimal input
     *
     * @param stringToEncode the character string to encode
     * @param priorityCharset The preferred {@link Charset}. When the value of the argument is null, the algorithm
     *   chooses charsets that leads to a minimal representation. Otherwise the algorithm will use the priority
     *   charset to encode any character in the input that can be encoded by it if the charset is among the
     *   supported charsets.
     * @param fnc1 denotes the character in the input that represents the FNC1 character or -1 if this is not GS1
     *   input.
     */ function MinimalECIInput(stringToEncode, priorityCharset, fnc1) {
        this.fnc1 = fnc1;
        var encoderSet = new (0, $jYYhL.ECIEncoderSet)(stringToEncode, priorityCharset, fnc1);
        if (encoderSet.length() === 1) // optimization for the case when all can be encoded without ECI in ISO-8859-1
        for(var i = 0; i < this.bytes.length; i++){
            var c = stringToEncode.charAt(i).charCodeAt(0);
            this.bytes[i] = c === fnc1 ? 1000 : c;
        }
        else this.bytes = this.encodeMinimally(stringToEncode, encoderSet, fnc1);
    }
    MinimalECIInput.prototype.getFNC1Character = function() {
        return this.fnc1;
    };
    /**
     * Returns the length of this input.  The length is the number
     * of {@code byte}s, FNC1 characters or ECIs in the sequence.
     *
     * @return  the number of {@code char}s in this sequence
     */ MinimalECIInput.prototype.length = function() {
        return this.bytes.length;
    };
    MinimalECIInput.prototype.haveNCharacters = function(index, n) {
        if (index + n - 1 >= this.bytes.length) return false;
        for(var i = 0; i < n; i++){
            if (this.isECI(index + i)) return false;
        }
        return true;
    };
    /**
     * Returns the {@code byte} value at the specified index.  An index ranges from zero
     * to {@code length() - 1}.  The first {@code byte} value of the sequence is at
     * index zero, the next at index one, and so on, as for array
     * indexing.
     *
     * @param   index the index of the {@code byte} value to be returned
     *
     * @return  the specified {@code byte} value as character or the FNC1 character
     *
     * @throws  IndexOutOfBoundsException
     *          if the {@code index} argument is negative or not less than
     *          {@code length()}
     * @throws  IllegalArgumentException
     *          if the value at the {@code index} argument is an ECI (@see #isECI)
     */ MinimalECIInput.prototype.charAt = function(index) {
        if (index < 0 || index >= this.length()) throw new Error("" + index);
        if (this.isECI(index)) throw new Error("value at " + index + " is not a character but an ECI");
        return this.isFNC1(index) ? this.fnc1 : this.bytes[index];
    };
    /**
     * Returns a {@code CharSequence} that is a subsequence of this sequence.
     * The subsequence starts with the {@code char} value at the specified index and
     * ends with the {@code char} value at index {@code end - 1}.  The length
     * (in {@code char}s) of the
     * returned sequence is {@code end - start}, so if {@code start == end}
     * then an empty sequence is returned.
     *
     * @param   start   the start index, inclusive
     * @param   end     the end index, exclusive
     *
     * @return  the specified subsequence
     *
     * @throws  IndexOutOfBoundsException
     *          if {@code start} or {@code end} are negative,
     *          if {@code end} is greater than {@code length()},
     *          or if {@code start} is greater than {@code end}
     * @throws  IllegalArgumentException
     *          if a value in the range {@code start}-{@code end} is an ECI (@see #isECI)
     */ MinimalECIInput.prototype.subSequence = function(start, end) {
        if (start < 0 || start > end || end > this.length()) throw new Error("" + start);
        var result = new (0, $6E9N1.default)();
        for(var i = start; i < end; i++){
            if (this.isECI(i)) throw new Error("value at " + i + " is not a character but an ECI");
            result.append(this.charAt(i));
        }
        return result.toString();
    };
    /**
     * Determines if a value is an ECI
     *
     * @param   index the index of the value
     *
     * @return  true if the value at position {@code index} is an ECI
     *
     * @throws  IndexOutOfBoundsException
     *          if the {@code index} argument is negative or not less than
     *          {@code length()}
     */ MinimalECIInput.prototype.isECI = function(index) {
        if (index < 0 || index >= this.length()) throw new Error("" + index);
        return this.bytes[index] > 255 && this.bytes[index] <= 999;
    };
    /**
     * Determines if a value is the FNC1 character
     *
     * @param   index the index of the value
     *
     * @return  true if the value at position {@code index} is the FNC1 character
     *
     * @throws  IndexOutOfBoundsException
     *          if the {@code index} argument is negative or not less than
     *          {@code length()}
     */ MinimalECIInput.prototype.isFNC1 = function(index) {
        if (index < 0 || index >= this.length()) throw new Error("" + index);
        return this.bytes[index] === 1000;
    };
    /**
     * Returns the {@code int} ECI value at the specified index.  An index ranges from zero
     * to {@code length() - 1}.  The first {@code byte} value of the sequence is at
     * index zero, the next at index one, and so on, as for array
     * indexing.
     *
     * @param   index the index of the {@code int} value to be returned
     *
     * @return  the specified {@code int} ECI value.
     *          The ECI specified the encoding of all bytes with a higher index until the
     *          next ECI or until the end of the input if no other ECI follows.
     *
     * @throws  IndexOutOfBoundsException
     *          if the {@code index} argument is negative or not less than
     *          {@code length()}
     * @throws  IllegalArgumentException
     *          if the value at the {@code index} argument is not an ECI (@see #isECI)
     */ MinimalECIInput.prototype.getECIValue = function(index) {
        if (index < 0 || index >= this.length()) throw new Error("" + index);
        if (!this.isECI(index)) throw new Error("value at " + index + " is not an ECI but a character");
        return this.bytes[index] - 256;
    };
    MinimalECIInput.prototype.addEdge = function(edges, to, edge) {
        if (edges[to][edge.encoderIndex] == null || edges[to][edge.encoderIndex].cachedTotalSize > edge.cachedTotalSize) edges[to][edge.encoderIndex] = edge;
    };
    MinimalECIInput.prototype.addEdges = function(stringToEncode, encoderSet, edges, from, previous, fnc1) {
        var ch = stringToEncode.charAt(from).charCodeAt(0);
        var start = 0;
        var end = encoderSet.length();
        if (encoderSet.getPriorityEncoderIndex() >= 0 && (ch === fnc1 || encoderSet.canEncode(ch, encoderSet.getPriorityEncoderIndex()))) {
            start = encoderSet.getPriorityEncoderIndex();
            end = start + 1;
        }
        for(var i = start; i < end; i++)if (ch === fnc1 || encoderSet.canEncode(ch, i)) this.addEdge(edges, from + 1, new $5f6f9175cd7a1057$var$InputEdge(ch, encoderSet, i, previous, fnc1));
    };
    MinimalECIInput.prototype.encodeMinimally = function(stringToEncode, encoderSet, fnc1) {
        var inputLength = stringToEncode.length;
        // Array that represents vertices. There is a vertex for every character and encoding.
        var edges = new $5f6f9175cd7a1057$var$InputEdge[inputLength + 1][encoderSet.length()]();
        this.addEdges(stringToEncode, encoderSet, edges, 0, null, fnc1);
        for(var i = 1; i <= inputLength; i++){
            for(var j = 0; j < encoderSet.length(); j++)if (edges[i][j] != null && i < inputLength) this.addEdges(stringToEncode, encoderSet, edges, i, edges[i][j], fnc1);
            // optimize memory by removing edges that have been passed.
            for(var j = 0; j < encoderSet.length(); j++)edges[i - 1][j] = null;
        }
        var minimalJ = -1;
        var minimalSize = (0, $hcAg4.default).MAX_VALUE;
        for(var j = 0; j < encoderSet.length(); j++)if (edges[inputLength][j] != null) {
            var edge = edges[inputLength][j];
            if (edge.cachedTotalSize < minimalSize) {
                minimalSize = edge.cachedTotalSize;
                minimalJ = j;
            }
        }
        if (minimalJ < 0) throw new Error('Failed to encode "' + stringToEncode + '"');
        var intsAL = [];
        var current = edges[inputLength][minimalJ];
        while(current != null){
            if (current.isFNC1()) intsAL.unshift(1000);
            else {
                var bytes = encoderSet.encode(current.c, current.encoderIndex);
                for(var i = bytes.length - 1; i >= 0; i--)intsAL.unshift(bytes[i] & 0xff);
            }
            var previousEncoderIndex = current.previous === null ? 0 : current.previous.encoderIndex;
            if (previousEncoderIndex !== current.encoderIndex) intsAL.unshift(256 + encoderSet.getECIValue(current.encoderIndex));
            current = current.previous;
        }
        var ints = [];
        for(var i = 0; i < ints.length; i++)ints[i] = intsAL[i];
        return ints;
    };
    return MinimalECIInput;
}();
var $5f6f9175cd7a1057$var$InputEdge = /** @class */ function() {
    function InputEdge(c, encoderSet, encoderIndex, previous, fnc1) {
        this.c = c;
        this.encoderSet = encoderSet;
        this.encoderIndex = encoderIndex;
        this.previous = previous;
        this.fnc1 = fnc1;
        this.c = c === fnc1 ? 1000 : c;
        var size = this.isFNC1() ? 1 : encoderSet.encode(c, encoderIndex).length;
        var previousEncoderIndex = previous === null ? 0 : previous.encoderIndex;
        if (previousEncoderIndex !== encoderIndex) size += $5f6f9175cd7a1057$var$COST_PER_ECI;
        if (previous != null) size += previous.cachedTotalSize;
        this.cachedTotalSize = size;
    }
    InputEdge.prototype.isFNC1 = function() {
        return this.c === 1000;
    };
    return InputEdge;
}();

});
parcelRegister("jYYhL", function(module, exports) {

$parcel$export(module.exports, "ECIEncoderSet", () => $e8c262575bd29ba4$export$b5aa35b60608d324);
/**
 * Set of CharsetEncoders for a given input string
 *
 * Invariants:
 * - The list contains only encoders from CharacterSetECI (list is shorter then the list of encoders available on
 *   the platform for which ECI values are defined).
 * - The list contains encoders at least one encoder for every character in the input.
 * - The first encoder in the list is always the ISO-8859-1 encoder even of no character in the input can be encoded
 *       by it.
 * - If the input contains a character that is not in ISO-8859-1 then the last two entries in the list will be the
 *   UTF-8 encoder and the UTF-16BE encoder.
 *
 * @author Alex Geller
 */ 
var $h9FI6 = parcelRequire("h9FI6");

var $7QoZg = parcelRequire("7QoZg");

var $fPMAB = parcelRequire("fPMAB");

var $7mB9T = parcelRequire("7mB9T");
var $e8c262575bd29ba4$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $e8c262575bd29ba4$var$CharsetEncoder = /** @class */ function() {
    function CharsetEncoder(charset) {
        this.charset = charset;
        this.name = charset.name;
    }
    CharsetEncoder.prototype.canEncode = function(c) {
        try {
            return (0, $fPMAB.default).encode(c, this.charset) != null;
        } catch (ex) {
            return false;
        }
    };
    return CharsetEncoder;
}();
var $e8c262575bd29ba4$export$b5aa35b60608d324 = /** @class */ function() {
    /**
     * Constructs an encoder set
     *
     * @param stringToEncode the string that needs to be encoded
     * @param priorityCharset The preferred {@link Charset} or null.
     * @param fnc1 fnc1 denotes the character in the input that represents the FNC1 character or -1 for a non-GS1 bar
     * code. When specified, it is considered an error to pass it as argument to the methods canEncode() or encode().
     */ function ECIEncoderSet(stringToEncode, priorityCharset, fnc1) {
        var e_1, _a, e_2, _b, e_3, _c;
        this.ENCODERS = [
            "IBM437",
            "ISO-8859-2",
            "ISO-8859-3",
            "ISO-8859-4",
            "ISO-8859-5",
            "ISO-8859-6",
            "ISO-8859-7",
            "ISO-8859-8",
            "ISO-8859-9",
            "ISO-8859-10",
            "ISO-8859-11",
            "ISO-8859-13",
            "ISO-8859-14",
            "ISO-8859-15",
            "ISO-8859-16",
            "windows-1250",
            "windows-1251",
            "windows-1252",
            "windows-1256",
            "Shift_JIS"
        ].map(function(name) {
            return new $e8c262575bd29ba4$var$CharsetEncoder((0, $h9FI6.default).forName(name));
        });
        this.encoders = [];
        var neededEncoders = [];
        // we always need the ISO-8859-1 encoder. It is the default encoding
        neededEncoders.push(new $e8c262575bd29ba4$var$CharsetEncoder((0, $7QoZg.default).ISO_8859_1));
        var needUnicodeEncoder = priorityCharset != null && priorityCharset.name.startsWith("UTF");
        // Walk over the input string and see if all characters can be encoded with the list of encoders
        for(var i = 0; i < stringToEncode.length; i++){
            var canEncode = false;
            try {
                for(var neededEncoders_1 = (e_1 = void 0, $e8c262575bd29ba4$var$__values(neededEncoders)), neededEncoders_1_1 = neededEncoders_1.next(); !neededEncoders_1_1.done; neededEncoders_1_1 = neededEncoders_1.next()){
                    var encoder = neededEncoders_1_1.value;
                    var singleCharacter = stringToEncode.charAt(i);
                    var c = singleCharacter.charCodeAt(0);
                    if (c === fnc1 || encoder.canEncode(singleCharacter)) {
                        canEncode = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (neededEncoders_1_1 && !neededEncoders_1_1.done && (_a = neededEncoders_1.return)) _a.call(neededEncoders_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (!canEncode) try {
                // for the character at position i we don't yet have an encoder in the list
                for(var _d = (e_2 = void 0, $e8c262575bd29ba4$var$__values(this.ENCODERS)), _e = _d.next(); !_e.done; _e = _d.next()){
                    var encoder = _e.value;
                    if (encoder.canEncode(stringToEncode.charAt(i))) {
                        // Good, we found an encoder that can encode the character. We add him to the list and continue scanning
                        // the input
                        neededEncoders.push(encoder);
                        canEncode = true;
                        break;
                    }
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            if (!canEncode) // The character is not encodeable by any of the single byte encoders so we remember that we will need a
            // Unicode encoder.
            needUnicodeEncoder = true;
        }
        if (neededEncoders.length === 1 && !needUnicodeEncoder) // the entire input can be encoded by the ISO-8859-1 encoder
        this.encoders = [
            neededEncoders[0]
        ];
        else {
            // we need more than one single byte encoder or we need a Unicode encoder.
            // In this case we append a UTF-8 and UTF-16 encoder to the list
            this.encoders = [];
            var index = 0;
            try {
                for(var neededEncoders_2 = $e8c262575bd29ba4$var$__values(neededEncoders), neededEncoders_2_1 = neededEncoders_2.next(); !neededEncoders_2_1.done; neededEncoders_2_1 = neededEncoders_2.next()){
                    var encoder = neededEncoders_2_1.value;
                    this.encoders[index++] = encoder;
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (neededEncoders_2_1 && !neededEncoders_2_1.done && (_c = neededEncoders_2.return)) _c.call(neededEncoders_2);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
        // this.encoders[index] = new CharsetEncoder(StandardCharsets.UTF_8);
        // this.encoders[index + 1] = new CharsetEncoder(StandardCharsets.UTF_16BE);
        }
        // Compute priorityEncoderIndex by looking up priorityCharset in encoders
        var priorityEncoderIndexValue = -1;
        if (priorityCharset != null) {
            for(var i = 0; i < this.encoders.length; i++)if (this.encoders[i] != null && priorityCharset.name === this.encoders[i].name) {
                priorityEncoderIndexValue = i;
                break;
            }
        }
        this.priorityEncoderIndex = priorityEncoderIndexValue;
    // invariants
    // if(this?.encoders?.[0].name !== StandardCharsets.ISO_8859_1)){
    // throw new Error("ISO-8859-1 must be the first encoder");
    // }
    }
    ECIEncoderSet.prototype.length = function() {
        return this.encoders.length;
    };
    ECIEncoderSet.prototype.getCharsetName = function(index) {
        if (!(index < this.length())) throw new Error("index must be less than length");
        return this.encoders[index].name;
    };
    ECIEncoderSet.prototype.getCharset = function(index) {
        if (!(index < this.length())) throw new Error("index must be less than length");
        return this.encoders[index].charset;
    };
    ECIEncoderSet.prototype.getECIValue = function(encoderIndex) {
        return this.encoders[encoderIndex].charset.getValueIdentifier();
    };
    /*
     *  returns -1 if no priority charset was defined
     */ ECIEncoderSet.prototype.getPriorityEncoderIndex = function() {
        return this.priorityEncoderIndex;
    };
    ECIEncoderSet.prototype.canEncode = function(c, encoderIndex) {
        if (!(encoderIndex < this.length())) throw new Error("index must be less than length");
        return true;
    };
    ECIEncoderSet.prototype.encode = function(c, encoderIndex) {
        if (!(encoderIndex < this.length())) throw new Error("index must be less than length");
        return (0, $fPMAB.default).encode((0, $7mB9T.default).getCharAt(c), this.encoders[encoderIndex].name);
    };
    return ECIEncoderSet;
}();

});





parcelRegister("8D9tv", function(module, exports) {
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ // package com.google.zxing.aztec;
// import com.google.zxing.BarcodeFormat;

var $bx5V3 = parcelRequire("bx5V3");

var $1NSRh = parcelRequire("1NSRh");

var $7WPDx = parcelRequire("7WPDx");

var $hzqel = parcelRequire("hzqel");

var $h9FI6 = parcelRequire("h9FI6");

var $7QoZg = parcelRequire("7QoZg");

var $hcAg4 = parcelRequire("hcAg4");

var $amwnq = parcelRequire("amwnq");

var $kLpae = parcelRequire("kLpae");

var $7mB9T = parcelRequire("7mB9T");
/**
 * Renders an Aztec code as a {@link BitMatrix}.
 */ var $648950c31623c205$var$AztecWriter = /** @class */ function() {
    function AztecWriter() {}
    // @Override
    AztecWriter.prototype.encode = function(contents, format, width, height) {
        return this.encodeWithHints(contents, format, width, height, null);
    };
    // @Override
    AztecWriter.prototype.encodeWithHints = function(contents, format, width, height, hints) {
        var charset = (0, $7QoZg.default).ISO_8859_1;
        var eccPercent = (0, $7WPDx.default).DEFAULT_EC_PERCENT;
        var layers = (0, $7WPDx.default).DEFAULT_AZTEC_LAYERS;
        if (hints != null) {
            if (hints.has((0, $1NSRh.default).CHARACTER_SET)) charset = (0, $h9FI6.default).forName(hints.get((0, $1NSRh.default).CHARACTER_SET).toString());
            if (hints.has((0, $1NSRh.default).ERROR_CORRECTION)) eccPercent = (0, $hcAg4.default).parseInt(hints.get((0, $1NSRh.default).ERROR_CORRECTION).toString());
            if (hints.has((0, $1NSRh.default).AZTEC_LAYERS)) layers = (0, $hcAg4.default).parseInt(hints.get((0, $1NSRh.default).AZTEC_LAYERS).toString());
        }
        return AztecWriter.encodeLayers(contents, format, width, height, charset, eccPercent, layers);
    };
    AztecWriter.encodeLayers = function(contents, format, width, height, charset, eccPercent, layers) {
        if (format !== (0, $bx5V3.default).AZTEC) throw new (0, $kLpae.default)("Can only encode AZTEC, but got " + format);
        var aztec = (0, $7WPDx.default).encode((0, $7mB9T.default).getBytes(contents, charset), eccPercent, layers);
        return AztecWriter.renderResult(aztec, width, height);
    };
    AztecWriter.renderResult = function(code, width, height) {
        var input = code.getMatrix();
        if (input == null) throw new (0, $amwnq.default)();
        var inputWidth = input.getWidth();
        var inputHeight = input.getHeight();
        var outputWidth = Math.max(width, inputWidth);
        var outputHeight = Math.max(height, inputHeight);
        var multiple = Math.min(outputWidth / inputWidth, outputHeight / inputHeight);
        var leftPadding = (outputWidth - inputWidth * multiple) / 2;
        var topPadding = (outputHeight - inputHeight * multiple) / 2;
        var output = new (0, $hzqel.default)(outputWidth, outputHeight);
        for(var inputY /*int*/  = 0, outputY = topPadding; inputY < inputHeight; inputY++, outputY += multiple){
            // Write the contents of this row of the barcode
            for(var inputX /*int*/  = 0, outputX = leftPadding; inputX < inputWidth; inputX++, outputX += multiple)if (input.get(inputX, inputY)) output.setRegion(outputX, outputY, multiple, multiple);
        }
        return output;
    };
    return AztecWriter;
}();
var $648950c31623c205$export$2e2bcd8739ae039 = $648950c31623c205$var$AztecWriter;

});
parcelRegister("7WPDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c960127db385957$export$2e2bcd8739ae039);

var $fHKUB = parcelRequire("fHKUB");

var $kLpae = parcelRequire("kLpae");

var $7mB9T = parcelRequire("7mB9T");

var $hzqel = parcelRequire("hzqel");

var $bkP7r = parcelRequire("bkP7r");

var $jFi7K = parcelRequire("jFi7K");

var $7nLua = parcelRequire("7nLua");

var $4d4yv = parcelRequire("4d4yv");

var $hcAg4 = parcelRequire("hcAg4");
var $5c960127db385957$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // package com.google.zxing.aztec.encoder;
// import com.google.zxing.common.BitArray;
// import com.google.zxing.common.BitMatrix;
// import com.google.zxing.common.reedsolomon.GenericGF;
// import com.google.zxing.common.reedsolomon.ReedSolomonEncoder;
/**
 * Generates Aztec 2D barcodes.
 *
 * @author Rustam Abdullaev
 */ var $5c960127db385957$var$Encoder = /** @class */ function() {
    function Encoder() {}
    /**
     * Encodes the given binary content as an Aztec symbol
     *
     * @param data input data string
     * @return Aztec symbol matrix with metadata
     */ Encoder.encodeBytes = function(data) {
        return Encoder.encode(data, Encoder.DEFAULT_EC_PERCENT, Encoder.DEFAULT_AZTEC_LAYERS);
    };
    /**
     * Encodes the given binary content as an Aztec symbol
     *
     * @param data input data string
     * @param minECCPercent minimal percentage of error check words (According to ISO/IEC 24778:2008,
     *                      a minimum of 23% + 3 words is recommended)
     * @param userSpecifiedLayers if non-zero, a user-specified value for the number of layers
     * @return Aztec symbol matrix with metadata
     */ Encoder.encode = function(data, minECCPercent, userSpecifiedLayers) {
        // High-level encode
        var bits = new (0, $4d4yv.default)(data).encode();
        // stuff bits and choose symbol size
        var eccBits = (0, $hcAg4.default).truncDivision(bits.getSize() * minECCPercent, 100) + 11;
        var totalSizeBits = bits.getSize() + eccBits;
        var compact;
        var layers;
        var totalBitsInLayer;
        var wordSize;
        var stuffedBits;
        if (userSpecifiedLayers !== Encoder.DEFAULT_AZTEC_LAYERS) {
            compact = userSpecifiedLayers < 0;
            layers = Math.abs(userSpecifiedLayers);
            if (layers > (compact ? Encoder.MAX_NB_BITS_COMPACT : Encoder.MAX_NB_BITS)) throw new (0, $kLpae.default)((0, $7mB9T.default).format("Illegal value %s for layers", userSpecifiedLayers));
            totalBitsInLayer = Encoder.totalBitsInLayer(layers, compact);
            wordSize = Encoder.WORD_SIZE[layers];
            var usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
            stuffedBits = Encoder.stuffBits(bits, wordSize);
            if (stuffedBits.getSize() + eccBits > usableBitsInLayers) throw new (0, $kLpae.default)("Data to large for user specified layer");
            if (compact && stuffedBits.getSize() > wordSize * 64) // Compact format only allows 64 data words, though C4 can hold more words than that
            throw new (0, $kLpae.default)("Data to large for user specified layer");
        } else {
            wordSize = 0;
            stuffedBits = null;
            // We look at the possible table sizes in the order Compact1, Compact2, Compact3,
            // Compact4, Normal4,...  Normal(i) for i < 4 isn't typically used since Compact(i+1)
            // is the same size, but has more data.
            for(var i /*int*/  = 0;; i++){
                if (i > Encoder.MAX_NB_BITS) throw new (0, $kLpae.default)("Data too large for an Aztec code");
                compact = i <= 3;
                layers = compact ? i + 1 : i;
                totalBitsInLayer = Encoder.totalBitsInLayer(layers, compact);
                if (totalSizeBits > totalBitsInLayer) continue;
                // [Re]stuff the bits if this is the first opportunity, or if the
                // wordSize has changed
                if (stuffedBits == null || wordSize !== Encoder.WORD_SIZE[layers]) {
                    wordSize = Encoder.WORD_SIZE[layers];
                    stuffedBits = Encoder.stuffBits(bits, wordSize);
                }
                var usableBitsInLayers = totalBitsInLayer - totalBitsInLayer % wordSize;
                if (compact && stuffedBits.getSize() > wordSize * 64) continue;
                if (stuffedBits.getSize() + eccBits <= usableBitsInLayers) break;
            }
        }
        var messageBits = Encoder.generateCheckWords(stuffedBits, totalBitsInLayer, wordSize);
        // generate mode message
        var messageSizeInWords = stuffedBits.getSize() / wordSize;
        var modeMessage = Encoder.generateModeMessage(compact, layers, messageSizeInWords);
        // allocate symbol
        var baseMatrixSize = (compact ? 11 : 14) + layers * 4; // not including alignment lines
        var alignmentMap = new Int32Array(baseMatrixSize);
        var matrixSize;
        if (compact) {
            // no alignment marks in compact mode, alignmentMap is a no-op
            matrixSize = baseMatrixSize;
            for(var i /*int*/  = 0; i < alignmentMap.length; i++)alignmentMap[i] = i;
        } else {
            matrixSize = baseMatrixSize + 1 + 2 * (0, $hcAg4.default).truncDivision((0, $hcAg4.default).truncDivision(baseMatrixSize, 2) - 1, 15);
            var origCenter = (0, $hcAg4.default).truncDivision(baseMatrixSize, 2);
            var center = (0, $hcAg4.default).truncDivision(matrixSize, 2);
            for(var i /*int*/  = 0; i < origCenter; i++){
                var newOffset = i + (0, $hcAg4.default).truncDivision(i, 15);
                alignmentMap[origCenter - i - 1] = center - newOffset - 1;
                alignmentMap[origCenter + i] = center + newOffset + 1;
            }
        }
        var matrix = new (0, $hzqel.default)(matrixSize);
        // draw data bits
        for(var i /*int*/  = 0, rowOffset = 0; i < layers; i++){
            var rowSize = (layers - i) * 4 + (compact ? 9 : 12);
            for(var j /*int*/  = 0; j < rowSize; j++){
                var columnOffset = j * 2;
                for(var k /*int*/  = 0; k < 2; k++){
                    if (messageBits.get(rowOffset + columnOffset + k)) matrix.set(alignmentMap[i * 2 + k], alignmentMap[i * 2 + j]);
                    if (messageBits.get(rowOffset + rowSize * 2 + columnOffset + k)) matrix.set(alignmentMap[i * 2 + j], alignmentMap[baseMatrixSize - 1 - i * 2 - k]);
                    if (messageBits.get(rowOffset + rowSize * 4 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - k], alignmentMap[baseMatrixSize - 1 - i * 2 - j]);
                    if (messageBits.get(rowOffset + rowSize * 6 + columnOffset + k)) matrix.set(alignmentMap[baseMatrixSize - 1 - i * 2 - j], alignmentMap[i * 2 + k]);
                }
            }
            rowOffset += rowSize * 8;
        }
        // draw mode message
        Encoder.drawModeMessage(matrix, compact, matrixSize, modeMessage);
        // draw alignment marks
        if (compact) Encoder.drawBullsEye(matrix, (0, $hcAg4.default).truncDivision(matrixSize, 2), 5);
        else {
            Encoder.drawBullsEye(matrix, (0, $hcAg4.default).truncDivision(matrixSize, 2), 7);
            for(var i /*int*/  = 0, j = 0; i < (0, $hcAg4.default).truncDivision(baseMatrixSize, 2) - 1; i += 15, j += 16)for(var k /*int*/  = (0, $hcAg4.default).truncDivision(matrixSize, 2) & 1; k < matrixSize; k += 2){
                matrix.set((0, $hcAg4.default).truncDivision(matrixSize, 2) - j, k);
                matrix.set((0, $hcAg4.default).truncDivision(matrixSize, 2) + j, k);
                matrix.set(k, (0, $hcAg4.default).truncDivision(matrixSize, 2) - j);
                matrix.set(k, (0, $hcAg4.default).truncDivision(matrixSize, 2) + j);
            }
        }
        var aztec = new (0, $bkP7r.default)();
        aztec.setCompact(compact);
        aztec.setSize(matrixSize);
        aztec.setLayers(layers);
        aztec.setCodeWords(messageSizeInWords);
        aztec.setMatrix(matrix);
        return aztec;
    };
    Encoder.drawBullsEye = function(matrix, center, size) {
        for(var i /*int*/  = 0; i < size; i += 2)for(var j /*int*/  = center - i; j <= center + i; j++){
            matrix.set(j, center - i);
            matrix.set(j, center + i);
            matrix.set(center - i, j);
            matrix.set(center + i, j);
        }
        matrix.set(center - size, center - size);
        matrix.set(center - size + 1, center - size);
        matrix.set(center - size, center - size + 1);
        matrix.set(center + size, center - size);
        matrix.set(center + size, center - size + 1);
        matrix.set(center + size, center + size - 1);
    };
    Encoder.generateModeMessage = function(compact, layers, messageSizeInWords) {
        var modeMessage = new (0, $fHKUB.default)();
        if (compact) {
            modeMessage.appendBits(layers - 1, 2);
            modeMessage.appendBits(messageSizeInWords - 1, 6);
            modeMessage = Encoder.generateCheckWords(modeMessage, 28, 4);
        } else {
            modeMessage.appendBits(layers - 1, 5);
            modeMessage.appendBits(messageSizeInWords - 1, 11);
            modeMessage = Encoder.generateCheckWords(modeMessage, 40, 4);
        }
        return modeMessage;
    };
    Encoder.drawModeMessage = function(matrix, compact, matrixSize, modeMessage) {
        var center = (0, $hcAg4.default).truncDivision(matrixSize, 2);
        if (compact) for(var i /*int*/  = 0; i < 7; i++){
            var offset = center - 3 + i;
            if (modeMessage.get(i)) matrix.set(offset, center - 5);
            if (modeMessage.get(i + 7)) matrix.set(center + 5, offset);
            if (modeMessage.get(20 - i)) matrix.set(offset, center + 5);
            if (modeMessage.get(27 - i)) matrix.set(center - 5, offset);
        }
        else for(var i /*int*/  = 0; i < 10; i++){
            var offset = center - 5 + i + (0, $hcAg4.default).truncDivision(i, 5);
            if (modeMessage.get(i)) matrix.set(offset, center - 7);
            if (modeMessage.get(i + 10)) matrix.set(center + 7, offset);
            if (modeMessage.get(29 - i)) matrix.set(offset, center + 7);
            if (modeMessage.get(39 - i)) matrix.set(center - 7, offset);
        }
    };
    Encoder.generateCheckWords = function(bitArray, totalBits, wordSize) {
        var e_1, _a;
        // bitArray is guaranteed to be a multiple of the wordSize, so no padding needed
        var messageSizeInWords = bitArray.getSize() / wordSize;
        var rs = new (0, $jFi7K.default)(Encoder.getGF(wordSize));
        var totalWords = (0, $hcAg4.default).truncDivision(totalBits, wordSize);
        var messageWords = Encoder.bitsToWords(bitArray, wordSize, totalWords);
        rs.encode(messageWords, totalWords - messageSizeInWords);
        var startPad = totalBits % wordSize;
        var messageBits = new (0, $fHKUB.default)();
        messageBits.appendBits(0, startPad);
        try {
            for(var _b = $5c960127db385957$var$__values(Array.from(messageWords)), _c = _b.next(); !_c.done; _c = _b.next()){
                var messageWord = _c.value /*: int*/ ;
                messageBits.appendBits(messageWord, wordSize);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return messageBits;
    };
    Encoder.bitsToWords = function(stuffedBits, wordSize, totalWords) {
        var message = new Int32Array(totalWords);
        var i;
        var n;
        for(i = 0, n = stuffedBits.getSize() / wordSize; i < n; i++){
            var value = 0;
            for(var j /*int*/  = 0; j < wordSize; j++)value |= stuffedBits.get(i * wordSize + j) ? 1 << wordSize - j - 1 : 0;
            message[i] = value;
        }
        return message;
    };
    Encoder.getGF = function(wordSize) {
        switch(wordSize){
            case 4:
                return (0, $7nLua.default).AZTEC_PARAM;
            case 6:
                return (0, $7nLua.default).AZTEC_DATA_6;
            case 8:
                return (0, $7nLua.default).AZTEC_DATA_8;
            case 10:
                return (0, $7nLua.default).AZTEC_DATA_10;
            case 12:
                return (0, $7nLua.default).AZTEC_DATA_12;
            default:
                throw new (0, $kLpae.default)("Unsupported word size " + wordSize);
        }
    };
    Encoder.stuffBits = function(bits, wordSize) {
        var out = new (0, $fHKUB.default)();
        var n = bits.getSize();
        var mask = (1 << wordSize) - 2;
        for(var i /*int*/  = 0; i < n; i += wordSize){
            var word = 0;
            for(var j /*int*/  = 0; j < wordSize; j++)if (i + j >= n || bits.get(i + j)) word |= 1 << wordSize - 1 - j;
            if ((word & mask) === mask) {
                out.appendBits(word & mask, wordSize);
                i--;
            } else if ((word & mask) === 0) {
                out.appendBits(word | 1, wordSize);
                i--;
            } else out.appendBits(word, wordSize);
        }
        return out;
    };
    Encoder.totalBitsInLayer = function(layers, compact) {
        return ((compact ? 88 : 112) + 16 * layers) * layers;
    };
    Encoder.DEFAULT_EC_PERCENT = 33; // default minimal percentage of error check words
    Encoder.DEFAULT_AZTEC_LAYERS = 0;
    Encoder.MAX_NB_BITS = 32;
    Encoder.MAX_NB_BITS_COMPACT = 4;
    Encoder.WORD_SIZE = Int32Array.from([
        4,
        6,
        6,
        8,
        8,
        8,
        8,
        8,
        8,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        10,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12,
        12
    ]);
    return Encoder;
}();
var $5c960127db385957$export$2e2bcd8739ae039 = $5c960127db385957$var$Encoder;

});
parcelRegister("bkP7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $8409371fa31211e5$export$2e2bcd8739ae039);
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ /**
 * Aztec 2D code representation
 *
 * @author Rustam Abdullaev
 */ var $8409371fa31211e5$var$AztecCode = /** @class */ function() {
    function AztecCode() {}
    /**
     * @return {@code true} if compact instead of full mode
     */ AztecCode.prototype.isCompact = function() {
        return this.compact;
    };
    AztecCode.prototype.setCompact = function(compact) {
        this.compact = compact;
    };
    /**
     * @return size in pixels (width and height)
     */ AztecCode.prototype.getSize = function() {
        return this.size;
    };
    AztecCode.prototype.setSize = function(size) {
        this.size = size;
    };
    /**
     * @return number of levels
     */ AztecCode.prototype.getLayers = function() {
        return this.layers;
    };
    AztecCode.prototype.setLayers = function(layers) {
        this.layers = layers;
    };
    /**
     * @return number of data codewords
     */ AztecCode.prototype.getCodeWords = function() {
        return this.codeWords;
    };
    AztecCode.prototype.setCodeWords = function(codeWords) {
        this.codeWords = codeWords;
    };
    /**
     * @return the symbol image
     */ AztecCode.prototype.getMatrix = function() {
        return this.matrix;
    };
    AztecCode.prototype.setMatrix = function(matrix) {
        this.matrix = matrix;
    };
    return AztecCode;
}();
var $8409371fa31211e5$export$2e2bcd8739ae039 = $8409371fa31211e5$var$AztecCode;

});

parcelRegister("4d4yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $310be8f0de4cfbeb$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9ooUP = parcelRequire("9ooUP");

var $fPWST = parcelRequire("fPWST");

var $lve0x = parcelRequire("lve0x");

var $3BagJ = parcelRequire("3BagJ");

var $dHuPh = parcelRequire("dHuPh");

var $7mB9T = parcelRequire("7mB9T");
var $310be8f0de4cfbeb$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * This produces nearly optimal encodings of text into the first-level of
 * encoding used by Aztec code.
 *
 * It uses a dynamic algorithm.  For each prefix of the string, it determines
 * a set of encodings that could lead to this prefix.  We repeatedly add a
 * character and generate a new set of optimal encodings until we have read
 * through the entire input.
 *
 * @author Frank Yellin
 * @author Rustam Abdullaev
 */ var $310be8f0de4cfbeb$var$HighLevelEncoder = /** @class */ function() {
    function HighLevelEncoder(text) {
        this.text = text;
    }
    /**
     * @return text represented by this encoder encoded as a {@link BitArray}
     */ HighLevelEncoder.prototype.encode = function() {
        var spaceCharCode = (0, $7mB9T.default).getCharCode(" ");
        var lineBreakCharCode = (0, $7mB9T.default).getCharCode("\n");
        var states = (0, $9ooUP.default).singletonList((0, $fPWST.default).INITIAL_STATE);
        for(var index = 0; index < this.text.length; index++){
            var pairCode = void 0;
            var nextChar = index + 1 < this.text.length ? this.text[index + 1] : 0;
            switch(this.text[index]){
                case (0, $7mB9T.default).getCharCode("\r"):
                    pairCode = nextChar === lineBreakCharCode ? 2 : 0;
                    break;
                case (0, $7mB9T.default).getCharCode("."):
                    pairCode = nextChar === spaceCharCode ? 3 : 0;
                    break;
                case (0, $7mB9T.default).getCharCode(","):
                    pairCode = nextChar === spaceCharCode ? 4 : 0;
                    break;
                case (0, $7mB9T.default).getCharCode(":"):
                    pairCode = nextChar === spaceCharCode ? 5 : 0;
                    break;
                default:
                    pairCode = 0;
            }
            if (pairCode > 0) {
                // We have one of the four special PUNCT pairs.  Treat them specially.
                // Get a new set of states for the two new characters.
                states = HighLevelEncoder.updateStateListForPair(states, index, pairCode);
                index++;
            } else // Get a new set of states for the new character.
            states = this.updateStateListForChar(states, index);
        }
        // We are left with a set of states.  Find the shortest one.
        var minState = (0, $9ooUP.default).min(states, function(a, b) {
            return a.getBitCount() - b.getBitCount();
        });
        // Convert it to a bit array, and return.
        return minState.toBitArray(this.text);
    };
    // We update a set of states for a new character by updating each state
    // for the new character, merging the results, and then removing the
    // non-optimal states.
    HighLevelEncoder.prototype.updateStateListForChar = function(states, index) {
        var e_1, _a;
        var result = [];
        try {
            for(var states_1 = $310be8f0de4cfbeb$var$__values(states), states_1_1 = states_1.next(); !states_1_1.done; states_1_1 = states_1.next()){
                var state = states_1_1.value /*State*/ ;
                this.updateStateForChar(state, index, result);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (states_1_1 && !states_1_1.done && (_a = states_1.return)) _a.call(states_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return HighLevelEncoder.simplifyStates(result);
    };
    // Return a set of states that represent the possible ways of updating this
    // state for the next character.  The resulting set of states are added to
    // the "result" list.
    HighLevelEncoder.prototype.updateStateForChar = function(state, index, result) {
        var ch = this.text[index] & 0xff;
        var charInCurrentTable = $3BagJ.CHAR_MAP[state.getMode()][ch] > 0;
        var stateNoBinary = null;
        for(var mode /*int*/  = 0; mode <= $lve0x.MODE_PUNCT; mode++){
            var charInMode = $3BagJ.CHAR_MAP[mode][ch];
            if (charInMode > 0) {
                if (stateNoBinary == null) // Only create stateNoBinary the first time it's required.
                stateNoBinary = state.endBinaryShift(index);
                // Try generating the character by latching to its mode
                if (!charInCurrentTable || mode === state.getMode() || mode === $lve0x.MODE_DIGIT) {
                    // If the character is in the current table, we don't want to latch to
                    // any other mode except possibly digit (which uses only 4 bits).  Any
                    // other latch would be equally successful *after* this character, and
                    // so wouldn't save any bits.
                    var latchState = stateNoBinary.latchAndAppend(mode, charInMode);
                    result.push(latchState);
                }
                // Try generating the character by switching to its mode.
                if (!charInCurrentTable && $dHuPh.SHIFT_TABLE[state.getMode()][mode] >= 0) {
                    // It never makes sense to temporarily shift to another mode if the
                    // character exists in the current mode.  That can never save bits.
                    var shiftState = stateNoBinary.shiftAndAppend(mode, charInMode);
                    result.push(shiftState);
                }
            }
        }
        if (state.getBinaryShiftByteCount() > 0 || $3BagJ.CHAR_MAP[state.getMode()][ch] === 0) {
            // It's never worthwhile to go into binary shift mode if you're not already
            // in binary shift mode, and the character exists in your current mode.
            // That can never save bits over just outputting the char in the current mode.
            var binaryState = state.addBinaryShiftChar(index);
            result.push(binaryState);
        }
    };
    HighLevelEncoder.updateStateListForPair = function(states, index, pairCode) {
        var e_2, _a;
        var result = [];
        try {
            for(var states_2 = $310be8f0de4cfbeb$var$__values(states), states_2_1 = states_2.next(); !states_2_1.done; states_2_1 = states_2.next()){
                var state = states_2_1.value /*State*/ ;
                this.updateStateForPair(state, index, pairCode, result);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (states_2_1 && !states_2_1.done && (_a = states_2.return)) _a.call(states_2);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return this.simplifyStates(result);
    };
    HighLevelEncoder.updateStateForPair = function(state, index, pairCode, result) {
        var stateNoBinary = state.endBinaryShift(index);
        // Possibility 1.  Latch to C.MODE_PUNCT, and then append this code
        result.push(stateNoBinary.latchAndAppend($lve0x.MODE_PUNCT, pairCode));
        if (state.getMode() !== $lve0x.MODE_PUNCT) // Possibility 2.  Shift to C.MODE_PUNCT, and then append this code.
        // Every state except C.MODE_PUNCT (handled above) can shift
        result.push(stateNoBinary.shiftAndAppend($lve0x.MODE_PUNCT, pairCode));
        if (pairCode === 3 || pairCode === 4) {
            // both characters are in DIGITS.  Sometimes better to just add two digits
            var digitState = stateNoBinary.latchAndAppend($lve0x.MODE_DIGIT, 16 - pairCode) // period or comma in DIGIT
            .latchAndAppend($lve0x.MODE_DIGIT, 1); // space in DIGIT
            result.push(digitState);
        }
        if (state.getBinaryShiftByteCount() > 0) {
            // It only makes sense to do the characters as binary if we're already
            // in binary mode.
            var binaryState = state.addBinaryShiftChar(index).addBinaryShiftChar(index + 1);
            result.push(binaryState);
        }
    };
    HighLevelEncoder.simplifyStates = function(states) {
        var e_3, _a, e_4, _b;
        var result = [];
        try {
            for(var states_3 = $310be8f0de4cfbeb$var$__values(states), states_3_1 = states_3.next(); !states_3_1.done; states_3_1 = states_3.next()){
                var newState = states_3_1.value;
                var add = true;
                var _loop_1 = function(oldState) {
                    if (oldState.isBetterThanOrEqualTo(newState)) {
                        add = false;
                        return "break";
                    }
                    if (newState.isBetterThanOrEqualTo(oldState)) // iterator.remove();
                    result = result.filter(function(x) {
                        return x !== oldState;
                    }); // remove old state
                };
                try {
                    for(var result_1 = (e_4 = void 0, $310be8f0de4cfbeb$var$__values(result)), result_1_1 = result_1.next(); !result_1_1.done; result_1_1 = result_1.next()){
                        var oldState = result_1_1.value;
                        var state_1 = _loop_1(oldState);
                        if (state_1 === "break") break;
                    }
                } catch (e_4_1) {
                    e_4 = {
                        error: e_4_1
                    };
                } finally{
                    try {
                        if (result_1_1 && !result_1_1.done && (_b = result_1.return)) _b.call(result_1);
                    } finally{
                        if (e_4) throw e_4.error;
                    }
                }
                if (add) result.push(newState);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (states_3_1 && !states_3_1.done && (_a = states_3.return)) _a.call(states_3);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
    return HighLevelEncoder;
}();
var $310be8f0de4cfbeb$export$2e2bcd8739ae039 = $310be8f0de4cfbeb$var$HighLevelEncoder;

});
parcelRegister("9ooUP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d69aeadc5059273$export$2e2bcd8739ae039);
var $6d69aeadc5059273$var$Collections = /** @class */ function() {
    function Collections() {}
    /**
     * The singletonList(T) method is used to return an immutable list containing only the specified object.
     */ Collections.singletonList = function(item) {
        return [
            item
        ];
    };
    /**
     * The min(Collection<? extends T>, Comparator<? super T>) method is used to return the minimum element of the given collection, according to the order induced by the specified comparator.
     */ Collections.min = function(collection, comparator) {
        return collection.sort(comparator)[0];
    };
    return Collections;
}();
var $6d69aeadc5059273$export$2e2bcd8739ae039 = $6d69aeadc5059273$var$Collections;

});

parcelRegister("fPWST", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8794bab1d376dd2$export$2e2bcd8739ae039);
/*
 * Copyright 2013 ZXing authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $fHKUB = parcelRequire("fHKUB");

var $hshcA = parcelRequire("hshcA");

var $lve0x = parcelRequire("lve0x");

var $70RLV = parcelRequire("70RLV");

var $dHuPh = parcelRequire("dHuPh");

var $7mB9T = parcelRequire("7mB9T");
var $b8794bab1d376dd2$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/**
 * State represents all information about a sequence necessary to generate the current output.
 * Note that a state is immutable.
 */ var $b8794bab1d376dd2$var$State = /** @class */ function() {
    function State(token, mode, binaryBytes, bitCount) {
        this.token = token;
        this.mode = mode;
        this.binaryShiftByteCount = binaryBytes;
        this.bitCount = bitCount;
    // Make sure we match the token
    // int binaryShiftBitCount = (binaryShiftByteCount * 8) +
    //    (binaryShiftByteCount === 0 ? 0 :
    //     binaryShiftByteCount <= 31 ? 10 :
    //     binaryShiftByteCount <= 62 ? 20 : 21);
    // assert this.bitCount === token.getTotalBitCount() + binaryShiftBitCount;
    }
    State.prototype.getMode = function() {
        return this.mode;
    };
    State.prototype.getToken = function() {
        return this.token;
    };
    State.prototype.getBinaryShiftByteCount = function() {
        return this.binaryShiftByteCount;
    };
    State.prototype.getBitCount = function() {
        return this.bitCount;
    };
    // Create a new state representing this state with a latch to a (not
    // necessary different) mode, and then a code.
    State.prototype.latchAndAppend = function(mode, value) {
        // assert binaryShiftByteCount === 0;
        var bitCount = this.bitCount;
        var token = this.token;
        if (mode !== this.mode) {
            var latch = $70RLV.LATCH_TABLE[this.mode][mode];
            token = $hshcA.add(token, latch & 0xffff, latch >> 16);
            bitCount += latch >> 16;
        }
        var latchModeBitCount = mode === $lve0x.MODE_DIGIT ? 4 : 5;
        token = $hshcA.add(token, value, latchModeBitCount);
        return new State(token, mode, 0, bitCount + latchModeBitCount);
    };
    // Create a new state representing this state, with a temporary shift
    // to a different mode to output a single value.
    State.prototype.shiftAndAppend = function(mode, value) {
        // assert binaryShiftByteCount === 0 && this.mode !== mode;
        var token = this.token;
        var thisModeBitCount = this.mode === $lve0x.MODE_DIGIT ? 4 : 5;
        // Shifts exist only to UPPER and PUNCT, both with tokens size 5.
        token = $hshcA.add(token, $dHuPh.SHIFT_TABLE[this.mode][mode], thisModeBitCount);
        token = $hshcA.add(token, value, 5);
        return new State(token, this.mode, 0, this.bitCount + thisModeBitCount + 5);
    };
    // Create a new state representing this state, but an additional character
    // output in Binary Shift mode.
    State.prototype.addBinaryShiftChar = function(index) {
        var token = this.token;
        var mode = this.mode;
        var bitCount = this.bitCount;
        if (this.mode === $lve0x.MODE_PUNCT || this.mode === $lve0x.MODE_DIGIT) {
            // assert binaryShiftByteCount === 0;
            var latch = $70RLV.LATCH_TABLE[mode][$lve0x.MODE_UPPER];
            token = $hshcA.add(token, latch & 0xffff, latch >> 16);
            bitCount += latch >> 16;
            mode = $lve0x.MODE_UPPER;
        }
        var deltaBitCount = this.binaryShiftByteCount === 0 || this.binaryShiftByteCount === 31 ? 18 : this.binaryShiftByteCount === 62 ? 9 : 8;
        var result = new State(token, mode, this.binaryShiftByteCount + 1, bitCount + deltaBitCount);
        if (result.binaryShiftByteCount === 2078) // The string is as long as it's allowed to be.  We should end it.
        result = result.endBinaryShift(index + 1);
        return result;
    };
    // Create the state identical to this one, but we are no longer in
    // Binary Shift mode.
    State.prototype.endBinaryShift = function(index) {
        if (this.binaryShiftByteCount === 0) return this;
        var token = this.token;
        token = $hshcA.addBinaryShift(token, index - this.binaryShiftByteCount, this.binaryShiftByteCount);
        // assert token.getTotalBitCount() === this.bitCount;
        return new State(token, this.mode, 0, this.bitCount);
    };
    // Returns true if "this" state is better (equal: or) to be in than "that"
    // state under all possible circumstances.
    State.prototype.isBetterThanOrEqualTo = function(other) {
        var newModeBitCount = this.bitCount + ($70RLV.LATCH_TABLE[this.mode][other.mode] >> 16);
        if (this.binaryShiftByteCount < other.binaryShiftByteCount) // add additional B/S encoding cost of other, if any
        newModeBitCount += State.calculateBinaryShiftCost(other) - State.calculateBinaryShiftCost(this);
        else if (this.binaryShiftByteCount > other.binaryShiftByteCount && other.binaryShiftByteCount > 0) // maximum possible additional cost (it: h)
        newModeBitCount += 10;
        return newModeBitCount <= other.bitCount;
    };
    State.prototype.toBitArray = function(text) {
        var e_1, _a;
        // Reverse the tokens, so that they are in the order that they should
        // be output
        var symbols = [];
        for(var token = this.endBinaryShift(text.length).token; token !== null; token = token.getPrevious())symbols.unshift(token);
        var bitArray = new (0, $fHKUB.default)();
        try {
            // Add each token to the result.
            for(var symbols_1 = $b8794bab1d376dd2$var$__values(symbols), symbols_1_1 = symbols_1.next(); !symbols_1_1.done; symbols_1_1 = symbols_1.next()){
                var symbol = symbols_1_1.value;
                symbol.appendTo(bitArray, text);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (symbols_1_1 && !symbols_1_1.done && (_a = symbols_1.return)) _a.call(symbols_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        // assert bitArray.getSize() === this.bitCount;
        return bitArray;
    };
    /**
     * @Override
     */ State.prototype.toString = function() {
        return (0, $7mB9T.default).format("%s bits=%d bytes=%d", $lve0x.MODE_NAMES[this.mode], this.bitCount, this.binaryShiftByteCount);
    };
    State.calculateBinaryShiftCost = function(state) {
        if (state.binaryShiftByteCount > 62) return 21; // B/S with extended length
        if (state.binaryShiftByteCount > 31) return 20; // two B/S
        if (state.binaryShiftByteCount > 0) return 10; // one B/S
        return 0;
    };
    State.INITIAL_STATE = new State($lve0x.EMPTY_TOKEN, $lve0x.MODE_UPPER, 0, 0);
    return State;
}();
var $b8794bab1d376dd2$export$2e2bcd8739ae039 = $b8794bab1d376dd2$var$State;

});
parcelRegister("hshcA", function(module, exports) {

$parcel$export(module.exports, "addBinaryShift", () => $cb526527f947d997$export$682754f93767697e);
$parcel$export(module.exports, "add", () => $cb526527f947d997$export$e16d8520af44a096);

var $96wI4 = parcelRequire("96wI4");

var $LsUjM = parcelRequire("LsUjM");
function $cb526527f947d997$export$682754f93767697e(token, start, byteCount) {
    // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
    return new (0, $LsUjM.default)(token, start, byteCount);
}
function $cb526527f947d997$export$e16d8520af44a096(token, value, bitCount) {
    return new (0, $96wI4.default)(token, value, bitCount);
}

});
parcelRegister("96wI4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a0e0c1984b5ad57$export$2e2bcd8739ae039);
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 
var $feYHZ = parcelRequire("feYHZ");

var $hcAg4 = parcelRequire("hcAg4");
var $6a0e0c1984b5ad57$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6a0e0c1984b5ad57$var$SimpleToken = /** @class */ function(_super) {
    $6a0e0c1984b5ad57$var$__extends(SimpleToken, _super);
    function SimpleToken(previous, value, bitCount) {
        var _this = _super.call(this, previous) || this;
        _this.value = value;
        _this.bitCount = bitCount;
        return _this;
    }
    /**
     * @Override
     */ SimpleToken.prototype.appendTo = function(bitArray, text) {
        bitArray.appendBits(this.value, this.bitCount);
    };
    SimpleToken.prototype.add = function(value, bitCount) {
        return new SimpleToken(this, value, bitCount);
    };
    SimpleToken.prototype.addBinaryShift = function(start, byteCount) {
        // no-op can't binary shift a simple token
        console.warn("addBinaryShift on SimpleToken, this simply returns a copy of this token");
        return new SimpleToken(this, start, byteCount);
    };
    /**
     * @Override
     */ SimpleToken.prototype.toString = function() {
        var value = this.value & (1 << this.bitCount) - 1;
        value |= 1 << this.bitCount;
        return "<" + (0, $hcAg4.default).toBinaryString(value | 1 << this.bitCount).substring(1) + ">";
    };
    return SimpleToken;
}((0, $feYHZ.default));
var $6a0e0c1984b5ad57$export$2e2bcd8739ae039 = $6a0e0c1984b5ad57$var$SimpleToken;

});
parcelRegister("feYHZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1874141db80652d$export$2e2bcd8739ae039);
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ var $b1874141db80652d$var$Token = /** @class */ function() {
    function Token(previous) {
        this.previous = previous;
    }
    Token.prototype.getPrevious = function() {
        return this.previous;
    };
    return Token;
}();
var $b1874141db80652d$export$2e2bcd8739ae039 = $b1874141db80652d$var$Token;

});


parcelRegister("LsUjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $08ead04cabf99875$export$2e2bcd8739ae039);
/*
* Copyright 2013 ZXing authors
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*      http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/ 
var $96wI4 = parcelRequire("96wI4");
var $08ead04cabf99875$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $08ead04cabf99875$var$BinaryShiftToken = /** @class */ function(_super) {
    $08ead04cabf99875$var$__extends(BinaryShiftToken, _super);
    function BinaryShiftToken(previous, binaryShiftStart, binaryShiftByteCount) {
        var _this = _super.call(this, previous, 0, 0) || this;
        _this.binaryShiftStart = binaryShiftStart;
        _this.binaryShiftByteCount = binaryShiftByteCount;
        return _this;
    }
    /**
     * @Override
     */ BinaryShiftToken.prototype.appendTo = function(bitArray, text) {
        for(var i = 0; i < this.binaryShiftByteCount; i++){
            if (i === 0 || i === 31 && this.binaryShiftByteCount <= 62) {
                // We need a header before the first character, and before
                // character 31 when the total byte code is <= 62
                bitArray.appendBits(31, 5); // BINARY_SHIFT
                if (this.binaryShiftByteCount > 62) bitArray.appendBits(this.binaryShiftByteCount - 31, 16);
                else if (i === 0) // 1 <= binaryShiftByteCode <= 62
                bitArray.appendBits(Math.min(this.binaryShiftByteCount, 31), 5);
                else // 32 <= binaryShiftCount <= 62 and i == 31
                bitArray.appendBits(this.binaryShiftByteCount - 31, 5);
            }
            bitArray.appendBits(text[this.binaryShiftStart + i], 8);
        }
    };
    BinaryShiftToken.prototype.addBinaryShift = function(start, byteCount) {
        // int bitCount = (byteCount * 8) + (byteCount <= 31 ? 10 : byteCount <= 62 ? 20 : 21);
        return new BinaryShiftToken(this, start, byteCount);
    };
    /**
     * @Override
     */ BinaryShiftToken.prototype.toString = function() {
        return "<" + this.binaryShiftStart + "::" + (this.binaryShiftStart + this.binaryShiftByteCount - 1) + ">";
    };
    return BinaryShiftToken;
}((0, $96wI4.default));
var $08ead04cabf99875$export$2e2bcd8739ae039 = $08ead04cabf99875$var$BinaryShiftToken;

});


parcelRegister("lve0x", function(module, exports) {

$parcel$export(module.exports, "MODE_NAMES", () => $fa775be11963b6e3$export$b330669118f5398c);
$parcel$export(module.exports, "MODE_UPPER", () => $fa775be11963b6e3$export$b62eceed7909eedb);
$parcel$export(module.exports, "MODE_LOWER", () => $fa775be11963b6e3$export$dddc678b91a92292);
$parcel$export(module.exports, "MODE_DIGIT", () => $fa775be11963b6e3$export$5a5ce6a997d69865);
$parcel$export(module.exports, "MODE_MIXED", () => $fa775be11963b6e3$export$7ff1f62ca8a43556);
$parcel$export(module.exports, "MODE_PUNCT", () => $fa775be11963b6e3$export$4e7b78785f29ce0f);
$parcel$export(module.exports, "EMPTY_TOKEN", () => $fa775be11963b6e3$export$89bb5d126ce811a2);

var $96wI4 = parcelRequire("96wI4");
var /*final*/ $fa775be11963b6e3$export$b330669118f5398c = [
    "UPPER",
    "LOWER",
    "DIGIT",
    "MIXED",
    "PUNCT"
];
var /*final*/ $fa775be11963b6e3$export$b62eceed7909eedb = 0; // 5 bits
var /*final*/ $fa775be11963b6e3$export$dddc678b91a92292 = 1; // 5 bits
var /*final*/ $fa775be11963b6e3$export$5a5ce6a997d69865 = 2; // 4 bits
var /*final*/ $fa775be11963b6e3$export$7ff1f62ca8a43556 = 3; // 5 bits
var /*final*/ $fa775be11963b6e3$export$4e7b78785f29ce0f = 4; // 5 bits
var $fa775be11963b6e3$export$89bb5d126ce811a2 = new (0, $96wI4.default)(null, 0, 0);

});

parcelRegister("70RLV", function(module, exports) {

$parcel$export(module.exports, "LATCH_TABLE", () => $51b23e7ceaf088bf$export$fff4b7837da52261);
// The Latch Table shows, for each pair of Modes, the optimal method for
// getting from one mode to another.  In the worst possible case, this can
// be up to 14 bits.  In the best possible case, we are already there!
// The high half-word of each entry gives the number of bits.
// The low half-word of each entry are the actual bits necessary to change
var $51b23e7ceaf088bf$export$fff4b7837da52261 = [
    Int32Array.from([
        0,
        327708,
        327710,
        327709,
        656318 // UPPER -> MIXED -> PUNCT
    ]),
    Int32Array.from([
        590318,
        0,
        327710,
        327709,
        656318 // LOWER -> MIXED -> PUNCT
    ]),
    Int32Array.from([
        262158,
        590300,
        0,
        590301,
        932798
    ]),
    Int32Array.from([
        327709,
        327708,
        656318,
        0,
        327710 // MIXED -> PUNCT
    ]),
    Int32Array.from([
        327711,
        656380,
        656382,
        656381,
        0
    ])
];

});

parcelRegister("dHuPh", function(module, exports) {

$parcel$export(module.exports, "SHIFT_TABLE", () => $9f9733f27fcae834$export$46c23485303b0705);

var $iYwLM = parcelRequire("iYwLM");

var $lve0x = parcelRequire("lve0x");
var $9f9733f27fcae834$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $9f9733f27fcae834$export$7347b8daf304f5f1(SHIFT_TABLE) {
    var e_1, _a;
    try {
        for(var SHIFT_TABLE_1 = $9f9733f27fcae834$var$__values(SHIFT_TABLE), SHIFT_TABLE_1_1 = SHIFT_TABLE_1.next(); !SHIFT_TABLE_1_1.done; SHIFT_TABLE_1_1 = SHIFT_TABLE_1.next()){
            var table = SHIFT_TABLE_1_1.value /*Int32Array*/ ;
            (0, $iYwLM.default).fill(table, -1);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (SHIFT_TABLE_1_1 && !SHIFT_TABLE_1_1.done && (_a = SHIFT_TABLE_1.return)) _a.call(SHIFT_TABLE_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    SHIFT_TABLE[$lve0x.MODE_UPPER][$lve0x.MODE_PUNCT] = 0;
    SHIFT_TABLE[$lve0x.MODE_LOWER][$lve0x.MODE_PUNCT] = 0;
    SHIFT_TABLE[$lve0x.MODE_LOWER][$lve0x.MODE_UPPER] = 28;
    SHIFT_TABLE[$lve0x.MODE_MIXED][$lve0x.MODE_PUNCT] = 0;
    SHIFT_TABLE[$lve0x.MODE_DIGIT][$lve0x.MODE_PUNCT] = 0;
    SHIFT_TABLE[$lve0x.MODE_DIGIT][$lve0x.MODE_UPPER] = 15;
    return SHIFT_TABLE;
}
var /*final*/ $9f9733f27fcae834$export$46c23485303b0705 = $9f9733f27fcae834$export$7347b8daf304f5f1((0, $iYwLM.default).createInt32Array(6, 6)); // mode shift codes, per table

});


parcelRegister("3BagJ", function(module, exports) {

$parcel$export(module.exports, "CHAR_MAP", () => $29eccafb87ec654b$export$15ce3e30c0b81cf5);

var $lve0x = parcelRequire("lve0x");

var $iYwLM = parcelRequire("iYwLM");

var $7mB9T = parcelRequire("7mB9T");
function $29eccafb87ec654b$export$cc3e6a9bbac46e84(CHAR_MAP) {
    var spaceCharCode = (0, $7mB9T.default).getCharCode(" ");
    var pointCharCode = (0, $7mB9T.default).getCharCode(".");
    var commaCharCode = (0, $7mB9T.default).getCharCode(",");
    CHAR_MAP[$lve0x.MODE_UPPER][spaceCharCode] = 1;
    var zUpperCharCode = (0, $7mB9T.default).getCharCode("Z");
    var aUpperCharCode = (0, $7mB9T.default).getCharCode("A");
    for(var c = aUpperCharCode; c <= zUpperCharCode; c++)CHAR_MAP[$lve0x.MODE_UPPER][c] = c - aUpperCharCode + 2;
    CHAR_MAP[$lve0x.MODE_LOWER][spaceCharCode] = 1;
    var zLowerCharCode = (0, $7mB9T.default).getCharCode("z");
    var aLowerCharCode = (0, $7mB9T.default).getCharCode("a");
    for(var c = aLowerCharCode; c <= zLowerCharCode; c++)CHAR_MAP[$lve0x.MODE_LOWER][c] = c - aLowerCharCode + 2;
    CHAR_MAP[$lve0x.MODE_DIGIT][spaceCharCode] = 1;
    var nineCharCode = (0, $7mB9T.default).getCharCode("9");
    var zeroCharCode = (0, $7mB9T.default).getCharCode("0");
    for(var c = zeroCharCode; c <= nineCharCode; c++)CHAR_MAP[$lve0x.MODE_DIGIT][c] = c - zeroCharCode + 2;
    CHAR_MAP[$lve0x.MODE_DIGIT][commaCharCode] = 12;
    CHAR_MAP[$lve0x.MODE_DIGIT][pointCharCode] = 13;
    var mixedTable = [
        "\0",
        " ",
        "\x01",
        "\x02",
        "\x03",
        "\x04",
        "\x05",
        "\x06",
        "\x07",
        "\b",
        "	",
        "\n",
        "\v",
        "\f",
        "\r",
        "\x1b",
        "\x1c",
        "\x1d",
        "\x1e",
        "\x1f",
        "@",
        "\\",
        "^",
        "_",
        "`",
        "|",
        "~",
        "\x7f"
    ];
    for(var i = 0; i < mixedTable.length; i++)CHAR_MAP[$lve0x.MODE_MIXED][(0, $7mB9T.default).getCharCode(mixedTable[i])] = i;
    var punctTable = [
        "\0",
        "\r",
        "\0",
        "\0",
        "\0",
        "\0",
        "!",
        "'",
        "#",
        "$",
        "%",
        "&",
        "'",
        "(",
        ")",
        "*",
        "+",
        ",",
        "-",
        ".",
        "/",
        ":",
        ";",
        "<",
        "=",
        ">",
        "?",
        "[",
        "]",
        "{",
        "}"
    ];
    for(var i = 0; i < punctTable.length; i++)if ((0, $7mB9T.default).getCharCode(punctTable[i]) > 0) CHAR_MAP[$lve0x.MODE_PUNCT][(0, $7mB9T.default).getCharCode(punctTable[i])] = i;
    return CHAR_MAP;
}
var $29eccafb87ec654b$export$15ce3e30c0b81cf5 = $29eccafb87ec654b$export$cc3e6a9bbac46e84((0, $iYwLM.default).createInt32Array(5, 256));

});






parcelRegister("9e5yx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $6b79bb32c3ff3d23$export$1e511d4a378977f5, (v) => $6b79bb32c3ff3d23$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $6b79bb32c3ff3d23$export$2e2bcd8739ae039, (v) => $6b79bb32c3ff3d23$export$2e2bcd8739ae039 = v);
var $6b79bb32c3ff3d23$export$1e511d4a378977f5;
var $6b79bb32c3ff3d23$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$6b79bb32c3ff3d23$export$1e511d4a378977f5 = true;
$6b79bb32c3ff3d23$export$2e2bcd8739ae039 = void 0;

var $6b79bb32c3ff3d23$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $6b79bb32c3ff3d23$var$_react = $1jnue((parcelRequire("acw62")));

var $6b79bb32c3ff3d23$var$_reactSelect = $1jnue((parcelRequire("a21V2")));

var $6b79bb32c3ff3d23$var$_useTranslate = $1jnue((parcelRequire("90irH")));
const $6b79bb32c3ff3d23$var$Select = ({ errorMessage: errorMessage, id: id, isDisabled: isDisabled, isRequired: isRequired, label: label, onChange: onChange, options: options, values: values, zIndex: zIndex, getOptionLabel: getOptionLabel, isMulti: isMulti })=>{
    const translate = (0, $6b79bb32c3ff3d23$var$_useTranslate.default)();
    const getBorderColor = (state)=>{
        if (state.menuIsOpen || state.isFocused) return "#000";
        return isRequired && !values.length || errorMessage ? "#D43F21" : "lightgrey";
    };
    return /*#__PURE__*/ $6b79bb32c3ff3d23$var$_react.default.createElement($6b79bb32c3ff3d23$var$_react.default.Fragment, null, /*#__PURE__*/ $6b79bb32c3ff3d23$var$_react.default.createElement("p", {
        className: "body-4 text-color-secondary pb1-sm"
    }, label, isRequired && "*"), /*#__PURE__*/ $6b79bb32c3ff3d23$var$_react.default.createElement($6b79bb32c3ff3d23$var$_reactSelect.default, {
        getOptionLabel: getOptionLabel,
        id: id,
        isDisabled: isDisabled,
        isMulti: isMulti,
        options: options,
        placeholder: translate("RL_Select"),
        styles: {
            container: (styles)=>({
                    ...styles,
                    minHeight: "`60px",
                    zIndex: zIndex
                }),
            control: (styles, state)=>({
                    ...styles,
                    borderColor: getBorderColor(state),
                    boxShadow: "#000",
                    minHeight: "60px",
                    padding: "0px 0px 0px 3px",
                    zIndex: zIndex
                })
        },
        value: values,
        onChange: (newValues)=>onChange(newValues || [])
    }), /*#__PURE__*/ $6b79bb32c3ff3d23$var$_react.default.createElement("p", {
        className: "text-color-error body-4 mt2-sm"
    }, errorMessage));
};
$6b79bb32c3ff3d23$var$Select.defaultProps = {
    errorMessage: "",
    getOptionLabel: ({ label: label })=>label,
    isDisabled: false,
    isMulti: false,
    isRequired: false,
    zIndex: 1
};
$6b79bb32c3ff3d23$var$Select.propTypes = {
    errorMessage: $6b79bb32c3ff3d23$var$_propTypes.default.string,
    getOptionLabel: $6b79bb32c3ff3d23$var$_propTypes.default.func,
    id: $6b79bb32c3ff3d23$var$_propTypes.default.string.isRequired,
    isDisabled: $6b79bb32c3ff3d23$var$_propTypes.default.bool,
    isMulti: $6b79bb32c3ff3d23$var$_propTypes.default.bool,
    isRequired: $6b79bb32c3ff3d23$var$_propTypes.default.bool,
    label: $6b79bb32c3ff3d23$var$_propTypes.default.string.isRequired,
    onChange: $6b79bb32c3ff3d23$var$_propTypes.default.func.isRequired,
    options: $6b79bb32c3ff3d23$var$_propTypes.default.arrayOf($6b79bb32c3ff3d23$var$_propTypes.default.shape()).isRequired,
    values: $6b79bb32c3ff3d23$var$_propTypes.default.arrayOf($6b79bb32c3ff3d23$var$_propTypes.default.oneOfType([
        $6b79bb32c3ff3d23$var$_propTypes.default.string,
        $6b79bb32c3ff3d23$var$_propTypes.default.number,
        $6b79bb32c3ff3d23$var$_propTypes.default.shape()
    ])).isRequired,
    zIndex: $6b79bb32c3ff3d23$var$_propTypes.default.number
};
var $6b79bb32c3ff3d23$var$_default = $6b79bb32c3ff3d23$export$2e2bcd8739ae039 = $6b79bb32c3ff3d23$var$Select;

});
parcelRegister("a21V2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "NonceProvider", () => $74db94543ef6f28d$export$a7deb1594c5ce10e);
$parcel$export(module.exports, "default", () => $74db94543ef6f28d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "components", () => (parcelRequire("32kym")).F);
$parcel$export(module.exports, "createFilter", () => (parcelRequire("bUCRB")).c);
$parcel$export(module.exports, "defaultTheme", () => (parcelRequire("bUCRB")).a);
$parcel$export(module.exports, "mergeStyles", () => (parcelRequire("bUCRB")).m);
parcelRequire("gZU1N");
parcelRequire("3p9rK");
parcelRequire("02Ztr");
parcelRequire("fUHKi");
parcelRequire("g5Zhu");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");
parcelRequire("6zC7B");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");

var $jk22o = parcelRequire("jk22o");

var $f5Egd = parcelRequire("f5Egd");
parcelRequire("1u0KT");
parcelRequire("41YNz");

var $32kym = parcelRequire("32kym");

var $bUCRB = parcelRequire("bUCRB");
parcelRequire("6xSYO");
parcelRequire("gS6QF");
parcelRequire("83zt3");

var $e9Jgd = parcelRequire("e9Jgd");

var $czXz2 = parcelRequire("czXz2");
function $74db94543ef6f28d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $74db94543ef6f28d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $74db94543ef6f28d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $74db94543ef6f28d$export$a7deb1594c5ce10e = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(NonceProvider, _Component);
    var _super = $74db94543ef6f28d$var$_createSuper(NonceProvider);
    function NonceProvider(props) {
        var _this;
        (0, $6CZeq.default)(this, NonceProvider);
        _this = _super.call(this, props);
        _this.createEmotionCache = function(nonce) {
            return (0, $czXz2.default)({
                nonce: nonce
            });
        };
        _this.createEmotionCache = (0, $jk22o.default)(_this.createEmotionCache);
        return _this;
    }
    (0, $cHPF9.default)(NonceProvider, [
        {
            key: "render",
            value: function render() {
                var emotionCache = this.createEmotionCache(this.props.nonce);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f5Egd.CacheProvider), {
                    value: emotionCache
                }, this.props.children);
            }
        }
    ]);
    return NonceProvider;
}((0, $acw62.Component));
var $74db94543ef6f28d$var$index = (0, $e9Jgd.m)((0, $bUCRB.S));
var $74db94543ef6f28d$export$2e2bcd8739ae039 = $74db94543ef6f28d$var$index;

});
parcelRegister("fUHKi", function(module, exports) {

var $5F6pO = parcelRequire("5F6pO");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $8UrHA = parcelRequire("8UrHA");
function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $5F6pO(r) || $hAHB6(r) || $72a6v(r) || $8UrHA();
}
module.exports = $b95e04f2d4c66124$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5F6pO", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2zZPz(r);
}
module.exports = $41f5c206613f56c9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hAHB6", function(module, exports) {
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cce79e023a3a67e7$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8UrHA", function(module, exports) {
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $67c90abe6042aecd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});






parcelRegister("8WGmK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $68349a7ebeb82f5c$export$1e511d4a378977f5, (v) => $68349a7ebeb82f5c$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $68349a7ebeb82f5c$export$2e2bcd8739ae039, (v) => $68349a7ebeb82f5c$export$2e2bcd8739ae039 = v);
var $68349a7ebeb82f5c$export$1e511d4a378977f5;
var $68349a7ebeb82f5c$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$68349a7ebeb82f5c$export$1e511d4a378977f5 = true;
$68349a7ebeb82f5c$export$2e2bcd8739ae039 = void 0;

var $68349a7ebeb82f5c$var$_react = $68349a7ebeb82f5c$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jHTLJ");
var $2OPjR = parcelRequire("2OPjR");

var $kfZjc = parcelRequire("kfZjc");

var $68349a7ebeb82f5c$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $7Yi7V = parcelRequire("7Yi7V");

var $jMcIG = parcelRequire("jMcIG");

var $ilYXe = parcelRequire("ilYXe");

var $68349a7ebeb82f5c$var$_nativeBridge = $1jnue((parcelRequire("ciGEA")));

var $f2CEG = parcelRequire("f2CEG");

var $68349a7ebeb82f5c$var$_LoginForm = $1jnue((parcelRequire("l7mjE")));
function $68349a7ebeb82f5c$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($68349a7ebeb82f5c$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $68349a7ebeb82f5c$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $68349a7ebeb82f5c$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $68349a7ebeb82f5c$var$LogIn = ()=>{
    const [auth, setAuth] = (0, $68349a7ebeb82f5c$var$_react.useState)(false);
    const [storeCurrency, setStoreCurrency] = (0, $68349a7ebeb82f5c$var$_react.useState)("");
    const [storeId, setStoreId] = (0, $68349a7ebeb82f5c$var$_react.useState)("");
    const [storeLocale, setStoreLocale] = (0, $68349a7ebeb82f5c$var$_react.useState)("");
    const [storeTimezone, setStoreTimezone] = (0, $68349a7ebeb82f5c$var$_react.useState)("");
    const [error, setError] = (0, $68349a7ebeb82f5c$var$_react.useState)("");
    const [isFetching, setIsFetching] = (0, $68349a7ebeb82f5c$var$_react.useState)(false);
    const [athleteNumber, setAthleteNumber] = (0, $68349a7ebeb82f5c$var$_react.useState)("");
    const [athletePassword, setAthletePassword] = (0, $68349a7ebeb82f5c$var$_react.useState)("");
    const [selectedCountry, setSelectedCountry] = (0, $68349a7ebeb82f5c$var$_react.useState)("");
    const [selectedStore, setSelectedStore] = (0, $68349a7ebeb82f5c$var$_react.useState)("");
    const [isNativeLoading, setIsNativeLoading] = (0, $68349a7ebeb82f5c$var$_react.useState)($68349a7ebeb82f5c$var$_nativeBridge.default.isNativeApp());
    const dispatch = (0, $2OPjR.useDispatch)();
    // --- Shared helpers used by both native and web login flows ------------
    const saveStoreToLocalStorage = ({ country: country, currency: currency, id: id, locale: locale, storeNumber: storeNumber, region: region, timezone: timezone })=>{
        localStorage.setItem("country", country);
        localStorage.setItem("storeCurrency", currency);
        localStorage.setItem("storeId", id);
        localStorage.setItem("storeLocale", locale);
        localStorage.setItem("storeNumber", storeNumber);
        localStorage.setItem("storeRegion", region);
        localStorage.setItem("storeTimezone", timezone);
    };
    const saveScsConfig = (data)=>{
        Object.keys(data).forEach((key)=>{
            localStorage.setItem(`scs.${key}`, data[key]);
        });
    };
    const updateStoreState = ({ country: country, storeNumber: storeNumber, currency: currency, id: id, locale: locale, timezone: timezone })=>{
        setSelectedCountry(country);
        setSelectedStore(storeNumber);
        setStoreCurrency(currency);
        setStoreId(id);
        setStoreLocale(locale);
        dispatch((0, $jMcIG.setLocale)(locale));
        setStoreTimezone(timezone);
    };
    const saveTranslationsFlag = (locale)=>{
        const isTranslationsAvailable = locale === $7Yi7V.DEFAULT_LOCALE || (0, $f2CEG.isAllTranslationsPresent)(locale);
        localStorage.setItem("isTranslationsAvailable", isTranslationsAvailable);
    };
    const dispatchFeatureFlags = ()=>{
        dispatch((0, $jMcIG.setIsMarkdownEnabled)(localStorage.getItem($7Yi7V.scsKeys.createMarkdowns) === "true"));
        dispatch((0, $jMcIG.setIsCreatePromotionEnabled)(localStorage.getItem($7Yi7V.scsKeys.createPromotions) === "true"));
        dispatch((0, $jMcIG.setIsCsvUploadEnabled)(localStorage.getItem($7Yi7V.scsKeys.isStyleUploadEnabled) === "true"));
        dispatch((0, $jMcIG.setAllowPromoteApp)(localStorage.getItem($7Yi7V.scsKeys.allowPromoteApp) === "true"));
    };
    const loadPromoteConfig = async (country, storeNumber)=>{
        const { data: data, errorMessage: errorMessage } = await (0, $ilYXe.getPromoteConfig)(country, storeNumber);
        if (errorMessage) {
            localStorage.setItem($7Yi7V.scsKeys.allowPromoteApp, "false");
            throw new Error(errorMessage);
        }
        saveScsConfig(data);
    };
    // --- Effects -----------------------------------------------------------
    (0, $68349a7ebeb82f5c$var$_react.useEffect)(()=>{
        dispatch((0, $jMcIG.setCountry)(selectedCountry));
        return ()=>{
            dispatch((0, $jMcIG.setCountry)(selectedCountry));
        };
    }, [
        selectedCountry,
        dispatch
    ]);
    // --- Native bridge auto-login ------------------------------------------
    (0, $68349a7ebeb82f5c$var$_react.useEffect)(()=>{
        if (!$68349a7ebeb82f5c$var$_nativeBridge.default.isNativeApp()) return;
        const nativeLogin = async ()=>{
            setIsNativeLoading(true);
            setError("");
            try {
                const token = await $68349a7ebeb82f5c$var$_nativeBridge.default.requestAthleteToken();
                const payload = $68349a7ebeb82f5c$var$_Auth.default.loginWithNativeToken(token);
                const country = payload.nike_country;
                const storeNumber = payload.nike_store;
                const storeData = await (0, $ilYXe.getStore)(country, storeNumber);
                saveStoreToLocalStorage({
                    country: country,
                    currency: storeData.currency,
                    id: storeData.id,
                    locale: storeData.locale,
                    region: storeData.region,
                    storeNumber: storeNumber,
                    timezone: storeData.timezone
                });
                await loadPromoteConfig(country, storeNumber);
                updateStoreState({
                    country: country,
                    currency: storeData.currency,
                    id: storeData.id,
                    locale: storeData.locale,
                    storeNumber: storeNumber,
                    timezone: storeData.timezone
                });
                saveTranslationsFlag(storeData.locale);
                dispatchFeatureFlags();
                setAuth(true);
            } catch (err) {
                setError(err.message || "Native authentication failed");
                setIsNativeLoading(false);
            }
        };
        nativeLogin();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // --- Web username/password helpers -------------------------------------
    const formIsNotFilled = ()=>!(athleteNumber.length && athletePassword.length && selectedCountry !== null && selectedCountry !== void 0 && selectedCountry.length && selectedStore.length);
    const onSubmit = async ()=>{
        setIsFetching(true);
        setError("");
        try {
            await $68349a7ebeb82f5c$var$_Auth.default.login({
                athleteNumber: athleteNumber,
                athletePassword: athletePassword,
                selectedCountry: selectedCountry,
                selectedStore: selectedStore
            });
            const { currency: currency, id: id, locale: locale, region: region, timezone: timezone } = await (0, $ilYXe.getStore)(selectedCountry, selectedStore);
            saveStoreToLocalStorage({
                country: selectedCountry,
                currency: currency,
                id: id,
                locale: locale,
                region: region,
                storeNumber: selectedStore,
                timezone: timezone
            });
            await loadPromoteConfig(selectedCountry, selectedStore);
            updateStoreState({
                country: selectedCountry,
                currency: currency,
                id: id,
                locale: locale,
                storeNumber: selectedStore,
                timezone: timezone
            });
            saveTranslationsFlag(locale);
            dispatchFeatureFlags();
            setAuth(true);
        } catch (err) {
            setError(err.message || "Sign in Failed");
            localStorage.clear();
            setAuth(false);
        } finally{
            setIsFetching(false);
        }
    };
    // --- Render ------------------------------------------------------------
    if (auth) return /*#__PURE__*/ $68349a7ebeb82f5c$var$_react.default.createElement($kfZjc.Redirect, {
        to: {
            pathname: "/promotions",
            state: {
                country: selectedCountry,
                storeCurrency: storeCurrency,
                storeId: storeId,
                storeLocale: storeLocale,
                storeNumber: selectedStore,
                storeTimezone: storeTimezone
            }
        }
    });
    if (isNativeLoading) return /*#__PURE__*/ $68349a7ebeb82f5c$var$_react.default.createElement("section", {
        className: "ncss-col-sm-12 ta-sm-c mt10-sm"
    }, /*#__PURE__*/ $68349a7ebeb82f5c$var$_react.default.createElement("h1", {
        className: "display-3 mb4-sm"
    }, "Signing in\u2026"), /*#__PURE__*/ $68349a7ebeb82f5c$var$_react.default.createElement("p", {
        className: "body-2 text-color-secondary"
    }, "Authenticating with Nike app"));
    if ($68349a7ebeb82f5c$var$_nativeBridge.default.isNativeApp() && error) return /*#__PURE__*/ $68349a7ebeb82f5c$var$_react.default.createElement("section", {
        className: "ncss-col-sm-12 ta-sm-c mt10-sm"
    }, /*#__PURE__*/ $68349a7ebeb82f5c$var$_react.default.createElement("h1", {
        className: "display-3 mb4-sm"
    }, "Promote App"), /*#__PURE__*/ $68349a7ebeb82f5c$var$_react.default.createElement("p", {
        className: "body-2 text-color-error"
    }, error));
    return /*#__PURE__*/ $68349a7ebeb82f5c$var$_react.default.createElement($68349a7ebeb82f5c$var$_LoginForm.default, {
        disableSubmit: formIsNotFilled(),
        errorMessage: error,
        fetching: isFetching,
        loginInformation: {
            athleteNumber: athleteNumber,
            athletePassword: athletePassword,
            selectedCountry: selectedCountry,
            selectedStore: selectedStore
        },
        setAthleteNumber: setAthleteNumber,
        setAthletePassword: setAthletePassword,
        setSelectedCountry: setSelectedCountry,
        setSelectedStore: setSelectedStore,
        onSubmit: onSubmit
    });
};
var $68349a7ebeb82f5c$var$_default = $68349a7ebeb82f5c$export$2e2bcd8739ae039 = $68349a7ebeb82f5c$var$LogIn;

});
parcelRegister("l7mjE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $f5fb8fe14c9948a3$export$1e511d4a378977f5, (v) => $f5fb8fe14c9948a3$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $f5fb8fe14c9948a3$export$2e2bcd8739ae039, (v) => $f5fb8fe14c9948a3$export$2e2bcd8739ae039 = v);
var $f5fb8fe14c9948a3$export$1e511d4a378977f5;
var $f5fb8fe14c9948a3$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$f5fb8fe14c9948a3$export$1e511d4a378977f5 = true;
$f5fb8fe14c9948a3$export$2e2bcd8739ae039 = void 0;

var $jXPi8 = parcelRequire("jXPi8");

var $7c2S2 = parcelRequire("7c2S2");

var $f5fb8fe14c9948a3$var$_i18nIsoCountries = $1jnue((parcelRequire("1Sw2c")));

var $f5fb8fe14c9948a3$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $f5fb8fe14c9948a3$var$_react = $1jnue((parcelRequire("acw62")));

var $f5fb8fe14c9948a3$var$_countriesWithNikeStores = $1jnue((parcelRequire("40fBa")));

var $ikfii = parcelRequire("ikfii");

$f5fb8fe14c9948a3$var$_i18nIsoCountries.default.registerLocale((parcelRequire("hcrRu")));
const $f5fb8fe14c9948a3$var$countryToFlag = (isoCode)=>typeof String.fromCodePoint !== "undefined" ? $f5fb8fe14c9948a3$var$_i18nIsoCountries.default.alpha3ToAlpha2(isoCode).replace(/./g, (char)=>String.fromCodePoint(char.charCodeAt(0) + 127397)) : isoCode;
const $f5fb8fe14c9948a3$var$convertCountryCodes = (nikeCountries)=>nikeCountries.map((country)=>({
            label: `${country.label} ${$f5fb8fe14c9948a3$var$countryToFlag(country.value)} `,
            value: country.value
        }));
const $f5fb8fe14c9948a3$var$LoginForm = (props)=>/*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement($f5fb8fe14c9948a3$var$_react.default.Fragment, null, /*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement("section", {
        className: "ncss-col-sm-12 full ncss-col-md-6 ta-sm-l mt3-sm mb3-sm"
    }, /*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement("section", {
        className: "ncss-col-sm-12 ta-sm-c mb3-sm"
    }, /*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement($7c2S2.NikeApp, {
        "aria-hidden": true,
        className: "flx-as-sm-c",
        size: "l"
    }), /*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement("h1", {
        className: "display-3"
    }, "Promote App")), /*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement($ikfii.Input, {
        isRequired: true,
        id: "athleteNumberInput",
        label: "Athlete Number",
        maxLength: 40,
        minLength: 1,
        value: props.loginInformation.athleteNumber,
        onChange: props.setAthleteNumber
    }), /*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement($ikfii.Input, {
        isRequired: true,
        id: "athletePasswordInput",
        label: "Athlete Password",
        type: "password",
        value: props.loginInformation.athletePassword,
        onChange: props.setAthletePassword
    }), /*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement($jXPi8.DropDownStyled, {
        autoComplete: "on",
        id: "storeCountryInput",
        label: "Store Country",
        name: "Store Country",
        options: $f5fb8fe14c9948a3$var$convertCountryCodes($f5fb8fe14c9948a3$var$_countriesWithNikeStores.default),
        requiredIndicator: "*",
        value: props.loginInformation.selectedCountry,
        onChange: ({ target: { value: newValue } })=>props.setSelectedCountry(newValue)
    }), /*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement($ikfii.Input, {
        isRequired: true,
        id: "selectedStoreInput",
        label: "Store Number",
        value: props.loginInformation.selectedStore,
        onChange: props.setSelectedStore
    }), /*#__PURE__*/ $f5fb8fe14c9948a3$var$_react.default.createElement($ikfii.ButtonSubmit, {
        isDisabled: props.disableSubmit,
        isSubmitting: props.fetching,
        label: "Sign In",
        messageError: props.errorMessage,
        onSubmit: props.onSubmit
    })));
$f5fb8fe14c9948a3$var$LoginForm.propTypes = {
    disableSubmit: $f5fb8fe14c9948a3$var$_propTypes.default.bool.isRequired,
    errorMessage: $f5fb8fe14c9948a3$var$_propTypes.default.string.isRequired,
    fetching: $f5fb8fe14c9948a3$var$_propTypes.default.bool.isRequired,
    loginInformation: $f5fb8fe14c9948a3$var$_propTypes.default.shape({
        athleteNumber: $f5fb8fe14c9948a3$var$_propTypes.default.string.isRequired,
        athletePassword: $f5fb8fe14c9948a3$var$_propTypes.default.string.isRequired,
        selectedCountry: $f5fb8fe14c9948a3$var$_propTypes.default.string.isRequired,
        selectedStore: $f5fb8fe14c9948a3$var$_propTypes.default.string.isRequired
    }).isRequired,
    onSubmit: $f5fb8fe14c9948a3$var$_propTypes.default.func.isRequired,
    setAthleteNumber: $f5fb8fe14c9948a3$var$_propTypes.default.func.isRequired,
    setAthletePassword: $f5fb8fe14c9948a3$var$_propTypes.default.func.isRequired,
    setSelectedCountry: $f5fb8fe14c9948a3$var$_propTypes.default.func.isRequired,
    setSelectedStore: $f5fb8fe14c9948a3$var$_propTypes.default.func.isRequired
};
var $f5fb8fe14c9948a3$var$_default = $f5fb8fe14c9948a3$export$2e2bcd8739ae039 = $f5fb8fe14c9948a3$var$LoginForm;

});
parcelRegister("7c2S2", function(module, exports) {

$parcel$export(module.exports, "NikeApp", () => $53cbe16e41f7911d$export$3efa64408a941cdb);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $53cbe16e41f7911d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $53cbe16e41f7911d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $53cbe16e41f7911d$var$_typeof(o);
}
function $53cbe16e41f7911d$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $53cbe16e41f7911d$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $53cbe16e41f7911d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $53cbe16e41f7911d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $53cbe16e41f7911d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $53cbe16e41f7911d$var$_defineProperty(obj, key, value) {
    key = $53cbe16e41f7911d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $53cbe16e41f7911d$var$_toPropertyKey(t) {
    var i = $53cbe16e41f7911d$var$_toPrimitive(t, "string");
    return "symbol" == $53cbe16e41f7911d$var$_typeof(i) ? i : String(i);
}
function $53cbe16e41f7911d$var$_toPrimitive(t, r) {
    if ("object" != $53cbe16e41f7911d$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $53cbe16e41f7911d$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $53cbe16e41f7911d$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
        clipRule: "evenodd"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
        clipRule: "evenodd"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M42 17.438L15.672 28.606C13.48 29.536 11.636 30 10.15 30c-1.672 0-2.89-.59-3.638-1.768-.97-1.518-.546-3.964 1.118-6.544.988-1.508 2.244-2.892 3.468-4.216-.288.468-2.83 4.698-.05 6.69.55.4 1.332.596 2.294.596.772 0 1.658-.126 2.632-.38L42 17.438z",
        clipRule: "evenodd"
    }))
};
var $53cbe16e41f7911d$export$3efa64408a941cdb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $53cbe16e41f7911d$var$_objectSpread($53cbe16e41f7911d$var$_objectSpread({}, props), {}, {
        paths: $53cbe16e41f7911d$var$compPaths,
        fill: "none"
    }));
});
$53cbe16e41f7911d$export$3efa64408a941cdb.displayName = "[Deprecated] NikeApp";

});

parcelRegister("1Sw2c", function(module, exports) {

$parcel$export(module.exports, "registerLocale", () => $15e3aefa8e338b9b$export$bab6a7822cc1e2cd, (v) => $15e3aefa8e338b9b$export$bab6a7822cc1e2cd = v);
$parcel$export(module.exports, "alpha3ToAlpha2", () => $15e3aefa8e338b9b$export$2a91d0f6f59b9f68, (v) => $15e3aefa8e338b9b$export$2a91d0f6f59b9f68 = v);
$parcel$export(module.exports, "alpha2ToAlpha3", () => $15e3aefa8e338b9b$export$65a456803fd0f049, (v) => $15e3aefa8e338b9b$export$65a456803fd0f049 = v);
$parcel$export(module.exports, "alpha3ToNumeric", () => $15e3aefa8e338b9b$export$442b6884bee533cd, (v) => $15e3aefa8e338b9b$export$442b6884bee533cd = v);
$parcel$export(module.exports, "alpha2ToNumeric", () => $15e3aefa8e338b9b$export$e8f1fd30e9fba660, (v) => $15e3aefa8e338b9b$export$e8f1fd30e9fba660 = v);
$parcel$export(module.exports, "numericToAlpha3", () => $15e3aefa8e338b9b$export$c50ba58d0968541f, (v) => $15e3aefa8e338b9b$export$c50ba58d0968541f = v);
$parcel$export(module.exports, "numericToAlpha2", () => $15e3aefa8e338b9b$export$e21a59c72a3c77a7, (v) => $15e3aefa8e338b9b$export$e21a59c72a3c77a7 = v);
$parcel$export(module.exports, "toAlpha3", () => $15e3aefa8e338b9b$export$3d1d5c3d00561285, (v) => $15e3aefa8e338b9b$export$3d1d5c3d00561285 = v);
$parcel$export(module.exports, "toAlpha2", () => $15e3aefa8e338b9b$export$53e0b99b5d556acf, (v) => $15e3aefa8e338b9b$export$53e0b99b5d556acf = v);
$parcel$export(module.exports, "getName", () => $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e, (v) => $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e = v);
$parcel$export(module.exports, "getNames", () => $15e3aefa8e338b9b$export$dc8de070e3f64a1a, (v) => $15e3aefa8e338b9b$export$dc8de070e3f64a1a = v);
$parcel$export(module.exports, "getAlpha2Code", () => $15e3aefa8e338b9b$export$9abd449eff192ddc, (v) => $15e3aefa8e338b9b$export$9abd449eff192ddc = v);
$parcel$export(module.exports, "getSimpleAlpha2Code", () => $15e3aefa8e338b9b$export$2db6702cc2165503, (v) => $15e3aefa8e338b9b$export$2db6702cc2165503 = v);
$parcel$export(module.exports, "getAlpha2Codes", () => $15e3aefa8e338b9b$export$f340c49a8d00de7f, (v) => $15e3aefa8e338b9b$export$f340c49a8d00de7f = v);
$parcel$export(module.exports, "getAlpha3Code", () => $15e3aefa8e338b9b$export$51175d5ff4bc4261, (v) => $15e3aefa8e338b9b$export$51175d5ff4bc4261 = v);
$parcel$export(module.exports, "getSimpleAlpha3Code", () => $15e3aefa8e338b9b$export$13496d6083a3d6ac, (v) => $15e3aefa8e338b9b$export$13496d6083a3d6ac = v);
$parcel$export(module.exports, "getAlpha3Codes", () => $15e3aefa8e338b9b$export$5b1d6865bbe9ebc, (v) => $15e3aefa8e338b9b$export$5b1d6865bbe9ebc = v);
$parcel$export(module.exports, "getNumericCodes", () => $15e3aefa8e338b9b$export$5169b68793e9dfd1, (v) => $15e3aefa8e338b9b$export$5169b68793e9dfd1 = v);
$parcel$export(module.exports, "langs", () => $15e3aefa8e338b9b$export$359be4c8544d6fb1, (v) => $15e3aefa8e338b9b$export$359be4c8544d6fb1 = v);
$parcel$export(module.exports, "isValid", () => $15e3aefa8e338b9b$export$1ea939691cdc45b8, (v) => $15e3aefa8e338b9b$export$1ea939691cdc45b8 = v);
/**
 * Register countries in browsers' environment:
 * @param {object} localeData
 * @example countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
 * @return void
 */ var $15e3aefa8e338b9b$export$bab6a7822cc1e2cd;
var $15e3aefa8e338b9b$export$2a91d0f6f59b9f68;
var $15e3aefa8e338b9b$export$65a456803fd0f049;
var $15e3aefa8e338b9b$export$442b6884bee533cd;
var $15e3aefa8e338b9b$export$e8f1fd30e9fba660;
var $15e3aefa8e338b9b$export$c50ba58d0968541f;
var $15e3aefa8e338b9b$export$e21a59c72a3c77a7;
var $15e3aefa8e338b9b$export$3d1d5c3d00561285;
var $15e3aefa8e338b9b$export$53e0b99b5d556acf;
/**
 * @param {string | number | Alpha2Code | Alpha3Code} code
 * @param {String} lang          language for country name
 * @param {GetNameOptions} options
 * @return {String | String[] | undefined}  name
 */ var $15e3aefa8e338b9b$export$7d9f7e9c1c02b41e;
/**
 * @param {String} lang             language for country names
 * @param {GetNameOptions} options   getNames Options
 * @return {LocalizedCountryNames}  country code
 *                                  mapped to county name
 */ var $15e3aefa8e338b9b$export$dc8de070e3f64a1a;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $15e3aefa8e338b9b$export$9abd449eff192ddc;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-2 or undefined
 */ var $15e3aefa8e338b9b$export$2db6702cc2165503;
/*
 * @return Object of alpha-2 codes mapped to alpha-3 codes
 */ var $15e3aefa8e338b9b$export$f340c49a8d00de7f;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $15e3aefa8e338b9b$export$51175d5ff4bc4261;
/*
 * @param name name
 * @param lang language for country name
 * @return ISO 3166-1 alpha-3 or undefined
 */ var $15e3aefa8e338b9b$export$13496d6083a3d6ac;
/*
 * @return Object of alpha-3 codes mapped to alpha-2 codes
 */ var $15e3aefa8e338b9b$export$5b1d6865bbe9ebc;
/*
 * @return Object of numeric codes mapped to alpha-2 codes
 */ var $15e3aefa8e338b9b$export$5169b68793e9dfd1;
/*
 * @return Array of supported languages
 */ var $15e3aefa8e338b9b$export$359be4c8544d6fb1;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return Boolean
 */ var $15e3aefa8e338b9b$export$1ea939691cdc45b8;
"use strict";

var $iKxK4 = parcelRequire("iKxK4");

var $9t0q2 = parcelRequire("9t0q2");
var $15e3aefa8e338b9b$require$removeDiacritics = $9t0q2.remove;
const $15e3aefa8e338b9b$var$registeredLocales = {};
/*
 * All codes map to ISO 3166-1 alpha-2
 */ const $15e3aefa8e338b9b$var$alpha2 = {}, $15e3aefa8e338b9b$var$alpha3 = {}, $15e3aefa8e338b9b$var$numeric = {}, $15e3aefa8e338b9b$var$invertedNumeric = {};
$iKxK4.forEach(function(codeInformation) {
    const s = codeInformation;
    $15e3aefa8e338b9b$var$alpha2[s[0]] = s[1];
    $15e3aefa8e338b9b$var$alpha3[s[1]] = s[0];
    $15e3aefa8e338b9b$var$numeric[s[2]] = s[0];
    $15e3aefa8e338b9b$var$invertedNumeric[s[0]] = s[2];
});
/**
 * @private
 * @param {number} code
 */ function $15e3aefa8e338b9b$var$formatNumericCode(code) {
    return String("000" + (code ? code : "")).slice(-3);
}
/**
 * @private
 * Avoid using obj.hasOwnProperty directly as `hasOwnProperty` could be a
 * property in itself ({ hasOwnProperty: 1 }) and cause weird bugs
 * https://eslint.org/docs/rules/no-prototype-builtins
 */ function $15e3aefa8e338b9b$var$hasOwnProperty(object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
}
/**
 * @private
 * Pass localeList through a filter and return a newLocaleList obj
 * with the same structure of the old localeList.
 *
 * @param {LocalizedCountryNames} localeList  Local List in raw
 * @param {Function} filter    callback to set filter rule
 * @return {String | String[]} new filtered Local List
 */ function $15e3aefa8e338b9b$var$localeFilter(localeList, filter) {
    return Object.keys(localeList).reduce(function(newLocaleList, alpha2) {
        const nameList = localeList[alpha2];
        newLocaleList[alpha2] = filter(nameList, alpha2);
        return newLocaleList;
    }, {});
}
/**
 * @private
 * Preserve for getName & getNames
 *
 * @param {GetNameOptions.select} type all | official | alias
 * @param countryNameList  string array of country's
 *                         official name and alias
 * @return {String | String[]} of a country name
 */ function $15e3aefa8e338b9b$var$filterNameBy(type, countryNameList) {
    switch(type){
        case "official":
            return Array.isArray(countryNameList) ? countryNameList[0] : countryNameList;
        case "all":
            return typeof countryNameList === "string" ? [
                countryNameList
            ] : countryNameList;
        case "alias":
            return Array.isArray(countryNameList) ? countryNameList[1] || countryNameList[0] : countryNameList;
        default:
            throw new TypeError("LocaleNameType must be one of these: all, official, alias!");
    }
}
$15e3aefa8e338b9b$export$bab6a7822cc1e2cd = function(localeData) {
    if (!localeData.locale) throw new TypeError("Missing localeData.locale");
    if (!localeData.countries) throw new TypeError("Missing localeData.countries");
    $15e3aefa8e338b9b$var$registeredLocales[localeData.locale] = localeData.countries;
};
/*
 * @param code Alpha-3 code
 * @return Alpha-2 code or undefined
 */ function $15e3aefa8e338b9b$var$alpha3ToAlpha2(code) {
    return $15e3aefa8e338b9b$var$alpha3[code];
}
$15e3aefa8e338b9b$export$2a91d0f6f59b9f68 = $15e3aefa8e338b9b$var$alpha3ToAlpha2;
/*
 * @param code Alpha-2 code
 * @return Alpha-3 code or undefined
 */ function $15e3aefa8e338b9b$var$alpha2ToAlpha3(code) {
    return $15e3aefa8e338b9b$var$alpha2[code];
}
$15e3aefa8e338b9b$export$65a456803fd0f049 = $15e3aefa8e338b9b$var$alpha2ToAlpha3;
/*
 * @param code Alpha-3 code
 * @return Numeric code or undefined
 */ function $15e3aefa8e338b9b$var$alpha3ToNumeric(code) {
    return $15e3aefa8e338b9b$var$invertedNumeric[$15e3aefa8e338b9b$var$alpha3ToAlpha2(code)];
}
$15e3aefa8e338b9b$export$442b6884bee533cd = $15e3aefa8e338b9b$var$alpha3ToNumeric;
/*
 * @param code Alpha-2 code
 * @return Numeric code or undefined
 */ function $15e3aefa8e338b9b$var$alpha2ToNumeric(code) {
    return $15e3aefa8e338b9b$var$invertedNumeric[code];
}
$15e3aefa8e338b9b$export$e8f1fd30e9fba660 = $15e3aefa8e338b9b$var$alpha2ToNumeric;
/*
 * @param code Numeric code
 * @return Alpha-3 code or undefined
 */ function $15e3aefa8e338b9b$var$numericToAlpha3(code) {
    const padded = $15e3aefa8e338b9b$var$formatNumericCode(code);
    return $15e3aefa8e338b9b$var$alpha2ToAlpha3($15e3aefa8e338b9b$var$numeric[padded]);
}
$15e3aefa8e338b9b$export$c50ba58d0968541f = $15e3aefa8e338b9b$var$numericToAlpha3;
/*
 * @param code Numeric code
 * @return Alpha-2 code or undefined
 */ function $15e3aefa8e338b9b$var$numericToAlpha2(code) {
    const padded = $15e3aefa8e338b9b$var$formatNumericCode(code);
    return $15e3aefa8e338b9b$var$numeric[padded];
}
$15e3aefa8e338b9b$export$e21a59c72a3c77a7 = $15e3aefa8e338b9b$var$numericToAlpha2;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-3
 */ function $15e3aefa8e338b9b$var$toAlpha3(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $15e3aefa8e338b9b$var$numericToAlpha3(code);
        if (code.length === 2) return $15e3aefa8e338b9b$var$alpha2ToAlpha3(code.toUpperCase());
        if (code.length === 3) return code.toUpperCase();
    }
    if (typeof code === "number") return $15e3aefa8e338b9b$var$numericToAlpha3(code);
    return undefined;
}
$15e3aefa8e338b9b$export$3d1d5c3d00561285 = $15e3aefa8e338b9b$var$toAlpha3;
/*
 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
 * @return ISO 3166-1 alpha-2
 */ function $15e3aefa8e338b9b$var$toAlpha2(code) {
    if (typeof code === "string") {
        if (/^[0-9]*$/.test(code)) return $15e3aefa8e338b9b$var$numericToAlpha2(code);
        if (code.length === 2) return code.toUpperCase();
        if (code.length === 3) return $15e3aefa8e338b9b$var$alpha3ToAlpha2(code.toUpperCase());
    }
    if (typeof code === "number") return $15e3aefa8e338b9b$var$numericToAlpha2(code);
    return undefined;
}
$15e3aefa8e338b9b$export$53e0b99b5d556acf = $15e3aefa8e338b9b$var$toAlpha2;
$15e3aefa8e338b9b$export$7d9f7e9c1c02b41e = function(code, lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    try {
        const codeMaps = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
        const nameList = codeMaps[$15e3aefa8e338b9b$var$toAlpha2(code)];
        return $15e3aefa8e338b9b$var$filterNameBy(options.select, nameList);
    } catch (err) {
        return undefined;
    }
};
$15e3aefa8e338b9b$export$dc8de070e3f64a1a = function(lang, options = {}) {
    if (!("select" in options)) options.select = "official";
    const localeList = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
    if (localeList === undefined) return {};
    return $15e3aefa8e338b9b$var$localeFilter(localeList, function(nameList) {
        return $15e3aefa8e338b9b$var$filterNameBy(options.select, nameList);
    });
};
$15e3aefa8e338b9b$export$9abd449eff192ddc = function(name, lang) {
    const normalizeString = (string)=>string.toLowerCase();
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$15e3aefa8e338b9b$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$15e3aefa8e338b9b$export$2db6702cc2165503 = function(name, lang) {
    const normalizeString = (string)=>$15e3aefa8e338b9b$require$removeDiacritics(string.toLowerCase());
    const areSimilar = (a, b)=>normalizeString(a) === normalizeString(b);
    try {
        const codenames = $15e3aefa8e338b9b$var$registeredLocales[lang.toLowerCase()];
        for(const p in codenames){
            if (!$15e3aefa8e338b9b$var$hasOwnProperty(codenames, p)) continue;
            if (typeof codenames[p] === "string") {
                if (areSimilar(codenames[p], name)) return p;
            }
            if (Array.isArray(codenames[p])) for (const mappedName of codenames[p]){
                if (areSimilar(mappedName, name)) return p;
            }
        }
        return undefined;
    } catch (err) {
        return undefined;
    }
};
$15e3aefa8e338b9b$export$f340c49a8d00de7f = function() {
    return $15e3aefa8e338b9b$var$alpha2;
};
$15e3aefa8e338b9b$export$51175d5ff4bc4261 = function(name, lang) {
    const alpha2 = $15e3aefa8e338b9b$export$9abd449eff192ddc(name, lang);
    if (alpha2) return $15e3aefa8e338b9b$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$15e3aefa8e338b9b$export$13496d6083a3d6ac = function(name, lang) {
    const alpha2 = $15e3aefa8e338b9b$export$2db6702cc2165503(name, lang);
    if (alpha2) return $15e3aefa8e338b9b$export$3d1d5c3d00561285(alpha2);
    else return undefined;
};
$15e3aefa8e338b9b$export$5b1d6865bbe9ebc = function() {
    return $15e3aefa8e338b9b$var$alpha3;
};
$15e3aefa8e338b9b$export$5169b68793e9dfd1 = function() {
    return $15e3aefa8e338b9b$var$numeric;
};
$15e3aefa8e338b9b$export$359be4c8544d6fb1 = function() {
    return Object.keys($15e3aefa8e338b9b$var$registeredLocales);
};
$15e3aefa8e338b9b$export$1ea939691cdc45b8 = function(code) {
    if (!code) return false;
    const coerced = code.toString().toUpperCase();
    return $15e3aefa8e338b9b$var$hasOwnProperty($15e3aefa8e338b9b$var$alpha3, coerced) || $15e3aefa8e338b9b$var$hasOwnProperty($15e3aefa8e338b9b$var$alpha2, coerced) || $15e3aefa8e338b9b$var$hasOwnProperty($15e3aefa8e338b9b$var$numeric, coerced);
};

});
parcelRegister("iKxK4", function(module, exports) {
module.exports = JSON.parse('[["AF","AFG","004","ISO 3166-2:AF"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["MK","MKD","807","ISO 3166-2:MK"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["AX","ALA","248","ISO 3166-2:AX"],["BQ","BES","535","ISO 3166-2:BQ"],["CW","CUW","531","ISO 3166-2:CW"],["GG","GGY","831","ISO 3166-2:GG"],["IM","IMN","833","ISO 3166-2:IM"],["JE","JEY","832","ISO 3166-2:JE"],["ME","MNE","499","ISO 3166-2:ME"],["BL","BLM","652","ISO 3166-2:BL"],["MF","MAF","663","ISO 3166-2:MF"],["RS","SRB","688","ISO 3166-2:RS"],["SX","SXM","534","ISO 3166-2:SX"],["SS","SSD","728","ISO 3166-2:SS"],["XK","XKX","983","ISO 3166-2:XK"]]');

});

parcelRegister("9t0q2", function(module, exports) {

$parcel$export(module.exports, "remove", () => $6e4725ac584d2777$export$cd7f480d6b8286c3, (v) => $6e4725ac584d2777$export$cd7f480d6b8286c3 = v);
var $6e4725ac584d2777$export$cd7f480d6b8286c3;
var $6e4725ac584d2777$export$452fcf31d2a11c49;
var $6e4725ac584d2777$export$a078a2660a2c4d03;
$6e4725ac584d2777$export$cd7f480d6b8286c3 = $6e4725ac584d2777$var$removeDiacritics;
var $6e4725ac584d2777$var$replacementList = [
    {
        base: " ",
        chars: "\xa0"
    },
    {
        base: "0",
        chars: "\u07C0"
    },
    {
        base: "A",
        chars: "\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        chars: "\uA732"
    },
    {
        base: "AE",
        chars: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        chars: "\uA734"
    },
    {
        base: "AU",
        chars: "\uA736"
    },
    {
        base: "AV",
        chars: "\uA738\uA73A"
    },
    {
        base: "AY",
        chars: "\uA73C"
    },
    {
        base: "B",
        chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181"
    },
    {
        base: "C",
        chars: "\u24B8\uFF23\uA73E\u1E08\u0106C\u0108\u010A\u010C\xc7\u0187\u023B"
    },
    {
        base: "D",
        chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779"
    },
    {
        base: "Dh",
        chars: "\xd0"
    },
    {
        base: "DZ",
        chars: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        chars: "\u01F2\u01C5"
    },
    {
        base: "E",
        chars: "\u025B\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07"
    },
    {
        base: "F",
        chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262"
    },
    {
        base: "H",
        chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        chars: "\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        chars: "\u24BF\uFF2A\u0134\u0248\u0237"
    },
    {
        base: "K",
        chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        chars: "\u01C7"
    },
    {
        base: "Lj",
        chars: "\u01C8"
    },
    {
        base: "M",
        chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB"
    },
    {
        base: "N",
        chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E"
    },
    {
        base: "NJ",
        chars: "\u01CA"
    },
    {
        base: "Nj",
        chars: "\u01CB"
    },
    {
        base: "O",
        chars: "\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OE",
        chars: "\u0152"
    },
    {
        base: "OI",
        chars: "\u01A2"
    },
    {
        base: "OO",
        chars: "\uA74E"
    },
    {
        base: "OU",
        chars: "\u0222"
    },
    {
        base: "P",
        chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        chars: "\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "Th",
        chars: "\xde"
    },
    {
        base: "TZ",
        chars: "\uA728"
    },
    {
        base: "U",
        chars: "\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        chars: "\uA760"
    },
    {
        base: "W",
        chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        chars: "\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        chars: "\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        chars: "\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251"
    },
    {
        base: "aa",
        chars: "\uA733"
    },
    {
        base: "ae",
        chars: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        chars: "\uA735"
    },
    {
        base: "au",
        chars: "\uA737"
    },
    {
        base: "av",
        chars: "\uA739\uA73B"
    },
    {
        base: "ay",
        chars: "\uA73D"
    },
    {
        base: "b",
        chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182"
    },
    {
        base: "c",
        chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA"
    },
    {
        base: "dh",
        chars: "\xf0"
    },
    {
        base: "dz",
        chars: "\u01F3\u01C6"
    },
    {
        base: "e",
        chars: "\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD"
    },
    {
        base: "f",
        chars: "\u24D5\uFF46\u1E1F\u0192"
    },
    {
        base: "ff",
        chars: "\uFB00"
    },
    {
        base: "fi",
        chars: "\uFB01"
    },
    {
        base: "fl",
        chars: "\uFB02"
    },
    {
        base: "ffi",
        chars: "\uFB03"
    },
    {
        base: "ffl",
        chars: "\uFB04"
    },
    {
        base: "g",
        chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79"
    },
    {
        base: "h",
        chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        chars: "\u0195"
    },
    {
        base: "i",
        chars: "\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        chars: "\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D"
    },
    {
        base: "lj",
        chars: "\u01C9"
    },
    {
        base: "m",
        chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        chars: "\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509"
    },
    {
        base: "nj",
        chars: "\u01CC"
    },
    {
        base: "o",
        chars: "\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\uA74B\uA74D\u0275\u0254\u1D11"
    },
    {
        base: "oe",
        chars: "\u0153"
    },
    {
        base: "oi",
        chars: "\u01A3"
    },
    {
        base: "oo",
        chars: "\uA74F"
    },
    {
        base: "ou",
        chars: "\u0223"
    },
    {
        base: "p",
        chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1"
    },
    {
        base: "q",
        chars: "\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282"
    },
    {
        base: "ss",
        chars: "\xdf"
    },
    {
        base: "t",
        chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "th",
        chars: "\xfe"
    },
    {
        base: "tz",
        chars: "\uA729"
    },
    {
        base: "u",
        chars: "\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        chars: "\uA761"
    },
    {
        base: "w",
        chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        chars: "\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        chars: "\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $6e4725ac584d2777$var$diacriticsMap = {};
for(var $6e4725ac584d2777$var$i = 0; $6e4725ac584d2777$var$i < $6e4725ac584d2777$var$replacementList.length; $6e4725ac584d2777$var$i += 1){
    var $6e4725ac584d2777$var$chars = $6e4725ac584d2777$var$replacementList[$6e4725ac584d2777$var$i].chars;
    for(var $6e4725ac584d2777$var$j = 0; $6e4725ac584d2777$var$j < $6e4725ac584d2777$var$chars.length; $6e4725ac584d2777$var$j += 1)$6e4725ac584d2777$var$diacriticsMap[$6e4725ac584d2777$var$chars[$6e4725ac584d2777$var$j]] = $6e4725ac584d2777$var$replacementList[$6e4725ac584d2777$var$i].base;
}
function $6e4725ac584d2777$var$removeDiacritics(str) {
    return str.replace(/[^\u0000-\u007e]/g, function(c) {
        return $6e4725ac584d2777$var$diacriticsMap[c] || c;
    });
}
$6e4725ac584d2777$export$452fcf31d2a11c49 = $6e4725ac584d2777$var$replacementList;
$6e4725ac584d2777$export$a078a2660a2c4d03 = $6e4725ac584d2777$var$diacriticsMap;

});


parcelRegister("40fBa", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");

var $2ea3430f395344cc$var$_prod = $1jnue((parcelRequire("ezCss")));

var $2ea3430f395344cc$var$_test = $1jnue((parcelRequire("hhDde")));
module.exports = "test".toLowerCase() === "production" ? $2ea3430f395344cc$var$_prod.default : $2ea3430f395344cc$var$_test.default;

});
parcelRegister("ezCss", function(module, exports) {
"use strict";
module.exports = JSON.parse('[{"label":"Albania","value":"ALB"},{"label":"Algeria","value":"DZA"},{"label":"Andorra","value":"AND"},{"label":"Argentina","value":"ARG"},{"label":"Armenia","value":"ARM"},{"label":"Australia","value":"AUS"},{"label":"Austria","value":"AUT"},{"label":"Azerbaijan","value":"AZE"},{"label":"Bahrain","value":"BHR"},{"label":"Belarus","value":"BLR"},{"label":"Belgium","value":"BEL"},{"label":"Bosnia and Herzegovina","value":"BIH"},{"label":"Brazil","value":"BRA"},{"label":"Bulgaria","value":"BGR"},{"label":"Canada","value":"CAN"},{"label":"Chile","value":"CHL"},{"label":"China","value":"CHN"},{"label":"Croatia","value":"HRV"},{"label":"Cyprus","value":"CYP"},{"label":"Czech Republic","value":"CZE"},{"label":"Denmark","value":"DNK"},{"label":"Egypt","value":"EGY"},{"label":"Estonia","value":"EST"},{"label":"Finland","value":"FIN"},{"label":"France","value":"FRA"},{"label":"Georgia","value":"GEO"},{"label":"Germany","value":"DEU"},{"label":"Greece","value":"GRC"},{"label":"Hong Kong","value":"HKG"},{"label":"Hungary","value":"HUN"},{"label":"India","value":"IND"},{"label":"Indonesia","value":"IDN"},{"label":"Ireland","value":"IRL"},{"label":"Israel","value":"ISR"},{"label":"Italy","value":"ITA"},{"label":"Japan","value":"JPN"},{"label":"Jordan","value":"JOR"},{"label":"Kazakhstan","value":"KAZ"},{"label":"Kenya","value":"KEN"},{"label":"Kuwait","value":"KWT"},{"label":"Kyrgyzstan","value":"KGZ"},{"label":"Latvia","value":"LVA"},{"label":"Lebanon","value":"LBN"},{"label":"Lithuania","value":"LTU"},{"label":"Luxembourg","value":"LUX"},{"label":"Macao","value":"MAC"},{"label":"Malaysia","value":"MYS"},{"label":"Mexico","value":"MEX"},{"label":"Moldova, Republic of","value":"MDA"},{"label":"Montenegro","value":"MNE"},{"label":"Morocco","value":"MAR"},{"label":"Netherlands","value":"NLD"},{"label":"New Zealand","value":"NZL"},{"label":"North Macedonia, Republic of","value":"MKD"},{"label":"Norway","value":"NOR"},{"label":"Oman","value":"OMN"},{"label":"Philippines","value":"PHL"},{"label":"Poland","value":"POL"},{"label":"Portugal","value":"PRT"},{"label":"Puerto Rico","value":"PRI"},{"label":"Qatar","value":"QAT"},{"label":"Romania","value":"ROU"},{"label":"Russian Federation","value":"RUS"},{"label":"Saudi Arabia","value":"SAU"},{"label":"Serbia","value":"SRB"},{"label":"Singapore","value":"SGP"},{"label":"Slovakia","value":"SVK"},{"label":"Slovenia","value":"SVN"},{"label":"South Africa","value":"ZAF"},{"label":"South Korea","value":"KOR"},{"label":"Spain","value":"ESP"},{"label":"Sweden","value":"SWE"},{"label":"Switzerland","value":"CHE"},{"label":"Taiwan","value":"TWN"},{"label":"Thailand","value":"THA"},{"label":"Turkey","value":"TUR"},{"label":"Turkmenistan","value":"TKM"},{"label":"Ukraine","value":"UKR"},{"label":"United Arab Emirates","value":"ARE"},{"label":"United Kingdom","value":"GBR"},{"label":"United States of America","value":"USA"},{"label":"Uruguay","value":"URY"},{"label":"Uzbekistan","value":"UZB"},{"label":"Viet Nam","value":"VNM"}]');

});

parcelRegister("hhDde", function(module, exports) {
"use strict";
module.exports = JSON.parse('[{"label":"Afghanistan","value":"AFG"},{"label":"\xc5land Islands","value":"ALA"},{"label":"Algeria","value":"DZA"},{"label":"American Samoa","value":"ASM"},{"label":"Andorra","value":"AND"},{"label":"Argentina","value":"ARG"},{"label":"Armenia","value":"ARM"},{"label":"Australia","value":"AUS"},{"label":"Austria","value":"AUT"},{"label":"Azerbaijan","value":"AZE"},{"label":"Bahrain","value":"BHR"},{"label":"Belarus","value":"BLR"},{"label":"Belgium","value":"BEL"},{"label":"Bolivia","value":"BOL"},{"label":"Bosnia and Herzegovina","value":"BIH"},{"label":"Bouvet Island","value":"BVT"},{"label":"Brazil","value":"BRA"},{"label":"Bulgaria","value":"BGR"},{"label":"Canada","value":"CAN"},{"label":"Chile","value":"CHL"},{"label":"China","value":"CHN"},{"label":"Croatia","value":"HRV"},{"label":"Cyprus","value":"CYP"},{"label":"Czech Republic","value":"CZE"},{"label":"Denmark","value":"DNK"},{"label":"Dominica","value":"DMA"},{"label":"Estonia","value":"EST"},{"label":"Falkland Islands (Malvinas)","value":"FLK"},{"label":"Finland","value":"FIN"},{"label":"France","value":"FRA"},{"label":"Georgia","value":"GEO"},{"label":"Germany","value":"DEU"},{"label":"Greece","value":"GRC"},{"label":"Hong Kong","value":"HKG"},{"label":"Hungary","value":"HUN"},{"label":"India","value":"IND"},{"label":"Ireland","value":"IRL"},{"label":"Israel","value":"ISR"},{"label":"Italy","value":"ITA"},{"label":"Japan","value":"JPN"},{"label":"Jordan","value":"JOR"},{"label":"Kazakhstan","value":"KAZ"},{"label":"Kuwait","value":"KWT"},{"label":"Kyrgyzstan","value":"KGZ"},{"label":"Latvia","value":"LVA"},{"label":"Lebanon","value":"LBN"},{"label":"Lithuania","value":"LTU"},{"label":"Luxembourg","value":"LUX"},{"label":"Macao","value":"MAC"},{"label":"Malaysia","value":"MYS"},{"label":"Mexico","value":"MEX"},{"label":"Moldova, Republic of","value":"MDA"},{"label":"Netherlands","value":"NLD"},{"label":"New Zealand","value":"NZL"},{"label":"North Macedonia, Republic of","value":"MKD"},{"label":"Norway","value":"NOR"},{"label":"Oman","value":"OMN"},{"label":"Poland","value":"POL"},{"label":"Portugal","value":"PRT"},{"label":"Qatar","value":"QAT"},{"label":"Romania","value":"ROU"},{"label":"Russian Federation","value":"RUS"},{"label":"Saudi Arabia","value":"SAU"},{"label":"Serbia","value":"SRB"},{"label":"Singapore","value":"SGP"},{"label":"Slovakia","value":"SVK"},{"label":"Slovenia","value":"SVN"},{"label":"South Africa","value":"ZAF"},{"label":"South Korea","value":"KOR"},{"label":"Spain","value":"ESP"},{"label":"Sweden","value":"SWE"},{"label":"Switzerland","value":"CHE"},{"label":"Taiwan","value":"TWN"},{"label":"Thailand","value":"THA"},{"label":"Turkey","value":"TUR"},{"label":"Turkmenistan","value":"TKM"},{"label":"Ukraine","value":"UKR"},{"label":"United Arab Emirates","value":"ARE"},{"label":"United Kingdom","value":"GBR"},{"label":"United States of America","value":"USA"},{"label":"Uruguay","value":"URY"},{"label":"Uzbekistan","value":"UZB"}]');

});


parcelRegister("hcrRu", function(module, exports) {
module.exports = JSON.parse('{"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo, the Democratic Republic of the","CK":"Cook Islands","CR":"Costa Rica","CI":"Cote D\'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":"South Korea","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People\'s Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MK":"North Macedonia, Republic of","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":["State of Palestine","Palestine"],"PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":["Russian Federation","Russia"],"RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Eswatini","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":["Taiwan, Province of China","Taiwan"],"TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":["United Kingdom","UK","Great Britain"],"US":["United States of America","USA"],"UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":"\xc5land Islands","BQ":"Bonaire, Sint Eustatius and Saba","CW":"Cura\xe7ao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barth\xe9lemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo"}}');

});



parcelRegister("ahQcD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $77d3fc4e6eab3d0f$export$1e511d4a378977f5, (v) => $77d3fc4e6eab3d0f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $77d3fc4e6eab3d0f$export$2e2bcd8739ae039, (v) => $77d3fc4e6eab3d0f$export$2e2bcd8739ae039 = v);
var $77d3fc4e6eab3d0f$export$1e511d4a378977f5;
var $77d3fc4e6eab3d0f$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$77d3fc4e6eab3d0f$export$1e511d4a378977f5 = true;
$77d3fc4e6eab3d0f$export$2e2bcd8739ae039 = void 0;

var $77d3fc4e6eab3d0f$var$_react = $1jnue((parcelRequire("acw62")));

var $kfZjc = parcelRequire("kfZjc");

var $77d3fc4e6eab3d0f$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $ikfii = parcelRequire("ikfii");
/* eslint-disable fp/no-mutating-methods */ const $77d3fc4e6eab3d0f$var$LoggedOut = ()=>{
    const history = (0, $kfZjc.useHistory)();
    const onClick = ()=>{
        history.push("/login");
    };
    return $77d3fc4e6eab3d0f$var$_Auth.default.isAuthenticated() ? /*#__PURE__*/ $77d3fc4e6eab3d0f$var$_react.default.createElement($kfZjc.Redirect, {
        to: "/login"
    }) : /*#__PURE__*/ $77d3fc4e6eab3d0f$var$_react.default.createElement("main", {
        className: "ncss-col-sm-12 ta-sm-c"
    }, /*#__PURE__*/ $77d3fc4e6eab3d0f$var$_react.default.createElement("h1", {
        className: "display-3 mt10-sm mb4-sm text-color-error"
    }, "You are logged out"), /*#__PURE__*/ $77d3fc4e6eab3d0f$var$_react.default.createElement("p", {
        className: "headline-4 p2-sm"
    }, "Please use the Sign In option below to login."), /*#__PURE__*/ $77d3fc4e6eab3d0f$var$_react.default.createElement("section", {
        className: "ncss-col-sm-5 ncss-col-lg-2 ta-sm-c mb3-sm pt4-sm"
    }, /*#__PURE__*/ $77d3fc4e6eab3d0f$var$_react.default.createElement($ikfii.ButtonSubmit, {
        label: "Sign In",
        onSubmit: onClick
    })));
};
var $77d3fc4e6eab3d0f$var$_default = $77d3fc4e6eab3d0f$export$2e2bcd8739ae039 = $77d3fc4e6eab3d0f$var$LoggedOut;

});

parcelRegister("9p6eo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $6d8b48355bbbd320$export$1e511d4a378977f5, (v) => $6d8b48355bbbd320$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $6d8b48355bbbd320$export$2e2bcd8739ae039, (v) => $6d8b48355bbbd320$export$2e2bcd8739ae039 = v);
var $6d8b48355bbbd320$export$1e511d4a378977f5;
var $6d8b48355bbbd320$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$6d8b48355bbbd320$export$1e511d4a378977f5 = true;
$6d8b48355bbbd320$export$2e2bcd8739ae039 = void 0;

var $6d8b48355bbbd320$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $6d8b48355bbbd320$var$_react = $6d8b48355bbbd320$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jHTLJ");
var $hrvfy = parcelRequire("hrvfy");

var $kfZjc = parcelRequire("kfZjc");

var $6d8b48355bbbd320$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $6d8b48355bbbd320$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $jMcIG = parcelRequire("jMcIG");

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $6d8b48355bbbd320$var$_getUserCountry = $1jnue((parcelRequire("uKJdY")));

var $ikfii = parcelRequire("ikfii");

var $6d8b48355bbbd320$var$_MarkdownHome = $1jnue((parcelRequire("ide2H")));
function $6d8b48355bbbd320$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6d8b48355bbbd320$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6d8b48355bbbd320$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6d8b48355bbbd320$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $6d8b48355bbbd320$var$Markdowns = ({ country: country, reduxSetCountry: reduxSetCountry })=>{
    const [markdowns, setMarkdowns] = (0, $6d8b48355bbbd320$var$_react.useState)([]);
    const [error, setError] = (0, $6d8b48355bbbd320$var$_react.useState)("");
    const [isFetching, setIsFetching] = (0, $6d8b48355bbbd320$var$_react.useState)(true);
    const translate = (0, $6d8b48355bbbd320$var$_useTranslate.default)();
    !country && reduxSetCountry((0, $6d8b48355bbbd320$var$_getUserCountry.default)());
    const location = (0, $kfZjc.useLocation)();
    (0, $6d8b48355bbbd320$var$_react.useEffect)(()=>{
        if (!$6d8b48355bbbd320$var$_Auth.default.isAuthenticated()) (async ()=>$6d8b48355bbbd320$var$_Auth.default.reAuthorize().then(()=>true).catch(()=>false))();
        // getMarkdowns (refresh the markdowns) every time we set isFetching to true
        if (country && isFetching) (async (_location$state)=>(0, $ilYXe.getMarkdowns)((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.storeId).then(({ objects: objects })=>(0, $6zLPD.handleResponse)(setMarkdowns, (0, $6zLPD.formatMarkdowns)(objects, country), setError, "")).catch((err)=>(0, $6zLPD.handleResponse)(setMarkdowns, [], setError, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>setIsFetching(false)))();
    }, [
        country,
        isFetching,
        location.state
    ]);
    return /*#__PURE__*/ $6d8b48355bbbd320$var$_react.default.createElement($6d8b48355bbbd320$var$_react.default.Fragment, null, /*#__PURE__*/ $6d8b48355bbbd320$var$_react.default.createElement("h1", {
        className: "display-3 text-color-accent mb3-sm"
    }, translate("RL_Markdowns")), /*#__PURE__*/ $6d8b48355bbbd320$var$_react.default.createElement($ikfii.ContentLoads, {
        error: error,
        isLoading: isFetching
    }, !isFetching && /*#__PURE__*/ $6d8b48355bbbd320$var$_react.default.createElement($6d8b48355bbbd320$var$_MarkdownHome.default, {
        canCreate: $6d8b48355bbbd320$var$_Auth.default.requiresRole40($6d8b48355bbbd320$var$_Auth.default.getAuth()),
        markdowns: markdowns,
        refreshMarkdowns: ()=>setIsFetching(true),
        setProducts: setMarkdowns
    })));
};
$6d8b48355bbbd320$var$Markdowns.propTypes = {
    country: $6d8b48355bbbd320$var$_propTypes.default.string.isRequired,
    reduxSetCountry: $6d8b48355bbbd320$var$_propTypes.default.func.isRequired
};
const $6d8b48355bbbd320$var$mapStateToProps = ({ country: country })=>({
        country: country
    });
const $6d8b48355bbbd320$var$mapDispatchToProps = (dispatch)=>({
        reduxSetCountry: (country)=>dispatch((0, $jMcIG.setCountry)(country))
    });
var $6d8b48355bbbd320$var$_default = $6d8b48355bbbd320$export$2e2bcd8739ae039 = (0, $hrvfy.default)($6d8b48355bbbd320$var$mapStateToProps, $6d8b48355bbbd320$var$mapDispatchToProps)($6d8b48355bbbd320$var$Markdowns);

});
parcelRegister("ide2H", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $d4245578ccf4eca1$export$1e511d4a378977f5, (v) => $d4245578ccf4eca1$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $d4245578ccf4eca1$export$2e2bcd8739ae039, (v) => $d4245578ccf4eca1$export$2e2bcd8739ae039 = v);
var $d4245578ccf4eca1$export$1e511d4a378977f5;
var $d4245578ccf4eca1$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$d4245578ccf4eca1$export$1e511d4a378977f5 = true;
$d4245578ccf4eca1$export$2e2bcd8739ae039 = void 0;

var $d4245578ccf4eca1$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $d4245578ccf4eca1$var$_react = $d4245578ccf4eca1$var$_interopRequireWildcard((parcelRequire("acw62")));

var $ikfii = parcelRequire("ikfii");

var $d4245578ccf4eca1$var$_MarkdownForm = $1jnue((parcelRequire("9TWYd")));
function $d4245578ccf4eca1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($d4245578ccf4eca1$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $d4245578ccf4eca1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $d4245578ccf4eca1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $d4245578ccf4eca1$var$MarkdownHome = ({ canCreate: canCreate, markdowns: markdowns, refreshMarkdowns: refreshMarkdowns, setProducts: setProducts })=>{
    const [isAdding, setIsAdding] = (0, $d4245578ccf4eca1$var$_react.useState)(false);
    const [isScanning, setIsScanning] = (0, $d4245578ccf4eca1$var$_react.useState)(false);
    const [gtin, setGTIN] = (0, $d4245578ccf4eca1$var$_react.useState)("");
    const toggleAddMarkdownPage = async ()=>{
        // Ignore your editor if it says these awaits do not do anything. They do. Without it, the DialogStyled will extend as tall as its background display, not as tall as the screen.
        await setIsAdding((prevIsAdding)=>!prevIsAdding);
        await setIsScanning((prevIsScanning)=>!prevIsScanning);
        if (isAdding) refreshMarkdowns();
    };
    // Close the popup when we find a gtin
    (0, $d4245578ccf4eca1$var$_react.useEffect)(()=>{
        if (gtin) (async ()=>{
            await setIsAdding(true);
            await setIsScanning(false);
        })();
    }, [
        gtin
    ]);
    return /*#__PURE__*/ $d4245578ccf4eca1$var$_react.default.createElement($d4245578ccf4eca1$var$_react.default.Fragment, null, isScanning ? /*#__PURE__*/ $d4245578ccf4eca1$var$_react.default.createElement($ikfii.Scanner, {
        onClose: ()=>setIsScanning(false),
        onDetected: (barcode)=>setGTIN(barcode.padStart(14, "0"))
    }) : /*#__PURE__*/ $d4245578ccf4eca1$var$_react.default.createElement($d4245578ccf4eca1$var$_react.default.Fragment, null, canCreate && /*#__PURE__*/ $d4245578ccf4eca1$var$_react.default.createElement($ikfii.ButtonAdd, {
        isAdding: isAdding,
        onToggle: toggleAddMarkdownPage
    }), isAdding ? /*#__PURE__*/ $d4245578ccf4eca1$var$_react.default.createElement($d4245578ccf4eca1$var$_MarkdownForm.default, {
        gtin: gtin
    }) : /*#__PURE__*/ $d4245578ccf4eca1$var$_react.default.createElement($ikfii.ProductsDisplay, {
        isMarkdowns: true,
        products: markdowns,
        setProducts: setProducts
    })));
};
$d4245578ccf4eca1$var$MarkdownHome.propTypes = {
    canCreate: $d4245578ccf4eca1$var$_propTypes.default.bool.isRequired,
    markdowns: $d4245578ccf4eca1$var$_propTypes.default.arrayOf($d4245578ccf4eca1$var$_propTypes.default.shape({
        id: $d4245578ccf4eca1$var$_propTypes.default.string.isRequired,
        itemDetails: $d4245578ccf4eca1$var$_propTypes.default.arrayOf($d4245578ccf4eca1$var$_propTypes.default.shape({
            createDateTime: $d4245578ccf4eca1$var$_propTypes.default.string,
            gtin: $d4245578ccf4eca1$var$_propTypes.default.string,
            markdownPrice: $d4245578ccf4eca1$var$_propTypes.default.number,
            name: $d4245578ccf4eca1$var$_propTypes.default.string,
            productId: $d4245578ccf4eca1$var$_propTypes.default.string,
            startDateTime: $d4245578ccf4eca1$var$_propTypes.default.string,
            styleColor: $d4245578ccf4eca1$var$_propTypes.default.string,
            typeId: $d4245578ccf4eca1$var$_propTypes.default.string
        })),
        startDate: $d4245578ccf4eca1$var$_propTypes.default.string.isRequired
    })).isRequired,
    refreshMarkdowns: $d4245578ccf4eca1$var$_propTypes.default.func.isRequired,
    setProducts: $d4245578ccf4eca1$var$_propTypes.default.func.isRequired
};
var $d4245578ccf4eca1$var$_default = $d4245578ccf4eca1$export$2e2bcd8739ae039 = $d4245578ccf4eca1$var$MarkdownHome;

});
parcelRegister("9TWYd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $7356fe61ae110714$export$1e511d4a378977f5, (v) => $7356fe61ae110714$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7356fe61ae110714$export$2e2bcd8739ae039, (v) => $7356fe61ae110714$export$2e2bcd8739ae039 = v);
var $7356fe61ae110714$export$1e511d4a378977f5;
var $7356fe61ae110714$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$7356fe61ae110714$export$1e511d4a378977f5 = true;
$7356fe61ae110714$export$2e2bcd8739ae039 = void 0;

var $7356fe61ae110714$var$_moment = $1jnue((parcelRequire("45fvw")));

var $7356fe61ae110714$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $7356fe61ae110714$var$_react = $7356fe61ae110714$var$_interopRequireWildcard((parcelRequire("acw62")));

var $7356fe61ae110714$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $ikfii = parcelRequire("ikfii");
function $7356fe61ae110714$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($7356fe61ae110714$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $7356fe61ae110714$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $7356fe61ae110714$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $7356fe61ae110714$var$MarkdownForm = ({ gtin: gtin })=>{
    const [price, setPrice] = (0, $7356fe61ae110714$var$_react.useState)(0);
    const [priceInputError, setPriceInputError] = (0, $7356fe61ae110714$var$_react.useState)("");
    const [startDate, setStartDate] = (0, $7356fe61ae110714$var$_react.useState)((0, $6zLPD.formatDate)((0, $7356fe61ae110714$var$_moment.default)().add(1, "day")));
    const [code, setCode] = (0, $7356fe61ae110714$var$_react.useState)(gtin ? {
        label: gtin,
        value: gtin
    } : undefined);
    const [codeIsGTIN, setCodeIsGTIN] = (0, $7356fe61ae110714$var$_react.useState)(!!gtin);
    const [submitDisabled, setSubmitDisabled] = (0, $7356fe61ae110714$var$_react.useState)(true);
    const [isSubmitting, setIsSubmitting] = (0, $7356fe61ae110714$var$_react.useState)(false);
    const [success, setSuccess] = (0, $7356fe61ae110714$var$_react.useState)("");
    const [error, setError] = (0, $7356fe61ae110714$var$_react.useState)("");
    const translate = (0, $7356fe61ae110714$var$_useTranslate.default)();
    // If we set the code state variable as something not the value passed in as gtin,
    // then we have removed the scanner's GTIN value, so we force the user to enter a Style Color
    (0, $7356fe61ae110714$var$_react.useEffect)(()=>{
        setCodeIsGTIN((code === null || code === void 0 ? void 0 : code.value) === gtin);
    }, [
        code,
        gtin
    ]);
    // every time the property gtin is updated, update the state variable for code
    (0, $7356fe61ae110714$var$_react.useEffect)(()=>{
        setCode(gtin ? {
            label: gtin,
            value: gtin
        } : undefined);
        setCodeIsGTIN(!!gtin);
    }, [
        gtin
    ]);
    (0, $7356fe61ae110714$var$_react.useEffect)(()=>{
        setSubmitDisabled(!(price && startDate && code !== null && code !== void 0 && code.value) || !!priceInputError);
    }, [
        price,
        startDate,
        code,
        priceInputError
    ]);
    (0, $7356fe61ae110714$var$_react.useEffect)(()=>{
        setPriceInputError("");
        !price || Number(price) || setPriceInputError(translate("RL_PriceValidation"));
    }, [
        price,
        translate
    ]);
    const onSubmit = ()=>{
        setIsSubmitting(true);
        (async ()=>(0, $ilYXe.postMarkdown)({
                gtin: (0, $6zLPD.isGTIN)(code.value) ? code.value : undefined,
                price: Number(price),
                startDate: startDate,
                styleColor: (0, $6zLPD.isStyleColor)(code.value) ? code.value.toUpperCase() : undefined
            }).then((res)=>{
                var _res$errors;
                if ((_res$errors = res.errors) !== null && _res$errors !== void 0 && _res$errors.length) {
                    const { errorMessage: errorMessage, successMessage: successMessage } = (0, $6zLPD.handleErrorMessage)(res, [
                        code.value
                    ]);
                    return (0, $6zLPD.handleResponse)(setSuccess, successMessage, setError, errorMessage);
                }
                return (0, $6zLPD.handleResponse)(setSuccess, translate("RL_MarkdownAddSuccess"), setError, "");
            }).catch((err)=>{
                const { errorMessage: errorMessage, successMessage: successMessage } = (0, $6zLPD.handleErrorMessage)(err, [
                    code.value
                ]);
                return (0, $6zLPD.handleResponse)(setSuccess, successMessage, setError, errorMessage);
            }).finally(()=>{
                window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
                setIsSubmitting(false);
            }))();
    };
    return /*#__PURE__*/ $7356fe61ae110714$var$_react.default.createElement($7356fe61ae110714$var$_react.default.Fragment, null, /*#__PURE__*/ $7356fe61ae110714$var$_react.default.createElement("section", {
        className: "ncss-col-sm-10 ta-sm-l mt3-sm mb3-sm"
    }, /*#__PURE__*/ $7356fe61ae110714$var$_react.default.createElement($ikfii.Creatable, {
        isRequired: true,
        id: codeIsGTIN ? "gtin" : "styleColor",
        isDisabled: isSubmitting,
        label: codeIsGTIN ? "GTIN" : translate("RL_StyleColor"),
        value: code,
        onChange: setCode
    }), /*#__PURE__*/ $7356fe61ae110714$var$_react.default.createElement($ikfii.CurrencyInput, {
        setAmount: setPrice
    }), /*#__PURE__*/ $7356fe61ae110714$var$_react.default.createElement($ikfii.InputDate, {
        isRequired: true,
        id: "startDate",
        label: translate("RL_StartDate"),
        minDate: (0, $6zLPD.formatDate)((0, $7356fe61ae110714$var$_moment.default)().add(1, "day")),
        value: startDate,
        onChange: setStartDate
    })), /*#__PURE__*/ $7356fe61ae110714$var$_react.default.createElement($ikfii.ButtonSubmit, {
        isDisabled: submitDisabled,
        isSubmitting: isSubmitting,
        label: translate("RL_AddMarkdown"),
        messageError: error,
        messageSuccess: success,
        onSubmit: onSubmit
    }));
};
$7356fe61ae110714$var$MarkdownForm.defaultProps = {
    gtin: ""
};
$7356fe61ae110714$var$MarkdownForm.propTypes = {
    gtin: $7356fe61ae110714$var$_propTypes.default.string
};
var $7356fe61ae110714$var$_default = $7356fe61ae110714$export$2e2bcd8739ae039 = $7356fe61ae110714$var$MarkdownForm;

});



parcelRegister("xT1Nv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $065dc4985456da65$export$1e511d4a378977f5, (v) => $065dc4985456da65$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $065dc4985456da65$export$2e2bcd8739ae039, (v) => $065dc4985456da65$export$2e2bcd8739ae039 = v);
var $065dc4985456da65$export$1e511d4a378977f5;
var $065dc4985456da65$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$065dc4985456da65$export$1e511d4a378977f5 = true;
$065dc4985456da65$export$2e2bcd8739ae039 = void 0;

var $jCCoq = parcelRequire("jCCoq");
var $9L4L1 = parcelRequire("9L4L1");
var $daLOv = parcelRequire("daLOv");
var $8EIwM = parcelRequire("8EIwM");
var $a6om9 = parcelRequire("a6om9");

var $065dc4985456da65$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $065dc4985456da65$var$_react = $1jnue((parcelRequire("acw62")));

parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $4fGPb = parcelRequire("4fGPb");

var $065dc4985456da65$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $065dc4985456da65$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $bEk1s = parcelRequire("bEk1s");

var $5enz3 = parcelRequire("5enz3");
const $065dc4985456da65$var$pages = [
    {
        Icon: $jCCoq.Activity,
        isEnabledForPartner: true,
        name: "RL_Promotions",
        url: "/promotions"
    },
    {
        defaultTitle: "Styles Upload",
        Icon: $8EIwM.Upload,
        isEnabledForPartner: false,
        name: "RL_StyleUpload1",
        url: "/upload"
    },
    {
        Icon: $a6om9.Wallet,
        isEnabledForPartner: false,
        name: "RL_Markdowns",
        url: "/markdowns"
    },
    {
        Icon: $daLOv.ShopnikeApp,
        isEnabledForPartner: false,
        name: "RL_StockOnHand",
        url: "/stock-on-hand"
    },
    {
        Icon: $9L4L1.Profile,
        isEnabledForPartner: true,
        name: "RL_Profile",
        url: "/profile"
    }
];
const $065dc4985456da65$var$NavBar = ({ location: { pathname: pathname } })=>{
    // const isPartnerLogin = useSelector(getIsPartnerLogin);
    const isMarkdownEnabled = (0, $iD0SF.useSelector)($bEk1s.getIsMarkdownEnabled);
    const accessToken = $065dc4985456da65$var$_Auth.default.getAuth();
    const hasLevel40Access = accessToken && $065dc4985456da65$var$_Auth.default.requiresRole40(accessToken);
    const isCsvUploadEnabled = (0, $iD0SF.useSelector)($bEk1s.getIsCsvUploadEnabled) && (0, $5enz3.isBohApp)() && hasLevel40Access;
    // if the user is a partner, only show the promotions and profile pages
    // else check if the markdowns page is enabled
    const TABS_ALWAYS_ENABLED = [
        "RL_Promotions",
        "RL_Profile"
    ];
    const isTabEnabled = {
        ...TABS_ALWAYS_ENABLED.reduce((acc, tab)=>({
                ...acc,
                [tab]: true
            }), {}),
        RL_Markdowns: isMarkdownEnabled,
        RL_StockOnHand: true,
        RL_StyleUpload1: isCsvUploadEnabled
    };
    const translate = (0, $065dc4985456da65$var$_useTranslate.default)();
    if (pathname === "/login" || pathname === "/logged-out" || pathname === "/unauthorized") return "";
    return /*#__PURE__*/ $065dc4985456da65$var$_react.default.createElement("nav", {
        className: "navbar u-full-width ta-sm-c"
    }, $065dc4985456da65$var$pages.filter((item)=>isTabEnabled[item.name]).map(({ Icon: Icon, name: name, url: url, defaultTitle: defaultTitle })=>/*#__PURE__*/ $065dc4985456da65$var$_react.default.createElement($4fGPb.Link, {
            key: url,
            style: {
                color: pathname.includes(url) && "#FA5400",
                width: "100px"
            },
            to: url
        }, /*#__PURE__*/ $065dc4985456da65$var$_react.default.createElement(Icon, {
            title: name
        }), /*#__PURE__*/ $065dc4985456da65$var$_react.default.createElement("p", {
            className: "body-4 mt-3-sm"
        }, translate(name) || defaultTitle))));
};
$065dc4985456da65$var$NavBar.propTypes = {
    location: $065dc4985456da65$var$_propTypes.default.shape().isRequired
};
var $065dc4985456da65$var$_default = $065dc4985456da65$export$2e2bcd8739ae039 = $065dc4985456da65$var$NavBar;

});
parcelRegister("jCCoq", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $e48f58f73fdce63c$export$9c16c1426311996d);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $e48f58f73fdce63c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e48f58f73fdce63c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e48f58f73fdce63c$var$_typeof(o);
}
function $e48f58f73fdce63c$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e48f58f73fdce63c$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e48f58f73fdce63c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $e48f58f73fdce63c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e48f58f73fdce63c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e48f58f73fdce63c$var$_defineProperty(obj, key, value) {
    key = $e48f58f73fdce63c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e48f58f73fdce63c$var$_toPropertyKey(t) {
    var i = $e48f58f73fdce63c$var$_toPrimitive(t, "string");
    return "symbol" == $e48f58f73fdce63c$var$_typeof(i) ? i : String(i);
}
function $e48f58f73fdce63c$var$_toPrimitive(t, r) {
    if ("object" != $e48f58f73fdce63c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $e48f58f73fdce63c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $e48f58f73fdce63c$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
        clipRule: "evenodd"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M9.25 20.25H6A2.25 2.25 0 013.75 18v-5.25h5.5v7.5zm8.75 0h-3.25V3.75h5.5V18A2.25 2.25 0 0118 20.25zm-8.75 0h5.5v-12h-5.5v12z",
        clipRule: "evenodd"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M18.5 40.5H12A4.5 4.5 0 017.5 36V25.5h11v15zm17.5 0h-6.5v-33h11V36a4.5 4.5 0 01-4.5 4.5zm-17.5 0h11v-24h-11v24z",
        clipRule: "evenodd"
    }))
};
var $e48f58f73fdce63c$export$9c16c1426311996d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $e48f58f73fdce63c$var$_objectSpread($e48f58f73fdce63c$var$_objectSpread({}, props), {}, {
        paths: $e48f58f73fdce63c$var$compPaths,
        fill: "none"
    }));
});
$e48f58f73fdce63c$export$9c16c1426311996d.displayName = "[Deprecated] Activity";

});

parcelRegister("9L4L1", function(module, exports) {

$parcel$export(module.exports, "Profile", () => $71ac318bc176f5c9$export$5120f2d0b8d4cab8);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $71ac318bc176f5c9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $71ac318bc176f5c9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $71ac318bc176f5c9$var$_typeof(o);
}
function $71ac318bc176f5c9$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71ac318bc176f5c9$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71ac318bc176f5c9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $71ac318bc176f5c9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71ac318bc176f5c9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $71ac318bc176f5c9$var$_defineProperty(obj, key, value) {
    key = $71ac318bc176f5c9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71ac318bc176f5c9$var$_toPropertyKey(t) {
    var i = $71ac318bc176f5c9$var$_toPrimitive(t, "string");
    return "symbol" == $71ac318bc176f5c9$var$_typeof(i) ? i : String(i);
}
function $71ac318bc176f5c9$var$_toPrimitive(t, r) {
    if ("object" != $71ac318bc176f5c9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $71ac318bc176f5c9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $71ac318bc176f5c9$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M3.75 21v-3a3.75 3.75 0 013.75-3.75h9A3.75 3.75 0 0120.25 18v3M12 3.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M3.75 21v-3a3.75 3.75 0 013.75-3.75h9A3.75 3.75 0 0120.25 18v3M12 3.75a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M7.5 42v-6a7.5 7.5 0 017.5-7.5h18a7.5 7.5 0 017.5 7.5v6m-9-27a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z"
    }))
};
var $71ac318bc176f5c9$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $71ac318bc176f5c9$var$_objectSpread($71ac318bc176f5c9$var$_objectSpread({}, props), {}, {
        paths: $71ac318bc176f5c9$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("daLOv", function(module, exports) {

$parcel$export(module.exports, "ShopnikeApp", () => $99714c4f91fd9519$export$445edbca9e0b245f);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $99714c4f91fd9519$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $99714c4f91fd9519$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $99714c4f91fd9519$var$_typeof(o);
}
function $99714c4f91fd9519$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $99714c4f91fd9519$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $99714c4f91fd9519$var$ownKeys(Object(t), !0).forEach(function(r) {
            $99714c4f91fd9519$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $99714c4f91fd9519$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $99714c4f91fd9519$var$_defineProperty(obj, key, value) {
    key = $99714c4f91fd9519$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $99714c4f91fd9519$var$_toPropertyKey(t) {
    var i = $99714c4f91fd9519$var$_toPrimitive(t, "string");
    return "symbol" == $99714c4f91fd9519$var$_typeof(i) ? i : String(i);
}
function $99714c4f91fd9519$var$_toPrimitive(t, r) {
    if ("object" != $99714c4f91fd9519$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $99714c4f91fd9519$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $99714c4f91fd9519$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M0 8.25h4.5M0 12.75h4.5m12.462 3.546a6.716 6.716 0 01-3.462.954 6.728 6.728 0 01-4.773-1.977A6.728 6.728 0 016.75 10.5c0-1.864.755-3.551 1.977-4.773A6.728 6.728 0 0113.5 3.75c1.864 0 3.551.755 4.773 1.977A6.728 6.728 0 0120.25 10.5a6.726 6.726 0 01-.921 3.407c-.517.882-.434 1.988.289 2.711l3.853 3.853"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M0 16.5h9m-9 9h9m24.924 7.092A13.432 13.432 0 0127 34.5c-3.728 0-7.102-1.51-9.546-3.954A13.455 13.455 0 0113.5 21c0-3.728 1.51-7.102 3.954-9.546A13.455 13.455 0 0127 7.5c3.728 0 7.102 1.51 9.546 3.954A13.455 13.455 0 0140.5 21c0 2.486-.672 4.814-1.842 6.814-1.034 1.764-.868 3.976.578 5.422l7.706 7.706"
    }))
};
var $99714c4f91fd9519$export$445edbca9e0b245f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $99714c4f91fd9519$var$_objectSpread($99714c4f91fd9519$var$_objectSpread({}, props), {}, {
        paths: $99714c4f91fd9519$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("8EIwM", function(module, exports) {

$parcel$export(module.exports, "Upload", () => $64d49969005e52ce$export$c58532f0fb5faa97);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $64d49969005e52ce$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $64d49969005e52ce$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $64d49969005e52ce$var$_typeof(o);
}
function $64d49969005e52ce$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64d49969005e52ce$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64d49969005e52ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            $64d49969005e52ce$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64d49969005e52ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $64d49969005e52ce$var$_defineProperty(obj, key, value) {
    key = $64d49969005e52ce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $64d49969005e52ce$var$_toPropertyKey(t) {
    var i = $64d49969005e52ce$var$_toPrimitive(t, "string");
    return "symbol" == $64d49969005e52ce$var$_typeof(i) ? i : String(i);
}
function $64d49969005e52ce$var$_toPrimitive(t, r) {
    if ("object" != $64d49969005e52ce$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $64d49969005e52ce$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $64d49969005e52ce$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M12 7.5v9c0 2.07-1.68 3.75-3.75 3.75m9-12.74a5.254 5.254 0 00-5.24-5.26c-2.9-.01-5.25 2.34-5.26 5.24m.74-.74c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75h2.26m4.5 0h2.24c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75m-8.2 4.03L12 7.07l3.71 3.71"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M12 7.5v9c0 2.07-1.68 3.75-3.75 3.75m9-12.74a5.254 5.254 0 00-5.24-5.26c-2.9-.01-5.25 2.34-5.26 5.24m.74-.74c-2.07 0-3.75 1.68-3.75 3.75 0 2.07 1.68 3.75 3.75 3.75h2.26m4.5 0h2.24c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75m-8.2 4.03L12 7.07l3.71 3.71"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M24 15v18c0 4.14-3.36 7.5-7.5 7.5m18-25.48A10.508 10.508 0 0024.02 4.5c-5.8-.02-10.5 4.68-10.52 10.48m1.48-1.48c-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5h4.52m9 0h4.48c4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5m-16.402 8.06l7.42-7.42 7.42 7.42"
    }))
};
var $64d49969005e52ce$export$c58532f0fb5faa97 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $64d49969005e52ce$var$_objectSpread($64d49969005e52ce$var$_objectSpread({}, props), {}, {
        paths: $64d49969005e52ce$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("a6om9", function(module, exports) {

$parcel$export(module.exports, "Wallet", () => $75ad5b8c95d20646$export$bcca3ea514774656);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $75ad5b8c95d20646$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $75ad5b8c95d20646$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $75ad5b8c95d20646$var$_typeof(o);
}
function $75ad5b8c95d20646$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $75ad5b8c95d20646$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $75ad5b8c95d20646$var$ownKeys(Object(t), !0).forEach(function(r) {
            $75ad5b8c95d20646$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $75ad5b8c95d20646$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $75ad5b8c95d20646$var$_defineProperty(obj, key, value) {
    key = $75ad5b8c95d20646$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75ad5b8c95d20646$var$_toPropertyKey(t) {
    var i = $75ad5b8c95d20646$var$_toPrimitive(t, "string");
    return "symbol" == $75ad5b8c95d20646$var$_typeof(i) ? i : String(i);
}
function $75ad5b8c95d20646$var$_toPrimitive(t, r) {
    if ("object" != $75ad5b8c95d20646$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $75ad5b8c95d20646$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $75ad5b8c95d20646$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M3.75 6A2.25 2.25 0 006 8.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6zm0 0A2.25 2.25 0 016 3.75h12.75V6.5m-15-.5v1.25m16.5 8.5h-3a1.5 1.5 0 010-3h3v3z"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "1.5",
        d: "M3.75 6A2.25 2.25 0 006 8.25h12a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25H6A2.25 2.25 0 013.75 18V6zm0 0A2.25 2.25 0 016 3.75h12.75V6.5m-15-.5v1.25m16.5 8.5h-3a1.5 1.5 0 010-3h3v3z"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeWidth: "3",
        d: "M7.5 12a4.5 4.5 0 004.5 4.5h24c2.484 0 4.5 2.016 4.5 4.5v15c0 2.484-2.016 4.5-4.5 4.5H12A4.502 4.502 0 017.5 36V12zm0 0A4.5 4.5 0 0112 7.5h25.5V13m-30-1v2.5m33 17h-6a3.001 3.001 0 010-6h6v6z"
    }))
};
var $75ad5b8c95d20646$export$bcca3ea514774656 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $75ad5b8c95d20646$var$_objectSpread($75ad5b8c95d20646$var$_objectSpread({}, props), {}, {
        paths: $75ad5b8c95d20646$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("5enz3", function(module, exports) {
"use strict";

var $f1q41 = parcelRequire("f1q41");

var $auStQ = parcelRequire("auStQ");
var $3cf089f12d06270b$require$promotionTranslate = $auStQ.promotionTranslate;

var $7Yi7V = parcelRequire("7Yi7V");
var $3cf089f12d06270b$require$CSV_UPLOAD = $7Yi7V.CSV_UPLOAD;
parcelRequire("bEk1s");
const $3cf089f12d06270b$var$REQUIRED_FIELDS = [
    "styleColor",
    "gender",
    "division",
    "bin",
    "price"
];
const $3cf089f12d06270b$var$ERROR_TRANSLATION_MAP = {
    DDB_EXCEPTION_ITEM_INSERT: "RL_Error3",
    DDB_EXCEPTION_PROMOTION_UPDATE: "RL_Error4",
    DEFAULT_PROMOTIONS_NOT_FOUND_IN_DDB: "RL_Error5",
    DUPLICATE_ITEM: "RL_Error6",
    VALIDATE_CLEARANCE: "RL_Error1",
    VALIDATE_DIVISION: "RL_Error7",
    VALIDATE_STYLECOLOR: "RL_Error2",
    VALIDATE_UNBINNED: "RL_Error8"
};
const $3cf089f12d06270b$var$getErrorTranslation = (key)=>$3cf089f12d06270b$var$ERROR_TRANSLATION_MAP[key] || "RL_UnknownError";
const $3cf089f12d06270b$var$getColumns = (localeForTranslation = "en-US")=>[
        {
            displayName: $3cf089f12d06270b$require$promotionTranslate("RL_RowNumber", localeForTranslation),
            id: "rowNo",
            isRequiredInUiReport: true,
            width: 1
        },
        {
            displayName: "Upload Id",
            id: "uploadId"
        },
        {
            displayName: $3cf089f12d06270b$require$promotionTranslate("RL_StyleColor", localeForTranslation),
            id: "styleColor",
            isRequiredInUiReport: true,
            width: 2
        },
        {
            displayName: "Gender",
            id: "gender"
        },
        {
            displayName: "Division",
            id: "division"
        },
        {
            displayName: "Bin",
            id: "bin"
        },
        {
            displayName: "Price",
            id: "price"
        },
        {
            classRenderer: (value)=>{
                if (value === $3cf089f12d06270b$require$CSV_UPLOAD.STATUS_PROCESSING) return "u-bold text-color-processing";
                return value === $3cf089f12d06270b$require$CSV_UPLOAD.STATUS_FAILURE ? "u-bold text-color-error" : "u-bold text-color-success";
            },
            displayName: $3cf089f12d06270b$require$promotionTranslate("RL_UploadStatus", localeForTranslation),
            id: "status",
            isRequiredInUiReport: true,
            translationEnabled: true,
            width: 3
        },
        {
            classRenderer: (value)=>value.length ? "u-bold text-color-error" : "u-bold text-color-success",
            displayName: $3cf089f12d06270b$require$promotionTranslate("RL_Errors", localeForTranslation),
            id: "errors",
            isRequiredInUiReport: true,
            isStatusColorRequired: true,
            renderer: (value)=>value === null || value === void 0 ? void 0 : value.map((error)=>$3cf089f12d06270b$var$getErrorTranslation(error.key)).join(","),
            translationEnabled: true,
            width: 5
        }
    ];
const $3cf089f12d06270b$var$columnsConfig = {
    colsRequiredInUpload: [
        {
            key: "styleColor",
            value: "Style-Color"
        },
        {
            key: "gender",
            value: "Gender"
        },
        {
            key: "division",
            value: "Division"
        },
        {
            key: "bin",
            value: "Bin"
        },
        {
            key: "price",
            value: "Price"
        }
    ],
    colsToDisplayInExport: [
        "styleColor",
        "gender",
        "division",
        "bin",
        "price",
        "status",
        "errors"
    ],
    colsToDisplayInUIReport: [
        "rowNo",
        "styleColor",
        "status",
        "errors"
    ]
};
const $3cf089f12d06270b$var$transformHeaders = (headers = [])=>headers.map((header)=>({
            csvHeader: header,
            csvKey: $f1q41.camelCase(header)
        }));
const $3cf089f12d06270b$var$getUiColumns = (localeForTranslation)=>{
    var _getColumns;
    return (_getColumns = $3cf089f12d06270b$var$getColumns(localeForTranslation)) === null || _getColumns === void 0 ? void 0 : _getColumns.filter((col)=>col.isRequiredInUiReport);
};
const $3cf089f12d06270b$var$getExportColumns = ()=>{
    var _getColumns2;
    return (_getColumns2 = $3cf089f12d06270b$var$getColumns()) === null || _getColumns2 === void 0 ? void 0 : _getColumns2.filter((col)=>$3cf089f12d06270b$var$columnsConfig.colsToDisplayInExport.includes(col.id));
};
const $3cf089f12d06270b$var$filterStyles = (style, filter)=>filter === "All" || style.status === filter;
const $3cf089f12d06270b$var$isMobile = ()=>Math.min(window.screen.width, window.screen.height) < 768 && window.navigator.maxTouchPoints > 0;
const $3cf089f12d06270b$var$isBohApp = ()=>!$3cf089f12d06270b$var$isMobile();
const $3cf089f12d06270b$var$extractRequiredHeaders = (headers)=>headers === null || headers === void 0 ? void 0 : headers.map((header, colIdx)=>{
        const csvKey = $f1q41.camelCase(header);
        const isRequired = !!$3cf089f12d06270b$var$columnsConfig.colsRequiredInUpload.find((item)=>item.key === csvKey);
        return {
            colIdx: colIdx,
            csvHeader: header,
            csvKey: csvKey,
            isRequired: isRequired
        };
    }).filter((item)=>item.isRequired);
const $3cf089f12d06270b$var$extractNecessaryData = (data, requiredkeys)=>data.map((row, idx)=>[
            idx === 0 ? "rowNo" : idx,
            ...$f1q41.at(row, requiredkeys)
        ]);
const $3cf089f12d06270b$var$getMissingColumns = (transformedHeaders)=>$3cf089f12d06270b$var$columnsConfig.colsRequiredInUpload.map(({ key: key, value: value })=>transformedHeaders.find((item)=>item.csvKey === key) ? null : value).filter((item)=>item);
const $3cf089f12d06270b$var$chunks = (array, chunkSize)=>$f1q41.chunk(array, chunkSize);
const $3cf089f12d06270b$var$getProgress = (completed, total)=>parseInt(completed / total * 100, 10);
const $3cf089f12d06270b$var$transformCsvToJsonObj = (csvArr)=>{
    const headers = $3cf089f12d06270b$var$transformHeaders(csvArr[0]);
    const csvArrWithoutHeaders = csvArr.slice(1);
    const itemIds = {};
    const rows = csvArrWithoutHeaders.reduce((agg, arr, idx)=>{
        agg.push(arr.reduce((obj, item, colIdx)=>{
            if (colIdx === 0) obj.rowNo = idx + 1;
            if ($3cf089f12d06270b$var$REQUIRED_FIELDS.includes(headers[colIdx].csvKey)) obj[headers[colIdx].csvKey] = item;
            return obj;
        }, {}));
        return agg;
    }, []);
    return {
        headers: headers,
        itemIds: itemIds,
        rows: rows
    };
};
const $3cf089f12d06270b$var$Test = {
    getColumns: $3cf089f12d06270b$var$getColumns,
    getErrorTranslation: $3cf089f12d06270b$var$getErrorTranslation
};
module.exports = {
    chunks: $3cf089f12d06270b$var$chunks,
    extractNecessaryData: $3cf089f12d06270b$var$extractNecessaryData,
    extractRequiredHeaders: $3cf089f12d06270b$var$extractRequiredHeaders,
    filterStyles: $3cf089f12d06270b$var$filterStyles,
    getErrorTranslation: $3cf089f12d06270b$var$getErrorTranslation,
    getExportColumns: $3cf089f12d06270b$var$getExportColumns,
    getMissingColumns: $3cf089f12d06270b$var$getMissingColumns,
    getProgress: $3cf089f12d06270b$var$getProgress,
    getUiColumns: $3cf089f12d06270b$var$getUiColumns,
    isBohApp: $3cf089f12d06270b$var$isBohApp,
    Test: $3cf089f12d06270b$var$Test,
    transformCsvToJsonObj: $3cf089f12d06270b$var$transformCsvToJsonObj
};

});
parcelRegister("f1q41", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});



parcelRegister("lX5Ms", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $ffb3978ff25a6923$export$1e511d4a378977f5, (v) => $ffb3978ff25a6923$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ffb3978ff25a6923$export$2e2bcd8739ae039, (v) => $ffb3978ff25a6923$export$2e2bcd8739ae039 = v);
var $ffb3978ff25a6923$export$1e511d4a378977f5;
var $ffb3978ff25a6923$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$ffb3978ff25a6923$export$1e511d4a378977f5 = true;
$ffb3978ff25a6923$export$2e2bcd8739ae039 = void 0;

var $ffb3978ff25a6923$var$_extends2 = $1jnue((parcelRequire("3p9rK")));

var $ffb3978ff25a6923$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $ffb3978ff25a6923$var$_react = $1jnue((parcelRequire("acw62")));

var $kfZjc = parcelRequire("kfZjc");

var $ffb3978ff25a6923$var$_Auth = $1jnue((parcelRequire("fIPMX")));
/* eslint-disable react/jsx-props-no-spreading */ const $ffb3978ff25a6923$var$PrivateRoute = ({ children: children, ...rest })=>/*#__PURE__*/ $ffb3978ff25a6923$var$_react.default.createElement($kfZjc.Route, (0, $ffb3978ff25a6923$var$_extends2.default)({}, rest, {
        render: ()=>$ffb3978ff25a6923$var$_Auth.default.isAuthenticated() ? children : /*#__PURE__*/ $ffb3978ff25a6923$var$_react.default.createElement($kfZjc.Redirect, {
                to: "/login"
            })
    }));
$ffb3978ff25a6923$var$PrivateRoute.propTypes = {
    children: $ffb3978ff25a6923$var$_propTypes.default.shape().isRequired
};
var $ffb3978ff25a6923$var$_default = $ffb3978ff25a6923$export$2e2bcd8739ae039 = $ffb3978ff25a6923$var$PrivateRoute;

});

parcelRegister("6kNd6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $49cac87f569dd0af$export$1e511d4a378977f5, (v) => $49cac87f569dd0af$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $49cac87f569dd0af$export$2e2bcd8739ae039, (v) => $49cac87f569dd0af$export$2e2bcd8739ae039 = v);
var $49cac87f569dd0af$export$1e511d4a378977f5;
var $49cac87f569dd0af$export$2e2bcd8739ae039;

var $6ZWSX = parcelRequire("6ZWSX");
var $49cac87f569dd0af$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $1jnue = parcelRequire("1jnue");
$49cac87f569dd0af$export$1e511d4a378977f5 = true;
$49cac87f569dd0af$export$2e2bcd8739ae039 = void 0;

var $e080M = parcelRequire("e080M");

var $49cac87f569dd0af$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $49cac87f569dd0af$var$_react = $49cac87f569dd0af$var$_interopRequireWildcard((parcelRequire("acw62")));

var $kfZjc = parcelRequire("kfZjc");

var $49cac87f569dd0af$var$_webrtcAdapter = $1jnue((parcelRequire("QqCqw")));

var $chAV5 = parcelRequire("chAV5");

var $49cac87f569dd0af$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $49cac87f569dd0af$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $ikfii = parcelRequire("ikfii");
function $49cac87f569dd0af$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($49cac87f569dd0af$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $49cac87f569dd0af$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $49cac87f569dd0af$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// import { useSelector } from 'react-redux';
// import { getIsPartnerLogin } from '../../redux/selectors';
const $49cac87f569dd0af$var$Profile = ()=>{
    const [auth, setAuth] = (0, $49cac87f569dd0af$var$_react.useState)($49cac87f569dd0af$var$_Auth.default.getAuth());
    const authInfo = (0, $49cac87f569dd0af$var$_react.useMemo)(()=>auth && JSON.parse($49cac87f569dd0af$require$Buffer.from(auth.split(".")[1], "base64").toString("utf-8")), [
        auth
    ]);
    const translate = (0, $49cac87f569dd0af$var$_useTranslate.default)();
    // const isPartnerLogin = useSelector(getIsPartnerLogin);
    return auth ? /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement($49cac87f569dd0af$var$_react.default.Fragment, null, /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement("h1", {
        className: "display-3 text-color-accent mb3-sm"
    }, translate("RL_Profile")), /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement($49cac87f569dd0af$var$ProfileInformation, {
        authInfo: authInfo,
        translate: translate
    }), /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement($ikfii.Button, {
        label: translate("RL_LogOut"),
        sectionClassName: "d-sm-flx flx-jc-sm-c mt6-sm",
        onClick: ()=>{
            $49cac87f569dd0af$var$_Auth.default.logout();
            setAuth("");
        }
    }), /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement("p", {
        className: "body-4 mt3-sm"
    }, translate("RL_Version"), " ", $chAV5.version), /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement("p", {
        className: "body-4"
    }, $49cac87f569dd0af$var$_webrtcAdapter.default.browserDetails.browser, " ", translate("RL_Browser"))) : /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement($kfZjc.Redirect, {
        to: "/login"
    });
};
const $49cac87f569dd0af$var$ProfileInformation = ({ authInfo: authInfo, translate: translate })=>/*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement($49cac87f569dd0af$var$_react.default.Fragment, null, /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement("h3", {
        className: "headline-3"
    }, translate("RL_Athlete"), " ", authInfo.nike_athleteLogin), /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement("h3", {
        className: "headline-3"
    }, localStorage.getItem("country"), " - ", localStorage.getItem("storeNumber")), /*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement("p", {
        className: "body-2 mt3-sm"
    }, translate("RL_AthleteRoles"), ":"), (0, $e080M.sort)(authInfo.nike_storeRoles).map((role)=>/*#__PURE__*/ $49cac87f569dd0af$var$_react.default.createElement("p", {
            key: role,
            className: "body-4"
        }, role)));
$49cac87f569dd0af$var$ProfileInformation.propTypes = {
    authInfo: $49cac87f569dd0af$var$_propTypes.default.shape({
        nike_athleteLogin: $49cac87f569dd0af$var$_propTypes.default.string,
        nike_storeRoles: $49cac87f569dd0af$var$_propTypes.default.arrayOf($49cac87f569dd0af$var$_propTypes.default.string)
    }).isRequired,
    // isPartnerLogin: PropTypes.bool.isRequired,
    translate: $49cac87f569dd0af$var$_propTypes.default.func.isRequired
};
var $49cac87f569dd0af$var$_default = $49cac87f569dd0af$export$2e2bcd8739ae039 = $49cac87f569dd0af$var$Profile;

});
parcelRegister("QqCqw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $09d981616173740d$export$2e2bcd8739ae039);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
var $jhs1n = parcelRequire("jhs1n");
"use strict";
const $09d981616173740d$var$adapter = (0, $jhs1n.adapterFactory)({
    window: typeof window === "undefined" ? undefined : window
});
var $09d981616173740d$export$2e2bcd8739ae039 = $09d981616173740d$var$adapter;

});
parcelRegister("jhs1n", function(module, exports) {

$parcel$export(module.exports, "adapterFactory", () => $e095574c16a43495$export$e77bf46c04ac7d12);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
var $7zZv5 = parcelRequire("7zZv5");

var $7lq4J = parcelRequire("7lq4J");

var $dLWZA = parcelRequire("dLWZA");

var $gV8Pp = parcelRequire("gV8Pp");

var $deq4F = parcelRequire("deq4F");

var $7H1jZ = parcelRequire("7H1jZ");
function $e095574c16a43495$export$e77bf46c04ac7d12({ window: window } = {}, options = {
    shimChrome: true,
    shimFirefox: true,
    shimEdge: true,
    shimSafari: true
}) {
    // Utils.
    const logging = $7zZv5.log;
    const browserDetails = $7zZv5.detectBrowser(window);
    const adapter = {
        browserDetails: browserDetails,
        commonShim: $7H1jZ,
        extractVersion: $7zZv5.extractVersion,
        disableLog: $7zZv5.disableLog,
        disableWarnings: $7zZv5.disableWarnings
    };
    // Shim browser if found.
    switch(browserDetails.browser){
        case "chrome":
            if (!$7lq4J || !$7lq4J.shimPeerConnection || !options.shimChrome) {
                logging("Chrome shim is not included in this adapter release.");
                return adapter;
            }
            if (browserDetails.version === null) {
                logging("Chrome shim can not determine version, not shimming.");
                return adapter;
            }
            logging("adapter.js shimming chrome.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $7lq4J;
            // Must be called before shimPeerConnection.
            $7H1jZ.shimAddIceCandidateNullOrEmpty(window, browserDetails);
            $7lq4J.shimGetUserMedia(window, browserDetails);
            $7lq4J.shimMediaStream(window, browserDetails);
            $7lq4J.shimPeerConnection(window, browserDetails);
            $7lq4J.shimOnTrack(window, browserDetails);
            $7lq4J.shimAddTrackRemoveTrack(window, browserDetails);
            $7lq4J.shimGetSendersWithDtmf(window, browserDetails);
            $7lq4J.shimGetStats(window, browserDetails);
            $7lq4J.shimSenderReceiverGetStats(window, browserDetails);
            $7lq4J.fixNegotiationNeeded(window, browserDetails);
            $7H1jZ.shimRTCIceCandidate(window, browserDetails);
            $7H1jZ.shimConnectionState(window, browserDetails);
            $7H1jZ.shimMaxMessageSize(window, browserDetails);
            $7H1jZ.shimSendThrowTypeError(window, browserDetails);
            $7H1jZ.removeExtmapAllowMixed(window, browserDetails);
            break;
        case "firefox":
            if (!$gV8Pp || !$gV8Pp.shimPeerConnection || !options.shimFirefox) {
                logging("Firefox shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming firefox.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $gV8Pp;
            // Must be called before shimPeerConnection.
            $7H1jZ.shimAddIceCandidateNullOrEmpty(window, browserDetails);
            $gV8Pp.shimGetUserMedia(window, browserDetails);
            $gV8Pp.shimPeerConnection(window, browserDetails);
            $gV8Pp.shimOnTrack(window, browserDetails);
            $gV8Pp.shimRemoveStream(window, browserDetails);
            $gV8Pp.shimSenderGetStats(window, browserDetails);
            $gV8Pp.shimReceiverGetStats(window, browserDetails);
            $gV8Pp.shimRTCDataChannel(window, browserDetails);
            $gV8Pp.shimAddTransceiver(window, browserDetails);
            $gV8Pp.shimGetParameters(window, browserDetails);
            $gV8Pp.shimCreateOffer(window, browserDetails);
            $gV8Pp.shimCreateAnswer(window, browserDetails);
            $7H1jZ.shimRTCIceCandidate(window, browserDetails);
            $7H1jZ.shimConnectionState(window, browserDetails);
            $7H1jZ.shimMaxMessageSize(window, browserDetails);
            $7H1jZ.shimSendThrowTypeError(window, browserDetails);
            break;
        case "edge":
            if (!$dLWZA || !$dLWZA.shimPeerConnection || !options.shimEdge) {
                logging("MS edge shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming edge.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $dLWZA;
            $dLWZA.shimGetUserMedia(window, browserDetails);
            $dLWZA.shimGetDisplayMedia(window, browserDetails);
            $dLWZA.shimPeerConnection(window, browserDetails);
            $dLWZA.shimReplaceTrack(window, browserDetails);
            // the edge shim implements the full RTCIceCandidate object.
            $7H1jZ.shimMaxMessageSize(window, browserDetails);
            $7H1jZ.shimSendThrowTypeError(window, browserDetails);
            break;
        case "safari":
            if (!$deq4F || !options.shimSafari) {
                logging("Safari shim is not included in this adapter release.");
                return adapter;
            }
            logging("adapter.js shimming safari.");
            // Export to the adapter global object visible in the browser.
            adapter.browserShim = $deq4F;
            // Must be called before shimCallbackAPI.
            $7H1jZ.shimAddIceCandidateNullOrEmpty(window, browserDetails);
            $deq4F.shimRTCIceServerUrls(window, browserDetails);
            $deq4F.shimCreateOfferLegacy(window, browserDetails);
            $deq4F.shimCallbacksAPI(window, browserDetails);
            $deq4F.shimLocalStreamsAPI(window, browserDetails);
            $deq4F.shimRemoteStreamsAPI(window, browserDetails);
            $deq4F.shimTrackEventTransceiver(window, browserDetails);
            $deq4F.shimGetUserMedia(window, browserDetails);
            $deq4F.shimAudioContext(window, browserDetails);
            $7H1jZ.shimRTCIceCandidate(window, browserDetails);
            $7H1jZ.shimMaxMessageSize(window, browserDetails);
            $7H1jZ.shimSendThrowTypeError(window, browserDetails);
            $7H1jZ.removeExtmapAllowMixed(window, browserDetails);
            break;
        default:
            logging("Unsupported browser!");
            break;
    }
    return adapter;
}

});
parcelRegister("7zZv5", function(module, exports) {

$parcel$export(module.exports, "extractVersion", () => $584b81f9a9b8bf97$export$e3c02be309be1f23);
$parcel$export(module.exports, "wrapPeerConnectionEvent", () => $584b81f9a9b8bf97$export$1f48841962b828b1);
$parcel$export(module.exports, "disableLog", () => $584b81f9a9b8bf97$export$afbfee8cc06fd3e4);
$parcel$export(module.exports, "disableWarnings", () => $584b81f9a9b8bf97$export$51516be4b019e41e);
$parcel$export(module.exports, "log", () => $584b81f9a9b8bf97$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "deprecated", () => $584b81f9a9b8bf97$export$cdd73fc4100a6ef4);
$parcel$export(module.exports, "detectBrowser", () => $584b81f9a9b8bf97$export$2d31490a0c05f094);
$parcel$export(module.exports, "compactObject", () => $584b81f9a9b8bf97$export$15384eac40dc88c8);
$parcel$export(module.exports, "filterStats", () => $584b81f9a9b8bf97$export$93439ffc3f787d51);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
let $584b81f9a9b8bf97$var$logDisabled_ = true;
let $584b81f9a9b8bf97$var$deprecationWarnings_ = true;
function $584b81f9a9b8bf97$export$e3c02be309be1f23(uastring, expr, pos) {
    const match = uastring.match(expr);
    return match && match.length >= pos && parseInt(match[pos], 10);
}
function $584b81f9a9b8bf97$export$1f48841962b828b1(window1, eventNameToWrap, wrapper) {
    if (!window1.RTCPeerConnection) return;
    const proto = window1.RTCPeerConnection.prototype;
    const nativeAddEventListener = proto.addEventListener;
    proto.addEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap) return nativeAddEventListener.apply(this, arguments);
        const wrappedCallback = (e)=>{
            const modifiedEvent = wrapper(e);
            if (modifiedEvent) {
                if (cb.handleEvent) cb.handleEvent(modifiedEvent);
                else cb(modifiedEvent);
            }
        };
        this._eventMap = this._eventMap || {};
        if (!this._eventMap[eventNameToWrap]) this._eventMap[eventNameToWrap] = new Map();
        this._eventMap[eventNameToWrap].set(cb, wrappedCallback);
        return nativeAddEventListener.apply(this, [
            nativeEventName,
            wrappedCallback
        ]);
    };
    const nativeRemoveEventListener = proto.removeEventListener;
    proto.removeEventListener = function(nativeEventName, cb) {
        if (nativeEventName !== eventNameToWrap || !this._eventMap || !this._eventMap[eventNameToWrap]) return nativeRemoveEventListener.apply(this, arguments);
        if (!this._eventMap[eventNameToWrap].has(cb)) return nativeRemoveEventListener.apply(this, arguments);
        const unwrappedCb = this._eventMap[eventNameToWrap].get(cb);
        this._eventMap[eventNameToWrap].delete(cb);
        if (this._eventMap[eventNameToWrap].size === 0) delete this._eventMap[eventNameToWrap];
        if (Object.keys(this._eventMap).length === 0) delete this._eventMap;
        return nativeRemoveEventListener.apply(this, [
            nativeEventName,
            unwrappedCb
        ]);
    };
    Object.defineProperty(proto, "on" + eventNameToWrap, {
        get () {
            return this["_on" + eventNameToWrap];
        },
        set (cb) {
            if (this["_on" + eventNameToWrap]) {
                this.removeEventListener(eventNameToWrap, this["_on" + eventNameToWrap]);
                delete this["_on" + eventNameToWrap];
            }
            if (cb) this.addEventListener(eventNameToWrap, this["_on" + eventNameToWrap] = cb);
        },
        enumerable: true,
        configurable: true
    });
}
function $584b81f9a9b8bf97$export$afbfee8cc06fd3e4(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $584b81f9a9b8bf97$var$logDisabled_ = bool;
    return bool ? "adapter.js logging disabled" : "adapter.js logging enabled";
}
function $584b81f9a9b8bf97$export$51516be4b019e41e(bool) {
    if (typeof bool !== "boolean") return new Error("Argument type: " + typeof bool + ". Please use a boolean.");
    $584b81f9a9b8bf97$var$deprecationWarnings_ = !bool;
    return "adapter.js deprecation warnings " + (bool ? "disabled" : "enabled");
}
function $584b81f9a9b8bf97$export$bef1f36f5486a6a3() {
    if (typeof window === "object") {
        if ($584b81f9a9b8bf97$var$logDisabled_) return;
        if (typeof console !== "undefined" && typeof console.log === "function") console.log.apply(console, arguments);
    }
}
function $584b81f9a9b8bf97$export$cdd73fc4100a6ef4(oldMethod, newMethod) {
    if (!$584b81f9a9b8bf97$var$deprecationWarnings_) return;
    console.warn(oldMethod + " is deprecated, please use " + newMethod + " instead.");
}
function $584b81f9a9b8bf97$export$2d31490a0c05f094(window1) {
    // Returned result object.
    const result = {
        browser: null,
        version: null
    };
    // Fail early if it's not a browser
    if (typeof window1 === "undefined" || !window1.navigator) {
        result.browser = "Not a browser.";
        return result;
    }
    const { navigator: navigator } = window1;
    if (navigator.mozGetUserMedia) {
        result.browser = "firefox";
        result.version = $584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia || window1.isSecureContext === false && window1.webkitRTCPeerConnection && !window1.RTCIceGatherer) {
        // Chrome, Chromium, Webview, Opera.
        // Version matches Chrome/WebRTC version.
        // Chrome 74 removed webkitGetUserMedia on http as well so we need the
        // more complicated fallback to webkitRTCPeerConnection.
        result.browser = "chrome";
        result.version = $584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (navigator.mediaDevices && navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) {
        result.browser = "edge";
        result.version = $584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /Edge\/(\d+).(\d+)$/, 2);
    } else if (window1.RTCPeerConnection && navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) {
        result.browser = "safari";
        result.version = $584b81f9a9b8bf97$export$e3c02be309be1f23(navigator.userAgent, /AppleWebKit\/(\d+)\./, 1);
        result.supportsUnifiedPlan = window1.RTCRtpTransceiver && "currentDirection" in window1.RTCRtpTransceiver.prototype;
    } else {
        result.browser = "Not a supported browser.";
        return result;
    }
    return result;
}
/**
 * Checks if something is an object.
 *
 * @param {*} val The something you want to check.
 * @return true if val is an object, false otherwise.
 */ function $584b81f9a9b8bf97$var$isObject(val) {
    return Object.prototype.toString.call(val) === "[object Object]";
}
function $584b81f9a9b8bf97$export$15384eac40dc88c8(data) {
    if (!$584b81f9a9b8bf97$var$isObject(data)) return data;
    return Object.keys(data).reduce(function(accumulator, key) {
        const isObj = $584b81f9a9b8bf97$var$isObject(data[key]);
        const value = isObj ? $584b81f9a9b8bf97$export$15384eac40dc88c8(data[key]) : data[key];
        const isEmptyObject = isObj && !Object.keys(value).length;
        if (value === undefined || isEmptyObject) return accumulator;
        return Object.assign(accumulator, {
            [key]: value
        });
    }, {});
}
function $584b81f9a9b8bf97$export$571b373e75babb58(stats, base, resultSet) {
    if (!base || resultSet.has(base.id)) return;
    resultSet.set(base.id, base);
    Object.keys(base).forEach((name)=>{
        if (name.endsWith("Id")) $584b81f9a9b8bf97$export$571b373e75babb58(stats, stats.get(base[name]), resultSet);
        else if (name.endsWith("Ids")) base[name].forEach((id)=>{
            $584b81f9a9b8bf97$export$571b373e75babb58(stats, stats.get(id), resultSet);
        });
    });
}
function $584b81f9a9b8bf97$export$93439ffc3f787d51(result, track, outbound) {
    const streamStatsType = outbound ? "outbound-rtp" : "inbound-rtp";
    const filteredResult = new Map();
    if (track === null) return filteredResult;
    const trackStats = [];
    result.forEach((value)=>{
        if (value.type === "track" && value.trackIdentifier === track.id) trackStats.push(value);
    });
    trackStats.forEach((trackStat)=>{
        result.forEach((stats)=>{
            if (stats.type === streamStatsType && stats.trackId === trackStat.id) $584b81f9a9b8bf97$export$571b373e75babb58(result, stats, filteredResult);
        });
    });
    return filteredResult;
}

});

parcelRegister("7lq4J", function(module, exports) {

$parcel$export(module.exports, "shimMediaStream", () => $558eb894511c4db3$export$33ee24e7a300bcd1);
$parcel$export(module.exports, "shimOnTrack", () => $558eb894511c4db3$export$f358708f68ab068);
$parcel$export(module.exports, "shimGetSendersWithDtmf", () => $558eb894511c4db3$export$a41a030a2842f5d6);
$parcel$export(module.exports, "shimGetStats", () => $558eb894511c4db3$export$90608323826f0b17);
$parcel$export(module.exports, "shimSenderReceiverGetStats", () => $558eb894511c4db3$export$f2f0f2338114eb4b);
$parcel$export(module.exports, "shimAddTrackRemoveTrackWithNative", () => $558eb894511c4db3$export$30e3cdd46f8d5100);
$parcel$export(module.exports, "shimAddTrackRemoveTrack", () => $558eb894511c4db3$export$9588259fcf4ebc91);
$parcel$export(module.exports, "shimPeerConnection", () => $558eb894511c4db3$export$852a08dda9a55ea7);
$parcel$export(module.exports, "fixNegotiationNeeded", () => $558eb894511c4db3$export$341293bbeaae37cb);
$parcel$export(module.exports, "shimGetUserMedia", () => (parcelRequire("g7Lue")).shimGetUserMedia);
$parcel$export(module.exports, "shimGetDisplayMedia", () => (parcelRequire("4MCaR")).shimGetDisplayMedia);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
var $7zZv5 = parcelRequire("7zZv5");

var $g7Lue = parcelRequire("g7Lue");

var $4MCaR = parcelRequire("4MCaR");
"use strict";
function $558eb894511c4db3$export$33ee24e7a300bcd1(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
}
function $558eb894511c4db3$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCPeerConnection && !("ontrack" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "ontrack", {
            get () {
                return this._ontrack;
            },
            set (f) {
                if (this._ontrack) this.removeEventListener("track", this._ontrack);
                this.addEventListener("track", this._ontrack = f);
            },
            enumerable: true,
            configurable: true
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            if (!this._ontrackpoly) {
                this._ontrackpoly = (e)=>{
                    // onaddstream does not fire when a track is added to an existing
                    // stream. But stream.onaddtrack is implemented so we use that.
                    e.stream.addEventListener("addtrack", (te)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === te.track.id);
                        else receiver = {
                            track: te.track
                        };
                        const event = new Event("track");
                        event.track = te.track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                    e.stream.getTracks().forEach((track)=>{
                        let receiver;
                        if (window.RTCPeerConnection.prototype.getReceivers) receiver = this.getReceivers().find((r)=>r.track && r.track.id === track.id);
                        else receiver = {
                            track: track
                        };
                        const event = new Event("track");
                        event.track = track;
                        event.receiver = receiver;
                        event.transceiver = {
                            receiver: receiver
                        };
                        event.streams = [
                            e.stream
                        ];
                        this.dispatchEvent(event);
                    });
                };
                this.addEventListener("addstream", this._ontrackpoly);
            }
            return origSetRemoteDescription.apply(this, arguments);
        };
    } else // even if RTCRtpTransceiver is in window, it is only used and
    // emitted in unified-plan. Unfortunately this means we need
    // to unconditionally wrap the event.
    $7zZv5.wrapPeerConnectionEvent(window, "track", (e)=>{
        if (!e.transceiver) Object.defineProperty(e, "transceiver", {
            value: {
                receiver: e.receiver
            }
        });
        return e;
    });
}
function $558eb894511c4db3$export$a41a030a2842f5d6(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === "object" && window.RTCPeerConnection && !("getSenders" in window.RTCPeerConnection.prototype) && "createDTMFSender" in window.RTCPeerConnection.prototype) {
        const shimSenderWithDtmf = function(pc, track) {
            return {
                track: track,
                get dtmf () {
                    if (this._dtmf === undefined) {
                        if (track.kind === "audio") this._dtmf = pc.createDTMFSender(track);
                        else this._dtmf = null;
                    }
                    return this._dtmf;
                },
                _pc: pc
            };
        };
        // augment addTrack when getSenders is not available.
        if (!window.RTCPeerConnection.prototype.getSenders) {
            window.RTCPeerConnection.prototype.getSenders = function getSenders() {
                this._senders = this._senders || [];
                return this._senders.slice(); // return a copy of the internal state.
            };
            const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
            window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
                let sender = origAddTrack.apply(this, arguments);
                if (!sender) {
                    sender = shimSenderWithDtmf(this, track);
                    this._senders.push(sender);
                }
                return sender;
            };
            const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
            window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
                origRemoveTrack.apply(this, arguments);
                const idx = this._senders.indexOf(sender);
                if (idx !== -1) this._senders.splice(idx, 1);
            };
        }
        const origAddStream = window.RTCPeerConnection.prototype.addStream;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            this._senders = this._senders || [];
            origAddStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                this._senders.push(shimSenderWithDtmf(this, track));
            });
        };
        const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
        window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
            this._senders = this._senders || [];
            origRemoveStream.apply(this, [
                stream
            ]);
            stream.getTracks().forEach((track)=>{
                const sender = this._senders.find((s)=>s.track === track);
                if (sender) this._senders.splice(this._senders.indexOf(sender), 1);
            });
        };
    } else if (typeof window === "object" && window.RTCPeerConnection && "getSenders" in window.RTCPeerConnection.prototype && "createDTMFSender" in window.RTCPeerConnection.prototype && window.RTCRtpSender && !("dtmf" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        Object.defineProperty(window.RTCRtpSender.prototype, "dtmf", {
            get () {
                if (this._dtmf === undefined) {
                    if (this.track.kind === "audio") this._dtmf = this._pc.createDTMFSender(this.track);
                    else this._dtmf = null;
                }
                return this._dtmf;
            }
        });
    }
}
function $558eb894511c4db3$export$90608323826f0b17(window) {
    if (!window.RTCPeerConnection) return;
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        // If selector is a function then we are in the old style stats so just
        // pass back the original getStats format to avoid breaking old users.
        if (arguments.length > 0 && typeof selector === "function") return origGetStats.apply(this, arguments);
        // When spec-style getStats is supported, return those when called with
        // either no arguments or the selector argument is null.
        if (origGetStats.length === 0 && (arguments.length === 0 || typeof selector !== "function")) return origGetStats.apply(this, []);
        const fixChromeStats_ = function(response) {
            const standardReport = {};
            const reports = response.result();
            reports.forEach((report)=>{
                const standardStats = {
                    id: report.id,
                    timestamp: report.timestamp,
                    type: {
                        localcandidate: "local-candidate",
                        remotecandidate: "remote-candidate"
                    }[report.type] || report.type
                };
                report.names().forEach((name)=>{
                    standardStats[name] = report.stat(name);
                });
                standardReport[standardStats.id] = standardStats;
            });
            return standardReport;
        };
        // shim getStats with maplike support
        const makeMapStats = function(stats) {
            return new Map(Object.keys(stats).map((key)=>[
                    key,
                    stats[key]
                ]));
        };
        if (arguments.length >= 2) {
            const successCallbackWrapper_ = function(response) {
                onSucc(makeMapStats(fixChromeStats_(response)));
            };
            return origGetStats.apply(this, [
                successCallbackWrapper_,
                selector
            ]);
        }
        // promise-support
        return new Promise((resolve, reject)=>{
            origGetStats.apply(this, [
                function(response) {
                    resolve(makeMapStats(fixChromeStats_(response)));
                },
                reject
            ]);
        }).then(onSucc, onErr);
    };
}
function $558eb894511c4db3$export$f2f0f2338114eb4b(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender && window.RTCRtpReceiver)) return;
    // shim sender stats.
    if (!("getStats" in window.RTCRtpSender.prototype)) {
        const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
        if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
            const senders = origGetSenders.apply(this, []);
            senders.forEach((sender)=>sender._pc = this);
            return senders;
        };
        const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
            const sender = origAddTrack.apply(this, arguments);
            sender._pc = this;
            return sender;
        };
        window.RTCRtpSender.prototype.getStats = function getStats() {
            const sender = this;
            return this._pc.getStats().then((result)=>/* Note: this will include stats of all senders that
         *   send a track with the same id as sender.track as
         *   it is not possible to identify the RTCRtpSender.
         */ $7zZv5.filterStats(result, sender.track, true));
        };
    }
    // shim receiver stats.
    if (!("getStats" in window.RTCRtpReceiver.prototype)) {
        const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
        if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
            const receivers = origGetReceivers.apply(this, []);
            receivers.forEach((receiver)=>receiver._pc = this);
            return receivers;
        };
        $7zZv5.wrapPeerConnectionEvent(window, "track", (e)=>{
            e.receiver._pc = e.srcElement;
            return e;
        });
        window.RTCRtpReceiver.prototype.getStats = function getStats() {
            const receiver = this;
            return this._pc.getStats().then((result)=>$7zZv5.filterStats(result, receiver.track, false));
        };
    }
    if (!("getStats" in window.RTCRtpSender.prototype && "getStats" in window.RTCRtpReceiver.prototype)) return;
    // shim RTCPeerConnection.getStats(track).
    const origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        if (arguments.length > 0 && arguments[0] instanceof window.MediaStreamTrack) {
            const track = arguments[0];
            let sender;
            let receiver;
            let err;
            this.getSenders().forEach((s)=>{
                if (s.track === track) {
                    if (sender) err = true;
                    else sender = s;
                }
            });
            this.getReceivers().forEach((r)=>{
                if (r.track === track) {
                    if (receiver) err = true;
                    else receiver = r;
                }
                return r.track === track;
            });
            if (err || sender && receiver) return Promise.reject(new DOMException("There are more than one sender or receiver for the track.", "InvalidAccessError"));
            else if (sender) return sender.getStats();
            else if (receiver) return receiver.getStats();
            return Promise.reject(new DOMException("There is no sender or receiver for the track.", "InvalidAccessError"));
        }
        return origGetStats.apply(this, arguments);
    };
}
function $558eb894511c4db3$export$30e3cdd46f8d5100(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        return Object.keys(this._shimmedLocalStreams).map((streamId)=>this._shimmedLocalStreams[streamId][0]);
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (!stream) return origAddTrack.apply(this, arguments);
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        const sender = origAddTrack.apply(this, arguments);
        if (!this._shimmedLocalStreams[stream.id]) this._shimmedLocalStreams[stream.id] = [
            stream,
            sender
        ];
        else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) this._shimmedLocalStreams[stream.id].push(sender);
        return sender;
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        const existingSenders = this.getSenders();
        origAddStream.apply(this, arguments);
        const newSenders = this.getSenders().filter((newSender)=>existingSenders.indexOf(newSender) === -1);
        this._shimmedLocalStreams[stream.id] = [
            stream
        ].concat(newSenders);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        delete this._shimmedLocalStreams[stream.id];
        return origRemoveStream.apply(this, arguments);
    };
    const origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        this._shimmedLocalStreams = this._shimmedLocalStreams || {};
        if (sender) Object.keys(this._shimmedLocalStreams).forEach((streamId)=>{
            const idx = this._shimmedLocalStreams[streamId].indexOf(sender);
            if (idx !== -1) this._shimmedLocalStreams[streamId].splice(idx, 1);
            if (this._shimmedLocalStreams[streamId].length === 1) delete this._shimmedLocalStreams[streamId];
        });
        return origRemoveTrack.apply(this, arguments);
    };
}
function $558eb894511c4db3$export$9588259fcf4ebc91(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack && browserDetails.version >= 65) return $558eb894511c4db3$export$30e3cdd46f8d5100(window);
    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    const origGetLocalStreams = window.RTCPeerConnection.prototype.getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        const nativeStreams = origGetLocalStreams.apply(this);
        this._reverseStreams = this._reverseStreams || {};
        return nativeStreams.map((stream)=>this._reverseStreams[stream.id]);
    };
    const origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        stream.getTracks().forEach((track)=>{
            const alreadyExists = this.getSenders().find((s)=>s.track === track);
            if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        });
        // Add identity mapping for consistency with addTrack.
        // Unless this is being used with a stream from addTrack.
        if (!this._reverseStreams[stream.id]) {
            const newStream = new window.MediaStream(stream.getTracks());
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            stream = newStream;
        }
        origAddStream.apply(this, [
            stream
        ]);
    };
    const origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        origRemoveStream.apply(this, [
            this._streams[stream.id] || stream
        ]);
        delete this._reverseStreams[this._streams[stream.id] ? this._streams[stream.id].id : stream.id];
        delete this._streams[stream.id];
    };
    window.RTCPeerConnection.prototype.addTrack = function addTrack(track, stream) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        const streams = [].slice.call(arguments, 1);
        if (streams.length !== 1 || !streams[0].getTracks().find((t)=>t === track)) // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.", "NotSupportedError");
        const alreadyExists = this.getSenders().find((s)=>s.track === track);
        if (alreadyExists) throw new DOMException("Track already exists.", "InvalidAccessError");
        this._streams = this._streams || {};
        this._reverseStreams = this._reverseStreams || {};
        const oldStream = this._streams[stream.id];
        if (oldStream) {
            // this is using odd Chrome behaviour, use with caution:
            // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
            // Note: we rely on the high-level addTrack/dtmf shim to
            // create the sender with a dtmf sender.
            oldStream.addTrack(track);
            // Trigger ONN async.
            Promise.resolve().then(()=>{
                this.dispatchEvent(new Event("negotiationneeded"));
            });
        } else {
            const newStream = new window.MediaStream([
                track
            ]);
            this._streams[stream.id] = newStream;
            this._reverseStreams[newStream.id] = stream;
            this.addStream(newStream);
        }
        return this.getSenders().find((s)=>s.track === track);
    };
    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(internalStream.id, "g"), externalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    function replaceExternalStreamId(pc, description) {
        let sdp = description.sdp;
        Object.keys(pc._reverseStreams || []).forEach((internalId)=>{
            const externalStream = pc._reverseStreams[internalId];
            const internalStream = pc._streams[externalStream.id];
            sdp = sdp.replace(new RegExp(externalStream.id, "g"), internalStream.id);
        });
        return new RTCSessionDescription({
            type: description.type,
            sdp: sdp
        });
    }
    [
        "createOffer",
        "createAnswer"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                const args = arguments;
                const isLegacyCall = arguments.length && typeof arguments[0] === "function";
                if (isLegacyCall) return nativeMethod.apply(this, [
                    (description)=>{
                        const desc = replaceInternalStreamId(this, description);
                        args[0].apply(null, [
                            desc
                        ]);
                    },
                    (err)=>{
                        if (args[1]) args[1].apply(null, err);
                    },
                    arguments[2]
                ]);
                return nativeMethod.apply(this, arguments).then((description)=>replaceInternalStreamId(this, description));
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const origSetLocalDescription = window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function setLocalDescription() {
        if (!arguments.length || !arguments[0].type) return origSetLocalDescription.apply(this, arguments);
        arguments[0] = replaceExternalStreamId(this, arguments[0]);
        return origSetLocalDescription.apply(this, arguments);
    };
    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier
    const origLocalDescription = Object.getOwnPropertyDescriptor(window.RTCPeerConnection.prototype, "localDescription");
    Object.defineProperty(window.RTCPeerConnection.prototype, "localDescription", {
        get () {
            const description = origLocalDescription.get.apply(this);
            if (description.type === "") return description;
            return replaceInternalStreamId(this, description);
        }
    });
    window.RTCPeerConnection.prototype.removeTrack = function removeTrack(sender) {
        if (this.signalingState === "closed") throw new DOMException("The RTCPeerConnection's signalingState is 'closed'.", "InvalidStateError");
        // We can not yet check for sender instanceof RTCRtpSender
        // since we shim RTPSender. So we check if sender._pc is set.
        if (!sender._pc) throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.", "TypeError");
        const isLocal = sender._pc === this;
        if (!isLocal) throw new DOMException("Sender was not created by this connection.", "InvalidAccessError");
        // Search for the native stream the senders track belongs to.
        this._streams = this._streams || {};
        let stream;
        Object.keys(this._streams).forEach((streamid)=>{
            const hasTrack = this._streams[streamid].getTracks().find((track)=>sender.track === track);
            if (hasTrack) stream = this._streams[streamid];
        });
        if (stream) {
            if (stream.getTracks().length === 1) // if this is the last track of the stream, remove the stream. This
            // takes care of any shimmed _senders.
            this.removeStream(this._reverseStreams[stream.id]);
            else // relying on the same odd chrome behaviour as above.
            stream.removeTrack(sender.track);
            this.dispatchEvent(new Event("negotiationneeded"));
        }
    };
}
function $558eb894511c4db3$export$852a08dda9a55ea7(window, browserDetails) {
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.webkitRTCPeerConnection;
    if (!window.RTCPeerConnection) return;
    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    if (browserDetails.version < 53) [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
}
function $558eb894511c4db3$export$341293bbeaae37cb(window, browserDetails) {
    $7zZv5.wrapPeerConnectionEvent(window, "negotiationneeded", (e)=>{
        const pc = e.target;
        if (browserDetails.version < 72 || pc.getConfiguration && pc.getConfiguration().sdpSemantics === "plan-b") {
            if (pc.signalingState !== "stable") return;
        }
        return e;
    });
}

});
parcelRegister("g7Lue", function(module, exports) {

$parcel$export(module.exports, "shimGetUserMedia", () => $bbd222a30988f5e1$export$1ed4910f4d37dc5e);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
var $7zZv5 = parcelRequire("7zZv5");
"use strict";
const $bbd222a30988f5e1$var$logging = $7zZv5.log;
function $bbd222a30988f5e1$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    if (!navigator.mediaDevices) return;
    const constraintsToChrome_ = function(c) {
        if (typeof c !== "object" || c.mandatory || c.optional) return c;
        const cc = {};
        Object.keys(c).forEach((key)=>{
            if (key === "require" || key === "advanced" || key === "mediaSource") return;
            const r = typeof c[key] === "object" ? c[key] : {
                ideal: c[key]
            };
            if (r.exact !== undefined && typeof r.exact === "number") r.min = r.max = r.exact;
            const oldname_ = function(prefix, name) {
                if (prefix) return prefix + name.charAt(0).toUpperCase() + name.slice(1);
                return name === "deviceId" ? "sourceId" : name;
            };
            if (r.ideal !== undefined) {
                cc.optional = cc.optional || [];
                let oc = {};
                if (typeof r.ideal === "number") {
                    oc[oldname_("min", key)] = r.ideal;
                    cc.optional.push(oc);
                    oc = {};
                    oc[oldname_("max", key)] = r.ideal;
                    cc.optional.push(oc);
                } else {
                    oc[oldname_("", key)] = r.ideal;
                    cc.optional.push(oc);
                }
            }
            if (r.exact !== undefined && typeof r.exact !== "number") {
                cc.mandatory = cc.mandatory || {};
                cc.mandatory[oldname_("", key)] = r.exact;
            } else [
                "min",
                "max"
            ].forEach((mix)=>{
                if (r[mix] !== undefined) {
                    cc.mandatory = cc.mandatory || {};
                    cc.mandatory[oldname_(mix, key)] = r[mix];
                }
            });
        });
        if (c.advanced) cc.optional = (cc.optional || []).concat(c.advanced);
        return cc;
    };
    const shimConstraints_ = function(constraints, func) {
        if (browserDetails.version >= 61) return func(constraints);
        constraints = JSON.parse(JSON.stringify(constraints));
        if (constraints && typeof constraints.audio === "object") {
            const remap = function(obj, a, b) {
                if (a in obj && !(b in obj)) {
                    obj[b] = obj[a];
                    delete obj[a];
                }
            };
            constraints = JSON.parse(JSON.stringify(constraints));
            remap(constraints.audio, "autoGainControl", "googAutoGainControl");
            remap(constraints.audio, "noiseSuppression", "googNoiseSuppression");
            constraints.audio = constraintsToChrome_(constraints.audio);
        }
        if (constraints && typeof constraints.video === "object") {
            // Shim facingMode for mobile & surface pro.
            let face = constraints.video.facingMode;
            face = face && (typeof face === "object" ? face : {
                ideal: face
            });
            const getSupportedFacingModeLies = browserDetails.version < 66;
            if (face && (face.exact === "user" || face.exact === "environment" || face.ideal === "user" || face.ideal === "environment") && !(navigator.mediaDevices.getSupportedConstraints && navigator.mediaDevices.getSupportedConstraints().facingMode && !getSupportedFacingModeLies)) {
                delete constraints.video.facingMode;
                let matches;
                if (face.exact === "environment" || face.ideal === "environment") matches = [
                    "back",
                    "rear"
                ];
                else if (face.exact === "user" || face.ideal === "user") matches = [
                    "front"
                ];
                if (matches) // Look for matches in label, or use last cam for back (typical).
                return navigator.mediaDevices.enumerateDevices().then((devices)=>{
                    devices = devices.filter((d)=>d.kind === "videoinput");
                    let dev = devices.find((d)=>matches.some((match)=>d.label.toLowerCase().includes(match)));
                    if (!dev && devices.length && matches.includes("back")) dev = devices[devices.length - 1]; // more likely the back cam
                    if (dev) constraints.video.deviceId = face.exact ? {
                        exact: dev.deviceId
                    } : {
                        ideal: dev.deviceId
                    };
                    constraints.video = constraintsToChrome_(constraints.video);
                    $bbd222a30988f5e1$var$logging("chrome: " + JSON.stringify(constraints));
                    return func(constraints);
                });
            }
            constraints.video = constraintsToChrome_(constraints.video);
        }
        $bbd222a30988f5e1$var$logging("chrome: " + JSON.stringify(constraints));
        return func(constraints);
    };
    const shimError_ = function(e) {
        if (browserDetails.version >= 64) return e;
        return {
            name: ({
                PermissionDeniedError: "NotAllowedError",
                PermissionDismissedError: "NotAllowedError",
                InvalidStateError: "NotAllowedError",
                DevicesNotFoundError: "NotFoundError",
                ConstraintNotSatisfiedError: "OverconstrainedError",
                TrackStartError: "NotReadableError",
                MediaDeviceFailedDueToShutdown: "NotAllowedError",
                MediaDeviceKillSwitchOn: "NotAllowedError",
                TabCaptureError: "AbortError",
                ScreenCaptureError: "AbortError",
                DeviceCaptureError: "AbortError"
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint || e.constraintName,
            toString () {
                return this.name + (this.message && ": ") + this.message;
            }
        };
    };
    const getUserMedia_ = function(constraints, onSuccess, onError) {
        shimConstraints_(constraints, (c)=>{
            navigator.webkitGetUserMedia(c, onSuccess, (e)=>{
                if (onError) onError(shimError_(e));
            });
        });
    };
    navigator.getUserMedia = getUserMedia_.bind(navigator);
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    if (navigator.mediaDevices.getUserMedia) {
        const origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(cs) {
            return shimConstraints_(cs, (c)=>origGetUserMedia(c).then((stream)=>{
                    if (c.audio && !stream.getAudioTracks().length || c.video && !stream.getVideoTracks().length) {
                        stream.getTracks().forEach((track)=>{
                            track.stop();
                        });
                        throw new DOMException("", "NotFoundError");
                    }
                    return stream;
                }, (e)=>Promise.reject(shimError_(e))));
        };
    }
}

});

parcelRegister("4MCaR", function(module, exports) {

$parcel$export(module.exports, "shimGetDisplayMedia", () => $37b941bc77cf20ee$export$97270b87351d9c04);
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $37b941bc77cf20ee$export$97270b87351d9c04(window, getSourceId) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    // getSourceId is a function that returns a promise resolving with
    // the sourceId of the screen/window/tab to be shared.
    if (typeof getSourceId !== "function") {
        console.error("shimGetDisplayMedia: getSourceId argument is not a function");
        return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        return getSourceId(constraints).then((sourceId)=>{
            const widthSpecified = constraints.video && constraints.video.width;
            const heightSpecified = constraints.video && constraints.video.height;
            const frameRateSpecified = constraints.video && constraints.video.frameRate;
            constraints.video = {
                mandatory: {
                    chromeMediaSource: "desktop",
                    chromeMediaSourceId: sourceId,
                    maxFrameRate: frameRateSpecified || 3
                }
            };
            if (widthSpecified) constraints.video.mandatory.maxWidth = widthSpecified;
            if (heightSpecified) constraints.video.mandatory.maxHeight = heightSpecified;
            return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
}

});


parcelRegister("dLWZA", function(module, exports) {

$parcel$export(module.exports, "shimPeerConnection", () => $a06d6cd16fdc81fa$export$852a08dda9a55ea7);
$parcel$export(module.exports, "shimReplaceTrack", () => $a06d6cd16fdc81fa$export$72e310cc73676e34);
$parcel$export(module.exports, "shimGetUserMedia", () => (parcelRequire("j21PI")).shimGetUserMedia);
$parcel$export(module.exports, "shimGetDisplayMedia", () => (parcelRequire("8u9ip")).shimGetDisplayMedia);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
var $7zZv5 = parcelRequire("7zZv5");

var $1qNPx = parcelRequire("1qNPx");

var $12pYe = parcelRequire("12pYe");

var $j21PI = parcelRequire("j21PI");

var $8u9ip = parcelRequire("8u9ip");
"use strict";
function $a06d6cd16fdc81fa$export$852a08dda9a55ea7(window, browserDetails) {
    if (window.RTCIceGatherer) {
        if (!window.RTCIceCandidate) window.RTCIceCandidate = function RTCIceCandidate(args) {
            return args;
        };
        if (!window.RTCSessionDescription) window.RTCSessionDescription = function RTCSessionDescription(args) {
            return args;
        };
        // this adds an additional event listener to MediaStrackTrack that signals
        // when a tracks enabled property was changed. Workaround for a bug in
        // addStream, see below. No longer required in 15025+
        if (browserDetails.version < 15025) {
            const origMSTEnabled = Object.getOwnPropertyDescriptor(window.MediaStreamTrack.prototype, "enabled");
            Object.defineProperty(window.MediaStreamTrack.prototype, "enabled", {
                set (value) {
                    origMSTEnabled.set.call(this, value);
                    const ev = new Event("enabled");
                    ev.enabled = value;
                    this.dispatchEvent(ev);
                }
            });
        }
    }
    // ORTC defines the DTMF sender a bit different.
    // https://github.com/w3c/ortc/issues/714
    if (window.RTCRtpSender && !("dtmf" in window.RTCRtpSender.prototype)) Object.defineProperty(window.RTCRtpSender.prototype, "dtmf", {
        get () {
            if (this._dtmf === undefined) {
                if (this.track.kind === "audio") this._dtmf = new window.RTCDtmfSender(this);
                else if (this.track.kind === "video") this._dtmf = null;
            }
            return this._dtmf;
        }
    });
    // Edge currently only implements the RTCDtmfSender, not the
    // RTCDTMFSender alias. See http://draft.ortc.org/#rtcdtmfsender2*
    if (window.RTCDtmfSender && !window.RTCDTMFSender) window.RTCDTMFSender = window.RTCDtmfSender;
    const RTCPeerConnectionShim = (0, (/*@__PURE__*/$parcel$interopDefault($12pYe)))(window, browserDetails.version);
    window.RTCPeerConnection = function RTCPeerConnection(config) {
        if (config && config.iceServers) {
            config.iceServers = (0, $1qNPx.filterIceServers)(config.iceServers, browserDetails.version);
            $7zZv5.log("ICE servers after filtering:", config.iceServers);
        }
        return new RTCPeerConnectionShim(config);
    };
    window.RTCPeerConnection.prototype = RTCPeerConnectionShim.prototype;
}
function $a06d6cd16fdc81fa$export$72e310cc73676e34(window) {
    // ORTC has replaceTrack -- https://github.com/w3c/ortc/issues/614
    if (window.RTCRtpSender && !("replaceTrack" in window.RTCRtpSender.prototype)) window.RTCRtpSender.prototype.replaceTrack = window.RTCRtpSender.prototype.setTrack;
}

});
parcelRegister("1qNPx", function(module, exports) {

$parcel$export(module.exports, "filterIceServers", () => $10aedf6dbcf60d26$export$66148a33ab327e2);
/*
 *  Copyright (c) 2018 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
var $7zZv5 = parcelRequire("7zZv5");
"use strict";
function $10aedf6dbcf60d26$export$66148a33ab327e2(iceServers, edgeVersion) {
    let hasTurn = false;
    iceServers = JSON.parse(JSON.stringify(iceServers));
    return iceServers.filter((server)=>{
        if (server && (server.urls || server.url)) {
            let urls = server.urls || server.url;
            if (server.url && !server.urls) $7zZv5.deprecated("RTCIceServer.url", "RTCIceServer.urls");
            const isString = typeof urls === "string";
            if (isString) urls = [
                urls
            ];
            urls = urls.filter((url)=>{
                // filter STUN unconditionally.
                if (url.indexOf("stun:") === 0) return false;
                const validTurn = url.startsWith("turn") && !url.startsWith("turn:[") && url.includes("transport=udp");
                if (validTurn && !hasTurn) {
                    hasTurn = true;
                    return true;
                }
                return validTurn && !hasTurn;
            });
            delete server.url;
            server.urls = isString ? urls[0] : urls;
            return !!urls.length;
        }
    });
}

});

parcelRegister("12pYe", function(module, exports) {
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";

var $a3uXU = parcelRequire("a3uXU");
function $0c1a1f8c0fb8833d$var$fixStatsType(stat) {
    return ({
        inboundrtp: "inbound-rtp",
        outboundrtp: "outbound-rtp",
        candidatepair: "candidate-pair",
        localcandidate: "local-candidate",
        remotecandidate: "remote-candidate"
    })[stat.type] || stat.type;
}
function $0c1a1f8c0fb8833d$var$writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
    var sdp = $a3uXU.writeRtpDescription(transceiver.kind, caps);
    // Map ICE parameters (ufrag, pwd) to SDP.
    sdp += $a3uXU.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
    // Map DTLS parameters to SDP.
    sdp += $a3uXU.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === "offer" ? "actpass" : dtlsRole || "active");
    sdp += "a=mid:" + transceiver.mid + "\r\n";
    if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += "a=sendrecv\r\n";
    else if (transceiver.rtpSender) sdp += "a=sendonly\r\n";
    else if (transceiver.rtpReceiver) sdp += "a=recvonly\r\n";
    else sdp += "a=inactive\r\n";
    if (transceiver.rtpSender) {
        var trackId = transceiver.rtpSender._initialTrackId || transceiver.rtpSender.track.id;
        transceiver.rtpSender._initialTrackId = trackId;
        // spec.
        var msid = "msid:" + (stream ? stream.id : "-") + " " + trackId + "\r\n";
        sdp += "a=" + msid;
        // for Chrome. Legacy should no longer be required.
        sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " " + msid;
        // RTX
        if (transceiver.sendEncodingParameters[0].rtx) {
            sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " " + msid;
            sdp += "a=ssrc-group:FID " + transceiver.sendEncodingParameters[0].ssrc + " " + transceiver.sendEncodingParameters[0].rtx.ssrc + "\r\n";
        }
    }
    // FIXME: this should be written by writeRtpDescription.
    sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " cname:" + $a3uXU.localCName + "\r\n";
    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " cname:" + $a3uXU.localCName + "\r\n";
    return sdp;
}
// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
function $0c1a1f8c0fb8833d$var$filterIceServers(iceServers, edgeVersion) {
    var hasTurn = false;
    iceServers = JSON.parse(JSON.stringify(iceServers));
    return iceServers.filter(function(server) {
        if (server && (server.urls || server.url)) {
            var urls = server.urls || server.url;
            if (server.url && !server.urls) console.warn("RTCIceServer.url is deprecated! Use urls instead.");
            var isString = typeof urls === "string";
            if (isString) urls = [
                urls
            ];
            urls = urls.filter(function(url) {
                var validTurn = url.indexOf("turn:") === 0 && url.indexOf("transport=udp") !== -1 && url.indexOf("turn:[") === -1 && !hasTurn;
                if (validTurn) {
                    hasTurn = true;
                    return true;
                }
                return url.indexOf("stun:") === 0 && edgeVersion >= 14393 && url.indexOf("?transport=udp") === -1;
            });
            delete server.url;
            server.urls = isString ? urls[0] : urls;
            return !!urls.length;
        }
    });
}
// Determines the intersection of local and remote capabilities.
function $0c1a1f8c0fb8833d$var$getCommonCapabilities(localCapabilities, remoteCapabilities) {
    var commonCapabilities = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: []
    };
    var findCodecByPayloadType = function(pt, codecs) {
        pt = parseInt(pt, 10);
        for(var i = 0; i < codecs.length; i++){
            if (codecs[i].payloadType === pt || codecs[i].preferredPayloadType === pt) return codecs[i];
        }
    };
    var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
        var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
        var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
        return lCodec && rCodec && lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
    };
    localCapabilities.codecs.forEach(function(lCodec) {
        for(var i = 0; i < remoteCapabilities.codecs.length; i++){
            var rCodec = remoteCapabilities.codecs[i];
            if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() && lCodec.clockRate === rCodec.clockRate) {
                if (lCodec.name.toLowerCase() === "rtx" && lCodec.parameters && rCodec.parameters.apt) {
                    // for RTX we need to find the local rtx that has a apt
                    // which points to the same local codec as the remote one.
                    if (!rtxCapabilityMatches(lCodec, rCodec, localCapabilities.codecs, remoteCapabilities.codecs)) continue;
                }
                rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
                // number of channels is the highest common number of channels
                rCodec.numChannels = Math.min(lCodec.numChannels, rCodec.numChannels);
                // push rCodec so we reply with offerer payload type
                commonCapabilities.codecs.push(rCodec);
                // determine common feedback mechanisms
                rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
                    for(var j = 0; j < lCodec.rtcpFeedback.length; j++){
                        if (lCodec.rtcpFeedback[j].type === fb.type && lCodec.rtcpFeedback[j].parameter === fb.parameter) return true;
                    }
                    return false;
                });
                break;
            }
        }
    });
    localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
        for(var i = 0; i < remoteCapabilities.headerExtensions.length; i++){
            var rHeaderExtension = remoteCapabilities.headerExtensions[i];
            if (lHeaderExtension.uri === rHeaderExtension.uri) {
                commonCapabilities.headerExtensions.push(rHeaderExtension);
                break;
            }
        }
    });
    // FIXME: fecMechanisms
    return commonCapabilities;
}
// is action=setLocalDescription with type allowed in signalingState
function $0c1a1f8c0fb8833d$var$isActionAllowedInSignalingState(action, type, signalingState) {
    return ({
        offer: {
            setLocalDescription: [
                "stable",
                "have-local-offer"
            ],
            setRemoteDescription: [
                "stable",
                "have-remote-offer"
            ]
        },
        answer: {
            setLocalDescription: [
                "have-remote-offer",
                "have-local-pranswer"
            ],
            setRemoteDescription: [
                "have-local-offer",
                "have-remote-pranswer"
            ]
        }
    })[type][action].indexOf(signalingState) !== -1;
}
function $0c1a1f8c0fb8833d$var$maybeAddCandidate(iceTransport, candidate) {
    // Edge's internal representation adds some fields therefore
    // not all fieldѕ are taken into account.
    var alreadyAdded = iceTransport.getRemoteCandidates().find(function(remoteCandidate) {
        return candidate.foundation === remoteCandidate.foundation && candidate.ip === remoteCandidate.ip && candidate.port === remoteCandidate.port && candidate.priority === remoteCandidate.priority && candidate.protocol === remoteCandidate.protocol && candidate.type === remoteCandidate.type;
    });
    if (!alreadyAdded) iceTransport.addRemoteCandidate(candidate);
    return !alreadyAdded;
}
function $0c1a1f8c0fb8833d$var$makeError(name, description) {
    var e = new Error(description);
    e.name = name;
    // legacy error codes from https://heycam.github.io/webidl/#idl-DOMException-error-names
    e.code = ({
        NotSupportedError: 9,
        InvalidStateError: 11,
        InvalidAccessError: 15,
        TypeError: undefined,
        OperationError: undefined
    })[name];
    return e;
}
module.exports = function(window, edgeVersion) {
    // https://w3c.github.io/mediacapture-main/#mediastream
    // Helper function to add the track to the stream and
    // dispatch the event ourselves.
    function addTrackToStreamAndFireEvent(track, stream) {
        stream.addTrack(track);
        stream.dispatchEvent(new window.MediaStreamTrackEvent("addtrack", {
            track: track
        }));
    }
    function removeTrackFromStreamAndFireEvent(track, stream) {
        stream.removeTrack(track);
        stream.dispatchEvent(new window.MediaStreamTrackEvent("removetrack", {
            track: track
        }));
    }
    function fireAddTrack(pc, track, receiver, streams) {
        var trackEvent = new Event("track");
        trackEvent.track = track;
        trackEvent.receiver = receiver;
        trackEvent.transceiver = {
            receiver: receiver
        };
        trackEvent.streams = streams;
        window.setTimeout(function() {
            pc._dispatchEvent("track", trackEvent);
        });
    }
    var RTCPeerConnection = function(config) {
        var pc = this;
        var _eventTarget = document.createDocumentFragment();
        [
            "addEventListener",
            "removeEventListener",
            "dispatchEvent"
        ].forEach(function(method) {
            pc[method] = _eventTarget[method].bind(_eventTarget);
        });
        this.canTrickleIceCandidates = null;
        this.needNegotiation = false;
        this.localStreams = [];
        this.remoteStreams = [];
        this._localDescription = null;
        this._remoteDescription = null;
        this.signalingState = "stable";
        this.iceConnectionState = "new";
        this.connectionState = "new";
        this.iceGatheringState = "new";
        config = JSON.parse(JSON.stringify(config || {}));
        this.usingBundle = config.bundlePolicy === "max-bundle";
        if (config.rtcpMuxPolicy === "negotiate") throw $0c1a1f8c0fb8833d$var$makeError("NotSupportedError", "rtcpMuxPolicy 'negotiate' is not supported");
        else if (!config.rtcpMuxPolicy) config.rtcpMuxPolicy = "require";
        switch(config.iceTransportPolicy){
            case "all":
            case "relay":
                break;
            default:
                config.iceTransportPolicy = "all";
                break;
        }
        switch(config.bundlePolicy){
            case "balanced":
            case "max-compat":
            case "max-bundle":
                break;
            default:
                config.bundlePolicy = "balanced";
                break;
        }
        config.iceServers = $0c1a1f8c0fb8833d$var$filterIceServers(config.iceServers || [], edgeVersion);
        this._iceGatherers = [];
        if (config.iceCandidatePoolSize) for(var i = config.iceCandidatePoolSize; i > 0; i--)this._iceGatherers.push(new window.RTCIceGatherer({
            iceServers: config.iceServers,
            gatherPolicy: config.iceTransportPolicy
        }));
        else config.iceCandidatePoolSize = 0;
        this._config = config;
        // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
        // everything that is needed to describe a SDP m-line.
        this.transceivers = [];
        this._sdpSessionId = $a3uXU.generateSessionId();
        this._sdpSessionVersion = 0;
        this._dtlsRole = undefined; // role for a=setup to use in answers.
        this._isClosed = false;
    };
    Object.defineProperty(RTCPeerConnection.prototype, "localDescription", {
        configurable: true,
        get: function() {
            return this._localDescription;
        }
    });
    Object.defineProperty(RTCPeerConnection.prototype, "remoteDescription", {
        configurable: true,
        get: function() {
            return this._remoteDescription;
        }
    });
    // set up event handlers on prototype
    RTCPeerConnection.prototype.onicecandidate = null;
    RTCPeerConnection.prototype.onaddstream = null;
    RTCPeerConnection.prototype.ontrack = null;
    RTCPeerConnection.prototype.onremovestream = null;
    RTCPeerConnection.prototype.onsignalingstatechange = null;
    RTCPeerConnection.prototype.oniceconnectionstatechange = null;
    RTCPeerConnection.prototype.onconnectionstatechange = null;
    RTCPeerConnection.prototype.onicegatheringstatechange = null;
    RTCPeerConnection.prototype.onnegotiationneeded = null;
    RTCPeerConnection.prototype.ondatachannel = null;
    RTCPeerConnection.prototype._dispatchEvent = function(name, event) {
        if (this._isClosed) return;
        this.dispatchEvent(event);
        if (typeof this["on" + name] === "function") this["on" + name](event);
    };
    RTCPeerConnection.prototype._emitGatheringStateChange = function() {
        var event = new Event("icegatheringstatechange");
        this._dispatchEvent("icegatheringstatechange", event);
    };
    RTCPeerConnection.prototype.getConfiguration = function() {
        return this._config;
    };
    RTCPeerConnection.prototype.getLocalStreams = function() {
        return this.localStreams;
    };
    RTCPeerConnection.prototype.getRemoteStreams = function() {
        return this.remoteStreams;
    };
    // internal helper to create a transceiver object.
    // (which is not yet the same as the WebRTC 1.0 transceiver)
    RTCPeerConnection.prototype._createTransceiver = function(kind, doNotAdd) {
        var hasBundleTransport = this.transceivers.length > 0;
        var transceiver = {
            track: null,
            iceGatherer: null,
            iceTransport: null,
            dtlsTransport: null,
            localCapabilities: null,
            remoteCapabilities: null,
            rtpSender: null,
            rtpReceiver: null,
            kind: kind,
            mid: null,
            sendEncodingParameters: null,
            recvEncodingParameters: null,
            stream: null,
            associatedRemoteMediaStreams: [],
            wantReceive: true
        };
        if (this.usingBundle && hasBundleTransport) {
            transceiver.iceTransport = this.transceivers[0].iceTransport;
            transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
        } else {
            var transports = this._createIceAndDtlsTransports();
            transceiver.iceTransport = transports.iceTransport;
            transceiver.dtlsTransport = transports.dtlsTransport;
        }
        if (!doNotAdd) this.transceivers.push(transceiver);
        return transceiver;
    };
    RTCPeerConnection.prototype.addTrack = function(track, stream) {
        if (this._isClosed) throw $0c1a1f8c0fb8833d$var$makeError("InvalidStateError", "Attempted to call addTrack on a closed peerconnection.");
        var alreadyExists = this.transceivers.find(function(s) {
            return s.track === track;
        });
        if (alreadyExists) throw $0c1a1f8c0fb8833d$var$makeError("InvalidAccessError", "Track already exists.");
        var transceiver;
        for(var i = 0; i < this.transceivers.length; i++)if (!this.transceivers[i].track && this.transceivers[i].kind === track.kind) transceiver = this.transceivers[i];
        if (!transceiver) transceiver = this._createTransceiver(track.kind);
        this._maybeFireNegotiationNeeded();
        if (this.localStreams.indexOf(stream) === -1) this.localStreams.push(stream);
        transceiver.track = track;
        transceiver.stream = stream;
        transceiver.rtpSender = new window.RTCRtpSender(track, transceiver.dtlsTransport);
        return transceiver.rtpSender;
    };
    RTCPeerConnection.prototype.addStream = function(stream) {
        var pc = this;
        if (edgeVersion >= 15025) stream.getTracks().forEach(function(track) {
            pc.addTrack(track, stream);
        });
        else {
            // Clone is necessary for local demos mostly, attaching directly
            // to two different senders does not work (build 10547).
            // Fixed in 15025 (or earlier)
            var clonedStream = stream.clone();
            stream.getTracks().forEach(function(track, idx) {
                var clonedTrack = clonedStream.getTracks()[idx];
                track.addEventListener("enabled", function(event) {
                    clonedTrack.enabled = event.enabled;
                });
            });
            clonedStream.getTracks().forEach(function(track) {
                pc.addTrack(track, clonedStream);
            });
        }
    };
    RTCPeerConnection.prototype.removeTrack = function(sender) {
        if (this._isClosed) throw $0c1a1f8c0fb8833d$var$makeError("InvalidStateError", "Attempted to call removeTrack on a closed peerconnection.");
        if (!(sender instanceof window.RTCRtpSender)) throw new TypeError("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.");
        var transceiver = this.transceivers.find(function(t) {
            return t.rtpSender === sender;
        });
        if (!transceiver) throw $0c1a1f8c0fb8833d$var$makeError("InvalidAccessError", "Sender was not created by this connection.");
        var stream = transceiver.stream;
        transceiver.rtpSender.stop();
        transceiver.rtpSender = null;
        transceiver.track = null;
        transceiver.stream = null;
        // remove the stream from the set of local streams
        var localStreams = this.transceivers.map(function(t) {
            return t.stream;
        });
        if (localStreams.indexOf(stream) === -1 && this.localStreams.indexOf(stream) > -1) this.localStreams.splice(this.localStreams.indexOf(stream), 1);
        this._maybeFireNegotiationNeeded();
    };
    RTCPeerConnection.prototype.removeStream = function(stream) {
        var pc = this;
        stream.getTracks().forEach(function(track) {
            var sender = pc.getSenders().find(function(s) {
                return s.track === track;
            });
            if (sender) pc.removeTrack(sender);
        });
    };
    RTCPeerConnection.prototype.getSenders = function() {
        return this.transceivers.filter(function(transceiver) {
            return !!transceiver.rtpSender;
        }).map(function(transceiver) {
            return transceiver.rtpSender;
        });
    };
    RTCPeerConnection.prototype.getReceivers = function() {
        return this.transceivers.filter(function(transceiver) {
            return !!transceiver.rtpReceiver;
        }).map(function(transceiver) {
            return transceiver.rtpReceiver;
        });
    };
    RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex, usingBundle) {
        var pc = this;
        if (usingBundle && sdpMLineIndex > 0) return this.transceivers[0].iceGatherer;
        else if (this._iceGatherers.length) return this._iceGatherers.shift();
        var iceGatherer = new window.RTCIceGatherer({
            iceServers: this._config.iceServers,
            gatherPolicy: this._config.iceTransportPolicy
        });
        Object.defineProperty(iceGatherer, "state", {
            value: "new",
            writable: true
        });
        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];
        this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
            var end = !event.candidate || Object.keys(event.candidate).length === 0;
            // polyfill since RTCIceGatherer.state is not implemented in
            // Edge 10547 yet.
            iceGatherer.state = end ? "completed" : "gathering";
            if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
        };
        iceGatherer.addEventListener("localcandidate", this.transceivers[sdpMLineIndex].bufferCandidates);
        return iceGatherer;
    };
    // start gathering from an RTCIceGatherer.
    RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
        var pc = this;
        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
        if (iceGatherer.onlocalcandidate) return;
        var bufferedCandidateEvents = this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
        this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
        iceGatherer.removeEventListener("localcandidate", this.transceivers[sdpMLineIndex].bufferCandidates);
        iceGatherer.onlocalcandidate = function(evt) {
            if (pc.usingBundle && sdpMLineIndex > 0) // if we know that we use bundle we can drop candidates with
            // ѕdpMLineIndex > 0. If we don't do this then our state gets
            // confused since we dispose the extra ice gatherer.
            return;
            var event = new Event("icecandidate");
            event.candidate = {
                sdpMid: mid,
                sdpMLineIndex: sdpMLineIndex
            };
            var cand = evt.candidate;
            // Edge emits an empty object for RTCIceCandidateComplete‥
            var end = !cand || Object.keys(cand).length === 0;
            if (end) // polyfill since RTCIceGatherer.state is not implemented in
            // Edge 10547 yet.
            {
                if (iceGatherer.state === "new" || iceGatherer.state === "gathering") iceGatherer.state = "completed";
            } else {
                if (iceGatherer.state === "new") iceGatherer.state = "gathering";
                // RTCIceCandidate doesn't have a component, needs to be added
                cand.component = 1;
                // also the usernameFragment. TODO: update SDP to take both variants.
                cand.ufrag = iceGatherer.getLocalParameters().usernameFragment;
                var serializedCandidate = $a3uXU.writeCandidate(cand);
                event.candidate = Object.assign(event.candidate, $a3uXU.parseCandidate(serializedCandidate));
                event.candidate.candidate = serializedCandidate;
                event.candidate.toJSON = function() {
                    return {
                        candidate: event.candidate.candidate,
                        sdpMid: event.candidate.sdpMid,
                        sdpMLineIndex: event.candidate.sdpMLineIndex,
                        usernameFragment: event.candidate.usernameFragment
                    };
                };
            }
            // update local description.
            var sections = $a3uXU.getMediaSections(pc._localDescription.sdp);
            if (!end) sections[event.candidate.sdpMLineIndex] += "a=" + event.candidate.candidate + "\r\n";
            else sections[event.candidate.sdpMLineIndex] += "a=end-of-candidates\r\n";
            pc._localDescription.sdp = $a3uXU.getDescription(pc._localDescription.sdp) + sections.join("");
            var complete = pc.transceivers.every(function(transceiver) {
                return transceiver.iceGatherer && transceiver.iceGatherer.state === "completed";
            });
            if (pc.iceGatheringState !== "gathering") {
                pc.iceGatheringState = "gathering";
                pc._emitGatheringStateChange();
            }
            // Emit candidate. Also emit null candidate when all gatherers are
            // complete.
            if (!end) pc._dispatchEvent("icecandidate", event);
            if (complete) {
                pc._dispatchEvent("icecandidate", new Event("icecandidate"));
                pc.iceGatheringState = "complete";
                pc._emitGatheringStateChange();
            }
        };
        // emit already gathered candidates.
        window.setTimeout(function() {
            bufferedCandidateEvents.forEach(function(e) {
                iceGatherer.onlocalcandidate(e);
            });
        }, 0);
    };
    // Create ICE transport and DTLS transport.
    RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
        var pc = this;
        var iceTransport = new window.RTCIceTransport(null);
        iceTransport.onicestatechange = function() {
            pc._updateIceConnectionState();
            pc._updateConnectionState();
        };
        var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
        dtlsTransport.ondtlsstatechange = function() {
            pc._updateConnectionState();
        };
        dtlsTransport.onerror = function() {
            // onerror does not set state to failed by itself.
            Object.defineProperty(dtlsTransport, "state", {
                value: "failed",
                writable: true
            });
            pc._updateConnectionState();
        };
        return {
            iceTransport: iceTransport,
            dtlsTransport: dtlsTransport
        };
    };
    // Destroy ICE gatherer, ICE transport and DTLS transport.
    // Without triggering the callbacks.
    RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(sdpMLineIndex) {
        var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
        if (iceGatherer) {
            delete iceGatherer.onlocalcandidate;
            delete this.transceivers[sdpMLineIndex].iceGatherer;
        }
        var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
        if (iceTransport) {
            delete iceTransport.onicestatechange;
            delete this.transceivers[sdpMLineIndex].iceTransport;
        }
        var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
        if (dtlsTransport) {
            delete dtlsTransport.ondtlsstatechange;
            delete dtlsTransport.onerror;
            delete this.transceivers[sdpMLineIndex].dtlsTransport;
        }
    };
    // Start the RTP Sender and Receiver for a transceiver.
    RTCPeerConnection.prototype._transceive = function(transceiver, send, recv) {
        var params = $0c1a1f8c0fb8833d$var$getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
        if (send && transceiver.rtpSender) {
            params.encodings = transceiver.sendEncodingParameters;
            params.rtcp = {
                cname: $a3uXU.localCName,
                compound: transceiver.rtcpParameters.compound
            };
            if (transceiver.recvEncodingParameters.length) params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
            transceiver.rtpSender.send(params);
        }
        if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
            // remove RTX field in Edge 14942
            if (transceiver.kind === "video" && transceiver.recvEncodingParameters && edgeVersion < 15019) transceiver.recvEncodingParameters.forEach(function(p) {
                delete p.rtx;
            });
            if (transceiver.recvEncodingParameters.length) params.encodings = transceiver.recvEncodingParameters;
            else params.encodings = [
                {}
            ];
            params.rtcp = {
                compound: transceiver.rtcpParameters.compound
            };
            if (transceiver.rtcpParameters.cname) params.rtcp.cname = transceiver.rtcpParameters.cname;
            if (transceiver.sendEncodingParameters.length) params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
            transceiver.rtpReceiver.receive(params);
        }
    };
    RTCPeerConnection.prototype.setLocalDescription = function(description) {
        var pc = this;
        // Note: pranswer is not supported.
        if ([
            "offer",
            "answer"
        ].indexOf(description.type) === -1) return Promise.reject($0c1a1f8c0fb8833d$var$makeError("TypeError", 'Unsupported type "' + description.type + '"'));
        if (!$0c1a1f8c0fb8833d$var$isActionAllowedInSignalingState("setLocalDescription", description.type, pc.signalingState) || pc._isClosed) return Promise.reject($0c1a1f8c0fb8833d$var$makeError("InvalidStateError", "Can not set local " + description.type + " in state " + pc.signalingState));
        var sections;
        var sessionpart;
        if (description.type === "offer") {
            // VERY limited support for SDP munging. Limited to:
            // * changing the order of codecs
            sections = $a3uXU.splitSections(description.sdp);
            sessionpart = sections.shift();
            sections.forEach(function(mediaSection, sdpMLineIndex) {
                var caps = $a3uXU.parseRtpParameters(mediaSection);
                pc.transceivers[sdpMLineIndex].localCapabilities = caps;
            });
            pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
                pc._gather(transceiver.mid, sdpMLineIndex);
            });
        } else if (description.type === "answer") {
            sections = $a3uXU.splitSections(pc._remoteDescription.sdp);
            sessionpart = sections.shift();
            var isIceLite = $a3uXU.matchPrefix(sessionpart, "a=ice-lite").length > 0;
            sections.forEach(function(mediaSection, sdpMLineIndex) {
                var transceiver = pc.transceivers[sdpMLineIndex];
                var iceGatherer = transceiver.iceGatherer;
                var iceTransport = transceiver.iceTransport;
                var dtlsTransport = transceiver.dtlsTransport;
                var localCapabilities = transceiver.localCapabilities;
                var remoteCapabilities = transceiver.remoteCapabilities;
                // treat bundle-only as not-rejected.
                var rejected = $a3uXU.isRejected(mediaSection) && $a3uXU.matchPrefix(mediaSection, "a=bundle-only").length === 0;
                if (!rejected && !transceiver.rejected) {
                    var remoteIceParameters = $a3uXU.getIceParameters(mediaSection, sessionpart);
                    var remoteDtlsParameters = $a3uXU.getDtlsParameters(mediaSection, sessionpart);
                    if (isIceLite) remoteDtlsParameters.role = "server";
                    if (!pc.usingBundle || sdpMLineIndex === 0) {
                        pc._gather(transceiver.mid, sdpMLineIndex);
                        if (iceTransport.state === "new") iceTransport.start(iceGatherer, remoteIceParameters, isIceLite ? "controlling" : "controlled");
                        if (dtlsTransport.state === "new") dtlsTransport.start(remoteDtlsParameters);
                    }
                    // Calculate intersection of capabilities.
                    var params = $0c1a1f8c0fb8833d$var$getCommonCapabilities(localCapabilities, remoteCapabilities);
                    // Start the RTCRtpSender. The RTCRtpReceiver for this
                    // transceiver has already been started in setRemoteDescription.
                    pc._transceive(transceiver, params.codecs.length > 0, false);
                }
            });
        }
        pc._localDescription = {
            type: description.type,
            sdp: description.sdp
        };
        if (description.type === "offer") pc._updateSignalingState("have-local-offer");
        else pc._updateSignalingState("stable");
        return Promise.resolve();
    };
    RTCPeerConnection.prototype.setRemoteDescription = function(description) {
        var pc = this;
        // Note: pranswer is not supported.
        if ([
            "offer",
            "answer"
        ].indexOf(description.type) === -1) return Promise.reject($0c1a1f8c0fb8833d$var$makeError("TypeError", 'Unsupported type "' + description.type + '"'));
        if (!$0c1a1f8c0fb8833d$var$isActionAllowedInSignalingState("setRemoteDescription", description.type, pc.signalingState) || pc._isClosed) return Promise.reject($0c1a1f8c0fb8833d$var$makeError("InvalidStateError", "Can not set remote " + description.type + " in state " + pc.signalingState));
        var streams = {};
        pc.remoteStreams.forEach(function(stream) {
            streams[stream.id] = stream;
        });
        var receiverList = [];
        var sections = $a3uXU.splitSections(description.sdp);
        var sessionpart = sections.shift();
        var isIceLite = $a3uXU.matchPrefix(sessionpart, "a=ice-lite").length > 0;
        var usingBundle = $a3uXU.matchPrefix(sessionpart, "a=group:BUNDLE ").length > 0;
        pc.usingBundle = usingBundle;
        var iceOptions = $a3uXU.matchPrefix(sessionpart, "a=ice-options:")[0];
        if (iceOptions) pc.canTrickleIceCandidates = iceOptions.substr(14).split(" ").indexOf("trickle") >= 0;
        else pc.canTrickleIceCandidates = false;
        sections.forEach(function(mediaSection, sdpMLineIndex) {
            var lines = $a3uXU.splitLines(mediaSection);
            var kind = $a3uXU.getKind(mediaSection);
            // treat bundle-only as not-rejected.
            var rejected = $a3uXU.isRejected(mediaSection) && $a3uXU.matchPrefix(mediaSection, "a=bundle-only").length === 0;
            var protocol = lines[0].substr(2).split(" ")[2];
            var direction = $a3uXU.getDirection(mediaSection, sessionpart);
            var remoteMsid = $a3uXU.parseMsid(mediaSection);
            var mid = $a3uXU.getMid(mediaSection) || $a3uXU.generateIdentifier();
            // Reject datachannels which are not implemented yet.
            if (rejected || kind === "application" && (protocol === "DTLS/SCTP" || protocol === "UDP/DTLS/SCTP")) {
                // TODO: this is dangerous in the case where a non-rejected m-line
                //     becomes rejected.
                pc.transceivers[sdpMLineIndex] = {
                    mid: mid,
                    kind: kind,
                    protocol: protocol,
                    rejected: true
                };
                return;
            }
            if (!rejected && pc.transceivers[sdpMLineIndex] && pc.transceivers[sdpMLineIndex].rejected) // recycle a rejected transceiver.
            pc.transceivers[sdpMLineIndex] = pc._createTransceiver(kind, true);
            var transceiver;
            var iceGatherer;
            var iceTransport;
            var dtlsTransport;
            var rtpReceiver;
            var sendEncodingParameters;
            var recvEncodingParameters;
            var localCapabilities;
            var track;
            // FIXME: ensure the mediaSection has rtcp-mux set.
            var remoteCapabilities = $a3uXU.parseRtpParameters(mediaSection);
            var remoteIceParameters;
            var remoteDtlsParameters;
            if (!rejected) {
                remoteIceParameters = $a3uXU.getIceParameters(mediaSection, sessionpart);
                remoteDtlsParameters = $a3uXU.getDtlsParameters(mediaSection, sessionpart);
                remoteDtlsParameters.role = "client";
            }
            recvEncodingParameters = $a3uXU.parseRtpEncodingParameters(mediaSection);
            var rtcpParameters = $a3uXU.parseRtcpParameters(mediaSection);
            var isComplete = $a3uXU.matchPrefix(mediaSection, "a=end-of-candidates", sessionpart).length > 0;
            var cands = $a3uXU.matchPrefix(mediaSection, "a=candidate:").map(function(cand) {
                return $a3uXU.parseCandidate(cand);
            }).filter(function(cand) {
                return cand.component === 1;
            });
            // Check if we can use BUNDLE and dispose transports.
            if ((description.type === "offer" || description.type === "answer") && !rejected && usingBundle && sdpMLineIndex > 0 && pc.transceivers[sdpMLineIndex]) {
                pc._disposeIceAndDtlsTransports(sdpMLineIndex);
                pc.transceivers[sdpMLineIndex].iceGatherer = pc.transceivers[0].iceGatherer;
                pc.transceivers[sdpMLineIndex].iceTransport = pc.transceivers[0].iceTransport;
                pc.transceivers[sdpMLineIndex].dtlsTransport = pc.transceivers[0].dtlsTransport;
                if (pc.transceivers[sdpMLineIndex].rtpSender) pc.transceivers[sdpMLineIndex].rtpSender.setTransport(pc.transceivers[0].dtlsTransport);
                if (pc.transceivers[sdpMLineIndex].rtpReceiver) pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(pc.transceivers[0].dtlsTransport);
            }
            if (description.type === "offer" && !rejected) {
                transceiver = pc.transceivers[sdpMLineIndex] || pc._createTransceiver(kind);
                transceiver.mid = mid;
                if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, usingBundle);
                if (cands.length && transceiver.iceTransport.state === "new") {
                    if (isComplete && (!usingBundle || sdpMLineIndex === 0)) transceiver.iceTransport.setRemoteCandidates(cands);
                    else cands.forEach(function(candidate) {
                        $0c1a1f8c0fb8833d$var$maybeAddCandidate(transceiver.iceTransport, candidate);
                    });
                }
                localCapabilities = window.RTCRtpReceiver.getCapabilities(kind);
                // filter RTX until additional stuff needed for RTX is implemented
                // in adapter.js
                if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                    return codec.name !== "rtx";
                });
                sendEncodingParameters = transceiver.sendEncodingParameters || [
                    {
                        ssrc: (2 * sdpMLineIndex + 2) * 1001
                    }
                ];
                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                var isNewTrack = false;
                if (direction === "sendrecv" || direction === "sendonly") {
                    isNewTrack = !transceiver.rtpReceiver;
                    rtpReceiver = transceiver.rtpReceiver || new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
                    if (isNewTrack) {
                        var stream;
                        track = rtpReceiver.track;
                        // FIXME: does not work with Plan B.
                        if (remoteMsid && remoteMsid.stream === "-") ;
                        else if (remoteMsid) {
                            if (!streams[remoteMsid.stream]) {
                                streams[remoteMsid.stream] = new window.MediaStream();
                                Object.defineProperty(streams[remoteMsid.stream], "id", {
                                    get: function() {
                                        return remoteMsid.stream;
                                    }
                                });
                            }
                            Object.defineProperty(track, "id", {
                                get: function() {
                                    return remoteMsid.track;
                                }
                            });
                            stream = streams[remoteMsid.stream];
                        } else {
                            if (!streams.default) streams.default = new window.MediaStream();
                            stream = streams.default;
                        }
                        if (stream) {
                            addTrackToStreamAndFireEvent(track, stream);
                            transceiver.associatedRemoteMediaStreams.push(stream);
                        }
                        receiverList.push([
                            track,
                            rtpReceiver,
                            stream
                        ]);
                    }
                } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
                    transceiver.associatedRemoteMediaStreams.forEach(function(s) {
                        var nativeTrack = s.getTracks().find(function(t) {
                            return t.id === transceiver.rtpReceiver.track.id;
                        });
                        if (nativeTrack) removeTrackFromStreamAndFireEvent(nativeTrack, s);
                    });
                    transceiver.associatedRemoteMediaStreams = [];
                }
                transceiver.localCapabilities = localCapabilities;
                transceiver.remoteCapabilities = remoteCapabilities;
                transceiver.rtpReceiver = rtpReceiver;
                transceiver.rtcpParameters = rtcpParameters;
                transceiver.sendEncodingParameters = sendEncodingParameters;
                transceiver.recvEncodingParameters = recvEncodingParameters;
                // Start the RTCRtpReceiver now. The RTPSender is started in
                // setLocalDescription.
                pc._transceive(pc.transceivers[sdpMLineIndex], false, isNewTrack);
            } else if (description.type === "answer" && !rejected) {
                transceiver = pc.transceivers[sdpMLineIndex];
                iceGatherer = transceiver.iceGatherer;
                iceTransport = transceiver.iceTransport;
                dtlsTransport = transceiver.dtlsTransport;
                rtpReceiver = transceiver.rtpReceiver;
                sendEncodingParameters = transceiver.sendEncodingParameters;
                localCapabilities = transceiver.localCapabilities;
                pc.transceivers[sdpMLineIndex].recvEncodingParameters = recvEncodingParameters;
                pc.transceivers[sdpMLineIndex].remoteCapabilities = remoteCapabilities;
                pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;
                if (cands.length && iceTransport.state === "new") {
                    if ((isIceLite || isComplete) && (!usingBundle || sdpMLineIndex === 0)) iceTransport.setRemoteCandidates(cands);
                    else cands.forEach(function(candidate) {
                        $0c1a1f8c0fb8833d$var$maybeAddCandidate(transceiver.iceTransport, candidate);
                    });
                }
                if (!usingBundle || sdpMLineIndex === 0) {
                    if (iceTransport.state === "new") iceTransport.start(iceGatherer, remoteIceParameters, "controlling");
                    if (dtlsTransport.state === "new") dtlsTransport.start(remoteDtlsParameters);
                }
                // If the offer contained RTX but the answer did not,
                // remove RTX from sendEncodingParameters.
                var commonCapabilities = $0c1a1f8c0fb8833d$var$getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
                var hasRtx = commonCapabilities.codecs.filter(function(c) {
                    return c.name.toLowerCase() === "rtx";
                }).length;
                if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) delete transceiver.sendEncodingParameters[0].rtx;
                pc._transceive(transceiver, direction === "sendrecv" || direction === "recvonly", direction === "sendrecv" || direction === "sendonly");
                // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
                if (rtpReceiver && (direction === "sendrecv" || direction === "sendonly")) {
                    track = rtpReceiver.track;
                    if (remoteMsid) {
                        if (!streams[remoteMsid.stream]) streams[remoteMsid.stream] = new window.MediaStream();
                        addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
                        receiverList.push([
                            track,
                            rtpReceiver,
                            streams[remoteMsid.stream]
                        ]);
                    } else {
                        if (!streams.default) streams.default = new window.MediaStream();
                        addTrackToStreamAndFireEvent(track, streams.default);
                        receiverList.push([
                            track,
                            rtpReceiver,
                            streams.default
                        ]);
                    }
                } else // FIXME: actually the receiver should be created later.
                delete transceiver.rtpReceiver;
            }
        });
        if (pc._dtlsRole === undefined) pc._dtlsRole = description.type === "offer" ? "active" : "passive";
        pc._remoteDescription = {
            type: description.type,
            sdp: description.sdp
        };
        if (description.type === "offer") pc._updateSignalingState("have-remote-offer");
        else pc._updateSignalingState("stable");
        Object.keys(streams).forEach(function(sid) {
            var stream = streams[sid];
            if (stream.getTracks().length) {
                if (pc.remoteStreams.indexOf(stream) === -1) {
                    pc.remoteStreams.push(stream);
                    var event = new Event("addstream");
                    event.stream = stream;
                    window.setTimeout(function() {
                        pc._dispatchEvent("addstream", event);
                    });
                }
                receiverList.forEach(function(item) {
                    var track = item[0];
                    var receiver = item[1];
                    if (stream.id !== item[2].id) return;
                    fireAddTrack(pc, track, receiver, [
                        stream
                    ]);
                });
            }
        });
        receiverList.forEach(function(item) {
            if (item[2]) return;
            fireAddTrack(pc, item[0], item[1], []);
        });
        // check whether addIceCandidate({}) was called within four seconds after
        // setRemoteDescription.
        window.setTimeout(function() {
            if (!(pc && pc.transceivers)) return;
            pc.transceivers.forEach(function(transceiver) {
                if (transceiver.iceTransport && transceiver.iceTransport.state === "new" && transceiver.iceTransport.getRemoteCandidates().length > 0) {
                    console.warn("Timeout for addRemoteCandidate. Consider sending an end-of-candidates notification");
                    transceiver.iceTransport.addRemoteCandidate({});
                }
            });
        }, 4000);
        return Promise.resolve();
    };
    RTCPeerConnection.prototype.close = function() {
        this.transceivers.forEach(function(transceiver) {
            /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */ if (transceiver.iceTransport) transceiver.iceTransport.stop();
            if (transceiver.dtlsTransport) transceiver.dtlsTransport.stop();
            if (transceiver.rtpSender) transceiver.rtpSender.stop();
            if (transceiver.rtpReceiver) transceiver.rtpReceiver.stop();
        });
        // FIXME: clean up tracks, local streams, remote streams, etc
        this._isClosed = true;
        this._updateSignalingState("closed");
    };
    // Update the signaling state.
    RTCPeerConnection.prototype._updateSignalingState = function(newState) {
        this.signalingState = newState;
        var event = new Event("signalingstatechange");
        this._dispatchEvent("signalingstatechange", event);
    };
    // Determine whether to fire the negotiationneeded event.
    RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
        var pc = this;
        if (this.signalingState !== "stable" || this.needNegotiation === true) return;
        this.needNegotiation = true;
        window.setTimeout(function() {
            if (pc.needNegotiation) {
                pc.needNegotiation = false;
                var event = new Event("negotiationneeded");
                pc._dispatchEvent("negotiationneeded", event);
            }
        }, 0);
    };
    // Update the ice connection state.
    RTCPeerConnection.prototype._updateIceConnectionState = function() {
        var newState;
        var states = {
            "new": 0,
            closed: 0,
            checking: 0,
            connected: 0,
            completed: 0,
            disconnected: 0,
            failed: 0
        };
        this.transceivers.forEach(function(transceiver) {
            if (transceiver.iceTransport && !transceiver.rejected) states[transceiver.iceTransport.state]++;
        });
        newState = "new";
        if (states.failed > 0) newState = "failed";
        else if (states.checking > 0) newState = "checking";
        else if (states.disconnected > 0) newState = "disconnected";
        else if (states.new > 0) newState = "new";
        else if (states.connected > 0) newState = "connected";
        else if (states.completed > 0) newState = "completed";
        if (newState !== this.iceConnectionState) {
            this.iceConnectionState = newState;
            var event = new Event("iceconnectionstatechange");
            this._dispatchEvent("iceconnectionstatechange", event);
        }
    };
    // Update the connection state.
    RTCPeerConnection.prototype._updateConnectionState = function() {
        var newState;
        var states = {
            "new": 0,
            closed: 0,
            connecting: 0,
            connected: 0,
            completed: 0,
            disconnected: 0,
            failed: 0
        };
        this.transceivers.forEach(function(transceiver) {
            if (transceiver.iceTransport && transceiver.dtlsTransport && !transceiver.rejected) {
                states[transceiver.iceTransport.state]++;
                states[transceiver.dtlsTransport.state]++;
            }
        });
        // ICETransport.completed and connected are the same for this purpose.
        states.connected += states.completed;
        newState = "new";
        if (states.failed > 0) newState = "failed";
        else if (states.connecting > 0) newState = "connecting";
        else if (states.disconnected > 0) newState = "disconnected";
        else if (states.new > 0) newState = "new";
        else if (states.connected > 0) newState = "connected";
        if (newState !== this.connectionState) {
            this.connectionState = newState;
            var event = new Event("connectionstatechange");
            this._dispatchEvent("connectionstatechange", event);
        }
    };
    RTCPeerConnection.prototype.createOffer = function() {
        var pc = this;
        if (pc._isClosed) return Promise.reject($0c1a1f8c0fb8833d$var$makeError("InvalidStateError", "Can not call createOffer after close"));
        var numAudioTracks = pc.transceivers.filter(function(t) {
            return t.kind === "audio";
        }).length;
        var numVideoTracks = pc.transceivers.filter(function(t) {
            return t.kind === "video";
        }).length;
        // Determine number of audio and video tracks we need to send/recv.
        var offerOptions = arguments[0];
        if (offerOptions) {
            // Reject Chrome legacy constraints.
            if (offerOptions.mandatory || offerOptions.optional) throw new TypeError("Legacy mandatory/optional constraints not supported.");
            if (offerOptions.offerToReceiveAudio !== undefined) {
                if (offerOptions.offerToReceiveAudio === true) numAudioTracks = 1;
                else if (offerOptions.offerToReceiveAudio === false) numAudioTracks = 0;
                else numAudioTracks = offerOptions.offerToReceiveAudio;
            }
            if (offerOptions.offerToReceiveVideo !== undefined) {
                if (offerOptions.offerToReceiveVideo === true) numVideoTracks = 1;
                else if (offerOptions.offerToReceiveVideo === false) numVideoTracks = 0;
                else numVideoTracks = offerOptions.offerToReceiveVideo;
            }
        }
        pc.transceivers.forEach(function(transceiver) {
            if (transceiver.kind === "audio") {
                numAudioTracks--;
                if (numAudioTracks < 0) transceiver.wantReceive = false;
            } else if (transceiver.kind === "video") {
                numVideoTracks--;
                if (numVideoTracks < 0) transceiver.wantReceive = false;
            }
        });
        // Create M-lines for recvonly streams.
        while(numAudioTracks > 0 || numVideoTracks > 0){
            if (numAudioTracks > 0) {
                pc._createTransceiver("audio");
                numAudioTracks--;
            }
            if (numVideoTracks > 0) {
                pc._createTransceiver("video");
                numVideoTracks--;
            }
        }
        var sdp = $a3uXU.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            // For each track, create an ice gatherer, ice transport,
            // dtls transport, potentially rtpsender and rtpreceiver.
            var track = transceiver.track;
            var kind = transceiver.kind;
            var mid = transceiver.mid || $a3uXU.generateIdentifier();
            transceiver.mid = mid;
            if (!transceiver.iceGatherer) transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex, pc.usingBundle);
            var localCapabilities = window.RTCRtpSender.getCapabilities(kind);
            // filter RTX until additional stuff needed for RTX is implemented
            // in adapter.js
            if (edgeVersion < 15019) localCapabilities.codecs = localCapabilities.codecs.filter(function(codec) {
                return codec.name !== "rtx";
            });
            localCapabilities.codecs.forEach(function(codec) {
                // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
                // by adding level-asymmetry-allowed=1
                if (codec.name === "H264" && codec.parameters["level-asymmetry-allowed"] === undefined) codec.parameters["level-asymmetry-allowed"] = "1";
                // for subsequent offers, we might have to re-use the payload
                // type of the last offer.
                if (transceiver.remoteCapabilities && transceiver.remoteCapabilities.codecs) transceiver.remoteCapabilities.codecs.forEach(function(remoteCodec) {
                    if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() && codec.clockRate === remoteCodec.clockRate) codec.preferredPayloadType = remoteCodec.payloadType;
                });
            });
            localCapabilities.headerExtensions.forEach(function(hdrExt) {
                var remoteExtensions = transceiver.remoteCapabilities && transceiver.remoteCapabilities.headerExtensions || [];
                remoteExtensions.forEach(function(rHdrExt) {
                    if (hdrExt.uri === rHdrExt.uri) hdrExt.id = rHdrExt.id;
                });
            });
            // generate an ssrc now, to be used later in rtpSender.send
            var sendEncodingParameters = transceiver.sendEncodingParameters || [
                {
                    ssrc: (2 * sdpMLineIndex + 1) * 1001
                }
            ];
            if (track) // add RTX
            {
                if (edgeVersion >= 15019 && kind === "video" && !sendEncodingParameters[0].rtx) sendEncodingParameters[0].rtx = {
                    ssrc: sendEncodingParameters[0].ssrc + 1
                };
            }
            if (transceiver.wantReceive) transceiver.rtpReceiver = new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);
            transceiver.localCapabilities = localCapabilities;
            transceiver.sendEncodingParameters = sendEncodingParameters;
        });
        // always offer BUNDLE and dispose on return if not supported.
        if (pc._config.bundlePolicy !== "max-compat") sdp += "a=group:BUNDLE " + pc.transceivers.map(function(t) {
            return t.mid;
        }).join(" ") + "\r\n";
        sdp += "a=ice-options:trickle\r\n";
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            sdp += $0c1a1f8c0fb8833d$var$writeMediaSection(transceiver, transceiver.localCapabilities, "offer", transceiver.stream, pc._dtlsRole);
            sdp += "a=rtcp-rsize\r\n";
            if (transceiver.iceGatherer && pc.iceGatheringState !== "new" && (sdpMLineIndex === 0 || !pc.usingBundle)) {
                transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
                    cand.component = 1;
                    sdp += "a=" + $a3uXU.writeCandidate(cand) + "\r\n";
                });
                if (transceiver.iceGatherer.state === "completed") sdp += "a=end-of-candidates\r\n";
            }
        });
        var desc = new window.RTCSessionDescription({
            type: "offer",
            sdp: sdp
        });
        return Promise.resolve(desc);
    };
    RTCPeerConnection.prototype.createAnswer = function() {
        var pc = this;
        if (pc._isClosed) return Promise.reject($0c1a1f8c0fb8833d$var$makeError("InvalidStateError", "Can not call createAnswer after close"));
        if (!(pc.signalingState === "have-remote-offer" || pc.signalingState === "have-local-pranswer")) return Promise.reject($0c1a1f8c0fb8833d$var$makeError("InvalidStateError", "Can not call createAnswer in signalingState " + pc.signalingState));
        var sdp = $a3uXU.writeSessionBoilerplate(pc._sdpSessionId, pc._sdpSessionVersion++);
        if (pc.usingBundle) sdp += "a=group:BUNDLE " + pc.transceivers.map(function(t) {
            return t.mid;
        }).join(" ") + "\r\n";
        sdp += "a=ice-options:trickle\r\n";
        var mediaSectionsInOffer = $a3uXU.getMediaSections(pc._remoteDescription.sdp).length;
        pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
            if (sdpMLineIndex + 1 > mediaSectionsInOffer) return;
            if (transceiver.rejected) {
                if (transceiver.kind === "application") {
                    if (transceiver.protocol === "DTLS/SCTP") sdp += "m=application 0 DTLS/SCTP 5000\r\n";
                    else sdp += "m=application 0 " + transceiver.protocol + " webrtc-datachannel\r\n";
                } else if (transceiver.kind === "audio") sdp += "m=audio 0 UDP/TLS/RTP/SAVPF 0\r\na=rtpmap:0 PCMU/8000\r\n";
                else if (transceiver.kind === "video") sdp += "m=video 0 UDP/TLS/RTP/SAVPF 120\r\na=rtpmap:120 VP8/90000\r\n";
                sdp += "c=IN IP4 0.0.0.0\r\na=inactive\r\na=mid:" + transceiver.mid + "\r\n";
                return;
            }
            // FIXME: look at direction.
            if (transceiver.stream) {
                var localTrack;
                if (transceiver.kind === "audio") localTrack = transceiver.stream.getAudioTracks()[0];
                else if (transceiver.kind === "video") localTrack = transceiver.stream.getVideoTracks()[0];
                if (localTrack) // add RTX
                {
                    if (edgeVersion >= 15019 && transceiver.kind === "video" && !transceiver.sendEncodingParameters[0].rtx) transceiver.sendEncodingParameters[0].rtx = {
                        ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
                    };
                }
            }
            // Calculate intersection of capabilities.
            var commonCapabilities = $0c1a1f8c0fb8833d$var$getCommonCapabilities(transceiver.localCapabilities, transceiver.remoteCapabilities);
            var hasRtx = commonCapabilities.codecs.filter(function(c) {
                return c.name.toLowerCase() === "rtx";
            }).length;
            if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) delete transceiver.sendEncodingParameters[0].rtx;
            sdp += $0c1a1f8c0fb8833d$var$writeMediaSection(transceiver, commonCapabilities, "answer", transceiver.stream, pc._dtlsRole);
            if (transceiver.rtcpParameters && transceiver.rtcpParameters.reducedSize) sdp += "a=rtcp-rsize\r\n";
        });
        var desc = new window.RTCSessionDescription({
            type: "answer",
            sdp: sdp
        });
        return Promise.resolve(desc);
    };
    RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
        var pc = this;
        var sections;
        if (candidate && !(candidate.sdpMLineIndex !== undefined || candidate.sdpMid)) return Promise.reject(new TypeError("sdpMLineIndex or sdpMid required"));
        // TODO: needs to go into ops queue.
        return new Promise(function(resolve, reject) {
            if (!pc._remoteDescription) return reject($0c1a1f8c0fb8833d$var$makeError("InvalidStateError", "Can not add ICE candidate without a remote description"));
            else if (!candidate || candidate.candidate === "") for(var j = 0; j < pc.transceivers.length; j++){
                if (pc.transceivers[j].rejected) continue;
                pc.transceivers[j].iceTransport.addRemoteCandidate({});
                sections = $a3uXU.getMediaSections(pc._remoteDescription.sdp);
                sections[j] += "a=end-of-candidates\r\n";
                pc._remoteDescription.sdp = $a3uXU.getDescription(pc._remoteDescription.sdp) + sections.join("");
                if (pc.usingBundle) break;
            }
            else {
                var sdpMLineIndex = candidate.sdpMLineIndex;
                if (candidate.sdpMid) {
                    for(var i = 0; i < pc.transceivers.length; i++)if (pc.transceivers[i].mid === candidate.sdpMid) {
                        sdpMLineIndex = i;
                        break;
                    }
                }
                var transceiver = pc.transceivers[sdpMLineIndex];
                if (transceiver) {
                    if (transceiver.rejected) return resolve();
                    var cand = Object.keys(candidate.candidate).length > 0 ? $a3uXU.parseCandidate(candidate.candidate) : {};
                    // Ignore Chrome's invalid candidates since Edge does not like them.
                    if (cand.protocol === "tcp" && (cand.port === 0 || cand.port === 9)) return resolve();
                    // Ignore RTCP candidates, we assume RTCP-MUX.
                    if (cand.component && cand.component !== 1) return resolve();
                    // when using bundle, avoid adding candidates to the wrong
                    // ice transport. And avoid adding candidates added in the SDP.
                    if (sdpMLineIndex === 0 || sdpMLineIndex > 0 && transceiver.iceTransport !== pc.transceivers[0].iceTransport) {
                        if (!$0c1a1f8c0fb8833d$var$maybeAddCandidate(transceiver.iceTransport, cand)) return reject($0c1a1f8c0fb8833d$var$makeError("OperationError", "Can not add ICE candidate"));
                    }
                    // update the remoteDescription.
                    var candidateString = candidate.candidate.trim();
                    if (candidateString.indexOf("a=") === 0) candidateString = candidateString.substr(2);
                    sections = $a3uXU.getMediaSections(pc._remoteDescription.sdp);
                    sections[sdpMLineIndex] += "a=" + (cand.type ? candidateString : "end-of-candidates") + "\r\n";
                    pc._remoteDescription.sdp = $a3uXU.getDescription(pc._remoteDescription.sdp) + sections.join("");
                } else return reject($0c1a1f8c0fb8833d$var$makeError("OperationError", "Can not add ICE candidate"));
            }
            resolve();
        });
    };
    RTCPeerConnection.prototype.getStats = function(selector) {
        if (selector && selector instanceof window.MediaStreamTrack) {
            var senderOrReceiver = null;
            this.transceivers.forEach(function(transceiver) {
                if (transceiver.rtpSender && transceiver.rtpSender.track === selector) senderOrReceiver = transceiver.rtpSender;
                else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track === selector) senderOrReceiver = transceiver.rtpReceiver;
            });
            if (!senderOrReceiver) throw $0c1a1f8c0fb8833d$var$makeError("InvalidAccessError", "Invalid selector.");
            return senderOrReceiver.getStats();
        }
        var promises = [];
        this.transceivers.forEach(function(transceiver) {
            [
                "rtpSender",
                "rtpReceiver",
                "iceGatherer",
                "iceTransport",
                "dtlsTransport"
            ].forEach(function(method) {
                if (transceiver[method]) promises.push(transceiver[method].getStats());
            });
        });
        return Promise.all(promises).then(function(allStats) {
            var results = new Map();
            allStats.forEach(function(stats) {
                stats.forEach(function(stat) {
                    results.set(stat.id, stat);
                });
            });
            return results;
        });
    };
    // fix low-level stat names and return Map instead of object.
    var ortcObjects = [
        "RTCRtpSender",
        "RTCRtpReceiver",
        "RTCIceGatherer",
        "RTCIceTransport",
        "RTCDtlsTransport"
    ];
    ortcObjects.forEach(function(ortcObjectName) {
        var obj = window[ortcObjectName];
        if (obj && obj.prototype && obj.prototype.getStats) {
            var nativeGetstats = obj.prototype.getStats;
            obj.prototype.getStats = function() {
                return nativeGetstats.apply(this).then(function(nativeStats) {
                    var mapStats = new Map();
                    Object.keys(nativeStats).forEach(function(id) {
                        nativeStats[id].type = $0c1a1f8c0fb8833d$var$fixStatsType(nativeStats[id]);
                        mapStats.set(id, nativeStats[id]);
                    });
                    return mapStats;
                });
            };
        }
    });
    // legacy callback shims. Should be moved to adapter.js some days.
    var methods = [
        "createOffer",
        "createAnswer"
    ];
    methods.forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[0] === "function" || typeof args[1] === "function") return nativeMethod.apply(this, [
                arguments[2]
            ]).then(function(description) {
                if (typeof args[0] === "function") args[0].apply(null, [
                    description
                ]);
            }, function(error) {
                if (typeof args[1] === "function") args[1].apply(null, [
                    error
                ]);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    methods = [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ];
    methods.forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[1] === "function" || typeof args[2] === "function") return nativeMethod.apply(this, arguments).then(function() {
                if (typeof args[1] === "function") args[1].apply(null);
            }, function(error) {
                if (typeof args[2] === "function") args[2].apply(null, [
                    error
                ]);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    // getStats is special. It doesn't have a spec legacy method yet we support
    // getStats(something, cb) without error callbacks.
    [
        "getStats"
    ].forEach(function(method) {
        var nativeMethod = RTCPeerConnection.prototype[method];
        RTCPeerConnection.prototype[method] = function() {
            var args = arguments;
            if (typeof args[1] === "function") return nativeMethod.apply(this, arguments).then(function() {
                if (typeof args[1] === "function") args[1].apply(null);
            });
            return nativeMethod.apply(this, arguments);
        };
    });
    return RTCPeerConnection;
};

});
parcelRegister("a3uXU", function(module, exports) {
/* eslint-env node */ "use strict";
// SDP helpers.
var $7522343ecaeeccb8$var$SDPUtils = {};
// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
$7522343ecaeeccb8$var$SDPUtils.generateIdentifier = function() {
    return Math.random().toString(36).substr(2, 10);
};
// The RTCP CNAME used by all peerconnections from the same JS.
$7522343ecaeeccb8$var$SDPUtils.localCName = $7522343ecaeeccb8$var$SDPUtils.generateIdentifier();
// Splits SDP into lines, dealing with both CRLF and LF.
$7522343ecaeeccb8$var$SDPUtils.splitLines = function(blob) {
    return blob.trim().split("\n").map(function(line) {
        return line.trim();
    });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
$7522343ecaeeccb8$var$SDPUtils.splitSections = function(blob) {
    var parts = blob.split("\nm=");
    return parts.map(function(part, index) {
        return (index > 0 ? "m=" + part : part).trim() + "\r\n";
    });
};
// returns the session description.
$7522343ecaeeccb8$var$SDPUtils.getDescription = function(blob) {
    var sections = $7522343ecaeeccb8$var$SDPUtils.splitSections(blob);
    return sections && sections[0];
};
// returns the individual media sections.
$7522343ecaeeccb8$var$SDPUtils.getMediaSections = function(blob) {
    var sections = $7522343ecaeeccb8$var$SDPUtils.splitSections(blob);
    sections.shift();
    return sections;
};
// Returns lines that start with a certain prefix.
$7522343ecaeeccb8$var$SDPUtils.matchPrefix = function(blob, prefix) {
    return $7522343ecaeeccb8$var$SDPUtils.splitLines(blob).filter(function(line) {
        return line.indexOf(prefix) === 0;
    });
};
// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
$7522343ecaeeccb8$var$SDPUtils.parseCandidate = function(line) {
    var parts;
    // Parse both variants.
    if (line.indexOf("a=candidate:") === 0) parts = line.substring(12).split(" ");
    else parts = line.substring(10).split(" ");
    var candidate = {
        foundation: parts[0],
        component: parseInt(parts[1], 10),
        protocol: parts[2].toLowerCase(),
        priority: parseInt(parts[3], 10),
        ip: parts[4],
        address: parts[4],
        port: parseInt(parts[5], 10),
        // skip parts[6] == 'typ'
        type: parts[7]
    };
    for(var i = 8; i < parts.length; i += 2)switch(parts[i]){
        case "raddr":
            candidate.relatedAddress = parts[i + 1];
            break;
        case "rport":
            candidate.relatedPort = parseInt(parts[i + 1], 10);
            break;
        case "tcptype":
            candidate.tcpType = parts[i + 1];
            break;
        case "ufrag":
            candidate.ufrag = parts[i + 1]; // for backward compability.
            candidate.usernameFragment = parts[i + 1];
            break;
        default:
            candidate[parts[i]] = parts[i + 1];
            break;
    }
    return candidate;
};
// Translates a candidate object into SDP candidate attribute.
$7522343ecaeeccb8$var$SDPUtils.writeCandidate = function(candidate) {
    var sdp = [];
    sdp.push(candidate.foundation);
    sdp.push(candidate.component);
    sdp.push(candidate.protocol.toUpperCase());
    sdp.push(candidate.priority);
    sdp.push(candidate.address || candidate.ip);
    sdp.push(candidate.port);
    var type = candidate.type;
    sdp.push("typ");
    sdp.push(type);
    if (type !== "host" && candidate.relatedAddress && candidate.relatedPort) {
        sdp.push("raddr");
        sdp.push(candidate.relatedAddress);
        sdp.push("rport");
        sdp.push(candidate.relatedPort);
    }
    if (candidate.tcpType && candidate.protocol.toLowerCase() === "tcp") {
        sdp.push("tcptype");
        sdp.push(candidate.tcpType);
    }
    if (candidate.usernameFragment || candidate.ufrag) {
        sdp.push("ufrag");
        sdp.push(candidate.usernameFragment || candidate.ufrag);
    }
    return "candidate:" + sdp.join(" ");
};
// Parses an ice-options line, returns an array of option tags.
// a=ice-options:foo bar
$7522343ecaeeccb8$var$SDPUtils.parseIceOptions = function(line) {
    return line.substr(14).split(" ");
};
// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
$7522343ecaeeccb8$var$SDPUtils.parseRtpMap = function(line) {
    var parts = line.substr(9).split(" ");
    var parsed = {
        payloadType: parseInt(parts.shift(), 10) // was: id
    };
    parts = parts[0].split("/");
    parsed.name = parts[0];
    parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
    parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
    // legacy alias, got renamed back to channels in ORTC.
    parsed.numChannels = parsed.channels;
    return parsed;
};
// Generate an a=rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
$7522343ecaeeccb8$var$SDPUtils.writeRtpMap = function(codec) {
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    var channels = codec.channels || codec.numChannels || 1;
    return "a=rtpmap:" + pt + " " + codec.name + "/" + codec.clockRate + (channels !== 1 ? "/" + channels : "") + "\r\n";
};
// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
$7522343ecaeeccb8$var$SDPUtils.parseExtmap = function(line) {
    var parts = line.substr(9).split(" ");
    return {
        id: parseInt(parts[0], 10),
        direction: parts[0].indexOf("/") > 0 ? parts[0].split("/")[1] : "sendrecv",
        uri: parts[1]
    };
};
// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
$7522343ecaeeccb8$var$SDPUtils.writeExtmap = function(headerExtension) {
    return "a=extmap:" + (headerExtension.id || headerExtension.preferredId) + (headerExtension.direction && headerExtension.direction !== "sendrecv" ? "/" + headerExtension.direction : "") + " " + headerExtension.uri + "\r\n";
};
// Parses an ftmp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
$7522343ecaeeccb8$var$SDPUtils.parseFmtp = function(line) {
    var parsed = {};
    var kv;
    var parts = line.substr(line.indexOf(" ") + 1).split(";");
    for(var j = 0; j < parts.length; j++){
        kv = parts[j].trim().split("=");
        parsed[kv[0].trim()] = kv[1];
    }
    return parsed;
};
// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7522343ecaeeccb8$var$SDPUtils.writeFmtp = function(codec) {
    var line = "";
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.parameters && Object.keys(codec.parameters).length) {
        var params = [];
        Object.keys(codec.parameters).forEach(function(param) {
            if (codec.parameters[param]) params.push(param + "=" + codec.parameters[param]);
            else params.push(param);
        });
        line += "a=fmtp:" + pt + " " + params.join(";") + "\r\n";
    }
    return line;
};
// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
$7522343ecaeeccb8$var$SDPUtils.parseRtcpFb = function(line) {
    var parts = line.substr(line.indexOf(" ") + 1).split(" ");
    return {
        type: parts.shift(),
        parameter: parts.join(" ")
    };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
$7522343ecaeeccb8$var$SDPUtils.writeRtcpFb = function(codec) {
    var lines = "";
    var pt = codec.payloadType;
    if (codec.preferredPayloadType !== undefined) pt = codec.preferredPayloadType;
    if (codec.rtcpFeedback && codec.rtcpFeedback.length) // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function(fb) {
        lines += "a=rtcp-fb:" + pt + " " + fb.type + (fb.parameter && fb.parameter.length ? " " + fb.parameter : "") + "\r\n";
    });
    return lines;
};
// Parses an RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
$7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia = function(line) {
    var sp = line.indexOf(" ");
    var parts = {
        ssrc: parseInt(line.substr(7, sp - 7), 10)
    };
    var colon = line.indexOf(":", sp);
    if (colon > -1) {
        parts.attribute = line.substr(sp + 1, colon - sp - 1);
        parts.value = line.substr(colon + 1);
    } else parts.attribute = line.substr(sp + 1);
    return parts;
};
$7522343ecaeeccb8$var$SDPUtils.parseSsrcGroup = function(line) {
    var parts = line.substr(13).split(" ");
    return {
        semantics: parts.shift(),
        ssrcs: parts.map(function(ssrc) {
            return parseInt(ssrc, 10);
        })
    };
};
// Extracts the MID (RFC 5888) from a media section.
// returns the MID or undefined if no mid line was found.
$7522343ecaeeccb8$var$SDPUtils.getMid = function(mediaSection) {
    var mid = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=mid:")[0];
    if (mid) return mid.substr(6);
};
$7522343ecaeeccb8$var$SDPUtils.parseFingerprint = function(line) {
    var parts = line.substr(14).split(" ");
    return {
        algorithm: parts[0].toLowerCase(),
        value: parts[1]
    };
};
// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
$7522343ecaeeccb8$var$SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
    var lines = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=fingerprint:");
    // Note: a=setup line is ignored since we use the 'auto' role.
    // Note2: 'algorithm' is not case sensitive except in Edge.
    return {
        role: "auto",
        fingerprints: lines.map($7522343ecaeeccb8$var$SDPUtils.parseFingerprint)
    };
};
// Serializes DTLS parameters to SDP.
$7522343ecaeeccb8$var$SDPUtils.writeDtlsParameters = function(params, setupType) {
    var sdp = "a=setup:" + setupType + "\r\n";
    params.fingerprints.forEach(function(fp) {
        sdp += "a=fingerprint:" + fp.algorithm + " " + fp.value + "\r\n";
    });
    return sdp;
};
// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
$7522343ecaeeccb8$var$SDPUtils.parseCryptoLine = function(line) {
    var parts = line.substr(9).split(" ");
    return {
        tag: parseInt(parts[0], 10),
        cryptoSuite: parts[1],
        keyParams: parts[2],
        sessionParams: parts.slice(3)
    };
};
$7522343ecaeeccb8$var$SDPUtils.writeCryptoLine = function(parameters) {
    return "a=crypto:" + parameters.tag + " " + parameters.cryptoSuite + " " + (typeof parameters.keyParams === "object" ? $7522343ecaeeccb8$var$SDPUtils.writeCryptoKeyParams(parameters.keyParams) : parameters.keyParams) + (parameters.sessionParams ? " " + parameters.sessionParams.join(" ") : "") + "\r\n";
};
// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
$7522343ecaeeccb8$var$SDPUtils.parseCryptoKeyParams = function(keyParams) {
    if (keyParams.indexOf("inline:") !== 0) return null;
    var parts = keyParams.substr(7).split("|");
    return {
        keyMethod: "inline",
        keySalt: parts[0],
        lifeTime: parts[1],
        mkiValue: parts[2] ? parts[2].split(":")[0] : undefined,
        mkiLength: parts[2] ? parts[2].split(":")[1] : undefined
    };
};
$7522343ecaeeccb8$var$SDPUtils.writeCryptoKeyParams = function(keyParams) {
    return keyParams.keyMethod + ":" + keyParams.keySalt + (keyParams.lifeTime ? "|" + keyParams.lifeTime : "") + (keyParams.mkiValue && keyParams.mkiLength ? "|" + keyParams.mkiValue + ":" + keyParams.mkiLength : "");
};
// Extracts all SDES paramters.
$7522343ecaeeccb8$var$SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
    var lines = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=crypto:");
    return lines.map($7522343ecaeeccb8$var$SDPUtils.parseCryptoLine);
};
// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
$7522343ecaeeccb8$var$SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
    var ufrag = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-ufrag:")[0];
    var pwd = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection + sessionpart, "a=ice-pwd:")[0];
    if (!(ufrag && pwd)) return null;
    return {
        usernameFragment: ufrag.substr(12),
        password: pwd.substr(10)
    };
};
// Serializes ICE parameters to SDP.
$7522343ecaeeccb8$var$SDPUtils.writeIceParameters = function(params) {
    return "a=ice-ufrag:" + params.usernameFragment + "\r\n" + "a=ice-pwd:" + params.password + "\r\n";
};
// Parses the SDP media section and returns RTCRtpParameters.
$7522343ecaeeccb8$var$SDPUtils.parseRtpParameters = function(mediaSection) {
    var description = {
        codecs: [],
        headerExtensions: [],
        fecMechanisms: [],
        rtcp: []
    };
    var lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(" ");
    for(var i = 3; i < mline.length; i++){
        var pt = mline[i];
        var rtpmapline = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=rtpmap:" + pt + " ")[0];
        if (rtpmapline) {
            var codec = $7522343ecaeeccb8$var$SDPUtils.parseRtpMap(rtpmapline);
            var fmtps = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=fmtp:" + pt + " ");
            // Only the first a=fmtp:<pt> is considered.
            codec.parameters = fmtps.length ? $7522343ecaeeccb8$var$SDPUtils.parseFmtp(fmtps[0]) : {};
            codec.rtcpFeedback = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-fb:" + pt + " ").map($7522343ecaeeccb8$var$SDPUtils.parseRtcpFb);
            description.codecs.push(codec);
            // parse FEC mechanisms from rtpmap lines.
            switch(codec.name.toUpperCase()){
                case "RED":
                case "ULPFEC":
                    description.fecMechanisms.push(codec.name.toUpperCase());
                    break;
                default:
                    break;
            }
        }
    }
    $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=extmap:").forEach(function(line) {
        description.headerExtensions.push($7522343ecaeeccb8$var$SDPUtils.parseExtmap(line));
    });
    // FIXME: parse rtcp.
    return description;
};
// Generates parts of the SDP media section describing the capabilities /
// parameters.
$7522343ecaeeccb8$var$SDPUtils.writeRtpDescription = function(kind, caps) {
    var sdp = "";
    // Build the mline.
    sdp += "m=" + kind + " ";
    sdp += caps.codecs.length > 0 ? "9" : "0"; // reject if no codecs.
    sdp += " UDP/TLS/RTP/SAVPF ";
    sdp += caps.codecs.map(function(codec) {
        if (codec.preferredPayloadType !== undefined) return codec.preferredPayloadType;
        return codec.payloadType;
    }).join(" ") + "\r\n";
    sdp += "c=IN IP4 0.0.0.0\r\n";
    sdp += "a=rtcp:9 IN IP4 0.0.0.0\r\n";
    // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
    caps.codecs.forEach(function(codec) {
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeRtpMap(codec);
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeFmtp(codec);
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeRtcpFb(codec);
    });
    var maxptime = 0;
    caps.codecs.forEach(function(codec) {
        if (codec.maxptime > maxptime) maxptime = codec.maxptime;
    });
    if (maxptime > 0) sdp += "a=maxptime:" + maxptime + "\r\n";
    sdp += "a=rtcp-mux\r\n";
    if (caps.headerExtensions) caps.headerExtensions.forEach(function(extension) {
        sdp += $7522343ecaeeccb8$var$SDPUtils.writeExtmap(extension);
    });
    // FIXME: write fecMechanisms.
    return sdp;
};
// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
$7522343ecaeeccb8$var$SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
    var encodingParameters = [];
    var description = $7522343ecaeeccb8$var$SDPUtils.parseRtpParameters(mediaSection);
    var hasRed = description.fecMechanisms.indexOf("RED") !== -1;
    var hasUlpfec = description.fecMechanisms.indexOf("ULPFEC") !== -1;
    // filter a=ssrc:... cname:, ignore PlanB-msid
    var ssrcs = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map(function(line) {
        return $7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia(line);
    }).filter(function(parts) {
        return parts.attribute === "cname";
    });
    var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
    var secondarySsrc;
    var flows = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc-group:FID").map(function(line) {
        var parts = line.substr(17).split(" ");
        return parts.map(function(part) {
            return parseInt(part, 10);
        });
    });
    if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) secondarySsrc = flows[0][1];
    description.codecs.forEach(function(codec) {
        if (codec.name.toUpperCase() === "RTX" && codec.parameters.apt) {
            var encParam = {
                ssrc: primarySsrc,
                codecPayloadType: parseInt(codec.parameters.apt, 10)
            };
            if (primarySsrc && secondarySsrc) encParam.rtx = {
                ssrc: secondarySsrc
            };
            encodingParameters.push(encParam);
            if (hasRed) {
                encParam = JSON.parse(JSON.stringify(encParam));
                encParam.fec = {
                    ssrc: primarySsrc,
                    mechanism: hasUlpfec ? "red+ulpfec" : "red"
                };
                encodingParameters.push(encParam);
            }
        }
    });
    if (encodingParameters.length === 0 && primarySsrc) encodingParameters.push({
        ssrc: primarySsrc
    });
    // we support both b=AS and b=TIAS but interpret AS as TIAS.
    var bandwidth = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "b=");
    if (bandwidth.length) {
        if (bandwidth[0].indexOf("b=TIAS:") === 0) bandwidth = parseInt(bandwidth[0].substr(7), 10);
        else if (bandwidth[0].indexOf("b=AS:") === 0) // use formula from JSEP to convert b=AS to TIAS value.
        bandwidth = parseInt(bandwidth[0].substr(5), 10) * 950 - 16000;
        else bandwidth = undefined;
        encodingParameters.forEach(function(params) {
            params.maxBitrate = bandwidth;
        });
    }
    return encodingParameters;
};
// parses http://draft.ortc.org/#rtcrtcpparameters*
$7522343ecaeeccb8$var$SDPUtils.parseRtcpParameters = function(mediaSection) {
    var rtcpParameters = {};
    // Gets the first SSRC. Note tha with RTX there might be multiple
    // SSRCs.
    var remoteSsrc = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map(function(line) {
        return $7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia(line);
    }).filter(function(obj) {
        return obj.attribute === "cname";
    })[0];
    if (remoteSsrc) {
        rtcpParameters.cname = remoteSsrc.value;
        rtcpParameters.ssrc = remoteSsrc.ssrc;
    }
    // Edge uses the compound attribute instead of reducedSize
    // compound is !reducedSize
    var rsize = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-rsize");
    rtcpParameters.reducedSize = rsize.length > 0;
    rtcpParameters.compound = rsize.length === 0;
    // parses the rtcp-mux attrіbute.
    // Note that Edge does not support unmuxed RTCP.
    var mux = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=rtcp-mux");
    rtcpParameters.mux = mux.length > 0;
    return rtcpParameters;
};
// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
$7522343ecaeeccb8$var$SDPUtils.parseMsid = function(mediaSection) {
    var parts;
    var spec = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=msid:");
    if (spec.length === 1) {
        parts = spec[0].substr(7).split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
    var planB = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=ssrc:").map(function(line) {
        return $7522343ecaeeccb8$var$SDPUtils.parseSsrcMedia(line);
    }).filter(function(msidParts) {
        return msidParts.attribute === "msid";
    });
    if (planB.length > 0) {
        parts = planB[0].value.split(" ");
        return {
            stream: parts[0],
            track: parts[1]
        };
    }
};
// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
$7522343ecaeeccb8$var$SDPUtils.parseSctpDescription = function(mediaSection) {
    var mline = $7522343ecaeeccb8$var$SDPUtils.parseMLine(mediaSection);
    var maxSizeLine = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=max-message-size:");
    var maxMessageSize;
    if (maxSizeLine.length > 0) maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
    if (isNaN(maxMessageSize)) maxMessageSize = 65536;
    var sctpPort = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=sctp-port:");
    if (sctpPort.length > 0) return {
        port: parseInt(sctpPort[0].substr(12), 10),
        protocol: mline.fmt,
        maxMessageSize: maxMessageSize
    };
    var sctpMapLines = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:");
    if (sctpMapLines.length > 0) {
        var parts = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "a=sctpmap:")[0].substr(10).split(" ");
        return {
            port: parseInt(parts[0], 10),
            protocol: parts[1],
            maxMessageSize: maxMessageSize
        };
    }
};
// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
$7522343ecaeeccb8$var$SDPUtils.writeSctpDescription = function(media, sctp) {
    var output = [];
    if (media.protocol !== "DTLS/SCTP") output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.protocol + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctp-port:" + sctp.port + "\r\n"
    ];
    else output = [
        "m=" + media.kind + " 9 " + media.protocol + " " + sctp.port + "\r\n",
        "c=IN IP4 0.0.0.0\r\n",
        "a=sctpmap:" + sctp.port + " " + sctp.protocol + " 65535\r\n"
    ];
    if (sctp.maxMessageSize !== undefined) output.push("a=max-message-size:" + sctp.maxMessageSize + "\r\n");
    return output.join("");
};
// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
$7522343ecaeeccb8$var$SDPUtils.generateSessionId = function() {
    return Math.random().toString().substr(2, 21);
};
// Write boilder plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
$7522343ecaeeccb8$var$SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
    var sessionId;
    var version = sessVer !== undefined ? sessVer : 2;
    if (sessId) sessionId = sessId;
    else sessionId = $7522343ecaeeccb8$var$SDPUtils.generateSessionId();
    var user = sessUser || "thisisadapterortc";
    // FIXME: sess-id should be an NTP timestamp.
    return "v=0\r\no=" + user + " " + sessionId + " " + version + " IN IP4 127.0.0.1\r\n" + "s=-\r\n" + "t=0 0\r\n";
};
$7522343ecaeeccb8$var$SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
    var sdp = $7522343ecaeeccb8$var$SDPUtils.writeRtpDescription(transceiver.kind, caps);
    // Map ICE parameters (ufrag, pwd) to SDP.
    sdp += $7522343ecaeeccb8$var$SDPUtils.writeIceParameters(transceiver.iceGatherer.getLocalParameters());
    // Map DTLS parameters to SDP.
    sdp += $7522343ecaeeccb8$var$SDPUtils.writeDtlsParameters(transceiver.dtlsTransport.getLocalParameters(), type === "offer" ? "actpass" : "active");
    sdp += "a=mid:" + transceiver.mid + "\r\n";
    if (transceiver.direction) sdp += "a=" + transceiver.direction + "\r\n";
    else if (transceiver.rtpSender && transceiver.rtpReceiver) sdp += "a=sendrecv\r\n";
    else if (transceiver.rtpSender) sdp += "a=sendonly\r\n";
    else if (transceiver.rtpReceiver) sdp += "a=recvonly\r\n";
    else sdp += "a=inactive\r\n";
    if (transceiver.rtpSender) {
        // spec.
        var msid = "msid:" + stream.id + " " + transceiver.rtpSender.track.id + "\r\n";
        sdp += "a=" + msid;
        // for Chrome.
        sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " " + msid;
        if (transceiver.sendEncodingParameters[0].rtx) {
            sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " " + msid;
            sdp += "a=ssrc-group:FID " + transceiver.sendEncodingParameters[0].ssrc + " " + transceiver.sendEncodingParameters[0].rtx.ssrc + "\r\n";
        }
    }
    // FIXME: this should be written by writeRtpDescription.
    sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].ssrc + " cname:" + $7522343ecaeeccb8$var$SDPUtils.localCName + "\r\n";
    if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) sdp += "a=ssrc:" + transceiver.sendEncodingParameters[0].rtx.ssrc + " cname:" + $7522343ecaeeccb8$var$SDPUtils.localCName + "\r\n";
    return sdp;
};
// Gets the direction from the mediaSection or the sessionpart.
$7522343ecaeeccb8$var$SDPUtils.getDirection = function(mediaSection, sessionpart) {
    // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
    var lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    for(var i = 0; i < lines.length; i++)switch(lines[i]){
        case "a=sendrecv":
        case "a=sendonly":
        case "a=recvonly":
        case "a=inactive":
            return lines[i].substr(2);
        default:
    }
    if (sessionpart) return $7522343ecaeeccb8$var$SDPUtils.getDirection(sessionpart);
    return "sendrecv";
};
$7522343ecaeeccb8$var$SDPUtils.getKind = function(mediaSection) {
    var lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    var mline = lines[0].split(" ");
    return mline[0].substr(2);
};
$7522343ecaeeccb8$var$SDPUtils.isRejected = function(mediaSection) {
    return mediaSection.split(" ", 2)[1] === "0";
};
$7522343ecaeeccb8$var$SDPUtils.parseMLine = function(mediaSection) {
    var lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(mediaSection);
    var parts = lines[0].substr(2).split(" ");
    return {
        kind: parts[0],
        port: parseInt(parts[1], 10),
        protocol: parts[2],
        fmt: parts.slice(3).join(" ")
    };
};
$7522343ecaeeccb8$var$SDPUtils.parseOLine = function(mediaSection) {
    var line = $7522343ecaeeccb8$var$SDPUtils.matchPrefix(mediaSection, "o=")[0];
    var parts = line.substr(2).split(" ");
    return {
        username: parts[0],
        sessionId: parts[1],
        sessionVersion: parseInt(parts[2], 10),
        netType: parts[3],
        addressType: parts[4],
        address: parts[5]
    };
};
// a very naive interpretation of a valid SDP.
$7522343ecaeeccb8$var$SDPUtils.isValidSDP = function(blob) {
    if (typeof blob !== "string" || blob.length === 0) return false;
    var lines = $7522343ecaeeccb8$var$SDPUtils.splitLines(blob);
    for(var i = 0; i < lines.length; i++){
        if (lines[i].length < 2 || lines[i].charAt(1) !== "=") return false;
    // TODO: check the modifier a bit more.
    }
    return true;
};
module.exports = $7522343ecaeeccb8$var$SDPUtils;

});


parcelRegister("j21PI", function(module, exports) {

$parcel$export(module.exports, "shimGetUserMedia", () => $ddafa03a1a3b63a2$export$1ed4910f4d37dc5e);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $ddafa03a1a3b63a2$export$1ed4910f4d37dc5e(window) {
    const navigator = window && window.navigator;
    const shimError_ = function(e) {
        return {
            name: ({
                PermissionDeniedError: "NotAllowedError"
            })[e.name] || e.name,
            message: e.message,
            constraint: e.constraint,
            toString () {
                return this.name;
            }
        };
    };
    // getUserMedia error shim.
    const origGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
        return origGetUserMedia(c).catch((e)=>Promise.reject(shimError_(e)));
    };
}

});

parcelRegister("8u9ip", function(module, exports) {

$parcel$export(module.exports, "shimGetDisplayMedia", () => $62d856099aa24219$export$97270b87351d9c04);
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $62d856099aa24219$export$97270b87351d9c04(window) {
    if (!("getDisplayMedia" in window.navigator)) return;
    if (!window.navigator.mediaDevices) return;
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    window.navigator.mediaDevices.getDisplayMedia = window.navigator.getDisplayMedia.bind(window.navigator);
}

});


parcelRegister("gV8Pp", function(module, exports) {

$parcel$export(module.exports, "shimOnTrack", () => $c518d147eb169a8d$export$f358708f68ab068);
$parcel$export(module.exports, "shimPeerConnection", () => $c518d147eb169a8d$export$852a08dda9a55ea7);
$parcel$export(module.exports, "shimSenderGetStats", () => $c518d147eb169a8d$export$f0525502095c04ef);
$parcel$export(module.exports, "shimReceiverGetStats", () => $c518d147eb169a8d$export$83d69126527b1171);
$parcel$export(module.exports, "shimRemoveStream", () => $c518d147eb169a8d$export$825e523ef749bd8c);
$parcel$export(module.exports, "shimRTCDataChannel", () => $c518d147eb169a8d$export$ff9cb3bc8990e8f7);
$parcel$export(module.exports, "shimAddTransceiver", () => $c518d147eb169a8d$export$70c77533b6e9908d);
$parcel$export(module.exports, "shimGetParameters", () => $c518d147eb169a8d$export$66238223c298fbaa);
$parcel$export(module.exports, "shimCreateOffer", () => $c518d147eb169a8d$export$51beccf0e777b843);
$parcel$export(module.exports, "shimCreateAnswer", () => $c518d147eb169a8d$export$df0b46e7cef08150);
$parcel$export(module.exports, "shimGetUserMedia", () => (parcelRequire("4FleT")).shimGetUserMedia);
$parcel$export(module.exports, "shimGetDisplayMedia", () => (parcelRequire("hDYMC")).shimGetDisplayMedia);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
var $7zZv5 = parcelRequire("7zZv5");

var $4FleT = parcelRequire("4FleT");

var $hDYMC = parcelRequire("hDYMC");
"use strict";
function $c518d147eb169a8d$export$f358708f68ab068(window) {
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $c518d147eb169a8d$export$852a08dda9a55ea7(window, browserDetails) {
    if (typeof window !== "object" || !(window.RTCPeerConnection || window.mozRTCPeerConnection)) return; // probably media.peerconnection.enabled=false in about:config
    if (!window.RTCPeerConnection && window.mozRTCPeerConnection) // very basic support for old versions.
    window.RTCPeerConnection = window.mozRTCPeerConnection;
    if (browserDetails.version < 53) // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    [
        "setLocalDescription",
        "setRemoteDescription",
        "addIceCandidate"
    ].forEach(function(method) {
        const nativeMethod = window.RTCPeerConnection.prototype[method];
        const methodObj = {
            [method] () {
                arguments[0] = new (method === "addIceCandidate" ? window.RTCIceCandidate : window.RTCSessionDescription)(arguments[0]);
                return nativeMethod.apply(this, arguments);
            }
        };
        window.RTCPeerConnection.prototype[method] = methodObj[method];
    });
    const modernStatsTypes = {
        inboundrtp: "inbound-rtp",
        outboundrtp: "outbound-rtp",
        candidatepair: "candidate-pair",
        localcandidate: "local-candidate",
        remotecandidate: "remote-candidate"
    };
    const nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function getStats() {
        const [selector, onSucc, onErr] = arguments;
        return nativeGetStats.apply(this, [
            selector || null
        ]).then((stats)=>{
            if (browserDetails.version < 53 && !onSucc) // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
                stats.forEach((stat)=>{
                    stat.type = modernStatsTypes[stat.type] || stat.type;
                });
            } catch (e) {
                if (e.name !== "TypeError") throw e;
                // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
                stats.forEach((stat, i)=>{
                    stats.set(i, Object.assign({}, stat, {
                        type: modernStatsTypes[stat.type] || stat.type
                    }));
                });
            }
            return stats;
        }).then(onSucc, onErr);
    };
}
function $c518d147eb169a8d$export$f0525502095c04ef(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpSender.prototype) return;
    const origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) window.RTCPeerConnection.prototype.getSenders = function getSenders() {
        const senders = origGetSenders.apply(this, []);
        senders.forEach((sender)=>sender._pc = this);
        return senders;
    };
    const origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) window.RTCPeerConnection.prototype.addTrack = function addTrack() {
        const sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
    };
    window.RTCRtpSender.prototype.getStats = function getStats() {
        return this.track ? this._pc.getStats(this.track) : Promise.resolve(new Map());
    };
}
function $c518d147eb169a8d$export$83d69126527b1171(window) {
    if (!(typeof window === "object" && window.RTCPeerConnection && window.RTCRtpSender)) return;
    if (window.RTCRtpSender && "getStats" in window.RTCRtpReceiver.prototype) return;
    const origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) window.RTCPeerConnection.prototype.getReceivers = function getReceivers() {
        const receivers = origGetReceivers.apply(this, []);
        receivers.forEach((receiver)=>receiver._pc = this);
        return receivers;
    };
    $7zZv5.wrapPeerConnectionEvent(window, "track", (e)=>{
        e.receiver._pc = e.srcElement;
        return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function getStats() {
        return this._pc.getStats(this.track);
    };
}
function $c518d147eb169a8d$export$825e523ef749bd8c(window) {
    if (!window.RTCPeerConnection || "removeStream" in window.RTCPeerConnection.prototype) return;
    window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        $7zZv5.deprecated("removeStream", "removeTrack");
        this.getSenders().forEach((sender)=>{
            if (sender.track && stream.getTracks().includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $c518d147eb169a8d$export$ff9cb3bc8990e8f7(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) window.RTCDataChannel = window.DataChannel;
}
function $c518d147eb169a8d$export$70c77533b6e9908d(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origAddTransceiver = window.RTCPeerConnection.prototype.addTransceiver;
    if (origAddTransceiver) window.RTCPeerConnection.prototype.addTransceiver = function addTransceiver() {
        this.setParametersPromises = [];
        const initParameters = arguments[1];
        const shouldPerformCheck = initParameters && "sendEncodings" in initParameters;
        if (shouldPerformCheck) // If sendEncodings params are provided, validate grammar
        initParameters.sendEncodings.forEach((encodingParam)=>{
            if ("rid" in encodingParam) {
                const ridRegex = /^[a-z0-9]{0,16}$/i;
                if (!ridRegex.test(encodingParam.rid)) throw new TypeError("Invalid RID value provided.");
            }
            if ("scaleResolutionDownBy" in encodingParam) {
                if (!(parseFloat(encodingParam.scaleResolutionDownBy) >= 1.0)) throw new RangeError("scale_resolution_down_by must be >= 1.0");
            }
            if ("maxFramerate" in encodingParam) {
                if (!(parseFloat(encodingParam.maxFramerate) >= 0)) throw new RangeError("max_framerate must be >= 0.0");
            }
        });
        const transceiver = origAddTransceiver.apply(this, arguments);
        if (shouldPerformCheck) {
            // Check if the init options were applied. If not we do this in an
            // asynchronous way and save the promise reference in a global object.
            // This is an ugly hack, but at the same time is way more robust than
            // checking the sender parameters before and after the createOffer
            // Also note that after the createoffer we are not 100% sure that
            // the params were asynchronously applied so we might miss the
            // opportunity to recreate offer.
            const { sender: sender } = transceiver;
            const params = sender.getParameters();
            if (!("encodings" in params) || // Avoid being fooled by patched getParameters() below.
            params.encodings.length === 1 && Object.keys(params.encodings[0]).length === 0) {
                params.encodings = initParameters.sendEncodings;
                sender.sendEncodings = initParameters.sendEncodings;
                this.setParametersPromises.push(sender.setParameters(params).then(()=>{
                    delete sender.sendEncodings;
                }).catch(()=>{
                    delete sender.sendEncodings;
                }));
            }
        }
        return transceiver;
    };
}
function $c518d147eb169a8d$export$66238223c298fbaa(window) {
    if (!(typeof window === "object" && window.RTCRtpSender)) return;
    const origGetParameters = window.RTCRtpSender.prototype.getParameters;
    if (origGetParameters) window.RTCRtpSender.prototype.getParameters = function getParameters() {
        const params = origGetParameters.apply(this, arguments);
        if (!("encodings" in params)) params.encodings = [].concat(this.sendEncodings || [
            {}
        ]);
        return params;
    };
}
function $c518d147eb169a8d$export$51beccf0e777b843(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateOffer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateOffer.apply(this, arguments);
    };
}
function $c518d147eb169a8d$export$df0b46e7cef08150(window) {
    // https://github.com/webrtcHacks/adapter/issues/998#issuecomment-516921647
    // Firefox ignores the init sendEncodings options passed to addTransceiver
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1396918
    if (!(typeof window === "object" && window.RTCPeerConnection)) return;
    const origCreateAnswer = window.RTCPeerConnection.prototype.createAnswer;
    window.RTCPeerConnection.prototype.createAnswer = function createAnswer() {
        if (this.setParametersPromises && this.setParametersPromises.length) return Promise.all(this.setParametersPromises).then(()=>{
            return origCreateAnswer.apply(this, arguments);
        }).finally(()=>{
            this.setParametersPromises = [];
        });
        return origCreateAnswer.apply(this, arguments);
    };
}

});
parcelRegister("4FleT", function(module, exports) {

$parcel$export(module.exports, "shimGetUserMedia", () => $365b77720cb4f52a$export$1ed4910f4d37dc5e);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
var $7zZv5 = parcelRequire("7zZv5");
"use strict";
function $365b77720cb4f52a$export$1ed4910f4d37dc5e(window, browserDetails) {
    const navigator = window && window.navigator;
    const MediaStreamTrack = window && window.MediaStreamTrack;
    navigator.getUserMedia = function(constraints, onSuccess, onError) {
        // Replace Firefox 44+'s deprecation warning with unprefixed version.
        $7zZv5.deprecated("navigator.getUserMedia", "navigator.mediaDevices.getUserMedia");
        navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
    };
    if (!(browserDetails.version > 55 && "autoGainControl" in navigator.mediaDevices.getSupportedConstraints())) {
        const remap = function(obj, a, b) {
            if (a in obj && !(b in obj)) {
                obj[b] = obj[a];
                delete obj[a];
            }
        };
        const nativeGetUserMedia = navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
        navigator.mediaDevices.getUserMedia = function(c) {
            if (typeof c === "object" && typeof c.audio === "object") {
                c = JSON.parse(JSON.stringify(c));
                remap(c.audio, "autoGainControl", "mozAutoGainControl");
                remap(c.audio, "noiseSuppression", "mozNoiseSuppression");
            }
            return nativeGetUserMedia(c);
        };
        if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
            const nativeGetSettings = MediaStreamTrack.prototype.getSettings;
            MediaStreamTrack.prototype.getSettings = function() {
                const obj = nativeGetSettings.apply(this, arguments);
                remap(obj, "mozAutoGainControl", "autoGainControl");
                remap(obj, "mozNoiseSuppression", "noiseSuppression");
                return obj;
            };
        }
        if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
            const nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
            MediaStreamTrack.prototype.applyConstraints = function(c) {
                if (this.kind === "audio" && typeof c === "object") {
                    c = JSON.parse(JSON.stringify(c));
                    remap(c, "autoGainControl", "mozAutoGainControl");
                    remap(c, "noiseSuppression", "mozNoiseSuppression");
                }
                return nativeApplyConstraints.apply(this, [
                    c
                ]);
            };
        }
    }
}

});

parcelRegister("hDYMC", function(module, exports) {

$parcel$export(module.exports, "shimGetDisplayMedia", () => $cd853a759273f164$export$97270b87351d9c04);
/*
 *  Copyright (c) 2018 The adapter.js project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ "use strict";
function $cd853a759273f164$export$97270b87351d9c04(window, preferredMediaSource) {
    if (window.navigator.mediaDevices && "getDisplayMedia" in window.navigator.mediaDevices) return;
    if (!window.navigator.mediaDevices) return;
    window.navigator.mediaDevices.getDisplayMedia = function getDisplayMedia(constraints) {
        if (!(constraints && constraints.video)) {
            const err = new DOMException("getDisplayMedia without video constraints is undefined");
            err.name = "NotFoundError";
            // from https://heycam.github.io/webidl/#idl-DOMException-error-names
            err.code = 8;
            return Promise.reject(err);
        }
        if (constraints.video === true) constraints.video = {
            mediaSource: preferredMediaSource
        };
        else constraints.video.mediaSource = preferredMediaSource;
        return window.navigator.mediaDevices.getUserMedia(constraints);
    };
}

});


parcelRegister("deq4F", function(module, exports) {

$parcel$export(module.exports, "shimLocalStreamsAPI", () => $9a20cef3f9b7f4b6$export$8df41282f4fdcea2);
$parcel$export(module.exports, "shimRemoteStreamsAPI", () => $9a20cef3f9b7f4b6$export$762aa4cbb4f2f857);
$parcel$export(module.exports, "shimCallbacksAPI", () => $9a20cef3f9b7f4b6$export$da31df245debdd3);
$parcel$export(module.exports, "shimGetUserMedia", () => $9a20cef3f9b7f4b6$export$1ed4910f4d37dc5e);
$parcel$export(module.exports, "shimConstraints", () => $9a20cef3f9b7f4b6$export$494a01ac68ba81ac);
$parcel$export(module.exports, "shimRTCIceServerUrls", () => $9a20cef3f9b7f4b6$export$671a8b47b41b6f41);
$parcel$export(module.exports, "shimTrackEventTransceiver", () => $9a20cef3f9b7f4b6$export$85d53da088cb1b14);
$parcel$export(module.exports, "shimCreateOfferLegacy", () => $9a20cef3f9b7f4b6$export$d444266503fdd2d4);
$parcel$export(module.exports, "shimAudioContext", () => $9a20cef3f9b7f4b6$export$857cd739a7b795d2);
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ 
var $7zZv5 = parcelRequire("7zZv5");
"use strict";
function $9a20cef3f9b7f4b6$export$8df41282f4fdcea2(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getLocalStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getLocalStreams = function getLocalStreams() {
        if (!this._localStreams) this._localStreams = [];
        return this._localStreams;
    };
    if (!("addStream" in window.RTCPeerConnection.prototype)) {
        const _addTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addStream = function addStream(stream) {
            if (!this._localStreams) this._localStreams = [];
            if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            // Try to emulate Chrome's behaviour of adding in audio-video order.
            // Safari orders by track id.
            stream.getAudioTracks().forEach((track)=>_addTrack.call(this, track, stream));
            stream.getVideoTracks().forEach((track)=>_addTrack.call(this, track, stream));
        };
        window.RTCPeerConnection.prototype.addTrack = function addTrack(track, ...streams) {
            if (streams) streams.forEach((stream)=>{
                if (!this._localStreams) this._localStreams = [
                    stream
                ];
                else if (!this._localStreams.includes(stream)) this._localStreams.push(stream);
            });
            return _addTrack.apply(this, arguments);
        };
    }
    if (!("removeStream" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.removeStream = function removeStream(stream) {
        if (!this._localStreams) this._localStreams = [];
        const index = this._localStreams.indexOf(stream);
        if (index === -1) return;
        this._localStreams.splice(index, 1);
        const tracks = stream.getTracks();
        this.getSenders().forEach((sender)=>{
            if (tracks.includes(sender.track)) this.removeTrack(sender);
        });
    };
}
function $9a20cef3f9b7f4b6$export$762aa4cbb4f2f857(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    if (!("getRemoteStreams" in window.RTCPeerConnection.prototype)) window.RTCPeerConnection.prototype.getRemoteStreams = function getRemoteStreams() {
        return this._remoteStreams ? this._remoteStreams : [];
    };
    if (!("onaddstream" in window.RTCPeerConnection.prototype)) {
        Object.defineProperty(window.RTCPeerConnection.prototype, "onaddstream", {
            get () {
                return this._onaddstream;
            },
            set (f) {
                if (this._onaddstream) {
                    this.removeEventListener("addstream", this._onaddstream);
                    this.removeEventListener("track", this._onaddstreampoly);
                }
                this.addEventListener("addstream", this._onaddstream = f);
                this.addEventListener("track", this._onaddstreampoly = (e)=>{
                    e.streams.forEach((stream)=>{
                        if (!this._remoteStreams) this._remoteStreams = [];
                        if (this._remoteStreams.includes(stream)) return;
                        this._remoteStreams.push(stream);
                        const event = new Event("addstream");
                        event.stream = stream;
                        this.dispatchEvent(event);
                    });
                });
            }
        });
        const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
        window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
            const pc = this;
            if (!this._onaddstreampoly) this.addEventListener("track", this._onaddstreampoly = function(e) {
                e.streams.forEach((stream)=>{
                    if (!pc._remoteStreams) pc._remoteStreams = [];
                    if (pc._remoteStreams.indexOf(stream) >= 0) return;
                    pc._remoteStreams.push(stream);
                    const event = new Event("addstream");
                    event.stream = stream;
                    pc.dispatchEvent(event);
                });
            });
            return origSetRemoteDescription.apply(pc, arguments);
        };
    }
}
function $9a20cef3f9b7f4b6$export$da31df245debdd3(window) {
    if (typeof window !== "object" || !window.RTCPeerConnection) return;
    const prototype = window.RTCPeerConnection.prototype;
    const origCreateOffer = prototype.createOffer;
    const origCreateAnswer = prototype.createAnswer;
    const setLocalDescription = prototype.setLocalDescription;
    const setRemoteDescription = prototype.setRemoteDescription;
    const addIceCandidate = prototype.addIceCandidate;
    prototype.createOffer = function createOffer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateOffer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.createAnswer = function createAnswer(successCallback, failureCallback) {
        const options = arguments.length >= 2 ? arguments[2] : arguments[0];
        const promise = origCreateAnswer.apply(this, [
            options
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    let withCallback = function(description, successCallback, failureCallback) {
        const promise = setLocalDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;
    withCallback = function(description, successCallback, failureCallback) {
        const promise = setRemoteDescription.apply(this, [
            description
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;
    withCallback = function(candidate, successCallback, failureCallback) {
        const promise = addIceCandidate.apply(this, [
            candidate
        ]);
        if (!failureCallback) return promise;
        promise.then(successCallback, failureCallback);
        return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
}
function $9a20cef3f9b7f4b6$export$1ed4910f4d37dc5e(window) {
    const navigator = window && window.navigator;
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        // shim not needed in Safari 12.1
        const mediaDevices = navigator.mediaDevices;
        const _getUserMedia = mediaDevices.getUserMedia.bind(mediaDevices);
        navigator.mediaDevices.getUserMedia = (constraints)=>{
            return _getUserMedia($9a20cef3f9b7f4b6$export$494a01ac68ba81ac(constraints));
        };
    }
    if (!navigator.getUserMedia && navigator.mediaDevices && navigator.mediaDevices.getUserMedia) navigator.getUserMedia = (function getUserMedia(constraints, cb, errcb) {
        navigator.mediaDevices.getUserMedia(constraints).then(cb, errcb);
    }).bind(navigator);
}
function $9a20cef3f9b7f4b6$export$494a01ac68ba81ac(constraints) {
    if (constraints && constraints.video !== undefined) return Object.assign({}, constraints, {
        video: $7zZv5.compactObject(constraints.video)
    });
    return constraints;
}
function $9a20cef3f9b7f4b6$export$671a8b47b41b6f41(window) {
    if (!window.RTCPeerConnection) return;
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    const OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function RTCPeerConnection(pcConfig, pcConstraints) {
        if (pcConfig && pcConfig.iceServers) {
            const newIceServers = [];
            for(let i = 0; i < pcConfig.iceServers.length; i++){
                let server = pcConfig.iceServers[i];
                if (!server.hasOwnProperty("urls") && server.hasOwnProperty("url")) {
                    $7zZv5.deprecated("RTCIceServer.url", "RTCIceServer.urls");
                    server = JSON.parse(JSON.stringify(server));
                    server.urls = server.url;
                    delete server.url;
                    newIceServers.push(server);
                } else newIceServers.push(pcConfig.iceServers[i]);
            }
            pcConfig.iceServers = newIceServers;
        }
        return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ("generateCertificate" in OrigPeerConnection) Object.defineProperty(window.RTCPeerConnection, "generateCertificate", {
        get () {
            return OrigPeerConnection.generateCertificate;
        }
    });
}
function $9a20cef3f9b7f4b6$export$85d53da088cb1b14(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === "object" && window.RTCTrackEvent && "receiver" in window.RTCTrackEvent.prototype && !("transceiver" in window.RTCTrackEvent.prototype)) Object.defineProperty(window.RTCTrackEvent.prototype, "transceiver", {
        get () {
            return {
                receiver: this.receiver
            };
        }
    });
}
function $9a20cef3f9b7f4b6$export$d444266503fdd2d4(window) {
    const origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function createOffer(offerOptions) {
        if (offerOptions) {
            if (typeof offerOptions.offerToReceiveAudio !== "undefined") // support bit values
            offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
            const audioTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "audio");
            if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
                if (audioTransceiver.direction === "sendrecv") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("sendonly");
                    else audioTransceiver.direction = "sendonly";
                } else if (audioTransceiver.direction === "recvonly") {
                    if (audioTransceiver.setDirection) audioTransceiver.setDirection("inactive");
                    else audioTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveAudio === true && !audioTransceiver) this.addTransceiver("audio");
            if (typeof offerOptions.offerToReceiveVideo !== "undefined") // support bit values
            offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
            const videoTransceiver = this.getTransceivers().find((transceiver)=>transceiver.receiver.track.kind === "video");
            if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
                if (videoTransceiver.direction === "sendrecv") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("sendonly");
                    else videoTransceiver.direction = "sendonly";
                } else if (videoTransceiver.direction === "recvonly") {
                    if (videoTransceiver.setDirection) videoTransceiver.setDirection("inactive");
                    else videoTransceiver.direction = "inactive";
                }
            } else if (offerOptions.offerToReceiveVideo === true && !videoTransceiver) this.addTransceiver("video");
        }
        return origCreateOffer.apply(this, arguments);
    };
}
function $9a20cef3f9b7f4b6$export$857cd739a7b795d2(window) {
    if (typeof window !== "object" || window.AudioContext) return;
    window.AudioContext = window.webkitAudioContext;
}

});

parcelRegister("7H1jZ", function(module, exports) {

$parcel$export(module.exports, "shimRTCIceCandidate", () => $599d92f2f0dc2dee$export$cf133661e444ccfe);
$parcel$export(module.exports, "shimMaxMessageSize", () => $599d92f2f0dc2dee$export$a99147c78a56edc4);
$parcel$export(module.exports, "shimSendThrowTypeError", () => $599d92f2f0dc2dee$export$d461c8d5c5db5da7);
$parcel$export(module.exports, "shimConnectionState", () => $599d92f2f0dc2dee$export$63bb816cc75460);
$parcel$export(module.exports, "removeExtmapAllowMixed", () => $599d92f2f0dc2dee$export$a57d114344295149);
$parcel$export(module.exports, "shimAddIceCandidateNullOrEmpty", () => $599d92f2f0dc2dee$export$51d5e40b48c771c7);
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */ /* eslint-env node */ 
var $a3uXU = parcelRequire("a3uXU");

var $7zZv5 = parcelRequire("7zZv5");
"use strict";
function $599d92f2f0dc2dee$export$cf133661e444ccfe(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || window.RTCIceCandidate && "foundation" in window.RTCIceCandidate.prototype) return;
    const NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function RTCIceCandidate(args) {
        // Remove the a= which shouldn't be part of the candidate string.
        if (typeof args === "object" && args.candidate && args.candidate.indexOf("a=") === 0) {
            args = JSON.parse(JSON.stringify(args));
            args.candidate = args.candidate.substr(2);
        }
        if (args.candidate && args.candidate.length) {
            // Augment the native candidate with the parsed fields.
            const nativeCandidate = new NativeRTCIceCandidate(args);
            const parsedCandidate = (0, (/*@__PURE__*/$parcel$interopDefault($a3uXU))).parseCandidate(args.candidate);
            const augmentedCandidate = Object.assign(nativeCandidate, parsedCandidate);
            // Add a serializer that does not serialize the extra attributes.
            augmentedCandidate.toJSON = function toJSON() {
                return {
                    candidate: augmentedCandidate.candidate,
                    sdpMid: augmentedCandidate.sdpMid,
                    sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
                    usernameFragment: augmentedCandidate.usernameFragment
                };
            };
            return augmentedCandidate;
        }
        return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;
    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    $7zZv5.wrapPeerConnectionEvent(window, "icecandidate", (e)=>{
        if (e.candidate) Object.defineProperty(e, "candidate", {
            value: new window.RTCIceCandidate(e.candidate),
            writable: "false"
        });
        return e;
    });
}
function $599d92f2f0dc2dee$export$a99147c78a56edc4(window, browserDetails) {
    if (!window.RTCPeerConnection) return;
    if (!("sctp" in window.RTCPeerConnection.prototype)) Object.defineProperty(window.RTCPeerConnection.prototype, "sctp", {
        get () {
            return typeof this._sctp === "undefined" ? null : this._sctp;
        }
    });
    const sctpInDescription = function(description) {
        if (!description || !description.sdp) return false;
        const sections = (0, (/*@__PURE__*/$parcel$interopDefault($a3uXU))).splitSections(description.sdp);
        sections.shift();
        return sections.some((mediaSection)=>{
            const mLine = (0, (/*@__PURE__*/$parcel$interopDefault($a3uXU))).parseMLine(mediaSection);
            return mLine && mLine.kind === "application" && mLine.protocol.indexOf("SCTP") !== -1;
        });
    };
    const getRemoteFirefoxVersion = function(description) {
        // TODO: Is there a better solution for detecting Firefox?
        const match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
        if (match === null || match.length < 2) return -1;
        const version = parseInt(match[1], 10);
        // Test for NaN (yes, this is ugly)
        return version !== version ? -1 : version;
    };
    const getCanSendMaxMessageSize = function(remoteIsFirefox) {
        // Every implementation we know can send at least 64 KiB.
        // Note: Although Chrome is technically able to send up to 256 KiB, the
        //       data does not reach the other peer reliably.
        //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
        let canSendMaxMessageSize = 65536;
        if (browserDetails.browser === "firefox") {
            if (browserDetails.version < 57) {
                if (remoteIsFirefox === -1) // FF < 57 will send in 16 KiB chunks using the deprecated PPID
                // fragmentation.
                canSendMaxMessageSize = 16384;
                else // However, other FF (and RAWRTC) can reassemble PPID-fragmented
                // messages. Thus, supporting ~2 GiB when sending.
                canSendMaxMessageSize = 2147483637;
            } else if (browserDetails.version < 60) // Currently, all FF >= 57 will reset the remote maximum message size
            // to the default value when a data channel is created at a later
            // stage. :(
            // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
            canSendMaxMessageSize = browserDetails.version === 57 ? 65535 : 65536;
            else // FF >= 60 supports sending ~2 GiB
            canSendMaxMessageSize = 2147483637;
        }
        return canSendMaxMessageSize;
    };
    const getMaxMessageSize = function(description, remoteIsFirefox) {
        // Note: 65536 bytes is the default value from the SDP spec. Also,
        //       every implementation we know supports receiving 65536 bytes.
        let maxMessageSize = 65536;
        // FF 57 has a slightly incorrect default remote max message size, so
        // we need to adjust it here to avoid a failure when sending.
        // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
        if (browserDetails.browser === "firefox" && browserDetails.version === 57) maxMessageSize = 65535;
        const match = (0, (/*@__PURE__*/$parcel$interopDefault($a3uXU))).matchPrefix(description.sdp, "a=max-message-size:");
        if (match.length > 0) maxMessageSize = parseInt(match[0].substr(19), 10);
        else if (browserDetails.browser === "firefox" && remoteIsFirefox !== -1) // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
        return maxMessageSize;
    };
    const origSetRemoteDescription = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription() {
        this._sctp = null;
        // Chrome decided to not expose .sctp in plan-b mode.
        // As usual, adapter.js has to do an 'ugly worakaround'
        // to cover up the mess.
        if (browserDetails.browser === "chrome" && browserDetails.version >= 76) {
            const { sdpSemantics: sdpSemantics } = this.getConfiguration();
            if (sdpSemantics === "plan-b") Object.defineProperty(this, "sctp", {
                get () {
                    return typeof this._sctp === "undefined" ? null : this._sctp;
                },
                enumerable: true,
                configurable: true
            });
        }
        if (sctpInDescription(arguments[0])) {
            // Check if the remote is FF.
            const isFirefox = getRemoteFirefoxVersion(arguments[0]);
            // Get the maximum message size the local peer is capable of sending
            const canSendMMS = getCanSendMaxMessageSize(isFirefox);
            // Get the maximum message size of the remote peer.
            const remoteMMS = getMaxMessageSize(arguments[0], isFirefox);
            // Determine final maximum message size
            let maxMessageSize;
            if (canSendMMS === 0 && remoteMMS === 0) maxMessageSize = Number.POSITIVE_INFINITY;
            else if (canSendMMS === 0 || remoteMMS === 0) maxMessageSize = Math.max(canSendMMS, remoteMMS);
            else maxMessageSize = Math.min(canSendMMS, remoteMMS);
            // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
            // attribute.
            const sctp = {};
            Object.defineProperty(sctp, "maxMessageSize", {
                get () {
                    return maxMessageSize;
                }
            });
            this._sctp = sctp;
        }
        return origSetRemoteDescription.apply(this, arguments);
    };
}
function $599d92f2f0dc2dee$export$d461c8d5c5db5da7(window) {
    if (!(window.RTCPeerConnection && "createDataChannel" in window.RTCPeerConnection.prototype)) return;
    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
    function wrapDcSend(dc, pc) {
        const origDataChannelSend = dc.send;
        dc.send = function send() {
            const data = arguments[0];
            const length = data.length || data.size || data.byteLength;
            if (dc.readyState === "open" && pc.sctp && length > pc.sctp.maxMessageSize) throw new TypeError("Message too large (can send a maximum of " + pc.sctp.maxMessageSize + " bytes)");
            return origDataChannelSend.apply(dc, arguments);
        };
    }
    const origCreateDataChannel = window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function createDataChannel() {
        const dataChannel = origCreateDataChannel.apply(this, arguments);
        wrapDcSend(dataChannel, this);
        return dataChannel;
    };
    $7zZv5.wrapPeerConnectionEvent(window, "datachannel", (e)=>{
        wrapDcSend(e.channel, e.target);
        return e;
    });
}
function $599d92f2f0dc2dee$export$63bb816cc75460(window) {
    if (!window.RTCPeerConnection || "connectionState" in window.RTCPeerConnection.prototype) return;
    const proto = window.RTCPeerConnection.prototype;
    Object.defineProperty(proto, "connectionState", {
        get () {
            return ({
                completed: "connected",
                checking: "connecting"
            })[this.iceConnectionState] || this.iceConnectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(proto, "onconnectionstatechange", {
        get () {
            return this._onconnectionstatechange || null;
        },
        set (cb) {
            if (this._onconnectionstatechange) {
                this.removeEventListener("connectionstatechange", this._onconnectionstatechange);
                delete this._onconnectionstatechange;
            }
            if (cb) this.addEventListener("connectionstatechange", this._onconnectionstatechange = cb);
        },
        enumerable: true,
        configurable: true
    });
    [
        "setLocalDescription",
        "setRemoteDescription"
    ].forEach((method)=>{
        const origMethod = proto[method];
        proto[method] = function() {
            if (!this._connectionstatechangepoly) {
                this._connectionstatechangepoly = (e)=>{
                    const pc = e.target;
                    if (pc._lastConnectionState !== pc.connectionState) {
                        pc._lastConnectionState = pc.connectionState;
                        const newEvent = new Event("connectionstatechange", e);
                        pc.dispatchEvent(newEvent);
                    }
                    return e;
                };
                this.addEventListener("iceconnectionstatechange", this._connectionstatechangepoly);
            }
            return origMethod.apply(this, arguments);
        };
    });
}
function $599d92f2f0dc2dee$export$a57d114344295149(window, browserDetails) {
    /* remove a=extmap-allow-mixed for webrtc.org < M71 */ if (!window.RTCPeerConnection) return;
    if (browserDetails.browser === "chrome" && browserDetails.version >= 71) return;
    if (browserDetails.browser === "safari" && browserDetails.version >= 605) return;
    const nativeSRD = window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function setRemoteDescription(desc) {
        if (desc && desc.sdp && desc.sdp.indexOf("\na=extmap-allow-mixed") !== -1) {
            const sdp = desc.sdp.split("\n").filter((line)=>{
                return line.trim() !== "a=extmap-allow-mixed";
            }).join("\n");
            // Safari enforces read-only-ness of RTCSessionDescription fields.
            if (window.RTCSessionDescription && desc instanceof window.RTCSessionDescription) arguments[0] = new window.RTCSessionDescription({
                type: desc.type,
                sdp: sdp
            });
            else desc.sdp = sdp;
        }
        return nativeSRD.apply(this, arguments);
    };
}
function $599d92f2f0dc2dee$export$51d5e40b48c771c7(window, browserDetails) {
    // Support for addIceCandidate(null or undefined)
    // as well as addIceCandidate({candidate: "", ...})
    // https://bugs.chromium.org/p/chromium/issues/detail?id=978582
    // Note: must be called before other polyfills which change the signature.
    if (!(window.RTCPeerConnection && window.RTCPeerConnection.prototype)) return;
    const nativeAddIceCandidate = window.RTCPeerConnection.prototype.addIceCandidate;
    if (!nativeAddIceCandidate || nativeAddIceCandidate.length === 0) return;
    window.RTCPeerConnection.prototype.addIceCandidate = function addIceCandidate() {
        if (!arguments[0]) {
            if (arguments[1]) arguments[1].apply(null);
            return Promise.resolve();
        }
        // Firefox 68+ emits and processes {candidate: "", ...}, ignore
        // in older versions.
        // Native support for ignoring exists for Chrome M77+.
        // Safari ignores as well, exact version unknown but works in the same
        // version that also ignores addIceCandidate(null).
        if ((browserDetails.browser === "chrome" && browserDetails.version < 78 || browserDetails.browser === "firefox" && browserDetails.version < 68 || browserDetails.browser === "safari") && arguments[0] && arguments[0].candidate === "") return Promise.resolve();
        return nativeAddIceCandidate.apply(this, arguments);
    };
}

});



parcelRegister("chAV5", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"name":"promote-frontend","version":"2.8.0","description":"Frontend for the Promote App","author":"Retail Commerce Foundation","license":"ISC","repository":{"type":"https","url":"https://github.com/nike-retail-commerce-foundation/rcf-promote-frontend"},"scripts":{"start:athlete":"PORT=1234 parcel index.html","start:test":"NODE_ENV=test parcel index.html","start:prod":"NODE_ENV=production parcel index.html","lint":"eslint-output --max-warnings 5 --color .","build":"parcel build --dist-dir dist_p index.html","build:test":"NODE_ENV=test parcel build index.html","jest":"TZ=UTC jest --coverage --passWithNoTests","test":"npm run lint && npm run jest","viewcoverage":"open reports/coverage/index.html","preinstall":"npx npm-force-resolutions"},"dependencies":{"@babel/runtime":"^7.23.2","@emotion/core":"10.0.27","@emotion/styled":"10.0.27","@emotion/styled-base":"10.0.27","@nike/frame-component-library":"^5.4.9","@nike/nike-design-system-components":"^0.11.13","@nike/nike-design-system-icons":"^0.3.21","@nike/rcf-fp":"^0.5.0","@reduxjs/toolkit":"^1.9.7","@zxing/library":"^0.21.1","clsx":"^1.2.1","emotion-theming":"10.0.27","i18n-iso-countries":"^6.8.0","intersection-observer":"^0.10.0","locale-code":"^2.0.2","lodash":"^4.17.21","moment":"^2.30.1","moment-timezone":"^0.5.45","numeral":"^2.0.6","papaparse":"^5.4.1","parcel":"^2.10.0","prop-types":"^15.8.1","rcffus-sps-translations":"^1.10.0","react":"^17.0.1","react-csv-downloader":"^3.1.0","react-dom":"^17.0.1","react-intersection-observer":"^8.34.0","react-redux":"^7.2.9","react-router-dom":"^5.3.4","react-select":"^3.2.0","webrtc-adapter":"^7.7.1"},"devDependencies":{"@babel/cli":"^7.23.0","@babel/core":"^7.24.9","@babel/plugin-proposal-nullish-coalescing-operator":"^7.18.6","@babel/plugin-proposal-optional-chaining":"^7.21.0","@babel/plugin-proposal-private-methods":"^7.18.6","@babel/plugin-syntax-bigint":"^7.8.3","@babel/plugin-syntax-typescript":"^7.24.7","@babel/preset-env":"^7.23.2","@babel/preset-react":"^7.22.15","@nike/eslint-config-rcf":"^0.6.0","@testing-library/jest-dom":"^5.17.0","@testing-library/react":"^12.1.5","babel-preset-nano-react-app":"^0.1.0","buffer":"^6.0.3","eslint":"^7.32.0","eslint-output":"^2.0.4","jest":"^29.7.0","jest-environment-jsdom":"^29.7.0","jest-junit":"^13.2.0","jest-stare":"^2.5.1","process":"^0.11.10"},"resolutions":{"node-forge":"0.10.0"}}');

});


parcelRegister("52kTc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3aad57d9c7ba581b$export$1e511d4a378977f5, (v) => $3aad57d9c7ba581b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3aad57d9c7ba581b$export$2e2bcd8739ae039, (v) => $3aad57d9c7ba581b$export$2e2bcd8739ae039 = v);
var $3aad57d9c7ba581b$export$1e511d4a378977f5;
var $3aad57d9c7ba581b$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$3aad57d9c7ba581b$export$1e511d4a378977f5 = true;
$3aad57d9c7ba581b$export$2e2bcd8739ae039 = void 0;

var $3aad57d9c7ba581b$var$_react = $3aad57d9c7ba581b$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $kfZjc = parcelRequire("kfZjc");

var $3aad57d9c7ba581b$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $3aad57d9c7ba581b$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $bEk1s = parcelRequire("bEk1s");

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $ikfii = parcelRequire("ikfii");

var $3aad57d9c7ba581b$var$_PromotionDetail = $1jnue((parcelRequire("kbC8s")));

var $3aad57d9c7ba581b$var$_PromotionHome = $1jnue((parcelRequire("4EphB")));
function $3aad57d9c7ba581b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3aad57d9c7ba581b$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $3aad57d9c7ba581b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $3aad57d9c7ba581b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
/* eslint-disable import/named */ const $3aad57d9c7ba581b$var$Promotions = ()=>{
    const [activePromotion, setActivePromotion] = (0, $3aad57d9c7ba581b$var$_react.useState)("");
    const [clearError, setClearError] = (0, $3aad57d9c7ba581b$var$_react.useState)("");
    const [clearSuccess, setClearSuccess] = (0, $3aad57d9c7ba581b$var$_react.useState)("");
    const [isFetching, setIsFetching] = (0, $3aad57d9c7ba581b$var$_react.useState)(true);
    const [promotions, setPromotions] = (0, $3aad57d9c7ba581b$var$_react.useState)([]);
    const [error, setError] = (0, $3aad57d9c7ba581b$var$_react.useState)("");
    const location = (0, $kfZjc.useLocation)();
    const translate = (0, $3aad57d9c7ba581b$var$_useTranslate.default)();
    // check if create promotion is enabled
    const isCreatePromotionEnabled = (0, $iD0SF.useSelector)($bEk1s.getIsCreatePromotionEnabled);
    (0, $3aad57d9c7ba581b$var$_react.useEffect)(()=>{
        if (!$3aad57d9c7ba581b$var$_Auth.default.isAuthenticated()) (async ()=>$3aad57d9c7ba581b$var$_Auth.default.reAuthorize().then(()=>true).catch(()=>false))();
        // getPromotions (refresh the promotions) every time we set isFetching to true or we come back to the home page
        if (isFetching || !location.pathname.startsWith("/promotions/")) (async (_location$state)=>(0, $ilYXe.getPromotions)((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.storeId).then(({ objects: objects })=>!objects.length ? (0, $6zLPD.handleResponse)(setPromotions, [], setError, translate("RL_PromotionValidation1")) : (0, $6zLPD.handleResponse)(setPromotions, (0, $6zLPD.formatPromotions)(objects), setError, "")).catch((err)=>(0, $6zLPD.handleResponse)(setPromotions, [], setError, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>setIsFetching(false)))();
    }, [
        isFetching,
        location,
        translate
    ]);
    return /*#__PURE__*/ $3aad57d9c7ba581b$var$_react.default.createElement($3aad57d9c7ba581b$var$_react.default.Fragment, null, /*#__PURE__*/ $3aad57d9c7ba581b$var$_react.default.createElement("h1", {
        className: "display-3 text-color-accent mb3-sm"
    }, translate("RL_Promotions")), /*#__PURE__*/ $3aad57d9c7ba581b$var$_react.default.createElement($3aad57d9c7ba581b$var$_react.default.Fragment, null, /*#__PURE__*/ $3aad57d9c7ba581b$var$_react.default.createElement($ikfii.Messages, {
        className: "pb2-sm",
        error: clearError,
        success: clearSuccess
    }), /*#__PURE__*/ $3aad57d9c7ba581b$var$_react.default.createElement($ikfii.ContentLoads, {
        error: error,
        isLoading: isFetching
    }, location.pathname.startsWith("/promotions/") ? /*#__PURE__*/ $3aad57d9c7ba581b$var$_react.default.createElement($3aad57d9c7ba581b$var$_PromotionDetail.default, {
        canAdd: $3aad57d9c7ba581b$var$_Auth.default.requiresRole40($3aad57d9c7ba581b$var$_Auth.default.getAuth()),
        canEdit: $3aad57d9c7ba581b$var$_Auth.default.requiresRole40($3aad57d9c7ba581b$var$_Auth.default.getAuth()),
        promotion: promotions.find((p)=>p.id === activePromotion)
    }) : /*#__PURE__*/ $3aad57d9c7ba581b$var$_react.default.createElement($3aad57d9c7ba581b$var$_PromotionHome.default, {
        canCreate: $3aad57d9c7ba581b$var$_Auth.default.requiresRole40($3aad57d9c7ba581b$var$_Auth.default.getAuth()) && isCreatePromotionEnabled,
        promotions: promotions,
        refreshPromotions: ()=>setIsFetching(true),
        setActivePromotion: setActivePromotion,
        setClearError: setClearError,
        setClearSuccess: setClearSuccess
    }))));
};
var $3aad57d9c7ba581b$var$_default = $3aad57d9c7ba581b$export$2e2bcd8739ae039 = $3aad57d9c7ba581b$var$Promotions;

});
parcelRegister("kbC8s", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $eb226aa175c55ffe$export$1e511d4a378977f5, (v) => $eb226aa175c55ffe$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $eb226aa175c55ffe$export$2e2bcd8739ae039, (v) => $eb226aa175c55ffe$export$2e2bcd8739ae039 = v);
var $eb226aa175c55ffe$export$1e511d4a378977f5;
var $eb226aa175c55ffe$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$eb226aa175c55ffe$export$1e511d4a378977f5 = true;
$eb226aa175c55ffe$export$2e2bcd8739ae039 = void 0;

var $CMhXv = parcelRequire("CMhXv");
var $8EAGh = parcelRequire("8EAGh");

var $eb226aa175c55ffe$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $eb226aa175c55ffe$var$_react = $eb226aa175c55ffe$var$_interopRequireWildcard((parcelRequire("acw62")));

var $kfZjc = parcelRequire("kfZjc");

var $7Yi7V = parcelRequire("7Yi7V");

var $eb226aa175c55ffe$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $ikfii = parcelRequire("ikfii");

var $eb226aa175c55ffe$var$_ProductsForm = $1jnue((parcelRequire("8gaqL")));

var $eb226aa175c55ffe$var$_ProductsScan = $1jnue((parcelRequire("5sxtX")));

var $eb226aa175c55ffe$var$_PromotionEdit = $1jnue((parcelRequire("9pYKL")));
function $eb226aa175c55ffe$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($eb226aa175c55ffe$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $eb226aa175c55ffe$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $eb226aa175c55ffe$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $eb226aa175c55ffe$var$PromotionDetail = ({ canAdd: canAdd, canEdit: canEdit, promotion: propPromotion })=>{
    const [isAdding, setIsAdding] = (0, $eb226aa175c55ffe$var$_react.useState)(false);
    const [promotion, setPromotion] = (0, $eb226aa175c55ffe$var$_react.useState)({
        ...propPromotion
    });
    const [isFetching, setIsFetching] = (0, $eb226aa175c55ffe$var$_react.useState)(false);
    const [error, setError] = (0, $eb226aa175c55ffe$var$_react.useState)("");
    const [errorUpdate, setErrorUpdate] = (0, $eb226aa175c55ffe$var$_react.useState)("");
    const [successUpdate, setSuccessUpdate] = (0, $eb226aa175c55ffe$var$_react.useState)("");
    const [isEditing, setIsEditing] = (0, $eb226aa175c55ffe$var$_react.useState)(false);
    const [isScanning, setIsScanning] = (0, $eb226aa175c55ffe$var$_react.useState)(false);
    const translate = (0, $eb226aa175c55ffe$var$_useTranslate.default)();
    (0, $eb226aa175c55ffe$var$_react.useEffect)(()=>{
        // getPromotion (refresh the promotions) every time we set isFetching to true
        if (isFetching && propPromotion) (async ()=>(0, $ilYXe.getPromotion)(propPromotion.id).then((res)=>(0, $6zLPD.handleResponse)(setPromotion, (0, $6zLPD.formatPromotions)([
                    res
                ])[0], setError, "")).catch((err)=>(0, $6zLPD.handleResponse)(()=>{}, undefined, setError, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>setIsFetching(false)))();
    }, [
        isFetching,
        propPromotion
    ]);
    const toggleAddProductsPage = async ()=>{
        isAdding && setIsFetching(true);
        return setIsAdding((wasAdding)=>!wasAdding);
    };
    const toggleEditPromotionPage = async ()=>{
        isEditing && setIsFetching(true);
        return setIsEditing((wasEditing)=>!wasEditing);
    };
    const promotionId = (0, $eb226aa175c55ffe$var$_react.useMemo)(()=>{
        const { status: status, gppsPromotionId: gppsPromotionId, discountPercentage: discountPercentage } = promotion;
        if (status === "PENDING_SYNC" && gppsPromotionId !== "NOT_CREATED") return /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("span", {
            className: "text-color-accent"
        }, translate("RL_PendingSync"));
        else if (!status || discountPercentage === 0 || status === "NO_ITEMS") return /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("span", {
            className: "text-color-accent"
        }, translate("RL_PausedPromotion"));
        return gppsPromotionId;
    }, [
        promotion,
        translate
    ]);
    // eslint-disable-next-line no-nested-ternary
    return propPromotion ? /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($eb226aa175c55ffe$var$_react.default.Fragment, null, isEditing && /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($eb226aa175c55ffe$var$_PromotionEdit.default, {
        patchPromotion: $ilYXe.patchPromotion,
        promotion: promotion,
        onClose: async ()=>{
            await toggleEditPromotionPage();
            (0, $6zLPD.handleResponse)(setSuccessUpdate, "", setErrorUpdate, "");
            setIsScanning(false);
            setIsEditing(false);
        }
    }), isScanning && /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($eb226aa175c55ffe$var$_ProductsScan.default, {
        patchPromotion: $ilYXe.patchPromotion,
        promotion: promotion,
        setIsFetching: setIsFetching,
        onClose: async ()=>{
            await toggleAddProductsPage();
            (0, $6zLPD.handleResponse)(setSuccessUpdate, "", setErrorUpdate, "");
            setIsScanning(false);
            setIsEditing(false);
        }
    }), !isEditing && !isScanning && /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($eb226aa175c55ffe$var$_react.default.Fragment, null, /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("article", {
        className: "ncss-row"
    }, /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("section", {
        className: "ncss-col-sm-8"
    }, /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($ikfii.Back, {
        label: translate("RL_BackToPromotions"),
        link: "/promotions"
    })), canAdd && /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("section", {
        className: "ncss-col-sm-4"
    }, /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("section", {
        className: "d-sm-flx flx-jc-sm-fe"
    }, canEdit && /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($ikfii.Button, {
        icon: /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($CMhXv.Edit, {
            style: {
                margin: "0.27rem -1.5rem"
            },
            title: translate("RL_EditPromotion")
        }),
        sectionClassName: "pr1-sm",
        onClick: async ()=>{
            await toggleEditPromotionPage();
        }
    }), /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($ikfii.Button, {
        icon: /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($8EAGh.Scan, {
            style: {
                margin: "0.27rem -1.5rem"
            },
            title: translate("RL_ScanBarcode")
        }),
        isDisabled: isFetching,
        onClick: async ()=>{
            await toggleAddProductsPage();
            setIsScanning((wasScanning)=>!wasScanning);
        }
    })))), /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("h2", {
        className: "headline-1 text-color-accent mt6-sm mb3-sm",
        style: {
            overflowWrap: "anywhere"
        }
    }, promotion.name), /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("h5", {
        className: "headline-5 mt3-sm"
    }, translate("RL_PromotionID"), ": ", promotionId), /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("h3", {
        className: "headline-4 mt3-sm"
    }, `${translate("RL_Discount")}: ${promotion.discountPercentage}%`), /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement("h3", {
        className: "headline-4 mt2-sm mb2-sm"
    }, !$7Yi7V.defaultPromotions.includes(promotion.name) ? `${translate("RL_Ends")}: ${promotion.endDate}` : ""), /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($ikfii.ContentLoads, {
        error: error,
        isLoading: isFetching
    }, /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($ikfii.Messages, {
        error: errorUpdate,
        success: successUpdate
    }), canAdd && /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($ikfii.ButtonAdd, {
        isAdding: isAdding,
        onToggle: toggleAddProductsPage
    }), isAdding || isScanning ? /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($eb226aa175c55ffe$var$_ProductsForm.default, {
        patchPromotion: $ilYXe.patchPromotion,
        promotion: promotion
    }) : /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($ikfii.ProductsDisplay, {
        canDelete: canEdit,
        products: promotion.itemDetails || [],
        promotion: promotion,
        setProducts: (itemDetails)=>setPromotion((prevPromotion)=>({
                    ...prevPromotion,
                    itemDetails: itemDetails
                })),
        title: translate("RL_Products")
    })))) : /*#__PURE__*/ $eb226aa175c55ffe$var$_react.default.createElement($kfZjc.Redirect, {
        to: "/promotions"
    });
};
$eb226aa175c55ffe$var$PromotionDetail.defaultProps = {
    promotion: undefined
};
$eb226aa175c55ffe$var$PromotionDetail.propTypes = {
    canAdd: $eb226aa175c55ffe$var$_propTypes.default.bool.isRequired,
    canEdit: $eb226aa175c55ffe$var$_propTypes.default.bool.isRequired,
    promotion: $eb226aa175c55ffe$var$_propTypes.default.shape({
        discountPercentage: $eb226aa175c55ffe$var$_propTypes.default.number.isRequired,
        divisions: $eb226aa175c55ffe$var$_propTypes.default.shape().isRequired,
        endDate: $eb226aa175c55ffe$var$_propTypes.default.string.isRequired,
        endDateTime: $eb226aa175c55ffe$var$_propTypes.default.string.isRequired,
        genders: $eb226aa175c55ffe$var$_propTypes.default.shape().isRequired,
        gppsPromotionId: $eb226aa175c55ffe$var$_propTypes.default.oneOfType([
            $eb226aa175c55ffe$var$_propTypes.default.number,
            $eb226aa175c55ffe$var$_propTypes.default.string
        ]).isRequired,
        id: $eb226aa175c55ffe$var$_propTypes.default.string.isRequired,
        itemDetails: $eb226aa175c55ffe$var$_propTypes.default.arrayOf($eb226aa175c55ffe$var$_propTypes.default.shape({
            gtin: $eb226aa175c55ffe$var$_propTypes.default.string,
            name: $eb226aa175c55ffe$var$_propTypes.default.string,
            productId: $eb226aa175c55ffe$var$_propTypes.default.string,
            styleColor: $eb226aa175c55ffe$var$_propTypes.default.string
        })),
        name: $eb226aa175c55ffe$var$_propTypes.default.string.isRequired,
        startDate: $eb226aa175c55ffe$var$_propTypes.default.string.isRequired,
        status: $eb226aa175c55ffe$var$_propTypes.default.string.isRequired
    })
};
var $eb226aa175c55ffe$var$_default = $eb226aa175c55ffe$export$2e2bcd8739ae039 = $eb226aa175c55ffe$var$PromotionDetail;

});
parcelRegister("CMhXv", function(module, exports) {

$parcel$export(module.exports, "Edit", () => $074901d89cadc9b8$export$6ed0965c9443aaa6);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $074901d89cadc9b8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $074901d89cadc9b8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $074901d89cadc9b8$var$_typeof(o);
}
function $074901d89cadc9b8$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $074901d89cadc9b8$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $074901d89cadc9b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $074901d89cadc9b8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $074901d89cadc9b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $074901d89cadc9b8$var$_defineProperty(obj, key, value) {
    key = $074901d89cadc9b8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $074901d89cadc9b8$var$_toPropertyKey(t) {
    var i = $074901d89cadc9b8$var$_toPrimitive(t, "string");
    return "symbol" == $074901d89cadc9b8$var$_typeof(i) ? i : String(i);
}
function $074901d89cadc9b8$var$_toPrimitive(t, r) {
    if ("object" != $074901d89cadc9b8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $074901d89cadc9b8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $074901d89cadc9b8$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M13.5 8l2.5 2.5M8.357 18H6v-2.357L15.643 6 18 8.357 8.357 18z"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M15.02 6.56l2.63 2.63M6.94 20.25H3.76v-3.18L16.77 4.06l3.18 3.18L6.94 20.25z"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M30.04 13.12l5.26 5.26M13.88 40.5H7.52v-6.36L33.54 8.12l6.36 6.36L13.88 40.5z"
    }))
};
var $074901d89cadc9b8$export$6ed0965c9443aaa6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $074901d89cadc9b8$var$_objectSpread($074901d89cadc9b8$var$_objectSpread({}, props), {}, {
        paths: $074901d89cadc9b8$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("8EAGh", function(module, exports) {

$parcel$export(module.exports, "Scan", () => $64ce83392cc91554$export$f2b7c70641756fd4);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $64ce83392cc91554$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $64ce83392cc91554$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $64ce83392cc91554$var$_typeof(o);
}
function $64ce83392cc91554$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $64ce83392cc91554$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $64ce83392cc91554$var$ownKeys(Object(t), !0).forEach(function(r) {
            $64ce83392cc91554$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $64ce83392cc91554$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $64ce83392cc91554$var$_defineProperty(obj, key, value) {
    key = $64ce83392cc91554$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $64ce83392cc91554$var$_toPropertyKey(t) {
    var i = $64ce83392cc91554$var$_toPrimitive(t, "string");
    return "symbol" == $64ce83392cc91554$var$_typeof(i) ? i : String(i);
}
function $64ce83392cc91554$var$_toPrimitive(t, r) {
    if ("object" != $64ce83392cc91554$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $64ce83392cc91554$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $64ce83392cc91554$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M2.25 18v1.75a2 2 0 002 2H6m12 0h1.75a2 2 0 002-2V18m0-12V4.25a2 2 0 00-2-2H18m-12 0H4.25a2 2 0 00-2 2V6m11.5 0v12m-7-12v12m10.5-12v12m-7-12v12"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M2.25 18v1.75a2 2 0 002 2H6m12 0h1.75a2 2 0 002-2V18m0-12V4.25a2 2 0 00-2-2H18m-12 0H4.25a2 2 0 00-2 2V6m11.5 0v12m-7-12v12m10.5-12v12m-7-12v12"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M4.5 36v3.5a4 4 0 004 4H12m24 0h3.5a4 4 0 004-4V36m0-24V8.5a4 4 0 00-4-4H36m-24 0H8.5a4 4 0 00-4 4V12m23 0v24m-14-24v24m21-24v24m-14-24v24"
    }))
};
var $64ce83392cc91554$export$f2b7c70641756fd4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $64ce83392cc91554$var$_objectSpread($64ce83392cc91554$var$_objectSpread({}, props), {}, {
        paths: $64ce83392cc91554$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("8gaqL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $6037e8a98f3f2d1f$export$1e511d4a378977f5, (v) => $6037e8a98f3f2d1f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $6037e8a98f3f2d1f$export$2e2bcd8739ae039, (v) => $6037e8a98f3f2d1f$export$2e2bcd8739ae039 = v);
var $6037e8a98f3f2d1f$export$1e511d4a378977f5;
var $6037e8a98f3f2d1f$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$6037e8a98f3f2d1f$export$1e511d4a378977f5 = true;
$6037e8a98f3f2d1f$export$2e2bcd8739ae039 = void 0;

var $6037e8a98f3f2d1f$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $6037e8a98f3f2d1f$var$_react = $6037e8a98f3f2d1f$var$_interopRequireWildcard((parcelRequire("acw62")));

var $6037e8a98f3f2d1f$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $6zLPD = parcelRequire("6zLPD");

var $ikfii = parcelRequire("ikfii");
function $6037e8a98f3f2d1f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6037e8a98f3f2d1f$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6037e8a98f3f2d1f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6037e8a98f3f2d1f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $6037e8a98f3f2d1f$var$ProductsAdd = ({ promotion: promotion, patchPromotion: patchPromotion })=>{
    const [styleColors, setStyleColors] = (0, $6037e8a98f3f2d1f$var$_react.useState)([]);
    const [submitDisabled, setSubmitDisabled] = (0, $6037e8a98f3f2d1f$var$_react.useState)(true);
    const [isSubmitting, setIsSubmitting] = (0, $6037e8a98f3f2d1f$var$_react.useState)(false);
    const [success, setSuccess] = (0, $6037e8a98f3f2d1f$var$_react.useState)("");
    const [error, setError] = (0, $6037e8a98f3f2d1f$var$_react.useState)("");
    const translate = (0, $6037e8a98f3f2d1f$var$_useTranslate.default)();
    const setStyleColorsWithCreateDate = (values)=>setStyleColors(values === null || values === void 0 ? void 0 : values.map((x)=>x.date ? x : {
                ...x,
                date: new Date().toISOString()
            }));
    (0, $6037e8a98f3f2d1f$var$_react.useEffect)(()=>{
        const isFormComplete = styleColors === null || styleColors === void 0 ? void 0 : styleColors.length;
        setError("");
        setSubmitDisabled(!isFormComplete);
        setSuccess("");
    }, [
        styleColors
    ]);
    const onSubmit = ()=>{
        setIsSubmitting(true);
        const newItems = styleColors.map(({ value: value, date: date })=>({
                createDateTime: date,
                styleColor: value.toUpperCase()
            }));
        (async ()=>patchPromotion(promotion.id, {
                updates: (0, $6zLPD.formatPromotionPatchAddItems)(newItems),
                ...(0, $6zLPD.formatStoreInfo)()
            }).then((res)=>{
                var _res$errors;
                if ((_res$errors = res.errors) !== null && _res$errors !== void 0 && _res$errors.length) {
                    const { errorMessage: errorMessage, successMessage: successMessage } = (0, $6zLPD.handleErrorMessage)(res, newItems.map((item)=>item.styleColor));
                    return (0, $6zLPD.handleResponse)(setSuccess, successMessage, setError, errorMessage);
                }
                return (0, $6zLPD.handleResponse)(setSuccess, translate("RL_ProductsAddSuccess"), setError, "");
            }).catch((err)=>(0, $6zLPD.handleResponse)(setSuccess, "", setError, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>{
                window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
                setIsSubmitting(false);
            }))();
    };
    return /*#__PURE__*/ $6037e8a98f3f2d1f$var$_react.default.createElement($6037e8a98f3f2d1f$var$_react.default.Fragment, null, /*#__PURE__*/ $6037e8a98f3f2d1f$var$_react.default.createElement("section", {
        className: "ncss-col-sm-10 ta-sm-l mt3-sm mb3-sm"
    }, /*#__PURE__*/ $6037e8a98f3f2d1f$var$_react.default.createElement($ikfii.Creatable, {
        isMulti: true,
        isRequired: true,
        id: "styleColor",
        isDisabled: isSubmitting,
        label: translate("RL_StyleColors"),
        maxValues: 50,
        value: styleColors,
        onChange: setStyleColorsWithCreateDate
    })), /*#__PURE__*/ $6037e8a98f3f2d1f$var$_react.default.createElement($ikfii.ButtonSubmit, {
        isDisabled: submitDisabled,
        isSubmitting: isSubmitting,
        label: translate((styleColors === null || styleColors === void 0 ? void 0 : styleColors.length) !== 1 ? "RL_Add2Products" : "RL_Add1Product", (styleColors === null || styleColors === void 0 ? void 0 : styleColors.length) || 0),
        messageError: error,
        messageSuccess: success,
        onSubmit: onSubmit
    }));
};
$6037e8a98f3f2d1f$var$ProductsAdd.propTypes = {
    patchPromotion: $6037e8a98f3f2d1f$var$_propTypes.default.func.isRequired,
    promotion: $6037e8a98f3f2d1f$var$_propTypes.default.shape().isRequired
};
var $6037e8a98f3f2d1f$var$_default = $6037e8a98f3f2d1f$export$2e2bcd8739ae039 = $6037e8a98f3f2d1f$var$ProductsAdd;

});

parcelRegister("5sxtX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3f998a28c3e0c971$export$1e511d4a378977f5, (v) => $3f998a28c3e0c971$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3f998a28c3e0c971$export$2e2bcd8739ae039, (v) => $3f998a28c3e0c971$export$2e2bcd8739ae039 = v);
var $3f998a28c3e0c971$export$1e511d4a378977f5;
var $3f998a28c3e0c971$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$3f998a28c3e0c971$export$1e511d4a378977f5 = true;
$3f998a28c3e0c971$export$2e2bcd8739ae039 = void 0;

var $3f998a28c3e0c971$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $3f998a28c3e0c971$var$_react = $3f998a28c3e0c971$var$_interopRequireWildcard((parcelRequire("acw62")));

var $3f998a28c3e0c971$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $6zLPD = parcelRequire("6zLPD");

var $ikfii = parcelRequire("ikfii");
function $3f998a28c3e0c971$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3f998a28c3e0c971$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $3f998a28c3e0c971$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $3f998a28c3e0c971$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $3f998a28c3e0c971$var$ProductsScan = ({ onClose: onClose, promotion: promotion, setIsFetching: setIsFetching, patchPromotion: patchPromotion })=>{
    const translate = (0, $3f998a28c3e0c971$var$_useTranslate.default)();
    const [gtins, setGTINS] = (0, $3f998a28c3e0c971$var$_react.useState)([]);
    const [isSubmitted, setIsSubmitted] = (0, $3f998a28c3e0c971$var$_react.useState)(false);
    const [label, setLabel] = (0, $3f998a28c3e0c971$var$_react.useState)(translate("RL_Submit"));
    const [isSubmitting, setIsSubmitting] = (0, $3f998a28c3e0c971$var$_react.useState)(false);
    const [isCancellationConfirmationOpen, setIsCancellationConfirmationOpen] = (0, $3f998a28c3e0c971$var$_react.useState)(false);
    const [success, setSuccess] = (0, $3f998a28c3e0c971$var$_react.useState)(translate("RL_StartScanning"));
    const [error, setError] = (0, $3f998a28c3e0c971$var$_react.useState)("");
    const onDetected = (barcode)=>{
        if (gtins.length >= 50) setError(translate("RL_CodesValidation", 50));
        else {
            setError("");
            const gtin = barcode.padStart(14, "0");
            if (!gtins.some((x)=>x.gtin === gtin)) {
                const gtinsCopy = [
                    ...gtins,
                    {
                        date: new Date().toISOString(),
                        gtin: gtin
                    }
                ];
                setGTINS(gtinsCopy);
                setLabel(gtinsCopy.length > 0 ? translate(gtinsCopy.length > 1 ? "RL_Add2Products" : "RL_Add1Product", gtinsCopy.length) : "");
            }
        }
        setSuccess("");
        setIsSubmitted(false);
    };
    const onPopupSubmit = ()=>{
        onClose();
        setGTINS([]);
        setLabel(translate("RL_Submit"));
        (0, $6zLPD.handleResponse)(setSuccess, "", setError, "");
        setIsFetching(true);
    };
    const onPopupClose = ()=>gtins.length > 0 && !isSubmitted ? setIsCancellationConfirmationOpen(true) : onPopupSubmit();
    const onSubmit = ()=>{
        setIsSubmitting(true);
        const newItemDetails = Array.from(gtins).map((x)=>({
                createDateTime: x.date,
                gtin: x.gtin
            }));
        (async ()=>patchPromotion(promotion.id, {
                updates: (0, $6zLPD.formatPromotionPatchAddItems)(newItemDetails),
                ...(0, $6zLPD.formatStoreInfo)()
            }).then((res)=>{
                var _res$errors;
                if ((_res$errors = res.errors) !== null && _res$errors !== void 0 && _res$errors.length) {
                    const { errorMessage: errorMessage, successMessage: successMessage } = (0, $6zLPD.handleErrorMessage)(res, gtins.map((item)=>item.gtin));
                    return (0, $6zLPD.handleResponse)(setSuccess, successMessage, setError, errorMessage);
                }
                return (0, $6zLPD.handleResponse)(setSuccess, translate("RL_ProductScanSuccess"), setError, "");
            }).catch((err)=>(0, $6zLPD.handleResponse)(setSuccess, "", setError, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>{
                setGTINS([]);
                setIsSubmitting(false);
                setIsSubmitted(true);
            }))();
    };
    return /*#__PURE__*/ $3f998a28c3e0c971$var$_react.default.createElement($ikfii.Scanner, {
        onClose: onPopupClose,
        onDetected: onDetected
    }, /*#__PURE__*/ $3f998a28c3e0c971$var$_react.default.createElement($ikfii.ButtonSubmit, {
        isDisabled: !(gtins !== null && gtins !== void 0 && gtins.length) || isSubmitted,
        isSubmitting: isSubmitting,
        label: label,
        messageError: error,
        messageSuccess: success,
        onSubmit: onSubmit
    }), /*#__PURE__*/ $3f998a28c3e0c971$var$_react.default.createElement($ikfii.Popup, {
        isOpen: isCancellationConfirmationOpen,
        setIsOpen: setIsCancellationConfirmationOpen,
        subtitle: gtins.length === 1 ? translate("RL_ProductScanCancel1") : translate("RL_ProductScanCancel2", gtins.length),
        onSubmit: onPopupSubmit
    }));
};
$3f998a28c3e0c971$var$ProductsScan.propTypes = {
    onClose: $3f998a28c3e0c971$var$_propTypes.default.func.isRequired,
    patchPromotion: $3f998a28c3e0c971$var$_propTypes.default.func.isRequired,
    promotion: $3f998a28c3e0c971$var$_propTypes.default.shape().isRequired,
    setIsFetching: $3f998a28c3e0c971$var$_propTypes.default.func.isRequired
};
var $3f998a28c3e0c971$var$_default = $3f998a28c3e0c971$export$2e2bcd8739ae039 = $3f998a28c3e0c971$var$ProductsScan;

});

parcelRegister("9pYKL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $6db5932d93f0db19$export$1e511d4a378977f5, (v) => $6db5932d93f0db19$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $6db5932d93f0db19$export$2e2bcd8739ae039, (v) => $6db5932d93f0db19$export$2e2bcd8739ae039 = v);
var $6db5932d93f0db19$export$1e511d4a378977f5;
var $6db5932d93f0db19$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$6db5932d93f0db19$export$1e511d4a378977f5 = true;
$6db5932d93f0db19$export$2e2bcd8739ae039 = void 0;

var $142Bi = parcelRequire("142Bi");

var $6db5932d93f0db19$var$_moment = $1jnue((parcelRequire("45fvw")));

var $6db5932d93f0db19$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $6db5932d93f0db19$var$_react = $6db5932d93f0db19$var$_interopRequireWildcard((parcelRequire("acw62")));

var $6db5932d93f0db19$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $ikfii = parcelRequire("ikfii");
function $6db5932d93f0db19$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6db5932d93f0db19$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6db5932d93f0db19$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6db5932d93f0db19$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $6db5932d93f0db19$var$PromotionEdit = ({ onClose: onClose, promotion: propPromotion })=>{
    const [promotion, setPromotion] = (0, $6db5932d93f0db19$var$_react.useState)({
        ...propPromotion
    });
    const [discountPercentage, setDiscountPercentage] = (0, $6db5932d93f0db19$var$_react.useState)(promotion.discountPercentage);
    const [endDate, setEndDate] = (0, $6db5932d93f0db19$var$_react.useState)((0, $6zLPD.formatDate)((0, $6db5932d93f0db19$var$_moment.default)(promotion.endDateTime)));
    const [name, setName] = (0, $6db5932d93f0db19$var$_react.useState)(promotion.name);
    const [dateError, setDateError] = (0, $6db5932d93f0db19$var$_react.useState)("");
    const [nameError, setNameError] = (0, $6db5932d93f0db19$var$_react.useState)("");
    const [submitDisabled, setSubmitDisabled] = (0, $6db5932d93f0db19$var$_react.useState)(true);
    const [isUpdating, setIsUpdating] = (0, $6db5932d93f0db19$var$_react.useState)(false);
    const [errorUpdate, setErrorUpdate] = (0, $6db5932d93f0db19$var$_react.useState)("");
    const [successUpdate, setSuccessUpdate] = (0, $6db5932d93f0db19$var$_react.useState)("");
    const translate = (0, $6db5932d93f0db19$var$_useTranslate.default)();
    const attributesChanged = discountPercentage !== promotion.discountPercentage || endDate !== (0, $6zLPD.formatDate)((0, $6db5932d93f0db19$var$_moment.default)(promotion.endDateTime)) || name !== promotion.name;
    (0, $6db5932d93f0db19$var$_react.useEffect)(()=>{
        const isFormComplete = name && (discountPercentage || discountPercentage === 0) && endDate;
        // If the endDate is set to 'tomorrow' during the window of time between a GPPS sync and 'tomorrow',
        // that will cause the promotion to get skipped during the next scheduled sync to GPPS.
        // Thus, we require the new endDate to be at least 2 days out to prevent a possible desync.
        const isDateValid = endDate === promotion.endDate || (0, $6db5932d93f0db19$var$_moment.default)().add(2, "d").startOf("day") <= (0, $6db5932d93f0db19$var$_moment.default)(endDate);
        const isNameValid = /^[a-zA-Z0-9 ]*$/.test(name);
        const isPromotionNameValid = !/\s{2,}/.test(name);
        setNameError(!isNameValid || !isPromotionNameValid ? translate("RL_PromotionNameValidation2") : "");
        setDateError(isDateValid ? "" : translate("RL_EndDateValidation1"));
        setErrorUpdate("");
        setSubmitDisabled(!(isFormComplete && attributesChanged && isDateValid && isNameValid && isPromotionNameValid));
    }, [
        attributesChanged,
        discountPercentage,
        endDate,
        name,
        promotion.endDate,
        translate
    ]);
    const mapUpdates = (updates)=>Object.entries(updates).filter(([key, value])=>key === "endDateTime" ? (0, $6zLPD.formatDate)((0, $6db5932d93f0db19$var$_moment.default)(value)) !== (0, $6zLPD.formatDate)((0, $6db5932d93f0db19$var$_moment.default)(promotion.endDateTime)) : value !== promotion[key]).map(([key, value])=>(0, $6zLPD.formatPromotionPatchUpdate)(key, value));
    const onUpdate = ()=>{
        setErrorUpdate("");
        setSuccessUpdate("");
        setIsUpdating(true);
        const updates = {
            discountPercentage: discountPercentage,
            endDateTime: (0, $6db5932d93f0db19$var$_moment.default)(endDate).startOf("day").toISOString(),
            name: name === null || name === void 0 ? void 0 : name.trim()
        };
        (async ()=>(0, $ilYXe.patchPromotion)(promotion.id, {
                updates: mapUpdates(updates),
                ...(0, $6zLPD.formatStoreInfo)()
            }).then((updatedPromotion)=>{
                setPromotion(updatedPromotion);
                return (0, $6zLPD.handleResponse)(setSuccessUpdate, translate("RL_PromotionUpdateSuccess"), setErrorUpdate, "");
            }).catch((err)=>(0, $6zLPD.handleResponse)(()=>{}, null, setErrorUpdate, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>{
                window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
                setIsUpdating(false);
            }))();
    };
    const onChangeName = (val)=>{
        const trimmedValue = val === null || val === void 0 ? void 0 : val.trim();
        setName(trimmedValue);
    };
    return /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement("div", null, /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement("nav", {
        className: "d-sm-flx flx-jc-sm-fe"
    }, /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement($ikfii.Button, {
        icon: /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement($142Bi.Close, {
            style: {
                margin: "0.32rem -1rem"
            },
            title: "Cancel"
        }),
        onClick: onClose
    })), /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement("section", {
        className: "ncss-col-sm-10 ta-sm-l mb3-sm"
    }, promotion.createdBy === "DEFAULT_PROMOTION" && /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement("p", {
        className: "body-3"
    }, translate("RL_DefaultPromotion")), promotion.createdBy !== "DEFAULT_PROMOTION" && /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement($ikfii.Input, {
        isRequired: true,
        showCharacterCount: true,
        error: !name || !!nameError,
        errorMessage: nameError,
        id: "name",
        label: translate("RL_PromotionName"),
        maxLength: 21,
        minLength: 1,
        value: name,
        onChange: onChangeName
    }), /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement($ikfii.DiscountPercentages, {
        isRequired: true,
        discountPercentage: discountPercentage,
        onChange: setDiscountPercentage
    }), promotion.createdBy !== "DEFAULT_PROMOTION" && /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement($ikfii.InputDate, {
        isRequired: true,
        errorMessage: dateError,
        id: "endDate",
        label: translate("RL_EndDate"),
        minDate: (0, $6zLPD.formatDate)((0, $6db5932d93f0db19$var$_moment.default)().add(2, "d").startOf("day")),
        value: endDate,
        onChange: setEndDate
    })), /*#__PURE__*/ $6db5932d93f0db19$var$_react.default.createElement($ikfii.ButtonSubmit, {
        isDisabled: submitDisabled,
        isSubmitting: isUpdating,
        label: translate("RL_SaveChanges"),
        messageError: errorUpdate,
        messageSuccess: successUpdate,
        sectionClassName: "mb3-sm",
        onSubmit: onUpdate
    }));
};
$6db5932d93f0db19$var$PromotionEdit.propTypes = {
    onClose: $6db5932d93f0db19$var$_propTypes.default.func.isRequired,
    promotion: $6db5932d93f0db19$var$_propTypes.default.shape().isRequired
};
var $6db5932d93f0db19$var$_default = $6db5932d93f0db19$export$2e2bcd8739ae039 = $6db5932d93f0db19$var$PromotionEdit;

});


parcelRegister("4EphB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $362e827e130bb890$export$1e511d4a378977f5, (v) => $362e827e130bb890$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $362e827e130bb890$export$2e2bcd8739ae039, (v) => $362e827e130bb890$export$2e2bcd8739ae039 = v);
var $362e827e130bb890$export$1e511d4a378977f5;
var $362e827e130bb890$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$362e827e130bb890$export$1e511d4a378977f5 = true;
$362e827e130bb890$export$2e2bcd8739ae039 = void 0;

var $362e827e130bb890$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $362e827e130bb890$var$_react = $362e827e130bb890$var$_interopRequireWildcard((parcelRequire("acw62")));

var $362e827e130bb890$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $ikfii = parcelRequire("ikfii");

var $362e827e130bb890$var$_PromotionAdd = $1jnue((parcelRequire("cid6v")));

var $362e827e130bb890$var$_PromotionPreview = $1jnue((parcelRequire("dmJ6G")));
function $362e827e130bb890$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($362e827e130bb890$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $362e827e130bb890$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $362e827e130bb890$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $362e827e130bb890$var$PromotionHome = ({ promotions: promotions, refreshPromotions: refreshPromotions, setActivePromotion: setActivePromotion, setClearError: setClearError, setClearSuccess: setClearSuccess, canCreate: canCreate })=>{
    const [isAdding, setIsAdding] = (0, $362e827e130bb890$var$_react.useState)(false);
    const toggleAddPromotionPage = ()=>{
        isAdding && refreshPromotions();
        return setIsAdding((wasAdding)=>!wasAdding);
    };
    return /*#__PURE__*/ $362e827e130bb890$var$_react.default.createElement($362e827e130bb890$var$_react.default.Fragment, null, canCreate && /*#__PURE__*/ $362e827e130bb890$var$_react.default.createElement($ikfii.ButtonAdd, {
        isAdding: isAdding,
        onToggle: toggleAddPromotionPage
    }), isAdding ? /*#__PURE__*/ $362e827e130bb890$var$_react.default.createElement($362e827e130bb890$var$_PromotionAdd.default, null) : /*#__PURE__*/ $362e827e130bb890$var$_react.default.createElement($362e827e130bb890$var$_PromotionPreview.default, {
        canDelete: $362e827e130bb890$var$_Auth.default.requiresRole40($362e827e130bb890$var$_Auth.default.getAuth()),
        promotions: promotions,
        refreshPromotions: refreshPromotions,
        setActivePromotion: setActivePromotion,
        setClearError: setClearError,
        setClearSuccess: setClearSuccess
    }));
};
$362e827e130bb890$var$PromotionHome.propTypes = {
    canCreate: $362e827e130bb890$var$_propTypes.default.bool.isRequired,
    promotions: $362e827e130bb890$var$_propTypes.default.arrayOf($362e827e130bb890$var$_propTypes.default.shape({
        discountPercentage: $362e827e130bb890$var$_propTypes.default.number.isRequired,
        divisions: $362e827e130bb890$var$_propTypes.default.shape().isRequired,
        endDate: $362e827e130bb890$var$_propTypes.default.string.isRequired,
        genders: $362e827e130bb890$var$_propTypes.default.shape().isRequired,
        id: $362e827e130bb890$var$_propTypes.default.string.isRequired,
        itemDetails: $362e827e130bb890$var$_propTypes.default.arrayOf($362e827e130bb890$var$_propTypes.default.shape({
            gtin: $362e827e130bb890$var$_propTypes.default.string,
            name: $362e827e130bb890$var$_propTypes.default.string,
            productId: $362e827e130bb890$var$_propTypes.default.string,
            styleColor: $362e827e130bb890$var$_propTypes.default.string
        })),
        name: $362e827e130bb890$var$_propTypes.default.string.isRequired,
        startDate: $362e827e130bb890$var$_propTypes.default.string.isRequired
    })).isRequired,
    refreshPromotions: $362e827e130bb890$var$_propTypes.default.func.isRequired,
    setActivePromotion: $362e827e130bb890$var$_propTypes.default.func.isRequired,
    setClearError: $362e827e130bb890$var$_propTypes.default.func.isRequired,
    setClearSuccess: $362e827e130bb890$var$_propTypes.default.func.isRequired
};
var $362e827e130bb890$var$_default = $362e827e130bb890$export$2e2bcd8739ae039 = $362e827e130bb890$var$PromotionHome;

});
parcelRegister("cid6v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $8f3154a6b36d7940$export$1e511d4a378977f5, (v) => $8f3154a6b36d7940$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $8f3154a6b36d7940$export$2e2bcd8739ae039, (v) => $8f3154a6b36d7940$export$2e2bcd8739ae039 = v);
var $8f3154a6b36d7940$export$1e511d4a378977f5;
var $8f3154a6b36d7940$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$8f3154a6b36d7940$export$1e511d4a378977f5 = true;
$8f3154a6b36d7940$export$2e2bcd8739ae039 = void 0;

var $8f3154a6b36d7940$var$_moment = $1jnue((parcelRequire("45fvw")));

var $8f3154a6b36d7940$var$_react = $8f3154a6b36d7940$var$_interopRequireWildcard((parcelRequire("acw62")));

var $8f3154a6b36d7940$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $1BuK1 = parcelRequire("1BuK1");

var $ikfii = parcelRequire("ikfii");
function $8f3154a6b36d7940$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8f3154a6b36d7940$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $8f3154a6b36d7940$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $8f3154a6b36d7940$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $8f3154a6b36d7940$var$PromotionAdd = ()=>{
    const [name, setName] = (0, $8f3154a6b36d7940$var$_react.useState)("");
    const [discountPercentage, setDiscountPercentage] = (0, $8f3154a6b36d7940$var$_react.useState)(0);
    const [nameError, setNameError] = (0, $8f3154a6b36d7940$var$_react.useState)("");
    const [divisions, setDivisions] = (0, $8f3154a6b36d7940$var$_react.useState)([]);
    const [genders, setGenders] = (0, $8f3154a6b36d7940$var$_react.useState)([]);
    const [startDate, setStartDate] = (0, $8f3154a6b36d7940$var$_react.useState)((0, $6zLPD.formatDate)((0, $8f3154a6b36d7940$var$_moment.default)().add(1, "d")));
    const [endDate, setEndDate] = (0, $8f3154a6b36d7940$var$_react.useState)((0, $6zLPD.formatDate)((0, $8f3154a6b36d7940$var$_moment.default)().add(1, "d").add(1, "w")));
    const [dateError, setDateError] = (0, $8f3154a6b36d7940$var$_react.useState)("");
    const [submitDisabled, setSubmitDisabled] = (0, $8f3154a6b36d7940$var$_react.useState)(true);
    const [isSubmitting, setIsSubmitting] = (0, $8f3154a6b36d7940$var$_react.useState)(false);
    const [success, setSuccess] = (0, $8f3154a6b36d7940$var$_react.useState)("");
    const [error, setError] = (0, $8f3154a6b36d7940$var$_react.useState)("");
    const translate = (0, $8f3154a6b36d7940$var$_useTranslate.default)();
    (0, $8f3154a6b36d7940$var$_react.useEffect)(()=>{
        const isFormComplete = name && (discountPercentage || discountPercentage === 0) && divisions.length && genders.length && startDate && endDate;
        const areDatesValid = startDate < endDate;
        const isNameValid = /^[a-zA-Z0-9 ]*$/.test(name);
        const isPromotionNameValid = !/\s{2,}/.test(name);
        setNameError(!isNameValid || !isPromotionNameValid ? translate("RL_PromotionNameValidation2") : "");
        setDateError(areDatesValid ? "" : translate("RL_EndDateValidation2"));
        setError("");
        setSubmitDisabled(!(isFormComplete && areDatesValid && isNameValid && isPromotionNameValid));
        setSuccess("");
    }, [
        discountPercentage,
        divisions,
        endDate,
        genders,
        name,
        startDate,
        translate
    ]);
    const onSubmit = ()=>{
        setIsSubmitting(true);
        (async ()=>(0, $ilYXe.postPromotion)({
                discountPercentage: discountPercentage,
                divisions: divisions,
                endDate: endDate,
                genders: genders,
                name: name === null || name === void 0 ? void 0 : name.trim(),
                startDate: startDate
            }).then(()=>(0, $6zLPD.handleResponse)(setSuccess, translate("RL_ProductAddSuccess1", name), setError, "")).catch((err)=>(0, $6zLPD.handleResponse)(setSuccess, "", setError, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>{
                window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
                setIsSubmitting(false);
            }))();
    };
    const translateLabel = (0, $8f3154a6b36d7940$var$_react.useCallback)(({ label: label })=>translate($1BuK1.translationMappings[label]) || label, [
        translate
    ]);
    const onChangeName = (val)=>{
        const trimmedValue = val === null || val === void 0 ? void 0 : val.trim();
        setName(trimmedValue);
    };
    return /*#__PURE__*/ $8f3154a6b36d7940$var$_react.default.createElement($8f3154a6b36d7940$var$_react.default.Fragment, null, /*#__PURE__*/ $8f3154a6b36d7940$var$_react.default.createElement("section", {
        className: "ncss-col-sm-10 ta-sm-l mt3-sm mb3-sm"
    }, /*#__PURE__*/ $8f3154a6b36d7940$var$_react.default.createElement($ikfii.Input, {
        isRequired: true,
        showCharacterCount: true,
        error: !name || !!nameError,
        errorMessage: nameError,
        id: "name",
        label: translate("RL_PromotionName"),
        maxLength: 21,
        minLength: 1,
        value: name,
        onChange: onChangeName
    }), /*#__PURE__*/ $8f3154a6b36d7940$var$_react.default.createElement($ikfii.DiscountPercentages, {
        isRequired: true,
        discountPercentage: discountPercentage,
        onChange: setDiscountPercentage
    }), /*#__PURE__*/ $8f3154a6b36d7940$var$_react.default.createElement($ikfii.Select, {
        isMulti: true,
        isRequired: true,
        getOptionLabel: translateLabel,
        id: "divisions",
        label: translate("RL_Divisions"),
        options: $1BuK1.divisionValues,
        values: divisions,
        zIndex: 2,
        onChange: setDivisions
    }), /*#__PURE__*/ $8f3154a6b36d7940$var$_react.default.createElement($ikfii.Select, {
        isMulti: true,
        isRequired: true,
        getOptionLabel: translateLabel,
        id: "genders",
        label: translate("RL_Genders"),
        options: $1BuK1.genderValues,
        values: genders,
        zIndex: 1,
        onChange: setGenders
    }), /*#__PURE__*/ $8f3154a6b36d7940$var$_react.default.createElement($ikfii.InputDate, {
        isRequired: true,
        id: "startDate",
        label: translate("RL_StartDate"),
        minDate: (0, $6zLPD.formatDate)((0, $8f3154a6b36d7940$var$_moment.default)().add(1, "d").startOf("day")),
        value: startDate,
        onChange: setStartDate
    }), /*#__PURE__*/ $8f3154a6b36d7940$var$_react.default.createElement($ikfii.InputDate, {
        isRequired: true,
        errorMessage: dateError,
        id: "endDate",
        label: translate("RL_EndDate"),
        minDate: (0, $6zLPD.formatDate)((0, $8f3154a6b36d7940$var$_moment.default)(startDate).add(1, "d").startOf("day")),
        value: endDate,
        onChange: setEndDate
    })), /*#__PURE__*/ $8f3154a6b36d7940$var$_react.default.createElement($ikfii.ButtonSubmit, {
        isDisabled: submitDisabled,
        isSubmitting: isSubmitting,
        label: translate("RL_AddPromotion"),
        messageError: error,
        messageSuccess: success,
        onSubmit: onSubmit
    }));
};
var $8f3154a6b36d7940$var$_default = $8f3154a6b36d7940$export$2e2bcd8739ae039 = $8f3154a6b36d7940$var$PromotionAdd;

});

parcelRegister("dmJ6G", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $9bb051b0d910296f$export$1e511d4a378977f5, (v) => $9bb051b0d910296f$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $9bb051b0d910296f$export$2e2bcd8739ae039, (v) => $9bb051b0d910296f$export$2e2bcd8739ae039 = v);
var $9bb051b0d910296f$export$1e511d4a378977f5;
var $9bb051b0d910296f$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$9bb051b0d910296f$export$1e511d4a378977f5 = true;
$9bb051b0d910296f$export$2e2bcd8739ae039 = void 0;

var $142Bi = parcelRequire("142Bi");

var $9bb051b0d910296f$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $9bb051b0d910296f$var$_react = $9bb051b0d910296f$var$_interopRequireWildcard((parcelRequire("acw62")));

var $7Yi7V = parcelRequire("7Yi7V");

var $9bb051b0d910296f$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $f2CEG = parcelRequire("f2CEG");

var $ikfii = parcelRequire("ikfii");

function $9bb051b0d910296f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($9bb051b0d910296f$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $9bb051b0d910296f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $9bb051b0d910296f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// Update the magic 6 if we ever have more divisions (there are 6 groupings, so 'All' is all 6)
const $9bb051b0d910296f$var$formatDivisions = (p, translate)=>p.divisions.size === 6 ? translate("RL_AllDivisions") : (0, $6zLPD.formatUniqueString)((0, $f2CEG.translateSets)(p.divisions, translate));
// Update this magic 4 if we ever have more genders (there are 4 groupings, so 'All' is all 4)
const $9bb051b0d910296f$var$formatGenders = (p, translate)=>`${p.genders.size > 1 ? translate("RL_Genders") : translate("RL_Gender")}: ${p.genders.size === 4 ? translate("RL_All") : (0, $6zLPD.formatUniqueString)((0, $f2CEG.translateSets)(p.genders, translate))}`;
const $9bb051b0d910296f$var$formatSublabel = (p, translate)=>{
    var _p$itemDetails, _p$itemDetails2;
    return translate(((_p$itemDetails = p.itemDetails) === null || _p$itemDetails === void 0 ? void 0 : _p$itemDetails.length) !== 1 ? "RL_OffCodes" : "RL_OffCode", p.discountPercentage, ((_p$itemDetails2 = p.itemDetails) === null || _p$itemDetails2 === void 0 ? void 0 : _p$itemDetails2.length) || 0);
};
const $9bb051b0d910296f$var$PromotionPreview = ({ canDelete: canDelete, promotions: promotions, refreshPromotions: refreshPromotions, setActivePromotion: setActivePromotion, setClearError: setClearError, setClearSuccess: setClearSuccess })=>{
    const [isClearing, setIsClearing] = (0, $9bb051b0d910296f$var$_react.useState)(false);
    const [searchValue, setSearchValue] = (0, $9bb051b0d910296f$var$_react.useState)("");
    const translate = (0, $9bb051b0d910296f$var$_useTranslate.default)();
    const onDeletePromotionItems = async (promotion)=>{
        setIsClearing(true);
        return (0, $ilYXe.patchPromotion)(promotion.id, {
            updates: (0, $6zLPD.formatPromotionPatchDeleteItems)(promotion.itemDetails),
            ...(0, $6zLPD.formatStoreInfo)()
        }).then((res)=>res.errors.length ? (0, $6zLPD.handleResponse)(setClearSuccess, "", setClearError, translate("RL_ItemDeleteFail")) : (0, $6zLPD.handleResponse)(setClearSuccess, translate("RL_ClearItemSuccess", promotion.name), setClearError, "")).catch((err)=>(0, $6zLPD.handleResponse)(setClearSuccess, "", setClearError, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>{
            setIsClearing(false);
            refreshPromotions();
        });
    };
    const onArrowClick = (promotionId)=>{
        (0, $6zLPD.handleResponse)(setClearSuccess, "", setClearError, "");
        return setActivePromotion(promotionId);
    };
    const filterPromotions = (promotion)=>promotion.name.toUpperCase().indexOf(searchValue.toUpperCase()) !== -1 || promotion.itemDetails.some((i)=>i.styleColor.indexOf(searchValue.toUpperCase()) !== -1);
    return /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement($9bb051b0d910296f$var$_react.default.Fragment, null, /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement($ikfii.Input, {
        id: "Search Promotions",
        label: translate("RL_SearchPromotions"),
        placeholder: translate("RL_PromotionNameorStyleColor"),
        trailingIconContent: /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement($142Bi.Close, null),
        value: searchValue,
        onChange: setSearchValue,
        onIconClick: ()=>setSearchValue("")
    }), promotions.filter((p)=>filterPromotions(p)).map((p)=>/*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement("article", {
            key: p.id,
            className: "va-sm-t ta-sm-l"
        }, /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement("section", {
            className: "slide-display"
        }, /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement("section", {
            className: "slide-display-info"
        }, /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement($ikfii.CustomPanel, {
            key: p.id,
            button: {
                onClick: ()=>onArrowClick(p.id),
                to: `/promotions/${p.id}`
            },
            label: p.name,
            sublabel: $9bb051b0d910296f$var$formatSublabel(p, translate)
        }, /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement($9bb051b0d910296f$var$_react.default.Fragment, null, /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement("p", {
            className: "body-2"
        }, $9bb051b0d910296f$var$formatGenders(p, translate)), /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement("p", {
            className: "body-2"
        }, $9bb051b0d910296f$var$formatDivisions(p, translate)), /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement("p", {
            className: "body-2"
        }, !$7Yi7V.defaultPromotions.includes(p.name) ? `${p.startDate} - ${p.endDate}` : "")))), canDelete && /*#__PURE__*/ $9bb051b0d910296f$var$_react.default.createElement($ikfii.ButtonPopup, {
            className: "bg-error u-rounded text-color-primary-light flx-jc-sm-c flx-ai-sm-c ml1-sm mb2-sm pr1-sm slide-display-button",
            isDisabled: isClearing || !p.itemDetails.length,
            label: translate("RL_Clear"),
            style: {
                height: "auto",
                width: "65px"
            },
            subtitle: translate("RL_ProductDeleteConfirm4", p.itemDetails.length, p.name),
            onSubmit: async ()=>onDeletePromotionItems(p)
        })))));
};
$9bb051b0d910296f$var$PromotionPreview.propTypes = {
    canDelete: $9bb051b0d910296f$var$_propTypes.default.bool.isRequired,
    promotions: $9bb051b0d910296f$var$_propTypes.default.arrayOf($9bb051b0d910296f$var$_propTypes.default.shape({
        discountPercentage: $9bb051b0d910296f$var$_propTypes.default.number.isRequired,
        divisions: $9bb051b0d910296f$var$_propTypes.default.shape().isRequired,
        endDate: $9bb051b0d910296f$var$_propTypes.default.string.isRequired,
        genders: $9bb051b0d910296f$var$_propTypes.default.shape().isRequired,
        id: $9bb051b0d910296f$var$_propTypes.default.string.isRequired,
        itemDetails: $9bb051b0d910296f$var$_propTypes.default.arrayOf($9bb051b0d910296f$var$_propTypes.default.shape({
            gtin: $9bb051b0d910296f$var$_propTypes.default.string,
            name: $9bb051b0d910296f$var$_propTypes.default.string,
            productId: $9bb051b0d910296f$var$_propTypes.default.string,
            styleColor: $9bb051b0d910296f$var$_propTypes.default.string
        })),
        name: $9bb051b0d910296f$var$_propTypes.default.string.isRequired,
        startDate: $9bb051b0d910296f$var$_propTypes.default.string.isRequired
    })).isRequired,
    refreshPromotions: $9bb051b0d910296f$var$_propTypes.default.func.isRequired,
    setActivePromotion: $9bb051b0d910296f$var$_propTypes.default.func.isRequired,
    setClearError: $9bb051b0d910296f$var$_propTypes.default.func.isRequired,
    setClearSuccess: $9bb051b0d910296f$var$_propTypes.default.func.isRequired
};
var $9bb051b0d910296f$var$_default = $9bb051b0d910296f$export$2e2bcd8739ae039 = $9bb051b0d910296f$var$PromotionPreview;

});



parcelRegister("gMLlu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $c385dae55ce8f933$export$1e511d4a378977f5, (v) => $c385dae55ce8f933$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $c385dae55ce8f933$export$2e2bcd8739ae039, (v) => $c385dae55ce8f933$export$2e2bcd8739ae039 = v);
var $c385dae55ce8f933$export$1e511d4a378977f5;
var $c385dae55ce8f933$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$c385dae55ce8f933$export$1e511d4a378977f5 = true;
$c385dae55ce8f933$export$2e2bcd8739ae039 = void 0;

var $c385dae55ce8f933$var$_react = $1jnue((parcelRequire("acw62")));

var $kfZjc = parcelRequire("kfZjc");
// import { useSelector } from 'react-redux';
// import { getIsPartnerLogin } from '../redux/selectors';
const $c385dae55ce8f933$var$RouteInvalid = ()=>window.location.pathname === "" || window.location.pathname === "/" ? /*#__PURE__*/ $c385dae55ce8f933$var$_react.default.createElement($kfZjc.Redirect, {
        to: "/promotions"
    }) : /*#__PURE__*/ $c385dae55ce8f933$var$_react.default.createElement("main", {
        className: "ncss-col-sm-12 ta-sm-c"
    }, /*#__PURE__*/ $c385dae55ce8f933$var$_react.default.createElement("h1", {
        className: "display-3 mt10-sm mb4-sm text-color-error"
    }, "This Route is Invalid"), /*#__PURE__*/ $c385dae55ce8f933$var$_react.default.createElement("p", {
        className: "headline-4"
    }, "The Promote App page you are trying to reach does not exist."), /*#__PURE__*/ $c385dae55ce8f933$var$_react.default.createElement("p", {
        className: "headline-4"
    }, "Please navigate through the app via the navigation bar below."));
var $c385dae55ce8f933$var$_default = $c385dae55ce8f933$export$2e2bcd8739ae039 = $c385dae55ce8f933$var$RouteInvalid;

});

parcelRegister("3L1tV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $2bc6e916538f579b$export$1e511d4a378977f5, (v) => $2bc6e916538f579b$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2bc6e916538f579b$export$2e2bcd8739ae039, (v) => $2bc6e916538f579b$export$2e2bcd8739ae039 = v);
var $2bc6e916538f579b$export$1e511d4a378977f5;
var $2bc6e916538f579b$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$2bc6e916538f579b$export$1e511d4a378977f5 = true;
$2bc6e916538f579b$export$2e2bcd8739ae039 = void 0;

var $jXPi8 = parcelRequire("jXPi8");
var $hx9Ss = parcelRequire("hx9Ss");
var $9ib4p = parcelRequire("9ib4p");

var $e080M = parcelRequire("e080M");

var $2bc6e916538f579b$var$_react = $2bc6e916538f579b$var$_interopRequireWildcard((parcelRequire("acw62")));

var $kfZjc = parcelRequire("kfZjc");

var $2bc6e916538f579b$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $2bc6e916538f579b$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $1BuK1 = parcelRequire("1BuK1");

var $8FTdl = parcelRequire("8FTdl");

var $ikfii = parcelRequire("ikfii");

var $2bc6e916538f579b$var$_SOHHome = $1jnue((parcelRequire("54u2G")));

function $2bc6e916538f579b$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2bc6e916538f579b$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $2bc6e916538f579b$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $2bc6e916538f579b$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $2bc6e916538f579b$var$StockOnHand = ()=>{
    const [isFetching, setIsFetching] = (0, $2bc6e916538f579b$var$_react.useState)(true);
    const [fetchError, setFetchError] = (0, $2bc6e916538f579b$var$_react.useState)("");
    const [soh, setSOH] = (0, $2bc6e916538f579b$var$_react.useState)([]);
    const [sohSortDirection, setSohSortDirection] = (0, $2bc6e916538f579b$var$_react.useState)("desc");
    const [productType, setProductType] = (0, $2bc6e916538f579b$var$_react.useState)("d3169f60-9d03-4ba0-818f-58e1967ce8e3");
    const [quantityFilter, setQuantityFilter] = (0, $2bc6e916538f579b$var$_react.useState)({
        filter: "minimumQuantity",
        quantity: "10"
    });
    const [isDeleting, setIsDeleting] = (0, $2bc6e916538f579b$var$_react.useState)(false);
    const [deleteError, setDeleteError] = (0, $2bc6e916538f579b$var$_react.useState)("");
    const [deleteSuccess, setDeleteSuccess] = (0, $2bc6e916538f579b$var$_react.useState)("");
    const translate = (0, $2bc6e916538f579b$var$_useTranslate.default)();
    const location = (0, $kfZjc.useLocation)();
    (0, $2bc6e916538f579b$var$_react.useEffect)(()=>{
        if (!$2bc6e916538f579b$var$_Auth.default.isAuthenticated()) (async ()=>$2bc6e916538f579b$var$_Auth.default.reAuthorize().then(()=>true).catch(()=>false))();
        if (isFetching) (async (_location$state)=>(0, $ilYXe.getStockOnHand)((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.storeId, productType, {
                [quantityFilter.filter]: quantityFilter.quantity
            }).then(({ objects: objects })=>(0, $6zLPD.handleResponse)(setSOH, (0, $6zLPD.formatStockOnHand)(objects, sohSortDirection), setFetchError, "")).catch((err)=>(0, $6zLPD.handleResponse)(setSOH, [], setFetchError, (0, $6zLPD.handleErrorMessage)(err))).finally(()=>setIsFetching(false)))();
    }, [
        isFetching,
        location.state,
        quantityFilter,
        productType,
        sohSortDirection
    ]);
    const handleDelete = (errors, successes, numberOfPromotionsUpdated, numberOfProductsDeleted)=>{
        const errorsDeleting = errors.size > 0;
        const someSuccessesDeleting = successes.size > 0;
        const allSuccessesDeleting = successes.size === numberOfPromotionsUpdated;
        const partialSuccess = ()=>errorsDeleting || someSuccessesDeleting;
        const allSuccess = ()=>!errorsDeleting && allSuccessesDeleting && numberOfProductsDeleted !== 1;
        const singleSuccess = ()=>!errorsDeleting && allSuccessesDeleting && numberOfProductsDeleted === 1;
        const [successMessage, errorMessage] = (0, $e080M.match)()([
            singleSuccess,
            [
                translate("RL_PromotionDeleteSuccess1"),
                ""
            ]
        ], [
            allSuccess,
            [
                translate("RL_PromotionDeleteSuccess2"),
                ""
            ]
        ], [
            partialSuccess,
            [
                "",
                translate("RL_ItemDeleteFail")
            ]
        ], [
            $e080M.Default,
            [
                "",
                ""
            ]
        ]);
        (0, $6zLPD.handleResponse)(setDeleteSuccess, successMessage, setDeleteError, errorMessage);
        // triggers the above useEffect to getStockOnHand
        setIsFetching(true);
    };
    const handleFilterChange = ()=>{
        (0, $6zLPD.handleResponse)(setDeleteSuccess, "", setDeleteError, "");
        setIsFetching(true);
    };
    const toggleSOHSortDirection = ()=>{
        const toggledDirection = sohSortDirection === "desc" ? "asc" : "desc";
        (0, $6zLPD.handleResponse)(setSOH, (0, $6zLPD.sortStockOnHand)(soh, toggledDirection), setFetchError, "");
        setSohSortDirection(toggledDirection);
    };
    const translatedProductTypes = (0, $2bc6e916538f579b$var$_react.useMemo)(()=>$8FTdl.productTypes.map(({ label: label, value: value })=>({
                label: translate($1BuK1.translationMappings[label]),
                value: value
            })), [
        translate
    ]);
    return /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement($2bc6e916538f579b$var$_react.default.Fragment, null, /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement("h1", {
        className: "display-3 text-color-accent mb3-sm"
    }, translate("RL_StockOnHand")), /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement("section", {
        className: "ncss-col-sm-12 full"
    }, /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement($jXPi8.DropDownStyled, {
        autoComplete: "on",
        disabled: isFetching || isDeleting,
        id: "divisionIdInput",
        label: translate("RL_ProductType"),
        name: "Product Type",
        options: translatedProductTypes,
        value: productType,
        onChange: ({ target: { value: value } })=>{
            setProductType(value);
            setQuantityFilter({
                ...quantityFilter,
                quantity: $8FTdl.defaultUnitsThresholds[value]
            });
            handleFilterChange();
        }
    })), /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement("section", {
        className: "d-sm-flx"
    }, /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement($9ib4p.SwitchStyled, {
        classes: {
            Container: "mt4-sm mr4-sm"
        },
        disabled: isFetching || isDeleting,
        selectedValue: quantityFilter.filter,
        onClick: ()=>{
            setQuantityFilter({
                ...quantityFilter,
                filter: quantityFilter.filter === "minimumQuantity" ? "maximumQuantity" : "minimumQuantity"
            });
            handleFilterChange();
        }
    }, /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement($hx9Ss.SwitchOptionStyled, {
        id: "minimumQuantitySwitch",
        label: ">=",
        value: "minimumQuantity"
    }), /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement($hx9Ss.SwitchOptionStyled, {
        id: "maximumQuantitySwitch",
        label: "<=",
        value: "maximumQuantity"
    })), /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement($jXPi8.DropDownStyled, {
        autoComplete: "on",
        disabled: isFetching || isDeleting,
        id: "unitsThresholdInput",
        label: translate("RL_Units"),
        name: "Units Threshold",
        options: $8FTdl.unitsThresholds,
        value: quantityFilter.quantity,
        onChange: ({ target: { value: value } })=>{
            setQuantityFilter({
                ...quantityFilter,
                quantity: value
            });
            handleFilterChange();
        }
    })), /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement($ikfii.ContentLoads, {
        error: fetchError,
        isLoading: isFetching
    }, /*#__PURE__*/ $2bc6e916538f579b$var$_react.default.createElement($2bc6e916538f579b$var$_SOHHome.default, {
        deleteError: deleteError,
        deleteSuccess: deleteSuccess,
        handleDelete: handleDelete,
        isDeleting: isDeleting,
        quantityFilter: quantityFilter,
        setIsDeleting: setIsDeleting,
        soh: soh,
        sohSortDirection: sohSortDirection,
        toggleSOHSortDirection: toggleSOHSortDirection
    })));
};
var $2bc6e916538f579b$var$_default = $2bc6e916538f579b$export$2e2bcd8739ae039 = $2bc6e916538f579b$var$StockOnHand;

});
parcelRegister("hx9Ss", function(module, exports) {

$parcel$export(module.exports, "SwitchOptionStyled", () => $cc3d2e2a37e84909$export$fad0e407d7773a64);

var $acw62 = parcelRequire("acw62");

var $gVJvh = parcelRequire("gVJvh");

var $3Dtv6 = parcelRequire("3Dtv6");
var $cc3d2e2a37e84909$var$i = {
    SwitchInputComponent: (0, $3Dtv6.ToggleSwitchInputStyled)
};
var $cc3d2e2a37e84909$export$fad0e407d7773a64 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(e, o) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gVJvh.SwitchOption), Object.assign({}, $cc3d2e2a37e84909$var$i, e, {
        ref: o
    }));
});
$cc3d2e2a37e84909$export$fad0e407d7773a64.displayName = "SwitchOptionStyled";

});
parcelRegister("gVJvh", function(module, exports) {

$parcel$export(module.exports, "SwitchOption", () => $c535443d584fe1d6$export$9e7e2a6e18a1d883);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $iqs5J = parcelRequire("iqs5J");
var $c535443d584fe1d6$export$9e7e2a6e18a1d883 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(i, l) {
    var o = i.className, n = i.disabled, r = i.id, c = i.value, p = i.name, s = i.labelClass, m = i.label, d = i.checked, h = i.SwitchInputComponent, w = void 0 === h ? (0, $iqs5J.ToggleSwitchInput) : h, u = i.SwitchInputComponentProps, b = (0, $1SA7b.default)("switch-input", o), f = (0, $1SA7b.default)("switch-label", s);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(w, {
        className: b,
        id: r,
        value: c,
        name: p,
        labelClass: f,
        label: m,
        checked: d,
        disabled: n,
        SwitchInputComponentProps: u,
        ref: l
    });
});
$c535443d584fe1d6$export$9e7e2a6e18a1d883.displayName = "SwitchOption";

});
parcelRegister("iqs5J", function(module, exports) {

$parcel$export(module.exports, "ToggleSwitchInput", () => $d6a07212ce0eb0c2$export$27a8b0ff0018db84);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");
var $d6a07212ce0eb0c2$export$27a8b0ff0018db84 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, l) {
    var r = t.className, n = t.id, c = t.value, o = t.name, m = t.checked, s = t.labelClass, p = t.label, i = t.SwitchInputComponentProps, u = t.ToggleInputComponentProps, d = (0, $1SA7b.default)(r, m ? "selected" : "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", Object.assign({
        type: "radio",
        className: d,
        id: n,
        value: c,
        name: o,
        checked: m,
        readOnly: !0
    }, i, u)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: s,
        htmlFor: n,
        ref: l
    }, p));
});

});


parcelRegister("3Dtv6", function(module, exports) {

$parcel$export(module.exports, "ToggleSwitchInputStyled", () => $2a5be5d580f521f9$export$e88ae4550cab20b5);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");

var $iqs5J = parcelRequire("iqs5J");
var $2a5be5d580f521f9$var$n = {
    name: "iwu81d",
    styles: "-webkit-appearance:none;display:none;pointer-events:none;visibility:hidden;"
}, $2a5be5d580f521f9$var$i = function() {
    return $2a5be5d580f521f9$var$n;
};
var $2a5be5d580f521f9$export$e88ae4550cab20b5 = (0, $1poQt.default)((0, $iqs5J.ToggleSwitchInput), {
    target: "e123c80g0"
})($2a5be5d580f521f9$var$i);

});


parcelRegister("9ib4p", function(module, exports) {

$parcel$export(module.exports, "SwitchStyled", () => $6c3e61c6a54e5c0b$export$58c8a7517af54a5c);

var $1poQt = parcelRequire("1poQt");

var $acw62 = parcelRequire("acw62");

var $6tIfH = parcelRequire("6tIfH");

var $1AVdp = parcelRequire("1AVdp");

var $b4YfI = parcelRequire("b4YfI");
var $6c3e61c6a54e5c0b$var$i = {
    SwitchButtonComponent: (0, $b4YfI.ToggleSwitchButtonStyled)
}, $6c3e61c6a54e5c0b$var$n = function(t) {
    var o = t.children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6tIfH.Switch), Object.assign({}, $6c3e61c6a54e5c0b$var$i, t), o);
};
var $6c3e61c6a54e5c0b$export$58c8a7517af54a5c = (0, $1poQt.default)($6c3e61c6a54e5c0b$var$n, {
    target: "e1x9x0870"
})((0, $1AVdp.switchStyles));

});
parcelRegister("6tIfH", function(module, exports) {

$parcel$export(module.exports, "Switch", () => $4b77c7165cf169c4$export$b5d5cf8927ab7262);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");

var $cfkQ7 = parcelRequire("cfkQ7");
var $NrUJm = parcelRequire("NrUJm");
var $9iiQA = parcelRequire("9iiQA");

var $h1B2D = parcelRequire("h1B2D");
var $5vEzr = parcelRequire("5vEzr");


var $gVJvh = parcelRequire("gVJvh");
function $4b77c7165cf169c4$var$t(t, e) {
    return function(t) {
        if (Array.isArray(t)) return t;
    }(t) || function(t, n) {
        var e = t && ("undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"]);
        if (null == e) return;
        var r, o, i = [], l = !0, c = !1;
        try {
            for(e = e.call(t); !(l = (r = e.next()).done) && (i.push(r.value), !n || i.length !== n); l = !0);
        } catch (t) {
            c = !0, o = t;
        } finally{
            try {
                l || null == e.return || e.return();
            } finally{
                if (c) throw o;
            }
        }
        return i;
    }(t, e) || function(t, e) {
        if (!t) return;
        if ("string" == typeof t) return $4b77c7165cf169c4$var$n(t, e);
        var r = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === r && t.constructor && (r = t.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(t);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $4b77c7165cf169c4$var$n(t, e);
    }(t, e) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $4b77c7165cf169c4$var$n(t, n) {
    var e, r;
    for((null == n || n > t.length) && (n = t.length), e = 0, r = new Array(n); e < n; e++)r[e] = t[e];
    return r;
}
function $4b77c7165cf169c4$var$e(t) {
    return ($4b77c7165cf169c4$var$e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
}
var $4b77c7165cf169c4$var$r = undefined && undefined.__rest || function(t, n) {
    var e, r = {};
    for(var o in t)Object.prototype.hasOwnProperty.call(t, o) && n.indexOf(o) < 0 && (r[o] = t[o]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) for(e = 0, o = Object.getOwnPropertySymbols(t); e < o.length; e++)n.indexOf(o[e]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[e]) && (r[o[e]] = t[o[e]]);
    return r;
};
var $4b77c7165cf169c4$var$y = function(t, n, r, i, l) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(t, function(t, c) {
        var a, u, s, d;
        return t && $4b77c7165cf169c4$var$e(t) === $4b77c7165cf169c4$var$e((0, $gVJvh.SwitchOption)) ? (u = (a = t.props).id, s = a.value, d = !i && 0 === c || s === i, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(t, {
            checked: d,
            name: n,
            disabled: r,
            key: "".concat(String(u), "-").concat(String(c)),
            ref: l[c]
        })) : null;
    });
}, $4b77c7165cf169c4$var$b = function(t) {
    return null == t ? void 0 : t[0].props.label;
}, $4b77c7165cf169c4$var$S = function(t) {
    var n = (null == t ? void 0 : t.length) - 1;
    return null == t ? void 0 : t[null != n ? n : 1].props.label;
}, $4b77c7165cf169c4$var$w = function(t, n, e) {
    var r, i, l = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(n), c = l.length - 1;
    return e ? (null === (r = l[c]) || void 0 === r ? void 0 : r.props.value) !== t : (null === (i = l[c]) || void 0 === i ? void 0 : i.props.value) === t;
};
var $4b77c7165cf169c4$export$b5d5cf8927ab7262 = function(n) {
    var e = n.a11ySwitchDescription, h = n.a11ySwitchDescriptionId, v = n.children, g = n.classes, C = void 0 === g ? {} : g, O = n.className, E = n.disabled, P = void 0 !== E && E, j = n.name, x = n.onClick, A = n.selectedValue, B = n.SwitchButtonComponent, I = void 0 === B ? (0, $cfkQ7.ToggleSwitchButton) : B, k = n.SwitchButtonComponentProps, N = n.SwitchSliderComponent, W = void 0 === N ? (0, $NrUJm.ToggleSwitchSlider) : N, D = n.SwitchSliderComponentProps, L = $4b77c7165cf169c4$var$r(n, [
        "a11ySwitchDescription",
        "a11ySwitchDescriptionId",
        "children",
        "classes",
        "className",
        "disabled",
        "name",
        "onClick",
        "selectedValue",
        "SwitchButtonComponent",
        "SwitchButtonComponentProps",
        "SwitchSliderComponent",
        "SwitchSliderComponentProps"
    ]), T = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(v);
    if (2 !== T) throw new Error("Switch components must be given SwitchOption children.");
    var V = (0, $acw62.useRef)(null), _ = (0, $acw62.useRef)(null), M = (0, $acw62.useRef)(null), U = (0, $5vEzr.useWindowWidth)({
        wait: 250
    }), $ = (0, $h1B2D.useIsRightToLeft)("#switch-container-".concat(j)), q = $4b77c7165cf169c4$var$t((0, $acw62.useState)(null != A ? A : ""), 2), z = q[0], F = q[1], G = $4b77c7165cf169c4$var$t((0, $acw62.useState)($4b77c7165cf169c4$var$y(v, j, P, z, [
        _,
        M
    ])), 2), H = G[0], J = G[1], K = $4b77c7165cf169c4$var$t((0, $acw62.useState)({}), 2), Q = K[0], R = K[1], X = $4b77c7165cf169c4$var$t((0, $acw62.useState)(), 2), Y = X[0], Z = X[1], tt = function() {
        var t, n, e, r, o, i = $4b77c7165cf169c4$var$w(z, H, $);
        Z(null === (t = V.current) || void 0 === t ? void 0 : t.offsetWidth);
        var l = null === (n = _.current) || void 0 === n ? void 0 : n.offsetWidth, c = null === (e = M.current) || void 0 === e ? void 0 : e.offsetWidth, a = function(t, n, e, r, o) {
            return t ? n - (o ? e : r) : 0;
        }(i, null !== (o = null === (r = V.current) || void 0 === r ? void 0 : r.offsetWidth) && void 0 !== o ? o : 0, l, c, $), u = function(t, n, e, r) {
            return "".concat(t ? r ? n : e : r ? e : n, "px");
        }(i, l, c, $);
        R({
            left: "".concat(a, "px"),
            width: u
        });
    };
    (0, $acw62.useEffect)(function() {
        var t;
        Y && Y !== (null === (t = V.current) || void 0 === t ? void 0 : t.offsetWidth) && tt();
    }, [
        U
    ]), (0, $acw62.useLayoutEffect)(function() {
        tt();
    }, [
        z,
        V,
        H,
        _,
        M,
        $
    ]), (0, $acw62.useEffect)(function() {
        F(null != A ? A : "");
    }, [
        A
    ]), (0, $acw62.useEffect)(function() {
        var t = $4b77c7165cf169c4$var$y(v, j, P, z, [
            _,
            M
        ]);
        J(t);
    }, [
        z,
        P,
        v,
        j,
        M,
        _
    ]);
    var nt = (0, $1SA7b.default)("switch-container", O, C.Container, P ? "disabled" : "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: nt
    }, L, {
        id: "switch-container-".concat(j)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(I, {
        onClick: function(t) {
            var n = H[0].props.value, e = H[T - 1].props.value, r = function(t, n, e, r) {
                if (!t) return e;
                var o = r ? e : n;
                return t === o ? r ? n : e : o;
            }(z, n, e, $);
            F(r), x && x(t, r);
        },
        className: (0, $1SA7b.default)("switch-button", C.Button),
        disabled: P,
        isToggledOn: $4b77c7165cf169c4$var$w(z, H, $),
        ref: V,
        SwitchButtonComponentProps: k,
        ariaLabelledBy: "switch-button-label-".concat(j),
        descriptionId: h
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(W, {
        className: (0, $1SA7b.default)("switch-slider", C.Slide),
        isToggledOn: $4b77c7165cf169c4$var$w(z, H, $),
        offLabel: $4b77c7165cf169c4$var$b(H),
        onLabel: $4b77c7165cf169c4$var$S(H),
        sliderStyles: Q,
        SwitchSliderComponentProps: D
    }), H), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $9iiQA.visuallyHidden),
        id: "switch-button-label-".concat(j)
    }, function(t, n, e, r) {
        return t ? r ? e : n : r ? n : e;
    }($4b77c7165cf169c4$var$w(z, H, $), $4b77c7165cf169c4$var$S(H), $4b77c7165cf169c4$var$b(H), $)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: (0, $9iiQA.visuallyHidden),
        id: h
    }, e));
};

});
parcelRegister("cfkQ7", function(module, exports) {

$parcel$export(module.exports, "ToggleSwitchButton", () => $8ea70d1524313fef$export$665b0203f2a49bfc);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");
var $8ea70d1524313fef$export$665b0203f2a49bfc = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, r) {
    var n = t.className, a = t.disabled, i = t.onClick, c = t.isToggledOn, l = t.children, d = t.descriptionId, s = t.Component, b = void 0 === s ? "button" : s, m = t.SwitchButtonComponentProps, p = t.ToggleButtonComponentProps, f = t.ariaLabelledBy, u = (0, $1SA7b.default)(n, c ? "on" : "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(b, Object.assign({
        role: "switch",
        type: "button",
        disabled: a,
        "aria-checked": c,
        onClick: function(e) {
            i && i(e);
        },
        className: u,
        ref: r,
        "aria-describedby": d,
        "aria-labelledby": f
    }, m, p), l);
});

});

parcelRegister("NrUJm", function(module, exports) {

$parcel$export(module.exports, "ToggleSwitchSlider", () => $094a3adbf357edc5$export$77c564f7ffa74c25);

var $acw62 = parcelRequire("acw62");

var $1SA7b = parcelRequire("1SA7b");
var $094a3adbf357edc5$export$77c564f7ffa74c25 = function(r) {
    var t = r.sliderStyles, s = r.className, l = r.isToggledOn, n = r.SwitchSliderComponentProps, i = r.ToggleSliderComponentProps, a = (0, $1SA7b.default)(s, l ? "on" : "off");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        style: t,
        className: a
    }, n, i));
};

});


parcelRegister("1AVdp", function(module, exports) {

$parcel$export(module.exports, "switchStyles", () => $129588f96b52d55d$export$1a9765986710715);
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $7GaV5 = parcelRequire("7GaV5");
var $129588f96b52d55d$export$1a9765986710715 = function(t) {
    var i = t.theme, e = i.colorBorderBase, n = i.paletteGrey4, a = i.paletteGrey2, s = i.colorBackgroundPrimary, d = i.colorContentPrimary, l = i.sizeBorderRadiusXl, c = i.colorContentDisabled, p = i.typographyCta1, x = i.sizeBorderWidthS, h = i.transitionDurationNormal, u = i.transitionTimingFunctionEase;
    return (0, $6xSYO.default)("&.disabled{.switch-button{color:", c, ";cursor:not-allowed;}.switch-slider{&:hover{box-shadow:none;}}}.switch-button{width:max-content;max-width:100vw;", p, " padding:0;display:flex;background-color:", n, ";color:", d, ";&:focus{.switch-slider{box-shadow:0 0 0 8px ", (0, $7GaV5.hexToCssRgba)(a, .25), ";}}label{z-index:1;pointer-events:none;padding:7px 28px 9px 28px;}}.switch-slider{height:100%;background-color:", s, ";border-radius:", l, ";box-sizing:border-box;padding:7px 28px 9px 28px;border:solid ", x, " ", e, ";position:absolute;transition-properties:left,width;transition-duration:", h, ";transition-timing-function:", u, ";&:hover{box-shadow:0 0 0 8px ", (0, $7GaV5.hexToCssRgba)(a, .25), ";}}");
};

});

parcelRegister("b4YfI", function(module, exports) {

$parcel$export(module.exports, "ToggleSwitchButtonStyled", () => $810ece4ba3a2893d$export$4f658901e95cadc6);

var $1poQt = parcelRequire("1poQt");
parcelRequire("f5Egd");
var $6xSYO = parcelRequire("6xSYO");

var $cfkQ7 = parcelRequire("cfkQ7");
var $810ece4ba3a2893d$var$t = function(o) {
    var e = o.theme.sizeBorderRadiusXl;
    return (0, $6xSYO.default)("border:hidden;outline:none;position:relative;cursor:pointer;border-radius:", e, ";");
};
var $810ece4ba3a2893d$export$4f658901e95cadc6 = (0, $1poQt.default)((0, $cfkQ7.ToggleSwitchButton), {
    target: "e83u3v70"
})($810ece4ba3a2893d$var$t);

});


parcelRegister("8FTdl", function(module, exports) {
"use strict";
const $650cfb764367bafd$var$defaultUnitsThresholds = {
    "24e5faba-9761-4669-bcc7-05060f0eeccb": "10",
    // Equipment
    "aaf5eae1-6889-4638-927a-527d511483a5": "30",
    // Footwear
    "d3169f60-9d03-4ba0-818f-58e1967ce8e3": "10" // Apparel
};
const $650cfb764367bafd$var$productTypes = [
    {
        label: "Apparel",
        value: "d3169f60-9d03-4ba0-818f-58e1967ce8e3"
    },
    {
        label: "Equipment",
        value: "24e5faba-9761-4669-bcc7-05060f0eeccb"
    },
    {
        label: "Footwear",
        value: "aaf5eae1-6889-4638-927a-527d511483a5"
    }
];
const $650cfb764367bafd$var$unitsThresholds = [
    {
        label: "0",
        value: "0"
    },
    {
        label: "10",
        value: "10"
    },
    {
        label: "20",
        value: "20"
    },
    {
        label: "30",
        value: "30"
    },
    {
        label: "40",
        value: "40"
    },
    {
        label: "50",
        value: "50"
    },
    {
        label: "60",
        value: "60"
    },
    {
        label: "70",
        value: "70"
    },
    {
        label: "80",
        value: "80"
    },
    {
        label: "90",
        value: "90"
    },
    {
        label: "100",
        value: "100"
    }
];
module.exports = {
    defaultUnitsThresholds: $650cfb764367bafd$var$defaultUnitsThresholds,
    productTypes: $650cfb764367bafd$var$productTypes,
    unitsThresholds: $650cfb764367bafd$var$unitsThresholds
};

});

parcelRegister("54u2G", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $3b14a143d17d6e9d$export$1e511d4a378977f5, (v) => $3b14a143d17d6e9d$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $3b14a143d17d6e9d$export$2e2bcd8739ae039, (v) => $3b14a143d17d6e9d$export$2e2bcd8739ae039 = v);
var $3b14a143d17d6e9d$export$1e511d4a378977f5;
var $3b14a143d17d6e9d$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$3b14a143d17d6e9d$export$1e511d4a378977f5 = true;
$3b14a143d17d6e9d$export$2e2bcd8739ae039 = void 0;

var $kf90S = parcelRequire("kf90S");
var $fb6hm = parcelRequire("fb6hm");

var $3b14a143d17d6e9d$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $3b14a143d17d6e9d$var$_react = $3b14a143d17d6e9d$var$_interopRequireWildcard((parcelRequire("acw62")));

var $3b14a143d17d6e9d$var$_Auth = $1jnue((parcelRequire("fIPMX")));

var $3b14a143d17d6e9d$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $lioyy = parcelRequire("lioyy");

var $ilYXe = parcelRequire("ilYXe");

var $6zLPD = parcelRequire("6zLPD");

var $ikfii = parcelRequire("ikfii");
function $3b14a143d17d6e9d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3b14a143d17d6e9d$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $3b14a143d17d6e9d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $3b14a143d17d6e9d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $3b14a143d17d6e9d$var$SOHHome = ({ deleteError: deleteError, deleteSuccess: deleteSuccess, handleDelete: handleDelete, isDeleting: isDeleting, quantityFilter: quantityFilter, setIsDeleting: setIsDeleting, soh: soh, sohSortDirection: sohSortDirection, toggleSOHSortDirection: toggleSOHSortDirection })=>{
    const translate = (0, $3b14a143d17d6e9d$var$_useTranslate.default)();
    const deleteErrors = new Set();
    const deleteSuccesses = new Set();
    const sohError = soh.filter(({ error: error })=>error).map((badItem)=>`${badItem.styleColor} - ${badItem.error}`).join(" ** ");
    const products = soh.filter(({ error: error })=>!error);
    const canDelete = $3b14a143d17d6e9d$var$_Auth.default.requiresRole40($3b14a143d17d6e9d$var$_Auth.default.getAuth());
    const deleteProductFromPromotion = (promotionId, items)=>(()=>(0, $ilYXe.patchPromotion)(promotionId, {
                updates: (0, $6zLPD.formatPromotionPatchDeleteItems)(items),
                ...(0, $6zLPD.formatStoreInfo)()
            }).then((res)=>{
                var _res$errors;
                if (res !== null && res !== void 0 && (_res$errors = res.errors) !== null && _res$errors !== void 0 && _res$errors.length) // eslint-disable-next-line fp/no-throw
                throw Error(res.errors);
                return deleteSuccesses.add(promotionId);
            }).catch((err)=>deleteErrors.add(`${promotionId} ${err.message}`)))();
    const deleteProductsFromPromotions = async (sohProducts)=>{
        setIsDeleting(true);
        deleteErrors.clear();
        deleteSuccesses.clear();
        // { promotionId: [{ gtin, styleColor, productId }] }
        const promotionGroups = Object.entries((0, $6zLPD.groupSOHByPromotionId)(sohProducts));
        const promises = promotionGroups.map(([promotionId, items])=>deleteProductFromPromotion(promotionId, items));
        await Promise.all(promises)// handleDelete sets error/success messages, fetches the sohProducts, and sets them as the products for ProductsDisplay
        .then(()=>handleDelete(deleteErrors, deleteSuccesses, promotionGroups.length, sohProducts.length));
        setIsDeleting(false);
    };
    const SortIcon = (0, $3b14a143d17d6e9d$var$_react.useMemo)(()=>sohSortDirection === "desc" ? $fb6hm.SortDescending : $kf90S.SortAscending, [
        sohSortDirection
    ]);
    return /*#__PURE__*/ $3b14a143d17d6e9d$var$_react.default.createElement($ikfii.ContentLoads, {
        isLoading: isDeleting
    }, /*#__PURE__*/ $3b14a143d17d6e9d$var$_react.default.createElement($ikfii.Messages, {
        error: deleteError || sohError,
        success: deleteSuccess
    }), products.length > 0 && /*#__PURE__*/ $3b14a143d17d6e9d$var$_react.default.createElement("section", {
        className: "d-sm-flx flx-jc-sm-fe"
    }, /*#__PURE__*/ $3b14a143d17d6e9d$var$_react.default.createElement($ikfii.Button, {
        icon: /*#__PURE__*/ $3b14a143d17d6e9d$var$_react.default.createElement(SortIcon, {
            style: {
                margin: "0.27rem -1.5rem"
            },
            title: "Sort SOH"
        }),
        sectionClassName: "pr1-sm",
        onClick: toggleSOHSortDirection
    }), canDelete && /*#__PURE__*/ $3b14a143d17d6e9d$var$_react.default.createElement("section", {
        className: "ta-sm-l d-sm-flx flx-jc-sm-fe"
    }, /*#__PURE__*/ $3b14a143d17d6e9d$var$_react.default.createElement($ikfii.ButtonPopup, {
        className: "mb2-sm ncss-btn-secondary-dark",
        isSubmitting: isDeleting,
        label: /*#__PURE__*/ $3b14a143d17d6e9d$var$_react.default.createElement($lioyy.Delete, {
            style: {
                margin: "0.1rem -0.5rem"
            }
        }),
        subtitle: translate(quantityFilter.filter === "minimumQuantity" ? "RL_ProductDeleteConfirm2" : "RL_ProductDeleteConfirm1", quantityFilter.quantity),
        onSubmit: ()=>deleteProductsFromPromotions(products)
    }))), /*#__PURE__*/ $3b14a143d17d6e9d$var$_react.default.createElement($ikfii.ProductsDisplay, {
        isStockOnHand: true,
        canDelete: canDelete,
        popupSubtitle: translate("RL_ProductDeleteConfirm3"),
        products: products,
        title: `${translate("RL_PromotionalProductsWith")} ${quantityFilter.filter === "minimumQuantity" ? ">=" : "<="} ${quantityFilter.quantity} ${translate("RL_Units")}`,
        onStockOnHandDelete: (product)=>deleteProductsFromPromotions([
                product
            ])
    }));
};
$3b14a143d17d6e9d$var$SOHHome.propTypes = {
    deleteError: $3b14a143d17d6e9d$var$_propTypes.default.string.isRequired,
    deleteSuccess: $3b14a143d17d6e9d$var$_propTypes.default.string.isRequired,
    handleDelete: $3b14a143d17d6e9d$var$_propTypes.default.func.isRequired,
    isDeleting: $3b14a143d17d6e9d$var$_propTypes.default.bool.isRequired,
    quantityFilter: $3b14a143d17d6e9d$var$_propTypes.default.shape({
        filter: $3b14a143d17d6e9d$var$_propTypes.default.string.isRequired,
        quantity: $3b14a143d17d6e9d$var$_propTypes.default.string.isRequired
    }).isRequired,
    setIsDeleting: $3b14a143d17d6e9d$var$_propTypes.default.func.isRequired,
    soh: $3b14a143d17d6e9d$var$_propTypes.default.arrayOf($3b14a143d17d6e9d$var$_propTypes.default.shape({
        name: $3b14a143d17d6e9d$var$_propTypes.default.string.isRequired,
        promotionIds: $3b14a143d17d6e9d$var$_propTypes.default.arrayOf($3b14a143d17d6e9d$var$_propTypes.default.string),
        stockOnHand: $3b14a143d17d6e9d$var$_propTypes.default.number
    })).isRequired,
    sohSortDirection: $3b14a143d17d6e9d$var$_propTypes.default.string.isRequired,
    toggleSOHSortDirection: $3b14a143d17d6e9d$var$_propTypes.default.func.isRequired
};
var $3b14a143d17d6e9d$var$_default = $3b14a143d17d6e9d$export$2e2bcd8739ae039 = $3b14a143d17d6e9d$var$SOHHome;

});
parcelRegister("kf90S", function(module, exports) {

$parcel$export(module.exports, "SortAscending", () => $ebcc333280c4957e$export$d712e6551bccd398);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $ebcc333280c4957e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ebcc333280c4957e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ebcc333280c4957e$var$_typeof(o);
}
function $ebcc333280c4957e$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ebcc333280c4957e$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ebcc333280c4957e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ebcc333280c4957e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ebcc333280c4957e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ebcc333280c4957e$var$_defineProperty(obj, key, value) {
    key = $ebcc333280c4957e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ebcc333280c4957e$var$_toPropertyKey(t) {
    var i = $ebcc333280c4957e$var$_toPrimitive(t, "string");
    return "symbol" == $ebcc333280c4957e$var$_typeof(i) ? i : String(i);
}
function $ebcc333280c4957e$var$_toPrimitive(t, r) {
    if ("object" != $ebcc333280c4957e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $ebcc333280c4957e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ebcc333280c4957e$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M12 14.25H3m4.5-4.5H3m13.5 9H3m10.5-9.46l3.71-3.71 3.71 3.71M17.25 15V6"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M12 14.25H3m4.5-4.5H3m13.5 9H3m10.5-9.46l3.71-3.71 3.71 3.71M17.25 15V6"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M24 28.5H6m9-9H6m27 18H6m21-18.92l7.42-7.42 7.42 7.42M34.5 30V12"
    }))
};
var $ebcc333280c4957e$export$d712e6551bccd398 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $ebcc333280c4957e$var$_objectSpread($ebcc333280c4957e$var$_objectSpread({}, props), {}, {
        paths: $ebcc333280c4957e$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("fb6hm", function(module, exports) {

$parcel$export(module.exports, "SortDescending", () => $b0ccc0fbfe0f88b4$export$c31c60d3eb623d05);

var $acw62 = parcelRequire("acw62");

var $kc63j = parcelRequire("kc63j");
function $b0ccc0fbfe0f88b4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b0ccc0fbfe0f88b4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b0ccc0fbfe0f88b4$var$_typeof(o);
}
function $b0ccc0fbfe0f88b4$var$ownKeys(e, r) {
    var t = Object.keys(e), o;
    if (Object.getOwnPropertySymbols) {
        o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b0ccc0fbfe0f88b4$var$_objectSpread(e) {
    var r, t;
    for(r = 1; r < arguments.length; r++){
        t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b0ccc0fbfe0f88b4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b0ccc0fbfe0f88b4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b0ccc0fbfe0f88b4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b0ccc0fbfe0f88b4$var$_defineProperty(obj, key, value) {
    key = $b0ccc0fbfe0f88b4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b0ccc0fbfe0f88b4$var$_toPropertyKey(t) {
    var i = $b0ccc0fbfe0f88b4$var$_toPrimitive(t, "string");
    return "symbol" == $b0ccc0fbfe0f88b4$var$_typeof(i) ? i : String(i);
}
function $b0ccc0fbfe0f88b4$var$_toPrimitive(t, r) {
    if ("object" != $b0ccc0fbfe0f88b4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive], i;
    if (void 0 !== e) {
        i = e.call(t, r || "default");
        if ("object" != $b0ccc0fbfe0f88b4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $b0ccc0fbfe0f88b4$var$compPaths = {
    s: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M12.01 9.75h-9m4.5 4.5h-4.5m13.5-9H3.01M17.26 9v9m3.71-3.27l-3.71 3.71-3.71-3.71"
    })),
    m: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "1.5",
        d: "M12.01 9.75h-9m4.5 4.5h-4.5m13.5-9H3.01M17.26 9v9m3.71-3.27l-3.71 3.71-3.71-3.71"
    })),
    l: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        stroke: "currentColor",
        strokeMiterlimit: "10",
        strokeWidth: "3",
        d: "M24.02 19.5h-18m9 9h-9m27-18h-27m28.5 7.5v18m7.422-6.54l-7.42 7.42-7.42-7.42"
    }))
};
var $b0ccc0fbfe0f88b4$export$c31c60d3eb623d05 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kc63j.SvgIcon), $b0ccc0fbfe0f88b4$var$_objectSpread($b0ccc0fbfe0f88b4$var$_objectSpread({}, props), {}, {
        paths: $b0ccc0fbfe0f88b4$var$compPaths,
        fill: "none"
    }));
});

});

parcelRegister("lioyy", function(module, exports) {

$parcel$export(module.exports, "Delete", () => $f80e53d02b4e1b3b$export$bfadae053a633538, (v) => $f80e53d02b4e1b3b$export$bfadae053a633538 = v);
var $f80e53d02b4e1b3b$export$1e511d4a378977f5;
var $f80e53d02b4e1b3b$export$bfadae053a633538;
"use strict";

var $1jnue = parcelRequire("1jnue");
$f80e53d02b4e1b3b$export$1e511d4a378977f5 = true;

var $f80e53d02b4e1b3b$var$_Delete = $1jnue((parcelRequire("9DdIR")));
$f80e53d02b4e1b3b$export$bfadae053a633538 = $f80e53d02b4e1b3b$var$_Delete.default;

});
parcelRegister("9DdIR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $7032669412666a64$export$1e511d4a378977f5, (v) => $7032669412666a64$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $7032669412666a64$export$2e2bcd8739ae039, (v) => $7032669412666a64$export$2e2bcd8739ae039 = v);
var $7032669412666a64$export$1e511d4a378977f5;
var $7032669412666a64$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$7032669412666a64$export$1e511d4a378977f5 = true;
$7032669412666a64$export$2e2bcd8739ae039 = void 0;

var $7032669412666a64$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $7032669412666a64$var$_react = $1jnue((parcelRequire("acw62")));
const $7032669412666a64$var$Delete = ({ style: style })=>/*#__PURE__*/ $7032669412666a64$var$_react.default.createElement("svg", {
        fill: "none",
        height: "24",
        style: style,
        title: "delete icon",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $7032669412666a64$var$_react.default.createElement("path", {
        d: "M14.25 7.5V19.5",
        stroke: "#111111",
        strokeMiterlimit: "10",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ $7032669412666a64$var$_react.default.createElement("path", {
        d: "M9.75 7.5V19.5",
        stroke: "#111111",
        strokeMiterlimit: "10",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ $7032669412666a64$var$_react.default.createElement("path", {
        d: "M5.25 6V19.5C5.25 20.74 6.26 21.75 7.5 21.75H16.5C17.74 21.75 18.75 20.74 18.75 19.5V5.25H21.5",
        stroke: "#111111",
        strokeMiterlimit: "10",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ $7032669412666a64$var$_react.default.createElement("path", {
        d: "M18.75 5.25H21",
        stroke: "#111111",
        strokeMiterlimit: "10",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ $7032669412666a64$var$_react.default.createElement("path", {
        d: "M9 2.25H14.25C15.08 2.25 15.75 2.92 15.75 3.75C15.75 4.58 15.08 5.25 14.25 5.25H3",
        stroke: "#111111",
        strokeMiterlimit: "10",
        strokeWidth: "1.5"
    }));
$7032669412666a64$var$Delete.defaultProps = {
    style: {
        margin: "0.1rem -1rem"
    }
};
$7032669412666a64$var$Delete.propTypes = {
    style: $7032669412666a64$var$_propTypes.default.shape()
};
var $7032669412666a64$var$_default = $7032669412666a64$export$2e2bcd8739ae039 = $7032669412666a64$var$Delete;

});




parcelRegister("3J8Aw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $2b6c3c776bd852e3$export$1e511d4a378977f5, (v) => $2b6c3c776bd852e3$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2b6c3c776bd852e3$export$2e2bcd8739ae039, (v) => $2b6c3c776bd852e3$export$2e2bcd8739ae039 = v);
var $2b6c3c776bd852e3$export$1e511d4a378977f5;
var $2b6c3c776bd852e3$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$2b6c3c776bd852e3$export$1e511d4a378977f5 = true;
$2b6c3c776bd852e3$export$2e2bcd8739ae039 = void 0;

var $2b6c3c776bd852e3$var$_react = $2b6c3c776bd852e3$var$_interopRequireWildcard((parcelRequire("acw62")));


var $2b6c3c776bd852e3$var$_UploadHome = $1jnue((parcelRequire("ejiha")));
function $2b6c3c776bd852e3$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($2b6c3c776bd852e3$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $2b6c3c776bd852e3$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $2b6c3c776bd852e3$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $2b6c3c776bd852e3$var$Upload = ()=>{
    const [uploadBatches, setUploadBatches] = (0, $2b6c3c776bd852e3$var$_react.useState)([]);
    const uploadRef = (0, $2b6c3c776bd852e3$var$_react.useRef)(null);
    // eslint-disable-next-line fp/no-mutation
    uploadRef.current = uploadBatches;
    return /*#__PURE__*/ $2b6c3c776bd852e3$var$_react.default.createElement("div", null, /*#__PURE__*/ $2b6c3c776bd852e3$var$_react.default.createElement($2b6c3c776bd852e3$var$_UploadHome.default, {
        setUploadBatches: setUploadBatches,
        uploadRef: uploadRef
    }));
};
var $2b6c3c776bd852e3$var$_default = $2b6c3c776bd852e3$export$2e2bcd8739ae039 = $2b6c3c776bd852e3$var$Upload;

});
parcelRegister("ejiha", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $a6b10445e0c8c7e1$export$1e511d4a378977f5, (v) => $a6b10445e0c8c7e1$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $a6b10445e0c8c7e1$export$2e2bcd8739ae039, (v) => $a6b10445e0c8c7e1$export$2e2bcd8739ae039 = v);
var $a6b10445e0c8c7e1$export$1e511d4a378977f5;
var $a6b10445e0c8c7e1$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$a6b10445e0c8c7e1$export$1e511d4a378977f5 = true;
$a6b10445e0c8c7e1$export$2e2bcd8739ae039 = void 0;

var $3cu5Z = parcelRequire("3cu5Z");

var $e080M = parcelRequire("e080M");

var $a6b10445e0c8c7e1$var$_papaparse = $1jnue((parcelRequire("gKeLP")));

var $a6b10445e0c8c7e1$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $a6b10445e0c8c7e1$var$_react = $a6b10445e0c8c7e1$var$_interopRequireWildcard((parcelRequire("acw62")));

var $7Yi7V = parcelRequire("7Yi7V");

var $a6b10445e0c8c7e1$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $ilYXe = parcelRequire("ilYXe");

var $5enz3 = parcelRequire("5enz3");

var $ikfii = parcelRequire("ikfii");

var $a6b10445e0c8c7e1$var$_LeavePageBlocker = $1jnue((parcelRequire("11pJC")));

var $a6b10445e0c8c7e1$var$_UploadReport = $1jnue((parcelRequire("bz9qw")));
function $a6b10445e0c8c7e1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($a6b10445e0c8c7e1$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $a6b10445e0c8c7e1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $a6b10445e0c8c7e1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $a6b10445e0c8c7e1$var$UploadHome = ({ setUploadBatches: setUploadBatches, uploadRef: uploadRef })=>{
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, $a6b10445e0c8c7e1$var$_react.useState)(true);
    const [isSubmitting, setIsSubmitting] = (0, $a6b10445e0c8c7e1$var$_react.useState)(false);
    const [isUploadInProgress, setIsUploadInProgress] = (0, $a6b10445e0c8c7e1$var$_react.useState)(false);
    const [translationAttributes, setTranslationAttributes] = (0, $a6b10445e0c8c7e1$var$_react.useState)({}); // used by translate method for parameters
    const currentBatchNoRef = (0, $a6b10445e0c8c7e1$var$_react.useRef)(null);
    const translate = (0, $a6b10445e0c8c7e1$var$_useTranslate.default)();
    const [uploadStatus, setUploadStatus] = (0, $a6b10445e0c8c7e1$var$_react.useState)({
        failureCount: 0,
        isError: false,
        isUploadCompleted: false,
        status: [],
        statusText: null,
        successCount: 0,
        totalCompleted: 0,
        totalUploads: 0,
        uploadId: null
    });
    const csvRef = (0, $a6b10445e0c8c7e1$var$_react.useRef)(null);
    const uploadStatusRef = (0, $a6b10445e0c8c7e1$var$_react.useRef)(null);
    const statusRef = (0, $a6b10445e0c8c7e1$var$_react.useRef)(null);
    // eslint-disable-next-line fp/no-mutation
    uploadStatusRef.current = uploadStatus;
    const btnRef = (0, $a6b10445e0c8c7e1$var$_react.useRef)(null);
    const [csvHeaders, setCsvHeaders] = (0, $a6b10445e0c8c7e1$var$_react.useState)([]);
    const executeScroll = ()=>{
        var _statusRef$current;
        return (_statusRef$current = statusRef.current) === null || _statusRef$current === void 0 ? void 0 : _statusRef$current.scrollIntoView();
    };
    const getNextBatchForUpload = (lastBatchNo = 0)=>{
        const thisUploadBatches = uploadRef.current;
        const nextBatch = thisUploadBatches.find((item)=>item.batchNo === lastBatchNo + 1);
        if (!nextBatch) return null;
        return {
            ...nextBatch,
            chunk: [
                csvHeaders,
                ...nextBatch.chunk
            ]
        };
    };
    const [inputCsvJsonData, setInputCsvJsonData] = (0, $a6b10445e0c8c7e1$var$_react.useState)([]);
    const onBatchSuccess = async (batchResponse)=>{
        const { results: batchResults, uploadId: responseUploadId } = batchResponse;
        const batchCount = batchResults.length;
        const batchSuccessCount = batchResults.filter((item)=>!item.errors.length).length;
        const batchFailureCount = batchCount - batchSuccessCount;
        const processedRows = batchResults.map((item)=>item.rowNo);
        setUploadStatus((prevState)=>{
            const totalCompleted = prevState.totalCompleted + batchCount;
            const newStatus = prevState.status.map((currentItem)=>{
                const updatedItem = processedRows.includes(currentItem.rowNo) ? batchResults.find((item)=>item.rowNo === currentItem.rowNo) : null;
                return updatedItem ? {
                    ...updatedItem,
                    status: updatedItem.errors.length ? $7Yi7V.CSV_UPLOAD.STATUS_FAILURE : $7Yi7V.CSV_UPLOAD.STATUS_SUCCESS
                } : currentItem;
            });
            return {
                ...prevState,
                failureCount: prevState.failureCount + batchFailureCount,
                isUploadCompleted: totalCompleted === prevState.totalUploads,
                status: newStatus,
                statusText: "RL_PleaseWait",
                successCount: prevState.successCount + batchSuccessCount,
                totalCompleted: totalCompleted,
                uploadId: prevState.uploadId || responseUploadId
            };
        });
    };
    const onBatchFailure = ()=>{
        const lastBatchNo = currentBatchNoRef.current;
        const lastBatch = uploadRef.current.find((item)=>item.batchNo === lastBatchNo);
        const batchCount = lastBatch.chunk.length;
        const batchSuccessCount = 0;
        const batchFailureCount = batchCount;
        const processedRows = lastBatch.chunk.map((item)=>item[0]);
        setUploadStatus((prevState)=>{
            const totalCompleted = prevState.totalCompleted + batchCount;
            const newStatus = prevState.status.map((currentItem)=>{
                const updatedItem = processedRows.includes(currentItem.rowNo) ? {
                    ...currentItem,
                    errors: [
                        {
                            errorCode: "UNEXPECTED_FAILURE",
                            errorMessage: "Unexpected Failure"
                        }
                    ]
                } : null;
                return updatedItem ? {
                    ...updatedItem,
                    status: updatedItem.errors.length ? $7Yi7V.CSV_UPLOAD.STATUS_FAILURE : $7Yi7V.CSV_UPLOAD.STATUS_SUCCESS
                } : currentItem;
            });
            return {
                ...prevState,
                failureCount: prevState.failureCount + batchFailureCount,
                isUploadCompleted: totalCompleted === prevState.totalUploads,
                status: newStatus,
                statusText: "RL_PleaseWait",
                successCount: prevState.successCount + batchSuccessCount,
                totalCompleted: totalCompleted
            };
        });
    };
    const getLastBatch = (prevState, lastBatchNo)=>{
        const updatedBatches = prevState.map((item)=>item.batchNo === lastBatchNo ? {
                ...item,
                isProcessed: true
            } : item);
        return updatedBatches;
    };
    const updateLastBatchStatus = (lastBatchNo)=>{
        setUploadBatches((prevState)=>[
                ...getLastBatch(prevState, lastBatchNo)
            ]);
    };
    const allBatchesCompleted = ()=>{
        setIsSubmitting(false);
        setIsUploadInProgress(false);
        setUploadStatus((prevState)=>({
                ...prevState,
                statusText: "RL_UploadComplete"
            }));
        setTimeout(()=>{
            executeScroll();
        }, 10);
    };
    const onBatchComplete = (response, isSuccess = true)=>{
        const batchNo = isSuccess ? response.batchNo : currentBatchNoRef.current;
        if (isSuccess) onBatchSuccess(response);
        else onBatchFailure(response);
        const lastBatchNo = parseInt(batchNo, 10);
        updateLastBatchStatus(lastBatchNo);
        // eslint-disable-next-line no-use-before-define
        setTimeout(()=>onUpload(lastBatchNo), $7Yi7V.CSV_UPLOAD.BATCH_INTERVAL_MS);
    };
    const uploadFail = ()=>{
        setIsSubmitDisabled(true);
        setIsUploadInProgress(false);
        setIsSubmitting(false);
        setUploadStatus({
            isError: true,
            statusText: `Error: API Validation failed.`
        });
        setInputCsvJsonData({});
    };
    const uploadNextBatch = async (nextBatchJson, batchNo)=>{
        const isLastBatch = batchNo === uploadStatusRef.current.totalUploads;
        (0, $ilYXe.postCsvUpload)(nextBatchJson, uploadStatusRef.current.uploadId, batchNo, isLastBatch).then((response)=>{
            var _JSON$parse, _response$value;
            const apiContractError = (_JSON$parse = JSON.parse((response === null || response === void 0 ? void 0 : (_response$value = response.value) === null || _response$value === void 0 ? void 0 : _response$value.body) || null)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.errors;
            if (apiContractError) return uploadFail();
            onBatchComplete(response);
            return true;
        }).catch((error)=>{
            onBatchComplete(error, false);
            return true;
        });
    };
    const onUpload = (lastBatchNo)=>{
        const nextBatch = getNextBatchForUpload(lastBatchNo);
        if (!nextBatch) {
            allBatchesCompleted();
            return;
        }
        // eslint-disable-next-line fp/no-mutation
        currentBatchNoRef.current = nextBatch.batchNo;
        const nextBatchJson = nextBatch.chunk;
        uploadNextBatch(nextBatchJson, nextBatch.batchNo);
    };
    const onUploadClick = ()=>{
        setIsSubmitDisabled(true);
        setIsSubmitting(true);
        setIsUploadInProgress(true);
        onUpload();
    };
    const prepareStatusObject = (transformeCsvdData)=>{
        const { rows: rows } = (0, $5enz3.transformCsvToJsonObj)(transformeCsvdData);
        const status = rows.map((item)=>({
                ...item,
                errors: [],
                status: $7Yi7V.CSV_UPLOAD.STATUS_PROCESSING
            }));
        setUploadStatus((prevState)=>({
                ...prevState,
                status: status
            }));
    };
    const prepareUploadBatches = (transformeCsvdData)=>{
        setIsSubmitting(false);
        const dataWithoutHeader = transformeCsvdData.slice(1);
        const uploadChunks = (0, $5enz3.chunks)(dataWithoutHeader, $7Yi7V.CSV_UPLOAD.BATCH_SIZE);
        const batches = uploadChunks.map((chunk, idx)=>({
                batchNo: idx + 1,
                chunk: chunk,
                isProcessed: false
            }));
        setUploadStatus((prevState)=>({
                ...prevState,
                failureCount: 0,
                isError: false,
                isUploadCompleted: false,
                statusText: "",
                successCount: 0,
                totalCompleted: 0,
                totalUploads: dataWithoutHeader.length,
                uploadId: null
            }));
        setUploadBatches(batches);
        prepareStatusObject(transformeCsvdData);
    };
    const validateAndtransformUploadedData = (data)=>{
        const headers = data[0];
        const transformedHeaders = (0, $5enz3.extractRequiredHeaders)(headers);
        const requiredkeys = transformedHeaders.map((header)=>header.colIdx);
        const missingColumns = (0, $5enz3.getMissingColumns)(transformedHeaders);
        if (missingColumns.length) {
            setIsSubmitDisabled(true);
            setUploadStatus({
                isError: true,
                statusText: "RL_UploadMissing"
            });
            setTranslationAttributes({
                missingColumns: missingColumns
            });
            setInputCsvJsonData({});
            return;
        }
        if (data.length < 2) {
            setIsSubmitDisabled(true);
            setInputCsvJsonData({});
            return;
        }
        if (data.length <= $7Yi7V.CSV_UPLOAD.MAX_ALLOWED_ROWS + 1) setIsSubmitDisabled(false);
        else {
            setIsSubmitDisabled(true);
            setUploadStatus({
                isError: true,
                statusText: "RL_Validate"
            });
            setTranslationAttributes({
                rowsInUploadedCsv: data.length
            });
            setInputCsvJsonData({});
            return;
        }
        const extractedData = (0, $5enz3.extractNecessaryData)(data, requiredkeys);
        const requiredHeaders = extractedData[0];
        const transformeCsvdData = extractedData;
        setInputCsvJsonData(transformeCsvdData);
        setCsvHeaders(requiredHeaders);
        prepareUploadBatches(transformeCsvdData);
    };
    const handleFileChange = (event)=>{
        const file = event.target.files[0];
        if (file) $a6b10445e0c8c7e1$var$_papaparse.default.parse(file, {
            complete (results) {
                validateAndtransformUploadedData(results.data);
            }
        });
    };
    const showUploadReport = isUploadInProgress || uploadStatus.isUploadCompleted;
    const getUploadStatusText = ()=>{
        var _translationAttribute;
        const { statusText: statusText } = uploadStatus;
        return (0, $e080M.match)(statusText)([
            "RL_UploadComplete",
            translate(statusText, uploadStatus.successCount, uploadStatus.totalUploads)
        ], [
            "RL_PleaseWait",
            translate(statusText, (0, $5enz3.getProgress)(uploadStatus.totalCompleted, uploadStatus.totalUploads))
        ], [
            "RL_UploadMissing",
            `${translate(statusText)}: ${(_translationAttribute = translationAttributes.missingColumns) === null || _translationAttribute === void 0 ? void 0 : _translationAttribute.join(", ")}`
        ], [
            "RL_Validate",
            `${translate(statusText, translationAttributes.rowsInUploadedCsv, $7Yi7V.CSV_UPLOAD.MAX_ALLOWED_ROWS)}`
        ], [
            ()=>!statusText,
            statusText
        ], [
            $e080M.Default,
            ""
        ]);
    };
    return /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement($a6b10445e0c8c7e1$var$_react.default.Fragment, null, /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement("h1", {
        className: "display-3 text-color-accent mb3-sm"
    }, translate("RL_StyleUpload")), /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement("br", null), /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement("section", {
        className: "ncss-col-sm-12 ta-sm-c mt3-sm mb3-sm"
    }, /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement("section", {
        className: "ncss-col-sm-12 ta-sm-c mt3-sm mb3-sm"
    }, /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement($3cu5Z.Input, {
        key: "csv-upload",
        ref: csvRef,
        accept: ".csv",
        className: "file-upload",
        datatype: "text",
        id: "fileEditStore",
        label: "File Upload",
        type: "file",
        onChange: handleFileChange
    })), /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement("section", {
        className: "ncss-col-sm-6 ta-sm-c mt3-sm mb3-sm"
    }, /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement($ikfii.ButtonSubmit, {
        ref: btnRef,
        buttonClassName: "mb2-sm",
        isDisabled: isSubmitDisabled,
        isSubmitting: isSubmitting,
        label: translate("RL_2UploaStyle", inputCsvJsonData.length > 1 ? inputCsvJsonData.length - 1 : ""),
        sectionClassName: "ncss-col-sm-4 full",
        onSubmit: onUploadClick
    }))), uploadStatus.statusText && /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement("section", {
        ref: statusRef,
        className: `text-color-${uploadStatus.isError ? "error" : "success"} u-bold`,
        id: "status-placeholder"
    }, getUploadStatusText()), /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement("br", null), showUploadReport && /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement($a6b10445e0c8c7e1$var$_UploadReport.default, {
        uploadStatus: uploadStatus
    }), /*#__PURE__*/ $a6b10445e0c8c7e1$var$_react.default.createElement($a6b10445e0c8c7e1$var$_LeavePageBlocker.default, {
        message: $7Yi7V.CSV_UPLOAD.WARNING_PAGE_LEAVE,
        when: isUploadInProgress
    }));
};
$a6b10445e0c8c7e1$var$UploadHome.propTypes = {
    setUploadBatches: $a6b10445e0c8c7e1$var$_propTypes.default.func.isRequired,
    uploadRef: $a6b10445e0c8c7e1$var$_propTypes.default.shape().isRequired
};
var $a6b10445e0c8c7e1$var$_default = $a6b10445e0c8c7e1$export$2e2bcd8739ae039 = $a6b10445e0c8c7e1$var$UploadHome;

});
parcelRegister("gKeLP", function(module, exports) {
/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/ !function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : module.exports = t();
}(module.exports, function s() {
    "use strict";
    var f = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== f ? f : {};
    var n = !f.document && !!f.postMessage, o = f.IS_PAPA_WORKER || !1, a = {}, u = 0, b = {
        parse: function(e, t) {
            var r = (t = t || {}).dynamicTyping || !1;
            J(r) && (t.dynamicTypingFunction = r, r = {});
            if (t.dynamicTyping = r, t.transform = !!J(t.transform) && t.transform, t.worker && b.WORKERS_SUPPORTED) {
                var i = function() {
                    if (!b.WORKERS_SUPPORTED) return !1;
                    var e = (r = f.URL || f.webkitURL || null, i = s.toString(), b.BLOB_URL || (b.BLOB_URL = r.createObjectURL(new Blob([
                        "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                        "(",
                        i,
                        ")();"
                    ], {
                        type: "text/javascript"
                    })))), t = new f.Worker(e);
                    var r, i;
                    return t.onmessage = _, t.id = u++, a[t.id] = t;
                }();
                return i.userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = J(t.step), t.chunk = J(t.chunk), t.complete = J(t.complete), t.error = J(t.error), delete t.worker, void i.postMessage({
                    input: e,
                    config: t,
                    workerId: i.id
                });
            }
            var n = null;
            b.NODE_STREAM_INPUT, "string" == typeof e ? (e = function(e) {
                if (65279 === e.charCodeAt(0)) return e.slice(1);
                return e;
            }(e), n = t.download ? new l(t) : new p(t)) : !0 === e.readable && J(e.read) && J(e.on) ? n = new g(t) : (f.File && e instanceof File || e instanceof Object) && (n = new c(t));
            return n.stream(e);
        },
        unparse: function(e, t) {
            var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, r = !1, i = null, o = !1;
            !function() {
                if ("object" != typeof t) return;
                "string" != typeof t.delimiter || b.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter);
                ("boolean" == typeof t.quotes || "function" == typeof t.quotes || Array.isArray(t.quotes)) && (n = t.quotes);
                "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (r = t.skipEmptyLines);
                "string" == typeof t.newline && (y = t.newline);
                "string" == typeof t.quoteChar && (s = t.quoteChar);
                "boolean" == typeof t.header && (_ = t.header);
                if (Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    i = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s);
                ("boolean" == typeof t.escapeFormulae || t.escapeFormulae instanceof RegExp) && (o = t.escapeFormulae instanceof RegExp ? t.escapeFormulae : /^[=+\-@\t\r].*$/);
            }();
            var u = new RegExp(Q(s), "g");
            "string" == typeof e && (e = JSON.parse(e));
            if (Array.isArray(e)) {
                if (!e.length || Array.isArray(e[0])) return h(null, e, r);
                if ("object" == typeof e[0]) return h(i || Object.keys(e[0]), e, r);
            } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || i), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
                e.data
            ])), h(e.fields || [], e.data || [], r);
            throw new Error("Unable to serialize unrecognized input");
            function h(e, t, r) {
                var i = "";
                "string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t));
                var n = Array.isArray(e) && 0 < e.length, s = !Array.isArray(t[0]);
                if (n && _) {
                    for(var a = 0; a < e.length; a++)0 < a && (i += m), i += v(e[a], a);
                    0 < t.length && (i += y);
                }
                for(var o = 0; o < t.length; o++){
                    var u = n ? e.length : t[o].length, h = !1, f = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                    if (r && !n && (h = "greedy" === r ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === r && n) {
                        for(var d = [], l = 0; l < u; l++){
                            var c = s ? e[l] : l;
                            d.push(t[o][c]);
                        }
                        h = "" === d.join("").trim();
                    }
                    if (!h) {
                        for(var p = 0; p < u; p++){
                            0 < p && !f && (i += m);
                            var g = n && s ? e[p] : p;
                            i += v(t[o][g], p);
                        }
                        o < t.length - 1 && (!r || 0 < u && !f) && (i += y);
                    }
                }
                return i;
            }
            function v(e, t) {
                if (null == e) return "";
                if (e.constructor === Date) return JSON.stringify(e).slice(1, 25);
                var r = !1;
                o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0);
                var i = e.toString().replace(u, a);
                return (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || function(e, t) {
                    for(var r = 0; r < t.length; r++)if (-1 < e.indexOf(t[r])) return !0;
                    return !1;
                }(i, b.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i;
            }
        }
    };
    if (b.RECORD_SEP = String.fromCharCode(30), b.UNIT_SEP = String.fromCharCode(31), b.BYTE_ORDER_MARK = "\uFEFF", b.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        b.BYTE_ORDER_MARK
    ], b.WORKERS_SUPPORTED = !n && !!f.Worker, b.NODE_STREAM_INPUT = 1, b.LocalChunkSize = 10485760, b.RemoteChunkSize = 5242880, b.DefaultDelimiter = ",", b.Parser = E, b.ParserHandle = r, b.NetworkStreamer = l, b.FileStreamer = c, b.StringStreamer = p, b.ReadableStreamStreamer = g, f.jQuery) {
        var d = f.jQuery;
        d.fn.parse = function(o) {
            var r = o.config || {}, u = [];
            return this.each(function(e) {
                if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && f.FileReader) || !this.files || 0 === this.files.length) return !0;
                for(var t = 0; t < this.files.length; t++)u.push({
                    file: this.files[t],
                    inputElem: this,
                    instanceConfig: d.extend({}, r)
                });
            }), e(), this;
            function e() {
                if (0 !== u.length) {
                    var e, t, r, i, n = u[0];
                    if (J(o.before)) {
                        var s = o.before(n.file, n.inputElem);
                        if ("object" == typeof s) {
                            if ("abort" === s.action) return e = "AbortError", t = n.file, r = n.inputElem, i = s.reason, void (J(o.error) && o.error({
                                name: e
                            }, t, r, i));
                            if ("skip" === s.action) return void h();
                            "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                        } else if ("skip" === s) return void h();
                    }
                    var a = n.instanceConfig.complete;
                    n.instanceConfig.complete = function(e) {
                        J(a) && a(e, n.file, n.inputElem), h();
                    }, b.parse(n.file, n.instanceConfig);
                } else J(o.complete) && o.complete();
            }
            function h() {
                u.splice(0, 1), e();
            }
        };
    }
    function h(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = w(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new r(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(e, t) {
            if (this.isFirstChunk && J(this._config.beforeFirstChunk)) {
                var r = this._config.beforeFirstChunk(e);
                void 0 !== r && (e = r);
            }
            this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + e;
            this._partialLine = "";
            var n = this._handle.parse(i, this._baseIndex, !this._finished);
            if (!this._handle.paused() && !this._handle.aborted()) {
                var s = n.meta.cursor;
                this._finished || (this._partialLine = i.substring(s - this._baseIndex), this._baseIndex = s), n && n.data && (this._rowCount += n.data.length);
                var a = this._finished || this._config.preview && this._rowCount >= this._config.preview;
                if (o) f.postMessage({
                    results: n,
                    workerId: b.WORKER_ID,
                    finished: a
                });
                else if (J(this._config.chunk) && !t) {
                    if (this._config.chunk(n, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    n = void 0, this._completeResults = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(n.data), this._completeResults.errors = this._completeResults.errors.concat(n.errors), this._completeResults.meta = n.meta), this._completed || !a || !J(this._config.complete) || n && n.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), a || n && n.meta.paused || this._nextChunk(), n;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            J(this._config.error) ? this._config.error(e) : o && this._config.error && f.postMessage({
                workerId: b.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function l(e) {
        var i;
        (e = e || {}).chunkSize || (e.chunkSize = b.RemoteChunkSize), h.call(this, e), this._nextChunk = n ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (i = new XMLHttpRequest, this._config.withCredentials && (i.withCredentials = this._config.withCredentials), n || (i.onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)), i.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !n), this._config.downloadRequestHeaders) {
                    var e = this._config.downloadRequestHeaders;
                    for(var t in e)i.setRequestHeader(t, e[t]);
                }
                if (this._config.chunkSize) {
                    var r = this._start + this._config.chunkSize - 1;
                    i.setRequestHeader("Range", "bytes=" + this._start + "-" + r);
                }
                try {
                    i.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                n && 0 === i.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === i.readyState && (i.status < 200 || 400 <= i.status ? this._chunkError() : (this._start += this._config.chunkSize ? this._config.chunkSize : i.responseText.length, this._finished = !this._config.chunkSize || this._start >= function(e) {
                var t = e.getResponseHeader("Content-Range");
                if (null === t) return -1;
                return parseInt(t.substring(t.lastIndexOf("/") + 1));
            }(i), this.parseChunk(i.responseText)));
        }, this._chunkError = function(e) {
            var t = i.statusText || e;
            this._sendError(new Error(t));
        };
    }
    function c(e) {
        var i, n;
        (e = e || {}).chunkSize || (e.chunkSize = b.LocalChunkSize), h.call(this, e);
        var s = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, n = e.slice || e.webkitSlice || e.mozSlice, s ? ((i = new FileReader).onload = v(this._chunkLoaded, this), i.onerror = v(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input;
            if (this._config.chunkSize) {
                var t = Math.min(this._start + this._config.chunkSize, this._input.size);
                e = n.call(e, this._start, t);
            }
            var r = i.readAsText(e, this._config.encoding);
            s || this._chunkLoaded({
                target: {
                    result: r
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function p(e) {
        var r;
        h.call(this, e = e || {}), this.stream = function(e) {
            return r = e, this._nextChunk();
        }, this._nextChunk = function() {
            if (!this._finished) {
                var e, t = this._config.chunkSize;
                return t ? (e = r.substring(0, t), r = r.substring(t)) : (e = r, r = ""), this._finished = !r, this.parseChunk(e);
            }
        };
    }
    function g(e) {
        h.call(this, e = e || {});
        var t = [], r = !0, i = !1;
        this.pause = function() {
            h.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            h.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            i && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : r = !0;
        }, this._streamData = v(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), r && (r = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = v(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = v(function() {
            this._streamCleanUp(), i = !0, this._streamData("");
        }, this), this._streamCleanUp = v(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function r(m) {
        var a, o, u, i = Math.pow(2, 53), n = -i, s = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, h = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, t = this, r = 0, f = 0, d = !1, e = !1, l = [], c = {
            data: [],
            errors: [],
            meta: {}
        };
        if (J(m.step)) {
            var p = m.step;
            m.step = function(e) {
                if (c = e, _()) g();
                else {
                    if (g(), 0 === c.data.length) return;
                    r += e.data.length, m.preview && r > m.preview ? o.abort() : (c.data = c.data[0], p(c, t));
                }
            };
        }
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            return c && u && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + b.DefaultDelimiter + "'"), u = !1), m.skipEmptyLines && (c.data = c.data.filter(function(e) {
                return !y(e);
            })), _() && function() {
                if (!c) return;
                function e(e, t) {
                    J(m.transformHeader) && (e = m.transformHeader(e, t)), l.push(e);
                }
                if (Array.isArray(c.data[0])) {
                    for(var t = 0; _() && t < c.data.length; t++)c.data[t].forEach(e);
                    c.data.splice(0, 1);
                } else c.data.forEach(e);
            }(), function() {
                if (!c || !m.header && !m.dynamicTyping && !m.transform) return c;
                function e(e, t) {
                    var r, i = m.header ? {} : [];
                    for(r = 0; r < e.length; r++){
                        var n = r, s = e[r];
                        m.header && (n = r >= l.length ? "__parsed_extra" : l[r]), m.transform && (s = m.transform(s, n)), s = v(n, s), "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                    }
                    return m.header && (r > l.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + l.length + " fields but parsed " + r, f + t) : r < l.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + l.length + " fields but parsed " + r, f + t)), i;
                }
                var t = 1;
                !c.data.length || Array.isArray(c.data[0]) ? (c.data = c.data.map(e), t = c.data.length) : c.data = e(c.data, 0);
                m.header && c.meta && (c.meta.fields = l);
                return f += t, c;
            }();
        }
        function _() {
            return m.header && 0 === l.length;
        }
        function v(e, t) {
            var r;
            return r = e, m.dynamicTypingFunction && void 0 === m.dynamicTyping[r] && (m.dynamicTyping[r] = m.dynamicTypingFunction(r)), !0 === (m.dynamicTyping[r] || m.dynamicTyping) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (function(e) {
                if (s.test(e)) {
                    var t = parseFloat(e);
                    if (n < t && t < i) return !0;
                }
                return !1;
            }(t) ? parseFloat(t) : h.test(t) ? new Date(t) : "" === t ? null : t) : t;
        }
        function k(e, t, r, i) {
            var n = {
                type: e,
                code: t,
                message: r
            };
            void 0 !== i && (n.row = i), c.errors.push(n);
        }
        this.parse = function(e, t, r) {
            var i = m.quoteChar || '"';
            if (m.newline || (m.newline = function(e, t) {
                e = e.substring(0, 1048576);
                var r = new RegExp(Q(t) + "([^]*?)" + Q(t), "gm"), i = (e = e.replace(r, "")).split("\r"), n = e.split("\n"), s = 1 < n.length && n[0].length < i[0].length;
                if (1 === i.length || s) return "\n";
                for(var a = 0, o = 0; o < i.length; o++)"\n" === i[o][0] && a++;
                return a >= i.length / 2 ? "\r\n" : "\r";
            }(e, i)), u = !1, m.delimiter) J(m.delimiter) && (m.delimiter = m.delimiter(e), c.meta.delimiter = m.delimiter);
            else {
                var n = function(e, t, r, i, n) {
                    var s, a, o, u;
                    n = n || [
                        ",",
                        "	",
                        "|",
                        ";",
                        b.RECORD_SEP,
                        b.UNIT_SEP
                    ];
                    for(var h = 0; h < n.length; h++){
                        var f = n[h], d = 0, l = 0, c = 0;
                        o = void 0;
                        for(var p = new E({
                            comments: i,
                            delimiter: f,
                            newline: t,
                            preview: 10
                        }).parse(e), g = 0; g < p.data.length; g++)if (r && y(p.data[g])) c++;
                        else {
                            var _ = p.data[g].length;
                            l += _, void 0 !== o ? 0 < _ && (d += Math.abs(_ - o), o = _) : o = _;
                        }
                        0 < p.data.length && (l /= p.data.length - c), (void 0 === a || d <= a) && (void 0 === u || u < l) && 1.99 < l && (a = d, s = f, u = l);
                    }
                    return {
                        successful: !!(m.delimiter = s),
                        bestDelimiter: s
                    };
                }(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess);
                n.successful ? m.delimiter = n.bestDelimiter : (u = !0, m.delimiter = b.DefaultDelimiter), c.meta.delimiter = m.delimiter;
            }
            var s = w(m);
            return m.preview && m.header && s.preview++, a = e, o = new E(s), c = o.parse(a, t, r), g(), d ? {
                meta: {
                    paused: !0
                }
            } : c || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return d;
        }, this.pause = function() {
            d = !0, o.abort(), a = J(m.chunk) ? "" : a.substring(o.getCharIndex());
        }, this.resume = function() {
            t.streamer._halted ? (d = !1, t.streamer.parseChunk(a, !0)) : setTimeout(t.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, o.abort(), c.meta.aborted = !0, J(m.complete) && m.complete(c), a = "";
        };
    }
    function Q(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(j) {
        var z, M = (j = j || {}).delimiter, P = j.newline, U = j.comments, q = j.step, N = j.preview, B = j.fastMode, K = z = void 0 === j.quoteChar || null === j.quoteChar ? '"' : j.quoteChar;
        if (void 0 !== j.escapeChar && (K = j.escapeChar), ("string" != typeof M || -1 < b.BAD_DELIMITERS.indexOf(M)) && (M = ","), U === M) throw new Error("Comment character same as delimiter");
        !0 === U ? U = "#" : ("string" != typeof U || -1 < b.BAD_DELIMITERS.indexOf(U)) && (U = !1), "\n" !== P && "\r" !== P && "\r\n" !== P && (P = "\n");
        var W = 0, H = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = M.length, s = P.length, a = U.length, o = J(q), u = [], h = [], f = [], d = W = 0;
            if (!i) return L();
            if (j.header && !t) {
                var l = i.split(P)[0].split(M), c = [], p = {}, g = !1;
                for(var _ in l){
                    var m = l[_];
                    J(j.transformHeader) && (m = j.transformHeader(m, _));
                    var y = m, v = p[m] || 0;
                    for(0 < v && (g = !0, y = m + "_" + v), p[m] = v + 1; c.includes(y);)y = y + "_" + v;
                    c.push(y);
                }
                if (g) {
                    var k = i.split(P);
                    k[0] = c.join(M), i = k.join(P);
                }
            }
            if (B || !1 !== B && -1 === i.indexOf(z)) {
                for(var b = i.split(P), E = 0; E < b.length; E++){
                    if (f = b[E], W += f.length, E !== b.length - 1) W += P.length;
                    else if (r) return L();
                    if (!U || f.substring(0, a) !== U) {
                        if (o) {
                            if (u = [], I(f.split(M)), F(), H) return L();
                        } else I(f.split(M));
                        if (N && N <= E) return u = u.slice(0, N), L(!0);
                    }
                }
                return L();
            }
            for(var w = i.indexOf(M, W), R = i.indexOf(P, W), C = new RegExp(Q(K) + Q(z), "g"), S = i.indexOf(z, W);;)if (i[W] !== z) {
                if (U && 0 === f.length && i.substring(W, W + a) === U) {
                    if (-1 === R) return L();
                    W = R + s, R = i.indexOf(P, W), w = i.indexOf(M, W);
                } else if (-1 !== w && (w < R || -1 === R)) f.push(i.substring(W, w)), W = w + e, w = i.indexOf(M, W);
                else {
                    if (-1 === R) break;
                    if (f.push(i.substring(W, R)), D(R + s), o && (F(), H)) return L();
                    if (N && u.length >= N) return L(!0);
                }
            } else for(S = W, W++;;){
                if (-1 === (S = i.indexOf(z, S + 1))) return r || h.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: u.length,
                    index: W
                }), T();
                if (S === n - 1) return T(i.substring(W, S).replace(C, z));
                if (z !== K || i[S + 1] !== K) {
                    if (z === K || 0 === S || i[S - 1] !== K) {
                        -1 !== w && w < S + 1 && (w = i.indexOf(M, S + 1)), -1 !== R && R < S + 1 && (R = i.indexOf(P, S + 1));
                        var O = A(-1 === R ? w : Math.min(w, R));
                        if (i.substr(S + 1 + O, e) === M) {
                            f.push(i.substring(W, S).replace(C, z)), i[W = S + 1 + O + e] !== z && (S = i.indexOf(z, W)), w = i.indexOf(M, W), R = i.indexOf(P, W);
                            break;
                        }
                        var x = A(R);
                        if (i.substring(S + 1 + x, S + 1 + x + s) === P) {
                            if (f.push(i.substring(W, S).replace(C, z)), D(S + 1 + x + s), w = i.indexOf(M, W), S = i.indexOf(z, W), o && (F(), H)) return L();
                            if (N && u.length >= N) return L(!0);
                            break;
                        }
                        h.push({
                            type: "Quotes",
                            code: "InvalidQuotes",
                            message: "Trailing quote on quoted field is malformed",
                            row: u.length,
                            index: W
                        }), S++;
                    }
                } else S++;
            }
            return T();
            function I(e) {
                u.push(e), d = W;
            }
            function A(e) {
                var t = 0;
                if (-1 !== e) {
                    var r = i.substring(S + 1, e);
                    r && "" === r.trim() && (t = r.length);
                }
                return t;
            }
            function T(e) {
                return r || (void 0 === e && (e = i.substring(W)), f.push(e), W = n, I(f), o && F()), L();
            }
            function D(e) {
                W = e, I(f), f = [], R = i.indexOf(P, W);
            }
            function L(e) {
                return {
                    data: u,
                    errors: h,
                    meta: {
                        delimiter: M,
                        linebreak: P,
                        aborted: H,
                        truncated: !!e,
                        cursor: d + (t || 0)
                    }
                };
            }
            function F() {
                q(L()), u = [], h = [];
            }
        }, this.abort = function() {
            H = !0;
        }, this.getCharIndex = function() {
            return W;
        };
    }
    function _(e) {
        var t = e.data, r = a[t.workerId], i = !1;
        if (t.error) r.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    i = !0, m(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: y,
                resume: y
            };
            if (J(r.userStep)) {
                for(var s = 0; s < t.results.data.length && (r.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !i); s++);
                delete t.results;
            } else J(r.userChunk) && (r.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !i && m(t.workerId, t.results);
    }
    function m(e, t) {
        var r = a[e];
        J(r.userComplete) && r.userComplete(t), r.terminate(), delete a[e];
    }
    function y() {
        throw new Error("Not implemented.");
    }
    function w(e) {
        if ("object" != typeof e || null === e) return e;
        var t = Array.isArray(e) ? [] : {};
        for(var r in e)t[r] = w(e[r]);
        return t;
    }
    function v(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function J(e) {
        return "function" == typeof e;
    }
    return o && (f.onmessage = function(e) {
        var t = e.data;
        void 0 === b.WORKER_ID && t && (b.WORKER_ID = t.workerId);
        if ("string" == typeof t.input) f.postMessage({
            workerId: b.WORKER_ID,
            results: b.parse(t.input, t.config),
            finished: !0
        });
        else if (f.File && t.input instanceof File || t.input instanceof Object) {
            var r = b.parse(t.input, t.config);
            r && f.postMessage({
                workerId: b.WORKER_ID,
                results: r,
                finished: !0
            });
        }
    }), (l.prototype = Object.create(h.prototype)).constructor = l, (c.prototype = Object.create(h.prototype)).constructor = c, (p.prototype = Object.create(p.prototype)).constructor = p, (g.prototype = Object.create(h.prototype)).constructor = g, b;
});

});

parcelRegister("11pJC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $0be9d8d6bcaa5ee8$export$1e511d4a378977f5, (v) => $0be9d8d6bcaa5ee8$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $0be9d8d6bcaa5ee8$export$2e2bcd8739ae039, (v) => $0be9d8d6bcaa5ee8$export$2e2bcd8739ae039 = v);
var $0be9d8d6bcaa5ee8$export$1e511d4a378977f5;
var $0be9d8d6bcaa5ee8$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$0be9d8d6bcaa5ee8$export$1e511d4a378977f5 = true;
$0be9d8d6bcaa5ee8$export$2e2bcd8739ae039 = void 0;

var $0be9d8d6bcaa5ee8$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $0be9d8d6bcaa5ee8$var$_react = $0be9d8d6bcaa5ee8$var$_interopRequireWildcard((parcelRequire("acw62")));

var $lgxrp = parcelRequire("lgxrp");
function $0be9d8d6bcaa5ee8$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($0be9d8d6bcaa5ee8$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $0be9d8d6bcaa5ee8$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $0be9d8d6bcaa5ee8$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $0be9d8d6bcaa5ee8$var$LeavePageBlocker = ({ when: when, message: message })=>{
    (0, $0be9d8d6bcaa5ee8$var$_react.useEffect)(()=>{
        if (!when) return ()=>{};
        const beforeUnloadCallback = (event)=>{
            event.preventDefault();
            // eslint-disable-next-line fp/no-mutation
            event.returnValue = message;
            return message;
        };
        window.addEventListener("beforeunload", beforeUnloadCallback);
        return ()=>{
            window.removeEventListener("beforeunload", beforeUnloadCallback);
        };
    }, [
        when,
        message
    ]);
    return /*#__PURE__*/ $0be9d8d6bcaa5ee8$var$_react.default.createElement($lgxrp.Prompt, {
        message: message,
        when: when
    });
};
$0be9d8d6bcaa5ee8$var$LeavePageBlocker.propTypes = {
    message: $0be9d8d6bcaa5ee8$var$_propTypes.default.string.isRequired,
    when: $0be9d8d6bcaa5ee8$var$_propTypes.default.bool.isRequired
};
var $0be9d8d6bcaa5ee8$var$_default = $0be9d8d6bcaa5ee8$export$2e2bcd8739ae039 = $0be9d8d6bcaa5ee8$var$LeavePageBlocker;

});
parcelRegister("lgxrp", function(module, exports) {
"use strict";
function $f7b5084cb6aad888$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $kfZjc = parcelRequire("kfZjc");

var $f7b5084cb6aad888$var$React = $f7b5084cb6aad888$var$_interopDefault((parcelRequire("acw62")));

var $3np4r = parcelRequire("3np4r");

var $f7b5084cb6aad888$var$PropTypes = $f7b5084cb6aad888$var$_interopDefault((parcelRequire("c9Z8w")));

var $f7b5084cb6aad888$var$warning = $f7b5084cb6aad888$var$_interopDefault((parcelRequire("9RYKL")));

var $f7b5084cb6aad888$var$invariant = $f7b5084cb6aad888$var$_interopDefault((parcelRequire("bv4qN")));
function $f7b5084cb6aad888$var$_extends() {
    $f7b5084cb6aad888$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f7b5084cb6aad888$var$_extends.apply(this, arguments);
}
function $f7b5084cb6aad888$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $f7b5084cb6aad888$var$_setPrototypeOf(subClass, superClass);
}
function $f7b5084cb6aad888$var$_setPrototypeOf(o, p) {
    $f7b5084cb6aad888$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f7b5084cb6aad888$var$_setPrototypeOf(o, p);
}
function $f7b5084cb6aad888$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $f7b5084cb6aad888$var$BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    $f7b5084cb6aad888$var$_inheritsLoose(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = $3np4r.createBrowserHistory(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($kfZjc.Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}($f7b5084cb6aad888$var$React.Component);
$f7b5084cb6aad888$var$BrowserRouter.propTypes = {
    basename: $f7b5084cb6aad888$var$PropTypes.string,
    children: $f7b5084cb6aad888$var$PropTypes.node,
    forceRefresh: $f7b5084cb6aad888$var$PropTypes.bool,
    getUserConfirmation: $f7b5084cb6aad888$var$PropTypes.func,
    keyLength: $f7b5084cb6aad888$var$PropTypes.number
};
$f7b5084cb6aad888$var$BrowserRouter.prototype.componentDidMount = function() {
    $f7b5084cb6aad888$var$warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
};
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $f7b5084cb6aad888$var$HashRouter = /*#__PURE__*/ function(_React$Component) {
    $f7b5084cb6aad888$var$_inheritsLoose(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = $3np4r.createHashHistory(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($kfZjc.Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}($f7b5084cb6aad888$var$React.Component);
$f7b5084cb6aad888$var$HashRouter.propTypes = {
    basename: $f7b5084cb6aad888$var$PropTypes.string,
    children: $f7b5084cb6aad888$var$PropTypes.node,
    getUserConfirmation: $f7b5084cb6aad888$var$PropTypes.func,
    hashType: $f7b5084cb6aad888$var$PropTypes.oneOf([
        "hashbang",
        "noslash",
        "slash"
    ])
};
$f7b5084cb6aad888$var$HashRouter.prototype.componentDidMount = function() {
    $f7b5084cb6aad888$var$warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { HashRouter as Router }`.");
};
var $f7b5084cb6aad888$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $f7b5084cb6aad888$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? $3np4r.createLocation(to, null, null, currentLocation) : to;
};
var $f7b5084cb6aad888$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $f7b5084cb6aad888$var$forwardRef = $f7b5084cb6aad888$var$React.forwardRef;
if (typeof $f7b5084cb6aad888$var$forwardRef === "undefined") $f7b5084cb6aad888$var$forwardRef = $f7b5084cb6aad888$var$forwardRefShim;
function $f7b5084cb6aad888$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $f7b5084cb6aad888$var$LinkAnchor = $f7b5084cb6aad888$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = $f7b5084cb6aad888$var$_objectWithoutPropertiesLoose(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = $f7b5084cb6aad888$var$_extends({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$f7b5084cb6aad888$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($f7b5084cb6aad888$var$forwardRefShim !== $f7b5084cb6aad888$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement("a", props);
});
$f7b5084cb6aad888$var$LinkAnchor.displayName = "LinkAnchor";
/**
 * The public API for rendering a history-aware <a>.
 */ var $f7b5084cb6aad888$var$Link = $f7b5084cb6aad888$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $f7b5084cb6aad888$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = $f7b5084cb6aad888$var$_objectWithoutPropertiesLoose(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($kfZjc.__RouterContext.Consumer, null, function(context) {
        !context && $f7b5084cb6aad888$var$invariant(false, "You should not use <Link> outside a <Router>");
        var history$1 = context.history;
        var location = $f7b5084cb6aad888$var$normalizeToLocation($f7b5084cb6aad888$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history$1.createHref(location) : "";
        var props = $f7b5084cb6aad888$var$_extends({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $f7b5084cb6aad888$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = $3np4r.createPath(context.location) === $3np4r.createPath($f7b5084cb6aad888$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history$1.replace : history$1.push;
                method(location);
            }
        }); // React 15 compat
        if ($f7b5084cb6aad888$var$forwardRefShim !== $f7b5084cb6aad888$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement(component, props);
    });
});
var $f7b5084cb6aad888$var$toType = $f7b5084cb6aad888$var$PropTypes.oneOfType([
    $f7b5084cb6aad888$var$PropTypes.string,
    $f7b5084cb6aad888$var$PropTypes.object,
    $f7b5084cb6aad888$var$PropTypes.func
]);
var $f7b5084cb6aad888$var$refType = $f7b5084cb6aad888$var$PropTypes.oneOfType([
    $f7b5084cb6aad888$var$PropTypes.string,
    $f7b5084cb6aad888$var$PropTypes.func,
    $f7b5084cb6aad888$var$PropTypes.shape({
        current: $f7b5084cb6aad888$var$PropTypes.any
    })
]);
$f7b5084cb6aad888$var$Link.displayName = "Link";
$f7b5084cb6aad888$var$Link.propTypes = {
    innerRef: $f7b5084cb6aad888$var$refType,
    onClick: $f7b5084cb6aad888$var$PropTypes.func,
    replace: $f7b5084cb6aad888$var$PropTypes.bool,
    target: $f7b5084cb6aad888$var$PropTypes.string,
    to: $f7b5084cb6aad888$var$toType.isRequired
};
var $f7b5084cb6aad888$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $f7b5084cb6aad888$var$forwardRef$1 = $f7b5084cb6aad888$var$React.forwardRef;
if (typeof $f7b5084cb6aad888$var$forwardRef$1 === "undefined") $f7b5084cb6aad888$var$forwardRef$1 = $f7b5084cb6aad888$var$forwardRefShim$1;
function $f7b5084cb6aad888$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $f7b5084cb6aad888$var$NavLink = $f7b5084cb6aad888$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = $f7b5084cb6aad888$var$_objectWithoutPropertiesLoose(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($kfZjc.__RouterContext.Consumer, null, function(context) {
        !context && $f7b5084cb6aad888$var$invariant(false, "You should not use <NavLink> outside a <Router>");
        var currentLocation = locationProp || context.location;
        var toLocation = $f7b5084cb6aad888$var$normalizeToLocation($f7b5084cb6aad888$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? $kfZjc.matchPath(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $f7b5084cb6aad888$var$joinClassnames(className, activeClassName);
            style = $f7b5084cb6aad888$var$_extends({}, style, activeStyle);
        }
        var props = $f7b5084cb6aad888$var$_extends({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($f7b5084cb6aad888$var$forwardRefShim$1 !== $f7b5084cb6aad888$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($f7b5084cb6aad888$var$Link, props);
    });
});
$f7b5084cb6aad888$var$NavLink.displayName = "NavLink";
var $f7b5084cb6aad888$var$ariaCurrentType = $f7b5084cb6aad888$var$PropTypes.oneOf([
    "page",
    "step",
    "location",
    "date",
    "time",
    "true",
    "false"
]);
$f7b5084cb6aad888$var$NavLink.propTypes = $f7b5084cb6aad888$var$_extends({}, $f7b5084cb6aad888$var$Link.propTypes, {
    "aria-current": $f7b5084cb6aad888$var$ariaCurrentType,
    activeClassName: $f7b5084cb6aad888$var$PropTypes.string,
    activeStyle: $f7b5084cb6aad888$var$PropTypes.object,
    className: $f7b5084cb6aad888$var$PropTypes.oneOfType([
        $f7b5084cb6aad888$var$PropTypes.string,
        $f7b5084cb6aad888$var$PropTypes.func
    ]),
    exact: $f7b5084cb6aad888$var$PropTypes.bool,
    isActive: $f7b5084cb6aad888$var$PropTypes.func,
    location: $f7b5084cb6aad888$var$PropTypes.object,
    sensitive: $f7b5084cb6aad888$var$PropTypes.bool,
    strict: $f7b5084cb6aad888$var$PropTypes.bool,
    style: $f7b5084cb6aad888$var$PropTypes.oneOfType([
        $f7b5084cb6aad888$var$PropTypes.object,
        $f7b5084cb6aad888$var$PropTypes.func
    ])
});
Object.defineProperty(module.exports, "MemoryRouter", {
    enumerable: true,
    get: function() {
        return $kfZjc.MemoryRouter;
    }
});
Object.defineProperty(module.exports, "Prompt", {
    enumerable: true,
    get: function() {
        return $kfZjc.Prompt;
    }
});
Object.defineProperty(module.exports, "Redirect", {
    enumerable: true,
    get: function() {
        return $kfZjc.Redirect;
    }
});
Object.defineProperty(module.exports, "Route", {
    enumerable: true,
    get: function() {
        return $kfZjc.Route;
    }
});
Object.defineProperty(module.exports, "Router", {
    enumerable: true,
    get: function() {
        return $kfZjc.Router;
    }
});
Object.defineProperty(module.exports, "StaticRouter", {
    enumerable: true,
    get: function() {
        return $kfZjc.StaticRouter;
    }
});
Object.defineProperty(module.exports, "Switch", {
    enumerable: true,
    get: function() {
        return $kfZjc.Switch;
    }
});
Object.defineProperty(module.exports, "generatePath", {
    enumerable: true,
    get: function() {
        return $kfZjc.generatePath;
    }
});
Object.defineProperty(module.exports, "matchPath", {
    enumerable: true,
    get: function() {
        return $kfZjc.matchPath;
    }
});
Object.defineProperty(module.exports, "useHistory", {
    enumerable: true,
    get: function() {
        return $kfZjc.useHistory;
    }
});
Object.defineProperty(module.exports, "useLocation", {
    enumerable: true,
    get: function() {
        return $kfZjc.useLocation;
    }
});
Object.defineProperty(module.exports, "useParams", {
    enumerable: true,
    get: function() {
        return $kfZjc.useParams;
    }
});
Object.defineProperty(module.exports, "useRouteMatch", {
    enumerable: true,
    get: function() {
        return $kfZjc.useRouteMatch;
    }
});
Object.defineProperty(module.exports, "withRouter", {
    enumerable: true,
    get: function() {
        return $kfZjc.withRouter;
    }
});
module.exports.BrowserRouter = $f7b5084cb6aad888$var$BrowserRouter;
module.exports.HashRouter = $f7b5084cb6aad888$var$HashRouter;
module.exports.Link = $f7b5084cb6aad888$var$Link;
module.exports.NavLink = $f7b5084cb6aad888$var$NavLink;

});


parcelRegister("bz9qw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $86ba4691f44c0765$export$1e511d4a378977f5, (v) => $86ba4691f44c0765$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $86ba4691f44c0765$export$2e2bcd8739ae039, (v) => $86ba4691f44c0765$export$2e2bcd8739ae039 = v);
var $86ba4691f44c0765$export$1e511d4a378977f5;
var $86ba4691f44c0765$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$86ba4691f44c0765$export$1e511d4a378977f5 = true;
$86ba4691f44c0765$export$2e2bcd8739ae039 = void 0;

var $86ba4691f44c0765$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $86ba4691f44c0765$var$_react = $86ba4691f44c0765$var$_interopRequireWildcard((parcelRequire("acw62")));
parcelRequire("jHTLJ");
var $iD0SF = parcelRequire("iD0SF");

var $7Yi7V = parcelRequire("7Yi7V");

var $86ba4691f44c0765$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $bEk1s = parcelRequire("bEk1s");

var $5enz3 = parcelRequire("5enz3");

var $ikfii = parcelRequire("ikfii");

var $86ba4691f44c0765$var$_Table = $1jnue((parcelRequire("eTocD")));

var $86ba4691f44c0765$var$_DownloadCsvButton = $1jnue((parcelRequire("kSXWJ")));
function $86ba4691f44c0765$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($86ba4691f44c0765$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $86ba4691f44c0765$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $86ba4691f44c0765$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
const $86ba4691f44c0765$var$UploadReport = ({ uploadStatus: uploadStatus })=>{
    const [filter, setFilter] = (0, $86ba4691f44c0765$var$_react.useState)("All");
    const translate = (0, $86ba4691f44c0765$var$_useTranslate.default)();
    const localeForTranslation = (0, $iD0SF.useSelector)($bEk1s.getLocaleForTranslation);
    const uiColumns = (0, $5enz3.getUiColumns)(localeForTranslation);
    return /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement($86ba4691f44c0765$var$_react.default.Fragment, null, /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement("hr", null), /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement("section", {
        className: "ncss-col-sm-12 ta-sm-c mt3-sm mb3-sm u-bold"
    }, /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement("div", {
        className: "ncss-container d-sm-flx",
        style: {
            justifyContent: "center"
        }
    }, /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement($ikfii.Button, {
        buttonClassName: `ncss-btn-${filter === "All" ? "primary" : "secondary"}-dark mr2-sm`,
        label: `${translate("RL_AllStyleColours")}: ${uploadStatus.totalUploads}`,
        onClick: ()=>setFilter("All")
    }), /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement($ikfii.Button, {
        buttonClassName: `ncss-btn-${filter === $7Yi7V.CSV_UPLOAD.STATUS_SUCCESS ? "primary" : "secondary"}-dark mr2-sm`,
        label: `${translate("RL_Succeeded")}: ${uploadStatus.successCount}`,
        onClick: ()=>setFilter($7Yi7V.CSV_UPLOAD.STATUS_SUCCESS)
    }), /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement($ikfii.Button, {
        buttonClassName: `ncss-btn-${filter === $7Yi7V.CSV_UPLOAD.STATUS_FAILURE ? "primary" : "secondary"}-dark mr2-sm`,
        label: `${translate("RL_Failed")}: ${uploadStatus.failureCount}`,
        onClick: ()=>setFilter($7Yi7V.CSV_UPLOAD.STATUS_FAILURE)
    }))), /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement("section", {
        className: "ncss-col-sm-10 ta-sm-c mt3-sm mb3-sm"
    }, /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement($86ba4691f44c0765$var$_Table.default, {
        columns: uiColumns,
        data: uploadStatus.status.filter((style)=>(0, $5enz3.filterStyles)(style, filter))
    })), uploadStatus.isUploadCompleted && /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement("section", {
        className: "ncss-col-sm-4 ta-sm-c mt3-sm mb3-sm"
    }, /*#__PURE__*/ $86ba4691f44c0765$var$_react.default.createElement($86ba4691f44c0765$var$_DownloadCsvButton.default, {
        uploadStatus: uploadStatus
    })));
};
$86ba4691f44c0765$var$UploadReport.propTypes = {
    uploadStatus: $86ba4691f44c0765$var$_propTypes.default.shape().isRequired
};
var $86ba4691f44c0765$var$_default = $86ba4691f44c0765$export$2e2bcd8739ae039 = $86ba4691f44c0765$var$UploadReport;

});
parcelRegister("eTocD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $ad78f9e88df917a9$export$1e511d4a378977f5, (v) => $ad78f9e88df917a9$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $ad78f9e88df917a9$export$2e2bcd8739ae039, (v) => $ad78f9e88df917a9$export$2e2bcd8739ae039 = v);
var $ad78f9e88df917a9$export$1e511d4a378977f5;
var $ad78f9e88df917a9$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$ad78f9e88df917a9$export$1e511d4a378977f5 = true;
$ad78f9e88df917a9$export$2e2bcd8739ae039 = void 0;

var $ad78f9e88df917a9$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $ad78f9e88df917a9$var$_react = $1jnue((parcelRequire("acw62")));

var $ad78f9e88df917a9$var$_useTranslate = $1jnue((parcelRequire("90irH")));
const $ad78f9e88df917a9$var$Table = ({ columns: columns, data: data })=>{
    const translate = (0, $ad78f9e88df917a9$var$_useTranslate.default)();
    const formatValue = (item, id, renderer, translationEnabled)=>{
        const renderedValue = renderer ? renderer(item[id], item) : item[id];
        const multipleValues = renderedValue === null || renderedValue === void 0 ? void 0 : renderedValue.toString().split(",");
        if (multipleValues.length > 1) return translationEnabled ? multipleValues.map((error)=>translate(error)).join(", ") : renderedValue;
        return translationEnabled ? translate(renderedValue) : renderedValue;
    };
    return /*#__PURE__*/ $ad78f9e88df917a9$var$_react.default.createElement("div", {
        className: "ncss-container fixed-fluid"
    }, /*#__PURE__*/ $ad78f9e88df917a9$var$_react.default.createElement("div", {
        key: "table-headers",
        className: "ncss-row bg-black text-color-primary-light u-bold p2-lg"
    }, columns.map(({ displayName: displayName, width: width, id: id })=>/*#__PURE__*/ $ad78f9e88df917a9$var$_react.default.createElement("div", {
            key: `table-header-${id}`,
            className: `ncss-col-sm-${width}`
        }, displayName))), /*#__PURE__*/ $ad78f9e88df917a9$var$_react.default.createElement("div", {
        key: "table-data",
        style: {
            maxHeight: "60vh",
            overflowX: "hidden",
            overflowY: "scroll"
        }
    }, data.map((item, idx)=>/*#__PURE__*/ $ad78f9e88df917a9$var$_react.default.createElement("div", {
            key: `table-row-${idx + 1}`,
            className: `ncss-row p2-lg ${idx % 2 !== 0 ? "bg-primary-grey" : ""}`
        }, columns.map(({ id: id, width: width, renderer: renderer, classRenderer: classRenderer, translationEnabled: translationEnabled })=>{
            const className = classRenderer ? classRenderer(item[id], item) : "";
            return /*#__PURE__*/ $ad78f9e88df917a9$var$_react.default.createElement("div", {
                key: `table-row-${idx + 1}-${id}`,
                className: `ncss-col-sm-${width} ${className}`
            }, formatValue(item, id, renderer, translationEnabled));
        })))));
};
$ad78f9e88df917a9$var$Table.propTypes = {
    columns: $ad78f9e88df917a9$var$_propTypes.default.arrayOf($ad78f9e88df917a9$var$_propTypes.default.shape()).isRequired,
    data: $ad78f9e88df917a9$var$_propTypes.default.arrayOf($ad78f9e88df917a9$var$_propTypes.default.shape()).isRequired
};
var $ad78f9e88df917a9$var$_default = $ad78f9e88df917a9$export$2e2bcd8739ae039 = $ad78f9e88df917a9$var$Table;

});

parcelRegister("kSXWJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $f34759e6e1a73234$export$1e511d4a378977f5, (v) => $f34759e6e1a73234$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $f34759e6e1a73234$export$2e2bcd8739ae039, (v) => $f34759e6e1a73234$export$2e2bcd8739ae039 = v);
var $f34759e6e1a73234$export$1e511d4a378977f5;
var $f34759e6e1a73234$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$f34759e6e1a73234$export$1e511d4a378977f5 = true;
$f34759e6e1a73234$export$2e2bcd8739ae039 = void 0;

var $f34759e6e1a73234$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $f34759e6e1a73234$var$_react = $1jnue((parcelRequire("acw62")));

var $f34759e6e1a73234$var$_reactCsvDownloader = $1jnue((parcelRequire("fM75R")));

var $f34759e6e1a73234$var$_useTranslate = $1jnue((parcelRequire("90irH")));

var $5enz3 = parcelRequire("5enz3");

var $ikfii = parcelRequire("ikfii");
const $f34759e6e1a73234$var$getExportFileName = ()=>{
    const country = localStorage.getItem("country");
    const store = localStorage.getItem("storeNumber");
    return `Styles-upload-report-${country}-${store}-${new Date().getTime()}`;
};
const $f34759e6e1a73234$var$getData = async (data, translate)=>data.map((exportRow)=>({
            ...exportRow,
            errors: exportRow.errors.map(({ key: key })=>translate((0, $5enz3.getErrorTranslation)(key))).join(", "),
            status: translate(exportRow.status)
        }));
const $f34759e6e1a73234$var$DownloadCsvButton = ({ uploadStatus: uploadStatus })=>{
    const translate = (0, $f34759e6e1a73234$var$_useTranslate.default)(); // Moved inside the component body, outside the return statement.
    return /*#__PURE__*/ $f34759e6e1a73234$var$_react.default.createElement($f34759e6e1a73234$var$_reactCsvDownloader.default, {
        columns: (0, $5enz3.getExportColumns)(),
        datas: $f34759e6e1a73234$var$getData(uploadStatus.status, translate),
        extension: ".csv",
        filename: $f34759e6e1a73234$var$getExportFileName(),
        separator: ","
    }, /*#__PURE__*/ $f34759e6e1a73234$var$_react.default.createElement($ikfii.ButtonSubmit, {
        buttonClassName: "mb2-sm",
        label: translate("RL_DownloadReport") // TODO: Value in double quotes, in bodega for few translations
        ,
        sectionClassName: "ncss-col-sm-4 full"
    }));
};
$f34759e6e1a73234$var$DownloadCsvButton.propTypes = {
    uploadStatus: $f34759e6e1a73234$var$_propTypes.default.shape().isRequired
};
var $f34759e6e1a73234$var$_default = $f34759e6e1a73234$export$2e2bcd8739ae039 = $f34759e6e1a73234$var$DownloadCsvButton;

});
parcelRegister("fM75R", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b7c0d75a7c69de23$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toCsv", () => (parcelRequire("kT5nu")).default);

var $crxWL = parcelRequire("crxWL");

var $acw62 = parcelRequire("acw62");

var $kT5nu = parcelRequire("kT5nu");
var $b7c0d75a7c69de23$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $b7c0d75a7c69de23$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $b7c0d75a7c69de23$export$2e2bcd8739ae039 extends $acw62.Component {
    constructor(){
        super(...arguments);
        // eslint-disable-next-line sonarjs/cognitive-complexity
        this.handleClick = ()=>$b7c0d75a7c69de23$var$__awaiter(this, void 0, void 0, function*() {
                const { suffix: suffix, prefix: prefix, bom: bom, extension: extension, disabled: disabled, meta: meta, separator: separator, handleError: handleError, handleEmpty: handleEmpty } = this.props;
                if (disabled) return;
                let { filename: filename } = this.props;
                let csv;
                try {
                    csv = yield (0, $kT5nu.default)(this.props);
                } catch (err) {
                    return handleError === null || handleError === void 0 ? void 0 : handleError(err);
                }
                if (!csv) {
                    if (handleEmpty) return handleEmpty();
                    else csv = "";
                }
                const bomCode = bom !== false ? "\uFEFF" : "";
                const metaContent = meta ? `sep=${separator}\r\n` : "";
                const resolvedExtension = extension || ".csv";
                if (filename.indexOf(resolvedExtension) === -1) filename += resolvedExtension;
                if (suffix) filename = typeof suffix === "string" || typeof suffix === "number" ? filename.replace(resolvedExtension, `_${suffix}${resolvedExtension}`) : filename.replace(resolvedExtension, `_${new Date().getTime()}${resolvedExtension}`);
                if (prefix) filename = typeof prefix === "string" || typeof prefix === "number" ? `${prefix}_${filename}` : `${new Date().getTime()}_${filename}`;
                const blob = new Blob([
                    `${bomCode}${metaContent}${csv}`
                ], {
                    type: "text/csv;charset=utf-8"
                });
                $crxWL.saveAs(blob, filename);
            });
    }
    render() {
        const _a = this.props, { children: children, text: text, disabled: disabled, bom: /* eslint-disable @typescript-eslint/no-unused-vars */ bom, filename: filename, extension: extension, prefix: prefix, suffix: suffix, meta: meta, handleError: handleError, handleEmpty: handleEmpty, columns: columns, datas: datas, separator: separator, noHeader: noHeader, wrapColumnChar: wrapColumnChar, newLineAtEnd: newLineAtEnd, chunkSize: chunkSize } = _a, /* eslint-enable @typescript-eslint/no-unused-vars */ props = $b7c0d75a7c69de23$var$__rest(_a, [
            "children",
            "text",
            "disabled",
            "bom",
            "filename",
            "extension",
            "prefix",
            "suffix",
            "meta",
            "handleError",
            "handleEmpty",
            "columns",
            "datas",
            "separator",
            "noHeader",
            "wrapColumnChar",
            "newLineAtEnd",
            "chunkSize"
        ]);
        if (typeof children === "undefined") return $acw62.createElement("button", Object.assign({
            type: "button"
        }, props, {
            onClick: this.handleClick,
            disabled: disabled
        }), text ? text : "Download");
        return $acw62.createElement("div", Object.assign({
            role: "button",
            tabIndex: 0
        }, props, {
            onClick: this.handleClick,
            onKeyPress: this.handleClick
        }), children);
    }
}

});
parcelRegister("crxWL", function(module, exports) {
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})(module.exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, module.exports = g;
});

});

parcelRegister("kT5nu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f34d1da4d8db789d$export$2e2bcd8739ae039);

var $hPtJY = parcelRequire("hPtJY");
var $f34d1da4d8db789d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f34d1da4d8db789d$var$newLine = "\r\n";
const $f34d1da4d8db789d$var$raf = typeof requestAnimationFrame === "function" ? requestAnimationFrame : $hPtJY.nextTick;
const $f34d1da4d8db789d$var$makeWrapper = (wrapChar)=>(str)=>`${wrapChar}${str}${wrapChar}`;
const $f34d1da4d8db789d$var$makeResolver = (resolve, newLineAtEnd)=>(content)=>{
        if (newLineAtEnd) content.push("");
        resolve(content.join($f34d1da4d8db789d$var$newLine));
    };
const $f34d1da4d8db789d$var$identityMapping = (arr, initialMapping)=>arr.reduce((acc, k)=>{
        acc.map[k] = k;
        acc.order.push(k);
        return acc;
    }, initialMapping);
const $f34d1da4d8db789d$var$extractHeaderFromData = (datas)=>datas.reduce((acc, v)=>{
        return Array.isArray(v) ? acc : $f34d1da4d8db789d$var$identityMapping(Object.keys(v), acc);
    }, {
        order: [],
        map: {}
    });
const $f34d1da4d8db789d$var$extractHeaderFromColumns = (columns)=>columns.reduce((acc, v)=>{
        var _a;
        let id, value;
        if (typeof v === "string") {
            id = v;
            value = v;
        } else {
            id = v.id;
            value = (_a = v.displayName) !== null && _a !== void 0 ? _a : v.id;
        }
        acc.map[id] = value;
        acc.order.push(id);
        return acc;
    }, {
        order: [],
        map: {}
    });
function $f34d1da4d8db789d$var$toChunks(arr, chunkSize) {
    return [
        ...Array(Math.ceil(arr.length / chunkSize))
    ].reduce((acc, _, i)=>{
        const begin = i * chunkSize;
        return acc.concat([
            arr.slice(begin, begin + chunkSize)
        ]);
    }, []);
}
const $f34d1da4d8db789d$var$createChunkProcessor = (resolve, wrap, content, datas, columnOrder, separator, chunkSize)=>{
    const chunks = $f34d1da4d8db789d$var$toChunks(datas, chunkSize);
    let i = 0;
    return function processChunk() {
        if (i >= chunks.length) {
            resolve(content);
            return;
        }
        const chunk = chunks[i];
        // @ts-expect-error
        const asArray = Array.isArray(chunk[0]) && !columnOrder.some((k)=>typeof chunk[0][k] !== "undefined");
        i += 1;
        chunk// @ts-expect-error
        .map((v)=>asArray ? v : columnOrder.map((k)=>{
                var _a;
                return (_a = v[k]) !== null && _a !== void 0 ? _a : "";
            })).forEach((v)=>{
            content.push(v.map(wrap).join(separator));
        });
        $f34d1da4d8db789d$var$raf(processChunk);
    };
};
function $f34d1da4d8db789d$export$2e2bcd8739ae039({ columns: columns, datas: datas, separator: separator = ",", noHeader: noHeader = false, wrapColumnChar: wrapColumnChar = "", newLineAtEnd: newLineAtEnd = false, chunkSize: chunkSize = 1000, title: title = "" }) {
    return $f34d1da4d8db789d$var$__awaiter(this, void 0, void 0, function*() {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise((_resolve, reject)=>$f34d1da4d8db789d$var$__awaiter(this, void 0, void 0, function*() {
                const resolve = $f34d1da4d8db789d$var$makeResolver(_resolve, newLineAtEnd);
                const wrap = $f34d1da4d8db789d$var$makeWrapper(wrapColumnChar);
                try {
                    datas = typeof datas === "function" ? yield datas() : yield datas;
                    if (!Array.isArray(datas)) return _resolve();
                    const { map: map, order: order } = columns ? $f34d1da4d8db789d$var$extractHeaderFromColumns(columns) : $f34d1da4d8db789d$var$extractHeaderFromData(datas);
                    const content = [];
                    if (!noHeader) {
                        const headerNames = order.map((id)=>map[id]);
                        if (headerNames.length > 0) {
                            if (title !== "") content.push(title);
                            content.push(headerNames.map(wrap).join(separator));
                        }
                    }
                    const processChunk = $f34d1da4d8db789d$var$createChunkProcessor(resolve, wrap, content, datas, order, separator, chunkSize);
                    $f34d1da4d8db789d$var$raf(processChunk);
                } catch (err) {
                    return reject(err);
                }
            }));
    });
}

});







"use strict";

var $1jnue = parcelRequire("1jnue");

var $35da740d59af89ba$var$_react = $1jnue((parcelRequire("acw62")));

var $35da740d59af89ba$var$_reactDom = $1jnue((parcelRequire("1u0KT")));

var $35da740d59af89ba$var$_App = $1jnue((parcelRequire("6ztrJ")));
$35da740d59af89ba$var$_reactDom.default.render(/*#__PURE__*/ $35da740d59af89ba$var$_react.default.createElement($35da740d59af89ba$var$_App.default, null), document.getElementById("root"));


//# sourceMappingURL=index.3147b7a3.js.map
